"use strict";
(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
    get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
  }) : x)(function(x) {
    if (typeof require !== "undefined")
      return require.apply(this, arguments);
    throw new Error('Dynamic require of "' + x + '" is not supported');
  });
  var __esm = (fn, res) => function __init() {
    return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
  };
  var __commonJS = (cb, mod) => function __require2() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };

  // <define:process>
  var define_process_default;
  var init_define_process = __esm({
    "<define:process>"() {
      define_process_default = { env: { NODE_ENV: "production", STANDALONE: "true" } };
    }
  });

  // ../../node_modules/.pnpm/esbuild-plugin-polyfill-node@0.3.0_esbuild@0.14.54/node_modules/esbuild-plugin-polyfill-node/polyfills/__dirname.js
  var init_dirname = __esm({
    "../../node_modules/.pnpm/esbuild-plugin-polyfill-node@0.3.0_esbuild@0.14.54/node_modules/esbuild-plugin-polyfill-node/polyfills/__dirname.js"() {
    }
  });

  // ../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/process.js
  var process_exports = {};
  __export(process_exports, {
    _debugEnd: () => _debugEnd,
    _debugProcess: () => _debugProcess,
    _events: () => _events,
    _eventsCount: () => _eventsCount,
    _exiting: () => _exiting,
    _fatalExceptions: () => _fatalExceptions,
    _getActiveHandles: () => _getActiveHandles,
    _getActiveRequests: () => _getActiveRequests,
    _kill: () => _kill,
    _linkedBinding: () => _linkedBinding,
    _maxListeners: () => _maxListeners,
    _preload_modules: () => _preload_modules,
    _rawDebug: () => _rawDebug,
    _startProfilerIdleNotifier: () => _startProfilerIdleNotifier,
    _stopProfilerIdleNotifier: () => _stopProfilerIdleNotifier,
    _tickCallback: () => _tickCallback,
    abort: () => abort,
    addListener: () => addListener,
    allowedNodeEnvironmentFlags: () => allowedNodeEnvironmentFlags,
    arch: () => arch,
    argv: () => argv,
    argv0: () => argv0,
    assert: () => assert,
    binding: () => binding,
    browser: () => browser,
    chdir: () => chdir,
    config: () => config,
    cpuUsage: () => cpuUsage,
    cwd: () => cwd,
    debugPort: () => debugPort,
    default: () => process,
    dlopen: () => dlopen,
    domain: () => domain,
    emit: () => emit,
    emitWarning: () => emitWarning,
    env: () => env,
    execArgv: () => execArgv,
    execPath: () => execPath,
    exit: () => exit,
    features: () => features,
    hasUncaughtExceptionCaptureCallback: () => hasUncaughtExceptionCaptureCallback,
    hrtime: () => hrtime,
    kill: () => kill,
    listeners: () => listeners,
    memoryUsage: () => memoryUsage,
    moduleLoadList: () => moduleLoadList,
    nextTick: () => nextTick,
    off: () => off,
    on: () => on,
    once: () => once,
    openStdin: () => openStdin,
    pid: () => pid,
    platform: () => platform,
    ppid: () => ppid,
    prependListener: () => prependListener,
    prependOnceListener: () => prependOnceListener,
    reallyExit: () => reallyExit,
    release: () => release,
    removeAllListeners: () => removeAllListeners,
    removeListener: () => removeListener,
    resourceUsage: () => resourceUsage,
    setSourceMapsEnabled: () => setSourceMapsEnabled,
    setUncaughtExceptionCaptureCallback: () => setUncaughtExceptionCaptureCallback,
    stderr: () => stderr,
    stdin: () => stdin,
    stdout: () => stdout,
    title: () => title,
    umask: () => umask,
    uptime: () => uptime,
    version: () => version,
    versions: () => versions
  });
  function unimplemented(name) {
    throw new Error("Node.js process " + name + " is not supported by JSPM core outside of Node.js");
  }
  function cleanUpNextTick() {
    if (!draining || !currentQueue)
      return;
    draining = false;
    if (currentQueue.length) {
      queue = currentQueue.concat(queue);
    } else {
      queueIndex = -1;
    }
    if (queue.length)
      drainQueue();
  }
  function drainQueue() {
    if (draining)
      return;
    var timeout = setTimeout(cleanUpNextTick, 0);
    draining = true;
    var len = queue.length;
    while (len) {
      currentQueue = queue;
      queue = [];
      while (++queueIndex < len) {
        if (currentQueue)
          currentQueue[queueIndex].run();
      }
      queueIndex = -1;
      len = queue.length;
    }
    currentQueue = null;
    draining = false;
    clearTimeout(timeout);
  }
  function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++)
        args[i - 1] = arguments[i];
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining)
      setTimeout(drainQueue, 0);
  }
  function Item(fun, array) {
    this.fun = fun;
    this.array = array;
  }
  function noop() {
  }
  function _linkedBinding(name) {
    unimplemented("_linkedBinding");
  }
  function dlopen(name) {
    unimplemented("dlopen");
  }
  function _getActiveRequests() {
    return [];
  }
  function _getActiveHandles() {
    return [];
  }
  function assert(condition, message) {
    if (!condition)
      throw new Error(message || "assertion error");
  }
  function hasUncaughtExceptionCaptureCallback() {
    return false;
  }
  function uptime() {
    return _performance.now() / 1e3;
  }
  function hrtime(previousTimestamp) {
    var baseNow = Math.floor((Date.now() - _performance.now()) * 1e-3);
    var clocktime = _performance.now() * 1e-3;
    var seconds = Math.floor(clocktime) + baseNow;
    var nanoseconds = Math.floor(clocktime % 1 * 1e9);
    if (previousTimestamp) {
      seconds = seconds - previousTimestamp[0];
      nanoseconds = nanoseconds - previousTimestamp[1];
      if (nanoseconds < 0) {
        seconds--;
        nanoseconds += nanoPerSec;
      }
    }
    return [seconds, nanoseconds];
  }
  function on() {
    return process;
  }
  function listeners(name) {
    return [];
  }
  var queue, draining, currentQueue, queueIndex, title, arch, platform, env, argv, execArgv, version, versions, emitWarning, binding, umask, cwd, chdir, release, browser, _rawDebug, moduleLoadList, domain, _exiting, config, reallyExit, _kill, cpuUsage, resourceUsage, memoryUsage, kill, exit, openStdin, allowedNodeEnvironmentFlags, features, _fatalExceptions, setUncaughtExceptionCaptureCallback, _tickCallback, _debugProcess, _debugEnd, _startProfilerIdleNotifier, _stopProfilerIdleNotifier, stdout, stderr, stdin, abort, pid, ppid, execPath, debugPort, argv0, _preload_modules, setSourceMapsEnabled, _performance, nowOffset, nanoPerSec, _maxListeners, _events, _eventsCount, addListener, once, off, removeListener, removeAllListeners, emit, prependListener, prependOnceListener, process;
  var init_process = __esm({
    "../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/process.js"() {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      queue = [];
      draining = false;
      queueIndex = -1;
      Item.prototype.run = function() {
        this.fun.apply(null, this.array);
      };
      title = "browser";
      arch = "x64";
      platform = "browser";
      env = {
        PATH: "/usr/bin",
        LANG: typeof navigator !== "undefined" ? navigator.language + ".UTF-8" : void 0,
        PWD: "/",
        HOME: "/home",
        TMP: "/tmp"
      };
      argv = ["/usr/bin/node"];
      execArgv = [];
      version = "v16.8.0";
      versions = {};
      emitWarning = function(message, type) {
        console.warn((type ? type + ": " : "") + message);
      };
      binding = function(name) {
        unimplemented("binding");
      };
      umask = function(mask) {
        return 0;
      };
      cwd = function() {
        return "/";
      };
      chdir = function(dir) {
      };
      release = {
        name: "node",
        sourceUrl: "",
        headersUrl: "",
        libUrl: ""
      };
      browser = true;
      _rawDebug = noop;
      moduleLoadList = [];
      domain = {};
      _exiting = false;
      config = {};
      reallyExit = noop;
      _kill = noop;
      cpuUsage = function() {
        return {};
      };
      resourceUsage = cpuUsage;
      memoryUsage = cpuUsage;
      kill = noop;
      exit = noop;
      openStdin = noop;
      allowedNodeEnvironmentFlags = {};
      features = {
        inspector: false,
        debug: false,
        uv: false,
        ipv6: false,
        tls_alpn: false,
        tls_sni: false,
        tls_ocsp: false,
        tls: false,
        cached_builtins: true
      };
      _fatalExceptions = noop;
      setUncaughtExceptionCaptureCallback = noop;
      _tickCallback = noop;
      _debugProcess = noop;
      _debugEnd = noop;
      _startProfilerIdleNotifier = noop;
      _stopProfilerIdleNotifier = noop;
      stdout = void 0;
      stderr = void 0;
      stdin = void 0;
      abort = noop;
      pid = 2;
      ppid = 1;
      execPath = "/bin/usr/node";
      debugPort = 9229;
      argv0 = "node";
      _preload_modules = [];
      setSourceMapsEnabled = noop;
      _performance = {
        now: typeof performance !== "undefined" ? performance.now.bind(performance) : void 0,
        timing: typeof performance !== "undefined" ? performance.timing : void 0
      };
      if (_performance.now === void 0) {
        nowOffset = Date.now();
        if (_performance.timing && _performance.timing.navigationStart) {
          nowOffset = _performance.timing.navigationStart;
        }
        _performance.now = () => Date.now() - nowOffset;
      }
      nanoPerSec = 1e9;
      hrtime.bigint = function(time) {
        var diff = hrtime(time);
        if (typeof BigInt === "undefined") {
          return diff[0] * nanoPerSec + diff[1];
        }
        return BigInt(diff[0] * nanoPerSec) + BigInt(diff[1]);
      };
      _maxListeners = 10;
      _events = {};
      _eventsCount = 0;
      addListener = on;
      once = on;
      off = on;
      removeListener = on;
      removeAllListeners = on;
      emit = noop;
      prependListener = on;
      prependOnceListener = on;
      process = {
        version,
        versions,
        arch,
        platform,
        browser,
        release,
        _rawDebug,
        moduleLoadList,
        binding,
        _linkedBinding,
        _events,
        _eventsCount,
        _maxListeners,
        on,
        addListener,
        once,
        off,
        removeListener,
        removeAllListeners,
        emit,
        prependListener,
        prependOnceListener,
        listeners,
        domain,
        _exiting,
        config,
        dlopen,
        uptime,
        _getActiveRequests,
        _getActiveHandles,
        reallyExit,
        _kill,
        cpuUsage,
        resourceUsage,
        memoryUsage,
        kill,
        exit,
        openStdin,
        allowedNodeEnvironmentFlags,
        assert,
        features,
        _fatalExceptions,
        setUncaughtExceptionCaptureCallback,
        hasUncaughtExceptionCaptureCallback,
        emitWarning,
        nextTick,
        _tickCallback,
        _debugProcess,
        _debugEnd,
        _startProfilerIdleNotifier,
        _stopProfilerIdleNotifier,
        stdout,
        stdin,
        stderr,
        abort,
        umask,
        chdir,
        cwd,
        env,
        title,
        argv,
        execArgv,
        pid,
        ppid,
        execPath,
        debugPort,
        hrtime,
        argv0,
        _preload_modules,
        setSourceMapsEnabled
      };
    }
  });

  // ../../node_modules/.pnpm/esbuild-plugin-polyfill-node@0.3.0_esbuild@0.14.54/node_modules/esbuild-plugin-polyfill-node/polyfills/process.js
  var init_process2 = __esm({
    "../../node_modules/.pnpm/esbuild-plugin-polyfill-node@0.3.0_esbuild@0.14.54/node_modules/esbuild-plugin-polyfill-node/polyfills/process.js"() {
      init_process();
    }
  });

  // ../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/chunk-DtuTasat.js
  function dew$2() {
    if (_dewExec$2)
      return exports$2;
    _dewExec$2 = true;
    exports$2.byteLength = byteLength;
    exports$2.toByteArray = toByteArray;
    exports$2.fromByteArray = fromByteArray;
    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for (var i = 0, len = code.length; i < len; ++i) {
      lookup[i] = code[i];
      revLookup[code.charCodeAt(i)] = i;
    }
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
    function getLens(b64) {
      var len2 = b64.length;
      if (len2 % 4 > 0) {
        throw new Error("Invalid string. Length must be a multiple of 4");
      }
      var validLen = b64.indexOf("=");
      if (validLen === -1)
        validLen = len2;
      var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
      return [validLen, placeHoldersLen];
    }
    function byteLength(b64) {
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function _byteLength(b64, validLen, placeHoldersLen) {
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function toByteArray(b64) {
      var tmp;
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
      var curByte = 0;
      var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
      var i2;
      for (i2 = 0; i2 < len2; i2 += 4) {
        tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
        arr[curByte++] = tmp >> 16 & 255;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      return arr;
    }
    function tripletToBase64(num) {
      return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
    }
    function encodeChunk(uint8, start, end) {
      var tmp;
      var output = [];
      for (var i2 = start; i2 < end; i2 += 3) {
        tmp = (uint8[i2] << 16 & 16711680) + (uint8[i2 + 1] << 8 & 65280) + (uint8[i2 + 2] & 255);
        output.push(tripletToBase64(tmp));
      }
      return output.join("");
    }
    function fromByteArray(uint8) {
      var tmp;
      var len2 = uint8.length;
      var extraBytes = len2 % 3;
      var parts = [];
      var maxChunkLength = 16383;
      for (var i2 = 0, len22 = len2 - extraBytes; i2 < len22; i2 += maxChunkLength) {
        parts.push(encodeChunk(uint8, i2, i2 + maxChunkLength > len22 ? len22 : i2 + maxChunkLength));
      }
      if (extraBytes === 1) {
        tmp = uint8[len2 - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "==");
      } else if (extraBytes === 2) {
        tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "=");
      }
      return parts.join("");
    }
    return exports$2;
  }
  function dew$1() {
    if (_dewExec$1)
      return exports$1;
    _dewExec$1 = true;
    exports$1.read = function(buffer, offset, isLE, mLen, nBytes) {
      var e, m;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var nBits = -7;
      var i = isLE ? nBytes - 1 : 0;
      var d = isLE ? -1 : 1;
      var s = buffer[offset + i];
      i += d;
      e = s & (1 << -nBits) - 1;
      s >>= -nBits;
      nBits += eLen;
      for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {
      }
      m = e & (1 << -nBits) - 1;
      e >>= -nBits;
      nBits += mLen;
      for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {
      }
      if (e === 0) {
        e = 1 - eBias;
      } else if (e === eMax) {
        return m ? NaN : (s ? -1 : 1) * Infinity;
      } else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
      }
      return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
    };
    exports$1.write = function(buffer, value, offset, isLE, mLen, nBytes) {
      var e, m, c;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
      var i = isLE ? 0 : nBytes - 1;
      var d = isLE ? 1 : -1;
      var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
      value = Math.abs(value);
      if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
      } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
          e--;
          c *= 2;
        }
        if (e + eBias >= 1) {
          value += rt / c;
        } else {
          value += rt * Math.pow(2, 1 - eBias);
        }
        if (value * c >= 2) {
          e++;
          c /= 2;
        }
        if (e + eBias >= eMax) {
          m = 0;
          e = eMax;
        } else if (e + eBias >= 1) {
          m = (value * c - 1) * Math.pow(2, mLen);
          e = e + eBias;
        } else {
          m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
          e = 0;
        }
      }
      for (; mLen >= 8; buffer[offset + i] = m & 255, i += d, m /= 256, mLen -= 8) {
      }
      e = e << mLen | m;
      eLen += mLen;
      for (; eLen > 0; buffer[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {
      }
      buffer[offset + i - d] |= s * 128;
    };
    return exports$1;
  }
  function dew() {
    if (_dewExec)
      return exports2;
    _dewExec = true;
    const base64 = dew$2();
    const ieee754 = dew$1();
    const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
    exports2.Buffer = Buffer5;
    exports2.SlowBuffer = SlowBuffer;
    exports2.INSPECT_MAX_BYTES = 50;
    const K_MAX_LENGTH = 2147483647;
    exports2.kMaxLength = K_MAX_LENGTH;
    Buffer5.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer5.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
      console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
    }
    function typedArraySupport() {
      try {
        const arr = new Uint8Array(1);
        const proto = {
          foo: function() {
            return 42;
          }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
      } catch (e) {
        return false;
      }
    }
    Object.defineProperty(Buffer5.prototype, "parent", {
      enumerable: true,
      get: function() {
        if (!Buffer5.isBuffer(this))
          return void 0;
        return this.buffer;
      }
    });
    Object.defineProperty(Buffer5.prototype, "offset", {
      enumerable: true,
      get: function() {
        if (!Buffer5.isBuffer(this))
          return void 0;
        return this.byteOffset;
      }
    });
    function createBuffer(length) {
      if (length > K_MAX_LENGTH) {
        throw new RangeError('The value "' + length + '" is invalid for option "size"');
      }
      const buf = new Uint8Array(length);
      Object.setPrototypeOf(buf, Buffer5.prototype);
      return buf;
    }
    function Buffer5(arg, encodingOrOffset, length) {
      if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") {
          throw new TypeError('The "string" argument must be of type string. Received type number');
        }
        return allocUnsafe2(arg);
      }
      return from(arg, encodingOrOffset, length);
    }
    Buffer5.poolSize = 8192;
    function from(value, encodingOrOffset, length) {
      if (typeof value === "string") {
        return fromString(value, encodingOrOffset);
      }
      if (ArrayBuffer.isView(value)) {
        return fromArrayView(value);
      }
      if (value == null) {
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
      }
      if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
        return fromArrayBuffer(value, encodingOrOffset, length);
      }
      if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
        return fromArrayBuffer(value, encodingOrOffset, length);
      }
      if (typeof value === "number") {
        throw new TypeError('The "value" argument must not be of type number. Received type number');
      }
      const valueOf = value.valueOf && value.valueOf();
      if (valueOf != null && valueOf !== value) {
        return Buffer5.from(valueOf, encodingOrOffset, length);
      }
      const b = fromObject(value);
      if (b)
        return b;
      if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
        return Buffer5.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
      }
      throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    }
    Buffer5.from = function(value, encodingOrOffset, length) {
      return from(value, encodingOrOffset, length);
    };
    Object.setPrototypeOf(Buffer5.prototype, Uint8Array.prototype);
    Object.setPrototypeOf(Buffer5, Uint8Array);
    function assertSize(size2) {
      if (typeof size2 !== "number") {
        throw new TypeError('"size" argument must be of type number');
      } else if (size2 < 0) {
        throw new RangeError('The value "' + size2 + '" is invalid for option "size"');
      }
    }
    function alloc(size2, fill2, encoding) {
      assertSize(size2);
      if (size2 <= 0) {
        return createBuffer(size2);
      }
      if (fill2 !== void 0) {
        return typeof encoding === "string" ? createBuffer(size2).fill(fill2, encoding) : createBuffer(size2).fill(fill2);
      }
      return createBuffer(size2);
    }
    Buffer5.alloc = function(size2, fill2, encoding) {
      return alloc(size2, fill2, encoding);
    };
    function allocUnsafe2(size2) {
      assertSize(size2);
      return createBuffer(size2 < 0 ? 0 : checked(size2) | 0);
    }
    Buffer5.allocUnsafe = function(size2) {
      return allocUnsafe2(size2);
    };
    Buffer5.allocUnsafeSlow = function(size2) {
      return allocUnsafe2(size2);
    };
    function fromString(string, encoding) {
      if (typeof encoding !== "string" || encoding === "") {
        encoding = "utf8";
      }
      if (!Buffer5.isEncoding(encoding)) {
        throw new TypeError("Unknown encoding: " + encoding);
      }
      const length = byteLength(string, encoding) | 0;
      let buf = createBuffer(length);
      const actual = buf.write(string, encoding);
      if (actual !== length) {
        buf = buf.slice(0, actual);
      }
      return buf;
    }
    function fromArrayLike(array) {
      const length = array.length < 0 ? 0 : checked(array.length) | 0;
      const buf = createBuffer(length);
      for (let i = 0; i < length; i += 1) {
        buf[i] = array[i] & 255;
      }
      return buf;
    }
    function fromArrayView(arrayView) {
      if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
      }
      return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array, byteOffset, length) {
      if (byteOffset < 0 || array.byteLength < byteOffset) {
        throw new RangeError('"offset" is outside of buffer bounds');
      }
      if (array.byteLength < byteOffset + (length || 0)) {
        throw new RangeError('"length" is outside of buffer bounds');
      }
      let buf;
      if (byteOffset === void 0 && length === void 0) {
        buf = new Uint8Array(array);
      } else if (length === void 0) {
        buf = new Uint8Array(array, byteOffset);
      } else {
        buf = new Uint8Array(array, byteOffset, length);
      }
      Object.setPrototypeOf(buf, Buffer5.prototype);
      return buf;
    }
    function fromObject(obj) {
      if (Buffer5.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) {
          return buf;
        }
        obj.copy(buf, 0, 0, len);
        return buf;
      }
      if (obj.length !== void 0) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
          return createBuffer(0);
        }
        return fromArrayLike(obj);
      }
      if (obj.type === "Buffer" && Array.isArray(obj.data)) {
        return fromArrayLike(obj.data);
      }
    }
    function checked(length) {
      if (length >= K_MAX_LENGTH) {
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
      }
      return length | 0;
    }
    function SlowBuffer(length) {
      if (+length != length) {
        length = 0;
      }
      return Buffer5.alloc(+length);
    }
    Buffer5.isBuffer = function isBuffer3(b) {
      return b != null && b._isBuffer === true && b !== Buffer5.prototype;
    };
    Buffer5.compare = function compare(a, b) {
      if (isInstance(a, Uint8Array))
        a = Buffer5.from(a, a.offset, a.byteLength);
      if (isInstance(b, Uint8Array))
        b = Buffer5.from(b, b.offset, b.byteLength);
      if (!Buffer5.isBuffer(a) || !Buffer5.isBuffer(b)) {
        throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
      }
      if (a === b)
        return 0;
      let x = a.length;
      let y = b.length;
      for (let i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i];
          y = b[i];
          break;
        }
      }
      if (x < y)
        return -1;
      if (y < x)
        return 1;
      return 0;
    };
    Buffer5.isEncoding = function isEncoding(encoding) {
      switch (String(encoding).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return true;
        default:
          return false;
      }
    };
    Buffer5.concat = function concat2(list, length) {
      if (!Array.isArray(list)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      }
      if (list.length === 0) {
        return Buffer5.alloc(0);
      }
      let i;
      if (length === void 0) {
        length = 0;
        for (i = 0; i < list.length; ++i) {
          length += list[i].length;
        }
      }
      const buffer = Buffer5.allocUnsafe(length);
      let pos = 0;
      for (i = 0; i < list.length; ++i) {
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
          if (pos + buf.length > buffer.length) {
            if (!Buffer5.isBuffer(buf))
              buf = Buffer5.from(buf);
            buf.copy(buffer, pos);
          } else {
            Uint8Array.prototype.set.call(buffer, buf, pos);
          }
        } else if (!Buffer5.isBuffer(buf)) {
          throw new TypeError('"list" argument must be an Array of Buffers');
        } else {
          buf.copy(buffer, pos);
        }
        pos += buf.length;
      }
      return buffer;
    };
    function byteLength(string, encoding) {
      if (Buffer5.isBuffer(string)) {
        return string.length;
      }
      if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
        return string.byteLength;
      }
      if (typeof string !== "string") {
        throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
      }
      const len = string.length;
      const mustMatch = arguments.length > 2 && arguments[2] === true;
      if (!mustMatch && len === 0)
        return 0;
      let loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "ascii":
          case "latin1":
          case "binary":
            return len;
          case "utf8":
          case "utf-8":
            return utf8ToBytes(string).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return len * 2;
          case "hex":
            return len >>> 1;
          case "base64":
            return base64ToBytes(string).length;
          default:
            if (loweredCase) {
              return mustMatch ? -1 : utf8ToBytes(string).length;
            }
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer5.byteLength = byteLength;
    function slowToString(encoding, start, end) {
      let loweredCase = false;
      if (start === void 0 || start < 0) {
        start = 0;
      }
      if (start > this.length) {
        return "";
      }
      if (end === void 0 || end > this.length) {
        end = this.length;
      }
      if (end <= 0) {
        return "";
      }
      end >>>= 0;
      start >>>= 0;
      if (end <= start) {
        return "";
      }
      if (!encoding)
        encoding = "utf8";
      while (true) {
        switch (encoding) {
          case "hex":
            return hexSlice(this, start, end);
          case "utf8":
          case "utf-8":
            return utf8Slice(this, start, end);
          case "ascii":
            return asciiSlice(this, start, end);
          case "latin1":
          case "binary":
            return latin1Slice(this, start, end);
          case "base64":
            return base64Slice(this, start, end);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return utf16leSlice(this, start, end);
          default:
            if (loweredCase)
              throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer5.prototype._isBuffer = true;
    function swap(b, n, m) {
      const i = b[n];
      b[n] = b[m];
      b[m] = i;
    }
    Buffer5.prototype.swap16 = function swap16() {
      const len = this.length;
      if (len % 2 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      }
      for (let i = 0; i < len; i += 2) {
        swap(this, i, i + 1);
      }
      return this;
    };
    Buffer5.prototype.swap32 = function swap32() {
      const len = this.length;
      if (len % 4 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      }
      for (let i = 0; i < len; i += 4) {
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
      }
      return this;
    };
    Buffer5.prototype.swap64 = function swap64() {
      const len = this.length;
      if (len % 8 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      }
      for (let i = 0; i < len; i += 8) {
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
      }
      return this;
    };
    Buffer5.prototype.toString = function toString2() {
      const length = this.length;
      if (length === 0)
        return "";
      if (arguments.length === 0)
        return utf8Slice(this, 0, length);
      return slowToString.apply(this, arguments);
    };
    Buffer5.prototype.toLocaleString = Buffer5.prototype.toString;
    Buffer5.prototype.equals = function equals(b) {
      if (!Buffer5.isBuffer(b))
        throw new TypeError("Argument must be a Buffer");
      if (this === b)
        return true;
      return Buffer5.compare(this, b) === 0;
    };
    Buffer5.prototype.inspect = function inspect2() {
      let str = "";
      const max2 = exports2.INSPECT_MAX_BYTES;
      str = this.toString("hex", 0, max2).replace(/(.{2})/g, "$1 ").trim();
      if (this.length > max2)
        str += " ... ";
      return "<Buffer " + str + ">";
    };
    if (customInspectSymbol) {
      Buffer5.prototype[customInspectSymbol] = Buffer5.prototype.inspect;
    }
    Buffer5.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
      if (isInstance(target, Uint8Array)) {
        target = Buffer5.from(target, target.offset, target.byteLength);
      }
      if (!Buffer5.isBuffer(target)) {
        throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
      }
      if (start === void 0) {
        start = 0;
      }
      if (end === void 0) {
        end = target ? target.length : 0;
      }
      if (thisStart === void 0) {
        thisStart = 0;
      }
      if (thisEnd === void 0) {
        thisEnd = this.length;
      }
      if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError("out of range index");
      }
      if (thisStart >= thisEnd && start >= end) {
        return 0;
      }
      if (thisStart >= thisEnd) {
        return -1;
      }
      if (start >= end) {
        return 1;
      }
      start >>>= 0;
      end >>>= 0;
      thisStart >>>= 0;
      thisEnd >>>= 0;
      if (this === target)
        return 0;
      let x = thisEnd - thisStart;
      let y = end - start;
      const len = Math.min(x, y);
      const thisCopy = this.slice(thisStart, thisEnd);
      const targetCopy = target.slice(start, end);
      for (let i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
          x = thisCopy[i];
          y = targetCopy[i];
          break;
        }
      }
      if (x < y)
        return -1;
      if (y < x)
        return 1;
      return 0;
    };
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
      if (buffer.length === 0)
        return -1;
      if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
      } else if (byteOffset > 2147483647) {
        byteOffset = 2147483647;
      } else if (byteOffset < -2147483648) {
        byteOffset = -2147483648;
      }
      byteOffset = +byteOffset;
      if (numberIsNaN(byteOffset)) {
        byteOffset = dir ? 0 : buffer.length - 1;
      }
      if (byteOffset < 0)
        byteOffset = buffer.length + byteOffset;
      if (byteOffset >= buffer.length) {
        if (dir)
          return -1;
        else
          byteOffset = buffer.length - 1;
      } else if (byteOffset < 0) {
        if (dir)
          byteOffset = 0;
        else
          return -1;
      }
      if (typeof val === "string") {
        val = Buffer5.from(val, encoding);
      }
      if (Buffer5.isBuffer(val)) {
        if (val.length === 0) {
          return -1;
        }
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
      } else if (typeof val === "number") {
        val = val & 255;
        if (typeof Uint8Array.prototype.indexOf === "function") {
          if (dir) {
            return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
          } else {
            return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
          }
        }
        return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
      }
      throw new TypeError("val must be string, number or Buffer");
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
      let indexSize = 1;
      let arrLength = arr.length;
      let valLength = val.length;
      if (encoding !== void 0) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
          if (arr.length < 2 || val.length < 2) {
            return -1;
          }
          indexSize = 2;
          arrLength /= 2;
          valLength /= 2;
          byteOffset /= 2;
        }
      }
      function read(buf, i2) {
        if (indexSize === 1) {
          return buf[i2];
        } else {
          return buf.readUInt16BE(i2 * indexSize);
        }
      }
      let i;
      if (dir) {
        let foundIndex = -1;
        for (i = byteOffset; i < arrLength; i++) {
          if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1)
              foundIndex = i;
            if (i - foundIndex + 1 === valLength)
              return foundIndex * indexSize;
          } else {
            if (foundIndex !== -1)
              i -= i - foundIndex;
            foundIndex = -1;
          }
        }
      } else {
        if (byteOffset + valLength > arrLength)
          byteOffset = arrLength - valLength;
        for (i = byteOffset; i >= 0; i--) {
          let found = true;
          for (let j = 0; j < valLength; j++) {
            if (read(arr, i + j) !== read(val, j)) {
              found = false;
              break;
            }
          }
          if (found)
            return i;
        }
      }
      return -1;
    }
    Buffer5.prototype.includes = function includes2(val, byteOffset, encoding) {
      return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer5.prototype.indexOf = function indexOf2(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer5.prototype.lastIndexOf = function lastIndexOf2(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length) {
      offset = Number(offset) || 0;
      const remaining = buf.length - offset;
      if (!length) {
        length = remaining;
      } else {
        length = Number(length);
        if (length > remaining) {
          length = remaining;
        }
      }
      const strLen = string.length;
      if (length > strLen / 2) {
        length = strLen / 2;
      }
      let i;
      for (i = 0; i < length; ++i) {
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed))
          return i;
        buf[offset + i] = parsed;
      }
      return i;
    }
    function utf8Write(buf, string, offset, length) {
      return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string, offset, length) {
      return blitBuffer(asciiToBytes(string), buf, offset, length);
    }
    function base64Write(buf, string, offset, length) {
      return blitBuffer(base64ToBytes(string), buf, offset, length);
    }
    function ucs2Write(buf, string, offset, length) {
      return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }
    Buffer5.prototype.write = function write(string, offset, length, encoding) {
      if (offset === void 0) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
      } else if (length === void 0 && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
      } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
          length = length >>> 0;
          if (encoding === void 0)
            encoding = "utf8";
        } else {
          encoding = length;
          length = void 0;
        }
      } else {
        throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
      }
      const remaining = this.length - offset;
      if (length === void 0 || length > remaining)
        length = remaining;
      if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
        throw new RangeError("Attempt to write outside buffer bounds");
      }
      if (!encoding)
        encoding = "utf8";
      let loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "hex":
            return hexWrite(this, string, offset, length);
          case "utf8":
          case "utf-8":
            return utf8Write(this, string, offset, length);
          case "ascii":
          case "latin1":
          case "binary":
            return asciiWrite(this, string, offset, length);
          case "base64":
            return base64Write(this, string, offset, length);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ucs2Write(this, string, offset, length);
          default:
            if (loweredCase)
              throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    };
    Buffer5.prototype.toJSON = function toJSON() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function base64Slice(buf, start, end) {
      if (start === 0 && end === buf.length) {
        return base64.fromByteArray(buf);
      } else {
        return base64.fromByteArray(buf.slice(start, end));
      }
    }
    function utf8Slice(buf, start, end) {
      end = Math.min(buf.length, end);
      const res = [];
      let i = start;
      while (i < end) {
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
        if (i + bytesPerSequence <= end) {
          let secondByte, thirdByte, fourthByte, tempCodePoint;
          switch (bytesPerSequence) {
            case 1:
              if (firstByte < 128) {
                codePoint = firstByte;
              }
              break;
            case 2:
              secondByte = buf[i + 1];
              if ((secondByte & 192) === 128) {
                tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                if (tempCodePoint > 127) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 3:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 4:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              fourthByte = buf[i + 3];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                  codePoint = tempCodePoint;
                }
              }
          }
        }
        if (codePoint === null) {
          codePoint = 65533;
          bytesPerSequence = 1;
        } else if (codePoint > 65535) {
          codePoint -= 65536;
          res.push(codePoint >>> 10 & 1023 | 55296);
          codePoint = 56320 | codePoint & 1023;
        }
        res.push(codePoint);
        i += bytesPerSequence;
      }
      return decodeCodePointsArray(res);
    }
    const MAX_ARGUMENTS_LENGTH = 4096;
    function decodeCodePointsArray(codePoints) {
      const len = codePoints.length;
      if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints);
      }
      let res = "";
      let i = 0;
      while (i < len) {
        res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
      }
      return res;
    }
    function asciiSlice(buf, start, end) {
      let ret = "";
      end = Math.min(buf.length, end);
      for (let i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 127);
      }
      return ret;
    }
    function latin1Slice(buf, start, end) {
      let ret = "";
      end = Math.min(buf.length, end);
      for (let i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i]);
      }
      return ret;
    }
    function hexSlice(buf, start, end) {
      const len = buf.length;
      if (!start || start < 0)
        start = 0;
      if (!end || end < 0 || end > len)
        end = len;
      let out = "";
      for (let i = start; i < end; ++i) {
        out += hexSliceLookupTable[buf[i]];
      }
      return out;
    }
    function utf16leSlice(buf, start, end) {
      const bytes = buf.slice(start, end);
      let res = "";
      for (let i = 0; i < bytes.length - 1; i += 2) {
        res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
      }
      return res;
    }
    Buffer5.prototype.slice = function slice2(start, end) {
      const len = this.length;
      start = ~~start;
      end = end === void 0 ? len : ~~end;
      if (start < 0) {
        start += len;
        if (start < 0)
          start = 0;
      } else if (start > len) {
        start = len;
      }
      if (end < 0) {
        end += len;
        if (end < 0)
          end = 0;
      } else if (end > len) {
        end = len;
      }
      if (end < start)
        end = start;
      const newBuf = this.subarray(start, end);
      Object.setPrototypeOf(newBuf, Buffer5.prototype);
      return newBuf;
    };
    function checkOffset(offset, ext, length) {
      if (offset % 1 !== 0 || offset < 0)
        throw new RangeError("offset is not uint");
      if (offset + ext > length)
        throw new RangeError("Trying to access beyond buffer length");
    }
    Buffer5.prototype.readUintLE = Buffer5.prototype.readUIntLE = function readUIntLE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert)
        checkOffset(offset, byteLength2, this.length);
      let val = this[offset];
      let mul = 1;
      let i = 0;
      while (++i < byteLength2 && (mul *= 256)) {
        val += this[offset + i] * mul;
      }
      return val;
    };
    Buffer5.prototype.readUintBE = Buffer5.prototype.readUIntBE = function readUIntBE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        checkOffset(offset, byteLength2, this.length);
      }
      let val = this[offset + --byteLength2];
      let mul = 1;
      while (byteLength2 > 0 && (mul *= 256)) {
        val += this[offset + --byteLength2] * mul;
      }
      return val;
    };
    Buffer5.prototype.readUint8 = Buffer5.prototype.readUInt8 = function readUInt8(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 1, this.length);
      return this[offset];
    };
    Buffer5.prototype.readUint16LE = Buffer5.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      return this[offset] | this[offset + 1] << 8;
    };
    Buffer5.prototype.readUint16BE = Buffer5.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      return this[offset] << 8 | this[offset + 1];
    };
    Buffer5.prototype.readUint32LE = Buffer5.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
    };
    Buffer5.prototype.readUint32BE = Buffer5.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer5.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last2 = this[offset + 7];
      if (first === void 0 || last2 === void 0) {
        boundsError(offset, this.length - 8);
      }
      const lo = first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
      const hi = this[++offset] + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + last2 * 2 ** 24;
      return BigInt(lo) + (BigInt(hi) << BigInt(32));
    });
    Buffer5.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last2 = this[offset + 7];
      if (first === void 0 || last2 === void 0) {
        boundsError(offset, this.length - 8);
      }
      const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
      const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last2;
      return (BigInt(hi) << BigInt(32)) + BigInt(lo);
    });
    Buffer5.prototype.readIntLE = function readIntLE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert)
        checkOffset(offset, byteLength2, this.length);
      let val = this[offset];
      let mul = 1;
      let i = 0;
      while (++i < byteLength2 && (mul *= 256)) {
        val += this[offset + i] * mul;
      }
      mul *= 128;
      if (val >= mul)
        val -= Math.pow(2, 8 * byteLength2);
      return val;
    };
    Buffer5.prototype.readIntBE = function readIntBE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert)
        checkOffset(offset, byteLength2, this.length);
      let i = byteLength2;
      let mul = 1;
      let val = this[offset + --i];
      while (i > 0 && (mul *= 256)) {
        val += this[offset + --i] * mul;
      }
      mul *= 128;
      if (val >= mul)
        val -= Math.pow(2, 8 * byteLength2);
      return val;
    };
    Buffer5.prototype.readInt8 = function readInt8(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 1, this.length);
      if (!(this[offset] & 128))
        return this[offset];
      return (255 - this[offset] + 1) * -1;
    };
    Buffer5.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      const val = this[offset] | this[offset + 1] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer5.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      const val = this[offset + 1] | this[offset] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer5.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer5.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer5.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last2 = this[offset + 7];
      if (first === void 0 || last2 === void 0) {
        boundsError(offset, this.length - 8);
      }
      const val = this[offset + 4] + this[offset + 5] * 2 ** 8 + this[offset + 6] * 2 ** 16 + (last2 << 24);
      return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
    });
    Buffer5.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last2 = this[offset + 7];
      if (first === void 0 || last2 === void 0) {
        boundsError(offset, this.length - 8);
      }
      const val = (first << 24) + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
      return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last2);
    });
    Buffer5.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, true, 23, 4);
    };
    Buffer5.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, false, 23, 4);
    };
    Buffer5.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, true, 52, 8);
    };
    Buffer5.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max2, min2) {
      if (!Buffer5.isBuffer(buf))
        throw new TypeError('"buffer" argument must be a Buffer instance');
      if (value > max2 || value < min2)
        throw new RangeError('"value" argument is out of bounds');
      if (offset + ext > buf.length)
        throw new RangeError("Index out of range");
    }
    Buffer5.prototype.writeUintLE = Buffer5.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
        checkInt(this, value, offset, byteLength2, maxBytes, 0);
      }
      let mul = 1;
      let i = 0;
      this[offset] = value & 255;
      while (++i < byteLength2 && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
      }
      return offset + byteLength2;
    };
    Buffer5.prototype.writeUintBE = Buffer5.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
        checkInt(this, value, offset, byteLength2, maxBytes, 0);
      }
      let i = byteLength2 - 1;
      let mul = 1;
      this[offset + i] = value & 255;
      while (--i >= 0 && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
      }
      return offset + byteLength2;
    };
    Buffer5.prototype.writeUint8 = Buffer5.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 1, 255, 0);
      this[offset] = value & 255;
      return offset + 1;
    };
    Buffer5.prototype.writeUint16LE = Buffer5.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      return offset + 2;
    };
    Buffer5.prototype.writeUint16BE = Buffer5.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
      this[offset] = value >>> 8;
      this[offset + 1] = value & 255;
      return offset + 2;
    };
    Buffer5.prototype.writeUint32LE = Buffer5.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
      this[offset + 3] = value >>> 24;
      this[offset + 2] = value >>> 16;
      this[offset + 1] = value >>> 8;
      this[offset] = value & 255;
      return offset + 4;
    };
    Buffer5.prototype.writeUint32BE = Buffer5.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 255;
      return offset + 4;
    };
    function wrtBigUInt64LE(buf, value, offset, min2, max2) {
      checkIntBI(value, min2, max2, buf, offset, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      return offset;
    }
    function wrtBigUInt64BE(buf, value, offset, min2, max2) {
      checkIntBI(value, min2, max2, buf, offset, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset + 7] = lo;
      lo = lo >> 8;
      buf[offset + 6] = lo;
      lo = lo >> 8;
      buf[offset + 5] = lo;
      lo = lo >> 8;
      buf[offset + 4] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      buf[offset + 3] = hi;
      hi = hi >> 8;
      buf[offset + 2] = hi;
      hi = hi >> 8;
      buf[offset + 1] = hi;
      hi = hi >> 8;
      buf[offset] = hi;
      return offset + 8;
    }
    Buffer5.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
      return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer5.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
      return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer5.prototype.writeIntLE = function writeIntLE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength2 - 1);
        checkInt(this, value, offset, byteLength2, limit - 1, -limit);
      }
      let i = 0;
      let mul = 1;
      let sub = 0;
      this[offset] = value & 255;
      while (++i < byteLength2 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 255;
      }
      return offset + byteLength2;
    };
    Buffer5.prototype.writeIntBE = function writeIntBE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength2 - 1);
        checkInt(this, value, offset, byteLength2, limit - 1, -limit);
      }
      let i = byteLength2 - 1;
      let mul = 1;
      let sub = 0;
      this[offset + i] = value & 255;
      while (--i >= 0 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 255;
      }
      return offset + byteLength2;
    };
    Buffer5.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 1, 127, -128);
      if (value < 0)
        value = 255 + value + 1;
      this[offset] = value & 255;
      return offset + 1;
    };
    Buffer5.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      return offset + 2;
    };
    Buffer5.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
      this[offset] = value >>> 8;
      this[offset + 1] = value & 255;
      return offset + 2;
    };
    Buffer5.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      this[offset + 2] = value >>> 16;
      this[offset + 3] = value >>> 24;
      return offset + 4;
    };
    Buffer5.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
      if (value < 0)
        value = 4294967295 + value + 1;
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 255;
      return offset + 4;
    };
    Buffer5.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
      return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    Buffer5.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
      return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function checkIEEE754(buf, value, offset, ext, max2, min2) {
      if (offset + ext > buf.length)
        throw new RangeError("Index out of range");
      if (offset < 0)
        throw new RangeError("Index out of range");
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 4);
      }
      ieee754.write(buf, value, offset, littleEndian, 23, 4);
      return offset + 4;
    }
    Buffer5.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
      return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer5.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
      return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 8);
      }
      ieee754.write(buf, value, offset, littleEndian, 52, 8);
      return offset + 8;
    }
    Buffer5.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
      return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer5.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
      return writeDouble(this, value, offset, false, noAssert);
    };
    Buffer5.prototype.copy = function copy(target, targetStart, start, end) {
      if (!Buffer5.isBuffer(target))
        throw new TypeError("argument should be a Buffer");
      if (!start)
        start = 0;
      if (!end && end !== 0)
        end = this.length;
      if (targetStart >= target.length)
        targetStart = target.length;
      if (!targetStart)
        targetStart = 0;
      if (end > 0 && end < start)
        end = start;
      if (end === start)
        return 0;
      if (target.length === 0 || this.length === 0)
        return 0;
      if (targetStart < 0) {
        throw new RangeError("targetStart out of bounds");
      }
      if (start < 0 || start >= this.length)
        throw new RangeError("Index out of range");
      if (end < 0)
        throw new RangeError("sourceEnd out of bounds");
      if (end > this.length)
        end = this.length;
      if (target.length - targetStart < end - start) {
        end = target.length - targetStart + start;
      }
      const len = end - start;
      if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
        this.copyWithin(targetStart, start, end);
      } else {
        Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
      }
      return len;
    };
    Buffer5.prototype.fill = function fill2(val, start, end, encoding) {
      if (typeof val === "string") {
        if (typeof start === "string") {
          encoding = start;
          start = 0;
          end = this.length;
        } else if (typeof end === "string") {
          encoding = end;
          end = this.length;
        }
        if (encoding !== void 0 && typeof encoding !== "string") {
          throw new TypeError("encoding must be a string");
        }
        if (typeof encoding === "string" && !Buffer5.isEncoding(encoding)) {
          throw new TypeError("Unknown encoding: " + encoding);
        }
        if (val.length === 1) {
          const code = val.charCodeAt(0);
          if (encoding === "utf8" && code < 128 || encoding === "latin1") {
            val = code;
          }
        }
      } else if (typeof val === "number") {
        val = val & 255;
      } else if (typeof val === "boolean") {
        val = Number(val);
      }
      if (start < 0 || this.length < start || this.length < end) {
        throw new RangeError("Out of range index");
      }
      if (end <= start) {
        return this;
      }
      start = start >>> 0;
      end = end === void 0 ? this.length : end >>> 0;
      if (!val)
        val = 0;
      let i;
      if (typeof val === "number") {
        for (i = start; i < end; ++i) {
          this[i] = val;
        }
      } else {
        const bytes = Buffer5.isBuffer(val) ? val : Buffer5.from(val, encoding);
        const len = bytes.length;
        if (len === 0) {
          throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        }
        for (i = 0; i < end - start; ++i) {
          this[i + start] = bytes[i % len];
        }
      }
      return this;
    };
    const errors = {};
    function E(sym, getMessage, Base) {
      errors[sym] = class NodeError extends Base {
        constructor() {
          super();
          Object.defineProperty(this, "message", {
            value: getMessage.apply(this, arguments),
            writable: true,
            configurable: true
          });
          this.name = `${this.name} [${sym}]`;
          this.stack;
          delete this.name;
        }
        get code() {
          return sym;
        }
        set code(value) {
          Object.defineProperty(this, "code", {
            configurable: true,
            enumerable: true,
            value,
            writable: true
          });
        }
        toString() {
          return `${this.name} [${sym}]: ${this.message}`;
        }
      };
    }
    E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
      if (name) {
        return `${name} is outside of buffer bounds`;
      }
      return "Attempt to access memory outside buffer bounds";
    }, RangeError);
    E("ERR_INVALID_ARG_TYPE", function(name, actual) {
      return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
    }, TypeError);
    E("ERR_OUT_OF_RANGE", function(str, range2, input) {
      let msg = `The value of "${str}" is out of range.`;
      let received = input;
      if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
        received = addNumericalSeparator(String(input));
      } else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
          received = addNumericalSeparator(received);
        }
        received += "n";
      }
      msg += ` It must be ${range2}. Received ${received}`;
      return msg;
    }, RangeError);
    function addNumericalSeparator(val) {
      let res = "";
      let i = val.length;
      const start = val[0] === "-" ? 1 : 0;
      for (; i >= start + 4; i -= 3) {
        res = `_${val.slice(i - 3, i)}${res}`;
      }
      return `${val.slice(0, i)}${res}`;
    }
    function checkBounds(buf, offset, byteLength2) {
      validateNumber(offset, "offset");
      if (buf[offset] === void 0 || buf[offset + byteLength2] === void 0) {
        boundsError(offset, buf.length - (byteLength2 + 1));
      }
    }
    function checkIntBI(value, min2, max2, buf, offset, byteLength2) {
      if (value > max2 || value < min2) {
        const n = typeof min2 === "bigint" ? "n" : "";
        let range2;
        {
          if (min2 === 0 || min2 === BigInt(0)) {
            range2 = `>= 0${n} and < 2${n} ** ${(byteLength2 + 1) * 8}${n}`;
          } else {
            range2 = `>= -(2${n} ** ${(byteLength2 + 1) * 8 - 1}${n}) and < 2 ** ${(byteLength2 + 1) * 8 - 1}${n}`;
          }
        }
        throw new errors.ERR_OUT_OF_RANGE("value", range2, value);
      }
      checkBounds(buf, offset, byteLength2);
    }
    function validateNumber(value, name) {
      if (typeof value !== "number") {
        throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
      }
    }
    function boundsError(value, length, type) {
      if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE("offset", "an integer", value);
      }
      if (length < 0) {
        throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
      }
      throw new errors.ERR_OUT_OF_RANGE("offset", `>= ${0} and <= ${length}`, value);
    }
    const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
      str = str.split("=")[0];
      str = str.trim().replace(INVALID_BASE64_RE, "");
      if (str.length < 2)
        return "";
      while (str.length % 4 !== 0) {
        str = str + "=";
      }
      return str;
    }
    function utf8ToBytes(string, units) {
      units = units || Infinity;
      let codePoint;
      const length = string.length;
      let leadSurrogate = null;
      const bytes = [];
      for (let i = 0; i < length; ++i) {
        codePoint = string.charCodeAt(i);
        if (codePoint > 55295 && codePoint < 57344) {
          if (!leadSurrogate) {
            if (codePoint > 56319) {
              if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
              continue;
            } else if (i + 1 === length) {
              if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
              continue;
            }
            leadSurrogate = codePoint;
            continue;
          }
          if (codePoint < 56320) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            leadSurrogate = codePoint;
            continue;
          }
          codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
        } else if (leadSurrogate) {
          if ((units -= 3) > -1)
            bytes.push(239, 191, 189);
        }
        leadSurrogate = null;
        if (codePoint < 128) {
          if ((units -= 1) < 0)
            break;
          bytes.push(codePoint);
        } else if (codePoint < 2048) {
          if ((units -= 2) < 0)
            break;
          bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
        } else if (codePoint < 65536) {
          if ((units -= 3) < 0)
            break;
          bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
        } else if (codePoint < 1114112) {
          if ((units -= 4) < 0)
            break;
          bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
        } else {
          throw new Error("Invalid code point");
        }
      }
      return bytes;
    }
    function asciiToBytes(str) {
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        byteArray.push(str.charCodeAt(i) & 255);
      }
      return byteArray;
    }
    function utf16leToBytes(str, units) {
      let c, hi, lo;
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        if ((units -= 2) < 0)
          break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
      }
      return byteArray;
    }
    function base64ToBytes(str) {
      return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
      let i;
      for (i = 0; i < length; ++i) {
        if (i + offset >= dst.length || i >= src.length)
          break;
        dst[i + offset] = src[i];
      }
      return i;
    }
    function isInstance(obj, type) {
      return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN(obj) {
      return obj !== obj;
    }
    const hexSliceLookupTable = function() {
      const alphabet = "0123456789abcdef";
      const table = new Array(256);
      for (let i = 0; i < 16; ++i) {
        const i16 = i * 16;
        for (let j = 0; j < 16; ++j) {
          table[i16 + j] = alphabet[i] + alphabet[j];
        }
      }
      return table;
    }();
    function defineBigIntMethod(fn) {
      return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
    }
    function BufferBigIntNotDefined() {
      throw new Error("BigInt not supported");
    }
    return exports2;
  }
  var exports$2, _dewExec$2, exports$1, _dewExec$1, exports2, _dewExec;
  var init_chunk_DtuTasat = __esm({
    "../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/chunk-DtuTasat.js"() {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      exports$2 = {};
      _dewExec$2 = false;
      exports$1 = {};
      _dewExec$1 = false;
      exports2 = {};
      _dewExec = false;
    }
  });

  // ../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/buffer.js
  var exports3, Buffer2, INSPECT_MAX_BYTES, kMaxLength;
  var init_buffer = __esm({
    "../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/buffer.js"() {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      init_chunk_DtuTasat();
      exports3 = dew();
      exports3["Buffer"];
      exports3["SlowBuffer"];
      exports3["INSPECT_MAX_BYTES"];
      exports3["kMaxLength"];
      Buffer2 = exports3.Buffer;
      INSPECT_MAX_BYTES = exports3.INSPECT_MAX_BYTES;
      kMaxLength = exports3.kMaxLength;
    }
  });

  // ../../node_modules/.pnpm/esbuild-plugin-polyfill-node@0.3.0_esbuild@0.14.54/node_modules/esbuild-plugin-polyfill-node/polyfills/buffer.js
  var init_buffer2 = __esm({
    "../../node_modules/.pnpm/esbuild-plugin-polyfill-node@0.3.0_esbuild@0.14.54/node_modules/esbuild-plugin-polyfill-node/polyfills/buffer.js"() {
      init_buffer();
    }
  });

  // ../../node_modules/.pnpm/lower-case@1.1.4/node_modules/lower-case/lower-case.js
  var require_lower_case = __commonJS({
    "../../node_modules/.pnpm/lower-case@1.1.4/node_modules/lower-case/lower-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var LANGUAGES = {
        tr: {
          regexp: /\u0130|\u0049|\u0049\u0307/g,
          map: {
            "\u0130": "i",
            "I": "\u0131",
            "I\u0307": "i"
          }
        },
        az: {
          regexp: /[\u0130]/g,
          map: {
            "\u0130": "i",
            "I": "\u0131",
            "I\u0307": "i"
          }
        },
        lt: {
          regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g,
          map: {
            "I": "i\u0307",
            "J": "j\u0307",
            "\u012E": "\u012F\u0307",
            "\xCC": "i\u0307\u0300",
            "\xCD": "i\u0307\u0301",
            "\u0128": "i\u0307\u0303"
          }
        }
      };
      module2.exports = function(str, locale) {
        var lang = LANGUAGES[locale];
        str = str == null ? "" : String(str);
        if (lang) {
          str = str.replace(lang.regexp, function(m) {
            return lang.map[m];
          });
        }
        return str.toLowerCase();
      };
    }
  });

  // ../../node_modules/.pnpm/no-case@2.3.2/node_modules/no-case/vendor/non-word-regexp.js
  var require_non_word_regexp = __commonJS({
    "../../node_modules/.pnpm/no-case@2.3.2/node_modules/no-case/vendor/non-word-regexp.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = /[^A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+/g;
    }
  });

  // ../../node_modules/.pnpm/no-case@2.3.2/node_modules/no-case/vendor/camel-case-regexp.js
  var require_camel_case_regexp = __commonJS({
    "../../node_modules/.pnpm/no-case@2.3.2/node_modules/no-case/vendor/camel-case-regexp.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = /([a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])/g;
    }
  });

  // ../../node_modules/.pnpm/no-case@2.3.2/node_modules/no-case/vendor/camel-case-upper-regexp.js
  var require_camel_case_upper_regexp = __commonJS({
    "../../node_modules/.pnpm/no-case@2.3.2/node_modules/no-case/vendor/camel-case-upper-regexp.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = /([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A][a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A])/g;
    }
  });

  // ../../node_modules/.pnpm/no-case@2.3.2/node_modules/no-case/no-case.js
  var require_no_case = __commonJS({
    "../../node_modules/.pnpm/no-case@2.3.2/node_modules/no-case/no-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var lowerCase2 = require_lower_case();
      var NON_WORD_REGEXP = require_non_word_regexp();
      var CAMEL_CASE_REGEXP = require_camel_case_regexp();
      var CAMEL_CASE_UPPER_REGEXP = require_camel_case_upper_regexp();
      module2.exports = function(str, locale, replacement) {
        if (str == null) {
          return "";
        }
        replacement = typeof replacement !== "string" ? " " : replacement;
        function replace2(match, index, value) {
          if (index === 0 || index === value.length - match.length) {
            return "";
          }
          return replacement;
        }
        str = String(str).replace(CAMEL_CASE_REGEXP, "$1 $2").replace(CAMEL_CASE_UPPER_REGEXP, "$1 $2").replace(NON_WORD_REGEXP, replace2);
        return lowerCase2(str, locale);
      };
    }
  });

  // ../../node_modules/.pnpm/dot-case@2.1.1/node_modules/dot-case/dot-case.js
  var require_dot_case = __commonJS({
    "../../node_modules/.pnpm/dot-case@2.1.1/node_modules/dot-case/dot-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var noCase = require_no_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale, ".");
      };
    }
  });

  // ../../node_modules/.pnpm/upper-case@1.1.3/node_modules/upper-case/upper-case.js
  var require_upper_case = __commonJS({
    "../../node_modules/.pnpm/upper-case@1.1.3/node_modules/upper-case/upper-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var LANGUAGES = {
        tr: {
          regexp: /[\u0069]/g,
          map: {
            "i": "\u0130"
          }
        },
        az: {
          regexp: /[\u0069]/g,
          map: {
            "i": "\u0130"
          }
        },
        lt: {
          regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
          map: {
            "i\u0307": "I",
            "j\u0307": "J",
            "\u012F\u0307": "\u012E",
            "i\u0307\u0300": "\xCC",
            "i\u0307\u0301": "\xCD",
            "i\u0307\u0303": "\u0128"
          }
        }
      };
      module2.exports = function(str, locale) {
        var lang = LANGUAGES[locale];
        str = str == null ? "" : String(str);
        if (lang) {
          str = str.replace(lang.regexp, function(m) {
            return lang.map[m];
          });
        }
        return str.toUpperCase();
      };
    }
  });

  // ../../node_modules/.pnpm/swap-case@1.1.2/node_modules/swap-case/swap-case.js
  var require_swap_case = __commonJS({
    "../../node_modules/.pnpm/swap-case@1.1.2/node_modules/swap-case/swap-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var upperCase2 = require_upper_case();
      var lowerCase2 = require_lower_case();
      module2.exports = function(str, locale) {
        if (str == null) {
          return "";
        }
        var result2 = "";
        for (var i = 0; i < str.length; i++) {
          var c = str[i];
          var u = upperCase2(c, locale);
          result2 += u === c ? lowerCase2(c, locale) : u;
        }
        return result2;
      };
    }
  });

  // ../../node_modules/.pnpm/path-case@2.1.1/node_modules/path-case/path-case.js
  var require_path_case = __commonJS({
    "../../node_modules/.pnpm/path-case@2.1.1/node_modules/path-case/path-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var noCase = require_no_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale, "/");
      };
    }
  });

  // ../../node_modules/.pnpm/camel-case@3.0.0/node_modules/camel-case/camel-case.js
  var require_camel_case = __commonJS({
    "../../node_modules/.pnpm/camel-case@3.0.0/node_modules/camel-case/camel-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var upperCase2 = require_upper_case();
      var noCase = require_no_case();
      module2.exports = function(value, locale, mergeNumbers) {
        var result2 = noCase(value, locale);
        if (!mergeNumbers) {
          result2 = result2.replace(/ (?=\d)/g, "_");
        }
        return result2.replace(/ (.)/g, function(m, $1) {
          return upperCase2($1, locale);
        });
      };
    }
  });

  // ../../node_modules/.pnpm/snake-case@2.1.0/node_modules/snake-case/snake-case.js
  var require_snake_case = __commonJS({
    "../../node_modules/.pnpm/snake-case@2.1.0/node_modules/snake-case/snake-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var noCase = require_no_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale, "_");
      };
    }
  });

  // ../../node_modules/.pnpm/title-case@2.1.1/node_modules/title-case/title-case.js
  var require_title_case = __commonJS({
    "../../node_modules/.pnpm/title-case@2.1.1/node_modules/title-case/title-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var noCase = require_no_case();
      var upperCase2 = require_upper_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale).replace(/^.| ./g, function(m) {
          return upperCase2(m, locale);
        });
      };
    }
  });

  // ../../node_modules/.pnpm/param-case@2.1.1/node_modules/param-case/param-case.js
  var require_param_case = __commonJS({
    "../../node_modules/.pnpm/param-case@2.1.1/node_modules/param-case/param-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var noCase = require_no_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale, "-");
      };
    }
  });

  // ../../node_modules/.pnpm/header-case@1.0.1/node_modules/header-case/header-case.js
  var require_header_case = __commonJS({
    "../../node_modules/.pnpm/header-case@1.0.1/node_modules/header-case/header-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var noCase = require_no_case();
      var upperCase2 = require_upper_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale, "-").replace(/^.|-./g, function(m) {
          return upperCase2(m, locale);
        });
      };
    }
  });

  // ../../node_modules/.pnpm/upper-case-first@1.1.2/node_modules/upper-case-first/upper-case-first.js
  var require_upper_case_first = __commonJS({
    "../../node_modules/.pnpm/upper-case-first@1.1.2/node_modules/upper-case-first/upper-case-first.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var upperCase2 = require_upper_case();
      module2.exports = function(str, locale) {
        if (str == null) {
          return "";
        }
        str = String(str);
        return upperCase2(str.charAt(0), locale) + str.substr(1);
      };
    }
  });

  // ../../node_modules/.pnpm/pascal-case@2.0.1/node_modules/pascal-case/pascal-case.js
  var require_pascal_case = __commonJS({
    "../../node_modules/.pnpm/pascal-case@2.0.1/node_modules/pascal-case/pascal-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var camelCase2 = require_camel_case();
      var upperCaseFirst2 = require_upper_case_first();
      module2.exports = function(value, locale, mergeNumbers) {
        return upperCaseFirst2(camelCase2(value, locale, mergeNumbers), locale);
      };
    }
  });

  // ../../node_modules/.pnpm/constant-case@2.0.0/node_modules/constant-case/constant-case.js
  var require_constant_case = __commonJS({
    "../../node_modules/.pnpm/constant-case@2.0.0/node_modules/constant-case/constant-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var upperCase2 = require_upper_case();
      var snakeCase2 = require_snake_case();
      module2.exports = function(value, locale) {
        return upperCase2(snakeCase2(value, locale), locale);
      };
    }
  });

  // ../../node_modules/.pnpm/sentence-case@2.1.1/node_modules/sentence-case/sentence-case.js
  var require_sentence_case = __commonJS({
    "../../node_modules/.pnpm/sentence-case@2.1.1/node_modules/sentence-case/sentence-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var noCase = require_no_case();
      var upperCaseFirst2 = require_upper_case_first();
      module2.exports = function(value, locale) {
        return upperCaseFirst2(noCase(value, locale), locale);
      };
    }
  });

  // ../../node_modules/.pnpm/is-upper-case@1.1.2/node_modules/is-upper-case/is-upper-case.js
  var require_is_upper_case = __commonJS({
    "../../node_modules/.pnpm/is-upper-case@1.1.2/node_modules/is-upper-case/is-upper-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var upperCase2 = require_upper_case();
      module2.exports = function(string, locale) {
        return upperCase2(string, locale) === string;
      };
    }
  });

  // ../../node_modules/.pnpm/is-lower-case@1.1.3/node_modules/is-lower-case/is-lower-case.js
  var require_is_lower_case = __commonJS({
    "../../node_modules/.pnpm/is-lower-case@1.1.3/node_modules/is-lower-case/is-lower-case.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var lowerCase2 = require_lower_case();
      module2.exports = function(string, locale) {
        return lowerCase2(string, locale) === string;
      };
    }
  });

  // ../../node_modules/.pnpm/lower-case-first@1.0.2/node_modules/lower-case-first/lower-case-first.js
  var require_lower_case_first = __commonJS({
    "../../node_modules/.pnpm/lower-case-first@1.0.2/node_modules/lower-case-first/lower-case-first.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var lowerCase2 = require_lower_case();
      module2.exports = function(str, locale) {
        if (str == null) {
          return "";
        }
        str = String(str);
        return lowerCase2(str.charAt(0), locale) + str.substr(1);
      };
    }
  });

  // ../../node_modules/.pnpm/change-case@3.1.0/node_modules/change-case/change-case.js
  var require_change_case = __commonJS({
    "../../node_modules/.pnpm/change-case@3.1.0/node_modules/change-case/change-case.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      exports8.no = exports8.noCase = require_no_case();
      exports8.dot = exports8.dotCase = require_dot_case();
      exports8.swap = exports8.swapCase = require_swap_case();
      exports8.path = exports8.pathCase = require_path_case();
      exports8.upper = exports8.upperCase = require_upper_case();
      exports8.lower = exports8.lowerCase = require_lower_case();
      exports8.camel = exports8.camelCase = require_camel_case();
      exports8.snake = exports8.snakeCase = require_snake_case();
      exports8.title = exports8.titleCase = require_title_case();
      exports8.param = exports8.paramCase = require_param_case();
      exports8.kebab = exports8.kebabCase = exports8.paramCase;
      exports8.hyphen = exports8.hyphenCase = exports8.paramCase;
      exports8.header = exports8.headerCase = require_header_case();
      exports8.pascal = exports8.pascalCase = require_pascal_case();
      exports8.constant = exports8.constantCase = require_constant_case();
      exports8.sentence = exports8.sentenceCase = require_sentence_case();
      exports8.isUpper = exports8.isUpperCase = require_is_upper_case();
      exports8.isLower = exports8.isLowerCase = require_is_lower_case();
      exports8.ucFirst = exports8.upperCaseFirst = require_upper_case_first();
      exports8.lcFirst = exports8.lowerCaseFirst = require_lower_case_first();
    }
  });

  // ../../node_modules/.pnpm/any-base@1.1.0/node_modules/any-base/src/converter.js
  var require_converter = __commonJS({
    "../../node_modules/.pnpm/any-base@1.1.0/node_modules/any-base/src/converter.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      function Converter(srcAlphabet, dstAlphabet) {
        if (!srcAlphabet || !dstAlphabet || !srcAlphabet.length || !dstAlphabet.length) {
          throw new Error("Bad alphabet");
        }
        this.srcAlphabet = srcAlphabet;
        this.dstAlphabet = dstAlphabet;
      }
      Converter.prototype.convert = function(number) {
        var i, divide2, newlen, numberMap = {}, fromBase = this.srcAlphabet.length, toBase = this.dstAlphabet.length, length = number.length, result2 = typeof number === "string" ? "" : [];
        if (!this.isValid(number)) {
          throw new Error('Number "' + number + '" contains of non-alphabetic digits (' + this.srcAlphabet + ")");
        }
        if (this.srcAlphabet === this.dstAlphabet) {
          return number;
        }
        for (i = 0; i < length; i++) {
          numberMap[i] = this.srcAlphabet.indexOf(number[i]);
        }
        do {
          divide2 = 0;
          newlen = 0;
          for (i = 0; i < length; i++) {
            divide2 = divide2 * fromBase + numberMap[i];
            if (divide2 >= toBase) {
              numberMap[newlen++] = parseInt(divide2 / toBase, 10);
              divide2 = divide2 % toBase;
            } else if (newlen > 0) {
              numberMap[newlen++] = 0;
            }
          }
          length = newlen;
          result2 = this.dstAlphabet.slice(divide2, divide2 + 1).concat(result2);
        } while (newlen !== 0);
        return result2;
      };
      Converter.prototype.isValid = function(number) {
        var i = 0;
        for (; i < number.length; ++i) {
          if (this.srcAlphabet.indexOf(number[i]) === -1) {
            return false;
          }
        }
        return true;
      };
      module2.exports = Converter;
    }
  });

  // ../../node_modules/.pnpm/any-base@1.1.0/node_modules/any-base/index.js
  var require_any_base = __commonJS({
    "../../node_modules/.pnpm/any-base@1.1.0/node_modules/any-base/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var Converter = require_converter();
      function anyBase(srcAlphabet, dstAlphabet) {
        var converter = new Converter(srcAlphabet, dstAlphabet);
        return function(number) {
          return converter.convert(number);
        };
      }
      anyBase.BIN = "01";
      anyBase.OCT = "01234567";
      anyBase.DEC = "0123456789";
      anyBase.HEX = "0123456789abcdef";
      module2.exports = anyBase;
    }
  });

  // ../../node_modules/.pnpm/uuid@3.4.0/node_modules/uuid/lib/rng-browser.js
  var require_rng_browser = __commonJS({
    "../../node_modules/.pnpm/uuid@3.4.0/node_modules/uuid/lib/rng-browser.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
      if (getRandomValues) {
        rnds8 = new Uint8Array(16);
        module2.exports = function whatwgRNG() {
          getRandomValues(rnds8);
          return rnds8;
        };
      } else {
        rnds = new Array(16);
        module2.exports = function mathRNG() {
          for (var i = 0, r; i < 16; i++) {
            if ((i & 3) === 0)
              r = Math.random() * 4294967296;
            rnds[i] = r >>> ((i & 3) << 3) & 255;
          }
          return rnds;
        };
      }
      var rnds8;
      var rnds;
    }
  });

  // ../../node_modules/.pnpm/uuid@3.4.0/node_modules/uuid/lib/bytesToUuid.js
  var require_bytesToUuid = __commonJS({
    "../../node_modules/.pnpm/uuid@3.4.0/node_modules/uuid/lib/bytesToUuid.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var byteToHex = [];
      for (i = 0; i < 256; ++i) {
        byteToHex[i] = (i + 256).toString(16).substr(1);
      }
      var i;
      function bytesToUuid(buf, offset) {
        var i2 = offset || 0;
        var bth = byteToHex;
        return [
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]],
          "-",
          bth[buf[i2++]],
          bth[buf[i2++]],
          "-",
          bth[buf[i2++]],
          bth[buf[i2++]],
          "-",
          bth[buf[i2++]],
          bth[buf[i2++]],
          "-",
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]]
        ].join("");
      }
      module2.exports = bytesToUuid;
    }
  });

  // ../../node_modules/.pnpm/uuid@3.4.0/node_modules/uuid/v4.js
  var require_v4 = __commonJS({
    "../../node_modules/.pnpm/uuid@3.4.0/node_modules/uuid/v4.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var rng = require_rng_browser();
      var bytesToUuid = require_bytesToUuid();
      function v4(options, buf, offset) {
        var i = buf && offset || 0;
        if (typeof options == "string") {
          buf = options === "binary" ? new Array(16) : null;
          options = null;
        }
        options = options || {};
        var rnds = options.random || (options.rng || rng)();
        rnds[6] = rnds[6] & 15 | 64;
        rnds[8] = rnds[8] & 63 | 128;
        if (buf) {
          for (var ii = 0; ii < 16; ++ii) {
            buf[i + ii] = rnds[ii];
          }
        }
        return buf || bytesToUuid(rnds);
      }
      module2.exports = v4;
    }
  });

  // ../../node_modules/.pnpm/short-uuid@3.1.1/node_modules/short-uuid/index.js
  var require_short_uuid = __commonJS({
    "../../node_modules/.pnpm/short-uuid@3.1.1/node_modules/short-uuid/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var anyBase = require_any_base();
      var uuidV4 = require_v4();
      var flickrBase58 = "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ";
      var cookieBase90 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!#$%&'()*+-./:<=>?@[]^_`{|}~";
      var toFlickr;
      function shortenUUID(longId, translator) {
        return translator(longId.toLowerCase().replace(/-/g, ""));
      }
      function enlargeUUID(shortId, translator) {
        var uu1 = translator(shortId);
        var leftPad = "";
        var m;
        for (var i = 0, len = 32 - uu1.length; i < len; ++i) {
          leftPad += "0";
        }
        m = (leftPad + uu1).match(/(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/);
        return [m[1], m[2], m[3], m[4], m[5]].join("-");
      }
      module2.exports = function() {
        function MakeConvertor(toAlphabet) {
          var useAlphabet = toAlphabet || flickrBase58;
          var fromHex = anyBase(anyBase.HEX, useAlphabet);
          var toHex = anyBase(useAlphabet, anyBase.HEX);
          var generate4 = function() {
            return shortenUUID(uuidV4(), fromHex);
          };
          return {
            new: generate4,
            generate: generate4,
            uuid: uuidV4,
            fromUUID: function(uuid) {
              return shortenUUID(uuid, fromHex);
            },
            toUUID: function(shortUuid) {
              return enlargeUUID(shortUuid, toHex);
            },
            alphabet: useAlphabet
          };
        }
        MakeConvertor.constants = {
          flickrBase58,
          cookieBase90
        };
        MakeConvertor.uuid = uuidV4;
        MakeConvertor.generate = function() {
          if (!toFlickr) {
            toFlickr = anyBase(anyBase.HEX, flickrBase58);
          }
          return shortenUUID(uuidV4(), toFlickr);
        };
        return MakeConvertor;
      }();
    }
  });

  // ../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/chunk-DtcTpLWz.js
  function dew$k() {
    if (_dewExec$k)
      return exports$k;
    _dewExec$k = true;
    exports$k = function hasSymbols() {
      if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
        return false;
      }
      if (typeof Symbol.iterator === "symbol") {
        return true;
      }
      var obj = {};
      var sym = Symbol("test");
      var symObj = Object(sym);
      if (typeof sym === "string") {
        return false;
      }
      if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
        return false;
      }
      if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
        return false;
      }
      var symVal = 42;
      obj[sym] = symVal;
      for (sym in obj) {
        return false;
      }
      if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
        return false;
      }
      if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
        return false;
      }
      var syms = Object.getOwnPropertySymbols(obj);
      if (syms.length !== 1 || syms[0] !== sym) {
        return false;
      }
      if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
        return false;
      }
      if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) {
          return false;
        }
      }
      return true;
    };
    return exports$k;
  }
  function dew$j() {
    if (_dewExec$j)
      return exports$j;
    _dewExec$j = true;
    exports$j = Error;
    return exports$j;
  }
  function dew$i() {
    if (_dewExec$i)
      return exports$i;
    _dewExec$i = true;
    exports$i = EvalError;
    return exports$i;
  }
  function dew$h() {
    if (_dewExec$h)
      return exports$h;
    _dewExec$h = true;
    exports$h = RangeError;
    return exports$h;
  }
  function dew$g() {
    if (_dewExec$g)
      return exports$g;
    _dewExec$g = true;
    exports$g = ReferenceError;
    return exports$g;
  }
  function dew$f() {
    if (_dewExec$f)
      return exports$f;
    _dewExec$f = true;
    exports$f = SyntaxError;
    return exports$f;
  }
  function dew$e() {
    if (_dewExec$e)
      return exports$e;
    _dewExec$e = true;
    exports$e = TypeError;
    return exports$e;
  }
  function dew$d() {
    if (_dewExec$d)
      return exports$d;
    _dewExec$d = true;
    exports$d = URIError;
    return exports$d;
  }
  function dew$c() {
    if (_dewExec$c)
      return exports$c;
    _dewExec$c = true;
    var origSymbol = typeof Symbol !== "undefined" && Symbol;
    var hasSymbolSham = dew$k();
    exports$c = function hasNativeSymbols() {
      if (typeof origSymbol !== "function") {
        return false;
      }
      if (typeof Symbol !== "function") {
        return false;
      }
      if (typeof origSymbol("foo") !== "symbol") {
        return false;
      }
      if (typeof Symbol("bar") !== "symbol") {
        return false;
      }
      return hasSymbolSham();
    };
    return exports$c;
  }
  function dew$b() {
    if (_dewExec$b)
      return exports$b;
    _dewExec$b = true;
    var test = {
      __proto__: null,
      foo: {}
    };
    var $Object = Object;
    exports$b = function hasProto() {
      return {
        __proto__: test
      }.foo === test.foo && !(test instanceof $Object);
    };
    return exports$b;
  }
  function dew$a() {
    if (_dewExec$a)
      return exports$a;
    _dewExec$a = true;
    var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
    var toStr = Object.prototype.toString;
    var max2 = Math.max;
    var funcType = "[object Function]";
    var concatty = function concatty2(a, b) {
      var arr = [];
      for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
      }
      for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
      }
      return arr;
    };
    var slicy = function slicy2(arrLike, offset) {
      var arr = [];
      for (var i = offset, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
      }
      return arr;
    };
    var joiny = function(arr, joiner) {
      var str = "";
      for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
          str += joiner;
        }
      }
      return str;
    };
    exports$a = function bind2(that) {
      var target = this;
      if (typeof target !== "function" || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
      }
      var args = slicy(arguments, 1);
      var bound;
      var binder = function() {
        if (this instanceof bound) {
          var result2 = target.apply(this, concatty(args, arguments));
          if (Object(result2) === result2) {
            return result2;
          }
          return this;
        }
        return target.apply(that, concatty(args, arguments));
      };
      var boundLength = max2(0, target.length - args.length);
      var boundArgs = [];
      for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = "$" + i;
      }
      bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
      if (target.prototype) {
        var Empty = function Empty2() {
        };
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
      }
      return bound;
    };
    return exports$a;
  }
  function dew$9() {
    if (_dewExec$9)
      return exports$9;
    _dewExec$9 = true;
    var implementation = dew$a();
    exports$9 = Function.prototype.bind || implementation;
    return exports$9;
  }
  function dew$8() {
    if (_dewExec$8)
      return exports$8;
    _dewExec$8 = true;
    var call = Function.prototype.call;
    var $hasOwn = Object.prototype.hasOwnProperty;
    var bind2 = dew$9();
    exports$8 = bind2.call(call, $hasOwn);
    return exports$8;
  }
  function dew$7() {
    if (_dewExec$7)
      return exports$7;
    _dewExec$7 = true;
    var undefined$1;
    var $Error = dew$j();
    var $EvalError = dew$i();
    var $RangeError = dew$h();
    var $ReferenceError = dew$g();
    var $SyntaxError = dew$f();
    var $TypeError = dew$e();
    var $URIError = dew$d();
    var $Function = Function;
    var getEvalledConstructor = function(expressionSyntax) {
      try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
      } catch (e) {
      }
    };
    var $gOPD = Object.getOwnPropertyDescriptor;
    if ($gOPD) {
      try {
        $gOPD({}, "");
      } catch (e) {
        $gOPD = null;
      }
    }
    var throwTypeError = function() {
      throw new $TypeError();
    };
    var ThrowTypeError = $gOPD ? function() {
      try {
        arguments.callee;
        return throwTypeError;
      } catch (calleeThrows) {
        try {
          return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
          return throwTypeError;
        }
      }
    }() : throwTypeError;
    var hasSymbols = dew$c()();
    var hasProto = dew$b()();
    var getProto = Object.getPrototypeOf || (hasProto ? function(x) {
      return x.__proto__;
    } : null);
    var needsEval = {};
    var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined$1 : getProto(Uint8Array);
    var INTRINSICS = {
      __proto__: null,
      "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
      "%ArrayIteratorPrototype%": hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
      "%AsyncFromSyncIteratorPrototype%": undefined$1,
      "%AsyncFunction%": needsEval,
      "%AsyncGenerator%": needsEval,
      "%AsyncGeneratorFunction%": needsEval,
      "%AsyncIteratorPrototype%": needsEval,
      "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
      "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
      "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined$1 : BigInt64Array,
      "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined$1 : BigUint64Array,
      "%Boolean%": Boolean,
      "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": $Error,
      "%eval%": eval,
      "%EvalError%": $EvalError,
      "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
      "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
      "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
      "%Function%": $Function,
      "%GeneratorFunction%": needsEval,
      "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
      "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
      "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
      "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
      "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
      "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
      "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
      "%RangeError%": $RangeError,
      "%ReferenceError%": $ReferenceError,
      "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
      "%RegExp%": RegExp,
      "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
      "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
      "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": hasSymbols && getProto ? getProto(""[Symbol.iterator]()) : undefined$1,
      "%Symbol%": hasSymbols ? Symbol : undefined$1,
      "%SyntaxError%": $SyntaxError,
      "%ThrowTypeError%": ThrowTypeError,
      "%TypedArray%": TypedArray,
      "%TypeError%": $TypeError,
      "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
      "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
      "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
      "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
      "%URIError%": $URIError,
      "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
      "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
      "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet
    };
    if (getProto) {
      try {
        null.error;
      } catch (e) {
        var errorProto = getProto(getProto(e));
        INTRINSICS["%Error.prototype%"] = errorProto;
      }
    }
    var doEval = function doEval2(name) {
      var value;
      if (name === "%AsyncFunction%") {
        value = getEvalledConstructor("async function () {}");
      } else if (name === "%GeneratorFunction%") {
        value = getEvalledConstructor("function* () {}");
      } else if (name === "%AsyncGeneratorFunction%") {
        value = getEvalledConstructor("async function* () {}");
      } else if (name === "%AsyncGenerator%") {
        var fn = doEval2("%AsyncGeneratorFunction%");
        if (fn) {
          value = fn.prototype;
        }
      } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval2("%AsyncGenerator%");
        if (gen && getProto) {
          value = getProto(gen.prototype);
        }
      }
      INTRINSICS[name] = value;
      return value;
    };
    var LEGACY_ALIASES = {
      __proto__: null,
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    };
    var bind2 = dew$9();
    var hasOwn = dew$8();
    var $concat = bind2.call(Function.call, Array.prototype.concat);
    var $spliceApply = bind2.call(Function.apply, Array.prototype.splice);
    var $replace = bind2.call(Function.call, String.prototype.replace);
    var $strSlice = bind2.call(Function.call, String.prototype.slice);
    var $exec = bind2.call(Function.call, RegExp.prototype.exec);
    var rePropName2 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
    var reEscapeChar2 = /\\(\\)?/g;
    var stringToPath2 = function stringToPath3(string) {
      var first = $strSlice(string, 0, 1);
      var last2 = $strSlice(string, -1);
      if (first === "%" && last2 !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
      } else if (last2 === "%" && first !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
      }
      var result2 = [];
      $replace(string, rePropName2, function(match, number, quote, subString) {
        result2[result2.length] = quote ? $replace(subString, reEscapeChar2, "$1") : number || match;
      });
      return result2;
    };
    var getBaseIntrinsic = function getBaseIntrinsic2(name, allowMissing) {
      var intrinsicName = name;
      var alias;
      if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
      }
      if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) {
          value = doEval(intrinsicName);
        }
        if (typeof value === "undefined" && !allowMissing) {
          throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        }
        return {
          alias,
          name: intrinsicName,
          value
        };
      }
      throw new $SyntaxError("intrinsic " + name + " does not exist!");
    };
    exports$7 = function GetIntrinsic(name, allowMissing) {
      if (typeof name !== "string" || name.length === 0) {
        throw new $TypeError("intrinsic name must be a non-empty string");
      }
      if (arguments.length > 1 && typeof allowMissing !== "boolean") {
        throw new $TypeError('"allowMissing" argument must be a boolean');
      }
      if ($exec(/^%?[^%]*%?$/, name) === null) {
        throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
      }
      var parts = stringToPath2(name);
      var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
      var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
      var intrinsicRealName = intrinsic.name;
      var value = intrinsic.value;
      var skipFurtherCaching = false;
      var alias = intrinsic.alias;
      if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([0, 1], alias));
      }
      for (var i = 1, isOwn = true; i < parts.length; i += 1) {
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last2 = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last2 === '"' || last2 === "'" || last2 === "`") && first !== last2) {
          throw new $SyntaxError("property names with quotes must have matching quotes");
        }
        if (part === "constructor" || !isOwn) {
          skipFurtherCaching = true;
        }
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) {
          value = INTRINSICS[intrinsicRealName];
        } else if (value != null) {
          if (!(part in value)) {
            if (!allowMissing) {
              throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
            }
            return void 0;
          }
          if ($gOPD && i + 1 >= parts.length) {
            var desc = $gOPD(value, part);
            isOwn = !!desc;
            if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
              value = desc.get;
            } else {
              value = value[part];
            }
          } else {
            isOwn = hasOwn(value, part);
            value = value[part];
          }
          if (isOwn && !skipFurtherCaching) {
            INTRINSICS[intrinsicRealName] = value;
          }
        }
      }
      return value;
    };
    return exports$7;
  }
  function dew$6() {
    if (_dewExec$6)
      return exports$6;
    _dewExec$6 = true;
    var GetIntrinsic = dew$7();
    var $defineProperty = GetIntrinsic("%Object.defineProperty%", true) || false;
    if ($defineProperty) {
      try {
        $defineProperty({}, "a", {
          value: 1
        });
      } catch (e) {
        $defineProperty = false;
      }
    }
    exports$6 = $defineProperty;
    return exports$6;
  }
  function dew$5() {
    if (_dewExec$5)
      return exports$5;
    _dewExec$5 = true;
    var GetIntrinsic = dew$7();
    var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
    if ($gOPD) {
      try {
        $gOPD([], "length");
      } catch (e) {
        $gOPD = null;
      }
    }
    exports$5 = $gOPD;
    return exports$5;
  }
  function dew$4() {
    if (_dewExec$4)
      return exports$4;
    _dewExec$4 = true;
    var $defineProperty = dew$6();
    var $SyntaxError = dew$f();
    var $TypeError = dew$e();
    var gopd = dew$5();
    exports$4 = function defineDataProperty(obj, property2, value) {
      if (!obj || typeof obj !== "object" && typeof obj !== "function") {
        throw new $TypeError("`obj` must be an object or a function`");
      }
      if (typeof property2 !== "string" && typeof property2 !== "symbol") {
        throw new $TypeError("`property` must be a string or a symbol`");
      }
      if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) {
        throw new $TypeError("`nonEnumerable`, if provided, must be a boolean or null");
      }
      if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) {
        throw new $TypeError("`nonWritable`, if provided, must be a boolean or null");
      }
      if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) {
        throw new $TypeError("`nonConfigurable`, if provided, must be a boolean or null");
      }
      if (arguments.length > 6 && typeof arguments[6] !== "boolean") {
        throw new $TypeError("`loose`, if provided, must be a boolean");
      }
      var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
      var nonWritable = arguments.length > 4 ? arguments[4] : null;
      var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
      var loose = arguments.length > 6 ? arguments[6] : false;
      var desc = !!gopd && gopd(obj, property2);
      if ($defineProperty) {
        $defineProperty(obj, property2, {
          configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
          enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
          value,
          writable: nonWritable === null && desc ? desc.writable : !nonWritable
        });
      } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
        obj[property2] = value;
      } else {
        throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
      }
    };
    return exports$4;
  }
  function dew$3() {
    if (_dewExec$3)
      return exports$3;
    _dewExec$3 = true;
    var $defineProperty = dew$6();
    var hasPropertyDescriptors = function hasPropertyDescriptors2() {
      return !!$defineProperty;
    };
    hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
      if (!$defineProperty) {
        return null;
      }
      try {
        return $defineProperty([], "length", {
          value: 1
        }).length !== 1;
      } catch (e) {
        return true;
      }
    };
    exports$3 = hasPropertyDescriptors;
    return exports$3;
  }
  function dew$22() {
    if (_dewExec$22)
      return exports$22;
    _dewExec$22 = true;
    var GetIntrinsic = dew$7();
    var define2 = dew$4();
    var hasDescriptors = dew$3()();
    var gOPD = dew$5();
    var $TypeError = dew$e();
    var $floor = GetIntrinsic("%Math.floor%");
    exports$22 = function setFunctionLength(fn, length) {
      if (typeof fn !== "function") {
        throw new $TypeError("`fn` is not a function");
      }
      if (typeof length !== "number" || length < 0 || length > 4294967295 || $floor(length) !== length) {
        throw new $TypeError("`length` must be a positive 32-bit integer");
      }
      var loose = arguments.length > 2 && !!arguments[2];
      var functionLengthIsConfigurable = true;
      var functionLengthIsWritable = true;
      if ("length" in fn && gOPD) {
        var desc = gOPD(fn, "length");
        if (desc && !desc.configurable) {
          functionLengthIsConfigurable = false;
        }
        if (desc && !desc.writable) {
          functionLengthIsWritable = false;
        }
      }
      if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if (hasDescriptors) {
          define2(fn, "length", length, true, true);
        } else {
          define2(fn, "length", length);
        }
      }
      return fn;
    };
    return exports$22;
  }
  function dew$12() {
    if (_dewExec$12)
      return exports$12;
    _dewExec$12 = true;
    var bind2 = dew$9();
    var GetIntrinsic = dew$7();
    var setFunctionLength = dew$22();
    var $TypeError = dew$e();
    var $apply = GetIntrinsic("%Function.prototype.apply%");
    var $call = GetIntrinsic("%Function.prototype.call%");
    var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind2.call($call, $apply);
    var $defineProperty = dew$6();
    var $max = GetIntrinsic("%Math.max%");
    exports$12 = function callBind(originalFunction) {
      if (typeof originalFunction !== "function") {
        throw new $TypeError("a function is required");
      }
      var func = $reflectApply(bind2, $call, arguments);
      return setFunctionLength(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
    };
    var applyBind = function applyBind2() {
      return $reflectApply(bind2, $apply, arguments);
    };
    if ($defineProperty) {
      $defineProperty(exports$12, "apply", {
        value: applyBind
      });
    } else {
      exports$12.apply = applyBind;
    }
    return exports$12;
  }
  function dew2() {
    if (_dewExec2)
      return exports4;
    _dewExec2 = true;
    var GetIntrinsic = dew$7();
    var callBind = dew$12();
    var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
    exports4 = function callBoundIntrinsic(name, allowMissing) {
      var intrinsic = GetIntrinsic(name, !!allowMissing);
      if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
        return callBind(intrinsic);
      }
      return intrinsic;
    };
    return exports4;
  }
  var exports$k, _dewExec$k, exports$j, _dewExec$j, exports$i, _dewExec$i, exports$h, _dewExec$h, exports$g, _dewExec$g, exports$f, _dewExec$f, exports$e, _dewExec$e, exports$d, _dewExec$d, exports$c, _dewExec$c, exports$b, _dewExec$b, exports$a, _dewExec$a, exports$9, _dewExec$9, exports$8, _dewExec$8, exports$7, _dewExec$7, exports$6, _dewExec$6, exports$5, _dewExec$5, exports$4, _dewExec$4, exports$3, _dewExec$3, exports$22, _dewExec$22, exports$12, _dewExec$12, exports4, _dewExec2;
  var init_chunk_DtcTpLWz = __esm({
    "../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/chunk-DtcTpLWz.js"() {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      exports$k = {};
      _dewExec$k = false;
      exports$j = {};
      _dewExec$j = false;
      exports$i = {};
      _dewExec$i = false;
      exports$h = {};
      _dewExec$h = false;
      exports$g = {};
      _dewExec$g = false;
      exports$f = {};
      _dewExec$f = false;
      exports$e = {};
      _dewExec$e = false;
      exports$d = {};
      _dewExec$d = false;
      exports$c = {};
      _dewExec$c = false;
      exports$b = {};
      _dewExec$b = false;
      exports$a = {};
      _dewExec$a = false;
      exports$9 = {};
      _dewExec$9 = false;
      exports$8 = {};
      _dewExec$8 = false;
      exports$7 = {};
      _dewExec$7 = false;
      exports$6 = {};
      _dewExec$6 = false;
      exports$5 = {};
      _dewExec$5 = false;
      exports$4 = {};
      _dewExec$4 = false;
      exports$3 = {};
      _dewExec$3 = false;
      exports$22 = {};
      _dewExec$22 = false;
      exports$12 = {};
      _dewExec$12 = false;
      exports4 = {};
      _dewExec2 = false;
    }
  });

  // ../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/chunk-CkFCi-G1.js
  function dew3() {
    if (_dewExec3)
      return exports5;
    _dewExec3 = true;
    if (typeof Object.create === "function") {
      exports5 = function inherits2(ctor, superCtor) {
        if (superCtor) {
          ctor.super_ = superCtor;
          ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
              value: ctor,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
        }
      };
    } else {
      exports5 = function inherits2(ctor, superCtor) {
        if (superCtor) {
          ctor.super_ = superCtor;
          var TempCtor = function() {
          };
          TempCtor.prototype = superCtor.prototype;
          ctor.prototype = new TempCtor();
          ctor.prototype.constructor = ctor;
        }
      };
    }
    return exports5;
  }
  var exports5, _dewExec3;
  var init_chunk_CkFCi_G1 = __esm({
    "../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/chunk-CkFCi-G1.js"() {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      exports5 = {};
      _dewExec3 = false;
    }
  });

  // ../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/chunk-DEMDiNwt.js
  function unimplemented2(name) {
    throw new Error("Node.js process " + name + " is not supported by JSPM core outside of Node.js");
  }
  function cleanUpNextTick2() {
    if (!draining2 || !currentQueue2)
      return;
    draining2 = false;
    if (currentQueue2.length) {
      queue2 = currentQueue2.concat(queue2);
    } else {
      queueIndex2 = -1;
    }
    if (queue2.length)
      drainQueue2();
  }
  function drainQueue2() {
    if (draining2)
      return;
    var timeout = setTimeout(cleanUpNextTick2, 0);
    draining2 = true;
    var len = queue2.length;
    while (len) {
      currentQueue2 = queue2;
      queue2 = [];
      while (++queueIndex2 < len) {
        if (currentQueue2)
          currentQueue2[queueIndex2].run();
      }
      queueIndex2 = -1;
      len = queue2.length;
    }
    currentQueue2 = null;
    draining2 = false;
    clearTimeout(timeout);
  }
  function nextTick2(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++)
        args[i - 1] = arguments[i];
    }
    queue2.push(new Item2(fun, args));
    if (queue2.length === 1 && !draining2)
      setTimeout(drainQueue2, 0);
  }
  function Item2(fun, array) {
    this.fun = fun;
    this.array = array;
  }
  function noop4() {
  }
  function _linkedBinding2(name) {
    unimplemented2("_linkedBinding");
  }
  function dlopen2(name) {
    unimplemented2("dlopen");
  }
  function _getActiveRequests2() {
    return [];
  }
  function _getActiveHandles2() {
    return [];
  }
  function assert2(condition, message) {
    if (!condition)
      throw new Error(message || "assertion error");
  }
  function hasUncaughtExceptionCaptureCallback2() {
    return false;
  }
  function uptime2() {
    return _performance2.now() / 1e3;
  }
  function hrtime2(previousTimestamp) {
    var baseNow = Math.floor((Date.now() - _performance2.now()) * 1e-3);
    var clocktime = _performance2.now() * 1e-3;
    var seconds = Math.floor(clocktime) + baseNow;
    var nanoseconds = Math.floor(clocktime % 1 * 1e9);
    if (previousTimestamp) {
      seconds = seconds - previousTimestamp[0];
      nanoseconds = nanoseconds - previousTimestamp[1];
      if (nanoseconds < 0) {
        seconds--;
        nanoseconds += nanoPerSec2;
      }
    }
    return [seconds, nanoseconds];
  }
  function on2() {
    return process2;
  }
  function listeners2(name) {
    return [];
  }
  var queue2, draining2, currentQueue2, queueIndex2, title2, arch2, platform2, env2, argv2, execArgv2, version2, versions2, emitWarning2, binding2, umask2, cwd2, chdir2, release2, _rawDebug2, moduleLoadList2, domain2, _exiting2, config2, reallyExit2, _kill2, cpuUsage2, resourceUsage2, memoryUsage2, kill2, exit2, openStdin2, allowedNodeEnvironmentFlags2, features2, _fatalExceptions2, setUncaughtExceptionCaptureCallback2, _tickCallback2, _debugProcess2, _debugEnd2, _startProfilerIdleNotifier2, _stopProfilerIdleNotifier2, stdout2, stderr2, stdin2, abort2, pid2, ppid2, execPath2, debugPort2, argv02, _preload_modules2, setSourceMapsEnabled2, _performance2, nowOffset, nanoPerSec2, _maxListeners2, _events2, _eventsCount2, addListener2, once3, off2, removeListener2, removeAllListeners2, emit2, prependListener2, prependOnceListener2, process2;
  var init_chunk_DEMDiNwt = __esm({
    "../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/chunk-DEMDiNwt.js"() {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      queue2 = [];
      draining2 = false;
      queueIndex2 = -1;
      Item2.prototype.run = function() {
        this.fun.apply(null, this.array);
      };
      title2 = "browser";
      arch2 = "x64";
      platform2 = "browser";
      env2 = {
        PATH: "/usr/bin",
        LANG: navigator.language + ".UTF-8",
        PWD: "/",
        HOME: "/home",
        TMP: "/tmp"
      };
      argv2 = ["/usr/bin/node"];
      execArgv2 = [];
      version2 = "v16.8.0";
      versions2 = {};
      emitWarning2 = function(message, type) {
        console.warn((type ? type + ": " : "") + message);
      };
      binding2 = function(name) {
        unimplemented2("binding");
      };
      umask2 = function(mask) {
        return 0;
      };
      cwd2 = function() {
        return "/";
      };
      chdir2 = function(dir) {
      };
      release2 = {
        name: "node",
        sourceUrl: "",
        headersUrl: "",
        libUrl: ""
      };
      _rawDebug2 = noop4;
      moduleLoadList2 = [];
      domain2 = {};
      _exiting2 = false;
      config2 = {};
      reallyExit2 = noop4;
      _kill2 = noop4;
      cpuUsage2 = function() {
        return {};
      };
      resourceUsage2 = cpuUsage2;
      memoryUsage2 = cpuUsage2;
      kill2 = noop4;
      exit2 = noop4;
      openStdin2 = noop4;
      allowedNodeEnvironmentFlags2 = {};
      features2 = {
        inspector: false,
        debug: false,
        uv: false,
        ipv6: false,
        tls_alpn: false,
        tls_sni: false,
        tls_ocsp: false,
        tls: false,
        cached_builtins: true
      };
      _fatalExceptions2 = noop4;
      setUncaughtExceptionCaptureCallback2 = noop4;
      _tickCallback2 = noop4;
      _debugProcess2 = noop4;
      _debugEnd2 = noop4;
      _startProfilerIdleNotifier2 = noop4;
      _stopProfilerIdleNotifier2 = noop4;
      stdout2 = void 0;
      stderr2 = void 0;
      stdin2 = void 0;
      abort2 = noop4;
      pid2 = 2;
      ppid2 = 1;
      execPath2 = "/bin/usr/node";
      debugPort2 = 9229;
      argv02 = "node";
      _preload_modules2 = [];
      setSourceMapsEnabled2 = noop4;
      _performance2 = {
        now: typeof performance !== "undefined" ? performance.now.bind(performance) : void 0,
        timing: typeof performance !== "undefined" ? performance.timing : void 0
      };
      if (_performance2.now === void 0) {
        nowOffset = Date.now();
        if (_performance2.timing && _performance2.timing.navigationStart) {
          nowOffset = _performance2.timing.navigationStart;
        }
        _performance2.now = () => Date.now() - nowOffset;
      }
      nanoPerSec2 = 1e9;
      hrtime2.bigint = function(time) {
        var diff = hrtime2(time);
        if (typeof BigInt === "undefined") {
          return diff[0] * nanoPerSec2 + diff[1];
        }
        return BigInt(diff[0] * nanoPerSec2) + BigInt(diff[1]);
      };
      _maxListeners2 = 10;
      _events2 = {};
      _eventsCount2 = 0;
      addListener2 = on2;
      once3 = on2;
      off2 = on2;
      removeListener2 = on2;
      removeAllListeners2 = on2;
      emit2 = noop4;
      prependListener2 = on2;
      prependOnceListener2 = on2;
      process2 = {
        version: version2,
        versions: versions2,
        arch: arch2,
        platform: platform2,
        release: release2,
        _rawDebug: _rawDebug2,
        moduleLoadList: moduleLoadList2,
        binding: binding2,
        _linkedBinding: _linkedBinding2,
        _events: _events2,
        _eventsCount: _eventsCount2,
        _maxListeners: _maxListeners2,
        on: on2,
        addListener: addListener2,
        once: once3,
        off: off2,
        removeListener: removeListener2,
        removeAllListeners: removeAllListeners2,
        emit: emit2,
        prependListener: prependListener2,
        prependOnceListener: prependOnceListener2,
        listeners: listeners2,
        domain: domain2,
        _exiting: _exiting2,
        config: config2,
        dlopen: dlopen2,
        uptime: uptime2,
        _getActiveRequests: _getActiveRequests2,
        _getActiveHandles: _getActiveHandles2,
        reallyExit: reallyExit2,
        _kill: _kill2,
        cpuUsage: cpuUsage2,
        resourceUsage: resourceUsage2,
        memoryUsage: memoryUsage2,
        kill: kill2,
        exit: exit2,
        openStdin: openStdin2,
        allowedNodeEnvironmentFlags: allowedNodeEnvironmentFlags2,
        assert: assert2,
        features: features2,
        _fatalExceptions: _fatalExceptions2,
        setUncaughtExceptionCaptureCallback: setUncaughtExceptionCaptureCallback2,
        hasUncaughtExceptionCaptureCallback: hasUncaughtExceptionCaptureCallback2,
        emitWarning: emitWarning2,
        nextTick: nextTick2,
        _tickCallback: _tickCallback2,
        _debugProcess: _debugProcess2,
        _debugEnd: _debugEnd2,
        _startProfilerIdleNotifier: _startProfilerIdleNotifier2,
        _stopProfilerIdleNotifier: _stopProfilerIdleNotifier2,
        stdout: stdout2,
        stdin: stdin2,
        stderr: stderr2,
        abort: abort2,
        umask: umask2,
        chdir: chdir2,
        cwd: cwd2,
        env: env2,
        title: title2,
        argv: argv2,
        execArgv: execArgv2,
        pid: pid2,
        ppid: ppid2,
        execPath: execPath2,
        debugPort: debugPort2,
        hrtime: hrtime2,
        argv0: argv02,
        _preload_modules: _preload_modules2,
        setSourceMapsEnabled: setSourceMapsEnabled2
      };
    }
  });

  // ../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/util.js
  var util_exports = {};
  __export(util_exports, {
    TextDecoder: () => TextDecoder2,
    TextEncoder: () => TextEncoder,
    _extend: () => _extend,
    callbackify: () => callbackify,
    debuglog: () => debuglog,
    default: () => exports6,
    deprecate: () => deprecate,
    format: () => format,
    inherits: () => inherits,
    inspect: () => inspect,
    isArray: () => isArray2,
    isBoolean: () => isBoolean2,
    isBuffer: () => isBuffer2,
    isDate: () => isDate2,
    isError: () => isError2,
    isFunction: () => isFunction2,
    isNull: () => isNull2,
    isNullOrUndefined: () => isNullOrUndefined,
    isNumber: () => isNumber2,
    isObject: () => isObject4,
    isPrimitive: () => isPrimitive,
    isRegExp: () => isRegExp2,
    isString: () => isString2,
    isSymbol: () => isSymbol2,
    isUndefined: () => isUndefined2,
    log: () => log,
    promisify: () => promisify,
    types: () => types
  });
  function dew$b2() {
    if (_dewExec$b2)
      return exports$c2;
    _dewExec$b2 = true;
    var hasSymbols = dew$k();
    exports$c2 = function hasToStringTagShams() {
      return hasSymbols() && !!Symbol.toStringTag;
    };
    return exports$c2;
  }
  function dew$a2() {
    if (_dewExec$a2)
      return exports$b2;
    _dewExec$a2 = true;
    var hasToStringTag = dew$b2()();
    var callBound = dew2();
    var $toString = callBound("Object.prototype.toString");
    var isStandardArguments = function isArguments2(value) {
      if (hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) {
        return false;
      }
      return $toString(value) === "[object Arguments]";
    };
    var isLegacyArguments = function isArguments2(value) {
      if (isStandardArguments(value)) {
        return true;
      }
      return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $toString(value) !== "[object Array]" && $toString(value.callee) === "[object Function]";
    };
    var supportsStandardArguments = function() {
      return isStandardArguments(arguments);
    }();
    isStandardArguments.isLegacyArguments = isLegacyArguments;
    exports$b2 = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
    return exports$b2;
  }
  function dew$92() {
    if (_dewExec$92)
      return exports$a2;
    _dewExec$92 = true;
    var toStr = Object.prototype.toString;
    var fnToStr = Function.prototype.toString;
    var isFnRegex = /^\s*(?:function)?\*/;
    var hasToStringTag = dew$b2()();
    var getProto = Object.getPrototypeOf;
    var getGeneratorFunc = function() {
      if (!hasToStringTag) {
        return false;
      }
      try {
        return Function("return function*() {}")();
      } catch (e) {
      }
    };
    var GeneratorFunction;
    exports$a2 = function isGeneratorFunction(fn) {
      if (typeof fn !== "function") {
        return false;
      }
      if (isFnRegex.test(fnToStr.call(fn))) {
        return true;
      }
      if (!hasToStringTag) {
        var str = toStr.call(fn);
        return str === "[object GeneratorFunction]";
      }
      if (!getProto) {
        return false;
      }
      if (typeof GeneratorFunction === "undefined") {
        var generatorFunc = getGeneratorFunc();
        GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
      }
      return getProto(fn) === GeneratorFunction;
    };
    return exports$a2;
  }
  function dew$82() {
    if (_dewExec$82)
      return exports$92;
    _dewExec$82 = true;
    var fnToStr = Function.prototype.toString;
    var reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
    var badArrayLike;
    var isCallableMarker;
    if (typeof reflectApply === "function" && typeof Object.defineProperty === "function") {
      try {
        badArrayLike = Object.defineProperty({}, "length", {
          get: function() {
            throw isCallableMarker;
          }
        });
        isCallableMarker = {};
        reflectApply(function() {
          throw 42;
        }, null, badArrayLike);
      } catch (_) {
        if (_ !== isCallableMarker) {
          reflectApply = null;
        }
      }
    } else {
      reflectApply = null;
    }
    var constructorRegex = /^\s*class\b/;
    var isES6ClassFn = function isES6ClassFunction(value) {
      try {
        var fnStr = fnToStr.call(value);
        return constructorRegex.test(fnStr);
      } catch (e) {
        return false;
      }
    };
    var tryFunctionObject = function tryFunctionToStr(value) {
      try {
        if (isES6ClassFn(value)) {
          return false;
        }
        fnToStr.call(value);
        return true;
      } catch (e) {
        return false;
      }
    };
    var toStr = Object.prototype.toString;
    var objectClass = "[object Object]";
    var fnClass = "[object Function]";
    var genClass = "[object GeneratorFunction]";
    var ddaClass = "[object HTMLAllCollection]";
    var ddaClass2 = "[object HTML document.all class]";
    var ddaClass3 = "[object HTMLCollection]";
    var hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag;
    var isIE68 = !(0 in [,]);
    var isDDA = function isDocumentDotAll() {
      return false;
    };
    if (typeof document === "object") {
      var all = document.all;
      if (toStr.call(all) === toStr.call(document.all)) {
        isDDA = function isDocumentDotAll(value) {
          if ((isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) {
            try {
              var str = toStr.call(value);
              return (str === ddaClass || str === ddaClass2 || str === ddaClass3 || str === objectClass) && value("") == null;
            } catch (e) {
            }
          }
          return false;
        };
      }
    }
    exports$92 = reflectApply ? function isCallable(value) {
      if (isDDA(value)) {
        return true;
      }
      if (!value) {
        return false;
      }
      if (typeof value !== "function" && typeof value !== "object") {
        return false;
      }
      try {
        reflectApply(value, null, badArrayLike);
      } catch (e) {
        if (e !== isCallableMarker) {
          return false;
        }
      }
      return !isES6ClassFn(value) && tryFunctionObject(value);
    } : function isCallable(value) {
      if (isDDA(value)) {
        return true;
      }
      if (!value) {
        return false;
      }
      if (typeof value !== "function" && typeof value !== "object") {
        return false;
      }
      if (hasToStringTag) {
        return tryFunctionObject(value);
      }
      if (isES6ClassFn(value)) {
        return false;
      }
      var strClass = toStr.call(value);
      if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) {
        return false;
      }
      return tryFunctionObject(value);
    };
    return exports$92;
  }
  function dew$72() {
    if (_dewExec$72)
      return exports$82;
    _dewExec$72 = true;
    var isCallable = dew$82();
    var toStr = Object.prototype.toString;
    var hasOwnProperty27 = Object.prototype.hasOwnProperty;
    var forEachArray = function forEachArray2(array, iterator, receiver) {
      for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty27.call(array, i)) {
          if (receiver == null) {
            iterator(array[i], i, array);
          } else {
            iterator.call(receiver, array[i], i, array);
          }
        }
      }
    };
    var forEachString = function forEachString2(string, iterator, receiver) {
      for (var i = 0, len = string.length; i < len; i++) {
        if (receiver == null) {
          iterator(string.charAt(i), i, string);
        } else {
          iterator.call(receiver, string.charAt(i), i, string);
        }
      }
    };
    var forEachObject = function forEachObject2(object, iterator, receiver) {
      for (var k in object) {
        if (hasOwnProperty27.call(object, k)) {
          if (receiver == null) {
            iterator(object[k], k, object);
          } else {
            iterator.call(receiver, object[k], k, object);
          }
        }
      }
    };
    var forEach2 = function forEach3(list, iterator, thisArg) {
      if (!isCallable(iterator)) {
        throw new TypeError("iterator must be a function");
      }
      var receiver;
      if (arguments.length >= 3) {
        receiver = thisArg;
      }
      if (toStr.call(list) === "[object Array]") {
        forEachArray(list, iterator, receiver);
      } else if (typeof list === "string") {
        forEachString(list, iterator, receiver);
      } else {
        forEachObject(list, iterator, receiver);
      }
    };
    exports$82 = forEach2;
    return exports$82;
  }
  function dew$62() {
    if (_dewExec$62)
      return exports$72;
    _dewExec$62 = true;
    exports$72 = ["Float32Array", "Float64Array", "Int8Array", "Int16Array", "Int32Array", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "BigInt64Array", "BigUint64Array"];
    return exports$72;
  }
  function dew$52() {
    if (_dewExec$52)
      return exports$62;
    _dewExec$52 = true;
    var possibleNames = dew$62();
    var g = typeof globalThis === "undefined" ? _global$2 : globalThis;
    exports$62 = function availableTypedArrays() {
      var out = [];
      for (var i = 0; i < possibleNames.length; i++) {
        if (typeof g[possibleNames[i]] === "function") {
          out[out.length] = possibleNames[i];
        }
      }
      return out;
    };
    return exports$62;
  }
  function dew$42() {
    if (_dewExec$42)
      return exports$52;
    _dewExec$42 = true;
    var forEach2 = dew$72();
    var availableTypedArrays = dew$52();
    var callBind = dew$12();
    var callBound = dew2();
    var gOPD = dew$5();
    var $toString = callBound("Object.prototype.toString");
    var hasToStringTag = dew$b2()();
    var g = typeof globalThis === "undefined" ? _global$1 : globalThis;
    var typedArrays = availableTypedArrays();
    var $slice = callBound("String.prototype.slice");
    var getPrototypeOf = Object.getPrototypeOf;
    var $indexOf = callBound("Array.prototype.indexOf", true) || function indexOf2(array, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i] === value) {
          return i;
        }
      }
      return -1;
    };
    var cache = {
      __proto__: null
    };
    if (hasToStringTag && gOPD && getPrototypeOf) {
      forEach2(typedArrays, function(typedArray) {
        var arr = new g[typedArray]();
        if (Symbol.toStringTag in arr) {
          var proto = getPrototypeOf(arr);
          var descriptor = gOPD(proto, Symbol.toStringTag);
          if (!descriptor) {
            var superProto = getPrototypeOf(proto);
            descriptor = gOPD(superProto, Symbol.toStringTag);
          }
          cache["$" + typedArray] = callBind(descriptor.get);
        }
      });
    } else {
      forEach2(typedArrays, function(typedArray) {
        var arr = new g[typedArray]();
        var fn = arr.slice || arr.set;
        if (fn) {
          cache["$" + typedArray] = callBind(fn);
        }
      });
    }
    var tryTypedArrays = function tryAllTypedArrays(value) {
      var found = false;
      forEach2(
        cache,
        function(getter, typedArray) {
          if (!found) {
            try {
              if ("$" + getter(value) === typedArray) {
                found = $slice(typedArray, 1);
              }
            } catch (e) {
            }
          }
        }
      );
      return found;
    };
    var trySlices = function tryAllSlices(value) {
      var found = false;
      forEach2(
        cache,
        function(getter, name) {
          if (!found) {
            try {
              getter(value);
              found = $slice(name, 1);
            } catch (e) {
            }
          }
        }
      );
      return found;
    };
    exports$52 = function whichTypedArray(value) {
      if (!value || typeof value !== "object") {
        return false;
      }
      if (!hasToStringTag) {
        var tag = $slice($toString(value), 8, -1);
        if ($indexOf(typedArrays, tag) > -1) {
          return tag;
        }
        if (tag !== "Object") {
          return false;
        }
        return trySlices(value);
      }
      if (!gOPD) {
        return null;
      }
      return tryTypedArrays(value);
    };
    return exports$52;
  }
  function dew$32() {
    if (_dewExec$32)
      return exports$42;
    _dewExec$32 = true;
    var whichTypedArray = dew$42();
    exports$42 = function isTypedArray2(value) {
      return !!whichTypedArray(value);
    };
    return exports$42;
  }
  function dew$23() {
    if (_dewExec$23)
      return exports$32;
    _dewExec$23 = true;
    var isArgumentsObject = dew$a2();
    var isGeneratorFunction = dew$92();
    var whichTypedArray = dew$42();
    var isTypedArray2 = dew$32();
    function uncurryThis(f) {
      return f.call.bind(f);
    }
    var BigIntSupported = typeof BigInt !== "undefined";
    var SymbolSupported = typeof Symbol !== "undefined";
    var ObjectToString = uncurryThis(Object.prototype.toString);
    var numberValue = uncurryThis(Number.prototype.valueOf);
    var stringValue = uncurryThis(String.prototype.valueOf);
    var booleanValue = uncurryThis(Boolean.prototype.valueOf);
    if (BigIntSupported) {
      var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
    }
    if (SymbolSupported) {
      var symbolValue = uncurryThis(Symbol.prototype.valueOf);
    }
    function checkBoxedPrimitive(value, prototypeValueOf) {
      if (typeof value !== "object") {
        return false;
      }
      try {
        prototypeValueOf(value);
        return true;
      } catch (e) {
        return false;
      }
    }
    exports$32.isArgumentsObject = isArgumentsObject;
    exports$32.isGeneratorFunction = isGeneratorFunction;
    exports$32.isTypedArray = isTypedArray2;
    function isPromise(input) {
      return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
    }
    exports$32.isPromise = isPromise;
    function isArrayBufferView(value) {
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        return ArrayBuffer.isView(value);
      }
      return isTypedArray2(value) || isDataView(value);
    }
    exports$32.isArrayBufferView = isArrayBufferView;
    function isUint8Array(value) {
      return whichTypedArray(value) === "Uint8Array";
    }
    exports$32.isUint8Array = isUint8Array;
    function isUint8ClampedArray(value) {
      return whichTypedArray(value) === "Uint8ClampedArray";
    }
    exports$32.isUint8ClampedArray = isUint8ClampedArray;
    function isUint16Array(value) {
      return whichTypedArray(value) === "Uint16Array";
    }
    exports$32.isUint16Array = isUint16Array;
    function isUint32Array(value) {
      return whichTypedArray(value) === "Uint32Array";
    }
    exports$32.isUint32Array = isUint32Array;
    function isInt8Array(value) {
      return whichTypedArray(value) === "Int8Array";
    }
    exports$32.isInt8Array = isInt8Array;
    function isInt16Array(value) {
      return whichTypedArray(value) === "Int16Array";
    }
    exports$32.isInt16Array = isInt16Array;
    function isInt32Array(value) {
      return whichTypedArray(value) === "Int32Array";
    }
    exports$32.isInt32Array = isInt32Array;
    function isFloat32Array(value) {
      return whichTypedArray(value) === "Float32Array";
    }
    exports$32.isFloat32Array = isFloat32Array;
    function isFloat64Array(value) {
      return whichTypedArray(value) === "Float64Array";
    }
    exports$32.isFloat64Array = isFloat64Array;
    function isBigInt64Array(value) {
      return whichTypedArray(value) === "BigInt64Array";
    }
    exports$32.isBigInt64Array = isBigInt64Array;
    function isBigUint64Array(value) {
      return whichTypedArray(value) === "BigUint64Array";
    }
    exports$32.isBigUint64Array = isBigUint64Array;
    function isMapToString(value) {
      return ObjectToString(value) === "[object Map]";
    }
    isMapToString.working = typeof Map !== "undefined" && isMapToString(/* @__PURE__ */ new Map());
    function isMap2(value) {
      if (typeof Map === "undefined") {
        return false;
      }
      return isMapToString.working ? isMapToString(value) : value instanceof Map;
    }
    exports$32.isMap = isMap2;
    function isSetToString(value) {
      return ObjectToString(value) === "[object Set]";
    }
    isSetToString.working = typeof Set !== "undefined" && isSetToString(/* @__PURE__ */ new Set());
    function isSet2(value) {
      if (typeof Set === "undefined") {
        return false;
      }
      return isSetToString.working ? isSetToString(value) : value instanceof Set;
    }
    exports$32.isSet = isSet2;
    function isWeakMapToString(value) {
      return ObjectToString(value) === "[object WeakMap]";
    }
    isWeakMapToString.working = typeof WeakMap !== "undefined" && isWeakMapToString(/* @__PURE__ */ new WeakMap());
    function isWeakMap2(value) {
      if (typeof WeakMap === "undefined") {
        return false;
      }
      return isWeakMapToString.working ? isWeakMapToString(value) : value instanceof WeakMap;
    }
    exports$32.isWeakMap = isWeakMap2;
    function isWeakSetToString(value) {
      return ObjectToString(value) === "[object WeakSet]";
    }
    isWeakSetToString.working = typeof WeakSet !== "undefined" && isWeakSetToString(/* @__PURE__ */ new WeakSet());
    function isWeakSet2(value) {
      return isWeakSetToString(value);
    }
    exports$32.isWeakSet = isWeakSet2;
    function isArrayBufferToString(value) {
      return ObjectToString(value) === "[object ArrayBuffer]";
    }
    isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && isArrayBufferToString(new ArrayBuffer());
    function isArrayBuffer2(value) {
      if (typeof ArrayBuffer === "undefined") {
        return false;
      }
      return isArrayBufferToString.working ? isArrayBufferToString(value) : value instanceof ArrayBuffer;
    }
    exports$32.isArrayBuffer = isArrayBuffer2;
    function isDataViewToString(value) {
      return ObjectToString(value) === "[object DataView]";
    }
    isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
    function isDataView(value) {
      if (typeof DataView === "undefined") {
        return false;
      }
      return isDataViewToString.working ? isDataViewToString(value) : value instanceof DataView;
    }
    exports$32.isDataView = isDataView;
    var SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : void 0;
    function isSharedArrayBufferToString(value) {
      return ObjectToString(value) === "[object SharedArrayBuffer]";
    }
    function isSharedArrayBuffer(value) {
      if (typeof SharedArrayBufferCopy === "undefined") {
        return false;
      }
      if (typeof isSharedArrayBufferToString.working === "undefined") {
        isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
      }
      return isSharedArrayBufferToString.working ? isSharedArrayBufferToString(value) : value instanceof SharedArrayBufferCopy;
    }
    exports$32.isSharedArrayBuffer = isSharedArrayBuffer;
    function isAsyncFunction(value) {
      return ObjectToString(value) === "[object AsyncFunction]";
    }
    exports$32.isAsyncFunction = isAsyncFunction;
    function isMapIterator(value) {
      return ObjectToString(value) === "[object Map Iterator]";
    }
    exports$32.isMapIterator = isMapIterator;
    function isSetIterator(value) {
      return ObjectToString(value) === "[object Set Iterator]";
    }
    exports$32.isSetIterator = isSetIterator;
    function isGeneratorObject(value) {
      return ObjectToString(value) === "[object Generator]";
    }
    exports$32.isGeneratorObject = isGeneratorObject;
    function isWebAssemblyCompiledModule(value) {
      return ObjectToString(value) === "[object WebAssembly.Module]";
    }
    exports$32.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
    function isNumberObject(value) {
      return checkBoxedPrimitive(value, numberValue);
    }
    exports$32.isNumberObject = isNumberObject;
    function isStringObject(value) {
      return checkBoxedPrimitive(value, stringValue);
    }
    exports$32.isStringObject = isStringObject;
    function isBooleanObject(value) {
      return checkBoxedPrimitive(value, booleanValue);
    }
    exports$32.isBooleanObject = isBooleanObject;
    function isBigIntObject(value) {
      return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
    }
    exports$32.isBigIntObject = isBigIntObject;
    function isSymbolObject(value) {
      return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
    }
    exports$32.isSymbolObject = isSymbolObject;
    function isBoxedPrimitive(value) {
      return isNumberObject(value) || isStringObject(value) || isBooleanObject(value) || isBigIntObject(value) || isSymbolObject(value);
    }
    exports$32.isBoxedPrimitive = isBoxedPrimitive;
    function isAnyArrayBuffer(value) {
      return typeof Uint8Array !== "undefined" && (isArrayBuffer2(value) || isSharedArrayBuffer(value));
    }
    exports$32.isAnyArrayBuffer = isAnyArrayBuffer;
    ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(method2) {
      Object.defineProperty(exports$32, method2, {
        enumerable: false,
        value: function() {
          throw new Error(method2 + " is not supported in userland");
        }
      });
    });
    return exports$32;
  }
  function dew$13() {
    if (_dewExec$13)
      return exports$23;
    _dewExec$13 = true;
    exports$23 = function isBuffer3(arg) {
      return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
    };
    return exports$23;
  }
  function dew4() {
    if (_dewExec4)
      return exports$13;
    _dewExec4 = true;
    var process$1 = process2;
    var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors2(obj) {
      var keys2 = Object.keys(obj);
      var descriptors = {};
      for (var i = 0; i < keys2.length; i++) {
        descriptors[keys2[i]] = Object.getOwnPropertyDescriptor(obj, keys2[i]);
      }
      return descriptors;
    };
    var formatRegExp = /%[sdj%]/g;
    exports$13.format = function(f) {
      if (!isString3(f)) {
        var objects = [];
        for (var i = 0; i < arguments.length; i++) {
          objects.push(inspect2(arguments[i]));
        }
        return objects.join(" ");
      }
      var i = 1;
      var args = arguments;
      var len = args.length;
      var str = String(f).replace(formatRegExp, function(x2) {
        if (x2 === "%%")
          return "%";
        if (i >= len)
          return x2;
        switch (x2) {
          case "%s":
            return String(args[i++]);
          case "%d":
            return Number(args[i++]);
          case "%j":
            try {
              return JSON.stringify(args[i++]);
            } catch (_) {
              return "[Circular]";
            }
          default:
            return x2;
        }
      });
      for (var x = args[i]; i < len; x = args[++i]) {
        if (isNull3(x) || !isObject5(x)) {
          str += " " + x;
        } else {
          str += " " + inspect2(x);
        }
      }
      return str;
    };
    exports$13.deprecate = function(fn, msg) {
      if (typeof process$1 !== "undefined" && process$1.noDeprecation === true) {
        return fn;
      }
      if (typeof process$1 === "undefined") {
        return function() {
          return exports$13.deprecate(fn, msg).apply(this || _global, arguments);
        };
      }
      var warned = false;
      function deprecated() {
        if (!warned) {
          if (process$1.throwDeprecation) {
            throw new Error(msg);
          } else if (process$1.traceDeprecation) {
            console.trace(msg);
          } else {
            console.error(msg);
          }
          warned = true;
        }
        return fn.apply(this || _global, arguments);
      }
      return deprecated;
    };
    var debugs = {};
    var debugEnvRegex = /^$/;
    if (process$1.env.NODE_DEBUG) {
      var debugEnv = process$1.env.NODE_DEBUG;
      debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase();
      debugEnvRegex = new RegExp("^" + debugEnv + "$", "i");
    }
    exports$13.debuglog = function(set2) {
      set2 = set2.toUpperCase();
      if (!debugs[set2]) {
        if (debugEnvRegex.test(set2)) {
          var pid3 = process$1.pid;
          debugs[set2] = function() {
            var msg = exports$13.format.apply(exports$13, arguments);
            console.error("%s %d: %s", set2, pid3, msg);
          };
        } else {
          debugs[set2] = function() {
          };
        }
      }
      return debugs[set2];
    };
    function inspect2(obj, opts) {
      var ctx = {
        seen: [],
        stylize: stylizeNoColor
      };
      if (arguments.length >= 3)
        ctx.depth = arguments[2];
      if (arguments.length >= 4)
        ctx.colors = arguments[3];
      if (isBoolean3(opts)) {
        ctx.showHidden = opts;
      } else if (opts) {
        exports$13._extend(ctx, opts);
      }
      if (isUndefined3(ctx.showHidden))
        ctx.showHidden = false;
      if (isUndefined3(ctx.depth))
        ctx.depth = 2;
      if (isUndefined3(ctx.colors))
        ctx.colors = false;
      if (isUndefined3(ctx.customInspect))
        ctx.customInspect = true;
      if (ctx.colors)
        ctx.stylize = stylizeWithColor;
      return formatValue(ctx, obj, ctx.depth);
    }
    exports$13.inspect = inspect2;
    inspect2.colors = {
      "bold": [1, 22],
      "italic": [3, 23],
      "underline": [4, 24],
      "inverse": [7, 27],
      "white": [37, 39],
      "grey": [90, 39],
      "black": [30, 39],
      "blue": [34, 39],
      "cyan": [36, 39],
      "green": [32, 39],
      "magenta": [35, 39],
      "red": [31, 39],
      "yellow": [33, 39]
    };
    inspect2.styles = {
      "special": "cyan",
      "number": "yellow",
      "boolean": "yellow",
      "undefined": "grey",
      "null": "bold",
      "string": "green",
      "date": "magenta",
      "regexp": "red"
    };
    function stylizeWithColor(str, styleType) {
      var style = inspect2.styles[styleType];
      if (style) {
        return "\x1B[" + inspect2.colors[style][0] + "m" + str + "\x1B[" + inspect2.colors[style][1] + "m";
      } else {
        return str;
      }
    }
    function stylizeNoColor(str, styleType) {
      return str;
    }
    function arrayToHash(array) {
      var hash = {};
      array.forEach(function(val, idx) {
        hash[val] = true;
      });
      return hash;
    }
    function formatValue(ctx, value, recurseTimes) {
      if (ctx.customInspect && value && isFunction3(value.inspect) && value.inspect !== exports$13.inspect && !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!isString3(ret)) {
          ret = formatValue(ctx, ret, recurseTimes);
        }
        return ret;
      }
      var primitive = formatPrimitive(ctx, value);
      if (primitive) {
        return primitive;
      }
      var keys2 = Object.keys(value);
      var visibleKeys = arrayToHash(keys2);
      if (ctx.showHidden) {
        keys2 = Object.getOwnPropertyNames(value);
      }
      if (isError3(value) && (keys2.indexOf("message") >= 0 || keys2.indexOf("description") >= 0)) {
        return formatError(value);
      }
      if (keys2.length === 0) {
        if (isFunction3(value)) {
          var name = value.name ? ": " + value.name : "";
          return ctx.stylize("[Function" + name + "]", "special");
        }
        if (isRegExp3(value)) {
          return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        }
        if (isDate3(value)) {
          return ctx.stylize(Date.prototype.toString.call(value), "date");
        }
        if (isError3(value)) {
          return formatError(value);
        }
      }
      var base = "", array = false, braces = ["{", "}"];
      if (isArray3(value)) {
        array = true;
        braces = ["[", "]"];
      }
      if (isFunction3(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
      }
      if (isRegExp3(value)) {
        base = " " + RegExp.prototype.toString.call(value);
      }
      if (isDate3(value)) {
        base = " " + Date.prototype.toUTCString.call(value);
      }
      if (isError3(value)) {
        base = " " + formatError(value);
      }
      if (keys2.length === 0 && (!array || value.length == 0)) {
        return braces[0] + base + braces[1];
      }
      if (recurseTimes < 0) {
        if (isRegExp3(value)) {
          return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        } else {
          return ctx.stylize("[Object]", "special");
        }
      }
      ctx.seen.push(value);
      var output;
      if (array) {
        output = formatArray(ctx, value, recurseTimes, visibleKeys, keys2);
      } else {
        output = keys2.map(function(key) {
          return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
        });
      }
      ctx.seen.pop();
      return reduceToSingleString(output, base, braces);
    }
    function formatPrimitive(ctx, value) {
      if (isUndefined3(value))
        return ctx.stylize("undefined", "undefined");
      if (isString3(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
      }
      if (isNumber3(value))
        return ctx.stylize("" + value, "number");
      if (isBoolean3(value))
        return ctx.stylize("" + value, "boolean");
      if (isNull3(value))
        return ctx.stylize("null", "null");
    }
    function formatError(value) {
      return "[" + Error.prototype.toString.call(value) + "]";
    }
    function formatArray(ctx, value, recurseTimes, visibleKeys, keys2) {
      var output = [];
      for (var i = 0, l = value.length; i < l; ++i) {
        if (hasOwnProperty27(value, String(i))) {
          output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
        } else {
          output.push("");
        }
      }
      keys2.forEach(function(key) {
        if (!key.match(/^\d+$/)) {
          output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
        }
      });
      return output;
    }
    function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
      var name, str, desc;
      desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
      };
      if (desc.get) {
        if (desc.set) {
          str = ctx.stylize("[Getter/Setter]", "special");
        } else {
          str = ctx.stylize("[Getter]", "special");
        }
      } else {
        if (desc.set) {
          str = ctx.stylize("[Setter]", "special");
        }
      }
      if (!hasOwnProperty27(visibleKeys, key)) {
        name = "[" + key + "]";
      }
      if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
          if (isNull3(recurseTimes)) {
            str = formatValue(ctx, desc.value, null);
          } else {
            str = formatValue(ctx, desc.value, recurseTimes - 1);
          }
          if (str.indexOf("\n") > -1) {
            if (array) {
              str = str.split("\n").map(function(line) {
                return "  " + line;
              }).join("\n").slice(2);
            } else {
              str = "\n" + str.split("\n").map(function(line) {
                return "   " + line;
              }).join("\n");
            }
          }
        } else {
          str = ctx.stylize("[Circular]", "special");
        }
      }
      if (isUndefined3(name)) {
        if (array && key.match(/^\d+$/)) {
          return str;
        }
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
          name = name.slice(1, -1);
          name = ctx.stylize(name, "name");
        } else {
          name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
          name = ctx.stylize(name, "string");
        }
      }
      return name + ": " + str;
    }
    function reduceToSingleString(output, base, braces) {
      var length = output.reduce(function(prev, cur) {
        if (cur.indexOf("\n") >= 0)
          ;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      if (length > 60) {
        return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
      }
      return braces[0] + base + " " + output.join(", ") + " " + braces[1];
    }
    exports$13.types = dew$23();
    function isArray3(ar) {
      return Array.isArray(ar);
    }
    exports$13.isArray = isArray3;
    function isBoolean3(arg) {
      return typeof arg === "boolean";
    }
    exports$13.isBoolean = isBoolean3;
    function isNull3(arg) {
      return arg === null;
    }
    exports$13.isNull = isNull3;
    function isNullOrUndefined2(arg) {
      return arg == null;
    }
    exports$13.isNullOrUndefined = isNullOrUndefined2;
    function isNumber3(arg) {
      return typeof arg === "number";
    }
    exports$13.isNumber = isNumber3;
    function isString3(arg) {
      return typeof arg === "string";
    }
    exports$13.isString = isString3;
    function isSymbol3(arg) {
      return typeof arg === "symbol";
    }
    exports$13.isSymbol = isSymbol3;
    function isUndefined3(arg) {
      return arg === void 0;
    }
    exports$13.isUndefined = isUndefined3;
    function isRegExp3(re) {
      return isObject5(re) && objectToString2(re) === "[object RegExp]";
    }
    exports$13.isRegExp = isRegExp3;
    exports$13.types.isRegExp = isRegExp3;
    function isObject5(arg) {
      return typeof arg === "object" && arg !== null;
    }
    exports$13.isObject = isObject5;
    function isDate3(d) {
      return isObject5(d) && objectToString2(d) === "[object Date]";
    }
    exports$13.isDate = isDate3;
    exports$13.types.isDate = isDate3;
    function isError3(e) {
      return isObject5(e) && (objectToString2(e) === "[object Error]" || e instanceof Error);
    }
    exports$13.isError = isError3;
    exports$13.types.isNativeError = isError3;
    function isFunction3(arg) {
      return typeof arg === "function";
    }
    exports$13.isFunction = isFunction3;
    function isPrimitive2(arg) {
      return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || typeof arg === "undefined";
    }
    exports$13.isPrimitive = isPrimitive2;
    exports$13.isBuffer = dew$13();
    function objectToString2(o) {
      return Object.prototype.toString.call(o);
    }
    function pad2(n) {
      return n < 10 ? "0" + n.toString(10) : n.toString(10);
    }
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    function timestamp() {
      var d = new Date();
      var time = [pad2(d.getHours()), pad2(d.getMinutes()), pad2(d.getSeconds())].join(":");
      return [d.getDate(), months[d.getMonth()], time].join(" ");
    }
    exports$13.log = function() {
      console.log("%s - %s", timestamp(), exports$13.format.apply(exports$13, arguments));
    };
    exports$13.inherits = dew3();
    exports$13._extend = function(origin, add2) {
      if (!add2 || !isObject5(add2))
        return origin;
      var keys2 = Object.keys(add2);
      var i = keys2.length;
      while (i--) {
        origin[keys2[i]] = add2[keys2[i]];
      }
      return origin;
    };
    function hasOwnProperty27(obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    var kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : void 0;
    exports$13.promisify = function promisify2(original) {
      if (typeof original !== "function")
        throw new TypeError('The "original" argument must be of type Function');
      if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
        fn = original[kCustomPromisifiedSymbol];
        if (typeof fn !== "function") {
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        }
        Object.defineProperty(fn, kCustomPromisifiedSymbol, {
          value: fn,
          enumerable: false,
          writable: false,
          configurable: true
        });
        return fn;
      }
      function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve2, reject2) {
          promiseResolve = resolve2;
          promiseReject = reject2;
        });
        var args = [];
        for (var i = 0; i < arguments.length; i++) {
          args.push(arguments[i]);
        }
        args.push(function(err, value) {
          if (err) {
            promiseReject(err);
          } else {
            promiseResolve(value);
          }
        });
        try {
          original.apply(this || _global, args);
        } catch (err) {
          promiseReject(err);
        }
        return promise;
      }
      Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
      if (kCustomPromisifiedSymbol)
        Object.defineProperty(fn, kCustomPromisifiedSymbol, {
          value: fn,
          enumerable: false,
          writable: false,
          configurable: true
        });
      return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
    };
    exports$13.promisify.custom = kCustomPromisifiedSymbol;
    function callbackifyOnRejected(reason, cb) {
      if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
      }
      return cb(reason);
    }
    function callbackify2(original) {
      if (typeof original !== "function") {
        throw new TypeError('The "original" argument must be of type Function');
      }
      function callbackified() {
        var args = [];
        for (var i = 0; i < arguments.length; i++) {
          args.push(arguments[i]);
        }
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") {
          throw new TypeError("The last argument must be of type Function");
        }
        var self2 = this || _global;
        var cb = function() {
          return maybeCb.apply(self2, arguments);
        };
        original.apply(this || _global, args).then(function(ret) {
          process$1.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
          process$1.nextTick(callbackifyOnRejected.bind(null, rej, cb));
        });
      }
      Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
      Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
      return callbackified;
    }
    exports$13.callbackify = callbackify2;
    return exports$13;
  }
  var exports$c2, _dewExec$b2, exports$b2, _dewExec$a2, exports$a2, _dewExec$92, exports$92, _dewExec$82, exports$82, _dewExec$72, exports$72, _dewExec$62, exports$62, _dewExec$52, _global$2, exports$52, _dewExec$42, _global$1, exports$42, _dewExec$32, exports$32, _dewExec$23, exports$23, _dewExec$13, exports$13, _dewExec4, _global, exports6, _extend, callbackify, debuglog, deprecate, format, inherits, inspect, isArray2, isBoolean2, isBuffer2, isDate2, isError2, isFunction2, isNull2, isNullOrUndefined, isNumber2, isObject4, isPrimitive, isRegExp2, isString2, isSymbol2, isUndefined2, log, promisify, types, TextEncoder, TextDecoder2;
  var init_util = __esm({
    "../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/util.js"() {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      init_chunk_DtcTpLWz();
      init_chunk_CkFCi_G1();
      init_chunk_DEMDiNwt();
      exports$c2 = {};
      _dewExec$b2 = false;
      exports$b2 = {};
      _dewExec$a2 = false;
      exports$a2 = {};
      _dewExec$92 = false;
      exports$92 = {};
      _dewExec$82 = false;
      exports$82 = {};
      _dewExec$72 = false;
      exports$72 = {};
      _dewExec$62 = false;
      exports$62 = {};
      _dewExec$52 = false;
      _global$2 = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
      exports$52 = {};
      _dewExec$42 = false;
      _global$1 = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
      exports$42 = {};
      _dewExec$32 = false;
      exports$32 = {};
      _dewExec$23 = false;
      exports$23 = {};
      _dewExec$13 = false;
      exports$13 = {};
      _dewExec4 = false;
      _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
      exports6 = dew4();
      exports6["format"];
      exports6["deprecate"];
      exports6["debuglog"];
      exports6["inspect"];
      exports6["types"];
      exports6["isArray"];
      exports6["isBoolean"];
      exports6["isNull"];
      exports6["isNullOrUndefined"];
      exports6["isNumber"];
      exports6["isString"];
      exports6["isSymbol"];
      exports6["isUndefined"];
      exports6["isRegExp"];
      exports6["isObject"];
      exports6["isDate"];
      exports6["isError"];
      exports6["isFunction"];
      exports6["isPrimitive"];
      exports6["isBuffer"];
      exports6["log"];
      exports6["inherits"];
      exports6["_extend"];
      exports6["promisify"];
      exports6["callbackify"];
      _extend = exports6._extend;
      callbackify = exports6.callbackify;
      debuglog = exports6.debuglog;
      deprecate = exports6.deprecate;
      format = exports6.format;
      inherits = exports6.inherits;
      inspect = exports6.inspect;
      isArray2 = exports6.isArray;
      isBoolean2 = exports6.isBoolean;
      isBuffer2 = exports6.isBuffer;
      isDate2 = exports6.isDate;
      isError2 = exports6.isError;
      isFunction2 = exports6.isFunction;
      isNull2 = exports6.isNull;
      isNullOrUndefined = exports6.isNullOrUndefined;
      isNumber2 = exports6.isNumber;
      isObject4 = exports6.isObject;
      isPrimitive = exports6.isPrimitive;
      isRegExp2 = exports6.isRegExp;
      isString2 = exports6.isString;
      isSymbol2 = exports6.isSymbol;
      isUndefined2 = exports6.isUndefined;
      log = exports6.log;
      promisify = exports6.promisify;
      types = exports6.types;
      TextEncoder = exports6.TextEncoder = globalThis.TextEncoder;
      TextDecoder2 = exports6.TextDecoder = globalThis.TextDecoder;
    }
  });

  // ../../node_modules/.pnpm/ret@0.1.15/node_modules/ret/lib/types.js
  var require_types = __commonJS({
    "../../node_modules/.pnpm/ret@0.1.15/node_modules/ret/lib/types.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = {
        ROOT: 0,
        GROUP: 1,
        POSITION: 2,
        SET: 3,
        RANGE: 4,
        REPETITION: 5,
        REFERENCE: 6,
        CHAR: 7
      };
    }
  });

  // ../../node_modules/.pnpm/ret@0.1.15/node_modules/ret/lib/sets.js
  var require_sets = __commonJS({
    "../../node_modules/.pnpm/ret@0.1.15/node_modules/ret/lib/sets.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var types2 = require_types();
      var INTS = function() {
        return [{ type: types2.RANGE, from: 48, to: 57 }];
      };
      var WORDS = function() {
        return [
          { type: types2.CHAR, value: 95 },
          { type: types2.RANGE, from: 97, to: 122 },
          { type: types2.RANGE, from: 65, to: 90 }
        ].concat(INTS());
      };
      var WHITESPACE = function() {
        return [
          { type: types2.CHAR, value: 9 },
          { type: types2.CHAR, value: 10 },
          { type: types2.CHAR, value: 11 },
          { type: types2.CHAR, value: 12 },
          { type: types2.CHAR, value: 13 },
          { type: types2.CHAR, value: 32 },
          { type: types2.CHAR, value: 160 },
          { type: types2.CHAR, value: 5760 },
          { type: types2.CHAR, value: 6158 },
          { type: types2.CHAR, value: 8192 },
          { type: types2.CHAR, value: 8193 },
          { type: types2.CHAR, value: 8194 },
          { type: types2.CHAR, value: 8195 },
          { type: types2.CHAR, value: 8196 },
          { type: types2.CHAR, value: 8197 },
          { type: types2.CHAR, value: 8198 },
          { type: types2.CHAR, value: 8199 },
          { type: types2.CHAR, value: 8200 },
          { type: types2.CHAR, value: 8201 },
          { type: types2.CHAR, value: 8202 },
          { type: types2.CHAR, value: 8232 },
          { type: types2.CHAR, value: 8233 },
          { type: types2.CHAR, value: 8239 },
          { type: types2.CHAR, value: 8287 },
          { type: types2.CHAR, value: 12288 },
          { type: types2.CHAR, value: 65279 }
        ];
      };
      var NOTANYCHAR = function() {
        return [
          { type: types2.CHAR, value: 10 },
          { type: types2.CHAR, value: 13 },
          { type: types2.CHAR, value: 8232 },
          { type: types2.CHAR, value: 8233 }
        ];
      };
      exports8.words = function() {
        return { type: types2.SET, set: WORDS(), not: false };
      };
      exports8.notWords = function() {
        return { type: types2.SET, set: WORDS(), not: true };
      };
      exports8.ints = function() {
        return { type: types2.SET, set: INTS(), not: false };
      };
      exports8.notInts = function() {
        return { type: types2.SET, set: INTS(), not: true };
      };
      exports8.whitespace = function() {
        return { type: types2.SET, set: WHITESPACE(), not: false };
      };
      exports8.notWhitespace = function() {
        return { type: types2.SET, set: WHITESPACE(), not: true };
      };
      exports8.anyChar = function() {
        return { type: types2.SET, set: NOTANYCHAR(), not: true };
      };
    }
  });

  // ../../node_modules/.pnpm/ret@0.1.15/node_modules/ret/lib/util.js
  var require_util = __commonJS({
    "../../node_modules/.pnpm/ret@0.1.15/node_modules/ret/lib/util.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var types2 = require_types();
      var sets = require_sets();
      var CTRL = "@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^ ?";
      var SLSH = { "0": 0, "t": 9, "n": 10, "v": 11, "f": 12, "r": 13 };
      exports8.strToChars = function(str) {
        var chars_regex = /(\[\\b\])|(\\)?\\(?:u([A-F0-9]{4})|x([A-F0-9]{2})|(0?[0-7]{2})|c([@A-Z\[\\\]\^?])|([0tnvfr]))/g;
        str = str.replace(chars_regex, function(s, b, lbs, a16, b16, c8, dctrl, eslsh) {
          if (lbs) {
            return s;
          }
          var code = b ? 8 : a16 ? parseInt(a16, 16) : b16 ? parseInt(b16, 16) : c8 ? parseInt(c8, 8) : dctrl ? CTRL.indexOf(dctrl) : SLSH[eslsh];
          var c = String.fromCharCode(code);
          if (/[\[\]{}\^$.|?*+()]/.test(c)) {
            c = "\\" + c;
          }
          return c;
        });
        return str;
      };
      exports8.tokenizeClass = function(str, regexpStr) {
        var tokens = [];
        var regexp = /\\(?:(w)|(d)|(s)|(W)|(D)|(S))|((?:(?:\\)(.)|([^\]\\]))-(?:\\)?([^\]]))|(\])|(?:\\)?(.)/g;
        var rs, c;
        while ((rs = regexp.exec(str)) != null) {
          if (rs[1]) {
            tokens.push(sets.words());
          } else if (rs[2]) {
            tokens.push(sets.ints());
          } else if (rs[3]) {
            tokens.push(sets.whitespace());
          } else if (rs[4]) {
            tokens.push(sets.notWords());
          } else if (rs[5]) {
            tokens.push(sets.notInts());
          } else if (rs[6]) {
            tokens.push(sets.notWhitespace());
          } else if (rs[7]) {
            tokens.push({
              type: types2.RANGE,
              from: (rs[8] || rs[9]).charCodeAt(0),
              to: rs[10].charCodeAt(0)
            });
          } else if (c = rs[12]) {
            tokens.push({
              type: types2.CHAR,
              value: c.charCodeAt(0)
            });
          } else {
            return [tokens, regexp.lastIndex];
          }
        }
        exports8.error(regexpStr, "Unterminated character class");
      };
      exports8.error = function(regexp, msg) {
        throw new SyntaxError("Invalid regular expression: /" + regexp + "/: " + msg);
      };
    }
  });

  // ../../node_modules/.pnpm/ret@0.1.15/node_modules/ret/lib/positions.js
  var require_positions = __commonJS({
    "../../node_modules/.pnpm/ret@0.1.15/node_modules/ret/lib/positions.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var types2 = require_types();
      exports8.wordBoundary = function() {
        return { type: types2.POSITION, value: "b" };
      };
      exports8.nonWordBoundary = function() {
        return { type: types2.POSITION, value: "B" };
      };
      exports8.begin = function() {
        return { type: types2.POSITION, value: "^" };
      };
      exports8.end = function() {
        return { type: types2.POSITION, value: "$" };
      };
    }
  });

  // ../../node_modules/.pnpm/ret@0.1.15/node_modules/ret/lib/index.js
  var require_lib = __commonJS({
    "../../node_modules/.pnpm/ret@0.1.15/node_modules/ret/lib/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var util = require_util();
      var types2 = require_types();
      var sets = require_sets();
      var positions = require_positions();
      module2.exports = function(regexpStr) {
        var i = 0, l, c, start = { type: types2.ROOT, stack: [] }, lastGroup = start, last2 = start.stack, groupStack = [];
        var repeatErr = function(i2) {
          util.error(regexpStr, "Nothing to repeat at column " + (i2 - 1));
        };
        var str = util.strToChars(regexpStr);
        l = str.length;
        while (i < l) {
          c = str[i++];
          switch (c) {
            case "\\":
              c = str[i++];
              switch (c) {
                case "b":
                  last2.push(positions.wordBoundary());
                  break;
                case "B":
                  last2.push(positions.nonWordBoundary());
                  break;
                case "w":
                  last2.push(sets.words());
                  break;
                case "W":
                  last2.push(sets.notWords());
                  break;
                case "d":
                  last2.push(sets.ints());
                  break;
                case "D":
                  last2.push(sets.notInts());
                  break;
                case "s":
                  last2.push(sets.whitespace());
                  break;
                case "S":
                  last2.push(sets.notWhitespace());
                  break;
                default:
                  if (/\d/.test(c)) {
                    last2.push({ type: types2.REFERENCE, value: parseInt(c, 10) });
                  } else {
                    last2.push({ type: types2.CHAR, value: c.charCodeAt(0) });
                  }
              }
              break;
            case "^":
              last2.push(positions.begin());
              break;
            case "$":
              last2.push(positions.end());
              break;
            case "[":
              var not;
              if (str[i] === "^") {
                not = true;
                i++;
              } else {
                not = false;
              }
              var classTokens = util.tokenizeClass(str.slice(i), regexpStr);
              i += classTokens[1];
              last2.push({
                type: types2.SET,
                set: classTokens[0],
                not
              });
              break;
            case ".":
              last2.push(sets.anyChar());
              break;
            case "(":
              var group = {
                type: types2.GROUP,
                stack: [],
                remember: true
              };
              c = str[i];
              if (c === "?") {
                c = str[i + 1];
                i += 2;
                if (c === "=") {
                  group.followedBy = true;
                } else if (c === "!") {
                  group.notFollowedBy = true;
                } else if (c !== ":") {
                  util.error(
                    regexpStr,
                    "Invalid group, character '" + c + "' after '?' at column " + (i - 1)
                  );
                }
                group.remember = false;
              }
              last2.push(group);
              groupStack.push(lastGroup);
              lastGroup = group;
              last2 = group.stack;
              break;
            case ")":
              if (groupStack.length === 0) {
                util.error(regexpStr, "Unmatched ) at column " + (i - 1));
              }
              lastGroup = groupStack.pop();
              last2 = lastGroup.options ? lastGroup.options[lastGroup.options.length - 1] : lastGroup.stack;
              break;
            case "|":
              if (!lastGroup.options) {
                lastGroup.options = [lastGroup.stack];
                delete lastGroup.stack;
              }
              var stack = [];
              lastGroup.options.push(stack);
              last2 = stack;
              break;
            case "{":
              var rs = /^(\d+)(,(\d+)?)?\}/.exec(str.slice(i)), min2, max2;
              if (rs !== null) {
                if (last2.length === 0) {
                  repeatErr(i);
                }
                min2 = parseInt(rs[1], 10);
                max2 = rs[2] ? rs[3] ? parseInt(rs[3], 10) : Infinity : min2;
                i += rs[0].length;
                last2.push({
                  type: types2.REPETITION,
                  min: min2,
                  max: max2,
                  value: last2.pop()
                });
              } else {
                last2.push({
                  type: types2.CHAR,
                  value: 123
                });
              }
              break;
            case "?":
              if (last2.length === 0) {
                repeatErr(i);
              }
              last2.push({
                type: types2.REPETITION,
                min: 0,
                max: 1,
                value: last2.pop()
              });
              break;
            case "+":
              if (last2.length === 0) {
                repeatErr(i);
              }
              last2.push({
                type: types2.REPETITION,
                min: 1,
                max: Infinity,
                value: last2.pop()
              });
              break;
            case "*":
              if (last2.length === 0) {
                repeatErr(i);
              }
              last2.push({
                type: types2.REPETITION,
                min: 0,
                max: Infinity,
                value: last2.pop()
              });
              break;
            default:
              last2.push({
                type: types2.CHAR,
                value: c.charCodeAt(0)
              });
          }
        }
        if (groupStack.length !== 0) {
          util.error(regexpStr, "Unterminated group");
        }
        return start;
      };
      module2.exports.types = types2;
    }
  });

  // ../../node_modules/.pnpm/safe-regex@1.1.0/node_modules/safe-regex/index.js
  var require_safe_regex = __commonJS({
    "../../node_modules/.pnpm/safe-regex@1.1.0/node_modules/safe-regex/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var parse4 = require_lib();
      var types2 = parse4.types;
      module2.exports = function(re, opts) {
        if (!opts)
          opts = {};
        var replimit = opts.limit === void 0 ? 25 : opts.limit;
        if (isRegExp3(re))
          re = re.source;
        else if (typeof re !== "string")
          re = String(re);
        try {
          re = parse4(re);
        } catch (err) {
          return false;
        }
        var reps = 0;
        return function walk(node, starHeight) {
          if (node.type === types2.REPETITION) {
            starHeight++;
            reps++;
            if (starHeight > 1)
              return false;
            if (reps > replimit)
              return false;
          }
          if (node.options) {
            for (var i = 0, len = node.options.length; i < len; i++) {
              var ok = walk({ stack: node.options[i] }, starHeight);
              if (!ok)
                return false;
            }
          }
          var stack = node.stack || node.value && node.value.stack;
          if (!stack)
            return true;
          for (var i = 0; i < stack.length; i++) {
            var ok = walk(stack[i], starHeight);
            if (!ok)
              return false;
          }
          return true;
        }(re, 0);
      };
      function isRegExp3(x) {
        return {}.toString.call(x) === "[object RegExp]";
      }
    }
  });

  // ../../node_modules/.pnpm/isobject@3.0.1/node_modules/isobject/index.js
  var require_isobject = __commonJS({
    "../../node_modules/.pnpm/isobject@3.0.1/node_modules/isobject/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = function isObject5(val) {
        return val != null && typeof val === "object" && Array.isArray(val) === false;
      };
    }
  });

  // ../../node_modules/.pnpm/function-bind@1.1.2/node_modules/function-bind/implementation.js
  var require_implementation = __commonJS({
    "../../node_modules/.pnpm/function-bind@1.1.2/node_modules/function-bind/implementation.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
      var toStr = Object.prototype.toString;
      var max2 = Math.max;
      var funcType = "[object Function]";
      var concatty = function concatty2(a, b) {
        var arr = [];
        for (var i = 0; i < a.length; i += 1) {
          arr[i] = a[i];
        }
        for (var j = 0; j < b.length; j += 1) {
          arr[j + a.length] = b[j];
        }
        return arr;
      };
      var slicy = function slicy2(arrLike, offset) {
        var arr = [];
        for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
          arr[j] = arrLike[i];
        }
        return arr;
      };
      var joiny = function(arr, joiner) {
        var str = "";
        for (var i = 0; i < arr.length; i += 1) {
          str += arr[i];
          if (i + 1 < arr.length) {
            str += joiner;
          }
        }
        return str;
      };
      module2.exports = function bind2(that) {
        var target = this;
        if (typeof target !== "function" || toStr.apply(target) !== funcType) {
          throw new TypeError(ERROR_MESSAGE + target);
        }
        var args = slicy(arguments, 1);
        var bound;
        var binder = function() {
          if (this instanceof bound) {
            var result2 = target.apply(
              this,
              concatty(args, arguments)
            );
            if (Object(result2) === result2) {
              return result2;
            }
            return this;
          }
          return target.apply(
            that,
            concatty(args, arguments)
          );
        };
        var boundLength = max2(0, target.length - args.length);
        var boundArgs = [];
        for (var i = 0; i < boundLength; i++) {
          boundArgs[i] = "$" + i;
        }
        bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
        if (target.prototype) {
          var Empty = function Empty2() {
          };
          Empty.prototype = target.prototype;
          bound.prototype = new Empty();
          Empty.prototype = null;
        }
        return bound;
      };
    }
  });

  // ../../node_modules/.pnpm/function-bind@1.1.2/node_modules/function-bind/index.js
  var require_function_bind = __commonJS({
    "../../node_modules/.pnpm/function-bind@1.1.2/node_modules/function-bind/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var implementation = require_implementation();
      module2.exports = Function.prototype.bind || implementation;
    }
  });

  // ../../node_modules/.pnpm/hasown@2.0.2/node_modules/hasown/index.js
  var require_hasown = __commonJS({
    "../../node_modules/.pnpm/hasown@2.0.2/node_modules/hasown/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var call = Function.prototype.call;
      var $hasOwn = Object.prototype.hasOwnProperty;
      var bind2 = require_function_bind();
      module2.exports = bind2.call(call, $hasOwn);
    }
  });

  // ../../node_modules/.pnpm/is-accessor-descriptor@1.0.1/node_modules/is-accessor-descriptor/index.js
  var require_is_accessor_descriptor = __commonJS({
    "../../node_modules/.pnpm/is-accessor-descriptor@1.0.1/node_modules/is-accessor-descriptor/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var hasOwn = require_hasown();
      var accessor = {
        __proto__: null,
        configurable: "boolean",
        enumerable: "boolean",
        get: "function",
        set: "function"
      };
      module2.exports = function isAccessorDescriptor(obj, prop) {
        if (typeof prop === "string") {
          var val = Object.getOwnPropertyDescriptor(obj, prop);
          return typeof val !== "undefined";
        }
        if (!obj || typeof obj !== "object") {
          return false;
        }
        if (hasOwn(obj, "value") || hasOwn(obj, "writable")) {
          return false;
        }
        if ((!hasOwn(obj, "get") || typeof obj.get !== "function") && (!hasOwn(obj, "set") || typeof obj.set !== "function")) {
          return false;
        }
        if (hasOwn(obj, "get") && typeof obj.get !== "function" && typeof obj.get !== "undefined" || hasOwn(obj, "set") && typeof obj.set !== "function" && typeof obj.set !== "undefined") {
          return false;
        }
        for (var key in obj) {
          if (hasOwn(obj, key) && hasOwn(accessor, key) && typeof obj[key] !== accessor[key] && typeof obj[key] !== "undefined") {
            return false;
          }
        }
        return true;
      };
    }
  });

  // ../../node_modules/.pnpm/is-data-descriptor@1.0.1/node_modules/is-data-descriptor/index.js
  var require_is_data_descriptor = __commonJS({
    "../../node_modules/.pnpm/is-data-descriptor@1.0.1/node_modules/is-data-descriptor/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var hasOwn = require_hasown();
      var data = {
        __proto__: null,
        configurable: "boolean",
        enumerable: "boolean",
        writable: "boolean"
      };
      module2.exports = function isDataDescriptor(obj, prop) {
        if (!obj || typeof obj !== "object") {
          return false;
        }
        if (typeof prop === "string") {
          var val = Object.getOwnPropertyDescriptor(obj, prop);
          return typeof val !== "undefined";
        }
        if (!("value" in obj) && !("writable" in obj) || "get" in obj || "set" in obj) {
          return false;
        }
        for (var key in obj) {
          if (key !== "value" && hasOwn(obj, key) && hasOwn(data, key) && typeof obj[key] !== data[key] && typeof obj[key] !== "undefined") {
            return false;
          }
        }
        return true;
      };
    }
  });

  // ../../node_modules/.pnpm/is-descriptor@1.0.3/node_modules/is-descriptor/index.js
  var require_is_descriptor = __commonJS({
    "../../node_modules/.pnpm/is-descriptor@1.0.3/node_modules/is-descriptor/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isAccessor = require_is_accessor_descriptor();
      var isData = require_is_data_descriptor();
      module2.exports = function isDescriptor(obj, key) {
        if (!obj || typeof obj !== "object" && typeof obj !== "function") {
          return false;
        }
        if ("get" in obj || "set" in obj) {
          return isAccessor(obj, key);
        }
        return isData(obj, key);
      };
    }
  });

  // ../../node_modules/.pnpm/define-property@2.0.2/node_modules/define-property/index.js
  var require_define_property = __commonJS({
    "../../node_modules/.pnpm/define-property@2.0.2/node_modules/define-property/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isobject = require_isobject();
      var isDescriptor = require_is_descriptor();
      var define2 = typeof Reflect !== "undefined" && Reflect.defineProperty ? Reflect.defineProperty : Object.defineProperty;
      module2.exports = function defineProperty2(obj, key, val) {
        if (!isobject(obj) && typeof obj !== "function" && !Array.isArray(obj)) {
          throw new TypeError("expected an object, function, or array");
        }
        if (typeof key !== "string") {
          throw new TypeError('expected "key" to be a string');
        }
        if (isDescriptor(val)) {
          define2(obj, key, val);
          return obj;
        }
        define2(obj, key, {
          configurable: true,
          enumerable: false,
          writable: true,
          value: val
        });
        return obj;
      };
    }
  });

  // ../../node_modules/.pnpm/is-plain-object@2.0.4/node_modules/is-plain-object/index.js
  var require_is_plain_object = __commonJS({
    "../../node_modules/.pnpm/is-plain-object@2.0.4/node_modules/is-plain-object/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isObject5 = require_isobject();
      function isObjectObject(o) {
        return isObject5(o) === true && Object.prototype.toString.call(o) === "[object Object]";
      }
      module2.exports = function isPlainObject3(o) {
        var ctor, prot;
        if (isObjectObject(o) === false)
          return false;
        ctor = o.constructor;
        if (typeof ctor !== "function")
          return false;
        prot = ctor.prototype;
        if (isObjectObject(prot) === false)
          return false;
        if (prot.hasOwnProperty("isPrototypeOf") === false) {
          return false;
        }
        return true;
      };
    }
  });

  // ../../node_modules/.pnpm/is-extendable@1.0.1/node_modules/is-extendable/index.js
  var require_is_extendable = __commonJS({
    "../../node_modules/.pnpm/is-extendable@1.0.1/node_modules/is-extendable/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isPlainObject3 = require_is_plain_object();
      module2.exports = function isExtendable(val) {
        return isPlainObject3(val) || typeof val === "function" || Array.isArray(val);
      };
    }
  });

  // ../../node_modules/.pnpm/assign-symbols@1.0.0/node_modules/assign-symbols/index.js
  var require_assign_symbols = __commonJS({
    "../../node_modules/.pnpm/assign-symbols@1.0.0/node_modules/assign-symbols/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = function(receiver, objects) {
        if (receiver === null || typeof receiver === "undefined") {
          throw new TypeError("expected first argument to be an object.");
        }
        if (typeof objects === "undefined" || typeof Symbol === "undefined") {
          return receiver;
        }
        if (typeof Object.getOwnPropertySymbols !== "function") {
          return receiver;
        }
        var isEnumerable = Object.prototype.propertyIsEnumerable;
        var target = Object(receiver);
        var len = arguments.length, i = 0;
        while (++i < len) {
          var provider = Object(arguments[i]);
          var names = Object.getOwnPropertySymbols(provider);
          for (var j = 0; j < names.length; j++) {
            var key = names[j];
            if (isEnumerable.call(provider, key)) {
              target[key] = provider[key];
            }
          }
        }
        return target;
      };
    }
  });

  // ../../node_modules/.pnpm/extend-shallow@3.0.2/node_modules/extend-shallow/index.js
  var require_extend_shallow = __commonJS({
    "../../node_modules/.pnpm/extend-shallow@3.0.2/node_modules/extend-shallow/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isExtendable = require_is_extendable();
      var assignSymbols = require_assign_symbols();
      module2.exports = Object.assign || function(obj) {
        if (obj === null || typeof obj === "undefined") {
          throw new TypeError("Cannot convert undefined or null to object");
        }
        if (!isObject5(obj)) {
          obj = {};
        }
        for (var i = 1; i < arguments.length; i++) {
          var val = arguments[i];
          if (isString3(val)) {
            val = toObject(val);
          }
          if (isObject5(val)) {
            assign2(obj, val);
            assignSymbols(obj, val);
          }
        }
        return obj;
      };
      function assign2(a, b) {
        for (var key in b) {
          if (hasOwn(b, key)) {
            a[key] = b[key];
          }
        }
      }
      function isString3(val) {
        return val && typeof val === "string";
      }
      function toObject(str) {
        var obj = {};
        for (var i in str) {
          obj[i] = str[i];
        }
        return obj;
      }
      function isObject5(val) {
        return val && typeof val === "object" || isExtendable(val);
      }
      function hasOwn(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
      }
    }
  });

  // ../../node_modules/.pnpm/regex-not@1.0.2/node_modules/regex-not/index.js
  var require_regex_not = __commonJS({
    "../../node_modules/.pnpm/regex-not@1.0.2/node_modules/regex-not/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var extend = require_extend_shallow();
      var safe = require_safe_regex();
      function toRegex(pattern, options) {
        return new RegExp(toRegex.create(pattern, options));
      }
      toRegex.create = function(pattern, options) {
        if (typeof pattern !== "string") {
          throw new TypeError("expected a string");
        }
        var opts = extend({}, options);
        if (opts.contains === true) {
          opts.strictNegate = false;
        }
        var open2 = opts.strictOpen !== false ? "^" : "";
        var close = opts.strictClose !== false ? "$" : "";
        var endChar = opts.endChar ? opts.endChar : "+";
        var str = pattern;
        if (opts.strictNegate === false) {
          str = "(?:(?!(?:" + pattern + ")).)" + endChar;
        } else {
          str = "(?:(?!^(?:" + pattern + ")$).)" + endChar;
        }
        var res = open2 + str + close;
        if (opts.safe === true && safe(res) === false) {
          throw new Error("potentially unsafe regular expression: " + res);
        }
        return res;
      };
      module2.exports = toRegex;
    }
  });

  // ../../node_modules/.pnpm/to-regex@3.0.2/node_modules/to-regex/index.js
  var require_to_regex = __commonJS({
    "../../node_modules/.pnpm/to-regex@3.0.2/node_modules/to-regex/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var safe = require_safe_regex();
      var define2 = require_define_property();
      var extend = require_extend_shallow();
      var not = require_regex_not();
      var MAX_LENGTH = 1024 * 64;
      var cache = {};
      module2.exports = function(patterns, options) {
        if (!Array.isArray(patterns)) {
          return makeRe(patterns, options);
        }
        return makeRe(patterns.join("|"), options);
      };
      function makeRe(pattern, options) {
        if (pattern instanceof RegExp) {
          return pattern;
        }
        if (typeof pattern !== "string") {
          throw new TypeError("expected a string");
        }
        if (pattern.length > MAX_LENGTH) {
          throw new Error("expected pattern to be less than " + MAX_LENGTH + " characters");
        }
        var key = pattern;
        if (!options || options && options.cache !== false) {
          key = createKey(pattern, options);
          if (cache.hasOwnProperty(key)) {
            return cache[key];
          }
        }
        var opts = extend({}, options);
        if (opts.contains === true) {
          if (opts.negate === true) {
            opts.strictNegate = false;
          } else {
            opts.strict = false;
          }
        }
        if (opts.strict === false) {
          opts.strictOpen = false;
          opts.strictClose = false;
        }
        var open2 = opts.strictOpen !== false ? "^" : "";
        var close = opts.strictClose !== false ? "$" : "";
        var flags = opts.flags || "";
        var regex;
        if (opts.nocase === true && !/i/.test(flags)) {
          flags += "i";
        }
        try {
          if (opts.negate || typeof opts.strictNegate === "boolean") {
            pattern = not.create(pattern, opts);
          }
          var str = open2 + "(?:" + pattern + ")" + close;
          regex = new RegExp(str, flags);
          if (opts.safe === true && safe(regex) === false) {
            throw new Error("potentially unsafe regular expression: " + regex.source);
          }
        } catch (err) {
          if (opts.strictErrors === true || opts.safe === true) {
            err.key = key;
            err.pattern = pattern;
            err.originalOptions = options;
            err.createdOptions = opts;
            throw err;
          }
          try {
            regex = new RegExp("^" + pattern.replace(/(\W)/g, "\\$1") + "$");
          } catch (err2) {
            regex = /.^/;
          }
        }
        if (opts.cache !== false) {
          memoize2(regex, key, pattern, opts);
        }
        return regex;
      }
      function memoize2(regex, key, pattern, options) {
        define2(regex, "cached", true);
        define2(regex, "pattern", pattern);
        define2(regex, "options", options);
        define2(regex, "key", key);
        cache[key] = regex;
      }
      function createKey(pattern, options) {
        if (!options)
          return pattern;
        var key = pattern;
        for (var prop in options) {
          if (options.hasOwnProperty(prop)) {
            key += ";" + prop + "=" + String(options[prop]);
          }
        }
        return key;
      }
      module2.exports.makeRe = makeRe;
    }
  });

  // ../../node_modules/.pnpm/nanomatch@1.2.13_supports-color@6.1.0/node_modules/nanomatch/lib/compilers.js
  var require_compilers = __commonJS({
    "../../node_modules/.pnpm/nanomatch@1.2.13_supports-color@6.1.0/node_modules/nanomatch/lib/compilers.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = function(nanomatch, options) {
        function slash() {
          if (options && typeof options.slash === "string") {
            return options.slash;
          }
          if (options && typeof options.slash === "function") {
            return options.slash.call(nanomatch);
          }
          return "\\\\/";
        }
        function star() {
          if (options && typeof options.star === "string") {
            return options.star;
          }
          if (options && typeof options.star === "function") {
            return options.star.call(nanomatch);
          }
          return "[^" + slash() + "]*?";
        }
        var ast = nanomatch.ast = nanomatch.parser.ast;
        ast.state = nanomatch.parser.state;
        nanomatch.compiler.state = ast.state;
        nanomatch.compiler.set("not", function(node) {
          var prev = this.prev();
          if (this.options.nonegate === true || prev.type !== "bos") {
            return this.emit("\\" + node.val, node);
          }
          return this.emit(node.val, node);
        }).set("escape", function(node) {
          if (this.options.unescape && /^[-\w_.]/.test(node.val)) {
            return this.emit(node.val, node);
          }
          return this.emit("\\" + node.val, node);
        }).set("quoted", function(node) {
          return this.emit(node.val, node);
        }).set("dollar", function(node) {
          if (node.parent.type === "bracket") {
            return this.emit(node.val, node);
          }
          return this.emit("\\" + node.val, node);
        }).set("dot", function(node) {
          if (node.dotfiles === true)
            this.dotfiles = true;
          return this.emit("\\" + node.val, node);
        }).set("backslash", function(node) {
          return this.emit(node.val, node);
        }).set("slash", function(node, nodes, i) {
          var val = "[" + slash() + "]";
          var parent2 = node.parent;
          var prev = this.prev();
          while (parent2.type === "paren" && !parent2.hasSlash) {
            parent2.hasSlash = true;
            parent2 = parent2.parent;
          }
          if (prev.addQmark) {
            val += "?";
          }
          if (node.rest.slice(0, 2) === "\\b") {
            return this.emit(val, node);
          }
          if (node.parsed === "**" || node.parsed === "./**") {
            this.output = "(?:" + this.output;
            return this.emit(val + ")?", node);
          }
          if (node.parsed === "!**" && this.options.nonegate !== true) {
            return this.emit(val + "?\\b", node);
          }
          return this.emit(val, node);
        }).set("bracket", function(node) {
          var close = node.close;
          var open2 = !node.escaped ? "[" : "\\[";
          var negated = node.negated;
          var inner = node.inner;
          var val = node.val;
          if (node.escaped === true) {
            inner = inner.replace(/\\?(\W)/g, "\\$1");
            negated = "";
          }
          if (inner === "]-") {
            inner = "\\]\\-";
          }
          if (negated && inner.indexOf(".") === -1) {
            inner += ".";
          }
          if (negated && inner.indexOf("/") === -1) {
            inner += "/";
          }
          val = open2 + negated + inner + close;
          return this.emit(val, node);
        }).set("square", function(node) {
          var val = (/^\W/.test(node.val) ? "\\" : "") + node.val;
          return this.emit(val, node);
        }).set("qmark", function(node) {
          var prev = this.prev();
          var val = "[^.\\\\/]";
          if (this.options.dot || prev.type !== "bos" && prev.type !== "slash") {
            val = "[^\\\\/]";
          }
          if (node.parsed.slice(-1) === "(") {
            var ch = node.rest.charAt(0);
            if (ch === "!" || ch === "=" || ch === ":") {
              return this.emit(node.val, node);
            }
          }
          if (node.val.length > 1) {
            val += "{" + node.val.length + "}";
          }
          return this.emit(val, node);
        }).set("plus", function(node) {
          var prev = node.parsed.slice(-1);
          if (prev === "]" || prev === ")") {
            return this.emit(node.val, node);
          }
          if (!this.output || /[?*+]/.test(ch) && node.parent.type !== "bracket") {
            return this.emit("\\+", node);
          }
          var ch = this.output.slice(-1);
          if (/\w/.test(ch) && !node.inside) {
            return this.emit("+\\+?", node);
          }
          return this.emit("+", node);
        }).set("globstar", function(node, nodes, i) {
          if (!this.output) {
            this.state.leadingGlobstar = true;
          }
          var prev = this.prev();
          var before2 = this.prev(2);
          var next = this.next();
          var after2 = this.next(2);
          var type = prev.type;
          var val = node.val;
          if (prev.type === "slash" && next.type === "slash") {
            if (before2.type === "text") {
              this.output += "?";
              if (after2.type !== "text") {
                this.output += "\\b";
              }
            }
          }
          var parsed = node.parsed;
          if (parsed.charAt(0) === "!") {
            parsed = parsed.slice(1);
          }
          var isInside = node.isInside.paren || node.isInside.brace;
          if (parsed && type !== "slash" && type !== "bos" && !isInside) {
            val = star();
          } else {
            val = this.options.dot !== true ? "(?:(?!(?:[" + slash() + "]|^)\\.).)*?" : "(?:(?!(?:[" + slash() + "]|^)(?:\\.{1,2})($|[" + slash() + "]))(?!\\.{2}).)*?";
          }
          if ((type === "slash" || type === "bos") && this.options.dot !== true) {
            val = "(?!\\.)" + val;
          }
          if (prev.type === "slash" && next.type === "slash" && before2.type !== "text") {
            if (after2.type === "text" || after2.type === "star") {
              node.addQmark = true;
            }
          }
          if (this.options.capture) {
            val = "(" + val + ")";
          }
          return this.emit(val, node);
        }).set("star", function(node, nodes, i) {
          var prior = nodes[i - 2] || {};
          var prev = this.prev();
          var next = this.next();
          var type = prev.type;
          function isStart(n) {
            return n.type === "bos" || n.type === "slash";
          }
          if (this.output === "" && this.options.contains !== true) {
            this.output = "(?![" + slash() + "])";
          }
          if (type === "bracket" && this.options.bash === false) {
            var str = next && next.type === "bracket" ? star() : "*?";
            if (!prev.nodes || prev.nodes[1].type !== "posix") {
              return this.emit(str, node);
            }
          }
          var prefix = !this.dotfiles && type !== "text" && type !== "escape" ? this.options.dot ? "(?!(?:^|[" + slash() + "])\\.{1,2}(?:$|[" + slash() + "]))" : "(?!\\.)" : "";
          if (isStart(prev) || isStart(prior) && type === "not") {
            if (prefix !== "(?!\\.)") {
              prefix += "(?!(\\.{2}|\\.[" + slash() + "]))(?=.)";
            } else {
              prefix += "(?=.)";
            }
          } else if (prefix === "(?!\\.)") {
            prefix = "";
          }
          if (prev.type === "not" && prior.type === "bos" && this.options.dot === true) {
            this.output = "(?!\\.)" + this.output;
          }
          var output = prefix + star();
          if (this.options.capture) {
            output = "(" + output + ")";
          }
          return this.emit(output, node);
        }).set("text", function(node) {
          return this.emit(node.val, node);
        }).set("eos", function(node) {
          var prev = this.prev();
          var val = node.val;
          this.output = "(?:\\.[" + slash() + "](?=.))?" + this.output;
          if (this.state.metachar && prev.type !== "qmark" && prev.type !== "slash") {
            val += this.options.contains ? "[" + slash() + "]?" : "(?:[" + slash() + "]|$)";
          }
          return this.emit(val, node);
        });
        if (options && typeof options.compilers === "function") {
          options.compilers(nanomatch.compiler);
        }
      };
    }
  });

  // ../../node_modules/.pnpm/nanomatch@1.2.13_supports-color@6.1.0/node_modules/nanomatch/lib/parsers.js
  var require_parsers = __commonJS({
    "../../node_modules/.pnpm/nanomatch@1.2.13_supports-color@6.1.0/node_modules/nanomatch/lib/parsers.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var regexNot = require_regex_not();
      var toRegex = require_to_regex();
      var cached;
      var NOT_REGEX = `[\\[!*+?$^"'.\\\\/]+`;
      var not = createTextRegex(NOT_REGEX);
      module2.exports = function(nanomatch, options) {
        var parser3 = nanomatch.parser;
        var opts = parser3.options;
        parser3.state = {
          slashes: 0,
          paths: []
        };
        parser3.ast.state = parser3.state;
        parser3.capture("prefix", function() {
          if (this.parsed)
            return;
          var m = this.match(/^\.[\\/]/);
          if (!m)
            return;
          this.state.strictOpen = !!this.options.strictOpen;
          this.state.addPrefix = true;
        }).capture("escape", function() {
          if (this.isInside("bracket"))
            return;
          var pos = this.position();
          var m = this.match(/^(?:\\(.)|([$^]))/);
          if (!m)
            return;
          return pos({
            type: "escape",
            val: m[2] || m[1]
          });
        }).capture("quoted", function() {
          var pos = this.position();
          var m = this.match(/^["']/);
          if (!m)
            return;
          var quote = m[0];
          if (this.input.indexOf(quote) === -1) {
            return pos({
              type: "escape",
              val: quote
            });
          }
          var tok = advanceTo(this.input, quote);
          this.consume(tok.len);
          return pos({
            type: "quoted",
            val: tok.esc
          });
        }).capture("not", function() {
          var parsed = this.parsed;
          var pos = this.position();
          var m = this.match(this.notRegex || /^!+/);
          if (!m)
            return;
          var val = m[0];
          var isNegated = val.length % 2 === 1;
          if (parsed === "" && !isNegated) {
            val = "";
          }
          if (parsed === "" && isNegated && this.options.nonegate !== true) {
            this.bos.val = "(?!^(?:";
            this.append = ")$).*";
            val = "";
          }
          return pos({
            type: "not",
            val
          });
        }).capture("dot", function() {
          var parsed = this.parsed;
          var pos = this.position();
          var m = this.match(/^\.+/);
          if (!m)
            return;
          var val = m[0];
          this.state.dot = val === "." && (parsed === "" || parsed.slice(-1) === "/");
          return pos({
            type: "dot",
            dotfiles: this.state.dot,
            val
          });
        }).capture("plus", /^\+(?!\()/).capture("qmark", function() {
          var parsed = this.parsed;
          var pos = this.position();
          var m = this.match(/^\?+(?!\()/);
          if (!m)
            return;
          this.state.metachar = true;
          this.state.qmark = true;
          return pos({
            type: "qmark",
            parsed,
            val: m[0]
          });
        }).capture("globstar", function() {
          var parsed = this.parsed;
          var pos = this.position();
          var m = this.match(/^\*{2}(?![*(])(?=[,)/]|$)/);
          if (!m)
            return;
          var type = opts.noglobstar !== true ? "globstar" : "star";
          var node = pos({ type, parsed });
          this.state.metachar = true;
          while (this.input.slice(0, 4) === "/**/") {
            this.input = this.input.slice(3);
          }
          node.isInside = {
            brace: this.isInside("brace"),
            paren: this.isInside("paren")
          };
          if (type === "globstar") {
            this.state.globstar = true;
            node.val = "**";
          } else {
            this.state.star = true;
            node.val = "*";
          }
          return node;
        }).capture("star", function() {
          var pos = this.position();
          var starRe = /^(?:\*(?![*(])|[*]{3,}(?!\()|[*]{2}(?![(/]|$)|\*(?=\*\())/;
          var m = this.match(starRe);
          if (!m)
            return;
          this.state.metachar = true;
          this.state.star = true;
          return pos({
            type: "star",
            val: m[0]
          });
        }).capture("slash", function() {
          var pos = this.position();
          var m = this.match(/^\//);
          if (!m)
            return;
          this.state.slashes++;
          return pos({
            type: "slash",
            val: m[0]
          });
        }).capture("backslash", function() {
          var pos = this.position();
          var m = this.match(/^\\(?![*+?(){}[\]'"])/);
          if (!m)
            return;
          var val = m[0];
          if (this.isInside("bracket")) {
            val = "\\";
          } else if (val.length > 1) {
            val = "\\\\";
          }
          return pos({
            type: "backslash",
            val
          });
        }).capture("square", function() {
          if (this.isInside("bracket"))
            return;
          var pos = this.position();
          var m = this.match(/^\[([^!^\\])\]/);
          if (!m)
            return;
          return pos({
            type: "square",
            val: m[1]
          });
        }).capture("bracket", function() {
          var pos = this.position();
          var m = this.match(/^(?:\[([!^]?)([^\]]+|\]-)(\]|[^*+?]+)|\[)/);
          if (!m)
            return;
          var val = m[0];
          var negated = m[1] ? "^" : "";
          var inner = (m[2] || "").replace(/\\\\+/, "\\\\");
          var close = m[3] || "";
          if (m[2] && inner.length < m[2].length) {
            val = val.replace(/\\\\+/, "\\\\");
          }
          var esc = this.input.slice(0, 2);
          if (inner === "" && esc === "\\]") {
            inner += esc;
            this.consume(2);
            var str = this.input;
            var idx = -1;
            var ch;
            while (ch = str[++idx]) {
              this.consume(1);
              if (ch === "]") {
                close = ch;
                break;
              }
              inner += ch;
            }
          }
          return pos({
            type: "bracket",
            val,
            escaped: close !== "]",
            negated,
            inner,
            close
          });
        }).capture("text", function() {
          if (this.isInside("bracket"))
            return;
          var pos = this.position();
          var m = this.match(not);
          if (!m || !m[0])
            return;
          return pos({
            type: "text",
            val: m[0]
          });
        });
        if (options && typeof options.parsers === "function") {
          options.parsers(nanomatch.parser);
        }
      };
      function advanceTo(input, endChar) {
        var ch = input.charAt(0);
        var tok = { len: 1, val: "", esc: "" };
        var idx = 0;
        function advance() {
          if (ch !== "\\") {
            tok.esc += "\\" + ch;
            tok.val += ch;
          }
          ch = input.charAt(++idx);
          tok.len++;
          if (ch === "\\") {
            advance();
            advance();
          }
        }
        while (ch && ch !== endChar) {
          advance();
        }
        return tok;
      }
      function createTextRegex(pattern) {
        if (cached)
          return cached;
        var opts = { contains: true, strictClose: false };
        var not2 = regexNot.create(pattern, opts);
        var re = toRegex("^(?:[*]\\((?=.)|" + not2 + ")", opts);
        return cached = re;
      }
      module2.exports.not = NOT_REGEX;
    }
  });

  // ../../node_modules/.pnpm/map-cache@0.2.2/node_modules/map-cache/index.js
  var require_map_cache = __commonJS({
    "../../node_modules/.pnpm/map-cache@0.2.2/node_modules/map-cache/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var hasOwn = Object.prototype.hasOwnProperty;
      module2.exports = MapCache2;
      function MapCache2(data) {
        this.__data__ = data || {};
      }
      MapCache2.prototype.set = function mapSet(key, value) {
        if (key !== "__proto__") {
          this.__data__[key] = value;
        }
        return this;
      };
      MapCache2.prototype.get = function mapGet(key) {
        return key === "__proto__" ? void 0 : this.__data__[key];
      };
      MapCache2.prototype.has = function mapHas(key) {
        return key !== "__proto__" && hasOwn.call(this.__data__, key);
      };
      MapCache2.prototype.del = function mapDelete(key) {
        return this.has(key) && delete this.__data__[key];
      };
    }
  });

  // ../../node_modules/.pnpm/fragment-cache@0.2.1/node_modules/fragment-cache/index.js
  var require_fragment_cache = __commonJS({
    "../../node_modules/.pnpm/fragment-cache@0.2.1/node_modules/fragment-cache/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var MapCache2 = require_map_cache();
      function FragmentCache(caches) {
        this.caches = caches || {};
      }
      FragmentCache.prototype = {
        cache: function(cacheName) {
          return this.caches[cacheName] || (this.caches[cacheName] = new MapCache2());
        },
        set: function(cacheName, key, val) {
          var cache = this.cache(cacheName);
          cache.set(key, val);
          return cache;
        },
        has: function(cacheName, key) {
          return typeof this.get(cacheName, key) !== "undefined";
        },
        get: function(name, key) {
          var cache = this.cache(name);
          if (typeof key === "string") {
            return cache.get(key);
          }
          return cache;
        }
      };
      exports8 = module2.exports = FragmentCache;
    }
  });

  // ../../node_modules/.pnpm/nanomatch@1.2.13_supports-color@6.1.0/node_modules/nanomatch/lib/cache.js
  var require_cache = __commonJS({
    "../../node_modules/.pnpm/nanomatch@1.2.13_supports-color@6.1.0/node_modules/nanomatch/lib/cache.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = new (require_fragment_cache())();
    }
  });

  // ../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/chunk-BlJi4mNy.js
  function dew5() {
    if (_dewExec5)
      return exports$14;
    _dewExec5 = true;
    var process$1 = process2;
    function assertPath(path) {
      if (typeof path !== "string") {
        throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
      }
    }
    function normalizeStringPosix(path, allowAboveRoot) {
      var res = "";
      var lastSegmentLength = 0;
      var lastSlash = -1;
      var dots = 0;
      var code;
      for (var i = 0; i <= path.length; ++i) {
        if (i < path.length)
          code = path.charCodeAt(i);
        else if (code === 47)
          break;
        else
          code = 47;
        if (code === 47) {
          if (lastSlash === i - 1 || dots === 1)
            ;
          else if (lastSlash !== i - 1 && dots === 2) {
            if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
              if (res.length > 2) {
                var lastSlashIndex = res.lastIndexOf("/");
                if (lastSlashIndex !== res.length - 1) {
                  if (lastSlashIndex === -1) {
                    res = "";
                    lastSegmentLength = 0;
                  } else {
                    res = res.slice(0, lastSlashIndex);
                    lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                  }
                  lastSlash = i;
                  dots = 0;
                  continue;
                }
              } else if (res.length === 2 || res.length === 1) {
                res = "";
                lastSegmentLength = 0;
                lastSlash = i;
                dots = 0;
                continue;
              }
            }
            if (allowAboveRoot) {
              if (res.length > 0)
                res += "/..";
              else
                res = "..";
              lastSegmentLength = 2;
            }
          } else {
            if (res.length > 0)
              res += "/" + path.slice(lastSlash + 1, i);
            else
              res = path.slice(lastSlash + 1, i);
            lastSegmentLength = i - lastSlash - 1;
          }
          lastSlash = i;
          dots = 0;
        } else if (code === 46 && dots !== -1) {
          ++dots;
        } else {
          dots = -1;
        }
      }
      return res;
    }
    function _format(sep2, pathObject) {
      var dir = pathObject.dir || pathObject.root;
      var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
      if (!dir) {
        return base;
      }
      if (dir === pathObject.root) {
        return dir + base;
      }
      return dir + sep2 + base;
    }
    var posix2 = {
      resolve: function resolve2() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd3;
        for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
          var path;
          if (i >= 0)
            path = arguments[i];
          else {
            if (cwd3 === void 0)
              cwd3 = process$1.cwd();
            path = cwd3;
          }
          assertPath(path);
          if (path.length === 0) {
            continue;
          }
          resolvedPath = path + "/" + resolvedPath;
          resolvedAbsolute = path.charCodeAt(0) === 47;
        }
        resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
          if (resolvedPath.length > 0)
            return "/" + resolvedPath;
          else
            return "/";
        } else if (resolvedPath.length > 0) {
          return resolvedPath;
        } else {
          return ".";
        }
      },
      normalize: function normalize2(path) {
        assertPath(path);
        if (path.length === 0)
          return ".";
        var isAbsolute2 = path.charCodeAt(0) === 47;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47;
        path = normalizeStringPosix(path, !isAbsolute2);
        if (path.length === 0 && !isAbsolute2)
          path = ".";
        if (path.length > 0 && trailingSeparator)
          path += "/";
        if (isAbsolute2)
          return "/" + path;
        return path;
      },
      isAbsolute: function isAbsolute2(path) {
        assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47;
      },
      join: function join3() {
        if (arguments.length === 0)
          return ".";
        var joined;
        for (var i = 0; i < arguments.length; ++i) {
          var arg = arguments[i];
          assertPath(arg);
          if (arg.length > 0) {
            if (joined === void 0)
              joined = arg;
            else
              joined += "/" + arg;
          }
        }
        if (joined === void 0)
          return ".";
        return posix2.normalize(joined);
      },
      relative: function relative2(from, to) {
        assertPath(from);
        assertPath(to);
        if (from === to)
          return "";
        from = posix2.resolve(from);
        to = posix2.resolve(to);
        if (from === to)
          return "";
        var fromStart = 1;
        for (; fromStart < from.length; ++fromStart) {
          if (from.charCodeAt(fromStart) !== 47)
            break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        var toStart = 1;
        for (; toStart < to.length; ++toStart) {
          if (to.charCodeAt(toStart) !== 47)
            break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for (; i <= length; ++i) {
          if (i === length) {
            if (toLen > length) {
              if (to.charCodeAt(toStart + i) === 47) {
                return to.slice(toStart + i + 1);
              } else if (i === 0) {
                return to.slice(toStart + i);
              }
            } else if (fromLen > length) {
              if (from.charCodeAt(fromStart + i) === 47) {
                lastCommonSep = i;
              } else if (i === 0) {
                lastCommonSep = 0;
              }
            }
            break;
          }
          var fromCode = from.charCodeAt(fromStart + i);
          var toCode = to.charCodeAt(toStart + i);
          if (fromCode !== toCode)
            break;
          else if (fromCode === 47)
            lastCommonSep = i;
        }
        var out = "";
        for (i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i) {
          if (i === fromEnd || from.charCodeAt(i) === 47) {
            if (out.length === 0)
              out += "..";
            else
              out += "/..";
          }
        }
        if (out.length > 0)
          return out + to.slice(toStart + lastCommonSep);
        else {
          toStart += lastCommonSep;
          if (to.charCodeAt(toStart) === 47)
            ++toStart;
          return to.slice(toStart);
        }
      },
      _makeLong: function _makeLong2(path) {
        return path;
      },
      dirname: function dirname2(path) {
        assertPath(path);
        if (path.length === 0)
          return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47;
        var end = -1;
        var matchedSlash = true;
        for (var i = path.length - 1; i >= 1; --i) {
          code = path.charCodeAt(i);
          if (code === 47) {
            if (!matchedSlash) {
              end = i;
              break;
            }
          } else {
            matchedSlash = false;
          }
        }
        if (end === -1)
          return hasRoot ? "/" : ".";
        if (hasRoot && end === 1)
          return "//";
        return path.slice(0, end);
      },
      basename: function basename2(path, ext) {
        if (ext !== void 0 && typeof ext !== "string")
          throw new TypeError('"ext" argument must be a string');
        assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== void 0 && ext.length > 0 && ext.length <= path.length) {
          if (ext.length === path.length && ext === path)
            return "";
          var extIdx = ext.length - 1;
          var firstNonSlashEnd = -1;
          for (i = path.length - 1; i >= 0; --i) {
            var code = path.charCodeAt(i);
            if (code === 47) {
              if (!matchedSlash) {
                start = i + 1;
                break;
              }
            } else {
              if (firstNonSlashEnd === -1) {
                matchedSlash = false;
                firstNonSlashEnd = i + 1;
              }
              if (extIdx >= 0) {
                if (code === ext.charCodeAt(extIdx)) {
                  if (--extIdx === -1) {
                    end = i;
                  }
                } else {
                  extIdx = -1;
                  end = firstNonSlashEnd;
                }
              }
            }
          }
          if (start === end)
            end = firstNonSlashEnd;
          else if (end === -1)
            end = path.length;
          return path.slice(start, end);
        } else {
          for (i = path.length - 1; i >= 0; --i) {
            if (path.charCodeAt(i) === 47) {
              if (!matchedSlash) {
                start = i + 1;
                break;
              }
            } else if (end === -1) {
              matchedSlash = false;
              end = i + 1;
            }
          }
          if (end === -1)
            return "";
          return path.slice(start, end);
        }
      },
      extname: function extname2(path) {
        assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var preDotState = 0;
        for (var i = path.length - 1; i >= 0; --i) {
          var code = path.charCodeAt(i);
          if (code === 47) {
            if (!matchedSlash) {
              startPart = i + 1;
              break;
            }
            continue;
          }
          if (end === -1) {
            matchedSlash = false;
            end = i + 1;
          }
          if (code === 46) {
            if (startDot === -1)
              startDot = i;
            else if (preDotState !== 1)
              preDotState = 1;
          } else if (startDot !== -1) {
            preDotState = -1;
          }
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
          return "";
        }
        return path.slice(startDot, end);
      },
      format: function format3(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") {
          throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        }
        return _format("/", pathObject);
      },
      parse: function parse4(path) {
        assertPath(path);
        var ret = {
          root: "",
          dir: "",
          base: "",
          ext: "",
          name: ""
        };
        if (path.length === 0)
          return ret;
        var code = path.charCodeAt(0);
        var isAbsolute2 = code === 47;
        var start;
        if (isAbsolute2) {
          ret.root = "/";
          start = 1;
        } else {
          start = 0;
        }
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        var preDotState = 0;
        for (; i >= start; --i) {
          code = path.charCodeAt(i);
          if (code === 47) {
            if (!matchedSlash) {
              startPart = i + 1;
              break;
            }
            continue;
          }
          if (end === -1) {
            matchedSlash = false;
            end = i + 1;
          }
          if (code === 46) {
            if (startDot === -1)
              startDot = i;
            else if (preDotState !== 1)
              preDotState = 1;
          } else if (startDot !== -1) {
            preDotState = -1;
          }
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
          if (end !== -1) {
            if (startPart === 0 && isAbsolute2)
              ret.base = ret.name = path.slice(1, end);
            else
              ret.base = ret.name = path.slice(startPart, end);
          }
        } else {
          if (startPart === 0 && isAbsolute2) {
            ret.name = path.slice(1, startDot);
            ret.base = path.slice(1, end);
          } else {
            ret.name = path.slice(startPart, startDot);
            ret.base = path.slice(startPart, end);
          }
          ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0)
          ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute2)
          ret.dir = "/";
        return ret;
      },
      sep: "/",
      delimiter: ":",
      win32: null,
      posix: null
    };
    posix2.posix = posix2;
    exports$14 = posix2;
    return exports$14;
  }
  var exports$14, _dewExec5, exports7;
  var init_chunk_BlJi4mNy = __esm({
    "../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/chunk-BlJi4mNy.js"() {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      init_chunk_DEMDiNwt();
      exports$14 = {};
      _dewExec5 = false;
      exports7 = dew5();
    }
  });

  // ../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/path.js
  var path_exports = {};
  __export(path_exports, {
    _makeLong: () => _makeLong,
    basename: () => basename,
    default: () => exports7,
    delimiter: () => delimiter,
    dirname: () => dirname,
    extname: () => extname,
    format: () => format2,
    isAbsolute: () => isAbsolute,
    join: () => join2,
    normalize: () => normalize,
    parse: () => parse,
    posix: () => posix,
    relative: () => relative,
    resolve: () => resolve,
    sep: () => sep,
    win32: () => win32
  });
  var _makeLong, basename, delimiter, dirname, extname, format2, isAbsolute, join2, normalize, parse, posix, relative, resolve, sep, win32;
  var init_path = __esm({
    "../../node_modules/.pnpm/@jspm+core@2.1.0/node_modules/@jspm/core/nodelibs/browser/path.js"() {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      init_chunk_BlJi4mNy();
      init_chunk_DEMDiNwt();
      _makeLong = exports7._makeLong;
      basename = exports7.basename;
      delimiter = exports7.delimiter;
      dirname = exports7.dirname;
      extname = exports7.extname;
      format2 = exports7.format;
      isAbsolute = exports7.isAbsolute;
      join2 = exports7.join;
      normalize = exports7.normalize;
      parse = exports7.parse;
      posix = exports7.posix;
      relative = exports7.relative;
      resolve = exports7.resolve;
      sep = exports7.sep;
      win32 = exports7.win32;
    }
  });

  // ../../node_modules/.pnpm/is-windows@1.0.2/node_modules/is-windows/index.js
  var require_is_windows = __commonJS({
    "../../node_modules/.pnpm/is-windows@1.0.2/node_modules/is-windows/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      (function(factory2) {
        if (exports8 && typeof exports8 === "object" && typeof module2 !== "undefined") {
          module2.exports = factory2();
        } else if (typeof define === "function" && define.amd) {
          define([], factory2);
        } else if (typeof window !== "undefined") {
          window.isWindows = factory2();
        } else if (typeof global !== "undefined") {
          global.isWindows = factory2();
        } else if (typeof self !== "undefined") {
          self.isWindows = factory2();
        } else {
          this.isWindows = factory2();
        }
      })(function() {
        "use strict";
        return function isWindows() {
          return define_process_default && (define_process_default.platform === "win32" || /^(msys|cygwin)$/.test(define_process_default.env.OSTYPE));
        };
      });
    }
  });

  // ../../node_modules/.pnpm/define-property@1.0.0/node_modules/define-property/index.js
  var require_define_property2 = __commonJS({
    "../../node_modules/.pnpm/define-property@1.0.0/node_modules/define-property/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isDescriptor = require_is_descriptor();
      module2.exports = function defineProperty2(obj, prop, val) {
        if (typeof obj !== "object" && typeof obj !== "function") {
          throw new TypeError("expected an object or function.");
        }
        if (typeof prop !== "string") {
          throw new TypeError("expected `prop` to be a string.");
        }
        if (isDescriptor(val) && ("set" in val || "get" in val)) {
          return Object.defineProperty(obj, prop, val);
        }
        return Object.defineProperty(obj, prop, {
          configurable: true,
          enumerable: false,
          writable: true,
          value: val
        });
      };
    }
  });

  // ../../node_modules/.pnpm/component-emitter@1.3.1/node_modules/component-emitter/index.js
  var require_component_emitter = __commonJS({
    "../../node_modules/.pnpm/component-emitter@1.3.1/node_modules/component-emitter/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      if (typeof module2 !== "undefined") {
        module2.exports = Emitter;
      }
      function Emitter(obj) {
        if (obj)
          return mixin3(obj);
      }
      function mixin3(obj) {
        for (var key in Emitter.prototype) {
          obj[key] = Emitter.prototype[key];
        }
        return obj;
      }
      Emitter.prototype.on = Emitter.prototype.addEventListener = function(event, fn) {
        this._callbacks = this._callbacks || {};
        (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
        return this;
      };
      Emitter.prototype.once = function(event, fn) {
        function on3() {
          this.off(event, on3);
          fn.apply(this, arguments);
        }
        on3.fn = fn;
        this.on(event, on3);
        return this;
      };
      Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function(event, fn) {
        this._callbacks = this._callbacks || {};
        if (0 == arguments.length) {
          this._callbacks = {};
          return this;
        }
        var callbacks = this._callbacks["$" + event];
        if (!callbacks)
          return this;
        if (1 == arguments.length) {
          delete this._callbacks["$" + event];
          return this;
        }
        var cb;
        for (var i = 0; i < callbacks.length; i++) {
          cb = callbacks[i];
          if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
          }
        }
        if (callbacks.length === 0) {
          delete this._callbacks["$" + event];
        }
        return this;
      };
      Emitter.prototype.emit = function(event) {
        this._callbacks = this._callbacks || {};
        var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
        for (var i = 1; i < arguments.length; i++) {
          args[i - 1] = arguments[i];
        }
        if (callbacks) {
          callbacks = callbacks.slice(0);
          for (var i = 0, len = callbacks.length; i < len; ++i) {
            callbacks[i].apply(this, args);
          }
        }
        return this;
      };
      Emitter.prototype.listeners = function(event) {
        this._callbacks = this._callbacks || {};
        return this._callbacks["$" + event] || [];
      };
      Emitter.prototype.hasListeners = function(event) {
        return !!this.listeners(event).length;
      };
    }
  });

  // ../../node_modules/.pnpm/object-visit@1.0.1/node_modules/object-visit/index.js
  var require_object_visit = __commonJS({
    "../../node_modules/.pnpm/object-visit@1.0.1/node_modules/object-visit/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isObject5 = require_isobject();
      module2.exports = function visit(thisArg, method2, target, val) {
        if (!isObject5(thisArg) && typeof thisArg !== "function") {
          throw new Error("object-visit expects `thisArg` to be an object.");
        }
        if (typeof method2 !== "string") {
          throw new Error("object-visit expects `method` name to be a string");
        }
        if (typeof thisArg[method2] !== "function") {
          return thisArg;
        }
        var args = [].slice.call(arguments, 3);
        target = target || {};
        for (var key in target) {
          var arr = [key, target[key]].concat(args);
          thisArg[method2].apply(thisArg, arr);
        }
        return thisArg;
      };
    }
  });

  // ../../node_modules/.pnpm/map-visit@1.0.0/node_modules/map-visit/index.js
  var require_map_visit = __commonJS({
    "../../node_modules/.pnpm/map-visit@1.0.0/node_modules/map-visit/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var util = (init_util(), __toCommonJS(util_exports));
      var visit = require_object_visit();
      module2.exports = function mapVisit(collection, method2, val) {
        if (isObject5(val)) {
          return visit.apply(null, arguments);
        }
        if (!Array.isArray(val)) {
          throw new TypeError("expected an array: " + util.inspect(val));
        }
        var args = [].slice.call(arguments, 3);
        for (var i = 0; i < val.length; i++) {
          var ele = val[i];
          if (isObject5(ele)) {
            visit.apply(null, [collection, method2, ele].concat(args));
          } else {
            collection[method2].apply(collection, [ele].concat(args));
          }
        }
      };
      function isObject5(val) {
        return val && (typeof val === "function" || !Array.isArray(val) && typeof val === "object");
      }
    }
  });

  // ../../node_modules/.pnpm/collection-visit@1.0.0/node_modules/collection-visit/index.js
  var require_collection_visit = __commonJS({
    "../../node_modules/.pnpm/collection-visit@1.0.0/node_modules/collection-visit/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var visit = require_object_visit();
      var mapVisit = require_map_visit();
      module2.exports = function(collection, method2, val) {
        var result2;
        if (typeof val === "string" && method2 in collection) {
          var args = [].slice.call(arguments, 2);
          result2 = collection[method2].apply(collection, args);
        } else if (Array.isArray(val)) {
          result2 = mapVisit.apply(null, arguments);
        } else {
          result2 = visit.apply(null, arguments);
        }
        if (typeof result2 !== "undefined") {
          return result2;
        }
        return collection;
      };
    }
  });

  // ../../node_modules/.pnpm/is-buffer@1.1.6/node_modules/is-buffer/index.js
  var require_is_buffer = __commonJS({
    "../../node_modules/.pnpm/is-buffer@1.1.6/node_modules/is-buffer/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = function(obj) {
        return obj != null && (isBuffer3(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
      };
      function isBuffer3(obj) {
        return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
      }
      function isSlowBuffer(obj) {
        return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isBuffer3(obj.slice(0, 0));
      }
    }
  });

  // ../../node_modules/.pnpm/kind-of@3.2.2/node_modules/kind-of/index.js
  var require_kind_of = __commonJS({
    "../../node_modules/.pnpm/kind-of@3.2.2/node_modules/kind-of/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isBuffer3 = require_is_buffer();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (typeof val === "undefined") {
          return "undefined";
        }
        if (val === null) {
          return "null";
        }
        if (val === true || val === false || val instanceof Boolean) {
          return "boolean";
        }
        if (typeof val === "string" || val instanceof String) {
          return "string";
        }
        if (typeof val === "number" || val instanceof Number) {
          return "number";
        }
        if (typeof val === "function" || val instanceof Function) {
          return "function";
        }
        if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
          return "array";
        }
        if (val instanceof RegExp) {
          return "regexp";
        }
        if (val instanceof Date) {
          return "date";
        }
        var type = toString2.call(val);
        if (type === "[object RegExp]") {
          return "regexp";
        }
        if (type === "[object Date]") {
          return "date";
        }
        if (type === "[object Arguments]") {
          return "arguments";
        }
        if (type === "[object Error]") {
          return "error";
        }
        if (isBuffer3(val)) {
          return "buffer";
        }
        if (type === "[object Set]") {
          return "set";
        }
        if (type === "[object WeakSet]") {
          return "weakset";
        }
        if (type === "[object Map]") {
          return "map";
        }
        if (type === "[object WeakMap]") {
          return "weakmap";
        }
        if (type === "[object Symbol]") {
          return "symbol";
        }
        if (type === "[object Int8Array]") {
          return "int8array";
        }
        if (type === "[object Uint8Array]") {
          return "uint8array";
        }
        if (type === "[object Uint8ClampedArray]") {
          return "uint8clampedarray";
        }
        if (type === "[object Int16Array]") {
          return "int16array";
        }
        if (type === "[object Uint16Array]") {
          return "uint16array";
        }
        if (type === "[object Int32Array]") {
          return "int32array";
        }
        if (type === "[object Uint32Array]") {
          return "uint32array";
        }
        if (type === "[object Float32Array]") {
          return "float32array";
        }
        if (type === "[object Float64Array]") {
          return "float64array";
        }
        return "object";
      };
    }
  });

  // ../../node_modules/.pnpm/to-object-path@0.3.0/node_modules/to-object-path/index.js
  var require_to_object_path = __commonJS({
    "../../node_modules/.pnpm/to-object-path@0.3.0/node_modules/to-object-path/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var typeOf = require_kind_of();
      module2.exports = function toPath2(args) {
        if (typeOf(args) !== "arguments") {
          args = arguments;
        }
        return filter2(args).join(".");
      };
      function filter2(arr) {
        var len = arr.length;
        var idx = -1;
        var res = [];
        while (++idx < len) {
          var ele = arr[idx];
          if (typeOf(ele) === "arguments" || Array.isArray(ele)) {
            res.push.apply(res, filter2(ele));
          } else if (typeof ele === "string") {
            res.push(ele);
          }
        }
        return res;
      }
    }
  });

  // ../../node_modules/.pnpm/is-extendable@0.1.1/node_modules/is-extendable/index.js
  var require_is_extendable2 = __commonJS({
    "../../node_modules/.pnpm/is-extendable@0.1.1/node_modules/is-extendable/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = function isExtendable(val) {
        return typeof val !== "undefined" && val !== null && (typeof val === "object" || typeof val === "function");
      };
    }
  });

  // ../../node_modules/.pnpm/arr-union@3.1.0/node_modules/arr-union/index.js
  var require_arr_union = __commonJS({
    "../../node_modules/.pnpm/arr-union@3.1.0/node_modules/arr-union/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = function union2(init) {
        if (!Array.isArray(init)) {
          throw new TypeError("arr-union expects the first argument to be an array.");
        }
        var len = arguments.length;
        var i = 0;
        while (++i < len) {
          var arg = arguments[i];
          if (!arg)
            continue;
          if (!Array.isArray(arg)) {
            arg = [arg];
          }
          for (var j = 0; j < arg.length; j++) {
            var ele = arg[j];
            if (init.indexOf(ele) >= 0) {
              continue;
            }
            init.push(ele);
          }
        }
        return init;
      };
    }
  });

  // ../../node_modules/.pnpm/get-value@2.0.6/node_modules/get-value/index.js
  var require_get_value = __commonJS({
    "../../node_modules/.pnpm/get-value@2.0.6/node_modules/get-value/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = function(obj, prop, a, b, c) {
        if (!isObject5(obj) || !prop) {
          return obj;
        }
        prop = toString2(prop);
        if (a)
          prop += "." + toString2(a);
        if (b)
          prop += "." + toString2(b);
        if (c)
          prop += "." + toString2(c);
        if (prop in obj) {
          return obj[prop];
        }
        var segs = prop.split(".");
        var len = segs.length;
        var i = -1;
        while (obj && ++i < len) {
          var key = segs[i];
          while (key[key.length - 1] === "\\") {
            key = key.slice(0, -1) + "." + segs[++i];
          }
          obj = obj[key];
        }
        return obj;
      };
      function isObject5(val) {
        return val !== null && (typeof val === "object" || typeof val === "function");
      }
      function toString2(val) {
        if (!val)
          return "";
        if (Array.isArray(val)) {
          return val.join(".");
        }
        return val;
      }
    }
  });

  // ../../node_modules/.pnpm/split-string@3.1.0/node_modules/split-string/index.js
  var require_split_string = __commonJS({
    "../../node_modules/.pnpm/split-string@3.1.0/node_modules/split-string/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var extend = require_extend_shallow();
      module2.exports = function(str, options, fn) {
        if (typeof str !== "string") {
          throw new TypeError("expected a string");
        }
        if (typeof options === "function") {
          fn = options;
          options = null;
        }
        if (typeof options === "string") {
          options = { sep: options };
        }
        var opts = extend({ sep: "." }, options);
        var quotes = opts.quotes || ['"', "'", "`"];
        var brackets;
        if (opts.brackets === true) {
          brackets = {
            "<": ">",
            "(": ")",
            "[": "]",
            "{": "}"
          };
        } else if (opts.brackets) {
          brackets = opts.brackets;
        }
        var tokens = [];
        var stack = [];
        var arr = [""];
        var sep2 = opts.sep;
        var len = str.length;
        var idx = -1;
        var closeIdx;
        function expected() {
          if (brackets && stack.length) {
            return brackets[stack[stack.length - 1]];
          }
        }
        while (++idx < len) {
          var ch = str[idx];
          var next = str[idx + 1];
          var tok = { val: ch, idx, arr, str };
          tokens.push(tok);
          if (ch === "\\") {
            tok.val = keepEscaping(opts, str, idx) === true ? ch + next : next;
            tok.escaped = true;
            if (typeof fn === "function") {
              fn(tok);
            }
            arr[arr.length - 1] += tok.val;
            idx++;
            continue;
          }
          if (brackets && brackets[ch]) {
            stack.push(ch);
            var e = expected();
            var i = idx + 1;
            if (str.indexOf(e, i + 1) !== -1) {
              while (stack.length && i < len) {
                var s = str[++i];
                if (s === "\\") {
                  s++;
                  continue;
                }
                if (quotes.indexOf(s) !== -1) {
                  i = getClosingQuote(str, s, i + 1);
                  continue;
                }
                e = expected();
                if (stack.length && str.indexOf(e, i + 1) === -1) {
                  break;
                }
                if (brackets[s]) {
                  stack.push(s);
                  continue;
                }
                if (e === s) {
                  stack.pop();
                }
              }
            }
            closeIdx = i;
            if (closeIdx === -1) {
              arr[arr.length - 1] += ch;
              continue;
            }
            ch = str.slice(idx, closeIdx + 1);
            tok.val = ch;
            tok.idx = idx = closeIdx;
          }
          if (quotes.indexOf(ch) !== -1) {
            closeIdx = getClosingQuote(str, ch, idx + 1);
            if (closeIdx === -1) {
              arr[arr.length - 1] += ch;
              continue;
            }
            if (keepQuotes(ch, opts) === true) {
              ch = str.slice(idx, closeIdx + 1);
            } else {
              ch = str.slice(idx + 1, closeIdx);
            }
            tok.val = ch;
            tok.idx = idx = closeIdx;
          }
          if (typeof fn === "function") {
            fn(tok, tokens);
            ch = tok.val;
            idx = tok.idx;
          }
          if (tok.val === sep2 && tok.split !== false) {
            arr.push("");
            continue;
          }
          arr[arr.length - 1] += tok.val;
        }
        return arr;
      };
      function getClosingQuote(str, ch, i, brackets) {
        var idx = str.indexOf(ch, i);
        if (str.charAt(idx - 1) === "\\") {
          return getClosingQuote(str, ch, idx + 1);
        }
        return idx;
      }
      function keepQuotes(ch, opts) {
        if (opts.keepDoubleQuotes === true && ch === '"')
          return true;
        if (opts.keepSingleQuotes === true && ch === "'")
          return true;
        return opts.keepQuotes;
      }
      function keepEscaping(opts, str, idx) {
        if (typeof opts.keepEscaping === "function") {
          return opts.keepEscaping(str, idx);
        }
        return opts.keepEscaping === true || str[idx + 1] === "\\";
      }
    }
  });

  // ../../node_modules/.pnpm/extend-shallow@2.0.1/node_modules/extend-shallow/index.js
  var require_extend_shallow2 = __commonJS({
    "../../node_modules/.pnpm/extend-shallow@2.0.1/node_modules/extend-shallow/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isObject5 = require_is_extendable2();
      module2.exports = function extend(o) {
        if (!isObject5(o)) {
          o = {};
        }
        var len = arguments.length;
        for (var i = 1; i < len; i++) {
          var obj = arguments[i];
          if (isObject5(obj)) {
            assign2(o, obj);
          }
        }
        return o;
      };
      function assign2(a, b) {
        for (var key in b) {
          if (hasOwn(b, key)) {
            a[key] = b[key];
          }
        }
      }
      function hasOwn(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
      }
    }
  });

  // ../../node_modules/.pnpm/set-value@2.0.1/node_modules/set-value/index.js
  var require_set_value = __commonJS({
    "../../node_modules/.pnpm/set-value@2.0.1/node_modules/set-value/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var split2 = require_split_string();
      var extend = require_extend_shallow2();
      var isPlainObject3 = require_is_plain_object();
      var isObject5 = require_is_extendable2();
      module2.exports = function(obj, prop, val) {
        if (!isObject5(obj)) {
          return obj;
        }
        if (Array.isArray(prop)) {
          prop = [].concat.apply([], prop).join(".");
        }
        if (typeof prop !== "string") {
          return obj;
        }
        var keys2 = split2(prop, { sep: ".", brackets: true }).filter(isValidKey);
        var len = keys2.length;
        var idx = -1;
        var current = obj;
        while (++idx < len) {
          var key = keys2[idx];
          if (idx !== len - 1) {
            if (!isObject5(current[key])) {
              current[key] = {};
            }
            current = current[key];
            continue;
          }
          if (isPlainObject3(current[key]) && isPlainObject3(val)) {
            current[key] = extend({}, current[key], val);
          } else {
            current[key] = val;
          }
        }
        return obj;
      };
      function isValidKey(key) {
        return key !== "__proto__" && key !== "constructor" && key !== "prototype";
      }
    }
  });

  // ../../node_modules/.pnpm/union-value@1.0.1/node_modules/union-value/index.js
  var require_union_value = __commonJS({
    "../../node_modules/.pnpm/union-value@1.0.1/node_modules/union-value/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isObject5 = require_is_extendable2();
      var union2 = require_arr_union();
      var get2 = require_get_value();
      var set2 = require_set_value();
      module2.exports = function unionValue(obj, prop, value) {
        if (!isObject5(obj)) {
          throw new TypeError("union-value expects the first argument to be an object.");
        }
        if (typeof prop !== "string") {
          throw new TypeError("union-value expects `prop` to be a string.");
        }
        var arr = arrayify(get2(obj, prop));
        set2(obj, prop, union2(arr, arrayify(value)));
        return obj;
      };
      function arrayify(val) {
        if (val === null || typeof val === "undefined") {
          return [];
        }
        if (Array.isArray(val)) {
          return val;
        }
        return [val];
      }
    }
  });

  // ../../node_modules/.pnpm/isarray@1.0.0/node_modules/isarray/index.js
  var require_isarray = __commonJS({
    "../../node_modules/.pnpm/isarray@1.0.0/node_modules/isarray/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var toString2 = {}.toString;
      module2.exports = Array.isArray || function(arr) {
        return toString2.call(arr) == "[object Array]";
      };
    }
  });

  // ../../node_modules/.pnpm/isobject@2.1.0/node_modules/isobject/index.js
  var require_isobject2 = __commonJS({
    "../../node_modules/.pnpm/isobject@2.1.0/node_modules/isobject/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isArray3 = require_isarray();
      module2.exports = function isObject5(val) {
        return val != null && typeof val === "object" && isArray3(val) === false;
      };
    }
  });

  // ../../node_modules/.pnpm/has-values@0.1.4/node_modules/has-values/index.js
  var require_has_values = __commonJS({
    "../../node_modules/.pnpm/has-values@0.1.4/node_modules/has-values/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = function hasValue(o, noZero) {
        if (o === null || o === void 0) {
          return false;
        }
        if (typeof o === "boolean") {
          return true;
        }
        if (typeof o === "number") {
          if (o === 0 && noZero === true) {
            return false;
          }
          return true;
        }
        if (o.length !== void 0) {
          return o.length !== 0;
        }
        for (var key in o) {
          if (o.hasOwnProperty(key)) {
            return true;
          }
        }
        return false;
      };
    }
  });

  // ../../node_modules/.pnpm/has-value@0.3.1/node_modules/has-value/index.js
  var require_has_value = __commonJS({
    "../../node_modules/.pnpm/has-value@0.3.1/node_modules/has-value/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isObject5 = require_isobject2();
      var hasValues = require_has_values();
      var get2 = require_get_value();
      module2.exports = function(obj, prop, noZero) {
        if (isObject5(obj)) {
          return hasValues(get2(obj, prop), noZero);
        }
        return hasValues(obj, prop);
      };
    }
  });

  // ../../node_modules/.pnpm/unset-value@1.0.0/node_modules/unset-value/index.js
  var require_unset_value = __commonJS({
    "../../node_modules/.pnpm/unset-value@1.0.0/node_modules/unset-value/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isObject5 = require_isobject();
      var has2 = require_has_value();
      module2.exports = function unset2(obj, prop) {
        if (!isObject5(obj)) {
          throw new TypeError("expected an object.");
        }
        if (obj.hasOwnProperty(prop)) {
          delete obj[prop];
          return true;
        }
        if (has2(obj, prop)) {
          var segs = prop.split(".");
          var last2 = segs.pop();
          while (segs.length && segs[segs.length - 1].slice(-1) === "\\") {
            last2 = segs.pop().slice(0, -1) + "." + last2;
          }
          while (segs.length)
            obj = obj[prop = segs.shift()];
          return delete obj[last2];
        }
        return true;
      };
    }
  });

  // ../../node_modules/.pnpm/kind-of@4.0.0/node_modules/kind-of/index.js
  var require_kind_of2 = __commonJS({
    "../../node_modules/.pnpm/kind-of@4.0.0/node_modules/kind-of/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isBuffer3 = require_is_buffer();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (typeof val === "undefined") {
          return "undefined";
        }
        if (val === null) {
          return "null";
        }
        if (val === true || val === false || val instanceof Boolean) {
          return "boolean";
        }
        if (typeof val === "string" || val instanceof String) {
          return "string";
        }
        if (typeof val === "number" || val instanceof Number) {
          return "number";
        }
        if (typeof val === "function" || val instanceof Function) {
          return "function";
        }
        if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
          return "array";
        }
        if (val instanceof RegExp) {
          return "regexp";
        }
        if (val instanceof Date) {
          return "date";
        }
        var type = toString2.call(val);
        if (type === "[object RegExp]") {
          return "regexp";
        }
        if (type === "[object Date]") {
          return "date";
        }
        if (type === "[object Arguments]") {
          return "arguments";
        }
        if (type === "[object Error]") {
          return "error";
        }
        if (type === "[object Promise]") {
          return "promise";
        }
        if (isBuffer3(val)) {
          return "buffer";
        }
        if (type === "[object Set]") {
          return "set";
        }
        if (type === "[object WeakSet]") {
          return "weakset";
        }
        if (type === "[object Map]") {
          return "map";
        }
        if (type === "[object WeakMap]") {
          return "weakmap";
        }
        if (type === "[object Symbol]") {
          return "symbol";
        }
        if (type === "[object Int8Array]") {
          return "int8array";
        }
        if (type === "[object Uint8Array]") {
          return "uint8array";
        }
        if (type === "[object Uint8ClampedArray]") {
          return "uint8clampedarray";
        }
        if (type === "[object Int16Array]") {
          return "int16array";
        }
        if (type === "[object Uint16Array]") {
          return "uint16array";
        }
        if (type === "[object Int32Array]") {
          return "int32array";
        }
        if (type === "[object Uint32Array]") {
          return "uint32array";
        }
        if (type === "[object Float32Array]") {
          return "float32array";
        }
        if (type === "[object Float64Array]") {
          return "float64array";
        }
        return "object";
      };
    }
  });

  // ../../node_modules/.pnpm/is-number@3.0.0/node_modules/is-number/index.js
  var require_is_number = __commonJS({
    "../../node_modules/.pnpm/is-number@3.0.0/node_modules/is-number/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var typeOf = require_kind_of();
      module2.exports = function isNumber3(num) {
        var type = typeOf(num);
        if (type === "string") {
          if (!num.trim())
            return false;
        } else if (type !== "number") {
          return false;
        }
        return num - num + 1 >= 0;
      };
    }
  });

  // ../../node_modules/.pnpm/has-values@1.0.0/node_modules/has-values/index.js
  var require_has_values2 = __commonJS({
    "../../node_modules/.pnpm/has-values@1.0.0/node_modules/has-values/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var typeOf = require_kind_of2();
      var isNumber3 = require_is_number();
      module2.exports = function hasValue(val) {
        if (isNumber3(val)) {
          return true;
        }
        switch (typeOf(val)) {
          case "null":
          case "boolean":
          case "function":
            return true;
          case "string":
          case "arguments":
            return val.length !== 0;
          case "error":
            return val.message !== "";
          case "array":
            var len = val.length;
            if (len === 0) {
              return false;
            }
            for (var i = 0; i < len; i++) {
              if (hasValue(val[i])) {
                return true;
              }
            }
            return false;
          case "file":
          case "map":
          case "set":
            return val.size !== 0;
          case "object":
            var keys2 = Object.keys(val);
            if (keys2.length === 0) {
              return false;
            }
            for (var i = 0; i < keys2.length; i++) {
              var key = keys2[i];
              if (hasValue(val[key])) {
                return true;
              }
            }
            return false;
          default: {
            return false;
          }
        }
      };
    }
  });

  // ../../node_modules/.pnpm/has-value@1.0.0/node_modules/has-value/index.js
  var require_has_value2 = __commonJS({
    "../../node_modules/.pnpm/has-value@1.0.0/node_modules/has-value/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isObject5 = require_isobject();
      var hasValues = require_has_values2();
      var get2 = require_get_value();
      module2.exports = function(val, prop) {
        return hasValues(isObject5(val) && prop ? get2(val, prop) : val);
      };
    }
  });

  // ../../node_modules/.pnpm/cache-base@1.0.1/node_modules/cache-base/index.js
  var require_cache_base = __commonJS({
    "../../node_modules/.pnpm/cache-base@1.0.1/node_modules/cache-base/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isObject5 = require_isobject();
      var Emitter = require_component_emitter();
      var visit = require_collection_visit();
      var toPath2 = require_to_object_path();
      var union2 = require_union_value();
      var del = require_unset_value();
      var get2 = require_get_value();
      var has2 = require_has_value2();
      var set2 = require_set_value();
      function namespace(prop) {
        function Cache(cache) {
          if (prop) {
            this[prop] = {};
          }
          if (cache) {
            this.set(cache);
          }
        }
        Emitter(Cache.prototype);
        Cache.prototype.set = function(key, val) {
          if (Array.isArray(key) && arguments.length === 2) {
            key = toPath2(key);
          }
          if (isObject5(key) || Array.isArray(key)) {
            this.visit("set", key);
          } else {
            set2(prop ? this[prop] : this, key, val);
            this.emit("set", key, val);
          }
          return this;
        };
        Cache.prototype.union = function(key, val) {
          if (Array.isArray(key) && arguments.length === 2) {
            key = toPath2(key);
          }
          var ctx = prop ? this[prop] : this;
          union2(ctx, key, arrayify(val));
          this.emit("union", val);
          return this;
        };
        Cache.prototype.get = function(key) {
          key = toPath2(arguments);
          var ctx = prop ? this[prop] : this;
          var val = get2(ctx, key);
          this.emit("get", key, val);
          return val;
        };
        Cache.prototype.has = function(key) {
          key = toPath2(arguments);
          var ctx = prop ? this[prop] : this;
          var val = get2(ctx, key);
          var has3 = typeof val !== "undefined";
          this.emit("has", key, has3);
          return has3;
        };
        Cache.prototype.del = function(key) {
          if (Array.isArray(key)) {
            this.visit("del", key);
          } else {
            del(prop ? this[prop] : this, key);
            this.emit("del", key);
          }
          return this;
        };
        Cache.prototype.clear = function() {
          if (prop) {
            this[prop] = {};
          }
        };
        Cache.prototype.visit = function(method2, val) {
          visit(this, method2, val);
          return this;
        };
        return Cache;
      }
      function arrayify(val) {
        return val ? Array.isArray(val) ? val : [val] : [];
      }
      module2.exports = namespace();
      module2.exports.namespace = namespace;
    }
  });

  // ../../node_modules/.pnpm/for-in@1.0.2/node_modules/for-in/index.js
  var require_for_in = __commonJS({
    "../../node_modules/.pnpm/for-in@1.0.2/node_modules/for-in/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = function forIn2(obj, fn, thisArg) {
        for (var key in obj) {
          if (fn.call(thisArg, obj[key], key, obj) === false) {
            break;
          }
        }
      };
    }
  });

  // ../../node_modules/.pnpm/mixin-deep@1.3.2/node_modules/mixin-deep/index.js
  var require_mixin_deep = __commonJS({
    "../../node_modules/.pnpm/mixin-deep@1.3.2/node_modules/mixin-deep/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isExtendable = require_is_extendable();
      var forIn2 = require_for_in();
      function mixinDeep(target, objects) {
        var len = arguments.length, i = 0;
        while (++i < len) {
          var obj = arguments[i];
          if (isObject5(obj)) {
            forIn2(obj, copy, target);
          }
        }
        return target;
      }
      function copy(val, key) {
        if (!isValidKey(key)) {
          return;
        }
        var obj = this[key];
        if (isObject5(val) && isObject5(obj)) {
          mixinDeep(obj, val);
        } else {
          this[key] = val;
        }
      }
      function isObject5(val) {
        return isExtendable(val) && !Array.isArray(val);
      }
      function isValidKey(key) {
        return key !== "__proto__" && key !== "constructor" && key !== "prototype";
      }
      module2.exports = mixinDeep;
    }
  });

  // ../../node_modules/.pnpm/pascalcase@0.1.1/node_modules/pascalcase/index.js
  var require_pascalcase = __commonJS({
    "../../node_modules/.pnpm/pascalcase@0.1.1/node_modules/pascalcase/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      function pascalcase(str) {
        if (typeof str !== "string") {
          throw new TypeError("expected a string.");
        }
        str = str.replace(/([A-Z])/g, " $1");
        if (str.length === 1) {
          return str.toUpperCase();
        }
        str = str.replace(/^[\W_]+|[\W_]+$/g, "").toLowerCase();
        str = str.charAt(0).toUpperCase() + str.slice(1);
        return str.replace(/[\W_]+(\w|$)/g, function(_, ch) {
          return ch.toUpperCase();
        });
      }
      module2.exports = pascalcase;
    }
  });

  // ../../node_modules/.pnpm/is-descriptor@0.1.7/node_modules/is-descriptor/index.js
  var require_is_descriptor2 = __commonJS({
    "../../node_modules/.pnpm/is-descriptor@0.1.7/node_modules/is-descriptor/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isAccessor = require_is_accessor_descriptor();
      var isData = require_is_data_descriptor();
      module2.exports = function isDescriptor(obj, key) {
        if (!obj || typeof obj !== "object" && typeof obj !== "function") {
          return false;
        }
        if ("get" in obj || "set" in obj) {
          return isAccessor(obj, key);
        }
        return isData(obj, key);
      };
    }
  });

  // ../../node_modules/.pnpm/define-property@0.2.5/node_modules/define-property/index.js
  var require_define_property3 = __commonJS({
    "../../node_modules/.pnpm/define-property@0.2.5/node_modules/define-property/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isDescriptor = require_is_descriptor2();
      module2.exports = function defineProperty2(obj, prop, val) {
        if (typeof obj !== "object" && typeof obj !== "function") {
          throw new TypeError("expected an object or function.");
        }
        if (typeof prop !== "string") {
          throw new TypeError("expected `prop` to be a string.");
        }
        if (isDescriptor(val) && ("set" in val || "get" in val)) {
          return Object.defineProperty(obj, prop, val);
        }
        return Object.defineProperty(obj, prop, {
          configurable: true,
          enumerable: false,
          writable: true,
          value: val
        });
      };
    }
  });

  // ../../node_modules/.pnpm/copy-descriptor@0.1.1/node_modules/copy-descriptor/index.js
  var require_copy_descriptor = __commonJS({
    "../../node_modules/.pnpm/copy-descriptor@0.1.1/node_modules/copy-descriptor/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = function copyDescriptor(receiver, provider, from, to) {
        if (!isObject5(provider) && typeof provider !== "function") {
          to = from;
          from = provider;
          provider = receiver;
        }
        if (!isObject5(receiver) && typeof receiver !== "function") {
          throw new TypeError("expected the first argument to be an object");
        }
        if (!isObject5(provider) && typeof provider !== "function") {
          throw new TypeError("expected provider to be an object");
        }
        if (typeof to !== "string") {
          to = from;
        }
        if (typeof from !== "string") {
          throw new TypeError("expected key to be a string");
        }
        if (!(from in provider)) {
          throw new Error('property "' + from + '" does not exist');
        }
        var val = Object.getOwnPropertyDescriptor(provider, from);
        if (val)
          Object.defineProperty(receiver, to, val);
      };
      function isObject5(val) {
        return {}.toString.call(val) === "[object Object]";
      }
    }
  });

  // ../../node_modules/.pnpm/object-copy@0.1.0/node_modules/object-copy/index.js
  var require_object_copy = __commonJS({
    "../../node_modules/.pnpm/object-copy@0.1.0/node_modules/object-copy/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var typeOf = require_kind_of();
      var copyDescriptor = require_copy_descriptor();
      var define2 = require_define_property3();
      function copy(receiver, provider, omit2) {
        if (!isObject5(receiver)) {
          throw new TypeError("expected receiving object to be an object.");
        }
        if (!isObject5(provider)) {
          throw new TypeError("expected providing object to be an object.");
        }
        var props = nativeKeys2(provider);
        var keys2 = Object.keys(provider);
        var len = props.length;
        omit2 = arrayify(omit2);
        while (len--) {
          var key = props[len];
          if (has2(keys2, key)) {
            define2(receiver, key, provider[key]);
          } else if (!(key in receiver) && !has2(omit2, key)) {
            copyDescriptor(receiver, provider, key);
          }
        }
      }
      function isObject5(val) {
        return typeOf(val) === "object" || typeof val === "function";
      }
      function has2(obj, val) {
        val = arrayify(val);
        var len = val.length;
        if (isObject5(obj)) {
          for (var key in obj) {
            if (val.indexOf(key) > -1) {
              return true;
            }
          }
          var keys2 = nativeKeys2(obj);
          return has2(keys2, val);
        }
        if (Array.isArray(obj)) {
          var arr = obj;
          while (len--) {
            if (arr.indexOf(val[len]) > -1) {
              return true;
            }
          }
          return false;
        }
        throw new TypeError("expected an array or object.");
      }
      function arrayify(val) {
        return val ? Array.isArray(val) ? val : [val] : [];
      }
      function hasConstructor(val) {
        return isObject5(val) && typeof val.constructor !== "undefined";
      }
      function nativeKeys2(val) {
        if (!hasConstructor(val))
          return [];
        return Object.getOwnPropertyNames(val);
      }
      module2.exports = copy;
      module2.exports.has = has2;
    }
  });

  // ../../node_modules/.pnpm/static-extend@0.1.2/node_modules/static-extend/index.js
  var require_static_extend = __commonJS({
    "../../node_modules/.pnpm/static-extend@0.1.2/node_modules/static-extend/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var copy = require_object_copy();
      var define2 = require_define_property3();
      var util = (init_util(), __toCommonJS(util_exports));
      function extend(Parent, extendFn) {
        if (typeof Parent !== "function") {
          throw new TypeError("expected Parent to be a function.");
        }
        return function(Ctor, proto) {
          if (typeof Ctor !== "function") {
            throw new TypeError("expected Ctor to be a function.");
          }
          util.inherits(Ctor, Parent);
          copy(Ctor, Parent);
          if (typeof proto === "object") {
            var obj = Object.create(proto);
            for (var k in obj) {
              Ctor.prototype[k] = obj[k];
            }
          }
          define2(Ctor.prototype, "_parent_", {
            configurable: true,
            set: function() {
            },
            get: function() {
              return Parent.prototype;
            }
          });
          if (typeof extendFn === "function") {
            extendFn(Ctor, Parent);
          }
          Ctor.extend = extend(Ctor, extendFn);
        };
      }
      module2.exports = extend;
    }
  });

  // ../../node_modules/.pnpm/class-utils@0.3.6/node_modules/class-utils/index.js
  var require_class_utils = __commonJS({
    "../../node_modules/.pnpm/class-utils@0.3.6/node_modules/class-utils/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var util = (init_util(), __toCommonJS(util_exports));
      var union2 = require_arr_union();
      var define2 = require_define_property3();
      var staticExtend = require_static_extend();
      var isObj = require_isobject();
      var cu = module2.exports;
      cu.isObject = function isObject5(val) {
        return isObj(val) || typeof val === "function";
      };
      cu.has = function has2(obj, val) {
        val = cu.arrayify(val);
        var len = val.length;
        if (cu.isObject(obj)) {
          for (var key in obj) {
            if (val.indexOf(key) > -1) {
              return true;
            }
          }
          var keys2 = cu.nativeKeys(obj);
          return cu.has(keys2, val);
        }
        if (Array.isArray(obj)) {
          var arr = obj;
          while (len--) {
            if (arr.indexOf(val[len]) > -1) {
              return true;
            }
          }
          return false;
        }
        throw new TypeError("expected an array or object.");
      };
      cu.hasAll = function hasAll(val, values2) {
        values2 = cu.arrayify(values2);
        var len = values2.length;
        while (len--) {
          if (!cu.has(val, values2[len])) {
            return false;
          }
        }
        return true;
      };
      cu.arrayify = function arrayify(val) {
        return val ? Array.isArray(val) ? val : [val] : [];
      };
      cu.noop = function noop5() {
        return;
      };
      cu.identity = function identity2(val) {
        return val;
      };
      cu.hasConstructor = function hasConstructor(val) {
        return cu.isObject(val) && typeof val.constructor !== "undefined";
      };
      cu.nativeKeys = function nativeKeys2(val) {
        if (!cu.hasConstructor(val))
          return [];
        var keys2 = Object.getOwnPropertyNames(val);
        if ("caller" in val)
          keys2.push("caller");
        return keys2;
      };
      cu.getDescriptor = function getDescriptor(obj, key) {
        if (!cu.isObject(obj)) {
          throw new TypeError("expected an object.");
        }
        if (typeof key !== "string") {
          throw new TypeError("expected key to be a string.");
        }
        return Object.getOwnPropertyDescriptor(obj, key);
      };
      cu.copyDescriptor = function copyDescriptor(receiver, provider, name) {
        if (!cu.isObject(receiver)) {
          throw new TypeError("expected receiving object to be an object.");
        }
        if (!cu.isObject(provider)) {
          throw new TypeError("expected providing object to be an object.");
        }
        if (typeof name !== "string") {
          throw new TypeError("expected name to be a string.");
        }
        var val = cu.getDescriptor(provider, name);
        if (val)
          Object.defineProperty(receiver, name, val);
      };
      cu.copy = function copy(receiver, provider, omit2) {
        if (!cu.isObject(receiver)) {
          throw new TypeError("expected receiving object to be an object.");
        }
        if (!cu.isObject(provider)) {
          throw new TypeError("expected providing object to be an object.");
        }
        var props = Object.getOwnPropertyNames(provider);
        var keys2 = Object.keys(provider);
        var len = props.length, key;
        omit2 = cu.arrayify(omit2);
        while (len--) {
          key = props[len];
          if (cu.has(keys2, key)) {
            define2(receiver, key, provider[key]);
          } else if (!(key in receiver) && !cu.has(omit2, key)) {
            cu.copyDescriptor(receiver, provider, key);
          }
        }
      };
      cu.inherit = function inherit(receiver, provider, omit2) {
        if (!cu.isObject(receiver)) {
          throw new TypeError("expected receiving object to be an object.");
        }
        if (!cu.isObject(provider)) {
          throw new TypeError("expected providing object to be an object.");
        }
        var keys2 = [];
        for (var key in provider) {
          keys2.push(key);
          receiver[key] = provider[key];
        }
        keys2 = keys2.concat(cu.arrayify(omit2));
        var a = provider.prototype || provider;
        var b = receiver.prototype || receiver;
        cu.copy(b, a, keys2);
      };
      cu.extend = function() {
        return staticExtend.apply(null, arguments);
      };
      cu.bubble = function(Parent, events) {
        events = events || [];
        Parent.bubble = function(Child, arr) {
          if (Array.isArray(arr)) {
            events = union2([], events, arr);
          }
          var len = events.length;
          var idx = -1;
          while (++idx < len) {
            var name = events[idx];
            Parent.on(name, Child.emit.bind(Child, name));
          }
          cu.bubble(Child, events);
        };
      };
    }
  });

  // ../../node_modules/.pnpm/base@0.11.2/node_modules/base/index.js
  var require_base = __commonJS({
    "../../node_modules/.pnpm/base@0.11.2/node_modules/base/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var util = (init_util(), __toCommonJS(util_exports));
      var define2 = require_define_property2();
      var CacheBase = require_cache_base();
      var Emitter = require_component_emitter();
      var isObject5 = require_isobject();
      var merge2 = require_mixin_deep();
      var pascal = require_pascalcase();
      var cu = require_class_utils();
      function namespace(name) {
        var Cache = name ? CacheBase.namespace(name) : CacheBase;
        var fns = [];
        function Base(config3, options) {
          if (!(this instanceof Base)) {
            return new Base(config3, options);
          }
          Cache.call(this, config3);
          this.is("base");
          this.initBase(config3, options);
        }
        util.inherits(Base, Cache);
        Emitter(Base);
        Base.prototype.initBase = function(config3, options) {
          this.options = merge2({}, this.options, options);
          this.cache = this.cache || {};
          this.define("registered", {});
          if (name)
            this[name] = {};
          this.define("_callbacks", this._callbacks);
          if (isObject5(config3)) {
            this.visit("set", config3);
          }
          Base.run(this, "use", fns);
        };
        Base.prototype.is = function(name2) {
          if (typeof name2 !== "string") {
            throw new TypeError("expected name to be a string");
          }
          this.define("is" + pascal(name2), true);
          this.define("_name", name2);
          this.define("_appname", name2);
          return this;
        };
        Base.prototype.isRegistered = function(name2, register) {
          if (this.registered.hasOwnProperty(name2)) {
            return true;
          }
          if (register !== false) {
            this.registered[name2] = true;
            this.emit("plugin", name2);
          }
          return false;
        };
        Base.prototype.use = function(fn) {
          fn.call(this, this);
          return this;
        };
        Base.prototype.define = function(key, val) {
          if (isObject5(key)) {
            return this.visit("define", key);
          }
          define2(this, key, val);
          return this;
        };
        Base.prototype.mixin = function(key, val) {
          Base.prototype[key] = val;
          return this;
        };
        Base.prototype.mixins = Base.prototype.mixins || [];
        Object.defineProperty(Base.prototype, "base", {
          configurable: true,
          get: function() {
            return this.parent ? this.parent.base : this;
          }
        });
        define2(Base, "use", function(fn) {
          fns.push(fn);
          return Base;
        });
        define2(Base, "run", function(obj, prop, arr) {
          var len = arr.length, i = 0;
          while (len--) {
            obj[prop](arr[i++]);
          }
          return Base;
        });
        define2(Base, "extend", cu.extend(Base, function(Ctor, Parent) {
          Ctor.prototype.mixins = Ctor.prototype.mixins || [];
          define2(Ctor, "mixin", function(fn) {
            var mixin3 = fn(Ctor.prototype, Ctor);
            if (typeof mixin3 === "function") {
              Ctor.prototype.mixins.push(mixin3);
            }
            return Ctor;
          });
          define2(Ctor, "mixins", function(Child) {
            Base.run(Child, "mixin", Ctor.prototype.mixins);
            return Ctor;
          });
          Ctor.prototype.mixin = function(key, value) {
            Ctor.prototype[key] = value;
            return this;
          };
          return Base;
        }));
        define2(Base, "mixin", function(fn) {
          var mixin3 = fn(Base.prototype, Base);
          if (typeof mixin3 === "function") {
            Base.prototype.mixins.push(mixin3);
          }
          return Base;
        });
        define2(Base, "mixins", function(Child) {
          Base.run(Child, "mixin", Base.prototype.mixins);
          return Base;
        });
        define2(Base, "inherit", cu.inherit);
        define2(Base, "bubble", cu.bubble);
        return Base;
      }
      module2.exports = namespace();
      module2.exports.namespace = namespace;
    }
  });

  // ../../node_modules/.pnpm/use@3.1.1/node_modules/use/index.js
  var require_use = __commonJS({
    "../../node_modules/.pnpm/use@3.1.1/node_modules/use/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = function base(app, options) {
        if (!isObject5(app) && typeof app !== "function") {
          throw new TypeError("expected an object or function");
        }
        var opts = isObject5(options) ? options : {};
        var prop = typeof opts.prop === "string" ? opts.prop : "fns";
        if (!Array.isArray(app[prop])) {
          define2(app, prop, []);
        }
        define2(app, "use", use);
        define2(app, "run", function(val) {
          if (!isObject5(val))
            return;
          if (!val.use || !val.run) {
            define2(val, prop, val[prop] || []);
            define2(val, "use", use);
          }
          if (!val[prop] || val[prop].indexOf(base) === -1) {
            val.use(base);
          }
          var self2 = this || app;
          var fns = self2[prop];
          var len = fns.length;
          var idx = -1;
          while (++idx < len) {
            val.use(fns[idx]);
          }
          return val;
        });
        function use(type, fn, options2) {
          var offset = 1;
          if (typeof type === "string" || Array.isArray(type)) {
            fn = wrap2(type, fn);
            offset++;
          } else {
            options2 = fn;
            fn = type;
          }
          if (typeof fn !== "function") {
            throw new TypeError("expected a function");
          }
          var self2 = this || app;
          var fns = self2[prop];
          var args = [].slice.call(arguments, offset);
          args.unshift(self2);
          if (typeof opts.hook === "function") {
            opts.hook.apply(self2, args);
          }
          var val = fn.apply(self2, args);
          if (typeof val === "function" && fns.indexOf(val) === -1) {
            fns.push(val);
          }
          return self2;
        }
        function wrap2(type, fn) {
          return function plugin() {
            return this.type === type ? fn.apply(this, arguments) : plugin;
          };
        }
        return app;
      };
      function isObject5(val) {
        return val && typeof val === "object" && !Array.isArray(val);
      }
      function define2(obj, key, val) {
        Object.defineProperty(obj, key, {
          configurable: true,
          writable: true,
          value: val
        });
      }
    }
  });

  // ../../node_modules/.pnpm/ms@2.0.0/node_modules/ms/index.js
  var require_ms = __commonJS({
    "../../node_modules/.pnpm/ms@2.0.0/node_modules/ms/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var s = 1e3;
      var m = s * 60;
      var h = m * 60;
      var d = h * 24;
      var y = d * 365.25;
      module2.exports = function(val, options) {
        options = options || {};
        var type = typeof val;
        if (type === "string" && val.length > 0) {
          return parse4(val);
        } else if (type === "number" && isNaN(val) === false) {
          return options.long ? fmtLong(val) : fmtShort(val);
        }
        throw new Error(
          "val is not a non-empty string or a valid number. val=" + JSON.stringify(val)
        );
      };
      function parse4(str) {
        str = String(str);
        if (str.length > 100) {
          return;
        }
        var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
          str
        );
        if (!match) {
          return;
        }
        var n = parseFloat(match[1]);
        var type = (match[2] || "ms").toLowerCase();
        switch (type) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return n * y;
          case "days":
          case "day":
          case "d":
            return n * d;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return n * h;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return n * m;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return n * s;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return n;
          default:
            return void 0;
        }
      }
      function fmtShort(ms) {
        if (ms >= d) {
          return Math.round(ms / d) + "d";
        }
        if (ms >= h) {
          return Math.round(ms / h) + "h";
        }
        if (ms >= m) {
          return Math.round(ms / m) + "m";
        }
        if (ms >= s) {
          return Math.round(ms / s) + "s";
        }
        return ms + "ms";
      }
      function fmtLong(ms) {
        return plural(ms, d, "day") || plural(ms, h, "hour") || plural(ms, m, "minute") || plural(ms, s, "second") || ms + " ms";
      }
      function plural(ms, n, name) {
        if (ms < n) {
          return;
        }
        if (ms < n * 1.5) {
          return Math.floor(ms / n) + " " + name;
        }
        return Math.ceil(ms / n) + " " + name + "s";
      }
    }
  });

  // ../../node_modules/.pnpm/debug@2.6.9_supports-color@6.1.0/node_modules/debug/src/debug.js
  var require_debug = __commonJS({
    "../../node_modules/.pnpm/debug@2.6.9_supports-color@6.1.0/node_modules/debug/src/debug.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      exports8 = module2.exports = createDebug.debug = createDebug["default"] = createDebug;
      exports8.coerce = coerce;
      exports8.disable = disable;
      exports8.enable = enable;
      exports8.enabled = enabled;
      exports8.humanize = require_ms();
      exports8.names = [];
      exports8.skips = [];
      exports8.formatters = {};
      var prevTime;
      function selectColor(namespace) {
        var hash = 0, i;
        for (i in namespace) {
          hash = (hash << 5) - hash + namespace.charCodeAt(i);
          hash |= 0;
        }
        return exports8.colors[Math.abs(hash) % exports8.colors.length];
      }
      function createDebug(namespace) {
        function debug() {
          if (!debug.enabled)
            return;
          var self2 = debug;
          var curr = +new Date();
          var ms = curr - (prevTime || curr);
          self2.diff = ms;
          self2.prev = prevTime;
          self2.curr = curr;
          prevTime = curr;
          var args = new Array(arguments.length);
          for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i];
          }
          args[0] = exports8.coerce(args[0]);
          if ("string" !== typeof args[0]) {
            args.unshift("%O");
          }
          var index = 0;
          args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format3) {
            if (match === "%%")
              return match;
            index++;
            var formatter = exports8.formatters[format3];
            if ("function" === typeof formatter) {
              var val = args[index];
              match = formatter.call(self2, val);
              args.splice(index, 1);
              index--;
            }
            return match;
          });
          exports8.formatArgs.call(self2, args);
          var logFn = debug.log || exports8.log || console.log.bind(console);
          logFn.apply(self2, args);
        }
        debug.namespace = namespace;
        debug.enabled = exports8.enabled(namespace);
        debug.useColors = exports8.useColors();
        debug.color = selectColor(namespace);
        if ("function" === typeof exports8.init) {
          exports8.init(debug);
        }
        return debug;
      }
      function enable(namespaces) {
        exports8.save(namespaces);
        exports8.names = [];
        exports8.skips = [];
        var split2 = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        var len = split2.length;
        for (var i = 0; i < len; i++) {
          if (!split2[i])
            continue;
          namespaces = split2[i].replace(/\*/g, ".*?");
          if (namespaces[0] === "-") {
            exports8.skips.push(new RegExp("^" + namespaces.substr(1) + "$"));
          } else {
            exports8.names.push(new RegExp("^" + namespaces + "$"));
          }
        }
      }
      function disable() {
        exports8.enable("");
      }
      function enabled(name) {
        var i, len;
        for (i = 0, len = exports8.skips.length; i < len; i++) {
          if (exports8.skips[i].test(name)) {
            return false;
          }
        }
        for (i = 0, len = exports8.names.length; i < len; i++) {
          if (exports8.names[i].test(name)) {
            return true;
          }
        }
        return false;
      }
      function coerce(val) {
        if (val instanceof Error)
          return val.stack || val.message;
        return val;
      }
    }
  });

  // ../../node_modules/.pnpm/debug@2.6.9_supports-color@6.1.0/node_modules/debug/src/browser.js
  var require_browser = __commonJS({
    "../../node_modules/.pnpm/debug@2.6.9_supports-color@6.1.0/node_modules/debug/src/browser.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      exports8 = module2.exports = require_debug();
      exports8.log = log2;
      exports8.formatArgs = formatArgs;
      exports8.save = save;
      exports8.load = load;
      exports8.useColors = useColors;
      exports8.storage = "undefined" != typeof chrome && "undefined" != typeof chrome.storage ? chrome.storage.local : localstorage();
      exports8.colors = [
        "lightseagreen",
        "forestgreen",
        "goldenrod",
        "dodgerblue",
        "darkorchid",
        "crimson"
      ];
      function useColors() {
        if (typeof window !== "undefined" && window.process && window.process.type === "renderer") {
          return true;
        }
        return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
      }
      exports8.formatters.j = function(v) {
        try {
          return JSON.stringify(v);
        } catch (err) {
          return "[UnexpectedJSONParseError]: " + err.message;
        }
      };
      function formatArgs(args) {
        var useColors2 = this.useColors;
        args[0] = (useColors2 ? "%c" : "") + this.namespace + (useColors2 ? " %c" : " ") + args[0] + (useColors2 ? "%c " : " ") + "+" + exports8.humanize(this.diff);
        if (!useColors2)
          return;
        var c = "color: " + this.color;
        args.splice(1, 0, c, "color: inherit");
        var index = 0;
        var lastC = 0;
        args[0].replace(/%[a-zA-Z%]/g, function(match) {
          if ("%%" === match)
            return;
          index++;
          if ("%c" === match) {
            lastC = index;
          }
        });
        args.splice(lastC, 0, c);
      }
      function log2() {
        return "object" === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
      }
      function save(namespaces) {
        try {
          if (null == namespaces) {
            exports8.storage.removeItem("debug");
          } else {
            exports8.storage.debug = namespaces;
          }
        } catch (e) {
        }
      }
      function load() {
        var r;
        try {
          r = exports8.storage.debug;
        } catch (e) {
        }
        if (!r && typeof define_process_default !== "undefined" && "env" in define_process_default) {
          r = define_process_default.env.DEBUG;
        }
        return r;
      }
      exports8.enable(load());
      function localstorage() {
        try {
          return window.localStorage;
        } catch (e) {
        }
      }
    }
  });

  // ../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/base64.js
  var require_base64 = __commonJS({
    "../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/base64.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var intToCharMap = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
      exports8.encode = function(number) {
        if (0 <= number && number < intToCharMap.length) {
          return intToCharMap[number];
        }
        throw new TypeError("Must be between 0 and 63: " + number);
      };
      exports8.decode = function(charCode) {
        var bigA = 65;
        var bigZ = 90;
        var littleA = 97;
        var littleZ = 122;
        var zero = 48;
        var nine = 57;
        var plus = 43;
        var slash = 47;
        var littleOffset = 26;
        var numberOffset = 52;
        if (bigA <= charCode && charCode <= bigZ) {
          return charCode - bigA;
        }
        if (littleA <= charCode && charCode <= littleZ) {
          return charCode - littleA + littleOffset;
        }
        if (zero <= charCode && charCode <= nine) {
          return charCode - zero + numberOffset;
        }
        if (charCode == plus) {
          return 62;
        }
        if (charCode == slash) {
          return 63;
        }
        return -1;
      };
    }
  });

  // ../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/base64-vlq.js
  var require_base64_vlq = __commonJS({
    "../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/base64-vlq.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var base64 = require_base64();
      var VLQ_BASE_SHIFT = 5;
      var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
      var VLQ_BASE_MASK = VLQ_BASE - 1;
      var VLQ_CONTINUATION_BIT = VLQ_BASE;
      function toVLQSigned(aValue) {
        return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
      }
      function fromVLQSigned(aValue) {
        var isNegative = (aValue & 1) === 1;
        var shifted = aValue >> 1;
        return isNegative ? -shifted : shifted;
      }
      exports8.encode = function base64VLQ_encode(aValue) {
        var encoded = "";
        var digit;
        var vlq = toVLQSigned(aValue);
        do {
          digit = vlq & VLQ_BASE_MASK;
          vlq >>>= VLQ_BASE_SHIFT;
          if (vlq > 0) {
            digit |= VLQ_CONTINUATION_BIT;
          }
          encoded += base64.encode(digit);
        } while (vlq > 0);
        return encoded;
      };
      exports8.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
        var strLen = aStr.length;
        var result2 = 0;
        var shift = 0;
        var continuation, digit;
        do {
          if (aIndex >= strLen) {
            throw new Error("Expected more digits in base 64 VLQ value.");
          }
          digit = base64.decode(aStr.charCodeAt(aIndex++));
          if (digit === -1) {
            throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
          }
          continuation = !!(digit & VLQ_CONTINUATION_BIT);
          digit &= VLQ_BASE_MASK;
          result2 = result2 + (digit << shift);
          shift += VLQ_BASE_SHIFT;
        } while (continuation);
        aOutParam.value = fromVLQSigned(result2);
        aOutParam.rest = aIndex;
      };
    }
  });

  // ../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/util.js
  var require_util2 = __commonJS({
    "../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/util.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      function getArg(aArgs, aName, aDefaultValue) {
        if (aName in aArgs) {
          return aArgs[aName];
        } else if (arguments.length === 3) {
          return aDefaultValue;
        } else {
          throw new Error('"' + aName + '" is a required argument.');
        }
      }
      exports8.getArg = getArg;
      var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
      var dataUrlRegexp = /^data:.+\,.+$/;
      function urlParse(aUrl) {
        var match = aUrl.match(urlRegexp);
        if (!match) {
          return null;
        }
        return {
          scheme: match[1],
          auth: match[2],
          host: match[3],
          port: match[4],
          path: match[5]
        };
      }
      exports8.urlParse = urlParse;
      function urlGenerate(aParsedUrl) {
        var url = "";
        if (aParsedUrl.scheme) {
          url += aParsedUrl.scheme + ":";
        }
        url += "//";
        if (aParsedUrl.auth) {
          url += aParsedUrl.auth + "@";
        }
        if (aParsedUrl.host) {
          url += aParsedUrl.host;
        }
        if (aParsedUrl.port) {
          url += ":" + aParsedUrl.port;
        }
        if (aParsedUrl.path) {
          url += aParsedUrl.path;
        }
        return url;
      }
      exports8.urlGenerate = urlGenerate;
      function normalize2(aPath) {
        var path = aPath;
        var url = urlParse(aPath);
        if (url) {
          if (!url.path) {
            return aPath;
          }
          path = url.path;
        }
        var isAbsolute2 = exports8.isAbsolute(path);
        var parts = path.split(/\/+/);
        for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
          part = parts[i];
          if (part === ".") {
            parts.splice(i, 1);
          } else if (part === "..") {
            up++;
          } else if (up > 0) {
            if (part === "") {
              parts.splice(i + 1, up);
              up = 0;
            } else {
              parts.splice(i, 2);
              up--;
            }
          }
        }
        path = parts.join("/");
        if (path === "") {
          path = isAbsolute2 ? "/" : ".";
        }
        if (url) {
          url.path = path;
          return urlGenerate(url);
        }
        return path;
      }
      exports8.normalize = normalize2;
      function join3(aRoot, aPath) {
        if (aRoot === "") {
          aRoot = ".";
        }
        if (aPath === "") {
          aPath = ".";
        }
        var aPathUrl = urlParse(aPath);
        var aRootUrl = urlParse(aRoot);
        if (aRootUrl) {
          aRoot = aRootUrl.path || "/";
        }
        if (aPathUrl && !aPathUrl.scheme) {
          if (aRootUrl) {
            aPathUrl.scheme = aRootUrl.scheme;
          }
          return urlGenerate(aPathUrl);
        }
        if (aPathUrl || aPath.match(dataUrlRegexp)) {
          return aPath;
        }
        if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
          aRootUrl.host = aPath;
          return urlGenerate(aRootUrl);
        }
        var joined = aPath.charAt(0) === "/" ? aPath : normalize2(aRoot.replace(/\/+$/, "") + "/" + aPath);
        if (aRootUrl) {
          aRootUrl.path = joined;
          return urlGenerate(aRootUrl);
        }
        return joined;
      }
      exports8.join = join3;
      exports8.isAbsolute = function(aPath) {
        return aPath.charAt(0) === "/" || !!aPath.match(urlRegexp);
      };
      function relative2(aRoot, aPath) {
        if (aRoot === "") {
          aRoot = ".";
        }
        aRoot = aRoot.replace(/\/$/, "");
        var level = 0;
        while (aPath.indexOf(aRoot + "/") !== 0) {
          var index = aRoot.lastIndexOf("/");
          if (index < 0) {
            return aPath;
          }
          aRoot = aRoot.slice(0, index);
          if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
            return aPath;
          }
          ++level;
        }
        return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
      }
      exports8.relative = relative2;
      var supportsNullProto = function() {
        var obj = /* @__PURE__ */ Object.create(null);
        return !("__proto__" in obj);
      }();
      function identity2(s) {
        return s;
      }
      function toSetString(aStr) {
        if (isProtoString(aStr)) {
          return "$" + aStr;
        }
        return aStr;
      }
      exports8.toSetString = supportsNullProto ? identity2 : toSetString;
      function fromSetString(aStr) {
        if (isProtoString(aStr)) {
          return aStr.slice(1);
        }
        return aStr;
      }
      exports8.fromSetString = supportsNullProto ? identity2 : fromSetString;
      function isProtoString(s) {
        if (!s) {
          return false;
        }
        var length = s.length;
        if (length < 9) {
          return false;
        }
        if (s.charCodeAt(length - 1) !== 95 || s.charCodeAt(length - 2) !== 95 || s.charCodeAt(length - 3) !== 111 || s.charCodeAt(length - 4) !== 116 || s.charCodeAt(length - 5) !== 111 || s.charCodeAt(length - 6) !== 114 || s.charCodeAt(length - 7) !== 112 || s.charCodeAt(length - 8) !== 95 || s.charCodeAt(length - 9) !== 95) {
          return false;
        }
        for (var i = length - 10; i >= 0; i--) {
          if (s.charCodeAt(i) !== 36) {
            return false;
          }
        }
        return true;
      }
      function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
        var cmp = mappingA.source - mappingB.source;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalLine - mappingB.originalLine;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalColumn - mappingB.originalColumn;
        if (cmp !== 0 || onlyCompareOriginal) {
          return cmp;
        }
        cmp = mappingA.generatedColumn - mappingB.generatedColumn;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.generatedLine - mappingB.generatedLine;
        if (cmp !== 0) {
          return cmp;
        }
        return mappingA.name - mappingB.name;
      }
      exports8.compareByOriginalPositions = compareByOriginalPositions;
      function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
        var cmp = mappingA.generatedLine - mappingB.generatedLine;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.generatedColumn - mappingB.generatedColumn;
        if (cmp !== 0 || onlyCompareGenerated) {
          return cmp;
        }
        cmp = mappingA.source - mappingB.source;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalLine - mappingB.originalLine;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalColumn - mappingB.originalColumn;
        if (cmp !== 0) {
          return cmp;
        }
        return mappingA.name - mappingB.name;
      }
      exports8.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
      function strcmp(aStr1, aStr2) {
        if (aStr1 === aStr2) {
          return 0;
        }
        if (aStr1 > aStr2) {
          return 1;
        }
        return -1;
      }
      function compareByGeneratedPositionsInflated(mappingA, mappingB) {
        var cmp = mappingA.generatedLine - mappingB.generatedLine;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.generatedColumn - mappingB.generatedColumn;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = strcmp(mappingA.source, mappingB.source);
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalLine - mappingB.originalLine;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalColumn - mappingB.originalColumn;
        if (cmp !== 0) {
          return cmp;
        }
        return strcmp(mappingA.name, mappingB.name);
      }
      exports8.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;
    }
  });

  // ../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/array-set.js
  var require_array_set = __commonJS({
    "../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/array-set.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var util = require_util2();
      var has2 = Object.prototype.hasOwnProperty;
      var hasNativeMap = typeof Map !== "undefined";
      function ArraySet() {
        this._array = [];
        this._set = hasNativeMap ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null);
      }
      ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
        var set2 = new ArraySet();
        for (var i = 0, len = aArray.length; i < len; i++) {
          set2.add(aArray[i], aAllowDuplicates);
        }
        return set2;
      };
      ArraySet.prototype.size = function ArraySet_size() {
        return hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
      };
      ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
        var sStr = hasNativeMap ? aStr : util.toSetString(aStr);
        var isDuplicate = hasNativeMap ? this.has(aStr) : has2.call(this._set, sStr);
        var idx = this._array.length;
        if (!isDuplicate || aAllowDuplicates) {
          this._array.push(aStr);
        }
        if (!isDuplicate) {
          if (hasNativeMap) {
            this._set.set(aStr, idx);
          } else {
            this._set[sStr] = idx;
          }
        }
      };
      ArraySet.prototype.has = function ArraySet_has(aStr) {
        if (hasNativeMap) {
          return this._set.has(aStr);
        } else {
          var sStr = util.toSetString(aStr);
          return has2.call(this._set, sStr);
        }
      };
      ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
        if (hasNativeMap) {
          var idx = this._set.get(aStr);
          if (idx >= 0) {
            return idx;
          }
        } else {
          var sStr = util.toSetString(aStr);
          if (has2.call(this._set, sStr)) {
            return this._set[sStr];
          }
        }
        throw new Error('"' + aStr + '" is not in the set.');
      };
      ArraySet.prototype.at = function ArraySet_at(aIdx) {
        if (aIdx >= 0 && aIdx < this._array.length) {
          return this._array[aIdx];
        }
        throw new Error("No element indexed by " + aIdx);
      };
      ArraySet.prototype.toArray = function ArraySet_toArray() {
        return this._array.slice();
      };
      exports8.ArraySet = ArraySet;
    }
  });

  // ../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/mapping-list.js
  var require_mapping_list = __commonJS({
    "../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/mapping-list.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var util = require_util2();
      function generatedPositionAfter(mappingA, mappingB) {
        var lineA = mappingA.generatedLine;
        var lineB = mappingB.generatedLine;
        var columnA = mappingA.generatedColumn;
        var columnB = mappingB.generatedColumn;
        return lineB > lineA || lineB == lineA && columnB >= columnA || util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
      }
      function MappingList() {
        this._array = [];
        this._sorted = true;
        this._last = { generatedLine: -1, generatedColumn: 0 };
      }
      MappingList.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
        this._array.forEach(aCallback, aThisArg);
      };
      MappingList.prototype.add = function MappingList_add(aMapping) {
        if (generatedPositionAfter(this._last, aMapping)) {
          this._last = aMapping;
          this._array.push(aMapping);
        } else {
          this._sorted = false;
          this._array.push(aMapping);
        }
      };
      MappingList.prototype.toArray = function MappingList_toArray() {
        if (!this._sorted) {
          this._array.sort(util.compareByGeneratedPositionsInflated);
          this._sorted = true;
        }
        return this._array;
      };
      exports8.MappingList = MappingList;
    }
  });

  // ../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/source-map-generator.js
  var require_source_map_generator = __commonJS({
    "../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/source-map-generator.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var base64VLQ = require_base64_vlq();
      var util = require_util2();
      var ArraySet = require_array_set().ArraySet;
      var MappingList = require_mapping_list().MappingList;
      function SourceMapGenerator(aArgs) {
        if (!aArgs) {
          aArgs = {};
        }
        this._file = util.getArg(aArgs, "file", null);
        this._sourceRoot = util.getArg(aArgs, "sourceRoot", null);
        this._skipValidation = util.getArg(aArgs, "skipValidation", false);
        this._sources = new ArraySet();
        this._names = new ArraySet();
        this._mappings = new MappingList();
        this._sourcesContents = null;
      }
      SourceMapGenerator.prototype._version = 3;
      SourceMapGenerator.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
        var sourceRoot = aSourceMapConsumer.sourceRoot;
        var generator = new SourceMapGenerator({
          file: aSourceMapConsumer.file,
          sourceRoot
        });
        aSourceMapConsumer.eachMapping(function(mapping) {
          var newMapping = {
            generated: {
              line: mapping.generatedLine,
              column: mapping.generatedColumn
            }
          };
          if (mapping.source != null) {
            newMapping.source = mapping.source;
            if (sourceRoot != null) {
              newMapping.source = util.relative(sourceRoot, newMapping.source);
            }
            newMapping.original = {
              line: mapping.originalLine,
              column: mapping.originalColumn
            };
            if (mapping.name != null) {
              newMapping.name = mapping.name;
            }
          }
          generator.addMapping(newMapping);
        });
        aSourceMapConsumer.sources.forEach(function(sourceFile) {
          var content = aSourceMapConsumer.sourceContentFor(sourceFile);
          if (content != null) {
            generator.setSourceContent(sourceFile, content);
          }
        });
        return generator;
      };
      SourceMapGenerator.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
        var generated = util.getArg(aArgs, "generated");
        var original = util.getArg(aArgs, "original", null);
        var source = util.getArg(aArgs, "source", null);
        var name = util.getArg(aArgs, "name", null);
        if (!this._skipValidation) {
          this._validateMapping(generated, original, source, name);
        }
        if (source != null) {
          source = String(source);
          if (!this._sources.has(source)) {
            this._sources.add(source);
          }
        }
        if (name != null) {
          name = String(name);
          if (!this._names.has(name)) {
            this._names.add(name);
          }
        }
        this._mappings.add({
          generatedLine: generated.line,
          generatedColumn: generated.column,
          originalLine: original != null && original.line,
          originalColumn: original != null && original.column,
          source,
          name
        });
      };
      SourceMapGenerator.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
        var source = aSourceFile;
        if (this._sourceRoot != null) {
          source = util.relative(this._sourceRoot, source);
        }
        if (aSourceContent != null) {
          if (!this._sourcesContents) {
            this._sourcesContents = /* @__PURE__ */ Object.create(null);
          }
          this._sourcesContents[util.toSetString(source)] = aSourceContent;
        } else if (this._sourcesContents) {
          delete this._sourcesContents[util.toSetString(source)];
          if (Object.keys(this._sourcesContents).length === 0) {
            this._sourcesContents = null;
          }
        }
      };
      SourceMapGenerator.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
        var sourceFile = aSourceFile;
        if (aSourceFile == null) {
          if (aSourceMapConsumer.file == null) {
            throw new Error(
              `SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map's "file" property. Both were omitted.`
            );
          }
          sourceFile = aSourceMapConsumer.file;
        }
        var sourceRoot = this._sourceRoot;
        if (sourceRoot != null) {
          sourceFile = util.relative(sourceRoot, sourceFile);
        }
        var newSources = new ArraySet();
        var newNames = new ArraySet();
        this._mappings.unsortedForEach(function(mapping) {
          if (mapping.source === sourceFile && mapping.originalLine != null) {
            var original = aSourceMapConsumer.originalPositionFor({
              line: mapping.originalLine,
              column: mapping.originalColumn
            });
            if (original.source != null) {
              mapping.source = original.source;
              if (aSourceMapPath != null) {
                mapping.source = util.join(aSourceMapPath, mapping.source);
              }
              if (sourceRoot != null) {
                mapping.source = util.relative(sourceRoot, mapping.source);
              }
              mapping.originalLine = original.line;
              mapping.originalColumn = original.column;
              if (original.name != null) {
                mapping.name = original.name;
              }
            }
          }
          var source = mapping.source;
          if (source != null && !newSources.has(source)) {
            newSources.add(source);
          }
          var name = mapping.name;
          if (name != null && !newNames.has(name)) {
            newNames.add(name);
          }
        }, this);
        this._sources = newSources;
        this._names = newNames;
        aSourceMapConsumer.sources.forEach(function(sourceFile2) {
          var content = aSourceMapConsumer.sourceContentFor(sourceFile2);
          if (content != null) {
            if (aSourceMapPath != null) {
              sourceFile2 = util.join(aSourceMapPath, sourceFile2);
            }
            if (sourceRoot != null) {
              sourceFile2 = util.relative(sourceRoot, sourceFile2);
            }
            this.setSourceContent(sourceFile2, content);
          }
        }, this);
      };
      SourceMapGenerator.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
        if (aOriginal && typeof aOriginal.line !== "number" && typeof aOriginal.column !== "number") {
          throw new Error(
            "original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values."
          );
        }
        if (aGenerated && "line" in aGenerated && "column" in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) {
          return;
        } else if (aGenerated && "line" in aGenerated && "column" in aGenerated && aOriginal && "line" in aOriginal && "column" in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) {
          return;
        } else {
          throw new Error("Invalid mapping: " + JSON.stringify({
            generated: aGenerated,
            source: aSource,
            original: aOriginal,
            name: aName
          }));
        }
      };
      SourceMapGenerator.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
        var previousGeneratedColumn = 0;
        var previousGeneratedLine = 1;
        var previousOriginalColumn = 0;
        var previousOriginalLine = 0;
        var previousName = 0;
        var previousSource = 0;
        var result2 = "";
        var next;
        var mapping;
        var nameIdx;
        var sourceIdx;
        var mappings = this._mappings.toArray();
        for (var i = 0, len = mappings.length; i < len; i++) {
          mapping = mappings[i];
          next = "";
          if (mapping.generatedLine !== previousGeneratedLine) {
            previousGeneratedColumn = 0;
            while (mapping.generatedLine !== previousGeneratedLine) {
              next += ";";
              previousGeneratedLine++;
            }
          } else {
            if (i > 0) {
              if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
                continue;
              }
              next += ",";
            }
          }
          next += base64VLQ.encode(mapping.generatedColumn - previousGeneratedColumn);
          previousGeneratedColumn = mapping.generatedColumn;
          if (mapping.source != null) {
            sourceIdx = this._sources.indexOf(mapping.source);
            next += base64VLQ.encode(sourceIdx - previousSource);
            previousSource = sourceIdx;
            next += base64VLQ.encode(mapping.originalLine - 1 - previousOriginalLine);
            previousOriginalLine = mapping.originalLine - 1;
            next += base64VLQ.encode(mapping.originalColumn - previousOriginalColumn);
            previousOriginalColumn = mapping.originalColumn;
            if (mapping.name != null) {
              nameIdx = this._names.indexOf(mapping.name);
              next += base64VLQ.encode(nameIdx - previousName);
              previousName = nameIdx;
            }
          }
          result2 += next;
        }
        return result2;
      };
      SourceMapGenerator.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
        return aSources.map(function(source) {
          if (!this._sourcesContents) {
            return null;
          }
          if (aSourceRoot != null) {
            source = util.relative(aSourceRoot, source);
          }
          var key = util.toSetString(source);
          return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
        }, this);
      };
      SourceMapGenerator.prototype.toJSON = function SourceMapGenerator_toJSON() {
        var map2 = {
          version: this._version,
          sources: this._sources.toArray(),
          names: this._names.toArray(),
          mappings: this._serializeMappings()
        };
        if (this._file != null) {
          map2.file = this._file;
        }
        if (this._sourceRoot != null) {
          map2.sourceRoot = this._sourceRoot;
        }
        if (this._sourcesContents) {
          map2.sourcesContent = this._generateSourcesContent(map2.sources, map2.sourceRoot);
        }
        return map2;
      };
      SourceMapGenerator.prototype.toString = function SourceMapGenerator_toString() {
        return JSON.stringify(this.toJSON());
      };
      exports8.SourceMapGenerator = SourceMapGenerator;
    }
  });

  // ../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/binary-search.js
  var require_binary_search = __commonJS({
    "../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/binary-search.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      exports8.GREATEST_LOWER_BOUND = 1;
      exports8.LEAST_UPPER_BOUND = 2;
      function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
        var mid = Math.floor((aHigh - aLow) / 2) + aLow;
        var cmp = aCompare(aNeedle, aHaystack[mid], true);
        if (cmp === 0) {
          return mid;
        } else if (cmp > 0) {
          if (aHigh - mid > 1) {
            return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
          }
          if (aBias == exports8.LEAST_UPPER_BOUND) {
            return aHigh < aHaystack.length ? aHigh : -1;
          } else {
            return mid;
          }
        } else {
          if (mid - aLow > 1) {
            return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
          }
          if (aBias == exports8.LEAST_UPPER_BOUND) {
            return mid;
          } else {
            return aLow < 0 ? -1 : aLow;
          }
        }
      }
      exports8.search = function search(aNeedle, aHaystack, aCompare, aBias) {
        if (aHaystack.length === 0) {
          return -1;
        }
        var index = recursiveSearch(
          -1,
          aHaystack.length,
          aNeedle,
          aHaystack,
          aCompare,
          aBias || exports8.GREATEST_LOWER_BOUND
        );
        if (index < 0) {
          return -1;
        }
        while (index - 1 >= 0) {
          if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
            break;
          }
          --index;
        }
        return index;
      };
    }
  });

  // ../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/quick-sort.js
  var require_quick_sort = __commonJS({
    "../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/quick-sort.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      function swap(ary2, x, y) {
        var temp = ary2[x];
        ary2[x] = ary2[y];
        ary2[y] = temp;
      }
      function randomIntInRange(low, high) {
        return Math.round(low + Math.random() * (high - low));
      }
      function doQuickSort(ary2, comparator, p, r) {
        if (p < r) {
          var pivotIndex = randomIntInRange(p, r);
          var i = p - 1;
          swap(ary2, pivotIndex, r);
          var pivot = ary2[r];
          for (var j = p; j < r; j++) {
            if (comparator(ary2[j], pivot) <= 0) {
              i += 1;
              swap(ary2, i, j);
            }
          }
          swap(ary2, i + 1, j);
          var q = i + 1;
          doQuickSort(ary2, comparator, p, q - 1);
          doQuickSort(ary2, comparator, q + 1, r);
        }
      }
      exports8.quickSort = function(ary2, comparator) {
        doQuickSort(ary2, comparator, 0, ary2.length - 1);
      };
    }
  });

  // ../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/source-map-consumer.js
  var require_source_map_consumer = __commonJS({
    "../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/source-map-consumer.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var util = require_util2();
      var binarySearch = require_binary_search();
      var ArraySet = require_array_set().ArraySet;
      var base64VLQ = require_base64_vlq();
      var quickSort = require_quick_sort().quickSort;
      function SourceMapConsumer(aSourceMap) {
        var sourceMap = aSourceMap;
        if (typeof aSourceMap === "string") {
          sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
        }
        return sourceMap.sections != null ? new IndexedSourceMapConsumer(sourceMap) : new BasicSourceMapConsumer(sourceMap);
      }
      SourceMapConsumer.fromSourceMap = function(aSourceMap) {
        return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
      };
      SourceMapConsumer.prototype._version = 3;
      SourceMapConsumer.prototype.__generatedMappings = null;
      Object.defineProperty(SourceMapConsumer.prototype, "_generatedMappings", {
        get: function() {
          if (!this.__generatedMappings) {
            this._parseMappings(this._mappings, this.sourceRoot);
          }
          return this.__generatedMappings;
        }
      });
      SourceMapConsumer.prototype.__originalMappings = null;
      Object.defineProperty(SourceMapConsumer.prototype, "_originalMappings", {
        get: function() {
          if (!this.__originalMappings) {
            this._parseMappings(this._mappings, this.sourceRoot);
          }
          return this.__originalMappings;
        }
      });
      SourceMapConsumer.prototype._charIsMappingSeparator = function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
        var c = aStr.charAt(index);
        return c === ";" || c === ",";
      };
      SourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
        throw new Error("Subclasses must implement _parseMappings");
      };
      SourceMapConsumer.GENERATED_ORDER = 1;
      SourceMapConsumer.ORIGINAL_ORDER = 2;
      SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
      SourceMapConsumer.LEAST_UPPER_BOUND = 2;
      SourceMapConsumer.prototype.eachMapping = function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
        var context = aContext || null;
        var order = aOrder || SourceMapConsumer.GENERATED_ORDER;
        var mappings;
        switch (order) {
          case SourceMapConsumer.GENERATED_ORDER:
            mappings = this._generatedMappings;
            break;
          case SourceMapConsumer.ORIGINAL_ORDER:
            mappings = this._originalMappings;
            break;
          default:
            throw new Error("Unknown order of iteration.");
        }
        var sourceRoot = this.sourceRoot;
        mappings.map(function(mapping) {
          var source = mapping.source === null ? null : this._sources.at(mapping.source);
          if (source != null && sourceRoot != null) {
            source = util.join(sourceRoot, source);
          }
          return {
            source,
            generatedLine: mapping.generatedLine,
            generatedColumn: mapping.generatedColumn,
            originalLine: mapping.originalLine,
            originalColumn: mapping.originalColumn,
            name: mapping.name === null ? null : this._names.at(mapping.name)
          };
        }, this).forEach(aCallback, context);
      };
      SourceMapConsumer.prototype.allGeneratedPositionsFor = function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
        var line = util.getArg(aArgs, "line");
        var needle = {
          source: util.getArg(aArgs, "source"),
          originalLine: line,
          originalColumn: util.getArg(aArgs, "column", 0)
        };
        if (this.sourceRoot != null) {
          needle.source = util.relative(this.sourceRoot, needle.source);
        }
        if (!this._sources.has(needle.source)) {
          return [];
        }
        needle.source = this._sources.indexOf(needle.source);
        var mappings = [];
        var index = this._findMapping(
          needle,
          this._originalMappings,
          "originalLine",
          "originalColumn",
          util.compareByOriginalPositions,
          binarySearch.LEAST_UPPER_BOUND
        );
        if (index >= 0) {
          var mapping = this._originalMappings[index];
          if (aArgs.column === void 0) {
            var originalLine = mapping.originalLine;
            while (mapping && mapping.originalLine === originalLine) {
              mappings.push({
                line: util.getArg(mapping, "generatedLine", null),
                column: util.getArg(mapping, "generatedColumn", null),
                lastColumn: util.getArg(mapping, "lastGeneratedColumn", null)
              });
              mapping = this._originalMappings[++index];
            }
          } else {
            var originalColumn = mapping.originalColumn;
            while (mapping && mapping.originalLine === line && mapping.originalColumn == originalColumn) {
              mappings.push({
                line: util.getArg(mapping, "generatedLine", null),
                column: util.getArg(mapping, "generatedColumn", null),
                lastColumn: util.getArg(mapping, "lastGeneratedColumn", null)
              });
              mapping = this._originalMappings[++index];
            }
          }
        }
        return mappings;
      };
      exports8.SourceMapConsumer = SourceMapConsumer;
      function BasicSourceMapConsumer(aSourceMap) {
        var sourceMap = aSourceMap;
        if (typeof aSourceMap === "string") {
          sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
        }
        var version3 = util.getArg(sourceMap, "version");
        var sources = util.getArg(sourceMap, "sources");
        var names = util.getArg(sourceMap, "names", []);
        var sourceRoot = util.getArg(sourceMap, "sourceRoot", null);
        var sourcesContent = util.getArg(sourceMap, "sourcesContent", null);
        var mappings = util.getArg(sourceMap, "mappings");
        var file2 = util.getArg(sourceMap, "file", null);
        if (version3 != this._version) {
          throw new Error("Unsupported version: " + version3);
        }
        sources = sources.map(String).map(util.normalize).map(function(source) {
          return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source) ? util.relative(sourceRoot, source) : source;
        });
        this._names = ArraySet.fromArray(names.map(String), true);
        this._sources = ArraySet.fromArray(sources, true);
        this.sourceRoot = sourceRoot;
        this.sourcesContent = sourcesContent;
        this._mappings = mappings;
        this.file = file2;
      }
      BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
      BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;
      BasicSourceMapConsumer.fromSourceMap = function SourceMapConsumer_fromSourceMap(aSourceMap) {
        var smc = Object.create(BasicSourceMapConsumer.prototype);
        var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
        var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
        smc.sourceRoot = aSourceMap._sourceRoot;
        smc.sourcesContent = aSourceMap._generateSourcesContent(
          smc._sources.toArray(),
          smc.sourceRoot
        );
        smc.file = aSourceMap._file;
        var generatedMappings = aSourceMap._mappings.toArray().slice();
        var destGeneratedMappings = smc.__generatedMappings = [];
        var destOriginalMappings = smc.__originalMappings = [];
        for (var i = 0, length = generatedMappings.length; i < length; i++) {
          var srcMapping = generatedMappings[i];
          var destMapping = new Mapping();
          destMapping.generatedLine = srcMapping.generatedLine;
          destMapping.generatedColumn = srcMapping.generatedColumn;
          if (srcMapping.source) {
            destMapping.source = sources.indexOf(srcMapping.source);
            destMapping.originalLine = srcMapping.originalLine;
            destMapping.originalColumn = srcMapping.originalColumn;
            if (srcMapping.name) {
              destMapping.name = names.indexOf(srcMapping.name);
            }
            destOriginalMappings.push(destMapping);
          }
          destGeneratedMappings.push(destMapping);
        }
        quickSort(smc.__originalMappings, util.compareByOriginalPositions);
        return smc;
      };
      BasicSourceMapConsumer.prototype._version = 3;
      Object.defineProperty(BasicSourceMapConsumer.prototype, "sources", {
        get: function() {
          return this._sources.toArray().map(function(s) {
            return this.sourceRoot != null ? util.join(this.sourceRoot, s) : s;
          }, this);
        }
      });
      function Mapping() {
        this.generatedLine = 0;
        this.generatedColumn = 0;
        this.source = null;
        this.originalLine = null;
        this.originalColumn = null;
        this.name = null;
      }
      BasicSourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
        var generatedLine = 1;
        var previousGeneratedColumn = 0;
        var previousOriginalLine = 0;
        var previousOriginalColumn = 0;
        var previousSource = 0;
        var previousName = 0;
        var length = aStr.length;
        var index = 0;
        var cachedSegments = {};
        var temp = {};
        var originalMappings = [];
        var generatedMappings = [];
        var mapping, str, segment, end, value;
        while (index < length) {
          if (aStr.charAt(index) === ";") {
            generatedLine++;
            index++;
            previousGeneratedColumn = 0;
          } else if (aStr.charAt(index) === ",") {
            index++;
          } else {
            mapping = new Mapping();
            mapping.generatedLine = generatedLine;
            for (end = index; end < length; end++) {
              if (this._charIsMappingSeparator(aStr, end)) {
                break;
              }
            }
            str = aStr.slice(index, end);
            segment = cachedSegments[str];
            if (segment) {
              index += str.length;
            } else {
              segment = [];
              while (index < end) {
                base64VLQ.decode(aStr, index, temp);
                value = temp.value;
                index = temp.rest;
                segment.push(value);
              }
              if (segment.length === 2) {
                throw new Error("Found a source, but no line and column");
              }
              if (segment.length === 3) {
                throw new Error("Found a source and line, but no column");
              }
              cachedSegments[str] = segment;
            }
            mapping.generatedColumn = previousGeneratedColumn + segment[0];
            previousGeneratedColumn = mapping.generatedColumn;
            if (segment.length > 1) {
              mapping.source = previousSource + segment[1];
              previousSource += segment[1];
              mapping.originalLine = previousOriginalLine + segment[2];
              previousOriginalLine = mapping.originalLine;
              mapping.originalLine += 1;
              mapping.originalColumn = previousOriginalColumn + segment[3];
              previousOriginalColumn = mapping.originalColumn;
              if (segment.length > 4) {
                mapping.name = previousName + segment[4];
                previousName += segment[4];
              }
            }
            generatedMappings.push(mapping);
            if (typeof mapping.originalLine === "number") {
              originalMappings.push(mapping);
            }
          }
        }
        quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
        this.__generatedMappings = generatedMappings;
        quickSort(originalMappings, util.compareByOriginalPositions);
        this.__originalMappings = originalMappings;
      };
      BasicSourceMapConsumer.prototype._findMapping = function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName, aColumnName, aComparator, aBias) {
        if (aNeedle[aLineName] <= 0) {
          throw new TypeError("Line must be greater than or equal to 1, got " + aNeedle[aLineName]);
        }
        if (aNeedle[aColumnName] < 0) {
          throw new TypeError("Column must be greater than or equal to 0, got " + aNeedle[aColumnName]);
        }
        return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
      };
      BasicSourceMapConsumer.prototype.computeColumnSpans = function SourceMapConsumer_computeColumnSpans() {
        for (var index = 0; index < this._generatedMappings.length; ++index) {
          var mapping = this._generatedMappings[index];
          if (index + 1 < this._generatedMappings.length) {
            var nextMapping = this._generatedMappings[index + 1];
            if (mapping.generatedLine === nextMapping.generatedLine) {
              mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
              continue;
            }
          }
          mapping.lastGeneratedColumn = Infinity;
        }
      };
      BasicSourceMapConsumer.prototype.originalPositionFor = function SourceMapConsumer_originalPositionFor(aArgs) {
        var needle = {
          generatedLine: util.getArg(aArgs, "line"),
          generatedColumn: util.getArg(aArgs, "column")
        };
        var index = this._findMapping(
          needle,
          this._generatedMappings,
          "generatedLine",
          "generatedColumn",
          util.compareByGeneratedPositionsDeflated,
          util.getArg(aArgs, "bias", SourceMapConsumer.GREATEST_LOWER_BOUND)
        );
        if (index >= 0) {
          var mapping = this._generatedMappings[index];
          if (mapping.generatedLine === needle.generatedLine) {
            var source = util.getArg(mapping, "source", null);
            if (source !== null) {
              source = this._sources.at(source);
              if (this.sourceRoot != null) {
                source = util.join(this.sourceRoot, source);
              }
            }
            var name = util.getArg(mapping, "name", null);
            if (name !== null) {
              name = this._names.at(name);
            }
            return {
              source,
              line: util.getArg(mapping, "originalLine", null),
              column: util.getArg(mapping, "originalColumn", null),
              name
            };
          }
        }
        return {
          source: null,
          line: null,
          column: null,
          name: null
        };
      };
      BasicSourceMapConsumer.prototype.hasContentsOfAllSources = function BasicSourceMapConsumer_hasContentsOfAllSources() {
        if (!this.sourcesContent) {
          return false;
        }
        return this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(sc) {
          return sc == null;
        });
      };
      BasicSourceMapConsumer.prototype.sourceContentFor = function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
        if (!this.sourcesContent) {
          return null;
        }
        if (this.sourceRoot != null) {
          aSource = util.relative(this.sourceRoot, aSource);
        }
        if (this._sources.has(aSource)) {
          return this.sourcesContent[this._sources.indexOf(aSource)];
        }
        var url;
        if (this.sourceRoot != null && (url = util.urlParse(this.sourceRoot))) {
          var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
          if (url.scheme == "file" && this._sources.has(fileUriAbsPath)) {
            return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];
          }
          if ((!url.path || url.path == "/") && this._sources.has("/" + aSource)) {
            return this.sourcesContent[this._sources.indexOf("/" + aSource)];
          }
        }
        if (nullOnMissing) {
          return null;
        } else {
          throw new Error('"' + aSource + '" is not in the SourceMap.');
        }
      };
      BasicSourceMapConsumer.prototype.generatedPositionFor = function SourceMapConsumer_generatedPositionFor(aArgs) {
        var source = util.getArg(aArgs, "source");
        if (this.sourceRoot != null) {
          source = util.relative(this.sourceRoot, source);
        }
        if (!this._sources.has(source)) {
          return {
            line: null,
            column: null,
            lastColumn: null
          };
        }
        source = this._sources.indexOf(source);
        var needle = {
          source,
          originalLine: util.getArg(aArgs, "line"),
          originalColumn: util.getArg(aArgs, "column")
        };
        var index = this._findMapping(
          needle,
          this._originalMappings,
          "originalLine",
          "originalColumn",
          util.compareByOriginalPositions,
          util.getArg(aArgs, "bias", SourceMapConsumer.GREATEST_LOWER_BOUND)
        );
        if (index >= 0) {
          var mapping = this._originalMappings[index];
          if (mapping.source === needle.source) {
            return {
              line: util.getArg(mapping, "generatedLine", null),
              column: util.getArg(mapping, "generatedColumn", null),
              lastColumn: util.getArg(mapping, "lastGeneratedColumn", null)
            };
          }
        }
        return {
          line: null,
          column: null,
          lastColumn: null
        };
      };
      exports8.BasicSourceMapConsumer = BasicSourceMapConsumer;
      function IndexedSourceMapConsumer(aSourceMap) {
        var sourceMap = aSourceMap;
        if (typeof aSourceMap === "string") {
          sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
        }
        var version3 = util.getArg(sourceMap, "version");
        var sections = util.getArg(sourceMap, "sections");
        if (version3 != this._version) {
          throw new Error("Unsupported version: " + version3);
        }
        this._sources = new ArraySet();
        this._names = new ArraySet();
        var lastOffset = {
          line: -1,
          column: 0
        };
        this._sections = sections.map(function(s) {
          if (s.url) {
            throw new Error("Support for url field in sections not implemented.");
          }
          var offset = util.getArg(s, "offset");
          var offsetLine = util.getArg(offset, "line");
          var offsetColumn = util.getArg(offset, "column");
          if (offsetLine < lastOffset.line || offsetLine === lastOffset.line && offsetColumn < lastOffset.column) {
            throw new Error("Section offsets must be ordered and non-overlapping.");
          }
          lastOffset = offset;
          return {
            generatedOffset: {
              generatedLine: offsetLine + 1,
              generatedColumn: offsetColumn + 1
            },
            consumer: new SourceMapConsumer(util.getArg(s, "map"))
          };
        });
      }
      IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
      IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;
      IndexedSourceMapConsumer.prototype._version = 3;
      Object.defineProperty(IndexedSourceMapConsumer.prototype, "sources", {
        get: function() {
          var sources = [];
          for (var i = 0; i < this._sections.length; i++) {
            for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
              sources.push(this._sections[i].consumer.sources[j]);
            }
          }
          return sources;
        }
      });
      IndexedSourceMapConsumer.prototype.originalPositionFor = function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
        var needle = {
          generatedLine: util.getArg(aArgs, "line"),
          generatedColumn: util.getArg(aArgs, "column")
        };
        var sectionIndex = binarySearch.search(
          needle,
          this._sections,
          function(needle2, section2) {
            var cmp = needle2.generatedLine - section2.generatedOffset.generatedLine;
            if (cmp) {
              return cmp;
            }
            return needle2.generatedColumn - section2.generatedOffset.generatedColumn;
          }
        );
        var section = this._sections[sectionIndex];
        if (!section) {
          return {
            source: null,
            line: null,
            column: null,
            name: null
          };
        }
        return section.consumer.originalPositionFor({
          line: needle.generatedLine - (section.generatedOffset.generatedLine - 1),
          column: needle.generatedColumn - (section.generatedOffset.generatedLine === needle.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
          bias: aArgs.bias
        });
      };
      IndexedSourceMapConsumer.prototype.hasContentsOfAllSources = function IndexedSourceMapConsumer_hasContentsOfAllSources() {
        return this._sections.every(function(s) {
          return s.consumer.hasContentsOfAllSources();
        });
      };
      IndexedSourceMapConsumer.prototype.sourceContentFor = function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
        for (var i = 0; i < this._sections.length; i++) {
          var section = this._sections[i];
          var content = section.consumer.sourceContentFor(aSource, true);
          if (content) {
            return content;
          }
        }
        if (nullOnMissing) {
          return null;
        } else {
          throw new Error('"' + aSource + '" is not in the SourceMap.');
        }
      };
      IndexedSourceMapConsumer.prototype.generatedPositionFor = function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
        for (var i = 0; i < this._sections.length; i++) {
          var section = this._sections[i];
          if (section.consumer.sources.indexOf(util.getArg(aArgs, "source")) === -1) {
            continue;
          }
          var generatedPosition = section.consumer.generatedPositionFor(aArgs);
          if (generatedPosition) {
            var ret = {
              line: generatedPosition.line + (section.generatedOffset.generatedLine - 1),
              column: generatedPosition.column + (section.generatedOffset.generatedLine === generatedPosition.line ? section.generatedOffset.generatedColumn - 1 : 0)
            };
            return ret;
          }
        }
        return {
          line: null,
          column: null
        };
      };
      IndexedSourceMapConsumer.prototype._parseMappings = function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
        this.__generatedMappings = [];
        this.__originalMappings = [];
        for (var i = 0; i < this._sections.length; i++) {
          var section = this._sections[i];
          var sectionMappings = section.consumer._generatedMappings;
          for (var j = 0; j < sectionMappings.length; j++) {
            var mapping = sectionMappings[j];
            var source = section.consumer._sources.at(mapping.source);
            if (section.consumer.sourceRoot !== null) {
              source = util.join(section.consumer.sourceRoot, source);
            }
            this._sources.add(source);
            source = this._sources.indexOf(source);
            var name = section.consumer._names.at(mapping.name);
            this._names.add(name);
            name = this._names.indexOf(name);
            var adjustedMapping = {
              source,
              generatedLine: mapping.generatedLine + (section.generatedOffset.generatedLine - 1),
              generatedColumn: mapping.generatedColumn + (section.generatedOffset.generatedLine === mapping.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
              originalLine: mapping.originalLine,
              originalColumn: mapping.originalColumn,
              name
            };
            this.__generatedMappings.push(adjustedMapping);
            if (typeof adjustedMapping.originalLine === "number") {
              this.__originalMappings.push(adjustedMapping);
            }
          }
        }
        quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
        quickSort(this.__originalMappings, util.compareByOriginalPositions);
      };
      exports8.IndexedSourceMapConsumer = IndexedSourceMapConsumer;
    }
  });

  // ../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/source-node.js
  var require_source_node = __commonJS({
    "../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/lib/source-node.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var SourceMapGenerator = require_source_map_generator().SourceMapGenerator;
      var util = require_util2();
      var REGEX_NEWLINE = /(\r?\n)/;
      var NEWLINE_CODE = 10;
      var isSourceNode = "$$$isSourceNode$$$";
      function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
        this.children = [];
        this.sourceContents = {};
        this.line = aLine == null ? null : aLine;
        this.column = aColumn == null ? null : aColumn;
        this.source = aSource == null ? null : aSource;
        this.name = aName == null ? null : aName;
        this[isSourceNode] = true;
        if (aChunks != null)
          this.add(aChunks);
      }
      SourceNode.fromStringWithSourceMap = function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
        var node = new SourceNode();
        var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
        var remainingLinesIndex = 0;
        var shiftNextLine = function() {
          var lineContents = getNextLine();
          var newLine = getNextLine() || "";
          return lineContents + newLine;
          function getNextLine() {
            return remainingLinesIndex < remainingLines.length ? remainingLines[remainingLinesIndex++] : void 0;
          }
        };
        var lastGeneratedLine = 1, lastGeneratedColumn = 0;
        var lastMapping = null;
        aSourceMapConsumer.eachMapping(function(mapping) {
          if (lastMapping !== null) {
            if (lastGeneratedLine < mapping.generatedLine) {
              addMappingWithCode(lastMapping, shiftNextLine());
              lastGeneratedLine++;
              lastGeneratedColumn = 0;
            } else {
              var nextLine = remainingLines[remainingLinesIndex];
              var code = nextLine.substr(0, mapping.generatedColumn - lastGeneratedColumn);
              remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn - lastGeneratedColumn);
              lastGeneratedColumn = mapping.generatedColumn;
              addMappingWithCode(lastMapping, code);
              lastMapping = mapping;
              return;
            }
          }
          while (lastGeneratedLine < mapping.generatedLine) {
            node.add(shiftNextLine());
            lastGeneratedLine++;
          }
          if (lastGeneratedColumn < mapping.generatedColumn) {
            var nextLine = remainingLines[remainingLinesIndex];
            node.add(nextLine.substr(0, mapping.generatedColumn));
            remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
            lastGeneratedColumn = mapping.generatedColumn;
          }
          lastMapping = mapping;
        }, this);
        if (remainingLinesIndex < remainingLines.length) {
          if (lastMapping) {
            addMappingWithCode(lastMapping, shiftNextLine());
          }
          node.add(remainingLines.splice(remainingLinesIndex).join(""));
        }
        aSourceMapConsumer.sources.forEach(function(sourceFile) {
          var content = aSourceMapConsumer.sourceContentFor(sourceFile);
          if (content != null) {
            if (aRelativePath != null) {
              sourceFile = util.join(aRelativePath, sourceFile);
            }
            node.setSourceContent(sourceFile, content);
          }
        });
        return node;
        function addMappingWithCode(mapping, code) {
          if (mapping === null || mapping.source === void 0) {
            node.add(code);
          } else {
            var source = aRelativePath ? util.join(aRelativePath, mapping.source) : mapping.source;
            node.add(new SourceNode(
              mapping.originalLine,
              mapping.originalColumn,
              source,
              code,
              mapping.name
            ));
          }
        }
      };
      SourceNode.prototype.add = function SourceNode_add(aChunk) {
        if (Array.isArray(aChunk)) {
          aChunk.forEach(function(chunk2) {
            this.add(chunk2);
          }, this);
        } else if (aChunk[isSourceNode] || typeof aChunk === "string") {
          if (aChunk) {
            this.children.push(aChunk);
          }
        } else {
          throw new TypeError(
            "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
          );
        }
        return this;
      };
      SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
        if (Array.isArray(aChunk)) {
          for (var i = aChunk.length - 1; i >= 0; i--) {
            this.prepend(aChunk[i]);
          }
        } else if (aChunk[isSourceNode] || typeof aChunk === "string") {
          this.children.unshift(aChunk);
        } else {
          throw new TypeError(
            "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
          );
        }
        return this;
      };
      SourceNode.prototype.walk = function SourceNode_walk(aFn) {
        var chunk2;
        for (var i = 0, len = this.children.length; i < len; i++) {
          chunk2 = this.children[i];
          if (chunk2[isSourceNode]) {
            chunk2.walk(aFn);
          } else {
            if (chunk2 !== "") {
              aFn(chunk2, {
                source: this.source,
                line: this.line,
                column: this.column,
                name: this.name
              });
            }
          }
        }
      };
      SourceNode.prototype.join = function SourceNode_join(aSep) {
        var newChildren;
        var i;
        var len = this.children.length;
        if (len > 0) {
          newChildren = [];
          for (i = 0; i < len - 1; i++) {
            newChildren.push(this.children[i]);
            newChildren.push(aSep);
          }
          newChildren.push(this.children[i]);
          this.children = newChildren;
        }
        return this;
      };
      SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
        var lastChild = this.children[this.children.length - 1];
        if (lastChild[isSourceNode]) {
          lastChild.replaceRight(aPattern, aReplacement);
        } else if (typeof lastChild === "string") {
          this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
        } else {
          this.children.push("".replace(aPattern, aReplacement));
        }
        return this;
      };
      SourceNode.prototype.setSourceContent = function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
        this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
      };
      SourceNode.prototype.walkSourceContents = function SourceNode_walkSourceContents(aFn) {
        for (var i = 0, len = this.children.length; i < len; i++) {
          if (this.children[i][isSourceNode]) {
            this.children[i].walkSourceContents(aFn);
          }
        }
        var sources = Object.keys(this.sourceContents);
        for (var i = 0, len = sources.length; i < len; i++) {
          aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
        }
      };
      SourceNode.prototype.toString = function SourceNode_toString() {
        var str = "";
        this.walk(function(chunk2) {
          str += chunk2;
        });
        return str;
      };
      SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
        var generated = {
          code: "",
          line: 1,
          column: 0
        };
        var map2 = new SourceMapGenerator(aArgs);
        var sourceMappingActive = false;
        var lastOriginalSource = null;
        var lastOriginalLine = null;
        var lastOriginalColumn = null;
        var lastOriginalName = null;
        this.walk(function(chunk2, original) {
          generated.code += chunk2;
          if (original.source !== null && original.line !== null && original.column !== null) {
            if (lastOriginalSource !== original.source || lastOriginalLine !== original.line || lastOriginalColumn !== original.column || lastOriginalName !== original.name) {
              map2.addMapping({
                source: original.source,
                original: {
                  line: original.line,
                  column: original.column
                },
                generated: {
                  line: generated.line,
                  column: generated.column
                },
                name: original.name
              });
            }
            lastOriginalSource = original.source;
            lastOriginalLine = original.line;
            lastOriginalColumn = original.column;
            lastOriginalName = original.name;
            sourceMappingActive = true;
          } else if (sourceMappingActive) {
            map2.addMapping({
              generated: {
                line: generated.line,
                column: generated.column
              }
            });
            lastOriginalSource = null;
            sourceMappingActive = false;
          }
          for (var idx = 0, length = chunk2.length; idx < length; idx++) {
            if (chunk2.charCodeAt(idx) === NEWLINE_CODE) {
              generated.line++;
              generated.column = 0;
              if (idx + 1 === length) {
                lastOriginalSource = null;
                sourceMappingActive = false;
              } else if (sourceMappingActive) {
                map2.addMapping({
                  source: original.source,
                  original: {
                    line: original.line,
                    column: original.column
                  },
                  generated: {
                    line: generated.line,
                    column: generated.column
                  },
                  name: original.name
                });
              }
            } else {
              generated.column++;
            }
          }
        });
        this.walkSourceContents(function(sourceFile, sourceContent) {
          map2.setSourceContent(sourceFile, sourceContent);
        });
        return { code: generated.code, map: map2 };
      };
      exports8.SourceNode = SourceNode;
    }
  });

  // ../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/source-map.js
  var require_source_map = __commonJS({
    "../../node_modules/.pnpm/source-map@0.5.7/node_modules/source-map/source-map.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      exports8.SourceMapGenerator = require_source_map_generator().SourceMapGenerator;
      exports8.SourceMapConsumer = require_source_map_consumer().SourceMapConsumer;
      exports8.SourceNode = require_source_node().SourceNode;
    }
  });

  // ../../node_modules/.pnpm/source-map-url@0.4.1/node_modules/source-map-url/source-map-url.js
  var require_source_map_url = __commonJS({
    "../../node_modules/.pnpm/source-map-url@0.4.1/node_modules/source-map-url/source-map-url.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      void function(root2, factory2) {
        if (typeof define === "function" && define.amd) {
          define(factory2);
        } else if (typeof exports8 === "object") {
          module2.exports = factory2();
        } else {
          root2.sourceMappingURL = factory2();
        }
      }(exports8, function() {
        var innerRegex = /[#@] sourceMappingURL=([^\s'"]*)/;
        var regex = RegExp(
          "(?:/\\*(?:\\s*\r?\n(?://)?)?(?:" + innerRegex.source + ")\\s*\\*/|//(?:" + innerRegex.source + "))\\s*"
        );
        return {
          regex,
          _innerRegex: innerRegex,
          getFrom: function(code) {
            var match = code.match(regex);
            return match ? match[1] || match[2] || "" : null;
          },
          existsIn: function(code) {
            return regex.test(code);
          },
          removeFrom: function(code) {
            return code.replace(regex, "");
          },
          insertBefore: function(code, string) {
            var match = code.match(regex);
            if (match) {
              return code.slice(0, match.index) + string + code.slice(match.index);
            } else {
              return code + string;
            }
          }
        };
      });
    }
  });

  // ../../node_modules/.pnpm/resolve-url@0.2.1/node_modules/resolve-url/resolve-url.js
  var require_resolve_url = __commonJS({
    "../../node_modules/.pnpm/resolve-url@0.2.1/node_modules/resolve-url/resolve-url.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      void function(root2, factory2) {
        if (typeof define === "function" && define.amd) {
          define(factory2);
        } else if (typeof exports8 === "object") {
          module2.exports = factory2();
        } else {
          root2.resolveUrl = factory2();
        }
      }(exports8, function() {
        function resolveUrl() {
          var numUrls = arguments.length;
          if (numUrls === 0) {
            throw new Error("resolveUrl requires at least one argument; got none.");
          }
          var base = document.createElement("base");
          base.href = arguments[0];
          if (numUrls === 1) {
            return base.href;
          }
          var head2 = document.getElementsByTagName("head")[0];
          head2.insertBefore(base, head2.firstChild);
          var a = document.createElement("a");
          var resolved;
          for (var index = 1; index < numUrls; index++) {
            a.href = arguments[index];
            resolved = a.href;
            base.href = resolved;
          }
          head2.removeChild(base);
          return resolved;
        }
        return resolveUrl;
      });
    }
  });

  // ../../node_modules/.pnpm/source-map-resolve@0.5.3/node_modules/source-map-resolve/source-map-resolve.js
  var require_source_map_resolve = __commonJS({
    "../../node_modules/.pnpm/source-map-resolve@0.5.3/node_modules/source-map-resolve/source-map-resolve.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      void function(root2, factory2) {
        if (typeof define === "function" && define.amd) {
          define(["source-map-url", "resolve-url"], factory2);
        } else if (typeof exports8 === "object") {
          var sourceMappingURL = require_source_map_url();
          var resolveUrl = require_resolve_url();
          module2.exports = factory2(sourceMappingURL, resolveUrl);
        } else {
          root2.sourceMapResolve = factory2(root2.sourceMappingURL, root2.resolveUrl);
        }
      }(exports8, function(sourceMappingURL, resolveUrl) {
        function callbackAsync(callback, error, result2) {
          setImmediate(function() {
            callback(error, result2);
          });
        }
        function parseMapToJSON(string, data) {
          try {
            return JSON.parse(string.replace(/^\)\]\}'/, ""));
          } catch (error) {
            error.sourceMapData = data;
            throw error;
          }
        }
        function readSync(read, url, data) {
          var readUrl = url;
          try {
            return String(read(readUrl));
          } catch (error) {
            error.sourceMapData = data;
            throw error;
          }
        }
        function resolveSourceMap(code, codeUrl, read, callback) {
          var mapData;
          try {
            mapData = resolveSourceMapHelper(code, codeUrl);
          } catch (error) {
            return callbackAsync(callback, error);
          }
          if (!mapData || mapData.map) {
            return callbackAsync(callback, null, mapData);
          }
          var readUrl = mapData.url;
          read(readUrl, function(error, result2) {
            if (error) {
              error.sourceMapData = mapData;
              return callback(error);
            }
            mapData.map = String(result2);
            try {
              mapData.map = parseMapToJSON(mapData.map, mapData);
            } catch (error2) {
              return callback(error2);
            }
            callback(null, mapData);
          });
        }
        function resolveSourceMapSync(code, codeUrl, read) {
          var mapData = resolveSourceMapHelper(code, codeUrl);
          if (!mapData || mapData.map) {
            return mapData;
          }
          mapData.map = readSync(read, mapData.url, mapData);
          mapData.map = parseMapToJSON(mapData.map, mapData);
          return mapData;
        }
        var dataUriRegex = /^data:([^,;]*)(;[^,;]*)*(?:,(.*))?$/;
        var jsonMimeTypeRegex = /^(?:application|text)\/json$/;
        var jsonCharacterEncoding = "utf-8";
        function base64ToBuf(b64) {
          var binStr = atob(b64);
          var len = binStr.length;
          var arr = new Uint8Array(len);
          for (var i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i);
          }
          return arr;
        }
        function decodeBase64String(b64) {
          if (typeof TextDecoder === "undefined" || typeof Uint8Array === "undefined") {
            return atob(b64);
          }
          var buf = base64ToBuf(b64);
          var decoder = new TextDecoder(jsonCharacterEncoding, { fatal: true });
          return decoder.decode(buf);
        }
        function resolveSourceMapHelper(code, codeUrl) {
          var url = sourceMappingURL.getFrom(code);
          if (!url) {
            return null;
          }
          var dataUri = url.match(dataUriRegex);
          if (dataUri) {
            var mimeType = dataUri[1] || "text/plain";
            var lastParameter = dataUri[2] || "";
            var encoded = dataUri[3] || "";
            var data = {
              sourceMappingURL: url,
              url: null,
              sourcesRelativeTo: codeUrl,
              map: encoded
            };
            if (!jsonMimeTypeRegex.test(mimeType)) {
              var error = new Error("Unuseful data uri mime type: " + mimeType);
              error.sourceMapData = data;
              throw error;
            }
            try {
              data.map = parseMapToJSON(
                lastParameter === ";base64" ? decodeBase64String(encoded) : decodeURIComponent(encoded),
                data
              );
            } catch (error2) {
              error2.sourceMapData = data;
              throw error2;
            }
            return data;
          }
          var mapUrl = resolveUrl(codeUrl, url);
          return {
            sourceMappingURL: url,
            url: mapUrl,
            sourcesRelativeTo: mapUrl,
            map: null
          };
        }
        function resolveSources(map2, mapUrl, read, options, callback) {
          if (typeof options === "function") {
            callback = options;
            options = {};
          }
          var pending = map2.sources ? map2.sources.length : 0;
          var result2 = {
            sourcesResolved: [],
            sourcesContent: []
          };
          if (pending === 0) {
            callbackAsync(callback, null, result2);
            return;
          }
          var done = function() {
            pending--;
            if (pending === 0) {
              callback(null, result2);
            }
          };
          resolveSourcesHelper(map2, mapUrl, options, function(fullUrl, sourceContent, index) {
            result2.sourcesResolved[index] = fullUrl;
            if (typeof sourceContent === "string") {
              result2.sourcesContent[index] = sourceContent;
              callbackAsync(done, null);
            } else {
              var readUrl = fullUrl;
              read(readUrl, function(error, source) {
                result2.sourcesContent[index] = error ? error : String(source);
                done();
              });
            }
          });
        }
        function resolveSourcesSync(map2, mapUrl, read, options) {
          var result2 = {
            sourcesResolved: [],
            sourcesContent: []
          };
          if (!map2.sources || map2.sources.length === 0) {
            return result2;
          }
          resolveSourcesHelper(map2, mapUrl, options, function(fullUrl, sourceContent, index) {
            result2.sourcesResolved[index] = fullUrl;
            if (read !== null) {
              if (typeof sourceContent === "string") {
                result2.sourcesContent[index] = sourceContent;
              } else {
                var readUrl = fullUrl;
                try {
                  result2.sourcesContent[index] = String(read(readUrl));
                } catch (error) {
                  result2.sourcesContent[index] = error;
                }
              }
            }
          });
          return result2;
        }
        var endingSlash = /\/?$/;
        function resolveSourcesHelper(map2, mapUrl, options, fn) {
          options = options || {};
          var fullUrl;
          var sourceContent;
          var sourceRoot;
          for (var index = 0, len = map2.sources.length; index < len; index++) {
            sourceRoot = null;
            if (typeof options.sourceRoot === "string") {
              sourceRoot = options.sourceRoot;
            } else if (typeof map2.sourceRoot === "string" && options.sourceRoot !== false) {
              sourceRoot = map2.sourceRoot;
            }
            if (sourceRoot === null || sourceRoot === "") {
              fullUrl = resolveUrl(mapUrl, map2.sources[index]);
            } else {
              fullUrl = resolveUrl(mapUrl, sourceRoot.replace(endingSlash, "/"), map2.sources[index]);
            }
            sourceContent = (map2.sourcesContent || [])[index];
            fn(fullUrl, sourceContent, index);
          }
        }
        function resolve2(code, codeUrl, read, options, callback) {
          if (typeof options === "function") {
            callback = options;
            options = {};
          }
          if (code === null) {
            var mapUrl = codeUrl;
            var data = {
              sourceMappingURL: null,
              url: mapUrl,
              sourcesRelativeTo: mapUrl,
              map: null
            };
            var readUrl = mapUrl;
            read(readUrl, function(error, result2) {
              if (error) {
                error.sourceMapData = data;
                return callback(error);
              }
              data.map = String(result2);
              try {
                data.map = parseMapToJSON(data.map, data);
              } catch (error2) {
                return callback(error2);
              }
              _resolveSources(data);
            });
          } else {
            resolveSourceMap(code, codeUrl, read, function(error, mapData) {
              if (error) {
                return callback(error);
              }
              if (!mapData) {
                return callback(null, null);
              }
              _resolveSources(mapData);
            });
          }
          function _resolveSources(mapData) {
            resolveSources(mapData.map, mapData.sourcesRelativeTo, read, options, function(error, result2) {
              if (error) {
                return callback(error);
              }
              mapData.sourcesResolved = result2.sourcesResolved;
              mapData.sourcesContent = result2.sourcesContent;
              callback(null, mapData);
            });
          }
        }
        function resolveSync(code, codeUrl, read, options) {
          var mapData;
          if (code === null) {
            var mapUrl = codeUrl;
            mapData = {
              sourceMappingURL: null,
              url: mapUrl,
              sourcesRelativeTo: mapUrl,
              map: null
            };
            mapData.map = readSync(read, mapUrl, mapData);
            mapData.map = parseMapToJSON(mapData.map, mapData);
          } else {
            mapData = resolveSourceMapSync(code, codeUrl, read);
            if (!mapData) {
              return null;
            }
          }
          var result2 = resolveSourcesSync(mapData.map, mapData.sourcesRelativeTo, read, options);
          mapData.sourcesResolved = result2.sourcesResolved;
          mapData.sourcesContent = result2.sourcesContent;
          return mapData;
        }
        return {
          resolveSourceMap,
          resolveSourceMapSync,
          resolveSources,
          resolveSourcesSync,
          resolve: resolve2,
          resolveSync,
          parseMapToJSON
        };
      });
    }
  });

  // ../../node_modules/.pnpm/snapdragon@0.8.2_supports-color@6.1.0/node_modules/snapdragon/lib/utils.js
  var require_utils = __commonJS({
    "../../node_modules/.pnpm/snapdragon@0.8.2_supports-color@6.1.0/node_modules/snapdragon/lib/utils.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      exports8.extend = require_extend_shallow2();
      exports8.SourceMap = require_source_map();
      exports8.sourceMapResolve = require_source_map_resolve();
      exports8.unixify = function(fp) {
        return fp.split(/\\+/).join("/");
      };
      exports8.isString = function(str) {
        return str && typeof str === "string";
      };
      exports8.arrayify = function(val) {
        if (typeof val === "string")
          return [val];
        return val ? Array.isArray(val) ? val : [val] : [];
      };
      exports8.last = function(arr, n) {
        return arr[arr.length - (n || 1)];
      };
    }
  });

  // ignore:fs
  var require_fs = __commonJS({
    "ignore:fs"() {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
    }
  });

  // ../../node_modules/.pnpm/snapdragon@0.8.2_supports-color@6.1.0/node_modules/snapdragon/lib/source-maps.js
  var require_source_maps = __commonJS({
    "../../node_modules/.pnpm/snapdragon@0.8.2_supports-color@6.1.0/node_modules/snapdragon/lib/source-maps.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var fs = require_fs();
      var path = (init_path(), __toCommonJS(path_exports));
      var define2 = require_define_property3();
      var utils = require_utils();
      module2.exports = mixin3;
      function mixin3(compiler) {
        define2(compiler, "_comment", compiler.comment);
        compiler.map = new utils.SourceMap.SourceMapGenerator();
        compiler.position = { line: 1, column: 1 };
        compiler.content = {};
        compiler.files = {};
        for (var key in exports8) {
          define2(compiler, key, exports8[key]);
        }
      }
      exports8.updatePosition = function(str) {
        var lines = str.match(/\n/g);
        if (lines)
          this.position.line += lines.length;
        var i = str.lastIndexOf("\n");
        this.position.column = ~i ? str.length - i : this.position.column + str.length;
      };
      exports8.emit = function(str, node) {
        var position = node.position || {};
        var source = position.source;
        if (source) {
          if (position.filepath) {
            source = utils.unixify(position.filepath);
          }
          this.map.addMapping({
            source,
            generated: {
              line: this.position.line,
              column: Math.max(this.position.column - 1, 0)
            },
            original: {
              line: position.start.line,
              column: position.start.column - 1
            }
          });
          if (position.content) {
            this.addContent(source, position);
          }
          if (position.filepath) {
            this.addFile(source, position);
          }
          this.updatePosition(str);
          this.output += str;
        }
        return str;
      };
      exports8.addFile = function(file2, position) {
        if (typeof position.content !== "string")
          return;
        if (Object.prototype.hasOwnProperty.call(this.files, file2))
          return;
        this.files[file2] = position.content;
      };
      exports8.addContent = function(source, position) {
        if (typeof position.content !== "string")
          return;
        if (Object.prototype.hasOwnProperty.call(this.content, source))
          return;
        this.map.setSourceContent(source, position.content);
      };
      exports8.applySourceMaps = function() {
        Object.keys(this.files).forEach(function(file2) {
          var content = this.files[file2];
          this.map.setSourceContent(file2, content);
          if (this.options.inputSourcemaps === true) {
            var originalMap = utils.sourceMapResolve.resolveSync(content, file2, fs.readFileSync);
            if (originalMap) {
              var map2 = new utils.SourceMap.SourceMapConsumer(originalMap.map);
              var relativeTo = originalMap.sourcesRelativeTo;
              this.map.applySourceMap(map2, file2, utils.unixify(path.dirname(relativeTo)));
            }
          }
        }, this);
      };
      exports8.comment = function(node) {
        if (/^# sourceMappingURL=/.test(node.comment)) {
          return this.emit("", node.position);
        }
        return this._comment(node);
      };
    }
  });

  // ../../node_modules/.pnpm/snapdragon@0.8.2_supports-color@6.1.0/node_modules/snapdragon/lib/compiler.js
  var require_compiler = __commonJS({
    "../../node_modules/.pnpm/snapdragon@0.8.2_supports-color@6.1.0/node_modules/snapdragon/lib/compiler.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var use = require_use();
      var define2 = require_define_property3();
      var debug = require_browser()("snapdragon:compiler");
      var utils = require_utils();
      function Compiler(options, state) {
        debug("initializing", __filename);
        this.options = utils.extend({ source: "string" }, options);
        this.state = state || {};
        this.compilers = {};
        this.output = "";
        this.set("eos", function(node) {
          return this.emit(node.val, node);
        });
        this.set("noop", function(node) {
          return this.emit(node.val, node);
        });
        this.set("bos", function(node) {
          return this.emit(node.val, node);
        });
        use(this);
      }
      Compiler.prototype = {
        error: function(msg, node) {
          var pos = node.position || { start: { column: 0 } };
          var message = this.options.source + " column:" + pos.start.column + ": " + msg;
          var err = new Error(message);
          err.reason = msg;
          err.column = pos.start.column;
          err.source = this.pattern;
          if (this.options.silent) {
            this.errors.push(err);
          } else {
            throw err;
          }
        },
        define: function(key, val) {
          define2(this, key, val);
          return this;
        },
        emit: function(str, node) {
          this.output += str;
          return str;
        },
        set: function(name, fn) {
          this.compilers[name] = fn;
          return this;
        },
        get: function(name) {
          return this.compilers[name];
        },
        prev: function(n) {
          return this.ast.nodes[this.idx - (n || 1)] || { type: "bos", val: "" };
        },
        next: function(n) {
          return this.ast.nodes[this.idx + (n || 1)] || { type: "eos", val: "" };
        },
        visit: function(node, nodes, i) {
          var fn = this.compilers[node.type];
          this.idx = i;
          if (typeof fn !== "function") {
            throw this.error('compiler "' + node.type + '" is not registered', node);
          }
          return fn.call(this, node, nodes, i);
        },
        mapVisit: function(nodes) {
          if (!Array.isArray(nodes)) {
            throw new TypeError("expected an array");
          }
          var len = nodes.length;
          var idx = -1;
          while (++idx < len) {
            this.visit(nodes[idx], nodes, idx);
          }
          return this;
        },
        compile: function(ast, options) {
          var opts = utils.extend({}, this.options, options);
          this.ast = ast;
          this.parsingErrors = this.ast.errors;
          this.output = "";
          if (opts.sourcemap) {
            var sourcemaps = require_source_maps();
            sourcemaps(this);
            this.mapVisit(this.ast.nodes);
            this.applySourceMaps();
            this.map = opts.sourcemap === "generator" ? this.map : this.map.toJSON();
            return this;
          }
          this.mapVisit(this.ast.nodes);
          return this;
        }
      };
      module2.exports = Compiler;
    }
  });

  // ../../node_modules/.pnpm/snapdragon@0.8.2_supports-color@6.1.0/node_modules/snapdragon/lib/position.js
  var require_position = __commonJS({
    "../../node_modules/.pnpm/snapdragon@0.8.2_supports-color@6.1.0/node_modules/snapdragon/lib/position.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var define2 = require_define_property3();
      module2.exports = function Position(start, parser3) {
        this.start = start;
        this.end = { line: parser3.line, column: parser3.column };
        define2(this, "content", parser3.orig);
        define2(this, "source", parser3.options.source);
      };
    }
  });

  // ../../node_modules/.pnpm/snapdragon@0.8.2_supports-color@6.1.0/node_modules/snapdragon/lib/parser.js
  var require_parser = __commonJS({
    "../../node_modules/.pnpm/snapdragon@0.8.2_supports-color@6.1.0/node_modules/snapdragon/lib/parser.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var use = require_use();
      var util = (init_util(), __toCommonJS(util_exports));
      var Cache = require_map_cache();
      var define2 = require_define_property3();
      var debug = require_browser()("snapdragon:parser");
      var Position = require_position();
      var utils = require_utils();
      function Parser(options) {
        debug("initializing", __filename);
        this.options = utils.extend({ source: "string" }, options);
        this.init(this.options);
        use(this);
      }
      Parser.prototype = {
        constructor: Parser,
        init: function(options) {
          this.orig = "";
          this.input = "";
          this.parsed = "";
          this.column = 1;
          this.line = 1;
          this.regex = new Cache();
          this.errors = this.errors || [];
          this.parsers = this.parsers || {};
          this.types = this.types || [];
          this.sets = this.sets || {};
          this.fns = this.fns || [];
          this.currentType = "root";
          var pos = this.position();
          this.bos = pos({ type: "bos", val: "" });
          this.ast = {
            type: "root",
            errors: this.errors,
            nodes: [this.bos]
          };
          define2(this.bos, "parent", this.ast);
          this.nodes = [this.ast];
          this.count = 0;
          this.setCount = 0;
          this.stack = [];
        },
        error: function(msg, node) {
          var pos = node.position || { start: { column: 0, line: 0 } };
          var line = pos.start.line;
          var column = pos.start.column;
          var source = this.options.source;
          var message = source + " <line:" + line + " column:" + column + ">: " + msg;
          var err = new Error(message);
          err.source = source;
          err.reason = msg;
          err.pos = pos;
          if (this.options.silent) {
            this.errors.push(err);
          } else {
            throw err;
          }
        },
        define: function(key, val) {
          define2(this, key, val);
          return this;
        },
        position: function() {
          var start = { line: this.line, column: this.column };
          var self2 = this;
          return function(node) {
            define2(node, "position", new Position(start, self2));
            return node;
          };
        },
        set: function(type, fn) {
          if (this.types.indexOf(type) === -1) {
            this.types.push(type);
          }
          this.parsers[type] = fn.bind(this);
          return this;
        },
        get: function(name) {
          return this.parsers[name];
        },
        push: function(type, token) {
          this.sets[type] = this.sets[type] || [];
          this.count++;
          this.stack.push(token);
          return this.sets[type].push(token);
        },
        pop: function(type) {
          this.sets[type] = this.sets[type] || [];
          this.count--;
          this.stack.pop();
          return this.sets[type].pop();
        },
        isInside: function(type) {
          this.sets[type] = this.sets[type] || [];
          return this.sets[type].length > 0;
        },
        isType: function(node, type) {
          return node && node.type === type;
        },
        prev: function(n) {
          return this.stack.length > 0 ? utils.last(this.stack, n) : utils.last(this.nodes, n);
        },
        consume: function(len) {
          this.input = this.input.substr(len);
        },
        updatePosition: function(str, len) {
          var lines = str.match(/\n/g);
          if (lines)
            this.line += lines.length;
          var i = str.lastIndexOf("\n");
          this.column = ~i ? len - i : this.column + len;
          this.parsed += str;
          this.consume(len);
        },
        match: function(regex) {
          var m = regex.exec(this.input);
          if (m) {
            this.updatePosition(m[0], m[0].length);
            return m;
          }
        },
        capture: function(type, regex) {
          if (typeof regex === "function") {
            return this.set.apply(this, arguments);
          }
          this.regex.set(type, regex);
          this.set(type, function() {
            var parsed = this.parsed;
            var pos = this.position();
            var m = this.match(regex);
            if (!m || !m[0])
              return;
            var prev = this.prev();
            var node = pos({
              type,
              val: m[0],
              parsed,
              rest: this.input
            });
            if (m[1]) {
              node.inner = m[1];
            }
            define2(node, "inside", this.stack.length > 0);
            define2(node, "parent", prev);
            prev.nodes.push(node);
          }.bind(this));
          return this;
        },
        capturePair: function(type, openRegex, closeRegex, fn) {
          this.sets[type] = this.sets[type] || [];
          this.set(type + ".open", function() {
            var parsed = this.parsed;
            var pos = this.position();
            var m = this.match(openRegex);
            if (!m || !m[0])
              return;
            var val = m[0];
            this.setCount++;
            this.specialChars = true;
            var open2 = pos({
              type: type + ".open",
              val,
              rest: this.input
            });
            if (typeof m[1] !== "undefined") {
              open2.inner = m[1];
            }
            var prev = this.prev();
            var node = pos({
              type,
              nodes: [open2]
            });
            define2(node, "rest", this.input);
            define2(node, "parsed", parsed);
            define2(node, "prefix", m[1]);
            define2(node, "parent", prev);
            define2(open2, "parent", node);
            if (typeof fn === "function") {
              fn.call(this, open2, node);
            }
            this.push(type, node);
            prev.nodes.push(node);
          });
          this.set(type + ".close", function() {
            var pos = this.position();
            var m = this.match(closeRegex);
            if (!m || !m[0])
              return;
            var parent2 = this.pop(type);
            var node = pos({
              type: type + ".close",
              rest: this.input,
              suffix: m[1],
              val: m[0]
            });
            if (!this.isType(parent2, type)) {
              if (this.options.strict) {
                throw new Error('missing opening "' + type + '"');
              }
              this.setCount--;
              node.escaped = true;
              return node;
            }
            if (node.suffix === "\\") {
              parent2.escaped = true;
              node.escaped = true;
            }
            parent2.nodes.push(node);
            define2(node, "parent", parent2);
          });
          return this;
        },
        eos: function() {
          var pos = this.position();
          if (this.input)
            return;
          var prev = this.prev();
          while (prev.type !== "root" && !prev.visited) {
            if (this.options.strict === true) {
              throw new SyntaxError("invalid syntax:" + util.inspect(prev, null, 2));
            }
            if (!hasDelims(prev)) {
              prev.parent.escaped = true;
              prev.escaped = true;
            }
            visit(prev, function(node) {
              if (!hasDelims(node.parent)) {
                node.parent.escaped = true;
                node.escaped = true;
              }
            });
            prev = prev.parent;
          }
          var tok = pos({
            type: "eos",
            val: this.append || ""
          });
          define2(tok, "parent", this.ast);
          return tok;
        },
        next: function() {
          var parsed = this.parsed;
          var len = this.types.length;
          var idx = -1;
          var tok;
          while (++idx < len) {
            if (tok = this.parsers[this.types[idx]].call(this)) {
              define2(tok, "rest", this.input);
              define2(tok, "parsed", parsed);
              this.last = tok;
              return tok;
            }
          }
        },
        parse: function(input) {
          if (typeof input !== "string") {
            throw new TypeError("expected a string");
          }
          this.init(this.options);
          this.orig = input;
          this.input = input;
          var self2 = this;
          function parse4() {
            input = self2.input;
            var node2 = self2.next();
            if (node2) {
              var prev = self2.prev();
              if (prev) {
                define2(node2, "parent", prev);
                if (prev.nodes) {
                  prev.nodes.push(node2);
                }
              }
              if (self2.sets.hasOwnProperty(prev.type)) {
                self2.currentType = prev.type;
              }
            }
            if (self2.input && input === self2.input) {
              throw new Error('no parsers registered for: "' + self2.input.slice(0, 5) + '"');
            }
          }
          while (this.input)
            parse4();
          if (this.stack.length && this.options.strict) {
            var node = this.stack.pop();
            throw this.error("missing opening " + node.type + ': "' + this.orig + '"');
          }
          var eos = this.eos();
          var tok = this.prev();
          if (tok.type !== "eos") {
            this.ast.nodes.push(eos);
          }
          return this.ast;
        }
      };
      function visit(node, fn) {
        if (!node.visited) {
          define2(node, "visited", true);
          return node.nodes ? mapVisit(node.nodes, fn) : fn(node);
        }
        return node;
      }
      function mapVisit(nodes, fn) {
        var len = nodes.length;
        var idx = -1;
        while (++idx < len) {
          visit(nodes[idx], fn);
        }
      }
      function hasOpen(node) {
        return node.nodes && node.nodes[0].type === node.type + ".open";
      }
      function hasClose(node) {
        return node.nodes && utils.last(node.nodes).type === node.type + ".close";
      }
      function hasDelims(node) {
        return hasOpen(node) && hasClose(node);
      }
      module2.exports = Parser;
    }
  });

  // ../../node_modules/.pnpm/snapdragon@0.8.2_supports-color@6.1.0/node_modules/snapdragon/index.js
  var require_snapdragon = __commonJS({
    "../../node_modules/.pnpm/snapdragon@0.8.2_supports-color@6.1.0/node_modules/snapdragon/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var Base = require_base();
      var define2 = require_define_property3();
      var Compiler = require_compiler();
      var Parser = require_parser();
      var utils = require_utils();
      function Snapdragon(options) {
        Base.call(this, null, options);
        this.options = utils.extend({ source: "string" }, this.options);
        this.compiler = new Compiler(this.options);
        this.parser = new Parser(this.options);
        Object.defineProperty(this, "compilers", {
          get: function() {
            return this.compiler.compilers;
          }
        });
        Object.defineProperty(this, "parsers", {
          get: function() {
            return this.parser.parsers;
          }
        });
        Object.defineProperty(this, "regex", {
          get: function() {
            return this.parser.regex;
          }
        });
      }
      Base.extend(Snapdragon);
      Snapdragon.prototype.capture = function() {
        return this.parser.capture.apply(this.parser, arguments);
      };
      Snapdragon.prototype.use = function(fn) {
        fn.call(this, this);
        return this;
      };
      Snapdragon.prototype.parse = function(str, options) {
        this.options = utils.extend({}, this.options, options);
        var parsed = this.parser.parse(str, this.options);
        define2(parsed, "parser", this.parser);
        return parsed;
      };
      Snapdragon.prototype.compile = function(ast, options) {
        this.options = utils.extend({}, this.options, options);
        var compiled = this.compiler.compile(ast, this.options);
        define2(compiled, "compiler", this.compiler);
        return compiled;
      };
      module2.exports = Snapdragon;
      module2.exports.Compiler = Compiler;
      module2.exports.Parser = Parser;
    }
  });

  // ../../node_modules/.pnpm/arr-diff@4.0.0/node_modules/arr-diff/index.js
  var require_arr_diff = __commonJS({
    "../../node_modules/.pnpm/arr-diff@4.0.0/node_modules/arr-diff/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = function diff(arr) {
        var len = arguments.length;
        var idx = 0;
        while (++idx < len) {
          arr = diffArray(arr, arguments[idx]);
        }
        return arr;
      };
      function diffArray(one, two) {
        if (!Array.isArray(two)) {
          return one.slice();
        }
        var tlen = two.length;
        var olen = one.length;
        var idx = -1;
        var arr = [];
        while (++idx < olen) {
          var ele = one[idx];
          var hasEle = false;
          for (var i = 0; i < tlen; i++) {
            var val = two[i];
            if (ele === val) {
              hasEle = true;
              break;
            }
          }
          if (hasEle === false) {
            arr.push(ele);
          }
        }
        return arr;
      }
    }
  });

  // ../../node_modules/.pnpm/object.pick@1.3.0/node_modules/object.pick/index.js
  var require_object = __commonJS({
    "../../node_modules/.pnpm/object.pick@1.3.0/node_modules/object.pick/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var isObject5 = require_isobject();
      module2.exports = function pick2(obj, keys2) {
        if (!isObject5(obj) && typeof obj !== "function") {
          return {};
        }
        var res = {};
        if (typeof keys2 === "string") {
          if (keys2 in obj) {
            res[keys2] = obj[keys2];
          }
          return res;
        }
        var len = keys2.length;
        var idx = -1;
        while (++idx < len) {
          var key = keys2[idx];
          if (key in obj) {
            res[key] = obj[key];
          }
        }
        return res;
      };
    }
  });

  // ../../node_modules/.pnpm/kind-of@6.0.3/node_modules/kind-of/index.js
  var require_kind_of3 = __commonJS({
    "../../node_modules/.pnpm/kind-of@6.0.3/node_modules/kind-of/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (val === void 0)
          return "undefined";
        if (val === null)
          return "null";
        var type = typeof val;
        if (type === "boolean")
          return "boolean";
        if (type === "string")
          return "string";
        if (type === "number")
          return "number";
        if (type === "symbol")
          return "symbol";
        if (type === "function") {
          return isGeneratorFn(val) ? "generatorfunction" : "function";
        }
        if (isArray3(val))
          return "array";
        if (isBuffer3(val))
          return "buffer";
        if (isArguments2(val))
          return "arguments";
        if (isDate3(val))
          return "date";
        if (isError3(val))
          return "error";
        if (isRegexp(val))
          return "regexp";
        switch (ctorName(val)) {
          case "Symbol":
            return "symbol";
          case "Promise":
            return "promise";
          case "WeakMap":
            return "weakmap";
          case "WeakSet":
            return "weakset";
          case "Map":
            return "map";
          case "Set":
            return "set";
          case "Int8Array":
            return "int8array";
          case "Uint8Array":
            return "uint8array";
          case "Uint8ClampedArray":
            return "uint8clampedarray";
          case "Int16Array":
            return "int16array";
          case "Uint16Array":
            return "uint16array";
          case "Int32Array":
            return "int32array";
          case "Uint32Array":
            return "uint32array";
          case "Float32Array":
            return "float32array";
          case "Float64Array":
            return "float64array";
        }
        if (isGeneratorObj(val)) {
          return "generator";
        }
        type = toString2.call(val);
        switch (type) {
          case "[object Object]":
            return "object";
          case "[object Map Iterator]":
            return "mapiterator";
          case "[object Set Iterator]":
            return "setiterator";
          case "[object String Iterator]":
            return "stringiterator";
          case "[object Array Iterator]":
            return "arrayiterator";
        }
        return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
      };
      function ctorName(val) {
        return typeof val.constructor === "function" ? val.constructor.name : null;
      }
      function isArray3(val) {
        if (Array.isArray)
          return Array.isArray(val);
        return val instanceof Array;
      }
      function isError3(val) {
        return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
      }
      function isDate3(val) {
        if (val instanceof Date)
          return true;
        return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
      }
      function isRegexp(val) {
        if (val instanceof RegExp)
          return true;
        return typeof val.flags === "string" && typeof val.ignoreCase === "boolean" && typeof val.multiline === "boolean" && typeof val.global === "boolean";
      }
      function isGeneratorFn(name, val) {
        return ctorName(name) === "GeneratorFunction";
      }
      function isGeneratorObj(val) {
        return typeof val.throw === "function" && typeof val.return === "function" && typeof val.next === "function";
      }
      function isArguments2(val) {
        try {
          if (typeof val.length === "number" && typeof val.callee === "function") {
            return true;
          }
        } catch (err) {
          if (err.message.indexOf("callee") !== -1) {
            return true;
          }
        }
        return false;
      }
      function isBuffer3(val) {
        if (val.constructor && typeof val.constructor.isBuffer === "function") {
          return val.constructor.isBuffer(val);
        }
        return false;
      }
    }
  });

  // ../../node_modules/.pnpm/array-unique@0.3.2/node_modules/array-unique/index.js
  var require_array_unique = __commonJS({
    "../../node_modules/.pnpm/array-unique@0.3.2/node_modules/array-unique/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      module2.exports = function unique(arr) {
        if (!Array.isArray(arr)) {
          throw new TypeError("array-unique expects an array.");
        }
        var len = arr.length;
        var i = -1;
        while (i++ < len) {
          var j = i + 1;
          for (; j < arr.length; ++j) {
            if (arr[i] === arr[j]) {
              arr.splice(j--, 1);
            }
          }
        }
        return arr;
      };
      module2.exports.immutable = function uniqueImmutable(arr) {
        if (!Array.isArray(arr)) {
          throw new TypeError("array-unique expects an array.");
        }
        var arrLen = arr.length;
        var newArr = new Array(arrLen);
        for (var i = 0; i < arrLen; i++) {
          newArr[i] = arr[i];
        }
        return module2.exports(newArr);
      };
    }
  });

  // ../../node_modules/.pnpm/nanomatch@1.2.13_supports-color@6.1.0/node_modules/nanomatch/lib/utils.js
  var require_utils2 = __commonJS({
    "../../node_modules/.pnpm/nanomatch@1.2.13_supports-color@6.1.0/node_modules/nanomatch/lib/utils.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var utils = module2.exports;
      var path = (init_path(), __toCommonJS(path_exports));
      var isWindows = require_is_windows()();
      var Snapdragon = require_snapdragon();
      utils.define = require_define_property();
      utils.diff = require_arr_diff();
      utils.extend = require_extend_shallow();
      utils.pick = require_object();
      utils.typeOf = require_kind_of3();
      utils.unique = require_array_unique();
      utils.isEmptyString = function(val) {
        return String(val) === "" || String(val) === "./";
      };
      utils.isWindows = function() {
        return path.sep === "\\" || isWindows === true;
      };
      utils.last = function(arr, n) {
        return arr[arr.length - (n || 1)];
      };
      utils.instantiate = function(ast, options) {
        var snapdragon;
        if (utils.typeOf(ast) === "object" && ast.snapdragon) {
          snapdragon = ast.snapdragon;
        } else if (utils.typeOf(options) === "object" && options.snapdragon) {
          snapdragon = options.snapdragon;
        } else {
          snapdragon = new Snapdragon(options);
        }
        utils.define(snapdragon, "parse", function(str, options2) {
          var parsed = Snapdragon.prototype.parse.call(this, str, options2);
          parsed.input = str;
          var last2 = this.parser.stack.pop();
          if (last2 && this.options.strictErrors !== true) {
            var open2 = last2.nodes[0];
            var inner = last2.nodes[1];
            if (last2.type === "bracket") {
              if (inner.val.charAt(0) === "[") {
                inner.val = "\\" + inner.val;
              }
            } else {
              open2.val = "\\" + open2.val;
              var sibling = open2.parent.nodes[1];
              if (sibling.type === "star") {
                sibling.loose = true;
              }
            }
          }
          utils.define(parsed, "parser", this.parser);
          return parsed;
        });
        return snapdragon;
      };
      utils.createKey = function(pattern, options) {
        if (typeof options === "undefined") {
          return pattern;
        }
        var key = pattern;
        for (var prop in options) {
          if (options.hasOwnProperty(prop)) {
            key += ";" + prop + "=" + String(options[prop]);
          }
        }
        return key;
      };
      utils.arrayify = function(val) {
        if (typeof val === "string")
          return [val];
        return val ? Array.isArray(val) ? val : [val] : [];
      };
      utils.isString = function(val) {
        return typeof val === "string";
      };
      utils.isRegex = function(val) {
        return utils.typeOf(val) === "regexp";
      };
      utils.isObject = function(val) {
        return utils.typeOf(val) === "object";
      };
      utils.escapeRegex = function(str) {
        return str.replace(/[-[\]{}()^$|*+?.\\/\s]/g, "\\$&");
      };
      utils.combineDupes = function(input, patterns) {
        patterns = utils.arrayify(patterns).join("|").split("|");
        patterns = patterns.map(function(s) {
          return s.replace(/\\?([+*\\/])/g, "\\$1");
        });
        var substr = patterns.join("|");
        var regex = new RegExp("(" + substr + ")(?=\\1)", "g");
        return input.replace(regex, "");
      };
      utils.hasSpecialChars = function(str) {
        return /(?:(?:(^|\/)[!.])|[*?+()|[\]{}]|[+@]\()/.test(str);
      };
      utils.toPosixPath = function(str) {
        return str.replace(/\\+/g, "/");
      };
      utils.unescape = function(str) {
        return utils.toPosixPath(str.replace(/\\(?=[*+?!.])/g, ""));
      };
      utils.stripDrive = function(fp) {
        return utils.isWindows() ? fp.replace(/^[a-z]:[\\/]+?/i, "/") : fp;
      };
      utils.stripPrefix = function(str) {
        if (str.charAt(0) === "." && (str.charAt(1) === "/" || str.charAt(1) === "\\")) {
          return str.slice(2);
        }
        return str;
      };
      utils.isSimpleChar = function(str) {
        return str.trim() === "" || str === ".";
      };
      utils.isSlash = function(str) {
        return str === "/" || str === "\\/" || str === "\\" || str === "\\\\";
      };
      utils.matchPath = function(pattern, options) {
        return options && options.contains ? utils.containsPattern(pattern, options) : utils.equalsPattern(pattern, options);
      };
      utils._equals = function(filepath, unixPath, pattern) {
        return pattern === filepath || pattern === unixPath;
      };
      utils._contains = function(filepath, unixPath, pattern) {
        return filepath.indexOf(pattern) !== -1 || unixPath.indexOf(pattern) !== -1;
      };
      utils.equalsPattern = function(pattern, options) {
        var unixify = utils.unixify(options);
        options = options || {};
        return function fn(filepath) {
          var equal = utils._equals(filepath, unixify(filepath), pattern);
          if (equal === true || options.nocase !== true) {
            return equal;
          }
          var lower = filepath.toLowerCase();
          return utils._equals(lower, unixify(lower), pattern);
        };
      };
      utils.containsPattern = function(pattern, options) {
        var unixify = utils.unixify(options);
        options = options || {};
        return function(filepath) {
          var contains = utils._contains(filepath, unixify(filepath), pattern);
          if (contains === true || options.nocase !== true) {
            return contains;
          }
          var lower = filepath.toLowerCase();
          return utils._contains(lower, unixify(lower), pattern);
        };
      };
      utils.matchBasename = function(re) {
        return function(filepath) {
          return re.test(filepath) || re.test(path.basename(filepath));
        };
      };
      utils.identity = function(val) {
        return val;
      };
      utils.value = function(str, unixify, options) {
        if (options && options.unixify === false) {
          return str;
        }
        if (options && typeof options.unixify === "function") {
          return options.unixify(str);
        }
        return unixify(str);
      };
      utils.unixify = function(options) {
        var opts = options || {};
        return function(filepath) {
          if (opts.stripPrefix !== false) {
            filepath = utils.stripPrefix(filepath);
          }
          if (opts.unescape === true) {
            filepath = utils.unescape(filepath);
          }
          if (opts.unixify === true || utils.isWindows()) {
            filepath = utils.toPosixPath(filepath);
          }
          return filepath;
        };
      };
    }
  });

  // ../../node_modules/.pnpm/nanomatch@1.2.13_supports-color@6.1.0/node_modules/nanomatch/index.js
  var require_nanomatch = __commonJS({
    "../../node_modules/.pnpm/nanomatch@1.2.13_supports-color@6.1.0/node_modules/nanomatch/index.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var util = (init_util(), __toCommonJS(util_exports));
      var toRegex = require_to_regex();
      var extend = require_extend_shallow();
      var compilers = require_compilers();
      var parsers = require_parsers();
      var cache = require_cache();
      var utils = require_utils2();
      var MAX_LENGTH = 1024 * 64;
      function nanomatch(list, patterns, options) {
        patterns = utils.arrayify(patterns);
        list = utils.arrayify(list);
        var len = patterns.length;
        if (list.length === 0 || len === 0) {
          return [];
        }
        if (len === 1) {
          return nanomatch.match(list, patterns[0], options);
        }
        var negated = false;
        var omit2 = [];
        var keep = [];
        var idx = -1;
        while (++idx < len) {
          var pattern = patterns[idx];
          if (typeof pattern === "string" && pattern.charCodeAt(0) === 33) {
            omit2.push.apply(omit2, nanomatch.match(list, pattern.slice(1), options));
            negated = true;
          } else {
            keep.push.apply(keep, nanomatch.match(list, pattern, options));
          }
        }
        if (negated && keep.length === 0) {
          if (options && options.unixify === false) {
            keep = list.slice();
          } else {
            var unixify = utils.unixify(options);
            for (var i = 0; i < list.length; i++) {
              keep.push(unixify(list[i]));
            }
          }
        }
        var matches2 = utils.diff(keep, omit2);
        if (!options || options.nodupes !== false) {
          return utils.unique(matches2);
        }
        return matches2;
      }
      nanomatch.match = function(list, pattern, options) {
        if (Array.isArray(pattern)) {
          throw new TypeError("expected pattern to be a string");
        }
        var unixify = utils.unixify(options);
        var isMatch2 = memoize2("match", pattern, options, nanomatch.matcher);
        var matches2 = [];
        list = utils.arrayify(list);
        var len = list.length;
        var idx = -1;
        while (++idx < len) {
          var ele = list[idx];
          if (ele === pattern || isMatch2(ele)) {
            matches2.push(utils.value(ele, unixify, options));
          }
        }
        if (typeof options === "undefined") {
          return utils.unique(matches2);
        }
        if (matches2.length === 0) {
          if (options.failglob === true) {
            throw new Error('no matches found for "' + pattern + '"');
          }
          if (options.nonull === true || options.nullglob === true) {
            return [options.unescape ? utils.unescape(pattern) : pattern];
          }
        }
        if (options.ignore) {
          matches2 = nanomatch.not(matches2, options.ignore, options);
        }
        return options.nodupes !== false ? utils.unique(matches2) : matches2;
      };
      nanomatch.isMatch = function(str, pattern, options) {
        if (typeof str !== "string") {
          throw new TypeError('expected a string: "' + util.inspect(str) + '"');
        }
        if (utils.isEmptyString(str) || utils.isEmptyString(pattern)) {
          return false;
        }
        var equals = utils.equalsPattern(options);
        if (equals(str)) {
          return true;
        }
        var isMatch2 = memoize2("isMatch", pattern, options, nanomatch.matcher);
        return isMatch2(str);
      };
      nanomatch.some = function(list, patterns, options) {
        if (typeof list === "string") {
          list = [list];
        }
        for (var i = 0; i < list.length; i++) {
          if (nanomatch(list[i], patterns, options).length === 1) {
            return true;
          }
        }
        return false;
      };
      nanomatch.every = function(list, patterns, options) {
        if (typeof list === "string") {
          list = [list];
        }
        for (var i = 0; i < list.length; i++) {
          if (nanomatch(list[i], patterns, options).length !== 1) {
            return false;
          }
        }
        return true;
      };
      nanomatch.any = function(str, patterns, options) {
        if (typeof str !== "string") {
          throw new TypeError('expected a string: "' + util.inspect(str) + '"');
        }
        if (utils.isEmptyString(str) || utils.isEmptyString(patterns)) {
          return false;
        }
        if (typeof patterns === "string") {
          patterns = [patterns];
        }
        for (var i = 0; i < patterns.length; i++) {
          if (nanomatch.isMatch(str, patterns[i], options)) {
            return true;
          }
        }
        return false;
      };
      nanomatch.all = function(str, patterns, options) {
        if (typeof str !== "string") {
          throw new TypeError('expected a string: "' + util.inspect(str) + '"');
        }
        if (typeof patterns === "string") {
          patterns = [patterns];
        }
        for (var i = 0; i < patterns.length; i++) {
          if (!nanomatch.isMatch(str, patterns[i], options)) {
            return false;
          }
        }
        return true;
      };
      nanomatch.not = function(list, patterns, options) {
        var opts = extend({}, options);
        var ignore = opts.ignore;
        delete opts.ignore;
        list = utils.arrayify(list);
        var matches2 = utils.diff(list, nanomatch(list, patterns, opts));
        if (ignore) {
          matches2 = utils.diff(matches2, nanomatch(list, ignore));
        }
        return opts.nodupes !== false ? utils.unique(matches2) : matches2;
      };
      nanomatch.contains = function(str, patterns, options) {
        if (typeof str !== "string") {
          throw new TypeError('expected a string: "' + util.inspect(str) + '"');
        }
        if (typeof patterns === "string") {
          if (utils.isEmptyString(str) || utils.isEmptyString(patterns)) {
            return false;
          }
          var equals = utils.equalsPattern(patterns, options);
          if (equals(str)) {
            return true;
          }
          var contains = utils.containsPattern(patterns, options);
          if (contains(str)) {
            return true;
          }
        }
        var opts = extend({}, options, { contains: true });
        return nanomatch.any(str, patterns, opts);
      };
      nanomatch.matchBase = function(pattern, options) {
        if (pattern && pattern.indexOf("/") !== -1 || !options)
          return false;
        return options.basename === true || options.matchBase === true;
      };
      nanomatch.matchKeys = function(obj, patterns, options) {
        if (!utils.isObject(obj)) {
          throw new TypeError("expected the first argument to be an object");
        }
        var keys2 = nanomatch(Object.keys(obj), patterns, options);
        return utils.pick(obj, keys2);
      };
      nanomatch.matcher = function matcher(pattern, options) {
        if (utils.isEmptyString(pattern)) {
          return function() {
            return false;
          };
        }
        if (Array.isArray(pattern)) {
          return compose(pattern, options, matcher);
        }
        if (pattern instanceof RegExp) {
          return test(pattern);
        }
        if (!utils.isString(pattern)) {
          throw new TypeError("expected pattern to be an array, string or regex");
        }
        if (!utils.hasSpecialChars(pattern)) {
          if (options && options.nocase === true) {
            pattern = pattern.toLowerCase();
          }
          return utils.matchPath(pattern, options);
        }
        var re = nanomatch.makeRe(pattern, options);
        if (nanomatch.matchBase(pattern, options)) {
          return utils.matchBasename(re, options);
        }
        function test(regex) {
          var equals = utils.equalsPattern(options);
          var unixify = utils.unixify(options);
          return function(str) {
            if (equals(str)) {
              return true;
            }
            if (regex.test(unixify(str))) {
              return true;
            }
            return false;
          };
        }
        var matcherFn = test(re);
        utils.define(matcherFn, "result", re.result);
        return matcherFn;
      };
      nanomatch.capture = function(pattern, str, options) {
        var re = nanomatch.makeRe(pattern, extend({ capture: true }, options));
        var unixify = utils.unixify(options);
        function match() {
          return function(string) {
            var match2 = re.exec(unixify(string));
            if (!match2) {
              return null;
            }
            return match2.slice(1);
          };
        }
        var capture = memoize2("capture", pattern, options, match);
        return capture(str);
      };
      nanomatch.makeRe = function(pattern, options) {
        if (pattern instanceof RegExp) {
          return pattern;
        }
        if (typeof pattern !== "string") {
          throw new TypeError("expected pattern to be a string");
        }
        if (pattern.length > MAX_LENGTH) {
          throw new Error("expected pattern to be less than " + MAX_LENGTH + " characters");
        }
        function makeRe() {
          var opts = utils.extend({ wrap: false }, options);
          var result2 = nanomatch.create(pattern, opts);
          var regex = toRegex(result2.output, opts);
          utils.define(regex, "result", result2);
          return regex;
        }
        return memoize2("makeRe", pattern, options, makeRe);
      };
      nanomatch.create = function(pattern, options) {
        if (typeof pattern !== "string") {
          throw new TypeError("expected a string");
        }
        function create2() {
          return nanomatch.compile(nanomatch.parse(pattern, options), options);
        }
        return memoize2("create", pattern, options, create2);
      };
      nanomatch.parse = function(pattern, options) {
        if (typeof pattern !== "string") {
          throw new TypeError("expected a string");
        }
        function parse4() {
          var snapdragon = utils.instantiate(null, options);
          parsers(snapdragon, options);
          var ast = snapdragon.parse(pattern, options);
          utils.define(ast, "snapdragon", snapdragon);
          ast.input = pattern;
          return ast;
        }
        return memoize2("parse", pattern, options, parse4);
      };
      nanomatch.compile = function(ast, options) {
        if (typeof ast === "string") {
          ast = nanomatch.parse(ast, options);
        }
        function compile() {
          var snapdragon = utils.instantiate(ast, options);
          compilers(snapdragon, options);
          return snapdragon.compile(ast, options);
        }
        return memoize2("compile", ast.input, options, compile);
      };
      nanomatch.clearCache = function() {
        nanomatch.cache.__data__ = {};
      };
      function compose(patterns, options, matcher) {
        var matchers;
        return memoize2("compose", String(patterns), options, function() {
          return function(file2) {
            if (!matchers) {
              matchers = [];
              for (var i = 0; i < patterns.length; i++) {
                matchers.push(matcher(patterns[i], options));
              }
            }
            var len = matchers.length;
            while (len--) {
              if (matchers[len](file2) === true) {
                return true;
              }
            }
            return false;
          };
        });
      }
      function memoize2(type, pattern, options, fn) {
        var key = utils.createKey(type + "=" + pattern, options);
        if (options && options.cache === false) {
          return fn(pattern, options);
        }
        if (cache.has(type, key)) {
          return cache.get(type, key);
        }
        var val = fn(pattern, options);
        cache.set(type, key, val);
        return val;
      }
      nanomatch.compilers = compilers;
      nanomatch.parsers = parsers;
      nanomatch.cache = cache;
      module2.exports = nanomatch;
    }
  });

  // ../../node_modules/.pnpm/jszip@3.10.1/node_modules/jszip/dist/jszip.min.js
  var require_jszip_min = __commonJS({
    "../../node_modules/.pnpm/jszip@3.10.1/node_modules/jszip/dist/jszip.min.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      !function(e) {
        if ("object" == typeof exports8 && "undefined" != typeof module2)
          module2.exports = e();
        else if ("function" == typeof define && define.amd)
          define([], e);
        else {
          ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).JSZip = e();
        }
      }(function() {
        return function s(a, o, h) {
          function u(r, e2) {
            if (!o[r]) {
              if (!a[r]) {
                var t3 = "function" == typeof __require && __require;
                if (!e2 && t3)
                  return t3(r, true);
                if (l)
                  return l(r, true);
                var n = new Error("Cannot find module '" + r + "'");
                throw n.code = "MODULE_NOT_FOUND", n;
              }
              var i = o[r] = { exports: {} };
              a[r][0].call(i.exports, function(e3) {
                var t4 = a[r][1][e3];
                return u(t4 || e3);
              }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
          }
          for (var l = "function" == typeof __require && __require, e = 0; e < h.length; e++)
            u(h[e]);
          return u;
        }({ 1: [function(e, t3, r) {
          "use strict";
          var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          r.encode = function(e2) {
            for (var t4, r2, n, i, s, a, o, h = [], u = 0, l = e2.length, f = l, c2 = "string" !== d.getTypeOf(e2); u < e2.length; )
              f = l - u, n = c2 ? (t4 = e2[u++], r2 = u < l ? e2[u++] : 0, u < l ? e2[u++] : 0) : (t4 = e2.charCodeAt(u++), r2 = u < l ? e2.charCodeAt(u++) : 0, u < l ? e2.charCodeAt(u++) : 0), i = t4 >> 2, s = (3 & t4) << 4 | r2 >> 4, a = 1 < f ? (15 & r2) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
            return h.join("");
          }, r.decode = function(e2) {
            var t4, r2, n, i, s, a, o = 0, h = 0, u = "data:";
            if (e2.substr(0, u.length) === u)
              throw new Error("Invalid base64 input, it looks like a data url.");
            var l, f = 3 * (e2 = e2.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
            if (e2.charAt(e2.length - 1) === p.charAt(64) && f--, e2.charAt(e2.length - 2) === p.charAt(64) && f--, f % 1 != 0)
              throw new Error("Invalid base64 input, bad content length.");
            for (l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e2.length; )
              t4 = p.indexOf(e2.charAt(o++)) << 2 | (i = p.indexOf(e2.charAt(o++))) >> 4, r2 = (15 & i) << 4 | (s = p.indexOf(e2.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e2.charAt(o++))), l[h++] = t4, 64 !== s && (l[h++] = r2), 64 !== a && (l[h++] = n);
            return l;
          };
        }, { "./support": 30, "./utils": 32 }], 2: [function(e, t3, r) {
          "use strict";
          var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
          function o(e2, t4, r2, n2, i2) {
            this.compressedSize = e2, this.uncompressedSize = t4, this.crc32 = r2, this.compression = n2, this.compressedContent = i2;
          }
          o.prototype = { getContentWorker: function() {
            var e2 = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t4 = this;
            return e2.on("end", function() {
              if (this.streamInfo.data_length !== t4.uncompressedSize)
                throw new Error("Bug : uncompressed data size mismatch");
            }), e2;
          }, getCompressedWorker: function() {
            return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
          } }, o.createWorkerFrom = function(e2, t4, r2) {
            return e2.pipe(new s()).pipe(new a("uncompressedSize")).pipe(t4.compressWorker(r2)).pipe(new a("compressedSize")).withStreamInfo("compression", t4);
          }, t3.exports = o;
        }, { "./external": 6, "./stream/Crc32Probe": 25, "./stream/DataLengthProbe": 26, "./stream/DataWorker": 27 }], 3: [function(e, t3, r) {
          "use strict";
          var n = e("./stream/GenericWorker");
          r.STORE = { magic: "\0\0", compressWorker: function() {
            return new n("STORE compression");
          }, uncompressWorker: function() {
            return new n("STORE decompression");
          } }, r.DEFLATE = e("./flate");
        }, { "./flate": 7, "./stream/GenericWorker": 28 }], 4: [function(e, t3, r) {
          "use strict";
          var n = e("./utils");
          var o = function() {
            for (var e2, t4 = [], r2 = 0; r2 < 256; r2++) {
              e2 = r2;
              for (var n2 = 0; n2 < 8; n2++)
                e2 = 1 & e2 ? 3988292384 ^ e2 >>> 1 : e2 >>> 1;
              t4[r2] = e2;
            }
            return t4;
          }();
          t3.exports = function(e2, t4) {
            return void 0 !== e2 && e2.length ? "string" !== n.getTypeOf(e2) ? function(e3, t5, r2, n2) {
              var i = o, s = n2 + r2;
              e3 ^= -1;
              for (var a = n2; a < s; a++)
                e3 = e3 >>> 8 ^ i[255 & (e3 ^ t5[a])];
              return -1 ^ e3;
            }(0 | t4, e2, e2.length, 0) : function(e3, t5, r2, n2) {
              var i = o, s = n2 + r2;
              e3 ^= -1;
              for (var a = n2; a < s; a++)
                e3 = e3 >>> 8 ^ i[255 & (e3 ^ t5.charCodeAt(a))];
              return -1 ^ e3;
            }(0 | t4, e2, e2.length, 0) : 0;
          };
        }, { "./utils": 32 }], 5: [function(e, t3, r) {
          "use strict";
          r.base64 = false, r.binary = false, r.dir = false, r.createFolders = true, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
        }, {}], 6: [function(e, t3, r) {
          "use strict";
          var n = null;
          n = "undefined" != typeof Promise ? Promise : e("lie"), t3.exports = { Promise: n };
        }, { lie: 37 }], 7: [function(e, t3, r) {
          "use strict";
          var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
          function h(e2, t4) {
            a.call(this, "FlateWorker/" + e2), this._pako = null, this._pakoAction = e2, this._pakoOptions = t4, this.meta = {};
          }
          r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e2) {
            this.meta = e2.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e2.data), false);
          }, h.prototype.flush = function() {
            a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], true);
          }, h.prototype.cleanUp = function() {
            a.prototype.cleanUp.call(this), this._pako = null;
          }, h.prototype._createPako = function() {
            this._pako = new i[this._pakoAction]({ raw: true, level: this._pakoOptions.level || -1 });
            var t4 = this;
            this._pako.onData = function(e2) {
              t4.push({ data: e2, meta: t4.meta });
            };
          }, r.compressWorker = function(e2) {
            return new h("Deflate", e2);
          }, r.uncompressWorker = function() {
            return new h("Inflate", {});
          };
        }, { "./stream/GenericWorker": 28, "./utils": 32, pako: 38 }], 8: [function(e, t3, r) {
          "use strict";
          function A(e2, t4) {
            var r2, n2 = "";
            for (r2 = 0; r2 < t4; r2++)
              n2 += String.fromCharCode(255 & e2), e2 >>>= 8;
            return n2;
          }
          function n(e2, t4, r2, n2, i2, s2) {
            var a, o, h = e2.file, u = e2.compression, l = s2 !== O.utf8encode, f = I.transformTo("string", s2(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s2(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
            t4 && !r2 || (x.crc32 = e2.crc32, x.compressedSize = e2.compressedSize, x.uncompressedSize = e2.uncompressedSize);
            var S = 0;
            t4 && (S |= 8), l || !_ && !g || (S |= 2048);
            var z = 0, C = 0;
            w && (z |= 16), "UNIX" === i2 ? (C = 798, z |= function(e3, t5) {
              var r3 = e3;
              return e3 || (r3 = t5 ? 16893 : 33204), (65535 & r3) << 16;
            }(h.unixPermissions, w)) : (C = 20, z |= function(e3) {
              return 63 & (e3 || 0);
            }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
            var E = "";
            return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), { fileRecord: R.LOCAL_FILE_HEADER + E + f + b, dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n2, 4) + f + b + p };
          }
          var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
          function s(e2, t4, r2, n2) {
            i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t4, this.zipPlatform = r2, this.encodeFileName = n2, this.streamFiles = e2, this.accumulate = false, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
          }
          I.inherits(s, i), s.prototype.push = function(e2) {
            var t4 = e2.meta.percent || 0, r2 = this.entriesCount, n2 = this._sources.length;
            this.accumulate ? this.contentBuffer.push(e2) : (this.bytesWritten += e2.data.length, i.prototype.push.call(this, { data: e2.data, meta: { currentFile: this.currentFile, percent: r2 ? (t4 + 100 * (r2 - n2 - 1)) / r2 : 100 } }));
          }, s.prototype.openedSource = function(e2) {
            this.currentSourceOffset = this.bytesWritten, this.currentFile = e2.file.name;
            var t4 = this.streamFiles && !e2.file.dir;
            if (t4) {
              var r2 = n(e2, t4, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
              this.push({ data: r2.fileRecord, meta: { percent: 0 } });
            } else
              this.accumulate = true;
          }, s.prototype.closedSource = function(e2) {
            this.accumulate = false;
            var t4 = this.streamFiles && !e2.file.dir, r2 = n(e2, t4, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
            if (this.dirRecords.push(r2.dirRecord), t4)
              this.push({ data: function(e3) {
                return R.DATA_DESCRIPTOR + A(e3.crc32, 4) + A(e3.compressedSize, 4) + A(e3.uncompressedSize, 4);
              }(e2), meta: { percent: 100 } });
            else
              for (this.push({ data: r2.fileRecord, meta: { percent: 0 } }); this.contentBuffer.length; )
                this.push(this.contentBuffer.shift());
            this.currentFile = null;
          }, s.prototype.flush = function() {
            for (var e2 = this.bytesWritten, t4 = 0; t4 < this.dirRecords.length; t4++)
              this.push({ data: this.dirRecords[t4], meta: { percent: 100 } });
            var r2 = this.bytesWritten - e2, n2 = function(e3, t5, r3, n3, i2) {
              var s2 = I.transformTo("string", i2(n3));
              return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e3, 2) + A(e3, 2) + A(t5, 4) + A(r3, 4) + A(s2.length, 2) + s2;
            }(this.dirRecords.length, r2, e2, this.zipComment, this.encodeFileName);
            this.push({ data: n2, meta: { percent: 100 } });
          }, s.prototype.prepareNextSource = function() {
            this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
          }, s.prototype.registerPrevious = function(e2) {
            this._sources.push(e2);
            var t4 = this;
            return e2.on("data", function(e3) {
              t4.processChunk(e3);
            }), e2.on("end", function() {
              t4.closedSource(t4.previous.streamInfo), t4._sources.length ? t4.prepareNextSource() : t4.end();
            }), e2.on("error", function(e3) {
              t4.error(e3);
            }), this;
          }, s.prototype.resume = function() {
            return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), true) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), true));
          }, s.prototype.error = function(e2) {
            var t4 = this._sources;
            if (!i.prototype.error.call(this, e2))
              return false;
            for (var r2 = 0; r2 < t4.length; r2++)
              try {
                t4[r2].error(e2);
              } catch (e3) {
              }
            return true;
          }, s.prototype.lock = function() {
            i.prototype.lock.call(this);
            for (var e2 = this._sources, t4 = 0; t4 < e2.length; t4++)
              e2[t4].lock();
          }, t3.exports = s;
        }, { "../crc32": 4, "../signature": 23, "../stream/GenericWorker": 28, "../utf8": 31, "../utils": 32 }], 9: [function(e, t3, r) {
          "use strict";
          var u = e("../compressions"), n = e("./ZipFileWorker");
          r.generateWorker = function(e2, a, t4) {
            var o = new n(a.streamFiles, t4, a.platform, a.encodeFileName), h = 0;
            try {
              e2.forEach(function(e3, t5) {
                h++;
                var r2 = function(e4, t6) {
                  var r3 = e4 || t6, n3 = u[r3];
                  if (!n3)
                    throw new Error(r3 + " is not a valid compression method !");
                  return n3;
                }(t5.options.compression, a.compression), n2 = t5.options.compressionOptions || a.compressionOptions || {}, i = t5.dir, s = t5.date;
                t5._compressWorker(r2, n2).withStreamInfo("file", { name: e3, dir: i, date: s, comment: t5.comment || "", unixPermissions: t5.unixPermissions, dosPermissions: t5.dosPermissions }).pipe(o);
              }), o.entriesCount = h;
            } catch (e3) {
              o.error(e3);
            }
            return o;
          };
        }, { "../compressions": 3, "./ZipFileWorker": 8 }], 10: [function(e, t3, r) {
          "use strict";
          function n() {
            if (!(this instanceof n))
              return new n();
            if (arguments.length)
              throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
            this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
              var e2 = new n();
              for (var t4 in this)
                "function" != typeof this[t4] && (e2[t4] = this[t4]);
              return e2;
            };
          }
          (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e2, t4) {
            return new n().loadAsync(e2, t4);
          }, n.external = e("./external"), t3.exports = n;
        }, { "./defaults": 5, "./external": 6, "./load": 11, "./object": 15, "./support": 30 }], 11: [function(e, t3, r) {
          "use strict";
          var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
          function f(n2) {
            return new i.Promise(function(e2, t4) {
              var r2 = n2.decompressed.getContentWorker().pipe(new a());
              r2.on("error", function(e3) {
                t4(e3);
              }).on("end", function() {
                r2.streamInfo.crc32 !== n2.decompressed.crc32 ? t4(new Error("Corrupted zip : CRC32 mismatch")) : e2();
              }).resume();
            });
          }
          t3.exports = function(e2, o) {
            var h = this;
            return o = u.extend(o || {}, { base64: false, checkCRC32: false, optimizedBinaryString: false, createFolders: false, decodeFileName: n.utf8decode }), l.isNode && l.isStream(e2) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e2, true, o.optimizedBinaryString, o.base64).then(function(e3) {
              var t4 = new s(o);
              return t4.load(e3), t4;
            }).then(function(e3) {
              var t4 = [i.Promise.resolve(e3)], r2 = e3.files;
              if (o.checkCRC32)
                for (var n2 = 0; n2 < r2.length; n2++)
                  t4.push(f(r2[n2]));
              return i.Promise.all(t4);
            }).then(function(e3) {
              for (var t4 = e3.shift(), r2 = t4.files, n2 = 0; n2 < r2.length; n2++) {
                var i2 = r2[n2], s2 = i2.fileNameStr, a2 = u.resolve(i2.fileNameStr);
                h.file(a2, i2.decompressed, { binary: true, optimizedBinaryString: true, date: i2.date, dir: i2.dir, comment: i2.fileCommentStr.length ? i2.fileCommentStr : null, unixPermissions: i2.unixPermissions, dosPermissions: i2.dosPermissions, createFolders: o.createFolders }), i2.dir || (h.file(a2).unsafeOriginalName = s2);
              }
              return t4.zipComment.length && (h.comment = t4.zipComment), h;
            });
          };
        }, { "./external": 6, "./nodejsUtils": 14, "./stream/Crc32Probe": 25, "./utf8": 31, "./utils": 32, "./zipEntries": 33 }], 12: [function(e, t3, r) {
          "use strict";
          var n = e("../utils"), i = e("../stream/GenericWorker");
          function s(e2, t4) {
            i.call(this, "Nodejs stream input adapter for " + e2), this._upstreamEnded = false, this._bindStream(t4);
          }
          n.inherits(s, i), s.prototype._bindStream = function(e2) {
            var t4 = this;
            (this._stream = e2).pause(), e2.on("data", function(e3) {
              t4.push({ data: e3, meta: { percent: 0 } });
            }).on("error", function(e3) {
              t4.isPaused ? this.generatedError = e3 : t4.error(e3);
            }).on("end", function() {
              t4.isPaused ? t4._upstreamEnded = true : t4.end();
            });
          }, s.prototype.pause = function() {
            return !!i.prototype.pause.call(this) && (this._stream.pause(), true);
          }, s.prototype.resume = function() {
            return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), true);
          }, t3.exports = s;
        }, { "../stream/GenericWorker": 28, "../utils": 32 }], 13: [function(e, t3, r) {
          "use strict";
          var i = e("readable-stream").Readable;
          function n(e2, t4, r2) {
            i.call(this, t4), this._helper = e2;
            var n2 = this;
            e2.on("data", function(e3, t5) {
              n2.push(e3) || n2._helper.pause(), r2 && r2(t5);
            }).on("error", function(e3) {
              n2.emit("error", e3);
            }).on("end", function() {
              n2.push(null);
            });
          }
          e("../utils").inherits(n, i), n.prototype._read = function() {
            this._helper.resume();
          }, t3.exports = n;
        }, { "../utils": 32, "readable-stream": 16 }], 14: [function(e, t3, r) {
          "use strict";
          t3.exports = { isNode: "undefined" != typeof Buffer2, newBufferFrom: function(e2, t4) {
            if (Buffer2.from && Buffer2.from !== Uint8Array.from)
              return Buffer2.from(e2, t4);
            if ("number" == typeof e2)
              throw new Error('The "data" argument must not be a number');
            return new Buffer2(e2, t4);
          }, allocBuffer: function(e2) {
            if (Buffer2.alloc)
              return Buffer2.alloc(e2);
            var t4 = new Buffer2(e2);
            return t4.fill(0), t4;
          }, isBuffer: function(e2) {
            return Buffer2.isBuffer(e2);
          }, isStream: function(e2) {
            return e2 && "function" == typeof e2.on && "function" == typeof e2.pause && "function" == typeof e2.resume;
          } };
        }, {}], 15: [function(e, t3, r) {
          "use strict";
          function s(e2, t4, r2) {
            var n2, i2 = u.getTypeOf(t4), s2 = u.extend(r2 || {}, f);
            s2.date = s2.date || new Date(), null !== s2.compression && (s2.compression = s2.compression.toUpperCase()), "string" == typeof s2.unixPermissions && (s2.unixPermissions = parseInt(s2.unixPermissions, 8)), s2.unixPermissions && 16384 & s2.unixPermissions && (s2.dir = true), s2.dosPermissions && 16 & s2.dosPermissions && (s2.dir = true), s2.dir && (e2 = g(e2)), s2.createFolders && (n2 = _(e2)) && b.call(this, n2, true);
            var a2 = "string" === i2 && false === s2.binary && false === s2.base64;
            r2 && void 0 !== r2.binary || (s2.binary = !a2), (t4 instanceof c && 0 === t4.uncompressedSize || s2.dir || !t4 || 0 === t4.length) && (s2.base64 = false, s2.binary = true, t4 = "", s2.compression = "STORE", i2 = "string");
            var o2 = null;
            o2 = t4 instanceof c || t4 instanceof l ? t4 : p.isNode && p.isStream(t4) ? new m(e2, t4) : u.prepareContent(e2, t4, s2.binary, s2.optimizedBinaryString, s2.base64);
            var h2 = new d(e2, o2, s2);
            this.files[e2] = h2;
          }
          var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e2) {
            "/" === e2.slice(-1) && (e2 = e2.substring(0, e2.length - 1));
            var t4 = e2.lastIndexOf("/");
            return 0 < t4 ? e2.substring(0, t4) : "";
          }, g = function(e2) {
            return "/" !== e2.slice(-1) && (e2 += "/"), e2;
          }, b = function(e2, t4) {
            return t4 = void 0 !== t4 ? t4 : f.createFolders, e2 = g(e2), this.files[e2] || s.call(this, e2, null, { dir: true, createFolders: t4 }), this.files[e2];
          };
          function h(e2) {
            return "[object RegExp]" === Object.prototype.toString.call(e2);
          }
          var n = { load: function() {
            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
          }, forEach: function(e2) {
            var t4, r2, n2;
            for (t4 in this.files)
              n2 = this.files[t4], (r2 = t4.slice(this.root.length, t4.length)) && t4.slice(0, this.root.length) === this.root && e2(r2, n2);
          }, filter: function(r2) {
            var n2 = [];
            return this.forEach(function(e2, t4) {
              r2(e2, t4) && n2.push(t4);
            }), n2;
          }, file: function(e2, t4, r2) {
            if (1 !== arguments.length)
              return e2 = this.root + e2, s.call(this, e2, t4, r2), this;
            if (h(e2)) {
              var n2 = e2;
              return this.filter(function(e3, t5) {
                return !t5.dir && n2.test(e3);
              });
            }
            var i2 = this.files[this.root + e2];
            return i2 && !i2.dir ? i2 : null;
          }, folder: function(r2) {
            if (!r2)
              return this;
            if (h(r2))
              return this.filter(function(e3, t5) {
                return t5.dir && r2.test(e3);
              });
            var e2 = this.root + r2, t4 = b.call(this, e2), n2 = this.clone();
            return n2.root = t4.name, n2;
          }, remove: function(r2) {
            r2 = this.root + r2;
            var e2 = this.files[r2];
            if (e2 || ("/" !== r2.slice(-1) && (r2 += "/"), e2 = this.files[r2]), e2 && !e2.dir)
              delete this.files[r2];
            else
              for (var t4 = this.filter(function(e3, t5) {
                return t5.name.slice(0, r2.length) === r2;
              }), n2 = 0; n2 < t4.length; n2++)
                delete this.files[t4[n2].name];
            return this;
          }, generate: function() {
            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
          }, generateInternalStream: function(e2) {
            var t4, r2 = {};
            try {
              if ((r2 = u.extend(e2 || {}, { streamFiles: false, compression: "STORE", compressionOptions: null, type: "", platform: "DOS", comment: null, mimeType: "application/zip", encodeFileName: i.utf8encode })).type = r2.type.toLowerCase(), r2.compression = r2.compression.toUpperCase(), "binarystring" === r2.type && (r2.type = "string"), !r2.type)
                throw new Error("No output type specified.");
              u.checkSupport(r2.type), "darwin" !== r2.platform && "freebsd" !== r2.platform && "linux" !== r2.platform && "sunos" !== r2.platform || (r2.platform = "UNIX"), "win32" === r2.platform && (r2.platform = "DOS");
              var n2 = r2.comment || this.comment || "";
              t4 = o.generateWorker(this, r2, n2);
            } catch (e3) {
              (t4 = new l("error")).error(e3);
            }
            return new a(t4, r2.type || "string", r2.mimeType);
          }, generateAsync: function(e2, t4) {
            return this.generateInternalStream(e2).accumulate(t4);
          }, generateNodeStream: function(e2, t4) {
            return (e2 = e2 || {}).type || (e2.type = "nodebuffer"), this.generateInternalStream(e2).toNodejsStream(t4);
          } };
          t3.exports = n;
        }, { "./compressedObject": 2, "./defaults": 5, "./generate": 9, "./nodejs/NodejsStreamInputAdapter": 12, "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31, "./utils": 32, "./zipObject": 35 }], 16: [function(e, t3, r) {
          "use strict";
          t3.exports = e("stream");
        }, { stream: void 0 }], 17: [function(e, t3, r) {
          "use strict";
          var n = e("./DataReader");
          function i(e2) {
            n.call(this, e2);
            for (var t4 = 0; t4 < this.data.length; t4++)
              e2[t4] = 255 & e2[t4];
          }
          e("../utils").inherits(i, n), i.prototype.byteAt = function(e2) {
            return this.data[this.zero + e2];
          }, i.prototype.lastIndexOfSignature = function(e2) {
            for (var t4 = e2.charCodeAt(0), r2 = e2.charCodeAt(1), n2 = e2.charCodeAt(2), i2 = e2.charCodeAt(3), s = this.length - 4; 0 <= s; --s)
              if (this.data[s] === t4 && this.data[s + 1] === r2 && this.data[s + 2] === n2 && this.data[s + 3] === i2)
                return s - this.zero;
            return -1;
          }, i.prototype.readAndCheckSignature = function(e2) {
            var t4 = e2.charCodeAt(0), r2 = e2.charCodeAt(1), n2 = e2.charCodeAt(2), i2 = e2.charCodeAt(3), s = this.readData(4);
            return t4 === s[0] && r2 === s[1] && n2 === s[2] && i2 === s[3];
          }, i.prototype.readData = function(e2) {
            if (this.checkOffset(e2), 0 === e2)
              return [];
            var t4 = this.data.slice(this.zero + this.index, this.zero + this.index + e2);
            return this.index += e2, t4;
          }, t3.exports = i;
        }, { "../utils": 32, "./DataReader": 18 }], 18: [function(e, t3, r) {
          "use strict";
          var n = e("../utils");
          function i(e2) {
            this.data = e2, this.length = e2.length, this.index = 0, this.zero = 0;
          }
          i.prototype = { checkOffset: function(e2) {
            this.checkIndex(this.index + e2);
          }, checkIndex: function(e2) {
            if (this.length < this.zero + e2 || e2 < 0)
              throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e2 + "). Corrupted zip ?");
          }, setIndex: function(e2) {
            this.checkIndex(e2), this.index = e2;
          }, skip: function(e2) {
            this.setIndex(this.index + e2);
          }, byteAt: function() {
          }, readInt: function(e2) {
            var t4, r2 = 0;
            for (this.checkOffset(e2), t4 = this.index + e2 - 1; t4 >= this.index; t4--)
              r2 = (r2 << 8) + this.byteAt(t4);
            return this.index += e2, r2;
          }, readString: function(e2) {
            return n.transformTo("string", this.readData(e2));
          }, readData: function() {
          }, lastIndexOfSignature: function() {
          }, readAndCheckSignature: function() {
          }, readDate: function() {
            var e2 = this.readInt(4);
            return new Date(Date.UTC(1980 + (e2 >> 25 & 127), (e2 >> 21 & 15) - 1, e2 >> 16 & 31, e2 >> 11 & 31, e2 >> 5 & 63, (31 & e2) << 1));
          } }, t3.exports = i;
        }, { "../utils": 32 }], 19: [function(e, t3, r) {
          "use strict";
          var n = e("./Uint8ArrayReader");
          function i(e2) {
            n.call(this, e2);
          }
          e("../utils").inherits(i, n), i.prototype.readData = function(e2) {
            this.checkOffset(e2);
            var t4 = this.data.slice(this.zero + this.index, this.zero + this.index + e2);
            return this.index += e2, t4;
          }, t3.exports = i;
        }, { "../utils": 32, "./Uint8ArrayReader": 21 }], 20: [function(e, t3, r) {
          "use strict";
          var n = e("./DataReader");
          function i(e2) {
            n.call(this, e2);
          }
          e("../utils").inherits(i, n), i.prototype.byteAt = function(e2) {
            return this.data.charCodeAt(this.zero + e2);
          }, i.prototype.lastIndexOfSignature = function(e2) {
            return this.data.lastIndexOf(e2) - this.zero;
          }, i.prototype.readAndCheckSignature = function(e2) {
            return e2 === this.readData(4);
          }, i.prototype.readData = function(e2) {
            this.checkOffset(e2);
            var t4 = this.data.slice(this.zero + this.index, this.zero + this.index + e2);
            return this.index += e2, t4;
          }, t3.exports = i;
        }, { "../utils": 32, "./DataReader": 18 }], 21: [function(e, t3, r) {
          "use strict";
          var n = e("./ArrayReader");
          function i(e2) {
            n.call(this, e2);
          }
          e("../utils").inherits(i, n), i.prototype.readData = function(e2) {
            if (this.checkOffset(e2), 0 === e2)
              return new Uint8Array(0);
            var t4 = this.data.subarray(this.zero + this.index, this.zero + this.index + e2);
            return this.index += e2, t4;
          }, t3.exports = i;
        }, { "../utils": 32, "./ArrayReader": 17 }], 22: [function(e, t3, r) {
          "use strict";
          var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
          t3.exports = function(e2) {
            var t4 = n.getTypeOf(e2);
            return n.checkSupport(t4), "string" !== t4 || i.uint8array ? "nodebuffer" === t4 ? new o(e2) : i.uint8array ? new h(n.transformTo("uint8array", e2)) : new s(n.transformTo("array", e2)) : new a(e2);
          };
        }, { "../support": 30, "../utils": 32, "./ArrayReader": 17, "./NodeBufferReader": 19, "./StringReader": 20, "./Uint8ArrayReader": 21 }], 23: [function(e, t3, r) {
          "use strict";
          r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\x07\b";
        }, {}], 24: [function(e, t3, r) {
          "use strict";
          var n = e("./GenericWorker"), i = e("../utils");
          function s(e2) {
            n.call(this, "ConvertWorker to " + e2), this.destType = e2;
          }
          i.inherits(s, n), s.prototype.processChunk = function(e2) {
            this.push({ data: i.transformTo(this.destType, e2.data), meta: e2.meta });
          }, t3.exports = s;
        }, { "../utils": 32, "./GenericWorker": 28 }], 25: [function(e, t3, r) {
          "use strict";
          var n = e("./GenericWorker"), i = e("../crc32");
          function s() {
            n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
          }
          e("../utils").inherits(s, n), s.prototype.processChunk = function(e2) {
            this.streamInfo.crc32 = i(e2.data, this.streamInfo.crc32 || 0), this.push(e2);
          }, t3.exports = s;
        }, { "../crc32": 4, "../utils": 32, "./GenericWorker": 28 }], 26: [function(e, t3, r) {
          "use strict";
          var n = e("../utils"), i = e("./GenericWorker");
          function s(e2) {
            i.call(this, "DataLengthProbe for " + e2), this.propName = e2, this.withStreamInfo(e2, 0);
          }
          n.inherits(s, i), s.prototype.processChunk = function(e2) {
            if (e2) {
              var t4 = this.streamInfo[this.propName] || 0;
              this.streamInfo[this.propName] = t4 + e2.data.length;
            }
            i.prototype.processChunk.call(this, e2);
          }, t3.exports = s;
        }, { "../utils": 32, "./GenericWorker": 28 }], 27: [function(e, t3, r) {
          "use strict";
          var n = e("../utils"), i = e("./GenericWorker");
          function s(e2) {
            i.call(this, "DataWorker");
            var t4 = this;
            this.dataIsReady = false, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = false, e2.then(function(e3) {
              t4.dataIsReady = true, t4.data = e3, t4.max = e3 && e3.length || 0, t4.type = n.getTypeOf(e3), t4.isPaused || t4._tickAndRepeat();
            }, function(e3) {
              t4.error(e3);
            });
          }
          n.inherits(s, i), s.prototype.cleanUp = function() {
            i.prototype.cleanUp.call(this), this.data = null;
          }, s.prototype.resume = function() {
            return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = true, n.delay(this._tickAndRepeat, [], this)), true);
          }, s.prototype._tickAndRepeat = function() {
            this._tickScheduled = false, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = true));
          }, s.prototype._tick = function() {
            if (this.isPaused || this.isFinished)
              return false;
            var e2 = null, t4 = Math.min(this.max, this.index + 16384);
            if (this.index >= this.max)
              return this.end();
            switch (this.type) {
              case "string":
                e2 = this.data.substring(this.index, t4);
                break;
              case "uint8array":
                e2 = this.data.subarray(this.index, t4);
                break;
              case "array":
              case "nodebuffer":
                e2 = this.data.slice(this.index, t4);
            }
            return this.index = t4, this.push({ data: e2, meta: { percent: this.max ? this.index / this.max * 100 : 0 } });
          }, t3.exports = s;
        }, { "../utils": 32, "./GenericWorker": 28 }], 28: [function(e, t3, r) {
          "use strict";
          function n(e2) {
            this.name = e2 || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = true, this.isFinished = false, this.isLocked = false, this._listeners = { data: [], end: [], error: [] }, this.previous = null;
          }
          n.prototype = { push: function(e2) {
            this.emit("data", e2);
          }, end: function() {
            if (this.isFinished)
              return false;
            this.flush();
            try {
              this.emit("end"), this.cleanUp(), this.isFinished = true;
            } catch (e2) {
              this.emit("error", e2);
            }
            return true;
          }, error: function(e2) {
            return !this.isFinished && (this.isPaused ? this.generatedError = e2 : (this.isFinished = true, this.emit("error", e2), this.previous && this.previous.error(e2), this.cleanUp()), true);
          }, on: function(e2, t4) {
            return this._listeners[e2].push(t4), this;
          }, cleanUp: function() {
            this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
          }, emit: function(e2, t4) {
            if (this._listeners[e2])
              for (var r2 = 0; r2 < this._listeners[e2].length; r2++)
                this._listeners[e2][r2].call(this, t4);
          }, pipe: function(e2) {
            return e2.registerPrevious(this);
          }, registerPrevious: function(e2) {
            if (this.isLocked)
              throw new Error("The stream '" + this + "' has already been used.");
            this.streamInfo = e2.streamInfo, this.mergeStreamInfo(), this.previous = e2;
            var t4 = this;
            return e2.on("data", function(e3) {
              t4.processChunk(e3);
            }), e2.on("end", function() {
              t4.end();
            }), e2.on("error", function(e3) {
              t4.error(e3);
            }), this;
          }, pause: function() {
            return !this.isPaused && !this.isFinished && (this.isPaused = true, this.previous && this.previous.pause(), true);
          }, resume: function() {
            if (!this.isPaused || this.isFinished)
              return false;
            var e2 = this.isPaused = false;
            return this.generatedError && (this.error(this.generatedError), e2 = true), this.previous && this.previous.resume(), !e2;
          }, flush: function() {
          }, processChunk: function(e2) {
            this.push(e2);
          }, withStreamInfo: function(e2, t4) {
            return this.extraStreamInfo[e2] = t4, this.mergeStreamInfo(), this;
          }, mergeStreamInfo: function() {
            for (var e2 in this.extraStreamInfo)
              Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e2) && (this.streamInfo[e2] = this.extraStreamInfo[e2]);
          }, lock: function() {
            if (this.isLocked)
              throw new Error("The stream '" + this + "' has already been used.");
            this.isLocked = true, this.previous && this.previous.lock();
          }, toString: function() {
            var e2 = "Worker " + this.name;
            return this.previous ? this.previous + " -> " + e2 : e2;
          } }, t3.exports = n;
        }, {}], 29: [function(e, t3, r) {
          "use strict";
          var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
          if (n.nodestream)
            try {
              o = e("../nodejs/NodejsStreamOutputAdapter");
            } catch (e2) {
            }
          function l(e2, o2) {
            return new a.Promise(function(t4, r2) {
              var n2 = [], i2 = e2._internalType, s2 = e2._outputType, a2 = e2._mimeType;
              e2.on("data", function(e3, t5) {
                n2.push(e3), o2 && o2(t5);
              }).on("error", function(e3) {
                n2 = [], r2(e3);
              }).on("end", function() {
                try {
                  var e3 = function(e4, t5, r3) {
                    switch (e4) {
                      case "blob":
                        return h.newBlob(h.transformTo("arraybuffer", t5), r3);
                      case "base64":
                        return u.encode(t5);
                      default:
                        return h.transformTo(e4, t5);
                    }
                  }(s2, function(e4, t5) {
                    var r3, n3 = 0, i3 = null, s3 = 0;
                    for (r3 = 0; r3 < t5.length; r3++)
                      s3 += t5[r3].length;
                    switch (e4) {
                      case "string":
                        return t5.join("");
                      case "array":
                        return Array.prototype.concat.apply([], t5);
                      case "uint8array":
                        for (i3 = new Uint8Array(s3), r3 = 0; r3 < t5.length; r3++)
                          i3.set(t5[r3], n3), n3 += t5[r3].length;
                        return i3;
                      case "nodebuffer":
                        return Buffer2.concat(t5);
                      default:
                        throw new Error("concat : unsupported type '" + e4 + "'");
                    }
                  }(i2, n2), a2);
                  t4(e3);
                } catch (e4) {
                  r2(e4);
                }
                n2 = [];
              }).resume();
            });
          }
          function f(e2, t4, r2) {
            var n2 = t4;
            switch (t4) {
              case "blob":
              case "arraybuffer":
                n2 = "uint8array";
                break;
              case "base64":
                n2 = "string";
            }
            try {
              this._internalType = n2, this._outputType = t4, this._mimeType = r2, h.checkSupport(n2), this._worker = e2.pipe(new i(n2)), e2.lock();
            } catch (e3) {
              this._worker = new s("error"), this._worker.error(e3);
            }
          }
          f.prototype = { accumulate: function(e2) {
            return l(this, e2);
          }, on: function(e2, t4) {
            var r2 = this;
            return "data" === e2 ? this._worker.on(e2, function(e3) {
              t4.call(r2, e3.data, e3.meta);
            }) : this._worker.on(e2, function() {
              h.delay(t4, arguments, r2);
            }), this;
          }, resume: function() {
            return h.delay(this._worker.resume, [], this._worker), this;
          }, pause: function() {
            return this._worker.pause(), this;
          }, toNodejsStream: function(e2) {
            if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType)
              throw new Error(this._outputType + " is not supported by this method");
            return new o(this, { objectMode: "nodebuffer" !== this._outputType }, e2);
          } }, t3.exports = f;
        }, { "../base64": 1, "../external": 6, "../nodejs/NodejsStreamOutputAdapter": 13, "../support": 30, "../utils": 32, "./ConvertWorker": 24, "./GenericWorker": 28 }], 30: [function(e, t3, r) {
          "use strict";
          if (r.base64 = true, r.array = true, r.string = true, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof Buffer2, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer)
            r.blob = false;
          else {
            var n = new ArrayBuffer(0);
            try {
              r.blob = 0 === new Blob([n], { type: "application/zip" }).size;
            } catch (e2) {
              try {
                var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
              } catch (e3) {
                r.blob = false;
              }
            }
          }
          try {
            r.nodestream = !!e("readable-stream").Readable;
          } catch (e2) {
            r.nodestream = false;
          }
        }, { "readable-stream": 16 }], 31: [function(e, t3, s) {
          "use strict";
          for (var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)
            u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
          u[254] = u[254] = 1;
          function a() {
            n.call(this, "utf-8 decode"), this.leftOver = null;
          }
          function l() {
            n.call(this, "utf-8 encode");
          }
          s.utf8encode = function(e2) {
            return h.nodebuffer ? r.newBufferFrom(e2, "utf-8") : function(e3) {
              var t4, r2, n2, i2, s2, a2 = e3.length, o2 = 0;
              for (i2 = 0; i2 < a2; i2++)
                55296 == (64512 & (r2 = e3.charCodeAt(i2))) && i2 + 1 < a2 && 56320 == (64512 & (n2 = e3.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), o2 += r2 < 128 ? 1 : r2 < 2048 ? 2 : r2 < 65536 ? 3 : 4;
              for (t4 = h.uint8array ? new Uint8Array(o2) : new Array(o2), i2 = s2 = 0; s2 < o2; i2++)
                55296 == (64512 & (r2 = e3.charCodeAt(i2))) && i2 + 1 < a2 && 56320 == (64512 & (n2 = e3.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), r2 < 128 ? t4[s2++] = r2 : (r2 < 2048 ? t4[s2++] = 192 | r2 >>> 6 : (r2 < 65536 ? t4[s2++] = 224 | r2 >>> 12 : (t4[s2++] = 240 | r2 >>> 18, t4[s2++] = 128 | r2 >>> 12 & 63), t4[s2++] = 128 | r2 >>> 6 & 63), t4[s2++] = 128 | 63 & r2);
              return t4;
            }(e2);
          }, s.utf8decode = function(e2) {
            return h.nodebuffer ? o.transformTo("nodebuffer", e2).toString("utf-8") : function(e3) {
              var t4, r2, n2, i2, s2 = e3.length, a2 = new Array(2 * s2);
              for (t4 = r2 = 0; t4 < s2; )
                if ((n2 = e3[t4++]) < 128)
                  a2[r2++] = n2;
                else if (4 < (i2 = u[n2]))
                  a2[r2++] = 65533, t4 += i2 - 1;
                else {
                  for (n2 &= 2 === i2 ? 31 : 3 === i2 ? 15 : 7; 1 < i2 && t4 < s2; )
                    n2 = n2 << 6 | 63 & e3[t4++], i2--;
                  1 < i2 ? a2[r2++] = 65533 : n2 < 65536 ? a2[r2++] = n2 : (n2 -= 65536, a2[r2++] = 55296 | n2 >> 10 & 1023, a2[r2++] = 56320 | 1023 & n2);
                }
              return a2.length !== r2 && (a2.subarray ? a2 = a2.subarray(0, r2) : a2.length = r2), o.applyFromCharCode(a2);
            }(e2 = o.transformTo(h.uint8array ? "uint8array" : "array", e2));
          }, o.inherits(a, n), a.prototype.processChunk = function(e2) {
            var t4 = o.transformTo(h.uint8array ? "uint8array" : "array", e2.data);
            if (this.leftOver && this.leftOver.length) {
              if (h.uint8array) {
                var r2 = t4;
                (t4 = new Uint8Array(r2.length + this.leftOver.length)).set(this.leftOver, 0), t4.set(r2, this.leftOver.length);
              } else
                t4 = this.leftOver.concat(t4);
              this.leftOver = null;
            }
            var n2 = function(e3, t5) {
              var r3;
              for ((t5 = t5 || e3.length) > e3.length && (t5 = e3.length), r3 = t5 - 1; 0 <= r3 && 128 == (192 & e3[r3]); )
                r3--;
              return r3 < 0 ? t5 : 0 === r3 ? t5 : r3 + u[e3[r3]] > t5 ? r3 : t5;
            }(t4), i2 = t4;
            n2 !== t4.length && (h.uint8array ? (i2 = t4.subarray(0, n2), this.leftOver = t4.subarray(n2, t4.length)) : (i2 = t4.slice(0, n2), this.leftOver = t4.slice(n2, t4.length))), this.push({ data: s.utf8decode(i2), meta: e2.meta });
          }, a.prototype.flush = function() {
            this.leftOver && this.leftOver.length && (this.push({ data: s.utf8decode(this.leftOver), meta: {} }), this.leftOver = null);
          }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e2) {
            this.push({ data: s.utf8encode(e2.data), meta: e2.meta });
          }, s.Utf8EncodeWorker = l;
        }, { "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./support": 30, "./utils": 32 }], 32: [function(e, t3, a) {
          "use strict";
          var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
          function n(e2) {
            return e2;
          }
          function l(e2, t4) {
            for (var r2 = 0; r2 < e2.length; ++r2)
              t4[r2] = 255 & e2.charCodeAt(r2);
            return t4;
          }
          e("setimmediate"), a.newBlob = function(t4, r2) {
            a.checkSupport("blob");
            try {
              return new Blob([t4], { type: r2 });
            } catch (e2) {
              try {
                var n2 = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                return n2.append(t4), n2.getBlob(r2);
              } catch (e3) {
                throw new Error("Bug : can't construct the Blob.");
              }
            }
          };
          var i = { stringifyByChunk: function(e2, t4, r2) {
            var n2 = [], i2 = 0, s2 = e2.length;
            if (s2 <= r2)
              return String.fromCharCode.apply(null, e2);
            for (; i2 < s2; )
              "array" === t4 || "nodebuffer" === t4 ? n2.push(String.fromCharCode.apply(null, e2.slice(i2, Math.min(i2 + r2, s2)))) : n2.push(String.fromCharCode.apply(null, e2.subarray(i2, Math.min(i2 + r2, s2)))), i2 += r2;
            return n2.join("");
          }, stringifyByChar: function(e2) {
            for (var t4 = "", r2 = 0; r2 < e2.length; r2++)
              t4 += String.fromCharCode(e2[r2]);
            return t4;
          }, applyCanBeUsed: { uint8array: function() {
            try {
              return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
            } catch (e2) {
              return false;
            }
          }(), nodebuffer: function() {
            try {
              return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
            } catch (e2) {
              return false;
            }
          }() } };
          function s(e2) {
            var t4 = 65536, r2 = a.getTypeOf(e2), n2 = true;
            if ("uint8array" === r2 ? n2 = i.applyCanBeUsed.uint8array : "nodebuffer" === r2 && (n2 = i.applyCanBeUsed.nodebuffer), n2)
              for (; 1 < t4; )
                try {
                  return i.stringifyByChunk(e2, r2, t4);
                } catch (e3) {
                  t4 = Math.floor(t4 / 2);
                }
            return i.stringifyByChar(e2);
          }
          function f(e2, t4) {
            for (var r2 = 0; r2 < e2.length; r2++)
              t4[r2] = e2[r2];
            return t4;
          }
          a.applyFromCharCode = s;
          var c = {};
          c.string = { string: n, array: function(e2) {
            return l(e2, new Array(e2.length));
          }, arraybuffer: function(e2) {
            return c.string.uint8array(e2).buffer;
          }, uint8array: function(e2) {
            return l(e2, new Uint8Array(e2.length));
          }, nodebuffer: function(e2) {
            return l(e2, r.allocBuffer(e2.length));
          } }, c.array = { string: s, array: n, arraybuffer: function(e2) {
            return new Uint8Array(e2).buffer;
          }, uint8array: function(e2) {
            return new Uint8Array(e2);
          }, nodebuffer: function(e2) {
            return r.newBufferFrom(e2);
          } }, c.arraybuffer = { string: function(e2) {
            return s(new Uint8Array(e2));
          }, array: function(e2) {
            return f(new Uint8Array(e2), new Array(e2.byteLength));
          }, arraybuffer: n, uint8array: function(e2) {
            return new Uint8Array(e2);
          }, nodebuffer: function(e2) {
            return r.newBufferFrom(new Uint8Array(e2));
          } }, c.uint8array = { string: s, array: function(e2) {
            return f(e2, new Array(e2.length));
          }, arraybuffer: function(e2) {
            return e2.buffer;
          }, uint8array: n, nodebuffer: function(e2) {
            return r.newBufferFrom(e2);
          } }, c.nodebuffer = { string: s, array: function(e2) {
            return f(e2, new Array(e2.length));
          }, arraybuffer: function(e2) {
            return c.nodebuffer.uint8array(e2).buffer;
          }, uint8array: function(e2) {
            return f(e2, new Uint8Array(e2.length));
          }, nodebuffer: n }, a.transformTo = function(e2, t4) {
            if (t4 = t4 || "", !e2)
              return t4;
            a.checkSupport(e2);
            var r2 = a.getTypeOf(t4);
            return c[r2][e2](t4);
          }, a.resolve = function(e2) {
            for (var t4 = e2.split("/"), r2 = [], n2 = 0; n2 < t4.length; n2++) {
              var i2 = t4[n2];
              "." === i2 || "" === i2 && 0 !== n2 && n2 !== t4.length - 1 || (".." === i2 ? r2.pop() : r2.push(i2));
            }
            return r2.join("/");
          }, a.getTypeOf = function(e2) {
            return "string" == typeof e2 ? "string" : "[object Array]" === Object.prototype.toString.call(e2) ? "array" : o.nodebuffer && r.isBuffer(e2) ? "nodebuffer" : o.uint8array && e2 instanceof Uint8Array ? "uint8array" : o.arraybuffer && e2 instanceof ArrayBuffer ? "arraybuffer" : void 0;
          }, a.checkSupport = function(e2) {
            if (!o[e2.toLowerCase()])
              throw new Error(e2 + " is not supported by this platform");
          }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e2) {
            var t4, r2, n2 = "";
            for (r2 = 0; r2 < (e2 || "").length; r2++)
              n2 += "\\x" + ((t4 = e2.charCodeAt(r2)) < 16 ? "0" : "") + t4.toString(16).toUpperCase();
            return n2;
          }, a.delay = function(e2, t4, r2) {
            setImmediate(function() {
              e2.apply(r2 || null, t4 || []);
            });
          }, a.inherits = function(e2, t4) {
            function r2() {
            }
            r2.prototype = t4.prototype, e2.prototype = new r2();
          }, a.extend = function() {
            var e2, t4, r2 = {};
            for (e2 = 0; e2 < arguments.length; e2++)
              for (t4 in arguments[e2])
                Object.prototype.hasOwnProperty.call(arguments[e2], t4) && void 0 === r2[t4] && (r2[t4] = arguments[e2][t4]);
            return r2;
          }, a.prepareContent = function(r2, e2, n2, i2, s2) {
            return u.Promise.resolve(e2).then(function(n3) {
              return o.blob && (n3 instanceof Blob || -1 !== ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(n3))) && "undefined" != typeof FileReader ? new u.Promise(function(t4, r3) {
                var e3 = new FileReader();
                e3.onload = function(e4) {
                  t4(e4.target.result);
                }, e3.onerror = function(e4) {
                  r3(e4.target.error);
                }, e3.readAsArrayBuffer(n3);
              }) : n3;
            }).then(function(e3) {
              var t4 = a.getTypeOf(e3);
              return t4 ? ("arraybuffer" === t4 ? e3 = a.transformTo("uint8array", e3) : "string" === t4 && (s2 ? e3 = h.decode(e3) : n2 && true !== i2 && (e3 = function(e4) {
                return l(e4, o.uint8array ? new Uint8Array(e4.length) : new Array(e4.length));
              }(e3))), e3) : u.Promise.reject(new Error("Can't read the data of '" + r2 + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
            });
          };
        }, { "./base64": 1, "./external": 6, "./nodejsUtils": 14, "./support": 30, setimmediate: 54 }], 33: [function(e, t3, r) {
          "use strict";
          var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
          function h(e2) {
            this.files = [], this.loadOptions = e2;
          }
          h.prototype = { checkSignature: function(e2) {
            if (!this.reader.readAndCheckSignature(e2)) {
              this.reader.index -= 4;
              var t4 = this.reader.readString(4);
              throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t4) + ", expected " + i.pretty(e2) + ")");
            }
          }, isSignature: function(e2, t4) {
            var r2 = this.reader.index;
            this.reader.setIndex(e2);
            var n2 = this.reader.readString(4) === t4;
            return this.reader.setIndex(r2), n2;
          }, readBlockEndOfCentral: function() {
            this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
            var e2 = this.reader.readData(this.zipCommentLength), t4 = o.uint8array ? "uint8array" : "array", r2 = i.transformTo(t4, e2);
            this.zipComment = this.loadOptions.decodeFileName(r2);
          }, readBlockZip64EndOfCentral: function() {
            this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
            for (var e2, t4, r2, n2 = this.zip64EndOfCentralSize - 44; 0 < n2; )
              e2 = this.reader.readInt(2), t4 = this.reader.readInt(4), r2 = this.reader.readData(t4), this.zip64ExtensibleData[e2] = { id: e2, length: t4, value: r2 };
          }, readBlockZip64EndOfCentralLocator: function() {
            if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount)
              throw new Error("Multi-volumes zip are not supported");
          }, readLocalFiles: function() {
            var e2, t4;
            for (e2 = 0; e2 < this.files.length; e2++)
              t4 = this.files[e2], this.reader.setIndex(t4.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t4.readLocalPart(this.reader), t4.handleUTF8(), t4.processAttributes();
          }, readCentralDir: function() {
            var e2;
            for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER); )
              (e2 = new a({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e2);
            if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length)
              throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
          }, readEndOfCentral: function() {
            var e2 = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
            if (e2 < 0)
              throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
            this.reader.setIndex(e2);
            var t4 = e2;
            if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
              if (this.zip64 = true, (e2 = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0)
                throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
              if (this.reader.setIndex(e2), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0))
                throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
              this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
            }
            var r2 = this.centralDirOffset + this.centralDirSize;
            this.zip64 && (r2 += 20, r2 += 12 + this.zip64EndOfCentralSize);
            var n2 = t4 - r2;
            if (0 < n2)
              this.isSignature(t4, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n2);
            else if (n2 < 0)
              throw new Error("Corrupted zip: missing " + Math.abs(n2) + " bytes.");
          }, prepareReader: function(e2) {
            this.reader = n(e2);
          }, load: function(e2) {
            this.prepareReader(e2), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
          } }, t3.exports = h;
        }, { "./reader/readerFor": 22, "./signature": 23, "./support": 30, "./utils": 32, "./zipEntry": 34 }], 34: [function(e, t3, r) {
          "use strict";
          var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
          function l(e2, t4) {
            this.options = e2, this.loadOptions = t4;
          }
          l.prototype = { isEncrypted: function() {
            return 1 == (1 & this.bitFlag);
          }, useUTF8: function() {
            return 2048 == (2048 & this.bitFlag);
          }, readLocalPart: function(e2) {
            var t4, r2;
            if (e2.skip(22), this.fileNameLength = e2.readInt(2), r2 = e2.readInt(2), this.fileName = e2.readData(this.fileNameLength), e2.skip(r2), -1 === this.compressedSize || -1 === this.uncompressedSize)
              throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
            if (null === (t4 = function(e3) {
              for (var t5 in h)
                if (Object.prototype.hasOwnProperty.call(h, t5) && h[t5].magic === e3)
                  return h[t5];
              return null;
            }(this.compressionMethod)))
              throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
            this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t4, e2.readData(this.compressedSize));
          }, readCentralPart: function(e2) {
            this.versionMadeBy = e2.readInt(2), e2.skip(2), this.bitFlag = e2.readInt(2), this.compressionMethod = e2.readString(2), this.date = e2.readDate(), this.crc32 = e2.readInt(4), this.compressedSize = e2.readInt(4), this.uncompressedSize = e2.readInt(4);
            var t4 = e2.readInt(2);
            if (this.extraFieldsLength = e2.readInt(2), this.fileCommentLength = e2.readInt(2), this.diskNumberStart = e2.readInt(2), this.internalFileAttributes = e2.readInt(2), this.externalFileAttributes = e2.readInt(4), this.localHeaderOffset = e2.readInt(4), this.isEncrypted())
              throw new Error("Encrypted zip are not supported");
            e2.skip(t4), this.readExtraFields(e2), this.parseZIP64ExtraField(e2), this.fileComment = e2.readData(this.fileCommentLength);
          }, processAttributes: function() {
            this.unixPermissions = null, this.dosPermissions = null;
            var e2 = this.versionMadeBy >> 8;
            this.dir = !!(16 & this.externalFileAttributes), 0 == e2 && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e2 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = true);
          }, parseZIP64ExtraField: function() {
            if (this.extraFields[1]) {
              var e2 = n(this.extraFields[1].value);
              this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e2.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e2.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e2.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e2.readInt(4));
            }
          }, readExtraFields: function(e2) {
            var t4, r2, n2, i2 = e2.index + this.extraFieldsLength;
            for (this.extraFields || (this.extraFields = {}); e2.index + 4 < i2; )
              t4 = e2.readInt(2), r2 = e2.readInt(2), n2 = e2.readData(r2), this.extraFields[t4] = { id: t4, length: r2, value: n2 };
            e2.setIndex(i2);
          }, handleUTF8: function() {
            var e2 = u.uint8array ? "uint8array" : "array";
            if (this.useUTF8())
              this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
            else {
              var t4 = this.findExtraFieldUnicodePath();
              if (null !== t4)
                this.fileNameStr = t4;
              else {
                var r2 = s.transformTo(e2, this.fileName);
                this.fileNameStr = this.loadOptions.decodeFileName(r2);
              }
              var n2 = this.findExtraFieldUnicodeComment();
              if (null !== n2)
                this.fileCommentStr = n2;
              else {
                var i2 = s.transformTo(e2, this.fileComment);
                this.fileCommentStr = this.loadOptions.decodeFileName(i2);
              }
            }
          }, findExtraFieldUnicodePath: function() {
            var e2 = this.extraFields[28789];
            if (e2) {
              var t4 = n(e2.value);
              return 1 !== t4.readInt(1) ? null : a(this.fileName) !== t4.readInt(4) ? null : o.utf8decode(t4.readData(e2.length - 5));
            }
            return null;
          }, findExtraFieldUnicodeComment: function() {
            var e2 = this.extraFields[25461];
            if (e2) {
              var t4 = n(e2.value);
              return 1 !== t4.readInt(1) ? null : a(this.fileComment) !== t4.readInt(4) ? null : o.utf8decode(t4.readData(e2.length - 5));
            }
            return null;
          } }, t3.exports = l;
        }, { "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./reader/readerFor": 22, "./support": 30, "./utf8": 31, "./utils": 32 }], 35: [function(e, t3, r) {
          "use strict";
          function n(e2, t4, r2) {
            this.name = e2, this.dir = r2.dir, this.date = r2.date, this.comment = r2.comment, this.unixPermissions = r2.unixPermissions, this.dosPermissions = r2.dosPermissions, this._data = t4, this._dataBinary = r2.binary, this.options = { compression: r2.compression, compressionOptions: r2.compressionOptions };
          }
          var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
          n.prototype = { internalStream: function(e2) {
            var t4 = null, r2 = "string";
            try {
              if (!e2)
                throw new Error("No output type specified.");
              var n2 = "string" === (r2 = e2.toLowerCase()) || "text" === r2;
              "binarystring" !== r2 && "text" !== r2 || (r2 = "string"), t4 = this._decompressWorker();
              var i2 = !this._dataBinary;
              i2 && !n2 && (t4 = t4.pipe(new a.Utf8EncodeWorker())), !i2 && n2 && (t4 = t4.pipe(new a.Utf8DecodeWorker()));
            } catch (e3) {
              (t4 = new h("error")).error(e3);
            }
            return new s(t4, r2, "");
          }, async: function(e2, t4) {
            return this.internalStream(e2).accumulate(t4);
          }, nodeStream: function(e2, t4) {
            return this.internalStream(e2 || "nodebuffer").toNodejsStream(t4);
          }, _compressWorker: function(e2, t4) {
            if (this._data instanceof o && this._data.compression.magic === e2.magic)
              return this._data.getCompressedWorker();
            var r2 = this._decompressWorker();
            return this._dataBinary || (r2 = r2.pipe(new a.Utf8EncodeWorker())), o.createWorkerFrom(r2, e2, t4);
          }, _decompressWorker: function() {
            return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
          } };
          for (var u = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], l = function() {
            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
          }, f = 0; f < u.length; f++)
            n.prototype[u[f]] = l;
          t3.exports = n;
        }, { "./compressedObject": 2, "./stream/DataWorker": 27, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31 }], 36: [function(e, l, t3) {
          (function(t4) {
            "use strict";
            var r, n, e2 = t4.MutationObserver || t4.WebKitMutationObserver;
            if (e2) {
              var i = 0, s = new e2(u), a = t4.document.createTextNode("");
              s.observe(a, { characterData: true }), r = function() {
                a.data = i = ++i % 2;
              };
            } else if (t4.setImmediate || void 0 === t4.MessageChannel)
              r = "document" in t4 && "onreadystatechange" in t4.document.createElement("script") ? function() {
                var e3 = t4.document.createElement("script");
                e3.onreadystatechange = function() {
                  u(), e3.onreadystatechange = null, e3.parentNode.removeChild(e3), e3 = null;
                }, t4.document.documentElement.appendChild(e3);
              } : function() {
                setTimeout(u, 0);
              };
            else {
              var o = new t4.MessageChannel();
              o.port1.onmessage = u, r = function() {
                o.port2.postMessage(0);
              };
            }
            var h = [];
            function u() {
              var e3, t5;
              n = true;
              for (var r2 = h.length; r2; ) {
                for (t5 = h, h = [], e3 = -1; ++e3 < r2; )
                  t5[e3]();
                r2 = h.length;
              }
              n = false;
            }
            l.exports = function(e3) {
              1 !== h.push(e3) || n || r();
            };
          }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
        }, {}], 37: [function(e, t3, r) {
          "use strict";
          var i = e("immediate");
          function u() {
          }
          var l = {}, s = ["REJECTED"], a = ["FULFILLED"], n = ["PENDING"];
          function o(e2) {
            if ("function" != typeof e2)
              throw new TypeError("resolver must be a function");
            this.state = n, this.queue = [], this.outcome = void 0, e2 !== u && d(this, e2);
          }
          function h(e2, t4, r2) {
            this.promise = e2, "function" == typeof t4 && (this.onFulfilled = t4, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r2 && (this.onRejected = r2, this.callRejected = this.otherCallRejected);
          }
          function f(t4, r2, n2) {
            i(function() {
              var e2;
              try {
                e2 = r2(n2);
              } catch (e3) {
                return l.reject(t4, e3);
              }
              e2 === t4 ? l.reject(t4, new TypeError("Cannot resolve promise with itself")) : l.resolve(t4, e2);
            });
          }
          function c(e2) {
            var t4 = e2 && e2.then;
            if (e2 && ("object" == typeof e2 || "function" == typeof e2) && "function" == typeof t4)
              return function() {
                t4.apply(e2, arguments);
              };
          }
          function d(t4, e2) {
            var r2 = false;
            function n2(e3) {
              r2 || (r2 = true, l.reject(t4, e3));
            }
            function i2(e3) {
              r2 || (r2 = true, l.resolve(t4, e3));
            }
            var s2 = p(function() {
              e2(i2, n2);
            });
            "error" === s2.status && n2(s2.value);
          }
          function p(e2, t4) {
            var r2 = {};
            try {
              r2.value = e2(t4), r2.status = "success";
            } catch (e3) {
              r2.status = "error", r2.value = e3;
            }
            return r2;
          }
          (t3.exports = o).prototype.finally = function(t4) {
            if ("function" != typeof t4)
              return this;
            var r2 = this.constructor;
            return this.then(function(e2) {
              return r2.resolve(t4()).then(function() {
                return e2;
              });
            }, function(e2) {
              return r2.resolve(t4()).then(function() {
                throw e2;
              });
            });
          }, o.prototype.catch = function(e2) {
            return this.then(null, e2);
          }, o.prototype.then = function(e2, t4) {
            if ("function" != typeof e2 && this.state === a || "function" != typeof t4 && this.state === s)
              return this;
            var r2 = new this.constructor(u);
            this.state !== n ? f(r2, this.state === a ? e2 : t4, this.outcome) : this.queue.push(new h(r2, e2, t4));
            return r2;
          }, h.prototype.callFulfilled = function(e2) {
            l.resolve(this.promise, e2);
          }, h.prototype.otherCallFulfilled = function(e2) {
            f(this.promise, this.onFulfilled, e2);
          }, h.prototype.callRejected = function(e2) {
            l.reject(this.promise, e2);
          }, h.prototype.otherCallRejected = function(e2) {
            f(this.promise, this.onRejected, e2);
          }, l.resolve = function(e2, t4) {
            var r2 = p(c, t4);
            if ("error" === r2.status)
              return l.reject(e2, r2.value);
            var n2 = r2.value;
            if (n2)
              d(e2, n2);
            else {
              e2.state = a, e2.outcome = t4;
              for (var i2 = -1, s2 = e2.queue.length; ++i2 < s2; )
                e2.queue[i2].callFulfilled(t4);
            }
            return e2;
          }, l.reject = function(e2, t4) {
            e2.state = s, e2.outcome = t4;
            for (var r2 = -1, n2 = e2.queue.length; ++r2 < n2; )
              e2.queue[r2].callRejected(t4);
            return e2;
          }, o.resolve = function(e2) {
            if (e2 instanceof this)
              return e2;
            return l.resolve(new this(u), e2);
          }, o.reject = function(e2) {
            var t4 = new this(u);
            return l.reject(t4, e2);
          }, o.all = function(e2) {
            var r2 = this;
            if ("[object Array]" !== Object.prototype.toString.call(e2))
              return this.reject(new TypeError("must be an array"));
            var n2 = e2.length, i2 = false;
            if (!n2)
              return this.resolve([]);
            var s2 = new Array(n2), a2 = 0, t4 = -1, o2 = new this(u);
            for (; ++t4 < n2; )
              h2(e2[t4], t4);
            return o2;
            function h2(e3, t5) {
              r2.resolve(e3).then(function(e4) {
                s2[t5] = e4, ++a2 !== n2 || i2 || (i2 = true, l.resolve(o2, s2));
              }, function(e4) {
                i2 || (i2 = true, l.reject(o2, e4));
              });
            }
          }, o.race = function(e2) {
            var t4 = this;
            if ("[object Array]" !== Object.prototype.toString.call(e2))
              return this.reject(new TypeError("must be an array"));
            var r2 = e2.length, n2 = false;
            if (!r2)
              return this.resolve([]);
            var i2 = -1, s2 = new this(u);
            for (; ++i2 < r2; )
              a2 = e2[i2], t4.resolve(a2).then(function(e3) {
                n2 || (n2 = true, l.resolve(s2, e3));
              }, function(e3) {
                n2 || (n2 = true, l.reject(s2, e3));
              });
            var a2;
            return s2;
          };
        }, { immediate: 36 }], 38: [function(e, t3, r) {
          "use strict";
          var n = {};
          (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t3.exports = n;
        }, { "./lib/deflate": 39, "./lib/inflate": 40, "./lib/utils/common": 41, "./lib/zlib/constants": 44 }], 39: [function(e, t3, r) {
          "use strict";
          var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
          function p(e2) {
            if (!(this instanceof p))
              return new p(e2);
            this.options = o.assign({ level: f, method: d, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: c, to: "" }, e2 || {});
            var t4 = this.options;
            t4.raw && 0 < t4.windowBits ? t4.windowBits = -t4.windowBits : t4.gzip && 0 < t4.windowBits && t4.windowBits < 16 && (t4.windowBits += 16), this.err = 0, this.msg = "", this.ended = false, this.chunks = [], this.strm = new s(), this.strm.avail_out = 0;
            var r2 = a.deflateInit2(this.strm, t4.level, t4.method, t4.windowBits, t4.memLevel, t4.strategy);
            if (r2 !== l)
              throw new Error(i[r2]);
            if (t4.header && a.deflateSetHeader(this.strm, t4.header), t4.dictionary) {
              var n2;
              if (n2 = "string" == typeof t4.dictionary ? h.string2buf(t4.dictionary) : "[object ArrayBuffer]" === u.call(t4.dictionary) ? new Uint8Array(t4.dictionary) : t4.dictionary, (r2 = a.deflateSetDictionary(this.strm, n2)) !== l)
                throw new Error(i[r2]);
              this._dict_set = true;
            }
          }
          function n(e2, t4) {
            var r2 = new p(t4);
            if (r2.push(e2, true), r2.err)
              throw r2.msg || i[r2.err];
            return r2.result;
          }
          p.prototype.push = function(e2, t4) {
            var r2, n2, i2 = this.strm, s2 = this.options.chunkSize;
            if (this.ended)
              return false;
            n2 = t4 === ~~t4 ? t4 : true === t4 ? 4 : 0, "string" == typeof e2 ? i2.input = h.string2buf(e2) : "[object ArrayBuffer]" === u.call(e2) ? i2.input = new Uint8Array(e2) : i2.input = e2, i2.next_in = 0, i2.avail_in = i2.input.length;
            do {
              if (0 === i2.avail_out && (i2.output = new o.Buf8(s2), i2.next_out = 0, i2.avail_out = s2), 1 !== (r2 = a.deflate(i2, n2)) && r2 !== l)
                return this.onEnd(r2), !(this.ended = true);
              0 !== i2.avail_out && (0 !== i2.avail_in || 4 !== n2 && 2 !== n2) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i2.output, i2.next_out))) : this.onData(o.shrinkBuf(i2.output, i2.next_out)));
            } while ((0 < i2.avail_in || 0 === i2.avail_out) && 1 !== r2);
            return 4 === n2 ? (r2 = a.deflateEnd(this.strm), this.onEnd(r2), this.ended = true, r2 === l) : 2 !== n2 || (this.onEnd(l), !(i2.avail_out = 0));
          }, p.prototype.onData = function(e2) {
            this.chunks.push(e2);
          }, p.prototype.onEnd = function(e2) {
            e2 === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e2, this.msg = this.strm.msg;
          }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e2, t4) {
            return (t4 = t4 || {}).raw = true, n(e2, t4);
          }, r.gzip = function(e2, t4) {
            return (t4 = t4 || {}).gzip = true, n(e2, t4);
          };
        }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/deflate": 46, "./zlib/messages": 51, "./zlib/zstream": 53 }], 40: [function(e, t3, r) {
          "use strict";
          var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
          function a(e2) {
            if (!(this instanceof a))
              return new a(e2);
            this.options = d.assign({ chunkSize: 16384, windowBits: 0, to: "" }, e2 || {});
            var t4 = this.options;
            t4.raw && 0 <= t4.windowBits && t4.windowBits < 16 && (t4.windowBits = -t4.windowBits, 0 === t4.windowBits && (t4.windowBits = -15)), !(0 <= t4.windowBits && t4.windowBits < 16) || e2 && e2.windowBits || (t4.windowBits += 32), 15 < t4.windowBits && t4.windowBits < 48 && 0 == (15 & t4.windowBits) && (t4.windowBits |= 15), this.err = 0, this.msg = "", this.ended = false, this.chunks = [], this.strm = new i(), this.strm.avail_out = 0;
            var r2 = c.inflateInit2(this.strm, t4.windowBits);
            if (r2 !== m.Z_OK)
              throw new Error(n[r2]);
            this.header = new s(), c.inflateGetHeader(this.strm, this.header);
          }
          function o(e2, t4) {
            var r2 = new a(t4);
            if (r2.push(e2, true), r2.err)
              throw r2.msg || n[r2.err];
            return r2.result;
          }
          a.prototype.push = function(e2, t4) {
            var r2, n2, i2, s2, a2, o2, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = false;
            if (this.ended)
              return false;
            n2 = t4 === ~~t4 ? t4 : true === t4 ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e2 ? h.input = p.binstring2buf(e2) : "[object ArrayBuffer]" === _.call(e2) ? h.input = new Uint8Array(e2) : h.input = e2, h.next_in = 0, h.avail_in = h.input.length;
            do {
              if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r2 = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o2 = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r2 = c.inflateSetDictionary(this.strm, o2)), r2 === m.Z_BUF_ERROR && true === f && (r2 = m.Z_OK, f = false), r2 !== m.Z_STREAM_END && r2 !== m.Z_OK)
                return this.onEnd(r2), !(this.ended = true);
              h.next_out && (0 !== h.avail_out && r2 !== m.Z_STREAM_END && (0 !== h.avail_in || n2 !== m.Z_FINISH && n2 !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i2 = p.utf8border(h.output, h.next_out), s2 = h.next_out - i2, a2 = p.buf2string(h.output, i2), h.next_out = s2, h.avail_out = u - s2, s2 && d.arraySet(h.output, h.output, i2, s2, 0), this.onData(a2)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = true);
            } while ((0 < h.avail_in || 0 === h.avail_out) && r2 !== m.Z_STREAM_END);
            return r2 === m.Z_STREAM_END && (n2 = m.Z_FINISH), n2 === m.Z_FINISH ? (r2 = c.inflateEnd(this.strm), this.onEnd(r2), this.ended = true, r2 === m.Z_OK) : n2 !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), !(h.avail_out = 0));
          }, a.prototype.onData = function(e2) {
            this.chunks.push(e2);
          }, a.prototype.onEnd = function(e2) {
            e2 === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e2, this.msg = this.strm.msg;
          }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e2, t4) {
            return (t4 = t4 || {}).raw = true, o(e2, t4);
          }, r.ungzip = o;
        }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/constants": 44, "./zlib/gzheader": 47, "./zlib/inflate": 49, "./zlib/messages": 51, "./zlib/zstream": 53 }], 41: [function(e, t3, r) {
          "use strict";
          var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
          r.assign = function(e2) {
            for (var t4 = Array.prototype.slice.call(arguments, 1); t4.length; ) {
              var r2 = t4.shift();
              if (r2) {
                if ("object" != typeof r2)
                  throw new TypeError(r2 + "must be non-object");
                for (var n2 in r2)
                  r2.hasOwnProperty(n2) && (e2[n2] = r2[n2]);
              }
            }
            return e2;
          }, r.shrinkBuf = function(e2, t4) {
            return e2.length === t4 ? e2 : e2.subarray ? e2.subarray(0, t4) : (e2.length = t4, e2);
          };
          var i = { arraySet: function(e2, t4, r2, n2, i2) {
            if (t4.subarray && e2.subarray)
              e2.set(t4.subarray(r2, r2 + n2), i2);
            else
              for (var s2 = 0; s2 < n2; s2++)
                e2[i2 + s2] = t4[r2 + s2];
          }, flattenChunks: function(e2) {
            var t4, r2, n2, i2, s2, a;
            for (t4 = n2 = 0, r2 = e2.length; t4 < r2; t4++)
              n2 += e2[t4].length;
            for (a = new Uint8Array(n2), t4 = i2 = 0, r2 = e2.length; t4 < r2; t4++)
              s2 = e2[t4], a.set(s2, i2), i2 += s2.length;
            return a;
          } }, s = { arraySet: function(e2, t4, r2, n2, i2) {
            for (var s2 = 0; s2 < n2; s2++)
              e2[i2 + s2] = t4[r2 + s2];
          }, flattenChunks: function(e2) {
            return [].concat.apply([], e2);
          } };
          r.setTyped = function(e2) {
            e2 ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
          }, r.setTyped(n);
        }, {}], 42: [function(e, t3, r) {
          "use strict";
          var h = e("./common"), i = true, s = true;
          try {
            String.fromCharCode.apply(null, [0]);
          } catch (e2) {
            i = false;
          }
          try {
            String.fromCharCode.apply(null, new Uint8Array(1));
          } catch (e2) {
            s = false;
          }
          for (var u = new h.Buf8(256), n = 0; n < 256; n++)
            u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
          function l(e2, t4) {
            if (t4 < 65537 && (e2.subarray && s || !e2.subarray && i))
              return String.fromCharCode.apply(null, h.shrinkBuf(e2, t4));
            for (var r2 = "", n2 = 0; n2 < t4; n2++)
              r2 += String.fromCharCode(e2[n2]);
            return r2;
          }
          u[254] = u[254] = 1, r.string2buf = function(e2) {
            var t4, r2, n2, i2, s2, a = e2.length, o = 0;
            for (i2 = 0; i2 < a; i2++)
              55296 == (64512 & (r2 = e2.charCodeAt(i2))) && i2 + 1 < a && 56320 == (64512 & (n2 = e2.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), o += r2 < 128 ? 1 : r2 < 2048 ? 2 : r2 < 65536 ? 3 : 4;
            for (t4 = new h.Buf8(o), i2 = s2 = 0; s2 < o; i2++)
              55296 == (64512 & (r2 = e2.charCodeAt(i2))) && i2 + 1 < a && 56320 == (64512 & (n2 = e2.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), r2 < 128 ? t4[s2++] = r2 : (r2 < 2048 ? t4[s2++] = 192 | r2 >>> 6 : (r2 < 65536 ? t4[s2++] = 224 | r2 >>> 12 : (t4[s2++] = 240 | r2 >>> 18, t4[s2++] = 128 | r2 >>> 12 & 63), t4[s2++] = 128 | r2 >>> 6 & 63), t4[s2++] = 128 | 63 & r2);
            return t4;
          }, r.buf2binstring = function(e2) {
            return l(e2, e2.length);
          }, r.binstring2buf = function(e2) {
            for (var t4 = new h.Buf8(e2.length), r2 = 0, n2 = t4.length; r2 < n2; r2++)
              t4[r2] = e2.charCodeAt(r2);
            return t4;
          }, r.buf2string = function(e2, t4) {
            var r2, n2, i2, s2, a = t4 || e2.length, o = new Array(2 * a);
            for (r2 = n2 = 0; r2 < a; )
              if ((i2 = e2[r2++]) < 128)
                o[n2++] = i2;
              else if (4 < (s2 = u[i2]))
                o[n2++] = 65533, r2 += s2 - 1;
              else {
                for (i2 &= 2 === s2 ? 31 : 3 === s2 ? 15 : 7; 1 < s2 && r2 < a; )
                  i2 = i2 << 6 | 63 & e2[r2++], s2--;
                1 < s2 ? o[n2++] = 65533 : i2 < 65536 ? o[n2++] = i2 : (i2 -= 65536, o[n2++] = 55296 | i2 >> 10 & 1023, o[n2++] = 56320 | 1023 & i2);
              }
            return l(o, n2);
          }, r.utf8border = function(e2, t4) {
            var r2;
            for ((t4 = t4 || e2.length) > e2.length && (t4 = e2.length), r2 = t4 - 1; 0 <= r2 && 128 == (192 & e2[r2]); )
              r2--;
            return r2 < 0 ? t4 : 0 === r2 ? t4 : r2 + u[e2[r2]] > t4 ? r2 : t4;
          };
        }, { "./common": 41 }], 43: [function(e, t3, r) {
          "use strict";
          t3.exports = function(e2, t4, r2, n) {
            for (var i = 65535 & e2 | 0, s = e2 >>> 16 & 65535 | 0, a = 0; 0 !== r2; ) {
              for (r2 -= a = 2e3 < r2 ? 2e3 : r2; s = s + (i = i + t4[n++] | 0) | 0, --a; )
                ;
              i %= 65521, s %= 65521;
            }
            return i | s << 16 | 0;
          };
        }, {}], 44: [function(e, t3, r) {
          "use strict";
          t3.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
        }, {}], 45: [function(e, t3, r) {
          "use strict";
          var o = function() {
            for (var e2, t4 = [], r2 = 0; r2 < 256; r2++) {
              e2 = r2;
              for (var n = 0; n < 8; n++)
                e2 = 1 & e2 ? 3988292384 ^ e2 >>> 1 : e2 >>> 1;
              t4[r2] = e2;
            }
            return t4;
          }();
          t3.exports = function(e2, t4, r2, n) {
            var i = o, s = n + r2;
            e2 ^= -1;
            for (var a = n; a < s; a++)
              e2 = e2 >>> 8 ^ i[255 & (e2 ^ t4[a])];
            return -1 ^ e2;
          };
        }, {}], 46: [function(e, t3, r) {
          "use strict";
          var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
          function R(e2, t4) {
            return e2.msg = n[t4], t4;
          }
          function T(e2) {
            return (e2 << 1) - (4 < e2 ? 9 : 0);
          }
          function D(e2) {
            for (var t4 = e2.length; 0 <= --t4; )
              e2[t4] = 0;
          }
          function F(e2) {
            var t4 = e2.state, r2 = t4.pending;
            r2 > e2.avail_out && (r2 = e2.avail_out), 0 !== r2 && (c.arraySet(e2.output, t4.pending_buf, t4.pending_out, r2, e2.next_out), e2.next_out += r2, t4.pending_out += r2, e2.total_out += r2, e2.avail_out -= r2, t4.pending -= r2, 0 === t4.pending && (t4.pending_out = 0));
          }
          function N(e2, t4) {
            u._tr_flush_block(e2, 0 <= e2.block_start ? e2.block_start : -1, e2.strstart - e2.block_start, t4), e2.block_start = e2.strstart, F(e2.strm);
          }
          function U(e2, t4) {
            e2.pending_buf[e2.pending++] = t4;
          }
          function P(e2, t4) {
            e2.pending_buf[e2.pending++] = t4 >>> 8 & 255, e2.pending_buf[e2.pending++] = 255 & t4;
          }
          function L(e2, t4) {
            var r2, n2, i2 = e2.max_chain_length, s2 = e2.strstart, a2 = e2.prev_length, o2 = e2.nice_match, h2 = e2.strstart > e2.w_size - z ? e2.strstart - (e2.w_size - z) : 0, u2 = e2.window, l2 = e2.w_mask, f2 = e2.prev, c2 = e2.strstart + S, d2 = u2[s2 + a2 - 1], p2 = u2[s2 + a2];
            e2.prev_length >= e2.good_match && (i2 >>= 2), o2 > e2.lookahead && (o2 = e2.lookahead);
            do {
              if (u2[(r2 = t4) + a2] === p2 && u2[r2 + a2 - 1] === d2 && u2[r2] === u2[s2] && u2[++r2] === u2[s2 + 1]) {
                s2 += 2, r2++;
                do {
                } while (u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && s2 < c2);
                if (n2 = S - (c2 - s2), s2 = c2 - S, a2 < n2) {
                  if (e2.match_start = t4, o2 <= (a2 = n2))
                    break;
                  d2 = u2[s2 + a2 - 1], p2 = u2[s2 + a2];
                }
              }
            } while ((t4 = f2[t4 & l2]) > h2 && 0 != --i2);
            return a2 <= e2.lookahead ? a2 : e2.lookahead;
          }
          function j(e2) {
            var t4, r2, n2, i2, s2, a2, o2, h2, u2, l2, f2 = e2.w_size;
            do {
              if (i2 = e2.window_size - e2.lookahead - e2.strstart, e2.strstart >= f2 + (f2 - z)) {
                for (c.arraySet(e2.window, e2.window, f2, f2, 0), e2.match_start -= f2, e2.strstart -= f2, e2.block_start -= f2, t4 = r2 = e2.hash_size; n2 = e2.head[--t4], e2.head[t4] = f2 <= n2 ? n2 - f2 : 0, --r2; )
                  ;
                for (t4 = r2 = f2; n2 = e2.prev[--t4], e2.prev[t4] = f2 <= n2 ? n2 - f2 : 0, --r2; )
                  ;
                i2 += f2;
              }
              if (0 === e2.strm.avail_in)
                break;
              if (a2 = e2.strm, o2 = e2.window, h2 = e2.strstart + e2.lookahead, u2 = i2, l2 = void 0, l2 = a2.avail_in, u2 < l2 && (l2 = u2), r2 = 0 === l2 ? 0 : (a2.avail_in -= l2, c.arraySet(o2, a2.input, a2.next_in, l2, h2), 1 === a2.state.wrap ? a2.adler = d(a2.adler, o2, l2, h2) : 2 === a2.state.wrap && (a2.adler = p(a2.adler, o2, l2, h2)), a2.next_in += l2, a2.total_in += l2, l2), e2.lookahead += r2, e2.lookahead + e2.insert >= x)
                for (s2 = e2.strstart - e2.insert, e2.ins_h = e2.window[s2], e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[s2 + 1]) & e2.hash_mask; e2.insert && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[s2 + x - 1]) & e2.hash_mask, e2.prev[s2 & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = s2, s2++, e2.insert--, !(e2.lookahead + e2.insert < x)); )
                  ;
            } while (e2.lookahead < z && 0 !== e2.strm.avail_in);
          }
          function Z(e2, t4) {
            for (var r2, n2; ; ) {
              if (e2.lookahead < z) {
                if (j(e2), e2.lookahead < z && t4 === l)
                  return A;
                if (0 === e2.lookahead)
                  break;
              }
              if (r2 = 0, e2.lookahead >= x && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), 0 !== r2 && e2.strstart - r2 <= e2.w_size - z && (e2.match_length = L(e2, r2)), e2.match_length >= x)
                if (n2 = u._tr_tally(e2, e2.strstart - e2.match_start, e2.match_length - x), e2.lookahead -= e2.match_length, e2.match_length <= e2.max_lazy_match && e2.lookahead >= x) {
                  for (e2.match_length--; e2.strstart++, e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart, 0 != --e2.match_length; )
                    ;
                  e2.strstart++;
                } else
                  e2.strstart += e2.match_length, e2.match_length = 0, e2.ins_h = e2.window[e2.strstart], e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + 1]) & e2.hash_mask;
              else
                n2 = u._tr_tally(e2, 0, e2.window[e2.strstart]), e2.lookahead--, e2.strstart++;
              if (n2 && (N(e2, false), 0 === e2.strm.avail_out))
                return A;
            }
            return e2.insert = e2.strstart < x - 1 ? e2.strstart : x - 1, t4 === f ? (N(e2, true), 0 === e2.strm.avail_out ? O : B) : e2.last_lit && (N(e2, false), 0 === e2.strm.avail_out) ? A : I;
          }
          function W(e2, t4) {
            for (var r2, n2, i2; ; ) {
              if (e2.lookahead < z) {
                if (j(e2), e2.lookahead < z && t4 === l)
                  return A;
                if (0 === e2.lookahead)
                  break;
              }
              if (r2 = 0, e2.lookahead >= x && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), e2.prev_length = e2.match_length, e2.prev_match = e2.match_start, e2.match_length = x - 1, 0 !== r2 && e2.prev_length < e2.max_lazy_match && e2.strstart - r2 <= e2.w_size - z && (e2.match_length = L(e2, r2), e2.match_length <= 5 && (1 === e2.strategy || e2.match_length === x && 4096 < e2.strstart - e2.match_start) && (e2.match_length = x - 1)), e2.prev_length >= x && e2.match_length <= e2.prev_length) {
                for (i2 = e2.strstart + e2.lookahead - x, n2 = u._tr_tally(e2, e2.strstart - 1 - e2.prev_match, e2.prev_length - x), e2.lookahead -= e2.prev_length - 1, e2.prev_length -= 2; ++e2.strstart <= i2 && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), 0 != --e2.prev_length; )
                  ;
                if (e2.match_available = 0, e2.match_length = x - 1, e2.strstart++, n2 && (N(e2, false), 0 === e2.strm.avail_out))
                  return A;
              } else if (e2.match_available) {
                if ((n2 = u._tr_tally(e2, 0, e2.window[e2.strstart - 1])) && N(e2, false), e2.strstart++, e2.lookahead--, 0 === e2.strm.avail_out)
                  return A;
              } else
                e2.match_available = 1, e2.strstart++, e2.lookahead--;
            }
            return e2.match_available && (n2 = u._tr_tally(e2, 0, e2.window[e2.strstart - 1]), e2.match_available = 0), e2.insert = e2.strstart < x - 1 ? e2.strstart : x - 1, t4 === f ? (N(e2, true), 0 === e2.strm.avail_out ? O : B) : e2.last_lit && (N(e2, false), 0 === e2.strm.avail_out) ? A : I;
          }
          function M(e2, t4, r2, n2, i2) {
            this.good_length = e2, this.max_lazy = t4, this.nice_length = r2, this.max_chain = n2, this.func = i2;
          }
          function H() {
            this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
          }
          function G(e2) {
            var t4;
            return e2 && e2.state ? (e2.total_in = e2.total_out = 0, e2.data_type = i, (t4 = e2.state).pending = 0, t4.pending_out = 0, t4.wrap < 0 && (t4.wrap = -t4.wrap), t4.status = t4.wrap ? C : E, e2.adler = 2 === t4.wrap ? 0 : 1, t4.last_flush = l, u._tr_init(t4), m) : R(e2, _);
          }
          function K(e2) {
            var t4 = G(e2);
            return t4 === m && function(e3) {
              e3.window_size = 2 * e3.w_size, D(e3.head), e3.max_lazy_match = h[e3.level].max_lazy, e3.good_match = h[e3.level].good_length, e3.nice_match = h[e3.level].nice_length, e3.max_chain_length = h[e3.level].max_chain, e3.strstart = 0, e3.block_start = 0, e3.lookahead = 0, e3.insert = 0, e3.match_length = e3.prev_length = x - 1, e3.match_available = 0, e3.ins_h = 0;
            }(e2.state), t4;
          }
          function Y(e2, t4, r2, n2, i2, s2) {
            if (!e2)
              return _;
            var a2 = 1;
            if (t4 === g && (t4 = 6), n2 < 0 ? (a2 = 0, n2 = -n2) : 15 < n2 && (a2 = 2, n2 -= 16), i2 < 1 || y < i2 || r2 !== v || n2 < 8 || 15 < n2 || t4 < 0 || 9 < t4 || s2 < 0 || b < s2)
              return R(e2, _);
            8 === n2 && (n2 = 9);
            var o2 = new H();
            return (e2.state = o2).strm = e2, o2.wrap = a2, o2.gzhead = null, o2.w_bits = n2, o2.w_size = 1 << o2.w_bits, o2.w_mask = o2.w_size - 1, o2.hash_bits = i2 + 7, o2.hash_size = 1 << o2.hash_bits, o2.hash_mask = o2.hash_size - 1, o2.hash_shift = ~~((o2.hash_bits + x - 1) / x), o2.window = new c.Buf8(2 * o2.w_size), o2.head = new c.Buf16(o2.hash_size), o2.prev = new c.Buf16(o2.w_size), o2.lit_bufsize = 1 << i2 + 6, o2.pending_buf_size = 4 * o2.lit_bufsize, o2.pending_buf = new c.Buf8(o2.pending_buf_size), o2.d_buf = 1 * o2.lit_bufsize, o2.l_buf = 3 * o2.lit_bufsize, o2.level = t4, o2.strategy = s2, o2.method = r2, K(e2);
          }
          h = [new M(0, 0, 0, 0, function(e2, t4) {
            var r2 = 65535;
            for (r2 > e2.pending_buf_size - 5 && (r2 = e2.pending_buf_size - 5); ; ) {
              if (e2.lookahead <= 1) {
                if (j(e2), 0 === e2.lookahead && t4 === l)
                  return A;
                if (0 === e2.lookahead)
                  break;
              }
              e2.strstart += e2.lookahead, e2.lookahead = 0;
              var n2 = e2.block_start + r2;
              if ((0 === e2.strstart || e2.strstart >= n2) && (e2.lookahead = e2.strstart - n2, e2.strstart = n2, N(e2, false), 0 === e2.strm.avail_out))
                return A;
              if (e2.strstart - e2.block_start >= e2.w_size - z && (N(e2, false), 0 === e2.strm.avail_out))
                return A;
            }
            return e2.insert = 0, t4 === f ? (N(e2, true), 0 === e2.strm.avail_out ? O : B) : (e2.strstart > e2.block_start && (N(e2, false), e2.strm.avail_out), A);
          }), new M(4, 4, 8, 4, Z), new M(4, 5, 16, 8, Z), new M(4, 6, 32, 32, Z), new M(4, 4, 16, 16, W), new M(8, 16, 32, 32, W), new M(8, 16, 128, 128, W), new M(8, 32, 128, 256, W), new M(32, 128, 258, 1024, W), new M(32, 258, 258, 4096, W)], r.deflateInit = function(e2, t4) {
            return Y(e2, t4, v, 15, 8, 0);
          }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e2, t4) {
            return e2 && e2.state ? 2 !== e2.state.wrap ? _ : (e2.state.gzhead = t4, m) : _;
          }, r.deflate = function(e2, t4) {
            var r2, n2, i2, s2;
            if (!e2 || !e2.state || 5 < t4 || t4 < 0)
              return e2 ? R(e2, _) : _;
            if (n2 = e2.state, !e2.output || !e2.input && 0 !== e2.avail_in || 666 === n2.status && t4 !== f)
              return R(e2, 0 === e2.avail_out ? -5 : _);
            if (n2.strm = e2, r2 = n2.last_flush, n2.last_flush = t4, n2.status === C)
              if (2 === n2.wrap)
                e2.adler = 0, U(n2, 31), U(n2, 139), U(n2, 8), n2.gzhead ? (U(n2, (n2.gzhead.text ? 1 : 0) + (n2.gzhead.hcrc ? 2 : 0) + (n2.gzhead.extra ? 4 : 0) + (n2.gzhead.name ? 8 : 0) + (n2.gzhead.comment ? 16 : 0)), U(n2, 255 & n2.gzhead.time), U(n2, n2.gzhead.time >> 8 & 255), U(n2, n2.gzhead.time >> 16 & 255), U(n2, n2.gzhead.time >> 24 & 255), U(n2, 9 === n2.level ? 2 : 2 <= n2.strategy || n2.level < 2 ? 4 : 0), U(n2, 255 & n2.gzhead.os), n2.gzhead.extra && n2.gzhead.extra.length && (U(n2, 255 & n2.gzhead.extra.length), U(n2, n2.gzhead.extra.length >> 8 & 255)), n2.gzhead.hcrc && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending, 0)), n2.gzindex = 0, n2.status = 69) : (U(n2, 0), U(n2, 0), U(n2, 0), U(n2, 0), U(n2, 0), U(n2, 9 === n2.level ? 2 : 2 <= n2.strategy || n2.level < 2 ? 4 : 0), U(n2, 3), n2.status = E);
              else {
                var a2 = v + (n2.w_bits - 8 << 4) << 8;
                a2 |= (2 <= n2.strategy || n2.level < 2 ? 0 : n2.level < 6 ? 1 : 6 === n2.level ? 2 : 3) << 6, 0 !== n2.strstart && (a2 |= 32), a2 += 31 - a2 % 31, n2.status = E, P(n2, a2), 0 !== n2.strstart && (P(n2, e2.adler >>> 16), P(n2, 65535 & e2.adler)), e2.adler = 1;
              }
            if (69 === n2.status)
              if (n2.gzhead.extra) {
                for (i2 = n2.pending; n2.gzindex < (65535 & n2.gzhead.extra.length) && (n2.pending !== n2.pending_buf_size || (n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), F(e2), i2 = n2.pending, n2.pending !== n2.pending_buf_size)); )
                  U(n2, 255 & n2.gzhead.extra[n2.gzindex]), n2.gzindex++;
                n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), n2.gzindex === n2.gzhead.extra.length && (n2.gzindex = 0, n2.status = 73);
              } else
                n2.status = 73;
            if (73 === n2.status)
              if (n2.gzhead.name) {
                i2 = n2.pending;
                do {
                  if (n2.pending === n2.pending_buf_size && (n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), F(e2), i2 = n2.pending, n2.pending === n2.pending_buf_size)) {
                    s2 = 1;
                    break;
                  }
                  s2 = n2.gzindex < n2.gzhead.name.length ? 255 & n2.gzhead.name.charCodeAt(n2.gzindex++) : 0, U(n2, s2);
                } while (0 !== s2);
                n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), 0 === s2 && (n2.gzindex = 0, n2.status = 91);
              } else
                n2.status = 91;
            if (91 === n2.status)
              if (n2.gzhead.comment) {
                i2 = n2.pending;
                do {
                  if (n2.pending === n2.pending_buf_size && (n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), F(e2), i2 = n2.pending, n2.pending === n2.pending_buf_size)) {
                    s2 = 1;
                    break;
                  }
                  s2 = n2.gzindex < n2.gzhead.comment.length ? 255 & n2.gzhead.comment.charCodeAt(n2.gzindex++) : 0, U(n2, s2);
                } while (0 !== s2);
                n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), 0 === s2 && (n2.status = 103);
              } else
                n2.status = 103;
            if (103 === n2.status && (n2.gzhead.hcrc ? (n2.pending + 2 > n2.pending_buf_size && F(e2), n2.pending + 2 <= n2.pending_buf_size && (U(n2, 255 & e2.adler), U(n2, e2.adler >> 8 & 255), e2.adler = 0, n2.status = E)) : n2.status = E), 0 !== n2.pending) {
              if (F(e2), 0 === e2.avail_out)
                return n2.last_flush = -1, m;
            } else if (0 === e2.avail_in && T(t4) <= T(r2) && t4 !== f)
              return R(e2, -5);
            if (666 === n2.status && 0 !== e2.avail_in)
              return R(e2, -5);
            if (0 !== e2.avail_in || 0 !== n2.lookahead || t4 !== l && 666 !== n2.status) {
              var o2 = 2 === n2.strategy ? function(e3, t5) {
                for (var r3; ; ) {
                  if (0 === e3.lookahead && (j(e3), 0 === e3.lookahead)) {
                    if (t5 === l)
                      return A;
                    break;
                  }
                  if (e3.match_length = 0, r3 = u._tr_tally(e3, 0, e3.window[e3.strstart]), e3.lookahead--, e3.strstart++, r3 && (N(e3, false), 0 === e3.strm.avail_out))
                    return A;
                }
                return e3.insert = 0, t5 === f ? (N(e3, true), 0 === e3.strm.avail_out ? O : B) : e3.last_lit && (N(e3, false), 0 === e3.strm.avail_out) ? A : I;
              }(n2, t4) : 3 === n2.strategy ? function(e3, t5) {
                for (var r3, n3, i3, s3, a3 = e3.window; ; ) {
                  if (e3.lookahead <= S) {
                    if (j(e3), e3.lookahead <= S && t5 === l)
                      return A;
                    if (0 === e3.lookahead)
                      break;
                  }
                  if (e3.match_length = 0, e3.lookahead >= x && 0 < e3.strstart && (n3 = a3[i3 = e3.strstart - 1]) === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3]) {
                    s3 = e3.strstart + S;
                    do {
                    } while (n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && i3 < s3);
                    e3.match_length = S - (s3 - i3), e3.match_length > e3.lookahead && (e3.match_length = e3.lookahead);
                  }
                  if (e3.match_length >= x ? (r3 = u._tr_tally(e3, 1, e3.match_length - x), e3.lookahead -= e3.match_length, e3.strstart += e3.match_length, e3.match_length = 0) : (r3 = u._tr_tally(e3, 0, e3.window[e3.strstart]), e3.lookahead--, e3.strstart++), r3 && (N(e3, false), 0 === e3.strm.avail_out))
                    return A;
                }
                return e3.insert = 0, t5 === f ? (N(e3, true), 0 === e3.strm.avail_out ? O : B) : e3.last_lit && (N(e3, false), 0 === e3.strm.avail_out) ? A : I;
              }(n2, t4) : h[n2.level].func(n2, t4);
              if (o2 !== O && o2 !== B || (n2.status = 666), o2 === A || o2 === O)
                return 0 === e2.avail_out && (n2.last_flush = -1), m;
              if (o2 === I && (1 === t4 ? u._tr_align(n2) : 5 !== t4 && (u._tr_stored_block(n2, 0, 0, false), 3 === t4 && (D(n2.head), 0 === n2.lookahead && (n2.strstart = 0, n2.block_start = 0, n2.insert = 0))), F(e2), 0 === e2.avail_out))
                return n2.last_flush = -1, m;
            }
            return t4 !== f ? m : n2.wrap <= 0 ? 1 : (2 === n2.wrap ? (U(n2, 255 & e2.adler), U(n2, e2.adler >> 8 & 255), U(n2, e2.adler >> 16 & 255), U(n2, e2.adler >> 24 & 255), U(n2, 255 & e2.total_in), U(n2, e2.total_in >> 8 & 255), U(n2, e2.total_in >> 16 & 255), U(n2, e2.total_in >> 24 & 255)) : (P(n2, e2.adler >>> 16), P(n2, 65535 & e2.adler)), F(e2), 0 < n2.wrap && (n2.wrap = -n2.wrap), 0 !== n2.pending ? m : 1);
          }, r.deflateEnd = function(e2) {
            var t4;
            return e2 && e2.state ? (t4 = e2.state.status) !== C && 69 !== t4 && 73 !== t4 && 91 !== t4 && 103 !== t4 && t4 !== E && 666 !== t4 ? R(e2, _) : (e2.state = null, t4 === E ? R(e2, -3) : m) : _;
          }, r.deflateSetDictionary = function(e2, t4) {
            var r2, n2, i2, s2, a2, o2, h2, u2, l2 = t4.length;
            if (!e2 || !e2.state)
              return _;
            if (2 === (s2 = (r2 = e2.state).wrap) || 1 === s2 && r2.status !== C || r2.lookahead)
              return _;
            for (1 === s2 && (e2.adler = d(e2.adler, t4, l2, 0)), r2.wrap = 0, l2 >= r2.w_size && (0 === s2 && (D(r2.head), r2.strstart = 0, r2.block_start = 0, r2.insert = 0), u2 = new c.Buf8(r2.w_size), c.arraySet(u2, t4, l2 - r2.w_size, r2.w_size, 0), t4 = u2, l2 = r2.w_size), a2 = e2.avail_in, o2 = e2.next_in, h2 = e2.input, e2.avail_in = l2, e2.next_in = 0, e2.input = t4, j(r2); r2.lookahead >= x; ) {
              for (n2 = r2.strstart, i2 = r2.lookahead - (x - 1); r2.ins_h = (r2.ins_h << r2.hash_shift ^ r2.window[n2 + x - 1]) & r2.hash_mask, r2.prev[n2 & r2.w_mask] = r2.head[r2.ins_h], r2.head[r2.ins_h] = n2, n2++, --i2; )
                ;
              r2.strstart = n2, r2.lookahead = x - 1, j(r2);
            }
            return r2.strstart += r2.lookahead, r2.block_start = r2.strstart, r2.insert = r2.lookahead, r2.lookahead = 0, r2.match_length = r2.prev_length = x - 1, r2.match_available = 0, e2.next_in = o2, e2.input = h2, e2.avail_in = a2, r2.wrap = s2, m;
          }, r.deflateInfo = "pako deflate (from Nodeca project)";
        }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./messages": 51, "./trees": 52 }], 47: [function(e, t3, r) {
          "use strict";
          t3.exports = function() {
            this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = false;
          };
        }, {}], 48: [function(e, t3, r) {
          "use strict";
          t3.exports = function(e2, t4) {
            var r2, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
            r2 = e2.state, n = e2.next_in, z = e2.input, i = n + (e2.avail_in - 5), s = e2.next_out, C = e2.output, a = s - (t4 - e2.avail_out), o = s + (e2.avail_out - 257), h = r2.dmax, u = r2.wsize, l = r2.whave, f = r2.wnext, c = r2.window, d = r2.hold, p = r2.bits, m = r2.lencode, _ = r2.distcode, g = (1 << r2.lenbits) - 1, b = (1 << r2.distbits) - 1;
            e:
              do {
                p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                t:
                  for (; ; ) {
                    if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255))
                      C[s++] = 65535 & v;
                    else {
                      if (!(16 & y)) {
                        if (0 == (64 & y)) {
                          v = m[(65535 & v) + (d & (1 << y) - 1)];
                          continue t;
                        }
                        if (32 & y) {
                          r2.mode = 12;
                          break e;
                        }
                        e2.msg = "invalid literal/length code", r2.mode = 30;
                        break e;
                      }
                      w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                      r:
                        for (; ; ) {
                          if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                            if (0 == (64 & y)) {
                              v = _[(65535 & v) + (d & (1 << y) - 1)];
                              continue r;
                            }
                            e2.msg = "invalid distance code", r2.mode = 30;
                            break e;
                          }
                          if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                            e2.msg = "invalid distance too far back", r2.mode = 30;
                            break e;
                          }
                          if (d >>>= y, p -= y, (y = s - a) < k) {
                            if (l < (y = k - y) && r2.sane) {
                              e2.msg = "invalid distance too far back", r2.mode = 30;
                              break e;
                            }
                            if (S = c, (x = 0) === f) {
                              if (x += u - y, y < w) {
                                for (w -= y; C[s++] = c[x++], --y; )
                                  ;
                                x = s - k, S = C;
                              }
                            } else if (f < y) {
                              if (x += u + f - y, (y -= f) < w) {
                                for (w -= y; C[s++] = c[x++], --y; )
                                  ;
                                if (x = 0, f < w) {
                                  for (w -= y = f; C[s++] = c[x++], --y; )
                                    ;
                                  x = s - k, S = C;
                                }
                              }
                            } else if (x += f - y, y < w) {
                              for (w -= y; C[s++] = c[x++], --y; )
                                ;
                              x = s - k, S = C;
                            }
                            for (; 2 < w; )
                              C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                            w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                          } else {
                            for (x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3); )
                              ;
                            w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                          }
                          break;
                        }
                    }
                    break;
                  }
              } while (n < i && s < o);
            n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e2.next_in = n, e2.next_out = s, e2.avail_in = n < i ? i - n + 5 : 5 - (n - i), e2.avail_out = s < o ? o - s + 257 : 257 - (s - o), r2.hold = d, r2.bits = p;
          };
        }, {}], 49: [function(e, t3, r) {
          "use strict";
          var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
          function L(e2) {
            return (e2 >>> 24 & 255) + (e2 >>> 8 & 65280) + ((65280 & e2) << 8) + ((255 & e2) << 24);
          }
          function s() {
            this.mode = 0, this.last = false, this.wrap = 0, this.havedict = false, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
          }
          function a(e2) {
            var t4;
            return e2 && e2.state ? (t4 = e2.state, e2.total_in = e2.total_out = t4.total = 0, e2.msg = "", t4.wrap && (e2.adler = 1 & t4.wrap), t4.mode = P, t4.last = 0, t4.havedict = 0, t4.dmax = 32768, t4.head = null, t4.hold = 0, t4.bits = 0, t4.lencode = t4.lendyn = new I.Buf32(n), t4.distcode = t4.distdyn = new I.Buf32(i), t4.sane = 1, t4.back = -1, N) : U;
          }
          function o(e2) {
            var t4;
            return e2 && e2.state ? ((t4 = e2.state).wsize = 0, t4.whave = 0, t4.wnext = 0, a(e2)) : U;
          }
          function h(e2, t4) {
            var r2, n2;
            return e2 && e2.state ? (n2 = e2.state, t4 < 0 ? (r2 = 0, t4 = -t4) : (r2 = 1 + (t4 >> 4), t4 < 48 && (t4 &= 15)), t4 && (t4 < 8 || 15 < t4) ? U : (null !== n2.window && n2.wbits !== t4 && (n2.window = null), n2.wrap = r2, n2.wbits = t4, o(e2))) : U;
          }
          function u(e2, t4) {
            var r2, n2;
            return e2 ? (n2 = new s(), (e2.state = n2).window = null, (r2 = h(e2, t4)) !== N && (e2.state = null), r2) : U;
          }
          var l, f, c = true;
          function j(e2) {
            if (c) {
              var t4;
              for (l = new I.Buf32(512), f = new I.Buf32(32), t4 = 0; t4 < 144; )
                e2.lens[t4++] = 8;
              for (; t4 < 256; )
                e2.lens[t4++] = 9;
              for (; t4 < 280; )
                e2.lens[t4++] = 7;
              for (; t4 < 288; )
                e2.lens[t4++] = 8;
              for (T(D, e2.lens, 0, 288, l, 0, e2.work, { bits: 9 }), t4 = 0; t4 < 32; )
                e2.lens[t4++] = 5;
              T(F, e2.lens, 0, 32, f, 0, e2.work, { bits: 5 }), c = false;
            }
            e2.lencode = l, e2.lenbits = 9, e2.distcode = f, e2.distbits = 5;
          }
          function Z(e2, t4, r2, n2) {
            var i2, s2 = e2.state;
            return null === s2.window && (s2.wsize = 1 << s2.wbits, s2.wnext = 0, s2.whave = 0, s2.window = new I.Buf8(s2.wsize)), n2 >= s2.wsize ? (I.arraySet(s2.window, t4, r2 - s2.wsize, s2.wsize, 0), s2.wnext = 0, s2.whave = s2.wsize) : (n2 < (i2 = s2.wsize - s2.wnext) && (i2 = n2), I.arraySet(s2.window, t4, r2 - n2, i2, s2.wnext), (n2 -= i2) ? (I.arraySet(s2.window, t4, r2 - n2, n2, 0), s2.wnext = n2, s2.whave = s2.wsize) : (s2.wnext += i2, s2.wnext === s2.wsize && (s2.wnext = 0), s2.whave < s2.wsize && (s2.whave += i2))), 0;
          }
          r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e2) {
            return u(e2, 15);
          }, r.inflateInit2 = u, r.inflate = function(e2, t4) {
            var r2, n2, i2, s2, a2, o2, h2, u2, l2, f2, c2, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
            if (!e2 || !e2.state || !e2.output || !e2.input && 0 !== e2.avail_in)
              return U;
            12 === (r2 = e2.state).mode && (r2.mode = 13), a2 = e2.next_out, i2 = e2.output, h2 = e2.avail_out, s2 = e2.next_in, n2 = e2.input, o2 = e2.avail_in, u2 = r2.hold, l2 = r2.bits, f2 = o2, c2 = h2, x = N;
            e:
              for (; ; )
                switch (r2.mode) {
                  case P:
                    if (0 === r2.wrap) {
                      r2.mode = 13;
                      break;
                    }
                    for (; l2 < 16; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if (2 & r2.wrap && 35615 === u2) {
                      E[r2.check = 0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0), l2 = u2 = 0, r2.mode = 2;
                      break;
                    }
                    if (r2.flags = 0, r2.head && (r2.head.done = false), !(1 & r2.wrap) || (((255 & u2) << 8) + (u2 >> 8)) % 31) {
                      e2.msg = "incorrect header check", r2.mode = 30;
                      break;
                    }
                    if (8 != (15 & u2)) {
                      e2.msg = "unknown compression method", r2.mode = 30;
                      break;
                    }
                    if (l2 -= 4, k = 8 + (15 & (u2 >>>= 4)), 0 === r2.wbits)
                      r2.wbits = k;
                    else if (k > r2.wbits) {
                      e2.msg = "invalid window size", r2.mode = 30;
                      break;
                    }
                    r2.dmax = 1 << k, e2.adler = r2.check = 1, r2.mode = 512 & u2 ? 10 : 12, l2 = u2 = 0;
                    break;
                  case 2:
                    for (; l2 < 16; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if (r2.flags = u2, 8 != (255 & r2.flags)) {
                      e2.msg = "unknown compression method", r2.mode = 30;
                      break;
                    }
                    if (57344 & r2.flags) {
                      e2.msg = "unknown header flags set", r2.mode = 30;
                      break;
                    }
                    r2.head && (r2.head.text = u2 >> 8 & 1), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0)), l2 = u2 = 0, r2.mode = 3;
                  case 3:
                    for (; l2 < 32; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    r2.head && (r2.head.time = u2), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, E[2] = u2 >>> 16 & 255, E[3] = u2 >>> 24 & 255, r2.check = B(r2.check, E, 4, 0)), l2 = u2 = 0, r2.mode = 4;
                  case 4:
                    for (; l2 < 16; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    r2.head && (r2.head.xflags = 255 & u2, r2.head.os = u2 >> 8), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0)), l2 = u2 = 0, r2.mode = 5;
                  case 5:
                    if (1024 & r2.flags) {
                      for (; l2 < 16; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      r2.length = u2, r2.head && (r2.head.extra_len = u2), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0)), l2 = u2 = 0;
                    } else
                      r2.head && (r2.head.extra = null);
                    r2.mode = 6;
                  case 6:
                    if (1024 & r2.flags && (o2 < (d = r2.length) && (d = o2), d && (r2.head && (k = r2.head.extra_len - r2.length, r2.head.extra || (r2.head.extra = new Array(r2.head.extra_len)), I.arraySet(r2.head.extra, n2, s2, d, k)), 512 & r2.flags && (r2.check = B(r2.check, n2, d, s2)), o2 -= d, s2 += d, r2.length -= d), r2.length))
                      break e;
                    r2.length = 0, r2.mode = 7;
                  case 7:
                    if (2048 & r2.flags) {
                      if (0 === o2)
                        break e;
                      for (d = 0; k = n2[s2 + d++], r2.head && k && r2.length < 65536 && (r2.head.name += String.fromCharCode(k)), k && d < o2; )
                        ;
                      if (512 & r2.flags && (r2.check = B(r2.check, n2, d, s2)), o2 -= d, s2 += d, k)
                        break e;
                    } else
                      r2.head && (r2.head.name = null);
                    r2.length = 0, r2.mode = 8;
                  case 8:
                    if (4096 & r2.flags) {
                      if (0 === o2)
                        break e;
                      for (d = 0; k = n2[s2 + d++], r2.head && k && r2.length < 65536 && (r2.head.comment += String.fromCharCode(k)), k && d < o2; )
                        ;
                      if (512 & r2.flags && (r2.check = B(r2.check, n2, d, s2)), o2 -= d, s2 += d, k)
                        break e;
                    } else
                      r2.head && (r2.head.comment = null);
                    r2.mode = 9;
                  case 9:
                    if (512 & r2.flags) {
                      for (; l2 < 16; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      if (u2 !== (65535 & r2.check)) {
                        e2.msg = "header crc mismatch", r2.mode = 30;
                        break;
                      }
                      l2 = u2 = 0;
                    }
                    r2.head && (r2.head.hcrc = r2.flags >> 9 & 1, r2.head.done = true), e2.adler = r2.check = 0, r2.mode = 12;
                    break;
                  case 10:
                    for (; l2 < 32; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    e2.adler = r2.check = L(u2), l2 = u2 = 0, r2.mode = 11;
                  case 11:
                    if (0 === r2.havedict)
                      return e2.next_out = a2, e2.avail_out = h2, e2.next_in = s2, e2.avail_in = o2, r2.hold = u2, r2.bits = l2, 2;
                    e2.adler = r2.check = 1, r2.mode = 12;
                  case 12:
                    if (5 === t4 || 6 === t4)
                      break e;
                  case 13:
                    if (r2.last) {
                      u2 >>>= 7 & l2, l2 -= 7 & l2, r2.mode = 27;
                      break;
                    }
                    for (; l2 < 3; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    switch (r2.last = 1 & u2, l2 -= 1, 3 & (u2 >>>= 1)) {
                      case 0:
                        r2.mode = 14;
                        break;
                      case 1:
                        if (j(r2), r2.mode = 20, 6 !== t4)
                          break;
                        u2 >>>= 2, l2 -= 2;
                        break e;
                      case 2:
                        r2.mode = 17;
                        break;
                      case 3:
                        e2.msg = "invalid block type", r2.mode = 30;
                    }
                    u2 >>>= 2, l2 -= 2;
                    break;
                  case 14:
                    for (u2 >>>= 7 & l2, l2 -= 7 & l2; l2 < 32; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if ((65535 & u2) != (u2 >>> 16 ^ 65535)) {
                      e2.msg = "invalid stored block lengths", r2.mode = 30;
                      break;
                    }
                    if (r2.length = 65535 & u2, l2 = u2 = 0, r2.mode = 15, 6 === t4)
                      break e;
                  case 15:
                    r2.mode = 16;
                  case 16:
                    if (d = r2.length) {
                      if (o2 < d && (d = o2), h2 < d && (d = h2), 0 === d)
                        break e;
                      I.arraySet(i2, n2, s2, d, a2), o2 -= d, s2 += d, h2 -= d, a2 += d, r2.length -= d;
                      break;
                    }
                    r2.mode = 12;
                    break;
                  case 17:
                    for (; l2 < 14; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if (r2.nlen = 257 + (31 & u2), u2 >>>= 5, l2 -= 5, r2.ndist = 1 + (31 & u2), u2 >>>= 5, l2 -= 5, r2.ncode = 4 + (15 & u2), u2 >>>= 4, l2 -= 4, 286 < r2.nlen || 30 < r2.ndist) {
                      e2.msg = "too many length or distance symbols", r2.mode = 30;
                      break;
                    }
                    r2.have = 0, r2.mode = 18;
                  case 18:
                    for (; r2.have < r2.ncode; ) {
                      for (; l2 < 3; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      r2.lens[A[r2.have++]] = 7 & u2, u2 >>>= 3, l2 -= 3;
                    }
                    for (; r2.have < 19; )
                      r2.lens[A[r2.have++]] = 0;
                    if (r2.lencode = r2.lendyn, r2.lenbits = 7, S = { bits: r2.lenbits }, x = T(0, r2.lens, 0, 19, r2.lencode, 0, r2.work, S), r2.lenbits = S.bits, x) {
                      e2.msg = "invalid code lengths set", r2.mode = 30;
                      break;
                    }
                    r2.have = 0, r2.mode = 19;
                  case 19:
                    for (; r2.have < r2.nlen + r2.ndist; ) {
                      for (; g = (C = r2.lencode[u2 & (1 << r2.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l2); ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      if (b < 16)
                        u2 >>>= _, l2 -= _, r2.lens[r2.have++] = b;
                      else {
                        if (16 === b) {
                          for (z = _ + 2; l2 < z; ) {
                            if (0 === o2)
                              break e;
                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                          }
                          if (u2 >>>= _, l2 -= _, 0 === r2.have) {
                            e2.msg = "invalid bit length repeat", r2.mode = 30;
                            break;
                          }
                          k = r2.lens[r2.have - 1], d = 3 + (3 & u2), u2 >>>= 2, l2 -= 2;
                        } else if (17 === b) {
                          for (z = _ + 3; l2 < z; ) {
                            if (0 === o2)
                              break e;
                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                          }
                          l2 -= _, k = 0, d = 3 + (7 & (u2 >>>= _)), u2 >>>= 3, l2 -= 3;
                        } else {
                          for (z = _ + 7; l2 < z; ) {
                            if (0 === o2)
                              break e;
                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                          }
                          l2 -= _, k = 0, d = 11 + (127 & (u2 >>>= _)), u2 >>>= 7, l2 -= 7;
                        }
                        if (r2.have + d > r2.nlen + r2.ndist) {
                          e2.msg = "invalid bit length repeat", r2.mode = 30;
                          break;
                        }
                        for (; d--; )
                          r2.lens[r2.have++] = k;
                      }
                    }
                    if (30 === r2.mode)
                      break;
                    if (0 === r2.lens[256]) {
                      e2.msg = "invalid code -- missing end-of-block", r2.mode = 30;
                      break;
                    }
                    if (r2.lenbits = 9, S = { bits: r2.lenbits }, x = T(D, r2.lens, 0, r2.nlen, r2.lencode, 0, r2.work, S), r2.lenbits = S.bits, x) {
                      e2.msg = "invalid literal/lengths set", r2.mode = 30;
                      break;
                    }
                    if (r2.distbits = 6, r2.distcode = r2.distdyn, S = { bits: r2.distbits }, x = T(F, r2.lens, r2.nlen, r2.ndist, r2.distcode, 0, r2.work, S), r2.distbits = S.bits, x) {
                      e2.msg = "invalid distances set", r2.mode = 30;
                      break;
                    }
                    if (r2.mode = 20, 6 === t4)
                      break e;
                  case 20:
                    r2.mode = 21;
                  case 21:
                    if (6 <= o2 && 258 <= h2) {
                      e2.next_out = a2, e2.avail_out = h2, e2.next_in = s2, e2.avail_in = o2, r2.hold = u2, r2.bits = l2, R(e2, c2), a2 = e2.next_out, i2 = e2.output, h2 = e2.avail_out, s2 = e2.next_in, n2 = e2.input, o2 = e2.avail_in, u2 = r2.hold, l2 = r2.bits, 12 === r2.mode && (r2.back = -1);
                      break;
                    }
                    for (r2.back = 0; g = (C = r2.lencode[u2 & (1 << r2.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l2); ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if (g && 0 == (240 & g)) {
                      for (v = _, y = g, w = b; g = (C = r2.lencode[w + ((u2 & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l2); ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      u2 >>>= v, l2 -= v, r2.back += v;
                    }
                    if (u2 >>>= _, l2 -= _, r2.back += _, r2.length = b, 0 === g) {
                      r2.mode = 26;
                      break;
                    }
                    if (32 & g) {
                      r2.back = -1, r2.mode = 12;
                      break;
                    }
                    if (64 & g) {
                      e2.msg = "invalid literal/length code", r2.mode = 30;
                      break;
                    }
                    r2.extra = 15 & g, r2.mode = 22;
                  case 22:
                    if (r2.extra) {
                      for (z = r2.extra; l2 < z; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      r2.length += u2 & (1 << r2.extra) - 1, u2 >>>= r2.extra, l2 -= r2.extra, r2.back += r2.extra;
                    }
                    r2.was = r2.length, r2.mode = 23;
                  case 23:
                    for (; g = (C = r2.distcode[u2 & (1 << r2.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l2); ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if (0 == (240 & g)) {
                      for (v = _, y = g, w = b; g = (C = r2.distcode[w + ((u2 & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l2); ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      u2 >>>= v, l2 -= v, r2.back += v;
                    }
                    if (u2 >>>= _, l2 -= _, r2.back += _, 64 & g) {
                      e2.msg = "invalid distance code", r2.mode = 30;
                      break;
                    }
                    r2.offset = b, r2.extra = 15 & g, r2.mode = 24;
                  case 24:
                    if (r2.extra) {
                      for (z = r2.extra; l2 < z; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      r2.offset += u2 & (1 << r2.extra) - 1, u2 >>>= r2.extra, l2 -= r2.extra, r2.back += r2.extra;
                    }
                    if (r2.offset > r2.dmax) {
                      e2.msg = "invalid distance too far back", r2.mode = 30;
                      break;
                    }
                    r2.mode = 25;
                  case 25:
                    if (0 === h2)
                      break e;
                    if (d = c2 - h2, r2.offset > d) {
                      if ((d = r2.offset - d) > r2.whave && r2.sane) {
                        e2.msg = "invalid distance too far back", r2.mode = 30;
                        break;
                      }
                      p = d > r2.wnext ? (d -= r2.wnext, r2.wsize - d) : r2.wnext - d, d > r2.length && (d = r2.length), m = r2.window;
                    } else
                      m = i2, p = a2 - r2.offset, d = r2.length;
                    for (h2 < d && (d = h2), h2 -= d, r2.length -= d; i2[a2++] = m[p++], --d; )
                      ;
                    0 === r2.length && (r2.mode = 21);
                    break;
                  case 26:
                    if (0 === h2)
                      break e;
                    i2[a2++] = r2.length, h2--, r2.mode = 21;
                    break;
                  case 27:
                    if (r2.wrap) {
                      for (; l2 < 32; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 |= n2[s2++] << l2, l2 += 8;
                      }
                      if (c2 -= h2, e2.total_out += c2, r2.total += c2, c2 && (e2.adler = r2.check = r2.flags ? B(r2.check, i2, c2, a2 - c2) : O(r2.check, i2, c2, a2 - c2)), c2 = h2, (r2.flags ? u2 : L(u2)) !== r2.check) {
                        e2.msg = "incorrect data check", r2.mode = 30;
                        break;
                      }
                      l2 = u2 = 0;
                    }
                    r2.mode = 28;
                  case 28:
                    if (r2.wrap && r2.flags) {
                      for (; l2 < 32; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      if (u2 !== (4294967295 & r2.total)) {
                        e2.msg = "incorrect length check", r2.mode = 30;
                        break;
                      }
                      l2 = u2 = 0;
                    }
                    r2.mode = 29;
                  case 29:
                    x = 1;
                    break e;
                  case 30:
                    x = -3;
                    break e;
                  case 31:
                    return -4;
                  case 32:
                  default:
                    return U;
                }
            return e2.next_out = a2, e2.avail_out = h2, e2.next_in = s2, e2.avail_in = o2, r2.hold = u2, r2.bits = l2, (r2.wsize || c2 !== e2.avail_out && r2.mode < 30 && (r2.mode < 27 || 4 !== t4)) && Z(e2, e2.output, e2.next_out, c2 - e2.avail_out) ? (r2.mode = 31, -4) : (f2 -= e2.avail_in, c2 -= e2.avail_out, e2.total_in += f2, e2.total_out += c2, r2.total += c2, r2.wrap && c2 && (e2.adler = r2.check = r2.flags ? B(r2.check, i2, c2, e2.next_out - c2) : O(r2.check, i2, c2, e2.next_out - c2)), e2.data_type = r2.bits + (r2.last ? 64 : 0) + (12 === r2.mode ? 128 : 0) + (20 === r2.mode || 15 === r2.mode ? 256 : 0), (0 == f2 && 0 === c2 || 4 === t4) && x === N && (x = -5), x);
          }, r.inflateEnd = function(e2) {
            if (!e2 || !e2.state)
              return U;
            var t4 = e2.state;
            return t4.window && (t4.window = null), e2.state = null, N;
          }, r.inflateGetHeader = function(e2, t4) {
            var r2;
            return e2 && e2.state ? 0 == (2 & (r2 = e2.state).wrap) ? U : ((r2.head = t4).done = false, N) : U;
          }, r.inflateSetDictionary = function(e2, t4) {
            var r2, n2 = t4.length;
            return e2 && e2.state ? 0 !== (r2 = e2.state).wrap && 11 !== r2.mode ? U : 11 === r2.mode && O(1, t4, n2, 0) !== r2.check ? -3 : Z(e2, t4, n2, n2) ? (r2.mode = 31, -4) : (r2.havedict = 1, N) : U;
          }, r.inflateInfo = "pako inflate (from Nodeca project)";
        }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./inffast": 48, "./inftrees": 50 }], 50: [function(e, t3, r) {
          "use strict";
          var D = e("../utils/common"), F = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], N = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], U = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], P = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
          t3.exports = function(e2, t4, r2, n, i, s, a, o) {
            var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
            for (b = 0; b <= 15; b++)
              O[b] = 0;
            for (v = 0; v < n; v++)
              O[t4[r2 + v]]++;
            for (k = g, w = 15; 1 <= w && 0 === O[w]; w--)
              ;
            if (w < k && (k = w), 0 === w)
              return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
            for (y = 1; y < w && 0 === O[y]; y++)
              ;
            for (k < y && (k = y), b = z = 1; b <= 15; b++)
              if (z <<= 1, (z -= O[b]) < 0)
                return -1;
            if (0 < z && (0 === e2 || 1 !== w))
              return -1;
            for (B[1] = 0, b = 1; b < 15; b++)
              B[b + 1] = B[b] + O[b];
            for (v = 0; v < n; v++)
              0 !== t4[r2 + v] && (a[B[t4[r2 + v]]++] = v);
            if (d = 0 === e2 ? (A = R = a, 19) : 1 === e2 ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e2 && 852 < C || 2 === e2 && 592 < C)
              return 1;
            for (; ; ) {
              for (p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u; )
                ;
              for (h = 1 << b - 1; E & h; )
                h >>= 1;
              if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                if (b === w)
                  break;
                b = t4[r2 + a[v]];
              }
              if (k < b && (E & f) !== l) {
                for (0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0); )
                  x++, z <<= 1;
                if (C += 1 << x, 1 === e2 && 852 < C || 2 === e2 && 592 < C)
                  return 1;
                i[l = E & f] = k << 24 | x << 16 | c - s | 0;
              }
            }
            return 0 !== E && (i[c + E] = b - S << 24 | 64 << 16 | 0), o.bits = k, 0;
          };
        }, { "../utils/common": 41 }], 51: [function(e, t3, r) {
          "use strict";
          t3.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
        }, {}], 52: [function(e, t3, r) {
          "use strict";
          var i = e("../utils/common"), o = 0, h = 1;
          function n(e2) {
            for (var t4 = e2.length; 0 <= --t4; )
              e2[t4] = 0;
          }
          var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], k = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], x = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], S = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], z = new Array(2 * (l + 2));
          n(z);
          var C = new Array(2 * f);
          n(C);
          var E = new Array(512);
          n(E);
          var A = new Array(256);
          n(A);
          var I = new Array(a);
          n(I);
          var O, B, R, T = new Array(f);
          function D(e2, t4, r2, n2, i2) {
            this.static_tree = e2, this.extra_bits = t4, this.extra_base = r2, this.elems = n2, this.max_length = i2, this.has_stree = e2 && e2.length;
          }
          function F(e2, t4) {
            this.dyn_tree = e2, this.max_code = 0, this.stat_desc = t4;
          }
          function N(e2) {
            return e2 < 256 ? E[e2] : E[256 + (e2 >>> 7)];
          }
          function U(e2, t4) {
            e2.pending_buf[e2.pending++] = 255 & t4, e2.pending_buf[e2.pending++] = t4 >>> 8 & 255;
          }
          function P(e2, t4, r2) {
            e2.bi_valid > d - r2 ? (e2.bi_buf |= t4 << e2.bi_valid & 65535, U(e2, e2.bi_buf), e2.bi_buf = t4 >> d - e2.bi_valid, e2.bi_valid += r2 - d) : (e2.bi_buf |= t4 << e2.bi_valid & 65535, e2.bi_valid += r2);
          }
          function L(e2, t4, r2) {
            P(e2, r2[2 * t4], r2[2 * t4 + 1]);
          }
          function j(e2, t4) {
            for (var r2 = 0; r2 |= 1 & e2, e2 >>>= 1, r2 <<= 1, 0 < --t4; )
              ;
            return r2 >>> 1;
          }
          function Z(e2, t4, r2) {
            var n2, i2, s2 = new Array(g + 1), a2 = 0;
            for (n2 = 1; n2 <= g; n2++)
              s2[n2] = a2 = a2 + r2[n2 - 1] << 1;
            for (i2 = 0; i2 <= t4; i2++) {
              var o2 = e2[2 * i2 + 1];
              0 !== o2 && (e2[2 * i2] = j(s2[o2]++, o2));
            }
          }
          function W(e2) {
            var t4;
            for (t4 = 0; t4 < l; t4++)
              e2.dyn_ltree[2 * t4] = 0;
            for (t4 = 0; t4 < f; t4++)
              e2.dyn_dtree[2 * t4] = 0;
            for (t4 = 0; t4 < c; t4++)
              e2.bl_tree[2 * t4] = 0;
            e2.dyn_ltree[2 * m] = 1, e2.opt_len = e2.static_len = 0, e2.last_lit = e2.matches = 0;
          }
          function M(e2) {
            8 < e2.bi_valid ? U(e2, e2.bi_buf) : 0 < e2.bi_valid && (e2.pending_buf[e2.pending++] = e2.bi_buf), e2.bi_buf = 0, e2.bi_valid = 0;
          }
          function H(e2, t4, r2, n2) {
            var i2 = 2 * t4, s2 = 2 * r2;
            return e2[i2] < e2[s2] || e2[i2] === e2[s2] && n2[t4] <= n2[r2];
          }
          function G(e2, t4, r2) {
            for (var n2 = e2.heap[r2], i2 = r2 << 1; i2 <= e2.heap_len && (i2 < e2.heap_len && H(t4, e2.heap[i2 + 1], e2.heap[i2], e2.depth) && i2++, !H(t4, n2, e2.heap[i2], e2.depth)); )
              e2.heap[r2] = e2.heap[i2], r2 = i2, i2 <<= 1;
            e2.heap[r2] = n2;
          }
          function K(e2, t4, r2) {
            var n2, i2, s2, a2, o2 = 0;
            if (0 !== e2.last_lit)
              for (; n2 = e2.pending_buf[e2.d_buf + 2 * o2] << 8 | e2.pending_buf[e2.d_buf + 2 * o2 + 1], i2 = e2.pending_buf[e2.l_buf + o2], o2++, 0 === n2 ? L(e2, i2, t4) : (L(e2, (s2 = A[i2]) + u + 1, t4), 0 !== (a2 = w[s2]) && P(e2, i2 -= I[s2], a2), L(e2, s2 = N(--n2), r2), 0 !== (a2 = k[s2]) && P(e2, n2 -= T[s2], a2)), o2 < e2.last_lit; )
                ;
            L(e2, m, t4);
          }
          function Y(e2, t4) {
            var r2, n2, i2, s2 = t4.dyn_tree, a2 = t4.stat_desc.static_tree, o2 = t4.stat_desc.has_stree, h2 = t4.stat_desc.elems, u2 = -1;
            for (e2.heap_len = 0, e2.heap_max = _, r2 = 0; r2 < h2; r2++)
              0 !== s2[2 * r2] ? (e2.heap[++e2.heap_len] = u2 = r2, e2.depth[r2] = 0) : s2[2 * r2 + 1] = 0;
            for (; e2.heap_len < 2; )
              s2[2 * (i2 = e2.heap[++e2.heap_len] = u2 < 2 ? ++u2 : 0)] = 1, e2.depth[i2] = 0, e2.opt_len--, o2 && (e2.static_len -= a2[2 * i2 + 1]);
            for (t4.max_code = u2, r2 = e2.heap_len >> 1; 1 <= r2; r2--)
              G(e2, s2, r2);
            for (i2 = h2; r2 = e2.heap[1], e2.heap[1] = e2.heap[e2.heap_len--], G(e2, s2, 1), n2 = e2.heap[1], e2.heap[--e2.heap_max] = r2, e2.heap[--e2.heap_max] = n2, s2[2 * i2] = s2[2 * r2] + s2[2 * n2], e2.depth[i2] = (e2.depth[r2] >= e2.depth[n2] ? e2.depth[r2] : e2.depth[n2]) + 1, s2[2 * r2 + 1] = s2[2 * n2 + 1] = i2, e2.heap[1] = i2++, G(e2, s2, 1), 2 <= e2.heap_len; )
              ;
            e2.heap[--e2.heap_max] = e2.heap[1], function(e3, t5) {
              var r3, n3, i3, s3, a3, o3, h3 = t5.dyn_tree, u3 = t5.max_code, l2 = t5.stat_desc.static_tree, f2 = t5.stat_desc.has_stree, c2 = t5.stat_desc.extra_bits, d2 = t5.stat_desc.extra_base, p2 = t5.stat_desc.max_length, m2 = 0;
              for (s3 = 0; s3 <= g; s3++)
                e3.bl_count[s3] = 0;
              for (h3[2 * e3.heap[e3.heap_max] + 1] = 0, r3 = e3.heap_max + 1; r3 < _; r3++)
                p2 < (s3 = h3[2 * h3[2 * (n3 = e3.heap[r3]) + 1] + 1] + 1) && (s3 = p2, m2++), h3[2 * n3 + 1] = s3, u3 < n3 || (e3.bl_count[s3]++, a3 = 0, d2 <= n3 && (a3 = c2[n3 - d2]), o3 = h3[2 * n3], e3.opt_len += o3 * (s3 + a3), f2 && (e3.static_len += o3 * (l2[2 * n3 + 1] + a3)));
              if (0 !== m2) {
                do {
                  for (s3 = p2 - 1; 0 === e3.bl_count[s3]; )
                    s3--;
                  e3.bl_count[s3]--, e3.bl_count[s3 + 1] += 2, e3.bl_count[p2]--, m2 -= 2;
                } while (0 < m2);
                for (s3 = p2; 0 !== s3; s3--)
                  for (n3 = e3.bl_count[s3]; 0 !== n3; )
                    u3 < (i3 = e3.heap[--r3]) || (h3[2 * i3 + 1] !== s3 && (e3.opt_len += (s3 - h3[2 * i3 + 1]) * h3[2 * i3], h3[2 * i3 + 1] = s3), n3--);
              }
            }(e2, t4), Z(s2, u2, e2.bl_count);
          }
          function X(e2, t4, r2) {
            var n2, i2, s2 = -1, a2 = t4[1], o2 = 0, h2 = 7, u2 = 4;
            for (0 === a2 && (h2 = 138, u2 = 3), t4[2 * (r2 + 1) + 1] = 65535, n2 = 0; n2 <= r2; n2++)
              i2 = a2, a2 = t4[2 * (n2 + 1) + 1], ++o2 < h2 && i2 === a2 || (o2 < u2 ? e2.bl_tree[2 * i2] += o2 : 0 !== i2 ? (i2 !== s2 && e2.bl_tree[2 * i2]++, e2.bl_tree[2 * b]++) : o2 <= 10 ? e2.bl_tree[2 * v]++ : e2.bl_tree[2 * y]++, s2 = i2, u2 = (o2 = 0) === a2 ? (h2 = 138, 3) : i2 === a2 ? (h2 = 6, 3) : (h2 = 7, 4));
          }
          function V(e2, t4, r2) {
            var n2, i2, s2 = -1, a2 = t4[1], o2 = 0, h2 = 7, u2 = 4;
            for (0 === a2 && (h2 = 138, u2 = 3), n2 = 0; n2 <= r2; n2++)
              if (i2 = a2, a2 = t4[2 * (n2 + 1) + 1], !(++o2 < h2 && i2 === a2)) {
                if (o2 < u2)
                  for (; L(e2, i2, e2.bl_tree), 0 != --o2; )
                    ;
                else
                  0 !== i2 ? (i2 !== s2 && (L(e2, i2, e2.bl_tree), o2--), L(e2, b, e2.bl_tree), P(e2, o2 - 3, 2)) : o2 <= 10 ? (L(e2, v, e2.bl_tree), P(e2, o2 - 3, 3)) : (L(e2, y, e2.bl_tree), P(e2, o2 - 11, 7));
                s2 = i2, u2 = (o2 = 0) === a2 ? (h2 = 138, 3) : i2 === a2 ? (h2 = 6, 3) : (h2 = 7, 4);
              }
          }
          n(T);
          var q = false;
          function J(e2, t4, r2, n2) {
            P(e2, (s << 1) + (n2 ? 1 : 0), 3), function(e3, t5, r3, n3) {
              M(e3), n3 && (U(e3, r3), U(e3, ~r3)), i.arraySet(e3.pending_buf, e3.window, t5, r3, e3.pending), e3.pending += r3;
            }(e2, t4, r2, true);
          }
          r._tr_init = function(e2) {
            q || (function() {
              var e3, t4, r2, n2, i2, s2 = new Array(g + 1);
              for (n2 = r2 = 0; n2 < a - 1; n2++)
                for (I[n2] = r2, e3 = 0; e3 < 1 << w[n2]; e3++)
                  A[r2++] = n2;
              for (A[r2 - 1] = n2, n2 = i2 = 0; n2 < 16; n2++)
                for (T[n2] = i2, e3 = 0; e3 < 1 << k[n2]; e3++)
                  E[i2++] = n2;
              for (i2 >>= 7; n2 < f; n2++)
                for (T[n2] = i2 << 7, e3 = 0; e3 < 1 << k[n2] - 7; e3++)
                  E[256 + i2++] = n2;
              for (t4 = 0; t4 <= g; t4++)
                s2[t4] = 0;
              for (e3 = 0; e3 <= 143; )
                z[2 * e3 + 1] = 8, e3++, s2[8]++;
              for (; e3 <= 255; )
                z[2 * e3 + 1] = 9, e3++, s2[9]++;
              for (; e3 <= 279; )
                z[2 * e3 + 1] = 7, e3++, s2[7]++;
              for (; e3 <= 287; )
                z[2 * e3 + 1] = 8, e3++, s2[8]++;
              for (Z(z, l + 1, s2), e3 = 0; e3 < f; e3++)
                C[2 * e3 + 1] = 5, C[2 * e3] = j(e3, 5);
              O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
            }(), q = true), e2.l_desc = new F(e2.dyn_ltree, O), e2.d_desc = new F(e2.dyn_dtree, B), e2.bl_desc = new F(e2.bl_tree, R), e2.bi_buf = 0, e2.bi_valid = 0, W(e2);
          }, r._tr_stored_block = J, r._tr_flush_block = function(e2, t4, r2, n2) {
            var i2, s2, a2 = 0;
            0 < e2.level ? (2 === e2.strm.data_type && (e2.strm.data_type = function(e3) {
              var t5, r3 = 4093624447;
              for (t5 = 0; t5 <= 31; t5++, r3 >>>= 1)
                if (1 & r3 && 0 !== e3.dyn_ltree[2 * t5])
                  return o;
              if (0 !== e3.dyn_ltree[18] || 0 !== e3.dyn_ltree[20] || 0 !== e3.dyn_ltree[26])
                return h;
              for (t5 = 32; t5 < u; t5++)
                if (0 !== e3.dyn_ltree[2 * t5])
                  return h;
              return o;
            }(e2)), Y(e2, e2.l_desc), Y(e2, e2.d_desc), a2 = function(e3) {
              var t5;
              for (X(e3, e3.dyn_ltree, e3.l_desc.max_code), X(e3, e3.dyn_dtree, e3.d_desc.max_code), Y(e3, e3.bl_desc), t5 = c - 1; 3 <= t5 && 0 === e3.bl_tree[2 * S[t5] + 1]; t5--)
                ;
              return e3.opt_len += 3 * (t5 + 1) + 5 + 5 + 4, t5;
            }(e2), i2 = e2.opt_len + 3 + 7 >>> 3, (s2 = e2.static_len + 3 + 7 >>> 3) <= i2 && (i2 = s2)) : i2 = s2 = r2 + 5, r2 + 4 <= i2 && -1 !== t4 ? J(e2, t4, r2, n2) : 4 === e2.strategy || s2 === i2 ? (P(e2, 2 + (n2 ? 1 : 0), 3), K(e2, z, C)) : (P(e2, 4 + (n2 ? 1 : 0), 3), function(e3, t5, r3, n3) {
              var i3;
              for (P(e3, t5 - 257, 5), P(e3, r3 - 1, 5), P(e3, n3 - 4, 4), i3 = 0; i3 < n3; i3++)
                P(e3, e3.bl_tree[2 * S[i3] + 1], 3);
              V(e3, e3.dyn_ltree, t5 - 1), V(e3, e3.dyn_dtree, r3 - 1);
            }(e2, e2.l_desc.max_code + 1, e2.d_desc.max_code + 1, a2 + 1), K(e2, e2.dyn_ltree, e2.dyn_dtree)), W(e2), n2 && M(e2);
          }, r._tr_tally = function(e2, t4, r2) {
            return e2.pending_buf[e2.d_buf + 2 * e2.last_lit] = t4 >>> 8 & 255, e2.pending_buf[e2.d_buf + 2 * e2.last_lit + 1] = 255 & t4, e2.pending_buf[e2.l_buf + e2.last_lit] = 255 & r2, e2.last_lit++, 0 === t4 ? e2.dyn_ltree[2 * r2]++ : (e2.matches++, t4--, e2.dyn_ltree[2 * (A[r2] + u + 1)]++, e2.dyn_dtree[2 * N(t4)]++), e2.last_lit === e2.lit_bufsize - 1;
          }, r._tr_align = function(e2) {
            P(e2, 2, 3), L(e2, m, z), function(e3) {
              16 === e3.bi_valid ? (U(e3, e3.bi_buf), e3.bi_buf = 0, e3.bi_valid = 0) : 8 <= e3.bi_valid && (e3.pending_buf[e3.pending++] = 255 & e3.bi_buf, e3.bi_buf >>= 8, e3.bi_valid -= 8);
            }(e2);
          };
        }, { "../utils/common": 41 }], 53: [function(e, t3, r) {
          "use strict";
          t3.exports = function() {
            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
          };
        }, {}], 54: [function(e, t3, r) {
          (function(e2) {
            !function(r2, n) {
              "use strict";
              if (!r2.setImmediate) {
                var i, s, t4, a, o = 1, h = {}, u = false, l = r2.document, e3 = Object.getPrototypeOf && Object.getPrototypeOf(r2);
                e3 = e3 && e3.setTimeout ? e3 : r2, i = "[object process]" === {}.toString.call(r2.process) ? function(e4) {
                  define_process_default.nextTick(function() {
                    c(e4);
                  });
                } : function() {
                  if (r2.postMessage && !r2.importScripts) {
                    var e4 = true, t5 = r2.onmessage;
                    return r2.onmessage = function() {
                      e4 = false;
                    }, r2.postMessage("", "*"), r2.onmessage = t5, e4;
                  }
                }() ? (a = "setImmediate$" + Math.random() + "$", r2.addEventListener ? r2.addEventListener("message", d, false) : r2.attachEvent("onmessage", d), function(e4) {
                  r2.postMessage(a + e4, "*");
                }) : r2.MessageChannel ? ((t4 = new MessageChannel()).port1.onmessage = function(e4) {
                  c(e4.data);
                }, function(e4) {
                  t4.port2.postMessage(e4);
                }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e4) {
                  var t5 = l.createElement("script");
                  t5.onreadystatechange = function() {
                    c(e4), t5.onreadystatechange = null, s.removeChild(t5), t5 = null;
                  }, s.appendChild(t5);
                }) : function(e4) {
                  setTimeout(c, 0, e4);
                }, e3.setImmediate = function(e4) {
                  "function" != typeof e4 && (e4 = new Function("" + e4));
                  for (var t5 = new Array(arguments.length - 1), r3 = 0; r3 < t5.length; r3++)
                    t5[r3] = arguments[r3 + 1];
                  var n2 = { callback: e4, args: t5 };
                  return h[o] = n2, i(o), o++;
                }, e3.clearImmediate = f;
              }
              function f(e4) {
                delete h[e4];
              }
              function c(e4) {
                if (u)
                  setTimeout(c, 0, e4);
                else {
                  var t5 = h[e4];
                  if (t5) {
                    u = true;
                    try {
                      !function(e5) {
                        var t6 = e5.callback, r3 = e5.args;
                        switch (r3.length) {
                          case 0:
                            t6();
                            break;
                          case 1:
                            t6(r3[0]);
                            break;
                          case 2:
                            t6(r3[0], r3[1]);
                            break;
                          case 3:
                            t6(r3[0], r3[1], r3[2]);
                            break;
                          default:
                            t6.apply(n, r3);
                        }
                      }(t5);
                    } finally {
                      f(e4), u = false;
                    }
                  }
                }
              }
              function d(e4) {
                e4.source === r2 && "string" == typeof e4.data && 0 === e4.data.indexOf(a) && c(+e4.data.slice(a.length));
              }
            }("undefined" == typeof self ? void 0 === e2 ? this : e2 : self);
          }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
        }, {}] }, {}, [10])(10);
      });
    }
  });

  // ../../node_modules/.pnpm/file-saver@2.0.5/node_modules/file-saver/dist/FileSaver.min.js
  var require_FileSaver_min = __commonJS({
    "../../node_modules/.pnpm/file-saver@2.0.5/node_modules/file-saver/dist/FileSaver.min.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      (function(a, b) {
        if ("function" == typeof define && define.amd)
          define([], b);
        else if ("undefined" != typeof exports8)
          b();
        else {
          b(), a.FileSaver = { exports: {} }.exports;
        }
      })(exports8, function() {
        "use strict";
        function b(a2, b2) {
          return "undefined" == typeof b2 ? b2 = { autoBom: false } : "object" != typeof b2 && (console.warn("Deprecated: Expected third argument to be a object"), b2 = { autoBom: !b2 }), b2.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a2.type) ? new Blob(["\uFEFF", a2], { type: a2.type }) : a2;
        }
        function c(a2, b2, c2) {
          var d2 = new XMLHttpRequest();
          d2.open("GET", a2), d2.responseType = "blob", d2.onload = function() {
            g(d2.response, b2, c2);
          }, d2.onerror = function() {
            console.error("could not download file");
          }, d2.send();
        }
        function d(a2) {
          var b2 = new XMLHttpRequest();
          b2.open("HEAD", a2, false);
          try {
            b2.send();
          } catch (a3) {
          }
          return 200 <= b2.status && 299 >= b2.status;
        }
        function e(a2) {
          try {
            a2.dispatchEvent(new MouseEvent("click"));
          } catch (c2) {
            var b2 = document.createEvent("MouseEvents");
            b2.initMouseEvent("click", true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null), a2.dispatchEvent(b2);
          }
        }
        var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof global && global.global === global ? global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {
        } : "download" in HTMLAnchorElement.prototype && !a ? function(b2, g2, h) {
          var i = f.URL || f.webkitURL, j = document.createElement("a");
          g2 = g2 || b2.name || "download", j.download = g2, j.rel = "noopener", "string" == typeof b2 ? (j.href = b2, j.origin === location.origin ? e(j) : d(j.href) ? c(b2, g2, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b2), setTimeout(function() {
            i.revokeObjectURL(j.href);
          }, 4e4), setTimeout(function() {
            e(j);
          }, 0));
        } : "msSaveOrOpenBlob" in navigator ? function(f2, g2, h) {
          if (g2 = g2 || f2.name || "download", "string" != typeof f2)
            navigator.msSaveOrOpenBlob(b(f2, h), g2);
          else if (d(f2))
            c(f2, g2, h);
          else {
            var i = document.createElement("a");
            i.href = f2, i.target = "_blank", setTimeout(function() {
              e(i);
            });
          }
        } : function(b2, d2, e2, g2) {
          if (g2 = g2 || open("", "_blank"), g2 && (g2.document.title = g2.document.body.innerText = "downloading..."), "string" == typeof b2)
            return c(b2, d2, e2);
          var h = "application/octet-stream" === b2.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
          if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader();
            k.onloadend = function() {
              var a2 = k.result;
              a2 = j ? a2 : a2.replace(/^data:[^;]*;/, "data:attachment/file;"), g2 ? g2.location.href = a2 : location = a2, g2 = null;
            }, k.readAsDataURL(b2);
          } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b2);
            g2 ? g2.location = m : location.href = m, g2 = null, setTimeout(function() {
              l.revokeObjectURL(m);
            }, 4e4);
          }
        });
        f.saveAs = g.saveAs = g, "undefined" != typeof module2 && (module2.exports = g);
      });
    }
  });

  // ../../node_modules/.pnpm/@babel+parser@7.28.3/node_modules/@babel/parser/lib/index.js
  var require_lib2 = __commonJS({
    "../../node_modules/.pnpm/@babel+parser@7.28.3/node_modules/@babel/parser/lib/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      function _objectWithoutPropertiesLoose(r, e) {
        if (null == r)
          return {};
        var t3 = {};
        for (var n in r)
          if ({}.hasOwnProperty.call(r, n)) {
            if (-1 !== e.indexOf(n))
              continue;
            t3[n] = r[n];
          }
        return t3;
      }
      var Position = class {
        constructor(line, col, index) {
          this.line = void 0;
          this.column = void 0;
          this.index = void 0;
          this.line = line;
          this.column = col;
          this.index = index;
        }
      };
      var SourceLocation = class {
        constructor(start, end) {
          this.start = void 0;
          this.end = void 0;
          this.filename = void 0;
          this.identifierName = void 0;
          this.start = start;
          this.end = end;
        }
      };
      function createPositionWithColumnOffset(position, columnOffset) {
        const {
          line,
          column,
          index
        } = position;
        return new Position(line, column + columnOffset, index + columnOffset);
      }
      var code = "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED";
      var ModuleErrors = {
        ImportMetaOutsideModule: {
          message: `import.meta may appear only with 'sourceType: "module"'`,
          code
        },
        ImportOutsideModule: {
          message: `'import' and 'export' may appear only with 'sourceType: "module"'`,
          code
        }
      };
      var NodeDescriptions = {
        ArrayPattern: "array destructuring pattern",
        AssignmentExpression: "assignment expression",
        AssignmentPattern: "assignment expression",
        ArrowFunctionExpression: "arrow function expression",
        ConditionalExpression: "conditional expression",
        CatchClause: "catch clause",
        ForOfStatement: "for-of statement",
        ForInStatement: "for-in statement",
        ForStatement: "for-loop",
        FormalParameters: "function parameter list",
        Identifier: "identifier",
        ImportSpecifier: "import specifier",
        ImportDefaultSpecifier: "import default specifier",
        ImportNamespaceSpecifier: "import namespace specifier",
        ObjectPattern: "object destructuring pattern",
        ParenthesizedExpression: "parenthesized expression",
        RestElement: "rest element",
        UpdateExpression: {
          true: "prefix operation",
          false: "postfix operation"
        },
        VariableDeclarator: "variable declaration",
        YieldExpression: "yield expression"
      };
      var toNodeDescription = (node) => node.type === "UpdateExpression" ? NodeDescriptions.UpdateExpression[`${node.prefix}`] : NodeDescriptions[node.type];
      var StandardErrors = {
        AccessorIsGenerator: ({
          kind
        }) => `A ${kind}ter cannot be a generator.`,
        ArgumentsInClass: "'arguments' is only allowed in functions and class methods.",
        AsyncFunctionInSingleStatementContext: "Async functions can only be declared at the top level or inside a block.",
        AwaitBindingIdentifier: "Can not use 'await' as identifier inside an async function.",
        AwaitBindingIdentifierInStaticBlock: "Can not use 'await' as identifier inside a static block.",
        AwaitExpressionFormalParameter: "'await' is not allowed in async function parameters.",
        AwaitUsingNotInAsyncContext: "'await using' is only allowed within async functions and at the top levels of modules.",
        AwaitNotInAsyncContext: "'await' is only allowed within async functions and at the top levels of modules.",
        BadGetterArity: "A 'get' accessor must not have any formal parameters.",
        BadSetterArity: "A 'set' accessor must have exactly one formal parameter.",
        BadSetterRestParameter: "A 'set' accessor function argument must not be a rest parameter.",
        ConstructorClassField: "Classes may not have a field named 'constructor'.",
        ConstructorClassPrivateField: "Classes may not have a private field named '#constructor'.",
        ConstructorIsAccessor: "Class constructor may not be an accessor.",
        ConstructorIsAsync: "Constructor can't be an async function.",
        ConstructorIsGenerator: "Constructor can't be a generator.",
        DeclarationMissingInitializer: ({
          kind
        }) => `Missing initializer in ${kind} declaration.`,
        DecoratorArgumentsOutsideParentheses: "Decorator arguments must be moved inside parentheses: use '@(decorator(args))' instead of '@(decorator)(args)'.",
        DecoratorBeforeExport: "Decorators must be placed *before* the 'export' keyword. Remove the 'decoratorsBeforeExport: true' option to use the 'export @decorator class {}' syntax.",
        DecoratorsBeforeAfterExport: "Decorators can be placed *either* before or after the 'export' keyword, but not in both locations at the same time.",
        DecoratorConstructor: "Decorators can't be used with a constructor. Did you mean '@dec class { ... }'?",
        DecoratorExportClass: "Decorators must be placed *after* the 'export' keyword. Remove the 'decoratorsBeforeExport: false' option to use the '@decorator export class {}' syntax.",
        DecoratorSemicolon: "Decorators must not be followed by a semicolon.",
        DecoratorStaticBlock: "Decorators can't be used with a static block.",
        DeferImportRequiresNamespace: 'Only `import defer * as x from "./module"` is valid.',
        DeletePrivateField: "Deleting a private field is not allowed.",
        DestructureNamedImport: "ES2015 named imports do not destructure. Use another statement for destructuring after the import.",
        DuplicateConstructor: "Duplicate constructor in the same class.",
        DuplicateDefaultExport: "Only one default export allowed per module.",
        DuplicateExport: ({
          exportName
        }) => `\`${exportName}\` has already been exported. Exported identifiers must be unique.`,
        DuplicateProto: "Redefinition of __proto__ property.",
        DuplicateRegExpFlags: "Duplicate regular expression flag.",
        ElementAfterRest: "Rest element must be last element.",
        EscapedCharNotAnIdentifier: "Invalid Unicode escape.",
        ExportBindingIsString: ({
          localName,
          exportName
        }) => `A string literal cannot be used as an exported binding without \`from\`.
- Did you mean \`export { '${localName}' as '${exportName}' } from 'some-module'\`?`,
        ExportDefaultFromAsIdentifier: "'from' is not allowed as an identifier after 'export default'.",
        ForInOfLoopInitializer: ({
          type
        }) => `'${type === "ForInStatement" ? "for-in" : "for-of"}' loop variable declaration may not have an initializer.`,
        ForInUsing: "For-in loop may not start with 'using' declaration.",
        ForOfAsync: "The left-hand side of a for-of loop may not be 'async'.",
        ForOfLet: "The left-hand side of a for-of loop may not start with 'let'.",
        GeneratorInSingleStatementContext: "Generators can only be declared at the top level or inside a block.",
        IllegalBreakContinue: ({
          type
        }) => `Unsyntactic ${type === "BreakStatement" ? "break" : "continue"}.`,
        IllegalLanguageModeDirective: "Illegal 'use strict' directive in function with non-simple parameter list.",
        IllegalReturn: "'return' outside of function.",
        ImportAttributesUseAssert: "The `assert` keyword in import attributes is deprecated and it has been replaced by the `with` keyword. You can enable the `deprecatedImportAssert` parser plugin to suppress this error.",
        ImportBindingIsString: ({
          importName
        }) => `A string literal cannot be used as an imported binding.
- Did you mean \`import { "${importName}" as foo }\`?`,
        ImportCallArity: `\`import()\` requires exactly one or two arguments.`,
        ImportCallNotNewExpression: "Cannot use new with import(...).",
        ImportCallSpreadArgument: "`...` is not allowed in `import()`.",
        ImportJSONBindingNotDefault: "A JSON module can only be imported with `default`.",
        ImportReflectionHasAssertion: "`import module x` cannot have assertions.",
        ImportReflectionNotBinding: 'Only `import module x from "./module"` is valid.',
        IncompatibleRegExpUVFlags: "The 'u' and 'v' regular expression flags cannot be enabled at the same time.",
        InvalidBigIntLiteral: "Invalid BigIntLiteral.",
        InvalidCodePoint: "Code point out of bounds.",
        InvalidCoverDiscardElement: "'void' must be followed by an expression when not used in a binding position.",
        InvalidCoverInitializedName: "Invalid shorthand property initializer.",
        InvalidDecimal: "Invalid decimal.",
        InvalidDigit: ({
          radix
        }) => `Expected number in radix ${radix}.`,
        InvalidEscapeSequence: "Bad character escape sequence.",
        InvalidEscapeSequenceTemplate: "Invalid escape sequence in template.",
        InvalidEscapedReservedWord: ({
          reservedWord
        }) => `Escape sequence in keyword ${reservedWord}.`,
        InvalidIdentifier: ({
          identifierName
        }) => `Invalid identifier ${identifierName}.`,
        InvalidLhs: ({
          ancestor
        }) => `Invalid left-hand side in ${toNodeDescription(ancestor)}.`,
        InvalidLhsBinding: ({
          ancestor
        }) => `Binding invalid left-hand side in ${toNodeDescription(ancestor)}.`,
        InvalidLhsOptionalChaining: ({
          ancestor
        }) => `Invalid optional chaining in the left-hand side of ${toNodeDescription(ancestor)}.`,
        InvalidNumber: "Invalid number.",
        InvalidOrMissingExponent: "Floating-point numbers require a valid exponent after the 'e'.",
        InvalidOrUnexpectedToken: ({
          unexpected
        }) => `Unexpected character '${unexpected}'.`,
        InvalidParenthesizedAssignment: "Invalid parenthesized assignment pattern.",
        InvalidPrivateFieldResolution: ({
          identifierName
        }) => `Private name #${identifierName} is not defined.`,
        InvalidPropertyBindingPattern: "Binding member expression.",
        InvalidRecordProperty: "Only properties and spread elements are allowed in record definitions.",
        InvalidRestAssignmentPattern: "Invalid rest operator's argument.",
        LabelRedeclaration: ({
          labelName
        }) => `Label '${labelName}' is already declared.`,
        LetInLexicalBinding: "'let' is disallowed as a lexically bound name.",
        LineTerminatorBeforeArrow: "No line break is allowed before '=>'.",
        MalformedRegExpFlags: "Invalid regular expression flag.",
        MissingClassName: "A class name is required.",
        MissingEqInAssignment: "Only '=' operator can be used for specifying default value.",
        MissingSemicolon: "Missing semicolon.",
        MissingPlugin: ({
          missingPlugin
        }) => `This experimental syntax requires enabling the parser plugin: ${missingPlugin.map((name) => JSON.stringify(name)).join(", ")}.`,
        MissingOneOfPlugins: ({
          missingPlugin
        }) => `This experimental syntax requires enabling one of the following parser plugin(s): ${missingPlugin.map((name) => JSON.stringify(name)).join(", ")}.`,
        MissingUnicodeEscape: "Expecting Unicode escape sequence \\uXXXX.",
        MixingCoalesceWithLogical: "Nullish coalescing operator(??) requires parens when mixing with logical operators.",
        ModuleAttributeDifferentFromType: "The only accepted module attribute is `type`.",
        ModuleAttributeInvalidValue: "Only string literals are allowed as module attribute values.",
        ModuleAttributesWithDuplicateKeys: ({
          key
        }) => `Duplicate key "${key}" is not allowed in module attributes.`,
        ModuleExportNameHasLoneSurrogate: ({
          surrogateCharCode
        }) => `An export name cannot include a lone surrogate, found '\\u${surrogateCharCode.toString(16)}'.`,
        ModuleExportUndefined: ({
          localName
        }) => `Export '${localName}' is not defined.`,
        MultipleDefaultsInSwitch: "Multiple default clauses.",
        NewlineAfterThrow: "Illegal newline after throw.",
        NoCatchOrFinally: "Missing catch or finally clause.",
        NumberIdentifier: "Identifier directly after number.",
        NumericSeparatorInEscapeSequence: "Numeric separators are not allowed inside unicode escape sequences or hex escape sequences.",
        ObsoleteAwaitStar: "'await*' has been removed from the async functions proposal. Use Promise.all() instead.",
        OptionalChainingNoNew: "Constructors in/after an Optional Chain are not allowed.",
        OptionalChainingNoTemplate: "Tagged Template Literals are not allowed in optionalChain.",
        OverrideOnConstructor: "'override' modifier cannot appear on a constructor declaration.",
        ParamDupe: "Argument name clash.",
        PatternHasAccessor: "Object pattern can't contain getter or setter.",
        PatternHasMethod: "Object pattern can't contain methods.",
        PrivateInExpectedIn: ({
          identifierName
        }) => `Private names are only allowed in property accesses (\`obj.#${identifierName}\`) or in \`in\` expressions (\`#${identifierName} in obj\`).`,
        PrivateNameRedeclaration: ({
          identifierName
        }) => `Duplicate private name #${identifierName}.`,
        RecordExpressionBarIncorrectEndSyntaxType: "Record expressions ending with '|}' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
        RecordExpressionBarIncorrectStartSyntaxType: "Record expressions starting with '{|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
        RecordExpressionHashIncorrectStartSyntaxType: "Record expressions starting with '#{' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.",
        RecordNoProto: "'__proto__' is not allowed in Record expressions.",
        RestTrailingComma: "Unexpected trailing comma after rest element.",
        SloppyFunction: "In non-strict mode code, functions can only be declared at top level or inside a block.",
        SloppyFunctionAnnexB: "In non-strict mode code, functions can only be declared at top level, inside a block, or as the body of an if statement.",
        SourcePhaseImportRequiresDefault: 'Only `import source x from "./module"` is valid.',
        StaticPrototype: "Classes may not have static property named prototype.",
        SuperNotAllowed: "`super()` is only valid inside a class constructor of a subclass. Maybe a typo in the method name ('constructor') or not extending another class?",
        SuperPrivateField: "Private fields can't be accessed on super.",
        TrailingDecorator: "Decorators must be attached to a class element.",
        TupleExpressionBarIncorrectEndSyntaxType: "Tuple expressions ending with '|]' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
        TupleExpressionBarIncorrectStartSyntaxType: "Tuple expressions starting with '[|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
        TupleExpressionHashIncorrectStartSyntaxType: "Tuple expressions starting with '#[' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.",
        UnexpectedArgumentPlaceholder: "Unexpected argument placeholder.",
        UnexpectedAwaitAfterPipelineBody: 'Unexpected "await" after pipeline body; await must have parentheses in minimal proposal.',
        UnexpectedDigitAfterHash: "Unexpected digit after hash token.",
        UnexpectedImportExport: "'import' and 'export' may only appear at the top level.",
        UnexpectedKeyword: ({
          keyword
        }) => `Unexpected keyword '${keyword}'.`,
        UnexpectedLeadingDecorator: "Leading decorators must be attached to a class declaration.",
        UnexpectedLexicalDeclaration: "Lexical declaration cannot appear in a single-statement context.",
        UnexpectedNewTarget: "`new.target` can only be used in functions or class properties.",
        UnexpectedNumericSeparator: "A numeric separator is only allowed between two digits.",
        UnexpectedPrivateField: "Unexpected private name.",
        UnexpectedReservedWord: ({
          reservedWord
        }) => `Unexpected reserved word '${reservedWord}'.`,
        UnexpectedSuper: "'super' is only allowed in object methods and classes.",
        UnexpectedToken: ({
          expected,
          unexpected
        }) => `Unexpected token${unexpected ? ` '${unexpected}'.` : ""}${expected ? `, expected "${expected}"` : ""}`,
        UnexpectedTokenUnaryExponentiation: "Illegal expression. Wrap left hand side or entire exponentiation in parentheses.",
        UnexpectedUsingDeclaration: "Using declaration cannot appear in the top level when source type is `script` or in the bare case statement.",
        UnexpectedVoidPattern: "Unexpected void binding.",
        UnsupportedBind: "Binding should be performed on object property.",
        UnsupportedDecoratorExport: "A decorated export must export a class declaration.",
        UnsupportedDefaultExport: "Only expressions, functions or classes are allowed as the `default` export.",
        UnsupportedImport: "`import` can only be used in `import()` or `import.meta`.",
        UnsupportedMetaProperty: ({
          target,
          onlyValidPropertyName
        }) => `The only valid meta property for ${target} is ${target}.${onlyValidPropertyName}.`,
        UnsupportedParameterDecorator: "Decorators cannot be used to decorate parameters.",
        UnsupportedPropertyDecorator: "Decorators cannot be used to decorate object literal properties.",
        UnsupportedSuper: "'super' can only be used with function calls (i.e. super()) or in property accesses (i.e. super.prop or super[prop]).",
        UnterminatedComment: "Unterminated comment.",
        UnterminatedRegExp: "Unterminated regular expression.",
        UnterminatedString: "Unterminated string constant.",
        UnterminatedTemplate: "Unterminated template.",
        UsingDeclarationExport: "Using declaration cannot be exported.",
        UsingDeclarationHasBindingPattern: "Using declaration cannot have destructuring patterns.",
        VarRedeclaration: ({
          identifierName
        }) => `Identifier '${identifierName}' has already been declared.`,
        VoidPatternCatchClauseParam: "A void binding can not be the catch clause parameter. Use `try { ... } catch { ... }` if you want to discard the caught error.",
        VoidPatternInitializer: "A void binding may not have an initializer.",
        YieldBindingIdentifier: "Can not use 'yield' as identifier inside a generator.",
        YieldInParameter: "Yield expression is not allowed in formal parameters.",
        YieldNotInGeneratorFunction: "'yield' is only allowed within generator functions.",
        ZeroDigitNumericSeparator: "Numeric separator can not be used after leading 0."
      };
      var StrictModeErrors = {
        StrictDelete: "Deleting local variable in strict mode.",
        StrictEvalArguments: ({
          referenceName
        }) => `Assigning to '${referenceName}' in strict mode.`,
        StrictEvalArgumentsBinding: ({
          bindingName
        }) => `Binding '${bindingName}' in strict mode.`,
        StrictFunction: "In strict mode code, functions can only be declared at top level or inside a block.",
        StrictNumericEscape: "The only valid numeric escape in strict mode is '\\0'.",
        StrictOctalLiteral: "Legacy octal literals are not allowed in strict mode.",
        StrictWith: "'with' in strict mode."
      };
      var ParseExpressionErrors = {
        ParseExpressionEmptyInput: "Unexpected parseExpression() input: The input is empty or contains only comments.",
        ParseExpressionExpectsEOF: ({
          unexpected
        }) => `Unexpected parseExpression() input: The input should contain exactly one expression, but the first expression is followed by the unexpected character \`${String.fromCodePoint(unexpected)}\`.`
      };
      var UnparenthesizedPipeBodyDescriptions = /* @__PURE__ */ new Set(["ArrowFunctionExpression", "AssignmentExpression", "ConditionalExpression", "YieldExpression"]);
      var PipelineOperatorErrors = Object.assign({
        PipeBodyIsTighter: "Unexpected yield after pipeline body; any yield expression acting as Hack-style pipe body must be parenthesized due to its loose operator precedence.",
        PipeTopicRequiresHackPipes: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.',
        PipeTopicUnbound: "Topic reference is unbound; it must be inside a pipe body.",
        PipeTopicUnconfiguredToken: ({
          token
        }) => `Invalid topic token ${token}. In order to use ${token} as a topic reference, the pipelineOperator plugin must be configured with { "proposal": "hack", "topicToken": "${token}" }.`,
        PipeTopicUnused: "Hack-style pipe body does not contain a topic reference; Hack-style pipes must use topic at least once.",
        PipeUnparenthesizedBody: ({
          type
        }) => `Hack-style pipe body cannot be an unparenthesized ${toNodeDescription({
          type
        })}; please wrap it in parentheses.`
      }, {
        PipelineBodyNoArrow: 'Unexpected arrow "=>" after pipeline body; arrow function in pipeline body must be parenthesized.',
        PipelineBodySequenceExpression: "Pipeline body may not be a comma-separated sequence expression.",
        PipelineHeadSequenceExpression: "Pipeline head should not be a comma-separated sequence expression.",
        PipelineTopicUnused: "Pipeline is in topic style but does not use topic reference.",
        PrimaryTopicNotAllowed: "Topic reference was used in a lexical context without topic binding.",
        PrimaryTopicRequiresSmartPipeline: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.'
      });
      var _excluded = ["message"];
      function defineHidden(obj, key, value) {
        Object.defineProperty(obj, key, {
          enumerable: false,
          configurable: true,
          value
        });
      }
      function toParseErrorConstructor({
        toMessage,
        code: code2,
        reasonCode,
        syntaxPlugin
      }) {
        const hasMissingPlugin = reasonCode === "MissingPlugin" || reasonCode === "MissingOneOfPlugins";
        {
          const oldReasonCodes = {
            AccessorCannotDeclareThisParameter: "AccesorCannotDeclareThisParameter",
            AccessorCannotHaveTypeParameters: "AccesorCannotHaveTypeParameters",
            ConstInitializerMustBeStringOrNumericLiteralOrLiteralEnumReference: "ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference",
            SetAccessorCannotHaveOptionalParameter: "SetAccesorCannotHaveOptionalParameter",
            SetAccessorCannotHaveRestParameter: "SetAccesorCannotHaveRestParameter",
            SetAccessorCannotHaveReturnType: "SetAccesorCannotHaveReturnType"
          };
          if (oldReasonCodes[reasonCode]) {
            reasonCode = oldReasonCodes[reasonCode];
          }
        }
        return function constructor(loc, details) {
          const error = new SyntaxError();
          error.code = code2;
          error.reasonCode = reasonCode;
          error.loc = loc;
          error.pos = loc.index;
          error.syntaxPlugin = syntaxPlugin;
          if (hasMissingPlugin) {
            error.missingPlugin = details.missingPlugin;
          }
          defineHidden(error, "clone", function clone2(overrides = {}) {
            var _overrides$loc;
            const {
              line,
              column,
              index
            } = (_overrides$loc = overrides.loc) != null ? _overrides$loc : loc;
            return constructor(new Position(line, column, index), Object.assign({}, details, overrides.details));
          });
          defineHidden(error, "details", details);
          Object.defineProperty(error, "message", {
            configurable: true,
            get() {
              const message = `${toMessage(details)} (${loc.line}:${loc.column})`;
              this.message = message;
              return message;
            },
            set(value) {
              Object.defineProperty(this, "message", {
                value,
                writable: true
              });
            }
          });
          return error;
        };
      }
      function ParseErrorEnum(argument, syntaxPlugin) {
        if (Array.isArray(argument)) {
          return (parseErrorTemplates) => ParseErrorEnum(parseErrorTemplates, argument[0]);
        }
        const ParseErrorConstructors = {};
        for (const reasonCode of Object.keys(argument)) {
          const template2 = argument[reasonCode];
          const _ref = typeof template2 === "string" ? {
            message: () => template2
          } : typeof template2 === "function" ? {
            message: template2
          } : template2, {
            message
          } = _ref, rest2 = _objectWithoutPropertiesLoose(_ref, _excluded);
          const toMessage = typeof message === "string" ? () => message : message;
          ParseErrorConstructors[reasonCode] = toParseErrorConstructor(Object.assign({
            code: "BABEL_PARSER_SYNTAX_ERROR",
            reasonCode,
            toMessage
          }, syntaxPlugin ? {
            syntaxPlugin
          } : {}, rest2));
        }
        return ParseErrorConstructors;
      }
      var Errors = Object.assign({}, ParseErrorEnum(ModuleErrors), ParseErrorEnum(StandardErrors), ParseErrorEnum(StrictModeErrors), ParseErrorEnum(ParseExpressionErrors), ParseErrorEnum`pipelineOperator`(PipelineOperatorErrors));
      function createDefaultOptions() {
        return {
          sourceType: "script",
          sourceFilename: void 0,
          startIndex: 0,
          startColumn: 0,
          startLine: 1,
          allowAwaitOutsideFunction: false,
          allowReturnOutsideFunction: false,
          allowNewTargetOutsideFunction: false,
          allowImportExportEverywhere: false,
          allowSuperOutsideMethod: false,
          allowUndeclaredExports: false,
          allowYieldOutsideFunction: false,
          plugins: [],
          strictMode: null,
          ranges: false,
          tokens: false,
          createImportExpressions: false,
          createParenthesizedExpressions: false,
          errorRecovery: false,
          attachComment: true,
          annexB: true
        };
      }
      function getOptions(opts) {
        const options = createDefaultOptions();
        if (opts == null) {
          return options;
        }
        if (opts.annexB != null && opts.annexB !== false) {
          throw new Error("The `annexB` option can only be set to `false`.");
        }
        for (const key of Object.keys(options)) {
          if (opts[key] != null)
            options[key] = opts[key];
        }
        if (options.startLine === 1) {
          if (opts.startIndex == null && options.startColumn > 0) {
            options.startIndex = options.startColumn;
          } else if (opts.startColumn == null && options.startIndex > 0) {
            options.startColumn = options.startIndex;
          }
        } else if (opts.startColumn == null || opts.startIndex == null) {
          if (opts.startIndex != null) {
            throw new Error("With a `startLine > 1` you must also specify `startIndex` and `startColumn`.");
          }
        }
        if (options.sourceType === "commonjs") {
          if (opts.allowAwaitOutsideFunction != null) {
            throw new Error("The `allowAwaitOutsideFunction` option cannot be used with `sourceType: 'commonjs'`.");
          }
          if (opts.allowReturnOutsideFunction != null) {
            throw new Error("`sourceType: 'commonjs'` implies `allowReturnOutsideFunction: true`, please remove the `allowReturnOutsideFunction` option or use `sourceType: 'script'`.");
          }
          if (opts.allowNewTargetOutsideFunction != null) {
            throw new Error("`sourceType: 'commonjs'` implies `allowNewTargetOutsideFunction: true`, please remove the `allowNewTargetOutsideFunction` option or use `sourceType: 'script'`.");
          }
        }
        return options;
      }
      var {
        defineProperty: defineProperty2
      } = Object;
      var toUnenumerable = (object, key) => {
        if (object) {
          defineProperty2(object, key, {
            enumerable: false,
            value: object[key]
          });
        }
      };
      function toESTreeLocation(node) {
        toUnenumerable(node.loc.start, "index");
        toUnenumerable(node.loc.end, "index");
        return node;
      }
      var estree = (superClass) => class ESTreeParserMixin extends superClass {
        parse() {
          const file2 = toESTreeLocation(super.parse());
          if (this.optionFlags & 256) {
            file2.tokens = file2.tokens.map(toESTreeLocation);
          }
          return file2;
        }
        parseRegExpLiteral({
          pattern,
          flags
        }) {
          let regex = null;
          try {
            regex = new RegExp(pattern, flags);
          } catch (_) {
          }
          const node = this.estreeParseLiteral(regex);
          node.regex = {
            pattern,
            flags
          };
          return node;
        }
        parseBigIntLiteral(value) {
          let bigInt;
          try {
            bigInt = BigInt(value);
          } catch (_unused) {
            bigInt = null;
          }
          const node = this.estreeParseLiteral(bigInt);
          node.bigint = String(node.value || value);
          return node;
        }
        parseDecimalLiteral(value) {
          const decimal = null;
          const node = this.estreeParseLiteral(decimal);
          node.decimal = String(node.value || value);
          return node;
        }
        estreeParseLiteral(value) {
          return this.parseLiteral(value, "Literal");
        }
        parseStringLiteral(value) {
          return this.estreeParseLiteral(value);
        }
        parseNumericLiteral(value) {
          return this.estreeParseLiteral(value);
        }
        parseNullLiteral() {
          return this.estreeParseLiteral(null);
        }
        parseBooleanLiteral(value) {
          return this.estreeParseLiteral(value);
        }
        estreeParseChainExpression(node, endLoc) {
          const chain2 = this.startNodeAtNode(node);
          chain2.expression = node;
          return this.finishNodeAt(chain2, "ChainExpression", endLoc);
        }
        directiveToStmt(directive) {
          const expression = directive.value;
          delete directive.value;
          this.castNodeTo(expression, "Literal");
          expression.raw = expression.extra.raw;
          expression.value = expression.extra.expressionValue;
          const stmt = this.castNodeTo(directive, "ExpressionStatement");
          stmt.expression = expression;
          stmt.directive = expression.extra.rawValue;
          delete expression.extra;
          return stmt;
        }
        fillOptionalPropertiesForTSESLint(node) {
        }
        cloneEstreeStringLiteral(node) {
          const {
            start,
            end,
            loc,
            range: range2,
            raw,
            value
          } = node;
          const cloned = Object.create(node.constructor.prototype);
          cloned.type = "Literal";
          cloned.start = start;
          cloned.end = end;
          cloned.loc = loc;
          cloned.range = range2;
          cloned.raw = raw;
          cloned.value = value;
          return cloned;
        }
        initFunction(node, isAsync) {
          super.initFunction(node, isAsync);
          node.expression = false;
        }
        checkDeclaration(node) {
          if (node != null && this.isObjectProperty(node)) {
            this.checkDeclaration(node.value);
          } else {
            super.checkDeclaration(node);
          }
        }
        getObjectOrClassMethodParams(method2) {
          return method2.value.params;
        }
        isValidDirective(stmt) {
          var _stmt$expression$extr;
          return stmt.type === "ExpressionStatement" && stmt.expression.type === "Literal" && typeof stmt.expression.value === "string" && !((_stmt$expression$extr = stmt.expression.extra) != null && _stmt$expression$extr.parenthesized);
        }
        parseBlockBody(node, allowDirectives, topLevel, end, afterBlockParse) {
          super.parseBlockBody(node, allowDirectives, topLevel, end, afterBlockParse);
          const directiveStatements = node.directives.map((d) => this.directiveToStmt(d));
          node.body = directiveStatements.concat(node.body);
          delete node.directives;
        }
        parsePrivateName() {
          const node = super.parsePrivateName();
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return node;
            }
          }
          return this.convertPrivateNameToPrivateIdentifier(node);
        }
        convertPrivateNameToPrivateIdentifier(node) {
          const name = super.getPrivateNameSV(node);
          node = node;
          delete node.id;
          node.name = name;
          return this.castNodeTo(node, "PrivateIdentifier");
        }
        isPrivateName(node) {
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return super.isPrivateName(node);
            }
          }
          return node.type === "PrivateIdentifier";
        }
        getPrivateNameSV(node) {
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return super.getPrivateNameSV(node);
            }
          }
          return node.name;
        }
        parseLiteral(value, type) {
          const node = super.parseLiteral(value, type);
          node.raw = node.extra.raw;
          delete node.extra;
          return node;
        }
        parseFunctionBody(node, allowExpression, isMethod = false) {
          super.parseFunctionBody(node, allowExpression, isMethod);
          node.expression = node.body.type !== "BlockStatement";
        }
        parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope = false) {
          let funcNode = this.startNode();
          funcNode.kind = node.kind;
          funcNode = super.parseMethod(funcNode, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope);
          delete funcNode.kind;
          const {
            typeParameters
          } = node;
          if (typeParameters) {
            delete node.typeParameters;
            funcNode.typeParameters = typeParameters;
            this.resetStartLocationFromNode(funcNode, typeParameters);
          }
          const valueNode = this.castNodeTo(funcNode, "FunctionExpression");
          node.value = valueNode;
          if (type === "ClassPrivateMethod") {
            node.computed = false;
          }
          if (type === "ObjectMethod") {
            if (node.kind === "method") {
              node.kind = "init";
            }
            node.shorthand = false;
            return this.finishNode(node, "Property");
          } else {
            return this.finishNode(node, "MethodDefinition");
          }
        }
        nameIsConstructor(key) {
          if (key.type === "Literal")
            return key.value === "constructor";
          return super.nameIsConstructor(key);
        }
        parseClassProperty(...args) {
          const propertyNode = super.parseClassProperty(...args);
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return propertyNode;
            }
          }
          {
            this.castNodeTo(propertyNode, "PropertyDefinition");
          }
          return propertyNode;
        }
        parseClassPrivateProperty(...args) {
          const propertyNode = super.parseClassPrivateProperty(...args);
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return propertyNode;
            }
          }
          {
            this.castNodeTo(propertyNode, "PropertyDefinition");
          }
          propertyNode.computed = false;
          return propertyNode;
        }
        parseClassAccessorProperty(node) {
          const accessorPropertyNode = super.parseClassAccessorProperty(node);
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return accessorPropertyNode;
            }
          }
          if (accessorPropertyNode.abstract && this.hasPlugin("typescript")) {
            delete accessorPropertyNode.abstract;
            this.castNodeTo(accessorPropertyNode, "TSAbstractAccessorProperty");
          } else {
            this.castNodeTo(accessorPropertyNode, "AccessorProperty");
          }
          return accessorPropertyNode;
        }
        parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors) {
          const node = super.parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors);
          if (node) {
            node.kind = "init";
            this.castNodeTo(node, "Property");
          }
          return node;
        }
        finishObjectProperty(node) {
          node.kind = "init";
          return this.finishNode(node, "Property");
        }
        isValidLVal(type, isUnparenthesizedInAssign, binding3) {
          return type === "Property" ? "value" : super.isValidLVal(type, isUnparenthesizedInAssign, binding3);
        }
        isAssignable(node, isBinding) {
          if (node != null && this.isObjectProperty(node)) {
            return this.isAssignable(node.value, isBinding);
          }
          return super.isAssignable(node, isBinding);
        }
        toAssignable(node, isLHS = false) {
          if (node != null && this.isObjectProperty(node)) {
            const {
              key,
              value
            } = node;
            if (this.isPrivateName(key)) {
              this.classScope.usePrivateName(this.getPrivateNameSV(key), key.loc.start);
            }
            this.toAssignable(value, isLHS);
          } else {
            super.toAssignable(node, isLHS);
          }
        }
        toAssignableObjectExpressionProp(prop, isLast, isLHS) {
          if (prop.type === "Property" && (prop.kind === "get" || prop.kind === "set")) {
            this.raise(Errors.PatternHasAccessor, prop.key);
          } else if (prop.type === "Property" && prop.method) {
            this.raise(Errors.PatternHasMethod, prop.key);
          } else {
            super.toAssignableObjectExpressionProp(prop, isLast, isLHS);
          }
        }
        finishCallExpression(unfinished, optional) {
          const node = super.finishCallExpression(unfinished, optional);
          if (node.callee.type === "Import") {
            var _ref;
            this.castNodeTo(node, "ImportExpression");
            node.source = node.arguments[0];
            node.options = (_ref = node.arguments[1]) != null ? _ref : null;
            {
              var _ref2;
              node.attributes = (_ref2 = node.arguments[1]) != null ? _ref2 : null;
            }
            delete node.arguments;
            delete node.callee;
          } else if (node.type === "OptionalCallExpression") {
            this.castNodeTo(node, "CallExpression");
          } else {
            node.optional = false;
          }
          return node;
        }
        toReferencedArguments(node) {
          if (node.type === "ImportExpression") {
            return;
          }
          super.toReferencedArguments(node);
        }
        parseExport(unfinished, decorators) {
          const exportStartLoc = this.state.lastTokStartLoc;
          const node = super.parseExport(unfinished, decorators);
          switch (node.type) {
            case "ExportAllDeclaration":
              node.exported = null;
              break;
            case "ExportNamedDeclaration":
              if (node.specifiers.length === 1 && node.specifiers[0].type === "ExportNamespaceSpecifier") {
                this.castNodeTo(node, "ExportAllDeclaration");
                node.exported = node.specifiers[0].exported;
                delete node.specifiers;
              }
            case "ExportDefaultDeclaration":
              {
                var _declaration$decorato;
                const {
                  declaration
                } = node;
                if ((declaration == null ? void 0 : declaration.type) === "ClassDeclaration" && ((_declaration$decorato = declaration.decorators) == null ? void 0 : _declaration$decorato.length) > 0 && declaration.start === node.start) {
                  this.resetStartLocation(node, exportStartLoc);
                }
              }
              break;
          }
          return node;
        }
        stopParseSubscript(base, state) {
          const node = super.stopParseSubscript(base, state);
          if (state.optionalChainMember) {
            return this.estreeParseChainExpression(node, base.loc.end);
          }
          return node;
        }
        parseMember(base, startLoc, state, computed, optional) {
          const node = super.parseMember(base, startLoc, state, computed, optional);
          if (node.type === "OptionalMemberExpression") {
            this.castNodeTo(node, "MemberExpression");
          } else {
            node.optional = false;
          }
          return node;
        }
        isOptionalMemberExpression(node) {
          if (node.type === "ChainExpression") {
            return node.expression.type === "MemberExpression";
          }
          return super.isOptionalMemberExpression(node);
        }
        hasPropertyAsPrivateName(node) {
          if (node.type === "ChainExpression") {
            node = node.expression;
          }
          return super.hasPropertyAsPrivateName(node);
        }
        isObjectProperty(node) {
          return node.type === "Property" && node.kind === "init" && !node.method;
        }
        isObjectMethod(node) {
          return node.type === "Property" && (node.method || node.kind === "get" || node.kind === "set");
        }
        castNodeTo(node, type) {
          const result2 = super.castNodeTo(node, type);
          this.fillOptionalPropertiesForTSESLint(result2);
          return result2;
        }
        cloneIdentifier(node) {
          const cloned = super.cloneIdentifier(node);
          this.fillOptionalPropertiesForTSESLint(cloned);
          return cloned;
        }
        cloneStringLiteral(node) {
          if (node.type === "Literal") {
            return this.cloneEstreeStringLiteral(node);
          }
          return super.cloneStringLiteral(node);
        }
        finishNodeAt(node, type, endLoc) {
          return toESTreeLocation(super.finishNodeAt(node, type, endLoc));
        }
        finishNode(node, type) {
          const result2 = super.finishNode(node, type);
          this.fillOptionalPropertiesForTSESLint(result2);
          return result2;
        }
        resetStartLocation(node, startLoc) {
          super.resetStartLocation(node, startLoc);
          toESTreeLocation(node);
        }
        resetEndLocation(node, endLoc = this.state.lastTokEndLoc) {
          super.resetEndLocation(node, endLoc);
          toESTreeLocation(node);
        }
      };
      var TokContext = class {
        constructor(token, preserveSpace) {
          this.token = void 0;
          this.preserveSpace = void 0;
          this.token = token;
          this.preserveSpace = !!preserveSpace;
        }
      };
      var types2 = {
        brace: new TokContext("{"),
        j_oTag: new TokContext("<tag"),
        j_cTag: new TokContext("</tag"),
        j_expr: new TokContext("<tag>...</tag>", true)
      };
      {
        types2.template = new TokContext("`", true);
      }
      var beforeExpr = true;
      var startsExpr = true;
      var isLoop = true;
      var isAssign = true;
      var prefix = true;
      var postfix = true;
      var ExportedTokenType = class {
        constructor(label, conf = {}) {
          this.label = void 0;
          this.keyword = void 0;
          this.beforeExpr = void 0;
          this.startsExpr = void 0;
          this.rightAssociative = void 0;
          this.isLoop = void 0;
          this.isAssign = void 0;
          this.prefix = void 0;
          this.postfix = void 0;
          this.binop = void 0;
          this.label = label;
          this.keyword = conf.keyword;
          this.beforeExpr = !!conf.beforeExpr;
          this.startsExpr = !!conf.startsExpr;
          this.rightAssociative = !!conf.rightAssociative;
          this.isLoop = !!conf.isLoop;
          this.isAssign = !!conf.isAssign;
          this.prefix = !!conf.prefix;
          this.postfix = !!conf.postfix;
          this.binop = conf.binop != null ? conf.binop : null;
          {
            this.updateContext = null;
          }
        }
      };
      var keywords$1 = /* @__PURE__ */ new Map();
      function createKeyword(name, options = {}) {
        options.keyword = name;
        const token = createToken(name, options);
        keywords$1.set(name, token);
        return token;
      }
      function createBinop(name, binop) {
        return createToken(name, {
          beforeExpr,
          binop
        });
      }
      var tokenTypeCounter = -1;
      var tokenTypes = [];
      var tokenLabels = [];
      var tokenBinops = [];
      var tokenBeforeExprs = [];
      var tokenStartsExprs = [];
      var tokenPrefixes = [];
      function createToken(name, options = {}) {
        var _options$binop, _options$beforeExpr, _options$startsExpr, _options$prefix;
        ++tokenTypeCounter;
        tokenLabels.push(name);
        tokenBinops.push((_options$binop = options.binop) != null ? _options$binop : -1);
        tokenBeforeExprs.push((_options$beforeExpr = options.beforeExpr) != null ? _options$beforeExpr : false);
        tokenStartsExprs.push((_options$startsExpr = options.startsExpr) != null ? _options$startsExpr : false);
        tokenPrefixes.push((_options$prefix = options.prefix) != null ? _options$prefix : false);
        tokenTypes.push(new ExportedTokenType(name, options));
        return tokenTypeCounter;
      }
      function createKeywordLike(name, options = {}) {
        var _options$binop2, _options$beforeExpr2, _options$startsExpr2, _options$prefix2;
        ++tokenTypeCounter;
        keywords$1.set(name, tokenTypeCounter);
        tokenLabels.push(name);
        tokenBinops.push((_options$binop2 = options.binop) != null ? _options$binop2 : -1);
        tokenBeforeExprs.push((_options$beforeExpr2 = options.beforeExpr) != null ? _options$beforeExpr2 : false);
        tokenStartsExprs.push((_options$startsExpr2 = options.startsExpr) != null ? _options$startsExpr2 : false);
        tokenPrefixes.push((_options$prefix2 = options.prefix) != null ? _options$prefix2 : false);
        tokenTypes.push(new ExportedTokenType("name", options));
        return tokenTypeCounter;
      }
      var tt = {
        bracketL: createToken("[", {
          beforeExpr,
          startsExpr
        }),
        bracketHashL: createToken("#[", {
          beforeExpr,
          startsExpr
        }),
        bracketBarL: createToken("[|", {
          beforeExpr,
          startsExpr
        }),
        bracketR: createToken("]"),
        bracketBarR: createToken("|]"),
        braceL: createToken("{", {
          beforeExpr,
          startsExpr
        }),
        braceBarL: createToken("{|", {
          beforeExpr,
          startsExpr
        }),
        braceHashL: createToken("#{", {
          beforeExpr,
          startsExpr
        }),
        braceR: createToken("}"),
        braceBarR: createToken("|}"),
        parenL: createToken("(", {
          beforeExpr,
          startsExpr
        }),
        parenR: createToken(")"),
        comma: createToken(",", {
          beforeExpr
        }),
        semi: createToken(";", {
          beforeExpr
        }),
        colon: createToken(":", {
          beforeExpr
        }),
        doubleColon: createToken("::", {
          beforeExpr
        }),
        dot: createToken("."),
        question: createToken("?", {
          beforeExpr
        }),
        questionDot: createToken("?."),
        arrow: createToken("=>", {
          beforeExpr
        }),
        template: createToken("template"),
        ellipsis: createToken("...", {
          beforeExpr
        }),
        backQuote: createToken("`", {
          startsExpr
        }),
        dollarBraceL: createToken("${", {
          beforeExpr,
          startsExpr
        }),
        templateTail: createToken("...`", {
          startsExpr
        }),
        templateNonTail: createToken("...${", {
          beforeExpr,
          startsExpr
        }),
        at: createToken("@"),
        hash: createToken("#", {
          startsExpr
        }),
        interpreterDirective: createToken("#!..."),
        eq: createToken("=", {
          beforeExpr,
          isAssign
        }),
        assign: createToken("_=", {
          beforeExpr,
          isAssign
        }),
        slashAssign: createToken("_=", {
          beforeExpr,
          isAssign
        }),
        xorAssign: createToken("_=", {
          beforeExpr,
          isAssign
        }),
        moduloAssign: createToken("_=", {
          beforeExpr,
          isAssign
        }),
        incDec: createToken("++/--", {
          prefix,
          postfix,
          startsExpr
        }),
        bang: createToken("!", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        tilde: createToken("~", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        doubleCaret: createToken("^^", {
          startsExpr
        }),
        doubleAt: createToken("@@", {
          startsExpr
        }),
        pipeline: createBinop("|>", 0),
        nullishCoalescing: createBinop("??", 1),
        logicalOR: createBinop("||", 1),
        logicalAND: createBinop("&&", 2),
        bitwiseOR: createBinop("|", 3),
        bitwiseXOR: createBinop("^", 4),
        bitwiseAND: createBinop("&", 5),
        equality: createBinop("==/!=/===/!==", 6),
        lt: createBinop("</>/<=/>=", 7),
        gt: createBinop("</>/<=/>=", 7),
        relational: createBinop("</>/<=/>=", 7),
        bitShift: createBinop("<</>>/>>>", 8),
        bitShiftL: createBinop("<</>>/>>>", 8),
        bitShiftR: createBinop("<</>>/>>>", 8),
        plusMin: createToken("+/-", {
          beforeExpr,
          binop: 9,
          prefix,
          startsExpr
        }),
        modulo: createToken("%", {
          binop: 10,
          startsExpr
        }),
        star: createToken("*", {
          binop: 10
        }),
        slash: createBinop("/", 10),
        exponent: createToken("**", {
          beforeExpr,
          binop: 11,
          rightAssociative: true
        }),
        _in: createKeyword("in", {
          beforeExpr,
          binop: 7
        }),
        _instanceof: createKeyword("instanceof", {
          beforeExpr,
          binop: 7
        }),
        _break: createKeyword("break"),
        _case: createKeyword("case", {
          beforeExpr
        }),
        _catch: createKeyword("catch"),
        _continue: createKeyword("continue"),
        _debugger: createKeyword("debugger"),
        _default: createKeyword("default", {
          beforeExpr
        }),
        _else: createKeyword("else", {
          beforeExpr
        }),
        _finally: createKeyword("finally"),
        _function: createKeyword("function", {
          startsExpr
        }),
        _if: createKeyword("if"),
        _return: createKeyword("return", {
          beforeExpr
        }),
        _switch: createKeyword("switch"),
        _throw: createKeyword("throw", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        _try: createKeyword("try"),
        _var: createKeyword("var"),
        _const: createKeyword("const"),
        _with: createKeyword("with"),
        _new: createKeyword("new", {
          beforeExpr,
          startsExpr
        }),
        _this: createKeyword("this", {
          startsExpr
        }),
        _super: createKeyword("super", {
          startsExpr
        }),
        _class: createKeyword("class", {
          startsExpr
        }),
        _extends: createKeyword("extends", {
          beforeExpr
        }),
        _export: createKeyword("export"),
        _import: createKeyword("import", {
          startsExpr
        }),
        _null: createKeyword("null", {
          startsExpr
        }),
        _true: createKeyword("true", {
          startsExpr
        }),
        _false: createKeyword("false", {
          startsExpr
        }),
        _typeof: createKeyword("typeof", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        _void: createKeyword("void", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        _delete: createKeyword("delete", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        _do: createKeyword("do", {
          isLoop,
          beforeExpr
        }),
        _for: createKeyword("for", {
          isLoop
        }),
        _while: createKeyword("while", {
          isLoop
        }),
        _as: createKeywordLike("as", {
          startsExpr
        }),
        _assert: createKeywordLike("assert", {
          startsExpr
        }),
        _async: createKeywordLike("async", {
          startsExpr
        }),
        _await: createKeywordLike("await", {
          startsExpr
        }),
        _defer: createKeywordLike("defer", {
          startsExpr
        }),
        _from: createKeywordLike("from", {
          startsExpr
        }),
        _get: createKeywordLike("get", {
          startsExpr
        }),
        _let: createKeywordLike("let", {
          startsExpr
        }),
        _meta: createKeywordLike("meta", {
          startsExpr
        }),
        _of: createKeywordLike("of", {
          startsExpr
        }),
        _sent: createKeywordLike("sent", {
          startsExpr
        }),
        _set: createKeywordLike("set", {
          startsExpr
        }),
        _source: createKeywordLike("source", {
          startsExpr
        }),
        _static: createKeywordLike("static", {
          startsExpr
        }),
        _using: createKeywordLike("using", {
          startsExpr
        }),
        _yield: createKeywordLike("yield", {
          startsExpr
        }),
        _asserts: createKeywordLike("asserts", {
          startsExpr
        }),
        _checks: createKeywordLike("checks", {
          startsExpr
        }),
        _exports: createKeywordLike("exports", {
          startsExpr
        }),
        _global: createKeywordLike("global", {
          startsExpr
        }),
        _implements: createKeywordLike("implements", {
          startsExpr
        }),
        _intrinsic: createKeywordLike("intrinsic", {
          startsExpr
        }),
        _infer: createKeywordLike("infer", {
          startsExpr
        }),
        _is: createKeywordLike("is", {
          startsExpr
        }),
        _mixins: createKeywordLike("mixins", {
          startsExpr
        }),
        _proto: createKeywordLike("proto", {
          startsExpr
        }),
        _require: createKeywordLike("require", {
          startsExpr
        }),
        _satisfies: createKeywordLike("satisfies", {
          startsExpr
        }),
        _keyof: createKeywordLike("keyof", {
          startsExpr
        }),
        _readonly: createKeywordLike("readonly", {
          startsExpr
        }),
        _unique: createKeywordLike("unique", {
          startsExpr
        }),
        _abstract: createKeywordLike("abstract", {
          startsExpr
        }),
        _declare: createKeywordLike("declare", {
          startsExpr
        }),
        _enum: createKeywordLike("enum", {
          startsExpr
        }),
        _module: createKeywordLike("module", {
          startsExpr
        }),
        _namespace: createKeywordLike("namespace", {
          startsExpr
        }),
        _interface: createKeywordLike("interface", {
          startsExpr
        }),
        _type: createKeywordLike("type", {
          startsExpr
        }),
        _opaque: createKeywordLike("opaque", {
          startsExpr
        }),
        name: createToken("name", {
          startsExpr
        }),
        placeholder: createToken("%%", {
          startsExpr
        }),
        string: createToken("string", {
          startsExpr
        }),
        num: createToken("num", {
          startsExpr
        }),
        bigint: createToken("bigint", {
          startsExpr
        }),
        decimal: createToken("decimal", {
          startsExpr
        }),
        regexp: createToken("regexp", {
          startsExpr
        }),
        privateName: createToken("#name", {
          startsExpr
        }),
        eof: createToken("eof"),
        jsxName: createToken("jsxName"),
        jsxText: createToken("jsxText", {
          beforeExpr
        }),
        jsxTagStart: createToken("jsxTagStart", {
          startsExpr
        }),
        jsxTagEnd: createToken("jsxTagEnd")
      };
      function tokenIsIdentifier(token) {
        return token >= 93 && token <= 133;
      }
      function tokenKeywordOrIdentifierIsKeyword(token) {
        return token <= 92;
      }
      function tokenIsKeywordOrIdentifier(token) {
        return token >= 58 && token <= 133;
      }
      function tokenIsLiteralPropertyName(token) {
        return token >= 58 && token <= 137;
      }
      function tokenComesBeforeExpression(token) {
        return tokenBeforeExprs[token];
      }
      function tokenCanStartExpression(token) {
        return tokenStartsExprs[token];
      }
      function tokenIsAssignment(token) {
        return token >= 29 && token <= 33;
      }
      function tokenIsFlowInterfaceOrTypeOrOpaque(token) {
        return token >= 129 && token <= 131;
      }
      function tokenIsLoop(token) {
        return token >= 90 && token <= 92;
      }
      function tokenIsKeyword(token) {
        return token >= 58 && token <= 92;
      }
      function tokenIsOperator(token) {
        return token >= 39 && token <= 59;
      }
      function tokenIsPostfix(token) {
        return token === 34;
      }
      function tokenIsPrefix(token) {
        return tokenPrefixes[token];
      }
      function tokenIsTSTypeOperator(token) {
        return token >= 121 && token <= 123;
      }
      function tokenIsTSDeclarationStart(token) {
        return token >= 124 && token <= 130;
      }
      function tokenLabelName(token) {
        return tokenLabels[token];
      }
      function tokenOperatorPrecedence(token) {
        return tokenBinops[token];
      }
      function tokenIsRightAssociative(token) {
        return token === 57;
      }
      function tokenIsTemplate(token) {
        return token >= 24 && token <= 25;
      }
      function getExportedToken(token) {
        return tokenTypes[token];
      }
      {
        tokenTypes[8].updateContext = (context) => {
          context.pop();
        };
        tokenTypes[5].updateContext = tokenTypes[7].updateContext = tokenTypes[23].updateContext = (context) => {
          context.push(types2.brace);
        };
        tokenTypes[22].updateContext = (context) => {
          if (context[context.length - 1] === types2.template) {
            context.pop();
          } else {
            context.push(types2.template);
          }
        };
        tokenTypes[143].updateContext = (context) => {
          context.push(types2.j_expr, types2.j_oTag);
        };
      }
      var nonASCIIidentifierStartChars = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
      var nonASCIIidentifierChars = "\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0897-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u200C\u200D\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\u30FB\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F\uFF65";
      var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
      var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
      nonASCIIidentifierStartChars = nonASCIIidentifierChars = null;
      var astralIdentifierStartCodes = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 4, 51, 13, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 39, 27, 10, 22, 251, 41, 7, 1, 17, 2, 60, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 31, 9, 2, 0, 3, 0, 2, 37, 2, 0, 26, 0, 2, 0, 45, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 200, 32, 32, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 26, 3994, 6, 582, 6842, 29, 1763, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 433, 44, 212, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 42, 9, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 229, 29, 3, 0, 496, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 4191];
      var astralIdentifierCodes = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 7, 9, 32, 4, 318, 1, 80, 3, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 68, 8, 2, 0, 3, 0, 2, 3, 2, 4, 2, 0, 15, 1, 83, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 7, 19, 58, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 343, 9, 54, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 10, 5350, 0, 7, 14, 11465, 27, 2343, 9, 87, 9, 39, 4, 60, 6, 26, 9, 535, 9, 470, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4178, 9, 519, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 245, 1, 2, 9, 726, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
      function isInAstralSet(code2, set2) {
        let pos = 65536;
        for (let i = 0, length = set2.length; i < length; i += 2) {
          pos += set2[i];
          if (pos > code2)
            return false;
          pos += set2[i + 1];
          if (pos >= code2)
            return true;
        }
        return false;
      }
      function isIdentifierStart(code2) {
        if (code2 < 65)
          return code2 === 36;
        if (code2 <= 90)
          return true;
        if (code2 < 97)
          return code2 === 95;
        if (code2 <= 122)
          return true;
        if (code2 <= 65535) {
          return code2 >= 170 && nonASCIIidentifierStart.test(String.fromCharCode(code2));
        }
        return isInAstralSet(code2, astralIdentifierStartCodes);
      }
      function isIdentifierChar(code2) {
        if (code2 < 48)
          return code2 === 36;
        if (code2 < 58)
          return true;
        if (code2 < 65)
          return false;
        if (code2 <= 90)
          return true;
        if (code2 < 97)
          return code2 === 95;
        if (code2 <= 122)
          return true;
        if (code2 <= 65535) {
          return code2 >= 170 && nonASCIIidentifier.test(String.fromCharCode(code2));
        }
        return isInAstralSet(code2, astralIdentifierStartCodes) || isInAstralSet(code2, astralIdentifierCodes);
      }
      var reservedWords = {
        keyword: ["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"],
        strict: ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"],
        strictBind: ["eval", "arguments"]
      };
      var keywords = new Set(reservedWords.keyword);
      var reservedWordsStrictSet = new Set(reservedWords.strict);
      var reservedWordsStrictBindSet = new Set(reservedWords.strictBind);
      function isReservedWord(word, inModule) {
        return inModule && word === "await" || word === "enum";
      }
      function isStrictReservedWord(word, inModule) {
        return isReservedWord(word, inModule) || reservedWordsStrictSet.has(word);
      }
      function isStrictBindOnlyReservedWord(word) {
        return reservedWordsStrictBindSet.has(word);
      }
      function isStrictBindReservedWord(word, inModule) {
        return isStrictReservedWord(word, inModule) || isStrictBindOnlyReservedWord(word);
      }
      function isKeyword(word) {
        return keywords.has(word);
      }
      function isIteratorStart(current, next, next2) {
        return current === 64 && next === 64 && isIdentifierStart(next2);
      }
      var reservedWordLikeSet = /* @__PURE__ */ new Set(["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete", "implements", "interface", "let", "package", "private", "protected", "public", "static", "yield", "eval", "arguments", "enum", "await"]);
      function canBeReservedWord(word) {
        return reservedWordLikeSet.has(word);
      }
      var Scope2 = class {
        constructor(flags) {
          this.flags = 0;
          this.names = /* @__PURE__ */ new Map();
          this.firstLexicalName = "";
          this.flags = flags;
        }
      };
      var ScopeHandler = class {
        constructor(parser3, inModule) {
          this.parser = void 0;
          this.scopeStack = [];
          this.inModule = void 0;
          this.undefinedExports = /* @__PURE__ */ new Map();
          this.parser = parser3;
          this.inModule = inModule;
        }
        get inTopLevel() {
          return (this.currentScope().flags & 1) > 0;
        }
        get inFunction() {
          return (this.currentVarScopeFlags() & 2) > 0;
        }
        get allowSuper() {
          return (this.currentThisScopeFlags() & 16) > 0;
        }
        get allowDirectSuper() {
          return (this.currentThisScopeFlags() & 32) > 0;
        }
        get allowNewTarget() {
          return (this.currentThisScopeFlags() & 512) > 0;
        }
        get inClass() {
          return (this.currentThisScopeFlags() & 64) > 0;
        }
        get inClassAndNotInNonArrowFunction() {
          const flags = this.currentThisScopeFlags();
          return (flags & 64) > 0 && (flags & 2) === 0;
        }
        get inStaticBlock() {
          for (let i = this.scopeStack.length - 1; ; i--) {
            const {
              flags
            } = this.scopeStack[i];
            if (flags & 128) {
              return true;
            }
            if (flags & (1667 | 64)) {
              return false;
            }
          }
        }
        get inNonArrowFunction() {
          return (this.currentThisScopeFlags() & 2) > 0;
        }
        get inBareCaseStatement() {
          return (this.currentScope().flags & 256) > 0;
        }
        get treatFunctionsAsVar() {
          return this.treatFunctionsAsVarInScope(this.currentScope());
        }
        createScope(flags) {
          return new Scope2(flags);
        }
        enter(flags) {
          this.scopeStack.push(this.createScope(flags));
        }
        exit() {
          const scope = this.scopeStack.pop();
          return scope.flags;
        }
        treatFunctionsAsVarInScope(scope) {
          return !!(scope.flags & (2 | 128) || !this.parser.inModule && scope.flags & 1);
        }
        declareName(name, bindingType, loc) {
          let scope = this.currentScope();
          if (bindingType & 8 || bindingType & 16) {
            this.checkRedeclarationInScope(scope, name, bindingType, loc);
            let type = scope.names.get(name) || 0;
            if (bindingType & 16) {
              type = type | 4;
            } else {
              if (!scope.firstLexicalName) {
                scope.firstLexicalName = name;
              }
              type = type | 2;
            }
            scope.names.set(name, type);
            if (bindingType & 8) {
              this.maybeExportDefined(scope, name);
            }
          } else if (bindingType & 4) {
            for (let i = this.scopeStack.length - 1; i >= 0; --i) {
              scope = this.scopeStack[i];
              this.checkRedeclarationInScope(scope, name, bindingType, loc);
              scope.names.set(name, (scope.names.get(name) || 0) | 1);
              this.maybeExportDefined(scope, name);
              if (scope.flags & 1667)
                break;
            }
          }
          if (this.parser.inModule && scope.flags & 1) {
            this.undefinedExports.delete(name);
          }
        }
        maybeExportDefined(scope, name) {
          if (this.parser.inModule && scope.flags & 1) {
            this.undefinedExports.delete(name);
          }
        }
        checkRedeclarationInScope(scope, name, bindingType, loc) {
          if (this.isRedeclaredInScope(scope, name, bindingType)) {
            this.parser.raise(Errors.VarRedeclaration, loc, {
              identifierName: name
            });
          }
        }
        isRedeclaredInScope(scope, name, bindingType) {
          if (!(bindingType & 1))
            return false;
          if (bindingType & 8) {
            return scope.names.has(name);
          }
          const type = scope.names.get(name);
          if (bindingType & 16) {
            return (type & 2) > 0 || !this.treatFunctionsAsVarInScope(scope) && (type & 1) > 0;
          }
          return (type & 2) > 0 && !(scope.flags & 8 && scope.firstLexicalName === name) || !this.treatFunctionsAsVarInScope(scope) && (type & 4) > 0;
        }
        checkLocalExport(id) {
          const {
            name
          } = id;
          const topLevelScope = this.scopeStack[0];
          if (!topLevelScope.names.has(name)) {
            this.undefinedExports.set(name, id.loc.start);
          }
        }
        currentScope() {
          return this.scopeStack[this.scopeStack.length - 1];
        }
        currentVarScopeFlags() {
          for (let i = this.scopeStack.length - 1; ; i--) {
            const {
              flags
            } = this.scopeStack[i];
            if (flags & 1667) {
              return flags;
            }
          }
        }
        currentThisScopeFlags() {
          for (let i = this.scopeStack.length - 1; ; i--) {
            const {
              flags
            } = this.scopeStack[i];
            if (flags & (1667 | 64) && !(flags & 4)) {
              return flags;
            }
          }
        }
      };
      var FlowScope = class extends Scope2 {
        constructor(...args) {
          super(...args);
          this.declareFunctions = /* @__PURE__ */ new Set();
        }
      };
      var FlowScopeHandler = class extends ScopeHandler {
        createScope(flags) {
          return new FlowScope(flags);
        }
        declareName(name, bindingType, loc) {
          const scope = this.currentScope();
          if (bindingType & 2048) {
            this.checkRedeclarationInScope(scope, name, bindingType, loc);
            this.maybeExportDefined(scope, name);
            scope.declareFunctions.add(name);
            return;
          }
          super.declareName(name, bindingType, loc);
        }
        isRedeclaredInScope(scope, name, bindingType) {
          if (super.isRedeclaredInScope(scope, name, bindingType))
            return true;
          if (bindingType & 2048 && !scope.declareFunctions.has(name)) {
            const type = scope.names.get(name);
            return (type & 4) > 0 || (type & 2) > 0;
          }
          return false;
        }
        checkLocalExport(id) {
          if (!this.scopeStack[0].declareFunctions.has(id.name)) {
            super.checkLocalExport(id);
          }
        }
      };
      var reservedTypes = /* @__PURE__ */ new Set(["_", "any", "bool", "boolean", "empty", "extends", "false", "interface", "mixed", "null", "number", "static", "string", "true", "typeof", "void"]);
      var FlowErrors = ParseErrorEnum`flow`({
        AmbiguousConditionalArrow: "Ambiguous expression: wrap the arrow functions in parentheses to disambiguate.",
        AmbiguousDeclareModuleKind: "Found both `declare module.exports` and `declare export` in the same module. Modules can only have 1 since they are either an ES module or they are a CommonJS module.",
        AssignReservedType: ({
          reservedType
        }) => `Cannot overwrite reserved type ${reservedType}.`,
        DeclareClassElement: "The `declare` modifier can only appear on class fields.",
        DeclareClassFieldInitializer: "Initializers are not allowed in fields with the `declare` modifier.",
        DuplicateDeclareModuleExports: "Duplicate `declare module.exports` statement.",
        EnumBooleanMemberNotInitialized: ({
          memberName,
          enumName
        }) => `Boolean enum members need to be initialized. Use either \`${memberName} = true,\` or \`${memberName} = false,\` in enum \`${enumName}\`.`,
        EnumDuplicateMemberName: ({
          memberName,
          enumName
        }) => `Enum member names need to be unique, but the name \`${memberName}\` has already been used before in enum \`${enumName}\`.`,
        EnumInconsistentMemberValues: ({
          enumName
        }) => `Enum \`${enumName}\` has inconsistent member initializers. Either use no initializers, or consistently use literals (either booleans, numbers, or strings) for all member initializers.`,
        EnumInvalidExplicitType: ({
          invalidEnumType,
          enumName
        }) => `Enum type \`${invalidEnumType}\` is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${enumName}\`.`,
        EnumInvalidExplicitTypeUnknownSupplied: ({
          enumName
        }) => `Supplied enum type is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${enumName}\`.`,
        EnumInvalidMemberInitializerPrimaryType: ({
          enumName,
          memberName,
          explicitType
        }) => `Enum \`${enumName}\` has type \`${explicitType}\`, so the initializer of \`${memberName}\` needs to be a ${explicitType} literal.`,
        EnumInvalidMemberInitializerSymbolType: ({
          enumName,
          memberName
        }) => `Symbol enum members cannot be initialized. Use \`${memberName},\` in enum \`${enumName}\`.`,
        EnumInvalidMemberInitializerUnknownType: ({
          enumName,
          memberName
        }) => `The enum member initializer for \`${memberName}\` needs to be a literal (either a boolean, number, or string) in enum \`${enumName}\`.`,
        EnumInvalidMemberName: ({
          enumName,
          memberName,
          suggestion
        }) => `Enum member names cannot start with lowercase 'a' through 'z'. Instead of using \`${memberName}\`, consider using \`${suggestion}\`, in enum \`${enumName}\`.`,
        EnumNumberMemberNotInitialized: ({
          enumName,
          memberName
        }) => `Number enum members need to be initialized, e.g. \`${memberName} = 1\` in enum \`${enumName}\`.`,
        EnumStringMemberInconsistentlyInitialized: ({
          enumName
        }) => `String enum members need to consistently either all use initializers, or use no initializers, in enum \`${enumName}\`.`,
        GetterMayNotHaveThisParam: "A getter cannot have a `this` parameter.",
        ImportReflectionHasImportType: "An `import module` declaration can not use `type` or `typeof` keyword.",
        ImportTypeShorthandOnlyInPureImport: "The `type` and `typeof` keywords on named imports can only be used on regular `import` statements. It cannot be used with `import type` or `import typeof` statements.",
        InexactInsideExact: "Explicit inexact syntax cannot appear inside an explicit exact object type.",
        InexactInsideNonObject: "Explicit inexact syntax cannot appear in class or interface definitions.",
        InexactVariance: "Explicit inexact syntax cannot have variance.",
        InvalidNonTypeImportInDeclareModule: "Imports within a `declare module` body must always be `import type` or `import typeof`.",
        MissingTypeParamDefault: "Type parameter declaration needs a default, since a preceding type parameter declaration has a default.",
        NestedDeclareModule: "`declare module` cannot be used inside another `declare module`.",
        NestedFlowComment: "Cannot have a flow comment inside another flow comment.",
        PatternIsOptional: Object.assign({
          message: "A binding pattern parameter cannot be optional in an implementation signature."
        }, {
          reasonCode: "OptionalBindingPattern"
        }),
        SetterMayNotHaveThisParam: "A setter cannot have a `this` parameter.",
        SpreadVariance: "Spread properties cannot have variance.",
        ThisParamAnnotationRequired: "A type annotation is required for the `this` parameter.",
        ThisParamBannedInConstructor: "Constructors cannot have a `this` parameter; constructors don't bind `this` like other functions.",
        ThisParamMayNotBeOptional: "The `this` parameter cannot be optional.",
        ThisParamMustBeFirst: "The `this` parameter must be the first function parameter.",
        ThisParamNoDefault: "The `this` parameter may not have a default value.",
        TypeBeforeInitializer: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.",
        TypeCastInPattern: "The type cast expression is expected to be wrapped with parenthesis.",
        UnexpectedExplicitInexactInObject: "Explicit inexact syntax must appear at the end of an inexact object.",
        UnexpectedReservedType: ({
          reservedType
        }) => `Unexpected reserved type ${reservedType}.`,
        UnexpectedReservedUnderscore: "`_` is only allowed as a type argument to call or new.",
        UnexpectedSpaceBetweenModuloChecks: "Spaces between `%` and `checks` are not allowed here.",
        UnexpectedSpreadType: "Spread operator cannot appear in class or interface definitions.",
        UnexpectedSubtractionOperand: 'Unexpected token, expected "number" or "bigint".',
        UnexpectedTokenAfterTypeParameter: "Expected an arrow function after this type parameter declaration.",
        UnexpectedTypeParameterBeforeAsyncArrowFunction: "Type parameters must come after the async keyword, e.g. instead of `<T> async () => {}`, use `async <T>() => {}`.",
        UnsupportedDeclareExportKind: ({
          unsupportedExportKind,
          suggestion
        }) => `\`declare export ${unsupportedExportKind}\` is not supported. Use \`${suggestion}\` instead.`,
        UnsupportedStatementInDeclareModule: "Only declares and type imports are allowed inside declare module.",
        UnterminatedFlowComment: "Unterminated flow-comment."
      });
      function isEsModuleType(bodyElement) {
        return bodyElement.type === "DeclareExportAllDeclaration" || bodyElement.type === "DeclareExportDeclaration" && (!bodyElement.declaration || bodyElement.declaration.type !== "TypeAlias" && bodyElement.declaration.type !== "InterfaceDeclaration");
      }
      function hasTypeImportKind(node) {
        return node.importKind === "type" || node.importKind === "typeof";
      }
      var exportSuggestions = {
        const: "declare export var",
        let: "declare export var",
        type: "export type",
        interface: "export interface"
      };
      function partition2(list, test) {
        const list1 = [];
        const list2 = [];
        for (let i = 0; i < list.length; i++) {
          (test(list[i], i, list) ? list1 : list2).push(list[i]);
        }
        return [list1, list2];
      }
      var FLOW_PRAGMA_REGEX = /\*?\s*@((?:no)?flow)\b/;
      var flow2 = (superClass) => class FlowParserMixin extends superClass {
        constructor(...args) {
          super(...args);
          this.flowPragma = void 0;
        }
        getScopeHandler() {
          return FlowScopeHandler;
        }
        shouldParseTypes() {
          return this.getPluginOption("flow", "all") || this.flowPragma === "flow";
        }
        finishToken(type, val) {
          if (type !== 134 && type !== 13 && type !== 28) {
            if (this.flowPragma === void 0) {
              this.flowPragma = null;
            }
          }
          super.finishToken(type, val);
        }
        addComment(comment) {
          if (this.flowPragma === void 0) {
            const matches2 = FLOW_PRAGMA_REGEX.exec(comment.value);
            if (!matches2)
              ;
            else if (matches2[1] === "flow") {
              this.flowPragma = "flow";
            } else if (matches2[1] === "noflow") {
              this.flowPragma = "noflow";
            } else {
              throw new Error("Unexpected flow pragma");
            }
          }
          super.addComment(comment);
        }
        flowParseTypeInitialiser(tok) {
          const oldInType = this.state.inType;
          this.state.inType = true;
          this.expect(tok || 14);
          const type = this.flowParseType();
          this.state.inType = oldInType;
          return type;
        }
        flowParsePredicate() {
          const node = this.startNode();
          const moduloLoc = this.state.startLoc;
          this.next();
          this.expectContextual(110);
          if (this.state.lastTokStartLoc.index > moduloLoc.index + 1) {
            this.raise(FlowErrors.UnexpectedSpaceBetweenModuloChecks, moduloLoc);
          }
          if (this.eat(10)) {
            node.value = super.parseExpression();
            this.expect(11);
            return this.finishNode(node, "DeclaredPredicate");
          } else {
            return this.finishNode(node, "InferredPredicate");
          }
        }
        flowParseTypeAndPredicateInitialiser() {
          const oldInType = this.state.inType;
          this.state.inType = true;
          this.expect(14);
          let type = null;
          let predicate = null;
          if (this.match(54)) {
            this.state.inType = oldInType;
            predicate = this.flowParsePredicate();
          } else {
            type = this.flowParseType();
            this.state.inType = oldInType;
            if (this.match(54)) {
              predicate = this.flowParsePredicate();
            }
          }
          return [type, predicate];
        }
        flowParseDeclareClass(node) {
          this.next();
          this.flowParseInterfaceish(node, true);
          return this.finishNode(node, "DeclareClass");
        }
        flowParseDeclareFunction(node) {
          this.next();
          const id = node.id = this.parseIdentifier();
          const typeNode = this.startNode();
          const typeContainer = this.startNode();
          if (this.match(47)) {
            typeNode.typeParameters = this.flowParseTypeParameterDeclaration();
          } else {
            typeNode.typeParameters = null;
          }
          this.expect(10);
          const tmp = this.flowParseFunctionTypeParams();
          typeNode.params = tmp.params;
          typeNode.rest = tmp.rest;
          typeNode.this = tmp._this;
          this.expect(11);
          [typeNode.returnType, node.predicate] = this.flowParseTypeAndPredicateInitialiser();
          typeContainer.typeAnnotation = this.finishNode(typeNode, "FunctionTypeAnnotation");
          id.typeAnnotation = this.finishNode(typeContainer, "TypeAnnotation");
          this.resetEndLocation(id);
          this.semicolon();
          this.scope.declareName(node.id.name, 2048, node.id.loc.start);
          return this.finishNode(node, "DeclareFunction");
        }
        flowParseDeclare(node, insideModule) {
          if (this.match(80)) {
            return this.flowParseDeclareClass(node);
          } else if (this.match(68)) {
            return this.flowParseDeclareFunction(node);
          } else if (this.match(74)) {
            return this.flowParseDeclareVariable(node);
          } else if (this.eatContextual(127)) {
            if (this.match(16)) {
              return this.flowParseDeclareModuleExports(node);
            } else {
              if (insideModule) {
                this.raise(FlowErrors.NestedDeclareModule, this.state.lastTokStartLoc);
              }
              return this.flowParseDeclareModule(node);
            }
          } else if (this.isContextual(130)) {
            return this.flowParseDeclareTypeAlias(node);
          } else if (this.isContextual(131)) {
            return this.flowParseDeclareOpaqueType(node);
          } else if (this.isContextual(129)) {
            return this.flowParseDeclareInterface(node);
          } else if (this.match(82)) {
            return this.flowParseDeclareExportDeclaration(node, insideModule);
          } else {
            this.unexpected();
          }
        }
        flowParseDeclareVariable(node) {
          this.next();
          node.id = this.flowParseTypeAnnotatableIdentifier(true);
          this.scope.declareName(node.id.name, 5, node.id.loc.start);
          this.semicolon();
          return this.finishNode(node, "DeclareVariable");
        }
        flowParseDeclareModule(node) {
          this.scope.enter(0);
          if (this.match(134)) {
            node.id = super.parseExprAtom();
          } else {
            node.id = this.parseIdentifier();
          }
          const bodyNode = node.body = this.startNode();
          const body = bodyNode.body = [];
          this.expect(5);
          while (!this.match(8)) {
            let bodyNode2 = this.startNode();
            if (this.match(83)) {
              this.next();
              if (!this.isContextual(130) && !this.match(87)) {
                this.raise(FlowErrors.InvalidNonTypeImportInDeclareModule, this.state.lastTokStartLoc);
              }
              super.parseImport(bodyNode2);
            } else {
              this.expectContextual(125, FlowErrors.UnsupportedStatementInDeclareModule);
              bodyNode2 = this.flowParseDeclare(bodyNode2, true);
            }
            body.push(bodyNode2);
          }
          this.scope.exit();
          this.expect(8);
          this.finishNode(bodyNode, "BlockStatement");
          let kind = null;
          let hasModuleExport = false;
          body.forEach((bodyElement) => {
            if (isEsModuleType(bodyElement)) {
              if (kind === "CommonJS") {
                this.raise(FlowErrors.AmbiguousDeclareModuleKind, bodyElement);
              }
              kind = "ES";
            } else if (bodyElement.type === "DeclareModuleExports") {
              if (hasModuleExport) {
                this.raise(FlowErrors.DuplicateDeclareModuleExports, bodyElement);
              }
              if (kind === "ES") {
                this.raise(FlowErrors.AmbiguousDeclareModuleKind, bodyElement);
              }
              kind = "CommonJS";
              hasModuleExport = true;
            }
          });
          node.kind = kind || "CommonJS";
          return this.finishNode(node, "DeclareModule");
        }
        flowParseDeclareExportDeclaration(node, insideModule) {
          this.expect(82);
          if (this.eat(65)) {
            if (this.match(68) || this.match(80)) {
              node.declaration = this.flowParseDeclare(this.startNode());
            } else {
              node.declaration = this.flowParseType();
              this.semicolon();
            }
            node.default = true;
            return this.finishNode(node, "DeclareExportDeclaration");
          } else {
            if (this.match(75) || this.isLet() || (this.isContextual(130) || this.isContextual(129)) && !insideModule) {
              const label = this.state.value;
              throw this.raise(FlowErrors.UnsupportedDeclareExportKind, this.state.startLoc, {
                unsupportedExportKind: label,
                suggestion: exportSuggestions[label]
              });
            }
            if (this.match(74) || this.match(68) || this.match(80) || this.isContextual(131)) {
              node.declaration = this.flowParseDeclare(this.startNode());
              node.default = false;
              return this.finishNode(node, "DeclareExportDeclaration");
            } else if (this.match(55) || this.match(5) || this.isContextual(129) || this.isContextual(130) || this.isContextual(131)) {
              node = this.parseExport(node, null);
              if (node.type === "ExportNamedDeclaration") {
                node.default = false;
                delete node.exportKind;
                return this.castNodeTo(node, "DeclareExportDeclaration");
              } else {
                return this.castNodeTo(node, "DeclareExportAllDeclaration");
              }
            }
          }
          this.unexpected();
        }
        flowParseDeclareModuleExports(node) {
          this.next();
          this.expectContextual(111);
          node.typeAnnotation = this.flowParseTypeAnnotation();
          this.semicolon();
          return this.finishNode(node, "DeclareModuleExports");
        }
        flowParseDeclareTypeAlias(node) {
          this.next();
          const finished = this.flowParseTypeAlias(node);
          this.castNodeTo(finished, "DeclareTypeAlias");
          return finished;
        }
        flowParseDeclareOpaqueType(node) {
          this.next();
          const finished = this.flowParseOpaqueType(node, true);
          this.castNodeTo(finished, "DeclareOpaqueType");
          return finished;
        }
        flowParseDeclareInterface(node) {
          this.next();
          this.flowParseInterfaceish(node, false);
          return this.finishNode(node, "DeclareInterface");
        }
        flowParseInterfaceish(node, isClass) {
          node.id = this.flowParseRestrictedIdentifier(!isClass, true);
          this.scope.declareName(node.id.name, isClass ? 17 : 8201, node.id.loc.start);
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          } else {
            node.typeParameters = null;
          }
          node.extends = [];
          if (this.eat(81)) {
            do {
              node.extends.push(this.flowParseInterfaceExtends());
            } while (!isClass && this.eat(12));
          }
          if (isClass) {
            node.implements = [];
            node.mixins = [];
            if (this.eatContextual(117)) {
              do {
                node.mixins.push(this.flowParseInterfaceExtends());
              } while (this.eat(12));
            }
            if (this.eatContextual(113)) {
              do {
                node.implements.push(this.flowParseInterfaceExtends());
              } while (this.eat(12));
            }
          }
          node.body = this.flowParseObjectType({
            allowStatic: isClass,
            allowExact: false,
            allowSpread: false,
            allowProto: isClass,
            allowInexact: false
          });
        }
        flowParseInterfaceExtends() {
          const node = this.startNode();
          node.id = this.flowParseQualifiedTypeIdentifier();
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterInstantiation();
          } else {
            node.typeParameters = null;
          }
          return this.finishNode(node, "InterfaceExtends");
        }
        flowParseInterface(node) {
          this.flowParseInterfaceish(node, false);
          return this.finishNode(node, "InterfaceDeclaration");
        }
        checkNotUnderscore(word) {
          if (word === "_") {
            this.raise(FlowErrors.UnexpectedReservedUnderscore, this.state.startLoc);
          }
        }
        checkReservedType(word, startLoc, declaration) {
          if (!reservedTypes.has(word))
            return;
          this.raise(declaration ? FlowErrors.AssignReservedType : FlowErrors.UnexpectedReservedType, startLoc, {
            reservedType: word
          });
        }
        flowParseRestrictedIdentifier(liberal, declaration) {
          this.checkReservedType(this.state.value, this.state.startLoc, declaration);
          return this.parseIdentifier(liberal);
        }
        flowParseTypeAlias(node) {
          node.id = this.flowParseRestrictedIdentifier(false, true);
          this.scope.declareName(node.id.name, 8201, node.id.loc.start);
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          } else {
            node.typeParameters = null;
          }
          node.right = this.flowParseTypeInitialiser(29);
          this.semicolon();
          return this.finishNode(node, "TypeAlias");
        }
        flowParseOpaqueType(node, declare) {
          this.expectContextual(130);
          node.id = this.flowParseRestrictedIdentifier(true, true);
          this.scope.declareName(node.id.name, 8201, node.id.loc.start);
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          } else {
            node.typeParameters = null;
          }
          node.supertype = null;
          if (this.match(14)) {
            node.supertype = this.flowParseTypeInitialiser(14);
          }
          node.impltype = null;
          if (!declare) {
            node.impltype = this.flowParseTypeInitialiser(29);
          }
          this.semicolon();
          return this.finishNode(node, "OpaqueType");
        }
        flowParseTypeParameter(requireDefault = false) {
          const nodeStartLoc = this.state.startLoc;
          const node = this.startNode();
          const variance = this.flowParseVariance();
          const ident = this.flowParseTypeAnnotatableIdentifier();
          node.name = ident.name;
          node.variance = variance;
          node.bound = ident.typeAnnotation;
          if (this.match(29)) {
            this.eat(29);
            node.default = this.flowParseType();
          } else {
            if (requireDefault) {
              this.raise(FlowErrors.MissingTypeParamDefault, nodeStartLoc);
            }
          }
          return this.finishNode(node, "TypeParameter");
        }
        flowParseTypeParameterDeclaration() {
          const oldInType = this.state.inType;
          const node = this.startNode();
          node.params = [];
          this.state.inType = true;
          if (this.match(47) || this.match(143)) {
            this.next();
          } else {
            this.unexpected();
          }
          let defaultRequired = false;
          do {
            const typeParameter = this.flowParseTypeParameter(defaultRequired);
            node.params.push(typeParameter);
            if (typeParameter.default) {
              defaultRequired = true;
            }
            if (!this.match(48)) {
              this.expect(12);
            }
          } while (!this.match(48));
          this.expect(48);
          this.state.inType = oldInType;
          return this.finishNode(node, "TypeParameterDeclaration");
        }
        flowInTopLevelContext(cb) {
          if (this.curContext() !== types2.brace) {
            const oldContext = this.state.context;
            this.state.context = [oldContext[0]];
            try {
              return cb();
            } finally {
              this.state.context = oldContext;
            }
          } else {
            return cb();
          }
        }
        flowParseTypeParameterInstantiationInExpression() {
          if (this.reScan_lt() !== 47)
            return;
          return this.flowParseTypeParameterInstantiation();
        }
        flowParseTypeParameterInstantiation() {
          const node = this.startNode();
          const oldInType = this.state.inType;
          this.state.inType = true;
          node.params = [];
          this.flowInTopLevelContext(() => {
            this.expect(47);
            const oldNoAnonFunctionType = this.state.noAnonFunctionType;
            this.state.noAnonFunctionType = false;
            while (!this.match(48)) {
              node.params.push(this.flowParseType());
              if (!this.match(48)) {
                this.expect(12);
              }
            }
            this.state.noAnonFunctionType = oldNoAnonFunctionType;
          });
          this.state.inType = oldInType;
          if (!this.state.inType && this.curContext() === types2.brace) {
            this.reScan_lt_gt();
          }
          this.expect(48);
          return this.finishNode(node, "TypeParameterInstantiation");
        }
        flowParseTypeParameterInstantiationCallOrNew() {
          if (this.reScan_lt() !== 47)
            return;
          const node = this.startNode();
          const oldInType = this.state.inType;
          node.params = [];
          this.state.inType = true;
          this.expect(47);
          while (!this.match(48)) {
            node.params.push(this.flowParseTypeOrImplicitInstantiation());
            if (!this.match(48)) {
              this.expect(12);
            }
          }
          this.expect(48);
          this.state.inType = oldInType;
          return this.finishNode(node, "TypeParameterInstantiation");
        }
        flowParseInterfaceType() {
          const node = this.startNode();
          this.expectContextual(129);
          node.extends = [];
          if (this.eat(81)) {
            do {
              node.extends.push(this.flowParseInterfaceExtends());
            } while (this.eat(12));
          }
          node.body = this.flowParseObjectType({
            allowStatic: false,
            allowExact: false,
            allowSpread: false,
            allowProto: false,
            allowInexact: false
          });
          return this.finishNode(node, "InterfaceTypeAnnotation");
        }
        flowParseObjectPropertyKey() {
          return this.match(135) || this.match(134) ? super.parseExprAtom() : this.parseIdentifier(true);
        }
        flowParseObjectTypeIndexer(node, isStatic, variance) {
          node.static = isStatic;
          if (this.lookahead().type === 14) {
            node.id = this.flowParseObjectPropertyKey();
            node.key = this.flowParseTypeInitialiser();
          } else {
            node.id = null;
            node.key = this.flowParseType();
          }
          this.expect(3);
          node.value = this.flowParseTypeInitialiser();
          node.variance = variance;
          return this.finishNode(node, "ObjectTypeIndexer");
        }
        flowParseObjectTypeInternalSlot(node, isStatic) {
          node.static = isStatic;
          node.id = this.flowParseObjectPropertyKey();
          this.expect(3);
          this.expect(3);
          if (this.match(47) || this.match(10)) {
            node.method = true;
            node.optional = false;
            node.value = this.flowParseObjectTypeMethodish(this.startNodeAt(node.loc.start));
          } else {
            node.method = false;
            if (this.eat(17)) {
              node.optional = true;
            }
            node.value = this.flowParseTypeInitialiser();
          }
          return this.finishNode(node, "ObjectTypeInternalSlot");
        }
        flowParseObjectTypeMethodish(node) {
          node.params = [];
          node.rest = null;
          node.typeParameters = null;
          node.this = null;
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          }
          this.expect(10);
          if (this.match(78)) {
            node.this = this.flowParseFunctionTypeParam(true);
            node.this.name = null;
            if (!this.match(11)) {
              this.expect(12);
            }
          }
          while (!this.match(11) && !this.match(21)) {
            node.params.push(this.flowParseFunctionTypeParam(false));
            if (!this.match(11)) {
              this.expect(12);
            }
          }
          if (this.eat(21)) {
            node.rest = this.flowParseFunctionTypeParam(false);
          }
          this.expect(11);
          node.returnType = this.flowParseTypeInitialiser();
          return this.finishNode(node, "FunctionTypeAnnotation");
        }
        flowParseObjectTypeCallProperty(node, isStatic) {
          const valueNode = this.startNode();
          node.static = isStatic;
          node.value = this.flowParseObjectTypeMethodish(valueNode);
          return this.finishNode(node, "ObjectTypeCallProperty");
        }
        flowParseObjectType({
          allowStatic,
          allowExact,
          allowSpread,
          allowProto,
          allowInexact
        }) {
          const oldInType = this.state.inType;
          this.state.inType = true;
          const nodeStart = this.startNode();
          nodeStart.callProperties = [];
          nodeStart.properties = [];
          nodeStart.indexers = [];
          nodeStart.internalSlots = [];
          let endDelim;
          let exact;
          let inexact = false;
          if (allowExact && this.match(6)) {
            this.expect(6);
            endDelim = 9;
            exact = true;
          } else {
            this.expect(5);
            endDelim = 8;
            exact = false;
          }
          nodeStart.exact = exact;
          while (!this.match(endDelim)) {
            let isStatic = false;
            let protoStartLoc = null;
            let inexactStartLoc = null;
            const node = this.startNode();
            if (allowProto && this.isContextual(118)) {
              const lookahead = this.lookahead();
              if (lookahead.type !== 14 && lookahead.type !== 17) {
                this.next();
                protoStartLoc = this.state.startLoc;
                allowStatic = false;
              }
            }
            if (allowStatic && this.isContextual(106)) {
              const lookahead = this.lookahead();
              if (lookahead.type !== 14 && lookahead.type !== 17) {
                this.next();
                isStatic = true;
              }
            }
            const variance = this.flowParseVariance();
            if (this.eat(0)) {
              if (protoStartLoc != null) {
                this.unexpected(protoStartLoc);
              }
              if (this.eat(0)) {
                if (variance) {
                  this.unexpected(variance.loc.start);
                }
                nodeStart.internalSlots.push(this.flowParseObjectTypeInternalSlot(node, isStatic));
              } else {
                nodeStart.indexers.push(this.flowParseObjectTypeIndexer(node, isStatic, variance));
              }
            } else if (this.match(10) || this.match(47)) {
              if (protoStartLoc != null) {
                this.unexpected(protoStartLoc);
              }
              if (variance) {
                this.unexpected(variance.loc.start);
              }
              nodeStart.callProperties.push(this.flowParseObjectTypeCallProperty(node, isStatic));
            } else {
              let kind = "init";
              if (this.isContextual(99) || this.isContextual(104)) {
                const lookahead = this.lookahead();
                if (tokenIsLiteralPropertyName(lookahead.type)) {
                  kind = this.state.value;
                  this.next();
                }
              }
              const propOrInexact = this.flowParseObjectTypeProperty(node, isStatic, protoStartLoc, variance, kind, allowSpread, allowInexact != null ? allowInexact : !exact);
              if (propOrInexact === null) {
                inexact = true;
                inexactStartLoc = this.state.lastTokStartLoc;
              } else {
                nodeStart.properties.push(propOrInexact);
              }
            }
            this.flowObjectTypeSemicolon();
            if (inexactStartLoc && !this.match(8) && !this.match(9)) {
              this.raise(FlowErrors.UnexpectedExplicitInexactInObject, inexactStartLoc);
            }
          }
          this.expect(endDelim);
          if (allowSpread) {
            nodeStart.inexact = inexact;
          }
          const out = this.finishNode(nodeStart, "ObjectTypeAnnotation");
          this.state.inType = oldInType;
          return out;
        }
        flowParseObjectTypeProperty(node, isStatic, protoStartLoc, variance, kind, allowSpread, allowInexact) {
          if (this.eat(21)) {
            const isInexactToken = this.match(12) || this.match(13) || this.match(8) || this.match(9);
            if (isInexactToken) {
              if (!allowSpread) {
                this.raise(FlowErrors.InexactInsideNonObject, this.state.lastTokStartLoc);
              } else if (!allowInexact) {
                this.raise(FlowErrors.InexactInsideExact, this.state.lastTokStartLoc);
              }
              if (variance) {
                this.raise(FlowErrors.InexactVariance, variance);
              }
              return null;
            }
            if (!allowSpread) {
              this.raise(FlowErrors.UnexpectedSpreadType, this.state.lastTokStartLoc);
            }
            if (protoStartLoc != null) {
              this.unexpected(protoStartLoc);
            }
            if (variance) {
              this.raise(FlowErrors.SpreadVariance, variance);
            }
            node.argument = this.flowParseType();
            return this.finishNode(node, "ObjectTypeSpreadProperty");
          } else {
            node.key = this.flowParseObjectPropertyKey();
            node.static = isStatic;
            node.proto = protoStartLoc != null;
            node.kind = kind;
            let optional = false;
            if (this.match(47) || this.match(10)) {
              node.method = true;
              if (protoStartLoc != null) {
                this.unexpected(protoStartLoc);
              }
              if (variance) {
                this.unexpected(variance.loc.start);
              }
              node.value = this.flowParseObjectTypeMethodish(this.startNodeAt(node.loc.start));
              if (kind === "get" || kind === "set") {
                this.flowCheckGetterSetterParams(node);
              }
              if (!allowSpread && node.key.name === "constructor" && node.value.this) {
                this.raise(FlowErrors.ThisParamBannedInConstructor, node.value.this);
              }
            } else {
              if (kind !== "init")
                this.unexpected();
              node.method = false;
              if (this.eat(17)) {
                optional = true;
              }
              node.value = this.flowParseTypeInitialiser();
              node.variance = variance;
            }
            node.optional = optional;
            return this.finishNode(node, "ObjectTypeProperty");
          }
        }
        flowCheckGetterSetterParams(property2) {
          const paramCount = property2.kind === "get" ? 0 : 1;
          const length = property2.value.params.length + (property2.value.rest ? 1 : 0);
          if (property2.value.this) {
            this.raise(property2.kind === "get" ? FlowErrors.GetterMayNotHaveThisParam : FlowErrors.SetterMayNotHaveThisParam, property2.value.this);
          }
          if (length !== paramCount) {
            this.raise(property2.kind === "get" ? Errors.BadGetterArity : Errors.BadSetterArity, property2);
          }
          if (property2.kind === "set" && property2.value.rest) {
            this.raise(Errors.BadSetterRestParameter, property2);
          }
        }
        flowObjectTypeSemicolon() {
          if (!this.eat(13) && !this.eat(12) && !this.match(8) && !this.match(9)) {
            this.unexpected();
          }
        }
        flowParseQualifiedTypeIdentifier(startLoc, id) {
          startLoc != null ? startLoc : startLoc = this.state.startLoc;
          let node = id || this.flowParseRestrictedIdentifier(true);
          while (this.eat(16)) {
            const node2 = this.startNodeAt(startLoc);
            node2.qualification = node;
            node2.id = this.flowParseRestrictedIdentifier(true);
            node = this.finishNode(node2, "QualifiedTypeIdentifier");
          }
          return node;
        }
        flowParseGenericType(startLoc, id) {
          const node = this.startNodeAt(startLoc);
          node.typeParameters = null;
          node.id = this.flowParseQualifiedTypeIdentifier(startLoc, id);
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterInstantiation();
          }
          return this.finishNode(node, "GenericTypeAnnotation");
        }
        flowParseTypeofType() {
          const node = this.startNode();
          this.expect(87);
          node.argument = this.flowParsePrimaryType();
          return this.finishNode(node, "TypeofTypeAnnotation");
        }
        flowParseTupleType() {
          const node = this.startNode();
          node.types = [];
          this.expect(0);
          while (this.state.pos < this.length && !this.match(3)) {
            node.types.push(this.flowParseType());
            if (this.match(3))
              break;
            this.expect(12);
          }
          this.expect(3);
          return this.finishNode(node, "TupleTypeAnnotation");
        }
        flowParseFunctionTypeParam(first) {
          let name = null;
          let optional = false;
          let typeAnnotation = null;
          const node = this.startNode();
          const lh = this.lookahead();
          const isThis = this.state.type === 78;
          if (lh.type === 14 || lh.type === 17) {
            if (isThis && !first) {
              this.raise(FlowErrors.ThisParamMustBeFirst, node);
            }
            name = this.parseIdentifier(isThis);
            if (this.eat(17)) {
              optional = true;
              if (isThis) {
                this.raise(FlowErrors.ThisParamMayNotBeOptional, node);
              }
            }
            typeAnnotation = this.flowParseTypeInitialiser();
          } else {
            typeAnnotation = this.flowParseType();
          }
          node.name = name;
          node.optional = optional;
          node.typeAnnotation = typeAnnotation;
          return this.finishNode(node, "FunctionTypeParam");
        }
        reinterpretTypeAsFunctionTypeParam(type) {
          const node = this.startNodeAt(type.loc.start);
          node.name = null;
          node.optional = false;
          node.typeAnnotation = type;
          return this.finishNode(node, "FunctionTypeParam");
        }
        flowParseFunctionTypeParams(params = []) {
          let rest2 = null;
          let _this = null;
          if (this.match(78)) {
            _this = this.flowParseFunctionTypeParam(true);
            _this.name = null;
            if (!this.match(11)) {
              this.expect(12);
            }
          }
          while (!this.match(11) && !this.match(21)) {
            params.push(this.flowParseFunctionTypeParam(false));
            if (!this.match(11)) {
              this.expect(12);
            }
          }
          if (this.eat(21)) {
            rest2 = this.flowParseFunctionTypeParam(false);
          }
          return {
            params,
            rest: rest2,
            _this
          };
        }
        flowIdentToTypeAnnotation(startLoc, node, id) {
          switch (id.name) {
            case "any":
              return this.finishNode(node, "AnyTypeAnnotation");
            case "bool":
            case "boolean":
              return this.finishNode(node, "BooleanTypeAnnotation");
            case "mixed":
              return this.finishNode(node, "MixedTypeAnnotation");
            case "empty":
              return this.finishNode(node, "EmptyTypeAnnotation");
            case "number":
              return this.finishNode(node, "NumberTypeAnnotation");
            case "string":
              return this.finishNode(node, "StringTypeAnnotation");
            case "symbol":
              return this.finishNode(node, "SymbolTypeAnnotation");
            default:
              this.checkNotUnderscore(id.name);
              return this.flowParseGenericType(startLoc, id);
          }
        }
        flowParsePrimaryType() {
          const startLoc = this.state.startLoc;
          const node = this.startNode();
          let tmp;
          let type;
          let isGroupedType = false;
          const oldNoAnonFunctionType = this.state.noAnonFunctionType;
          switch (this.state.type) {
            case 5:
              return this.flowParseObjectType({
                allowStatic: false,
                allowExact: false,
                allowSpread: true,
                allowProto: false,
                allowInexact: true
              });
            case 6:
              return this.flowParseObjectType({
                allowStatic: false,
                allowExact: true,
                allowSpread: true,
                allowProto: false,
                allowInexact: false
              });
            case 0:
              this.state.noAnonFunctionType = false;
              type = this.flowParseTupleType();
              this.state.noAnonFunctionType = oldNoAnonFunctionType;
              return type;
            case 47: {
              const node2 = this.startNode();
              node2.typeParameters = this.flowParseTypeParameterDeclaration();
              this.expect(10);
              tmp = this.flowParseFunctionTypeParams();
              node2.params = tmp.params;
              node2.rest = tmp.rest;
              node2.this = tmp._this;
              this.expect(11);
              this.expect(19);
              node2.returnType = this.flowParseType();
              return this.finishNode(node2, "FunctionTypeAnnotation");
            }
            case 10: {
              const node2 = this.startNode();
              this.next();
              if (!this.match(11) && !this.match(21)) {
                if (tokenIsIdentifier(this.state.type) || this.match(78)) {
                  const token = this.lookahead().type;
                  isGroupedType = token !== 17 && token !== 14;
                } else {
                  isGroupedType = true;
                }
              }
              if (isGroupedType) {
                this.state.noAnonFunctionType = false;
                type = this.flowParseType();
                this.state.noAnonFunctionType = oldNoAnonFunctionType;
                if (this.state.noAnonFunctionType || !(this.match(12) || this.match(11) && this.lookahead().type === 19)) {
                  this.expect(11);
                  return type;
                } else {
                  this.eat(12);
                }
              }
              if (type) {
                tmp = this.flowParseFunctionTypeParams([this.reinterpretTypeAsFunctionTypeParam(type)]);
              } else {
                tmp = this.flowParseFunctionTypeParams();
              }
              node2.params = tmp.params;
              node2.rest = tmp.rest;
              node2.this = tmp._this;
              this.expect(11);
              this.expect(19);
              node2.returnType = this.flowParseType();
              node2.typeParameters = null;
              return this.finishNode(node2, "FunctionTypeAnnotation");
            }
            case 134:
              return this.parseLiteral(this.state.value, "StringLiteralTypeAnnotation");
            case 85:
            case 86:
              node.value = this.match(85);
              this.next();
              return this.finishNode(node, "BooleanLiteralTypeAnnotation");
            case 53:
              if (this.state.value === "-") {
                this.next();
                if (this.match(135)) {
                  return this.parseLiteralAtNode(-this.state.value, "NumberLiteralTypeAnnotation", node);
                }
                if (this.match(136)) {
                  return this.parseLiteralAtNode(-this.state.value, "BigIntLiteralTypeAnnotation", node);
                }
                throw this.raise(FlowErrors.UnexpectedSubtractionOperand, this.state.startLoc);
              }
              this.unexpected();
              return;
            case 135:
              return this.parseLiteral(this.state.value, "NumberLiteralTypeAnnotation");
            case 136:
              return this.parseLiteral(this.state.value, "BigIntLiteralTypeAnnotation");
            case 88:
              this.next();
              return this.finishNode(node, "VoidTypeAnnotation");
            case 84:
              this.next();
              return this.finishNode(node, "NullLiteralTypeAnnotation");
            case 78:
              this.next();
              return this.finishNode(node, "ThisTypeAnnotation");
            case 55:
              this.next();
              return this.finishNode(node, "ExistsTypeAnnotation");
            case 87:
              return this.flowParseTypeofType();
            default:
              if (tokenIsKeyword(this.state.type)) {
                const label = tokenLabelName(this.state.type);
                this.next();
                return super.createIdentifier(node, label);
              } else if (tokenIsIdentifier(this.state.type)) {
                if (this.isContextual(129)) {
                  return this.flowParseInterfaceType();
                }
                return this.flowIdentToTypeAnnotation(startLoc, node, this.parseIdentifier());
              }
          }
          this.unexpected();
        }
        flowParsePostfixType() {
          const startLoc = this.state.startLoc;
          let type = this.flowParsePrimaryType();
          let seenOptionalIndexedAccess = false;
          while ((this.match(0) || this.match(18)) && !this.canInsertSemicolon()) {
            const node = this.startNodeAt(startLoc);
            const optional = this.eat(18);
            seenOptionalIndexedAccess = seenOptionalIndexedAccess || optional;
            this.expect(0);
            if (!optional && this.match(3)) {
              node.elementType = type;
              this.next();
              type = this.finishNode(node, "ArrayTypeAnnotation");
            } else {
              node.objectType = type;
              node.indexType = this.flowParseType();
              this.expect(3);
              if (seenOptionalIndexedAccess) {
                node.optional = optional;
                type = this.finishNode(node, "OptionalIndexedAccessType");
              } else {
                type = this.finishNode(node, "IndexedAccessType");
              }
            }
          }
          return type;
        }
        flowParsePrefixType() {
          const node = this.startNode();
          if (this.eat(17)) {
            node.typeAnnotation = this.flowParsePrefixType();
            return this.finishNode(node, "NullableTypeAnnotation");
          } else {
            return this.flowParsePostfixType();
          }
        }
        flowParseAnonFunctionWithoutParens() {
          const param = this.flowParsePrefixType();
          if (!this.state.noAnonFunctionType && this.eat(19)) {
            const node = this.startNodeAt(param.loc.start);
            node.params = [this.reinterpretTypeAsFunctionTypeParam(param)];
            node.rest = null;
            node.this = null;
            node.returnType = this.flowParseType();
            node.typeParameters = null;
            return this.finishNode(node, "FunctionTypeAnnotation");
          }
          return param;
        }
        flowParseIntersectionType() {
          const node = this.startNode();
          this.eat(45);
          const type = this.flowParseAnonFunctionWithoutParens();
          node.types = [type];
          while (this.eat(45)) {
            node.types.push(this.flowParseAnonFunctionWithoutParens());
          }
          return node.types.length === 1 ? type : this.finishNode(node, "IntersectionTypeAnnotation");
        }
        flowParseUnionType() {
          const node = this.startNode();
          this.eat(43);
          const type = this.flowParseIntersectionType();
          node.types = [type];
          while (this.eat(43)) {
            node.types.push(this.flowParseIntersectionType());
          }
          return node.types.length === 1 ? type : this.finishNode(node, "UnionTypeAnnotation");
        }
        flowParseType() {
          const oldInType = this.state.inType;
          this.state.inType = true;
          const type = this.flowParseUnionType();
          this.state.inType = oldInType;
          return type;
        }
        flowParseTypeOrImplicitInstantiation() {
          if (this.state.type === 132 && this.state.value === "_") {
            const startLoc = this.state.startLoc;
            const node = this.parseIdentifier();
            return this.flowParseGenericType(startLoc, node);
          } else {
            return this.flowParseType();
          }
        }
        flowParseTypeAnnotation() {
          const node = this.startNode();
          node.typeAnnotation = this.flowParseTypeInitialiser();
          return this.finishNode(node, "TypeAnnotation");
        }
        flowParseTypeAnnotatableIdentifier(allowPrimitiveOverride) {
          const ident = allowPrimitiveOverride ? this.parseIdentifier() : this.flowParseRestrictedIdentifier();
          if (this.match(14)) {
            ident.typeAnnotation = this.flowParseTypeAnnotation();
            this.resetEndLocation(ident);
          }
          return ident;
        }
        typeCastToParameter(node) {
          node.expression.typeAnnotation = node.typeAnnotation;
          this.resetEndLocation(node.expression, node.typeAnnotation.loc.end);
          return node.expression;
        }
        flowParseVariance() {
          let variance = null;
          if (this.match(53)) {
            variance = this.startNode();
            if (this.state.value === "+") {
              variance.kind = "plus";
            } else {
              variance.kind = "minus";
            }
            this.next();
            return this.finishNode(variance, "Variance");
          }
          return variance;
        }
        parseFunctionBody(node, allowExpressionBody, isMethod = false) {
          if (allowExpressionBody) {
            this.forwardNoArrowParamsConversionAt(node, () => super.parseFunctionBody(node, true, isMethod));
            return;
          }
          super.parseFunctionBody(node, false, isMethod);
        }
        parseFunctionBodyAndFinish(node, type, isMethod = false) {
          if (this.match(14)) {
            const typeNode = this.startNode();
            [typeNode.typeAnnotation, node.predicate] = this.flowParseTypeAndPredicateInitialiser();
            node.returnType = typeNode.typeAnnotation ? this.finishNode(typeNode, "TypeAnnotation") : null;
          }
          return super.parseFunctionBodyAndFinish(node, type, isMethod);
        }
        parseStatementLike(flags) {
          if (this.state.strict && this.isContextual(129)) {
            const lookahead = this.lookahead();
            if (tokenIsKeywordOrIdentifier(lookahead.type)) {
              const node = this.startNode();
              this.next();
              return this.flowParseInterface(node);
            }
          } else if (this.isContextual(126)) {
            const node = this.startNode();
            this.next();
            return this.flowParseEnumDeclaration(node);
          }
          const stmt = super.parseStatementLike(flags);
          if (this.flowPragma === void 0 && !this.isValidDirective(stmt)) {
            this.flowPragma = null;
          }
          return stmt;
        }
        parseExpressionStatement(node, expr, decorators) {
          if (expr.type === "Identifier") {
            if (expr.name === "declare") {
              if (this.match(80) || tokenIsIdentifier(this.state.type) || this.match(68) || this.match(74) || this.match(82)) {
                return this.flowParseDeclare(node);
              }
            } else if (tokenIsIdentifier(this.state.type)) {
              if (expr.name === "interface") {
                return this.flowParseInterface(node);
              } else if (expr.name === "type") {
                return this.flowParseTypeAlias(node);
              } else if (expr.name === "opaque") {
                return this.flowParseOpaqueType(node, false);
              }
            }
          }
          return super.parseExpressionStatement(node, expr, decorators);
        }
        shouldParseExportDeclaration() {
          const {
            type
          } = this.state;
          if (type === 126 || tokenIsFlowInterfaceOrTypeOrOpaque(type)) {
            return !this.state.containsEsc;
          }
          return super.shouldParseExportDeclaration();
        }
        isExportDefaultSpecifier() {
          const {
            type
          } = this.state;
          if (type === 126 || tokenIsFlowInterfaceOrTypeOrOpaque(type)) {
            return this.state.containsEsc;
          }
          return super.isExportDefaultSpecifier();
        }
        parseExportDefaultExpression() {
          if (this.isContextual(126)) {
            const node = this.startNode();
            this.next();
            return this.flowParseEnumDeclaration(node);
          }
          return super.parseExportDefaultExpression();
        }
        parseConditional(expr, startLoc, refExpressionErrors) {
          if (!this.match(17))
            return expr;
          if (this.state.maybeInArrowParameters) {
            const nextCh = this.lookaheadCharCode();
            if (nextCh === 44 || nextCh === 61 || nextCh === 58 || nextCh === 41) {
              this.setOptionalParametersError(refExpressionErrors);
              return expr;
            }
          }
          this.expect(17);
          const state = this.state.clone();
          const originalNoArrowAt = this.state.noArrowAt;
          const node = this.startNodeAt(startLoc);
          let {
            consequent,
            failed
          } = this.tryParseConditionalConsequent();
          let [valid, invalid] = this.getArrowLikeExpressions(consequent);
          if (failed || invalid.length > 0) {
            const noArrowAt = [...originalNoArrowAt];
            if (invalid.length > 0) {
              this.state = state;
              this.state.noArrowAt = noArrowAt;
              for (let i = 0; i < invalid.length; i++) {
                noArrowAt.push(invalid[i].start);
              }
              ({
                consequent,
                failed
              } = this.tryParseConditionalConsequent());
              [valid, invalid] = this.getArrowLikeExpressions(consequent);
            }
            if (failed && valid.length > 1) {
              this.raise(FlowErrors.AmbiguousConditionalArrow, state.startLoc);
            }
            if (failed && valid.length === 1) {
              this.state = state;
              noArrowAt.push(valid[0].start);
              this.state.noArrowAt = noArrowAt;
              ({
                consequent,
                failed
              } = this.tryParseConditionalConsequent());
            }
          }
          this.getArrowLikeExpressions(consequent, true);
          this.state.noArrowAt = originalNoArrowAt;
          this.expect(14);
          node.test = expr;
          node.consequent = consequent;
          node.alternate = this.forwardNoArrowParamsConversionAt(node, () => this.parseMaybeAssign(void 0, void 0));
          return this.finishNode(node, "ConditionalExpression");
        }
        tryParseConditionalConsequent() {
          this.state.noArrowParamsConversionAt.push(this.state.start);
          const consequent = this.parseMaybeAssignAllowIn();
          const failed = !this.match(14);
          this.state.noArrowParamsConversionAt.pop();
          return {
            consequent,
            failed
          };
        }
        getArrowLikeExpressions(node, disallowInvalid) {
          const stack = [node];
          const arrows = [];
          while (stack.length !== 0) {
            const node2 = stack.pop();
            if (node2.type === "ArrowFunctionExpression" && node2.body.type !== "BlockStatement") {
              if (node2.typeParameters || !node2.returnType) {
                this.finishArrowValidation(node2);
              } else {
                arrows.push(node2);
              }
              stack.push(node2.body);
            } else if (node2.type === "ConditionalExpression") {
              stack.push(node2.consequent);
              stack.push(node2.alternate);
            }
          }
          if (disallowInvalid) {
            arrows.forEach((node2) => this.finishArrowValidation(node2));
            return [arrows, []];
          }
          return partition2(arrows, (node2) => node2.params.every((param) => this.isAssignable(param, true)));
        }
        finishArrowValidation(node) {
          var _node$extra;
          this.toAssignableList(node.params, (_node$extra = node.extra) == null ? void 0 : _node$extra.trailingCommaLoc, false);
          this.scope.enter(514 | 4);
          super.checkParams(node, false, true);
          this.scope.exit();
        }
        forwardNoArrowParamsConversionAt(node, parse5) {
          let result2;
          if (this.state.noArrowParamsConversionAt.includes(this.offsetToSourcePos(node.start))) {
            this.state.noArrowParamsConversionAt.push(this.state.start);
            result2 = parse5();
            this.state.noArrowParamsConversionAt.pop();
          } else {
            result2 = parse5();
          }
          return result2;
        }
        parseParenItem(node, startLoc) {
          const newNode = super.parseParenItem(node, startLoc);
          if (this.eat(17)) {
            newNode.optional = true;
            this.resetEndLocation(node);
          }
          if (this.match(14)) {
            const typeCastNode = this.startNodeAt(startLoc);
            typeCastNode.expression = newNode;
            typeCastNode.typeAnnotation = this.flowParseTypeAnnotation();
            return this.finishNode(typeCastNode, "TypeCastExpression");
          }
          return newNode;
        }
        assertModuleNodeAllowed(node) {
          if (node.type === "ImportDeclaration" && (node.importKind === "type" || node.importKind === "typeof") || node.type === "ExportNamedDeclaration" && node.exportKind === "type" || node.type === "ExportAllDeclaration" && node.exportKind === "type") {
            return;
          }
          super.assertModuleNodeAllowed(node);
        }
        parseExportDeclaration(node) {
          if (this.isContextual(130)) {
            node.exportKind = "type";
            const declarationNode = this.startNode();
            this.next();
            if (this.match(5)) {
              node.specifiers = this.parseExportSpecifiers(true);
              super.parseExportFrom(node);
              return null;
            } else {
              return this.flowParseTypeAlias(declarationNode);
            }
          } else if (this.isContextual(131)) {
            node.exportKind = "type";
            const declarationNode = this.startNode();
            this.next();
            return this.flowParseOpaqueType(declarationNode, false);
          } else if (this.isContextual(129)) {
            node.exportKind = "type";
            const declarationNode = this.startNode();
            this.next();
            return this.flowParseInterface(declarationNode);
          } else if (this.isContextual(126)) {
            node.exportKind = "value";
            const declarationNode = this.startNode();
            this.next();
            return this.flowParseEnumDeclaration(declarationNode);
          } else {
            return super.parseExportDeclaration(node);
          }
        }
        eatExportStar(node) {
          if (super.eatExportStar(node))
            return true;
          if (this.isContextual(130) && this.lookahead().type === 55) {
            node.exportKind = "type";
            this.next();
            this.next();
            return true;
          }
          return false;
        }
        maybeParseExportNamespaceSpecifier(node) {
          const {
            startLoc
          } = this.state;
          const hasNamespace = super.maybeParseExportNamespaceSpecifier(node);
          if (hasNamespace && node.exportKind === "type") {
            this.unexpected(startLoc);
          }
          return hasNamespace;
        }
        parseClassId(node, isStatement, optionalId) {
          super.parseClassId(node, isStatement, optionalId);
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          }
        }
        parseClassMember(classBody, member, state) {
          const {
            startLoc
          } = this.state;
          if (this.isContextual(125)) {
            if (super.parseClassMemberFromModifier(classBody, member)) {
              return;
            }
            member.declare = true;
          }
          super.parseClassMember(classBody, member, state);
          if (member.declare) {
            if (member.type !== "ClassProperty" && member.type !== "ClassPrivateProperty" && member.type !== "PropertyDefinition") {
              this.raise(FlowErrors.DeclareClassElement, startLoc);
            } else if (member.value) {
              this.raise(FlowErrors.DeclareClassFieldInitializer, member.value);
            }
          }
        }
        isIterator(word) {
          return word === "iterator" || word === "asyncIterator";
        }
        readIterator() {
          const word = super.readWord1();
          const fullWord = "@@" + word;
          if (!this.isIterator(word) || !this.state.inType) {
            this.raise(Errors.InvalidIdentifier, this.state.curPosition(), {
              identifierName: fullWord
            });
          }
          this.finishToken(132, fullWord);
        }
        getTokenFromCode(code2) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (code2 === 123 && next === 124) {
            this.finishOp(6, 2);
          } else if (this.state.inType && (code2 === 62 || code2 === 60)) {
            this.finishOp(code2 === 62 ? 48 : 47, 1);
          } else if (this.state.inType && code2 === 63) {
            if (next === 46) {
              this.finishOp(18, 2);
            } else {
              this.finishOp(17, 1);
            }
          } else if (isIteratorStart(code2, next, this.input.charCodeAt(this.state.pos + 2))) {
            this.state.pos += 2;
            this.readIterator();
          } else {
            super.getTokenFromCode(code2);
          }
        }
        isAssignable(node, isBinding) {
          if (node.type === "TypeCastExpression") {
            return this.isAssignable(node.expression, isBinding);
          } else {
            return super.isAssignable(node, isBinding);
          }
        }
        toAssignable(node, isLHS = false) {
          if (!isLHS && node.type === "AssignmentExpression" && node.left.type === "TypeCastExpression") {
            node.left = this.typeCastToParameter(node.left);
          }
          super.toAssignable(node, isLHS);
        }
        toAssignableList(exprList, trailingCommaLoc, isLHS) {
          for (let i = 0; i < exprList.length; i++) {
            const expr = exprList[i];
            if ((expr == null ? void 0 : expr.type) === "TypeCastExpression") {
              exprList[i] = this.typeCastToParameter(expr);
            }
          }
          super.toAssignableList(exprList, trailingCommaLoc, isLHS);
        }
        toReferencedList(exprList, isParenthesizedExpr) {
          for (let i = 0; i < exprList.length; i++) {
            var _expr$extra;
            const expr = exprList[i];
            if (expr && expr.type === "TypeCastExpression" && !((_expr$extra = expr.extra) != null && _expr$extra.parenthesized) && (exprList.length > 1 || !isParenthesizedExpr)) {
              this.raise(FlowErrors.TypeCastInPattern, expr.typeAnnotation);
            }
          }
          return exprList;
        }
        parseArrayLike(close, canBePattern, isTuple, refExpressionErrors) {
          const node = super.parseArrayLike(close, canBePattern, isTuple, refExpressionErrors);
          if (canBePattern && !this.state.maybeInArrowParameters) {
            this.toReferencedList(node.elements);
          }
          return node;
        }
        isValidLVal(type, isParenthesized, binding3) {
          return type === "TypeCastExpression" || super.isValidLVal(type, isParenthesized, binding3);
        }
        parseClassProperty(node) {
          if (this.match(14)) {
            node.typeAnnotation = this.flowParseTypeAnnotation();
          }
          return super.parseClassProperty(node);
        }
        parseClassPrivateProperty(node) {
          if (this.match(14)) {
            node.typeAnnotation = this.flowParseTypeAnnotation();
          }
          return super.parseClassPrivateProperty(node);
        }
        isClassMethod() {
          return this.match(47) || super.isClassMethod();
        }
        isClassProperty() {
          return this.match(14) || super.isClassProperty();
        }
        isNonstaticConstructor(method2) {
          return !this.match(14) && super.isNonstaticConstructor(method2);
        }
        pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper) {
          if (method2.variance) {
            this.unexpected(method2.variance.loc.start);
          }
          delete method2.variance;
          if (this.match(47)) {
            method2.typeParameters = this.flowParseTypeParameterDeclaration();
          }
          super.pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper);
          if (method2.params && isConstructor) {
            const params = method2.params;
            if (params.length > 0 && this.isThisParam(params[0])) {
              this.raise(FlowErrors.ThisParamBannedInConstructor, method2);
            }
          } else if (method2.type === "MethodDefinition" && isConstructor && method2.value.params) {
            const params = method2.value.params;
            if (params.length > 0 && this.isThisParam(params[0])) {
              this.raise(FlowErrors.ThisParamBannedInConstructor, method2);
            }
          }
        }
        pushClassPrivateMethod(classBody, method2, isGenerator, isAsync) {
          if (method2.variance) {
            this.unexpected(method2.variance.loc.start);
          }
          delete method2.variance;
          if (this.match(47)) {
            method2.typeParameters = this.flowParseTypeParameterDeclaration();
          }
          super.pushClassPrivateMethod(classBody, method2, isGenerator, isAsync);
        }
        parseClassSuper(node) {
          super.parseClassSuper(node);
          if (node.superClass && (this.match(47) || this.match(51))) {
            {
              node.superTypeParameters = this.flowParseTypeParameterInstantiationInExpression();
            }
          }
          if (this.isContextual(113)) {
            this.next();
            const implemented = node.implements = [];
            do {
              const node2 = this.startNode();
              node2.id = this.flowParseRestrictedIdentifier(true);
              if (this.match(47)) {
                node2.typeParameters = this.flowParseTypeParameterInstantiation();
              } else {
                node2.typeParameters = null;
              }
              implemented.push(this.finishNode(node2, "ClassImplements"));
            } while (this.eat(12));
          }
        }
        checkGetterSetterParams(method2) {
          super.checkGetterSetterParams(method2);
          const params = this.getObjectOrClassMethodParams(method2);
          if (params.length > 0) {
            const param = params[0];
            if (this.isThisParam(param) && method2.kind === "get") {
              this.raise(FlowErrors.GetterMayNotHaveThisParam, param);
            } else if (this.isThisParam(param)) {
              this.raise(FlowErrors.SetterMayNotHaveThisParam, param);
            }
          }
        }
        parsePropertyNamePrefixOperator(node) {
          node.variance = this.flowParseVariance();
        }
        parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors) {
          if (prop.variance) {
            this.unexpected(prop.variance.loc.start);
          }
          delete prop.variance;
          let typeParameters;
          if (this.match(47) && !isAccessor) {
            typeParameters = this.flowParseTypeParameterDeclaration();
            if (!this.match(10))
              this.unexpected();
          }
          const result2 = super.parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors);
          if (typeParameters) {
            (result2.value || result2).typeParameters = typeParameters;
          }
          return result2;
        }
        parseFunctionParamType(param) {
          if (this.eat(17)) {
            if (param.type !== "Identifier") {
              this.raise(FlowErrors.PatternIsOptional, param);
            }
            if (this.isThisParam(param)) {
              this.raise(FlowErrors.ThisParamMayNotBeOptional, param);
            }
            param.optional = true;
          }
          if (this.match(14)) {
            param.typeAnnotation = this.flowParseTypeAnnotation();
          } else if (this.isThisParam(param)) {
            this.raise(FlowErrors.ThisParamAnnotationRequired, param);
          }
          if (this.match(29) && this.isThisParam(param)) {
            this.raise(FlowErrors.ThisParamNoDefault, param);
          }
          this.resetEndLocation(param);
          return param;
        }
        parseMaybeDefault(startLoc, left) {
          const node = super.parseMaybeDefault(startLoc, left);
          if (node.type === "AssignmentPattern" && node.typeAnnotation && node.right.start < node.typeAnnotation.start) {
            this.raise(FlowErrors.TypeBeforeInitializer, node.typeAnnotation);
          }
          return node;
        }
        checkImportReflection(node) {
          super.checkImportReflection(node);
          if (node.module && node.importKind !== "value") {
            this.raise(FlowErrors.ImportReflectionHasImportType, node.specifiers[0].loc.start);
          }
        }
        parseImportSpecifierLocal(node, specifier, type) {
          specifier.local = hasTypeImportKind(node) ? this.flowParseRestrictedIdentifier(true, true) : this.parseIdentifier();
          node.specifiers.push(this.finishImportSpecifier(specifier, type));
        }
        isPotentialImportPhase(isExport) {
          if (super.isPotentialImportPhase(isExport))
            return true;
          if (this.isContextual(130)) {
            if (!isExport)
              return true;
            const ch = this.lookaheadCharCode();
            return ch === 123 || ch === 42;
          }
          return !isExport && this.isContextual(87);
        }
        applyImportPhase(node, isExport, phase, loc) {
          super.applyImportPhase(node, isExport, phase, loc);
          if (isExport) {
            if (!phase && this.match(65)) {
              return;
            }
            node.exportKind = phase === "type" ? phase : "value";
          } else {
            if (phase === "type" && this.match(55))
              this.unexpected();
            node.importKind = phase === "type" || phase === "typeof" ? phase : "value";
          }
        }
        parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, bindingType) {
          const firstIdent = specifier.imported;
          let specifierTypeKind = null;
          if (firstIdent.type === "Identifier") {
            if (firstIdent.name === "type") {
              specifierTypeKind = "type";
            } else if (firstIdent.name === "typeof") {
              specifierTypeKind = "typeof";
            }
          }
          let isBinding = false;
          if (this.isContextual(93) && !this.isLookaheadContextual("as")) {
            const as_ident = this.parseIdentifier(true);
            if (specifierTypeKind !== null && !tokenIsKeywordOrIdentifier(this.state.type)) {
              specifier.imported = as_ident;
              specifier.importKind = specifierTypeKind;
              specifier.local = this.cloneIdentifier(as_ident);
            } else {
              specifier.imported = firstIdent;
              specifier.importKind = null;
              specifier.local = this.parseIdentifier();
            }
          } else {
            if (specifierTypeKind !== null && tokenIsKeywordOrIdentifier(this.state.type)) {
              specifier.imported = this.parseIdentifier(true);
              specifier.importKind = specifierTypeKind;
            } else {
              if (importedIsString) {
                throw this.raise(Errors.ImportBindingIsString, specifier, {
                  importName: firstIdent.value
                });
              }
              specifier.imported = firstIdent;
              specifier.importKind = null;
            }
            if (this.eatContextual(93)) {
              specifier.local = this.parseIdentifier();
            } else {
              isBinding = true;
              specifier.local = this.cloneIdentifier(specifier.imported);
            }
          }
          const specifierIsTypeImport = hasTypeImportKind(specifier);
          if (isInTypeOnlyImport && specifierIsTypeImport) {
            this.raise(FlowErrors.ImportTypeShorthandOnlyInPureImport, specifier);
          }
          if (isInTypeOnlyImport || specifierIsTypeImport) {
            this.checkReservedType(specifier.local.name, specifier.local.loc.start, true);
          }
          if (isBinding && !isInTypeOnlyImport && !specifierIsTypeImport) {
            this.checkReservedWord(specifier.local.name, specifier.loc.start, true, true);
          }
          return this.finishImportSpecifier(specifier, "ImportSpecifier");
        }
        parseBindingAtom() {
          switch (this.state.type) {
            case 78:
              return this.parseIdentifier(true);
            default:
              return super.parseBindingAtom();
          }
        }
        parseFunctionParams(node, isConstructor) {
          const kind = node.kind;
          if (kind !== "get" && kind !== "set" && this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          }
          super.parseFunctionParams(node, isConstructor);
        }
        parseVarId(decl, kind) {
          super.parseVarId(decl, kind);
          if (this.match(14)) {
            decl.id.typeAnnotation = this.flowParseTypeAnnotation();
            this.resetEndLocation(decl.id);
          }
        }
        parseAsyncArrowFromCallExpression(node, call) {
          if (this.match(14)) {
            const oldNoAnonFunctionType = this.state.noAnonFunctionType;
            this.state.noAnonFunctionType = true;
            node.returnType = this.flowParseTypeAnnotation();
            this.state.noAnonFunctionType = oldNoAnonFunctionType;
          }
          return super.parseAsyncArrowFromCallExpression(node, call);
        }
        shouldParseAsyncArrow() {
          return this.match(14) || super.shouldParseAsyncArrow();
        }
        parseMaybeAssign(refExpressionErrors, afterLeftParse) {
          var _jsx;
          let state = null;
          let jsx2;
          if (this.hasPlugin("jsx") && (this.match(143) || this.match(47))) {
            state = this.state.clone();
            jsx2 = this.tryParse(() => super.parseMaybeAssign(refExpressionErrors, afterLeftParse), state);
            if (!jsx2.error)
              return jsx2.node;
            const {
              context
            } = this.state;
            const currentContext = context[context.length - 1];
            if (currentContext === types2.j_oTag || currentContext === types2.j_expr) {
              context.pop();
            }
          }
          if ((_jsx = jsx2) != null && _jsx.error || this.match(47)) {
            var _jsx2, _jsx3;
            state = state || this.state.clone();
            let typeParameters;
            const arrow = this.tryParse((abort3) => {
              var _arrowExpression$extr;
              typeParameters = this.flowParseTypeParameterDeclaration();
              const arrowExpression2 = this.forwardNoArrowParamsConversionAt(typeParameters, () => {
                const result2 = super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
                this.resetStartLocationFromNode(result2, typeParameters);
                return result2;
              });
              if ((_arrowExpression$extr = arrowExpression2.extra) != null && _arrowExpression$extr.parenthesized)
                abort3();
              const expr = this.maybeUnwrapTypeCastExpression(arrowExpression2);
              if (expr.type !== "ArrowFunctionExpression")
                abort3();
              expr.typeParameters = typeParameters;
              this.resetStartLocationFromNode(expr, typeParameters);
              return arrowExpression2;
            }, state);
            let arrowExpression = null;
            if (arrow.node && this.maybeUnwrapTypeCastExpression(arrow.node).type === "ArrowFunctionExpression") {
              if (!arrow.error && !arrow.aborted) {
                if (arrow.node.async) {
                  this.raise(FlowErrors.UnexpectedTypeParameterBeforeAsyncArrowFunction, typeParameters);
                }
                return arrow.node;
              }
              arrowExpression = arrow.node;
            }
            if ((_jsx2 = jsx2) != null && _jsx2.node) {
              this.state = jsx2.failState;
              return jsx2.node;
            }
            if (arrowExpression) {
              this.state = arrow.failState;
              return arrowExpression;
            }
            if ((_jsx3 = jsx2) != null && _jsx3.thrown)
              throw jsx2.error;
            if (arrow.thrown)
              throw arrow.error;
            throw this.raise(FlowErrors.UnexpectedTokenAfterTypeParameter, typeParameters);
          }
          return super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
        }
        parseArrow(node) {
          if (this.match(14)) {
            const result2 = this.tryParse(() => {
              const oldNoAnonFunctionType = this.state.noAnonFunctionType;
              this.state.noAnonFunctionType = true;
              const typeNode = this.startNode();
              [typeNode.typeAnnotation, node.predicate] = this.flowParseTypeAndPredicateInitialiser();
              this.state.noAnonFunctionType = oldNoAnonFunctionType;
              if (this.canInsertSemicolon())
                this.unexpected();
              if (!this.match(19))
                this.unexpected();
              return typeNode;
            });
            if (result2.thrown)
              return null;
            if (result2.error)
              this.state = result2.failState;
            node.returnType = result2.node.typeAnnotation ? this.finishNode(result2.node, "TypeAnnotation") : null;
          }
          return super.parseArrow(node);
        }
        shouldParseArrow(params) {
          return this.match(14) || super.shouldParseArrow(params);
        }
        setArrowFunctionParameters(node, params) {
          if (this.state.noArrowParamsConversionAt.includes(this.offsetToSourcePos(node.start))) {
            node.params = params;
          } else {
            super.setArrowFunctionParameters(node, params);
          }
        }
        checkParams(node, allowDuplicates, isArrowFunction, strictModeChanged = true) {
          if (isArrowFunction && this.state.noArrowParamsConversionAt.includes(this.offsetToSourcePos(node.start))) {
            return;
          }
          for (let i = 0; i < node.params.length; i++) {
            if (this.isThisParam(node.params[i]) && i > 0) {
              this.raise(FlowErrors.ThisParamMustBeFirst, node.params[i]);
            }
          }
          super.checkParams(node, allowDuplicates, isArrowFunction, strictModeChanged);
        }
        parseParenAndDistinguishExpression(canBeArrow) {
          return super.parseParenAndDistinguishExpression(canBeArrow && !this.state.noArrowAt.includes(this.sourceToOffsetPos(this.state.start)));
        }
        parseSubscripts(base, startLoc, noCalls) {
          if (base.type === "Identifier" && base.name === "async" && this.state.noArrowAt.includes(startLoc.index)) {
            this.next();
            const node = this.startNodeAt(startLoc);
            node.callee = base;
            node.arguments = super.parseCallExpressionArguments();
            base = this.finishNode(node, "CallExpression");
          } else if (base.type === "Identifier" && base.name === "async" && this.match(47)) {
            const state = this.state.clone();
            const arrow = this.tryParse((abort3) => this.parseAsyncArrowWithTypeParameters(startLoc) || abort3(), state);
            if (!arrow.error && !arrow.aborted)
              return arrow.node;
            const result2 = this.tryParse(() => super.parseSubscripts(base, startLoc, noCalls), state);
            if (result2.node && !result2.error)
              return result2.node;
            if (arrow.node) {
              this.state = arrow.failState;
              return arrow.node;
            }
            if (result2.node) {
              this.state = result2.failState;
              return result2.node;
            }
            throw arrow.error || result2.error;
          }
          return super.parseSubscripts(base, startLoc, noCalls);
        }
        parseSubscript(base, startLoc, noCalls, subscriptState) {
          if (this.match(18) && this.isLookaheadToken_lt()) {
            subscriptState.optionalChainMember = true;
            if (noCalls) {
              subscriptState.stop = true;
              return base;
            }
            this.next();
            const node = this.startNodeAt(startLoc);
            node.callee = base;
            node.typeArguments = this.flowParseTypeParameterInstantiationInExpression();
            this.expect(10);
            node.arguments = this.parseCallExpressionArguments();
            node.optional = true;
            return this.finishCallExpression(node, true);
          } else if (!noCalls && this.shouldParseTypes() && (this.match(47) || this.match(51))) {
            const node = this.startNodeAt(startLoc);
            node.callee = base;
            const result2 = this.tryParse(() => {
              node.typeArguments = this.flowParseTypeParameterInstantiationCallOrNew();
              this.expect(10);
              node.arguments = super.parseCallExpressionArguments();
              if (subscriptState.optionalChainMember) {
                node.optional = false;
              }
              return this.finishCallExpression(node, subscriptState.optionalChainMember);
            });
            if (result2.node) {
              if (result2.error)
                this.state = result2.failState;
              return result2.node;
            }
          }
          return super.parseSubscript(base, startLoc, noCalls, subscriptState);
        }
        parseNewCallee(node) {
          super.parseNewCallee(node);
          let targs = null;
          if (this.shouldParseTypes() && this.match(47)) {
            targs = this.tryParse(() => this.flowParseTypeParameterInstantiationCallOrNew()).node;
          }
          node.typeArguments = targs;
        }
        parseAsyncArrowWithTypeParameters(startLoc) {
          const node = this.startNodeAt(startLoc);
          this.parseFunctionParams(node, false);
          if (!this.parseArrow(node))
            return;
          return super.parseArrowExpression(node, void 0, true);
        }
        readToken_mult_modulo(code2) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (code2 === 42 && next === 47 && this.state.hasFlowComment) {
            this.state.hasFlowComment = false;
            this.state.pos += 2;
            this.nextToken();
            return;
          }
          super.readToken_mult_modulo(code2);
        }
        readToken_pipe_amp(code2) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (code2 === 124 && next === 125) {
            this.finishOp(9, 2);
            return;
          }
          super.readToken_pipe_amp(code2);
        }
        parseTopLevel(file2, program3) {
          const fileNode = super.parseTopLevel(file2, program3);
          if (this.state.hasFlowComment) {
            this.raise(FlowErrors.UnterminatedFlowComment, this.state.curPosition());
          }
          return fileNode;
        }
        skipBlockComment() {
          if (this.hasPlugin("flowComments") && this.skipFlowComment()) {
            if (this.state.hasFlowComment) {
              throw this.raise(FlowErrors.NestedFlowComment, this.state.startLoc);
            }
            this.hasFlowCommentCompletion();
            const commentSkip = this.skipFlowComment();
            if (commentSkip) {
              this.state.pos += commentSkip;
              this.state.hasFlowComment = true;
            }
            return;
          }
          return super.skipBlockComment(this.state.hasFlowComment ? "*-/" : "*/");
        }
        skipFlowComment() {
          const {
            pos
          } = this.state;
          let shiftToFirstNonWhiteSpace = 2;
          while ([32, 9].includes(this.input.charCodeAt(pos + shiftToFirstNonWhiteSpace))) {
            shiftToFirstNonWhiteSpace++;
          }
          const ch2 = this.input.charCodeAt(shiftToFirstNonWhiteSpace + pos);
          const ch3 = this.input.charCodeAt(shiftToFirstNonWhiteSpace + pos + 1);
          if (ch2 === 58 && ch3 === 58) {
            return shiftToFirstNonWhiteSpace + 2;
          }
          if (this.input.slice(shiftToFirstNonWhiteSpace + pos, shiftToFirstNonWhiteSpace + pos + 12) === "flow-include") {
            return shiftToFirstNonWhiteSpace + 12;
          }
          if (ch2 === 58 && ch3 !== 58) {
            return shiftToFirstNonWhiteSpace;
          }
          return false;
        }
        hasFlowCommentCompletion() {
          const end = this.input.indexOf("*/", this.state.pos);
          if (end === -1) {
            throw this.raise(Errors.UnterminatedComment, this.state.curPosition());
          }
        }
        flowEnumErrorBooleanMemberNotInitialized(loc, {
          enumName,
          memberName
        }) {
          this.raise(FlowErrors.EnumBooleanMemberNotInitialized, loc, {
            memberName,
            enumName
          });
        }
        flowEnumErrorInvalidMemberInitializer(loc, enumContext) {
          return this.raise(!enumContext.explicitType ? FlowErrors.EnumInvalidMemberInitializerUnknownType : enumContext.explicitType === "symbol" ? FlowErrors.EnumInvalidMemberInitializerSymbolType : FlowErrors.EnumInvalidMemberInitializerPrimaryType, loc, enumContext);
        }
        flowEnumErrorNumberMemberNotInitialized(loc, details) {
          this.raise(FlowErrors.EnumNumberMemberNotInitialized, loc, details);
        }
        flowEnumErrorStringMemberInconsistentlyInitialized(node, details) {
          this.raise(FlowErrors.EnumStringMemberInconsistentlyInitialized, node, details);
        }
        flowEnumMemberInit() {
          const startLoc = this.state.startLoc;
          const endOfInit = () => this.match(12) || this.match(8);
          switch (this.state.type) {
            case 135: {
              const literal = this.parseNumericLiteral(this.state.value);
              if (endOfInit()) {
                return {
                  type: "number",
                  loc: literal.loc.start,
                  value: literal
                };
              }
              return {
                type: "invalid",
                loc: startLoc
              };
            }
            case 134: {
              const literal = this.parseStringLiteral(this.state.value);
              if (endOfInit()) {
                return {
                  type: "string",
                  loc: literal.loc.start,
                  value: literal
                };
              }
              return {
                type: "invalid",
                loc: startLoc
              };
            }
            case 85:
            case 86: {
              const literal = this.parseBooleanLiteral(this.match(85));
              if (endOfInit()) {
                return {
                  type: "boolean",
                  loc: literal.loc.start,
                  value: literal
                };
              }
              return {
                type: "invalid",
                loc: startLoc
              };
            }
            default:
              return {
                type: "invalid",
                loc: startLoc
              };
          }
        }
        flowEnumMemberRaw() {
          const loc = this.state.startLoc;
          const id = this.parseIdentifier(true);
          const init = this.eat(29) ? this.flowEnumMemberInit() : {
            type: "none",
            loc
          };
          return {
            id,
            init
          };
        }
        flowEnumCheckExplicitTypeMismatch(loc, context, expectedType) {
          const {
            explicitType
          } = context;
          if (explicitType === null) {
            return;
          }
          if (explicitType !== expectedType) {
            this.flowEnumErrorInvalidMemberInitializer(loc, context);
          }
        }
        flowEnumMembers({
          enumName,
          explicitType
        }) {
          const seenNames = /* @__PURE__ */ new Set();
          const members = {
            booleanMembers: [],
            numberMembers: [],
            stringMembers: [],
            defaultedMembers: []
          };
          let hasUnknownMembers = false;
          while (!this.match(8)) {
            if (this.eat(21)) {
              hasUnknownMembers = true;
              break;
            }
            const memberNode = this.startNode();
            const {
              id,
              init
            } = this.flowEnumMemberRaw();
            const memberName = id.name;
            if (memberName === "") {
              continue;
            }
            if (/^[a-z]/.test(memberName)) {
              this.raise(FlowErrors.EnumInvalidMemberName, id, {
                memberName,
                suggestion: memberName[0].toUpperCase() + memberName.slice(1),
                enumName
              });
            }
            if (seenNames.has(memberName)) {
              this.raise(FlowErrors.EnumDuplicateMemberName, id, {
                memberName,
                enumName
              });
            }
            seenNames.add(memberName);
            const context = {
              enumName,
              explicitType,
              memberName
            };
            memberNode.id = id;
            switch (init.type) {
              case "boolean": {
                this.flowEnumCheckExplicitTypeMismatch(init.loc, context, "boolean");
                memberNode.init = init.value;
                members.booleanMembers.push(this.finishNode(memberNode, "EnumBooleanMember"));
                break;
              }
              case "number": {
                this.flowEnumCheckExplicitTypeMismatch(init.loc, context, "number");
                memberNode.init = init.value;
                members.numberMembers.push(this.finishNode(memberNode, "EnumNumberMember"));
                break;
              }
              case "string": {
                this.flowEnumCheckExplicitTypeMismatch(init.loc, context, "string");
                memberNode.init = init.value;
                members.stringMembers.push(this.finishNode(memberNode, "EnumStringMember"));
                break;
              }
              case "invalid": {
                throw this.flowEnumErrorInvalidMemberInitializer(init.loc, context);
              }
              case "none": {
                switch (explicitType) {
                  case "boolean":
                    this.flowEnumErrorBooleanMemberNotInitialized(init.loc, context);
                    break;
                  case "number":
                    this.flowEnumErrorNumberMemberNotInitialized(init.loc, context);
                    break;
                  default:
                    members.defaultedMembers.push(this.finishNode(memberNode, "EnumDefaultedMember"));
                }
              }
            }
            if (!this.match(8)) {
              this.expect(12);
            }
          }
          return {
            members,
            hasUnknownMembers
          };
        }
        flowEnumStringMembers(initializedMembers, defaultedMembers, {
          enumName
        }) {
          if (initializedMembers.length === 0) {
            return defaultedMembers;
          } else if (defaultedMembers.length === 0) {
            return initializedMembers;
          } else if (defaultedMembers.length > initializedMembers.length) {
            for (const member of initializedMembers) {
              this.flowEnumErrorStringMemberInconsistentlyInitialized(member, {
                enumName
              });
            }
            return defaultedMembers;
          } else {
            for (const member of defaultedMembers) {
              this.flowEnumErrorStringMemberInconsistentlyInitialized(member, {
                enumName
              });
            }
            return initializedMembers;
          }
        }
        flowEnumParseExplicitType({
          enumName
        }) {
          if (!this.eatContextual(102))
            return null;
          if (!tokenIsIdentifier(this.state.type)) {
            throw this.raise(FlowErrors.EnumInvalidExplicitTypeUnknownSupplied, this.state.startLoc, {
              enumName
            });
          }
          const {
            value
          } = this.state;
          this.next();
          if (value !== "boolean" && value !== "number" && value !== "string" && value !== "symbol") {
            this.raise(FlowErrors.EnumInvalidExplicitType, this.state.startLoc, {
              enumName,
              invalidEnumType: value
            });
          }
          return value;
        }
        flowEnumBody(node, id) {
          const enumName = id.name;
          const nameLoc = id.loc.start;
          const explicitType = this.flowEnumParseExplicitType({
            enumName
          });
          this.expect(5);
          const {
            members,
            hasUnknownMembers
          } = this.flowEnumMembers({
            enumName,
            explicitType
          });
          node.hasUnknownMembers = hasUnknownMembers;
          switch (explicitType) {
            case "boolean":
              node.explicitType = true;
              node.members = members.booleanMembers;
              this.expect(8);
              return this.finishNode(node, "EnumBooleanBody");
            case "number":
              node.explicitType = true;
              node.members = members.numberMembers;
              this.expect(8);
              return this.finishNode(node, "EnumNumberBody");
            case "string":
              node.explicitType = true;
              node.members = this.flowEnumStringMembers(members.stringMembers, members.defaultedMembers, {
                enumName
              });
              this.expect(8);
              return this.finishNode(node, "EnumStringBody");
            case "symbol":
              node.members = members.defaultedMembers;
              this.expect(8);
              return this.finishNode(node, "EnumSymbolBody");
            default: {
              const empty = () => {
                node.members = [];
                this.expect(8);
                return this.finishNode(node, "EnumStringBody");
              };
              node.explicitType = false;
              const boolsLen = members.booleanMembers.length;
              const numsLen = members.numberMembers.length;
              const strsLen = members.stringMembers.length;
              const defaultedLen = members.defaultedMembers.length;
              if (!boolsLen && !numsLen && !strsLen && !defaultedLen) {
                return empty();
              } else if (!boolsLen && !numsLen) {
                node.members = this.flowEnumStringMembers(members.stringMembers, members.defaultedMembers, {
                  enumName
                });
                this.expect(8);
                return this.finishNode(node, "EnumStringBody");
              } else if (!numsLen && !strsLen && boolsLen >= defaultedLen) {
                for (const member of members.defaultedMembers) {
                  this.flowEnumErrorBooleanMemberNotInitialized(member.loc.start, {
                    enumName,
                    memberName: member.id.name
                  });
                }
                node.members = members.booleanMembers;
                this.expect(8);
                return this.finishNode(node, "EnumBooleanBody");
              } else if (!boolsLen && !strsLen && numsLen >= defaultedLen) {
                for (const member of members.defaultedMembers) {
                  this.flowEnumErrorNumberMemberNotInitialized(member.loc.start, {
                    enumName,
                    memberName: member.id.name
                  });
                }
                node.members = members.numberMembers;
                this.expect(8);
                return this.finishNode(node, "EnumNumberBody");
              } else {
                this.raise(FlowErrors.EnumInconsistentMemberValues, nameLoc, {
                  enumName
                });
                return empty();
              }
            }
          }
        }
        flowParseEnumDeclaration(node) {
          const id = this.parseIdentifier();
          node.id = id;
          node.body = this.flowEnumBody(this.startNode(), id);
          return this.finishNode(node, "EnumDeclaration");
        }
        jsxParseOpeningElementAfterName(node) {
          if (this.shouldParseTypes()) {
            if (this.match(47) || this.match(51)) {
              node.typeArguments = this.flowParseTypeParameterInstantiationInExpression();
            }
          }
          return super.jsxParseOpeningElementAfterName(node);
        }
        isLookaheadToken_lt() {
          const next = this.nextTokenStart();
          if (this.input.charCodeAt(next) === 60) {
            const afterNext = this.input.charCodeAt(next + 1);
            return afterNext !== 60 && afterNext !== 61;
          }
          return false;
        }
        reScan_lt_gt() {
          const {
            type
          } = this.state;
          if (type === 47) {
            this.state.pos -= 1;
            this.readToken_lt();
          } else if (type === 48) {
            this.state.pos -= 1;
            this.readToken_gt();
          }
        }
        reScan_lt() {
          const {
            type
          } = this.state;
          if (type === 51) {
            this.state.pos -= 2;
            this.finishOp(47, 1);
            return 47;
          }
          return type;
        }
        maybeUnwrapTypeCastExpression(node) {
          return node.type === "TypeCastExpression" ? node.expression : node;
        }
      };
      var entities = {
        __proto__: null,
        quot: '"',
        amp: "&",
        apos: "'",
        lt: "<",
        gt: ">",
        nbsp: "\xA0",
        iexcl: "\xA1",
        cent: "\xA2",
        pound: "\xA3",
        curren: "\xA4",
        yen: "\xA5",
        brvbar: "\xA6",
        sect: "\xA7",
        uml: "\xA8",
        copy: "\xA9",
        ordf: "\xAA",
        laquo: "\xAB",
        not: "\xAC",
        shy: "\xAD",
        reg: "\xAE",
        macr: "\xAF",
        deg: "\xB0",
        plusmn: "\xB1",
        sup2: "\xB2",
        sup3: "\xB3",
        acute: "\xB4",
        micro: "\xB5",
        para: "\xB6",
        middot: "\xB7",
        cedil: "\xB8",
        sup1: "\xB9",
        ordm: "\xBA",
        raquo: "\xBB",
        frac14: "\xBC",
        frac12: "\xBD",
        frac34: "\xBE",
        iquest: "\xBF",
        Agrave: "\xC0",
        Aacute: "\xC1",
        Acirc: "\xC2",
        Atilde: "\xC3",
        Auml: "\xC4",
        Aring: "\xC5",
        AElig: "\xC6",
        Ccedil: "\xC7",
        Egrave: "\xC8",
        Eacute: "\xC9",
        Ecirc: "\xCA",
        Euml: "\xCB",
        Igrave: "\xCC",
        Iacute: "\xCD",
        Icirc: "\xCE",
        Iuml: "\xCF",
        ETH: "\xD0",
        Ntilde: "\xD1",
        Ograve: "\xD2",
        Oacute: "\xD3",
        Ocirc: "\xD4",
        Otilde: "\xD5",
        Ouml: "\xD6",
        times: "\xD7",
        Oslash: "\xD8",
        Ugrave: "\xD9",
        Uacute: "\xDA",
        Ucirc: "\xDB",
        Uuml: "\xDC",
        Yacute: "\xDD",
        THORN: "\xDE",
        szlig: "\xDF",
        agrave: "\xE0",
        aacute: "\xE1",
        acirc: "\xE2",
        atilde: "\xE3",
        auml: "\xE4",
        aring: "\xE5",
        aelig: "\xE6",
        ccedil: "\xE7",
        egrave: "\xE8",
        eacute: "\xE9",
        ecirc: "\xEA",
        euml: "\xEB",
        igrave: "\xEC",
        iacute: "\xED",
        icirc: "\xEE",
        iuml: "\xEF",
        eth: "\xF0",
        ntilde: "\xF1",
        ograve: "\xF2",
        oacute: "\xF3",
        ocirc: "\xF4",
        otilde: "\xF5",
        ouml: "\xF6",
        divide: "\xF7",
        oslash: "\xF8",
        ugrave: "\xF9",
        uacute: "\xFA",
        ucirc: "\xFB",
        uuml: "\xFC",
        yacute: "\xFD",
        thorn: "\xFE",
        yuml: "\xFF",
        OElig: "\u0152",
        oelig: "\u0153",
        Scaron: "\u0160",
        scaron: "\u0161",
        Yuml: "\u0178",
        fnof: "\u0192",
        circ: "\u02C6",
        tilde: "\u02DC",
        Alpha: "\u0391",
        Beta: "\u0392",
        Gamma: "\u0393",
        Delta: "\u0394",
        Epsilon: "\u0395",
        Zeta: "\u0396",
        Eta: "\u0397",
        Theta: "\u0398",
        Iota: "\u0399",
        Kappa: "\u039A",
        Lambda: "\u039B",
        Mu: "\u039C",
        Nu: "\u039D",
        Xi: "\u039E",
        Omicron: "\u039F",
        Pi: "\u03A0",
        Rho: "\u03A1",
        Sigma: "\u03A3",
        Tau: "\u03A4",
        Upsilon: "\u03A5",
        Phi: "\u03A6",
        Chi: "\u03A7",
        Psi: "\u03A8",
        Omega: "\u03A9",
        alpha: "\u03B1",
        beta: "\u03B2",
        gamma: "\u03B3",
        delta: "\u03B4",
        epsilon: "\u03B5",
        zeta: "\u03B6",
        eta: "\u03B7",
        theta: "\u03B8",
        iota: "\u03B9",
        kappa: "\u03BA",
        lambda: "\u03BB",
        mu: "\u03BC",
        nu: "\u03BD",
        xi: "\u03BE",
        omicron: "\u03BF",
        pi: "\u03C0",
        rho: "\u03C1",
        sigmaf: "\u03C2",
        sigma: "\u03C3",
        tau: "\u03C4",
        upsilon: "\u03C5",
        phi: "\u03C6",
        chi: "\u03C7",
        psi: "\u03C8",
        omega: "\u03C9",
        thetasym: "\u03D1",
        upsih: "\u03D2",
        piv: "\u03D6",
        ensp: "\u2002",
        emsp: "\u2003",
        thinsp: "\u2009",
        zwnj: "\u200C",
        zwj: "\u200D",
        lrm: "\u200E",
        rlm: "\u200F",
        ndash: "\u2013",
        mdash: "\u2014",
        lsquo: "\u2018",
        rsquo: "\u2019",
        sbquo: "\u201A",
        ldquo: "\u201C",
        rdquo: "\u201D",
        bdquo: "\u201E",
        dagger: "\u2020",
        Dagger: "\u2021",
        bull: "\u2022",
        hellip: "\u2026",
        permil: "\u2030",
        prime: "\u2032",
        Prime: "\u2033",
        lsaquo: "\u2039",
        rsaquo: "\u203A",
        oline: "\u203E",
        frasl: "\u2044",
        euro: "\u20AC",
        image: "\u2111",
        weierp: "\u2118",
        real: "\u211C",
        trade: "\u2122",
        alefsym: "\u2135",
        larr: "\u2190",
        uarr: "\u2191",
        rarr: "\u2192",
        darr: "\u2193",
        harr: "\u2194",
        crarr: "\u21B5",
        lArr: "\u21D0",
        uArr: "\u21D1",
        rArr: "\u21D2",
        dArr: "\u21D3",
        hArr: "\u21D4",
        forall: "\u2200",
        part: "\u2202",
        exist: "\u2203",
        empty: "\u2205",
        nabla: "\u2207",
        isin: "\u2208",
        notin: "\u2209",
        ni: "\u220B",
        prod: "\u220F",
        sum: "\u2211",
        minus: "\u2212",
        lowast: "\u2217",
        radic: "\u221A",
        prop: "\u221D",
        infin: "\u221E",
        ang: "\u2220",
        and: "\u2227",
        or: "\u2228",
        cap: "\u2229",
        cup: "\u222A",
        int: "\u222B",
        there4: "\u2234",
        sim: "\u223C",
        cong: "\u2245",
        asymp: "\u2248",
        ne: "\u2260",
        equiv: "\u2261",
        le: "\u2264",
        ge: "\u2265",
        sub: "\u2282",
        sup: "\u2283",
        nsub: "\u2284",
        sube: "\u2286",
        supe: "\u2287",
        oplus: "\u2295",
        otimes: "\u2297",
        perp: "\u22A5",
        sdot: "\u22C5",
        lceil: "\u2308",
        rceil: "\u2309",
        lfloor: "\u230A",
        rfloor: "\u230B",
        lang: "\u2329",
        rang: "\u232A",
        loz: "\u25CA",
        spades: "\u2660",
        clubs: "\u2663",
        hearts: "\u2665",
        diams: "\u2666"
      };
      var lineBreak = /\r\n|[\r\n\u2028\u2029]/;
      var lineBreakG = new RegExp(lineBreak.source, "g");
      function isNewLine(code2) {
        switch (code2) {
          case 10:
          case 13:
          case 8232:
          case 8233:
            return true;
          default:
            return false;
        }
      }
      function hasNewLine(input, start, end) {
        for (let i = start; i < end; i++) {
          if (isNewLine(input.charCodeAt(i))) {
            return true;
          }
        }
        return false;
      }
      var skipWhiteSpace = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;
      var skipWhiteSpaceInLine = /(?:[^\S\n\r\u2028\u2029]|\/\/.*|\/\*.*?\*\/)*/g;
      function isWhitespace(code2) {
        switch (code2) {
          case 9:
          case 11:
          case 12:
          case 32:
          case 160:
          case 5760:
          case 8192:
          case 8193:
          case 8194:
          case 8195:
          case 8196:
          case 8197:
          case 8198:
          case 8199:
          case 8200:
          case 8201:
          case 8202:
          case 8239:
          case 8287:
          case 12288:
          case 65279:
            return true;
          default:
            return false;
        }
      }
      var JsxErrors = ParseErrorEnum`jsx`({
        AttributeIsEmpty: "JSX attributes must only be assigned a non-empty expression.",
        MissingClosingTagElement: ({
          openingTagName
        }) => `Expected corresponding JSX closing tag for <${openingTagName}>.`,
        MissingClosingTagFragment: "Expected corresponding JSX closing tag for <>.",
        UnexpectedSequenceExpression: "Sequence expressions cannot be directly nested inside JSX. Did you mean to wrap it in parentheses (...)?",
        UnexpectedToken: ({
          unexpected,
          HTMLEntity
        }) => `Unexpected token \`${unexpected}\`. Did you mean \`${HTMLEntity}\` or \`{'${unexpected}'}\`?`,
        UnsupportedJsxValue: "JSX value should be either an expression or a quoted JSX text.",
        UnterminatedJsxContent: "Unterminated JSX contents.",
        UnwrappedAdjacentJSXElements: "Adjacent JSX elements must be wrapped in an enclosing tag. Did you want a JSX fragment <>...</>?"
      });
      function isFragment(object) {
        return object ? object.type === "JSXOpeningFragment" || object.type === "JSXClosingFragment" : false;
      }
      function getQualifiedJSXName(object) {
        if (object.type === "JSXIdentifier") {
          return object.name;
        }
        if (object.type === "JSXNamespacedName") {
          return object.namespace.name + ":" + object.name.name;
        }
        if (object.type === "JSXMemberExpression") {
          return getQualifiedJSXName(object.object) + "." + getQualifiedJSXName(object.property);
        }
        throw new Error("Node had unexpected type: " + object.type);
      }
      var jsx = (superClass) => class JSXParserMixin extends superClass {
        jsxReadToken() {
          let out = "";
          let chunkStart = this.state.pos;
          for (; ; ) {
            if (this.state.pos >= this.length) {
              throw this.raise(JsxErrors.UnterminatedJsxContent, this.state.startLoc);
            }
            const ch = this.input.charCodeAt(this.state.pos);
            switch (ch) {
              case 60:
              case 123:
                if (this.state.pos === this.state.start) {
                  if (ch === 60 && this.state.canStartJSXElement) {
                    ++this.state.pos;
                    this.finishToken(143);
                  } else {
                    super.getTokenFromCode(ch);
                  }
                  return;
                }
                out += this.input.slice(chunkStart, this.state.pos);
                this.finishToken(142, out);
                return;
              case 38:
                out += this.input.slice(chunkStart, this.state.pos);
                out += this.jsxReadEntity();
                chunkStart = this.state.pos;
                break;
              case 62:
              case 125:
              default:
                if (isNewLine(ch)) {
                  out += this.input.slice(chunkStart, this.state.pos);
                  out += this.jsxReadNewLine(true);
                  chunkStart = this.state.pos;
                } else {
                  ++this.state.pos;
                }
            }
          }
        }
        jsxReadNewLine(normalizeCRLF) {
          const ch = this.input.charCodeAt(this.state.pos);
          let out;
          ++this.state.pos;
          if (ch === 13 && this.input.charCodeAt(this.state.pos) === 10) {
            ++this.state.pos;
            out = normalizeCRLF ? "\n" : "\r\n";
          } else {
            out = String.fromCharCode(ch);
          }
          ++this.state.curLine;
          this.state.lineStart = this.state.pos;
          return out;
        }
        jsxReadString(quote) {
          let out = "";
          let chunkStart = ++this.state.pos;
          for (; ; ) {
            if (this.state.pos >= this.length) {
              throw this.raise(Errors.UnterminatedString, this.state.startLoc);
            }
            const ch = this.input.charCodeAt(this.state.pos);
            if (ch === quote)
              break;
            if (ch === 38) {
              out += this.input.slice(chunkStart, this.state.pos);
              out += this.jsxReadEntity();
              chunkStart = this.state.pos;
            } else if (isNewLine(ch)) {
              out += this.input.slice(chunkStart, this.state.pos);
              out += this.jsxReadNewLine(false);
              chunkStart = this.state.pos;
            } else {
              ++this.state.pos;
            }
          }
          out += this.input.slice(chunkStart, this.state.pos++);
          this.finishToken(134, out);
        }
        jsxReadEntity() {
          const startPos = ++this.state.pos;
          if (this.codePointAtPos(this.state.pos) === 35) {
            ++this.state.pos;
            let radix = 10;
            if (this.codePointAtPos(this.state.pos) === 120) {
              radix = 16;
              ++this.state.pos;
            }
            const codePoint = this.readInt(radix, void 0, false, "bail");
            if (codePoint !== null && this.codePointAtPos(this.state.pos) === 59) {
              ++this.state.pos;
              return String.fromCodePoint(codePoint);
            }
          } else {
            let count = 0;
            let semi = false;
            while (count++ < 10 && this.state.pos < this.length && !(semi = this.codePointAtPos(this.state.pos) === 59)) {
              ++this.state.pos;
            }
            if (semi) {
              const desc = this.input.slice(startPos, this.state.pos);
              const entity = entities[desc];
              ++this.state.pos;
              if (entity) {
                return entity;
              }
            }
          }
          this.state.pos = startPos;
          return "&";
        }
        jsxReadWord() {
          let ch;
          const start = this.state.pos;
          do {
            ch = this.input.charCodeAt(++this.state.pos);
          } while (isIdentifierChar(ch) || ch === 45);
          this.finishToken(141, this.input.slice(start, this.state.pos));
        }
        jsxParseIdentifier() {
          const node = this.startNode();
          if (this.match(141)) {
            node.name = this.state.value;
          } else if (tokenIsKeyword(this.state.type)) {
            node.name = tokenLabelName(this.state.type);
          } else {
            this.unexpected();
          }
          this.next();
          return this.finishNode(node, "JSXIdentifier");
        }
        jsxParseNamespacedName() {
          const startLoc = this.state.startLoc;
          const name = this.jsxParseIdentifier();
          if (!this.eat(14))
            return name;
          const node = this.startNodeAt(startLoc);
          node.namespace = name;
          node.name = this.jsxParseIdentifier();
          return this.finishNode(node, "JSXNamespacedName");
        }
        jsxParseElementName() {
          const startLoc = this.state.startLoc;
          let node = this.jsxParseNamespacedName();
          if (node.type === "JSXNamespacedName") {
            return node;
          }
          while (this.eat(16)) {
            const newNode = this.startNodeAt(startLoc);
            newNode.object = node;
            newNode.property = this.jsxParseIdentifier();
            node = this.finishNode(newNode, "JSXMemberExpression");
          }
          return node;
        }
        jsxParseAttributeValue() {
          let node;
          switch (this.state.type) {
            case 5:
              node = this.startNode();
              this.setContext(types2.brace);
              this.next();
              node = this.jsxParseExpressionContainer(node, types2.j_oTag);
              if (node.expression.type === "JSXEmptyExpression") {
                this.raise(JsxErrors.AttributeIsEmpty, node);
              }
              return node;
            case 143:
            case 134:
              return this.parseExprAtom();
            default:
              throw this.raise(JsxErrors.UnsupportedJsxValue, this.state.startLoc);
          }
        }
        jsxParseEmptyExpression() {
          const node = this.startNodeAt(this.state.lastTokEndLoc);
          return this.finishNodeAt(node, "JSXEmptyExpression", this.state.startLoc);
        }
        jsxParseSpreadChild(node) {
          this.next();
          node.expression = this.parseExpression();
          this.setContext(types2.j_expr);
          this.state.canStartJSXElement = true;
          this.expect(8);
          return this.finishNode(node, "JSXSpreadChild");
        }
        jsxParseExpressionContainer(node, previousContext) {
          if (this.match(8)) {
            node.expression = this.jsxParseEmptyExpression();
          } else {
            const expression = this.parseExpression();
            node.expression = expression;
          }
          this.setContext(previousContext);
          this.state.canStartJSXElement = true;
          this.expect(8);
          return this.finishNode(node, "JSXExpressionContainer");
        }
        jsxParseAttribute() {
          const node = this.startNode();
          if (this.match(5)) {
            this.setContext(types2.brace);
            this.next();
            this.expect(21);
            node.argument = this.parseMaybeAssignAllowIn();
            this.setContext(types2.j_oTag);
            this.state.canStartJSXElement = true;
            this.expect(8);
            return this.finishNode(node, "JSXSpreadAttribute");
          }
          node.name = this.jsxParseNamespacedName();
          node.value = this.eat(29) ? this.jsxParseAttributeValue() : null;
          return this.finishNode(node, "JSXAttribute");
        }
        jsxParseOpeningElementAt(startLoc) {
          const node = this.startNodeAt(startLoc);
          if (this.eat(144)) {
            return this.finishNode(node, "JSXOpeningFragment");
          }
          node.name = this.jsxParseElementName();
          return this.jsxParseOpeningElementAfterName(node);
        }
        jsxParseOpeningElementAfterName(node) {
          const attributes = [];
          while (!this.match(56) && !this.match(144)) {
            attributes.push(this.jsxParseAttribute());
          }
          node.attributes = attributes;
          node.selfClosing = this.eat(56);
          this.expect(144);
          return this.finishNode(node, "JSXOpeningElement");
        }
        jsxParseClosingElementAt(startLoc) {
          const node = this.startNodeAt(startLoc);
          if (this.eat(144)) {
            return this.finishNode(node, "JSXClosingFragment");
          }
          node.name = this.jsxParseElementName();
          this.expect(144);
          return this.finishNode(node, "JSXClosingElement");
        }
        jsxParseElementAt(startLoc) {
          const node = this.startNodeAt(startLoc);
          const children = [];
          const openingElement = this.jsxParseOpeningElementAt(startLoc);
          let closingElement = null;
          if (!openingElement.selfClosing) {
            contents:
              for (; ; ) {
                switch (this.state.type) {
                  case 143:
                    startLoc = this.state.startLoc;
                    this.next();
                    if (this.eat(56)) {
                      closingElement = this.jsxParseClosingElementAt(startLoc);
                      break contents;
                    }
                    children.push(this.jsxParseElementAt(startLoc));
                    break;
                  case 142:
                    children.push(this.parseLiteral(this.state.value, "JSXText"));
                    break;
                  case 5: {
                    const node2 = this.startNode();
                    this.setContext(types2.brace);
                    this.next();
                    if (this.match(21)) {
                      children.push(this.jsxParseSpreadChild(node2));
                    } else {
                      children.push(this.jsxParseExpressionContainer(node2, types2.j_expr));
                    }
                    break;
                  }
                  default:
                    this.unexpected();
                }
              }
            if (isFragment(openingElement) && !isFragment(closingElement) && closingElement !== null) {
              this.raise(JsxErrors.MissingClosingTagFragment, closingElement);
            } else if (!isFragment(openingElement) && isFragment(closingElement)) {
              this.raise(JsxErrors.MissingClosingTagElement, closingElement, {
                openingTagName: getQualifiedJSXName(openingElement.name)
              });
            } else if (!isFragment(openingElement) && !isFragment(closingElement)) {
              if (getQualifiedJSXName(closingElement.name) !== getQualifiedJSXName(openingElement.name)) {
                this.raise(JsxErrors.MissingClosingTagElement, closingElement, {
                  openingTagName: getQualifiedJSXName(openingElement.name)
                });
              }
            }
          }
          if (isFragment(openingElement)) {
            node.openingFragment = openingElement;
            node.closingFragment = closingElement;
          } else {
            node.openingElement = openingElement;
            node.closingElement = closingElement;
          }
          node.children = children;
          if (this.match(47)) {
            throw this.raise(JsxErrors.UnwrappedAdjacentJSXElements, this.state.startLoc);
          }
          return isFragment(openingElement) ? this.finishNode(node, "JSXFragment") : this.finishNode(node, "JSXElement");
        }
        jsxParseElement() {
          const startLoc = this.state.startLoc;
          this.next();
          return this.jsxParseElementAt(startLoc);
        }
        setContext(newContext) {
          const {
            context
          } = this.state;
          context[context.length - 1] = newContext;
        }
        parseExprAtom(refExpressionErrors) {
          if (this.match(143)) {
            return this.jsxParseElement();
          } else if (this.match(47) && this.input.charCodeAt(this.state.pos) !== 33) {
            this.replaceToken(143);
            return this.jsxParseElement();
          } else {
            return super.parseExprAtom(refExpressionErrors);
          }
        }
        skipSpace() {
          const curContext = this.curContext();
          if (!curContext.preserveSpace)
            super.skipSpace();
        }
        getTokenFromCode(code2) {
          const context = this.curContext();
          if (context === types2.j_expr) {
            this.jsxReadToken();
            return;
          }
          if (context === types2.j_oTag || context === types2.j_cTag) {
            if (isIdentifierStart(code2)) {
              this.jsxReadWord();
              return;
            }
            if (code2 === 62) {
              ++this.state.pos;
              this.finishToken(144);
              return;
            }
            if ((code2 === 34 || code2 === 39) && context === types2.j_oTag) {
              this.jsxReadString(code2);
              return;
            }
          }
          if (code2 === 60 && this.state.canStartJSXElement && this.input.charCodeAt(this.state.pos + 1) !== 33) {
            ++this.state.pos;
            this.finishToken(143);
            return;
          }
          super.getTokenFromCode(code2);
        }
        updateContext(prevType) {
          const {
            context,
            type
          } = this.state;
          if (type === 56 && prevType === 143) {
            context.splice(-2, 2, types2.j_cTag);
            this.state.canStartJSXElement = false;
          } else if (type === 143) {
            context.push(types2.j_oTag);
          } else if (type === 144) {
            const out = context[context.length - 1];
            if (out === types2.j_oTag && prevType === 56 || out === types2.j_cTag) {
              context.pop();
              this.state.canStartJSXElement = context[context.length - 1] === types2.j_expr;
            } else {
              this.setContext(types2.j_expr);
              this.state.canStartJSXElement = true;
            }
          } else {
            this.state.canStartJSXElement = tokenComesBeforeExpression(type);
          }
        }
      };
      var TypeScriptScope = class extends Scope2 {
        constructor(...args) {
          super(...args);
          this.tsNames = /* @__PURE__ */ new Map();
        }
      };
      var TypeScriptScopeHandler = class extends ScopeHandler {
        constructor(...args) {
          super(...args);
          this.importsStack = [];
        }
        createScope(flags) {
          this.importsStack.push(/* @__PURE__ */ new Set());
          return new TypeScriptScope(flags);
        }
        enter(flags) {
          if (flags === 1024) {
            this.importsStack.push(/* @__PURE__ */ new Set());
          }
          super.enter(flags);
        }
        exit() {
          const flags = super.exit();
          if (flags === 1024) {
            this.importsStack.pop();
          }
          return flags;
        }
        hasImport(name, allowShadow) {
          const len = this.importsStack.length;
          if (this.importsStack[len - 1].has(name)) {
            return true;
          }
          if (!allowShadow && len > 1) {
            for (let i = 0; i < len - 1; i++) {
              if (this.importsStack[i].has(name))
                return true;
            }
          }
          return false;
        }
        declareName(name, bindingType, loc) {
          if (bindingType & 4096) {
            if (this.hasImport(name, true)) {
              this.parser.raise(Errors.VarRedeclaration, loc, {
                identifierName: name
              });
            }
            this.importsStack[this.importsStack.length - 1].add(name);
            return;
          }
          const scope = this.currentScope();
          let type = scope.tsNames.get(name) || 0;
          if (bindingType & 1024) {
            this.maybeExportDefined(scope, name);
            scope.tsNames.set(name, type | 16);
            return;
          }
          super.declareName(name, bindingType, loc);
          if (bindingType & 2) {
            if (!(bindingType & 1)) {
              this.checkRedeclarationInScope(scope, name, bindingType, loc);
              this.maybeExportDefined(scope, name);
            }
            type = type | 1;
          }
          if (bindingType & 256) {
            type = type | 2;
          }
          if (bindingType & 512) {
            type = type | 4;
          }
          if (bindingType & 128) {
            type = type | 8;
          }
          if (type)
            scope.tsNames.set(name, type);
        }
        isRedeclaredInScope(scope, name, bindingType) {
          const type = scope.tsNames.get(name);
          if ((type & 2) > 0) {
            if (bindingType & 256) {
              const isConst = !!(bindingType & 512);
              const wasConst = (type & 4) > 0;
              return isConst !== wasConst;
            }
            return true;
          }
          if (bindingType & 128 && (type & 8) > 0) {
            if (scope.names.get(name) & 2) {
              return !!(bindingType & 1);
            } else {
              return false;
            }
          }
          if (bindingType & 2 && (type & 1) > 0) {
            return true;
          }
          return super.isRedeclaredInScope(scope, name, bindingType);
        }
        checkLocalExport(id) {
          const {
            name
          } = id;
          if (this.hasImport(name))
            return;
          const len = this.scopeStack.length;
          for (let i = len - 1; i >= 0; i--) {
            const scope = this.scopeStack[i];
            const type = scope.tsNames.get(name);
            if ((type & 1) > 0 || (type & 16) > 0) {
              return;
            }
          }
          super.checkLocalExport(id);
        }
      };
      var ProductionParameterHandler = class {
        constructor() {
          this.stacks = [];
        }
        enter(flags) {
          this.stacks.push(flags);
        }
        exit() {
          this.stacks.pop();
        }
        currentFlags() {
          return this.stacks[this.stacks.length - 1];
        }
        get hasAwait() {
          return (this.currentFlags() & 2) > 0;
        }
        get hasYield() {
          return (this.currentFlags() & 1) > 0;
        }
        get hasReturn() {
          return (this.currentFlags() & 4) > 0;
        }
        get hasIn() {
          return (this.currentFlags() & 8) > 0;
        }
      };
      function functionFlags(isAsync, isGenerator) {
        return (isAsync ? 2 : 0) | (isGenerator ? 1 : 0);
      }
      var BaseParser = class {
        constructor() {
          this.sawUnambiguousESM = false;
          this.ambiguousScriptDifferentAst = false;
        }
        sourceToOffsetPos(sourcePos) {
          return sourcePos + this.startIndex;
        }
        offsetToSourcePos(offsetPos) {
          return offsetPos - this.startIndex;
        }
        hasPlugin(pluginConfig) {
          if (typeof pluginConfig === "string") {
            return this.plugins.has(pluginConfig);
          } else {
            const [pluginName, pluginOptions] = pluginConfig;
            if (!this.hasPlugin(pluginName)) {
              return false;
            }
            const actualOptions = this.plugins.get(pluginName);
            for (const key of Object.keys(pluginOptions)) {
              if ((actualOptions == null ? void 0 : actualOptions[key]) !== pluginOptions[key]) {
                return false;
              }
            }
            return true;
          }
        }
        getPluginOption(plugin, name) {
          var _this$plugins$get;
          return (_this$plugins$get = this.plugins.get(plugin)) == null ? void 0 : _this$plugins$get[name];
        }
      };
      function setTrailingComments(node, comments) {
        if (node.trailingComments === void 0) {
          node.trailingComments = comments;
        } else {
          node.trailingComments.unshift(...comments);
        }
      }
      function setLeadingComments(node, comments) {
        if (node.leadingComments === void 0) {
          node.leadingComments = comments;
        } else {
          node.leadingComments.unshift(...comments);
        }
      }
      function setInnerComments(node, comments) {
        if (node.innerComments === void 0) {
          node.innerComments = comments;
        } else {
          node.innerComments.unshift(...comments);
        }
      }
      function adjustInnerComments(node, elements, commentWS) {
        let lastElement = null;
        let i = elements.length;
        while (lastElement === null && i > 0) {
          lastElement = elements[--i];
        }
        if (lastElement === null || lastElement.start > commentWS.start) {
          setInnerComments(node, commentWS.comments);
        } else {
          setTrailingComments(lastElement, commentWS.comments);
        }
      }
      var CommentsParser = class extends BaseParser {
        addComment(comment) {
          if (this.filename)
            comment.loc.filename = this.filename;
          const {
            commentsLen
          } = this.state;
          if (this.comments.length !== commentsLen) {
            this.comments.length = commentsLen;
          }
          this.comments.push(comment);
          this.state.commentsLen++;
        }
        processComment(node) {
          const {
            commentStack
          } = this.state;
          const commentStackLength = commentStack.length;
          if (commentStackLength === 0)
            return;
          let i = commentStackLength - 1;
          const lastCommentWS = commentStack[i];
          if (lastCommentWS.start === node.end) {
            lastCommentWS.leadingNode = node;
            i--;
          }
          const {
            start: nodeStart
          } = node;
          for (; i >= 0; i--) {
            const commentWS = commentStack[i];
            const commentEnd = commentWS.end;
            if (commentEnd > nodeStart) {
              commentWS.containingNode = node;
              this.finalizeComment(commentWS);
              commentStack.splice(i, 1);
            } else {
              if (commentEnd === nodeStart) {
                commentWS.trailingNode = node;
              }
              break;
            }
          }
        }
        finalizeComment(commentWS) {
          var _node$options;
          const {
            comments
          } = commentWS;
          if (commentWS.leadingNode !== null || commentWS.trailingNode !== null) {
            if (commentWS.leadingNode !== null) {
              setTrailingComments(commentWS.leadingNode, comments);
            }
            if (commentWS.trailingNode !== null) {
              setLeadingComments(commentWS.trailingNode, comments);
            }
          } else {
            const {
              containingNode: node,
              start: commentStart
            } = commentWS;
            if (this.input.charCodeAt(this.offsetToSourcePos(commentStart) - 1) === 44) {
              switch (node.type) {
                case "ObjectExpression":
                case "ObjectPattern":
                case "RecordExpression":
                  adjustInnerComments(node, node.properties, commentWS);
                  break;
                case "CallExpression":
                case "OptionalCallExpression":
                  adjustInnerComments(node, node.arguments, commentWS);
                  break;
                case "ImportExpression":
                  adjustInnerComments(node, [node.source, (_node$options = node.options) != null ? _node$options : null], commentWS);
                  break;
                case "FunctionDeclaration":
                case "FunctionExpression":
                case "ArrowFunctionExpression":
                case "ObjectMethod":
                case "ClassMethod":
                case "ClassPrivateMethod":
                  adjustInnerComments(node, node.params, commentWS);
                  break;
                case "ArrayExpression":
                case "ArrayPattern":
                case "TupleExpression":
                  adjustInnerComments(node, node.elements, commentWS);
                  break;
                case "ExportNamedDeclaration":
                case "ImportDeclaration":
                  adjustInnerComments(node, node.specifiers, commentWS);
                  break;
                case "TSEnumDeclaration":
                  {
                    adjustInnerComments(node, node.members, commentWS);
                  }
                  break;
                case "TSEnumBody":
                  adjustInnerComments(node, node.members, commentWS);
                  break;
                default: {
                  setInnerComments(node, comments);
                }
              }
            } else {
              setInnerComments(node, comments);
            }
          }
        }
        finalizeRemainingComments() {
          const {
            commentStack
          } = this.state;
          for (let i = commentStack.length - 1; i >= 0; i--) {
            this.finalizeComment(commentStack[i]);
          }
          this.state.commentStack = [];
        }
        resetPreviousNodeTrailingComments(node) {
          const {
            commentStack
          } = this.state;
          const {
            length
          } = commentStack;
          if (length === 0)
            return;
          const commentWS = commentStack[length - 1];
          if (commentWS.leadingNode === node) {
            commentWS.leadingNode = null;
          }
        }
        takeSurroundingComments(node, start, end) {
          const {
            commentStack
          } = this.state;
          const commentStackLength = commentStack.length;
          if (commentStackLength === 0)
            return;
          let i = commentStackLength - 1;
          for (; i >= 0; i--) {
            const commentWS = commentStack[i];
            const commentEnd = commentWS.end;
            const commentStart = commentWS.start;
            if (commentStart === end) {
              commentWS.leadingNode = node;
            } else if (commentEnd === start) {
              commentWS.trailingNode = node;
            } else if (commentEnd < start) {
              break;
            }
          }
        }
      };
      var State = class {
        constructor() {
          this.flags = 1024;
          this.startIndex = void 0;
          this.curLine = void 0;
          this.lineStart = void 0;
          this.startLoc = void 0;
          this.endLoc = void 0;
          this.errors = [];
          this.potentialArrowAt = -1;
          this.noArrowAt = [];
          this.noArrowParamsConversionAt = [];
          this.topicContext = {
            maxNumOfResolvableTopics: 0,
            maxTopicIndex: null
          };
          this.labels = [];
          this.commentsLen = 0;
          this.commentStack = [];
          this.pos = 0;
          this.type = 140;
          this.value = null;
          this.start = 0;
          this.end = 0;
          this.lastTokEndLoc = null;
          this.lastTokStartLoc = null;
          this.context = [types2.brace];
          this.firstInvalidTemplateEscapePos = null;
          this.strictErrors = /* @__PURE__ */ new Map();
          this.tokensLength = 0;
        }
        get strict() {
          return (this.flags & 1) > 0;
        }
        set strict(v) {
          if (v)
            this.flags |= 1;
          else
            this.flags &= -2;
        }
        init({
          strictMode,
          sourceType,
          startIndex,
          startLine,
          startColumn
        }) {
          this.strict = strictMode === false ? false : strictMode === true ? true : sourceType === "module";
          this.startIndex = startIndex;
          this.curLine = startLine;
          this.lineStart = -startColumn;
          this.startLoc = this.endLoc = new Position(startLine, startColumn, startIndex);
        }
        get maybeInArrowParameters() {
          return (this.flags & 2) > 0;
        }
        set maybeInArrowParameters(v) {
          if (v)
            this.flags |= 2;
          else
            this.flags &= -3;
        }
        get inType() {
          return (this.flags & 4) > 0;
        }
        set inType(v) {
          if (v)
            this.flags |= 4;
          else
            this.flags &= -5;
        }
        get noAnonFunctionType() {
          return (this.flags & 8) > 0;
        }
        set noAnonFunctionType(v) {
          if (v)
            this.flags |= 8;
          else
            this.flags &= -9;
        }
        get hasFlowComment() {
          return (this.flags & 16) > 0;
        }
        set hasFlowComment(v) {
          if (v)
            this.flags |= 16;
          else
            this.flags &= -17;
        }
        get isAmbientContext() {
          return (this.flags & 32) > 0;
        }
        set isAmbientContext(v) {
          if (v)
            this.flags |= 32;
          else
            this.flags &= -33;
        }
        get inAbstractClass() {
          return (this.flags & 64) > 0;
        }
        set inAbstractClass(v) {
          if (v)
            this.flags |= 64;
          else
            this.flags &= -65;
        }
        get inDisallowConditionalTypesContext() {
          return (this.flags & 128) > 0;
        }
        set inDisallowConditionalTypesContext(v) {
          if (v)
            this.flags |= 128;
          else
            this.flags &= -129;
        }
        get soloAwait() {
          return (this.flags & 256) > 0;
        }
        set soloAwait(v) {
          if (v)
            this.flags |= 256;
          else
            this.flags &= -257;
        }
        get inFSharpPipelineDirectBody() {
          return (this.flags & 512) > 0;
        }
        set inFSharpPipelineDirectBody(v) {
          if (v)
            this.flags |= 512;
          else
            this.flags &= -513;
        }
        get canStartJSXElement() {
          return (this.flags & 1024) > 0;
        }
        set canStartJSXElement(v) {
          if (v)
            this.flags |= 1024;
          else
            this.flags &= -1025;
        }
        get containsEsc() {
          return (this.flags & 2048) > 0;
        }
        set containsEsc(v) {
          if (v)
            this.flags |= 2048;
          else
            this.flags &= -2049;
        }
        get hasTopLevelAwait() {
          return (this.flags & 4096) > 0;
        }
        set hasTopLevelAwait(v) {
          if (v)
            this.flags |= 4096;
          else
            this.flags &= -4097;
        }
        curPosition() {
          return new Position(this.curLine, this.pos - this.lineStart, this.pos + this.startIndex);
        }
        clone() {
          const state = new State();
          state.flags = this.flags;
          state.startIndex = this.startIndex;
          state.curLine = this.curLine;
          state.lineStart = this.lineStart;
          state.startLoc = this.startLoc;
          state.endLoc = this.endLoc;
          state.errors = this.errors.slice();
          state.potentialArrowAt = this.potentialArrowAt;
          state.noArrowAt = this.noArrowAt.slice();
          state.noArrowParamsConversionAt = this.noArrowParamsConversionAt.slice();
          state.topicContext = this.topicContext;
          state.labels = this.labels.slice();
          state.commentsLen = this.commentsLen;
          state.commentStack = this.commentStack.slice();
          state.pos = this.pos;
          state.type = this.type;
          state.value = this.value;
          state.start = this.start;
          state.end = this.end;
          state.lastTokEndLoc = this.lastTokEndLoc;
          state.lastTokStartLoc = this.lastTokStartLoc;
          state.context = this.context.slice();
          state.firstInvalidTemplateEscapePos = this.firstInvalidTemplateEscapePos;
          state.strictErrors = this.strictErrors;
          state.tokensLength = this.tokensLength;
          return state;
        }
      };
      var _isDigit = function isDigit(code2) {
        return code2 >= 48 && code2 <= 57;
      };
      var forbiddenNumericSeparatorSiblings = {
        decBinOct: /* @__PURE__ */ new Set([46, 66, 69, 79, 95, 98, 101, 111]),
        hex: /* @__PURE__ */ new Set([46, 88, 95, 120])
      };
      var isAllowedNumericSeparatorSibling = {
        bin: (ch) => ch === 48 || ch === 49,
        oct: (ch) => ch >= 48 && ch <= 55,
        dec: (ch) => ch >= 48 && ch <= 57,
        hex: (ch) => ch >= 48 && ch <= 57 || ch >= 65 && ch <= 70 || ch >= 97 && ch <= 102
      };
      function readStringContents(type, input, pos, lineStart, curLine, errors) {
        const initialPos = pos;
        const initialLineStart = lineStart;
        const initialCurLine = curLine;
        let out = "";
        let firstInvalidLoc = null;
        let chunkStart = pos;
        const {
          length
        } = input;
        for (; ; ) {
          if (pos >= length) {
            errors.unterminated(initialPos, initialLineStart, initialCurLine);
            out += input.slice(chunkStart, pos);
            break;
          }
          const ch = input.charCodeAt(pos);
          if (isStringEnd(type, ch, input, pos)) {
            out += input.slice(chunkStart, pos);
            break;
          }
          if (ch === 92) {
            out += input.slice(chunkStart, pos);
            const res = readEscapedChar(input, pos, lineStart, curLine, type === "template", errors);
            if (res.ch === null && !firstInvalidLoc) {
              firstInvalidLoc = {
                pos,
                lineStart,
                curLine
              };
            } else {
              out += res.ch;
            }
            ({
              pos,
              lineStart,
              curLine
            } = res);
            chunkStart = pos;
          } else if (ch === 8232 || ch === 8233) {
            ++pos;
            ++curLine;
            lineStart = pos;
          } else if (ch === 10 || ch === 13) {
            if (type === "template") {
              out += input.slice(chunkStart, pos) + "\n";
              ++pos;
              if (ch === 13 && input.charCodeAt(pos) === 10) {
                ++pos;
              }
              ++curLine;
              chunkStart = lineStart = pos;
            } else {
              errors.unterminated(initialPos, initialLineStart, initialCurLine);
            }
          } else {
            ++pos;
          }
        }
        return {
          pos,
          str: out,
          firstInvalidLoc,
          lineStart,
          curLine,
          containsInvalid: !!firstInvalidLoc
        };
      }
      function isStringEnd(type, ch, input, pos) {
        if (type === "template") {
          return ch === 96 || ch === 36 && input.charCodeAt(pos + 1) === 123;
        }
        return ch === (type === "double" ? 34 : 39);
      }
      function readEscapedChar(input, pos, lineStart, curLine, inTemplate, errors) {
        const throwOnInvalid = !inTemplate;
        pos++;
        const res = (ch2) => ({
          pos,
          ch: ch2,
          lineStart,
          curLine
        });
        const ch = input.charCodeAt(pos++);
        switch (ch) {
          case 110:
            return res("\n");
          case 114:
            return res("\r");
          case 120: {
            let code2;
            ({
              code: code2,
              pos
            } = readHexChar(input, pos, lineStart, curLine, 2, false, throwOnInvalid, errors));
            return res(code2 === null ? null : String.fromCharCode(code2));
          }
          case 117: {
            let code2;
            ({
              code: code2,
              pos
            } = readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors));
            return res(code2 === null ? null : String.fromCodePoint(code2));
          }
          case 116:
            return res("	");
          case 98:
            return res("\b");
          case 118:
            return res("\v");
          case 102:
            return res("\f");
          case 13:
            if (input.charCodeAt(pos) === 10) {
              ++pos;
            }
          case 10:
            lineStart = pos;
            ++curLine;
          case 8232:
          case 8233:
            return res("");
          case 56:
          case 57:
            if (inTemplate) {
              return res(null);
            } else {
              errors.strictNumericEscape(pos - 1, lineStart, curLine);
            }
          default:
            if (ch >= 48 && ch <= 55) {
              const startPos = pos - 1;
              const match = /^[0-7]+/.exec(input.slice(startPos, pos + 2));
              let octalStr = match[0];
              let octal = parseInt(octalStr, 8);
              if (octal > 255) {
                octalStr = octalStr.slice(0, -1);
                octal = parseInt(octalStr, 8);
              }
              pos += octalStr.length - 1;
              const next = input.charCodeAt(pos);
              if (octalStr !== "0" || next === 56 || next === 57) {
                if (inTemplate) {
                  return res(null);
                } else {
                  errors.strictNumericEscape(startPos, lineStart, curLine);
                }
              }
              return res(String.fromCharCode(octal));
            }
            return res(String.fromCharCode(ch));
        }
      }
      function readHexChar(input, pos, lineStart, curLine, len, forceLen, throwOnInvalid, errors) {
        const initialPos = pos;
        let n;
        ({
          n,
          pos
        } = readInt(input, pos, lineStart, curLine, 16, len, forceLen, false, errors, !throwOnInvalid));
        if (n === null) {
          if (throwOnInvalid) {
            errors.invalidEscapeSequence(initialPos, lineStart, curLine);
          } else {
            pos = initialPos - 1;
          }
        }
        return {
          code: n,
          pos
        };
      }
      function readInt(input, pos, lineStart, curLine, radix, len, forceLen, allowNumSeparator, errors, bailOnError) {
        const start = pos;
        const forbiddenSiblings = radix === 16 ? forbiddenNumericSeparatorSiblings.hex : forbiddenNumericSeparatorSiblings.decBinOct;
        const isAllowedSibling = radix === 16 ? isAllowedNumericSeparatorSibling.hex : radix === 10 ? isAllowedNumericSeparatorSibling.dec : radix === 8 ? isAllowedNumericSeparatorSibling.oct : isAllowedNumericSeparatorSibling.bin;
        let invalid = false;
        let total = 0;
        for (let i = 0, e = len == null ? Infinity : len; i < e; ++i) {
          const code2 = input.charCodeAt(pos);
          let val;
          if (code2 === 95 && allowNumSeparator !== "bail") {
            const prev = input.charCodeAt(pos - 1);
            const next = input.charCodeAt(pos + 1);
            if (!allowNumSeparator) {
              if (bailOnError)
                return {
                  n: null,
                  pos
                };
              errors.numericSeparatorInEscapeSequence(pos, lineStart, curLine);
            } else if (Number.isNaN(next) || !isAllowedSibling(next) || forbiddenSiblings.has(prev) || forbiddenSiblings.has(next)) {
              if (bailOnError)
                return {
                  n: null,
                  pos
                };
              errors.unexpectedNumericSeparator(pos, lineStart, curLine);
            }
            ++pos;
            continue;
          }
          if (code2 >= 97) {
            val = code2 - 97 + 10;
          } else if (code2 >= 65) {
            val = code2 - 65 + 10;
          } else if (_isDigit(code2)) {
            val = code2 - 48;
          } else {
            val = Infinity;
          }
          if (val >= radix) {
            if (val <= 9 && bailOnError) {
              return {
                n: null,
                pos
              };
            } else if (val <= 9 && errors.invalidDigit(pos, lineStart, curLine, radix)) {
              val = 0;
            } else if (forceLen) {
              val = 0;
              invalid = true;
            } else {
              break;
            }
          }
          ++pos;
          total = total * radix + val;
        }
        if (pos === start || len != null && pos - start !== len || invalid) {
          return {
            n: null,
            pos
          };
        }
        return {
          n: total,
          pos
        };
      }
      function readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors) {
        const ch = input.charCodeAt(pos);
        let code2;
        if (ch === 123) {
          ++pos;
          ({
            code: code2,
            pos
          } = readHexChar(input, pos, lineStart, curLine, input.indexOf("}", pos) - pos, true, throwOnInvalid, errors));
          ++pos;
          if (code2 !== null && code2 > 1114111) {
            if (throwOnInvalid) {
              errors.invalidCodePoint(pos, lineStart, curLine);
            } else {
              return {
                code: null,
                pos
              };
            }
          }
        } else {
          ({
            code: code2,
            pos
          } = readHexChar(input, pos, lineStart, curLine, 4, false, throwOnInvalid, errors));
        }
        return {
          code: code2,
          pos
        };
      }
      function buildPosition(pos, lineStart, curLine) {
        return new Position(curLine, pos - lineStart, pos);
      }
      var VALID_REGEX_FLAGS = /* @__PURE__ */ new Set([103, 109, 115, 105, 121, 117, 100, 118]);
      var Token = class {
        constructor(state) {
          const startIndex = state.startIndex || 0;
          this.type = state.type;
          this.value = state.value;
          this.start = startIndex + state.start;
          this.end = startIndex + state.end;
          this.loc = new SourceLocation(state.startLoc, state.endLoc);
        }
      };
      var Tokenizer = class extends CommentsParser {
        constructor(options, input) {
          super();
          this.isLookahead = void 0;
          this.tokens = [];
          this.errorHandlers_readInt = {
            invalidDigit: (pos, lineStart, curLine, radix) => {
              if (!(this.optionFlags & 2048))
                return false;
              this.raise(Errors.InvalidDigit, buildPosition(pos, lineStart, curLine), {
                radix
              });
              return true;
            },
            numericSeparatorInEscapeSequence: this.errorBuilder(Errors.NumericSeparatorInEscapeSequence),
            unexpectedNumericSeparator: this.errorBuilder(Errors.UnexpectedNumericSeparator)
          };
          this.errorHandlers_readCodePoint = Object.assign({}, this.errorHandlers_readInt, {
            invalidEscapeSequence: this.errorBuilder(Errors.InvalidEscapeSequence),
            invalidCodePoint: this.errorBuilder(Errors.InvalidCodePoint)
          });
          this.errorHandlers_readStringContents_string = Object.assign({}, this.errorHandlers_readCodePoint, {
            strictNumericEscape: (pos, lineStart, curLine) => {
              this.recordStrictModeErrors(Errors.StrictNumericEscape, buildPosition(pos, lineStart, curLine));
            },
            unterminated: (pos, lineStart, curLine) => {
              throw this.raise(Errors.UnterminatedString, buildPosition(pos - 1, lineStart, curLine));
            }
          });
          this.errorHandlers_readStringContents_template = Object.assign({}, this.errorHandlers_readCodePoint, {
            strictNumericEscape: this.errorBuilder(Errors.StrictNumericEscape),
            unterminated: (pos, lineStart, curLine) => {
              throw this.raise(Errors.UnterminatedTemplate, buildPosition(pos, lineStart, curLine));
            }
          });
          this.state = new State();
          this.state.init(options);
          this.input = input;
          this.length = input.length;
          this.comments = [];
          this.isLookahead = false;
        }
        pushToken(token) {
          this.tokens.length = this.state.tokensLength;
          this.tokens.push(token);
          ++this.state.tokensLength;
        }
        next() {
          this.checkKeywordEscapes();
          if (this.optionFlags & 256) {
            this.pushToken(new Token(this.state));
          }
          this.state.lastTokEndLoc = this.state.endLoc;
          this.state.lastTokStartLoc = this.state.startLoc;
          this.nextToken();
        }
        eat(type) {
          if (this.match(type)) {
            this.next();
            return true;
          } else {
            return false;
          }
        }
        match(type) {
          return this.state.type === type;
        }
        createLookaheadState(state) {
          return {
            pos: state.pos,
            value: null,
            type: state.type,
            start: state.start,
            end: state.end,
            context: [this.curContext()],
            inType: state.inType,
            startLoc: state.startLoc,
            lastTokEndLoc: state.lastTokEndLoc,
            curLine: state.curLine,
            lineStart: state.lineStart,
            curPosition: state.curPosition
          };
        }
        lookahead() {
          const old = this.state;
          this.state = this.createLookaheadState(old);
          this.isLookahead = true;
          this.nextToken();
          this.isLookahead = false;
          const curr = this.state;
          this.state = old;
          return curr;
        }
        nextTokenStart() {
          return this.nextTokenStartSince(this.state.pos);
        }
        nextTokenStartSince(pos) {
          skipWhiteSpace.lastIndex = pos;
          return skipWhiteSpace.test(this.input) ? skipWhiteSpace.lastIndex : pos;
        }
        lookaheadCharCode() {
          return this.lookaheadCharCodeSince(this.state.pos);
        }
        lookaheadCharCodeSince(pos) {
          return this.input.charCodeAt(this.nextTokenStartSince(pos));
        }
        nextTokenInLineStart() {
          return this.nextTokenInLineStartSince(this.state.pos);
        }
        nextTokenInLineStartSince(pos) {
          skipWhiteSpaceInLine.lastIndex = pos;
          return skipWhiteSpaceInLine.test(this.input) ? skipWhiteSpaceInLine.lastIndex : pos;
        }
        lookaheadInLineCharCode() {
          return this.input.charCodeAt(this.nextTokenInLineStart());
        }
        codePointAtPos(pos) {
          let cp = this.input.charCodeAt(pos);
          if ((cp & 64512) === 55296 && ++pos < this.input.length) {
            const trail = this.input.charCodeAt(pos);
            if ((trail & 64512) === 56320) {
              cp = 65536 + ((cp & 1023) << 10) + (trail & 1023);
            }
          }
          return cp;
        }
        setStrict(strict) {
          this.state.strict = strict;
          if (strict) {
            this.state.strictErrors.forEach(([toParseError, at2]) => this.raise(toParseError, at2));
            this.state.strictErrors.clear();
          }
        }
        curContext() {
          return this.state.context[this.state.context.length - 1];
        }
        nextToken() {
          this.skipSpace();
          this.state.start = this.state.pos;
          if (!this.isLookahead)
            this.state.startLoc = this.state.curPosition();
          if (this.state.pos >= this.length) {
            this.finishToken(140);
            return;
          }
          this.getTokenFromCode(this.codePointAtPos(this.state.pos));
        }
        skipBlockComment(commentEnd) {
          let startLoc;
          if (!this.isLookahead)
            startLoc = this.state.curPosition();
          const start = this.state.pos;
          const end = this.input.indexOf(commentEnd, start + 2);
          if (end === -1) {
            throw this.raise(Errors.UnterminatedComment, this.state.curPosition());
          }
          this.state.pos = end + commentEnd.length;
          lineBreakG.lastIndex = start + 2;
          while (lineBreakG.test(this.input) && lineBreakG.lastIndex <= end) {
            ++this.state.curLine;
            this.state.lineStart = lineBreakG.lastIndex;
          }
          if (this.isLookahead)
            return;
          const comment = {
            type: "CommentBlock",
            value: this.input.slice(start + 2, end),
            start: this.sourceToOffsetPos(start),
            end: this.sourceToOffsetPos(end + commentEnd.length),
            loc: new SourceLocation(startLoc, this.state.curPosition())
          };
          if (this.optionFlags & 256)
            this.pushToken(comment);
          return comment;
        }
        skipLineComment(startSkip) {
          const start = this.state.pos;
          let startLoc;
          if (!this.isLookahead)
            startLoc = this.state.curPosition();
          let ch = this.input.charCodeAt(this.state.pos += startSkip);
          if (this.state.pos < this.length) {
            while (!isNewLine(ch) && ++this.state.pos < this.length) {
              ch = this.input.charCodeAt(this.state.pos);
            }
          }
          if (this.isLookahead)
            return;
          const end = this.state.pos;
          const value = this.input.slice(start + startSkip, end);
          const comment = {
            type: "CommentLine",
            value,
            start: this.sourceToOffsetPos(start),
            end: this.sourceToOffsetPos(end),
            loc: new SourceLocation(startLoc, this.state.curPosition())
          };
          if (this.optionFlags & 256)
            this.pushToken(comment);
          return comment;
        }
        skipSpace() {
          const spaceStart = this.state.pos;
          const comments = this.optionFlags & 4096 ? [] : null;
          loop:
            while (this.state.pos < this.length) {
              const ch = this.input.charCodeAt(this.state.pos);
              switch (ch) {
                case 32:
                case 160:
                case 9:
                  ++this.state.pos;
                  break;
                case 13:
                  if (this.input.charCodeAt(this.state.pos + 1) === 10) {
                    ++this.state.pos;
                  }
                case 10:
                case 8232:
                case 8233:
                  ++this.state.pos;
                  ++this.state.curLine;
                  this.state.lineStart = this.state.pos;
                  break;
                case 47:
                  switch (this.input.charCodeAt(this.state.pos + 1)) {
                    case 42: {
                      const comment = this.skipBlockComment("*/");
                      if (comment !== void 0) {
                        this.addComment(comment);
                        comments == null || comments.push(comment);
                      }
                      break;
                    }
                    case 47: {
                      const comment = this.skipLineComment(2);
                      if (comment !== void 0) {
                        this.addComment(comment);
                        comments == null || comments.push(comment);
                      }
                      break;
                    }
                    default:
                      break loop;
                  }
                  break;
                default:
                  if (isWhitespace(ch)) {
                    ++this.state.pos;
                  } else if (ch === 45 && !this.inModule && this.optionFlags & 8192) {
                    const pos = this.state.pos;
                    if (this.input.charCodeAt(pos + 1) === 45 && this.input.charCodeAt(pos + 2) === 62 && (spaceStart === 0 || this.state.lineStart > spaceStart)) {
                      const comment = this.skipLineComment(3);
                      if (comment !== void 0) {
                        this.addComment(comment);
                        comments == null || comments.push(comment);
                      }
                    } else {
                      break loop;
                    }
                  } else if (ch === 60 && !this.inModule && this.optionFlags & 8192) {
                    const pos = this.state.pos;
                    if (this.input.charCodeAt(pos + 1) === 33 && this.input.charCodeAt(pos + 2) === 45 && this.input.charCodeAt(pos + 3) === 45) {
                      const comment = this.skipLineComment(4);
                      if (comment !== void 0) {
                        this.addComment(comment);
                        comments == null || comments.push(comment);
                      }
                    } else {
                      break loop;
                    }
                  } else {
                    break loop;
                  }
              }
            }
          if ((comments == null ? void 0 : comments.length) > 0) {
            const end = this.state.pos;
            const commentWhitespace = {
              start: this.sourceToOffsetPos(spaceStart),
              end: this.sourceToOffsetPos(end),
              comments,
              leadingNode: null,
              trailingNode: null,
              containingNode: null
            };
            this.state.commentStack.push(commentWhitespace);
          }
        }
        finishToken(type, val) {
          this.state.end = this.state.pos;
          this.state.endLoc = this.state.curPosition();
          const prevType = this.state.type;
          this.state.type = type;
          this.state.value = val;
          if (!this.isLookahead) {
            this.updateContext(prevType);
          }
        }
        replaceToken(type) {
          this.state.type = type;
          this.updateContext();
        }
        readToken_numberSign() {
          if (this.state.pos === 0 && this.readToken_interpreter()) {
            return;
          }
          const nextPos = this.state.pos + 1;
          const next = this.codePointAtPos(nextPos);
          if (next >= 48 && next <= 57) {
            throw this.raise(Errors.UnexpectedDigitAfterHash, this.state.curPosition());
          }
          if (next === 123 || next === 91 && this.hasPlugin("recordAndTuple")) {
            this.expectPlugin("recordAndTuple");
            if (this.getPluginOption("recordAndTuple", "syntaxType") === "bar") {
              throw this.raise(next === 123 ? Errors.RecordExpressionHashIncorrectStartSyntaxType : Errors.TupleExpressionHashIncorrectStartSyntaxType, this.state.curPosition());
            }
            this.state.pos += 2;
            if (next === 123) {
              this.finishToken(7);
            } else {
              this.finishToken(1);
            }
          } else if (isIdentifierStart(next)) {
            ++this.state.pos;
            this.finishToken(139, this.readWord1(next));
          } else if (next === 92) {
            ++this.state.pos;
            this.finishToken(139, this.readWord1());
          } else {
            this.finishOp(27, 1);
          }
        }
        readToken_dot() {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next >= 48 && next <= 57) {
            this.readNumber(true);
            return;
          }
          if (next === 46 && this.input.charCodeAt(this.state.pos + 2) === 46) {
            this.state.pos += 3;
            this.finishToken(21);
          } else {
            ++this.state.pos;
            this.finishToken(16);
          }
        }
        readToken_slash() {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === 61) {
            this.finishOp(31, 2);
          } else {
            this.finishOp(56, 1);
          }
        }
        readToken_interpreter() {
          if (this.state.pos !== 0 || this.length < 2)
            return false;
          let ch = this.input.charCodeAt(this.state.pos + 1);
          if (ch !== 33)
            return false;
          const start = this.state.pos;
          this.state.pos += 1;
          while (!isNewLine(ch) && ++this.state.pos < this.length) {
            ch = this.input.charCodeAt(this.state.pos);
          }
          const value = this.input.slice(start + 2, this.state.pos);
          this.finishToken(28, value);
          return true;
        }
        readToken_mult_modulo(code2) {
          let type = code2 === 42 ? 55 : 54;
          let width = 1;
          let next = this.input.charCodeAt(this.state.pos + 1);
          if (code2 === 42 && next === 42) {
            width++;
            next = this.input.charCodeAt(this.state.pos + 2);
            type = 57;
          }
          if (next === 61 && !this.state.inType) {
            width++;
            type = code2 === 37 ? 33 : 30;
          }
          this.finishOp(type, width);
        }
        readToken_pipe_amp(code2) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === code2) {
            if (this.input.charCodeAt(this.state.pos + 2) === 61) {
              this.finishOp(30, 3);
            } else {
              this.finishOp(code2 === 124 ? 41 : 42, 2);
            }
            return;
          }
          if (code2 === 124) {
            if (next === 62) {
              this.finishOp(39, 2);
              return;
            }
            if (this.hasPlugin("recordAndTuple") && next === 125) {
              if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") {
                throw this.raise(Errors.RecordExpressionBarIncorrectEndSyntaxType, this.state.curPosition());
              }
              this.state.pos += 2;
              this.finishToken(9);
              return;
            }
            if (this.hasPlugin("recordAndTuple") && next === 93) {
              if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") {
                throw this.raise(Errors.TupleExpressionBarIncorrectEndSyntaxType, this.state.curPosition());
              }
              this.state.pos += 2;
              this.finishToken(4);
              return;
            }
          }
          if (next === 61) {
            this.finishOp(30, 2);
            return;
          }
          this.finishOp(code2 === 124 ? 43 : 45, 1);
        }
        readToken_caret() {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === 61 && !this.state.inType) {
            this.finishOp(32, 2);
          } else if (next === 94 && this.hasPlugin(["pipelineOperator", {
            proposal: "hack",
            topicToken: "^^"
          }])) {
            this.finishOp(37, 2);
            const lookaheadCh = this.input.codePointAt(this.state.pos);
            if (lookaheadCh === 94) {
              this.unexpected();
            }
          } else {
            this.finishOp(44, 1);
          }
        }
        readToken_atSign() {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === 64 && this.hasPlugin(["pipelineOperator", {
            proposal: "hack",
            topicToken: "@@"
          }])) {
            this.finishOp(38, 2);
          } else {
            this.finishOp(26, 1);
          }
        }
        readToken_plus_min(code2) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === code2) {
            this.finishOp(34, 2);
            return;
          }
          if (next === 61) {
            this.finishOp(30, 2);
          } else {
            this.finishOp(53, 1);
          }
        }
        readToken_lt() {
          const {
            pos
          } = this.state;
          const next = this.input.charCodeAt(pos + 1);
          if (next === 60) {
            if (this.input.charCodeAt(pos + 2) === 61) {
              this.finishOp(30, 3);
              return;
            }
            this.finishOp(51, 2);
            return;
          }
          if (next === 61) {
            this.finishOp(49, 2);
            return;
          }
          this.finishOp(47, 1);
        }
        readToken_gt() {
          const {
            pos
          } = this.state;
          const next = this.input.charCodeAt(pos + 1);
          if (next === 62) {
            const size2 = this.input.charCodeAt(pos + 2) === 62 ? 3 : 2;
            if (this.input.charCodeAt(pos + size2) === 61) {
              this.finishOp(30, size2 + 1);
              return;
            }
            this.finishOp(52, size2);
            return;
          }
          if (next === 61) {
            this.finishOp(49, 2);
            return;
          }
          this.finishOp(48, 1);
        }
        readToken_eq_excl(code2) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === 61) {
            this.finishOp(46, this.input.charCodeAt(this.state.pos + 2) === 61 ? 3 : 2);
            return;
          }
          if (code2 === 61 && next === 62) {
            this.state.pos += 2;
            this.finishToken(19);
            return;
          }
          this.finishOp(code2 === 61 ? 29 : 35, 1);
        }
        readToken_question() {
          const next = this.input.charCodeAt(this.state.pos + 1);
          const next2 = this.input.charCodeAt(this.state.pos + 2);
          if (next === 63) {
            if (next2 === 61) {
              this.finishOp(30, 3);
            } else {
              this.finishOp(40, 2);
            }
          } else if (next === 46 && !(next2 >= 48 && next2 <= 57)) {
            this.state.pos += 2;
            this.finishToken(18);
          } else {
            ++this.state.pos;
            this.finishToken(17);
          }
        }
        getTokenFromCode(code2) {
          switch (code2) {
            case 46:
              this.readToken_dot();
              return;
            case 40:
              ++this.state.pos;
              this.finishToken(10);
              return;
            case 41:
              ++this.state.pos;
              this.finishToken(11);
              return;
            case 59:
              ++this.state.pos;
              this.finishToken(13);
              return;
            case 44:
              ++this.state.pos;
              this.finishToken(12);
              return;
            case 91:
              if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") {
                  throw this.raise(Errors.TupleExpressionBarIncorrectStartSyntaxType, this.state.curPosition());
                }
                this.state.pos += 2;
                this.finishToken(2);
              } else {
                ++this.state.pos;
                this.finishToken(0);
              }
              return;
            case 93:
              ++this.state.pos;
              this.finishToken(3);
              return;
            case 123:
              if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") {
                  throw this.raise(Errors.RecordExpressionBarIncorrectStartSyntaxType, this.state.curPosition());
                }
                this.state.pos += 2;
                this.finishToken(6);
              } else {
                ++this.state.pos;
                this.finishToken(5);
              }
              return;
            case 125:
              ++this.state.pos;
              this.finishToken(8);
              return;
            case 58:
              if (this.hasPlugin("functionBind") && this.input.charCodeAt(this.state.pos + 1) === 58) {
                this.finishOp(15, 2);
              } else {
                ++this.state.pos;
                this.finishToken(14);
              }
              return;
            case 63:
              this.readToken_question();
              return;
            case 96:
              this.readTemplateToken();
              return;
            case 48: {
              const next = this.input.charCodeAt(this.state.pos + 1);
              if (next === 120 || next === 88) {
                this.readRadixNumber(16);
                return;
              }
              if (next === 111 || next === 79) {
                this.readRadixNumber(8);
                return;
              }
              if (next === 98 || next === 66) {
                this.readRadixNumber(2);
                return;
              }
            }
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
              this.readNumber(false);
              return;
            case 34:
            case 39:
              this.readString(code2);
              return;
            case 47:
              this.readToken_slash();
              return;
            case 37:
            case 42:
              this.readToken_mult_modulo(code2);
              return;
            case 124:
            case 38:
              this.readToken_pipe_amp(code2);
              return;
            case 94:
              this.readToken_caret();
              return;
            case 43:
            case 45:
              this.readToken_plus_min(code2);
              return;
            case 60:
              this.readToken_lt();
              return;
            case 62:
              this.readToken_gt();
              return;
            case 61:
            case 33:
              this.readToken_eq_excl(code2);
              return;
            case 126:
              this.finishOp(36, 1);
              return;
            case 64:
              this.readToken_atSign();
              return;
            case 35:
              this.readToken_numberSign();
              return;
            case 92:
              this.readWord();
              return;
            default:
              if (isIdentifierStart(code2)) {
                this.readWord(code2);
                return;
              }
          }
          throw this.raise(Errors.InvalidOrUnexpectedToken, this.state.curPosition(), {
            unexpected: String.fromCodePoint(code2)
          });
        }
        finishOp(type, size2) {
          const str = this.input.slice(this.state.pos, this.state.pos + size2);
          this.state.pos += size2;
          this.finishToken(type, str);
        }
        readRegexp() {
          const startLoc = this.state.startLoc;
          const start = this.state.start + 1;
          let escaped, inClass;
          let {
            pos
          } = this.state;
          for (; ; ++pos) {
            if (pos >= this.length) {
              throw this.raise(Errors.UnterminatedRegExp, createPositionWithColumnOffset(startLoc, 1));
            }
            const ch = this.input.charCodeAt(pos);
            if (isNewLine(ch)) {
              throw this.raise(Errors.UnterminatedRegExp, createPositionWithColumnOffset(startLoc, 1));
            }
            if (escaped) {
              escaped = false;
            } else {
              if (ch === 91) {
                inClass = true;
              } else if (ch === 93 && inClass) {
                inClass = false;
              } else if (ch === 47 && !inClass) {
                break;
              }
              escaped = ch === 92;
            }
          }
          const content = this.input.slice(start, pos);
          ++pos;
          let mods = "";
          const nextPos = () => createPositionWithColumnOffset(startLoc, pos + 2 - start);
          while (pos < this.length) {
            const cp = this.codePointAtPos(pos);
            const char = String.fromCharCode(cp);
            if (VALID_REGEX_FLAGS.has(cp)) {
              if (cp === 118) {
                if (mods.includes("u")) {
                  this.raise(Errors.IncompatibleRegExpUVFlags, nextPos());
                }
              } else if (cp === 117) {
                if (mods.includes("v")) {
                  this.raise(Errors.IncompatibleRegExpUVFlags, nextPos());
                }
              }
              if (mods.includes(char)) {
                this.raise(Errors.DuplicateRegExpFlags, nextPos());
              }
            } else if (isIdentifierChar(cp) || cp === 92) {
              this.raise(Errors.MalformedRegExpFlags, nextPos());
            } else {
              break;
            }
            ++pos;
            mods += char;
          }
          this.state.pos = pos;
          this.finishToken(138, {
            pattern: content,
            flags: mods
          });
        }
        readInt(radix, len, forceLen = false, allowNumSeparator = true) {
          const {
            n,
            pos
          } = readInt(this.input, this.state.pos, this.state.lineStart, this.state.curLine, radix, len, forceLen, allowNumSeparator, this.errorHandlers_readInt, false);
          this.state.pos = pos;
          return n;
        }
        readRadixNumber(radix) {
          const start = this.state.pos;
          const startLoc = this.state.curPosition();
          let isBigInt = false;
          this.state.pos += 2;
          const val = this.readInt(radix);
          if (val == null) {
            this.raise(Errors.InvalidDigit, createPositionWithColumnOffset(startLoc, 2), {
              radix
            });
          }
          const next = this.input.charCodeAt(this.state.pos);
          if (next === 110) {
            ++this.state.pos;
            isBigInt = true;
          } else if (next === 109) {
            throw this.raise(Errors.InvalidDecimal, startLoc);
          }
          if (isIdentifierStart(this.codePointAtPos(this.state.pos))) {
            throw this.raise(Errors.NumberIdentifier, this.state.curPosition());
          }
          if (isBigInt) {
            const str = this.input.slice(start, this.state.pos).replace(/[_n]/g, "");
            this.finishToken(136, str);
            return;
          }
          this.finishToken(135, val);
        }
        readNumber(startsWithDot) {
          const start = this.state.pos;
          const startLoc = this.state.curPosition();
          let isFloat = false;
          let isBigInt = false;
          let hasExponent = false;
          let isOctal = false;
          if (!startsWithDot && this.readInt(10) === null) {
            this.raise(Errors.InvalidNumber, this.state.curPosition());
          }
          const hasLeadingZero = this.state.pos - start >= 2 && this.input.charCodeAt(start) === 48;
          if (hasLeadingZero) {
            const integer = this.input.slice(start, this.state.pos);
            this.recordStrictModeErrors(Errors.StrictOctalLiteral, startLoc);
            if (!this.state.strict) {
              const underscorePos = integer.indexOf("_");
              if (underscorePos > 0) {
                this.raise(Errors.ZeroDigitNumericSeparator, createPositionWithColumnOffset(startLoc, underscorePos));
              }
            }
            isOctal = hasLeadingZero && !/[89]/.test(integer);
          }
          let next = this.input.charCodeAt(this.state.pos);
          if (next === 46 && !isOctal) {
            ++this.state.pos;
            this.readInt(10);
            isFloat = true;
            next = this.input.charCodeAt(this.state.pos);
          }
          if ((next === 69 || next === 101) && !isOctal) {
            next = this.input.charCodeAt(++this.state.pos);
            if (next === 43 || next === 45) {
              ++this.state.pos;
            }
            if (this.readInt(10) === null) {
              this.raise(Errors.InvalidOrMissingExponent, startLoc);
            }
            isFloat = true;
            hasExponent = true;
            next = this.input.charCodeAt(this.state.pos);
          }
          if (next === 110) {
            if (isFloat || hasLeadingZero) {
              this.raise(Errors.InvalidBigIntLiteral, startLoc);
            }
            ++this.state.pos;
            isBigInt = true;
          }
          if (next === 109) {
            this.expectPlugin("decimal", this.state.curPosition());
            if (hasExponent || hasLeadingZero) {
              this.raise(Errors.InvalidDecimal, startLoc);
            }
            ++this.state.pos;
            var isDecimal = true;
          }
          if (isIdentifierStart(this.codePointAtPos(this.state.pos))) {
            throw this.raise(Errors.NumberIdentifier, this.state.curPosition());
          }
          const str = this.input.slice(start, this.state.pos).replace(/[_mn]/g, "");
          if (isBigInt) {
            this.finishToken(136, str);
            return;
          }
          if (isDecimal) {
            this.finishToken(137, str);
            return;
          }
          const val = isOctal ? parseInt(str, 8) : parseFloat(str);
          this.finishToken(135, val);
        }
        readCodePoint(throwOnInvalid) {
          const {
            code: code2,
            pos
          } = readCodePoint(this.input, this.state.pos, this.state.lineStart, this.state.curLine, throwOnInvalid, this.errorHandlers_readCodePoint);
          this.state.pos = pos;
          return code2;
        }
        readString(quote) {
          const {
            str,
            pos,
            curLine,
            lineStart
          } = readStringContents(quote === 34 ? "double" : "single", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_string);
          this.state.pos = pos + 1;
          this.state.lineStart = lineStart;
          this.state.curLine = curLine;
          this.finishToken(134, str);
        }
        readTemplateContinuation() {
          if (!this.match(8)) {
            this.unexpected(null, 8);
          }
          this.state.pos--;
          this.readTemplateToken();
        }
        readTemplateToken() {
          const opening = this.input[this.state.pos];
          const {
            str,
            firstInvalidLoc,
            pos,
            curLine,
            lineStart
          } = readStringContents("template", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_template);
          this.state.pos = pos + 1;
          this.state.lineStart = lineStart;
          this.state.curLine = curLine;
          if (firstInvalidLoc) {
            this.state.firstInvalidTemplateEscapePos = new Position(firstInvalidLoc.curLine, firstInvalidLoc.pos - firstInvalidLoc.lineStart, this.sourceToOffsetPos(firstInvalidLoc.pos));
          }
          if (this.input.codePointAt(pos) === 96) {
            this.finishToken(24, firstInvalidLoc ? null : opening + str + "`");
          } else {
            this.state.pos++;
            this.finishToken(25, firstInvalidLoc ? null : opening + str + "${");
          }
        }
        recordStrictModeErrors(toParseError, at2) {
          const index = at2.index;
          if (this.state.strict && !this.state.strictErrors.has(index)) {
            this.raise(toParseError, at2);
          } else {
            this.state.strictErrors.set(index, [toParseError, at2]);
          }
        }
        readWord1(firstCode) {
          this.state.containsEsc = false;
          let word = "";
          const start = this.state.pos;
          let chunkStart = this.state.pos;
          if (firstCode !== void 0) {
            this.state.pos += firstCode <= 65535 ? 1 : 2;
          }
          while (this.state.pos < this.length) {
            const ch = this.codePointAtPos(this.state.pos);
            if (isIdentifierChar(ch)) {
              this.state.pos += ch <= 65535 ? 1 : 2;
            } else if (ch === 92) {
              this.state.containsEsc = true;
              word += this.input.slice(chunkStart, this.state.pos);
              const escStart = this.state.curPosition();
              const identifierCheck = this.state.pos === start ? isIdentifierStart : isIdentifierChar;
              if (this.input.charCodeAt(++this.state.pos) !== 117) {
                this.raise(Errors.MissingUnicodeEscape, this.state.curPosition());
                chunkStart = this.state.pos - 1;
                continue;
              }
              ++this.state.pos;
              const esc = this.readCodePoint(true);
              if (esc !== null) {
                if (!identifierCheck(esc)) {
                  this.raise(Errors.EscapedCharNotAnIdentifier, escStart);
                }
                word += String.fromCodePoint(esc);
              }
              chunkStart = this.state.pos;
            } else {
              break;
            }
          }
          return word + this.input.slice(chunkStart, this.state.pos);
        }
        readWord(firstCode) {
          const word = this.readWord1(firstCode);
          const type = keywords$1.get(word);
          if (type !== void 0) {
            this.finishToken(type, tokenLabelName(type));
          } else {
            this.finishToken(132, word);
          }
        }
        checkKeywordEscapes() {
          const {
            type
          } = this.state;
          if (tokenIsKeyword(type) && this.state.containsEsc) {
            this.raise(Errors.InvalidEscapedReservedWord, this.state.startLoc, {
              reservedWord: tokenLabelName(type)
            });
          }
        }
        raise(toParseError, at2, details = {}) {
          const loc = at2 instanceof Position ? at2 : at2.loc.start;
          const error = toParseError(loc, details);
          if (!(this.optionFlags & 2048))
            throw error;
          if (!this.isLookahead)
            this.state.errors.push(error);
          return error;
        }
        raiseOverwrite(toParseError, at2, details = {}) {
          const loc = at2 instanceof Position ? at2 : at2.loc.start;
          const pos = loc.index;
          const errors = this.state.errors;
          for (let i = errors.length - 1; i >= 0; i--) {
            const error = errors[i];
            if (error.loc.index === pos) {
              return errors[i] = toParseError(loc, details);
            }
            if (error.loc.index < pos)
              break;
          }
          return this.raise(toParseError, at2, details);
        }
        updateContext(prevType) {
        }
        unexpected(loc, type) {
          throw this.raise(Errors.UnexpectedToken, loc != null ? loc : this.state.startLoc, {
            expected: type ? tokenLabelName(type) : null
          });
        }
        expectPlugin(pluginName, loc) {
          if (this.hasPlugin(pluginName)) {
            return true;
          }
          throw this.raise(Errors.MissingPlugin, loc != null ? loc : this.state.startLoc, {
            missingPlugin: [pluginName]
          });
        }
        expectOnePlugin(pluginNames) {
          if (!pluginNames.some((name) => this.hasPlugin(name))) {
            throw this.raise(Errors.MissingOneOfPlugins, this.state.startLoc, {
              missingPlugin: pluginNames
            });
          }
        }
        errorBuilder(error) {
          return (pos, lineStart, curLine) => {
            this.raise(error, buildPosition(pos, lineStart, curLine));
          };
        }
      };
      var ClassScope = class {
        constructor() {
          this.privateNames = /* @__PURE__ */ new Set();
          this.loneAccessors = /* @__PURE__ */ new Map();
          this.undefinedPrivateNames = /* @__PURE__ */ new Map();
        }
      };
      var ClassScopeHandler = class {
        constructor(parser3) {
          this.parser = void 0;
          this.stack = [];
          this.undefinedPrivateNames = /* @__PURE__ */ new Map();
          this.parser = parser3;
        }
        current() {
          return this.stack[this.stack.length - 1];
        }
        enter() {
          this.stack.push(new ClassScope());
        }
        exit() {
          const oldClassScope = this.stack.pop();
          const current = this.current();
          for (const [name, loc] of Array.from(oldClassScope.undefinedPrivateNames)) {
            if (current) {
              if (!current.undefinedPrivateNames.has(name)) {
                current.undefinedPrivateNames.set(name, loc);
              }
            } else {
              this.parser.raise(Errors.InvalidPrivateFieldResolution, loc, {
                identifierName: name
              });
            }
          }
        }
        declarePrivateName(name, elementType, loc) {
          const {
            privateNames,
            loneAccessors,
            undefinedPrivateNames
          } = this.current();
          let redefined = privateNames.has(name);
          if (elementType & 3) {
            const accessor = redefined && loneAccessors.get(name);
            if (accessor) {
              const oldStatic = accessor & 4;
              const newStatic = elementType & 4;
              const oldKind = accessor & 3;
              const newKind = elementType & 3;
              redefined = oldKind === newKind || oldStatic !== newStatic;
              if (!redefined)
                loneAccessors.delete(name);
            } else if (!redefined) {
              loneAccessors.set(name, elementType);
            }
          }
          if (redefined) {
            this.parser.raise(Errors.PrivateNameRedeclaration, loc, {
              identifierName: name
            });
          }
          privateNames.add(name);
          undefinedPrivateNames.delete(name);
        }
        usePrivateName(name, loc) {
          let classScope;
          for (classScope of this.stack) {
            if (classScope.privateNames.has(name))
              return;
          }
          if (classScope) {
            classScope.undefinedPrivateNames.set(name, loc);
          } else {
            this.parser.raise(Errors.InvalidPrivateFieldResolution, loc, {
              identifierName: name
            });
          }
        }
      };
      var ExpressionScope = class {
        constructor(type = 0) {
          this.type = type;
        }
        canBeArrowParameterDeclaration() {
          return this.type === 2 || this.type === 1;
        }
        isCertainlyParameterDeclaration() {
          return this.type === 3;
        }
      };
      var ArrowHeadParsingScope = class extends ExpressionScope {
        constructor(type) {
          super(type);
          this.declarationErrors = /* @__PURE__ */ new Map();
        }
        recordDeclarationError(ParsingErrorClass, at2) {
          const index = at2.index;
          this.declarationErrors.set(index, [ParsingErrorClass, at2]);
        }
        clearDeclarationError(index) {
          this.declarationErrors.delete(index);
        }
        iterateErrors(iterator) {
          this.declarationErrors.forEach(iterator);
        }
      };
      var ExpressionScopeHandler = class {
        constructor(parser3) {
          this.parser = void 0;
          this.stack = [new ExpressionScope()];
          this.parser = parser3;
        }
        enter(scope) {
          this.stack.push(scope);
        }
        exit() {
          this.stack.pop();
        }
        recordParameterInitializerError(toParseError, node) {
          const origin = node.loc.start;
          const {
            stack
          } = this;
          let i = stack.length - 1;
          let scope = stack[i];
          while (!scope.isCertainlyParameterDeclaration()) {
            if (scope.canBeArrowParameterDeclaration()) {
              scope.recordDeclarationError(toParseError, origin);
            } else {
              return;
            }
            scope = stack[--i];
          }
          this.parser.raise(toParseError, origin);
        }
        recordArrowParameterBindingError(error, node) {
          const {
            stack
          } = this;
          const scope = stack[stack.length - 1];
          const origin = node.loc.start;
          if (scope.isCertainlyParameterDeclaration()) {
            this.parser.raise(error, origin);
          } else if (scope.canBeArrowParameterDeclaration()) {
            scope.recordDeclarationError(error, origin);
          } else {
            return;
          }
        }
        recordAsyncArrowParametersError(at2) {
          const {
            stack
          } = this;
          let i = stack.length - 1;
          let scope = stack[i];
          while (scope.canBeArrowParameterDeclaration()) {
            if (scope.type === 2) {
              scope.recordDeclarationError(Errors.AwaitBindingIdentifier, at2);
            }
            scope = stack[--i];
          }
        }
        validateAsPattern() {
          const {
            stack
          } = this;
          const currentScope = stack[stack.length - 1];
          if (!currentScope.canBeArrowParameterDeclaration())
            return;
          currentScope.iterateErrors(([toParseError, loc]) => {
            this.parser.raise(toParseError, loc);
            let i = stack.length - 2;
            let scope = stack[i];
            while (scope.canBeArrowParameterDeclaration()) {
              scope.clearDeclarationError(loc.index);
              scope = stack[--i];
            }
          });
        }
      };
      function newParameterDeclarationScope() {
        return new ExpressionScope(3);
      }
      function newArrowHeadScope() {
        return new ArrowHeadParsingScope(1);
      }
      function newAsyncArrowScope() {
        return new ArrowHeadParsingScope(2);
      }
      function newExpressionScope() {
        return new ExpressionScope();
      }
      var UtilParser = class extends Tokenizer {
        addExtra(node, key, value, enumerable = true) {
          if (!node)
            return;
          let {
            extra
          } = node;
          if (extra == null) {
            extra = {};
            node.extra = extra;
          }
          if (enumerable) {
            extra[key] = value;
          } else {
            Object.defineProperty(extra, key, {
              enumerable,
              value
            });
          }
        }
        isContextual(token) {
          return this.state.type === token && !this.state.containsEsc;
        }
        isUnparsedContextual(nameStart, name) {
          if (this.input.startsWith(name, nameStart)) {
            const nextCh = this.input.charCodeAt(nameStart + name.length);
            return !(isIdentifierChar(nextCh) || (nextCh & 64512) === 55296);
          }
          return false;
        }
        isLookaheadContextual(name) {
          const next = this.nextTokenStart();
          return this.isUnparsedContextual(next, name);
        }
        eatContextual(token) {
          if (this.isContextual(token)) {
            this.next();
            return true;
          }
          return false;
        }
        expectContextual(token, toParseError) {
          if (!this.eatContextual(token)) {
            if (toParseError != null) {
              throw this.raise(toParseError, this.state.startLoc);
            }
            this.unexpected(null, token);
          }
        }
        canInsertSemicolon() {
          return this.match(140) || this.match(8) || this.hasPrecedingLineBreak();
        }
        hasPrecedingLineBreak() {
          return hasNewLine(this.input, this.offsetToSourcePos(this.state.lastTokEndLoc.index), this.state.start);
        }
        hasFollowingLineBreak() {
          return hasNewLine(this.input, this.state.end, this.nextTokenStart());
        }
        isLineTerminator() {
          return this.eat(13) || this.canInsertSemicolon();
        }
        semicolon(allowAsi = true) {
          if (allowAsi ? this.isLineTerminator() : this.eat(13))
            return;
          this.raise(Errors.MissingSemicolon, this.state.lastTokEndLoc);
        }
        expect(type, loc) {
          if (!this.eat(type)) {
            this.unexpected(loc, type);
          }
        }
        tryParse(fn, oldState = this.state.clone()) {
          const abortSignal = {
            node: null
          };
          try {
            const node = fn((node2 = null) => {
              abortSignal.node = node2;
              throw abortSignal;
            });
            if (this.state.errors.length > oldState.errors.length) {
              const failState = this.state;
              this.state = oldState;
              this.state.tokensLength = failState.tokensLength;
              return {
                node,
                error: failState.errors[oldState.errors.length],
                thrown: false,
                aborted: false,
                failState
              };
            }
            return {
              node,
              error: null,
              thrown: false,
              aborted: false,
              failState: null
            };
          } catch (error) {
            const failState = this.state;
            this.state = oldState;
            if (error instanceof SyntaxError) {
              return {
                node: null,
                error,
                thrown: true,
                aborted: false,
                failState
              };
            }
            if (error === abortSignal) {
              return {
                node: abortSignal.node,
                error: null,
                thrown: false,
                aborted: true,
                failState
              };
            }
            throw error;
          }
        }
        checkExpressionErrors(refExpressionErrors, andThrow) {
          if (!refExpressionErrors)
            return false;
          const {
            shorthandAssignLoc,
            doubleProtoLoc,
            privateKeyLoc,
            optionalParametersLoc,
            voidPatternLoc
          } = refExpressionErrors;
          const hasErrors = !!shorthandAssignLoc || !!doubleProtoLoc || !!optionalParametersLoc || !!privateKeyLoc || !!voidPatternLoc;
          if (!andThrow) {
            return hasErrors;
          }
          if (shorthandAssignLoc != null) {
            this.raise(Errors.InvalidCoverInitializedName, shorthandAssignLoc);
          }
          if (doubleProtoLoc != null) {
            this.raise(Errors.DuplicateProto, doubleProtoLoc);
          }
          if (privateKeyLoc != null) {
            this.raise(Errors.UnexpectedPrivateField, privateKeyLoc);
          }
          if (optionalParametersLoc != null) {
            this.unexpected(optionalParametersLoc);
          }
          if (voidPatternLoc != null) {
            this.raise(Errors.InvalidCoverDiscardElement, voidPatternLoc);
          }
        }
        isLiteralPropertyName() {
          return tokenIsLiteralPropertyName(this.state.type);
        }
        isPrivateName(node) {
          return node.type === "PrivateName";
        }
        getPrivateNameSV(node) {
          return node.id.name;
        }
        hasPropertyAsPrivateName(node) {
          return (node.type === "MemberExpression" || node.type === "OptionalMemberExpression") && this.isPrivateName(node.property);
        }
        isObjectProperty(node) {
          return node.type === "ObjectProperty";
        }
        isObjectMethod(node) {
          return node.type === "ObjectMethod";
        }
        initializeScopes(inModule = this.options.sourceType === "module") {
          const oldLabels = this.state.labels;
          this.state.labels = [];
          const oldExportedIdentifiers = this.exportedIdentifiers;
          this.exportedIdentifiers = /* @__PURE__ */ new Set();
          const oldInModule = this.inModule;
          this.inModule = inModule;
          const oldScope = this.scope;
          const ScopeHandler2 = this.getScopeHandler();
          this.scope = new ScopeHandler2(this, inModule);
          const oldProdParam = this.prodParam;
          this.prodParam = new ProductionParameterHandler();
          const oldClassScope = this.classScope;
          this.classScope = new ClassScopeHandler(this);
          const oldExpressionScope = this.expressionScope;
          this.expressionScope = new ExpressionScopeHandler(this);
          return () => {
            this.state.labels = oldLabels;
            this.exportedIdentifiers = oldExportedIdentifiers;
            this.inModule = oldInModule;
            this.scope = oldScope;
            this.prodParam = oldProdParam;
            this.classScope = oldClassScope;
            this.expressionScope = oldExpressionScope;
          };
        }
        enterInitialScopes() {
          let paramFlags = 0;
          if (this.inModule || this.optionFlags & 1) {
            paramFlags |= 2;
          }
          if (this.optionFlags & 32) {
            paramFlags |= 1;
          }
          const isCommonJS = !this.inModule && this.options.sourceType === "commonjs";
          if (isCommonJS || this.optionFlags & 2) {
            paramFlags |= 4;
          }
          this.prodParam.enter(paramFlags);
          let scopeFlags = isCommonJS ? 514 : 1;
          if (this.optionFlags & 4) {
            scopeFlags |= 512;
          }
          this.scope.enter(scopeFlags);
        }
        checkDestructuringPrivate(refExpressionErrors) {
          const {
            privateKeyLoc
          } = refExpressionErrors;
          if (privateKeyLoc !== null) {
            this.expectPlugin("destructuringPrivate", privateKeyLoc);
          }
        }
      };
      var ExpressionErrors = class {
        constructor() {
          this.shorthandAssignLoc = null;
          this.doubleProtoLoc = null;
          this.privateKeyLoc = null;
          this.optionalParametersLoc = null;
          this.voidPatternLoc = null;
        }
      };
      var Node2 = class {
        constructor(parser3, pos, loc) {
          this.type = "";
          this.start = pos;
          this.end = 0;
          this.loc = new SourceLocation(loc);
          if ((parser3 == null ? void 0 : parser3.optionFlags) & 128)
            this.range = [pos, 0];
          if (parser3 != null && parser3.filename)
            this.loc.filename = parser3.filename;
        }
      };
      var NodePrototype = Node2.prototype;
      {
        NodePrototype.__clone = function() {
          const newNode = new Node2(void 0, this.start, this.loc.start);
          const keys2 = Object.keys(this);
          for (let i = 0, length = keys2.length; i < length; i++) {
            const key = keys2[i];
            if (key !== "leadingComments" && key !== "trailingComments" && key !== "innerComments") {
              newNode[key] = this[key];
            }
          }
          return newNode;
        };
      }
      var NodeUtils = class extends UtilParser {
        startNode() {
          const loc = this.state.startLoc;
          return new Node2(this, loc.index, loc);
        }
        startNodeAt(loc) {
          return new Node2(this, loc.index, loc);
        }
        startNodeAtNode(type) {
          return this.startNodeAt(type.loc.start);
        }
        finishNode(node, type) {
          return this.finishNodeAt(node, type, this.state.lastTokEndLoc);
        }
        finishNodeAt(node, type, endLoc) {
          node.type = type;
          node.end = endLoc.index;
          node.loc.end = endLoc;
          if (this.optionFlags & 128)
            node.range[1] = endLoc.index;
          if (this.optionFlags & 4096) {
            this.processComment(node);
          }
          return node;
        }
        resetStartLocation(node, startLoc) {
          node.start = startLoc.index;
          node.loc.start = startLoc;
          if (this.optionFlags & 128)
            node.range[0] = startLoc.index;
        }
        resetEndLocation(node, endLoc = this.state.lastTokEndLoc) {
          node.end = endLoc.index;
          node.loc.end = endLoc;
          if (this.optionFlags & 128)
            node.range[1] = endLoc.index;
        }
        resetStartLocationFromNode(node, locationNode) {
          this.resetStartLocation(node, locationNode.loc.start);
        }
        castNodeTo(node, type) {
          node.type = type;
          return node;
        }
        cloneIdentifier(node) {
          const {
            type,
            start,
            end,
            loc,
            range: range2,
            name
          } = node;
          const cloned = Object.create(NodePrototype);
          cloned.type = type;
          cloned.start = start;
          cloned.end = end;
          cloned.loc = loc;
          cloned.range = range2;
          cloned.name = name;
          if (node.extra)
            cloned.extra = node.extra;
          return cloned;
        }
        cloneStringLiteral(node) {
          const {
            type,
            start,
            end,
            loc,
            range: range2,
            extra
          } = node;
          const cloned = Object.create(NodePrototype);
          cloned.type = type;
          cloned.start = start;
          cloned.end = end;
          cloned.loc = loc;
          cloned.range = range2;
          cloned.extra = extra;
          cloned.value = node.value;
          return cloned;
        }
      };
      var unwrapParenthesizedExpression = (node) => {
        return node.type === "ParenthesizedExpression" ? unwrapParenthesizedExpression(node.expression) : node;
      };
      var LValParser = class extends NodeUtils {
        toAssignable(node, isLHS = false) {
          var _node$extra, _node$extra3;
          let parenthesized = void 0;
          if (node.type === "ParenthesizedExpression" || (_node$extra = node.extra) != null && _node$extra.parenthesized) {
            parenthesized = unwrapParenthesizedExpression(node);
            if (isLHS) {
              if (parenthesized.type === "Identifier") {
                this.expressionScope.recordArrowParameterBindingError(Errors.InvalidParenthesizedAssignment, node);
              } else if (parenthesized.type !== "MemberExpression" && !this.isOptionalMemberExpression(parenthesized)) {
                this.raise(Errors.InvalidParenthesizedAssignment, node);
              }
            } else {
              this.raise(Errors.InvalidParenthesizedAssignment, node);
            }
          }
          switch (node.type) {
            case "Identifier":
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
            case "VoidPattern":
              break;
            case "ObjectExpression":
              this.castNodeTo(node, "ObjectPattern");
              for (let i = 0, length = node.properties.length, last2 = length - 1; i < length; i++) {
                var _node$extra2;
                const prop = node.properties[i];
                const isLast = i === last2;
                this.toAssignableObjectExpressionProp(prop, isLast, isLHS);
                if (isLast && prop.type === "RestElement" && (_node$extra2 = node.extra) != null && _node$extra2.trailingCommaLoc) {
                  this.raise(Errors.RestTrailingComma, node.extra.trailingCommaLoc);
                }
              }
              break;
            case "ObjectProperty": {
              const {
                key,
                value
              } = node;
              if (this.isPrivateName(key)) {
                this.classScope.usePrivateName(this.getPrivateNameSV(key), key.loc.start);
              }
              this.toAssignable(value, isLHS);
              break;
            }
            case "SpreadElement": {
              throw new Error("Internal @babel/parser error (this is a bug, please report it). SpreadElement should be converted by .toAssignable's caller.");
            }
            case "ArrayExpression":
              this.castNodeTo(node, "ArrayPattern");
              this.toAssignableList(node.elements, (_node$extra3 = node.extra) == null ? void 0 : _node$extra3.trailingCommaLoc, isLHS);
              break;
            case "AssignmentExpression":
              if (node.operator !== "=") {
                this.raise(Errors.MissingEqInAssignment, node.left.loc.end);
              }
              this.castNodeTo(node, "AssignmentPattern");
              delete node.operator;
              if (node.left.type === "VoidPattern") {
                this.raise(Errors.VoidPatternInitializer, node.left);
              }
              this.toAssignable(node.left, isLHS);
              break;
            case "ParenthesizedExpression":
              this.toAssignable(parenthesized, isLHS);
              break;
          }
        }
        toAssignableObjectExpressionProp(prop, isLast, isLHS) {
          if (prop.type === "ObjectMethod") {
            this.raise(prop.kind === "get" || prop.kind === "set" ? Errors.PatternHasAccessor : Errors.PatternHasMethod, prop.key);
          } else if (prop.type === "SpreadElement") {
            this.castNodeTo(prop, "RestElement");
            const arg = prop.argument;
            this.checkToRestConversion(arg, false);
            this.toAssignable(arg, isLHS);
            if (!isLast) {
              this.raise(Errors.RestTrailingComma, prop);
            }
          } else {
            this.toAssignable(prop, isLHS);
          }
        }
        toAssignableList(exprList, trailingCommaLoc, isLHS) {
          const end = exprList.length - 1;
          for (let i = 0; i <= end; i++) {
            const elt = exprList[i];
            if (!elt)
              continue;
            this.toAssignableListItem(exprList, i, isLHS);
            if (elt.type === "RestElement") {
              if (i < end) {
                this.raise(Errors.RestTrailingComma, elt);
              } else if (trailingCommaLoc) {
                this.raise(Errors.RestTrailingComma, trailingCommaLoc);
              }
            }
          }
        }
        toAssignableListItem(exprList, index, isLHS) {
          const node = exprList[index];
          if (node.type === "SpreadElement") {
            this.castNodeTo(node, "RestElement");
            const arg = node.argument;
            this.checkToRestConversion(arg, true);
            this.toAssignable(arg, isLHS);
          } else {
            this.toAssignable(node, isLHS);
          }
        }
        isAssignable(node, isBinding) {
          switch (node.type) {
            case "Identifier":
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
            case "VoidPattern":
              return true;
            case "ObjectExpression": {
              const last2 = node.properties.length - 1;
              return node.properties.every((prop, i) => {
                return prop.type !== "ObjectMethod" && (i === last2 || prop.type !== "SpreadElement") && this.isAssignable(prop);
              });
            }
            case "ObjectProperty":
              return this.isAssignable(node.value);
            case "SpreadElement":
              return this.isAssignable(node.argument);
            case "ArrayExpression":
              return node.elements.every((element) => element === null || this.isAssignable(element));
            case "AssignmentExpression":
              return node.operator === "=";
            case "ParenthesizedExpression":
              return this.isAssignable(node.expression);
            case "MemberExpression":
            case "OptionalMemberExpression":
              return !isBinding;
            default:
              return false;
          }
        }
        toReferencedList(exprList, isParenthesizedExpr) {
          return exprList;
        }
        toReferencedListDeep(exprList, isParenthesizedExpr) {
          this.toReferencedList(exprList, isParenthesizedExpr);
          for (const expr of exprList) {
            if ((expr == null ? void 0 : expr.type) === "ArrayExpression") {
              this.toReferencedListDeep(expr.elements);
            }
          }
        }
        parseSpread(refExpressionErrors) {
          const node = this.startNode();
          this.next();
          node.argument = this.parseMaybeAssignAllowIn(refExpressionErrors, void 0);
          return this.finishNode(node, "SpreadElement");
        }
        parseRestBinding() {
          const node = this.startNode();
          this.next();
          const argument = this.parseBindingAtom();
          if (argument.type === "VoidPattern") {
            this.raise(Errors.UnexpectedVoidPattern, argument);
          }
          node.argument = argument;
          return this.finishNode(node, "RestElement");
        }
        parseBindingAtom() {
          switch (this.state.type) {
            case 0: {
              const node = this.startNode();
              this.next();
              node.elements = this.parseBindingList(3, 93, 1);
              return this.finishNode(node, "ArrayPattern");
            }
            case 5:
              return this.parseObjectLike(8, true);
            case 88:
              return this.parseVoidPattern(null);
          }
          return this.parseIdentifier();
        }
        parseBindingList(close, closeCharCode, flags) {
          const allowEmpty = flags & 1;
          const elts = [];
          let first = true;
          while (!this.eat(close)) {
            if (first) {
              first = false;
            } else {
              this.expect(12);
            }
            if (allowEmpty && this.match(12)) {
              elts.push(null);
            } else if (this.eat(close)) {
              break;
            } else if (this.match(21)) {
              let rest2 = this.parseRestBinding();
              if (this.hasPlugin("flow") || flags & 2) {
                rest2 = this.parseFunctionParamType(rest2);
              }
              elts.push(rest2);
              if (!this.checkCommaAfterRest(closeCharCode)) {
                this.expect(close);
                break;
              }
            } else {
              const decorators = [];
              if (flags & 2) {
                if (this.match(26) && this.hasPlugin("decorators")) {
                  this.raise(Errors.UnsupportedParameterDecorator, this.state.startLoc);
                }
                while (this.match(26)) {
                  decorators.push(this.parseDecorator());
                }
              }
              elts.push(this.parseBindingElement(flags, decorators));
            }
          }
          return elts;
        }
        parseBindingRestProperty(prop) {
          this.next();
          if (this.hasPlugin("discardBinding") && this.match(88)) {
            prop.argument = this.parseVoidPattern(null);
            this.raise(Errors.UnexpectedVoidPattern, prop.argument);
          } else {
            prop.argument = this.parseIdentifier();
          }
          this.checkCommaAfterRest(125);
          return this.finishNode(prop, "RestElement");
        }
        parseBindingProperty() {
          const {
            type,
            startLoc
          } = this.state;
          if (type === 21) {
            return this.parseBindingRestProperty(this.startNode());
          }
          const prop = this.startNode();
          if (type === 139) {
            this.expectPlugin("destructuringPrivate", startLoc);
            this.classScope.usePrivateName(this.state.value, startLoc);
            prop.key = this.parsePrivateName();
          } else {
            this.parsePropertyName(prop);
          }
          prop.method = false;
          return this.parseObjPropValue(prop, startLoc, false, false, true, false);
        }
        parseBindingElement(flags, decorators) {
          const left = this.parseMaybeDefault();
          if (this.hasPlugin("flow") || flags & 2) {
            this.parseFunctionParamType(left);
          }
          if (decorators.length) {
            left.decorators = decorators;
            this.resetStartLocationFromNode(left, decorators[0]);
          }
          const elt = this.parseMaybeDefault(left.loc.start, left);
          return elt;
        }
        parseFunctionParamType(param) {
          return param;
        }
        parseMaybeDefault(startLoc, left) {
          startLoc != null ? startLoc : startLoc = this.state.startLoc;
          left = left != null ? left : this.parseBindingAtom();
          if (!this.eat(29))
            return left;
          const node = this.startNodeAt(startLoc);
          if (left.type === "VoidPattern") {
            this.raise(Errors.VoidPatternInitializer, left);
          }
          node.left = left;
          node.right = this.parseMaybeAssignAllowIn();
          return this.finishNode(node, "AssignmentPattern");
        }
        isValidLVal(type, isUnparenthesizedInAssign, binding3) {
          switch (type) {
            case "AssignmentPattern":
              return "left";
            case "RestElement":
              return "argument";
            case "ObjectProperty":
              return "value";
            case "ParenthesizedExpression":
              return "expression";
            case "ArrayPattern":
              return "elements";
            case "ObjectPattern":
              return "properties";
            case "VoidPattern":
              return true;
          }
          return false;
        }
        isOptionalMemberExpression(expression) {
          return expression.type === "OptionalMemberExpression";
        }
        checkLVal(expression, ancestor, binding3 = 64, checkClashes = false, strictModeChanged = false, hasParenthesizedAncestor = false) {
          var _expression$extra;
          const type = expression.type;
          if (this.isObjectMethod(expression))
            return;
          const isOptionalMemberExpression = this.isOptionalMemberExpression(expression);
          if (isOptionalMemberExpression || type === "MemberExpression") {
            if (isOptionalMemberExpression) {
              this.expectPlugin("optionalChainingAssign", expression.loc.start);
              if (ancestor.type !== "AssignmentExpression") {
                this.raise(Errors.InvalidLhsOptionalChaining, expression, {
                  ancestor
                });
              }
            }
            if (binding3 !== 64) {
              this.raise(Errors.InvalidPropertyBindingPattern, expression);
            }
            return;
          }
          if (type === "Identifier") {
            this.checkIdentifier(expression, binding3, strictModeChanged);
            const {
              name
            } = expression;
            if (checkClashes) {
              if (checkClashes.has(name)) {
                this.raise(Errors.ParamDupe, expression);
              } else {
                checkClashes.add(name);
              }
            }
            return;
          } else if (type === "VoidPattern" && ancestor.type === "CatchClause") {
            this.raise(Errors.VoidPatternCatchClauseParam, expression);
          }
          const validity = this.isValidLVal(type, !(hasParenthesizedAncestor || (_expression$extra = expression.extra) != null && _expression$extra.parenthesized) && ancestor.type === "AssignmentExpression", binding3);
          if (validity === true)
            return;
          if (validity === false) {
            const ParseErrorClass = binding3 === 64 ? Errors.InvalidLhs : Errors.InvalidLhsBinding;
            this.raise(ParseErrorClass, expression, {
              ancestor
            });
            return;
          }
          let key, isParenthesizedExpression;
          if (typeof validity === "string") {
            key = validity;
            isParenthesizedExpression = type === "ParenthesizedExpression";
          } else {
            [key, isParenthesizedExpression] = validity;
          }
          const nextAncestor = type === "ArrayPattern" || type === "ObjectPattern" ? {
            type
          } : ancestor;
          const val = expression[key];
          if (Array.isArray(val)) {
            for (const child of val) {
              if (child) {
                this.checkLVal(child, nextAncestor, binding3, checkClashes, strictModeChanged, isParenthesizedExpression);
              }
            }
          } else if (val) {
            this.checkLVal(val, nextAncestor, binding3, checkClashes, strictModeChanged, isParenthesizedExpression);
          }
        }
        checkIdentifier(at2, bindingType, strictModeChanged = false) {
          if (this.state.strict && (strictModeChanged ? isStrictBindReservedWord(at2.name, this.inModule) : isStrictBindOnlyReservedWord(at2.name))) {
            if (bindingType === 64) {
              this.raise(Errors.StrictEvalArguments, at2, {
                referenceName: at2.name
              });
            } else {
              this.raise(Errors.StrictEvalArgumentsBinding, at2, {
                bindingName: at2.name
              });
            }
          }
          if (bindingType & 8192 && at2.name === "let") {
            this.raise(Errors.LetInLexicalBinding, at2);
          }
          if (!(bindingType & 64)) {
            this.declareNameFromIdentifier(at2, bindingType);
          }
        }
        declareNameFromIdentifier(identifier3, binding3) {
          this.scope.declareName(identifier3.name, binding3, identifier3.loc.start);
        }
        checkToRestConversion(node, allowPattern) {
          switch (node.type) {
            case "ParenthesizedExpression":
              this.checkToRestConversion(node.expression, allowPattern);
              break;
            case "Identifier":
            case "MemberExpression":
              break;
            case "ArrayExpression":
            case "ObjectExpression":
              if (allowPattern)
                break;
            default:
              this.raise(Errors.InvalidRestAssignmentPattern, node);
          }
        }
        checkCommaAfterRest(close) {
          if (!this.match(12)) {
            return false;
          }
          this.raise(this.lookaheadCharCode() === close ? Errors.RestTrailingComma : Errors.ElementAfterRest, this.state.startLoc);
          return true;
        }
      };
      function nonNull(x) {
        if (x == null) {
          throw new Error(`Unexpected ${x} value.`);
        }
        return x;
      }
      function assert3(x) {
        if (!x) {
          throw new Error("Assert fail");
        }
      }
      var TSErrors = ParseErrorEnum`typescript`({
        AbstractMethodHasImplementation: ({
          methodName
        }) => `Method '${methodName}' cannot have an implementation because it is marked abstract.`,
        AbstractPropertyHasInitializer: ({
          propertyName
        }) => `Property '${propertyName}' cannot have an initializer because it is marked abstract.`,
        AccessorCannotBeOptional: "An 'accessor' property cannot be declared optional.",
        AccessorCannotDeclareThisParameter: "'get' and 'set' accessors cannot declare 'this' parameters.",
        AccessorCannotHaveTypeParameters: "An accessor cannot have type parameters.",
        ClassMethodHasDeclare: "Class methods cannot have the 'declare' modifier.",
        ClassMethodHasReadonly: "Class methods cannot have the 'readonly' modifier.",
        ConstInitializerMustBeStringOrNumericLiteralOrLiteralEnumReference: "A 'const' initializer in an ambient context must be a string or numeric literal or literal enum reference.",
        ConstructorHasTypeParameters: "Type parameters cannot appear on a constructor declaration.",
        DeclareAccessor: ({
          kind
        }) => `'declare' is not allowed in ${kind}ters.`,
        DeclareClassFieldHasInitializer: "Initializers are not allowed in ambient contexts.",
        DeclareFunctionHasImplementation: "An implementation cannot be declared in ambient contexts.",
        DuplicateAccessibilityModifier: ({
          modifier
        }) => `Accessibility modifier already seen: '${modifier}'.`,
        DuplicateModifier: ({
          modifier
        }) => `Duplicate modifier: '${modifier}'.`,
        EmptyHeritageClauseType: ({
          token
        }) => `'${token}' list cannot be empty.`,
        EmptyTypeArguments: "Type argument list cannot be empty.",
        EmptyTypeParameters: "Type parameter list cannot be empty.",
        ExpectedAmbientAfterExportDeclare: "'export declare' must be followed by an ambient declaration.",
        ImportAliasHasImportType: "An import alias can not use 'import type'.",
        ImportReflectionHasImportType: "An `import module` declaration can not use `type` modifier",
        IncompatibleModifiers: ({
          modifiers
        }) => `'${modifiers[0]}' modifier cannot be used with '${modifiers[1]}' modifier.`,
        IndexSignatureHasAbstract: "Index signatures cannot have the 'abstract' modifier.",
        IndexSignatureHasAccessibility: ({
          modifier
        }) => `Index signatures cannot have an accessibility modifier ('${modifier}').`,
        IndexSignatureHasDeclare: "Index signatures cannot have the 'declare' modifier.",
        IndexSignatureHasOverride: "'override' modifier cannot appear on an index signature.",
        IndexSignatureHasStatic: "Index signatures cannot have the 'static' modifier.",
        InitializerNotAllowedInAmbientContext: "Initializers are not allowed in ambient contexts.",
        InvalidHeritageClauseType: ({
          token
        }) => `'${token}' list can only include identifiers or qualified-names with optional type arguments.`,
        InvalidModifierOnAwaitUsingDeclaration: (modifier) => `'${modifier}' modifier cannot appear on an await using declaration.`,
        InvalidModifierOnTypeMember: ({
          modifier
        }) => `'${modifier}' modifier cannot appear on a type member.`,
        InvalidModifierOnTypeParameter: ({
          modifier
        }) => `'${modifier}' modifier cannot appear on a type parameter.`,
        InvalidModifierOnTypeParameterPositions: ({
          modifier
        }) => `'${modifier}' modifier can only appear on a type parameter of a class, interface or type alias.`,
        InvalidModifierOnUsingDeclaration: (modifier) => `'${modifier}' modifier cannot appear on a using declaration.`,
        InvalidModifiersOrder: ({
          orderedModifiers
        }) => `'${orderedModifiers[0]}' modifier must precede '${orderedModifiers[1]}' modifier.`,
        InvalidPropertyAccessAfterInstantiationExpression: "Invalid property access after an instantiation expression. You can either wrap the instantiation expression in parentheses, or delete the type arguments.",
        InvalidTupleMemberLabel: "Tuple members must be labeled with a simple identifier.",
        MissingInterfaceName: "'interface' declarations must be followed by an identifier.",
        NonAbstractClassHasAbstractMethod: "Abstract methods can only appear within an abstract class.",
        NonClassMethodPropertyHasAbstractModifier: "'abstract' modifier can only appear on a class, method, or property declaration.",
        OptionalTypeBeforeRequired: "A required element cannot follow an optional element.",
        OverrideNotInSubClass: "This member cannot have an 'override' modifier because its containing class does not extend another class.",
        PatternIsOptional: "A binding pattern parameter cannot be optional in an implementation signature.",
        PrivateElementHasAbstract: "Private elements cannot have the 'abstract' modifier.",
        PrivateElementHasAccessibility: ({
          modifier
        }) => `Private elements cannot have an accessibility modifier ('${modifier}').`,
        ReadonlyForMethodSignature: "'readonly' modifier can only appear on a property declaration or index signature.",
        ReservedArrowTypeParam: "This syntax is reserved in files with the .mts or .cts extension. Add a trailing comma, as in `<T,>() => ...`.",
        ReservedTypeAssertion: "This syntax is reserved in files with the .mts or .cts extension. Use an `as` expression instead.",
        SetAccessorCannotHaveOptionalParameter: "A 'set' accessor cannot have an optional parameter.",
        SetAccessorCannotHaveRestParameter: "A 'set' accessor cannot have rest parameter.",
        SetAccessorCannotHaveReturnType: "A 'set' accessor cannot have a return type annotation.",
        SingleTypeParameterWithoutTrailingComma: ({
          typeParameterName
        }) => `Single type parameter ${typeParameterName} should have a trailing comma. Example usage: <${typeParameterName},>.`,
        StaticBlockCannotHaveModifier: "Static class blocks cannot have any modifier.",
        TupleOptionalAfterType: "A labeled tuple optional element must be declared using a question mark after the name and before the colon (`name?: type`), rather than after the type (`name: type?`).",
        TypeAnnotationAfterAssign: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.",
        TypeImportCannotSpecifyDefaultAndNamed: "A type-only import can specify a default import or named bindings, but not both.",
        TypeModifierIsUsedInTypeExports: "The 'type' modifier cannot be used on a named export when 'export type' is used on its export statement.",
        TypeModifierIsUsedInTypeImports: "The 'type' modifier cannot be used on a named import when 'import type' is used on its import statement.",
        UnexpectedParameterModifier: "A parameter property is only allowed in a constructor implementation.",
        UnexpectedReadonly: "'readonly' type modifier is only permitted on array and tuple literal types.",
        UnexpectedTypeAnnotation: "Did not expect a type annotation here.",
        UnexpectedTypeCastInParameter: "Unexpected type cast in parameter position.",
        UnsupportedImportTypeArgument: "Argument in a type import must be a string literal.",
        UnsupportedParameterPropertyKind: "A parameter property may not be declared using a binding pattern.",
        UnsupportedSignatureParameterKind: ({
          type
        }) => `Name in a signature must be an Identifier, ObjectPattern or ArrayPattern, instead got ${type}.`,
        UsingDeclarationInAmbientContext: (kind) => `'${kind}' declarations are not allowed in ambient contexts.`
      });
      function keywordTypeFromName(value) {
        switch (value) {
          case "any":
            return "TSAnyKeyword";
          case "boolean":
            return "TSBooleanKeyword";
          case "bigint":
            return "TSBigIntKeyword";
          case "never":
            return "TSNeverKeyword";
          case "number":
            return "TSNumberKeyword";
          case "object":
            return "TSObjectKeyword";
          case "string":
            return "TSStringKeyword";
          case "symbol":
            return "TSSymbolKeyword";
          case "undefined":
            return "TSUndefinedKeyword";
          case "unknown":
            return "TSUnknownKeyword";
          default:
            return void 0;
        }
      }
      function tsIsAccessModifier(modifier) {
        return modifier === "private" || modifier === "public" || modifier === "protected";
      }
      function tsIsVarianceAnnotations(modifier) {
        return modifier === "in" || modifier === "out";
      }
      var typescript = (superClass) => class TypeScriptParserMixin extends superClass {
        constructor(...args) {
          super(...args);
          this.tsParseInOutModifiers = this.tsParseModifiers.bind(this, {
            allowedModifiers: ["in", "out"],
            disallowedModifiers: ["const", "public", "private", "protected", "readonly", "declare", "abstract", "override"],
            errorTemplate: TSErrors.InvalidModifierOnTypeParameter
          });
          this.tsParseConstModifier = this.tsParseModifiers.bind(this, {
            allowedModifiers: ["const"],
            disallowedModifiers: ["in", "out"],
            errorTemplate: TSErrors.InvalidModifierOnTypeParameterPositions
          });
          this.tsParseInOutConstModifiers = this.tsParseModifiers.bind(this, {
            allowedModifiers: ["in", "out", "const"],
            disallowedModifiers: ["public", "private", "protected", "readonly", "declare", "abstract", "override"],
            errorTemplate: TSErrors.InvalidModifierOnTypeParameter
          });
        }
        getScopeHandler() {
          return TypeScriptScopeHandler;
        }
        tsIsIdentifier() {
          return tokenIsIdentifier(this.state.type);
        }
        tsTokenCanFollowModifier() {
          return this.match(0) || this.match(5) || this.match(55) || this.match(21) || this.match(139) || this.isLiteralPropertyName();
        }
        tsNextTokenOnSameLineAndCanFollowModifier() {
          this.next();
          if (this.hasPrecedingLineBreak()) {
            return false;
          }
          return this.tsTokenCanFollowModifier();
        }
        tsNextTokenCanFollowModifier() {
          if (this.match(106)) {
            this.next();
            return this.tsTokenCanFollowModifier();
          }
          return this.tsNextTokenOnSameLineAndCanFollowModifier();
        }
        tsParseModifier(allowedModifiers, stopOnStartOfClassStaticBlock, hasSeenStaticModifier) {
          if (!tokenIsIdentifier(this.state.type) && this.state.type !== 58 && this.state.type !== 75) {
            return void 0;
          }
          const modifier = this.state.value;
          if (allowedModifiers.includes(modifier)) {
            if (hasSeenStaticModifier && this.match(106)) {
              return void 0;
            }
            if (stopOnStartOfClassStaticBlock && this.tsIsStartOfStaticBlocks()) {
              return void 0;
            }
            if (this.tsTryParse(this.tsNextTokenCanFollowModifier.bind(this))) {
              return modifier;
            }
          }
          return void 0;
        }
        tsParseModifiers({
          allowedModifiers,
          disallowedModifiers,
          stopOnStartOfClassStaticBlock,
          errorTemplate = TSErrors.InvalidModifierOnTypeMember
        }, modified) {
          const enforceOrder = (loc, modifier, before2, after2) => {
            if (modifier === before2 && modified[after2]) {
              this.raise(TSErrors.InvalidModifiersOrder, loc, {
                orderedModifiers: [before2, after2]
              });
            }
          };
          const incompatible = (loc, modifier, mod1, mod2) => {
            if (modified[mod1] && modifier === mod2 || modified[mod2] && modifier === mod1) {
              this.raise(TSErrors.IncompatibleModifiers, loc, {
                modifiers: [mod1, mod2]
              });
            }
          };
          for (; ; ) {
            const {
              startLoc
            } = this.state;
            const modifier = this.tsParseModifier(allowedModifiers.concat(disallowedModifiers != null ? disallowedModifiers : []), stopOnStartOfClassStaticBlock, modified.static);
            if (!modifier)
              break;
            if (tsIsAccessModifier(modifier)) {
              if (modified.accessibility) {
                this.raise(TSErrors.DuplicateAccessibilityModifier, startLoc, {
                  modifier
                });
              } else {
                enforceOrder(startLoc, modifier, modifier, "override");
                enforceOrder(startLoc, modifier, modifier, "static");
                enforceOrder(startLoc, modifier, modifier, "readonly");
                modified.accessibility = modifier;
              }
            } else if (tsIsVarianceAnnotations(modifier)) {
              if (modified[modifier]) {
                this.raise(TSErrors.DuplicateModifier, startLoc, {
                  modifier
                });
              }
              modified[modifier] = true;
              enforceOrder(startLoc, modifier, "in", "out");
            } else {
              if (hasOwnProperty.call(modified, modifier)) {
                this.raise(TSErrors.DuplicateModifier, startLoc, {
                  modifier
                });
              } else {
                enforceOrder(startLoc, modifier, "static", "readonly");
                enforceOrder(startLoc, modifier, "static", "override");
                enforceOrder(startLoc, modifier, "override", "readonly");
                enforceOrder(startLoc, modifier, "abstract", "override");
                incompatible(startLoc, modifier, "declare", "override");
                incompatible(startLoc, modifier, "static", "abstract");
              }
              modified[modifier] = true;
            }
            if (disallowedModifiers != null && disallowedModifiers.includes(modifier)) {
              this.raise(errorTemplate, startLoc, {
                modifier
              });
            }
          }
        }
        tsIsListTerminator(kind) {
          switch (kind) {
            case "EnumMembers":
            case "TypeMembers":
              return this.match(8);
            case "HeritageClauseElement":
              return this.match(5);
            case "TupleElementTypes":
              return this.match(3);
            case "TypeParametersOrArguments":
              return this.match(48);
          }
        }
        tsParseList(kind, parseElement) {
          const result2 = [];
          while (!this.tsIsListTerminator(kind)) {
            result2.push(parseElement());
          }
          return result2;
        }
        tsParseDelimitedList(kind, parseElement, refTrailingCommaPos) {
          return nonNull(this.tsParseDelimitedListWorker(kind, parseElement, true, refTrailingCommaPos));
        }
        tsParseDelimitedListWorker(kind, parseElement, expectSuccess, refTrailingCommaPos) {
          const result2 = [];
          let trailingCommaPos = -1;
          for (; ; ) {
            if (this.tsIsListTerminator(kind)) {
              break;
            }
            trailingCommaPos = -1;
            const element = parseElement();
            if (element == null) {
              return void 0;
            }
            result2.push(element);
            if (this.eat(12)) {
              trailingCommaPos = this.state.lastTokStartLoc.index;
              continue;
            }
            if (this.tsIsListTerminator(kind)) {
              break;
            }
            if (expectSuccess) {
              this.expect(12);
            }
            return void 0;
          }
          if (refTrailingCommaPos) {
            refTrailingCommaPos.value = trailingCommaPos;
          }
          return result2;
        }
        tsParseBracketedList(kind, parseElement, bracket, skipFirstToken, refTrailingCommaPos) {
          if (!skipFirstToken) {
            if (bracket) {
              this.expect(0);
            } else {
              this.expect(47);
            }
          }
          const result2 = this.tsParseDelimitedList(kind, parseElement, refTrailingCommaPos);
          if (bracket) {
            this.expect(3);
          } else {
            this.expect(48);
          }
          return result2;
        }
        tsParseImportType() {
          const node = this.startNode();
          this.expect(83);
          this.expect(10);
          if (!this.match(134)) {
            this.raise(TSErrors.UnsupportedImportTypeArgument, this.state.startLoc);
            {
              node.argument = super.parseExprAtom();
            }
          } else {
            {
              node.argument = this.parseStringLiteral(this.state.value);
            }
          }
          if (this.eat(12)) {
            node.options = this.tsParseImportTypeOptions();
          } else {
            node.options = null;
          }
          this.expect(11);
          if (this.eat(16)) {
            node.qualifier = this.tsParseEntityName(1 | 2);
          }
          if (this.match(47)) {
            {
              node.typeParameters = this.tsParseTypeArguments();
            }
          }
          return this.finishNode(node, "TSImportType");
        }
        tsParseImportTypeOptions() {
          const node = this.startNode();
          this.expect(5);
          const withProperty = this.startNode();
          if (this.isContextual(76)) {
            withProperty.method = false;
            withProperty.key = this.parseIdentifier(true);
            withProperty.computed = false;
            withProperty.shorthand = false;
          } else {
            this.unexpected(null, 76);
          }
          this.expect(14);
          withProperty.value = this.tsParseImportTypeWithPropertyValue();
          node.properties = [this.finishObjectProperty(withProperty)];
          this.eat(12);
          this.expect(8);
          return this.finishNode(node, "ObjectExpression");
        }
        tsParseImportTypeWithPropertyValue() {
          const node = this.startNode();
          const properties = [];
          this.expect(5);
          while (!this.match(8)) {
            const type = this.state.type;
            if (tokenIsIdentifier(type) || type === 134) {
              properties.push(super.parsePropertyDefinition(null));
            } else {
              this.unexpected();
            }
            this.eat(12);
          }
          node.properties = properties;
          this.next();
          return this.finishNode(node, "ObjectExpression");
        }
        tsParseEntityName(flags) {
          let entity;
          if (flags & 1 && this.match(78)) {
            if (flags & 2) {
              entity = this.parseIdentifier(true);
            } else {
              const node = this.startNode();
              this.next();
              entity = this.finishNode(node, "ThisExpression");
            }
          } else {
            entity = this.parseIdentifier(!!(flags & 1));
          }
          while (this.eat(16)) {
            const node = this.startNodeAtNode(entity);
            node.left = entity;
            node.right = this.parseIdentifier(!!(flags & 1));
            entity = this.finishNode(node, "TSQualifiedName");
          }
          return entity;
        }
        tsParseTypeReference() {
          const node = this.startNode();
          node.typeName = this.tsParseEntityName(1);
          if (!this.hasPrecedingLineBreak() && this.match(47)) {
            {
              node.typeParameters = this.tsParseTypeArguments();
            }
          }
          return this.finishNode(node, "TSTypeReference");
        }
        tsParseThisTypePredicate(lhs) {
          this.next();
          const node = this.startNodeAtNode(lhs);
          node.parameterName = lhs;
          node.typeAnnotation = this.tsParseTypeAnnotation(false);
          node.asserts = false;
          return this.finishNode(node, "TSTypePredicate");
        }
        tsParseThisTypeNode() {
          const node = this.startNode();
          this.next();
          return this.finishNode(node, "TSThisType");
        }
        tsParseTypeQuery() {
          const node = this.startNode();
          this.expect(87);
          if (this.match(83)) {
            node.exprName = this.tsParseImportType();
          } else {
            {
              node.exprName = this.tsParseEntityName(1 | 2);
            }
          }
          if (!this.hasPrecedingLineBreak() && this.match(47)) {
            {
              node.typeParameters = this.tsParseTypeArguments();
            }
          }
          return this.finishNode(node, "TSTypeQuery");
        }
        tsParseTypeParameter(parseModifiers) {
          const node = this.startNode();
          parseModifiers(node);
          node.name = this.tsParseTypeParameterName();
          node.constraint = this.tsEatThenParseType(81);
          node.default = this.tsEatThenParseType(29);
          return this.finishNode(node, "TSTypeParameter");
        }
        tsTryParseTypeParameters(parseModifiers) {
          if (this.match(47)) {
            return this.tsParseTypeParameters(parseModifiers);
          }
        }
        tsParseTypeParameters(parseModifiers) {
          const node = this.startNode();
          if (this.match(47) || this.match(143)) {
            this.next();
          } else {
            this.unexpected();
          }
          const refTrailingCommaPos = {
            value: -1
          };
          node.params = this.tsParseBracketedList("TypeParametersOrArguments", this.tsParseTypeParameter.bind(this, parseModifiers), false, true, refTrailingCommaPos);
          if (node.params.length === 0) {
            this.raise(TSErrors.EmptyTypeParameters, node);
          }
          if (refTrailingCommaPos.value !== -1) {
            this.addExtra(node, "trailingComma", refTrailingCommaPos.value);
          }
          return this.finishNode(node, "TSTypeParameterDeclaration");
        }
        tsFillSignature(returnToken, signature) {
          const returnTokenRequired = returnToken === 19;
          const paramsKey = "parameters";
          const returnTypeKey = "typeAnnotation";
          signature.typeParameters = this.tsTryParseTypeParameters(this.tsParseConstModifier);
          this.expect(10);
          signature[paramsKey] = this.tsParseBindingListForSignature();
          if (returnTokenRequired) {
            signature[returnTypeKey] = this.tsParseTypeOrTypePredicateAnnotation(returnToken);
          } else if (this.match(returnToken)) {
            signature[returnTypeKey] = this.tsParseTypeOrTypePredicateAnnotation(returnToken);
          }
        }
        tsParseBindingListForSignature() {
          const list = super.parseBindingList(11, 41, 2);
          for (const pattern of list) {
            const {
              type
            } = pattern;
            if (type === "AssignmentPattern" || type === "TSParameterProperty") {
              this.raise(TSErrors.UnsupportedSignatureParameterKind, pattern, {
                type
              });
            }
          }
          return list;
        }
        tsParseTypeMemberSemicolon() {
          if (!this.eat(12) && !this.isLineTerminator()) {
            this.expect(13);
          }
        }
        tsParseSignatureMember(kind, node) {
          this.tsFillSignature(14, node);
          this.tsParseTypeMemberSemicolon();
          return this.finishNode(node, kind);
        }
        tsIsUnambiguouslyIndexSignature() {
          this.next();
          if (tokenIsIdentifier(this.state.type)) {
            this.next();
            return this.match(14);
          }
          return false;
        }
        tsTryParseIndexSignature(node) {
          if (!(this.match(0) && this.tsLookAhead(this.tsIsUnambiguouslyIndexSignature.bind(this)))) {
            return;
          }
          this.expect(0);
          const id = this.parseIdentifier();
          id.typeAnnotation = this.tsParseTypeAnnotation();
          this.resetEndLocation(id);
          this.expect(3);
          node.parameters = [id];
          const type = this.tsTryParseTypeAnnotation();
          if (type)
            node.typeAnnotation = type;
          this.tsParseTypeMemberSemicolon();
          return this.finishNode(node, "TSIndexSignature");
        }
        tsParsePropertyOrMethodSignature(node, readonly) {
          if (this.eat(17))
            node.optional = true;
          if (this.match(10) || this.match(47)) {
            if (readonly) {
              this.raise(TSErrors.ReadonlyForMethodSignature, node);
            }
            const method2 = node;
            if (method2.kind && this.match(47)) {
              this.raise(TSErrors.AccessorCannotHaveTypeParameters, this.state.curPosition());
            }
            this.tsFillSignature(14, method2);
            this.tsParseTypeMemberSemicolon();
            const paramsKey = "parameters";
            const returnTypeKey = "typeAnnotation";
            if (method2.kind === "get") {
              if (method2[paramsKey].length > 0) {
                this.raise(Errors.BadGetterArity, this.state.curPosition());
                if (this.isThisParam(method2[paramsKey][0])) {
                  this.raise(TSErrors.AccessorCannotDeclareThisParameter, this.state.curPosition());
                }
              }
            } else if (method2.kind === "set") {
              if (method2[paramsKey].length !== 1) {
                this.raise(Errors.BadSetterArity, this.state.curPosition());
              } else {
                const firstParameter = method2[paramsKey][0];
                if (this.isThisParam(firstParameter)) {
                  this.raise(TSErrors.AccessorCannotDeclareThisParameter, this.state.curPosition());
                }
                if (firstParameter.type === "Identifier" && firstParameter.optional) {
                  this.raise(TSErrors.SetAccessorCannotHaveOptionalParameter, this.state.curPosition());
                }
                if (firstParameter.type === "RestElement") {
                  this.raise(TSErrors.SetAccessorCannotHaveRestParameter, this.state.curPosition());
                }
              }
              if (method2[returnTypeKey]) {
                this.raise(TSErrors.SetAccessorCannotHaveReturnType, method2[returnTypeKey]);
              }
            } else {
              method2.kind = "method";
            }
            return this.finishNode(method2, "TSMethodSignature");
          } else {
            const property2 = node;
            if (readonly)
              property2.readonly = true;
            const type = this.tsTryParseTypeAnnotation();
            if (type)
              property2.typeAnnotation = type;
            this.tsParseTypeMemberSemicolon();
            return this.finishNode(property2, "TSPropertySignature");
          }
        }
        tsParseTypeMember() {
          const node = this.startNode();
          if (this.match(10) || this.match(47)) {
            return this.tsParseSignatureMember("TSCallSignatureDeclaration", node);
          }
          if (this.match(77)) {
            const id = this.startNode();
            this.next();
            if (this.match(10) || this.match(47)) {
              return this.tsParseSignatureMember("TSConstructSignatureDeclaration", node);
            } else {
              node.key = this.createIdentifier(id, "new");
              return this.tsParsePropertyOrMethodSignature(node, false);
            }
          }
          this.tsParseModifiers({
            allowedModifiers: ["readonly"],
            disallowedModifiers: ["declare", "abstract", "private", "protected", "public", "static", "override"]
          }, node);
          const idx = this.tsTryParseIndexSignature(node);
          if (idx) {
            return idx;
          }
          super.parsePropertyName(node);
          if (!node.computed && node.key.type === "Identifier" && (node.key.name === "get" || node.key.name === "set") && this.tsTokenCanFollowModifier()) {
            node.kind = node.key.name;
            super.parsePropertyName(node);
            if (!this.match(10) && !this.match(47)) {
              this.unexpected(null, 10);
            }
          }
          return this.tsParsePropertyOrMethodSignature(node, !!node.readonly);
        }
        tsParseTypeLiteral() {
          const node = this.startNode();
          node.members = this.tsParseObjectTypeMembers();
          return this.finishNode(node, "TSTypeLiteral");
        }
        tsParseObjectTypeMembers() {
          this.expect(5);
          const members = this.tsParseList("TypeMembers", this.tsParseTypeMember.bind(this));
          this.expect(8);
          return members;
        }
        tsIsStartOfMappedType() {
          this.next();
          if (this.eat(53)) {
            return this.isContextual(122);
          }
          if (this.isContextual(122)) {
            this.next();
          }
          if (!this.match(0)) {
            return false;
          }
          this.next();
          if (!this.tsIsIdentifier()) {
            return false;
          }
          this.next();
          return this.match(58);
        }
        tsParseMappedType() {
          const node = this.startNode();
          this.expect(5);
          if (this.match(53)) {
            node.readonly = this.state.value;
            this.next();
            this.expectContextual(122);
          } else if (this.eatContextual(122)) {
            node.readonly = true;
          }
          this.expect(0);
          {
            const typeParameter = this.startNode();
            typeParameter.name = this.tsParseTypeParameterName();
            typeParameter.constraint = this.tsExpectThenParseType(58);
            node.typeParameter = this.finishNode(typeParameter, "TSTypeParameter");
          }
          node.nameType = this.eatContextual(93) ? this.tsParseType() : null;
          this.expect(3);
          if (this.match(53)) {
            node.optional = this.state.value;
            this.next();
            this.expect(17);
          } else if (this.eat(17)) {
            node.optional = true;
          }
          node.typeAnnotation = this.tsTryParseType();
          this.semicolon();
          this.expect(8);
          return this.finishNode(node, "TSMappedType");
        }
        tsParseTupleType() {
          const node = this.startNode();
          node.elementTypes = this.tsParseBracketedList("TupleElementTypes", this.tsParseTupleElementType.bind(this), true, false);
          let seenOptionalElement = false;
          node.elementTypes.forEach((elementNode) => {
            const {
              type
            } = elementNode;
            if (seenOptionalElement && type !== "TSRestType" && type !== "TSOptionalType" && !(type === "TSNamedTupleMember" && elementNode.optional)) {
              this.raise(TSErrors.OptionalTypeBeforeRequired, elementNode);
            }
            seenOptionalElement || (seenOptionalElement = type === "TSNamedTupleMember" && elementNode.optional || type === "TSOptionalType");
          });
          return this.finishNode(node, "TSTupleType");
        }
        tsParseTupleElementType() {
          const restStartLoc = this.state.startLoc;
          const rest2 = this.eat(21);
          const {
            startLoc
          } = this.state;
          let labeled;
          let label;
          let optional;
          let type;
          const isWord = tokenIsKeywordOrIdentifier(this.state.type);
          const chAfterWord = isWord ? this.lookaheadCharCode() : null;
          if (chAfterWord === 58) {
            labeled = true;
            optional = false;
            label = this.parseIdentifier(true);
            this.expect(14);
            type = this.tsParseType();
          } else if (chAfterWord === 63) {
            optional = true;
            const wordName = this.state.value;
            const typeOrLabel = this.tsParseNonArrayType();
            if (this.lookaheadCharCode() === 58) {
              labeled = true;
              label = this.createIdentifier(this.startNodeAt(startLoc), wordName);
              this.expect(17);
              this.expect(14);
              type = this.tsParseType();
            } else {
              labeled = false;
              type = typeOrLabel;
              this.expect(17);
            }
          } else {
            type = this.tsParseType();
            optional = this.eat(17);
            labeled = this.eat(14);
          }
          if (labeled) {
            let labeledNode;
            if (label) {
              labeledNode = this.startNodeAt(startLoc);
              labeledNode.optional = optional;
              labeledNode.label = label;
              labeledNode.elementType = type;
              if (this.eat(17)) {
                labeledNode.optional = true;
                this.raise(TSErrors.TupleOptionalAfterType, this.state.lastTokStartLoc);
              }
            } else {
              labeledNode = this.startNodeAt(startLoc);
              labeledNode.optional = optional;
              this.raise(TSErrors.InvalidTupleMemberLabel, type);
              labeledNode.label = type;
              labeledNode.elementType = this.tsParseType();
            }
            type = this.finishNode(labeledNode, "TSNamedTupleMember");
          } else if (optional) {
            const optionalTypeNode = this.startNodeAt(startLoc);
            optionalTypeNode.typeAnnotation = type;
            type = this.finishNode(optionalTypeNode, "TSOptionalType");
          }
          if (rest2) {
            const restNode = this.startNodeAt(restStartLoc);
            restNode.typeAnnotation = type;
            type = this.finishNode(restNode, "TSRestType");
          }
          return type;
        }
        tsParseParenthesizedType() {
          const node = this.startNode();
          this.expect(10);
          node.typeAnnotation = this.tsParseType();
          this.expect(11);
          return this.finishNode(node, "TSParenthesizedType");
        }
        tsParseFunctionOrConstructorType(type, abstract) {
          const node = this.startNode();
          if (type === "TSConstructorType") {
            node.abstract = !!abstract;
            if (abstract)
              this.next();
            this.next();
          }
          this.tsInAllowConditionalTypesContext(() => this.tsFillSignature(19, node));
          return this.finishNode(node, type);
        }
        tsParseLiteralTypeNode() {
          const node = this.startNode();
          switch (this.state.type) {
            case 135:
            case 136:
            case 134:
            case 85:
            case 86:
              node.literal = super.parseExprAtom();
              break;
            default:
              this.unexpected();
          }
          return this.finishNode(node, "TSLiteralType");
        }
        tsParseTemplateLiteralType() {
          {
            const node = this.startNode();
            node.literal = super.parseTemplate(false);
            return this.finishNode(node, "TSLiteralType");
          }
        }
        parseTemplateSubstitution() {
          if (this.state.inType)
            return this.tsParseType();
          return super.parseTemplateSubstitution();
        }
        tsParseThisTypeOrThisTypePredicate() {
          const thisKeyword = this.tsParseThisTypeNode();
          if (this.isContextual(116) && !this.hasPrecedingLineBreak()) {
            return this.tsParseThisTypePredicate(thisKeyword);
          } else {
            return thisKeyword;
          }
        }
        tsParseNonArrayType() {
          switch (this.state.type) {
            case 134:
            case 135:
            case 136:
            case 85:
            case 86:
              return this.tsParseLiteralTypeNode();
            case 53:
              if (this.state.value === "-") {
                const node = this.startNode();
                const nextToken = this.lookahead();
                if (nextToken.type !== 135 && nextToken.type !== 136) {
                  this.unexpected();
                }
                node.literal = this.parseMaybeUnary();
                return this.finishNode(node, "TSLiteralType");
              }
              break;
            case 78:
              return this.tsParseThisTypeOrThisTypePredicate();
            case 87:
              return this.tsParseTypeQuery();
            case 83:
              return this.tsParseImportType();
            case 5:
              return this.tsLookAhead(this.tsIsStartOfMappedType.bind(this)) ? this.tsParseMappedType() : this.tsParseTypeLiteral();
            case 0:
              return this.tsParseTupleType();
            case 10:
              return this.tsParseParenthesizedType();
            case 25:
            case 24:
              return this.tsParseTemplateLiteralType();
            default: {
              const {
                type
              } = this.state;
              if (tokenIsIdentifier(type) || type === 88 || type === 84) {
                const nodeType = type === 88 ? "TSVoidKeyword" : type === 84 ? "TSNullKeyword" : keywordTypeFromName(this.state.value);
                if (nodeType !== void 0 && this.lookaheadCharCode() !== 46) {
                  const node = this.startNode();
                  this.next();
                  return this.finishNode(node, nodeType);
                }
                return this.tsParseTypeReference();
              }
            }
          }
          this.unexpected();
        }
        tsParseArrayTypeOrHigher() {
          const {
            startLoc
          } = this.state;
          let type = this.tsParseNonArrayType();
          while (!this.hasPrecedingLineBreak() && this.eat(0)) {
            if (this.match(3)) {
              const node = this.startNodeAt(startLoc);
              node.elementType = type;
              this.expect(3);
              type = this.finishNode(node, "TSArrayType");
            } else {
              const node = this.startNodeAt(startLoc);
              node.objectType = type;
              node.indexType = this.tsParseType();
              this.expect(3);
              type = this.finishNode(node, "TSIndexedAccessType");
            }
          }
          return type;
        }
        tsParseTypeOperator() {
          const node = this.startNode();
          const operator = this.state.value;
          this.next();
          node.operator = operator;
          node.typeAnnotation = this.tsParseTypeOperatorOrHigher();
          if (operator === "readonly") {
            this.tsCheckTypeAnnotationForReadOnly(node);
          }
          return this.finishNode(node, "TSTypeOperator");
        }
        tsCheckTypeAnnotationForReadOnly(node) {
          switch (node.typeAnnotation.type) {
            case "TSTupleType":
            case "TSArrayType":
              return;
            default:
              this.raise(TSErrors.UnexpectedReadonly, node);
          }
        }
        tsParseInferType() {
          const node = this.startNode();
          this.expectContextual(115);
          const typeParameter = this.startNode();
          typeParameter.name = this.tsParseTypeParameterName();
          typeParameter.constraint = this.tsTryParse(() => this.tsParseConstraintForInferType());
          node.typeParameter = this.finishNode(typeParameter, "TSTypeParameter");
          return this.finishNode(node, "TSInferType");
        }
        tsParseConstraintForInferType() {
          if (this.eat(81)) {
            const constraint = this.tsInDisallowConditionalTypesContext(() => this.tsParseType());
            if (this.state.inDisallowConditionalTypesContext || !this.match(17)) {
              return constraint;
            }
          }
        }
        tsParseTypeOperatorOrHigher() {
          const isTypeOperator = tokenIsTSTypeOperator(this.state.type) && !this.state.containsEsc;
          return isTypeOperator ? this.tsParseTypeOperator() : this.isContextual(115) ? this.tsParseInferType() : this.tsInAllowConditionalTypesContext(() => this.tsParseArrayTypeOrHigher());
        }
        tsParseUnionOrIntersectionType(kind, parseConstituentType, operator) {
          const node = this.startNode();
          const hasLeadingOperator = this.eat(operator);
          const types3 = [];
          do {
            types3.push(parseConstituentType());
          } while (this.eat(operator));
          if (types3.length === 1 && !hasLeadingOperator) {
            return types3[0];
          }
          node.types = types3;
          return this.finishNode(node, kind);
        }
        tsParseIntersectionTypeOrHigher() {
          return this.tsParseUnionOrIntersectionType("TSIntersectionType", this.tsParseTypeOperatorOrHigher.bind(this), 45);
        }
        tsParseUnionTypeOrHigher() {
          return this.tsParseUnionOrIntersectionType("TSUnionType", this.tsParseIntersectionTypeOrHigher.bind(this), 43);
        }
        tsIsStartOfFunctionType() {
          if (this.match(47)) {
            return true;
          }
          return this.match(10) && this.tsLookAhead(this.tsIsUnambiguouslyStartOfFunctionType.bind(this));
        }
        tsSkipParameterStart() {
          if (tokenIsIdentifier(this.state.type) || this.match(78)) {
            this.next();
            return true;
          }
          if (this.match(5)) {
            const {
              errors
            } = this.state;
            const previousErrorCount = errors.length;
            try {
              this.parseObjectLike(8, true);
              return errors.length === previousErrorCount;
            } catch (_unused) {
              return false;
            }
          }
          if (this.match(0)) {
            this.next();
            const {
              errors
            } = this.state;
            const previousErrorCount = errors.length;
            try {
              super.parseBindingList(3, 93, 1);
              return errors.length === previousErrorCount;
            } catch (_unused2) {
              return false;
            }
          }
          return false;
        }
        tsIsUnambiguouslyStartOfFunctionType() {
          this.next();
          if (this.match(11) || this.match(21)) {
            return true;
          }
          if (this.tsSkipParameterStart()) {
            if (this.match(14) || this.match(12) || this.match(17) || this.match(29)) {
              return true;
            }
            if (this.match(11)) {
              this.next();
              if (this.match(19)) {
                return true;
              }
            }
          }
          return false;
        }
        tsParseTypeOrTypePredicateAnnotation(returnToken) {
          return this.tsInType(() => {
            const t3 = this.startNode();
            this.expect(returnToken);
            const node = this.startNode();
            const asserts = !!this.tsTryParse(this.tsParseTypePredicateAsserts.bind(this));
            if (asserts && this.match(78)) {
              let thisTypePredicate = this.tsParseThisTypeOrThisTypePredicate();
              if (thisTypePredicate.type === "TSThisType") {
                node.parameterName = thisTypePredicate;
                node.asserts = true;
                node.typeAnnotation = null;
                thisTypePredicate = this.finishNode(node, "TSTypePredicate");
              } else {
                this.resetStartLocationFromNode(thisTypePredicate, node);
                thisTypePredicate.asserts = true;
              }
              t3.typeAnnotation = thisTypePredicate;
              return this.finishNode(t3, "TSTypeAnnotation");
            }
            const typePredicateVariable = this.tsIsIdentifier() && this.tsTryParse(this.tsParseTypePredicatePrefix.bind(this));
            if (!typePredicateVariable) {
              if (!asserts) {
                return this.tsParseTypeAnnotation(false, t3);
              }
              node.parameterName = this.parseIdentifier();
              node.asserts = asserts;
              node.typeAnnotation = null;
              t3.typeAnnotation = this.finishNode(node, "TSTypePredicate");
              return this.finishNode(t3, "TSTypeAnnotation");
            }
            const type = this.tsParseTypeAnnotation(false);
            node.parameterName = typePredicateVariable;
            node.typeAnnotation = type;
            node.asserts = asserts;
            t3.typeAnnotation = this.finishNode(node, "TSTypePredicate");
            return this.finishNode(t3, "TSTypeAnnotation");
          });
        }
        tsTryParseTypeOrTypePredicateAnnotation() {
          if (this.match(14)) {
            return this.tsParseTypeOrTypePredicateAnnotation(14);
          }
        }
        tsTryParseTypeAnnotation() {
          if (this.match(14)) {
            return this.tsParseTypeAnnotation();
          }
        }
        tsTryParseType() {
          return this.tsEatThenParseType(14);
        }
        tsParseTypePredicatePrefix() {
          const id = this.parseIdentifier();
          if (this.isContextual(116) && !this.hasPrecedingLineBreak()) {
            this.next();
            return id;
          }
        }
        tsParseTypePredicateAsserts() {
          if (this.state.type !== 109) {
            return false;
          }
          const containsEsc = this.state.containsEsc;
          this.next();
          if (!tokenIsIdentifier(this.state.type) && !this.match(78)) {
            return false;
          }
          if (containsEsc) {
            this.raise(Errors.InvalidEscapedReservedWord, this.state.lastTokStartLoc, {
              reservedWord: "asserts"
            });
          }
          return true;
        }
        tsParseTypeAnnotation(eatColon = true, t3 = this.startNode()) {
          this.tsInType(() => {
            if (eatColon)
              this.expect(14);
            t3.typeAnnotation = this.tsParseType();
          });
          return this.finishNode(t3, "TSTypeAnnotation");
        }
        tsParseType() {
          assert3(this.state.inType);
          const type = this.tsParseNonConditionalType();
          if (this.state.inDisallowConditionalTypesContext || this.hasPrecedingLineBreak() || !this.eat(81)) {
            return type;
          }
          const node = this.startNodeAtNode(type);
          node.checkType = type;
          node.extendsType = this.tsInDisallowConditionalTypesContext(() => this.tsParseNonConditionalType());
          this.expect(17);
          node.trueType = this.tsInAllowConditionalTypesContext(() => this.tsParseType());
          this.expect(14);
          node.falseType = this.tsInAllowConditionalTypesContext(() => this.tsParseType());
          return this.finishNode(node, "TSConditionalType");
        }
        isAbstractConstructorSignature() {
          return this.isContextual(124) && this.isLookaheadContextual("new");
        }
        tsParseNonConditionalType() {
          if (this.tsIsStartOfFunctionType()) {
            return this.tsParseFunctionOrConstructorType("TSFunctionType");
          }
          if (this.match(77)) {
            return this.tsParseFunctionOrConstructorType("TSConstructorType");
          } else if (this.isAbstractConstructorSignature()) {
            return this.tsParseFunctionOrConstructorType("TSConstructorType", true);
          }
          return this.tsParseUnionTypeOrHigher();
        }
        tsParseTypeAssertion() {
          if (this.getPluginOption("typescript", "disallowAmbiguousJSXLike")) {
            this.raise(TSErrors.ReservedTypeAssertion, this.state.startLoc);
          }
          const node = this.startNode();
          node.typeAnnotation = this.tsInType(() => {
            this.next();
            return this.match(75) ? this.tsParseTypeReference() : this.tsParseType();
          });
          this.expect(48);
          node.expression = this.parseMaybeUnary();
          return this.finishNode(node, "TSTypeAssertion");
        }
        tsParseHeritageClause(token) {
          const originalStartLoc = this.state.startLoc;
          const delimitedList = this.tsParseDelimitedList("HeritageClauseElement", () => {
            {
              const node = this.startNode();
              node.expression = this.tsParseEntityName(1 | 2);
              if (this.match(47)) {
                node.typeParameters = this.tsParseTypeArguments();
              }
              return this.finishNode(node, "TSExpressionWithTypeArguments");
            }
          });
          if (!delimitedList.length) {
            this.raise(TSErrors.EmptyHeritageClauseType, originalStartLoc, {
              token
            });
          }
          return delimitedList;
        }
        tsParseInterfaceDeclaration(node, properties = {}) {
          if (this.hasFollowingLineBreak())
            return null;
          this.expectContextual(129);
          if (properties.declare)
            node.declare = true;
          if (tokenIsIdentifier(this.state.type)) {
            node.id = this.parseIdentifier();
            this.checkIdentifier(node.id, 130);
          } else {
            node.id = null;
            this.raise(TSErrors.MissingInterfaceName, this.state.startLoc);
          }
          node.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutConstModifiers);
          if (this.eat(81)) {
            node.extends = this.tsParseHeritageClause("extends");
          }
          const body = this.startNode();
          body.body = this.tsInType(this.tsParseObjectTypeMembers.bind(this));
          node.body = this.finishNode(body, "TSInterfaceBody");
          return this.finishNode(node, "TSInterfaceDeclaration");
        }
        tsParseTypeAliasDeclaration(node) {
          node.id = this.parseIdentifier();
          this.checkIdentifier(node.id, 2);
          node.typeAnnotation = this.tsInType(() => {
            node.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers);
            this.expect(29);
            if (this.isContextual(114) && this.lookaheadCharCode() !== 46) {
              const node2 = this.startNode();
              this.next();
              return this.finishNode(node2, "TSIntrinsicKeyword");
            }
            return this.tsParseType();
          });
          this.semicolon();
          return this.finishNode(node, "TSTypeAliasDeclaration");
        }
        tsInTopLevelContext(cb) {
          if (this.curContext() !== types2.brace) {
            const oldContext = this.state.context;
            this.state.context = [oldContext[0]];
            try {
              return cb();
            } finally {
              this.state.context = oldContext;
            }
          } else {
            return cb();
          }
        }
        tsInType(cb) {
          const oldInType = this.state.inType;
          this.state.inType = true;
          try {
            return cb();
          } finally {
            this.state.inType = oldInType;
          }
        }
        tsInDisallowConditionalTypesContext(cb) {
          const oldInDisallowConditionalTypesContext = this.state.inDisallowConditionalTypesContext;
          this.state.inDisallowConditionalTypesContext = true;
          try {
            return cb();
          } finally {
            this.state.inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
          }
        }
        tsInAllowConditionalTypesContext(cb) {
          const oldInDisallowConditionalTypesContext = this.state.inDisallowConditionalTypesContext;
          this.state.inDisallowConditionalTypesContext = false;
          try {
            return cb();
          } finally {
            this.state.inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
          }
        }
        tsEatThenParseType(token) {
          if (this.match(token)) {
            return this.tsNextThenParseType();
          }
        }
        tsExpectThenParseType(token) {
          return this.tsInType(() => {
            this.expect(token);
            return this.tsParseType();
          });
        }
        tsNextThenParseType() {
          return this.tsInType(() => {
            this.next();
            return this.tsParseType();
          });
        }
        tsParseEnumMember() {
          const node = this.startNode();
          node.id = this.match(134) ? super.parseStringLiteral(this.state.value) : this.parseIdentifier(true);
          if (this.eat(29)) {
            node.initializer = super.parseMaybeAssignAllowIn();
          }
          return this.finishNode(node, "TSEnumMember");
        }
        tsParseEnumDeclaration(node, properties = {}) {
          if (properties.const)
            node.const = true;
          if (properties.declare)
            node.declare = true;
          this.expectContextual(126);
          node.id = this.parseIdentifier();
          this.checkIdentifier(node.id, node.const ? 8971 : 8459);
          {
            this.expect(5);
            node.members = this.tsParseDelimitedList("EnumMembers", this.tsParseEnumMember.bind(this));
            this.expect(8);
          }
          return this.finishNode(node, "TSEnumDeclaration");
        }
        tsParseEnumBody() {
          const node = this.startNode();
          this.expect(5);
          node.members = this.tsParseDelimitedList("EnumMembers", this.tsParseEnumMember.bind(this));
          this.expect(8);
          return this.finishNode(node, "TSEnumBody");
        }
        tsParseModuleBlock() {
          const node = this.startNode();
          this.scope.enter(0);
          this.expect(5);
          super.parseBlockOrModuleBlockBody(node.body = [], void 0, true, 8);
          this.scope.exit();
          return this.finishNode(node, "TSModuleBlock");
        }
        tsParseModuleOrNamespaceDeclaration(node, nested = false) {
          node.id = this.parseIdentifier();
          if (!nested) {
            this.checkIdentifier(node.id, 1024);
          }
          if (this.eat(16)) {
            const inner = this.startNode();
            this.tsParseModuleOrNamespaceDeclaration(inner, true);
            node.body = inner;
          } else {
            this.scope.enter(1024);
            this.prodParam.enter(0);
            node.body = this.tsParseModuleBlock();
            this.prodParam.exit();
            this.scope.exit();
          }
          return this.finishNode(node, "TSModuleDeclaration");
        }
        tsParseAmbientExternalModuleDeclaration(node) {
          if (this.isContextual(112)) {
            node.kind = "global";
            {
              node.global = true;
            }
            node.id = this.parseIdentifier();
          } else if (this.match(134)) {
            node.kind = "module";
            node.id = super.parseStringLiteral(this.state.value);
          } else {
            this.unexpected();
          }
          if (this.match(5)) {
            this.scope.enter(1024);
            this.prodParam.enter(0);
            node.body = this.tsParseModuleBlock();
            this.prodParam.exit();
            this.scope.exit();
          } else {
            this.semicolon();
          }
          return this.finishNode(node, "TSModuleDeclaration");
        }
        tsParseImportEqualsDeclaration(node, maybeDefaultIdentifier, isExport) {
          {
            node.isExport = isExport || false;
          }
          node.id = maybeDefaultIdentifier || this.parseIdentifier();
          this.checkIdentifier(node.id, 4096);
          this.expect(29);
          const moduleReference = this.tsParseModuleReference();
          if (node.importKind === "type" && moduleReference.type !== "TSExternalModuleReference") {
            this.raise(TSErrors.ImportAliasHasImportType, moduleReference);
          }
          node.moduleReference = moduleReference;
          this.semicolon();
          return this.finishNode(node, "TSImportEqualsDeclaration");
        }
        tsIsExternalModuleReference() {
          return this.isContextual(119) && this.lookaheadCharCode() === 40;
        }
        tsParseModuleReference() {
          return this.tsIsExternalModuleReference() ? this.tsParseExternalModuleReference() : this.tsParseEntityName(0);
        }
        tsParseExternalModuleReference() {
          const node = this.startNode();
          this.expectContextual(119);
          this.expect(10);
          if (!this.match(134)) {
            this.unexpected();
          }
          node.expression = super.parseExprAtom();
          this.expect(11);
          this.sawUnambiguousESM = true;
          return this.finishNode(node, "TSExternalModuleReference");
        }
        tsLookAhead(f) {
          const state = this.state.clone();
          const res = f();
          this.state = state;
          return res;
        }
        tsTryParseAndCatch(f) {
          const result2 = this.tryParse((abort3) => f() || abort3());
          if (result2.aborted || !result2.node)
            return;
          if (result2.error)
            this.state = result2.failState;
          return result2.node;
        }
        tsTryParse(f) {
          const state = this.state.clone();
          const result2 = f();
          if (result2 !== void 0 && result2 !== false) {
            return result2;
          }
          this.state = state;
        }
        tsTryParseDeclare(node) {
          if (this.isLineTerminator()) {
            return;
          }
          const startType = this.state.type;
          return this.tsInAmbientContext(() => {
            switch (startType) {
              case 68:
                node.declare = true;
                return super.parseFunctionStatement(node, false, false);
              case 80:
                node.declare = true;
                return this.parseClass(node, true, false);
              case 126:
                return this.tsParseEnumDeclaration(node, {
                  declare: true
                });
              case 112:
                return this.tsParseAmbientExternalModuleDeclaration(node);
              case 100:
                if (this.state.containsEsc) {
                  return;
                }
              case 75:
              case 74:
                if (!this.match(75) || !this.isLookaheadContextual("enum")) {
                  node.declare = true;
                  return this.parseVarStatement(node, this.state.value, true);
                }
                this.expect(75);
                return this.tsParseEnumDeclaration(node, {
                  const: true,
                  declare: true
                });
              case 107:
                if (this.isUsing()) {
                  this.raise(TSErrors.InvalidModifierOnUsingDeclaration, this.state.startLoc, "declare");
                  node.declare = true;
                  return this.parseVarStatement(node, "using", true);
                }
                break;
              case 96:
                if (this.isAwaitUsing()) {
                  this.raise(TSErrors.InvalidModifierOnAwaitUsingDeclaration, this.state.startLoc, "declare");
                  node.declare = true;
                  this.next();
                  return this.parseVarStatement(node, "await using", true);
                }
                break;
              case 129: {
                const result2 = this.tsParseInterfaceDeclaration(node, {
                  declare: true
                });
                if (result2)
                  return result2;
              }
              default:
                if (tokenIsIdentifier(startType)) {
                  return this.tsParseDeclaration(node, this.state.value, true, null);
                }
            }
          });
        }
        tsTryParseExportDeclaration() {
          return this.tsParseDeclaration(this.startNode(), this.state.value, true, null);
        }
        tsParseExpressionStatement(node, expr, decorators) {
          switch (expr.name) {
            case "declare": {
              const declaration = this.tsTryParseDeclare(node);
              if (declaration) {
                declaration.declare = true;
              }
              return declaration;
            }
            case "global":
              if (this.match(5)) {
                this.scope.enter(1024);
                this.prodParam.enter(0);
                const mod = node;
                mod.kind = "global";
                {
                  node.global = true;
                }
                mod.id = expr;
                mod.body = this.tsParseModuleBlock();
                this.scope.exit();
                this.prodParam.exit();
                return this.finishNode(mod, "TSModuleDeclaration");
              }
              break;
            default:
              return this.tsParseDeclaration(node, expr.name, false, decorators);
          }
        }
        tsParseDeclaration(node, value, next, decorators) {
          switch (value) {
            case "abstract":
              if (this.tsCheckLineTerminator(next) && (this.match(80) || tokenIsIdentifier(this.state.type))) {
                return this.tsParseAbstractDeclaration(node, decorators);
              }
              break;
            case "module":
              if (this.tsCheckLineTerminator(next)) {
                if (this.match(134)) {
                  return this.tsParseAmbientExternalModuleDeclaration(node);
                } else if (tokenIsIdentifier(this.state.type)) {
                  node.kind = "module";
                  return this.tsParseModuleOrNamespaceDeclaration(node);
                }
              }
              break;
            case "namespace":
              if (this.tsCheckLineTerminator(next) && tokenIsIdentifier(this.state.type)) {
                node.kind = "namespace";
                return this.tsParseModuleOrNamespaceDeclaration(node);
              }
              break;
            case "type":
              if (this.tsCheckLineTerminator(next) && tokenIsIdentifier(this.state.type)) {
                return this.tsParseTypeAliasDeclaration(node);
              }
              break;
          }
        }
        tsCheckLineTerminator(next) {
          if (next) {
            if (this.hasFollowingLineBreak())
              return false;
            this.next();
            return true;
          }
          return !this.isLineTerminator();
        }
        tsTryParseGenericAsyncArrowFunction(startLoc) {
          if (!this.match(47))
            return;
          const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
          this.state.maybeInArrowParameters = true;
          const res = this.tsTryParseAndCatch(() => {
            const node = this.startNodeAt(startLoc);
            node.typeParameters = this.tsParseTypeParameters(this.tsParseConstModifier);
            super.parseFunctionParams(node);
            node.returnType = this.tsTryParseTypeOrTypePredicateAnnotation();
            this.expect(19);
            return node;
          });
          this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
          if (!res)
            return;
          return super.parseArrowExpression(res, null, true);
        }
        tsParseTypeArgumentsInExpression() {
          if (this.reScan_lt() !== 47)
            return;
          return this.tsParseTypeArguments();
        }
        tsParseTypeArguments() {
          const node = this.startNode();
          node.params = this.tsInType(() => this.tsInTopLevelContext(() => {
            this.expect(47);
            return this.tsParseDelimitedList("TypeParametersOrArguments", this.tsParseType.bind(this));
          }));
          if (node.params.length === 0) {
            this.raise(TSErrors.EmptyTypeArguments, node);
          } else if (!this.state.inType && this.curContext() === types2.brace) {
            this.reScan_lt_gt();
          }
          this.expect(48);
          return this.finishNode(node, "TSTypeParameterInstantiation");
        }
        tsIsDeclarationStart() {
          return tokenIsTSDeclarationStart(this.state.type);
        }
        isExportDefaultSpecifier() {
          if (this.tsIsDeclarationStart())
            return false;
          return super.isExportDefaultSpecifier();
        }
        parseBindingElement(flags, decorators) {
          const startLoc = decorators.length ? decorators[0].loc.start : this.state.startLoc;
          const modified = {};
          this.tsParseModifiers({
            allowedModifiers: ["public", "private", "protected", "override", "readonly"]
          }, modified);
          const accessibility = modified.accessibility;
          const override = modified.override;
          const readonly = modified.readonly;
          if (!(flags & 4) && (accessibility || readonly || override)) {
            this.raise(TSErrors.UnexpectedParameterModifier, startLoc);
          }
          const left = this.parseMaybeDefault();
          if (flags & 2) {
            this.parseFunctionParamType(left);
          }
          const elt = this.parseMaybeDefault(left.loc.start, left);
          if (accessibility || readonly || override) {
            const pp = this.startNodeAt(startLoc);
            if (decorators.length) {
              pp.decorators = decorators;
            }
            if (accessibility)
              pp.accessibility = accessibility;
            if (readonly)
              pp.readonly = readonly;
            if (override)
              pp.override = override;
            if (elt.type !== "Identifier" && elt.type !== "AssignmentPattern") {
              this.raise(TSErrors.UnsupportedParameterPropertyKind, pp);
            }
            pp.parameter = elt;
            return this.finishNode(pp, "TSParameterProperty");
          }
          if (decorators.length) {
            left.decorators = decorators;
          }
          return elt;
        }
        isSimpleParameter(node) {
          return node.type === "TSParameterProperty" && super.isSimpleParameter(node.parameter) || super.isSimpleParameter(node);
        }
        tsDisallowOptionalPattern(node) {
          for (const param of node.params) {
            if (param.type !== "Identifier" && param.optional && !this.state.isAmbientContext) {
              this.raise(TSErrors.PatternIsOptional, param);
            }
          }
        }
        setArrowFunctionParameters(node, params, trailingCommaLoc) {
          super.setArrowFunctionParameters(node, params, trailingCommaLoc);
          this.tsDisallowOptionalPattern(node);
        }
        parseFunctionBodyAndFinish(node, type, isMethod = false) {
          if (this.match(14)) {
            node.returnType = this.tsParseTypeOrTypePredicateAnnotation(14);
          }
          const bodilessType = type === "FunctionDeclaration" ? "TSDeclareFunction" : type === "ClassMethod" || type === "ClassPrivateMethod" ? "TSDeclareMethod" : void 0;
          if (bodilessType && !this.match(5) && this.isLineTerminator()) {
            return this.finishNode(node, bodilessType);
          }
          if (bodilessType === "TSDeclareFunction" && this.state.isAmbientContext) {
            this.raise(TSErrors.DeclareFunctionHasImplementation, node);
            if (node.declare) {
              return super.parseFunctionBodyAndFinish(node, bodilessType, isMethod);
            }
          }
          this.tsDisallowOptionalPattern(node);
          return super.parseFunctionBodyAndFinish(node, type, isMethod);
        }
        registerFunctionStatementId(node) {
          if (!node.body && node.id) {
            this.checkIdentifier(node.id, 1024);
          } else {
            super.registerFunctionStatementId(node);
          }
        }
        tsCheckForInvalidTypeCasts(items) {
          items.forEach((node) => {
            if ((node == null ? void 0 : node.type) === "TSTypeCastExpression") {
              this.raise(TSErrors.UnexpectedTypeAnnotation, node.typeAnnotation);
            }
          });
        }
        toReferencedList(exprList, isInParens) {
          this.tsCheckForInvalidTypeCasts(exprList);
          return exprList;
        }
        parseArrayLike(close, canBePattern, isTuple, refExpressionErrors) {
          const node = super.parseArrayLike(close, canBePattern, isTuple, refExpressionErrors);
          if (node.type === "ArrayExpression") {
            this.tsCheckForInvalidTypeCasts(node.elements);
          }
          return node;
        }
        parseSubscript(base, startLoc, noCalls, state) {
          if (!this.hasPrecedingLineBreak() && this.match(35)) {
            this.state.canStartJSXElement = false;
            this.next();
            const nonNullExpression = this.startNodeAt(startLoc);
            nonNullExpression.expression = base;
            return this.finishNode(nonNullExpression, "TSNonNullExpression");
          }
          let isOptionalCall = false;
          if (this.match(18) && this.lookaheadCharCode() === 60) {
            if (noCalls) {
              state.stop = true;
              return base;
            }
            state.optionalChainMember = isOptionalCall = true;
            this.next();
          }
          if (this.match(47) || this.match(51)) {
            let missingParenErrorLoc;
            const result2 = this.tsTryParseAndCatch(() => {
              if (!noCalls && this.atPossibleAsyncArrow(base)) {
                const asyncArrowFn = this.tsTryParseGenericAsyncArrowFunction(startLoc);
                if (asyncArrowFn) {
                  state.stop = true;
                  return asyncArrowFn;
                }
              }
              const typeArguments = this.tsParseTypeArgumentsInExpression();
              if (!typeArguments)
                return;
              if (isOptionalCall && !this.match(10)) {
                missingParenErrorLoc = this.state.curPosition();
                return;
              }
              if (tokenIsTemplate(this.state.type)) {
                const result3 = super.parseTaggedTemplateExpression(base, startLoc, state);
                {
                  result3.typeParameters = typeArguments;
                }
                return result3;
              }
              if (!noCalls && this.eat(10)) {
                const node2 = this.startNodeAt(startLoc);
                node2.callee = base;
                node2.arguments = this.parseCallExpressionArguments();
                this.tsCheckForInvalidTypeCasts(node2.arguments);
                {
                  node2.typeParameters = typeArguments;
                }
                if (state.optionalChainMember) {
                  node2.optional = isOptionalCall;
                }
                return this.finishCallExpression(node2, state.optionalChainMember);
              }
              const tokenType = this.state.type;
              if (tokenType === 48 || tokenType === 52 || tokenType !== 10 && tokenCanStartExpression(tokenType) && !this.hasPrecedingLineBreak()) {
                return;
              }
              const node = this.startNodeAt(startLoc);
              node.expression = base;
              {
                node.typeParameters = typeArguments;
              }
              return this.finishNode(node, "TSInstantiationExpression");
            });
            if (missingParenErrorLoc) {
              this.unexpected(missingParenErrorLoc, 10);
            }
            if (result2) {
              if (result2.type === "TSInstantiationExpression") {
                if (this.match(16) || this.match(18) && this.lookaheadCharCode() !== 40) {
                  this.raise(TSErrors.InvalidPropertyAccessAfterInstantiationExpression, this.state.startLoc);
                }
                if (!this.match(16) && !this.match(18)) {
                  result2.expression = super.stopParseSubscript(base, state);
                }
              }
              return result2;
            }
          }
          return super.parseSubscript(base, startLoc, noCalls, state);
        }
        parseNewCallee(node) {
          var _callee$extra;
          super.parseNewCallee(node);
          const {
            callee
          } = node;
          if (callee.type === "TSInstantiationExpression" && !((_callee$extra = callee.extra) != null && _callee$extra.parenthesized)) {
            {
              node.typeParameters = callee.typeParameters;
            }
            node.callee = callee.expression;
          }
        }
        parseExprOp(left, leftStartLoc, minPrec) {
          let isSatisfies;
          if (tokenOperatorPrecedence(58) > minPrec && !this.hasPrecedingLineBreak() && (this.isContextual(93) || (isSatisfies = this.isContextual(120)))) {
            const node = this.startNodeAt(leftStartLoc);
            node.expression = left;
            node.typeAnnotation = this.tsInType(() => {
              this.next();
              if (this.match(75)) {
                if (isSatisfies) {
                  this.raise(Errors.UnexpectedKeyword, this.state.startLoc, {
                    keyword: "const"
                  });
                }
                return this.tsParseTypeReference();
              }
              return this.tsParseType();
            });
            this.finishNode(node, isSatisfies ? "TSSatisfiesExpression" : "TSAsExpression");
            this.reScan_lt_gt();
            return this.parseExprOp(node, leftStartLoc, minPrec);
          }
          return super.parseExprOp(left, leftStartLoc, minPrec);
        }
        checkReservedWord(word, startLoc, checkKeywords, isBinding) {
          if (!this.state.isAmbientContext) {
            super.checkReservedWord(word, startLoc, checkKeywords, isBinding);
          }
        }
        checkImportReflection(node) {
          super.checkImportReflection(node);
          if (node.module && node.importKind !== "value") {
            this.raise(TSErrors.ImportReflectionHasImportType, node.specifiers[0].loc.start);
          }
        }
        checkDuplicateExports() {
        }
        isPotentialImportPhase(isExport) {
          if (super.isPotentialImportPhase(isExport))
            return true;
          if (this.isContextual(130)) {
            const ch = this.lookaheadCharCode();
            return isExport ? ch === 123 || ch === 42 : ch !== 61;
          }
          return !isExport && this.isContextual(87);
        }
        applyImportPhase(node, isExport, phase, loc) {
          super.applyImportPhase(node, isExport, phase, loc);
          if (isExport) {
            node.exportKind = phase === "type" ? "type" : "value";
          } else {
            node.importKind = phase === "type" || phase === "typeof" ? phase : "value";
          }
        }
        parseImport(node) {
          if (this.match(134)) {
            node.importKind = "value";
            return super.parseImport(node);
          }
          let importNode;
          if (tokenIsIdentifier(this.state.type) && this.lookaheadCharCode() === 61) {
            node.importKind = "value";
            return this.tsParseImportEqualsDeclaration(node);
          } else if (this.isContextual(130)) {
            const maybeDefaultIdentifier = this.parseMaybeImportPhase(node, false);
            if (this.lookaheadCharCode() === 61) {
              return this.tsParseImportEqualsDeclaration(node, maybeDefaultIdentifier);
            } else {
              importNode = super.parseImportSpecifiersAndAfter(node, maybeDefaultIdentifier);
            }
          } else {
            importNode = super.parseImport(node);
          }
          if (importNode.importKind === "type" && importNode.specifiers.length > 1 && importNode.specifiers[0].type === "ImportDefaultSpecifier") {
            this.raise(TSErrors.TypeImportCannotSpecifyDefaultAndNamed, importNode);
          }
          return importNode;
        }
        parseExport(node, decorators) {
          if (this.match(83)) {
            const nodeImportEquals = node;
            this.next();
            let maybeDefaultIdentifier = null;
            if (this.isContextual(130) && this.isPotentialImportPhase(false)) {
              maybeDefaultIdentifier = this.parseMaybeImportPhase(nodeImportEquals, false);
            } else {
              nodeImportEquals.importKind = "value";
            }
            const declaration = this.tsParseImportEqualsDeclaration(nodeImportEquals, maybeDefaultIdentifier, true);
            {
              return declaration;
            }
          } else if (this.eat(29)) {
            const assign2 = node;
            assign2.expression = super.parseExpression();
            this.semicolon();
            this.sawUnambiguousESM = true;
            return this.finishNode(assign2, "TSExportAssignment");
          } else if (this.eatContextual(93)) {
            const decl = node;
            this.expectContextual(128);
            decl.id = this.parseIdentifier();
            this.semicolon();
            return this.finishNode(decl, "TSNamespaceExportDeclaration");
          } else {
            return super.parseExport(node, decorators);
          }
        }
        isAbstractClass() {
          return this.isContextual(124) && this.isLookaheadContextual("class");
        }
        parseExportDefaultExpression() {
          if (this.isAbstractClass()) {
            const cls = this.startNode();
            this.next();
            cls.abstract = true;
            return this.parseClass(cls, true, true);
          }
          if (this.match(129)) {
            const result2 = this.tsParseInterfaceDeclaration(this.startNode());
            if (result2)
              return result2;
          }
          return super.parseExportDefaultExpression();
        }
        parseVarStatement(node, kind, allowMissingInitializer = false) {
          const {
            isAmbientContext
          } = this.state;
          const declaration = super.parseVarStatement(node, kind, allowMissingInitializer || isAmbientContext);
          if (!isAmbientContext)
            return declaration;
          if (!node.declare && (kind === "using" || kind === "await using")) {
            this.raiseOverwrite(TSErrors.UsingDeclarationInAmbientContext, node, kind);
            return declaration;
          }
          for (const {
            id,
            init
          } of declaration.declarations) {
            if (!init)
              continue;
            if (kind === "var" || kind === "let" || !!id.typeAnnotation) {
              this.raise(TSErrors.InitializerNotAllowedInAmbientContext, init);
            } else if (!isValidAmbientConstInitializer(init, this.hasPlugin("estree"))) {
              this.raise(TSErrors.ConstInitializerMustBeStringOrNumericLiteralOrLiteralEnumReference, init);
            }
          }
          return declaration;
        }
        parseStatementContent(flags, decorators) {
          if (this.match(75) && this.isLookaheadContextual("enum")) {
            const node = this.startNode();
            this.expect(75);
            return this.tsParseEnumDeclaration(node, {
              const: true
            });
          }
          if (this.isContextual(126)) {
            return this.tsParseEnumDeclaration(this.startNode());
          }
          if (this.isContextual(129)) {
            const result2 = this.tsParseInterfaceDeclaration(this.startNode());
            if (result2)
              return result2;
          }
          return super.parseStatementContent(flags, decorators);
        }
        parseAccessModifier() {
          return this.tsParseModifier(["public", "protected", "private"]);
        }
        tsHasSomeModifiers(member, modifiers) {
          return modifiers.some((modifier) => {
            if (tsIsAccessModifier(modifier)) {
              return member.accessibility === modifier;
            }
            return !!member[modifier];
          });
        }
        tsIsStartOfStaticBlocks() {
          return this.isContextual(106) && this.lookaheadCharCode() === 123;
        }
        parseClassMember(classBody, member, state) {
          const modifiers = ["declare", "private", "public", "protected", "override", "abstract", "readonly", "static"];
          this.tsParseModifiers({
            allowedModifiers: modifiers,
            disallowedModifiers: ["in", "out"],
            stopOnStartOfClassStaticBlock: true,
            errorTemplate: TSErrors.InvalidModifierOnTypeParameterPositions
          }, member);
          const callParseClassMemberWithIsStatic = () => {
            if (this.tsIsStartOfStaticBlocks()) {
              this.next();
              this.next();
              if (this.tsHasSomeModifiers(member, modifiers)) {
                this.raise(TSErrors.StaticBlockCannotHaveModifier, this.state.curPosition());
              }
              super.parseClassStaticBlock(classBody, member);
            } else {
              this.parseClassMemberWithIsStatic(classBody, member, state, !!member.static);
            }
          };
          if (member.declare) {
            this.tsInAmbientContext(callParseClassMemberWithIsStatic);
          } else {
            callParseClassMemberWithIsStatic();
          }
        }
        parseClassMemberWithIsStatic(classBody, member, state, isStatic) {
          const idx = this.tsTryParseIndexSignature(member);
          if (idx) {
            classBody.body.push(idx);
            if (member.abstract) {
              this.raise(TSErrors.IndexSignatureHasAbstract, member);
            }
            if (member.accessibility) {
              this.raise(TSErrors.IndexSignatureHasAccessibility, member, {
                modifier: member.accessibility
              });
            }
            if (member.declare) {
              this.raise(TSErrors.IndexSignatureHasDeclare, member);
            }
            if (member.override) {
              this.raise(TSErrors.IndexSignatureHasOverride, member);
            }
            return;
          }
          if (!this.state.inAbstractClass && member.abstract) {
            this.raise(TSErrors.NonAbstractClassHasAbstractMethod, member);
          }
          if (member.override) {
            if (!state.hadSuperClass) {
              this.raise(TSErrors.OverrideNotInSubClass, member);
            }
          }
          super.parseClassMemberWithIsStatic(classBody, member, state, isStatic);
        }
        parsePostMemberNameModifiers(methodOrProp) {
          const optional = this.eat(17);
          if (optional)
            methodOrProp.optional = true;
          if (methodOrProp.readonly && this.match(10)) {
            this.raise(TSErrors.ClassMethodHasReadonly, methodOrProp);
          }
          if (methodOrProp.declare && this.match(10)) {
            this.raise(TSErrors.ClassMethodHasDeclare, methodOrProp);
          }
        }
        parseExpressionStatement(node, expr, decorators) {
          const decl = expr.type === "Identifier" ? this.tsParseExpressionStatement(node, expr, decorators) : void 0;
          return decl || super.parseExpressionStatement(node, expr, decorators);
        }
        shouldParseExportDeclaration() {
          if (this.tsIsDeclarationStart())
            return true;
          return super.shouldParseExportDeclaration();
        }
        parseConditional(expr, startLoc, refExpressionErrors) {
          if (!this.match(17))
            return expr;
          if (this.state.maybeInArrowParameters) {
            const nextCh = this.lookaheadCharCode();
            if (nextCh === 44 || nextCh === 61 || nextCh === 58 || nextCh === 41) {
              this.setOptionalParametersError(refExpressionErrors);
              return expr;
            }
          }
          return super.parseConditional(expr, startLoc, refExpressionErrors);
        }
        parseParenItem(node, startLoc) {
          const newNode = super.parseParenItem(node, startLoc);
          if (this.eat(17)) {
            newNode.optional = true;
            this.resetEndLocation(node);
          }
          if (this.match(14)) {
            const typeCastNode = this.startNodeAt(startLoc);
            typeCastNode.expression = node;
            typeCastNode.typeAnnotation = this.tsParseTypeAnnotation();
            return this.finishNode(typeCastNode, "TSTypeCastExpression");
          }
          return node;
        }
        parseExportDeclaration(node) {
          if (!this.state.isAmbientContext && this.isContextual(125)) {
            return this.tsInAmbientContext(() => this.parseExportDeclaration(node));
          }
          const startLoc = this.state.startLoc;
          const isDeclare = this.eatContextual(125);
          if (isDeclare && (this.isContextual(125) || !this.shouldParseExportDeclaration())) {
            throw this.raise(TSErrors.ExpectedAmbientAfterExportDeclare, this.state.startLoc);
          }
          const isIdentifier2 = tokenIsIdentifier(this.state.type);
          const declaration = isIdentifier2 && this.tsTryParseExportDeclaration() || super.parseExportDeclaration(node);
          if (!declaration)
            return null;
          if (declaration.type === "TSInterfaceDeclaration" || declaration.type === "TSTypeAliasDeclaration" || isDeclare) {
            node.exportKind = "type";
          }
          if (isDeclare && declaration.type !== "TSImportEqualsDeclaration") {
            this.resetStartLocation(declaration, startLoc);
            declaration.declare = true;
          }
          return declaration;
        }
        parseClassId(node, isStatement, optionalId, bindingType) {
          if ((!isStatement || optionalId) && this.isContextual(113)) {
            return;
          }
          super.parseClassId(node, isStatement, optionalId, node.declare ? 1024 : 8331);
          const typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutConstModifiers);
          if (typeParameters)
            node.typeParameters = typeParameters;
        }
        parseClassPropertyAnnotation(node) {
          if (!node.optional) {
            if (this.eat(35)) {
              node.definite = true;
            } else if (this.eat(17)) {
              node.optional = true;
            }
          }
          const type = this.tsTryParseTypeAnnotation();
          if (type)
            node.typeAnnotation = type;
        }
        parseClassProperty(node) {
          this.parseClassPropertyAnnotation(node);
          if (this.state.isAmbientContext && !(node.readonly && !node.typeAnnotation) && this.match(29)) {
            this.raise(TSErrors.DeclareClassFieldHasInitializer, this.state.startLoc);
          }
          if (node.abstract && this.match(29)) {
            const {
              key
            } = node;
            this.raise(TSErrors.AbstractPropertyHasInitializer, this.state.startLoc, {
              propertyName: key.type === "Identifier" && !node.computed ? key.name : `[${this.input.slice(this.offsetToSourcePos(key.start), this.offsetToSourcePos(key.end))}]`
            });
          }
          return super.parseClassProperty(node);
        }
        parseClassPrivateProperty(node) {
          if (node.abstract) {
            this.raise(TSErrors.PrivateElementHasAbstract, node);
          }
          if (node.accessibility) {
            this.raise(TSErrors.PrivateElementHasAccessibility, node, {
              modifier: node.accessibility
            });
          }
          this.parseClassPropertyAnnotation(node);
          return super.parseClassPrivateProperty(node);
        }
        parseClassAccessorProperty(node) {
          this.parseClassPropertyAnnotation(node);
          if (node.optional) {
            this.raise(TSErrors.AccessorCannotBeOptional, node);
          }
          return super.parseClassAccessorProperty(node);
        }
        pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper) {
          const typeParameters = this.tsTryParseTypeParameters(this.tsParseConstModifier);
          if (typeParameters && isConstructor) {
            this.raise(TSErrors.ConstructorHasTypeParameters, typeParameters);
          }
          const {
            declare = false,
            kind
          } = method2;
          if (declare && (kind === "get" || kind === "set")) {
            this.raise(TSErrors.DeclareAccessor, method2, {
              kind
            });
          }
          if (typeParameters)
            method2.typeParameters = typeParameters;
          super.pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper);
        }
        pushClassPrivateMethod(classBody, method2, isGenerator, isAsync) {
          const typeParameters = this.tsTryParseTypeParameters(this.tsParseConstModifier);
          if (typeParameters)
            method2.typeParameters = typeParameters;
          super.pushClassPrivateMethod(classBody, method2, isGenerator, isAsync);
        }
        declareClassPrivateMethodInScope(node, kind) {
          if (node.type === "TSDeclareMethod")
            return;
          if (node.type === "MethodDefinition" && node.value.body == null) {
            return;
          }
          super.declareClassPrivateMethodInScope(node, kind);
        }
        parseClassSuper(node) {
          super.parseClassSuper(node);
          if (node.superClass && (this.match(47) || this.match(51))) {
            {
              node.superTypeParameters = this.tsParseTypeArgumentsInExpression();
            }
          }
          if (this.eatContextual(113)) {
            node.implements = this.tsParseHeritageClause("implements");
          }
        }
        parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors) {
          const typeParameters = this.tsTryParseTypeParameters(this.tsParseConstModifier);
          if (typeParameters)
            prop.typeParameters = typeParameters;
          return super.parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors);
        }
        parseFunctionParams(node, isConstructor) {
          const typeParameters = this.tsTryParseTypeParameters(this.tsParseConstModifier);
          if (typeParameters)
            node.typeParameters = typeParameters;
          super.parseFunctionParams(node, isConstructor);
        }
        parseVarId(decl, kind) {
          super.parseVarId(decl, kind);
          if (decl.id.type === "Identifier" && !this.hasPrecedingLineBreak() && this.eat(35)) {
            decl.definite = true;
          }
          const type = this.tsTryParseTypeAnnotation();
          if (type) {
            decl.id.typeAnnotation = type;
            this.resetEndLocation(decl.id);
          }
        }
        parseAsyncArrowFromCallExpression(node, call) {
          if (this.match(14)) {
            node.returnType = this.tsParseTypeAnnotation();
          }
          return super.parseAsyncArrowFromCallExpression(node, call);
        }
        parseMaybeAssign(refExpressionErrors, afterLeftParse) {
          var _jsx, _jsx2, _typeCast, _jsx3, _typeCast2;
          let state;
          let jsx2;
          let typeCast;
          if (this.hasPlugin("jsx") && (this.match(143) || this.match(47))) {
            state = this.state.clone();
            jsx2 = this.tryParse(() => super.parseMaybeAssign(refExpressionErrors, afterLeftParse), state);
            if (!jsx2.error)
              return jsx2.node;
            const {
              context
            } = this.state;
            const currentContext = context[context.length - 1];
            if (currentContext === types2.j_oTag || currentContext === types2.j_expr) {
              context.pop();
            }
          }
          if (!((_jsx = jsx2) != null && _jsx.error) && !this.match(47)) {
            return super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
          }
          if (!state || state === this.state)
            state = this.state.clone();
          let typeParameters;
          const arrow = this.tryParse((abort3) => {
            var _expr$extra, _typeParameters;
            typeParameters = this.tsParseTypeParameters(this.tsParseConstModifier);
            const expr = super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
            if (expr.type !== "ArrowFunctionExpression" || (_expr$extra = expr.extra) != null && _expr$extra.parenthesized) {
              abort3();
            }
            if (((_typeParameters = typeParameters) == null ? void 0 : _typeParameters.params.length) !== 0) {
              this.resetStartLocationFromNode(expr, typeParameters);
            }
            expr.typeParameters = typeParameters;
            return expr;
          }, state);
          if (!arrow.error && !arrow.aborted) {
            if (typeParameters)
              this.reportReservedArrowTypeParam(typeParameters);
            return arrow.node;
          }
          if (!jsx2) {
            assert3(!this.hasPlugin("jsx"));
            typeCast = this.tryParse(() => super.parseMaybeAssign(refExpressionErrors, afterLeftParse), state);
            if (!typeCast.error)
              return typeCast.node;
          }
          if ((_jsx2 = jsx2) != null && _jsx2.node) {
            this.state = jsx2.failState;
            return jsx2.node;
          }
          if (arrow.node) {
            this.state = arrow.failState;
            if (typeParameters)
              this.reportReservedArrowTypeParam(typeParameters);
            return arrow.node;
          }
          if ((_typeCast = typeCast) != null && _typeCast.node) {
            this.state = typeCast.failState;
            return typeCast.node;
          }
          throw ((_jsx3 = jsx2) == null ? void 0 : _jsx3.error) || arrow.error || ((_typeCast2 = typeCast) == null ? void 0 : _typeCast2.error);
        }
        reportReservedArrowTypeParam(node) {
          var _node$extra2;
          if (node.params.length === 1 && !node.params[0].constraint && !((_node$extra2 = node.extra) != null && _node$extra2.trailingComma) && this.getPluginOption("typescript", "disallowAmbiguousJSXLike")) {
            this.raise(TSErrors.ReservedArrowTypeParam, node);
          }
        }
        parseMaybeUnary(refExpressionErrors, sawUnary) {
          if (!this.hasPlugin("jsx") && this.match(47)) {
            return this.tsParseTypeAssertion();
          }
          return super.parseMaybeUnary(refExpressionErrors, sawUnary);
        }
        parseArrow(node) {
          if (this.match(14)) {
            const result2 = this.tryParse((abort3) => {
              const returnType = this.tsParseTypeOrTypePredicateAnnotation(14);
              if (this.canInsertSemicolon() || !this.match(19))
                abort3();
              return returnType;
            });
            if (result2.aborted)
              return;
            if (!result2.thrown) {
              if (result2.error)
                this.state = result2.failState;
              node.returnType = result2.node;
            }
          }
          return super.parseArrow(node);
        }
        parseFunctionParamType(param) {
          if (this.eat(17)) {
            param.optional = true;
          }
          const type = this.tsTryParseTypeAnnotation();
          if (type)
            param.typeAnnotation = type;
          this.resetEndLocation(param);
          return param;
        }
        isAssignable(node, isBinding) {
          switch (node.type) {
            case "TSTypeCastExpression":
              return this.isAssignable(node.expression, isBinding);
            case "TSParameterProperty":
              return true;
            default:
              return super.isAssignable(node, isBinding);
          }
        }
        toAssignable(node, isLHS = false) {
          switch (node.type) {
            case "ParenthesizedExpression":
              this.toAssignableParenthesizedExpression(node, isLHS);
              break;
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "TSNonNullExpression":
            case "TSTypeAssertion":
              if (isLHS) {
                this.expressionScope.recordArrowParameterBindingError(TSErrors.UnexpectedTypeCastInParameter, node);
              } else {
                this.raise(TSErrors.UnexpectedTypeCastInParameter, node);
              }
              this.toAssignable(node.expression, isLHS);
              break;
            case "AssignmentExpression":
              if (!isLHS && node.left.type === "TSTypeCastExpression") {
                node.left = this.typeCastToParameter(node.left);
              }
            default:
              super.toAssignable(node, isLHS);
          }
        }
        toAssignableParenthesizedExpression(node, isLHS) {
          switch (node.expression.type) {
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "TSNonNullExpression":
            case "TSTypeAssertion":
            case "ParenthesizedExpression":
              this.toAssignable(node.expression, isLHS);
              break;
            default:
              super.toAssignable(node, isLHS);
          }
        }
        checkToRestConversion(node, allowPattern) {
          switch (node.type) {
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "TSTypeAssertion":
            case "TSNonNullExpression":
              this.checkToRestConversion(node.expression, false);
              break;
            default:
              super.checkToRestConversion(node, allowPattern);
          }
        }
        isValidLVal(type, isUnparenthesizedInAssign, binding3) {
          switch (type) {
            case "TSTypeCastExpression":
              return true;
            case "TSParameterProperty":
              return "parameter";
            case "TSNonNullExpression":
              return "expression";
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "TSTypeAssertion":
              return (binding3 !== 64 || !isUnparenthesizedInAssign) && ["expression", true];
            default:
              return super.isValidLVal(type, isUnparenthesizedInAssign, binding3);
          }
        }
        parseBindingAtom() {
          if (this.state.type === 78) {
            return this.parseIdentifier(true);
          }
          return super.parseBindingAtom();
        }
        parseMaybeDecoratorArguments(expr, startLoc) {
          if (this.match(47) || this.match(51)) {
            const typeArguments = this.tsParseTypeArgumentsInExpression();
            if (this.match(10)) {
              const call = super.parseMaybeDecoratorArguments(expr, startLoc);
              {
                call.typeParameters = typeArguments;
              }
              return call;
            }
            this.unexpected(null, 10);
          }
          return super.parseMaybeDecoratorArguments(expr, startLoc);
        }
        checkCommaAfterRest(close) {
          if (this.state.isAmbientContext && this.match(12) && this.lookaheadCharCode() === close) {
            this.next();
            return false;
          }
          return super.checkCommaAfterRest(close);
        }
        isClassMethod() {
          return this.match(47) || super.isClassMethod();
        }
        isClassProperty() {
          return this.match(35) || this.match(14) || super.isClassProperty();
        }
        parseMaybeDefault(startLoc, left) {
          const node = super.parseMaybeDefault(startLoc, left);
          if (node.type === "AssignmentPattern" && node.typeAnnotation && node.right.start < node.typeAnnotation.start) {
            this.raise(TSErrors.TypeAnnotationAfterAssign, node.typeAnnotation);
          }
          return node;
        }
        getTokenFromCode(code2) {
          if (this.state.inType) {
            if (code2 === 62) {
              this.finishOp(48, 1);
              return;
            }
            if (code2 === 60) {
              this.finishOp(47, 1);
              return;
            }
          }
          super.getTokenFromCode(code2);
        }
        reScan_lt_gt() {
          const {
            type
          } = this.state;
          if (type === 47) {
            this.state.pos -= 1;
            this.readToken_lt();
          } else if (type === 48) {
            this.state.pos -= 1;
            this.readToken_gt();
          }
        }
        reScan_lt() {
          const {
            type
          } = this.state;
          if (type === 51) {
            this.state.pos -= 2;
            this.finishOp(47, 1);
            return 47;
          }
          return type;
        }
        toAssignableListItem(exprList, index, isLHS) {
          const node = exprList[index];
          if (node.type === "TSTypeCastExpression") {
            exprList[index] = this.typeCastToParameter(node);
          }
          super.toAssignableListItem(exprList, index, isLHS);
        }
        typeCastToParameter(node) {
          node.expression.typeAnnotation = node.typeAnnotation;
          this.resetEndLocation(node.expression, node.typeAnnotation.loc.end);
          return node.expression;
        }
        shouldParseArrow(params) {
          if (this.match(14)) {
            return params.every((expr) => this.isAssignable(expr, true));
          }
          return super.shouldParseArrow(params);
        }
        shouldParseAsyncArrow() {
          return this.match(14) || super.shouldParseAsyncArrow();
        }
        canHaveLeadingDecorator() {
          return super.canHaveLeadingDecorator() || this.isAbstractClass();
        }
        jsxParseOpeningElementAfterName(node) {
          if (this.match(47) || this.match(51)) {
            const typeArguments = this.tsTryParseAndCatch(() => this.tsParseTypeArgumentsInExpression());
            if (typeArguments) {
              {
                node.typeParameters = typeArguments;
              }
            }
          }
          return super.jsxParseOpeningElementAfterName(node);
        }
        getGetterSetterExpectedParamCount(method2) {
          const baseCount = super.getGetterSetterExpectedParamCount(method2);
          const params = this.getObjectOrClassMethodParams(method2);
          const firstParam = params[0];
          const hasContextParam = firstParam && this.isThisParam(firstParam);
          return hasContextParam ? baseCount + 1 : baseCount;
        }
        parseCatchClauseParam() {
          const param = super.parseCatchClauseParam();
          const type = this.tsTryParseTypeAnnotation();
          if (type) {
            param.typeAnnotation = type;
            this.resetEndLocation(param);
          }
          return param;
        }
        tsInAmbientContext(cb) {
          const {
            isAmbientContext: oldIsAmbientContext,
            strict: oldStrict
          } = this.state;
          this.state.isAmbientContext = true;
          this.state.strict = false;
          try {
            return cb();
          } finally {
            this.state.isAmbientContext = oldIsAmbientContext;
            this.state.strict = oldStrict;
          }
        }
        parseClass(node, isStatement, optionalId) {
          const oldInAbstractClass = this.state.inAbstractClass;
          this.state.inAbstractClass = !!node.abstract;
          try {
            return super.parseClass(node, isStatement, optionalId);
          } finally {
            this.state.inAbstractClass = oldInAbstractClass;
          }
        }
        tsParseAbstractDeclaration(node, decorators) {
          if (this.match(80)) {
            node.abstract = true;
            return this.maybeTakeDecorators(decorators, this.parseClass(node, true, false));
          } else if (this.isContextual(129)) {
            if (!this.hasFollowingLineBreak()) {
              node.abstract = true;
              this.raise(TSErrors.NonClassMethodPropertyHasAbstractModifier, node);
              return this.tsParseInterfaceDeclaration(node);
            }
          } else {
            this.unexpected(null, 80);
          }
        }
        parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope) {
          const method2 = super.parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope);
          if (method2.abstract || method2.type === "TSAbstractMethodDefinition") {
            const hasEstreePlugin = this.hasPlugin("estree");
            const methodFn = hasEstreePlugin ? method2.value : method2;
            if (methodFn.body) {
              const {
                key
              } = method2;
              this.raise(TSErrors.AbstractMethodHasImplementation, method2, {
                methodName: key.type === "Identifier" && !method2.computed ? key.name : `[${this.input.slice(this.offsetToSourcePos(key.start), this.offsetToSourcePos(key.end))}]`
              });
            }
          }
          return method2;
        }
        tsParseTypeParameterName() {
          const typeName = this.parseIdentifier();
          return typeName.name;
        }
        shouldParseAsAmbientContext() {
          return !!this.getPluginOption("typescript", "dts");
        }
        parse() {
          if (this.shouldParseAsAmbientContext()) {
            this.state.isAmbientContext = true;
          }
          return super.parse();
        }
        getExpression() {
          if (this.shouldParseAsAmbientContext()) {
            this.state.isAmbientContext = true;
          }
          return super.getExpression();
        }
        parseExportSpecifier(node, isString3, isInTypeExport, isMaybeTypeOnly) {
          if (!isString3 && isMaybeTypeOnly) {
            this.parseTypeOnlyImportExportSpecifier(node, false, isInTypeExport);
            return this.finishNode(node, "ExportSpecifier");
          }
          node.exportKind = "value";
          return super.parseExportSpecifier(node, isString3, isInTypeExport, isMaybeTypeOnly);
        }
        parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, bindingType) {
          if (!importedIsString && isMaybeTypeOnly) {
            this.parseTypeOnlyImportExportSpecifier(specifier, true, isInTypeOnlyImport);
            return this.finishNode(specifier, "ImportSpecifier");
          }
          specifier.importKind = "value";
          return super.parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, isInTypeOnlyImport ? 4098 : 4096);
        }
        parseTypeOnlyImportExportSpecifier(node, isImport, isInTypeOnlyImportExport) {
          const leftOfAsKey = isImport ? "imported" : "local";
          const rightOfAsKey = isImport ? "local" : "exported";
          let leftOfAs = node[leftOfAsKey];
          let rightOfAs;
          let hasTypeSpecifier = false;
          let canParseAsKeyword = true;
          const loc = leftOfAs.loc.start;
          if (this.isContextual(93)) {
            const firstAs = this.parseIdentifier();
            if (this.isContextual(93)) {
              const secondAs = this.parseIdentifier();
              if (tokenIsKeywordOrIdentifier(this.state.type)) {
                hasTypeSpecifier = true;
                leftOfAs = firstAs;
                rightOfAs = isImport ? this.parseIdentifier() : this.parseModuleExportName();
                canParseAsKeyword = false;
              } else {
                rightOfAs = secondAs;
                canParseAsKeyword = false;
              }
            } else if (tokenIsKeywordOrIdentifier(this.state.type)) {
              canParseAsKeyword = false;
              rightOfAs = isImport ? this.parseIdentifier() : this.parseModuleExportName();
            } else {
              hasTypeSpecifier = true;
              leftOfAs = firstAs;
            }
          } else if (tokenIsKeywordOrIdentifier(this.state.type)) {
            hasTypeSpecifier = true;
            if (isImport) {
              leftOfAs = this.parseIdentifier(true);
              if (!this.isContextual(93)) {
                this.checkReservedWord(leftOfAs.name, leftOfAs.loc.start, true, true);
              }
            } else {
              leftOfAs = this.parseModuleExportName();
            }
          }
          if (hasTypeSpecifier && isInTypeOnlyImportExport) {
            this.raise(isImport ? TSErrors.TypeModifierIsUsedInTypeImports : TSErrors.TypeModifierIsUsedInTypeExports, loc);
          }
          node[leftOfAsKey] = leftOfAs;
          node[rightOfAsKey] = rightOfAs;
          const kindKey = isImport ? "importKind" : "exportKind";
          node[kindKey] = hasTypeSpecifier ? "type" : "value";
          if (canParseAsKeyword && this.eatContextual(93)) {
            node[rightOfAsKey] = isImport ? this.parseIdentifier() : this.parseModuleExportName();
          }
          if (!node[rightOfAsKey]) {
            node[rightOfAsKey] = this.cloneIdentifier(node[leftOfAsKey]);
          }
          if (isImport) {
            this.checkIdentifier(node[rightOfAsKey], hasTypeSpecifier ? 4098 : 4096);
          }
        }
        fillOptionalPropertiesForTSESLint(node) {
          var _node$directive, _node$decorators, _node$optional, _node$typeAnnotation, _node$accessibility, _node$decorators2, _node$override, _node$readonly, _node$static, _node$declare, _node$returnType, _node$typeParameters, _node$optional2, _node$optional3, _node$accessibility2, _node$readonly2, _node$static2, _node$declare2, _node$definite, _node$readonly3, _node$typeAnnotation2, _node$accessibility3, _node$decorators3, _node$override2, _node$optional4, _node$id, _node$abstract, _node$declare3, _node$decorators4, _node$implements, _node$superTypeArgume, _node$typeParameters2, _node$declare4, _node$definite2, _node$const, _node$declare5, _node$computed, _node$qualifier, _node$options, _node$declare6, _node$extends, _node$declare7, _node$global, _node$const2, _node$in, _node$out;
          switch (node.type) {
            case "ExpressionStatement":
              (_node$directive = node.directive) != null ? _node$directive : node.directive = void 0;
              return;
            case "RestElement":
              node.value = void 0;
            case "Identifier":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "ObjectPattern":
              (_node$decorators = node.decorators) != null ? _node$decorators : node.decorators = [];
              (_node$optional = node.optional) != null ? _node$optional : node.optional = false;
              (_node$typeAnnotation = node.typeAnnotation) != null ? _node$typeAnnotation : node.typeAnnotation = void 0;
              return;
            case "TSParameterProperty":
              (_node$accessibility = node.accessibility) != null ? _node$accessibility : node.accessibility = void 0;
              (_node$decorators2 = node.decorators) != null ? _node$decorators2 : node.decorators = [];
              (_node$override = node.override) != null ? _node$override : node.override = false;
              (_node$readonly = node.readonly) != null ? _node$readonly : node.readonly = false;
              (_node$static = node.static) != null ? _node$static : node.static = false;
              return;
            case "TSEmptyBodyFunctionExpression":
              node.body = null;
            case "TSDeclareFunction":
            case "FunctionDeclaration":
            case "FunctionExpression":
            case "ClassMethod":
            case "ClassPrivateMethod":
              (_node$declare = node.declare) != null ? _node$declare : node.declare = false;
              (_node$returnType = node.returnType) != null ? _node$returnType : node.returnType = void 0;
              (_node$typeParameters = node.typeParameters) != null ? _node$typeParameters : node.typeParameters = void 0;
              return;
            case "Property":
              (_node$optional2 = node.optional) != null ? _node$optional2 : node.optional = false;
              return;
            case "TSMethodSignature":
            case "TSPropertySignature":
              (_node$optional3 = node.optional) != null ? _node$optional3 : node.optional = false;
            case "TSIndexSignature":
              (_node$accessibility2 = node.accessibility) != null ? _node$accessibility2 : node.accessibility = void 0;
              (_node$readonly2 = node.readonly) != null ? _node$readonly2 : node.readonly = false;
              (_node$static2 = node.static) != null ? _node$static2 : node.static = false;
              return;
            case "TSAbstractPropertyDefinition":
            case "PropertyDefinition":
            case "TSAbstractAccessorProperty":
            case "AccessorProperty":
              (_node$declare2 = node.declare) != null ? _node$declare2 : node.declare = false;
              (_node$definite = node.definite) != null ? _node$definite : node.definite = false;
              (_node$readonly3 = node.readonly) != null ? _node$readonly3 : node.readonly = false;
              (_node$typeAnnotation2 = node.typeAnnotation) != null ? _node$typeAnnotation2 : node.typeAnnotation = void 0;
            case "TSAbstractMethodDefinition":
            case "MethodDefinition":
              (_node$accessibility3 = node.accessibility) != null ? _node$accessibility3 : node.accessibility = void 0;
              (_node$decorators3 = node.decorators) != null ? _node$decorators3 : node.decorators = [];
              (_node$override2 = node.override) != null ? _node$override2 : node.override = false;
              (_node$optional4 = node.optional) != null ? _node$optional4 : node.optional = false;
              return;
            case "ClassExpression":
              (_node$id = node.id) != null ? _node$id : node.id = null;
            case "ClassDeclaration":
              (_node$abstract = node.abstract) != null ? _node$abstract : node.abstract = false;
              (_node$declare3 = node.declare) != null ? _node$declare3 : node.declare = false;
              (_node$decorators4 = node.decorators) != null ? _node$decorators4 : node.decorators = [];
              (_node$implements = node.implements) != null ? _node$implements : node.implements = [];
              (_node$superTypeArgume = node.superTypeArguments) != null ? _node$superTypeArgume : node.superTypeArguments = void 0;
              (_node$typeParameters2 = node.typeParameters) != null ? _node$typeParameters2 : node.typeParameters = void 0;
              return;
            case "TSTypeAliasDeclaration":
            case "VariableDeclaration":
              (_node$declare4 = node.declare) != null ? _node$declare4 : node.declare = false;
              return;
            case "VariableDeclarator":
              (_node$definite2 = node.definite) != null ? _node$definite2 : node.definite = false;
              return;
            case "TSEnumDeclaration":
              (_node$const = node.const) != null ? _node$const : node.const = false;
              (_node$declare5 = node.declare) != null ? _node$declare5 : node.declare = false;
              return;
            case "TSEnumMember":
              (_node$computed = node.computed) != null ? _node$computed : node.computed = false;
              return;
            case "TSImportType":
              (_node$qualifier = node.qualifier) != null ? _node$qualifier : node.qualifier = null;
              (_node$options = node.options) != null ? _node$options : node.options = null;
              return;
            case "TSInterfaceDeclaration":
              (_node$declare6 = node.declare) != null ? _node$declare6 : node.declare = false;
              (_node$extends = node.extends) != null ? _node$extends : node.extends = [];
              return;
            case "TSModuleDeclaration":
              (_node$declare7 = node.declare) != null ? _node$declare7 : node.declare = false;
              (_node$global = node.global) != null ? _node$global : node.global = node.kind === "global";
              return;
            case "TSTypeParameter":
              (_node$const2 = node.const) != null ? _node$const2 : node.const = false;
              (_node$in = node.in) != null ? _node$in : node.in = false;
              (_node$out = node.out) != null ? _node$out : node.out = false;
              return;
          }
        }
      };
      function isPossiblyLiteralEnum(expression) {
        if (expression.type !== "MemberExpression")
          return false;
        const {
          computed,
          property: property2
        } = expression;
        if (computed && property2.type !== "StringLiteral" && (property2.type !== "TemplateLiteral" || property2.expressions.length > 0)) {
          return false;
        }
        return isUncomputedMemberExpressionChain(expression.object);
      }
      function isValidAmbientConstInitializer(expression, estree2) {
        var _expression$extra;
        const {
          type
        } = expression;
        if ((_expression$extra = expression.extra) != null && _expression$extra.parenthesized) {
          return false;
        }
        if (estree2) {
          if (type === "Literal") {
            const {
              value
            } = expression;
            if (typeof value === "string" || typeof value === "boolean") {
              return true;
            }
          }
        } else {
          if (type === "StringLiteral" || type === "BooleanLiteral") {
            return true;
          }
        }
        if (isNumber3(expression, estree2) || isNegativeNumber(expression, estree2)) {
          return true;
        }
        if (type === "TemplateLiteral" && expression.expressions.length === 0) {
          return true;
        }
        if (isPossiblyLiteralEnum(expression)) {
          return true;
        }
        return false;
      }
      function isNumber3(expression, estree2) {
        if (estree2) {
          return expression.type === "Literal" && (typeof expression.value === "number" || "bigint" in expression);
        }
        return expression.type === "NumericLiteral" || expression.type === "BigIntLiteral";
      }
      function isNegativeNumber(expression, estree2) {
        if (expression.type === "UnaryExpression") {
          const {
            operator,
            argument
          } = expression;
          if (operator === "-" && isNumber3(argument, estree2)) {
            return true;
          }
        }
        return false;
      }
      function isUncomputedMemberExpressionChain(expression) {
        if (expression.type === "Identifier")
          return true;
        if (expression.type !== "MemberExpression" || expression.computed) {
          return false;
        }
        return isUncomputedMemberExpressionChain(expression.object);
      }
      var PlaceholderErrors = ParseErrorEnum`placeholders`({
        ClassNameIsRequired: "A class name is required.",
        UnexpectedSpace: "Unexpected space in placeholder."
      });
      var placeholders = (superClass) => class PlaceholdersParserMixin extends superClass {
        parsePlaceholder(expectedNode) {
          if (this.match(133)) {
            const node = this.startNode();
            this.next();
            this.assertNoSpace();
            node.name = super.parseIdentifier(true);
            this.assertNoSpace();
            this.expect(133);
            return this.finishPlaceholder(node, expectedNode);
          }
        }
        finishPlaceholder(node, expectedNode) {
          let placeholder = node;
          if (!placeholder.expectedNode || !placeholder.type) {
            placeholder = this.finishNode(placeholder, "Placeholder");
          }
          placeholder.expectedNode = expectedNode;
          return placeholder;
        }
        getTokenFromCode(code2) {
          if (code2 === 37 && this.input.charCodeAt(this.state.pos + 1) === 37) {
            this.finishOp(133, 2);
          } else {
            super.getTokenFromCode(code2);
          }
        }
        parseExprAtom(refExpressionErrors) {
          return this.parsePlaceholder("Expression") || super.parseExprAtom(refExpressionErrors);
        }
        parseIdentifier(liberal) {
          return this.parsePlaceholder("Identifier") || super.parseIdentifier(liberal);
        }
        checkReservedWord(word, startLoc, checkKeywords, isBinding) {
          if (word !== void 0) {
            super.checkReservedWord(word, startLoc, checkKeywords, isBinding);
          }
        }
        cloneIdentifier(node) {
          const cloned = super.cloneIdentifier(node);
          if (cloned.type === "Placeholder") {
            cloned.expectedNode = node.expectedNode;
          }
          return cloned;
        }
        cloneStringLiteral(node) {
          if (node.type === "Placeholder") {
            return this.cloneIdentifier(node);
          }
          return super.cloneStringLiteral(node);
        }
        parseBindingAtom() {
          return this.parsePlaceholder("Pattern") || super.parseBindingAtom();
        }
        isValidLVal(type, isParenthesized, binding3) {
          return type === "Placeholder" || super.isValidLVal(type, isParenthesized, binding3);
        }
        toAssignable(node, isLHS) {
          if (node && node.type === "Placeholder" && node.expectedNode === "Expression") {
            node.expectedNode = "Pattern";
          } else {
            super.toAssignable(node, isLHS);
          }
        }
        chStartsBindingIdentifier(ch, pos) {
          if (super.chStartsBindingIdentifier(ch, pos)) {
            return true;
          }
          const next = this.nextTokenStart();
          if (this.input.charCodeAt(next) === 37 && this.input.charCodeAt(next + 1) === 37) {
            return true;
          }
          return false;
        }
        verifyBreakContinue(node, isBreak) {
          if (node.label && node.label.type === "Placeholder")
            return;
          super.verifyBreakContinue(node, isBreak);
        }
        parseExpressionStatement(node, expr) {
          var _expr$extra;
          if (expr.type !== "Placeholder" || (_expr$extra = expr.extra) != null && _expr$extra.parenthesized) {
            return super.parseExpressionStatement(node, expr);
          }
          if (this.match(14)) {
            const stmt = node;
            stmt.label = this.finishPlaceholder(expr, "Identifier");
            this.next();
            stmt.body = super.parseStatementOrSloppyAnnexBFunctionDeclaration();
            return this.finishNode(stmt, "LabeledStatement");
          }
          this.semicolon();
          const stmtPlaceholder = node;
          stmtPlaceholder.name = expr.name;
          return this.finishPlaceholder(stmtPlaceholder, "Statement");
        }
        parseBlock(allowDirectives, createNewLexicalScope, afterBlockParse) {
          return this.parsePlaceholder("BlockStatement") || super.parseBlock(allowDirectives, createNewLexicalScope, afterBlockParse);
        }
        parseFunctionId(requireId) {
          return this.parsePlaceholder("Identifier") || super.parseFunctionId(requireId);
        }
        parseClass(node, isStatement, optionalId) {
          const type = isStatement ? "ClassDeclaration" : "ClassExpression";
          this.next();
          const oldStrict = this.state.strict;
          const placeholder = this.parsePlaceholder("Identifier");
          if (placeholder) {
            if (this.match(81) || this.match(133) || this.match(5)) {
              node.id = placeholder;
            } else if (optionalId || !isStatement) {
              node.id = null;
              node.body = this.finishPlaceholder(placeholder, "ClassBody");
              return this.finishNode(node, type);
            } else {
              throw this.raise(PlaceholderErrors.ClassNameIsRequired, this.state.startLoc);
            }
          } else {
            this.parseClassId(node, isStatement, optionalId);
          }
          super.parseClassSuper(node);
          node.body = this.parsePlaceholder("ClassBody") || super.parseClassBody(!!node.superClass, oldStrict);
          return this.finishNode(node, type);
        }
        parseExport(node, decorators) {
          const placeholder = this.parsePlaceholder("Identifier");
          if (!placeholder)
            return super.parseExport(node, decorators);
          const node2 = node;
          if (!this.isContextual(98) && !this.match(12)) {
            node2.specifiers = [];
            node2.source = null;
            node2.declaration = this.finishPlaceholder(placeholder, "Declaration");
            return this.finishNode(node2, "ExportNamedDeclaration");
          }
          this.expectPlugin("exportDefaultFrom");
          const specifier = this.startNode();
          specifier.exported = placeholder;
          node2.specifiers = [this.finishNode(specifier, "ExportDefaultSpecifier")];
          return super.parseExport(node2, decorators);
        }
        isExportDefaultSpecifier() {
          if (this.match(65)) {
            const next = this.nextTokenStart();
            if (this.isUnparsedContextual(next, "from")) {
              if (this.input.startsWith(tokenLabelName(133), this.nextTokenStartSince(next + 4))) {
                return true;
              }
            }
          }
          return super.isExportDefaultSpecifier();
        }
        maybeParseExportDefaultSpecifier(node, maybeDefaultIdentifier) {
          var _specifiers;
          if ((_specifiers = node.specifiers) != null && _specifiers.length) {
            return true;
          }
          return super.maybeParseExportDefaultSpecifier(node, maybeDefaultIdentifier);
        }
        checkExport(node) {
          const {
            specifiers
          } = node;
          if (specifiers != null && specifiers.length) {
            node.specifiers = specifiers.filter((node2) => node2.exported.type === "Placeholder");
          }
          super.checkExport(node);
          node.specifiers = specifiers;
        }
        parseImport(node) {
          const placeholder = this.parsePlaceholder("Identifier");
          if (!placeholder)
            return super.parseImport(node);
          node.specifiers = [];
          if (!this.isContextual(98) && !this.match(12)) {
            node.source = this.finishPlaceholder(placeholder, "StringLiteral");
            this.semicolon();
            return this.finishNode(node, "ImportDeclaration");
          }
          const specifier = this.startNodeAtNode(placeholder);
          specifier.local = placeholder;
          node.specifiers.push(this.finishNode(specifier, "ImportDefaultSpecifier"));
          if (this.eat(12)) {
            const hasStarImport = this.maybeParseStarImportSpecifier(node);
            if (!hasStarImport)
              this.parseNamedImportSpecifiers(node);
          }
          this.expectContextual(98);
          node.source = this.parseImportSource();
          this.semicolon();
          return this.finishNode(node, "ImportDeclaration");
        }
        parseImportSource() {
          return this.parsePlaceholder("StringLiteral") || super.parseImportSource();
        }
        assertNoSpace() {
          if (this.state.start > this.offsetToSourcePos(this.state.lastTokEndLoc.index)) {
            this.raise(PlaceholderErrors.UnexpectedSpace, this.state.lastTokEndLoc);
          }
        }
      };
      var v8intrinsic = (superClass) => class V8IntrinsicMixin extends superClass {
        parseV8Intrinsic() {
          if (this.match(54)) {
            const v8IntrinsicStartLoc = this.state.startLoc;
            const node = this.startNode();
            this.next();
            if (tokenIsIdentifier(this.state.type)) {
              const name = this.parseIdentifierName();
              const identifier3 = this.createIdentifier(node, name);
              this.castNodeTo(identifier3, "V8IntrinsicIdentifier");
              if (this.match(10)) {
                return identifier3;
              }
            }
            this.unexpected(v8IntrinsicStartLoc);
          }
        }
        parseExprAtom(refExpressionErrors) {
          return this.parseV8Intrinsic() || super.parseExprAtom(refExpressionErrors);
        }
      };
      var PIPELINE_PROPOSALS = ["minimal", "fsharp", "hack", "smart"];
      var TOPIC_TOKENS = ["^^", "@@", "^", "%", "#"];
      function validatePlugins(pluginsMap) {
        if (pluginsMap.has("decorators")) {
          if (pluginsMap.has("decorators-legacy")) {
            throw new Error("Cannot use the decorators and decorators-legacy plugin together");
          }
          const decoratorsBeforeExport = pluginsMap.get("decorators").decoratorsBeforeExport;
          if (decoratorsBeforeExport != null && typeof decoratorsBeforeExport !== "boolean") {
            throw new Error("'decoratorsBeforeExport' must be a boolean, if specified.");
          }
          const allowCallParenthesized = pluginsMap.get("decorators").allowCallParenthesized;
          if (allowCallParenthesized != null && typeof allowCallParenthesized !== "boolean") {
            throw new Error("'allowCallParenthesized' must be a boolean.");
          }
        }
        if (pluginsMap.has("flow") && pluginsMap.has("typescript")) {
          throw new Error("Cannot combine flow and typescript plugins.");
        }
        if (pluginsMap.has("placeholders") && pluginsMap.has("v8intrinsic")) {
          throw new Error("Cannot combine placeholders and v8intrinsic plugins.");
        }
        if (pluginsMap.has("pipelineOperator")) {
          var _pluginsMap$get2;
          const proposal = pluginsMap.get("pipelineOperator").proposal;
          if (!PIPELINE_PROPOSALS.includes(proposal)) {
            const proposalList = PIPELINE_PROPOSALS.map((p) => `"${p}"`).join(", ");
            throw new Error(`"pipelineOperator" requires "proposal" option whose value must be one of: ${proposalList}.`);
          }
          if (proposal === "hack") {
            if (pluginsMap.has("placeholders")) {
              throw new Error("Cannot combine placeholders plugin and Hack-style pipes.");
            }
            if (pluginsMap.has("v8intrinsic")) {
              throw new Error("Cannot combine v8intrinsic plugin and Hack-style pipes.");
            }
            const topicToken = pluginsMap.get("pipelineOperator").topicToken;
            if (!TOPIC_TOKENS.includes(topicToken)) {
              const tokenList = TOPIC_TOKENS.map((t3) => `"${t3}"`).join(", ");
              throw new Error(`"pipelineOperator" in "proposal": "hack" mode also requires a "topicToken" option whose value must be one of: ${tokenList}.`);
            }
            {
              var _pluginsMap$get;
              if (topicToken === "#" && ((_pluginsMap$get = pluginsMap.get("recordAndTuple")) == null ? void 0 : _pluginsMap$get.syntaxType) === "hash") {
                throw new Error(`Plugin conflict between \`["pipelineOperator", { proposal: "hack", topicToken: "#" }]\` and \`${JSON.stringify(["recordAndTuple", pluginsMap.get("recordAndTuple")])}\`.`);
              }
            }
          } else if (proposal === "smart" && ((_pluginsMap$get2 = pluginsMap.get("recordAndTuple")) == null ? void 0 : _pluginsMap$get2.syntaxType) === "hash") {
            throw new Error(`Plugin conflict between \`["pipelineOperator", { proposal: "smart" }]\` and \`${JSON.stringify(["recordAndTuple", pluginsMap.get("recordAndTuple")])}\`.`);
          }
        }
        if (pluginsMap.has("moduleAttributes")) {
          {
            if (pluginsMap.has("deprecatedImportAssert") || pluginsMap.has("importAssertions")) {
              throw new Error("Cannot combine importAssertions, deprecatedImportAssert and moduleAttributes plugins.");
            }
            const moduleAttributesVersionPluginOption = pluginsMap.get("moduleAttributes").version;
            if (moduleAttributesVersionPluginOption !== "may-2020") {
              throw new Error("The 'moduleAttributes' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is 'may-2020'.");
            }
          }
        }
        if (pluginsMap.has("importAssertions")) {
          if (pluginsMap.has("deprecatedImportAssert")) {
            throw new Error("Cannot combine importAssertions and deprecatedImportAssert plugins.");
          }
        }
        if (!pluginsMap.has("deprecatedImportAssert") && pluginsMap.has("importAttributes") && pluginsMap.get("importAttributes").deprecatedAssertSyntax) {
          {
            pluginsMap.set("deprecatedImportAssert", {});
          }
        }
        if (pluginsMap.has("recordAndTuple")) {
          {
            const syntaxType = pluginsMap.get("recordAndTuple").syntaxType;
            if (syntaxType != null) {
              const RECORD_AND_TUPLE_SYNTAX_TYPES = ["hash", "bar"];
              if (!RECORD_AND_TUPLE_SYNTAX_TYPES.includes(syntaxType)) {
                throw new Error("The 'syntaxType' option of the 'recordAndTuple' plugin must be one of: " + RECORD_AND_TUPLE_SYNTAX_TYPES.map((p) => `'${p}'`).join(", "));
              }
            }
          }
        }
        if (pluginsMap.has("asyncDoExpressions") && !pluginsMap.has("doExpressions")) {
          const error = new Error("'asyncDoExpressions' requires 'doExpressions', please add 'doExpressions' to parser plugins.");
          error.missingPlugins = "doExpressions";
          throw error;
        }
        if (pluginsMap.has("optionalChainingAssign") && pluginsMap.get("optionalChainingAssign").version !== "2023-07") {
          throw new Error("The 'optionalChainingAssign' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is '2023-07'.");
        }
        if (pluginsMap.has("discardBinding") && pluginsMap.get("discardBinding").syntaxType !== "void") {
          throw new Error("The 'discardBinding' plugin requires a 'syntaxType' option. Currently the only supported value is 'void'.");
        }
      }
      var mixinPlugins = {
        estree,
        jsx,
        flow: flow2,
        typescript,
        v8intrinsic,
        placeholders
      };
      var mixinPluginNames = Object.keys(mixinPlugins);
      var ExpressionParser = class extends LValParser {
        checkProto(prop, isRecord, sawProto, refExpressionErrors) {
          if (prop.type === "SpreadElement" || this.isObjectMethod(prop) || prop.computed || prop.shorthand) {
            return sawProto;
          }
          const key = prop.key;
          const name = key.type === "Identifier" ? key.name : key.value;
          if (name === "__proto__") {
            if (isRecord) {
              this.raise(Errors.RecordNoProto, key);
              return true;
            }
            if (sawProto) {
              if (refExpressionErrors) {
                if (refExpressionErrors.doubleProtoLoc === null) {
                  refExpressionErrors.doubleProtoLoc = key.loc.start;
                }
              } else {
                this.raise(Errors.DuplicateProto, key);
              }
            }
            return true;
          }
          return sawProto;
        }
        shouldExitDescending(expr, potentialArrowAt) {
          return expr.type === "ArrowFunctionExpression" && this.offsetToSourcePos(expr.start) === potentialArrowAt;
        }
        getExpression() {
          this.enterInitialScopes();
          this.nextToken();
          if (this.match(140)) {
            throw this.raise(Errors.ParseExpressionEmptyInput, this.state.startLoc);
          }
          const expr = this.parseExpression();
          if (!this.match(140)) {
            throw this.raise(Errors.ParseExpressionExpectsEOF, this.state.startLoc, {
              unexpected: this.input.codePointAt(this.state.start)
            });
          }
          this.finalizeRemainingComments();
          expr.comments = this.comments;
          expr.errors = this.state.errors;
          if (this.optionFlags & 256) {
            expr.tokens = this.tokens;
          }
          return expr;
        }
        parseExpression(disallowIn, refExpressionErrors) {
          if (disallowIn) {
            return this.disallowInAnd(() => this.parseExpressionBase(refExpressionErrors));
          }
          return this.allowInAnd(() => this.parseExpressionBase(refExpressionErrors));
        }
        parseExpressionBase(refExpressionErrors) {
          const startLoc = this.state.startLoc;
          const expr = this.parseMaybeAssign(refExpressionErrors);
          if (this.match(12)) {
            const node = this.startNodeAt(startLoc);
            node.expressions = [expr];
            while (this.eat(12)) {
              node.expressions.push(this.parseMaybeAssign(refExpressionErrors));
            }
            this.toReferencedList(node.expressions);
            return this.finishNode(node, "SequenceExpression");
          }
          return expr;
        }
        parseMaybeAssignDisallowIn(refExpressionErrors, afterLeftParse) {
          return this.disallowInAnd(() => this.parseMaybeAssign(refExpressionErrors, afterLeftParse));
        }
        parseMaybeAssignAllowIn(refExpressionErrors, afterLeftParse) {
          return this.allowInAnd(() => this.parseMaybeAssign(refExpressionErrors, afterLeftParse));
        }
        setOptionalParametersError(refExpressionErrors) {
          refExpressionErrors.optionalParametersLoc = this.state.startLoc;
        }
        parseMaybeAssign(refExpressionErrors, afterLeftParse) {
          const startLoc = this.state.startLoc;
          const isYield = this.isContextual(108);
          if (isYield) {
            if (this.prodParam.hasYield) {
              this.next();
              let left2 = this.parseYield(startLoc);
              if (afterLeftParse) {
                left2 = afterLeftParse.call(this, left2, startLoc);
              }
              return left2;
            }
          }
          let ownExpressionErrors;
          if (refExpressionErrors) {
            ownExpressionErrors = false;
          } else {
            refExpressionErrors = new ExpressionErrors();
            ownExpressionErrors = true;
          }
          const {
            type
          } = this.state;
          if (type === 10 || tokenIsIdentifier(type)) {
            this.state.potentialArrowAt = this.state.start;
          }
          let left = this.parseMaybeConditional(refExpressionErrors);
          if (afterLeftParse) {
            left = afterLeftParse.call(this, left, startLoc);
          }
          if (tokenIsAssignment(this.state.type)) {
            const node = this.startNodeAt(startLoc);
            const operator = this.state.value;
            node.operator = operator;
            if (this.match(29)) {
              this.toAssignable(left, true);
              node.left = left;
              const startIndex = startLoc.index;
              if (refExpressionErrors.doubleProtoLoc != null && refExpressionErrors.doubleProtoLoc.index >= startIndex) {
                refExpressionErrors.doubleProtoLoc = null;
              }
              if (refExpressionErrors.shorthandAssignLoc != null && refExpressionErrors.shorthandAssignLoc.index >= startIndex) {
                refExpressionErrors.shorthandAssignLoc = null;
              }
              if (refExpressionErrors.privateKeyLoc != null && refExpressionErrors.privateKeyLoc.index >= startIndex) {
                this.checkDestructuringPrivate(refExpressionErrors);
                refExpressionErrors.privateKeyLoc = null;
              }
              if (refExpressionErrors.voidPatternLoc != null && refExpressionErrors.voidPatternLoc.index >= startIndex) {
                refExpressionErrors.voidPatternLoc = null;
              }
            } else {
              node.left = left;
            }
            this.next();
            node.right = this.parseMaybeAssign();
            this.checkLVal(left, this.finishNode(node, "AssignmentExpression"));
            return node;
          } else if (ownExpressionErrors) {
            this.checkExpressionErrors(refExpressionErrors, true);
          }
          if (isYield) {
            const {
              type: type2
            } = this.state;
            const startsExpr2 = this.hasPlugin("v8intrinsic") ? tokenCanStartExpression(type2) : tokenCanStartExpression(type2) && !this.match(54);
            if (startsExpr2 && !this.isAmbiguousPrefixOrIdentifier()) {
              this.raiseOverwrite(Errors.YieldNotInGeneratorFunction, startLoc);
              return this.parseYield(startLoc);
            }
          }
          return left;
        }
        parseMaybeConditional(refExpressionErrors) {
          const startLoc = this.state.startLoc;
          const potentialArrowAt = this.state.potentialArrowAt;
          const expr = this.parseExprOps(refExpressionErrors);
          if (this.shouldExitDescending(expr, potentialArrowAt)) {
            return expr;
          }
          return this.parseConditional(expr, startLoc, refExpressionErrors);
        }
        parseConditional(expr, startLoc, refExpressionErrors) {
          if (this.eat(17)) {
            const node = this.startNodeAt(startLoc);
            node.test = expr;
            node.consequent = this.parseMaybeAssignAllowIn();
            this.expect(14);
            node.alternate = this.parseMaybeAssign();
            return this.finishNode(node, "ConditionalExpression");
          }
          return expr;
        }
        parseMaybeUnaryOrPrivate(refExpressionErrors) {
          return this.match(139) ? this.parsePrivateName() : this.parseMaybeUnary(refExpressionErrors);
        }
        parseExprOps(refExpressionErrors) {
          const startLoc = this.state.startLoc;
          const potentialArrowAt = this.state.potentialArrowAt;
          const expr = this.parseMaybeUnaryOrPrivate(refExpressionErrors);
          if (this.shouldExitDescending(expr, potentialArrowAt)) {
            return expr;
          }
          return this.parseExprOp(expr, startLoc, -1);
        }
        parseExprOp(left, leftStartLoc, minPrec) {
          if (this.isPrivateName(left)) {
            const value = this.getPrivateNameSV(left);
            if (minPrec >= tokenOperatorPrecedence(58) || !this.prodParam.hasIn || !this.match(58)) {
              this.raise(Errors.PrivateInExpectedIn, left, {
                identifierName: value
              });
            }
            this.classScope.usePrivateName(value, left.loc.start);
          }
          const op = this.state.type;
          if (tokenIsOperator(op) && (this.prodParam.hasIn || !this.match(58))) {
            let prec = tokenOperatorPrecedence(op);
            if (prec > minPrec) {
              if (op === 39) {
                this.expectPlugin("pipelineOperator");
                if (this.state.inFSharpPipelineDirectBody) {
                  return left;
                }
                this.checkPipelineAtInfixOperator(left, leftStartLoc);
              }
              const node = this.startNodeAt(leftStartLoc);
              node.left = left;
              node.operator = this.state.value;
              const logical = op === 41 || op === 42;
              const coalesce = op === 40;
              if (coalesce) {
                prec = tokenOperatorPrecedence(42);
              }
              this.next();
              if (op === 39 && this.hasPlugin(["pipelineOperator", {
                proposal: "minimal"
              }])) {
                if (this.state.type === 96 && this.prodParam.hasAwait) {
                  throw this.raise(Errors.UnexpectedAwaitAfterPipelineBody, this.state.startLoc);
                }
              }
              node.right = this.parseExprOpRightExpr(op, prec);
              const finishedNode = this.finishNode(node, logical || coalesce ? "LogicalExpression" : "BinaryExpression");
              const nextOp = this.state.type;
              if (coalesce && (nextOp === 41 || nextOp === 42) || logical && nextOp === 40) {
                throw this.raise(Errors.MixingCoalesceWithLogical, this.state.startLoc);
              }
              return this.parseExprOp(finishedNode, leftStartLoc, minPrec);
            }
          }
          return left;
        }
        parseExprOpRightExpr(op, prec) {
          const startLoc = this.state.startLoc;
          switch (op) {
            case 39:
              switch (this.getPluginOption("pipelineOperator", "proposal")) {
                case "hack":
                  return this.withTopicBindingContext(() => {
                    return this.parseHackPipeBody();
                  });
                case "fsharp":
                  return this.withSoloAwaitPermittingContext(() => {
                    return this.parseFSharpPipelineBody(prec);
                  });
              }
              if (this.getPluginOption("pipelineOperator", "proposal") === "smart") {
                return this.withTopicBindingContext(() => {
                  if (this.prodParam.hasYield && this.isContextual(108)) {
                    throw this.raise(Errors.PipeBodyIsTighter, this.state.startLoc);
                  }
                  return this.parseSmartPipelineBodyInStyle(this.parseExprOpBaseRightExpr(op, prec), startLoc);
                });
              }
            default:
              return this.parseExprOpBaseRightExpr(op, prec);
          }
        }
        parseExprOpBaseRightExpr(op, prec) {
          const startLoc = this.state.startLoc;
          return this.parseExprOp(this.parseMaybeUnaryOrPrivate(), startLoc, tokenIsRightAssociative(op) ? prec - 1 : prec);
        }
        parseHackPipeBody() {
          var _body$extra;
          const {
            startLoc
          } = this.state;
          const body = this.parseMaybeAssign();
          const requiredParentheses = UnparenthesizedPipeBodyDescriptions.has(body.type);
          if (requiredParentheses && !((_body$extra = body.extra) != null && _body$extra.parenthesized)) {
            this.raise(Errors.PipeUnparenthesizedBody, startLoc, {
              type: body.type
            });
          }
          if (!this.topicReferenceWasUsedInCurrentContext()) {
            this.raise(Errors.PipeTopicUnused, startLoc);
          }
          return body;
        }
        checkExponentialAfterUnary(node) {
          if (this.match(57)) {
            this.raise(Errors.UnexpectedTokenUnaryExponentiation, node.argument);
          }
        }
        parseMaybeUnary(refExpressionErrors, sawUnary) {
          const startLoc = this.state.startLoc;
          const isAwait = this.isContextual(96);
          if (isAwait && this.recordAwaitIfAllowed()) {
            this.next();
            const expr2 = this.parseAwait(startLoc);
            if (!sawUnary)
              this.checkExponentialAfterUnary(expr2);
            return expr2;
          }
          const update2 = this.match(34);
          const node = this.startNode();
          if (tokenIsPrefix(this.state.type)) {
            node.operator = this.state.value;
            node.prefix = true;
            if (this.match(72)) {
              this.expectPlugin("throwExpressions");
            }
            const isDelete = this.match(89);
            this.next();
            node.argument = this.parseMaybeUnary(null, true);
            this.checkExpressionErrors(refExpressionErrors, true);
            if (this.state.strict && isDelete) {
              const arg = node.argument;
              if (arg.type === "Identifier") {
                this.raise(Errors.StrictDelete, node);
              } else if (this.hasPropertyAsPrivateName(arg)) {
                this.raise(Errors.DeletePrivateField, node);
              }
            }
            if (!update2) {
              if (!sawUnary) {
                this.checkExponentialAfterUnary(node);
              }
              return this.finishNode(node, "UnaryExpression");
            }
          }
          const expr = this.parseUpdate(node, update2, refExpressionErrors);
          if (isAwait) {
            const {
              type
            } = this.state;
            const startsExpr2 = this.hasPlugin("v8intrinsic") ? tokenCanStartExpression(type) : tokenCanStartExpression(type) && !this.match(54);
            if (startsExpr2 && !this.isAmbiguousPrefixOrIdentifier()) {
              this.raiseOverwrite(Errors.AwaitNotInAsyncContext, startLoc);
              return this.parseAwait(startLoc);
            }
          }
          return expr;
        }
        parseUpdate(node, update2, refExpressionErrors) {
          if (update2) {
            const updateExpressionNode = node;
            this.checkLVal(updateExpressionNode.argument, this.finishNode(updateExpressionNode, "UpdateExpression"));
            return node;
          }
          const startLoc = this.state.startLoc;
          let expr = this.parseExprSubscripts(refExpressionErrors);
          if (this.checkExpressionErrors(refExpressionErrors, false))
            return expr;
          while (tokenIsPostfix(this.state.type) && !this.canInsertSemicolon()) {
            const node2 = this.startNodeAt(startLoc);
            node2.operator = this.state.value;
            node2.prefix = false;
            node2.argument = expr;
            this.next();
            this.checkLVal(expr, expr = this.finishNode(node2, "UpdateExpression"));
          }
          return expr;
        }
        parseExprSubscripts(refExpressionErrors) {
          const startLoc = this.state.startLoc;
          const potentialArrowAt = this.state.potentialArrowAt;
          const expr = this.parseExprAtom(refExpressionErrors);
          if (this.shouldExitDescending(expr, potentialArrowAt)) {
            return expr;
          }
          return this.parseSubscripts(expr, startLoc);
        }
        parseSubscripts(base, startLoc, noCalls) {
          const state = {
            optionalChainMember: false,
            maybeAsyncArrow: this.atPossibleAsyncArrow(base),
            stop: false
          };
          do {
            base = this.parseSubscript(base, startLoc, noCalls, state);
            state.maybeAsyncArrow = false;
          } while (!state.stop);
          return base;
        }
        parseSubscript(base, startLoc, noCalls, state) {
          const {
            type
          } = this.state;
          if (!noCalls && type === 15) {
            return this.parseBind(base, startLoc, noCalls, state);
          } else if (tokenIsTemplate(type)) {
            return this.parseTaggedTemplateExpression(base, startLoc, state);
          }
          let optional = false;
          if (type === 18) {
            if (noCalls) {
              this.raise(Errors.OptionalChainingNoNew, this.state.startLoc);
              if (this.lookaheadCharCode() === 40) {
                return this.stopParseSubscript(base, state);
              }
            }
            state.optionalChainMember = optional = true;
            this.next();
          }
          if (!noCalls && this.match(10)) {
            return this.parseCoverCallAndAsyncArrowHead(base, startLoc, state, optional);
          } else {
            const computed = this.eat(0);
            if (computed || optional || this.eat(16)) {
              return this.parseMember(base, startLoc, state, computed, optional);
            } else {
              return this.stopParseSubscript(base, state);
            }
          }
        }
        stopParseSubscript(base, state) {
          state.stop = true;
          return base;
        }
        parseMember(base, startLoc, state, computed, optional) {
          const node = this.startNodeAt(startLoc);
          node.object = base;
          node.computed = computed;
          if (computed) {
            node.property = this.parseExpression();
            this.expect(3);
          } else if (this.match(139)) {
            if (base.type === "Super") {
              this.raise(Errors.SuperPrivateField, startLoc);
            }
            this.classScope.usePrivateName(this.state.value, this.state.startLoc);
            node.property = this.parsePrivateName();
          } else {
            node.property = this.parseIdentifier(true);
          }
          if (state.optionalChainMember) {
            node.optional = optional;
            return this.finishNode(node, "OptionalMemberExpression");
          } else {
            return this.finishNode(node, "MemberExpression");
          }
        }
        parseBind(base, startLoc, noCalls, state) {
          const node = this.startNodeAt(startLoc);
          node.object = base;
          this.next();
          node.callee = this.parseNoCallExpr();
          state.stop = true;
          return this.parseSubscripts(this.finishNode(node, "BindExpression"), startLoc, noCalls);
        }
        parseCoverCallAndAsyncArrowHead(base, startLoc, state, optional) {
          const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
          let refExpressionErrors = null;
          this.state.maybeInArrowParameters = true;
          this.next();
          const node = this.startNodeAt(startLoc);
          node.callee = base;
          const {
            maybeAsyncArrow,
            optionalChainMember
          } = state;
          if (maybeAsyncArrow) {
            this.expressionScope.enter(newAsyncArrowScope());
            refExpressionErrors = new ExpressionErrors();
          }
          if (optionalChainMember) {
            node.optional = optional;
          }
          if (optional) {
            node.arguments = this.parseCallExpressionArguments();
          } else {
            node.arguments = this.parseCallExpressionArguments(base.type !== "Super", node, refExpressionErrors);
          }
          let finishedNode = this.finishCallExpression(node, optionalChainMember);
          if (maybeAsyncArrow && this.shouldParseAsyncArrow() && !optional) {
            state.stop = true;
            this.checkDestructuringPrivate(refExpressionErrors);
            this.expressionScope.validateAsPattern();
            this.expressionScope.exit();
            finishedNode = this.parseAsyncArrowFromCallExpression(this.startNodeAt(startLoc), finishedNode);
          } else {
            if (maybeAsyncArrow) {
              this.checkExpressionErrors(refExpressionErrors, true);
              this.expressionScope.exit();
            }
            this.toReferencedArguments(finishedNode);
          }
          this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
          return finishedNode;
        }
        toReferencedArguments(node, isParenthesizedExpr) {
          this.toReferencedListDeep(node.arguments, isParenthesizedExpr);
        }
        parseTaggedTemplateExpression(base, startLoc, state) {
          const node = this.startNodeAt(startLoc);
          node.tag = base;
          node.quasi = this.parseTemplate(true);
          if (state.optionalChainMember) {
            this.raise(Errors.OptionalChainingNoTemplate, startLoc);
          }
          return this.finishNode(node, "TaggedTemplateExpression");
        }
        atPossibleAsyncArrow(base) {
          return base.type === "Identifier" && base.name === "async" && this.state.lastTokEndLoc.index === base.end && !this.canInsertSemicolon() && base.end - base.start === 5 && this.offsetToSourcePos(base.start) === this.state.potentialArrowAt;
        }
        finishCallExpression(node, optional) {
          if (node.callee.type === "Import") {
            if (node.arguments.length === 0 || node.arguments.length > 2) {
              this.raise(Errors.ImportCallArity, node);
            } else {
              for (const arg of node.arguments) {
                if (arg.type === "SpreadElement") {
                  this.raise(Errors.ImportCallSpreadArgument, arg);
                }
              }
            }
          }
          return this.finishNode(node, optional ? "OptionalCallExpression" : "CallExpression");
        }
        parseCallExpressionArguments(allowPlaceholder, nodeForExtra, refExpressionErrors) {
          const elts = [];
          let first = true;
          const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = false;
          while (!this.eat(11)) {
            if (first) {
              first = false;
            } else {
              this.expect(12);
              if (this.match(11)) {
                if (nodeForExtra) {
                  this.addTrailingCommaExtraToNode(nodeForExtra);
                }
                this.next();
                break;
              }
            }
            elts.push(this.parseExprListItem(11, false, refExpressionErrors, allowPlaceholder));
          }
          this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
          return elts;
        }
        shouldParseAsyncArrow() {
          return this.match(19) && !this.canInsertSemicolon();
        }
        parseAsyncArrowFromCallExpression(node, call) {
          var _call$extra;
          this.resetPreviousNodeTrailingComments(call);
          this.expect(19);
          this.parseArrowExpression(node, call.arguments, true, (_call$extra = call.extra) == null ? void 0 : _call$extra.trailingCommaLoc);
          if (call.innerComments) {
            setInnerComments(node, call.innerComments);
          }
          if (call.callee.trailingComments) {
            setInnerComments(node, call.callee.trailingComments);
          }
          return node;
        }
        parseNoCallExpr() {
          const startLoc = this.state.startLoc;
          return this.parseSubscripts(this.parseExprAtom(), startLoc, true);
        }
        parseExprAtom(refExpressionErrors) {
          let node;
          let decorators = null;
          const {
            type
          } = this.state;
          switch (type) {
            case 79:
              return this.parseSuper();
            case 83:
              node = this.startNode();
              this.next();
              if (this.match(16)) {
                return this.parseImportMetaPropertyOrPhaseCall(node);
              }
              if (this.match(10)) {
                if (this.optionFlags & 512) {
                  return this.parseImportCall(node);
                } else {
                  return this.finishNode(node, "Import");
                }
              } else {
                this.raise(Errors.UnsupportedImport, this.state.lastTokStartLoc);
                return this.finishNode(node, "Import");
              }
            case 78:
              node = this.startNode();
              this.next();
              return this.finishNode(node, "ThisExpression");
            case 90: {
              return this.parseDo(this.startNode(), false);
            }
            case 56:
            case 31: {
              this.readRegexp();
              return this.parseRegExpLiteral(this.state.value);
            }
            case 135:
              return this.parseNumericLiteral(this.state.value);
            case 136:
              return this.parseBigIntLiteral(this.state.value);
            case 134:
              return this.parseStringLiteral(this.state.value);
            case 84:
              return this.parseNullLiteral();
            case 85:
              return this.parseBooleanLiteral(true);
            case 86:
              return this.parseBooleanLiteral(false);
            case 10: {
              const canBeArrow = this.state.potentialArrowAt === this.state.start;
              return this.parseParenAndDistinguishExpression(canBeArrow);
            }
            case 0: {
              return this.parseArrayLike(3, true, false, refExpressionErrors);
            }
            case 5: {
              return this.parseObjectLike(8, false, false, refExpressionErrors);
            }
            case 68:
              return this.parseFunctionOrFunctionSent();
            case 26:
              decorators = this.parseDecorators();
            case 80:
              return this.parseClass(this.maybeTakeDecorators(decorators, this.startNode()), false);
            case 77:
              return this.parseNewOrNewTarget();
            case 25:
            case 24:
              return this.parseTemplate(false);
            case 15: {
              node = this.startNode();
              this.next();
              node.object = null;
              const callee = node.callee = this.parseNoCallExpr();
              if (callee.type === "MemberExpression") {
                return this.finishNode(node, "BindExpression");
              } else {
                throw this.raise(Errors.UnsupportedBind, callee);
              }
            }
            case 139: {
              this.raise(Errors.PrivateInExpectedIn, this.state.startLoc, {
                identifierName: this.state.value
              });
              return this.parsePrivateName();
            }
            case 33: {
              return this.parseTopicReferenceThenEqualsSign(54, "%");
            }
            case 32: {
              return this.parseTopicReferenceThenEqualsSign(44, "^");
            }
            case 37:
            case 38: {
              return this.parseTopicReference("hack");
            }
            case 44:
            case 54:
            case 27: {
              const pipeProposal = this.getPluginOption("pipelineOperator", "proposal");
              if (pipeProposal) {
                return this.parseTopicReference(pipeProposal);
              }
              this.unexpected();
              break;
            }
            case 47: {
              const lookaheadCh = this.input.codePointAt(this.nextTokenStart());
              if (isIdentifierStart(lookaheadCh) || lookaheadCh === 62) {
                this.expectOnePlugin(["jsx", "flow", "typescript"]);
              } else {
                this.unexpected();
              }
              break;
            }
            default:
              {
                if (type === 137) {
                  return this.parseDecimalLiteral(this.state.value);
                } else if (type === 2 || type === 1) {
                  return this.parseArrayLike(this.state.type === 2 ? 4 : 3, false, true);
                } else if (type === 6 || type === 7) {
                  return this.parseObjectLike(this.state.type === 6 ? 9 : 8, false, true);
                }
              }
              if (tokenIsIdentifier(type)) {
                if (this.isContextual(127) && this.lookaheadInLineCharCode() === 123) {
                  return this.parseModuleExpression();
                }
                const canBeArrow = this.state.potentialArrowAt === this.state.start;
                const containsEsc = this.state.containsEsc;
                const id = this.parseIdentifier();
                if (!containsEsc && id.name === "async" && !this.canInsertSemicolon()) {
                  const {
                    type: type2
                  } = this.state;
                  if (type2 === 68) {
                    this.resetPreviousNodeTrailingComments(id);
                    this.next();
                    return this.parseAsyncFunctionExpression(this.startNodeAtNode(id));
                  } else if (tokenIsIdentifier(type2)) {
                    if (this.lookaheadCharCode() === 61) {
                      return this.parseAsyncArrowUnaryFunction(this.startNodeAtNode(id));
                    } else {
                      return id;
                    }
                  } else if (type2 === 90) {
                    this.resetPreviousNodeTrailingComments(id);
                    return this.parseDo(this.startNodeAtNode(id), true);
                  }
                }
                if (canBeArrow && this.match(19) && !this.canInsertSemicolon()) {
                  this.next();
                  return this.parseArrowExpression(this.startNodeAtNode(id), [id], false);
                }
                return id;
              } else {
                this.unexpected();
              }
          }
        }
        parseTopicReferenceThenEqualsSign(topicTokenType, topicTokenValue) {
          const pipeProposal = this.getPluginOption("pipelineOperator", "proposal");
          if (pipeProposal) {
            this.state.type = topicTokenType;
            this.state.value = topicTokenValue;
            this.state.pos--;
            this.state.end--;
            this.state.endLoc = createPositionWithColumnOffset(this.state.endLoc, -1);
            return this.parseTopicReference(pipeProposal);
          } else {
            this.unexpected();
          }
        }
        parseTopicReference(pipeProposal) {
          const node = this.startNode();
          const startLoc = this.state.startLoc;
          const tokenType = this.state.type;
          this.next();
          return this.finishTopicReference(node, startLoc, pipeProposal, tokenType);
        }
        finishTopicReference(node, startLoc, pipeProposal, tokenType) {
          if (this.testTopicReferenceConfiguration(pipeProposal, startLoc, tokenType)) {
            if (pipeProposal === "hack") {
              if (!this.topicReferenceIsAllowedInCurrentContext()) {
                this.raise(Errors.PipeTopicUnbound, startLoc);
              }
              this.registerTopicReference();
              return this.finishNode(node, "TopicReference");
            } else {
              if (!this.topicReferenceIsAllowedInCurrentContext()) {
                this.raise(Errors.PrimaryTopicNotAllowed, startLoc);
              }
              this.registerTopicReference();
              return this.finishNode(node, "PipelinePrimaryTopicReference");
            }
          } else {
            throw this.raise(Errors.PipeTopicUnconfiguredToken, startLoc, {
              token: tokenLabelName(tokenType)
            });
          }
        }
        testTopicReferenceConfiguration(pipeProposal, startLoc, tokenType) {
          switch (pipeProposal) {
            case "hack": {
              return this.hasPlugin(["pipelineOperator", {
                topicToken: tokenLabelName(tokenType)
              }]);
            }
            case "smart":
              return tokenType === 27;
            default:
              throw this.raise(Errors.PipeTopicRequiresHackPipes, startLoc);
          }
        }
        parseAsyncArrowUnaryFunction(node) {
          this.prodParam.enter(functionFlags(true, this.prodParam.hasYield));
          const params = [this.parseIdentifier()];
          this.prodParam.exit();
          if (this.hasPrecedingLineBreak()) {
            this.raise(Errors.LineTerminatorBeforeArrow, this.state.curPosition());
          }
          this.expect(19);
          return this.parseArrowExpression(node, params, true);
        }
        parseDo(node, isAsync) {
          this.expectPlugin("doExpressions");
          if (isAsync) {
            this.expectPlugin("asyncDoExpressions");
          }
          node.async = isAsync;
          this.next();
          const oldLabels = this.state.labels;
          this.state.labels = [];
          if (isAsync) {
            this.prodParam.enter(2);
            node.body = this.parseBlock();
            this.prodParam.exit();
          } else {
            node.body = this.parseBlock();
          }
          this.state.labels = oldLabels;
          return this.finishNode(node, "DoExpression");
        }
        parseSuper() {
          const node = this.startNode();
          this.next();
          if (this.match(10) && !this.scope.allowDirectSuper && !(this.optionFlags & 16)) {
            this.raise(Errors.SuperNotAllowed, node);
          } else if (!this.scope.allowSuper && !(this.optionFlags & 16)) {
            this.raise(Errors.UnexpectedSuper, node);
          }
          if (!this.match(10) && !this.match(0) && !this.match(16)) {
            this.raise(Errors.UnsupportedSuper, node);
          }
          return this.finishNode(node, "Super");
        }
        parsePrivateName() {
          const node = this.startNode();
          const id = this.startNodeAt(createPositionWithColumnOffset(this.state.startLoc, 1));
          const name = this.state.value;
          this.next();
          node.id = this.createIdentifier(id, name);
          return this.finishNode(node, "PrivateName");
        }
        parseFunctionOrFunctionSent() {
          const node = this.startNode();
          this.next();
          if (this.prodParam.hasYield && this.match(16)) {
            const meta = this.createIdentifier(this.startNodeAtNode(node), "function");
            this.next();
            if (this.match(103)) {
              this.expectPlugin("functionSent");
            } else if (!this.hasPlugin("functionSent")) {
              this.unexpected();
            }
            return this.parseMetaProperty(node, meta, "sent");
          }
          return this.parseFunction(node);
        }
        parseMetaProperty(node, meta, propertyName) {
          node.meta = meta;
          const containsEsc = this.state.containsEsc;
          node.property = this.parseIdentifier(true);
          if (node.property.name !== propertyName || containsEsc) {
            this.raise(Errors.UnsupportedMetaProperty, node.property, {
              target: meta.name,
              onlyValidPropertyName: propertyName
            });
          }
          return this.finishNode(node, "MetaProperty");
        }
        parseImportMetaPropertyOrPhaseCall(node) {
          this.next();
          if (this.isContextual(105) || this.isContextual(97)) {
            const isSource = this.isContextual(105);
            this.expectPlugin(isSource ? "sourcePhaseImports" : "deferredImportEvaluation");
            this.next();
            node.phase = isSource ? "source" : "defer";
            return this.parseImportCall(node);
          } else {
            const id = this.createIdentifierAt(this.startNodeAtNode(node), "import", this.state.lastTokStartLoc);
            if (this.isContextual(101)) {
              if (!this.inModule) {
                this.raise(Errors.ImportMetaOutsideModule, id);
              }
              this.sawUnambiguousESM = true;
            }
            return this.parseMetaProperty(node, id, "meta");
          }
        }
        parseLiteralAtNode(value, type, node) {
          this.addExtra(node, "rawValue", value);
          this.addExtra(node, "raw", this.input.slice(this.offsetToSourcePos(node.start), this.state.end));
          node.value = value;
          this.next();
          return this.finishNode(node, type);
        }
        parseLiteral(value, type) {
          const node = this.startNode();
          return this.parseLiteralAtNode(value, type, node);
        }
        parseStringLiteral(value) {
          return this.parseLiteral(value, "StringLiteral");
        }
        parseNumericLiteral(value) {
          return this.parseLiteral(value, "NumericLiteral");
        }
        parseBigIntLiteral(value) {
          {
            return this.parseLiteral(value, "BigIntLiteral");
          }
        }
        parseDecimalLiteral(value) {
          return this.parseLiteral(value, "DecimalLiteral");
        }
        parseRegExpLiteral(value) {
          const node = this.startNode();
          this.addExtra(node, "raw", this.input.slice(this.offsetToSourcePos(node.start), this.state.end));
          node.pattern = value.pattern;
          node.flags = value.flags;
          this.next();
          return this.finishNode(node, "RegExpLiteral");
        }
        parseBooleanLiteral(value) {
          const node = this.startNode();
          node.value = value;
          this.next();
          return this.finishNode(node, "BooleanLiteral");
        }
        parseNullLiteral() {
          const node = this.startNode();
          this.next();
          return this.finishNode(node, "NullLiteral");
        }
        parseParenAndDistinguishExpression(canBeArrow) {
          const startLoc = this.state.startLoc;
          let val;
          this.next();
          this.expressionScope.enter(newArrowHeadScope());
          const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
          const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
          this.state.maybeInArrowParameters = true;
          this.state.inFSharpPipelineDirectBody = false;
          const innerStartLoc = this.state.startLoc;
          const exprList = [];
          const refExpressionErrors = new ExpressionErrors();
          let first = true;
          let spreadStartLoc;
          let optionalCommaStartLoc;
          while (!this.match(11)) {
            if (first) {
              first = false;
            } else {
              this.expect(12, refExpressionErrors.optionalParametersLoc === null ? null : refExpressionErrors.optionalParametersLoc);
              if (this.match(11)) {
                optionalCommaStartLoc = this.state.startLoc;
                break;
              }
            }
            if (this.match(21)) {
              const spreadNodeStartLoc = this.state.startLoc;
              spreadStartLoc = this.state.startLoc;
              exprList.push(this.parseParenItem(this.parseRestBinding(), spreadNodeStartLoc));
              if (!this.checkCommaAfterRest(41)) {
                break;
              }
            } else {
              exprList.push(this.parseMaybeAssignAllowInOrVoidPattern(11, refExpressionErrors, this.parseParenItem));
            }
          }
          const innerEndLoc = this.state.lastTokEndLoc;
          this.expect(11);
          this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
          this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
          let arrowNode = this.startNodeAt(startLoc);
          if (canBeArrow && this.shouldParseArrow(exprList) && (arrowNode = this.parseArrow(arrowNode))) {
            this.checkDestructuringPrivate(refExpressionErrors);
            this.expressionScope.validateAsPattern();
            this.expressionScope.exit();
            this.parseArrowExpression(arrowNode, exprList, false);
            return arrowNode;
          }
          this.expressionScope.exit();
          if (!exprList.length) {
            this.unexpected(this.state.lastTokStartLoc);
          }
          if (optionalCommaStartLoc)
            this.unexpected(optionalCommaStartLoc);
          if (spreadStartLoc)
            this.unexpected(spreadStartLoc);
          this.checkExpressionErrors(refExpressionErrors, true);
          this.toReferencedListDeep(exprList, true);
          if (exprList.length > 1) {
            val = this.startNodeAt(innerStartLoc);
            val.expressions = exprList;
            this.finishNode(val, "SequenceExpression");
            this.resetEndLocation(val, innerEndLoc);
          } else {
            val = exprList[0];
          }
          return this.wrapParenthesis(startLoc, val);
        }
        wrapParenthesis(startLoc, expression) {
          if (!(this.optionFlags & 1024)) {
            this.addExtra(expression, "parenthesized", true);
            this.addExtra(expression, "parenStart", startLoc.index);
            this.takeSurroundingComments(expression, startLoc.index, this.state.lastTokEndLoc.index);
            return expression;
          }
          const parenExpression = this.startNodeAt(startLoc);
          parenExpression.expression = expression;
          return this.finishNode(parenExpression, "ParenthesizedExpression");
        }
        shouldParseArrow(params) {
          return !this.canInsertSemicolon();
        }
        parseArrow(node) {
          if (this.eat(19)) {
            return node;
          }
        }
        parseParenItem(node, startLoc) {
          return node;
        }
        parseNewOrNewTarget() {
          const node = this.startNode();
          this.next();
          if (this.match(16)) {
            const meta = this.createIdentifier(this.startNodeAtNode(node), "new");
            this.next();
            const metaProp = this.parseMetaProperty(node, meta, "target");
            if (!this.scope.allowNewTarget) {
              this.raise(Errors.UnexpectedNewTarget, metaProp);
            }
            return metaProp;
          }
          return this.parseNew(node);
        }
        parseNew(node) {
          this.parseNewCallee(node);
          if (this.eat(10)) {
            const args = this.parseExprList(11);
            this.toReferencedList(args);
            node.arguments = args;
          } else {
            node.arguments = [];
          }
          return this.finishNode(node, "NewExpression");
        }
        parseNewCallee(node) {
          const isImport = this.match(83);
          const callee = this.parseNoCallExpr();
          node.callee = callee;
          if (isImport && (callee.type === "Import" || callee.type === "ImportExpression")) {
            this.raise(Errors.ImportCallNotNewExpression, callee);
          }
        }
        parseTemplateElement(isTagged) {
          const {
            start,
            startLoc,
            end,
            value
          } = this.state;
          const elemStart = start + 1;
          const elem = this.startNodeAt(createPositionWithColumnOffset(startLoc, 1));
          if (value === null) {
            if (!isTagged) {
              this.raise(Errors.InvalidEscapeSequenceTemplate, createPositionWithColumnOffset(this.state.firstInvalidTemplateEscapePos, 1));
            }
          }
          const isTail = this.match(24);
          const endOffset = isTail ? -1 : -2;
          const elemEnd = end + endOffset;
          elem.value = {
            raw: this.input.slice(elemStart, elemEnd).replace(/\r\n?/g, "\n"),
            cooked: value === null ? null : value.slice(1, endOffset)
          };
          elem.tail = isTail;
          this.next();
          const finishedNode = this.finishNode(elem, "TemplateElement");
          this.resetEndLocation(finishedNode, createPositionWithColumnOffset(this.state.lastTokEndLoc, endOffset));
          return finishedNode;
        }
        parseTemplate(isTagged) {
          const node = this.startNode();
          let curElt = this.parseTemplateElement(isTagged);
          const quasis = [curElt];
          const substitutions = [];
          while (!curElt.tail) {
            substitutions.push(this.parseTemplateSubstitution());
            this.readTemplateContinuation();
            quasis.push(curElt = this.parseTemplateElement(isTagged));
          }
          node.expressions = substitutions;
          node.quasis = quasis;
          return this.finishNode(node, "TemplateLiteral");
        }
        parseTemplateSubstitution() {
          return this.parseExpression();
        }
        parseObjectLike(close, isPattern, isRecord, refExpressionErrors) {
          if (isRecord) {
            this.expectPlugin("recordAndTuple");
          }
          const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = false;
          let sawProto = false;
          let first = true;
          const node = this.startNode();
          node.properties = [];
          this.next();
          while (!this.match(close)) {
            if (first) {
              first = false;
            } else {
              this.expect(12);
              if (this.match(close)) {
                this.addTrailingCommaExtraToNode(node);
                break;
              }
            }
            let prop;
            if (isPattern) {
              prop = this.parseBindingProperty();
            } else {
              prop = this.parsePropertyDefinition(refExpressionErrors);
              sawProto = this.checkProto(prop, isRecord, sawProto, refExpressionErrors);
            }
            if (isRecord && !this.isObjectProperty(prop) && prop.type !== "SpreadElement") {
              this.raise(Errors.InvalidRecordProperty, prop);
            }
            {
              if (prop.shorthand) {
                this.addExtra(prop, "shorthand", true);
              }
            }
            node.properties.push(prop);
          }
          this.next();
          this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
          let type = "ObjectExpression";
          if (isPattern) {
            type = "ObjectPattern";
          } else if (isRecord) {
            type = "RecordExpression";
          }
          return this.finishNode(node, type);
        }
        addTrailingCommaExtraToNode(node) {
          this.addExtra(node, "trailingComma", this.state.lastTokStartLoc.index);
          this.addExtra(node, "trailingCommaLoc", this.state.lastTokStartLoc, false);
        }
        maybeAsyncOrAccessorProp(prop) {
          return !prop.computed && prop.key.type === "Identifier" && (this.isLiteralPropertyName() || this.match(0) || this.match(55));
        }
        parsePropertyDefinition(refExpressionErrors) {
          let decorators = [];
          if (this.match(26)) {
            if (this.hasPlugin("decorators")) {
              this.raise(Errors.UnsupportedPropertyDecorator, this.state.startLoc);
            }
            while (this.match(26)) {
              decorators.push(this.parseDecorator());
            }
          }
          const prop = this.startNode();
          let isAsync = false;
          let isAccessor = false;
          let startLoc;
          if (this.match(21)) {
            if (decorators.length)
              this.unexpected();
            return this.parseSpread();
          }
          if (decorators.length) {
            prop.decorators = decorators;
            decorators = [];
          }
          prop.method = false;
          if (refExpressionErrors) {
            startLoc = this.state.startLoc;
          }
          let isGenerator = this.eat(55);
          this.parsePropertyNamePrefixOperator(prop);
          const containsEsc = this.state.containsEsc;
          this.parsePropertyName(prop, refExpressionErrors);
          if (!isGenerator && !containsEsc && this.maybeAsyncOrAccessorProp(prop)) {
            const {
              key
            } = prop;
            const keyName = key.name;
            if (keyName === "async" && !this.hasPrecedingLineBreak()) {
              isAsync = true;
              this.resetPreviousNodeTrailingComments(key);
              isGenerator = this.eat(55);
              this.parsePropertyName(prop);
            }
            if (keyName === "get" || keyName === "set") {
              isAccessor = true;
              this.resetPreviousNodeTrailingComments(key);
              prop.kind = keyName;
              if (this.match(55)) {
                isGenerator = true;
                this.raise(Errors.AccessorIsGenerator, this.state.curPosition(), {
                  kind: keyName
                });
                this.next();
              }
              this.parsePropertyName(prop);
            }
          }
          return this.parseObjPropValue(prop, startLoc, isGenerator, isAsync, false, isAccessor, refExpressionErrors);
        }
        getGetterSetterExpectedParamCount(method2) {
          return method2.kind === "get" ? 0 : 1;
        }
        getObjectOrClassMethodParams(method2) {
          return method2.params;
        }
        checkGetterSetterParams(method2) {
          var _params;
          const paramCount = this.getGetterSetterExpectedParamCount(method2);
          const params = this.getObjectOrClassMethodParams(method2);
          if (params.length !== paramCount) {
            this.raise(method2.kind === "get" ? Errors.BadGetterArity : Errors.BadSetterArity, method2);
          }
          if (method2.kind === "set" && ((_params = params[params.length - 1]) == null ? void 0 : _params.type) === "RestElement") {
            this.raise(Errors.BadSetterRestParameter, method2);
          }
        }
        parseObjectMethod(prop, isGenerator, isAsync, isPattern, isAccessor) {
          if (isAccessor) {
            const finishedProp = this.parseMethod(prop, isGenerator, false, false, false, "ObjectMethod");
            this.checkGetterSetterParams(finishedProp);
            return finishedProp;
          }
          if (isAsync || isGenerator || this.match(10)) {
            if (isPattern)
              this.unexpected();
            prop.kind = "method";
            prop.method = true;
            return this.parseMethod(prop, isGenerator, isAsync, false, false, "ObjectMethod");
          }
        }
        parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors) {
          prop.shorthand = false;
          if (this.eat(14)) {
            prop.value = isPattern ? this.parseMaybeDefault(this.state.startLoc) : this.parseMaybeAssignAllowInOrVoidPattern(8, refExpressionErrors);
            return this.finishObjectProperty(prop);
          }
          if (!prop.computed && prop.key.type === "Identifier") {
            this.checkReservedWord(prop.key.name, prop.key.loc.start, true, false);
            if (isPattern) {
              prop.value = this.parseMaybeDefault(startLoc, this.cloneIdentifier(prop.key));
            } else if (this.match(29)) {
              const shorthandAssignLoc = this.state.startLoc;
              if (refExpressionErrors != null) {
                if (refExpressionErrors.shorthandAssignLoc === null) {
                  refExpressionErrors.shorthandAssignLoc = shorthandAssignLoc;
                }
              } else {
                this.raise(Errors.InvalidCoverInitializedName, shorthandAssignLoc);
              }
              prop.value = this.parseMaybeDefault(startLoc, this.cloneIdentifier(prop.key));
            } else {
              prop.value = this.cloneIdentifier(prop.key);
            }
            prop.shorthand = true;
            return this.finishObjectProperty(prop);
          }
        }
        finishObjectProperty(node) {
          return this.finishNode(node, "ObjectProperty");
        }
        parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors) {
          const node = this.parseObjectMethod(prop, isGenerator, isAsync, isPattern, isAccessor) || this.parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors);
          if (!node)
            this.unexpected();
          return node;
        }
        parsePropertyName(prop, refExpressionErrors) {
          if (this.eat(0)) {
            prop.computed = true;
            prop.key = this.parseMaybeAssignAllowIn();
            this.expect(3);
          } else {
            const {
              type,
              value
            } = this.state;
            let key;
            if (tokenIsKeywordOrIdentifier(type)) {
              key = this.parseIdentifier(true);
            } else {
              switch (type) {
                case 135:
                  key = this.parseNumericLiteral(value);
                  break;
                case 134:
                  key = this.parseStringLiteral(value);
                  break;
                case 136:
                  key = this.parseBigIntLiteral(value);
                  break;
                case 139: {
                  const privateKeyLoc = this.state.startLoc;
                  if (refExpressionErrors != null) {
                    if (refExpressionErrors.privateKeyLoc === null) {
                      refExpressionErrors.privateKeyLoc = privateKeyLoc;
                    }
                  } else {
                    this.raise(Errors.UnexpectedPrivateField, privateKeyLoc);
                  }
                  key = this.parsePrivateName();
                  break;
                }
                default:
                  if (type === 137) {
                    key = this.parseDecimalLiteral(value);
                    break;
                  }
                  this.unexpected();
              }
            }
            prop.key = key;
            if (type !== 139) {
              prop.computed = false;
            }
          }
        }
        initFunction(node, isAsync) {
          node.id = null;
          node.generator = false;
          node.async = isAsync;
        }
        parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope = false) {
          this.initFunction(node, isAsync);
          node.generator = isGenerator;
          this.scope.enter(514 | 16 | (inClassScope ? 576 : 0) | (allowDirectSuper ? 32 : 0));
          this.prodParam.enter(functionFlags(isAsync, node.generator));
          this.parseFunctionParams(node, isConstructor);
          const finishedNode = this.parseFunctionBodyAndFinish(node, type, true);
          this.prodParam.exit();
          this.scope.exit();
          return finishedNode;
        }
        parseArrayLike(close, canBePattern, isTuple, refExpressionErrors) {
          if (isTuple) {
            this.expectPlugin("recordAndTuple");
          }
          const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = false;
          const node = this.startNode();
          this.next();
          node.elements = this.parseExprList(close, !isTuple, refExpressionErrors, node);
          this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
          return this.finishNode(node, isTuple ? "TupleExpression" : "ArrayExpression");
        }
        parseArrowExpression(node, params, isAsync, trailingCommaLoc) {
          this.scope.enter(514 | 4);
          let flags = functionFlags(isAsync, false);
          if (!this.match(5) && this.prodParam.hasIn) {
            flags |= 8;
          }
          this.prodParam.enter(flags);
          this.initFunction(node, isAsync);
          const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
          if (params) {
            this.state.maybeInArrowParameters = true;
            this.setArrowFunctionParameters(node, params, trailingCommaLoc);
          }
          this.state.maybeInArrowParameters = false;
          this.parseFunctionBody(node, true);
          this.prodParam.exit();
          this.scope.exit();
          this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
          return this.finishNode(node, "ArrowFunctionExpression");
        }
        setArrowFunctionParameters(node, params, trailingCommaLoc) {
          this.toAssignableList(params, trailingCommaLoc, false);
          node.params = params;
        }
        parseFunctionBodyAndFinish(node, type, isMethod = false) {
          this.parseFunctionBody(node, false, isMethod);
          return this.finishNode(node, type);
        }
        parseFunctionBody(node, allowExpression, isMethod = false) {
          const isExpression = allowExpression && !this.match(5);
          this.expressionScope.enter(newExpressionScope());
          if (isExpression) {
            node.body = this.parseMaybeAssign();
            this.checkParams(node, false, allowExpression, false);
          } else {
            const oldStrict = this.state.strict;
            const oldLabels = this.state.labels;
            this.state.labels = [];
            this.prodParam.enter(this.prodParam.currentFlags() | 4);
            node.body = this.parseBlock(true, false, (hasStrictModeDirective) => {
              const nonSimple = !this.isSimpleParamList(node.params);
              if (hasStrictModeDirective && nonSimple) {
                this.raise(Errors.IllegalLanguageModeDirective, (node.kind === "method" || node.kind === "constructor") && !!node.key ? node.key.loc.end : node);
              }
              const strictModeChanged = !oldStrict && this.state.strict;
              this.checkParams(node, !this.state.strict && !allowExpression && !isMethod && !nonSimple, allowExpression, strictModeChanged);
              if (this.state.strict && node.id) {
                this.checkIdentifier(node.id, 65, strictModeChanged);
              }
            });
            this.prodParam.exit();
            this.state.labels = oldLabels;
          }
          this.expressionScope.exit();
        }
        isSimpleParameter(node) {
          return node.type === "Identifier";
        }
        isSimpleParamList(params) {
          for (let i = 0, len = params.length; i < len; i++) {
            if (!this.isSimpleParameter(params[i]))
              return false;
          }
          return true;
        }
        checkParams(node, allowDuplicates, isArrowFunction, strictModeChanged = true) {
          const checkClashes = !allowDuplicates && /* @__PURE__ */ new Set();
          const formalParameters = {
            type: "FormalParameters"
          };
          for (const param of node.params) {
            this.checkLVal(param, formalParameters, 5, checkClashes, strictModeChanged);
          }
        }
        parseExprList(close, allowEmpty, refExpressionErrors, nodeForExtra) {
          const elts = [];
          let first = true;
          while (!this.eat(close)) {
            if (first) {
              first = false;
            } else {
              this.expect(12);
              if (this.match(close)) {
                if (nodeForExtra) {
                  this.addTrailingCommaExtraToNode(nodeForExtra);
                }
                this.next();
                break;
              }
            }
            elts.push(this.parseExprListItem(close, allowEmpty, refExpressionErrors));
          }
          return elts;
        }
        parseExprListItem(close, allowEmpty, refExpressionErrors, allowPlaceholder) {
          let elt;
          if (this.match(12)) {
            if (!allowEmpty) {
              this.raise(Errors.UnexpectedToken, this.state.curPosition(), {
                unexpected: ","
              });
            }
            elt = null;
          } else if (this.match(21)) {
            const spreadNodeStartLoc = this.state.startLoc;
            elt = this.parseParenItem(this.parseSpread(refExpressionErrors), spreadNodeStartLoc);
          } else if (this.match(17)) {
            this.expectPlugin("partialApplication");
            if (!allowPlaceholder) {
              this.raise(Errors.UnexpectedArgumentPlaceholder, this.state.startLoc);
            }
            const node = this.startNode();
            this.next();
            elt = this.finishNode(node, "ArgumentPlaceholder");
          } else {
            elt = this.parseMaybeAssignAllowInOrVoidPattern(close, refExpressionErrors, this.parseParenItem);
          }
          return elt;
        }
        parseIdentifier(liberal) {
          const node = this.startNode();
          const name = this.parseIdentifierName(liberal);
          return this.createIdentifier(node, name);
        }
        createIdentifier(node, name) {
          node.name = name;
          node.loc.identifierName = name;
          return this.finishNode(node, "Identifier");
        }
        createIdentifierAt(node, name, endLoc) {
          node.name = name;
          node.loc.identifierName = name;
          return this.finishNodeAt(node, "Identifier", endLoc);
        }
        parseIdentifierName(liberal) {
          let name;
          const {
            startLoc,
            type
          } = this.state;
          if (tokenIsKeywordOrIdentifier(type)) {
            name = this.state.value;
          } else {
            this.unexpected();
          }
          const tokenIsKeyword2 = tokenKeywordOrIdentifierIsKeyword(type);
          if (liberal) {
            if (tokenIsKeyword2) {
              this.replaceToken(132);
            }
          } else {
            this.checkReservedWord(name, startLoc, tokenIsKeyword2, false);
          }
          this.next();
          return name;
        }
        checkReservedWord(word, startLoc, checkKeywords, isBinding) {
          if (word.length > 10) {
            return;
          }
          if (!canBeReservedWord(word)) {
            return;
          }
          if (checkKeywords && isKeyword(word)) {
            this.raise(Errors.UnexpectedKeyword, startLoc, {
              keyword: word
            });
            return;
          }
          const reservedTest = !this.state.strict ? isReservedWord : isBinding ? isStrictBindReservedWord : isStrictReservedWord;
          if (reservedTest(word, this.inModule)) {
            this.raise(Errors.UnexpectedReservedWord, startLoc, {
              reservedWord: word
            });
            return;
          } else if (word === "yield") {
            if (this.prodParam.hasYield) {
              this.raise(Errors.YieldBindingIdentifier, startLoc);
              return;
            }
          } else if (word === "await") {
            if (this.prodParam.hasAwait) {
              this.raise(Errors.AwaitBindingIdentifier, startLoc);
              return;
            }
            if (this.scope.inStaticBlock) {
              this.raise(Errors.AwaitBindingIdentifierInStaticBlock, startLoc);
              return;
            }
            this.expressionScope.recordAsyncArrowParametersError(startLoc);
          } else if (word === "arguments") {
            if (this.scope.inClassAndNotInNonArrowFunction) {
              this.raise(Errors.ArgumentsInClass, startLoc);
              return;
            }
          }
        }
        recordAwaitIfAllowed() {
          const isAwaitAllowed = this.prodParam.hasAwait;
          if (isAwaitAllowed && !this.scope.inFunction) {
            this.state.hasTopLevelAwait = true;
          }
          return isAwaitAllowed;
        }
        parseAwait(startLoc) {
          const node = this.startNodeAt(startLoc);
          this.expressionScope.recordParameterInitializerError(Errors.AwaitExpressionFormalParameter, node);
          if (this.eat(55)) {
            this.raise(Errors.ObsoleteAwaitStar, node);
          }
          if (!this.scope.inFunction && !(this.optionFlags & 1)) {
            if (this.isAmbiguousPrefixOrIdentifier()) {
              this.ambiguousScriptDifferentAst = true;
            } else {
              this.sawUnambiguousESM = true;
            }
          }
          if (!this.state.soloAwait) {
            node.argument = this.parseMaybeUnary(null, true);
          }
          return this.finishNode(node, "AwaitExpression");
        }
        isAmbiguousPrefixOrIdentifier() {
          if (this.hasPrecedingLineBreak())
            return true;
          const {
            type
          } = this.state;
          return type === 53 || type === 10 || type === 0 || tokenIsTemplate(type) || type === 102 && !this.state.containsEsc || type === 138 || type === 56 || this.hasPlugin("v8intrinsic") && type === 54;
        }
        parseYield(startLoc) {
          const node = this.startNodeAt(startLoc);
          this.expressionScope.recordParameterInitializerError(Errors.YieldInParameter, node);
          let delegating = false;
          let argument = null;
          if (!this.hasPrecedingLineBreak()) {
            delegating = this.eat(55);
            switch (this.state.type) {
              case 13:
              case 140:
              case 8:
              case 11:
              case 3:
              case 9:
              case 14:
              case 12:
                if (!delegating)
                  break;
              default:
                argument = this.parseMaybeAssign();
            }
          }
          node.delegate = delegating;
          node.argument = argument;
          return this.finishNode(node, "YieldExpression");
        }
        parseImportCall(node) {
          this.next();
          node.source = this.parseMaybeAssignAllowIn();
          node.options = null;
          if (this.eat(12)) {
            if (!this.match(11)) {
              node.options = this.parseMaybeAssignAllowIn();
              if (this.eat(12)) {
                this.addTrailingCommaExtraToNode(node.options);
                if (!this.match(11)) {
                  do {
                    this.parseMaybeAssignAllowIn();
                  } while (this.eat(12) && !this.match(11));
                  this.raise(Errors.ImportCallArity, node);
                }
              }
            } else {
              this.addTrailingCommaExtraToNode(node.source);
            }
          }
          this.expect(11);
          return this.finishNode(node, "ImportExpression");
        }
        checkPipelineAtInfixOperator(left, leftStartLoc) {
          if (this.hasPlugin(["pipelineOperator", {
            proposal: "smart"
          }])) {
            if (left.type === "SequenceExpression") {
              this.raise(Errors.PipelineHeadSequenceExpression, leftStartLoc);
            }
          }
        }
        parseSmartPipelineBodyInStyle(childExpr, startLoc) {
          if (this.isSimpleReference(childExpr)) {
            const bodyNode = this.startNodeAt(startLoc);
            bodyNode.callee = childExpr;
            return this.finishNode(bodyNode, "PipelineBareFunction");
          } else {
            const bodyNode = this.startNodeAt(startLoc);
            this.checkSmartPipeTopicBodyEarlyErrors(startLoc);
            bodyNode.expression = childExpr;
            return this.finishNode(bodyNode, "PipelineTopicExpression");
          }
        }
        isSimpleReference(expression) {
          switch (expression.type) {
            case "MemberExpression":
              return !expression.computed && this.isSimpleReference(expression.object);
            case "Identifier":
              return true;
            default:
              return false;
          }
        }
        checkSmartPipeTopicBodyEarlyErrors(startLoc) {
          if (this.match(19)) {
            throw this.raise(Errors.PipelineBodyNoArrow, this.state.startLoc);
          }
          if (!this.topicReferenceWasUsedInCurrentContext()) {
            this.raise(Errors.PipelineTopicUnused, startLoc);
          }
        }
        withTopicBindingContext(callback) {
          const outerContextTopicState = this.state.topicContext;
          this.state.topicContext = {
            maxNumOfResolvableTopics: 1,
            maxTopicIndex: null
          };
          try {
            return callback();
          } finally {
            this.state.topicContext = outerContextTopicState;
          }
        }
        withSmartMixTopicForbiddingContext(callback) {
          if (this.hasPlugin(["pipelineOperator", {
            proposal: "smart"
          }])) {
            const outerContextTopicState = this.state.topicContext;
            this.state.topicContext = {
              maxNumOfResolvableTopics: 0,
              maxTopicIndex: null
            };
            try {
              return callback();
            } finally {
              this.state.topicContext = outerContextTopicState;
            }
          } else {
            return callback();
          }
        }
        withSoloAwaitPermittingContext(callback) {
          const outerContextSoloAwaitState = this.state.soloAwait;
          this.state.soloAwait = true;
          try {
            return callback();
          } finally {
            this.state.soloAwait = outerContextSoloAwaitState;
          }
        }
        allowInAnd(callback) {
          const flags = this.prodParam.currentFlags();
          const prodParamToSet = 8 & ~flags;
          if (prodParamToSet) {
            this.prodParam.enter(flags | 8);
            try {
              return callback();
            } finally {
              this.prodParam.exit();
            }
          }
          return callback();
        }
        disallowInAnd(callback) {
          const flags = this.prodParam.currentFlags();
          const prodParamToClear = 8 & flags;
          if (prodParamToClear) {
            this.prodParam.enter(flags & ~8);
            try {
              return callback();
            } finally {
              this.prodParam.exit();
            }
          }
          return callback();
        }
        registerTopicReference() {
          this.state.topicContext.maxTopicIndex = 0;
        }
        topicReferenceIsAllowedInCurrentContext() {
          return this.state.topicContext.maxNumOfResolvableTopics >= 1;
        }
        topicReferenceWasUsedInCurrentContext() {
          return this.state.topicContext.maxTopicIndex != null && this.state.topicContext.maxTopicIndex >= 0;
        }
        parseFSharpPipelineBody(prec) {
          const startLoc = this.state.startLoc;
          this.state.potentialArrowAt = this.state.start;
          const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = true;
          const ret = this.parseExprOp(this.parseMaybeUnaryOrPrivate(), startLoc, prec);
          this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
          return ret;
        }
        parseModuleExpression() {
          this.expectPlugin("moduleBlocks");
          const node = this.startNode();
          this.next();
          if (!this.match(5)) {
            this.unexpected(null, 5);
          }
          const program3 = this.startNodeAt(this.state.endLoc);
          this.next();
          const revertScopes = this.initializeScopes(true);
          this.enterInitialScopes();
          try {
            node.body = this.parseProgram(program3, 8, "module");
          } finally {
            revertScopes();
          }
          return this.finishNode(node, "ModuleExpression");
        }
        parseVoidPattern(refExpressionErrors) {
          this.expectPlugin("discardBinding");
          const node = this.startNode();
          if (refExpressionErrors != null) {
            refExpressionErrors.voidPatternLoc = this.state.startLoc;
          }
          this.next();
          return this.finishNode(node, "VoidPattern");
        }
        parseMaybeAssignAllowInOrVoidPattern(close, refExpressionErrors, afterLeftParse) {
          if (refExpressionErrors != null && this.match(88)) {
            const nextCode = this.lookaheadCharCode();
            if (nextCode === 44 || nextCode === (close === 3 ? 93 : close === 8 ? 125 : 41) || nextCode === 61) {
              return this.parseMaybeDefault(this.state.startLoc, this.parseVoidPattern(refExpressionErrors));
            }
          }
          return this.parseMaybeAssignAllowIn(refExpressionErrors, afterLeftParse);
        }
        parsePropertyNamePrefixOperator(prop) {
        }
      };
      var loopLabel = {
        kind: 1
      };
      var switchLabel = {
        kind: 2
      };
      var loneSurrogate = /[\uD800-\uDFFF]/u;
      var keywordRelationalOperator = /in(?:stanceof)?/y;
      function babel7CompatTokens(tokens, input, startIndex) {
        for (let i = 0; i < tokens.length; i++) {
          const token = tokens[i];
          const {
            type
          } = token;
          if (typeof type === "number") {
            {
              if (type === 139) {
                const {
                  loc,
                  start,
                  value,
                  end
                } = token;
                const hashEndPos = start + 1;
                const hashEndLoc = createPositionWithColumnOffset(loc.start, 1);
                tokens.splice(i, 1, new Token({
                  type: getExportedToken(27),
                  value: "#",
                  start,
                  end: hashEndPos,
                  startLoc: loc.start,
                  endLoc: hashEndLoc
                }), new Token({
                  type: getExportedToken(132),
                  value,
                  start: hashEndPos,
                  end,
                  startLoc: hashEndLoc,
                  endLoc: loc.end
                }));
                i++;
                continue;
              }
              if (tokenIsTemplate(type)) {
                const {
                  loc,
                  start,
                  value,
                  end
                } = token;
                const backquoteEnd = start + 1;
                const backquoteEndLoc = createPositionWithColumnOffset(loc.start, 1);
                let startToken;
                if (input.charCodeAt(start - startIndex) === 96) {
                  startToken = new Token({
                    type: getExportedToken(22),
                    value: "`",
                    start,
                    end: backquoteEnd,
                    startLoc: loc.start,
                    endLoc: backquoteEndLoc
                  });
                } else {
                  startToken = new Token({
                    type: getExportedToken(8),
                    value: "}",
                    start,
                    end: backquoteEnd,
                    startLoc: loc.start,
                    endLoc: backquoteEndLoc
                  });
                }
                let templateValue, templateElementEnd, templateElementEndLoc, endToken;
                if (type === 24) {
                  templateElementEnd = end - 1;
                  templateElementEndLoc = createPositionWithColumnOffset(loc.end, -1);
                  templateValue = value === null ? null : value.slice(1, -1);
                  endToken = new Token({
                    type: getExportedToken(22),
                    value: "`",
                    start: templateElementEnd,
                    end,
                    startLoc: templateElementEndLoc,
                    endLoc: loc.end
                  });
                } else {
                  templateElementEnd = end - 2;
                  templateElementEndLoc = createPositionWithColumnOffset(loc.end, -2);
                  templateValue = value === null ? null : value.slice(1, -2);
                  endToken = new Token({
                    type: getExportedToken(23),
                    value: "${",
                    start: templateElementEnd,
                    end,
                    startLoc: templateElementEndLoc,
                    endLoc: loc.end
                  });
                }
                tokens.splice(i, 1, startToken, new Token({
                  type: getExportedToken(20),
                  value: templateValue,
                  start: backquoteEnd,
                  end: templateElementEnd,
                  startLoc: backquoteEndLoc,
                  endLoc: templateElementEndLoc
                }), endToken);
                i += 2;
                continue;
              }
            }
            token.type = getExportedToken(type);
          }
        }
        return tokens;
      }
      var StatementParser = class extends ExpressionParser {
        parseTopLevel(file2, program3) {
          file2.program = this.parseProgram(program3, 140, this.options.sourceType === "module" ? "module" : "script");
          file2.comments = this.comments;
          if (this.optionFlags & 256) {
            file2.tokens = babel7CompatTokens(this.tokens, this.input, this.startIndex);
          }
          return this.finishNode(file2, "File");
        }
        parseProgram(program3, end, sourceType) {
          program3.sourceType = sourceType;
          program3.interpreter = this.parseInterpreterDirective();
          this.parseBlockBody(program3, true, true, end);
          if (this.inModule) {
            if (!(this.optionFlags & 64) && this.scope.undefinedExports.size > 0) {
              for (const [localName, at2] of Array.from(this.scope.undefinedExports)) {
                this.raise(Errors.ModuleExportUndefined, at2, {
                  localName
                });
              }
            }
            this.addExtra(program3, "topLevelAwait", this.state.hasTopLevelAwait);
          }
          let finishedProgram;
          if (end === 140) {
            finishedProgram = this.finishNode(program3, "Program");
          } else {
            finishedProgram = this.finishNodeAt(program3, "Program", createPositionWithColumnOffset(this.state.startLoc, -1));
          }
          return finishedProgram;
        }
        stmtToDirective(stmt) {
          const directive = this.castNodeTo(stmt, "Directive");
          const directiveLiteral = this.castNodeTo(stmt.expression, "DirectiveLiteral");
          const expressionValue = directiveLiteral.value;
          const raw = this.input.slice(this.offsetToSourcePos(directiveLiteral.start), this.offsetToSourcePos(directiveLiteral.end));
          const val = directiveLiteral.value = raw.slice(1, -1);
          this.addExtra(directiveLiteral, "raw", raw);
          this.addExtra(directiveLiteral, "rawValue", val);
          this.addExtra(directiveLiteral, "expressionValue", expressionValue);
          directive.value = directiveLiteral;
          delete stmt.expression;
          return directive;
        }
        parseInterpreterDirective() {
          if (!this.match(28)) {
            return null;
          }
          const node = this.startNode();
          node.value = this.state.value;
          this.next();
          return this.finishNode(node, "InterpreterDirective");
        }
        isLet() {
          if (!this.isContextual(100)) {
            return false;
          }
          return this.hasFollowingBindingAtom();
        }
        isUsing() {
          if (!this.isContextual(107)) {
            return false;
          }
          const next = this.nextTokenInLineStart();
          const nextCh = this.codePointAtPos(next);
          return this.chStartsBindingIdentifier(nextCh, next);
        }
        isForUsing() {
          if (!this.isContextual(107)) {
            return false;
          }
          const next = this.nextTokenInLineStart();
          const nextCh = this.codePointAtPos(next);
          if (this.isUnparsedContextual(next, "of")) {
            const nextCharAfterOf = this.lookaheadCharCodeSince(next + 2);
            if (nextCharAfterOf !== 61 && nextCharAfterOf !== 58 && nextCharAfterOf !== 59) {
              return false;
            }
          }
          if (this.chStartsBindingIdentifier(nextCh, next) || this.isUnparsedContextual(next, "void")) {
            return true;
          }
          return false;
        }
        isAwaitUsing() {
          if (!this.isContextual(96)) {
            return false;
          }
          let next = this.nextTokenInLineStart();
          if (this.isUnparsedContextual(next, "using")) {
            next = this.nextTokenInLineStartSince(next + 5);
            const nextCh = this.codePointAtPos(next);
            if (this.chStartsBindingIdentifier(nextCh, next)) {
              return true;
            }
          }
          return false;
        }
        chStartsBindingIdentifier(ch, pos) {
          if (isIdentifierStart(ch)) {
            keywordRelationalOperator.lastIndex = pos;
            if (keywordRelationalOperator.test(this.input)) {
              const endCh = this.codePointAtPos(keywordRelationalOperator.lastIndex);
              if (!isIdentifierChar(endCh) && endCh !== 92) {
                return false;
              }
            }
            return true;
          } else if (ch === 92) {
            return true;
          } else {
            return false;
          }
        }
        chStartsBindingPattern(ch) {
          return ch === 91 || ch === 123;
        }
        hasFollowingBindingAtom() {
          const next = this.nextTokenStart();
          const nextCh = this.codePointAtPos(next);
          return this.chStartsBindingPattern(nextCh) || this.chStartsBindingIdentifier(nextCh, next);
        }
        hasInLineFollowingBindingIdentifierOrBrace() {
          const next = this.nextTokenInLineStart();
          const nextCh = this.codePointAtPos(next);
          return nextCh === 123 || this.chStartsBindingIdentifier(nextCh, next);
        }
        allowsUsing() {
          return (this.scope.inModule || !this.scope.inTopLevel) && !this.scope.inBareCaseStatement;
        }
        parseModuleItem() {
          return this.parseStatementLike(1 | 2 | 4 | 8);
        }
        parseStatementListItem() {
          return this.parseStatementLike(2 | 4 | (!this.options.annexB || this.state.strict ? 0 : 8));
        }
        parseStatementOrSloppyAnnexBFunctionDeclaration(allowLabeledFunction = false) {
          let flags = 0;
          if (this.options.annexB && !this.state.strict) {
            flags |= 4;
            if (allowLabeledFunction) {
              flags |= 8;
            }
          }
          return this.parseStatementLike(flags);
        }
        parseStatement() {
          return this.parseStatementLike(0);
        }
        parseStatementLike(flags) {
          let decorators = null;
          if (this.match(26)) {
            decorators = this.parseDecorators(true);
          }
          return this.parseStatementContent(flags, decorators);
        }
        parseStatementContent(flags, decorators) {
          const startType = this.state.type;
          const node = this.startNode();
          const allowDeclaration = !!(flags & 2);
          const allowFunctionDeclaration = !!(flags & 4);
          const topLevel = flags & 1;
          switch (startType) {
            case 60:
              return this.parseBreakContinueStatement(node, true);
            case 63:
              return this.parseBreakContinueStatement(node, false);
            case 64:
              return this.parseDebuggerStatement(node);
            case 90:
              return this.parseDoWhileStatement(node);
            case 91:
              return this.parseForStatement(node);
            case 68:
              if (this.lookaheadCharCode() === 46)
                break;
              if (!allowFunctionDeclaration) {
                this.raise(this.state.strict ? Errors.StrictFunction : this.options.annexB ? Errors.SloppyFunctionAnnexB : Errors.SloppyFunction, this.state.startLoc);
              }
              return this.parseFunctionStatement(node, false, !allowDeclaration && allowFunctionDeclaration);
            case 80:
              if (!allowDeclaration)
                this.unexpected();
              return this.parseClass(this.maybeTakeDecorators(decorators, node), true);
            case 69:
              return this.parseIfStatement(node);
            case 70:
              return this.parseReturnStatement(node);
            case 71:
              return this.parseSwitchStatement(node);
            case 72:
              return this.parseThrowStatement(node);
            case 73:
              return this.parseTryStatement(node);
            case 96:
              if (this.isAwaitUsing()) {
                if (!this.allowsUsing()) {
                  this.raise(Errors.UnexpectedUsingDeclaration, node);
                } else if (!allowDeclaration) {
                  this.raise(Errors.UnexpectedLexicalDeclaration, node);
                } else if (!this.recordAwaitIfAllowed()) {
                  this.raise(Errors.AwaitUsingNotInAsyncContext, node);
                }
                this.next();
                return this.parseVarStatement(node, "await using");
              }
              break;
            case 107:
              if (this.state.containsEsc || !this.hasInLineFollowingBindingIdentifierOrBrace()) {
                break;
              }
              if (!this.allowsUsing()) {
                this.raise(Errors.UnexpectedUsingDeclaration, this.state.startLoc);
              } else if (!allowDeclaration) {
                this.raise(Errors.UnexpectedLexicalDeclaration, this.state.startLoc);
              }
              return this.parseVarStatement(node, "using");
            case 100: {
              if (this.state.containsEsc) {
                break;
              }
              const next = this.nextTokenStart();
              const nextCh = this.codePointAtPos(next);
              if (nextCh !== 91) {
                if (!allowDeclaration && this.hasFollowingLineBreak())
                  break;
                if (!this.chStartsBindingIdentifier(nextCh, next) && nextCh !== 123) {
                  break;
                }
              }
            }
            case 75: {
              if (!allowDeclaration) {
                this.raise(Errors.UnexpectedLexicalDeclaration, this.state.startLoc);
              }
            }
            case 74: {
              const kind = this.state.value;
              return this.parseVarStatement(node, kind);
            }
            case 92:
              return this.parseWhileStatement(node);
            case 76:
              return this.parseWithStatement(node);
            case 5:
              return this.parseBlock();
            case 13:
              return this.parseEmptyStatement(node);
            case 83: {
              const nextTokenCharCode = this.lookaheadCharCode();
              if (nextTokenCharCode === 40 || nextTokenCharCode === 46) {
                break;
              }
            }
            case 82: {
              if (!(this.optionFlags & 8) && !topLevel) {
                this.raise(Errors.UnexpectedImportExport, this.state.startLoc);
              }
              this.next();
              let result2;
              if (startType === 83) {
                result2 = this.parseImport(node);
              } else {
                result2 = this.parseExport(node, decorators);
              }
              this.assertModuleNodeAllowed(result2);
              return result2;
            }
            default: {
              if (this.isAsyncFunction()) {
                if (!allowDeclaration) {
                  this.raise(Errors.AsyncFunctionInSingleStatementContext, this.state.startLoc);
                }
                this.next();
                return this.parseFunctionStatement(node, true, !allowDeclaration && allowFunctionDeclaration);
              }
            }
          }
          const maybeName = this.state.value;
          const expr = this.parseExpression();
          if (tokenIsIdentifier(startType) && expr.type === "Identifier" && this.eat(14)) {
            return this.parseLabeledStatement(node, maybeName, expr, flags);
          } else {
            return this.parseExpressionStatement(node, expr, decorators);
          }
        }
        assertModuleNodeAllowed(node) {
          if (!(this.optionFlags & 8) && !this.inModule) {
            this.raise(Errors.ImportOutsideModule, node);
          }
        }
        decoratorsEnabledBeforeExport() {
          if (this.hasPlugin("decorators-legacy"))
            return true;
          return this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") !== false;
        }
        maybeTakeDecorators(maybeDecorators, classNode, exportNode) {
          if (maybeDecorators) {
            var _classNode$decorators;
            if ((_classNode$decorators = classNode.decorators) != null && _classNode$decorators.length) {
              if (typeof this.getPluginOption("decorators", "decoratorsBeforeExport") !== "boolean") {
                this.raise(Errors.DecoratorsBeforeAfterExport, classNode.decorators[0]);
              }
              classNode.decorators.unshift(...maybeDecorators);
            } else {
              classNode.decorators = maybeDecorators;
            }
            this.resetStartLocationFromNode(classNode, maybeDecorators[0]);
            if (exportNode)
              this.resetStartLocationFromNode(exportNode, classNode);
          }
          return classNode;
        }
        canHaveLeadingDecorator() {
          return this.match(80);
        }
        parseDecorators(allowExport) {
          const decorators = [];
          do {
            decorators.push(this.parseDecorator());
          } while (this.match(26));
          if (this.match(82)) {
            if (!allowExport) {
              this.unexpected();
            }
            if (!this.decoratorsEnabledBeforeExport()) {
              this.raise(Errors.DecoratorExportClass, this.state.startLoc);
            }
          } else if (!this.canHaveLeadingDecorator()) {
            throw this.raise(Errors.UnexpectedLeadingDecorator, this.state.startLoc);
          }
          return decorators;
        }
        parseDecorator() {
          this.expectOnePlugin(["decorators", "decorators-legacy"]);
          const node = this.startNode();
          this.next();
          if (this.hasPlugin("decorators")) {
            const startLoc = this.state.startLoc;
            let expr;
            if (this.match(10)) {
              const startLoc2 = this.state.startLoc;
              this.next();
              expr = this.parseExpression();
              this.expect(11);
              expr = this.wrapParenthesis(startLoc2, expr);
              const paramsStartLoc = this.state.startLoc;
              node.expression = this.parseMaybeDecoratorArguments(expr, startLoc2);
              if (this.getPluginOption("decorators", "allowCallParenthesized") === false && node.expression !== expr) {
                this.raise(Errors.DecoratorArgumentsOutsideParentheses, paramsStartLoc);
              }
            } else {
              expr = this.parseIdentifier(false);
              while (this.eat(16)) {
                const node2 = this.startNodeAt(startLoc);
                node2.object = expr;
                if (this.match(139)) {
                  this.classScope.usePrivateName(this.state.value, this.state.startLoc);
                  node2.property = this.parsePrivateName();
                } else {
                  node2.property = this.parseIdentifier(true);
                }
                node2.computed = false;
                expr = this.finishNode(node2, "MemberExpression");
              }
              node.expression = this.parseMaybeDecoratorArguments(expr, startLoc);
            }
          } else {
            node.expression = this.parseExprSubscripts();
          }
          return this.finishNode(node, "Decorator");
        }
        parseMaybeDecoratorArguments(expr, startLoc) {
          if (this.eat(10)) {
            const node = this.startNodeAt(startLoc);
            node.callee = expr;
            node.arguments = this.parseCallExpressionArguments();
            this.toReferencedList(node.arguments);
            return this.finishNode(node, "CallExpression");
          }
          return expr;
        }
        parseBreakContinueStatement(node, isBreak) {
          this.next();
          if (this.isLineTerminator()) {
            node.label = null;
          } else {
            node.label = this.parseIdentifier();
            this.semicolon();
          }
          this.verifyBreakContinue(node, isBreak);
          return this.finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement");
        }
        verifyBreakContinue(node, isBreak) {
          let i;
          for (i = 0; i < this.state.labels.length; ++i) {
            const lab = this.state.labels[i];
            if (node.label == null || lab.name === node.label.name) {
              if (lab.kind != null && (isBreak || lab.kind === 1)) {
                break;
              }
              if (node.label && isBreak)
                break;
            }
          }
          if (i === this.state.labels.length) {
            const type = isBreak ? "BreakStatement" : "ContinueStatement";
            this.raise(Errors.IllegalBreakContinue, node, {
              type
            });
          }
        }
        parseDebuggerStatement(node) {
          this.next();
          this.semicolon();
          return this.finishNode(node, "DebuggerStatement");
        }
        parseHeaderExpression() {
          this.expect(10);
          const val = this.parseExpression();
          this.expect(11);
          return val;
        }
        parseDoWhileStatement(node) {
          this.next();
          this.state.labels.push(loopLabel);
          node.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement());
          this.state.labels.pop();
          this.expect(92);
          node.test = this.parseHeaderExpression();
          this.eat(13);
          return this.finishNode(node, "DoWhileStatement");
        }
        parseForStatement(node) {
          this.next();
          this.state.labels.push(loopLabel);
          let awaitAt = null;
          if (this.isContextual(96) && this.recordAwaitIfAllowed()) {
            awaitAt = this.state.startLoc;
            this.next();
          }
          this.scope.enter(0);
          this.expect(10);
          if (this.match(13)) {
            if (awaitAt !== null) {
              this.unexpected(awaitAt);
            }
            return this.parseFor(node, null);
          }
          const startsWithLet = this.isContextual(100);
          {
            const startsWithAwaitUsing = this.isAwaitUsing();
            const starsWithUsingDeclaration = startsWithAwaitUsing || this.isForUsing();
            const isLetOrUsing = startsWithLet && this.hasFollowingBindingAtom() || starsWithUsingDeclaration;
            if (this.match(74) || this.match(75) || isLetOrUsing) {
              const initNode = this.startNode();
              let kind;
              if (startsWithAwaitUsing) {
                kind = "await using";
                if (!this.recordAwaitIfAllowed()) {
                  this.raise(Errors.AwaitUsingNotInAsyncContext, this.state.startLoc);
                }
                this.next();
              } else {
                kind = this.state.value;
              }
              this.next();
              this.parseVar(initNode, true, kind);
              const init2 = this.finishNode(initNode, "VariableDeclaration");
              const isForIn = this.match(58);
              if (isForIn && starsWithUsingDeclaration) {
                this.raise(Errors.ForInUsing, init2);
              }
              if ((isForIn || this.isContextual(102)) && init2.declarations.length === 1) {
                return this.parseForIn(node, init2, awaitAt);
              }
              if (awaitAt !== null) {
                this.unexpected(awaitAt);
              }
              return this.parseFor(node, init2);
            }
          }
          const startsWithAsync = this.isContextual(95);
          const refExpressionErrors = new ExpressionErrors();
          const init = this.parseExpression(true, refExpressionErrors);
          const isForOf = this.isContextual(102);
          if (isForOf) {
            if (startsWithLet) {
              this.raise(Errors.ForOfLet, init);
            }
            if (awaitAt === null && startsWithAsync && init.type === "Identifier") {
              this.raise(Errors.ForOfAsync, init);
            }
          }
          if (isForOf || this.match(58)) {
            this.checkDestructuringPrivate(refExpressionErrors);
            this.toAssignable(init, true);
            const type = isForOf ? "ForOfStatement" : "ForInStatement";
            this.checkLVal(init, {
              type
            });
            return this.parseForIn(node, init, awaitAt);
          } else {
            this.checkExpressionErrors(refExpressionErrors, true);
          }
          if (awaitAt !== null) {
            this.unexpected(awaitAt);
          }
          return this.parseFor(node, init);
        }
        parseFunctionStatement(node, isAsync, isHangingDeclaration) {
          this.next();
          return this.parseFunction(node, 1 | (isHangingDeclaration ? 2 : 0) | (isAsync ? 8 : 0));
        }
        parseIfStatement(node) {
          this.next();
          node.test = this.parseHeaderExpression();
          node.consequent = this.parseStatementOrSloppyAnnexBFunctionDeclaration();
          node.alternate = this.eat(66) ? this.parseStatementOrSloppyAnnexBFunctionDeclaration() : null;
          return this.finishNode(node, "IfStatement");
        }
        parseReturnStatement(node) {
          if (!this.prodParam.hasReturn) {
            this.raise(Errors.IllegalReturn, this.state.startLoc);
          }
          this.next();
          if (this.isLineTerminator()) {
            node.argument = null;
          } else {
            node.argument = this.parseExpression();
            this.semicolon();
          }
          return this.finishNode(node, "ReturnStatement");
        }
        parseSwitchStatement(node) {
          this.next();
          node.discriminant = this.parseHeaderExpression();
          const cases = node.cases = [];
          this.expect(5);
          this.state.labels.push(switchLabel);
          this.scope.enter(256);
          let cur;
          for (let sawDefault; !this.match(8); ) {
            if (this.match(61) || this.match(65)) {
              const isCase = this.match(61);
              if (cur)
                this.finishNode(cur, "SwitchCase");
              cases.push(cur = this.startNode());
              cur.consequent = [];
              this.next();
              if (isCase) {
                cur.test = this.parseExpression();
              } else {
                if (sawDefault) {
                  this.raise(Errors.MultipleDefaultsInSwitch, this.state.lastTokStartLoc);
                }
                sawDefault = true;
                cur.test = null;
              }
              this.expect(14);
            } else {
              if (cur) {
                cur.consequent.push(this.parseStatementListItem());
              } else {
                this.unexpected();
              }
            }
          }
          this.scope.exit();
          if (cur)
            this.finishNode(cur, "SwitchCase");
          this.next();
          this.state.labels.pop();
          return this.finishNode(node, "SwitchStatement");
        }
        parseThrowStatement(node) {
          this.next();
          if (this.hasPrecedingLineBreak()) {
            this.raise(Errors.NewlineAfterThrow, this.state.lastTokEndLoc);
          }
          node.argument = this.parseExpression();
          this.semicolon();
          return this.finishNode(node, "ThrowStatement");
        }
        parseCatchClauseParam() {
          const param = this.parseBindingAtom();
          this.scope.enter(this.options.annexB && param.type === "Identifier" ? 8 : 0);
          this.checkLVal(param, {
            type: "CatchClause"
          }, 9);
          return param;
        }
        parseTryStatement(node) {
          this.next();
          node.block = this.parseBlock();
          node.handler = null;
          if (this.match(62)) {
            const clause = this.startNode();
            this.next();
            if (this.match(10)) {
              this.expect(10);
              clause.param = this.parseCatchClauseParam();
              this.expect(11);
            } else {
              clause.param = null;
              this.scope.enter(0);
            }
            clause.body = this.withSmartMixTopicForbiddingContext(() => this.parseBlock(false, false));
            this.scope.exit();
            node.handler = this.finishNode(clause, "CatchClause");
          }
          node.finalizer = this.eat(67) ? this.parseBlock() : null;
          if (!node.handler && !node.finalizer) {
            this.raise(Errors.NoCatchOrFinally, node);
          }
          return this.finishNode(node, "TryStatement");
        }
        parseVarStatement(node, kind, allowMissingInitializer = false) {
          this.next();
          this.parseVar(node, false, kind, allowMissingInitializer);
          this.semicolon();
          return this.finishNode(node, "VariableDeclaration");
        }
        parseWhileStatement(node) {
          this.next();
          node.test = this.parseHeaderExpression();
          this.state.labels.push(loopLabel);
          node.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement());
          this.state.labels.pop();
          return this.finishNode(node, "WhileStatement");
        }
        parseWithStatement(node) {
          if (this.state.strict) {
            this.raise(Errors.StrictWith, this.state.startLoc);
          }
          this.next();
          node.object = this.parseHeaderExpression();
          node.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement());
          return this.finishNode(node, "WithStatement");
        }
        parseEmptyStatement(node) {
          this.next();
          return this.finishNode(node, "EmptyStatement");
        }
        parseLabeledStatement(node, maybeName, expr, flags) {
          for (const label of this.state.labels) {
            if (label.name === maybeName) {
              this.raise(Errors.LabelRedeclaration, expr, {
                labelName: maybeName
              });
            }
          }
          const kind = tokenIsLoop(this.state.type) ? 1 : this.match(71) ? 2 : null;
          for (let i = this.state.labels.length - 1; i >= 0; i--) {
            const label = this.state.labels[i];
            if (label.statementStart === node.start) {
              label.statementStart = this.sourceToOffsetPos(this.state.start);
              label.kind = kind;
            } else {
              break;
            }
          }
          this.state.labels.push({
            name: maybeName,
            kind,
            statementStart: this.sourceToOffsetPos(this.state.start)
          });
          node.body = flags & 8 ? this.parseStatementOrSloppyAnnexBFunctionDeclaration(true) : this.parseStatement();
          this.state.labels.pop();
          node.label = expr;
          return this.finishNode(node, "LabeledStatement");
        }
        parseExpressionStatement(node, expr, decorators) {
          node.expression = expr;
          this.semicolon();
          return this.finishNode(node, "ExpressionStatement");
        }
        parseBlock(allowDirectives = false, createNewLexicalScope = true, afterBlockParse) {
          const node = this.startNode();
          if (allowDirectives) {
            this.state.strictErrors.clear();
          }
          this.expect(5);
          if (createNewLexicalScope) {
            this.scope.enter(0);
          }
          this.parseBlockBody(node, allowDirectives, false, 8, afterBlockParse);
          if (createNewLexicalScope) {
            this.scope.exit();
          }
          return this.finishNode(node, "BlockStatement");
        }
        isValidDirective(stmt) {
          return stmt.type === "ExpressionStatement" && stmt.expression.type === "StringLiteral" && !stmt.expression.extra.parenthesized;
        }
        parseBlockBody(node, allowDirectives, topLevel, end, afterBlockParse) {
          const body = node.body = [];
          const directives = node.directives = [];
          this.parseBlockOrModuleBlockBody(body, allowDirectives ? directives : void 0, topLevel, end, afterBlockParse);
        }
        parseBlockOrModuleBlockBody(body, directives, topLevel, end, afterBlockParse) {
          const oldStrict = this.state.strict;
          let hasStrictModeDirective = false;
          let parsedNonDirective = false;
          while (!this.match(end)) {
            const stmt = topLevel ? this.parseModuleItem() : this.parseStatementListItem();
            if (directives && !parsedNonDirective) {
              if (this.isValidDirective(stmt)) {
                const directive = this.stmtToDirective(stmt);
                directives.push(directive);
                if (!hasStrictModeDirective && directive.value.value === "use strict") {
                  hasStrictModeDirective = true;
                  this.setStrict(true);
                }
                continue;
              }
              parsedNonDirective = true;
              this.state.strictErrors.clear();
            }
            body.push(stmt);
          }
          afterBlockParse == null || afterBlockParse.call(this, hasStrictModeDirective);
          if (!oldStrict) {
            this.setStrict(false);
          }
          this.next();
        }
        parseFor(node, init) {
          node.init = init;
          this.semicolon(false);
          node.test = this.match(13) ? null : this.parseExpression();
          this.semicolon(false);
          node.update = this.match(11) ? null : this.parseExpression();
          this.expect(11);
          node.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement());
          this.scope.exit();
          this.state.labels.pop();
          return this.finishNode(node, "ForStatement");
        }
        parseForIn(node, init, awaitAt) {
          const isForIn = this.match(58);
          this.next();
          if (isForIn) {
            if (awaitAt !== null)
              this.unexpected(awaitAt);
          } else {
            node.await = awaitAt !== null;
          }
          if (init.type === "VariableDeclaration" && init.declarations[0].init != null && (!isForIn || !this.options.annexB || this.state.strict || init.kind !== "var" || init.declarations[0].id.type !== "Identifier")) {
            this.raise(Errors.ForInOfLoopInitializer, init, {
              type: isForIn ? "ForInStatement" : "ForOfStatement"
            });
          }
          if (init.type === "AssignmentPattern") {
            this.raise(Errors.InvalidLhs, init, {
              ancestor: {
                type: "ForStatement"
              }
            });
          }
          node.left = init;
          node.right = isForIn ? this.parseExpression() : this.parseMaybeAssignAllowIn();
          this.expect(11);
          node.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement());
          this.scope.exit();
          this.state.labels.pop();
          return this.finishNode(node, isForIn ? "ForInStatement" : "ForOfStatement");
        }
        parseVar(node, isFor, kind, allowMissingInitializer = false) {
          const declarations = node.declarations = [];
          node.kind = kind;
          for (; ; ) {
            const decl = this.startNode();
            this.parseVarId(decl, kind);
            decl.init = !this.eat(29) ? null : isFor ? this.parseMaybeAssignDisallowIn() : this.parseMaybeAssignAllowIn();
            if (decl.init === null && !allowMissingInitializer) {
              if (decl.id.type !== "Identifier" && !(isFor && (this.match(58) || this.isContextual(102)))) {
                this.raise(Errors.DeclarationMissingInitializer, this.state.lastTokEndLoc, {
                  kind: "destructuring"
                });
              } else if ((kind === "const" || kind === "using" || kind === "await using") && !(this.match(58) || this.isContextual(102))) {
                this.raise(Errors.DeclarationMissingInitializer, this.state.lastTokEndLoc, {
                  kind
                });
              }
            }
            declarations.push(this.finishNode(decl, "VariableDeclarator"));
            if (!this.eat(12))
              break;
          }
          return node;
        }
        parseVarId(decl, kind) {
          const id = this.parseBindingAtom();
          if (kind === "using" || kind === "await using") {
            if (id.type === "ArrayPattern" || id.type === "ObjectPattern") {
              this.raise(Errors.UsingDeclarationHasBindingPattern, id.loc.start);
            }
          } else {
            if (id.type === "VoidPattern") {
              this.raise(Errors.UnexpectedVoidPattern, id.loc.start);
            }
          }
          this.checkLVal(id, {
            type: "VariableDeclarator"
          }, kind === "var" ? 5 : 8201);
          decl.id = id;
        }
        parseAsyncFunctionExpression(node) {
          return this.parseFunction(node, 8);
        }
        parseFunction(node, flags = 0) {
          const hangingDeclaration = flags & 2;
          const isDeclaration = !!(flags & 1);
          const requireId = isDeclaration && !(flags & 4);
          const isAsync = !!(flags & 8);
          this.initFunction(node, isAsync);
          if (this.match(55)) {
            if (hangingDeclaration) {
              this.raise(Errors.GeneratorInSingleStatementContext, this.state.startLoc);
            }
            this.next();
            node.generator = true;
          }
          if (isDeclaration) {
            node.id = this.parseFunctionId(requireId);
          }
          const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
          this.state.maybeInArrowParameters = false;
          this.scope.enter(514);
          this.prodParam.enter(functionFlags(isAsync, node.generator));
          if (!isDeclaration) {
            node.id = this.parseFunctionId();
          }
          this.parseFunctionParams(node, false);
          this.withSmartMixTopicForbiddingContext(() => {
            this.parseFunctionBodyAndFinish(node, isDeclaration ? "FunctionDeclaration" : "FunctionExpression");
          });
          this.prodParam.exit();
          this.scope.exit();
          if (isDeclaration && !hangingDeclaration) {
            this.registerFunctionStatementId(node);
          }
          this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
          return node;
        }
        parseFunctionId(requireId) {
          return requireId || tokenIsIdentifier(this.state.type) ? this.parseIdentifier() : null;
        }
        parseFunctionParams(node, isConstructor) {
          this.expect(10);
          this.expressionScope.enter(newParameterDeclarationScope());
          node.params = this.parseBindingList(11, 41, 2 | (isConstructor ? 4 : 0));
          this.expressionScope.exit();
        }
        registerFunctionStatementId(node) {
          if (!node.id)
            return;
          this.scope.declareName(node.id.name, !this.options.annexB || this.state.strict || node.generator || node.async ? this.scope.treatFunctionsAsVar ? 5 : 8201 : 17, node.id.loc.start);
        }
        parseClass(node, isStatement, optionalId) {
          this.next();
          const oldStrict = this.state.strict;
          this.state.strict = true;
          this.parseClassId(node, isStatement, optionalId);
          this.parseClassSuper(node);
          node.body = this.parseClassBody(!!node.superClass, oldStrict);
          return this.finishNode(node, isStatement ? "ClassDeclaration" : "ClassExpression");
        }
        isClassProperty() {
          return this.match(29) || this.match(13) || this.match(8);
        }
        isClassMethod() {
          return this.match(10);
        }
        nameIsConstructor(key) {
          return key.type === "Identifier" && key.name === "constructor" || key.type === "StringLiteral" && key.value === "constructor";
        }
        isNonstaticConstructor(method2) {
          return !method2.computed && !method2.static && this.nameIsConstructor(method2.key);
        }
        parseClassBody(hadSuperClass, oldStrict) {
          this.classScope.enter();
          const state = {
            hadConstructor: false,
            hadSuperClass
          };
          let decorators = [];
          const classBody = this.startNode();
          classBody.body = [];
          this.expect(5);
          this.withSmartMixTopicForbiddingContext(() => {
            while (!this.match(8)) {
              if (this.eat(13)) {
                if (decorators.length > 0) {
                  throw this.raise(Errors.DecoratorSemicolon, this.state.lastTokEndLoc);
                }
                continue;
              }
              if (this.match(26)) {
                decorators.push(this.parseDecorator());
                continue;
              }
              const member = this.startNode();
              if (decorators.length) {
                member.decorators = decorators;
                this.resetStartLocationFromNode(member, decorators[0]);
                decorators = [];
              }
              this.parseClassMember(classBody, member, state);
              if (member.kind === "constructor" && member.decorators && member.decorators.length > 0) {
                this.raise(Errors.DecoratorConstructor, member);
              }
            }
          });
          this.state.strict = oldStrict;
          this.next();
          if (decorators.length) {
            throw this.raise(Errors.TrailingDecorator, this.state.startLoc);
          }
          this.classScope.exit();
          return this.finishNode(classBody, "ClassBody");
        }
        parseClassMemberFromModifier(classBody, member) {
          const key = this.parseIdentifier(true);
          if (this.isClassMethod()) {
            const method2 = member;
            method2.kind = "method";
            method2.computed = false;
            method2.key = key;
            method2.static = false;
            this.pushClassMethod(classBody, method2, false, false, false, false);
            return true;
          } else if (this.isClassProperty()) {
            const prop = member;
            prop.computed = false;
            prop.key = key;
            prop.static = false;
            classBody.body.push(this.parseClassProperty(prop));
            return true;
          }
          this.resetPreviousNodeTrailingComments(key);
          return false;
        }
        parseClassMember(classBody, member, state) {
          const isStatic = this.isContextual(106);
          if (isStatic) {
            if (this.parseClassMemberFromModifier(classBody, member)) {
              return;
            }
            if (this.eat(5)) {
              this.parseClassStaticBlock(classBody, member);
              return;
            }
          }
          this.parseClassMemberWithIsStatic(classBody, member, state, isStatic);
        }
        parseClassMemberWithIsStatic(classBody, member, state, isStatic) {
          const publicMethod = member;
          const privateMethod = member;
          const publicProp = member;
          const privateProp = member;
          const accessorProp = member;
          const method2 = publicMethod;
          const publicMember = publicMethod;
          member.static = isStatic;
          this.parsePropertyNamePrefixOperator(member);
          if (this.eat(55)) {
            method2.kind = "method";
            const isPrivateName = this.match(139);
            this.parseClassElementName(method2);
            this.parsePostMemberNameModifiers(method2);
            if (isPrivateName) {
              this.pushClassPrivateMethod(classBody, privateMethod, true, false);
              return;
            }
            if (this.isNonstaticConstructor(publicMethod)) {
              this.raise(Errors.ConstructorIsGenerator, publicMethod.key);
            }
            this.pushClassMethod(classBody, publicMethod, true, false, false, false);
            return;
          }
          const isContextual = !this.state.containsEsc && tokenIsIdentifier(this.state.type);
          const key = this.parseClassElementName(member);
          const maybeContextualKw = isContextual ? key.name : null;
          const isPrivate = this.isPrivateName(key);
          const maybeQuestionTokenStartLoc = this.state.startLoc;
          this.parsePostMemberNameModifiers(publicMember);
          if (this.isClassMethod()) {
            method2.kind = "method";
            if (isPrivate) {
              this.pushClassPrivateMethod(classBody, privateMethod, false, false);
              return;
            }
            const isConstructor = this.isNonstaticConstructor(publicMethod);
            let allowsDirectSuper = false;
            if (isConstructor) {
              publicMethod.kind = "constructor";
              if (state.hadConstructor && !this.hasPlugin("typescript")) {
                this.raise(Errors.DuplicateConstructor, key);
              }
              if (isConstructor && this.hasPlugin("typescript") && member.override) {
                this.raise(Errors.OverrideOnConstructor, key);
              }
              state.hadConstructor = true;
              allowsDirectSuper = state.hadSuperClass;
            }
            this.pushClassMethod(classBody, publicMethod, false, false, isConstructor, allowsDirectSuper);
          } else if (this.isClassProperty()) {
            if (isPrivate) {
              this.pushClassPrivateProperty(classBody, privateProp);
            } else {
              this.pushClassProperty(classBody, publicProp);
            }
          } else if (maybeContextualKw === "async" && !this.isLineTerminator()) {
            this.resetPreviousNodeTrailingComments(key);
            const isGenerator = this.eat(55);
            if (publicMember.optional) {
              this.unexpected(maybeQuestionTokenStartLoc);
            }
            method2.kind = "method";
            const isPrivate2 = this.match(139);
            this.parseClassElementName(method2);
            this.parsePostMemberNameModifiers(publicMember);
            if (isPrivate2) {
              this.pushClassPrivateMethod(classBody, privateMethod, isGenerator, true);
            } else {
              if (this.isNonstaticConstructor(publicMethod)) {
                this.raise(Errors.ConstructorIsAsync, publicMethod.key);
              }
              this.pushClassMethod(classBody, publicMethod, isGenerator, true, false, false);
            }
          } else if ((maybeContextualKw === "get" || maybeContextualKw === "set") && !(this.match(55) && this.isLineTerminator())) {
            this.resetPreviousNodeTrailingComments(key);
            method2.kind = maybeContextualKw;
            const isPrivate2 = this.match(139);
            this.parseClassElementName(publicMethod);
            if (isPrivate2) {
              this.pushClassPrivateMethod(classBody, privateMethod, false, false);
            } else {
              if (this.isNonstaticConstructor(publicMethod)) {
                this.raise(Errors.ConstructorIsAccessor, publicMethod.key);
              }
              this.pushClassMethod(classBody, publicMethod, false, false, false, false);
            }
            this.checkGetterSetterParams(publicMethod);
          } else if (maybeContextualKw === "accessor" && !this.isLineTerminator()) {
            this.expectPlugin("decoratorAutoAccessors");
            this.resetPreviousNodeTrailingComments(key);
            const isPrivate2 = this.match(139);
            this.parseClassElementName(publicProp);
            this.pushClassAccessorProperty(classBody, accessorProp, isPrivate2);
          } else if (this.isLineTerminator()) {
            if (isPrivate) {
              this.pushClassPrivateProperty(classBody, privateProp);
            } else {
              this.pushClassProperty(classBody, publicProp);
            }
          } else {
            this.unexpected();
          }
        }
        parseClassElementName(member) {
          const {
            type,
            value
          } = this.state;
          if ((type === 132 || type === 134) && member.static && value === "prototype") {
            this.raise(Errors.StaticPrototype, this.state.startLoc);
          }
          if (type === 139) {
            if (value === "constructor") {
              this.raise(Errors.ConstructorClassPrivateField, this.state.startLoc);
            }
            const key = this.parsePrivateName();
            member.key = key;
            return key;
          }
          this.parsePropertyName(member);
          return member.key;
        }
        parseClassStaticBlock(classBody, member) {
          var _member$decorators;
          this.scope.enter(576 | 128 | 16);
          const oldLabels = this.state.labels;
          this.state.labels = [];
          this.prodParam.enter(0);
          const body = member.body = [];
          this.parseBlockOrModuleBlockBody(body, void 0, false, 8);
          this.prodParam.exit();
          this.scope.exit();
          this.state.labels = oldLabels;
          classBody.body.push(this.finishNode(member, "StaticBlock"));
          if ((_member$decorators = member.decorators) != null && _member$decorators.length) {
            this.raise(Errors.DecoratorStaticBlock, member);
          }
        }
        pushClassProperty(classBody, prop) {
          if (!prop.computed && this.nameIsConstructor(prop.key)) {
            this.raise(Errors.ConstructorClassField, prop.key);
          }
          classBody.body.push(this.parseClassProperty(prop));
        }
        pushClassPrivateProperty(classBody, prop) {
          const node = this.parseClassPrivateProperty(prop);
          classBody.body.push(node);
          this.classScope.declarePrivateName(this.getPrivateNameSV(node.key), 0, node.key.loc.start);
        }
        pushClassAccessorProperty(classBody, prop, isPrivate) {
          if (!isPrivate && !prop.computed && this.nameIsConstructor(prop.key)) {
            this.raise(Errors.ConstructorClassField, prop.key);
          }
          const node = this.parseClassAccessorProperty(prop);
          classBody.body.push(node);
          if (isPrivate) {
            this.classScope.declarePrivateName(this.getPrivateNameSV(node.key), 0, node.key.loc.start);
          }
        }
        pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper) {
          classBody.body.push(this.parseMethod(method2, isGenerator, isAsync, isConstructor, allowsDirectSuper, "ClassMethod", true));
        }
        pushClassPrivateMethod(classBody, method2, isGenerator, isAsync) {
          const node = this.parseMethod(method2, isGenerator, isAsync, false, false, "ClassPrivateMethod", true);
          classBody.body.push(node);
          const kind = node.kind === "get" ? node.static ? 6 : 2 : node.kind === "set" ? node.static ? 5 : 1 : 0;
          this.declareClassPrivateMethodInScope(node, kind);
        }
        declareClassPrivateMethodInScope(node, kind) {
          this.classScope.declarePrivateName(this.getPrivateNameSV(node.key), kind, node.key.loc.start);
        }
        parsePostMemberNameModifiers(methodOrProp) {
        }
        parseClassPrivateProperty(node) {
          this.parseInitializer(node);
          this.semicolon();
          return this.finishNode(node, "ClassPrivateProperty");
        }
        parseClassProperty(node) {
          this.parseInitializer(node);
          this.semicolon();
          return this.finishNode(node, "ClassProperty");
        }
        parseClassAccessorProperty(node) {
          this.parseInitializer(node);
          this.semicolon();
          return this.finishNode(node, "ClassAccessorProperty");
        }
        parseInitializer(node) {
          this.scope.enter(576 | 16);
          this.expressionScope.enter(newExpressionScope());
          this.prodParam.enter(0);
          node.value = this.eat(29) ? this.parseMaybeAssignAllowIn() : null;
          this.expressionScope.exit();
          this.prodParam.exit();
          this.scope.exit();
        }
        parseClassId(node, isStatement, optionalId, bindingType = 8331) {
          if (tokenIsIdentifier(this.state.type)) {
            node.id = this.parseIdentifier();
            if (isStatement) {
              this.declareNameFromIdentifier(node.id, bindingType);
            }
          } else {
            if (optionalId || !isStatement) {
              node.id = null;
            } else {
              throw this.raise(Errors.MissingClassName, this.state.startLoc);
            }
          }
        }
        parseClassSuper(node) {
          node.superClass = this.eat(81) ? this.parseExprSubscripts() : null;
        }
        parseExport(node, decorators) {
          const maybeDefaultIdentifier = this.parseMaybeImportPhase(node, true);
          const hasDefault = this.maybeParseExportDefaultSpecifier(node, maybeDefaultIdentifier);
          const parseAfterDefault = !hasDefault || this.eat(12);
          const hasStar = parseAfterDefault && this.eatExportStar(node);
          const hasNamespace = hasStar && this.maybeParseExportNamespaceSpecifier(node);
          const parseAfterNamespace = parseAfterDefault && (!hasNamespace || this.eat(12));
          const isFromRequired = hasDefault || hasStar;
          if (hasStar && !hasNamespace) {
            if (hasDefault)
              this.unexpected();
            if (decorators) {
              throw this.raise(Errors.UnsupportedDecoratorExport, node);
            }
            this.parseExportFrom(node, true);
            this.sawUnambiguousESM = true;
            return this.finishNode(node, "ExportAllDeclaration");
          }
          const hasSpecifiers = this.maybeParseExportNamedSpecifiers(node);
          if (hasDefault && parseAfterDefault && !hasStar && !hasSpecifiers) {
            this.unexpected(null, 5);
          }
          if (hasNamespace && parseAfterNamespace) {
            this.unexpected(null, 98);
          }
          let hasDeclaration;
          if (isFromRequired || hasSpecifiers) {
            hasDeclaration = false;
            if (decorators) {
              throw this.raise(Errors.UnsupportedDecoratorExport, node);
            }
            this.parseExportFrom(node, isFromRequired);
          } else {
            hasDeclaration = this.maybeParseExportDeclaration(node);
          }
          if (isFromRequired || hasSpecifiers || hasDeclaration) {
            var _node2$declaration;
            const node2 = node;
            this.checkExport(node2, true, false, !!node2.source);
            if (((_node2$declaration = node2.declaration) == null ? void 0 : _node2$declaration.type) === "ClassDeclaration") {
              this.maybeTakeDecorators(decorators, node2.declaration, node2);
            } else if (decorators) {
              throw this.raise(Errors.UnsupportedDecoratorExport, node);
            }
            this.sawUnambiguousESM = true;
            return this.finishNode(node2, "ExportNamedDeclaration");
          }
          if (this.eat(65)) {
            const node2 = node;
            const decl = this.parseExportDefaultExpression();
            node2.declaration = decl;
            if (decl.type === "ClassDeclaration") {
              this.maybeTakeDecorators(decorators, decl, node2);
            } else if (decorators) {
              throw this.raise(Errors.UnsupportedDecoratorExport, node);
            }
            this.checkExport(node2, true, true);
            this.sawUnambiguousESM = true;
            return this.finishNode(node2, "ExportDefaultDeclaration");
          }
          this.unexpected(null, 5);
        }
        eatExportStar(node) {
          return this.eat(55);
        }
        maybeParseExportDefaultSpecifier(node, maybeDefaultIdentifier) {
          if (maybeDefaultIdentifier || this.isExportDefaultSpecifier()) {
            this.expectPlugin("exportDefaultFrom", maybeDefaultIdentifier == null ? void 0 : maybeDefaultIdentifier.loc.start);
            const id = maybeDefaultIdentifier || this.parseIdentifier(true);
            const specifier = this.startNodeAtNode(id);
            specifier.exported = id;
            node.specifiers = [this.finishNode(specifier, "ExportDefaultSpecifier")];
            return true;
          }
          return false;
        }
        maybeParseExportNamespaceSpecifier(node) {
          if (this.isContextual(93)) {
            var _ref, _ref$specifiers;
            (_ref$specifiers = (_ref = node).specifiers) != null ? _ref$specifiers : _ref.specifiers = [];
            const specifier = this.startNodeAt(this.state.lastTokStartLoc);
            this.next();
            specifier.exported = this.parseModuleExportName();
            node.specifiers.push(this.finishNode(specifier, "ExportNamespaceSpecifier"));
            return true;
          }
          return false;
        }
        maybeParseExportNamedSpecifiers(node) {
          if (this.match(5)) {
            const node2 = node;
            if (!node2.specifiers)
              node2.specifiers = [];
            const isTypeExport = node2.exportKind === "type";
            node2.specifiers.push(...this.parseExportSpecifiers(isTypeExport));
            node2.source = null;
            if (this.hasPlugin("importAssertions")) {
              node2.assertions = [];
            } else {
              node2.attributes = [];
            }
            node2.declaration = null;
            return true;
          }
          return false;
        }
        maybeParseExportDeclaration(node) {
          if (this.shouldParseExportDeclaration()) {
            node.specifiers = [];
            node.source = null;
            if (this.hasPlugin("importAssertions")) {
              node.assertions = [];
            } else {
              node.attributes = [];
            }
            node.declaration = this.parseExportDeclaration(node);
            return true;
          }
          return false;
        }
        isAsyncFunction() {
          if (!this.isContextual(95))
            return false;
          const next = this.nextTokenInLineStart();
          return this.isUnparsedContextual(next, "function");
        }
        parseExportDefaultExpression() {
          const expr = this.startNode();
          if (this.match(68)) {
            this.next();
            return this.parseFunction(expr, 1 | 4);
          } else if (this.isAsyncFunction()) {
            this.next();
            this.next();
            return this.parseFunction(expr, 1 | 4 | 8);
          }
          if (this.match(80)) {
            return this.parseClass(expr, true, true);
          }
          if (this.match(26)) {
            if (this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") === true) {
              this.raise(Errors.DecoratorBeforeExport, this.state.startLoc);
            }
            return this.parseClass(this.maybeTakeDecorators(this.parseDecorators(false), this.startNode()), true, true);
          }
          if (this.match(75) || this.match(74) || this.isLet() || this.isUsing() || this.isAwaitUsing()) {
            throw this.raise(Errors.UnsupportedDefaultExport, this.state.startLoc);
          }
          const res = this.parseMaybeAssignAllowIn();
          this.semicolon();
          return res;
        }
        parseExportDeclaration(node) {
          if (this.match(80)) {
            const node2 = this.parseClass(this.startNode(), true, false);
            return node2;
          }
          return this.parseStatementListItem();
        }
        isExportDefaultSpecifier() {
          const {
            type
          } = this.state;
          if (tokenIsIdentifier(type)) {
            if (type === 95 && !this.state.containsEsc || type === 100) {
              return false;
            }
            if ((type === 130 || type === 129) && !this.state.containsEsc) {
              const next2 = this.nextTokenStart();
              const nextChar = this.input.charCodeAt(next2);
              if (nextChar === 123 || this.chStartsBindingIdentifier(nextChar, next2) && !this.input.startsWith("from", next2)) {
                this.expectOnePlugin(["flow", "typescript"]);
                return false;
              }
            }
          } else if (!this.match(65)) {
            return false;
          }
          const next = this.nextTokenStart();
          const hasFrom = this.isUnparsedContextual(next, "from");
          if (this.input.charCodeAt(next) === 44 || tokenIsIdentifier(this.state.type) && hasFrom) {
            return true;
          }
          if (this.match(65) && hasFrom) {
            const nextAfterFrom = this.input.charCodeAt(this.nextTokenStartSince(next + 4));
            return nextAfterFrom === 34 || nextAfterFrom === 39;
          }
          return false;
        }
        parseExportFrom(node, expect) {
          if (this.eatContextual(98)) {
            node.source = this.parseImportSource();
            this.checkExport(node);
            this.maybeParseImportAttributes(node);
            this.checkJSONModuleImport(node);
          } else if (expect) {
            this.unexpected();
          }
          this.semicolon();
        }
        shouldParseExportDeclaration() {
          const {
            type
          } = this.state;
          if (type === 26) {
            this.expectOnePlugin(["decorators", "decorators-legacy"]);
            if (this.hasPlugin("decorators")) {
              if (this.getPluginOption("decorators", "decoratorsBeforeExport") === true) {
                this.raise(Errors.DecoratorBeforeExport, this.state.startLoc);
              }
              return true;
            }
          }
          if (this.isUsing()) {
            this.raise(Errors.UsingDeclarationExport, this.state.startLoc);
            return true;
          }
          if (this.isAwaitUsing()) {
            this.raise(Errors.UsingDeclarationExport, this.state.startLoc);
            return true;
          }
          return type === 74 || type === 75 || type === 68 || type === 80 || this.isLet() || this.isAsyncFunction();
        }
        checkExport(node, checkNames, isDefault, isFrom) {
          if (checkNames) {
            var _node$specifiers;
            if (isDefault) {
              this.checkDuplicateExports(node, "default");
              if (this.hasPlugin("exportDefaultFrom")) {
                var _declaration$extra;
                const declaration = node.declaration;
                if (declaration.type === "Identifier" && declaration.name === "from" && declaration.end - declaration.start === 4 && !((_declaration$extra = declaration.extra) != null && _declaration$extra.parenthesized)) {
                  this.raise(Errors.ExportDefaultFromAsIdentifier, declaration);
                }
              }
            } else if ((_node$specifiers = node.specifiers) != null && _node$specifiers.length) {
              for (const specifier of node.specifiers) {
                const {
                  exported
                } = specifier;
                const exportName = exported.type === "Identifier" ? exported.name : exported.value;
                this.checkDuplicateExports(specifier, exportName);
                if (!isFrom && specifier.local) {
                  const {
                    local
                  } = specifier;
                  if (local.type !== "Identifier") {
                    this.raise(Errors.ExportBindingIsString, specifier, {
                      localName: local.value,
                      exportName
                    });
                  } else {
                    this.checkReservedWord(local.name, local.loc.start, true, false);
                    this.scope.checkLocalExport(local);
                  }
                }
              }
            } else if (node.declaration) {
              const decl = node.declaration;
              if (decl.type === "FunctionDeclaration" || decl.type === "ClassDeclaration") {
                const {
                  id
                } = decl;
                if (!id)
                  throw new Error("Assertion failure");
                this.checkDuplicateExports(node, id.name);
              } else if (decl.type === "VariableDeclaration") {
                for (const declaration of decl.declarations) {
                  this.checkDeclaration(declaration.id);
                }
              }
            }
          }
        }
        checkDeclaration(node) {
          if (node.type === "Identifier") {
            this.checkDuplicateExports(node, node.name);
          } else if (node.type === "ObjectPattern") {
            for (const prop of node.properties) {
              this.checkDeclaration(prop);
            }
          } else if (node.type === "ArrayPattern") {
            for (const elem of node.elements) {
              if (elem) {
                this.checkDeclaration(elem);
              }
            }
          } else if (node.type === "ObjectProperty") {
            this.checkDeclaration(node.value);
          } else if (node.type === "RestElement") {
            this.checkDeclaration(node.argument);
          } else if (node.type === "AssignmentPattern") {
            this.checkDeclaration(node.left);
          }
        }
        checkDuplicateExports(node, exportName) {
          if (this.exportedIdentifiers.has(exportName)) {
            if (exportName === "default") {
              this.raise(Errors.DuplicateDefaultExport, node);
            } else {
              this.raise(Errors.DuplicateExport, node, {
                exportName
              });
            }
          }
          this.exportedIdentifiers.add(exportName);
        }
        parseExportSpecifiers(isInTypeExport) {
          const nodes = [];
          let first = true;
          this.expect(5);
          while (!this.eat(8)) {
            if (first) {
              first = false;
            } else {
              this.expect(12);
              if (this.eat(8))
                break;
            }
            const isMaybeTypeOnly = this.isContextual(130);
            const isString3 = this.match(134);
            const node = this.startNode();
            node.local = this.parseModuleExportName();
            nodes.push(this.parseExportSpecifier(node, isString3, isInTypeExport, isMaybeTypeOnly));
          }
          return nodes;
        }
        parseExportSpecifier(node, isString3, isInTypeExport, isMaybeTypeOnly) {
          if (this.eatContextual(93)) {
            node.exported = this.parseModuleExportName();
          } else if (isString3) {
            node.exported = this.cloneStringLiteral(node.local);
          } else if (!node.exported) {
            node.exported = this.cloneIdentifier(node.local);
          }
          return this.finishNode(node, "ExportSpecifier");
        }
        parseModuleExportName() {
          if (this.match(134)) {
            const result2 = this.parseStringLiteral(this.state.value);
            const surrogate = loneSurrogate.exec(result2.value);
            if (surrogate) {
              this.raise(Errors.ModuleExportNameHasLoneSurrogate, result2, {
                surrogateCharCode: surrogate[0].charCodeAt(0)
              });
            }
            return result2;
          }
          return this.parseIdentifier(true);
        }
        isJSONModuleImport(node) {
          if (node.assertions != null) {
            return node.assertions.some(({
              key,
              value
            }) => {
              return value.value === "json" && (key.type === "Identifier" ? key.name === "type" : key.value === "type");
            });
          }
          return false;
        }
        checkImportReflection(node) {
          const {
            specifiers
          } = node;
          const singleBindingType = specifiers.length === 1 ? specifiers[0].type : null;
          if (node.phase === "source") {
            if (singleBindingType !== "ImportDefaultSpecifier") {
              this.raise(Errors.SourcePhaseImportRequiresDefault, specifiers[0].loc.start);
            }
          } else if (node.phase === "defer") {
            if (singleBindingType !== "ImportNamespaceSpecifier") {
              this.raise(Errors.DeferImportRequiresNamespace, specifiers[0].loc.start);
            }
          } else if (node.module) {
            var _node$assertions;
            if (singleBindingType !== "ImportDefaultSpecifier") {
              this.raise(Errors.ImportReflectionNotBinding, specifiers[0].loc.start);
            }
            if (((_node$assertions = node.assertions) == null ? void 0 : _node$assertions.length) > 0) {
              this.raise(Errors.ImportReflectionHasAssertion, specifiers[0].loc.start);
            }
          }
        }
        checkJSONModuleImport(node) {
          if (this.isJSONModuleImport(node) && node.type !== "ExportAllDeclaration") {
            const {
              specifiers
            } = node;
            if (specifiers != null) {
              const nonDefaultNamedSpecifier = specifiers.find((specifier) => {
                let imported;
                if (specifier.type === "ExportSpecifier") {
                  imported = specifier.local;
                } else if (specifier.type === "ImportSpecifier") {
                  imported = specifier.imported;
                }
                if (imported !== void 0) {
                  return imported.type === "Identifier" ? imported.name !== "default" : imported.value !== "default";
                }
              });
              if (nonDefaultNamedSpecifier !== void 0) {
                this.raise(Errors.ImportJSONBindingNotDefault, nonDefaultNamedSpecifier.loc.start);
              }
            }
          }
        }
        isPotentialImportPhase(isExport) {
          if (isExport)
            return false;
          return this.isContextual(105) || this.isContextual(97) || this.isContextual(127);
        }
        applyImportPhase(node, isExport, phase, loc) {
          if (isExport) {
            return;
          }
          if (phase === "module") {
            this.expectPlugin("importReflection", loc);
            node.module = true;
          } else if (this.hasPlugin("importReflection")) {
            node.module = false;
          }
          if (phase === "source") {
            this.expectPlugin("sourcePhaseImports", loc);
            node.phase = "source";
          } else if (phase === "defer") {
            this.expectPlugin("deferredImportEvaluation", loc);
            node.phase = "defer";
          } else if (this.hasPlugin("sourcePhaseImports")) {
            node.phase = null;
          }
        }
        parseMaybeImportPhase(node, isExport) {
          if (!this.isPotentialImportPhase(isExport)) {
            this.applyImportPhase(node, isExport, null);
            return null;
          }
          const phaseIdentifier = this.startNode();
          const phaseIdentifierName = this.parseIdentifierName(true);
          const {
            type
          } = this.state;
          const isImportPhase = tokenIsKeywordOrIdentifier(type) ? type !== 98 || this.lookaheadCharCode() === 102 : type !== 12;
          if (isImportPhase) {
            this.applyImportPhase(node, isExport, phaseIdentifierName, phaseIdentifier.loc.start);
            return null;
          } else {
            this.applyImportPhase(node, isExport, null);
            return this.createIdentifier(phaseIdentifier, phaseIdentifierName);
          }
        }
        isPrecedingIdImportPhase(phase) {
          const {
            type
          } = this.state;
          return tokenIsIdentifier(type) ? type !== 98 || this.lookaheadCharCode() === 102 : type !== 12;
        }
        parseImport(node) {
          if (this.match(134)) {
            return this.parseImportSourceAndAttributes(node);
          }
          return this.parseImportSpecifiersAndAfter(node, this.parseMaybeImportPhase(node, false));
        }
        parseImportSpecifiersAndAfter(node, maybeDefaultIdentifier) {
          node.specifiers = [];
          const hasDefault = this.maybeParseDefaultImportSpecifier(node, maybeDefaultIdentifier);
          const parseNext = !hasDefault || this.eat(12);
          const hasStar = parseNext && this.maybeParseStarImportSpecifier(node);
          if (parseNext && !hasStar)
            this.parseNamedImportSpecifiers(node);
          this.expectContextual(98);
          return this.parseImportSourceAndAttributes(node);
        }
        parseImportSourceAndAttributes(node) {
          var _node$specifiers2;
          (_node$specifiers2 = node.specifiers) != null ? _node$specifiers2 : node.specifiers = [];
          node.source = this.parseImportSource();
          this.maybeParseImportAttributes(node);
          this.checkImportReflection(node);
          this.checkJSONModuleImport(node);
          this.semicolon();
          this.sawUnambiguousESM = true;
          return this.finishNode(node, "ImportDeclaration");
        }
        parseImportSource() {
          if (!this.match(134))
            this.unexpected();
          return this.parseExprAtom();
        }
        parseImportSpecifierLocal(node, specifier, type) {
          specifier.local = this.parseIdentifier();
          node.specifiers.push(this.finishImportSpecifier(specifier, type));
        }
        finishImportSpecifier(specifier, type, bindingType = 8201) {
          this.checkLVal(specifier.local, {
            type
          }, bindingType);
          return this.finishNode(specifier, type);
        }
        parseImportAttributes() {
          this.expect(5);
          const attrs = [];
          const attrNames = /* @__PURE__ */ new Set();
          do {
            if (this.match(8)) {
              break;
            }
            const node = this.startNode();
            const keyName = this.state.value;
            if (attrNames.has(keyName)) {
              this.raise(Errors.ModuleAttributesWithDuplicateKeys, this.state.startLoc, {
                key: keyName
              });
            }
            attrNames.add(keyName);
            if (this.match(134)) {
              node.key = this.parseStringLiteral(keyName);
            } else {
              node.key = this.parseIdentifier(true);
            }
            this.expect(14);
            if (!this.match(134)) {
              throw this.raise(Errors.ModuleAttributeInvalidValue, this.state.startLoc);
            }
            node.value = this.parseStringLiteral(this.state.value);
            attrs.push(this.finishNode(node, "ImportAttribute"));
          } while (this.eat(12));
          this.expect(8);
          return attrs;
        }
        parseModuleAttributes() {
          const attrs = [];
          const attributes = /* @__PURE__ */ new Set();
          do {
            const node = this.startNode();
            node.key = this.parseIdentifier(true);
            if (node.key.name !== "type") {
              this.raise(Errors.ModuleAttributeDifferentFromType, node.key);
            }
            if (attributes.has(node.key.name)) {
              this.raise(Errors.ModuleAttributesWithDuplicateKeys, node.key, {
                key: node.key.name
              });
            }
            attributes.add(node.key.name);
            this.expect(14);
            if (!this.match(134)) {
              throw this.raise(Errors.ModuleAttributeInvalidValue, this.state.startLoc);
            }
            node.value = this.parseStringLiteral(this.state.value);
            attrs.push(this.finishNode(node, "ImportAttribute"));
          } while (this.eat(12));
          return attrs;
        }
        maybeParseImportAttributes(node) {
          let attributes;
          {
            var useWith = false;
          }
          if (this.match(76)) {
            if (this.hasPrecedingLineBreak() && this.lookaheadCharCode() === 40) {
              return;
            }
            this.next();
            if (this.hasPlugin("moduleAttributes")) {
              attributes = this.parseModuleAttributes();
              this.addExtra(node, "deprecatedWithLegacySyntax", true);
            } else {
              attributes = this.parseImportAttributes();
            }
            {
              useWith = true;
            }
          } else if (this.isContextual(94) && !this.hasPrecedingLineBreak()) {
            if (!this.hasPlugin("deprecatedImportAssert") && !this.hasPlugin("importAssertions")) {
              this.raise(Errors.ImportAttributesUseAssert, this.state.startLoc);
            }
            if (!this.hasPlugin("importAssertions")) {
              this.addExtra(node, "deprecatedAssertSyntax", true);
            }
            this.next();
            attributes = this.parseImportAttributes();
          } else {
            attributes = [];
          }
          if (!useWith && this.hasPlugin("importAssertions")) {
            node.assertions = attributes;
          } else {
            node.attributes = attributes;
          }
        }
        maybeParseDefaultImportSpecifier(node, maybeDefaultIdentifier) {
          if (maybeDefaultIdentifier) {
            const specifier = this.startNodeAtNode(maybeDefaultIdentifier);
            specifier.local = maybeDefaultIdentifier;
            node.specifiers.push(this.finishImportSpecifier(specifier, "ImportDefaultSpecifier"));
            return true;
          } else if (tokenIsKeywordOrIdentifier(this.state.type)) {
            this.parseImportSpecifierLocal(node, this.startNode(), "ImportDefaultSpecifier");
            return true;
          }
          return false;
        }
        maybeParseStarImportSpecifier(node) {
          if (this.match(55)) {
            const specifier = this.startNode();
            this.next();
            this.expectContextual(93);
            this.parseImportSpecifierLocal(node, specifier, "ImportNamespaceSpecifier");
            return true;
          }
          return false;
        }
        parseNamedImportSpecifiers(node) {
          let first = true;
          this.expect(5);
          while (!this.eat(8)) {
            if (first) {
              first = false;
            } else {
              if (this.eat(14)) {
                throw this.raise(Errors.DestructureNamedImport, this.state.startLoc);
              }
              this.expect(12);
              if (this.eat(8))
                break;
            }
            const specifier = this.startNode();
            const importedIsString = this.match(134);
            const isMaybeTypeOnly = this.isContextual(130);
            specifier.imported = this.parseModuleExportName();
            const importSpecifier = this.parseImportSpecifier(specifier, importedIsString, node.importKind === "type" || node.importKind === "typeof", isMaybeTypeOnly, void 0);
            node.specifiers.push(importSpecifier);
          }
        }
        parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, bindingType) {
          if (this.eatContextual(93)) {
            specifier.local = this.parseIdentifier();
          } else {
            const {
              imported
            } = specifier;
            if (importedIsString) {
              throw this.raise(Errors.ImportBindingIsString, specifier, {
                importName: imported.value
              });
            }
            this.checkReservedWord(imported.name, specifier.loc.start, true, true);
            if (!specifier.local) {
              specifier.local = this.cloneIdentifier(imported);
            }
          }
          return this.finishImportSpecifier(specifier, "ImportSpecifier", bindingType);
        }
        isThisParam(param) {
          return param.type === "Identifier" && param.name === "this";
        }
      };
      var Parser = class extends StatementParser {
        constructor(options, input, pluginsMap) {
          options = getOptions(options);
          super(options, input);
          this.options = options;
          this.initializeScopes();
          this.plugins = pluginsMap;
          this.filename = options.sourceFilename;
          this.startIndex = options.startIndex;
          let optionFlags = 0;
          if (options.allowAwaitOutsideFunction) {
            optionFlags |= 1;
          }
          if (options.allowReturnOutsideFunction) {
            optionFlags |= 2;
          }
          if (options.allowImportExportEverywhere) {
            optionFlags |= 8;
          }
          if (options.allowSuperOutsideMethod) {
            optionFlags |= 16;
          }
          if (options.allowUndeclaredExports) {
            optionFlags |= 64;
          }
          if (options.allowNewTargetOutsideFunction) {
            optionFlags |= 4;
          }
          if (options.allowYieldOutsideFunction) {
            optionFlags |= 32;
          }
          if (options.ranges) {
            optionFlags |= 128;
          }
          if (options.tokens) {
            optionFlags |= 256;
          }
          if (options.createImportExpressions) {
            optionFlags |= 512;
          }
          if (options.createParenthesizedExpressions) {
            optionFlags |= 1024;
          }
          if (options.errorRecovery) {
            optionFlags |= 2048;
          }
          if (options.attachComment) {
            optionFlags |= 4096;
          }
          if (options.annexB) {
            optionFlags |= 8192;
          }
          this.optionFlags = optionFlags;
        }
        getScopeHandler() {
          return ScopeHandler;
        }
        parse() {
          this.enterInitialScopes();
          const file2 = this.startNode();
          const program3 = this.startNode();
          this.nextToken();
          file2.errors = null;
          this.parseTopLevel(file2, program3);
          file2.errors = this.state.errors;
          file2.comments.length = this.state.commentsLen;
          return file2;
        }
      };
      function parse4(input, options) {
        var _options;
        if (((_options = options) == null ? void 0 : _options.sourceType) === "unambiguous") {
          options = Object.assign({}, options);
          try {
            options.sourceType = "module";
            const parser3 = getParser(options, input);
            const ast = parser3.parse();
            if (parser3.sawUnambiguousESM) {
              return ast;
            }
            if (parser3.ambiguousScriptDifferentAst) {
              try {
                options.sourceType = "script";
                return getParser(options, input).parse();
              } catch (_unused) {
              }
            } else {
              ast.program.sourceType = "script";
            }
            return ast;
          } catch (moduleError) {
            try {
              options.sourceType = "script";
              return getParser(options, input).parse();
            } catch (_unused2) {
            }
            throw moduleError;
          }
        } else {
          return getParser(options, input).parse();
        }
      }
      function parseExpression3(input, options) {
        const parser3 = getParser(options, input);
        if (parser3.options.strictMode) {
          parser3.state.strict = true;
        }
        return parser3.getExpression();
      }
      function generateExportedTokenTypes(internalTokenTypes) {
        const tokenTypes2 = {};
        for (const typeName of Object.keys(internalTokenTypes)) {
          tokenTypes2[typeName] = getExportedToken(internalTokenTypes[typeName]);
        }
        return tokenTypes2;
      }
      var tokTypes = generateExportedTokenTypes(tt);
      function getParser(options, input) {
        let cls = Parser;
        const pluginsMap = /* @__PURE__ */ new Map();
        if (options != null && options.plugins) {
          for (const plugin of options.plugins) {
            let name, opts;
            if (typeof plugin === "string") {
              name = plugin;
            } else {
              [name, opts] = plugin;
            }
            if (!pluginsMap.has(name)) {
              pluginsMap.set(name, opts || {});
            }
          }
          validatePlugins(pluginsMap);
          cls = getParserClass(pluginsMap);
        }
        return new cls(options, input, pluginsMap);
      }
      var parserClassCache = /* @__PURE__ */ new Map();
      function getParserClass(pluginsMap) {
        const pluginList = [];
        for (const name of mixinPluginNames) {
          if (pluginsMap.has(name)) {
            pluginList.push(name);
          }
        }
        const key = pluginList.join("|");
        let cls = parserClassCache.get(key);
        if (!cls) {
          cls = Parser;
          for (const plugin of pluginList) {
            cls = mixinPlugins[plugin](cls);
          }
          parserClassCache.set(key, cls);
        }
        return cls;
      }
      exports8.parse = parse4;
      exports8.parseExpression = parseExpression3;
      exports8.tokTypes = tokTypes;
    }
  });

  // ../../node_modules/.pnpm/@jridgewell+sourcemap-codec@1.5.0/node_modules/@jridgewell/sourcemap-codec/dist/sourcemap-codec.umd.js
  var require_sourcemap_codec_umd = __commonJS({
    "../../node_modules/.pnpm/@jridgewell+sourcemap-codec@1.5.0/node_modules/@jridgewell/sourcemap-codec/dist/sourcemap-codec.umd.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      (function(global2, factory2) {
        typeof exports8 === "object" && typeof module2 !== "undefined" ? factory2(exports8) : typeof define === "function" && define.amd ? define(["exports"], factory2) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, factory2(global2.sourcemapCodec = {}));
      })(exports8, function(exports9) {
        "use strict";
        const comma = ",".charCodeAt(0);
        const semicolon = ";".charCodeAt(0);
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        const intToChar = new Uint8Array(64);
        const charToInt = new Uint8Array(128);
        for (let i = 0; i < chars.length; i++) {
          const c = chars.charCodeAt(i);
          intToChar[i] = c;
          charToInt[c] = i;
        }
        function decodeInteger(reader, relative2) {
          let value = 0;
          let shift = 0;
          let integer = 0;
          do {
            const c = reader.next();
            integer = charToInt[c];
            value |= (integer & 31) << shift;
            shift += 5;
          } while (integer & 32);
          const shouldNegate = value & 1;
          value >>>= 1;
          if (shouldNegate) {
            value = -2147483648 | -value;
          }
          return relative2 + value;
        }
        function encodeInteger(builder, num, relative2) {
          let delta = num - relative2;
          delta = delta < 0 ? -delta << 1 | 1 : delta << 1;
          do {
            let clamped = delta & 31;
            delta >>>= 5;
            if (delta > 0)
              clamped |= 32;
            builder.write(intToChar[clamped]);
          } while (delta > 0);
          return num;
        }
        function hasMoreVlq(reader, max2) {
          if (reader.pos >= max2)
            return false;
          return reader.peek() !== comma;
        }
        const bufLength = 1024 * 16;
        const td = typeof TextDecoder !== "undefined" ? /* @__PURE__ */ new TextDecoder() : typeof Buffer2 !== "undefined" ? {
          decode(buf) {
            const out = Buffer2.from(buf.buffer, buf.byteOffset, buf.byteLength);
            return out.toString();
          }
        } : {
          decode(buf) {
            let out = "";
            for (let i = 0; i < buf.length; i++) {
              out += String.fromCharCode(buf[i]);
            }
            return out;
          }
        };
        class StringWriter {
          constructor() {
            this.pos = 0;
            this.out = "";
            this.buffer = new Uint8Array(bufLength);
          }
          write(v) {
            const { buffer } = this;
            buffer[this.pos++] = v;
            if (this.pos === bufLength) {
              this.out += td.decode(buffer);
              this.pos = 0;
            }
          }
          flush() {
            const { buffer, out, pos } = this;
            return pos > 0 ? out + td.decode(buffer.subarray(0, pos)) : out;
          }
        }
        class StringReader {
          constructor(buffer) {
            this.pos = 0;
            this.buffer = buffer;
          }
          next() {
            return this.buffer.charCodeAt(this.pos++);
          }
          peek() {
            return this.buffer.charCodeAt(this.pos);
          }
          indexOf(char) {
            const { buffer, pos } = this;
            const idx = buffer.indexOf(char, pos);
            return idx === -1 ? buffer.length : idx;
          }
        }
        const EMPTY = [];
        function decodeOriginalScopes(input) {
          const { length } = input;
          const reader = new StringReader(input);
          const scopes = [];
          const stack = [];
          let line = 0;
          for (; reader.pos < length; reader.pos++) {
            line = decodeInteger(reader, line);
            const column = decodeInteger(reader, 0);
            if (!hasMoreVlq(reader, length)) {
              const last2 = stack.pop();
              last2[2] = line;
              last2[3] = column;
              continue;
            }
            const kind = decodeInteger(reader, 0);
            const fields = decodeInteger(reader, 0);
            const hasName = fields & 1;
            const scope = hasName ? [line, column, 0, 0, kind, decodeInteger(reader, 0)] : [line, column, 0, 0, kind];
            let vars = EMPTY;
            if (hasMoreVlq(reader, length)) {
              vars = [];
              do {
                const varsIndex = decodeInteger(reader, 0);
                vars.push(varsIndex);
              } while (hasMoreVlq(reader, length));
            }
            scope.vars = vars;
            scopes.push(scope);
            stack.push(scope);
          }
          return scopes;
        }
        function encodeOriginalScopes(scopes) {
          const writer = new StringWriter();
          for (let i = 0; i < scopes.length; ) {
            i = _encodeOriginalScopes(scopes, i, writer, [0]);
          }
          return writer.flush();
        }
        function _encodeOriginalScopes(scopes, index, writer, state) {
          const scope = scopes[index];
          const { 0: startLine, 1: startColumn, 2: endLine, 3: endColumn, 4: kind, vars } = scope;
          if (index > 0)
            writer.write(comma);
          state[0] = encodeInteger(writer, startLine, state[0]);
          encodeInteger(writer, startColumn, 0);
          encodeInteger(writer, kind, 0);
          const fields = scope.length === 6 ? 1 : 0;
          encodeInteger(writer, fields, 0);
          if (scope.length === 6)
            encodeInteger(writer, scope[5], 0);
          for (const v of vars) {
            encodeInteger(writer, v, 0);
          }
          for (index++; index < scopes.length; ) {
            const next = scopes[index];
            const { 0: l, 1: c } = next;
            if (l > endLine || l === endLine && c >= endColumn) {
              break;
            }
            index = _encodeOriginalScopes(scopes, index, writer, state);
          }
          writer.write(comma);
          state[0] = encodeInteger(writer, endLine, state[0]);
          encodeInteger(writer, endColumn, 0);
          return index;
        }
        function decodeGeneratedRanges(input) {
          const { length } = input;
          const reader = new StringReader(input);
          const ranges = [];
          const stack = [];
          let genLine = 0;
          let definitionSourcesIndex = 0;
          let definitionScopeIndex = 0;
          let callsiteSourcesIndex = 0;
          let callsiteLine = 0;
          let callsiteColumn = 0;
          let bindingLine = 0;
          let bindingColumn = 0;
          do {
            const semi = reader.indexOf(";");
            let genColumn = 0;
            for (; reader.pos < semi; reader.pos++) {
              genColumn = decodeInteger(reader, genColumn);
              if (!hasMoreVlq(reader, semi)) {
                const last2 = stack.pop();
                last2[2] = genLine;
                last2[3] = genColumn;
                continue;
              }
              const fields = decodeInteger(reader, 0);
              const hasDefinition = fields & 1;
              const hasCallsite = fields & 2;
              const hasScope = fields & 4;
              let callsite = null;
              let bindings = EMPTY;
              let range2;
              if (hasDefinition) {
                const defSourcesIndex = decodeInteger(reader, definitionSourcesIndex);
                definitionScopeIndex = decodeInteger(reader, definitionSourcesIndex === defSourcesIndex ? definitionScopeIndex : 0);
                definitionSourcesIndex = defSourcesIndex;
                range2 = [genLine, genColumn, 0, 0, defSourcesIndex, definitionScopeIndex];
              } else {
                range2 = [genLine, genColumn, 0, 0];
              }
              range2.isScope = !!hasScope;
              if (hasCallsite) {
                const prevCsi = callsiteSourcesIndex;
                const prevLine = callsiteLine;
                callsiteSourcesIndex = decodeInteger(reader, callsiteSourcesIndex);
                const sameSource = prevCsi === callsiteSourcesIndex;
                callsiteLine = decodeInteger(reader, sameSource ? callsiteLine : 0);
                callsiteColumn = decodeInteger(reader, sameSource && prevLine === callsiteLine ? callsiteColumn : 0);
                callsite = [callsiteSourcesIndex, callsiteLine, callsiteColumn];
              }
              range2.callsite = callsite;
              if (hasMoreVlq(reader, semi)) {
                bindings = [];
                do {
                  bindingLine = genLine;
                  bindingColumn = genColumn;
                  const expressionsCount = decodeInteger(reader, 0);
                  let expressionRanges;
                  if (expressionsCount < -1) {
                    expressionRanges = [[decodeInteger(reader, 0)]];
                    for (let i = -1; i > expressionsCount; i--) {
                      const prevBl = bindingLine;
                      bindingLine = decodeInteger(reader, bindingLine);
                      bindingColumn = decodeInteger(reader, bindingLine === prevBl ? bindingColumn : 0);
                      const expression = decodeInteger(reader, 0);
                      expressionRanges.push([expression, bindingLine, bindingColumn]);
                    }
                  } else {
                    expressionRanges = [[expressionsCount]];
                  }
                  bindings.push(expressionRanges);
                } while (hasMoreVlq(reader, semi));
              }
              range2.bindings = bindings;
              ranges.push(range2);
              stack.push(range2);
            }
            genLine++;
            reader.pos = semi + 1;
          } while (reader.pos < length);
          return ranges;
        }
        function encodeGeneratedRanges(ranges) {
          if (ranges.length === 0)
            return "";
          const writer = new StringWriter();
          for (let i = 0; i < ranges.length; ) {
            i = _encodeGeneratedRanges(ranges, i, writer, [0, 0, 0, 0, 0, 0, 0]);
          }
          return writer.flush();
        }
        function _encodeGeneratedRanges(ranges, index, writer, state) {
          const range2 = ranges[index];
          const { 0: startLine, 1: startColumn, 2: endLine, 3: endColumn, isScope, callsite, bindings } = range2;
          if (state[0] < startLine) {
            catchupLine(writer, state[0], startLine);
            state[0] = startLine;
            state[1] = 0;
          } else if (index > 0) {
            writer.write(comma);
          }
          state[1] = encodeInteger(writer, range2[1], state[1]);
          const fields = (range2.length === 6 ? 1 : 0) | (callsite ? 2 : 0) | (isScope ? 4 : 0);
          encodeInteger(writer, fields, 0);
          if (range2.length === 6) {
            const { 4: sourcesIndex, 5: scopesIndex } = range2;
            if (sourcesIndex !== state[2]) {
              state[3] = 0;
            }
            state[2] = encodeInteger(writer, sourcesIndex, state[2]);
            state[3] = encodeInteger(writer, scopesIndex, state[3]);
          }
          if (callsite) {
            const { 0: sourcesIndex, 1: callLine, 2: callColumn } = range2.callsite;
            if (sourcesIndex !== state[4]) {
              state[5] = 0;
              state[6] = 0;
            } else if (callLine !== state[5]) {
              state[6] = 0;
            }
            state[4] = encodeInteger(writer, sourcesIndex, state[4]);
            state[5] = encodeInteger(writer, callLine, state[5]);
            state[6] = encodeInteger(writer, callColumn, state[6]);
          }
          if (bindings) {
            for (const binding3 of bindings) {
              if (binding3.length > 1)
                encodeInteger(writer, -binding3.length, 0);
              const expression = binding3[0][0];
              encodeInteger(writer, expression, 0);
              let bindingStartLine = startLine;
              let bindingStartColumn = startColumn;
              for (let i = 1; i < binding3.length; i++) {
                const expRange = binding3[i];
                bindingStartLine = encodeInteger(writer, expRange[1], bindingStartLine);
                bindingStartColumn = encodeInteger(writer, expRange[2], bindingStartColumn);
                encodeInteger(writer, expRange[0], 0);
              }
            }
          }
          for (index++; index < ranges.length; ) {
            const next = ranges[index];
            const { 0: l, 1: c } = next;
            if (l > endLine || l === endLine && c >= endColumn) {
              break;
            }
            index = _encodeGeneratedRanges(ranges, index, writer, state);
          }
          if (state[0] < endLine) {
            catchupLine(writer, state[0], endLine);
            state[0] = endLine;
            state[1] = 0;
          } else {
            writer.write(comma);
          }
          state[1] = encodeInteger(writer, endColumn, state[1]);
          return index;
        }
        function catchupLine(writer, lastLine, line) {
          do {
            writer.write(semicolon);
          } while (++lastLine < line);
        }
        function decode(mappings) {
          const { length } = mappings;
          const reader = new StringReader(mappings);
          const decoded = [];
          let genColumn = 0;
          let sourcesIndex = 0;
          let sourceLine = 0;
          let sourceColumn = 0;
          let namesIndex = 0;
          do {
            const semi = reader.indexOf(";");
            const line = [];
            let sorted = true;
            let lastCol = 0;
            genColumn = 0;
            while (reader.pos < semi) {
              let seg;
              genColumn = decodeInteger(reader, genColumn);
              if (genColumn < lastCol)
                sorted = false;
              lastCol = genColumn;
              if (hasMoreVlq(reader, semi)) {
                sourcesIndex = decodeInteger(reader, sourcesIndex);
                sourceLine = decodeInteger(reader, sourceLine);
                sourceColumn = decodeInteger(reader, sourceColumn);
                if (hasMoreVlq(reader, semi)) {
                  namesIndex = decodeInteger(reader, namesIndex);
                  seg = [genColumn, sourcesIndex, sourceLine, sourceColumn, namesIndex];
                } else {
                  seg = [genColumn, sourcesIndex, sourceLine, sourceColumn];
                }
              } else {
                seg = [genColumn];
              }
              line.push(seg);
              reader.pos++;
            }
            if (!sorted)
              sort(line);
            decoded.push(line);
            reader.pos = semi + 1;
          } while (reader.pos <= length);
          return decoded;
        }
        function sort(line) {
          line.sort(sortComparator);
        }
        function sortComparator(a, b) {
          return a[0] - b[0];
        }
        function encode(decoded) {
          const writer = new StringWriter();
          let sourcesIndex = 0;
          let sourceLine = 0;
          let sourceColumn = 0;
          let namesIndex = 0;
          for (let i = 0; i < decoded.length; i++) {
            const line = decoded[i];
            if (i > 0)
              writer.write(semicolon);
            if (line.length === 0)
              continue;
            let genColumn = 0;
            for (let j = 0; j < line.length; j++) {
              const segment = line[j];
              if (j > 0)
                writer.write(comma);
              genColumn = encodeInteger(writer, segment[0], genColumn);
              if (segment.length === 1)
                continue;
              sourcesIndex = encodeInteger(writer, segment[1], sourcesIndex);
              sourceLine = encodeInteger(writer, segment[2], sourceLine);
              sourceColumn = encodeInteger(writer, segment[3], sourceColumn);
              if (segment.length === 4)
                continue;
              namesIndex = encodeInteger(writer, segment[4], namesIndex);
            }
          }
          return writer.flush();
        }
        exports9.decode = decode;
        exports9.decodeGeneratedRanges = decodeGeneratedRanges;
        exports9.decodeOriginalScopes = decodeOriginalScopes;
        exports9.encode = encode;
        exports9.encodeGeneratedRanges = encodeGeneratedRanges;
        exports9.encodeOriginalScopes = encodeOriginalScopes;
        Object.defineProperty(exports9, "__esModule", { value: true });
      });
    }
  });

  // ../../node_modules/.pnpm/@jridgewell+resolve-uri@3.1.2/node_modules/@jridgewell/resolve-uri/dist/resolve-uri.umd.js
  var require_resolve_uri_umd = __commonJS({
    "../../node_modules/.pnpm/@jridgewell+resolve-uri@3.1.2/node_modules/@jridgewell/resolve-uri/dist/resolve-uri.umd.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      (function(global2, factory2) {
        typeof exports8 === "object" && typeof module2 !== "undefined" ? module2.exports = factory2() : typeof define === "function" && define.amd ? define(factory2) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, global2.resolveURI = factory2());
      })(exports8, function() {
        "use strict";
        const schemeRegex = /^[\w+.-]+:\/\//;
        const urlRegex = /^([\w+.-]+:)\/\/([^@/#?]*@)?([^:/#?]*)(:\d+)?(\/[^#?]*)?(\?[^#]*)?(#.*)?/;
        const fileRegex = /^file:(?:\/\/((?![a-z]:)[^/#?]*)?)?(\/?[^#?]*)(\?[^#]*)?(#.*)?/i;
        function isAbsoluteUrl(input) {
          return schemeRegex.test(input);
        }
        function isSchemeRelativeUrl(input) {
          return input.startsWith("//");
        }
        function isAbsolutePath(input) {
          return input.startsWith("/");
        }
        function isFileUrl(input) {
          return input.startsWith("file:");
        }
        function isRelative(input) {
          return /^[.?#]/.test(input);
        }
        function parseAbsoluteUrl(input) {
          const match = urlRegex.exec(input);
          return makeUrl(match[1], match[2] || "", match[3], match[4] || "", match[5] || "/", match[6] || "", match[7] || "");
        }
        function parseFileUrl(input) {
          const match = fileRegex.exec(input);
          const path = match[2];
          return makeUrl("file:", "", match[1] || "", "", isAbsolutePath(path) ? path : "/" + path, match[3] || "", match[4] || "");
        }
        function makeUrl(scheme, user, host, port, path, query, hash) {
          return {
            scheme,
            user,
            host,
            port,
            path,
            query,
            hash,
            type: 7
          };
        }
        function parseUrl(input) {
          if (isSchemeRelativeUrl(input)) {
            const url2 = parseAbsoluteUrl("http:" + input);
            url2.scheme = "";
            url2.type = 6;
            return url2;
          }
          if (isAbsolutePath(input)) {
            const url2 = parseAbsoluteUrl("http://foo.com" + input);
            url2.scheme = "";
            url2.host = "";
            url2.type = 5;
            return url2;
          }
          if (isFileUrl(input))
            return parseFileUrl(input);
          if (isAbsoluteUrl(input))
            return parseAbsoluteUrl(input);
          const url = parseAbsoluteUrl("http://foo.com/" + input);
          url.scheme = "";
          url.host = "";
          url.type = input ? input.startsWith("?") ? 3 : input.startsWith("#") ? 2 : 4 : 1;
          return url;
        }
        function stripPathFilename(path) {
          if (path.endsWith("/.."))
            return path;
          const index = path.lastIndexOf("/");
          return path.slice(0, index + 1);
        }
        function mergePaths(url, base) {
          normalizePath(base, base.type);
          if (url.path === "/") {
            url.path = base.path;
          } else {
            url.path = stripPathFilename(base.path) + url.path;
          }
        }
        function normalizePath(url, type) {
          const rel = type <= 4;
          const pieces = url.path.split("/");
          let pointer = 1;
          let positive = 0;
          let addTrailingSlash = false;
          for (let i = 1; i < pieces.length; i++) {
            const piece = pieces[i];
            if (!piece) {
              addTrailingSlash = true;
              continue;
            }
            addTrailingSlash = false;
            if (piece === ".")
              continue;
            if (piece === "..") {
              if (positive) {
                addTrailingSlash = true;
                positive--;
                pointer--;
              } else if (rel) {
                pieces[pointer++] = piece;
              }
              continue;
            }
            pieces[pointer++] = piece;
            positive++;
          }
          let path = "";
          for (let i = 1; i < pointer; i++) {
            path += "/" + pieces[i];
          }
          if (!path || addTrailingSlash && !path.endsWith("/..")) {
            path += "/";
          }
          url.path = path;
        }
        function resolve2(input, base) {
          if (!input && !base)
            return "";
          const url = parseUrl(input);
          let inputType = url.type;
          if (base && inputType !== 7) {
            const baseUrl = parseUrl(base);
            const baseType = baseUrl.type;
            switch (inputType) {
              case 1:
                url.hash = baseUrl.hash;
              case 2:
                url.query = baseUrl.query;
              case 3:
              case 4:
                mergePaths(url, baseUrl);
              case 5:
                url.user = baseUrl.user;
                url.host = baseUrl.host;
                url.port = baseUrl.port;
              case 6:
                url.scheme = baseUrl.scheme;
            }
            if (baseType > inputType)
              inputType = baseType;
          }
          normalizePath(url, inputType);
          const queryHash = url.query + url.hash;
          switch (inputType) {
            case 2:
            case 3:
              return queryHash;
            case 4: {
              const path = url.path.slice(1);
              if (!path)
                return queryHash || ".";
              if (isRelative(base || input) && !isRelative(path)) {
                return "./" + path + queryHash;
              }
              return path + queryHash;
            }
            case 5:
              return url.path + queryHash;
            default:
              return url.scheme + "//" + url.user + url.host + url.port + url.path + queryHash;
          }
        }
        return resolve2;
      });
    }
  });

  // ../../node_modules/.pnpm/@jridgewell+trace-mapping@0.3.29/node_modules/@jridgewell/trace-mapping/dist/trace-mapping.umd.js
  var require_trace_mapping_umd = __commonJS({
    "../../node_modules/.pnpm/@jridgewell+trace-mapping@0.3.29/node_modules/@jridgewell/trace-mapping/dist/trace-mapping.umd.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      (function(global2, factory2, m) {
        typeof exports8 === "object" && typeof module2 !== "undefined" ? factory2(module2, require_resolve_uri_umd(), require_sourcemap_codec_umd()) : typeof define === "function" && define.amd ? define(["module", "@jridgewell/resolve-uri", "@jridgewell/sourcemap-codec"], factory2) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, factory2(m = { exports: {} }, global2.resolveURI, global2.sourcemapCodec), global2.traceMapping = "default" in m.exports ? m.exports.default : m.exports);
      })(exports8, function(module3, require_resolveURI, require_sourcemapCodec) {
        "use strict";
        var __create2 = Object.create;
        var __defProp2 = Object.defineProperty;
        var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
        var __getOwnPropNames2 = Object.getOwnPropertyNames;
        var __getProtoOf2 = Object.getPrototypeOf;
        var __hasOwnProp2 = Object.prototype.hasOwnProperty;
        var __commonJS2 = (cb, mod) => function __require2() {
          return mod || (0, cb[__getOwnPropNames2(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
        };
        var __export2 = (target, all) => {
          for (var name in all)
            __defProp2(target, name, { get: all[name], enumerable: true });
        };
        var __copyProps2 = (to, from, except, desc) => {
          if (from && typeof from === "object" || typeof from === "function") {
            for (let key of __getOwnPropNames2(from))
              if (!__hasOwnProp2.call(to, key) && key !== except)
                __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
          }
          return to;
        };
        var __toESM2 = (mod, isNodeMode, target) => (target = mod != null ? __create2(__getProtoOf2(mod)) : {}, __copyProps2(
          isNodeMode || !mod || !mod.__esModule ? __defProp2(target, "default", { value: mod, enumerable: true }) : target,
          mod
        ));
        var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
        var require_sourcemap_codec = __commonJS2({
          "umd:@jridgewell/sourcemap-codec"(exports9, module22) {
            module22.exports = require_sourcemapCodec;
          }
        });
        var require_resolve_uri = __commonJS2({
          "umd:@jridgewell/resolve-uri"(exports9, module22) {
            module22.exports = require_resolveURI;
          }
        });
        var trace_mapping_exports = {};
        __export2(trace_mapping_exports, {
          AnyMap: () => FlattenMap,
          FlattenMap: () => FlattenMap,
          GREATEST_LOWER_BOUND: () => GREATEST_LOWER_BOUND,
          LEAST_UPPER_BOUND: () => LEAST_UPPER_BOUND,
          TraceMap: () => TraceMap,
          allGeneratedPositionsFor: () => allGeneratedPositionsFor,
          decodedMap: () => decodedMap,
          decodedMappings: () => decodedMappings,
          eachMapping: () => eachMapping,
          encodedMap: () => encodedMap,
          encodedMappings: () => encodedMappings,
          generatedPositionFor: () => generatedPositionFor,
          isIgnored: () => isIgnored,
          originalPositionFor: () => originalPositionFor,
          presortedDecodedMap: () => presortedDecodedMap,
          sourceContentFor: () => sourceContentFor,
          traceSegment: () => traceSegment
        });
        module3.exports = __toCommonJS2(trace_mapping_exports);
        var import_sourcemap_codec = __toESM2(require_sourcemap_codec());
        var import_resolve_uri = __toESM2(require_resolve_uri());
        function stripFilename(path) {
          if (!path)
            return "";
          const index = path.lastIndexOf("/");
          return path.slice(0, index + 1);
        }
        function resolver(mapUrl, sourceRoot) {
          const from = stripFilename(mapUrl);
          const prefix = sourceRoot ? sourceRoot + "/" : "";
          return (source) => (0, import_resolve_uri.default)(prefix + (source || ""), from);
        }
        var COLUMN = 0;
        var SOURCES_INDEX = 1;
        var SOURCE_LINE = 2;
        var SOURCE_COLUMN = 3;
        var NAMES_INDEX = 4;
        var REV_GENERATED_LINE = 1;
        var REV_GENERATED_COLUMN = 2;
        function maybeSort(mappings, owned) {
          const unsortedIndex = nextUnsortedSegmentLine(mappings, 0);
          if (unsortedIndex === mappings.length)
            return mappings;
          if (!owned)
            mappings = mappings.slice();
          for (let i = unsortedIndex; i < mappings.length; i = nextUnsortedSegmentLine(mappings, i + 1)) {
            mappings[i] = sortSegments(mappings[i], owned);
          }
          return mappings;
        }
        function nextUnsortedSegmentLine(mappings, start) {
          for (let i = start; i < mappings.length; i++) {
            if (!isSorted(mappings[i]))
              return i;
          }
          return mappings.length;
        }
        function isSorted(line) {
          for (let j = 1; j < line.length; j++) {
            if (line[j][COLUMN] < line[j - 1][COLUMN]) {
              return false;
            }
          }
          return true;
        }
        function sortSegments(line, owned) {
          if (!owned)
            line = line.slice();
          return line.sort(sortComparator);
        }
        function sortComparator(a, b) {
          return a[COLUMN] - b[COLUMN];
        }
        var found = false;
        function binarySearch(haystack, needle, low, high) {
          while (low <= high) {
            const mid = low + (high - low >> 1);
            const cmp = haystack[mid][COLUMN] - needle;
            if (cmp === 0) {
              found = true;
              return mid;
            }
            if (cmp < 0) {
              low = mid + 1;
            } else {
              high = mid - 1;
            }
          }
          found = false;
          return low - 1;
        }
        function upperBound(haystack, needle, index) {
          for (let i = index + 1; i < haystack.length; index = i++) {
            if (haystack[i][COLUMN] !== needle)
              break;
          }
          return index;
        }
        function lowerBound(haystack, needle, index) {
          for (let i = index - 1; i >= 0; index = i--) {
            if (haystack[i][COLUMN] !== needle)
              break;
          }
          return index;
        }
        function memoizedState() {
          return {
            lastKey: -1,
            lastNeedle: -1,
            lastIndex: -1
          };
        }
        function memoizedBinarySearch(haystack, needle, state, key) {
          const { lastKey, lastNeedle, lastIndex } = state;
          let low = 0;
          let high = haystack.length - 1;
          if (key === lastKey) {
            if (needle === lastNeedle) {
              found = lastIndex !== -1 && haystack[lastIndex][COLUMN] === needle;
              return lastIndex;
            }
            if (needle >= lastNeedle) {
              low = lastIndex === -1 ? 0 : lastIndex;
            } else {
              high = lastIndex;
            }
          }
          state.lastKey = key;
          state.lastNeedle = needle;
          return state.lastIndex = binarySearch(haystack, needle, low, high);
        }
        function buildBySources(decoded, memos) {
          const sources = memos.map(buildNullArray);
          for (let i = 0; i < decoded.length; i++) {
            const line = decoded[i];
            for (let j = 0; j < line.length; j++) {
              const seg = line[j];
              if (seg.length === 1)
                continue;
              const sourceIndex2 = seg[SOURCES_INDEX];
              const sourceLine = seg[SOURCE_LINE];
              const sourceColumn = seg[SOURCE_COLUMN];
              const originalSource = sources[sourceIndex2];
              const originalLine = originalSource[sourceLine] || (originalSource[sourceLine] = []);
              const memo = memos[sourceIndex2];
              let index = upperBound(
                originalLine,
                sourceColumn,
                memoizedBinarySearch(originalLine, sourceColumn, memo, sourceLine)
              );
              memo.lastIndex = ++index;
              insert(originalLine, index, [sourceColumn, i, seg[COLUMN]]);
            }
          }
          return sources;
        }
        function insert(array, index, value) {
          for (let i = array.length; i > index; i--) {
            array[i] = array[i - 1];
          }
          array[index] = value;
        }
        function buildNullArray() {
          return { __proto__: null };
        }
        function parse4(map2) {
          return typeof map2 === "string" ? JSON.parse(map2) : map2;
        }
        var FlattenMap = function(map2, mapUrl) {
          const parsed = parse4(map2);
          if (!("sections" in parsed)) {
            return new TraceMap(parsed, mapUrl);
          }
          const mappings = [];
          const sources = [];
          const sourcesContent = [];
          const names = [];
          const ignoreList = [];
          recurse(
            parsed,
            mapUrl,
            mappings,
            sources,
            sourcesContent,
            names,
            ignoreList,
            0,
            0,
            Infinity,
            Infinity
          );
          const joined = {
            version: 3,
            file: parsed.file,
            names,
            sources,
            sourcesContent,
            mappings,
            ignoreList
          };
          return presortedDecodedMap(joined);
        };
        function recurse(input, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset, columnOffset, stopLine, stopColumn) {
          const { sections } = input;
          for (let i = 0; i < sections.length; i++) {
            const { map: map2, offset } = sections[i];
            let sl = stopLine;
            let sc = stopColumn;
            if (i + 1 < sections.length) {
              const nextOffset = sections[i + 1].offset;
              sl = Math.min(stopLine, lineOffset + nextOffset.line);
              if (sl === stopLine) {
                sc = Math.min(stopColumn, columnOffset + nextOffset.column);
              } else if (sl < stopLine) {
                sc = columnOffset + nextOffset.column;
              }
            }
            addSection(
              map2,
              mapUrl,
              mappings,
              sources,
              sourcesContent,
              names,
              ignoreList,
              lineOffset + offset.line,
              columnOffset + offset.column,
              sl,
              sc
            );
          }
        }
        function addSection(input, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset, columnOffset, stopLine, stopColumn) {
          const parsed = parse4(input);
          if ("sections" in parsed)
            return recurse(...arguments);
          const map2 = new TraceMap(parsed, mapUrl);
          const sourcesOffset = sources.length;
          const namesOffset = names.length;
          const decoded = decodedMappings(map2);
          const { resolvedSources, sourcesContent: contents, ignoreList: ignores } = map2;
          append(sources, resolvedSources);
          append(names, map2.names);
          if (contents)
            append(sourcesContent, contents);
          else
            for (let i = 0; i < resolvedSources.length; i++)
              sourcesContent.push(null);
          if (ignores)
            for (let i = 0; i < ignores.length; i++)
              ignoreList.push(ignores[i] + sourcesOffset);
          for (let i = 0; i < decoded.length; i++) {
            const lineI = lineOffset + i;
            if (lineI > stopLine)
              return;
            const out = getLine(mappings, lineI);
            const cOffset = i === 0 ? columnOffset : 0;
            const line = decoded[i];
            for (let j = 0; j < line.length; j++) {
              const seg = line[j];
              const column = cOffset + seg[COLUMN];
              if (lineI === stopLine && column >= stopColumn)
                return;
              if (seg.length === 1) {
                out.push([column]);
                continue;
              }
              const sourcesIndex = sourcesOffset + seg[SOURCES_INDEX];
              const sourceLine = seg[SOURCE_LINE];
              const sourceColumn = seg[SOURCE_COLUMN];
              out.push(
                seg.length === 4 ? [column, sourcesIndex, sourceLine, sourceColumn] : [column, sourcesIndex, sourceLine, sourceColumn, namesOffset + seg[NAMES_INDEX]]
              );
            }
          }
        }
        function append(arr, other) {
          for (let i = 0; i < other.length; i++)
            arr.push(other[i]);
        }
        function getLine(arr, index) {
          for (let i = arr.length; i <= index; i++)
            arr[i] = [];
          return arr[index];
        }
        var LINE_GTR_ZERO = "`line` must be greater than 0 (lines start at line 1)";
        var COL_GTR_EQ_ZERO = "`column` must be greater than or equal to 0 (columns start at column 0)";
        var LEAST_UPPER_BOUND = -1;
        var GREATEST_LOWER_BOUND = 1;
        var TraceMap = class {
          constructor(map2, mapUrl) {
            const isString3 = typeof map2 === "string";
            if (!isString3 && map2._decodedMemo)
              return map2;
            const parsed = parse4(map2);
            const { version: version3, file: file2, names, sourceRoot, sources, sourcesContent } = parsed;
            this.version = version3;
            this.file = file2;
            this.names = names || [];
            this.sourceRoot = sourceRoot;
            this.sources = sources;
            this.sourcesContent = sourcesContent;
            this.ignoreList = parsed.ignoreList || parsed.x_google_ignoreList || void 0;
            const resolve2 = resolver(mapUrl, sourceRoot);
            this.resolvedSources = sources.map(resolve2);
            const { mappings } = parsed;
            if (typeof mappings === "string") {
              this._encoded = mappings;
              this._decoded = void 0;
            } else if (Array.isArray(mappings)) {
              this._encoded = void 0;
              this._decoded = maybeSort(mappings, isString3);
            } else if (parsed.sections) {
              throw new Error(`TraceMap passed sectioned source map, please use FlattenMap export instead`);
            } else {
              throw new Error(`invalid source map: ${JSON.stringify(parsed)}`);
            }
            this._decodedMemo = memoizedState();
            this._bySources = void 0;
            this._bySourceMemos = void 0;
          }
        };
        function cast(map2) {
          return map2;
        }
        function encodedMappings(map2) {
          var _a, _b;
          return (_b = (_a = cast(map2))._encoded) != null ? _b : _a._encoded = (0, import_sourcemap_codec.encode)(cast(map2)._decoded);
        }
        function decodedMappings(map2) {
          var _a;
          return (_a = cast(map2))._decoded || (_a._decoded = (0, import_sourcemap_codec.decode)(cast(map2)._encoded));
        }
        function traceSegment(map2, line, column) {
          const decoded = decodedMappings(map2);
          if (line >= decoded.length)
            return null;
          const segments = decoded[line];
          const index = traceSegmentInternal(
            segments,
            cast(map2)._decodedMemo,
            line,
            column,
            GREATEST_LOWER_BOUND
          );
          return index === -1 ? null : segments[index];
        }
        function originalPositionFor(map2, needle) {
          let { line, column, bias } = needle;
          line--;
          if (line < 0)
            throw new Error(LINE_GTR_ZERO);
          if (column < 0)
            throw new Error(COL_GTR_EQ_ZERO);
          const decoded = decodedMappings(map2);
          if (line >= decoded.length)
            return OMapping(null, null, null, null);
          const segments = decoded[line];
          const index = traceSegmentInternal(
            segments,
            cast(map2)._decodedMemo,
            line,
            column,
            bias || GREATEST_LOWER_BOUND
          );
          if (index === -1)
            return OMapping(null, null, null, null);
          const segment = segments[index];
          if (segment.length === 1)
            return OMapping(null, null, null, null);
          const { names, resolvedSources } = map2;
          return OMapping(
            resolvedSources[segment[SOURCES_INDEX]],
            segment[SOURCE_LINE] + 1,
            segment[SOURCE_COLUMN],
            segment.length === 5 ? names[segment[NAMES_INDEX]] : null
          );
        }
        function generatedPositionFor(map2, needle) {
          const { source, line, column, bias } = needle;
          return generatedPosition(map2, source, line, column, bias || GREATEST_LOWER_BOUND, false);
        }
        function allGeneratedPositionsFor(map2, needle) {
          const { source, line, column, bias } = needle;
          return generatedPosition(map2, source, line, column, bias || LEAST_UPPER_BOUND, true);
        }
        function eachMapping(map2, cb) {
          const decoded = decodedMappings(map2);
          const { names, resolvedSources } = map2;
          for (let i = 0; i < decoded.length; i++) {
            const line = decoded[i];
            for (let j = 0; j < line.length; j++) {
              const seg = line[j];
              const generatedLine = i + 1;
              const generatedColumn = seg[0];
              let source = null;
              let originalLine = null;
              let originalColumn = null;
              let name = null;
              if (seg.length !== 1) {
                source = resolvedSources[seg[1]];
                originalLine = seg[2] + 1;
                originalColumn = seg[3];
              }
              if (seg.length === 5)
                name = names[seg[4]];
              cb({
                generatedLine,
                generatedColumn,
                source,
                originalLine,
                originalColumn,
                name
              });
            }
          }
        }
        function sourceIndex(map2, source) {
          const { sources, resolvedSources } = map2;
          let index = sources.indexOf(source);
          if (index === -1)
            index = resolvedSources.indexOf(source);
          return index;
        }
        function sourceContentFor(map2, source) {
          const { sourcesContent } = map2;
          if (sourcesContent == null)
            return null;
          const index = sourceIndex(map2, source);
          return index === -1 ? null : sourcesContent[index];
        }
        function isIgnored(map2, source) {
          const { ignoreList } = map2;
          if (ignoreList == null)
            return false;
          const index = sourceIndex(map2, source);
          return index === -1 ? false : ignoreList.includes(index);
        }
        function presortedDecodedMap(map2, mapUrl) {
          const tracer = new TraceMap(clone2(map2, []), mapUrl);
          cast(tracer)._decoded = map2.mappings;
          return tracer;
        }
        function decodedMap(map2) {
          return clone2(map2, decodedMappings(map2));
        }
        function encodedMap(map2) {
          return clone2(map2, encodedMappings(map2));
        }
        function clone2(map2, mappings) {
          return {
            version: map2.version,
            file: map2.file,
            names: map2.names,
            sourceRoot: map2.sourceRoot,
            sources: map2.sources,
            sourcesContent: map2.sourcesContent,
            mappings,
            ignoreList: map2.ignoreList || map2.x_google_ignoreList
          };
        }
        function OMapping(source, line, column, name) {
          return { source, line, column, name };
        }
        function GMapping(line, column) {
          return { line, column };
        }
        function traceSegmentInternal(segments, memo, line, column, bias) {
          let index = memoizedBinarySearch(segments, column, memo, line);
          if (found) {
            index = (bias === LEAST_UPPER_BOUND ? upperBound : lowerBound)(segments, column, index);
          } else if (bias === LEAST_UPPER_BOUND)
            index++;
          if (index === -1 || index === segments.length)
            return -1;
          return index;
        }
        function sliceGeneratedPositions(segments, memo, line, column, bias) {
          let min2 = traceSegmentInternal(segments, memo, line, column, GREATEST_LOWER_BOUND);
          if (!found && bias === LEAST_UPPER_BOUND)
            min2++;
          if (min2 === -1 || min2 === segments.length)
            return [];
          const matchedColumn = found ? column : segments[min2][COLUMN];
          if (!found)
            min2 = lowerBound(segments, matchedColumn, min2);
          const max2 = upperBound(segments, matchedColumn, min2);
          const result2 = [];
          for (; min2 <= max2; min2++) {
            const segment = segments[min2];
            result2.push(GMapping(segment[REV_GENERATED_LINE] + 1, segment[REV_GENERATED_COLUMN]));
          }
          return result2;
        }
        function generatedPosition(map2, source, line, column, bias, all) {
          var _a;
          line--;
          if (line < 0)
            throw new Error(LINE_GTR_ZERO);
          if (column < 0)
            throw new Error(COL_GTR_EQ_ZERO);
          const { sources, resolvedSources } = map2;
          let sourceIndex2 = sources.indexOf(source);
          if (sourceIndex2 === -1)
            sourceIndex2 = resolvedSources.indexOf(source);
          if (sourceIndex2 === -1)
            return all ? [] : GMapping(null, null);
          const generated = (_a = cast(map2))._bySources || (_a._bySources = buildBySources(
            decodedMappings(map2),
            cast(map2)._bySourceMemos = sources.map(memoizedState)
          ));
          const segments = generated[sourceIndex2][line];
          if (segments == null)
            return all ? [] : GMapping(null, null);
          const memo = cast(map2)._bySourceMemos[sourceIndex2];
          if (all)
            return sliceGeneratedPositions(segments, memo, line, column, bias);
          const index = traceSegmentInternal(segments, memo, line, column, bias);
          if (index === -1)
            return GMapping(null, null);
          const segment = segments[index];
          return GMapping(segment[REV_GENERATED_LINE] + 1, segment[REV_GENERATED_COLUMN]);
        }
      });
    }
  });

  // ../../node_modules/.pnpm/@jridgewell+gen-mapping@0.3.12/node_modules/@jridgewell/gen-mapping/dist/gen-mapping.umd.js
  var require_gen_mapping_umd = __commonJS({
    "../../node_modules/.pnpm/@jridgewell+gen-mapping@0.3.12/node_modules/@jridgewell/gen-mapping/dist/gen-mapping.umd.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      (function(global2, factory2, m) {
        typeof exports8 === "object" && typeof module2 !== "undefined" ? factory2(module2, require_sourcemap_codec_umd(), require_trace_mapping_umd()) : typeof define === "function" && define.amd ? define(["module", "@jridgewell/sourcemap-codec", "@jridgewell/trace-mapping"], factory2) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, factory2(m = { exports: {} }, global2.sourcemapCodec, global2.traceMapping), global2.genMapping = "default" in m.exports ? m.exports.default : m.exports);
      })(exports8, function(module3, require_sourcemapCodec, require_traceMapping) {
        "use strict";
        var __create2 = Object.create;
        var __defProp2 = Object.defineProperty;
        var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
        var __getOwnPropNames2 = Object.getOwnPropertyNames;
        var __getProtoOf2 = Object.getPrototypeOf;
        var __hasOwnProp2 = Object.prototype.hasOwnProperty;
        var __commonJS2 = (cb, mod) => function __require2() {
          return mod || (0, cb[__getOwnPropNames2(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
        };
        var __export2 = (target, all) => {
          for (var name in all)
            __defProp2(target, name, { get: all[name], enumerable: true });
        };
        var __copyProps2 = (to, from, except, desc) => {
          if (from && typeof from === "object" || typeof from === "function") {
            for (let key of __getOwnPropNames2(from))
              if (!__hasOwnProp2.call(to, key) && key !== except)
                __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
          }
          return to;
        };
        var __toESM2 = (mod, isNodeMode, target) => (target = mod != null ? __create2(__getProtoOf2(mod)) : {}, __copyProps2(
          isNodeMode || !mod || !mod.__esModule ? __defProp2(target, "default", { value: mod, enumerable: true }) : target,
          mod
        ));
        var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
        var require_sourcemap_codec = __commonJS2({
          "umd:@jridgewell/sourcemap-codec"(exports9, module22) {
            module22.exports = require_sourcemapCodec;
          }
        });
        var require_trace_mapping = __commonJS2({
          "umd:@jridgewell/trace-mapping"(exports9, module22) {
            module22.exports = require_traceMapping;
          }
        });
        var gen_mapping_exports = {};
        __export2(gen_mapping_exports, {
          GenMapping: () => GenMapping,
          addMapping: () => addMapping,
          addSegment: () => addSegment,
          allMappings: () => allMappings,
          fromMap: () => fromMap,
          maybeAddMapping: () => maybeAddMapping,
          maybeAddSegment: () => maybeAddSegment,
          setIgnore: () => setIgnore,
          setSourceContent: () => setSourceContent,
          toDecodedMap: () => toDecodedMap,
          toEncodedMap: () => toEncodedMap
        });
        module3.exports = __toCommonJS2(gen_mapping_exports);
        var SetArray = class {
          constructor() {
            this._indexes = { __proto__: null };
            this.array = [];
          }
        };
        function cast(set2) {
          return set2;
        }
        function get2(setarr, key) {
          return cast(setarr)._indexes[key];
        }
        function put(setarr, key) {
          const index = get2(setarr, key);
          if (index !== void 0)
            return index;
          const { array, _indexes: indexes } = cast(setarr);
          const length = array.push(key);
          return indexes[key] = length - 1;
        }
        function remove2(setarr, key) {
          const index = get2(setarr, key);
          if (index === void 0)
            return;
          const { array, _indexes: indexes } = cast(setarr);
          for (let i = index + 1; i < array.length; i++) {
            const k = array[i];
            array[i - 1] = k;
            indexes[k]--;
          }
          indexes[key] = void 0;
          array.pop();
        }
        var import_sourcemap_codec = __toESM2(require_sourcemap_codec());
        var import_trace_mapping = __toESM2(require_trace_mapping());
        var COLUMN = 0;
        var SOURCES_INDEX = 1;
        var SOURCE_LINE = 2;
        var SOURCE_COLUMN = 3;
        var NAMES_INDEX = 4;
        var NO_NAME = -1;
        var GenMapping = class {
          constructor({ file: file2, sourceRoot } = {}) {
            this._names = new SetArray();
            this._sources = new SetArray();
            this._sourcesContent = [];
            this._mappings = [];
            this.file = file2;
            this.sourceRoot = sourceRoot;
            this._ignoreList = new SetArray();
          }
        };
        function cast2(map2) {
          return map2;
        }
        function addSegment(map2, genLine, genColumn, source, sourceLine, sourceColumn, name, content) {
          return addSegmentInternal(
            false,
            map2,
            genLine,
            genColumn,
            source,
            sourceLine,
            sourceColumn,
            name,
            content
          );
        }
        function addMapping(map2, mapping) {
          return addMappingInternal(false, map2, mapping);
        }
        var maybeAddSegment = (map2, genLine, genColumn, source, sourceLine, sourceColumn, name, content) => {
          return addSegmentInternal(
            true,
            map2,
            genLine,
            genColumn,
            source,
            sourceLine,
            sourceColumn,
            name,
            content
          );
        };
        var maybeAddMapping = (map2, mapping) => {
          return addMappingInternal(true, map2, mapping);
        };
        function setSourceContent(map2, source, content) {
          const {
            _sources: sources,
            _sourcesContent: sourcesContent
          } = cast2(map2);
          const index = put(sources, source);
          sourcesContent[index] = content;
        }
        function setIgnore(map2, source, ignore = true) {
          const {
            _sources: sources,
            _sourcesContent: sourcesContent,
            _ignoreList: ignoreList
          } = cast2(map2);
          const index = put(sources, source);
          if (index === sourcesContent.length)
            sourcesContent[index] = null;
          if (ignore)
            put(ignoreList, index);
          else
            remove2(ignoreList, index);
        }
        function toDecodedMap(map2) {
          const {
            _mappings: mappings,
            _sources: sources,
            _sourcesContent: sourcesContent,
            _names: names,
            _ignoreList: ignoreList
          } = cast2(map2);
          removeEmptyFinalLines(mappings);
          return {
            version: 3,
            file: map2.file || void 0,
            names: names.array,
            sourceRoot: map2.sourceRoot || void 0,
            sources: sources.array,
            sourcesContent,
            mappings,
            ignoreList: ignoreList.array
          };
        }
        function toEncodedMap(map2) {
          const decoded = toDecodedMap(map2);
          return Object.assign({}, decoded, {
            mappings: (0, import_sourcemap_codec.encode)(decoded.mappings)
          });
        }
        function fromMap(input) {
          const map2 = new import_trace_mapping.TraceMap(input);
          const gen = new GenMapping({ file: map2.file, sourceRoot: map2.sourceRoot });
          putAll(cast2(gen)._names, map2.names);
          putAll(cast2(gen)._sources, map2.sources);
          cast2(gen)._sourcesContent = map2.sourcesContent || map2.sources.map(() => null);
          cast2(gen)._mappings = (0, import_trace_mapping.decodedMappings)(map2);
          if (map2.ignoreList)
            putAll(cast2(gen)._ignoreList, map2.ignoreList);
          return gen;
        }
        function allMappings(map2) {
          const out = [];
          const { _mappings: mappings, _sources: sources, _names: names } = cast2(map2);
          for (let i = 0; i < mappings.length; i++) {
            const line = mappings[i];
            for (let j = 0; j < line.length; j++) {
              const seg = line[j];
              const generated = { line: i + 1, column: seg[COLUMN] };
              let source = void 0;
              let original = void 0;
              let name = void 0;
              if (seg.length !== 1) {
                source = sources.array[seg[SOURCES_INDEX]];
                original = { line: seg[SOURCE_LINE] + 1, column: seg[SOURCE_COLUMN] };
                if (seg.length === 5)
                  name = names.array[seg[NAMES_INDEX]];
              }
              out.push({ generated, source, original, name });
            }
          }
          return out;
        }
        function addSegmentInternal(skipable, map2, genLine, genColumn, source, sourceLine, sourceColumn, name, content) {
          const {
            _mappings: mappings,
            _sources: sources,
            _sourcesContent: sourcesContent,
            _names: names
          } = cast2(map2);
          const line = getIndex(mappings, genLine);
          const index = getColumnIndex(line, genColumn);
          if (!source) {
            if (skipable && skipSourceless(line, index))
              return;
            return insert(line, index, [genColumn]);
          }
          assert3(sourceLine);
          assert3(sourceColumn);
          const sourcesIndex = put(sources, source);
          const namesIndex = name ? put(names, name) : NO_NAME;
          if (sourcesIndex === sourcesContent.length)
            sourcesContent[sourcesIndex] = content != null ? content : null;
          if (skipable && skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex)) {
            return;
          }
          return insert(
            line,
            index,
            name ? [genColumn, sourcesIndex, sourceLine, sourceColumn, namesIndex] : [genColumn, sourcesIndex, sourceLine, sourceColumn]
          );
        }
        function assert3(_val) {
        }
        function getIndex(arr, index) {
          for (let i = arr.length; i <= index; i++) {
            arr[i] = [];
          }
          return arr[index];
        }
        function getColumnIndex(line, genColumn) {
          let index = line.length;
          for (let i = index - 1; i >= 0; index = i--) {
            const current = line[i];
            if (genColumn >= current[COLUMN])
              break;
          }
          return index;
        }
        function insert(array, index, value) {
          for (let i = array.length; i > index; i--) {
            array[i] = array[i - 1];
          }
          array[index] = value;
        }
        function removeEmptyFinalLines(mappings) {
          const { length } = mappings;
          let len = length;
          for (let i = len - 1; i >= 0; len = i, i--) {
            if (mappings[i].length > 0)
              break;
          }
          if (len < length)
            mappings.length = len;
        }
        function putAll(setarr, array) {
          for (let i = 0; i < array.length; i++)
            put(setarr, array[i]);
        }
        function skipSourceless(line, index) {
          if (index === 0)
            return true;
          const prev = line[index - 1];
          return prev.length === 1;
        }
        function skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex) {
          if (index === 0)
            return false;
          const prev = line[index - 1];
          if (prev.length === 1)
            return false;
          return sourcesIndex === prev[SOURCES_INDEX] && sourceLine === prev[SOURCE_LINE] && sourceColumn === prev[SOURCE_COLUMN] && namesIndex === (prev.length === 5 ? prev[NAMES_INDEX] : NO_NAME);
        }
        function addMappingInternal(skipable, map2, mapping) {
          const { generated, source, original, name, content } = mapping;
          if (!source) {
            return addSegmentInternal(
              skipable,
              map2,
              generated.line - 1,
              generated.column,
              null,
              null,
              null,
              null,
              null
            );
          }
          assert3(original);
          return addSegmentInternal(
            skipable,
            map2,
            generated.line - 1,
            generated.column,
            source,
            original.line - 1,
            original.column,
            name,
            content
          );
        }
      });
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/source-map.js
  var require_source_map2 = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/source-map.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      var _genMapping = require_gen_mapping_umd();
      var _traceMapping = require_trace_mapping_umd();
      var SourceMap = class {
        constructor(opts, code) {
          var _opts$sourceFileName;
          this._map = void 0;
          this._rawMappings = void 0;
          this._sourceFileName = void 0;
          this._lastGenLine = 0;
          this._lastSourceLine = 0;
          this._lastSourceColumn = 0;
          this._inputMap = void 0;
          const map2 = this._map = new _genMapping.GenMapping({
            sourceRoot: opts.sourceRoot
          });
          this._sourceFileName = (_opts$sourceFileName = opts.sourceFileName) == null ? void 0 : _opts$sourceFileName.replace(/\\/g, "/");
          this._rawMappings = void 0;
          if (opts.inputSourceMap) {
            this._inputMap = new _traceMapping.TraceMap(opts.inputSourceMap);
            const resolvedSources = this._inputMap.resolvedSources;
            if (resolvedSources.length) {
              for (let i = 0; i < resolvedSources.length; i++) {
                var _this$_inputMap$sourc;
                (0, _genMapping.setSourceContent)(map2, resolvedSources[i], (_this$_inputMap$sourc = this._inputMap.sourcesContent) == null ? void 0 : _this$_inputMap$sourc[i]);
              }
            }
          }
          if (typeof code === "string" && !opts.inputSourceMap) {
            (0, _genMapping.setSourceContent)(map2, this._sourceFileName, code);
          } else if (typeof code === "object") {
            for (const sourceFileName of Object.keys(code)) {
              (0, _genMapping.setSourceContent)(map2, sourceFileName.replace(/\\/g, "/"), code[sourceFileName]);
            }
          }
        }
        get() {
          return (0, _genMapping.toEncodedMap)(this._map);
        }
        getDecoded() {
          return (0, _genMapping.toDecodedMap)(this._map);
        }
        getRawMappings() {
          return this._rawMappings || (this._rawMappings = (0, _genMapping.allMappings)(this._map));
        }
        mark(generated, line, column, identifierName, identifierNamePos, filename) {
          var _originalMapping;
          this._rawMappings = void 0;
          let originalMapping;
          if (line != null) {
            if (this._inputMap) {
              originalMapping = (0, _traceMapping.originalPositionFor)(this._inputMap, {
                line,
                column
              });
              if (!originalMapping.name && identifierNamePos) {
                const originalIdentifierMapping = (0, _traceMapping.originalPositionFor)(this._inputMap, identifierNamePos);
                if (originalIdentifierMapping.name) {
                  identifierName = originalIdentifierMapping.name;
                }
              }
            } else {
              originalMapping = {
                source: (filename == null ? void 0 : filename.replace(/\\/g, "/")) || this._sourceFileName,
                line,
                column
              };
            }
          }
          (0, _genMapping.maybeAddMapping)(this._map, {
            name: identifierName,
            generated,
            source: (_originalMapping = originalMapping) == null ? void 0 : _originalMapping.source,
            original: originalMapping
          });
        }
      };
      exports8.default = SourceMap;
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/buffer.js
  var require_buffer = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/buffer.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      var Buffer5 = class {
        constructor(map2, indentChar) {
          this._map = null;
          this._buf = "";
          this._str = "";
          this._appendCount = 0;
          this._last = 0;
          this._queue = [];
          this._queueCursor = 0;
          this._canMarkIdName = true;
          this._indentChar = "";
          this._fastIndentations = [];
          this._position = {
            line: 1,
            column: 0
          };
          this._sourcePosition = {
            identifierName: void 0,
            identifierNamePos: void 0,
            line: void 0,
            column: void 0,
            filename: void 0
          };
          this._map = map2;
          this._indentChar = indentChar;
          for (let i = 0; i < 64; i++) {
            this._fastIndentations.push(indentChar.repeat(i));
          }
          this._allocQueue();
        }
        _allocQueue() {
          const queue3 = this._queue;
          for (let i = 0; i < 16; i++) {
            queue3.push({
              char: 0,
              repeat: 1,
              line: void 0,
              column: void 0,
              identifierName: void 0,
              identifierNamePos: void 0,
              filename: ""
            });
          }
        }
        _pushQueue(char, repeat2, line, column, filename) {
          const cursor = this._queueCursor;
          if (cursor === this._queue.length) {
            this._allocQueue();
          }
          const item = this._queue[cursor];
          item.char = char;
          item.repeat = repeat2;
          item.line = line;
          item.column = column;
          item.filename = filename;
          this._queueCursor++;
        }
        _popQueue() {
          if (this._queueCursor === 0) {
            throw new Error("Cannot pop from empty queue");
          }
          return this._queue[--this._queueCursor];
        }
        get() {
          this._flush();
          const map2 = this._map;
          const result2 = {
            code: (this._buf + this._str).trimRight(),
            decodedMap: map2 == null ? void 0 : map2.getDecoded(),
            get __mergedMap() {
              return this.map;
            },
            get map() {
              const resultMap = map2 ? map2.get() : null;
              result2.map = resultMap;
              return resultMap;
            },
            set map(value) {
              Object.defineProperty(result2, "map", {
                value,
                writable: true
              });
            },
            get rawMappings() {
              const mappings = map2 == null ? void 0 : map2.getRawMappings();
              result2.rawMappings = mappings;
              return mappings;
            },
            set rawMappings(value) {
              Object.defineProperty(result2, "rawMappings", {
                value,
                writable: true
              });
            }
          };
          return result2;
        }
        append(str, maybeNewline) {
          this._flush();
          this._append(str, this._sourcePosition, maybeNewline);
        }
        appendChar(char) {
          this._flush();
          this._appendChar(char, 1, this._sourcePosition);
        }
        queue(char) {
          if (char === 10) {
            while (this._queueCursor !== 0) {
              const char2 = this._queue[this._queueCursor - 1].char;
              if (char2 !== 32 && char2 !== 9) {
                break;
              }
              this._queueCursor--;
            }
          }
          const sourcePosition = this._sourcePosition;
          this._pushQueue(char, 1, sourcePosition.line, sourcePosition.column, sourcePosition.filename);
        }
        queueIndentation(repeat2) {
          if (repeat2 === 0)
            return;
          this._pushQueue(-1, repeat2, void 0, void 0, void 0);
        }
        _flush() {
          const queueCursor = this._queueCursor;
          const queue3 = this._queue;
          for (let i = 0; i < queueCursor; i++) {
            const item = queue3[i];
            this._appendChar(item.char, item.repeat, item);
          }
          this._queueCursor = 0;
        }
        _appendChar(char, repeat2, sourcePos) {
          this._last = char;
          if (char === -1) {
            const fastIndentation = this._fastIndentations[repeat2];
            if (fastIndentation !== void 0) {
              this._str += fastIndentation;
            } else {
              this._str += repeat2 > 1 ? this._indentChar.repeat(repeat2) : this._indentChar;
            }
          } else {
            this._str += repeat2 > 1 ? String.fromCharCode(char).repeat(repeat2) : String.fromCharCode(char);
          }
          if (char !== 10) {
            this._mark(sourcePos.line, sourcePos.column, sourcePos.identifierName, sourcePos.identifierNamePos, sourcePos.filename);
            this._position.column += repeat2;
          } else {
            this._position.line++;
            this._position.column = 0;
          }
          if (this._canMarkIdName) {
            sourcePos.identifierName = void 0;
            sourcePos.identifierNamePos = void 0;
          }
        }
        _append(str, sourcePos, maybeNewline) {
          const len = str.length;
          const position = this._position;
          this._last = str.charCodeAt(len - 1);
          if (++this._appendCount > 4096) {
            +this._str;
            this._buf += this._str;
            this._str = str;
            this._appendCount = 0;
          } else {
            this._str += str;
          }
          if (!maybeNewline && !this._map) {
            position.column += len;
            return;
          }
          const {
            column,
            identifierName,
            identifierNamePos,
            filename
          } = sourcePos;
          let line = sourcePos.line;
          if ((identifierName != null || identifierNamePos != null) && this._canMarkIdName) {
            sourcePos.identifierName = void 0;
            sourcePos.identifierNamePos = void 0;
          }
          let i = str.indexOf("\n");
          let last2 = 0;
          if (i !== 0) {
            this._mark(line, column, identifierName, identifierNamePos, filename);
          }
          while (i !== -1) {
            position.line++;
            position.column = 0;
            last2 = i + 1;
            if (last2 < len && line !== void 0) {
              this._mark(++line, 0, null, null, filename);
            }
            i = str.indexOf("\n", last2);
          }
          position.column += len - last2;
        }
        _mark(line, column, identifierName, identifierNamePos, filename) {
          var _this$_map;
          (_this$_map = this._map) == null || _this$_map.mark(this._position, line, column, identifierName, identifierNamePos, filename);
        }
        removeTrailingNewline() {
          const queueCursor = this._queueCursor;
          if (queueCursor !== 0 && this._queue[queueCursor - 1].char === 10) {
            this._queueCursor--;
          }
        }
        removeLastSemicolon() {
          const queueCursor = this._queueCursor;
          if (queueCursor !== 0 && this._queue[queueCursor - 1].char === 59) {
            this._queueCursor--;
          }
        }
        getLastChar() {
          const queueCursor = this._queueCursor;
          return queueCursor !== 0 ? this._queue[queueCursor - 1].char : this._last;
        }
        getNewlineCount() {
          const queueCursor = this._queueCursor;
          let count = 0;
          if (queueCursor === 0)
            return this._last === 10 ? 1 : 0;
          for (let i = queueCursor - 1; i >= 0; i--) {
            if (this._queue[i].char !== 10) {
              break;
            }
            count++;
          }
          return count === queueCursor && this._last === 10 ? count + 1 : count;
        }
        endsWithCharAndNewline() {
          const queue3 = this._queue;
          const queueCursor = this._queueCursor;
          if (queueCursor !== 0) {
            const lastCp = queue3[queueCursor - 1].char;
            if (lastCp !== 10)
              return;
            if (queueCursor > 1) {
              return queue3[queueCursor - 2].char;
            } else {
              return this._last;
            }
          }
        }
        hasContent() {
          return this._queueCursor !== 0 || !!this._last;
        }
        exactSource(loc, cb) {
          if (!this._map) {
            cb();
            return;
          }
          this.source("start", loc);
          const identifierName = loc.identifierName;
          const sourcePos = this._sourcePosition;
          if (identifierName) {
            this._canMarkIdName = false;
            sourcePos.identifierName = identifierName;
          }
          cb();
          if (identifierName) {
            this._canMarkIdName = true;
            sourcePos.identifierName = void 0;
            sourcePos.identifierNamePos = void 0;
          }
          this.source("end", loc);
        }
        source(prop, loc) {
          if (!this._map)
            return;
          this._normalizePosition(prop, loc, 0);
        }
        sourceWithOffset(prop, loc, columnOffset) {
          if (!this._map)
            return;
          this._normalizePosition(prop, loc, columnOffset);
        }
        _normalizePosition(prop, loc, columnOffset) {
          const pos = loc[prop];
          const target = this._sourcePosition;
          if (pos) {
            target.line = pos.line;
            target.column = Math.max(pos.column + columnOffset, 0);
            target.filename = loc.filename;
          }
        }
        getCurrentColumn() {
          const queue3 = this._queue;
          const queueCursor = this._queueCursor;
          let lastIndex = -1;
          let len = 0;
          for (let i = 0; i < queueCursor; i++) {
            const item = queue3[i];
            if (item.char === 10) {
              lastIndex = len;
            }
            len += item.repeat;
          }
          return lastIndex === -1 ? this._position.column + len : len - 1 - lastIndex;
        }
        getCurrentLine() {
          let count = 0;
          const queue3 = this._queue;
          for (let i = 0; i < this._queueCursor; i++) {
            if (queue3[i].char === 10) {
              count++;
            }
          }
          return this._position.line + count;
        }
      };
      exports8.default = Buffer5;
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/utils/shallowEqual.js
  var require_shallowEqual = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/utils/shallowEqual.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = shallowEqual;
      function shallowEqual(actual, expected) {
        const keys2 = Object.keys(expected);
        for (const key of keys2) {
          if (actual[key] !== expected[key]) {
            return false;
          }
        }
        return true;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/utils/deprecationWarning.js
  var require_deprecationWarning = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/utils/deprecationWarning.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = deprecationWarning;
      var warnings = /* @__PURE__ */ new Set();
      function deprecationWarning(oldName, newName, prefix = "", cacheKey = oldName) {
        if (warnings.has(cacheKey))
          return;
        warnings.add(cacheKey);
        const {
          internal,
          trace
        } = captureShortStackTrace(1, 2);
        if (internal) {
          return;
        }
        console.warn(`${prefix}\`${oldName}\` has been deprecated, please migrate to \`${newName}\`
${trace}`);
      }
      function captureShortStackTrace(skip, length) {
        const {
          stackTraceLimit,
          prepareStackTrace
        } = Error;
        let stackTrace;
        Error.stackTraceLimit = 1 + skip + length;
        Error.prepareStackTrace = function(err, stack) {
          stackTrace = stack;
        };
        new Error().stack;
        Error.stackTraceLimit = stackTraceLimit;
        Error.prepareStackTrace = prepareStackTrace;
        if (!stackTrace)
          return {
            internal: false,
            trace: ""
          };
        const shortStackTrace = stackTrace.slice(1 + skip, 1 + skip + length);
        return {
          internal: /[\\/]@babel[\\/]/.test(shortStackTrace[1].getFileName()),
          trace: shortStackTrace.map((frame) => `    at ${frame}`).join("\n")
        };
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/generated/index.js
  var require_generated = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/generated/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.isAccessor = isAccessor;
      exports8.isAnyTypeAnnotation = isAnyTypeAnnotation;
      exports8.isArgumentPlaceholder = isArgumentPlaceholder;
      exports8.isArrayExpression = isArrayExpression;
      exports8.isArrayPattern = isArrayPattern;
      exports8.isArrayTypeAnnotation = isArrayTypeAnnotation;
      exports8.isArrowFunctionExpression = isArrowFunctionExpression;
      exports8.isAssignmentExpression = isAssignmentExpression;
      exports8.isAssignmentPattern = isAssignmentPattern;
      exports8.isAwaitExpression = isAwaitExpression;
      exports8.isBigIntLiteral = isBigIntLiteral;
      exports8.isBinary = isBinary;
      exports8.isBinaryExpression = isBinaryExpression;
      exports8.isBindExpression = isBindExpression;
      exports8.isBlock = isBlock;
      exports8.isBlockParent = isBlockParent;
      exports8.isBlockStatement = isBlockStatement;
      exports8.isBooleanLiteral = isBooleanLiteral;
      exports8.isBooleanLiteralTypeAnnotation = isBooleanLiteralTypeAnnotation;
      exports8.isBooleanTypeAnnotation = isBooleanTypeAnnotation;
      exports8.isBreakStatement = isBreakStatement;
      exports8.isCallExpression = isCallExpression;
      exports8.isCatchClause = isCatchClause;
      exports8.isClass = isClass;
      exports8.isClassAccessorProperty = isClassAccessorProperty;
      exports8.isClassBody = isClassBody;
      exports8.isClassDeclaration = isClassDeclaration;
      exports8.isClassExpression = isClassExpression;
      exports8.isClassImplements = isClassImplements;
      exports8.isClassMethod = isClassMethod;
      exports8.isClassPrivateMethod = isClassPrivateMethod;
      exports8.isClassPrivateProperty = isClassPrivateProperty;
      exports8.isClassProperty = isClassProperty;
      exports8.isCompletionStatement = isCompletionStatement;
      exports8.isConditional = isConditional;
      exports8.isConditionalExpression = isConditionalExpression;
      exports8.isContinueStatement = isContinueStatement;
      exports8.isDebuggerStatement = isDebuggerStatement;
      exports8.isDecimalLiteral = isDecimalLiteral;
      exports8.isDeclaration = isDeclaration;
      exports8.isDeclareClass = isDeclareClass;
      exports8.isDeclareExportAllDeclaration = isDeclareExportAllDeclaration;
      exports8.isDeclareExportDeclaration = isDeclareExportDeclaration;
      exports8.isDeclareFunction = isDeclareFunction;
      exports8.isDeclareInterface = isDeclareInterface;
      exports8.isDeclareModule = isDeclareModule;
      exports8.isDeclareModuleExports = isDeclareModuleExports;
      exports8.isDeclareOpaqueType = isDeclareOpaqueType;
      exports8.isDeclareTypeAlias = isDeclareTypeAlias;
      exports8.isDeclareVariable = isDeclareVariable;
      exports8.isDeclaredPredicate = isDeclaredPredicate;
      exports8.isDecorator = isDecorator;
      exports8.isDirective = isDirective;
      exports8.isDirectiveLiteral = isDirectiveLiteral;
      exports8.isDoExpression = isDoExpression;
      exports8.isDoWhileStatement = isDoWhileStatement;
      exports8.isEmptyStatement = isEmptyStatement;
      exports8.isEmptyTypeAnnotation = isEmptyTypeAnnotation;
      exports8.isEnumBody = isEnumBody;
      exports8.isEnumBooleanBody = isEnumBooleanBody;
      exports8.isEnumBooleanMember = isEnumBooleanMember;
      exports8.isEnumDeclaration = isEnumDeclaration;
      exports8.isEnumDefaultedMember = isEnumDefaultedMember;
      exports8.isEnumMember = isEnumMember;
      exports8.isEnumNumberBody = isEnumNumberBody;
      exports8.isEnumNumberMember = isEnumNumberMember;
      exports8.isEnumStringBody = isEnumStringBody;
      exports8.isEnumStringMember = isEnumStringMember;
      exports8.isEnumSymbolBody = isEnumSymbolBody;
      exports8.isExistsTypeAnnotation = isExistsTypeAnnotation;
      exports8.isExportAllDeclaration = isExportAllDeclaration;
      exports8.isExportDeclaration = isExportDeclaration;
      exports8.isExportDefaultDeclaration = isExportDefaultDeclaration;
      exports8.isExportDefaultSpecifier = isExportDefaultSpecifier;
      exports8.isExportNamedDeclaration = isExportNamedDeclaration;
      exports8.isExportNamespaceSpecifier = isExportNamespaceSpecifier;
      exports8.isExportSpecifier = isExportSpecifier;
      exports8.isExpression = isExpression;
      exports8.isExpressionStatement = isExpressionStatement;
      exports8.isExpressionWrapper = isExpressionWrapper;
      exports8.isFile = isFile;
      exports8.isFlow = isFlow;
      exports8.isFlowBaseAnnotation = isFlowBaseAnnotation;
      exports8.isFlowDeclaration = isFlowDeclaration;
      exports8.isFlowPredicate = isFlowPredicate;
      exports8.isFlowType = isFlowType;
      exports8.isFor = isFor;
      exports8.isForInStatement = isForInStatement;
      exports8.isForOfStatement = isForOfStatement;
      exports8.isForStatement = isForStatement;
      exports8.isForXStatement = isForXStatement;
      exports8.isFunction = isFunction3;
      exports8.isFunctionDeclaration = isFunctionDeclaration;
      exports8.isFunctionExpression = isFunctionExpression;
      exports8.isFunctionParameter = isFunctionParameter;
      exports8.isFunctionParent = isFunctionParent;
      exports8.isFunctionTypeAnnotation = isFunctionTypeAnnotation;
      exports8.isFunctionTypeParam = isFunctionTypeParam;
      exports8.isGenericTypeAnnotation = isGenericTypeAnnotation;
      exports8.isIdentifier = isIdentifier2;
      exports8.isIfStatement = isIfStatement;
      exports8.isImmutable = isImmutable;
      exports8.isImport = isImport;
      exports8.isImportAttribute = isImportAttribute;
      exports8.isImportDeclaration = isImportDeclaration;
      exports8.isImportDefaultSpecifier = isImportDefaultSpecifier;
      exports8.isImportExpression = isImportExpression;
      exports8.isImportNamespaceSpecifier = isImportNamespaceSpecifier;
      exports8.isImportOrExportDeclaration = isImportOrExportDeclaration;
      exports8.isImportSpecifier = isImportSpecifier;
      exports8.isIndexedAccessType = isIndexedAccessType;
      exports8.isInferredPredicate = isInferredPredicate;
      exports8.isInterfaceDeclaration = isInterfaceDeclaration;
      exports8.isInterfaceExtends = isInterfaceExtends;
      exports8.isInterfaceTypeAnnotation = isInterfaceTypeAnnotation;
      exports8.isInterpreterDirective = isInterpreterDirective;
      exports8.isIntersectionTypeAnnotation = isIntersectionTypeAnnotation;
      exports8.isJSX = isJSX;
      exports8.isJSXAttribute = isJSXAttribute;
      exports8.isJSXClosingElement = isJSXClosingElement;
      exports8.isJSXClosingFragment = isJSXClosingFragment;
      exports8.isJSXElement = isJSXElement;
      exports8.isJSXEmptyExpression = isJSXEmptyExpression;
      exports8.isJSXExpressionContainer = isJSXExpressionContainer;
      exports8.isJSXFragment = isJSXFragment;
      exports8.isJSXIdentifier = isJSXIdentifier;
      exports8.isJSXMemberExpression = isJSXMemberExpression;
      exports8.isJSXNamespacedName = isJSXNamespacedName;
      exports8.isJSXOpeningElement = isJSXOpeningElement;
      exports8.isJSXOpeningFragment = isJSXOpeningFragment;
      exports8.isJSXSpreadAttribute = isJSXSpreadAttribute;
      exports8.isJSXSpreadChild = isJSXSpreadChild;
      exports8.isJSXText = isJSXText;
      exports8.isLVal = isLVal;
      exports8.isLabeledStatement = isLabeledStatement;
      exports8.isLiteral = isLiteral;
      exports8.isLogicalExpression = isLogicalExpression;
      exports8.isLoop = isLoop;
      exports8.isMemberExpression = isMemberExpression;
      exports8.isMetaProperty = isMetaProperty;
      exports8.isMethod = isMethod;
      exports8.isMiscellaneous = isMiscellaneous;
      exports8.isMixedTypeAnnotation = isMixedTypeAnnotation;
      exports8.isModuleDeclaration = isModuleDeclaration;
      exports8.isModuleExpression = isModuleExpression;
      exports8.isModuleSpecifier = isModuleSpecifier;
      exports8.isNewExpression = isNewExpression;
      exports8.isNoop = isNoop;
      exports8.isNullLiteral = isNullLiteral;
      exports8.isNullLiteralTypeAnnotation = isNullLiteralTypeAnnotation;
      exports8.isNullableTypeAnnotation = isNullableTypeAnnotation;
      exports8.isNumberLiteral = isNumberLiteral;
      exports8.isNumberLiteralTypeAnnotation = isNumberLiteralTypeAnnotation;
      exports8.isNumberTypeAnnotation = isNumberTypeAnnotation;
      exports8.isNumericLiteral = isNumericLiteral;
      exports8.isObjectExpression = isObjectExpression;
      exports8.isObjectMember = isObjectMember;
      exports8.isObjectMethod = isObjectMethod;
      exports8.isObjectPattern = isObjectPattern;
      exports8.isObjectProperty = isObjectProperty;
      exports8.isObjectTypeAnnotation = isObjectTypeAnnotation;
      exports8.isObjectTypeCallProperty = isObjectTypeCallProperty;
      exports8.isObjectTypeIndexer = isObjectTypeIndexer;
      exports8.isObjectTypeInternalSlot = isObjectTypeInternalSlot;
      exports8.isObjectTypeProperty = isObjectTypeProperty;
      exports8.isObjectTypeSpreadProperty = isObjectTypeSpreadProperty;
      exports8.isOpaqueType = isOpaqueType;
      exports8.isOptionalCallExpression = isOptionalCallExpression;
      exports8.isOptionalIndexedAccessType = isOptionalIndexedAccessType;
      exports8.isOptionalMemberExpression = isOptionalMemberExpression;
      exports8.isParenthesizedExpression = isParenthesizedExpression;
      exports8.isPattern = isPattern;
      exports8.isPatternLike = isPatternLike;
      exports8.isPipelineBareFunction = isPipelineBareFunction;
      exports8.isPipelinePrimaryTopicReference = isPipelinePrimaryTopicReference;
      exports8.isPipelineTopicExpression = isPipelineTopicExpression;
      exports8.isPlaceholder = isPlaceholder;
      exports8.isPrivate = isPrivate;
      exports8.isPrivateName = isPrivateName;
      exports8.isProgram = isProgram;
      exports8.isProperty = isProperty;
      exports8.isPureish = isPureish;
      exports8.isQualifiedTypeIdentifier = isQualifiedTypeIdentifier;
      exports8.isRecordExpression = isRecordExpression;
      exports8.isRegExpLiteral = isRegExpLiteral;
      exports8.isRegexLiteral = isRegexLiteral;
      exports8.isRestElement = isRestElement;
      exports8.isRestProperty = isRestProperty;
      exports8.isReturnStatement = isReturnStatement;
      exports8.isScopable = isScopable;
      exports8.isSequenceExpression = isSequenceExpression;
      exports8.isSpreadElement = isSpreadElement;
      exports8.isSpreadProperty = isSpreadProperty;
      exports8.isStandardized = isStandardized;
      exports8.isStatement = isStatement;
      exports8.isStaticBlock = isStaticBlock;
      exports8.isStringLiteral = isStringLiteral;
      exports8.isStringLiteralTypeAnnotation = isStringLiteralTypeAnnotation;
      exports8.isStringTypeAnnotation = isStringTypeAnnotation;
      exports8.isSuper = isSuper;
      exports8.isSwitchCase = isSwitchCase;
      exports8.isSwitchStatement = isSwitchStatement;
      exports8.isSymbolTypeAnnotation = isSymbolTypeAnnotation;
      exports8.isTSAnyKeyword = isTSAnyKeyword;
      exports8.isTSArrayType = isTSArrayType;
      exports8.isTSAsExpression = isTSAsExpression;
      exports8.isTSBaseType = isTSBaseType;
      exports8.isTSBigIntKeyword = isTSBigIntKeyword;
      exports8.isTSBooleanKeyword = isTSBooleanKeyword;
      exports8.isTSCallSignatureDeclaration = isTSCallSignatureDeclaration;
      exports8.isTSConditionalType = isTSConditionalType;
      exports8.isTSConstructSignatureDeclaration = isTSConstructSignatureDeclaration;
      exports8.isTSConstructorType = isTSConstructorType;
      exports8.isTSDeclareFunction = isTSDeclareFunction;
      exports8.isTSDeclareMethod = isTSDeclareMethod;
      exports8.isTSEntityName = isTSEntityName;
      exports8.isTSEnumBody = isTSEnumBody;
      exports8.isTSEnumDeclaration = isTSEnumDeclaration;
      exports8.isTSEnumMember = isTSEnumMember;
      exports8.isTSExportAssignment = isTSExportAssignment;
      exports8.isTSExpressionWithTypeArguments = isTSExpressionWithTypeArguments;
      exports8.isTSExternalModuleReference = isTSExternalModuleReference;
      exports8.isTSFunctionType = isTSFunctionType;
      exports8.isTSImportEqualsDeclaration = isTSImportEqualsDeclaration;
      exports8.isTSImportType = isTSImportType;
      exports8.isTSIndexSignature = isTSIndexSignature;
      exports8.isTSIndexedAccessType = isTSIndexedAccessType;
      exports8.isTSInferType = isTSInferType;
      exports8.isTSInstantiationExpression = isTSInstantiationExpression;
      exports8.isTSInterfaceBody = isTSInterfaceBody;
      exports8.isTSInterfaceDeclaration = isTSInterfaceDeclaration;
      exports8.isTSIntersectionType = isTSIntersectionType;
      exports8.isTSIntrinsicKeyword = isTSIntrinsicKeyword;
      exports8.isTSLiteralType = isTSLiteralType;
      exports8.isTSMappedType = isTSMappedType;
      exports8.isTSMethodSignature = isTSMethodSignature;
      exports8.isTSModuleBlock = isTSModuleBlock;
      exports8.isTSModuleDeclaration = isTSModuleDeclaration;
      exports8.isTSNamedTupleMember = isTSNamedTupleMember;
      exports8.isTSNamespaceExportDeclaration = isTSNamespaceExportDeclaration;
      exports8.isTSNeverKeyword = isTSNeverKeyword;
      exports8.isTSNonNullExpression = isTSNonNullExpression;
      exports8.isTSNullKeyword = isTSNullKeyword;
      exports8.isTSNumberKeyword = isTSNumberKeyword;
      exports8.isTSObjectKeyword = isTSObjectKeyword;
      exports8.isTSOptionalType = isTSOptionalType;
      exports8.isTSParameterProperty = isTSParameterProperty;
      exports8.isTSParenthesizedType = isTSParenthesizedType;
      exports8.isTSPropertySignature = isTSPropertySignature;
      exports8.isTSQualifiedName = isTSQualifiedName;
      exports8.isTSRestType = isTSRestType;
      exports8.isTSSatisfiesExpression = isTSSatisfiesExpression;
      exports8.isTSStringKeyword = isTSStringKeyword;
      exports8.isTSSymbolKeyword = isTSSymbolKeyword;
      exports8.isTSTemplateLiteralType = isTSTemplateLiteralType;
      exports8.isTSThisType = isTSThisType;
      exports8.isTSTupleType = isTSTupleType;
      exports8.isTSType = isTSType;
      exports8.isTSTypeAliasDeclaration = isTSTypeAliasDeclaration;
      exports8.isTSTypeAnnotation = isTSTypeAnnotation;
      exports8.isTSTypeAssertion = isTSTypeAssertion;
      exports8.isTSTypeElement = isTSTypeElement;
      exports8.isTSTypeLiteral = isTSTypeLiteral;
      exports8.isTSTypeOperator = isTSTypeOperator;
      exports8.isTSTypeParameter = isTSTypeParameter;
      exports8.isTSTypeParameterDeclaration = isTSTypeParameterDeclaration;
      exports8.isTSTypeParameterInstantiation = isTSTypeParameterInstantiation;
      exports8.isTSTypePredicate = isTSTypePredicate;
      exports8.isTSTypeQuery = isTSTypeQuery;
      exports8.isTSTypeReference = isTSTypeReference;
      exports8.isTSUndefinedKeyword = isTSUndefinedKeyword;
      exports8.isTSUnionType = isTSUnionType;
      exports8.isTSUnknownKeyword = isTSUnknownKeyword;
      exports8.isTSVoidKeyword = isTSVoidKeyword;
      exports8.isTaggedTemplateExpression = isTaggedTemplateExpression;
      exports8.isTemplateElement = isTemplateElement;
      exports8.isTemplateLiteral = isTemplateLiteral;
      exports8.isTerminatorless = isTerminatorless;
      exports8.isThisExpression = isThisExpression;
      exports8.isThisTypeAnnotation = isThisTypeAnnotation;
      exports8.isThrowStatement = isThrowStatement;
      exports8.isTopicReference = isTopicReference;
      exports8.isTryStatement = isTryStatement;
      exports8.isTupleExpression = isTupleExpression;
      exports8.isTupleTypeAnnotation = isTupleTypeAnnotation;
      exports8.isTypeAlias = isTypeAlias;
      exports8.isTypeAnnotation = isTypeAnnotation;
      exports8.isTypeCastExpression = isTypeCastExpression;
      exports8.isTypeParameter = isTypeParameter;
      exports8.isTypeParameterDeclaration = isTypeParameterDeclaration;
      exports8.isTypeParameterInstantiation = isTypeParameterInstantiation;
      exports8.isTypeScript = isTypeScript;
      exports8.isTypeofTypeAnnotation = isTypeofTypeAnnotation;
      exports8.isUnaryExpression = isUnaryExpression;
      exports8.isUnaryLike = isUnaryLike;
      exports8.isUnionTypeAnnotation = isUnionTypeAnnotation;
      exports8.isUpdateExpression = isUpdateExpression;
      exports8.isUserWhitespacable = isUserWhitespacable;
      exports8.isV8IntrinsicIdentifier = isV8IntrinsicIdentifier;
      exports8.isVariableDeclaration = isVariableDeclaration;
      exports8.isVariableDeclarator = isVariableDeclarator;
      exports8.isVariance = isVariance;
      exports8.isVoidPattern = isVoidPattern;
      exports8.isVoidTypeAnnotation = isVoidTypeAnnotation;
      exports8.isWhile = isWhile;
      exports8.isWhileStatement = isWhileStatement;
      exports8.isWithStatement = isWithStatement;
      exports8.isYieldExpression = isYieldExpression;
      var _shallowEqual = require_shallowEqual();
      var _deprecationWarning = require_deprecationWarning();
      function isArrayExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ArrayExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isAssignmentExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "AssignmentExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isBinaryExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "BinaryExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isInterpreterDirective(node, opts) {
        if (!node)
          return false;
        if (node.type !== "InterpreterDirective")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDirective(node, opts) {
        if (!node)
          return false;
        if (node.type !== "Directive")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDirectiveLiteral(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DirectiveLiteral")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isBlockStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "BlockStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isBreakStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "BreakStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isCallExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "CallExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isCatchClause(node, opts) {
        if (!node)
          return false;
        if (node.type !== "CatchClause")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isConditionalExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ConditionalExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isContinueStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ContinueStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDebuggerStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DebuggerStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDoWhileStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DoWhileStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isEmptyStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "EmptyStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isExpressionStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ExpressionStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isFile(node, opts) {
        if (!node)
          return false;
        if (node.type !== "File")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isForInStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ForInStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isForStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ForStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isFunctionDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "FunctionDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isFunctionExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "FunctionExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isIdentifier2(node, opts) {
        if (!node)
          return false;
        if (node.type !== "Identifier")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isIfStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "IfStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isLabeledStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "LabeledStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isStringLiteral(node, opts) {
        if (!node)
          return false;
        if (node.type !== "StringLiteral")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isNumericLiteral(node, opts) {
        if (!node)
          return false;
        if (node.type !== "NumericLiteral")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isNullLiteral(node, opts) {
        if (!node)
          return false;
        if (node.type !== "NullLiteral")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isBooleanLiteral(node, opts) {
        if (!node)
          return false;
        if (node.type !== "BooleanLiteral")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isRegExpLiteral(node, opts) {
        if (!node)
          return false;
        if (node.type !== "RegExpLiteral")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isLogicalExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "LogicalExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isMemberExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "MemberExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isNewExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "NewExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isProgram(node, opts) {
        if (!node)
          return false;
        if (node.type !== "Program")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isObjectExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ObjectExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isObjectMethod(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ObjectMethod")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isObjectProperty(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ObjectProperty")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isRestElement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "RestElement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isReturnStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ReturnStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isSequenceExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "SequenceExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isParenthesizedExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ParenthesizedExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isSwitchCase(node, opts) {
        if (!node)
          return false;
        if (node.type !== "SwitchCase")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isSwitchStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "SwitchStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isThisExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ThisExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isThrowStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ThrowStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTryStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TryStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isUnaryExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "UnaryExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isUpdateExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "UpdateExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isVariableDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "VariableDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isVariableDeclarator(node, opts) {
        if (!node)
          return false;
        if (node.type !== "VariableDeclarator")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isWhileStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "WhileStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isWithStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "WithStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isAssignmentPattern(node, opts) {
        if (!node)
          return false;
        if (node.type !== "AssignmentPattern")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isArrayPattern(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ArrayPattern")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isArrowFunctionExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ArrowFunctionExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isClassBody(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ClassBody")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isClassExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ClassExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isClassDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ClassDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isExportAllDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ExportAllDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isExportDefaultDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ExportDefaultDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isExportNamedDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ExportNamedDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isExportSpecifier(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ExportSpecifier")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isForOfStatement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ForOfStatement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isImportDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ImportDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isImportDefaultSpecifier(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ImportDefaultSpecifier")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isImportNamespaceSpecifier(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ImportNamespaceSpecifier")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isImportSpecifier(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ImportSpecifier")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isImportExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ImportExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isMetaProperty(node, opts) {
        if (!node)
          return false;
        if (node.type !== "MetaProperty")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isClassMethod(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ClassMethod")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isObjectPattern(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ObjectPattern")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isSpreadElement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "SpreadElement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isSuper(node, opts) {
        if (!node)
          return false;
        if (node.type !== "Super")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTaggedTemplateExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TaggedTemplateExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTemplateElement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TemplateElement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTemplateLiteral(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TemplateLiteral")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isYieldExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "YieldExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isAwaitExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "AwaitExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isImport(node, opts) {
        if (!node)
          return false;
        if (node.type !== "Import")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isBigIntLiteral(node, opts) {
        if (!node)
          return false;
        if (node.type !== "BigIntLiteral")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isExportNamespaceSpecifier(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ExportNamespaceSpecifier")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isOptionalMemberExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "OptionalMemberExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isOptionalCallExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "OptionalCallExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isClassProperty(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ClassProperty")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isClassAccessorProperty(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ClassAccessorProperty")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isClassPrivateProperty(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ClassPrivateProperty")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isClassPrivateMethod(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ClassPrivateMethod")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isPrivateName(node, opts) {
        if (!node)
          return false;
        if (node.type !== "PrivateName")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isStaticBlock(node, opts) {
        if (!node)
          return false;
        if (node.type !== "StaticBlock")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isImportAttribute(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ImportAttribute")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isAnyTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "AnyTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isArrayTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ArrayTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isBooleanTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "BooleanTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isBooleanLiteralTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "BooleanLiteralTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isNullLiteralTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "NullLiteralTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isClassImplements(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ClassImplements")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDeclareClass(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DeclareClass")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDeclareFunction(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DeclareFunction")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDeclareInterface(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DeclareInterface")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDeclareModule(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DeclareModule")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDeclareModuleExports(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DeclareModuleExports")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDeclareTypeAlias(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DeclareTypeAlias")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDeclareOpaqueType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DeclareOpaqueType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDeclareVariable(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DeclareVariable")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDeclareExportDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DeclareExportDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDeclareExportAllDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DeclareExportAllDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDeclaredPredicate(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DeclaredPredicate")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isExistsTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ExistsTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isFunctionTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "FunctionTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isFunctionTypeParam(node, opts) {
        if (!node)
          return false;
        if (node.type !== "FunctionTypeParam")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isGenericTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "GenericTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isInferredPredicate(node, opts) {
        if (!node)
          return false;
        if (node.type !== "InferredPredicate")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isInterfaceExtends(node, opts) {
        if (!node)
          return false;
        if (node.type !== "InterfaceExtends")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isInterfaceDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "InterfaceDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isInterfaceTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "InterfaceTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isIntersectionTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "IntersectionTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isMixedTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "MixedTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isEmptyTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "EmptyTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isNullableTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "NullableTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isNumberLiteralTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "NumberLiteralTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isNumberTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "NumberTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isObjectTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ObjectTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isObjectTypeInternalSlot(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ObjectTypeInternalSlot")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isObjectTypeCallProperty(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ObjectTypeCallProperty")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isObjectTypeIndexer(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ObjectTypeIndexer")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isObjectTypeProperty(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ObjectTypeProperty")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isObjectTypeSpreadProperty(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ObjectTypeSpreadProperty")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isOpaqueType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "OpaqueType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isQualifiedTypeIdentifier(node, opts) {
        if (!node)
          return false;
        if (node.type !== "QualifiedTypeIdentifier")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isStringLiteralTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "StringLiteralTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isStringTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "StringTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isSymbolTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "SymbolTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isThisTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ThisTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTupleTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TupleTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTypeofTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TypeofTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTypeAlias(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TypeAlias")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTypeCastExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TypeCastExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTypeParameter(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TypeParameter")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTypeParameterDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TypeParameterDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTypeParameterInstantiation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TypeParameterInstantiation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isUnionTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "UnionTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isVariance(node, opts) {
        if (!node)
          return false;
        if (node.type !== "Variance")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isVoidTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "VoidTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isEnumDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "EnumDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isEnumBooleanBody(node, opts) {
        if (!node)
          return false;
        if (node.type !== "EnumBooleanBody")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isEnumNumberBody(node, opts) {
        if (!node)
          return false;
        if (node.type !== "EnumNumberBody")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isEnumStringBody(node, opts) {
        if (!node)
          return false;
        if (node.type !== "EnumStringBody")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isEnumSymbolBody(node, opts) {
        if (!node)
          return false;
        if (node.type !== "EnumSymbolBody")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isEnumBooleanMember(node, opts) {
        if (!node)
          return false;
        if (node.type !== "EnumBooleanMember")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isEnumNumberMember(node, opts) {
        if (!node)
          return false;
        if (node.type !== "EnumNumberMember")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isEnumStringMember(node, opts) {
        if (!node)
          return false;
        if (node.type !== "EnumStringMember")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isEnumDefaultedMember(node, opts) {
        if (!node)
          return false;
        if (node.type !== "EnumDefaultedMember")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isIndexedAccessType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "IndexedAccessType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isOptionalIndexedAccessType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "OptionalIndexedAccessType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSXAttribute(node, opts) {
        if (!node)
          return false;
        if (node.type !== "JSXAttribute")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSXClosingElement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "JSXClosingElement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSXElement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "JSXElement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSXEmptyExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "JSXEmptyExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSXExpressionContainer(node, opts) {
        if (!node)
          return false;
        if (node.type !== "JSXExpressionContainer")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSXSpreadChild(node, opts) {
        if (!node)
          return false;
        if (node.type !== "JSXSpreadChild")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSXIdentifier(node, opts) {
        if (!node)
          return false;
        if (node.type !== "JSXIdentifier")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSXMemberExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "JSXMemberExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSXNamespacedName(node, opts) {
        if (!node)
          return false;
        if (node.type !== "JSXNamespacedName")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSXOpeningElement(node, opts) {
        if (!node)
          return false;
        if (node.type !== "JSXOpeningElement")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSXSpreadAttribute(node, opts) {
        if (!node)
          return false;
        if (node.type !== "JSXSpreadAttribute")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSXText(node, opts) {
        if (!node)
          return false;
        if (node.type !== "JSXText")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSXFragment(node, opts) {
        if (!node)
          return false;
        if (node.type !== "JSXFragment")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSXOpeningFragment(node, opts) {
        if (!node)
          return false;
        if (node.type !== "JSXOpeningFragment")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSXClosingFragment(node, opts) {
        if (!node)
          return false;
        if (node.type !== "JSXClosingFragment")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isNoop(node, opts) {
        if (!node)
          return false;
        if (node.type !== "Noop")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isPlaceholder(node, opts) {
        if (!node)
          return false;
        if (node.type !== "Placeholder")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isV8IntrinsicIdentifier(node, opts) {
        if (!node)
          return false;
        if (node.type !== "V8IntrinsicIdentifier")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isArgumentPlaceholder(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ArgumentPlaceholder")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isBindExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "BindExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDecorator(node, opts) {
        if (!node)
          return false;
        if (node.type !== "Decorator")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDoExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DoExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isExportDefaultSpecifier(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ExportDefaultSpecifier")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isRecordExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "RecordExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTupleExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TupleExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDecimalLiteral(node, opts) {
        if (!node)
          return false;
        if (node.type !== "DecimalLiteral")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isModuleExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "ModuleExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTopicReference(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TopicReference")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isPipelineTopicExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "PipelineTopicExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isPipelineBareFunction(node, opts) {
        if (!node)
          return false;
        if (node.type !== "PipelineBareFunction")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isPipelinePrimaryTopicReference(node, opts) {
        if (!node)
          return false;
        if (node.type !== "PipelinePrimaryTopicReference")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isVoidPattern(node, opts) {
        if (!node)
          return false;
        if (node.type !== "VoidPattern")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSParameterProperty(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSParameterProperty")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSDeclareFunction(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSDeclareFunction")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSDeclareMethod(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSDeclareMethod")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSQualifiedName(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSQualifiedName")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSCallSignatureDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSCallSignatureDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSConstructSignatureDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSConstructSignatureDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSPropertySignature(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSPropertySignature")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSMethodSignature(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSMethodSignature")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSIndexSignature(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSIndexSignature")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSAnyKeyword(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSAnyKeyword")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSBooleanKeyword(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSBooleanKeyword")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSBigIntKeyword(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSBigIntKeyword")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSIntrinsicKeyword(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSIntrinsicKeyword")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSNeverKeyword(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSNeverKeyword")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSNullKeyword(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSNullKeyword")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSNumberKeyword(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSNumberKeyword")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSObjectKeyword(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSObjectKeyword")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSStringKeyword(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSStringKeyword")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSSymbolKeyword(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSSymbolKeyword")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSUndefinedKeyword(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSUndefinedKeyword")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSUnknownKeyword(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSUnknownKeyword")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSVoidKeyword(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSVoidKeyword")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSThisType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSThisType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSFunctionType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSFunctionType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSConstructorType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSConstructorType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSTypeReference(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSTypeReference")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSTypePredicate(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSTypePredicate")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSTypeQuery(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSTypeQuery")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSTypeLiteral(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSTypeLiteral")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSArrayType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSArrayType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSTupleType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSTupleType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSOptionalType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSOptionalType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSRestType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSRestType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSNamedTupleMember(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSNamedTupleMember")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSUnionType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSUnionType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSIntersectionType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSIntersectionType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSConditionalType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSConditionalType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSInferType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSInferType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSParenthesizedType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSParenthesizedType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSTypeOperator(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSTypeOperator")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSIndexedAccessType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSIndexedAccessType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSMappedType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSMappedType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSTemplateLiteralType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSTemplateLiteralType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSLiteralType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSLiteralType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSExpressionWithTypeArguments(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSExpressionWithTypeArguments")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSInterfaceDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSInterfaceDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSInterfaceBody(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSInterfaceBody")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSTypeAliasDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSTypeAliasDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSInstantiationExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSInstantiationExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSAsExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSAsExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSSatisfiesExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSSatisfiesExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSTypeAssertion(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSTypeAssertion")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSEnumBody(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSEnumBody")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSEnumDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSEnumDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSEnumMember(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSEnumMember")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSModuleDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSModuleDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSModuleBlock(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSModuleBlock")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSImportType(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSImportType")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSImportEqualsDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSImportEqualsDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSExternalModuleReference(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSExternalModuleReference")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSNonNullExpression(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSNonNullExpression")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSExportAssignment(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSExportAssignment")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSNamespaceExportDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSNamespaceExportDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSTypeAnnotation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSTypeAnnotation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSTypeParameterInstantiation(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSTypeParameterInstantiation")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSTypeParameterDeclaration(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSTypeParameterDeclaration")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSTypeParameter(node, opts) {
        if (!node)
          return false;
        if (node.type !== "TSTypeParameter")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isStandardized(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ArrayExpression":
          case "AssignmentExpression":
          case "BinaryExpression":
          case "InterpreterDirective":
          case "Directive":
          case "DirectiveLiteral":
          case "BlockStatement":
          case "BreakStatement":
          case "CallExpression":
          case "CatchClause":
          case "ConditionalExpression":
          case "ContinueStatement":
          case "DebuggerStatement":
          case "DoWhileStatement":
          case "EmptyStatement":
          case "ExpressionStatement":
          case "File":
          case "ForInStatement":
          case "ForStatement":
          case "FunctionDeclaration":
          case "FunctionExpression":
          case "Identifier":
          case "IfStatement":
          case "LabeledStatement":
          case "StringLiteral":
          case "NumericLiteral":
          case "NullLiteral":
          case "BooleanLiteral":
          case "RegExpLiteral":
          case "LogicalExpression":
          case "MemberExpression":
          case "NewExpression":
          case "Program":
          case "ObjectExpression":
          case "ObjectMethod":
          case "ObjectProperty":
          case "RestElement":
          case "ReturnStatement":
          case "SequenceExpression":
          case "ParenthesizedExpression":
          case "SwitchCase":
          case "SwitchStatement":
          case "ThisExpression":
          case "ThrowStatement":
          case "TryStatement":
          case "UnaryExpression":
          case "UpdateExpression":
          case "VariableDeclaration":
          case "VariableDeclarator":
          case "WhileStatement":
          case "WithStatement":
          case "AssignmentPattern":
          case "ArrayPattern":
          case "ArrowFunctionExpression":
          case "ClassBody":
          case "ClassExpression":
          case "ClassDeclaration":
          case "ExportAllDeclaration":
          case "ExportDefaultDeclaration":
          case "ExportNamedDeclaration":
          case "ExportSpecifier":
          case "ForOfStatement":
          case "ImportDeclaration":
          case "ImportDefaultSpecifier":
          case "ImportNamespaceSpecifier":
          case "ImportSpecifier":
          case "ImportExpression":
          case "MetaProperty":
          case "ClassMethod":
          case "ObjectPattern":
          case "SpreadElement":
          case "Super":
          case "TaggedTemplateExpression":
          case "TemplateElement":
          case "TemplateLiteral":
          case "YieldExpression":
          case "AwaitExpression":
          case "Import":
          case "BigIntLiteral":
          case "ExportNamespaceSpecifier":
          case "OptionalMemberExpression":
          case "OptionalCallExpression":
          case "ClassProperty":
          case "ClassAccessorProperty":
          case "ClassPrivateProperty":
          case "ClassPrivateMethod":
          case "PrivateName":
          case "StaticBlock":
          case "ImportAttribute":
            break;
          case "Placeholder":
            switch (node.expectedNode) {
              case "Identifier":
              case "StringLiteral":
              case "BlockStatement":
              case "ClassBody":
                break;
              default:
                return false;
            }
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isExpression(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ArrayExpression":
          case "AssignmentExpression":
          case "BinaryExpression":
          case "CallExpression":
          case "ConditionalExpression":
          case "FunctionExpression":
          case "Identifier":
          case "StringLiteral":
          case "NumericLiteral":
          case "NullLiteral":
          case "BooleanLiteral":
          case "RegExpLiteral":
          case "LogicalExpression":
          case "MemberExpression":
          case "NewExpression":
          case "ObjectExpression":
          case "SequenceExpression":
          case "ParenthesizedExpression":
          case "ThisExpression":
          case "UnaryExpression":
          case "UpdateExpression":
          case "ArrowFunctionExpression":
          case "ClassExpression":
          case "ImportExpression":
          case "MetaProperty":
          case "Super":
          case "TaggedTemplateExpression":
          case "TemplateLiteral":
          case "YieldExpression":
          case "AwaitExpression":
          case "Import":
          case "BigIntLiteral":
          case "OptionalMemberExpression":
          case "OptionalCallExpression":
          case "TypeCastExpression":
          case "JSXElement":
          case "JSXFragment":
          case "BindExpression":
          case "DoExpression":
          case "RecordExpression":
          case "TupleExpression":
          case "DecimalLiteral":
          case "ModuleExpression":
          case "TopicReference":
          case "PipelineTopicExpression":
          case "PipelineBareFunction":
          case "PipelinePrimaryTopicReference":
          case "TSInstantiationExpression":
          case "TSAsExpression":
          case "TSSatisfiesExpression":
          case "TSTypeAssertion":
          case "TSNonNullExpression":
            break;
          case "Placeholder":
            switch (node.expectedNode) {
              case "Expression":
              case "Identifier":
              case "StringLiteral":
                break;
              default:
                return false;
            }
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isBinary(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "BinaryExpression":
          case "LogicalExpression":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isScopable(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "BlockStatement":
          case "CatchClause":
          case "DoWhileStatement":
          case "ForInStatement":
          case "ForStatement":
          case "FunctionDeclaration":
          case "FunctionExpression":
          case "Program":
          case "ObjectMethod":
          case "SwitchStatement":
          case "WhileStatement":
          case "ArrowFunctionExpression":
          case "ClassExpression":
          case "ClassDeclaration":
          case "ForOfStatement":
          case "ClassMethod":
          case "ClassPrivateMethod":
          case "StaticBlock":
          case "TSModuleBlock":
            break;
          case "Placeholder":
            if (node.expectedNode === "BlockStatement")
              break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isBlockParent(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "BlockStatement":
          case "CatchClause":
          case "DoWhileStatement":
          case "ForInStatement":
          case "ForStatement":
          case "FunctionDeclaration":
          case "FunctionExpression":
          case "Program":
          case "ObjectMethod":
          case "SwitchStatement":
          case "WhileStatement":
          case "ArrowFunctionExpression":
          case "ForOfStatement":
          case "ClassMethod":
          case "ClassPrivateMethod":
          case "StaticBlock":
          case "TSModuleBlock":
            break;
          case "Placeholder":
            if (node.expectedNode === "BlockStatement")
              break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isBlock(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "BlockStatement":
          case "Program":
          case "TSModuleBlock":
            break;
          case "Placeholder":
            if (node.expectedNode === "BlockStatement")
              break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isStatement(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "BlockStatement":
          case "BreakStatement":
          case "ContinueStatement":
          case "DebuggerStatement":
          case "DoWhileStatement":
          case "EmptyStatement":
          case "ExpressionStatement":
          case "ForInStatement":
          case "ForStatement":
          case "FunctionDeclaration":
          case "IfStatement":
          case "LabeledStatement":
          case "ReturnStatement":
          case "SwitchStatement":
          case "ThrowStatement":
          case "TryStatement":
          case "VariableDeclaration":
          case "WhileStatement":
          case "WithStatement":
          case "ClassDeclaration":
          case "ExportAllDeclaration":
          case "ExportDefaultDeclaration":
          case "ExportNamedDeclaration":
          case "ForOfStatement":
          case "ImportDeclaration":
          case "DeclareClass":
          case "DeclareFunction":
          case "DeclareInterface":
          case "DeclareModule":
          case "DeclareModuleExports":
          case "DeclareTypeAlias":
          case "DeclareOpaqueType":
          case "DeclareVariable":
          case "DeclareExportDeclaration":
          case "DeclareExportAllDeclaration":
          case "InterfaceDeclaration":
          case "OpaqueType":
          case "TypeAlias":
          case "EnumDeclaration":
          case "TSDeclareFunction":
          case "TSInterfaceDeclaration":
          case "TSTypeAliasDeclaration":
          case "TSEnumDeclaration":
          case "TSModuleDeclaration":
          case "TSImportEqualsDeclaration":
          case "TSExportAssignment":
          case "TSNamespaceExportDeclaration":
            break;
          case "Placeholder":
            switch (node.expectedNode) {
              case "Statement":
              case "Declaration":
              case "BlockStatement":
                break;
              default:
                return false;
            }
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTerminatorless(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "BreakStatement":
          case "ContinueStatement":
          case "ReturnStatement":
          case "ThrowStatement":
          case "YieldExpression":
          case "AwaitExpression":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isCompletionStatement(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "BreakStatement":
          case "ContinueStatement":
          case "ReturnStatement":
          case "ThrowStatement":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isConditional(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ConditionalExpression":
          case "IfStatement":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isLoop(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "DoWhileStatement":
          case "ForInStatement":
          case "ForStatement":
          case "WhileStatement":
          case "ForOfStatement":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isWhile(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "DoWhileStatement":
          case "WhileStatement":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isExpressionWrapper(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ExpressionStatement":
          case "ParenthesizedExpression":
          case "TypeCastExpression":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isFor(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ForInStatement":
          case "ForStatement":
          case "ForOfStatement":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isForXStatement(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ForInStatement":
          case "ForOfStatement":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isFunction3(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "FunctionDeclaration":
          case "FunctionExpression":
          case "ObjectMethod":
          case "ArrowFunctionExpression":
          case "ClassMethod":
          case "ClassPrivateMethod":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isFunctionParent(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "FunctionDeclaration":
          case "FunctionExpression":
          case "ObjectMethod":
          case "ArrowFunctionExpression":
          case "ClassMethod":
          case "ClassPrivateMethod":
          case "StaticBlock":
          case "TSModuleBlock":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isPureish(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "FunctionDeclaration":
          case "FunctionExpression":
          case "StringLiteral":
          case "NumericLiteral":
          case "NullLiteral":
          case "BooleanLiteral":
          case "RegExpLiteral":
          case "ArrowFunctionExpression":
          case "BigIntLiteral":
          case "DecimalLiteral":
            break;
          case "Placeholder":
            if (node.expectedNode === "StringLiteral")
              break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isDeclaration(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "FunctionDeclaration":
          case "VariableDeclaration":
          case "ClassDeclaration":
          case "ExportAllDeclaration":
          case "ExportDefaultDeclaration":
          case "ExportNamedDeclaration":
          case "ImportDeclaration":
          case "DeclareClass":
          case "DeclareFunction":
          case "DeclareInterface":
          case "DeclareModule":
          case "DeclareModuleExports":
          case "DeclareTypeAlias":
          case "DeclareOpaqueType":
          case "DeclareVariable":
          case "DeclareExportDeclaration":
          case "DeclareExportAllDeclaration":
          case "InterfaceDeclaration":
          case "OpaqueType":
          case "TypeAlias":
          case "EnumDeclaration":
          case "TSDeclareFunction":
          case "TSInterfaceDeclaration":
          case "TSTypeAliasDeclaration":
          case "TSEnumDeclaration":
          case "TSModuleDeclaration":
          case "TSImportEqualsDeclaration":
            break;
          case "Placeholder":
            if (node.expectedNode === "Declaration")
              break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isFunctionParameter(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "Identifier":
          case "RestElement":
          case "AssignmentPattern":
          case "ArrayPattern":
          case "ObjectPattern":
          case "VoidPattern":
            break;
          case "Placeholder":
            if (node.expectedNode === "Identifier")
              break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isPatternLike(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "Identifier":
          case "MemberExpression":
          case "RestElement":
          case "AssignmentPattern":
          case "ArrayPattern":
          case "ObjectPattern":
          case "VoidPattern":
          case "TSAsExpression":
          case "TSSatisfiesExpression":
          case "TSTypeAssertion":
          case "TSNonNullExpression":
            break;
          case "Placeholder":
            switch (node.expectedNode) {
              case "Pattern":
              case "Identifier":
                break;
              default:
                return false;
            }
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isLVal(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "Identifier":
          case "MemberExpression":
          case "RestElement":
          case "AssignmentPattern":
          case "ArrayPattern":
          case "ObjectPattern":
          case "TSParameterProperty":
          case "TSAsExpression":
          case "TSSatisfiesExpression":
          case "TSTypeAssertion":
          case "TSNonNullExpression":
            break;
          case "Placeholder":
            switch (node.expectedNode) {
              case "Pattern":
              case "Identifier":
                break;
              default:
                return false;
            }
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSEntityName(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "Identifier":
          case "TSQualifiedName":
            break;
          case "Placeholder":
            if (node.expectedNode === "Identifier")
              break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isLiteral(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "StringLiteral":
          case "NumericLiteral":
          case "NullLiteral":
          case "BooleanLiteral":
          case "RegExpLiteral":
          case "TemplateLiteral":
          case "BigIntLiteral":
          case "DecimalLiteral":
            break;
          case "Placeholder":
            if (node.expectedNode === "StringLiteral")
              break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isImmutable(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "StringLiteral":
          case "NumericLiteral":
          case "NullLiteral":
          case "BooleanLiteral":
          case "BigIntLiteral":
          case "JSXAttribute":
          case "JSXClosingElement":
          case "JSXElement":
          case "JSXExpressionContainer":
          case "JSXSpreadChild":
          case "JSXOpeningElement":
          case "JSXText":
          case "JSXFragment":
          case "JSXOpeningFragment":
          case "JSXClosingFragment":
          case "DecimalLiteral":
            break;
          case "Placeholder":
            if (node.expectedNode === "StringLiteral")
              break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isUserWhitespacable(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ObjectMethod":
          case "ObjectProperty":
          case "ObjectTypeInternalSlot":
          case "ObjectTypeCallProperty":
          case "ObjectTypeIndexer":
          case "ObjectTypeProperty":
          case "ObjectTypeSpreadProperty":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isMethod(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ObjectMethod":
          case "ClassMethod":
          case "ClassPrivateMethod":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isObjectMember(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ObjectMethod":
          case "ObjectProperty":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isProperty(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ObjectProperty":
          case "ClassProperty":
          case "ClassAccessorProperty":
          case "ClassPrivateProperty":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isUnaryLike(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "UnaryExpression":
          case "SpreadElement":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isPattern(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "AssignmentPattern":
          case "ArrayPattern":
          case "ObjectPattern":
          case "VoidPattern":
            break;
          case "Placeholder":
            if (node.expectedNode === "Pattern")
              break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isClass(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ClassExpression":
          case "ClassDeclaration":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isImportOrExportDeclaration(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ExportAllDeclaration":
          case "ExportDefaultDeclaration":
          case "ExportNamedDeclaration":
          case "ImportDeclaration":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isExportDeclaration(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ExportAllDeclaration":
          case "ExportDefaultDeclaration":
          case "ExportNamedDeclaration":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isModuleSpecifier(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ExportSpecifier":
          case "ImportDefaultSpecifier":
          case "ImportNamespaceSpecifier":
          case "ImportSpecifier":
          case "ExportNamespaceSpecifier":
          case "ExportDefaultSpecifier":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isAccessor(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ClassAccessorProperty":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isPrivate(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "ClassPrivateProperty":
          case "ClassPrivateMethod":
          case "PrivateName":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isFlow(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "AnyTypeAnnotation":
          case "ArrayTypeAnnotation":
          case "BooleanTypeAnnotation":
          case "BooleanLiteralTypeAnnotation":
          case "NullLiteralTypeAnnotation":
          case "ClassImplements":
          case "DeclareClass":
          case "DeclareFunction":
          case "DeclareInterface":
          case "DeclareModule":
          case "DeclareModuleExports":
          case "DeclareTypeAlias":
          case "DeclareOpaqueType":
          case "DeclareVariable":
          case "DeclareExportDeclaration":
          case "DeclareExportAllDeclaration":
          case "DeclaredPredicate":
          case "ExistsTypeAnnotation":
          case "FunctionTypeAnnotation":
          case "FunctionTypeParam":
          case "GenericTypeAnnotation":
          case "InferredPredicate":
          case "InterfaceExtends":
          case "InterfaceDeclaration":
          case "InterfaceTypeAnnotation":
          case "IntersectionTypeAnnotation":
          case "MixedTypeAnnotation":
          case "EmptyTypeAnnotation":
          case "NullableTypeAnnotation":
          case "NumberLiteralTypeAnnotation":
          case "NumberTypeAnnotation":
          case "ObjectTypeAnnotation":
          case "ObjectTypeInternalSlot":
          case "ObjectTypeCallProperty":
          case "ObjectTypeIndexer":
          case "ObjectTypeProperty":
          case "ObjectTypeSpreadProperty":
          case "OpaqueType":
          case "QualifiedTypeIdentifier":
          case "StringLiteralTypeAnnotation":
          case "StringTypeAnnotation":
          case "SymbolTypeAnnotation":
          case "ThisTypeAnnotation":
          case "TupleTypeAnnotation":
          case "TypeofTypeAnnotation":
          case "TypeAlias":
          case "TypeAnnotation":
          case "TypeCastExpression":
          case "TypeParameter":
          case "TypeParameterDeclaration":
          case "TypeParameterInstantiation":
          case "UnionTypeAnnotation":
          case "Variance":
          case "VoidTypeAnnotation":
          case "EnumDeclaration":
          case "EnumBooleanBody":
          case "EnumNumberBody":
          case "EnumStringBody":
          case "EnumSymbolBody":
          case "EnumBooleanMember":
          case "EnumNumberMember":
          case "EnumStringMember":
          case "EnumDefaultedMember":
          case "IndexedAccessType":
          case "OptionalIndexedAccessType":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isFlowType(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "AnyTypeAnnotation":
          case "ArrayTypeAnnotation":
          case "BooleanTypeAnnotation":
          case "BooleanLiteralTypeAnnotation":
          case "NullLiteralTypeAnnotation":
          case "ExistsTypeAnnotation":
          case "FunctionTypeAnnotation":
          case "GenericTypeAnnotation":
          case "InterfaceTypeAnnotation":
          case "IntersectionTypeAnnotation":
          case "MixedTypeAnnotation":
          case "EmptyTypeAnnotation":
          case "NullableTypeAnnotation":
          case "NumberLiteralTypeAnnotation":
          case "NumberTypeAnnotation":
          case "ObjectTypeAnnotation":
          case "StringLiteralTypeAnnotation":
          case "StringTypeAnnotation":
          case "SymbolTypeAnnotation":
          case "ThisTypeAnnotation":
          case "TupleTypeAnnotation":
          case "TypeofTypeAnnotation":
          case "UnionTypeAnnotation":
          case "VoidTypeAnnotation":
          case "IndexedAccessType":
          case "OptionalIndexedAccessType":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isFlowBaseAnnotation(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "AnyTypeAnnotation":
          case "BooleanTypeAnnotation":
          case "NullLiteralTypeAnnotation":
          case "MixedTypeAnnotation":
          case "EmptyTypeAnnotation":
          case "NumberTypeAnnotation":
          case "StringTypeAnnotation":
          case "SymbolTypeAnnotation":
          case "ThisTypeAnnotation":
          case "VoidTypeAnnotation":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isFlowDeclaration(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "DeclareClass":
          case "DeclareFunction":
          case "DeclareInterface":
          case "DeclareModule":
          case "DeclareModuleExports":
          case "DeclareTypeAlias":
          case "DeclareOpaqueType":
          case "DeclareVariable":
          case "DeclareExportDeclaration":
          case "DeclareExportAllDeclaration":
          case "InterfaceDeclaration":
          case "OpaqueType":
          case "TypeAlias":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isFlowPredicate(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "DeclaredPredicate":
          case "InferredPredicate":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isEnumBody(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "EnumBooleanBody":
          case "EnumNumberBody":
          case "EnumStringBody":
          case "EnumSymbolBody":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isEnumMember(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "EnumBooleanMember":
          case "EnumNumberMember":
          case "EnumStringMember":
          case "EnumDefaultedMember":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isJSX(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "JSXAttribute":
          case "JSXClosingElement":
          case "JSXElement":
          case "JSXEmptyExpression":
          case "JSXExpressionContainer":
          case "JSXSpreadChild":
          case "JSXIdentifier":
          case "JSXMemberExpression":
          case "JSXNamespacedName":
          case "JSXOpeningElement":
          case "JSXSpreadAttribute":
          case "JSXText":
          case "JSXFragment":
          case "JSXOpeningFragment":
          case "JSXClosingFragment":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isMiscellaneous(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "Noop":
          case "Placeholder":
          case "V8IntrinsicIdentifier":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTypeScript(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "TSParameterProperty":
          case "TSDeclareFunction":
          case "TSDeclareMethod":
          case "TSQualifiedName":
          case "TSCallSignatureDeclaration":
          case "TSConstructSignatureDeclaration":
          case "TSPropertySignature":
          case "TSMethodSignature":
          case "TSIndexSignature":
          case "TSAnyKeyword":
          case "TSBooleanKeyword":
          case "TSBigIntKeyword":
          case "TSIntrinsicKeyword":
          case "TSNeverKeyword":
          case "TSNullKeyword":
          case "TSNumberKeyword":
          case "TSObjectKeyword":
          case "TSStringKeyword":
          case "TSSymbolKeyword":
          case "TSUndefinedKeyword":
          case "TSUnknownKeyword":
          case "TSVoidKeyword":
          case "TSThisType":
          case "TSFunctionType":
          case "TSConstructorType":
          case "TSTypeReference":
          case "TSTypePredicate":
          case "TSTypeQuery":
          case "TSTypeLiteral":
          case "TSArrayType":
          case "TSTupleType":
          case "TSOptionalType":
          case "TSRestType":
          case "TSNamedTupleMember":
          case "TSUnionType":
          case "TSIntersectionType":
          case "TSConditionalType":
          case "TSInferType":
          case "TSParenthesizedType":
          case "TSTypeOperator":
          case "TSIndexedAccessType":
          case "TSMappedType":
          case "TSTemplateLiteralType":
          case "TSLiteralType":
          case "TSExpressionWithTypeArguments":
          case "TSInterfaceDeclaration":
          case "TSInterfaceBody":
          case "TSTypeAliasDeclaration":
          case "TSInstantiationExpression":
          case "TSAsExpression":
          case "TSSatisfiesExpression":
          case "TSTypeAssertion":
          case "TSEnumBody":
          case "TSEnumDeclaration":
          case "TSEnumMember":
          case "TSModuleDeclaration":
          case "TSModuleBlock":
          case "TSImportType":
          case "TSImportEqualsDeclaration":
          case "TSExternalModuleReference":
          case "TSNonNullExpression":
          case "TSExportAssignment":
          case "TSNamespaceExportDeclaration":
          case "TSTypeAnnotation":
          case "TSTypeParameterInstantiation":
          case "TSTypeParameterDeclaration":
          case "TSTypeParameter":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSTypeElement(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "TSCallSignatureDeclaration":
          case "TSConstructSignatureDeclaration":
          case "TSPropertySignature":
          case "TSMethodSignature":
          case "TSIndexSignature":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSType(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "TSAnyKeyword":
          case "TSBooleanKeyword":
          case "TSBigIntKeyword":
          case "TSIntrinsicKeyword":
          case "TSNeverKeyword":
          case "TSNullKeyword":
          case "TSNumberKeyword":
          case "TSObjectKeyword":
          case "TSStringKeyword":
          case "TSSymbolKeyword":
          case "TSUndefinedKeyword":
          case "TSUnknownKeyword":
          case "TSVoidKeyword":
          case "TSThisType":
          case "TSFunctionType":
          case "TSConstructorType":
          case "TSTypeReference":
          case "TSTypePredicate":
          case "TSTypeQuery":
          case "TSTypeLiteral":
          case "TSArrayType":
          case "TSTupleType":
          case "TSOptionalType":
          case "TSRestType":
          case "TSUnionType":
          case "TSIntersectionType":
          case "TSConditionalType":
          case "TSInferType":
          case "TSParenthesizedType":
          case "TSTypeOperator":
          case "TSIndexedAccessType":
          case "TSMappedType":
          case "TSTemplateLiteralType":
          case "TSLiteralType":
          case "TSExpressionWithTypeArguments":
          case "TSImportType":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isTSBaseType(node, opts) {
        if (!node)
          return false;
        switch (node.type) {
          case "TSAnyKeyword":
          case "TSBooleanKeyword":
          case "TSBigIntKeyword":
          case "TSIntrinsicKeyword":
          case "TSNeverKeyword":
          case "TSNullKeyword":
          case "TSNumberKeyword":
          case "TSObjectKeyword":
          case "TSStringKeyword":
          case "TSSymbolKeyword":
          case "TSUndefinedKeyword":
          case "TSUnknownKeyword":
          case "TSVoidKeyword":
          case "TSThisType":
          case "TSTemplateLiteralType":
          case "TSLiteralType":
            break;
          default:
            return false;
        }
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isNumberLiteral(node, opts) {
        (0, _deprecationWarning.default)("isNumberLiteral", "isNumericLiteral");
        if (!node)
          return false;
        if (node.type !== "NumberLiteral")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isRegexLiteral(node, opts) {
        (0, _deprecationWarning.default)("isRegexLiteral", "isRegExpLiteral");
        if (!node)
          return false;
        if (node.type !== "RegexLiteral")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isRestProperty(node, opts) {
        (0, _deprecationWarning.default)("isRestProperty", "isRestElement");
        if (!node)
          return false;
        if (node.type !== "RestProperty")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isSpreadProperty(node, opts) {
        (0, _deprecationWarning.default)("isSpreadProperty", "isSpreadElement");
        if (!node)
          return false;
        if (node.type !== "SpreadProperty")
          return false;
        return opts == null || (0, _shallowEqual.default)(node, opts);
      }
      function isModuleDeclaration(node, opts) {
        (0, _deprecationWarning.default)("isModuleDeclaration", "isImportOrExportDeclaration");
        return isImportOrExportDeclaration(node, opts);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/matchesPattern.js
  var require_matchesPattern = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/matchesPattern.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = matchesPattern;
      var _index = require_generated();
      function isMemberExpressionLike(node) {
        return (0, _index.isMemberExpression)(node) || (0, _index.isMetaProperty)(node);
      }
      function matchesPattern(member, match, allowPartial) {
        if (!isMemberExpressionLike(member))
          return false;
        const parts = Array.isArray(match) ? match : match.split(".");
        const nodes = [];
        let node;
        for (node = member; isMemberExpressionLike(node); node = (_object = node.object) != null ? _object : node.meta) {
          var _object;
          nodes.push(node.property);
        }
        nodes.push(node);
        if (nodes.length < parts.length)
          return false;
        if (!allowPartial && nodes.length > parts.length)
          return false;
        for (let i = 0, j = nodes.length - 1; i < parts.length; i++, j--) {
          const node2 = nodes[j];
          let value;
          if ((0, _index.isIdentifier)(node2)) {
            value = node2.name;
          } else if ((0, _index.isStringLiteral)(node2)) {
            value = node2.value;
          } else if ((0, _index.isThisExpression)(node2)) {
            value = "this";
          } else if ((0, _index.isSuper)(node2)) {
            value = "super";
          } else if ((0, _index.isPrivateName)(node2)) {
            value = "#" + node2.id.name;
          } else {
            return false;
          }
          if (parts[i] !== value)
            return false;
        }
        return true;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/buildMatchMemberExpression.js
  var require_buildMatchMemberExpression = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/buildMatchMemberExpression.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = buildMatchMemberExpression;
      var _matchesPattern = require_matchesPattern();
      function buildMatchMemberExpression(match, allowPartial) {
        const parts = match.split(".");
        return (member) => (0, _matchesPattern.default)(member, parts, allowPartial);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/react/isReactComponent.js
  var require_isReactComponent = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/react/isReactComponent.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      var _buildMatchMemberExpression = require_buildMatchMemberExpression();
      var isReactComponent = (0, _buildMatchMemberExpression.default)("React.Component");
      var _default = exports8.default = isReactComponent;
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/react/isCompatTag.js
  var require_isCompatTag = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/react/isCompatTag.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = isCompatTag;
      function isCompatTag(tagName) {
        return !!tagName && /^[a-z]/.test(tagName);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isType.js
  var require_isType = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isType.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = isType;
      var _index = require_definitions();
      function isType(nodeType, targetType) {
        if (nodeType === targetType)
          return true;
        if (nodeType == null)
          return false;
        if (_index.ALIAS_KEYS[targetType])
          return false;
        const aliases = _index.FLIPPED_ALIAS_KEYS[targetType];
        if (aliases != null && aliases.includes(nodeType))
          return true;
        return false;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isPlaceholderType.js
  var require_isPlaceholderType = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isPlaceholderType.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = isPlaceholderType;
      var _index = require_definitions();
      function isPlaceholderType(placeholderType, targetType) {
        if (placeholderType === targetType)
          return true;
        const aliases = _index.PLACEHOLDERS_ALIAS[placeholderType];
        if (aliases != null && aliases.includes(targetType))
          return true;
        return false;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/is.js
  var require_is = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/is.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = is;
      var _shallowEqual = require_shallowEqual();
      var _isType = require_isType();
      var _isPlaceholderType = require_isPlaceholderType();
      var _index = require_definitions();
      function is(type, node, opts) {
        if (!node)
          return false;
        const matches2 = (0, _isType.default)(node.type, type);
        if (!matches2) {
          if (!opts && node.type === "Placeholder" && type in _index.FLIPPED_ALIAS_KEYS) {
            return (0, _isPlaceholderType.default)(node.expectedNode, type);
          }
          return false;
        }
        if (opts === void 0) {
          return true;
        } else {
          return (0, _shallowEqual.default)(node, opts);
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+helper-validator-identifier@7.27.1/node_modules/@babel/helper-validator-identifier/lib/identifier.js
  var require_identifier = __commonJS({
    "../../node_modules/.pnpm/@babel+helper-validator-identifier@7.27.1/node_modules/@babel/helper-validator-identifier/lib/identifier.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.isIdentifierChar = isIdentifierChar;
      exports8.isIdentifierName = isIdentifierName;
      exports8.isIdentifierStart = isIdentifierStart;
      var nonASCIIidentifierStartChars = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
      var nonASCIIidentifierChars = "\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0897-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u200C\u200D\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\u30FB\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F\uFF65";
      var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
      var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
      nonASCIIidentifierStartChars = nonASCIIidentifierChars = null;
      var astralIdentifierStartCodes = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 4, 51, 13, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 39, 27, 10, 22, 251, 41, 7, 1, 17, 2, 60, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 31, 9, 2, 0, 3, 0, 2, 37, 2, 0, 26, 0, 2, 0, 45, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 200, 32, 32, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 26, 3994, 6, 582, 6842, 29, 1763, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 433, 44, 212, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 42, 9, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 229, 29, 3, 0, 496, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 4191];
      var astralIdentifierCodes = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 7, 9, 32, 4, 318, 1, 80, 3, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 68, 8, 2, 0, 3, 0, 2, 3, 2, 4, 2, 0, 15, 1, 83, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 7, 19, 58, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 343, 9, 54, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 10, 5350, 0, 7, 14, 11465, 27, 2343, 9, 87, 9, 39, 4, 60, 6, 26, 9, 535, 9, 470, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4178, 9, 519, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 245, 1, 2, 9, 726, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
      function isInAstralSet(code, set2) {
        let pos = 65536;
        for (let i = 0, length = set2.length; i < length; i += 2) {
          pos += set2[i];
          if (pos > code)
            return false;
          pos += set2[i + 1];
          if (pos >= code)
            return true;
        }
        return false;
      }
      function isIdentifierStart(code) {
        if (code < 65)
          return code === 36;
        if (code <= 90)
          return true;
        if (code < 97)
          return code === 95;
        if (code <= 122)
          return true;
        if (code <= 65535) {
          return code >= 170 && nonASCIIidentifierStart.test(String.fromCharCode(code));
        }
        return isInAstralSet(code, astralIdentifierStartCodes);
      }
      function isIdentifierChar(code) {
        if (code < 48)
          return code === 36;
        if (code < 58)
          return true;
        if (code < 65)
          return false;
        if (code <= 90)
          return true;
        if (code < 97)
          return code === 95;
        if (code <= 122)
          return true;
        if (code <= 65535) {
          return code >= 170 && nonASCIIidentifier.test(String.fromCharCode(code));
        }
        return isInAstralSet(code, astralIdentifierStartCodes) || isInAstralSet(code, astralIdentifierCodes);
      }
      function isIdentifierName(name) {
        let isFirst = true;
        for (let i = 0; i < name.length; i++) {
          let cp = name.charCodeAt(i);
          if ((cp & 64512) === 55296 && i + 1 < name.length) {
            const trail = name.charCodeAt(++i);
            if ((trail & 64512) === 56320) {
              cp = 65536 + ((cp & 1023) << 10) + (trail & 1023);
            }
          }
          if (isFirst) {
            isFirst = false;
            if (!isIdentifierStart(cp)) {
              return false;
            }
          } else if (!isIdentifierChar(cp)) {
            return false;
          }
        }
        return !isFirst;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+helper-validator-identifier@7.27.1/node_modules/@babel/helper-validator-identifier/lib/keyword.js
  var require_keyword = __commonJS({
    "../../node_modules/.pnpm/@babel+helper-validator-identifier@7.27.1/node_modules/@babel/helper-validator-identifier/lib/keyword.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.isKeyword = isKeyword;
      exports8.isReservedWord = isReservedWord;
      exports8.isStrictBindOnlyReservedWord = isStrictBindOnlyReservedWord;
      exports8.isStrictBindReservedWord = isStrictBindReservedWord;
      exports8.isStrictReservedWord = isStrictReservedWord;
      var reservedWords = {
        keyword: ["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"],
        strict: ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"],
        strictBind: ["eval", "arguments"]
      };
      var keywords = new Set(reservedWords.keyword);
      var reservedWordsStrictSet = new Set(reservedWords.strict);
      var reservedWordsStrictBindSet = new Set(reservedWords.strictBind);
      function isReservedWord(word, inModule) {
        return inModule && word === "await" || word === "enum";
      }
      function isStrictReservedWord(word, inModule) {
        return isReservedWord(word, inModule) || reservedWordsStrictSet.has(word);
      }
      function isStrictBindOnlyReservedWord(word) {
        return reservedWordsStrictBindSet.has(word);
      }
      function isStrictBindReservedWord(word, inModule) {
        return isStrictReservedWord(word, inModule) || isStrictBindOnlyReservedWord(word);
      }
      function isKeyword(word) {
        return keywords.has(word);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+helper-validator-identifier@7.27.1/node_modules/@babel/helper-validator-identifier/lib/index.js
  var require_lib3 = __commonJS({
    "../../node_modules/.pnpm/@babel+helper-validator-identifier@7.27.1/node_modules/@babel/helper-validator-identifier/lib/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      Object.defineProperty(exports8, "isIdentifierChar", {
        enumerable: true,
        get: function() {
          return _identifier.isIdentifierChar;
        }
      });
      Object.defineProperty(exports8, "isIdentifierName", {
        enumerable: true,
        get: function() {
          return _identifier.isIdentifierName;
        }
      });
      Object.defineProperty(exports8, "isIdentifierStart", {
        enumerable: true,
        get: function() {
          return _identifier.isIdentifierStart;
        }
      });
      Object.defineProperty(exports8, "isKeyword", {
        enumerable: true,
        get: function() {
          return _keyword.isKeyword;
        }
      });
      Object.defineProperty(exports8, "isReservedWord", {
        enumerable: true,
        get: function() {
          return _keyword.isReservedWord;
        }
      });
      Object.defineProperty(exports8, "isStrictBindOnlyReservedWord", {
        enumerable: true,
        get: function() {
          return _keyword.isStrictBindOnlyReservedWord;
        }
      });
      Object.defineProperty(exports8, "isStrictBindReservedWord", {
        enumerable: true,
        get: function() {
          return _keyword.isStrictBindReservedWord;
        }
      });
      Object.defineProperty(exports8, "isStrictReservedWord", {
        enumerable: true,
        get: function() {
          return _keyword.isStrictReservedWord;
        }
      });
      var _identifier = require_identifier();
      var _keyword = require_keyword();
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isValidIdentifier.js
  var require_isValidIdentifier = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isValidIdentifier.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = isValidIdentifier2;
      var _helperValidatorIdentifier = require_lib3();
      function isValidIdentifier2(name, reserved = true) {
        if (typeof name !== "string")
          return false;
        if (reserved) {
          if ((0, _helperValidatorIdentifier.isKeyword)(name) || (0, _helperValidatorIdentifier.isStrictReservedWord)(name, true)) {
            return false;
          }
        }
        return (0, _helperValidatorIdentifier.isIdentifierName)(name);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+helper-string-parser@7.27.1/node_modules/@babel/helper-string-parser/lib/index.js
  var require_lib4 = __commonJS({
    "../../node_modules/.pnpm/@babel+helper-string-parser@7.27.1/node_modules/@babel/helper-string-parser/lib/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.readCodePoint = readCodePoint;
      exports8.readInt = readInt;
      exports8.readStringContents = readStringContents;
      var _isDigit = function isDigit(code) {
        return code >= 48 && code <= 57;
      };
      var forbiddenNumericSeparatorSiblings = {
        decBinOct: /* @__PURE__ */ new Set([46, 66, 69, 79, 95, 98, 101, 111]),
        hex: /* @__PURE__ */ new Set([46, 88, 95, 120])
      };
      var isAllowedNumericSeparatorSibling = {
        bin: (ch) => ch === 48 || ch === 49,
        oct: (ch) => ch >= 48 && ch <= 55,
        dec: (ch) => ch >= 48 && ch <= 57,
        hex: (ch) => ch >= 48 && ch <= 57 || ch >= 65 && ch <= 70 || ch >= 97 && ch <= 102
      };
      function readStringContents(type, input, pos, lineStart, curLine, errors) {
        const initialPos = pos;
        const initialLineStart = lineStart;
        const initialCurLine = curLine;
        let out = "";
        let firstInvalidLoc = null;
        let chunkStart = pos;
        const {
          length
        } = input;
        for (; ; ) {
          if (pos >= length) {
            errors.unterminated(initialPos, initialLineStart, initialCurLine);
            out += input.slice(chunkStart, pos);
            break;
          }
          const ch = input.charCodeAt(pos);
          if (isStringEnd(type, ch, input, pos)) {
            out += input.slice(chunkStart, pos);
            break;
          }
          if (ch === 92) {
            out += input.slice(chunkStart, pos);
            const res = readEscapedChar(input, pos, lineStart, curLine, type === "template", errors);
            if (res.ch === null && !firstInvalidLoc) {
              firstInvalidLoc = {
                pos,
                lineStart,
                curLine
              };
            } else {
              out += res.ch;
            }
            ({
              pos,
              lineStart,
              curLine
            } = res);
            chunkStart = pos;
          } else if (ch === 8232 || ch === 8233) {
            ++pos;
            ++curLine;
            lineStart = pos;
          } else if (ch === 10 || ch === 13) {
            if (type === "template") {
              out += input.slice(chunkStart, pos) + "\n";
              ++pos;
              if (ch === 13 && input.charCodeAt(pos) === 10) {
                ++pos;
              }
              ++curLine;
              chunkStart = lineStart = pos;
            } else {
              errors.unterminated(initialPos, initialLineStart, initialCurLine);
            }
          } else {
            ++pos;
          }
        }
        return {
          pos,
          str: out,
          firstInvalidLoc,
          lineStart,
          curLine,
          containsInvalid: !!firstInvalidLoc
        };
      }
      function isStringEnd(type, ch, input, pos) {
        if (type === "template") {
          return ch === 96 || ch === 36 && input.charCodeAt(pos + 1) === 123;
        }
        return ch === (type === "double" ? 34 : 39);
      }
      function readEscapedChar(input, pos, lineStart, curLine, inTemplate, errors) {
        const throwOnInvalid = !inTemplate;
        pos++;
        const res = (ch2) => ({
          pos,
          ch: ch2,
          lineStart,
          curLine
        });
        const ch = input.charCodeAt(pos++);
        switch (ch) {
          case 110:
            return res("\n");
          case 114:
            return res("\r");
          case 120: {
            let code;
            ({
              code,
              pos
            } = readHexChar(input, pos, lineStart, curLine, 2, false, throwOnInvalid, errors));
            return res(code === null ? null : String.fromCharCode(code));
          }
          case 117: {
            let code;
            ({
              code,
              pos
            } = readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors));
            return res(code === null ? null : String.fromCodePoint(code));
          }
          case 116:
            return res("	");
          case 98:
            return res("\b");
          case 118:
            return res("\v");
          case 102:
            return res("\f");
          case 13:
            if (input.charCodeAt(pos) === 10) {
              ++pos;
            }
          case 10:
            lineStart = pos;
            ++curLine;
          case 8232:
          case 8233:
            return res("");
          case 56:
          case 57:
            if (inTemplate) {
              return res(null);
            } else {
              errors.strictNumericEscape(pos - 1, lineStart, curLine);
            }
          default:
            if (ch >= 48 && ch <= 55) {
              const startPos = pos - 1;
              const match = /^[0-7]+/.exec(input.slice(startPos, pos + 2));
              let octalStr = match[0];
              let octal = parseInt(octalStr, 8);
              if (octal > 255) {
                octalStr = octalStr.slice(0, -1);
                octal = parseInt(octalStr, 8);
              }
              pos += octalStr.length - 1;
              const next = input.charCodeAt(pos);
              if (octalStr !== "0" || next === 56 || next === 57) {
                if (inTemplate) {
                  return res(null);
                } else {
                  errors.strictNumericEscape(startPos, lineStart, curLine);
                }
              }
              return res(String.fromCharCode(octal));
            }
            return res(String.fromCharCode(ch));
        }
      }
      function readHexChar(input, pos, lineStart, curLine, len, forceLen, throwOnInvalid, errors) {
        const initialPos = pos;
        let n;
        ({
          n,
          pos
        } = readInt(input, pos, lineStart, curLine, 16, len, forceLen, false, errors, !throwOnInvalid));
        if (n === null) {
          if (throwOnInvalid) {
            errors.invalidEscapeSequence(initialPos, lineStart, curLine);
          } else {
            pos = initialPos - 1;
          }
        }
        return {
          code: n,
          pos
        };
      }
      function readInt(input, pos, lineStart, curLine, radix, len, forceLen, allowNumSeparator, errors, bailOnError) {
        const start = pos;
        const forbiddenSiblings = radix === 16 ? forbiddenNumericSeparatorSiblings.hex : forbiddenNumericSeparatorSiblings.decBinOct;
        const isAllowedSibling = radix === 16 ? isAllowedNumericSeparatorSibling.hex : radix === 10 ? isAllowedNumericSeparatorSibling.dec : radix === 8 ? isAllowedNumericSeparatorSibling.oct : isAllowedNumericSeparatorSibling.bin;
        let invalid = false;
        let total = 0;
        for (let i = 0, e = len == null ? Infinity : len; i < e; ++i) {
          const code = input.charCodeAt(pos);
          let val;
          if (code === 95 && allowNumSeparator !== "bail") {
            const prev = input.charCodeAt(pos - 1);
            const next = input.charCodeAt(pos + 1);
            if (!allowNumSeparator) {
              if (bailOnError)
                return {
                  n: null,
                  pos
                };
              errors.numericSeparatorInEscapeSequence(pos, lineStart, curLine);
            } else if (Number.isNaN(next) || !isAllowedSibling(next) || forbiddenSiblings.has(prev) || forbiddenSiblings.has(next)) {
              if (bailOnError)
                return {
                  n: null,
                  pos
                };
              errors.unexpectedNumericSeparator(pos, lineStart, curLine);
            }
            ++pos;
            continue;
          }
          if (code >= 97) {
            val = code - 97 + 10;
          } else if (code >= 65) {
            val = code - 65 + 10;
          } else if (_isDigit(code)) {
            val = code - 48;
          } else {
            val = Infinity;
          }
          if (val >= radix) {
            if (val <= 9 && bailOnError) {
              return {
                n: null,
                pos
              };
            } else if (val <= 9 && errors.invalidDigit(pos, lineStart, curLine, radix)) {
              val = 0;
            } else if (forceLen) {
              val = 0;
              invalid = true;
            } else {
              break;
            }
          }
          ++pos;
          total = total * radix + val;
        }
        if (pos === start || len != null && pos - start !== len || invalid) {
          return {
            n: null,
            pos
          };
        }
        return {
          n: total,
          pos
        };
      }
      function readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors) {
        const ch = input.charCodeAt(pos);
        let code;
        if (ch === 123) {
          ++pos;
          ({
            code,
            pos
          } = readHexChar(input, pos, lineStart, curLine, input.indexOf("}", pos) - pos, true, throwOnInvalid, errors));
          ++pos;
          if (code !== null && code > 1114111) {
            if (throwOnInvalid) {
              errors.invalidCodePoint(pos, lineStart, curLine);
            } else {
              return {
                code: null,
                pos
              };
            }
          }
        } else {
          ({
            code,
            pos
          } = readHexChar(input, pos, lineStart, curLine, 4, false, throwOnInvalid, errors));
        }
        return {
          code,
          pos
        };
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/constants/index.js
  var require_constants = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/constants/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.UPDATE_OPERATORS = exports8.UNARY_OPERATORS = exports8.STRING_UNARY_OPERATORS = exports8.STATEMENT_OR_BLOCK_KEYS = exports8.NUMBER_UNARY_OPERATORS = exports8.NUMBER_BINARY_OPERATORS = exports8.LOGICAL_OPERATORS = exports8.INHERIT_KEYS = exports8.FOR_INIT_KEYS = exports8.FLATTENABLE_KEYS = exports8.EQUALITY_BINARY_OPERATORS = exports8.COMPARISON_BINARY_OPERATORS = exports8.COMMENT_KEYS = exports8.BOOLEAN_UNARY_OPERATORS = exports8.BOOLEAN_NUMBER_BINARY_OPERATORS = exports8.BOOLEAN_BINARY_OPERATORS = exports8.BINARY_OPERATORS = exports8.ASSIGNMENT_OPERATORS = void 0;
      var STATEMENT_OR_BLOCK_KEYS = exports8.STATEMENT_OR_BLOCK_KEYS = ["consequent", "body", "alternate"];
      var FLATTENABLE_KEYS = exports8.FLATTENABLE_KEYS = ["body", "expressions"];
      var FOR_INIT_KEYS = exports8.FOR_INIT_KEYS = ["left", "init"];
      var COMMENT_KEYS = exports8.COMMENT_KEYS = ["leadingComments", "trailingComments", "innerComments"];
      var LOGICAL_OPERATORS = exports8.LOGICAL_OPERATORS = ["||", "&&", "??"];
      var UPDATE_OPERATORS = exports8.UPDATE_OPERATORS = ["++", "--"];
      var BOOLEAN_NUMBER_BINARY_OPERATORS = exports8.BOOLEAN_NUMBER_BINARY_OPERATORS = [">", "<", ">=", "<="];
      var EQUALITY_BINARY_OPERATORS = exports8.EQUALITY_BINARY_OPERATORS = ["==", "===", "!=", "!=="];
      var COMPARISON_BINARY_OPERATORS = exports8.COMPARISON_BINARY_OPERATORS = [...EQUALITY_BINARY_OPERATORS, "in", "instanceof"];
      var BOOLEAN_BINARY_OPERATORS = exports8.BOOLEAN_BINARY_OPERATORS = [...COMPARISON_BINARY_OPERATORS, ...BOOLEAN_NUMBER_BINARY_OPERATORS];
      var NUMBER_BINARY_OPERATORS = exports8.NUMBER_BINARY_OPERATORS = ["-", "/", "%", "*", "**", "&", "|", ">>", ">>>", "<<", "^"];
      var BINARY_OPERATORS = exports8.BINARY_OPERATORS = ["+", ...NUMBER_BINARY_OPERATORS, ...BOOLEAN_BINARY_OPERATORS, "|>"];
      var ASSIGNMENT_OPERATORS = exports8.ASSIGNMENT_OPERATORS = ["=", "+=", ...NUMBER_BINARY_OPERATORS.map((op) => op + "="), ...LOGICAL_OPERATORS.map((op) => op + "=")];
      var BOOLEAN_UNARY_OPERATORS = exports8.BOOLEAN_UNARY_OPERATORS = ["delete", "!"];
      var NUMBER_UNARY_OPERATORS = exports8.NUMBER_UNARY_OPERATORS = ["+", "-", "~"];
      var STRING_UNARY_OPERATORS = exports8.STRING_UNARY_OPERATORS = ["typeof"];
      var UNARY_OPERATORS = exports8.UNARY_OPERATORS = ["void", "throw", ...BOOLEAN_UNARY_OPERATORS, ...NUMBER_UNARY_OPERATORS, ...STRING_UNARY_OPERATORS];
      var INHERIT_KEYS = exports8.INHERIT_KEYS = {
        optional: ["typeAnnotation", "typeParameters", "returnType"],
        force: ["start", "loc", "end"]
      };
      {
        exports8.BLOCK_SCOPED_SYMBOL = Symbol.for("var used to be block scoped");
        exports8.NOT_LOCAL_BINDING = Symbol.for("should not be considered a local binding");
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/utils.js
  var require_utils3 = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/utils.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.allExpandedTypes = exports8.VISITOR_KEYS = exports8.NODE_PARENT_VALIDATIONS = exports8.NODE_FIELDS = exports8.FLIPPED_ALIAS_KEYS = exports8.DEPRECATED_KEYS = exports8.BUILDER_KEYS = exports8.ALIAS_KEYS = void 0;
      exports8.arrayOf = arrayOf;
      exports8.arrayOfType = arrayOfType;
      exports8.assertEach = assertEach;
      exports8.assertNodeOrValueType = assertNodeOrValueType;
      exports8.assertNodeType = assertNodeType;
      exports8.assertOneOf = assertOneOf;
      exports8.assertOptionalChainStart = assertOptionalChainStart;
      exports8.assertShape = assertShape;
      exports8.assertValueType = assertValueType;
      exports8.chain = chain2;
      exports8.default = defineType;
      exports8.defineAliasedType = defineAliasedType;
      exports8.validate = validate;
      exports8.validateArrayOfType = validateArrayOfType;
      exports8.validateOptional = validateOptional;
      exports8.validateOptionalType = validateOptionalType;
      exports8.validateType = validateType;
      var _is = require_is();
      var _validate = require_validate();
      var VISITOR_KEYS = exports8.VISITOR_KEYS = {};
      var ALIAS_KEYS = exports8.ALIAS_KEYS = {};
      var FLIPPED_ALIAS_KEYS = exports8.FLIPPED_ALIAS_KEYS = {};
      var NODE_FIELDS = exports8.NODE_FIELDS = {};
      var BUILDER_KEYS = exports8.BUILDER_KEYS = {};
      var DEPRECATED_KEYS = exports8.DEPRECATED_KEYS = {};
      var NODE_PARENT_VALIDATIONS = exports8.NODE_PARENT_VALIDATIONS = {};
      function getType(val) {
        if (Array.isArray(val)) {
          return "array";
        } else if (val === null) {
          return "null";
        } else {
          return typeof val;
        }
      }
      function validate(validate2) {
        return {
          validate: validate2
        };
      }
      function validateType(...typeNames) {
        return validate(assertNodeType(...typeNames));
      }
      function validateOptional(validate2) {
        return {
          validate: validate2,
          optional: true
        };
      }
      function validateOptionalType(...typeNames) {
        return {
          validate: assertNodeType(...typeNames),
          optional: true
        };
      }
      function arrayOf(elementType) {
        return chain2(assertValueType("array"), assertEach(elementType));
      }
      function arrayOfType(...typeNames) {
        return arrayOf(assertNodeType(...typeNames));
      }
      function validateArrayOfType(...typeNames) {
        return validate(arrayOfType(...typeNames));
      }
      function assertEach(callback) {
        const childValidator = define_process_default.env.BABEL_TYPES_8_BREAKING ? _validate.validateChild : () => {
        };
        function validator(node, key, val) {
          if (!Array.isArray(val))
            return;
          let i = 0;
          const subKey = {
            toString() {
              return `${key}[${i}]`;
            }
          };
          for (; i < val.length; i++) {
            const v = val[i];
            callback(node, subKey, v);
            childValidator(node, subKey, v);
          }
        }
        validator.each = callback;
        return validator;
      }
      function assertOneOf(...values2) {
        function validate2(node, key, val) {
          if (!values2.includes(val)) {
            throw new TypeError(`Property ${key} expected value to be one of ${JSON.stringify(values2)} but got ${JSON.stringify(val)}`);
          }
        }
        validate2.oneOf = values2;
        return validate2;
      }
      var allExpandedTypes = exports8.allExpandedTypes = [];
      function assertNodeType(...types2) {
        const expandedTypes = /* @__PURE__ */ new Set();
        allExpandedTypes.push({
          types: types2,
          set: expandedTypes
        });
        function validate2(node, key, val) {
          const valType = val == null ? void 0 : val.type;
          if (valType != null) {
            if (expandedTypes.has(valType)) {
              (0, _validate.validateChild)(node, key, val);
              return;
            }
            if (valType === "Placeholder") {
              for (const type of types2) {
                if ((0, _is.default)(type, val)) {
                  (0, _validate.validateChild)(node, key, val);
                  return;
                }
              }
            }
          }
          throw new TypeError(`Property ${key} of ${node.type} expected node to be of a type ${JSON.stringify(types2)} but instead got ${JSON.stringify(valType)}`);
        }
        validate2.oneOfNodeTypes = types2;
        return validate2;
      }
      function assertNodeOrValueType(...types2) {
        function validate2(node, key, val) {
          const primitiveType = getType(val);
          for (const type of types2) {
            if (primitiveType === type || (0, _is.default)(type, val)) {
              (0, _validate.validateChild)(node, key, val);
              return;
            }
          }
          throw new TypeError(`Property ${key} of ${node.type} expected node to be of a type ${JSON.stringify(types2)} but instead got ${JSON.stringify(val == null ? void 0 : val.type)}`);
        }
        validate2.oneOfNodeOrValueTypes = types2;
        return validate2;
      }
      function assertValueType(type) {
        function validate2(node, key, val) {
          if (getType(val) === type) {
            return;
          }
          throw new TypeError(`Property ${key} expected type of ${type} but got ${getType(val)}`);
        }
        validate2.type = type;
        return validate2;
      }
      function assertShape(shape) {
        const keys2 = Object.keys(shape);
        function validate2(node, key, val) {
          const errors = [];
          for (const property2 of keys2) {
            try {
              (0, _validate.validateField)(node, property2, val[property2], shape[property2]);
            } catch (error) {
              if (error instanceof TypeError) {
                errors.push(error.message);
                continue;
              }
              throw error;
            }
          }
          if (errors.length) {
            throw new TypeError(`Property ${key} of ${node.type} expected to have the following:
${errors.join("\n")}`);
          }
        }
        validate2.shapeOf = shape;
        return validate2;
      }
      function assertOptionalChainStart() {
        function validate2(node) {
          var _current;
          let current = node;
          while (node) {
            const {
              type
            } = current;
            if (type === "OptionalCallExpression") {
              if (current.optional)
                return;
              current = current.callee;
              continue;
            }
            if (type === "OptionalMemberExpression") {
              if (current.optional)
                return;
              current = current.object;
              continue;
            }
            break;
          }
          throw new TypeError(`Non-optional ${node.type} must chain from an optional OptionalMemberExpression or OptionalCallExpression. Found chain from ${(_current = current) == null ? void 0 : _current.type}`);
        }
        return validate2;
      }
      function chain2(...fns) {
        function validate2(...args) {
          for (const fn of fns) {
            fn(...args);
          }
        }
        validate2.chainOf = fns;
        if (fns.length >= 2 && "type" in fns[0] && fns[0].type === "array" && !("each" in fns[1])) {
          throw new Error(`An assertValueType("array") validator can only be followed by an assertEach(...) validator.`);
        }
        return validate2;
      }
      var validTypeOpts = /* @__PURE__ */ new Set(["aliases", "builder", "deprecatedAlias", "fields", "inherits", "visitor", "validate"]);
      var validFieldKeys = /* @__PURE__ */ new Set(["default", "optional", "deprecated", "validate"]);
      var store = {};
      function defineAliasedType(...aliases) {
        return (type, opts = {}) => {
          let defined = opts.aliases;
          if (!defined) {
            var _store$opts$inherits$;
            if (opts.inherits)
              defined = (_store$opts$inherits$ = store[opts.inherits].aliases) == null ? void 0 : _store$opts$inherits$.slice();
            defined != null ? defined : defined = [];
            opts.aliases = defined;
          }
          const additional = aliases.filter((a) => !defined.includes(a));
          defined.unshift(...additional);
          defineType(type, opts);
        };
      }
      function defineType(type, opts = {}) {
        const inherits2 = opts.inherits && store[opts.inherits] || {};
        let fields = opts.fields;
        if (!fields) {
          fields = {};
          if (inherits2.fields) {
            const keys2 = Object.getOwnPropertyNames(inherits2.fields);
            for (const key of keys2) {
              const field = inherits2.fields[key];
              const def = field.default;
              if (Array.isArray(def) ? def.length > 0 : def && typeof def === "object") {
                throw new Error("field defaults can only be primitives or empty arrays currently");
              }
              fields[key] = {
                default: Array.isArray(def) ? [] : def,
                optional: field.optional,
                deprecated: field.deprecated,
                validate: field.validate
              };
            }
          }
        }
        const visitor = opts.visitor || inherits2.visitor || [];
        const aliases = opts.aliases || inherits2.aliases || [];
        const builder = opts.builder || inherits2.builder || opts.visitor || [];
        for (const k of Object.keys(opts)) {
          if (!validTypeOpts.has(k)) {
            throw new Error(`Unknown type option "${k}" on ${type}`);
          }
        }
        if (opts.deprecatedAlias) {
          DEPRECATED_KEYS[opts.deprecatedAlias] = type;
        }
        for (const key of visitor.concat(builder)) {
          fields[key] = fields[key] || {};
        }
        for (const key of Object.keys(fields)) {
          const field = fields[key];
          if (field.default !== void 0 && !builder.includes(key)) {
            field.optional = true;
          }
          if (field.default === void 0) {
            field.default = null;
          } else if (!field.validate && field.default != null) {
            field.validate = assertValueType(getType(field.default));
          }
          for (const k of Object.keys(field)) {
            if (!validFieldKeys.has(k)) {
              throw new Error(`Unknown field key "${k}" on ${type}.${key}`);
            }
          }
        }
        VISITOR_KEYS[type] = opts.visitor = visitor;
        BUILDER_KEYS[type] = opts.builder = builder;
        NODE_FIELDS[type] = opts.fields = fields;
        ALIAS_KEYS[type] = opts.aliases = aliases;
        aliases.forEach((alias) => {
          FLIPPED_ALIAS_KEYS[alias] = FLIPPED_ALIAS_KEYS[alias] || [];
          FLIPPED_ALIAS_KEYS[alias].push(type);
        });
        if (opts.validate) {
          NODE_PARENT_VALIDATIONS[type] = opts.validate;
        }
        store[type] = opts;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/core.js
  var require_core = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/core.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.patternLikeCommon = exports8.importAttributes = exports8.functionTypeAnnotationCommon = exports8.functionDeclarationCommon = exports8.functionCommon = exports8.classMethodOrPropertyCommon = exports8.classMethodOrDeclareMethodCommon = void 0;
      var _is = require_is();
      var _isValidIdentifier = require_isValidIdentifier();
      var _helperValidatorIdentifier = require_lib3();
      var _helperStringParser = require_lib4();
      var _index = require_constants();
      var _utils = require_utils3();
      var defineType = (0, _utils.defineAliasedType)("Standardized");
      defineType("ArrayExpression", {
        fields: {
          elements: {
            validate: (0, _utils.arrayOf)((0, _utils.assertNodeOrValueType)("null", "Expression", "SpreadElement")),
            default: !define_process_default.env.BABEL_TYPES_8_BREAKING ? [] : void 0
          }
        },
        visitor: ["elements"],
        aliases: ["Expression"]
      });
      defineType("AssignmentExpression", {
        fields: {
          operator: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertValueType)("string") : Object.assign(function() {
              const identifier3 = (0, _utils.assertOneOf)(..._index.ASSIGNMENT_OPERATORS);
              const pattern = (0, _utils.assertOneOf)("=");
              return function(node, key, val) {
                const validator = (0, _is.default)("Pattern", node.left) ? pattern : identifier3;
                validator(node, key, val);
              };
            }(), {
              oneOf: _index.ASSIGNMENT_OPERATORS
            })
          },
          left: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertNodeType)("LVal", "OptionalMemberExpression") : (0, _utils.assertNodeType)("Identifier", "MemberExpression", "OptionalMemberExpression", "ArrayPattern", "ObjectPattern", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression")
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        builder: ["operator", "left", "right"],
        visitor: ["left", "right"],
        aliases: ["Expression"]
      });
      defineType("BinaryExpression", {
        builder: ["operator", "left", "right"],
        fields: {
          operator: {
            validate: (0, _utils.assertOneOf)(..._index.BINARY_OPERATORS)
          },
          left: {
            validate: function() {
              const expression = (0, _utils.assertNodeType)("Expression");
              const inOp = (0, _utils.assertNodeType)("Expression", "PrivateName");
              const validator = Object.assign(function(node, key, val) {
                const validator2 = node.operator === "in" ? inOp : expression;
                validator2(node, key, val);
              }, {
                oneOfNodeTypes: ["Expression", "PrivateName"]
              });
              return validator;
            }()
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        visitor: ["left", "right"],
        aliases: ["Binary", "Expression"]
      });
      defineType("InterpreterDirective", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        }
      });
      defineType("Directive", {
        visitor: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertNodeType)("DirectiveLiteral")
          }
        }
      });
      defineType("DirectiveLiteral", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        }
      });
      defineType("BlockStatement", {
        builder: ["body", "directives"],
        visitor: ["directives", "body"],
        fields: {
          directives: {
            validate: (0, _utils.arrayOfType)("Directive"),
            default: []
          },
          body: (0, _utils.validateArrayOfType)("Statement")
        },
        aliases: ["Scopable", "BlockParent", "Block", "Statement"]
      });
      defineType("BreakStatement", {
        visitor: ["label"],
        fields: {
          label: {
            validate: (0, _utils.assertNodeType)("Identifier"),
            optional: true
          }
        },
        aliases: ["Statement", "Terminatorless", "CompletionStatement"]
      });
      defineType("CallExpression", {
        visitor: ["callee", "typeParameters", "typeArguments", "arguments"],
        builder: ["callee", "arguments"],
        aliases: ["Expression"],
        fields: Object.assign({
          callee: {
            validate: (0, _utils.assertNodeType)("Expression", "Super", "V8IntrinsicIdentifier")
          },
          arguments: (0, _utils.validateArrayOfType)("Expression", "SpreadElement", "ArgumentPlaceholder"),
          typeArguments: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation"),
            optional: true
          }
        }, define_process_default.env.BABEL_TYPES_8_BREAKING ? {} : {
          optional: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          typeParameters: {
            validate: (0, _utils.assertNodeType)("TSTypeParameterInstantiation"),
            optional: true
          }
        })
      });
      defineType("CatchClause", {
        visitor: ["param", "body"],
        fields: {
          param: {
            validate: (0, _utils.assertNodeType)("Identifier", "ArrayPattern", "ObjectPattern"),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          }
        },
        aliases: ["Scopable", "BlockParent"]
      });
      defineType("ConditionalExpression", {
        visitor: ["test", "consequent", "alternate"],
        fields: {
          test: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          consequent: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          alternate: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        aliases: ["Expression", "Conditional"]
      });
      defineType("ContinueStatement", {
        visitor: ["label"],
        fields: {
          label: {
            validate: (0, _utils.assertNodeType)("Identifier"),
            optional: true
          }
        },
        aliases: ["Statement", "Terminatorless", "CompletionStatement"]
      });
      defineType("DebuggerStatement", {
        aliases: ["Statement"]
      });
      defineType("DoWhileStatement", {
        builder: ["test", "body"],
        visitor: ["body", "test"],
        fields: {
          test: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        },
        aliases: ["Statement", "BlockParent", "Loop", "While", "Scopable"]
      });
      defineType("EmptyStatement", {
        aliases: ["Statement"]
      });
      defineType("ExpressionStatement", {
        visitor: ["expression"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        aliases: ["Statement", "ExpressionWrapper"]
      });
      defineType("File", {
        builder: ["program", "comments", "tokens"],
        visitor: ["program"],
        fields: {
          program: {
            validate: (0, _utils.assertNodeType)("Program")
          },
          comments: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? Object.assign(() => {
            }, {
              each: {
                oneOfNodeTypes: ["CommentBlock", "CommentLine"]
              }
            }) : (0, _utils.assertEach)((0, _utils.assertNodeType)("CommentBlock", "CommentLine")),
            optional: true
          },
          tokens: {
            validate: (0, _utils.assertEach)(Object.assign(() => {
            }, {
              type: "any"
            })),
            optional: true
          }
        }
      });
      defineType("ForInStatement", {
        visitor: ["left", "right", "body"],
        aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement"],
        fields: {
          left: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertNodeType)("VariableDeclaration", "LVal") : (0, _utils.assertNodeType)("VariableDeclaration", "Identifier", "MemberExpression", "ArrayPattern", "ObjectPattern", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression")
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      defineType("ForStatement", {
        visitor: ["init", "test", "update", "body"],
        aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop"],
        fields: {
          init: {
            validate: (0, _utils.assertNodeType)("VariableDeclaration", "Expression"),
            optional: true
          },
          test: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          update: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      var functionCommon = () => ({
        params: (0, _utils.validateArrayOfType)("FunctionParameter"),
        generator: {
          default: false
        },
        async: {
          default: false
        }
      });
      exports8.functionCommon = functionCommon;
      var functionTypeAnnotationCommon = () => ({
        returnType: {
          validate: (0, _utils.assertNodeType)("TypeAnnotation", "TSTypeAnnotation", "Noop"),
          optional: true
        },
        typeParameters: {
          validate: (0, _utils.assertNodeType)("TypeParameterDeclaration", "TSTypeParameterDeclaration", "Noop"),
          optional: true
        }
      });
      exports8.functionTypeAnnotationCommon = functionTypeAnnotationCommon;
      var functionDeclarationCommon = () => Object.assign({}, functionCommon(), {
        declare: {
          validate: (0, _utils.assertValueType)("boolean"),
          optional: true
        },
        id: {
          validate: (0, _utils.assertNodeType)("Identifier"),
          optional: true
        }
      });
      exports8.functionDeclarationCommon = functionDeclarationCommon;
      defineType("FunctionDeclaration", {
        builder: ["id", "params", "body", "generator", "async"],
        visitor: ["id", "typeParameters", "params", "predicate", "returnType", "body"],
        fields: Object.assign({}, functionDeclarationCommon(), functionTypeAnnotationCommon(), {
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          },
          predicate: {
            validate: (0, _utils.assertNodeType)("DeclaredPredicate", "InferredPredicate"),
            optional: true
          }
        }),
        aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Statement", "Pureish", "Declaration"],
        validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? void 0 : function() {
          const identifier3 = (0, _utils.assertNodeType)("Identifier");
          return function(parent2, key, node) {
            if (!(0, _is.default)("ExportDefaultDeclaration", parent2)) {
              identifier3(node, "id", node.id);
            }
          };
        }()
      });
      defineType("FunctionExpression", {
        inherits: "FunctionDeclaration",
        aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Expression", "Pureish"],
        fields: Object.assign({}, functionCommon(), functionTypeAnnotationCommon(), {
          id: {
            validate: (0, _utils.assertNodeType)("Identifier"),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          },
          predicate: {
            validate: (0, _utils.assertNodeType)("DeclaredPredicate", "InferredPredicate"),
            optional: true
          }
        })
      });
      var patternLikeCommon = () => ({
        typeAnnotation: {
          validate: (0, _utils.assertNodeType)("TypeAnnotation", "TSTypeAnnotation", "Noop"),
          optional: true
        },
        optional: {
          validate: (0, _utils.assertValueType)("boolean"),
          optional: true
        },
        decorators: {
          validate: (0, _utils.arrayOfType)("Decorator"),
          optional: true
        }
      });
      exports8.patternLikeCommon = patternLikeCommon;
      defineType("Identifier", {
        builder: ["name"],
        visitor: ["typeAnnotation", "decorators"],
        aliases: ["Expression", "FunctionParameter", "PatternLike", "LVal", "TSEntityName"],
        fields: Object.assign({}, patternLikeCommon(), {
          name: {
            validate: define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.chain)((0, _utils.assertValueType)("string"), Object.assign(function(node, key, val) {
              if (!(0, _isValidIdentifier.default)(val, false)) {
                throw new TypeError(`"${val}" is not a valid identifier name`);
              }
            }, {
              type: "string"
            })) : (0, _utils.assertValueType)("string")
          }
        }),
        validate: define_process_default.env.BABEL_TYPES_8_BREAKING ? function(parent2, key, node) {
          const match = /\.(\w+)$/.exec(key.toString());
          if (!match)
            return;
          const [, parentKey] = match;
          const nonComp = {
            computed: false
          };
          if (parentKey === "property") {
            if ((0, _is.default)("MemberExpression", parent2, nonComp))
              return;
            if ((0, _is.default)("OptionalMemberExpression", parent2, nonComp))
              return;
          } else if (parentKey === "key") {
            if ((0, _is.default)("Property", parent2, nonComp))
              return;
            if ((0, _is.default)("Method", parent2, nonComp))
              return;
          } else if (parentKey === "exported") {
            if ((0, _is.default)("ExportSpecifier", parent2))
              return;
          } else if (parentKey === "imported") {
            if ((0, _is.default)("ImportSpecifier", parent2, {
              imported: node
            }))
              return;
          } else if (parentKey === "meta") {
            if ((0, _is.default)("MetaProperty", parent2, {
              meta: node
            }))
              return;
          }
          if (((0, _helperValidatorIdentifier.isKeyword)(node.name) || (0, _helperValidatorIdentifier.isReservedWord)(node.name, false)) && node.name !== "this") {
            throw new TypeError(`"${node.name}" is not a valid identifier`);
          }
        } : void 0
      });
      defineType("IfStatement", {
        visitor: ["test", "consequent", "alternate"],
        aliases: ["Statement", "Conditional"],
        fields: {
          test: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          consequent: {
            validate: (0, _utils.assertNodeType)("Statement")
          },
          alternate: {
            optional: true,
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      defineType("LabeledStatement", {
        visitor: ["label", "body"],
        aliases: ["Statement"],
        fields: {
          label: {
            validate: (0, _utils.assertNodeType)("Identifier")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      defineType("StringLiteral", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        },
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      defineType("NumericLiteral", {
        builder: ["value"],
        deprecatedAlias: "NumberLiteral",
        fields: {
          value: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("number"), Object.assign(function(node, key, val) {
              if (1 / val < 0 || !Number.isFinite(val)) {
                const error = new Error(`NumericLiterals must be non-negative finite numbers. You can use t.valueToNode(${val}) instead.`);
                {
                }
              }
            }, {
              type: "number"
            }))
          }
        },
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      defineType("NullLiteral", {
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      defineType("BooleanLiteral", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("boolean")
          }
        },
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      defineType("RegExpLiteral", {
        builder: ["pattern", "flags"],
        deprecatedAlias: "RegexLiteral",
        aliases: ["Expression", "Pureish", "Literal"],
        fields: {
          pattern: {
            validate: (0, _utils.assertValueType)("string")
          },
          flags: {
            validate: define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.chain)((0, _utils.assertValueType)("string"), Object.assign(function(node, key, val) {
              const invalid = /[^gimsuy]/.exec(val);
              if (invalid) {
                throw new TypeError(`"${invalid[0]}" is not a valid RegExp flag`);
              }
            }, {
              type: "string"
            })) : (0, _utils.assertValueType)("string"),
            default: ""
          }
        }
      });
      defineType("LogicalExpression", {
        builder: ["operator", "left", "right"],
        visitor: ["left", "right"],
        aliases: ["Binary", "Expression"],
        fields: {
          operator: {
            validate: (0, _utils.assertOneOf)(..._index.LOGICAL_OPERATORS)
          },
          left: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("MemberExpression", {
        builder: ["object", "property", "computed", ...!define_process_default.env.BABEL_TYPES_8_BREAKING ? ["optional"] : []],
        visitor: ["object", "property"],
        aliases: ["Expression", "LVal", "PatternLike"],
        fields: Object.assign({
          object: {
            validate: (0, _utils.assertNodeType)("Expression", "Super")
          },
          property: {
            validate: function() {
              const normal = (0, _utils.assertNodeType)("Identifier", "PrivateName");
              const computed = (0, _utils.assertNodeType)("Expression");
              const validator = function(node, key, val) {
                const validator2 = node.computed ? computed : normal;
                validator2(node, key, val);
              };
              validator.oneOfNodeTypes = ["Expression", "Identifier", "PrivateName"];
              return validator;
            }()
          },
          computed: {
            default: false
          }
        }, !define_process_default.env.BABEL_TYPES_8_BREAKING ? {
          optional: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          }
        } : {})
      });
      defineType("NewExpression", {
        inherits: "CallExpression"
      });
      defineType("Program", {
        visitor: ["directives", "body"],
        builder: ["body", "directives", "sourceType", "interpreter"],
        fields: {
          sourceType: {
            validate: (0, _utils.assertOneOf)("script", "module"),
            default: "script"
          },
          interpreter: {
            validate: (0, _utils.assertNodeType)("InterpreterDirective"),
            default: null,
            optional: true
          },
          directives: {
            validate: (0, _utils.arrayOfType)("Directive"),
            default: []
          },
          body: (0, _utils.validateArrayOfType)("Statement")
        },
        aliases: ["Scopable", "BlockParent", "Block"]
      });
      defineType("ObjectExpression", {
        visitor: ["properties"],
        aliases: ["Expression"],
        fields: {
          properties: (0, _utils.validateArrayOfType)("ObjectMethod", "ObjectProperty", "SpreadElement")
        }
      });
      defineType("ObjectMethod", {
        builder: ["kind", "key", "params", "body", "computed", "generator", "async"],
        visitor: ["decorators", "key", "typeParameters", "params", "returnType", "body"],
        fields: Object.assign({}, functionCommon(), functionTypeAnnotationCommon(), {
          kind: Object.assign({
            validate: (0, _utils.assertOneOf)("method", "get", "set")
          }, !define_process_default.env.BABEL_TYPES_8_BREAKING ? {
            default: "method"
          } : {}),
          computed: {
            default: false
          },
          key: {
            validate: function() {
              const normal = (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral");
              const computed = (0, _utils.assertNodeType)("Expression");
              const validator = function(node, key, val) {
                const validator2 = node.computed ? computed : normal;
                validator2(node, key, val);
              };
              validator.oneOfNodeTypes = ["Expression", "Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral"];
              return validator;
            }()
          },
          decorators: {
            validate: (0, _utils.arrayOfType)("Decorator"),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          }
        }),
        aliases: ["UserWhitespacable", "Function", "Scopable", "BlockParent", "FunctionParent", "Method", "ObjectMember"]
      });
      defineType("ObjectProperty", {
        builder: ["key", "value", "computed", "shorthand", ...!define_process_default.env.BABEL_TYPES_8_BREAKING ? ["decorators"] : []],
        fields: {
          computed: {
            default: false
          },
          key: {
            validate: function() {
              const normal = (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "DecimalLiteral", "PrivateName");
              const computed = (0, _utils.assertNodeType)("Expression");
              const validator = Object.assign(function(node, key, val) {
                const validator2 = node.computed ? computed : normal;
                validator2(node, key, val);
              }, {
                oneOfNodeTypes: ["Expression", "Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "DecimalLiteral", "PrivateName"]
              });
              return validator;
            }()
          },
          value: {
            validate: (0, _utils.assertNodeType)("Expression", "PatternLike")
          },
          shorthand: {
            validate: define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.chain)((0, _utils.assertValueType)("boolean"), Object.assign(function(node, key, shorthand) {
              if (!shorthand)
                return;
              if (node.computed) {
                throw new TypeError("Property shorthand of ObjectProperty cannot be true if computed is true");
              }
              if (!(0, _is.default)("Identifier", node.key)) {
                throw new TypeError("Property shorthand of ObjectProperty cannot be true if key is not an Identifier");
              }
            }, {
              type: "boolean"
            })) : (0, _utils.assertValueType)("boolean"),
            default: false
          },
          decorators: {
            validate: (0, _utils.arrayOfType)("Decorator"),
            optional: true
          }
        },
        visitor: ["decorators", "key", "value"],
        aliases: ["UserWhitespacable", "Property", "ObjectMember"],
        validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? void 0 : function() {
          const pattern = (0, _utils.assertNodeType)("Identifier", "Pattern", "TSAsExpression", "TSSatisfiesExpression", "TSNonNullExpression", "TSTypeAssertion");
          const expression = (0, _utils.assertNodeType)("Expression");
          return function(parent2, key, node) {
            const validator = (0, _is.default)("ObjectPattern", parent2) ? pattern : expression;
            validator(node, "value", node.value);
          };
        }()
      });
      defineType("RestElement", {
        visitor: ["argument", "typeAnnotation"],
        builder: ["argument"],
        aliases: ["FunctionParameter", "PatternLike", "LVal"],
        deprecatedAlias: "RestProperty",
        fields: Object.assign({}, patternLikeCommon(), {
          argument: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertNodeType)("Identifier", "ArrayPattern", "ObjectPattern", "MemberExpression", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression", "RestElement", "AssignmentPattern") : (0, _utils.assertNodeType)("Identifier", "ArrayPattern", "ObjectPattern", "MemberExpression", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression")
          }
        }),
        validate: define_process_default.env.BABEL_TYPES_8_BREAKING ? function(parent2, key) {
          const match = /(\w+)\[(\d+)\]/.exec(key.toString());
          if (!match)
            throw new Error("Internal Babel error: malformed key.");
          const [, listKey, index] = match;
          if (parent2[listKey].length > +index + 1) {
            throw new TypeError(`RestElement must be last element of ${listKey}`);
          }
        } : void 0
      });
      defineType("ReturnStatement", {
        visitor: ["argument"],
        aliases: ["Statement", "Terminatorless", "CompletionStatement"],
        fields: {
          argument: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          }
        }
      });
      defineType("SequenceExpression", {
        visitor: ["expressions"],
        fields: {
          expressions: (0, _utils.validateArrayOfType)("Expression")
        },
        aliases: ["Expression"]
      });
      defineType("ParenthesizedExpression", {
        visitor: ["expression"],
        aliases: ["Expression", "ExpressionWrapper"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("SwitchCase", {
        visitor: ["test", "consequent"],
        fields: {
          test: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          consequent: (0, _utils.validateArrayOfType)("Statement")
        }
      });
      defineType("SwitchStatement", {
        visitor: ["discriminant", "cases"],
        aliases: ["Statement", "BlockParent", "Scopable"],
        fields: {
          discriminant: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          cases: (0, _utils.validateArrayOfType)("SwitchCase")
        }
      });
      defineType("ThisExpression", {
        aliases: ["Expression"]
      });
      defineType("ThrowStatement", {
        visitor: ["argument"],
        aliases: ["Statement", "Terminatorless", "CompletionStatement"],
        fields: {
          argument: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("TryStatement", {
        visitor: ["block", "handler", "finalizer"],
        aliases: ["Statement"],
        fields: {
          block: {
            validate: define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.chain)((0, _utils.assertNodeType)("BlockStatement"), Object.assign(function(node) {
              if (!node.handler && !node.finalizer) {
                throw new TypeError("TryStatement expects either a handler or finalizer, or both");
              }
            }, {
              oneOfNodeTypes: ["BlockStatement"]
            })) : (0, _utils.assertNodeType)("BlockStatement")
          },
          handler: {
            optional: true,
            validate: (0, _utils.assertNodeType)("CatchClause")
          },
          finalizer: {
            optional: true,
            validate: (0, _utils.assertNodeType)("BlockStatement")
          }
        }
      });
      defineType("UnaryExpression", {
        builder: ["operator", "argument", "prefix"],
        fields: {
          prefix: {
            default: true
          },
          argument: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          operator: {
            validate: (0, _utils.assertOneOf)(..._index.UNARY_OPERATORS)
          }
        },
        visitor: ["argument"],
        aliases: ["UnaryLike", "Expression"]
      });
      defineType("UpdateExpression", {
        builder: ["operator", "argument", "prefix"],
        fields: {
          prefix: {
            default: false
          },
          argument: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertNodeType)("Expression") : (0, _utils.assertNodeType)("Identifier", "MemberExpression")
          },
          operator: {
            validate: (0, _utils.assertOneOf)(..._index.UPDATE_OPERATORS)
          }
        },
        visitor: ["argument"],
        aliases: ["Expression"]
      });
      defineType("VariableDeclaration", {
        builder: ["kind", "declarations"],
        visitor: ["declarations"],
        aliases: ["Statement", "Declaration"],
        fields: {
          declare: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          kind: {
            validate: (0, _utils.assertOneOf)("var", "let", "const", "using", "await using")
          },
          declarations: (0, _utils.validateArrayOfType)("VariableDeclarator")
        },
        validate: define_process_default.env.BABEL_TYPES_8_BREAKING ? (() => {
          const withoutInit = (0, _utils.assertNodeType)("Identifier", "Placeholder");
          const constOrLetOrVar = (0, _utils.assertNodeType)("Identifier", "ArrayPattern", "ObjectPattern", "Placeholder");
          const usingOrAwaitUsing = (0, _utils.assertNodeType)("Identifier", "VoidPattern", "Placeholder");
          return function(parent2, key, node) {
            const {
              kind,
              declarations
            } = node;
            const parentIsForX = (0, _is.default)("ForXStatement", parent2, {
              left: node
            });
            if (parentIsForX) {
              if (declarations.length !== 1) {
                throw new TypeError(`Exactly one VariableDeclarator is required in the VariableDeclaration of a ${parent2.type}`);
              }
            }
            for (const decl of declarations) {
              if (kind === "const" || kind === "let" || kind === "var") {
                if (!parentIsForX && !decl.init) {
                  withoutInit(decl, "id", decl.id);
                } else {
                  constOrLetOrVar(decl, "id", decl.id);
                }
              } else {
                usingOrAwaitUsing(decl, "id", decl.id);
              }
            }
          };
        })() : void 0
      });
      defineType("VariableDeclarator", {
        visitor: ["id", "init"],
        fields: {
          id: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertNodeType)("LVal", "VoidPattern") : (0, _utils.assertNodeType)("Identifier", "ArrayPattern", "ObjectPattern", "VoidPattern")
          },
          definite: {
            optional: true,
            validate: (0, _utils.assertValueType)("boolean")
          },
          init: {
            optional: true,
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("WhileStatement", {
        visitor: ["test", "body"],
        aliases: ["Statement", "BlockParent", "Loop", "While", "Scopable"],
        fields: {
          test: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      defineType("WithStatement", {
        visitor: ["object", "body"],
        aliases: ["Statement"],
        fields: {
          object: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      defineType("AssignmentPattern", {
        visitor: ["left", "right", "decorators"],
        builder: ["left", "right"],
        aliases: ["FunctionParameter", "Pattern", "PatternLike", "LVal"],
        fields: Object.assign({}, patternLikeCommon(), {
          left: {
            validate: (0, _utils.assertNodeType)("Identifier", "ObjectPattern", "ArrayPattern", "MemberExpression", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression")
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          decorators: {
            validate: (0, _utils.arrayOfType)("Decorator"),
            optional: true
          }
        })
      });
      defineType("ArrayPattern", {
        visitor: ["elements", "typeAnnotation"],
        builder: ["elements"],
        aliases: ["FunctionParameter", "Pattern", "PatternLike", "LVal"],
        fields: Object.assign({}, patternLikeCommon(), {
          elements: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeOrValueType)("null", "PatternLike")))
          }
        })
      });
      defineType("ArrowFunctionExpression", {
        builder: ["params", "body", "async"],
        visitor: ["typeParameters", "params", "predicate", "returnType", "body"],
        aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Expression", "Pureish"],
        fields: Object.assign({}, functionCommon(), functionTypeAnnotationCommon(), {
          expression: {
            validate: (0, _utils.assertValueType)("boolean")
          },
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement", "Expression")
          },
          predicate: {
            validate: (0, _utils.assertNodeType)("DeclaredPredicate", "InferredPredicate"),
            optional: true
          }
        })
      });
      defineType("ClassBody", {
        visitor: ["body"],
        fields: {
          body: (0, _utils.validateArrayOfType)("ClassMethod", "ClassPrivateMethod", "ClassProperty", "ClassPrivateProperty", "ClassAccessorProperty", "TSDeclareMethod", "TSIndexSignature", "StaticBlock")
        }
      });
      defineType("ClassExpression", {
        builder: ["id", "superClass", "body", "decorators"],
        visitor: ["decorators", "id", "typeParameters", "superClass", "superTypeParameters", "mixins", "implements", "body"],
        aliases: ["Scopable", "Class", "Expression"],
        fields: {
          id: {
            validate: (0, _utils.assertNodeType)("Identifier"),
            optional: true
          },
          typeParameters: {
            validate: (0, _utils.assertNodeType)("TypeParameterDeclaration", "TSTypeParameterDeclaration", "Noop"),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("ClassBody")
          },
          superClass: {
            optional: true,
            validate: (0, _utils.assertNodeType)("Expression")
          },
          ["superTypeParameters"]: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
            optional: true
          },
          implements: {
            validate: (0, _utils.arrayOfType)("TSExpressionWithTypeArguments", "ClassImplements"),
            optional: true
          },
          decorators: {
            validate: (0, _utils.arrayOfType)("Decorator"),
            optional: true
          },
          mixins: {
            validate: (0, _utils.assertNodeType)("InterfaceExtends"),
            optional: true
          }
        }
      });
      defineType("ClassDeclaration", {
        inherits: "ClassExpression",
        aliases: ["Scopable", "Class", "Statement", "Declaration"],
        fields: {
          id: {
            validate: (0, _utils.assertNodeType)("Identifier"),
            optional: true
          },
          typeParameters: {
            validate: (0, _utils.assertNodeType)("TypeParameterDeclaration", "TSTypeParameterDeclaration", "Noop"),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("ClassBody")
          },
          superClass: {
            optional: true,
            validate: (0, _utils.assertNodeType)("Expression")
          },
          ["superTypeParameters"]: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
            optional: true
          },
          implements: {
            validate: (0, _utils.arrayOfType)("TSExpressionWithTypeArguments", "ClassImplements"),
            optional: true
          },
          decorators: {
            validate: (0, _utils.arrayOfType)("Decorator"),
            optional: true
          },
          mixins: {
            validate: (0, _utils.assertNodeType)("InterfaceExtends"),
            optional: true
          },
          declare: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          abstract: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          }
        },
        validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? void 0 : function() {
          const identifier3 = (0, _utils.assertNodeType)("Identifier");
          return function(parent2, key, node) {
            if (!(0, _is.default)("ExportDefaultDeclaration", parent2)) {
              identifier3(node, "id", node.id);
            }
          };
        }()
      });
      var importAttributes = exports8.importAttributes = {
        attributes: {
          optional: true,
          validate: (0, _utils.arrayOfType)("ImportAttribute")
        },
        assertions: {
          deprecated: true,
          optional: true,
          validate: (0, _utils.arrayOfType)("ImportAttribute")
        }
      };
      defineType("ExportAllDeclaration", {
        builder: ["source"],
        visitor: ["source", "attributes", "assertions"],
        aliases: ["Statement", "Declaration", "ImportOrExportDeclaration", "ExportDeclaration"],
        fields: Object.assign({
          source: {
            validate: (0, _utils.assertNodeType)("StringLiteral")
          },
          exportKind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("type", "value"))
        }, importAttributes)
      });
      defineType("ExportDefaultDeclaration", {
        visitor: ["declaration"],
        aliases: ["Statement", "Declaration", "ImportOrExportDeclaration", "ExportDeclaration"],
        fields: {
          declaration: (0, _utils.validateType)("TSDeclareFunction", "FunctionDeclaration", "ClassDeclaration", "Expression"),
          exportKind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("value"))
        }
      });
      defineType("ExportNamedDeclaration", {
        builder: ["declaration", "specifiers", "source"],
        visitor: ["declaration", "specifiers", "source", "attributes", "assertions"],
        aliases: ["Statement", "Declaration", "ImportOrExportDeclaration", "ExportDeclaration"],
        fields: Object.assign({
          declaration: {
            optional: true,
            validate: define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.chain)((0, _utils.assertNodeType)("Declaration"), Object.assign(function(node, key, val) {
              if (val && node.specifiers.length) {
                throw new TypeError("Only declaration or specifiers is allowed on ExportNamedDeclaration");
              }
              if (val && node.source) {
                throw new TypeError("Cannot export a declaration from a source");
              }
            }, {
              oneOfNodeTypes: ["Declaration"]
            })) : (0, _utils.assertNodeType)("Declaration")
          }
        }, importAttributes, {
          specifiers: {
            default: [],
            validate: (0, _utils.arrayOf)(function() {
              const sourced = (0, _utils.assertNodeType)("ExportSpecifier", "ExportDefaultSpecifier", "ExportNamespaceSpecifier");
              const sourceless = (0, _utils.assertNodeType)("ExportSpecifier");
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return sourced;
              return Object.assign(function(node, key, val) {
                const validator = node.source ? sourced : sourceless;
                validator(node, key, val);
              }, {
                oneOfNodeTypes: ["ExportSpecifier", "ExportDefaultSpecifier", "ExportNamespaceSpecifier"]
              });
            }())
          },
          source: {
            validate: (0, _utils.assertNodeType)("StringLiteral"),
            optional: true
          },
          exportKind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("type", "value"))
        })
      });
      defineType("ExportSpecifier", {
        visitor: ["local", "exported"],
        aliases: ["ModuleSpecifier"],
        fields: {
          local: {
            validate: (0, _utils.assertNodeType)("Identifier")
          },
          exported: {
            validate: (0, _utils.assertNodeType)("Identifier", "StringLiteral")
          },
          exportKind: {
            validate: (0, _utils.assertOneOf)("type", "value"),
            optional: true
          }
        }
      });
      defineType("ForOfStatement", {
        visitor: ["left", "right", "body"],
        builder: ["left", "right", "body", "await"],
        aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement"],
        fields: {
          left: {
            validate: function() {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING) {
                return (0, _utils.assertNodeType)("VariableDeclaration", "LVal");
              }
              const declaration = (0, _utils.assertNodeType)("VariableDeclaration");
              const lval = (0, _utils.assertNodeType)("Identifier", "MemberExpression", "ArrayPattern", "ObjectPattern", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression");
              return Object.assign(function(node, key, val) {
                if ((0, _is.default)("VariableDeclaration", val)) {
                  declaration(node, key, val);
                } else {
                  lval(node, key, val);
                }
              }, {
                oneOfNodeTypes: ["VariableDeclaration", "Identifier", "MemberExpression", "ArrayPattern", "ObjectPattern", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression"]
              });
            }()
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          },
          await: {
            default: false
          }
        }
      });
      defineType("ImportDeclaration", {
        builder: ["specifiers", "source"],
        visitor: ["specifiers", "source", "attributes", "assertions"],
        aliases: ["Statement", "Declaration", "ImportOrExportDeclaration"],
        fields: Object.assign({}, importAttributes, {
          module: {
            optional: true,
            validate: (0, _utils.assertValueType)("boolean")
          },
          phase: {
            default: null,
            validate: (0, _utils.assertOneOf)("source", "defer")
          },
          specifiers: (0, _utils.validateArrayOfType)("ImportSpecifier", "ImportDefaultSpecifier", "ImportNamespaceSpecifier"),
          source: {
            validate: (0, _utils.assertNodeType)("StringLiteral")
          },
          importKind: {
            validate: (0, _utils.assertOneOf)("type", "typeof", "value"),
            optional: true
          }
        })
      });
      defineType("ImportDefaultSpecifier", {
        visitor: ["local"],
        aliases: ["ModuleSpecifier"],
        fields: {
          local: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      defineType("ImportNamespaceSpecifier", {
        visitor: ["local"],
        aliases: ["ModuleSpecifier"],
        fields: {
          local: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      defineType("ImportSpecifier", {
        visitor: ["imported", "local"],
        builder: ["local", "imported"],
        aliases: ["ModuleSpecifier"],
        fields: {
          local: {
            validate: (0, _utils.assertNodeType)("Identifier")
          },
          imported: {
            validate: (0, _utils.assertNodeType)("Identifier", "StringLiteral")
          },
          importKind: {
            validate: (0, _utils.assertOneOf)("type", "typeof", "value"),
            optional: true
          }
        }
      });
      defineType("ImportExpression", {
        visitor: ["source", "options"],
        aliases: ["Expression"],
        fields: {
          phase: {
            default: null,
            validate: (0, _utils.assertOneOf)("source", "defer")
          },
          source: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          options: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          }
        }
      });
      defineType("MetaProperty", {
        visitor: ["meta", "property"],
        aliases: ["Expression"],
        fields: {
          meta: {
            validate: define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.chain)((0, _utils.assertNodeType)("Identifier"), Object.assign(function(node, key, val) {
              let property2;
              switch (val.name) {
                case "function":
                  property2 = "sent";
                  break;
                case "new":
                  property2 = "target";
                  break;
                case "import":
                  property2 = "meta";
                  break;
              }
              if (!(0, _is.default)("Identifier", node.property, {
                name: property2
              })) {
                throw new TypeError("Unrecognised MetaProperty");
              }
            }, {
              oneOfNodeTypes: ["Identifier"]
            })) : (0, _utils.assertNodeType)("Identifier")
          },
          property: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      var classMethodOrPropertyCommon = () => ({
        abstract: {
          validate: (0, _utils.assertValueType)("boolean"),
          optional: true
        },
        accessibility: {
          validate: (0, _utils.assertOneOf)("public", "private", "protected"),
          optional: true
        },
        static: {
          default: false
        },
        override: {
          default: false
        },
        computed: {
          default: false
        },
        optional: {
          validate: (0, _utils.assertValueType)("boolean"),
          optional: true
        },
        key: {
          validate: (0, _utils.chain)(function() {
            const normal = (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral");
            const computed = (0, _utils.assertNodeType)("Expression");
            return function(node, key, val) {
              const validator = node.computed ? computed : normal;
              validator(node, key, val);
            };
          }(), (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "Expression"))
        }
      });
      exports8.classMethodOrPropertyCommon = classMethodOrPropertyCommon;
      var classMethodOrDeclareMethodCommon = () => Object.assign({}, functionCommon(), classMethodOrPropertyCommon(), {
        params: (0, _utils.validateArrayOfType)("FunctionParameter", "TSParameterProperty"),
        kind: {
          validate: (0, _utils.assertOneOf)("get", "set", "method", "constructor"),
          default: "method"
        },
        access: {
          validate: (0, _utils.chain)((0, _utils.assertValueType)("string"), (0, _utils.assertOneOf)("public", "private", "protected")),
          optional: true
        },
        decorators: {
          validate: (0, _utils.arrayOfType)("Decorator"),
          optional: true
        }
      });
      exports8.classMethodOrDeclareMethodCommon = classMethodOrDeclareMethodCommon;
      defineType("ClassMethod", {
        aliases: ["Function", "Scopable", "BlockParent", "FunctionParent", "Method"],
        builder: ["kind", "key", "params", "body", "computed", "static", "generator", "async"],
        visitor: ["decorators", "key", "typeParameters", "params", "returnType", "body"],
        fields: Object.assign({}, classMethodOrDeclareMethodCommon(), functionTypeAnnotationCommon(), {
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          }
        })
      });
      defineType("ObjectPattern", {
        visitor: ["decorators", "properties", "typeAnnotation"],
        builder: ["properties"],
        aliases: ["FunctionParameter", "Pattern", "PatternLike", "LVal"],
        fields: Object.assign({}, patternLikeCommon(), {
          properties: (0, _utils.validateArrayOfType)("RestElement", "ObjectProperty")
        })
      });
      defineType("SpreadElement", {
        visitor: ["argument"],
        aliases: ["UnaryLike"],
        deprecatedAlias: "SpreadProperty",
        fields: {
          argument: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("Super", {
        aliases: ["Expression"]
      });
      defineType("TaggedTemplateExpression", {
        visitor: ["tag", "typeParameters", "quasi"],
        builder: ["tag", "quasi"],
        aliases: ["Expression"],
        fields: {
          tag: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          quasi: {
            validate: (0, _utils.assertNodeType)("TemplateLiteral")
          },
          ["typeParameters"]: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
            optional: true
          }
        }
      });
      defineType("TemplateElement", {
        builder: ["value", "tail"],
        fields: {
          value: {
            validate: (0, _utils.chain)((0, _utils.assertShape)({
              raw: {
                validate: (0, _utils.assertValueType)("string")
              },
              cooked: {
                validate: (0, _utils.assertValueType)("string"),
                optional: true
              }
            }), function templateElementCookedValidator(node) {
              const raw = node.value.raw;
              let unterminatedCalled = false;
              const error = () => {
                throw new Error("Internal @babel/types error.");
              };
              const {
                str,
                firstInvalidLoc
              } = (0, _helperStringParser.readStringContents)("template", raw, 0, 0, 0, {
                unterminated() {
                  unterminatedCalled = true;
                },
                strictNumericEscape: error,
                invalidEscapeSequence: error,
                numericSeparatorInEscapeSequence: error,
                unexpectedNumericSeparator: error,
                invalidDigit: error,
                invalidCodePoint: error
              });
              if (!unterminatedCalled)
                throw new Error("Invalid raw");
              node.value.cooked = firstInvalidLoc ? null : str;
            })
          },
          tail: {
            default: false
          }
        }
      });
      defineType("TemplateLiteral", {
        visitor: ["quasis", "expressions"],
        aliases: ["Expression", "Literal"],
        fields: {
          quasis: (0, _utils.validateArrayOfType)("TemplateElement"),
          expressions: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Expression", "TSType")), function(node, key, val) {
              if (node.quasis.length !== val.length + 1) {
                throw new TypeError(`Number of ${node.type} quasis should be exactly one more than the number of expressions.
Expected ${val.length + 1} quasis but got ${node.quasis.length}`);
              }
            })
          }
        }
      });
      defineType("YieldExpression", {
        builder: ["argument", "delegate"],
        visitor: ["argument"],
        aliases: ["Expression", "Terminatorless"],
        fields: {
          delegate: {
            validate: define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.chain)((0, _utils.assertValueType)("boolean"), Object.assign(function(node, key, val) {
              if (val && !node.argument) {
                throw new TypeError("Property delegate of YieldExpression cannot be true if there is no argument");
              }
            }, {
              type: "boolean"
            })) : (0, _utils.assertValueType)("boolean"),
            default: false
          },
          argument: {
            optional: true,
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("AwaitExpression", {
        builder: ["argument"],
        visitor: ["argument"],
        aliases: ["Expression", "Terminatorless"],
        fields: {
          argument: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("Import", {
        aliases: ["Expression"]
      });
      defineType("BigIntLiteral", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        },
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      defineType("ExportNamespaceSpecifier", {
        visitor: ["exported"],
        aliases: ["ModuleSpecifier"],
        fields: {
          exported: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      defineType("OptionalMemberExpression", {
        builder: ["object", "property", "computed", "optional"],
        visitor: ["object", "property"],
        aliases: ["Expression"],
        fields: {
          object: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          property: {
            validate: function() {
              const normal = (0, _utils.assertNodeType)("Identifier");
              const computed = (0, _utils.assertNodeType)("Expression");
              const validator = Object.assign(function(node, key, val) {
                const validator2 = node.computed ? computed : normal;
                validator2(node, key, val);
              }, {
                oneOfNodeTypes: ["Expression", "Identifier"]
              });
              return validator;
            }()
          },
          computed: {
            default: false
          },
          optional: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertValueType)("boolean") : (0, _utils.chain)((0, _utils.assertValueType)("boolean"), (0, _utils.assertOptionalChainStart)())
          }
        }
      });
      defineType("OptionalCallExpression", {
        visitor: ["callee", "typeParameters", "typeArguments", "arguments"],
        builder: ["callee", "arguments", "optional"],
        aliases: ["Expression"],
        fields: Object.assign({
          callee: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          arguments: (0, _utils.validateArrayOfType)("Expression", "SpreadElement", "ArgumentPlaceholder"),
          optional: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertValueType)("boolean") : (0, _utils.chain)((0, _utils.assertValueType)("boolean"), (0, _utils.assertOptionalChainStart)())
          },
          typeArguments: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation"),
            optional: true
          }
        }, {
          typeParameters: {
            validate: (0, _utils.assertNodeType)("TSTypeParameterInstantiation"),
            optional: true
          }
        })
      });
      defineType("ClassProperty", {
        visitor: ["decorators", "variance", "key", "typeAnnotation", "value"],
        builder: ["key", "value", "typeAnnotation", "decorators", "computed", "static"],
        aliases: ["Property"],
        fields: Object.assign({}, classMethodOrPropertyCommon(), {
          value: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          definite: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          typeAnnotation: {
            validate: (0, _utils.assertNodeType)("TypeAnnotation", "TSTypeAnnotation", "Noop"),
            optional: true
          },
          decorators: {
            validate: (0, _utils.arrayOfType)("Decorator"),
            optional: true
          },
          readonly: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          declare: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          variance: {
            validate: (0, _utils.assertNodeType)("Variance"),
            optional: true
          }
        })
      });
      defineType("ClassAccessorProperty", {
        visitor: ["decorators", "key", "typeAnnotation", "value"],
        builder: ["key", "value", "typeAnnotation", "decorators", "computed", "static"],
        aliases: ["Property", "Accessor"],
        fields: Object.assign({}, classMethodOrPropertyCommon(), {
          key: {
            validate: (0, _utils.chain)(function() {
              const normal = (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "PrivateName");
              const computed = (0, _utils.assertNodeType)("Expression");
              return function(node, key, val) {
                const validator = node.computed ? computed : normal;
                validator(node, key, val);
              };
            }(), (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "Expression", "PrivateName"))
          },
          value: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          definite: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          typeAnnotation: {
            validate: (0, _utils.assertNodeType)("TypeAnnotation", "TSTypeAnnotation", "Noop"),
            optional: true
          },
          decorators: {
            validate: (0, _utils.arrayOfType)("Decorator"),
            optional: true
          },
          readonly: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          declare: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          variance: {
            validate: (0, _utils.assertNodeType)("Variance"),
            optional: true
          }
        })
      });
      defineType("ClassPrivateProperty", {
        visitor: ["decorators", "variance", "key", "typeAnnotation", "value"],
        builder: ["key", "value", "decorators", "static"],
        aliases: ["Property", "Private"],
        fields: {
          key: {
            validate: (0, _utils.assertNodeType)("PrivateName")
          },
          value: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          typeAnnotation: {
            validate: (0, _utils.assertNodeType)("TypeAnnotation", "TSTypeAnnotation", "Noop"),
            optional: true
          },
          decorators: {
            validate: (0, _utils.arrayOfType)("Decorator"),
            optional: true
          },
          static: {
            validate: (0, _utils.assertValueType)("boolean"),
            default: false
          },
          readonly: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          optional: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          definite: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          variance: {
            validate: (0, _utils.assertNodeType)("Variance"),
            optional: true
          }
        }
      });
      defineType("ClassPrivateMethod", {
        builder: ["kind", "key", "params", "body", "static"],
        visitor: ["decorators", "key", "typeParameters", "params", "returnType", "body"],
        aliases: ["Function", "Scopable", "BlockParent", "FunctionParent", "Method", "Private"],
        fields: Object.assign({}, classMethodOrDeclareMethodCommon(), functionTypeAnnotationCommon(), {
          kind: {
            validate: (0, _utils.assertOneOf)("get", "set", "method"),
            default: "method"
          },
          key: {
            validate: (0, _utils.assertNodeType)("PrivateName")
          },
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          }
        })
      });
      defineType("PrivateName", {
        visitor: ["id"],
        aliases: ["Private"],
        fields: {
          id: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      defineType("StaticBlock", {
        visitor: ["body"],
        fields: {
          body: (0, _utils.validateArrayOfType)("Statement")
        },
        aliases: ["Scopable", "BlockParent", "FunctionParent"]
      });
      defineType("ImportAttribute", {
        visitor: ["key", "value"],
        fields: {
          key: {
            validate: (0, _utils.assertNodeType)("Identifier", "StringLiteral")
          },
          value: {
            validate: (0, _utils.assertNodeType)("StringLiteral")
          }
        }
      });
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/flow.js
  var require_flow = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/flow.js"() {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var _core = require_core();
      var _utils = require_utils3();
      var defineType = (0, _utils.defineAliasedType)("Flow");
      var defineInterfaceishType = (name) => {
        const isDeclareClass = name === "DeclareClass";
        defineType(name, {
          builder: ["id", "typeParameters", "extends", "body"],
          visitor: ["id", "typeParameters", "extends", ...isDeclareClass ? ["mixins", "implements"] : [], "body"],
          aliases: ["FlowDeclaration", "Statement", "Declaration"],
          fields: Object.assign({
            id: (0, _utils.validateType)("Identifier"),
            typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
            extends: (0, _utils.validateOptional)((0, _utils.arrayOfType)("InterfaceExtends"))
          }, isDeclareClass ? {
            mixins: (0, _utils.validateOptional)((0, _utils.arrayOfType)("InterfaceExtends")),
            implements: (0, _utils.validateOptional)((0, _utils.arrayOfType)("ClassImplements"))
          } : {}, {
            body: (0, _utils.validateType)("ObjectTypeAnnotation")
          })
        });
      };
      defineType("AnyTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("ArrayTypeAnnotation", {
        visitor: ["elementType"],
        aliases: ["FlowType"],
        fields: {
          elementType: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("BooleanTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("BooleanLiteralTypeAnnotation", {
        builder: ["value"],
        aliases: ["FlowType"],
        fields: {
          value: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("NullLiteralTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("ClassImplements", {
        visitor: ["id", "typeParameters"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterInstantiation")
        }
      });
      defineInterfaceishType("DeclareClass");
      defineType("DeclareFunction", {
        builder: ["id"],
        visitor: ["id", "predicate"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          predicate: (0, _utils.validateOptionalType)("DeclaredPredicate")
        }
      });
      defineInterfaceishType("DeclareInterface");
      defineType("DeclareModule", {
        builder: ["id", "body", "kind"],
        visitor: ["id", "body"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier", "StringLiteral"),
          body: (0, _utils.validateType)("BlockStatement"),
          kind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("CommonJS", "ES"))
        }
      });
      defineType("DeclareModuleExports", {
        visitor: ["typeAnnotation"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("TypeAnnotation")
        }
      });
      defineType("DeclareTypeAlias", {
        visitor: ["id", "typeParameters", "right"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
          right: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("DeclareOpaqueType", {
        visitor: ["id", "typeParameters", "supertype"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
          supertype: (0, _utils.validateOptionalType)("FlowType"),
          impltype: (0, _utils.validateOptionalType)("FlowType")
        }
      });
      defineType("DeclareVariable", {
        visitor: ["id"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier")
        }
      });
      defineType("DeclareExportDeclaration", {
        visitor: ["declaration", "specifiers", "source", "attributes"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: Object.assign({
          declaration: (0, _utils.validateOptionalType)("Flow"),
          specifiers: (0, _utils.validateOptional)((0, _utils.arrayOfType)("ExportSpecifier", "ExportNamespaceSpecifier")),
          source: (0, _utils.validateOptionalType)("StringLiteral"),
          default: (0, _utils.validateOptional)((0, _utils.assertValueType)("boolean"))
        }, _core.importAttributes)
      });
      defineType("DeclareExportAllDeclaration", {
        visitor: ["source", "attributes"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: Object.assign({
          source: (0, _utils.validateType)("StringLiteral"),
          exportKind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("type", "value"))
        }, _core.importAttributes)
      });
      defineType("DeclaredPredicate", {
        visitor: ["value"],
        aliases: ["FlowPredicate"],
        fields: {
          value: (0, _utils.validateType)("Flow")
        }
      });
      defineType("ExistsTypeAnnotation", {
        aliases: ["FlowType"]
      });
      defineType("FunctionTypeAnnotation", {
        builder: ["typeParameters", "params", "rest", "returnType"],
        visitor: ["typeParameters", "this", "params", "rest", "returnType"],
        aliases: ["FlowType"],
        fields: {
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
          params: (0, _utils.validateArrayOfType)("FunctionTypeParam"),
          rest: (0, _utils.validateOptionalType)("FunctionTypeParam"),
          this: (0, _utils.validateOptionalType)("FunctionTypeParam"),
          returnType: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("FunctionTypeParam", {
        visitor: ["name", "typeAnnotation"],
        fields: {
          name: (0, _utils.validateOptionalType)("Identifier"),
          typeAnnotation: (0, _utils.validateType)("FlowType"),
          optional: (0, _utils.validateOptional)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("GenericTypeAnnotation", {
        visitor: ["id", "typeParameters"],
        aliases: ["FlowType"],
        fields: {
          id: (0, _utils.validateType)("Identifier", "QualifiedTypeIdentifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterInstantiation")
        }
      });
      defineType("InferredPredicate", {
        aliases: ["FlowPredicate"]
      });
      defineType("InterfaceExtends", {
        visitor: ["id", "typeParameters"],
        fields: {
          id: (0, _utils.validateType)("Identifier", "QualifiedTypeIdentifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterInstantiation")
        }
      });
      defineInterfaceishType("InterfaceDeclaration");
      defineType("InterfaceTypeAnnotation", {
        visitor: ["extends", "body"],
        aliases: ["FlowType"],
        fields: {
          extends: (0, _utils.validateOptional)((0, _utils.arrayOfType)("InterfaceExtends")),
          body: (0, _utils.validateType)("ObjectTypeAnnotation")
        }
      });
      defineType("IntersectionTypeAnnotation", {
        visitor: ["types"],
        aliases: ["FlowType"],
        fields: {
          types: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
        }
      });
      defineType("MixedTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("EmptyTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("NullableTypeAnnotation", {
        visitor: ["typeAnnotation"],
        aliases: ["FlowType"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("NumberLiteralTypeAnnotation", {
        builder: ["value"],
        aliases: ["FlowType"],
        fields: {
          value: (0, _utils.validate)((0, _utils.assertValueType)("number"))
        }
      });
      defineType("NumberTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("ObjectTypeAnnotation", {
        visitor: ["properties", "indexers", "callProperties", "internalSlots"],
        aliases: ["FlowType"],
        builder: ["properties", "indexers", "callProperties", "internalSlots", "exact"],
        fields: {
          properties: (0, _utils.validate)((0, _utils.arrayOfType)("ObjectTypeProperty", "ObjectTypeSpreadProperty")),
          indexers: {
            validate: (0, _utils.arrayOfType)("ObjectTypeIndexer"),
            optional: true,
            default: []
          },
          callProperties: {
            validate: (0, _utils.arrayOfType)("ObjectTypeCallProperty"),
            optional: true,
            default: []
          },
          internalSlots: {
            validate: (0, _utils.arrayOfType)("ObjectTypeInternalSlot"),
            optional: true,
            default: []
          },
          exact: {
            validate: (0, _utils.assertValueType)("boolean"),
            default: false
          },
          inexact: (0, _utils.validateOptional)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("ObjectTypeInternalSlot", {
        visitor: ["id", "value"],
        builder: ["id", "value", "optional", "static", "method"],
        aliases: ["UserWhitespacable"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          value: (0, _utils.validateType)("FlowType"),
          optional: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          static: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          method: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("ObjectTypeCallProperty", {
        visitor: ["value"],
        aliases: ["UserWhitespacable"],
        fields: {
          value: (0, _utils.validateType)("FlowType"),
          static: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("ObjectTypeIndexer", {
        visitor: ["variance", "id", "key", "value"],
        builder: ["id", "key", "value", "variance"],
        aliases: ["UserWhitespacable"],
        fields: {
          id: (0, _utils.validateOptionalType)("Identifier"),
          key: (0, _utils.validateType)("FlowType"),
          value: (0, _utils.validateType)("FlowType"),
          static: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          variance: (0, _utils.validateOptionalType)("Variance")
        }
      });
      defineType("ObjectTypeProperty", {
        visitor: ["key", "value", "variance"],
        aliases: ["UserWhitespacable"],
        fields: {
          key: (0, _utils.validateType)("Identifier", "StringLiteral"),
          value: (0, _utils.validateType)("FlowType"),
          kind: (0, _utils.validate)((0, _utils.assertOneOf)("init", "get", "set")),
          static: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          proto: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          optional: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          variance: (0, _utils.validateOptionalType)("Variance"),
          method: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("ObjectTypeSpreadProperty", {
        visitor: ["argument"],
        aliases: ["UserWhitespacable"],
        fields: {
          argument: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("OpaqueType", {
        visitor: ["id", "typeParameters", "supertype", "impltype"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
          supertype: (0, _utils.validateOptionalType)("FlowType"),
          impltype: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("QualifiedTypeIdentifier", {
        visitor: ["qualification", "id"],
        builder: ["id", "qualification"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          qualification: (0, _utils.validateType)("Identifier", "QualifiedTypeIdentifier")
        }
      });
      defineType("StringLiteralTypeAnnotation", {
        builder: ["value"],
        aliases: ["FlowType"],
        fields: {
          value: (0, _utils.validate)((0, _utils.assertValueType)("string"))
        }
      });
      defineType("StringTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("SymbolTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("ThisTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("TupleTypeAnnotation", {
        visitor: ["types"],
        aliases: ["FlowType"],
        fields: {
          types: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
        }
      });
      defineType("TypeofTypeAnnotation", {
        visitor: ["argument"],
        aliases: ["FlowType"],
        fields: {
          argument: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("TypeAlias", {
        visitor: ["id", "typeParameters", "right"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
          right: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("TypeAnnotation", {
        visitor: ["typeAnnotation"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("TypeCastExpression", {
        visitor: ["expression", "typeAnnotation"],
        aliases: ["ExpressionWrapper", "Expression"],
        fields: {
          expression: (0, _utils.validateType)("Expression"),
          typeAnnotation: (0, _utils.validateType)("TypeAnnotation")
        }
      });
      defineType("TypeParameter", {
        visitor: ["bound", "default", "variance"],
        fields: {
          name: (0, _utils.validate)((0, _utils.assertValueType)("string")),
          bound: (0, _utils.validateOptionalType)("TypeAnnotation"),
          default: (0, _utils.validateOptionalType)("FlowType"),
          variance: (0, _utils.validateOptionalType)("Variance")
        }
      });
      defineType("TypeParameterDeclaration", {
        visitor: ["params"],
        fields: {
          params: (0, _utils.validate)((0, _utils.arrayOfType)("TypeParameter"))
        }
      });
      defineType("TypeParameterInstantiation", {
        visitor: ["params"],
        fields: {
          params: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
        }
      });
      defineType("UnionTypeAnnotation", {
        visitor: ["types"],
        aliases: ["FlowType"],
        fields: {
          types: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
        }
      });
      defineType("Variance", {
        builder: ["kind"],
        fields: {
          kind: (0, _utils.validate)((0, _utils.assertOneOf)("minus", "plus"))
        }
      });
      defineType("VoidTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("EnumDeclaration", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "body"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          body: (0, _utils.validateType)("EnumBooleanBody", "EnumNumberBody", "EnumStringBody", "EnumSymbolBody")
        }
      });
      defineType("EnumBooleanBody", {
        aliases: ["EnumBody"],
        visitor: ["members"],
        fields: {
          explicitType: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          members: (0, _utils.validateArrayOfType)("EnumBooleanMember"),
          hasUnknownMembers: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("EnumNumberBody", {
        aliases: ["EnumBody"],
        visitor: ["members"],
        fields: {
          explicitType: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          members: (0, _utils.validateArrayOfType)("EnumNumberMember"),
          hasUnknownMembers: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("EnumStringBody", {
        aliases: ["EnumBody"],
        visitor: ["members"],
        fields: {
          explicitType: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          members: (0, _utils.validateArrayOfType)("EnumStringMember", "EnumDefaultedMember"),
          hasUnknownMembers: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("EnumSymbolBody", {
        aliases: ["EnumBody"],
        visitor: ["members"],
        fields: {
          members: (0, _utils.validateArrayOfType)("EnumDefaultedMember"),
          hasUnknownMembers: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("EnumBooleanMember", {
        aliases: ["EnumMember"],
        builder: ["id"],
        visitor: ["id", "init"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          init: (0, _utils.validateType)("BooleanLiteral")
        }
      });
      defineType("EnumNumberMember", {
        aliases: ["EnumMember"],
        visitor: ["id", "init"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          init: (0, _utils.validateType)("NumericLiteral")
        }
      });
      defineType("EnumStringMember", {
        aliases: ["EnumMember"],
        visitor: ["id", "init"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          init: (0, _utils.validateType)("StringLiteral")
        }
      });
      defineType("EnumDefaultedMember", {
        aliases: ["EnumMember"],
        visitor: ["id"],
        fields: {
          id: (0, _utils.validateType)("Identifier")
        }
      });
      defineType("IndexedAccessType", {
        visitor: ["objectType", "indexType"],
        aliases: ["FlowType"],
        fields: {
          objectType: (0, _utils.validateType)("FlowType"),
          indexType: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("OptionalIndexedAccessType", {
        visitor: ["objectType", "indexType"],
        aliases: ["FlowType"],
        fields: {
          objectType: (0, _utils.validateType)("FlowType"),
          indexType: (0, _utils.validateType)("FlowType"),
          optional: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/jsx.js
  var require_jsx = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/jsx.js"() {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var _utils = require_utils3();
      var defineType = (0, _utils.defineAliasedType)("JSX");
      defineType("JSXAttribute", {
        visitor: ["name", "value"],
        aliases: ["Immutable"],
        fields: {
          name: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier", "JSXNamespacedName")
          },
          value: {
            optional: true,
            validate: (0, _utils.assertNodeType)("JSXElement", "JSXFragment", "StringLiteral", "JSXExpressionContainer")
          }
        }
      });
      defineType("JSXClosingElement", {
        visitor: ["name"],
        aliases: ["Immutable"],
        fields: {
          name: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier", "JSXMemberExpression", "JSXNamespacedName")
          }
        }
      });
      defineType("JSXElement", {
        builder: ["openingElement", "closingElement", "children", "selfClosing"],
        visitor: ["openingElement", "children", "closingElement"],
        aliases: ["Immutable", "Expression"],
        fields: Object.assign({
          openingElement: {
            validate: (0, _utils.assertNodeType)("JSXOpeningElement")
          },
          closingElement: {
            optional: true,
            validate: (0, _utils.assertNodeType)("JSXClosingElement")
          },
          children: (0, _utils.validateArrayOfType)("JSXText", "JSXExpressionContainer", "JSXSpreadChild", "JSXElement", "JSXFragment")
        }, {
          selfClosing: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          }
        })
      });
      defineType("JSXEmptyExpression", {});
      defineType("JSXExpressionContainer", {
        visitor: ["expression"],
        aliases: ["Immutable"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression", "JSXEmptyExpression")
          }
        }
      });
      defineType("JSXSpreadChild", {
        visitor: ["expression"],
        aliases: ["Immutable"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("JSXIdentifier", {
        builder: ["name"],
        fields: {
          name: {
            validate: (0, _utils.assertValueType)("string")
          }
        }
      });
      defineType("JSXMemberExpression", {
        visitor: ["object", "property"],
        fields: {
          object: {
            validate: (0, _utils.assertNodeType)("JSXMemberExpression", "JSXIdentifier")
          },
          property: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier")
          }
        }
      });
      defineType("JSXNamespacedName", {
        visitor: ["namespace", "name"],
        fields: {
          namespace: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier")
          },
          name: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier")
          }
        }
      });
      defineType("JSXOpeningElement", {
        builder: ["name", "attributes", "selfClosing"],
        visitor: ["name", "typeParameters", "typeArguments", "attributes"],
        aliases: ["Immutable"],
        fields: Object.assign({
          name: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier", "JSXMemberExpression", "JSXNamespacedName")
          },
          selfClosing: {
            default: false
          },
          attributes: (0, _utils.validateArrayOfType)("JSXAttribute", "JSXSpreadAttribute"),
          typeArguments: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation"),
            optional: true
          }
        }, {
          typeParameters: {
            validate: (0, _utils.assertNodeType)("TSTypeParameterInstantiation"),
            optional: true
          }
        })
      });
      defineType("JSXSpreadAttribute", {
        visitor: ["argument"],
        fields: {
          argument: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("JSXText", {
        aliases: ["Immutable"],
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        }
      });
      defineType("JSXFragment", {
        builder: ["openingFragment", "closingFragment", "children"],
        visitor: ["openingFragment", "children", "closingFragment"],
        aliases: ["Immutable", "Expression"],
        fields: {
          openingFragment: {
            validate: (0, _utils.assertNodeType)("JSXOpeningFragment")
          },
          closingFragment: {
            validate: (0, _utils.assertNodeType)("JSXClosingFragment")
          },
          children: (0, _utils.validateArrayOfType)("JSXText", "JSXExpressionContainer", "JSXSpreadChild", "JSXElement", "JSXFragment")
        }
      });
      defineType("JSXOpeningFragment", {
        aliases: ["Immutable"]
      });
      defineType("JSXClosingFragment", {
        aliases: ["Immutable"]
      });
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/placeholders.js
  var require_placeholders = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/placeholders.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.PLACEHOLDERS_FLIPPED_ALIAS = exports8.PLACEHOLDERS_ALIAS = exports8.PLACEHOLDERS = void 0;
      var _utils = require_utils3();
      var PLACEHOLDERS = exports8.PLACEHOLDERS = ["Identifier", "StringLiteral", "Expression", "Statement", "Declaration", "BlockStatement", "ClassBody", "Pattern"];
      var PLACEHOLDERS_ALIAS = exports8.PLACEHOLDERS_ALIAS = {
        Declaration: ["Statement"],
        Pattern: ["PatternLike", "LVal"]
      };
      for (const type of PLACEHOLDERS) {
        const alias = _utils.ALIAS_KEYS[type];
        if (alias != null && alias.length)
          PLACEHOLDERS_ALIAS[type] = alias;
      }
      var PLACEHOLDERS_FLIPPED_ALIAS = exports8.PLACEHOLDERS_FLIPPED_ALIAS = {};
      Object.keys(PLACEHOLDERS_ALIAS).forEach((type) => {
        PLACEHOLDERS_ALIAS[type].forEach((alias) => {
          if (!hasOwnProperty.call(PLACEHOLDERS_FLIPPED_ALIAS, alias)) {
            PLACEHOLDERS_FLIPPED_ALIAS[alias] = [];
          }
          PLACEHOLDERS_FLIPPED_ALIAS[alias].push(type);
        });
      });
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/misc.js
  var require_misc = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/misc.js"() {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var _utils = require_utils3();
      var _placeholders = require_placeholders();
      var _core = require_core();
      var defineType = (0, _utils.defineAliasedType)("Miscellaneous");
      {
        defineType("Noop", {
          visitor: []
        });
      }
      defineType("Placeholder", {
        visitor: [],
        builder: ["expectedNode", "name"],
        fields: Object.assign({
          name: {
            validate: (0, _utils.assertNodeType)("Identifier")
          },
          expectedNode: {
            validate: (0, _utils.assertOneOf)(..._placeholders.PLACEHOLDERS)
          }
        }, (0, _core.patternLikeCommon)())
      });
      defineType("V8IntrinsicIdentifier", {
        builder: ["name"],
        fields: {
          name: {
            validate: (0, _utils.assertValueType)("string")
          }
        }
      });
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/experimental.js
  var require_experimental = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/experimental.js"() {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var _utils = require_utils3();
      (0, _utils.default)("ArgumentPlaceholder", {});
      (0, _utils.default)("BindExpression", {
        visitor: ["object", "callee"],
        aliases: ["Expression"],
        fields: !define_process_default.env.BABEL_TYPES_8_BREAKING ? {
          object: {
            validate: Object.assign(() => {
            }, {
              oneOfNodeTypes: ["Expression"]
            })
          },
          callee: {
            validate: Object.assign(() => {
            }, {
              oneOfNodeTypes: ["Expression"]
            })
          }
        } : {
          object: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          callee: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      (0, _utils.default)("Decorator", {
        visitor: ["expression"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      (0, _utils.default)("DoExpression", {
        visitor: ["body"],
        builder: ["body", "async"],
        aliases: ["Expression"],
        fields: {
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          },
          async: {
            validate: (0, _utils.assertValueType)("boolean"),
            default: false
          }
        }
      });
      (0, _utils.default)("ExportDefaultSpecifier", {
        visitor: ["exported"],
        aliases: ["ModuleSpecifier"],
        fields: {
          exported: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      (0, _utils.default)("RecordExpression", {
        visitor: ["properties"],
        aliases: ["Expression"],
        fields: {
          properties: (0, _utils.validateArrayOfType)("ObjectProperty", "SpreadElement")
        }
      });
      (0, _utils.default)("TupleExpression", {
        fields: {
          elements: {
            validate: (0, _utils.arrayOfType)("Expression", "SpreadElement"),
            default: []
          }
        },
        visitor: ["elements"],
        aliases: ["Expression"]
      });
      {
        (0, _utils.default)("DecimalLiteral", {
          builder: ["value"],
          fields: {
            value: {
              validate: (0, _utils.assertValueType)("string")
            }
          },
          aliases: ["Expression", "Pureish", "Literal", "Immutable"]
        });
      }
      (0, _utils.default)("ModuleExpression", {
        visitor: ["body"],
        fields: {
          body: {
            validate: (0, _utils.assertNodeType)("Program")
          }
        },
        aliases: ["Expression"]
      });
      (0, _utils.default)("TopicReference", {
        aliases: ["Expression"]
      });
      (0, _utils.default)("PipelineTopicExpression", {
        builder: ["expression"],
        visitor: ["expression"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        aliases: ["Expression"]
      });
      (0, _utils.default)("PipelineBareFunction", {
        builder: ["callee"],
        visitor: ["callee"],
        fields: {
          callee: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        aliases: ["Expression"]
      });
      (0, _utils.default)("PipelinePrimaryTopicReference", {
        aliases: ["Expression"]
      });
      (0, _utils.default)("VoidPattern", {
        aliases: ["Pattern", "PatternLike", "FunctionParameter"]
      });
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/typescript.js
  var require_typescript = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/typescript.js"() {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var _utils = require_utils3();
      var _core = require_core();
      var _is = require_is();
      var defineType = (0, _utils.defineAliasedType)("TypeScript");
      var bool = (0, _utils.assertValueType)("boolean");
      var tSFunctionTypeAnnotationCommon = () => ({
        returnType: {
          validate: (0, _utils.assertNodeType)("TSTypeAnnotation", "Noop"),
          optional: true
        },
        typeParameters: {
          validate: (0, _utils.assertNodeType)("TSTypeParameterDeclaration", "Noop"),
          optional: true
        }
      });
      defineType("TSParameterProperty", {
        aliases: ["LVal"],
        visitor: ["parameter"],
        fields: {
          accessibility: {
            validate: (0, _utils.assertOneOf)("public", "private", "protected"),
            optional: true
          },
          readonly: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          parameter: {
            validate: (0, _utils.assertNodeType)("Identifier", "AssignmentPattern")
          },
          override: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          decorators: {
            validate: (0, _utils.arrayOfType)("Decorator"),
            optional: true
          }
        }
      });
      defineType("TSDeclareFunction", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "typeParameters", "params", "returnType"],
        fields: Object.assign({}, (0, _core.functionDeclarationCommon)(), tSFunctionTypeAnnotationCommon())
      });
      defineType("TSDeclareMethod", {
        visitor: ["decorators", "key", "typeParameters", "params", "returnType"],
        fields: Object.assign({}, (0, _core.classMethodOrDeclareMethodCommon)(), tSFunctionTypeAnnotationCommon())
      });
      defineType("TSQualifiedName", {
        aliases: ["TSEntityName"],
        visitor: ["left", "right"],
        fields: {
          left: (0, _utils.validateType)("TSEntityName"),
          right: (0, _utils.validateType)("Identifier")
        }
      });
      var signatureDeclarationCommon = () => ({
        typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterDeclaration"),
        ["parameters"]: (0, _utils.validateArrayOfType)("ArrayPattern", "Identifier", "ObjectPattern", "RestElement"),
        ["typeAnnotation"]: (0, _utils.validateOptionalType)("TSTypeAnnotation")
      });
      var callConstructSignatureDeclaration = {
        aliases: ["TSTypeElement"],
        visitor: ["typeParameters", "parameters", "typeAnnotation"],
        fields: signatureDeclarationCommon()
      };
      defineType("TSCallSignatureDeclaration", callConstructSignatureDeclaration);
      defineType("TSConstructSignatureDeclaration", callConstructSignatureDeclaration);
      var namedTypeElementCommon = () => ({
        key: (0, _utils.validateType)("Expression"),
        computed: {
          default: false
        },
        optional: (0, _utils.validateOptional)(bool)
      });
      defineType("TSPropertySignature", {
        aliases: ["TSTypeElement"],
        visitor: ["key", "typeAnnotation"],
        fields: Object.assign({}, namedTypeElementCommon(), {
          readonly: (0, _utils.validateOptional)(bool),
          typeAnnotation: (0, _utils.validateOptionalType)("TSTypeAnnotation"),
          kind: {
            optional: true,
            validate: (0, _utils.assertOneOf)("get", "set")
          }
        })
      });
      defineType("TSMethodSignature", {
        aliases: ["TSTypeElement"],
        visitor: ["key", "typeParameters", "parameters", "typeAnnotation"],
        fields: Object.assign({}, signatureDeclarationCommon(), namedTypeElementCommon(), {
          kind: {
            validate: (0, _utils.assertOneOf)("method", "get", "set")
          }
        })
      });
      defineType("TSIndexSignature", {
        aliases: ["TSTypeElement"],
        visitor: ["parameters", "typeAnnotation"],
        fields: {
          readonly: (0, _utils.validateOptional)(bool),
          static: (0, _utils.validateOptional)(bool),
          parameters: (0, _utils.validateArrayOfType)("Identifier"),
          typeAnnotation: (0, _utils.validateOptionalType)("TSTypeAnnotation")
        }
      });
      var tsKeywordTypes = ["TSAnyKeyword", "TSBooleanKeyword", "TSBigIntKeyword", "TSIntrinsicKeyword", "TSNeverKeyword", "TSNullKeyword", "TSNumberKeyword", "TSObjectKeyword", "TSStringKeyword", "TSSymbolKeyword", "TSUndefinedKeyword", "TSUnknownKeyword", "TSVoidKeyword"];
      for (const type of tsKeywordTypes) {
        defineType(type, {
          aliases: ["TSType", "TSBaseType"],
          visitor: [],
          fields: {}
        });
      }
      defineType("TSThisType", {
        aliases: ["TSType", "TSBaseType"],
        visitor: [],
        fields: {}
      });
      var fnOrCtrBase = {
        aliases: ["TSType"],
        visitor: ["typeParameters", "parameters", "typeAnnotation"]
      };
      defineType("TSFunctionType", Object.assign({}, fnOrCtrBase, {
        fields: signatureDeclarationCommon()
      }));
      defineType("TSConstructorType", Object.assign({}, fnOrCtrBase, {
        fields: Object.assign({}, signatureDeclarationCommon(), {
          abstract: (0, _utils.validateOptional)(bool)
        })
      }));
      defineType("TSTypeReference", {
        aliases: ["TSType"],
        visitor: ["typeName", "typeParameters"],
        fields: {
          typeName: (0, _utils.validateType)("TSEntityName"),
          ["typeParameters"]: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
        }
      });
      defineType("TSTypePredicate", {
        aliases: ["TSType"],
        visitor: ["parameterName", "typeAnnotation"],
        builder: ["parameterName", "typeAnnotation", "asserts"],
        fields: {
          parameterName: (0, _utils.validateType)("Identifier", "TSThisType"),
          typeAnnotation: (0, _utils.validateOptionalType)("TSTypeAnnotation"),
          asserts: (0, _utils.validateOptional)(bool)
        }
      });
      defineType("TSTypeQuery", {
        aliases: ["TSType"],
        visitor: ["exprName", "typeParameters"],
        fields: {
          exprName: (0, _utils.validateType)("TSEntityName", "TSImportType"),
          ["typeParameters"]: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
        }
      });
      defineType("TSTypeLiteral", {
        aliases: ["TSType"],
        visitor: ["members"],
        fields: {
          members: (0, _utils.validateArrayOfType)("TSTypeElement")
        }
      });
      defineType("TSArrayType", {
        aliases: ["TSType"],
        visitor: ["elementType"],
        fields: {
          elementType: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSTupleType", {
        aliases: ["TSType"],
        visitor: ["elementTypes"],
        fields: {
          elementTypes: (0, _utils.validateArrayOfType)("TSType", "TSNamedTupleMember")
        }
      });
      defineType("TSOptionalType", {
        aliases: ["TSType"],
        visitor: ["typeAnnotation"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSRestType", {
        aliases: ["TSType"],
        visitor: ["typeAnnotation"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSNamedTupleMember", {
        visitor: ["label", "elementType"],
        builder: ["label", "elementType", "optional"],
        fields: {
          label: (0, _utils.validateType)("Identifier"),
          optional: {
            validate: bool,
            default: false
          },
          elementType: (0, _utils.validateType)("TSType")
        }
      });
      var unionOrIntersection = {
        aliases: ["TSType"],
        visitor: ["types"],
        fields: {
          types: (0, _utils.validateArrayOfType)("TSType")
        }
      };
      defineType("TSUnionType", unionOrIntersection);
      defineType("TSIntersectionType", unionOrIntersection);
      defineType("TSConditionalType", {
        aliases: ["TSType"],
        visitor: ["checkType", "extendsType", "trueType", "falseType"],
        fields: {
          checkType: (0, _utils.validateType)("TSType"),
          extendsType: (0, _utils.validateType)("TSType"),
          trueType: (0, _utils.validateType)("TSType"),
          falseType: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSInferType", {
        aliases: ["TSType"],
        visitor: ["typeParameter"],
        fields: {
          typeParameter: (0, _utils.validateType)("TSTypeParameter")
        }
      });
      defineType("TSParenthesizedType", {
        aliases: ["TSType"],
        visitor: ["typeAnnotation"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSTypeOperator", {
        aliases: ["TSType"],
        visitor: ["typeAnnotation"],
        builder: ["typeAnnotation", "operator"],
        fields: {
          operator: {
            validate: (0, _utils.assertValueType)("string"),
            default: "keyof"
          },
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSIndexedAccessType", {
        aliases: ["TSType"],
        visitor: ["objectType", "indexType"],
        fields: {
          objectType: (0, _utils.validateType)("TSType"),
          indexType: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSMappedType", {
        aliases: ["TSType"],
        visitor: ["typeParameter", "nameType", "typeAnnotation"],
        builder: ["typeParameter", "typeAnnotation", "nameType"],
        fields: Object.assign({}, {
          typeParameter: (0, _utils.validateType)("TSTypeParameter")
        }, {
          readonly: (0, _utils.validateOptional)((0, _utils.assertOneOf)(true, false, "+", "-")),
          optional: (0, _utils.validateOptional)((0, _utils.assertOneOf)(true, false, "+", "-")),
          typeAnnotation: (0, _utils.validateOptionalType)("TSType"),
          nameType: (0, _utils.validateOptionalType)("TSType")
        })
      });
      defineType("TSTemplateLiteralType", {
        aliases: ["TSType", "TSBaseType"],
        visitor: ["quasis", "types"],
        fields: {
          quasis: (0, _utils.validateArrayOfType)("TemplateElement"),
          types: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("TSType")), function(node, key, val) {
              if (node.quasis.length !== val.length + 1) {
                throw new TypeError(`Number of ${node.type} quasis should be exactly one more than the number of types.
Expected ${val.length + 1} quasis but got ${node.quasis.length}`);
              }
            })
          }
        }
      });
      defineType("TSLiteralType", {
        aliases: ["TSType", "TSBaseType"],
        visitor: ["literal"],
        fields: {
          literal: {
            validate: function() {
              const unaryExpression = (0, _utils.assertNodeType)("NumericLiteral", "BigIntLiteral");
              const unaryOperator = (0, _utils.assertOneOf)("-");
              const literal = (0, _utils.assertNodeType)("NumericLiteral", "StringLiteral", "BooleanLiteral", "BigIntLiteral", "TemplateLiteral");
              function validator(parent2, key, node) {
                if ((0, _is.default)("UnaryExpression", node)) {
                  unaryOperator(node, "operator", node.operator);
                  unaryExpression(node, "argument", node.argument);
                } else {
                  literal(parent2, key, node);
                }
              }
              validator.oneOfNodeTypes = ["NumericLiteral", "StringLiteral", "BooleanLiteral", "BigIntLiteral", "TemplateLiteral", "UnaryExpression"];
              return validator;
            }()
          }
        }
      });
      {
        defineType("TSExpressionWithTypeArguments", {
          aliases: ["TSType"],
          visitor: ["expression", "typeParameters"],
          fields: {
            expression: (0, _utils.validateType)("TSEntityName"),
            typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
          }
        });
      }
      defineType("TSInterfaceDeclaration", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "typeParameters", "extends", "body"],
        fields: {
          declare: (0, _utils.validateOptional)(bool),
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterDeclaration"),
          extends: (0, _utils.validateOptional)((0, _utils.arrayOfType)("TSExpressionWithTypeArguments")),
          body: (0, _utils.validateType)("TSInterfaceBody")
        }
      });
      defineType("TSInterfaceBody", {
        visitor: ["body"],
        fields: {
          body: (0, _utils.validateArrayOfType)("TSTypeElement")
        }
      });
      defineType("TSTypeAliasDeclaration", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "typeParameters", "typeAnnotation"],
        fields: {
          declare: (0, _utils.validateOptional)(bool),
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterDeclaration"),
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSInstantiationExpression", {
        aliases: ["Expression"],
        visitor: ["expression", "typeParameters"],
        fields: {
          expression: (0, _utils.validateType)("Expression"),
          ["typeParameters"]: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
        }
      });
      var TSTypeExpression = {
        aliases: ["Expression", "LVal", "PatternLike"],
        visitor: ["expression", "typeAnnotation"],
        fields: {
          expression: (0, _utils.validateType)("Expression"),
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      };
      defineType("TSAsExpression", TSTypeExpression);
      defineType("TSSatisfiesExpression", TSTypeExpression);
      defineType("TSTypeAssertion", {
        aliases: ["Expression", "LVal", "PatternLike"],
        visitor: ["typeAnnotation", "expression"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("TSType"),
          expression: (0, _utils.validateType)("Expression")
        }
      });
      defineType("TSEnumBody", {
        visitor: ["members"],
        fields: {
          members: (0, _utils.validateArrayOfType)("TSEnumMember")
        }
      });
      {
        defineType("TSEnumDeclaration", {
          aliases: ["Statement", "Declaration"],
          visitor: ["id", "members"],
          fields: {
            declare: (0, _utils.validateOptional)(bool),
            const: (0, _utils.validateOptional)(bool),
            id: (0, _utils.validateType)("Identifier"),
            members: (0, _utils.validateArrayOfType)("TSEnumMember"),
            initializer: (0, _utils.validateOptionalType)("Expression"),
            body: (0, _utils.validateOptionalType)("TSEnumBody")
          }
        });
      }
      defineType("TSEnumMember", {
        visitor: ["id", "initializer"],
        fields: {
          id: (0, _utils.validateType)("Identifier", "StringLiteral"),
          initializer: (0, _utils.validateOptionalType)("Expression")
        }
      });
      defineType("TSModuleDeclaration", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "body"],
        fields: Object.assign({
          kind: {
            validate: (0, _utils.assertOneOf)("global", "module", "namespace")
          },
          declare: (0, _utils.validateOptional)(bool)
        }, {
          global: (0, _utils.validateOptional)(bool)
        }, {
          id: (0, _utils.validateType)("Identifier", "StringLiteral"),
          body: (0, _utils.validateType)("TSModuleBlock", "TSModuleDeclaration")
        })
      });
      defineType("TSModuleBlock", {
        aliases: ["Scopable", "Block", "BlockParent", "FunctionParent"],
        visitor: ["body"],
        fields: {
          body: (0, _utils.validateArrayOfType)("Statement")
        }
      });
      defineType("TSImportType", {
        aliases: ["TSType"],
        builder: ["argument", "qualifier", "typeParameters"],
        visitor: ["argument", "options", "qualifier", "typeParameters"],
        fields: {
          argument: (0, _utils.validateType)("StringLiteral"),
          qualifier: (0, _utils.validateOptionalType)("TSEntityName"),
          ["typeParameters"]: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation"),
          options: {
            validate: (0, _utils.assertNodeType)("ObjectExpression"),
            optional: true
          }
        }
      });
      defineType("TSImportEqualsDeclaration", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "moduleReference"],
        fields: Object.assign({}, {
          isExport: (0, _utils.validate)(bool)
        }, {
          id: (0, _utils.validateType)("Identifier"),
          moduleReference: (0, _utils.validateType)("TSEntityName", "TSExternalModuleReference"),
          importKind: {
            validate: (0, _utils.assertOneOf)("type", "value"),
            optional: true
          }
        })
      });
      defineType("TSExternalModuleReference", {
        visitor: ["expression"],
        fields: {
          expression: (0, _utils.validateType)("StringLiteral")
        }
      });
      defineType("TSNonNullExpression", {
        aliases: ["Expression", "LVal", "PatternLike"],
        visitor: ["expression"],
        fields: {
          expression: (0, _utils.validateType)("Expression")
        }
      });
      defineType("TSExportAssignment", {
        aliases: ["Statement"],
        visitor: ["expression"],
        fields: {
          expression: (0, _utils.validateType)("Expression")
        }
      });
      defineType("TSNamespaceExportDeclaration", {
        aliases: ["Statement"],
        visitor: ["id"],
        fields: {
          id: (0, _utils.validateType)("Identifier")
        }
      });
      defineType("TSTypeAnnotation", {
        visitor: ["typeAnnotation"],
        fields: {
          typeAnnotation: {
            validate: (0, _utils.assertNodeType)("TSType")
          }
        }
      });
      defineType("TSTypeParameterInstantiation", {
        visitor: ["params"],
        fields: {
          params: (0, _utils.validateArrayOfType)("TSType")
        }
      });
      defineType("TSTypeParameterDeclaration", {
        visitor: ["params"],
        fields: {
          params: (0, _utils.validateArrayOfType)("TSTypeParameter")
        }
      });
      defineType("TSTypeParameter", {
        builder: ["constraint", "default", "name"],
        visitor: ["constraint", "default"],
        fields: {
          name: {
            validate: (0, _utils.assertValueType)("string")
          },
          in: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          out: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          const: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          constraint: {
            validate: (0, _utils.assertNodeType)("TSType"),
            optional: true
          },
          default: {
            validate: (0, _utils.assertNodeType)("TSType"),
            optional: true
          }
        }
      });
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/deprecated-aliases.js
  var require_deprecated_aliases = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/deprecated-aliases.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.DEPRECATED_ALIASES = void 0;
      var DEPRECATED_ALIASES = exports8.DEPRECATED_ALIASES = {
        ModuleDeclaration: "ImportOrExportDeclaration"
      };
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/index.js
  var require_definitions = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/definitions/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      Object.defineProperty(exports8, "ALIAS_KEYS", {
        enumerable: true,
        get: function() {
          return _utils.ALIAS_KEYS;
        }
      });
      Object.defineProperty(exports8, "BUILDER_KEYS", {
        enumerable: true,
        get: function() {
          return _utils.BUILDER_KEYS;
        }
      });
      Object.defineProperty(exports8, "DEPRECATED_ALIASES", {
        enumerable: true,
        get: function() {
          return _deprecatedAliases.DEPRECATED_ALIASES;
        }
      });
      Object.defineProperty(exports8, "DEPRECATED_KEYS", {
        enumerable: true,
        get: function() {
          return _utils.DEPRECATED_KEYS;
        }
      });
      Object.defineProperty(exports8, "FLIPPED_ALIAS_KEYS", {
        enumerable: true,
        get: function() {
          return _utils.FLIPPED_ALIAS_KEYS;
        }
      });
      Object.defineProperty(exports8, "NODE_FIELDS", {
        enumerable: true,
        get: function() {
          return _utils.NODE_FIELDS;
        }
      });
      Object.defineProperty(exports8, "NODE_PARENT_VALIDATIONS", {
        enumerable: true,
        get: function() {
          return _utils.NODE_PARENT_VALIDATIONS;
        }
      });
      Object.defineProperty(exports8, "PLACEHOLDERS", {
        enumerable: true,
        get: function() {
          return _placeholders.PLACEHOLDERS;
        }
      });
      Object.defineProperty(exports8, "PLACEHOLDERS_ALIAS", {
        enumerable: true,
        get: function() {
          return _placeholders.PLACEHOLDERS_ALIAS;
        }
      });
      Object.defineProperty(exports8, "PLACEHOLDERS_FLIPPED_ALIAS", {
        enumerable: true,
        get: function() {
          return _placeholders.PLACEHOLDERS_FLIPPED_ALIAS;
        }
      });
      exports8.TYPES = void 0;
      Object.defineProperty(exports8, "VISITOR_KEYS", {
        enumerable: true,
        get: function() {
          return _utils.VISITOR_KEYS;
        }
      });
      require_core();
      require_flow();
      require_jsx();
      require_misc();
      require_experimental();
      require_typescript();
      var _utils = require_utils3();
      var _placeholders = require_placeholders();
      var _deprecatedAliases = require_deprecated_aliases();
      Object.keys(_deprecatedAliases.DEPRECATED_ALIASES).forEach((deprecatedAlias) => {
        _utils.FLIPPED_ALIAS_KEYS[deprecatedAlias] = _utils.FLIPPED_ALIAS_KEYS[_deprecatedAliases.DEPRECATED_ALIASES[deprecatedAlias]];
      });
      for (const {
        types: types2,
        set: set2
      } of _utils.allExpandedTypes) {
        for (const type of types2) {
          const aliases = _utils.FLIPPED_ALIAS_KEYS[type];
          if (aliases) {
            aliases.forEach(set2.add, set2);
          } else {
            set2.add(type);
          }
        }
      }
      var TYPES = exports8.TYPES = [].concat(Object.keys(_utils.VISITOR_KEYS), Object.keys(_utils.FLIPPED_ALIAS_KEYS), Object.keys(_utils.DEPRECATED_KEYS));
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/validate.js
  var require_validate = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/validate.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = validate;
      exports8.validateChild = validateChild;
      exports8.validateField = validateField;
      exports8.validateInternal = validateInternal;
      var _index = require_definitions();
      function validate(node, key, val) {
        if (!node)
          return;
        const fields = _index.NODE_FIELDS[node.type];
        if (!fields)
          return;
        const field = fields[key];
        validateField(node, key, val, field);
        validateChild(node, key, val);
      }
      function validateInternal(field, node, key, val, maybeNode) {
        if (!(field != null && field.validate))
          return;
        if (field.optional && val == null)
          return;
        field.validate(node, key, val);
        if (maybeNode) {
          var _NODE_PARENT_VALIDATI;
          const type = val.type;
          if (type == null)
            return;
          (_NODE_PARENT_VALIDATI = _index.NODE_PARENT_VALIDATIONS[type]) == null || _NODE_PARENT_VALIDATI.call(_index.NODE_PARENT_VALIDATIONS, node, key, val);
        }
      }
      function validateField(node, key, val, field) {
        if (!(field != null && field.validate))
          return;
        if (field.optional && val == null)
          return;
        field.validate(node, key, val);
      }
      function validateChild(node, key, val) {
        var _NODE_PARENT_VALIDATI2;
        const type = val == null ? void 0 : val.type;
        if (type == null)
          return;
        (_NODE_PARENT_VALIDATI2 = _index.NODE_PARENT_VALIDATIONS[type]) == null || _NODE_PARENT_VALIDATI2.call(_index.NODE_PARENT_VALIDATIONS, node, key, val);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/generated/lowercase.js
  var require_lowercase = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/generated/lowercase.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.anyTypeAnnotation = anyTypeAnnotation;
      exports8.argumentPlaceholder = argumentPlaceholder;
      exports8.arrayExpression = arrayExpression;
      exports8.arrayPattern = arrayPattern;
      exports8.arrayTypeAnnotation = arrayTypeAnnotation;
      exports8.arrowFunctionExpression = arrowFunctionExpression2;
      exports8.assignmentExpression = assignmentExpression;
      exports8.assignmentPattern = assignmentPattern;
      exports8.awaitExpression = awaitExpression;
      exports8.bigIntLiteral = bigIntLiteral;
      exports8.binaryExpression = binaryExpression;
      exports8.bindExpression = bindExpression;
      exports8.blockStatement = blockStatement;
      exports8.booleanLiteral = booleanLiteral;
      exports8.booleanLiteralTypeAnnotation = booleanLiteralTypeAnnotation;
      exports8.booleanTypeAnnotation = booleanTypeAnnotation;
      exports8.breakStatement = breakStatement;
      exports8.callExpression = callExpression;
      exports8.catchClause = catchClause;
      exports8.classAccessorProperty = classAccessorProperty;
      exports8.classBody = classBody;
      exports8.classDeclaration = classDeclaration;
      exports8.classExpression = classExpression;
      exports8.classImplements = classImplements;
      exports8.classMethod = classMethod2;
      exports8.classPrivateMethod = classPrivateMethod;
      exports8.classPrivateProperty = classPrivateProperty;
      exports8.classProperty = classProperty;
      exports8.conditionalExpression = conditionalExpression;
      exports8.continueStatement = continueStatement;
      exports8.debuggerStatement = debuggerStatement;
      exports8.decimalLiteral = decimalLiteral;
      exports8.declareClass = declareClass;
      exports8.declareExportAllDeclaration = declareExportAllDeclaration;
      exports8.declareExportDeclaration = declareExportDeclaration;
      exports8.declareFunction = declareFunction;
      exports8.declareInterface = declareInterface;
      exports8.declareModule = declareModule;
      exports8.declareModuleExports = declareModuleExports;
      exports8.declareOpaqueType = declareOpaqueType;
      exports8.declareTypeAlias = declareTypeAlias;
      exports8.declareVariable = declareVariable;
      exports8.declaredPredicate = declaredPredicate;
      exports8.decorator = decorator;
      exports8.directive = directive;
      exports8.directiveLiteral = directiveLiteral;
      exports8.doExpression = doExpression;
      exports8.doWhileStatement = doWhileStatement;
      exports8.emptyStatement = emptyStatement;
      exports8.emptyTypeAnnotation = emptyTypeAnnotation;
      exports8.enumBooleanBody = enumBooleanBody;
      exports8.enumBooleanMember = enumBooleanMember;
      exports8.enumDeclaration = enumDeclaration;
      exports8.enumDefaultedMember = enumDefaultedMember;
      exports8.enumNumberBody = enumNumberBody;
      exports8.enumNumberMember = enumNumberMember;
      exports8.enumStringBody = enumStringBody;
      exports8.enumStringMember = enumStringMember;
      exports8.enumSymbolBody = enumSymbolBody;
      exports8.existsTypeAnnotation = existsTypeAnnotation;
      exports8.exportAllDeclaration = exportAllDeclaration;
      exports8.exportDefaultDeclaration = exportDefaultDeclaration;
      exports8.exportDefaultSpecifier = exportDefaultSpecifier;
      exports8.exportNamedDeclaration = exportNamedDeclaration;
      exports8.exportNamespaceSpecifier = exportNamespaceSpecifier;
      exports8.exportSpecifier = exportSpecifier;
      exports8.expressionStatement = expressionStatement2;
      exports8.file = file2;
      exports8.forInStatement = forInStatement;
      exports8.forOfStatement = forOfStatement;
      exports8.forStatement = forStatement;
      exports8.functionDeclaration = functionDeclaration;
      exports8.functionExpression = functionExpression;
      exports8.functionTypeAnnotation = functionTypeAnnotation;
      exports8.functionTypeParam = functionTypeParam;
      exports8.genericTypeAnnotation = genericTypeAnnotation;
      exports8.identifier = identifier3;
      exports8.ifStatement = ifStatement;
      exports8.import = _import;
      exports8.importAttribute = importAttribute;
      exports8.importDeclaration = importDeclaration;
      exports8.importDefaultSpecifier = importDefaultSpecifier;
      exports8.importExpression = importExpression;
      exports8.importNamespaceSpecifier = importNamespaceSpecifier;
      exports8.importSpecifier = importSpecifier;
      exports8.indexedAccessType = indexedAccessType;
      exports8.inferredPredicate = inferredPredicate;
      exports8.interfaceDeclaration = interfaceDeclaration;
      exports8.interfaceExtends = interfaceExtends;
      exports8.interfaceTypeAnnotation = interfaceTypeAnnotation;
      exports8.interpreterDirective = interpreterDirective;
      exports8.intersectionTypeAnnotation = intersectionTypeAnnotation;
      exports8.jSXAttribute = exports8.jsxAttribute = jsxAttribute;
      exports8.jSXClosingElement = exports8.jsxClosingElement = jsxClosingElement;
      exports8.jSXClosingFragment = exports8.jsxClosingFragment = jsxClosingFragment;
      exports8.jSXElement = exports8.jsxElement = jsxElement;
      exports8.jSXEmptyExpression = exports8.jsxEmptyExpression = jsxEmptyExpression;
      exports8.jSXExpressionContainer = exports8.jsxExpressionContainer = jsxExpressionContainer;
      exports8.jSXFragment = exports8.jsxFragment = jsxFragment;
      exports8.jSXIdentifier = exports8.jsxIdentifier = jsxIdentifier;
      exports8.jSXMemberExpression = exports8.jsxMemberExpression = jsxMemberExpression;
      exports8.jSXNamespacedName = exports8.jsxNamespacedName = jsxNamespacedName;
      exports8.jSXOpeningElement = exports8.jsxOpeningElement = jsxOpeningElement;
      exports8.jSXOpeningFragment = exports8.jsxOpeningFragment = jsxOpeningFragment;
      exports8.jSXSpreadAttribute = exports8.jsxSpreadAttribute = jsxSpreadAttribute;
      exports8.jSXSpreadChild = exports8.jsxSpreadChild = jsxSpreadChild;
      exports8.jSXText = exports8.jsxText = jsxText;
      exports8.labeledStatement = labeledStatement;
      exports8.logicalExpression = logicalExpression;
      exports8.memberExpression = memberExpression;
      exports8.metaProperty = metaProperty;
      exports8.mixedTypeAnnotation = mixedTypeAnnotation;
      exports8.moduleExpression = moduleExpression;
      exports8.newExpression = newExpression;
      exports8.noop = noop5;
      exports8.nullLiteral = nullLiteral;
      exports8.nullLiteralTypeAnnotation = nullLiteralTypeAnnotation;
      exports8.nullableTypeAnnotation = nullableTypeAnnotation;
      exports8.numberLiteral = NumberLiteral;
      exports8.numberLiteralTypeAnnotation = numberLiteralTypeAnnotation;
      exports8.numberTypeAnnotation = numberTypeAnnotation;
      exports8.numericLiteral = numericLiteral;
      exports8.objectExpression = objectExpression;
      exports8.objectMethod = objectMethod;
      exports8.objectPattern = objectPattern;
      exports8.objectProperty = objectProperty;
      exports8.objectTypeAnnotation = objectTypeAnnotation;
      exports8.objectTypeCallProperty = objectTypeCallProperty;
      exports8.objectTypeIndexer = objectTypeIndexer;
      exports8.objectTypeInternalSlot = objectTypeInternalSlot;
      exports8.objectTypeProperty = objectTypeProperty;
      exports8.objectTypeSpreadProperty = objectTypeSpreadProperty;
      exports8.opaqueType = opaqueType;
      exports8.optionalCallExpression = optionalCallExpression;
      exports8.optionalIndexedAccessType = optionalIndexedAccessType;
      exports8.optionalMemberExpression = optionalMemberExpression;
      exports8.parenthesizedExpression = parenthesizedExpression;
      exports8.pipelineBareFunction = pipelineBareFunction;
      exports8.pipelinePrimaryTopicReference = pipelinePrimaryTopicReference;
      exports8.pipelineTopicExpression = pipelineTopicExpression;
      exports8.placeholder = placeholder;
      exports8.privateName = privateName;
      exports8.program = program3;
      exports8.qualifiedTypeIdentifier = qualifiedTypeIdentifier;
      exports8.recordExpression = recordExpression;
      exports8.regExpLiteral = regExpLiteral;
      exports8.regexLiteral = RegexLiteral;
      exports8.restElement = restElement;
      exports8.restProperty = RestProperty;
      exports8.returnStatement = returnStatement;
      exports8.sequenceExpression = sequenceExpression;
      exports8.spreadElement = spreadElement;
      exports8.spreadProperty = SpreadProperty;
      exports8.staticBlock = staticBlock;
      exports8.stringLiteral = stringLiteral;
      exports8.stringLiteralTypeAnnotation = stringLiteralTypeAnnotation;
      exports8.stringTypeAnnotation = stringTypeAnnotation;
      exports8.super = _super;
      exports8.switchCase = switchCase;
      exports8.switchStatement = switchStatement;
      exports8.symbolTypeAnnotation = symbolTypeAnnotation;
      exports8.taggedTemplateExpression = taggedTemplateExpression;
      exports8.templateElement = templateElement;
      exports8.templateLiteral = templateLiteral;
      exports8.thisExpression = thisExpression;
      exports8.thisTypeAnnotation = thisTypeAnnotation;
      exports8.throwStatement = throwStatement;
      exports8.topicReference = topicReference;
      exports8.tryStatement = tryStatement;
      exports8.tSAnyKeyword = exports8.tsAnyKeyword = tsAnyKeyword;
      exports8.tSArrayType = exports8.tsArrayType = tsArrayType;
      exports8.tSAsExpression = exports8.tsAsExpression = tsAsExpression;
      exports8.tSBigIntKeyword = exports8.tsBigIntKeyword = tsBigIntKeyword;
      exports8.tSBooleanKeyword = exports8.tsBooleanKeyword = tsBooleanKeyword;
      exports8.tSCallSignatureDeclaration = exports8.tsCallSignatureDeclaration = tsCallSignatureDeclaration;
      exports8.tSConditionalType = exports8.tsConditionalType = tsConditionalType;
      exports8.tSConstructSignatureDeclaration = exports8.tsConstructSignatureDeclaration = tsConstructSignatureDeclaration;
      exports8.tSConstructorType = exports8.tsConstructorType = tsConstructorType;
      exports8.tSDeclareFunction = exports8.tsDeclareFunction = tsDeclareFunction;
      exports8.tSDeclareMethod = exports8.tsDeclareMethod = tsDeclareMethod;
      exports8.tSEnumBody = exports8.tsEnumBody = tsEnumBody;
      exports8.tSEnumDeclaration = exports8.tsEnumDeclaration = tsEnumDeclaration;
      exports8.tSEnumMember = exports8.tsEnumMember = tsEnumMember;
      exports8.tSExportAssignment = exports8.tsExportAssignment = tsExportAssignment;
      exports8.tSExpressionWithTypeArguments = exports8.tsExpressionWithTypeArguments = tsExpressionWithTypeArguments;
      exports8.tSExternalModuleReference = exports8.tsExternalModuleReference = tsExternalModuleReference;
      exports8.tSFunctionType = exports8.tsFunctionType = tsFunctionType;
      exports8.tSImportEqualsDeclaration = exports8.tsImportEqualsDeclaration = tsImportEqualsDeclaration;
      exports8.tSImportType = exports8.tsImportType = tsImportType;
      exports8.tSIndexSignature = exports8.tsIndexSignature = tsIndexSignature;
      exports8.tSIndexedAccessType = exports8.tsIndexedAccessType = tsIndexedAccessType;
      exports8.tSInferType = exports8.tsInferType = tsInferType;
      exports8.tSInstantiationExpression = exports8.tsInstantiationExpression = tsInstantiationExpression;
      exports8.tSInterfaceBody = exports8.tsInterfaceBody = tsInterfaceBody;
      exports8.tSInterfaceDeclaration = exports8.tsInterfaceDeclaration = tsInterfaceDeclaration;
      exports8.tSIntersectionType = exports8.tsIntersectionType = tsIntersectionType;
      exports8.tSIntrinsicKeyword = exports8.tsIntrinsicKeyword = tsIntrinsicKeyword;
      exports8.tSLiteralType = exports8.tsLiteralType = tsLiteralType;
      exports8.tSMappedType = exports8.tsMappedType = tsMappedType;
      exports8.tSMethodSignature = exports8.tsMethodSignature = tsMethodSignature;
      exports8.tSModuleBlock = exports8.tsModuleBlock = tsModuleBlock;
      exports8.tSModuleDeclaration = exports8.tsModuleDeclaration = tsModuleDeclaration;
      exports8.tSNamedTupleMember = exports8.tsNamedTupleMember = tsNamedTupleMember;
      exports8.tSNamespaceExportDeclaration = exports8.tsNamespaceExportDeclaration = tsNamespaceExportDeclaration;
      exports8.tSNeverKeyword = exports8.tsNeverKeyword = tsNeverKeyword;
      exports8.tSNonNullExpression = exports8.tsNonNullExpression = tsNonNullExpression;
      exports8.tSNullKeyword = exports8.tsNullKeyword = tsNullKeyword;
      exports8.tSNumberKeyword = exports8.tsNumberKeyword = tsNumberKeyword;
      exports8.tSObjectKeyword = exports8.tsObjectKeyword = tsObjectKeyword;
      exports8.tSOptionalType = exports8.tsOptionalType = tsOptionalType;
      exports8.tSParameterProperty = exports8.tsParameterProperty = tsParameterProperty;
      exports8.tSParenthesizedType = exports8.tsParenthesizedType = tsParenthesizedType;
      exports8.tSPropertySignature = exports8.tsPropertySignature = tsPropertySignature;
      exports8.tSQualifiedName = exports8.tsQualifiedName = tsQualifiedName;
      exports8.tSRestType = exports8.tsRestType = tsRestType;
      exports8.tSSatisfiesExpression = exports8.tsSatisfiesExpression = tsSatisfiesExpression;
      exports8.tSStringKeyword = exports8.tsStringKeyword = tsStringKeyword;
      exports8.tSSymbolKeyword = exports8.tsSymbolKeyword = tsSymbolKeyword;
      exports8.tSTemplateLiteralType = exports8.tsTemplateLiteralType = tsTemplateLiteralType;
      exports8.tSThisType = exports8.tsThisType = tsThisType;
      exports8.tSTupleType = exports8.tsTupleType = tsTupleType;
      exports8.tSTypeAliasDeclaration = exports8.tsTypeAliasDeclaration = tsTypeAliasDeclaration;
      exports8.tSTypeAnnotation = exports8.tsTypeAnnotation = tsTypeAnnotation;
      exports8.tSTypeAssertion = exports8.tsTypeAssertion = tsTypeAssertion;
      exports8.tSTypeLiteral = exports8.tsTypeLiteral = tsTypeLiteral;
      exports8.tSTypeOperator = exports8.tsTypeOperator = tsTypeOperator;
      exports8.tSTypeParameter = exports8.tsTypeParameter = tsTypeParameter;
      exports8.tSTypeParameterDeclaration = exports8.tsTypeParameterDeclaration = tsTypeParameterDeclaration;
      exports8.tSTypeParameterInstantiation = exports8.tsTypeParameterInstantiation = tsTypeParameterInstantiation;
      exports8.tSTypePredicate = exports8.tsTypePredicate = tsTypePredicate;
      exports8.tSTypeQuery = exports8.tsTypeQuery = tsTypeQuery;
      exports8.tSTypeReference = exports8.tsTypeReference = tsTypeReference;
      exports8.tSUndefinedKeyword = exports8.tsUndefinedKeyword = tsUndefinedKeyword;
      exports8.tSUnionType = exports8.tsUnionType = tsUnionType;
      exports8.tSUnknownKeyword = exports8.tsUnknownKeyword = tsUnknownKeyword;
      exports8.tSVoidKeyword = exports8.tsVoidKeyword = tsVoidKeyword;
      exports8.tupleExpression = tupleExpression;
      exports8.tupleTypeAnnotation = tupleTypeAnnotation;
      exports8.typeAlias = typeAlias;
      exports8.typeAnnotation = typeAnnotation;
      exports8.typeCastExpression = typeCastExpression;
      exports8.typeParameter = typeParameter;
      exports8.typeParameterDeclaration = typeParameterDeclaration;
      exports8.typeParameterInstantiation = typeParameterInstantiation;
      exports8.typeofTypeAnnotation = typeofTypeAnnotation;
      exports8.unaryExpression = unaryExpression;
      exports8.unionTypeAnnotation = unionTypeAnnotation;
      exports8.updateExpression = updateExpression;
      exports8.v8IntrinsicIdentifier = v8IntrinsicIdentifier;
      exports8.variableDeclaration = variableDeclaration;
      exports8.variableDeclarator = variableDeclarator;
      exports8.variance = variance;
      exports8.voidPattern = voidPattern;
      exports8.voidTypeAnnotation = voidTypeAnnotation;
      exports8.whileStatement = whileStatement;
      exports8.withStatement = withStatement;
      exports8.yieldExpression = yieldExpression;
      var _validate = require_validate();
      var _deprecationWarning = require_deprecationWarning();
      var utils = require_utils3();
      var {
        validateInternal: validate
      } = _validate;
      var {
        NODE_FIELDS
      } = utils;
      function bigIntLiteral(value) {
        if (typeof value === "bigint") {
          value = value.toString();
        }
        const node = {
          type: "BigIntLiteral",
          value
        };
        const defs = NODE_FIELDS.BigIntLiteral;
        validate(defs.value, node, "value", value);
        return node;
      }
      function arrayExpression(elements = []) {
        const node = {
          type: "ArrayExpression",
          elements
        };
        const defs = NODE_FIELDS.ArrayExpression;
        validate(defs.elements, node, "elements", elements, 1);
        return node;
      }
      function assignmentExpression(operator, left, right) {
        const node = {
          type: "AssignmentExpression",
          operator,
          left,
          right
        };
        const defs = NODE_FIELDS.AssignmentExpression;
        validate(defs.operator, node, "operator", operator);
        validate(defs.left, node, "left", left, 1);
        validate(defs.right, node, "right", right, 1);
        return node;
      }
      function binaryExpression(operator, left, right) {
        const node = {
          type: "BinaryExpression",
          operator,
          left,
          right
        };
        const defs = NODE_FIELDS.BinaryExpression;
        validate(defs.operator, node, "operator", operator);
        validate(defs.left, node, "left", left, 1);
        validate(defs.right, node, "right", right, 1);
        return node;
      }
      function interpreterDirective(value) {
        const node = {
          type: "InterpreterDirective",
          value
        };
        const defs = NODE_FIELDS.InterpreterDirective;
        validate(defs.value, node, "value", value);
        return node;
      }
      function directive(value) {
        const node = {
          type: "Directive",
          value
        };
        const defs = NODE_FIELDS.Directive;
        validate(defs.value, node, "value", value, 1);
        return node;
      }
      function directiveLiteral(value) {
        const node = {
          type: "DirectiveLiteral",
          value
        };
        const defs = NODE_FIELDS.DirectiveLiteral;
        validate(defs.value, node, "value", value);
        return node;
      }
      function blockStatement(body, directives = []) {
        const node = {
          type: "BlockStatement",
          body,
          directives
        };
        const defs = NODE_FIELDS.BlockStatement;
        validate(defs.body, node, "body", body, 1);
        validate(defs.directives, node, "directives", directives, 1);
        return node;
      }
      function breakStatement(label = null) {
        const node = {
          type: "BreakStatement",
          label
        };
        const defs = NODE_FIELDS.BreakStatement;
        validate(defs.label, node, "label", label, 1);
        return node;
      }
      function callExpression(callee, _arguments) {
        const node = {
          type: "CallExpression",
          callee,
          arguments: _arguments
        };
        const defs = NODE_FIELDS.CallExpression;
        validate(defs.callee, node, "callee", callee, 1);
        validate(defs.arguments, node, "arguments", _arguments, 1);
        return node;
      }
      function catchClause(param = null, body) {
        const node = {
          type: "CatchClause",
          param,
          body
        };
        const defs = NODE_FIELDS.CatchClause;
        validate(defs.param, node, "param", param, 1);
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function conditionalExpression(test, consequent, alternate) {
        const node = {
          type: "ConditionalExpression",
          test,
          consequent,
          alternate
        };
        const defs = NODE_FIELDS.ConditionalExpression;
        validate(defs.test, node, "test", test, 1);
        validate(defs.consequent, node, "consequent", consequent, 1);
        validate(defs.alternate, node, "alternate", alternate, 1);
        return node;
      }
      function continueStatement(label = null) {
        const node = {
          type: "ContinueStatement",
          label
        };
        const defs = NODE_FIELDS.ContinueStatement;
        validate(defs.label, node, "label", label, 1);
        return node;
      }
      function debuggerStatement() {
        return {
          type: "DebuggerStatement"
        };
      }
      function doWhileStatement(test, body) {
        const node = {
          type: "DoWhileStatement",
          test,
          body
        };
        const defs = NODE_FIELDS.DoWhileStatement;
        validate(defs.test, node, "test", test, 1);
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function emptyStatement() {
        return {
          type: "EmptyStatement"
        };
      }
      function expressionStatement2(expression) {
        const node = {
          type: "ExpressionStatement",
          expression
        };
        const defs = NODE_FIELDS.ExpressionStatement;
        validate(defs.expression, node, "expression", expression, 1);
        return node;
      }
      function file2(program4, comments = null, tokens = null) {
        const node = {
          type: "File",
          program: program4,
          comments,
          tokens
        };
        const defs = NODE_FIELDS.File;
        validate(defs.program, node, "program", program4, 1);
        validate(defs.comments, node, "comments", comments, 1);
        validate(defs.tokens, node, "tokens", tokens);
        return node;
      }
      function forInStatement(left, right, body) {
        const node = {
          type: "ForInStatement",
          left,
          right,
          body
        };
        const defs = NODE_FIELDS.ForInStatement;
        validate(defs.left, node, "left", left, 1);
        validate(defs.right, node, "right", right, 1);
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function forStatement(init = null, test = null, update2 = null, body) {
        const node = {
          type: "ForStatement",
          init,
          test,
          update: update2,
          body
        };
        const defs = NODE_FIELDS.ForStatement;
        validate(defs.init, node, "init", init, 1);
        validate(defs.test, node, "test", test, 1);
        validate(defs.update, node, "update", update2, 1);
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function functionDeclaration(id = null, params, body, generator = false, async = false) {
        const node = {
          type: "FunctionDeclaration",
          id,
          params,
          body,
          generator,
          async
        };
        const defs = NODE_FIELDS.FunctionDeclaration;
        validate(defs.id, node, "id", id, 1);
        validate(defs.params, node, "params", params, 1);
        validate(defs.body, node, "body", body, 1);
        validate(defs.generator, node, "generator", generator);
        validate(defs.async, node, "async", async);
        return node;
      }
      function functionExpression(id = null, params, body, generator = false, async = false) {
        const node = {
          type: "FunctionExpression",
          id,
          params,
          body,
          generator,
          async
        };
        const defs = NODE_FIELDS.FunctionExpression;
        validate(defs.id, node, "id", id, 1);
        validate(defs.params, node, "params", params, 1);
        validate(defs.body, node, "body", body, 1);
        validate(defs.generator, node, "generator", generator);
        validate(defs.async, node, "async", async);
        return node;
      }
      function identifier3(name) {
        const node = {
          type: "Identifier",
          name
        };
        const defs = NODE_FIELDS.Identifier;
        validate(defs.name, node, "name", name);
        return node;
      }
      function ifStatement(test, consequent, alternate = null) {
        const node = {
          type: "IfStatement",
          test,
          consequent,
          alternate
        };
        const defs = NODE_FIELDS.IfStatement;
        validate(defs.test, node, "test", test, 1);
        validate(defs.consequent, node, "consequent", consequent, 1);
        validate(defs.alternate, node, "alternate", alternate, 1);
        return node;
      }
      function labeledStatement(label, body) {
        const node = {
          type: "LabeledStatement",
          label,
          body
        };
        const defs = NODE_FIELDS.LabeledStatement;
        validate(defs.label, node, "label", label, 1);
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function stringLiteral(value) {
        const node = {
          type: "StringLiteral",
          value
        };
        const defs = NODE_FIELDS.StringLiteral;
        validate(defs.value, node, "value", value);
        return node;
      }
      function numericLiteral(value) {
        const node = {
          type: "NumericLiteral",
          value
        };
        const defs = NODE_FIELDS.NumericLiteral;
        validate(defs.value, node, "value", value);
        return node;
      }
      function nullLiteral() {
        return {
          type: "NullLiteral"
        };
      }
      function booleanLiteral(value) {
        const node = {
          type: "BooleanLiteral",
          value
        };
        const defs = NODE_FIELDS.BooleanLiteral;
        validate(defs.value, node, "value", value);
        return node;
      }
      function regExpLiteral(pattern, flags = "") {
        const node = {
          type: "RegExpLiteral",
          pattern,
          flags
        };
        const defs = NODE_FIELDS.RegExpLiteral;
        validate(defs.pattern, node, "pattern", pattern);
        validate(defs.flags, node, "flags", flags);
        return node;
      }
      function logicalExpression(operator, left, right) {
        const node = {
          type: "LogicalExpression",
          operator,
          left,
          right
        };
        const defs = NODE_FIELDS.LogicalExpression;
        validate(defs.operator, node, "operator", operator);
        validate(defs.left, node, "left", left, 1);
        validate(defs.right, node, "right", right, 1);
        return node;
      }
      function memberExpression(object, property2, computed = false, optional = null) {
        const node = {
          type: "MemberExpression",
          object,
          property: property2,
          computed,
          optional
        };
        const defs = NODE_FIELDS.MemberExpression;
        validate(defs.object, node, "object", object, 1);
        validate(defs.property, node, "property", property2, 1);
        validate(defs.computed, node, "computed", computed);
        validate(defs.optional, node, "optional", optional);
        return node;
      }
      function newExpression(callee, _arguments) {
        const node = {
          type: "NewExpression",
          callee,
          arguments: _arguments
        };
        const defs = NODE_FIELDS.NewExpression;
        validate(defs.callee, node, "callee", callee, 1);
        validate(defs.arguments, node, "arguments", _arguments, 1);
        return node;
      }
      function program3(body, directives = [], sourceType = "script", interpreter = null) {
        const node = {
          type: "Program",
          body,
          directives,
          sourceType,
          interpreter
        };
        const defs = NODE_FIELDS.Program;
        validate(defs.body, node, "body", body, 1);
        validate(defs.directives, node, "directives", directives, 1);
        validate(defs.sourceType, node, "sourceType", sourceType);
        validate(defs.interpreter, node, "interpreter", interpreter, 1);
        return node;
      }
      function objectExpression(properties) {
        const node = {
          type: "ObjectExpression",
          properties
        };
        const defs = NODE_FIELDS.ObjectExpression;
        validate(defs.properties, node, "properties", properties, 1);
        return node;
      }
      function objectMethod(kind = "method", key, params, body, computed = false, generator = false, async = false) {
        const node = {
          type: "ObjectMethod",
          kind,
          key,
          params,
          body,
          computed,
          generator,
          async
        };
        const defs = NODE_FIELDS.ObjectMethod;
        validate(defs.kind, node, "kind", kind);
        validate(defs.key, node, "key", key, 1);
        validate(defs.params, node, "params", params, 1);
        validate(defs.body, node, "body", body, 1);
        validate(defs.computed, node, "computed", computed);
        validate(defs.generator, node, "generator", generator);
        validate(defs.async, node, "async", async);
        return node;
      }
      function objectProperty(key, value, computed = false, shorthand = false, decorators = null) {
        const node = {
          type: "ObjectProperty",
          key,
          value,
          computed,
          shorthand,
          decorators
        };
        const defs = NODE_FIELDS.ObjectProperty;
        validate(defs.key, node, "key", key, 1);
        validate(defs.value, node, "value", value, 1);
        validate(defs.computed, node, "computed", computed);
        validate(defs.shorthand, node, "shorthand", shorthand);
        validate(defs.decorators, node, "decorators", decorators, 1);
        return node;
      }
      function restElement(argument) {
        const node = {
          type: "RestElement",
          argument
        };
        const defs = NODE_FIELDS.RestElement;
        validate(defs.argument, node, "argument", argument, 1);
        return node;
      }
      function returnStatement(argument = null) {
        const node = {
          type: "ReturnStatement",
          argument
        };
        const defs = NODE_FIELDS.ReturnStatement;
        validate(defs.argument, node, "argument", argument, 1);
        return node;
      }
      function sequenceExpression(expressions) {
        const node = {
          type: "SequenceExpression",
          expressions
        };
        const defs = NODE_FIELDS.SequenceExpression;
        validate(defs.expressions, node, "expressions", expressions, 1);
        return node;
      }
      function parenthesizedExpression(expression) {
        const node = {
          type: "ParenthesizedExpression",
          expression
        };
        const defs = NODE_FIELDS.ParenthesizedExpression;
        validate(defs.expression, node, "expression", expression, 1);
        return node;
      }
      function switchCase(test = null, consequent) {
        const node = {
          type: "SwitchCase",
          test,
          consequent
        };
        const defs = NODE_FIELDS.SwitchCase;
        validate(defs.test, node, "test", test, 1);
        validate(defs.consequent, node, "consequent", consequent, 1);
        return node;
      }
      function switchStatement(discriminant, cases) {
        const node = {
          type: "SwitchStatement",
          discriminant,
          cases
        };
        const defs = NODE_FIELDS.SwitchStatement;
        validate(defs.discriminant, node, "discriminant", discriminant, 1);
        validate(defs.cases, node, "cases", cases, 1);
        return node;
      }
      function thisExpression() {
        return {
          type: "ThisExpression"
        };
      }
      function throwStatement(argument) {
        const node = {
          type: "ThrowStatement",
          argument
        };
        const defs = NODE_FIELDS.ThrowStatement;
        validate(defs.argument, node, "argument", argument, 1);
        return node;
      }
      function tryStatement(block, handler = null, finalizer = null) {
        const node = {
          type: "TryStatement",
          block,
          handler,
          finalizer
        };
        const defs = NODE_FIELDS.TryStatement;
        validate(defs.block, node, "block", block, 1);
        validate(defs.handler, node, "handler", handler, 1);
        validate(defs.finalizer, node, "finalizer", finalizer, 1);
        return node;
      }
      function unaryExpression(operator, argument, prefix = true) {
        const node = {
          type: "UnaryExpression",
          operator,
          argument,
          prefix
        };
        const defs = NODE_FIELDS.UnaryExpression;
        validate(defs.operator, node, "operator", operator);
        validate(defs.argument, node, "argument", argument, 1);
        validate(defs.prefix, node, "prefix", prefix);
        return node;
      }
      function updateExpression(operator, argument, prefix = false) {
        const node = {
          type: "UpdateExpression",
          operator,
          argument,
          prefix
        };
        const defs = NODE_FIELDS.UpdateExpression;
        validate(defs.operator, node, "operator", operator);
        validate(defs.argument, node, "argument", argument, 1);
        validate(defs.prefix, node, "prefix", prefix);
        return node;
      }
      function variableDeclaration(kind, declarations) {
        const node = {
          type: "VariableDeclaration",
          kind,
          declarations
        };
        const defs = NODE_FIELDS.VariableDeclaration;
        validate(defs.kind, node, "kind", kind);
        validate(defs.declarations, node, "declarations", declarations, 1);
        return node;
      }
      function variableDeclarator(id, init = null) {
        const node = {
          type: "VariableDeclarator",
          id,
          init
        };
        const defs = NODE_FIELDS.VariableDeclarator;
        validate(defs.id, node, "id", id, 1);
        validate(defs.init, node, "init", init, 1);
        return node;
      }
      function whileStatement(test, body) {
        const node = {
          type: "WhileStatement",
          test,
          body
        };
        const defs = NODE_FIELDS.WhileStatement;
        validate(defs.test, node, "test", test, 1);
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function withStatement(object, body) {
        const node = {
          type: "WithStatement",
          object,
          body
        };
        const defs = NODE_FIELDS.WithStatement;
        validate(defs.object, node, "object", object, 1);
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function assignmentPattern(left, right) {
        const node = {
          type: "AssignmentPattern",
          left,
          right
        };
        const defs = NODE_FIELDS.AssignmentPattern;
        validate(defs.left, node, "left", left, 1);
        validate(defs.right, node, "right", right, 1);
        return node;
      }
      function arrayPattern(elements) {
        const node = {
          type: "ArrayPattern",
          elements
        };
        const defs = NODE_FIELDS.ArrayPattern;
        validate(defs.elements, node, "elements", elements, 1);
        return node;
      }
      function arrowFunctionExpression2(params, body, async = false) {
        const node = {
          type: "ArrowFunctionExpression",
          params,
          body,
          async,
          expression: null
        };
        const defs = NODE_FIELDS.ArrowFunctionExpression;
        validate(defs.params, node, "params", params, 1);
        validate(defs.body, node, "body", body, 1);
        validate(defs.async, node, "async", async);
        return node;
      }
      function classBody(body) {
        const node = {
          type: "ClassBody",
          body
        };
        const defs = NODE_FIELDS.ClassBody;
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function classExpression(id = null, superClass = null, body, decorators = null) {
        const node = {
          type: "ClassExpression",
          id,
          superClass,
          body,
          decorators
        };
        const defs = NODE_FIELDS.ClassExpression;
        validate(defs.id, node, "id", id, 1);
        validate(defs.superClass, node, "superClass", superClass, 1);
        validate(defs.body, node, "body", body, 1);
        validate(defs.decorators, node, "decorators", decorators, 1);
        return node;
      }
      function classDeclaration(id = null, superClass = null, body, decorators = null) {
        const node = {
          type: "ClassDeclaration",
          id,
          superClass,
          body,
          decorators
        };
        const defs = NODE_FIELDS.ClassDeclaration;
        validate(defs.id, node, "id", id, 1);
        validate(defs.superClass, node, "superClass", superClass, 1);
        validate(defs.body, node, "body", body, 1);
        validate(defs.decorators, node, "decorators", decorators, 1);
        return node;
      }
      function exportAllDeclaration(source) {
        const node = {
          type: "ExportAllDeclaration",
          source
        };
        const defs = NODE_FIELDS.ExportAllDeclaration;
        validate(defs.source, node, "source", source, 1);
        return node;
      }
      function exportDefaultDeclaration(declaration) {
        const node = {
          type: "ExportDefaultDeclaration",
          declaration
        };
        const defs = NODE_FIELDS.ExportDefaultDeclaration;
        validate(defs.declaration, node, "declaration", declaration, 1);
        return node;
      }
      function exportNamedDeclaration(declaration = null, specifiers = [], source = null) {
        const node = {
          type: "ExportNamedDeclaration",
          declaration,
          specifiers,
          source
        };
        const defs = NODE_FIELDS.ExportNamedDeclaration;
        validate(defs.declaration, node, "declaration", declaration, 1);
        validate(defs.specifiers, node, "specifiers", specifiers, 1);
        validate(defs.source, node, "source", source, 1);
        return node;
      }
      function exportSpecifier(local, exported) {
        const node = {
          type: "ExportSpecifier",
          local,
          exported
        };
        const defs = NODE_FIELDS.ExportSpecifier;
        validate(defs.local, node, "local", local, 1);
        validate(defs.exported, node, "exported", exported, 1);
        return node;
      }
      function forOfStatement(left, right, body, _await = false) {
        const node = {
          type: "ForOfStatement",
          left,
          right,
          body,
          await: _await
        };
        const defs = NODE_FIELDS.ForOfStatement;
        validate(defs.left, node, "left", left, 1);
        validate(defs.right, node, "right", right, 1);
        validate(defs.body, node, "body", body, 1);
        validate(defs.await, node, "await", _await);
        return node;
      }
      function importDeclaration(specifiers, source) {
        const node = {
          type: "ImportDeclaration",
          specifiers,
          source
        };
        const defs = NODE_FIELDS.ImportDeclaration;
        validate(defs.specifiers, node, "specifiers", specifiers, 1);
        validate(defs.source, node, "source", source, 1);
        return node;
      }
      function importDefaultSpecifier(local) {
        const node = {
          type: "ImportDefaultSpecifier",
          local
        };
        const defs = NODE_FIELDS.ImportDefaultSpecifier;
        validate(defs.local, node, "local", local, 1);
        return node;
      }
      function importNamespaceSpecifier(local) {
        const node = {
          type: "ImportNamespaceSpecifier",
          local
        };
        const defs = NODE_FIELDS.ImportNamespaceSpecifier;
        validate(defs.local, node, "local", local, 1);
        return node;
      }
      function importSpecifier(local, imported) {
        const node = {
          type: "ImportSpecifier",
          local,
          imported
        };
        const defs = NODE_FIELDS.ImportSpecifier;
        validate(defs.local, node, "local", local, 1);
        validate(defs.imported, node, "imported", imported, 1);
        return node;
      }
      function importExpression(source, options = null) {
        const node = {
          type: "ImportExpression",
          source,
          options
        };
        const defs = NODE_FIELDS.ImportExpression;
        validate(defs.source, node, "source", source, 1);
        validate(defs.options, node, "options", options, 1);
        return node;
      }
      function metaProperty(meta, property2) {
        const node = {
          type: "MetaProperty",
          meta,
          property: property2
        };
        const defs = NODE_FIELDS.MetaProperty;
        validate(defs.meta, node, "meta", meta, 1);
        validate(defs.property, node, "property", property2, 1);
        return node;
      }
      function classMethod2(kind = "method", key, params, body, computed = false, _static = false, generator = false, async = false) {
        const node = {
          type: "ClassMethod",
          kind,
          key,
          params,
          body,
          computed,
          static: _static,
          generator,
          async
        };
        const defs = NODE_FIELDS.ClassMethod;
        validate(defs.kind, node, "kind", kind);
        validate(defs.key, node, "key", key, 1);
        validate(defs.params, node, "params", params, 1);
        validate(defs.body, node, "body", body, 1);
        validate(defs.computed, node, "computed", computed);
        validate(defs.static, node, "static", _static);
        validate(defs.generator, node, "generator", generator);
        validate(defs.async, node, "async", async);
        return node;
      }
      function objectPattern(properties) {
        const node = {
          type: "ObjectPattern",
          properties
        };
        const defs = NODE_FIELDS.ObjectPattern;
        validate(defs.properties, node, "properties", properties, 1);
        return node;
      }
      function spreadElement(argument) {
        const node = {
          type: "SpreadElement",
          argument
        };
        const defs = NODE_FIELDS.SpreadElement;
        validate(defs.argument, node, "argument", argument, 1);
        return node;
      }
      function _super() {
        return {
          type: "Super"
        };
      }
      function taggedTemplateExpression(tag, quasi) {
        const node = {
          type: "TaggedTemplateExpression",
          tag,
          quasi
        };
        const defs = NODE_FIELDS.TaggedTemplateExpression;
        validate(defs.tag, node, "tag", tag, 1);
        validate(defs.quasi, node, "quasi", quasi, 1);
        return node;
      }
      function templateElement(value, tail2 = false) {
        const node = {
          type: "TemplateElement",
          value,
          tail: tail2
        };
        const defs = NODE_FIELDS.TemplateElement;
        validate(defs.value, node, "value", value);
        validate(defs.tail, node, "tail", tail2);
        return node;
      }
      function templateLiteral(quasis, expressions) {
        const node = {
          type: "TemplateLiteral",
          quasis,
          expressions
        };
        const defs = NODE_FIELDS.TemplateLiteral;
        validate(defs.quasis, node, "quasis", quasis, 1);
        validate(defs.expressions, node, "expressions", expressions, 1);
        return node;
      }
      function yieldExpression(argument = null, delegate = false) {
        const node = {
          type: "YieldExpression",
          argument,
          delegate
        };
        const defs = NODE_FIELDS.YieldExpression;
        validate(defs.argument, node, "argument", argument, 1);
        validate(defs.delegate, node, "delegate", delegate);
        return node;
      }
      function awaitExpression(argument) {
        const node = {
          type: "AwaitExpression",
          argument
        };
        const defs = NODE_FIELDS.AwaitExpression;
        validate(defs.argument, node, "argument", argument, 1);
        return node;
      }
      function _import() {
        return {
          type: "Import"
        };
      }
      function exportNamespaceSpecifier(exported) {
        const node = {
          type: "ExportNamespaceSpecifier",
          exported
        };
        const defs = NODE_FIELDS.ExportNamespaceSpecifier;
        validate(defs.exported, node, "exported", exported, 1);
        return node;
      }
      function optionalMemberExpression(object, property2, computed = false, optional) {
        const node = {
          type: "OptionalMemberExpression",
          object,
          property: property2,
          computed,
          optional
        };
        const defs = NODE_FIELDS.OptionalMemberExpression;
        validate(defs.object, node, "object", object, 1);
        validate(defs.property, node, "property", property2, 1);
        validate(defs.computed, node, "computed", computed);
        validate(defs.optional, node, "optional", optional);
        return node;
      }
      function optionalCallExpression(callee, _arguments, optional) {
        const node = {
          type: "OptionalCallExpression",
          callee,
          arguments: _arguments,
          optional
        };
        const defs = NODE_FIELDS.OptionalCallExpression;
        validate(defs.callee, node, "callee", callee, 1);
        validate(defs.arguments, node, "arguments", _arguments, 1);
        validate(defs.optional, node, "optional", optional);
        return node;
      }
      function classProperty(key, value = null, typeAnnotation2 = null, decorators = null, computed = false, _static = false) {
        const node = {
          type: "ClassProperty",
          key,
          value,
          typeAnnotation: typeAnnotation2,
          decorators,
          computed,
          static: _static
        };
        const defs = NODE_FIELDS.ClassProperty;
        validate(defs.key, node, "key", key, 1);
        validate(defs.value, node, "value", value, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        validate(defs.decorators, node, "decorators", decorators, 1);
        validate(defs.computed, node, "computed", computed);
        validate(defs.static, node, "static", _static);
        return node;
      }
      function classAccessorProperty(key, value = null, typeAnnotation2 = null, decorators = null, computed = false, _static = false) {
        const node = {
          type: "ClassAccessorProperty",
          key,
          value,
          typeAnnotation: typeAnnotation2,
          decorators,
          computed,
          static: _static
        };
        const defs = NODE_FIELDS.ClassAccessorProperty;
        validate(defs.key, node, "key", key, 1);
        validate(defs.value, node, "value", value, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        validate(defs.decorators, node, "decorators", decorators, 1);
        validate(defs.computed, node, "computed", computed);
        validate(defs.static, node, "static", _static);
        return node;
      }
      function classPrivateProperty(key, value = null, decorators = null, _static = false) {
        const node = {
          type: "ClassPrivateProperty",
          key,
          value,
          decorators,
          static: _static
        };
        const defs = NODE_FIELDS.ClassPrivateProperty;
        validate(defs.key, node, "key", key, 1);
        validate(defs.value, node, "value", value, 1);
        validate(defs.decorators, node, "decorators", decorators, 1);
        validate(defs.static, node, "static", _static);
        return node;
      }
      function classPrivateMethod(kind = "method", key, params, body, _static = false) {
        const node = {
          type: "ClassPrivateMethod",
          kind,
          key,
          params,
          body,
          static: _static
        };
        const defs = NODE_FIELDS.ClassPrivateMethod;
        validate(defs.kind, node, "kind", kind);
        validate(defs.key, node, "key", key, 1);
        validate(defs.params, node, "params", params, 1);
        validate(defs.body, node, "body", body, 1);
        validate(defs.static, node, "static", _static);
        return node;
      }
      function privateName(id) {
        const node = {
          type: "PrivateName",
          id
        };
        const defs = NODE_FIELDS.PrivateName;
        validate(defs.id, node, "id", id, 1);
        return node;
      }
      function staticBlock(body) {
        const node = {
          type: "StaticBlock",
          body
        };
        const defs = NODE_FIELDS.StaticBlock;
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function importAttribute(key, value) {
        const node = {
          type: "ImportAttribute",
          key,
          value
        };
        const defs = NODE_FIELDS.ImportAttribute;
        validate(defs.key, node, "key", key, 1);
        validate(defs.value, node, "value", value, 1);
        return node;
      }
      function anyTypeAnnotation() {
        return {
          type: "AnyTypeAnnotation"
        };
      }
      function arrayTypeAnnotation(elementType) {
        const node = {
          type: "ArrayTypeAnnotation",
          elementType
        };
        const defs = NODE_FIELDS.ArrayTypeAnnotation;
        validate(defs.elementType, node, "elementType", elementType, 1);
        return node;
      }
      function booleanTypeAnnotation() {
        return {
          type: "BooleanTypeAnnotation"
        };
      }
      function booleanLiteralTypeAnnotation(value) {
        const node = {
          type: "BooleanLiteralTypeAnnotation",
          value
        };
        const defs = NODE_FIELDS.BooleanLiteralTypeAnnotation;
        validate(defs.value, node, "value", value);
        return node;
      }
      function nullLiteralTypeAnnotation() {
        return {
          type: "NullLiteralTypeAnnotation"
        };
      }
      function classImplements(id, typeParameters = null) {
        const node = {
          type: "ClassImplements",
          id,
          typeParameters
        };
        const defs = NODE_FIELDS.ClassImplements;
        validate(defs.id, node, "id", id, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        return node;
      }
      function declareClass(id, typeParameters = null, _extends = null, body) {
        const node = {
          type: "DeclareClass",
          id,
          typeParameters,
          extends: _extends,
          body
        };
        const defs = NODE_FIELDS.DeclareClass;
        validate(defs.id, node, "id", id, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.extends, node, "extends", _extends, 1);
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function declareFunction(id) {
        const node = {
          type: "DeclareFunction",
          id
        };
        const defs = NODE_FIELDS.DeclareFunction;
        validate(defs.id, node, "id", id, 1);
        return node;
      }
      function declareInterface(id, typeParameters = null, _extends = null, body) {
        const node = {
          type: "DeclareInterface",
          id,
          typeParameters,
          extends: _extends,
          body
        };
        const defs = NODE_FIELDS.DeclareInterface;
        validate(defs.id, node, "id", id, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.extends, node, "extends", _extends, 1);
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function declareModule(id, body, kind = null) {
        const node = {
          type: "DeclareModule",
          id,
          body,
          kind
        };
        const defs = NODE_FIELDS.DeclareModule;
        validate(defs.id, node, "id", id, 1);
        validate(defs.body, node, "body", body, 1);
        validate(defs.kind, node, "kind", kind);
        return node;
      }
      function declareModuleExports(typeAnnotation2) {
        const node = {
          type: "DeclareModuleExports",
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.DeclareModuleExports;
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function declareTypeAlias(id, typeParameters = null, right) {
        const node = {
          type: "DeclareTypeAlias",
          id,
          typeParameters,
          right
        };
        const defs = NODE_FIELDS.DeclareTypeAlias;
        validate(defs.id, node, "id", id, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.right, node, "right", right, 1);
        return node;
      }
      function declareOpaqueType(id, typeParameters = null, supertype = null) {
        const node = {
          type: "DeclareOpaqueType",
          id,
          typeParameters,
          supertype
        };
        const defs = NODE_FIELDS.DeclareOpaqueType;
        validate(defs.id, node, "id", id, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.supertype, node, "supertype", supertype, 1);
        return node;
      }
      function declareVariable(id) {
        const node = {
          type: "DeclareVariable",
          id
        };
        const defs = NODE_FIELDS.DeclareVariable;
        validate(defs.id, node, "id", id, 1);
        return node;
      }
      function declareExportDeclaration(declaration = null, specifiers = null, source = null, attributes = null) {
        const node = {
          type: "DeclareExportDeclaration",
          declaration,
          specifiers,
          source,
          attributes
        };
        const defs = NODE_FIELDS.DeclareExportDeclaration;
        validate(defs.declaration, node, "declaration", declaration, 1);
        validate(defs.specifiers, node, "specifiers", specifiers, 1);
        validate(defs.source, node, "source", source, 1);
        validate(defs.attributes, node, "attributes", attributes, 1);
        return node;
      }
      function declareExportAllDeclaration(source, attributes = null) {
        const node = {
          type: "DeclareExportAllDeclaration",
          source,
          attributes
        };
        const defs = NODE_FIELDS.DeclareExportAllDeclaration;
        validate(defs.source, node, "source", source, 1);
        validate(defs.attributes, node, "attributes", attributes, 1);
        return node;
      }
      function declaredPredicate(value) {
        const node = {
          type: "DeclaredPredicate",
          value
        };
        const defs = NODE_FIELDS.DeclaredPredicate;
        validate(defs.value, node, "value", value, 1);
        return node;
      }
      function existsTypeAnnotation() {
        return {
          type: "ExistsTypeAnnotation"
        };
      }
      function functionTypeAnnotation(typeParameters = null, params, rest2 = null, returnType) {
        const node = {
          type: "FunctionTypeAnnotation",
          typeParameters,
          params,
          rest: rest2,
          returnType
        };
        const defs = NODE_FIELDS.FunctionTypeAnnotation;
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.params, node, "params", params, 1);
        validate(defs.rest, node, "rest", rest2, 1);
        validate(defs.returnType, node, "returnType", returnType, 1);
        return node;
      }
      function functionTypeParam(name = null, typeAnnotation2) {
        const node = {
          type: "FunctionTypeParam",
          name,
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.FunctionTypeParam;
        validate(defs.name, node, "name", name, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function genericTypeAnnotation(id, typeParameters = null) {
        const node = {
          type: "GenericTypeAnnotation",
          id,
          typeParameters
        };
        const defs = NODE_FIELDS.GenericTypeAnnotation;
        validate(defs.id, node, "id", id, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        return node;
      }
      function inferredPredicate() {
        return {
          type: "InferredPredicate"
        };
      }
      function interfaceExtends(id, typeParameters = null) {
        const node = {
          type: "InterfaceExtends",
          id,
          typeParameters
        };
        const defs = NODE_FIELDS.InterfaceExtends;
        validate(defs.id, node, "id", id, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        return node;
      }
      function interfaceDeclaration(id, typeParameters = null, _extends = null, body) {
        const node = {
          type: "InterfaceDeclaration",
          id,
          typeParameters,
          extends: _extends,
          body
        };
        const defs = NODE_FIELDS.InterfaceDeclaration;
        validate(defs.id, node, "id", id, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.extends, node, "extends", _extends, 1);
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function interfaceTypeAnnotation(_extends = null, body) {
        const node = {
          type: "InterfaceTypeAnnotation",
          extends: _extends,
          body
        };
        const defs = NODE_FIELDS.InterfaceTypeAnnotation;
        validate(defs.extends, node, "extends", _extends, 1);
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function intersectionTypeAnnotation(types2) {
        const node = {
          type: "IntersectionTypeAnnotation",
          types: types2
        };
        const defs = NODE_FIELDS.IntersectionTypeAnnotation;
        validate(defs.types, node, "types", types2, 1);
        return node;
      }
      function mixedTypeAnnotation() {
        return {
          type: "MixedTypeAnnotation"
        };
      }
      function emptyTypeAnnotation() {
        return {
          type: "EmptyTypeAnnotation"
        };
      }
      function nullableTypeAnnotation(typeAnnotation2) {
        const node = {
          type: "NullableTypeAnnotation",
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.NullableTypeAnnotation;
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function numberLiteralTypeAnnotation(value) {
        const node = {
          type: "NumberLiteralTypeAnnotation",
          value
        };
        const defs = NODE_FIELDS.NumberLiteralTypeAnnotation;
        validate(defs.value, node, "value", value);
        return node;
      }
      function numberTypeAnnotation() {
        return {
          type: "NumberTypeAnnotation"
        };
      }
      function objectTypeAnnotation(properties, indexers = [], callProperties = [], internalSlots = [], exact = false) {
        const node = {
          type: "ObjectTypeAnnotation",
          properties,
          indexers,
          callProperties,
          internalSlots,
          exact
        };
        const defs = NODE_FIELDS.ObjectTypeAnnotation;
        validate(defs.properties, node, "properties", properties, 1);
        validate(defs.indexers, node, "indexers", indexers, 1);
        validate(defs.callProperties, node, "callProperties", callProperties, 1);
        validate(defs.internalSlots, node, "internalSlots", internalSlots, 1);
        validate(defs.exact, node, "exact", exact);
        return node;
      }
      function objectTypeInternalSlot(id, value, optional, _static, method2) {
        const node = {
          type: "ObjectTypeInternalSlot",
          id,
          value,
          optional,
          static: _static,
          method: method2
        };
        const defs = NODE_FIELDS.ObjectTypeInternalSlot;
        validate(defs.id, node, "id", id, 1);
        validate(defs.value, node, "value", value, 1);
        validate(defs.optional, node, "optional", optional);
        validate(defs.static, node, "static", _static);
        validate(defs.method, node, "method", method2);
        return node;
      }
      function objectTypeCallProperty(value) {
        const node = {
          type: "ObjectTypeCallProperty",
          value,
          static: null
        };
        const defs = NODE_FIELDS.ObjectTypeCallProperty;
        validate(defs.value, node, "value", value, 1);
        return node;
      }
      function objectTypeIndexer(id = null, key, value, variance2 = null) {
        const node = {
          type: "ObjectTypeIndexer",
          id,
          key,
          value,
          variance: variance2,
          static: null
        };
        const defs = NODE_FIELDS.ObjectTypeIndexer;
        validate(defs.id, node, "id", id, 1);
        validate(defs.key, node, "key", key, 1);
        validate(defs.value, node, "value", value, 1);
        validate(defs.variance, node, "variance", variance2, 1);
        return node;
      }
      function objectTypeProperty(key, value, variance2 = null) {
        const node = {
          type: "ObjectTypeProperty",
          key,
          value,
          variance: variance2,
          kind: null,
          method: null,
          optional: null,
          proto: null,
          static: null
        };
        const defs = NODE_FIELDS.ObjectTypeProperty;
        validate(defs.key, node, "key", key, 1);
        validate(defs.value, node, "value", value, 1);
        validate(defs.variance, node, "variance", variance2, 1);
        return node;
      }
      function objectTypeSpreadProperty(argument) {
        const node = {
          type: "ObjectTypeSpreadProperty",
          argument
        };
        const defs = NODE_FIELDS.ObjectTypeSpreadProperty;
        validate(defs.argument, node, "argument", argument, 1);
        return node;
      }
      function opaqueType(id, typeParameters = null, supertype = null, impltype) {
        const node = {
          type: "OpaqueType",
          id,
          typeParameters,
          supertype,
          impltype
        };
        const defs = NODE_FIELDS.OpaqueType;
        validate(defs.id, node, "id", id, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.supertype, node, "supertype", supertype, 1);
        validate(defs.impltype, node, "impltype", impltype, 1);
        return node;
      }
      function qualifiedTypeIdentifier(id, qualification) {
        const node = {
          type: "QualifiedTypeIdentifier",
          id,
          qualification
        };
        const defs = NODE_FIELDS.QualifiedTypeIdentifier;
        validate(defs.id, node, "id", id, 1);
        validate(defs.qualification, node, "qualification", qualification, 1);
        return node;
      }
      function stringLiteralTypeAnnotation(value) {
        const node = {
          type: "StringLiteralTypeAnnotation",
          value
        };
        const defs = NODE_FIELDS.StringLiteralTypeAnnotation;
        validate(defs.value, node, "value", value);
        return node;
      }
      function stringTypeAnnotation() {
        return {
          type: "StringTypeAnnotation"
        };
      }
      function symbolTypeAnnotation() {
        return {
          type: "SymbolTypeAnnotation"
        };
      }
      function thisTypeAnnotation() {
        return {
          type: "ThisTypeAnnotation"
        };
      }
      function tupleTypeAnnotation(types2) {
        const node = {
          type: "TupleTypeAnnotation",
          types: types2
        };
        const defs = NODE_FIELDS.TupleTypeAnnotation;
        validate(defs.types, node, "types", types2, 1);
        return node;
      }
      function typeofTypeAnnotation(argument) {
        const node = {
          type: "TypeofTypeAnnotation",
          argument
        };
        const defs = NODE_FIELDS.TypeofTypeAnnotation;
        validate(defs.argument, node, "argument", argument, 1);
        return node;
      }
      function typeAlias(id, typeParameters = null, right) {
        const node = {
          type: "TypeAlias",
          id,
          typeParameters,
          right
        };
        const defs = NODE_FIELDS.TypeAlias;
        validate(defs.id, node, "id", id, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.right, node, "right", right, 1);
        return node;
      }
      function typeAnnotation(typeAnnotation2) {
        const node = {
          type: "TypeAnnotation",
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.TypeAnnotation;
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function typeCastExpression(expression, typeAnnotation2) {
        const node = {
          type: "TypeCastExpression",
          expression,
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.TypeCastExpression;
        validate(defs.expression, node, "expression", expression, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function typeParameter(bound = null, _default = null, variance2 = null) {
        const node = {
          type: "TypeParameter",
          bound,
          default: _default,
          variance: variance2,
          name: null
        };
        const defs = NODE_FIELDS.TypeParameter;
        validate(defs.bound, node, "bound", bound, 1);
        validate(defs.default, node, "default", _default, 1);
        validate(defs.variance, node, "variance", variance2, 1);
        return node;
      }
      function typeParameterDeclaration(params) {
        const node = {
          type: "TypeParameterDeclaration",
          params
        };
        const defs = NODE_FIELDS.TypeParameterDeclaration;
        validate(defs.params, node, "params", params, 1);
        return node;
      }
      function typeParameterInstantiation(params) {
        const node = {
          type: "TypeParameterInstantiation",
          params
        };
        const defs = NODE_FIELDS.TypeParameterInstantiation;
        validate(defs.params, node, "params", params, 1);
        return node;
      }
      function unionTypeAnnotation(types2) {
        const node = {
          type: "UnionTypeAnnotation",
          types: types2
        };
        const defs = NODE_FIELDS.UnionTypeAnnotation;
        validate(defs.types, node, "types", types2, 1);
        return node;
      }
      function variance(kind) {
        const node = {
          type: "Variance",
          kind
        };
        const defs = NODE_FIELDS.Variance;
        validate(defs.kind, node, "kind", kind);
        return node;
      }
      function voidTypeAnnotation() {
        return {
          type: "VoidTypeAnnotation"
        };
      }
      function enumDeclaration(id, body) {
        const node = {
          type: "EnumDeclaration",
          id,
          body
        };
        const defs = NODE_FIELDS.EnumDeclaration;
        validate(defs.id, node, "id", id, 1);
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function enumBooleanBody(members) {
        const node = {
          type: "EnumBooleanBody",
          members,
          explicitType: null,
          hasUnknownMembers: null
        };
        const defs = NODE_FIELDS.EnumBooleanBody;
        validate(defs.members, node, "members", members, 1);
        return node;
      }
      function enumNumberBody(members) {
        const node = {
          type: "EnumNumberBody",
          members,
          explicitType: null,
          hasUnknownMembers: null
        };
        const defs = NODE_FIELDS.EnumNumberBody;
        validate(defs.members, node, "members", members, 1);
        return node;
      }
      function enumStringBody(members) {
        const node = {
          type: "EnumStringBody",
          members,
          explicitType: null,
          hasUnknownMembers: null
        };
        const defs = NODE_FIELDS.EnumStringBody;
        validate(defs.members, node, "members", members, 1);
        return node;
      }
      function enumSymbolBody(members) {
        const node = {
          type: "EnumSymbolBody",
          members,
          hasUnknownMembers: null
        };
        const defs = NODE_FIELDS.EnumSymbolBody;
        validate(defs.members, node, "members", members, 1);
        return node;
      }
      function enumBooleanMember(id) {
        const node = {
          type: "EnumBooleanMember",
          id,
          init: null
        };
        const defs = NODE_FIELDS.EnumBooleanMember;
        validate(defs.id, node, "id", id, 1);
        return node;
      }
      function enumNumberMember(id, init) {
        const node = {
          type: "EnumNumberMember",
          id,
          init
        };
        const defs = NODE_FIELDS.EnumNumberMember;
        validate(defs.id, node, "id", id, 1);
        validate(defs.init, node, "init", init, 1);
        return node;
      }
      function enumStringMember(id, init) {
        const node = {
          type: "EnumStringMember",
          id,
          init
        };
        const defs = NODE_FIELDS.EnumStringMember;
        validate(defs.id, node, "id", id, 1);
        validate(defs.init, node, "init", init, 1);
        return node;
      }
      function enumDefaultedMember(id) {
        const node = {
          type: "EnumDefaultedMember",
          id
        };
        const defs = NODE_FIELDS.EnumDefaultedMember;
        validate(defs.id, node, "id", id, 1);
        return node;
      }
      function indexedAccessType(objectType, indexType) {
        const node = {
          type: "IndexedAccessType",
          objectType,
          indexType
        };
        const defs = NODE_FIELDS.IndexedAccessType;
        validate(defs.objectType, node, "objectType", objectType, 1);
        validate(defs.indexType, node, "indexType", indexType, 1);
        return node;
      }
      function optionalIndexedAccessType(objectType, indexType) {
        const node = {
          type: "OptionalIndexedAccessType",
          objectType,
          indexType,
          optional: null
        };
        const defs = NODE_FIELDS.OptionalIndexedAccessType;
        validate(defs.objectType, node, "objectType", objectType, 1);
        validate(defs.indexType, node, "indexType", indexType, 1);
        return node;
      }
      function jsxAttribute(name, value = null) {
        const node = {
          type: "JSXAttribute",
          name,
          value
        };
        const defs = NODE_FIELDS.JSXAttribute;
        validate(defs.name, node, "name", name, 1);
        validate(defs.value, node, "value", value, 1);
        return node;
      }
      function jsxClosingElement(name) {
        const node = {
          type: "JSXClosingElement",
          name
        };
        const defs = NODE_FIELDS.JSXClosingElement;
        validate(defs.name, node, "name", name, 1);
        return node;
      }
      function jsxElement(openingElement, closingElement = null, children, selfClosing = null) {
        const node = {
          type: "JSXElement",
          openingElement,
          closingElement,
          children,
          selfClosing
        };
        const defs = NODE_FIELDS.JSXElement;
        validate(defs.openingElement, node, "openingElement", openingElement, 1);
        validate(defs.closingElement, node, "closingElement", closingElement, 1);
        validate(defs.children, node, "children", children, 1);
        validate(defs.selfClosing, node, "selfClosing", selfClosing);
        return node;
      }
      function jsxEmptyExpression() {
        return {
          type: "JSXEmptyExpression"
        };
      }
      function jsxExpressionContainer(expression) {
        const node = {
          type: "JSXExpressionContainer",
          expression
        };
        const defs = NODE_FIELDS.JSXExpressionContainer;
        validate(defs.expression, node, "expression", expression, 1);
        return node;
      }
      function jsxSpreadChild(expression) {
        const node = {
          type: "JSXSpreadChild",
          expression
        };
        const defs = NODE_FIELDS.JSXSpreadChild;
        validate(defs.expression, node, "expression", expression, 1);
        return node;
      }
      function jsxIdentifier(name) {
        const node = {
          type: "JSXIdentifier",
          name
        };
        const defs = NODE_FIELDS.JSXIdentifier;
        validate(defs.name, node, "name", name);
        return node;
      }
      function jsxMemberExpression(object, property2) {
        const node = {
          type: "JSXMemberExpression",
          object,
          property: property2
        };
        const defs = NODE_FIELDS.JSXMemberExpression;
        validate(defs.object, node, "object", object, 1);
        validate(defs.property, node, "property", property2, 1);
        return node;
      }
      function jsxNamespacedName(namespace, name) {
        const node = {
          type: "JSXNamespacedName",
          namespace,
          name
        };
        const defs = NODE_FIELDS.JSXNamespacedName;
        validate(defs.namespace, node, "namespace", namespace, 1);
        validate(defs.name, node, "name", name, 1);
        return node;
      }
      function jsxOpeningElement(name, attributes, selfClosing = false) {
        const node = {
          type: "JSXOpeningElement",
          name,
          attributes,
          selfClosing
        };
        const defs = NODE_FIELDS.JSXOpeningElement;
        validate(defs.name, node, "name", name, 1);
        validate(defs.attributes, node, "attributes", attributes, 1);
        validate(defs.selfClosing, node, "selfClosing", selfClosing);
        return node;
      }
      function jsxSpreadAttribute(argument) {
        const node = {
          type: "JSXSpreadAttribute",
          argument
        };
        const defs = NODE_FIELDS.JSXSpreadAttribute;
        validate(defs.argument, node, "argument", argument, 1);
        return node;
      }
      function jsxText(value) {
        const node = {
          type: "JSXText",
          value
        };
        const defs = NODE_FIELDS.JSXText;
        validate(defs.value, node, "value", value);
        return node;
      }
      function jsxFragment(openingFragment, closingFragment, children) {
        const node = {
          type: "JSXFragment",
          openingFragment,
          closingFragment,
          children
        };
        const defs = NODE_FIELDS.JSXFragment;
        validate(defs.openingFragment, node, "openingFragment", openingFragment, 1);
        validate(defs.closingFragment, node, "closingFragment", closingFragment, 1);
        validate(defs.children, node, "children", children, 1);
        return node;
      }
      function jsxOpeningFragment() {
        return {
          type: "JSXOpeningFragment"
        };
      }
      function jsxClosingFragment() {
        return {
          type: "JSXClosingFragment"
        };
      }
      function noop5() {
        return {
          type: "Noop"
        };
      }
      function placeholder(expectedNode, name) {
        const node = {
          type: "Placeholder",
          expectedNode,
          name
        };
        const defs = NODE_FIELDS.Placeholder;
        validate(defs.expectedNode, node, "expectedNode", expectedNode);
        validate(defs.name, node, "name", name, 1);
        return node;
      }
      function v8IntrinsicIdentifier(name) {
        const node = {
          type: "V8IntrinsicIdentifier",
          name
        };
        const defs = NODE_FIELDS.V8IntrinsicIdentifier;
        validate(defs.name, node, "name", name);
        return node;
      }
      function argumentPlaceholder() {
        return {
          type: "ArgumentPlaceholder"
        };
      }
      function bindExpression(object, callee) {
        const node = {
          type: "BindExpression",
          object,
          callee
        };
        const defs = NODE_FIELDS.BindExpression;
        validate(defs.object, node, "object", object, 1);
        validate(defs.callee, node, "callee", callee, 1);
        return node;
      }
      function decorator(expression) {
        const node = {
          type: "Decorator",
          expression
        };
        const defs = NODE_FIELDS.Decorator;
        validate(defs.expression, node, "expression", expression, 1);
        return node;
      }
      function doExpression(body, async = false) {
        const node = {
          type: "DoExpression",
          body,
          async
        };
        const defs = NODE_FIELDS.DoExpression;
        validate(defs.body, node, "body", body, 1);
        validate(defs.async, node, "async", async);
        return node;
      }
      function exportDefaultSpecifier(exported) {
        const node = {
          type: "ExportDefaultSpecifier",
          exported
        };
        const defs = NODE_FIELDS.ExportDefaultSpecifier;
        validate(defs.exported, node, "exported", exported, 1);
        return node;
      }
      function recordExpression(properties) {
        const node = {
          type: "RecordExpression",
          properties
        };
        const defs = NODE_FIELDS.RecordExpression;
        validate(defs.properties, node, "properties", properties, 1);
        return node;
      }
      function tupleExpression(elements = []) {
        const node = {
          type: "TupleExpression",
          elements
        };
        const defs = NODE_FIELDS.TupleExpression;
        validate(defs.elements, node, "elements", elements, 1);
        return node;
      }
      function decimalLiteral(value) {
        const node = {
          type: "DecimalLiteral",
          value
        };
        const defs = NODE_FIELDS.DecimalLiteral;
        validate(defs.value, node, "value", value);
        return node;
      }
      function moduleExpression(body) {
        const node = {
          type: "ModuleExpression",
          body
        };
        const defs = NODE_FIELDS.ModuleExpression;
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function topicReference() {
        return {
          type: "TopicReference"
        };
      }
      function pipelineTopicExpression(expression) {
        const node = {
          type: "PipelineTopicExpression",
          expression
        };
        const defs = NODE_FIELDS.PipelineTopicExpression;
        validate(defs.expression, node, "expression", expression, 1);
        return node;
      }
      function pipelineBareFunction(callee) {
        const node = {
          type: "PipelineBareFunction",
          callee
        };
        const defs = NODE_FIELDS.PipelineBareFunction;
        validate(defs.callee, node, "callee", callee, 1);
        return node;
      }
      function pipelinePrimaryTopicReference() {
        return {
          type: "PipelinePrimaryTopicReference"
        };
      }
      function voidPattern() {
        return {
          type: "VoidPattern"
        };
      }
      function tsParameterProperty(parameter) {
        const node = {
          type: "TSParameterProperty",
          parameter
        };
        const defs = NODE_FIELDS.TSParameterProperty;
        validate(defs.parameter, node, "parameter", parameter, 1);
        return node;
      }
      function tsDeclareFunction(id = null, typeParameters = null, params, returnType = null) {
        const node = {
          type: "TSDeclareFunction",
          id,
          typeParameters,
          params,
          returnType
        };
        const defs = NODE_FIELDS.TSDeclareFunction;
        validate(defs.id, node, "id", id, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.params, node, "params", params, 1);
        validate(defs.returnType, node, "returnType", returnType, 1);
        return node;
      }
      function tsDeclareMethod(decorators = null, key, typeParameters = null, params, returnType = null) {
        const node = {
          type: "TSDeclareMethod",
          decorators,
          key,
          typeParameters,
          params,
          returnType
        };
        const defs = NODE_FIELDS.TSDeclareMethod;
        validate(defs.decorators, node, "decorators", decorators, 1);
        validate(defs.key, node, "key", key, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.params, node, "params", params, 1);
        validate(defs.returnType, node, "returnType", returnType, 1);
        return node;
      }
      function tsQualifiedName(left, right) {
        const node = {
          type: "TSQualifiedName",
          left,
          right
        };
        const defs = NODE_FIELDS.TSQualifiedName;
        validate(defs.left, node, "left", left, 1);
        validate(defs.right, node, "right", right, 1);
        return node;
      }
      function tsCallSignatureDeclaration(typeParameters = null, parameters, typeAnnotation2 = null) {
        const node = {
          type: "TSCallSignatureDeclaration",
          typeParameters,
          parameters,
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.TSCallSignatureDeclaration;
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.parameters, node, "parameters", parameters, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function tsConstructSignatureDeclaration(typeParameters = null, parameters, typeAnnotation2 = null) {
        const node = {
          type: "TSConstructSignatureDeclaration",
          typeParameters,
          parameters,
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.TSConstructSignatureDeclaration;
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.parameters, node, "parameters", parameters, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function tsPropertySignature(key, typeAnnotation2 = null) {
        const node = {
          type: "TSPropertySignature",
          key,
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.TSPropertySignature;
        validate(defs.key, node, "key", key, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function tsMethodSignature(key, typeParameters = null, parameters, typeAnnotation2 = null) {
        const node = {
          type: "TSMethodSignature",
          key,
          typeParameters,
          parameters,
          typeAnnotation: typeAnnotation2,
          kind: null
        };
        const defs = NODE_FIELDS.TSMethodSignature;
        validate(defs.key, node, "key", key, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.parameters, node, "parameters", parameters, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function tsIndexSignature(parameters, typeAnnotation2 = null) {
        const node = {
          type: "TSIndexSignature",
          parameters,
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.TSIndexSignature;
        validate(defs.parameters, node, "parameters", parameters, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function tsAnyKeyword() {
        return {
          type: "TSAnyKeyword"
        };
      }
      function tsBooleanKeyword() {
        return {
          type: "TSBooleanKeyword"
        };
      }
      function tsBigIntKeyword() {
        return {
          type: "TSBigIntKeyword"
        };
      }
      function tsIntrinsicKeyword() {
        return {
          type: "TSIntrinsicKeyword"
        };
      }
      function tsNeverKeyword() {
        return {
          type: "TSNeverKeyword"
        };
      }
      function tsNullKeyword() {
        return {
          type: "TSNullKeyword"
        };
      }
      function tsNumberKeyword() {
        return {
          type: "TSNumberKeyword"
        };
      }
      function tsObjectKeyword() {
        return {
          type: "TSObjectKeyword"
        };
      }
      function tsStringKeyword() {
        return {
          type: "TSStringKeyword"
        };
      }
      function tsSymbolKeyword() {
        return {
          type: "TSSymbolKeyword"
        };
      }
      function tsUndefinedKeyword() {
        return {
          type: "TSUndefinedKeyword"
        };
      }
      function tsUnknownKeyword() {
        return {
          type: "TSUnknownKeyword"
        };
      }
      function tsVoidKeyword() {
        return {
          type: "TSVoidKeyword"
        };
      }
      function tsThisType() {
        return {
          type: "TSThisType"
        };
      }
      function tsFunctionType(typeParameters = null, parameters, typeAnnotation2 = null) {
        const node = {
          type: "TSFunctionType",
          typeParameters,
          parameters,
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.TSFunctionType;
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.parameters, node, "parameters", parameters, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function tsConstructorType(typeParameters = null, parameters, typeAnnotation2 = null) {
        const node = {
          type: "TSConstructorType",
          typeParameters,
          parameters,
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.TSConstructorType;
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.parameters, node, "parameters", parameters, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function tsTypeReference(typeName, typeParameters = null) {
        const node = {
          type: "TSTypeReference",
          typeName,
          typeParameters
        };
        const defs = NODE_FIELDS.TSTypeReference;
        validate(defs.typeName, node, "typeName", typeName, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        return node;
      }
      function tsTypePredicate(parameterName, typeAnnotation2 = null, asserts = null) {
        const node = {
          type: "TSTypePredicate",
          parameterName,
          typeAnnotation: typeAnnotation2,
          asserts
        };
        const defs = NODE_FIELDS.TSTypePredicate;
        validate(defs.parameterName, node, "parameterName", parameterName, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        validate(defs.asserts, node, "asserts", asserts);
        return node;
      }
      function tsTypeQuery(exprName, typeParameters = null) {
        const node = {
          type: "TSTypeQuery",
          exprName,
          typeParameters
        };
        const defs = NODE_FIELDS.TSTypeQuery;
        validate(defs.exprName, node, "exprName", exprName, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        return node;
      }
      function tsTypeLiteral(members) {
        const node = {
          type: "TSTypeLiteral",
          members
        };
        const defs = NODE_FIELDS.TSTypeLiteral;
        validate(defs.members, node, "members", members, 1);
        return node;
      }
      function tsArrayType(elementType) {
        const node = {
          type: "TSArrayType",
          elementType
        };
        const defs = NODE_FIELDS.TSArrayType;
        validate(defs.elementType, node, "elementType", elementType, 1);
        return node;
      }
      function tsTupleType(elementTypes) {
        const node = {
          type: "TSTupleType",
          elementTypes
        };
        const defs = NODE_FIELDS.TSTupleType;
        validate(defs.elementTypes, node, "elementTypes", elementTypes, 1);
        return node;
      }
      function tsOptionalType(typeAnnotation2) {
        const node = {
          type: "TSOptionalType",
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.TSOptionalType;
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function tsRestType(typeAnnotation2) {
        const node = {
          type: "TSRestType",
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.TSRestType;
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function tsNamedTupleMember(label, elementType, optional = false) {
        const node = {
          type: "TSNamedTupleMember",
          label,
          elementType,
          optional
        };
        const defs = NODE_FIELDS.TSNamedTupleMember;
        validate(defs.label, node, "label", label, 1);
        validate(defs.elementType, node, "elementType", elementType, 1);
        validate(defs.optional, node, "optional", optional);
        return node;
      }
      function tsUnionType(types2) {
        const node = {
          type: "TSUnionType",
          types: types2
        };
        const defs = NODE_FIELDS.TSUnionType;
        validate(defs.types, node, "types", types2, 1);
        return node;
      }
      function tsIntersectionType(types2) {
        const node = {
          type: "TSIntersectionType",
          types: types2
        };
        const defs = NODE_FIELDS.TSIntersectionType;
        validate(defs.types, node, "types", types2, 1);
        return node;
      }
      function tsConditionalType(checkType, extendsType, trueType, falseType) {
        const node = {
          type: "TSConditionalType",
          checkType,
          extendsType,
          trueType,
          falseType
        };
        const defs = NODE_FIELDS.TSConditionalType;
        validate(defs.checkType, node, "checkType", checkType, 1);
        validate(defs.extendsType, node, "extendsType", extendsType, 1);
        validate(defs.trueType, node, "trueType", trueType, 1);
        validate(defs.falseType, node, "falseType", falseType, 1);
        return node;
      }
      function tsInferType(typeParameter2) {
        const node = {
          type: "TSInferType",
          typeParameter: typeParameter2
        };
        const defs = NODE_FIELDS.TSInferType;
        validate(defs.typeParameter, node, "typeParameter", typeParameter2, 1);
        return node;
      }
      function tsParenthesizedType(typeAnnotation2) {
        const node = {
          type: "TSParenthesizedType",
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.TSParenthesizedType;
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function tsTypeOperator(typeAnnotation2, operator = "keyof") {
        const node = {
          type: "TSTypeOperator",
          typeAnnotation: typeAnnotation2,
          operator
        };
        const defs = NODE_FIELDS.TSTypeOperator;
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        validate(defs.operator, node, "operator", operator);
        return node;
      }
      function tsIndexedAccessType(objectType, indexType) {
        const node = {
          type: "TSIndexedAccessType",
          objectType,
          indexType
        };
        const defs = NODE_FIELDS.TSIndexedAccessType;
        validate(defs.objectType, node, "objectType", objectType, 1);
        validate(defs.indexType, node, "indexType", indexType, 1);
        return node;
      }
      function tsMappedType(typeParameter2, typeAnnotation2 = null, nameType = null) {
        const node = {
          type: "TSMappedType",
          typeParameter: typeParameter2,
          typeAnnotation: typeAnnotation2,
          nameType
        };
        const defs = NODE_FIELDS.TSMappedType;
        validate(defs.typeParameter, node, "typeParameter", typeParameter2, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        validate(defs.nameType, node, "nameType", nameType, 1);
        return node;
      }
      function tsTemplateLiteralType(quasis, types2) {
        const node = {
          type: "TSTemplateLiteralType",
          quasis,
          types: types2
        };
        const defs = NODE_FIELDS.TSTemplateLiteralType;
        validate(defs.quasis, node, "quasis", quasis, 1);
        validate(defs.types, node, "types", types2, 1);
        return node;
      }
      function tsLiteralType(literal) {
        const node = {
          type: "TSLiteralType",
          literal
        };
        const defs = NODE_FIELDS.TSLiteralType;
        validate(defs.literal, node, "literal", literal, 1);
        return node;
      }
      function tsExpressionWithTypeArguments(expression, typeParameters = null) {
        const node = {
          type: "TSExpressionWithTypeArguments",
          expression,
          typeParameters
        };
        const defs = NODE_FIELDS.TSExpressionWithTypeArguments;
        validate(defs.expression, node, "expression", expression, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        return node;
      }
      function tsInterfaceDeclaration(id, typeParameters = null, _extends = null, body) {
        const node = {
          type: "TSInterfaceDeclaration",
          id,
          typeParameters,
          extends: _extends,
          body
        };
        const defs = NODE_FIELDS.TSInterfaceDeclaration;
        validate(defs.id, node, "id", id, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.extends, node, "extends", _extends, 1);
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function tsInterfaceBody(body) {
        const node = {
          type: "TSInterfaceBody",
          body
        };
        const defs = NODE_FIELDS.TSInterfaceBody;
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function tsTypeAliasDeclaration(id, typeParameters = null, typeAnnotation2) {
        const node = {
          type: "TSTypeAliasDeclaration",
          id,
          typeParameters,
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.TSTypeAliasDeclaration;
        validate(defs.id, node, "id", id, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function tsInstantiationExpression(expression, typeParameters = null) {
        const node = {
          type: "TSInstantiationExpression",
          expression,
          typeParameters
        };
        const defs = NODE_FIELDS.TSInstantiationExpression;
        validate(defs.expression, node, "expression", expression, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        return node;
      }
      function tsAsExpression(expression, typeAnnotation2) {
        const node = {
          type: "TSAsExpression",
          expression,
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.TSAsExpression;
        validate(defs.expression, node, "expression", expression, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function tsSatisfiesExpression(expression, typeAnnotation2) {
        const node = {
          type: "TSSatisfiesExpression",
          expression,
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.TSSatisfiesExpression;
        validate(defs.expression, node, "expression", expression, 1);
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function tsTypeAssertion(typeAnnotation2, expression) {
        const node = {
          type: "TSTypeAssertion",
          typeAnnotation: typeAnnotation2,
          expression
        };
        const defs = NODE_FIELDS.TSTypeAssertion;
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        validate(defs.expression, node, "expression", expression, 1);
        return node;
      }
      function tsEnumBody(members) {
        const node = {
          type: "TSEnumBody",
          members
        };
        const defs = NODE_FIELDS.TSEnumBody;
        validate(defs.members, node, "members", members, 1);
        return node;
      }
      function tsEnumDeclaration(id, members) {
        const node = {
          type: "TSEnumDeclaration",
          id,
          members
        };
        const defs = NODE_FIELDS.TSEnumDeclaration;
        validate(defs.id, node, "id", id, 1);
        validate(defs.members, node, "members", members, 1);
        return node;
      }
      function tsEnumMember(id, initializer = null) {
        const node = {
          type: "TSEnumMember",
          id,
          initializer
        };
        const defs = NODE_FIELDS.TSEnumMember;
        validate(defs.id, node, "id", id, 1);
        validate(defs.initializer, node, "initializer", initializer, 1);
        return node;
      }
      function tsModuleDeclaration(id, body) {
        const node = {
          type: "TSModuleDeclaration",
          id,
          body,
          kind: null
        };
        const defs = NODE_FIELDS.TSModuleDeclaration;
        validate(defs.id, node, "id", id, 1);
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function tsModuleBlock(body) {
        const node = {
          type: "TSModuleBlock",
          body
        };
        const defs = NODE_FIELDS.TSModuleBlock;
        validate(defs.body, node, "body", body, 1);
        return node;
      }
      function tsImportType(argument, qualifier = null, typeParameters = null) {
        const node = {
          type: "TSImportType",
          argument,
          qualifier,
          typeParameters
        };
        const defs = NODE_FIELDS.TSImportType;
        validate(defs.argument, node, "argument", argument, 1);
        validate(defs.qualifier, node, "qualifier", qualifier, 1);
        validate(defs.typeParameters, node, "typeParameters", typeParameters, 1);
        return node;
      }
      function tsImportEqualsDeclaration(id, moduleReference) {
        const node = {
          type: "TSImportEqualsDeclaration",
          id,
          moduleReference,
          isExport: null
        };
        const defs = NODE_FIELDS.TSImportEqualsDeclaration;
        validate(defs.id, node, "id", id, 1);
        validate(defs.moduleReference, node, "moduleReference", moduleReference, 1);
        return node;
      }
      function tsExternalModuleReference(expression) {
        const node = {
          type: "TSExternalModuleReference",
          expression
        };
        const defs = NODE_FIELDS.TSExternalModuleReference;
        validate(defs.expression, node, "expression", expression, 1);
        return node;
      }
      function tsNonNullExpression(expression) {
        const node = {
          type: "TSNonNullExpression",
          expression
        };
        const defs = NODE_FIELDS.TSNonNullExpression;
        validate(defs.expression, node, "expression", expression, 1);
        return node;
      }
      function tsExportAssignment(expression) {
        const node = {
          type: "TSExportAssignment",
          expression
        };
        const defs = NODE_FIELDS.TSExportAssignment;
        validate(defs.expression, node, "expression", expression, 1);
        return node;
      }
      function tsNamespaceExportDeclaration(id) {
        const node = {
          type: "TSNamespaceExportDeclaration",
          id
        };
        const defs = NODE_FIELDS.TSNamespaceExportDeclaration;
        validate(defs.id, node, "id", id, 1);
        return node;
      }
      function tsTypeAnnotation(typeAnnotation2) {
        const node = {
          type: "TSTypeAnnotation",
          typeAnnotation: typeAnnotation2
        };
        const defs = NODE_FIELDS.TSTypeAnnotation;
        validate(defs.typeAnnotation, node, "typeAnnotation", typeAnnotation2, 1);
        return node;
      }
      function tsTypeParameterInstantiation(params) {
        const node = {
          type: "TSTypeParameterInstantiation",
          params
        };
        const defs = NODE_FIELDS.TSTypeParameterInstantiation;
        validate(defs.params, node, "params", params, 1);
        return node;
      }
      function tsTypeParameterDeclaration(params) {
        const node = {
          type: "TSTypeParameterDeclaration",
          params
        };
        const defs = NODE_FIELDS.TSTypeParameterDeclaration;
        validate(defs.params, node, "params", params, 1);
        return node;
      }
      function tsTypeParameter(constraint = null, _default = null, name) {
        const node = {
          type: "TSTypeParameter",
          constraint,
          default: _default,
          name
        };
        const defs = NODE_FIELDS.TSTypeParameter;
        validate(defs.constraint, node, "constraint", constraint, 1);
        validate(defs.default, node, "default", _default, 1);
        validate(defs.name, node, "name", name);
        return node;
      }
      function NumberLiteral(value) {
        (0, _deprecationWarning.default)("NumberLiteral", "NumericLiteral", "The node type ");
        return numericLiteral(value);
      }
      function RegexLiteral(pattern, flags = "") {
        (0, _deprecationWarning.default)("RegexLiteral", "RegExpLiteral", "The node type ");
        return regExpLiteral(pattern, flags);
      }
      function RestProperty(argument) {
        (0, _deprecationWarning.default)("RestProperty", "RestElement", "The node type ");
        return restElement(argument);
      }
      function SpreadProperty(argument) {
        (0, _deprecationWarning.default)("SpreadProperty", "SpreadElement", "The node type ");
        return spreadElement(argument);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/generated/uppercase.js
  var require_uppercase = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/generated/uppercase.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.JSXIdentifier = exports8.JSXFragment = exports8.JSXExpressionContainer = exports8.JSXEmptyExpression = exports8.JSXElement = exports8.JSXClosingFragment = exports8.JSXClosingElement = exports8.JSXAttribute = exports8.IntersectionTypeAnnotation = exports8.InterpreterDirective = exports8.InterfaceTypeAnnotation = exports8.InterfaceExtends = exports8.InterfaceDeclaration = exports8.InferredPredicate = exports8.IndexedAccessType = exports8.ImportSpecifier = exports8.ImportNamespaceSpecifier = exports8.ImportExpression = exports8.ImportDefaultSpecifier = exports8.ImportDeclaration = exports8.ImportAttribute = exports8.Import = exports8.IfStatement = exports8.Identifier = exports8.GenericTypeAnnotation = exports8.FunctionTypeParam = exports8.FunctionTypeAnnotation = exports8.FunctionExpression = exports8.FunctionDeclaration = exports8.ForStatement = exports8.ForOfStatement = exports8.ForInStatement = exports8.File = exports8.ExpressionStatement = exports8.ExportSpecifier = exports8.ExportNamespaceSpecifier = exports8.ExportNamedDeclaration = exports8.ExportDefaultSpecifier = exports8.ExportDefaultDeclaration = exports8.ExportAllDeclaration = exports8.ExistsTypeAnnotation = exports8.EnumSymbolBody = exports8.EnumStringMember = exports8.EnumStringBody = exports8.EnumNumberMember = exports8.EnumNumberBody = exports8.EnumDefaultedMember = exports8.EnumDeclaration = exports8.EnumBooleanMember = exports8.EnumBooleanBody = exports8.EmptyTypeAnnotation = exports8.EmptyStatement = exports8.DoWhileStatement = exports8.DoExpression = exports8.DirectiveLiteral = exports8.Directive = exports8.Decorator = exports8.DeclaredPredicate = exports8.DeclareVariable = exports8.DeclareTypeAlias = exports8.DeclareOpaqueType = exports8.DeclareModuleExports = exports8.DeclareModule = exports8.DeclareInterface = exports8.DeclareFunction = exports8.DeclareExportDeclaration = exports8.DeclareExportAllDeclaration = exports8.DeclareClass = exports8.DecimalLiteral = exports8.DebuggerStatement = exports8.ContinueStatement = exports8.ConditionalExpression = exports8.ClassProperty = exports8.ClassPrivateProperty = exports8.ClassPrivateMethod = exports8.ClassMethod = exports8.ClassImplements = exports8.ClassExpression = exports8.ClassDeclaration = exports8.ClassBody = exports8.ClassAccessorProperty = exports8.CatchClause = exports8.CallExpression = exports8.BreakStatement = exports8.BooleanTypeAnnotation = exports8.BooleanLiteralTypeAnnotation = exports8.BooleanLiteral = exports8.BlockStatement = exports8.BindExpression = exports8.BinaryExpression = exports8.BigIntLiteral = exports8.AwaitExpression = exports8.AssignmentPattern = exports8.AssignmentExpression = exports8.ArrowFunctionExpression = exports8.ArrayTypeAnnotation = exports8.ArrayPattern = exports8.ArrayExpression = exports8.ArgumentPlaceholder = exports8.AnyTypeAnnotation = void 0;
      exports8.TSNumberKeyword = exports8.TSNullKeyword = exports8.TSNonNullExpression = exports8.TSNeverKeyword = exports8.TSNamespaceExportDeclaration = exports8.TSNamedTupleMember = exports8.TSModuleDeclaration = exports8.TSModuleBlock = exports8.TSMethodSignature = exports8.TSMappedType = exports8.TSLiteralType = exports8.TSIntrinsicKeyword = exports8.TSIntersectionType = exports8.TSInterfaceDeclaration = exports8.TSInterfaceBody = exports8.TSInstantiationExpression = exports8.TSInferType = exports8.TSIndexedAccessType = exports8.TSIndexSignature = exports8.TSImportType = exports8.TSImportEqualsDeclaration = exports8.TSFunctionType = exports8.TSExternalModuleReference = exports8.TSExpressionWithTypeArguments = exports8.TSExportAssignment = exports8.TSEnumMember = exports8.TSEnumDeclaration = exports8.TSEnumBody = exports8.TSDeclareMethod = exports8.TSDeclareFunction = exports8.TSConstructorType = exports8.TSConstructSignatureDeclaration = exports8.TSConditionalType = exports8.TSCallSignatureDeclaration = exports8.TSBooleanKeyword = exports8.TSBigIntKeyword = exports8.TSAsExpression = exports8.TSArrayType = exports8.TSAnyKeyword = exports8.SymbolTypeAnnotation = exports8.SwitchStatement = exports8.SwitchCase = exports8.Super = exports8.StringTypeAnnotation = exports8.StringLiteralTypeAnnotation = exports8.StringLiteral = exports8.StaticBlock = exports8.SpreadProperty = exports8.SpreadElement = exports8.SequenceExpression = exports8.ReturnStatement = exports8.RestProperty = exports8.RestElement = exports8.RegexLiteral = exports8.RegExpLiteral = exports8.RecordExpression = exports8.QualifiedTypeIdentifier = exports8.Program = exports8.PrivateName = exports8.Placeholder = exports8.PipelineTopicExpression = exports8.PipelinePrimaryTopicReference = exports8.PipelineBareFunction = exports8.ParenthesizedExpression = exports8.OptionalMemberExpression = exports8.OptionalIndexedAccessType = exports8.OptionalCallExpression = exports8.OpaqueType = exports8.ObjectTypeSpreadProperty = exports8.ObjectTypeProperty = exports8.ObjectTypeInternalSlot = exports8.ObjectTypeIndexer = exports8.ObjectTypeCallProperty = exports8.ObjectTypeAnnotation = exports8.ObjectProperty = exports8.ObjectPattern = exports8.ObjectMethod = exports8.ObjectExpression = exports8.NumericLiteral = exports8.NumberTypeAnnotation = exports8.NumberLiteralTypeAnnotation = exports8.NumberLiteral = exports8.NullableTypeAnnotation = exports8.NullLiteralTypeAnnotation = exports8.NullLiteral = exports8.Noop = exports8.NewExpression = exports8.ModuleExpression = exports8.MixedTypeAnnotation = exports8.MetaProperty = exports8.MemberExpression = exports8.LogicalExpression = exports8.LabeledStatement = exports8.JSXText = exports8.JSXSpreadChild = exports8.JSXSpreadAttribute = exports8.JSXOpeningFragment = exports8.JSXOpeningElement = exports8.JSXNamespacedName = exports8.JSXMemberExpression = void 0;
      exports8.YieldExpression = exports8.WithStatement = exports8.WhileStatement = exports8.VoidTypeAnnotation = exports8.VoidPattern = exports8.Variance = exports8.VariableDeclarator = exports8.VariableDeclaration = exports8.V8IntrinsicIdentifier = exports8.UpdateExpression = exports8.UnionTypeAnnotation = exports8.UnaryExpression = exports8.TypeofTypeAnnotation = exports8.TypeParameterInstantiation = exports8.TypeParameterDeclaration = exports8.TypeParameter = exports8.TypeCastExpression = exports8.TypeAnnotation = exports8.TypeAlias = exports8.TupleTypeAnnotation = exports8.TupleExpression = exports8.TryStatement = exports8.TopicReference = exports8.ThrowStatement = exports8.ThisTypeAnnotation = exports8.ThisExpression = exports8.TemplateLiteral = exports8.TemplateElement = exports8.TaggedTemplateExpression = exports8.TSVoidKeyword = exports8.TSUnknownKeyword = exports8.TSUnionType = exports8.TSUndefinedKeyword = exports8.TSTypeReference = exports8.TSTypeQuery = exports8.TSTypePredicate = exports8.TSTypeParameterInstantiation = exports8.TSTypeParameterDeclaration = exports8.TSTypeParameter = exports8.TSTypeOperator = exports8.TSTypeLiteral = exports8.TSTypeAssertion = exports8.TSTypeAnnotation = exports8.TSTypeAliasDeclaration = exports8.TSTupleType = exports8.TSThisType = exports8.TSTemplateLiteralType = exports8.TSSymbolKeyword = exports8.TSStringKeyword = exports8.TSSatisfiesExpression = exports8.TSRestType = exports8.TSQualifiedName = exports8.TSPropertySignature = exports8.TSParenthesizedType = exports8.TSParameterProperty = exports8.TSOptionalType = exports8.TSObjectKeyword = void 0;
      var b = require_lowercase();
      var _deprecationWarning = require_deprecationWarning();
      function alias(lowercase) {
        {
          return b[lowercase];
        }
      }
      var ArrayExpression = exports8.ArrayExpression = alias("arrayExpression");
      var AssignmentExpression = exports8.AssignmentExpression = alias("assignmentExpression");
      var BinaryExpression = exports8.BinaryExpression = alias("binaryExpression");
      var InterpreterDirective = exports8.InterpreterDirective = alias("interpreterDirective");
      var Directive = exports8.Directive = alias("directive");
      var DirectiveLiteral = exports8.DirectiveLiteral = alias("directiveLiteral");
      var BlockStatement = exports8.BlockStatement = alias("blockStatement");
      var BreakStatement = exports8.BreakStatement = alias("breakStatement");
      var CallExpression = exports8.CallExpression = alias("callExpression");
      var CatchClause = exports8.CatchClause = alias("catchClause");
      var ConditionalExpression = exports8.ConditionalExpression = alias("conditionalExpression");
      var ContinueStatement = exports8.ContinueStatement = alias("continueStatement");
      var DebuggerStatement = exports8.DebuggerStatement = alias("debuggerStatement");
      var DoWhileStatement = exports8.DoWhileStatement = alias("doWhileStatement");
      var EmptyStatement = exports8.EmptyStatement = alias("emptyStatement");
      var ExpressionStatement = exports8.ExpressionStatement = alias("expressionStatement");
      var File = exports8.File = alias("file");
      var ForInStatement = exports8.ForInStatement = alias("forInStatement");
      var ForStatement = exports8.ForStatement = alias("forStatement");
      var FunctionDeclaration = exports8.FunctionDeclaration = alias("functionDeclaration");
      var FunctionExpression = exports8.FunctionExpression = alias("functionExpression");
      var Identifier = exports8.Identifier = alias("identifier");
      var IfStatement = exports8.IfStatement = alias("ifStatement");
      var LabeledStatement = exports8.LabeledStatement = alias("labeledStatement");
      var StringLiteral = exports8.StringLiteral = alias("stringLiteral");
      var NumericLiteral = exports8.NumericLiteral = alias("numericLiteral");
      var NullLiteral = exports8.NullLiteral = alias("nullLiteral");
      var BooleanLiteral = exports8.BooleanLiteral = alias("booleanLiteral");
      var RegExpLiteral = exports8.RegExpLiteral = alias("regExpLiteral");
      var LogicalExpression = exports8.LogicalExpression = alias("logicalExpression");
      var MemberExpression = exports8.MemberExpression = alias("memberExpression");
      var NewExpression = exports8.NewExpression = alias("newExpression");
      var Program = exports8.Program = alias("program");
      var ObjectExpression = exports8.ObjectExpression = alias("objectExpression");
      var ObjectMethod = exports8.ObjectMethod = alias("objectMethod");
      var ObjectProperty = exports8.ObjectProperty = alias("objectProperty");
      var RestElement = exports8.RestElement = alias("restElement");
      var ReturnStatement = exports8.ReturnStatement = alias("returnStatement");
      var SequenceExpression = exports8.SequenceExpression = alias("sequenceExpression");
      var ParenthesizedExpression = exports8.ParenthesizedExpression = alias("parenthesizedExpression");
      var SwitchCase = exports8.SwitchCase = alias("switchCase");
      var SwitchStatement = exports8.SwitchStatement = alias("switchStatement");
      var ThisExpression = exports8.ThisExpression = alias("thisExpression");
      var ThrowStatement = exports8.ThrowStatement = alias("throwStatement");
      var TryStatement = exports8.TryStatement = alias("tryStatement");
      var UnaryExpression = exports8.UnaryExpression = alias("unaryExpression");
      var UpdateExpression = exports8.UpdateExpression = alias("updateExpression");
      var VariableDeclaration = exports8.VariableDeclaration = alias("variableDeclaration");
      var VariableDeclarator = exports8.VariableDeclarator = alias("variableDeclarator");
      var WhileStatement = exports8.WhileStatement = alias("whileStatement");
      var WithStatement = exports8.WithStatement = alias("withStatement");
      var AssignmentPattern = exports8.AssignmentPattern = alias("assignmentPattern");
      var ArrayPattern = exports8.ArrayPattern = alias("arrayPattern");
      var ArrowFunctionExpression = exports8.ArrowFunctionExpression = alias("arrowFunctionExpression");
      var ClassBody = exports8.ClassBody = alias("classBody");
      var ClassExpression = exports8.ClassExpression = alias("classExpression");
      var ClassDeclaration = exports8.ClassDeclaration = alias("classDeclaration");
      var ExportAllDeclaration = exports8.ExportAllDeclaration = alias("exportAllDeclaration");
      var ExportDefaultDeclaration = exports8.ExportDefaultDeclaration = alias("exportDefaultDeclaration");
      var ExportNamedDeclaration = exports8.ExportNamedDeclaration = alias("exportNamedDeclaration");
      var ExportSpecifier = exports8.ExportSpecifier = alias("exportSpecifier");
      var ForOfStatement = exports8.ForOfStatement = alias("forOfStatement");
      var ImportDeclaration = exports8.ImportDeclaration = alias("importDeclaration");
      var ImportDefaultSpecifier = exports8.ImportDefaultSpecifier = alias("importDefaultSpecifier");
      var ImportNamespaceSpecifier = exports8.ImportNamespaceSpecifier = alias("importNamespaceSpecifier");
      var ImportSpecifier = exports8.ImportSpecifier = alias("importSpecifier");
      var ImportExpression = exports8.ImportExpression = alias("importExpression");
      var MetaProperty = exports8.MetaProperty = alias("metaProperty");
      var ClassMethod = exports8.ClassMethod = alias("classMethod");
      var ObjectPattern = exports8.ObjectPattern = alias("objectPattern");
      var SpreadElement = exports8.SpreadElement = alias("spreadElement");
      var Super = exports8.Super = alias("super");
      var TaggedTemplateExpression = exports8.TaggedTemplateExpression = alias("taggedTemplateExpression");
      var TemplateElement = exports8.TemplateElement = alias("templateElement");
      var TemplateLiteral = exports8.TemplateLiteral = alias("templateLiteral");
      var YieldExpression = exports8.YieldExpression = alias("yieldExpression");
      var AwaitExpression = exports8.AwaitExpression = alias("awaitExpression");
      var Import = exports8.Import = alias("import");
      var BigIntLiteral = exports8.BigIntLiteral = alias("bigIntLiteral");
      var ExportNamespaceSpecifier = exports8.ExportNamespaceSpecifier = alias("exportNamespaceSpecifier");
      var OptionalMemberExpression = exports8.OptionalMemberExpression = alias("optionalMemberExpression");
      var OptionalCallExpression = exports8.OptionalCallExpression = alias("optionalCallExpression");
      var ClassProperty = exports8.ClassProperty = alias("classProperty");
      var ClassAccessorProperty = exports8.ClassAccessorProperty = alias("classAccessorProperty");
      var ClassPrivateProperty = exports8.ClassPrivateProperty = alias("classPrivateProperty");
      var ClassPrivateMethod = exports8.ClassPrivateMethod = alias("classPrivateMethod");
      var PrivateName = exports8.PrivateName = alias("privateName");
      var StaticBlock = exports8.StaticBlock = alias("staticBlock");
      var ImportAttribute = exports8.ImportAttribute = alias("importAttribute");
      var AnyTypeAnnotation = exports8.AnyTypeAnnotation = alias("anyTypeAnnotation");
      var ArrayTypeAnnotation = exports8.ArrayTypeAnnotation = alias("arrayTypeAnnotation");
      var BooleanTypeAnnotation = exports8.BooleanTypeAnnotation = alias("booleanTypeAnnotation");
      var BooleanLiteralTypeAnnotation = exports8.BooleanLiteralTypeAnnotation = alias("booleanLiteralTypeAnnotation");
      var NullLiteralTypeAnnotation = exports8.NullLiteralTypeAnnotation = alias("nullLiteralTypeAnnotation");
      var ClassImplements = exports8.ClassImplements = alias("classImplements");
      var DeclareClass = exports8.DeclareClass = alias("declareClass");
      var DeclareFunction = exports8.DeclareFunction = alias("declareFunction");
      var DeclareInterface = exports8.DeclareInterface = alias("declareInterface");
      var DeclareModule = exports8.DeclareModule = alias("declareModule");
      var DeclareModuleExports = exports8.DeclareModuleExports = alias("declareModuleExports");
      var DeclareTypeAlias = exports8.DeclareTypeAlias = alias("declareTypeAlias");
      var DeclareOpaqueType = exports8.DeclareOpaqueType = alias("declareOpaqueType");
      var DeclareVariable = exports8.DeclareVariable = alias("declareVariable");
      var DeclareExportDeclaration = exports8.DeclareExportDeclaration = alias("declareExportDeclaration");
      var DeclareExportAllDeclaration = exports8.DeclareExportAllDeclaration = alias("declareExportAllDeclaration");
      var DeclaredPredicate = exports8.DeclaredPredicate = alias("declaredPredicate");
      var ExistsTypeAnnotation = exports8.ExistsTypeAnnotation = alias("existsTypeAnnotation");
      var FunctionTypeAnnotation = exports8.FunctionTypeAnnotation = alias("functionTypeAnnotation");
      var FunctionTypeParam = exports8.FunctionTypeParam = alias("functionTypeParam");
      var GenericTypeAnnotation = exports8.GenericTypeAnnotation = alias("genericTypeAnnotation");
      var InferredPredicate = exports8.InferredPredicate = alias("inferredPredicate");
      var InterfaceExtends = exports8.InterfaceExtends = alias("interfaceExtends");
      var InterfaceDeclaration = exports8.InterfaceDeclaration = alias("interfaceDeclaration");
      var InterfaceTypeAnnotation = exports8.InterfaceTypeAnnotation = alias("interfaceTypeAnnotation");
      var IntersectionTypeAnnotation = exports8.IntersectionTypeAnnotation = alias("intersectionTypeAnnotation");
      var MixedTypeAnnotation = exports8.MixedTypeAnnotation = alias("mixedTypeAnnotation");
      var EmptyTypeAnnotation = exports8.EmptyTypeAnnotation = alias("emptyTypeAnnotation");
      var NullableTypeAnnotation = exports8.NullableTypeAnnotation = alias("nullableTypeAnnotation");
      var NumberLiteralTypeAnnotation = exports8.NumberLiteralTypeAnnotation = alias("numberLiteralTypeAnnotation");
      var NumberTypeAnnotation = exports8.NumberTypeAnnotation = alias("numberTypeAnnotation");
      var ObjectTypeAnnotation = exports8.ObjectTypeAnnotation = alias("objectTypeAnnotation");
      var ObjectTypeInternalSlot = exports8.ObjectTypeInternalSlot = alias("objectTypeInternalSlot");
      var ObjectTypeCallProperty = exports8.ObjectTypeCallProperty = alias("objectTypeCallProperty");
      var ObjectTypeIndexer = exports8.ObjectTypeIndexer = alias("objectTypeIndexer");
      var ObjectTypeProperty = exports8.ObjectTypeProperty = alias("objectTypeProperty");
      var ObjectTypeSpreadProperty = exports8.ObjectTypeSpreadProperty = alias("objectTypeSpreadProperty");
      var OpaqueType = exports8.OpaqueType = alias("opaqueType");
      var QualifiedTypeIdentifier = exports8.QualifiedTypeIdentifier = alias("qualifiedTypeIdentifier");
      var StringLiteralTypeAnnotation = exports8.StringLiteralTypeAnnotation = alias("stringLiteralTypeAnnotation");
      var StringTypeAnnotation = exports8.StringTypeAnnotation = alias("stringTypeAnnotation");
      var SymbolTypeAnnotation = exports8.SymbolTypeAnnotation = alias("symbolTypeAnnotation");
      var ThisTypeAnnotation = exports8.ThisTypeAnnotation = alias("thisTypeAnnotation");
      var TupleTypeAnnotation = exports8.TupleTypeAnnotation = alias("tupleTypeAnnotation");
      var TypeofTypeAnnotation = exports8.TypeofTypeAnnotation = alias("typeofTypeAnnotation");
      var TypeAlias = exports8.TypeAlias = alias("typeAlias");
      var TypeAnnotation = exports8.TypeAnnotation = alias("typeAnnotation");
      var TypeCastExpression = exports8.TypeCastExpression = alias("typeCastExpression");
      var TypeParameter = exports8.TypeParameter = alias("typeParameter");
      var TypeParameterDeclaration = exports8.TypeParameterDeclaration = alias("typeParameterDeclaration");
      var TypeParameterInstantiation = exports8.TypeParameterInstantiation = alias("typeParameterInstantiation");
      var UnionTypeAnnotation = exports8.UnionTypeAnnotation = alias("unionTypeAnnotation");
      var Variance = exports8.Variance = alias("variance");
      var VoidTypeAnnotation = exports8.VoidTypeAnnotation = alias("voidTypeAnnotation");
      var EnumDeclaration = exports8.EnumDeclaration = alias("enumDeclaration");
      var EnumBooleanBody = exports8.EnumBooleanBody = alias("enumBooleanBody");
      var EnumNumberBody = exports8.EnumNumberBody = alias("enumNumberBody");
      var EnumStringBody = exports8.EnumStringBody = alias("enumStringBody");
      var EnumSymbolBody = exports8.EnumSymbolBody = alias("enumSymbolBody");
      var EnumBooleanMember = exports8.EnumBooleanMember = alias("enumBooleanMember");
      var EnumNumberMember = exports8.EnumNumberMember = alias("enumNumberMember");
      var EnumStringMember = exports8.EnumStringMember = alias("enumStringMember");
      var EnumDefaultedMember = exports8.EnumDefaultedMember = alias("enumDefaultedMember");
      var IndexedAccessType = exports8.IndexedAccessType = alias("indexedAccessType");
      var OptionalIndexedAccessType = exports8.OptionalIndexedAccessType = alias("optionalIndexedAccessType");
      var JSXAttribute = exports8.JSXAttribute = alias("jsxAttribute");
      var JSXClosingElement = exports8.JSXClosingElement = alias("jsxClosingElement");
      var JSXElement = exports8.JSXElement = alias("jsxElement");
      var JSXEmptyExpression = exports8.JSXEmptyExpression = alias("jsxEmptyExpression");
      var JSXExpressionContainer = exports8.JSXExpressionContainer = alias("jsxExpressionContainer");
      var JSXSpreadChild = exports8.JSXSpreadChild = alias("jsxSpreadChild");
      var JSXIdentifier = exports8.JSXIdentifier = alias("jsxIdentifier");
      var JSXMemberExpression = exports8.JSXMemberExpression = alias("jsxMemberExpression");
      var JSXNamespacedName = exports8.JSXNamespacedName = alias("jsxNamespacedName");
      var JSXOpeningElement = exports8.JSXOpeningElement = alias("jsxOpeningElement");
      var JSXSpreadAttribute = exports8.JSXSpreadAttribute = alias("jsxSpreadAttribute");
      var JSXText = exports8.JSXText = alias("jsxText");
      var JSXFragment = exports8.JSXFragment = alias("jsxFragment");
      var JSXOpeningFragment = exports8.JSXOpeningFragment = alias("jsxOpeningFragment");
      var JSXClosingFragment = exports8.JSXClosingFragment = alias("jsxClosingFragment");
      var Noop = exports8.Noop = alias("noop");
      var Placeholder = exports8.Placeholder = alias("placeholder");
      var V8IntrinsicIdentifier = exports8.V8IntrinsicIdentifier = alias("v8IntrinsicIdentifier");
      var ArgumentPlaceholder = exports8.ArgumentPlaceholder = alias("argumentPlaceholder");
      var BindExpression = exports8.BindExpression = alias("bindExpression");
      var Decorator = exports8.Decorator = alias("decorator");
      var DoExpression = exports8.DoExpression = alias("doExpression");
      var ExportDefaultSpecifier = exports8.ExportDefaultSpecifier = alias("exportDefaultSpecifier");
      var RecordExpression = exports8.RecordExpression = alias("recordExpression");
      var TupleExpression = exports8.TupleExpression = alias("tupleExpression");
      var DecimalLiteral = exports8.DecimalLiteral = alias("decimalLiteral");
      var ModuleExpression = exports8.ModuleExpression = alias("moduleExpression");
      var TopicReference = exports8.TopicReference = alias("topicReference");
      var PipelineTopicExpression = exports8.PipelineTopicExpression = alias("pipelineTopicExpression");
      var PipelineBareFunction = exports8.PipelineBareFunction = alias("pipelineBareFunction");
      var PipelinePrimaryTopicReference = exports8.PipelinePrimaryTopicReference = alias("pipelinePrimaryTopicReference");
      var VoidPattern = exports8.VoidPattern = alias("voidPattern");
      var TSParameterProperty = exports8.TSParameterProperty = alias("tsParameterProperty");
      var TSDeclareFunction = exports8.TSDeclareFunction = alias("tsDeclareFunction");
      var TSDeclareMethod = exports8.TSDeclareMethod = alias("tsDeclareMethod");
      var TSQualifiedName = exports8.TSQualifiedName = alias("tsQualifiedName");
      var TSCallSignatureDeclaration = exports8.TSCallSignatureDeclaration = alias("tsCallSignatureDeclaration");
      var TSConstructSignatureDeclaration = exports8.TSConstructSignatureDeclaration = alias("tsConstructSignatureDeclaration");
      var TSPropertySignature = exports8.TSPropertySignature = alias("tsPropertySignature");
      var TSMethodSignature = exports8.TSMethodSignature = alias("tsMethodSignature");
      var TSIndexSignature = exports8.TSIndexSignature = alias("tsIndexSignature");
      var TSAnyKeyword = exports8.TSAnyKeyword = alias("tsAnyKeyword");
      var TSBooleanKeyword = exports8.TSBooleanKeyword = alias("tsBooleanKeyword");
      var TSBigIntKeyword = exports8.TSBigIntKeyword = alias("tsBigIntKeyword");
      var TSIntrinsicKeyword = exports8.TSIntrinsicKeyword = alias("tsIntrinsicKeyword");
      var TSNeverKeyword = exports8.TSNeverKeyword = alias("tsNeverKeyword");
      var TSNullKeyword = exports8.TSNullKeyword = alias("tsNullKeyword");
      var TSNumberKeyword = exports8.TSNumberKeyword = alias("tsNumberKeyword");
      var TSObjectKeyword = exports8.TSObjectKeyword = alias("tsObjectKeyword");
      var TSStringKeyword = exports8.TSStringKeyword = alias("tsStringKeyword");
      var TSSymbolKeyword = exports8.TSSymbolKeyword = alias("tsSymbolKeyword");
      var TSUndefinedKeyword = exports8.TSUndefinedKeyword = alias("tsUndefinedKeyword");
      var TSUnknownKeyword = exports8.TSUnknownKeyword = alias("tsUnknownKeyword");
      var TSVoidKeyword = exports8.TSVoidKeyword = alias("tsVoidKeyword");
      var TSThisType = exports8.TSThisType = alias("tsThisType");
      var TSFunctionType = exports8.TSFunctionType = alias("tsFunctionType");
      var TSConstructorType = exports8.TSConstructorType = alias("tsConstructorType");
      var TSTypeReference = exports8.TSTypeReference = alias("tsTypeReference");
      var TSTypePredicate = exports8.TSTypePredicate = alias("tsTypePredicate");
      var TSTypeQuery = exports8.TSTypeQuery = alias("tsTypeQuery");
      var TSTypeLiteral = exports8.TSTypeLiteral = alias("tsTypeLiteral");
      var TSArrayType = exports8.TSArrayType = alias("tsArrayType");
      var TSTupleType = exports8.TSTupleType = alias("tsTupleType");
      var TSOptionalType = exports8.TSOptionalType = alias("tsOptionalType");
      var TSRestType = exports8.TSRestType = alias("tsRestType");
      var TSNamedTupleMember = exports8.TSNamedTupleMember = alias("tsNamedTupleMember");
      var TSUnionType = exports8.TSUnionType = alias("tsUnionType");
      var TSIntersectionType = exports8.TSIntersectionType = alias("tsIntersectionType");
      var TSConditionalType = exports8.TSConditionalType = alias("tsConditionalType");
      var TSInferType = exports8.TSInferType = alias("tsInferType");
      var TSParenthesizedType = exports8.TSParenthesizedType = alias("tsParenthesizedType");
      var TSTypeOperator = exports8.TSTypeOperator = alias("tsTypeOperator");
      var TSIndexedAccessType = exports8.TSIndexedAccessType = alias("tsIndexedAccessType");
      var TSMappedType = exports8.TSMappedType = alias("tsMappedType");
      var TSTemplateLiteralType = exports8.TSTemplateLiteralType = alias("tsTemplateLiteralType");
      var TSLiteralType = exports8.TSLiteralType = alias("tsLiteralType");
      var TSExpressionWithTypeArguments = exports8.TSExpressionWithTypeArguments = alias("tsExpressionWithTypeArguments");
      var TSInterfaceDeclaration = exports8.TSInterfaceDeclaration = alias("tsInterfaceDeclaration");
      var TSInterfaceBody = exports8.TSInterfaceBody = alias("tsInterfaceBody");
      var TSTypeAliasDeclaration = exports8.TSTypeAliasDeclaration = alias("tsTypeAliasDeclaration");
      var TSInstantiationExpression = exports8.TSInstantiationExpression = alias("tsInstantiationExpression");
      var TSAsExpression = exports8.TSAsExpression = alias("tsAsExpression");
      var TSSatisfiesExpression = exports8.TSSatisfiesExpression = alias("tsSatisfiesExpression");
      var TSTypeAssertion = exports8.TSTypeAssertion = alias("tsTypeAssertion");
      var TSEnumBody = exports8.TSEnumBody = alias("tsEnumBody");
      var TSEnumDeclaration = exports8.TSEnumDeclaration = alias("tsEnumDeclaration");
      var TSEnumMember = exports8.TSEnumMember = alias("tsEnumMember");
      var TSModuleDeclaration = exports8.TSModuleDeclaration = alias("tsModuleDeclaration");
      var TSModuleBlock = exports8.TSModuleBlock = alias("tsModuleBlock");
      var TSImportType = exports8.TSImportType = alias("tsImportType");
      var TSImportEqualsDeclaration = exports8.TSImportEqualsDeclaration = alias("tsImportEqualsDeclaration");
      var TSExternalModuleReference = exports8.TSExternalModuleReference = alias("tsExternalModuleReference");
      var TSNonNullExpression = exports8.TSNonNullExpression = alias("tsNonNullExpression");
      var TSExportAssignment = exports8.TSExportAssignment = alias("tsExportAssignment");
      var TSNamespaceExportDeclaration = exports8.TSNamespaceExportDeclaration = alias("tsNamespaceExportDeclaration");
      var TSTypeAnnotation = exports8.TSTypeAnnotation = alias("tsTypeAnnotation");
      var TSTypeParameterInstantiation = exports8.TSTypeParameterInstantiation = alias("tsTypeParameterInstantiation");
      var TSTypeParameterDeclaration = exports8.TSTypeParameterDeclaration = alias("tsTypeParameterDeclaration");
      var TSTypeParameter = exports8.TSTypeParameter = alias("tsTypeParameter");
      var NumberLiteral = exports8.NumberLiteral = b.numberLiteral;
      var RegexLiteral = exports8.RegexLiteral = b.regexLiteral;
      var RestProperty = exports8.RestProperty = b.restProperty;
      var SpreadProperty = exports8.SpreadProperty = b.spreadProperty;
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/generated/index.js
  var require_generated2 = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/generated/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      var _lowercase = require_lowercase();
      Object.keys(_lowercase).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports8 && exports8[key] === _lowercase[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _lowercase[key];
          }
        });
      });
      var _uppercase = require_uppercase();
      Object.keys(_uppercase).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports8 && exports8[key] === _uppercase[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _uppercase[key];
          }
        });
      });
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/utils/react/cleanJSXElementLiteralChild.js
  var require_cleanJSXElementLiteralChild = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/utils/react/cleanJSXElementLiteralChild.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = cleanJSXElementLiteralChild;
      var _index = require_generated2();
      var _index2 = require_lib5();
      function cleanJSXElementLiteralChild(child, args) {
        const lines = child.value.split(/\r\n|\n|\r/);
        let lastNonEmptyLine = 0;
        for (let i = 0; i < lines.length; i++) {
          if (/[^ \t]/.exec(lines[i])) {
            lastNonEmptyLine = i;
          }
        }
        let str = "";
        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          const isFirstLine = i === 0;
          const isLastLine = i === lines.length - 1;
          const isLastNonEmptyLine = i === lastNonEmptyLine;
          let trimmedLine = line.replace(/\t/g, " ");
          if (!isFirstLine) {
            trimmedLine = trimmedLine.replace(/^ +/, "");
          }
          if (!isLastLine) {
            trimmedLine = trimmedLine.replace(/ +$/, "");
          }
          if (trimmedLine) {
            if (!isLastNonEmptyLine) {
              trimmedLine += " ";
            }
            str += trimmedLine;
          }
        }
        if (str)
          args.push((0, _index2.inherits)((0, _index.stringLiteral)(str), child));
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/react/buildChildren.js
  var require_buildChildren = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/react/buildChildren.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = buildChildren;
      var _index = require_generated();
      var _cleanJSXElementLiteralChild = require_cleanJSXElementLiteralChild();
      function buildChildren(node) {
        const elements = [];
        for (let i = 0; i < node.children.length; i++) {
          let child = node.children[i];
          if ((0, _index.isJSXText)(child)) {
            (0, _cleanJSXElementLiteralChild.default)(child, elements);
            continue;
          }
          if ((0, _index.isJSXExpressionContainer)(child))
            child = child.expression;
          if ((0, _index.isJSXEmptyExpression)(child))
            continue;
          elements.push(child);
        }
        return elements;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isNode.js
  var require_isNode = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isNode.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = isNode;
      var _index = require_definitions();
      function isNode(node) {
        return !!(node && _index.VISITOR_KEYS[node.type]);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/asserts/assertNode.js
  var require_assertNode = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/asserts/assertNode.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = assertNode;
      var _isNode = require_isNode();
      function assertNode(node) {
        if (!(0, _isNode.default)(node)) {
          var _node$type;
          const type = (_node$type = node == null ? void 0 : node.type) != null ? _node$type : JSON.stringify(node);
          throw new TypeError(`Not a valid node of type "${type}"`);
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/asserts/generated/index.js
  var require_generated3 = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/asserts/generated/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.assertAccessor = assertAccessor;
      exports8.assertAnyTypeAnnotation = assertAnyTypeAnnotation;
      exports8.assertArgumentPlaceholder = assertArgumentPlaceholder;
      exports8.assertArrayExpression = assertArrayExpression;
      exports8.assertArrayPattern = assertArrayPattern;
      exports8.assertArrayTypeAnnotation = assertArrayTypeAnnotation;
      exports8.assertArrowFunctionExpression = assertArrowFunctionExpression;
      exports8.assertAssignmentExpression = assertAssignmentExpression;
      exports8.assertAssignmentPattern = assertAssignmentPattern;
      exports8.assertAwaitExpression = assertAwaitExpression;
      exports8.assertBigIntLiteral = assertBigIntLiteral;
      exports8.assertBinary = assertBinary;
      exports8.assertBinaryExpression = assertBinaryExpression;
      exports8.assertBindExpression = assertBindExpression;
      exports8.assertBlock = assertBlock;
      exports8.assertBlockParent = assertBlockParent;
      exports8.assertBlockStatement = assertBlockStatement;
      exports8.assertBooleanLiteral = assertBooleanLiteral;
      exports8.assertBooleanLiteralTypeAnnotation = assertBooleanLiteralTypeAnnotation;
      exports8.assertBooleanTypeAnnotation = assertBooleanTypeAnnotation;
      exports8.assertBreakStatement = assertBreakStatement;
      exports8.assertCallExpression = assertCallExpression;
      exports8.assertCatchClause = assertCatchClause;
      exports8.assertClass = assertClass;
      exports8.assertClassAccessorProperty = assertClassAccessorProperty;
      exports8.assertClassBody = assertClassBody;
      exports8.assertClassDeclaration = assertClassDeclaration;
      exports8.assertClassExpression = assertClassExpression;
      exports8.assertClassImplements = assertClassImplements;
      exports8.assertClassMethod = assertClassMethod;
      exports8.assertClassPrivateMethod = assertClassPrivateMethod;
      exports8.assertClassPrivateProperty = assertClassPrivateProperty;
      exports8.assertClassProperty = assertClassProperty;
      exports8.assertCompletionStatement = assertCompletionStatement;
      exports8.assertConditional = assertConditional;
      exports8.assertConditionalExpression = assertConditionalExpression;
      exports8.assertContinueStatement = assertContinueStatement;
      exports8.assertDebuggerStatement = assertDebuggerStatement;
      exports8.assertDecimalLiteral = assertDecimalLiteral;
      exports8.assertDeclaration = assertDeclaration;
      exports8.assertDeclareClass = assertDeclareClass;
      exports8.assertDeclareExportAllDeclaration = assertDeclareExportAllDeclaration;
      exports8.assertDeclareExportDeclaration = assertDeclareExportDeclaration;
      exports8.assertDeclareFunction = assertDeclareFunction;
      exports8.assertDeclareInterface = assertDeclareInterface;
      exports8.assertDeclareModule = assertDeclareModule;
      exports8.assertDeclareModuleExports = assertDeclareModuleExports;
      exports8.assertDeclareOpaqueType = assertDeclareOpaqueType;
      exports8.assertDeclareTypeAlias = assertDeclareTypeAlias;
      exports8.assertDeclareVariable = assertDeclareVariable;
      exports8.assertDeclaredPredicate = assertDeclaredPredicate;
      exports8.assertDecorator = assertDecorator;
      exports8.assertDirective = assertDirective;
      exports8.assertDirectiveLiteral = assertDirectiveLiteral;
      exports8.assertDoExpression = assertDoExpression;
      exports8.assertDoWhileStatement = assertDoWhileStatement;
      exports8.assertEmptyStatement = assertEmptyStatement;
      exports8.assertEmptyTypeAnnotation = assertEmptyTypeAnnotation;
      exports8.assertEnumBody = assertEnumBody;
      exports8.assertEnumBooleanBody = assertEnumBooleanBody;
      exports8.assertEnumBooleanMember = assertEnumBooleanMember;
      exports8.assertEnumDeclaration = assertEnumDeclaration;
      exports8.assertEnumDefaultedMember = assertEnumDefaultedMember;
      exports8.assertEnumMember = assertEnumMember;
      exports8.assertEnumNumberBody = assertEnumNumberBody;
      exports8.assertEnumNumberMember = assertEnumNumberMember;
      exports8.assertEnumStringBody = assertEnumStringBody;
      exports8.assertEnumStringMember = assertEnumStringMember;
      exports8.assertEnumSymbolBody = assertEnumSymbolBody;
      exports8.assertExistsTypeAnnotation = assertExistsTypeAnnotation;
      exports8.assertExportAllDeclaration = assertExportAllDeclaration;
      exports8.assertExportDeclaration = assertExportDeclaration;
      exports8.assertExportDefaultDeclaration = assertExportDefaultDeclaration;
      exports8.assertExportDefaultSpecifier = assertExportDefaultSpecifier;
      exports8.assertExportNamedDeclaration = assertExportNamedDeclaration;
      exports8.assertExportNamespaceSpecifier = assertExportNamespaceSpecifier;
      exports8.assertExportSpecifier = assertExportSpecifier;
      exports8.assertExpression = assertExpression;
      exports8.assertExpressionStatement = assertExpressionStatement;
      exports8.assertExpressionWrapper = assertExpressionWrapper;
      exports8.assertFile = assertFile;
      exports8.assertFlow = assertFlow;
      exports8.assertFlowBaseAnnotation = assertFlowBaseAnnotation;
      exports8.assertFlowDeclaration = assertFlowDeclaration;
      exports8.assertFlowPredicate = assertFlowPredicate;
      exports8.assertFlowType = assertFlowType;
      exports8.assertFor = assertFor;
      exports8.assertForInStatement = assertForInStatement;
      exports8.assertForOfStatement = assertForOfStatement;
      exports8.assertForStatement = assertForStatement;
      exports8.assertForXStatement = assertForXStatement;
      exports8.assertFunction = assertFunction;
      exports8.assertFunctionDeclaration = assertFunctionDeclaration;
      exports8.assertFunctionExpression = assertFunctionExpression;
      exports8.assertFunctionParameter = assertFunctionParameter;
      exports8.assertFunctionParent = assertFunctionParent;
      exports8.assertFunctionTypeAnnotation = assertFunctionTypeAnnotation;
      exports8.assertFunctionTypeParam = assertFunctionTypeParam;
      exports8.assertGenericTypeAnnotation = assertGenericTypeAnnotation;
      exports8.assertIdentifier = assertIdentifier;
      exports8.assertIfStatement = assertIfStatement;
      exports8.assertImmutable = assertImmutable;
      exports8.assertImport = assertImport;
      exports8.assertImportAttribute = assertImportAttribute;
      exports8.assertImportDeclaration = assertImportDeclaration;
      exports8.assertImportDefaultSpecifier = assertImportDefaultSpecifier;
      exports8.assertImportExpression = assertImportExpression;
      exports8.assertImportNamespaceSpecifier = assertImportNamespaceSpecifier;
      exports8.assertImportOrExportDeclaration = assertImportOrExportDeclaration;
      exports8.assertImportSpecifier = assertImportSpecifier;
      exports8.assertIndexedAccessType = assertIndexedAccessType;
      exports8.assertInferredPredicate = assertInferredPredicate;
      exports8.assertInterfaceDeclaration = assertInterfaceDeclaration;
      exports8.assertInterfaceExtends = assertInterfaceExtends;
      exports8.assertInterfaceTypeAnnotation = assertInterfaceTypeAnnotation;
      exports8.assertInterpreterDirective = assertInterpreterDirective;
      exports8.assertIntersectionTypeAnnotation = assertIntersectionTypeAnnotation;
      exports8.assertJSX = assertJSX;
      exports8.assertJSXAttribute = assertJSXAttribute;
      exports8.assertJSXClosingElement = assertJSXClosingElement;
      exports8.assertJSXClosingFragment = assertJSXClosingFragment;
      exports8.assertJSXElement = assertJSXElement;
      exports8.assertJSXEmptyExpression = assertJSXEmptyExpression;
      exports8.assertJSXExpressionContainer = assertJSXExpressionContainer;
      exports8.assertJSXFragment = assertJSXFragment;
      exports8.assertJSXIdentifier = assertJSXIdentifier;
      exports8.assertJSXMemberExpression = assertJSXMemberExpression;
      exports8.assertJSXNamespacedName = assertJSXNamespacedName;
      exports8.assertJSXOpeningElement = assertJSXOpeningElement;
      exports8.assertJSXOpeningFragment = assertJSXOpeningFragment;
      exports8.assertJSXSpreadAttribute = assertJSXSpreadAttribute;
      exports8.assertJSXSpreadChild = assertJSXSpreadChild;
      exports8.assertJSXText = assertJSXText;
      exports8.assertLVal = assertLVal;
      exports8.assertLabeledStatement = assertLabeledStatement;
      exports8.assertLiteral = assertLiteral;
      exports8.assertLogicalExpression = assertLogicalExpression;
      exports8.assertLoop = assertLoop;
      exports8.assertMemberExpression = assertMemberExpression;
      exports8.assertMetaProperty = assertMetaProperty;
      exports8.assertMethod = assertMethod;
      exports8.assertMiscellaneous = assertMiscellaneous;
      exports8.assertMixedTypeAnnotation = assertMixedTypeAnnotation;
      exports8.assertModuleDeclaration = assertModuleDeclaration;
      exports8.assertModuleExpression = assertModuleExpression;
      exports8.assertModuleSpecifier = assertModuleSpecifier;
      exports8.assertNewExpression = assertNewExpression;
      exports8.assertNoop = assertNoop;
      exports8.assertNullLiteral = assertNullLiteral;
      exports8.assertNullLiteralTypeAnnotation = assertNullLiteralTypeAnnotation;
      exports8.assertNullableTypeAnnotation = assertNullableTypeAnnotation;
      exports8.assertNumberLiteral = assertNumberLiteral;
      exports8.assertNumberLiteralTypeAnnotation = assertNumberLiteralTypeAnnotation;
      exports8.assertNumberTypeAnnotation = assertNumberTypeAnnotation;
      exports8.assertNumericLiteral = assertNumericLiteral;
      exports8.assertObjectExpression = assertObjectExpression;
      exports8.assertObjectMember = assertObjectMember;
      exports8.assertObjectMethod = assertObjectMethod;
      exports8.assertObjectPattern = assertObjectPattern;
      exports8.assertObjectProperty = assertObjectProperty;
      exports8.assertObjectTypeAnnotation = assertObjectTypeAnnotation;
      exports8.assertObjectTypeCallProperty = assertObjectTypeCallProperty;
      exports8.assertObjectTypeIndexer = assertObjectTypeIndexer;
      exports8.assertObjectTypeInternalSlot = assertObjectTypeInternalSlot;
      exports8.assertObjectTypeProperty = assertObjectTypeProperty;
      exports8.assertObjectTypeSpreadProperty = assertObjectTypeSpreadProperty;
      exports8.assertOpaqueType = assertOpaqueType;
      exports8.assertOptionalCallExpression = assertOptionalCallExpression;
      exports8.assertOptionalIndexedAccessType = assertOptionalIndexedAccessType;
      exports8.assertOptionalMemberExpression = assertOptionalMemberExpression;
      exports8.assertParenthesizedExpression = assertParenthesizedExpression;
      exports8.assertPattern = assertPattern;
      exports8.assertPatternLike = assertPatternLike;
      exports8.assertPipelineBareFunction = assertPipelineBareFunction;
      exports8.assertPipelinePrimaryTopicReference = assertPipelinePrimaryTopicReference;
      exports8.assertPipelineTopicExpression = assertPipelineTopicExpression;
      exports8.assertPlaceholder = assertPlaceholder;
      exports8.assertPrivate = assertPrivate;
      exports8.assertPrivateName = assertPrivateName;
      exports8.assertProgram = assertProgram;
      exports8.assertProperty = assertProperty;
      exports8.assertPureish = assertPureish;
      exports8.assertQualifiedTypeIdentifier = assertQualifiedTypeIdentifier;
      exports8.assertRecordExpression = assertRecordExpression;
      exports8.assertRegExpLiteral = assertRegExpLiteral;
      exports8.assertRegexLiteral = assertRegexLiteral;
      exports8.assertRestElement = assertRestElement;
      exports8.assertRestProperty = assertRestProperty;
      exports8.assertReturnStatement = assertReturnStatement;
      exports8.assertScopable = assertScopable;
      exports8.assertSequenceExpression = assertSequenceExpression;
      exports8.assertSpreadElement = assertSpreadElement;
      exports8.assertSpreadProperty = assertSpreadProperty;
      exports8.assertStandardized = assertStandardized;
      exports8.assertStatement = assertStatement;
      exports8.assertStaticBlock = assertStaticBlock;
      exports8.assertStringLiteral = assertStringLiteral;
      exports8.assertStringLiteralTypeAnnotation = assertStringLiteralTypeAnnotation;
      exports8.assertStringTypeAnnotation = assertStringTypeAnnotation;
      exports8.assertSuper = assertSuper;
      exports8.assertSwitchCase = assertSwitchCase;
      exports8.assertSwitchStatement = assertSwitchStatement;
      exports8.assertSymbolTypeAnnotation = assertSymbolTypeAnnotation;
      exports8.assertTSAnyKeyword = assertTSAnyKeyword;
      exports8.assertTSArrayType = assertTSArrayType;
      exports8.assertTSAsExpression = assertTSAsExpression;
      exports8.assertTSBaseType = assertTSBaseType;
      exports8.assertTSBigIntKeyword = assertTSBigIntKeyword;
      exports8.assertTSBooleanKeyword = assertTSBooleanKeyword;
      exports8.assertTSCallSignatureDeclaration = assertTSCallSignatureDeclaration;
      exports8.assertTSConditionalType = assertTSConditionalType;
      exports8.assertTSConstructSignatureDeclaration = assertTSConstructSignatureDeclaration;
      exports8.assertTSConstructorType = assertTSConstructorType;
      exports8.assertTSDeclareFunction = assertTSDeclareFunction;
      exports8.assertTSDeclareMethod = assertTSDeclareMethod;
      exports8.assertTSEntityName = assertTSEntityName;
      exports8.assertTSEnumBody = assertTSEnumBody;
      exports8.assertTSEnumDeclaration = assertTSEnumDeclaration;
      exports8.assertTSEnumMember = assertTSEnumMember;
      exports8.assertTSExportAssignment = assertTSExportAssignment;
      exports8.assertTSExpressionWithTypeArguments = assertTSExpressionWithTypeArguments;
      exports8.assertTSExternalModuleReference = assertTSExternalModuleReference;
      exports8.assertTSFunctionType = assertTSFunctionType;
      exports8.assertTSImportEqualsDeclaration = assertTSImportEqualsDeclaration;
      exports8.assertTSImportType = assertTSImportType;
      exports8.assertTSIndexSignature = assertTSIndexSignature;
      exports8.assertTSIndexedAccessType = assertTSIndexedAccessType;
      exports8.assertTSInferType = assertTSInferType;
      exports8.assertTSInstantiationExpression = assertTSInstantiationExpression;
      exports8.assertTSInterfaceBody = assertTSInterfaceBody;
      exports8.assertTSInterfaceDeclaration = assertTSInterfaceDeclaration;
      exports8.assertTSIntersectionType = assertTSIntersectionType;
      exports8.assertTSIntrinsicKeyword = assertTSIntrinsicKeyword;
      exports8.assertTSLiteralType = assertTSLiteralType;
      exports8.assertTSMappedType = assertTSMappedType;
      exports8.assertTSMethodSignature = assertTSMethodSignature;
      exports8.assertTSModuleBlock = assertTSModuleBlock;
      exports8.assertTSModuleDeclaration = assertTSModuleDeclaration;
      exports8.assertTSNamedTupleMember = assertTSNamedTupleMember;
      exports8.assertTSNamespaceExportDeclaration = assertTSNamespaceExportDeclaration;
      exports8.assertTSNeverKeyword = assertTSNeverKeyword;
      exports8.assertTSNonNullExpression = assertTSNonNullExpression;
      exports8.assertTSNullKeyword = assertTSNullKeyword;
      exports8.assertTSNumberKeyword = assertTSNumberKeyword;
      exports8.assertTSObjectKeyword = assertTSObjectKeyword;
      exports8.assertTSOptionalType = assertTSOptionalType;
      exports8.assertTSParameterProperty = assertTSParameterProperty;
      exports8.assertTSParenthesizedType = assertTSParenthesizedType;
      exports8.assertTSPropertySignature = assertTSPropertySignature;
      exports8.assertTSQualifiedName = assertTSQualifiedName;
      exports8.assertTSRestType = assertTSRestType;
      exports8.assertTSSatisfiesExpression = assertTSSatisfiesExpression;
      exports8.assertTSStringKeyword = assertTSStringKeyword;
      exports8.assertTSSymbolKeyword = assertTSSymbolKeyword;
      exports8.assertTSTemplateLiteralType = assertTSTemplateLiteralType;
      exports8.assertTSThisType = assertTSThisType;
      exports8.assertTSTupleType = assertTSTupleType;
      exports8.assertTSType = assertTSType;
      exports8.assertTSTypeAliasDeclaration = assertTSTypeAliasDeclaration;
      exports8.assertTSTypeAnnotation = assertTSTypeAnnotation;
      exports8.assertTSTypeAssertion = assertTSTypeAssertion;
      exports8.assertTSTypeElement = assertTSTypeElement;
      exports8.assertTSTypeLiteral = assertTSTypeLiteral;
      exports8.assertTSTypeOperator = assertTSTypeOperator;
      exports8.assertTSTypeParameter = assertTSTypeParameter;
      exports8.assertTSTypeParameterDeclaration = assertTSTypeParameterDeclaration;
      exports8.assertTSTypeParameterInstantiation = assertTSTypeParameterInstantiation;
      exports8.assertTSTypePredicate = assertTSTypePredicate;
      exports8.assertTSTypeQuery = assertTSTypeQuery;
      exports8.assertTSTypeReference = assertTSTypeReference;
      exports8.assertTSUndefinedKeyword = assertTSUndefinedKeyword;
      exports8.assertTSUnionType = assertTSUnionType;
      exports8.assertTSUnknownKeyword = assertTSUnknownKeyword;
      exports8.assertTSVoidKeyword = assertTSVoidKeyword;
      exports8.assertTaggedTemplateExpression = assertTaggedTemplateExpression;
      exports8.assertTemplateElement = assertTemplateElement;
      exports8.assertTemplateLiteral = assertTemplateLiteral;
      exports8.assertTerminatorless = assertTerminatorless;
      exports8.assertThisExpression = assertThisExpression;
      exports8.assertThisTypeAnnotation = assertThisTypeAnnotation;
      exports8.assertThrowStatement = assertThrowStatement;
      exports8.assertTopicReference = assertTopicReference;
      exports8.assertTryStatement = assertTryStatement;
      exports8.assertTupleExpression = assertTupleExpression;
      exports8.assertTupleTypeAnnotation = assertTupleTypeAnnotation;
      exports8.assertTypeAlias = assertTypeAlias;
      exports8.assertTypeAnnotation = assertTypeAnnotation;
      exports8.assertTypeCastExpression = assertTypeCastExpression;
      exports8.assertTypeParameter = assertTypeParameter;
      exports8.assertTypeParameterDeclaration = assertTypeParameterDeclaration;
      exports8.assertTypeParameterInstantiation = assertTypeParameterInstantiation;
      exports8.assertTypeScript = assertTypeScript;
      exports8.assertTypeofTypeAnnotation = assertTypeofTypeAnnotation;
      exports8.assertUnaryExpression = assertUnaryExpression;
      exports8.assertUnaryLike = assertUnaryLike;
      exports8.assertUnionTypeAnnotation = assertUnionTypeAnnotation;
      exports8.assertUpdateExpression = assertUpdateExpression;
      exports8.assertUserWhitespacable = assertUserWhitespacable;
      exports8.assertV8IntrinsicIdentifier = assertV8IntrinsicIdentifier;
      exports8.assertVariableDeclaration = assertVariableDeclaration;
      exports8.assertVariableDeclarator = assertVariableDeclarator;
      exports8.assertVariance = assertVariance;
      exports8.assertVoidPattern = assertVoidPattern;
      exports8.assertVoidTypeAnnotation = assertVoidTypeAnnotation;
      exports8.assertWhile = assertWhile;
      exports8.assertWhileStatement = assertWhileStatement;
      exports8.assertWithStatement = assertWithStatement;
      exports8.assertYieldExpression = assertYieldExpression;
      var _is = require_is();
      var _deprecationWarning = require_deprecationWarning();
      function assert3(type, node, opts) {
        if (!(0, _is.default)(type, node, opts)) {
          throw new Error(`Expected type "${type}" with option ${JSON.stringify(opts)}, but instead got "${node.type}".`);
        }
      }
      function assertArrayExpression(node, opts) {
        assert3("ArrayExpression", node, opts);
      }
      function assertAssignmentExpression(node, opts) {
        assert3("AssignmentExpression", node, opts);
      }
      function assertBinaryExpression(node, opts) {
        assert3("BinaryExpression", node, opts);
      }
      function assertInterpreterDirective(node, opts) {
        assert3("InterpreterDirective", node, opts);
      }
      function assertDirective(node, opts) {
        assert3("Directive", node, opts);
      }
      function assertDirectiveLiteral(node, opts) {
        assert3("DirectiveLiteral", node, opts);
      }
      function assertBlockStatement(node, opts) {
        assert3("BlockStatement", node, opts);
      }
      function assertBreakStatement(node, opts) {
        assert3("BreakStatement", node, opts);
      }
      function assertCallExpression(node, opts) {
        assert3("CallExpression", node, opts);
      }
      function assertCatchClause(node, opts) {
        assert3("CatchClause", node, opts);
      }
      function assertConditionalExpression(node, opts) {
        assert3("ConditionalExpression", node, opts);
      }
      function assertContinueStatement(node, opts) {
        assert3("ContinueStatement", node, opts);
      }
      function assertDebuggerStatement(node, opts) {
        assert3("DebuggerStatement", node, opts);
      }
      function assertDoWhileStatement(node, opts) {
        assert3("DoWhileStatement", node, opts);
      }
      function assertEmptyStatement(node, opts) {
        assert3("EmptyStatement", node, opts);
      }
      function assertExpressionStatement(node, opts) {
        assert3("ExpressionStatement", node, opts);
      }
      function assertFile(node, opts) {
        assert3("File", node, opts);
      }
      function assertForInStatement(node, opts) {
        assert3("ForInStatement", node, opts);
      }
      function assertForStatement(node, opts) {
        assert3("ForStatement", node, opts);
      }
      function assertFunctionDeclaration(node, opts) {
        assert3("FunctionDeclaration", node, opts);
      }
      function assertFunctionExpression(node, opts) {
        assert3("FunctionExpression", node, opts);
      }
      function assertIdentifier(node, opts) {
        assert3("Identifier", node, opts);
      }
      function assertIfStatement(node, opts) {
        assert3("IfStatement", node, opts);
      }
      function assertLabeledStatement(node, opts) {
        assert3("LabeledStatement", node, opts);
      }
      function assertStringLiteral(node, opts) {
        assert3("StringLiteral", node, opts);
      }
      function assertNumericLiteral(node, opts) {
        assert3("NumericLiteral", node, opts);
      }
      function assertNullLiteral(node, opts) {
        assert3("NullLiteral", node, opts);
      }
      function assertBooleanLiteral(node, opts) {
        assert3("BooleanLiteral", node, opts);
      }
      function assertRegExpLiteral(node, opts) {
        assert3("RegExpLiteral", node, opts);
      }
      function assertLogicalExpression(node, opts) {
        assert3("LogicalExpression", node, opts);
      }
      function assertMemberExpression(node, opts) {
        assert3("MemberExpression", node, opts);
      }
      function assertNewExpression(node, opts) {
        assert3("NewExpression", node, opts);
      }
      function assertProgram(node, opts) {
        assert3("Program", node, opts);
      }
      function assertObjectExpression(node, opts) {
        assert3("ObjectExpression", node, opts);
      }
      function assertObjectMethod(node, opts) {
        assert3("ObjectMethod", node, opts);
      }
      function assertObjectProperty(node, opts) {
        assert3("ObjectProperty", node, opts);
      }
      function assertRestElement(node, opts) {
        assert3("RestElement", node, opts);
      }
      function assertReturnStatement(node, opts) {
        assert3("ReturnStatement", node, opts);
      }
      function assertSequenceExpression(node, opts) {
        assert3("SequenceExpression", node, opts);
      }
      function assertParenthesizedExpression(node, opts) {
        assert3("ParenthesizedExpression", node, opts);
      }
      function assertSwitchCase(node, opts) {
        assert3("SwitchCase", node, opts);
      }
      function assertSwitchStatement(node, opts) {
        assert3("SwitchStatement", node, opts);
      }
      function assertThisExpression(node, opts) {
        assert3("ThisExpression", node, opts);
      }
      function assertThrowStatement(node, opts) {
        assert3("ThrowStatement", node, opts);
      }
      function assertTryStatement(node, opts) {
        assert3("TryStatement", node, opts);
      }
      function assertUnaryExpression(node, opts) {
        assert3("UnaryExpression", node, opts);
      }
      function assertUpdateExpression(node, opts) {
        assert3("UpdateExpression", node, opts);
      }
      function assertVariableDeclaration(node, opts) {
        assert3("VariableDeclaration", node, opts);
      }
      function assertVariableDeclarator(node, opts) {
        assert3("VariableDeclarator", node, opts);
      }
      function assertWhileStatement(node, opts) {
        assert3("WhileStatement", node, opts);
      }
      function assertWithStatement(node, opts) {
        assert3("WithStatement", node, opts);
      }
      function assertAssignmentPattern(node, opts) {
        assert3("AssignmentPattern", node, opts);
      }
      function assertArrayPattern(node, opts) {
        assert3("ArrayPattern", node, opts);
      }
      function assertArrowFunctionExpression(node, opts) {
        assert3("ArrowFunctionExpression", node, opts);
      }
      function assertClassBody(node, opts) {
        assert3("ClassBody", node, opts);
      }
      function assertClassExpression(node, opts) {
        assert3("ClassExpression", node, opts);
      }
      function assertClassDeclaration(node, opts) {
        assert3("ClassDeclaration", node, opts);
      }
      function assertExportAllDeclaration(node, opts) {
        assert3("ExportAllDeclaration", node, opts);
      }
      function assertExportDefaultDeclaration(node, opts) {
        assert3("ExportDefaultDeclaration", node, opts);
      }
      function assertExportNamedDeclaration(node, opts) {
        assert3("ExportNamedDeclaration", node, opts);
      }
      function assertExportSpecifier(node, opts) {
        assert3("ExportSpecifier", node, opts);
      }
      function assertForOfStatement(node, opts) {
        assert3("ForOfStatement", node, opts);
      }
      function assertImportDeclaration(node, opts) {
        assert3("ImportDeclaration", node, opts);
      }
      function assertImportDefaultSpecifier(node, opts) {
        assert3("ImportDefaultSpecifier", node, opts);
      }
      function assertImportNamespaceSpecifier(node, opts) {
        assert3("ImportNamespaceSpecifier", node, opts);
      }
      function assertImportSpecifier(node, opts) {
        assert3("ImportSpecifier", node, opts);
      }
      function assertImportExpression(node, opts) {
        assert3("ImportExpression", node, opts);
      }
      function assertMetaProperty(node, opts) {
        assert3("MetaProperty", node, opts);
      }
      function assertClassMethod(node, opts) {
        assert3("ClassMethod", node, opts);
      }
      function assertObjectPattern(node, opts) {
        assert3("ObjectPattern", node, opts);
      }
      function assertSpreadElement(node, opts) {
        assert3("SpreadElement", node, opts);
      }
      function assertSuper(node, opts) {
        assert3("Super", node, opts);
      }
      function assertTaggedTemplateExpression(node, opts) {
        assert3("TaggedTemplateExpression", node, opts);
      }
      function assertTemplateElement(node, opts) {
        assert3("TemplateElement", node, opts);
      }
      function assertTemplateLiteral(node, opts) {
        assert3("TemplateLiteral", node, opts);
      }
      function assertYieldExpression(node, opts) {
        assert3("YieldExpression", node, opts);
      }
      function assertAwaitExpression(node, opts) {
        assert3("AwaitExpression", node, opts);
      }
      function assertImport(node, opts) {
        assert3("Import", node, opts);
      }
      function assertBigIntLiteral(node, opts) {
        assert3("BigIntLiteral", node, opts);
      }
      function assertExportNamespaceSpecifier(node, opts) {
        assert3("ExportNamespaceSpecifier", node, opts);
      }
      function assertOptionalMemberExpression(node, opts) {
        assert3("OptionalMemberExpression", node, opts);
      }
      function assertOptionalCallExpression(node, opts) {
        assert3("OptionalCallExpression", node, opts);
      }
      function assertClassProperty(node, opts) {
        assert3("ClassProperty", node, opts);
      }
      function assertClassAccessorProperty(node, opts) {
        assert3("ClassAccessorProperty", node, opts);
      }
      function assertClassPrivateProperty(node, opts) {
        assert3("ClassPrivateProperty", node, opts);
      }
      function assertClassPrivateMethod(node, opts) {
        assert3("ClassPrivateMethod", node, opts);
      }
      function assertPrivateName(node, opts) {
        assert3("PrivateName", node, opts);
      }
      function assertStaticBlock(node, opts) {
        assert3("StaticBlock", node, opts);
      }
      function assertImportAttribute(node, opts) {
        assert3("ImportAttribute", node, opts);
      }
      function assertAnyTypeAnnotation(node, opts) {
        assert3("AnyTypeAnnotation", node, opts);
      }
      function assertArrayTypeAnnotation(node, opts) {
        assert3("ArrayTypeAnnotation", node, opts);
      }
      function assertBooleanTypeAnnotation(node, opts) {
        assert3("BooleanTypeAnnotation", node, opts);
      }
      function assertBooleanLiteralTypeAnnotation(node, opts) {
        assert3("BooleanLiteralTypeAnnotation", node, opts);
      }
      function assertNullLiteralTypeAnnotation(node, opts) {
        assert3("NullLiteralTypeAnnotation", node, opts);
      }
      function assertClassImplements(node, opts) {
        assert3("ClassImplements", node, opts);
      }
      function assertDeclareClass(node, opts) {
        assert3("DeclareClass", node, opts);
      }
      function assertDeclareFunction(node, opts) {
        assert3("DeclareFunction", node, opts);
      }
      function assertDeclareInterface(node, opts) {
        assert3("DeclareInterface", node, opts);
      }
      function assertDeclareModule(node, opts) {
        assert3("DeclareModule", node, opts);
      }
      function assertDeclareModuleExports(node, opts) {
        assert3("DeclareModuleExports", node, opts);
      }
      function assertDeclareTypeAlias(node, opts) {
        assert3("DeclareTypeAlias", node, opts);
      }
      function assertDeclareOpaqueType(node, opts) {
        assert3("DeclareOpaqueType", node, opts);
      }
      function assertDeclareVariable(node, opts) {
        assert3("DeclareVariable", node, opts);
      }
      function assertDeclareExportDeclaration(node, opts) {
        assert3("DeclareExportDeclaration", node, opts);
      }
      function assertDeclareExportAllDeclaration(node, opts) {
        assert3("DeclareExportAllDeclaration", node, opts);
      }
      function assertDeclaredPredicate(node, opts) {
        assert3("DeclaredPredicate", node, opts);
      }
      function assertExistsTypeAnnotation(node, opts) {
        assert3("ExistsTypeAnnotation", node, opts);
      }
      function assertFunctionTypeAnnotation(node, opts) {
        assert3("FunctionTypeAnnotation", node, opts);
      }
      function assertFunctionTypeParam(node, opts) {
        assert3("FunctionTypeParam", node, opts);
      }
      function assertGenericTypeAnnotation(node, opts) {
        assert3("GenericTypeAnnotation", node, opts);
      }
      function assertInferredPredicate(node, opts) {
        assert3("InferredPredicate", node, opts);
      }
      function assertInterfaceExtends(node, opts) {
        assert3("InterfaceExtends", node, opts);
      }
      function assertInterfaceDeclaration(node, opts) {
        assert3("InterfaceDeclaration", node, opts);
      }
      function assertInterfaceTypeAnnotation(node, opts) {
        assert3("InterfaceTypeAnnotation", node, opts);
      }
      function assertIntersectionTypeAnnotation(node, opts) {
        assert3("IntersectionTypeAnnotation", node, opts);
      }
      function assertMixedTypeAnnotation(node, opts) {
        assert3("MixedTypeAnnotation", node, opts);
      }
      function assertEmptyTypeAnnotation(node, opts) {
        assert3("EmptyTypeAnnotation", node, opts);
      }
      function assertNullableTypeAnnotation(node, opts) {
        assert3("NullableTypeAnnotation", node, opts);
      }
      function assertNumberLiteralTypeAnnotation(node, opts) {
        assert3("NumberLiteralTypeAnnotation", node, opts);
      }
      function assertNumberTypeAnnotation(node, opts) {
        assert3("NumberTypeAnnotation", node, opts);
      }
      function assertObjectTypeAnnotation(node, opts) {
        assert3("ObjectTypeAnnotation", node, opts);
      }
      function assertObjectTypeInternalSlot(node, opts) {
        assert3("ObjectTypeInternalSlot", node, opts);
      }
      function assertObjectTypeCallProperty(node, opts) {
        assert3("ObjectTypeCallProperty", node, opts);
      }
      function assertObjectTypeIndexer(node, opts) {
        assert3("ObjectTypeIndexer", node, opts);
      }
      function assertObjectTypeProperty(node, opts) {
        assert3("ObjectTypeProperty", node, opts);
      }
      function assertObjectTypeSpreadProperty(node, opts) {
        assert3("ObjectTypeSpreadProperty", node, opts);
      }
      function assertOpaqueType(node, opts) {
        assert3("OpaqueType", node, opts);
      }
      function assertQualifiedTypeIdentifier(node, opts) {
        assert3("QualifiedTypeIdentifier", node, opts);
      }
      function assertStringLiteralTypeAnnotation(node, opts) {
        assert3("StringLiteralTypeAnnotation", node, opts);
      }
      function assertStringTypeAnnotation(node, opts) {
        assert3("StringTypeAnnotation", node, opts);
      }
      function assertSymbolTypeAnnotation(node, opts) {
        assert3("SymbolTypeAnnotation", node, opts);
      }
      function assertThisTypeAnnotation(node, opts) {
        assert3("ThisTypeAnnotation", node, opts);
      }
      function assertTupleTypeAnnotation(node, opts) {
        assert3("TupleTypeAnnotation", node, opts);
      }
      function assertTypeofTypeAnnotation(node, opts) {
        assert3("TypeofTypeAnnotation", node, opts);
      }
      function assertTypeAlias(node, opts) {
        assert3("TypeAlias", node, opts);
      }
      function assertTypeAnnotation(node, opts) {
        assert3("TypeAnnotation", node, opts);
      }
      function assertTypeCastExpression(node, opts) {
        assert3("TypeCastExpression", node, opts);
      }
      function assertTypeParameter(node, opts) {
        assert3("TypeParameter", node, opts);
      }
      function assertTypeParameterDeclaration(node, opts) {
        assert3("TypeParameterDeclaration", node, opts);
      }
      function assertTypeParameterInstantiation(node, opts) {
        assert3("TypeParameterInstantiation", node, opts);
      }
      function assertUnionTypeAnnotation(node, opts) {
        assert3("UnionTypeAnnotation", node, opts);
      }
      function assertVariance(node, opts) {
        assert3("Variance", node, opts);
      }
      function assertVoidTypeAnnotation(node, opts) {
        assert3("VoidTypeAnnotation", node, opts);
      }
      function assertEnumDeclaration(node, opts) {
        assert3("EnumDeclaration", node, opts);
      }
      function assertEnumBooleanBody(node, opts) {
        assert3("EnumBooleanBody", node, opts);
      }
      function assertEnumNumberBody(node, opts) {
        assert3("EnumNumberBody", node, opts);
      }
      function assertEnumStringBody(node, opts) {
        assert3("EnumStringBody", node, opts);
      }
      function assertEnumSymbolBody(node, opts) {
        assert3("EnumSymbolBody", node, opts);
      }
      function assertEnumBooleanMember(node, opts) {
        assert3("EnumBooleanMember", node, opts);
      }
      function assertEnumNumberMember(node, opts) {
        assert3("EnumNumberMember", node, opts);
      }
      function assertEnumStringMember(node, opts) {
        assert3("EnumStringMember", node, opts);
      }
      function assertEnumDefaultedMember(node, opts) {
        assert3("EnumDefaultedMember", node, opts);
      }
      function assertIndexedAccessType(node, opts) {
        assert3("IndexedAccessType", node, opts);
      }
      function assertOptionalIndexedAccessType(node, opts) {
        assert3("OptionalIndexedAccessType", node, opts);
      }
      function assertJSXAttribute(node, opts) {
        assert3("JSXAttribute", node, opts);
      }
      function assertJSXClosingElement(node, opts) {
        assert3("JSXClosingElement", node, opts);
      }
      function assertJSXElement(node, opts) {
        assert3("JSXElement", node, opts);
      }
      function assertJSXEmptyExpression(node, opts) {
        assert3("JSXEmptyExpression", node, opts);
      }
      function assertJSXExpressionContainer(node, opts) {
        assert3("JSXExpressionContainer", node, opts);
      }
      function assertJSXSpreadChild(node, opts) {
        assert3("JSXSpreadChild", node, opts);
      }
      function assertJSXIdentifier(node, opts) {
        assert3("JSXIdentifier", node, opts);
      }
      function assertJSXMemberExpression(node, opts) {
        assert3("JSXMemberExpression", node, opts);
      }
      function assertJSXNamespacedName(node, opts) {
        assert3("JSXNamespacedName", node, opts);
      }
      function assertJSXOpeningElement(node, opts) {
        assert3("JSXOpeningElement", node, opts);
      }
      function assertJSXSpreadAttribute(node, opts) {
        assert3("JSXSpreadAttribute", node, opts);
      }
      function assertJSXText(node, opts) {
        assert3("JSXText", node, opts);
      }
      function assertJSXFragment(node, opts) {
        assert3("JSXFragment", node, opts);
      }
      function assertJSXOpeningFragment(node, opts) {
        assert3("JSXOpeningFragment", node, opts);
      }
      function assertJSXClosingFragment(node, opts) {
        assert3("JSXClosingFragment", node, opts);
      }
      function assertNoop(node, opts) {
        assert3("Noop", node, opts);
      }
      function assertPlaceholder(node, opts) {
        assert3("Placeholder", node, opts);
      }
      function assertV8IntrinsicIdentifier(node, opts) {
        assert3("V8IntrinsicIdentifier", node, opts);
      }
      function assertArgumentPlaceholder(node, opts) {
        assert3("ArgumentPlaceholder", node, opts);
      }
      function assertBindExpression(node, opts) {
        assert3("BindExpression", node, opts);
      }
      function assertDecorator(node, opts) {
        assert3("Decorator", node, opts);
      }
      function assertDoExpression(node, opts) {
        assert3("DoExpression", node, opts);
      }
      function assertExportDefaultSpecifier(node, opts) {
        assert3("ExportDefaultSpecifier", node, opts);
      }
      function assertRecordExpression(node, opts) {
        assert3("RecordExpression", node, opts);
      }
      function assertTupleExpression(node, opts) {
        assert3("TupleExpression", node, opts);
      }
      function assertDecimalLiteral(node, opts) {
        assert3("DecimalLiteral", node, opts);
      }
      function assertModuleExpression(node, opts) {
        assert3("ModuleExpression", node, opts);
      }
      function assertTopicReference(node, opts) {
        assert3("TopicReference", node, opts);
      }
      function assertPipelineTopicExpression(node, opts) {
        assert3("PipelineTopicExpression", node, opts);
      }
      function assertPipelineBareFunction(node, opts) {
        assert3("PipelineBareFunction", node, opts);
      }
      function assertPipelinePrimaryTopicReference(node, opts) {
        assert3("PipelinePrimaryTopicReference", node, opts);
      }
      function assertVoidPattern(node, opts) {
        assert3("VoidPattern", node, opts);
      }
      function assertTSParameterProperty(node, opts) {
        assert3("TSParameterProperty", node, opts);
      }
      function assertTSDeclareFunction(node, opts) {
        assert3("TSDeclareFunction", node, opts);
      }
      function assertTSDeclareMethod(node, opts) {
        assert3("TSDeclareMethod", node, opts);
      }
      function assertTSQualifiedName(node, opts) {
        assert3("TSQualifiedName", node, opts);
      }
      function assertTSCallSignatureDeclaration(node, opts) {
        assert3("TSCallSignatureDeclaration", node, opts);
      }
      function assertTSConstructSignatureDeclaration(node, opts) {
        assert3("TSConstructSignatureDeclaration", node, opts);
      }
      function assertTSPropertySignature(node, opts) {
        assert3("TSPropertySignature", node, opts);
      }
      function assertTSMethodSignature(node, opts) {
        assert3("TSMethodSignature", node, opts);
      }
      function assertTSIndexSignature(node, opts) {
        assert3("TSIndexSignature", node, opts);
      }
      function assertTSAnyKeyword(node, opts) {
        assert3("TSAnyKeyword", node, opts);
      }
      function assertTSBooleanKeyword(node, opts) {
        assert3("TSBooleanKeyword", node, opts);
      }
      function assertTSBigIntKeyword(node, opts) {
        assert3("TSBigIntKeyword", node, opts);
      }
      function assertTSIntrinsicKeyword(node, opts) {
        assert3("TSIntrinsicKeyword", node, opts);
      }
      function assertTSNeverKeyword(node, opts) {
        assert3("TSNeverKeyword", node, opts);
      }
      function assertTSNullKeyword(node, opts) {
        assert3("TSNullKeyword", node, opts);
      }
      function assertTSNumberKeyword(node, opts) {
        assert3("TSNumberKeyword", node, opts);
      }
      function assertTSObjectKeyword(node, opts) {
        assert3("TSObjectKeyword", node, opts);
      }
      function assertTSStringKeyword(node, opts) {
        assert3("TSStringKeyword", node, opts);
      }
      function assertTSSymbolKeyword(node, opts) {
        assert3("TSSymbolKeyword", node, opts);
      }
      function assertTSUndefinedKeyword(node, opts) {
        assert3("TSUndefinedKeyword", node, opts);
      }
      function assertTSUnknownKeyword(node, opts) {
        assert3("TSUnknownKeyword", node, opts);
      }
      function assertTSVoidKeyword(node, opts) {
        assert3("TSVoidKeyword", node, opts);
      }
      function assertTSThisType(node, opts) {
        assert3("TSThisType", node, opts);
      }
      function assertTSFunctionType(node, opts) {
        assert3("TSFunctionType", node, opts);
      }
      function assertTSConstructorType(node, opts) {
        assert3("TSConstructorType", node, opts);
      }
      function assertTSTypeReference(node, opts) {
        assert3("TSTypeReference", node, opts);
      }
      function assertTSTypePredicate(node, opts) {
        assert3("TSTypePredicate", node, opts);
      }
      function assertTSTypeQuery(node, opts) {
        assert3("TSTypeQuery", node, opts);
      }
      function assertTSTypeLiteral(node, opts) {
        assert3("TSTypeLiteral", node, opts);
      }
      function assertTSArrayType(node, opts) {
        assert3("TSArrayType", node, opts);
      }
      function assertTSTupleType(node, opts) {
        assert3("TSTupleType", node, opts);
      }
      function assertTSOptionalType(node, opts) {
        assert3("TSOptionalType", node, opts);
      }
      function assertTSRestType(node, opts) {
        assert3("TSRestType", node, opts);
      }
      function assertTSNamedTupleMember(node, opts) {
        assert3("TSNamedTupleMember", node, opts);
      }
      function assertTSUnionType(node, opts) {
        assert3("TSUnionType", node, opts);
      }
      function assertTSIntersectionType(node, opts) {
        assert3("TSIntersectionType", node, opts);
      }
      function assertTSConditionalType(node, opts) {
        assert3("TSConditionalType", node, opts);
      }
      function assertTSInferType(node, opts) {
        assert3("TSInferType", node, opts);
      }
      function assertTSParenthesizedType(node, opts) {
        assert3("TSParenthesizedType", node, opts);
      }
      function assertTSTypeOperator(node, opts) {
        assert3("TSTypeOperator", node, opts);
      }
      function assertTSIndexedAccessType(node, opts) {
        assert3("TSIndexedAccessType", node, opts);
      }
      function assertTSMappedType(node, opts) {
        assert3("TSMappedType", node, opts);
      }
      function assertTSTemplateLiteralType(node, opts) {
        assert3("TSTemplateLiteralType", node, opts);
      }
      function assertTSLiteralType(node, opts) {
        assert3("TSLiteralType", node, opts);
      }
      function assertTSExpressionWithTypeArguments(node, opts) {
        assert3("TSExpressionWithTypeArguments", node, opts);
      }
      function assertTSInterfaceDeclaration(node, opts) {
        assert3("TSInterfaceDeclaration", node, opts);
      }
      function assertTSInterfaceBody(node, opts) {
        assert3("TSInterfaceBody", node, opts);
      }
      function assertTSTypeAliasDeclaration(node, opts) {
        assert3("TSTypeAliasDeclaration", node, opts);
      }
      function assertTSInstantiationExpression(node, opts) {
        assert3("TSInstantiationExpression", node, opts);
      }
      function assertTSAsExpression(node, opts) {
        assert3("TSAsExpression", node, opts);
      }
      function assertTSSatisfiesExpression(node, opts) {
        assert3("TSSatisfiesExpression", node, opts);
      }
      function assertTSTypeAssertion(node, opts) {
        assert3("TSTypeAssertion", node, opts);
      }
      function assertTSEnumBody(node, opts) {
        assert3("TSEnumBody", node, opts);
      }
      function assertTSEnumDeclaration(node, opts) {
        assert3("TSEnumDeclaration", node, opts);
      }
      function assertTSEnumMember(node, opts) {
        assert3("TSEnumMember", node, opts);
      }
      function assertTSModuleDeclaration(node, opts) {
        assert3("TSModuleDeclaration", node, opts);
      }
      function assertTSModuleBlock(node, opts) {
        assert3("TSModuleBlock", node, opts);
      }
      function assertTSImportType(node, opts) {
        assert3("TSImportType", node, opts);
      }
      function assertTSImportEqualsDeclaration(node, opts) {
        assert3("TSImportEqualsDeclaration", node, opts);
      }
      function assertTSExternalModuleReference(node, opts) {
        assert3("TSExternalModuleReference", node, opts);
      }
      function assertTSNonNullExpression(node, opts) {
        assert3("TSNonNullExpression", node, opts);
      }
      function assertTSExportAssignment(node, opts) {
        assert3("TSExportAssignment", node, opts);
      }
      function assertTSNamespaceExportDeclaration(node, opts) {
        assert3("TSNamespaceExportDeclaration", node, opts);
      }
      function assertTSTypeAnnotation(node, opts) {
        assert3("TSTypeAnnotation", node, opts);
      }
      function assertTSTypeParameterInstantiation(node, opts) {
        assert3("TSTypeParameterInstantiation", node, opts);
      }
      function assertTSTypeParameterDeclaration(node, opts) {
        assert3("TSTypeParameterDeclaration", node, opts);
      }
      function assertTSTypeParameter(node, opts) {
        assert3("TSTypeParameter", node, opts);
      }
      function assertStandardized(node, opts) {
        assert3("Standardized", node, opts);
      }
      function assertExpression(node, opts) {
        assert3("Expression", node, opts);
      }
      function assertBinary(node, opts) {
        assert3("Binary", node, opts);
      }
      function assertScopable(node, opts) {
        assert3("Scopable", node, opts);
      }
      function assertBlockParent(node, opts) {
        assert3("BlockParent", node, opts);
      }
      function assertBlock(node, opts) {
        assert3("Block", node, opts);
      }
      function assertStatement(node, opts) {
        assert3("Statement", node, opts);
      }
      function assertTerminatorless(node, opts) {
        assert3("Terminatorless", node, opts);
      }
      function assertCompletionStatement(node, opts) {
        assert3("CompletionStatement", node, opts);
      }
      function assertConditional(node, opts) {
        assert3("Conditional", node, opts);
      }
      function assertLoop(node, opts) {
        assert3("Loop", node, opts);
      }
      function assertWhile(node, opts) {
        assert3("While", node, opts);
      }
      function assertExpressionWrapper(node, opts) {
        assert3("ExpressionWrapper", node, opts);
      }
      function assertFor(node, opts) {
        assert3("For", node, opts);
      }
      function assertForXStatement(node, opts) {
        assert3("ForXStatement", node, opts);
      }
      function assertFunction(node, opts) {
        assert3("Function", node, opts);
      }
      function assertFunctionParent(node, opts) {
        assert3("FunctionParent", node, opts);
      }
      function assertPureish(node, opts) {
        assert3("Pureish", node, opts);
      }
      function assertDeclaration(node, opts) {
        assert3("Declaration", node, opts);
      }
      function assertFunctionParameter(node, opts) {
        assert3("FunctionParameter", node, opts);
      }
      function assertPatternLike(node, opts) {
        assert3("PatternLike", node, opts);
      }
      function assertLVal(node, opts) {
        assert3("LVal", node, opts);
      }
      function assertTSEntityName(node, opts) {
        assert3("TSEntityName", node, opts);
      }
      function assertLiteral(node, opts) {
        assert3("Literal", node, opts);
      }
      function assertImmutable(node, opts) {
        assert3("Immutable", node, opts);
      }
      function assertUserWhitespacable(node, opts) {
        assert3("UserWhitespacable", node, opts);
      }
      function assertMethod(node, opts) {
        assert3("Method", node, opts);
      }
      function assertObjectMember(node, opts) {
        assert3("ObjectMember", node, opts);
      }
      function assertProperty(node, opts) {
        assert3("Property", node, opts);
      }
      function assertUnaryLike(node, opts) {
        assert3("UnaryLike", node, opts);
      }
      function assertPattern(node, opts) {
        assert3("Pattern", node, opts);
      }
      function assertClass(node, opts) {
        assert3("Class", node, opts);
      }
      function assertImportOrExportDeclaration(node, opts) {
        assert3("ImportOrExportDeclaration", node, opts);
      }
      function assertExportDeclaration(node, opts) {
        assert3("ExportDeclaration", node, opts);
      }
      function assertModuleSpecifier(node, opts) {
        assert3("ModuleSpecifier", node, opts);
      }
      function assertAccessor(node, opts) {
        assert3("Accessor", node, opts);
      }
      function assertPrivate(node, opts) {
        assert3("Private", node, opts);
      }
      function assertFlow(node, opts) {
        assert3("Flow", node, opts);
      }
      function assertFlowType(node, opts) {
        assert3("FlowType", node, opts);
      }
      function assertFlowBaseAnnotation(node, opts) {
        assert3("FlowBaseAnnotation", node, opts);
      }
      function assertFlowDeclaration(node, opts) {
        assert3("FlowDeclaration", node, opts);
      }
      function assertFlowPredicate(node, opts) {
        assert3("FlowPredicate", node, opts);
      }
      function assertEnumBody(node, opts) {
        assert3("EnumBody", node, opts);
      }
      function assertEnumMember(node, opts) {
        assert3("EnumMember", node, opts);
      }
      function assertJSX(node, opts) {
        assert3("JSX", node, opts);
      }
      function assertMiscellaneous(node, opts) {
        assert3("Miscellaneous", node, opts);
      }
      function assertTypeScript(node, opts) {
        assert3("TypeScript", node, opts);
      }
      function assertTSTypeElement(node, opts) {
        assert3("TSTypeElement", node, opts);
      }
      function assertTSType(node, opts) {
        assert3("TSType", node, opts);
      }
      function assertTSBaseType(node, opts) {
        assert3("TSBaseType", node, opts);
      }
      function assertNumberLiteral(node, opts) {
        (0, _deprecationWarning.default)("assertNumberLiteral", "assertNumericLiteral");
        assert3("NumberLiteral", node, opts);
      }
      function assertRegexLiteral(node, opts) {
        (0, _deprecationWarning.default)("assertRegexLiteral", "assertRegExpLiteral");
        assert3("RegexLiteral", node, opts);
      }
      function assertRestProperty(node, opts) {
        (0, _deprecationWarning.default)("assertRestProperty", "assertRestElement");
        assert3("RestProperty", node, opts);
      }
      function assertSpreadProperty(node, opts) {
        (0, _deprecationWarning.default)("assertSpreadProperty", "assertSpreadElement");
        assert3("SpreadProperty", node, opts);
      }
      function assertModuleDeclaration(node, opts) {
        (0, _deprecationWarning.default)("assertModuleDeclaration", "assertImportOrExportDeclaration");
        assert3("ModuleDeclaration", node, opts);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/flow/createTypeAnnotationBasedOnTypeof.js
  var require_createTypeAnnotationBasedOnTypeof = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/flow/createTypeAnnotationBasedOnTypeof.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      var _index = require_generated2();
      var _default = exports8.default = createTypeAnnotationBasedOnTypeof;
      function createTypeAnnotationBasedOnTypeof(type) {
        switch (type) {
          case "string":
            return (0, _index.stringTypeAnnotation)();
          case "number":
            return (0, _index.numberTypeAnnotation)();
          case "undefined":
            return (0, _index.voidTypeAnnotation)();
          case "boolean":
            return (0, _index.booleanTypeAnnotation)();
          case "function":
            return (0, _index.genericTypeAnnotation)((0, _index.identifier)("Function"));
          case "object":
            return (0, _index.genericTypeAnnotation)((0, _index.identifier)("Object"));
          case "symbol":
            return (0, _index.genericTypeAnnotation)((0, _index.identifier)("Symbol"));
          case "bigint":
            return (0, _index.anyTypeAnnotation)();
        }
        throw new Error("Invalid typeof value: " + type);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/modifications/flow/removeTypeDuplicates.js
  var require_removeTypeDuplicates = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/modifications/flow/removeTypeDuplicates.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = removeTypeDuplicates;
      var _index = require_generated();
      function getQualifiedName(node) {
        return (0, _index.isIdentifier)(node) ? node.name : `${node.id.name}.${getQualifiedName(node.qualification)}`;
      }
      function removeTypeDuplicates(nodesIn) {
        const nodes = Array.from(nodesIn);
        const generics = /* @__PURE__ */ new Map();
        const bases = /* @__PURE__ */ new Map();
        const typeGroups = /* @__PURE__ */ new Set();
        const types2 = [];
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];
          if (!node)
            continue;
          if (types2.includes(node)) {
            continue;
          }
          if ((0, _index.isAnyTypeAnnotation)(node)) {
            return [node];
          }
          if ((0, _index.isFlowBaseAnnotation)(node)) {
            bases.set(node.type, node);
            continue;
          }
          if ((0, _index.isUnionTypeAnnotation)(node)) {
            if (!typeGroups.has(node.types)) {
              nodes.push(...node.types);
              typeGroups.add(node.types);
            }
            continue;
          }
          if ((0, _index.isGenericTypeAnnotation)(node)) {
            const name = getQualifiedName(node.id);
            if (generics.has(name)) {
              let existing = generics.get(name);
              if (existing.typeParameters) {
                if (node.typeParameters) {
                  existing.typeParameters.params.push(...node.typeParameters.params);
                  existing.typeParameters.params = removeTypeDuplicates(existing.typeParameters.params);
                }
              } else {
                existing = node.typeParameters;
              }
            } else {
              generics.set(name, node);
            }
            continue;
          }
          types2.push(node);
        }
        for (const [, baseType] of bases) {
          types2.push(baseType);
        }
        for (const [, genericName] of generics) {
          types2.push(genericName);
        }
        return types2;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/flow/createFlowUnionType.js
  var require_createFlowUnionType = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/flow/createFlowUnionType.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = createFlowUnionType;
      var _index = require_generated2();
      var _removeTypeDuplicates = require_removeTypeDuplicates();
      function createFlowUnionType(types2) {
        const flattened = (0, _removeTypeDuplicates.default)(types2);
        if (flattened.length === 1) {
          return flattened[0];
        } else {
          return (0, _index.unionTypeAnnotation)(flattened);
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/modifications/typescript/removeTypeDuplicates.js
  var require_removeTypeDuplicates2 = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/modifications/typescript/removeTypeDuplicates.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = removeTypeDuplicates;
      var _index = require_generated();
      function getQualifiedName(node) {
        return (0, _index.isIdentifier)(node) ? node.name : (0, _index.isThisExpression)(node) ? "this" : `${node.right.name}.${getQualifiedName(node.left)}`;
      }
      function removeTypeDuplicates(nodesIn) {
        const nodes = Array.from(nodesIn);
        const generics = /* @__PURE__ */ new Map();
        const bases = /* @__PURE__ */ new Map();
        const typeGroups = /* @__PURE__ */ new Set();
        const types2 = [];
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];
          if (!node)
            continue;
          if (types2.includes(node)) {
            continue;
          }
          if ((0, _index.isTSAnyKeyword)(node)) {
            return [node];
          }
          if ((0, _index.isTSBaseType)(node)) {
            bases.set(node.type, node);
            continue;
          }
          if ((0, _index.isTSUnionType)(node)) {
            if (!typeGroups.has(node.types)) {
              nodes.push(...node.types);
              typeGroups.add(node.types);
            }
            continue;
          }
          const typeArgumentsKey = "typeParameters";
          if ((0, _index.isTSTypeReference)(node) && node[typeArgumentsKey]) {
            const typeArguments = node[typeArgumentsKey];
            const name = getQualifiedName(node.typeName);
            if (generics.has(name)) {
              let existing = generics.get(name);
              const existingTypeArguments = existing[typeArgumentsKey];
              if (existingTypeArguments) {
                existingTypeArguments.params.push(...typeArguments.params);
                existingTypeArguments.params = removeTypeDuplicates(existingTypeArguments.params);
              } else {
                existing = typeArguments;
              }
            } else {
              generics.set(name, node);
            }
            continue;
          }
          types2.push(node);
        }
        for (const [, baseType] of bases) {
          types2.push(baseType);
        }
        for (const [, genericName] of generics) {
          types2.push(genericName);
        }
        return types2;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/typescript/createTSUnionType.js
  var require_createTSUnionType = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/typescript/createTSUnionType.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = createTSUnionType;
      var _index = require_generated2();
      var _removeTypeDuplicates = require_removeTypeDuplicates2();
      var _index2 = require_generated();
      function createTSUnionType(typeAnnotations) {
        const types2 = typeAnnotations.map((type) => {
          return (0, _index2.isTSTypeAnnotation)(type) ? type.typeAnnotation : type;
        });
        const flattened = (0, _removeTypeDuplicates.default)(types2);
        if (flattened.length === 1) {
          return flattened[0];
        } else {
          return (0, _index.tsUnionType)(flattened);
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/productions.js
  var require_productions = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/builders/productions.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.buildUndefinedNode = buildUndefinedNode;
      var _index = require_generated2();
      function buildUndefinedNode() {
        return (0, _index.unaryExpression)("void", (0, _index.numericLiteral)(0), true);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/clone/cloneNode.js
  var require_cloneNode = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/clone/cloneNode.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = cloneNode;
      var _index = require_definitions();
      var _index2 = require_generated();
      var {
        hasOwn
      } = {
        hasOwn: Function.call.bind(Object.prototype.hasOwnProperty)
      };
      function cloneIfNode(obj, deep, withoutLoc, commentsCache) {
        if (obj && typeof obj.type === "string") {
          return cloneNodeInternal(obj, deep, withoutLoc, commentsCache);
        }
        return obj;
      }
      function cloneIfNodeOrArray(obj, deep, withoutLoc, commentsCache) {
        if (Array.isArray(obj)) {
          return obj.map((node) => cloneIfNode(node, deep, withoutLoc, commentsCache));
        }
        return cloneIfNode(obj, deep, withoutLoc, commentsCache);
      }
      function cloneNode(node, deep = true, withoutLoc = false) {
        return cloneNodeInternal(node, deep, withoutLoc, /* @__PURE__ */ new Map());
      }
      function cloneNodeInternal(node, deep = true, withoutLoc = false, commentsCache) {
        if (!node)
          return node;
        const {
          type
        } = node;
        const newNode = {
          type: node.type
        };
        if ((0, _index2.isIdentifier)(node)) {
          newNode.name = node.name;
          if (hasOwn(node, "optional") && typeof node.optional === "boolean") {
            newNode.optional = node.optional;
          }
          if (hasOwn(node, "typeAnnotation")) {
            newNode.typeAnnotation = deep ? cloneIfNodeOrArray(node.typeAnnotation, true, withoutLoc, commentsCache) : node.typeAnnotation;
          }
          if (hasOwn(node, "decorators")) {
            newNode.decorators = deep ? cloneIfNodeOrArray(node.decorators, true, withoutLoc, commentsCache) : node.decorators;
          }
        } else if (!hasOwn(_index.NODE_FIELDS, type)) {
          throw new Error(`Unknown node type: "${type}"`);
        } else {
          for (const field of Object.keys(_index.NODE_FIELDS[type])) {
            if (hasOwn(node, field)) {
              if (deep) {
                newNode[field] = (0, _index2.isFile)(node) && field === "comments" ? maybeCloneComments(node.comments, deep, withoutLoc, commentsCache) : cloneIfNodeOrArray(node[field], true, withoutLoc, commentsCache);
              } else {
                newNode[field] = node[field];
              }
            }
          }
        }
        if (hasOwn(node, "loc")) {
          if (withoutLoc) {
            newNode.loc = null;
          } else {
            newNode.loc = node.loc;
          }
        }
        if (hasOwn(node, "leadingComments")) {
          newNode.leadingComments = maybeCloneComments(node.leadingComments, deep, withoutLoc, commentsCache);
        }
        if (hasOwn(node, "innerComments")) {
          newNode.innerComments = maybeCloneComments(node.innerComments, deep, withoutLoc, commentsCache);
        }
        if (hasOwn(node, "trailingComments")) {
          newNode.trailingComments = maybeCloneComments(node.trailingComments, deep, withoutLoc, commentsCache);
        }
        if (hasOwn(node, "extra")) {
          newNode.extra = Object.assign({}, node.extra);
        }
        return newNode;
      }
      function maybeCloneComments(comments, deep, withoutLoc, commentsCache) {
        if (!comments || !deep) {
          return comments;
        }
        return comments.map((comment) => {
          const cache = commentsCache.get(comment);
          if (cache)
            return cache;
          const {
            type,
            value,
            loc
          } = comment;
          const ret = {
            type,
            value,
            loc
          };
          if (withoutLoc) {
            ret.loc = null;
          }
          commentsCache.set(comment, ret);
          return ret;
        });
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/clone/clone.js
  var require_clone = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/clone/clone.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = clone2;
      var _cloneNode = require_cloneNode();
      function clone2(node) {
        return (0, _cloneNode.default)(node, false);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/clone/cloneDeep.js
  var require_cloneDeep = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/clone/cloneDeep.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = cloneDeep2;
      var _cloneNode = require_cloneNode();
      function cloneDeep2(node) {
        return (0, _cloneNode.default)(node);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/clone/cloneDeepWithoutLoc.js
  var require_cloneDeepWithoutLoc = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/clone/cloneDeepWithoutLoc.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = cloneDeepWithoutLoc;
      var _cloneNode = require_cloneNode();
      function cloneDeepWithoutLoc(node) {
        return (0, _cloneNode.default)(node, true, true);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/clone/cloneWithoutLoc.js
  var require_cloneWithoutLoc = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/clone/cloneWithoutLoc.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = cloneWithoutLoc;
      var _cloneNode = require_cloneNode();
      function cloneWithoutLoc(node) {
        return (0, _cloneNode.default)(node, false, true);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/comments/addComments.js
  var require_addComments = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/comments/addComments.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = addComments;
      function addComments(node, type, comments) {
        if (!comments || !node)
          return node;
        const key = `${type}Comments`;
        if (node[key]) {
          if (type === "leading") {
            node[key] = comments.concat(node[key]);
          } else {
            node[key].push(...comments);
          }
        } else {
          node[key] = comments;
        }
        return node;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/comments/addComment.js
  var require_addComment = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/comments/addComment.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = addComment;
      var _addComments = require_addComments();
      function addComment(node, type, content, line) {
        return (0, _addComments.default)(node, type, [{
          type: line ? "CommentLine" : "CommentBlock",
          value: content
        }]);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/utils/inherit.js
  var require_inherit = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/utils/inherit.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = inherit;
      function inherit(key, child, parent2) {
        if (child && parent2) {
          child[key] = Array.from(new Set([].concat(child[key], parent2[key]).filter(Boolean)));
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/comments/inheritInnerComments.js
  var require_inheritInnerComments = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/comments/inheritInnerComments.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = inheritInnerComments;
      var _inherit = require_inherit();
      function inheritInnerComments(child, parent2) {
        (0, _inherit.default)("innerComments", child, parent2);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/comments/inheritLeadingComments.js
  var require_inheritLeadingComments = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/comments/inheritLeadingComments.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = inheritLeadingComments;
      var _inherit = require_inherit();
      function inheritLeadingComments(child, parent2) {
        (0, _inherit.default)("leadingComments", child, parent2);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/comments/inheritTrailingComments.js
  var require_inheritTrailingComments = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/comments/inheritTrailingComments.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = inheritTrailingComments;
      var _inherit = require_inherit();
      function inheritTrailingComments(child, parent2) {
        (0, _inherit.default)("trailingComments", child, parent2);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/comments/inheritsComments.js
  var require_inheritsComments = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/comments/inheritsComments.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = inheritsComments;
      var _inheritTrailingComments = require_inheritTrailingComments();
      var _inheritLeadingComments = require_inheritLeadingComments();
      var _inheritInnerComments = require_inheritInnerComments();
      function inheritsComments(child, parent2) {
        (0, _inheritTrailingComments.default)(child, parent2);
        (0, _inheritLeadingComments.default)(child, parent2);
        (0, _inheritInnerComments.default)(child, parent2);
        return child;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/comments/removeComments.js
  var require_removeComments = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/comments/removeComments.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = removeComments;
      var _index = require_constants();
      function removeComments(node) {
        _index.COMMENT_KEYS.forEach((key) => {
          node[key] = null;
        });
        return node;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/constants/generated/index.js
  var require_generated4 = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/constants/generated/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.WHILE_TYPES = exports8.USERWHITESPACABLE_TYPES = exports8.UNARYLIKE_TYPES = exports8.TYPESCRIPT_TYPES = exports8.TSTYPE_TYPES = exports8.TSTYPEELEMENT_TYPES = exports8.TSENTITYNAME_TYPES = exports8.TSBASETYPE_TYPES = exports8.TERMINATORLESS_TYPES = exports8.STATEMENT_TYPES = exports8.STANDARDIZED_TYPES = exports8.SCOPABLE_TYPES = exports8.PUREISH_TYPES = exports8.PROPERTY_TYPES = exports8.PRIVATE_TYPES = exports8.PATTERN_TYPES = exports8.PATTERNLIKE_TYPES = exports8.OBJECTMEMBER_TYPES = exports8.MODULESPECIFIER_TYPES = exports8.MODULEDECLARATION_TYPES = exports8.MISCELLANEOUS_TYPES = exports8.METHOD_TYPES = exports8.LVAL_TYPES = exports8.LOOP_TYPES = exports8.LITERAL_TYPES = exports8.JSX_TYPES = exports8.IMPORTOREXPORTDECLARATION_TYPES = exports8.IMMUTABLE_TYPES = exports8.FUNCTION_TYPES = exports8.FUNCTIONPARENT_TYPES = exports8.FUNCTIONPARAMETER_TYPES = exports8.FOR_TYPES = exports8.FORXSTATEMENT_TYPES = exports8.FLOW_TYPES = exports8.FLOWTYPE_TYPES = exports8.FLOWPREDICATE_TYPES = exports8.FLOWDECLARATION_TYPES = exports8.FLOWBASEANNOTATION_TYPES = exports8.EXPRESSION_TYPES = exports8.EXPRESSIONWRAPPER_TYPES = exports8.EXPORTDECLARATION_TYPES = exports8.ENUMMEMBER_TYPES = exports8.ENUMBODY_TYPES = exports8.DECLARATION_TYPES = exports8.CONDITIONAL_TYPES = exports8.COMPLETIONSTATEMENT_TYPES = exports8.CLASS_TYPES = exports8.BLOCK_TYPES = exports8.BLOCKPARENT_TYPES = exports8.BINARY_TYPES = exports8.ACCESSOR_TYPES = void 0;
      var _index = require_definitions();
      var STANDARDIZED_TYPES = exports8.STANDARDIZED_TYPES = _index.FLIPPED_ALIAS_KEYS["Standardized"];
      var EXPRESSION_TYPES = exports8.EXPRESSION_TYPES = _index.FLIPPED_ALIAS_KEYS["Expression"];
      var BINARY_TYPES = exports8.BINARY_TYPES = _index.FLIPPED_ALIAS_KEYS["Binary"];
      var SCOPABLE_TYPES = exports8.SCOPABLE_TYPES = _index.FLIPPED_ALIAS_KEYS["Scopable"];
      var BLOCKPARENT_TYPES = exports8.BLOCKPARENT_TYPES = _index.FLIPPED_ALIAS_KEYS["BlockParent"];
      var BLOCK_TYPES = exports8.BLOCK_TYPES = _index.FLIPPED_ALIAS_KEYS["Block"];
      var STATEMENT_TYPES = exports8.STATEMENT_TYPES = _index.FLIPPED_ALIAS_KEYS["Statement"];
      var TERMINATORLESS_TYPES = exports8.TERMINATORLESS_TYPES = _index.FLIPPED_ALIAS_KEYS["Terminatorless"];
      var COMPLETIONSTATEMENT_TYPES = exports8.COMPLETIONSTATEMENT_TYPES = _index.FLIPPED_ALIAS_KEYS["CompletionStatement"];
      var CONDITIONAL_TYPES = exports8.CONDITIONAL_TYPES = _index.FLIPPED_ALIAS_KEYS["Conditional"];
      var LOOP_TYPES = exports8.LOOP_TYPES = _index.FLIPPED_ALIAS_KEYS["Loop"];
      var WHILE_TYPES = exports8.WHILE_TYPES = _index.FLIPPED_ALIAS_KEYS["While"];
      var EXPRESSIONWRAPPER_TYPES = exports8.EXPRESSIONWRAPPER_TYPES = _index.FLIPPED_ALIAS_KEYS["ExpressionWrapper"];
      var FOR_TYPES = exports8.FOR_TYPES = _index.FLIPPED_ALIAS_KEYS["For"];
      var FORXSTATEMENT_TYPES = exports8.FORXSTATEMENT_TYPES = _index.FLIPPED_ALIAS_KEYS["ForXStatement"];
      var FUNCTION_TYPES = exports8.FUNCTION_TYPES = _index.FLIPPED_ALIAS_KEYS["Function"];
      var FUNCTIONPARENT_TYPES = exports8.FUNCTIONPARENT_TYPES = _index.FLIPPED_ALIAS_KEYS["FunctionParent"];
      var PUREISH_TYPES = exports8.PUREISH_TYPES = _index.FLIPPED_ALIAS_KEYS["Pureish"];
      var DECLARATION_TYPES = exports8.DECLARATION_TYPES = _index.FLIPPED_ALIAS_KEYS["Declaration"];
      var FUNCTIONPARAMETER_TYPES = exports8.FUNCTIONPARAMETER_TYPES = _index.FLIPPED_ALIAS_KEYS["FunctionParameter"];
      var PATTERNLIKE_TYPES = exports8.PATTERNLIKE_TYPES = _index.FLIPPED_ALIAS_KEYS["PatternLike"];
      var LVAL_TYPES = exports8.LVAL_TYPES = _index.FLIPPED_ALIAS_KEYS["LVal"];
      var TSENTITYNAME_TYPES = exports8.TSENTITYNAME_TYPES = _index.FLIPPED_ALIAS_KEYS["TSEntityName"];
      var LITERAL_TYPES = exports8.LITERAL_TYPES = _index.FLIPPED_ALIAS_KEYS["Literal"];
      var IMMUTABLE_TYPES = exports8.IMMUTABLE_TYPES = _index.FLIPPED_ALIAS_KEYS["Immutable"];
      var USERWHITESPACABLE_TYPES = exports8.USERWHITESPACABLE_TYPES = _index.FLIPPED_ALIAS_KEYS["UserWhitespacable"];
      var METHOD_TYPES = exports8.METHOD_TYPES = _index.FLIPPED_ALIAS_KEYS["Method"];
      var OBJECTMEMBER_TYPES = exports8.OBJECTMEMBER_TYPES = _index.FLIPPED_ALIAS_KEYS["ObjectMember"];
      var PROPERTY_TYPES = exports8.PROPERTY_TYPES = _index.FLIPPED_ALIAS_KEYS["Property"];
      var UNARYLIKE_TYPES = exports8.UNARYLIKE_TYPES = _index.FLIPPED_ALIAS_KEYS["UnaryLike"];
      var PATTERN_TYPES = exports8.PATTERN_TYPES = _index.FLIPPED_ALIAS_KEYS["Pattern"];
      var CLASS_TYPES = exports8.CLASS_TYPES = _index.FLIPPED_ALIAS_KEYS["Class"];
      var IMPORTOREXPORTDECLARATION_TYPES = exports8.IMPORTOREXPORTDECLARATION_TYPES = _index.FLIPPED_ALIAS_KEYS["ImportOrExportDeclaration"];
      var EXPORTDECLARATION_TYPES = exports8.EXPORTDECLARATION_TYPES = _index.FLIPPED_ALIAS_KEYS["ExportDeclaration"];
      var MODULESPECIFIER_TYPES = exports8.MODULESPECIFIER_TYPES = _index.FLIPPED_ALIAS_KEYS["ModuleSpecifier"];
      var ACCESSOR_TYPES = exports8.ACCESSOR_TYPES = _index.FLIPPED_ALIAS_KEYS["Accessor"];
      var PRIVATE_TYPES = exports8.PRIVATE_TYPES = _index.FLIPPED_ALIAS_KEYS["Private"];
      var FLOW_TYPES = exports8.FLOW_TYPES = _index.FLIPPED_ALIAS_KEYS["Flow"];
      var FLOWTYPE_TYPES = exports8.FLOWTYPE_TYPES = _index.FLIPPED_ALIAS_KEYS["FlowType"];
      var FLOWBASEANNOTATION_TYPES = exports8.FLOWBASEANNOTATION_TYPES = _index.FLIPPED_ALIAS_KEYS["FlowBaseAnnotation"];
      var FLOWDECLARATION_TYPES = exports8.FLOWDECLARATION_TYPES = _index.FLIPPED_ALIAS_KEYS["FlowDeclaration"];
      var FLOWPREDICATE_TYPES = exports8.FLOWPREDICATE_TYPES = _index.FLIPPED_ALIAS_KEYS["FlowPredicate"];
      var ENUMBODY_TYPES = exports8.ENUMBODY_TYPES = _index.FLIPPED_ALIAS_KEYS["EnumBody"];
      var ENUMMEMBER_TYPES = exports8.ENUMMEMBER_TYPES = _index.FLIPPED_ALIAS_KEYS["EnumMember"];
      var JSX_TYPES = exports8.JSX_TYPES = _index.FLIPPED_ALIAS_KEYS["JSX"];
      var MISCELLANEOUS_TYPES = exports8.MISCELLANEOUS_TYPES = _index.FLIPPED_ALIAS_KEYS["Miscellaneous"];
      var TYPESCRIPT_TYPES = exports8.TYPESCRIPT_TYPES = _index.FLIPPED_ALIAS_KEYS["TypeScript"];
      var TSTYPEELEMENT_TYPES = exports8.TSTYPEELEMENT_TYPES = _index.FLIPPED_ALIAS_KEYS["TSTypeElement"];
      var TSTYPE_TYPES = exports8.TSTYPE_TYPES = _index.FLIPPED_ALIAS_KEYS["TSType"];
      var TSBASETYPE_TYPES = exports8.TSBASETYPE_TYPES = _index.FLIPPED_ALIAS_KEYS["TSBaseType"];
      var MODULEDECLARATION_TYPES = exports8.MODULEDECLARATION_TYPES = IMPORTOREXPORTDECLARATION_TYPES;
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toBlock.js
  var require_toBlock = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toBlock.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = toBlock;
      var _index = require_generated();
      var _index2 = require_generated2();
      function toBlock(node, parent2) {
        if ((0, _index.isBlockStatement)(node)) {
          return node;
        }
        let blockNodes = [];
        if ((0, _index.isEmptyStatement)(node)) {
          blockNodes = [];
        } else {
          if (!(0, _index.isStatement)(node)) {
            if ((0, _index.isFunction)(parent2)) {
              node = (0, _index2.returnStatement)(node);
            } else {
              node = (0, _index2.expressionStatement)(node);
            }
          }
          blockNodes = [node];
        }
        return (0, _index2.blockStatement)(blockNodes);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/ensureBlock.js
  var require_ensureBlock = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/ensureBlock.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = ensureBlock;
      var _toBlock = require_toBlock();
      function ensureBlock(node, key = "body") {
        const result2 = (0, _toBlock.default)(node[key], node);
        node[key] = result2;
        return result2;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toIdentifier.js
  var require_toIdentifier = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toIdentifier.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = toIdentifier;
      var _isValidIdentifier = require_isValidIdentifier();
      var _helperValidatorIdentifier = require_lib3();
      function toIdentifier(input) {
        input = input + "";
        let name = "";
        for (const c of input) {
          name += (0, _helperValidatorIdentifier.isIdentifierChar)(c.codePointAt(0)) ? c : "-";
        }
        name = name.replace(/^[-0-9]+/, "");
        name = name.replace(/[-\s]+(.)?/g, function(match, c) {
          return c ? c.toUpperCase() : "";
        });
        if (!(0, _isValidIdentifier.default)(name)) {
          name = `_${name}`;
        }
        return name || "_";
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toBindingIdentifierName.js
  var require_toBindingIdentifierName = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toBindingIdentifierName.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = toBindingIdentifierName;
      var _toIdentifier = require_toIdentifier();
      function toBindingIdentifierName(name) {
        name = (0, _toIdentifier.default)(name);
        if (name === "eval" || name === "arguments")
          name = "_" + name;
        return name;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toComputedKey.js
  var require_toComputedKey = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toComputedKey.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = toComputedKey;
      var _index = require_generated();
      var _index2 = require_generated2();
      function toComputedKey(node, key = node.key || node.property) {
        if (!node.computed && (0, _index.isIdentifier)(key))
          key = (0, _index2.stringLiteral)(key.name);
        return key;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toExpression.js
  var require_toExpression = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toExpression.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      var _index = require_generated();
      var _default = exports8.default = toExpression;
      function toExpression(node) {
        if ((0, _index.isExpressionStatement)(node)) {
          node = node.expression;
        }
        if ((0, _index.isExpression)(node)) {
          return node;
        }
        if ((0, _index.isClass)(node)) {
          node.type = "ClassExpression";
          node.abstract = false;
        } else if ((0, _index.isFunction)(node)) {
          node.type = "FunctionExpression";
        }
        if (!(0, _index.isExpression)(node)) {
          throw new Error(`cannot turn ${node.type} to an expression`);
        }
        return node;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/traverse/traverseFast.js
  var require_traverseFast = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/traverse/traverseFast.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = traverseFast;
      var _index = require_definitions();
      var _skip = Symbol();
      var _stop = Symbol();
      function traverseFast(node, enter, opts) {
        if (!node)
          return false;
        const keys2 = _index.VISITOR_KEYS[node.type];
        if (!keys2)
          return false;
        opts = opts || {};
        const ret = enter(node, opts);
        if (ret !== void 0) {
          switch (ret) {
            case _skip:
              return false;
            case _stop:
              return true;
          }
        }
        for (const key of keys2) {
          const subNode = node[key];
          if (!subNode)
            continue;
          if (Array.isArray(subNode)) {
            for (const node2 of subNode) {
              if (traverseFast(node2, enter, opts))
                return true;
            }
          } else {
            if (traverseFast(subNode, enter, opts))
              return true;
          }
        }
        return false;
      }
      traverseFast.skip = _skip;
      traverseFast.stop = _stop;
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/modifications/removeProperties.js
  var require_removeProperties = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/modifications/removeProperties.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = removeProperties;
      var _index = require_constants();
      var CLEAR_KEYS = ["tokens", "start", "end", "loc", "raw", "rawValue"];
      var CLEAR_KEYS_PLUS_COMMENTS = [..._index.COMMENT_KEYS, "comments", ...CLEAR_KEYS];
      function removeProperties(node, opts = {}) {
        const map2 = opts.preserveComments ? CLEAR_KEYS : CLEAR_KEYS_PLUS_COMMENTS;
        for (const key of map2) {
          if (node[key] != null)
            node[key] = void 0;
        }
        for (const key of Object.keys(node)) {
          if (key[0] === "_" && node[key] != null)
            node[key] = void 0;
        }
        const symbols = Object.getOwnPropertySymbols(node);
        for (const sym of symbols) {
          node[sym] = null;
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/modifications/removePropertiesDeep.js
  var require_removePropertiesDeep = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/modifications/removePropertiesDeep.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = removePropertiesDeep;
      var _traverseFast = require_traverseFast();
      var _removeProperties = require_removeProperties();
      function removePropertiesDeep(tree, opts) {
        (0, _traverseFast.default)(tree, _removeProperties.default, opts);
        return tree;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toKeyAlias.js
  var require_toKeyAlias = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toKeyAlias.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = toKeyAlias;
      var _index = require_generated();
      var _cloneNode = require_cloneNode();
      var _removePropertiesDeep = require_removePropertiesDeep();
      function toKeyAlias(node, key = node.key) {
        let alias;
        if (node.kind === "method") {
          return toKeyAlias.increment() + "";
        } else if ((0, _index.isIdentifier)(key)) {
          alias = key.name;
        } else if ((0, _index.isStringLiteral)(key)) {
          alias = JSON.stringify(key.value);
        } else {
          alias = JSON.stringify((0, _removePropertiesDeep.default)((0, _cloneNode.default)(key)));
        }
        if (node.computed) {
          alias = `[${alias}]`;
        }
        if (node.static) {
          alias = `static:${alias}`;
        }
        return alias;
      }
      toKeyAlias.uid = 0;
      toKeyAlias.increment = function() {
        if (toKeyAlias.uid >= Number.MAX_SAFE_INTEGER) {
          return toKeyAlias.uid = 0;
        } else {
          return toKeyAlias.uid++;
        }
      };
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toStatement.js
  var require_toStatement = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toStatement.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      var _index = require_generated();
      var _index2 = require_generated2();
      var _default = exports8.default = toStatement;
      function toStatement(node, ignore) {
        if ((0, _index.isStatement)(node)) {
          return node;
        }
        let mustHaveId = false;
        let newType;
        if ((0, _index.isClass)(node)) {
          mustHaveId = true;
          newType = "ClassDeclaration";
        } else if ((0, _index.isFunction)(node)) {
          mustHaveId = true;
          newType = "FunctionDeclaration";
        } else if ((0, _index.isAssignmentExpression)(node)) {
          return (0, _index2.expressionStatement)(node);
        }
        if (mustHaveId && !node.id) {
          newType = false;
        }
        if (!newType) {
          if (ignore) {
            return false;
          } else {
            throw new Error(`cannot turn ${node.type} to a statement`);
          }
        }
        node.type = newType;
        return node;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/valueToNode.js
  var require_valueToNode = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/valueToNode.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      var _isValidIdentifier = require_isValidIdentifier();
      var _index = require_generated2();
      var _default = exports8.default = valueToNode;
      var objectToString2 = Function.call.bind(Object.prototype.toString);
      function isRegExp3(value) {
        return objectToString2(value) === "[object RegExp]";
      }
      function isPlainObject3(value) {
        if (typeof value !== "object" || value === null || Object.prototype.toString.call(value) !== "[object Object]") {
          return false;
        }
        const proto = Object.getPrototypeOf(value);
        return proto === null || Object.getPrototypeOf(proto) === null;
      }
      function valueToNode(value) {
        if (value === void 0) {
          return (0, _index.identifier)("undefined");
        }
        if (value === true || value === false) {
          return (0, _index.booleanLiteral)(value);
        }
        if (value === null) {
          return (0, _index.nullLiteral)();
        }
        if (typeof value === "string") {
          return (0, _index.stringLiteral)(value);
        }
        if (typeof value === "number") {
          let result2;
          if (Number.isFinite(value)) {
            result2 = (0, _index.numericLiteral)(Math.abs(value));
          } else {
            let numerator;
            if (Number.isNaN(value)) {
              numerator = (0, _index.numericLiteral)(0);
            } else {
              numerator = (0, _index.numericLiteral)(1);
            }
            result2 = (0, _index.binaryExpression)("/", numerator, (0, _index.numericLiteral)(0));
          }
          if (value < 0 || Object.is(value, -0)) {
            result2 = (0, _index.unaryExpression)("-", result2);
          }
          return result2;
        }
        if (typeof value === "bigint") {
          if (value < 0) {
            return (0, _index.unaryExpression)("-", (0, _index.bigIntLiteral)(-value));
          } else {
            return (0, _index.bigIntLiteral)(value);
          }
        }
        if (isRegExp3(value)) {
          const pattern = value.source;
          const flags = /\/([a-z]*)$/.exec(value.toString())[1];
          return (0, _index.regExpLiteral)(pattern, flags);
        }
        if (Array.isArray(value)) {
          return (0, _index.arrayExpression)(value.map(valueToNode));
        }
        if (isPlainObject3(value)) {
          const props = [];
          for (const key of Object.keys(value)) {
            let nodeKey, computed = false;
            if ((0, _isValidIdentifier.default)(key)) {
              if (key === "__proto__") {
                computed = true;
                nodeKey = (0, _index.stringLiteral)(key);
              } else {
                nodeKey = (0, _index.identifier)(key);
              }
            } else {
              nodeKey = (0, _index.stringLiteral)(key);
            }
            props.push((0, _index.objectProperty)(nodeKey, valueToNode(value[key]), computed));
          }
          return (0, _index.objectExpression)(props);
        }
        throw new Error("don't know how to turn this value into a node");
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/modifications/appendToMemberExpression.js
  var require_appendToMemberExpression = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/modifications/appendToMemberExpression.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = appendToMemberExpression;
      var _index = require_generated2();
      function appendToMemberExpression(member, append, computed = false) {
        member.object = (0, _index.memberExpression)(member.object, member.property, member.computed);
        member.property = append;
        member.computed = !!computed;
        return member;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/modifications/inherits.js
  var require_inherits = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/modifications/inherits.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = inherits2;
      var _index = require_constants();
      var _inheritsComments = require_inheritsComments();
      function inherits2(child, parent2) {
        if (!child || !parent2)
          return child;
        for (const key of _index.INHERIT_KEYS.optional) {
          if (child[key] == null) {
            child[key] = parent2[key];
          }
        }
        for (const key of Object.keys(parent2)) {
          if (key[0] === "_" && key !== "__clone") {
            child[key] = parent2[key];
          }
        }
        for (const key of _index.INHERIT_KEYS.force) {
          child[key] = parent2[key];
        }
        (0, _inheritsComments.default)(child, parent2);
        return child;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/modifications/prependToMemberExpression.js
  var require_prependToMemberExpression = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/modifications/prependToMemberExpression.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = prependToMemberExpression;
      var _index = require_generated2();
      var _index2 = require_lib5();
      function prependToMemberExpression(member, prepend) {
        if ((0, _index2.isSuper)(member.object)) {
          throw new Error("Cannot prepend node to super property access (`super.foo`).");
        }
        member.object = (0, _index.memberExpression)(prepend, member.object);
        return member;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/retrievers/getAssignmentIdentifiers.js
  var require_getAssignmentIdentifiers = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/retrievers/getAssignmentIdentifiers.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = getAssignmentIdentifiers;
      function getAssignmentIdentifiers(node) {
        const search = [].concat(node);
        const ids = /* @__PURE__ */ Object.create(null);
        while (search.length) {
          const id = search.pop();
          if (!id)
            continue;
          switch (id.type) {
            case "ArrayPattern":
              search.push(...id.elements);
              break;
            case "AssignmentExpression":
            case "AssignmentPattern":
            case "ForInStatement":
            case "ForOfStatement":
              search.push(id.left);
              break;
            case "ObjectPattern":
              search.push(...id.properties);
              break;
            case "ObjectProperty":
              search.push(id.value);
              break;
            case "RestElement":
            case "UpdateExpression":
              search.push(id.argument);
              break;
            case "UnaryExpression":
              if (id.operator === "delete") {
                search.push(id.argument);
              }
              break;
            case "Identifier":
              ids[id.name] = id;
              break;
            default:
              break;
          }
        }
        return ids;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/retrievers/getBindingIdentifiers.js
  var require_getBindingIdentifiers = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/retrievers/getBindingIdentifiers.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = getBindingIdentifiers;
      var _index = require_generated();
      function getBindingIdentifiers(node, duplicates, outerOnly, newBindingsOnly) {
        const search = [].concat(node);
        const ids = /* @__PURE__ */ Object.create(null);
        while (search.length) {
          const id = search.shift();
          if (!id)
            continue;
          if (newBindingsOnly && ((0, _index.isAssignmentExpression)(id) || (0, _index.isUnaryExpression)(id) || (0, _index.isUpdateExpression)(id))) {
            continue;
          }
          if ((0, _index.isIdentifier)(id)) {
            if (duplicates) {
              const _ids = ids[id.name] = ids[id.name] || [];
              _ids.push(id);
            } else {
              ids[id.name] = id;
            }
            continue;
          }
          if ((0, _index.isExportDeclaration)(id) && !(0, _index.isExportAllDeclaration)(id)) {
            if ((0, _index.isDeclaration)(id.declaration)) {
              search.push(id.declaration);
            }
            continue;
          }
          if (outerOnly) {
            if ((0, _index.isFunctionDeclaration)(id)) {
              search.push(id.id);
              continue;
            }
            if ((0, _index.isFunctionExpression)(id)) {
              continue;
            }
          }
          const keys3 = getBindingIdentifiers.keys[id.type];
          if (keys3) {
            for (let i = 0; i < keys3.length; i++) {
              const key = keys3[i];
              const nodes = id[key];
              if (nodes) {
                if (Array.isArray(nodes)) {
                  search.push(...nodes);
                } else {
                  search.push(nodes);
                }
              }
            }
          }
        }
        return ids;
      }
      var keys2 = {
        DeclareClass: ["id"],
        DeclareFunction: ["id"],
        DeclareModule: ["id"],
        DeclareVariable: ["id"],
        DeclareInterface: ["id"],
        DeclareTypeAlias: ["id"],
        DeclareOpaqueType: ["id"],
        InterfaceDeclaration: ["id"],
        TypeAlias: ["id"],
        OpaqueType: ["id"],
        CatchClause: ["param"],
        LabeledStatement: ["label"],
        UnaryExpression: ["argument"],
        AssignmentExpression: ["left"],
        ImportSpecifier: ["local"],
        ImportNamespaceSpecifier: ["local"],
        ImportDefaultSpecifier: ["local"],
        ImportDeclaration: ["specifiers"],
        TSImportEqualsDeclaration: ["id"],
        ExportSpecifier: ["exported"],
        ExportNamespaceSpecifier: ["exported"],
        ExportDefaultSpecifier: ["exported"],
        FunctionDeclaration: ["id", "params"],
        FunctionExpression: ["id", "params"],
        ArrowFunctionExpression: ["params"],
        ObjectMethod: ["params"],
        ClassMethod: ["params"],
        ClassPrivateMethod: ["params"],
        ForInStatement: ["left"],
        ForOfStatement: ["left"],
        ClassDeclaration: ["id"],
        ClassExpression: ["id"],
        RestElement: ["argument"],
        UpdateExpression: ["argument"],
        ObjectProperty: ["value"],
        AssignmentPattern: ["left"],
        ArrayPattern: ["elements"],
        ObjectPattern: ["properties"],
        VariableDeclaration: ["declarations"],
        VariableDeclarator: ["id"]
      };
      getBindingIdentifiers.keys = keys2;
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/retrievers/getOuterBindingIdentifiers.js
  var require_getOuterBindingIdentifiers = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/retrievers/getOuterBindingIdentifiers.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      var _getBindingIdentifiers = require_getBindingIdentifiers();
      var _default = exports8.default = getOuterBindingIdentifiers;
      function getOuterBindingIdentifiers(node, duplicates) {
        return (0, _getBindingIdentifiers.default)(node, duplicates, true);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/retrievers/getFunctionName.js
  var require_getFunctionName = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/retrievers/getFunctionName.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = getFunctionName;
      var _index = require_generated();
      function getNameFromLiteralId(id) {
        if ((0, _index.isNullLiteral)(id)) {
          return "null";
        }
        if ((0, _index.isRegExpLiteral)(id)) {
          return `/${id.pattern}/${id.flags}`;
        }
        if ((0, _index.isTemplateLiteral)(id)) {
          return id.quasis.map((quasi) => quasi.value.raw).join("");
        }
        if (id.value !== void 0) {
          return String(id.value);
        }
        return null;
      }
      function getObjectMemberKey(node) {
        if (!node.computed || (0, _index.isLiteral)(node.key)) {
          return node.key;
        }
      }
      function getFunctionName(node, parent2) {
        if ("id" in node && node.id) {
          return {
            name: node.id.name,
            originalNode: node.id
          };
        }
        let prefix = "";
        let id;
        if ((0, _index.isObjectProperty)(parent2, {
          value: node
        })) {
          id = getObjectMemberKey(parent2);
        } else if ((0, _index.isObjectMethod)(node) || (0, _index.isClassMethod)(node)) {
          id = getObjectMemberKey(node);
          if (node.kind === "get")
            prefix = "get ";
          else if (node.kind === "set")
            prefix = "set ";
        } else if ((0, _index.isVariableDeclarator)(parent2, {
          init: node
        })) {
          id = parent2.id;
        } else if ((0, _index.isAssignmentExpression)(parent2, {
          operator: "=",
          right: node
        })) {
          id = parent2.left;
        }
        if (!id)
          return null;
        const name = (0, _index.isLiteral)(id) ? getNameFromLiteralId(id) : (0, _index.isIdentifier)(id) ? id.name : (0, _index.isPrivateName)(id) ? id.id.name : null;
        if (name == null)
          return null;
        return {
          name: prefix + name,
          originalNode: id
        };
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/traverse/traverse.js
  var require_traverse = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/traverse/traverse.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = traverse3;
      var _index = require_definitions();
      function traverse3(node, handlers, state) {
        if (typeof handlers === "function") {
          handlers = {
            enter: handlers
          };
        }
        const {
          enter,
          exit: exit3
        } = handlers;
        traverseSimpleImpl(node, enter, exit3, state, []);
      }
      function traverseSimpleImpl(node, enter, exit3, state, ancestors) {
        const keys2 = _index.VISITOR_KEYS[node.type];
        if (!keys2)
          return;
        if (enter)
          enter(node, ancestors, state);
        for (const key of keys2) {
          const subNode = node[key];
          if (Array.isArray(subNode)) {
            for (let i = 0; i < subNode.length; i++) {
              const child = subNode[i];
              if (!child)
                continue;
              ancestors.push({
                node,
                key,
                index: i
              });
              traverseSimpleImpl(child, enter, exit3, state, ancestors);
              ancestors.pop();
            }
          } else if (subNode) {
            ancestors.push({
              node,
              key
            });
            traverseSimpleImpl(subNode, enter, exit3, state, ancestors);
            ancestors.pop();
          }
        }
        if (exit3)
          exit3(node, ancestors, state);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isBinding.js
  var require_isBinding = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isBinding.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = isBinding;
      var _getBindingIdentifiers = require_getBindingIdentifiers();
      function isBinding(node, parent2, grandparent) {
        if (grandparent && node.type === "Identifier" && parent2.type === "ObjectProperty" && grandparent.type === "ObjectExpression") {
          return false;
        }
        const keys2 = _getBindingIdentifiers.default.keys[parent2.type];
        if (keys2) {
          for (let i = 0; i < keys2.length; i++) {
            const key = keys2[i];
            const val = parent2[key];
            if (Array.isArray(val)) {
              if (val.includes(node))
                return true;
            } else {
              if (val === node)
                return true;
            }
          }
        }
        return false;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isLet.js
  var require_isLet = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isLet.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = isLet;
      var _index = require_generated();
      {
        BLOCK_SCOPED_SYMBOL = Symbol.for("var used to be block scoped");
      }
      var BLOCK_SCOPED_SYMBOL;
      function isLet(node) {
        {
          return (0, _index.isVariableDeclaration)(node) && (node.kind !== "var" || node[BLOCK_SCOPED_SYMBOL]);
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isBlockScoped.js
  var require_isBlockScoped = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isBlockScoped.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = isBlockScoped;
      var _index = require_generated();
      var _isLet = require_isLet();
      function isBlockScoped(node) {
        return (0, _index.isFunctionDeclaration)(node) || (0, _index.isClassDeclaration)(node) || (0, _isLet.default)(node);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isImmutable.js
  var require_isImmutable = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isImmutable.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = isImmutable;
      var _isType = require_isType();
      var _index = require_generated();
      function isImmutable(node) {
        if ((0, _isType.default)(node.type, "Immutable"))
          return true;
        if ((0, _index.isIdentifier)(node)) {
          if (node.name === "undefined") {
            return true;
          } else {
            return false;
          }
        }
        return false;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isNodesEquivalent.js
  var require_isNodesEquivalent = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isNodesEquivalent.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = isNodesEquivalent;
      var _index = require_definitions();
      function isNodesEquivalent(a, b) {
        if (typeof a !== "object" || typeof b !== "object" || a == null || b == null) {
          return a === b;
        }
        if (a.type !== b.type) {
          return false;
        }
        const fields = Object.keys(_index.NODE_FIELDS[a.type] || a.type);
        const visitorKeys = _index.VISITOR_KEYS[a.type];
        for (const field of fields) {
          const val_a = a[field];
          const val_b = b[field];
          if (typeof val_a !== typeof val_b) {
            return false;
          }
          if (val_a == null && val_b == null) {
            continue;
          } else if (val_a == null || val_b == null) {
            return false;
          }
          if (Array.isArray(val_a)) {
            if (!Array.isArray(val_b)) {
              return false;
            }
            if (val_a.length !== val_b.length) {
              return false;
            }
            for (let i = 0; i < val_a.length; i++) {
              if (!isNodesEquivalent(val_a[i], val_b[i])) {
                return false;
              }
            }
            continue;
          }
          if (typeof val_a === "object" && !(visitorKeys != null && visitorKeys.includes(field))) {
            for (const key of Object.keys(val_a)) {
              if (val_a[key] !== val_b[key]) {
                return false;
              }
            }
            continue;
          }
          if (!isNodesEquivalent(val_a, val_b)) {
            return false;
          }
        }
        return true;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isReferenced.js
  var require_isReferenced = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isReferenced.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = isReferenced;
      function isReferenced(node, parent2, grandparent) {
        switch (parent2.type) {
          case "MemberExpression":
          case "OptionalMemberExpression":
            if (parent2.property === node) {
              return !!parent2.computed;
            }
            return parent2.object === node;
          case "JSXMemberExpression":
            return parent2.object === node;
          case "VariableDeclarator":
            return parent2.init === node;
          case "ArrowFunctionExpression":
            return parent2.body === node;
          case "PrivateName":
            return false;
          case "ClassMethod":
          case "ClassPrivateMethod":
          case "ObjectMethod":
            if (parent2.key === node) {
              return !!parent2.computed;
            }
            return false;
          case "ObjectProperty":
            if (parent2.key === node) {
              return !!parent2.computed;
            }
            return !grandparent || grandparent.type !== "ObjectPattern";
          case "ClassProperty":
          case "ClassAccessorProperty":
            if (parent2.key === node) {
              return !!parent2.computed;
            }
            return true;
          case "ClassPrivateProperty":
            return parent2.key !== node;
          case "ClassDeclaration":
          case "ClassExpression":
            return parent2.superClass === node;
          case "AssignmentExpression":
            return parent2.right === node;
          case "AssignmentPattern":
            return parent2.right === node;
          case "LabeledStatement":
            return false;
          case "CatchClause":
            return false;
          case "RestElement":
            return false;
          case "BreakStatement":
          case "ContinueStatement":
            return false;
          case "FunctionDeclaration":
          case "FunctionExpression":
            return false;
          case "ExportNamespaceSpecifier":
          case "ExportDefaultSpecifier":
            return false;
          case "ExportSpecifier":
            if (grandparent != null && grandparent.source) {
              return false;
            }
            return parent2.local === node;
          case "ImportDefaultSpecifier":
          case "ImportNamespaceSpecifier":
          case "ImportSpecifier":
            return false;
          case "ImportAttribute":
            return false;
          case "JSXAttribute":
            return false;
          case "ObjectPattern":
          case "ArrayPattern":
            return false;
          case "MetaProperty":
            return false;
          case "ObjectTypeProperty":
            return parent2.key !== node;
          case "TSEnumMember":
            return parent2.id !== node;
          case "TSPropertySignature":
            if (parent2.key === node) {
              return !!parent2.computed;
            }
            return true;
        }
        return true;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isScope.js
  var require_isScope = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isScope.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = isScope;
      var _index = require_generated();
      function isScope(node, parent2) {
        if ((0, _index.isBlockStatement)(node) && ((0, _index.isFunction)(parent2) || (0, _index.isCatchClause)(parent2))) {
          return false;
        }
        if ((0, _index.isPattern)(node) && ((0, _index.isFunction)(parent2) || (0, _index.isCatchClause)(parent2))) {
          return true;
        }
        return (0, _index.isScopable)(node);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isSpecifierDefault.js
  var require_isSpecifierDefault = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isSpecifierDefault.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = isSpecifierDefault;
      var _index = require_generated();
      function isSpecifierDefault(specifier) {
        return (0, _index.isImportDefaultSpecifier)(specifier) || (0, _index.isIdentifier)(specifier.imported || specifier.exported, {
          name: "default"
        });
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isValidES3Identifier.js
  var require_isValidES3Identifier = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isValidES3Identifier.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = isValidES3Identifier;
      var _isValidIdentifier = require_isValidIdentifier();
      var RESERVED_WORDS_ES3_ONLY = /* @__PURE__ */ new Set(["abstract", "boolean", "byte", "char", "double", "enum", "final", "float", "goto", "implements", "int", "interface", "long", "native", "package", "private", "protected", "public", "short", "static", "synchronized", "throws", "transient", "volatile"]);
      function isValidES3Identifier(name) {
        return (0, _isValidIdentifier.default)(name) && !RESERVED_WORDS_ES3_ONLY.has(name);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isVar.js
  var require_isVar = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/validators/isVar.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = isVar;
      var _index = require_generated();
      {
        BLOCK_SCOPED_SYMBOL = Symbol.for("var used to be block scoped");
      }
      var BLOCK_SCOPED_SYMBOL;
      function isVar(node) {
        {
          return (0, _index.isVariableDeclaration)(node, {
            kind: "var"
          }) && !node[BLOCK_SCOPED_SYMBOL];
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/gatherSequenceExpressions.js
  var require_gatherSequenceExpressions = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/gatherSequenceExpressions.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = gatherSequenceExpressions;
      var _getBindingIdentifiers = require_getBindingIdentifiers();
      var _index = require_generated();
      var _index2 = require_generated2();
      var _productions = require_productions();
      var _cloneNode = require_cloneNode();
      function gatherSequenceExpressions(nodes, declars) {
        const exprs = [];
        let ensureLastUndefined = true;
        for (const node of nodes) {
          if (!(0, _index.isEmptyStatement)(node)) {
            ensureLastUndefined = false;
          }
          if ((0, _index.isExpression)(node)) {
            exprs.push(node);
          } else if ((0, _index.isExpressionStatement)(node)) {
            exprs.push(node.expression);
          } else if ((0, _index.isVariableDeclaration)(node)) {
            if (node.kind !== "var")
              return;
            for (const declar of node.declarations) {
              const bindings = (0, _getBindingIdentifiers.default)(declar);
              for (const key of Object.keys(bindings)) {
                declars.push({
                  kind: node.kind,
                  id: (0, _cloneNode.default)(bindings[key])
                });
              }
              if (declar.init) {
                exprs.push((0, _index2.assignmentExpression)("=", declar.id, declar.init));
              }
            }
            ensureLastUndefined = true;
          } else if ((0, _index.isIfStatement)(node)) {
            const consequent = node.consequent ? gatherSequenceExpressions([node.consequent], declars) : (0, _productions.buildUndefinedNode)();
            const alternate = node.alternate ? gatherSequenceExpressions([node.alternate], declars) : (0, _productions.buildUndefinedNode)();
            if (!consequent || !alternate)
              return;
            exprs.push((0, _index2.conditionalExpression)(node.test, consequent, alternate));
          } else if ((0, _index.isBlockStatement)(node)) {
            const body = gatherSequenceExpressions(node.body, declars);
            if (!body)
              return;
            exprs.push(body);
          } else if ((0, _index.isEmptyStatement)(node)) {
            if (nodes.indexOf(node) === 0) {
              ensureLastUndefined = true;
            }
          } else {
            return;
          }
        }
        if (ensureLastUndefined) {
          exprs.push((0, _productions.buildUndefinedNode)());
        }
        if (exprs.length === 1) {
          return exprs[0];
        } else {
          return (0, _index2.sequenceExpression)(exprs);
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toSequenceExpression.js
  var require_toSequenceExpression = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/converters/toSequenceExpression.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = toSequenceExpression;
      var _gatherSequenceExpressions = require_gatherSequenceExpressions();
      function toSequenceExpression(nodes, scope) {
        if (!(nodes != null && nodes.length))
          return;
        const declars = [];
        const result2 = (0, _gatherSequenceExpressions.default)(nodes, declars);
        if (!result2)
          return;
        for (const declar of declars) {
          scope.push(declar);
        }
        return result2;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/index.js
  var require_lib5 = __commonJS({
    "../../node_modules/.pnpm/@babel+types@7.28.2/node_modules/@babel/types/lib/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      var _exportNames = {
        react: true,
        assertNode: true,
        createTypeAnnotationBasedOnTypeof: true,
        createUnionTypeAnnotation: true,
        createFlowUnionType: true,
        createTSUnionType: true,
        cloneNode: true,
        clone: true,
        cloneDeep: true,
        cloneDeepWithoutLoc: true,
        cloneWithoutLoc: true,
        addComment: true,
        addComments: true,
        inheritInnerComments: true,
        inheritLeadingComments: true,
        inheritsComments: true,
        inheritTrailingComments: true,
        removeComments: true,
        ensureBlock: true,
        toBindingIdentifierName: true,
        toBlock: true,
        toComputedKey: true,
        toExpression: true,
        toIdentifier: true,
        toKeyAlias: true,
        toStatement: true,
        valueToNode: true,
        appendToMemberExpression: true,
        inherits: true,
        prependToMemberExpression: true,
        removeProperties: true,
        removePropertiesDeep: true,
        removeTypeDuplicates: true,
        getAssignmentIdentifiers: true,
        getBindingIdentifiers: true,
        getOuterBindingIdentifiers: true,
        getFunctionName: true,
        traverse: true,
        traverseFast: true,
        shallowEqual: true,
        is: true,
        isBinding: true,
        isBlockScoped: true,
        isImmutable: true,
        isLet: true,
        isNode: true,
        isNodesEquivalent: true,
        isPlaceholderType: true,
        isReferenced: true,
        isScope: true,
        isSpecifierDefault: true,
        isType: true,
        isValidES3Identifier: true,
        isValidIdentifier: true,
        isVar: true,
        matchesPattern: true,
        validate: true,
        buildMatchMemberExpression: true,
        __internal__deprecationWarning: true
      };
      Object.defineProperty(exports8, "__internal__deprecationWarning", {
        enumerable: true,
        get: function() {
          return _deprecationWarning.default;
        }
      });
      Object.defineProperty(exports8, "addComment", {
        enumerable: true,
        get: function() {
          return _addComment.default;
        }
      });
      Object.defineProperty(exports8, "addComments", {
        enumerable: true,
        get: function() {
          return _addComments.default;
        }
      });
      Object.defineProperty(exports8, "appendToMemberExpression", {
        enumerable: true,
        get: function() {
          return _appendToMemberExpression.default;
        }
      });
      Object.defineProperty(exports8, "assertNode", {
        enumerable: true,
        get: function() {
          return _assertNode.default;
        }
      });
      Object.defineProperty(exports8, "buildMatchMemberExpression", {
        enumerable: true,
        get: function() {
          return _buildMatchMemberExpression.default;
        }
      });
      Object.defineProperty(exports8, "clone", {
        enumerable: true,
        get: function() {
          return _clone.default;
        }
      });
      Object.defineProperty(exports8, "cloneDeep", {
        enumerable: true,
        get: function() {
          return _cloneDeep.default;
        }
      });
      Object.defineProperty(exports8, "cloneDeepWithoutLoc", {
        enumerable: true,
        get: function() {
          return _cloneDeepWithoutLoc.default;
        }
      });
      Object.defineProperty(exports8, "cloneNode", {
        enumerable: true,
        get: function() {
          return _cloneNode.default;
        }
      });
      Object.defineProperty(exports8, "cloneWithoutLoc", {
        enumerable: true,
        get: function() {
          return _cloneWithoutLoc.default;
        }
      });
      Object.defineProperty(exports8, "createFlowUnionType", {
        enumerable: true,
        get: function() {
          return _createFlowUnionType.default;
        }
      });
      Object.defineProperty(exports8, "createTSUnionType", {
        enumerable: true,
        get: function() {
          return _createTSUnionType.default;
        }
      });
      Object.defineProperty(exports8, "createTypeAnnotationBasedOnTypeof", {
        enumerable: true,
        get: function() {
          return _createTypeAnnotationBasedOnTypeof.default;
        }
      });
      Object.defineProperty(exports8, "createUnionTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _createFlowUnionType.default;
        }
      });
      Object.defineProperty(exports8, "ensureBlock", {
        enumerable: true,
        get: function() {
          return _ensureBlock.default;
        }
      });
      Object.defineProperty(exports8, "getAssignmentIdentifiers", {
        enumerable: true,
        get: function() {
          return _getAssignmentIdentifiers.default;
        }
      });
      Object.defineProperty(exports8, "getBindingIdentifiers", {
        enumerable: true,
        get: function() {
          return _getBindingIdentifiers.default;
        }
      });
      Object.defineProperty(exports8, "getFunctionName", {
        enumerable: true,
        get: function() {
          return _getFunctionName.default;
        }
      });
      Object.defineProperty(exports8, "getOuterBindingIdentifiers", {
        enumerable: true,
        get: function() {
          return _getOuterBindingIdentifiers.default;
        }
      });
      Object.defineProperty(exports8, "inheritInnerComments", {
        enumerable: true,
        get: function() {
          return _inheritInnerComments.default;
        }
      });
      Object.defineProperty(exports8, "inheritLeadingComments", {
        enumerable: true,
        get: function() {
          return _inheritLeadingComments.default;
        }
      });
      Object.defineProperty(exports8, "inheritTrailingComments", {
        enumerable: true,
        get: function() {
          return _inheritTrailingComments.default;
        }
      });
      Object.defineProperty(exports8, "inherits", {
        enumerable: true,
        get: function() {
          return _inherits.default;
        }
      });
      Object.defineProperty(exports8, "inheritsComments", {
        enumerable: true,
        get: function() {
          return _inheritsComments.default;
        }
      });
      Object.defineProperty(exports8, "is", {
        enumerable: true,
        get: function() {
          return _is.default;
        }
      });
      Object.defineProperty(exports8, "isBinding", {
        enumerable: true,
        get: function() {
          return _isBinding.default;
        }
      });
      Object.defineProperty(exports8, "isBlockScoped", {
        enumerable: true,
        get: function() {
          return _isBlockScoped.default;
        }
      });
      Object.defineProperty(exports8, "isImmutable", {
        enumerable: true,
        get: function() {
          return _isImmutable.default;
        }
      });
      Object.defineProperty(exports8, "isLet", {
        enumerable: true,
        get: function() {
          return _isLet.default;
        }
      });
      Object.defineProperty(exports8, "isNode", {
        enumerable: true,
        get: function() {
          return _isNode.default;
        }
      });
      Object.defineProperty(exports8, "isNodesEquivalent", {
        enumerable: true,
        get: function() {
          return _isNodesEquivalent.default;
        }
      });
      Object.defineProperty(exports8, "isPlaceholderType", {
        enumerable: true,
        get: function() {
          return _isPlaceholderType.default;
        }
      });
      Object.defineProperty(exports8, "isReferenced", {
        enumerable: true,
        get: function() {
          return _isReferenced.default;
        }
      });
      Object.defineProperty(exports8, "isScope", {
        enumerable: true,
        get: function() {
          return _isScope.default;
        }
      });
      Object.defineProperty(exports8, "isSpecifierDefault", {
        enumerable: true,
        get: function() {
          return _isSpecifierDefault.default;
        }
      });
      Object.defineProperty(exports8, "isType", {
        enumerable: true,
        get: function() {
          return _isType.default;
        }
      });
      Object.defineProperty(exports8, "isValidES3Identifier", {
        enumerable: true,
        get: function() {
          return _isValidES3Identifier.default;
        }
      });
      Object.defineProperty(exports8, "isValidIdentifier", {
        enumerable: true,
        get: function() {
          return _isValidIdentifier.default;
        }
      });
      Object.defineProperty(exports8, "isVar", {
        enumerable: true,
        get: function() {
          return _isVar.default;
        }
      });
      Object.defineProperty(exports8, "matchesPattern", {
        enumerable: true,
        get: function() {
          return _matchesPattern.default;
        }
      });
      Object.defineProperty(exports8, "prependToMemberExpression", {
        enumerable: true,
        get: function() {
          return _prependToMemberExpression.default;
        }
      });
      exports8.react = void 0;
      Object.defineProperty(exports8, "removeComments", {
        enumerable: true,
        get: function() {
          return _removeComments.default;
        }
      });
      Object.defineProperty(exports8, "removeProperties", {
        enumerable: true,
        get: function() {
          return _removeProperties.default;
        }
      });
      Object.defineProperty(exports8, "removePropertiesDeep", {
        enumerable: true,
        get: function() {
          return _removePropertiesDeep.default;
        }
      });
      Object.defineProperty(exports8, "removeTypeDuplicates", {
        enumerable: true,
        get: function() {
          return _removeTypeDuplicates.default;
        }
      });
      Object.defineProperty(exports8, "shallowEqual", {
        enumerable: true,
        get: function() {
          return _shallowEqual.default;
        }
      });
      Object.defineProperty(exports8, "toBindingIdentifierName", {
        enumerable: true,
        get: function() {
          return _toBindingIdentifierName.default;
        }
      });
      Object.defineProperty(exports8, "toBlock", {
        enumerable: true,
        get: function() {
          return _toBlock.default;
        }
      });
      Object.defineProperty(exports8, "toComputedKey", {
        enumerable: true,
        get: function() {
          return _toComputedKey.default;
        }
      });
      Object.defineProperty(exports8, "toExpression", {
        enumerable: true,
        get: function() {
          return _toExpression.default;
        }
      });
      Object.defineProperty(exports8, "toIdentifier", {
        enumerable: true,
        get: function() {
          return _toIdentifier.default;
        }
      });
      Object.defineProperty(exports8, "toKeyAlias", {
        enumerable: true,
        get: function() {
          return _toKeyAlias.default;
        }
      });
      Object.defineProperty(exports8, "toStatement", {
        enumerable: true,
        get: function() {
          return _toStatement.default;
        }
      });
      Object.defineProperty(exports8, "traverse", {
        enumerable: true,
        get: function() {
          return _traverse.default;
        }
      });
      Object.defineProperty(exports8, "traverseFast", {
        enumerable: true,
        get: function() {
          return _traverseFast.default;
        }
      });
      Object.defineProperty(exports8, "validate", {
        enumerable: true,
        get: function() {
          return _validate.default;
        }
      });
      Object.defineProperty(exports8, "valueToNode", {
        enumerable: true,
        get: function() {
          return _valueToNode.default;
        }
      });
      var _isReactComponent = require_isReactComponent();
      var _isCompatTag = require_isCompatTag();
      var _buildChildren = require_buildChildren();
      var _assertNode = require_assertNode();
      var _index = require_generated3();
      Object.keys(_index).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports8 && exports8[key] === _index[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _index[key];
          }
        });
      });
      var _createTypeAnnotationBasedOnTypeof = require_createTypeAnnotationBasedOnTypeof();
      var _createFlowUnionType = require_createFlowUnionType();
      var _createTSUnionType = require_createTSUnionType();
      var _productions = require_productions();
      Object.keys(_productions).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports8 && exports8[key] === _productions[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _productions[key];
          }
        });
      });
      var _index2 = require_generated2();
      Object.keys(_index2).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports8 && exports8[key] === _index2[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _index2[key];
          }
        });
      });
      var _cloneNode = require_cloneNode();
      var _clone = require_clone();
      var _cloneDeep = require_cloneDeep();
      var _cloneDeepWithoutLoc = require_cloneDeepWithoutLoc();
      var _cloneWithoutLoc = require_cloneWithoutLoc();
      var _addComment = require_addComment();
      var _addComments = require_addComments();
      var _inheritInnerComments = require_inheritInnerComments();
      var _inheritLeadingComments = require_inheritLeadingComments();
      var _inheritsComments = require_inheritsComments();
      var _inheritTrailingComments = require_inheritTrailingComments();
      var _removeComments = require_removeComments();
      var _index3 = require_generated4();
      Object.keys(_index3).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports8 && exports8[key] === _index3[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _index3[key];
          }
        });
      });
      var _index4 = require_constants();
      Object.keys(_index4).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports8 && exports8[key] === _index4[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _index4[key];
          }
        });
      });
      var _ensureBlock = require_ensureBlock();
      var _toBindingIdentifierName = require_toBindingIdentifierName();
      var _toBlock = require_toBlock();
      var _toComputedKey = require_toComputedKey();
      var _toExpression = require_toExpression();
      var _toIdentifier = require_toIdentifier();
      var _toKeyAlias = require_toKeyAlias();
      var _toStatement = require_toStatement();
      var _valueToNode = require_valueToNode();
      var _index5 = require_definitions();
      Object.keys(_index5).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports8 && exports8[key] === _index5[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _index5[key];
          }
        });
      });
      var _appendToMemberExpression = require_appendToMemberExpression();
      var _inherits = require_inherits();
      var _prependToMemberExpression = require_prependToMemberExpression();
      var _removeProperties = require_removeProperties();
      var _removePropertiesDeep = require_removePropertiesDeep();
      var _removeTypeDuplicates = require_removeTypeDuplicates();
      var _getAssignmentIdentifiers = require_getAssignmentIdentifiers();
      var _getBindingIdentifiers = require_getBindingIdentifiers();
      var _getOuterBindingIdentifiers = require_getOuterBindingIdentifiers();
      var _getFunctionName = require_getFunctionName();
      var _traverse = require_traverse();
      Object.keys(_traverse).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports8 && exports8[key] === _traverse[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _traverse[key];
          }
        });
      });
      var _traverseFast = require_traverseFast();
      var _shallowEqual = require_shallowEqual();
      var _is = require_is();
      var _isBinding = require_isBinding();
      var _isBlockScoped = require_isBlockScoped();
      var _isImmutable = require_isImmutable();
      var _isLet = require_isLet();
      var _isNode = require_isNode();
      var _isNodesEquivalent = require_isNodesEquivalent();
      var _isPlaceholderType = require_isPlaceholderType();
      var _isReferenced = require_isReferenced();
      var _isScope = require_isScope();
      var _isSpecifierDefault = require_isSpecifierDefault();
      var _isType = require_isType();
      var _isValidES3Identifier = require_isValidES3Identifier();
      var _isValidIdentifier = require_isValidIdentifier();
      var _isVar = require_isVar();
      var _matchesPattern = require_matchesPattern();
      var _validate = require_validate();
      var _buildMatchMemberExpression = require_buildMatchMemberExpression();
      var _index6 = require_generated();
      Object.keys(_index6).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports8 && exports8[key] === _index6[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _index6[key];
          }
        });
      });
      var _deprecationWarning = require_deprecationWarning();
      var _toSequenceExpression = require_toSequenceExpression();
      var react = exports8.react = {
        isReactComponent: _isReactComponent.default,
        isCompatTag: _isCompatTag.default,
        buildChildren: _buildChildren.default
      };
      {
        exports8.toSequenceExpression = _toSequenceExpression.default;
      }
      if (define_process_default.env.BABEL_TYPES_8_BREAKING) {
        console.warn("BABEL_TYPES_8_BREAKING is not supported anymore. Use the latest Babel 8.0.0 pre-release instead!");
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/node/whitespace.js
  var require_whitespace = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/node/whitespace.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.nodes = void 0;
      var _t = require_lib5();
      var {
        FLIPPED_ALIAS_KEYS,
        isArrayExpression,
        isAssignmentExpression,
        isBinary,
        isBlockStatement,
        isCallExpression,
        isFunction: isFunction3,
        isIdentifier: isIdentifier2,
        isLiteral,
        isMemberExpression,
        isObjectExpression,
        isOptionalCallExpression,
        isOptionalMemberExpression,
        isStringLiteral
      } = _t;
      function crawlInternal(node, state) {
        if (!node)
          return state;
        if (isMemberExpression(node) || isOptionalMemberExpression(node)) {
          crawlInternal(node.object, state);
          if (node.computed)
            crawlInternal(node.property, state);
        } else if (isBinary(node) || isAssignmentExpression(node)) {
          crawlInternal(node.left, state);
          crawlInternal(node.right, state);
        } else if (isCallExpression(node) || isOptionalCallExpression(node)) {
          state.hasCall = true;
          crawlInternal(node.callee, state);
        } else if (isFunction3(node)) {
          state.hasFunction = true;
        } else if (isIdentifier2(node)) {
          state.hasHelper = state.hasHelper || node.callee && isHelper(node.callee);
        }
        return state;
      }
      function crawl(node) {
        return crawlInternal(node, {
          hasCall: false,
          hasFunction: false,
          hasHelper: false
        });
      }
      function isHelper(node) {
        if (!node)
          return false;
        if (isMemberExpression(node)) {
          return isHelper(node.object) || isHelper(node.property);
        } else if (isIdentifier2(node)) {
          return node.name === "require" || node.name.charCodeAt(0) === 95;
        } else if (isCallExpression(node)) {
          return isHelper(node.callee);
        } else if (isBinary(node) || isAssignmentExpression(node)) {
          return isIdentifier2(node.left) && isHelper(node.left) || isHelper(node.right);
        } else {
          return false;
        }
      }
      function isType(node) {
        return isLiteral(node) || isObjectExpression(node) || isArrayExpression(node) || isIdentifier2(node) || isMemberExpression(node);
      }
      var nodes = exports8.nodes = {
        AssignmentExpression(node) {
          const state = crawl(node.right);
          if (state.hasCall && state.hasHelper || state.hasFunction) {
            return state.hasFunction ? 1 | 2 : 2;
          }
        },
        SwitchCase(node, parent2) {
          return (!!node.consequent.length || parent2.cases[0] === node ? 1 : 0) | (!node.consequent.length && parent2.cases[parent2.cases.length - 1] === node ? 2 : 0);
        },
        LogicalExpression(node) {
          if (isFunction3(node.left) || isFunction3(node.right)) {
            return 2;
          }
        },
        Literal(node) {
          if (isStringLiteral(node) && node.value === "use strict") {
            return 2;
          }
        },
        CallExpression(node) {
          if (isFunction3(node.callee) || isHelper(node)) {
            return 1 | 2;
          }
        },
        OptionalCallExpression(node) {
          if (isFunction3(node.callee)) {
            return 1 | 2;
          }
        },
        VariableDeclaration(node) {
          for (let i = 0; i < node.declarations.length; i++) {
            const declar = node.declarations[i];
            let enabled = isHelper(declar.id) && !isType(declar.init);
            if (!enabled && declar.init) {
              const state = crawl(declar.init);
              enabled = isHelper(declar.init) && state.hasCall || state.hasFunction;
            }
            if (enabled) {
              return 1 | 2;
            }
          }
        },
        IfStatement(node) {
          if (isBlockStatement(node.consequent)) {
            return 1 | 2;
          }
        }
      };
      nodes.ObjectProperty = nodes.ObjectTypeProperty = nodes.ObjectMethod = function(node, parent2) {
        if (parent2.properties[0] === node) {
          return 1;
        }
      };
      nodes.ObjectTypeCallProperty = function(node, parent2) {
        var _parent$properties;
        if (parent2.callProperties[0] === node && !((_parent$properties = parent2.properties) != null && _parent$properties.length)) {
          return 1;
        }
      };
      nodes.ObjectTypeIndexer = function(node, parent2) {
        var _parent$properties2, _parent$callPropertie;
        if (parent2.indexers[0] === node && !((_parent$properties2 = parent2.properties) != null && _parent$properties2.length) && !((_parent$callPropertie = parent2.callProperties) != null && _parent$callPropertie.length)) {
          return 1;
        }
      };
      nodes.ObjectTypeInternalSlot = function(node, parent2) {
        var _parent$properties3, _parent$callPropertie2, _parent$indexers;
        if (parent2.internalSlots[0] === node && !((_parent$properties3 = parent2.properties) != null && _parent$properties3.length) && !((_parent$callPropertie2 = parent2.callProperties) != null && _parent$callPropertie2.length) && !((_parent$indexers = parent2.indexers) != null && _parent$indexers.length)) {
          return 1;
        }
      };
      [["Function", true], ["Class", true], ["Loop", true], ["LabeledStatement", true], ["SwitchStatement", true], ["TryStatement", true]].forEach(function([type, amounts]) {
        [type].concat(FLIPPED_ALIAS_KEYS[type] || []).forEach(function(type2) {
          const ret = amounts ? 1 | 2 : 0;
          nodes[type2] = () => ret;
        });
      });
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/node/parentheses.js
  var require_parentheses = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/node/parentheses.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.AssignmentExpression = AssignmentExpression;
      exports8.Binary = Binary;
      exports8.BinaryExpression = BinaryExpression;
      exports8.ClassExpression = ClassExpression;
      exports8.ArrowFunctionExpression = exports8.ConditionalExpression = ConditionalExpression;
      exports8.DoExpression = DoExpression;
      exports8.FunctionExpression = FunctionExpression;
      exports8.FunctionTypeAnnotation = FunctionTypeAnnotation;
      exports8.Identifier = Identifier;
      exports8.LogicalExpression = LogicalExpression;
      exports8.NullableTypeAnnotation = NullableTypeAnnotation;
      exports8.ObjectExpression = ObjectExpression;
      exports8.OptionalIndexedAccessType = OptionalIndexedAccessType;
      exports8.OptionalCallExpression = exports8.OptionalMemberExpression = OptionalMemberExpression;
      exports8.SequenceExpression = SequenceExpression;
      exports8.TSSatisfiesExpression = exports8.TSAsExpression = TSAsExpression;
      exports8.TSConditionalType = TSConditionalType;
      exports8.TSConstructorType = exports8.TSFunctionType = TSFunctionType;
      exports8.TSInferType = TSInferType;
      exports8.TSInstantiationExpression = TSInstantiationExpression;
      exports8.TSIntersectionType = TSIntersectionType;
      exports8.UnaryLike = exports8.TSTypeAssertion = UnaryLike;
      exports8.TSTypeOperator = TSTypeOperator;
      exports8.TSUnionType = TSUnionType;
      exports8.IntersectionTypeAnnotation = exports8.UnionTypeAnnotation = UnionTypeAnnotation;
      exports8.UpdateExpression = UpdateExpression;
      exports8.AwaitExpression = exports8.YieldExpression = YieldExpression;
      var _t = require_lib5();
      var _index = require_node();
      var {
        isArrayTypeAnnotation,
        isBinaryExpression,
        isCallExpression,
        isForOfStatement,
        isIndexedAccessType,
        isMemberExpression,
        isObjectPattern,
        isOptionalMemberExpression,
        isYieldExpression,
        isStatement
      } = _t;
      var PRECEDENCE = /* @__PURE__ */ new Map([["||", 0], ["??", 0], ["|>", 0], ["&&", 1], ["|", 2], ["^", 3], ["&", 4], ["==", 5], ["===", 5], ["!=", 5], ["!==", 5], ["<", 6], [">", 6], ["<=", 6], [">=", 6], ["in", 6], ["instanceof", 6], [">>", 7], ["<<", 7], [">>>", 7], ["+", 8], ["-", 8], ["*", 9], ["/", 9], ["%", 9], ["**", 10]]);
      function getBinaryPrecedence(node, nodeType) {
        if (nodeType === "BinaryExpression" || nodeType === "LogicalExpression") {
          return PRECEDENCE.get(node.operator);
        }
        if (nodeType === "TSAsExpression" || nodeType === "TSSatisfiesExpression") {
          return PRECEDENCE.get("in");
        }
      }
      function isTSTypeExpression(nodeType) {
        return nodeType === "TSAsExpression" || nodeType === "TSSatisfiesExpression" || nodeType === "TSTypeAssertion";
      }
      var isClassExtendsClause = (node, parent2) => {
        const parentType = parent2.type;
        return (parentType === "ClassDeclaration" || parentType === "ClassExpression") && parent2.superClass === node;
      };
      var hasPostfixPart = (node, parent2) => {
        const parentType = parent2.type;
        return (parentType === "MemberExpression" || parentType === "OptionalMemberExpression") && parent2.object === node || (parentType === "CallExpression" || parentType === "OptionalCallExpression" || parentType === "NewExpression") && parent2.callee === node || parentType === "TaggedTemplateExpression" && parent2.tag === node || parentType === "TSNonNullExpression";
      };
      function NullableTypeAnnotation(node, parent2) {
        return isArrayTypeAnnotation(parent2);
      }
      function FunctionTypeAnnotation(node, parent2, tokenContext) {
        const parentType = parent2.type;
        return parentType === "UnionTypeAnnotation" || parentType === "IntersectionTypeAnnotation" || parentType === "ArrayTypeAnnotation" || Boolean(tokenContext & _index.TokenContext.arrowFlowReturnType);
      }
      function UpdateExpression(node, parent2) {
        return hasPostfixPart(node, parent2) || isClassExtendsClause(node, parent2);
      }
      function needsParenBeforeExpressionBrace(tokenContext) {
        return Boolean(tokenContext & (_index.TokenContext.expressionStatement | _index.TokenContext.arrowBody));
      }
      function ObjectExpression(node, parent2, tokenContext) {
        return needsParenBeforeExpressionBrace(tokenContext);
      }
      function DoExpression(node, parent2, tokenContext) {
        return !node.async && Boolean(tokenContext & _index.TokenContext.expressionStatement);
      }
      function Binary(node, parent2) {
        const parentType = parent2.type;
        if (node.type === "BinaryExpression" && node.operator === "**" && parentType === "BinaryExpression" && parent2.operator === "**") {
          return parent2.left === node;
        }
        if (isClassExtendsClause(node, parent2)) {
          return true;
        }
        if (hasPostfixPart(node, parent2) || parentType === "UnaryExpression" || parentType === "SpreadElement" || parentType === "AwaitExpression") {
          return true;
        }
        const parentPos = getBinaryPrecedence(parent2, parentType);
        if (parentPos != null) {
          const nodePos = getBinaryPrecedence(node, node.type);
          if (parentPos === nodePos && parentType === "BinaryExpression" && parent2.right === node || parentPos > nodePos) {
            return true;
          }
        }
        return void 0;
      }
      function UnionTypeAnnotation(node, parent2) {
        const parentType = parent2.type;
        return parentType === "ArrayTypeAnnotation" || parentType === "NullableTypeAnnotation" || parentType === "IntersectionTypeAnnotation" || parentType === "UnionTypeAnnotation";
      }
      function OptionalIndexedAccessType(node, parent2) {
        return isIndexedAccessType(parent2) && parent2.objectType === node;
      }
      function TSAsExpression(node, parent2) {
        if ((parent2.type === "AssignmentExpression" || parent2.type === "AssignmentPattern") && parent2.left === node) {
          return true;
        }
        if (parent2.type === "BinaryExpression" && (parent2.operator === "|" || parent2.operator === "&") && node === parent2.left) {
          return true;
        }
        return Binary(node, parent2);
      }
      function TSConditionalType(node, parent2) {
        const parentType = parent2.type;
        if (parentType === "TSArrayType" || parentType === "TSIndexedAccessType" && parent2.objectType === node || parentType === "TSOptionalType" || parentType === "TSTypeOperator" || parentType === "TSTypeParameter") {
          return true;
        }
        if ((parentType === "TSIntersectionType" || parentType === "TSUnionType") && parent2.types[0] === node) {
          return true;
        }
        if (parentType === "TSConditionalType" && (parent2.checkType === node || parent2.extendsType === node)) {
          return true;
        }
        return false;
      }
      function TSUnionType(node, parent2) {
        const parentType = parent2.type;
        return parentType === "TSIntersectionType" || parentType === "TSTypeOperator" || parentType === "TSArrayType" || parentType === "TSIndexedAccessType" && parent2.objectType === node || parentType === "TSOptionalType";
      }
      function TSIntersectionType(node, parent2) {
        const parentType = parent2.type;
        return parentType === "TSTypeOperator" || parentType === "TSArrayType" || parentType === "TSIndexedAccessType" && parent2.objectType === node || parentType === "TSOptionalType";
      }
      function TSInferType(node, parent2) {
        const parentType = parent2.type;
        if (parentType === "TSArrayType" || parentType === "TSIndexedAccessType" && parent2.objectType === node || parentType === "TSOptionalType") {
          return true;
        }
        if (node.typeParameter.constraint) {
          if ((parentType === "TSIntersectionType" || parentType === "TSUnionType") && parent2.types[0] === node) {
            return true;
          }
        }
        return false;
      }
      function TSTypeOperator(node, parent2) {
        const parentType = parent2.type;
        return parentType === "TSArrayType" || parentType === "TSIndexedAccessType" && parent2.objectType === node || parentType === "TSOptionalType";
      }
      function TSInstantiationExpression(node, parent2) {
        const parentType = parent2.type;
        return (parentType === "CallExpression" || parentType === "OptionalCallExpression" || parentType === "NewExpression" || parentType === "TSInstantiationExpression") && !!parent2.typeParameters;
      }
      function TSFunctionType(node, parent2) {
        const parentType = parent2.type;
        return parentType === "TSIntersectionType" || parentType === "TSUnionType" || parentType === "TSTypeOperator" || parentType === "TSOptionalType" || parentType === "TSArrayType" || parentType === "TSIndexedAccessType" && parent2.objectType === node || parentType === "TSConditionalType" && (parent2.checkType === node || parent2.extendsType === node);
      }
      function BinaryExpression(node, parent2, tokenContext) {
        return node.operator === "in" && Boolean(tokenContext & _index.TokenContext.forInOrInitHeadAccumulate);
      }
      function SequenceExpression(node, parent2) {
        const parentType = parent2.type;
        if (parentType === "SequenceExpression" || parentType === "ParenthesizedExpression" || parentType === "MemberExpression" && parent2.property === node || parentType === "OptionalMemberExpression" && parent2.property === node || parentType === "TemplateLiteral") {
          return false;
        }
        if (parentType === "ClassDeclaration") {
          return true;
        }
        if (parentType === "ForOfStatement") {
          return parent2.right === node;
        }
        if (parentType === "ExportDefaultDeclaration") {
          return true;
        }
        return !isStatement(parent2);
      }
      function YieldExpression(node, parent2) {
        const parentType = parent2.type;
        return parentType === "BinaryExpression" || parentType === "LogicalExpression" || parentType === "UnaryExpression" || parentType === "SpreadElement" || hasPostfixPart(node, parent2) || parentType === "AwaitExpression" && isYieldExpression(node) || parentType === "ConditionalExpression" && node === parent2.test || isClassExtendsClause(node, parent2) || isTSTypeExpression(parentType);
      }
      function ClassExpression(node, parent2, tokenContext) {
        return Boolean(tokenContext & (_index.TokenContext.expressionStatement | _index.TokenContext.exportDefault));
      }
      function UnaryLike(node, parent2) {
        return hasPostfixPart(node, parent2) || isBinaryExpression(parent2) && parent2.operator === "**" && parent2.left === node || isClassExtendsClause(node, parent2);
      }
      function FunctionExpression(node, parent2, tokenContext) {
        return Boolean(tokenContext & (_index.TokenContext.expressionStatement | _index.TokenContext.exportDefault));
      }
      function ConditionalExpression(node, parent2) {
        const parentType = parent2.type;
        if (parentType === "UnaryExpression" || parentType === "SpreadElement" || parentType === "BinaryExpression" || parentType === "LogicalExpression" || parentType === "ConditionalExpression" && parent2.test === node || parentType === "AwaitExpression" || isTSTypeExpression(parentType)) {
          return true;
        }
        return UnaryLike(node, parent2);
      }
      function OptionalMemberExpression(node, parent2) {
        return isCallExpression(parent2) && parent2.callee === node || isMemberExpression(parent2) && parent2.object === node;
      }
      function AssignmentExpression(node, parent2, tokenContext) {
        if (needsParenBeforeExpressionBrace(tokenContext) && isObjectPattern(node.left)) {
          return true;
        } else {
          return ConditionalExpression(node, parent2);
        }
      }
      function LogicalExpression(node, parent2) {
        const parentType = parent2.type;
        if (isTSTypeExpression(parentType))
          return true;
        if (parentType !== "LogicalExpression")
          return false;
        switch (node.operator) {
          case "||":
            return parent2.operator === "??" || parent2.operator === "&&";
          case "&&":
            return parent2.operator === "??";
          case "??":
            return parent2.operator !== "??";
        }
      }
      function Identifier(node, parent2, tokenContext, getRawIdentifier) {
        var _node$extra;
        const parentType = parent2.type;
        if ((_node$extra = node.extra) != null && _node$extra.parenthesized && parentType === "AssignmentExpression" && parent2.left === node) {
          const rightType = parent2.right.type;
          if ((rightType === "FunctionExpression" || rightType === "ClassExpression") && parent2.right.id == null) {
            return true;
          }
        }
        if (getRawIdentifier && getRawIdentifier(node) !== node.name) {
          return false;
        }
        if (node.name === "let") {
          const isFollowedByBracket = isMemberExpression(parent2, {
            object: node,
            computed: true
          }) || isOptionalMemberExpression(parent2, {
            object: node,
            computed: true,
            optional: false
          });
          if (isFollowedByBracket && tokenContext & (_index.TokenContext.expressionStatement | _index.TokenContext.forInitHead | _index.TokenContext.forInHead)) {
            return true;
          }
          return Boolean(tokenContext & _index.TokenContext.forOfHead);
        }
        return node.name === "async" && isForOfStatement(parent2, {
          left: node,
          await: false
        });
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/node/index.js
  var require_node = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/node/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.TokenContext = void 0;
      exports8.isLastChild = isLastChild;
      exports8.needsParens = needsParens;
      exports8.needsWhitespace = needsWhitespace;
      exports8.needsWhitespaceAfter = needsWhitespaceAfter;
      exports8.needsWhitespaceBefore = needsWhitespaceBefore;
      var whitespace = require_whitespace();
      var parens = require_parentheses();
      var _t = require_lib5();
      var {
        FLIPPED_ALIAS_KEYS,
        VISITOR_KEYS,
        isCallExpression,
        isDecorator,
        isExpressionStatement,
        isMemberExpression,
        isNewExpression,
        isParenthesizedExpression
      } = _t;
      var TokenContext = exports8.TokenContext = {
        normal: 0,
        expressionStatement: 1,
        arrowBody: 2,
        exportDefault: 4,
        arrowFlowReturnType: 8,
        forInitHead: 16,
        forInHead: 32,
        forOfHead: 64,
        forInOrInitHeadAccumulate: 128,
        forInOrInitHeadAccumulatePassThroughMask: 128
      };
      function expandAliases(obj) {
        const map2 = /* @__PURE__ */ new Map();
        function add2(type, func) {
          const fn = map2.get(type);
          map2.set(type, fn ? function(node, parent2, stack, getRawIdentifier) {
            var _fn;
            return (_fn = fn(node, parent2, stack, getRawIdentifier)) != null ? _fn : func(node, parent2, stack, getRawIdentifier);
          } : func);
        }
        for (const type of Object.keys(obj)) {
          const aliases = FLIPPED_ALIAS_KEYS[type];
          if (aliases) {
            for (const alias of aliases) {
              add2(alias, obj[type]);
            }
          } else {
            add2(type, obj[type]);
          }
        }
        return map2;
      }
      var expandedParens = expandAliases(parens);
      var expandedWhitespaceNodes = expandAliases(whitespace.nodes);
      function isOrHasCallExpression(node) {
        if (isCallExpression(node)) {
          return true;
        }
        return isMemberExpression(node) && isOrHasCallExpression(node.object);
      }
      function needsWhitespace(node, parent2, type) {
        var _expandedWhitespaceNo;
        if (!node)
          return false;
        if (isExpressionStatement(node)) {
          node = node.expression;
        }
        const flag = (_expandedWhitespaceNo = expandedWhitespaceNodes.get(node.type)) == null ? void 0 : _expandedWhitespaceNo(node, parent2);
        if (typeof flag === "number") {
          return (flag & type) !== 0;
        }
        return false;
      }
      function needsWhitespaceBefore(node, parent2) {
        return needsWhitespace(node, parent2, 1);
      }
      function needsWhitespaceAfter(node, parent2) {
        return needsWhitespace(node, parent2, 2);
      }
      function needsParens(node, parent2, tokenContext, getRawIdentifier) {
        var _expandedParens$get;
        if (!parent2)
          return false;
        if (isNewExpression(parent2) && parent2.callee === node) {
          if (isOrHasCallExpression(node))
            return true;
        }
        if (isDecorator(parent2)) {
          return !isDecoratorMemberExpression(node) && !(isCallExpression(node) && isDecoratorMemberExpression(node.callee)) && !isParenthesizedExpression(node);
        }
        return (_expandedParens$get = expandedParens.get(node.type)) == null ? void 0 : _expandedParens$get(node, parent2, tokenContext, getRawIdentifier);
      }
      function isDecoratorMemberExpression(node) {
        switch (node.type) {
          case "Identifier":
            return true;
          case "MemberExpression":
            return !node.computed && node.property.type === "Identifier" && isDecoratorMemberExpression(node.object);
          default:
            return false;
        }
      }
      function isLastChild(parent2, child) {
        const visitorKeys = VISITOR_KEYS[parent2.type];
        for (let i = visitorKeys.length - 1; i >= 0; i--) {
          const val = parent2[visitorKeys[i]];
          if (val === child) {
            return true;
          } else if (Array.isArray(val)) {
            let j = val.length - 1;
            while (j >= 0 && val[j] === null)
              j--;
            return j >= 0 && val[j] === child;
          } else if (val) {
            return false;
          }
        }
        return false;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/token-map.js
  var require_token_map = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/token-map.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.TokenMap = void 0;
      var _t = require_lib5();
      var {
        traverseFast,
        VISITOR_KEYS
      } = _t;
      var TokenMap = class {
        constructor(ast, tokens, source) {
          this._tokens = void 0;
          this._source = void 0;
          this._nodesToTokenIndexes = /* @__PURE__ */ new Map();
          this._nodesOccurrencesCountCache = /* @__PURE__ */ new Map();
          this._tokensCache = /* @__PURE__ */ new Map();
          this._tokens = tokens;
          this._source = source;
          traverseFast(ast, (node) => {
            const indexes = this._getTokensIndexesOfNode(node);
            if (indexes.length > 0)
              this._nodesToTokenIndexes.set(node, indexes);
          });
          this._tokensCache = null;
        }
        has(node) {
          return this._nodesToTokenIndexes.has(node);
        }
        getIndexes(node) {
          return this._nodesToTokenIndexes.get(node);
        }
        find(node, condition) {
          const indexes = this._nodesToTokenIndexes.get(node);
          if (indexes) {
            for (let k = 0; k < indexes.length; k++) {
              const index = indexes[k];
              const tok = this._tokens[index];
              if (condition(tok, index))
                return tok;
            }
          }
          return null;
        }
        findLastIndex(node, condition) {
          const indexes = this._nodesToTokenIndexes.get(node);
          if (indexes) {
            for (let k = indexes.length - 1; k >= 0; k--) {
              const index = indexes[k];
              const tok = this._tokens[index];
              if (condition(tok, index))
                return index;
            }
          }
          return -1;
        }
        findMatching(node, test, occurrenceCount = 0) {
          const indexes = this._nodesToTokenIndexes.get(node);
          if (indexes) {
            let i = 0;
            const count = occurrenceCount;
            if (count > 1) {
              const cache = this._nodesOccurrencesCountCache.get(node);
              if (cache && cache.test === test && cache.count < count) {
                i = cache.i + 1;
                occurrenceCount -= cache.count + 1;
              }
            }
            for (; i < indexes.length; i++) {
              const tok = this._tokens[indexes[i]];
              if (this.matchesOriginal(tok, test)) {
                if (occurrenceCount === 0) {
                  if (count > 0) {
                    this._nodesOccurrencesCountCache.set(node, {
                      test,
                      count,
                      i
                    });
                  }
                  return tok;
                }
                occurrenceCount--;
              }
            }
          }
          return null;
        }
        matchesOriginal(token, test) {
          if (token.end - token.start !== test.length)
            return false;
          if (token.value != null)
            return token.value === test;
          return this._source.startsWith(test, token.start);
        }
        startMatches(node, test) {
          const indexes = this._nodesToTokenIndexes.get(node);
          if (!indexes)
            return false;
          const tok = this._tokens[indexes[0]];
          if (tok.start !== node.start)
            return false;
          return this.matchesOriginal(tok, test);
        }
        endMatches(node, test) {
          const indexes = this._nodesToTokenIndexes.get(node);
          if (!indexes)
            return false;
          const tok = this._tokens[indexes[indexes.length - 1]];
          if (tok.end !== node.end)
            return false;
          return this.matchesOriginal(tok, test);
        }
        _getTokensIndexesOfNode(node) {
          if (node.start == null || node.end == null)
            return [];
          const {
            first,
            last: last2
          } = this._findTokensOfNode(node, 0, this._tokens.length - 1);
          let low = first;
          const children = childrenIterator(node);
          if ((node.type === "ExportNamedDeclaration" || node.type === "ExportDefaultDeclaration") && node.declaration && node.declaration.type === "ClassDeclaration") {
            children.next();
          }
          const indexes = [];
          for (const child of children) {
            if (child == null)
              continue;
            if (child.start == null || child.end == null)
              continue;
            const childTok = this._findTokensOfNode(child, low, last2);
            const high = childTok.first;
            for (let k = low; k < high; k++)
              indexes.push(k);
            low = childTok.last + 1;
          }
          for (let k = low; k <= last2; k++)
            indexes.push(k);
          return indexes;
        }
        _findTokensOfNode(node, low, high) {
          const cached = this._tokensCache.get(node);
          if (cached)
            return cached;
          const first = this._findFirstTokenOfNode(node.start, low, high);
          const last2 = this._findLastTokenOfNode(node.end, first, high);
          this._tokensCache.set(node, {
            first,
            last: last2
          });
          return {
            first,
            last: last2
          };
        }
        _findFirstTokenOfNode(start, low, high) {
          while (low <= high) {
            const mid = high + low >> 1;
            if (start < this._tokens[mid].start) {
              high = mid - 1;
            } else if (start > this._tokens[mid].start) {
              low = mid + 1;
            } else {
              return mid;
            }
          }
          return low;
        }
        _findLastTokenOfNode(end, low, high) {
          while (low <= high) {
            const mid = high + low >> 1;
            if (end < this._tokens[mid].end) {
              high = mid - 1;
            } else if (end > this._tokens[mid].end) {
              low = mid + 1;
            } else {
              return mid;
            }
          }
          return high;
        }
      };
      exports8.TokenMap = TokenMap;
      function* childrenIterator(node) {
        if (node.type === "TemplateLiteral") {
          yield node.quasis[0];
          for (let i = 1; i < node.quasis.length; i++) {
            yield node.expressions[i - 1];
            yield node.quasis[i];
          }
          return;
        }
        const keys2 = VISITOR_KEYS[node.type];
        for (const key of keys2) {
          const child = node[key];
          if (!child)
            continue;
          if (Array.isArray(child)) {
            yield* child;
          } else {
            yield child;
          }
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/template-literals.js
  var require_template_literals = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/template-literals.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.TaggedTemplateExpression = TaggedTemplateExpression;
      exports8.TemplateElement = TemplateElement;
      exports8.TemplateLiteral = TemplateLiteral;
      exports8._printTemplate = _printTemplate;
      function TaggedTemplateExpression(node) {
        this.print(node.tag);
        {
          this.print(node.typeParameters);
        }
        this.print(node.quasi);
      }
      function TemplateElement() {
        throw new Error("TemplateElement printing is handled in TemplateLiteral");
      }
      function _printTemplate(node, substitutions) {
        const quasis = node.quasis;
        let partRaw = "`";
        for (let i = 0; i < quasis.length - 1; i++) {
          partRaw += quasis[i].value.raw;
          this.token(partRaw + "${", true);
          this.print(substitutions[i]);
          partRaw = "}";
          if (this.tokenMap) {
            const token = this.tokenMap.findMatching(node, "}", i);
            if (token)
              this._catchUpTo(token.loc.start);
          }
        }
        partRaw += quasis[quasis.length - 1].value.raw;
        this.token(partRaw + "`", true);
      }
      function TemplateLiteral(node) {
        this._printTemplate(node, node.expressions);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/expressions.js
  var require_expressions = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/expressions.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.LogicalExpression = exports8.BinaryExpression = exports8.AssignmentExpression = AssignmentExpression;
      exports8.AssignmentPattern = AssignmentPattern;
      exports8.AwaitExpression = AwaitExpression;
      exports8.BindExpression = BindExpression;
      exports8.CallExpression = CallExpression;
      exports8.ConditionalExpression = ConditionalExpression;
      exports8.Decorator = Decorator;
      exports8.DoExpression = DoExpression;
      exports8.EmptyStatement = EmptyStatement;
      exports8.ExpressionStatement = ExpressionStatement;
      exports8.Import = Import;
      exports8.MemberExpression = MemberExpression;
      exports8.MetaProperty = MetaProperty;
      exports8.ModuleExpression = ModuleExpression;
      exports8.NewExpression = NewExpression;
      exports8.OptionalCallExpression = OptionalCallExpression;
      exports8.OptionalMemberExpression = OptionalMemberExpression;
      exports8.ParenthesizedExpression = ParenthesizedExpression;
      exports8.PrivateName = PrivateName;
      exports8.SequenceExpression = SequenceExpression;
      exports8.Super = Super;
      exports8.ThisExpression = ThisExpression;
      exports8.UnaryExpression = UnaryExpression;
      exports8.UpdateExpression = UpdateExpression;
      exports8.V8IntrinsicIdentifier = V8IntrinsicIdentifier;
      exports8.YieldExpression = YieldExpression;
      exports8._shouldPrintDecoratorsBeforeExport = _shouldPrintDecoratorsBeforeExport;
      var _t = require_lib5();
      var _index = require_node();
      var {
        isCallExpression,
        isLiteral,
        isMemberExpression,
        isNewExpression,
        isPattern
      } = _t;
      function UnaryExpression(node) {
        const {
          operator
        } = node;
        if (operator === "void" || operator === "delete" || operator === "typeof" || operator === "throw") {
          this.word(operator);
          this.space();
        } else {
          this.token(operator);
        }
        this.print(node.argument);
      }
      function DoExpression(node) {
        if (node.async) {
          this.word("async", true);
          this.space();
        }
        this.word("do");
        this.space();
        this.print(node.body);
      }
      function ParenthesizedExpression(node) {
        this.tokenChar(40);
        const exit3 = this.enterDelimited();
        this.print(node.expression);
        exit3();
        this.rightParens(node);
      }
      function UpdateExpression(node) {
        if (node.prefix) {
          this.token(node.operator);
          this.print(node.argument);
        } else {
          this.print(node.argument, true);
          this.token(node.operator);
        }
      }
      function ConditionalExpression(node) {
        this.print(node.test);
        this.space();
        this.tokenChar(63);
        this.space();
        this.print(node.consequent);
        this.space();
        this.tokenChar(58);
        this.space();
        this.print(node.alternate);
      }
      function NewExpression(node, parent2) {
        this.word("new");
        this.space();
        this.print(node.callee);
        if (this.format.minified && node.arguments.length === 0 && !node.optional && !isCallExpression(parent2, {
          callee: node
        }) && !isMemberExpression(parent2) && !isNewExpression(parent2)) {
          return;
        }
        this.print(node.typeArguments);
        {
          this.print(node.typeParameters);
          if (node.optional) {
            this.token("?.");
          }
        }
        if (node.arguments.length === 0 && this.tokenMap && !this.tokenMap.endMatches(node, ")")) {
          return;
        }
        this.tokenChar(40);
        const exit3 = this.enterDelimited();
        this.printList(node.arguments, this.shouldPrintTrailingComma(")"));
        exit3();
        this.rightParens(node);
      }
      function SequenceExpression(node) {
        this.printList(node.expressions);
      }
      function ThisExpression() {
        this.word("this");
      }
      function Super() {
        this.word("super");
      }
      function _shouldPrintDecoratorsBeforeExport(node) {
        if (typeof this.format.decoratorsBeforeExport === "boolean") {
          return this.format.decoratorsBeforeExport;
        }
        return typeof node.start === "number" && node.start === node.declaration.start;
      }
      function Decorator(node) {
        this.tokenChar(64);
        this.print(node.expression);
        this.newline();
      }
      function OptionalMemberExpression(node) {
        let {
          computed
        } = node;
        const {
          optional,
          property: property2
        } = node;
        this.print(node.object);
        if (!computed && isMemberExpression(property2)) {
          throw new TypeError("Got a MemberExpression for MemberExpression property");
        }
        if (isLiteral(property2) && typeof property2.value === "number") {
          computed = true;
        }
        if (optional) {
          this.token("?.");
        }
        if (computed) {
          this.tokenChar(91);
          this.print(property2);
          this.tokenChar(93);
        } else {
          if (!optional) {
            this.tokenChar(46);
          }
          this.print(property2);
        }
      }
      function OptionalCallExpression(node) {
        this.print(node.callee);
        {
          this.print(node.typeParameters);
        }
        if (node.optional) {
          this.token("?.");
        }
        this.print(node.typeArguments);
        this.tokenChar(40);
        const exit3 = this.enterDelimited();
        this.printList(node.arguments);
        exit3();
        this.rightParens(node);
      }
      function CallExpression(node) {
        this.print(node.callee);
        this.print(node.typeArguments);
        {
          this.print(node.typeParameters);
        }
        this.tokenChar(40);
        const exit3 = this.enterDelimited();
        this.printList(node.arguments, this.shouldPrintTrailingComma(")"));
        exit3();
        this.rightParens(node);
      }
      function Import() {
        this.word("import");
      }
      function AwaitExpression(node) {
        this.word("await");
        this.space();
        this.print(node.argument);
      }
      function YieldExpression(node) {
        if (node.delegate) {
          this.word("yield", true);
          this.tokenChar(42);
          if (node.argument) {
            this.space();
            this.print(node.argument);
          }
        } else if (node.argument) {
          this.word("yield", true);
          this.space();
          this.print(node.argument);
        } else {
          this.word("yield");
        }
      }
      function EmptyStatement() {
        this.semicolon(true);
      }
      function ExpressionStatement(node) {
        this.tokenContext |= _index.TokenContext.expressionStatement;
        this.print(node.expression);
        this.semicolon();
      }
      function AssignmentPattern(node) {
        this.print(node.left);
        if (node.left.type === "Identifier" || isPattern(node.left)) {
          if (node.left.optional)
            this.tokenChar(63);
          this.print(node.left.typeAnnotation);
        }
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.right);
      }
      function AssignmentExpression(node) {
        this.print(node.left);
        this.space();
        if (node.operator === "in" || node.operator === "instanceof") {
          this.word(node.operator);
        } else {
          this.token(node.operator);
          this._endsWithDiv = node.operator === "/";
        }
        this.space();
        this.print(node.right);
      }
      function BindExpression(node) {
        this.print(node.object);
        this.token("::");
        this.print(node.callee);
      }
      function MemberExpression(node) {
        this.print(node.object);
        if (!node.computed && isMemberExpression(node.property)) {
          throw new TypeError("Got a MemberExpression for MemberExpression property");
        }
        let computed = node.computed;
        if (isLiteral(node.property) && typeof node.property.value === "number") {
          computed = true;
        }
        if (computed) {
          const exit3 = this.enterDelimited();
          this.tokenChar(91);
          this.print(node.property);
          this.tokenChar(93);
          exit3();
        } else {
          this.tokenChar(46);
          this.print(node.property);
        }
      }
      function MetaProperty(node) {
        this.print(node.meta);
        this.tokenChar(46);
        this.print(node.property);
      }
      function PrivateName(node) {
        this.tokenChar(35);
        this.print(node.id);
      }
      function V8IntrinsicIdentifier(node) {
        this.tokenChar(37);
        this.word(node.name);
      }
      function ModuleExpression(node) {
        this.word("module", true);
        this.space();
        this.tokenChar(123);
        this.indent();
        const {
          body
        } = node;
        if (body.body.length || body.directives.length) {
          this.newline();
        }
        this.print(body);
        this.dedent();
        this.rightBrace(node);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/statements.js
  var require_statements = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/statements.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.BreakStatement = BreakStatement;
      exports8.CatchClause = CatchClause;
      exports8.ContinueStatement = ContinueStatement;
      exports8.DebuggerStatement = DebuggerStatement;
      exports8.DoWhileStatement = DoWhileStatement;
      exports8.ForOfStatement = exports8.ForInStatement = void 0;
      exports8.ForStatement = ForStatement;
      exports8.IfStatement = IfStatement;
      exports8.LabeledStatement = LabeledStatement;
      exports8.ReturnStatement = ReturnStatement;
      exports8.SwitchCase = SwitchCase;
      exports8.SwitchStatement = SwitchStatement;
      exports8.ThrowStatement = ThrowStatement;
      exports8.TryStatement = TryStatement;
      exports8.VariableDeclaration = VariableDeclaration;
      exports8.VariableDeclarator = VariableDeclarator;
      exports8.WhileStatement = WhileStatement;
      exports8.WithStatement = WithStatement;
      var _t = require_lib5();
      var {
        isFor,
        isForStatement,
        isIfStatement,
        isStatement
      } = _t;
      function WithStatement(node) {
        this.word("with");
        this.space();
        this.tokenChar(40);
        this.print(node.object);
        this.tokenChar(41);
        this.printBlock(node);
      }
      function IfStatement(node) {
        this.word("if");
        this.space();
        this.tokenChar(40);
        this.print(node.test);
        this.tokenChar(41);
        this.space();
        const needsBlock = node.alternate && isIfStatement(getLastStatement(node.consequent));
        if (needsBlock) {
          this.tokenChar(123);
          this.newline();
          this.indent();
        }
        this.printAndIndentOnComments(node.consequent);
        if (needsBlock) {
          this.dedent();
          this.newline();
          this.tokenChar(125);
        }
        if (node.alternate) {
          if (this.endsWith(125))
            this.space();
          this.word("else");
          this.space();
          this.printAndIndentOnComments(node.alternate);
        }
      }
      function getLastStatement(statement) {
        const {
          body
        } = statement;
        if (isStatement(body) === false) {
          return statement;
        }
        return getLastStatement(body);
      }
      function ForStatement(node) {
        this.word("for");
        this.space();
        this.tokenChar(40);
        {
          const exit3 = this.enterForStatementInit();
          this.print(node.init);
          exit3();
        }
        this.tokenChar(59);
        if (node.test) {
          this.space();
          this.print(node.test);
        }
        this.token(";", false, 1);
        if (node.update) {
          this.space();
          this.print(node.update);
        }
        this.tokenChar(41);
        this.printBlock(node);
      }
      function WhileStatement(node) {
        this.word("while");
        this.space();
        this.tokenChar(40);
        this.print(node.test);
        this.tokenChar(41);
        this.printBlock(node);
      }
      function ForXStatement(node) {
        this.word("for");
        this.space();
        const isForOf = node.type === "ForOfStatement";
        if (isForOf && node.await) {
          this.word("await");
          this.space();
        }
        this.noIndentInnerCommentsHere();
        this.tokenChar(40);
        {
          const exit3 = this.enterForXStatementInit(isForOf);
          this.print(node.left);
          exit3 == null || exit3();
        }
        this.space();
        this.word(isForOf ? "of" : "in");
        this.space();
        this.print(node.right);
        this.tokenChar(41);
        this.printBlock(node);
      }
      var ForInStatement = exports8.ForInStatement = ForXStatement;
      var ForOfStatement = exports8.ForOfStatement = ForXStatement;
      function DoWhileStatement(node) {
        this.word("do");
        this.space();
        this.print(node.body);
        this.space();
        this.word("while");
        this.space();
        this.tokenChar(40);
        this.print(node.test);
        this.tokenChar(41);
        this.semicolon();
      }
      function printStatementAfterKeyword(printer, node) {
        if (node) {
          printer.space();
          printer.printTerminatorless(node);
        }
        printer.semicolon();
      }
      function BreakStatement(node) {
        this.word("break");
        printStatementAfterKeyword(this, node.label);
      }
      function ContinueStatement(node) {
        this.word("continue");
        printStatementAfterKeyword(this, node.label);
      }
      function ReturnStatement(node) {
        this.word("return");
        printStatementAfterKeyword(this, node.argument);
      }
      function ThrowStatement(node) {
        this.word("throw");
        printStatementAfterKeyword(this, node.argument);
      }
      function LabeledStatement(node) {
        this.print(node.label);
        this.tokenChar(58);
        this.space();
        this.print(node.body);
      }
      function TryStatement(node) {
        this.word("try");
        this.space();
        this.print(node.block);
        this.space();
        if (node.handlers) {
          this.print(node.handlers[0]);
        } else {
          this.print(node.handler);
        }
        if (node.finalizer) {
          this.space();
          this.word("finally");
          this.space();
          this.print(node.finalizer);
        }
      }
      function CatchClause(node) {
        this.word("catch");
        this.space();
        if (node.param) {
          this.tokenChar(40);
          this.print(node.param);
          this.print(node.param.typeAnnotation);
          this.tokenChar(41);
          this.space();
        }
        this.print(node.body);
      }
      function SwitchStatement(node) {
        this.word("switch");
        this.space();
        this.tokenChar(40);
        this.print(node.discriminant);
        this.tokenChar(41);
        this.space();
        this.tokenChar(123);
        this.printSequence(node.cases, true, void 0, function addNewlines(leading, cas) {
          if (!leading && node.cases[node.cases.length - 1] === cas)
            return -1;
        });
        this.rightBrace(node);
      }
      function SwitchCase(node) {
        if (node.test) {
          this.word("case");
          this.space();
          this.print(node.test);
          this.tokenChar(58);
        } else {
          this.word("default");
          this.tokenChar(58);
        }
        if (node.consequent.length) {
          this.newline();
          this.printSequence(node.consequent, true);
        }
      }
      function DebuggerStatement() {
        this.word("debugger");
        this.semicolon();
      }
      function VariableDeclaration(node, parent2) {
        if (node.declare) {
          this.word("declare");
          this.space();
        }
        const {
          kind
        } = node;
        if (kind === "await using") {
          this.word("await");
          this.space();
          this.word("using", true);
        } else {
          this.word(kind, kind === "using");
        }
        this.space();
        let hasInits = false;
        if (!isFor(parent2)) {
          for (const declar of node.declarations) {
            if (declar.init) {
              hasInits = true;
            }
          }
        }
        this.printList(node.declarations, void 0, void 0, node.declarations.length > 1, hasInits ? function(occurrenceCount) {
          this.token(",", false, occurrenceCount);
          this.newline();
        } : void 0);
        if (isFor(parent2)) {
          if (isForStatement(parent2)) {
            if (parent2.init === node)
              return;
          } else {
            if (parent2.left === node)
              return;
          }
        }
        this.semicolon();
      }
      function VariableDeclarator(node) {
        this.print(node.id);
        if (node.definite)
          this.tokenChar(33);
        this.print(node.id.typeAnnotation);
        if (node.init) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.init);
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/classes.js
  var require_classes = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/classes.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.ClassAccessorProperty = ClassAccessorProperty;
      exports8.ClassBody = ClassBody;
      exports8.ClassExpression = exports8.ClassDeclaration = ClassDeclaration;
      exports8.ClassMethod = ClassMethod;
      exports8.ClassPrivateMethod = ClassPrivateMethod;
      exports8.ClassPrivateProperty = ClassPrivateProperty;
      exports8.ClassProperty = ClassProperty;
      exports8.StaticBlock = StaticBlock;
      exports8._classMethodHead = _classMethodHead;
      var _t = require_lib5();
      var {
        isExportDefaultDeclaration,
        isExportNamedDeclaration
      } = _t;
      function ClassDeclaration(node, parent2) {
        const inExport = isExportDefaultDeclaration(parent2) || isExportNamedDeclaration(parent2);
        if (!inExport || !this._shouldPrintDecoratorsBeforeExport(parent2)) {
          this.printJoin(node.decorators);
        }
        if (node.declare) {
          this.word("declare");
          this.space();
        }
        if (node.abstract) {
          this.word("abstract");
          this.space();
        }
        this.word("class");
        if (node.id) {
          this.space();
          this.print(node.id);
        }
        this.print(node.typeParameters);
        if (node.superClass) {
          this.space();
          this.word("extends");
          this.space();
          this.print(node.superClass);
          this.print(node.superTypeParameters);
        }
        if (node.implements) {
          this.space();
          this.word("implements");
          this.space();
          this.printList(node.implements);
        }
        this.space();
        this.print(node.body);
      }
      function ClassBody(node) {
        this.tokenChar(123);
        if (node.body.length === 0) {
          this.tokenChar(125);
        } else {
          this.newline();
          const separator = classBodyEmptySemicolonsPrinter(this, node);
          separator == null || separator(-1);
          const exit3 = this.enterDelimited();
          this.printJoin(node.body, true, true, separator, true);
          exit3();
          if (!this.endsWith(10))
            this.newline();
          this.rightBrace(node);
        }
      }
      function classBodyEmptySemicolonsPrinter(printer, node) {
        if (!printer.tokenMap || node.start == null || node.end == null) {
          return null;
        }
        const indexes = printer.tokenMap.getIndexes(node);
        if (!indexes)
          return null;
        let k = 1;
        let occurrenceCount = 0;
        let nextLocIndex = 0;
        const advanceNextLocIndex = () => {
          while (nextLocIndex < node.body.length && node.body[nextLocIndex].start == null) {
            nextLocIndex++;
          }
        };
        advanceNextLocIndex();
        return (i) => {
          if (nextLocIndex <= i) {
            nextLocIndex = i + 1;
            advanceNextLocIndex();
          }
          const end = nextLocIndex === node.body.length ? node.end : node.body[nextLocIndex].start;
          let tok;
          while (k < indexes.length && printer.tokenMap.matchesOriginal(tok = printer._tokens[indexes[k]], ";") && tok.start < end) {
            printer.token(";", void 0, occurrenceCount++);
            k++;
          }
        };
      }
      function ClassProperty(node) {
        this.printJoin(node.decorators);
        if (!node.static && !this.format.preserveFormat) {
          var _node$key$loc;
          const endLine = (_node$key$loc = node.key.loc) == null || (_node$key$loc = _node$key$loc.end) == null ? void 0 : _node$key$loc.line;
          if (endLine)
            this.catchUp(endLine);
        }
        this.tsPrintClassMemberModifiers(node);
        if (node.computed) {
          this.tokenChar(91);
          this.print(node.key);
          this.tokenChar(93);
        } else {
          this._variance(node);
          this.print(node.key);
        }
        if (node.optional) {
          this.tokenChar(63);
        }
        if (node.definite) {
          this.tokenChar(33);
        }
        this.print(node.typeAnnotation);
        if (node.value) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.value);
        }
        this.semicolon();
      }
      function ClassAccessorProperty(node) {
        var _node$key$loc2;
        this.printJoin(node.decorators);
        const endLine = (_node$key$loc2 = node.key.loc) == null || (_node$key$loc2 = _node$key$loc2.end) == null ? void 0 : _node$key$loc2.line;
        if (endLine)
          this.catchUp(endLine);
        this.tsPrintClassMemberModifiers(node);
        this.word("accessor", true);
        this.space();
        if (node.computed) {
          this.tokenChar(91);
          this.print(node.key);
          this.tokenChar(93);
        } else {
          this._variance(node);
          this.print(node.key);
        }
        if (node.optional) {
          this.tokenChar(63);
        }
        if (node.definite) {
          this.tokenChar(33);
        }
        this.print(node.typeAnnotation);
        if (node.value) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.value);
        }
        this.semicolon();
      }
      function ClassPrivateProperty(node) {
        this.printJoin(node.decorators);
        this.tsPrintClassMemberModifiers(node);
        this.print(node.key);
        if (node.optional) {
          this.tokenChar(63);
        }
        if (node.definite) {
          this.tokenChar(33);
        }
        this.print(node.typeAnnotation);
        if (node.value) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.value);
        }
        this.semicolon();
      }
      function ClassMethod(node) {
        this._classMethodHead(node);
        this.space();
        this.print(node.body);
      }
      function ClassPrivateMethod(node) {
        this._classMethodHead(node);
        this.space();
        this.print(node.body);
      }
      function _classMethodHead(node) {
        this.printJoin(node.decorators);
        if (!this.format.preserveFormat) {
          var _node$key$loc3;
          const endLine = (_node$key$loc3 = node.key.loc) == null || (_node$key$loc3 = _node$key$loc3.end) == null ? void 0 : _node$key$loc3.line;
          if (endLine)
            this.catchUp(endLine);
        }
        this.tsPrintClassMemberModifiers(node);
        this._methodHead(node);
      }
      function StaticBlock(node) {
        this.word("static");
        this.space();
        this.tokenChar(123);
        if (node.body.length === 0) {
          this.tokenChar(125);
        } else {
          this.newline();
          this.printSequence(node.body, true);
          this.rightBrace(node);
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/methods.js
  var require_methods = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/methods.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.ArrowFunctionExpression = ArrowFunctionExpression;
      exports8.FunctionDeclaration = exports8.FunctionExpression = FunctionExpression;
      exports8._functionHead = _functionHead;
      exports8._methodHead = _methodHead;
      exports8._param = _param;
      exports8._parameters = _parameters;
      exports8._params = _params;
      exports8._predicate = _predicate;
      exports8._shouldPrintArrowParamsParens = _shouldPrintArrowParamsParens;
      var _t = require_lib5();
      var _index = require_node();
      var {
        isIdentifier: isIdentifier2
      } = _t;
      function _params(node, idNode, parentNode) {
        this.print(node.typeParameters);
        const nameInfo = _getFuncIdName.call(this, idNode, parentNode);
        if (nameInfo) {
          this.sourceIdentifierName(nameInfo.name, nameInfo.pos);
        }
        this.tokenChar(40);
        this._parameters(node.params, ")");
        const noLineTerminator = node.type === "ArrowFunctionExpression";
        this.print(node.returnType, noLineTerminator);
        this._noLineTerminator = noLineTerminator;
      }
      function _parameters(parameters, endToken) {
        const exit3 = this.enterDelimited();
        const trailingComma = this.shouldPrintTrailingComma(endToken);
        const paramLength = parameters.length;
        for (let i = 0; i < paramLength; i++) {
          this._param(parameters[i]);
          if (trailingComma || i < paramLength - 1) {
            this.token(",", null, i);
            this.space();
          }
        }
        this.token(endToken);
        exit3();
      }
      function _param(parameter) {
        this.printJoin(parameter.decorators);
        this.print(parameter);
        if (parameter.optional) {
          this.tokenChar(63);
        }
        this.print(parameter.typeAnnotation);
      }
      function _methodHead(node) {
        const kind = node.kind;
        const key = node.key;
        if (kind === "get" || kind === "set") {
          this.word(kind);
          this.space();
        }
        if (node.async) {
          this.word("async", true);
          this.space();
        }
        if (kind === "method" || kind === "init") {
          if (node.generator) {
            this.tokenChar(42);
          }
        }
        if (node.computed) {
          this.tokenChar(91);
          this.print(key);
          this.tokenChar(93);
        } else {
          this.print(key);
        }
        if (node.optional) {
          this.tokenChar(63);
        }
        this._params(node, node.computed && node.key.type !== "StringLiteral" ? void 0 : node.key, void 0);
      }
      function _predicate(node, noLineTerminatorAfter) {
        if (node.predicate) {
          if (!node.returnType) {
            this.tokenChar(58);
          }
          this.space();
          this.print(node.predicate, noLineTerminatorAfter);
        }
      }
      function _functionHead(node, parent2) {
        if (node.async) {
          this.word("async");
          if (!this.format.preserveFormat) {
            this._endsWithInnerRaw = false;
          }
          this.space();
        }
        this.word("function");
        if (node.generator) {
          if (!this.format.preserveFormat) {
            this._endsWithInnerRaw = false;
          }
          this.tokenChar(42);
        }
        this.space();
        if (node.id) {
          this.print(node.id);
        }
        this._params(node, node.id, parent2);
        if (node.type !== "TSDeclareFunction") {
          this._predicate(node);
        }
      }
      function FunctionExpression(node, parent2) {
        this._functionHead(node, parent2);
        this.space();
        this.print(node.body);
      }
      function ArrowFunctionExpression(node, parent2) {
        if (node.async) {
          this.word("async", true);
          this.space();
        }
        if (this._shouldPrintArrowParamsParens(node)) {
          this._params(node, void 0, parent2);
        } else {
          this.print(node.params[0], true);
        }
        this._predicate(node, true);
        this.space();
        this.printInnerComments();
        this.token("=>");
        this.space();
        this.tokenContext |= _index.TokenContext.arrowBody;
        this.print(node.body);
      }
      function _shouldPrintArrowParamsParens(node) {
        var _firstParam$leadingCo, _firstParam$trailingC;
        if (node.params.length !== 1)
          return true;
        if (node.typeParameters || node.returnType || node.predicate) {
          return true;
        }
        const firstParam = node.params[0];
        if (!isIdentifier2(firstParam) || firstParam.typeAnnotation || firstParam.optional || (_firstParam$leadingCo = firstParam.leadingComments) != null && _firstParam$leadingCo.length || (_firstParam$trailingC = firstParam.trailingComments) != null && _firstParam$trailingC.length) {
          return true;
        }
        if (this.tokenMap) {
          if (node.loc == null)
            return true;
          if (this.tokenMap.findMatching(node, "(") !== null)
            return true;
          const arrowToken = this.tokenMap.findMatching(node, "=>");
          if ((arrowToken == null ? void 0 : arrowToken.loc) == null)
            return true;
          return arrowToken.loc.start.line !== node.loc.start.line;
        }
        if (this.format.retainLines)
          return true;
        return false;
      }
      function _getFuncIdName(idNode, parent2) {
        let id = idNode;
        if (!id && parent2) {
          const parentType = parent2.type;
          if (parentType === "VariableDeclarator") {
            id = parent2.id;
          } else if (parentType === "AssignmentExpression" || parentType === "AssignmentPattern") {
            id = parent2.left;
          } else if (parentType === "ObjectProperty" || parentType === "ClassProperty") {
            if (!parent2.computed || parent2.key.type === "StringLiteral") {
              id = parent2.key;
            }
          } else if (parentType === "ClassPrivateProperty" || parentType === "ClassAccessorProperty") {
            id = parent2.key;
          }
        }
        if (!id)
          return;
        let nameInfo;
        if (id.type === "Identifier") {
          var _id$loc, _id$loc2;
          nameInfo = {
            pos: (_id$loc = id.loc) == null ? void 0 : _id$loc.start,
            name: ((_id$loc2 = id.loc) == null ? void 0 : _id$loc2.identifierName) || id.name
          };
        } else if (id.type === "PrivateName") {
          var _id$loc3;
          nameInfo = {
            pos: (_id$loc3 = id.loc) == null ? void 0 : _id$loc3.start,
            name: "#" + id.id.name
          };
        } else if (id.type === "StringLiteral") {
          var _id$loc4;
          nameInfo = {
            pos: (_id$loc4 = id.loc) == null ? void 0 : _id$loc4.start,
            name: id.value
          };
        }
        return nameInfo;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/modules.js
  var require_modules = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/modules.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.ExportAllDeclaration = ExportAllDeclaration;
      exports8.ExportDefaultDeclaration = ExportDefaultDeclaration;
      exports8.ExportDefaultSpecifier = ExportDefaultSpecifier;
      exports8.ExportNamedDeclaration = ExportNamedDeclaration;
      exports8.ExportNamespaceSpecifier = ExportNamespaceSpecifier;
      exports8.ExportSpecifier = ExportSpecifier;
      exports8.ImportAttribute = ImportAttribute;
      exports8.ImportDeclaration = ImportDeclaration;
      exports8.ImportDefaultSpecifier = ImportDefaultSpecifier;
      exports8.ImportExpression = ImportExpression;
      exports8.ImportNamespaceSpecifier = ImportNamespaceSpecifier;
      exports8.ImportSpecifier = ImportSpecifier;
      exports8._printAttributes = _printAttributes;
      var _t = require_lib5();
      var _index = require_node();
      var {
        isClassDeclaration,
        isExportDefaultSpecifier,
        isExportNamespaceSpecifier,
        isImportDefaultSpecifier,
        isImportNamespaceSpecifier,
        isStatement
      } = _t;
      function ImportSpecifier(node) {
        if (node.importKind === "type" || node.importKind === "typeof") {
          this.word(node.importKind);
          this.space();
        }
        this.print(node.imported);
        if (node.local && node.local.name !== node.imported.name) {
          this.space();
          this.word("as");
          this.space();
          this.print(node.local);
        }
      }
      function ImportDefaultSpecifier(node) {
        this.print(node.local);
      }
      function ExportDefaultSpecifier(node) {
        this.print(node.exported);
      }
      function ExportSpecifier(node) {
        if (node.exportKind === "type") {
          this.word("type");
          this.space();
        }
        this.print(node.local);
        if (node.exported && node.local.name !== node.exported.name) {
          this.space();
          this.word("as");
          this.space();
          this.print(node.exported);
        }
      }
      function ExportNamespaceSpecifier(node) {
        this.tokenChar(42);
        this.space();
        this.word("as");
        this.space();
        this.print(node.exported);
      }
      var warningShown = false;
      function _printAttributes(node, hasPreviousBrace) {
        var _node$extra;
        const {
          importAttributesKeyword
        } = this.format;
        const {
          attributes,
          assertions
        } = node;
        if (attributes && !importAttributesKeyword && node.extra && (node.extra.deprecatedAssertSyntax || node.extra.deprecatedWithLegacySyntax) && !warningShown) {
          warningShown = true;
          console.warn(`You are using import attributes, without specifying the desired output syntax.
Please specify the "importAttributesKeyword" generator option, whose value can be one of:
 - "with"        : \`import { a } from "b" with { type: "json" };\`
 - "assert"      : \`import { a } from "b" assert { type: "json" };\`
 - "with-legacy" : \`import { a } from "b" with type: "json";\`
`);
        }
        const useAssertKeyword = importAttributesKeyword === "assert" || !importAttributesKeyword && assertions;
        this.word(useAssertKeyword ? "assert" : "with");
        this.space();
        if (!useAssertKeyword && (importAttributesKeyword === "with-legacy" || !importAttributesKeyword && (_node$extra = node.extra) != null && _node$extra.deprecatedWithLegacySyntax)) {
          this.printList(attributes || assertions);
          return;
        }
        const occurrenceCount = hasPreviousBrace ? 1 : 0;
        this.token("{", null, occurrenceCount);
        this.space();
        this.printList(attributes || assertions, this.shouldPrintTrailingComma("}"));
        this.space();
        this.token("}", null, occurrenceCount);
      }
      function ExportAllDeclaration(node) {
        var _node$attributes, _node$assertions;
        this.word("export");
        this.space();
        if (node.exportKind === "type") {
          this.word("type");
          this.space();
        }
        this.tokenChar(42);
        this.space();
        this.word("from");
        this.space();
        if ((_node$attributes = node.attributes) != null && _node$attributes.length || (_node$assertions = node.assertions) != null && _node$assertions.length) {
          this.print(node.source, true);
          this.space();
          this._printAttributes(node, false);
        } else {
          this.print(node.source);
        }
        this.semicolon();
      }
      function maybePrintDecoratorsBeforeExport(printer, node) {
        if (isClassDeclaration(node.declaration) && printer._shouldPrintDecoratorsBeforeExport(node)) {
          printer.printJoin(node.declaration.decorators);
        }
      }
      function ExportNamedDeclaration(node) {
        maybePrintDecoratorsBeforeExport(this, node);
        this.word("export");
        this.space();
        if (node.declaration) {
          const declar = node.declaration;
          this.print(declar);
          if (!isStatement(declar))
            this.semicolon();
        } else {
          if (node.exportKind === "type") {
            this.word("type");
            this.space();
          }
          const specifiers = node.specifiers.slice(0);
          let hasSpecial = false;
          for (; ; ) {
            const first = specifiers[0];
            if (isExportDefaultSpecifier(first) || isExportNamespaceSpecifier(first)) {
              hasSpecial = true;
              this.print(specifiers.shift());
              if (specifiers.length) {
                this.tokenChar(44);
                this.space();
              }
            } else {
              break;
            }
          }
          let hasBrace = false;
          if (specifiers.length || !specifiers.length && !hasSpecial) {
            hasBrace = true;
            this.tokenChar(123);
            if (specifiers.length) {
              this.space();
              this.printList(specifiers, this.shouldPrintTrailingComma("}"));
              this.space();
            }
            this.tokenChar(125);
          }
          if (node.source) {
            var _node$attributes2, _node$assertions2;
            this.space();
            this.word("from");
            this.space();
            if ((_node$attributes2 = node.attributes) != null && _node$attributes2.length || (_node$assertions2 = node.assertions) != null && _node$assertions2.length) {
              this.print(node.source, true);
              this.space();
              this._printAttributes(node, hasBrace);
            } else {
              this.print(node.source);
            }
          }
          this.semicolon();
        }
      }
      function ExportDefaultDeclaration(node) {
        maybePrintDecoratorsBeforeExport(this, node);
        this.word("export");
        this.noIndentInnerCommentsHere();
        this.space();
        this.word("default");
        this.space();
        this.tokenContext |= _index.TokenContext.exportDefault;
        const declar = node.declaration;
        this.print(declar);
        if (!isStatement(declar))
          this.semicolon();
      }
      function ImportDeclaration(node) {
        var _node$attributes3, _node$assertions3;
        this.word("import");
        this.space();
        const isTypeKind = node.importKind === "type" || node.importKind === "typeof";
        if (isTypeKind) {
          this.noIndentInnerCommentsHere();
          this.word(node.importKind);
          this.space();
        } else if (node.module) {
          this.noIndentInnerCommentsHere();
          this.word("module");
          this.space();
        } else if (node.phase) {
          this.noIndentInnerCommentsHere();
          this.word(node.phase);
          this.space();
        }
        const specifiers = node.specifiers.slice(0);
        const hasSpecifiers = !!specifiers.length;
        while (hasSpecifiers) {
          const first = specifiers[0];
          if (isImportDefaultSpecifier(first) || isImportNamespaceSpecifier(first)) {
            this.print(specifiers.shift());
            if (specifiers.length) {
              this.tokenChar(44);
              this.space();
            }
          } else {
            break;
          }
        }
        let hasBrace = false;
        if (specifiers.length) {
          hasBrace = true;
          this.tokenChar(123);
          this.space();
          this.printList(specifiers, this.shouldPrintTrailingComma("}"));
          this.space();
          this.tokenChar(125);
        } else if (isTypeKind && !hasSpecifiers) {
          hasBrace = true;
          this.tokenChar(123);
          this.tokenChar(125);
        }
        if (hasSpecifiers || isTypeKind) {
          this.space();
          this.word("from");
          this.space();
        }
        if ((_node$attributes3 = node.attributes) != null && _node$attributes3.length || (_node$assertions3 = node.assertions) != null && _node$assertions3.length) {
          this.print(node.source, true);
          this.space();
          this._printAttributes(node, hasBrace);
        } else {
          this.print(node.source);
        }
        this.semicolon();
      }
      function ImportAttribute(node) {
        this.print(node.key);
        this.tokenChar(58);
        this.space();
        this.print(node.value);
      }
      function ImportNamespaceSpecifier(node) {
        this.tokenChar(42);
        this.space();
        this.word("as");
        this.space();
        this.print(node.local);
      }
      function ImportExpression(node) {
        this.word("import");
        if (node.phase) {
          this.tokenChar(46);
          this.word(node.phase);
        }
        this.tokenChar(40);
        const shouldPrintTrailingComma = this.shouldPrintTrailingComma(")");
        this.print(node.source);
        if (node.options != null) {
          this.tokenChar(44);
          this.space();
          this.print(node.options);
        }
        if (shouldPrintTrailingComma) {
          this.tokenChar(44);
        }
        this.rightParens(node);
      }
    }
  });

  // ../../node_modules/.pnpm/jsesc@3.1.0/node_modules/jsesc/jsesc.js
  var require_jsesc = __commonJS({
    "../../node_modules/.pnpm/jsesc@3.1.0/node_modules/jsesc/jsesc.js"(exports8, module2) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var object = {};
      var hasOwnProperty27 = object.hasOwnProperty;
      var forOwn2 = (object2, callback) => {
        for (const key in object2) {
          if (hasOwnProperty27.call(object2, key)) {
            callback(key, object2[key]);
          }
        }
      };
      var extend = (destination, source) => {
        if (!source) {
          return destination;
        }
        forOwn2(source, (key, value) => {
          destination[key] = value;
        });
        return destination;
      };
      var forEach2 = (array, callback) => {
        const length = array.length;
        let index = -1;
        while (++index < length) {
          callback(array[index]);
        }
      };
      var fourHexEscape = (hex) => {
        return "\\u" + ("0000" + hex).slice(-4);
      };
      var hexadecimal = (code, lowercase) => {
        let hexadecimal2 = code.toString(16);
        if (lowercase)
          return hexadecimal2;
        return hexadecimal2.toUpperCase();
      };
      var toString2 = object.toString;
      var isArray3 = Array.isArray;
      var isBuffer3 = (value) => {
        return typeof Buffer2 === "function" && Buffer2.isBuffer(value);
      };
      var isObject5 = (value) => {
        return toString2.call(value) == "[object Object]";
      };
      var isString3 = (value) => {
        return typeof value == "string" || toString2.call(value) == "[object String]";
      };
      var isNumber3 = (value) => {
        return typeof value == "number" || toString2.call(value) == "[object Number]";
      };
      var isBigInt = (value) => {
        return typeof value == "bigint";
      };
      var isFunction3 = (value) => {
        return typeof value == "function";
      };
      var isMap2 = (value) => {
        return toString2.call(value) == "[object Map]";
      };
      var isSet2 = (value) => {
        return toString2.call(value) == "[object Set]";
      };
      var singleEscapes = {
        "\\": "\\\\",
        "\b": "\\b",
        "\f": "\\f",
        "\n": "\\n",
        "\r": "\\r",
        "	": "\\t"
      };
      var regexSingleEscape = /[\\\b\f\n\r\t]/;
      var regexDigit = /[0-9]/;
      var regexWhitespace = /[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;
      var escapeEverythingRegex = /([\uD800-\uDBFF][\uDC00-\uDFFF])|([\uD800-\uDFFF])|(['"`])|[^]/g;
      var escapeNonAsciiRegex = /([\uD800-\uDBFF][\uDC00-\uDFFF])|([\uD800-\uDFFF])|(['"`])|[^ !#-&\(-\[\]-_a-~]/g;
      var jsesc = (argument, options) => {
        const increaseIndentation = () => {
          oldIndent = indent;
          ++options.indentLevel;
          indent = options.indent.repeat(options.indentLevel);
        };
        const defaults2 = {
          "escapeEverything": false,
          "minimal": false,
          "isScriptContext": false,
          "quotes": "single",
          "wrap": false,
          "es6": false,
          "json": false,
          "compact": true,
          "lowercaseHex": false,
          "numbers": "decimal",
          "indent": "	",
          "indentLevel": 0,
          "__inline1__": false,
          "__inline2__": false
        };
        const json = options && options.json;
        if (json) {
          defaults2.quotes = "double";
          defaults2.wrap = true;
        }
        options = extend(defaults2, options);
        if (options.quotes != "single" && options.quotes != "double" && options.quotes != "backtick") {
          options.quotes = "single";
        }
        const quote = options.quotes == "double" ? '"' : options.quotes == "backtick" ? "`" : "'";
        const compact2 = options.compact;
        const lowercaseHex = options.lowercaseHex;
        let indent = options.indent.repeat(options.indentLevel);
        let oldIndent = "";
        const inline1 = options.__inline1__;
        const inline2 = options.__inline2__;
        const newLine = compact2 ? "" : "\n";
        let result2;
        let isEmpty2 = true;
        const useBinNumbers = options.numbers == "binary";
        const useOctNumbers = options.numbers == "octal";
        const useDecNumbers = options.numbers == "decimal";
        const useHexNumbers = options.numbers == "hexadecimal";
        if (json && argument && isFunction3(argument.toJSON)) {
          argument = argument.toJSON();
        }
        if (!isString3(argument)) {
          if (isMap2(argument)) {
            if (argument.size == 0) {
              return "new Map()";
            }
            if (!compact2) {
              options.__inline1__ = true;
              options.__inline2__ = false;
            }
            return "new Map(" + jsesc(Array.from(argument), options) + ")";
          }
          if (isSet2(argument)) {
            if (argument.size == 0) {
              return "new Set()";
            }
            return "new Set(" + jsesc(Array.from(argument), options) + ")";
          }
          if (isBuffer3(argument)) {
            if (argument.length == 0) {
              return "Buffer.from([])";
            }
            return "Buffer.from(" + jsesc(Array.from(argument), options) + ")";
          }
          if (isArray3(argument)) {
            result2 = [];
            options.wrap = true;
            if (inline1) {
              options.__inline1__ = false;
              options.__inline2__ = true;
            }
            if (!inline2) {
              increaseIndentation();
            }
            forEach2(argument, (value) => {
              isEmpty2 = false;
              if (inline2) {
                options.__inline2__ = false;
              }
              result2.push(
                (compact2 || inline2 ? "" : indent) + jsesc(value, options)
              );
            });
            if (isEmpty2) {
              return "[]";
            }
            if (inline2) {
              return "[" + result2.join(", ") + "]";
            }
            return "[" + newLine + result2.join("," + newLine) + newLine + (compact2 ? "" : oldIndent) + "]";
          } else if (isNumber3(argument) || isBigInt(argument)) {
            if (json) {
              return JSON.stringify(Number(argument));
            }
            let result3;
            if (useDecNumbers) {
              result3 = String(argument);
            } else if (useHexNumbers) {
              let hexadecimal2 = argument.toString(16);
              if (!lowercaseHex) {
                hexadecimal2 = hexadecimal2.toUpperCase();
              }
              result3 = "0x" + hexadecimal2;
            } else if (useBinNumbers) {
              result3 = "0b" + argument.toString(2);
            } else if (useOctNumbers) {
              result3 = "0o" + argument.toString(8);
            }
            if (isBigInt(argument)) {
              return result3 + "n";
            }
            return result3;
          } else if (isBigInt(argument)) {
            if (json) {
              return JSON.stringify(Number(argument));
            }
            return argument + "n";
          } else if (!isObject5(argument)) {
            if (json) {
              return JSON.stringify(argument) || "null";
            }
            return String(argument);
          } else {
            result2 = [];
            options.wrap = true;
            increaseIndentation();
            forOwn2(argument, (key, value) => {
              isEmpty2 = false;
              result2.push(
                (compact2 ? "" : indent) + jsesc(key, options) + ":" + (compact2 ? "" : " ") + jsesc(value, options)
              );
            });
            if (isEmpty2) {
              return "{}";
            }
            return "{" + newLine + result2.join("," + newLine) + newLine + (compact2 ? "" : oldIndent) + "}";
          }
        }
        const regex = options.escapeEverything ? escapeEverythingRegex : escapeNonAsciiRegex;
        result2 = argument.replace(regex, (char, pair, lone, quoteChar, index, string) => {
          if (pair) {
            if (options.minimal)
              return pair;
            const first = pair.charCodeAt(0);
            const second = pair.charCodeAt(1);
            if (options.es6) {
              const codePoint = (first - 55296) * 1024 + second - 56320 + 65536;
              const hex2 = hexadecimal(codePoint, lowercaseHex);
              return "\\u{" + hex2 + "}";
            }
            return fourHexEscape(hexadecimal(first, lowercaseHex)) + fourHexEscape(hexadecimal(second, lowercaseHex));
          }
          if (lone) {
            return fourHexEscape(hexadecimal(lone.charCodeAt(0), lowercaseHex));
          }
          if (char == "\0" && !json && !regexDigit.test(string.charAt(index + 1))) {
            return "\\0";
          }
          if (quoteChar) {
            if (quoteChar == quote || options.escapeEverything) {
              return "\\" + quoteChar;
            }
            return quoteChar;
          }
          if (regexSingleEscape.test(char)) {
            return singleEscapes[char];
          }
          if (options.minimal && !regexWhitespace.test(char)) {
            return char;
          }
          const hex = hexadecimal(char.charCodeAt(0), lowercaseHex);
          if (json || hex.length > 2) {
            return fourHexEscape(hex);
          }
          return "\\x" + ("00" + hex).slice(-2);
        });
        if (quote == "`") {
          result2 = result2.replace(/\$\{/g, "\\${");
        }
        if (options.isScriptContext) {
          result2 = result2.replace(/<\/(script|style)/gi, "<\\/$1").replace(/<!--/g, json ? "\\u003C!--" : "\\x3C!--");
        }
        if (options.wrap) {
          result2 = quote + result2 + quote;
        }
        return result2;
      };
      jsesc.version = "3.0.2";
      module2.exports = jsesc;
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/types.js
  var require_types2 = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/types.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.ArgumentPlaceholder = ArgumentPlaceholder;
      exports8.ArrayPattern = exports8.ArrayExpression = ArrayExpression;
      exports8.BigIntLiteral = BigIntLiteral;
      exports8.BooleanLiteral = BooleanLiteral;
      exports8.Identifier = Identifier;
      exports8.NullLiteral = NullLiteral;
      exports8.NumericLiteral = NumericLiteral;
      exports8.ObjectPattern = exports8.ObjectExpression = ObjectExpression;
      exports8.ObjectMethod = ObjectMethod;
      exports8.ObjectProperty = ObjectProperty;
      exports8.PipelineBareFunction = PipelineBareFunction;
      exports8.PipelinePrimaryTopicReference = PipelinePrimaryTopicReference;
      exports8.PipelineTopicExpression = PipelineTopicExpression;
      exports8.RecordExpression = RecordExpression;
      exports8.RegExpLiteral = RegExpLiteral;
      exports8.SpreadElement = exports8.RestElement = RestElement;
      exports8.StringLiteral = StringLiteral;
      exports8.TopicReference = TopicReference;
      exports8.TupleExpression = TupleExpression;
      exports8.VoidPattern = VoidPattern;
      exports8._getRawIdentifier = _getRawIdentifier;
      var _t = require_lib5();
      var _jsesc = require_jsesc();
      var {
        isAssignmentPattern,
        isIdentifier: isIdentifier2
      } = _t;
      var lastRawIdentNode = null;
      var lastRawIdentResult = "";
      function _getRawIdentifier(node) {
        if (node === lastRawIdentNode)
          return lastRawIdentResult;
        lastRawIdentNode = node;
        const {
          name
        } = node;
        const token = this.tokenMap.find(node, (tok) => tok.value === name);
        if (token) {
          lastRawIdentResult = this._originalCode.slice(token.start, token.end);
          return lastRawIdentResult;
        }
        return lastRawIdentResult = node.name;
      }
      function Identifier(node) {
        var _node$loc;
        this.sourceIdentifierName(((_node$loc = node.loc) == null ? void 0 : _node$loc.identifierName) || node.name);
        this.word(this.tokenMap ? this._getRawIdentifier(node) : node.name);
      }
      function ArgumentPlaceholder() {
        this.tokenChar(63);
      }
      function RestElement(node) {
        this.token("...");
        this.print(node.argument);
      }
      function ObjectExpression(node) {
        const props = node.properties;
        this.tokenChar(123);
        if (props.length) {
          const exit3 = this.enterDelimited();
          this.space();
          this.printList(props, this.shouldPrintTrailingComma("}"), true, true);
          this.space();
          exit3();
        }
        this.sourceWithOffset("end", node.loc, -1);
        this.tokenChar(125);
      }
      function ObjectMethod(node) {
        this.printJoin(node.decorators);
        this._methodHead(node);
        this.space();
        this.print(node.body);
      }
      function ObjectProperty(node) {
        this.printJoin(node.decorators);
        if (node.computed) {
          this.tokenChar(91);
          this.print(node.key);
          this.tokenChar(93);
        } else {
          if (isAssignmentPattern(node.value) && isIdentifier2(node.key) && node.key.name === node.value.left.name) {
            this.print(node.value);
            return;
          }
          this.print(node.key);
          if (node.shorthand && isIdentifier2(node.key) && isIdentifier2(node.value) && node.key.name === node.value.name) {
            return;
          }
        }
        this.tokenChar(58);
        this.space();
        this.print(node.value);
      }
      function ArrayExpression(node) {
        const elems = node.elements;
        const len = elems.length;
        this.tokenChar(91);
        const exit3 = this.enterDelimited();
        for (let i = 0; i < elems.length; i++) {
          const elem = elems[i];
          if (elem) {
            if (i > 0)
              this.space();
            this.print(elem);
            if (i < len - 1 || this.shouldPrintTrailingComma("]")) {
              this.token(",", false, i);
            }
          } else {
            this.token(",", false, i);
          }
        }
        exit3();
        this.tokenChar(93);
      }
      function RecordExpression(node) {
        const props = node.properties;
        let startToken;
        let endToken;
        {
          if (this.format.recordAndTupleSyntaxType === "bar") {
            startToken = "{|";
            endToken = "|}";
          } else if (this.format.recordAndTupleSyntaxType !== "hash" && this.format.recordAndTupleSyntaxType != null) {
            throw new Error(`The "recordAndTupleSyntaxType" generator option must be "bar" or "hash" (${JSON.stringify(this.format.recordAndTupleSyntaxType)} received).`);
          } else {
            startToken = "#{";
            endToken = "}";
          }
        }
        this.token(startToken);
        if (props.length) {
          this.space();
          this.printList(props, this.shouldPrintTrailingComma(endToken), true, true);
          this.space();
        }
        this.token(endToken);
      }
      function TupleExpression(node) {
        const elems = node.elements;
        const len = elems.length;
        let startToken;
        let endToken;
        {
          if (this.format.recordAndTupleSyntaxType === "bar") {
            startToken = "[|";
            endToken = "|]";
          } else if (this.format.recordAndTupleSyntaxType === "hash") {
            startToken = "#[";
            endToken = "]";
          } else {
            throw new Error(`${this.format.recordAndTupleSyntaxType} is not a valid recordAndTuple syntax type`);
          }
        }
        this.token(startToken);
        for (let i = 0; i < elems.length; i++) {
          const elem = elems[i];
          if (elem) {
            if (i > 0)
              this.space();
            this.print(elem);
            if (i < len - 1 || this.shouldPrintTrailingComma(endToken)) {
              this.token(",", false, i);
            }
          }
        }
        this.token(endToken);
      }
      function RegExpLiteral(node) {
        this.word(`/${node.pattern}/${node.flags}`);
      }
      function BooleanLiteral(node) {
        this.word(node.value ? "true" : "false");
      }
      function NullLiteral() {
        this.word("null");
      }
      function NumericLiteral(node) {
        const raw = this.getPossibleRaw(node);
        const opts = this.format.jsescOption;
        const value = node.value;
        const str = value + "";
        if (opts.numbers) {
          this.number(_jsesc(value, opts), value);
        } else if (raw == null) {
          this.number(str, value);
        } else if (this.format.minified) {
          this.number(raw.length < str.length ? raw : str, value);
        } else {
          this.number(raw, value);
        }
      }
      function StringLiteral(node) {
        const raw = this.getPossibleRaw(node);
        if (!this.format.minified && raw !== void 0) {
          this.token(raw);
          return;
        }
        const val = _jsesc(node.value, this.format.jsescOption);
        this.token(val);
      }
      function BigIntLiteral(node) {
        const raw = this.getPossibleRaw(node);
        if (!this.format.minified && raw !== void 0) {
          this.word(raw);
          return;
        }
        this.word(node.value + "n");
      }
      var validTopicTokenSet = /* @__PURE__ */ new Set(["^^", "@@", "^", "%", "#"]);
      function TopicReference() {
        const {
          topicToken
        } = this.format;
        if (validTopicTokenSet.has(topicToken)) {
          this.token(topicToken);
        } else {
          const givenTopicTokenJSON = JSON.stringify(topicToken);
          const validTopics = Array.from(validTopicTokenSet, (v) => JSON.stringify(v));
          throw new Error(`The "topicToken" generator option must be one of ${validTopics.join(", ")} (${givenTopicTokenJSON} received instead).`);
        }
      }
      function PipelineTopicExpression(node) {
        this.print(node.expression);
      }
      function PipelineBareFunction(node) {
        this.print(node.callee);
      }
      function PipelinePrimaryTopicReference() {
        this.tokenChar(35);
      }
      function VoidPattern() {
        this.word("void");
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/flow.js
  var require_flow2 = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/flow.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.AnyTypeAnnotation = AnyTypeAnnotation;
      exports8.ArrayTypeAnnotation = ArrayTypeAnnotation;
      exports8.BooleanLiteralTypeAnnotation = BooleanLiteralTypeAnnotation;
      exports8.BooleanTypeAnnotation = BooleanTypeAnnotation;
      exports8.DeclareClass = DeclareClass;
      exports8.DeclareExportAllDeclaration = DeclareExportAllDeclaration;
      exports8.DeclareExportDeclaration = DeclareExportDeclaration;
      exports8.DeclareFunction = DeclareFunction;
      exports8.DeclareInterface = DeclareInterface;
      exports8.DeclareModule = DeclareModule;
      exports8.DeclareModuleExports = DeclareModuleExports;
      exports8.DeclareOpaqueType = DeclareOpaqueType;
      exports8.DeclareTypeAlias = DeclareTypeAlias;
      exports8.DeclareVariable = DeclareVariable;
      exports8.DeclaredPredicate = DeclaredPredicate;
      exports8.EmptyTypeAnnotation = EmptyTypeAnnotation;
      exports8.EnumBooleanBody = EnumBooleanBody;
      exports8.EnumBooleanMember = EnumBooleanMember;
      exports8.EnumDeclaration = EnumDeclaration;
      exports8.EnumDefaultedMember = EnumDefaultedMember;
      exports8.EnumNumberBody = EnumNumberBody;
      exports8.EnumNumberMember = EnumNumberMember;
      exports8.EnumStringBody = EnumStringBody;
      exports8.EnumStringMember = EnumStringMember;
      exports8.EnumSymbolBody = EnumSymbolBody;
      exports8.ExistsTypeAnnotation = ExistsTypeAnnotation;
      exports8.FunctionTypeAnnotation = FunctionTypeAnnotation;
      exports8.FunctionTypeParam = FunctionTypeParam;
      exports8.IndexedAccessType = IndexedAccessType;
      exports8.InferredPredicate = InferredPredicate;
      exports8.InterfaceDeclaration = InterfaceDeclaration;
      exports8.GenericTypeAnnotation = exports8.ClassImplements = exports8.InterfaceExtends = InterfaceExtends;
      exports8.InterfaceTypeAnnotation = InterfaceTypeAnnotation;
      exports8.IntersectionTypeAnnotation = IntersectionTypeAnnotation;
      exports8.MixedTypeAnnotation = MixedTypeAnnotation;
      exports8.NullLiteralTypeAnnotation = NullLiteralTypeAnnotation;
      exports8.NullableTypeAnnotation = NullableTypeAnnotation;
      Object.defineProperty(exports8, "NumberLiteralTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _types2.NumericLiteral;
        }
      });
      exports8.NumberTypeAnnotation = NumberTypeAnnotation;
      exports8.ObjectTypeAnnotation = ObjectTypeAnnotation;
      exports8.ObjectTypeCallProperty = ObjectTypeCallProperty;
      exports8.ObjectTypeIndexer = ObjectTypeIndexer;
      exports8.ObjectTypeInternalSlot = ObjectTypeInternalSlot;
      exports8.ObjectTypeProperty = ObjectTypeProperty;
      exports8.ObjectTypeSpreadProperty = ObjectTypeSpreadProperty;
      exports8.OpaqueType = OpaqueType;
      exports8.OptionalIndexedAccessType = OptionalIndexedAccessType;
      exports8.QualifiedTypeIdentifier = QualifiedTypeIdentifier;
      Object.defineProperty(exports8, "StringLiteralTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _types2.StringLiteral;
        }
      });
      exports8.StringTypeAnnotation = StringTypeAnnotation;
      exports8.SymbolTypeAnnotation = SymbolTypeAnnotation;
      exports8.ThisTypeAnnotation = ThisTypeAnnotation;
      exports8.TupleTypeAnnotation = TupleTypeAnnotation;
      exports8.TypeAlias = TypeAlias;
      exports8.TypeAnnotation = TypeAnnotation;
      exports8.TypeCastExpression = TypeCastExpression;
      exports8.TypeParameter = TypeParameter;
      exports8.TypeParameterDeclaration = exports8.TypeParameterInstantiation = TypeParameterInstantiation;
      exports8.TypeofTypeAnnotation = TypeofTypeAnnotation;
      exports8.UnionTypeAnnotation = UnionTypeAnnotation;
      exports8.Variance = Variance;
      exports8.VoidTypeAnnotation = VoidTypeAnnotation;
      exports8._interfaceish = _interfaceish;
      exports8._variance = _variance;
      var _t = require_lib5();
      var _modules = require_modules();
      var _index = require_node();
      var _types2 = require_types2();
      var {
        isDeclareExportDeclaration,
        isStatement
      } = _t;
      function AnyTypeAnnotation() {
        this.word("any");
      }
      function ArrayTypeAnnotation(node) {
        this.print(node.elementType, true);
        this.tokenChar(91);
        this.tokenChar(93);
      }
      function BooleanTypeAnnotation() {
        this.word("boolean");
      }
      function BooleanLiteralTypeAnnotation(node) {
        this.word(node.value ? "true" : "false");
      }
      function NullLiteralTypeAnnotation() {
        this.word("null");
      }
      function DeclareClass(node, parent2) {
        if (!isDeclareExportDeclaration(parent2)) {
          this.word("declare");
          this.space();
        }
        this.word("class");
        this.space();
        this._interfaceish(node);
      }
      function DeclareFunction(node, parent2) {
        if (!isDeclareExportDeclaration(parent2)) {
          this.word("declare");
          this.space();
        }
        this.word("function");
        this.space();
        this.print(node.id);
        this.print(node.id.typeAnnotation.typeAnnotation);
        if (node.predicate) {
          this.space();
          this.print(node.predicate);
        }
        this.semicolon();
      }
      function InferredPredicate() {
        this.tokenChar(37);
        this.word("checks");
      }
      function DeclaredPredicate(node) {
        this.tokenChar(37);
        this.word("checks");
        this.tokenChar(40);
        this.print(node.value);
        this.tokenChar(41);
      }
      function DeclareInterface(node) {
        this.word("declare");
        this.space();
        this.InterfaceDeclaration(node);
      }
      function DeclareModule(node) {
        this.word("declare");
        this.space();
        this.word("module");
        this.space();
        this.print(node.id);
        this.space();
        this.print(node.body);
      }
      function DeclareModuleExports(node) {
        this.word("declare");
        this.space();
        this.word("module");
        this.tokenChar(46);
        this.word("exports");
        this.print(node.typeAnnotation);
      }
      function DeclareTypeAlias(node) {
        this.word("declare");
        this.space();
        this.TypeAlias(node);
      }
      function DeclareOpaqueType(node, parent2) {
        if (!isDeclareExportDeclaration(parent2)) {
          this.word("declare");
          this.space();
        }
        this.OpaqueType(node);
      }
      function DeclareVariable(node, parent2) {
        if (!isDeclareExportDeclaration(parent2)) {
          this.word("declare");
          this.space();
        }
        this.word("var");
        this.space();
        this.print(node.id);
        this.print(node.id.typeAnnotation);
        this.semicolon();
      }
      function DeclareExportDeclaration(node) {
        this.word("declare");
        this.space();
        this.word("export");
        this.space();
        if (node.default) {
          this.word("default");
          this.space();
        }
        FlowExportDeclaration.call(this, node);
      }
      function DeclareExportAllDeclaration(node) {
        this.word("declare");
        this.space();
        _modules.ExportAllDeclaration.call(this, node);
      }
      function EnumDeclaration(node) {
        const {
          id,
          body
        } = node;
        this.word("enum");
        this.space();
        this.print(id);
        this.print(body);
      }
      function enumExplicitType(context, name, hasExplicitType) {
        if (hasExplicitType) {
          context.space();
          context.word("of");
          context.space();
          context.word(name);
        }
        context.space();
      }
      function enumBody(context, node) {
        const {
          members
        } = node;
        context.token("{");
        context.indent();
        context.newline();
        for (const member of members) {
          context.print(member);
          context.newline();
        }
        if (node.hasUnknownMembers) {
          context.token("...");
          context.newline();
        }
        context.dedent();
        context.token("}");
      }
      function EnumBooleanBody(node) {
        const {
          explicitType
        } = node;
        enumExplicitType(this, "boolean", explicitType);
        enumBody(this, node);
      }
      function EnumNumberBody(node) {
        const {
          explicitType
        } = node;
        enumExplicitType(this, "number", explicitType);
        enumBody(this, node);
      }
      function EnumStringBody(node) {
        const {
          explicitType
        } = node;
        enumExplicitType(this, "string", explicitType);
        enumBody(this, node);
      }
      function EnumSymbolBody(node) {
        enumExplicitType(this, "symbol", true);
        enumBody(this, node);
      }
      function EnumDefaultedMember(node) {
        const {
          id
        } = node;
        this.print(id);
        this.tokenChar(44);
      }
      function enumInitializedMember(context, node) {
        context.print(node.id);
        context.space();
        context.token("=");
        context.space();
        context.print(node.init);
        context.token(",");
      }
      function EnumBooleanMember(node) {
        enumInitializedMember(this, node);
      }
      function EnumNumberMember(node) {
        enumInitializedMember(this, node);
      }
      function EnumStringMember(node) {
        enumInitializedMember(this, node);
      }
      function FlowExportDeclaration(node) {
        if (node.declaration) {
          const declar = node.declaration;
          this.print(declar);
          if (!isStatement(declar))
            this.semicolon();
        } else {
          this.tokenChar(123);
          if (node.specifiers.length) {
            this.space();
            this.printList(node.specifiers);
            this.space();
          }
          this.tokenChar(125);
          if (node.source) {
            this.space();
            this.word("from");
            this.space();
            this.print(node.source);
          }
          this.semicolon();
        }
      }
      function ExistsTypeAnnotation() {
        this.tokenChar(42);
      }
      function FunctionTypeAnnotation(node, parent2) {
        this.print(node.typeParameters);
        this.tokenChar(40);
        if (node.this) {
          this.word("this");
          this.tokenChar(58);
          this.space();
          this.print(node.this.typeAnnotation);
          if (node.params.length || node.rest) {
            this.tokenChar(44);
            this.space();
          }
        }
        this.printList(node.params);
        if (node.rest) {
          if (node.params.length) {
            this.tokenChar(44);
            this.space();
          }
          this.token("...");
          this.print(node.rest);
        }
        this.tokenChar(41);
        const type = parent2 == null ? void 0 : parent2.type;
        if (type != null && (type === "ObjectTypeCallProperty" || type === "ObjectTypeInternalSlot" || type === "DeclareFunction" || type === "ObjectTypeProperty" && parent2.method)) {
          this.tokenChar(58);
        } else {
          this.space();
          this.token("=>");
        }
        this.space();
        this.print(node.returnType);
      }
      function FunctionTypeParam(node) {
        this.print(node.name);
        if (node.optional)
          this.tokenChar(63);
        if (node.name) {
          this.tokenChar(58);
          this.space();
        }
        this.print(node.typeAnnotation);
      }
      function InterfaceExtends(node) {
        this.print(node.id);
        this.print(node.typeParameters, true);
      }
      function _interfaceish(node) {
        var _node$extends;
        this.print(node.id);
        this.print(node.typeParameters);
        if ((_node$extends = node.extends) != null && _node$extends.length) {
          this.space();
          this.word("extends");
          this.space();
          this.printList(node.extends);
        }
        if (node.type === "DeclareClass") {
          var _node$mixins, _node$implements;
          if ((_node$mixins = node.mixins) != null && _node$mixins.length) {
            this.space();
            this.word("mixins");
            this.space();
            this.printList(node.mixins);
          }
          if ((_node$implements = node.implements) != null && _node$implements.length) {
            this.space();
            this.word("implements");
            this.space();
            this.printList(node.implements);
          }
        }
        this.space();
        this.print(node.body);
      }
      function _variance(node) {
        var _node$variance;
        const kind = (_node$variance = node.variance) == null ? void 0 : _node$variance.kind;
        if (kind != null) {
          if (kind === "plus") {
            this.tokenChar(43);
          } else if (kind === "minus") {
            this.tokenChar(45);
          }
        }
      }
      function InterfaceDeclaration(node) {
        this.word("interface");
        this.space();
        this._interfaceish(node);
      }
      function andSeparator(occurrenceCount) {
        this.space();
        this.token("&", false, occurrenceCount);
        this.space();
      }
      function InterfaceTypeAnnotation(node) {
        var _node$extends2;
        this.word("interface");
        if ((_node$extends2 = node.extends) != null && _node$extends2.length) {
          this.space();
          this.word("extends");
          this.space();
          this.printList(node.extends);
        }
        this.space();
        this.print(node.body);
      }
      function IntersectionTypeAnnotation(node) {
        this.printJoin(node.types, void 0, void 0, andSeparator);
      }
      function MixedTypeAnnotation() {
        this.word("mixed");
      }
      function EmptyTypeAnnotation() {
        this.word("empty");
      }
      function NullableTypeAnnotation(node) {
        this.tokenChar(63);
        this.print(node.typeAnnotation);
      }
      function NumberTypeAnnotation() {
        this.word("number");
      }
      function StringTypeAnnotation() {
        this.word("string");
      }
      function ThisTypeAnnotation() {
        this.word("this");
      }
      function TupleTypeAnnotation(node) {
        this.tokenChar(91);
        this.printList(node.types);
        this.tokenChar(93);
      }
      function TypeofTypeAnnotation(node) {
        this.word("typeof");
        this.space();
        this.print(node.argument);
      }
      function TypeAlias(node) {
        this.word("type");
        this.space();
        this.print(node.id);
        this.print(node.typeParameters);
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.right);
        this.semicolon();
      }
      function TypeAnnotation(node, parent2) {
        this.tokenChar(58);
        this.space();
        if (parent2.type === "ArrowFunctionExpression") {
          this.tokenContext |= _index.TokenContext.arrowFlowReturnType;
        } else if (node.optional) {
          this.tokenChar(63);
        }
        this.print(node.typeAnnotation);
      }
      function TypeParameterInstantiation(node) {
        this.tokenChar(60);
        this.printList(node.params);
        this.tokenChar(62);
      }
      function TypeParameter(node) {
        this._variance(node);
        this.word(node.name);
        if (node.bound) {
          this.print(node.bound);
        }
        if (node.default) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.default);
        }
      }
      function OpaqueType(node) {
        this.word("opaque");
        this.space();
        this.word("type");
        this.space();
        this.print(node.id);
        this.print(node.typeParameters);
        if (node.supertype) {
          this.tokenChar(58);
          this.space();
          this.print(node.supertype);
        }
        if (node.impltype) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.impltype);
        }
        this.semicolon();
      }
      function ObjectTypeAnnotation(node) {
        if (node.exact) {
          this.token("{|");
        } else {
          this.tokenChar(123);
        }
        const props = [...node.properties, ...node.callProperties || [], ...node.indexers || [], ...node.internalSlots || []];
        if (props.length) {
          this.newline();
          this.space();
          this.printJoin(props, true, true, void 0, void 0, function addNewlines(leading) {
            if (leading && !props[0])
              return 1;
          }, () => {
            if (props.length !== 1 || node.inexact) {
              this.tokenChar(44);
              this.space();
            }
          });
          this.space();
        }
        if (node.inexact) {
          this.indent();
          this.token("...");
          if (props.length) {
            this.newline();
          }
          this.dedent();
        }
        if (node.exact) {
          this.token("|}");
        } else {
          this.tokenChar(125);
        }
      }
      function ObjectTypeInternalSlot(node) {
        if (node.static) {
          this.word("static");
          this.space();
        }
        this.tokenChar(91);
        this.tokenChar(91);
        this.print(node.id);
        this.tokenChar(93);
        this.tokenChar(93);
        if (node.optional)
          this.tokenChar(63);
        if (!node.method) {
          this.tokenChar(58);
          this.space();
        }
        this.print(node.value);
      }
      function ObjectTypeCallProperty(node) {
        if (node.static) {
          this.word("static");
          this.space();
        }
        this.print(node.value);
      }
      function ObjectTypeIndexer(node) {
        if (node.static) {
          this.word("static");
          this.space();
        }
        this._variance(node);
        this.tokenChar(91);
        if (node.id) {
          this.print(node.id);
          this.tokenChar(58);
          this.space();
        }
        this.print(node.key);
        this.tokenChar(93);
        this.tokenChar(58);
        this.space();
        this.print(node.value);
      }
      function ObjectTypeProperty(node) {
        if (node.proto) {
          this.word("proto");
          this.space();
        }
        if (node.static) {
          this.word("static");
          this.space();
        }
        if (node.kind === "get" || node.kind === "set") {
          this.word(node.kind);
          this.space();
        }
        this._variance(node);
        this.print(node.key);
        if (node.optional)
          this.tokenChar(63);
        if (!node.method) {
          this.tokenChar(58);
          this.space();
        }
        this.print(node.value);
      }
      function ObjectTypeSpreadProperty(node) {
        this.token("...");
        this.print(node.argument);
      }
      function QualifiedTypeIdentifier(node) {
        this.print(node.qualification);
        this.tokenChar(46);
        this.print(node.id);
      }
      function SymbolTypeAnnotation() {
        this.word("symbol");
      }
      function orSeparator(occurrenceCount) {
        this.space();
        this.token("|", false, occurrenceCount);
        this.space();
      }
      function UnionTypeAnnotation(node) {
        this.printJoin(node.types, void 0, void 0, orSeparator);
      }
      function TypeCastExpression(node) {
        this.tokenChar(40);
        this.print(node.expression);
        this.print(node.typeAnnotation);
        this.tokenChar(41);
      }
      function Variance(node) {
        if (node.kind === "plus") {
          this.tokenChar(43);
        } else {
          this.tokenChar(45);
        }
      }
      function VoidTypeAnnotation() {
        this.word("void");
      }
      function IndexedAccessType(node) {
        this.print(node.objectType, true);
        this.tokenChar(91);
        this.print(node.indexType);
        this.tokenChar(93);
      }
      function OptionalIndexedAccessType(node) {
        this.print(node.objectType);
        if (node.optional) {
          this.token("?.");
        }
        this.tokenChar(91);
        this.print(node.indexType);
        this.tokenChar(93);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/base.js
  var require_base2 = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/base.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.BlockStatement = BlockStatement;
      exports8.Directive = Directive;
      exports8.DirectiveLiteral = DirectiveLiteral;
      exports8.File = File;
      exports8.InterpreterDirective = InterpreterDirective;
      exports8.Placeholder = Placeholder;
      exports8.Program = Program;
      function File(node) {
        if (node.program) {
          this.print(node.program.interpreter);
        }
        this.print(node.program);
      }
      function Program(node) {
        var _node$directives;
        this.noIndentInnerCommentsHere();
        this.printInnerComments();
        const directivesLen = (_node$directives = node.directives) == null ? void 0 : _node$directives.length;
        if (directivesLen) {
          var _node$directives$trai;
          const newline = node.body.length ? 2 : 1;
          this.printSequence(node.directives, void 0, newline);
          if (!((_node$directives$trai = node.directives[directivesLen - 1].trailingComments) != null && _node$directives$trai.length)) {
            this.newline(newline);
          }
        }
        this.printSequence(node.body);
      }
      function BlockStatement(node) {
        var _node$directives2;
        this.tokenChar(123);
        const exit3 = this.enterDelimited();
        const directivesLen = (_node$directives2 = node.directives) == null ? void 0 : _node$directives2.length;
        if (directivesLen) {
          var _node$directives$trai2;
          const newline = node.body.length ? 2 : 1;
          this.printSequence(node.directives, true, newline);
          if (!((_node$directives$trai2 = node.directives[directivesLen - 1].trailingComments) != null && _node$directives$trai2.length)) {
            this.newline(newline);
          }
        }
        this.printSequence(node.body, true);
        exit3();
        this.rightBrace(node);
      }
      function Directive(node) {
        this.print(node.value);
        this.semicolon();
      }
      var unescapedSingleQuoteRE = /(?:^|[^\\])(?:\\\\)*'/;
      var unescapedDoubleQuoteRE = /(?:^|[^\\])(?:\\\\)*"/;
      function DirectiveLiteral(node) {
        const raw = this.getPossibleRaw(node);
        if (!this.format.minified && raw !== void 0) {
          this.token(raw);
          return;
        }
        const {
          value
        } = node;
        if (!unescapedDoubleQuoteRE.test(value)) {
          this.token(`"${value}"`);
        } else if (!unescapedSingleQuoteRE.test(value)) {
          this.token(`'${value}'`);
        } else {
          throw new Error("Malformed AST: it is not possible to print a directive containing both unescaped single and double quotes.");
        }
      }
      function InterpreterDirective(node) {
        this.token(`#!${node.value}`);
        this.newline(1, true);
      }
      function Placeholder(node) {
        this.token("%%");
        this.print(node.name);
        this.token("%%");
        if (node.expectedNode === "Statement") {
          this.semicolon();
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/jsx.js
  var require_jsx2 = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/jsx.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.JSXAttribute = JSXAttribute;
      exports8.JSXClosingElement = JSXClosingElement;
      exports8.JSXClosingFragment = JSXClosingFragment;
      exports8.JSXElement = JSXElement;
      exports8.JSXEmptyExpression = JSXEmptyExpression;
      exports8.JSXExpressionContainer = JSXExpressionContainer;
      exports8.JSXFragment = JSXFragment;
      exports8.JSXIdentifier = JSXIdentifier;
      exports8.JSXMemberExpression = JSXMemberExpression;
      exports8.JSXNamespacedName = JSXNamespacedName;
      exports8.JSXOpeningElement = JSXOpeningElement;
      exports8.JSXOpeningFragment = JSXOpeningFragment;
      exports8.JSXSpreadAttribute = JSXSpreadAttribute;
      exports8.JSXSpreadChild = JSXSpreadChild;
      exports8.JSXText = JSXText;
      function JSXAttribute(node) {
        this.print(node.name);
        if (node.value) {
          this.tokenChar(61);
          this.print(node.value);
        }
      }
      function JSXIdentifier(node) {
        this.word(node.name);
      }
      function JSXNamespacedName(node) {
        this.print(node.namespace);
        this.tokenChar(58);
        this.print(node.name);
      }
      function JSXMemberExpression(node) {
        this.print(node.object);
        this.tokenChar(46);
        this.print(node.property);
      }
      function JSXSpreadAttribute(node) {
        this.tokenChar(123);
        this.token("...");
        this.print(node.argument);
        this.rightBrace(node);
      }
      function JSXExpressionContainer(node) {
        this.tokenChar(123);
        this.print(node.expression);
        this.rightBrace(node);
      }
      function JSXSpreadChild(node) {
        this.tokenChar(123);
        this.token("...");
        this.print(node.expression);
        this.rightBrace(node);
      }
      function JSXText(node) {
        const raw = this.getPossibleRaw(node);
        if (raw !== void 0) {
          this.token(raw, true);
        } else {
          this.token(node.value, true);
        }
      }
      function JSXElement(node) {
        const open2 = node.openingElement;
        this.print(open2);
        if (open2.selfClosing)
          return;
        this.indent();
        for (const child of node.children) {
          this.print(child);
        }
        this.dedent();
        this.print(node.closingElement);
      }
      function spaceSeparator() {
        this.space();
      }
      function JSXOpeningElement(node) {
        this.tokenChar(60);
        this.print(node.name);
        {
          if (node.typeArguments) {
            this.print(node.typeArguments);
          }
          this.print(node.typeParameters);
        }
        if (node.attributes.length > 0) {
          this.space();
          this.printJoin(node.attributes, void 0, void 0, spaceSeparator);
        }
        if (node.selfClosing) {
          this.space();
          this.tokenChar(47);
        }
        this.tokenChar(62);
      }
      function JSXClosingElement(node) {
        this.tokenChar(60);
        this.tokenChar(47);
        this.print(node.name);
        this.tokenChar(62);
      }
      function JSXEmptyExpression() {
        this.printInnerComments();
      }
      function JSXFragment(node) {
        this.print(node.openingFragment);
        this.indent();
        for (const child of node.children) {
          this.print(child);
        }
        this.dedent();
        this.print(node.closingFragment);
      }
      function JSXOpeningFragment() {
        this.tokenChar(60);
        this.tokenChar(62);
      }
      function JSXClosingFragment() {
        this.token("</");
        this.tokenChar(62);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/typescript.js
  var require_typescript2 = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/typescript.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.TSAnyKeyword = TSAnyKeyword;
      exports8.TSArrayType = TSArrayType;
      exports8.TSSatisfiesExpression = exports8.TSAsExpression = TSTypeExpression;
      exports8.TSBigIntKeyword = TSBigIntKeyword;
      exports8.TSBooleanKeyword = TSBooleanKeyword;
      exports8.TSCallSignatureDeclaration = TSCallSignatureDeclaration;
      exports8.TSInterfaceHeritage = exports8.TSClassImplements = TSClassImplements;
      exports8.TSConditionalType = TSConditionalType;
      exports8.TSConstructSignatureDeclaration = TSConstructSignatureDeclaration;
      exports8.TSConstructorType = TSConstructorType;
      exports8.TSDeclareFunction = TSDeclareFunction;
      exports8.TSDeclareMethod = TSDeclareMethod;
      exports8.TSEnumBody = TSEnumBody;
      exports8.TSEnumDeclaration = TSEnumDeclaration;
      exports8.TSEnumMember = TSEnumMember;
      exports8.TSExportAssignment = TSExportAssignment;
      exports8.TSExternalModuleReference = TSExternalModuleReference;
      exports8.TSFunctionType = TSFunctionType;
      exports8.TSImportEqualsDeclaration = TSImportEqualsDeclaration;
      exports8.TSImportType = TSImportType;
      exports8.TSIndexSignature = TSIndexSignature;
      exports8.TSIndexedAccessType = TSIndexedAccessType;
      exports8.TSInferType = TSInferType;
      exports8.TSInstantiationExpression = TSInstantiationExpression;
      exports8.TSInterfaceBody = TSInterfaceBody;
      exports8.TSInterfaceDeclaration = TSInterfaceDeclaration;
      exports8.TSIntersectionType = TSIntersectionType;
      exports8.TSIntrinsicKeyword = TSIntrinsicKeyword;
      exports8.TSLiteralType = TSLiteralType;
      exports8.TSMappedType = TSMappedType;
      exports8.TSMethodSignature = TSMethodSignature;
      exports8.TSModuleBlock = TSModuleBlock;
      exports8.TSModuleDeclaration = TSModuleDeclaration;
      exports8.TSNamedTupleMember = TSNamedTupleMember;
      exports8.TSNamespaceExportDeclaration = TSNamespaceExportDeclaration;
      exports8.TSNeverKeyword = TSNeverKeyword;
      exports8.TSNonNullExpression = TSNonNullExpression;
      exports8.TSNullKeyword = TSNullKeyword;
      exports8.TSNumberKeyword = TSNumberKeyword;
      exports8.TSObjectKeyword = TSObjectKeyword;
      exports8.TSOptionalType = TSOptionalType;
      exports8.TSParameterProperty = TSParameterProperty;
      exports8.TSParenthesizedType = TSParenthesizedType;
      exports8.TSPropertySignature = TSPropertySignature;
      exports8.TSQualifiedName = TSQualifiedName;
      exports8.TSRestType = TSRestType;
      exports8.TSStringKeyword = TSStringKeyword;
      exports8.TSSymbolKeyword = TSSymbolKeyword;
      exports8.TSTemplateLiteralType = TSTemplateLiteralType;
      exports8.TSThisType = TSThisType;
      exports8.TSTupleType = TSTupleType;
      exports8.TSTypeAliasDeclaration = TSTypeAliasDeclaration;
      exports8.TSTypeAnnotation = TSTypeAnnotation;
      exports8.TSTypeAssertion = TSTypeAssertion;
      exports8.TSTypeLiteral = TSTypeLiteral;
      exports8.TSTypeOperator = TSTypeOperator;
      exports8.TSTypeParameter = TSTypeParameter;
      exports8.TSTypeParameterDeclaration = exports8.TSTypeParameterInstantiation = TSTypeParameterInstantiation;
      exports8.TSTypePredicate = TSTypePredicate;
      exports8.TSTypeQuery = TSTypeQuery;
      exports8.TSTypeReference = TSTypeReference;
      exports8.TSUndefinedKeyword = TSUndefinedKeyword;
      exports8.TSUnionType = TSUnionType;
      exports8.TSUnknownKeyword = TSUnknownKeyword;
      exports8.TSVoidKeyword = TSVoidKeyword;
      exports8.tsPrintClassMemberModifiers = tsPrintClassMemberModifiers;
      exports8.tsPrintFunctionOrConstructorType = tsPrintFunctionOrConstructorType;
      exports8.tsPrintPropertyOrMethodName = tsPrintPropertyOrMethodName;
      exports8.tsPrintSignatureDeclarationBase = tsPrintSignatureDeclarationBase;
      function TSTypeAnnotation(node, parent2) {
        this.token((parent2.type === "TSFunctionType" || parent2.type === "TSConstructorType") && parent2.typeAnnotation === node ? "=>" : ":");
        this.space();
        if (node.optional)
          this.tokenChar(63);
        this.print(node.typeAnnotation);
      }
      function TSTypeParameterInstantiation(node, parent2) {
        this.tokenChar(60);
        let printTrailingSeparator = parent2.type === "ArrowFunctionExpression" && node.params.length === 1;
        if (this.tokenMap && node.start != null && node.end != null) {
          printTrailingSeparator && (printTrailingSeparator = !!this.tokenMap.find(node, (t3) => this.tokenMap.matchesOriginal(t3, ",")));
          printTrailingSeparator || (printTrailingSeparator = this.shouldPrintTrailingComma(">"));
        }
        this.printList(node.params, printTrailingSeparator);
        this.tokenChar(62);
      }
      function TSTypeParameter(node) {
        if (node.const) {
          this.word("const");
          this.space();
        }
        if (node.in) {
          this.word("in");
          this.space();
        }
        if (node.out) {
          this.word("out");
          this.space();
        }
        this.word(node.name);
        if (node.constraint) {
          this.space();
          this.word("extends");
          this.space();
          this.print(node.constraint);
        }
        if (node.default) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.default);
        }
      }
      function TSParameterProperty(node) {
        if (node.accessibility) {
          this.word(node.accessibility);
          this.space();
        }
        if (node.readonly) {
          this.word("readonly");
          this.space();
        }
        this._param(node.parameter);
      }
      function TSDeclareFunction(node, parent2) {
        if (node.declare) {
          this.word("declare");
          this.space();
        }
        this._functionHead(node, parent2);
        this.semicolon();
      }
      function TSDeclareMethod(node) {
        this._classMethodHead(node);
        this.semicolon();
      }
      function TSQualifiedName(node) {
        this.print(node.left);
        this.tokenChar(46);
        this.print(node.right);
      }
      function TSCallSignatureDeclaration(node) {
        this.tsPrintSignatureDeclarationBase(node);
        maybePrintTrailingCommaOrSemicolon(this, node);
      }
      function maybePrintTrailingCommaOrSemicolon(printer, node) {
        if (!printer.tokenMap || !node.start || !node.end) {
          printer.semicolon();
          return;
        }
        if (printer.tokenMap.endMatches(node, ",")) {
          printer.token(",");
        } else if (printer.tokenMap.endMatches(node, ";")) {
          printer.semicolon();
        }
      }
      function TSConstructSignatureDeclaration(node) {
        this.word("new");
        this.space();
        this.tsPrintSignatureDeclarationBase(node);
        maybePrintTrailingCommaOrSemicolon(this, node);
      }
      function TSPropertySignature(node) {
        const {
          readonly
        } = node;
        if (readonly) {
          this.word("readonly");
          this.space();
        }
        this.tsPrintPropertyOrMethodName(node);
        this.print(node.typeAnnotation);
        maybePrintTrailingCommaOrSemicolon(this, node);
      }
      function tsPrintPropertyOrMethodName(node) {
        if (node.computed) {
          this.tokenChar(91);
        }
        this.print(node.key);
        if (node.computed) {
          this.tokenChar(93);
        }
        if (node.optional) {
          this.tokenChar(63);
        }
      }
      function TSMethodSignature(node) {
        const {
          kind
        } = node;
        if (kind === "set" || kind === "get") {
          this.word(kind);
          this.space();
        }
        this.tsPrintPropertyOrMethodName(node);
        this.tsPrintSignatureDeclarationBase(node);
        maybePrintTrailingCommaOrSemicolon(this, node);
      }
      function TSIndexSignature(node) {
        const {
          readonly,
          static: isStatic
        } = node;
        if (isStatic) {
          this.word("static");
          this.space();
        }
        if (readonly) {
          this.word("readonly");
          this.space();
        }
        this.tokenChar(91);
        this._parameters(node.parameters, "]");
        this.print(node.typeAnnotation);
        maybePrintTrailingCommaOrSemicolon(this, node);
      }
      function TSAnyKeyword() {
        this.word("any");
      }
      function TSBigIntKeyword() {
        this.word("bigint");
      }
      function TSUnknownKeyword() {
        this.word("unknown");
      }
      function TSNumberKeyword() {
        this.word("number");
      }
      function TSObjectKeyword() {
        this.word("object");
      }
      function TSBooleanKeyword() {
        this.word("boolean");
      }
      function TSStringKeyword() {
        this.word("string");
      }
      function TSSymbolKeyword() {
        this.word("symbol");
      }
      function TSVoidKeyword() {
        this.word("void");
      }
      function TSUndefinedKeyword() {
        this.word("undefined");
      }
      function TSNullKeyword() {
        this.word("null");
      }
      function TSNeverKeyword() {
        this.word("never");
      }
      function TSIntrinsicKeyword() {
        this.word("intrinsic");
      }
      function TSThisType() {
        this.word("this");
      }
      function TSFunctionType(node) {
        this.tsPrintFunctionOrConstructorType(node);
      }
      function TSConstructorType(node) {
        if (node.abstract) {
          this.word("abstract");
          this.space();
        }
        this.word("new");
        this.space();
        this.tsPrintFunctionOrConstructorType(node);
      }
      function tsPrintFunctionOrConstructorType(node) {
        const {
          typeParameters
        } = node;
        const parameters = node.parameters;
        this.print(typeParameters);
        this.tokenChar(40);
        this._parameters(parameters, ")");
        this.space();
        const returnType = node.typeAnnotation;
        this.print(returnType);
      }
      function TSTypeReference(node) {
        const typeArguments = node.typeParameters;
        this.print(node.typeName, !!typeArguments);
        this.print(typeArguments);
      }
      function TSTypePredicate(node) {
        if (node.asserts) {
          this.word("asserts");
          this.space();
        }
        this.print(node.parameterName);
        if (node.typeAnnotation) {
          this.space();
          this.word("is");
          this.space();
          this.print(node.typeAnnotation.typeAnnotation);
        }
      }
      function TSTypeQuery(node) {
        this.word("typeof");
        this.space();
        this.print(node.exprName);
        const typeArguments = node.typeParameters;
        if (typeArguments) {
          this.print(typeArguments);
        }
      }
      function TSTypeLiteral(node) {
        printBraced(this, node, () => this.printJoin(node.members, true, true));
      }
      function TSArrayType(node) {
        this.print(node.elementType, true);
        this.tokenChar(91);
        this.tokenChar(93);
      }
      function TSTupleType(node) {
        this.tokenChar(91);
        this.printList(node.elementTypes, this.shouldPrintTrailingComma("]"));
        this.tokenChar(93);
      }
      function TSOptionalType(node) {
        this.print(node.typeAnnotation);
        this.tokenChar(63);
      }
      function TSRestType(node) {
        this.token("...");
        this.print(node.typeAnnotation);
      }
      function TSNamedTupleMember(node) {
        this.print(node.label);
        if (node.optional)
          this.tokenChar(63);
        this.tokenChar(58);
        this.space();
        this.print(node.elementType);
      }
      function TSUnionType(node) {
        tsPrintUnionOrIntersectionType(this, node, "|");
      }
      function TSIntersectionType(node) {
        tsPrintUnionOrIntersectionType(this, node, "&");
      }
      function tsPrintUnionOrIntersectionType(printer, node, sep2) {
        var _printer$tokenMap;
        let hasLeadingToken = 0;
        if ((_printer$tokenMap = printer.tokenMap) != null && _printer$tokenMap.startMatches(node, sep2)) {
          hasLeadingToken = 1;
          printer.token(sep2);
        }
        printer.printJoin(node.types, void 0, void 0, function(i) {
          this.space();
          this.token(sep2, null, i + hasLeadingToken);
          this.space();
        });
      }
      function TSConditionalType(node) {
        this.print(node.checkType);
        this.space();
        this.word("extends");
        this.space();
        this.print(node.extendsType);
        this.space();
        this.tokenChar(63);
        this.space();
        this.print(node.trueType);
        this.space();
        this.tokenChar(58);
        this.space();
        this.print(node.falseType);
      }
      function TSInferType(node) {
        this.word("infer");
        this.print(node.typeParameter);
      }
      function TSParenthesizedType(node) {
        this.tokenChar(40);
        this.print(node.typeAnnotation);
        this.tokenChar(41);
      }
      function TSTypeOperator(node) {
        this.word(node.operator);
        this.space();
        this.print(node.typeAnnotation);
      }
      function TSIndexedAccessType(node) {
        this.print(node.objectType, true);
        this.tokenChar(91);
        this.print(node.indexType);
        this.tokenChar(93);
      }
      function TSMappedType(node) {
        const {
          nameType,
          optional,
          readonly,
          typeAnnotation
        } = node;
        this.tokenChar(123);
        const exit3 = this.enterDelimited();
        this.space();
        if (readonly) {
          tokenIfPlusMinus(this, readonly);
          this.word("readonly");
          this.space();
        }
        this.tokenChar(91);
        {
          this.word(node.typeParameter.name);
        }
        this.space();
        this.word("in");
        this.space();
        {
          this.print(node.typeParameter.constraint);
        }
        if (nameType) {
          this.space();
          this.word("as");
          this.space();
          this.print(nameType);
        }
        this.tokenChar(93);
        if (optional) {
          tokenIfPlusMinus(this, optional);
          this.tokenChar(63);
        }
        if (typeAnnotation) {
          this.tokenChar(58);
          this.space();
          this.print(typeAnnotation);
        }
        this.space();
        exit3();
        this.tokenChar(125);
      }
      function tokenIfPlusMinus(self2, tok) {
        if (tok !== true) {
          self2.token(tok);
        }
      }
      function TSTemplateLiteralType(node) {
        this._printTemplate(node, node.types);
      }
      function TSLiteralType(node) {
        this.print(node.literal);
      }
      function TSClassImplements(node) {
        this.print(node.expression);
        this.print(node.typeArguments);
      }
      function TSInterfaceDeclaration(node) {
        const {
          declare,
          id,
          typeParameters,
          extends: extendz,
          body
        } = node;
        if (declare) {
          this.word("declare");
          this.space();
        }
        this.word("interface");
        this.space();
        this.print(id);
        this.print(typeParameters);
        if (extendz != null && extendz.length) {
          this.space();
          this.word("extends");
          this.space();
          this.printList(extendz);
        }
        this.space();
        this.print(body);
      }
      function TSInterfaceBody(node) {
        printBraced(this, node, () => this.printJoin(node.body, true, true));
      }
      function TSTypeAliasDeclaration(node) {
        const {
          declare,
          id,
          typeParameters,
          typeAnnotation
        } = node;
        if (declare) {
          this.word("declare");
          this.space();
        }
        this.word("type");
        this.space();
        this.print(id);
        this.print(typeParameters);
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(typeAnnotation);
        this.semicolon();
      }
      function TSTypeExpression(node) {
        const {
          type,
          expression,
          typeAnnotation
        } = node;
        this.print(expression, true);
        this.space();
        this.word(type === "TSAsExpression" ? "as" : "satisfies");
        this.space();
        this.print(typeAnnotation);
      }
      function TSTypeAssertion(node) {
        const {
          typeAnnotation,
          expression
        } = node;
        this.tokenChar(60);
        this.print(typeAnnotation);
        this.tokenChar(62);
        this.space();
        this.print(expression);
      }
      function TSInstantiationExpression(node) {
        this.print(node.expression);
        {
          this.print(node.typeParameters);
        }
      }
      function TSEnumDeclaration(node) {
        const {
          declare,
          const: isConst,
          id
        } = node;
        if (declare) {
          this.word("declare");
          this.space();
        }
        if (isConst) {
          this.word("const");
          this.space();
        }
        this.word("enum");
        this.space();
        this.print(id);
        this.space();
        {
          TSEnumBody.call(this, node);
        }
      }
      function TSEnumBody(node) {
        printBraced(this, node, () => {
          var _this$shouldPrintTrai;
          return this.printList(node.members, (_this$shouldPrintTrai = this.shouldPrintTrailingComma("}")) != null ? _this$shouldPrintTrai : true, true, true);
        });
      }
      function TSEnumMember(node) {
        const {
          id,
          initializer
        } = node;
        this.print(id);
        if (initializer) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(initializer);
        }
      }
      function TSModuleDeclaration(node) {
        const {
          declare,
          id,
          kind
        } = node;
        if (declare) {
          this.word("declare");
          this.space();
        }
        {
          if (!node.global) {
            this.word(kind != null ? kind : id.type === "Identifier" ? "namespace" : "module");
            this.space();
          }
          this.print(id);
          if (!node.body) {
            this.semicolon();
            return;
          }
          let body = node.body;
          while (body.type === "TSModuleDeclaration") {
            this.tokenChar(46);
            this.print(body.id);
            body = body.body;
          }
          this.space();
          this.print(body);
        }
      }
      function TSModuleBlock(node) {
        printBraced(this, node, () => this.printSequence(node.body, true));
      }
      function TSImportType(node) {
        const {
          argument,
          qualifier,
          options
        } = node;
        this.word("import");
        this.tokenChar(40);
        this.print(argument);
        if (options) {
          this.tokenChar(44);
          this.print(options);
        }
        this.tokenChar(41);
        if (qualifier) {
          this.tokenChar(46);
          this.print(qualifier);
        }
        const typeArguments = node.typeParameters;
        if (typeArguments) {
          this.print(typeArguments);
        }
      }
      function TSImportEqualsDeclaration(node) {
        const {
          id,
          moduleReference
        } = node;
        if (node.isExport) {
          this.word("export");
          this.space();
        }
        this.word("import");
        this.space();
        this.print(id);
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(moduleReference);
        this.semicolon();
      }
      function TSExternalModuleReference(node) {
        this.token("require(");
        this.print(node.expression);
        this.tokenChar(41);
      }
      function TSNonNullExpression(node) {
        this.print(node.expression);
        this.tokenChar(33);
      }
      function TSExportAssignment(node) {
        this.word("export");
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.expression);
        this.semicolon();
      }
      function TSNamespaceExportDeclaration(node) {
        this.word("export");
        this.space();
        this.word("as");
        this.space();
        this.word("namespace");
        this.space();
        this.print(node.id);
        this.semicolon();
      }
      function tsPrintSignatureDeclarationBase(node) {
        const {
          typeParameters
        } = node;
        const parameters = node.parameters;
        this.print(typeParameters);
        this.tokenChar(40);
        this._parameters(parameters, ")");
        const returnType = node.typeAnnotation;
        this.print(returnType);
      }
      function tsPrintClassMemberModifiers(node) {
        const isPrivateField = node.type === "ClassPrivateProperty";
        const isPublicField = node.type === "ClassAccessorProperty" || node.type === "ClassProperty";
        printModifiersList(this, node, [isPublicField && node.declare && "declare", !isPrivateField && node.accessibility]);
        if (node.static) {
          this.word("static");
          this.space();
        }
        printModifiersList(this, node, [!isPrivateField && node.abstract && "abstract", !isPrivateField && node.override && "override", (isPublicField || isPrivateField) && node.readonly && "readonly"]);
      }
      function printBraced(printer, node, cb) {
        printer.token("{");
        const exit3 = printer.enterDelimited();
        cb();
        exit3();
        printer.rightBrace(node);
      }
      function printModifiersList(printer, node, modifiers) {
        var _printer$tokenMap2;
        const modifiersSet = /* @__PURE__ */ new Set();
        for (const modifier of modifiers) {
          if (modifier)
            modifiersSet.add(modifier);
        }
        (_printer$tokenMap2 = printer.tokenMap) == null || _printer$tokenMap2.find(node, (tok) => {
          if (modifiersSet.has(tok.value)) {
            printer.token(tok.value);
            printer.space();
            modifiersSet.delete(tok.value);
            return modifiersSet.size === 0;
          }
        });
        for (const modifier of modifiersSet) {
          printer.word(modifier);
          printer.space();
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/index.js
  var require_generators = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      var _templateLiterals = require_template_literals();
      Object.keys(_templateLiterals).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports8 && exports8[key] === _templateLiterals[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _templateLiterals[key];
          }
        });
      });
      var _expressions = require_expressions();
      Object.keys(_expressions).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports8 && exports8[key] === _expressions[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _expressions[key];
          }
        });
      });
      var _statements = require_statements();
      Object.keys(_statements).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports8 && exports8[key] === _statements[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _statements[key];
          }
        });
      });
      var _classes = require_classes();
      Object.keys(_classes).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports8 && exports8[key] === _classes[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _classes[key];
          }
        });
      });
      var _methods = require_methods();
      Object.keys(_methods).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports8 && exports8[key] === _methods[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _methods[key];
          }
        });
      });
      var _modules = require_modules();
      Object.keys(_modules).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports8 && exports8[key] === _modules[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _modules[key];
          }
        });
      });
      var _types = require_types2();
      Object.keys(_types).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports8 && exports8[key] === _types[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _types[key];
          }
        });
      });
      var _flow = require_flow2();
      Object.keys(_flow).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports8 && exports8[key] === _flow[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _flow[key];
          }
        });
      });
      var _base = require_base2();
      Object.keys(_base).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports8 && exports8[key] === _base[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _base[key];
          }
        });
      });
      var _jsx = require_jsx2();
      Object.keys(_jsx).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports8 && exports8[key] === _jsx[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _jsx[key];
          }
        });
      });
      var _typescript = require_typescript2();
      Object.keys(_typescript).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports8 && exports8[key] === _typescript[key])
          return;
        Object.defineProperty(exports8, key, {
          enumerable: true,
          get: function() {
            return _typescript[key];
          }
        });
      });
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/deprecated.js
  var require_deprecated = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/generators/deprecated.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.addDeprecatedGenerators = addDeprecatedGenerators;
      function addDeprecatedGenerators(PrinterClass) {
        {
          const deprecatedBabel7Generators = {
            Noop() {
            },
            TSExpressionWithTypeArguments(node) {
              this.print(node.expression);
              this.print(node.typeParameters);
            },
            DecimalLiteral(node) {
              const raw = this.getPossibleRaw(node);
              if (!this.format.minified && raw !== void 0) {
                this.word(raw);
                return;
              }
              this.word(node.value + "m");
            }
          };
          Object.assign(PrinterClass.prototype, deprecatedBabel7Generators);
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/printer.js
  var require_printer = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/printer.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      var _buffer = require_buffer();
      var _index = require_node();
      var n = _index;
      var _t = require_lib5();
      var _tokenMap = require_token_map();
      var generatorFunctions = require_generators();
      var _deprecated = require_deprecated();
      var {
        isExpression,
        isFunction: isFunction3,
        isStatement,
        isClassBody,
        isTSInterfaceBody,
        isTSEnumMember
      } = _t;
      var SCIENTIFIC_NOTATION = /e/i;
      var ZERO_DECIMAL_INTEGER = /\.0+$/;
      var HAS_NEWLINE = /[\n\r\u2028\u2029]/;
      var HAS_NEWLINE_OR_BlOCK_COMMENT_END = /[\n\r\u2028\u2029]|\*\//;
      function commentIsNewline(c) {
        return c.type === "CommentLine" || HAS_NEWLINE.test(c.value);
      }
      var {
        needsParens
      } = n;
      var Printer = class {
        constructor(format3, map2, tokens, originalCode) {
          this.tokenContext = _index.TokenContext.normal;
          this._tokens = null;
          this._originalCode = null;
          this._currentNode = null;
          this._indent = 0;
          this._indentRepeat = 0;
          this._insideAux = false;
          this._noLineTerminator = false;
          this._noLineTerminatorAfterNode = null;
          this._printAuxAfterOnNextUserNode = false;
          this._printedComments = /* @__PURE__ */ new Set();
          this._endsWithInteger = false;
          this._endsWithWord = false;
          this._endsWithDiv = false;
          this._lastCommentLine = 0;
          this._endsWithInnerRaw = false;
          this._indentInnerComments = true;
          this.tokenMap = null;
          this._boundGetRawIdentifier = this._getRawIdentifier.bind(this);
          this._printSemicolonBeforeNextNode = -1;
          this._printSemicolonBeforeNextToken = -1;
          this.format = format3;
          this._tokens = tokens;
          this._originalCode = originalCode;
          this._indentRepeat = format3.indent.style.length;
          this._inputMap = map2 == null ? void 0 : map2._inputMap;
          this._buf = new _buffer.default(map2, format3.indent.style[0]);
        }
        enterForStatementInit() {
          this.tokenContext |= _index.TokenContext.forInitHead | _index.TokenContext.forInOrInitHeadAccumulate;
          return () => this.tokenContext = _index.TokenContext.normal;
        }
        enterForXStatementInit(isForOf) {
          if (isForOf) {
            this.tokenContext |= _index.TokenContext.forOfHead;
            return null;
          } else {
            this.tokenContext |= _index.TokenContext.forInHead | _index.TokenContext.forInOrInitHeadAccumulate;
            return () => this.tokenContext = _index.TokenContext.normal;
          }
        }
        enterDelimited() {
          const oldTokenContext = this.tokenContext;
          const oldNoLineTerminatorAfterNode = this._noLineTerminatorAfterNode;
          if (!(oldTokenContext & _index.TokenContext.forInOrInitHeadAccumulate) && oldNoLineTerminatorAfterNode === null) {
            return () => {
            };
          }
          this._noLineTerminatorAfterNode = null;
          this.tokenContext = _index.TokenContext.normal;
          return () => {
            this._noLineTerminatorAfterNode = oldNoLineTerminatorAfterNode;
            this.tokenContext = oldTokenContext;
          };
        }
        generate(ast) {
          if (this.format.preserveFormat) {
            this.tokenMap = new _tokenMap.TokenMap(ast, this._tokens, this._originalCode);
          }
          this.print(ast);
          this._maybeAddAuxComment();
          return this._buf.get();
        }
        indent() {
          const {
            format: format3
          } = this;
          if (format3.preserveFormat || format3.compact || format3.concise) {
            return;
          }
          this._indent++;
        }
        dedent() {
          const {
            format: format3
          } = this;
          if (format3.preserveFormat || format3.compact || format3.concise) {
            return;
          }
          this._indent--;
        }
        semicolon(force = false) {
          this._maybeAddAuxComment();
          if (force) {
            this._appendChar(59);
            this._noLineTerminator = false;
            return;
          }
          if (this.tokenMap) {
            const node = this._currentNode;
            if (node.start != null && node.end != null) {
              if (!this.tokenMap.endMatches(node, ";")) {
                this._printSemicolonBeforeNextNode = this._buf.getCurrentLine();
                return;
              }
              const indexes = this.tokenMap.getIndexes(this._currentNode);
              this._catchUpTo(this._tokens[indexes[indexes.length - 1]].loc.start);
            }
          }
          this._queue(59);
          this._noLineTerminator = false;
        }
        rightBrace(node) {
          if (this.format.minified) {
            this._buf.removeLastSemicolon();
          }
          this.sourceWithOffset("end", node.loc, -1);
          this.tokenChar(125);
        }
        rightParens(node) {
          this.sourceWithOffset("end", node.loc, -1);
          this.tokenChar(41);
        }
        space(force = false) {
          const {
            format: format3
          } = this;
          if (format3.compact || format3.preserveFormat)
            return;
          if (force) {
            this._space();
          } else if (this._buf.hasContent()) {
            const lastCp = this.getLastChar();
            if (lastCp !== 32 && lastCp !== 10) {
              this._space();
            }
          }
        }
        word(str, noLineTerminatorAfter = false) {
          this.tokenContext &= _index.TokenContext.forInOrInitHeadAccumulatePassThroughMask;
          this._maybePrintInnerComments(str);
          this._maybeAddAuxComment();
          if (this.tokenMap)
            this._catchUpToCurrentToken(str);
          if (this._endsWithWord || this._endsWithDiv && str.charCodeAt(0) === 47) {
            this._space();
          }
          this._append(str, false);
          this._endsWithWord = true;
          this._noLineTerminator = noLineTerminatorAfter;
        }
        number(str, number) {
          function isNonDecimalLiteral(str2) {
            if (str2.length > 2 && str2.charCodeAt(0) === 48) {
              const secondChar = str2.charCodeAt(1);
              return secondChar === 98 || secondChar === 111 || secondChar === 120;
            }
            return false;
          }
          this.word(str);
          this._endsWithInteger = Number.isInteger(number) && !isNonDecimalLiteral(str) && !SCIENTIFIC_NOTATION.test(str) && !ZERO_DECIMAL_INTEGER.test(str) && str.charCodeAt(str.length - 1) !== 46;
        }
        token(str, maybeNewline = false, occurrenceCount = 0) {
          this.tokenContext &= _index.TokenContext.forInOrInitHeadAccumulatePassThroughMask;
          this._maybePrintInnerComments(str, occurrenceCount);
          this._maybeAddAuxComment();
          if (this.tokenMap)
            this._catchUpToCurrentToken(str, occurrenceCount);
          const lastChar = this.getLastChar();
          const strFirst = str.charCodeAt(0);
          if (lastChar === 33 && (str === "--" || strFirst === 61) || strFirst === 43 && lastChar === 43 || strFirst === 45 && lastChar === 45 || strFirst === 46 && this._endsWithInteger) {
            this._space();
          }
          this._append(str, maybeNewline);
          this._noLineTerminator = false;
        }
        tokenChar(char) {
          this.tokenContext &= _index.TokenContext.forInOrInitHeadAccumulatePassThroughMask;
          const str = String.fromCharCode(char);
          this._maybePrintInnerComments(str);
          this._maybeAddAuxComment();
          if (this.tokenMap)
            this._catchUpToCurrentToken(str);
          const lastChar = this.getLastChar();
          if (char === 43 && lastChar === 43 || char === 45 && lastChar === 45 || char === 46 && this._endsWithInteger) {
            this._space();
          }
          this._appendChar(char);
          this._noLineTerminator = false;
        }
        newline(i = 1, force) {
          if (i <= 0)
            return;
          if (!force) {
            if (this.format.retainLines || this.format.compact)
              return;
            if (this.format.concise) {
              this.space();
              return;
            }
          }
          if (i > 2)
            i = 2;
          i -= this._buf.getNewlineCount();
          for (let j = 0; j < i; j++) {
            this._newline();
          }
          return;
        }
        endsWith(char) {
          return this.getLastChar() === char;
        }
        getLastChar() {
          return this._buf.getLastChar();
        }
        endsWithCharAndNewline() {
          return this._buf.endsWithCharAndNewline();
        }
        removeTrailingNewline() {
          this._buf.removeTrailingNewline();
        }
        exactSource(loc, cb) {
          if (!loc) {
            cb();
            return;
          }
          this._catchUp("start", loc);
          this._buf.exactSource(loc, cb);
        }
        source(prop, loc) {
          if (!loc)
            return;
          this._catchUp(prop, loc);
          this._buf.source(prop, loc);
        }
        sourceWithOffset(prop, loc, columnOffset) {
          if (!loc || this.format.preserveFormat)
            return;
          this._catchUp(prop, loc);
          this._buf.sourceWithOffset(prop, loc, columnOffset);
        }
        sourceIdentifierName(identifierName, pos) {
          if (!this._buf._canMarkIdName)
            return;
          const sourcePosition = this._buf._sourcePosition;
          sourcePosition.identifierNamePos = pos;
          sourcePosition.identifierName = identifierName;
        }
        _space() {
          this._queue(32);
        }
        _newline() {
          this._queue(10);
        }
        _catchUpToCurrentToken(str, occurrenceCount = 0) {
          const token = this.tokenMap.findMatching(this._currentNode, str, occurrenceCount);
          if (token)
            this._catchUpTo(token.loc.start);
          if (this._printSemicolonBeforeNextToken !== -1 && this._printSemicolonBeforeNextToken === this._buf.getCurrentLine()) {
            this._buf.appendChar(59);
            this._endsWithWord = false;
            this._endsWithInteger = false;
            this._endsWithDiv = false;
          }
          this._printSemicolonBeforeNextToken = -1;
          this._printSemicolonBeforeNextNode = -1;
        }
        _append(str, maybeNewline) {
          this._maybeIndent(str.charCodeAt(0));
          this._buf.append(str, maybeNewline);
          this._endsWithWord = false;
          this._endsWithInteger = false;
          this._endsWithDiv = false;
        }
        _appendChar(char) {
          this._maybeIndent(char);
          this._buf.appendChar(char);
          this._endsWithWord = false;
          this._endsWithInteger = false;
          this._endsWithDiv = false;
        }
        _queue(char) {
          this._maybeIndent(char);
          this._buf.queue(char);
          this._endsWithWord = false;
          this._endsWithInteger = false;
        }
        _maybeIndent(firstChar) {
          if (this._indent && firstChar !== 10 && this.endsWith(10)) {
            this._buf.queueIndentation(this._getIndent());
          }
        }
        _shouldIndent(firstChar) {
          if (this._indent && firstChar !== 10 && this.endsWith(10)) {
            return true;
          }
        }
        catchUp(line) {
          if (!this.format.retainLines)
            return;
          const count = line - this._buf.getCurrentLine();
          for (let i = 0; i < count; i++) {
            this._newline();
          }
        }
        _catchUp(prop, loc) {
          const {
            format: format3
          } = this;
          if (!format3.preserveFormat) {
            if (format3.retainLines && loc != null && loc[prop]) {
              this.catchUp(loc[prop].line);
            }
            return;
          }
          const pos = loc == null ? void 0 : loc[prop];
          if (pos != null)
            this._catchUpTo(pos);
        }
        _catchUpTo({
          line,
          column,
          index
        }) {
          const count = line - this._buf.getCurrentLine();
          if (count > 0 && this._noLineTerminator) {
            return;
          }
          for (let i = 0; i < count; i++) {
            this._newline();
          }
          const spacesCount = count > 0 ? column : column - this._buf.getCurrentColumn();
          if (spacesCount > 0) {
            const spaces = this._originalCode ? this._originalCode.slice(index - spacesCount, index).replace(/[^\t\x0B\f \xA0\u1680\u2000-\u200A\u202F\u205F\u3000\uFEFF]/gu, " ") : " ".repeat(spacesCount);
            this._append(spaces, false);
          }
        }
        _getIndent() {
          return this._indentRepeat * this._indent;
        }
        printTerminatorless(node) {
          this._noLineTerminator = true;
          this.print(node);
        }
        print(node, noLineTerminatorAfter, trailingCommentsLineOffset) {
          var _node$extra, _node$leadingComments, _node$leadingComments2;
          if (!node)
            return;
          this._endsWithInnerRaw = false;
          const nodeType = node.type;
          const format3 = this.format;
          const oldConcise = format3.concise;
          if (node._compact) {
            format3.concise = true;
          }
          const printMethod = this[nodeType];
          if (printMethod === void 0) {
            throw new ReferenceError(`unknown node of type ${JSON.stringify(nodeType)} with constructor ${JSON.stringify(node.constructor.name)}`);
          }
          const parent2 = this._currentNode;
          this._currentNode = node;
          if (this.tokenMap) {
            this._printSemicolonBeforeNextToken = this._printSemicolonBeforeNextNode;
          }
          const oldInAux = this._insideAux;
          this._insideAux = node.loc == null;
          this._maybeAddAuxComment(this._insideAux && !oldInAux);
          const parenthesized = (_node$extra = node.extra) == null ? void 0 : _node$extra.parenthesized;
          let shouldPrintParens = parenthesized && format3.preserveFormat || parenthesized && format3.retainFunctionParens && nodeType === "FunctionExpression" || needsParens(node, parent2, this.tokenContext, format3.preserveFormat ? this._boundGetRawIdentifier : void 0);
          if (!shouldPrintParens && parenthesized && (_node$leadingComments = node.leadingComments) != null && _node$leadingComments.length && node.leadingComments[0].type === "CommentBlock") {
            const parentType = parent2 == null ? void 0 : parent2.type;
            switch (parentType) {
              case "ExpressionStatement":
              case "VariableDeclarator":
              case "AssignmentExpression":
              case "ReturnStatement":
                break;
              case "CallExpression":
              case "OptionalCallExpression":
              case "NewExpression":
                if (parent2.callee !== node)
                  break;
              default:
                shouldPrintParens = true;
            }
          }
          let indentParenthesized = false;
          if (!shouldPrintParens && this._noLineTerminator && ((_node$leadingComments2 = node.leadingComments) != null && _node$leadingComments2.some(commentIsNewline) || this.format.retainLines && node.loc && node.loc.start.line > this._buf.getCurrentLine())) {
            shouldPrintParens = true;
            indentParenthesized = true;
          }
          let oldNoLineTerminatorAfterNode;
          let oldTokenContext;
          if (!shouldPrintParens) {
            noLineTerminatorAfter || (noLineTerminatorAfter = parent2 && this._noLineTerminatorAfterNode === parent2 && n.isLastChild(parent2, node));
            if (noLineTerminatorAfter) {
              var _node$trailingComment;
              if ((_node$trailingComment = node.trailingComments) != null && _node$trailingComment.some(commentIsNewline)) {
                if (isExpression(node))
                  shouldPrintParens = true;
              } else {
                oldNoLineTerminatorAfterNode = this._noLineTerminatorAfterNode;
                this._noLineTerminatorAfterNode = node;
              }
            }
          }
          if (shouldPrintParens) {
            this.tokenChar(40);
            if (indentParenthesized)
              this.indent();
            this._endsWithInnerRaw = false;
            if (this.tokenContext & _index.TokenContext.forInOrInitHeadAccumulate) {
              oldTokenContext = this.tokenContext;
              this.tokenContext = _index.TokenContext.normal;
            }
            oldNoLineTerminatorAfterNode = this._noLineTerminatorAfterNode;
            this._noLineTerminatorAfterNode = null;
          }
          this._lastCommentLine = 0;
          this._printLeadingComments(node, parent2);
          const loc = nodeType === "Program" || nodeType === "File" ? null : node.loc;
          this.exactSource(loc, printMethod.bind(this, node, parent2));
          if (shouldPrintParens) {
            this._printTrailingComments(node, parent2);
            if (indentParenthesized) {
              this.dedent();
              this.newline();
            }
            this.tokenChar(41);
            this._noLineTerminator = noLineTerminatorAfter;
            if (oldTokenContext)
              this.tokenContext = oldTokenContext;
          } else if (noLineTerminatorAfter && !this._noLineTerminator) {
            this._noLineTerminator = true;
            this._printTrailingComments(node, parent2);
          } else {
            this._printTrailingComments(node, parent2, trailingCommentsLineOffset);
          }
          this._currentNode = parent2;
          format3.concise = oldConcise;
          this._insideAux = oldInAux;
          if (oldNoLineTerminatorAfterNode !== void 0) {
            this._noLineTerminatorAfterNode = oldNoLineTerminatorAfterNode;
          }
          this._endsWithInnerRaw = false;
        }
        _maybeAddAuxComment(enteredPositionlessNode) {
          if (enteredPositionlessNode)
            this._printAuxBeforeComment();
          if (!this._insideAux)
            this._printAuxAfterComment();
        }
        _printAuxBeforeComment() {
          if (this._printAuxAfterOnNextUserNode)
            return;
          this._printAuxAfterOnNextUserNode = true;
          const comment = this.format.auxiliaryCommentBefore;
          if (comment) {
            this._printComment({
              type: "CommentBlock",
              value: comment
            }, 0);
          }
        }
        _printAuxAfterComment() {
          if (!this._printAuxAfterOnNextUserNode)
            return;
          this._printAuxAfterOnNextUserNode = false;
          const comment = this.format.auxiliaryCommentAfter;
          if (comment) {
            this._printComment({
              type: "CommentBlock",
              value: comment
            }, 0);
          }
        }
        getPossibleRaw(node) {
          const extra = node.extra;
          if ((extra == null ? void 0 : extra.raw) != null && extra.rawValue != null && node.value === extra.rawValue) {
            return extra.raw;
          }
        }
        printJoin(nodes, statement, indent, separator, printTrailingSeparator, addNewlines, iterator, trailingCommentsLineOffset) {
          if (!(nodes != null && nodes.length))
            return;
          if (indent == null && this.format.retainLines) {
            var _nodes$0$loc;
            const startLine = (_nodes$0$loc = nodes[0].loc) == null ? void 0 : _nodes$0$loc.start.line;
            if (startLine != null && startLine !== this._buf.getCurrentLine()) {
              indent = true;
            }
          }
          if (indent)
            this.indent();
          const newlineOpts = {
            addNewlines,
            nextNodeStartLine: 0
          };
          const boundSeparator = separator == null ? void 0 : separator.bind(this);
          const len = nodes.length;
          for (let i = 0; i < len; i++) {
            const node = nodes[i];
            if (!node)
              continue;
            if (statement)
              this._printNewline(i === 0, newlineOpts);
            this.print(node, void 0, trailingCommentsLineOffset || 0);
            iterator == null || iterator(node, i);
            if (boundSeparator != null) {
              if (i < len - 1)
                boundSeparator(i, false);
              else if (printTrailingSeparator)
                boundSeparator(i, true);
            }
            if (statement) {
              var _node$trailingComment2;
              if (!((_node$trailingComment2 = node.trailingComments) != null && _node$trailingComment2.length)) {
                this._lastCommentLine = 0;
              }
              if (i + 1 === len) {
                this.newline(1);
              } else {
                var _nextNode$loc;
                const nextNode = nodes[i + 1];
                newlineOpts.nextNodeStartLine = ((_nextNode$loc = nextNode.loc) == null ? void 0 : _nextNode$loc.start.line) || 0;
                this._printNewline(true, newlineOpts);
              }
            }
          }
          if (indent)
            this.dedent();
        }
        printAndIndentOnComments(node) {
          const indent = node.leadingComments && node.leadingComments.length > 0;
          if (indent)
            this.indent();
          this.print(node);
          if (indent)
            this.dedent();
        }
        printBlock(parent2) {
          const node = parent2.body;
          if (node.type !== "EmptyStatement") {
            this.space();
          }
          this.print(node);
        }
        _printTrailingComments(node, parent2, lineOffset) {
          const {
            innerComments,
            trailingComments
          } = node;
          if (innerComments != null && innerComments.length) {
            this._printComments(2, innerComments, node, parent2, lineOffset);
          }
          if (trailingComments != null && trailingComments.length) {
            this._printComments(2, trailingComments, node, parent2, lineOffset);
          }
        }
        _printLeadingComments(node, parent2) {
          const comments = node.leadingComments;
          if (!(comments != null && comments.length))
            return;
          this._printComments(0, comments, node, parent2);
        }
        _maybePrintInnerComments(nextTokenStr, nextTokenOccurrenceCount) {
          if (this._endsWithInnerRaw) {
            var _this$tokenMap;
            this.printInnerComments((_this$tokenMap = this.tokenMap) == null ? void 0 : _this$tokenMap.findMatching(this._currentNode, nextTokenStr, nextTokenOccurrenceCount));
          }
          this._endsWithInnerRaw = true;
          this._indentInnerComments = true;
        }
        printInnerComments(nextToken) {
          const node = this._currentNode;
          const comments = node.innerComments;
          if (!(comments != null && comments.length))
            return;
          const hasSpace = this.endsWith(32);
          const indent = this._indentInnerComments;
          const printedCommentsCount = this._printedComments.size;
          if (indent)
            this.indent();
          this._printComments(1, comments, node, void 0, void 0, nextToken);
          if (hasSpace && printedCommentsCount !== this._printedComments.size) {
            this.space();
          }
          if (indent)
            this.dedent();
        }
        noIndentInnerCommentsHere() {
          this._indentInnerComments = false;
        }
        printSequence(nodes, indent, trailingCommentsLineOffset, addNewlines) {
          this.printJoin(nodes, true, indent != null ? indent : false, void 0, void 0, addNewlines, void 0, trailingCommentsLineOffset);
        }
        printList(items, printTrailingSeparator, statement, indent, separator, iterator) {
          this.printJoin(items, statement, indent, separator != null ? separator : commaSeparator, printTrailingSeparator, void 0, iterator);
        }
        shouldPrintTrailingComma(listEnd) {
          if (!this.tokenMap)
            return null;
          const listEndIndex = this.tokenMap.findLastIndex(this._currentNode, (token) => this.tokenMap.matchesOriginal(token, listEnd));
          if (listEndIndex <= 0)
            return null;
          return this.tokenMap.matchesOriginal(this._tokens[listEndIndex - 1], ",");
        }
        _printNewline(newLine, opts) {
          const format3 = this.format;
          if (format3.retainLines || format3.compact)
            return;
          if (format3.concise) {
            this.space();
            return;
          }
          if (!newLine) {
            return;
          }
          const startLine = opts.nextNodeStartLine;
          const lastCommentLine = this._lastCommentLine;
          if (startLine > 0 && lastCommentLine > 0) {
            const offset = startLine - lastCommentLine;
            if (offset >= 0) {
              this.newline(offset || 1);
              return;
            }
          }
          if (this._buf.hasContent()) {
            this.newline(1);
          }
        }
        _shouldPrintComment(comment, nextToken) {
          if (comment.ignore)
            return 0;
          if (this._printedComments.has(comment))
            return 0;
          if (this._noLineTerminator && HAS_NEWLINE_OR_BlOCK_COMMENT_END.test(comment.value)) {
            return 2;
          }
          if (nextToken && this.tokenMap) {
            const commentTok = this.tokenMap.find(this._currentNode, (token) => token.value === comment.value);
            if (commentTok && commentTok.start > nextToken.start) {
              return 2;
            }
          }
          this._printedComments.add(comment);
          if (!this.format.shouldPrintComment(comment.value)) {
            return 0;
          }
          return 1;
        }
        _printComment(comment, skipNewLines) {
          const noLineTerminator = this._noLineTerminator;
          const isBlockComment = comment.type === "CommentBlock";
          const printNewLines = isBlockComment && skipNewLines !== 1 && !this._noLineTerminator;
          if (printNewLines && this._buf.hasContent() && skipNewLines !== 2) {
            this.newline(1);
          }
          const lastCharCode = this.getLastChar();
          if (lastCharCode !== 91 && lastCharCode !== 123 && lastCharCode !== 40) {
            this.space();
          }
          let val;
          if (isBlockComment) {
            val = `/*${comment.value}*/`;
            if (this.format.indent.adjustMultilineComment) {
              var _comment$loc;
              const offset = (_comment$loc = comment.loc) == null ? void 0 : _comment$loc.start.column;
              if (offset) {
                const newlineRegex = new RegExp("\\n\\s{1," + offset + "}", "g");
                val = val.replace(newlineRegex, "\n");
              }
              if (this.format.concise) {
                val = val.replace(/\n(?!$)/g, `
`);
              } else {
                let indentSize = this.format.retainLines ? 0 : this._buf.getCurrentColumn();
                if (this._shouldIndent(47) || this.format.retainLines) {
                  indentSize += this._getIndent();
                }
                val = val.replace(/\n(?!$)/g, `
${" ".repeat(indentSize)}`);
              }
            }
          } else if (!noLineTerminator) {
            val = `//${comment.value}`;
          } else {
            val = `/*${comment.value}*/`;
          }
          if (this._endsWithDiv)
            this._space();
          if (this.tokenMap) {
            const {
              _printSemicolonBeforeNextToken,
              _printSemicolonBeforeNextNode
            } = this;
            this._printSemicolonBeforeNextToken = -1;
            this._printSemicolonBeforeNextNode = -1;
            this.source("start", comment.loc);
            this._append(val, isBlockComment);
            this._printSemicolonBeforeNextNode = _printSemicolonBeforeNextNode;
            this._printSemicolonBeforeNextToken = _printSemicolonBeforeNextToken;
          } else {
            this.source("start", comment.loc);
            this._append(val, isBlockComment);
          }
          if (!isBlockComment && !noLineTerminator) {
            this.newline(1, true);
          }
          if (printNewLines && skipNewLines !== 3) {
            this.newline(1);
          }
        }
        _printComments(type, comments, node, parent2, lineOffset = 0, nextToken) {
          const nodeLoc = node.loc;
          const len = comments.length;
          let hasLoc = !!nodeLoc;
          const nodeStartLine = hasLoc ? nodeLoc.start.line : 0;
          const nodeEndLine = hasLoc ? nodeLoc.end.line : 0;
          let lastLine = 0;
          let leadingCommentNewline = 0;
          const maybeNewline = this._noLineTerminator ? function() {
          } : this.newline.bind(this);
          for (let i = 0; i < len; i++) {
            const comment = comments[i];
            const shouldPrint = this._shouldPrintComment(comment, nextToken);
            if (shouldPrint === 2) {
              hasLoc = false;
              break;
            }
            if (hasLoc && comment.loc && shouldPrint === 1) {
              const commentStartLine = comment.loc.start.line;
              const commentEndLine = comment.loc.end.line;
              if (type === 0) {
                let offset = 0;
                if (i === 0) {
                  if (this._buf.hasContent() && (comment.type === "CommentLine" || commentStartLine !== commentEndLine)) {
                    offset = leadingCommentNewline = 1;
                  }
                } else {
                  offset = commentStartLine - lastLine;
                }
                lastLine = commentEndLine;
                maybeNewline(offset);
                this._printComment(comment, 1);
                if (i + 1 === len) {
                  maybeNewline(Math.max(nodeStartLine - lastLine, leadingCommentNewline));
                  lastLine = nodeStartLine;
                }
              } else if (type === 1) {
                const offset = commentStartLine - (i === 0 ? nodeStartLine : lastLine);
                lastLine = commentEndLine;
                maybeNewline(offset);
                this._printComment(comment, 1);
                if (i + 1 === len) {
                  maybeNewline(Math.min(1, nodeEndLine - lastLine));
                  lastLine = nodeEndLine;
                }
              } else {
                const offset = commentStartLine - (i === 0 ? nodeEndLine - lineOffset : lastLine);
                lastLine = commentEndLine;
                maybeNewline(offset);
                this._printComment(comment, 1);
              }
            } else {
              hasLoc = false;
              if (shouldPrint !== 1) {
                continue;
              }
              if (len === 1) {
                const singleLine = comment.loc ? comment.loc.start.line === comment.loc.end.line : !HAS_NEWLINE.test(comment.value);
                const shouldSkipNewline = singleLine && !isStatement(node) && !isClassBody(parent2) && !isTSInterfaceBody(parent2) && !isTSEnumMember(node);
                if (type === 0) {
                  this._printComment(comment, shouldSkipNewline && node.type !== "ObjectExpression" || singleLine && isFunction3(parent2, {
                    body: node
                  }) ? 1 : 0);
                } else if (shouldSkipNewline && type === 2) {
                  this._printComment(comment, 1);
                } else {
                  this._printComment(comment, 0);
                }
              } else if (type === 1 && !(node.type === "ObjectExpression" && node.properties.length > 1) && node.type !== "ClassBody" && node.type !== "TSInterfaceBody") {
                this._printComment(comment, i === 0 ? 2 : i === len - 1 ? 3 : 0);
              } else {
                this._printComment(comment, 0);
              }
            }
          }
          if (type === 2 && hasLoc && lastLine) {
            this._lastCommentLine = lastLine;
          }
        }
      };
      Object.assign(Printer.prototype, generatorFunctions);
      {
        (0, _deprecated.addDeprecatedGenerators)(Printer);
      }
      var _default = exports8.default = Printer;
      function commaSeparator(occurrenceCount, last2) {
        this.token(",", false, occurrenceCount);
        if (!last2)
          this.space();
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/index.js
  var require_lib6 = __commonJS({
    "../../node_modules/.pnpm/@babel+generator@7.28.3/node_modules/@babel/generator/lib/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      exports8.generate = generate4;
      var _sourceMap = require_source_map2();
      var _printer = require_printer();
      function normalizeOptions(code, opts, ast) {
        if (opts.experimental_preserveFormat) {
          if (typeof code !== "string") {
            throw new Error("`experimental_preserveFormat` requires the original `code` to be passed to @babel/generator as a string");
          }
          if (!opts.retainLines) {
            throw new Error("`experimental_preserveFormat` requires `retainLines` to be set to `true`");
          }
          if (opts.compact && opts.compact !== "auto") {
            throw new Error("`experimental_preserveFormat` is not compatible with the `compact` option");
          }
          if (opts.minified) {
            throw new Error("`experimental_preserveFormat` is not compatible with the `minified` option");
          }
          if (opts.jsescOption) {
            throw new Error("`experimental_preserveFormat` is not compatible with the `jsescOption` option");
          }
          if (!Array.isArray(ast.tokens)) {
            throw new Error("`experimental_preserveFormat` requires the AST to have attached the token of the input code. Make sure to enable the `tokens: true` parser option.");
          }
        }
        const format3 = {
          auxiliaryCommentBefore: opts.auxiliaryCommentBefore,
          auxiliaryCommentAfter: opts.auxiliaryCommentAfter,
          shouldPrintComment: opts.shouldPrintComment,
          preserveFormat: opts.experimental_preserveFormat,
          retainLines: opts.retainLines,
          retainFunctionParens: opts.retainFunctionParens,
          comments: opts.comments == null || opts.comments,
          compact: opts.compact,
          minified: opts.minified,
          concise: opts.concise,
          indent: {
            adjustMultilineComment: true,
            style: "  "
          },
          jsescOption: Object.assign({
            quotes: "double",
            wrap: true,
            minimal: false
          }, opts.jsescOption),
          topicToken: opts.topicToken,
          importAttributesKeyword: opts.importAttributesKeyword
        };
        {
          var _opts$recordAndTupleS;
          format3.decoratorsBeforeExport = opts.decoratorsBeforeExport;
          format3.jsescOption.json = opts.jsonCompatibleStrings;
          format3.recordAndTupleSyntaxType = (_opts$recordAndTupleS = opts.recordAndTupleSyntaxType) != null ? _opts$recordAndTupleS : "hash";
        }
        if (format3.minified) {
          format3.compact = true;
          format3.shouldPrintComment = format3.shouldPrintComment || (() => format3.comments);
        } else {
          format3.shouldPrintComment = format3.shouldPrintComment || ((value) => format3.comments || value.includes("@license") || value.includes("@preserve"));
        }
        if (format3.compact === "auto") {
          format3.compact = typeof code === "string" && code.length > 5e5;
          if (format3.compact) {
            console.error(`[BABEL] Note: The code generator has deoptimised the styling of ${opts.filename} as it exceeds the max of ${"500KB"}.`);
          }
        }
        if (format3.compact || format3.preserveFormat) {
          format3.indent.adjustMultilineComment = false;
        }
        const {
          auxiliaryCommentBefore,
          auxiliaryCommentAfter,
          shouldPrintComment
        } = format3;
        if (auxiliaryCommentBefore && !shouldPrintComment(auxiliaryCommentBefore)) {
          format3.auxiliaryCommentBefore = void 0;
        }
        if (auxiliaryCommentAfter && !shouldPrintComment(auxiliaryCommentAfter)) {
          format3.auxiliaryCommentAfter = void 0;
        }
        return format3;
      }
      {
        exports8.CodeGenerator = class CodeGenerator {
          constructor(ast, opts = {}, code) {
            this._ast = void 0;
            this._format = void 0;
            this._map = void 0;
            this._ast = ast;
            this._format = normalizeOptions(code, opts, ast);
            this._map = opts.sourceMaps ? new _sourceMap.default(opts, code) : null;
          }
          generate() {
            const printer = new _printer.default(this._format, this._map);
            return printer.generate(this._ast);
          }
        };
      }
      function generate4(ast, opts = {}, code) {
        const format3 = normalizeOptions(code, opts, ast);
        const map2 = opts.sourceMaps ? new _sourceMap.default(opts, code) : null;
        const printer = new _printer.default(format3, map2, ast.tokens, typeof code === "string" ? code : null);
        return printer.generate(ast);
      }
      var _default = exports8.default = generate4;
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/lib/virtual-types.js
  var require_virtual_types = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/lib/virtual-types.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.Var = exports8.User = exports8.Statement = exports8.SpreadProperty = exports8.Scope = exports8.RestProperty = exports8.ReferencedMemberExpression = exports8.ReferencedIdentifier = exports8.Referenced = exports8.Pure = exports8.NumericLiteralTypeAnnotation = exports8.Generated = exports8.ForAwaitStatement = exports8.Flow = exports8.Expression = exports8.ExistentialTypeParam = exports8.BlockScoped = exports8.BindingIdentifier = void 0;
      var ReferencedIdentifier = exports8.ReferencedIdentifier = ["Identifier", "JSXIdentifier"];
      var ReferencedMemberExpression = exports8.ReferencedMemberExpression = ["MemberExpression"];
      var BindingIdentifier = exports8.BindingIdentifier = ["Identifier"];
      var Statement = exports8.Statement = ["Statement"];
      var Expression = exports8.Expression = ["Expression"];
      var Scope2 = exports8.Scope = ["Scopable", "Pattern"];
      var Referenced = exports8.Referenced = null;
      var BlockScoped = exports8.BlockScoped = null;
      var Var = exports8.Var = ["VariableDeclaration"];
      var User = exports8.User = null;
      var Generated = exports8.Generated = null;
      var Pure = exports8.Pure = null;
      var Flow = exports8.Flow = ["Flow", "ImportDeclaration", "ExportDeclaration", "ImportSpecifier"];
      var RestProperty = exports8.RestProperty = ["RestElement"];
      var SpreadProperty = exports8.SpreadProperty = ["RestElement"];
      var ExistentialTypeParam = exports8.ExistentialTypeParam = ["ExistsTypeAnnotation"];
      var NumericLiteralTypeAnnotation = exports8.NumericLiteralTypeAnnotation = ["NumberLiteralTypeAnnotation"];
      var ForAwaitStatement = exports8.ForAwaitStatement = ["ForOfStatement"];
    }
  });

  // ../../node_modules/.pnpm/ms@2.1.3/node_modules/ms/index.js
  var require_ms2 = __commonJS({
    "../../node_modules/.pnpm/ms@2.1.3/node_modules/ms/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var s = 1e3;
      var m = s * 60;
      var h = m * 60;
      var d = h * 24;
      var w = d * 7;
      var y = d * 365.25;
      module2.exports = function(val, options) {
        options = options || {};
        var type = typeof val;
        if (type === "string" && val.length > 0) {
          return parse4(val);
        } else if (type === "number" && isFinite(val)) {
          return options.long ? fmtLong(val) : fmtShort(val);
        }
        throw new Error(
          "val is not a non-empty string or a valid number. val=" + JSON.stringify(val)
        );
      };
      function parse4(str) {
        str = String(str);
        if (str.length > 100) {
          return;
        }
        var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
          str
        );
        if (!match) {
          return;
        }
        var n = parseFloat(match[1]);
        var type = (match[2] || "ms").toLowerCase();
        switch (type) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return n * y;
          case "weeks":
          case "week":
          case "w":
            return n * w;
          case "days":
          case "day":
          case "d":
            return n * d;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return n * h;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return n * m;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return n * s;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return n;
          default:
            return void 0;
        }
      }
      function fmtShort(ms) {
        var msAbs = Math.abs(ms);
        if (msAbs >= d) {
          return Math.round(ms / d) + "d";
        }
        if (msAbs >= h) {
          return Math.round(ms / h) + "h";
        }
        if (msAbs >= m) {
          return Math.round(ms / m) + "m";
        }
        if (msAbs >= s) {
          return Math.round(ms / s) + "s";
        }
        return ms + "ms";
      }
      function fmtLong(ms) {
        var msAbs = Math.abs(ms);
        if (msAbs >= d) {
          return plural(ms, msAbs, d, "day");
        }
        if (msAbs >= h) {
          return plural(ms, msAbs, h, "hour");
        }
        if (msAbs >= m) {
          return plural(ms, msAbs, m, "minute");
        }
        if (msAbs >= s) {
          return plural(ms, msAbs, s, "second");
        }
        return ms + " ms";
      }
      function plural(ms, msAbs, n, name) {
        var isPlural = msAbs >= n * 1.5;
        return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
      }
    }
  });

  // ../../node_modules/.pnpm/debug@4.4.1_supports-color@6.1.0/node_modules/debug/src/common.js
  var require_common = __commonJS({
    "../../node_modules/.pnpm/debug@4.4.1_supports-color@6.1.0/node_modules/debug/src/common.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      function setup(env3) {
        createDebug.debug = createDebug;
        createDebug.default = createDebug;
        createDebug.coerce = coerce;
        createDebug.disable = disable;
        createDebug.enable = enable;
        createDebug.enabled = enabled;
        createDebug.humanize = require_ms2();
        createDebug.destroy = destroy;
        Object.keys(env3).forEach((key) => {
          createDebug[key] = env3[key];
        });
        createDebug.names = [];
        createDebug.skips = [];
        createDebug.formatters = {};
        function selectColor(namespace) {
          let hash = 0;
          for (let i = 0; i < namespace.length; i++) {
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0;
          }
          return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
        }
        createDebug.selectColor = selectColor;
        function createDebug(namespace) {
          let prevTime;
          let enableOverride = null;
          let namespacesCache;
          let enabledCache;
          function debug(...args) {
            if (!debug.enabled) {
              return;
            }
            const self2 = debug;
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self2.diff = ms;
            self2.prev = prevTime;
            self2.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== "string") {
              args.unshift("%O");
            }
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format3) => {
              if (match === "%%") {
                return "%";
              }
              index++;
              const formatter = createDebug.formatters[format3];
              if (typeof formatter === "function") {
                const val = args[index];
                match = formatter.call(self2, val);
                args.splice(index, 1);
                index--;
              }
              return match;
            });
            createDebug.formatArgs.call(self2, args);
            const logFn = self2.log || createDebug.log;
            logFn.apply(self2, args);
          }
          debug.namespace = namespace;
          debug.useColors = createDebug.useColors();
          debug.color = createDebug.selectColor(namespace);
          debug.extend = extend;
          debug.destroy = createDebug.destroy;
          Object.defineProperty(debug, "enabled", {
            enumerable: true,
            configurable: false,
            get: () => {
              if (enableOverride !== null) {
                return enableOverride;
              }
              if (namespacesCache !== createDebug.namespaces) {
                namespacesCache = createDebug.namespaces;
                enabledCache = createDebug.enabled(namespace);
              }
              return enabledCache;
            },
            set: (v) => {
              enableOverride = v;
            }
          });
          if (typeof createDebug.init === "function") {
            createDebug.init(debug);
          }
          return debug;
        }
        function extend(namespace, delimiter2) {
          const newDebug = createDebug(this.namespace + (typeof delimiter2 === "undefined" ? ":" : delimiter2) + namespace);
          newDebug.log = this.log;
          return newDebug;
        }
        function enable(namespaces) {
          createDebug.save(namespaces);
          createDebug.namespaces = namespaces;
          createDebug.names = [];
          createDebug.skips = [];
          const split2 = (typeof namespaces === "string" ? namespaces : "").trim().replace(/\s+/g, ",").split(",").filter(Boolean);
          for (const ns of split2) {
            if (ns[0] === "-") {
              createDebug.skips.push(ns.slice(1));
            } else {
              createDebug.names.push(ns);
            }
          }
        }
        function matchesTemplate(search, template2) {
          let searchIndex = 0;
          let templateIndex = 0;
          let starIndex = -1;
          let matchIndex = 0;
          while (searchIndex < search.length) {
            if (templateIndex < template2.length && (template2[templateIndex] === search[searchIndex] || template2[templateIndex] === "*")) {
              if (template2[templateIndex] === "*") {
                starIndex = templateIndex;
                matchIndex = searchIndex;
                templateIndex++;
              } else {
                searchIndex++;
                templateIndex++;
              }
            } else if (starIndex !== -1) {
              templateIndex = starIndex + 1;
              matchIndex++;
              searchIndex = matchIndex;
            } else {
              return false;
            }
          }
          while (templateIndex < template2.length && template2[templateIndex] === "*") {
            templateIndex++;
          }
          return templateIndex === template2.length;
        }
        function disable() {
          const namespaces = [
            ...createDebug.names,
            ...createDebug.skips.map((namespace) => "-" + namespace)
          ].join(",");
          createDebug.enable("");
          return namespaces;
        }
        function enabled(name) {
          for (const skip of createDebug.skips) {
            if (matchesTemplate(name, skip)) {
              return false;
            }
          }
          for (const ns of createDebug.names) {
            if (matchesTemplate(name, ns)) {
              return true;
            }
          }
          return false;
        }
        function coerce(val) {
          if (val instanceof Error) {
            return val.stack || val.message;
          }
          return val;
        }
        function destroy() {
          console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
        createDebug.enable(createDebug.load());
        return createDebug;
      }
      module2.exports = setup;
    }
  });

  // ../../node_modules/.pnpm/debug@4.4.1_supports-color@6.1.0/node_modules/debug/src/browser.js
  var require_browser2 = __commonJS({
    "../../node_modules/.pnpm/debug@4.4.1_supports-color@6.1.0/node_modules/debug/src/browser.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      exports8.formatArgs = formatArgs;
      exports8.save = save;
      exports8.load = load;
      exports8.useColors = useColors;
      exports8.storage = localstorage();
      exports8.destroy = (() => {
        let warned = false;
        return () => {
          if (!warned) {
            warned = true;
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
          }
        };
      })();
      exports8.colors = [
        "#0000CC",
        "#0000FF",
        "#0033CC",
        "#0033FF",
        "#0066CC",
        "#0066FF",
        "#0099CC",
        "#0099FF",
        "#00CC00",
        "#00CC33",
        "#00CC66",
        "#00CC99",
        "#00CCCC",
        "#00CCFF",
        "#3300CC",
        "#3300FF",
        "#3333CC",
        "#3333FF",
        "#3366CC",
        "#3366FF",
        "#3399CC",
        "#3399FF",
        "#33CC00",
        "#33CC33",
        "#33CC66",
        "#33CC99",
        "#33CCCC",
        "#33CCFF",
        "#6600CC",
        "#6600FF",
        "#6633CC",
        "#6633FF",
        "#66CC00",
        "#66CC33",
        "#9900CC",
        "#9900FF",
        "#9933CC",
        "#9933FF",
        "#99CC00",
        "#99CC33",
        "#CC0000",
        "#CC0033",
        "#CC0066",
        "#CC0099",
        "#CC00CC",
        "#CC00FF",
        "#CC3300",
        "#CC3333",
        "#CC3366",
        "#CC3399",
        "#CC33CC",
        "#CC33FF",
        "#CC6600",
        "#CC6633",
        "#CC9900",
        "#CC9933",
        "#CCCC00",
        "#CCCC33",
        "#FF0000",
        "#FF0033",
        "#FF0066",
        "#FF0099",
        "#FF00CC",
        "#FF00FF",
        "#FF3300",
        "#FF3333",
        "#FF3366",
        "#FF3399",
        "#FF33CC",
        "#FF33FF",
        "#FF6600",
        "#FF6633",
        "#FF9900",
        "#FF9933",
        "#FFCC00",
        "#FFCC33"
      ];
      function useColors() {
        if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) {
          return true;
        }
        if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
          return false;
        }
        let m;
        return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator !== "undefined" && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31 || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
      }
      function formatArgs(args) {
        args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module2.exports.humanize(this.diff);
        if (!this.useColors) {
          return;
        }
        const c = "color: " + this.color;
        args.splice(1, 0, c, "color: inherit");
        let index = 0;
        let lastC = 0;
        args[0].replace(/%[a-zA-Z%]/g, (match) => {
          if (match === "%%") {
            return;
          }
          index++;
          if (match === "%c") {
            lastC = index;
          }
        });
        args.splice(lastC, 0, c);
      }
      exports8.log = console.debug || console.log || (() => {
      });
      function save(namespaces) {
        try {
          if (namespaces) {
            exports8.storage.setItem("debug", namespaces);
          } else {
            exports8.storage.removeItem("debug");
          }
        } catch (error) {
        }
      }
      function load() {
        let r;
        try {
          r = exports8.storage.getItem("debug") || exports8.storage.getItem("DEBUG");
        } catch (error) {
        }
        if (!r && typeof define_process_default !== "undefined" && "env" in define_process_default) {
          r = define_process_default.env.DEBUG;
        }
        return r;
      }
      function localstorage() {
        try {
          return localStorage;
        } catch (error) {
        }
      }
      module2.exports = require_common()(exports8);
      var { formatters } = module2.exports;
      formatters.j = function(v) {
        try {
          return JSON.stringify(v);
        } catch (error) {
          return "[UnexpectedJSONParseError]: " + error.message;
        }
      };
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/lib/virtual-types-validator.js
  var require_virtual_types_validator = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/lib/virtual-types-validator.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.isBindingIdentifier = isBindingIdentifier;
      exports8.isBlockScoped = isBlockScoped;
      exports8.isExpression = isExpression;
      exports8.isFlow = isFlow;
      exports8.isForAwaitStatement = isForAwaitStatement;
      exports8.isGenerated = isGenerated;
      exports8.isPure = isPure;
      exports8.isReferenced = isReferenced;
      exports8.isReferencedIdentifier = isReferencedIdentifier;
      exports8.isReferencedMemberExpression = isReferencedMemberExpression;
      exports8.isRestProperty = isRestProperty;
      exports8.isScope = isScope;
      exports8.isSpreadProperty = isSpreadProperty;
      exports8.isStatement = isStatement;
      exports8.isUser = isUser;
      exports8.isVar = isVar;
      var _t = require_lib5();
      var {
        isBinding,
        isBlockScoped: nodeIsBlockScoped,
        isExportDeclaration,
        isExpression: nodeIsExpression,
        isFlow: nodeIsFlow,
        isForStatement,
        isForXStatement,
        isIdentifier: isIdentifier2,
        isImportDeclaration,
        isImportSpecifier,
        isJSXIdentifier,
        isJSXMemberExpression,
        isMemberExpression,
        isRestElement: nodeIsRestElement,
        isReferenced: nodeIsReferenced,
        isScope: nodeIsScope,
        isStatement: nodeIsStatement,
        isVar: nodeIsVar,
        isVariableDeclaration,
        react,
        isForOfStatement
      } = _t;
      var {
        isCompatTag
      } = react;
      function isReferencedIdentifier(opts) {
        const {
          node,
          parent: parent2
        } = this;
        if (!isIdentifier2(node, opts) && !isJSXMemberExpression(parent2, opts)) {
          if (isJSXIdentifier(node, opts)) {
            if (isCompatTag(node.name))
              return false;
          } else {
            return false;
          }
        }
        return nodeIsReferenced(node, parent2, this.parentPath.parent);
      }
      function isReferencedMemberExpression() {
        const {
          node,
          parent: parent2
        } = this;
        return isMemberExpression(node) && nodeIsReferenced(node, parent2);
      }
      function isBindingIdentifier() {
        const {
          node,
          parent: parent2
        } = this;
        const grandparent = this.parentPath.parent;
        return isIdentifier2(node) && isBinding(node, parent2, grandparent);
      }
      function isStatement() {
        const {
          node,
          parent: parent2
        } = this;
        if (nodeIsStatement(node)) {
          if (isVariableDeclaration(node)) {
            if (isForXStatement(parent2, {
              left: node
            }))
              return false;
            if (isForStatement(parent2, {
              init: node
            }))
              return false;
          }
          return true;
        } else {
          return false;
        }
      }
      function isExpression() {
        if (this.isIdentifier()) {
          return this.isReferencedIdentifier();
        } else {
          return nodeIsExpression(this.node);
        }
      }
      function isScope() {
        return nodeIsScope(this.node, this.parent);
      }
      function isReferenced() {
        return nodeIsReferenced(this.node, this.parent);
      }
      function isBlockScoped() {
        return nodeIsBlockScoped(this.node);
      }
      function isVar() {
        return nodeIsVar(this.node);
      }
      function isUser() {
        return this.node && !!this.node.loc;
      }
      function isGenerated() {
        return !this.isUser();
      }
      function isPure(constantsOnly) {
        return this.scope.isPure(this.node, constantsOnly);
      }
      function isFlow() {
        const {
          node
        } = this;
        if (nodeIsFlow(node)) {
          return true;
        } else if (isImportDeclaration(node)) {
          return node.importKind === "type" || node.importKind === "typeof";
        } else if (isExportDeclaration(node)) {
          return node.exportKind === "type";
        } else if (isImportSpecifier(node)) {
          return node.importKind === "type" || node.importKind === "typeof";
        } else {
          return false;
        }
      }
      function isRestProperty() {
        var _this$parentPath;
        return nodeIsRestElement(this.node) && ((_this$parentPath = this.parentPath) == null ? void 0 : _this$parentPath.isObjectPattern());
      }
      function isSpreadProperty() {
        var _this$parentPath2;
        return nodeIsRestElement(this.node) && ((_this$parentPath2 = this.parentPath) == null ? void 0 : _this$parentPath2.isObjectExpression());
      }
      function isForAwaitStatement() {
        return isForOfStatement(this.node, {
          await: true
        });
      }
      {
        exports8.isExistentialTypeParam = function isExistentialTypeParam() {
          throw new Error("`path.isExistentialTypeParam` has been renamed to `path.isExistsTypeAnnotation()` in Babel 7.");
        };
        exports8.isNumericLiteralTypeAnnotation = function isNumericLiteralTypeAnnotation() {
          throw new Error("`path.isNumericLiteralTypeAnnotation()` has been renamed to `path.isNumberLiteralTypeAnnotation()` in Babel 7.");
        };
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/visitors.js
  var require_visitors = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/visitors.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.environmentVisitor = environmentVisitor;
      exports8.explode = explode$1;
      exports8.isExplodedVisitor = isExplodedVisitor;
      exports8.merge = merge2;
      exports8.verify = verify$1;
      var virtualTypes = require_virtual_types();
      var virtualTypesValidators = require_virtual_types_validator();
      var _t = require_lib5();
      var _context = require_context2();
      var {
        DEPRECATED_KEYS,
        DEPRECATED_ALIASES,
        FLIPPED_ALIAS_KEYS,
        TYPES,
        __internal__deprecationWarning: deprecationWarning
      } = _t;
      function isVirtualType(type) {
        return type in virtualTypes;
      }
      function isExplodedVisitor(visitor) {
        return visitor == null ? void 0 : visitor._exploded;
      }
      function explode$1(visitor) {
        if (isExplodedVisitor(visitor))
          return visitor;
        visitor._exploded = true;
        for (const nodeType of Object.keys(visitor)) {
          if (shouldIgnoreKey(nodeType))
            continue;
          const parts = nodeType.split("|");
          if (parts.length === 1)
            continue;
          const fns = visitor[nodeType];
          delete visitor[nodeType];
          for (const part of parts) {
            visitor[part] = fns;
          }
        }
        verify$1(visitor);
        delete visitor.__esModule;
        ensureEntranceObjects(visitor);
        ensureCallbackArrays(visitor);
        for (const nodeType of Object.keys(visitor)) {
          if (shouldIgnoreKey(nodeType))
            continue;
          if (!isVirtualType(nodeType))
            continue;
          const fns = visitor[nodeType];
          for (const type of Object.keys(fns)) {
            fns[type] = wrapCheck(nodeType, fns[type]);
          }
          delete visitor[nodeType];
          const types2 = virtualTypes[nodeType];
          if (types2 !== null) {
            for (const type of types2) {
              if (visitor[type]) {
                mergePair(visitor[type], fns);
              } else {
                visitor[type] = fns;
              }
            }
          } else {
            mergePair(visitor, fns);
          }
        }
        for (const nodeType of Object.keys(visitor)) {
          if (shouldIgnoreKey(nodeType))
            continue;
          let aliases = FLIPPED_ALIAS_KEYS[nodeType];
          if (nodeType in DEPRECATED_KEYS) {
            const deprecatedKey = DEPRECATED_KEYS[nodeType];
            deprecationWarning(nodeType, deprecatedKey, "Visitor ");
            aliases = [deprecatedKey];
          } else if (nodeType in DEPRECATED_ALIASES) {
            const deprecatedAlias = DEPRECATED_ALIASES[nodeType];
            deprecationWarning(nodeType, deprecatedAlias, "Visitor ");
            aliases = FLIPPED_ALIAS_KEYS[deprecatedAlias];
          }
          if (!aliases)
            continue;
          const fns = visitor[nodeType];
          delete visitor[nodeType];
          for (const alias of aliases) {
            const existing = visitor[alias];
            if (existing) {
              mergePair(existing, fns);
            } else {
              visitor[alias] = Object.assign({}, fns);
            }
          }
        }
        for (const nodeType of Object.keys(visitor)) {
          if (shouldIgnoreKey(nodeType))
            continue;
          ensureCallbackArrays(visitor[nodeType]);
        }
        return visitor;
      }
      function verify$1(visitor) {
        if (visitor._verified)
          return;
        if (typeof visitor === "function") {
          throw new Error("You passed `traverse()` a function when it expected a visitor object, are you sure you didn't mean `{ enter: Function }`?");
        }
        for (const nodeType of Object.keys(visitor)) {
          if (nodeType === "enter" || nodeType === "exit") {
            validateVisitorMethods(nodeType, visitor[nodeType]);
          }
          if (shouldIgnoreKey(nodeType))
            continue;
          if (!TYPES.includes(nodeType)) {
            throw new Error(`You gave us a visitor for the node type ${nodeType} but it's not a valid type in @babel/traverse ${"7.28.3"}`);
          }
          const visitors = visitor[nodeType];
          if (typeof visitors === "object") {
            for (const visitorKey of Object.keys(visitors)) {
              if (visitorKey === "enter" || visitorKey === "exit") {
                validateVisitorMethods(`${nodeType}.${visitorKey}`, visitors[visitorKey]);
              } else {
                throw new Error(`You passed \`traverse()\` a visitor object with the property ${nodeType} that has the invalid property ${visitorKey}`);
              }
            }
          }
        }
        visitor._verified = true;
      }
      function validateVisitorMethods(path, val) {
        const fns = [].concat(val);
        for (const fn of fns) {
          if (typeof fn !== "function") {
            throw new TypeError(`Non-function found defined in ${path} with type ${typeof fn}`);
          }
        }
      }
      function merge2(visitors, states = [], wrapper) {
        const mergedVisitor = {
          _verified: true,
          _exploded: true
        };
        {
          Object.defineProperty(mergedVisitor, "_exploded", {
            enumerable: false
          });
          Object.defineProperty(mergedVisitor, "_verified", {
            enumerable: false
          });
        }
        for (let i = 0; i < visitors.length; i++) {
          const visitor = explode$1(visitors[i]);
          const state = states[i];
          let topVisitor = visitor;
          if (state || wrapper) {
            topVisitor = wrapWithStateOrWrapper(topVisitor, state, wrapper);
          }
          mergePair(mergedVisitor, topVisitor);
          for (const key of Object.keys(visitor)) {
            if (shouldIgnoreKey(key))
              continue;
            let typeVisitor = visitor[key];
            if (state || wrapper) {
              typeVisitor = wrapWithStateOrWrapper(typeVisitor, state, wrapper);
            }
            const nodeVisitor = mergedVisitor[key] || (mergedVisitor[key] = {});
            mergePair(nodeVisitor, typeVisitor);
          }
        }
        return mergedVisitor;
      }
      function wrapWithStateOrWrapper(oldVisitor, state, wrapper) {
        const newVisitor = {};
        for (const phase of ["enter", "exit"]) {
          let fns = oldVisitor[phase];
          if (!Array.isArray(fns))
            continue;
          fns = fns.map(function(fn) {
            let newFn = fn;
            if (state) {
              newFn = function(path) {
                fn.call(state, path, state);
              };
            }
            if (wrapper) {
              newFn = wrapper(state == null ? void 0 : state.key, phase, newFn);
            }
            if (newFn !== fn) {
              newFn.toString = () => fn.toString();
            }
            return newFn;
          });
          newVisitor[phase] = fns;
        }
        return newVisitor;
      }
      function ensureEntranceObjects(obj) {
        for (const key of Object.keys(obj)) {
          if (shouldIgnoreKey(key))
            continue;
          const fns = obj[key];
          if (typeof fns === "function") {
            obj[key] = {
              enter: fns
            };
          }
        }
      }
      function ensureCallbackArrays(obj) {
        if (obj.enter && !Array.isArray(obj.enter))
          obj.enter = [obj.enter];
        if (obj.exit && !Array.isArray(obj.exit))
          obj.exit = [obj.exit];
      }
      function wrapCheck(nodeType, fn) {
        const fnKey = `is${nodeType}`;
        const validator = virtualTypesValidators[fnKey];
        const newFn = function(path) {
          if (validator.call(path)) {
            return fn.apply(this, arguments);
          }
        };
        newFn.toString = () => fn.toString();
        return newFn;
      }
      function shouldIgnoreKey(key) {
        if (key[0] === "_")
          return true;
        if (key === "enter" || key === "exit" || key === "shouldSkip")
          return true;
        if (key === "denylist" || key === "noScope" || key === "skipKeys") {
          return true;
        }
        {
          if (key === "blacklist") {
            return true;
          }
        }
        return false;
      }
      function mergePair(dest, src) {
        for (const phase of ["enter", "exit"]) {
          if (!src[phase])
            continue;
          dest[phase] = [].concat(dest[phase] || [], src[phase]);
        }
      }
      var _environmentVisitor = {
        FunctionParent(path) {
          if (path.isArrowFunctionExpression())
            return;
          path.skip();
          if (path.isMethod()) {
            if (!path.requeueComputedKeyAndDecorators) {
              _context.requeueComputedKeyAndDecorators.call(path);
            } else {
              path.requeueComputedKeyAndDecorators();
            }
          }
        },
        Property(path) {
          if (path.isObjectProperty())
            return;
          path.skip();
          if (!path.requeueComputedKeyAndDecorators) {
            _context.requeueComputedKeyAndDecorators.call(path);
          } else {
            path.requeueComputedKeyAndDecorators();
          }
        }
      };
      function environmentVisitor(visitor) {
        return merge2([_environmentVisitor, visitor]);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/scope/lib/renamer.js
  var require_renamer = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/scope/lib/renamer.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      var t3 = require_lib5();
      var _t = t3;
      var _traverseNode = require_traverse_node();
      var _visitors = require_visitors();
      var _context = require_context2();
      var {
        getAssignmentIdentifiers
      } = _t;
      var renameVisitor = {
        ReferencedIdentifier({
          node
        }, state) {
          if (node.name === state.oldName) {
            node.name = state.newName;
          }
        },
        Scope(path, state) {
          if (!path.scope.bindingIdentifierEquals(state.oldName, state.binding.identifier)) {
            path.skip();
            if (path.isMethod()) {
              if (!path.requeueComputedKeyAndDecorators) {
                _context.requeueComputedKeyAndDecorators.call(path);
              } else {
                path.requeueComputedKeyAndDecorators();
              }
            }
          }
        },
        ObjectProperty({
          node,
          scope
        }, state) {
          const {
            name
          } = node.key;
          if (node.shorthand && (name === state.oldName || name === state.newName) && scope.getBindingIdentifier(name) === state.binding.identifier) {
            node.shorthand = false;
            {
              var _node$extra;
              if ((_node$extra = node.extra) != null && _node$extra.shorthand)
                node.extra.shorthand = false;
            }
          }
        },
        "AssignmentExpression|Declaration|VariableDeclarator"(path, state) {
          if (path.isVariableDeclaration())
            return;
          const ids = path.isAssignmentExpression() ? getAssignmentIdentifiers(path.node) : path.getOuterBindingIdentifiers();
          for (const name in ids) {
            if (name === state.oldName)
              ids[name].name = state.newName;
          }
        }
      };
      var Renamer = class {
        constructor(binding3, oldName, newName) {
          this.newName = newName;
          this.oldName = oldName;
          this.binding = binding3;
        }
        maybeConvertFromExportDeclaration(parentDeclar) {
          const maybeExportDeclar = parentDeclar.parentPath;
          if (!maybeExportDeclar.isExportDeclaration()) {
            return;
          }
          if (maybeExportDeclar.isExportDefaultDeclaration()) {
            const {
              declaration
            } = maybeExportDeclar.node;
            if (t3.isDeclaration(declaration) && !declaration.id) {
              return;
            }
          }
          if (maybeExportDeclar.isExportAllDeclaration()) {
            return;
          }
          maybeExportDeclar.splitExportDeclaration();
        }
        maybeConvertFromClassFunctionDeclaration(path) {
          return path;
        }
        maybeConvertFromClassFunctionExpression(path) {
          return path;
        }
        rename() {
          const {
            binding: binding3,
            oldName,
            newName
          } = this;
          const {
            scope,
            path
          } = binding3;
          const parentDeclar = path.find((path2) => path2.isDeclaration() || path2.isFunctionExpression() || path2.isClassExpression());
          if (parentDeclar) {
            const bindingIds = parentDeclar.getOuterBindingIdentifiers();
            if (bindingIds[oldName] === binding3.identifier) {
              this.maybeConvertFromExportDeclaration(parentDeclar);
            }
          }
          const blockToTraverse = arguments[0] || scope.block;
          const skipKeys = {
            discriminant: true
          };
          if (t3.isMethod(blockToTraverse)) {
            if (blockToTraverse.computed) {
              skipKeys.key = true;
            }
            if (!t3.isObjectMethod(blockToTraverse)) {
              skipKeys.decorators = true;
            }
          }
          (0, _traverseNode.traverseNode)(blockToTraverse, (0, _visitors.explode)(renameVisitor), scope, this, scope.path, skipKeys);
          if (!arguments[0]) {
            scope.removeOwnBinding(oldName);
            scope.bindings[newName] = binding3;
            this.binding.identifier.name = newName;
          }
          if (parentDeclar) {
            this.maybeConvertFromClassFunctionDeclaration(path);
            this.maybeConvertFromClassFunctionExpression(path);
          }
        }
      };
      exports8.default = Renamer;
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/scope/binding.js
  var require_binding = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/scope/binding.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      var Binding = class {
        constructor({
          identifier: identifier3,
          scope,
          path,
          kind
        }) {
          this.identifier = void 0;
          this.scope = void 0;
          this.path = void 0;
          this.kind = void 0;
          this.constantViolations = [];
          this.constant = true;
          this.referencePaths = [];
          this.referenced = false;
          this.references = 0;
          this.identifier = identifier3;
          this.scope = scope;
          this.path = path;
          this.kind = kind;
          if ((kind === "var" || kind === "hoisted") && isInitInLoop(path)) {
            this.reassign(path);
          }
          this.clearValue();
        }
        deoptValue() {
          this.clearValue();
          this.hasDeoptedValue = true;
        }
        setValue(value) {
          if (this.hasDeoptedValue)
            return;
          this.hasValue = true;
          this.value = value;
        }
        clearValue() {
          this.hasDeoptedValue = false;
          this.hasValue = false;
          this.value = null;
        }
        reassign(path) {
          this.constant = false;
          if (this.constantViolations.includes(path)) {
            return;
          }
          this.constantViolations.push(path);
        }
        reference(path) {
          if (this.referencePaths.includes(path)) {
            return;
          }
          this.referenced = true;
          this.references++;
          this.referencePaths.push(path);
        }
        dereference() {
          this.references--;
          this.referenced = !!this.references;
        }
      };
      exports8.default = Binding;
      function isInitInLoop(path) {
        const isFunctionDeclarationOrHasInit = !path.isVariableDeclarator() || path.node.init;
        for (let {
          parentPath,
          key
        } = path; parentPath; {
          parentPath,
          key
        } = parentPath) {
          if (parentPath.isFunctionParent())
            return false;
          if (key === "left" && parentPath.isForXStatement() || isFunctionDeclarationOrHasInit && key === "body" && parentPath.isLoop()) {
            return true;
          }
        }
        return false;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/cache.js
  var require_cache2 = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/cache.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.clear = clear;
      exports8.clearPath = clearPath;
      exports8.clearScope = clearScope;
      exports8.getCachedPaths = getCachedPaths;
      exports8.getOrCreateCachedPaths = getOrCreateCachedPaths;
      exports8.scope = exports8.path = void 0;
      var pathsCache = exports8.path = /* @__PURE__ */ new WeakMap();
      var scope = exports8.scope = /* @__PURE__ */ new WeakMap();
      function clear() {
        clearPath();
        clearScope();
      }
      function clearPath() {
        exports8.path = pathsCache = /* @__PURE__ */ new WeakMap();
      }
      function clearScope() {
        exports8.scope = scope = /* @__PURE__ */ new WeakMap();
      }
      function getCachedPaths(path) {
        const {
          parent: parent2,
          parentPath
        } = path;
        return pathsCache.get(parent2);
      }
      function getOrCreateCachedPaths(node, parentPath) {
        ;
        let paths = pathsCache.get(node);
        if (!paths)
          pathsCache.set(node, paths = /* @__PURE__ */ new Map());
        return paths;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+helper-globals@7.28.0/node_modules/@babel/helper-globals/data/builtin-lower.json
  var require_builtin_lower = __commonJS({
    "../../node_modules/.pnpm/@babel+helper-globals@7.28.0/node_modules/@babel/helper-globals/data/builtin-lower.json"(exports8, module2) {
      module2.exports = [
        "decodeURI",
        "decodeURIComponent",
        "encodeURI",
        "encodeURIComponent",
        "escape",
        "eval",
        "globalThis",
        "isFinite",
        "isNaN",
        "parseFloat",
        "parseInt",
        "undefined",
        "unescape"
      ];
    }
  });

  // ../../node_modules/.pnpm/@babel+helper-globals@7.28.0/node_modules/@babel/helper-globals/data/builtin-upper.json
  var require_builtin_upper = __commonJS({
    "../../node_modules/.pnpm/@babel+helper-globals@7.28.0/node_modules/@babel/helper-globals/data/builtin-upper.json"(exports8, module2) {
      module2.exports = [
        "AggregateError",
        "Array",
        "ArrayBuffer",
        "Atomics",
        "BigInt",
        "BigInt64Array",
        "BigUint64Array",
        "Boolean",
        "DataView",
        "Date",
        "Error",
        "EvalError",
        "FinalizationRegistry",
        "Float16Array",
        "Float32Array",
        "Float64Array",
        "Function",
        "Infinity",
        "Int16Array",
        "Int32Array",
        "Int8Array",
        "Intl",
        "Iterator",
        "JSON",
        "Map",
        "Math",
        "NaN",
        "Number",
        "Object",
        "Promise",
        "Proxy",
        "RangeError",
        "ReferenceError",
        "Reflect",
        "RegExp",
        "Set",
        "SharedArrayBuffer",
        "String",
        "Symbol",
        "SyntaxError",
        "TypeError",
        "Uint16Array",
        "Uint32Array",
        "Uint8Array",
        "Uint8ClampedArray",
        "URIError",
        "WeakMap",
        "WeakRef",
        "WeakSet"
      ];
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/scope/index.js
  var require_scope = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/scope/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      var _renamer = require_renamer();
      var _index = require_lib9();
      var _binding = require_binding();
      var _t = require_lib5();
      var t3 = _t;
      var _cache = require_cache2();
      var globalsBuiltinLower = require_builtin_lower();
      var globalsBuiltinUpper = require_builtin_upper();
      var {
        assignmentExpression,
        callExpression,
        cloneNode,
        getBindingIdentifiers,
        identifier: identifier3,
        isArrayExpression,
        isBinary,
        isCallExpression,
        isClass,
        isClassBody,
        isClassDeclaration,
        isExportAllDeclaration,
        isExportDefaultDeclaration,
        isExportNamedDeclaration,
        isFunctionDeclaration,
        isIdentifier: isIdentifier2,
        isImportDeclaration,
        isLiteral,
        isMemberExpression,
        isMethod,
        isModuleSpecifier,
        isNullLiteral,
        isObjectExpression,
        isProperty,
        isPureish,
        isRegExpLiteral,
        isSuper,
        isTaggedTemplateExpression,
        isTemplateLiteral,
        isThisExpression,
        isUnaryExpression,
        isVariableDeclaration,
        expressionStatement: expressionStatement2,
        matchesPattern,
        memberExpression,
        numericLiteral,
        toIdentifier,
        variableDeclaration,
        variableDeclarator,
        isRecordExpression,
        isTupleExpression,
        isObjectProperty,
        isTopicReference,
        isMetaProperty,
        isPrivateName,
        isExportDeclaration,
        buildUndefinedNode,
        sequenceExpression
      } = _t;
      function gatherNodeParts(node, parts) {
        switch (node == null ? void 0 : node.type) {
          default:
            if (isImportDeclaration(node) || isExportDeclaration(node)) {
              var _node$specifiers;
              if ((isExportAllDeclaration(node) || isExportNamedDeclaration(node) || isImportDeclaration(node)) && node.source) {
                gatherNodeParts(node.source, parts);
              } else if ((isExportNamedDeclaration(node) || isImportDeclaration(node)) && (_node$specifiers = node.specifiers) != null && _node$specifiers.length) {
                for (const e of node.specifiers)
                  gatherNodeParts(e, parts);
              } else if ((isExportDefaultDeclaration(node) || isExportNamedDeclaration(node)) && node.declaration) {
                gatherNodeParts(node.declaration, parts);
              }
            } else if (isModuleSpecifier(node)) {
              gatherNodeParts(node.local, parts);
            } else if (isLiteral(node) && !isNullLiteral(node) && !isRegExpLiteral(node) && !isTemplateLiteral(node)) {
              parts.push(node.value);
            }
            break;
          case "MemberExpression":
          case "OptionalMemberExpression":
          case "JSXMemberExpression":
            gatherNodeParts(node.object, parts);
            gatherNodeParts(node.property, parts);
            break;
          case "Identifier":
          case "JSXIdentifier":
            parts.push(node.name);
            break;
          case "CallExpression":
          case "OptionalCallExpression":
          case "NewExpression":
            gatherNodeParts(node.callee, parts);
            break;
          case "ObjectExpression":
          case "ObjectPattern":
            for (const e of node.properties) {
              gatherNodeParts(e, parts);
            }
            break;
          case "SpreadElement":
          case "RestElement":
            gatherNodeParts(node.argument, parts);
            break;
          case "ObjectProperty":
          case "ObjectMethod":
          case "ClassProperty":
          case "ClassMethod":
          case "ClassPrivateProperty":
          case "ClassPrivateMethod":
            gatherNodeParts(node.key, parts);
            break;
          case "ThisExpression":
            parts.push("this");
            break;
          case "Super":
            parts.push("super");
            break;
          case "Import":
          case "ImportExpression":
            parts.push("import");
            break;
          case "DoExpression":
            parts.push("do");
            break;
          case "YieldExpression":
            parts.push("yield");
            gatherNodeParts(node.argument, parts);
            break;
          case "AwaitExpression":
            parts.push("await");
            gatherNodeParts(node.argument, parts);
            break;
          case "AssignmentExpression":
            gatherNodeParts(node.left, parts);
            break;
          case "VariableDeclarator":
            gatherNodeParts(node.id, parts);
            break;
          case "FunctionExpression":
          case "FunctionDeclaration":
          case "ClassExpression":
          case "ClassDeclaration":
            gatherNodeParts(node.id, parts);
            break;
          case "PrivateName":
            gatherNodeParts(node.id, parts);
            break;
          case "ParenthesizedExpression":
            gatherNodeParts(node.expression, parts);
            break;
          case "UnaryExpression":
          case "UpdateExpression":
            gatherNodeParts(node.argument, parts);
            break;
          case "MetaProperty":
            gatherNodeParts(node.meta, parts);
            gatherNodeParts(node.property, parts);
            break;
          case "JSXElement":
            gatherNodeParts(node.openingElement, parts);
            break;
          case "JSXOpeningElement":
            gatherNodeParts(node.name, parts);
            break;
          case "JSXFragment":
            gatherNodeParts(node.openingFragment, parts);
            break;
          case "JSXOpeningFragment":
            parts.push("Fragment");
            break;
          case "JSXNamespacedName":
            gatherNodeParts(node.namespace, parts);
            gatherNodeParts(node.name, parts);
            break;
        }
      }
      function resetScope(scope) {
        {
          scope.references = /* @__PURE__ */ Object.create(null);
          scope.uids = /* @__PURE__ */ Object.create(null);
        }
        scope.bindings = /* @__PURE__ */ Object.create(null);
        scope.globals = /* @__PURE__ */ Object.create(null);
      }
      {
        NOT_LOCAL_BINDING = Symbol.for("should not be considered a local binding");
      }
      var NOT_LOCAL_BINDING;
      var collectorVisitor = {
        ForStatement(path) {
          const declar = path.get("init");
          if (declar.isVar()) {
            const {
              scope
            } = path;
            const parentScope = scope.getFunctionParent() || scope.getProgramParent();
            parentScope.registerBinding("var", declar);
          }
        },
        Declaration(path) {
          if (path.isBlockScoped())
            return;
          if (path.isImportDeclaration())
            return;
          if (path.isExportDeclaration())
            return;
          const parent2 = path.scope.getFunctionParent() || path.scope.getProgramParent();
          parent2.registerDeclaration(path);
        },
        ImportDeclaration(path) {
          const parent2 = path.scope.getBlockParent();
          parent2.registerDeclaration(path);
        },
        TSImportEqualsDeclaration(path) {
          const parent2 = path.scope.getBlockParent();
          parent2.registerDeclaration(path);
        },
        ReferencedIdentifier(path, state) {
          if (t3.isTSQualifiedName(path.parent) && path.parent.right === path.node) {
            return;
          }
          if (path.parentPath.isTSImportEqualsDeclaration())
            return;
          state.references.push(path);
        },
        ForXStatement(path, state) {
          const left = path.get("left");
          if (left.isPattern() || left.isIdentifier()) {
            state.constantViolations.push(path);
          } else if (left.isVar()) {
            const {
              scope
            } = path;
            const parentScope = scope.getFunctionParent() || scope.getProgramParent();
            parentScope.registerBinding("var", left);
          }
        },
        ExportDeclaration: {
          exit(path) {
            const {
              node,
              scope
            } = path;
            if (isExportAllDeclaration(node))
              return;
            const declar = node.declaration;
            if (isClassDeclaration(declar) || isFunctionDeclaration(declar)) {
              const id = declar.id;
              if (!id)
                return;
              const binding3 = scope.getBinding(id.name);
              binding3 == null || binding3.reference(path);
            } else if (isVariableDeclaration(declar)) {
              for (const decl of declar.declarations) {
                for (const name of Object.keys(getBindingIdentifiers(decl))) {
                  const binding3 = scope.getBinding(name);
                  binding3 == null || binding3.reference(path);
                }
              }
            }
          }
        },
        LabeledStatement(path) {
          path.scope.getBlockParent().registerDeclaration(path);
        },
        AssignmentExpression(path, state) {
          state.assignments.push(path);
        },
        UpdateExpression(path, state) {
          state.constantViolations.push(path);
        },
        UnaryExpression(path, state) {
          if (path.node.operator === "delete") {
            state.constantViolations.push(path);
          }
        },
        BlockScoped(path) {
          let scope = path.scope;
          if (scope.path === path)
            scope = scope.parent;
          const parent2 = scope.getBlockParent();
          parent2.registerDeclaration(path);
          if (path.isClassDeclaration() && path.node.id) {
            const id = path.node.id;
            const name = id.name;
            path.scope.bindings[name] = path.scope.parent.getBinding(name);
          }
        },
        CatchClause(path) {
          path.scope.registerBinding("let", path);
        },
        Function(path) {
          const params = path.get("params");
          for (const param of params) {
            path.scope.registerBinding("param", param);
          }
          if (path.isFunctionExpression() && path.node.id && !path.node.id[NOT_LOCAL_BINDING]) {
            path.scope.registerBinding("local", path.get("id"), path);
          }
        },
        ClassExpression(path) {
          if (path.node.id && !path.node.id[NOT_LOCAL_BINDING]) {
            path.scope.registerBinding("local", path.get("id"), path);
          }
        },
        TSTypeAnnotation(path) {
          path.skip();
        }
      };
      var scopeVisitor;
      var uid = 0;
      var Scope2 = class {
        constructor(path) {
          this.uid = void 0;
          this.path = void 0;
          this.block = void 0;
          this.inited = void 0;
          this.labels = void 0;
          this.bindings = void 0;
          this.referencesSet = void 0;
          this.globals = void 0;
          this.uidsSet = void 0;
          this.data = void 0;
          this.crawling = void 0;
          const {
            node
          } = path;
          const cached = _cache.scope.get(node);
          if ((cached == null ? void 0 : cached.path) === path) {
            return cached;
          }
          _cache.scope.set(node, this);
          this.uid = uid++;
          this.block = node;
          this.path = path;
          this.labels = /* @__PURE__ */ new Map();
          this.inited = false;
          {
            Object.defineProperties(this, {
              references: {
                enumerable: true,
                configurable: true,
                writable: true,
                value: /* @__PURE__ */ Object.create(null)
              },
              uids: {
                enumerable: true,
                configurable: true,
                writable: true,
                value: /* @__PURE__ */ Object.create(null)
              }
            });
          }
        }
        get parent() {
          var _parent;
          let parent2, path = this.path;
          do {
            var _path;
            const shouldSkip = path.key === "key" || path.listKey === "decorators";
            path = path.parentPath;
            if (shouldSkip && path.isMethod())
              path = path.parentPath;
            if ((_path = path) != null && _path.isScope())
              parent2 = path;
          } while (path && !parent2);
          return (_parent = parent2) == null ? void 0 : _parent.scope;
        }
        get references() {
          throw new Error("Scope#references is not available in Babel 8. Use Scope#referencesSet instead.");
        }
        get uids() {
          throw new Error("Scope#uids is not available in Babel 8. Use Scope#uidsSet instead.");
        }
        generateDeclaredUidIdentifier(name) {
          const id = this.generateUidIdentifier(name);
          this.push({
            id
          });
          return cloneNode(id);
        }
        generateUidIdentifier(name) {
          return identifier3(this.generateUid(name));
        }
        generateUid(name = "temp") {
          name = toIdentifier(name).replace(/^_+/, "").replace(/\d+$/g, "");
          let uid2;
          let i = 0;
          do {
            uid2 = `_${name}`;
            if (i >= 11)
              uid2 += i - 1;
            else if (i >= 9)
              uid2 += i - 9;
            else if (i >= 1)
              uid2 += i + 1;
            i++;
          } while (this.hasLabel(uid2) || this.hasBinding(uid2) || this.hasGlobal(uid2) || this.hasReference(uid2));
          const program3 = this.getProgramParent();
          {
            program3.references[uid2] = true;
            program3.uids[uid2] = true;
          }
          return uid2;
        }
        generateUidBasedOnNode(node, defaultName) {
          const parts = [];
          gatherNodeParts(node, parts);
          let id = parts.join("$");
          id = id.replace(/^_/, "") || defaultName || "ref";
          return this.generateUid(id.slice(0, 20));
        }
        generateUidIdentifierBasedOnNode(node, defaultName) {
          return identifier3(this.generateUidBasedOnNode(node, defaultName));
        }
        isStatic(node) {
          if (isThisExpression(node) || isSuper(node) || isTopicReference(node)) {
            return true;
          }
          if (isIdentifier2(node)) {
            const binding3 = this.getBinding(node.name);
            if (binding3) {
              return binding3.constant;
            } else {
              return this.hasBinding(node.name);
            }
          }
          return false;
        }
        maybeGenerateMemoised(node, dontPush) {
          if (this.isStatic(node)) {
            return null;
          } else {
            const id = this.generateUidIdentifierBasedOnNode(node);
            if (!dontPush) {
              this.push({
                id
              });
              return cloneNode(id);
            }
            return id;
          }
        }
        checkBlockScopedCollisions(local, kind, name, id) {
          if (kind === "param")
            return;
          if (local.kind === "local")
            return;
          const duplicate = kind === "let" || local.kind === "let" || local.kind === "const" || local.kind === "module" || local.kind === "param" && kind === "const";
          if (duplicate) {
            throw this.path.hub.buildError(id, `Duplicate declaration "${name}"`, TypeError);
          }
        }
        rename(oldName, newName) {
          const binding3 = this.getBinding(oldName);
          if (binding3) {
            newName || (newName = this.generateUidIdentifier(oldName).name);
            const renamer = new _renamer.default(binding3, oldName, newName);
            {
              renamer.rename(arguments[2]);
            }
          }
        }
        dump() {
          const sep2 = "-".repeat(60);
          console.log(sep2);
          let scope = this;
          do {
            console.log("#", scope.block.type);
            for (const name of Object.keys(scope.bindings)) {
              const binding3 = scope.bindings[name];
              console.log(" -", name, {
                constant: binding3.constant,
                references: binding3.references,
                violations: binding3.constantViolations.length,
                kind: binding3.kind
              });
            }
          } while (scope = scope.parent);
          console.log(sep2);
        }
        hasLabel(name) {
          return !!this.getLabel(name);
        }
        getLabel(name) {
          return this.labels.get(name);
        }
        registerLabel(path) {
          this.labels.set(path.node.label.name, path);
        }
        registerDeclaration(path) {
          if (path.isLabeledStatement()) {
            this.registerLabel(path);
          } else if (path.isFunctionDeclaration()) {
            this.registerBinding("hoisted", path.get("id"), path);
          } else if (path.isVariableDeclaration()) {
            const declarations = path.get("declarations");
            const {
              kind
            } = path.node;
            for (const declar of declarations) {
              this.registerBinding(kind === "using" || kind === "await using" ? "const" : kind, declar);
            }
          } else if (path.isClassDeclaration()) {
            if (path.node.declare)
              return;
            this.registerBinding("let", path);
          } else if (path.isImportDeclaration()) {
            const isTypeDeclaration = path.node.importKind === "type" || path.node.importKind === "typeof";
            const specifiers = path.get("specifiers");
            for (const specifier of specifiers) {
              const isTypeSpecifier = isTypeDeclaration || specifier.isImportSpecifier() && (specifier.node.importKind === "type" || specifier.node.importKind === "typeof");
              this.registerBinding(isTypeSpecifier ? "unknown" : "module", specifier);
            }
          } else if (path.isExportDeclaration()) {
            const declar = path.get("declaration");
            if (declar.isClassDeclaration() || declar.isFunctionDeclaration() || declar.isVariableDeclaration()) {
              this.registerDeclaration(declar);
            }
          } else {
            this.registerBinding("unknown", path);
          }
        }
        buildUndefinedNode() {
          return buildUndefinedNode();
        }
        registerConstantViolation(path) {
          const ids = path.getAssignmentIdentifiers();
          for (const name of Object.keys(ids)) {
            var _this$getBinding;
            (_this$getBinding = this.getBinding(name)) == null || _this$getBinding.reassign(path);
          }
        }
        registerBinding(kind, path, bindingPath = path) {
          if (!kind)
            throw new ReferenceError("no `kind`");
          if (path.isVariableDeclaration()) {
            const declarators = path.get("declarations");
            for (const declar of declarators) {
              this.registerBinding(kind, declar);
            }
            return;
          }
          const parent2 = this.getProgramParent();
          const ids = path.getOuterBindingIdentifiers(true);
          for (const name of Object.keys(ids)) {
            {
              parent2.references[name] = true;
            }
            for (const id of ids[name]) {
              const local = this.getOwnBinding(name);
              if (local) {
                if (local.identifier === id)
                  continue;
                this.checkBlockScopedCollisions(local, kind, name, id);
              }
              if (local) {
                local.reassign(bindingPath);
              } else {
                this.bindings[name] = new _binding.default({
                  identifier: id,
                  scope: this,
                  path: bindingPath,
                  kind
                });
              }
            }
          }
        }
        addGlobal(node) {
          this.globals[node.name] = node;
        }
        hasUid(name) {
          {
            let scope = this;
            do {
              if (scope.uids[name])
                return true;
            } while (scope = scope.parent);
            return false;
          }
        }
        hasGlobal(name) {
          let scope = this;
          do {
            if (scope.globals[name])
              return true;
          } while (scope = scope.parent);
          return false;
        }
        hasReference(name) {
          {
            return !!this.getProgramParent().references[name];
          }
        }
        isPure(node, constantsOnly) {
          if (isIdentifier2(node)) {
            const binding3 = this.getBinding(node.name);
            if (!binding3)
              return false;
            if (constantsOnly)
              return binding3.constant;
            return true;
          } else if (isThisExpression(node) || isMetaProperty(node) || isTopicReference(node) || isPrivateName(node)) {
            return true;
          } else if (isClass(node)) {
            var _node$decorators;
            if (node.superClass && !this.isPure(node.superClass, constantsOnly)) {
              return false;
            }
            if (((_node$decorators = node.decorators) == null ? void 0 : _node$decorators.length) > 0) {
              return false;
            }
            return this.isPure(node.body, constantsOnly);
          } else if (isClassBody(node)) {
            for (const method2 of node.body) {
              if (!this.isPure(method2, constantsOnly))
                return false;
            }
            return true;
          } else if (isBinary(node)) {
            return this.isPure(node.left, constantsOnly) && this.isPure(node.right, constantsOnly);
          } else if (isArrayExpression(node) || isTupleExpression(node)) {
            for (const elem of node.elements) {
              if (elem !== null && !this.isPure(elem, constantsOnly))
                return false;
            }
            return true;
          } else if (isObjectExpression(node) || isRecordExpression(node)) {
            for (const prop of node.properties) {
              if (!this.isPure(prop, constantsOnly))
                return false;
            }
            return true;
          } else if (isMethod(node)) {
            var _node$decorators2;
            if (node.computed && !this.isPure(node.key, constantsOnly))
              return false;
            if (((_node$decorators2 = node.decorators) == null ? void 0 : _node$decorators2.length) > 0) {
              return false;
            }
            return true;
          } else if (isProperty(node)) {
            var _node$decorators3;
            if (node.computed && !this.isPure(node.key, constantsOnly))
              return false;
            if (((_node$decorators3 = node.decorators) == null ? void 0 : _node$decorators3.length) > 0) {
              return false;
            }
            if (isObjectProperty(node) || node.static) {
              if (node.value !== null && !this.isPure(node.value, constantsOnly)) {
                return false;
              }
            }
            return true;
          } else if (isUnaryExpression(node)) {
            return this.isPure(node.argument, constantsOnly);
          } else if (isTemplateLiteral(node)) {
            for (const expression of node.expressions) {
              if (!this.isPure(expression, constantsOnly))
                return false;
            }
            return true;
          } else if (isTaggedTemplateExpression(node)) {
            return matchesPattern(node.tag, "String.raw") && !this.hasBinding("String", {
              noGlobals: true
            }) && this.isPure(node.quasi, constantsOnly);
          } else if (isMemberExpression(node)) {
            return !node.computed && isIdentifier2(node.object) && node.object.name === "Symbol" && isIdentifier2(node.property) && node.property.name !== "for" && !this.hasBinding("Symbol", {
              noGlobals: true
            });
          } else if (isCallExpression(node)) {
            return matchesPattern(node.callee, "Symbol.for") && !this.hasBinding("Symbol", {
              noGlobals: true
            }) && node.arguments.length === 1 && t3.isStringLiteral(node.arguments[0]);
          } else {
            return isPureish(node);
          }
        }
        setData(key, val) {
          return this.data[key] = val;
        }
        getData(key) {
          let scope = this;
          do {
            const data = scope.data[key];
            if (data != null)
              return data;
          } while (scope = scope.parent);
        }
        removeData(key) {
          let scope = this;
          do {
            const data = scope.data[key];
            if (data != null)
              scope.data[key] = null;
          } while (scope = scope.parent);
        }
        init() {
          if (!this.inited) {
            this.inited = true;
            this.crawl();
          }
        }
        crawl() {
          const path = this.path;
          resetScope(this);
          this.data = /* @__PURE__ */ Object.create(null);
          let scope = this;
          do {
            if (scope.crawling)
              return;
            if (scope.path.isProgram()) {
              break;
            }
          } while (scope = scope.parent);
          const programParent = scope;
          const state = {
            references: [],
            constantViolations: [],
            assignments: []
          };
          this.crawling = true;
          scopeVisitor || (scopeVisitor = _index.default.visitors.merge([{
            Scope(path2) {
              resetScope(path2.scope);
            }
          }, collectorVisitor]));
          if (path.type !== "Program") {
            for (const visit of scopeVisitor.enter) {
              visit.call(state, path, state);
            }
            const typeVisitors = scopeVisitor[path.type];
            if (typeVisitors) {
              for (const visit of typeVisitors.enter) {
                visit.call(state, path, state);
              }
            }
          }
          path.traverse(scopeVisitor, state);
          this.crawling = false;
          for (const path2 of state.assignments) {
            const ids = path2.getAssignmentIdentifiers();
            for (const name of Object.keys(ids)) {
              if (path2.scope.getBinding(name))
                continue;
              programParent.addGlobal(ids[name]);
            }
            path2.scope.registerConstantViolation(path2);
          }
          for (const ref of state.references) {
            const binding3 = ref.scope.getBinding(ref.node.name);
            if (binding3) {
              binding3.reference(ref);
            } else {
              programParent.addGlobal(ref.node);
            }
          }
          for (const path2 of state.constantViolations) {
            path2.scope.registerConstantViolation(path2);
          }
        }
        push(opts) {
          let path = this.path;
          if (path.isPattern()) {
            path = this.getPatternParent().path;
          } else if (!path.isBlockStatement() && !path.isProgram()) {
            path = this.getBlockParent().path;
          }
          if (path.isSwitchStatement()) {
            path = (this.getFunctionParent() || this.getProgramParent()).path;
          }
          const {
            init,
            unique,
            kind = "var",
            id
          } = opts;
          if (!init && !unique && (kind === "var" || kind === "let") && path.isFunction() && !path.node.name && isCallExpression(path.parent, {
            callee: path.node
          }) && path.parent.arguments.length <= path.node.params.length && isIdentifier2(id)) {
            path.pushContainer("params", id);
            path.scope.registerBinding("param", path.get("params")[path.node.params.length - 1]);
            return;
          }
          if (path.isLoop() || path.isCatchClause() || path.isFunction()) {
            path.ensureBlock();
            path = path.get("body");
          }
          const blockHoist = opts._blockHoist == null ? 2 : opts._blockHoist;
          const dataKey = `declaration:${kind}:${blockHoist}`;
          let declarPath = !unique && path.getData(dataKey);
          if (!declarPath) {
            const declar = variableDeclaration(kind, []);
            declar._blockHoist = blockHoist;
            [declarPath] = path.unshiftContainer("body", [declar]);
            if (!unique)
              path.setData(dataKey, declarPath);
          }
          const declarator = variableDeclarator(id, init);
          const len = declarPath.node.declarations.push(declarator);
          path.scope.registerBinding(kind, declarPath.get("declarations")[len - 1]);
        }
        getProgramParent() {
          let scope = this;
          do {
            if (scope.path.isProgram()) {
              return scope;
            }
          } while (scope = scope.parent);
          throw new Error("Couldn't find a Program");
        }
        getFunctionParent() {
          let scope = this;
          do {
            if (scope.path.isFunctionParent()) {
              return scope;
            }
          } while (scope = scope.parent);
          return null;
        }
        getBlockParent() {
          let scope = this;
          do {
            if (scope.path.isBlockParent()) {
              return scope;
            }
          } while (scope = scope.parent);
          throw new Error("We couldn't find a BlockStatement, For, Switch, Function, Loop or Program...");
        }
        getPatternParent() {
          let scope = this;
          do {
            if (!scope.path.isPattern()) {
              return scope.getBlockParent();
            }
          } while (scope = scope.parent.parent);
          throw new Error("We couldn't find a BlockStatement, For, Switch, Function, Loop or Program...");
        }
        getAllBindings() {
          const ids = /* @__PURE__ */ Object.create(null);
          let scope = this;
          do {
            for (const key of Object.keys(scope.bindings)) {
              if (key in ids === false) {
                ids[key] = scope.bindings[key];
              }
            }
            scope = scope.parent;
          } while (scope);
          return ids;
        }
        bindingIdentifierEquals(name, node) {
          return this.getBindingIdentifier(name) === node;
        }
        getBinding(name) {
          let scope = this;
          let previousPath;
          do {
            const binding3 = scope.getOwnBinding(name);
            if (binding3) {
              var _previousPath;
              if ((_previousPath = previousPath) != null && _previousPath.isPattern() && binding3.kind !== "param" && binding3.kind !== "local") {
              } else {
                return binding3;
              }
            } else if (!binding3 && name === "arguments" && scope.path.isFunction() && !scope.path.isArrowFunctionExpression()) {
              break;
            }
            previousPath = scope.path;
          } while (scope = scope.parent);
        }
        getOwnBinding(name) {
          return this.bindings[name];
        }
        getBindingIdentifier(name) {
          var _this$getBinding2;
          return (_this$getBinding2 = this.getBinding(name)) == null ? void 0 : _this$getBinding2.identifier;
        }
        getOwnBindingIdentifier(name) {
          const binding3 = this.bindings[name];
          return binding3 == null ? void 0 : binding3.identifier;
        }
        hasOwnBinding(name) {
          return !!this.getOwnBinding(name);
        }
        hasBinding(name, opts) {
          if (!name)
            return false;
          let noGlobals;
          let noUids;
          let upToScope;
          if (typeof opts === "object") {
            noGlobals = opts.noGlobals;
            noUids = opts.noUids;
            upToScope = opts.upToScope;
          } else if (typeof opts === "boolean") {
            noGlobals = opts;
          }
          let scope = this;
          do {
            if (upToScope === scope) {
              break;
            }
            if (scope.hasOwnBinding(name)) {
              return true;
            }
          } while (scope = scope.parent);
          if (!noUids && this.hasUid(name))
            return true;
          if (!noGlobals && Scope2.globals.includes(name))
            return true;
          if (!noGlobals && Scope2.contextVariables.includes(name))
            return true;
          return false;
        }
        parentHasBinding(name, opts) {
          var _this$parent;
          return (_this$parent = this.parent) == null ? void 0 : _this$parent.hasBinding(name, opts);
        }
        moveBindingTo(name, scope) {
          const info = this.getBinding(name);
          if (info) {
            info.scope.removeOwnBinding(name);
            info.scope = scope;
            scope.bindings[name] = info;
          }
        }
        removeOwnBinding(name) {
          delete this.bindings[name];
        }
        removeBinding(name) {
          var _this$getBinding3;
          (_this$getBinding3 = this.getBinding(name)) == null || _this$getBinding3.scope.removeOwnBinding(name);
          {
            let scope = this;
            do {
              if (scope.uids[name]) {
                scope.uids[name] = false;
              }
            } while (scope = scope.parent);
          }
        }
        hoistVariables(emit3 = (id) => this.push({
          id
        })) {
          this.crawl();
          const seen = /* @__PURE__ */ new Set();
          for (const name of Object.keys(this.bindings)) {
            const binding3 = this.bindings[name];
            if (!binding3)
              continue;
            const {
              path
            } = binding3;
            if (!path.isVariableDeclarator())
              continue;
            const {
              parent: parent2,
              parentPath
            } = path;
            if (parent2.kind !== "var" || seen.has(parent2))
              continue;
            seen.add(path.parent);
            let firstId;
            const init = [];
            for (const decl of parent2.declarations) {
              firstId != null ? firstId : firstId = decl.id;
              if (decl.init) {
                init.push(assignmentExpression("=", decl.id, decl.init));
              }
              const ids = Object.keys(getBindingIdentifiers(decl, false, true, true));
              for (const name2 of ids) {
                emit3(identifier3(name2), decl.init != null);
              }
            }
            if (parentPath.parentPath.isFor({
              left: parent2
            })) {
              parentPath.replaceWith(firstId);
            } else if (init.length === 0) {
              parentPath.remove();
            } else {
              const expr = init.length === 1 ? init[0] : sequenceExpression(init);
              if (parentPath.parentPath.isForStatement({
                init: parent2
              })) {
                parentPath.replaceWith(expr);
              } else {
                parentPath.replaceWith(expressionStatement2(expr));
              }
            }
          }
        }
      };
      exports8.default = Scope2;
      Scope2.globals = [...globalsBuiltinLower, ...globalsBuiltinUpper];
      Scope2.contextVariables = ["arguments", "undefined", "Infinity", "NaN"];
      {
        Scope2.prototype._renameFromMap = function _renameFromMap(map2, oldName, newName, value) {
          if (map2[oldName]) {
            map2[newName] = value;
            map2[oldName] = null;
          }
        };
        Scope2.prototype.traverse = function(node, opts, state) {
          (0, _index.default)(node, opts, this, state, this.path);
        };
        Scope2.prototype._generateUid = function _generateUid(name, i) {
          let id = name;
          if (i > 1)
            id += i;
          return `_${id}`;
        };
        Scope2.prototype.toArray = function toArray2(node, i, arrayLikeIsIterable) {
          if (isIdentifier2(node)) {
            const binding3 = this.getBinding(node.name);
            if (binding3 != null && binding3.constant && binding3.path.isGenericType("Array")) {
              return node;
            }
          }
          if (isArrayExpression(node)) {
            return node;
          }
          if (isIdentifier2(node, {
            name: "arguments"
          })) {
            return callExpression(memberExpression(memberExpression(memberExpression(identifier3("Array"), identifier3("prototype")), identifier3("slice")), identifier3("call")), [node]);
          }
          let helperName;
          const args = [node];
          if (i === true) {
            helperName = "toConsumableArray";
          } else if (typeof i === "number") {
            args.push(numericLiteral(i));
            helperName = "slicedToArray";
          } else {
            helperName = "toArray";
          }
          if (arrayLikeIsIterable) {
            args.unshift(this.path.hub.addHelper(helperName));
            helperName = "maybeArrayLike";
          }
          return callExpression(this.path.hub.addHelper(helperName), args);
        };
        Scope2.prototype.getAllBindingsOfKind = function getAllBindingsOfKind(...kinds) {
          const ids = /* @__PURE__ */ Object.create(null);
          for (const kind of kinds) {
            let scope = this;
            do {
              for (const name of Object.keys(scope.bindings)) {
                const binding3 = scope.bindings[name];
                if (binding3.kind === kind)
                  ids[name] = binding3;
              }
              scope = scope.parent;
            } while (scope);
          }
          return ids;
        };
        Object.defineProperties(Scope2.prototype, {
          parentBlock: {
            configurable: true,
            enumerable: true,
            get() {
              return this.path.parent;
            }
          },
          hub: {
            configurable: true,
            enumerable: true,
            get() {
              return this.path.hub;
            }
          }
        });
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/ancestry.js
  var require_ancestry = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/ancestry.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.find = find2;
      exports8.findParent = findParent;
      exports8.getAncestry = getAncestry;
      exports8.getDeepestCommonAncestorFrom = getDeepestCommonAncestorFrom;
      exports8.getEarliestCommonAncestorFrom = getEarliestCommonAncestorFrom;
      exports8.getFunctionParent = getFunctionParent;
      exports8.getStatementParent = getStatementParent;
      exports8.inType = inType;
      exports8.isAncestor = isAncestor;
      exports8.isDescendant = isDescendant;
      var _t = require_lib5();
      var {
        VISITOR_KEYS
      } = _t;
      function findParent(callback) {
        let path = this;
        while (path = path.parentPath) {
          if (callback(path))
            return path;
        }
        return null;
      }
      function find2(callback) {
        let path = this;
        do {
          if (callback(path))
            return path;
        } while (path = path.parentPath);
        return null;
      }
      function getFunctionParent() {
        return this.findParent((p) => p.isFunction());
      }
      function getStatementParent() {
        let path = this;
        do {
          if (!path.parentPath || Array.isArray(path.container) && path.isStatement()) {
            break;
          } else {
            path = path.parentPath;
          }
        } while (path);
        if (path && (path.isProgram() || path.isFile())) {
          throw new Error("File/Program node, we can't possibly find a statement parent to this");
        }
        return path;
      }
      function getEarliestCommonAncestorFrom(paths) {
        return this.getDeepestCommonAncestorFrom(paths, function(deepest, i, ancestries) {
          let earliest;
          const keys2 = VISITOR_KEYS[deepest.type];
          for (const ancestry of ancestries) {
            const path = ancestry[i + 1];
            if (!earliest) {
              earliest = path;
              continue;
            }
            if (path.listKey && earliest.listKey === path.listKey) {
              if (path.key < earliest.key) {
                earliest = path;
                continue;
              }
            }
            const earliestKeyIndex = keys2.indexOf(earliest.parentKey);
            const currentKeyIndex = keys2.indexOf(path.parentKey);
            if (earliestKeyIndex > currentKeyIndex) {
              earliest = path;
            }
          }
          return earliest;
        });
      }
      function getDeepestCommonAncestorFrom(paths, filter2) {
        if (!paths.length) {
          return this;
        }
        if (paths.length === 1) {
          return paths[0];
        }
        let minDepth = Infinity;
        let lastCommonIndex, lastCommon;
        const ancestries = paths.map((path) => {
          const ancestry = [];
          do {
            ancestry.unshift(path);
          } while ((path = path.parentPath) && path !== this);
          if (ancestry.length < minDepth) {
            minDepth = ancestry.length;
          }
          return ancestry;
        });
        const first = ancestries[0];
        depthLoop:
          for (let i = 0; i < minDepth; i++) {
            const shouldMatch = first[i];
            for (const ancestry of ancestries) {
              if (ancestry[i] !== shouldMatch) {
                break depthLoop;
              }
            }
            lastCommonIndex = i;
            lastCommon = shouldMatch;
          }
        if (lastCommon) {
          if (filter2) {
            return filter2(lastCommon, lastCommonIndex, ancestries);
          } else {
            return lastCommon;
          }
        } else {
          throw new Error("Couldn't find intersection");
        }
      }
      function getAncestry() {
        let path = this;
        const paths = [];
        do {
          paths.push(path);
        } while (path = path.parentPath);
        return paths;
      }
      function isAncestor(maybeDescendant) {
        return maybeDescendant.isDescendant(this);
      }
      function isDescendant(maybeAncestor) {
        return !!this.findParent((parent2) => parent2 === maybeAncestor);
      }
      function inType(...candidateTypes) {
        let path = this;
        while (path) {
          if (candidateTypes.includes(path.node.type))
            return true;
          path = path.parentPath;
        }
        return false;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/inference/util.js
  var require_util3 = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/inference/util.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.createUnionType = createUnionType;
      var _t = require_lib5();
      var {
        createFlowUnionType,
        createTSUnionType,
        createUnionTypeAnnotation,
        isFlowType,
        isTSType
      } = _t;
      function createUnionType(types2) {
        {
          if (types2.every((v) => isFlowType(v))) {
            if (createFlowUnionType) {
              return createFlowUnionType(types2);
            }
            return createUnionTypeAnnotation(types2);
          } else if (types2.every((v) => isTSType(v))) {
            if (createTSUnionType) {
              return createTSUnionType(types2);
            }
          }
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/inference/inferer-reference.js
  var require_inferer_reference = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/inference/inferer-reference.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = _default;
      var _t = require_lib5();
      var _util = require_util3();
      var {
        BOOLEAN_NUMBER_BINARY_OPERATORS,
        createTypeAnnotationBasedOnTypeof,
        numberTypeAnnotation,
        voidTypeAnnotation
      } = _t;
      function _default(node) {
        if (!this.isReferenced())
          return;
        const binding3 = this.scope.getBinding(node.name);
        if (binding3) {
          if (binding3.identifier.typeAnnotation) {
            return binding3.identifier.typeAnnotation;
          } else {
            return getTypeAnnotationBindingConstantViolations(binding3, this, node.name);
          }
        }
        if (node.name === "undefined") {
          return voidTypeAnnotation();
        } else if (node.name === "NaN" || node.name === "Infinity") {
          return numberTypeAnnotation();
        } else if (node.name === "arguments") {
        }
      }
      function getTypeAnnotationBindingConstantViolations(binding3, path, name) {
        const types2 = [];
        const functionConstantViolations = [];
        let constantViolations = getConstantViolationsBefore(binding3, path, functionConstantViolations);
        const testType = getConditionalAnnotation(binding3, path, name);
        if (testType) {
          const testConstantViolations = getConstantViolationsBefore(binding3, testType.ifStatement);
          constantViolations = constantViolations.filter((path2) => !testConstantViolations.includes(path2));
          types2.push(testType.typeAnnotation);
        }
        if (constantViolations.length) {
          constantViolations.push(...functionConstantViolations);
          for (const violation of constantViolations) {
            types2.push(violation.getTypeAnnotation());
          }
        }
        if (!types2.length) {
          return;
        }
        return (0, _util.createUnionType)(types2);
      }
      function getConstantViolationsBefore(binding3, path, functions2) {
        const violations = binding3.constantViolations.slice();
        violations.unshift(binding3.path);
        return violations.filter((violation) => {
          violation = violation.resolve();
          const status = violation._guessExecutionStatusRelativeTo(path);
          if (functions2 && status === "unknown")
            functions2.push(violation);
          return status === "before";
        });
      }
      function inferAnnotationFromBinaryExpression(name, path) {
        const operator = path.node.operator;
        const right = path.get("right").resolve();
        const left = path.get("left").resolve();
        let target;
        if (left.isIdentifier({
          name
        })) {
          target = right;
        } else if (right.isIdentifier({
          name
        })) {
          target = left;
        }
        if (target) {
          if (operator === "===") {
            return target.getTypeAnnotation();
          }
          if (BOOLEAN_NUMBER_BINARY_OPERATORS.includes(operator)) {
            return numberTypeAnnotation();
          }
          return;
        }
        if (operator !== "===" && operator !== "==")
          return;
        let typeofPath;
        let typePath;
        if (left.isUnaryExpression({
          operator: "typeof"
        })) {
          typeofPath = left;
          typePath = right;
        } else if (right.isUnaryExpression({
          operator: "typeof"
        })) {
          typeofPath = right;
          typePath = left;
        }
        if (!typeofPath)
          return;
        if (!typeofPath.get("argument").isIdentifier({
          name
        }))
          return;
        typePath = typePath.resolve();
        if (!typePath.isLiteral())
          return;
        const typeValue = typePath.node.value;
        if (typeof typeValue !== "string")
          return;
        return createTypeAnnotationBasedOnTypeof(typeValue);
      }
      function getParentConditionalPath(binding3, path, name) {
        let parentPath;
        while (parentPath = path.parentPath) {
          if (parentPath.isIfStatement() || parentPath.isConditionalExpression()) {
            if (path.key === "test") {
              return;
            }
            return parentPath;
          }
          if (parentPath.isFunction()) {
            if (parentPath.parentPath.scope.getBinding(name) !== binding3)
              return;
          }
          path = parentPath;
        }
      }
      function getConditionalAnnotation(binding3, path, name) {
        const ifStatement = getParentConditionalPath(binding3, path, name);
        if (!ifStatement)
          return;
        const test = ifStatement.get("test");
        const paths = [test];
        const types2 = [];
        for (let i = 0; i < paths.length; i++) {
          const path2 = paths[i];
          if (path2.isLogicalExpression()) {
            if (path2.node.operator === "&&") {
              paths.push(path2.get("left"));
              paths.push(path2.get("right"));
            }
          } else if (path2.isBinaryExpression()) {
            const type = inferAnnotationFromBinaryExpression(name, path2);
            if (type)
              types2.push(type);
          }
        }
        if (types2.length) {
          return {
            typeAnnotation: (0, _util.createUnionType)(types2),
            ifStatement
          };
        }
        return getConditionalAnnotation(binding3, ifStatement, name);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/inference/inferers.js
  var require_inferers = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/inference/inferers.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.ArrayExpression = ArrayExpression;
      exports8.AssignmentExpression = AssignmentExpression;
      exports8.BinaryExpression = BinaryExpression;
      exports8.BooleanLiteral = BooleanLiteral;
      exports8.CallExpression = CallExpression;
      exports8.ConditionalExpression = ConditionalExpression;
      exports8.ClassDeclaration = exports8.ClassExpression = exports8.FunctionDeclaration = exports8.ArrowFunctionExpression = exports8.FunctionExpression = Func;
      Object.defineProperty(exports8, "Identifier", {
        enumerable: true,
        get: function() {
          return _infererReference.default;
        }
      });
      exports8.LogicalExpression = LogicalExpression;
      exports8.NewExpression = NewExpression;
      exports8.NullLiteral = NullLiteral;
      exports8.NumericLiteral = NumericLiteral;
      exports8.ObjectExpression = ObjectExpression;
      exports8.ParenthesizedExpression = ParenthesizedExpression;
      exports8.RegExpLiteral = RegExpLiteral;
      exports8.RestElement = RestElement;
      exports8.SequenceExpression = SequenceExpression;
      exports8.StringLiteral = StringLiteral;
      exports8.TSAsExpression = TSAsExpression;
      exports8.TSNonNullExpression = TSNonNullExpression;
      exports8.TaggedTemplateExpression = TaggedTemplateExpression;
      exports8.TemplateLiteral = TemplateLiteral;
      exports8.TypeCastExpression = TypeCastExpression;
      exports8.UnaryExpression = UnaryExpression;
      exports8.UpdateExpression = UpdateExpression;
      exports8.VariableDeclarator = VariableDeclarator;
      var _t = require_lib5();
      var _infererReference = require_inferer_reference();
      var _util = require_util3();
      var {
        BOOLEAN_BINARY_OPERATORS,
        BOOLEAN_UNARY_OPERATORS,
        NUMBER_BINARY_OPERATORS,
        NUMBER_UNARY_OPERATORS,
        STRING_UNARY_OPERATORS,
        anyTypeAnnotation,
        arrayTypeAnnotation,
        booleanTypeAnnotation,
        buildMatchMemberExpression,
        genericTypeAnnotation,
        identifier: identifier3,
        nullLiteralTypeAnnotation,
        numberTypeAnnotation,
        stringTypeAnnotation,
        tupleTypeAnnotation,
        unionTypeAnnotation,
        voidTypeAnnotation,
        isIdentifier: isIdentifier2
      } = _t;
      function VariableDeclarator() {
        if (!this.get("id").isIdentifier())
          return;
        return this.get("init").getTypeAnnotation();
      }
      function TypeCastExpression(node) {
        return node.typeAnnotation;
      }
      TypeCastExpression.validParent = true;
      function TSAsExpression(node) {
        return node.typeAnnotation;
      }
      TSAsExpression.validParent = true;
      function TSNonNullExpression() {
        return this.get("expression").getTypeAnnotation();
      }
      function NewExpression(node) {
        if (node.callee.type === "Identifier") {
          return genericTypeAnnotation(node.callee);
        }
      }
      function TemplateLiteral() {
        return stringTypeAnnotation();
      }
      function UnaryExpression(node) {
        const operator = node.operator;
        if (operator === "void") {
          return voidTypeAnnotation();
        } else if (NUMBER_UNARY_OPERATORS.includes(operator)) {
          return numberTypeAnnotation();
        } else if (STRING_UNARY_OPERATORS.includes(operator)) {
          return stringTypeAnnotation();
        } else if (BOOLEAN_UNARY_OPERATORS.includes(operator)) {
          return booleanTypeAnnotation();
        }
      }
      function BinaryExpression(node) {
        const operator = node.operator;
        if (NUMBER_BINARY_OPERATORS.includes(operator)) {
          return numberTypeAnnotation();
        } else if (BOOLEAN_BINARY_OPERATORS.includes(operator)) {
          return booleanTypeAnnotation();
        } else if (operator === "+") {
          const right = this.get("right");
          const left = this.get("left");
          if (left.isBaseType("number") && right.isBaseType("number")) {
            return numberTypeAnnotation();
          } else if (left.isBaseType("string") || right.isBaseType("string")) {
            return stringTypeAnnotation();
          }
          return unionTypeAnnotation([stringTypeAnnotation(), numberTypeAnnotation()]);
        }
      }
      function LogicalExpression() {
        const argumentTypes = [this.get("left").getTypeAnnotation(), this.get("right").getTypeAnnotation()];
        return (0, _util.createUnionType)(argumentTypes);
      }
      function ConditionalExpression() {
        const argumentTypes = [this.get("consequent").getTypeAnnotation(), this.get("alternate").getTypeAnnotation()];
        return (0, _util.createUnionType)(argumentTypes);
      }
      function SequenceExpression() {
        return this.get("expressions").pop().getTypeAnnotation();
      }
      function ParenthesizedExpression() {
        return this.get("expression").getTypeAnnotation();
      }
      function AssignmentExpression() {
        return this.get("right").getTypeAnnotation();
      }
      function UpdateExpression(node) {
        const operator = node.operator;
        if (operator === "++" || operator === "--") {
          return numberTypeAnnotation();
        }
      }
      function StringLiteral() {
        return stringTypeAnnotation();
      }
      function NumericLiteral() {
        return numberTypeAnnotation();
      }
      function BooleanLiteral() {
        return booleanTypeAnnotation();
      }
      function NullLiteral() {
        return nullLiteralTypeAnnotation();
      }
      function RegExpLiteral() {
        return genericTypeAnnotation(identifier3("RegExp"));
      }
      function ObjectExpression() {
        return genericTypeAnnotation(identifier3("Object"));
      }
      function ArrayExpression() {
        return genericTypeAnnotation(identifier3("Array"));
      }
      function RestElement() {
        return ArrayExpression();
      }
      RestElement.validParent = true;
      function Func() {
        return genericTypeAnnotation(identifier3("Function"));
      }
      var isArrayFrom = buildMatchMemberExpression("Array.from");
      var isObjectKeys = buildMatchMemberExpression("Object.keys");
      var isObjectValues = buildMatchMemberExpression("Object.values");
      var isObjectEntries = buildMatchMemberExpression("Object.entries");
      function CallExpression() {
        const {
          callee
        } = this.node;
        if (isObjectKeys(callee)) {
          return arrayTypeAnnotation(stringTypeAnnotation());
        } else if (isArrayFrom(callee) || isObjectValues(callee) || isIdentifier2(callee, {
          name: "Array"
        })) {
          return arrayTypeAnnotation(anyTypeAnnotation());
        } else if (isObjectEntries(callee)) {
          return arrayTypeAnnotation(tupleTypeAnnotation([stringTypeAnnotation(), anyTypeAnnotation()]));
        }
        return resolveCall(this.get("callee"));
      }
      function TaggedTemplateExpression() {
        return resolveCall(this.get("tag"));
      }
      function resolveCall(callee) {
        callee = callee.resolve();
        if (callee.isFunction()) {
          const {
            node
          } = callee;
          if (node.async) {
            if (node.generator) {
              return genericTypeAnnotation(identifier3("AsyncIterator"));
            } else {
              return genericTypeAnnotation(identifier3("Promise"));
            }
          } else {
            if (node.generator) {
              return genericTypeAnnotation(identifier3("Iterator"));
            } else if (callee.node.returnType) {
              return callee.node.returnType;
            } else {
            }
          }
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/inference/index.js
  var require_inference = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/inference/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8._getTypeAnnotation = _getTypeAnnotation;
      exports8.baseTypeStrictlyMatches = baseTypeStrictlyMatches;
      exports8.couldBeBaseType = couldBeBaseType;
      exports8.getTypeAnnotation = getTypeAnnotation;
      exports8.isBaseType = isBaseType;
      exports8.isGenericType = isGenericType;
      var inferers = require_inferers();
      var _t = require_lib5();
      var {
        anyTypeAnnotation,
        isAnyTypeAnnotation,
        isArrayTypeAnnotation,
        isBooleanTypeAnnotation,
        isEmptyTypeAnnotation,
        isFlowBaseAnnotation,
        isGenericTypeAnnotation,
        isIdentifier: isIdentifier2,
        isMixedTypeAnnotation,
        isNumberTypeAnnotation,
        isStringTypeAnnotation,
        isTSArrayType,
        isTSTypeAnnotation,
        isTSTypeReference,
        isTupleTypeAnnotation,
        isTypeAnnotation,
        isUnionTypeAnnotation,
        isVoidTypeAnnotation,
        stringTypeAnnotation,
        voidTypeAnnotation
      } = _t;
      function getTypeAnnotation() {
        let type = this.getData("typeAnnotation");
        if (type != null) {
          return type;
        }
        type = _getTypeAnnotation.call(this) || anyTypeAnnotation();
        if (isTypeAnnotation(type) || isTSTypeAnnotation(type)) {
          type = type.typeAnnotation;
        }
        this.setData("typeAnnotation", type);
        return type;
      }
      var typeAnnotationInferringNodes = /* @__PURE__ */ new WeakSet();
      function _getTypeAnnotation() {
        const node = this.node;
        if (!node) {
          if (this.key === "init" && this.parentPath.isVariableDeclarator()) {
            const declar = this.parentPath.parentPath;
            const declarParent = declar.parentPath;
            if (declar.key === "left" && declarParent.isForInStatement()) {
              return stringTypeAnnotation();
            }
            if (declar.key === "left" && declarParent.isForOfStatement()) {
              return anyTypeAnnotation();
            }
            return voidTypeAnnotation();
          } else {
            return;
          }
        }
        if (node.typeAnnotation) {
          return node.typeAnnotation;
        }
        if (typeAnnotationInferringNodes.has(node)) {
          return;
        }
        typeAnnotationInferringNodes.add(node);
        try {
          var _inferer;
          let inferer = inferers[node.type];
          if (inferer) {
            return inferer.call(this, node);
          }
          inferer = inferers[this.parentPath.type];
          if ((_inferer = inferer) != null && _inferer.validParent) {
            return this.parentPath.getTypeAnnotation();
          }
        } finally {
          typeAnnotationInferringNodes.delete(node);
        }
      }
      function isBaseType(baseName, soft) {
        return _isBaseType(baseName, this.getTypeAnnotation(), soft);
      }
      function _isBaseType(baseName, type, soft) {
        if (baseName === "string") {
          return isStringTypeAnnotation(type);
        } else if (baseName === "number") {
          return isNumberTypeAnnotation(type);
        } else if (baseName === "boolean") {
          return isBooleanTypeAnnotation(type);
        } else if (baseName === "any") {
          return isAnyTypeAnnotation(type);
        } else if (baseName === "mixed") {
          return isMixedTypeAnnotation(type);
        } else if (baseName === "empty") {
          return isEmptyTypeAnnotation(type);
        } else if (baseName === "void") {
          return isVoidTypeAnnotation(type);
        } else {
          if (soft) {
            return false;
          } else {
            throw new Error(`Unknown base type ${baseName}`);
          }
        }
      }
      function couldBeBaseType(name) {
        const type = this.getTypeAnnotation();
        if (isAnyTypeAnnotation(type))
          return true;
        if (isUnionTypeAnnotation(type)) {
          for (const type2 of type.types) {
            if (isAnyTypeAnnotation(type2) || _isBaseType(name, type2, true)) {
              return true;
            }
          }
          return false;
        } else {
          return _isBaseType(name, type, true);
        }
      }
      function baseTypeStrictlyMatches(rightArg) {
        const left = this.getTypeAnnotation();
        const right = rightArg.getTypeAnnotation();
        if (!isAnyTypeAnnotation(left) && isFlowBaseAnnotation(left)) {
          return right.type === left.type;
        }
        return false;
      }
      function isGenericType(genericName) {
        const type = this.getTypeAnnotation();
        if (genericName === "Array") {
          if (isTSArrayType(type) || isArrayTypeAnnotation(type) || isTupleTypeAnnotation(type)) {
            return true;
          }
        }
        return isGenericTypeAnnotation(type) && isIdentifier2(type.id, {
          name: genericName
        }) || isTSTypeReference(type) && isIdentifier2(type.typeName, {
          name: genericName
        });
      }
    }
  });

  // ../../node_modules/.pnpm/picocolors@1.1.1/node_modules/picocolors/picocolors.browser.js
  var require_picocolors_browser = __commonJS({
    "../../node_modules/.pnpm/picocolors@1.1.1/node_modules/picocolors/picocolors.browser.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var x = String;
      var create2 = function() {
        return { isColorSupported: false, reset: x, bold: x, dim: x, italic: x, underline: x, inverse: x, hidden: x, strikethrough: x, black: x, red: x, green: x, yellow: x, blue: x, magenta: x, cyan: x, white: x, gray: x, bgBlack: x, bgRed: x, bgGreen: x, bgYellow: x, bgBlue: x, bgMagenta: x, bgCyan: x, bgWhite: x, blackBright: x, redBright: x, greenBright: x, yellowBright: x, blueBright: x, magentaBright: x, cyanBright: x, whiteBright: x, bgBlackBright: x, bgRedBright: x, bgGreenBright: x, bgYellowBright: x, bgBlueBright: x, bgMagentaBright: x, bgCyanBright: x, bgWhiteBright: x };
      };
      module2.exports = create2();
      module2.exports.createColors = create2;
    }
  });

  // ../../node_modules/.pnpm/js-tokens@4.0.0/node_modules/js-tokens/index.js
  var require_js_tokens = __commonJS({
    "../../node_modules/.pnpm/js-tokens@4.0.0/node_modules/js-tokens/index.js"(exports8) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = /((['"])(?:(?!\2|\\).|\\(?:\r\n|[\s\S]))*(\2)?|`(?:[^`\\$]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{[^}]*\}?)*\}?)*(`)?)|(\/\/.*)|(\/\*(?:[^*]|\*(?!\/))*(\*\/)?)|(\/(?!\*)(?:\[(?:(?![\]\\]).|\\.)*\]|(?![\/\]\\]).|\\.)+\/(?:(?!\s*(?:\b|[\u0080-\uFFFF$\\'"~({]|[+\-!](?!=)|\.?\d))|[gmiyus]{1,6}\b(?![\u0080-\uFFFF$\\]|\s*(?:[+\-*%&|^<>!=?({]|\/(?![\/*])))))|(0[xX][\da-fA-F]+|0[oO][0-7]+|0[bB][01]+|(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?)|((?!\d)(?:(?!\s)[$\w\u0080-\uFFFF]|\\u[\da-fA-F]{4}|\\u\{[\da-fA-F]+\})+)|(--|\+\+|&&|\|\||=>|\.{3}|(?:[+\-\/%&|^]|\*{1,2}|<{1,2}|>{1,3}|!=?|={1,2})=?|[?~.,:;[\](){}])|(\s+)|(^$|[\s\S])/g;
      exports8.matchToToken = function(match) {
        var token = { type: "invalid", value: match[0], closed: void 0 };
        if (match[1])
          token.type = "string", token.closed = !!(match[3] || match[4]);
        else if (match[5])
          token.type = "comment";
        else if (match[6])
          token.type = "comment", token.closed = !!match[7];
        else if (match[8])
          token.type = "regex";
        else if (match[9])
          token.type = "number";
        else if (match[10])
          token.type = "name";
        else if (match[11])
          token.type = "punctuator";
        else if (match[12])
          token.type = "whitespace";
        return token;
      };
    }
  });

  // ../../node_modules/.pnpm/@babel+code-frame@7.27.1/node_modules/@babel/code-frame/lib/index.js
  var require_lib7 = __commonJS({
    "../../node_modules/.pnpm/@babel+code-frame@7.27.1/node_modules/@babel/code-frame/lib/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", { value: true });
      var picocolors = require_picocolors_browser();
      var jsTokens = require_js_tokens();
      var helperValidatorIdentifier = require_lib3();
      function isColorSupported() {
        return typeof define_process_default === "object" && (define_process_default.env.FORCE_COLOR === "0" || define_process_default.env.FORCE_COLOR === "false") ? false : picocolors.isColorSupported;
      }
      var compose = (f, g) => (v) => f(g(v));
      function buildDefs(colors) {
        return {
          keyword: colors.cyan,
          capitalized: colors.yellow,
          jsxIdentifier: colors.yellow,
          punctuator: colors.yellow,
          number: colors.magenta,
          string: colors.green,
          regex: colors.magenta,
          comment: colors.gray,
          invalid: compose(compose(colors.white, colors.bgRed), colors.bold),
          gutter: colors.gray,
          marker: compose(colors.red, colors.bold),
          message: compose(colors.red, colors.bold),
          reset: colors.reset
        };
      }
      var defsOn = buildDefs(picocolors.createColors(true));
      var defsOff = buildDefs(picocolors.createColors(false));
      function getDefs(enabled) {
        return enabled ? defsOn : defsOff;
      }
      var sometimesKeywords = /* @__PURE__ */ new Set(["as", "async", "from", "get", "of", "set"]);
      var NEWLINE$1 = /\r\n|[\n\r\u2028\u2029]/;
      var BRACKET = /^[()[\]{}]$/;
      var tokenize;
      {
        const JSX_TAG = /^[a-z][\w-]*$/i;
        const getTokenType = function(token, offset, text) {
          if (token.type === "name") {
            if (helperValidatorIdentifier.isKeyword(token.value) || helperValidatorIdentifier.isStrictReservedWord(token.value, true) || sometimesKeywords.has(token.value)) {
              return "keyword";
            }
            if (JSX_TAG.test(token.value) && (text[offset - 1] === "<" || text.slice(offset - 2, offset) === "</")) {
              return "jsxIdentifier";
            }
            if (token.value[0] !== token.value[0].toLowerCase()) {
              return "capitalized";
            }
          }
          if (token.type === "punctuator" && BRACKET.test(token.value)) {
            return "bracket";
          }
          if (token.type === "invalid" && (token.value === "@" || token.value === "#")) {
            return "punctuator";
          }
          return token.type;
        };
        tokenize = function* (text) {
          let match;
          while (match = jsTokens.default.exec(text)) {
            const token = jsTokens.matchToToken(match);
            yield {
              type: getTokenType(token, match.index, text),
              value: token.value
            };
          }
        };
      }
      function highlight(text) {
        if (text === "")
          return "";
        const defs = getDefs(true);
        let highlighted = "";
        for (const {
          type,
          value
        } of tokenize(text)) {
          if (type in defs) {
            highlighted += value.split(NEWLINE$1).map((str) => defs[type](str)).join("\n");
          } else {
            highlighted += value;
          }
        }
        return highlighted;
      }
      var deprecationWarningShown = false;
      var NEWLINE = /\r\n|[\n\r\u2028\u2029]/;
      function getMarkerLines(loc, source, opts) {
        const startLoc = Object.assign({
          column: 0,
          line: -1
        }, loc.start);
        const endLoc = Object.assign({}, startLoc, loc.end);
        const {
          linesAbove = 2,
          linesBelow = 3
        } = opts || {};
        const startLine = startLoc.line;
        const startColumn = startLoc.column;
        const endLine = endLoc.line;
        const endColumn = endLoc.column;
        let start = Math.max(startLine - (linesAbove + 1), 0);
        let end = Math.min(source.length, endLine + linesBelow);
        if (startLine === -1) {
          start = 0;
        }
        if (endLine === -1) {
          end = source.length;
        }
        const lineDiff = endLine - startLine;
        const markerLines = {};
        if (lineDiff) {
          for (let i = 0; i <= lineDiff; i++) {
            const lineNumber = i + startLine;
            if (!startColumn) {
              markerLines[lineNumber] = true;
            } else if (i === 0) {
              const sourceLength = source[lineNumber - 1].length;
              markerLines[lineNumber] = [startColumn, sourceLength - startColumn + 1];
            } else if (i === lineDiff) {
              markerLines[lineNumber] = [0, endColumn];
            } else {
              const sourceLength = source[lineNumber - i].length;
              markerLines[lineNumber] = [0, sourceLength];
            }
          }
        } else {
          if (startColumn === endColumn) {
            if (startColumn) {
              markerLines[startLine] = [startColumn, 0];
            } else {
              markerLines[startLine] = true;
            }
          } else {
            markerLines[startLine] = [startColumn, endColumn - startColumn];
          }
        }
        return {
          start,
          end,
          markerLines
        };
      }
      function codeFrameColumns(rawLines, loc, opts = {}) {
        const shouldHighlight = opts.forceColor || isColorSupported() && opts.highlightCode;
        const defs = getDefs(shouldHighlight);
        const lines = rawLines.split(NEWLINE);
        const {
          start,
          end,
          markerLines
        } = getMarkerLines(loc, lines, opts);
        const hasColumns = loc.start && typeof loc.start.column === "number";
        const numberMaxWidth = String(end).length;
        const highlightedLines = shouldHighlight ? highlight(rawLines) : rawLines;
        let frame = highlightedLines.split(NEWLINE, end).slice(start, end).map((line, index2) => {
          const number = start + 1 + index2;
          const paddedNumber = ` ${number}`.slice(-numberMaxWidth);
          const gutter = ` ${paddedNumber} |`;
          const hasMarker = markerLines[number];
          const lastMarkerLine = !markerLines[number + 1];
          if (hasMarker) {
            let markerLine = "";
            if (Array.isArray(hasMarker)) {
              const markerSpacing = line.slice(0, Math.max(hasMarker[0] - 1, 0)).replace(/[^\t]/g, " ");
              const numberOfMarkers = hasMarker[1] || 1;
              markerLine = ["\n ", defs.gutter(gutter.replace(/\d/g, " ")), " ", markerSpacing, defs.marker("^").repeat(numberOfMarkers)].join("");
              if (lastMarkerLine && opts.message) {
                markerLine += " " + defs.message(opts.message);
              }
            }
            return [defs.marker(">"), defs.gutter(gutter), line.length > 0 ? ` ${line}` : "", markerLine].join("");
          } else {
            return ` ${defs.gutter(gutter)}${line.length > 0 ? ` ${line}` : ""}`;
          }
        }).join("\n");
        if (opts.message && !hasColumns) {
          frame = `${" ".repeat(numberMaxWidth + 1)}${opts.message}
${frame}`;
        }
        if (shouldHighlight) {
          return defs.reset(frame);
        } else {
          return frame;
        }
      }
      function index(rawLines, lineNumber, colNumber, opts = {}) {
        if (!deprecationWarningShown) {
          deprecationWarningShown = true;
          const message = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
          if (define_process_default.emitWarning) {
            define_process_default.emitWarning(message, "DeprecationWarning");
          } else {
            const deprecationError = new Error(message);
            deprecationError.name = "DeprecationWarning";
            console.warn(new Error(message));
          }
        }
        colNumber = Math.max(colNumber, 0);
        const location2 = {
          start: {
            column: colNumber,
            line: lineNumber
          }
        };
        return codeFrameColumns(rawLines, location2, opts);
      }
      exports8.codeFrameColumns = codeFrameColumns;
      exports8.default = index;
      exports8.highlight = highlight;
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/lib/removal-hooks.js
  var require_removal_hooks = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/lib/removal-hooks.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.hooks = void 0;
      var hooks = exports8.hooks = [function(self2, parent2) {
        const removeParent = self2.key === "test" && (parent2.isWhile() || parent2.isSwitchCase()) || self2.key === "declaration" && parent2.isExportDeclaration() || self2.key === "body" && parent2.isLabeledStatement() || self2.listKey === "declarations" && parent2.isVariableDeclaration() && parent2.node.declarations.length === 1 || self2.key === "expression" && parent2.isExpressionStatement();
        if (removeParent) {
          parent2.remove();
          return true;
        }
      }, function(self2, parent2) {
        if (parent2.isSequenceExpression() && parent2.node.expressions.length === 1) {
          parent2.replaceWith(parent2.node.expressions[0]);
          return true;
        }
      }, function(self2, parent2) {
        if (parent2.isBinary()) {
          if (self2.key === "left") {
            parent2.replaceWith(parent2.node.right);
          } else {
            parent2.replaceWith(parent2.node.left);
          }
          return true;
        }
      }, function(self2, parent2) {
        if (parent2.isIfStatement() && self2.key === "consequent" || self2.key === "body" && (parent2.isLoop() || parent2.isArrowFunctionExpression())) {
          self2.replaceWith({
            type: "BlockStatement",
            body: []
          });
          return true;
        }
      }];
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/removal.js
  var require_removal = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/removal.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8._assertUnremoved = _assertUnremoved;
      exports8._callRemovalHooks = _callRemovalHooks;
      exports8._markRemoved = _markRemoved;
      exports8._remove = _remove;
      exports8._removeFromScope = _removeFromScope;
      exports8.remove = remove2;
      var _removalHooks = require_removal_hooks();
      var _cache = require_cache2();
      var _replacement = require_replacement();
      var _index = require_path();
      var _t = require_lib5();
      var _modification = require_modification();
      var _context = require_context2();
      var {
        getBindingIdentifiers
      } = _t;
      function remove2() {
        var _this$opts;
        _assertUnremoved.call(this);
        _context.resync.call(this);
        if (_callRemovalHooks.call(this)) {
          _markRemoved.call(this);
          return;
        }
        if (!((_this$opts = this.opts) != null && _this$opts.noScope)) {
          _removeFromScope.call(this);
        }
        this.shareCommentsWithSiblings();
        _remove.call(this);
        _markRemoved.call(this);
      }
      function _removeFromScope() {
        const bindings = getBindingIdentifiers(this.node, false, false, true);
        Object.keys(bindings).forEach((name) => this.scope.removeBinding(name));
      }
      function _callRemovalHooks() {
        if (this.parentPath) {
          for (const fn of _removalHooks.hooks) {
            if (fn(this, this.parentPath))
              return true;
          }
        }
      }
      function _remove() {
        if (Array.isArray(this.container)) {
          this.container.splice(this.key, 1);
          _modification.updateSiblingKeys.call(this, this.key, -1);
        } else {
          _replacement._replaceWith.call(this, null);
        }
      }
      function _markRemoved() {
        this._traverseFlags |= _index.SHOULD_SKIP | _index.REMOVED;
        if (this.parent) {
          var _getCachedPaths;
          (_getCachedPaths = (0, _cache.getCachedPaths)(this)) == null || _getCachedPaths.delete(this.node);
        }
        this.node = null;
      }
      function _assertUnremoved() {
        if (this.removed) {
          throw this.buildCodeFrameError("NodePath has been removed so is read-only.");
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/lib/hoister.js
  var require_hoister = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/lib/hoister.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      var _t = require_lib5();
      var _t2 = _t;
      var {
        react
      } = _t;
      var {
        cloneNode,
        jsxExpressionContainer,
        variableDeclaration,
        variableDeclarator
      } = _t2;
      var referenceVisitor = {
        ReferencedIdentifier(path, state) {
          if (path.isJSXIdentifier() && react.isCompatTag(path.node.name) && !path.parentPath.isJSXMemberExpression()) {
            return;
          }
          if (path.node.name === "this") {
            let scope = path.scope;
            do {
              if (scope.path.isFunction() && !scope.path.isArrowFunctionExpression()) {
                break;
              }
            } while (scope = scope.parent);
            if (scope)
              state.breakOnScopePaths.push(scope.path);
          }
          const binding3 = path.scope.getBinding(path.node.name);
          if (!binding3)
            return;
          for (const violation of binding3.constantViolations) {
            if (violation.scope !== binding3.path.scope) {
              state.mutableBinding = true;
              path.stop();
              return;
            }
          }
          if (binding3 !== state.scope.getBinding(path.node.name))
            return;
          state.bindings[path.node.name] = binding3;
        }
      };
      var PathHoister = class {
        constructor(path, scope) {
          this.breakOnScopePaths = void 0;
          this.bindings = void 0;
          this.mutableBinding = void 0;
          this.scopes = void 0;
          this.scope = void 0;
          this.path = void 0;
          this.attachAfter = void 0;
          this.breakOnScopePaths = [];
          this.bindings = {};
          this.mutableBinding = false;
          this.scopes = [];
          this.scope = scope;
          this.path = path;
          this.attachAfter = false;
        }
        isCompatibleScope(scope) {
          for (const key of Object.keys(this.bindings)) {
            const binding3 = this.bindings[key];
            if (!scope.bindingIdentifierEquals(key, binding3.identifier)) {
              return false;
            }
          }
          return true;
        }
        getCompatibleScopes() {
          let scope = this.path.scope;
          do {
            if (this.isCompatibleScope(scope)) {
              this.scopes.push(scope);
            } else {
              break;
            }
            if (this.breakOnScopePaths.includes(scope.path)) {
              break;
            }
          } while (scope = scope.parent);
        }
        getAttachmentPath() {
          let path = this._getAttachmentPath();
          if (!path)
            return;
          let targetScope = path.scope;
          if (targetScope.path === path) {
            targetScope = path.scope.parent;
          }
          if (targetScope.path.isProgram() || targetScope.path.isFunction()) {
            for (const name of Object.keys(this.bindings)) {
              if (!targetScope.hasOwnBinding(name))
                continue;
              const binding3 = this.bindings[name];
              if (binding3.kind === "param" || binding3.path.parentKey === "params") {
                continue;
              }
              const bindingParentPath = this.getAttachmentParentForPath(binding3.path);
              if (bindingParentPath.key >= path.key) {
                this.attachAfter = true;
                path = binding3.path;
                for (const violationPath of binding3.constantViolations) {
                  if (this.getAttachmentParentForPath(violationPath).key > path.key) {
                    path = violationPath;
                  }
                }
              }
            }
          }
          return path;
        }
        _getAttachmentPath() {
          const scopes = this.scopes;
          const scope = scopes.pop();
          if (!scope)
            return;
          if (scope.path.isFunction()) {
            if (this.hasOwnParamBindings(scope)) {
              if (this.scope === scope)
                return;
              const bodies = scope.path.get("body").get("body");
              for (let i = 0; i < bodies.length; i++) {
                if (bodies[i].node._blockHoist)
                  continue;
                return bodies[i];
              }
            } else {
              return this.getNextScopeAttachmentParent();
            }
          } else if (scope.path.isProgram()) {
            return this.getNextScopeAttachmentParent();
          }
        }
        getNextScopeAttachmentParent() {
          const scope = this.scopes.pop();
          if (scope)
            return this.getAttachmentParentForPath(scope.path);
        }
        getAttachmentParentForPath(path) {
          do {
            if (!path.parentPath || Array.isArray(path.container) && path.isStatement()) {
              return path;
            }
          } while (path = path.parentPath);
        }
        hasOwnParamBindings(scope) {
          for (const name of Object.keys(this.bindings)) {
            if (!scope.hasOwnBinding(name))
              continue;
            const binding3 = this.bindings[name];
            if (binding3.kind === "param" && binding3.constant)
              return true;
          }
          return false;
        }
        run() {
          this.path.traverse(referenceVisitor, this);
          if (this.mutableBinding)
            return;
          this.getCompatibleScopes();
          const attachTo = this.getAttachmentPath();
          if (!attachTo)
            return;
          if (attachTo.getFunctionParent() === this.path.getFunctionParent())
            return;
          let uid = attachTo.scope.generateUidIdentifier("ref");
          const declarator = variableDeclarator(uid, this.path.node);
          const insertFn = this.attachAfter ? "insertAfter" : "insertBefore";
          const [attached] = attachTo[insertFn]([attachTo.isVariableDeclarator() ? declarator : variableDeclaration("var", [declarator])]);
          const parent2 = this.path.parentPath;
          if (parent2.isJSXElement() && this.path.container === parent2.node.children) {
            uid = jsxExpressionContainer(uid);
          }
          this.path.replaceWith(cloneNode(uid));
          return attachTo.isVariableDeclarator() ? attached.get("init") : attached.get("declarations.0.init");
        }
      };
      exports8.default = PathHoister;
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/modification.js
  var require_modification = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/modification.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8._containerInsert = _containerInsert;
      exports8._containerInsertAfter = _containerInsertAfter;
      exports8._containerInsertBefore = _containerInsertBefore;
      exports8._verifyNodeList = _verifyNodeList;
      exports8.insertAfter = insertAfter;
      exports8.insertBefore = insertBefore;
      exports8.pushContainer = pushContainer;
      exports8.unshiftContainer = unshiftContainer;
      exports8.updateSiblingKeys = updateSiblingKeys;
      var _cache = require_cache2();
      var _index = require_path();
      var _context = require_context2();
      var _removal = require_removal();
      var _t = require_lib5();
      var _hoister = require_hoister();
      var {
        arrowFunctionExpression: arrowFunctionExpression2,
        assertExpression,
        assignmentExpression,
        blockStatement,
        callExpression,
        cloneNode,
        expressionStatement: expressionStatement2,
        isAssignmentExpression,
        isCallExpression,
        isExportNamedDeclaration,
        isExpression,
        isIdentifier: isIdentifier2,
        isSequenceExpression,
        isSuper,
        thisExpression
      } = _t;
      function insertBefore(nodes_) {
        _removal._assertUnremoved.call(this);
        const nodes = _verifyNodeList.call(this, nodes_);
        const {
          parentPath,
          parent: parent2
        } = this;
        if (parentPath.isExpressionStatement() || parentPath.isLabeledStatement() || isExportNamedDeclaration(parent2) || parentPath.isExportDefaultDeclaration() && this.isDeclaration()) {
          return parentPath.insertBefore(nodes);
        } else if (this.isNodeType("Expression") && !this.isJSXElement() || parentPath.isForStatement() && this.key === "init") {
          if (this.node)
            nodes.push(this.node);
          return this.replaceExpressionWithStatements(nodes);
        } else if (Array.isArray(this.container)) {
          return _containerInsertBefore.call(this, nodes);
        } else if (this.isStatementOrBlock()) {
          const node = this.node;
          const shouldInsertCurrentNode = node && (!this.isExpressionStatement() || node.expression != null);
          this.replaceWith(blockStatement(shouldInsertCurrentNode ? [node] : []));
          return this.unshiftContainer("body", nodes);
        } else {
          throw new Error("We don't know what to do with this node type. We were previously a Statement but we can't fit in here?");
        }
      }
      function _containerInsert(from, nodes) {
        updateSiblingKeys.call(this, from, nodes.length);
        const paths = [];
        this.container.splice(from, 0, ...nodes);
        for (let i = 0; i < nodes.length; i++) {
          var _this$context;
          const to = from + i;
          const path = this.getSibling(to);
          paths.push(path);
          if ((_this$context = this.context) != null && _this$context.queue) {
            _context.pushContext.call(path, this.context);
          }
        }
        const contexts = _context._getQueueContexts.call(this);
        for (const path of paths) {
          _context.setScope.call(path);
          path.debug("Inserted.");
          for (const context of contexts) {
            context.maybeQueue(path, true);
          }
        }
        return paths;
      }
      function _containerInsertBefore(nodes) {
        return _containerInsert.call(this, this.key, nodes);
      }
      function _containerInsertAfter(nodes) {
        return _containerInsert.call(this, this.key + 1, nodes);
      }
      var last2 = (arr) => arr[arr.length - 1];
      function isHiddenInSequenceExpression(path) {
        return isSequenceExpression(path.parent) && (last2(path.parent.expressions) !== path.node || isHiddenInSequenceExpression(path.parentPath));
      }
      function isAlmostConstantAssignment(node, scope) {
        if (!isAssignmentExpression(node) || !isIdentifier2(node.left)) {
          return false;
        }
        const blockScope = scope.getBlockParent();
        return blockScope.hasOwnBinding(node.left.name) && blockScope.getOwnBinding(node.left.name).constantViolations.length <= 1;
      }
      function insertAfter(nodes_) {
        _removal._assertUnremoved.call(this);
        if (this.isSequenceExpression()) {
          return last2(this.get("expressions")).insertAfter(nodes_);
        }
        const nodes = _verifyNodeList.call(this, nodes_);
        const {
          parentPath,
          parent: parent2
        } = this;
        if (parentPath.isExpressionStatement() || parentPath.isLabeledStatement() || isExportNamedDeclaration(parent2) || parentPath.isExportDefaultDeclaration() && this.isDeclaration()) {
          return parentPath.insertAfter(nodes.map((node) => {
            return isExpression(node) ? expressionStatement2(node) : node;
          }));
        } else if (this.isNodeType("Expression") && !this.isJSXElement() && !parentPath.isJSXElement() || parentPath.isForStatement() && this.key === "init") {
          const self2 = this;
          if (self2.node) {
            const node = self2.node;
            let {
              scope
            } = this;
            if (scope.path.isPattern()) {
              assertExpression(node);
              self2.replaceWith(callExpression(arrowFunctionExpression2([], node), []));
              self2.get("callee.body").insertAfter(nodes);
              return [self2];
            }
            if (isHiddenInSequenceExpression(self2)) {
              nodes.unshift(node);
            } else if (isCallExpression(node) && isSuper(node.callee)) {
              nodes.unshift(node);
              nodes.push(thisExpression());
            } else if (isAlmostConstantAssignment(node, scope)) {
              nodes.unshift(node);
              nodes.push(cloneNode(node.left));
            } else if (scope.isPure(node, true)) {
              nodes.push(node);
            } else {
              if (parentPath.isMethod({
                computed: true,
                key: node
              })) {
                scope = scope.parent;
              }
              const temp = scope.generateDeclaredUidIdentifier();
              nodes.unshift(expressionStatement2(assignmentExpression("=", cloneNode(temp), node)));
              nodes.push(expressionStatement2(cloneNode(temp)));
            }
          }
          return this.replaceExpressionWithStatements(nodes);
        } else if (Array.isArray(this.container)) {
          return _containerInsertAfter.call(this, nodes);
        } else if (this.isStatementOrBlock()) {
          const node = this.node;
          const shouldInsertCurrentNode = node && (!this.isExpressionStatement() || node.expression != null);
          this.replaceWith(blockStatement(shouldInsertCurrentNode ? [node] : []));
          return this.pushContainer("body", nodes);
        } else {
          throw new Error("We don't know what to do with this node type. We were previously a Statement but we can't fit in here?");
        }
      }
      function updateSiblingKeys(fromIndex, incrementBy) {
        if (!this.parent)
          return;
        const paths = (0, _cache.getCachedPaths)(this);
        if (!paths)
          return;
        for (const [, path] of paths) {
          if (typeof path.key === "number" && path.container === this.container && path.key >= fromIndex) {
            path.key += incrementBy;
          }
        }
      }
      function _verifyNodeList(nodes) {
        if (!nodes) {
          return [];
        }
        if (!Array.isArray(nodes)) {
          nodes = [nodes];
        }
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];
          let msg;
          if (!node) {
            msg = "has falsy node";
          } else if (typeof node !== "object") {
            msg = "contains a non-object node";
          } else if (!node.type) {
            msg = "without a type";
          } else if (node instanceof _index.default) {
            msg = "has a NodePath when it expected a raw object";
          }
          if (msg) {
            const type = Array.isArray(node) ? "array" : typeof node;
            throw new Error(`Node list ${msg} with the index of ${i} and type of ${type}`);
          }
        }
        return nodes;
      }
      function unshiftContainer(listKey, nodes) {
        _removal._assertUnremoved.call(this);
        nodes = _verifyNodeList.call(this, nodes);
        const path = _index.default.get({
          parentPath: this,
          parent: this.node,
          container: this.node[listKey],
          listKey,
          key: 0
        }).setContext(this.context);
        return _containerInsertBefore.call(path, nodes);
      }
      function pushContainer(listKey, nodes) {
        _removal._assertUnremoved.call(this);
        const verifiedNodes = _verifyNodeList.call(this, nodes);
        const container = this.node[listKey];
        const path = _index.default.get({
          parentPath: this,
          parent: this.node,
          container,
          listKey,
          key: container.length
        }).setContext(this.context);
        return path.replaceWithMultiple(verifiedNodes);
      }
      {
        exports8.hoist = function hoist(scope = this.scope) {
          const hoister = new _hoister.default(this, scope);
          return hoister.run();
        };
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/replacement.js
  var require_replacement = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/replacement.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8._replaceWith = _replaceWith;
      exports8.replaceExpressionWithStatements = replaceExpressionWithStatements;
      exports8.replaceInline = replaceInline;
      exports8.replaceWith = replaceWith;
      exports8.replaceWithMultiple = replaceWithMultiple;
      exports8.replaceWithSourceString = replaceWithSourceString;
      var _codeFrame = require_lib7();
      var _index = require_lib9();
      var _index2 = require_path();
      var _cache = require_cache2();
      var _modification = require_modification();
      var _parser = require_lib2();
      var _t = require_lib5();
      var _context = require_context2();
      var {
        FUNCTION_TYPES,
        arrowFunctionExpression: arrowFunctionExpression2,
        assignmentExpression,
        awaitExpression,
        blockStatement,
        buildUndefinedNode,
        callExpression,
        cloneNode,
        conditionalExpression,
        expressionStatement: expressionStatement2,
        getBindingIdentifiers,
        identifier: identifier3,
        inheritLeadingComments,
        inheritTrailingComments,
        inheritsComments,
        isBlockStatement,
        isEmptyStatement,
        isExpression,
        isExpressionStatement,
        isIfStatement,
        isProgram,
        isStatement,
        isVariableDeclaration,
        removeComments,
        returnStatement,
        sequenceExpression,
        validate,
        yieldExpression
      } = _t;
      function replaceWithMultiple(nodes) {
        var _getCachedPaths;
        _context.resync.call(this);
        nodes = _modification._verifyNodeList.call(this, nodes);
        inheritLeadingComments(nodes[0], this.node);
        inheritTrailingComments(nodes[nodes.length - 1], this.node);
        (_getCachedPaths = (0, _cache.getCachedPaths)(this)) == null || _getCachedPaths.delete(this.node);
        this.node = this.container[this.key] = null;
        const paths = this.insertAfter(nodes);
        if (this.node) {
          this.requeue();
        } else {
          this.remove();
        }
        return paths;
      }
      function replaceWithSourceString(replacement) {
        _context.resync.call(this);
        let ast;
        try {
          replacement = `(${replacement})`;
          ast = (0, _parser.parse)(replacement);
        } catch (err) {
          const loc = err.loc;
          if (loc) {
            err.message += " - make sure this is an expression.\n" + (0, _codeFrame.codeFrameColumns)(replacement, {
              start: {
                line: loc.line,
                column: loc.column + 1
              }
            });
            err.code = "BABEL_REPLACE_SOURCE_ERROR";
          }
          throw err;
        }
        const expressionAST = ast.program.body[0].expression;
        _index.default.removeProperties(expressionAST);
        return this.replaceWith(expressionAST);
      }
      function replaceWith(replacementPath) {
        _context.resync.call(this);
        if (this.removed) {
          throw new Error("You can't replace this node, we've already removed it");
        }
        let replacement = replacementPath instanceof _index2.default ? replacementPath.node : replacementPath;
        if (!replacement) {
          throw new Error("You passed `path.replaceWith()` a falsy node, use `path.remove()` instead");
        }
        if (this.node === replacement) {
          return [this];
        }
        if (this.isProgram() && !isProgram(replacement)) {
          throw new Error("You can only replace a Program root node with another Program node");
        }
        if (Array.isArray(replacement)) {
          throw new Error("Don't use `path.replaceWith()` with an array of nodes, use `path.replaceWithMultiple()`");
        }
        if (typeof replacement === "string") {
          throw new Error("Don't use `path.replaceWith()` with a source string, use `path.replaceWithSourceString()`");
        }
        let nodePath = "";
        if (this.isNodeType("Statement") && isExpression(replacement)) {
          if (!this.canHaveVariableDeclarationOrExpression() && !this.canSwapBetweenExpressionAndStatement(replacement) && !this.parentPath.isExportDefaultDeclaration()) {
            replacement = expressionStatement2(replacement);
            nodePath = "expression";
          }
        }
        if (this.isNodeType("Expression") && isStatement(replacement)) {
          if (!this.canHaveVariableDeclarationOrExpression() && !this.canSwapBetweenExpressionAndStatement(replacement)) {
            return this.replaceExpressionWithStatements([replacement]);
          }
        }
        const oldNode = this.node;
        if (oldNode) {
          inheritsComments(replacement, oldNode);
          removeComments(oldNode);
        }
        _replaceWith.call(this, replacement);
        this.type = replacement.type;
        _context.setScope.call(this);
        this.requeue();
        return [nodePath ? this.get(nodePath) : this];
      }
      function _replaceWith(node) {
        var _getCachedPaths2;
        if (!this.container) {
          throw new ReferenceError("Container is falsy");
        }
        if (this.inList) {
          validate(this.parent, this.key, [node]);
        } else {
          validate(this.parent, this.key, node);
        }
        this.debug(`Replace with ${node == null ? void 0 : node.type}`);
        (_getCachedPaths2 = (0, _cache.getCachedPaths)(this)) == null || _getCachedPaths2.set(node, this).delete(this.node);
        this.node = this.container[this.key] = node;
      }
      function replaceExpressionWithStatements(nodes) {
        _context.resync.call(this);
        const declars = [];
        const nodesAsSingleExpression = gatherSequenceExpressions(nodes, declars);
        if (nodesAsSingleExpression) {
          for (const id of declars)
            this.scope.push({
              id
            });
          return this.replaceWith(nodesAsSingleExpression)[0].get("expressions");
        }
        const functionParent = this.getFunctionParent();
        const isParentAsync = functionParent == null ? void 0 : functionParent.node.async;
        const isParentGenerator = functionParent == null ? void 0 : functionParent.node.generator;
        const container = arrowFunctionExpression2([], blockStatement(nodes));
        this.replaceWith(callExpression(container, []));
        const callee = this.get("callee");
        callee.get("body").scope.hoistVariables((id) => this.scope.push({
          id
        }));
        const completionRecords = callee.getCompletionRecords();
        for (const path of completionRecords) {
          if (!path.isExpressionStatement())
            continue;
          const loop = path.findParent((path2) => path2.isLoop());
          if (loop) {
            let uid = loop.getData("expressionReplacementReturnUid");
            if (!uid) {
              uid = callee.scope.generateDeclaredUidIdentifier("ret");
              callee.get("body").pushContainer("body", returnStatement(cloneNode(uid)));
              loop.setData("expressionReplacementReturnUid", uid);
            } else {
              uid = identifier3(uid.name);
            }
            path.get("expression").replaceWith(assignmentExpression("=", cloneNode(uid), path.node.expression));
          } else {
            path.replaceWith(returnStatement(path.node.expression));
          }
        }
        callee.arrowFunctionToExpression();
        const newCallee = callee;
        const needToAwaitFunction = isParentAsync && _index.default.hasType(this.get("callee.body").node, "AwaitExpression", FUNCTION_TYPES);
        const needToYieldFunction = isParentGenerator && _index.default.hasType(this.get("callee.body").node, "YieldExpression", FUNCTION_TYPES);
        if (needToAwaitFunction) {
          newCallee.set("async", true);
          if (!needToYieldFunction) {
            this.replaceWith(awaitExpression(this.node));
          }
        }
        if (needToYieldFunction) {
          newCallee.set("generator", true);
          this.replaceWith(yieldExpression(this.node, true));
        }
        return newCallee.get("body.body");
      }
      function gatherSequenceExpressions(nodes, declars) {
        const exprs = [];
        let ensureLastUndefined = true;
        for (const node of nodes) {
          if (!isEmptyStatement(node)) {
            ensureLastUndefined = false;
          }
          if (isExpression(node)) {
            exprs.push(node);
          } else if (isExpressionStatement(node)) {
            exprs.push(node.expression);
          } else if (isVariableDeclaration(node)) {
            if (node.kind !== "var")
              return;
            for (const declar of node.declarations) {
              const bindings = getBindingIdentifiers(declar);
              for (const key of Object.keys(bindings)) {
                declars.push(cloneNode(bindings[key]));
              }
              if (declar.init) {
                exprs.push(assignmentExpression("=", declar.id, declar.init));
              }
            }
            ensureLastUndefined = true;
          } else if (isIfStatement(node)) {
            const consequent = node.consequent ? gatherSequenceExpressions([node.consequent], declars) : buildUndefinedNode();
            const alternate = node.alternate ? gatherSequenceExpressions([node.alternate], declars) : buildUndefinedNode();
            if (!consequent || !alternate)
              return;
            exprs.push(conditionalExpression(node.test, consequent, alternate));
          } else if (isBlockStatement(node)) {
            const body = gatherSequenceExpressions(node.body, declars);
            if (!body)
              return;
            exprs.push(body);
          } else if (isEmptyStatement(node)) {
            if (nodes.indexOf(node) === 0) {
              ensureLastUndefined = true;
            }
          } else {
            return;
          }
        }
        if (ensureLastUndefined)
          exprs.push(buildUndefinedNode());
        if (exprs.length === 1) {
          return exprs[0];
        } else {
          return sequenceExpression(exprs);
        }
      }
      function replaceInline(nodes) {
        _context.resync.call(this);
        if (Array.isArray(nodes)) {
          if (Array.isArray(this.container)) {
            nodes = _modification._verifyNodeList.call(this, nodes);
            const paths = _modification._containerInsertAfter.call(this, nodes);
            this.remove();
            return paths;
          } else {
            return this.replaceWithMultiple(nodes);
          }
        } else {
          return this.replaceWith(nodes);
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/evaluation.js
  var require_evaluation = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/evaluation.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.evaluate = evaluate;
      exports8.evaluateTruthy = evaluateTruthy;
      var VALID_OBJECT_CALLEES = ["Number", "String", "Math"];
      var VALID_IDENTIFIER_CALLEES = ["isFinite", "isNaN", "parseFloat", "parseInt", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", null, null];
      var INVALID_METHODS = ["random"];
      function isValidObjectCallee(val) {
        return VALID_OBJECT_CALLEES.includes(val);
      }
      function isValidIdentifierCallee(val) {
        return VALID_IDENTIFIER_CALLEES.includes(val);
      }
      function isInvalidMethod(val) {
        return INVALID_METHODS.includes(val);
      }
      function evaluateTruthy() {
        const res = this.evaluate();
        if (res.confident)
          return !!res.value;
      }
      function deopt(path, state) {
        if (!state.confident)
          return;
        state.deoptPath = path;
        state.confident = false;
      }
      var Globals = /* @__PURE__ */ new Map([["undefined", void 0], ["Infinity", Infinity], ["NaN", NaN]]);
      function evaluateCached(path, state) {
        const {
          node
        } = path;
        const {
          seen
        } = state;
        if (seen.has(node)) {
          const existing = seen.get(node);
          if (existing.resolved) {
            return existing.value;
          } else {
            deopt(path, state);
            return;
          }
        } else {
          const item = {
            resolved: false
          };
          seen.set(node, item);
          const val = _evaluate(path, state);
          if (state.confident) {
            item.resolved = true;
            item.value = val;
          }
          return val;
        }
      }
      function _evaluate(path, state) {
        if (!state.confident)
          return;
        if (path.isSequenceExpression()) {
          const exprs = path.get("expressions");
          return evaluateCached(exprs[exprs.length - 1], state);
        }
        if (path.isStringLiteral() || path.isNumericLiteral() || path.isBooleanLiteral()) {
          return path.node.value;
        }
        if (path.isNullLiteral()) {
          return null;
        }
        if (path.isTemplateLiteral()) {
          return evaluateQuasis(path, path.node.quasis, state);
        }
        if (path.isTaggedTemplateExpression() && path.get("tag").isMemberExpression()) {
          const object = path.get("tag.object");
          const {
            node: {
              name
            }
          } = object;
          const property2 = path.get("tag.property");
          if (object.isIdentifier() && name === "String" && !path.scope.getBinding(name) && property2.isIdentifier() && property2.node.name === "raw") {
            return evaluateQuasis(path, path.node.quasi.quasis, state, true);
          }
        }
        if (path.isConditionalExpression()) {
          const testResult = evaluateCached(path.get("test"), state);
          if (!state.confident)
            return;
          if (testResult) {
            return evaluateCached(path.get("consequent"), state);
          } else {
            return evaluateCached(path.get("alternate"), state);
          }
        }
        if (path.isExpressionWrapper()) {
          return evaluateCached(path.get("expression"), state);
        }
        if (path.isMemberExpression() && !path.parentPath.isCallExpression({
          callee: path.node
        })) {
          const property2 = path.get("property");
          const object = path.get("object");
          if (object.isLiteral()) {
            const value = object.node.value;
            const type = typeof value;
            let key = null;
            if (path.node.computed) {
              key = evaluateCached(property2, state);
              if (!state.confident)
                return;
            } else if (property2.isIdentifier()) {
              key = property2.node.name;
            }
            if ((type === "number" || type === "string") && key != null && (typeof key === "number" || typeof key === "string")) {
              return value[key];
            }
          }
        }
        if (path.isReferencedIdentifier()) {
          const binding3 = path.scope.getBinding(path.node.name);
          if (binding3) {
            if (binding3.constantViolations.length > 0 || path.node.start < binding3.path.node.end) {
              deopt(binding3.path, state);
              return;
            }
            const bindingPathScope = binding3.path.scope;
            if (binding3.kind === "var" && bindingPathScope !== binding3.scope) {
              let hasUnsafeBlock = !bindingPathScope.path.parentPath.isBlockStatement();
              for (let scope = bindingPathScope.parent; scope; scope = scope.parent) {
                var _scope$path$parentPat;
                if (scope === path.scope) {
                  if (hasUnsafeBlock) {
                    deopt(binding3.path, state);
                    return;
                  }
                  break;
                }
                if ((_scope$path$parentPat = scope.path.parentPath) != null && _scope$path$parentPat.isBlockStatement()) {
                  hasUnsafeBlock = true;
                }
              }
            }
            if (binding3.hasValue) {
              return binding3.value;
            }
          }
          const name = path.node.name;
          if (Globals.has(name)) {
            if (!binding3) {
              return Globals.get(name);
            }
            deopt(binding3.path, state);
            return;
          }
          const resolved = path.resolve();
          if (resolved === path) {
            deopt(path, state);
            return;
          }
          const value = evaluateCached(resolved, state);
          if (typeof value === "object" && value !== null && binding3.references > 1) {
            deopt(resolved, state);
            return;
          }
          return value;
        }
        if (path.isUnaryExpression({
          prefix: true
        })) {
          if (path.node.operator === "void") {
            return void 0;
          }
          const argument = path.get("argument");
          if (path.node.operator === "typeof" && (argument.isFunction() || argument.isClass())) {
            return "function";
          }
          const arg = evaluateCached(argument, state);
          if (!state.confident)
            return;
          switch (path.node.operator) {
            case "!":
              return !arg;
            case "+":
              return +arg;
            case "-":
              return -arg;
            case "~":
              return ~arg;
            case "typeof":
              return typeof arg;
          }
        }
        if (path.isArrayExpression()) {
          const arr = [];
          const elems = path.get("elements");
          for (const elem of elems) {
            const elemValue = elem.evaluate();
            if (elemValue.confident) {
              arr.push(elemValue.value);
            } else {
              deopt(elemValue.deopt, state);
              return;
            }
          }
          return arr;
        }
        if (path.isObjectExpression()) {
          const obj = {};
          const props = path.get("properties");
          for (const prop of props) {
            if (prop.isObjectMethod() || prop.isSpreadElement()) {
              deopt(prop, state);
              return;
            }
            const keyPath = prop.get("key");
            let key;
            if (prop.node.computed) {
              key = keyPath.evaluate();
              if (!key.confident) {
                deopt(key.deopt, state);
                return;
              }
              key = key.value;
            } else if (keyPath.isIdentifier()) {
              key = keyPath.node.name;
            } else {
              key = keyPath.node.value;
            }
            const valuePath = prop.get("value");
            let value = valuePath.evaluate();
            if (!value.confident) {
              deopt(value.deopt, state);
              return;
            }
            value = value.value;
            obj[key] = value;
          }
          return obj;
        }
        if (path.isLogicalExpression()) {
          const wasConfident = state.confident;
          const left = evaluateCached(path.get("left"), state);
          const leftConfident = state.confident;
          state.confident = wasConfident;
          const right = evaluateCached(path.get("right"), state);
          const rightConfident = state.confident;
          switch (path.node.operator) {
            case "||":
              state.confident = leftConfident && (!!left || rightConfident);
              if (!state.confident)
                return;
              return left || right;
            case "&&":
              state.confident = leftConfident && (!left || rightConfident);
              if (!state.confident)
                return;
              return left && right;
            case "??":
              state.confident = leftConfident && (left != null || rightConfident);
              if (!state.confident)
                return;
              return left != null ? left : right;
          }
        }
        if (path.isBinaryExpression()) {
          const left = evaluateCached(path.get("left"), state);
          if (!state.confident)
            return;
          const right = evaluateCached(path.get("right"), state);
          if (!state.confident)
            return;
          switch (path.node.operator) {
            case "-":
              return left - right;
            case "+":
              return left + right;
            case "/":
              return left / right;
            case "*":
              return left * right;
            case "%":
              return left % right;
            case "**":
              return Math.pow(left, right);
            case "<":
              return left < right;
            case ">":
              return left > right;
            case "<=":
              return left <= right;
            case ">=":
              return left >= right;
            case "==":
              return left == right;
            case "!=":
              return left != right;
            case "===":
              return left === right;
            case "!==":
              return left !== right;
            case "|":
              return left | right;
            case "&":
              return left & right;
            case "^":
              return left ^ right;
            case "<<":
              return left << right;
            case ">>":
              return left >> right;
            case ">>>":
              return left >>> right;
          }
        }
        if (path.isCallExpression()) {
          const callee = path.get("callee");
          let context;
          let func;
          if (callee.isIdentifier() && !path.scope.getBinding(callee.node.name) && (isValidObjectCallee(callee.node.name) || isValidIdentifierCallee(callee.node.name))) {
            func = global[callee.node.name];
          }
          if (callee.isMemberExpression()) {
            const object = callee.get("object");
            const property2 = callee.get("property");
            if (object.isIdentifier() && property2.isIdentifier() && isValidObjectCallee(object.node.name) && !isInvalidMethod(property2.node.name)) {
              context = global[object.node.name];
              const key = property2.node.name;
              if (hasOwnProperty.call(context, key)) {
                func = context[key];
              }
            }
            if (object.isLiteral() && property2.isIdentifier()) {
              const type = typeof object.node.value;
              if (type === "string" || type === "number") {
                context = object.node.value;
                func = context[property2.node.name];
              }
            }
          }
          if (func) {
            const args = path.get("arguments").map((arg) => evaluateCached(arg, state));
            if (!state.confident)
              return;
            return func.apply(context, args);
          }
        }
        deopt(path, state);
      }
      function evaluateQuasis(path, quasis, state, raw = false) {
        let str = "";
        let i = 0;
        const exprs = path.isTemplateLiteral() ? path.get("expressions") : path.get("quasi.expressions");
        for (const elem of quasis) {
          if (!state.confident)
            break;
          str += raw ? elem.value.raw : elem.value.cooked;
          const expr = exprs[i++];
          if (expr)
            str += String(evaluateCached(expr, state));
        }
        if (!state.confident)
          return;
        return str;
      }
      function evaluate() {
        const state = {
          confident: true,
          deoptPath: null,
          seen: /* @__PURE__ */ new Map()
        };
        let value = evaluateCached(this, state);
        if (!state.confident)
          value = void 0;
        return {
          confident: state.confident,
          deopt: state.deoptPath,
          value
        };
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/formatters.js
  var require_formatters = __commonJS({
    "../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/formatters.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.statements = exports8.statement = exports8.smart = exports8.program = exports8.expression = void 0;
      var _t = require_lib5();
      var {
        assertExpressionStatement
      } = _t;
      function makeStatementFormatter(fn) {
        return {
          code: (str) => `/* @babel/template */;
${str}`,
          validate: () => {
          },
          unwrap: (ast) => {
            return fn(ast.program.body.slice(1));
          }
        };
      }
      var smart = exports8.smart = makeStatementFormatter((body) => {
        if (body.length > 1) {
          return body;
        } else {
          return body[0];
        }
      });
      var statements = exports8.statements = makeStatementFormatter((body) => body);
      var statement = exports8.statement = makeStatementFormatter((body) => {
        if (body.length === 0) {
          throw new Error("Found nothing to return.");
        }
        if (body.length > 1) {
          throw new Error("Found multiple statements but wanted one");
        }
        return body[0];
      });
      var expression = exports8.expression = {
        code: (str) => `(
${str}
)`,
        validate: (ast) => {
          if (ast.program.body.length > 1) {
            throw new Error("Found multiple statements but wanted one");
          }
          if (expression.unwrap(ast).start === 0) {
            throw new Error("Parse result included parens.");
          }
        },
        unwrap: ({
          program: program4
        }) => {
          const [stmt] = program4.body;
          assertExpressionStatement(stmt);
          return stmt.expression;
        }
      };
      var program3 = exports8.program = {
        code: (str) => str,
        validate: () => {
        },
        unwrap: (ast) => ast.program
      };
    }
  });

  // ../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/options.js
  var require_options = __commonJS({
    "../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/options.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.merge = merge2;
      exports8.normalizeReplacements = normalizeReplacements;
      exports8.validate = validate;
      var _excluded = ["placeholderWhitelist", "placeholderPattern", "preserveComments", "syntacticPlaceholders"];
      function _objectWithoutPropertiesLoose(r, e) {
        if (null == r)
          return {};
        var t3 = {};
        for (var n in r)
          if ({}.hasOwnProperty.call(r, n)) {
            if (-1 !== e.indexOf(n))
              continue;
            t3[n] = r[n];
          }
        return t3;
      }
      function merge2(a, b) {
        const {
          placeholderWhitelist = a.placeholderWhitelist,
          placeholderPattern = a.placeholderPattern,
          preserveComments = a.preserveComments,
          syntacticPlaceholders = a.syntacticPlaceholders
        } = b;
        return {
          parser: Object.assign({}, a.parser, b.parser),
          placeholderWhitelist,
          placeholderPattern,
          preserveComments,
          syntacticPlaceholders
        };
      }
      function validate(opts) {
        if (opts != null && typeof opts !== "object") {
          throw new Error("Unknown template options.");
        }
        const _ref = opts || {}, {
          placeholderWhitelist,
          placeholderPattern,
          preserveComments,
          syntacticPlaceholders
        } = _ref, parser3 = _objectWithoutPropertiesLoose(_ref, _excluded);
        if (placeholderWhitelist != null && !(placeholderWhitelist instanceof Set)) {
          throw new Error("'.placeholderWhitelist' must be a Set, null, or undefined");
        }
        if (placeholderPattern != null && !(placeholderPattern instanceof RegExp) && placeholderPattern !== false) {
          throw new Error("'.placeholderPattern' must be a RegExp, false, null, or undefined");
        }
        if (preserveComments != null && typeof preserveComments !== "boolean") {
          throw new Error("'.preserveComments' must be a boolean, null, or undefined");
        }
        if (syntacticPlaceholders != null && typeof syntacticPlaceholders !== "boolean") {
          throw new Error("'.syntacticPlaceholders' must be a boolean, null, or undefined");
        }
        if (syntacticPlaceholders === true && (placeholderWhitelist != null || placeholderPattern != null)) {
          throw new Error("'.placeholderWhitelist' and '.placeholderPattern' aren't compatible with '.syntacticPlaceholders: true'");
        }
        return {
          parser: parser3,
          placeholderWhitelist: placeholderWhitelist || void 0,
          placeholderPattern: placeholderPattern == null ? void 0 : placeholderPattern,
          preserveComments: preserveComments == null ? void 0 : preserveComments,
          syntacticPlaceholders: syntacticPlaceholders == null ? void 0 : syntacticPlaceholders
        };
      }
      function normalizeReplacements(replacements) {
        if (Array.isArray(replacements)) {
          return replacements.reduce((acc, replacement, i) => {
            acc["$" + i] = replacement;
            return acc;
          }, {});
        } else if (typeof replacements === "object" || replacements == null) {
          return replacements || void 0;
        }
        throw new Error("Template replacements must be an array, object, null, or undefined");
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/parse.js
  var require_parse = __commonJS({
    "../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/parse.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = parseAndBuildMetadata;
      var _t = require_lib5();
      var _parser = require_lib2();
      var _codeFrame = require_lib7();
      var {
        isCallExpression,
        isExpressionStatement,
        isFunction: isFunction3,
        isIdentifier: isIdentifier2,
        isJSXIdentifier,
        isNewExpression,
        isPlaceholder,
        isStatement,
        isStringLiteral,
        removePropertiesDeep,
        traverse: traverse3
      } = _t;
      var PATTERN = /^[_$A-Z0-9]+$/;
      function parseAndBuildMetadata(formatter, code, opts) {
        const {
          placeholderWhitelist,
          placeholderPattern,
          preserveComments,
          syntacticPlaceholders
        } = opts;
        const ast = parseWithCodeFrame(code, opts.parser, syntacticPlaceholders);
        removePropertiesDeep(ast, {
          preserveComments
        });
        formatter.validate(ast);
        const state = {
          syntactic: {
            placeholders: [],
            placeholderNames: /* @__PURE__ */ new Set()
          },
          legacy: {
            placeholders: [],
            placeholderNames: /* @__PURE__ */ new Set()
          },
          placeholderWhitelist,
          placeholderPattern,
          syntacticPlaceholders
        };
        traverse3(ast, placeholderVisitorHandler, state);
        return Object.assign({
          ast
        }, state.syntactic.placeholders.length ? state.syntactic : state.legacy);
      }
      function placeholderVisitorHandler(node, ancestors, state) {
        var _state$placeholderWhi;
        let name;
        let hasSyntacticPlaceholders = state.syntactic.placeholders.length > 0;
        if (isPlaceholder(node)) {
          if (state.syntacticPlaceholders === false) {
            throw new Error("%%foo%%-style placeholders can't be used when '.syntacticPlaceholders' is false.");
          }
          name = node.name.name;
          hasSyntacticPlaceholders = true;
        } else if (hasSyntacticPlaceholders || state.syntacticPlaceholders) {
          return;
        } else if (isIdentifier2(node) || isJSXIdentifier(node)) {
          name = node.name;
        } else if (isStringLiteral(node)) {
          name = node.value;
        } else {
          return;
        }
        if (hasSyntacticPlaceholders && (state.placeholderPattern != null || state.placeholderWhitelist != null)) {
          throw new Error("'.placeholderWhitelist' and '.placeholderPattern' aren't compatible with '.syntacticPlaceholders: true'");
        }
        if (!hasSyntacticPlaceholders && (state.placeholderPattern === false || !(state.placeholderPattern || PATTERN).test(name)) && !((_state$placeholderWhi = state.placeholderWhitelist) != null && _state$placeholderWhi.has(name))) {
          return;
        }
        ancestors = ancestors.slice();
        const {
          node: parent2,
          key
        } = ancestors[ancestors.length - 1];
        let type;
        if (isStringLiteral(node) || isPlaceholder(node, {
          expectedNode: "StringLiteral"
        })) {
          type = "string";
        } else if (isNewExpression(parent2) && key === "arguments" || isCallExpression(parent2) && key === "arguments" || isFunction3(parent2) && key === "params") {
          type = "param";
        } else if (isExpressionStatement(parent2) && !isPlaceholder(node)) {
          type = "statement";
          ancestors = ancestors.slice(0, -1);
        } else if (isStatement(node) && isPlaceholder(node)) {
          type = "statement";
        } else {
          type = "other";
        }
        const {
          placeholders,
          placeholderNames
        } = !hasSyntacticPlaceholders ? state.legacy : state.syntactic;
        placeholders.push({
          name,
          type,
          resolve: (ast) => resolveAncestors(ast, ancestors),
          isDuplicate: placeholderNames.has(name)
        });
        placeholderNames.add(name);
      }
      function resolveAncestors(ast, ancestors) {
        let parent2 = ast;
        for (let i = 0; i < ancestors.length - 1; i++) {
          const {
            key: key2,
            index: index2
          } = ancestors[i];
          if (index2 === void 0) {
            parent2 = parent2[key2];
          } else {
            parent2 = parent2[key2][index2];
          }
        }
        const {
          key,
          index
        } = ancestors[ancestors.length - 1];
        return {
          parent: parent2,
          key,
          index
        };
      }
      function parseWithCodeFrame(code, parserOpts, syntacticPlaceholders) {
        const plugins3 = (parserOpts.plugins || []).slice();
        if (syntacticPlaceholders !== false) {
          plugins3.push("placeholders");
        }
        parserOpts = Object.assign({
          allowAwaitOutsideFunction: true,
          allowReturnOutsideFunction: true,
          allowNewTargetOutsideFunction: true,
          allowSuperOutsideMethod: true,
          allowYieldOutsideFunction: true,
          sourceType: "module"
        }, parserOpts, {
          plugins: plugins3
        });
        try {
          return (0, _parser.parse)(code, parserOpts);
        } catch (err) {
          const loc = err.loc;
          if (loc) {
            err.message += "\n" + (0, _codeFrame.codeFrameColumns)(code, {
              start: loc
            });
            err.code = "BABEL_TEMPLATE_PARSE_ERROR";
          }
          throw err;
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/populate.js
  var require_populate = __commonJS({
    "../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/populate.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = populatePlaceholders;
      var _t = require_lib5();
      var {
        blockStatement,
        cloneNode,
        emptyStatement,
        expressionStatement: expressionStatement2,
        identifier: identifier3,
        isStatement,
        isStringLiteral,
        stringLiteral,
        validate
      } = _t;
      function populatePlaceholders(metadata, replacements) {
        const ast = cloneNode(metadata.ast);
        if (replacements) {
          metadata.placeholders.forEach((placeholder) => {
            if (!hasOwnProperty.call(replacements, placeholder.name)) {
              const placeholderName = placeholder.name;
              throw new Error(`Error: No substitution given for "${placeholderName}". If this is not meant to be a
            placeholder you may want to consider passing one of the following options to @babel/template:
            - { placeholderPattern: false, placeholderWhitelist: new Set(['${placeholderName}'])}
            - { placeholderPattern: /^${placeholderName}$/ }`);
            }
          });
          Object.keys(replacements).forEach((key) => {
            if (!metadata.placeholderNames.has(key)) {
              throw new Error(`Unknown substitution "${key}" given`);
            }
          });
        }
        metadata.placeholders.slice().reverse().forEach((placeholder) => {
          try {
            var _ref;
            applyReplacement(placeholder, ast, (_ref = replacements && replacements[placeholder.name]) != null ? _ref : null);
          } catch (e) {
            e.message = `@babel/template placeholder "${placeholder.name}": ${e.message}`;
            throw e;
          }
        });
        return ast;
      }
      function applyReplacement(placeholder, ast, replacement) {
        if (placeholder.isDuplicate) {
          if (Array.isArray(replacement)) {
            replacement = replacement.map((node) => cloneNode(node));
          } else if (typeof replacement === "object") {
            replacement = cloneNode(replacement);
          }
        }
        const {
          parent: parent2,
          key,
          index
        } = placeholder.resolve(ast);
        if (placeholder.type === "string") {
          if (typeof replacement === "string") {
            replacement = stringLiteral(replacement);
          }
          if (!replacement || !isStringLiteral(replacement)) {
            throw new Error("Expected string substitution");
          }
        } else if (placeholder.type === "statement") {
          if (index === void 0) {
            if (!replacement) {
              replacement = emptyStatement();
            } else if (Array.isArray(replacement)) {
              replacement = blockStatement(replacement);
            } else if (typeof replacement === "string") {
              replacement = expressionStatement2(identifier3(replacement));
            } else if (!isStatement(replacement)) {
              replacement = expressionStatement2(replacement);
            }
          } else {
            if (replacement && !Array.isArray(replacement)) {
              if (typeof replacement === "string") {
                replacement = identifier3(replacement);
              }
              if (!isStatement(replacement)) {
                replacement = expressionStatement2(replacement);
              }
            }
          }
        } else if (placeholder.type === "param") {
          if (typeof replacement === "string") {
            replacement = identifier3(replacement);
          }
          if (index === void 0)
            throw new Error("Assertion failure.");
        } else {
          if (typeof replacement === "string") {
            replacement = identifier3(replacement);
          }
          if (Array.isArray(replacement)) {
            throw new Error("Cannot replace single expression with an array.");
          }
        }
        function set2(parent3, key2, value) {
          const node = parent3[key2];
          parent3[key2] = value;
          if (node.type === "Identifier" || node.type === "Placeholder") {
            if (node.typeAnnotation) {
              value.typeAnnotation = node.typeAnnotation;
            }
            if (node.optional) {
              value.optional = node.optional;
            }
            if (node.decorators) {
              value.decorators = node.decorators;
            }
          }
        }
        if (index === void 0) {
          validate(parent2, key, replacement);
          set2(parent2, key, replacement);
        } else {
          const items = parent2[key].slice();
          if (placeholder.type === "statement" || placeholder.type === "param") {
            if (replacement == null) {
              items.splice(index, 1);
            } else if (Array.isArray(replacement)) {
              items.splice(index, 1, ...replacement);
            } else {
              set2(items, index, replacement);
            }
          } else {
            set2(items, index, replacement);
          }
          validate(parent2, key, items);
          parent2[key] = items;
        }
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/string.js
  var require_string = __commonJS({
    "../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/string.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = stringTemplate;
      var _options = require_options();
      var _parse = require_parse();
      var _populate = require_populate();
      function stringTemplate(formatter, code, opts) {
        code = formatter.code(code);
        let metadata;
        return (arg) => {
          const replacements = (0, _options.normalizeReplacements)(arg);
          if (!metadata)
            metadata = (0, _parse.default)(formatter, code, opts);
          return formatter.unwrap((0, _populate.default)(metadata, replacements));
        };
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/literal.js
  var require_literal = __commonJS({
    "../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/literal.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = literalTemplate;
      var _options = require_options();
      var _parse = require_parse();
      var _populate = require_populate();
      function literalTemplate(formatter, tpl, opts) {
        const {
          metadata,
          names
        } = buildLiteralData(formatter, tpl, opts);
        return (arg) => {
          const defaultReplacements = {};
          arg.forEach((replacement, i) => {
            defaultReplacements[names[i]] = replacement;
          });
          return (arg2) => {
            const replacements = (0, _options.normalizeReplacements)(arg2);
            if (replacements) {
              Object.keys(replacements).forEach((key) => {
                if (hasOwnProperty.call(defaultReplacements, key)) {
                  throw new Error("Unexpected replacement overlap.");
                }
              });
            }
            return formatter.unwrap((0, _populate.default)(metadata, replacements ? Object.assign(replacements, defaultReplacements) : defaultReplacements));
          };
        };
      }
      function buildLiteralData(formatter, tpl, opts) {
        let prefix = "BABEL_TPL$";
        const raw = tpl.join("");
        do {
          prefix = "$$" + prefix;
        } while (raw.includes(prefix));
        const {
          names,
          code
        } = buildTemplateCode(tpl, prefix);
        const metadata = (0, _parse.default)(formatter, formatter.code(code), {
          parser: opts.parser,
          placeholderWhitelist: new Set(names.concat(opts.placeholderWhitelist ? Array.from(opts.placeholderWhitelist) : [])),
          placeholderPattern: opts.placeholderPattern,
          preserveComments: opts.preserveComments,
          syntacticPlaceholders: opts.syntacticPlaceholders
        });
        return {
          metadata,
          names
        };
      }
      function buildTemplateCode(tpl, prefix) {
        const names = [];
        let code = tpl[0];
        for (let i = 1; i < tpl.length; i++) {
          const value = `${prefix}${i - 1}`;
          names.push(value);
          code += value + tpl[i];
        }
        return {
          names,
          code
        };
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/builder.js
  var require_builder = __commonJS({
    "../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/builder.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = createTemplateBuilder;
      var _options = require_options();
      var _string = require_string();
      var _literal = require_literal();
      var NO_PLACEHOLDER = (0, _options.validate)({
        placeholderPattern: false
      });
      function createTemplateBuilder(formatter, defaultOpts) {
        const templateFnCache = /* @__PURE__ */ new WeakMap();
        const templateAstCache = /* @__PURE__ */ new WeakMap();
        const cachedOpts = defaultOpts || (0, _options.validate)(null);
        return Object.assign((tpl, ...args) => {
          if (typeof tpl === "string") {
            if (args.length > 1)
              throw new Error("Unexpected extra params.");
            return extendedTrace((0, _string.default)(formatter, tpl, (0, _options.merge)(cachedOpts, (0, _options.validate)(args[0]))));
          } else if (Array.isArray(tpl)) {
            let builder = templateFnCache.get(tpl);
            if (!builder) {
              builder = (0, _literal.default)(formatter, tpl, cachedOpts);
              templateFnCache.set(tpl, builder);
            }
            return extendedTrace(builder(args));
          } else if (typeof tpl === "object" && tpl) {
            if (args.length > 0)
              throw new Error("Unexpected extra params.");
            return createTemplateBuilder(formatter, (0, _options.merge)(cachedOpts, (0, _options.validate)(tpl)));
          }
          throw new Error(`Unexpected template param ${typeof tpl}`);
        }, {
          ast: (tpl, ...args) => {
            if (typeof tpl === "string") {
              if (args.length > 1)
                throw new Error("Unexpected extra params.");
              return (0, _string.default)(formatter, tpl, (0, _options.merge)((0, _options.merge)(cachedOpts, (0, _options.validate)(args[0])), NO_PLACEHOLDER))();
            } else if (Array.isArray(tpl)) {
              let builder = templateAstCache.get(tpl);
              if (!builder) {
                builder = (0, _literal.default)(formatter, tpl, (0, _options.merge)(cachedOpts, NO_PLACEHOLDER));
                templateAstCache.set(tpl, builder);
              }
              return builder(args)();
            }
            throw new Error(`Unexpected template param ${typeof tpl}`);
          }
        });
      }
      function extendedTrace(fn) {
        let rootStack = "";
        try {
          throw new Error();
        } catch (error) {
          if (error.stack) {
            rootStack = error.stack.split("\n").slice(3).join("\n");
          }
        }
        return (arg) => {
          try {
            return fn(arg);
          } catch (err) {
            err.stack += `
    =============
${rootStack}`;
            throw err;
          }
        };
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/index.js
  var require_lib8 = __commonJS({
    "../../node_modules/.pnpm/@babel+template@7.27.2/node_modules/@babel/template/lib/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.statements = exports8.statement = exports8.smart = exports8.program = exports8.expression = exports8.default = void 0;
      var formatters = require_formatters();
      var _builder = require_builder();
      var smart = exports8.smart = (0, _builder.default)(formatters.smart);
      var statement = exports8.statement = (0, _builder.default)(formatters.statement);
      var statements = exports8.statements = (0, _builder.default)(formatters.statements);
      var expression = exports8.expression = (0, _builder.default)(formatters.expression);
      var program3 = exports8.program = (0, _builder.default)(formatters.program);
      var _default = exports8.default = Object.assign(smart.bind(void 0), {
        smart,
        statement,
        statements,
        expression,
        program: program3,
        ast: smart.ast
      });
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/conversion.js
  var require_conversion = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/conversion.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.arrowFunctionToExpression = arrowFunctionToExpression;
      exports8.ensureBlock = ensureBlock;
      exports8.ensureFunctionName = ensureFunctionName;
      exports8.splitExportDeclaration = splitExportDeclaration;
      exports8.toComputedKey = toComputedKey;
      exports8.unwrapFunctionEnvironment = unwrapFunctionEnvironment;
      var _t = require_lib5();
      var _template = require_lib8();
      var _visitors = require_visitors();
      var _context = require_context2();
      var {
        arrowFunctionExpression: arrowFunctionExpression2,
        assignmentExpression,
        binaryExpression,
        blockStatement,
        callExpression,
        conditionalExpression,
        expressionStatement: expressionStatement2,
        identifier: identifier3,
        isIdentifier: isIdentifier2,
        jsxIdentifier,
        logicalExpression,
        LOGICAL_OPERATORS,
        memberExpression,
        metaProperty,
        numericLiteral,
        objectExpression,
        restElement,
        returnStatement,
        sequenceExpression,
        spreadElement,
        stringLiteral,
        super: _super,
        thisExpression,
        toExpression,
        unaryExpression,
        toBindingIdentifierName,
        isFunction: isFunction3,
        isAssignmentPattern,
        isRestElement,
        getFunctionName,
        cloneNode,
        variableDeclaration,
        variableDeclarator,
        exportNamedDeclaration,
        exportSpecifier,
        inherits: inherits2
      } = _t;
      function toComputedKey() {
        let key;
        if (this.isMemberExpression()) {
          key = this.node.property;
        } else if (this.isProperty() || this.isMethod()) {
          key = this.node.key;
        } else {
          throw new ReferenceError("todo");
        }
        if (!this.node.computed) {
          if (isIdentifier2(key))
            key = stringLiteral(key.name);
        }
        return key;
      }
      function ensureBlock() {
        const body = this.get("body");
        const bodyNode = body.node;
        if (Array.isArray(body)) {
          throw new Error("Can't convert array path to a block statement");
        }
        if (!bodyNode) {
          throw new Error("Can't convert node without a body");
        }
        if (body.isBlockStatement()) {
          return bodyNode;
        }
        const statements = [];
        let stringPath = "body";
        let key;
        let listKey;
        if (body.isStatement()) {
          listKey = "body";
          key = 0;
          statements.push(body.node);
        } else {
          stringPath += ".body.0";
          if (this.isFunction()) {
            key = "argument";
            statements.push(returnStatement(body.node));
          } else {
            key = "expression";
            statements.push(expressionStatement2(body.node));
          }
        }
        this.node.body = blockStatement(statements);
        const parentPath = this.get(stringPath);
        _context.setup.call(body, parentPath, listKey ? parentPath.node[listKey] : parentPath.node, listKey, key);
        return this.node;
      }
      {
        exports8.arrowFunctionToShadowed = function() {
          if (!this.isArrowFunctionExpression())
            return;
          this.arrowFunctionToExpression();
        };
      }
      function unwrapFunctionEnvironment() {
        if (!this.isArrowFunctionExpression() && !this.isFunctionExpression() && !this.isFunctionDeclaration()) {
          throw this.buildCodeFrameError("Can only unwrap the environment of a function.");
        }
        hoistFunctionEnvironment(this);
      }
      function setType(path, type) {
        path.node.type = type;
      }
      function arrowFunctionToExpression({
        allowInsertArrow = true,
        allowInsertArrowWithRest = allowInsertArrow,
        noNewArrows = !((_arguments$) => (_arguments$ = arguments[0]) == null ? void 0 : _arguments$.specCompliant)()
      } = {}) {
        if (!this.isArrowFunctionExpression()) {
          throw this.buildCodeFrameError("Cannot convert non-arrow function to a function expression.");
        }
        let self2 = this;
        if (!noNewArrows) {
          var _self$ensureFunctionN;
          self2 = (_self$ensureFunctionN = self2.ensureFunctionName(false)) != null ? _self$ensureFunctionN : self2;
        }
        const {
          thisBinding,
          fnPath: fn
        } = hoistFunctionEnvironment(self2, noNewArrows, allowInsertArrow, allowInsertArrowWithRest);
        fn.ensureBlock();
        setType(fn, "FunctionExpression");
        if (!noNewArrows) {
          const checkBinding = thisBinding ? null : fn.scope.generateUidIdentifier("arrowCheckId");
          if (checkBinding) {
            fn.parentPath.scope.push({
              id: checkBinding,
              init: objectExpression([])
            });
          }
          fn.get("body").unshiftContainer("body", expressionStatement2(callExpression(this.hub.addHelper("newArrowCheck"), [thisExpression(), checkBinding ? identifier3(checkBinding.name) : identifier3(thisBinding)])));
          fn.replaceWith(callExpression(memberExpression(fn.node, identifier3("bind")), [checkBinding ? identifier3(checkBinding.name) : thisExpression()]));
          return fn.get("callee.object");
        }
        return fn;
      }
      var getSuperCallsVisitor = (0, _visitors.environmentVisitor)({
        CallExpression(child, {
          allSuperCalls
        }) {
          if (!child.get("callee").isSuper())
            return;
          allSuperCalls.push(child);
        }
      });
      function hoistFunctionEnvironment(fnPath, noNewArrows = true, allowInsertArrow = true, allowInsertArrowWithRest = true) {
        let arrowParent;
        let thisEnvFn = fnPath.findParent((p) => {
          if (p.isArrowFunctionExpression()) {
            arrowParent != null ? arrowParent : arrowParent = p;
            return false;
          }
          return p.isFunction() || p.isProgram() || p.isClassProperty({
            static: false
          }) || p.isClassPrivateProperty({
            static: false
          });
        });
        const inConstructor = thisEnvFn.isClassMethod({
          kind: "constructor"
        });
        if (thisEnvFn.isClassProperty() || thisEnvFn.isClassPrivateProperty()) {
          if (arrowParent) {
            thisEnvFn = arrowParent;
          } else if (allowInsertArrow) {
            fnPath.replaceWith(callExpression(arrowFunctionExpression2([], toExpression(fnPath.node)), []));
            thisEnvFn = fnPath.get("callee");
            fnPath = thisEnvFn.get("body");
          } else {
            throw fnPath.buildCodeFrameError("Unable to transform arrow inside class property");
          }
        }
        const {
          thisPaths,
          argumentsPaths,
          newTargetPaths,
          superProps,
          superCalls
        } = getScopeInformation(fnPath);
        if (inConstructor && superCalls.length > 0) {
          if (!allowInsertArrow) {
            throw superCalls[0].buildCodeFrameError("When using '@babel/plugin-transform-arrow-functions', it's not possible to compile `super()` in an arrow function without compiling classes.\nPlease add '@babel/plugin-transform-classes' to your Babel configuration.");
          }
          if (!allowInsertArrowWithRest) {
            throw superCalls[0].buildCodeFrameError("When using '@babel/plugin-transform-parameters', it's not possible to compile `super()` in an arrow function with default or rest parameters without compiling classes.\nPlease add '@babel/plugin-transform-classes' to your Babel configuration.");
          }
          const allSuperCalls = [];
          thisEnvFn.traverse(getSuperCallsVisitor, {
            allSuperCalls
          });
          const superBinding = getSuperBinding(thisEnvFn);
          allSuperCalls.forEach((superCall) => {
            const callee = identifier3(superBinding);
            callee.loc = superCall.node.callee.loc;
            superCall.get("callee").replaceWith(callee);
          });
        }
        if (argumentsPaths.length > 0) {
          const argumentsBinding = getBinding(thisEnvFn, "arguments", () => {
            const args = () => identifier3("arguments");
            if (thisEnvFn.scope.path.isProgram()) {
              return conditionalExpression(binaryExpression("===", unaryExpression("typeof", args()), stringLiteral("undefined")), thisEnvFn.scope.buildUndefinedNode(), args());
            } else {
              return args();
            }
          });
          argumentsPaths.forEach((argumentsChild) => {
            const argsRef = identifier3(argumentsBinding);
            argsRef.loc = argumentsChild.node.loc;
            argumentsChild.replaceWith(argsRef);
          });
        }
        if (newTargetPaths.length > 0) {
          const newTargetBinding = getBinding(thisEnvFn, "newtarget", () => metaProperty(identifier3("new"), identifier3("target")));
          newTargetPaths.forEach((targetChild) => {
            const targetRef = identifier3(newTargetBinding);
            targetRef.loc = targetChild.node.loc;
            targetChild.replaceWith(targetRef);
          });
        }
        if (superProps.length > 0) {
          if (!allowInsertArrow) {
            throw superProps[0].buildCodeFrameError("When using '@babel/plugin-transform-arrow-functions', it's not possible to compile `super.prop` in an arrow function without compiling classes.\nPlease add '@babel/plugin-transform-classes' to your Babel configuration.");
          }
          const flatSuperProps = superProps.reduce((acc, superProp) => acc.concat(standardizeSuperProperty(superProp)), []);
          flatSuperProps.forEach((superProp) => {
            const key = superProp.node.computed ? "" : superProp.get("property").node.name;
            const superParentPath = superProp.parentPath;
            const isAssignment = superParentPath.isAssignmentExpression({
              left: superProp.node
            });
            const isCall = superParentPath.isCallExpression({
              callee: superProp.node
            });
            const isTaggedTemplate = superParentPath.isTaggedTemplateExpression({
              tag: superProp.node
            });
            const superBinding = getSuperPropBinding(thisEnvFn, isAssignment, key);
            const args = [];
            if (superProp.node.computed) {
              args.push(superProp.get("property").node);
            }
            if (isAssignment) {
              const value = superParentPath.node.right;
              args.push(value);
            }
            const call = callExpression(identifier3(superBinding), args);
            if (isCall) {
              superParentPath.unshiftContainer("arguments", thisExpression());
              superProp.replaceWith(memberExpression(call, identifier3("call")));
              thisPaths.push(superParentPath.get("arguments.0"));
            } else if (isAssignment) {
              superParentPath.replaceWith(call);
            } else if (isTaggedTemplate) {
              superProp.replaceWith(callExpression(memberExpression(call, identifier3("bind"), false), [thisExpression()]));
              thisPaths.push(superProp.get("arguments.0"));
            } else {
              superProp.replaceWith(call);
            }
          });
        }
        let thisBinding;
        if (thisPaths.length > 0 || !noNewArrows) {
          thisBinding = getThisBinding(thisEnvFn, inConstructor);
          if (noNewArrows || inConstructor && hasSuperClass(thisEnvFn)) {
            thisPaths.forEach((thisChild) => {
              const thisRef = thisChild.isJSX() ? jsxIdentifier(thisBinding) : identifier3(thisBinding);
              thisRef.loc = thisChild.node.loc;
              thisChild.replaceWith(thisRef);
            });
            if (!noNewArrows)
              thisBinding = null;
          }
        }
        return {
          thisBinding,
          fnPath
        };
      }
      function isLogicalOp(op) {
        return LOGICAL_OPERATORS.includes(op);
      }
      function standardizeSuperProperty(superProp) {
        if (superProp.parentPath.isAssignmentExpression() && superProp.parentPath.node.operator !== "=") {
          const assignmentPath = superProp.parentPath;
          const op = assignmentPath.node.operator.slice(0, -1);
          const value = assignmentPath.node.right;
          const isLogicalAssignment = isLogicalOp(op);
          if (superProp.node.computed) {
            const tmp = superProp.scope.generateDeclaredUidIdentifier("tmp");
            const object = superProp.node.object;
            const property2 = superProp.node.property;
            assignmentPath.get("left").replaceWith(memberExpression(object, assignmentExpression("=", tmp, property2), true));
            assignmentPath.get("right").replaceWith(rightExpression(isLogicalAssignment ? "=" : op, memberExpression(object, identifier3(tmp.name), true), value));
          } else {
            const object = superProp.node.object;
            const property2 = superProp.node.property;
            assignmentPath.get("left").replaceWith(memberExpression(object, property2));
            assignmentPath.get("right").replaceWith(rightExpression(isLogicalAssignment ? "=" : op, memberExpression(object, identifier3(property2.name)), value));
          }
          if (isLogicalAssignment) {
            assignmentPath.replaceWith(logicalExpression(op, assignmentPath.node.left, assignmentPath.node.right));
          } else {
            assignmentPath.node.operator = "=";
          }
          return [assignmentPath.get("left"), assignmentPath.get("right").get("left")];
        } else if (superProp.parentPath.isUpdateExpression()) {
          const updateExpr = superProp.parentPath;
          const tmp = superProp.scope.generateDeclaredUidIdentifier("tmp");
          const computedKey = superProp.node.computed ? superProp.scope.generateDeclaredUidIdentifier("prop") : null;
          const parts = [assignmentExpression("=", tmp, memberExpression(superProp.node.object, computedKey ? assignmentExpression("=", computedKey, superProp.node.property) : superProp.node.property, superProp.node.computed)), assignmentExpression("=", memberExpression(superProp.node.object, computedKey ? identifier3(computedKey.name) : superProp.node.property, superProp.node.computed), binaryExpression(superProp.parentPath.node.operator[0], identifier3(tmp.name), numericLiteral(1)))];
          if (!superProp.parentPath.node.prefix) {
            parts.push(identifier3(tmp.name));
          }
          updateExpr.replaceWith(sequenceExpression(parts));
          const left = updateExpr.get("expressions.0.right");
          const right = updateExpr.get("expressions.1.left");
          return [left, right];
        }
        return [superProp];
        function rightExpression(op, left, right) {
          if (op === "=") {
            return assignmentExpression("=", left, right);
          } else {
            return binaryExpression(op, left, right);
          }
        }
      }
      function hasSuperClass(thisEnvFn) {
        return thisEnvFn.isClassMethod() && !!thisEnvFn.parentPath.parentPath.node.superClass;
      }
      var assignSuperThisVisitor = (0, _visitors.environmentVisitor)({
        CallExpression(child, {
          supers,
          thisBinding
        }) {
          if (!child.get("callee").isSuper())
            return;
          if (supers.has(child.node))
            return;
          supers.add(child.node);
          child.replaceWithMultiple([child.node, assignmentExpression("=", identifier3(thisBinding), identifier3("this"))]);
        }
      });
      function getThisBinding(thisEnvFn, inConstructor) {
        return getBinding(thisEnvFn, "this", (thisBinding) => {
          if (!inConstructor || !hasSuperClass(thisEnvFn))
            return thisExpression();
          thisEnvFn.traverse(assignSuperThisVisitor, {
            supers: /* @__PURE__ */ new WeakSet(),
            thisBinding
          });
        });
      }
      function getSuperBinding(thisEnvFn) {
        return getBinding(thisEnvFn, "supercall", () => {
          const argsBinding = thisEnvFn.scope.generateUidIdentifier("args");
          return arrowFunctionExpression2([restElement(argsBinding)], callExpression(_super(), [spreadElement(identifier3(argsBinding.name))]));
        });
      }
      function getSuperPropBinding(thisEnvFn, isAssignment, propName) {
        const op = isAssignment ? "set" : "get";
        return getBinding(thisEnvFn, `superprop_${op}:${propName || ""}`, () => {
          const argsList = [];
          let fnBody;
          if (propName) {
            fnBody = memberExpression(_super(), identifier3(propName));
          } else {
            const method2 = thisEnvFn.scope.generateUidIdentifier("prop");
            argsList.unshift(method2);
            fnBody = memberExpression(_super(), identifier3(method2.name), true);
          }
          if (isAssignment) {
            const valueIdent = thisEnvFn.scope.generateUidIdentifier("value");
            argsList.push(valueIdent);
            fnBody = assignmentExpression("=", fnBody, identifier3(valueIdent.name));
          }
          return arrowFunctionExpression2(argsList, fnBody);
        });
      }
      function getBinding(thisEnvFn, key, init) {
        const cacheKey = "binding:" + key;
        let data = thisEnvFn.getData(cacheKey);
        if (!data) {
          const id = thisEnvFn.scope.generateUidIdentifier(key);
          data = id.name;
          thisEnvFn.setData(cacheKey, data);
          thisEnvFn.scope.push({
            id,
            init: init(data)
          });
        }
        return data;
      }
      var getScopeInformationVisitor = (0, _visitors.environmentVisitor)({
        ThisExpression(child, {
          thisPaths
        }) {
          thisPaths.push(child);
        },
        JSXIdentifier(child, {
          thisPaths
        }) {
          if (child.node.name !== "this")
            return;
          if (!child.parentPath.isJSXMemberExpression({
            object: child.node
          }) && !child.parentPath.isJSXOpeningElement({
            name: child.node
          })) {
            return;
          }
          thisPaths.push(child);
        },
        CallExpression(child, {
          superCalls
        }) {
          if (child.get("callee").isSuper())
            superCalls.push(child);
        },
        MemberExpression(child, {
          superProps
        }) {
          if (child.get("object").isSuper())
            superProps.push(child);
        },
        Identifier(child, {
          argumentsPaths
        }) {
          if (!child.isReferencedIdentifier({
            name: "arguments"
          }))
            return;
          let curr = child.scope;
          do {
            if (curr.hasOwnBinding("arguments")) {
              curr.rename("arguments");
              return;
            }
            if (curr.path.isFunction() && !curr.path.isArrowFunctionExpression()) {
              break;
            }
          } while (curr = curr.parent);
          argumentsPaths.push(child);
        },
        MetaProperty(child, {
          newTargetPaths
        }) {
          if (!child.get("meta").isIdentifier({
            name: "new"
          }))
            return;
          if (!child.get("property").isIdentifier({
            name: "target"
          }))
            return;
          newTargetPaths.push(child);
        }
      });
      function getScopeInformation(fnPath) {
        const thisPaths = [];
        const argumentsPaths = [];
        const newTargetPaths = [];
        const superProps = [];
        const superCalls = [];
        fnPath.traverse(getScopeInformationVisitor, {
          thisPaths,
          argumentsPaths,
          newTargetPaths,
          superProps,
          superCalls
        });
        return {
          thisPaths,
          argumentsPaths,
          newTargetPaths,
          superProps,
          superCalls
        };
      }
      function splitExportDeclaration() {
        if (!this.isExportDeclaration() || this.isExportAllDeclaration()) {
          throw new Error("Only default and named export declarations can be split.");
        }
        if (this.isExportNamedDeclaration() && this.get("specifiers").length > 0) {
          throw new Error("It doesn't make sense to split exported specifiers.");
        }
        const declaration = this.get("declaration");
        if (this.isExportDefaultDeclaration()) {
          const standaloneDeclaration = declaration.isFunctionDeclaration() || declaration.isClassDeclaration();
          const exportExpr = declaration.isFunctionExpression() || declaration.isClassExpression();
          const scope = declaration.isScope() ? declaration.scope.parent : declaration.scope;
          let id = declaration.node.id;
          let needBindingRegistration = false;
          if (!id) {
            needBindingRegistration = true;
            id = scope.generateUidIdentifier("default");
            if (standaloneDeclaration || exportExpr) {
              declaration.node.id = cloneNode(id);
            }
          } else if (exportExpr && scope.hasBinding(id.name)) {
            needBindingRegistration = true;
            id = scope.generateUidIdentifier(id.name);
          }
          const updatedDeclaration = standaloneDeclaration ? declaration.node : variableDeclaration("var", [variableDeclarator(cloneNode(id), declaration.node)]);
          const updatedExportDeclaration = exportNamedDeclaration(null, [exportSpecifier(cloneNode(id), identifier3("default"))]);
          this.insertAfter(updatedExportDeclaration);
          this.replaceWith(updatedDeclaration);
          if (needBindingRegistration) {
            scope.registerDeclaration(this);
          }
          return this;
        } else if (this.get("specifiers").length > 0) {
          throw new Error("It doesn't make sense to split exported specifiers.");
        }
        const bindingIdentifiers = declaration.getOuterBindingIdentifiers();
        const specifiers = Object.keys(bindingIdentifiers).map((name) => {
          return exportSpecifier(identifier3(name), identifier3(name));
        });
        const aliasDeclar = exportNamedDeclaration(null, specifiers);
        this.insertAfter(aliasDeclar);
        this.replaceWith(declaration.node);
        return this;
      }
      var refersOuterBindingVisitor = {
        "ReferencedIdentifier|BindingIdentifier"(path, state) {
          if (path.node.name !== state.name)
            return;
          state.needsRename = true;
          path.stop();
        },
        Scope(path, state) {
          if (path.scope.hasOwnBinding(state.name)) {
            path.skip();
          }
        }
      };
      function ensureFunctionName(supportUnicodeId) {
        if (this.node.id)
          return this;
        const res = getFunctionName(this.node, this.parent);
        if (res == null)
          return this;
        let {
          name
        } = res;
        if (!supportUnicodeId && /[\uD800-\uDFFF]/.test(name)) {
          return null;
        }
        if (name.startsWith("get ") || name.startsWith("set ")) {
          return null;
        }
        name = toBindingIdentifierName(name.replace(/[/ ]/g, "_"));
        const id = identifier3(name);
        inherits2(id, res.originalNode);
        const state = {
          needsRename: false,
          name
        };
        const {
          scope
        } = this;
        const binding3 = scope.getOwnBinding(name);
        if (binding3) {
          if (binding3.kind === "param") {
            state.needsRename = true;
          } else {
          }
        } else if (scope.parent.hasBinding(name) || scope.hasGlobal(name)) {
          this.traverse(refersOuterBindingVisitor, state);
        }
        if (!state.needsRename) {
          this.node.id = id;
          {
            scope.getProgramParent().references[id.name] = true;
          }
          return this;
        }
        if (scope.hasBinding(id.name) && !scope.hasGlobal(id.name)) {
          scope.rename(id.name);
          this.node.id = id;
          {
            scope.getProgramParent().references[id.name] = true;
          }
          return this;
        }
        if (!isFunction3(this.node))
          return null;
        const key = scope.generateUidIdentifier(id.name);
        const params = [];
        for (let i = 0, len = getFunctionArity(this.node); i < len; i++) {
          params.push(scope.generateUidIdentifier("x"));
        }
        const call = _template.default.expression.ast`
    (function (${key}) {
      function ${id}(${params}) {
        return ${cloneNode(key)}.apply(this, arguments);
      }

      ${cloneNode(id)}.toString = function () {
        return ${cloneNode(key)}.toString();
      }

      return ${cloneNode(id)};
    })(${toExpression(this.node)})
  `;
        return this.replaceWith(call)[0].get("arguments.0");
      }
      function getFunctionArity(node) {
        const count = node.params.findIndex((param) => isAssignmentPattern(param) || isRestElement(param));
        return count === -1 ? node.params.length : count;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/introspection.js
  var require_introspection = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/introspection.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8._guessExecutionStatusRelativeTo = _guessExecutionStatusRelativeTo;
      exports8._resolve = _resolve;
      exports8.canHaveVariableDeclarationOrExpression = canHaveVariableDeclarationOrExpression;
      exports8.canSwapBetweenExpressionAndStatement = canSwapBetweenExpressionAndStatement;
      exports8.getSource = getSource;
      exports8.isCompletionRecord = isCompletionRecord;
      exports8.isConstantExpression = isConstantExpression;
      exports8.isInStrictMode = isInStrictMode;
      exports8.isNodeType = isNodeType;
      exports8.isStatementOrBlock = isStatementOrBlock;
      exports8.isStatic = isStatic;
      exports8.matchesPattern = matchesPattern;
      exports8.referencesImport = referencesImport;
      exports8.resolve = resolve2;
      exports8.willIMaybeExecuteBefore = willIMaybeExecuteBefore;
      var _t = require_lib5();
      var {
        STATEMENT_OR_BLOCK_KEYS,
        VISITOR_KEYS,
        isBlockStatement,
        isExpression,
        isIdentifier: isIdentifier2,
        isLiteral,
        isStringLiteral,
        isType,
        matchesPattern: _matchesPattern
      } = _t;
      function matchesPattern(pattern, allowPartial) {
        return _matchesPattern(this.node, pattern, allowPartial);
      }
      {
        exports8.has = function has2(key) {
          var _this$node;
          const val = (_this$node = this.node) == null ? void 0 : _this$node[key];
          if (val && Array.isArray(val)) {
            return !!val.length;
          } else {
            return !!val;
          }
        };
      }
      function isStatic() {
        return this.scope.isStatic(this.node);
      }
      {
        exports8.is = exports8.has;
        exports8.isnt = function isnt(key) {
          return !this.has(key);
        };
        exports8.equals = function equals(key, value) {
          return this.node[key] === value;
        };
      }
      function isNodeType(type) {
        return isType(this.type, type);
      }
      function canHaveVariableDeclarationOrExpression() {
        return (this.key === "init" || this.key === "left") && this.parentPath.isFor();
      }
      function canSwapBetweenExpressionAndStatement(replacement) {
        if (this.key !== "body" || !this.parentPath.isArrowFunctionExpression()) {
          return false;
        }
        if (this.isExpression()) {
          return isBlockStatement(replacement);
        } else if (this.isBlockStatement()) {
          return isExpression(replacement);
        }
        return false;
      }
      function isCompletionRecord(allowInsideFunction) {
        let path = this;
        let first = true;
        do {
          const {
            type,
            container
          } = path;
          if (!first && (path.isFunction() || type === "StaticBlock")) {
            return !!allowInsideFunction;
          }
          first = false;
          if (Array.isArray(container) && path.key !== container.length - 1) {
            return false;
          }
        } while ((path = path.parentPath) && !path.isProgram() && !path.isDoExpression());
        return true;
      }
      function isStatementOrBlock() {
        if (this.parentPath.isLabeledStatement() || isBlockStatement(this.container)) {
          return false;
        } else {
          return STATEMENT_OR_BLOCK_KEYS.includes(this.key);
        }
      }
      function referencesImport(moduleSource, importName) {
        if (!this.isReferencedIdentifier()) {
          if (this.isJSXMemberExpression() && this.node.property.name === importName || (this.isMemberExpression() || this.isOptionalMemberExpression()) && (this.node.computed ? isStringLiteral(this.node.property, {
            value: importName
          }) : this.node.property.name === importName)) {
            const object = this.get("object");
            return object.isReferencedIdentifier() && object.referencesImport(moduleSource, "*");
          }
          return false;
        }
        const binding3 = this.scope.getBinding(this.node.name);
        if (!binding3 || binding3.kind !== "module")
          return false;
        const path = binding3.path;
        const parent2 = path.parentPath;
        if (!parent2.isImportDeclaration())
          return false;
        if (parent2.node.source.value === moduleSource) {
          if (!importName)
            return true;
        } else {
          return false;
        }
        if (path.isImportDefaultSpecifier() && importName === "default") {
          return true;
        }
        if (path.isImportNamespaceSpecifier() && importName === "*") {
          return true;
        }
        if (path.isImportSpecifier() && isIdentifier2(path.node.imported, {
          name: importName
        })) {
          return true;
        }
        return false;
      }
      function getSource() {
        const node = this.node;
        if (node.end) {
          const code = this.hub.getCode();
          if (code)
            return code.slice(node.start, node.end);
        }
        return "";
      }
      function willIMaybeExecuteBefore(target) {
        return this._guessExecutionStatusRelativeTo(target) !== "after";
      }
      function getOuterFunction(path) {
        return path.isProgram() ? path : (path.parentPath.scope.getFunctionParent() || path.parentPath.scope.getProgramParent()).path;
      }
      function isExecutionUncertain(type, key) {
        switch (type) {
          case "LogicalExpression":
            return key === "right";
          case "ConditionalExpression":
          case "IfStatement":
            return key === "consequent" || key === "alternate";
          case "WhileStatement":
          case "DoWhileStatement":
          case "ForInStatement":
          case "ForOfStatement":
            return key === "body";
          case "ForStatement":
            return key === "body" || key === "update";
          case "SwitchStatement":
            return key === "cases";
          case "TryStatement":
            return key === "handler";
          case "AssignmentPattern":
            return key === "right";
          case "OptionalMemberExpression":
            return key === "property";
          case "OptionalCallExpression":
            return key === "arguments";
          default:
            return false;
        }
      }
      function isExecutionUncertainInList(paths, maxIndex) {
        for (let i = 0; i < maxIndex; i++) {
          const path = paths[i];
          if (isExecutionUncertain(path.parent.type, path.parentKey)) {
            return true;
          }
        }
        return false;
      }
      var SYMBOL_CHECKING = Symbol();
      function _guessExecutionStatusRelativeTo(target) {
        return _guessExecutionStatusRelativeToCached(this, target, /* @__PURE__ */ new Map());
      }
      function _guessExecutionStatusRelativeToCached(base, target, cache) {
        const funcParent = {
          this: getOuterFunction(base),
          target: getOuterFunction(target)
        };
        if (funcParent.target.node !== funcParent.this.node) {
          return _guessExecutionStatusRelativeToDifferentFunctionsCached(base, funcParent.target, cache);
        }
        const paths = {
          target: target.getAncestry(),
          this: base.getAncestry()
        };
        if (paths.target.includes(base))
          return "after";
        if (paths.this.includes(target))
          return "before";
        let commonPath;
        const commonIndex = {
          target: 0,
          this: 0
        };
        while (!commonPath && commonIndex.this < paths.this.length) {
          const path = paths.this[commonIndex.this];
          commonIndex.target = paths.target.indexOf(path);
          if (commonIndex.target >= 0) {
            commonPath = path;
          } else {
            commonIndex.this++;
          }
        }
        if (!commonPath) {
          throw new Error("Internal Babel error - The two compared nodes don't appear to belong to the same program.");
        }
        if (isExecutionUncertainInList(paths.this, commonIndex.this - 1) || isExecutionUncertainInList(paths.target, commonIndex.target - 1)) {
          return "unknown";
        }
        const divergence = {
          this: paths.this[commonIndex.this - 1],
          target: paths.target[commonIndex.target - 1]
        };
        if (divergence.target.listKey && divergence.this.listKey && divergence.target.container === divergence.this.container) {
          return divergence.target.key > divergence.this.key ? "before" : "after";
        }
        const keys2 = VISITOR_KEYS[commonPath.type];
        const keyPosition = {
          this: keys2.indexOf(divergence.this.parentKey),
          target: keys2.indexOf(divergence.target.parentKey)
        };
        return keyPosition.target > keyPosition.this ? "before" : "after";
      }
      function _guessExecutionStatusRelativeToDifferentFunctionsInternal(base, target, cache) {
        if (!target.isFunctionDeclaration()) {
          if (_guessExecutionStatusRelativeToCached(base, target, cache) === "before") {
            return "before";
          }
          return "unknown";
        } else if (target.parentPath.isExportDeclaration()) {
          return "unknown";
        }
        const binding3 = target.scope.getBinding(target.node.id.name);
        if (!binding3.references)
          return "before";
        const referencePaths = binding3.referencePaths;
        let allStatus;
        for (const path of referencePaths) {
          const childOfFunction = !!path.find((path2) => path2.node === target.node);
          if (childOfFunction)
            continue;
          if (path.key !== "callee" || !path.parentPath.isCallExpression()) {
            return "unknown";
          }
          const status = _guessExecutionStatusRelativeToCached(base, path, cache);
          if (allStatus && allStatus !== status) {
            return "unknown";
          } else {
            allStatus = status;
          }
        }
        return allStatus;
      }
      function _guessExecutionStatusRelativeToDifferentFunctionsCached(base, target, cache) {
        let nodeMap = cache.get(base.node);
        let cached;
        if (!nodeMap) {
          cache.set(base.node, nodeMap = /* @__PURE__ */ new Map());
        } else if (cached = nodeMap.get(target.node)) {
          if (cached === SYMBOL_CHECKING) {
            return "unknown";
          }
          return cached;
        }
        nodeMap.set(target.node, SYMBOL_CHECKING);
        const result2 = _guessExecutionStatusRelativeToDifferentFunctionsInternal(base, target, cache);
        nodeMap.set(target.node, result2);
        return result2;
      }
      function resolve2(dangerous, resolved) {
        return _resolve.call(this, dangerous, resolved) || this;
      }
      function _resolve(dangerous, resolved) {
        var _resolved;
        if ((_resolved = resolved) != null && _resolved.includes(this))
          return;
        resolved = resolved || [];
        resolved.push(this);
        if (this.isVariableDeclarator()) {
          if (this.get("id").isIdentifier()) {
            return this.get("init").resolve(dangerous, resolved);
          } else {
          }
        } else if (this.isReferencedIdentifier()) {
          const binding3 = this.scope.getBinding(this.node.name);
          if (!binding3)
            return;
          if (!binding3.constant)
            return;
          if (binding3.kind === "module")
            return;
          if (binding3.path !== this) {
            const ret = binding3.path.resolve(dangerous, resolved);
            if (this.find((parent2) => parent2.node === ret.node))
              return;
            return ret;
          }
        } else if (this.isTypeCastExpression()) {
          return this.get("expression").resolve(dangerous, resolved);
        } else if (dangerous && this.isMemberExpression()) {
          const targetKey = this.toComputedKey();
          if (!isLiteral(targetKey))
            return;
          const targetName = targetKey.value;
          const target = this.get("object").resolve(dangerous, resolved);
          if (target.isObjectExpression()) {
            const props = target.get("properties");
            for (const prop of props) {
              if (!prop.isProperty())
                continue;
              const key = prop.get("key");
              let match = prop.isnt("computed") && key.isIdentifier({
                name: targetName
              });
              match = match || key.isLiteral({
                value: targetName
              });
              if (match)
                return prop.get("value").resolve(dangerous, resolved);
            }
          } else if (target.isArrayExpression() && !isNaN(+targetName)) {
            const elems = target.get("elements");
            const elem = elems[targetName];
            if (elem)
              return elem.resolve(dangerous, resolved);
          }
        }
      }
      function isConstantExpression() {
        if (this.isIdentifier()) {
          const binding3 = this.scope.getBinding(this.node.name);
          if (!binding3)
            return false;
          return binding3.constant;
        }
        if (this.isLiteral()) {
          if (this.isRegExpLiteral()) {
            return false;
          }
          if (this.isTemplateLiteral()) {
            return this.get("expressions").every((expression) => expression.isConstantExpression());
          }
          return true;
        }
        if (this.isUnaryExpression()) {
          if (this.node.operator !== "void") {
            return false;
          }
          return this.get("argument").isConstantExpression();
        }
        if (this.isBinaryExpression()) {
          const {
            operator
          } = this.node;
          return operator !== "in" && operator !== "instanceof" && this.get("left").isConstantExpression() && this.get("right").isConstantExpression();
        }
        if (this.isMemberExpression()) {
          return !this.node.computed && this.get("object").isIdentifier({
            name: "Symbol"
          }) && !this.scope.hasBinding("Symbol", {
            noGlobals: true
          });
        }
        if (this.isCallExpression()) {
          return this.node.arguments.length === 1 && this.get("callee").matchesPattern("Symbol.for") && !this.scope.hasBinding("Symbol", {
            noGlobals: true
          }) && this.get("arguments")[0].isStringLiteral();
        }
        return false;
      }
      function isInStrictMode() {
        const start = this.isProgram() ? this : this.parentPath;
        const strictParent = start.find((path) => {
          if (path.isProgram({
            sourceType: "module"
          }))
            return true;
          if (path.isClass())
            return true;
          if (path.isArrowFunctionExpression() && !path.get("body").isBlockStatement()) {
            return false;
          }
          let body;
          if (path.isFunction()) {
            body = path.node.body;
          } else if (path.isProgram()) {
            body = path.node;
          } else {
            return false;
          }
          for (const directive of body.directives) {
            if (directive.value.value === "use strict") {
              return true;
            }
          }
        });
        return !!strictParent;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/family.js
  var require_family = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/family.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8._getKey = _getKey;
      exports8._getPattern = _getPattern;
      exports8.get = get2;
      exports8.getAllNextSiblings = getAllNextSiblings;
      exports8.getAllPrevSiblings = getAllPrevSiblings;
      exports8.getAssignmentIdentifiers = getAssignmentIdentifiers;
      exports8.getBindingIdentifierPaths = getBindingIdentifierPaths;
      exports8.getBindingIdentifiers = getBindingIdentifiers;
      exports8.getCompletionRecords = getCompletionRecords;
      exports8.getNextSibling = getNextSibling;
      exports8.getOpposite = getOpposite;
      exports8.getOuterBindingIdentifierPaths = getOuterBindingIdentifierPaths;
      exports8.getOuterBindingIdentifiers = getOuterBindingIdentifiers;
      exports8.getPrevSibling = getPrevSibling;
      exports8.getSibling = getSibling;
      var _index = require_path();
      var _t = require_lib5();
      var {
        getAssignmentIdentifiers: _getAssignmentIdentifiers,
        getBindingIdentifiers: _getBindingIdentifiers,
        getOuterBindingIdentifiers: _getOuterBindingIdentifiers,
        numericLiteral,
        unaryExpression
      } = _t;
      var NORMAL_COMPLETION = 0;
      var BREAK_COMPLETION = 1;
      function NormalCompletion(path) {
        return {
          type: NORMAL_COMPLETION,
          path
        };
      }
      function BreakCompletion(path) {
        return {
          type: BREAK_COMPLETION,
          path
        };
      }
      function getOpposite() {
        if (this.key === "left") {
          return this.getSibling("right");
        } else if (this.key === "right") {
          return this.getSibling("left");
        }
        return null;
      }
      function addCompletionRecords(path, records, context) {
        if (path) {
          records.push(..._getCompletionRecords(path, context));
        }
        return records;
      }
      function completionRecordForSwitch(cases, records, context) {
        let lastNormalCompletions = [];
        for (let i = 0; i < cases.length; i++) {
          const casePath = cases[i];
          const caseCompletions = _getCompletionRecords(casePath, context);
          const normalCompletions = [];
          const breakCompletions = [];
          for (const c of caseCompletions) {
            if (c.type === NORMAL_COMPLETION) {
              normalCompletions.push(c);
            }
            if (c.type === BREAK_COMPLETION) {
              breakCompletions.push(c);
            }
          }
          if (normalCompletions.length) {
            lastNormalCompletions = normalCompletions;
          }
          records.push(...breakCompletions);
        }
        records.push(...lastNormalCompletions);
        return records;
      }
      function normalCompletionToBreak(completions) {
        completions.forEach((c) => {
          c.type = BREAK_COMPLETION;
        });
      }
      function replaceBreakStatementInBreakCompletion(completions, reachable) {
        completions.forEach((c) => {
          if (c.path.isBreakStatement({
            label: null
          })) {
            if (reachable) {
              c.path.replaceWith(unaryExpression("void", numericLiteral(0)));
            } else {
              c.path.remove();
            }
          }
        });
      }
      function getStatementListCompletion(paths, context) {
        const completions = [];
        if (context.canHaveBreak) {
          let lastNormalCompletions = [];
          for (let i = 0; i < paths.length; i++) {
            const path = paths[i];
            const newContext = Object.assign({}, context, {
              inCaseClause: false
            });
            if (path.isBlockStatement() && (context.inCaseClause || context.shouldPopulateBreak)) {
              newContext.shouldPopulateBreak = true;
            } else {
              newContext.shouldPopulateBreak = false;
            }
            const statementCompletions = _getCompletionRecords(path, newContext);
            if (statementCompletions.length > 0 && statementCompletions.every((c) => c.type === BREAK_COMPLETION)) {
              if (lastNormalCompletions.length > 0 && statementCompletions.every((c) => c.path.isBreakStatement({
                label: null
              }))) {
                normalCompletionToBreak(lastNormalCompletions);
                completions.push(...lastNormalCompletions);
                if (lastNormalCompletions.some((c) => c.path.isDeclaration())) {
                  completions.push(...statementCompletions);
                  if (!context.shouldPreserveBreak) {
                    replaceBreakStatementInBreakCompletion(statementCompletions, true);
                  }
                }
                if (!context.shouldPreserveBreak) {
                  replaceBreakStatementInBreakCompletion(statementCompletions, false);
                }
              } else {
                completions.push(...statementCompletions);
                if (!context.shouldPopulateBreak && !context.shouldPreserveBreak) {
                  replaceBreakStatementInBreakCompletion(statementCompletions, true);
                }
              }
              break;
            }
            if (i === paths.length - 1) {
              completions.push(...statementCompletions);
            } else {
              lastNormalCompletions = [];
              for (let i2 = 0; i2 < statementCompletions.length; i2++) {
                const c = statementCompletions[i2];
                if (c.type === BREAK_COMPLETION) {
                  completions.push(c);
                }
                if (c.type === NORMAL_COMPLETION) {
                  lastNormalCompletions.push(c);
                }
              }
            }
          }
        } else if (paths.length) {
          for (let i = paths.length - 1; i >= 0; i--) {
            const pathCompletions = _getCompletionRecords(paths[i], context);
            if (pathCompletions.length > 1 || pathCompletions.length === 1 && !pathCompletions[0].path.isVariableDeclaration() && !pathCompletions[0].path.isEmptyStatement()) {
              completions.push(...pathCompletions);
              break;
            }
          }
        }
        return completions;
      }
      function _getCompletionRecords(path, context) {
        let records = [];
        if (path.isIfStatement()) {
          records = addCompletionRecords(path.get("consequent"), records, context);
          records = addCompletionRecords(path.get("alternate"), records, context);
        } else if (path.isDoExpression() || path.isFor() || path.isWhile() || path.isLabeledStatement()) {
          return addCompletionRecords(path.get("body"), records, context);
        } else if (path.isProgram() || path.isBlockStatement()) {
          return getStatementListCompletion(path.get("body"), context);
        } else if (path.isFunction()) {
          return _getCompletionRecords(path.get("body"), context);
        } else if (path.isTryStatement()) {
          records = addCompletionRecords(path.get("block"), records, context);
          records = addCompletionRecords(path.get("handler"), records, context);
        } else if (path.isCatchClause()) {
          return addCompletionRecords(path.get("body"), records, context);
        } else if (path.isSwitchStatement()) {
          return completionRecordForSwitch(path.get("cases"), records, context);
        } else if (path.isSwitchCase()) {
          return getStatementListCompletion(path.get("consequent"), {
            canHaveBreak: true,
            shouldPopulateBreak: false,
            inCaseClause: true,
            shouldPreserveBreak: context.shouldPreserveBreak
          });
        } else if (path.isBreakStatement()) {
          records.push(BreakCompletion(path));
        } else {
          records.push(NormalCompletion(path));
        }
        return records;
      }
      function getCompletionRecords(shouldPreserveBreak = false) {
        const records = _getCompletionRecords(this, {
          canHaveBreak: false,
          shouldPopulateBreak: false,
          inCaseClause: false,
          shouldPreserveBreak
        });
        return records.map((r) => r.path);
      }
      function getSibling(key) {
        return _index.default.get({
          parentPath: this.parentPath,
          parent: this.parent,
          container: this.container,
          listKey: this.listKey,
          key
        }).setContext(this.context);
      }
      function getPrevSibling() {
        return this.getSibling(this.key - 1);
      }
      function getNextSibling() {
        return this.getSibling(this.key + 1);
      }
      function getAllNextSiblings() {
        let _key = this.key;
        let sibling = this.getSibling(++_key);
        const siblings = [];
        while (sibling.node) {
          siblings.push(sibling);
          sibling = this.getSibling(++_key);
        }
        return siblings;
      }
      function getAllPrevSiblings() {
        let _key = this.key;
        let sibling = this.getSibling(--_key);
        const siblings = [];
        while (sibling.node) {
          siblings.push(sibling);
          sibling = this.getSibling(--_key);
        }
        return siblings;
      }
      function get2(key, context = true) {
        if (context === true)
          context = this.context;
        const parts = key.split(".");
        if (parts.length === 1) {
          return _getKey.call(this, key, context);
        } else {
          return _getPattern.call(this, parts, context);
        }
      }
      function _getKey(key, context) {
        const node = this.node;
        const container = node[key];
        if (Array.isArray(container)) {
          return container.map((_, i) => {
            return _index.default.get({
              listKey: key,
              parentPath: this,
              parent: node,
              container,
              key: i
            }).setContext(context);
          });
        } else {
          return _index.default.get({
            parentPath: this,
            parent: node,
            container: node,
            key
          }).setContext(context);
        }
      }
      function _getPattern(parts, context) {
        let path = this;
        for (const part of parts) {
          if (part === ".") {
            path = path.parentPath;
          } else {
            if (Array.isArray(path)) {
              path = path[part];
            } else {
              path = path.get(part, context);
            }
          }
        }
        return path;
      }
      function getAssignmentIdentifiers() {
        return _getAssignmentIdentifiers(this.node);
      }
      function getBindingIdentifiers(duplicates) {
        return _getBindingIdentifiers(this.node, duplicates);
      }
      function getOuterBindingIdentifiers(duplicates) {
        return _getOuterBindingIdentifiers(this.node, duplicates);
      }
      function getBindingIdentifierPaths(duplicates = false, outerOnly = false) {
        const path = this;
        const search = [path];
        const ids = /* @__PURE__ */ Object.create(null);
        while (search.length) {
          const id = search.shift();
          if (!id)
            continue;
          if (!id.node)
            continue;
          const keys2 = _getBindingIdentifiers.keys[id.node.type];
          if (id.isIdentifier()) {
            if (duplicates) {
              const _ids = ids[id.node.name] = ids[id.node.name] || [];
              _ids.push(id);
            } else {
              ids[id.node.name] = id;
            }
            continue;
          }
          if (id.isExportDeclaration()) {
            const declaration = id.get("declaration");
            if (declaration.isDeclaration()) {
              search.push(declaration);
            }
            continue;
          }
          if (outerOnly) {
            if (id.isFunctionDeclaration()) {
              search.push(id.get("id"));
              continue;
            }
            if (id.isFunctionExpression()) {
              continue;
            }
          }
          if (keys2) {
            for (let i = 0; i < keys2.length; i++) {
              const key = keys2[i];
              const child = id.get(key);
              if (Array.isArray(child)) {
                search.push(...child);
              } else if (child.node) {
                search.push(child);
              }
            }
          }
        }
        return ids;
      }
      function getOuterBindingIdentifierPaths(duplicates = false) {
        return this.getBindingIdentifierPaths(duplicates, true);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/comments.js
  var require_comments = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/comments.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.addComment = addComment;
      exports8.addComments = addComments;
      exports8.shareCommentsWithSiblings = shareCommentsWithSiblings;
      var _t = require_lib5();
      var {
        addComment: _addComment,
        addComments: _addComments
      } = _t;
      function shareCommentsWithSiblings() {
        if (typeof this.key === "string")
          return;
        const node = this.node;
        if (!node)
          return;
        const trailing = node.trailingComments;
        const leading = node.leadingComments;
        if (!trailing && !leading)
          return;
        const prev = this.getSibling(this.key - 1);
        const next = this.getSibling(this.key + 1);
        const hasPrev = Boolean(prev.node);
        const hasNext = Boolean(next.node);
        if (hasPrev) {
          if (leading) {
            prev.addComments("trailing", removeIfExisting(leading, prev.node.trailingComments));
          }
          if (trailing && !hasNext)
            prev.addComments("trailing", trailing);
        }
        if (hasNext) {
          if (trailing) {
            next.addComments("leading", removeIfExisting(trailing, next.node.leadingComments));
          }
          if (leading && !hasPrev)
            next.addComments("leading", leading);
        }
      }
      function removeIfExisting(list, toRemove) {
        if (!(toRemove != null && toRemove.length))
          return list;
        const set2 = new Set(toRemove);
        return list.filter((el) => {
          return !set2.has(el);
        });
      }
      function addComment(type, content, line) {
        _addComment(this.node, type, content, line);
      }
      function addComments(type, comments) {
        _addComments(this.node, type, comments);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/index.js
  var require_path = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = exports8.SHOULD_STOP = exports8.SHOULD_SKIP = exports8.REMOVED = void 0;
      var virtualTypes = require_virtual_types();
      var _debug = require_browser2();
      var _index = require_lib9();
      var _index2 = require_scope();
      var _t = require_lib5();
      var t3 = _t;
      var cache = require_cache2();
      var _generator = require_lib6();
      var NodePath_ancestry = require_ancestry();
      var NodePath_inference = require_inference();
      var NodePath_replacement = require_replacement();
      var NodePath_evaluation = require_evaluation();
      var NodePath_conversion = require_conversion();
      var NodePath_introspection = require_introspection();
      var _context = require_context2();
      var NodePath_context = _context;
      var NodePath_removal = require_removal();
      var NodePath_modification = require_modification();
      var NodePath_family = require_family();
      var NodePath_comments = require_comments();
      var NodePath_virtual_types_validator = require_virtual_types_validator();
      var {
        validate
      } = _t;
      var debug = _debug("babel");
      var REMOVED = exports8.REMOVED = 1 << 0;
      var SHOULD_STOP = exports8.SHOULD_STOP = 1 << 1;
      var SHOULD_SKIP = exports8.SHOULD_SKIP = 1 << 2;
      var NodePath_Final = exports8.default = class NodePath2 {
        constructor(hub, parent2) {
          this.contexts = [];
          this.state = null;
          this.opts = null;
          this._traverseFlags = 0;
          this.skipKeys = null;
          this.parentPath = null;
          this.container = null;
          this.listKey = null;
          this.key = null;
          this.node = null;
          this.type = null;
          this._store = null;
          this.parent = parent2;
          this.hub = hub;
          this.data = null;
          this.context = null;
          this.scope = null;
        }
        get removed() {
          return (this._traverseFlags & 1) > 0;
        }
        set removed(v) {
          if (v)
            this._traverseFlags |= 1;
          else
            this._traverseFlags &= -2;
        }
        get shouldStop() {
          return (this._traverseFlags & 2) > 0;
        }
        set shouldStop(v) {
          if (v)
            this._traverseFlags |= 2;
          else
            this._traverseFlags &= -3;
        }
        get shouldSkip() {
          return (this._traverseFlags & 4) > 0;
        }
        set shouldSkip(v) {
          if (v)
            this._traverseFlags |= 4;
          else
            this._traverseFlags &= -5;
        }
        static get({
          hub,
          parentPath,
          parent: parent2,
          container,
          listKey,
          key
        }) {
          if (!hub && parentPath) {
            hub = parentPath.hub;
          }
          if (!parent2) {
            throw new Error("To get a node path the parent needs to exist");
          }
          const targetNode = container[key];
          const paths = cache.getOrCreateCachedPaths(parent2, parentPath);
          let path = paths.get(targetNode);
          if (!path) {
            path = new NodePath2(hub, parent2);
            if (targetNode)
              paths.set(targetNode, path);
          }
          _context.setup.call(path, parentPath, container, listKey, key);
          return path;
        }
        getScope(scope) {
          return this.isScope() ? new _index2.default(this) : scope;
        }
        setData(key, val) {
          if (this.data == null) {
            this.data = /* @__PURE__ */ Object.create(null);
          }
          return this.data[key] = val;
        }
        getData(key, def) {
          if (this.data == null) {
            this.data = /* @__PURE__ */ Object.create(null);
          }
          let val = this.data[key];
          if (val === void 0 && def !== void 0)
            val = this.data[key] = def;
          return val;
        }
        hasNode() {
          return this.node != null;
        }
        buildCodeFrameError(msg, Error2 = SyntaxError) {
          return this.hub.buildError(this.node, msg, Error2);
        }
        traverse(visitor, state) {
          (0, _index.default)(this.node, visitor, this.scope, state, this);
        }
        set(key, node) {
          validate(this.node, key, node);
          this.node[key] = node;
        }
        getPathLocation() {
          const parts = [];
          let path = this;
          do {
            let key = path.key;
            if (path.inList)
              key = `${path.listKey}[${key}]`;
            parts.unshift(key);
          } while (path = path.parentPath);
          return parts.join(".");
        }
        debug(message) {
          if (!debug.enabled)
            return;
          debug(`${this.getPathLocation()} ${this.type}: ${message}`);
        }
        toString() {
          return (0, _generator.default)(this.node).code;
        }
        get inList() {
          return !!this.listKey;
        }
        set inList(inList) {
          if (!inList) {
            this.listKey = null;
          }
        }
        get parentKey() {
          return this.listKey || this.key;
        }
      };
      var methods = {
        findParent: NodePath_ancestry.findParent,
        find: NodePath_ancestry.find,
        getFunctionParent: NodePath_ancestry.getFunctionParent,
        getStatementParent: NodePath_ancestry.getStatementParent,
        getEarliestCommonAncestorFrom: NodePath_ancestry.getEarliestCommonAncestorFrom,
        getDeepestCommonAncestorFrom: NodePath_ancestry.getDeepestCommonAncestorFrom,
        getAncestry: NodePath_ancestry.getAncestry,
        isAncestor: NodePath_ancestry.isAncestor,
        isDescendant: NodePath_ancestry.isDescendant,
        inType: NodePath_ancestry.inType,
        getTypeAnnotation: NodePath_inference.getTypeAnnotation,
        isBaseType: NodePath_inference.isBaseType,
        couldBeBaseType: NodePath_inference.couldBeBaseType,
        baseTypeStrictlyMatches: NodePath_inference.baseTypeStrictlyMatches,
        isGenericType: NodePath_inference.isGenericType,
        replaceWithMultiple: NodePath_replacement.replaceWithMultiple,
        replaceWithSourceString: NodePath_replacement.replaceWithSourceString,
        replaceWith: NodePath_replacement.replaceWith,
        replaceExpressionWithStatements: NodePath_replacement.replaceExpressionWithStatements,
        replaceInline: NodePath_replacement.replaceInline,
        evaluateTruthy: NodePath_evaluation.evaluateTruthy,
        evaluate: NodePath_evaluation.evaluate,
        toComputedKey: NodePath_conversion.toComputedKey,
        ensureBlock: NodePath_conversion.ensureBlock,
        unwrapFunctionEnvironment: NodePath_conversion.unwrapFunctionEnvironment,
        arrowFunctionToExpression: NodePath_conversion.arrowFunctionToExpression,
        splitExportDeclaration: NodePath_conversion.splitExportDeclaration,
        ensureFunctionName: NodePath_conversion.ensureFunctionName,
        matchesPattern: NodePath_introspection.matchesPattern,
        isStatic: NodePath_introspection.isStatic,
        isNodeType: NodePath_introspection.isNodeType,
        canHaveVariableDeclarationOrExpression: NodePath_introspection.canHaveVariableDeclarationOrExpression,
        canSwapBetweenExpressionAndStatement: NodePath_introspection.canSwapBetweenExpressionAndStatement,
        isCompletionRecord: NodePath_introspection.isCompletionRecord,
        isStatementOrBlock: NodePath_introspection.isStatementOrBlock,
        referencesImport: NodePath_introspection.referencesImport,
        getSource: NodePath_introspection.getSource,
        willIMaybeExecuteBefore: NodePath_introspection.willIMaybeExecuteBefore,
        _guessExecutionStatusRelativeTo: NodePath_introspection._guessExecutionStatusRelativeTo,
        resolve: NodePath_introspection.resolve,
        isConstantExpression: NodePath_introspection.isConstantExpression,
        isInStrictMode: NodePath_introspection.isInStrictMode,
        isDenylisted: NodePath_context.isDenylisted,
        visit: NodePath_context.visit,
        skip: NodePath_context.skip,
        skipKey: NodePath_context.skipKey,
        stop: NodePath_context.stop,
        setContext: NodePath_context.setContext,
        requeue: NodePath_context.requeue,
        requeueComputedKeyAndDecorators: NodePath_context.requeueComputedKeyAndDecorators,
        remove: NodePath_removal.remove,
        insertBefore: NodePath_modification.insertBefore,
        insertAfter: NodePath_modification.insertAfter,
        unshiftContainer: NodePath_modification.unshiftContainer,
        pushContainer: NodePath_modification.pushContainer,
        getOpposite: NodePath_family.getOpposite,
        getCompletionRecords: NodePath_family.getCompletionRecords,
        getSibling: NodePath_family.getSibling,
        getPrevSibling: NodePath_family.getPrevSibling,
        getNextSibling: NodePath_family.getNextSibling,
        getAllNextSiblings: NodePath_family.getAllNextSiblings,
        getAllPrevSiblings: NodePath_family.getAllPrevSiblings,
        get: NodePath_family.get,
        getAssignmentIdentifiers: NodePath_family.getAssignmentIdentifiers,
        getBindingIdentifiers: NodePath_family.getBindingIdentifiers,
        getOuterBindingIdentifiers: NodePath_family.getOuterBindingIdentifiers,
        getBindingIdentifierPaths: NodePath_family.getBindingIdentifierPaths,
        getOuterBindingIdentifierPaths: NodePath_family.getOuterBindingIdentifierPaths,
        shareCommentsWithSiblings: NodePath_comments.shareCommentsWithSiblings,
        addComment: NodePath_comments.addComment,
        addComments: NodePath_comments.addComments
      };
      Object.assign(NodePath_Final.prototype, methods);
      {
        NodePath_Final.prototype.arrowFunctionToShadowed = NodePath_conversion[String("arrowFunctionToShadowed")];
        Object.assign(NodePath_Final.prototype, {
          has: NodePath_introspection[String("has")],
          is: NodePath_introspection[String("is")],
          isnt: NodePath_introspection[String("isnt")],
          equals: NodePath_introspection[String("equals")],
          hoist: NodePath_modification[String("hoist")],
          updateSiblingKeys: NodePath_modification.updateSiblingKeys,
          call: NodePath_context.call,
          isBlacklisted: NodePath_context[String("isBlacklisted")],
          setScope: NodePath_context.setScope,
          resync: NodePath_context.resync,
          popContext: NodePath_context.popContext,
          pushContext: NodePath_context.pushContext,
          setup: NodePath_context.setup,
          setKey: NodePath_context.setKey
        });
      }
      {
        NodePath_Final.prototype._guessExecutionStatusRelativeToDifferentFunctions = NodePath_introspection._guessExecutionStatusRelativeTo;
        NodePath_Final.prototype._guessExecutionStatusRelativeToDifferentFunctions = NodePath_introspection._guessExecutionStatusRelativeTo;
        Object.assign(NodePath_Final.prototype, {
          _getTypeAnnotation: NodePath_inference._getTypeAnnotation,
          _replaceWith: NodePath_replacement._replaceWith,
          _resolve: NodePath_introspection._resolve,
          _call: NodePath_context._call,
          _resyncParent: NodePath_context._resyncParent,
          _resyncKey: NodePath_context._resyncKey,
          _resyncList: NodePath_context._resyncList,
          _resyncRemoved: NodePath_context._resyncRemoved,
          _getQueueContexts: NodePath_context._getQueueContexts,
          _removeFromScope: NodePath_removal._removeFromScope,
          _callRemovalHooks: NodePath_removal._callRemovalHooks,
          _remove: NodePath_removal._remove,
          _markRemoved: NodePath_removal._markRemoved,
          _assertUnremoved: NodePath_removal._assertUnremoved,
          _containerInsert: NodePath_modification._containerInsert,
          _containerInsertBefore: NodePath_modification._containerInsertBefore,
          _containerInsertAfter: NodePath_modification._containerInsertAfter,
          _verifyNodeList: NodePath_modification._verifyNodeList,
          _getKey: NodePath_family._getKey,
          _getPattern: NodePath_family._getPattern
        });
      }
      for (const type of t3.TYPES) {
        const typeKey = `is${type}`;
        const fn = t3[typeKey];
        NodePath_Final.prototype[typeKey] = function(opts) {
          return fn(this.node, opts);
        };
        NodePath_Final.prototype[`assert${type}`] = function(opts) {
          if (!fn(this.node, opts)) {
            throw new TypeError(`Expected node path of type ${type}`);
          }
        };
      }
      Object.assign(NodePath_Final.prototype, NodePath_virtual_types_validator);
      for (const type of Object.keys(virtualTypes)) {
        if (type[0] === "_")
          continue;
        if (!t3.TYPES.includes(type))
          t3.TYPES.push(type);
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/context.js
  var require_context = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/context.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      var _index = require_path();
      var _t = require_lib5();
      var _context = require_context2();
      var {
        VISITOR_KEYS
      } = _t;
      var TraversalContext = class {
        constructor(scope, opts, state, parentPath) {
          this.queue = null;
          this.priorityQueue = null;
          this.parentPath = parentPath;
          this.scope = scope;
          this.state = state;
          this.opts = opts;
        }
        shouldVisit(node) {
          const opts = this.opts;
          if (opts.enter || opts.exit)
            return true;
          if (opts[node.type])
            return true;
          const keys2 = VISITOR_KEYS[node.type];
          if (!(keys2 != null && keys2.length))
            return false;
          for (const key of keys2) {
            if (node[key]) {
              return true;
            }
          }
          return false;
        }
        create(node, container, key, listKey) {
          return _index.default.get({
            parentPath: this.parentPath,
            parent: node,
            container,
            key,
            listKey
          });
        }
        maybeQueue(path, notPriority) {
          if (this.queue) {
            if (notPriority) {
              this.queue.push(path);
            } else {
              this.priorityQueue.push(path);
            }
          }
        }
        visitMultiple(container, parent2, listKey) {
          if (container.length === 0)
            return false;
          const queue3 = [];
          for (let key = 0; key < container.length; key++) {
            const node = container[key];
            if (node && this.shouldVisit(node)) {
              queue3.push(this.create(parent2, container, key, listKey));
            }
          }
          return this.visitQueue(queue3);
        }
        visitSingle(node, key) {
          if (this.shouldVisit(node[key])) {
            return this.visitQueue([this.create(node, node, key)]);
          } else {
            return false;
          }
        }
        visitQueue(queue3) {
          this.queue = queue3;
          this.priorityQueue = [];
          const visited = /* @__PURE__ */ new WeakSet();
          let stop = false;
          let visitIndex = 0;
          for (; visitIndex < queue3.length; ) {
            const path = queue3[visitIndex];
            visitIndex++;
            _context.resync.call(path);
            if (path.contexts.length === 0 || path.contexts[path.contexts.length - 1] !== this) {
              _context.pushContext.call(path, this);
            }
            if (path.key === null)
              continue;
            const {
              node
            } = path;
            if (visited.has(node))
              continue;
            if (node)
              visited.add(node);
            if (path.visit()) {
              stop = true;
              break;
            }
            if (this.priorityQueue.length) {
              stop = this.visitQueue(this.priorityQueue);
              this.priorityQueue = [];
              this.queue = queue3;
              if (stop)
                break;
            }
          }
          for (let i = 0; i < visitIndex; i++) {
            _context.popContext.call(queue3[i]);
          }
          this.queue = null;
          return stop;
        }
        visit(node, key) {
          const nodes = node[key];
          if (!nodes)
            return false;
          if (Array.isArray(nodes)) {
            return this.visitMultiple(nodes, node, key);
          } else {
            return this.visitSingle(node, key);
          }
        }
      };
      exports8.default = TraversalContext;
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/traverse-node.js
  var require_traverse_node = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/traverse-node.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.traverseNode = traverseNode;
      var _context = require_context();
      var _index = require_path();
      var _t = require_lib5();
      var _context2 = require_context2();
      var {
        VISITOR_KEYS
      } = _t;
      function traverseNode(node, opts, scope, state, path, skipKeys, visitSelf) {
        ;
        const keys2 = VISITOR_KEYS[node.type];
        if (!keys2)
          return false;
        const context = new _context.default(scope, opts, state, path);
        if (visitSelf) {
          if (skipKeys != null && skipKeys[path.parentKey])
            return false;
          return context.visitQueue([path]);
        }
        for (const key of keys2) {
          if (skipKeys != null && skipKeys[key])
            continue;
          if (context.visit(node, key)) {
            return true;
          }
        }
        return false;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/context.js
  var require_context2 = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/path/context.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8._call = _call;
      exports8._getQueueContexts = _getQueueContexts;
      exports8._resyncKey = _resyncKey;
      exports8._resyncList = _resyncList;
      exports8._resyncParent = _resyncParent;
      exports8._resyncRemoved = _resyncRemoved;
      exports8.call = call;
      exports8.isDenylisted = isDenylisted;
      exports8.popContext = popContext;
      exports8.pushContext = pushContext;
      exports8.requeue = requeue;
      exports8.requeueComputedKeyAndDecorators = requeueComputedKeyAndDecorators;
      exports8.resync = resync;
      exports8.setContext = setContext;
      exports8.setKey = setKey;
      exports8.setScope = setScope;
      exports8.setup = setup;
      exports8.skip = skip;
      exports8.skipKey = skipKey;
      exports8.stop = stop;
      exports8.visit = visit;
      var _traverseNode = require_traverse_node();
      var _index = require_path();
      var _removal = require_removal();
      var t3 = require_lib5();
      function call(key) {
        const opts = this.opts;
        this.debug(key);
        if (this.node) {
          if (_call.call(this, opts[key]))
            return true;
        }
        if (this.node) {
          var _opts$this$node$type;
          return _call.call(this, (_opts$this$node$type = opts[this.node.type]) == null ? void 0 : _opts$this$node$type[key]);
        }
        return false;
      }
      function _call(fns) {
        if (!fns)
          return false;
        for (const fn of fns) {
          if (!fn)
            continue;
          const node = this.node;
          if (!node)
            return true;
          const ret = fn.call(this.state, this, this.state);
          if (ret && typeof ret === "object" && typeof ret.then === "function") {
            throw new Error(`You appear to be using a plugin with an async traversal visitor, which your current version of Babel does not support. If you're using a published plugin, you may need to upgrade your @babel/core version.`);
          }
          if (ret) {
            throw new Error(`Unexpected return value from visitor method ${fn}`);
          }
          if (this.node !== node)
            return true;
          if (this._traverseFlags > 0)
            return true;
        }
        return false;
      }
      function isDenylisted() {
        var _this$opts$denylist;
        const denylist = (_this$opts$denylist = this.opts.denylist) != null ? _this$opts$denylist : this.opts.blacklist;
        return denylist == null ? void 0 : denylist.includes(this.node.type);
      }
      {
        exports8.isBlacklisted = isDenylisted;
      }
      function restoreContext(path, context) {
        if (path.context !== context) {
          path.context = context;
          path.state = context.state;
          path.opts = context.opts;
        }
      }
      function visit() {
        var _this$opts$shouldSkip, _this$opts;
        if (!this.node) {
          return false;
        }
        if (this.isDenylisted()) {
          return false;
        }
        if ((_this$opts$shouldSkip = (_this$opts = this.opts).shouldSkip) != null && _this$opts$shouldSkip.call(_this$opts, this)) {
          return false;
        }
        const currentContext = this.context;
        if (this.shouldSkip || call.call(this, "enter")) {
          this.debug("Skip...");
          return this.shouldStop;
        }
        restoreContext(this, currentContext);
        this.debug("Recursing into...");
        this.shouldStop = (0, _traverseNode.traverseNode)(this.node, this.opts, this.scope, this.state, this, this.skipKeys);
        restoreContext(this, currentContext);
        call.call(this, "exit");
        return this.shouldStop;
      }
      function skip() {
        this.shouldSkip = true;
      }
      function skipKey(key) {
        if (this.skipKeys == null) {
          this.skipKeys = {};
        }
        this.skipKeys[key] = true;
      }
      function stop() {
        this._traverseFlags |= _index.SHOULD_SKIP | _index.SHOULD_STOP;
      }
      function setScope() {
        var _this$opts2, _this$scope;
        if ((_this$opts2 = this.opts) != null && _this$opts2.noScope)
          return;
        let path = this.parentPath;
        if ((this.key === "key" || this.listKey === "decorators") && path.isMethod() || this.key === "discriminant" && path.isSwitchStatement()) {
          path = path.parentPath;
        }
        let target;
        while (path && !target) {
          var _path$opts;
          if ((_path$opts = path.opts) != null && _path$opts.noScope)
            return;
          target = path.scope;
          path = path.parentPath;
        }
        this.scope = this.getScope(target);
        (_this$scope = this.scope) == null || _this$scope.init();
      }
      function setContext(context) {
        if (this.skipKeys != null) {
          this.skipKeys = {};
        }
        this._traverseFlags = 0;
        if (context) {
          this.context = context;
          this.state = context.state;
          this.opts = context.opts;
        }
        setScope.call(this);
        return this;
      }
      function resync() {
        if (this.removed)
          return;
        _resyncParent.call(this);
        _resyncList.call(this);
        _resyncKey.call(this);
      }
      function _resyncParent() {
        if (this.parentPath) {
          this.parent = this.parentPath.node;
        }
      }
      function _resyncKey() {
        if (!this.container)
          return;
        if (this.node === this.container[this.key]) {
          return;
        }
        if (Array.isArray(this.container)) {
          for (let i = 0; i < this.container.length; i++) {
            if (this.container[i] === this.node) {
              setKey.call(this, i);
              return;
            }
          }
        } else {
          for (const key of Object.keys(this.container)) {
            if (this.container[key] === this.node) {
              setKey.call(this, key);
              return;
            }
          }
        }
        this.key = null;
      }
      function _resyncList() {
        if (!this.parent || !this.inList)
          return;
        const newContainer = this.parent[this.listKey];
        if (this.container === newContainer)
          return;
        this.container = newContainer || null;
      }
      function _resyncRemoved() {
        if (this.key == null || !this.container || this.container[this.key] !== this.node) {
          _removal._markRemoved.call(this);
        }
      }
      function popContext() {
        this.contexts.pop();
        if (this.contexts.length > 0) {
          this.setContext(this.contexts[this.contexts.length - 1]);
        } else {
          this.setContext(void 0);
        }
      }
      function pushContext(context) {
        this.contexts.push(context);
        this.setContext(context);
      }
      function setup(parentPath, container, listKey, key) {
        this.listKey = listKey;
        this.container = container;
        this.parentPath = parentPath || this.parentPath;
        setKey.call(this, key);
      }
      function setKey(key) {
        var _this$node;
        this.key = key;
        this.node = this.container[this.key];
        this.type = (_this$node = this.node) == null ? void 0 : _this$node.type;
      }
      function requeue(pathToQueue = this) {
        if (pathToQueue.removed)
          return;
        ;
        const contexts = this.contexts;
        for (const context of contexts) {
          context.maybeQueue(pathToQueue);
        }
      }
      function requeueComputedKeyAndDecorators() {
        const {
          context,
          node
        } = this;
        if (!t3.isPrivate(node) && node.computed) {
          context.maybeQueue(this.get("key"));
        }
        if (node.decorators) {
          for (const decorator of this.get("decorators")) {
            context.maybeQueue(decorator);
          }
        }
      }
      function _getQueueContexts() {
        let path = this;
        let contexts = this.contexts;
        while (!contexts.length) {
          path = path.parentPath;
          if (!path)
            break;
          contexts = path.contexts;
        }
        return contexts;
      }
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/hub.js
  var require_hub = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/hub.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      exports8.default = void 0;
      var Hub = class {
        getCode() {
        }
        getScope() {
        }
        addHelper() {
          throw new Error("Helpers are not supported by the default hub.");
        }
        buildError(node, msg, Error2 = TypeError) {
          return new Error2(msg);
        }
      };
      exports8.default = Hub;
    }
  });

  // ../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/index.js
  var require_lib9 = __commonJS({
    "../../node_modules/.pnpm/@babel+traverse@7.28.3/node_modules/@babel/traverse/lib/index.js"(exports8) {
      "use strict";
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      Object.defineProperty(exports8, "__esModule", {
        value: true
      });
      Object.defineProperty(exports8, "Hub", {
        enumerable: true,
        get: function() {
          return _hub.default;
        }
      });
      Object.defineProperty(exports8, "NodePath", {
        enumerable: true,
        get: function() {
          return _index.default;
        }
      });
      Object.defineProperty(exports8, "Scope", {
        enumerable: true,
        get: function() {
          return _index2.default;
        }
      });
      exports8.visitors = exports8.default = void 0;
      require_context2();
      var visitors = require_visitors();
      exports8.visitors = visitors;
      var _t = require_lib5();
      var cache = require_cache2();
      var _traverseNode = require_traverse_node();
      var _index = require_path();
      var _index2 = require_scope();
      var _hub = require_hub();
      var {
        VISITOR_KEYS,
        removeProperties,
        traverseFast
      } = _t;
      function traverse3(parent2, opts = {}, scope, state, parentPath, visitSelf) {
        if (!parent2)
          return;
        if (!opts.noScope && !scope) {
          if (parent2.type !== "Program" && parent2.type !== "File") {
            throw new Error(`You must pass a scope and parentPath unless traversing a Program/File. Instead of that you tried to traverse a ${parent2.type} node without passing scope and parentPath.`);
          }
        }
        if (!parentPath && visitSelf) {
          throw new Error("visitSelf can only be used when providing a NodePath.");
        }
        if (!VISITOR_KEYS[parent2.type]) {
          return;
        }
        visitors.explode(opts);
        (0, _traverseNode.traverseNode)(parent2, opts, scope, state, parentPath, null, visitSelf);
      }
      var _default = exports8.default = traverse3;
      traverse3.visitors = visitors;
      traverse3.verify = visitors.verify;
      traverse3.explode = visitors.explode;
      traverse3.cheap = function(node, enter) {
        traverseFast(node, enter);
        return;
      };
      traverse3.node = function(node, opts, scope, state, path, skipKeys) {
        (0, _traverseNode.traverseNode)(node, opts, scope, state, path, skipKeys);
      };
      traverse3.clearNode = function(node, opts) {
        removeProperties(node, opts);
      };
      traverse3.removeProperties = function(tree, opts) {
        traverseFast(tree, traverse3.clearNode, opts);
        return tree;
      };
      traverse3.hasType = function(tree, type, denylistTypes) {
        if (denylistTypes != null && denylistTypes.includes(tree.type))
          return false;
        if (tree.type === type)
          return true;
        return traverseFast(tree, function(node) {
          if (denylistTypes != null && denylistTypes.includes(node.type)) {
            return traverseFast.skip;
          }
          if (node.type === type) {
            return traverseFast.stop;
          }
        });
      };
      traverse3.cache = cache;
    }
  });

  // ../../node_modules/.pnpm/prettier@2.8.8/node_modules/prettier/standalone.js
  var require_standalone = __commonJS({
    "../../node_modules/.pnpm/prettier@2.8.8/node_modules/prettier/standalone.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      (function(e) {
        if (typeof exports8 == "object" && typeof module2 == "object")
          module2.exports = e();
        else if (typeof define == "function" && define.amd)
          define(e);
        else {
          var f = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : typeof self < "u" ? self : this || {};
          f.prettier = e();
        }
      })(function() {
        "use strict";
        var xe = (e, r) => () => (r || e((r = { exports: {} }).exports, r), r.exports);
        var pt = xe((r0, pu) => {
          var ir = function(e) {
            return e && e.Math == Math && e;
          };
          pu.exports = ir(typeof globalThis == "object" && globalThis) || ir(typeof window == "object" && window) || ir(typeof self == "object" && self) || ir(typeof global == "object" && global) || function() {
            return this;
          }() || Function("return this")();
        });
        var Dt = xe((n0, fu) => {
          fu.exports = function(e) {
            try {
              return !!e();
            } catch {
              return true;
            }
          };
        });
        var yt = xe((u0, Du) => {
          var Mo = Dt();
          Du.exports = !Mo(function() {
            return Object.defineProperty({}, 1, { get: function() {
              return 7;
            } })[1] != 7;
          });
        });
        var ar = xe((s0, mu) => {
          var Ro = Dt();
          mu.exports = !Ro(function() {
            var e = function() {
            }.bind();
            return typeof e != "function" || e.hasOwnProperty("prototype");
          });
        });
        var At = xe((i0, du) => {
          var $o = ar(), or = Function.prototype.call;
          du.exports = $o ? or.bind(or) : function() {
            return or.apply(or, arguments);
          };
        });
        var vu = xe((hu) => {
          "use strict";
          var gu = {}.propertyIsEnumerable, yu = Object.getOwnPropertyDescriptor, Vo = yu && !gu.call({ 1: 2 }, 1);
          hu.f = Vo ? function(r) {
            var t3 = yu(this, r);
            return !!t3 && t3.enumerable;
          } : gu;
        });
        var lr = xe((o0, Cu) => {
          Cu.exports = function(e, r) {
            return { enumerable: !(e & 1), configurable: !(e & 2), writable: !(e & 4), value: r };
          };
        });
        var mt = xe((l0, Au) => {
          var Eu = ar(), Fu = Function.prototype, Wr = Fu.call, Wo = Eu && Fu.bind.bind(Wr, Wr);
          Au.exports = Eu ? Wo : function(e) {
            return function() {
              return Wr.apply(e, arguments);
            };
          };
        });
        var Vt = xe((c0, xu) => {
          var Su = mt(), Ho = Su({}.toString), Go = Su("".slice);
          xu.exports = function(e) {
            return Go(Ho(e), 8, -1);
          };
        });
        var Tu = xe((p0, bu) => {
          var Uo = mt(), Jo = Dt(), zo = Vt(), Hr = Object, Xo = Uo("".split);
          bu.exports = Jo(function() {
            return !Hr("z").propertyIsEnumerable(0);
          }) ? function(e) {
            return zo(e) == "String" ? Xo(e, "") : Hr(e);
          } : Hr;
        });
        var cr = xe((f0, Bu) => {
          Bu.exports = function(e) {
            return e == null;
          };
        });
        var Gr = xe((D0, Nu) => {
          var Ko = cr(), Yo = TypeError;
          Nu.exports = function(e) {
            if (Ko(e))
              throw Yo("Can't call method on " + e);
            return e;
          };
        });
        var pr = xe((m0, wu) => {
          var Qo = Tu(), Zo = Gr();
          wu.exports = function(e) {
            return Qo(Zo(e));
          };
        });
        var Jr = xe((d0, _u) => {
          var Ur = typeof document == "object" && document.all, el = typeof Ur > "u" && Ur !== void 0;
          _u.exports = { all: Ur, IS_HTMLDDA: el };
        });
        var ot = xe((g0, Iu) => {
          var Pu = Jr(), tl = Pu.all;
          Iu.exports = Pu.IS_HTMLDDA ? function(e) {
            return typeof e == "function" || e === tl;
          } : function(e) {
            return typeof e == "function";
          };
        });
        var St = xe((y0, Ou) => {
          var ku = ot(), Lu = Jr(), rl = Lu.all;
          Ou.exports = Lu.IS_HTMLDDA ? function(e) {
            return typeof e == "object" ? e !== null : ku(e) || e === rl;
          } : function(e) {
            return typeof e == "object" ? e !== null : ku(e);
          };
        });
        var Wt = xe((h0, ju) => {
          var zr = pt(), nl = ot(), ul = function(e) {
            return nl(e) ? e : void 0;
          };
          ju.exports = function(e, r) {
            return arguments.length < 2 ? ul(zr[e]) : zr[e] && zr[e][r];
          };
        });
        var Xr = xe((v0, qu) => {
          var sl = mt();
          qu.exports = sl({}.isPrototypeOf);
        });
        var Ru = xe((C0, Mu) => {
          var il = Wt();
          Mu.exports = il("navigator", "userAgent") || "";
        });
        var Ju = xe((E0, Uu) => {
          var Gu = pt(), Kr = Ru(), $u = Gu.process, Vu = Gu.Deno, Wu = $u && $u.versions || Vu && Vu.version, Hu = Wu && Wu.v8, dt, fr;
          Hu && (dt = Hu.split("."), fr = dt[0] > 0 && dt[0] < 4 ? 1 : +(dt[0] + dt[1]));
          !fr && Kr && (dt = Kr.match(/Edge\/(\d+)/), (!dt || dt[1] >= 74) && (dt = Kr.match(/Chrome\/(\d+)/), dt && (fr = +dt[1])));
          Uu.exports = fr;
        });
        var Yr = xe((F0, Xu) => {
          var zu = Ju(), al = Dt();
          Xu.exports = !!Object.getOwnPropertySymbols && !al(function() {
            var e = Symbol();
            return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && zu && zu < 41;
          });
        });
        var Qr = xe((A0, Ku) => {
          var ol = Yr();
          Ku.exports = ol && !Symbol.sham && typeof Symbol.iterator == "symbol";
        });
        var Zr = xe((S0, Yu) => {
          var ll = Wt(), cl = ot(), pl = Xr(), fl = Qr(), Dl = Object;
          Yu.exports = fl ? function(e) {
            return typeof e == "symbol";
          } : function(e) {
            var r = ll("Symbol");
            return cl(r) && pl(r.prototype, Dl(e));
          };
        });
        var Dr = xe((x0, Qu) => {
          var ml = String;
          Qu.exports = function(e) {
            try {
              return ml(e);
            } catch {
              return "Object";
            }
          };
        });
        var Ht = xe((b0, Zu) => {
          var dl = ot(), gl = Dr(), yl = TypeError;
          Zu.exports = function(e) {
            if (dl(e))
              return e;
            throw yl(gl(e) + " is not a function");
          };
        });
        var mr = xe((T0, es) => {
          var hl = Ht(), vl = cr();
          es.exports = function(e, r) {
            var t3 = e[r];
            return vl(t3) ? void 0 : hl(t3);
          };
        });
        var rs = xe((B0, ts) => {
          var en = At(), tn = ot(), rn = St(), Cl = TypeError;
          ts.exports = function(e, r) {
            var t3, s;
            if (r === "string" && tn(t3 = e.toString) && !rn(s = en(t3, e)) || tn(t3 = e.valueOf) && !rn(s = en(t3, e)) || r !== "string" && tn(t3 = e.toString) && !rn(s = en(t3, e)))
              return s;
            throw Cl("Can't convert object to primitive value");
          };
        });
        var us = xe((N0, ns) => {
          ns.exports = false;
        });
        var dr = xe((w0, is) => {
          var ss = pt(), El = Object.defineProperty;
          is.exports = function(e, r) {
            try {
              El(ss, e, { value: r, configurable: true, writable: true });
            } catch {
              ss[e] = r;
            }
            return r;
          };
        });
        var gr = xe((_0, os) => {
          var Fl = pt(), Al = dr(), as = "__core-js_shared__", Sl = Fl[as] || Al(as, {});
          os.exports = Sl;
        });
        var nn = xe((P0, cs) => {
          var xl = us(), ls = gr();
          (cs.exports = function(e, r) {
            return ls[e] || (ls[e] = r !== void 0 ? r : {});
          })("versions", []).push({ version: "3.26.1", mode: xl ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE", source: "https://github.com/zloirock/core-js" });
        });
        var yr = xe((I0, ps) => {
          var bl = Gr(), Tl = Object;
          ps.exports = function(e) {
            return Tl(bl(e));
          };
        });
        var Ct = xe((k0, fs) => {
          var Bl = mt(), Nl = yr(), wl = Bl({}.hasOwnProperty);
          fs.exports = Object.hasOwn || function(r, t3) {
            return wl(Nl(r), t3);
          };
        });
        var un = xe((L0, Ds) => {
          var _l = mt(), Pl = 0, Il = Math.random(), kl = _l(1 .toString);
          Ds.exports = function(e) {
            return "Symbol(" + (e === void 0 ? "" : e) + ")_" + kl(++Pl + Il, 36);
          };
        });
        var bt = xe((O0, hs) => {
          var Ll = pt(), Ol = nn(), ms = Ct(), jl = un(), ds = Yr(), ys = Qr(), It = Ol("wks"), xt = Ll.Symbol, gs = xt && xt.for, ql = ys ? xt : xt && xt.withoutSetter || jl;
          hs.exports = function(e) {
            if (!ms(It, e) || !(ds || typeof It[e] == "string")) {
              var r = "Symbol." + e;
              ds && ms(xt, e) ? It[e] = xt[e] : ys && gs ? It[e] = gs(r) : It[e] = ql(r);
            }
            return It[e];
          };
        });
        var Fs = xe((j0, Es) => {
          var Ml = At(), vs = St(), Cs = Zr(), Rl = mr(), $l = rs(), Vl = bt(), Wl = TypeError, Hl = Vl("toPrimitive");
          Es.exports = function(e, r) {
            if (!vs(e) || Cs(e))
              return e;
            var t3 = Rl(e, Hl), s;
            if (t3) {
              if (r === void 0 && (r = "default"), s = Ml(t3, e, r), !vs(s) || Cs(s))
                return s;
              throw Wl("Can't convert object to primitive value");
            }
            return r === void 0 && (r = "number"), $l(e, r);
          };
        });
        var hr = xe((q0, As) => {
          var Gl = Fs(), Ul = Zr();
          As.exports = function(e) {
            var r = Gl(e, "string");
            return Ul(r) ? r : r + "";
          };
        });
        var bs = xe((M0, xs) => {
          var Jl = pt(), Ss = St(), sn = Jl.document, zl = Ss(sn) && Ss(sn.createElement);
          xs.exports = function(e) {
            return zl ? sn.createElement(e) : {};
          };
        });
        var an = xe((R0, Ts) => {
          var Xl = yt(), Kl = Dt(), Yl = bs();
          Ts.exports = !Xl && !Kl(function() {
            return Object.defineProperty(Yl("div"), "a", { get: function() {
              return 7;
            } }).a != 7;
          });
        });
        var on3 = xe((Ns) => {
          var Ql = yt(), Zl = At(), ec = vu(), tc = lr(), rc = pr(), nc = hr(), uc = Ct(), sc = an(), Bs = Object.getOwnPropertyDescriptor;
          Ns.f = Ql ? Bs : function(r, t3) {
            if (r = rc(r), t3 = nc(t3), sc)
              try {
                return Bs(r, t3);
              } catch {
              }
            if (uc(r, t3))
              return tc(!Zl(ec.f, r, t3), r[t3]);
          };
        });
        var _s = xe((V0, ws) => {
          var ic = yt(), ac = Dt();
          ws.exports = ic && ac(function() {
            return Object.defineProperty(function() {
            }, "prototype", { value: 42, writable: false }).prototype != 42;
          });
        });
        var Tt = xe((W0, Ps) => {
          var oc = St(), lc = String, cc = TypeError;
          Ps.exports = function(e) {
            if (oc(e))
              return e;
            throw cc(lc(e) + " is not an object");
          };
        });
        var kt = xe((ks) => {
          var pc = yt(), fc = an(), Dc = _s(), vr = Tt(), Is = hr(), mc = TypeError, ln = Object.defineProperty, dc = Object.getOwnPropertyDescriptor, cn = "enumerable", pn = "configurable", fn = "writable";
          ks.f = pc ? Dc ? function(r, t3, s) {
            if (vr(r), t3 = Is(t3), vr(s), typeof r == "function" && t3 === "prototype" && "value" in s && fn in s && !s[fn]) {
              var a = dc(r, t3);
              a && a[fn] && (r[t3] = s.value, s = { configurable: pn in s ? s[pn] : a[pn], enumerable: cn in s ? s[cn] : a[cn], writable: false });
            }
            return ln(r, t3, s);
          } : ln : function(r, t3, s) {
            if (vr(r), t3 = Is(t3), vr(s), fc)
              try {
                return ln(r, t3, s);
              } catch {
              }
            if ("get" in s || "set" in s)
              throw mc("Accessors not supported");
            return "value" in s && (r[t3] = s.value), r;
          };
        });
        var Dn = xe((G0, Ls) => {
          var gc = yt(), yc = kt(), hc = lr();
          Ls.exports = gc ? function(e, r, t3) {
            return yc.f(e, r, hc(1, t3));
          } : function(e, r, t3) {
            return e[r] = t3, e;
          };
        });
        var qs = xe((U0, js) => {
          var mn = yt(), vc = Ct(), Os = Function.prototype, Cc = mn && Object.getOwnPropertyDescriptor, dn = vc(Os, "name"), Ec = dn && function() {
          }.name === "something", Fc = dn && (!mn || mn && Cc(Os, "name").configurable);
          js.exports = { EXISTS: dn, PROPER: Ec, CONFIGURABLE: Fc };
        });
        var yn = xe((J0, Ms) => {
          var Ac = mt(), Sc = ot(), gn = gr(), xc = Ac(Function.toString);
          Sc(gn.inspectSource) || (gn.inspectSource = function(e) {
            return xc(e);
          });
          Ms.exports = gn.inspectSource;
        });
        var Vs = xe((z0, $s) => {
          var bc = pt(), Tc = ot(), Rs = bc.WeakMap;
          $s.exports = Tc(Rs) && /native code/.test(String(Rs));
        });
        var Gs = xe((X0, Hs) => {
          var Bc = nn(), Nc = un(), Ws = Bc("keys");
          Hs.exports = function(e) {
            return Ws[e] || (Ws[e] = Nc(e));
          };
        });
        var hn = xe((K0, Us) => {
          Us.exports = {};
        });
        var Ks = xe((Y0, Xs) => {
          var wc = Vs(), zs = pt(), _c = St(), Pc = Dn(), vn = Ct(), Cn = gr(), Ic = Gs(), kc = hn(), Js = "Object already initialized", En = zs.TypeError, Lc = zs.WeakMap, Cr, Gt, Er, Oc = function(e) {
            return Er(e) ? Gt(e) : Cr(e, {});
          }, jc = function(e) {
            return function(r) {
              var t3;
              if (!_c(r) || (t3 = Gt(r)).type !== e)
                throw En("Incompatible receiver, " + e + " required");
              return t3;
            };
          };
          wc || Cn.state ? (gt2 = Cn.state || (Cn.state = new Lc()), gt2.get = gt2.get, gt2.has = gt2.has, gt2.set = gt2.set, Cr = function(e, r) {
            if (gt2.has(e))
              throw En(Js);
            return r.facade = e, gt2.set(e, r), r;
          }, Gt = function(e) {
            return gt2.get(e) || {};
          }, Er = function(e) {
            return gt2.has(e);
          }) : (Bt = Ic("state"), kc[Bt] = true, Cr = function(e, r) {
            if (vn(e, Bt))
              throw En(Js);
            return r.facade = e, Pc(e, Bt, r), r;
          }, Gt = function(e) {
            return vn(e, Bt) ? e[Bt] : {};
          }, Er = function(e) {
            return vn(e, Bt);
          });
          var gt2, Bt;
          Xs.exports = { set: Cr, get: Gt, has: Er, enforce: Oc, getterFor: jc };
        });
        var An = xe((Q0, Qs) => {
          var qc = Dt(), Mc = ot(), Fr = Ct(), Fn = yt(), Rc = qs().CONFIGURABLE, $c = yn(), Ys = Ks(), Vc = Ys.enforce, Wc = Ys.get, Ar = Object.defineProperty, Hc = Fn && !qc(function() {
            return Ar(function() {
            }, "length", { value: 8 }).length !== 8;
          }), Gc = String(String).split("String"), Uc = Qs.exports = function(e, r, t3) {
            String(r).slice(0, 7) === "Symbol(" && (r = "[" + String(r).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), t3 && t3.getter && (r = "get " + r), t3 && t3.setter && (r = "set " + r), (!Fr(e, "name") || Rc && e.name !== r) && (Fn ? Ar(e, "name", { value: r, configurable: true }) : e.name = r), Hc && t3 && Fr(t3, "arity") && e.length !== t3.arity && Ar(e, "length", { value: t3.arity });
            try {
              t3 && Fr(t3, "constructor") && t3.constructor ? Fn && Ar(e, "prototype", { writable: false }) : e.prototype && (e.prototype = void 0);
            } catch {
            }
            var s = Vc(e);
            return Fr(s, "source") || (s.source = Gc.join(typeof r == "string" ? r : "")), e;
          };
          Function.prototype.toString = Uc(function() {
            return Mc(this) && Wc(this).source || $c(this);
          }, "toString");
        });
        var ei = xe((Z0, Zs) => {
          var Jc = ot(), zc = kt(), Xc = An(), Kc = dr();
          Zs.exports = function(e, r, t3, s) {
            s || (s = {});
            var a = s.enumerable, n = s.name !== void 0 ? s.name : r;
            if (Jc(t3) && Xc(t3, n, s), s.global)
              a ? e[r] = t3 : Kc(r, t3);
            else {
              try {
                s.unsafe ? e[r] && (a = true) : delete e[r];
              } catch {
              }
              a ? e[r] = t3 : zc.f(e, r, { value: t3, enumerable: false, configurable: !s.nonConfigurable, writable: !s.nonWritable });
            }
            return e;
          };
        });
        var ri = xe((ey, ti) => {
          var Yc = Math.ceil, Qc = Math.floor;
          ti.exports = Math.trunc || function(r) {
            var t3 = +r;
            return (t3 > 0 ? Qc : Yc)(t3);
          };
        });
        var Sr = xe((ty, ni) => {
          var Zc = ri();
          ni.exports = function(e) {
            var r = +e;
            return r !== r || r === 0 ? 0 : Zc(r);
          };
        });
        var si = xe((ry, ui) => {
          var ep = Sr(), tp = Math.max, rp = Math.min;
          ui.exports = function(e, r) {
            var t3 = ep(e);
            return t3 < 0 ? tp(t3 + r, 0) : rp(t3, r);
          };
        });
        var ai = xe((ny, ii) => {
          var np = Sr(), up = Math.min;
          ii.exports = function(e) {
            return e > 0 ? up(np(e), 9007199254740991) : 0;
          };
        });
        var Lt = xe((uy, oi) => {
          var sp = ai();
          oi.exports = function(e) {
            return sp(e.length);
          };
        });
        var pi = xe((sy, ci) => {
          var ip = pr(), ap = si(), op = Lt(), li = function(e) {
            return function(r, t3, s) {
              var a = ip(r), n = op(a), u = ap(s, n), i;
              if (e && t3 != t3) {
                for (; n > u; )
                  if (i = a[u++], i != i)
                    return true;
              } else
                for (; n > u; u++)
                  if ((e || u in a) && a[u] === t3)
                    return e || u || 0;
              return !e && -1;
            };
          };
          ci.exports = { includes: li(true), indexOf: li(false) };
        });
        var mi = xe((iy, Di) => {
          var lp = mt(), Sn = Ct(), cp = pr(), pp = pi().indexOf, fp = hn(), fi = lp([].push);
          Di.exports = function(e, r) {
            var t3 = cp(e), s = 0, a = [], n;
            for (n in t3)
              !Sn(fp, n) && Sn(t3, n) && fi(a, n);
            for (; r.length > s; )
              Sn(t3, n = r[s++]) && (~pp(a, n) || fi(a, n));
            return a;
          };
        });
        var gi = xe((ay, di) => {
          di.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        });
        var hi = xe((yi) => {
          var Dp = mi(), mp = gi(), dp = mp.concat("length", "prototype");
          yi.f = Object.getOwnPropertyNames || function(r) {
            return Dp(r, dp);
          };
        });
        var Ci = xe((vi) => {
          vi.f = Object.getOwnPropertySymbols;
        });
        var Fi = xe((cy, Ei) => {
          var gp = Wt(), yp = mt(), hp = hi(), vp = Ci(), Cp = Tt(), Ep = yp([].concat);
          Ei.exports = gp("Reflect", "ownKeys") || function(r) {
            var t3 = hp.f(Cp(r)), s = vp.f;
            return s ? Ep(t3, s(r)) : t3;
          };
        });
        var xi = xe((py, Si) => {
          var Ai = Ct(), Fp = Fi(), Ap = on3(), Sp = kt();
          Si.exports = function(e, r, t3) {
            for (var s = Fp(r), a = Sp.f, n = Ap.f, u = 0; u < s.length; u++) {
              var i = s[u];
              !Ai(e, i) && !(t3 && Ai(t3, i)) && a(e, i, n(r, i));
            }
          };
        });
        var Ti = xe((fy, bi) => {
          var xp = Dt(), bp = ot(), Tp = /#|\.prototype\./, Ut = function(e, r) {
            var t3 = Np[Bp(e)];
            return t3 == _p ? true : t3 == wp ? false : bp(r) ? xp(r) : !!r;
          }, Bp = Ut.normalize = function(e) {
            return String(e).replace(Tp, ".").toLowerCase();
          }, Np = Ut.data = {}, wp = Ut.NATIVE = "N", _p = Ut.POLYFILL = "P";
          bi.exports = Ut;
        });
        var Jt = xe((Dy, Bi) => {
          var xn = pt(), Pp = on3().f, Ip = Dn(), kp = ei(), Lp = dr(), Op = xi(), jp = Ti();
          Bi.exports = function(e, r) {
            var t3 = e.target, s = e.global, a = e.stat, n, u, i, l, p, y;
            if (s ? u = xn : a ? u = xn[t3] || Lp(t3, {}) : u = (xn[t3] || {}).prototype, u)
              for (i in r) {
                if (p = r[i], e.dontCallGetSet ? (y = Pp(u, i), l = y && y.value) : l = u[i], n = jp(s ? i : t3 + (a ? "." : "#") + i, e.forced), !n && l !== void 0) {
                  if (typeof p == typeof l)
                    continue;
                  Op(p, l);
                }
                (e.sham || l && l.sham) && Ip(p, "sham", true), kp(u, i, p, e);
              }
          };
        });
        var bn = xe((my, Ni) => {
          var qp = Vt();
          Ni.exports = Array.isArray || function(r) {
            return qp(r) == "Array";
          };
        });
        var _i = xe((dy, wi) => {
          var Mp = TypeError, Rp = 9007199254740991;
          wi.exports = function(e) {
            if (e > Rp)
              throw Mp("Maximum allowed index exceeded");
            return e;
          };
        });
        var Ii = xe((gy, Pi) => {
          var $p = Vt(), Vp = mt();
          Pi.exports = function(e) {
            if ($p(e) === "Function")
              return Vp(e);
          };
        });
        var Tn = xe((yy, Li) => {
          var ki = Ii(), Wp = Ht(), Hp = ar(), Gp = ki(ki.bind);
          Li.exports = function(e, r) {
            return Wp(e), r === void 0 ? e : Hp ? Gp(e, r) : function() {
              return e.apply(r, arguments);
            };
          };
        });
        var Bn = xe((hy, ji) => {
          "use strict";
          var Up = bn(), Jp = Lt(), zp = _i(), Xp = Tn(), Oi = function(e, r, t3, s, a, n, u, i) {
            for (var l = a, p = 0, y = u ? Xp(u, i) : false, h, g; p < s; )
              p in t3 && (h = y ? y(t3[p], p, r) : t3[p], n > 0 && Up(h) ? (g = Jp(h), l = Oi(e, r, h, g, l, n - 1) - 1) : (zp(l + 1), e[l] = h), l++), p++;
            return l;
          };
          ji.exports = Oi;
        });
        var Ri = xe((vy, Mi) => {
          var Kp = bt(), Yp = Kp("toStringTag"), qi = {};
          qi[Yp] = "z";
          Mi.exports = String(qi) === "[object z]";
        });
        var Nn = xe((Cy, $i) => {
          var Qp = Ri(), Zp = ot(), xr = Vt(), ef = bt(), tf = ef("toStringTag"), rf = Object, nf = xr(function() {
            return arguments;
          }()) == "Arguments", uf = function(e, r) {
            try {
              return e[r];
            } catch {
            }
          };
          $i.exports = Qp ? xr : function(e) {
            var r, t3, s;
            return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (t3 = uf(r = rf(e), tf)) == "string" ? t3 : nf ? xr(r) : (s = xr(r)) == "Object" && Zp(r.callee) ? "Arguments" : s;
          };
        });
        var Ji = xe((Ey, Ui) => {
          var sf = mt(), af = Dt(), Vi = ot(), of = Nn(), lf = Wt(), cf = yn(), Wi = function() {
          }, pf = [], Hi = lf("Reflect", "construct"), wn = /^\s*(?:class|function)\b/, ff = sf(wn.exec), Df = !wn.exec(Wi), zt = function(r) {
            if (!Vi(r))
              return false;
            try {
              return Hi(Wi, pf, r), true;
            } catch {
              return false;
            }
          }, Gi = function(r) {
            if (!Vi(r))
              return false;
            switch (of(r)) {
              case "AsyncFunction":
              case "GeneratorFunction":
              case "AsyncGeneratorFunction":
                return false;
            }
            try {
              return Df || !!ff(wn, cf(r));
            } catch {
              return true;
            }
          };
          Gi.sham = true;
          Ui.exports = !Hi || af(function() {
            var e;
            return zt(zt.call) || !zt(Object) || !zt(function() {
              e = true;
            }) || e;
          }) ? Gi : zt;
        });
        var Yi = xe((Fy, Ki) => {
          var zi = bn(), mf = Ji(), df = St(), gf = bt(), yf = gf("species"), Xi = Array;
          Ki.exports = function(e) {
            var r;
            return zi(e) && (r = e.constructor, mf(r) && (r === Xi || zi(r.prototype)) ? r = void 0 : df(r) && (r = r[yf], r === null && (r = void 0))), r === void 0 ? Xi : r;
          };
        });
        var _n = xe((Ay, Qi) => {
          var hf = Yi();
          Qi.exports = function(e, r) {
            return new (hf(e))(r === 0 ? 0 : r);
          };
        });
        var Zi = xe(() => {
          "use strict";
          var vf = Jt(), Cf = Bn(), Ef = Ht(), Ff = yr(), Af = Lt(), Sf = _n();
          vf({ target: "Array", proto: true }, { flatMap: function(r) {
            var t3 = Ff(this), s = Af(t3), a;
            return Ef(r), a = Sf(t3, 0), a.length = Cf(a, t3, t3, s, 0, 1, r, arguments.length > 1 ? arguments[1] : void 0), a;
          } });
        });
        var Pn = xe((by, ea) => {
          ea.exports = {};
        });
        var ra = xe((Ty, ta) => {
          var xf = bt(), bf = Pn(), Tf = xf("iterator"), Bf = Array.prototype;
          ta.exports = function(e) {
            return e !== void 0 && (bf.Array === e || Bf[Tf] === e);
          };
        });
        var In = xe((By, ua) => {
          var Nf = Nn(), na = mr(), wf = cr(), _f = Pn(), Pf = bt(), If = Pf("iterator");
          ua.exports = function(e) {
            if (!wf(e))
              return na(e, If) || na(e, "@@iterator") || _f[Nf(e)];
          };
        });
        var ia = xe((Ny, sa) => {
          var kf = At(), Lf = Ht(), Of = Tt(), jf = Dr(), qf = In(), Mf = TypeError;
          sa.exports = function(e, r) {
            var t3 = arguments.length < 2 ? qf(e) : r;
            if (Lf(t3))
              return Of(kf(t3, e));
            throw Mf(jf(e) + " is not iterable");
          };
        });
        var la = xe((wy, oa) => {
          var Rf = At(), aa = Tt(), $f = mr();
          oa.exports = function(e, r, t3) {
            var s, a;
            aa(e);
            try {
              if (s = $f(e, "return"), !s) {
                if (r === "throw")
                  throw t3;
                return t3;
              }
              s = Rf(s, e);
            } catch (n) {
              a = true, s = n;
            }
            if (r === "throw")
              throw t3;
            if (a)
              throw s;
            return aa(s), t3;
          };
        });
        var ma = xe((_y, Da) => {
          var Vf = Tn(), Wf = At(), Hf = Tt(), Gf = Dr(), Uf = ra(), Jf = Lt(), ca = Xr(), zf = ia(), Xf = In(), pa = la(), Kf = TypeError, br = function(e, r) {
            this.stopped = e, this.result = r;
          }, fa = br.prototype;
          Da.exports = function(e, r, t3) {
            var s = t3 && t3.that, a = !!(t3 && t3.AS_ENTRIES), n = !!(t3 && t3.IS_RECORD), u = !!(t3 && t3.IS_ITERATOR), i = !!(t3 && t3.INTERRUPTED), l = Vf(r, s), p, y, h, g, c, f, F, _ = function(E) {
              return p && pa(p, "normal", E), new br(true, E);
            }, w = function(E) {
              return a ? (Hf(E), i ? l(E[0], E[1], _) : l(E[0], E[1])) : i ? l(E, _) : l(E);
            };
            if (n)
              p = e.iterator;
            else if (u)
              p = e;
            else {
              if (y = Xf(e), !y)
                throw Kf(Gf(e) + " is not iterable");
              if (Uf(y)) {
                for (h = 0, g = Jf(e); g > h; h++)
                  if (c = w(e[h]), c && ca(fa, c))
                    return c;
                return new br(false);
              }
              p = zf(e, y);
            }
            for (f = n ? e.next : p.next; !(F = Wf(f, p)).done; ) {
              try {
                c = w(F.value);
              } catch (E) {
                pa(p, "throw", E);
              }
              if (typeof c == "object" && c && ca(fa, c))
                return c;
            }
            return new br(false);
          };
        });
        var ga = xe((Py, da) => {
          "use strict";
          var Yf = hr(), Qf = kt(), Zf = lr();
          da.exports = function(e, r, t3) {
            var s = Yf(r);
            s in e ? Qf.f(e, s, Zf(0, t3)) : e[s] = t3;
          };
        });
        var ya = xe(() => {
          var eD = Jt(), tD = ma(), rD = ga();
          eD({ target: "Object", stat: true }, { fromEntries: function(r) {
            var t3 = {};
            return tD(r, function(s, a) {
              rD(t3, s, a);
            }, { AS_ENTRIES: true }), t3;
          } });
        });
        var Ca = xe((Ly, va) => {
          var ha = An(), nD = kt();
          va.exports = function(e, r, t3) {
            return t3.get && ha(t3.get, r, { getter: true }), t3.set && ha(t3.set, r, { setter: true }), nD.f(e, r, t3);
          };
        });
        var Fa = xe((Oy, Ea) => {
          "use strict";
          var uD = Tt();
          Ea.exports = function() {
            var e = uD(this), r = "";
            return e.hasIndices && (r += "d"), e.global && (r += "g"), e.ignoreCase && (r += "i"), e.multiline && (r += "m"), e.dotAll && (r += "s"), e.unicode && (r += "u"), e.unicodeSets && (r += "v"), e.sticky && (r += "y"), r;
          };
        });
        var xa = xe(() => {
          var sD = pt(), iD = yt(), aD = Ca(), oD = Fa(), lD = Dt(), Aa = sD.RegExp, Sa = Aa.prototype, cD = iD && lD(function() {
            var e = true;
            try {
              Aa(".", "d");
            } catch {
              e = false;
            }
            var r = {}, t3 = "", s = e ? "dgimsy" : "gimsy", a = function(l, p) {
              Object.defineProperty(r, l, { get: function() {
                return t3 += p, true;
              } });
            }, n = { dotAll: "s", global: "g", ignoreCase: "i", multiline: "m", sticky: "y" };
            e && (n.hasIndices = "d");
            for (var u in n)
              a(u, n[u]);
            var i = Object.getOwnPropertyDescriptor(Sa, "flags").get.call(r);
            return i !== s || t3 !== s;
          });
          cD && aD(Sa, "flags", { configurable: true, get: oD });
        });
        var ba = xe(() => {
          var pD = Jt(), kn = pt();
          pD({ global: true, forced: kn.globalThis !== kn }, { globalThis: kn });
        });
        var Ta = xe(() => {
          ba();
        });
        var Ba = xe(() => {
          "use strict";
          var fD = Jt(), DD = Bn(), mD = yr(), dD = Lt(), gD = Sr(), yD = _n();
          fD({ target: "Array", proto: true }, { flat: function() {
            var r = arguments.length ? arguments[0] : void 0, t3 = mD(this), s = dD(t3), a = yD(t3, 0);
            return a.length = DD(a, t3, t3, s, 0, r === void 0 ? 1 : gD(r)), a;
          } });
        });
        var e0 = xe((Uy, jo) => {
          var hD = ["cliName", "cliCategory", "cliDescription"], vD = ["_"], CD = ["languageId"];
          function Hn(e, r) {
            if (e == null)
              return {};
            var t3 = ED(e, r), s, a;
            if (Object.getOwnPropertySymbols) {
              var n = Object.getOwnPropertySymbols(e);
              for (a = 0; a < n.length; a++)
                s = n[a], !(r.indexOf(s) >= 0) && Object.prototype.propertyIsEnumerable.call(e, s) && (t3[s] = e[s]);
            }
            return t3;
          }
          function ED(e, r) {
            if (e == null)
              return {};
            var t3 = {}, s = Object.keys(e), a, n;
            for (n = 0; n < s.length; n++)
              a = s[n], !(r.indexOf(a) >= 0) && (t3[a] = e[a]);
            return t3;
          }
          Zi();
          ya();
          xa();
          Ta();
          Ba();
          var FD = Object.create, _r = Object.defineProperty, AD = Object.getOwnPropertyDescriptor, Gn = Object.getOwnPropertyNames, SD = Object.getPrototypeOf, xD = Object.prototype.hasOwnProperty, ht = (e, r) => function() {
            return e && (r = (0, e[Gn(e)[0]])(e = 0)), r;
          }, te = (e, r) => function() {
            return r || (0, e[Gn(e)[0]])((r = { exports: {} }).exports, r), r.exports;
          }, Kt = (e, r) => {
            for (var t3 in r)
              _r(e, t3, { get: r[t3], enumerable: true });
          }, Pa = (e, r, t3, s) => {
            if (r && typeof r == "object" || typeof r == "function")
              for (let a of Gn(r))
                !xD.call(e, a) && a !== t3 && _r(e, a, { get: () => r[a], enumerable: !(s = AD(r, a)) || s.enumerable });
            return e;
          }, bD = (e, r, t3) => (t3 = e != null ? FD(SD(e)) : {}, Pa(r || !e || !e.__esModule ? _r(t3, "default", { value: e, enumerable: true }) : t3, e)), ft = (e) => Pa(_r({}, "__esModule", { value: true }), e), wt, ne = ht({ "<define:process>"() {
            wt = { env: {}, argv: [] };
          } }), Ia = te({ "package.json"(e, r) {
            r.exports = { version: "2.8.8" };
          } }), TD = te({ "node_modules/diff/lib/diff/base.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true }), e.default = r;
            function r() {
            }
            r.prototype = { diff: function(n, u) {
              var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l = i.callback;
              typeof i == "function" && (l = i, i = {}), this.options = i;
              var p = this;
              function y(N) {
                return l ? (setTimeout(function() {
                  l(void 0, N);
                }, 0), true) : N;
              }
              n = this.castInput(n), u = this.castInput(u), n = this.removeEmpty(this.tokenize(n)), u = this.removeEmpty(this.tokenize(u));
              var h = u.length, g = n.length, c = 1, f = h + g, F = [{ newPos: -1, components: [] }], _ = this.extractCommon(F[0], u, n, 0);
              if (F[0].newPos + 1 >= h && _ + 1 >= g)
                return y([{ value: this.join(u), count: u.length }]);
              function w() {
                for (var N = -1 * c; N <= c; N += 2) {
                  var x = void 0, I = F[N - 1], P = F[N + 1], $ = (P ? P.newPos : 0) - N;
                  I && (F[N - 1] = void 0);
                  var D = I && I.newPos + 1 < h, T = P && 0 <= $ && $ < g;
                  if (!D && !T) {
                    F[N] = void 0;
                    continue;
                  }
                  if (!D || T && I.newPos < P.newPos ? (x = s(P), p.pushComponent(x.components, void 0, true)) : (x = I, x.newPos++, p.pushComponent(x.components, true, void 0)), $ = p.extractCommon(x, u, n, N), x.newPos + 1 >= h && $ + 1 >= g)
                    return y(t3(p, x.components, u, n, p.useLongestToken));
                  F[N] = x;
                }
                c++;
              }
              if (l)
                (function N() {
                  setTimeout(function() {
                    if (c > f)
                      return l();
                    w() || N();
                  }, 0);
                })();
              else
                for (; c <= f; ) {
                  var E = w();
                  if (E)
                    return E;
                }
            }, pushComponent: function(n, u, i) {
              var l = n[n.length - 1];
              l && l.added === u && l.removed === i ? n[n.length - 1] = { count: l.count + 1, added: u, removed: i } : n.push({ count: 1, added: u, removed: i });
            }, extractCommon: function(n, u, i, l) {
              for (var p = u.length, y = i.length, h = n.newPos, g = h - l, c = 0; h + 1 < p && g + 1 < y && this.equals(u[h + 1], i[g + 1]); )
                h++, g++, c++;
              return c && n.components.push({ count: c }), n.newPos = h, g;
            }, equals: function(n, u) {
              return this.options.comparator ? this.options.comparator(n, u) : n === u || this.options.ignoreCase && n.toLowerCase() === u.toLowerCase();
            }, removeEmpty: function(n) {
              for (var u = [], i = 0; i < n.length; i++)
                n[i] && u.push(n[i]);
              return u;
            }, castInput: function(n) {
              return n;
            }, tokenize: function(n) {
              return n.split("");
            }, join: function(n) {
              return n.join("");
            } };
            function t3(a, n, u, i, l) {
              for (var p = 0, y = n.length, h = 0, g = 0; p < y; p++) {
                var c = n[p];
                if (c.removed) {
                  if (c.value = a.join(i.slice(g, g + c.count)), g += c.count, p && n[p - 1].added) {
                    var F = n[p - 1];
                    n[p - 1] = n[p], n[p] = F;
                  }
                } else {
                  if (!c.added && l) {
                    var f = u.slice(h, h + c.count);
                    f = f.map(function(w, E) {
                      var N = i[g + E];
                      return N.length > w.length ? N : w;
                    }), c.value = a.join(f);
                  } else
                    c.value = a.join(u.slice(h, h + c.count));
                  h += c.count, c.added || (g += c.count);
                }
              }
              var _ = n[y - 1];
              return y > 1 && typeof _.value == "string" && (_.added || _.removed) && a.equals("", _.value) && (n[y - 2].value += _.value, n.pop()), n;
            }
            function s(a) {
              return { newPos: a.newPos, components: a.components.slice(0) };
            }
          } }), BD = te({ "node_modules/diff/lib/diff/array.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true }), e.diffArrays = a, e.arrayDiff = void 0;
            var r = t3(TD());
            function t3(n) {
              return n && n.__esModule ? n : { default: n };
            }
            var s = new r.default();
            e.arrayDiff = s, s.tokenize = function(n) {
              return n.slice();
            }, s.join = s.removeEmpty = function(n) {
              return n;
            };
            function a(n, u, i) {
              return s.diff(n, u, i);
            }
          } }), Un = te({ "src/document/doc-builders.js"(e, r) {
            "use strict";
            ne();
            function t3(C) {
              return { type: "concat", parts: C };
            }
            function s(C) {
              return { type: "indent", contents: C };
            }
            function a(C, o) {
              return { type: "align", contents: o, n: C };
            }
            function n(C) {
              let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              return { type: "group", id: o.id, contents: C, break: Boolean(o.shouldBreak), expandedStates: o.expandedStates };
            }
            function u(C) {
              return a(Number.NEGATIVE_INFINITY, C);
            }
            function i(C) {
              return a({ type: "root" }, C);
            }
            function l(C) {
              return a(-1, C);
            }
            function p(C, o) {
              return n(C[0], Object.assign(Object.assign({}, o), {}, { expandedStates: C }));
            }
            function y(C) {
              return { type: "fill", parts: C };
            }
            function h(C, o) {
              let d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              return { type: "if-break", breakContents: C, flatContents: o, groupId: d.groupId };
            }
            function g(C, o) {
              return { type: "indent-if-break", contents: C, groupId: o.groupId, negate: o.negate };
            }
            function c(C) {
              return { type: "line-suffix", contents: C };
            }
            var f = { type: "line-suffix-boundary" }, F = { type: "break-parent" }, _ = { type: "trim" }, w = { type: "line", hard: true }, E = { type: "line", hard: true, literal: true }, N = { type: "line" }, x = { type: "line", soft: true }, I = t3([w, F]), P = t3([E, F]), $ = { type: "cursor", placeholder: Symbol("cursor") };
            function D(C, o) {
              let d = [];
              for (let v = 0; v < o.length; v++)
                v !== 0 && d.push(C), d.push(o[v]);
              return t3(d);
            }
            function T(C, o, d) {
              let v = C;
              if (o > 0) {
                for (let S = 0; S < Math.floor(o / d); ++S)
                  v = s(v);
                v = a(o % d, v), v = a(Number.NEGATIVE_INFINITY, v);
              }
              return v;
            }
            function m(C, o) {
              return { type: "label", label: C, contents: o };
            }
            r.exports = { concat: t3, join: D, line: N, softline: x, hardline: I, literalline: P, group: n, conditionalGroup: p, fill: y, lineSuffix: c, lineSuffixBoundary: f, cursor: $, breakParent: F, ifBreak: h, trim: _, indent: s, indentIfBreak: g, align: a, addAlignmentToDoc: T, markAsRoot: i, dedentToRoot: u, dedent: l, hardlineWithoutBreakParent: w, literallineWithoutBreakParent: E, label: m };
          } }), Jn = te({ "src/common/end-of-line.js"(e, r) {
            "use strict";
            ne();
            function t3(u) {
              let i = u.indexOf("\r");
              return i >= 0 ? u.charAt(i + 1) === `
` ? "crlf" : "cr" : "lf";
            }
            function s(u) {
              switch (u) {
                case "cr":
                  return "\r";
                case "crlf":
                  return `\r
`;
                default:
                  return `
`;
              }
            }
            function a(u, i) {
              let l;
              switch (i) {
                case `
`:
                  l = /\n/g;
                  break;
                case "\r":
                  l = /\r/g;
                  break;
                case `\r
`:
                  l = /\r\n/g;
                  break;
                default:
                  throw new Error(`Unexpected "eol" ${JSON.stringify(i)}.`);
              }
              let p = u.match(l);
              return p ? p.length : 0;
            }
            function n(u) {
              return u.replace(/\r\n?/g, `
`);
            }
            r.exports = { guessEndOfLine: t3, convertEndOfLineToChars: s, countEndOfLineChars: a, normalizeEndOfLine: n };
          } }), lt2 = te({ "src/utils/get-last.js"(e, r) {
            "use strict";
            ne();
            var t3 = (s) => s[s.length - 1];
            r.exports = t3;
          } });
          function ND() {
            let { onlyFirst: e = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
            return new RegExp(r, e ? void 0 : "g");
          }
          var wD = ht({ "node_modules/strip-ansi/node_modules/ansi-regex/index.js"() {
            ne();
          } });
          function _D(e) {
            if (typeof e != "string")
              throw new TypeError(`Expected a \`string\`, got \`${typeof e}\``);
            return e.replace(ND(), "");
          }
          var PD = ht({ "node_modules/strip-ansi/index.js"() {
            ne(), wD();
          } });
          function ID(e) {
            return Number.isInteger(e) ? e >= 4352 && (e <= 4447 || e === 9001 || e === 9002 || 11904 <= e && e <= 12871 && e !== 12351 || 12880 <= e && e <= 19903 || 19968 <= e && e <= 42182 || 43360 <= e && e <= 43388 || 44032 <= e && e <= 55203 || 63744 <= e && e <= 64255 || 65040 <= e && e <= 65049 || 65072 <= e && e <= 65131 || 65281 <= e && e <= 65376 || 65504 <= e && e <= 65510 || 110592 <= e && e <= 110593 || 127488 <= e && e <= 127569 || 131072 <= e && e <= 262141) : false;
          }
          var kD = ht({ "node_modules/is-fullwidth-code-point/index.js"() {
            ne();
          } }), LD = te({ "node_modules/emoji-regex/index.js"(e, r) {
            "use strict";
            ne(), r.exports = function() {
              return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
            };
          } }), ka = {};
          Kt(ka, { default: () => OD });
          function OD(e) {
            if (typeof e != "string" || e.length === 0 || (e = _D(e), e.length === 0))
              return 0;
            e = e.replace((0, La.default)(), "  ");
            let r = 0;
            for (let t3 = 0; t3 < e.length; t3++) {
              let s = e.codePointAt(t3);
              s <= 31 || s >= 127 && s <= 159 || s >= 768 && s <= 879 || (s > 65535 && t3++, r += ID(s) ? 2 : 1);
            }
            return r;
          }
          var La, jD = ht({ "node_modules/string-width/index.js"() {
            ne(), PD(), kD(), La = bD(LD());
          } }), Oa = te({ "src/utils/get-string-width.js"(e, r) {
            "use strict";
            ne();
            var t3 = (jD(), ft(ka)).default, s = /[^\x20-\x7F]/;
            function a(n) {
              return n ? s.test(n) ? t3(n) : n.length : 0;
            }
            r.exports = a;
          } }), Yt = te({ "src/document/doc-utils.js"(e, r) {
            "use strict";
            ne();
            var t3 = lt2(), { literalline: s, join: a } = Un(), n = (o) => Array.isArray(o) || o && o.type === "concat", u = (o) => {
              if (Array.isArray(o))
                return o;
              if (o.type !== "concat" && o.type !== "fill")
                throw new Error("Expect doc type to be `concat` or `fill`.");
              return o.parts;
            }, i = {};
            function l(o, d, v, S) {
              let b = [o];
              for (; b.length > 0; ) {
                let B = b.pop();
                if (B === i) {
                  v(b.pop());
                  continue;
                }
                if (v && b.push(B, i), !d || d(B) !== false)
                  if (n(B) || B.type === "fill") {
                    let k = u(B);
                    for (let M = k.length, R = M - 1; R >= 0; --R)
                      b.push(k[R]);
                  } else if (B.type === "if-break")
                    B.flatContents && b.push(B.flatContents), B.breakContents && b.push(B.breakContents);
                  else if (B.type === "group" && B.expandedStates)
                    if (S)
                      for (let k = B.expandedStates.length, M = k - 1; M >= 0; --M)
                        b.push(B.expandedStates[M]);
                    else
                      b.push(B.contents);
                  else
                    B.contents && b.push(B.contents);
              }
            }
            function p(o, d) {
              let v = /* @__PURE__ */ new Map();
              return S(o);
              function S(B) {
                if (v.has(B))
                  return v.get(B);
                let k = b(B);
                return v.set(B, k), k;
              }
              function b(B) {
                if (Array.isArray(B))
                  return d(B.map(S));
                if (B.type === "concat" || B.type === "fill") {
                  let k = B.parts.map(S);
                  return d(Object.assign(Object.assign({}, B), {}, { parts: k }));
                }
                if (B.type === "if-break") {
                  let k = B.breakContents && S(B.breakContents), M = B.flatContents && S(B.flatContents);
                  return d(Object.assign(Object.assign({}, B), {}, { breakContents: k, flatContents: M }));
                }
                if (B.type === "group" && B.expandedStates) {
                  let k = B.expandedStates.map(S), M = k[0];
                  return d(Object.assign(Object.assign({}, B), {}, { contents: M, expandedStates: k }));
                }
                if (B.contents) {
                  let k = S(B.contents);
                  return d(Object.assign(Object.assign({}, B), {}, { contents: k }));
                }
                return d(B);
              }
            }
            function y(o, d, v) {
              let S = v, b = false;
              function B(k) {
                let M = d(k);
                if (M !== void 0 && (b = true, S = M), b)
                  return false;
              }
              return l(o, B), S;
            }
            function h(o) {
              if (o.type === "group" && o.break || o.type === "line" && o.hard || o.type === "break-parent")
                return true;
            }
            function g(o) {
              return y(o, h, false);
            }
            function c(o) {
              if (o.length > 0) {
                let d = t3(o);
                !d.expandedStates && !d.break && (d.break = "propagated");
              }
              return null;
            }
            function f(o) {
              let d = /* @__PURE__ */ new Set(), v = [];
              function S(B) {
                if (B.type === "break-parent" && c(v), B.type === "group") {
                  if (v.push(B), d.has(B))
                    return false;
                  d.add(B);
                }
              }
              function b(B) {
                B.type === "group" && v.pop().break && c(v);
              }
              l(o, S, b, true);
            }
            function F(o) {
              return o.type === "line" && !o.hard ? o.soft ? "" : " " : o.type === "if-break" ? o.flatContents || "" : o;
            }
            function _(o) {
              return p(o, F);
            }
            var w = (o, d) => o && o.type === "line" && o.hard && d && d.type === "break-parent";
            function E(o) {
              if (!o)
                return o;
              if (n(o) || o.type === "fill") {
                let d = u(o);
                for (; d.length > 1 && w(...d.slice(-2)); )
                  d.length -= 2;
                if (d.length > 0) {
                  let v = E(t3(d));
                  d[d.length - 1] = v;
                }
                return Array.isArray(o) ? d : Object.assign(Object.assign({}, o), {}, { parts: d });
              }
              switch (o.type) {
                case "align":
                case "indent":
                case "indent-if-break":
                case "group":
                case "line-suffix":
                case "label": {
                  let d = E(o.contents);
                  return Object.assign(Object.assign({}, o), {}, { contents: d });
                }
                case "if-break": {
                  let d = E(o.breakContents), v = E(o.flatContents);
                  return Object.assign(Object.assign({}, o), {}, { breakContents: d, flatContents: v });
                }
              }
              return o;
            }
            function N(o) {
              return E(I(o));
            }
            function x(o) {
              switch (o.type) {
                case "fill":
                  if (o.parts.every((v) => v === ""))
                    return "";
                  break;
                case "group":
                  if (!o.contents && !o.id && !o.break && !o.expandedStates)
                    return "";
                  if (o.contents.type === "group" && o.contents.id === o.id && o.contents.break === o.break && o.contents.expandedStates === o.expandedStates)
                    return o.contents;
                  break;
                case "align":
                case "indent":
                case "indent-if-break":
                case "line-suffix":
                  if (!o.contents)
                    return "";
                  break;
                case "if-break":
                  if (!o.flatContents && !o.breakContents)
                    return "";
                  break;
              }
              if (!n(o))
                return o;
              let d = [];
              for (let v of u(o)) {
                if (!v)
                  continue;
                let [S, ...b] = n(v) ? u(v) : [v];
                typeof S == "string" && typeof t3(d) == "string" ? d[d.length - 1] += S : d.push(S), d.push(...b);
              }
              return d.length === 0 ? "" : d.length === 1 ? d[0] : Array.isArray(o) ? d : Object.assign(Object.assign({}, o), {}, { parts: d });
            }
            function I(o) {
              return p(o, (d) => x(d));
            }
            function P(o) {
              let d = [], v = o.filter(Boolean);
              for (; v.length > 0; ) {
                let S = v.shift();
                if (S) {
                  if (n(S)) {
                    v.unshift(...u(S));
                    continue;
                  }
                  if (d.length > 0 && typeof t3(d) == "string" && typeof S == "string") {
                    d[d.length - 1] += S;
                    continue;
                  }
                  d.push(S);
                }
              }
              return d;
            }
            function $(o) {
              return p(o, (d) => Array.isArray(d) ? P(d) : d.parts ? Object.assign(Object.assign({}, d), {}, { parts: P(d.parts) }) : d);
            }
            function D(o) {
              return p(o, (d) => typeof d == "string" && d.includes(`
`) ? T(d) : d);
            }
            function T(o) {
              let d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : s;
              return a(d, o.split(`
`)).parts;
            }
            function m(o) {
              if (o.type === "line")
                return true;
            }
            function C(o) {
              return y(o, m, false);
            }
            r.exports = { isConcat: n, getDocParts: u, willBreak: g, traverseDoc: l, findInDoc: y, mapDoc: p, propagateBreaks: f, removeLines: _, stripTrailingHardline: N, normalizeParts: P, normalizeDoc: $, cleanDoc: I, replaceTextEndOfLine: T, replaceEndOfLine: D, canBreak: C };
          } }), qD = te({ "src/document/doc-printer.js"(e, r) {
            "use strict";
            ne();
            var { convertEndOfLineToChars: t3 } = Jn(), s = lt2(), a = Oa(), { fill: n, cursor: u, indent: i } = Un(), { isConcat: l, getDocParts: p } = Yt(), y, h = 1, g = 2;
            function c() {
              return { value: "", length: 0, queue: [] };
            }
            function f(x, I) {
              return _(x, { type: "indent" }, I);
            }
            function F(x, I, P) {
              return I === Number.NEGATIVE_INFINITY ? x.root || c() : I < 0 ? _(x, { type: "dedent" }, P) : I ? I.type === "root" ? Object.assign(Object.assign({}, x), {}, { root: x }) : _(x, { type: typeof I == "string" ? "stringAlign" : "numberAlign", n: I }, P) : x;
            }
            function _(x, I, P) {
              let $ = I.type === "dedent" ? x.queue.slice(0, -1) : [...x.queue, I], D = "", T = 0, m = 0, C = 0;
              for (let k of $)
                switch (k.type) {
                  case "indent":
                    v(), P.useTabs ? o(1) : d(P.tabWidth);
                    break;
                  case "stringAlign":
                    v(), D += k.n, T += k.n.length;
                    break;
                  case "numberAlign":
                    m += 1, C += k.n;
                    break;
                  default:
                    throw new Error(`Unexpected type '${k.type}'`);
                }
              return b(), Object.assign(Object.assign({}, x), {}, { value: D, length: T, queue: $ });
              function o(k) {
                D += "	".repeat(k), T += P.tabWidth * k;
              }
              function d(k) {
                D += " ".repeat(k), T += k;
              }
              function v() {
                P.useTabs ? S() : b();
              }
              function S() {
                m > 0 && o(m), B();
              }
              function b() {
                C > 0 && d(C), B();
              }
              function B() {
                m = 0, C = 0;
              }
            }
            function w(x) {
              if (x.length === 0)
                return 0;
              let I = 0;
              for (; x.length > 0 && typeof s(x) == "string" && /^[\t ]*$/.test(s(x)); )
                I += x.pop().length;
              if (x.length > 0 && typeof s(x) == "string") {
                let P = s(x).replace(/[\t ]*$/, "");
                I += s(x).length - P.length, x[x.length - 1] = P;
              }
              return I;
            }
            function E(x, I, P, $, D) {
              let T = I.length, m = [x], C = [];
              for (; P >= 0; ) {
                if (m.length === 0) {
                  if (T === 0)
                    return true;
                  m.push(I[--T]);
                  continue;
                }
                let { mode: o, doc: d } = m.pop();
                if (typeof d == "string")
                  C.push(d), P -= a(d);
                else if (l(d) || d.type === "fill") {
                  let v = p(d);
                  for (let S = v.length - 1; S >= 0; S--)
                    m.push({ mode: o, doc: v[S] });
                } else
                  switch (d.type) {
                    case "indent":
                    case "align":
                    case "indent-if-break":
                    case "label":
                      m.push({ mode: o, doc: d.contents });
                      break;
                    case "trim":
                      P += w(C);
                      break;
                    case "group": {
                      if (D && d.break)
                        return false;
                      let v = d.break ? h : o, S = d.expandedStates && v === h ? s(d.expandedStates) : d.contents;
                      m.push({ mode: v, doc: S });
                      break;
                    }
                    case "if-break": {
                      let S = (d.groupId ? y[d.groupId] || g : o) === h ? d.breakContents : d.flatContents;
                      S && m.push({ mode: o, doc: S });
                      break;
                    }
                    case "line":
                      if (o === h || d.hard)
                        return true;
                      d.soft || (C.push(" "), P--);
                      break;
                    case "line-suffix":
                      $ = true;
                      break;
                    case "line-suffix-boundary":
                      if ($)
                        return false;
                      break;
                  }
              }
              return false;
            }
            function N(x, I) {
              y = {};
              let P = I.printWidth, $ = t3(I.endOfLine), D = 0, T = [{ ind: c(), mode: h, doc: x }], m = [], C = false, o = [];
              for (; T.length > 0; ) {
                let { ind: v, mode: S, doc: b } = T.pop();
                if (typeof b == "string") {
                  let B = $ !== `
` ? b.replace(/\n/g, $) : b;
                  m.push(B), D += a(B);
                } else if (l(b)) {
                  let B = p(b);
                  for (let k = B.length - 1; k >= 0; k--)
                    T.push({ ind: v, mode: S, doc: B[k] });
                } else
                  switch (b.type) {
                    case "cursor":
                      m.push(u.placeholder);
                      break;
                    case "indent":
                      T.push({ ind: f(v, I), mode: S, doc: b.contents });
                      break;
                    case "align":
                      T.push({ ind: F(v, b.n, I), mode: S, doc: b.contents });
                      break;
                    case "trim":
                      D -= w(m);
                      break;
                    case "group":
                      switch (S) {
                        case g:
                          if (!C) {
                            T.push({ ind: v, mode: b.break ? h : g, doc: b.contents });
                            break;
                          }
                        case h: {
                          C = false;
                          let B = { ind: v, mode: g, doc: b.contents }, k = P - D, M = o.length > 0;
                          if (!b.break && E(B, T, k, M))
                            T.push(B);
                          else if (b.expandedStates) {
                            let R = s(b.expandedStates);
                            if (b.break) {
                              T.push({ ind: v, mode: h, doc: R });
                              break;
                            } else
                              for (let q = 1; q < b.expandedStates.length + 1; q++)
                                if (q >= b.expandedStates.length) {
                                  T.push({ ind: v, mode: h, doc: R });
                                  break;
                                } else {
                                  let J = b.expandedStates[q], L = { ind: v, mode: g, doc: J };
                                  if (E(L, T, k, M)) {
                                    T.push(L);
                                    break;
                                  }
                                }
                          } else
                            T.push({ ind: v, mode: h, doc: b.contents });
                          break;
                        }
                      }
                      b.id && (y[b.id] = s(T).mode);
                      break;
                    case "fill": {
                      let B = P - D, { parts: k } = b;
                      if (k.length === 0)
                        break;
                      let [M, R] = k, q = { ind: v, mode: g, doc: M }, J = { ind: v, mode: h, doc: M }, L = E(q, [], B, o.length > 0, true);
                      if (k.length === 1) {
                        L ? T.push(q) : T.push(J);
                        break;
                      }
                      let Q = { ind: v, mode: g, doc: R }, V = { ind: v, mode: h, doc: R };
                      if (k.length === 2) {
                        L ? T.push(Q, q) : T.push(V, J);
                        break;
                      }
                      k.splice(0, 2);
                      let j = { ind: v, mode: S, doc: n(k) }, Y = k[0];
                      E({ ind: v, mode: g, doc: [M, R, Y] }, [], B, o.length > 0, true) ? T.push(j, Q, q) : L ? T.push(j, V, q) : T.push(j, V, J);
                      break;
                    }
                    case "if-break":
                    case "indent-if-break": {
                      let B = b.groupId ? y[b.groupId] : S;
                      if (B === h) {
                        let k = b.type === "if-break" ? b.breakContents : b.negate ? b.contents : i(b.contents);
                        k && T.push({ ind: v, mode: S, doc: k });
                      }
                      if (B === g) {
                        let k = b.type === "if-break" ? b.flatContents : b.negate ? i(b.contents) : b.contents;
                        k && T.push({ ind: v, mode: S, doc: k });
                      }
                      break;
                    }
                    case "line-suffix":
                      o.push({ ind: v, mode: S, doc: b.contents });
                      break;
                    case "line-suffix-boundary":
                      o.length > 0 && T.push({ ind: v, mode: S, doc: { type: "line", hard: true } });
                      break;
                    case "line":
                      switch (S) {
                        case g:
                          if (b.hard)
                            C = true;
                          else {
                            b.soft || (m.push(" "), D += 1);
                            break;
                          }
                        case h:
                          if (o.length > 0) {
                            T.push({ ind: v, mode: S, doc: b }, ...o.reverse()), o.length = 0;
                            break;
                          }
                          b.literal ? v.root ? (m.push($, v.root.value), D = v.root.length) : (m.push($), D = 0) : (D -= w(m), m.push($ + v.value), D = v.length);
                          break;
                      }
                      break;
                    case "label":
                      T.push({ ind: v, mode: S, doc: b.contents });
                      break;
                    default:
                  }
                T.length === 0 && o.length > 0 && (T.push(...o.reverse()), o.length = 0);
              }
              let d = m.indexOf(u.placeholder);
              if (d !== -1) {
                let v = m.indexOf(u.placeholder, d + 1), S = m.slice(0, d).join(""), b = m.slice(d + 1, v).join(""), B = m.slice(v + 1).join("");
                return { formatted: S + b + B, cursorNodeStart: S.length, cursorNodeText: b };
              }
              return { formatted: m.join("") };
            }
            r.exports = { printDocToString: N };
          } }), MD = te({ "src/document/doc-debug.js"(e, r) {
            "use strict";
            ne();
            var { isConcat: t3, getDocParts: s } = Yt();
            function a(u) {
              if (!u)
                return "";
              if (t3(u)) {
                let i = [];
                for (let l of s(u))
                  if (t3(l))
                    i.push(...a(l).parts);
                  else {
                    let p = a(l);
                    p !== "" && i.push(p);
                  }
                return { type: "concat", parts: i };
              }
              return u.type === "if-break" ? Object.assign(Object.assign({}, u), {}, { breakContents: a(u.breakContents), flatContents: a(u.flatContents) }) : u.type === "group" ? Object.assign(Object.assign({}, u), {}, { contents: a(u.contents), expandedStates: u.expandedStates && u.expandedStates.map(a) }) : u.type === "fill" ? { type: "fill", parts: u.parts.map(a) } : u.contents ? Object.assign(Object.assign({}, u), {}, { contents: a(u.contents) }) : u;
            }
            function n(u) {
              let i = /* @__PURE__ */ Object.create(null), l = /* @__PURE__ */ new Set();
              return p(a(u));
              function p(h, g, c) {
                if (typeof h == "string")
                  return JSON.stringify(h);
                if (t3(h)) {
                  let f = s(h).map(p).filter(Boolean);
                  return f.length === 1 ? f[0] : `[${f.join(", ")}]`;
                }
                if (h.type === "line") {
                  let f = Array.isArray(c) && c[g + 1] && c[g + 1].type === "break-parent";
                  return h.literal ? f ? "literalline" : "literallineWithoutBreakParent" : h.hard ? f ? "hardline" : "hardlineWithoutBreakParent" : h.soft ? "softline" : "line";
                }
                if (h.type === "break-parent")
                  return Array.isArray(c) && c[g - 1] && c[g - 1].type === "line" && c[g - 1].hard ? void 0 : "breakParent";
                if (h.type === "trim")
                  return "trim";
                if (h.type === "indent")
                  return "indent(" + p(h.contents) + ")";
                if (h.type === "align")
                  return h.n === Number.NEGATIVE_INFINITY ? "dedentToRoot(" + p(h.contents) + ")" : h.n < 0 ? "dedent(" + p(h.contents) + ")" : h.n.type === "root" ? "markAsRoot(" + p(h.contents) + ")" : "align(" + JSON.stringify(h.n) + ", " + p(h.contents) + ")";
                if (h.type === "if-break")
                  return "ifBreak(" + p(h.breakContents) + (h.flatContents ? ", " + p(h.flatContents) : "") + (h.groupId ? (h.flatContents ? "" : ', ""') + `, { groupId: ${y(h.groupId)} }` : "") + ")";
                if (h.type === "indent-if-break") {
                  let f = [];
                  h.negate && f.push("negate: true"), h.groupId && f.push(`groupId: ${y(h.groupId)}`);
                  let F = f.length > 0 ? `, { ${f.join(", ")} }` : "";
                  return `indentIfBreak(${p(h.contents)}${F})`;
                }
                if (h.type === "group") {
                  let f = [];
                  h.break && h.break !== "propagated" && f.push("shouldBreak: true"), h.id && f.push(`id: ${y(h.id)}`);
                  let F = f.length > 0 ? `, { ${f.join(", ")} }` : "";
                  return h.expandedStates ? `conditionalGroup([${h.expandedStates.map((_) => p(_)).join(",")}]${F})` : `group(${p(h.contents)}${F})`;
                }
                if (h.type === "fill")
                  return `fill([${h.parts.map((f) => p(f)).join(", ")}])`;
                if (h.type === "line-suffix")
                  return "lineSuffix(" + p(h.contents) + ")";
                if (h.type === "line-suffix-boundary")
                  return "lineSuffixBoundary";
                if (h.type === "label")
                  return `label(${JSON.stringify(h.label)}, ${p(h.contents)})`;
                throw new Error("Unknown doc type " + h.type);
              }
              function y(h) {
                if (typeof h != "symbol")
                  return JSON.stringify(String(h));
                if (h in i)
                  return i[h];
                let g = String(h).slice(7, -1) || "symbol";
                for (let c = 0; ; c++) {
                  let f = g + (c > 0 ? ` #${c}` : "");
                  if (!l.has(f))
                    return l.add(f), i[h] = `Symbol.for(${JSON.stringify(f)})`;
                }
              }
            }
            r.exports = { printDocToDebug: n };
          } }), qe = te({ "src/document/index.js"(e, r) {
            "use strict";
            ne(), r.exports = { builders: Un(), printer: qD(), utils: Yt(), debug: MD() };
          } }), ja = {};
          Kt(ja, { default: () => RD });
          function RD(e) {
            if (typeof e != "string")
              throw new TypeError("Expected a string");
            return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
          }
          var $D = ht({ "node_modules/escape-string-regexp/index.js"() {
            ne();
          } }), qa = te({ "node_modules/semver/internal/debug.js"(e, r) {
            ne();
            var t3 = typeof wt == "object" && wt.env && wt.env.NODE_DEBUG && /\bsemver\b/i.test(wt.env.NODE_DEBUG) ? function() {
              for (var s = arguments.length, a = new Array(s), n = 0; n < s; n++)
                a[n] = arguments[n];
              return console.error("SEMVER", ...a);
            } : () => {
            };
            r.exports = t3;
          } }), Ma = te({ "node_modules/semver/internal/constants.js"(e, r) {
            ne();
            var t3 = "2.0.0", s = 256, a = Number.MAX_SAFE_INTEGER || 9007199254740991, n = 16;
            r.exports = { SEMVER_SPEC_VERSION: t3, MAX_LENGTH: s, MAX_SAFE_INTEGER: a, MAX_SAFE_COMPONENT_LENGTH: n };
          } }), VD = te({ "node_modules/semver/internal/re.js"(e, r) {
            ne();
            var { MAX_SAFE_COMPONENT_LENGTH: t3 } = Ma(), s = qa();
            e = r.exports = {};
            var a = e.re = [], n = e.src = [], u = e.t = {}, i = 0, l = (p, y, h) => {
              let g = i++;
              s(p, g, y), u[p] = g, n[g] = y, a[g] = new RegExp(y, h ? "g" : void 0);
            };
            l("NUMERICIDENTIFIER", "0|[1-9]\\d*"), l("NUMERICIDENTIFIERLOOSE", "[0-9]+"), l("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), l("MAINVERSION", `(${n[u.NUMERICIDENTIFIER]})\\.(${n[u.NUMERICIDENTIFIER]})\\.(${n[u.NUMERICIDENTIFIER]})`), l("MAINVERSIONLOOSE", `(${n[u.NUMERICIDENTIFIERLOOSE]})\\.(${n[u.NUMERICIDENTIFIERLOOSE]})\\.(${n[u.NUMERICIDENTIFIERLOOSE]})`), l("PRERELEASEIDENTIFIER", `(?:${n[u.NUMERICIDENTIFIER]}|${n[u.NONNUMERICIDENTIFIER]})`), l("PRERELEASEIDENTIFIERLOOSE", `(?:${n[u.NUMERICIDENTIFIERLOOSE]}|${n[u.NONNUMERICIDENTIFIER]})`), l("PRERELEASE", `(?:-(${n[u.PRERELEASEIDENTIFIER]}(?:\\.${n[u.PRERELEASEIDENTIFIER]})*))`), l("PRERELEASELOOSE", `(?:-?(${n[u.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${n[u.PRERELEASEIDENTIFIERLOOSE]})*))`), l("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), l("BUILD", `(?:\\+(${n[u.BUILDIDENTIFIER]}(?:\\.${n[u.BUILDIDENTIFIER]})*))`), l("FULLPLAIN", `v?${n[u.MAINVERSION]}${n[u.PRERELEASE]}?${n[u.BUILD]}?`), l("FULL", `^${n[u.FULLPLAIN]}$`), l("LOOSEPLAIN", `[v=\\s]*${n[u.MAINVERSIONLOOSE]}${n[u.PRERELEASELOOSE]}?${n[u.BUILD]}?`), l("LOOSE", `^${n[u.LOOSEPLAIN]}$`), l("GTLT", "((?:<|>)?=?)"), l("XRANGEIDENTIFIERLOOSE", `${n[u.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), l("XRANGEIDENTIFIER", `${n[u.NUMERICIDENTIFIER]}|x|X|\\*`), l("XRANGEPLAIN", `[v=\\s]*(${n[u.XRANGEIDENTIFIER]})(?:\\.(${n[u.XRANGEIDENTIFIER]})(?:\\.(${n[u.XRANGEIDENTIFIER]})(?:${n[u.PRERELEASE]})?${n[u.BUILD]}?)?)?`), l("XRANGEPLAINLOOSE", `[v=\\s]*(${n[u.XRANGEIDENTIFIERLOOSE]})(?:\\.(${n[u.XRANGEIDENTIFIERLOOSE]})(?:\\.(${n[u.XRANGEIDENTIFIERLOOSE]})(?:${n[u.PRERELEASELOOSE]})?${n[u.BUILD]}?)?)?`), l("XRANGE", `^${n[u.GTLT]}\\s*${n[u.XRANGEPLAIN]}$`), l("XRANGELOOSE", `^${n[u.GTLT]}\\s*${n[u.XRANGEPLAINLOOSE]}$`), l("COERCE", `(^|[^\\d])(\\d{1,${t3}})(?:\\.(\\d{1,${t3}}))?(?:\\.(\\d{1,${t3}}))?(?:$|[^\\d])`), l("COERCERTL", n[u.COERCE], true), l("LONETILDE", "(?:~>?)"), l("TILDETRIM", `(\\s*)${n[u.LONETILDE]}\\s+`, true), e.tildeTrimReplace = "$1~", l("TILDE", `^${n[u.LONETILDE]}${n[u.XRANGEPLAIN]}$`), l("TILDELOOSE", `^${n[u.LONETILDE]}${n[u.XRANGEPLAINLOOSE]}$`), l("LONECARET", "(?:\\^)"), l("CARETTRIM", `(\\s*)${n[u.LONECARET]}\\s+`, true), e.caretTrimReplace = "$1^", l("CARET", `^${n[u.LONECARET]}${n[u.XRANGEPLAIN]}$`), l("CARETLOOSE", `^${n[u.LONECARET]}${n[u.XRANGEPLAINLOOSE]}$`), l("COMPARATORLOOSE", `^${n[u.GTLT]}\\s*(${n[u.LOOSEPLAIN]})$|^$`), l("COMPARATOR", `^${n[u.GTLT]}\\s*(${n[u.FULLPLAIN]})$|^$`), l("COMPARATORTRIM", `(\\s*)${n[u.GTLT]}\\s*(${n[u.LOOSEPLAIN]}|${n[u.XRANGEPLAIN]})`, true), e.comparatorTrimReplace = "$1$2$3", l("HYPHENRANGE", `^\\s*(${n[u.XRANGEPLAIN]})\\s+-\\s+(${n[u.XRANGEPLAIN]})\\s*$`), l("HYPHENRANGELOOSE", `^\\s*(${n[u.XRANGEPLAINLOOSE]})\\s+-\\s+(${n[u.XRANGEPLAINLOOSE]})\\s*$`), l("STAR", "(<|>)?=?\\s*\\*"), l("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), l("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
          } }), WD = te({ "node_modules/semver/internal/parse-options.js"(e, r) {
            ne();
            var t3 = ["includePrerelease", "loose", "rtl"], s = (a) => a ? typeof a != "object" ? { loose: true } : t3.filter((n) => a[n]).reduce((n, u) => (n[u] = true, n), {}) : {};
            r.exports = s;
          } }), HD = te({ "node_modules/semver/internal/identifiers.js"(e, r) {
            ne();
            var t3 = /^[0-9]+$/, s = (n, u) => {
              let i = t3.test(n), l = t3.test(u);
              return i && l && (n = +n, u = +u), n === u ? 0 : i && !l ? -1 : l && !i ? 1 : n < u ? -1 : 1;
            }, a = (n, u) => s(u, n);
            r.exports = { compareIdentifiers: s, rcompareIdentifiers: a };
          } }), GD = te({ "node_modules/semver/classes/semver.js"(e, r) {
            ne();
            var t3 = qa(), { MAX_LENGTH: s, MAX_SAFE_INTEGER: a } = Ma(), { re: n, t: u } = VD(), i = WD(), { compareIdentifiers: l } = HD(), p = class {
              constructor(y, h) {
                if (h = i(h), y instanceof p) {
                  if (y.loose === !!h.loose && y.includePrerelease === !!h.includePrerelease)
                    return y;
                  y = y.version;
                } else if (typeof y != "string")
                  throw new TypeError(`Invalid Version: ${y}`);
                if (y.length > s)
                  throw new TypeError(`version is longer than ${s} characters`);
                t3("SemVer", y, h), this.options = h, this.loose = !!h.loose, this.includePrerelease = !!h.includePrerelease;
                let g = y.trim().match(h.loose ? n[u.LOOSE] : n[u.FULL]);
                if (!g)
                  throw new TypeError(`Invalid Version: ${y}`);
                if (this.raw = y, this.major = +g[1], this.minor = +g[2], this.patch = +g[3], this.major > a || this.major < 0)
                  throw new TypeError("Invalid major version");
                if (this.minor > a || this.minor < 0)
                  throw new TypeError("Invalid minor version");
                if (this.patch > a || this.patch < 0)
                  throw new TypeError("Invalid patch version");
                g[4] ? this.prerelease = g[4].split(".").map((c) => {
                  if (/^[0-9]+$/.test(c)) {
                    let f = +c;
                    if (f >= 0 && f < a)
                      return f;
                  }
                  return c;
                }) : this.prerelease = [], this.build = g[5] ? g[5].split(".") : [], this.format();
              }
              format() {
                return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
              }
              toString() {
                return this.version;
              }
              compare(y) {
                if (t3("SemVer.compare", this.version, this.options, y), !(y instanceof p)) {
                  if (typeof y == "string" && y === this.version)
                    return 0;
                  y = new p(y, this.options);
                }
                return y.version === this.version ? 0 : this.compareMain(y) || this.comparePre(y);
              }
              compareMain(y) {
                return y instanceof p || (y = new p(y, this.options)), l(this.major, y.major) || l(this.minor, y.minor) || l(this.patch, y.patch);
              }
              comparePre(y) {
                if (y instanceof p || (y = new p(y, this.options)), this.prerelease.length && !y.prerelease.length)
                  return -1;
                if (!this.prerelease.length && y.prerelease.length)
                  return 1;
                if (!this.prerelease.length && !y.prerelease.length)
                  return 0;
                let h = 0;
                do {
                  let g = this.prerelease[h], c = y.prerelease[h];
                  if (t3("prerelease compare", h, g, c), g === void 0 && c === void 0)
                    return 0;
                  if (c === void 0)
                    return 1;
                  if (g === void 0)
                    return -1;
                  if (g === c)
                    continue;
                  return l(g, c);
                } while (++h);
              }
              compareBuild(y) {
                y instanceof p || (y = new p(y, this.options));
                let h = 0;
                do {
                  let g = this.build[h], c = y.build[h];
                  if (t3("prerelease compare", h, g, c), g === void 0 && c === void 0)
                    return 0;
                  if (c === void 0)
                    return 1;
                  if (g === void 0)
                    return -1;
                  if (g === c)
                    continue;
                  return l(g, c);
                } while (++h);
              }
              inc(y, h) {
                switch (y) {
                  case "premajor":
                    this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", h);
                    break;
                  case "preminor":
                    this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", h);
                    break;
                  case "prepatch":
                    this.prerelease.length = 0, this.inc("patch", h), this.inc("pre", h);
                    break;
                  case "prerelease":
                    this.prerelease.length === 0 && this.inc("patch", h), this.inc("pre", h);
                    break;
                  case "major":
                    (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                    break;
                  case "minor":
                    (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
                    break;
                  case "patch":
                    this.prerelease.length === 0 && this.patch++, this.prerelease = [];
                    break;
                  case "pre":
                    if (this.prerelease.length === 0)
                      this.prerelease = [0];
                    else {
                      let g = this.prerelease.length;
                      for (; --g >= 0; )
                        typeof this.prerelease[g] == "number" && (this.prerelease[g]++, g = -2);
                      g === -1 && this.prerelease.push(0);
                    }
                    h && (l(this.prerelease[0], h) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [h, 0]) : this.prerelease = [h, 0]);
                    break;
                  default:
                    throw new Error(`invalid increment argument: ${y}`);
                }
                return this.format(), this.raw = this.version, this;
              }
            };
            r.exports = p;
          } }), zn = te({ "node_modules/semver/functions/compare.js"(e, r) {
            ne();
            var t3 = GD(), s = (a, n, u) => new t3(a, u).compare(new t3(n, u));
            r.exports = s;
          } }), UD = te({ "node_modules/semver/functions/lt.js"(e, r) {
            ne();
            var t3 = zn(), s = (a, n, u) => t3(a, n, u) < 0;
            r.exports = s;
          } }), JD = te({ "node_modules/semver/functions/gte.js"(e, r) {
            ne();
            var t3 = zn(), s = (a, n, u) => t3(a, n, u) >= 0;
            r.exports = s;
          } }), zD = te({ "src/utils/arrayify.js"(e, r) {
            "use strict";
            ne(), r.exports = (t3, s) => Object.entries(t3).map((a) => {
              let [n, u] = a;
              return Object.assign({ [s]: n }, u);
            });
          } }), XD = te({ "node_modules/outdent/lib/index.js"(e, r) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true }), e.outdent = void 0;
            function t3() {
              for (var E = [], N = 0; N < arguments.length; N++)
                E[N] = arguments[N];
            }
            function s() {
              return typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : a();
            }
            function a() {
              return { add: t3, delete: t3, get: t3, set: t3, has: function(E) {
                return false;
              } };
            }
            var n = Object.prototype.hasOwnProperty, u = function(E, N) {
              return n.call(E, N);
            };
            function i(E, N) {
              for (var x in N)
                u(N, x) && (E[x] = N[x]);
              return E;
            }
            var l = /^[ \t]*(?:\r\n|\r|\n)/, p = /(?:\r\n|\r|\n)[ \t]*$/, y = /^(?:[\r\n]|$)/, h = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/, g = /^[ \t]*[\r\n][ \t\r\n]*$/;
            function c(E, N, x) {
              var I = 0, P = E[0].match(h);
              P && (I = P[1].length);
              var $ = "(\\r\\n|\\r|\\n).{0," + I + "}", D = new RegExp($, "g");
              N && (E = E.slice(1));
              var T = x.newline, m = x.trimLeadingNewline, C = x.trimTrailingNewline, o = typeof T == "string", d = E.length, v = E.map(function(S, b) {
                return S = S.replace(D, "$1"), b === 0 && m && (S = S.replace(l, "")), b === d - 1 && C && (S = S.replace(p, "")), o && (S = S.replace(/\r\n|\n|\r/g, function(B) {
                  return T;
                })), S;
              });
              return v;
            }
            function f(E, N) {
              for (var x = "", I = 0, P = E.length; I < P; I++)
                x += E[I], I < P - 1 && (x += N[I]);
              return x;
            }
            function F(E) {
              return u(E, "raw") && u(E, "length");
            }
            function _(E) {
              var N = s(), x = s();
              function I($) {
                for (var D = [], T = 1; T < arguments.length; T++)
                  D[T - 1] = arguments[T];
                if (F($)) {
                  var m = $, C = (D[0] === I || D[0] === w) && g.test(m[0]) && y.test(m[1]), o = C ? x : N, d = o.get(m);
                  if (d || (d = c(m, C, E), o.set(m, d)), D.length === 0)
                    return d[0];
                  var v = f(d, C ? D.slice(1) : D);
                  return v;
                } else
                  return _(i(i({}, E), $ || {}));
              }
              var P = i(I, { string: function($) {
                return c([$], false, E)[0];
              } });
              return P;
            }
            var w = _({ trimLeadingNewline: true, trimTrailingNewline: true });
            if (e.outdent = w, e.default = w, typeof r < "u")
              try {
                r.exports = w, Object.defineProperty(w, "__esModule", { value: true }), w.default = w, w.outdent = w;
              } catch {
              }
          } }), KD = te({ "src/main/core-options.js"(e, r) {
            "use strict";
            ne();
            var { outdent: t3 } = XD(), s = "Config", a = "Editor", n = "Format", u = "Other", i = "Output", l = "Global", p = "Special", y = { cursorOffset: { since: "1.4.0", category: p, type: "int", default: -1, range: { start: -1, end: Number.POSITIVE_INFINITY, step: 1 }, description: t3`
      Print (to stderr) where a cursor at the given position would move to after formatting.
      This option cannot be used with --range-start and --range-end.
    `, cliCategory: a }, endOfLine: { since: "1.15.0", category: l, type: "choice", default: [{ since: "1.15.0", value: "auto" }, { since: "2.0.0", value: "lf" }], description: "Which end of line characters to apply.", choices: [{ value: "lf", description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos" }, { value: "crlf", description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows" }, { value: "cr", description: "Carriage Return character only (\\r), used very rarely" }, { value: "auto", description: t3`
          Maintain existing
          (mixed values within one file are normalised by looking at what's used after the first line)
        ` }] }, filepath: { since: "1.4.0", category: p, type: "path", description: "Specify the input filepath. This will be used to do parser inference.", cliName: "stdin-filepath", cliCategory: u, cliDescription: "Path to the file to pretend that stdin comes from." }, insertPragma: { since: "1.8.0", category: p, type: "boolean", default: false, description: "Insert @format pragma into file's first docblock comment.", cliCategory: u }, parser: { since: "0.0.10", category: l, type: "choice", default: [{ since: "0.0.10", value: "babylon" }, { since: "1.13.0", value: void 0 }], description: "Which parser to use.", exception: (h) => typeof h == "string" || typeof h == "function", choices: [{ value: "flow", description: "Flow" }, { value: "babel", since: "1.16.0", description: "JavaScript" }, { value: "babel-flow", since: "1.16.0", description: "Flow" }, { value: "babel-ts", since: "2.0.0", description: "TypeScript" }, { value: "typescript", since: "1.4.0", description: "TypeScript" }, { value: "acorn", since: "2.6.0", description: "JavaScript" }, { value: "espree", since: "2.2.0", description: "JavaScript" }, { value: "meriyah", since: "2.2.0", description: "JavaScript" }, { value: "css", since: "1.7.1", description: "CSS" }, { value: "less", since: "1.7.1", description: "Less" }, { value: "scss", since: "1.7.1", description: "SCSS" }, { value: "json", since: "1.5.0", description: "JSON" }, { value: "json5", since: "1.13.0", description: "JSON5" }, { value: "json-stringify", since: "1.13.0", description: "JSON.stringify" }, { value: "graphql", since: "1.5.0", description: "GraphQL" }, { value: "markdown", since: "1.8.0", description: "Markdown" }, { value: "mdx", since: "1.15.0", description: "MDX" }, { value: "vue", since: "1.10.0", description: "Vue" }, { value: "yaml", since: "1.14.0", description: "YAML" }, { value: "glimmer", since: "2.3.0", description: "Ember / Handlebars" }, { value: "html", since: "1.15.0", description: "HTML" }, { value: "angular", since: "1.15.0", description: "Angular" }, { value: "lwc", since: "1.17.0", description: "Lightning Web Components" }] }, plugins: { since: "1.10.0", type: "path", array: true, default: [{ value: [] }], category: l, description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.", exception: (h) => typeof h == "string" || typeof h == "object", cliName: "plugin", cliCategory: s }, pluginSearchDirs: { since: "1.13.0", type: "path", array: true, default: [{ value: [] }], category: l, description: t3`
      Custom directory that contains prettier plugins in node_modules subdirectory.
      Overrides default behavior when plugins are searched relatively to the location of Prettier.
      Multiple values are accepted.
    `, exception: (h) => typeof h == "string" || typeof h == "object", cliName: "plugin-search-dir", cliCategory: s }, printWidth: { since: "0.0.0", category: l, type: "int", default: 80, description: "The line length where Prettier will try wrap.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, rangeEnd: { since: "1.4.0", category: p, type: "int", default: Number.POSITIVE_INFINITY, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: t3`
      Format code ending at a given character offset (exclusive).
      The range will extend forwards to the end of the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: a }, rangeStart: { since: "1.4.0", category: p, type: "int", default: 0, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: t3`
      Format code starting at a given character offset.
      The range will extend backwards to the start of the first line containing the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: a }, requirePragma: { since: "1.7.0", category: p, type: "boolean", default: false, description: t3`
      Require either '@prettier' or '@format' to be present in the file's first docblock comment
      in order for it to be formatted.
    `, cliCategory: u }, tabWidth: { type: "int", category: l, default: 2, description: "Number of spaces per indentation level.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, useTabs: { since: "1.0.0", category: l, type: "boolean", default: false, description: "Indent with tabs instead of spaces." }, embeddedLanguageFormatting: { since: "2.1.0", category: l, type: "choice", default: [{ since: "2.1.0", value: "auto" }], description: "Control how Prettier formats quoted code embedded in the file.", choices: [{ value: "auto", description: "Format embedded code if Prettier can automatically identify it." }, { value: "off", description: "Never automatically format embedded code." }] } };
            r.exports = { CATEGORY_CONFIG: s, CATEGORY_EDITOR: a, CATEGORY_FORMAT: n, CATEGORY_OTHER: u, CATEGORY_OUTPUT: i, CATEGORY_GLOBAL: l, CATEGORY_SPECIAL: p, options: y };
          } }), Xn = te({ "src/main/support.js"(e, r) {
            "use strict";
            ne();
            var t3 = { compare: zn(), lt: UD(), gte: JD() }, s = zD(), a = Ia().version, n = KD().options;
            function u() {
              let { plugins: l = [], showUnreleased: p = false, showDeprecated: y = false, showInternal: h = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = a.split("-", 1)[0], c = l.flatMap((E) => E.languages || []).filter(F), f = s(Object.assign({}, ...l.map((E) => {
                let { options: N } = E;
                return N;
              }), n), "name").filter((E) => F(E) && _(E)).sort((E, N) => E.name === N.name ? 0 : E.name < N.name ? -1 : 1).map(w).map((E) => {
                E = Object.assign({}, E), Array.isArray(E.default) && (E.default = E.default.length === 1 ? E.default[0].value : E.default.filter(F).sort((x, I) => t3.compare(I.since, x.since))[0].value), Array.isArray(E.choices) && (E.choices = E.choices.filter((x) => F(x) && _(x)), E.name === "parser" && i(E, c, l));
                let N = Object.fromEntries(l.filter((x) => x.defaultOptions && x.defaultOptions[E.name] !== void 0).map((x) => [x.name, x.defaultOptions[E.name]]));
                return Object.assign(Object.assign({}, E), {}, { pluginDefaults: N });
              });
              return { languages: c, options: f };
              function F(E) {
                return p || !("since" in E) || E.since && t3.gte(g, E.since);
              }
              function _(E) {
                return y || !("deprecated" in E) || E.deprecated && t3.lt(g, E.deprecated);
              }
              function w(E) {
                if (h)
                  return E;
                let { cliName: N, cliCategory: x, cliDescription: I } = E;
                return Hn(E, hD);
              }
            }
            function i(l, p, y) {
              let h = new Set(l.choices.map((g) => g.value));
              for (let g of p)
                if (g.parsers) {
                  for (let c of g.parsers)
                    if (!h.has(c)) {
                      h.add(c);
                      let f = y.find((_) => _.parsers && _.parsers[c]), F = g.name;
                      f && f.name && (F += ` (plugin: ${f.name})`), l.choices.push({ value: c, description: F });
                    }
                }
            }
            r.exports = { getSupportInfo: u };
          } }), Kn = te({ "src/utils/is-non-empty-array.js"(e, r) {
            "use strict";
            ne();
            function t3(s) {
              return Array.isArray(s) && s.length > 0;
            }
            r.exports = t3;
          } }), Pr = te({ "src/utils/text/skip.js"(e, r) {
            "use strict";
            ne();
            function t3(i) {
              return (l, p, y) => {
                let h = y && y.backwards;
                if (p === false)
                  return false;
                let { length: g } = l, c = p;
                for (; c >= 0 && c < g; ) {
                  let f = l.charAt(c);
                  if (i instanceof RegExp) {
                    if (!i.test(f))
                      return c;
                  } else if (!i.includes(f))
                    return c;
                  h ? c-- : c++;
                }
                return c === -1 || c === g ? c : false;
              };
            }
            var s = t3(/\s/), a = t3(" 	"), n = t3(",; 	"), u = t3(/[^\n\r]/);
            r.exports = { skipWhitespace: s, skipSpaces: a, skipToLineEnd: n, skipEverythingButNewLine: u };
          } }), Ra = te({ "src/utils/text/skip-inline-comment.js"(e, r) {
            "use strict";
            ne();
            function t3(s, a) {
              if (a === false)
                return false;
              if (s.charAt(a) === "/" && s.charAt(a + 1) === "*") {
                for (let n = a + 2; n < s.length; ++n)
                  if (s.charAt(n) === "*" && s.charAt(n + 1) === "/")
                    return n + 2;
              }
              return a;
            }
            r.exports = t3;
          } }), $a = te({ "src/utils/text/skip-trailing-comment.js"(e, r) {
            "use strict";
            ne();
            var { skipEverythingButNewLine: t3 } = Pr();
            function s(a, n) {
              return n === false ? false : a.charAt(n) === "/" && a.charAt(n + 1) === "/" ? t3(a, n) : n;
            }
            r.exports = s;
          } }), Va = te({ "src/utils/text/skip-newline.js"(e, r) {
            "use strict";
            ne();
            function t3(s, a, n) {
              let u = n && n.backwards;
              if (a === false)
                return false;
              let i = s.charAt(a);
              if (u) {
                if (s.charAt(a - 1) === "\r" && i === `
`)
                  return a - 2;
                if (i === `
` || i === "\r" || i === "\u2028" || i === "\u2029")
                  return a - 1;
              } else {
                if (i === "\r" && s.charAt(a + 1) === `
`)
                  return a + 2;
                if (i === `
` || i === "\r" || i === "\u2028" || i === "\u2029")
                  return a + 1;
              }
              return a;
            }
            r.exports = t3;
          } }), YD = te({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(e, r) {
            "use strict";
            ne();
            var t3 = Ra(), s = Va(), a = $a(), { skipSpaces: n } = Pr();
            function u(i, l) {
              let p = null, y = l;
              for (; y !== p; )
                p = y, y = n(i, y), y = t3(i, y), y = a(i, y), y = s(i, y);
              return y;
            }
            r.exports = u;
          } }), Ue = te({ "src/common/util.js"(e, r) {
            "use strict";
            ne();
            var { default: t3 } = ($D(), ft(ja)), s = lt2(), { getSupportInfo: a } = Xn(), n = Kn(), u = Oa(), { skipWhitespace: i, skipSpaces: l, skipToLineEnd: p, skipEverythingButNewLine: y } = Pr(), h = Ra(), g = $a(), c = Va(), f = YD(), F = (V) => V[V.length - 2];
            function _(V) {
              return (j, Y, ie) => {
                let ee = ie && ie.backwards;
                if (Y === false)
                  return false;
                let { length: ce } = j, W = Y;
                for (; W >= 0 && W < ce; ) {
                  let K = j.charAt(W);
                  if (V instanceof RegExp) {
                    if (!V.test(K))
                      return W;
                  } else if (!V.includes(K))
                    return W;
                  ee ? W-- : W++;
                }
                return W === -1 || W === ce ? W : false;
              };
            }
            function w(V, j) {
              let Y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, ie = l(V, Y.backwards ? j - 1 : j, Y), ee = c(V, ie, Y);
              return ie !== ee;
            }
            function E(V, j, Y) {
              for (let ie = j; ie < Y; ++ie)
                if (V.charAt(ie) === `
`)
                  return true;
              return false;
            }
            function N(V, j, Y) {
              let ie = Y(j) - 1;
              ie = l(V, ie, { backwards: true }), ie = c(V, ie, { backwards: true }), ie = l(V, ie, { backwards: true });
              let ee = c(V, ie, { backwards: true });
              return ie !== ee;
            }
            function x(V, j) {
              let Y = null, ie = j;
              for (; ie !== Y; )
                Y = ie, ie = p(V, ie), ie = h(V, ie), ie = l(V, ie);
              return ie = g(V, ie), ie = c(V, ie), ie !== false && w(V, ie);
            }
            function I(V, j, Y) {
              return x(V, Y(j));
            }
            function P(V, j, Y) {
              return f(V, Y(j));
            }
            function $(V, j, Y) {
              return V.charAt(P(V, j, Y));
            }
            function D(V, j) {
              let Y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              return l(V, Y.backwards ? j - 1 : j, Y) !== j;
            }
            function T(V, j) {
              let Y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, ie = 0;
              for (let ee = Y; ee < V.length; ++ee)
                V[ee] === "	" ? ie = ie + j - ie % j : ie++;
              return ie;
            }
            function m(V, j) {
              let Y = V.lastIndexOf(`
`);
              return Y === -1 ? 0 : T(V.slice(Y + 1).match(/^[\t ]*/)[0], j);
            }
            function C(V, j) {
              let Y = { quote: '"', regex: /"/g, escaped: "&quot;" }, ie = { quote: "'", regex: /'/g, escaped: "&apos;" }, ee = j === "'" ? ie : Y, ce = ee === ie ? Y : ie, W = ee;
              if (V.includes(ee.quote) || V.includes(ce.quote)) {
                let K = (V.match(ee.regex) || []).length, de = (V.match(ce.regex) || []).length;
                W = K > de ? ce : ee;
              }
              return W;
            }
            function o(V, j) {
              let Y = V.slice(1, -1), ie = j.parser === "json" || j.parser === "json5" && j.quoteProps === "preserve" && !j.singleQuote ? '"' : j.__isInHtmlAttribute ? "'" : C(Y, j.singleQuote ? "'" : '"').quote;
              return d(Y, ie, !(j.parser === "css" || j.parser === "less" || j.parser === "scss" || j.__embeddedInHtml));
            }
            function d(V, j, Y) {
              let ie = j === '"' ? "'" : '"', ee = /\\(.)|(["'])/gs, ce = V.replace(ee, (W, K, de) => K === ie ? K : de === j ? "\\" + de : de || (Y && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(K) ? K : "\\" + K));
              return j + ce + j;
            }
            function v(V) {
              return V.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
            }
            function S(V, j) {
              let Y = V.match(new RegExp(`(${t3(j)})+`, "g"));
              return Y === null ? 0 : Y.reduce((ie, ee) => Math.max(ie, ee.length / j.length), 0);
            }
            function b(V, j) {
              let Y = V.match(new RegExp(`(${t3(j)})+`, "g"));
              if (Y === null)
                return 0;
              let ie = /* @__PURE__ */ new Map(), ee = 0;
              for (let ce of Y) {
                let W = ce.length / j.length;
                ie.set(W, true), W > ee && (ee = W);
              }
              for (let ce = 1; ce < ee; ce++)
                if (!ie.get(ce))
                  return ce;
              return ee + 1;
            }
            function B(V, j) {
              (V.comments || (V.comments = [])).push(j), j.printed = false, j.nodeDescription = Q(V);
            }
            function k(V, j) {
              j.leading = true, j.trailing = false, B(V, j);
            }
            function M(V, j, Y) {
              j.leading = false, j.trailing = false, Y && (j.marker = Y), B(V, j);
            }
            function R(V, j) {
              j.leading = false, j.trailing = true, B(V, j);
            }
            function q(V, j) {
              let { languages: Y } = a({ plugins: j.plugins }), ie = Y.find((ee) => {
                let { name: ce } = ee;
                return ce.toLowerCase() === V;
              }) || Y.find((ee) => {
                let { aliases: ce } = ee;
                return Array.isArray(ce) && ce.includes(V);
              }) || Y.find((ee) => {
                let { extensions: ce } = ee;
                return Array.isArray(ce) && ce.includes(`.${V}`);
              });
              return ie && ie.parsers[0];
            }
            function J(V) {
              return V && V.type === "front-matter";
            }
            function L(V) {
              let j = /* @__PURE__ */ new WeakMap();
              return function(Y) {
                return j.has(Y) || j.set(Y, Symbol(V)), j.get(Y);
              };
            }
            function Q(V) {
              let j = V.type || V.kind || "(unknown type)", Y = String(V.name || V.id && (typeof V.id == "object" ? V.id.name : V.id) || V.key && (typeof V.key == "object" ? V.key.name : V.key) || V.value && (typeof V.value == "object" ? "" : String(V.value)) || V.operator || "");
              return Y.length > 20 && (Y = Y.slice(0, 19) + "\u2026"), j + (Y ? " " + Y : "");
            }
            r.exports = { inferParserByLanguage: q, getStringWidth: u, getMaxContinuousCount: S, getMinNotPresentContinuousCount: b, getPenultimate: F, getLast: s, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: f, getNextNonSpaceNonCommentCharacterIndex: P, getNextNonSpaceNonCommentCharacter: $, skip: _, skipWhitespace: i, skipSpaces: l, skipToLineEnd: p, skipEverythingButNewLine: y, skipInlineComment: h, skipTrailingComment: g, skipNewline: c, isNextLineEmptyAfterIndex: x, isNextLineEmpty: I, isPreviousLineEmpty: N, hasNewline: w, hasNewlineInRange: E, hasSpaces: D, getAlignmentSize: T, getIndentSize: m, getPreferredQuote: C, printString: o, printNumber: v, makeString: d, addLeadingComment: k, addDanglingComment: M, addTrailingComment: R, isFrontMatterNode: J, isNonEmptyArray: n, createGroupIdMapper: L };
          } }), Wa = {};
          Kt(Wa, { basename: () => za, default: () => Ka, delimiter: () => Mn, dirname: () => Ja, extname: () => Xa, isAbsolute: () => Qn, join: () => Ga, normalize: () => Yn, relative: () => Ua, resolve: () => wr, sep: () => qn });
          function Ha(e, r) {
            for (var t3 = 0, s = e.length - 1; s >= 0; s--) {
              var a = e[s];
              a === "." ? e.splice(s, 1) : a === ".." ? (e.splice(s, 1), t3++) : t3 && (e.splice(s, 1), t3--);
            }
            if (r)
              for (; t3--; t3)
                e.unshift("..");
            return e;
          }
          function wr() {
            for (var e = "", r = false, t3 = arguments.length - 1; t3 >= -1 && !r; t3--) {
              var s = t3 >= 0 ? arguments[t3] : "/";
              if (typeof s != "string")
                throw new TypeError("Arguments to path.resolve must be strings");
              if (!s)
                continue;
              e = s + "/" + e, r = s.charAt(0) === "/";
            }
            return e = Ha(Zn(e.split("/"), function(a) {
              return !!a;
            }), !r).join("/"), (r ? "/" : "") + e || ".";
          }
          function Yn(e) {
            var r = Qn(e), t3 = Ya(e, -1) === "/";
            return e = Ha(Zn(e.split("/"), function(s) {
              return !!s;
            }), !r).join("/"), !e && !r && (e = "."), e && t3 && (e += "/"), (r ? "/" : "") + e;
          }
          function Qn(e) {
            return e.charAt(0) === "/";
          }
          function Ga() {
            var e = Array.prototype.slice.call(arguments, 0);
            return Yn(Zn(e, function(r, t3) {
              if (typeof r != "string")
                throw new TypeError("Arguments to path.join must be strings");
              return r;
            }).join("/"));
          }
          function Ua(e, r) {
            e = wr(e).substr(1), r = wr(r).substr(1);
            function t3(p) {
              for (var y = 0; y < p.length && p[y] === ""; y++)
                ;
              for (var h = p.length - 1; h >= 0 && p[h] === ""; h--)
                ;
              return y > h ? [] : p.slice(y, h - y + 1);
            }
            for (var s = t3(e.split("/")), a = t3(r.split("/")), n = Math.min(s.length, a.length), u = n, i = 0; i < n; i++)
              if (s[i] !== a[i]) {
                u = i;
                break;
              }
            for (var l = [], i = u; i < s.length; i++)
              l.push("..");
            return l = l.concat(a.slice(u)), l.join("/");
          }
          function Ja(e) {
            var r = Ir(e), t3 = r[0], s = r[1];
            return !t3 && !s ? "." : (s && (s = s.substr(0, s.length - 1)), t3 + s);
          }
          function za(e, r) {
            var t3 = Ir(e)[2];
            return r && t3.substr(-1 * r.length) === r && (t3 = t3.substr(0, t3.length - r.length)), t3;
          }
          function Xa(e) {
            return Ir(e)[3];
          }
          function Zn(e, r) {
            if (e.filter)
              return e.filter(r);
            for (var t3 = [], s = 0; s < e.length; s++)
              r(e[s], s, e) && t3.push(e[s]);
            return t3;
          }
          var Na, Ir, qn, Mn, Ka, Ya, QD = ht({ "node-modules-polyfills:path"() {
            ne(), Na = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/, Ir = function(e) {
              return Na.exec(e).slice(1);
            }, qn = "/", Mn = ":", Ka = { extname: Xa, basename: za, dirname: Ja, sep: qn, delimiter: Mn, relative: Ua, join: Ga, isAbsolute: Qn, normalize: Yn, resolve: wr }, Ya = "ab".substr(-1) === "b" ? function(e, r, t3) {
              return e.substr(r, t3);
            } : function(e, r, t3) {
              return r < 0 && (r = e.length + r), e.substr(r, t3);
            };
          } }), ZD = te({ "node-modules-polyfills-commonjs:path"(e, r) {
            ne();
            var t3 = (QD(), ft(Wa));
            if (t3 && t3.default) {
              r.exports = t3.default;
              for (let s in t3)
                r.exports[s] = t3[s];
            } else
              t3 && (r.exports = t3);
          } }), Qt = te({ "src/common/errors.js"(e, r) {
            "use strict";
            ne();
            var t3 = class extends Error {
            }, s = class extends Error {
            }, a = class extends Error {
            }, n = class extends Error {
            };
            r.exports = { ConfigError: t3, DebugError: s, UndefinedParserError: a, ArgExpansionBailout: n };
          } }), vt = {};
          Kt(vt, { __assign: () => Nr, __asyncDelegator: () => fm, __asyncGenerator: () => pm, __asyncValues: () => Dm, __await: () => Xt, __awaiter: () => sm, __classPrivateFieldGet: () => ym, __classPrivateFieldSet: () => hm, __createBinding: () => am, __decorate: () => rm, __exportStar: () => om, __extends: () => em, __generator: () => im, __importDefault: () => gm, __importStar: () => dm, __makeTemplateObject: () => mm, __metadata: () => um, __param: () => nm2, __read: () => Qa, __rest: () => tm, __spread: () => lm, __spreadArrays: () => cm, __values: () => Rn });
          function em(e, r) {
            Br(e, r);
            function t3() {
              this.constructor = e;
            }
            e.prototype = r === null ? Object.create(r) : (t3.prototype = r.prototype, new t3());
          }
          function tm(e, r) {
            var t3 = {};
            for (var s in e)
              Object.prototype.hasOwnProperty.call(e, s) && r.indexOf(s) < 0 && (t3[s] = e[s]);
            if (e != null && typeof Object.getOwnPropertySymbols == "function")
              for (var a = 0, s = Object.getOwnPropertySymbols(e); a < s.length; a++)
                r.indexOf(s[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, s[a]) && (t3[s[a]] = e[s[a]]);
            return t3;
          }
          function rm(e, r, t3, s) {
            var a = arguments.length, n = a < 3 ? r : s === null ? s = Object.getOwnPropertyDescriptor(r, t3) : s, u;
            if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
              n = Reflect.decorate(e, r, t3, s);
            else
              for (var i = e.length - 1; i >= 0; i--)
                (u = e[i]) && (n = (a < 3 ? u(n) : a > 3 ? u(r, t3, n) : u(r, t3)) || n);
            return a > 3 && n && Object.defineProperty(r, t3, n), n;
          }
          function nm2(e, r) {
            return function(t3, s) {
              r(t3, s, e);
            };
          }
          function um(e, r) {
            if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
              return Reflect.metadata(e, r);
          }
          function sm(e, r, t3, s) {
            function a(n) {
              return n instanceof t3 ? n : new t3(function(u) {
                u(n);
              });
            }
            return new (t3 || (t3 = Promise))(function(n, u) {
              function i(y) {
                try {
                  p(s.next(y));
                } catch (h) {
                  u(h);
                }
              }
              function l(y) {
                try {
                  p(s.throw(y));
                } catch (h) {
                  u(h);
                }
              }
              function p(y) {
                y.done ? n(y.value) : a(y.value).then(i, l);
              }
              p((s = s.apply(e, r || [])).next());
            });
          }
          function im(e, r) {
            var t3 = { label: 0, sent: function() {
              if (n[0] & 1)
                throw n[1];
              return n[1];
            }, trys: [], ops: [] }, s, a, n, u;
            return u = { next: i(0), throw: i(1), return: i(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
              return this;
            }), u;
            function i(p) {
              return function(y) {
                return l([p, y]);
              };
            }
            function l(p) {
              if (s)
                throw new TypeError("Generator is already executing.");
              for (; t3; )
                try {
                  if (s = 1, a && (n = p[0] & 2 ? a.return : p[0] ? a.throw || ((n = a.return) && n.call(a), 0) : a.next) && !(n = n.call(a, p[1])).done)
                    return n;
                  switch (a = 0, n && (p = [p[0] & 2, n.value]), p[0]) {
                    case 0:
                    case 1:
                      n = p;
                      break;
                    case 4:
                      return t3.label++, { value: p[1], done: false };
                    case 5:
                      t3.label++, a = p[1], p = [0];
                      continue;
                    case 7:
                      p = t3.ops.pop(), t3.trys.pop();
                      continue;
                    default:
                      if (n = t3.trys, !(n = n.length > 0 && n[n.length - 1]) && (p[0] === 6 || p[0] === 2)) {
                        t3 = 0;
                        continue;
                      }
                      if (p[0] === 3 && (!n || p[1] > n[0] && p[1] < n[3])) {
                        t3.label = p[1];
                        break;
                      }
                      if (p[0] === 6 && t3.label < n[1]) {
                        t3.label = n[1], n = p;
                        break;
                      }
                      if (n && t3.label < n[2]) {
                        t3.label = n[2], t3.ops.push(p);
                        break;
                      }
                      n[2] && t3.ops.pop(), t3.trys.pop();
                      continue;
                  }
                  p = r.call(e, t3);
                } catch (y) {
                  p = [6, y], a = 0;
                } finally {
                  s = n = 0;
                }
              if (p[0] & 5)
                throw p[1];
              return { value: p[0] ? p[1] : void 0, done: true };
            }
          }
          function am(e, r, t3, s) {
            s === void 0 && (s = t3), e[s] = r[t3];
          }
          function om(e, r) {
            for (var t3 in e)
              t3 !== "default" && !r.hasOwnProperty(t3) && (r[t3] = e[t3]);
          }
          function Rn(e) {
            var r = typeof Symbol == "function" && Symbol.iterator, t3 = r && e[r], s = 0;
            if (t3)
              return t3.call(e);
            if (e && typeof e.length == "number")
              return { next: function() {
                return e && s >= e.length && (e = void 0), { value: e && e[s++], done: !e };
              } };
            throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
          }
          function Qa(e, r) {
            var t3 = typeof Symbol == "function" && e[Symbol.iterator];
            if (!t3)
              return e;
            var s = t3.call(e), a, n = [], u;
            try {
              for (; (r === void 0 || r-- > 0) && !(a = s.next()).done; )
                n.push(a.value);
            } catch (i) {
              u = { error: i };
            } finally {
              try {
                a && !a.done && (t3 = s.return) && t3.call(s);
              } finally {
                if (u)
                  throw u.error;
              }
            }
            return n;
          }
          function lm() {
            for (var e = [], r = 0; r < arguments.length; r++)
              e = e.concat(Qa(arguments[r]));
            return e;
          }
          function cm() {
            for (var e = 0, r = 0, t3 = arguments.length; r < t3; r++)
              e += arguments[r].length;
            for (var s = Array(e), a = 0, r = 0; r < t3; r++)
              for (var n = arguments[r], u = 0, i = n.length; u < i; u++, a++)
                s[a] = n[u];
            return s;
          }
          function Xt(e) {
            return this instanceof Xt ? (this.v = e, this) : new Xt(e);
          }
          function pm(e, r, t3) {
            if (!Symbol.asyncIterator)
              throw new TypeError("Symbol.asyncIterator is not defined.");
            var s = t3.apply(e, r || []), a, n = [];
            return a = {}, u("next"), u("throw"), u("return"), a[Symbol.asyncIterator] = function() {
              return this;
            }, a;
            function u(g) {
              s[g] && (a[g] = function(c) {
                return new Promise(function(f, F) {
                  n.push([g, c, f, F]) > 1 || i(g, c);
                });
              });
            }
            function i(g, c) {
              try {
                l(s[g](c));
              } catch (f) {
                h(n[0][3], f);
              }
            }
            function l(g) {
              g.value instanceof Xt ? Promise.resolve(g.value.v).then(p, y) : h(n[0][2], g);
            }
            function p(g) {
              i("next", g);
            }
            function y(g) {
              i("throw", g);
            }
            function h(g, c) {
              g(c), n.shift(), n.length && i(n[0][0], n[0][1]);
            }
          }
          function fm(e) {
            var r, t3;
            return r = {}, s("next"), s("throw", function(a) {
              throw a;
            }), s("return"), r[Symbol.iterator] = function() {
              return this;
            }, r;
            function s(a, n) {
              r[a] = e[a] ? function(u) {
                return (t3 = !t3) ? { value: Xt(e[a](u)), done: a === "return" } : n ? n(u) : u;
              } : n;
            }
          }
          function Dm(e) {
            if (!Symbol.asyncIterator)
              throw new TypeError("Symbol.asyncIterator is not defined.");
            var r = e[Symbol.asyncIterator], t3;
            return r ? r.call(e) : (e = typeof Rn == "function" ? Rn(e) : e[Symbol.iterator](), t3 = {}, s("next"), s("throw"), s("return"), t3[Symbol.asyncIterator] = function() {
              return this;
            }, t3);
            function s(n) {
              t3[n] = e[n] && function(u) {
                return new Promise(function(i, l) {
                  u = e[n](u), a(i, l, u.done, u.value);
                });
              };
            }
            function a(n, u, i, l) {
              Promise.resolve(l).then(function(p) {
                n({ value: p, done: i });
              }, u);
            }
          }
          function mm(e, r) {
            return Object.defineProperty ? Object.defineProperty(e, "raw", { value: r }) : e.raw = r, e;
          }
          function dm(e) {
            if (e && e.__esModule)
              return e;
            var r = {};
            if (e != null)
              for (var t3 in e)
                Object.hasOwnProperty.call(e, t3) && (r[t3] = e[t3]);
            return r.default = e, r;
          }
          function gm(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function ym(e, r) {
            if (!r.has(e))
              throw new TypeError("attempted to get private field on non-instance");
            return r.get(e);
          }
          function hm(e, r, t3) {
            if (!r.has(e))
              throw new TypeError("attempted to set private field on non-instance");
            return r.set(e, t3), t3;
          }
          var Br, Nr, Et = ht({ "node_modules/tslib/tslib.es6.js"() {
            ne(), Br = function(e, r) {
              return Br = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t3, s) {
                t3.__proto__ = s;
              } || function(t3, s) {
                for (var a in s)
                  s.hasOwnProperty(a) && (t3[a] = s[a]);
              }, Br(e, r);
            }, Nr = function() {
              return Nr = Object.assign || function(r) {
                for (var t3, s = 1, a = arguments.length; s < a; s++) {
                  t3 = arguments[s];
                  for (var n in t3)
                    Object.prototype.hasOwnProperty.call(t3, n) && (r[n] = t3[n]);
                }
                return r;
              }, Nr.apply(this, arguments);
            };
          } }), Za = te({ "node_modules/vnopts/lib/descriptors/api.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true }), e.apiDescriptor = { key: (r) => /^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(r) ? r : JSON.stringify(r), value(r) {
              if (r === null || typeof r != "object")
                return JSON.stringify(r);
              if (Array.isArray(r))
                return `[${r.map((s) => e.apiDescriptor.value(s)).join(", ")}]`;
              let t3 = Object.keys(r);
              return t3.length === 0 ? "{}" : `{ ${t3.map((s) => `${e.apiDescriptor.key(s)}: ${e.apiDescriptor.value(r[s])}`).join(", ")} }`;
            }, pair: (r) => {
              let { key: t3, value: s } = r;
              return e.apiDescriptor.value({ [t3]: s });
            } };
          } }), vm = te({ "node_modules/vnopts/lib/descriptors/index.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = (Et(), ft(vt));
            r.__exportStar(Za(), e);
          } }), kr = te({ "scripts/build/shims/chalk.cjs"(e, r) {
            "use strict";
            ne();
            var t3 = (s) => s;
            t3.grey = t3, t3.red = t3, t3.bold = t3, t3.yellow = t3, t3.blue = t3, t3.default = t3, r.exports = t3;
          } }), eo = te({ "node_modules/vnopts/lib/handlers/deprecated/common.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = kr();
            e.commonDeprecatedHandler = (t3, s, a) => {
              let { descriptor: n } = a, u = [`${r.default.yellow(typeof t3 == "string" ? n.key(t3) : n.pair(t3))} is deprecated`];
              return s && u.push(`we now treat it as ${r.default.blue(typeof s == "string" ? n.key(s) : n.pair(s))}`), u.join("; ") + ".";
            };
          } }), Cm = te({ "node_modules/vnopts/lib/handlers/deprecated/index.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = (Et(), ft(vt));
            r.__exportStar(eo(), e);
          } }), Em = te({ "node_modules/vnopts/lib/handlers/invalid/common.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = kr();
            e.commonInvalidHandler = (t3, s, a) => [`Invalid ${r.default.red(a.descriptor.key(t3))} value.`, `Expected ${r.default.blue(a.schemas[t3].expected(a))},`, `but received ${r.default.red(a.descriptor.value(s))}.`].join(" ");
          } }), to = te({ "node_modules/vnopts/lib/handlers/invalid/index.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = (Et(), ft(vt));
            r.__exportStar(Em(), e);
          } }), Fm = te({ "node_modules/vnopts/node_modules/leven/index.js"(e, r) {
            "use strict";
            ne();
            var t3 = [], s = [];
            r.exports = function(a, n) {
              if (a === n)
                return 0;
              var u = a;
              a.length > n.length && (a = n, n = u);
              var i = a.length, l = n.length;
              if (i === 0)
                return l;
              if (l === 0)
                return i;
              for (; i > 0 && a.charCodeAt(~-i) === n.charCodeAt(~-l); )
                i--, l--;
              if (i === 0)
                return l;
              for (var p = 0; p < i && a.charCodeAt(p) === n.charCodeAt(p); )
                p++;
              if (i -= p, l -= p, i === 0)
                return l;
              for (var y, h, g, c, f = 0, F = 0; f < i; )
                s[p + f] = a.charCodeAt(p + f), t3[f] = ++f;
              for (; F < l; )
                for (y = n.charCodeAt(p + F), g = F++, h = F, f = 0; f < i; f++)
                  c = y === s[p + f] ? g : g + 1, g = t3[f], h = t3[f] = g > h ? c > h ? h + 1 : c : c > g ? g + 1 : c;
              return h;
            };
          } }), ro = te({ "node_modules/vnopts/lib/handlers/unknown/leven.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = kr(), t3 = Fm();
            e.levenUnknownHandler = (s, a, n) => {
              let { descriptor: u, logger: i, schemas: l } = n, p = [`Ignored unknown option ${r.default.yellow(u.pair({ key: s, value: a }))}.`], y = Object.keys(l).sort().find((h) => t3(s, h) < 3);
              y && p.push(`Did you mean ${r.default.blue(u.key(y))}?`), i.warn(p.join(" "));
            };
          } }), Am = te({ "node_modules/vnopts/lib/handlers/unknown/index.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = (Et(), ft(vt));
            r.__exportStar(ro(), e);
          } }), Sm = te({ "node_modules/vnopts/lib/handlers/index.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = (Et(), ft(vt));
            r.__exportStar(Cm(), e), r.__exportStar(to(), e), r.__exportStar(Am(), e);
          } }), Ft = te({ "node_modules/vnopts/lib/schema.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = ["default", "expected", "validate", "deprecated", "forward", "redirect", "overlap", "preprocess", "postprocess"];
            function t3(n, u) {
              let i = new n(u), l = Object.create(i);
              for (let p of r)
                p in u && (l[p] = a(u[p], i, s.prototype[p].length));
              return l;
            }
            e.createSchema = t3;
            var s = class {
              constructor(n) {
                this.name = n.name;
              }
              static create(n) {
                return t3(this, n);
              }
              default(n) {
              }
              expected(n) {
                return "nothing";
              }
              validate(n, u) {
                return false;
              }
              deprecated(n, u) {
                return false;
              }
              forward(n, u) {
              }
              redirect(n, u) {
              }
              overlap(n, u, i) {
                return n;
              }
              preprocess(n, u) {
                return n;
              }
              postprocess(n, u) {
                return n;
              }
            };
            e.Schema = s;
            function a(n, u, i) {
              return typeof n == "function" ? function() {
                for (var l = arguments.length, p = new Array(l), y = 0; y < l; y++)
                  p[y] = arguments[y];
                return n(...p.slice(0, i - 1), u, ...p.slice(i - 1));
              } : () => n;
            }
          } }), xm = te({ "node_modules/vnopts/lib/schemas/alias.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Ft(), t3 = class extends r.Schema {
              constructor(s) {
                super(s), this._sourceName = s.sourceName;
              }
              expected(s) {
                return s.schemas[this._sourceName].expected(s);
              }
              validate(s, a) {
                return a.schemas[this._sourceName].validate(s, a);
              }
              redirect(s, a) {
                return this._sourceName;
              }
            };
            e.AliasSchema = t3;
          } }), bm = te({ "node_modules/vnopts/lib/schemas/any.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Ft(), t3 = class extends r.Schema {
              expected() {
                return "anything";
              }
              validate() {
                return true;
              }
            };
            e.AnySchema = t3;
          } }), Tm = te({ "node_modules/vnopts/lib/schemas/array.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = (Et(), ft(vt)), t3 = Ft(), s = class extends t3.Schema {
              constructor(n) {
                var { valueSchema: u, name: i = u.name } = n, l = r.__rest(n, ["valueSchema", "name"]);
                super(Object.assign({}, l, { name: i })), this._valueSchema = u;
              }
              expected(n) {
                return `an array of ${this._valueSchema.expected(n)}`;
              }
              validate(n, u) {
                if (!Array.isArray(n))
                  return false;
                let i = [];
                for (let l of n) {
                  let p = u.normalizeValidateResult(this._valueSchema.validate(l, u), l);
                  p !== true && i.push(p.value);
                }
                return i.length === 0 ? true : { value: i };
              }
              deprecated(n, u) {
                let i = [];
                for (let l of n) {
                  let p = u.normalizeDeprecatedResult(this._valueSchema.deprecated(l, u), l);
                  p !== false && i.push(...p.map((y) => {
                    let { value: h } = y;
                    return { value: [h] };
                  }));
                }
                return i;
              }
              forward(n, u) {
                let i = [];
                for (let l of n) {
                  let p = u.normalizeForwardResult(this._valueSchema.forward(l, u), l);
                  i.push(...p.map(a));
                }
                return i;
              }
              redirect(n, u) {
                let i = [], l = [];
                for (let p of n) {
                  let y = u.normalizeRedirectResult(this._valueSchema.redirect(p, u), p);
                  "remain" in y && i.push(y.remain), l.push(...y.redirect.map(a));
                }
                return i.length === 0 ? { redirect: l } : { redirect: l, remain: i };
              }
              overlap(n, u) {
                return n.concat(u);
              }
            };
            e.ArraySchema = s;
            function a(n) {
              let { from: u, to: i } = n;
              return { from: [u], to: i };
            }
          } }), Bm = te({ "node_modules/vnopts/lib/schemas/boolean.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Ft(), t3 = class extends r.Schema {
              expected() {
                return "true or false";
              }
              validate(s) {
                return typeof s == "boolean";
              }
            };
            e.BooleanSchema = t3;
          } }), eu = te({ "node_modules/vnopts/lib/utils.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            function r(c, f) {
              let F = /* @__PURE__ */ Object.create(null);
              for (let _ of c) {
                let w = _[f];
                if (F[w])
                  throw new Error(`Duplicate ${f} ${JSON.stringify(w)}`);
                F[w] = _;
              }
              return F;
            }
            e.recordFromArray = r;
            function t3(c, f) {
              let F = /* @__PURE__ */ new Map();
              for (let _ of c) {
                let w = _[f];
                if (F.has(w))
                  throw new Error(`Duplicate ${f} ${JSON.stringify(w)}`);
                F.set(w, _);
              }
              return F;
            }
            e.mapFromArray = t3;
            function s() {
              let c = /* @__PURE__ */ Object.create(null);
              return (f) => {
                let F = JSON.stringify(f);
                return c[F] ? true : (c[F] = true, false);
              };
            }
            e.createAutoChecklist = s;
            function a(c, f) {
              let F = [], _ = [];
              for (let w of c)
                f(w) ? F.push(w) : _.push(w);
              return [F, _];
            }
            e.partition = a;
            function n(c) {
              return c === Math.floor(c);
            }
            e.isInt = n;
            function u(c, f) {
              if (c === f)
                return 0;
              let F = typeof c, _ = typeof f, w = ["undefined", "object", "boolean", "number", "string"];
              return F !== _ ? w.indexOf(F) - w.indexOf(_) : F !== "string" ? Number(c) - Number(f) : c.localeCompare(f);
            }
            e.comparePrimitive = u;
            function i(c) {
              return c === void 0 ? {} : c;
            }
            e.normalizeDefaultResult = i;
            function l(c, f) {
              return c === true ? true : c === false ? { value: f } : c;
            }
            e.normalizeValidateResult = l;
            function p(c, f) {
              let F = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
              return c === false ? false : c === true ? F ? true : [{ value: f }] : "value" in c ? [c] : c.length === 0 ? false : c;
            }
            e.normalizeDeprecatedResult = p;
            function y(c, f) {
              return typeof c == "string" || "key" in c ? { from: f, to: c } : "from" in c ? { from: c.from, to: c.to } : { from: f, to: c.to };
            }
            e.normalizeTransferResult = y;
            function h(c, f) {
              return c === void 0 ? [] : Array.isArray(c) ? c.map((F) => y(F, f)) : [y(c, f)];
            }
            e.normalizeForwardResult = h;
            function g(c, f) {
              let F = h(typeof c == "object" && "redirect" in c ? c.redirect : c, f);
              return F.length === 0 ? { remain: f, redirect: F } : typeof c == "object" && "remain" in c ? { remain: c.remain, redirect: F } : { redirect: F };
            }
            e.normalizeRedirectResult = g;
          } }), Nm = te({ "node_modules/vnopts/lib/schemas/choice.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Ft(), t3 = eu(), s = class extends r.Schema {
              constructor(a) {
                super(a), this._choices = t3.mapFromArray(a.choices.map((n) => n && typeof n == "object" ? n : { value: n }), "value");
              }
              expected(a) {
                let { descriptor: n } = a, u = Array.from(this._choices.keys()).map((p) => this._choices.get(p)).filter((p) => !p.deprecated).map((p) => p.value).sort(t3.comparePrimitive).map(n.value), i = u.slice(0, -2), l = u.slice(-2);
                return i.concat(l.join(" or ")).join(", ");
              }
              validate(a) {
                return this._choices.has(a);
              }
              deprecated(a) {
                let n = this._choices.get(a);
                return n && n.deprecated ? { value: a } : false;
              }
              forward(a) {
                let n = this._choices.get(a);
                return n ? n.forward : void 0;
              }
              redirect(a) {
                let n = this._choices.get(a);
                return n ? n.redirect : void 0;
              }
            };
            e.ChoiceSchema = s;
          } }), no = te({ "node_modules/vnopts/lib/schemas/number.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Ft(), t3 = class extends r.Schema {
              expected() {
                return "a number";
              }
              validate(s, a) {
                return typeof s == "number";
              }
            };
            e.NumberSchema = t3;
          } }), wm = te({ "node_modules/vnopts/lib/schemas/integer.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = eu(), t3 = no(), s = class extends t3.NumberSchema {
              expected() {
                return "an integer";
              }
              validate(a, n) {
                return n.normalizeValidateResult(super.validate(a, n), a) === true && r.isInt(a);
              }
            };
            e.IntegerSchema = s;
          } }), _m = te({ "node_modules/vnopts/lib/schemas/string.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Ft(), t3 = class extends r.Schema {
              expected() {
                return "a string";
              }
              validate(s) {
                return typeof s == "string";
              }
            };
            e.StringSchema = t3;
          } }), Pm = te({ "node_modules/vnopts/lib/schemas/index.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = (Et(), ft(vt));
            r.__exportStar(xm(), e), r.__exportStar(bm(), e), r.__exportStar(Tm(), e), r.__exportStar(Bm(), e), r.__exportStar(Nm(), e), r.__exportStar(wm(), e), r.__exportStar(no(), e), r.__exportStar(_m(), e);
          } }), Im = te({ "node_modules/vnopts/lib/defaults.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Za(), t3 = eo(), s = to(), a = ro();
            e.defaultDescriptor = r.apiDescriptor, e.defaultUnknownHandler = a.levenUnknownHandler, e.defaultInvalidHandler = s.commonInvalidHandler, e.defaultDeprecatedHandler = t3.commonDeprecatedHandler;
          } }), km = te({ "node_modules/vnopts/lib/normalize.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Im(), t3 = eu();
            e.normalize = (a, n, u) => new s(n, u).normalize(a);
            var s = class {
              constructor(a, n) {
                let { logger: u = console, descriptor: i = r.defaultDescriptor, unknown: l = r.defaultUnknownHandler, invalid: p = r.defaultInvalidHandler, deprecated: y = r.defaultDeprecatedHandler } = n || {};
                this._utils = { descriptor: i, logger: u || { warn: () => {
                } }, schemas: t3.recordFromArray(a, "name"), normalizeDefaultResult: t3.normalizeDefaultResult, normalizeDeprecatedResult: t3.normalizeDeprecatedResult, normalizeForwardResult: t3.normalizeForwardResult, normalizeRedirectResult: t3.normalizeRedirectResult, normalizeValidateResult: t3.normalizeValidateResult }, this._unknownHandler = l, this._invalidHandler = p, this._deprecatedHandler = y, this.cleanHistory();
              }
              cleanHistory() {
                this._hasDeprecationWarned = t3.createAutoChecklist();
              }
              normalize(a) {
                let n = {}, u = [a], i = () => {
                  for (; u.length !== 0; ) {
                    let l = u.shift(), p = this._applyNormalization(l, n);
                    u.push(...p);
                  }
                };
                i();
                for (let l of Object.keys(this._utils.schemas)) {
                  let p = this._utils.schemas[l];
                  if (!(l in n)) {
                    let y = t3.normalizeDefaultResult(p.default(this._utils));
                    "value" in y && u.push({ [l]: y.value });
                  }
                }
                i();
                for (let l of Object.keys(this._utils.schemas)) {
                  let p = this._utils.schemas[l];
                  l in n && (n[l] = p.postprocess(n[l], this._utils));
                }
                return n;
              }
              _applyNormalization(a, n) {
                let u = [], [i, l] = t3.partition(Object.keys(a), (p) => p in this._utils.schemas);
                for (let p of i) {
                  let y = this._utils.schemas[p], h = y.preprocess(a[p], this._utils), g = t3.normalizeValidateResult(y.validate(h, this._utils), h);
                  if (g !== true) {
                    let { value: w } = g, E = this._invalidHandler(p, w, this._utils);
                    throw typeof E == "string" ? new Error(E) : E;
                  }
                  let c = (w) => {
                    let { from: E, to: N } = w;
                    u.push(typeof N == "string" ? { [N]: E } : { [N.key]: N.value });
                  }, f = (w) => {
                    let { value: E, redirectTo: N } = w, x = t3.normalizeDeprecatedResult(y.deprecated(E, this._utils), h, true);
                    if (x !== false)
                      if (x === true)
                        this._hasDeprecationWarned(p) || this._utils.logger.warn(this._deprecatedHandler(p, N, this._utils));
                      else
                        for (let { value: I } of x) {
                          let P = { key: p, value: I };
                          if (!this._hasDeprecationWarned(P)) {
                            let $ = typeof N == "string" ? { key: N, value: I } : N;
                            this._utils.logger.warn(this._deprecatedHandler(P, $, this._utils));
                          }
                        }
                  };
                  t3.normalizeForwardResult(y.forward(h, this._utils), h).forEach(c);
                  let _ = t3.normalizeRedirectResult(y.redirect(h, this._utils), h);
                  if (_.redirect.forEach(c), "remain" in _) {
                    let w = _.remain;
                    n[p] = p in n ? y.overlap(n[p], w, this._utils) : w, f({ value: w });
                  }
                  for (let { from: w, to: E } of _.redirect)
                    f({ value: w, redirectTo: E });
                }
                for (let p of l) {
                  let y = a[p], h = this._unknownHandler(p, y, this._utils);
                  if (h)
                    for (let g of Object.keys(h)) {
                      let c = { [g]: h[g] };
                      g in this._utils.schemas ? u.push(c) : Object.assign(n, c);
                    }
                }
                return u;
              }
            };
            e.Normalizer = s;
          } }), Lm = te({ "node_modules/vnopts/lib/index.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = (Et(), ft(vt));
            r.__exportStar(vm(), e), r.__exportStar(Sm(), e), r.__exportStar(Pm(), e), r.__exportStar(km(), e), r.__exportStar(Ft(), e);
          } }), Om = te({ "src/main/options-normalizer.js"(e, r) {
            "use strict";
            ne();
            var t3 = Lm(), s = lt2(), a = { key: (g) => g.length === 1 ? `-${g}` : `--${g}`, value: (g) => t3.apiDescriptor.value(g), pair: (g) => {
              let { key: c, value: f } = g;
              return f === false ? `--no-${c}` : f === true ? a.key(c) : f === "" ? `${a.key(c)} without an argument` : `${a.key(c)}=${f}`;
            } }, n = (g) => {
              let { colorsModule: c, levenshteinDistance: f } = g;
              return class extends t3.ChoiceSchema {
                constructor(_) {
                  let { name: w, flags: E } = _;
                  super({ name: w, choices: E }), this._flags = [...E].sort();
                }
                preprocess(_, w) {
                  if (typeof _ == "string" && _.length > 0 && !this._flags.includes(_)) {
                    let E = this._flags.find((N) => f(N, _) < 3);
                    if (E)
                      return w.logger.warn([`Unknown flag ${c.yellow(w.descriptor.value(_))},`, `did you mean ${c.blue(w.descriptor.value(E))}?`].join(" ")), E;
                  }
                  return _;
                }
                expected() {
                  return "a flag";
                }
              };
            }, u;
            function i(g, c) {
              let { logger: f = false, isCLI: F = false, passThrough: _ = false, colorsModule: w = null, levenshteinDistance: E = null } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, N = _ ? Array.isArray(_) ? (T, m) => _.includes(T) ? { [T]: m } : void 0 : (T, m) => ({ [T]: m }) : (T, m, C) => {
                let o = C.schemas, { _: d } = o, v = Hn(o, vD);
                return t3.levenUnknownHandler(T, m, Object.assign(Object.assign({}, C), {}, { schemas: v }));
              }, x = F ? a : t3.apiDescriptor, I = l(c, { isCLI: F, colorsModule: w, levenshteinDistance: E }), P = new t3.Normalizer(I, { logger: f, unknown: N, descriptor: x }), $ = f !== false;
              $ && u && (P._hasDeprecationWarned = u);
              let D = P.normalize(g);
              return $ && (u = P._hasDeprecationWarned), F && D["plugin-search"] === false && (D["plugin-search-dir"] = false), D;
            }
            function l(g, c) {
              let { isCLI: f, colorsModule: F, levenshteinDistance: _ } = c, w = [];
              f && w.push(t3.AnySchema.create({ name: "_" }));
              for (let E of g)
                w.push(p(E, { isCLI: f, optionInfos: g, colorsModule: F, levenshteinDistance: _ })), E.alias && f && w.push(t3.AliasSchema.create({ name: E.alias, sourceName: E.name }));
              return w;
            }
            function p(g, c) {
              let { isCLI: f, optionInfos: F, colorsModule: _, levenshteinDistance: w } = c, { name: E } = g;
              if (E === "plugin-search-dir" || E === "pluginSearchDirs")
                return t3.AnySchema.create({ name: E, preprocess(P) {
                  return P === false || (P = Array.isArray(P) ? P : [P]), P;
                }, validate(P) {
                  return P === false ? true : P.every(($) => typeof $ == "string");
                }, expected() {
                  return "false or paths to plugin search dir";
                } });
              let N = { name: E }, x, I = {};
              switch (g.type) {
                case "int":
                  x = t3.IntegerSchema, f && (N.preprocess = Number);
                  break;
                case "string":
                  x = t3.StringSchema;
                  break;
                case "choice":
                  x = t3.ChoiceSchema, N.choices = g.choices.map((P) => typeof P == "object" && P.redirect ? Object.assign(Object.assign({}, P), {}, { redirect: { to: { key: g.name, value: P.redirect } } }) : P);
                  break;
                case "boolean":
                  x = t3.BooleanSchema;
                  break;
                case "flag":
                  x = n({ colorsModule: _, levenshteinDistance: w }), N.flags = F.flatMap((P) => [P.alias, P.description && P.name, P.oppositeDescription && `no-${P.name}`].filter(Boolean));
                  break;
                case "path":
                  x = t3.StringSchema;
                  break;
                default:
                  throw new Error(`Unexpected type ${g.type}`);
              }
              if (g.exception ? N.validate = (P, $, D) => g.exception(P) || $.validate(P, D) : N.validate = (P, $, D) => P === void 0 || $.validate(P, D), g.redirect && (I.redirect = (P) => P ? { to: { key: g.redirect.option, value: g.redirect.value } } : void 0), g.deprecated && (I.deprecated = true), f && !g.array) {
                let P = N.preprocess || (($) => $);
                N.preprocess = ($, D, T) => D.preprocess(P(Array.isArray($) ? s($) : $), T);
              }
              return g.array ? t3.ArraySchema.create(Object.assign(Object.assign(Object.assign({}, f ? { preprocess: (P) => Array.isArray(P) ? P : [P] } : {}), I), {}, { valueSchema: x.create(N) })) : x.create(Object.assign(Object.assign({}, N), I));
            }
            function y(g, c, f) {
              return i(g, c, f);
            }
            function h(g, c, f) {
              return i(g, c, Object.assign({ isCLI: true }, f));
            }
            r.exports = { normalizeApiOptions: y, normalizeCliOptions: h };
          } }), ut = te({ "src/language-js/loc.js"(e, r) {
            "use strict";
            ne();
            var t3 = Kn();
            function s(l) {
              var p, y;
              let h = l.range ? l.range[0] : l.start, g = (p = (y = l.declaration) === null || y === void 0 ? void 0 : y.decorators) !== null && p !== void 0 ? p : l.decorators;
              return t3(g) ? Math.min(s(g[0]), h) : h;
            }
            function a(l) {
              return l.range ? l.range[1] : l.end;
            }
            function n(l, p) {
              let y = s(l);
              return Number.isInteger(y) && y === s(p);
            }
            function u(l, p) {
              let y = a(l);
              return Number.isInteger(y) && y === a(p);
            }
            function i(l, p) {
              return n(l, p) && u(l, p);
            }
            r.exports = { locStart: s, locEnd: a, hasSameLocStart: n, hasSameLoc: i };
          } }), jm = te({ "src/main/load-parser.js"(e, r) {
            ne(), r.exports = () => {
            };
          } }), qm = te({ "scripts/build/shims/babel-highlight.cjs"(e, r) {
            "use strict";
            ne();
            var t3 = kr(), s = { shouldHighlight: () => false, getChalk: () => t3 };
            r.exports = s;
          } }), Mm = te({ "node_modules/@babel/code-frame/lib/index.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true }), e.codeFrameColumns = u, e.default = i;
            var r = qm(), t3 = false;
            function s(l) {
              return { gutter: l.grey, marker: l.red.bold, message: l.red.bold };
            }
            var a = /\r\n|[\n\r\u2028\u2029]/;
            function n(l, p, y) {
              let h = Object.assign({ column: 0, line: -1 }, l.start), g = Object.assign({}, h, l.end), { linesAbove: c = 2, linesBelow: f = 3 } = y || {}, F = h.line, _ = h.column, w = g.line, E = g.column, N = Math.max(F - (c + 1), 0), x = Math.min(p.length, w + f);
              F === -1 && (N = 0), w === -1 && (x = p.length);
              let I = w - F, P = {};
              if (I)
                for (let $ = 0; $ <= I; $++) {
                  let D = $ + F;
                  if (!_)
                    P[D] = true;
                  else if ($ === 0) {
                    let T = p[D - 1].length;
                    P[D] = [_, T - _ + 1];
                  } else if ($ === I)
                    P[D] = [0, E];
                  else {
                    let T = p[D - $].length;
                    P[D] = [0, T];
                  }
                }
              else
                _ === E ? _ ? P[F] = [_, 0] : P[F] = true : P[F] = [_, E - _];
              return { start: N, end: x, markerLines: P };
            }
            function u(l, p) {
              let y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, h = (y.highlightCode || y.forceColor) && (0, r.shouldHighlight)(y), g = (0, r.getChalk)(y), c = s(g), f = ($, D) => h ? $(D) : D, F = l.split(a), { start: _, end: w, markerLines: E } = n(p, F, y), N = p.start && typeof p.start.column == "number", x = String(w).length, P = (h ? (0, r.default)(l, y) : l).split(a, w).slice(_, w).map(($, D) => {
                let T = _ + 1 + D, C = ` ${` ${T}`.slice(-x)} |`, o = E[T], d = !E[T + 1];
                if (o) {
                  let v = "";
                  if (Array.isArray(o)) {
                    let S = $.slice(0, Math.max(o[0] - 1, 0)).replace(/[^\t]/g, " "), b = o[1] || 1;
                    v = [`
 `, f(c.gutter, C.replace(/\d/g, " ")), " ", S, f(c.marker, "^").repeat(b)].join(""), d && y.message && (v += " " + f(c.message, y.message));
                  }
                  return [f(c.marker, ">"), f(c.gutter, C), $.length > 0 ? ` ${$}` : "", v].join("");
                } else
                  return ` ${f(c.gutter, C)}${$.length > 0 ? ` ${$}` : ""}`;
              }).join(`
`);
              return y.message && !N && (P = `${" ".repeat(x + 1)}${y.message}
${P}`), h ? g.reset(P) : P;
            }
            function i(l, p, y) {
              let h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
              if (!t3) {
                t3 = true;
                let c = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
                if (wt.emitWarning)
                  wt.emitWarning(c, "DeprecationWarning");
                else {
                  let f = new Error(c);
                  f.name = "DeprecationWarning", console.warn(new Error(c));
                }
              }
              return y = Math.max(y, 0), u(l, { start: { column: y, line: p } }, h);
            }
          } }), tu = te({ "src/main/parser.js"(e, r) {
            "use strict";
            ne();
            var { ConfigError: t3 } = Qt(), s = ut(), a = jm(), { locStart: n, locEnd: u } = s, i = Object.getOwnPropertyNames, l = Object.getOwnPropertyDescriptor;
            function p(g) {
              let c = {};
              for (let f of g.plugins)
                if (f.parsers)
                  for (let F of i(f.parsers))
                    Object.defineProperty(c, F, l(f.parsers, F));
              return c;
            }
            function y(g) {
              let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : p(g);
              if (typeof g.parser == "function")
                return { parse: g.parser, astFormat: "estree", locStart: n, locEnd: u };
              if (typeof g.parser == "string") {
                if (Object.prototype.hasOwnProperty.call(c, g.parser))
                  return c[g.parser];
                throw new t3(`Couldn't resolve parser "${g.parser}". Parsers must be explicitly added to the standalone bundle.`);
              }
            }
            function h(g, c) {
              let f = p(c), F = Object.defineProperties({}, Object.fromEntries(Object.keys(f).map((w) => [w, { enumerable: true, get() {
                return f[w].parse;
              } }]))), _ = y(c, f);
              try {
                return _.preprocess && (g = _.preprocess(g, c)), { text: g, ast: _.parse(g, F, c) };
              } catch (w) {
                let { loc: E } = w;
                if (E) {
                  let { codeFrameColumns: N } = Mm();
                  throw w.codeFrame = N(g, E, { highlightCode: true }), w.message += `
` + w.codeFrame, w;
                }
                throw w;
              }
            }
            r.exports = { parse: h, resolveParser: y };
          } }), uo = te({ "src/main/options.js"(e, r) {
            "use strict";
            ne();
            var t3 = ZD(), { UndefinedParserError: s } = Qt(), { getSupportInfo: a } = Xn(), n = Om(), { resolveParser: u } = tu(), i = { astFormat: "estree", printer: {}, originalText: void 0, locStart: null, locEnd: null };
            function l(h) {
              let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = Object.assign({}, h), f = a({ plugins: h.plugins, showUnreleased: true, showDeprecated: true }).options, F = Object.assign(Object.assign({}, i), Object.fromEntries(f.filter((x) => x.default !== void 0).map((x) => [x.name, x.default])));
              if (!c.parser) {
                if (!c.filepath)
                  (g.logger || console).warn("No parser and no filepath given, using 'babel' the parser now but this will throw an error in the future. Please specify a parser or a filepath so one can be inferred."), c.parser = "babel";
                else if (c.parser = y(c.filepath, c.plugins), !c.parser)
                  throw new s(`No parser could be inferred for file: ${c.filepath}`);
              }
              let _ = u(n.normalizeApiOptions(c, [f.find((x) => x.name === "parser")], { passThrough: true, logger: false }));
              c.astFormat = _.astFormat, c.locEnd = _.locEnd, c.locStart = _.locStart;
              let w = p(c);
              c.printer = w.printers[c.astFormat];
              let E = Object.fromEntries(f.filter((x) => x.pluginDefaults && x.pluginDefaults[w.name] !== void 0).map((x) => [x.name, x.pluginDefaults[w.name]])), N = Object.assign(Object.assign({}, F), E);
              for (let [x, I] of Object.entries(N))
                (c[x] === null || c[x] === void 0) && (c[x] = I);
              return c.parser === "json" && (c.trailingComma = "none"), n.normalizeApiOptions(c, f, Object.assign({ passThrough: Object.keys(i) }, g));
            }
            function p(h) {
              let { astFormat: g } = h;
              if (!g)
                throw new Error("getPlugin() requires astFormat to be set");
              let c = h.plugins.find((f) => f.printers && f.printers[g]);
              if (!c)
                throw new Error(`Couldn't find plugin for AST format "${g}"`);
              return c;
            }
            function y(h, g) {
              let c = t3.basename(h).toLowerCase(), F = a({ plugins: g }).languages.filter((_) => _.since !== null).find((_) => _.extensions && _.extensions.some((w) => c.endsWith(w)) || _.filenames && _.filenames.some((w) => w.toLowerCase() === c));
              return F && F.parsers[0];
            }
            r.exports = { normalize: l, hiddenDefaults: i, inferParser: y };
          } }), Rm = te({ "src/main/massage-ast.js"(e, r) {
            "use strict";
            ne();
            function t3(s, a, n) {
              if (Array.isArray(s))
                return s.map((p) => t3(p, a, n)).filter(Boolean);
              if (!s || typeof s != "object")
                return s;
              let u = a.printer.massageAstNode, i;
              u && u.ignoredProperties ? i = u.ignoredProperties : i = /* @__PURE__ */ new Set();
              let l = {};
              for (let [p, y] of Object.entries(s))
                !i.has(p) && typeof y != "function" && (l[p] = t3(y, a, s));
              if (u) {
                let p = u(s, l, n);
                if (p === null)
                  return;
                if (p)
                  return p;
              }
              return l;
            }
            r.exports = t3;
          } }), Zt = te({ "scripts/build/shims/assert.cjs"(e, r) {
            "use strict";
            ne();
            var t3 = () => {
            };
            t3.ok = t3, t3.strictEqual = t3, r.exports = t3;
          } }), et = te({ "src/main/comments.js"(e, r) {
            "use strict";
            ne();
            var t3 = Zt(), { builders: { line: s, hardline: a, breakParent: n, indent: u, lineSuffix: i, join: l, cursor: p } } = qe(), { hasNewline: y, skipNewline: h, skipSpaces: g, isPreviousLineEmpty: c, addLeadingComment: f, addDanglingComment: F, addTrailingComment: _ } = Ue(), w = /* @__PURE__ */ new WeakMap();
            function E(k, M, R) {
              if (!k)
                return;
              let { printer: q, locStart: J, locEnd: L } = M;
              if (R) {
                if (q.canAttachComment && q.canAttachComment(k)) {
                  let V;
                  for (V = R.length - 1; V >= 0 && !(J(R[V]) <= J(k) && L(R[V]) <= L(k)); --V)
                    ;
                  R.splice(V + 1, 0, k);
                  return;
                }
              } else if (w.has(k))
                return w.get(k);
              let Q = q.getCommentChildNodes && q.getCommentChildNodes(k, M) || typeof k == "object" && Object.entries(k).filter((V) => {
                let [j] = V;
                return j !== "enclosingNode" && j !== "precedingNode" && j !== "followingNode" && j !== "tokens" && j !== "comments" && j !== "parent";
              }).map((V) => {
                let [, j] = V;
                return j;
              });
              if (Q) {
                R || (R = [], w.set(k, R));
                for (let V of Q)
                  E(V, M, R);
                return R;
              }
            }
            function N(k, M, R, q) {
              let { locStart: J, locEnd: L } = R, Q = J(M), V = L(M), j = E(k, R), Y, ie, ee = 0, ce = j.length;
              for (; ee < ce; ) {
                let W = ee + ce >> 1, K = j[W], de = J(K), ue = L(K);
                if (de <= Q && V <= ue)
                  return N(K, M, R, K);
                if (ue <= Q) {
                  Y = K, ee = W + 1;
                  continue;
                }
                if (V <= de) {
                  ie = K, ce = W;
                  continue;
                }
                throw new Error("Comment location overlaps with node location");
              }
              if (q && q.type === "TemplateLiteral") {
                let { quasis: W } = q, K = C(W, M, R);
                Y && C(W, Y, R) !== K && (Y = null), ie && C(W, ie, R) !== K && (ie = null);
              }
              return { enclosingNode: q, precedingNode: Y, followingNode: ie };
            }
            var x = () => false;
            function I(k, M, R, q) {
              if (!Array.isArray(k))
                return;
              let J = [], { locStart: L, locEnd: Q, printer: { handleComments: V = {} } } = q, { avoidAstMutation: j, ownLine: Y = x, endOfLine: ie = x, remaining: ee = x } = V, ce = k.map((W, K) => Object.assign(Object.assign({}, N(M, W, q)), {}, { comment: W, text: R, options: q, ast: M, isLastComment: k.length - 1 === K }));
              for (let [W, K] of ce.entries()) {
                let { comment: de, precedingNode: ue, enclosingNode: Fe, followingNode: z, text: U, options: Z, ast: se, isLastComment: fe } = K;
                if (Z.parser === "json" || Z.parser === "json5" || Z.parser === "__js_expression" || Z.parser === "__vue_expression" || Z.parser === "__vue_ts_expression") {
                  if (L(de) - L(se) <= 0) {
                    f(se, de);
                    continue;
                  }
                  if (Q(de) - Q(se) >= 0) {
                    _(se, de);
                    continue;
                  }
                }
                let ge;
                if (j ? ge = [K] : (de.enclosingNode = Fe, de.precedingNode = ue, de.followingNode = z, ge = [de, U, Z, se, fe]), $(U, Z, ce, W))
                  de.placement = "ownLine", Y(...ge) || (z ? f(z, de) : ue ? _(ue, de) : F(Fe || se, de));
                else if (D(U, Z, ce, W))
                  de.placement = "endOfLine", ie(...ge) || (ue ? _(ue, de) : z ? f(z, de) : F(Fe || se, de));
                else if (de.placement = "remaining", !ee(...ge))
                  if (ue && z) {
                    let he = J.length;
                    he > 0 && J[he - 1].followingNode !== z && T(J, U, Z), J.push(K);
                  } else
                    ue ? _(ue, de) : z ? f(z, de) : F(Fe || se, de);
              }
              if (T(J, R, q), !j)
                for (let W of k)
                  delete W.precedingNode, delete W.enclosingNode, delete W.followingNode;
            }
            var P = (k) => !/[\S\n\u2028\u2029]/.test(k);
            function $(k, M, R, q) {
              let { comment: J, precedingNode: L } = R[q], { locStart: Q, locEnd: V } = M, j = Q(J);
              if (L)
                for (let Y = q - 1; Y >= 0; Y--) {
                  let { comment: ie, precedingNode: ee } = R[Y];
                  if (ee !== L || !P(k.slice(V(ie), j)))
                    break;
                  j = Q(ie);
                }
              return y(k, j, { backwards: true });
            }
            function D(k, M, R, q) {
              let { comment: J, followingNode: L } = R[q], { locStart: Q, locEnd: V } = M, j = V(J);
              if (L)
                for (let Y = q + 1; Y < R.length; Y++) {
                  let { comment: ie, followingNode: ee } = R[Y];
                  if (ee !== L || !P(k.slice(j, Q(ie))))
                    break;
                  j = V(ie);
                }
              return y(k, j);
            }
            function T(k, M, R) {
              let q = k.length;
              if (q === 0)
                return;
              let { precedingNode: J, followingNode: L, enclosingNode: Q } = k[0], V = R.printer.getGapRegex && R.printer.getGapRegex(Q) || /^[\s(]*$/, j = R.locStart(L), Y;
              for (Y = q; Y > 0; --Y) {
                let { comment: ie, precedingNode: ee, followingNode: ce } = k[Y - 1];
                t3.strictEqual(ee, J), t3.strictEqual(ce, L);
                let W = M.slice(R.locEnd(ie), j);
                if (V.test(W))
                  j = R.locStart(ie);
                else
                  break;
              }
              for (let [ie, { comment: ee }] of k.entries())
                ie < Y ? _(J, ee) : f(L, ee);
              for (let ie of [J, L])
                ie.comments && ie.comments.length > 1 && ie.comments.sort((ee, ce) => R.locStart(ee) - R.locStart(ce));
              k.length = 0;
            }
            function m(k, M) {
              let R = k.getValue();
              return R.printed = true, M.printer.printComment(k, M);
            }
            function C(k, M, R) {
              let q = R.locStart(M) - 1;
              for (let J = 1; J < k.length; ++J)
                if (q < R.locStart(k[J]))
                  return J - 1;
              return 0;
            }
            function o(k, M) {
              let R = k.getValue(), q = [m(k, M)], { printer: J, originalText: L, locStart: Q, locEnd: V } = M;
              if (J.isBlockComment && J.isBlockComment(R)) {
                let ie = y(L, V(R)) ? y(L, Q(R), { backwards: true }) ? a : s : " ";
                q.push(ie);
              } else
                q.push(a);
              let Y = h(L, g(L, V(R)));
              return Y !== false && y(L, Y) && q.push(a), q;
            }
            function d(k, M) {
              let R = k.getValue(), q = m(k, M), { printer: J, originalText: L, locStart: Q } = M, V = J.isBlockComment && J.isBlockComment(R);
              if (y(L, Q(R), { backwards: true })) {
                let Y = c(L, R, Q);
                return i([a, Y ? a : "", q]);
              }
              let j = [" ", q];
              return V || (j = [i(j), n]), j;
            }
            function v(k, M, R, q) {
              let J = [], L = k.getValue();
              return !L || !L.comments || (k.each(() => {
                let Q = k.getValue();
                !Q.leading && !Q.trailing && (!q || q(Q)) && J.push(m(k, M));
              }, "comments"), J.length === 0) ? "" : R ? l(a, J) : u([a, l(a, J)]);
            }
            function S(k, M, R) {
              let q = k.getValue();
              if (!q)
                return {};
              let J = q.comments || [];
              R && (J = J.filter((j) => !R.has(j)));
              let L = q === M.cursorNode;
              if (J.length === 0) {
                let j = L ? p : "";
                return { leading: j, trailing: j };
              }
              let Q = [], V = [];
              return k.each(() => {
                let j = k.getValue();
                if (R && R.has(j))
                  return;
                let { leading: Y, trailing: ie } = j;
                Y ? Q.push(o(k, M)) : ie && V.push(d(k, M));
              }, "comments"), L && (Q.unshift(p), V.push(p)), { leading: Q, trailing: V };
            }
            function b(k, M, R, q) {
              let { leading: J, trailing: L } = S(k, R, q);
              return !J && !L ? M : [J, M, L];
            }
            function B(k) {
              if (k)
                for (let M of k) {
                  if (!M.printed)
                    throw new Error('Comment "' + M.value.trim() + '" was not printed. Please report this error!');
                  delete M.printed;
                }
            }
            r.exports = { attach: I, printComments: b, printCommentsSeparately: S, printDanglingComments: v, getSortedChildNodes: E, ensureAllCommentsPrinted: B };
          } }), $m = te({ "src/common/ast-path.js"(e, r) {
            "use strict";
            ne();
            var t3 = lt2();
            function s(u, i) {
              let l = a(u.stack, i);
              return l === -1 ? null : u.stack[l];
            }
            function a(u, i) {
              for (let l = u.length - 1; l >= 0; l -= 2) {
                let p = u[l];
                if (p && !Array.isArray(p) && --i < 0)
                  return l;
              }
              return -1;
            }
            var n = class {
              constructor(u) {
                this.stack = [u];
              }
              getName() {
                let { stack: u } = this, { length: i } = u;
                return i > 1 ? u[i - 2] : null;
              }
              getValue() {
                return t3(this.stack);
              }
              getNode() {
                let u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return s(this, u);
              }
              getParentNode() {
                let u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return s(this, u + 1);
              }
              call(u) {
                let { stack: i } = this, { length: l } = i, p = t3(i);
                for (var y = arguments.length, h = new Array(y > 1 ? y - 1 : 0), g = 1; g < y; g++)
                  h[g - 1] = arguments[g];
                for (let f of h)
                  p = p[f], i.push(f, p);
                let c = u(this);
                return i.length = l, c;
              }
              callParent(u) {
                let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, l = a(this.stack, i + 1), p = this.stack.splice(l + 1), y = u(this);
                return this.stack.push(...p), y;
              }
              each(u) {
                let { stack: i } = this, { length: l } = i, p = t3(i);
                for (var y = arguments.length, h = new Array(y > 1 ? y - 1 : 0), g = 1; g < y; g++)
                  h[g - 1] = arguments[g];
                for (let c of h)
                  p = p[c], i.push(c, p);
                for (let c = 0; c < p.length; ++c)
                  i.push(c, p[c]), u(this, c, p), i.length -= 2;
                i.length = l;
              }
              map(u) {
                let i = [];
                for (var l = arguments.length, p = new Array(l > 1 ? l - 1 : 0), y = 1; y < l; y++)
                  p[y - 1] = arguments[y];
                return this.each((h, g, c) => {
                  i[g] = u(h, g, c);
                }, ...p), i;
              }
              try(u) {
                let { stack: i } = this, l = [...i];
                try {
                  return u();
                } finally {
                  i.length = 0, i.push(...l);
                }
              }
              match() {
                let u = this.stack.length - 1, i = null, l = this.stack[u--];
                for (var p = arguments.length, y = new Array(p), h = 0; h < p; h++)
                  y[h] = arguments[h];
                for (let g of y) {
                  if (l === void 0)
                    return false;
                  let c = null;
                  if (typeof i == "number" && (c = i, i = this.stack[u--], l = this.stack[u--]), g && !g(l, i, c))
                    return false;
                  i = this.stack[u--], l = this.stack[u--];
                }
                return true;
              }
              findAncestor(u) {
                let i = this.stack.length - 1, l = null, p = this.stack[i--];
                for (; p; ) {
                  let y = null;
                  if (typeof l == "number" && (y = l, l = this.stack[i--], p = this.stack[i--]), l !== null && u(p, l, y))
                    return p;
                  l = this.stack[i--], p = this.stack[i--];
                }
              }
            };
            r.exports = n;
          } }), Vm = te({ "src/main/multiparser.js"(e, r) {
            "use strict";
            ne();
            var { utils: { stripTrailingHardline: t3 } } = qe(), { normalize: s } = uo(), a = et();
            function n(i, l, p, y) {
              if (p.printer.embed && p.embeddedLanguageFormatting === "auto")
                return p.printer.embed(i, l, (h, g, c) => u(h, g, p, y, c), p);
            }
            function u(i, l, p, y) {
              let { stripTrailingHardline: h = false } = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, g = s(Object.assign(Object.assign(Object.assign({}, p), l), {}, { parentParser: p.parser, originalText: i }), { passThrough: true }), c = tu().parse(i, g), { ast: f } = c;
              i = c.text;
              let F = f.comments;
              delete f.comments, a.attach(F, f, i, g), g[Symbol.for("comments")] = F || [], g[Symbol.for("tokens")] = f.tokens || [];
              let _ = y(f, g);
              return a.ensureAllCommentsPrinted(F), h ? typeof _ == "string" ? _.replace(/(?:\r?\n)*$/, "") : t3(_) : _;
            }
            r.exports = { printSubtree: n };
          } }), Wm = te({ "src/main/ast-to-doc.js"(e, r) {
            "use strict";
            ne();
            var t3 = $m(), { builders: { hardline: s, addAlignmentToDoc: a }, utils: { propagateBreaks: n } } = qe(), { printComments: u } = et(), i = Vm();
            function l(h, g) {
              let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, { printer: f } = g;
              f.preprocess && (h = f.preprocess(h, g));
              let F = /* @__PURE__ */ new Map(), _ = new t3(h), w = E();
              return c > 0 && (w = a([s, w], c, g.tabWidth)), n(w), w;
              function E(x, I) {
                return x === void 0 || x === _ ? N(I) : Array.isArray(x) ? _.call(() => N(I), ...x) : _.call(() => N(I), x);
              }
              function N(x) {
                let I = _.getValue(), P = I && typeof I == "object" && x === void 0;
                if (P && F.has(I))
                  return F.get(I);
                let $ = y(_, g, E, x);
                return P && F.set(I, $), $;
              }
            }
            function p(h, g) {
              let { originalText: c, [Symbol.for("comments")]: f, locStart: F, locEnd: _ } = g, w = F(h), E = _(h), N = /* @__PURE__ */ new Set();
              for (let x of f)
                F(x) >= w && _(x) <= E && (x.printed = true, N.add(x));
              return { doc: c.slice(w, E), printedComments: N };
            }
            function y(h, g, c, f) {
              let F = h.getValue(), { printer: _ } = g, w, E;
              if (_.hasPrettierIgnore && _.hasPrettierIgnore(h))
                ({ doc: w, printedComments: E } = p(F, g));
              else {
                if (F)
                  try {
                    w = i.printSubtree(h, c, g, l);
                  } catch (N) {
                    if (globalThis.PRETTIER_DEBUG)
                      throw N;
                  }
                w || (w = _.print(h, g, c, f));
              }
              return (!_.willPrintOwnComments || !_.willPrintOwnComments(h, g)) && (w = u(h, w, g, E)), w;
            }
            r.exports = l;
          } }), Hm = te({ "src/main/range-util.js"(e, r) {
            "use strict";
            ne();
            var t3 = Zt(), s = et(), a = (f) => {
              let { parser: F } = f;
              return F === "json" || F === "json5" || F === "json-stringify";
            };
            function n(f, F) {
              let _ = [f.node, ...f.parentNodes], w = /* @__PURE__ */ new Set([F.node, ...F.parentNodes]);
              return _.find((E) => y.has(E.type) && w.has(E));
            }
            function u(f) {
              let F = f.length - 1;
              for (; ; ) {
                let _ = f[F];
                if (_ && (_.type === "Program" || _.type === "File"))
                  F--;
                else
                  break;
              }
              return f.slice(0, F + 1);
            }
            function i(f, F, _) {
              let { locStart: w, locEnd: E } = _, N = f.node, x = F.node;
              if (N === x)
                return { startNode: N, endNode: x };
              let I = w(f.node);
              for (let $ of u(F.parentNodes))
                if (w($) >= I)
                  x = $;
                else
                  break;
              let P = E(F.node);
              for (let $ of u(f.parentNodes)) {
                if (E($) <= P)
                  N = $;
                else
                  break;
                if (N === x)
                  break;
              }
              return { startNode: N, endNode: x };
            }
            function l(f, F, _, w) {
              let E = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], N = arguments.length > 5 ? arguments[5] : void 0, { locStart: x, locEnd: I } = _, P = x(f), $ = I(f);
              if (!(F > $ || F < P || N === "rangeEnd" && F === P || N === "rangeStart" && F === $)) {
                for (let D of s.getSortedChildNodes(f, _)) {
                  let T = l(D, F, _, w, [f, ...E], N);
                  if (T)
                    return T;
                }
                if (!w || w(f, E[0]))
                  return { node: f, parentNodes: E };
              }
            }
            function p(f, F) {
              return F !== "DeclareExportDeclaration" && f !== "TypeParameterDeclaration" && (f === "Directive" || f === "TypeAlias" || f === "TSExportAssignment" || f.startsWith("Declare") || f.startsWith("TSDeclare") || f.endsWith("Statement") || f.endsWith("Declaration"));
            }
            var y = /* @__PURE__ */ new Set(["ObjectExpression", "ArrayExpression", "StringLiteral", "NumericLiteral", "BooleanLiteral", "NullLiteral", "UnaryExpression", "TemplateLiteral"]), h = /* @__PURE__ */ new Set(["OperationDefinition", "FragmentDefinition", "VariableDefinition", "TypeExtensionDefinition", "ObjectTypeDefinition", "FieldDefinition", "DirectiveDefinition", "EnumTypeDefinition", "EnumValueDefinition", "InputValueDefinition", "InputObjectTypeDefinition", "SchemaDefinition", "OperationTypeDefinition", "InterfaceTypeDefinition", "UnionTypeDefinition", "ScalarTypeDefinition"]);
            function g(f, F, _) {
              if (!F)
                return false;
              switch (f.parser) {
                case "flow":
                case "babel":
                case "babel-flow":
                case "babel-ts":
                case "typescript":
                case "acorn":
                case "espree":
                case "meriyah":
                case "__babel_estree":
                  return p(F.type, _ && _.type);
                case "json":
                case "json5":
                case "json-stringify":
                  return y.has(F.type);
                case "graphql":
                  return h.has(F.kind);
                case "vue":
                  return F.tag !== "root";
              }
              return false;
            }
            function c(f, F, _) {
              let { rangeStart: w, rangeEnd: E, locStart: N, locEnd: x } = F;
              t3.ok(E > w);
              let I = f.slice(w, E).search(/\S/), P = I === -1;
              if (!P)
                for (w += I; E > w && !/\S/.test(f[E - 1]); --E)
                  ;
              let $ = l(_, w, F, (C, o) => g(F, C, o), [], "rangeStart"), D = P ? $ : l(_, E, F, (C) => g(F, C), [], "rangeEnd");
              if (!$ || !D)
                return { rangeStart: 0, rangeEnd: 0 };
              let T, m;
              if (a(F)) {
                let C = n($, D);
                T = C, m = C;
              } else
                ({ startNode: T, endNode: m } = i($, D, F));
              return { rangeStart: Math.min(N(T), N(m)), rangeEnd: Math.max(x(T), x(m)) };
            }
            r.exports = { calculateRange: c, findNodeAtOffset: l };
          } }), Gm = te({ "src/main/core.js"(e, r) {
            "use strict";
            ne();
            var { diffArrays: t3 } = BD(), { printer: { printDocToString: s }, debug: { printDocToDebug: a } } = qe(), { getAlignmentSize: n } = Ue(), { guessEndOfLine: u, convertEndOfLineToChars: i, countEndOfLineChars: l, normalizeEndOfLine: p } = Jn(), y = uo().normalize, h = Rm(), g = et(), c = tu(), f = Wm(), F = Hm(), _ = "\uFEFF", w = Symbol("cursor");
            function E(m, C, o) {
              let d = C.comments;
              return d && (delete C.comments, g.attach(d, C, m, o)), o[Symbol.for("comments")] = d || [], o[Symbol.for("tokens")] = C.tokens || [], o.originalText = m, d;
            }
            function N(m, C) {
              let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
              if (!m || m.trim().length === 0)
                return { formatted: "", cursorOffset: -1, comments: [] };
              let { ast: d, text: v } = c.parse(m, C);
              if (C.cursorOffset >= 0) {
                let k = F.findNodeAtOffset(d, C.cursorOffset, C);
                k && k.node && (C.cursorNode = k.node);
              }
              let S = E(v, d, C), b = f(d, C, o), B = s(b, C);
              if (g.ensureAllCommentsPrinted(S), o > 0) {
                let k = B.formatted.trim();
                B.cursorNodeStart !== void 0 && (B.cursorNodeStart -= B.formatted.indexOf(k)), B.formatted = k + i(C.endOfLine);
              }
              if (C.cursorOffset >= 0) {
                let k, M, R, q, J;
                if (C.cursorNode && B.cursorNodeText ? (k = C.locStart(C.cursorNode), M = v.slice(k, C.locEnd(C.cursorNode)), R = C.cursorOffset - k, q = B.cursorNodeStart, J = B.cursorNodeText) : (k = 0, M = v, R = C.cursorOffset, q = 0, J = B.formatted), M === J)
                  return { formatted: B.formatted, cursorOffset: q + R, comments: S };
                let L = [...M];
                L.splice(R, 0, w);
                let Q = [...J], V = t3(L, Q), j = q;
                for (let Y of V)
                  if (Y.removed) {
                    if (Y.value.includes(w))
                      break;
                  } else
                    j += Y.count;
                return { formatted: B.formatted, cursorOffset: j, comments: S };
              }
              return { formatted: B.formatted, cursorOffset: -1, comments: S };
            }
            function x(m, C) {
              let { ast: o, text: d } = c.parse(m, C), { rangeStart: v, rangeEnd: S } = F.calculateRange(d, C, o), b = d.slice(v, S), B = Math.min(v, d.lastIndexOf(`
`, v) + 1), k = d.slice(B, v).match(/^\s*/)[0], M = n(k, C.tabWidth), R = N(b, Object.assign(Object.assign({}, C), {}, { rangeStart: 0, rangeEnd: Number.POSITIVE_INFINITY, cursorOffset: C.cursorOffset > v && C.cursorOffset <= S ? C.cursorOffset - v : -1, endOfLine: "lf" }), M), q = R.formatted.trimEnd(), { cursorOffset: J } = C;
              J > S ? J += q.length - b.length : R.cursorOffset >= 0 && (J = R.cursorOffset + v);
              let L = d.slice(0, v) + q + d.slice(S);
              if (C.endOfLine !== "lf") {
                let Q = i(C.endOfLine);
                J >= 0 && Q === `\r
` && (J += l(L.slice(0, J), `
`)), L = L.replace(/\n/g, Q);
              }
              return { formatted: L, cursorOffset: J, comments: R.comments };
            }
            function I(m, C, o) {
              return typeof C != "number" || Number.isNaN(C) || C < 0 || C > m.length ? o : C;
            }
            function P(m, C) {
              let { cursorOffset: o, rangeStart: d, rangeEnd: v } = C;
              return o = I(m, o, -1), d = I(m, d, 0), v = I(m, v, m.length), Object.assign(Object.assign({}, C), {}, { cursorOffset: o, rangeStart: d, rangeEnd: v });
            }
            function $(m, C) {
              let { cursorOffset: o, rangeStart: d, rangeEnd: v, endOfLine: S } = P(m, C), b = m.charAt(0) === _;
              if (b && (m = m.slice(1), o--, d--, v--), S === "auto" && (S = u(m)), m.includes("\r")) {
                let B = (k) => l(m.slice(0, Math.max(k, 0)), `\r
`);
                o -= B(o), d -= B(d), v -= B(v), m = p(m);
              }
              return { hasBOM: b, text: m, options: P(m, Object.assign(Object.assign({}, C), {}, { cursorOffset: o, rangeStart: d, rangeEnd: v, endOfLine: S })) };
            }
            function D(m, C) {
              let o = c.resolveParser(C);
              return !o.hasPragma || o.hasPragma(m);
            }
            function T(m, C) {
              let { hasBOM: o, text: d, options: v } = $(m, y(C));
              if (v.rangeStart >= v.rangeEnd && d !== "" || v.requirePragma && !D(d, v))
                return { formatted: m, cursorOffset: C.cursorOffset, comments: [] };
              let S;
              return v.rangeStart > 0 || v.rangeEnd < d.length ? S = x(d, v) : (!v.requirePragma && v.insertPragma && v.printer.insertPragma && !D(d, v) && (d = v.printer.insertPragma(d)), S = N(d, v)), o && (S.formatted = _ + S.formatted, S.cursorOffset >= 0 && S.cursorOffset++), S;
            }
            r.exports = { formatWithCursor: T, parse(m, C, o) {
              let { text: d, options: v } = $(m, y(C)), S = c.parse(d, v);
              return o && (S.ast = h(S.ast, v)), S;
            }, formatAST(m, C) {
              C = y(C);
              let o = f(m, C);
              return s(o, C);
            }, formatDoc(m, C) {
              return T(a(m), Object.assign(Object.assign({}, C), {}, { parser: "__js_expression" })).formatted;
            }, printToDoc(m, C) {
              C = y(C);
              let { ast: o, text: d } = c.parse(m, C);
              return E(d, o, C), f(o, C);
            }, printDocToString(m, C) {
              return s(m, y(C));
            } };
          } }), Um = te({ "src/common/util-shared.js"(e, r) {
            "use strict";
            ne();
            var { getMaxContinuousCount: t3, getStringWidth: s, getAlignmentSize: a, getIndentSize: n, skip: u, skipWhitespace: i, skipSpaces: l, skipNewline: p, skipToLineEnd: y, skipEverythingButNewLine: h, skipInlineComment: g, skipTrailingComment: c, hasNewline: f, hasNewlineInRange: F, hasSpaces: _, isNextLineEmpty: w, isNextLineEmptyAfterIndex: E, isPreviousLineEmpty: N, getNextNonSpaceNonCommentCharacterIndex: x, makeString: I, addLeadingComment: P, addDanglingComment: $, addTrailingComment: D } = Ue();
            r.exports = { getMaxContinuousCount: t3, getStringWidth: s, getAlignmentSize: a, getIndentSize: n, skip: u, skipWhitespace: i, skipSpaces: l, skipNewline: p, skipToLineEnd: y, skipEverythingButNewLine: h, skipInlineComment: g, skipTrailingComment: c, hasNewline: f, hasNewlineInRange: F, hasSpaces: _, isNextLineEmpty: w, isNextLineEmptyAfterIndex: E, isPreviousLineEmpty: N, getNextNonSpaceNonCommentCharacterIndex: x, makeString: I, addLeadingComment: P, addDanglingComment: $, addTrailingComment: D };
          } }), _t = te({ "src/utils/create-language.js"(e, r) {
            "use strict";
            ne(), r.exports = function(t3, s) {
              let { languageId: a } = t3, n = Hn(t3, CD);
              return Object.assign(Object.assign({ linguistLanguageId: a }, n), s(t3));
            };
          } }), Jm = te({ "node_modules/esutils/lib/ast.js"(e, r) {
            ne(), function() {
              "use strict";
              function t3(l) {
                if (l == null)
                  return false;
                switch (l.type) {
                  case "ArrayExpression":
                  case "AssignmentExpression":
                  case "BinaryExpression":
                  case "CallExpression":
                  case "ConditionalExpression":
                  case "FunctionExpression":
                  case "Identifier":
                  case "Literal":
                  case "LogicalExpression":
                  case "MemberExpression":
                  case "NewExpression":
                  case "ObjectExpression":
                  case "SequenceExpression":
                  case "ThisExpression":
                  case "UnaryExpression":
                  case "UpdateExpression":
                    return true;
                }
                return false;
              }
              function s(l) {
                if (l == null)
                  return false;
                switch (l.type) {
                  case "DoWhileStatement":
                  case "ForInStatement":
                  case "ForStatement":
                  case "WhileStatement":
                    return true;
                }
                return false;
              }
              function a(l) {
                if (l == null)
                  return false;
                switch (l.type) {
                  case "BlockStatement":
                  case "BreakStatement":
                  case "ContinueStatement":
                  case "DebuggerStatement":
                  case "DoWhileStatement":
                  case "EmptyStatement":
                  case "ExpressionStatement":
                  case "ForInStatement":
                  case "ForStatement":
                  case "IfStatement":
                  case "LabeledStatement":
                  case "ReturnStatement":
                  case "SwitchStatement":
                  case "ThrowStatement":
                  case "TryStatement":
                  case "VariableDeclaration":
                  case "WhileStatement":
                  case "WithStatement":
                    return true;
                }
                return false;
              }
              function n(l) {
                return a(l) || l != null && l.type === "FunctionDeclaration";
              }
              function u(l) {
                switch (l.type) {
                  case "IfStatement":
                    return l.alternate != null ? l.alternate : l.consequent;
                  case "LabeledStatement":
                  case "ForStatement":
                  case "ForInStatement":
                  case "WhileStatement":
                  case "WithStatement":
                    return l.body;
                }
                return null;
              }
              function i(l) {
                var p;
                if (l.type !== "IfStatement" || l.alternate == null)
                  return false;
                p = l.consequent;
                do {
                  if (p.type === "IfStatement" && p.alternate == null)
                    return true;
                  p = u(p);
                } while (p);
                return false;
              }
              r.exports = { isExpression: t3, isStatement: a, isIterationStatement: s, isSourceElement: n, isProblematicIfStatement: i, trailingStatement: u };
            }();
          } }), so = te({ "node_modules/esutils/lib/code.js"(e, r) {
            ne(), function() {
              "use strict";
              var t3, s, a, n, u, i;
              s = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/, NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/ }, t3 = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/, NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/ };
              function l(E) {
                return 48 <= E && E <= 57;
              }
              function p(E) {
                return 48 <= E && E <= 57 || 97 <= E && E <= 102 || 65 <= E && E <= 70;
              }
              function y(E) {
                return E >= 48 && E <= 55;
              }
              a = [5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279];
              function h(E) {
                return E === 32 || E === 9 || E === 11 || E === 12 || E === 160 || E >= 5760 && a.indexOf(E) >= 0;
              }
              function g(E) {
                return E === 10 || E === 13 || E === 8232 || E === 8233;
              }
              function c(E) {
                if (E <= 65535)
                  return String.fromCharCode(E);
                var N = String.fromCharCode(Math.floor((E - 65536) / 1024) + 55296), x = String.fromCharCode((E - 65536) % 1024 + 56320);
                return N + x;
              }
              for (n = new Array(128), i = 0; i < 128; ++i)
                n[i] = i >= 97 && i <= 122 || i >= 65 && i <= 90 || i === 36 || i === 95;
              for (u = new Array(128), i = 0; i < 128; ++i)
                u[i] = i >= 97 && i <= 122 || i >= 65 && i <= 90 || i >= 48 && i <= 57 || i === 36 || i === 95;
              function f(E) {
                return E < 128 ? n[E] : s.NonAsciiIdentifierStart.test(c(E));
              }
              function F(E) {
                return E < 128 ? u[E] : s.NonAsciiIdentifierPart.test(c(E));
              }
              function _(E) {
                return E < 128 ? n[E] : t3.NonAsciiIdentifierStart.test(c(E));
              }
              function w(E) {
                return E < 128 ? u[E] : t3.NonAsciiIdentifierPart.test(c(E));
              }
              r.exports = { isDecimalDigit: l, isHexDigit: p, isOctalDigit: y, isWhiteSpace: h, isLineTerminator: g, isIdentifierStartES5: f, isIdentifierPartES5: F, isIdentifierStartES6: _, isIdentifierPartES6: w };
            }();
          } }), zm = te({ "node_modules/esutils/lib/keyword.js"(e, r) {
            ne(), function() {
              "use strict";
              var t3 = so();
              function s(f) {
                switch (f) {
                  case "implements":
                  case "interface":
                  case "package":
                  case "private":
                  case "protected":
                  case "public":
                  case "static":
                  case "let":
                    return true;
                  default:
                    return false;
                }
              }
              function a(f, F) {
                return !F && f === "yield" ? false : n(f, F);
              }
              function n(f, F) {
                if (F && s(f))
                  return true;
                switch (f.length) {
                  case 2:
                    return f === "if" || f === "in" || f === "do";
                  case 3:
                    return f === "var" || f === "for" || f === "new" || f === "try";
                  case 4:
                    return f === "this" || f === "else" || f === "case" || f === "void" || f === "with" || f === "enum";
                  case 5:
                    return f === "while" || f === "break" || f === "catch" || f === "throw" || f === "const" || f === "yield" || f === "class" || f === "super";
                  case 6:
                    return f === "return" || f === "typeof" || f === "delete" || f === "switch" || f === "export" || f === "import";
                  case 7:
                    return f === "default" || f === "finally" || f === "extends";
                  case 8:
                    return f === "function" || f === "continue" || f === "debugger";
                  case 10:
                    return f === "instanceof";
                  default:
                    return false;
                }
              }
              function u(f, F) {
                return f === "null" || f === "true" || f === "false" || a(f, F);
              }
              function i(f, F) {
                return f === "null" || f === "true" || f === "false" || n(f, F);
              }
              function l(f) {
                return f === "eval" || f === "arguments";
              }
              function p(f) {
                var F, _, w;
                if (f.length === 0 || (w = f.charCodeAt(0), !t3.isIdentifierStartES5(w)))
                  return false;
                for (F = 1, _ = f.length; F < _; ++F)
                  if (w = f.charCodeAt(F), !t3.isIdentifierPartES5(w))
                    return false;
                return true;
              }
              function y(f, F) {
                return (f - 55296) * 1024 + (F - 56320) + 65536;
              }
              function h(f) {
                var F, _, w, E, N;
                if (f.length === 0)
                  return false;
                for (N = t3.isIdentifierStartES6, F = 0, _ = f.length; F < _; ++F) {
                  if (w = f.charCodeAt(F), 55296 <= w && w <= 56319) {
                    if (++F, F >= _ || (E = f.charCodeAt(F), !(56320 <= E && E <= 57343)))
                      return false;
                    w = y(w, E);
                  }
                  if (!N(w))
                    return false;
                  N = t3.isIdentifierPartES6;
                }
                return true;
              }
              function g(f, F) {
                return p(f) && !u(f, F);
              }
              function c(f, F) {
                return h(f) && !i(f, F);
              }
              r.exports = { isKeywordES5: a, isKeywordES6: n, isReservedWordES5: u, isReservedWordES6: i, isRestrictedWord: l, isIdentifierNameES5: p, isIdentifierNameES6: h, isIdentifierES5: g, isIdentifierES6: c };
            }();
          } }), Xm = te({ "node_modules/esutils/lib/utils.js"(e) {
            ne(), function() {
              "use strict";
              e.ast = Jm(), e.code = so(), e.keyword = zm();
            }();
          } }), Pt = te({ "src/language-js/utils/is-block-comment.js"(e, r) {
            "use strict";
            ne();
            var t3 = /* @__PURE__ */ new Set(["Block", "CommentBlock", "MultiLine"]), s = (a) => t3.has(a == null ? void 0 : a.type);
            r.exports = s;
          } }), Km = te({ "src/language-js/utils/is-node-matches.js"(e, r) {
            "use strict";
            ne();
            function t3(a, n) {
              let u = n.split(".");
              for (let i = u.length - 1; i >= 0; i--) {
                let l = u[i];
                if (i === 0)
                  return a.type === "Identifier" && a.name === l;
                if (a.type !== "MemberExpression" || a.optional || a.computed || a.property.type !== "Identifier" || a.property.name !== l)
                  return false;
                a = a.object;
              }
            }
            function s(a, n) {
              return n.some((u) => t3(a, u));
            }
            r.exports = s;
          } }), Ke = te({ "src/language-js/utils/index.js"(e, r) {
            "use strict";
            ne();
            var t3 = Xm().keyword.isIdentifierNameES5, { getLast: s, hasNewline: a, skipWhitespace: n, isNonEmptyArray: u, isNextLineEmptyAfterIndex: i, getStringWidth: l } = Ue(), { locStart: p, locEnd: y, hasSameLocStart: h } = ut(), g = Pt(), c = Km(), f = "(?:(?=.)\\s)", F = new RegExp(`^${f}*:`), _ = new RegExp(`^${f}*::`);
            function w(O) {
              var me, _e;
              return ((me = O.extra) === null || me === void 0 ? void 0 : me.parenthesized) && g((_e = O.trailingComments) === null || _e === void 0 ? void 0 : _e[0]) && F.test(O.trailingComments[0].value);
            }
            function E(O) {
              let me = O == null ? void 0 : O[0];
              return g(me) && _.test(me.value);
            }
            function N(O, me) {
              if (!O || typeof O != "object")
                return false;
              if (Array.isArray(O))
                return O.some((He) => N(He, me));
              let _e = me(O);
              return typeof _e == "boolean" ? _e : Object.values(O).some((He) => N(He, me));
            }
            function x(O) {
              return O.type === "AssignmentExpression" || O.type === "BinaryExpression" || O.type === "LogicalExpression" || O.type === "NGPipeExpression" || O.type === "ConditionalExpression" || de(O) || ue(O) || O.type === "SequenceExpression" || O.type === "TaggedTemplateExpression" || O.type === "BindExpression" || O.type === "UpdateExpression" && !O.prefix || st(O) || O.type === "TSNonNullExpression";
            }
            function I(O) {
              var me, _e, He, Ge, it, Qe;
              return O.expressions ? O.expressions[0] : (me = (_e = (He = (Ge = (it = (Qe = O.left) !== null && Qe !== void 0 ? Qe : O.test) !== null && it !== void 0 ? it : O.callee) !== null && Ge !== void 0 ? Ge : O.object) !== null && He !== void 0 ? He : O.tag) !== null && _e !== void 0 ? _e : O.argument) !== null && me !== void 0 ? me : O.expression;
            }
            function P(O, me) {
              if (me.expressions)
                return ["expressions", 0];
              if (me.left)
                return ["left"];
              if (me.test)
                return ["test"];
              if (me.object)
                return ["object"];
              if (me.callee)
                return ["callee"];
              if (me.tag)
                return ["tag"];
              if (me.argument)
                return ["argument"];
              if (me.expression)
                return ["expression"];
              throw new Error("Unexpected node has no left side.");
            }
            function $(O) {
              return O = new Set(O), (me) => O.has(me == null ? void 0 : me.type);
            }
            var D = $(["Line", "CommentLine", "SingleLine", "HashbangComment", "HTMLOpen", "HTMLClose"]), T = $(["ExportDefaultDeclaration", "ExportDefaultSpecifier", "DeclareExportDeclaration", "ExportNamedDeclaration", "ExportAllDeclaration"]);
            function m(O) {
              let me = O.getParentNode();
              return O.getName() === "declaration" && T(me) ? me : null;
            }
            var C = $(["BooleanLiteral", "DirectiveLiteral", "Literal", "NullLiteral", "NumericLiteral", "BigIntLiteral", "DecimalLiteral", "RegExpLiteral", "StringLiteral", "TemplateLiteral", "TSTypeLiteral", "JSXText"]);
            function o(O) {
              return O.type === "NumericLiteral" || O.type === "Literal" && typeof O.value == "number";
            }
            function d(O) {
              return O.type === "UnaryExpression" && (O.operator === "+" || O.operator === "-") && o(O.argument);
            }
            function v(O) {
              return O.type === "StringLiteral" || O.type === "Literal" && typeof O.value == "string";
            }
            var S = $(["ObjectTypeAnnotation", "TSTypeLiteral", "TSMappedType"]), b = $(["FunctionExpression", "ArrowFunctionExpression"]);
            function B(O) {
              return O.type === "FunctionExpression" || O.type === "ArrowFunctionExpression" && O.body.type === "BlockStatement";
            }
            function k(O) {
              return de(O) && O.callee.type === "Identifier" && ["async", "inject", "fakeAsync", "waitForAsync"].includes(O.callee.name);
            }
            var M = $(["JSXElement", "JSXFragment"]);
            function R(O, me) {
              if (O.parentParser !== "markdown" && O.parentParser !== "mdx")
                return false;
              let _e = me.getNode();
              if (!_e.expression || !M(_e.expression))
                return false;
              let He = me.getParentNode();
              return He.type === "Program" && He.body.length === 1;
            }
            function q(O) {
              return O.kind === "get" || O.kind === "set";
            }
            function J(O) {
              return q(O) || h(O, O.value);
            }
            function L(O) {
              return (O.type === "ObjectTypeProperty" || O.type === "ObjectTypeInternalSlot") && O.value.type === "FunctionTypeAnnotation" && !O.static && !J(O);
            }
            function Q(O) {
              return (O.type === "TypeAnnotation" || O.type === "TSTypeAnnotation") && O.typeAnnotation.type === "FunctionTypeAnnotation" && !O.static && !h(O, O.typeAnnotation);
            }
            var V = $(["BinaryExpression", "LogicalExpression", "NGPipeExpression"]);
            function j(O) {
              return ue(O) || O.type === "BindExpression" && Boolean(O.object);
            }
            var Y = /* @__PURE__ */ new Set(["AnyTypeAnnotation", "TSAnyKeyword", "NullLiteralTypeAnnotation", "TSNullKeyword", "ThisTypeAnnotation", "TSThisType", "NumberTypeAnnotation", "TSNumberKeyword", "VoidTypeAnnotation", "TSVoidKeyword", "BooleanTypeAnnotation", "TSBooleanKeyword", "BigIntTypeAnnotation", "TSBigIntKeyword", "SymbolTypeAnnotation", "TSSymbolKeyword", "StringTypeAnnotation", "TSStringKeyword", "BooleanLiteralTypeAnnotation", "StringLiteralTypeAnnotation", "BigIntLiteralTypeAnnotation", "NumberLiteralTypeAnnotation", "TSLiteralType", "TSTemplateLiteralType", "EmptyTypeAnnotation", "MixedTypeAnnotation", "TSNeverKeyword", "TSObjectKeyword", "TSUndefinedKeyword", "TSUnknownKeyword"]);
            function ie(O) {
              return O ? !!((O.type === "GenericTypeAnnotation" || O.type === "TSTypeReference") && !O.typeParameters || Y.has(O.type)) : false;
            }
            function ee(O) {
              let me = /^(?:before|after)(?:Each|All)$/;
              return O.callee.type === "Identifier" && me.test(O.callee.name) && O.arguments.length === 1;
            }
            var ce = ["it", "it.only", "it.skip", "describe", "describe.only", "describe.skip", "test", "test.only", "test.skip", "test.step", "test.describe", "test.describe.only", "test.describe.parallel", "test.describe.parallel.only", "test.describe.serial", "test.describe.serial.only", "skip", "xit", "xdescribe", "xtest", "fit", "fdescribe", "ftest"];
            function W(O) {
              return c(O, ce);
            }
            function K(O, me) {
              if (O.type !== "CallExpression")
                return false;
              if (O.arguments.length === 1) {
                if (k(O) && me && K(me))
                  return b(O.arguments[0]);
                if (ee(O))
                  return k(O.arguments[0]);
              } else if ((O.arguments.length === 2 || O.arguments.length === 3) && (O.arguments[0].type === "TemplateLiteral" || v(O.arguments[0])) && W(O.callee))
                return O.arguments[2] && !o(O.arguments[2]) ? false : (O.arguments.length === 2 ? b(O.arguments[1]) : B(O.arguments[1]) && ve(O.arguments[1]).length <= 1) || k(O.arguments[1]);
              return false;
            }
            var de = $(["CallExpression", "OptionalCallExpression"]), ue = $(["MemberExpression", "OptionalMemberExpression"]);
            function Fe(O) {
              let me = "expressions";
              O.type === "TSTemplateLiteralType" && (me = "types");
              let _e = O[me];
              return _e.length === 0 ? false : _e.every((He) => {
                if (Me(He))
                  return false;
                if (He.type === "Identifier" || He.type === "ThisExpression")
                  return true;
                if (ue(He)) {
                  let Ge = He;
                  for (; ue(Ge); )
                    if (Ge.property.type !== "Identifier" && Ge.property.type !== "Literal" && Ge.property.type !== "StringLiteral" && Ge.property.type !== "NumericLiteral" || (Ge = Ge.object, Me(Ge)))
                      return false;
                  return Ge.type === "Identifier" || Ge.type === "ThisExpression";
                }
                return false;
              });
            }
            function z(O, me) {
              return O === "+" || O === "-" ? O + me : me;
            }
            function U(O, me) {
              let _e = p(me), He = n(O, y(me));
              return He !== false && O.slice(_e, _e + 2) === "/*" && O.slice(He, He + 2) === "*/";
            }
            function Z(O, me) {
              return M(me) ? Oe(me) : Me(me, Te.Leading, (_e) => a(O, y(_e)));
            }
            function se(O, me) {
              return me.parser !== "json" && v(O.key) && oe(O.key).slice(1, -1) === O.key.value && (t3(O.key.value) && !(me.parser === "babel-ts" && O.type === "ClassProperty" || me.parser === "typescript" && O.type === "PropertyDefinition") || fe(O.key.value) && String(Number(O.key.value)) === O.key.value && (me.parser === "babel" || me.parser === "acorn" || me.parser === "espree" || me.parser === "meriyah" || me.parser === "__babel_estree"));
            }
            function fe(O) {
              return /^(?:\d+|\d+\.\d+)$/.test(O);
            }
            function ge(O, me) {
              let _e = /^[fx]?(?:describe|it|test)$/;
              return me.type === "TaggedTemplateExpression" && me.quasi === O && me.tag.type === "MemberExpression" && me.tag.property.type === "Identifier" && me.tag.property.name === "each" && (me.tag.object.type === "Identifier" && _e.test(me.tag.object.name) || me.tag.object.type === "MemberExpression" && me.tag.object.property.type === "Identifier" && (me.tag.object.property.name === "only" || me.tag.object.property.name === "skip") && me.tag.object.object.type === "Identifier" && _e.test(me.tag.object.object.name));
            }
            function he(O) {
              return O.quasis.some((me) => me.value.raw.includes(`
`));
            }
            function we(O, me) {
              return (O.type === "TemplateLiteral" && he(O) || O.type === "TaggedTemplateExpression" && he(O.quasi)) && !a(me, p(O), { backwards: true });
            }
            function ke(O) {
              if (!Me(O))
                return false;
              let me = s(ae(O, Te.Dangling));
              return me && !g(me);
            }
            function Re(O) {
              if (O.length <= 1)
                return false;
              let me = 0;
              for (let _e of O)
                if (b(_e)) {
                  if (me += 1, me > 1)
                    return true;
                } else if (de(_e)) {
                  for (let He of _e.arguments)
                    if (b(He))
                      return true;
                }
              return false;
            }
            function Ne(O) {
              let me = O.getValue(), _e = O.getParentNode();
              return de(me) && de(_e) && _e.callee === me && me.arguments.length > _e.arguments.length && _e.arguments.length > 0;
            }
            function Pe(O, me) {
              if (me >= 2)
                return false;
              let _e = (Qe) => Pe(Qe, me + 1), He = O.type === "Literal" && "regex" in O && O.regex.pattern || O.type === "RegExpLiteral" && O.pattern;
              if (He && l(He) > 5)
                return false;
              if (O.type === "Literal" || O.type === "BigIntLiteral" || O.type === "DecimalLiteral" || O.type === "BooleanLiteral" || O.type === "NullLiteral" || O.type === "NumericLiteral" || O.type === "RegExpLiteral" || O.type === "StringLiteral" || O.type === "Identifier" || O.type === "ThisExpression" || O.type === "Super" || O.type === "PrivateName" || O.type === "PrivateIdentifier" || O.type === "ArgumentPlaceholder" || O.type === "Import")
                return true;
              if (O.type === "TemplateLiteral")
                return O.quasis.every((Qe) => !Qe.value.raw.includes(`
`)) && O.expressions.every(_e);
              if (O.type === "ObjectExpression")
                return O.properties.every((Qe) => !Qe.computed && (Qe.shorthand || Qe.value && _e(Qe.value)));
              if (O.type === "ArrayExpression")
                return O.elements.every((Qe) => Qe === null || _e(Qe));
              if (tt(O))
                return (O.type === "ImportExpression" || Pe(O.callee, me)) && Ye(O).every(_e);
              if (ue(O))
                return Pe(O.object, me) && Pe(O.property, me);
              let Ge = { "!": true, "-": true, "+": true, "~": true };
              if (O.type === "UnaryExpression" && Ge[O.operator])
                return Pe(O.argument, me);
              let it = { "++": true, "--": true };
              return O.type === "UpdateExpression" && it[O.operator] ? Pe(O.argument, me) : O.type === "TSNonNullExpression" ? Pe(O.expression, me) : false;
            }
            function oe(O) {
              var me, _e;
              return (me = (_e = O.extra) === null || _e === void 0 ? void 0 : _e.raw) !== null && me !== void 0 ? me : O.raw;
            }
            function H(O) {
              return O;
            }
            function pe(O) {
              return O.filepath && /\.tsx$/i.test(O.filepath);
            }
            function X(O) {
              let me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "es5";
              return O.trailingComma === "es5" && me === "es5" || O.trailingComma === "all" && (me === "all" || me === "es5");
            }
            function le(O, me) {
              switch (O.type) {
                case "BinaryExpression":
                case "LogicalExpression":
                case "AssignmentExpression":
                case "NGPipeExpression":
                  return le(O.left, me);
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return le(O.object, me);
                case "TaggedTemplateExpression":
                  return O.tag.type === "FunctionExpression" ? false : le(O.tag, me);
                case "CallExpression":
                case "OptionalCallExpression":
                  return O.callee.type === "FunctionExpression" ? false : le(O.callee, me);
                case "ConditionalExpression":
                  return le(O.test, me);
                case "UpdateExpression":
                  return !O.prefix && le(O.argument, me);
                case "BindExpression":
                  return O.object && le(O.object, me);
                case "SequenceExpression":
                  return le(O.expressions[0], me);
                case "TSSatisfiesExpression":
                case "TSAsExpression":
                case "TSNonNullExpression":
                  return le(O.expression, me);
                default:
                  return me(O);
              }
            }
            var Ae = { "==": true, "!=": true, "===": true, "!==": true }, Ee = { "*": true, "/": true, "%": true }, De = { ">>": true, ">>>": true, "<<": true };
            function A(O, me) {
              return !(re(me) !== re(O) || O === "**" || Ae[O] && Ae[me] || me === "%" && Ee[O] || O === "%" && Ee[me] || me !== O && Ee[me] && Ee[O] || De[O] && De[me]);
            }
            var G = new Map([["|>"], ["??"], ["||"], ["&&"], ["|"], ["^"], ["&"], ["==", "===", "!=", "!=="], ["<", ">", "<=", ">=", "in", "instanceof"], [">>", "<<", ">>>"], ["+", "-"], ["*", "/", "%"], ["**"]].flatMap((O, me) => O.map((_e) => [_e, me])));
            function re(O) {
              return G.get(O);
            }
            function ye(O) {
              return Boolean(De[O]) || O === "|" || O === "^" || O === "&";
            }
            function Ce(O) {
              var me;
              if (O.rest)
                return true;
              let _e = ve(O);
              return ((me = s(_e)) === null || me === void 0 ? void 0 : me.type) === "RestElement";
            }
            var Be = /* @__PURE__ */ new WeakMap();
            function ve(O) {
              if (Be.has(O))
                return Be.get(O);
              let me = [];
              return O.this && me.push(O.this), Array.isArray(O.parameters) ? me.push(...O.parameters) : Array.isArray(O.params) && me.push(...O.params), O.rest && me.push(O.rest), Be.set(O, me), me;
            }
            function ze(O, me) {
              let _e = O.getValue(), He = 0, Ge = (it) => me(it, He++);
              _e.this && O.call(Ge, "this"), Array.isArray(_e.parameters) ? O.each(Ge, "parameters") : Array.isArray(_e.params) && O.each(Ge, "params"), _e.rest && O.call(Ge, "rest");
            }
            var be = /* @__PURE__ */ new WeakMap();
            function Ye(O) {
              if (be.has(O))
                return be.get(O);
              let me = O.arguments;
              return O.type === "ImportExpression" && (me = [O.source], O.attributes && me.push(O.attributes)), be.set(O, me), me;
            }
            function Se(O, me) {
              let _e = O.getValue();
              _e.type === "ImportExpression" ? (O.call((He) => me(He, 0), "source"), _e.attributes && O.call((He) => me(He, 1), "attributes")) : O.each(me, "arguments");
            }
            function Ie(O) {
              return O.value.trim() === "prettier-ignore" && !O.unignore;
            }
            function Oe(O) {
              return O && (O.prettierIgnore || Me(O, Te.PrettierIgnore));
            }
            function Je(O) {
              let me = O.getValue();
              return Oe(me);
            }
            var Te = { Leading: 1 << 1, Trailing: 1 << 2, Dangling: 1 << 3, Block: 1 << 4, Line: 1 << 5, PrettierIgnore: 1 << 6, First: 1 << 7, Last: 1 << 8 }, je = (O, me) => {
              if (typeof O == "function" && (me = O, O = 0), O || me)
                return (_e, He, Ge) => !(O & Te.Leading && !_e.leading || O & Te.Trailing && !_e.trailing || O & Te.Dangling && (_e.leading || _e.trailing) || O & Te.Block && !g(_e) || O & Te.Line && !D(_e) || O & Te.First && He !== 0 || O & Te.Last && He !== Ge.length - 1 || O & Te.PrettierIgnore && !Ie(_e) || me && !me(_e));
            };
            function Me(O, me, _e) {
              if (!u(O == null ? void 0 : O.comments))
                return false;
              let He = je(me, _e);
              return He ? O.comments.some(He) : true;
            }
            function ae(O, me, _e) {
              if (!Array.isArray(O == null ? void 0 : O.comments))
                return [];
              let He = je(me, _e);
              return He ? O.comments.filter(He) : O.comments;
            }
            var nt = (O, me) => {
              let { originalText: _e } = me;
              return i(_e, y(O));
            };
            function tt(O) {
              return de(O) || O.type === "NewExpression" || O.type === "ImportExpression";
            }
            function Ve(O) {
              return O && (O.type === "ObjectProperty" || O.type === "Property" && !O.method && O.kind === "init");
            }
            function We(O) {
              return Boolean(O.__isUsingHackPipeline);
            }
            var Xe = Symbol("ifWithoutBlockAndSameLineComment");
            function st(O) {
              return O.type === "TSAsExpression" || O.type === "TSSatisfiesExpression";
            }
            r.exports = { getFunctionParameters: ve, iterateFunctionParametersPath: ze, getCallArguments: Ye, iterateCallArgumentsPath: Se, hasRestParameter: Ce, getLeftSide: I, getLeftSidePathName: P, getParentExportDeclaration: m, getTypeScriptMappedTypeModifier: z, hasFlowAnnotationComment: E, hasFlowShorthandAnnotationComment: w, hasLeadingOwnLineComment: Z, hasNakedLeftSide: x, hasNode: N, hasIgnoreComment: Je, hasNodeIgnoreComment: Oe, identity: H, isBinaryish: V, isCallLikeExpression: tt, isEnabledHackPipeline: We, isLineComment: D, isPrettierIgnoreComment: Ie, isCallExpression: de, isMemberExpression: ue, isExportDeclaration: T, isFlowAnnotationComment: U, isFunctionCompositionArgs: Re, isFunctionNotation: J, isFunctionOrArrowExpression: b, isGetterOrSetter: q, isJestEachTemplateLiteral: ge, isJsxNode: M, isLiteral: C, isLongCurriedCallExpression: Ne, isSimpleCallArgument: Pe, isMemberish: j, isNumericLiteral: o, isSignedNumericLiteral: d, isObjectProperty: Ve, isObjectType: S, isObjectTypePropertyAFunction: L, isSimpleType: ie, isSimpleNumber: fe, isSimpleTemplateLiteral: Fe, isStringLiteral: v, isStringPropSafeToUnquote: se, isTemplateOnItsOwnLine: we, isTestCall: K, isTheOnlyJsxElementInMarkdown: R, isTSXFile: pe, isTypeAnnotationAFunction: Q, isNextLineEmpty: nt, needsHardlineAfterDanglingComment: ke, rawText: oe, shouldPrintComma: X, isBitwiseOperator: ye, shouldFlatten: A, startsWithNoLookaheadToken: le, getPrecedence: re, hasComment: Me, getComments: ae, CommentCheckFlags: Te, markerForIfWithoutBlockAndSameLineComment: Xe, isTSTypeExpression: st };
          } }), jt = te({ "src/language-js/print/template-literal.js"(e, r) {
            "use strict";
            ne();
            var t3 = lt2(), { getStringWidth: s, getIndentSize: a } = Ue(), { builders: { join: n, hardline: u, softline: i, group: l, indent: p, align: y, lineSuffixBoundary: h, addAlignmentToDoc: g }, printer: { printDocToString: c }, utils: { mapDoc: f } } = qe(), { isBinaryish: F, isJestEachTemplateLiteral: _, isSimpleTemplateLiteral: w, hasComment: E, isMemberExpression: N, isTSTypeExpression: x } = Ke();
            function I(C, o, d) {
              let v = C.getValue();
              if (v.type === "TemplateLiteral" && _(v, C.getParentNode())) {
                let R = P(C, d, o);
                if (R)
                  return R;
              }
              let b = "expressions";
              v.type === "TSTemplateLiteralType" && (b = "types");
              let B = [], k = C.map(o, b), M = w(v);
              return M && (k = k.map((R) => c(R, Object.assign(Object.assign({}, d), {}, { printWidth: Number.POSITIVE_INFINITY })).formatted)), B.push(h, "`"), C.each((R) => {
                let q = R.getName();
                if (B.push(o()), q < k.length) {
                  let { tabWidth: J } = d, L = R.getValue(), Q = a(L.value.raw, J), V = k[q];
                  if (!M) {
                    let Y = v[b][q];
                    (E(Y) || N(Y) || Y.type === "ConditionalExpression" || Y.type === "SequenceExpression" || x(Y) || F(Y)) && (V = [p([i, V]), i]);
                  }
                  let j = Q === 0 && L.value.raw.endsWith(`
`) ? y(Number.NEGATIVE_INFINITY, V) : g(V, Q, J);
                  B.push(l(["${", j, h, "}"]));
                }
              }, "quasis"), B.push("`"), B;
            }
            function P(C, o, d) {
              let v = C.getNode(), S = v.quasis[0].value.raw.trim().split(/\s*\|\s*/);
              if (S.length > 1 || S.some((b) => b.length > 0)) {
                o.__inJestEach = true;
                let b = C.map(d, "expressions");
                o.__inJestEach = false;
                let B = [], k = b.map((L) => "${" + c(L, Object.assign(Object.assign({}, o), {}, { printWidth: Number.POSITIVE_INFINITY, endOfLine: "lf" })).formatted + "}"), M = [{ hasLineBreak: false, cells: [] }];
                for (let L = 1; L < v.quasis.length; L++) {
                  let Q = t3(M), V = k[L - 1];
                  Q.cells.push(V), V.includes(`
`) && (Q.hasLineBreak = true), v.quasis[L].value.raw.includes(`
`) && M.push({ hasLineBreak: false, cells: [] });
                }
                let R = Math.max(S.length, ...M.map((L) => L.cells.length)), q = Array.from({ length: R }).fill(0), J = [{ cells: S }, ...M.filter((L) => L.cells.length > 0)];
                for (let { cells: L } of J.filter((Q) => !Q.hasLineBreak))
                  for (let [Q, V] of L.entries())
                    q[Q] = Math.max(q[Q], s(V));
                return B.push(h, "`", p([u, n(u, J.map((L) => n(" | ", L.cells.map((Q, V) => L.hasLineBreak ? Q : Q + " ".repeat(q[V] - s(Q))))))]), u, "`"), B;
              }
            }
            function $(C, o) {
              let d = C.getValue(), v = o();
              return E(d) && (v = l([p([i, v]), i])), ["${", v, h, "}"];
            }
            function D(C, o) {
              return C.map((d) => $(d, o), "expressions");
            }
            function T(C, o) {
              return f(C, (d) => typeof d == "string" ? o ? d.replace(/(\\*)`/g, "$1$1\\`") : m(d) : d);
            }
            function m(C) {
              return C.replace(/([\\`]|\${)/g, "\\$1");
            }
            r.exports = { printTemplateLiteral: I, printTemplateExpressions: D, escapeTemplateCharacters: T, uncookTemplateElementValue: m };
          } }), Ym = te({ "src/language-js/embed/markdown.js"(e, r) {
            "use strict";
            ne();
            var { builders: { indent: t3, softline: s, literalline: a, dedentToRoot: n } } = qe(), { escapeTemplateCharacters: u } = jt();
            function i(p, y, h) {
              let c = p.getValue().quasis[0].value.raw.replace(/((?:\\\\)*)\\`/g, (w, E) => "\\".repeat(E.length / 2) + "`"), f = l(c), F = f !== "";
              F && (c = c.replace(new RegExp(`^${f}`, "gm"), ""));
              let _ = u(h(c, { parser: "markdown", __inJsTemplate: true }, { stripTrailingHardline: true }), true);
              return ["`", F ? t3([s, _]) : [a, n(_)], s, "`"];
            }
            function l(p) {
              let y = p.match(/^([^\S\n]*)\S/m);
              return y === null ? "" : y[1];
            }
            r.exports = i;
          } }), Qm = te({ "src/language-js/embed/css.js"(e, r) {
            "use strict";
            ne();
            var { isNonEmptyArray: t3 } = Ue(), { builders: { indent: s, hardline: a, softline: n }, utils: { mapDoc: u, replaceEndOfLine: i, cleanDoc: l } } = qe(), { printTemplateExpressions: p } = jt();
            function y(c, f, F) {
              let _ = c.getValue(), w = _.quasis.map((P) => P.value.raw), E = 0, N = w.reduce((P, $, D) => D === 0 ? $ : P + "@prettier-placeholder-" + E++ + "-id" + $, ""), x = F(N, { parser: "scss" }, { stripTrailingHardline: true }), I = p(c, f);
              return h(x, _, I);
            }
            function h(c, f, F) {
              if (f.quasis.length === 1 && !f.quasis[0].value.raw.trim())
                return "``";
              let w = g(c, F);
              if (!w)
                throw new Error("Couldn't insert all the expressions");
              return ["`", s([a, w]), n, "`"];
            }
            function g(c, f) {
              if (!t3(f))
                return c;
              let F = 0, _ = u(l(c), (w) => typeof w != "string" || !w.includes("@prettier-placeholder") ? w : w.split(/@prettier-placeholder-(\d+)-id/).map((E, N) => N % 2 === 0 ? i(E) : (F++, f[E])));
              return f.length === F ? _ : null;
            }
            r.exports = y;
          } }), Zm = te({ "src/language-js/embed/graphql.js"(e, r) {
            "use strict";
            ne();
            var { builders: { indent: t3, join: s, hardline: a } } = qe(), { escapeTemplateCharacters: n, printTemplateExpressions: u } = jt();
            function i(p, y, h) {
              let g = p.getValue(), c = g.quasis.length;
              if (c === 1 && g.quasis[0].value.raw.trim() === "")
                return "``";
              let f = u(p, y), F = [];
              for (let _ = 0; _ < c; _++) {
                let w = g.quasis[_], E = _ === 0, N = _ === c - 1, x = w.value.cooked, I = x.split(`
`), P = I.length, $ = f[_], D = P > 2 && I[0].trim() === "" && I[1].trim() === "", T = P > 2 && I[P - 1].trim() === "" && I[P - 2].trim() === "", m = I.every((o) => /^\s*(?:#[^\n\r]*)?$/.test(o));
                if (!N && /#[^\n\r]*$/.test(I[P - 1]))
                  return null;
                let C = null;
                m ? C = l(I) : C = h(x, { parser: "graphql" }, { stripTrailingHardline: true }), C ? (C = n(C, false), !E && D && F.push(""), F.push(C), !N && T && F.push("")) : !E && !N && D && F.push(""), $ && F.push($);
              }
              return ["`", t3([a, s(a, F)]), a, "`"];
            }
            function l(p) {
              let y = [], h = false, g = p.map((c) => c.trim());
              for (let [c, f] of g.entries())
                f !== "" && (g[c - 1] === "" && h ? y.push([a, f]) : y.push(f), h = true);
              return y.length === 0 ? null : s(a, y);
            }
            r.exports = i;
          } }), ed = te({ "src/language-js/embed/html.js"(e, r) {
            "use strict";
            ne();
            var { builders: { indent: t3, line: s, hardline: a, group: n }, utils: { mapDoc: u } } = qe(), { printTemplateExpressions: i, uncookTemplateElementValue: l } = jt(), p = 0;
            function y(h, g, c, f, F) {
              let { parser: _ } = F, w = h.getValue(), E = p;
              p = p + 1 >>> 0;
              let N = (d) => `PRETTIER_HTML_PLACEHOLDER_${d}_${E}_IN_JS`, x = w.quasis.map((d, v, S) => v === S.length - 1 ? d.value.cooked : d.value.cooked + N(v)).join(""), I = i(h, g);
              if (I.length === 0 && x.trim().length === 0)
                return "``";
              let P = new RegExp(N("(\\d+)"), "g"), $ = 0, D = c(x, { parser: _, __onHtmlRoot(d) {
                $ = d.children.length;
              } }, { stripTrailingHardline: true }), T = u(D, (d) => {
                if (typeof d != "string")
                  return d;
                let v = [], S = d.split(P);
                for (let b = 0; b < S.length; b++) {
                  let B = S[b];
                  if (b % 2 === 0) {
                    B && (B = l(B), f.__embeddedInHtml && (B = B.replace(/<\/(script)\b/gi, "<\\/$1")), v.push(B));
                    continue;
                  }
                  let k = Number(B);
                  v.push(I[k]);
                }
                return v;
              }), m = /^\s/.test(x) ? " " : "", C = /\s$/.test(x) ? " " : "", o = f.htmlWhitespaceSensitivity === "ignore" ? a : m && C ? s : null;
              return n(o ? ["`", t3([o, n(T)]), o, "`"] : ["`", m, $ > 1 ? t3(n(T)) : n(T), C, "`"]);
            }
            r.exports = y;
          } }), td = te({ "src/language-js/embed.js"(e, r) {
            "use strict";
            ne();
            var { hasComment: t3, CommentCheckFlags: s, isObjectProperty: a } = Ke(), n = Ym(), u = Qm(), i = Zm(), l = ed();
            function p(D) {
              if (g(D) || _(D) || w(D) || c(D))
                return "css";
              if (x(D))
                return "graphql";
              if (P(D))
                return "html";
              if (f(D))
                return "angular";
              if (h(D))
                return "markdown";
            }
            function y(D, T, m, C) {
              let o = D.getValue();
              if (o.type !== "TemplateLiteral" || $(o))
                return;
              let d = p(D);
              if (d) {
                if (d === "markdown")
                  return n(D, T, m);
                if (d === "css")
                  return u(D, T, m);
                if (d === "graphql")
                  return i(D, T, m);
                if (d === "html" || d === "angular")
                  return l(D, T, m, C, { parser: d });
              }
            }
            function h(D) {
              let T = D.getValue(), m = D.getParentNode();
              return m && m.type === "TaggedTemplateExpression" && T.quasis.length === 1 && m.tag.type === "Identifier" && (m.tag.name === "md" || m.tag.name === "markdown");
            }
            function g(D) {
              let T = D.getValue(), m = D.getParentNode(), C = D.getParentNode(1);
              return C && T.quasis && m.type === "JSXExpressionContainer" && C.type === "JSXElement" && C.openingElement.name.name === "style" && C.openingElement.attributes.some((o) => o.name.name === "jsx") || m && m.type === "TaggedTemplateExpression" && m.tag.type === "Identifier" && m.tag.name === "css" || m && m.type === "TaggedTemplateExpression" && m.tag.type === "MemberExpression" && m.tag.object.name === "css" && (m.tag.property.name === "global" || m.tag.property.name === "resolve");
            }
            function c(D) {
              return D.match((T) => T.type === "TemplateLiteral", (T, m) => T.type === "ArrayExpression" && m === "elements", (T, m) => a(T) && T.key.type === "Identifier" && T.key.name === "styles" && m === "value", ...F);
            }
            function f(D) {
              return D.match((T) => T.type === "TemplateLiteral", (T, m) => a(T) && T.key.type === "Identifier" && T.key.name === "template" && m === "value", ...F);
            }
            var F = [(D, T) => D.type === "ObjectExpression" && T === "properties", (D, T) => D.type === "CallExpression" && D.callee.type === "Identifier" && D.callee.name === "Component" && T === "arguments", (D, T) => D.type === "Decorator" && T === "expression"];
            function _(D) {
              let T = D.getParentNode();
              if (!T || T.type !== "TaggedTemplateExpression")
                return false;
              let m = T.tag.type === "ParenthesizedExpression" ? T.tag.expression : T.tag;
              switch (m.type) {
                case "MemberExpression":
                  return E(m.object) || N(m);
                case "CallExpression":
                  return E(m.callee) || m.callee.type === "MemberExpression" && (m.callee.object.type === "MemberExpression" && (E(m.callee.object.object) || N(m.callee.object)) || m.callee.object.type === "CallExpression" && E(m.callee.object.callee));
                case "Identifier":
                  return m.name === "css";
                default:
                  return false;
              }
            }
            function w(D) {
              let T = D.getParentNode(), m = D.getParentNode(1);
              return m && T.type === "JSXExpressionContainer" && m.type === "JSXAttribute" && m.name.type === "JSXIdentifier" && m.name.name === "css";
            }
            function E(D) {
              return D.type === "Identifier" && D.name === "styled";
            }
            function N(D) {
              return /^[A-Z]/.test(D.object.name) && D.property.name === "extend";
            }
            function x(D) {
              let T = D.getValue(), m = D.getParentNode();
              return I(T, "GraphQL") || m && (m.type === "TaggedTemplateExpression" && (m.tag.type === "MemberExpression" && m.tag.object.name === "graphql" && m.tag.property.name === "experimental" || m.tag.type === "Identifier" && (m.tag.name === "gql" || m.tag.name === "graphql")) || m.type === "CallExpression" && m.callee.type === "Identifier" && m.callee.name === "graphql");
            }
            function I(D, T) {
              return t3(D, s.Block | s.Leading, (m) => {
                let { value: C } = m;
                return C === ` ${T} `;
              });
            }
            function P(D) {
              return I(D.getValue(), "HTML") || D.match((T) => T.type === "TemplateLiteral", (T, m) => T.type === "TaggedTemplateExpression" && T.tag.type === "Identifier" && T.tag.name === "html" && m === "quasi");
            }
            function $(D) {
              let { quasis: T } = D;
              return T.some((m) => {
                let { value: { cooked: C } } = m;
                return C === null;
              });
            }
            r.exports = y;
          } }), rd = te({ "src/language-js/clean.js"(e, r) {
            "use strict";
            ne();
            var t3 = Pt(), s = /* @__PURE__ */ new Set(["range", "raw", "comments", "leadingComments", "trailingComments", "innerComments", "extra", "start", "end", "loc", "flags", "errors", "tokens"]), a = (u) => {
              for (let i of u.quasis)
                delete i.value;
            };
            function n(u, i, l) {
              if (u.type === "Program" && delete i.sourceType, (u.type === "BigIntLiteral" || u.type === "BigIntLiteralTypeAnnotation") && i.value && (i.value = i.value.toLowerCase()), (u.type === "BigIntLiteral" || u.type === "Literal") && i.bigint && (i.bigint = i.bigint.toLowerCase()), u.type === "DecimalLiteral" && (i.value = Number(i.value)), u.type === "Literal" && i.decimal && (i.decimal = Number(i.decimal)), u.type === "EmptyStatement" || u.type === "JSXText" || u.type === "JSXExpressionContainer" && (u.expression.type === "Literal" || u.expression.type === "StringLiteral") && u.expression.value === " ")
                return null;
              if ((u.type === "Property" || u.type === "ObjectProperty" || u.type === "MethodDefinition" || u.type === "ClassProperty" || u.type === "ClassMethod" || u.type === "PropertyDefinition" || u.type === "TSDeclareMethod" || u.type === "TSPropertySignature" || u.type === "ObjectTypeProperty") && typeof u.key == "object" && u.key && (u.key.type === "Literal" || u.key.type === "NumericLiteral" || u.key.type === "StringLiteral" || u.key.type === "Identifier") && delete i.key, u.type === "JSXElement" && u.openingElement.name.name === "style" && u.openingElement.attributes.some((h) => h.name.name === "jsx"))
                for (let { type: h, expression: g } of i.children)
                  h === "JSXExpressionContainer" && g.type === "TemplateLiteral" && a(g);
              u.type === "JSXAttribute" && u.name.name === "css" && u.value.type === "JSXExpressionContainer" && u.value.expression.type === "TemplateLiteral" && a(i.value.expression), u.type === "JSXAttribute" && u.value && u.value.type === "Literal" && /["']|&quot;|&apos;/.test(u.value.value) && (i.value.value = i.value.value.replace(/["']|&quot;|&apos;/g, '"'));
              let p = u.expression || u.callee;
              if (u.type === "Decorator" && p.type === "CallExpression" && p.callee.name === "Component" && p.arguments.length === 1) {
                let h = u.expression.arguments[0].properties;
                for (let [g, c] of i.expression.arguments[0].properties.entries())
                  switch (h[g].key.name) {
                    case "styles":
                      c.value.type === "ArrayExpression" && a(c.value.elements[0]);
                      break;
                    case "template":
                      c.value.type === "TemplateLiteral" && a(c.value);
                      break;
                  }
              }
              if (u.type === "TaggedTemplateExpression" && (u.tag.type === "MemberExpression" || u.tag.type === "Identifier" && (u.tag.name === "gql" || u.tag.name === "graphql" || u.tag.name === "css" || u.tag.name === "md" || u.tag.name === "markdown" || u.tag.name === "html") || u.tag.type === "CallExpression") && a(i.quasi), u.type === "TemplateLiteral") {
                var y;
                (((y = u.leadingComments) === null || y === void 0 ? void 0 : y.some((g) => t3(g) && ["GraphQL", "HTML"].some((c) => g.value === ` ${c} `))) || l.type === "CallExpression" && l.callee.name === "graphql" || !u.leadingComments) && a(i);
              }
              if (u.type === "InterpreterDirective" && (i.value = i.value.trimEnd()), (u.type === "TSIntersectionType" || u.type === "TSUnionType") && u.types.length === 1)
                return i.types[0];
            }
            n.ignoredProperties = s, r.exports = n;
          } }), io = {};
          Kt(io, { EOL: () => Wn, arch: () => nd, cpus: () => Do, default: () => vo, endianness: () => ao, freemem: () => po, getNetworkInterfaces: () => ho, hostname: () => oo, loadavg: () => lo, networkInterfaces: () => yo, platform: () => ud, release: () => go, tmpDir: () => $n, tmpdir: () => Vn, totalmem: () => fo, type: () => mo, uptime: () => co });
          function ao() {
            if (typeof Tr > "u") {
              var e = new ArrayBuffer(2), r = new Uint8Array(e), t3 = new Uint16Array(e);
              if (r[0] = 1, r[1] = 2, t3[0] === 258)
                Tr = "BE";
              else if (t3[0] === 513)
                Tr = "LE";
              else
                throw new Error("unable to figure out endianess");
            }
            return Tr;
          }
          function oo() {
            return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
          }
          function lo() {
            return [];
          }
          function co() {
            return 0;
          }
          function po() {
            return Number.MAX_VALUE;
          }
          function fo() {
            return Number.MAX_VALUE;
          }
          function Do() {
            return [];
          }
          function mo() {
            return "Browser";
          }
          function go() {
            return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
          }
          function yo() {
          }
          function ho() {
          }
          function nd() {
            return "javascript";
          }
          function ud() {
            return "browser";
          }
          function $n() {
            return "/tmp";
          }
          var Tr, Vn, Wn, vo, sd = ht({ "node-modules-polyfills:os"() {
            ne(), Vn = $n, Wn = `
`, vo = { EOL: Wn, tmpdir: Vn, tmpDir: $n, networkInterfaces: yo, getNetworkInterfaces: ho, release: go, type: mo, cpus: Do, totalmem: fo, freemem: po, uptime: co, loadavg: lo, hostname: oo, endianness: ao };
          } }), id = te({ "node-modules-polyfills-commonjs:os"(e, r) {
            ne();
            var t3 = (sd(), ft(io));
            if (t3 && t3.default) {
              r.exports = t3.default;
              for (let s in t3)
                r.exports[s] = t3[s];
            } else
              t3 && (r.exports = t3);
          } }), ad = te({ "node_modules/detect-newline/index.js"(e, r) {
            "use strict";
            ne();
            var t3 = (s) => {
              if (typeof s != "string")
                throw new TypeError("Expected a string");
              let a = s.match(/(?:\r?\n)/g) || [];
              if (a.length === 0)
                return;
              let n = a.filter((i) => i === `\r
`).length, u = a.length - n;
              return n > u ? `\r
` : `
`;
            };
            r.exports = t3, r.exports.graceful = (s) => typeof s == "string" && t3(s) || `
`;
          } }), od = te({ "node_modules/jest-docblock/build/index.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true }), e.extract = c, e.parse = F, e.parseWithComments = _, e.print = w, e.strip = f;
            function r() {
              let N = id();
              return r = function() {
                return N;
              }, N;
            }
            function t3() {
              let N = s(ad());
              return t3 = function() {
                return N;
              }, N;
            }
            function s(N) {
              return N && N.__esModule ? N : { default: N };
            }
            var a = /\*\/$/, n = /^\/\*\*?/, u = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, i = /(^|\s+)\/\/([^\r\n]*)/g, l = /^(\r?\n)+/, p = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, y = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, h = /(\r?\n|^) *\* ?/g, g = [];
            function c(N) {
              let x = N.match(u);
              return x ? x[0].trimLeft() : "";
            }
            function f(N) {
              let x = N.match(u);
              return x && x[0] ? N.substring(x[0].length) : N;
            }
            function F(N) {
              return _(N).pragmas;
            }
            function _(N) {
              let x = (0, t3().default)(N) || r().EOL;
              N = N.replace(n, "").replace(a, "").replace(h, "$1");
              let I = "";
              for (; I !== N; )
                I = N, N = N.replace(p, `${x}$1 $2${x}`);
              N = N.replace(l, "").trimRight();
              let P = /* @__PURE__ */ Object.create(null), $ = N.replace(y, "").replace(l, "").trimRight(), D;
              for (; D = y.exec(N); ) {
                let T = D[2].replace(i, "");
                typeof P[D[1]] == "string" || Array.isArray(P[D[1]]) ? P[D[1]] = g.concat(P[D[1]], T) : P[D[1]] = T;
              }
              return { comments: $, pragmas: P };
            }
            function w(N) {
              let { comments: x = "", pragmas: I = {} } = N, P = (0, t3().default)(x) || r().EOL, $ = "/**", D = " *", T = " */", m = Object.keys(I), C = m.map((d) => E(d, I[d])).reduce((d, v) => d.concat(v), []).map((d) => `${D} ${d}${P}`).join("");
              if (!x) {
                if (m.length === 0)
                  return "";
                if (m.length === 1 && !Array.isArray(I[m[0]])) {
                  let d = I[m[0]];
                  return `${$} ${E(m[0], d)[0]}${T}`;
                }
              }
              let o = x.split(P).map((d) => `${D} ${d}`).join(P) + P;
              return $ + P + (x ? o : "") + (x && m.length ? D + P : "") + C + T;
            }
            function E(N, x) {
              return g.concat(x).map((I) => `@${N} ${I}`.trim());
            }
          } }), ld = te({ "src/language-js/utils/get-shebang.js"(e, r) {
            "use strict";
            ne();
            function t3(s) {
              if (!s.startsWith("#!"))
                return "";
              let a = s.indexOf(`
`);
              return a === -1 ? s : s.slice(0, a);
            }
            r.exports = t3;
          } }), Co = te({ "src/language-js/pragma.js"(e, r) {
            "use strict";
            ne();
            var { parseWithComments: t3, strip: s, extract: a, print: n } = od(), { normalizeEndOfLine: u } = Jn(), i = ld();
            function l(h) {
              let g = i(h);
              g && (h = h.slice(g.length + 1));
              let c = a(h), { pragmas: f, comments: F } = t3(c);
              return { shebang: g, text: h, pragmas: f, comments: F };
            }
            function p(h) {
              let g = Object.keys(l(h).pragmas);
              return g.includes("prettier") || g.includes("format");
            }
            function y(h) {
              let { shebang: g, text: c, pragmas: f, comments: F } = l(h), _ = s(c), w = n({ pragmas: Object.assign({ format: "" }, f), comments: F.trimStart() });
              return (g ? `${g}
` : "") + u(w) + (_.startsWith(`
`) ? `
` : `

`) + _;
            }
            r.exports = { hasPragma: p, insertPragma: y };
          } }), cd = te({ "src/language-js/utils/is-type-cast-comment.js"(e, r) {
            "use strict";
            ne();
            var t3 = Pt();
            function s(a) {
              return t3(a) && a.value[0] === "*" && /@(?:type|satisfies)\b/.test(a.value);
            }
            r.exports = s;
          } }), Eo = te({ "src/language-js/comments.js"(e, r) {
            "use strict";
            ne();
            var { getLast: t3, hasNewline: s, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: a, getNextNonSpaceNonCommentCharacter: n, hasNewlineInRange: u, addLeadingComment: i, addTrailingComment: l, addDanglingComment: p, getNextNonSpaceNonCommentCharacterIndex: y, isNonEmptyArray: h } = Ue(), { getFunctionParameters: g, isPrettierIgnoreComment: c, isJsxNode: f, hasFlowShorthandAnnotationComment: F, hasFlowAnnotationComment: _, hasIgnoreComment: w, isCallLikeExpression: E, getCallArguments: N, isCallExpression: x, isMemberExpression: I, isObjectProperty: P, isLineComment: $, getComments: D, CommentCheckFlags: T, markerForIfWithoutBlockAndSameLineComment: m } = Ke(), { locStart: C, locEnd: o } = ut(), d = Pt(), v = cd();
            function S(De) {
              return [H, Fe, Q, q, J, L, ie, he, se, ge, we, ke, ce, z, U].some((A) => A(De));
            }
            function b(De) {
              return [R, Fe, V, we, q, J, L, ie, z, Z, fe, ge, Pe, U, X].some((A) => A(De));
            }
            function B(De) {
              return [H, q, J, j, ue, ce, ge, de, K, pe, U, oe].some((A) => A(De));
            }
            function k(De, A) {
              let G = (De.body || De.properties).find((re) => {
                let { type: ye } = re;
                return ye !== "EmptyStatement";
              });
              G ? i(G, A) : p(De, A);
            }
            function M(De, A) {
              De.type === "BlockStatement" ? k(De, A) : i(De, A);
            }
            function R(De) {
              let { comment: A, followingNode: G } = De;
              return G && v(A) ? (i(G, A), true) : false;
            }
            function q(De) {
              let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye, text: Ce } = De;
              if ((re == null ? void 0 : re.type) !== "IfStatement" || !ye)
                return false;
              if (n(Ce, A, o) === ")")
                return l(G, A), true;
              if (G === re.consequent && ye === re.alternate) {
                if (G.type === "BlockStatement")
                  l(G, A);
                else {
                  let ve = A.type === "SingleLine" || A.loc.start.line === A.loc.end.line, ze = A.loc.start.line === G.loc.start.line;
                  ve && ze ? p(G, A, m) : p(re, A);
                }
                return true;
              }
              return ye.type === "BlockStatement" ? (k(ye, A), true) : ye.type === "IfStatement" ? (M(ye.consequent, A), true) : re.consequent === ye ? (i(ye, A), true) : false;
            }
            function J(De) {
              let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye, text: Ce } = De;
              return (re == null ? void 0 : re.type) !== "WhileStatement" || !ye ? false : n(Ce, A, o) === ")" ? (l(G, A), true) : ye.type === "BlockStatement" ? (k(ye, A), true) : re.body === ye ? (i(ye, A), true) : false;
            }
            function L(De) {
              let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye } = De;
              return (re == null ? void 0 : re.type) !== "TryStatement" && (re == null ? void 0 : re.type) !== "CatchClause" || !ye ? false : re.type === "CatchClause" && G ? (l(G, A), true) : ye.type === "BlockStatement" ? (k(ye, A), true) : ye.type === "TryStatement" ? (M(ye.finalizer, A), true) : ye.type === "CatchClause" ? (M(ye.body, A), true) : false;
            }
            function Q(De) {
              let { comment: A, enclosingNode: G, followingNode: re } = De;
              return I(G) && (re == null ? void 0 : re.type) === "Identifier" ? (i(G, A), true) : false;
            }
            function V(De) {
              let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye, text: Ce } = De, Be = G && !u(Ce, o(G), C(A));
              return (!G || !Be) && ((re == null ? void 0 : re.type) === "ConditionalExpression" || (re == null ? void 0 : re.type) === "TSConditionalType") && ye ? (i(ye, A), true) : false;
            }
            function j(De) {
              let { comment: A, precedingNode: G, enclosingNode: re } = De;
              return P(re) && re.shorthand && re.key === G && re.value.type === "AssignmentPattern" ? (l(re.value.left, A), true) : false;
            }
            var Y = /* @__PURE__ */ new Set(["ClassDeclaration", "ClassExpression", "DeclareClass", "DeclareInterface", "InterfaceDeclaration", "TSInterfaceDeclaration"]);
            function ie(De) {
              let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye } = De;
              if (Y.has(re == null ? void 0 : re.type)) {
                if (h(re.decorators) && !(ye && ye.type === "Decorator"))
                  return l(t3(re.decorators), A), true;
                if (re.body && ye === re.body)
                  return k(re.body, A), true;
                if (ye) {
                  if (re.superClass && ye === re.superClass && G && (G === re.id || G === re.typeParameters))
                    return l(G, A), true;
                  for (let Ce of ["implements", "extends", "mixins"])
                    if (re[Ce] && ye === re[Ce][0])
                      return G && (G === re.id || G === re.typeParameters || G === re.superClass) ? l(G, A) : p(re, A, Ce), true;
                }
              }
              return false;
            }
            var ee = /* @__PURE__ */ new Set(["ClassMethod", "ClassProperty", "PropertyDefinition", "TSAbstractPropertyDefinition", "TSAbstractMethodDefinition", "TSDeclareMethod", "MethodDefinition", "ClassAccessorProperty", "AccessorProperty", "TSAbstractAccessorProperty"]);
            function ce(De) {
              let { comment: A, precedingNode: G, enclosingNode: re, text: ye } = De;
              return re && G && n(ye, A, o) === "(" && (re.type === "Property" || re.type === "TSDeclareMethod" || re.type === "TSAbstractMethodDefinition") && G.type === "Identifier" && re.key === G && n(ye, G, o) !== ":" || (G == null ? void 0 : G.type) === "Decorator" && ee.has(re == null ? void 0 : re.type) ? (l(G, A), true) : false;
            }
            var W = /* @__PURE__ */ new Set(["FunctionDeclaration", "FunctionExpression", "ClassMethod", "MethodDefinition", "ObjectMethod"]);
            function K(De) {
              let { comment: A, precedingNode: G, enclosingNode: re, text: ye } = De;
              return n(ye, A, o) !== "(" ? false : G && W.has(re == null ? void 0 : re.type) ? (l(G, A), true) : false;
            }
            function de(De) {
              let { comment: A, enclosingNode: G, text: re } = De;
              if ((G == null ? void 0 : G.type) !== "ArrowFunctionExpression")
                return false;
              let ye = y(re, A, o);
              return ye !== false && re.slice(ye, ye + 2) === "=>" ? (p(G, A), true) : false;
            }
            function ue(De) {
              let { comment: A, enclosingNode: G, text: re } = De;
              return n(re, A, o) !== ")" ? false : G && (le(G) && g(G).length === 0 || E(G) && N(G).length === 0) ? (p(G, A), true) : ((G == null ? void 0 : G.type) === "MethodDefinition" || (G == null ? void 0 : G.type) === "TSAbstractMethodDefinition") && g(G.value).length === 0 ? (p(G.value, A), true) : false;
            }
            function Fe(De) {
              let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye, text: Ce } = De;
              if ((G == null ? void 0 : G.type) === "FunctionTypeParam" && (re == null ? void 0 : re.type) === "FunctionTypeAnnotation" && (ye == null ? void 0 : ye.type) !== "FunctionTypeParam" || ((G == null ? void 0 : G.type) === "Identifier" || (G == null ? void 0 : G.type) === "AssignmentPattern") && re && le(re) && n(Ce, A, o) === ")")
                return l(G, A), true;
              if ((re == null ? void 0 : re.type) === "FunctionDeclaration" && (ye == null ? void 0 : ye.type) === "BlockStatement") {
                let Be = (() => {
                  let ve = g(re);
                  if (ve.length > 0)
                    return a(Ce, o(t3(ve)));
                  let ze = a(Ce, o(re.id));
                  return ze !== false && a(Ce, ze + 1);
                })();
                if (C(A) > Be)
                  return k(ye, A), true;
              }
              return false;
            }
            function z(De) {
              let { comment: A, enclosingNode: G } = De;
              return (G == null ? void 0 : G.type) === "LabeledStatement" ? (i(G, A), true) : false;
            }
            function U(De) {
              let { comment: A, enclosingNode: G } = De;
              return ((G == null ? void 0 : G.type) === "ContinueStatement" || (G == null ? void 0 : G.type) === "BreakStatement") && !G.label ? (l(G, A), true) : false;
            }
            function Z(De) {
              let { comment: A, precedingNode: G, enclosingNode: re } = De;
              return x(re) && G && re.callee === G && re.arguments.length > 0 ? (i(re.arguments[0], A), true) : false;
            }
            function se(De) {
              let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye } = De;
              return (re == null ? void 0 : re.type) === "UnionTypeAnnotation" || (re == null ? void 0 : re.type) === "TSUnionType" ? (c(A) && (ye.prettierIgnore = true, A.unignore = true), G ? (l(G, A), true) : false) : (((ye == null ? void 0 : ye.type) === "UnionTypeAnnotation" || (ye == null ? void 0 : ye.type) === "TSUnionType") && c(A) && (ye.types[0].prettierIgnore = true, A.unignore = true), false);
            }
            function fe(De) {
              let { comment: A, enclosingNode: G } = De;
              return P(G) ? (i(G, A), true) : false;
            }
            function ge(De) {
              let { comment: A, enclosingNode: G, followingNode: re, ast: ye, isLastComment: Ce } = De;
              return ye && ye.body && ye.body.length === 0 ? (Ce ? p(ye, A) : i(ye, A), true) : (G == null ? void 0 : G.type) === "Program" && (G == null ? void 0 : G.body.length) === 0 && !h(G.directives) ? (Ce ? p(G, A) : i(G, A), true) : (re == null ? void 0 : re.type) === "Program" && (re == null ? void 0 : re.body.length) === 0 && (G == null ? void 0 : G.type) === "ModuleExpression" ? (p(re, A), true) : false;
            }
            function he(De) {
              let { comment: A, enclosingNode: G } = De;
              return (G == null ? void 0 : G.type) === "ForInStatement" || (G == null ? void 0 : G.type) === "ForOfStatement" ? (i(G, A), true) : false;
            }
            function we(De) {
              let { comment: A, precedingNode: G, enclosingNode: re, text: ye } = De;
              if ((re == null ? void 0 : re.type) === "ImportSpecifier" || (re == null ? void 0 : re.type) === "ExportSpecifier")
                return i(re, A), true;
              let Ce = (G == null ? void 0 : G.type) === "ImportSpecifier" && (re == null ? void 0 : re.type) === "ImportDeclaration", Be = (G == null ? void 0 : G.type) === "ExportSpecifier" && (re == null ? void 0 : re.type) === "ExportNamedDeclaration";
              return (Ce || Be) && s(ye, o(A)) ? (l(G, A), true) : false;
            }
            function ke(De) {
              let { comment: A, enclosingNode: G } = De;
              return (G == null ? void 0 : G.type) === "AssignmentPattern" ? (i(G, A), true) : false;
            }
            var Re = /* @__PURE__ */ new Set(["VariableDeclarator", "AssignmentExpression", "TypeAlias", "TSTypeAliasDeclaration"]), Ne = /* @__PURE__ */ new Set(["ObjectExpression", "ArrayExpression", "TemplateLiteral", "TaggedTemplateExpression", "ObjectTypeAnnotation", "TSTypeLiteral"]);
            function Pe(De) {
              let { comment: A, enclosingNode: G, followingNode: re } = De;
              return Re.has(G == null ? void 0 : G.type) && re && (Ne.has(re.type) || d(A)) ? (i(re, A), true) : false;
            }
            function oe(De) {
              let { comment: A, enclosingNode: G, followingNode: re, text: ye } = De;
              return !re && ((G == null ? void 0 : G.type) === "TSMethodSignature" || (G == null ? void 0 : G.type) === "TSDeclareFunction" || (G == null ? void 0 : G.type) === "TSAbstractMethodDefinition") && n(ye, A, o) === ";" ? (l(G, A), true) : false;
            }
            function H(De) {
              let { comment: A, enclosingNode: G, followingNode: re } = De;
              if (c(A) && (G == null ? void 0 : G.type) === "TSMappedType" && (re == null ? void 0 : re.type) === "TSTypeParameter" && re.constraint)
                return G.prettierIgnore = true, A.unignore = true, true;
            }
            function pe(De) {
              let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye } = De;
              return (re == null ? void 0 : re.type) !== "TSMappedType" ? false : (ye == null ? void 0 : ye.type) === "TSTypeParameter" && ye.name ? (i(ye.name, A), true) : (G == null ? void 0 : G.type) === "TSTypeParameter" && G.constraint ? (l(G.constraint, A), true) : false;
            }
            function X(De) {
              let { comment: A, enclosingNode: G, followingNode: re } = De;
              return !G || G.type !== "SwitchCase" || G.test || !re || re !== G.consequent[0] ? false : (re.type === "BlockStatement" && $(A) ? k(re, A) : p(G, A), true);
            }
            function le(De) {
              return De.type === "ArrowFunctionExpression" || De.type === "FunctionExpression" || De.type === "FunctionDeclaration" || De.type === "ObjectMethod" || De.type === "ClassMethod" || De.type === "TSDeclareFunction" || De.type === "TSCallSignatureDeclaration" || De.type === "TSConstructSignatureDeclaration" || De.type === "TSMethodSignature" || De.type === "TSConstructorType" || De.type === "TSFunctionType" || De.type === "TSDeclareMethod";
            }
            function Ae(De, A) {
              if ((A.parser === "typescript" || A.parser === "flow" || A.parser === "acorn" || A.parser === "espree" || A.parser === "meriyah" || A.parser === "__babel_estree") && De.type === "MethodDefinition" && De.value && De.value.type === "FunctionExpression" && g(De.value).length === 0 && !De.value.returnType && !h(De.value.typeParameters) && De.value.body)
                return [...De.decorators || [], De.key, De.value.body];
            }
            function Ee(De) {
              let A = De.getValue(), G = De.getParentNode(), re = (ye) => _(D(ye, T.Leading)) || _(D(ye, T.Trailing));
              return (A && (f(A) || F(A) || x(G) && re(A)) || G && (G.type === "JSXSpreadAttribute" || G.type === "JSXSpreadChild" || G.type === "UnionTypeAnnotation" || G.type === "TSUnionType" || (G.type === "ClassDeclaration" || G.type === "ClassExpression") && G.superClass === A)) && (!w(De) || G.type === "UnionTypeAnnotation" || G.type === "TSUnionType");
            }
            r.exports = { handleOwnLineComment: S, handleEndOfLineComment: b, handleRemainingComment: B, getCommentChildNodes: Ae, willPrintOwnComments: Ee };
          } }), qt = te({ "src/language-js/needs-parens.js"(e, r) {
            "use strict";
            ne();
            var t3 = lt2(), s = Kn(), { getFunctionParameters: a, getLeftSidePathName: n, hasFlowShorthandAnnotationComment: u, hasNakedLeftSide: i, hasNode: l, isBitwiseOperator: p, startsWithNoLookaheadToken: y, shouldFlatten: h, getPrecedence: g, isCallExpression: c, isMemberExpression: f, isObjectProperty: F, isTSTypeExpression: _ } = Ke();
            function w(D, T) {
              let m = D.getParentNode();
              if (!m)
                return false;
              let C = D.getName(), o = D.getNode();
              if (T.__isInHtmlInterpolation && !T.bracketSpacing && I(o) && P(D))
                return true;
              if (E(o))
                return false;
              if (T.parser !== "flow" && u(D.getValue()))
                return true;
              if (o.type === "Identifier") {
                if (o.extra && o.extra.parenthesized && /^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(o.name) || C === "left" && (o.name === "async" && !m.await || o.name === "let") && m.type === "ForOfStatement")
                  return true;
                if (o.name === "let") {
                  var d;
                  let S = (d = D.findAncestor((b) => b.type === "ForOfStatement")) === null || d === void 0 ? void 0 : d.left;
                  if (S && y(S, (b) => b === o))
                    return true;
                }
                if (C === "object" && o.name === "let" && m.type === "MemberExpression" && m.computed && !m.optional) {
                  let S = D.findAncestor((B) => B.type === "ExpressionStatement" || B.type === "ForStatement" || B.type === "ForInStatement"), b = S ? S.type === "ExpressionStatement" ? S.expression : S.type === "ForStatement" ? S.init : S.left : void 0;
                  if (b && y(b, (B) => B === o))
                    return true;
                }
                return false;
              }
              if (o.type === "ObjectExpression" || o.type === "FunctionExpression" || o.type === "ClassExpression" || o.type === "DoExpression") {
                var v;
                let S = (v = D.findAncestor((b) => b.type === "ExpressionStatement")) === null || v === void 0 ? void 0 : v.expression;
                if (S && y(S, (b) => b === o))
                  return true;
              }
              switch (m.type) {
                case "ParenthesizedExpression":
                  return false;
                case "ClassDeclaration":
                case "ClassExpression": {
                  if (C === "superClass" && (o.type === "ArrowFunctionExpression" || o.type === "AssignmentExpression" || o.type === "AwaitExpression" || o.type === "BinaryExpression" || o.type === "ConditionalExpression" || o.type === "LogicalExpression" || o.type === "NewExpression" || o.type === "ObjectExpression" || o.type === "SequenceExpression" || o.type === "TaggedTemplateExpression" || o.type === "UnaryExpression" || o.type === "UpdateExpression" || o.type === "YieldExpression" || o.type === "TSNonNullExpression"))
                    return true;
                  break;
                }
                case "ExportDefaultDeclaration":
                  return $(D, T) || o.type === "SequenceExpression";
                case "Decorator": {
                  if (C === "expression") {
                    if (f(o) && o.computed)
                      return true;
                    let S = false, b = false, B = o;
                    for (; B; )
                      switch (B.type) {
                        case "MemberExpression":
                          b = true, B = B.object;
                          break;
                        case "CallExpression":
                          if (b || S)
                            return T.parser !== "typescript";
                          S = true, B = B.callee;
                          break;
                        case "Identifier":
                          return false;
                        case "TaggedTemplateExpression":
                          return T.parser !== "typescript";
                        default:
                          return true;
                      }
                    return true;
                  }
                  break;
                }
                case "ArrowFunctionExpression": {
                  if (C === "body" && o.type !== "SequenceExpression" && y(o, (S) => S.type === "ObjectExpression"))
                    return true;
                  break;
                }
              }
              switch (o.type) {
                case "UpdateExpression":
                  if (m.type === "UnaryExpression")
                    return o.prefix && (o.operator === "++" && m.operator === "+" || o.operator === "--" && m.operator === "-");
                case "UnaryExpression":
                  switch (m.type) {
                    case "UnaryExpression":
                      return o.operator === m.operator && (o.operator === "+" || o.operator === "-");
                    case "BindExpression":
                      return true;
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                      return C === "object";
                    case "TaggedTemplateExpression":
                      return true;
                    case "NewExpression":
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return C === "callee";
                    case "BinaryExpression":
                      return C === "left" && m.operator === "**";
                    case "TSNonNullExpression":
                      return true;
                    default:
                      return false;
                  }
                case "BinaryExpression": {
                  if (m.type === "UpdateExpression" || o.operator === "in" && N(D))
                    return true;
                  if (o.operator === "|>" && o.extra && o.extra.parenthesized) {
                    let S = D.getParentNode(1);
                    if (S.type === "BinaryExpression" && S.operator === "|>")
                      return true;
                  }
                }
                case "TSTypeAssertion":
                case "TSAsExpression":
                case "TSSatisfiesExpression":
                case "LogicalExpression":
                  switch (m.type) {
                    case "TSSatisfiesExpression":
                    case "TSAsExpression":
                      return !_(o);
                    case "ConditionalExpression":
                      return _(o);
                    case "CallExpression":
                    case "NewExpression":
                    case "OptionalCallExpression":
                      return C === "callee";
                    case "ClassExpression":
                    case "ClassDeclaration":
                      return C === "superClass";
                    case "TSTypeAssertion":
                    case "TaggedTemplateExpression":
                    case "UnaryExpression":
                    case "JSXSpreadAttribute":
                    case "SpreadElement":
                    case "SpreadProperty":
                    case "BindExpression":
                    case "AwaitExpression":
                    case "TSNonNullExpression":
                    case "UpdateExpression":
                      return true;
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                      return C === "object";
                    case "AssignmentExpression":
                    case "AssignmentPattern":
                      return C === "left" && (o.type === "TSTypeAssertion" || _(o));
                    case "LogicalExpression":
                      if (o.type === "LogicalExpression")
                        return m.operator !== o.operator;
                    case "BinaryExpression": {
                      let { operator: S, type: b } = o;
                      if (!S && b !== "TSTypeAssertion")
                        return true;
                      let B = g(S), k = m.operator, M = g(k);
                      return M > B || C === "right" && M === B || M === B && !h(k, S) ? true : M < B && S === "%" ? k === "+" || k === "-" : !!p(k);
                    }
                    default:
                      return false;
                  }
                case "SequenceExpression":
                  switch (m.type) {
                    case "ReturnStatement":
                      return false;
                    case "ForStatement":
                      return false;
                    case "ExpressionStatement":
                      return C !== "expression";
                    case "ArrowFunctionExpression":
                      return C !== "body";
                    default:
                      return true;
                  }
                case "YieldExpression":
                  if (m.type === "UnaryExpression" || m.type === "AwaitExpression" || _(m) || m.type === "TSNonNullExpression")
                    return true;
                case "AwaitExpression":
                  switch (m.type) {
                    case "TaggedTemplateExpression":
                    case "UnaryExpression":
                    case "LogicalExpression":
                    case "SpreadElement":
                    case "SpreadProperty":
                    case "TSAsExpression":
                    case "TSSatisfiesExpression":
                    case "TSNonNullExpression":
                    case "BindExpression":
                      return true;
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                      return C === "object";
                    case "NewExpression":
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return C === "callee";
                    case "ConditionalExpression":
                      return C === "test";
                    case "BinaryExpression":
                      return !(!o.argument && m.operator === "|>");
                    default:
                      return false;
                  }
                case "TSConditionalType":
                case "TSFunctionType":
                case "TSConstructorType":
                  if (C === "extendsType" && m.type === "TSConditionalType") {
                    if (o.type === "TSConditionalType")
                      return true;
                    let { typeAnnotation: S } = o.returnType || o.typeAnnotation;
                    if (S.type === "TSTypePredicate" && S.typeAnnotation && (S = S.typeAnnotation.typeAnnotation), S.type === "TSInferType" && S.typeParameter.constraint)
                      return true;
                  }
                  if (C === "checkType" && m.type === "TSConditionalType")
                    return true;
                case "TSUnionType":
                case "TSIntersectionType":
                  if ((m.type === "TSUnionType" || m.type === "TSIntersectionType") && m.types.length > 1 && (!o.types || o.types.length > 1))
                    return true;
                case "TSInferType":
                  if (o.type === "TSInferType" && m.type === "TSRestType")
                    return false;
                case "TSTypeOperator":
                  return m.type === "TSArrayType" || m.type === "TSOptionalType" || m.type === "TSRestType" || C === "objectType" && m.type === "TSIndexedAccessType" || m.type === "TSTypeOperator" || m.type === "TSTypeAnnotation" && D.getParentNode(1).type.startsWith("TSJSDoc");
                case "TSTypeQuery":
                  return C === "objectType" && m.type === "TSIndexedAccessType" || C === "elementType" && m.type === "TSArrayType";
                case "TypeofTypeAnnotation":
                  return C === "objectType" && (m.type === "IndexedAccessType" || m.type === "OptionalIndexedAccessType") || C === "elementType" && m.type === "ArrayTypeAnnotation";
                case "ArrayTypeAnnotation":
                  return m.type === "NullableTypeAnnotation";
                case "IntersectionTypeAnnotation":
                case "UnionTypeAnnotation":
                  return m.type === "ArrayTypeAnnotation" || m.type === "NullableTypeAnnotation" || m.type === "IntersectionTypeAnnotation" || m.type === "UnionTypeAnnotation" || C === "objectType" && (m.type === "IndexedAccessType" || m.type === "OptionalIndexedAccessType");
                case "NullableTypeAnnotation":
                  return m.type === "ArrayTypeAnnotation" || C === "objectType" && (m.type === "IndexedAccessType" || m.type === "OptionalIndexedAccessType");
                case "FunctionTypeAnnotation": {
                  let S = m.type === "NullableTypeAnnotation" ? D.getParentNode(1) : m;
                  return S.type === "UnionTypeAnnotation" || S.type === "IntersectionTypeAnnotation" || S.type === "ArrayTypeAnnotation" || C === "objectType" && (S.type === "IndexedAccessType" || S.type === "OptionalIndexedAccessType") || S.type === "NullableTypeAnnotation" || m.type === "FunctionTypeParam" && m.name === null && a(o).some((b) => b.typeAnnotation && b.typeAnnotation.type === "NullableTypeAnnotation");
                }
                case "OptionalIndexedAccessType":
                  return C === "objectType" && m.type === "IndexedAccessType";
                case "StringLiteral":
                case "NumericLiteral":
                case "Literal":
                  if (typeof o.value == "string" && m.type === "ExpressionStatement" && !m.directive) {
                    let S = D.getParentNode(1);
                    return S.type === "Program" || S.type === "BlockStatement";
                  }
                  return C === "object" && m.type === "MemberExpression" && typeof o.value == "number";
                case "AssignmentExpression": {
                  let S = D.getParentNode(1);
                  return C === "body" && m.type === "ArrowFunctionExpression" ? true : C === "key" && (m.type === "ClassProperty" || m.type === "PropertyDefinition") && m.computed || (C === "init" || C === "update") && m.type === "ForStatement" ? false : m.type === "ExpressionStatement" ? o.left.type === "ObjectPattern" : !(C === "key" && m.type === "TSPropertySignature" || m.type === "AssignmentExpression" || m.type === "SequenceExpression" && S && S.type === "ForStatement" && (S.init === m || S.update === m) || C === "value" && m.type === "Property" && S && S.type === "ObjectPattern" && S.properties.includes(m) || m.type === "NGChainedExpression");
                }
                case "ConditionalExpression":
                  switch (m.type) {
                    case "TaggedTemplateExpression":
                    case "UnaryExpression":
                    case "SpreadElement":
                    case "SpreadProperty":
                    case "BinaryExpression":
                    case "LogicalExpression":
                    case "NGPipeExpression":
                    case "ExportDefaultDeclaration":
                    case "AwaitExpression":
                    case "JSXSpreadAttribute":
                    case "TSTypeAssertion":
                    case "TypeCastExpression":
                    case "TSAsExpression":
                    case "TSSatisfiesExpression":
                    case "TSNonNullExpression":
                      return true;
                    case "NewExpression":
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return C === "callee";
                    case "ConditionalExpression":
                      return C === "test";
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                      return C === "object";
                    default:
                      return false;
                  }
                case "FunctionExpression":
                  switch (m.type) {
                    case "NewExpression":
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return C === "callee";
                    case "TaggedTemplateExpression":
                      return true;
                    default:
                      return false;
                  }
                case "ArrowFunctionExpression":
                  switch (m.type) {
                    case "BinaryExpression":
                      return m.operator !== "|>" || o.extra && o.extra.parenthesized;
                    case "NewExpression":
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return C === "callee";
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                      return C === "object";
                    case "TSAsExpression":
                    case "TSSatisfiesExpression":
                    case "TSNonNullExpression":
                    case "BindExpression":
                    case "TaggedTemplateExpression":
                    case "UnaryExpression":
                    case "LogicalExpression":
                    case "AwaitExpression":
                    case "TSTypeAssertion":
                      return true;
                    case "ConditionalExpression":
                      return C === "test";
                    default:
                      return false;
                  }
                case "ClassExpression":
                  if (s(o.decorators))
                    return true;
                  switch (m.type) {
                    case "NewExpression":
                      return C === "callee";
                    default:
                      return false;
                  }
                case "OptionalMemberExpression":
                case "OptionalCallExpression": {
                  let S = D.getParentNode(1);
                  if (C === "object" && m.type === "MemberExpression" || C === "callee" && (m.type === "CallExpression" || m.type === "NewExpression") || m.type === "TSNonNullExpression" && S.type === "MemberExpression" && S.object === m)
                    return true;
                }
                case "CallExpression":
                case "MemberExpression":
                case "TaggedTemplateExpression":
                case "TSNonNullExpression":
                  if (C === "callee" && (m.type === "BindExpression" || m.type === "NewExpression")) {
                    let S = o;
                    for (; S; )
                      switch (S.type) {
                        case "CallExpression":
                        case "OptionalCallExpression":
                          return true;
                        case "MemberExpression":
                        case "OptionalMemberExpression":
                        case "BindExpression":
                          S = S.object;
                          break;
                        case "TaggedTemplateExpression":
                          S = S.tag;
                          break;
                        case "TSNonNullExpression":
                          S = S.expression;
                          break;
                        default:
                          return false;
                      }
                  }
                  return false;
                case "BindExpression":
                  return C === "callee" && (m.type === "BindExpression" || m.type === "NewExpression") || C === "object" && f(m);
                case "NGPipeExpression":
                  return !(m.type === "NGRoot" || m.type === "NGMicrosyntaxExpression" || m.type === "ObjectProperty" && !(o.extra && o.extra.parenthesized) || m.type === "ArrayExpression" || c(m) && m.arguments[C] === o || C === "right" && m.type === "NGPipeExpression" || C === "property" && m.type === "MemberExpression" || m.type === "AssignmentExpression");
                case "JSXFragment":
                case "JSXElement":
                  return C === "callee" || C === "left" && m.type === "BinaryExpression" && m.operator === "<" || m.type !== "ArrayExpression" && m.type !== "ArrowFunctionExpression" && m.type !== "AssignmentExpression" && m.type !== "AssignmentPattern" && m.type !== "BinaryExpression" && m.type !== "NewExpression" && m.type !== "ConditionalExpression" && m.type !== "ExpressionStatement" && m.type !== "JsExpressionRoot" && m.type !== "JSXAttribute" && m.type !== "JSXElement" && m.type !== "JSXExpressionContainer" && m.type !== "JSXFragment" && m.type !== "LogicalExpression" && !c(m) && !F(m) && m.type !== "ReturnStatement" && m.type !== "ThrowStatement" && m.type !== "TypeCastExpression" && m.type !== "VariableDeclarator" && m.type !== "YieldExpression";
                case "TypeAnnotation":
                  return C === "returnType" && m.type === "ArrowFunctionExpression" && x(o);
              }
              return false;
            }
            function E(D) {
              return D.type === "BlockStatement" || D.type === "BreakStatement" || D.type === "ClassBody" || D.type === "ClassDeclaration" || D.type === "ClassMethod" || D.type === "ClassProperty" || D.type === "PropertyDefinition" || D.type === "ClassPrivateProperty" || D.type === "ContinueStatement" || D.type === "DebuggerStatement" || D.type === "DeclareClass" || D.type === "DeclareExportAllDeclaration" || D.type === "DeclareExportDeclaration" || D.type === "DeclareFunction" || D.type === "DeclareInterface" || D.type === "DeclareModule" || D.type === "DeclareModuleExports" || D.type === "DeclareVariable" || D.type === "DoWhileStatement" || D.type === "EnumDeclaration" || D.type === "ExportAllDeclaration" || D.type === "ExportDefaultDeclaration" || D.type === "ExportNamedDeclaration" || D.type === "ExpressionStatement" || D.type === "ForInStatement" || D.type === "ForOfStatement" || D.type === "ForStatement" || D.type === "FunctionDeclaration" || D.type === "IfStatement" || D.type === "ImportDeclaration" || D.type === "InterfaceDeclaration" || D.type === "LabeledStatement" || D.type === "MethodDefinition" || D.type === "ReturnStatement" || D.type === "SwitchStatement" || D.type === "ThrowStatement" || D.type === "TryStatement" || D.type === "TSDeclareFunction" || D.type === "TSEnumDeclaration" || D.type === "TSImportEqualsDeclaration" || D.type === "TSInterfaceDeclaration" || D.type === "TSModuleDeclaration" || D.type === "TSNamespaceExportDeclaration" || D.type === "TypeAlias" || D.type === "VariableDeclaration" || D.type === "WhileStatement" || D.type === "WithStatement";
            }
            function N(D) {
              let T = 0, m = D.getValue();
              for (; m; ) {
                let C = D.getParentNode(T++);
                if (C && C.type === "ForStatement" && C.init === m)
                  return true;
                m = C;
              }
              return false;
            }
            function x(D) {
              return l(D, (T) => T.type === "ObjectTypeAnnotation" && l(T, (m) => m.type === "FunctionTypeAnnotation" || void 0) || void 0);
            }
            function I(D) {
              switch (D.type) {
                case "ObjectExpression":
                  return true;
                default:
                  return false;
              }
            }
            function P(D) {
              let T = D.getValue(), m = D.getParentNode(), C = D.getName();
              switch (m.type) {
                case "NGPipeExpression":
                  if (typeof C == "number" && m.arguments[C] === T && m.arguments.length - 1 === C)
                    return D.callParent(P);
                  break;
                case "ObjectProperty":
                  if (C === "value") {
                    let o = D.getParentNode(1);
                    return t3(o.properties) === m;
                  }
                  break;
                case "BinaryExpression":
                case "LogicalExpression":
                  if (C === "right")
                    return D.callParent(P);
                  break;
                case "ConditionalExpression":
                  if (C === "alternate")
                    return D.callParent(P);
                  break;
                case "UnaryExpression":
                  if (m.prefix)
                    return D.callParent(P);
                  break;
              }
              return false;
            }
            function $(D, T) {
              let m = D.getValue(), C = D.getParentNode();
              return m.type === "FunctionExpression" || m.type === "ClassExpression" ? C.type === "ExportDefaultDeclaration" || !w(D, T) : !i(m) || C.type !== "ExportDefaultDeclaration" && w(D, T) ? false : D.call((o) => $(o, T), ...n(D, m));
            }
            r.exports = w;
          } }), Fo = te({ "src/language-js/print-preprocess.js"(e, r) {
            "use strict";
            ne();
            function t3(s, a) {
              switch (a.parser) {
                case "json":
                case "json5":
                case "json-stringify":
                case "__js_expression":
                case "__vue_expression":
                case "__vue_ts_expression":
                  return Object.assign(Object.assign({}, s), {}, { type: a.parser.startsWith("__") ? "JsExpressionRoot" : "JsonRoot", node: s, comments: [], rootMarker: a.rootMarker });
                default:
                  return s;
              }
            }
            r.exports = t3;
          } }), pd = te({ "src/language-js/print/html-binding.js"(e, r) {
            "use strict";
            ne();
            var { builders: { join: t3, line: s, group: a, softline: n, indent: u } } = qe();
            function i(p, y, h) {
              let g = p.getValue();
              if (y.__onHtmlBindingRoot && p.getName() === null && y.__onHtmlBindingRoot(g, y), g.type === "File") {
                if (y.__isVueForBindingLeft)
                  return p.call((c) => {
                    let f = t3([",", s], c.map(h, "params")), { params: F } = c.getValue();
                    return F.length === 1 ? f : ["(", u([n, a(f)]), n, ")"];
                  }, "program", "body", 0);
                if (y.__isVueBindings)
                  return p.call((c) => t3([",", s], c.map(h, "params")), "program", "body", 0);
              }
            }
            function l(p) {
              switch (p.type) {
                case "MemberExpression":
                  switch (p.property.type) {
                    case "Identifier":
                    case "NumericLiteral":
                    case "StringLiteral":
                      return l(p.object);
                  }
                  return false;
                case "Identifier":
                  return true;
                default:
                  return false;
              }
            }
            r.exports = { isVueEventBindingExpression: l, printHtmlBinding: i };
          } }), ru = te({ "src/language-js/print/binaryish.js"(e, r) {
            "use strict";
            ne();
            var { printComments: t3 } = et(), { getLast: s } = Ue(), { builders: { join: a, line: n, softline: u, group: i, indent: l, align: p, indentIfBreak: y }, utils: { cleanDoc: h, getDocParts: g, isConcat: c } } = qe(), { hasLeadingOwnLineComment: f, isBinaryish: F, isJsxNode: _, shouldFlatten: w, hasComment: E, CommentCheckFlags: N, isCallExpression: x, isMemberExpression: I, isObjectProperty: P, isEnabledHackPipeline: $ } = Ke(), D = 0;
            function T(o, d, v) {
              let S = o.getValue(), b = o.getParentNode(), B = o.getParentNode(1), k = S !== b.body && (b.type === "IfStatement" || b.type === "WhileStatement" || b.type === "SwitchStatement" || b.type === "DoWhileStatement"), M = $(d) && S.operator === "|>", R = m(o, v, d, false, k);
              if (k)
                return R;
              if (M)
                return i(R);
              if (x(b) && b.callee === S || b.type === "UnaryExpression" || I(b) && !b.computed)
                return i([l([u, ...R]), u]);
              let q = b.type === "ReturnStatement" || b.type === "ThrowStatement" || b.type === "JSXExpressionContainer" && B.type === "JSXAttribute" || S.operator !== "|" && b.type === "JsExpressionRoot" || S.type !== "NGPipeExpression" && (b.type === "NGRoot" && d.parser === "__ng_binding" || b.type === "NGMicrosyntaxExpression" && B.type === "NGMicrosyntax" && B.body.length === 1) || S === b.body && b.type === "ArrowFunctionExpression" || S !== b.body && b.type === "ForStatement" || b.type === "ConditionalExpression" && B.type !== "ReturnStatement" && B.type !== "ThrowStatement" && !x(B) || b.type === "TemplateLiteral", J = b.type === "AssignmentExpression" || b.type === "VariableDeclarator" || b.type === "ClassProperty" || b.type === "PropertyDefinition" || b.type === "TSAbstractPropertyDefinition" || b.type === "ClassPrivateProperty" || P(b), L = F(S.left) && w(S.operator, S.left.operator);
              if (q || C(S) && !L || !C(S) && J)
                return i(R);
              if (R.length === 0)
                return "";
              let Q = _(S.right), V = R.findIndex((W) => typeof W != "string" && !Array.isArray(W) && W.type === "group"), j = R.slice(0, V === -1 ? 1 : V + 1), Y = R.slice(j.length, Q ? -1 : void 0), ie = Symbol("logicalChain-" + ++D), ee = i([...j, l(Y)], { id: ie });
              if (!Q)
                return ee;
              let ce = s(R);
              return i([ee, y(ce, { groupId: ie })]);
            }
            function m(o, d, v, S, b) {
              let B = o.getValue();
              if (!F(B))
                return [i(d())];
              let k = [];
              w(B.operator, B.left.operator) ? k = o.call((Y) => m(Y, d, v, true, b), "left") : k.push(i(d("left")));
              let M = C(B), R = (B.operator === "|>" || B.type === "NGPipeExpression" || B.operator === "|" && v.parser === "__vue_expression") && !f(v.originalText, B.right), q = B.type === "NGPipeExpression" ? "|" : B.operator, J = B.type === "NGPipeExpression" && B.arguments.length > 0 ? i(l([n, ": ", a([n, ": "], o.map(d, "arguments").map((Y) => p(2, i(Y))))])) : "", L;
              if (M)
                L = [q, " ", d("right"), J];
              else {
                let ie = $(v) && q === "|>" ? o.call((ee) => m(ee, d, v, true, b), "right") : d("right");
                L = [R ? n : "", q, R ? " " : n, ie, J];
              }
              let Q = o.getParentNode(), V = E(B.left, N.Trailing | N.Line), j = V || !(b && B.type === "LogicalExpression") && Q.type !== B.type && B.left.type !== B.type && B.right.type !== B.type;
              if (k.push(R ? "" : " ", j ? i(L, { shouldBreak: V }) : L), S && E(B)) {
                let Y = h(t3(o, k, v));
                return c(Y) || Y.type === "fill" ? g(Y) : [Y];
              }
              return k;
            }
            function C(o) {
              return o.type !== "LogicalExpression" ? false : !!(o.right.type === "ObjectExpression" && o.right.properties.length > 0 || o.right.type === "ArrayExpression" && o.right.elements.length > 0 || _(o.right));
            }
            r.exports = { printBinaryishExpression: T, shouldInlineLogicalExpression: C };
          } }), fd = te({ "src/language-js/print/angular.js"(e, r) {
            "use strict";
            ne();
            var { builders: { join: t3, line: s, group: a } } = qe(), { hasNode: n, hasComment: u, getComments: i } = Ke(), { printBinaryishExpression: l } = ru();
            function p(g, c, f) {
              let F = g.getValue();
              if (F.type.startsWith("NG"))
                switch (F.type) {
                  case "NGRoot":
                    return [f("node"), u(F.node) ? " //" + i(F.node)[0].value.trimEnd() : ""];
                  case "NGPipeExpression":
                    return l(g, c, f);
                  case "NGChainedExpression":
                    return a(t3([";", s], g.map((_) => h(_) ? f() : ["(", f(), ")"], "expressions")));
                  case "NGEmptyExpression":
                    return "";
                  case "NGQuotedExpression":
                    return [F.prefix, ": ", F.value.trim()];
                  case "NGMicrosyntax":
                    return g.map((_, w) => [w === 0 ? "" : y(_.getValue(), w, F) ? " " : [";", s], f()], "body");
                  case "NGMicrosyntaxKey":
                    return /^[$_a-z][\w$]*(?:-[$_a-z][\w$])*$/i.test(F.name) ? F.name : JSON.stringify(F.name);
                  case "NGMicrosyntaxExpression":
                    return [f("expression"), F.alias === null ? "" : [" as ", f("alias")]];
                  case "NGMicrosyntaxKeyedExpression": {
                    let _ = g.getName(), w = g.getParentNode(), E = y(F, _, w) || (_ === 1 && (F.key.name === "then" || F.key.name === "else") || _ === 2 && F.key.name === "else" && w.body[_ - 1].type === "NGMicrosyntaxKeyedExpression" && w.body[_ - 1].key.name === "then") && w.body[0].type === "NGMicrosyntaxExpression";
                    return [f("key"), E ? " " : ": ", f("expression")];
                  }
                  case "NGMicrosyntaxLet":
                    return ["let ", f("key"), F.value === null ? "" : [" = ", f("value")]];
                  case "NGMicrosyntaxAs":
                    return [f("key"), " as ", f("alias")];
                  default:
                    throw new Error(`Unknown Angular node type: ${JSON.stringify(F.type)}.`);
                }
            }
            function y(g, c, f) {
              return g.type === "NGMicrosyntaxKeyedExpression" && g.key.name === "of" && c === 1 && f.body[0].type === "NGMicrosyntaxLet" && f.body[0].value === null;
            }
            function h(g) {
              return n(g.getValue(), (c) => {
                switch (c.type) {
                  case void 0:
                    return false;
                  case "CallExpression":
                  case "OptionalCallExpression":
                  case "AssignmentExpression":
                    return true;
                }
              });
            }
            r.exports = { printAngular: p };
          } }), Dd = te({ "src/language-js/print/jsx.js"(e, r) {
            "use strict";
            ne();
            var { printComments: t3, printDanglingComments: s, printCommentsSeparately: a } = et(), { builders: { line: n, hardline: u, softline: i, group: l, indent: p, conditionalGroup: y, fill: h, ifBreak: g, lineSuffixBoundary: c, join: f }, utils: { willBreak: F } } = qe(), { getLast: _, getPreferredQuote: w } = Ue(), { isJsxNode: E, rawText: N, isCallExpression: x, isStringLiteral: I, isBinaryish: P, hasComment: $, CommentCheckFlags: D, hasNodeIgnoreComment: T } = Ke(), m = qt(), { willPrintOwnComments: C } = Eo(), o = (U) => U === "" || U === n || U === u || U === i;
            function d(U, Z, se) {
              let fe = U.getValue();
              if (fe.type === "JSXElement" && de(fe))
                return [se("openingElement"), se("closingElement")];
              let ge = fe.type === "JSXElement" ? se("openingElement") : se("openingFragment"), he = fe.type === "JSXElement" ? se("closingElement") : se("closingFragment");
              if (fe.children.length === 1 && fe.children[0].type === "JSXExpressionContainer" && (fe.children[0].expression.type === "TemplateLiteral" || fe.children[0].expression.type === "TaggedTemplateExpression"))
                return [ge, ...U.map(se, "children"), he];
              fe.children = fe.children.map((A) => Fe(A) ? { type: "JSXText", value: " ", raw: " " } : A);
              let we = fe.children.some(E), ke = fe.children.filter((A) => A.type === "JSXExpressionContainer").length > 1, Re = fe.type === "JSXElement" && fe.openingElement.attributes.length > 1, Ne = F(ge) || we || Re || ke, Pe = U.getParentNode().rootMarker === "mdx", oe = Z.singleQuote ? "{' '}" : '{" "}', H = Pe ? " " : g([oe, i], " "), pe = fe.openingElement && fe.openingElement.name && fe.openingElement.name.name === "fbt", X = v(U, Z, se, H, pe), le = fe.children.some((A) => ue(A));
              for (let A = X.length - 2; A >= 0; A--) {
                let G = X[A] === "" && X[A + 1] === "", re = X[A] === u && X[A + 1] === "" && X[A + 2] === u, ye = (X[A] === i || X[A] === u) && X[A + 1] === "" && X[A + 2] === H, Ce = X[A] === H && X[A + 1] === "" && (X[A + 2] === i || X[A + 2] === u), Be = X[A] === H && X[A + 1] === "" && X[A + 2] === H, ve = X[A] === i && X[A + 1] === "" && X[A + 2] === u || X[A] === u && X[A + 1] === "" && X[A + 2] === i;
                re && le || G || ye || Be || ve ? X.splice(A, 2) : Ce && X.splice(A + 1, 2);
              }
              for (; X.length > 0 && o(_(X)); )
                X.pop();
              for (; X.length > 1 && o(X[0]) && o(X[1]); )
                X.shift(), X.shift();
              let Ae = [];
              for (let [A, G] of X.entries()) {
                if (G === H) {
                  if (A === 1 && X[A - 1] === "") {
                    if (X.length === 2) {
                      Ae.push(oe);
                      continue;
                    }
                    Ae.push([oe, u]);
                    continue;
                  } else if (A === X.length - 1) {
                    Ae.push(oe);
                    continue;
                  } else if (X[A - 1] === "" && X[A - 2] === u) {
                    Ae.push(oe);
                    continue;
                  }
                }
                Ae.push(G), F(G) && (Ne = true);
              }
              let Ee = le ? h(Ae) : l(Ae, { shouldBreak: true });
              if (Pe)
                return Ee;
              let De = l([ge, p([u, Ee]), u, he]);
              return Ne ? De : y([l([ge, ...X, he]), De]);
            }
            function v(U, Z, se, fe, ge) {
              let he = [];
              return U.each((we, ke, Re) => {
                let Ne = we.getValue();
                if (Ne.type === "JSXText") {
                  let Pe = N(Ne);
                  if (ue(Ne)) {
                    let oe = Pe.split(ce);
                    if (oe[0] === "") {
                      if (he.push(""), oe.shift(), /\n/.test(oe[0])) {
                        let pe = Re[ke + 1];
                        he.push(b(ge, oe[1], Ne, pe));
                      } else
                        he.push(fe);
                      oe.shift();
                    }
                    let H;
                    if (_(oe) === "" && (oe.pop(), H = oe.pop()), oe.length === 0)
                      return;
                    for (let [pe, X] of oe.entries())
                      pe % 2 === 1 ? he.push(n) : he.push(X);
                    if (H !== void 0)
                      if (/\n/.test(H)) {
                        let pe = Re[ke + 1];
                        he.push(b(ge, _(he), Ne, pe));
                      } else
                        he.push(fe);
                    else {
                      let pe = Re[ke + 1];
                      he.push(S(ge, _(he), Ne, pe));
                    }
                  } else
                    /\n/.test(Pe) ? Pe.match(/\n/g).length > 1 && he.push("", u) : he.push("", fe);
                } else {
                  let Pe = se();
                  he.push(Pe);
                  let oe = Re[ke + 1];
                  if (oe && ue(oe)) {
                    let pe = K(N(oe)).split(ce)[0];
                    he.push(S(ge, pe, Ne, oe));
                  } else
                    he.push(u);
                }
              }, "children"), he;
            }
            function S(U, Z, se, fe) {
              return U ? "" : se.type === "JSXElement" && !se.closingElement || fe && fe.type === "JSXElement" && !fe.closingElement ? Z.length === 1 ? i : u : i;
            }
            function b(U, Z, se, fe) {
              return U ? u : Z.length === 1 ? se.type === "JSXElement" && !se.closingElement || fe && fe.type === "JSXElement" && !fe.closingElement ? u : i : u;
            }
            function B(U, Z, se) {
              let fe = U.getParentNode();
              if (!fe || { ArrayExpression: true, JSXAttribute: true, JSXElement: true, JSXExpressionContainer: true, JSXFragment: true, ExpressionStatement: true, CallExpression: true, OptionalCallExpression: true, ConditionalExpression: true, JsExpressionRoot: true }[fe.type])
                return Z;
              let he = U.match(void 0, (ke) => ke.type === "ArrowFunctionExpression", x, (ke) => ke.type === "JSXExpressionContainer"), we = m(U, se);
              return l([we ? "" : g("("), p([i, Z]), i, we ? "" : g(")")], { shouldBreak: he });
            }
            function k(U, Z, se) {
              let fe = U.getValue(), ge = [];
              if (ge.push(se("name")), fe.value) {
                let he;
                if (I(fe.value)) {
                  let ke = N(fe.value).slice(1, -1).replace(/&apos;/g, "'").replace(/&quot;/g, '"'), { escaped: Re, quote: Ne, regex: Pe } = w(ke, Z.jsxSingleQuote ? "'" : '"');
                  ke = ke.replace(Pe, Re);
                  let { leading: oe, trailing: H } = U.call(() => a(U, Z), "value");
                  he = [oe, Ne, ke, Ne, H];
                } else
                  he = se("value");
                ge.push("=", he);
              }
              return ge;
            }
            function M(U, Z, se) {
              let fe = U.getValue(), ge = (he, we) => he.type === "JSXEmptyExpression" || !$(he) && (he.type === "ArrayExpression" || he.type === "ObjectExpression" || he.type === "ArrowFunctionExpression" || he.type === "AwaitExpression" && (ge(he.argument, he) || he.argument.type === "JSXElement") || x(he) || he.type === "FunctionExpression" || he.type === "TemplateLiteral" || he.type === "TaggedTemplateExpression" || he.type === "DoExpression" || E(we) && (he.type === "ConditionalExpression" || P(he)));
              return ge(fe.expression, U.getParentNode(0)) ? l(["{", se("expression"), c, "}"]) : l(["{", p([i, se("expression")]), i, c, "}"]);
            }
            function R(U, Z, se) {
              let fe = U.getValue(), ge = fe.name && $(fe.name) || fe.typeParameters && $(fe.typeParameters);
              if (fe.selfClosing && fe.attributes.length === 0 && !ge)
                return ["<", se("name"), se("typeParameters"), " />"];
              if (fe.attributes && fe.attributes.length === 1 && fe.attributes[0].value && I(fe.attributes[0].value) && !fe.attributes[0].value.value.includes(`
`) && !ge && !$(fe.attributes[0]))
                return l(["<", se("name"), se("typeParameters"), " ", ...U.map(se, "attributes"), fe.selfClosing ? " />" : ">"]);
              let he = fe.attributes && fe.attributes.some((ke) => ke.value && I(ke.value) && ke.value.value.includes(`
`)), we = Z.singleAttributePerLine && fe.attributes.length > 1 ? u : n;
              return l(["<", se("name"), se("typeParameters"), p(U.map(() => [we, se()], "attributes")), ...q(fe, Z, ge)], { shouldBreak: he });
            }
            function q(U, Z, se) {
              return U.selfClosing ? [n, "/>"] : J(U, Z, se) ? [">"] : [i, ">"];
            }
            function J(U, Z, se) {
              let fe = U.attributes.length > 0 && $(_(U.attributes), D.Trailing);
              return U.attributes.length === 0 && !se || (Z.bracketSameLine || Z.jsxBracketSameLine) && (!se || U.attributes.length > 0) && !fe;
            }
            function L(U, Z, se) {
              let fe = U.getValue(), ge = [];
              ge.push("</");
              let he = se("name");
              return $(fe.name, D.Leading | D.Line) ? ge.push(p([u, he]), u) : $(fe.name, D.Leading | D.Block) ? ge.push(" ", he) : ge.push(he), ge.push(">"), ge;
            }
            function Q(U, Z) {
              let se = U.getValue(), fe = $(se), ge = $(se, D.Line), he = se.type === "JSXOpeningFragment";
              return [he ? "<" : "</", p([ge ? u : fe && !he ? " " : "", s(U, Z, true)]), ge ? u : "", ">"];
            }
            function V(U, Z, se) {
              let fe = t3(U, d(U, Z, se), Z);
              return B(U, fe, Z);
            }
            function j(U, Z) {
              let se = U.getValue(), fe = $(se, D.Line);
              return [s(U, Z, !fe), fe ? u : ""];
            }
            function Y(U, Z, se) {
              let fe = U.getValue();
              return ["{", U.call((ge) => {
                let he = ["...", se()], we = ge.getValue();
                return !$(we) || !C(ge) ? he : [p([i, t3(ge, he, Z)]), i];
              }, fe.type === "JSXSpreadAttribute" ? "argument" : "expression"), "}"];
            }
            function ie(U, Z, se) {
              let fe = U.getValue();
              if (fe.type.startsWith("JSX"))
                switch (fe.type) {
                  case "JSXAttribute":
                    return k(U, Z, se);
                  case "JSXIdentifier":
                    return String(fe.name);
                  case "JSXNamespacedName":
                    return f(":", [se("namespace"), se("name")]);
                  case "JSXMemberExpression":
                    return f(".", [se("object"), se("property")]);
                  case "JSXSpreadAttribute":
                    return Y(U, Z, se);
                  case "JSXSpreadChild":
                    return Y(U, Z, se);
                  case "JSXExpressionContainer":
                    return M(U, Z, se);
                  case "JSXFragment":
                  case "JSXElement":
                    return V(U, Z, se);
                  case "JSXOpeningElement":
                    return R(U, Z, se);
                  case "JSXClosingElement":
                    return L(U, Z, se);
                  case "JSXOpeningFragment":
                  case "JSXClosingFragment":
                    return Q(U, Z);
                  case "JSXEmptyExpression":
                    return j(U, Z);
                  case "JSXText":
                    throw new Error("JSXText should be handled by JSXElement");
                  default:
                    throw new Error(`Unknown JSX node type: ${JSON.stringify(fe.type)}.`);
                }
            }
            var ee = ` 
\r	`, ce = new RegExp("([" + ee + "]+)"), W = new RegExp("[^" + ee + "]"), K = (U) => U.replace(new RegExp("(?:^" + ce.source + "|" + ce.source + "$)"), "");
            function de(U) {
              if (U.children.length === 0)
                return true;
              if (U.children.length > 1)
                return false;
              let Z = U.children[0];
              return Z.type === "JSXText" && !ue(Z);
            }
            function ue(U) {
              return U.type === "JSXText" && (W.test(N(U)) || !/\n/.test(N(U)));
            }
            function Fe(U) {
              return U.type === "JSXExpressionContainer" && I(U.expression) && U.expression.value === " " && !$(U.expression);
            }
            function z(U) {
              let Z = U.getValue(), se = U.getParentNode();
              if (!se || !Z || !E(Z) || !E(se))
                return false;
              let fe = se.children.indexOf(Z), ge = null;
              for (let he = fe; he > 0; he--) {
                let we = se.children[he - 1];
                if (!(we.type === "JSXText" && !ue(we))) {
                  ge = we;
                  break;
                }
              }
              return ge && ge.type === "JSXExpressionContainer" && ge.expression.type === "JSXEmptyExpression" && T(ge.expression);
            }
            r.exports = { hasJsxIgnoreComment: z, printJsx: ie };
          } }), ct = te({ "src/language-js/print/misc.js"(e, r) {
            "use strict";
            ne();
            var { isNonEmptyArray: t3 } = Ue(), { builders: { indent: s, join: a, line: n } } = qe(), { isFlowAnnotationComment: u } = Ke();
            function i(_) {
              let w = _.getValue();
              return !w.optional || w.type === "Identifier" && w === _.getParentNode().key ? "" : w.type === "OptionalCallExpression" || w.type === "OptionalMemberExpression" && w.computed ? "?." : "?";
            }
            function l(_) {
              return _.getValue().definite || _.match(void 0, (w, E) => E === "id" && w.type === "VariableDeclarator" && w.definite) ? "!" : "";
            }
            function p(_, w, E) {
              let N = _.getValue();
              return N.typeArguments ? E("typeArguments") : N.typeParameters ? E("typeParameters") : "";
            }
            function y(_, w, E) {
              let N = _.getValue();
              if (!N.typeAnnotation)
                return "";
              let x = _.getParentNode(), I = x.type === "DeclareFunction" && x.id === N;
              return u(w.originalText, N.typeAnnotation) ? [" /*: ", E("typeAnnotation"), " */"] : [I ? "" : ": ", E("typeAnnotation")];
            }
            function h(_, w, E) {
              return ["::", E("callee")];
            }
            function g(_, w, E) {
              let N = _.getValue();
              return t3(N.modifiers) ? [a(" ", _.map(E, "modifiers")), " "] : "";
            }
            function c(_, w, E) {
              return _.type === "EmptyStatement" ? ";" : _.type === "BlockStatement" || E ? [" ", w] : s([n, w]);
            }
            function f(_, w, E) {
              return ["...", E("argument"), y(_, w, E)];
            }
            function F(_, w) {
              let E = _.slice(1, -1);
              if (E.includes('"') || E.includes("'"))
                return _;
              let N = w.singleQuote ? "'" : '"';
              return N + E + N;
            }
            r.exports = { printOptionalToken: i, printDefiniteToken: l, printFunctionTypeParameters: p, printBindExpressionCallee: h, printTypeScriptModifiers: g, printTypeAnnotation: y, printRestSpread: f, adjustClause: c, printDirective: F };
          } }), er = te({ "src/language-js/print/array.js"(e, r) {
            "use strict";
            ne();
            var { printDanglingComments: t3 } = et(), { builders: { line: s, softline: a, hardline: n, group: u, indent: i, ifBreak: l, fill: p } } = qe(), { getLast: y, hasNewline: h } = Ue(), { shouldPrintComma: g, hasComment: c, CommentCheckFlags: f, isNextLineEmpty: F, isNumericLiteral: _, isSignedNumericLiteral: w } = Ke(), { locStart: E } = ut(), { printOptionalToken: N, printTypeAnnotation: x } = ct();
            function I(T, m, C) {
              let o = T.getValue(), d = [], v = o.type === "TupleExpression" ? "#[" : "[", S = "]";
              if (o.elements.length === 0)
                c(o, f.Dangling) ? d.push(u([v, t3(T, m), a, S])) : d.push(v, S);
              else {
                let b = y(o.elements), B = !(b && b.type === "RestElement"), k = b === null, M = Symbol("array"), R = !m.__inJestEach && o.elements.length > 1 && o.elements.every((L, Q, V) => {
                  let j = L && L.type;
                  if (j !== "ArrayExpression" && j !== "ObjectExpression")
                    return false;
                  let Y = V[Q + 1];
                  if (Y && j !== Y.type)
                    return false;
                  let ie = j === "ArrayExpression" ? "elements" : "properties";
                  return L[ie] && L[ie].length > 1;
                }), q = P(o, m), J = B ? k ? "," : g(m) ? q ? l(",", "", { groupId: M }) : l(",") : "" : "";
                d.push(u([v, i([a, q ? D(T, m, C, J) : [$(T, m, "elements", C), J], t3(T, m, true)]), a, S], { shouldBreak: R, id: M }));
              }
              return d.push(N(T), x(T, m, C)), d;
            }
            function P(T, m) {
              return T.elements.length > 1 && T.elements.every((C) => C && (_(C) || w(C) && !c(C.argument)) && !c(C, f.Trailing | f.Line, (o) => !h(m.originalText, E(o), { backwards: true })));
            }
            function $(T, m, C, o) {
              let d = [], v = [];
              return T.each((S) => {
                d.push(v, u(o())), v = [",", s], S.getValue() && F(S.getValue(), m) && v.push(a);
              }, C), d;
            }
            function D(T, m, C, o) {
              let d = [];
              return T.each((v, S, b) => {
                let B = S === b.length - 1;
                d.push([C(), B ? o : ","]), B || d.push(F(v.getValue(), m) ? [n, n] : c(b[S + 1], f.Leading | f.Line) ? n : s);
              }, "elements"), p(d);
            }
            r.exports = { printArray: I, printArrayItems: $, isConciselyPrintedArray: P };
          } }), Ao = te({ "src/language-js/print/call-arguments.js"(e, r) {
            "use strict";
            ne();
            var { printDanglingComments: t3 } = et(), { getLast: s, getPenultimate: a } = Ue(), { getFunctionParameters: n, hasComment: u, CommentCheckFlags: i, isFunctionCompositionArgs: l, isJsxNode: p, isLongCurriedCallExpression: y, shouldPrintComma: h, getCallArguments: g, iterateCallArgumentsPath: c, isNextLineEmpty: f, isCallExpression: F, isStringLiteral: _, isObjectProperty: w, isTSTypeExpression: E } = Ke(), { builders: { line: N, hardline: x, softline: I, group: P, indent: $, conditionalGroup: D, ifBreak: T, breakParent: m }, utils: { willBreak: C } } = qe(), { ArgExpansionBailout: o } = Qt(), { isConciselyPrintedArray: d } = er();
            function v(q, J, L) {
              let Q = q.getValue(), V = Q.type === "ImportExpression", j = g(Q);
              if (j.length === 0)
                return ["(", t3(q, J, true), ")"];
              if (k(j))
                return ["(", L(["arguments", 0]), ", ", L(["arguments", 1]), ")"];
              let Y = false, ie = false, ee = j.length - 1, ce = [];
              c(q, (z, U) => {
                let Z = z.getNode(), se = [L()];
                U === ee || (f(Z, J) ? (U === 0 && (ie = true), Y = true, se.push(",", x, x)) : se.push(",", N)), ce.push(se);
              });
              let W = !(V || Q.callee && Q.callee.type === "Import") && h(J, "all") ? "," : "";
              function K() {
                return P(["(", $([N, ...ce]), W, N, ")"], { shouldBreak: true });
              }
              if (Y || q.getParentNode().type !== "Decorator" && l(j))
                return K();
              let de = B(j), ue = b(j, J);
              if (de || ue) {
                if (de ? ce.slice(1).some(C) : ce.slice(0, -1).some(C))
                  return K();
                let z = [];
                try {
                  q.try(() => {
                    c(q, (U, Z) => {
                      de && Z === 0 && (z = [[L([], { expandFirstArg: true }), ce.length > 1 ? "," : "", ie ? x : N, ie ? x : ""], ...ce.slice(1)]), ue && Z === ee && (z = [...ce.slice(0, -1), L([], { expandLastArg: true })]);
                    });
                  });
                } catch (U) {
                  if (U instanceof o)
                    return K();
                  throw U;
                }
                return [ce.some(C) ? m : "", D([["(", ...z, ")"], de ? ["(", P(z[0], { shouldBreak: true }), ...z.slice(1), ")"] : ["(", ...ce.slice(0, -1), P(s(z), { shouldBreak: true }), ")"], K()])];
              }
              let Fe = ["(", $([I, ...ce]), T(W), I, ")"];
              return y(q) ? Fe : P(Fe, { shouldBreak: ce.some(C) || Y });
            }
            function S(q) {
              let J = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
              return q.type === "ObjectExpression" && (q.properties.length > 0 || u(q)) || q.type === "ArrayExpression" && (q.elements.length > 0 || u(q)) || q.type === "TSTypeAssertion" && S(q.expression) || E(q) && S(q.expression) || q.type === "FunctionExpression" || q.type === "ArrowFunctionExpression" && (!q.returnType || !q.returnType.typeAnnotation || q.returnType.typeAnnotation.type !== "TSTypeReference" || M(q.body)) && (q.body.type === "BlockStatement" || q.body.type === "ArrowFunctionExpression" && S(q.body, true) || q.body.type === "ObjectExpression" || q.body.type === "ArrayExpression" || !J && (F(q.body) || q.body.type === "ConditionalExpression") || p(q.body)) || q.type === "DoExpression" || q.type === "ModuleExpression";
            }
            function b(q, J) {
              let L = s(q), Q = a(q);
              return !u(L, i.Leading) && !u(L, i.Trailing) && S(L) && (!Q || Q.type !== L.type) && (q.length !== 2 || Q.type !== "ArrowFunctionExpression" || L.type !== "ArrayExpression") && !(q.length > 1 && L.type === "ArrayExpression" && d(L, J));
            }
            function B(q) {
              if (q.length !== 2)
                return false;
              let [J, L] = q;
              return J.type === "ModuleExpression" && R(L) ? true : !u(J) && (J.type === "FunctionExpression" || J.type === "ArrowFunctionExpression" && J.body.type === "BlockStatement") && L.type !== "FunctionExpression" && L.type !== "ArrowFunctionExpression" && L.type !== "ConditionalExpression" && !S(L);
            }
            function k(q) {
              return q.length === 2 && q[0].type === "ArrowFunctionExpression" && n(q[0]).length === 0 && q[0].body.type === "BlockStatement" && q[1].type === "ArrayExpression" && !q.some((J) => u(J));
            }
            function M(q) {
              return q.type === "BlockStatement" && (q.body.some((J) => J.type !== "EmptyStatement") || u(q, i.Dangling));
            }
            function R(q) {
              return q.type === "ObjectExpression" && q.properties.length === 1 && w(q.properties[0]) && q.properties[0].key.type === "Identifier" && q.properties[0].key.name === "type" && _(q.properties[0].value) && q.properties[0].value.value === "module";
            }
            r.exports = v;
          } }), So = te({ "src/language-js/print/member.js"(e, r) {
            "use strict";
            ne();
            var { builders: { softline: t3, group: s, indent: a, label: n } } = qe(), { isNumericLiteral: u, isMemberExpression: i, isCallExpression: l } = Ke(), { printOptionalToken: p } = ct();
            function y(g, c, f) {
              let F = g.getValue(), _ = g.getParentNode(), w, E = 0;
              do
                w = g.getParentNode(E), E++;
              while (w && (i(w) || w.type === "TSNonNullExpression"));
              let N = f("object"), x = h(g, c, f), I = w && (w.type === "NewExpression" || w.type === "BindExpression" || w.type === "AssignmentExpression" && w.left.type !== "Identifier") || F.computed || F.object.type === "Identifier" && F.property.type === "Identifier" && !i(_) || (_.type === "AssignmentExpression" || _.type === "VariableDeclarator") && (l(F.object) && F.object.arguments.length > 0 || F.object.type === "TSNonNullExpression" && l(F.object.expression) && F.object.expression.arguments.length > 0 || N.label === "member-chain");
              return n(N.label === "member-chain" ? "member-chain" : "member", [N, I ? x : s(a([t3, x]))]);
            }
            function h(g, c, f) {
              let F = f("property"), _ = g.getValue(), w = p(g);
              return _.computed ? !_.property || u(_.property) ? [w, "[", F, "]"] : s([w, "[", a([t3, F]), t3, "]"]) : [w, ".", F];
            }
            r.exports = { printMemberExpression: y, printMemberLookup: h };
          } }), md = te({ "src/language-js/print/member-chain.js"(e, r) {
            "use strict";
            ne();
            var { printComments: t3 } = et(), { getLast: s, isNextLineEmptyAfterIndex: a, getNextNonSpaceNonCommentCharacterIndex: n } = Ue(), u = qt(), { isCallExpression: i, isMemberExpression: l, isFunctionOrArrowExpression: p, isLongCurriedCallExpression: y, isMemberish: h, isNumericLiteral: g, isSimpleCallArgument: c, hasComment: f, CommentCheckFlags: F, isNextLineEmpty: _ } = Ke(), { locEnd: w } = ut(), { builders: { join: E, hardline: N, group: x, indent: I, conditionalGroup: P, breakParent: $, label: D }, utils: { willBreak: T } } = qe(), m = Ao(), { printMemberLookup: C } = So(), { printOptionalToken: o, printFunctionTypeParameters: d, printBindExpressionCallee: v } = ct();
            function S(b, B, k) {
              let M = b.getParentNode(), R = !M || M.type === "ExpressionStatement", q = [];
              function J(Ne) {
                let { originalText: Pe } = B, oe = n(Pe, Ne, w);
                return Pe.charAt(oe) === ")" ? oe !== false && a(Pe, oe + 1) : _(Ne, B);
              }
              function L(Ne) {
                let Pe = Ne.getValue();
                i(Pe) && (h(Pe.callee) || i(Pe.callee)) ? (q.unshift({ node: Pe, printed: [t3(Ne, [o(Ne), d(Ne, B, k), m(Ne, B, k)], B), J(Pe) ? N : ""] }), Ne.call((oe) => L(oe), "callee")) : h(Pe) ? (q.unshift({ node: Pe, needsParens: u(Ne, B), printed: t3(Ne, l(Pe) ? C(Ne, B, k) : v(Ne, B, k), B) }), Ne.call((oe) => L(oe), "object")) : Pe.type === "TSNonNullExpression" ? (q.unshift({ node: Pe, printed: t3(Ne, "!", B) }), Ne.call((oe) => L(oe), "expression")) : q.unshift({ node: Pe, printed: k() });
              }
              let Q = b.getValue();
              q.unshift({ node: Q, printed: [o(b), d(b, B, k), m(b, B, k)] }), Q.callee && b.call((Ne) => L(Ne), "callee");
              let V = [], j = [q[0]], Y = 1;
              for (; Y < q.length && (q[Y].node.type === "TSNonNullExpression" || i(q[Y].node) || l(q[Y].node) && q[Y].node.computed && g(q[Y].node.property)); ++Y)
                j.push(q[Y]);
              if (!i(q[0].node))
                for (; Y + 1 < q.length && (h(q[Y].node) && h(q[Y + 1].node)); ++Y)
                  j.push(q[Y]);
              V.push(j), j = [];
              let ie = false;
              for (; Y < q.length; ++Y) {
                if (ie && h(q[Y].node)) {
                  if (q[Y].node.computed && g(q[Y].node.property)) {
                    j.push(q[Y]);
                    continue;
                  }
                  V.push(j), j = [], ie = false;
                }
                (i(q[Y].node) || q[Y].node.type === "ImportExpression") && (ie = true), j.push(q[Y]), f(q[Y].node, F.Trailing) && (V.push(j), j = [], ie = false);
              }
              j.length > 0 && V.push(j);
              function ee(Ne) {
                return /^[A-Z]|^[$_]+$/.test(Ne);
              }
              function ce(Ne) {
                return Ne.length <= B.tabWidth;
              }
              function W(Ne) {
                let Pe = Ne[1].length > 0 && Ne[1][0].node.computed;
                if (Ne[0].length === 1) {
                  let H = Ne[0][0].node;
                  return H.type === "ThisExpression" || H.type === "Identifier" && (ee(H.name) || R && ce(H.name) || Pe);
                }
                let oe = s(Ne[0]).node;
                return l(oe) && oe.property.type === "Identifier" && (ee(oe.property.name) || Pe);
              }
              let K = V.length >= 2 && !f(V[1][0].node) && W(V);
              function de(Ne) {
                let Pe = Ne.map((oe) => oe.printed);
                return Ne.length > 0 && s(Ne).needsParens ? ["(", ...Pe, ")"] : Pe;
              }
              function ue(Ne) {
                return Ne.length === 0 ? "" : I(x([N, E(N, Ne.map(de))]));
              }
              let Fe = V.map(de), z = Fe, U = K ? 3 : 2, Z = V.flat(), se = Z.slice(1, -1).some((Ne) => f(Ne.node, F.Leading)) || Z.slice(0, -1).some((Ne) => f(Ne.node, F.Trailing)) || V[U] && f(V[U][0].node, F.Leading);
              if (V.length <= U && !se)
                return y(b) ? z : x(z);
              let fe = s(V[K ? 1 : 0]).node, ge = !i(fe) && J(fe), he = [de(V[0]), K ? V.slice(1, 2).map(de) : "", ge ? N : "", ue(V.slice(K ? 2 : 1))], we = q.map((Ne) => {
                let { node: Pe } = Ne;
                return Pe;
              }).filter(i);
              function ke() {
                let Ne = s(s(V)).node, Pe = s(Fe);
                return i(Ne) && T(Pe) && we.slice(0, -1).some((oe) => oe.arguments.some(p));
              }
              let Re;
              return se || we.length > 2 && we.some((Ne) => !Ne.arguments.every((Pe) => c(Pe, 0))) || Fe.slice(0, -1).some(T) || ke() ? Re = x(he) : Re = [T(z) || ge ? $ : "", P([z, he])], D("member-chain", Re);
            }
            r.exports = S;
          } }), xo = te({ "src/language-js/print/call-expression.js"(e, r) {
            "use strict";
            ne();
            var { builders: { join: t3, group: s } } = qe(), a = qt(), { getCallArguments: n, hasFlowAnnotationComment: u, isCallExpression: i, isMemberish: l, isStringLiteral: p, isTemplateOnItsOwnLine: y, isTestCall: h, iterateCallArgumentsPath: g } = Ke(), c = md(), f = Ao(), { printOptionalToken: F, printFunctionTypeParameters: _ } = ct();
            function w(N, x, I) {
              let P = N.getValue(), $ = N.getParentNode(), D = P.type === "NewExpression", T = P.type === "ImportExpression", m = F(N), C = n(P);
              if (C.length > 0 && (!T && !D && E(P, $) || C.length === 1 && y(C[0], x.originalText) || !D && h(P, $))) {
                let v = [];
                return g(N, () => {
                  v.push(I());
                }), [D ? "new " : "", I("callee"), m, _(N, x, I), "(", t3(", ", v), ")"];
              }
              let o = (x.parser === "babel" || x.parser === "babel-flow") && P.callee && P.callee.type === "Identifier" && u(P.callee.trailingComments);
              if (o && (P.callee.trailingComments[0].printed = true), !T && !D && l(P.callee) && !N.call((v) => a(v, x), "callee"))
                return c(N, x, I);
              let d = [D ? "new " : "", T ? "import" : I("callee"), m, o ? `/*:: ${P.callee.trailingComments[0].value.slice(2).trim()} */` : "", _(N, x, I), f(N, x, I)];
              return T || i(P.callee) ? s(d) : d;
            }
            function E(N, x) {
              if (N.callee.type !== "Identifier")
                return false;
              if (N.callee.name === "require")
                return true;
              if (N.callee.name === "define") {
                let I = n(N);
                return x.type === "ExpressionStatement" && (I.length === 1 || I.length === 2 && I[0].type === "ArrayExpression" || I.length === 3 && p(I[0]) && I[1].type === "ArrayExpression");
              }
              return false;
            }
            r.exports = { printCallExpression: w };
          } }), tr = te({ "src/language-js/print/assignment.js"(e, r) {
            "use strict";
            ne();
            var { isNonEmptyArray: t3, getStringWidth: s } = Ue(), { builders: { line: a, group: n, indent: u, indentIfBreak: i, lineSuffixBoundary: l }, utils: { cleanDoc: p, willBreak: y, canBreak: h } } = qe(), { hasLeadingOwnLineComment: g, isBinaryish: c, isStringLiteral: f, isLiteral: F, isNumericLiteral: _, isCallExpression: w, isMemberExpression: E, getCallArguments: N, rawText: x, hasComment: I, isSignedNumericLiteral: P, isObjectProperty: $ } = Ke(), { shouldInlineLogicalExpression: D } = ru(), { printCallExpression: T } = xo();
            function m(W, K, de, ue, Fe, z) {
              let U = d(W, K, de, ue, z), Z = de(z, { assignmentLayout: U });
              switch (U) {
                case "break-after-operator":
                  return n([n(ue), Fe, n(u([a, Z]))]);
                case "never-break-after-operator":
                  return n([n(ue), Fe, " ", Z]);
                case "fluid": {
                  let se = Symbol("assignment");
                  return n([n(ue), Fe, n(u(a), { id: se }), l, i(Z, { groupId: se })]);
                }
                case "break-lhs":
                  return n([ue, Fe, " ", n(Z)]);
                case "chain":
                  return [n(ue), Fe, a, Z];
                case "chain-tail":
                  return [n(ue), Fe, u([a, Z])];
                case "chain-tail-arrow-chain":
                  return [n(ue), Fe, Z];
                case "only-left":
                  return ue;
              }
            }
            function C(W, K, de) {
              let ue = W.getValue();
              return m(W, K, de, de("left"), [" ", ue.operator], "right");
            }
            function o(W, K, de) {
              return m(W, K, de, de("id"), " =", "init");
            }
            function d(W, K, de, ue, Fe) {
              let z = W.getValue(), U = z[Fe];
              if (!U)
                return "only-left";
              let Z = !b(U);
              if (W.match(b, B, (he) => !Z || he.type !== "ExpressionStatement" && he.type !== "VariableDeclaration"))
                return Z ? U.type === "ArrowFunctionExpression" && U.body.type === "ArrowFunctionExpression" ? "chain-tail-arrow-chain" : "chain-tail" : "chain";
              if (!Z && b(U.right) || g(K.originalText, U))
                return "break-after-operator";
              if (U.type === "CallExpression" && U.callee.name === "require" || K.parser === "json5" || K.parser === "json")
                return "never-break-after-operator";
              if (S(z) || k(z) || q(z) || J(z) && h(ue))
                return "break-lhs";
              let ge = ie(z, ue, K);
              return W.call(() => v(W, K, de, ge), Fe) ? "break-after-operator" : ge || U.type === "TemplateLiteral" || U.type === "TaggedTemplateExpression" || U.type === "BooleanLiteral" || _(U) || U.type === "ClassExpression" ? "never-break-after-operator" : "fluid";
            }
            function v(W, K, de, ue) {
              let Fe = W.getValue();
              if (c(Fe) && !D(Fe))
                return true;
              switch (Fe.type) {
                case "StringLiteralTypeAnnotation":
                case "SequenceExpression":
                  return true;
                case "ConditionalExpression": {
                  let { test: Z } = Fe;
                  return c(Z) && !D(Z);
                }
                case "ClassExpression":
                  return t3(Fe.decorators);
              }
              if (ue)
                return false;
              let z = Fe, U = [];
              for (; ; )
                if (z.type === "UnaryExpression")
                  z = z.argument, U.push("argument");
                else if (z.type === "TSNonNullExpression")
                  z = z.expression, U.push("expression");
                else
                  break;
              return !!(f(z) || W.call(() => V(W, K, de), ...U));
            }
            function S(W) {
              if (B(W)) {
                let K = W.left || W.id;
                return K.type === "ObjectPattern" && K.properties.length > 2 && K.properties.some((de) => $(de) && (!de.shorthand || de.value && de.value.type === "AssignmentPattern"));
              }
              return false;
            }
            function b(W) {
              return W.type === "AssignmentExpression";
            }
            function B(W) {
              return b(W) || W.type === "VariableDeclarator";
            }
            function k(W) {
              let K = M(W);
              if (t3(K)) {
                let de = W.type === "TSTypeAliasDeclaration" ? "constraint" : "bound";
                if (K.length > 1 && K.some((ue) => ue[de] || ue.default))
                  return true;
              }
              return false;
            }
            function M(W) {
              return R(W) && W.typeParameters && W.typeParameters.params ? W.typeParameters.params : null;
            }
            function R(W) {
              return W.type === "TSTypeAliasDeclaration" || W.type === "TypeAlias";
            }
            function q(W) {
              if (W.type !== "VariableDeclarator")
                return false;
              let { typeAnnotation: K } = W.id;
              if (!K || !K.typeAnnotation)
                return false;
              let de = L(K.typeAnnotation);
              return t3(de) && de.length > 1 && de.some((ue) => t3(L(ue)) || ue.type === "TSConditionalType");
            }
            function J(W) {
              return W.type === "VariableDeclarator" && W.init && W.init.type === "ArrowFunctionExpression";
            }
            function L(W) {
              return Q(W) && W.typeParameters && W.typeParameters.params ? W.typeParameters.params : null;
            }
            function Q(W) {
              return W.type === "TSTypeReference" || W.type === "GenericTypeAnnotation";
            }
            function V(W, K, de) {
              let ue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, Fe = W.getValue(), z = () => V(W, K, de, true);
              if (Fe.type === "TSNonNullExpression")
                return W.call(z, "expression");
              if (w(Fe)) {
                if (T(W, K, de).label === "member-chain")
                  return false;
                let Z = N(Fe);
                return !(Z.length === 0 || Z.length === 1 && Y(Z[0], K)) || ee(Fe, de) ? false : W.call(z, "callee");
              }
              return E(Fe) ? W.call(z, "object") : ue && (Fe.type === "Identifier" || Fe.type === "ThisExpression");
            }
            var j = 0.25;
            function Y(W, K) {
              let { printWidth: de } = K;
              if (I(W))
                return false;
              let ue = de * j;
              if (W.type === "ThisExpression" || W.type === "Identifier" && W.name.length <= ue || P(W) && !I(W.argument))
                return true;
              let Fe = W.type === "Literal" && "regex" in W && W.regex.pattern || W.type === "RegExpLiteral" && W.pattern;
              return Fe ? Fe.length <= ue : f(W) ? x(W).length <= ue : W.type === "TemplateLiteral" ? W.expressions.length === 0 && W.quasis[0].value.raw.length <= ue && !W.quasis[0].value.raw.includes(`
`) : F(W);
            }
            function ie(W, K, de) {
              if (!$(W))
                return false;
              K = p(K);
              let ue = 3;
              return typeof K == "string" && s(K) < de.tabWidth + ue;
            }
            function ee(W, K) {
              let de = ce(W);
              if (t3(de)) {
                if (de.length > 1)
                  return true;
                if (de.length === 1) {
                  let Fe = de[0];
                  if (Fe.type === "TSUnionType" || Fe.type === "UnionTypeAnnotation" || Fe.type === "TSIntersectionType" || Fe.type === "IntersectionTypeAnnotation" || Fe.type === "TSTypeLiteral" || Fe.type === "ObjectTypeAnnotation")
                    return true;
                }
                let ue = W.typeParameters ? "typeParameters" : "typeArguments";
                if (y(K(ue)))
                  return true;
              }
              return false;
            }
            function ce(W) {
              return W.typeParameters && W.typeParameters.params || W.typeArguments && W.typeArguments.params;
            }
            r.exports = { printVariableDeclarator: o, printAssignmentExpression: C, printAssignment: m, isArrowFunctionVariableDeclarator: J };
          } }), Lr = te({ "src/language-js/print/function-parameters.js"(e, r) {
            "use strict";
            ne();
            var { getNextNonSpaceNonCommentCharacter: t3 } = Ue(), { printDanglingComments: s } = et(), { builders: { line: a, hardline: n, softline: u, group: i, indent: l, ifBreak: p }, utils: { removeLines: y, willBreak: h } } = qe(), { getFunctionParameters: g, iterateFunctionParametersPath: c, isSimpleType: f, isTestCall: F, isTypeAnnotationAFunction: _, isObjectType: w, isObjectTypePropertyAFunction: E, hasRestParameter: N, shouldPrintComma: x, hasComment: I, isNextLineEmpty: P } = Ke(), { locEnd: $ } = ut(), { ArgExpansionBailout: D } = Qt(), { printFunctionTypeParameters: T } = ct();
            function m(v, S, b, B, k) {
              let M = v.getValue(), R = g(M), q = k ? T(v, b, S) : "";
              if (R.length === 0)
                return [q, "(", s(v, b, true, (ie) => t3(b.originalText, ie, $) === ")"), ")"];
              let J = v.getParentNode(), L = F(J), Q = C(M), V = [];
              if (c(v, (ie, ee) => {
                let ce = ee === R.length - 1;
                ce && M.rest && V.push("..."), V.push(S()), !ce && (V.push(","), L || Q ? V.push(" ") : P(R[ee], b) ? V.push(n, n) : V.push(a));
              }), B) {
                if (h(q) || h(V))
                  throw new D();
                return i([y(q), "(", y(V), ")"]);
              }
              let j = R.every((ie) => !ie.decorators);
              return Q && j ? [q, "(", ...V, ")"] : L ? [q, "(", ...V, ")"] : (E(J) || _(J) || J.type === "TypeAlias" || J.type === "UnionTypeAnnotation" || J.type === "TSUnionType" || J.type === "IntersectionTypeAnnotation" || J.type === "FunctionTypeAnnotation" && J.returnType === M) && R.length === 1 && R[0].name === null && M.this !== R[0] && R[0].typeAnnotation && M.typeParameters === null && f(R[0].typeAnnotation) && !M.rest ? b.arrowParens === "always" ? ["(", ...V, ")"] : V : [q, "(", l([u, ...V]), p(!N(M) && x(b, "all") ? "," : ""), u, ")"];
            }
            function C(v) {
              if (!v)
                return false;
              let S = g(v);
              if (S.length !== 1)
                return false;
              let [b] = S;
              return !I(b) && (b.type === "ObjectPattern" || b.type === "ArrayPattern" || b.type === "Identifier" && b.typeAnnotation && (b.typeAnnotation.type === "TypeAnnotation" || b.typeAnnotation.type === "TSTypeAnnotation") && w(b.typeAnnotation.typeAnnotation) || b.type === "FunctionTypeParam" && w(b.typeAnnotation) || b.type === "AssignmentPattern" && (b.left.type === "ObjectPattern" || b.left.type === "ArrayPattern") && (b.right.type === "Identifier" || b.right.type === "ObjectExpression" && b.right.properties.length === 0 || b.right.type === "ArrayExpression" && b.right.elements.length === 0));
            }
            function o(v) {
              let S;
              return v.returnType ? (S = v.returnType, S.typeAnnotation && (S = S.typeAnnotation)) : v.typeAnnotation && (S = v.typeAnnotation), S;
            }
            function d(v, S) {
              let b = o(v);
              if (!b)
                return false;
              let B = v.typeParameters && v.typeParameters.params;
              if (B) {
                if (B.length > 1)
                  return false;
                if (B.length === 1) {
                  let k = B[0];
                  if (k.constraint || k.default)
                    return false;
                }
              }
              return g(v).length === 1 && (w(b) || h(S));
            }
            r.exports = { printFunctionParameters: m, shouldHugFunctionParameters: C, shouldGroupFunctionParameters: d };
          } }), Or = te({ "src/language-js/print/type-annotation.js"(e, r) {
            "use strict";
            ne();
            var { printComments: t3, printDanglingComments: s } = et(), { isNonEmptyArray: a } = Ue(), { builders: { group: n, join: u, line: i, softline: l, indent: p, align: y, ifBreak: h } } = qe(), g = qt(), { locStart: c } = ut(), { isSimpleType: f, isObjectType: F, hasLeadingOwnLineComment: _, isObjectTypePropertyAFunction: w, shouldPrintComma: E } = Ke(), { printAssignment: N } = tr(), { printFunctionParameters: x, shouldGroupFunctionParameters: I } = Lr(), { printArrayItems: P } = er();
            function $(b) {
              if (f(b) || F(b))
                return true;
              if (b.type === "UnionTypeAnnotation" || b.type === "TSUnionType") {
                let B = b.types.filter((M) => M.type === "VoidTypeAnnotation" || M.type === "TSVoidKeyword" || M.type === "NullLiteralTypeAnnotation" || M.type === "TSNullKeyword").length, k = b.types.some((M) => M.type === "ObjectTypeAnnotation" || M.type === "TSTypeLiteral" || M.type === "GenericTypeAnnotation" || M.type === "TSTypeReference");
                if (b.types.length - 1 === B && k)
                  return true;
              }
              return false;
            }
            function D(b, B, k) {
              let M = B.semi ? ";" : "", R = b.getValue(), q = [];
              return q.push("opaque type ", k("id"), k("typeParameters")), R.supertype && q.push(": ", k("supertype")), R.impltype && q.push(" = ", k("impltype")), q.push(M), q;
            }
            function T(b, B, k) {
              let M = B.semi ? ";" : "", R = b.getValue(), q = [];
              R.declare && q.push("declare "), q.push("type ", k("id"), k("typeParameters"));
              let J = R.type === "TSTypeAliasDeclaration" ? "typeAnnotation" : "right";
              return [N(b, B, k, q, " =", J), M];
            }
            function m(b, B, k) {
              let M = b.getValue(), R = b.map(k, "types"), q = [], J = false;
              for (let L = 0; L < R.length; ++L)
                L === 0 ? q.push(R[L]) : F(M.types[L - 1]) && F(M.types[L]) ? q.push([" & ", J ? p(R[L]) : R[L]]) : !F(M.types[L - 1]) && !F(M.types[L]) ? q.push(p([" &", i, R[L]])) : (L > 1 && (J = true), q.push(" & ", L > 1 ? p(R[L]) : R[L]));
              return n(q);
            }
            function C(b, B, k) {
              let M = b.getValue(), R = b.getParentNode(), q = R.type !== "TypeParameterInstantiation" && R.type !== "TSTypeParameterInstantiation" && R.type !== "GenericTypeAnnotation" && R.type !== "TSTypeReference" && R.type !== "TSTypeAssertion" && R.type !== "TupleTypeAnnotation" && R.type !== "TSTupleType" && !(R.type === "FunctionTypeParam" && !R.name && b.getParentNode(1).this !== R) && !((R.type === "TypeAlias" || R.type === "VariableDeclarator" || R.type === "TSTypeAliasDeclaration") && _(B.originalText, M)), J = $(M), L = b.map((j) => {
                let Y = k();
                return J || (Y = y(2, Y)), t3(j, Y, B);
              }, "types");
              if (J)
                return u(" | ", L);
              let Q = q && !_(B.originalText, M), V = [h([Q ? i : "", "| "]), u([i, "| "], L)];
              return g(b, B) ? n([p(V), l]) : R.type === "TupleTypeAnnotation" && R.types.length > 1 || R.type === "TSTupleType" && R.elementTypes.length > 1 ? n([p([h(["(", l]), V]), l, h(")")]) : n(q ? p(V) : V);
            }
            function o(b, B, k) {
              let M = b.getValue(), R = [], q = b.getParentNode(0), J = b.getParentNode(1), L = b.getParentNode(2), Q = M.type === "TSFunctionType" || !((q.type === "ObjectTypeProperty" || q.type === "ObjectTypeInternalSlot") && !q.variance && !q.optional && c(q) === c(M) || q.type === "ObjectTypeCallProperty" || L && L.type === "DeclareFunction"), V = Q && (q.type === "TypeAnnotation" || q.type === "TSTypeAnnotation"), j = V && Q && (q.type === "TypeAnnotation" || q.type === "TSTypeAnnotation") && J.type === "ArrowFunctionExpression";
              w(q) && (Q = true, V = true), j && R.push("(");
              let Y = x(b, k, B, false, true), ie = M.returnType || M.predicate || M.typeAnnotation ? [Q ? " => " : ": ", k("returnType"), k("predicate"), k("typeAnnotation")] : "", ee = I(M, ie);
              return R.push(ee ? n(Y) : Y), ie && R.push(ie), j && R.push(")"), n(R);
            }
            function d(b, B, k) {
              let M = b.getValue(), R = M.type === "TSTupleType" ? "elementTypes" : "types", q = M[R], J = a(q), L = J ? l : "";
              return n(["[", p([L, P(b, B, R, k)]), h(J && E(B, "all") ? "," : ""), s(b, B, true), L, "]"]);
            }
            function v(b, B, k) {
              let M = b.getValue(), R = M.type === "OptionalIndexedAccessType" && M.optional ? "?.[" : "[";
              return [k("objectType"), R, k("indexType"), "]"];
            }
            function S(b, B, k) {
              let M = b.getValue();
              return [M.postfix ? "" : k, B("typeAnnotation"), M.postfix ? k : ""];
            }
            r.exports = { printOpaqueType: D, printTypeAlias: T, printIntersectionType: m, printUnionType: C, printFunctionType: o, printTupleType: d, printIndexedAccessType: v, shouldHugType: $, printJSDocType: S };
          } }), jr = te({ "src/language-js/print/type-parameters.js"(e, r) {
            "use strict";
            ne();
            var { printDanglingComments: t3 } = et(), { builders: { join: s, line: a, hardline: n, softline: u, group: i, indent: l, ifBreak: p } } = qe(), { isTestCall: y, hasComment: h, CommentCheckFlags: g, isTSXFile: c, shouldPrintComma: f, getFunctionParameters: F, isObjectType: _, getTypeScriptMappedTypeModifier: w } = Ke(), { createGroupIdMapper: E } = Ue(), { shouldHugType: N } = Or(), { isArrowFunctionVariableDeclarator: x } = tr(), I = E("typeParameters");
            function P(T, m, C, o) {
              let d = T.getValue();
              if (!d[o])
                return "";
              if (!Array.isArray(d[o]))
                return C(o);
              let v = T.getNode(2), S = v && y(v), b = T.match((M) => !(M[o].length === 1 && _(M[o][0])), void 0, (M, R) => R === "typeAnnotation", (M) => M.type === "Identifier", x);
              if (d[o].length === 0 || !b && (S || d[o].length === 1 && (d[o][0].type === "NullableTypeAnnotation" || N(d[o][0]))))
                return ["<", s(", ", T.map(C, o)), $(T, m), ">"];
              let k = d.type === "TSTypeParameterInstantiation" ? "" : F(d).length === 1 && c(m) && !d[o][0].constraint && T.getParentNode().type === "ArrowFunctionExpression" ? "," : f(m, "all") ? p(",") : "";
              return i(["<", l([u, s([",", a], T.map(C, o))]), k, u, ">"], { id: I(d) });
            }
            function $(T, m) {
              let C = T.getValue();
              if (!h(C, g.Dangling))
                return "";
              let o = !h(C, g.Line), d = t3(T, m, o);
              return o ? d : [d, n];
            }
            function D(T, m, C) {
              let o = T.getValue(), d = [o.type === "TSTypeParameter" && o.const ? "const " : ""], v = T.getParentNode();
              return v.type === "TSMappedType" ? (v.readonly && d.push(w(v.readonly, "readonly"), " "), d.push("[", C("name")), o.constraint && d.push(" in ", C("constraint")), v.nameType && d.push(" as ", T.callParent(() => C("nameType"))), d.push("]"), d) : (o.variance && d.push(C("variance")), o.in && d.push("in "), o.out && d.push("out "), d.push(C("name")), o.bound && d.push(": ", C("bound")), o.constraint && d.push(" extends ", C("constraint")), o.default && d.push(" = ", C("default")), d);
            }
            r.exports = { printTypeParameter: D, printTypeParameters: P, getTypeParametersGroupId: I };
          } }), rr = te({ "src/language-js/print/property.js"(e, r) {
            "use strict";
            ne();
            var { printComments: t3 } = et(), { printString: s, printNumber: a } = Ue(), { isNumericLiteral: n, isSimpleNumber: u, isStringLiteral: i, isStringPropSafeToUnquote: l, rawText: p } = Ke(), { printAssignment: y } = tr(), h = /* @__PURE__ */ new WeakMap();
            function g(f, F, _) {
              let w = f.getNode();
              if (w.computed)
                return ["[", _("key"), "]"];
              let E = f.getParentNode(), { key: N } = w;
              if (F.quoteProps === "consistent" && !h.has(E)) {
                let x = (E.properties || E.body || E.members).some((I) => !I.computed && I.key && i(I.key) && !l(I, F));
                h.set(E, x);
              }
              if ((N.type === "Identifier" || n(N) && u(a(p(N))) && String(N.value) === a(p(N)) && !(F.parser === "typescript" || F.parser === "babel-ts")) && (F.parser === "json" || F.quoteProps === "consistent" && h.get(E))) {
                let x = s(JSON.stringify(N.type === "Identifier" ? N.name : N.value.toString()), F);
                return f.call((I) => t3(I, x, F), "key");
              }
              return l(w, F) && (F.quoteProps === "as-needed" || F.quoteProps === "consistent" && !h.get(E)) ? f.call((x) => t3(x, /^\d/.test(N.value) ? a(N.value) : N.value, F), "key") : _("key");
            }
            function c(f, F, _) {
              return f.getValue().shorthand ? _("value") : y(f, F, _, g(f, F, _), ":", "value");
            }
            r.exports = { printProperty: c, printPropertyKey: g };
          } }), qr = te({ "src/language-js/print/function.js"(e, r) {
            "use strict";
            ne();
            var t3 = Zt(), { printDanglingComments: s, printCommentsSeparately: a } = et(), n = lt2(), { getNextNonSpaceNonCommentCharacterIndex: u } = Ue(), { builders: { line: i, softline: l, group: p, indent: y, ifBreak: h, hardline: g, join: c, indentIfBreak: f }, utils: { removeLines: F, willBreak: _ } } = qe(), { ArgExpansionBailout: w } = Qt(), { getFunctionParameters: E, hasLeadingOwnLineComment: N, isFlowAnnotationComment: x, isJsxNode: I, isTemplateOnItsOwnLine: P, shouldPrintComma: $, startsWithNoLookaheadToken: D, isBinaryish: T, isLineComment: m, hasComment: C, getComments: o, CommentCheckFlags: d, isCallLikeExpression: v, isCallExpression: S, getCallArguments: b, hasNakedLeftSide: B, getLeftSide: k } = Ke(), { locEnd: M } = ut(), { printFunctionParameters: R, shouldGroupFunctionParameters: q } = Lr(), { printPropertyKey: J } = rr(), { printFunctionTypeParameters: L } = ct();
            function Q(U, Z, se, fe) {
              let ge = U.getValue(), he = false;
              if ((ge.type === "FunctionDeclaration" || ge.type === "FunctionExpression") && fe && fe.expandLastArg) {
                let Pe = U.getParentNode();
                S(Pe) && b(Pe).length > 1 && (he = true);
              }
              let we = [];
              ge.type === "TSDeclareFunction" && ge.declare && we.push("declare "), ge.async && we.push("async "), ge.generator ? we.push("function* ") : we.push("function "), ge.id && we.push(Z("id"));
              let ke = R(U, Z, se, he), Re = K(U, Z, se), Ne = q(ge, Re);
              return we.push(L(U, se, Z), p([Ne ? p(ke) : ke, Re]), ge.body ? " " : "", Z("body")), se.semi && (ge.declare || !ge.body) && we.push(";"), we;
            }
            function V(U, Z, se) {
              let fe = U.getNode(), { kind: ge } = fe, he = fe.value || fe, we = [];
              return !ge || ge === "init" || ge === "method" || ge === "constructor" ? he.async && we.push("async ") : (t3.ok(ge === "get" || ge === "set"), we.push(ge, " ")), he.generator && we.push("*"), we.push(J(U, Z, se), fe.optional || fe.key.optional ? "?" : ""), fe === he ? we.push(j(U, Z, se)) : he.type === "FunctionExpression" ? we.push(U.call((ke) => j(ke, Z, se), "value")) : we.push(se("value")), we;
            }
            function j(U, Z, se) {
              let fe = U.getNode(), ge = R(U, se, Z), he = K(U, se, Z), we = q(fe, he), ke = [L(U, Z, se), p([we ? p(ge) : ge, he])];
              return fe.body ? ke.push(" ", se("body")) : ke.push(Z.semi ? ";" : ""), ke;
            }
            function Y(U, Z, se, fe) {
              let ge = U.getValue(), he = [];
              if (ge.async && he.push("async "), W(U, Z))
                he.push(se(["params", 0]));
              else {
                let ke = fe && (fe.expandLastArg || fe.expandFirstArg), Re = K(U, se, Z);
                if (ke) {
                  if (_(Re))
                    throw new w();
                  Re = p(F(Re));
                }
                he.push(p([R(U, se, Z, ke, true), Re]));
              }
              let we = s(U, Z, true, (ke) => {
                let Re = u(Z.originalText, ke, M);
                return Re !== false && Z.originalText.slice(Re, Re + 2) === "=>";
              });
              return we && he.push(" ", we), he;
            }
            function ie(U, Z, se, fe, ge, he) {
              let we = U.getName(), ke = U.getParentNode(), Re = v(ke) && we === "callee", Ne = Boolean(Z && Z.assignmentLayout), Pe = he.body.type !== "BlockStatement" && he.body.type !== "ObjectExpression" && he.body.type !== "SequenceExpression", oe = Re && Pe || Z && Z.assignmentLayout === "chain-tail-arrow-chain", H = Symbol("arrow-chain");
              return he.body.type === "SequenceExpression" && (ge = p(["(", y([l, ge]), l, ")"])), p([p(y([Re || Ne ? l : "", p(c([" =>", i], se), { shouldBreak: fe })]), { id: H, shouldBreak: oe }), " =>", f(Pe ? y([i, ge]) : [" ", ge], { groupId: H }), Re ? h(l, "", { groupId: H }) : ""]);
            }
            function ee(U, Z, se, fe) {
              let ge = U.getValue(), he = [], we = [], ke = false;
              if (function H() {
                let pe = Y(U, Z, se, fe);
                if (he.length === 0)
                  he.push(pe);
                else {
                  let { leading: X, trailing: le } = a(U, Z);
                  he.push([X, pe]), we.unshift(le);
                }
                ke = ke || ge.returnType && E(ge).length > 0 || ge.typeParameters || E(ge).some((X) => X.type !== "Identifier"), ge.body.type !== "ArrowFunctionExpression" || fe && fe.expandLastArg ? we.unshift(se("body", fe)) : (ge = ge.body, U.call(H, "body"));
              }(), he.length > 1)
                return ie(U, fe, he, ke, we, ge);
              let Re = he;
              if (Re.push(" =>"), !N(Z.originalText, ge.body) && (ge.body.type === "ArrayExpression" || ge.body.type === "ObjectExpression" || ge.body.type === "BlockStatement" || I(ge.body) || P(ge.body, Z.originalText) || ge.body.type === "ArrowFunctionExpression" || ge.body.type === "DoExpression"))
                return p([...Re, " ", we]);
              if (ge.body.type === "SequenceExpression")
                return p([...Re, p([" (", y([l, we]), l, ")"])]);
              let Ne = (fe && fe.expandLastArg || U.getParentNode().type === "JSXExpressionContainer") && !C(ge), Pe = fe && fe.expandLastArg && $(Z, "all"), oe = ge.body.type === "ConditionalExpression" && !D(ge.body, (H) => H.type === "ObjectExpression");
              return p([...Re, p([y([i, oe ? h("", "(") : "", we, oe ? h("", ")") : ""]), Ne ? [h(Pe ? "," : ""), l] : ""])]);
            }
            function ce(U) {
              let Z = E(U);
              return Z.length === 1 && !U.typeParameters && !C(U, d.Dangling) && Z[0].type === "Identifier" && !Z[0].typeAnnotation && !C(Z[0]) && !Z[0].optional && !U.predicate && !U.returnType;
            }
            function W(U, Z) {
              if (Z.arrowParens === "always")
                return false;
              if (Z.arrowParens === "avoid") {
                let se = U.getValue();
                return ce(se);
              }
              return false;
            }
            function K(U, Z, se) {
              let fe = U.getValue(), ge = Z("returnType");
              if (fe.returnType && x(se.originalText, fe.returnType))
                return [" /*: ", ge, " */"];
              let he = [ge];
              return fe.returnType && fe.returnType.typeAnnotation && he.unshift(": "), fe.predicate && he.push(fe.returnType ? " " : ": ", Z("predicate")), he;
            }
            function de(U, Z, se) {
              let fe = U.getValue(), ge = Z.semi ? ";" : "", he = [];
              fe.argument && (z(Z, fe.argument) ? he.push([" (", y([g, se("argument")]), g, ")"]) : T(fe.argument) || fe.argument.type === "SequenceExpression" ? he.push(p([h(" (", " "), y([l, se("argument")]), l, h(")")])) : he.push(" ", se("argument")));
              let we = o(fe), ke = n(we), Re = ke && m(ke);
              return Re && he.push(ge), C(fe, d.Dangling) && he.push(" ", s(U, Z, true)), Re || he.push(ge), he;
            }
            function ue(U, Z, se) {
              return ["return", de(U, Z, se)];
            }
            function Fe(U, Z, se) {
              return ["throw", de(U, Z, se)];
            }
            function z(U, Z) {
              if (N(U.originalText, Z))
                return true;
              if (B(Z)) {
                let se = Z, fe;
                for (; fe = k(se); )
                  if (se = fe, N(U.originalText, se))
                    return true;
              }
              return false;
            }
            r.exports = { printFunction: Q, printArrowFunction: ee, printMethod: V, printReturnStatement: ue, printThrowStatement: Fe, printMethodInternal: j, shouldPrintParamsWithoutParens: W };
          } }), nu = te({ "src/language-js/print/decorators.js"(e, r) {
            "use strict";
            ne();
            var { isNonEmptyArray: t3, hasNewline: s } = Ue(), { builders: { line: a, hardline: n, join: u, breakParent: i, group: l } } = qe(), { locStart: p, locEnd: y } = ut(), { getParentExportDeclaration: h } = Ke();
            function g(w, E, N) {
              let x = w.getValue();
              return l([u(a, w.map(N, "decorators")), F(x, E) ? n : a]);
            }
            function c(w, E, N) {
              return [u(n, w.map(N, "declaration", "decorators")), n];
            }
            function f(w, E, N) {
              let x = w.getValue(), { decorators: I } = x;
              if (!t3(I) || _(w.getParentNode()))
                return;
              let P = x.type === "ClassExpression" || x.type === "ClassDeclaration" || F(x, E);
              return [h(w) ? n : P ? i : "", u(a, w.map(N, "decorators")), a];
            }
            function F(w, E) {
              return w.decorators.some((N) => s(E.originalText, y(N)));
            }
            function _(w) {
              if (w.type !== "ExportDefaultDeclaration" && w.type !== "ExportNamedDeclaration" && w.type !== "DeclareExportDeclaration")
                return false;
              let E = w.declaration && w.declaration.decorators;
              return t3(E) && p(w) === p(E[0]);
            }
            r.exports = { printDecorators: f, printClassMemberDecorators: g, printDecoratorsBeforeExport: c, hasDecoratorsBeforeExport: _ };
          } }), nr = te({ "src/language-js/print/class.js"(e, r) {
            "use strict";
            ne();
            var { isNonEmptyArray: t3, createGroupIdMapper: s } = Ue(), { printComments: a, printDanglingComments: n } = et(), { builders: { join: u, line: i, hardline: l, softline: p, group: y, indent: h, ifBreak: g } } = qe(), { hasComment: c, CommentCheckFlags: f } = Ke(), { getTypeParametersGroupId: F } = jr(), { printMethod: _ } = qr(), { printOptionalToken: w, printTypeAnnotation: E, printDefiniteToken: N } = ct(), { printPropertyKey: x } = rr(), { printAssignment: I } = tr(), { printClassMemberDecorators: P } = nu();
            function $(b, B, k) {
              let M = b.getValue(), R = [];
              M.declare && R.push("declare "), M.abstract && R.push("abstract "), R.push("class");
              let q = M.id && c(M.id, f.Trailing) || M.typeParameters && c(M.typeParameters, f.Trailing) || M.superClass && c(M.superClass) || t3(M.extends) || t3(M.mixins) || t3(M.implements), J = [], L = [];
              if (M.id && J.push(" ", k("id")), J.push(k("typeParameters")), M.superClass) {
                let Q = [d(b, B, k), k("superTypeParameters")], V = b.call((j) => ["extends ", a(j, Q, B)], "superClass");
                q ? L.push(i, y(V)) : L.push(" ", V);
              } else
                L.push(o(b, B, k, "extends"));
              if (L.push(o(b, B, k, "mixins"), o(b, B, k, "implements")), q) {
                let Q;
                C(M) ? Q = [...J, h(L)] : Q = h([...J, L]), R.push(y(Q, { id: D(M) }));
              } else
                R.push(...J, ...L);
              return R.push(" ", k("body")), R;
            }
            var D = s("heritageGroup");
            function T(b) {
              return g(l, "", { groupId: D(b) });
            }
            function m(b) {
              return ["superClass", "extends", "mixins", "implements"].filter((B) => Boolean(b[B])).length > 1;
            }
            function C(b) {
              return b.typeParameters && !c(b.typeParameters, f.Trailing | f.Line) && !m(b);
            }
            function o(b, B, k, M) {
              let R = b.getValue();
              if (!t3(R[M]))
                return "";
              let q = n(b, B, true, (J) => {
                let { marker: L } = J;
                return L === M;
              });
              return [C(R) ? g(" ", i, { groupId: F(R.typeParameters) }) : i, q, q && l, M, y(h([i, u([",", i], b.map(k, M))]))];
            }
            function d(b, B, k) {
              let M = k("superClass");
              return b.getParentNode().type === "AssignmentExpression" ? y(g(["(", h([p, M]), p, ")"], M)) : M;
            }
            function v(b, B, k) {
              let M = b.getValue(), R = [];
              return t3(M.decorators) && R.push(P(b, B, k)), M.accessibility && R.push(M.accessibility + " "), M.readonly && R.push("readonly "), M.declare && R.push("declare "), M.static && R.push("static "), (M.type === "TSAbstractMethodDefinition" || M.abstract) && R.push("abstract "), M.override && R.push("override "), R.push(_(b, B, k)), R;
            }
            function S(b, B, k) {
              let M = b.getValue(), R = [], q = B.semi ? ";" : "";
              return t3(M.decorators) && R.push(P(b, B, k)), M.accessibility && R.push(M.accessibility + " "), M.declare && R.push("declare "), M.static && R.push("static "), (M.type === "TSAbstractPropertyDefinition" || M.type === "TSAbstractAccessorProperty" || M.abstract) && R.push("abstract "), M.override && R.push("override "), M.readonly && R.push("readonly "), M.variance && R.push(k("variance")), (M.type === "ClassAccessorProperty" || M.type === "AccessorProperty" || M.type === "TSAbstractAccessorProperty") && R.push("accessor "), R.push(x(b, B, k), w(b), N(b), E(b, B, k)), [I(b, B, k, R, " =", "value"), q];
            }
            r.exports = { printClass: $, printClassMethod: v, printClassProperty: S, printHardlineAfterHeritage: T };
          } }), bo = te({ "src/language-js/print/interface.js"(e, r) {
            "use strict";
            ne();
            var { isNonEmptyArray: t3 } = Ue(), { builders: { join: s, line: a, group: n, indent: u, ifBreak: i } } = qe(), { hasComment: l, identity: p, CommentCheckFlags: y } = Ke(), { getTypeParametersGroupId: h } = jr(), { printTypeScriptModifiers: g } = ct();
            function c(f, F, _) {
              let w = f.getValue(), E = [];
              w.declare && E.push("declare "), w.type === "TSInterfaceDeclaration" && E.push(w.abstract ? "abstract " : "", g(f, F, _)), E.push("interface");
              let N = [], x = [];
              w.type !== "InterfaceTypeAnnotation" && N.push(" ", _("id"), _("typeParameters"));
              let I = w.typeParameters && !l(w.typeParameters, y.Trailing | y.Line);
              return t3(w.extends) && x.push(I ? i(" ", a, { groupId: h(w.typeParameters) }) : a, "extends ", (w.extends.length === 1 ? p : u)(s([",", a], f.map(_, "extends")))), w.id && l(w.id, y.Trailing) || t3(w.extends) ? I ? E.push(n([...N, u(x)])) : E.push(n(u([...N, ...x]))) : E.push(...N, ...x), E.push(" ", _("body")), n(E);
            }
            r.exports = { printInterface: c };
          } }), To = te({ "src/language-js/print/module.js"(e, r) {
            "use strict";
            ne();
            var { isNonEmptyArray: t3 } = Ue(), { builders: { softline: s, group: a, indent: n, join: u, line: i, ifBreak: l, hardline: p } } = qe(), { printDanglingComments: y } = et(), { hasComment: h, CommentCheckFlags: g, shouldPrintComma: c, needsHardlineAfterDanglingComment: f, isStringLiteral: F, rawText: _ } = Ke(), { locStart: w, hasSameLoc: E } = ut(), { hasDecoratorsBeforeExport: N, printDecoratorsBeforeExport: x } = nu();
            function I(S, b, B) {
              let k = S.getValue(), M = b.semi ? ";" : "", R = [], { importKind: q } = k;
              return R.push("import"), q && q !== "value" && R.push(" ", q), R.push(m(S, b, B), T(S, b, B), o(S, b, B), M), R;
            }
            function P(S, b, B) {
              let k = S.getValue(), M = [];
              N(k) && M.push(x(S, b, B));
              let { type: R, exportKind: q, declaration: J } = k;
              return M.push("export"), (k.default || R === "ExportDefaultDeclaration") && M.push(" default"), h(k, g.Dangling) && (M.push(" ", y(S, b, true)), f(k) && M.push(p)), J ? M.push(" ", B("declaration")) : M.push(q === "type" ? " type" : "", m(S, b, B), T(S, b, B), o(S, b, B)), D(k, b) && M.push(";"), M;
            }
            function $(S, b, B) {
              let k = S.getValue(), M = b.semi ? ";" : "", R = [], { exportKind: q, exported: J } = k;
              return R.push("export"), q === "type" && R.push(" type"), R.push(" *"), J && R.push(" as ", B("exported")), R.push(T(S, b, B), o(S, b, B), M), R;
            }
            function D(S, b) {
              if (!b.semi)
                return false;
              let { type: B, declaration: k } = S, M = S.default || B === "ExportDefaultDeclaration";
              if (!k)
                return true;
              let { type: R } = k;
              return !!(M && R !== "ClassDeclaration" && R !== "FunctionDeclaration" && R !== "TSInterfaceDeclaration" && R !== "DeclareClass" && R !== "DeclareFunction" && R !== "TSDeclareFunction" && R !== "EnumDeclaration");
            }
            function T(S, b, B) {
              let k = S.getValue();
              if (!k.source)
                return "";
              let M = [];
              return C(k, b) || M.push(" from"), M.push(" ", B("source")), M;
            }
            function m(S, b, B) {
              let k = S.getValue();
              if (C(k, b))
                return "";
              let M = [" "];
              if (t3(k.specifiers)) {
                let R = [], q = [];
                S.each(() => {
                  let J = S.getValue().type;
                  if (J === "ExportNamespaceSpecifier" || J === "ExportDefaultSpecifier" || J === "ImportNamespaceSpecifier" || J === "ImportDefaultSpecifier")
                    R.push(B());
                  else if (J === "ExportSpecifier" || J === "ImportSpecifier")
                    q.push(B());
                  else
                    throw new Error(`Unknown specifier type ${JSON.stringify(J)}`);
                }, "specifiers"), M.push(u(", ", R)), q.length > 0 && (R.length > 0 && M.push(", "), q.length > 1 || R.length > 0 || k.specifiers.some((L) => h(L)) ? M.push(a(["{", n([b.bracketSpacing ? i : s, u([",", i], q)]), l(c(b) ? "," : ""), b.bracketSpacing ? i : s, "}"])) : M.push(["{", b.bracketSpacing ? " " : "", ...q, b.bracketSpacing ? " " : "", "}"]));
              } else
                M.push("{}");
              return M;
            }
            function C(S, b) {
              let { type: B, importKind: k, source: M, specifiers: R } = S;
              return B !== "ImportDeclaration" || t3(R) || k === "type" ? false : !/{\s*}/.test(b.originalText.slice(w(S), w(M)));
            }
            function o(S, b, B) {
              let k = S.getNode();
              return t3(k.assertions) ? [" assert {", b.bracketSpacing ? " " : "", u(", ", S.map(B, "assertions")), b.bracketSpacing ? " " : "", "}"] : "";
            }
            function d(S, b, B) {
              let k = S.getNode(), { type: M } = k, R = [], q = M === "ImportSpecifier" ? k.importKind : k.exportKind;
              q && q !== "value" && R.push(q, " ");
              let J = M.startsWith("Import"), L = J ? "imported" : "local", Q = J ? "local" : "exported", V = k[L], j = k[Q], Y = "", ie = "";
              return M === "ExportNamespaceSpecifier" || M === "ImportNamespaceSpecifier" ? Y = "*" : V && (Y = B(L)), j && !v(k) && (ie = B(Q)), R.push(Y, Y && ie ? " as " : "", ie), R;
            }
            function v(S) {
              if (S.type !== "ImportSpecifier" && S.type !== "ExportSpecifier")
                return false;
              let { local: b, [S.type === "ImportSpecifier" ? "imported" : "exported"]: B } = S;
              if (b.type !== B.type || !E(b, B))
                return false;
              if (F(b))
                return b.value === B.value && _(b) === _(B);
              switch (b.type) {
                case "Identifier":
                  return b.name === B.name;
                default:
                  return false;
              }
            }
            r.exports = { printImportDeclaration: I, printExportDeclaration: P, printExportAllDeclaration: $, printModuleSpecifier: d };
          } }), uu = te({ "src/language-js/print/object.js"(e, r) {
            "use strict";
            ne();
            var { printDanglingComments: t3 } = et(), { builders: { line: s, softline: a, group: n, indent: u, ifBreak: i, hardline: l } } = qe(), { getLast: p, hasNewlineInRange: y, hasNewline: h, isNonEmptyArray: g } = Ue(), { shouldPrintComma: c, hasComment: f, getComments: F, CommentCheckFlags: _, isNextLineEmpty: w } = Ke(), { locStart: E, locEnd: N } = ut(), { printOptionalToken: x, printTypeAnnotation: I } = ct(), { shouldHugFunctionParameters: P } = Lr(), { shouldHugType: $ } = Or(), { printHardlineAfterHeritage: D } = nr();
            function T(m, C, o) {
              let d = C.semi ? ";" : "", v = m.getValue(), S;
              v.type === "TSTypeLiteral" ? S = "members" : v.type === "TSInterfaceBody" ? S = "body" : S = "properties";
              let b = v.type === "ObjectTypeAnnotation", B = [S];
              b && B.push("indexers", "callProperties", "internalSlots");
              let k = B.map((W) => v[W][0]).sort((W, K) => E(W) - E(K))[0], M = m.getParentNode(0), R = b && M && (M.type === "InterfaceDeclaration" || M.type === "DeclareInterface" || M.type === "DeclareClass") && m.getName() === "body", q = v.type === "TSInterfaceBody" || R || v.type === "ObjectPattern" && M.type !== "FunctionDeclaration" && M.type !== "FunctionExpression" && M.type !== "ArrowFunctionExpression" && M.type !== "ObjectMethod" && M.type !== "ClassMethod" && M.type !== "ClassPrivateMethod" && M.type !== "AssignmentPattern" && M.type !== "CatchClause" && v.properties.some((W) => W.value && (W.value.type === "ObjectPattern" || W.value.type === "ArrayPattern")) || v.type !== "ObjectPattern" && k && y(C.originalText, E(v), E(k)), J = R ? ";" : v.type === "TSInterfaceBody" || v.type === "TSTypeLiteral" ? i(d, ";") : ",", L = v.type === "RecordExpression" ? "#{" : v.exact ? "{|" : "{", Q = v.exact ? "|}" : "}", V = [];
              for (let W of B)
                m.each((K) => {
                  let de = K.getValue();
                  V.push({ node: de, printed: o(), loc: E(de) });
                }, W);
              B.length > 1 && V.sort((W, K) => W.loc - K.loc);
              let j = [], Y = V.map((W) => {
                let K = [...j, n(W.printed)];
                return j = [J, s], (W.node.type === "TSPropertySignature" || W.node.type === "TSMethodSignature" || W.node.type === "TSConstructSignatureDeclaration") && f(W.node, _.PrettierIgnore) && j.shift(), w(W.node, C) && j.push(l), K;
              });
              if (v.inexact) {
                let W;
                if (f(v, _.Dangling)) {
                  let K = f(v, _.Line);
                  W = [t3(m, C, true), K || h(C.originalText, N(p(F(v)))) ? l : s, "..."];
                } else
                  W = ["..."];
                Y.push([...j, ...W]);
              }
              let ie = p(v[S]), ee = !(v.inexact || ie && ie.type === "RestElement" || ie && (ie.type === "TSPropertySignature" || ie.type === "TSCallSignatureDeclaration" || ie.type === "TSMethodSignature" || ie.type === "TSConstructSignatureDeclaration") && f(ie, _.PrettierIgnore)), ce;
              if (Y.length === 0) {
                if (!f(v, _.Dangling))
                  return [L, Q, I(m, C, o)];
                ce = n([L, t3(m, C), a, Q, x(m), I(m, C, o)]);
              } else
                ce = [R && g(v.properties) ? D(M) : "", L, u([C.bracketSpacing ? s : a, ...Y]), i(ee && (J !== "," || c(C)) ? J : ""), C.bracketSpacing ? s : a, Q, x(m), I(m, C, o)];
              return m.match((W) => W.type === "ObjectPattern" && !W.decorators, (W, K, de) => P(W) && (K === "params" || K === "parameters" || K === "this" || K === "rest") && de === 0) || m.match($, (W, K) => K === "typeAnnotation", (W, K) => K === "typeAnnotation", (W, K, de) => P(W) && (K === "params" || K === "parameters" || K === "this" || K === "rest") && de === 0) || !q && m.match((W) => W.type === "ObjectPattern", (W) => W.type === "AssignmentExpression" || W.type === "VariableDeclarator") ? ce : n(ce, { shouldBreak: q });
            }
            r.exports = { printObject: T };
          } }), dd = te({ "src/language-js/print/flow.js"(e, r) {
            "use strict";
            ne();
            var t3 = Zt(), { printDanglingComments: s } = et(), { printString: a, printNumber: n } = Ue(), { builders: { hardline: u, softline: i, group: l, indent: p } } = qe(), { getParentExportDeclaration: y, isFunctionNotation: h, isGetterOrSetter: g, rawText: c, shouldPrintComma: f } = Ke(), { locStart: F, locEnd: _ } = ut(), { replaceTextEndOfLine: w } = Yt(), { printClass: E } = nr(), { printOpaqueType: N, printTypeAlias: x, printIntersectionType: I, printUnionType: P, printFunctionType: $, printTupleType: D, printIndexedAccessType: T } = Or(), { printInterface: m } = bo(), { printTypeParameter: C, printTypeParameters: o } = jr(), { printExportDeclaration: d, printExportAllDeclaration: v } = To(), { printArrayItems: S } = er(), { printObject: b } = uu(), { printPropertyKey: B } = rr(), { printOptionalToken: k, printTypeAnnotation: M, printRestSpread: R } = ct();
            function q(L, Q, V) {
              let j = L.getValue(), Y = Q.semi ? ";" : "", ie = [];
              switch (j.type) {
                case "DeclareClass":
                  return J(L, E(L, Q, V));
                case "DeclareFunction":
                  return J(L, ["function ", V("id"), j.predicate ? " " : "", V("predicate"), Y]);
                case "DeclareModule":
                  return J(L, ["module ", V("id"), " ", V("body")]);
                case "DeclareModuleExports":
                  return J(L, ["module.exports", ": ", V("typeAnnotation"), Y]);
                case "DeclareVariable":
                  return J(L, ["var ", V("id"), Y]);
                case "DeclareOpaqueType":
                  return J(L, N(L, Q, V));
                case "DeclareInterface":
                  return J(L, m(L, Q, V));
                case "DeclareTypeAlias":
                  return J(L, x(L, Q, V));
                case "DeclareExportDeclaration":
                  return J(L, d(L, Q, V));
                case "DeclareExportAllDeclaration":
                  return J(L, v(L, Q, V));
                case "OpaqueType":
                  return N(L, Q, V);
                case "TypeAlias":
                  return x(L, Q, V);
                case "IntersectionTypeAnnotation":
                  return I(L, Q, V);
                case "UnionTypeAnnotation":
                  return P(L, Q, V);
                case "FunctionTypeAnnotation":
                  return $(L, Q, V);
                case "TupleTypeAnnotation":
                  return D(L, Q, V);
                case "GenericTypeAnnotation":
                  return [V("id"), o(L, Q, V, "typeParameters")];
                case "IndexedAccessType":
                case "OptionalIndexedAccessType":
                  return T(L, Q, V);
                case "TypeAnnotation":
                  return V("typeAnnotation");
                case "TypeParameter":
                  return C(L, Q, V);
                case "TypeofTypeAnnotation":
                  return ["typeof ", V("argument")];
                case "ExistsTypeAnnotation":
                  return "*";
                case "EmptyTypeAnnotation":
                  return "empty";
                case "MixedTypeAnnotation":
                  return "mixed";
                case "ArrayTypeAnnotation":
                  return [V("elementType"), "[]"];
                case "BooleanLiteralTypeAnnotation":
                  return String(j.value);
                case "EnumDeclaration":
                  return ["enum ", V("id"), " ", V("body")];
                case "EnumBooleanBody":
                case "EnumNumberBody":
                case "EnumStringBody":
                case "EnumSymbolBody": {
                  if (j.type === "EnumSymbolBody" || j.explicitType) {
                    let ee = null;
                    switch (j.type) {
                      case "EnumBooleanBody":
                        ee = "boolean";
                        break;
                      case "EnumNumberBody":
                        ee = "number";
                        break;
                      case "EnumStringBody":
                        ee = "string";
                        break;
                      case "EnumSymbolBody":
                        ee = "symbol";
                        break;
                    }
                    ie.push("of ", ee, " ");
                  }
                  if (j.members.length === 0 && !j.hasUnknownMembers)
                    ie.push(l(["{", s(L, Q), i, "}"]));
                  else {
                    let ee = j.members.length > 0 ? [u, S(L, Q, "members", V), j.hasUnknownMembers || f(Q) ? "," : ""] : [];
                    ie.push(l(["{", p([...ee, ...j.hasUnknownMembers ? [u, "..."] : []]), s(L, Q, true), u, "}"]));
                  }
                  return ie;
                }
                case "EnumBooleanMember":
                case "EnumNumberMember":
                case "EnumStringMember":
                  return [V("id"), " = ", typeof j.init == "object" ? V("init") : String(j.init)];
                case "EnumDefaultedMember":
                  return V("id");
                case "FunctionTypeParam": {
                  let ee = j.name ? V("name") : L.getParentNode().this === j ? "this" : "";
                  return [ee, k(L), ee ? ": " : "", V("typeAnnotation")];
                }
                case "InterfaceDeclaration":
                case "InterfaceTypeAnnotation":
                  return m(L, Q, V);
                case "ClassImplements":
                case "InterfaceExtends":
                  return [V("id"), V("typeParameters")];
                case "NullableTypeAnnotation":
                  return ["?", V("typeAnnotation")];
                case "Variance": {
                  let { kind: ee } = j;
                  return t3.ok(ee === "plus" || ee === "minus"), ee === "plus" ? "+" : "-";
                }
                case "ObjectTypeCallProperty":
                  return j.static && ie.push("static "), ie.push(V("value")), ie;
                case "ObjectTypeIndexer":
                  return [j.static ? "static " : "", j.variance ? V("variance") : "", "[", V("id"), j.id ? ": " : "", V("key"), "]: ", V("value")];
                case "ObjectTypeProperty": {
                  let ee = "";
                  return j.proto ? ee = "proto " : j.static && (ee = "static "), [ee, g(j) ? j.kind + " " : "", j.variance ? V("variance") : "", B(L, Q, V), k(L), h(j) ? "" : ": ", V("value")];
                }
                case "ObjectTypeAnnotation":
                  return b(L, Q, V);
                case "ObjectTypeInternalSlot":
                  return [j.static ? "static " : "", "[[", V("id"), "]]", k(L), j.method ? "" : ": ", V("value")];
                case "ObjectTypeSpreadProperty":
                  return R(L, Q, V);
                case "QualifiedTypeofIdentifier":
                case "QualifiedTypeIdentifier":
                  return [V("qualification"), ".", V("id")];
                case "StringLiteralTypeAnnotation":
                  return w(a(c(j), Q));
                case "NumberLiteralTypeAnnotation":
                  t3.strictEqual(typeof j.value, "number");
                case "BigIntLiteralTypeAnnotation":
                  return j.extra ? n(j.extra.raw) : n(j.raw);
                case "TypeCastExpression":
                  return ["(", V("expression"), M(L, Q, V), ")"];
                case "TypeParameterDeclaration":
                case "TypeParameterInstantiation": {
                  let ee = o(L, Q, V, "params");
                  if (Q.parser === "flow") {
                    let ce = F(j), W = _(j), K = Q.originalText.lastIndexOf("/*", ce), de = Q.originalText.indexOf("*/", W);
                    if (K !== -1 && de !== -1) {
                      let ue = Q.originalText.slice(K + 2, de).trim();
                      if (ue.startsWith("::") && !ue.includes("/*") && !ue.includes("*/"))
                        return ["/*:: ", ee, " */"];
                    }
                  }
                  return ee;
                }
                case "InferredPredicate":
                  return "%checks";
                case "DeclaredPredicate":
                  return ["%checks(", V("value"), ")"];
                case "AnyTypeAnnotation":
                  return "any";
                case "BooleanTypeAnnotation":
                  return "boolean";
                case "BigIntTypeAnnotation":
                  return "bigint";
                case "NullLiteralTypeAnnotation":
                  return "null";
                case "NumberTypeAnnotation":
                  return "number";
                case "SymbolTypeAnnotation":
                  return "symbol";
                case "StringTypeAnnotation":
                  return "string";
                case "VoidTypeAnnotation":
                  return "void";
                case "ThisTypeAnnotation":
                  return "this";
                case "Node":
                case "Printable":
                case "SourceLocation":
                case "Position":
                case "Statement":
                case "Function":
                case "Pattern":
                case "Expression":
                case "Declaration":
                case "Specifier":
                case "NamedSpecifier":
                case "Comment":
                case "MemberTypeAnnotation":
                case "Type":
                  throw new Error("unprintable type: " + JSON.stringify(j.type));
              }
            }
            function J(L, Q) {
              let V = y(L);
              return V ? (t3.strictEqual(V.type, "DeclareExportDeclaration"), Q) : ["declare ", Q];
            }
            r.exports = { printFlow: q };
          } }), gd = te({ "src/language-js/utils/is-ts-keyword-type.js"(e, r) {
            "use strict";
            ne();
            function t3(s) {
              let { type: a } = s;
              return a.startsWith("TS") && a.endsWith("Keyword");
            }
            r.exports = t3;
          } }), Bo = te({ "src/language-js/print/ternary.js"(e, r) {
            "use strict";
            ne();
            var { hasNewlineInRange: t3 } = Ue(), { isJsxNode: s, getComments: a, isCallExpression: n, isMemberExpression: u, isTSTypeExpression: i } = Ke(), { locStart: l, locEnd: p } = ut(), y = Pt(), { builders: { line: h, softline: g, group: c, indent: f, align: F, ifBreak: _, dedent: w, breakParent: E } } = qe();
            function N(D) {
              let T = [D];
              for (let m = 0; m < T.length; m++) {
                let C = T[m];
                for (let o of ["test", "consequent", "alternate"]) {
                  let d = C[o];
                  if (s(d))
                    return true;
                  d.type === "ConditionalExpression" && T.push(d);
                }
              }
              return false;
            }
            function x(D, T, m) {
              let C = D.getValue(), o = C.type === "ConditionalExpression", d = o ? "alternate" : "falseType", v = D.getParentNode(), S = o ? m("test") : [m("checkType"), " ", "extends", " ", m("extendsType")];
              return v.type === C.type && v[d] === C ? F(2, S) : S;
            }
            var I = /* @__PURE__ */ new Map([["AssignmentExpression", "right"], ["VariableDeclarator", "init"], ["ReturnStatement", "argument"], ["ThrowStatement", "argument"], ["UnaryExpression", "argument"], ["YieldExpression", "argument"]]);
            function P(D) {
              let T = D.getValue();
              if (T.type !== "ConditionalExpression")
                return false;
              let m, C = T;
              for (let o = 0; !m; o++) {
                let d = D.getParentNode(o);
                if (n(d) && d.callee === C || u(d) && d.object === C || d.type === "TSNonNullExpression" && d.expression === C) {
                  C = d;
                  continue;
                }
                d.type === "NewExpression" && d.callee === C || i(d) && d.expression === C ? (m = D.getParentNode(o + 1), C = d) : m = d;
              }
              return C === T ? false : m[I.get(m.type)] === C;
            }
            function $(D, T, m) {
              let C = D.getValue(), o = C.type === "ConditionalExpression", d = o ? "consequent" : "trueType", v = o ? "alternate" : "falseType", S = o ? ["test"] : ["checkType", "extendsType"], b = C[d], B = C[v], k = [], M = false, R = D.getParentNode(), q = R.type === C.type && S.some((ue) => R[ue] === C), J = R.type === C.type && !q, L, Q, V = 0;
              do
                Q = L || C, L = D.getParentNode(V), V++;
              while (L && L.type === C.type && S.every((ue) => L[ue] !== Q));
              let j = L || R, Y = Q;
              if (o && (s(C[S[0]]) || s(b) || s(B) || N(Y))) {
                M = true, J = true;
                let ue = (z) => [_("("), f([g, z]), g, _(")")], Fe = (z) => z.type === "NullLiteral" || z.type === "Literal" && z.value === null || z.type === "Identifier" && z.name === "undefined";
                k.push(" ? ", Fe(b) ? m(d) : ue(m(d)), " : ", B.type === C.type || Fe(B) ? m(v) : ue(m(v)));
              } else {
                let ue = [h, "? ", b.type === C.type ? _("", "(") : "", F(2, m(d)), b.type === C.type ? _("", ")") : "", h, ": ", B.type === C.type ? m(v) : F(2, m(v))];
                k.push(R.type !== C.type || R[v] === C || q ? ue : T.useTabs ? w(f(ue)) : F(Math.max(0, T.tabWidth - 2), ue));
              }
              let ee = [...S.map((ue) => a(C[ue])), a(b), a(B)].flat().some((ue) => y(ue) && t3(T.originalText, l(ue), p(ue))), ce = (ue) => R === j ? c(ue, { shouldBreak: ee }) : ee ? [ue, E] : ue, W = !M && (u(R) || R.type === "NGPipeExpression" && R.left === C) && !R.computed, K = P(D), de = ce([x(D, T, m), J ? k : f(k), o && W && !K ? g : ""]);
              return q || K ? c([f([g, de]), g]) : de;
            }
            r.exports = { printTernary: $ };
          } }), No = te({ "src/language-js/print/statement.js"(e, r) {
            "use strict";
            ne();
            var { builders: { hardline: t3 } } = qe(), s = qt(), { getLeftSidePathName: a, hasNakedLeftSide: n, isJsxNode: u, isTheOnlyJsxElementInMarkdown: i, hasComment: l, CommentCheckFlags: p, isNextLineEmpty: y } = Ke(), { shouldPrintParamsWithoutParens: h } = qr();
            function g(x, I, P, $) {
              let D = x.getValue(), T = [], m = D.type === "ClassBody", C = c(D[$]);
              return x.each((o, d, v) => {
                let S = o.getValue();
                if (S.type === "EmptyStatement")
                  return;
                let b = P();
                !I.semi && !m && !i(I, o) && f(o, I) ? l(S, p.Leading) ? T.push(P([], { needsSemi: true })) : T.push(";", b) : T.push(b), !I.semi && m && E(S) && N(S, v[d + 1]) && T.push(";"), S !== C && (T.push(t3), y(S, I) && T.push(t3));
              }, $), T;
            }
            function c(x) {
              for (let I = x.length - 1; I >= 0; I--) {
                let P = x[I];
                if (P.type !== "EmptyStatement")
                  return P;
              }
            }
            function f(x, I) {
              return x.getNode().type !== "ExpressionStatement" ? false : x.call(($) => F($, I), "expression");
            }
            function F(x, I) {
              let P = x.getValue();
              switch (P.type) {
                case "ParenthesizedExpression":
                case "TypeCastExpression":
                case "ArrayExpression":
                case "ArrayPattern":
                case "TemplateLiteral":
                case "TemplateElement":
                case "RegExpLiteral":
                  return true;
                case "ArrowFunctionExpression": {
                  if (!h(x, I))
                    return true;
                  break;
                }
                case "UnaryExpression": {
                  let { prefix: $, operator: D } = P;
                  if ($ && (D === "+" || D === "-"))
                    return true;
                  break;
                }
                case "BindExpression": {
                  if (!P.object)
                    return true;
                  break;
                }
                case "Literal": {
                  if (P.regex)
                    return true;
                  break;
                }
                default:
                  if (u(P))
                    return true;
              }
              return s(x, I) ? true : n(P) ? x.call(($) => F($, I), ...a(x, P)) : false;
            }
            function _(x, I, P) {
              return g(x, I, P, "body");
            }
            function w(x, I, P) {
              return g(x, I, P, "consequent");
            }
            var E = (x) => {
              let { type: I } = x;
              return I === "ClassProperty" || I === "PropertyDefinition" || I === "ClassPrivateProperty" || I === "ClassAccessorProperty" || I === "AccessorProperty" || I === "TSAbstractPropertyDefinition" || I === "TSAbstractAccessorProperty";
            };
            function N(x, I) {
              let { type: P, name: $ } = x.key;
              if (!x.computed && P === "Identifier" && ($ === "static" || $ === "get" || $ === "set" || $ === "accessor") && !x.value && !x.typeAnnotation)
                return true;
              if (!I || I.static || I.accessibility)
                return false;
              if (!I.computed) {
                let D = I.key && I.key.name;
                if (D === "in" || D === "instanceof")
                  return true;
              }
              if (E(I) && I.variance && !I.static && !I.declare)
                return true;
              switch (I.type) {
                case "ClassProperty":
                case "PropertyDefinition":
                case "TSAbstractPropertyDefinition":
                  return I.computed;
                case "MethodDefinition":
                case "TSAbstractMethodDefinition":
                case "ClassMethod":
                case "ClassPrivateMethod": {
                  if ((I.value ? I.value.async : I.async) || I.kind === "get" || I.kind === "set")
                    return false;
                  let T = I.value ? I.value.generator : I.generator;
                  return !!(I.computed || T);
                }
                case "TSIndexSignature":
                  return true;
              }
              return false;
            }
            r.exports = { printBody: _, printSwitchCaseConsequent: w };
          } }), wo = te({ "src/language-js/print/block.js"(e, r) {
            "use strict";
            ne();
            var { printDanglingComments: t3 } = et(), { isNonEmptyArray: s } = Ue(), { builders: { hardline: a, indent: n } } = qe(), { hasComment: u, CommentCheckFlags: i, isNextLineEmpty: l } = Ke(), { printHardlineAfterHeritage: p } = nr(), { printBody: y } = No();
            function h(c, f, F) {
              let _ = c.getValue(), w = [];
              if (_.type === "StaticBlock" && w.push("static "), _.type === "ClassBody" && s(_.body)) {
                let N = c.getParentNode();
                w.push(p(N));
              }
              w.push("{");
              let E = g(c, f, F);
              if (E)
                w.push(n([a, E]), a);
              else {
                let N = c.getParentNode(), x = c.getParentNode(1);
                N.type === "ArrowFunctionExpression" || N.type === "FunctionExpression" || N.type === "FunctionDeclaration" || N.type === "ObjectMethod" || N.type === "ClassMethod" || N.type === "ClassPrivateMethod" || N.type === "ForStatement" || N.type === "WhileStatement" || N.type === "DoWhileStatement" || N.type === "DoExpression" || N.type === "CatchClause" && !x.finalizer || N.type === "TSModuleDeclaration" || N.type === "TSDeclareFunction" || _.type === "StaticBlock" || _.type === "ClassBody" || w.push(a);
              }
              return w.push("}"), w;
            }
            function g(c, f, F) {
              let _ = c.getValue(), w = s(_.directives), E = _.body.some((I) => I.type !== "EmptyStatement"), N = u(_, i.Dangling);
              if (!w && !E && !N)
                return "";
              let x = [];
              if (w && c.each((I, P, $) => {
                x.push(F()), (P < $.length - 1 || E || N) && (x.push(a), l(I.getValue(), f) && x.push(a));
              }, "directives"), E && x.push(y(c, f, F)), N && x.push(t3(c, f, true)), _.type === "Program") {
                let I = c.getParentNode();
                (!I || I.type !== "ModuleExpression") && x.push(a);
              }
              return x;
            }
            r.exports = { printBlock: h, printBlockBody: g };
          } }), yd = te({ "src/language-js/print/typescript.js"(e, r) {
            "use strict";
            ne();
            var { printDanglingComments: t3 } = et(), { hasNewlineInRange: s } = Ue(), { builders: { join: a, line: n, hardline: u, softline: i, group: l, indent: p, conditionalGroup: y, ifBreak: h } } = qe(), { isStringLiteral: g, getTypeScriptMappedTypeModifier: c, shouldPrintComma: f, isCallExpression: F, isMemberExpression: _ } = Ke(), w = gd(), { locStart: E, locEnd: N } = ut(), { printOptionalToken: x, printTypeScriptModifiers: I } = ct(), { printTernary: P } = Bo(), { printFunctionParameters: $, shouldGroupFunctionParameters: D } = Lr(), { printTemplateLiteral: T } = jt(), { printArrayItems: m } = er(), { printObject: C } = uu(), { printClassProperty: o, printClassMethod: d } = nr(), { printTypeParameter: v, printTypeParameters: S } = jr(), { printPropertyKey: b } = rr(), { printFunction: B, printMethodInternal: k } = qr(), { printInterface: M } = bo(), { printBlock: R } = wo(), { printTypeAlias: q, printIntersectionType: J, printUnionType: L, printFunctionType: Q, printTupleType: V, printIndexedAccessType: j, printJSDocType: Y } = Or();
            function ie(ee, ce, W) {
              let K = ee.getValue();
              if (!K.type.startsWith("TS"))
                return;
              if (w(K))
                return K.type.slice(2, -7).toLowerCase();
              let de = ce.semi ? ";" : "", ue = [];
              switch (K.type) {
                case "TSThisType":
                  return "this";
                case "TSTypeAssertion": {
                  let Fe = !(K.expression.type === "ArrayExpression" || K.expression.type === "ObjectExpression"), z = l(["<", p([i, W("typeAnnotation")]), i, ">"]), U = [h("("), p([i, W("expression")]), i, h(")")];
                  return Fe ? y([[z, W("expression")], [z, l(U, { shouldBreak: true })], [z, W("expression")]]) : l([z, W("expression")]);
                }
                case "TSDeclareFunction":
                  return B(ee, W, ce);
                case "TSExportAssignment":
                  return ["export = ", W("expression"), de];
                case "TSModuleBlock":
                  return R(ee, ce, W);
                case "TSInterfaceBody":
                case "TSTypeLiteral":
                  return C(ee, ce, W);
                case "TSTypeAliasDeclaration":
                  return q(ee, ce, W);
                case "TSQualifiedName":
                  return a(".", [W("left"), W("right")]);
                case "TSAbstractMethodDefinition":
                case "TSDeclareMethod":
                  return d(ee, ce, W);
                case "TSAbstractAccessorProperty":
                case "TSAbstractPropertyDefinition":
                  return o(ee, ce, W);
                case "TSInterfaceHeritage":
                case "TSExpressionWithTypeArguments":
                  return ue.push(W("expression")), K.typeParameters && ue.push(W("typeParameters")), ue;
                case "TSTemplateLiteralType":
                  return T(ee, W, ce);
                case "TSNamedTupleMember":
                  return [W("label"), K.optional ? "?" : "", ": ", W("elementType")];
                case "TSRestType":
                  return ["...", W("typeAnnotation")];
                case "TSOptionalType":
                  return [W("typeAnnotation"), "?"];
                case "TSInterfaceDeclaration":
                  return M(ee, ce, W);
                case "TSClassImplements":
                  return [W("expression"), W("typeParameters")];
                case "TSTypeParameterDeclaration":
                case "TSTypeParameterInstantiation":
                  return S(ee, ce, W, "params");
                case "TSTypeParameter":
                  return v(ee, ce, W);
                case "TSSatisfiesExpression":
                case "TSAsExpression": {
                  let Fe = K.type === "TSAsExpression" ? "as" : "satisfies";
                  ue.push(W("expression"), ` ${Fe} `, W("typeAnnotation"));
                  let z = ee.getParentNode();
                  return F(z) && z.callee === K || _(z) && z.object === K ? l([p([i, ...ue]), i]) : ue;
                }
                case "TSArrayType":
                  return [W("elementType"), "[]"];
                case "TSPropertySignature":
                  return K.readonly && ue.push("readonly "), ue.push(b(ee, ce, W), x(ee)), K.typeAnnotation && ue.push(": ", W("typeAnnotation")), K.initializer && ue.push(" = ", W("initializer")), ue;
                case "TSParameterProperty":
                  return K.accessibility && ue.push(K.accessibility + " "), K.export && ue.push("export "), K.static && ue.push("static "), K.override && ue.push("override "), K.readonly && ue.push("readonly "), ue.push(W("parameter")), ue;
                case "TSTypeQuery":
                  return ["typeof ", W("exprName"), W("typeParameters")];
                case "TSIndexSignature": {
                  let Fe = ee.getParentNode(), z = K.parameters.length > 1 ? h(f(ce) ? "," : "") : "", U = l([p([i, a([", ", i], ee.map(W, "parameters"))]), z, i]);
                  return [K.export ? "export " : "", K.accessibility ? [K.accessibility, " "] : "", K.static ? "static " : "", K.readonly ? "readonly " : "", K.declare ? "declare " : "", "[", K.parameters ? U : "", K.typeAnnotation ? "]: " : "]", K.typeAnnotation ? W("typeAnnotation") : "", Fe.type === "ClassBody" ? de : ""];
                }
                case "TSTypePredicate":
                  return [K.asserts ? "asserts " : "", W("parameterName"), K.typeAnnotation ? [" is ", W("typeAnnotation")] : ""];
                case "TSNonNullExpression":
                  return [W("expression"), "!"];
                case "TSImportType":
                  return [K.isTypeOf ? "typeof " : "", "import(", W(K.parameter ? "parameter" : "argument"), ")", K.qualifier ? [".", W("qualifier")] : "", S(ee, ce, W, "typeParameters")];
                case "TSLiteralType":
                  return W("literal");
                case "TSIndexedAccessType":
                  return j(ee, ce, W);
                case "TSConstructSignatureDeclaration":
                case "TSCallSignatureDeclaration":
                case "TSConstructorType": {
                  if (K.type === "TSConstructorType" && K.abstract && ue.push("abstract "), K.type !== "TSCallSignatureDeclaration" && ue.push("new "), ue.push(l($(ee, W, ce, false, true))), K.returnType || K.typeAnnotation) {
                    let Fe = K.type === "TSConstructorType";
                    ue.push(Fe ? " => " : ": ", W("returnType"), W("typeAnnotation"));
                  }
                  return ue;
                }
                case "TSTypeOperator":
                  return [K.operator, " ", W("typeAnnotation")];
                case "TSMappedType": {
                  let Fe = s(ce.originalText, E(K), N(K));
                  return l(["{", p([ce.bracketSpacing ? n : i, W("typeParameter"), K.optional ? c(K.optional, "?") : "", K.typeAnnotation ? ": " : "", W("typeAnnotation"), h(de)]), t3(ee, ce, true), ce.bracketSpacing ? n : i, "}"], { shouldBreak: Fe });
                }
                case "TSMethodSignature": {
                  let Fe = K.kind && K.kind !== "method" ? `${K.kind} ` : "";
                  ue.push(K.accessibility ? [K.accessibility, " "] : "", Fe, K.export ? "export " : "", K.static ? "static " : "", K.readonly ? "readonly " : "", K.abstract ? "abstract " : "", K.declare ? "declare " : "", K.computed ? "[" : "", W("key"), K.computed ? "]" : "", x(ee));
                  let z = $(ee, W, ce, false, true), U = K.returnType ? "returnType" : "typeAnnotation", Z = K[U], se = Z ? W(U) : "", fe = D(K, se);
                  return ue.push(fe ? l(z) : z), Z && ue.push(": ", l(se)), l(ue);
                }
                case "TSNamespaceExportDeclaration":
                  return ue.push("export as namespace ", W("id")), ce.semi && ue.push(";"), l(ue);
                case "TSEnumDeclaration":
                  return K.declare && ue.push("declare "), K.modifiers && ue.push(I(ee, ce, W)), K.const && ue.push("const "), ue.push("enum ", W("id"), " "), K.members.length === 0 ? ue.push(l(["{", t3(ee, ce), i, "}"])) : ue.push(l(["{", p([u, m(ee, ce, "members", W), f(ce, "es5") ? "," : ""]), t3(ee, ce, true), u, "}"])), ue;
                case "TSEnumMember":
                  return K.computed ? ue.push("[", W("id"), "]") : ue.push(W("id")), K.initializer && ue.push(" = ", W("initializer")), ue;
                case "TSImportEqualsDeclaration":
                  return K.isExport && ue.push("export "), ue.push("import "), K.importKind && K.importKind !== "value" && ue.push(K.importKind, " "), ue.push(W("id"), " = ", W("moduleReference")), ce.semi && ue.push(";"), l(ue);
                case "TSExternalModuleReference":
                  return ["require(", W("expression"), ")"];
                case "TSModuleDeclaration": {
                  let Fe = ee.getParentNode(), z = g(K.id), U = Fe.type === "TSModuleDeclaration", Z = K.body && K.body.type === "TSModuleDeclaration";
                  if (U)
                    ue.push(".");
                  else {
                    K.declare && ue.push("declare "), ue.push(I(ee, ce, W));
                    let se = ce.originalText.slice(E(K), E(K.id));
                    K.id.type === "Identifier" && K.id.name === "global" && !/namespace|module/.test(se) || ue.push(z || /(?:^|\s)module(?:\s|$)/.test(se) ? "module " : "namespace ");
                  }
                  return ue.push(W("id")), Z ? ue.push(W("body")) : K.body ? ue.push(" ", l(W("body"))) : ue.push(de), ue;
                }
                case "TSConditionalType":
                  return P(ee, ce, W);
                case "TSInferType":
                  return ["infer", " ", W("typeParameter")];
                case "TSIntersectionType":
                  return J(ee, ce, W);
                case "TSUnionType":
                  return L(ee, ce, W);
                case "TSFunctionType":
                  return Q(ee, ce, W);
                case "TSTupleType":
                  return V(ee, ce, W);
                case "TSTypeReference":
                  return [W("typeName"), S(ee, ce, W, "typeParameters")];
                case "TSTypeAnnotation":
                  return W("typeAnnotation");
                case "TSEmptyBodyFunctionExpression":
                  return k(ee, ce, W);
                case "TSJSDocAllType":
                  return "*";
                case "TSJSDocUnknownType":
                  return "?";
                case "TSJSDocNullableType":
                  return Y(ee, W, "?");
                case "TSJSDocNonNullableType":
                  return Y(ee, W, "!");
                case "TSInstantiationExpression":
                  return [W("expression"), W("typeParameters")];
                default:
                  throw new Error(`Unknown TypeScript node type: ${JSON.stringify(K.type)}.`);
              }
            }
            r.exports = { printTypescript: ie };
          } }), hd = te({ "src/language-js/print/comment.js"(e, r) {
            "use strict";
            ne();
            var { hasNewline: t3 } = Ue(), { builders: { join: s, hardline: a }, utils: { replaceTextEndOfLine: n } } = qe(), { isLineComment: u } = Ke(), { locStart: i, locEnd: l } = ut(), p = Pt();
            function y(c, f) {
              let F = c.getValue();
              if (u(F))
                return f.originalText.slice(i(F), l(F)).trimEnd();
              if (p(F)) {
                if (h(F)) {
                  let E = g(F);
                  return F.trailing && !t3(f.originalText, i(F), { backwards: true }) ? [a, E] : E;
                }
                let _ = l(F), w = f.originalText.slice(_ - 3, _) === "*-/";
                return ["/*", n(F.value), w ? "*-/" : "*/"];
              }
              throw new Error("Not a comment: " + JSON.stringify(F));
            }
            function h(c) {
              let f = `*${c.value}*`.split(`
`);
              return f.length > 1 && f.every((F) => F.trim()[0] === "*");
            }
            function g(c) {
              let f = c.value.split(`
`);
              return ["/*", s(a, f.map((F, _) => _ === 0 ? F.trimEnd() : " " + (_ < f.length - 1 ? F.trim() : F.trimStart()))), "*/"];
            }
            r.exports = { printComment: y };
          } }), vd = te({ "src/language-js/print/literal.js"(e, r) {
            "use strict";
            ne();
            var { printString: t3, printNumber: s } = Ue(), { replaceTextEndOfLine: a } = Yt(), { printDirective: n } = ct();
            function u(y, h) {
              let g = y.getNode();
              switch (g.type) {
                case "RegExpLiteral":
                  return p(g);
                case "BigIntLiteral":
                  return l(g.bigint || g.extra.raw);
                case "NumericLiteral":
                  return s(g.extra.raw);
                case "StringLiteral":
                  return a(t3(g.extra.raw, h));
                case "NullLiteral":
                  return "null";
                case "BooleanLiteral":
                  return String(g.value);
                case "DecimalLiteral":
                  return s(g.value) + "m";
                case "Literal": {
                  if (g.regex)
                    return p(g.regex);
                  if (g.bigint)
                    return l(g.raw);
                  if (g.decimal)
                    return s(g.decimal) + "m";
                  let { value: c } = g;
                  return typeof c == "number" ? s(g.raw) : typeof c == "string" ? i(y) ? n(g.raw, h) : a(t3(g.raw, h)) : String(c);
                }
              }
            }
            function i(y) {
              if (y.getName() !== "expression")
                return;
              let h = y.getParentNode();
              return h.type === "ExpressionStatement" && h.directive;
            }
            function l(y) {
              return y.toLowerCase();
            }
            function p(y) {
              let { pattern: h, flags: g } = y;
              return g = [...g].sort().join(""), `/${h}/${g}`;
            }
            r.exports = { printLiteral: u };
          } }), Cd = te({ "src/language-js/printer-estree.js"(e, r) {
            "use strict";
            ne();
            var { printDanglingComments: t3 } = et(), { hasNewline: s } = Ue(), { builders: { join: a, line: n, hardline: u, softline: i, group: l, indent: p }, utils: { replaceTextEndOfLine: y } } = qe(), h = td(), g = rd(), { insertPragma: c } = Co(), f = Eo(), F = qt(), _ = Fo(), { hasFlowShorthandAnnotationComment: w, hasComment: E, CommentCheckFlags: N, isTheOnlyJsxElementInMarkdown: x, isLineComment: I, isNextLineEmpty: P, needsHardlineAfterDanglingComment: $, hasIgnoreComment: D, isCallExpression: T, isMemberExpression: m, markerForIfWithoutBlockAndSameLineComment: C } = Ke(), { locStart: o, locEnd: d } = ut(), v = Pt(), { printHtmlBinding: S, isVueEventBindingExpression: b } = pd(), { printAngular: B } = fd(), { printJsx: k, hasJsxIgnoreComment: M } = Dd(), { printFlow: R } = dd(), { printTypescript: q } = yd(), { printOptionalToken: J, printBindExpressionCallee: L, printTypeAnnotation: Q, adjustClause: V, printRestSpread: j, printDefiniteToken: Y, printDirective: ie } = ct(), { printImportDeclaration: ee, printExportDeclaration: ce, printExportAllDeclaration: W, printModuleSpecifier: K } = To(), { printTernary: de } = Bo(), { printTemplateLiteral: ue } = jt(), { printArray: Fe } = er(), { printObject: z } = uu(), { printClass: U, printClassMethod: Z, printClassProperty: se } = nr(), { printProperty: fe } = rr(), { printFunction: ge, printArrowFunction: he, printMethod: we, printReturnStatement: ke, printThrowStatement: Re } = qr(), { printCallExpression: Ne } = xo(), { printVariableDeclarator: Pe, printAssignmentExpression: oe } = tr(), { printBinaryishExpression: H } = ru(), { printSwitchCaseConsequent: pe } = No(), { printMemberExpression: X } = So(), { printBlock: le, printBlockBody: Ae } = wo(), { printComment: Ee } = hd(), { printLiteral: De } = vd(), { printDecorators: A } = nu();
            function G(Ce, Be, ve, ze) {
              let be = re(Ce, Be, ve, ze);
              if (!be)
                return "";
              let Ye = Ce.getValue(), { type: Se } = Ye;
              if (Se === "ClassMethod" || Se === "ClassPrivateMethod" || Se === "ClassProperty" || Se === "ClassAccessorProperty" || Se === "AccessorProperty" || Se === "TSAbstractAccessorProperty" || Se === "PropertyDefinition" || Se === "TSAbstractPropertyDefinition" || Se === "ClassPrivateProperty" || Se === "MethodDefinition" || Se === "TSAbstractMethodDefinition" || Se === "TSDeclareMethod")
                return be;
              let Ie = [be], Oe = A(Ce, Be, ve), Je = Ye.type === "ClassExpression" && Oe;
              if (Oe && (Ie = [...Oe, be], !Je))
                return l(Ie);
              if (!F(Ce, Be))
                return ze && ze.needsSemi && Ie.unshift(";"), Ie.length === 1 && Ie[0] === be ? be : Ie;
              if (Je && (Ie = [p([n, ...Ie])]), Ie.unshift("("), ze && ze.needsSemi && Ie.unshift(";"), w(Ye)) {
                let [je] = Ye.trailingComments;
                Ie.push(" /*", je.value.trimStart(), "*/"), je.printed = true;
              }
              return Je && Ie.push(n), Ie.push(")"), Ie;
            }
            function re(Ce, Be, ve, ze) {
              let be = Ce.getValue(), Ye = Be.semi ? ";" : "";
              if (!be)
                return "";
              if (typeof be == "string")
                return be;
              for (let Ie of [De, S, B, k, R, q]) {
                let Oe = Ie(Ce, Be, ve);
                if (typeof Oe < "u")
                  return Oe;
              }
              let Se = [];
              switch (be.type) {
                case "JsExpressionRoot":
                  return ve("node");
                case "JsonRoot":
                  return [ve("node"), u];
                case "File":
                  return be.program && be.program.interpreter && Se.push(ve(["program", "interpreter"])), Se.push(ve("program")), Se;
                case "Program":
                  return Ae(Ce, Be, ve);
                case "EmptyStatement":
                  return "";
                case "ExpressionStatement": {
                  if (Be.parser === "__vue_event_binding" || Be.parser === "__vue_ts_event_binding") {
                    let Oe = Ce.getParentNode();
                    if (Oe.type === "Program" && Oe.body.length === 1 && Oe.body[0] === be)
                      return [ve("expression"), b(be.expression) ? ";" : ""];
                  }
                  let Ie = t3(Ce, Be, true, (Oe) => {
                    let { marker: Je } = Oe;
                    return Je === C;
                  });
                  return [ve("expression"), x(Be, Ce) ? "" : Ye, Ie ? [" ", Ie] : ""];
                }
                case "ParenthesizedExpression":
                  return !E(be.expression) && (be.expression.type === "ObjectExpression" || be.expression.type === "ArrayExpression") ? ["(", ve("expression"), ")"] : l(["(", p([i, ve("expression")]), i, ")"]);
                case "AssignmentExpression":
                  return oe(Ce, Be, ve);
                case "VariableDeclarator":
                  return Pe(Ce, Be, ve);
                case "BinaryExpression":
                case "LogicalExpression":
                  return H(Ce, Be, ve);
                case "AssignmentPattern":
                  return [ve("left"), " = ", ve("right")];
                case "OptionalMemberExpression":
                case "MemberExpression":
                  return X(Ce, Be, ve);
                case "MetaProperty":
                  return [ve("meta"), ".", ve("property")];
                case "BindExpression":
                  return be.object && Se.push(ve("object")), Se.push(l(p([i, L(Ce, Be, ve)]))), Se;
                case "Identifier":
                  return [be.name, J(Ce), Y(Ce), Q(Ce, Be, ve)];
                case "V8IntrinsicIdentifier":
                  return ["%", be.name];
                case "SpreadElement":
                case "SpreadElementPattern":
                case "SpreadProperty":
                case "SpreadPropertyPattern":
                case "RestElement":
                  return j(Ce, Be, ve);
                case "FunctionDeclaration":
                case "FunctionExpression":
                  return ge(Ce, ve, Be, ze);
                case "ArrowFunctionExpression":
                  return he(Ce, Be, ve, ze);
                case "YieldExpression":
                  return Se.push("yield"), be.delegate && Se.push("*"), be.argument && Se.push(" ", ve("argument")), Se;
                case "AwaitExpression": {
                  if (Se.push("await"), be.argument) {
                    Se.push(" ", ve("argument"));
                    let Ie = Ce.getParentNode();
                    if (T(Ie) && Ie.callee === be || m(Ie) && Ie.object === be) {
                      Se = [p([i, ...Se]), i];
                      let Oe = Ce.findAncestor((Je) => Je.type === "AwaitExpression" || Je.type === "BlockStatement");
                      if (!Oe || Oe.type !== "AwaitExpression")
                        return l(Se);
                    }
                  }
                  return Se;
                }
                case "ExportDefaultDeclaration":
                case "ExportNamedDeclaration":
                  return ce(Ce, Be, ve);
                case "ExportAllDeclaration":
                  return W(Ce, Be, ve);
                case "ImportDeclaration":
                  return ee(Ce, Be, ve);
                case "ImportSpecifier":
                case "ExportSpecifier":
                case "ImportNamespaceSpecifier":
                case "ExportNamespaceSpecifier":
                case "ImportDefaultSpecifier":
                case "ExportDefaultSpecifier":
                  return K(Ce, Be, ve);
                case "ImportAttribute":
                  return [ve("key"), ": ", ve("value")];
                case "Import":
                  return "import";
                case "BlockStatement":
                case "StaticBlock":
                case "ClassBody":
                  return le(Ce, Be, ve);
                case "ThrowStatement":
                  return Re(Ce, Be, ve);
                case "ReturnStatement":
                  return ke(Ce, Be, ve);
                case "NewExpression":
                case "ImportExpression":
                case "OptionalCallExpression":
                case "CallExpression":
                  return Ne(Ce, Be, ve);
                case "ObjectExpression":
                case "ObjectPattern":
                case "RecordExpression":
                  return z(Ce, Be, ve);
                case "ObjectProperty":
                case "Property":
                  return be.method || be.kind === "get" || be.kind === "set" ? we(Ce, Be, ve) : fe(Ce, Be, ve);
                case "ObjectMethod":
                  return we(Ce, Be, ve);
                case "Decorator":
                  return ["@", ve("expression")];
                case "ArrayExpression":
                case "ArrayPattern":
                case "TupleExpression":
                  return Fe(Ce, Be, ve);
                case "SequenceExpression": {
                  let Ie = Ce.getParentNode(0);
                  if (Ie.type === "ExpressionStatement" || Ie.type === "ForStatement") {
                    let Oe = [];
                    return Ce.each((Je, Te) => {
                      Te === 0 ? Oe.push(ve()) : Oe.push(",", p([n, ve()]));
                    }, "expressions"), l(Oe);
                  }
                  return l(a([",", n], Ce.map(ve, "expressions")));
                }
                case "ThisExpression":
                  return "this";
                case "Super":
                  return "super";
                case "Directive":
                  return [ve("value"), Ye];
                case "DirectiveLiteral":
                  return ie(be.extra.raw, Be);
                case "UnaryExpression":
                  return Se.push(be.operator), /[a-z]$/.test(be.operator) && Se.push(" "), E(be.argument) ? Se.push(l(["(", p([i, ve("argument")]), i, ")"])) : Se.push(ve("argument")), Se;
                case "UpdateExpression":
                  return Se.push(ve("argument"), be.operator), be.prefix && Se.reverse(), Se;
                case "ConditionalExpression":
                  return de(Ce, Be, ve);
                case "VariableDeclaration": {
                  let Ie = Ce.map(ve, "declarations"), Oe = Ce.getParentNode(), Je = Oe.type === "ForStatement" || Oe.type === "ForInStatement" || Oe.type === "ForOfStatement", Te = be.declarations.some((Me) => Me.init), je;
                  return Ie.length === 1 && !E(be.declarations[0]) ? je = Ie[0] : Ie.length > 0 && (je = p(Ie[0])), Se = [be.declare ? "declare " : "", be.kind, je ? [" ", je] : "", p(Ie.slice(1).map((Me) => [",", Te && !Je ? u : n, Me]))], Je && Oe.body !== be || Se.push(Ye), l(Se);
                }
                case "WithStatement":
                  return l(["with (", ve("object"), ")", V(be.body, ve("body"))]);
                case "IfStatement": {
                  let Ie = V(be.consequent, ve("consequent")), Oe = l(["if (", l([p([i, ve("test")]), i]), ")", Ie]);
                  if (Se.push(Oe), be.alternate) {
                    let Je = E(be.consequent, N.Trailing | N.Line) || $(be), Te = be.consequent.type === "BlockStatement" && !Je;
                    Se.push(Te ? " " : u), E(be, N.Dangling) && Se.push(t3(Ce, Be, true), Je ? u : " "), Se.push("else", l(V(be.alternate, ve("alternate"), be.alternate.type === "IfStatement")));
                  }
                  return Se;
                }
                case "ForStatement": {
                  let Ie = V(be.body, ve("body")), Oe = t3(Ce, Be, true), Je = Oe ? [Oe, i] : "";
                  return !be.init && !be.test && !be.update ? [Je, l(["for (;;)", Ie])] : [Je, l(["for (", l([p([i, ve("init"), ";", n, ve("test"), ";", n, ve("update")]), i]), ")", Ie])];
                }
                case "WhileStatement":
                  return l(["while (", l([p([i, ve("test")]), i]), ")", V(be.body, ve("body"))]);
                case "ForInStatement":
                  return l(["for (", ve("left"), " in ", ve("right"), ")", V(be.body, ve("body"))]);
                case "ForOfStatement":
                  return l(["for", be.await ? " await" : "", " (", ve("left"), " of ", ve("right"), ")", V(be.body, ve("body"))]);
                case "DoWhileStatement": {
                  let Ie = V(be.body, ve("body"));
                  return Se = [l(["do", Ie])], be.body.type === "BlockStatement" ? Se.push(" ") : Se.push(u), Se.push("while (", l([p([i, ve("test")]), i]), ")", Ye), Se;
                }
                case "DoExpression":
                  return [be.async ? "async " : "", "do ", ve("body")];
                case "BreakStatement":
                  return Se.push("break"), be.label && Se.push(" ", ve("label")), Se.push(Ye), Se;
                case "ContinueStatement":
                  return Se.push("continue"), be.label && Se.push(" ", ve("label")), Se.push(Ye), Se;
                case "LabeledStatement":
                  return be.body.type === "EmptyStatement" ? [ve("label"), ":;"] : [ve("label"), ": ", ve("body")];
                case "TryStatement":
                  return ["try ", ve("block"), be.handler ? [" ", ve("handler")] : "", be.finalizer ? [" finally ", ve("finalizer")] : ""];
                case "CatchClause":
                  if (be.param) {
                    let Ie = E(be.param, (Je) => !v(Je) || Je.leading && s(Be.originalText, d(Je)) || Je.trailing && s(Be.originalText, o(Je), { backwards: true })), Oe = ve("param");
                    return ["catch ", Ie ? ["(", p([i, Oe]), i, ") "] : ["(", Oe, ") "], ve("body")];
                  }
                  return ["catch ", ve("body")];
                case "SwitchStatement":
                  return [l(["switch (", p([i, ve("discriminant")]), i, ")"]), " {", be.cases.length > 0 ? p([u, a(u, Ce.map((Ie, Oe, Je) => {
                    let Te = Ie.getValue();
                    return [ve(), Oe !== Je.length - 1 && P(Te, Be) ? u : ""];
                  }, "cases"))]) : "", u, "}"];
                case "SwitchCase": {
                  be.test ? Se.push("case ", ve("test"), ":") : Se.push("default:"), E(be, N.Dangling) && Se.push(" ", t3(Ce, Be, true));
                  let Ie = be.consequent.filter((Oe) => Oe.type !== "EmptyStatement");
                  if (Ie.length > 0) {
                    let Oe = pe(Ce, Be, ve);
                    Se.push(Ie.length === 1 && Ie[0].type === "BlockStatement" ? [" ", Oe] : p([u, Oe]));
                  }
                  return Se;
                }
                case "DebuggerStatement":
                  return ["debugger", Ye];
                case "ClassDeclaration":
                case "ClassExpression":
                  return U(Ce, Be, ve);
                case "ClassMethod":
                case "ClassPrivateMethod":
                case "MethodDefinition":
                  return Z(Ce, Be, ve);
                case "ClassProperty":
                case "PropertyDefinition":
                case "ClassPrivateProperty":
                case "ClassAccessorProperty":
                case "AccessorProperty":
                  return se(Ce, Be, ve);
                case "TemplateElement":
                  return y(be.value.raw);
                case "TemplateLiteral":
                  return ue(Ce, ve, Be);
                case "TaggedTemplateExpression":
                  return [ve("tag"), ve("typeParameters"), ve("quasi")];
                case "PrivateIdentifier":
                  return ["#", ve("name")];
                case "PrivateName":
                  return ["#", ve("id")];
                case "InterpreterDirective":
                  return Se.push("#!", be.value, u), P(be, Be) && Se.push(u), Se;
                case "TopicReference":
                  return "%";
                case "ArgumentPlaceholder":
                  return "?";
                case "ModuleExpression": {
                  Se.push("module {");
                  let Ie = ve("body");
                  return Ie && Se.push(p([u, Ie]), u), Se.push("}"), Se;
                }
                default:
                  throw new Error("unknown type: " + JSON.stringify(be.type));
              }
            }
            function ye(Ce) {
              return Ce.type && !v(Ce) && !I(Ce) && Ce.type !== "EmptyStatement" && Ce.type !== "TemplateElement" && Ce.type !== "Import" && Ce.type !== "TSEmptyBodyFunctionExpression";
            }
            r.exports = { preprocess: _, print: G, embed: h, insertPragma: c, massageAstNode: g, hasPrettierIgnore(Ce) {
              return D(Ce) || M(Ce);
            }, willPrintOwnComments: f.willPrintOwnComments, canAttachComment: ye, printComment: Ee, isBlockComment: v, handleComments: { avoidAstMutation: true, ownLine: f.handleOwnLineComment, endOfLine: f.handleEndOfLineComment, remaining: f.handleRemainingComment }, getCommentChildNodes: f.getCommentChildNodes };
          } }), Ed = te({ "src/language-js/printer-estree-json.js"(e, r) {
            "use strict";
            ne();
            var { builders: { hardline: t3, indent: s, join: a } } = qe(), n = Fo();
            function u(y, h, g) {
              let c = y.getValue();
              switch (c.type) {
                case "JsonRoot":
                  return [g("node"), t3];
                case "ArrayExpression": {
                  if (c.elements.length === 0)
                    return "[]";
                  let f = y.map(() => y.getValue() === null ? "null" : g(), "elements");
                  return ["[", s([t3, a([",", t3], f)]), t3, "]"];
                }
                case "ObjectExpression":
                  return c.properties.length === 0 ? "{}" : ["{", s([t3, a([",", t3], y.map(g, "properties"))]), t3, "}"];
                case "ObjectProperty":
                  return [g("key"), ": ", g("value")];
                case "UnaryExpression":
                  return [c.operator === "+" ? "" : c.operator, g("argument")];
                case "NullLiteral":
                  return "null";
                case "BooleanLiteral":
                  return c.value ? "true" : "false";
                case "StringLiteral":
                  return JSON.stringify(c.value);
                case "NumericLiteral":
                  return i(y) ? JSON.stringify(String(c.value)) : JSON.stringify(c.value);
                case "Identifier":
                  return i(y) ? JSON.stringify(c.name) : c.name;
                case "TemplateLiteral":
                  return g(["quasis", 0]);
                case "TemplateElement":
                  return JSON.stringify(c.value.cooked);
                default:
                  throw new Error("unknown type: " + JSON.stringify(c.type));
              }
            }
            function i(y) {
              return y.getName() === "key" && y.getParentNode().type === "ObjectProperty";
            }
            var l = /* @__PURE__ */ new Set(["start", "end", "extra", "loc", "comments", "leadingComments", "trailingComments", "innerComments", "errors", "range", "tokens"]);
            function p(y, h) {
              let { type: g } = y;
              if (g === "ObjectProperty") {
                let { key: c } = y;
                c.type === "Identifier" ? h.key = { type: "StringLiteral", value: c.name } : c.type === "NumericLiteral" && (h.key = { type: "StringLiteral", value: String(c.value) });
                return;
              }
              if (g === "UnaryExpression" && y.operator === "+")
                return h.argument;
              if (g === "ArrayExpression") {
                for (let [c, f] of y.elements.entries())
                  f === null && h.elements.splice(c, 0, { type: "NullLiteral" });
                return;
              }
              if (g === "TemplateLiteral")
                return { type: "StringLiteral", value: y.quasis[0].value.cooked };
            }
            p.ignoredProperties = l, r.exports = { preprocess: n, print: u, massageAstNode: p };
          } }), Mt = te({ "src/common/common-options.js"(e, r) {
            "use strict";
            ne();
            var t3 = "Common";
            r.exports = { bracketSpacing: { since: "0.0.0", category: t3, type: "boolean", default: true, description: "Print spaces between brackets.", oppositeDescription: "Do not print spaces between brackets." }, singleQuote: { since: "0.0.0", category: t3, type: "boolean", default: false, description: "Use single quotes instead of double quotes." }, proseWrap: { since: "1.8.2", category: t3, type: "choice", default: [{ since: "1.8.2", value: true }, { since: "1.9.0", value: "preserve" }], description: "How to wrap prose.", choices: [{ since: "1.9.0", value: "always", description: "Wrap prose if it exceeds the print width." }, { since: "1.9.0", value: "never", description: "Do not wrap prose." }, { since: "1.9.0", value: "preserve", description: "Wrap prose as-is." }] }, bracketSameLine: { since: "2.4.0", category: t3, type: "boolean", default: false, description: "Put > of opening tags on the last line instead of on a new line." }, singleAttributePerLine: { since: "2.6.0", category: t3, type: "boolean", default: false, description: "Enforce single attribute per line in HTML, Vue and JSX." } };
          } }), Fd = te({ "src/language-js/options.js"(e, r) {
            "use strict";
            ne();
            var t3 = Mt(), s = "JavaScript";
            r.exports = { arrowParens: { since: "1.9.0", category: s, type: "choice", default: [{ since: "1.9.0", value: "avoid" }, { since: "2.0.0", value: "always" }], description: "Include parentheses around a sole arrow function parameter.", choices: [{ value: "always", description: "Always include parens. Example: `(x) => x`" }, { value: "avoid", description: "Omit parens when possible. Example: `x => x`" }] }, bracketSameLine: t3.bracketSameLine, bracketSpacing: t3.bracketSpacing, jsxBracketSameLine: { since: "0.17.0", category: s, type: "boolean", description: "Put > on the last line instead of at a new line.", deprecated: "2.4.0" }, semi: { since: "1.0.0", category: s, type: "boolean", default: true, description: "Print semicolons.", oppositeDescription: "Do not print semicolons, except at the beginning of lines which may need them." }, singleQuote: t3.singleQuote, jsxSingleQuote: { since: "1.15.0", category: s, type: "boolean", default: false, description: "Use single quotes in JSX." }, quoteProps: { since: "1.17.0", category: s, type: "choice", default: "as-needed", description: "Change when properties in objects are quoted.", choices: [{ value: "as-needed", description: "Only add quotes around object properties where required." }, { value: "consistent", description: "If at least one property in an object requires quotes, quote all properties." }, { value: "preserve", description: "Respect the input use of quotes in object properties." }] }, trailingComma: { since: "0.0.0", category: s, type: "choice", default: [{ since: "0.0.0", value: false }, { since: "0.19.0", value: "none" }, { since: "2.0.0", value: "es5" }], description: "Print trailing commas wherever possible when multi-line.", choices: [{ value: "es5", description: "Trailing commas where valid in ES5 (objects, arrays, etc.)" }, { value: "none", description: "No trailing commas." }, { value: "all", description: "Trailing commas wherever possible (including function arguments)." }] }, singleAttributePerLine: t3.singleAttributePerLine };
          } }), Ad = te({ "src/language-js/parse/parsers.js"() {
            ne();
          } }), Ln = te({ "node_modules/linguist-languages/data/JavaScript.json"(e, r) {
            r.exports = { name: "JavaScript", type: "programming", tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "text/javascript", color: "#f1e05a", aliases: ["js", "node"], extensions: [".js", "._js", ".bones", ".cjs", ".es", ".es6", ".frag", ".gs", ".jake", ".javascript", ".jsb", ".jscad", ".jsfl", ".jslib", ".jsm", ".jspre", ".jss", ".jsx", ".mjs", ".njs", ".pac", ".sjs", ".ssjs", ".xsjs", ".xsjslib"], filenames: ["Jakefile"], interpreters: ["chakra", "d8", "gjs", "js", "node", "nodejs", "qjs", "rhino", "v8", "v8-shell"], languageId: 183 };
          } }), Sd = te({ "node_modules/linguist-languages/data/TypeScript.json"(e, r) {
            r.exports = { name: "TypeScript", type: "programming", color: "#3178c6", aliases: ["ts"], interpreters: ["deno", "ts-node"], extensions: [".ts", ".cts", ".mts"], tmScope: "source.ts", aceMode: "typescript", codemirrorMode: "javascript", codemirrorMimeType: "application/typescript", languageId: 378 };
          } }), xd = te({ "node_modules/linguist-languages/data/TSX.json"(e, r) {
            r.exports = { name: "TSX", type: "programming", color: "#3178c6", group: "TypeScript", extensions: [".tsx"], tmScope: "source.tsx", aceMode: "javascript", codemirrorMode: "jsx", codemirrorMimeType: "text/jsx", languageId: 94901924 };
          } }), wa = te({ "node_modules/linguist-languages/data/JSON.json"(e, r) {
            r.exports = { name: "JSON", type: "data", color: "#292929", tmScope: "source.json", aceMode: "json", codemirrorMode: "javascript", codemirrorMimeType: "application/json", aliases: ["geojson", "jsonl", "topojson"], extensions: [".json", ".4DForm", ".4DProject", ".avsc", ".geojson", ".gltf", ".har", ".ice", ".JSON-tmLanguage", ".jsonl", ".mcmeta", ".tfstate", ".tfstate.backup", ".topojson", ".webapp", ".webmanifest", ".yy", ".yyp"], filenames: [".arcconfig", ".auto-changelog", ".c8rc", ".htmlhintrc", ".imgbotconfig", ".nycrc", ".tern-config", ".tern-project", ".watchmanconfig", "Pipfile.lock", "composer.lock", "mcmod.info"], languageId: 174 };
          } }), bd = te({ "node_modules/linguist-languages/data/JSON with Comments.json"(e, r) {
            r.exports = { name: "JSON with Comments", type: "data", color: "#292929", group: "JSON", tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "text/javascript", aliases: ["jsonc"], extensions: [".jsonc", ".code-snippets", ".sublime-build", ".sublime-commands", ".sublime-completions", ".sublime-keymap", ".sublime-macro", ".sublime-menu", ".sublime-mousemap", ".sublime-project", ".sublime-settings", ".sublime-theme", ".sublime-workspace", ".sublime_metrics", ".sublime_session"], filenames: [".babelrc", ".devcontainer.json", ".eslintrc.json", ".jscsrc", ".jshintrc", ".jslintrc", "api-extractor.json", "devcontainer.json", "jsconfig.json", "language-configuration.json", "tsconfig.json", "tslint.json"], languageId: 423 };
          } }), Td = te({ "node_modules/linguist-languages/data/JSON5.json"(e, r) {
            r.exports = { name: "JSON5", type: "data", color: "#267CB9", extensions: [".json5"], tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "application/json", languageId: 175 };
          } }), Bd = te({ "src/language-js/index.js"(e, r) {
            "use strict";
            ne();
            var t3 = _t(), s = Cd(), a = Ed(), n = Fd(), u = Ad(), i = [t3(Ln(), (p) => ({ since: "0.0.0", parsers: ["babel", "acorn", "espree", "meriyah", "babel-flow", "babel-ts", "flow", "typescript"], vscodeLanguageIds: ["javascript", "mongo"], interpreters: [...p.interpreters, "zx"], extensions: [...p.extensions.filter((y) => y !== ".jsx"), ".wxs"] })), t3(Ln(), () => ({ name: "Flow", since: "0.0.0", parsers: ["flow", "babel-flow"], vscodeLanguageIds: ["javascript"], aliases: [], filenames: [], extensions: [".js.flow"] })), t3(Ln(), () => ({ name: "JSX", since: "0.0.0", parsers: ["babel", "babel-flow", "babel-ts", "flow", "typescript", "espree", "meriyah"], vscodeLanguageIds: ["javascriptreact"], aliases: void 0, filenames: void 0, extensions: [".jsx"], group: "JavaScript", interpreters: void 0, tmScope: "source.js.jsx", aceMode: "javascript", codemirrorMode: "jsx", codemirrorMimeType: "text/jsx", color: void 0 })), t3(Sd(), () => ({ since: "1.4.0", parsers: ["typescript", "babel-ts"], vscodeLanguageIds: ["typescript"] })), t3(xd(), () => ({ since: "1.4.0", parsers: ["typescript", "babel-ts"], vscodeLanguageIds: ["typescriptreact"] })), t3(wa(), () => ({ name: "JSON.stringify", since: "1.13.0", parsers: ["json-stringify"], vscodeLanguageIds: ["json"], extensions: [".importmap"], filenames: ["package.json", "package-lock.json", "composer.json"] })), t3(wa(), (p) => ({ since: "1.5.0", parsers: ["json"], vscodeLanguageIds: ["json"], extensions: p.extensions.filter((y) => y !== ".jsonl") })), t3(bd(), (p) => ({ since: "1.5.0", parsers: ["json"], vscodeLanguageIds: ["jsonc"], filenames: [...p.filenames, ".eslintrc", ".swcrc"] })), t3(Td(), () => ({ since: "1.13.0", parsers: ["json5"], vscodeLanguageIds: ["json5"] }))], l = { estree: s, "estree-json": a };
            r.exports = { languages: i, options: n, printers: l, parsers: u };
          } }), Nd = te({ "src/language-css/clean.js"(e, r) {
            "use strict";
            ne();
            var { isFrontMatterNode: t3 } = Ue(), s = lt2(), a = /* @__PURE__ */ new Set(["raw", "raws", "sourceIndex", "source", "before", "after", "trailingComma"]);
            function n(i, l, p) {
              if (t3(i) && i.lang === "yaml" && delete l.value, i.type === "css-comment" && p.type === "css-root" && p.nodes.length > 0 && ((p.nodes[0] === i || t3(p.nodes[0]) && p.nodes[1] === i) && (delete l.text, /^\*\s*@(?:format|prettier)\s*$/.test(i.text)) || p.type === "css-root" && s(p.nodes) === i))
                return null;
              if (i.type === "value-root" && delete l.text, (i.type === "media-query" || i.type === "media-query-list" || i.type === "media-feature-expression") && delete l.value, i.type === "css-rule" && delete l.params, i.type === "selector-combinator" && (l.value = l.value.replace(/\s+/g, " ")), i.type === "media-feature" && (l.value = l.value.replace(/ /g, "")), (i.type === "value-word" && (i.isColor && i.isHex || ["initial", "inherit", "unset", "revert"].includes(l.value.replace().toLowerCase())) || i.type === "media-feature" || i.type === "selector-root-invalid" || i.type === "selector-pseudo") && (l.value = l.value.toLowerCase()), i.type === "css-decl" && (l.prop = l.prop.toLowerCase()), (i.type === "css-atrule" || i.type === "css-import") && (l.name = l.name.toLowerCase()), i.type === "value-number" && (l.unit = l.unit.toLowerCase()), (i.type === "media-feature" || i.type === "media-keyword" || i.type === "media-type" || i.type === "media-unknown" || i.type === "media-url" || i.type === "media-value" || i.type === "selector-attribute" || i.type === "selector-string" || i.type === "selector-class" || i.type === "selector-combinator" || i.type === "value-string") && l.value && (l.value = u(l.value)), i.type === "selector-attribute" && (l.attribute = l.attribute.trim(), l.namespace && typeof l.namespace == "string" && (l.namespace = l.namespace.trim(), l.namespace.length === 0 && (l.namespace = true)), l.value && (l.value = l.value.trim().replace(/^["']|["']$/g, ""), delete l.quoted)), (i.type === "media-value" || i.type === "media-type" || i.type === "value-number" || i.type === "selector-root-invalid" || i.type === "selector-class" || i.type === "selector-combinator" || i.type === "selector-tag") && l.value && (l.value = l.value.replace(/([\d+.Ee-]+)([A-Za-z]*)/g, (y, h, g) => {
                let c = Number(h);
                return Number.isNaN(c) ? y : c + g.toLowerCase();
              })), i.type === "selector-tag") {
                let y = i.value.toLowerCase();
                ["from", "to"].includes(y) && (l.value = y);
              }
              if (i.type === "css-atrule" && i.name.toLowerCase() === "supports" && delete l.value, i.type === "selector-unknown" && delete l.value, i.type === "value-comma_group") {
                let y = i.groups.findIndex((h) => h.type === "value-number" && h.unit === "...");
                y !== -1 && (l.groups[y].unit = "", l.groups.splice(y + 1, 0, { type: "value-word", value: "...", isColor: false, isHex: false }));
              }
              if (i.type === "value-comma_group" && i.groups.some((y) => y.type === "value-atword" && y.value.endsWith("[") || y.type === "value-word" && y.value.startsWith("]")))
                return { type: "value-atword", value: i.groups.map((y) => y.value).join(""), group: { open: null, close: null, groups: [], type: "value-paren_group" } };
            }
            n.ignoredProperties = a;
            function u(i) {
              return i.replace(/'/g, '"').replace(/\\([^\dA-Fa-f])/g, "$1");
            }
            r.exports = n;
          } }), su = te({ "src/utils/front-matter/print.js"(e, r) {
            "use strict";
            ne();
            var { builders: { hardline: t3, markAsRoot: s } } = qe();
            function a(n, u) {
              if (n.lang === "yaml") {
                let i = n.value.trim(), l = i ? u(i, { parser: "yaml" }, { stripTrailingHardline: true }) : "";
                return s([n.startDelimiter, t3, l, l ? t3 : "", n.endDelimiter]);
              }
            }
            r.exports = a;
          } }), wd = te({ "src/language-css/embed.js"(e, r) {
            "use strict";
            ne();
            var { builders: { hardline: t3 } } = qe(), s = su();
            function a(n, u, i) {
              let l = n.getValue();
              if (l.type === "front-matter") {
                let p = s(l, i);
                return p ? [p, t3] : "";
              }
            }
            r.exports = a;
          } }), _o = te({ "src/utils/front-matter/parse.js"(e, r) {
            "use strict";
            ne();
            var t3 = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
            function s(a) {
              let n = a.match(t3);
              if (!n)
                return { content: a };
              let { startDelimiter: u, language: i, value: l = "", endDelimiter: p } = n.groups, y = i.trim() || "yaml";
              if (u === "+++" && (y = "toml"), y !== "yaml" && u !== p)
                return { content: a };
              let [h] = n;
              return { frontMatter: { type: "front-matter", lang: y, value: l, startDelimiter: u, endDelimiter: p, raw: h.replace(/\n$/, "") }, content: h.replace(/[^\n]/g, " ") + a.slice(h.length) };
            }
            r.exports = s;
          } }), _d = te({ "src/language-css/pragma.js"(e, r) {
            "use strict";
            ne();
            var t3 = Co(), s = _o();
            function a(u) {
              return t3.hasPragma(s(u).content);
            }
            function n(u) {
              let { frontMatter: i, content: l } = s(u);
              return (i ? i.raw + `

` : "") + t3.insertPragma(l);
            }
            r.exports = { hasPragma: a, insertPragma: n };
          } }), Pd = te({ "src/language-css/utils/index.js"(e, r) {
            "use strict";
            ne();
            var t3 = /* @__PURE__ */ new Set(["red", "green", "blue", "alpha", "a", "rgb", "hue", "h", "saturation", "s", "lightness", "l", "whiteness", "w", "blackness", "b", "tint", "shade", "blend", "blenda", "contrast", "hsl", "hsla", "hwb", "hwba"]);
            function s(z, U) {
              let Z = Array.isArray(U) ? U : [U], se = -1, fe;
              for (; fe = z.getParentNode(++se); )
                if (Z.includes(fe.type))
                  return se;
              return -1;
            }
            function a(z, U) {
              let Z = s(z, U);
              return Z === -1 ? null : z.getParentNode(Z);
            }
            function n(z) {
              var U;
              let Z = a(z, "css-decl");
              return Z == null || (U = Z.prop) === null || U === void 0 ? void 0 : U.toLowerCase();
            }
            var u = /* @__PURE__ */ new Set(["initial", "inherit", "unset", "revert"]);
            function i(z) {
              return u.has(z.toLowerCase());
            }
            function l(z, U) {
              let Z = a(z, "css-atrule");
              return (Z == null ? void 0 : Z.name) && Z.name.toLowerCase().endsWith("keyframes") && ["from", "to"].includes(U.toLowerCase());
            }
            function p(z) {
              return z.includes("$") || z.includes("@") || z.includes("#") || z.startsWith("%") || z.startsWith("--") || z.startsWith(":--") || z.includes("(") && z.includes(")") ? z : z.toLowerCase();
            }
            function y(z, U) {
              var Z;
              let se = a(z, "value-func");
              return (se == null || (Z = se.value) === null || Z === void 0 ? void 0 : Z.toLowerCase()) === U;
            }
            function h(z) {
              var U;
              let Z = a(z, "css-rule"), se = Z == null || (U = Z.raws) === null || U === void 0 ? void 0 : U.selector;
              return se && (se.startsWith(":import") || se.startsWith(":export"));
            }
            function g(z, U) {
              let Z = Array.isArray(U) ? U : [U], se = a(z, "css-atrule");
              return se && Z.includes(se.name.toLowerCase());
            }
            function c(z) {
              let U = z.getValue(), Z = a(z, "css-atrule");
              return (Z == null ? void 0 : Z.name) === "import" && U.groups[0].value === "url" && U.groups.length === 2;
            }
            function f(z) {
              return z.type === "value-func" && z.value.toLowerCase() === "url";
            }
            function F(z, U) {
              var Z;
              let se = (Z = z.getParentNode()) === null || Z === void 0 ? void 0 : Z.nodes;
              return se && se.indexOf(U) === se.length - 1;
            }
            function _(z) {
              let { selector: U } = z;
              return U ? typeof U == "string" && /^@.+:.*$/.test(U) || U.value && /^@.+:.*$/.test(U.value) : false;
            }
            function w(z) {
              return z.type === "value-word" && ["from", "through", "end"].includes(z.value);
            }
            function E(z) {
              return z.type === "value-word" && ["and", "or", "not"].includes(z.value);
            }
            function N(z) {
              return z.type === "value-word" && z.value === "in";
            }
            function x(z) {
              return z.type === "value-operator" && z.value === "*";
            }
            function I(z) {
              return z.type === "value-operator" && z.value === "/";
            }
            function P(z) {
              return z.type === "value-operator" && z.value === "+";
            }
            function $(z) {
              return z.type === "value-operator" && z.value === "-";
            }
            function D(z) {
              return z.type === "value-operator" && z.value === "%";
            }
            function T(z) {
              return x(z) || I(z) || P(z) || $(z) || D(z);
            }
            function m(z) {
              return z.type === "value-word" && ["==", "!="].includes(z.value);
            }
            function C(z) {
              return z.type === "value-word" && ["<", ">", "<=", ">="].includes(z.value);
            }
            function o(z) {
              return z.type === "css-atrule" && ["if", "else", "for", "each", "while"].includes(z.name);
            }
            function d(z) {
              var U;
              return ((U = z.raws) === null || U === void 0 ? void 0 : U.params) && /^\(\s*\)$/.test(z.raws.params);
            }
            function v(z) {
              return z.name.startsWith("prettier-placeholder");
            }
            function S(z) {
              return z.prop.startsWith("@prettier-placeholder");
            }
            function b(z, U) {
              return z.value === "$$" && z.type === "value-func" && (U == null ? void 0 : U.type) === "value-word" && !U.raws.before;
            }
            function B(z) {
              var U, Z;
              return ((U = z.value) === null || U === void 0 ? void 0 : U.type) === "value-root" && ((Z = z.value.group) === null || Z === void 0 ? void 0 : Z.type) === "value-value" && z.prop.toLowerCase() === "composes";
            }
            function k(z) {
              var U, Z, se;
              return ((U = z.value) === null || U === void 0 || (Z = U.group) === null || Z === void 0 || (se = Z.group) === null || se === void 0 ? void 0 : se.type) === "value-paren_group" && z.value.group.group.open !== null && z.value.group.group.close !== null;
            }
            function M(z) {
              var U;
              return ((U = z.raws) === null || U === void 0 ? void 0 : U.before) === "";
            }
            function R(z) {
              var U, Z;
              return z.type === "value-comma_group" && ((U = z.groups) === null || U === void 0 || (Z = U[1]) === null || Z === void 0 ? void 0 : Z.type) === "value-colon";
            }
            function q(z) {
              var U;
              return z.type === "value-paren_group" && ((U = z.groups) === null || U === void 0 ? void 0 : U[0]) && R(z.groups[0]);
            }
            function J(z) {
              var U;
              let Z = z.getValue();
              if (Z.groups.length === 0)
                return false;
              let se = z.getParentNode(1);
              if (!q(Z) && !(se && q(se)))
                return false;
              let fe = a(z, "css-decl");
              return !!(fe != null && (U = fe.prop) !== null && U !== void 0 && U.startsWith("$") || q(se) || se.type === "value-func");
            }
            function L(z) {
              return z.type === "value-comment" && z.inline;
            }
            function Q(z) {
              return z.type === "value-word" && z.value === "#";
            }
            function V(z) {
              return z.type === "value-word" && z.value === "{";
            }
            function j(z) {
              return z.type === "value-word" && z.value === "}";
            }
            function Y(z) {
              return ["value-word", "value-atword"].includes(z.type);
            }
            function ie(z) {
              return (z == null ? void 0 : z.type) === "value-colon";
            }
            function ee(z, U) {
              if (!R(U))
                return false;
              let { groups: Z } = U, se = Z.indexOf(z);
              return se === -1 ? false : ie(Z[se + 1]);
            }
            function ce(z) {
              return z.value && ["not", "and", "or"].includes(z.value.toLowerCase());
            }
            function W(z) {
              return z.type !== "value-func" ? false : t3.has(z.value.toLowerCase());
            }
            function K(z) {
              return /\/\//.test(z.split(/[\n\r]/).pop());
            }
            function de(z) {
              return (z == null ? void 0 : z.type) === "value-atword" && z.value.startsWith("prettier-placeholder-");
            }
            function ue(z, U) {
              var Z, se;
              if (((Z = z.open) === null || Z === void 0 ? void 0 : Z.value) !== "(" || ((se = z.close) === null || se === void 0 ? void 0 : se.value) !== ")" || z.groups.some((fe) => fe.type !== "value-comma_group"))
                return false;
              if (U.type === "value-comma_group") {
                let fe = U.groups.indexOf(z) - 1, ge = U.groups[fe];
                if ((ge == null ? void 0 : ge.type) === "value-word" && ge.value === "with")
                  return true;
              }
              return false;
            }
            function Fe(z) {
              var U, Z;
              return z.type === "value-paren_group" && ((U = z.open) === null || U === void 0 ? void 0 : U.value) === "(" && ((Z = z.close) === null || Z === void 0 ? void 0 : Z.value) === ")";
            }
            r.exports = { getAncestorCounter: s, getAncestorNode: a, getPropOfDeclNode: n, maybeToLowerCase: p, insideValueFunctionNode: y, insideICSSRuleNode: h, insideAtRuleNode: g, insideURLFunctionInImportAtRuleNode: c, isKeyframeAtRuleKeywords: l, isWideKeywords: i, isLastNode: F, isSCSSControlDirectiveNode: o, isDetachedRulesetDeclarationNode: _, isRelationalOperatorNode: C, isEqualityOperatorNode: m, isMultiplicationNode: x, isDivisionNode: I, isAdditionNode: P, isSubtractionNode: $, isModuloNode: D, isMathOperatorNode: T, isEachKeywordNode: N, isForKeywordNode: w, isURLFunctionNode: f, isIfElseKeywordNode: E, hasComposesNode: B, hasParensAroundNode: k, hasEmptyRawBefore: M, isDetachedRulesetCallNode: d, isTemplatePlaceholderNode: v, isTemplatePropNode: S, isPostcssSimpleVarNode: b, isKeyValuePairNode: R, isKeyValuePairInParenGroupNode: q, isKeyInValuePairNode: ee, isSCSSMapItemNode: J, isInlineValueCommentNode: L, isHashNode: Q, isLeftCurlyBraceNode: V, isRightCurlyBraceNode: j, isWordNode: Y, isColonNode: ie, isMediaAndSupportsKeywords: ce, isColorAdjusterFuncNode: W, lastLineHasInlineComment: K, isAtWordPlaceholderNode: de, isConfigurationNode: ue, isParenGroupNode: Fe };
          } }), Id = te({ "src/utils/line-column-to-index.js"(e, r) {
            "use strict";
            ne(), r.exports = function(t3, s) {
              let a = 0;
              for (let n = 0; n < t3.line - 1; ++n)
                a = s.indexOf(`
`, a) + 1;
              return a + t3.column;
            };
          } }), kd = te({ "src/language-css/loc.js"(e, r) {
            "use strict";
            ne();
            var { skipEverythingButNewLine: t3 } = Pr(), s = lt2(), a = Id();
            function n(c, f) {
              return typeof c.sourceIndex == "number" ? c.sourceIndex : c.source ? a(c.source.start, f) - 1 : null;
            }
            function u(c, f) {
              if (c.type === "css-comment" && c.inline)
                return t3(f, c.source.startOffset);
              let F = c.nodes && s(c.nodes);
              return F && c.source && !c.source.end && (c = F), c.source && c.source.end ? a(c.source.end, f) : null;
            }
            function i(c, f) {
              c.source && (c.source.startOffset = n(c, f), c.source.endOffset = u(c, f));
              for (let F in c) {
                let _ = c[F];
                F === "source" || !_ || typeof _ != "object" || (_.type === "value-root" || _.type === "value-unknown" ? l(_, p(c), _.text || _.value) : i(_, f));
              }
            }
            function l(c, f, F) {
              c.source && (c.source.startOffset = n(c, F) + f, c.source.endOffset = u(c, F) + f);
              for (let _ in c) {
                let w = c[_];
                _ === "source" || !w || typeof w != "object" || l(w, f, F);
              }
            }
            function p(c) {
              let f = c.source.startOffset;
              return typeof c.prop == "string" && (f += c.prop.length), c.type === "css-atrule" && typeof c.name == "string" && (f += 1 + c.name.length + c.raws.afterName.match(/^\s*:?\s*/)[0].length), c.type !== "css-atrule" && c.raws && typeof c.raws.between == "string" && (f += c.raws.between.length), f;
            }
            function y(c) {
              let f = "initial", F = "initial", _, w = false, E = [];
              for (let N = 0; N < c.length; N++) {
                let x = c[N];
                switch (f) {
                  case "initial":
                    if (x === "'") {
                      f = "single-quotes";
                      continue;
                    }
                    if (x === '"') {
                      f = "double-quotes";
                      continue;
                    }
                    if ((x === "u" || x === "U") && c.slice(N, N + 4).toLowerCase() === "url(") {
                      f = "url", N += 3;
                      continue;
                    }
                    if (x === "*" && c[N - 1] === "/") {
                      f = "comment-block";
                      continue;
                    }
                    if (x === "/" && c[N - 1] === "/") {
                      f = "comment-inline", _ = N - 1;
                      continue;
                    }
                    continue;
                  case "single-quotes":
                    if (x === "'" && c[N - 1] !== "\\" && (f = F, F = "initial"), x === `
` || x === "\r")
                      return c;
                    continue;
                  case "double-quotes":
                    if (x === '"' && c[N - 1] !== "\\" && (f = F, F = "initial"), x === `
` || x === "\r")
                      return c;
                    continue;
                  case "url":
                    if (x === ")" && (f = "initial"), x === `
` || x === "\r")
                      return c;
                    if (x === "'") {
                      f = "single-quotes", F = "url";
                      continue;
                    }
                    if (x === '"') {
                      f = "double-quotes", F = "url";
                      continue;
                    }
                    continue;
                  case "comment-block":
                    x === "/" && c[N - 1] === "*" && (f = "initial");
                    continue;
                  case "comment-inline":
                    (x === '"' || x === "'" || x === "*") && (w = true), (x === `
` || x === "\r") && (w && E.push([_, N]), f = "initial", w = false);
                    continue;
                }
              }
              for (let [N, x] of E)
                c = c.slice(0, N) + c.slice(N, x).replace(/["'*]/g, " ") + c.slice(x);
              return c;
            }
            function h(c) {
              return c.source.startOffset;
            }
            function g(c) {
              return c.source.endOffset;
            }
            r.exports = { locStart: h, locEnd: g, calculateLoc: i, replaceQuotesInInlineComments: y };
          } }), Ld = te({ "src/language-css/utils/is-less-parser.js"(e, r) {
            "use strict";
            ne();
            function t3(s) {
              return s.parser === "css" || s.parser === "less";
            }
            r.exports = t3;
          } }), Od = te({ "src/language-css/utils/is-scss.js"(e, r) {
            "use strict";
            ne();
            function t3(s, a) {
              return s === "less" || s === "scss" ? s === "scss" : /(?:\w\s*:\s*[^:}]+|#){|@import[^\n]+(?:url|,)/.test(a);
            }
            r.exports = t3;
          } }), jd = te({ "src/language-css/utils/css-units.evaluate.js"(e, r) {
            r.exports = { em: "em", rem: "rem", ex: "ex", rex: "rex", cap: "cap", rcap: "rcap", ch: "ch", rch: "rch", ic: "ic", ric: "ric", lh: "lh", rlh: "rlh", vw: "vw", svw: "svw", lvw: "lvw", dvw: "dvw", vh: "vh", svh: "svh", lvh: "lvh", dvh: "dvh", vi: "vi", svi: "svi", lvi: "lvi", dvi: "dvi", vb: "vb", svb: "svb", lvb: "lvb", dvb: "dvb", vmin: "vmin", svmin: "svmin", lvmin: "lvmin", dvmin: "dvmin", vmax: "vmax", svmax: "svmax", lvmax: "lvmax", dvmax: "dvmax", cm: "cm", mm: "mm", q: "Q", in: "in", pt: "pt", pc: "pc", px: "px", deg: "deg", grad: "grad", rad: "rad", turn: "turn", s: "s", ms: "ms", hz: "Hz", khz: "kHz", dpi: "dpi", dpcm: "dpcm", dppx: "dppx", x: "x" };
          } }), qd = te({ "src/language-css/utils/print-unit.js"(e, r) {
            "use strict";
            ne();
            var t3 = jd();
            function s(a) {
              let n = a.toLowerCase();
              return Object.prototype.hasOwnProperty.call(t3, n) ? t3[n] : a;
            }
            r.exports = s;
          } }), Md = te({ "src/language-css/printer-postcss.js"(e, r) {
            "use strict";
            ne();
            var t3 = lt2(), { printNumber: s, printString: a, hasNewline: n, isFrontMatterNode: u, isNextLineEmpty: i, isNonEmptyArray: l } = Ue(), { builders: { join: p, line: y, hardline: h, softline: g, group: c, fill: f, indent: F, dedent: _, ifBreak: w, breakParent: E }, utils: { removeLines: N, getDocParts: x } } = qe(), I = Nd(), P = wd(), { insertPragma: $ } = _d(), { getAncestorNode: D, getPropOfDeclNode: T, maybeToLowerCase: m, insideValueFunctionNode: C, insideICSSRuleNode: o, insideAtRuleNode: d, insideURLFunctionInImportAtRuleNode: v, isKeyframeAtRuleKeywords: S, isWideKeywords: b, isLastNode: B, isSCSSControlDirectiveNode: k, isDetachedRulesetDeclarationNode: M, isRelationalOperatorNode: R, isEqualityOperatorNode: q, isMultiplicationNode: J, isDivisionNode: L, isAdditionNode: Q, isSubtractionNode: V, isMathOperatorNode: j, isEachKeywordNode: Y, isForKeywordNode: ie, isURLFunctionNode: ee, isIfElseKeywordNode: ce, hasComposesNode: W, hasParensAroundNode: K, hasEmptyRawBefore: de, isKeyValuePairNode: ue, isKeyInValuePairNode: Fe, isDetachedRulesetCallNode: z, isTemplatePlaceholderNode: U, isTemplatePropNode: Z, isPostcssSimpleVarNode: se, isSCSSMapItemNode: fe, isInlineValueCommentNode: ge, isHashNode: he, isLeftCurlyBraceNode: we, isRightCurlyBraceNode: ke, isWordNode: Re, isColonNode: Ne, isMediaAndSupportsKeywords: Pe, isColorAdjusterFuncNode: oe, lastLineHasInlineComment: H, isAtWordPlaceholderNode: pe, isConfigurationNode: X, isParenGroupNode: le } = Pd(), { locStart: Ae, locEnd: Ee } = kd(), De = Ld(), A = Od(), G = qd();
            function re(Te) {
              return Te.trailingComma === "es5" || Te.trailingComma === "all";
            }
            function ye(Te, je, Me) {
              let ae = Te.getValue();
              if (!ae)
                return "";
              if (typeof ae == "string")
                return ae;
              switch (ae.type) {
                case "front-matter":
                  return [ae.raw, h];
                case "css-root": {
                  let Ve = Ce(Te, je, Me), We = ae.raws.after.trim();
                  return We.startsWith(";") && (We = We.slice(1).trim()), [Ve, We ? ` ${We}` : "", x(Ve).length > 0 ? h : ""];
                }
                case "css-comment": {
                  let Ve = ae.inline || ae.raws.inline, We = je.originalText.slice(Ae(ae), Ee(ae));
                  return Ve ? We.trimEnd() : We;
                }
                case "css-rule":
                  return [Me("selector"), ae.important ? " !important" : "", ae.nodes ? [ae.selector && ae.selector.type === "selector-unknown" && H(ae.selector.value) ? y : " ", "{", ae.nodes.length > 0 ? F([h, Ce(Te, je, Me)]) : "", h, "}", M(ae) ? ";" : ""] : ";"];
                case "css-decl": {
                  let Ve = Te.getParentNode(), { between: We } = ae.raws, Xe = We.trim(), st = Xe === ":", O = W(ae) ? N(Me("value")) : Me("value");
                  return !st && H(Xe) && (O = F([h, _(O)])), [ae.raws.before.replace(/[\s;]/g, ""), Ve.type === "css-atrule" && Ve.variable || o(Te) ? ae.prop : m(ae.prop), Xe.startsWith("//") ? " " : "", Xe, ae.extend ? "" : " ", De(je) && ae.extend && ae.selector ? ["extend(", Me("selector"), ")"] : "", O, ae.raws.important ? ae.raws.important.replace(/\s*!\s*important/i, " !important") : ae.important ? " !important" : "", ae.raws.scssDefault ? ae.raws.scssDefault.replace(/\s*!default/i, " !default") : ae.scssDefault ? " !default" : "", ae.raws.scssGlobal ? ae.raws.scssGlobal.replace(/\s*!global/i, " !global") : ae.scssGlobal ? " !global" : "", ae.nodes ? [" {", F([g, Ce(Te, je, Me)]), g, "}"] : Z(ae) && !Ve.raws.semicolon && je.originalText[Ee(ae) - 1] !== ";" ? "" : je.__isHTMLStyleAttribute && B(Te, ae) ? w(";") : ";"];
                }
                case "css-atrule": {
                  let Ve = Te.getParentNode(), We = U(ae) && !Ve.raws.semicolon && je.originalText[Ee(ae) - 1] !== ";";
                  if (De(je)) {
                    if (ae.mixin)
                      return [Me("selector"), ae.important ? " !important" : "", We ? "" : ";"];
                    if (ae.function)
                      return [ae.name, Me("params"), We ? "" : ";"];
                    if (ae.variable)
                      return ["@", ae.name, ": ", ae.value ? Me("value") : "", ae.raws.between.trim() ? ae.raws.between.trim() + " " : "", ae.nodes ? ["{", F([ae.nodes.length > 0 ? g : "", Ce(Te, je, Me)]), g, "}"] : "", We ? "" : ";"];
                  }
                  return ["@", z(ae) || ae.name.endsWith(":") ? ae.name : m(ae.name), ae.params ? [z(ae) ? "" : U(ae) ? ae.raws.afterName === "" ? "" : ae.name.endsWith(":") ? " " : /^\s*\n\s*\n/.test(ae.raws.afterName) ? [h, h] : /^\s*\n/.test(ae.raws.afterName) ? h : " " : " ", Me("params")] : "", ae.selector ? F([" ", Me("selector")]) : "", ae.value ? c([" ", Me("value"), k(ae) ? K(ae) ? " " : y : ""]) : ae.name === "else" ? " " : "", ae.nodes ? [k(ae) ? "" : ae.selector && !ae.selector.nodes && typeof ae.selector.value == "string" && H(ae.selector.value) || !ae.selector && typeof ae.params == "string" && H(ae.params) ? y : " ", "{", F([ae.nodes.length > 0 ? g : "", Ce(Te, je, Me)]), g, "}"] : We ? "" : ";"];
                }
                case "media-query-list": {
                  let Ve = [];
                  return Te.each((We) => {
                    let Xe = We.getValue();
                    Xe.type === "media-query" && Xe.value === "" || Ve.push(Me());
                  }, "nodes"), c(F(p(y, Ve)));
                }
                case "media-query":
                  return [p(" ", Te.map(Me, "nodes")), B(Te, ae) ? "" : ","];
                case "media-type":
                  return Oe(Se(ae.value, je));
                case "media-feature-expression":
                  return ae.nodes ? ["(", ...Te.map(Me, "nodes"), ")"] : ae.value;
                case "media-feature":
                  return m(Se(ae.value.replace(/ +/g, " "), je));
                case "media-colon":
                  return [ae.value, " "];
                case "media-value":
                  return Oe(Se(ae.value, je));
                case "media-keyword":
                  return Se(ae.value, je);
                case "media-url":
                  return Se(ae.value.replace(/^url\(\s+/gi, "url(").replace(/\s+\)$/g, ")"), je);
                case "media-unknown":
                  return ae.value;
                case "selector-root":
                  return c([d(Te, "custom-selector") ? [D(Te, "css-atrule").customSelector, y] : "", p([",", d(Te, ["extend", "custom-selector", "nest"]) ? y : h], Te.map(Me, "nodes"))]);
                case "selector-selector":
                  return c(F(Te.map(Me, "nodes")));
                case "selector-comment":
                  return ae.value;
                case "selector-string":
                  return Se(ae.value, je);
                case "selector-tag": {
                  let Ve = Te.getParentNode(), We = Ve && Ve.nodes.indexOf(ae), Xe = We && Ve.nodes[We - 1];
                  return [ae.namespace ? [ae.namespace === true ? "" : ae.namespace.trim(), "|"] : "", Xe.type === "selector-nesting" ? ae.value : Oe(S(Te, ae.value) ? ae.value.toLowerCase() : ae.value)];
                }
                case "selector-id":
                  return ["#", ae.value];
                case "selector-class":
                  return [".", Oe(Se(ae.value, je))];
                case "selector-attribute": {
                  var nt;
                  return ["[", ae.namespace ? [ae.namespace === true ? "" : ae.namespace.trim(), "|"] : "", ae.attribute.trim(), (nt = ae.operator) !== null && nt !== void 0 ? nt : "", ae.value ? Ie(Se(ae.value.trim(), je), je) : "", ae.insensitive ? " i" : "", "]"];
                }
                case "selector-combinator": {
                  if (ae.value === "+" || ae.value === ">" || ae.value === "~" || ae.value === ">>>") {
                    let Xe = Te.getParentNode();
                    return [Xe.type === "selector-selector" && Xe.nodes[0] === ae ? "" : y, ae.value, B(Te, ae) ? "" : " "];
                  }
                  let Ve = ae.value.trim().startsWith("(") ? y : "", We = Oe(Se(ae.value.trim(), je)) || y;
                  return [Ve, We];
                }
                case "selector-universal":
                  return [ae.namespace ? [ae.namespace === true ? "" : ae.namespace.trim(), "|"] : "", ae.value];
                case "selector-pseudo":
                  return [m(ae.value), l(ae.nodes) ? c(["(", F([g, p([",", y], Te.map(Me, "nodes"))]), g, ")"]) : ""];
                case "selector-nesting":
                  return ae.value;
                case "selector-unknown": {
                  let Ve = D(Te, "css-rule");
                  if (Ve && Ve.isSCSSNesterProperty)
                    return Oe(Se(m(ae.value), je));
                  let We = Te.getParentNode();
                  if (We.raws && We.raws.selector) {
                    let st = Ae(We), O = st + We.raws.selector.length;
                    return je.originalText.slice(st, O).trim();
                  }
                  let Xe = Te.getParentNode(1);
                  if (We.type === "value-paren_group" && Xe && Xe.type === "value-func" && Xe.value === "selector") {
                    let st = Ee(We.open) + 1, O = Ae(We.close), me = je.originalText.slice(st, O).trim();
                    return H(me) ? [E, me] : me;
                  }
                  return ae.value;
                }
                case "value-value":
                case "value-root":
                  return Me("group");
                case "value-comment":
                  return je.originalText.slice(Ae(ae), Ee(ae));
                case "value-comma_group": {
                  let Ve = Te.getParentNode(), We = Te.getParentNode(1), Xe = T(Te), st = Xe && Ve.type === "value-value" && (Xe === "grid" || Xe.startsWith("grid-template")), O = D(Te, "css-atrule"), me = O && k(O), _e = ae.groups.some((at2) => ge(at2)), He = Te.map(Me, "groups"), Ge = [], it = C(Te, "url"), Qe = false, rt = false;
                  for (let at2 = 0; at2 < ae.groups.length; ++at2) {
                    var tt;
                    Ge.push(He[at2]);
                    let Ze = ae.groups[at2 - 1], Le = ae.groups[at2], $e = ae.groups[at2 + 1], sr = ae.groups[at2 + 2];
                    if (it) {
                      ($e && Q($e) || Q(Le)) && Ge.push(" ");
                      continue;
                    }
                    if (d(Te, "forward") && Le.type === "value-word" && Le.value && Ze !== void 0 && Ze.type === "value-word" && Ze.value === "as" && $e.type === "value-operator" && $e.value === "*" || !$e || Le.type === "value-word" && Le.value.endsWith("-") && pe($e))
                      continue;
                    if (Le.type === "value-string" && Le.quoted) {
                      let $r = Le.value.lastIndexOf("#{"), Vr = Le.value.lastIndexOf("}");
                      $r !== -1 && Vr !== -1 ? Qe = $r > Vr : $r !== -1 ? Qe = true : Vr !== -1 && (Qe = false);
                    }
                    if (Qe || Ne(Le) || Ne($e) || Le.type === "value-atword" && (Le.value === "" || Le.value.endsWith("[")) || $e.type === "value-word" && $e.value.startsWith("]") || Le.value === "~" || Le.value && Le.value.includes("\\") && $e && $e.type !== "value-comment" || Ze && Ze.value && Ze.value.indexOf("\\") === Ze.value.length - 1 && Le.type === "value-operator" && Le.value === "/" || Le.value === "\\" || se(Le, $e) || he(Le) || we(Le) || ke($e) || we($e) && de($e) || ke(Le) && de($e) || Le.value === "--" && he($e))
                      continue;
                    let Rr = j(Le), ou = j($e);
                    if ((Rr && he($e) || ou && ke(Le)) && de($e) || !Ze && L(Le) || C(Te, "calc") && (Q(Le) || Q($e) || V(Le) || V($e)) && de($e))
                      continue;
                    let qo = (Q(Le) || V(Le)) && at2 === 0 && ($e.type === "value-number" || $e.isHex) && We && oe(We) && !de($e), lu = sr && sr.type === "value-func" || sr && Re(sr) || Le.type === "value-func" || Re(Le), cu = $e.type === "value-func" || Re($e) || Ze && Ze.type === "value-func" || Ze && Re(Ze);
                    if (!(!(J($e) || J(Le)) && !C(Te, "calc") && !qo && (L($e) && !lu || L(Le) && !cu || Q($e) && !lu || Q(Le) && !cu || V($e) || V(Le)) && (de($e) || Rr && (!Ze || Ze && j(Ze)))) && !((je.parser === "scss" || je.parser === "less") && Rr && Le.value === "-" && le($e) && Ee(Le) === Ae($e.open) && $e.open.value === "(")) {
                      if (ge(Le)) {
                        if (Ve.type === "value-paren_group") {
                          Ge.push(_(h));
                          continue;
                        }
                        Ge.push(h);
                        continue;
                      }
                      if (me && (q($e) || R($e) || ce($e) || Y(Le) || ie(Le))) {
                        Ge.push(" ");
                        continue;
                      }
                      if (O && O.name.toLowerCase() === "namespace") {
                        Ge.push(" ");
                        continue;
                      }
                      if (st) {
                        Le.source && $e.source && Le.source.start.line !== $e.source.start.line ? (Ge.push(h), rt = true) : Ge.push(" ");
                        continue;
                      }
                      if (ou) {
                        Ge.push(" ");
                        continue;
                      }
                      if (!($e && $e.value === "...") && !(pe(Le) && pe($e) && Ee(Le) === Ae($e))) {
                        if (pe(Le) && le($e) && Ee(Le) === Ae($e.open)) {
                          Ge.push(g);
                          continue;
                        }
                        if (Le.value === "with" && le($e)) {
                          Ge.push(" ");
                          continue;
                        }
                        (tt = Le.value) !== null && tt !== void 0 && tt.endsWith("#") && $e.value === "{" && le($e.group) || Ge.push(y);
                      }
                    }
                  }
                  return _e && Ge.push(E), rt && Ge.unshift(h), me ? c(F(Ge)) : v(Te) ? c(f(Ge)) : c(F(f(Ge)));
                }
                case "value-paren_group": {
                  let Ve = Te.getParentNode();
                  if (Ve && ee(Ve) && (ae.groups.length === 1 || ae.groups.length > 0 && ae.groups[0].type === "value-comma_group" && ae.groups[0].groups.length > 0 && ae.groups[0].groups[0].type === "value-word" && ae.groups[0].groups[0].value.startsWith("data:")))
                    return [ae.open ? Me("open") : "", p(",", Te.map(Me, "groups")), ae.close ? Me("close") : ""];
                  if (!ae.open) {
                    let it = Te.map(Me, "groups"), Qe = [];
                    for (let rt = 0; rt < it.length; rt++)
                      rt !== 0 && Qe.push([",", y]), Qe.push(it[rt]);
                    return c(F(f(Qe)));
                  }
                  let We = fe(Te), Xe = t3(ae.groups), st = Xe && Xe.type === "value-comment", O = Fe(ae, Ve), me = X(ae, Ve), _e = me || We && !O, He = me || O, Ge = c([ae.open ? Me("open") : "", F([g, p([y], Te.map((it, Qe) => {
                    let rt = it.getValue(), at2 = Qe === ae.groups.length - 1, Ze = [Me(), at2 ? "" : ","];
                    if (ue(rt) && rt.type === "value-comma_group" && rt.groups && rt.groups[0].type !== "value-paren_group" && rt.groups[2] && rt.groups[2].type === "value-paren_group") {
                      let Le = x(Ze[0].contents.contents);
                      Le[1] = c(Le[1]), Ze = [c(_(Ze))];
                    }
                    if (!at2 && rt.type === "value-comma_group" && l(rt.groups)) {
                      let Le = t3(rt.groups);
                      !Le.source && Le.close && (Le = Le.close), Le.source && i(je.originalText, Le, Ee) && Ze.push(h);
                    }
                    return Ze;
                  }, "groups"))]), w(!st && A(je.parser, je.originalText) && We && re(je) ? "," : ""), g, ae.close ? Me("close") : ""], { shouldBreak: _e });
                  return He ? _(Ge) : Ge;
                }
                case "value-func":
                  return [ae.value, d(Te, "supports") && Pe(ae) ? " " : "", Me("group")];
                case "value-paren":
                  return ae.value;
                case "value-number":
                  return [Je(ae.value), G(ae.unit)];
                case "value-operator":
                  return ae.value;
                case "value-word":
                  return ae.isColor && ae.isHex || b(ae.value) ? ae.value.toLowerCase() : ae.value;
                case "value-colon": {
                  let Ve = Te.getParentNode(), We = Ve && Ve.groups.indexOf(ae), Xe = We && Ve.groups[We - 1];
                  return [ae.value, Xe && typeof Xe.value == "string" && t3(Xe.value) === "\\" || C(Te, "url") ? "" : y];
                }
                case "value-comma":
                  return [ae.value, " "];
                case "value-string":
                  return a(ae.raws.quote + ae.value + ae.raws.quote, je);
                case "value-atword":
                  return ["@", ae.value];
                case "value-unicode-range":
                  return ae.value;
                case "value-unknown":
                  return ae.value;
                default:
                  throw new Error(`Unknown postcss type ${JSON.stringify(ae.type)}`);
              }
            }
            function Ce(Te, je, Me) {
              let ae = [];
              return Te.each((nt, tt, Ve) => {
                let We = Ve[tt - 1];
                if (We && We.type === "css-comment" && We.text.trim() === "prettier-ignore") {
                  let Xe = nt.getValue();
                  ae.push(je.originalText.slice(Ae(Xe), Ee(Xe)));
                } else
                  ae.push(Me());
                tt !== Ve.length - 1 && (Ve[tt + 1].type === "css-comment" && !n(je.originalText, Ae(Ve[tt + 1]), { backwards: true }) && !u(Ve[tt]) || Ve[tt + 1].type === "css-atrule" && Ve[tt + 1].name === "else" && Ve[tt].type !== "css-comment" ? ae.push(" ") : (ae.push(je.__isHTMLStyleAttribute ? y : h), i(je.originalText, nt.getValue(), Ee) && !u(Ve[tt]) && ae.push(h)));
              }, "nodes"), ae;
            }
            var Be = /(["'])(?:(?!\1)[^\\]|\\.)*\1/gs, ve = /(?:\d*\.\d+|\d+\.?)(?:[Ee][+-]?\d+)?/g, ze = /[A-Za-z]+/g, be = /[$@]?[A-Z_a-z\u0080-\uFFFF][\w\u0080-\uFFFF-]*/g, Ye = new RegExp(Be.source + `|(${be.source})?(${ve.source})(${ze.source})?`, "g");
            function Se(Te, je) {
              return Te.replace(Be, (Me) => a(Me, je));
            }
            function Ie(Te, je) {
              let Me = je.singleQuote ? "'" : '"';
              return Te.includes('"') || Te.includes("'") ? Te : Me + Te + Me;
            }
            function Oe(Te) {
              return Te.replace(Ye, (je, Me, ae, nt, tt) => !ae && nt ? Je(nt) + m(tt || "") : je);
            }
            function Je(Te) {
              return s(Te).replace(/\.0(?=$|e)/, "");
            }
            r.exports = { print: ye, embed: P, insertPragma: $, massageAstNode: I };
          } }), Rd = te({ "src/language-css/options.js"(e, r) {
            "use strict";
            ne();
            var t3 = Mt();
            r.exports = { singleQuote: t3.singleQuote };
          } }), $d = te({ "src/language-css/parsers.js"() {
            ne();
          } }), Vd = te({ "node_modules/linguist-languages/data/CSS.json"(e, r) {
            r.exports = { name: "CSS", type: "markup", tmScope: "source.css", aceMode: "css", codemirrorMode: "css", codemirrorMimeType: "text/css", color: "#563d7c", extensions: [".css"], languageId: 50 };
          } }), Wd = te({ "node_modules/linguist-languages/data/PostCSS.json"(e, r) {
            r.exports = { name: "PostCSS", type: "markup", color: "#dc3a0c", tmScope: "source.postcss", group: "CSS", extensions: [".pcss", ".postcss"], aceMode: "text", languageId: 262764437 };
          } }), Hd = te({ "node_modules/linguist-languages/data/Less.json"(e, r) {
            r.exports = { name: "Less", type: "markup", color: "#1d365d", aliases: ["less-css"], extensions: [".less"], tmScope: "source.css.less", aceMode: "less", codemirrorMode: "css", codemirrorMimeType: "text/css", languageId: 198 };
          } }), Gd = te({ "node_modules/linguist-languages/data/SCSS.json"(e, r) {
            r.exports = { name: "SCSS", type: "markup", color: "#c6538c", tmScope: "source.css.scss", aceMode: "scss", codemirrorMode: "css", codemirrorMimeType: "text/x-scss", extensions: [".scss"], languageId: 329 };
          } }), Ud = te({ "src/language-css/index.js"(e, r) {
            "use strict";
            ne();
            var t3 = _t(), s = Md(), a = Rd(), n = $d(), u = [t3(Vd(), (l) => ({ since: "1.4.0", parsers: ["css"], vscodeLanguageIds: ["css"], extensions: [...l.extensions, ".wxss"] })), t3(Wd(), () => ({ since: "1.4.0", parsers: ["css"], vscodeLanguageIds: ["postcss"] })), t3(Hd(), () => ({ since: "1.4.0", parsers: ["less"], vscodeLanguageIds: ["less"] })), t3(Gd(), () => ({ since: "1.4.0", parsers: ["scss"], vscodeLanguageIds: ["scss"] }))], i = { postcss: s };
            r.exports = { languages: u, options: a, printers: i, parsers: n };
          } }), Jd = te({ "src/language-handlebars/loc.js"(e, r) {
            "use strict";
            ne();
            function t3(a) {
              return a.loc.start.offset;
            }
            function s(a) {
              return a.loc.end.offset;
            }
            r.exports = { locStart: t3, locEnd: s };
          } }), zd = te({ "src/language-handlebars/clean.js"(e, r) {
            "use strict";
            ne();
            function t3(s, a) {
              if (s.type === "TextNode") {
                let n = s.chars.trim();
                if (!n)
                  return null;
                a.chars = n.replace(/[\t\n\f\r ]+/g, " ");
              }
              s.type === "AttrNode" && s.name.toLowerCase() === "class" && delete a.value;
            }
            t3.ignoredProperties = /* @__PURE__ */ new Set(["loc", "selfClosing"]), r.exports = t3;
          } }), Xd = te({ "src/language-handlebars/html-void-elements.evaluate.js"(e, r) {
            r.exports = ["area", "base", "br", "col", "command", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"];
          } }), Kd = te({ "src/language-handlebars/utils.js"(e, r) {
            "use strict";
            ne();
            var t3 = lt2(), s = Xd();
            function a(x) {
              let I = x.getValue(), P = x.getParentNode(0);
              return !!(g(x, ["ElementNode"]) && t3(P.children) === I || g(x, ["Block"]) && t3(P.body) === I);
            }
            function n(x) {
              return x.toUpperCase() === x;
            }
            function u(x) {
              return h(x, ["ElementNode"]) && typeof x.tag == "string" && !x.tag.startsWith(":") && (n(x.tag[0]) || x.tag.includes("."));
            }
            var i = new Set(s);
            function l(x) {
              return i.has(x.toLowerCase()) && !n(x[0]);
            }
            function p(x) {
              return x.selfClosing === true || l(x.tag) || u(x) && x.children.every((I) => y(I));
            }
            function y(x) {
              return h(x, ["TextNode"]) && !/\S/.test(x.chars);
            }
            function h(x, I) {
              return x && I.includes(x.type);
            }
            function g(x, I) {
              let P = x.getParentNode(0);
              return h(P, I);
            }
            function c(x, I) {
              let P = _(x);
              return h(P, I);
            }
            function f(x, I) {
              let P = w(x);
              return h(P, I);
            }
            function F(x, I) {
              var P, $, D, T;
              let m = x.getValue(), C = (P = x.getParentNode(0)) !== null && P !== void 0 ? P : {}, o = ($ = (D = (T = C.children) !== null && T !== void 0 ? T : C.body) !== null && D !== void 0 ? D : C.parts) !== null && $ !== void 0 ? $ : [], d = o.indexOf(m);
              return d !== -1 && o[d + I];
            }
            function _(x) {
              let I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
              return F(x, -I);
            }
            function w(x) {
              return F(x, 1);
            }
            function E(x) {
              return h(x, ["MustacheCommentStatement"]) && typeof x.value == "string" && x.value.trim() === "prettier-ignore";
            }
            function N(x) {
              let I = x.getValue(), P = _(x, 2);
              return E(I) || E(P);
            }
            r.exports = { getNextNode: w, getPreviousNode: _, hasPrettierIgnore: N, isLastNodeOfSiblings: a, isNextNodeOfSomeType: f, isNodeOfSomeType: h, isParentOfSomeType: g, isPreviousNodeOfSomeType: c, isVoid: p, isWhitespaceNode: y };
          } }), Yd = te({ "src/language-handlebars/printer-glimmer.js"(e, r) {
            "use strict";
            ne();
            var { builders: { dedent: t3, fill: s, group: a, hardline: n, ifBreak: u, indent: i, join: l, line: p, softline: y }, utils: { getDocParts: h, replaceTextEndOfLine: g } } = qe(), { getPreferredQuote: c, isNonEmptyArray: f } = Ue(), { locStart: F, locEnd: _ } = Jd(), w = zd(), { getNextNode: E, getPreviousNode: N, hasPrettierIgnore: x, isLastNodeOfSiblings: I, isNextNodeOfSomeType: P, isNodeOfSomeType: $, isParentOfSomeType: D, isPreviousNodeOfSomeType: T, isVoid: m, isWhitespaceNode: C } = Kd(), o = 2;
            function d(H, pe, X) {
              let le = H.getValue();
              if (!le)
                return "";
              if (x(H))
                return pe.originalText.slice(F(le), _(le));
              let Ae = pe.singleQuote ? "'" : '"';
              switch (le.type) {
                case "Block":
                case "Program":
                case "Template":
                  return a(H.map(X, "body"));
                case "ElementNode": {
                  let Ee = a(S(H, X)), De = pe.htmlWhitespaceSensitivity === "ignore" && P(H, ["ElementNode"]) ? y : "";
                  if (m(le))
                    return [Ee, De];
                  let A = ["</", le.tag, ">"];
                  return le.children.length === 0 ? [Ee, i(A), De] : pe.htmlWhitespaceSensitivity === "ignore" ? [Ee, i(b(H, pe, X)), n, i(A), De] : [Ee, i(a(b(H, pe, X))), i(A), De];
                }
                case "BlockStatement": {
                  let Ee = H.getParentNode(1);
                  return Ee && Ee.inverse && Ee.inverse.body.length === 1 && Ee.inverse.body[0] === le && Ee.inverse.body[0].path.parts[0] === Ee.path.parts[0] ? [ie(H, X, Ee.inverse.body[0].path.parts[0]), de(H, X, pe), ue(H, X, pe)] : [j(H, X), a([de(H, X, pe), ue(H, X, pe), ee(H, X, pe)])];
                }
                case "ElementModifierStatement":
                  return a(["{{", Re(H, X), "}}"]);
                case "MustacheStatement":
                  return a([k(le), Re(H, X), M(le)]);
                case "SubExpression":
                  return a(["(", ke(H, X), y, ")"]);
                case "AttrNode": {
                  let Ee = le.value.type === "TextNode";
                  if (Ee && le.value.chars === "" && F(le.value) === _(le.value))
                    return le.name;
                  let A = Ee ? c(le.value.chars, Ae).quote : le.value.type === "ConcatStatement" ? c(le.value.parts.filter((re) => re.type === "TextNode").map((re) => re.chars).join(""), Ae).quote : "", G = X("value");
                  return [le.name, "=", A, le.name === "class" && A ? a(i(G)) : G, A];
                }
                case "ConcatStatement":
                  return H.map(X, "parts");
                case "Hash":
                  return l(p, H.map(X, "pairs"));
                case "HashPair":
                  return [le.key, "=", X("value")];
                case "TextNode": {
                  let Ee = le.chars.replace(/{{/g, "\\{{"), De = U(H);
                  if (De) {
                    if (De === "class") {
                      let Ye = Ee.trim().split(/\s+/).join(" "), Se = false, Ie = false;
                      return D(H, ["ConcatStatement"]) && (T(H, ["MustacheStatement"]) && /^\s/.test(Ee) && (Se = true), P(H, ["MustacheStatement"]) && /\s$/.test(Ee) && Ye !== "" && (Ie = true)), [Se ? p : "", Ye, Ie ? p : ""];
                    }
                    return g(Ee);
                  }
                  let G = /^[\t\n\f\r ]*$/.test(Ee), re = !N(H), ye = !E(H);
                  if (pe.htmlWhitespaceSensitivity !== "ignore") {
                    let Ye = /^[\t\n\f\r ]*/, Se = /[\t\n\f\r ]*$/, Ie = ye && D(H, ["Template"]), Oe = re && D(H, ["Template"]);
                    if (G) {
                      if (Oe || Ie)
                        return "";
                      let ae = [p], nt = Z(Ee);
                      return nt && (ae = ge(nt)), I(H) && (ae = ae.map((tt) => t3(tt))), ae;
                    }
                    let [Je] = Ee.match(Ye), [Te] = Ee.match(Se), je = [];
                    if (Je) {
                      je = [p];
                      let ae = Z(Je);
                      ae && (je = ge(ae)), Ee = Ee.replace(Ye, "");
                    }
                    let Me = [];
                    if (Te) {
                      if (!Ie) {
                        Me = [p];
                        let ae = Z(Te);
                        ae && (Me = ge(ae)), I(H) && (Me = Me.map((nt) => t3(nt)));
                      }
                      Ee = Ee.replace(Se, "");
                    }
                    return [...je, s(Fe(Ee)), ...Me];
                  }
                  let Ce = Z(Ee), Be = se(Ee), ve = fe(Ee);
                  if ((re || ye) && G && D(H, ["Block", "ElementNode", "Template"]))
                    return "";
                  G && Ce ? (Be = Math.min(Ce, o), ve = 0) : (P(H, ["BlockStatement", "ElementNode"]) && (ve = Math.max(ve, 1)), T(H, ["BlockStatement", "ElementNode"]) && (Be = Math.max(Be, 1)));
                  let ze = "", be = "";
                  return ve === 0 && P(H, ["MustacheStatement"]) && (be = " "), Be === 0 && T(H, ["MustacheStatement"]) && (ze = " "), re && (Be = 0, ze = ""), ye && (ve = 0, be = ""), Ee = Ee.replace(/^[\t\n\f\r ]+/g, ze).replace(/[\t\n\f\r ]+$/, be), [...ge(Be), s(Fe(Ee)), ...ge(ve)];
                }
                case "MustacheCommentStatement": {
                  let Ee = F(le), De = _(le), A = pe.originalText.charAt(Ee + 2) === "~", G = pe.originalText.charAt(De - 3) === "~", re = le.value.includes("}}") ? "--" : "";
                  return ["{{", A ? "~" : "", "!", re, le.value, re, G ? "~" : "", "}}"];
                }
                case "PathExpression":
                  return le.original;
                case "BooleanLiteral":
                  return String(le.value);
                case "CommentStatement":
                  return ["<!--", le.value, "-->"];
                case "StringLiteral": {
                  if (we(H)) {
                    let Ee = pe.singleQuote ? '"' : "'";
                    return he(le.value, Ee);
                  }
                  return he(le.value, Ae);
                }
                case "NumberLiteral":
                  return String(le.value);
                case "UndefinedLiteral":
                  return "undefined";
                case "NullLiteral":
                  return "null";
                default:
                  throw new Error("unknown glimmer type: " + JSON.stringify(le.type));
              }
            }
            function v(H, pe) {
              return F(H) - F(pe);
            }
            function S(H, pe) {
              let X = H.getValue(), le = ["attributes", "modifiers", "comments"].filter((Ee) => f(X[Ee])), Ae = le.flatMap((Ee) => X[Ee]).sort(v);
              for (let Ee of le)
                H.each((De) => {
                  let A = Ae.indexOf(De.getValue());
                  Ae.splice(A, 1, [p, pe()]);
                }, Ee);
              return f(X.blockParams) && Ae.push(p, oe(X)), ["<", X.tag, i(Ae), B(X)];
            }
            function b(H, pe, X) {
              let Ae = H.getValue().children.every((Ee) => C(Ee));
              return pe.htmlWhitespaceSensitivity === "ignore" && Ae ? "" : H.map((Ee, De) => {
                let A = X();
                return De === 0 && pe.htmlWhitespaceSensitivity === "ignore" ? [y, A] : A;
              }, "children");
            }
            function B(H) {
              return m(H) ? u([y, "/>"], [" />", y]) : u([y, ">"], ">");
            }
            function k(H) {
              let pe = H.escaped === false ? "{{{" : "{{", X = H.strip && H.strip.open ? "~" : "";
              return [pe, X];
            }
            function M(H) {
              let pe = H.escaped === false ? "}}}" : "}}";
              return [H.strip && H.strip.close ? "~" : "", pe];
            }
            function R(H) {
              let pe = k(H), X = H.openStrip.open ? "~" : "";
              return [pe, X, "#"];
            }
            function q(H) {
              let pe = M(H);
              return [H.openStrip.close ? "~" : "", pe];
            }
            function J(H) {
              let pe = k(H), X = H.closeStrip.open ? "~" : "";
              return [pe, X, "/"];
            }
            function L(H) {
              let pe = M(H);
              return [H.closeStrip.close ? "~" : "", pe];
            }
            function Q(H) {
              let pe = k(H), X = H.inverseStrip.open ? "~" : "";
              return [pe, X];
            }
            function V(H) {
              let pe = M(H);
              return [H.inverseStrip.close ? "~" : "", pe];
            }
            function j(H, pe) {
              let X = H.getValue(), le = [], Ae = Pe(H, pe);
              return Ae && le.push(a(Ae)), f(X.program.blockParams) && le.push(oe(X.program)), a([R(X), Ne(H, pe), le.length > 0 ? i([p, l(p, le)]) : "", y, q(X)]);
            }
            function Y(H, pe) {
              return [pe.htmlWhitespaceSensitivity === "ignore" ? n : "", Q(H), "else", V(H)];
            }
            function ie(H, pe, X) {
              let le = H.getValue(), Ae = H.getParentNode(1);
              return a([Q(Ae), ["else", " ", X], i([p, a(Pe(H, pe)), ...f(le.program.blockParams) ? [p, oe(le.program)] : []]), y, V(Ae)]);
            }
            function ee(H, pe, X) {
              let le = H.getValue();
              return X.htmlWhitespaceSensitivity === "ignore" ? [ce(le) ? y : n, J(le), pe("path"), L(le)] : [J(le), pe("path"), L(le)];
            }
            function ce(H) {
              return $(H, ["BlockStatement"]) && H.program.body.every((pe) => C(pe));
            }
            function W(H) {
              return K(H) && H.inverse.body.length === 1 && $(H.inverse.body[0], ["BlockStatement"]) && H.inverse.body[0].path.parts[0] === H.path.parts[0];
            }
            function K(H) {
              return $(H, ["BlockStatement"]) && H.inverse;
            }
            function de(H, pe, X) {
              let le = H.getValue();
              if (ce(le))
                return "";
              let Ae = pe("program");
              return X.htmlWhitespaceSensitivity === "ignore" ? i([n, Ae]) : i(Ae);
            }
            function ue(H, pe, X) {
              let le = H.getValue(), Ae = pe("inverse"), Ee = X.htmlWhitespaceSensitivity === "ignore" ? [n, Ae] : Ae;
              return W(le) ? Ee : K(le) ? [Y(le, X), i(Ee)] : "";
            }
            function Fe(H) {
              return h(l(p, z(H)));
            }
            function z(H) {
              return H.split(/[\t\n\f\r ]+/);
            }
            function U(H) {
              for (let pe = 0; pe < 2; pe++) {
                let X = H.getParentNode(pe);
                if (X && X.type === "AttrNode")
                  return X.name.toLowerCase();
              }
            }
            function Z(H) {
              return H = typeof H == "string" ? H : "", H.split(`
`).length - 1;
            }
            function se(H) {
              H = typeof H == "string" ? H : "";
              let pe = (H.match(/^([^\S\n\r]*[\n\r])+/g) || [])[0] || "";
              return Z(pe);
            }
            function fe(H) {
              H = typeof H == "string" ? H : "";
              let pe = (H.match(/([\n\r][^\S\n\r]*)+$/g) || [])[0] || "";
              return Z(pe);
            }
            function ge() {
              let H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
              return Array.from({ length: Math.min(H, o) }).fill(n);
            }
            function he(H, pe) {
              let { quote: X, regex: le } = c(H, pe);
              return [X, H.replace(le, `\\${X}`), X];
            }
            function we(H) {
              let pe = 0, X = H.getParentNode(pe);
              for (; X && $(X, ["SubExpression"]); )
                pe++, X = H.getParentNode(pe);
              return !!(X && $(H.getParentNode(pe + 1), ["ConcatStatement"]) && $(H.getParentNode(pe + 2), ["AttrNode"]));
            }
            function ke(H, pe) {
              let X = Ne(H, pe), le = Pe(H, pe);
              return le ? i([X, p, a(le)]) : X;
            }
            function Re(H, pe) {
              let X = Ne(H, pe), le = Pe(H, pe);
              return le ? [i([X, p, le]), y] : X;
            }
            function Ne(H, pe) {
              return pe("path");
            }
            function Pe(H, pe) {
              let X = H.getValue(), le = [];
              if (X.params.length > 0) {
                let Ae = H.map(pe, "params");
                le.push(...Ae);
              }
              if (X.hash && X.hash.pairs.length > 0) {
                let Ae = pe("hash");
                le.push(Ae);
              }
              return le.length === 0 ? "" : l(p, le);
            }
            function oe(H) {
              return ["as |", H.blockParams.join(" "), "|"];
            }
            r.exports = { print: d, massageAstNode: w };
          } }), Qd = te({ "src/language-handlebars/parsers.js"() {
            ne();
          } }), Zd = te({ "node_modules/linguist-languages/data/Handlebars.json"(e, r) {
            r.exports = { name: "Handlebars", type: "markup", color: "#f7931e", aliases: ["hbs", "htmlbars"], extensions: [".handlebars", ".hbs"], tmScope: "text.html.handlebars", aceMode: "handlebars", languageId: 155 };
          } }), eg = te({ "src/language-handlebars/index.js"(e, r) {
            "use strict";
            ne();
            var t3 = _t(), s = Yd(), a = Qd(), n = [t3(Zd(), () => ({ since: "2.3.0", parsers: ["glimmer"], vscodeLanguageIds: ["handlebars"] }))], u = { glimmer: s };
            r.exports = { languages: n, printers: u, parsers: a };
          } }), tg = te({ "src/language-graphql/pragma.js"(e, r) {
            "use strict";
            ne();
            function t3(a) {
              return /^\s*#[^\S\n]*@(?:format|prettier)\s*(?:\n|$)/.test(a);
            }
            function s(a) {
              return `# @format

` + a;
            }
            r.exports = { hasPragma: t3, insertPragma: s };
          } }), rg = te({ "src/language-graphql/loc.js"(e, r) {
            "use strict";
            ne();
            function t3(a) {
              return typeof a.start == "number" ? a.start : a.loc && a.loc.start;
            }
            function s(a) {
              return typeof a.end == "number" ? a.end : a.loc && a.loc.end;
            }
            r.exports = { locStart: t3, locEnd: s };
          } }), ng = te({ "src/language-graphql/printer-graphql.js"(e, r) {
            "use strict";
            ne();
            var { builders: { join: t3, hardline: s, line: a, softline: n, group: u, indent: i, ifBreak: l } } = qe(), { isNextLineEmpty: p, isNonEmptyArray: y } = Ue(), { insertPragma: h } = tg(), { locStart: g, locEnd: c } = rg();
            function f(P, $, D) {
              let T = P.getValue();
              if (!T)
                return "";
              if (typeof T == "string")
                return T;
              switch (T.kind) {
                case "Document": {
                  let m = [];
                  return P.each((C, o, d) => {
                    m.push(D()), o !== d.length - 1 && (m.push(s), p($.originalText, C.getValue(), c) && m.push(s));
                  }, "definitions"), [...m, s];
                }
                case "OperationDefinition": {
                  let m = $.originalText[g(T)] !== "{", C = Boolean(T.name);
                  return [m ? T.operation : "", m && C ? [" ", D("name")] : "", m && !C && y(T.variableDefinitions) ? " " : "", y(T.variableDefinitions) ? u(["(", i([n, t3([l("", ", "), n], P.map(D, "variableDefinitions"))]), n, ")"]) : "", F(P, D, T), T.selectionSet ? !m && !C ? "" : " " : "", D("selectionSet")];
                }
                case "FragmentDefinition":
                  return ["fragment ", D("name"), y(T.variableDefinitions) ? u(["(", i([n, t3([l("", ", "), n], P.map(D, "variableDefinitions"))]), n, ")"]) : "", " on ", D("typeCondition"), F(P, D, T), " ", D("selectionSet")];
                case "SelectionSet":
                  return ["{", i([s, t3(s, _(P, $, D, "selections"))]), s, "}"];
                case "Field":
                  return u([T.alias ? [D("alias"), ": "] : "", D("name"), T.arguments.length > 0 ? u(["(", i([n, t3([l("", ", "), n], _(P, $, D, "arguments"))]), n, ")"]) : "", F(P, D, T), T.selectionSet ? " " : "", D("selectionSet")]);
                case "Name":
                  return T.value;
                case "StringValue": {
                  if (T.block) {
                    let m = T.value.replace(/"""/g, "\\$&").split(`
`);
                    return m.length === 1 && (m[0] = m[0].trim()), m.every((C) => C === "") && (m.length = 0), t3(s, ['"""', ...m, '"""']);
                  }
                  return ['"', T.value.replace(/["\\]/g, "\\$&").replace(/\n/g, "\\n"), '"'];
                }
                case "IntValue":
                case "FloatValue":
                case "EnumValue":
                  return T.value;
                case "BooleanValue":
                  return T.value ? "true" : "false";
                case "NullValue":
                  return "null";
                case "Variable":
                  return ["$", D("name")];
                case "ListValue":
                  return u(["[", i([n, t3([l("", ", "), n], P.map(D, "values"))]), n, "]"]);
                case "ObjectValue":
                  return u(["{", $.bracketSpacing && T.fields.length > 0 ? " " : "", i([n, t3([l("", ", "), n], P.map(D, "fields"))]), n, l("", $.bracketSpacing && T.fields.length > 0 ? " " : ""), "}"]);
                case "ObjectField":
                case "Argument":
                  return [D("name"), ": ", D("value")];
                case "Directive":
                  return ["@", D("name"), T.arguments.length > 0 ? u(["(", i([n, t3([l("", ", "), n], _(P, $, D, "arguments"))]), n, ")"]) : ""];
                case "NamedType":
                  return D("name");
                case "VariableDefinition":
                  return [D("variable"), ": ", D("type"), T.defaultValue ? [" = ", D("defaultValue")] : "", F(P, D, T)];
                case "ObjectTypeExtension":
                case "ObjectTypeDefinition":
                  return [D("description"), T.description ? s : "", T.kind === "ObjectTypeExtension" ? "extend " : "", "type ", D("name"), T.interfaces.length > 0 ? [" implements ", ...N(P, $, D)] : "", F(P, D, T), T.fields.length > 0 ? [" {", i([s, t3(s, _(P, $, D, "fields"))]), s, "}"] : ""];
                case "FieldDefinition":
                  return [D("description"), T.description ? s : "", D("name"), T.arguments.length > 0 ? u(["(", i([n, t3([l("", ", "), n], _(P, $, D, "arguments"))]), n, ")"]) : "", ": ", D("type"), F(P, D, T)];
                case "DirectiveDefinition":
                  return [D("description"), T.description ? s : "", "directive ", "@", D("name"), T.arguments.length > 0 ? u(["(", i([n, t3([l("", ", "), n], _(P, $, D, "arguments"))]), n, ")"]) : "", T.repeatable ? " repeatable" : "", " on ", t3(" | ", P.map(D, "locations"))];
                case "EnumTypeExtension":
                case "EnumTypeDefinition":
                  return [D("description"), T.description ? s : "", T.kind === "EnumTypeExtension" ? "extend " : "", "enum ", D("name"), F(P, D, T), T.values.length > 0 ? [" {", i([s, t3(s, _(P, $, D, "values"))]), s, "}"] : ""];
                case "EnumValueDefinition":
                  return [D("description"), T.description ? s : "", D("name"), F(P, D, T)];
                case "InputValueDefinition":
                  return [D("description"), T.description ? T.description.block ? s : a : "", D("name"), ": ", D("type"), T.defaultValue ? [" = ", D("defaultValue")] : "", F(P, D, T)];
                case "InputObjectTypeExtension":
                case "InputObjectTypeDefinition":
                  return [D("description"), T.description ? s : "", T.kind === "InputObjectTypeExtension" ? "extend " : "", "input ", D("name"), F(P, D, T), T.fields.length > 0 ? [" {", i([s, t3(s, _(P, $, D, "fields"))]), s, "}"] : ""];
                case "SchemaExtension":
                  return ["extend schema", F(P, D, T), ...T.operationTypes.length > 0 ? [" {", i([s, t3(s, _(P, $, D, "operationTypes"))]), s, "}"] : []];
                case "SchemaDefinition":
                  return [D("description"), T.description ? s : "", "schema", F(P, D, T), " {", T.operationTypes.length > 0 ? i([s, t3(s, _(P, $, D, "operationTypes"))]) : "", s, "}"];
                case "OperationTypeDefinition":
                  return [D("operation"), ": ", D("type")];
                case "InterfaceTypeExtension":
                case "InterfaceTypeDefinition":
                  return [D("description"), T.description ? s : "", T.kind === "InterfaceTypeExtension" ? "extend " : "", "interface ", D("name"), T.interfaces.length > 0 ? [" implements ", ...N(P, $, D)] : "", F(P, D, T), T.fields.length > 0 ? [" {", i([s, t3(s, _(P, $, D, "fields"))]), s, "}"] : ""];
                case "FragmentSpread":
                  return ["...", D("name"), F(P, D, T)];
                case "InlineFragment":
                  return ["...", T.typeCondition ? [" on ", D("typeCondition")] : "", F(P, D, T), " ", D("selectionSet")];
                case "UnionTypeExtension":
                case "UnionTypeDefinition":
                  return u([D("description"), T.description ? s : "", u([T.kind === "UnionTypeExtension" ? "extend " : "", "union ", D("name"), F(P, D, T), T.types.length > 0 ? [" =", l("", " "), i([l([a, "  "]), t3([a, "| "], P.map(D, "types"))])] : ""])]);
                case "ScalarTypeExtension":
                case "ScalarTypeDefinition":
                  return [D("description"), T.description ? s : "", T.kind === "ScalarTypeExtension" ? "extend " : "", "scalar ", D("name"), F(P, D, T)];
                case "NonNullType":
                  return [D("type"), "!"];
                case "ListType":
                  return ["[", D("type"), "]"];
                default:
                  throw new Error("unknown graphql type: " + JSON.stringify(T.kind));
              }
            }
            function F(P, $, D) {
              if (D.directives.length === 0)
                return "";
              let T = t3(a, P.map($, "directives"));
              return D.kind === "FragmentDefinition" || D.kind === "OperationDefinition" ? u([a, T]) : [" ", u(i([n, T]))];
            }
            function _(P, $, D, T) {
              return P.map((m, C, o) => {
                let d = D();
                return C < o.length - 1 && p($.originalText, m.getValue(), c) ? [d, s] : d;
              }, T);
            }
            function w(P) {
              return P.kind && P.kind !== "Comment";
            }
            function E(P) {
              let $ = P.getValue();
              if ($.kind === "Comment")
                return "#" + $.value.trimEnd();
              throw new Error("Not a comment: " + JSON.stringify($));
            }
            function N(P, $, D) {
              let T = P.getNode(), m = [], { interfaces: C } = T, o = P.map((d) => D(d), "interfaces");
              for (let d = 0; d < C.length; d++) {
                let v = C[d];
                m.push(o[d]);
                let S = C[d + 1];
                if (S) {
                  let b = $.originalText.slice(v.loc.end, S.loc.start), B = b.includes("#"), k = b.replace(/#.*/g, "").trim();
                  m.push(k === "," ? "," : " &", B ? a : " ");
                }
              }
              return m;
            }
            function x(P, $) {
              P.kind === "StringValue" && P.block && !P.value.includes(`
`) && ($.value = $.value.trim());
            }
            x.ignoredProperties = /* @__PURE__ */ new Set(["loc", "comments"]);
            function I(P) {
              var $;
              let D = P.getValue();
              return D == null || ($ = D.comments) === null || $ === void 0 ? void 0 : $.some((T) => T.value.trim() === "prettier-ignore");
            }
            r.exports = { print: f, massageAstNode: x, hasPrettierIgnore: I, insertPragma: h, printComment: E, canAttachComment: w };
          } }), ug = te({ "src/language-graphql/options.js"(e, r) {
            "use strict";
            ne();
            var t3 = Mt();
            r.exports = { bracketSpacing: t3.bracketSpacing };
          } }), sg = te({ "src/language-graphql/parsers.js"() {
            ne();
          } }), ig = te({ "node_modules/linguist-languages/data/GraphQL.json"(e, r) {
            r.exports = { name: "GraphQL", type: "data", color: "#e10098", extensions: [".graphql", ".gql", ".graphqls"], tmScope: "source.graphql", aceMode: "text", languageId: 139 };
          } }), ag = te({ "src/language-graphql/index.js"(e, r) {
            "use strict";
            ne();
            var t3 = _t(), s = ng(), a = ug(), n = sg(), u = [t3(ig(), () => ({ since: "1.5.0", parsers: ["graphql"], vscodeLanguageIds: ["graphql"] }))], i = { graphql: s };
            r.exports = { languages: u, options: a, printers: i, parsers: n };
          } }), Po = te({ "node_modules/collapse-white-space/index.js"(e, r) {
            "use strict";
            ne(), r.exports = t3;
            function t3(s) {
              return String(s).replace(/\s+/g, " ");
            }
          } }), Io = te({ "src/language-markdown/loc.js"(e, r) {
            "use strict";
            ne();
            function t3(a) {
              return a.position.start.offset;
            }
            function s(a) {
              return a.position.end.offset;
            }
            r.exports = { locStart: t3, locEnd: s };
          } }), og = te({ "src/language-markdown/constants.evaluate.js"(e, r) {
            r.exports = { cjkPattern: "(?:[\\u02ea-\\u02eb\\u1100-\\u11ff\\u2e80-\\u2e99\\u2e9b-\\u2ef3\\u2f00-\\u2fd5\\u2ff0-\\u303f\\u3041-\\u3096\\u3099-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312f\\u3131-\\u318e\\u3190-\\u3191\\u3196-\\u31ba\\u31c0-\\u31e3\\u31f0-\\u321e\\u322a-\\u3247\\u3260-\\u327e\\u328a-\\u32b0\\u32c0-\\u32cb\\u32d0-\\u3370\\u337b-\\u337f\\u33e0-\\u33fe\\u3400-\\u4db5\\u4e00-\\u9fef\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufe10-\\ufe1f\\ufe30-\\ufe6f\\uff00-\\uffef]|[\\ud840-\\ud868\\ud86a-\\ud86c\\ud86f-\\ud872\\ud874-\\ud879][\\udc00-\\udfff]|\\ud82c[\\udc00-\\udd1e\\udd50-\\udd52\\udd64-\\udd67]|\\ud83c[\\ude00\\ude50-\\ude51]|\\ud869[\\udc00-\\uded6\\udf00-\\udfff]|\\ud86d[\\udc00-\\udf34\\udf40-\\udfff]|\\ud86e[\\udc00-\\udc1d\\udc20-\\udfff]|\\ud873[\\udc00-\\udea1\\udeb0-\\udfff]|\\ud87a[\\udc00-\\udfe0]|\\ud87e[\\udc00-\\ude1d])(?:[\\ufe00-\\ufe0f]|\\udb40[\\udd00-\\uddef])?", kPattern: "[\\u1100-\\u11ff\\u3001-\\u3003\\u3008-\\u3011\\u3013-\\u301f\\u302e-\\u3030\\u3037\\u30fb\\u3131-\\u318e\\u3200-\\u321e\\u3260-\\u327e\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\ufe45-\\ufe46\\uff61-\\uff65\\uffa0-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc]", punctuationPattern: "[\\u0021-\\u002f\\u003a-\\u0040\\u005b-\\u0060\\u007b-\\u007e\\u00a1\\u00a7\\u00ab\\u00b6-\\u00b7\\u00bb\\u00bf\\u037e\\u0387\\u055a-\\u055f\\u0589-\\u058a\\u05be\\u05c0\\u05c3\\u05c6\\u05f3-\\u05f4\\u0609-\\u060a\\u060c-\\u060d\\u061b\\u061e-\\u061f\\u066a-\\u066d\\u06d4\\u0700-\\u070d\\u07f7-\\u07f9\\u0830-\\u083e\\u085e\\u0964-\\u0965\\u0970\\u09fd\\u0a76\\u0af0\\u0c77\\u0c84\\u0df4\\u0e4f\\u0e5a-\\u0e5b\\u0f04-\\u0f12\\u0f14\\u0f3a-\\u0f3d\\u0f85\\u0fd0-\\u0fd4\\u0fd9-\\u0fda\\u104a-\\u104f\\u10fb\\u1360-\\u1368\\u1400\\u166e\\u169b-\\u169c\\u16eb-\\u16ed\\u1735-\\u1736\\u17d4-\\u17d6\\u17d8-\\u17da\\u1800-\\u180a\\u1944-\\u1945\\u1a1e-\\u1a1f\\u1aa0-\\u1aa6\\u1aa8-\\u1aad\\u1b5a-\\u1b60\\u1bfc-\\u1bff\\u1c3b-\\u1c3f\\u1c7e-\\u1c7f\\u1cc0-\\u1cc7\\u1cd3\\u2010-\\u2027\\u2030-\\u2043\\u2045-\\u2051\\u2053-\\u205e\\u207d-\\u207e\\u208d-\\u208e\\u2308-\\u230b\\u2329-\\u232a\\u2768-\\u2775\\u27c5-\\u27c6\\u27e6-\\u27ef\\u2983-\\u2998\\u29d8-\\u29db\\u29fc-\\u29fd\\u2cf9-\\u2cfc\\u2cfe-\\u2cff\\u2d70\\u2e00-\\u2e2e\\u2e30-\\u2e4f\\u3001-\\u3003\\u3008-\\u3011\\u3014-\\u301f\\u3030\\u303d\\u30a0\\u30fb\\ua4fe-\\ua4ff\\ua60d-\\ua60f\\ua673\\ua67e\\ua6f2-\\ua6f7\\ua874-\\ua877\\ua8ce-\\ua8cf\\ua8f8-\\ua8fa\\ua8fc\\ua92e-\\ua92f\\ua95f\\ua9c1-\\ua9cd\\ua9de-\\ua9df\\uaa5c-\\uaa5f\\uaade-\\uaadf\\uaaf0-\\uaaf1\\uabeb\\ufd3e-\\ufd3f\\ufe10-\\ufe19\\ufe30-\\ufe52\\ufe54-\\ufe61\\ufe63\\ufe68\\ufe6a-\\ufe6b\\uff01-\\uff03\\uff05-\\uff0a\\uff0c-\\uff0f\\uff1a-\\uff1b\\uff1f-\\uff20\\uff3b-\\uff3d\\uff3f\\uff5b\\uff5d\\uff5f-\\uff65]|\\ud800[\\udd00-\\udd02\\udf9f\\udfd0]|\\ud801[\\udd6f]|\\ud802[\\udc57\\udd1f\\udd3f\\ude50-\\ude58\\ude7f\\udef0-\\udef6\\udf39-\\udf3f\\udf99-\\udf9c]|\\ud803[\\udf55-\\udf59]|\\ud804[\\udc47-\\udc4d\\udcbb-\\udcbc\\udcbe-\\udcc1\\udd40-\\udd43\\udd74-\\udd75\\uddc5-\\uddc8\\uddcd\\udddb\\udddd-\\udddf\\ude38-\\ude3d\\udea9]|\\ud805[\\udc4b-\\udc4f\\udc5b\\udc5d\\udcc6\\uddc1-\\uddd7\\ude41-\\ude43\\ude60-\\ude6c\\udf3c-\\udf3e]|\\ud806[\\udc3b\\udde2\\ude3f-\\ude46\\ude9a-\\ude9c\\ude9e-\\udea2]|\\ud807[\\udc41-\\udc45\\udc70-\\udc71\\udef7-\\udef8\\udfff]|\\ud809[\\udc70-\\udc74]|\\ud81a[\\ude6e-\\ude6f\\udef5\\udf37-\\udf3b\\udf44]|\\ud81b[\\ude97-\\ude9a\\udfe2]|\\ud82f[\\udc9f]|\\ud836[\\ude87-\\ude8b]|\\ud83a[\\udd5e-\\udd5f]" };
          } }), iu = te({ "src/language-markdown/utils.js"(e, r) {
            "use strict";
            ne();
            var { getLast: t3 } = Ue(), { locStart: s, locEnd: a } = Io(), { cjkPattern: n, kPattern: u, punctuationPattern: i } = og(), l = ["liquidNode", "inlineCode", "emphasis", "esComment", "strong", "delete", "wikiLink", "link", "linkReference", "image", "imageReference", "footnote", "footnoteReference", "sentence", "whitespace", "word", "break", "inlineMath"], p = [...l, "tableCell", "paragraph", "heading"], y = new RegExp(u), h = new RegExp(i);
            function g(E, N) {
              let x = "non-cjk", I = "cj-letter", P = "k-letter", $ = "cjk-punctuation", D = [], T = (N.proseWrap === "preserve" ? E : E.replace(new RegExp(`(${n})
(${n})`, "g"), "$1$2")).split(/([\t\n ]+)/);
              for (let [C, o] of T.entries()) {
                if (C % 2 === 1) {
                  D.push({ type: "whitespace", value: /\n/.test(o) ? `
` : " " });
                  continue;
                }
                if ((C === 0 || C === T.length - 1) && o === "")
                  continue;
                let d = o.split(new RegExp(`(${n})`));
                for (let [v, S] of d.entries())
                  if (!((v === 0 || v === d.length - 1) && S === "")) {
                    if (v % 2 === 0) {
                      S !== "" && m({ type: "word", value: S, kind: x, hasLeadingPunctuation: h.test(S[0]), hasTrailingPunctuation: h.test(t3(S)) });
                      continue;
                    }
                    m(h.test(S) ? { type: "word", value: S, kind: $, hasLeadingPunctuation: true, hasTrailingPunctuation: true } : { type: "word", value: S, kind: y.test(S) ? P : I, hasLeadingPunctuation: false, hasTrailingPunctuation: false });
                  }
              }
              return D;
              function m(C) {
                let o = t3(D);
                o && o.type === "word" && (o.kind === x && C.kind === I && !o.hasTrailingPunctuation || o.kind === I && C.kind === x && !C.hasLeadingPunctuation ? D.push({ type: "whitespace", value: " " }) : !d(x, $) && ![o.value, C.value].some((v) => /\u3000/.test(v)) && D.push({ type: "whitespace", value: "" })), D.push(C);
                function d(v, S) {
                  return o.kind === v && C.kind === S || o.kind === S && C.kind === v;
                }
              }
            }
            function c(E, N) {
              let [, x, I, P] = N.slice(E.position.start.offset, E.position.end.offset).match(/^\s*(\d+)(\.|\))(\s*)/);
              return { numberText: x, marker: I, leadingSpaces: P };
            }
            function f(E, N) {
              if (!E.ordered || E.children.length < 2)
                return false;
              let x = Number(c(E.children[0], N.originalText).numberText), I = Number(c(E.children[1], N.originalText).numberText);
              if (x === 0 && E.children.length > 2) {
                let P = Number(c(E.children[2], N.originalText).numberText);
                return I === 1 && P === 1;
              }
              return I === 1;
            }
            function F(E, N) {
              let { value: x } = E;
              return E.position.end.offset === N.length && x.endsWith(`
`) && N.endsWith(`
`) ? x.slice(0, -1) : x;
            }
            function _(E, N) {
              return function x(I, P, $) {
                let D = Object.assign({}, N(I, P, $));
                return D.children && (D.children = D.children.map((T, m) => x(T, m, [D, ...$]))), D;
              }(E, null, []);
            }
            function w(E) {
              if ((E == null ? void 0 : E.type) !== "link" || E.children.length !== 1)
                return false;
              let [N] = E.children;
              return s(E) === s(N) && a(E) === a(N);
            }
            r.exports = { mapAst: _, splitText: g, punctuationPattern: i, getFencedCodeBlockValue: F, getOrderedListItemInfo: c, hasGitDiffFriendlyOrderedList: f, INLINE_NODE_TYPES: l, INLINE_NODE_WRAPPER_TYPES: p, isAutolink: w };
          } }), lg = te({ "src/language-markdown/embed.js"(e, r) {
            "use strict";
            ne();
            var { inferParserByLanguage: t3, getMaxContinuousCount: s } = Ue(), { builders: { hardline: a, markAsRoot: n }, utils: { replaceEndOfLine: u } } = qe(), i = su(), { getFencedCodeBlockValue: l } = iu();
            function p(y, h, g, c) {
              let f = y.getValue();
              if (f.type === "code" && f.lang !== null) {
                let F = t3(f.lang, c);
                if (F) {
                  let _ = c.__inJsTemplate ? "~" : "`", w = _.repeat(Math.max(3, s(f.value, _) + 1)), E = { parser: F };
                  f.lang === "tsx" && (E.filepath = "dummy.tsx");
                  let N = g(l(f, c.originalText), E, { stripTrailingHardline: true });
                  return n([w, f.lang, f.meta ? " " + f.meta : "", a, u(N), a, w]);
                }
              }
              switch (f.type) {
                case "front-matter":
                  return i(f, g);
                case "importExport":
                  return [g(f.value, { parser: "babel" }, { stripTrailingHardline: true }), a];
                case "jsx":
                  return g(`<$>${f.value}</$>`, { parser: "__js_expression", rootMarker: "mdx" }, { stripTrailingHardline: true });
              }
              return null;
            }
            r.exports = p;
          } }), ko = te({ "src/language-markdown/pragma.js"(e, r) {
            "use strict";
            ne();
            var t3 = _o(), s = ["format", "prettier"];
            function a(n) {
              let u = `@(${s.join("|")})`, i = new RegExp([`<!--\\s*${u}\\s*-->`, `{\\s*\\/\\*\\s*${u}\\s*\\*\\/\\s*}`, `<!--.*\r?
[\\s\\S]*(^|
)[^\\S
]*${u}[^\\S
]*($|
)[\\s\\S]*
.*-->`].join("|"), "m"), l = n.match(i);
              return (l == null ? void 0 : l.index) === 0;
            }
            r.exports = { startWithPragma: a, hasPragma: (n) => a(t3(n).content.trimStart()), insertPragma: (n) => {
              let u = t3(n), i = `<!-- @${s[0]} -->`;
              return u.frontMatter ? `${u.frontMatter.raw}

${i}

${u.content}` : `${i}

${u.content}`;
            } };
          } }), cg = te({ "src/language-markdown/print-preprocess.js"(e, r) {
            "use strict";
            ne();
            var t3 = lt2(), { getOrderedListItemInfo: s, mapAst: a, splitText: n } = iu(), u = /^.$/su;
            function i(w, E) {
              return w = y(w, E), w = c(w), w = p(w, E), w = F(w, E), w = _(w, E), w = f(w, E), w = l(w), w = h(w), w;
            }
            function l(w) {
              return a(w, (E) => E.type !== "import" && E.type !== "export" ? E : Object.assign(Object.assign({}, E), {}, { type: "importExport" }));
            }
            function p(w, E) {
              return a(w, (N) => N.type !== "inlineCode" || E.proseWrap === "preserve" ? N : Object.assign(Object.assign({}, N), {}, { value: N.value.replace(/\s+/g, " ") }));
            }
            function y(w, E) {
              return a(w, (N) => N.type !== "text" || N.value === "*" || N.value === "_" || !u.test(N.value) || N.position.end.offset - N.position.start.offset === N.value.length ? N : Object.assign(Object.assign({}, N), {}, { value: E.originalText.slice(N.position.start.offset, N.position.end.offset) }));
            }
            function h(w) {
              return g(w, (E, N) => E.type === "importExport" && N.type === "importExport", (E, N) => ({ type: "importExport", value: E.value + `

` + N.value, position: { start: E.position.start, end: N.position.end } }));
            }
            function g(w, E, N) {
              return a(w, (x) => {
                if (!x.children)
                  return x;
                let I = x.children.reduce((P, $) => {
                  let D = t3(P);
                  return D && E(D, $) ? P.splice(-1, 1, N(D, $)) : P.push($), P;
                }, []);
                return Object.assign(Object.assign({}, x), {}, { children: I });
              });
            }
            function c(w) {
              return g(w, (E, N) => E.type === "text" && N.type === "text", (E, N) => ({ type: "text", value: E.value + N.value, position: { start: E.position.start, end: N.position.end } }));
            }
            function f(w, E) {
              return a(w, (N, x, I) => {
                let [P] = I;
                if (N.type !== "text")
                  return N;
                let { value: $ } = N;
                return P.type === "paragraph" && (x === 0 && ($ = $.trimStart()), x === P.children.length - 1 && ($ = $.trimEnd())), { type: "sentence", position: N.position, children: n($, E) };
              });
            }
            function F(w, E) {
              return a(w, (N, x, I) => {
                if (N.type === "code") {
                  let P = /^\n?(?: {4,}|\t)/.test(E.originalText.slice(N.position.start.offset, N.position.end.offset));
                  if (N.isIndented = P, P)
                    for (let $ = 0; $ < I.length; $++) {
                      let D = I[$];
                      if (D.hasIndentedCodeblock)
                        break;
                      D.type === "list" && (D.hasIndentedCodeblock = true);
                    }
                }
                return N;
              });
            }
            function _(w, E) {
              return a(w, (I, P, $) => {
                if (I.type === "list" && I.children.length > 0) {
                  for (let D = 0; D < $.length; D++) {
                    let T = $[D];
                    if (T.type === "list" && !T.isAligned)
                      return I.isAligned = false, I;
                  }
                  I.isAligned = x(I);
                }
                return I;
              });
              function N(I) {
                return I.children.length === 0 ? -1 : I.children[0].position.start.column - 1;
              }
              function x(I) {
                if (!I.ordered)
                  return true;
                let [P, $] = I.children;
                if (s(P, E.originalText).leadingSpaces.length > 1)
                  return true;
                let T = N(P);
                if (T === -1)
                  return false;
                if (I.children.length === 1)
                  return T % E.tabWidth === 0;
                let m = N($);
                return T !== m ? false : T % E.tabWidth === 0 ? true : s($, E.originalText).leadingSpaces.length > 1;
              }
            }
            r.exports = i;
          } }), pg = te({ "src/language-markdown/clean.js"(e, r) {
            "use strict";
            ne();
            var t3 = Po(), { isFrontMatterNode: s } = Ue(), { startWithPragma: a } = ko(), n = /* @__PURE__ */ new Set(["position", "raw"]);
            function u(i, l, p) {
              if ((i.type === "front-matter" || i.type === "code" || i.type === "yaml" || i.type === "import" || i.type === "export" || i.type === "jsx") && delete l.value, i.type === "list" && delete l.isAligned, (i.type === "list" || i.type === "listItem") && (delete l.spread, delete l.loose), i.type === "text" || (i.type === "inlineCode" && (l.value = i.value.replace(/[\t\n ]+/g, " ")), i.type === "wikiLink" && (l.value = i.value.trim().replace(/[\t\n]+/g, " ")), (i.type === "definition" || i.type === "linkReference" || i.type === "imageReference") && (l.label = t3(i.label)), (i.type === "definition" || i.type === "link" || i.type === "image") && i.title && (l.title = i.title.replace(/\\(["')])/g, "$1")), p && p.type === "root" && p.children.length > 0 && (p.children[0] === i || s(p.children[0]) && p.children[1] === i) && i.type === "html" && a(i.value)))
                return null;
            }
            u.ignoredProperties = n, r.exports = u;
          } }), fg = te({ "src/language-markdown/printer-markdown.js"(e, r) {
            "use strict";
            ne();
            var t3 = Po(), { getLast: s, getMinNotPresentContinuousCount: a, getMaxContinuousCount: n, getStringWidth: u, isNonEmptyArray: i } = Ue(), { builders: { breakParent: l, join: p, line: y, literalline: h, markAsRoot: g, hardline: c, softline: f, ifBreak: F, fill: _, align: w, indent: E, group: N, hardlineWithoutBreakParent: x }, utils: { normalizeDoc: I, replaceTextEndOfLine: P }, printer: { printDocToString: $ } } = qe(), D = lg(), { insertPragma: T } = ko(), { locStart: m, locEnd: C } = Io(), o = cg(), d = pg(), { getFencedCodeBlockValue: v, hasGitDiffFriendlyOrderedList: S, splitText: b, punctuationPattern: B, INLINE_NODE_TYPES: k, INLINE_NODE_WRAPPER_TYPES: M, isAutolink: R } = iu(), q = /* @__PURE__ */ new Set(["importExport"]), J = ["heading", "tableCell", "link", "wikiLink"], L = /* @__PURE__ */ new Set(["listItem", "definition", "footnoteDefinition"]);
            function Q(oe, H, pe) {
              let X = oe.getValue();
              if (ge(oe))
                return b(H.originalText.slice(X.position.start.offset, X.position.end.offset), H).map((le) => le.type === "word" ? le.value : le.value === "" ? "" : W(oe, le.value, H));
              switch (X.type) {
                case "front-matter":
                  return H.originalText.slice(X.position.start.offset, X.position.end.offset);
                case "root":
                  return X.children.length === 0 ? "" : [I(de(oe, H, pe)), q.has(z(X).type) ? "" : c];
                case "paragraph":
                  return ue(oe, H, pe, { postprocessor: _ });
                case "sentence":
                  return ue(oe, H, pe);
                case "word": {
                  let le = X.value.replace(/\*/g, "\\$&").replace(new RegExp([`(^|${B})(_+)`, `(_+)(${B}|$)`].join("|"), "g"), (De, A, G, re, ye) => (G ? `${A}${G}` : `${re}${ye}`).replace(/_/g, "\\_")), Ae = (De, A, G) => De.type === "sentence" && G === 0, Ee = (De, A, G) => R(De.children[G - 1]);
                  return le !== X.value && (oe.match(void 0, Ae, Ee) || oe.match(void 0, Ae, (De, A, G) => De.type === "emphasis" && G === 0, Ee)) && (le = le.replace(/^(\\?[*_])+/, (De) => De.replace(/\\/g, ""))), le;
                }
                case "whitespace": {
                  let le = oe.getParentNode(), Ae = le.children.indexOf(X), Ee = le.children[Ae + 1], De = Ee && /^>|^(?:[*+-]|#{1,6}|\d+[).])$/.test(Ee.value) ? "never" : H.proseWrap;
                  return W(oe, X.value, { proseWrap: De });
                }
                case "emphasis": {
                  let le;
                  if (R(X.children[0]))
                    le = H.originalText[X.position.start.offset];
                  else {
                    let Ae = oe.getParentNode(), Ee = Ae.children.indexOf(X), De = Ae.children[Ee - 1], A = Ae.children[Ee + 1];
                    le = De && De.type === "sentence" && De.children.length > 0 && s(De.children).type === "word" && !s(De.children).hasTrailingPunctuation || A && A.type === "sentence" && A.children.length > 0 && A.children[0].type === "word" && !A.children[0].hasLeadingPunctuation || ce(oe, "emphasis") ? "*" : "_";
                  }
                  return [le, ue(oe, H, pe), le];
                }
                case "strong":
                  return ["**", ue(oe, H, pe), "**"];
                case "delete":
                  return ["~~", ue(oe, H, pe), "~~"];
                case "inlineCode": {
                  let le = a(X.value, "`"), Ae = "`".repeat(le || 1), Ee = le && !/^\s/.test(X.value) ? " " : "";
                  return [Ae, Ee, X.value, Ee, Ae];
                }
                case "wikiLink": {
                  let le = "";
                  return H.proseWrap === "preserve" ? le = X.value : le = X.value.replace(/[\t\n]+/g, " "), ["[[", le, "]]"];
                }
                case "link":
                  switch (H.originalText[X.position.start.offset]) {
                    case "<": {
                      let le = "mailto:";
                      return ["<", X.url.startsWith(le) && H.originalText.slice(X.position.start.offset + 1, X.position.start.offset + 1 + le.length) !== le ? X.url.slice(le.length) : X.url, ">"];
                    }
                    case "[":
                      return ["[", ue(oe, H, pe), "](", he(X.url, ")"), we(X.title, H), ")"];
                    default:
                      return H.originalText.slice(X.position.start.offset, X.position.end.offset);
                  }
                case "image":
                  return ["![", X.alt || "", "](", he(X.url, ")"), we(X.title, H), ")"];
                case "blockquote":
                  return ["> ", w("> ", ue(oe, H, pe))];
                case "heading":
                  return ["#".repeat(X.depth) + " ", ue(oe, H, pe)];
                case "code": {
                  if (X.isIndented) {
                    let Ee = " ".repeat(4);
                    return w(Ee, [Ee, ...P(X.value, c)]);
                  }
                  let le = H.__inJsTemplate ? "~" : "`", Ae = le.repeat(Math.max(3, n(X.value, le) + 1));
                  return [Ae, X.lang || "", X.meta ? " " + X.meta : "", c, ...P(v(X, H.originalText), c), c, Ae];
                }
                case "html": {
                  let le = oe.getParentNode(), Ae = le.type === "root" && s(le.children) === X ? X.value.trimEnd() : X.value, Ee = /^<!--.*-->$/s.test(Ae);
                  return P(Ae, Ee ? c : g(h));
                }
                case "list": {
                  let le = Y(X, oe.getParentNode()), Ae = S(X, H);
                  return ue(oe, H, pe, { processor: (Ee, De) => {
                    let A = re(), G = Ee.getValue();
                    if (G.children.length === 2 && G.children[1].type === "html" && G.children[0].position.start.column !== G.children[1].position.start.column)
                      return [A, V(Ee, H, pe, A)];
                    return [A, w(" ".repeat(A.length), V(Ee, H, pe, A))];
                    function re() {
                      let ye = X.ordered ? (De === 0 ? X.start : Ae ? 1 : X.start + De) + (le % 2 === 0 ? ". " : ") ") : le % 2 === 0 ? "- " : "* ";
                      return X.isAligned || X.hasIndentedCodeblock ? j(ye, H) : ye;
                    }
                  } });
                }
                case "thematicBreak": {
                  let le = ee(oe, "list");
                  return le === -1 ? "---" : Y(oe.getParentNode(le), oe.getParentNode(le + 1)) % 2 === 0 ? "***" : "---";
                }
                case "linkReference":
                  return ["[", ue(oe, H, pe), "]", X.referenceType === "full" ? Ne(X) : X.referenceType === "collapsed" ? "[]" : ""];
                case "imageReference":
                  switch (X.referenceType) {
                    case "full":
                      return ["![", X.alt || "", "]", Ne(X)];
                    default:
                      return ["![", X.alt, "]", X.referenceType === "collapsed" ? "[]" : ""];
                  }
                case "definition": {
                  let le = H.proseWrap === "always" ? y : " ";
                  return N([Ne(X), ":", E([le, he(X.url), X.title === null ? "" : [le, we(X.title, H, false)]])]);
                }
                case "footnote":
                  return ["[^", ue(oe, H, pe), "]"];
                case "footnoteReference":
                  return Pe(X);
                case "footnoteDefinition": {
                  let le = oe.getParentNode().children[oe.getName() + 1], Ae = X.children.length === 1 && X.children[0].type === "paragraph" && (H.proseWrap === "never" || H.proseWrap === "preserve" && X.children[0].position.start.line === X.children[0].position.end.line);
                  return [Pe(X), ": ", Ae ? ue(oe, H, pe) : N([w(" ".repeat(4), ue(oe, H, pe, { processor: (Ee, De) => De === 0 ? N([f, pe()]) : pe() })), le && le.type === "footnoteDefinition" ? f : ""])];
                }
                case "table":
                  return K(oe, H, pe);
                case "tableCell":
                  return ue(oe, H, pe);
                case "break":
                  return /\s/.test(H.originalText[X.position.start.offset]) ? ["  ", g(h)] : ["\\", c];
                case "liquidNode":
                  return P(X.value, c);
                case "importExport":
                  return [X.value, c];
                case "esComment":
                  return ["{/* ", X.value, " */}"];
                case "jsx":
                  return X.value;
                case "math":
                  return ["$$", c, X.value ? [...P(X.value, c), c] : "", "$$"];
                case "inlineMath":
                  return H.originalText.slice(m(X), C(X));
                case "tableRow":
                case "listItem":
                default:
                  throw new Error(`Unknown markdown type ${JSON.stringify(X.type)}`);
              }
            }
            function V(oe, H, pe, X) {
              let le = oe.getValue(), Ae = le.checked === null ? "" : le.checked ? "[x] " : "[ ] ";
              return [Ae, ue(oe, H, pe, { processor: (Ee, De) => {
                if (De === 0 && Ee.getValue().type !== "list")
                  return w(" ".repeat(Ae.length), pe());
                let A = " ".repeat(ke(H.tabWidth - X.length, 0, 3));
                return [A, w(A, pe())];
              } })];
            }
            function j(oe, H) {
              let pe = X();
              return oe + " ".repeat(pe >= 4 ? 0 : pe);
              function X() {
                let le = oe.length % H.tabWidth;
                return le === 0 ? 0 : H.tabWidth - le;
              }
            }
            function Y(oe, H) {
              return ie(oe, H, (pe) => pe.ordered === oe.ordered);
            }
            function ie(oe, H, pe) {
              let X = -1;
              for (let le of H.children)
                if (le.type === oe.type && pe(le) ? X++ : X = -1, le === oe)
                  return X;
            }
            function ee(oe, H) {
              let pe = Array.isArray(H) ? H : [H], X = -1, le;
              for (; le = oe.getParentNode(++X); )
                if (pe.includes(le.type))
                  return X;
              return -1;
            }
            function ce(oe, H) {
              let pe = ee(oe, H);
              return pe === -1 ? null : oe.getParentNode(pe);
            }
            function W(oe, H, pe) {
              if (pe.proseWrap === "preserve" && H === `
`)
                return c;
              let X = pe.proseWrap === "always" && !ce(oe, J);
              return H !== "" ? X ? y : " " : X ? f : "";
            }
            function K(oe, H, pe) {
              let X = oe.getValue(), le = [], Ae = oe.map((ye) => ye.map((Ce, Be) => {
                let ve = $(pe(), H).formatted, ze = u(ve);
                return le[Be] = Math.max(le[Be] || 3, ze), { text: ve, width: ze };
              }, "children"), "children"), Ee = A(false);
              if (H.proseWrap !== "never")
                return [l, Ee];
              let De = A(true);
              return [l, N(F(De, Ee))];
              function A(ye) {
                let Ce = [re(Ae[0], ye), G(ye)];
                return Ae.length > 1 && Ce.push(p(x, Ae.slice(1).map((Be) => re(Be, ye)))), p(x, Ce);
              }
              function G(ye) {
                return `| ${le.map((Be, ve) => {
                  let ze = X.align[ve], be = ze === "center" || ze === "left" ? ":" : "-", Ye = ze === "center" || ze === "right" ? ":" : "-", Se = ye ? "-" : "-".repeat(Be - 2);
                  return `${be}${Se}${Ye}`;
                }).join(" | ")} |`;
              }
              function re(ye, Ce) {
                return `| ${ye.map((ve, ze) => {
                  let { text: be, width: Ye } = ve;
                  if (Ce)
                    return be;
                  let Se = le[ze] - Ye, Ie = X.align[ze], Oe = 0;
                  Ie === "right" ? Oe = Se : Ie === "center" && (Oe = Math.floor(Se / 2));
                  let Je = Se - Oe;
                  return `${" ".repeat(Oe)}${be}${" ".repeat(Je)}`;
                }).join(" | ")} |`;
              }
            }
            function de(oe, H, pe) {
              let X = [], le = null, { children: Ae } = oe.getValue();
              for (let [Ee, De] of Ae.entries())
                switch (U(De)) {
                  case "start":
                    le === null && (le = { index: Ee, offset: De.position.end.offset });
                    break;
                  case "end":
                    le !== null && (X.push({ start: le, end: { index: Ee, offset: De.position.start.offset } }), le = null);
                    break;
                  default:
                    break;
                }
              return ue(oe, H, pe, { processor: (Ee, De) => {
                if (X.length > 0) {
                  let A = X[0];
                  if (De === A.start.index)
                    return [Fe(Ae[A.start.index]), H.originalText.slice(A.start.offset, A.end.offset), Fe(Ae[A.end.index])];
                  if (A.start.index < De && De < A.end.index)
                    return false;
                  if (De === A.end.index)
                    return X.shift(), false;
                }
                return pe();
              } });
            }
            function ue(oe, H, pe) {
              let X = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, { postprocessor: le } = X, Ae = X.processor || (() => pe()), Ee = oe.getValue(), De = [], A;
              return oe.each((G, re) => {
                let ye = G.getValue(), Ce = Ae(G, re);
                if (Ce !== false) {
                  let Be = { parts: De, prevNode: A, parentNode: Ee, options: H };
                  Z(ye, Be) && (De.push(c), A && q.has(A.type) || (se(ye, Be) || fe(ye, Be)) && De.push(c), fe(ye, Be) && De.push(c)), De.push(Ce), A = ye;
                }
              }, "children"), le ? le(De) : De;
            }
            function Fe(oe) {
              if (oe.type === "html")
                return oe.value;
              if (oe.type === "paragraph" && Array.isArray(oe.children) && oe.children.length === 1 && oe.children[0].type === "esComment")
                return ["{/* ", oe.children[0].value, " */}"];
            }
            function z(oe) {
              let H = oe;
              for (; i(H.children); )
                H = s(H.children);
              return H;
            }
            function U(oe) {
              let H;
              if (oe.type === "html")
                H = oe.value.match(/^<!--\s*prettier-ignore(?:-(start|end))?\s*-->$/);
              else {
                let pe;
                oe.type === "esComment" ? pe = oe : oe.type === "paragraph" && oe.children.length === 1 && oe.children[0].type === "esComment" && (pe = oe.children[0]), pe && (H = pe.value.match(/^prettier-ignore(?:-(start|end))?$/));
              }
              return H ? H[1] || "next" : false;
            }
            function Z(oe, H) {
              let pe = H.parts.length === 0, X = k.includes(oe.type), le = oe.type === "html" && M.includes(H.parentNode.type);
              return !pe && !X && !le;
            }
            function se(oe, H) {
              var pe, X, le;
              let Ee = (H.prevNode && H.prevNode.type) === oe.type && L.has(oe.type), De = H.parentNode.type === "listItem" && !H.parentNode.loose, A = ((pe = H.prevNode) === null || pe === void 0 ? void 0 : pe.type) === "listItem" && H.prevNode.loose, G = U(H.prevNode) === "next", re = oe.type === "html" && ((X = H.prevNode) === null || X === void 0 ? void 0 : X.type) === "html" && H.prevNode.position.end.line + 1 === oe.position.start.line, ye = oe.type === "html" && H.parentNode.type === "listItem" && ((le = H.prevNode) === null || le === void 0 ? void 0 : le.type) === "paragraph" && H.prevNode.position.end.line + 1 === oe.position.start.line;
              return A || !(Ee || De || G || re || ye);
            }
            function fe(oe, H) {
              let pe = H.prevNode && H.prevNode.type === "list", X = oe.type === "code" && oe.isIndented;
              return pe && X;
            }
            function ge(oe) {
              let H = ce(oe, ["linkReference", "imageReference"]);
              return H && (H.type !== "linkReference" || H.referenceType !== "full");
            }
            function he(oe) {
              let H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], pe = [" ", ...Array.isArray(H) ? H : [H]];
              return new RegExp(pe.map((X) => `\\${X}`).join("|")).test(oe) ? `<${oe}>` : oe;
            }
            function we(oe, H) {
              let pe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
              if (!oe)
                return "";
              if (pe)
                return " " + we(oe, H, false);
              if (oe = oe.replace(/\\(["')])/g, "$1"), oe.includes('"') && oe.includes("'") && !oe.includes(")"))
                return `(${oe})`;
              let X = oe.split("'").length - 1, le = oe.split('"').length - 1, Ae = X > le ? '"' : le > X || H.singleQuote ? "'" : '"';
              return oe = oe.replace(/\\/, "\\\\"), oe = oe.replace(new RegExp(`(${Ae})`, "g"), "\\$1"), `${Ae}${oe}${Ae}`;
            }
            function ke(oe, H, pe) {
              return oe < H ? H : oe > pe ? pe : oe;
            }
            function Re(oe) {
              let H = Number(oe.getName());
              if (H === 0)
                return false;
              let pe = oe.getParentNode().children[H - 1];
              return U(pe) === "next";
            }
            function Ne(oe) {
              return `[${t3(oe.label)}]`;
            }
            function Pe(oe) {
              return `[^${oe.label}]`;
            }
            r.exports = { preprocess: o, print: Q, embed: D, massageAstNode: d, hasPrettierIgnore: Re, insertPragma: T };
          } }), Dg = te({ "src/language-markdown/options.js"(e, r) {
            "use strict";
            ne();
            var t3 = Mt();
            r.exports = { proseWrap: t3.proseWrap, singleQuote: t3.singleQuote };
          } }), mg = te({ "src/language-markdown/parsers.js"() {
            ne();
          } }), _a = te({ "node_modules/linguist-languages/data/Markdown.json"(e, r) {
            r.exports = { name: "Markdown", type: "prose", color: "#083fa1", aliases: ["pandoc"], aceMode: "markdown", codemirrorMode: "gfm", codemirrorMimeType: "text/x-gfm", wrap: true, extensions: [".md", ".livemd", ".markdown", ".mdown", ".mdwn", ".mdx", ".mkd", ".mkdn", ".mkdown", ".ronn", ".scd", ".workbook"], filenames: ["contents.lr"], tmScope: "source.gfm", languageId: 222 };
          } }), dg = te({ "src/language-markdown/index.js"(e, r) {
            "use strict";
            ne();
            var t3 = _t(), s = fg(), a = Dg(), n = mg(), u = [t3(_a(), (l) => ({ since: "1.8.0", parsers: ["markdown"], vscodeLanguageIds: ["markdown"], filenames: [...l.filenames, "README"], extensions: l.extensions.filter((p) => p !== ".mdx") })), t3(_a(), () => ({ name: "MDX", since: "1.15.0", parsers: ["mdx"], vscodeLanguageIds: ["mdx"], filenames: [], extensions: [".mdx"] }))], i = { mdast: s };
            r.exports = { languages: u, options: a, printers: i, parsers: n };
          } }), gg = te({ "src/language-html/clean.js"(e, r) {
            "use strict";
            ne();
            var { isFrontMatterNode: t3 } = Ue(), s = /* @__PURE__ */ new Set(["sourceSpan", "startSourceSpan", "endSourceSpan", "nameSpan", "valueSpan"]);
            function a(n, u) {
              if (n.type === "text" || n.type === "comment" || t3(n) || n.type === "yaml" || n.type === "toml")
                return null;
              n.type === "attribute" && delete u.value, n.type === "docType" && delete u.value;
            }
            a.ignoredProperties = s, r.exports = a;
          } }), yg = te({ "src/language-html/constants.evaluate.js"(e, r) {
            r.exports = { CSS_DISPLAY_TAGS: { area: "none", base: "none", basefont: "none", datalist: "none", head: "none", link: "none", meta: "none", noembed: "none", noframes: "none", param: "block", rp: "none", script: "block", source: "block", style: "none", template: "inline", track: "block", title: "none", html: "block", body: "block", address: "block", blockquote: "block", center: "block", div: "block", figure: "block", figcaption: "block", footer: "block", form: "block", header: "block", hr: "block", legend: "block", listing: "block", main: "block", p: "block", plaintext: "block", pre: "block", xmp: "block", slot: "contents", ruby: "ruby", rt: "ruby-text", article: "block", aside: "block", h1: "block", h2: "block", h3: "block", h4: "block", h5: "block", h6: "block", hgroup: "block", nav: "block", section: "block", dir: "block", dd: "block", dl: "block", dt: "block", ol: "block", ul: "block", li: "list-item", table: "table", caption: "table-caption", colgroup: "table-column-group", col: "table-column", thead: "table-header-group", tbody: "table-row-group", tfoot: "table-footer-group", tr: "table-row", td: "table-cell", th: "table-cell", fieldset: "block", button: "inline-block", details: "block", summary: "block", dialog: "block", meter: "inline-block", progress: "inline-block", object: "inline-block", video: "inline-block", audio: "inline-block", select: "inline-block", option: "block", optgroup: "block" }, CSS_DISPLAY_DEFAULT: "inline", CSS_WHITE_SPACE_TAGS: { listing: "pre", plaintext: "pre", pre: "pre", xmp: "pre", nobr: "nowrap", table: "initial", textarea: "pre-wrap" }, CSS_WHITE_SPACE_DEFAULT: "normal" };
          } }), hg = te({ "src/language-html/utils/is-unknown-namespace.js"(e, r) {
            "use strict";
            ne();
            function t3(s) {
              return s.type === "element" && !s.hasExplicitNamespace && !["html", "svg"].includes(s.namespace);
            }
            r.exports = t3;
          } }), Rt = te({ "src/language-html/utils/index.js"(e, r) {
            "use strict";
            ne();
            var { inferParserByLanguage: t3, isFrontMatterNode: s } = Ue(), { builders: { line: a, hardline: n, join: u }, utils: { getDocParts: i, replaceTextEndOfLine: l } } = qe(), { CSS_DISPLAY_TAGS: p, CSS_DISPLAY_DEFAULT: y, CSS_WHITE_SPACE_TAGS: h, CSS_WHITE_SPACE_DEFAULT: g } = yg(), c = hg(), f = /* @__PURE__ */ new Set(["	", `
`, "\f", "\r", " "]), F = (A) => A.replace(/^[\t\n\f\r ]+/, ""), _ = (A) => A.replace(/[\t\n\f\r ]+$/, ""), w = (A) => F(_(A)), E = (A) => A.replace(/^[\t\f\r ]*\n/g, ""), N = (A) => E(_(A)), x = (A) => A.split(/[\t\n\f\r ]+/), I = (A) => A.match(/^[\t\n\f\r ]*/)[0], P = (A) => {
              let [, G, re, ye] = A.match(/^([\t\n\f\r ]*)(.*?)([\t\n\f\r ]*)$/s);
              return { leadingWhitespace: G, trailingWhitespace: ye, text: re };
            }, $ = (A) => /[\t\n\f\r ]/.test(A);
            function D(A, G) {
              return !!(A.type === "ieConditionalComment" && A.lastChild && !A.lastChild.isSelfClosing && !A.lastChild.endSourceSpan || A.type === "ieConditionalComment" && !A.complete || se(A) && A.children.some((re) => re.type !== "text" && re.type !== "interpolation") || X(A, G) && !o(A) && A.type !== "interpolation");
            }
            function T(A) {
              return A.type === "attribute" || !A.parent || !A.prev ? false : m(A.prev);
            }
            function m(A) {
              return A.type === "comment" && A.value.trim() === "prettier-ignore";
            }
            function C(A) {
              return A.type === "text" || A.type === "comment";
            }
            function o(A) {
              return A.type === "element" && (A.fullName === "script" || A.fullName === "style" || A.fullName === "svg:style" || c(A) && (A.name === "script" || A.name === "style"));
            }
            function d(A) {
              return A.children && !o(A);
            }
            function v(A) {
              return o(A) || A.type === "interpolation" || S(A);
            }
            function S(A) {
              return we(A).startsWith("pre");
            }
            function b(A, G) {
              let re = ye();
              if (re && !A.prev && A.parent && A.parent.tagDefinition && A.parent.tagDefinition.ignoreFirstLf)
                return A.type === "interpolation";
              return re;
              function ye() {
                return s(A) ? false : (A.type === "text" || A.type === "interpolation") && A.prev && (A.prev.type === "text" || A.prev.type === "interpolation") ? true : !A.parent || A.parent.cssDisplay === "none" ? false : se(A.parent) ? true : !(!A.prev && (A.parent.type === "root" || se(A) && A.parent || o(A.parent) || H(A.parent, G) || !ue(A.parent.cssDisplay)) || A.prev && !U(A.prev.cssDisplay));
              }
            }
            function B(A, G) {
              return s(A) ? false : (A.type === "text" || A.type === "interpolation") && A.next && (A.next.type === "text" || A.next.type === "interpolation") ? true : !A.parent || A.parent.cssDisplay === "none" ? false : se(A.parent) ? true : !(!A.next && (A.parent.type === "root" || se(A) && A.parent || o(A.parent) || H(A.parent, G) || !Fe(A.parent.cssDisplay)) || A.next && !z(A.next.cssDisplay));
            }
            function k(A) {
              return Z(A.cssDisplay) && !o(A);
            }
            function M(A) {
              return s(A) || A.next && A.sourceSpan.end && A.sourceSpan.end.line + 1 < A.next.sourceSpan.start.line;
            }
            function R(A) {
              return q(A) || A.type === "element" && A.children.length > 0 && (["body", "script", "style"].includes(A.name) || A.children.some((G) => ee(G))) || A.firstChild && A.firstChild === A.lastChild && A.firstChild.type !== "text" && V(A.firstChild) && (!A.lastChild.isTrailingSpaceSensitive || j(A.lastChild));
            }
            function q(A) {
              return A.type === "element" && A.children.length > 0 && (["html", "head", "ul", "ol", "select"].includes(A.name) || A.cssDisplay.startsWith("table") && A.cssDisplay !== "table-cell");
            }
            function J(A) {
              return Y(A) || A.prev && L(A.prev) || Q(A);
            }
            function L(A) {
              return Y(A) || A.type === "element" && A.fullName === "br" || Q(A);
            }
            function Q(A) {
              return V(A) && j(A);
            }
            function V(A) {
              return A.hasLeadingSpaces && (A.prev ? A.prev.sourceSpan.end.line < A.sourceSpan.start.line : A.parent.type === "root" || A.parent.startSourceSpan.end.line < A.sourceSpan.start.line);
            }
            function j(A) {
              return A.hasTrailingSpaces && (A.next ? A.next.sourceSpan.start.line > A.sourceSpan.end.line : A.parent.type === "root" || A.parent.endSourceSpan && A.parent.endSourceSpan.start.line > A.sourceSpan.end.line);
            }
            function Y(A) {
              switch (A.type) {
                case "ieConditionalComment":
                case "comment":
                case "directive":
                  return true;
                case "element":
                  return ["script", "select"].includes(A.name);
              }
              return false;
            }
            function ie(A) {
              return A.lastChild ? ie(A.lastChild) : A;
            }
            function ee(A) {
              return A.children && A.children.some((G) => G.type !== "text");
            }
            function ce(A) {
              let { type: G, lang: re } = A.attrMap;
              if (G === "module" || G === "text/javascript" || G === "text/babel" || G === "application/javascript" || re === "jsx")
                return "babel";
              if (G === "application/x-typescript" || re === "ts" || re === "tsx")
                return "typescript";
              if (G === "text/markdown")
                return "markdown";
              if (G === "text/html")
                return "html";
              if (G && (G.endsWith("json") || G.endsWith("importmap")) || G === "speculationrules")
                return "json";
              if (G === "text/x-handlebars-template")
                return "glimmer";
            }
            function W(A, G) {
              let { lang: re } = A.attrMap;
              if (!re || re === "postcss" || re === "css")
                return "css";
              if (re === "scss")
                return "scss";
              if (re === "less")
                return "less";
              if (re === "stylus")
                return t3("stylus", G);
            }
            function K(A, G) {
              if (A.name === "script" && !A.attrMap.src)
                return !A.attrMap.lang && !A.attrMap.type ? "babel" : ce(A);
              if (A.name === "style")
                return W(A, G);
              if (G && X(A, G))
                return ce(A) || !("src" in A.attrMap) && t3(A.attrMap.lang, G);
            }
            function de(A) {
              return A === "block" || A === "list-item" || A.startsWith("table");
            }
            function ue(A) {
              return !de(A) && A !== "inline-block";
            }
            function Fe(A) {
              return !de(A) && A !== "inline-block";
            }
            function z(A) {
              return !de(A);
            }
            function U(A) {
              return !de(A);
            }
            function Z(A) {
              return !de(A) && A !== "inline-block";
            }
            function se(A) {
              return we(A).startsWith("pre");
            }
            function fe(A, G) {
              let re = 0;
              for (let ye = A.stack.length - 1; ye >= 0; ye--) {
                let Ce = A.stack[ye];
                Ce && typeof Ce == "object" && !Array.isArray(Ce) && G(Ce) && re++;
              }
              return re;
            }
            function ge(A, G) {
              let re = A;
              for (; re; ) {
                if (G(re))
                  return true;
                re = re.parent;
              }
              return false;
            }
            function he(A, G) {
              if (A.prev && A.prev.type === "comment") {
                let ye = A.prev.value.match(/^\s*display:\s*([a-z]+)\s*$/);
                if (ye)
                  return ye[1];
              }
              let re = false;
              if (A.type === "element" && A.namespace === "svg")
                if (ge(A, (ye) => ye.fullName === "svg:foreignObject"))
                  re = true;
                else
                  return A.name === "svg" ? "inline-block" : "block";
              switch (G.htmlWhitespaceSensitivity) {
                case "strict":
                  return "inline";
                case "ignore":
                  return "block";
                default:
                  return G.parser === "vue" && A.parent && A.parent.type === "root" ? "block" : A.type === "element" && (!A.namespace || re || c(A)) && p[A.name] || y;
              }
            }
            function we(A) {
              return A.type === "element" && (!A.namespace || c(A)) && h[A.name] || g;
            }
            function ke(A) {
              let G = Number.POSITIVE_INFINITY;
              for (let re of A.split(`
`)) {
                if (re.length === 0)
                  continue;
                if (!f.has(re[0]))
                  return 0;
                let ye = I(re).length;
                re.length !== ye && ye < G && (G = ye);
              }
              return G === Number.POSITIVE_INFINITY ? 0 : G;
            }
            function Re(A) {
              let G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ke(A);
              return G === 0 ? A : A.split(`
`).map((re) => re.slice(G)).join(`
`);
            }
            function Ne(A, G) {
              let re = 0;
              for (let ye = 0; ye < A.length; ye++)
                A[ye] === G && re++;
              return re;
            }
            function Pe(A) {
              return A.replace(/&apos;/g, "'").replace(/&quot;/g, '"');
            }
            var oe = /* @__PURE__ */ new Set(["template", "style", "script"]);
            function H(A, G) {
              return pe(A, G) && !oe.has(A.fullName);
            }
            function pe(A, G) {
              return G.parser === "vue" && A.type === "element" && A.parent.type === "root" && A.fullName.toLowerCase() !== "html";
            }
            function X(A, G) {
              return pe(A, G) && (H(A, G) || A.attrMap.lang && A.attrMap.lang !== "html");
            }
            function le(A) {
              let G = A.fullName;
              return G.charAt(0) === "#" || G === "slot-scope" || G === "v-slot" || G.startsWith("v-slot:");
            }
            function Ae(A, G) {
              let re = A.parent;
              if (!pe(re, G))
                return false;
              let ye = re.fullName, Ce = A.fullName;
              return ye === "script" && Ce === "setup" || ye === "style" && Ce === "vars";
            }
            function Ee(A) {
              let G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : A.value;
              return A.parent.isWhitespaceSensitive ? A.parent.isIndentationSensitive ? l(G) : l(Re(N(G)), n) : i(u(a, x(G)));
            }
            function De(A, G) {
              return pe(A, G) && A.name === "script";
            }
            r.exports = { htmlTrim: w, htmlTrimPreserveIndentation: N, hasHtmlWhitespace: $, getLeadingAndTrailingHtmlWhitespace: P, canHaveInterpolation: d, countChars: Ne, countParents: fe, dedentString: Re, forceBreakChildren: q, forceBreakContent: R, forceNextEmptyLine: M, getLastDescendant: ie, getNodeCssStyleDisplay: he, getNodeCssStyleWhiteSpace: we, hasPrettierIgnore: T, inferScriptParser: K, isVueCustomBlock: H, isVueNonHtmlBlock: X, isVueScriptTag: De, isVueSlotAttribute: le, isVueSfcBindingsAttribute: Ae, isVueSfcBlock: pe, isDanglingSpaceSensitiveNode: k, isIndentationSensitiveNode: S, isLeadingSpaceSensitiveNode: b, isPreLikeNode: se, isScriptLikeTag: o, isTextLikeNode: C, isTrailingSpaceSensitiveNode: B, isWhitespaceSensitiveNode: v, isUnknownNamespace: c, preferHardlineAsLeadingSpaces: J, preferHardlineAsTrailingSpaces: L, shouldPreserveContent: D, unescapeQuoteEntities: Pe, getTextValueParts: Ee };
          } }), vg = te({ "node_modules/angular-html-parser/lib/compiler/src/chars.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true }), e.$EOF = 0, e.$BSPACE = 8, e.$TAB = 9, e.$LF = 10, e.$VTAB = 11, e.$FF = 12, e.$CR = 13, e.$SPACE = 32, e.$BANG = 33, e.$DQ = 34, e.$HASH = 35, e.$$ = 36, e.$PERCENT = 37, e.$AMPERSAND = 38, e.$SQ = 39, e.$LPAREN = 40, e.$RPAREN = 41, e.$STAR = 42, e.$PLUS = 43, e.$COMMA = 44, e.$MINUS = 45, e.$PERIOD = 46, e.$SLASH = 47, e.$COLON = 58, e.$SEMICOLON = 59, e.$LT = 60, e.$EQ = 61, e.$GT = 62, e.$QUESTION = 63, e.$0 = 48, e.$7 = 55, e.$9 = 57, e.$A = 65, e.$E = 69, e.$F = 70, e.$X = 88, e.$Z = 90, e.$LBRACKET = 91, e.$BACKSLASH = 92, e.$RBRACKET = 93, e.$CARET = 94, e.$_ = 95, e.$a = 97, e.$b = 98, e.$e = 101, e.$f = 102, e.$n = 110, e.$r = 114, e.$t = 116, e.$u = 117, e.$v = 118, e.$x = 120, e.$z = 122, e.$LBRACE = 123, e.$BAR = 124, e.$RBRACE = 125, e.$NBSP = 160, e.$PIPE = 124, e.$TILDA = 126, e.$AT = 64, e.$BT = 96;
            function r(i) {
              return i >= e.$TAB && i <= e.$SPACE || i == e.$NBSP;
            }
            e.isWhitespace = r;
            function t3(i) {
              return e.$0 <= i && i <= e.$9;
            }
            e.isDigit = t3;
            function s(i) {
              return i >= e.$a && i <= e.$z || i >= e.$A && i <= e.$Z;
            }
            e.isAsciiLetter = s;
            function a(i) {
              return i >= e.$a && i <= e.$f || i >= e.$A && i <= e.$F || t3(i);
            }
            e.isAsciiHexDigit = a;
            function n(i) {
              return i === e.$LF || i === e.$CR;
            }
            e.isNewLine = n;
            function u(i) {
              return e.$0 <= i && i <= e.$7;
            }
            e.isOctalDigit = u;
          } }), Cg = te({ "node_modules/angular-html-parser/lib/compiler/src/aot/static_symbol.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = class {
              constructor(s, a, n) {
                this.filePath = s, this.name = a, this.members = n;
              }
              assertNoMembers() {
                if (this.members.length)
                  throw new Error(`Illegal state: symbol without members expected, but got ${JSON.stringify(this)}.`);
              }
            };
            e.StaticSymbol = r;
            var t3 = class {
              constructor() {
                this.cache = /* @__PURE__ */ new Map();
              }
              get(s, a, n) {
                n = n || [];
                let u = n.length ? `.${n.join(".")}` : "", i = `"${s}".${a}${u}`, l = this.cache.get(i);
                return l || (l = new r(s, a, n), this.cache.set(i, l)), l;
              }
            };
            e.StaticSymbolCache = t3;
          } }), Eg = te({ "node_modules/angular-html-parser/lib/compiler/src/util.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = /-+([a-z0-9])/g;
            function t3(o) {
              return o.replace(r, function() {
                for (var d = arguments.length, v = new Array(d), S = 0; S < d; S++)
                  v[S] = arguments[S];
                return v[1].toUpperCase();
              });
            }
            e.dashCaseToCamelCase = t3;
            function s(o, d) {
              return n(o, ":", d);
            }
            e.splitAtColon = s;
            function a(o, d) {
              return n(o, ".", d);
            }
            e.splitAtPeriod = a;
            function n(o, d, v) {
              let S = o.indexOf(d);
              return S == -1 ? v : [o.slice(0, S).trim(), o.slice(S + 1).trim()];
            }
            function u(o, d, v) {
              return Array.isArray(o) ? d.visitArray(o, v) : E(o) ? d.visitStringMap(o, v) : o == null || typeof o == "string" || typeof o == "number" || typeof o == "boolean" ? d.visitPrimitive(o, v) : d.visitOther(o, v);
            }
            e.visitValue = u;
            function i(o) {
              return o != null;
            }
            e.isDefined = i;
            function l(o) {
              return o === void 0 ? null : o;
            }
            e.noUndefined = l;
            var p = class {
              visitArray(o, d) {
                return o.map((v) => u(v, this, d));
              }
              visitStringMap(o, d) {
                let v = {};
                return Object.keys(o).forEach((S) => {
                  v[S] = u(o[S], this, d);
                }), v;
              }
              visitPrimitive(o, d) {
                return o;
              }
              visitOther(o, d) {
                return o;
              }
            };
            e.ValueTransformer = p, e.SyncAsync = { assertSync: (o) => {
              if (P(o))
                throw new Error("Illegal state: value cannot be a promise");
              return o;
            }, then: (o, d) => P(o) ? o.then(d) : d(o), all: (o) => o.some(P) ? Promise.all(o) : o };
            function y(o) {
              throw new Error(`Internal Error: ${o}`);
            }
            e.error = y;
            function h(o, d) {
              let v = Error(o);
              return v[g] = true, d && (v[c] = d), v;
            }
            e.syntaxError = h;
            var g = "ngSyntaxError", c = "ngParseErrors";
            function f(o) {
              return o[g];
            }
            e.isSyntaxError = f;
            function F(o) {
              return o[c] || [];
            }
            e.getParseErrors = F;
            function _(o) {
              return o.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
            }
            e.escapeRegExp = _;
            var w = Object.getPrototypeOf({});
            function E(o) {
              return typeof o == "object" && o !== null && Object.getPrototypeOf(o) === w;
            }
            function N(o) {
              let d = "";
              for (let v = 0; v < o.length; v++) {
                let S = o.charCodeAt(v);
                if (S >= 55296 && S <= 56319 && o.length > v + 1) {
                  let b = o.charCodeAt(v + 1);
                  b >= 56320 && b <= 57343 && (v++, S = (S - 55296 << 10) + b - 56320 + 65536);
                }
                S <= 127 ? d += String.fromCharCode(S) : S <= 2047 ? d += String.fromCharCode(S >> 6 & 31 | 192, S & 63 | 128) : S <= 65535 ? d += String.fromCharCode(S >> 12 | 224, S >> 6 & 63 | 128, S & 63 | 128) : S <= 2097151 && (d += String.fromCharCode(S >> 18 & 7 | 240, S >> 12 & 63 | 128, S >> 6 & 63 | 128, S & 63 | 128));
              }
              return d;
            }
            e.utf8Encode = N;
            function x(o) {
              if (typeof o == "string")
                return o;
              if (o instanceof Array)
                return "[" + o.map(x).join(", ") + "]";
              if (o == null)
                return "" + o;
              if (o.overriddenName)
                return `${o.overriddenName}`;
              if (o.name)
                return `${o.name}`;
              if (!o.toString)
                return "object";
              let d = o.toString();
              if (d == null)
                return "" + d;
              let v = d.indexOf(`
`);
              return v === -1 ? d : d.substring(0, v);
            }
            e.stringify = x;
            function I(o) {
              return typeof o == "function" && o.hasOwnProperty("__forward_ref__") ? o() : o;
            }
            e.resolveForwardRef = I;
            function P(o) {
              return !!o && typeof o.then == "function";
            }
            e.isPromise = P;
            var $ = class {
              constructor(o) {
                this.full = o;
                let d = o.split(".");
                this.major = d[0], this.minor = d[1], this.patch = d.slice(2).join(".");
              }
            };
            e.Version = $;
            var D = typeof window < "u" && window, T = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, m = typeof globalThis < "u" && globalThis, C = m || D || T;
            e.global = C;
          } }), Fg = te({ "node_modules/angular-html-parser/lib/compiler/src/compile_metadata.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Cg(), t3 = Eg(), s = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
            function a(v) {
              return v.replace(/\W/g, "_");
            }
            e.sanitizeIdentifier = a;
            var n = 0;
            function u(v) {
              if (!v || !v.reference)
                return null;
              let S = v.reference;
              if (S instanceof r.StaticSymbol)
                return S.name;
              if (S.__anonymousType)
                return S.__anonymousType;
              let b = t3.stringify(S);
              return b.indexOf("(") >= 0 ? (b = `anonymous_${n++}`, S.__anonymousType = b) : b = a(b), b;
            }
            e.identifierName = u;
            function i(v) {
              let S = v.reference;
              return S instanceof r.StaticSymbol ? S.filePath : `./${t3.stringify(S)}`;
            }
            e.identifierModuleUrl = i;
            function l(v, S) {
              return `View_${u({ reference: v })}_${S}`;
            }
            e.viewClassName = l;
            function p(v) {
              return `RenderType_${u({ reference: v })}`;
            }
            e.rendererTypeName = p;
            function y(v) {
              return `HostView_${u({ reference: v })}`;
            }
            e.hostViewClassName = y;
            function h(v) {
              return `${u({ reference: v })}NgFactory`;
            }
            e.componentFactoryName = h;
            var g;
            (function(v) {
              v[v.Pipe = 0] = "Pipe", v[v.Directive = 1] = "Directive", v[v.NgModule = 2] = "NgModule", v[v.Injectable = 3] = "Injectable";
            })(g = e.CompileSummaryKind || (e.CompileSummaryKind = {}));
            function c(v) {
              return v.value != null ? a(v.value) : u(v.identifier);
            }
            e.tokenName = c;
            function f(v) {
              return v.identifier != null ? v.identifier.reference : v.value;
            }
            e.tokenReference = f;
            var F = class {
              constructor() {
                let { moduleUrl: v, styles: S, styleUrls: b } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.moduleUrl = v || null, this.styles = P(S), this.styleUrls = P(b);
              }
            };
            e.CompileStylesheetMetadata = F;
            var _ = class {
              constructor(v) {
                let { encapsulation: S, template: b, templateUrl: B, htmlAst: k, styles: M, styleUrls: R, externalStylesheets: q, animations: J, ngContentSelectors: L, interpolation: Q, isInline: V, preserveWhitespaces: j } = v;
                if (this.encapsulation = S, this.template = b, this.templateUrl = B, this.htmlAst = k, this.styles = P(M), this.styleUrls = P(R), this.externalStylesheets = P(q), this.animations = J ? D(J) : [], this.ngContentSelectors = L || [], Q && Q.length != 2)
                  throw new Error("'interpolation' should have a start and an end symbol.");
                this.interpolation = Q, this.isInline = V, this.preserveWhitespaces = j;
              }
              toSummary() {
                return { ngContentSelectors: this.ngContentSelectors, encapsulation: this.encapsulation, styles: this.styles, animations: this.animations };
              }
            };
            e.CompileTemplateMetadata = _;
            var w = class {
              static create(v) {
                let { isHost: S, type: b, isComponent: B, selector: k, exportAs: M, changeDetection: R, inputs: q, outputs: J, host: L, providers: Q, viewProviders: V, queries: j, guards: Y, viewQueries: ie, entryComponents: ee, template: ce, componentViewType: W, rendererType: K, componentFactory: de } = v, ue = {}, Fe = {}, z = {};
                L != null && Object.keys(L).forEach((se) => {
                  let fe = L[se], ge = se.match(s);
                  ge === null ? z[se] = fe : ge[1] != null ? Fe[ge[1]] = fe : ge[2] != null && (ue[ge[2]] = fe);
                });
                let U = {};
                q != null && q.forEach((se) => {
                  let fe = t3.splitAtColon(se, [se, se]);
                  U[fe[0]] = fe[1];
                });
                let Z = {};
                return J != null && J.forEach((se) => {
                  let fe = t3.splitAtColon(se, [se, se]);
                  Z[fe[0]] = fe[1];
                }), new w({ isHost: S, type: b, isComponent: !!B, selector: k, exportAs: M, changeDetection: R, inputs: U, outputs: Z, hostListeners: ue, hostProperties: Fe, hostAttributes: z, providers: Q, viewProviders: V, queries: j, guards: Y, viewQueries: ie, entryComponents: ee, template: ce, componentViewType: W, rendererType: K, componentFactory: de });
              }
              constructor(v) {
                let { isHost: S, type: b, isComponent: B, selector: k, exportAs: M, changeDetection: R, inputs: q, outputs: J, hostListeners: L, hostProperties: Q, hostAttributes: V, providers: j, viewProviders: Y, queries: ie, guards: ee, viewQueries: ce, entryComponents: W, template: K, componentViewType: de, rendererType: ue, componentFactory: Fe } = v;
                this.isHost = !!S, this.type = b, this.isComponent = B, this.selector = k, this.exportAs = M, this.changeDetection = R, this.inputs = q, this.outputs = J, this.hostListeners = L, this.hostProperties = Q, this.hostAttributes = V, this.providers = P(j), this.viewProviders = P(Y), this.queries = P(ie), this.guards = ee, this.viewQueries = P(ce), this.entryComponents = P(W), this.template = K, this.componentViewType = de, this.rendererType = ue, this.componentFactory = Fe;
              }
              toSummary() {
                return { summaryKind: g.Directive, type: this.type, isComponent: this.isComponent, selector: this.selector, exportAs: this.exportAs, inputs: this.inputs, outputs: this.outputs, hostListeners: this.hostListeners, hostProperties: this.hostProperties, hostAttributes: this.hostAttributes, providers: this.providers, viewProviders: this.viewProviders, queries: this.queries, guards: this.guards, viewQueries: this.viewQueries, entryComponents: this.entryComponents, changeDetection: this.changeDetection, template: this.template && this.template.toSummary(), componentViewType: this.componentViewType, rendererType: this.rendererType, componentFactory: this.componentFactory };
              }
            };
            e.CompileDirectiveMetadata = w;
            var E = class {
              constructor(v) {
                let { type: S, name: b, pure: B } = v;
                this.type = S, this.name = b, this.pure = !!B;
              }
              toSummary() {
                return { summaryKind: g.Pipe, type: this.type, name: this.name, pure: this.pure };
              }
            };
            e.CompilePipeMetadata = E;
            var N = class {
            };
            e.CompileShallowModuleMetadata = N;
            var x = class {
              constructor(v) {
                let { type: S, providers: b, declaredDirectives: B, exportedDirectives: k, declaredPipes: M, exportedPipes: R, entryComponents: q, bootstrapComponents: J, importedModules: L, exportedModules: Q, schemas: V, transitiveModule: j, id: Y } = v;
                this.type = S || null, this.declaredDirectives = P(B), this.exportedDirectives = P(k), this.declaredPipes = P(M), this.exportedPipes = P(R), this.providers = P(b), this.entryComponents = P(q), this.bootstrapComponents = P(J), this.importedModules = P(L), this.exportedModules = P(Q), this.schemas = P(V), this.id = Y || null, this.transitiveModule = j || null;
              }
              toSummary() {
                let v = this.transitiveModule;
                return { summaryKind: g.NgModule, type: this.type, entryComponents: v.entryComponents, providers: v.providers, modules: v.modules, exportedDirectives: v.exportedDirectives, exportedPipes: v.exportedPipes };
              }
            };
            e.CompileNgModuleMetadata = x;
            var I = class {
              constructor() {
                this.directivesSet = /* @__PURE__ */ new Set(), this.directives = [], this.exportedDirectivesSet = /* @__PURE__ */ new Set(), this.exportedDirectives = [], this.pipesSet = /* @__PURE__ */ new Set(), this.pipes = [], this.exportedPipesSet = /* @__PURE__ */ new Set(), this.exportedPipes = [], this.modulesSet = /* @__PURE__ */ new Set(), this.modules = [], this.entryComponentsSet = /* @__PURE__ */ new Set(), this.entryComponents = [], this.providers = [];
              }
              addProvider(v, S) {
                this.providers.push({ provider: v, module: S });
              }
              addDirective(v) {
                this.directivesSet.has(v.reference) || (this.directivesSet.add(v.reference), this.directives.push(v));
              }
              addExportedDirective(v) {
                this.exportedDirectivesSet.has(v.reference) || (this.exportedDirectivesSet.add(v.reference), this.exportedDirectives.push(v));
              }
              addPipe(v) {
                this.pipesSet.has(v.reference) || (this.pipesSet.add(v.reference), this.pipes.push(v));
              }
              addExportedPipe(v) {
                this.exportedPipesSet.has(v.reference) || (this.exportedPipesSet.add(v.reference), this.exportedPipes.push(v));
              }
              addModule(v) {
                this.modulesSet.has(v.reference) || (this.modulesSet.add(v.reference), this.modules.push(v));
              }
              addEntryComponent(v) {
                this.entryComponentsSet.has(v.componentType) || (this.entryComponentsSet.add(v.componentType), this.entryComponents.push(v));
              }
            };
            e.TransitiveCompileNgModuleMetadata = I;
            function P(v) {
              return v || [];
            }
            var $ = class {
              constructor(v, S) {
                let { useClass: b, useValue: B, useExisting: k, useFactory: M, deps: R, multi: q } = S;
                this.token = v, this.useClass = b || null, this.useValue = B, this.useExisting = k, this.useFactory = M || null, this.dependencies = R || null, this.multi = !!q;
              }
            };
            e.ProviderMeta = $;
            function D(v) {
              return v.reduce((S, b) => {
                let B = Array.isArray(b) ? D(b) : b;
                return S.concat(B);
              }, []);
            }
            e.flatten = D;
            function T(v) {
              return v.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, "ng:///");
            }
            function m(v, S, b) {
              let B;
              return b.isInline ? S.type.reference instanceof r.StaticSymbol ? B = `${S.type.reference.filePath}.${S.type.reference.name}.html` : B = `${u(v)}/${u(S.type)}.html` : B = b.templateUrl, S.type.reference instanceof r.StaticSymbol ? B : T(B);
            }
            e.templateSourceUrl = m;
            function C(v, S) {
              let b = v.moduleUrl.split(/\/\\/g), B = b[b.length - 1];
              return T(`css/${S}${B}.ngstyle.js`);
            }
            e.sharedStylesheetJitUrl = C;
            function o(v) {
              return T(`${u(v.type)}/module.ngfactory.js`);
            }
            e.ngModuleJitUrl = o;
            function d(v, S) {
              return T(`${u(v)}/${u(S.type)}.ngfactory.js`);
            }
            e.templateJitUrl = d;
          } }), Ag = te({ "node_modules/angular-html-parser/lib/compiler/src/parse_util.js"(e) {
            "use strict";
            ne(), Object.defineProperty(e, "__esModule", { value: true });
            var r = vg(), t3 = Fg(), s = class {
              constructor(y, h, g, c) {
                this.file = y, this.offset = h, this.line = g, this.col = c;
              }
              toString() {
                return this.offset != null ? `${this.file.url}@${this.line}:${this.col}` : this.file.url;
              }
              moveBy(y) {
                let h = this.file.content, g = h.length, c = this.offset, f = this.line, F = this.col;
                for (; c > 0 && y < 0; )
                  if (c--, y++, h.charCodeAt(c) == r.$LF) {
                    f--;
                    let w = h.substr(0, c - 1).lastIndexOf(String.fromCharCode(r.$LF));
                    F = w > 0 ? c - w : c;
                  } else
                    F--;
                for (; c < g && y > 0; ) {
                  let _ = h.charCodeAt(c);
                  c++, y--, _ == r.$LF ? (f++, F = 0) : F++;
                }
                return new s(this.file, c, f, F);
              }
              getContext(y, h) {
                let g = this.file.content, c = this.offset;
                if (c != null) {
                  c > g.length - 1 && (c = g.length - 1);
                  let f = c, F = 0, _ = 0;
                  for (; F < y && c > 0 && (c--, F++, !(g[c] == `
` && ++_ == h)); )
                    ;
                  for (F = 0, _ = 0; F < y && f < g.length - 1 && (f++, F++, !(g[f] == `
` && ++_ == h)); )
                    ;
                  return { before: g.substring(c, this.offset), after: g.substring(this.offset, f + 1) };
                }
                return null;
              }
            };
            e.ParseLocation = s;
            var a = class {
              constructor(y, h) {
                this.content = y, this.url = h;
              }
            };
            e.ParseSourceFile = a;
            var n = class {
              constructor(y, h) {
                let g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                this.start = y, this.end = h, this.details = g;
              }
              toString() {
                return this.start.file.content.substring(this.start.offset, this.end.offset);
              }
            };
            e.ParseSourceSpan = n, e.EMPTY_PARSE_LOCATION = new s(new a("", ""), 0, 0, 0), e.EMPTY_SOURCE_SPAN = new n(e.EMPTY_PARSE_LOCATION, e.EMPTY_PARSE_LOCATION);
            var u;
            (function(y) {
              y[y.WARNING = 0] = "WARNING", y[y.ERROR = 1] = "ERROR";
            })(u = e.ParseErrorLevel || (e.ParseErrorLevel = {}));
            var i = class {
              constructor(y, h) {
                let g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : u.ERROR;
                this.span = y, this.msg = h, this.level = g;
              }
              contextualMessage() {
                let y = this.span.start.getContext(100, 3);
                return y ? `${this.msg} ("${y.before}[${u[this.level]} ->]${y.after}")` : this.msg;
              }
              toString() {
                let y = this.span.details ? `, ${this.span.details}` : "";
                return `${this.contextualMessage()}: ${this.span.start}${y}`;
              }
            };
            e.ParseError = i;
            function l(y, h) {
              let g = t3.identifierModuleUrl(h), c = g != null ? `in ${y} ${t3.identifierName(h)} in ${g}` : `in ${y} ${t3.identifierName(h)}`, f = new a("", c);
              return new n(new s(f, -1, -1, -1), new s(f, -1, -1, -1));
            }
            e.typeSourceSpan = l;
            function p(y, h, g) {
              let c = `in ${y} ${h} in ${g}`, f = new a("", c);
              return new n(new s(f, -1, -1, -1), new s(f, -1, -1, -1));
            }
            e.r3JitTypeSourceSpan = p;
          } }), Sg = te({ "src/language-html/print-preprocess.js"(e, r) {
            "use strict";
            ne();
            var { ParseSourceSpan: t3 } = Ag(), { htmlTrim: s, getLeadingAndTrailingHtmlWhitespace: a, hasHtmlWhitespace: n, canHaveInterpolation: u, getNodeCssStyleDisplay: i, isDanglingSpaceSensitiveNode: l, isIndentationSensitiveNode: p, isLeadingSpaceSensitiveNode: y, isTrailingSpaceSensitiveNode: h, isWhitespaceSensitiveNode: g, isVueScriptTag: c } = Rt(), f = [_, w, N, I, P, T, $, D, m, x, C];
            function F(o, d) {
              for (let v of f)
                v(o, d);
              return o;
            }
            function _(o) {
              o.walk((d) => {
                if (d.type === "element" && d.tagDefinition.ignoreFirstLf && d.children.length > 0 && d.children[0].type === "text" && d.children[0].value[0] === `
`) {
                  let v = d.children[0];
                  v.value.length === 1 ? d.removeChild(v) : v.value = v.value.slice(1);
                }
              });
            }
            function w(o) {
              let d = (v) => v.type === "element" && v.prev && v.prev.type === "ieConditionalStartComment" && v.prev.sourceSpan.end.offset === v.startSourceSpan.start.offset && v.firstChild && v.firstChild.type === "ieConditionalEndComment" && v.firstChild.sourceSpan.start.offset === v.startSourceSpan.end.offset;
              o.walk((v) => {
                if (v.children)
                  for (let S = 0; S < v.children.length; S++) {
                    let b = v.children[S];
                    if (!d(b))
                      continue;
                    let B = b.prev, k = b.firstChild;
                    v.removeChild(B), S--;
                    let M = new t3(B.sourceSpan.start, k.sourceSpan.end), R = new t3(M.start, b.sourceSpan.end);
                    b.condition = B.condition, b.sourceSpan = R, b.startSourceSpan = M, b.removeChild(k);
                  }
              });
            }
            function E(o, d, v) {
              o.walk((S) => {
                if (S.children)
                  for (let b = 0; b < S.children.length; b++) {
                    let B = S.children[b];
                    if (B.type !== "text" && !d(B))
                      continue;
                    B.type !== "text" && (B.type = "text", B.value = v(B));
                    let k = B.prev;
                    !k || k.type !== "text" || (k.value += B.value, k.sourceSpan = new t3(k.sourceSpan.start, B.sourceSpan.end), S.removeChild(B), b--);
                  }
              });
            }
            function N(o) {
              return E(o, (d) => d.type === "cdata", (d) => `<![CDATA[${d.value}]]>`);
            }
            function x(o) {
              let d = (v) => v.type === "element" && v.attrs.length === 0 && v.children.length === 1 && v.firstChild.type === "text" && !n(v.children[0].value) && !v.firstChild.hasLeadingSpaces && !v.firstChild.hasTrailingSpaces && v.isLeadingSpaceSensitive && !v.hasLeadingSpaces && v.isTrailingSpaceSensitive && !v.hasTrailingSpaces && v.prev && v.prev.type === "text" && v.next && v.next.type === "text";
              o.walk((v) => {
                if (v.children)
                  for (let S = 0; S < v.children.length; S++) {
                    let b = v.children[S];
                    if (!d(b))
                      continue;
                    let B = b.prev, k = b.next;
                    B.value += `<${b.rawName}>` + b.firstChild.value + `</${b.rawName}>` + k.value, B.sourceSpan = new t3(B.sourceSpan.start, k.sourceSpan.end), B.isTrailingSpaceSensitive = k.isTrailingSpaceSensitive, B.hasTrailingSpaces = k.hasTrailingSpaces, v.removeChild(b), S--, v.removeChild(k);
                  }
              });
            }
            function I(o, d) {
              if (d.parser === "html")
                return;
              let v = /{{(.+?)}}/s;
              o.walk((S) => {
                if (u(S))
                  for (let b of S.children) {
                    if (b.type !== "text")
                      continue;
                    let B = b.sourceSpan.start, k = null, M = b.value.split(v);
                    for (let R = 0; R < M.length; R++, B = k) {
                      let q = M[R];
                      if (R % 2 === 0) {
                        k = B.moveBy(q.length), q.length > 0 && S.insertChildBefore(b, { type: "text", value: q, sourceSpan: new t3(B, k) });
                        continue;
                      }
                      k = B.moveBy(q.length + 4), S.insertChildBefore(b, { type: "interpolation", sourceSpan: new t3(B, k), children: q.length === 0 ? [] : [{ type: "text", value: q, sourceSpan: new t3(B.moveBy(2), k.moveBy(-2)) }] });
                    }
                    S.removeChild(b);
                  }
              });
            }
            function P(o) {
              o.walk((d) => {
                if (!d.children)
                  return;
                if (d.children.length === 0 || d.children.length === 1 && d.children[0].type === "text" && s(d.children[0].value).length === 0) {
                  d.hasDanglingSpaces = d.children.length > 0, d.children = [];
                  return;
                }
                let v = g(d), S = p(d);
                if (!v)
                  for (let b = 0; b < d.children.length; b++) {
                    let B = d.children[b];
                    if (B.type !== "text")
                      continue;
                    let { leadingWhitespace: k, text: M, trailingWhitespace: R } = a(B.value), q = B.prev, J = B.next;
                    M ? (B.value = M, B.sourceSpan = new t3(B.sourceSpan.start.moveBy(k.length), B.sourceSpan.end.moveBy(-R.length)), k && (q && (q.hasTrailingSpaces = true), B.hasLeadingSpaces = true), R && (B.hasTrailingSpaces = true, J && (J.hasLeadingSpaces = true))) : (d.removeChild(B), b--, (k || R) && (q && (q.hasTrailingSpaces = true), J && (J.hasLeadingSpaces = true)));
                  }
                d.isWhitespaceSensitive = v, d.isIndentationSensitive = S;
              });
            }
            function $(o) {
              o.walk((d) => {
                d.isSelfClosing = !d.children || d.type === "element" && (d.tagDefinition.isVoid || d.startSourceSpan === d.endSourceSpan);
              });
            }
            function D(o, d) {
              o.walk((v) => {
                v.type === "element" && (v.hasHtmComponentClosingTag = v.endSourceSpan && /^<\s*\/\s*\/\s*>$/.test(d.originalText.slice(v.endSourceSpan.start.offset, v.endSourceSpan.end.offset)));
              });
            }
            function T(o, d) {
              o.walk((v) => {
                v.cssDisplay = i(v, d);
              });
            }
            function m(o, d) {
              o.walk((v) => {
                let { children: S } = v;
                if (S) {
                  if (S.length === 0) {
                    v.isDanglingSpaceSensitive = l(v);
                    return;
                  }
                  for (let b of S)
                    b.isLeadingSpaceSensitive = y(b, d), b.isTrailingSpaceSensitive = h(b, d);
                  for (let b = 0; b < S.length; b++) {
                    let B = S[b];
                    B.isLeadingSpaceSensitive = (b === 0 || B.prev.isTrailingSpaceSensitive) && B.isLeadingSpaceSensitive, B.isTrailingSpaceSensitive = (b === S.length - 1 || B.next.isLeadingSpaceSensitive) && B.isTrailingSpaceSensitive;
                  }
                }
              });
            }
            function C(o, d) {
              if (d.parser === "vue") {
                let v = o.children.find((b) => c(b, d));
                if (!v)
                  return;
                let { lang: S } = v.attrMap;
                (S === "ts" || S === "typescript") && (d.__should_parse_vue_template_with_ts = true);
              }
            }
            r.exports = F;
          } }), xg = te({ "src/language-html/pragma.js"(e, r) {
            "use strict";
            ne();
            function t3(a) {
              return /^\s*<!--\s*@(?:format|prettier)\s*-->/.test(a);
            }
            function s(a) {
              return `<!-- @format -->

` + a.replace(/^\s*\n/, "");
            }
            r.exports = { hasPragma: t3, insertPragma: s };
          } }), au = te({ "src/language-html/loc.js"(e, r) {
            "use strict";
            ne();
            function t3(a) {
              return a.sourceSpan.start.offset;
            }
            function s(a) {
              return a.sourceSpan.end.offset;
            }
            r.exports = { locStart: t3, locEnd: s };
          } }), ur = te({ "src/language-html/print/tag.js"(e, r) {
            "use strict";
            ne();
            var t3 = Zt(), { isNonEmptyArray: s } = Ue(), { builders: { indent: a, join: n, line: u, softline: i, hardline: l }, utils: { replaceTextEndOfLine: p } } = qe(), { locStart: y, locEnd: h } = au(), { isTextLikeNode: g, getLastDescendant: c, isPreLikeNode: f, hasPrettierIgnore: F, shouldPreserveContent: _, isVueSfcBlock: w } = Rt();
            function E(L, Q) {
              return [L.isSelfClosing ? "" : N(L, Q), x(L, Q)];
            }
            function N(L, Q) {
              return L.lastChild && o(L.lastChild) ? "" : [I(L, Q), $(L, Q)];
            }
            function x(L, Q) {
              return (L.next ? m(L.next) : C(L.parent)) ? "" : [D(L, Q), P(L, Q)];
            }
            function I(L, Q) {
              return C(L) ? D(L.lastChild, Q) : "";
            }
            function P(L, Q) {
              return o(L) ? $(L.parent, Q) : d(L) ? q(L.next) : "";
            }
            function $(L, Q) {
              if (t3(!L.isSelfClosing), T(L, Q))
                return "";
              switch (L.type) {
                case "ieConditionalComment":
                  return "<!";
                case "element":
                  if (L.hasHtmComponentClosingTag)
                    return "<//";
                default:
                  return `</${L.rawName}`;
              }
            }
            function D(L, Q) {
              if (T(L, Q))
                return "";
              switch (L.type) {
                case "ieConditionalComment":
                case "ieConditionalEndComment":
                  return "[endif]-->";
                case "ieConditionalStartComment":
                  return "]><!-->";
                case "interpolation":
                  return "}}";
                case "element":
                  if (L.isSelfClosing)
                    return "/>";
                default:
                  return ">";
              }
            }
            function T(L, Q) {
              return !L.isSelfClosing && !L.endSourceSpan && (F(L) || _(L.parent, Q));
            }
            function m(L) {
              return L.prev && L.prev.type !== "docType" && !g(L.prev) && L.isLeadingSpaceSensitive && !L.hasLeadingSpaces;
            }
            function C(L) {
              return L.lastChild && L.lastChild.isTrailingSpaceSensitive && !L.lastChild.hasTrailingSpaces && !g(c(L.lastChild)) && !f(L);
            }
            function o(L) {
              return !L.next && !L.hasTrailingSpaces && L.isTrailingSpaceSensitive && g(c(L));
            }
            function d(L) {
              return L.next && !g(L.next) && g(L) && L.isTrailingSpaceSensitive && !L.hasTrailingSpaces;
            }
            function v(L) {
              let Q = L.trim().match(/^prettier-ignore-attribute(?:\s+(.+))?$/s);
              return Q ? Q[1] ? Q[1].split(/\s+/) : true : false;
            }
            function S(L) {
              return !L.prev && L.isLeadingSpaceSensitive && !L.hasLeadingSpaces;
            }
            function b(L, Q, V) {
              let j = L.getValue();
              if (!s(j.attrs))
                return j.isSelfClosing ? " " : "";
              let Y = j.prev && j.prev.type === "comment" && v(j.prev.value), ie = typeof Y == "boolean" ? () => Y : Array.isArray(Y) ? (ue) => Y.includes(ue.rawName) : () => false, ee = L.map((ue) => {
                let Fe = ue.getValue();
                return ie(Fe) ? p(Q.originalText.slice(y(Fe), h(Fe))) : V();
              }, "attrs"), ce = j.type === "element" && j.fullName === "script" && j.attrs.length === 1 && j.attrs[0].fullName === "src" && j.children.length === 0, K = Q.singleAttributePerLine && j.attrs.length > 1 && !w(j, Q) ? l : u, de = [a([ce ? " " : u, n(K, ee)])];
              return j.firstChild && S(j.firstChild) || j.isSelfClosing && C(j.parent) || ce ? de.push(j.isSelfClosing ? " " : "") : de.push(Q.bracketSameLine ? j.isSelfClosing ? " " : "" : j.isSelfClosing ? u : i), de;
            }
            function B(L) {
              return L.firstChild && S(L.firstChild) ? "" : J(L);
            }
            function k(L, Q, V) {
              let j = L.getValue();
              return [M(j, Q), b(L, Q, V), j.isSelfClosing ? "" : B(j)];
            }
            function M(L, Q) {
              return L.prev && d(L.prev) ? "" : [R(L, Q), q(L)];
            }
            function R(L, Q) {
              return S(L) ? J(L.parent) : m(L) ? D(L.prev, Q) : "";
            }
            function q(L) {
              switch (L.type) {
                case "ieConditionalComment":
                case "ieConditionalStartComment":
                  return `<!--[if ${L.condition}`;
                case "ieConditionalEndComment":
                  return "<!--<!";
                case "interpolation":
                  return "{{";
                case "docType":
                  return "<!DOCTYPE";
                case "element":
                  if (L.condition)
                    return `<!--[if ${L.condition}]><!--><${L.rawName}`;
                default:
                  return `<${L.rawName}`;
              }
            }
            function J(L) {
              switch (t3(!L.isSelfClosing), L.type) {
                case "ieConditionalComment":
                  return "]>";
                case "element":
                  if (L.condition)
                    return "><!--<![endif]-->";
                default:
                  return ">";
              }
            }
            r.exports = { printClosingTag: E, printClosingTagStart: N, printClosingTagStartMarker: $, printClosingTagEndMarker: D, printClosingTagSuffix: P, printClosingTagEnd: x, needsToBorrowLastChildClosingTagEndMarker: C, needsToBorrowParentClosingTagStartMarker: o, needsToBorrowPrevClosingTagEndMarker: m, printOpeningTag: k, printOpeningTagStart: M, printOpeningTagPrefix: R, printOpeningTagStartMarker: q, printOpeningTagEndMarker: J, needsToBorrowNextOpeningTagStartMarker: d, needsToBorrowParentOpeningTagEndMarker: S };
          } }), bg = te({ "node_modules/parse-srcset/src/parse-srcset.js"(e, r) {
            ne(), function(t3, s) {
              typeof define == "function" && define.amd ? define([], s) : typeof r == "object" && r.exports ? r.exports = s() : t3.parseSrcset = s();
            }(e, function() {
              return function(t3, s) {
                var a = s && s.logger || console;
                function n($) {
                  return $ === " " || $ === "	" || $ === `
` || $ === "\f" || $ === "\r";
                }
                function u($) {
                  var D, T = $.exec(t3.substring(N));
                  if (T)
                    return D = T[0], N += D.length, D;
                }
                for (var i = t3.length, l = /^[ \t\n\r\u000c]+/, p = /^[, \t\n\r\u000c]+/, y = /^[^ \t\n\r\u000c]+/, h = /[,]+$/, g = /^\d+$/, c = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, f, F, _, w, E, N = 0, x = []; ; ) {
                  if (u(p), N >= i)
                    return x;
                  f = u(y), F = [], f.slice(-1) === "," ? (f = f.replace(h, ""), P()) : I();
                }
                function I() {
                  for (u(l), _ = "", w = "in descriptor"; ; ) {
                    if (E = t3.charAt(N), w === "in descriptor")
                      if (n(E))
                        _ && (F.push(_), _ = "", w = "after descriptor");
                      else if (E === ",") {
                        N += 1, _ && F.push(_), P();
                        return;
                      } else if (E === "(")
                        _ = _ + E, w = "in parens";
                      else if (E === "") {
                        _ && F.push(_), P();
                        return;
                      } else
                        _ = _ + E;
                    else if (w === "in parens")
                      if (E === ")")
                        _ = _ + E, w = "in descriptor";
                      else if (E === "") {
                        F.push(_), P();
                        return;
                      } else
                        _ = _ + E;
                    else if (w === "after descriptor" && !n(E))
                      if (E === "") {
                        P();
                        return;
                      } else
                        w = "in descriptor", N -= 1;
                    N += 1;
                  }
                }
                function P() {
                  var $ = false, D, T, m, C, o = {}, d, v, S, b, B;
                  for (C = 0; C < F.length; C++)
                    d = F[C], v = d[d.length - 1], S = d.substring(0, d.length - 1), b = parseInt(S, 10), B = parseFloat(S), g.test(S) && v === "w" ? ((D || T) && ($ = true), b === 0 ? $ = true : D = b) : c.test(S) && v === "x" ? ((D || T || m) && ($ = true), B < 0 ? $ = true : T = B) : g.test(S) && v === "h" ? ((m || T) && ($ = true), b === 0 ? $ = true : m = b) : $ = true;
                  $ ? a && a.error && a.error("Invalid srcset descriptor found in '" + t3 + "' at '" + d + "'.") : (o.url = f, D && (o.w = D), T && (o.d = T), m && (o.h = m), x.push(o));
                }
              };
            });
          } }), Tg = te({ "src/language-html/syntax-attribute.js"(e, r) {
            "use strict";
            ne();
            var t3 = bg(), { builders: { ifBreak: s, join: a, line: n } } = qe();
            function u(l) {
              let p = t3(l, { logger: { error(I) {
                throw new Error(I);
              } } }), y = p.some((I) => {
                let { w: P } = I;
                return P;
              }), h = p.some((I) => {
                let { h: P } = I;
                return P;
              }), g = p.some((I) => {
                let { d: P } = I;
                return P;
              });
              if (y + h + g > 1)
                throw new Error("Mixed descriptor in srcset is not supported");
              let c = y ? "w" : h ? "h" : "d", f = y ? "w" : h ? "h" : "x", F = (I) => Math.max(...I), _ = p.map((I) => I.url), w = F(_.map((I) => I.length)), E = p.map((I) => I[c]).map((I) => I ? I.toString() : ""), N = E.map((I) => {
                let P = I.indexOf(".");
                return P === -1 ? I.length : P;
              }), x = F(N);
              return a([",", n], _.map((I, P) => {
                let $ = [I], D = E[P];
                if (D) {
                  let T = w - I.length + 1, m = x - N[P], C = " ".repeat(T + m);
                  $.push(s(C, " "), D + f);
                }
                return $;
              }));
            }
            function i(l) {
              return l.trim().split(/\s+/).join(" ");
            }
            r.exports = { printImgSrcset: u, printClassNames: i };
          } }), Bg = te({ "src/language-html/syntax-vue.js"(e, r) {
            "use strict";
            ne();
            var { builders: { group: t3 } } = qe();
            function s(i, l) {
              let { left: p, operator: y, right: h } = a(i);
              return [t3(l(`function _(${p}) {}`, { parser: "babel", __isVueForBindingLeft: true })), " ", y, " ", l(h, { parser: "__js_expression" }, { stripTrailingHardline: true })];
            }
            function a(i) {
              let l = /(.*?)\s+(in|of)\s+(.*)/s, p = /,([^,\]}]*)(?:,([^,\]}]*))?$/, y = /^\(|\)$/g, h = i.match(l);
              if (!h)
                return;
              let g = {};
              if (g.for = h[3].trim(), !g.for)
                return;
              let c = h[1].trim().replace(y, ""), f = c.match(p);
              f ? (g.alias = c.replace(p, ""), g.iterator1 = f[1].trim(), f[2] && (g.iterator2 = f[2].trim())) : g.alias = c;
              let F = [g.alias, g.iterator1, g.iterator2];
              if (!F.some((_, w) => !_ && (w === 0 || F.slice(w + 1).some(Boolean))))
                return { left: F.filter(Boolean).join(","), operator: h[2], right: g.for };
            }
            function n(i, l) {
              return l(`function _(${i}) {}`, { parser: "babel", __isVueBindings: true });
            }
            function u(i) {
              let l = /^(?:[\w$]+|\([^)]*\))\s*=>|^function\s*\(/, p = /^[$A-Z_a-z][\w$]*(?:\.[$A-Z_a-z][\w$]*|\['[^']*']|\["[^"]*"]|\[\d+]|\[[$A-Z_a-z][\w$]*])*$/, y = i.trim();
              return l.test(y) || p.test(y);
            }
            r.exports = { isVueEventBindingExpression: u, printVueFor: s, printVueBindings: n };
          } }), Lo = te({ "src/language-html/get-node-content.js"(e, r) {
            "use strict";
            ne();
            var { needsToBorrowParentClosingTagStartMarker: t3, printClosingTagStartMarker: s, needsToBorrowLastChildClosingTagEndMarker: a, printClosingTagEndMarker: n, needsToBorrowParentOpeningTagEndMarker: u, printOpeningTagEndMarker: i } = ur();
            function l(p, y) {
              let h = p.startSourceSpan.end.offset;
              p.firstChild && u(p.firstChild) && (h -= i(p).length);
              let g = p.endSourceSpan.start.offset;
              return p.lastChild && t3(p.lastChild) ? g += s(p, y).length : a(p) && (g -= n(p.lastChild, y).length), y.originalText.slice(h, g);
            }
            r.exports = l;
          } }), Ng = te({ "src/language-html/embed.js"(e, r) {
            "use strict";
            ne();
            var { builders: { breakParent: t3, group: s, hardline: a, indent: n, line: u, fill: i, softline: l }, utils: { mapDoc: p, replaceTextEndOfLine: y } } = qe(), h = su(), { printClosingTag: g, printClosingTagSuffix: c, needsToBorrowPrevClosingTagEndMarker: f, printOpeningTagPrefix: F, printOpeningTag: _ } = ur(), { printImgSrcset: w, printClassNames: E } = Tg(), { printVueFor: N, printVueBindings: x, isVueEventBindingExpression: I } = Bg(), { isScriptLikeTag: P, isVueNonHtmlBlock: $, inferScriptParser: D, htmlTrimPreserveIndentation: T, dedentString: m, unescapeQuoteEntities: C, isVueSlotAttribute: o, isVueSfcBindingsAttribute: d, getTextValueParts: v } = Rt(), S = Lo();
            function b(k, M, R) {
              let q = (ee) => new RegExp(ee.join("|")).test(k.fullName), J = () => C(k.value), L = false, Q = (ee, ce) => {
                let W = ee.type === "NGRoot" ? ee.node.type === "NGMicrosyntax" && ee.node.body.length === 1 && ee.node.body[0].type === "NGMicrosyntaxExpression" ? ee.node.body[0].expression : ee.node : ee.type === "JsExpressionRoot" ? ee.node : ee;
                W && (W.type === "ObjectExpression" || W.type === "ArrayExpression" || ce.parser === "__vue_expression" && (W.type === "TemplateLiteral" || W.type === "StringLiteral")) && (L = true);
              }, V = (ee) => s(ee), j = function(ee) {
                let ce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return s([n([l, ee]), ce ? l : ""]);
              }, Y = (ee) => L ? V(ee) : j(ee), ie = (ee, ce) => M(ee, Object.assign({ __onHtmlBindingRoot: Q, __embeddedInHtml: true }, ce));
              if (k.fullName === "srcset" && (k.parent.fullName === "img" || k.parent.fullName === "source"))
                return j(w(J()));
              if (k.fullName === "class" && !R.parentParser) {
                let ee = J();
                if (!ee.includes("{{"))
                  return E(ee);
              }
              if (k.fullName === "style" && !R.parentParser) {
                let ee = J();
                if (!ee.includes("{{"))
                  return j(ie(ee, { parser: "css", __isHTMLStyleAttribute: true }));
              }
              if (R.parser === "vue") {
                if (k.fullName === "v-for")
                  return N(J(), ie);
                if (o(k) || d(k, R))
                  return x(J(), ie);
                let ee = ["^@", "^v-on:"], ce = ["^:", "^v-bind:"], W = ["^v-"];
                if (q(ee)) {
                  let K = J(), de = I(K) ? "__js_expression" : R.__should_parse_vue_template_with_ts ? "__vue_ts_event_binding" : "__vue_event_binding";
                  return Y(ie(K, { parser: de }));
                }
                if (q(ce))
                  return Y(ie(J(), { parser: "__vue_expression" }));
                if (q(W))
                  return Y(ie(J(), { parser: "__js_expression" }));
              }
              if (R.parser === "angular") {
                let ee = (z, U) => ie(z, Object.assign(Object.assign({}, U), {}, { trailingComma: "none" })), ce = ["^\\*"], W = ["^\\(.+\\)$", "^on-"], K = ["^\\[.+\\]$", "^bind(on)?-", "^ng-(if|show|hide|class|style)$"], de = ["^i18n(-.+)?$"];
                if (q(W))
                  return Y(ee(J(), { parser: "__ng_action" }));
                if (q(K))
                  return Y(ee(J(), { parser: "__ng_binding" }));
                if (q(de)) {
                  let z = J().trim();
                  return j(i(v(k, z)), !z.includes("@@"));
                }
                if (q(ce))
                  return Y(ee(J(), { parser: "__ng_directive" }));
                let ue = /{{(.+?)}}/s, Fe = J();
                if (ue.test(Fe)) {
                  let z = [];
                  for (let [U, Z] of Fe.split(ue).entries())
                    if (U % 2 === 0)
                      z.push(y(Z));
                    else
                      try {
                        z.push(s(["{{", n([u, ee(Z, { parser: "__ng_interpolation", __isInHtmlInterpolation: true })]), u, "}}"]));
                      } catch {
                        z.push("{{", y(Z), "}}");
                      }
                  return s(z);
                }
              }
              return null;
            }
            function B(k, M, R, q) {
              let J = k.getValue();
              switch (J.type) {
                case "element": {
                  if (P(J) || J.type === "interpolation")
                    return;
                  if (!J.isSelfClosing && $(J, q)) {
                    let L = D(J, q);
                    if (!L)
                      return;
                    let Q = S(J, q), V = /^\s*$/.test(Q), j = "";
                    return V || (j = R(T(Q), { parser: L, __embeddedInHtml: true }, { stripTrailingHardline: true }), V = j === ""), [F(J, q), s(_(k, q, M)), V ? "" : a, j, V ? "" : a, g(J, q), c(J, q)];
                  }
                  break;
                }
                case "text": {
                  if (P(J.parent)) {
                    let L = D(J.parent, q);
                    if (L) {
                      let Q = L === "markdown" ? m(J.value.replace(/^[^\S\n]*\n/, "")) : J.value, V = { parser: L, __embeddedInHtml: true };
                      if (q.parser === "html" && L === "babel") {
                        let j = "script", { attrMap: Y } = J.parent;
                        Y && (Y.type === "module" || Y.type === "text/babel" && Y["data-type"] === "module") && (j = "module"), V.__babelSourceType = j;
                      }
                      return [t3, F(J, q), R(Q, V, { stripTrailingHardline: true }), c(J, q)];
                    }
                  } else if (J.parent.type === "interpolation") {
                    let L = { __isInHtmlInterpolation: true, __embeddedInHtml: true };
                    return q.parser === "angular" ? (L.parser = "__ng_interpolation", L.trailingComma = "none") : q.parser === "vue" ? L.parser = q.__should_parse_vue_template_with_ts ? "__vue_ts_expression" : "__vue_expression" : L.parser = "__js_expression", [n([u, R(J.value, L, { stripTrailingHardline: true })]), J.parent.next && f(J.parent.next) ? " " : u];
                  }
                  break;
                }
                case "attribute": {
                  if (!J.value)
                    break;
                  if (/^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(q.originalText.slice(J.valueSpan.start.offset, J.valueSpan.end.offset)))
                    return [J.rawName, "=", J.value];
                  if (q.parser === "lwc" && /^{.*}$/s.test(q.originalText.slice(J.valueSpan.start.offset, J.valueSpan.end.offset)))
                    return [J.rawName, "=", J.value];
                  let L = b(J, (Q, V) => R(Q, Object.assign({ __isInHtmlAttribute: true, __embeddedInHtml: true }, V), { stripTrailingHardline: true }), q);
                  if (L)
                    return [J.rawName, '="', s(p(L, (Q) => typeof Q == "string" ? Q.replace(/"/g, "&quot;") : Q)), '"'];
                  break;
                }
                case "front-matter":
                  return h(J, R);
              }
            }
            r.exports = B;
          } }), Oo = te({ "src/language-html/print/children.js"(e, r) {
            "use strict";
            ne();
            var { builders: { breakParent: t3, group: s, ifBreak: a, line: n, softline: u, hardline: i }, utils: { replaceTextEndOfLine: l } } = qe(), { locStart: p, locEnd: y } = au(), { forceBreakChildren: h, forceNextEmptyLine: g, isTextLikeNode: c, hasPrettierIgnore: f, preferHardlineAsLeadingSpaces: F } = Rt(), { printOpeningTagPrefix: _, needsToBorrowNextOpeningTagStartMarker: w, printOpeningTagStartMarker: E, needsToBorrowPrevClosingTagEndMarker: N, printClosingTagEndMarker: x, printClosingTagSuffix: I, needsToBorrowParentClosingTagStartMarker: P } = ur();
            function $(m, C, o) {
              let d = m.getValue();
              return f(d) ? [_(d, C), ...l(C.originalText.slice(p(d) + (d.prev && w(d.prev) ? E(d).length : 0), y(d) - (d.next && N(d.next) ? x(d, C).length : 0))), I(d, C)] : o();
            }
            function D(m, C) {
              return c(m) && c(C) ? m.isTrailingSpaceSensitive ? m.hasTrailingSpaces ? F(C) ? i : n : "" : F(C) ? i : u : w(m) && (f(C) || C.firstChild || C.isSelfClosing || C.type === "element" && C.attrs.length > 0) || m.type === "element" && m.isSelfClosing && N(C) ? "" : !C.isLeadingSpaceSensitive || F(C) || N(C) && m.lastChild && P(m.lastChild) && m.lastChild.lastChild && P(m.lastChild.lastChild) ? i : C.hasLeadingSpaces ? n : u;
            }
            function T(m, C, o) {
              let d = m.getValue();
              if (h(d))
                return [t3, ...m.map((S) => {
                  let b = S.getValue(), B = b.prev ? D(b.prev, b) : "";
                  return [B ? [B, g(b.prev) ? i : ""] : "", $(S, C, o)];
                }, "children")];
              let v = d.children.map(() => Symbol(""));
              return m.map((S, b) => {
                let B = S.getValue();
                if (c(B)) {
                  if (B.prev && c(B.prev)) {
                    let Q = D(B.prev, B);
                    if (Q)
                      return g(B.prev) ? [i, i, $(S, C, o)] : [Q, $(S, C, o)];
                  }
                  return $(S, C, o);
                }
                let k = [], M = [], R = [], q = [], J = B.prev ? D(B.prev, B) : "", L = B.next ? D(B, B.next) : "";
                return J && (g(B.prev) ? k.push(i, i) : J === i ? k.push(i) : c(B.prev) ? M.push(J) : M.push(a("", u, { groupId: v[b - 1] }))), L && (g(B) ? c(B.next) && q.push(i, i) : L === i ? c(B.next) && q.push(i) : R.push(L)), [...k, s([...M, s([$(S, C, o), ...R], { id: v[b] })]), ...q];
              }, "children");
            }
            r.exports = { printChildren: T };
          } }), wg = te({ "src/language-html/print/element.js"(e, r) {
            "use strict";
            ne();
            var { builders: { breakParent: t3, dedentToRoot: s, group: a, ifBreak: n, indentIfBreak: u, indent: i, line: l, softline: p }, utils: { replaceTextEndOfLine: y } } = qe(), h = Lo(), { shouldPreserveContent: g, isScriptLikeTag: c, isVueCustomBlock: f, countParents: F, forceBreakContent: _ } = Rt(), { printOpeningTagPrefix: w, printOpeningTag: E, printClosingTagSuffix: N, printClosingTag: x, needsToBorrowPrevClosingTagEndMarker: I, needsToBorrowLastChildClosingTagEndMarker: P } = ur(), { printChildren: $ } = Oo();
            function D(T, m, C) {
              let o = T.getValue();
              if (g(o, m))
                return [w(o, m), a(E(T, m, C)), ...y(h(o, m)), ...x(o, m), N(o, m)];
              let d = o.children.length === 1 && o.firstChild.type === "interpolation" && o.firstChild.isLeadingSpaceSensitive && !o.firstChild.hasLeadingSpaces && o.lastChild.isTrailingSpaceSensitive && !o.lastChild.hasTrailingSpaces, v = Symbol("element-attr-group-id"), S = (M) => a([a(E(T, m, C), { id: v }), M, x(o, m)]), b = (M) => d ? u(M, { groupId: v }) : (c(o) || f(o, m)) && o.parent.type === "root" && m.parser === "vue" && !m.vueIndentScriptAndStyle ? M : i(M), B = () => d ? n(p, "", { groupId: v }) : o.firstChild.hasLeadingSpaces && o.firstChild.isLeadingSpaceSensitive ? l : o.firstChild.type === "text" && o.isWhitespaceSensitive && o.isIndentationSensitive ? s(p) : p, k = () => (o.next ? I(o.next) : P(o.parent)) ? o.lastChild.hasTrailingSpaces && o.lastChild.isTrailingSpaceSensitive ? " " : "" : d ? n(p, "", { groupId: v }) : o.lastChild.hasTrailingSpaces && o.lastChild.isTrailingSpaceSensitive ? l : (o.lastChild.type === "comment" || o.lastChild.type === "text" && o.isWhitespaceSensitive && o.isIndentationSensitive) && new RegExp(`\\n[\\t ]{${m.tabWidth * F(T, (R) => R.parent && R.parent.type !== "root")}}$`).test(o.lastChild.value) ? "" : p;
              return o.children.length === 0 ? S(o.hasDanglingSpaces && o.isDanglingSpaceSensitive ? l : "") : S([_(o) ? t3 : "", b([B(), $(T, m, C)]), k()]);
            }
            r.exports = { printElement: D };
          } }), _g = te({ "src/language-html/printer-html.js"(e, r) {
            "use strict";
            ne();
            var { builders: { fill: t3, group: s, hardline: a, literalline: n }, utils: { cleanDoc: u, getDocParts: i, isConcat: l, replaceTextEndOfLine: p } } = qe(), y = gg(), { countChars: h, unescapeQuoteEntities: g, getTextValueParts: c } = Rt(), f = Sg(), { insertPragma: F } = xg(), { locStart: _, locEnd: w } = au(), E = Ng(), { printClosingTagSuffix: N, printClosingTagEnd: x, printOpeningTagPrefix: I, printOpeningTagStart: P } = ur(), { printElement: $ } = wg(), { printChildren: D } = Oo();
            function T(m, C, o) {
              let d = m.getValue();
              switch (d.type) {
                case "front-matter":
                  return p(d.raw);
                case "root":
                  return C.__onHtmlRoot && C.__onHtmlRoot(d), [s(D(m, C, o)), a];
                case "element":
                case "ieConditionalComment":
                  return $(m, C, o);
                case "ieConditionalStartComment":
                case "ieConditionalEndComment":
                  return [P(d), x(d)];
                case "interpolation":
                  return [P(d, C), ...m.map(o, "children"), x(d, C)];
                case "text": {
                  if (d.parent.type === "interpolation") {
                    let S = /\n[^\S\n]*$/, b = S.test(d.value), B = b ? d.value.replace(S, "") : d.value;
                    return [...p(B), b ? a : ""];
                  }
                  let v = u([I(d, C), ...c(d), N(d, C)]);
                  return l(v) || v.type === "fill" ? t3(i(v)) : v;
                }
                case "docType":
                  return [s([P(d, C), " ", d.value.replace(/^html\b/i, "html").replace(/\s+/g, " ")]), x(d, C)];
                case "comment":
                  return [I(d, C), ...p(C.originalText.slice(_(d), w(d)), n), N(d, C)];
                case "attribute": {
                  if (d.value === null)
                    return d.rawName;
                  let v = g(d.value), S = h(v, "'"), b = h(v, '"'), B = S < b ? "'" : '"';
                  return [d.rawName, "=", B, ...p(B === '"' ? v.replace(/"/g, "&quot;") : v.replace(/'/g, "&apos;")), B];
                }
                default:
                  throw new Error(`Unexpected node type ${d.type}`);
              }
            }
            r.exports = { preprocess: f, print: T, insertPragma: F, massageAstNode: y, embed: E };
          } }), Pg = te({ "src/language-html/options.js"(e, r) {
            "use strict";
            ne();
            var t3 = Mt(), s = "HTML";
            r.exports = { bracketSameLine: t3.bracketSameLine, htmlWhitespaceSensitivity: { since: "1.15.0", category: s, type: "choice", default: "css", description: "How to handle whitespaces in HTML.", choices: [{ value: "css", description: "Respect the default value of CSS display property." }, { value: "strict", description: "Whitespaces are considered sensitive." }, { value: "ignore", description: "Whitespaces are considered insensitive." }] }, singleAttributePerLine: t3.singleAttributePerLine, vueIndentScriptAndStyle: { since: "1.19.0", category: s, type: "boolean", default: false, description: "Indent script and style tags in Vue files." } };
          } }), Ig = te({ "src/language-html/parsers.js"() {
            ne();
          } }), On = te({ "node_modules/linguist-languages/data/HTML.json"(e, r) {
            r.exports = { name: "HTML", type: "markup", tmScope: "text.html.basic", aceMode: "html", codemirrorMode: "htmlmixed", codemirrorMimeType: "text/html", color: "#e34c26", aliases: ["xhtml"], extensions: [".html", ".hta", ".htm", ".html.hl", ".inc", ".xht", ".xhtml"], languageId: 146 };
          } }), kg = te({ "node_modules/linguist-languages/data/Vue.json"(e, r) {
            r.exports = { name: "Vue", type: "markup", color: "#41b883", extensions: [".vue"], tmScope: "text.html.vue", aceMode: "html", languageId: 391 };
          } }), Lg = te({ "src/language-html/index.js"(e, r) {
            "use strict";
            ne();
            var t3 = _t(), s = _g(), a = Pg(), n = Ig(), u = [t3(On(), () => ({ name: "Angular", since: "1.15.0", parsers: ["angular"], vscodeLanguageIds: ["html"], extensions: [".component.html"], filenames: [] })), t3(On(), (l) => ({ since: "1.15.0", parsers: ["html"], vscodeLanguageIds: ["html"], extensions: [...l.extensions, ".mjml"] })), t3(On(), () => ({ name: "Lightning Web Components", since: "1.17.0", parsers: ["lwc"], vscodeLanguageIds: ["html"], extensions: [], filenames: [] })), t3(kg(), () => ({ since: "1.10.0", parsers: ["vue"], vscodeLanguageIds: ["vue"] }))], i = { html: s };
            r.exports = { languages: u, printers: i, options: a, parsers: n };
          } }), Og = te({ "src/language-yaml/pragma.js"(e, r) {
            "use strict";
            ne();
            function t3(n) {
              return /^\s*@(?:prettier|format)\s*$/.test(n);
            }
            function s(n) {
              return /^\s*#[^\S\n]*@(?:prettier|format)\s*?(?:\n|$)/.test(n);
            }
            function a(n) {
              return `# @format

${n}`;
            }
            r.exports = { isPragma: t3, hasPragma: s, insertPragma: a };
          } }), jg = te({ "src/language-yaml/loc.js"(e, r) {
            "use strict";
            ne();
            function t3(a) {
              return a.position.start.offset;
            }
            function s(a) {
              return a.position.end.offset;
            }
            r.exports = { locStart: t3, locEnd: s };
          } }), qg = te({ "src/language-yaml/embed.js"(e, r) {
            "use strict";
            ne();
            function t3(s, a, n, u) {
              if (s.getValue().type === "root" && u.filepath && /(?:[/\\]|^)\.(?:prettier|stylelint|lintstaged)rc$/.test(u.filepath))
                return n(u.originalText, Object.assign(Object.assign({}, u), {}, { parser: "json" }));
            }
            r.exports = t3;
          } }), $t = te({ "src/language-yaml/utils.js"(e, r) {
            "use strict";
            ne();
            var { getLast: t3, isNonEmptyArray: s } = Ue();
            function a(D, T) {
              let m = 0, C = D.stack.length - 1;
              for (let o = 0; o < C; o++) {
                let d = D.stack[o];
                n(d) && T(d) && m++;
              }
              return m;
            }
            function n(D, T) {
              return D && typeof D.type == "string" && (!T || T.includes(D.type));
            }
            function u(D, T, m) {
              return T("children" in D ? Object.assign(Object.assign({}, D), {}, { children: D.children.map((C) => u(C, T, D)) }) : D, m);
            }
            function i(D, T, m) {
              Object.defineProperty(D, T, { get: m, enumerable: false });
            }
            function l(D, T) {
              let m = 0, C = T.length;
              for (let o = D.position.end.offset - 1; o < C; o++) {
                let d = T[o];
                if (d === `
` && m++, m === 1 && /\S/.test(d))
                  return false;
                if (m === 2)
                  return true;
              }
              return false;
            }
            function p(D) {
              switch (D.getValue().type) {
                case "tag":
                case "anchor":
                case "comment":
                  return false;
              }
              let m = D.stack.length;
              for (let C = 1; C < m; C++) {
                let o = D.stack[C], d = D.stack[C - 1];
                if (Array.isArray(d) && typeof o == "number" && o !== d.length - 1)
                  return false;
              }
              return true;
            }
            function y(D) {
              return s(D.children) ? y(t3(D.children)) : D;
            }
            function h(D) {
              return D.value.trim() === "prettier-ignore";
            }
            function g(D) {
              let T = D.getValue();
              if (T.type === "documentBody") {
                let m = D.getParentNode();
                return N(m.head) && h(t3(m.head.endComments));
              }
              return F(T) && h(t3(T.leadingComments));
            }
            function c(D) {
              return !s(D.children) && !f(D);
            }
            function f(D) {
              return F(D) || _(D) || w(D) || E(D) || N(D);
            }
            function F(D) {
              return s(D == null ? void 0 : D.leadingComments);
            }
            function _(D) {
              return s(D == null ? void 0 : D.middleComments);
            }
            function w(D) {
              return D == null ? void 0 : D.indicatorComment;
            }
            function E(D) {
              return D == null ? void 0 : D.trailingComment;
            }
            function N(D) {
              return s(D == null ? void 0 : D.endComments);
            }
            function x(D) {
              let T = [], m;
              for (let C of D.split(/( +)/))
                C !== " " ? m === " " ? T.push(C) : T.push((T.pop() || "") + C) : m === void 0 && T.unshift(""), m = C;
              return m === " " && T.push((T.pop() || "") + " "), T[0] === "" && (T.shift(), T.unshift(" " + (T.shift() || ""))), T;
            }
            function I(D, T, m) {
              let C = T.split(`
`).map((o, d, v) => d === 0 && d === v.length - 1 ? o : d !== 0 && d !== v.length - 1 ? o.trim() : d === 0 ? o.trimEnd() : o.trimStart());
              return m.proseWrap === "preserve" ? C.map((o) => o.length === 0 ? [] : [o]) : C.map((o) => o.length === 0 ? [] : x(o)).reduce((o, d, v) => v !== 0 && C[v - 1].length > 0 && d.length > 0 && !(D === "quoteDouble" && t3(t3(o)).endsWith("\\")) ? [...o.slice(0, -1), [...t3(o), ...d]] : [...o, d], []).map((o) => m.proseWrap === "never" ? [o.join(" ")] : o);
            }
            function P(D, T) {
              let { parentIndent: m, isLastDescendant: C, options: o } = T, d = D.position.start.line === D.position.end.line ? "" : o.originalText.slice(D.position.start.offset, D.position.end.offset).match(/^[^\n]*\n(.*)$/s)[1], v;
              if (D.indent === null) {
                let B = d.match(/^(?<leadingSpace> *)[^\n\r ]/m);
                v = B ? B.groups.leadingSpace.length : Number.POSITIVE_INFINITY;
              } else
                v = D.indent - 1 + m;
              let S = d.split(`
`).map((B) => B.slice(v));
              if (o.proseWrap === "preserve" || D.type === "blockLiteral")
                return b(S.map((B) => B.length === 0 ? [] : [B]));
              return b(S.map((B) => B.length === 0 ? [] : x(B)).reduce((B, k, M) => M !== 0 && S[M - 1].length > 0 && k.length > 0 && !/^\s/.test(k[0]) && !/^\s|\s$/.test(t3(B)) ? [...B.slice(0, -1), [...t3(B), ...k]] : [...B, k], []).map((B) => B.reduce((k, M) => k.length > 0 && /\s$/.test(t3(k)) ? [...k.slice(0, -1), t3(k) + " " + M] : [...k, M], [])).map((B) => o.proseWrap === "never" ? [B.join(" ")] : B));
              function b(B) {
                if (D.chomping === "keep")
                  return t3(B).length === 0 ? B.slice(0, -1) : B;
                let k = 0;
                for (let M = B.length - 1; M >= 0 && B[M].length === 0; M--)
                  k++;
                return k === 0 ? B : k >= 2 && !C ? B.slice(0, -(k - 1)) : B.slice(0, -k);
              }
            }
            function $(D) {
              if (!D)
                return true;
              switch (D.type) {
                case "plain":
                case "quoteDouble":
                case "quoteSingle":
                case "alias":
                case "flowMapping":
                case "flowSequence":
                  return true;
                default:
                  return false;
              }
            }
            r.exports = { getLast: t3, getAncestorCount: a, isNode: n, isEmptyNode: c, isInlineNode: $, mapNode: u, defineShortcut: i, isNextLineEmpty: l, isLastDescendantNode: p, getBlockValueLineContents: P, getFlowScalarLineContents: I, getLastDescendantNode: y, hasPrettierIgnore: g, hasLeadingComments: F, hasMiddleComments: _, hasIndicatorComment: w, hasTrailingComment: E, hasEndComments: N };
          } }), Mg = te({ "src/language-yaml/print-preprocess.js"(e, r) {
            "use strict";
            ne();
            var { defineShortcut: t3, mapNode: s } = $t();
            function a(u) {
              return s(u, n);
            }
            function n(u) {
              switch (u.type) {
                case "document":
                  t3(u, "head", () => u.children[0]), t3(u, "body", () => u.children[1]);
                  break;
                case "documentBody":
                case "sequenceItem":
                case "flowSequenceItem":
                case "mappingKey":
                case "mappingValue":
                  t3(u, "content", () => u.children[0]);
                  break;
                case "mappingItem":
                case "flowMappingItem":
                  t3(u, "key", () => u.children[0]), t3(u, "value", () => u.children[1]);
                  break;
              }
              return u;
            }
            r.exports = a;
          } }), Mr = te({ "src/language-yaml/print/misc.js"(e, r) {
            "use strict";
            ne();
            var { builders: { softline: t3, align: s } } = qe(), { hasEndComments: a, isNextLineEmpty: n, isNode: u } = $t(), i = /* @__PURE__ */ new WeakMap();
            function l(h, g) {
              let c = h.getValue(), f = h.stack[0], F;
              return i.has(f) ? F = i.get(f) : (F = /* @__PURE__ */ new Set(), i.set(f, F)), !F.has(c.position.end.line) && (F.add(c.position.end.line), n(c, g) && !p(h.getParentNode())) ? t3 : "";
            }
            function p(h) {
              return a(h) && !u(h, ["documentHead", "documentBody", "flowMapping", "flowSequence"]);
            }
            function y(h, g) {
              return s(" ".repeat(h), g);
            }
            r.exports = { alignWithSpaces: y, shouldPrintEndComments: p, printNextEmptyLine: l };
          } }), Rg = te({ "src/language-yaml/print/flow-mapping-sequence.js"(e, r) {
            "use strict";
            ne();
            var { builders: { ifBreak: t3, line: s, softline: a, hardline: n, join: u } } = qe(), { isEmptyNode: i, getLast: l, hasEndComments: p } = $t(), { printNextEmptyLine: y, alignWithSpaces: h } = Mr();
            function g(f, F, _) {
              let w = f.getValue(), E = w.type === "flowMapping", N = E ? "{" : "[", x = E ? "}" : "]", I = a;
              E && w.children.length > 0 && _.bracketSpacing && (I = s);
              let P = l(w.children), $ = P && P.type === "flowMappingItem" && i(P.key) && i(P.value);
              return [N, h(_.tabWidth, [I, c(f, F, _), _.trailingComma === "none" ? "" : t3(","), p(w) ? [n, u(n, f.map(F, "endComments"))] : ""]), $ ? "" : I, x];
            }
            function c(f, F, _) {
              let w = f.getValue();
              return f.map((N, x) => [F(), x === w.children.length - 1 ? "" : [",", s, w.children[x].position.start.line !== w.children[x + 1].position.start.line ? y(N, _.originalText) : ""]], "children");
            }
            r.exports = { printFlowMapping: g, printFlowSequence: g };
          } }), $g = te({ "src/language-yaml/print/mapping-item.js"(e, r) {
            "use strict";
            ne();
            var { builders: { conditionalGroup: t3, group: s, hardline: a, ifBreak: n, join: u, line: i } } = qe(), { hasLeadingComments: l, hasMiddleComments: p, hasTrailingComment: y, hasEndComments: h, isNode: g, isEmptyNode: c, isInlineNode: f } = $t(), { alignWithSpaces: F } = Mr();
            function _(x, I, P, $, D) {
              let { key: T, value: m } = x, C = c(T), o = c(m);
              if (C && o)
                return ": ";
              let d = $("key"), v = E(x) ? " " : "";
              if (o)
                return x.type === "flowMappingItem" && I.type === "flowMapping" ? d : x.type === "mappingItem" && w(T.content, D) && !y(T.content) && (!I.tag || I.tag.value !== "tag:yaml.org,2002:set") ? [d, v, ":"] : ["? ", F(2, d)];
              let S = $("value");
              if (C)
                return [": ", F(2, S)];
              if (l(m) || !f(T.content))
                return ["? ", F(2, d), a, u("", P.map($, "value", "leadingComments").map((q) => [q, a])), ": ", F(2, S)];
              if (N(T.content) && !l(T.content) && !p(T.content) && !y(T.content) && !h(T) && !l(m.content) && !p(m.content) && !h(m) && w(m.content, D))
                return [d, v, ": ", S];
              let b = Symbol("mappingKey"), B = s([n("? "), s(F(2, d), { id: b })]), k = [a, ": ", F(2, S)], M = [v, ":"];
              l(m.content) || h(m) && m.content && !g(m.content, ["mapping", "sequence"]) || I.type === "mapping" && y(T.content) && f(m.content) || g(m.content, ["mapping", "sequence"]) && m.content.tag === null && m.content.anchor === null ? M.push(a) : m.content && M.push(i), M.push(S);
              let R = F(D.tabWidth, M);
              return w(T.content, D) && !l(T.content) && !p(T.content) && !h(T) ? t3([[d, R]]) : t3([[B, n(k, R, { groupId: b })]]);
            }
            function w(x, I) {
              if (!x)
                return true;
              switch (x.type) {
                case "plain":
                case "quoteSingle":
                case "quoteDouble":
                  break;
                case "alias":
                  return true;
                default:
                  return false;
              }
              if (I.proseWrap === "preserve")
                return x.position.start.line === x.position.end.line;
              if (/\\$/m.test(I.originalText.slice(x.position.start.offset, x.position.end.offset)))
                return false;
              switch (I.proseWrap) {
                case "never":
                  return !x.value.includes(`
`);
                case "always":
                  return !/[\n ]/.test(x.value);
                default:
                  return false;
              }
            }
            function E(x) {
              return x.key.content && x.key.content.type === "alias";
            }
            function N(x) {
              if (!x)
                return true;
              switch (x.type) {
                case "plain":
                case "quoteDouble":
                case "quoteSingle":
                  return x.position.start.line === x.position.end.line;
                case "alias":
                  return true;
                default:
                  return false;
              }
            }
            r.exports = _;
          } }), Vg = te({ "src/language-yaml/print/block.js"(e, r) {
            "use strict";
            ne();
            var { builders: { dedent: t3, dedentToRoot: s, fill: a, hardline: n, join: u, line: i, literalline: l, markAsRoot: p }, utils: { getDocParts: y } } = qe(), { getAncestorCount: h, getBlockValueLineContents: g, hasIndicatorComment: c, isLastDescendantNode: f, isNode: F } = $t(), { alignWithSpaces: _ } = Mr();
            function w(E, N, x) {
              let I = E.getValue(), P = h(E, (C) => F(C, ["sequence", "mapping"])), $ = f(E), D = [I.type === "blockFolded" ? ">" : "|"];
              I.indent !== null && D.push(I.indent.toString()), I.chomping !== "clip" && D.push(I.chomping === "keep" ? "+" : "-"), c(I) && D.push(" ", N("indicatorComment"));
              let T = g(I, { parentIndent: P, isLastDescendant: $, options: x }), m = [];
              for (let [C, o] of T.entries())
                C === 0 && m.push(n), m.push(a(y(u(i, o)))), C !== T.length - 1 ? m.push(o.length === 0 ? n : p(l)) : I.chomping === "keep" && $ && m.push(s(o.length === 0 ? n : l));
              return I.indent === null ? D.push(t3(_(x.tabWidth, m))) : D.push(s(_(I.indent - 1 + P, m))), D;
            }
            r.exports = w;
          } }), Wg = te({ "src/language-yaml/printer-yaml.js"(e, r) {
            "use strict";
            ne();
            var { builders: { breakParent: t3, fill: s, group: a, hardline: n, join: u, line: i, lineSuffix: l, literalline: p }, utils: { getDocParts: y, replaceTextEndOfLine: h } } = qe(), { isPreviousLineEmpty: g } = Ue(), { insertPragma: c, isPragma: f } = Og(), { locStart: F } = jg(), _ = qg(), { getFlowScalarLineContents: w, getLastDescendantNode: E, hasLeadingComments: N, hasMiddleComments: x, hasTrailingComment: I, hasEndComments: P, hasPrettierIgnore: $, isLastDescendantNode: D, isNode: T, isInlineNode: m } = $t(), C = Mg(), { alignWithSpaces: o, printNextEmptyLine: d, shouldPrintEndComments: v } = Mr(), { printFlowMapping: S, printFlowSequence: b } = Rg(), B = $g(), k = Vg();
            function M(j, Y, ie) {
              let ee = j.getValue(), ce = [];
              ee.type !== "mappingValue" && N(ee) && ce.push([u(n, j.map(ie, "leadingComments")), n]);
              let { tag: W, anchor: K } = ee;
              W && ce.push(ie("tag")), W && K && ce.push(" "), K && ce.push(ie("anchor"));
              let de = "";
              T(ee, ["mapping", "sequence", "comment", "directive", "mappingItem", "sequenceItem"]) && !D(j) && (de = d(j, Y.originalText)), (W || K) && (T(ee, ["sequence", "mapping"]) && !x(ee) ? ce.push(n) : ce.push(" ")), x(ee) && ce.push([ee.middleComments.length === 1 ? "" : n, u(n, j.map(ie, "middleComments")), n]);
              let ue = j.getParentNode();
              return $(j) ? ce.push(h(Y.originalText.slice(ee.position.start.offset, ee.position.end.offset).trimEnd(), p)) : ce.push(a(R(ee, ue, j, Y, ie))), I(ee) && !T(ee, ["document", "documentHead"]) && ce.push(l([ee.type === "mappingValue" && !ee.content ? "" : " ", ue.type === "mappingKey" && j.getParentNode(2).type === "mapping" && m(ee) ? "" : t3, ie("trailingComment")])), v(ee) && ce.push(o(ee.type === "sequenceItem" ? 2 : 0, [n, u(n, j.map((Fe) => [g(Y.originalText, Fe.getValue(), F) ? n : "", ie()], "endComments"))])), ce.push(de), ce;
            }
            function R(j, Y, ie, ee, ce) {
              switch (j.type) {
                case "root": {
                  let { children: W } = j, K = [];
                  ie.each((ue, Fe) => {
                    let z = W[Fe], U = W[Fe + 1];
                    Fe !== 0 && K.push(n), K.push(ce()), J(z, U) ? (K.push(n, "..."), I(z) && K.push(" ", ce("trailingComment"))) : U && !I(U.head) && K.push(n, "---");
                  }, "children");
                  let de = E(j);
                  return (!T(de, ["blockLiteral", "blockFolded"]) || de.chomping !== "keep") && K.push(n), K;
                }
                case "document": {
                  let W = Y.children[ie.getName() + 1], K = [];
                  return L(j, W, Y, ee) === "head" && ((j.head.children.length > 0 || j.head.endComments.length > 0) && K.push(ce("head")), I(j.head) ? K.push(["---", " ", ce(["head", "trailingComment"])]) : K.push("---")), q(j) && K.push(ce("body")), u(n, K);
                }
                case "documentHead":
                  return u(n, [...ie.map(ce, "children"), ...ie.map(ce, "endComments")]);
                case "documentBody": {
                  let { children: W, endComments: K } = j, de = "";
                  if (W.length > 0 && K.length > 0) {
                    let ue = E(j);
                    T(ue, ["blockFolded", "blockLiteral"]) ? ue.chomping !== "keep" && (de = [n, n]) : de = n;
                  }
                  return [u(n, ie.map(ce, "children")), de, u(n, ie.map(ce, "endComments"))];
                }
                case "directive":
                  return ["%", u(" ", [j.name, ...j.parameters])];
                case "comment":
                  return ["#", j.value];
                case "alias":
                  return ["*", j.value];
                case "tag":
                  return ee.originalText.slice(j.position.start.offset, j.position.end.offset);
                case "anchor":
                  return ["&", j.value];
                case "plain":
                  return Q(j.type, ee.originalText.slice(j.position.start.offset, j.position.end.offset), ee);
                case "quoteDouble":
                case "quoteSingle": {
                  let W = "'", K = '"', de = ee.originalText.slice(j.position.start.offset + 1, j.position.end.offset - 1);
                  if (j.type === "quoteSingle" && de.includes("\\") || j.type === "quoteDouble" && /\\[^"]/.test(de)) {
                    let Fe = j.type === "quoteDouble" ? K : W;
                    return [Fe, Q(j.type, de, ee), Fe];
                  }
                  if (de.includes(K))
                    return [W, Q(j.type, j.type === "quoteDouble" ? de.replace(/\\"/g, K).replace(/'/g, W.repeat(2)) : de, ee), W];
                  if (de.includes(W))
                    return [K, Q(j.type, j.type === "quoteSingle" ? de.replace(/''/g, W) : de, ee), K];
                  let ue = ee.singleQuote ? W : K;
                  return [ue, Q(j.type, de, ee), ue];
                }
                case "blockFolded":
                case "blockLiteral":
                  return k(ie, ce, ee);
                case "mapping":
                case "sequence":
                  return u(n, ie.map(ce, "children"));
                case "sequenceItem":
                  return ["- ", o(2, j.content ? ce("content") : "")];
                case "mappingKey":
                case "mappingValue":
                  return j.content ? ce("content") : "";
                case "mappingItem":
                case "flowMappingItem":
                  return B(j, Y, ie, ce, ee);
                case "flowMapping":
                  return S(ie, ce, ee);
                case "flowSequence":
                  return b(ie, ce, ee);
                case "flowSequenceItem":
                  return ce("content");
                default:
                  throw new Error(`Unexpected node type ${j.type}`);
              }
            }
            function q(j) {
              return j.body.children.length > 0 || P(j.body);
            }
            function J(j, Y) {
              return I(j) || Y && (Y.head.children.length > 0 || P(Y.head));
            }
            function L(j, Y, ie, ee) {
              return ie.children[0] === j && /---(?:\s|$)/.test(ee.originalText.slice(F(j), F(j) + 4)) || j.head.children.length > 0 || P(j.head) || I(j.head) ? "head" : J(j, Y) ? false : Y ? "root" : false;
            }
            function Q(j, Y, ie) {
              let ee = w(j, Y, ie);
              return u(n, ee.map((ce) => s(y(u(i, ce)))));
            }
            function V(j, Y) {
              if (T(Y))
                switch (delete Y.position, Y.type) {
                  case "comment":
                    if (f(Y.value))
                      return null;
                    break;
                  case "quoteDouble":
                  case "quoteSingle":
                    Y.type = "quote";
                    break;
                }
            }
            r.exports = { preprocess: C, embed: _, print: M, massageAstNode: V, insertPragma: c };
          } }), Hg = te({ "src/language-yaml/options.js"(e, r) {
            "use strict";
            ne();
            var t3 = Mt();
            r.exports = { bracketSpacing: t3.bracketSpacing, singleQuote: t3.singleQuote, proseWrap: t3.proseWrap };
          } }), Gg = te({ "src/language-yaml/parsers.js"() {
            ne();
          } }), Ug = te({ "node_modules/linguist-languages/data/YAML.json"(e, r) {
            r.exports = { name: "YAML", type: "data", color: "#cb171e", tmScope: "source.yaml", aliases: ["yml"], extensions: [".yml", ".mir", ".reek", ".rviz", ".sublime-syntax", ".syntax", ".yaml", ".yaml-tmlanguage", ".yaml.sed", ".yml.mysql"], filenames: [".clang-format", ".clang-tidy", ".gemrc", "CITATION.cff", "glide.lock", "yarn.lock"], aceMode: "yaml", codemirrorMode: "yaml", codemirrorMimeType: "text/x-yaml", languageId: 407 };
          } }), Jg = te({ "src/language-yaml/index.js"(e, r) {
            "use strict";
            ne();
            var t3 = _t(), s = Wg(), a = Hg(), n = Gg(), u = [t3(Ug(), (i) => ({ since: "1.14.0", parsers: ["yaml"], vscodeLanguageIds: ["yaml", "ansible", "home-assistant"], filenames: [...i.filenames.filter((l) => l !== "yarn.lock"), ".prettierrc", ".stylelintrc", ".lintstagedrc"] }))];
            r.exports = { languages: u, printers: { yaml: s }, options: a, parsers: n };
          } }), zg = te({ "src/languages.js"(e, r) {
            "use strict";
            ne(), r.exports = [Bd(), Ud(), eg(), ag(), dg(), Lg(), Jg()];
          } });
          ne();
          var { version: Xg } = Ia(), Ot = Gm(), { getSupportInfo: Kg } = Xn(), Yg = Um(), Qg = zg(), Zg = qe();
          function Nt(e) {
            let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
            return function() {
              for (var t3 = arguments.length, s = new Array(t3), a = 0; a < t3; a++)
                s[a] = arguments[a];
              let n = s[r] || {}, u = n.plugins || [];
              return s[r] = Object.assign(Object.assign({}, n), {}, { plugins: [...Qg, ...Array.isArray(u) ? u : Object.values(u)] }), e(...s);
            };
          }
          var jn = Nt(Ot.formatWithCursor);
          jo.exports = { formatWithCursor: jn, format(e, r) {
            return jn(e, r).formatted;
          }, check(e, r) {
            let { formatted: t3 } = jn(e, r);
            return t3 === e;
          }, doc: Zg, getSupportInfo: Nt(Kg, 0), version: Xg, util: Yg, __debug: { parse: Nt(Ot.parse), formatAST: Nt(Ot.formatAST), formatDoc: Nt(Ot.formatDoc), printToDoc: Nt(Ot.printToDoc), printDocToString: Nt(Ot.printDocToString) } };
        });
        return e0();
      });
    }
  });

  // ../../node_modules/.pnpm/prettier@2.8.8/node_modules/prettier/parser-babel.js
  var require_parser_babel = __commonJS({
    "../../node_modules/.pnpm/prettier@2.8.8/node_modules/prettier/parser-babel.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      (function(e) {
        if (typeof exports8 == "object" && typeof module2 == "object")
          module2.exports = e();
        else if (typeof define == "function" && define.amd)
          define(e);
        else {
          var i = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : typeof self < "u" ? self : this || {};
          i.prettierPlugins = i.prettierPlugins || {}, i.prettierPlugins.babel = e();
        }
      })(function() {
        "use strict";
        var E = (l, h) => () => (h || l((h = { exports: {} }).exports, h), h.exports);
        var re = E((xd, Zr) => {
          var Ct = function(l) {
            return l && l.Math == Math && l;
          };
          Zr.exports = Ct(typeof globalThis == "object" && globalThis) || Ct(typeof window == "object" && window) || Ct(typeof self == "object" && self) || Ct(typeof global == "object" && global) || function() {
            return this;
          }() || Function("return this")();
        });
        var ie = E((gd, ei) => {
          ei.exports = function(l) {
            try {
              return !!l();
            } catch {
              return true;
            }
          };
        });
        var ye = E((Pd, ti) => {
          var kh = ie();
          ti.exports = !kh(function() {
            return Object.defineProperty({}, 1, { get: function() {
              return 7;
            } })[1] != 7;
          });
        });
        var bt = E((Ad, si) => {
          var Dh = ie();
          si.exports = !Dh(function() {
            var l = function() {
            }.bind();
            return typeof l != "function" || l.hasOwnProperty("prototype");
          });
        });
        var wt = E((Td, ri) => {
          var Fh = bt(), St = Function.prototype.call;
          ri.exports = Fh ? St.bind(St) : function() {
            return St.apply(St, arguments);
          };
        });
        var oi = E((ni) => {
          "use strict";
          var ii = {}.propertyIsEnumerable, ai = Object.getOwnPropertyDescriptor, Lh = ai && !ii.call({ 1: 2 }, 1);
          ni.f = Lh ? function(h) {
            var p = ai(this, h);
            return !!p && p.enumerable;
          } : ii;
        });
        var fs = E((Ed, li) => {
          li.exports = function(l, h) {
            return { enumerable: !(l & 1), configurable: !(l & 2), writable: !(l & 4), value: h };
          };
        });
        var ae = E((Cd, ci) => {
          var hi = bt(), ui = Function.prototype, ds = ui.call, Oh = hi && ui.bind.bind(ds, ds);
          ci.exports = hi ? Oh : function(l) {
            return function() {
              return ds.apply(l, arguments);
            };
          };
        });
        var Ye = E((bd, fi) => {
          var pi = ae(), Bh = pi({}.toString), Mh = pi("".slice);
          fi.exports = function(l) {
            return Mh(Bh(l), 8, -1);
          };
        });
        var mi = E((Sd, di) => {
          var _h = ae(), Rh = ie(), jh = Ye(), ms = Object, qh = _h("".split);
          di.exports = Rh(function() {
            return !ms("z").propertyIsEnumerable(0);
          }) ? function(l) {
            return jh(l) == "String" ? qh(l, "") : ms(l);
          } : ms;
        });
        var ys = E((wd, yi) => {
          yi.exports = function(l) {
            return l == null;
          };
        });
        var xs = E((Id, xi) => {
          var Uh = ys(), $h = TypeError;
          xi.exports = function(l) {
            if (Uh(l))
              throw $h("Can't call method on " + l);
            return l;
          };
        });
        var It = E((Nd, gi) => {
          var Hh = mi(), zh = xs();
          gi.exports = function(l) {
            return Hh(zh(l));
          };
        });
        var Ps = E((kd, Pi) => {
          var gs = typeof document == "object" && document.all, Vh = typeof gs > "u" && gs !== void 0;
          Pi.exports = { all: gs, IS_HTMLDDA: Vh };
        });
        var ee = E((Dd, Ti) => {
          var Ai = Ps(), Kh = Ai.all;
          Ti.exports = Ai.IS_HTMLDDA ? function(l) {
            return typeof l == "function" || l === Kh;
          } : function(l) {
            return typeof l == "function";
          };
        });
        var Ie = E((Fd, Ci) => {
          var vi = ee(), Ei = Ps(), Wh = Ei.all;
          Ci.exports = Ei.IS_HTMLDDA ? function(l) {
            return typeof l == "object" ? l !== null : vi(l) || l === Wh;
          } : function(l) {
            return typeof l == "object" ? l !== null : vi(l);
          };
        });
        var Qe = E((Ld, bi) => {
          var As = re(), Gh = ee(), Jh = function(l) {
            return Gh(l) ? l : void 0;
          };
          bi.exports = function(l, h) {
            return arguments.length < 2 ? Jh(As[l]) : As[l] && As[l][h];
          };
        });
        var wi = E((Od, Si) => {
          var Xh = ae();
          Si.exports = Xh({}.isPrototypeOf);
        });
        var Ni = E((Bd, Ii) => {
          var Yh = Qe();
          Ii.exports = Yh("navigator", "userAgent") || "";
        });
        var Mi = E((Md, Bi) => {
          var Oi = re(), Ts = Ni(), ki = Oi.process, Di = Oi.Deno, Fi = ki && ki.versions || Di && Di.version, Li = Fi && Fi.v8, ne, Nt;
          Li && (ne = Li.split("."), Nt = ne[0] > 0 && ne[0] < 4 ? 1 : +(ne[0] + ne[1]));
          !Nt && Ts && (ne = Ts.match(/Edge\/(\d+)/), (!ne || ne[1] >= 74) && (ne = Ts.match(/Chrome\/(\d+)/), ne && (Nt = +ne[1])));
          Bi.exports = Nt;
        });
        var vs = E((_d, Ri) => {
          var _i = Mi(), Qh = ie();
          Ri.exports = !!Object.getOwnPropertySymbols && !Qh(function() {
            var l = Symbol();
            return !String(l) || !(Object(l) instanceof Symbol) || !Symbol.sham && _i && _i < 41;
          });
        });
        var Es = E((Rd, ji) => {
          var Zh = vs();
          ji.exports = Zh && !Symbol.sham && typeof Symbol.iterator == "symbol";
        });
        var Cs = E((jd, qi) => {
          var eu = Qe(), tu = ee(), su = wi(), ru = Es(), iu = Object;
          qi.exports = ru ? function(l) {
            return typeof l == "symbol";
          } : function(l) {
            var h = eu("Symbol");
            return tu(h) && su(h.prototype, iu(l));
          };
        });
        var $i = E((qd, Ui) => {
          var au = String;
          Ui.exports = function(l) {
            try {
              return au(l);
            } catch {
              return "Object";
            }
          };
        });
        var kt = E((Ud, Hi) => {
          var nu = ee(), ou = $i(), lu = TypeError;
          Hi.exports = function(l) {
            if (nu(l))
              return l;
            throw lu(ou(l) + " is not a function");
          };
        });
        var Vi = E(($d, zi) => {
          var hu = kt(), uu = ys();
          zi.exports = function(l, h) {
            var p = l[h];
            return uu(p) ? void 0 : hu(p);
          };
        });
        var Wi = E((Hd, Ki) => {
          var bs = wt(), Ss = ee(), ws = Ie(), cu = TypeError;
          Ki.exports = function(l, h) {
            var p, d;
            if (h === "string" && Ss(p = l.toString) && !ws(d = bs(p, l)) || Ss(p = l.valueOf) && !ws(d = bs(p, l)) || h !== "string" && Ss(p = l.toString) && !ws(d = bs(p, l)))
              return d;
            throw cu("Can't convert object to primitive value");
          };
        });
        var Ji = E((zd, Gi) => {
          Gi.exports = false;
        });
        var Dt = E((Vd, Yi) => {
          var Xi = re(), pu = Object.defineProperty;
          Yi.exports = function(l, h) {
            try {
              pu(Xi, l, { value: h, configurable: true, writable: true });
            } catch {
              Xi[l] = h;
            }
            return h;
          };
        });
        var Ft = E((Kd, Zi) => {
          var fu = re(), du = Dt(), Qi = "__core-js_shared__", mu = fu[Qi] || du(Qi, {});
          Zi.exports = mu;
        });
        var Is = E((Wd, ta) => {
          var yu = Ji(), ea = Ft();
          (ta.exports = function(l, h) {
            return ea[l] || (ea[l] = h !== void 0 ? h : {});
          })("versions", []).push({ version: "3.26.1", mode: yu ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE", source: "https://github.com/zloirock/core-js" });
        });
        var Ns = E((Gd, sa) => {
          var xu = xs(), gu = Object;
          sa.exports = function(l) {
            return gu(xu(l));
          };
        });
        var ve = E((Jd, ra) => {
          var Pu = ae(), Au = Ns(), Tu = Pu({}.hasOwnProperty);
          ra.exports = Object.hasOwn || function(h, p) {
            return Tu(Au(h), p);
          };
        });
        var ks = E((Xd, ia) => {
          var vu = ae(), Eu = 0, Cu = Math.random(), bu = vu(1 .toString);
          ia.exports = function(l) {
            return "Symbol(" + (l === void 0 ? "" : l) + ")_" + bu(++Eu + Cu, 36);
          };
        });
        var Ze = E((Yd, ha) => {
          var Su = re(), wu = Is(), aa = ve(), Iu = ks(), na = vs(), la = Es(), qe = wu("wks"), Ne = Su.Symbol, oa = Ne && Ne.for, Nu = la ? Ne : Ne && Ne.withoutSetter || Iu;
          ha.exports = function(l) {
            if (!aa(qe, l) || !(na || typeof qe[l] == "string")) {
              var h = "Symbol." + l;
              na && aa(Ne, l) ? qe[l] = Ne[l] : la && oa ? qe[l] = oa(h) : qe[l] = Nu(h);
            }
            return qe[l];
          };
        });
        var fa = E((Qd, pa) => {
          var ku = wt(), ua = Ie(), ca = Cs(), Du = Vi(), Fu = Wi(), Lu = Ze(), Ou = TypeError, Bu = Lu("toPrimitive");
          pa.exports = function(l, h) {
            if (!ua(l) || ca(l))
              return l;
            var p = Du(l, Bu), d;
            if (p) {
              if (h === void 0 && (h = "default"), d = ku(p, l, h), !ua(d) || ca(d))
                return d;
              throw Ou("Can't convert object to primitive value");
            }
            return h === void 0 && (h = "number"), Fu(l, h);
          };
        });
        var Ds = E((Zd, da) => {
          var Mu = fa(), _u = Cs();
          da.exports = function(l) {
            var h = Mu(l, "string");
            return _u(h) ? h : h + "";
          };
        });
        var xa = E((em, ya) => {
          var Ru = re(), ma = Ie(), Fs = Ru.document, ju = ma(Fs) && ma(Fs.createElement);
          ya.exports = function(l) {
            return ju ? Fs.createElement(l) : {};
          };
        });
        var Ls = E((tm, ga) => {
          var qu = ye(), Uu = ie(), $u = xa();
          ga.exports = !qu && !Uu(function() {
            return Object.defineProperty($u("div"), "a", { get: function() {
              return 7;
            } }).a != 7;
          });
        });
        var Os = E((Aa) => {
          var Hu = ye(), zu = wt(), Vu = oi(), Ku = fs(), Wu = It(), Gu = Ds(), Ju = ve(), Xu = Ls(), Pa = Object.getOwnPropertyDescriptor;
          Aa.f = Hu ? Pa : function(h, p) {
            if (h = Wu(h), p = Gu(p), Xu)
              try {
                return Pa(h, p);
              } catch {
              }
            if (Ju(h, p))
              return Ku(!zu(Vu.f, h, p), h[p]);
          };
        });
        var va = E((rm, Ta) => {
          var Yu = ye(), Qu = ie();
          Ta.exports = Yu && Qu(function() {
            return Object.defineProperty(function() {
            }, "prototype", { value: 42, writable: false }).prototype != 42;
          });
        });
        var Lt = E((im, Ea) => {
          var Zu = Ie(), ec = String, tc = TypeError;
          Ea.exports = function(l) {
            if (Zu(l))
              return l;
            throw tc(ec(l) + " is not an object");
          };
        });
        var et = E((ba) => {
          var sc = ye(), rc = Ls(), ic = va(), Ot = Lt(), Ca = Ds(), ac = TypeError, Bs = Object.defineProperty, nc = Object.getOwnPropertyDescriptor, Ms = "enumerable", _s = "configurable", Rs = "writable";
          ba.f = sc ? ic ? function(h, p, d) {
            if (Ot(h), p = Ca(p), Ot(d), typeof h == "function" && p === "prototype" && "value" in d && Rs in d && !d[Rs]) {
              var x = nc(h, p);
              x && x[Rs] && (h[p] = d.value, d = { configurable: _s in d ? d[_s] : x[_s], enumerable: Ms in d ? d[Ms] : x[Ms], writable: false });
            }
            return Bs(h, p, d);
          } : Bs : function(h, p, d) {
            if (Ot(h), p = Ca(p), Ot(d), rc)
              try {
                return Bs(h, p, d);
              } catch {
              }
            if ("get" in d || "set" in d)
              throw ac("Accessors not supported");
            return "value" in d && (h[p] = d.value), h;
          };
        });
        var js = E((nm2, Sa) => {
          var oc = ye(), lc = et(), hc = fs();
          Sa.exports = oc ? function(l, h, p) {
            return lc.f(l, h, hc(1, p));
          } : function(l, h, p) {
            return l[h] = p, l;
          };
        });
        var Na = E((om, Ia) => {
          var qs = ye(), uc = ve(), wa = Function.prototype, cc = qs && Object.getOwnPropertyDescriptor, Us = uc(wa, "name"), pc = Us && function() {
          }.name === "something", fc = Us && (!qs || qs && cc(wa, "name").configurable);
          Ia.exports = { EXISTS: Us, PROPER: pc, CONFIGURABLE: fc };
        });
        var Hs = E((lm, ka) => {
          var dc = ae(), mc = ee(), $s = Ft(), yc = dc(Function.toString);
          mc($s.inspectSource) || ($s.inspectSource = function(l) {
            return yc(l);
          });
          ka.exports = $s.inspectSource;
        });
        var La = E((hm, Fa) => {
          var xc = re(), gc = ee(), Da = xc.WeakMap;
          Fa.exports = gc(Da) && /native code/.test(String(Da));
        });
        var Ma = E((um, Ba) => {
          var Pc = Is(), Ac = ks(), Oa = Pc("keys");
          Ba.exports = function(l) {
            return Oa[l] || (Oa[l] = Ac(l));
          };
        });
        var zs = E((cm, _a) => {
          _a.exports = {};
        });
        var Ua = E((pm, qa) => {
          var Tc = La(), ja = re(), vc = Ie(), Ec = js(), Vs = ve(), Ks = Ft(), Cc = Ma(), bc = zs(), Ra = "Object already initialized", Ws = ja.TypeError, Sc = ja.WeakMap, Bt, tt, Mt, wc = function(l) {
            return Mt(l) ? tt(l) : Bt(l, {});
          }, Ic = function(l) {
            return function(h) {
              var p;
              if (!vc(h) || (p = tt(h)).type !== l)
                throw Ws("Incompatible receiver, " + l + " required");
              return p;
            };
          };
          Tc || Ks.state ? (oe = Ks.state || (Ks.state = new Sc()), oe.get = oe.get, oe.has = oe.has, oe.set = oe.set, Bt = function(l, h) {
            if (oe.has(l))
              throw Ws(Ra);
            return h.facade = l, oe.set(l, h), h;
          }, tt = function(l) {
            return oe.get(l) || {};
          }, Mt = function(l) {
            return oe.has(l);
          }) : (ke = Cc("state"), bc[ke] = true, Bt = function(l, h) {
            if (Vs(l, ke))
              throw Ws(Ra);
            return h.facade = l, Ec(l, ke, h), h;
          }, tt = function(l) {
            return Vs(l, ke) ? l[ke] : {};
          }, Mt = function(l) {
            return Vs(l, ke);
          });
          var oe, ke;
          qa.exports = { set: Bt, get: tt, has: Mt, enforce: wc, getterFor: Ic };
        });
        var Js = E((fm, Ha) => {
          var Nc = ie(), kc = ee(), _t = ve(), Gs = ye(), Dc = Na().CONFIGURABLE, Fc = Hs(), $a = Ua(), Lc = $a.enforce, Oc = $a.get, Rt = Object.defineProperty, Bc = Gs && !Nc(function() {
            return Rt(function() {
            }, "length", { value: 8 }).length !== 8;
          }), Mc = String(String).split("String"), _c = Ha.exports = function(l, h, p) {
            String(h).slice(0, 7) === "Symbol(" && (h = "[" + String(h).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), p && p.getter && (h = "get " + h), p && p.setter && (h = "set " + h), (!_t(l, "name") || Dc && l.name !== h) && (Gs ? Rt(l, "name", { value: h, configurable: true }) : l.name = h), Bc && p && _t(p, "arity") && l.length !== p.arity && Rt(l, "length", { value: p.arity });
            try {
              p && _t(p, "constructor") && p.constructor ? Gs && Rt(l, "prototype", { writable: false }) : l.prototype && (l.prototype = void 0);
            } catch {
            }
            var d = Lc(l);
            return _t(d, "source") || (d.source = Mc.join(typeof h == "string" ? h : "")), l;
          };
          Function.prototype.toString = _c(function() {
            return kc(this) && Oc(this).source || Fc(this);
          }, "toString");
        });
        var Va = E((dm, za) => {
          var Rc = ee(), jc = et(), qc = Js(), Uc = Dt();
          za.exports = function(l, h, p, d) {
            d || (d = {});
            var x = d.enumerable, P = d.name !== void 0 ? d.name : h;
            if (Rc(p) && qc(p, P, d), d.global)
              x ? l[h] = p : Uc(h, p);
            else {
              try {
                d.unsafe ? l[h] && (x = true) : delete l[h];
              } catch {
              }
              x ? l[h] = p : jc.f(l, h, { value: p, enumerable: false, configurable: !d.nonConfigurable, writable: !d.nonWritable });
            }
            return l;
          };
        });
        var Wa = E((mm, Ka) => {
          var $c = Math.ceil, Hc = Math.floor;
          Ka.exports = Math.trunc || function(h) {
            var p = +h;
            return (p > 0 ? Hc : $c)(p);
          };
        });
        var Xs = E((ym, Ga) => {
          var zc = Wa();
          Ga.exports = function(l) {
            var h = +l;
            return h !== h || h === 0 ? 0 : zc(h);
          };
        });
        var Xa = E((xm, Ja) => {
          var Vc = Xs(), Kc = Math.max, Wc = Math.min;
          Ja.exports = function(l, h) {
            var p = Vc(l);
            return p < 0 ? Kc(p + h, 0) : Wc(p, h);
          };
        });
        var Qa = E((gm, Ya) => {
          var Gc = Xs(), Jc = Math.min;
          Ya.exports = function(l) {
            return l > 0 ? Jc(Gc(l), 9007199254740991) : 0;
          };
        });
        var jt = E((Pm, Za) => {
          var Xc = Qa();
          Za.exports = function(l) {
            return Xc(l.length);
          };
        });
        var sn = E((Am, tn) => {
          var Yc = It(), Qc = Xa(), Zc = jt(), en = function(l) {
            return function(h, p, d) {
              var x = Yc(h), P = Zc(x), m = Qc(d, P), v;
              if (l && p != p) {
                for (; P > m; )
                  if (v = x[m++], v != v)
                    return true;
              } else
                for (; P > m; m++)
                  if ((l || m in x) && x[m] === p)
                    return l || m || 0;
              return !l && -1;
            };
          };
          tn.exports = { includes: en(true), indexOf: en(false) };
        });
        var nn = E((Tm, an) => {
          var ep = ae(), Ys = ve(), tp = It(), sp = sn().indexOf, rp = zs(), rn = ep([].push);
          an.exports = function(l, h) {
            var p = tp(l), d = 0, x = [], P;
            for (P in p)
              !Ys(rp, P) && Ys(p, P) && rn(x, P);
            for (; h.length > d; )
              Ys(p, P = h[d++]) && (~sp(x, P) || rn(x, P));
            return x;
          };
        });
        var ln = E((vm, on3) => {
          on3.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        });
        var un = E((hn) => {
          var ip = nn(), ap = ln(), np = ap.concat("length", "prototype");
          hn.f = Object.getOwnPropertyNames || function(h) {
            return ip(h, np);
          };
        });
        var pn = E((cn) => {
          cn.f = Object.getOwnPropertySymbols;
        });
        var dn = E((bm, fn) => {
          var op = Qe(), lp = ae(), hp = un(), up = pn(), cp = Lt(), pp = lp([].concat);
          fn.exports = op("Reflect", "ownKeys") || function(h) {
            var p = hp.f(cp(h)), d = up.f;
            return d ? pp(p, d(h)) : p;
          };
        });
        var xn = E((Sm, yn) => {
          var mn = ve(), fp = dn(), dp = Os(), mp = et();
          yn.exports = function(l, h, p) {
            for (var d = fp(h), x = mp.f, P = dp.f, m = 0; m < d.length; m++) {
              var v = d[m];
              !mn(l, v) && !(p && mn(p, v)) && x(l, v, P(h, v));
            }
          };
        });
        var Pn = E((wm, gn) => {
          var yp = ie(), xp = ee(), gp = /#|\.prototype\./, st = function(l, h) {
            var p = Ap[Pp(l)];
            return p == vp ? true : p == Tp ? false : xp(h) ? yp(h) : !!h;
          }, Pp = st.normalize = function(l) {
            return String(l).replace(gp, ".").toLowerCase();
          }, Ap = st.data = {}, Tp = st.NATIVE = "N", vp = st.POLYFILL = "P";
          gn.exports = st;
        });
        var Zs = E((Im, An) => {
          var Qs = re(), Ep = Os().f, Cp = js(), bp = Va(), Sp = Dt(), wp = xn(), Ip = Pn();
          An.exports = function(l, h) {
            var p = l.target, d = l.global, x = l.stat, P, m, v, S, k, F;
            if (d ? m = Qs : x ? m = Qs[p] || Sp(p, {}) : m = (Qs[p] || {}).prototype, m)
              for (v in h) {
                if (k = h[v], l.dontCallGetSet ? (F = Ep(m, v), S = F && F.value) : S = m[v], P = Ip(d ? v : p + (x ? "." : "#") + v, l.forced), !P && S !== void 0) {
                  if (typeof k == typeof S)
                    continue;
                  wp(k, S);
                }
                (l.sham || S && S.sham) && Cp(k, "sham", true), bp(m, v, k, l);
              }
          };
        });
        var Tn = E(() => {
          var Np = Zs(), er = re();
          Np({ global: true, forced: er.globalThis !== er }, { globalThis: er });
        });
        var vn = E(() => {
          Tn();
        });
        var bn = E((Lm, Cn) => {
          var En = Js(), kp = et();
          Cn.exports = function(l, h, p) {
            return p.get && En(p.get, h, { getter: true }), p.set && En(p.set, h, { setter: true }), kp.f(l, h, p);
          };
        });
        var wn = E((Om, Sn) => {
          "use strict";
          var Dp = Lt();
          Sn.exports = function() {
            var l = Dp(this), h = "";
            return l.hasIndices && (h += "d"), l.global && (h += "g"), l.ignoreCase && (h += "i"), l.multiline && (h += "m"), l.dotAll && (h += "s"), l.unicode && (h += "u"), l.unicodeSets && (h += "v"), l.sticky && (h += "y"), h;
          };
        });
        var kn = E(() => {
          var Fp = re(), Lp = ye(), Op = bn(), Bp = wn(), Mp = ie(), In = Fp.RegExp, Nn = In.prototype, _p = Lp && Mp(function() {
            var l = true;
            try {
              In(".", "d");
            } catch {
              l = false;
            }
            var h = {}, p = "", d = l ? "dgimsy" : "gimsy", x = function(S, k) {
              Object.defineProperty(h, S, { get: function() {
                return p += k, true;
              } });
            }, P = { dotAll: "s", global: "g", ignoreCase: "i", multiline: "m", sticky: "y" };
            l && (P.hasIndices = "d");
            for (var m in P)
              x(m, P[m]);
            var v = Object.getOwnPropertyDescriptor(Nn, "flags").get.call(h);
            return v !== d || p !== d;
          });
          _p && Op(Nn, "flags", { configurable: true, get: Bp });
        });
        var tr = E((_m, Dn) => {
          var Rp = Ye();
          Dn.exports = Array.isArray || function(h) {
            return Rp(h) == "Array";
          };
        });
        var Ln = E((Rm, Fn) => {
          var jp = TypeError, qp = 9007199254740991;
          Fn.exports = function(l) {
            if (l > qp)
              throw jp("Maximum allowed index exceeded");
            return l;
          };
        });
        var Bn = E((jm, On) => {
          var Up = Ye(), $p = ae();
          On.exports = function(l) {
            if (Up(l) === "Function")
              return $p(l);
          };
        });
        var Rn = E((qm, _n) => {
          var Mn = Bn(), Hp = kt(), zp = bt(), Vp = Mn(Mn.bind);
          _n.exports = function(l, h) {
            return Hp(l), h === void 0 ? l : zp ? Vp(l, h) : function() {
              return l.apply(h, arguments);
            };
          };
        });
        var Un = E((Um, qn) => {
          "use strict";
          var Kp = tr(), Wp = jt(), Gp = Ln(), Jp = Rn(), jn = function(l, h, p, d, x, P, m, v) {
            for (var S = x, k = 0, F = m ? Jp(m, v) : false, w, L; k < d; )
              k in p && (w = F ? F(p[k], k, h) : p[k], P > 0 && Kp(w) ? (L = Wp(w), S = jn(l, h, w, L, S, P - 1) - 1) : (Gp(S + 1), l[S] = w), S++), k++;
            return S;
          };
          qn.exports = jn;
        });
        var zn = E(($m, Hn) => {
          var Xp = Ze(), Yp = Xp("toStringTag"), $n = {};
          $n[Yp] = "z";
          Hn.exports = String($n) === "[object z]";
        });
        var Kn = E((Hm, Vn) => {
          var Qp = zn(), Zp = ee(), qt = Ye(), ef = Ze(), tf = ef("toStringTag"), sf = Object, rf = qt(function() {
            return arguments;
          }()) == "Arguments", af = function(l, h) {
            try {
              return l[h];
            } catch {
            }
          };
          Vn.exports = Qp ? qt : function(l) {
            var h, p, d;
            return l === void 0 ? "Undefined" : l === null ? "Null" : typeof (p = af(h = sf(l), tf)) == "string" ? p : rf ? qt(h) : (d = qt(h)) == "Object" && Zp(h.callee) ? "Arguments" : d;
          };
        });
        var Qn = E((zm, Yn) => {
          var nf = ae(), of = ie(), Wn = ee(), lf = Kn(), hf = Qe(), uf = Hs(), Gn = function() {
          }, cf = [], Jn = hf("Reflect", "construct"), sr = /^\s*(?:class|function)\b/, pf = nf(sr.exec), ff = !sr.exec(Gn), rt = function(h) {
            if (!Wn(h))
              return false;
            try {
              return Jn(Gn, cf, h), true;
            } catch {
              return false;
            }
          }, Xn = function(h) {
            if (!Wn(h))
              return false;
            switch (lf(h)) {
              case "AsyncFunction":
              case "GeneratorFunction":
              case "AsyncGeneratorFunction":
                return false;
            }
            try {
              return ff || !!pf(sr, uf(h));
            } catch {
              return true;
            }
          };
          Xn.sham = true;
          Yn.exports = !Jn || of(function() {
            var l;
            return rt(rt.call) || !rt(Object) || !rt(function() {
              l = true;
            }) || l;
          }) ? Xn : rt;
        });
        var so = E((Vm, to) => {
          var Zn = tr(), df = Qn(), mf = Ie(), yf = Ze(), xf = yf("species"), eo = Array;
          to.exports = function(l) {
            var h;
            return Zn(l) && (h = l.constructor, df(h) && (h === eo || Zn(h.prototype)) ? h = void 0 : mf(h) && (h = h[xf], h === null && (h = void 0))), h === void 0 ? eo : h;
          };
        });
        var io = E((Km, ro) => {
          var gf = so();
          ro.exports = function(l, h) {
            return new (gf(l))(h === 0 ? 0 : h);
          };
        });
        var ao = E(() => {
          "use strict";
          var Pf = Zs(), Af = Un(), Tf = kt(), vf = Ns(), Ef = jt(), Cf = io();
          Pf({ target: "Array", proto: true }, { flatMap: function(h) {
            var p = vf(this), d = Ef(p), x;
            return Tf(h), x = Cf(p, 0), x.length = Af(x, p, p, d, 0, 1, h, arguments.length > 1 ? arguments[1] : void 0), x;
          } });
        });
        var md = E((ty, Oo) => {
          vn();
          kn();
          ao();
          var nr = Object.defineProperty, bf = Object.getOwnPropertyDescriptor, or = Object.getOwnPropertyNames, Sf = Object.prototype.hasOwnProperty, co = (l, h) => function() {
            return l && (h = (0, l[or(l)[0]])(l = 0)), h;
          }, $ = (l, h) => function() {
            return h || (0, l[or(l)[0]])((h = { exports: {} }).exports, h), h.exports;
          }, wf = (l, h) => {
            for (var p in h)
              nr(l, p, { get: h[p], enumerable: true });
          }, If = (l, h, p, d) => {
            if (h && typeof h == "object" || typeof h == "function")
              for (let x of or(h))
                !Sf.call(l, x) && x !== p && nr(l, x, { get: () => h[x], enumerable: !(d = bf(h, x)) || d.enumerable });
            return l;
          }, Nf = (l) => If(nr({}, "__esModule", { value: true }), l), U = co({ "<define:process>"() {
          } }), kf = $({ "src/utils/try-combinations.js"(l, h) {
            "use strict";
            U();
            function p() {
              let d;
              for (var x = arguments.length, P = new Array(x), m = 0; m < x; m++)
                P[m] = arguments[m];
              for (let [v, S] of P.entries())
                try {
                  return { result: S() };
                } catch (k) {
                  v === 0 && (d = k);
                }
              return { error: d };
            }
            h.exports = p;
          } }), po = $({ "src/language-js/utils/get-shebang.js"(l, h) {
            "use strict";
            U();
            function p(d) {
              if (!d.startsWith("#!"))
                return "";
              let x = d.indexOf(`
`);
              return x === -1 ? d : d.slice(0, x);
            }
            h.exports = p;
          } }), Df = $({ "src/utils/text/skip-inline-comment.js"(l, h) {
            "use strict";
            U();
            function p(d, x) {
              if (x === false)
                return false;
              if (d.charAt(x) === "/" && d.charAt(x + 1) === "*") {
                for (let P = x + 2; P < d.length; ++P)
                  if (d.charAt(P) === "*" && d.charAt(P + 1) === "/")
                    return P + 2;
              }
              return x;
            }
            h.exports = p;
          } }), Ff = $({ "src/utils/text/skip-newline.js"(l, h) {
            "use strict";
            U();
            function p(d, x, P) {
              let m = P && P.backwards;
              if (x === false)
                return false;
              let v = d.charAt(x);
              if (m) {
                if (d.charAt(x - 1) === "\r" && v === `
`)
                  return x - 2;
                if (v === `
` || v === "\r" || v === "\u2028" || v === "\u2029")
                  return x - 1;
              } else {
                if (v === "\r" && d.charAt(x + 1) === `
`)
                  return x + 2;
                if (v === `
` || v === "\r" || v === "\u2028" || v === "\u2029")
                  return x + 1;
              }
              return x;
            }
            h.exports = p;
          } }), fo = $({ "src/utils/text/skip.js"(l, h) {
            "use strict";
            U();
            function p(v) {
              return (S, k, F) => {
                let w = F && F.backwards;
                if (k === false)
                  return false;
                let { length: L } = S, A = k;
                for (; A >= 0 && A < L; ) {
                  let _ = S.charAt(A);
                  if (v instanceof RegExp) {
                    if (!v.test(_))
                      return A;
                  } else if (!v.includes(_))
                    return A;
                  w ? A-- : A++;
                }
                return A === -1 || A === L ? A : false;
              };
            }
            var d = p(/\s/), x = p(" 	"), P = p(",; 	"), m = p(/[^\n\r]/);
            h.exports = { skipWhitespace: d, skipSpaces: x, skipToLineEnd: P, skipEverythingButNewLine: m };
          } }), Lf = $({ "src/utils/text/skip-trailing-comment.js"(l, h) {
            "use strict";
            U();
            var { skipEverythingButNewLine: p } = fo();
            function d(x, P) {
              return P === false ? false : x.charAt(P) === "/" && x.charAt(P + 1) === "/" ? p(x, P) : P;
            }
            h.exports = d;
          } }), Of = $({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(l, h) {
            "use strict";
            U();
            var p = Df(), d = Ff(), x = Lf(), { skipSpaces: P } = fo();
            function m(v, S) {
              let k = null, F = S;
              for (; F !== k; )
                k = F, F = P(v, F), F = p(v, F), F = x(v, F), F = d(v, F);
              return F;
            }
            h.exports = m;
          } }), mo = {};
          wf(mo, { EOL: () => ar, arch: () => Bf, cpus: () => vo, default: () => wo, endianness: () => yo, freemem: () => Ao, getNetworkInterfaces: () => So, hostname: () => xo, loadavg: () => go, networkInterfaces: () => bo, platform: () => Mf, release: () => Co, tmpDir: () => rr, tmpdir: () => ir, totalmem: () => To, type: () => Eo, uptime: () => Po });
          function yo() {
            if (typeof Ut > "u") {
              var l = new ArrayBuffer(2), h = new Uint8Array(l), p = new Uint16Array(l);
              if (h[0] = 1, h[1] = 2, p[0] === 258)
                Ut = "BE";
              else if (p[0] === 513)
                Ut = "LE";
              else
                throw new Error("unable to figure out endianess");
            }
            return Ut;
          }
          function xo() {
            return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
          }
          function go() {
            return [];
          }
          function Po() {
            return 0;
          }
          function Ao() {
            return Number.MAX_VALUE;
          }
          function To() {
            return Number.MAX_VALUE;
          }
          function vo() {
            return [];
          }
          function Eo() {
            return "Browser";
          }
          function Co() {
            return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
          }
          function bo() {
          }
          function So() {
          }
          function Bf() {
            return "javascript";
          }
          function Mf() {
            return "browser";
          }
          function rr() {
            return "/tmp";
          }
          var Ut, ir, ar, wo, _f = co({ "node-modules-polyfills:os"() {
            U(), ir = rr, ar = `
`, wo = { EOL: ar, tmpdir: ir, tmpDir: rr, networkInterfaces: bo, getNetworkInterfaces: So, release: Co, type: Eo, cpus: vo, totalmem: To, freemem: Ao, uptime: Po, loadavg: go, hostname: xo, endianness: yo };
          } }), Rf = $({ "node-modules-polyfills-commonjs:os"(l, h) {
            U();
            var p = (_f(), Nf(mo));
            if (p && p.default) {
              h.exports = p.default;
              for (let d in p)
                h.exports[d] = p[d];
            } else
              p && (h.exports = p);
          } }), jf = $({ "node_modules/detect-newline/index.js"(l, h) {
            "use strict";
            U();
            var p = (d) => {
              if (typeof d != "string")
                throw new TypeError("Expected a string");
              let x = d.match(/(?:\r?\n)/g) || [];
              if (x.length === 0)
                return;
              let P = x.filter((v) => v === `\r
`).length, m = x.length - P;
              return P > m ? `\r
` : `
`;
            };
            h.exports = p, h.exports.graceful = (d) => typeof d == "string" && p(d) || `
`;
          } }), qf = $({ "node_modules/jest-docblock/build/index.js"(l) {
            "use strict";
            U(), Object.defineProperty(l, "__esModule", { value: true }), l.extract = A, l.parse = G, l.parseWithComments = N, l.print = O, l.strip = _;
            function h() {
              let R = Rf();
              return h = function() {
                return R;
              }, R;
            }
            function p() {
              let R = d(jf());
              return p = function() {
                return R;
              }, R;
            }
            function d(R) {
              return R && R.__esModule ? R : { default: R };
            }
            var x = /\*\/$/, P = /^\/\*\*?/, m = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, v = /(^|\s+)\/\/([^\r\n]*)/g, S = /^(\r?\n)+/, k = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, F = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, w = /(\r?\n|^) *\* ?/g, L = [];
            function A(R) {
              let z = R.match(m);
              return z ? z[0].trimLeft() : "";
            }
            function _(R) {
              let z = R.match(m);
              return z && z[0] ? R.substring(z[0].length) : R;
            }
            function G(R) {
              return N(R).pragmas;
            }
            function N(R) {
              let z = (0, p().default)(R) || h().EOL;
              R = R.replace(P, "").replace(x, "").replace(w, "$1");
              let Q = "";
              for (; Q !== R; )
                Q = R, R = R.replace(k, `${z}$1 $2${z}`);
              R = R.replace(S, "").trimRight();
              let b = /* @__PURE__ */ Object.create(null), B = R.replace(F, "").replace(S, "").trimRight(), Z;
              for (; Z = F.exec(R); ) {
                let q = Z[2].replace(v, "");
                typeof b[Z[1]] == "string" || Array.isArray(b[Z[1]]) ? b[Z[1]] = L.concat(b[Z[1]], q) : b[Z[1]] = q;
              }
              return { comments: B, pragmas: b };
            }
            function O(R) {
              let { comments: z = "", pragmas: Q = {} } = R, b = (0, p().default)(z) || h().EOL, B = "/**", Z = " *", q = " */", ue = Object.keys(Q), te = ue.map((se) => H(se, Q[se])).reduce((se, He) => se.concat(He), []).map((se) => `${Z} ${se}${b}`).join("");
              if (!z) {
                if (ue.length === 0)
                  return "";
                if (ue.length === 1 && !Array.isArray(Q[ue[0]])) {
                  let se = Q[ue[0]];
                  return `${B} ${H(ue[0], se)[0]}${q}`;
                }
              }
              let it = z.split(b).map((se) => `${Z} ${se}`).join(b) + b;
              return B + b + (z ? it : "") + (z && ue.length ? Z + b : "") + te + q;
            }
            function H(R, z) {
              return L.concat(z).map((Q) => `@${R} ${Q}`.trim());
            }
          } }), Uf = $({ "src/common/end-of-line.js"(l, h) {
            "use strict";
            U();
            function p(m) {
              let v = m.indexOf("\r");
              return v >= 0 ? m.charAt(v + 1) === `
` ? "crlf" : "cr" : "lf";
            }
            function d(m) {
              switch (m) {
                case "cr":
                  return "\r";
                case "crlf":
                  return `\r
`;
                default:
                  return `
`;
              }
            }
            function x(m, v) {
              let S;
              switch (v) {
                case `
`:
                  S = /\n/g;
                  break;
                case "\r":
                  S = /\r/g;
                  break;
                case `\r
`:
                  S = /\r\n/g;
                  break;
                default:
                  throw new Error(`Unexpected "eol" ${JSON.stringify(v)}.`);
              }
              let k = m.match(S);
              return k ? k.length : 0;
            }
            function P(m) {
              return m.replace(/\r\n?/g, `
`);
            }
            h.exports = { guessEndOfLine: p, convertEndOfLineToChars: d, countEndOfLineChars: x, normalizeEndOfLine: P };
          } }), $f = $({ "src/language-js/pragma.js"(l, h) {
            "use strict";
            U();
            var { parseWithComments: p, strip: d, extract: x, print: P } = qf(), { normalizeEndOfLine: m } = Uf(), v = po();
            function S(w) {
              let L = v(w);
              L && (w = w.slice(L.length + 1));
              let A = x(w), { pragmas: _, comments: G } = p(A);
              return { shebang: L, text: w, pragmas: _, comments: G };
            }
            function k(w) {
              let L = Object.keys(S(w).pragmas);
              return L.includes("prettier") || L.includes("format");
            }
            function F(w) {
              let { shebang: L, text: A, pragmas: _, comments: G } = S(w), N = d(A), O = P({ pragmas: Object.assign({ format: "" }, _), comments: G.trimStart() });
              return (L ? `${L}
` : "") + m(O) + (N.startsWith(`
`) ? `
` : `

`) + N;
            }
            h.exports = { hasPragma: k, insertPragma: F };
          } }), Io = $({ "src/utils/is-non-empty-array.js"(l, h) {
            "use strict";
            U();
            function p(d) {
              return Array.isArray(d) && d.length > 0;
            }
            h.exports = p;
          } }), No = $({ "src/language-js/loc.js"(l, h) {
            "use strict";
            U();
            var p = Io();
            function d(S) {
              var k, F;
              let w = S.range ? S.range[0] : S.start, L = (k = (F = S.declaration) === null || F === void 0 ? void 0 : F.decorators) !== null && k !== void 0 ? k : S.decorators;
              return p(L) ? Math.min(d(L[0]), w) : w;
            }
            function x(S) {
              return S.range ? S.range[1] : S.end;
            }
            function P(S, k) {
              let F = d(S);
              return Number.isInteger(F) && F === d(k);
            }
            function m(S, k) {
              let F = x(S);
              return Number.isInteger(F) && F === x(k);
            }
            function v(S, k) {
              return P(S, k) && m(S, k);
            }
            h.exports = { locStart: d, locEnd: x, hasSameLocStart: P, hasSameLoc: v };
          } }), ko = $({ "src/language-js/parse/utils/create-parser.js"(l, h) {
            "use strict";
            U();
            var { hasPragma: p } = $f(), { locStart: d, locEnd: x } = No();
            function P(m) {
              return m = typeof m == "function" ? { parse: m } : m, Object.assign({ astFormat: "estree", hasPragma: p, locStart: d, locEnd: x }, m);
            }
            h.exports = P;
          } }), lr = $({ "src/common/parser-create-error.js"(l, h) {
            "use strict";
            U();
            function p(d, x) {
              let P = new SyntaxError(d + " (" + x.start.line + ":" + x.start.column + ")");
              return P.loc = x, P;
            }
            h.exports = p;
          } }), Do = $({ "src/language-js/parse/utils/create-babel-parse-error.js"(l, h) {
            "use strict";
            U();
            var p = lr();
            function d(x) {
              let { message: P, loc: m } = x;
              return p(P.replace(/ \(.*\)/, ""), { start: { line: m ? m.line : 0, column: m ? m.column + 1 : 0 } });
            }
            h.exports = d;
          } }), Hf = $({ "src/language-js/utils/is-ts-keyword-type.js"(l, h) {
            "use strict";
            U();
            function p(d) {
              let { type: x } = d;
              return x.startsWith("TS") && x.endsWith("Keyword");
            }
            h.exports = p;
          } }), zf = $({ "src/language-js/utils/is-block-comment.js"(l, h) {
            "use strict";
            U();
            var p = /* @__PURE__ */ new Set(["Block", "CommentBlock", "MultiLine"]), d = (x) => p.has(x == null ? void 0 : x.type);
            h.exports = d;
          } }), Vf = $({ "src/language-js/utils/is-type-cast-comment.js"(l, h) {
            "use strict";
            U();
            var p = zf();
            function d(x) {
              return p(x) && x.value[0] === "*" && /@(?:type|satisfies)\b/.test(x.value);
            }
            h.exports = d;
          } }), Kf = $({ "src/utils/get-last.js"(l, h) {
            "use strict";
            U();
            var p = (d) => d[d.length - 1];
            h.exports = p;
          } }), Wf = $({ "src/language-js/parse/postprocess/visit-node.js"(l, h) {
            "use strict";
            U();
            function p(d, x) {
              if (Array.isArray(d)) {
                for (let P = 0; P < d.length; P++)
                  d[P] = p(d[P], x);
                return d;
              }
              if (d && typeof d == "object" && typeof d.type == "string") {
                let P = Object.keys(d);
                for (let m = 0; m < P.length; m++)
                  d[P[m]] = p(d[P[m]], x);
                return x(d) || d;
              }
              return d;
            }
            h.exports = p;
          } }), Gf = $({ "src/language-js/parse/postprocess/throw-syntax-error.js"(l, h) {
            "use strict";
            U();
            var p = lr();
            function d(x, P) {
              let { start: m, end: v } = x.loc;
              throw p(P, { start: { line: m.line, column: m.column + 1 }, end: { line: v.line, column: v.column + 1 } });
            }
            h.exports = d;
          } }), Jf = $({ "src/language-js/parse/postprocess/index.js"(l, h) {
            "use strict";
            U();
            var { locStart: p, locEnd: d } = No(), x = Hf(), P = Vf(), m = Kf(), v = Wf(), S = Gf();
            function k(A, _) {
              if (_.parser !== "typescript" && _.parser !== "flow" && _.parser !== "acorn" && _.parser !== "espree" && _.parser !== "meriyah") {
                let N = /* @__PURE__ */ new Set();
                A = v(A, (O) => {
                  O.leadingComments && O.leadingComments.some(P) && N.add(p(O));
                }), A = v(A, (O) => {
                  if (O.type === "ParenthesizedExpression") {
                    let { expression: H } = O;
                    if (H.type === "TypeCastExpression")
                      return H.range = O.range, H;
                    let R = p(O);
                    if (!N.has(R))
                      return H.extra = Object.assign(Object.assign({}, H.extra), {}, { parenthesized: true }), H;
                  }
                });
              }
              return A = v(A, (N) => {
                switch (N.type) {
                  case "ChainExpression":
                    return F(N.expression);
                  case "LogicalExpression": {
                    if (w(N))
                      return L(N);
                    break;
                  }
                  case "VariableDeclaration": {
                    let O = m(N.declarations);
                    O && O.init && G(N, O);
                    break;
                  }
                  case "TSParenthesizedType":
                    return x(N.typeAnnotation) || N.typeAnnotation.type === "TSThisType" || (N.typeAnnotation.range = [p(N), d(N)]), N.typeAnnotation;
                  case "TSTypeParameter":
                    if (typeof N.name == "string") {
                      let O = p(N);
                      N.name = { type: "Identifier", name: N.name, range: [O, O + N.name.length] };
                    }
                    break;
                  case "ObjectExpression":
                    if (_.parser === "typescript") {
                      let O = N.properties.find((H) => H.type === "Property" && H.value.type === "TSEmptyBodyFunctionExpression");
                      O && S(O.value, "Unexpected token.");
                    }
                    break;
                  case "SequenceExpression": {
                    let O = m(N.expressions);
                    N.range = [p(N), Math.min(d(O), d(N))];
                    break;
                  }
                  case "TopicReference":
                    _.__isUsingHackPipeline = true;
                    break;
                  case "ExportAllDeclaration": {
                    let { exported: O } = N;
                    if (_.parser === "meriyah" && O && O.type === "Identifier") {
                      let H = _.originalText.slice(p(O), d(O));
                      (H.startsWith('"') || H.startsWith("'")) && (N.exported = Object.assign(Object.assign({}, N.exported), {}, { type: "Literal", value: N.exported.name, raw: H }));
                    }
                    break;
                  }
                  case "PropertyDefinition":
                    if (_.parser === "meriyah" && N.static && !N.computed && !N.key) {
                      let O = "static", H = p(N);
                      Object.assign(N, { static: false, key: { type: "Identifier", name: O, range: [H, H + O.length] } });
                    }
                    break;
                }
              }), A;
              function G(N, O) {
                _.originalText[d(O)] !== ";" && (N.range = [p(N), d(O)]);
              }
            }
            function F(A) {
              switch (A.type) {
                case "CallExpression":
                  A.type = "OptionalCallExpression", A.callee = F(A.callee);
                  break;
                case "MemberExpression":
                  A.type = "OptionalMemberExpression", A.object = F(A.object);
                  break;
                case "TSNonNullExpression":
                  A.expression = F(A.expression);
                  break;
              }
              return A;
            }
            function w(A) {
              return A.type === "LogicalExpression" && A.right.type === "LogicalExpression" && A.operator === A.right.operator;
            }
            function L(A) {
              return w(A) ? L({ type: "LogicalExpression", operator: A.operator, left: L({ type: "LogicalExpression", operator: A.operator, left: A.left, right: A.right.left, range: [p(A.left), d(A.right.left)] }), right: A.right.right, range: [p(A), d(A)] }) : A;
            }
            h.exports = k;
          } }), Fo = $({ "node_modules/@babel/parser/lib/index.js"(l) {
            "use strict";
            U(), Object.defineProperty(l, "__esModule", { value: true });
            var h = { sourceType: "script", sourceFilename: void 0, startColumn: 0, startLine: 1, allowAwaitOutsideFunction: false, allowReturnOutsideFunction: false, allowNewTargetOutsideFunction: false, allowImportExportEverywhere: false, allowSuperOutsideMethod: false, allowUndeclaredExports: false, plugins: [], strictMode: null, ranges: false, tokens: false, createParenthesizedExpressions: false, errorRecovery: false, attachComment: true, annexB: true };
            function p(t3) {
              if (t3 && t3.annexB != null && t3.annexB !== false)
                throw new Error("The `annexB` option can only be set to `false`.");
              let r = {};
              for (let e of Object.keys(h))
                r[e] = t3 && t3[e] != null ? t3[e] : h[e];
              return r;
            }
            var d = class {
              constructor(t3, r) {
                this.token = void 0, this.preserveSpace = void 0, this.token = t3, this.preserveSpace = !!r;
              }
            }, x = { brace: new d("{"), j_oTag: new d("<tag"), j_cTag: new d("</tag"), j_expr: new d("<tag>...</tag>", true) };
            x.template = new d("`", true);
            var P = true, m = true, v = true, S = true, k = true, F = true, w = class {
              constructor(t3) {
                let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.label = void 0, this.keyword = void 0, this.beforeExpr = void 0, this.startsExpr = void 0, this.rightAssociative = void 0, this.isLoop = void 0, this.isAssign = void 0, this.prefix = void 0, this.postfix = void 0, this.binop = void 0, this.label = t3, this.keyword = r.keyword, this.beforeExpr = !!r.beforeExpr, this.startsExpr = !!r.startsExpr, this.rightAssociative = !!r.rightAssociative, this.isLoop = !!r.isLoop, this.isAssign = !!r.isAssign, this.prefix = !!r.prefix, this.postfix = !!r.postfix, this.binop = r.binop != null ? r.binop : null, this.updateContext = null;
              }
            }, L = /* @__PURE__ */ new Map();
            function A(t3) {
              let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              r.keyword = t3;
              let e = b(t3, r);
              return L.set(t3, e), e;
            }
            function _(t3, r) {
              return b(t3, { beforeExpr: P, binop: r });
            }
            var G = -1, N = [], O = [], H = [], R = [], z = [], Q = [];
            function b(t3) {
              let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              var e, s, i, a;
              return ++G, O.push(t3), H.push((e = r.binop) != null ? e : -1), R.push((s = r.beforeExpr) != null ? s : false), z.push((i = r.startsExpr) != null ? i : false), Q.push((a = r.prefix) != null ? a : false), N.push(new w(t3, r)), G;
            }
            function B(t3) {
              let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              var e, s, i, a;
              return ++G, L.set(t3, G), O.push(t3), H.push((e = r.binop) != null ? e : -1), R.push((s = r.beforeExpr) != null ? s : false), z.push((i = r.startsExpr) != null ? i : false), Q.push((a = r.prefix) != null ? a : false), N.push(new w("name", r)), G;
            }
            var Z = { bracketL: b("[", { beforeExpr: P, startsExpr: m }), bracketHashL: b("#[", { beforeExpr: P, startsExpr: m }), bracketBarL: b("[|", { beforeExpr: P, startsExpr: m }), bracketR: b("]"), bracketBarR: b("|]"), braceL: b("{", { beforeExpr: P, startsExpr: m }), braceBarL: b("{|", { beforeExpr: P, startsExpr: m }), braceHashL: b("#{", { beforeExpr: P, startsExpr: m }), braceR: b("}"), braceBarR: b("|}"), parenL: b("(", { beforeExpr: P, startsExpr: m }), parenR: b(")"), comma: b(",", { beforeExpr: P }), semi: b(";", { beforeExpr: P }), colon: b(":", { beforeExpr: P }), doubleColon: b("::", { beforeExpr: P }), dot: b("."), question: b("?", { beforeExpr: P }), questionDot: b("?."), arrow: b("=>", { beforeExpr: P }), template: b("template"), ellipsis: b("...", { beforeExpr: P }), backQuote: b("`", { startsExpr: m }), dollarBraceL: b("${", { beforeExpr: P, startsExpr: m }), templateTail: b("...`", { startsExpr: m }), templateNonTail: b("...${", { beforeExpr: P, startsExpr: m }), at: b("@"), hash: b("#", { startsExpr: m }), interpreterDirective: b("#!..."), eq: b("=", { beforeExpr: P, isAssign: S }), assign: b("_=", { beforeExpr: P, isAssign: S }), slashAssign: b("_=", { beforeExpr: P, isAssign: S }), xorAssign: b("_=", { beforeExpr: P, isAssign: S }), moduloAssign: b("_=", { beforeExpr: P, isAssign: S }), incDec: b("++/--", { prefix: k, postfix: F, startsExpr: m }), bang: b("!", { beforeExpr: P, prefix: k, startsExpr: m }), tilde: b("~", { beforeExpr: P, prefix: k, startsExpr: m }), doubleCaret: b("^^", { startsExpr: m }), doubleAt: b("@@", { startsExpr: m }), pipeline: _("|>", 0), nullishCoalescing: _("??", 1), logicalOR: _("||", 1), logicalAND: _("&&", 2), bitwiseOR: _("|", 3), bitwiseXOR: _("^", 4), bitwiseAND: _("&", 5), equality: _("==/!=/===/!==", 6), lt: _("</>/<=/>=", 7), gt: _("</>/<=/>=", 7), relational: _("</>/<=/>=", 7), bitShift: _("<</>>/>>>", 8), bitShiftL: _("<</>>/>>>", 8), bitShiftR: _("<</>>/>>>", 8), plusMin: b("+/-", { beforeExpr: P, binop: 9, prefix: k, startsExpr: m }), modulo: b("%", { binop: 10, startsExpr: m }), star: b("*", { binop: 10 }), slash: _("/", 10), exponent: b("**", { beforeExpr: P, binop: 11, rightAssociative: true }), _in: A("in", { beforeExpr: P, binop: 7 }), _instanceof: A("instanceof", { beforeExpr: P, binop: 7 }), _break: A("break"), _case: A("case", { beforeExpr: P }), _catch: A("catch"), _continue: A("continue"), _debugger: A("debugger"), _default: A("default", { beforeExpr: P }), _else: A("else", { beforeExpr: P }), _finally: A("finally"), _function: A("function", { startsExpr: m }), _if: A("if"), _return: A("return", { beforeExpr: P }), _switch: A("switch"), _throw: A("throw", { beforeExpr: P, prefix: k, startsExpr: m }), _try: A("try"), _var: A("var"), _const: A("const"), _with: A("with"), _new: A("new", { beforeExpr: P, startsExpr: m }), _this: A("this", { startsExpr: m }), _super: A("super", { startsExpr: m }), _class: A("class", { startsExpr: m }), _extends: A("extends", { beforeExpr: P }), _export: A("export"), _import: A("import", { startsExpr: m }), _null: A("null", { startsExpr: m }), _true: A("true", { startsExpr: m }), _false: A("false", { startsExpr: m }), _typeof: A("typeof", { beforeExpr: P, prefix: k, startsExpr: m }), _void: A("void", { beforeExpr: P, prefix: k, startsExpr: m }), _delete: A("delete", { beforeExpr: P, prefix: k, startsExpr: m }), _do: A("do", { isLoop: v, beforeExpr: P }), _for: A("for", { isLoop: v }), _while: A("while", { isLoop: v }), _as: B("as", { startsExpr: m }), _assert: B("assert", { startsExpr: m }), _async: B("async", { startsExpr: m }), _await: B("await", { startsExpr: m }), _from: B("from", { startsExpr: m }), _get: B("get", { startsExpr: m }), _let: B("let", { startsExpr: m }), _meta: B("meta", { startsExpr: m }), _of: B("of", { startsExpr: m }), _sent: B("sent", { startsExpr: m }), _set: B("set", { startsExpr: m }), _static: B("static", { startsExpr: m }), _using: B("using", { startsExpr: m }), _yield: B("yield", { startsExpr: m }), _asserts: B("asserts", { startsExpr: m }), _checks: B("checks", { startsExpr: m }), _exports: B("exports", { startsExpr: m }), _global: B("global", { startsExpr: m }), _implements: B("implements", { startsExpr: m }), _intrinsic: B("intrinsic", { startsExpr: m }), _infer: B("infer", { startsExpr: m }), _is: B("is", { startsExpr: m }), _mixins: B("mixins", { startsExpr: m }), _proto: B("proto", { startsExpr: m }), _require: B("require", { startsExpr: m }), _satisfies: B("satisfies", { startsExpr: m }), _keyof: B("keyof", { startsExpr: m }), _readonly: B("readonly", { startsExpr: m }), _unique: B("unique", { startsExpr: m }), _abstract: B("abstract", { startsExpr: m }), _declare: B("declare", { startsExpr: m }), _enum: B("enum", { startsExpr: m }), _module: B("module", { startsExpr: m }), _namespace: B("namespace", { startsExpr: m }), _interface: B("interface", { startsExpr: m }), _type: B("type", { startsExpr: m }), _opaque: B("opaque", { startsExpr: m }), name: b("name", { startsExpr: m }), string: b("string", { startsExpr: m }), num: b("num", { startsExpr: m }), bigint: b("bigint", { startsExpr: m }), decimal: b("decimal", { startsExpr: m }), regexp: b("regexp", { startsExpr: m }), privateName: b("#name", { startsExpr: m }), eof: b("eof"), jsxName: b("jsxName"), jsxText: b("jsxText", { beforeExpr: true }), jsxTagStart: b("jsxTagStart", { startsExpr: true }), jsxTagEnd: b("jsxTagEnd"), placeholder: b("%%", { startsExpr: true }) };
            function q(t3) {
              return t3 >= 93 && t3 <= 130;
            }
            function ue(t3) {
              return t3 <= 92;
            }
            function te(t3) {
              return t3 >= 58 && t3 <= 130;
            }
            function it(t3) {
              return t3 >= 58 && t3 <= 134;
            }
            function se(t3) {
              return R[t3];
            }
            function He(t3) {
              return z[t3];
            }
            function Bo(t3) {
              return t3 >= 29 && t3 <= 33;
            }
            function hr(t3) {
              return t3 >= 127 && t3 <= 129;
            }
            function Mo(t3) {
              return t3 >= 90 && t3 <= 92;
            }
            function $t(t3) {
              return t3 >= 58 && t3 <= 92;
            }
            function _o(t3) {
              return t3 >= 39 && t3 <= 59;
            }
            function Ro(t3) {
              return t3 === 34;
            }
            function jo(t3) {
              return Q[t3];
            }
            function qo(t3) {
              return t3 >= 119 && t3 <= 121;
            }
            function Uo(t3) {
              return t3 >= 122 && t3 <= 128;
            }
            function xe(t3) {
              return O[t3];
            }
            function at2(t3) {
              return H[t3];
            }
            function $o(t3) {
              return t3 === 57;
            }
            function nt(t3) {
              return t3 >= 24 && t3 <= 25;
            }
            function ce(t3) {
              return N[t3];
            }
            N[8].updateContext = (t3) => {
              t3.pop();
            }, N[5].updateContext = N[7].updateContext = N[23].updateContext = (t3) => {
              t3.push(x.brace);
            }, N[22].updateContext = (t3) => {
              t3[t3.length - 1] === x.template ? t3.pop() : t3.push(x.template);
            }, N[140].updateContext = (t3) => {
              t3.push(x.j_expr, x.j_oTag);
            };
            function ot(t3, r) {
              if (t3 == null)
                return {};
              var e = {}, s = Object.keys(t3), i, a;
              for (a = 0; a < s.length; a++)
                i = s[a], !(r.indexOf(i) >= 0) && (e[i] = t3[i]);
              return e;
            }
            var ge = class {
              constructor(t3, r, e) {
                this.line = void 0, this.column = void 0, this.index = void 0, this.line = t3, this.column = r, this.index = e;
              }
            }, lt2 = class {
              constructor(t3, r) {
                this.start = void 0, this.end = void 0, this.filename = void 0, this.identifierName = void 0, this.start = t3, this.end = r;
              }
            };
            function Y(t3, r) {
              let { line: e, column: s, index: i } = t3;
              return new ge(e, s + r, i + r);
            }
            var Ht = { SyntaxError: "BABEL_PARSER_SYNTAX_ERROR", SourceTypeModuleError: "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED" }, Ho = function(t3) {
              let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t3.length - 1;
              return { get() {
                return t3.reduce((e, s) => e[s], this);
              }, set(e) {
                t3.reduce((s, i, a) => a === r ? s[i] = e : s[i], this);
              } };
            }, zo = (t3, r, e) => Object.keys(e).map((s) => [s, e[s]]).filter((s) => {
              let [, i] = s;
              return !!i;
            }).map((s) => {
              let [i, a] = s;
              return [i, typeof a == "function" ? { value: a, enumerable: false } : typeof a.reflect == "string" ? Object.assign({}, a, Ho(a.reflect.split("."))) : a];
            }).reduce((s, i) => {
              let [a, n] = i;
              return Object.defineProperty(s, a, Object.assign({ configurable: true }, n));
            }, Object.assign(new t3(), r)), Vo = { ImportMetaOutsideModule: { message: `import.meta may appear only with 'sourceType: "module"'`, code: Ht.SourceTypeModuleError }, ImportOutsideModule: { message: `'import' and 'export' may appear only with 'sourceType: "module"'`, code: Ht.SourceTypeModuleError } }, ur = { ArrayPattern: "array destructuring pattern", AssignmentExpression: "assignment expression", AssignmentPattern: "assignment expression", ArrowFunctionExpression: "arrow function expression", ConditionalExpression: "conditional expression", CatchClause: "catch clause", ForOfStatement: "for-of statement", ForInStatement: "for-in statement", ForStatement: "for-loop", FormalParameters: "function parameter list", Identifier: "identifier", ImportSpecifier: "import specifier", ImportDefaultSpecifier: "import default specifier", ImportNamespaceSpecifier: "import namespace specifier", ObjectPattern: "object destructuring pattern", ParenthesizedExpression: "parenthesized expression", RestElement: "rest element", UpdateExpression: { true: "prefix operation", false: "postfix operation" }, VariableDeclarator: "variable declaration", YieldExpression: "yield expression" }, zt = (t3) => {
              let { type: r, prefix: e } = t3;
              return r === "UpdateExpression" ? ur.UpdateExpression[String(e)] : ur[r];
            }, Ko = { AccessorIsGenerator: (t3) => {
              let { kind: r } = t3;
              return `A ${r}ter cannot be a generator.`;
            }, ArgumentsInClass: "'arguments' is only allowed in functions and class methods.", AsyncFunctionInSingleStatementContext: "Async functions can only be declared at the top level or inside a block.", AwaitBindingIdentifier: "Can not use 'await' as identifier inside an async function.", AwaitBindingIdentifierInStaticBlock: "Can not use 'await' as identifier inside a static block.", AwaitExpressionFormalParameter: "'await' is not allowed in async function parameters.", AwaitInUsingBinding: "'await' is not allowed to be used as a name in 'using' declarations.", AwaitNotInAsyncContext: "'await' is only allowed within async functions and at the top levels of modules.", AwaitNotInAsyncFunction: "'await' is only allowed within async functions.", BadGetterArity: "A 'get' accessor must not have any formal parameters.", BadSetterArity: "A 'set' accessor must have exactly one formal parameter.", BadSetterRestParameter: "A 'set' accessor function argument must not be a rest parameter.", ConstructorClassField: "Classes may not have a field named 'constructor'.", ConstructorClassPrivateField: "Classes may not have a private field named '#constructor'.", ConstructorIsAccessor: "Class constructor may not be an accessor.", ConstructorIsAsync: "Constructor can't be an async function.", ConstructorIsGenerator: "Constructor can't be a generator.", DeclarationMissingInitializer: (t3) => {
              let { kind: r } = t3;
              return `Missing initializer in ${r} declaration.`;
            }, DecoratorArgumentsOutsideParentheses: "Decorator arguments must be moved inside parentheses: use '@(decorator(args))' instead of '@(decorator)(args)'.", DecoratorBeforeExport: "Decorators must be placed *before* the 'export' keyword. Remove the 'decoratorsBeforeExport: true' option to use the 'export @decorator class {}' syntax.", DecoratorsBeforeAfterExport: "Decorators can be placed *either* before or after the 'export' keyword, but not in both locations at the same time.", DecoratorConstructor: "Decorators can't be used with a constructor. Did you mean '@dec class { ... }'?", DecoratorExportClass: "Decorators must be placed *after* the 'export' keyword. Remove the 'decoratorsBeforeExport: false' option to use the '@decorator export class {}' syntax.", DecoratorSemicolon: "Decorators must not be followed by a semicolon.", DecoratorStaticBlock: "Decorators can't be used with a static block.", DeletePrivateField: "Deleting a private field is not allowed.", DestructureNamedImport: "ES2015 named imports do not destructure. Use another statement for destructuring after the import.", DuplicateConstructor: "Duplicate constructor in the same class.", DuplicateDefaultExport: "Only one default export allowed per module.", DuplicateExport: (t3) => {
              let { exportName: r } = t3;
              return `\`${r}\` has already been exported. Exported identifiers must be unique.`;
            }, DuplicateProto: "Redefinition of __proto__ property.", DuplicateRegExpFlags: "Duplicate regular expression flag.", ElementAfterRest: "Rest element must be last element.", EscapedCharNotAnIdentifier: "Invalid Unicode escape.", ExportBindingIsString: (t3) => {
              let { localName: r, exportName: e } = t3;
              return `A string literal cannot be used as an exported binding without \`from\`.
- Did you mean \`export { '${r}' as '${e}' } from 'some-module'\`?`;
            }, ExportDefaultFromAsIdentifier: "'from' is not allowed as an identifier after 'export default'.", ForInOfLoopInitializer: (t3) => {
              let { type: r } = t3;
              return `'${r === "ForInStatement" ? "for-in" : "for-of"}' loop variable declaration may not have an initializer.`;
            }, ForInUsing: "For-in loop may not start with 'using' declaration.", ForOfAsync: "The left-hand side of a for-of loop may not be 'async'.", ForOfLet: "The left-hand side of a for-of loop may not start with 'let'.", GeneratorInSingleStatementContext: "Generators can only be declared at the top level or inside a block.", IllegalBreakContinue: (t3) => {
              let { type: r } = t3;
              return `Unsyntactic ${r === "BreakStatement" ? "break" : "continue"}.`;
            }, IllegalLanguageModeDirective: "Illegal 'use strict' directive in function with non-simple parameter list.", IllegalReturn: "'return' outside of function.", ImportBindingIsString: (t3) => {
              let { importName: r } = t3;
              return `A string literal cannot be used as an imported binding.
- Did you mean \`import { "${r}" as foo }\`?`;
            }, ImportCallArgumentTrailingComma: "Trailing comma is disallowed inside import(...) arguments.", ImportCallArity: (t3) => {
              let { maxArgumentCount: r } = t3;
              return `\`import()\` requires exactly ${r === 1 ? "one argument" : "one or two arguments"}.`;
            }, ImportCallNotNewExpression: "Cannot use new with import(...).", ImportCallSpreadArgument: "`...` is not allowed in `import()`.", ImportJSONBindingNotDefault: "A JSON module can only be imported with `default`.", ImportReflectionHasAssertion: "`import module x` cannot have assertions.", ImportReflectionNotBinding: 'Only `import module x from "./module"` is valid.', IncompatibleRegExpUVFlags: "The 'u' and 'v' regular expression flags cannot be enabled at the same time.", InvalidBigIntLiteral: "Invalid BigIntLiteral.", InvalidCodePoint: "Code point out of bounds.", InvalidCoverInitializedName: "Invalid shorthand property initializer.", InvalidDecimal: "Invalid decimal.", InvalidDigit: (t3) => {
              let { radix: r } = t3;
              return `Expected number in radix ${r}.`;
            }, InvalidEscapeSequence: "Bad character escape sequence.", InvalidEscapeSequenceTemplate: "Invalid escape sequence in template.", InvalidEscapedReservedWord: (t3) => {
              let { reservedWord: r } = t3;
              return `Escape sequence in keyword ${r}.`;
            }, InvalidIdentifier: (t3) => {
              let { identifierName: r } = t3;
              return `Invalid identifier ${r}.`;
            }, InvalidLhs: (t3) => {
              let { ancestor: r } = t3;
              return `Invalid left-hand side in ${zt(r)}.`;
            }, InvalidLhsBinding: (t3) => {
              let { ancestor: r } = t3;
              return `Binding invalid left-hand side in ${zt(r)}.`;
            }, InvalidNumber: "Invalid number.", InvalidOrMissingExponent: "Floating-point numbers require a valid exponent after the 'e'.", InvalidOrUnexpectedToken: (t3) => {
              let { unexpected: r } = t3;
              return `Unexpected character '${r}'.`;
            }, InvalidParenthesizedAssignment: "Invalid parenthesized assignment pattern.", InvalidPrivateFieldResolution: (t3) => {
              let { identifierName: r } = t3;
              return `Private name #${r} is not defined.`;
            }, InvalidPropertyBindingPattern: "Binding member expression.", InvalidRecordProperty: "Only properties and spread elements are allowed in record definitions.", InvalidRestAssignmentPattern: "Invalid rest operator's argument.", LabelRedeclaration: (t3) => {
              let { labelName: r } = t3;
              return `Label '${r}' is already declared.`;
            }, LetInLexicalBinding: "'let' is not allowed to be used as a name in 'let' or 'const' declarations.", LineTerminatorBeforeArrow: "No line break is allowed before '=>'.", MalformedRegExpFlags: "Invalid regular expression flag.", MissingClassName: "A class name is required.", MissingEqInAssignment: "Only '=' operator can be used for specifying default value.", MissingSemicolon: "Missing semicolon.", MissingPlugin: (t3) => {
              let { missingPlugin: r } = t3;
              return `This experimental syntax requires enabling the parser plugin: ${r.map((e) => JSON.stringify(e)).join(", ")}.`;
            }, MissingOneOfPlugins: (t3) => {
              let { missingPlugin: r } = t3;
              return `This experimental syntax requires enabling one of the following parser plugin(s): ${r.map((e) => JSON.stringify(e)).join(", ")}.`;
            }, MissingUnicodeEscape: "Expecting Unicode escape sequence \\uXXXX.", MixingCoalesceWithLogical: "Nullish coalescing operator(??) requires parens when mixing with logical operators.", ModuleAttributeDifferentFromType: "The only accepted module attribute is `type`.", ModuleAttributeInvalidValue: "Only string literals are allowed as module attribute values.", ModuleAttributesWithDuplicateKeys: (t3) => {
              let { key: r } = t3;
              return `Duplicate key "${r}" is not allowed in module attributes.`;
            }, ModuleExportNameHasLoneSurrogate: (t3) => {
              let { surrogateCharCode: r } = t3;
              return `An export name cannot include a lone surrogate, found '\\u${r.toString(16)}'.`;
            }, ModuleExportUndefined: (t3) => {
              let { localName: r } = t3;
              return `Export '${r}' is not defined.`;
            }, MultipleDefaultsInSwitch: "Multiple default clauses.", NewlineAfterThrow: "Illegal newline after throw.", NoCatchOrFinally: "Missing catch or finally clause.", NumberIdentifier: "Identifier directly after number.", NumericSeparatorInEscapeSequence: "Numeric separators are not allowed inside unicode escape sequences or hex escape sequences.", ObsoleteAwaitStar: "'await*' has been removed from the async functions proposal. Use Promise.all() instead.", OptionalChainingNoNew: "Constructors in/after an Optional Chain are not allowed.", OptionalChainingNoTemplate: "Tagged Template Literals are not allowed in optionalChain.", OverrideOnConstructor: "'override' modifier cannot appear on a constructor declaration.", ParamDupe: "Argument name clash.", PatternHasAccessor: "Object pattern can't contain getter or setter.", PatternHasMethod: "Object pattern can't contain methods.", PrivateInExpectedIn: (t3) => {
              let { identifierName: r } = t3;
              return `Private names are only allowed in property accesses (\`obj.#${r}\`) or in \`in\` expressions (\`#${r} in obj\`).`;
            }, PrivateNameRedeclaration: (t3) => {
              let { identifierName: r } = t3;
              return `Duplicate private name #${r}.`;
            }, RecordExpressionBarIncorrectEndSyntaxType: "Record expressions ending with '|}' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", RecordExpressionBarIncorrectStartSyntaxType: "Record expressions starting with '{|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", RecordExpressionHashIncorrectStartSyntaxType: "Record expressions starting with '#{' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.", RecordNoProto: "'__proto__' is not allowed in Record expressions.", RestTrailingComma: "Unexpected trailing comma after rest element.", SloppyFunction: "In non-strict mode code, functions can only be declared at top level or inside a block.", SloppyFunctionAnnexB: "In non-strict mode code, functions can only be declared at top level, inside a block, or as the body of an if statement.", StaticPrototype: "Classes may not have static property named prototype.", SuperNotAllowed: "`super()` is only valid inside a class constructor of a subclass. Maybe a typo in the method name ('constructor') or not extending another class?", SuperPrivateField: "Private fields can't be accessed on super.", TrailingDecorator: "Decorators must be attached to a class element.", TupleExpressionBarIncorrectEndSyntaxType: "Tuple expressions ending with '|]' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", TupleExpressionBarIncorrectStartSyntaxType: "Tuple expressions starting with '[|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", TupleExpressionHashIncorrectStartSyntaxType: "Tuple expressions starting with '#[' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.", UnexpectedArgumentPlaceholder: "Unexpected argument placeholder.", UnexpectedAwaitAfterPipelineBody: 'Unexpected "await" after pipeline body; await must have parentheses in minimal proposal.', UnexpectedDigitAfterHash: "Unexpected digit after hash token.", UnexpectedImportExport: "'import' and 'export' may only appear at the top level.", UnexpectedKeyword: (t3) => {
              let { keyword: r } = t3;
              return `Unexpected keyword '${r}'.`;
            }, UnexpectedLeadingDecorator: "Leading decorators must be attached to a class declaration.", UnexpectedLexicalDeclaration: "Lexical declaration cannot appear in a single-statement context.", UnexpectedNewTarget: "`new.target` can only be used in functions or class properties.", UnexpectedNumericSeparator: "A numeric separator is only allowed between two digits.", UnexpectedPrivateField: "Unexpected private name.", UnexpectedReservedWord: (t3) => {
              let { reservedWord: r } = t3;
              return `Unexpected reserved word '${r}'.`;
            }, UnexpectedSuper: "'super' is only allowed in object methods and classes.", UnexpectedToken: (t3) => {
              let { expected: r, unexpected: e } = t3;
              return `Unexpected token${e ? ` '${e}'.` : ""}${r ? `, expected "${r}"` : ""}`;
            }, UnexpectedTokenUnaryExponentiation: "Illegal expression. Wrap left hand side or entire exponentiation in parentheses.", UnexpectedUsingDeclaration: "Using declaration cannot appear in the top level when source type is `script`.", UnsupportedBind: "Binding should be performed on object property.", UnsupportedDecoratorExport: "A decorated export must export a class declaration.", UnsupportedDefaultExport: "Only expressions, functions or classes are allowed as the `default` export.", UnsupportedImport: "`import` can only be used in `import()` or `import.meta`.", UnsupportedMetaProperty: (t3) => {
              let { target: r, onlyValidPropertyName: e } = t3;
              return `The only valid meta property for ${r} is ${r}.${e}.`;
            }, UnsupportedParameterDecorator: "Decorators cannot be used to decorate parameters.", UnsupportedPropertyDecorator: "Decorators cannot be used to decorate object literal properties.", UnsupportedSuper: "'super' can only be used with function calls (i.e. super()) or in property accesses (i.e. super.prop or super[prop]).", UnterminatedComment: "Unterminated comment.", UnterminatedRegExp: "Unterminated regular expression.", UnterminatedString: "Unterminated string constant.", UnterminatedTemplate: "Unterminated template.", UsingDeclarationHasBindingPattern: "Using declaration cannot have destructuring patterns.", VarRedeclaration: (t3) => {
              let { identifierName: r } = t3;
              return `Identifier '${r}' has already been declared.`;
            }, YieldBindingIdentifier: "Can not use 'yield' as identifier inside a generator.", YieldInParameter: "Yield expression is not allowed in formal parameters.", ZeroDigitNumericSeparator: "Numeric separator can not be used after leading 0." }, Wo = { StrictDelete: "Deleting local variable in strict mode.", StrictEvalArguments: (t3) => {
              let { referenceName: r } = t3;
              return `Assigning to '${r}' in strict mode.`;
            }, StrictEvalArgumentsBinding: (t3) => {
              let { bindingName: r } = t3;
              return `Binding '${r}' in strict mode.`;
            }, StrictFunction: "In strict mode code, functions can only be declared at top level or inside a block.", StrictNumericEscape: "The only valid numeric escape in strict mode is '\\0'.", StrictOctalLiteral: "Legacy octal literals are not allowed in strict mode.", StrictWith: "'with' in strict mode." }, Go = /* @__PURE__ */ new Set(["ArrowFunctionExpression", "AssignmentExpression", "ConditionalExpression", "YieldExpression"]), Jo = { PipeBodyIsTighter: "Unexpected yield after pipeline body; any yield expression acting as Hack-style pipe body must be parenthesized due to its loose operator precedence.", PipeTopicRequiresHackPipes: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.', PipeTopicUnbound: "Topic reference is unbound; it must be inside a pipe body.", PipeTopicUnconfiguredToken: (t3) => {
              let { token: r } = t3;
              return `Invalid topic token ${r}. In order to use ${r} as a topic reference, the pipelineOperator plugin must be configured with { "proposal": "hack", "topicToken": "${r}" }.`;
            }, PipeTopicUnused: "Hack-style pipe body does not contain a topic reference; Hack-style pipes must use topic at least once.", PipeUnparenthesizedBody: (t3) => {
              let { type: r } = t3;
              return `Hack-style pipe body cannot be an unparenthesized ${zt({ type: r })}; please wrap it in parentheses.`;
            }, PipelineBodyNoArrow: 'Unexpected arrow "=>" after pipeline body; arrow function in pipeline body must be parenthesized.', PipelineBodySequenceExpression: "Pipeline body may not be a comma-separated sequence expression.", PipelineHeadSequenceExpression: "Pipeline head should not be a comma-separated sequence expression.", PipelineTopicUnused: "Pipeline is in topic style but does not use topic reference.", PrimaryTopicNotAllowed: "Topic reference was used in a lexical context without topic binding.", PrimaryTopicRequiresSmartPipeline: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.' }, Xo = ["toMessage"], Yo = ["message"];
            function Qo(t3) {
              let { toMessage: r } = t3, e = ot(t3, Xo);
              return function s(i) {
                let { loc: a, details: n } = i;
                return zo(SyntaxError, Object.assign({}, e, { loc: a }), { clone() {
                  let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = o.loc || {};
                  return s({ loc: new ge("line" in u ? u.line : this.loc.line, "column" in u ? u.column : this.loc.column, "index" in u ? u.index : this.loc.index), details: Object.assign({}, this.details, o.details) });
                }, details: { value: n, enumerable: false }, message: { get() {
                  return `${r(this.details)} (${this.loc.line}:${this.loc.column})`;
                }, set(o) {
                  Object.defineProperty(this, "message", { value: o });
                } }, pos: { reflect: "loc.index", enumerable: true }, missingPlugin: "missingPlugin" in n && { reflect: "details.missingPlugin", enumerable: true } });
              };
            }
            function pe(t3, r) {
              if (Array.isArray(t3))
                return (s) => pe(s, t3[0]);
              let e = {};
              for (let s of Object.keys(t3)) {
                let i = t3[s], a = typeof i == "string" ? { message: () => i } : typeof i == "function" ? { message: i } : i, { message: n } = a, o = ot(a, Yo), u = typeof n == "string" ? () => n : n;
                e[s] = Qo(Object.assign({ code: Ht.SyntaxError, reasonCode: s, toMessage: u }, r ? { syntaxPlugin: r } : {}, o));
              }
              return e;
            }
            var f = Object.assign({}, pe(Vo), pe(Ko), pe(Wo), pe`pipelineOperator`(Jo)), { defineProperty: Zo } = Object, cr = (t3, r) => Zo(t3, r, { enumerable: false, value: t3[r] });
            function ze(t3) {
              return t3.loc.start && cr(t3.loc.start, "index"), t3.loc.end && cr(t3.loc.end, "index"), t3;
            }
            var el = (t3) => class extends t3 {
              parse() {
                let e = ze(super.parse());
                return this.options.tokens && (e.tokens = e.tokens.map(ze)), e;
              }
              parseRegExpLiteral(e) {
                let { pattern: s, flags: i } = e, a = null;
                try {
                  a = new RegExp(s, i);
                } catch {
                }
                let n = this.estreeParseLiteral(a);
                return n.regex = { pattern: s, flags: i }, n;
              }
              parseBigIntLiteral(e) {
                let s;
                try {
                  s = BigInt(e);
                } catch {
                  s = null;
                }
                let i = this.estreeParseLiteral(s);
                return i.bigint = String(i.value || e), i;
              }
              parseDecimalLiteral(e) {
                let i = this.estreeParseLiteral(null);
                return i.decimal = String(i.value || e), i;
              }
              estreeParseLiteral(e) {
                return this.parseLiteral(e, "Literal");
              }
              parseStringLiteral(e) {
                return this.estreeParseLiteral(e);
              }
              parseNumericLiteral(e) {
                return this.estreeParseLiteral(e);
              }
              parseNullLiteral() {
                return this.estreeParseLiteral(null);
              }
              parseBooleanLiteral(e) {
                return this.estreeParseLiteral(e);
              }
              directiveToStmt(e) {
                let s = e.value;
                delete e.value, s.type = "Literal", s.raw = s.extra.raw, s.value = s.extra.expressionValue;
                let i = e;
                return i.type = "ExpressionStatement", i.expression = s, i.directive = s.extra.rawValue, delete s.extra, i;
              }
              initFunction(e, s) {
                super.initFunction(e, s), e.expression = false;
              }
              checkDeclaration(e) {
                e != null && this.isObjectProperty(e) ? this.checkDeclaration(e.value) : super.checkDeclaration(e);
              }
              getObjectOrClassMethodParams(e) {
                return e.value.params;
              }
              isValidDirective(e) {
                var s;
                return e.type === "ExpressionStatement" && e.expression.type === "Literal" && typeof e.expression.value == "string" && !((s = e.expression.extra) != null && s.parenthesized);
              }
              parseBlockBody(e, s, i, a, n) {
                super.parseBlockBody(e, s, i, a, n);
                let o = e.directives.map((u) => this.directiveToStmt(u));
                e.body = o.concat(e.body), delete e.directives;
              }
              pushClassMethod(e, s, i, a, n, o) {
                this.parseMethod(s, i, a, n, o, "ClassMethod", true), s.typeParameters && (s.value.typeParameters = s.typeParameters, delete s.typeParameters), e.body.push(s);
              }
              parsePrivateName() {
                let e = super.parsePrivateName();
                return this.getPluginOption("estree", "classFeatures") ? this.convertPrivateNameToPrivateIdentifier(e) : e;
              }
              convertPrivateNameToPrivateIdentifier(e) {
                let s = super.getPrivateNameSV(e);
                return e = e, delete e.id, e.name = s, e.type = "PrivateIdentifier", e;
              }
              isPrivateName(e) {
                return this.getPluginOption("estree", "classFeatures") ? e.type === "PrivateIdentifier" : super.isPrivateName(e);
              }
              getPrivateNameSV(e) {
                return this.getPluginOption("estree", "classFeatures") ? e.name : super.getPrivateNameSV(e);
              }
              parseLiteral(e, s) {
                let i = super.parseLiteral(e, s);
                return i.raw = i.extra.raw, delete i.extra, i;
              }
              parseFunctionBody(e, s) {
                let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                super.parseFunctionBody(e, s, i), e.expression = e.body.type !== "BlockStatement";
              }
              parseMethod(e, s, i, a, n, o) {
                let u = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, c = this.startNode();
                return c.kind = e.kind, c = super.parseMethod(c, s, i, a, n, o, u), c.type = "FunctionExpression", delete c.kind, e.value = c, o === "ClassPrivateMethod" && (e.computed = false), this.finishNode(e, "MethodDefinition");
              }
              parseClassProperty() {
                let e = super.parseClassProperty(...arguments);
                return this.getPluginOption("estree", "classFeatures") && (e.type = "PropertyDefinition"), e;
              }
              parseClassPrivateProperty() {
                let e = super.parseClassPrivateProperty(...arguments);
                return this.getPluginOption("estree", "classFeatures") && (e.type = "PropertyDefinition", e.computed = false), e;
              }
              parseObjectMethod(e, s, i, a, n) {
                let o = super.parseObjectMethod(e, s, i, a, n);
                return o && (o.type = "Property", o.kind === "method" && (o.kind = "init"), o.shorthand = false), o;
              }
              parseObjectProperty(e, s, i, a) {
                let n = super.parseObjectProperty(e, s, i, a);
                return n && (n.kind = "init", n.type = "Property"), n;
              }
              isValidLVal(e, s, i) {
                return e === "Property" ? "value" : super.isValidLVal(e, s, i);
              }
              isAssignable(e, s) {
                return e != null && this.isObjectProperty(e) ? this.isAssignable(e.value, s) : super.isAssignable(e, s);
              }
              toAssignable(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (e != null && this.isObjectProperty(e)) {
                  let { key: i, value: a } = e;
                  this.isPrivateName(i) && this.classScope.usePrivateName(this.getPrivateNameSV(i), i.loc.start), this.toAssignable(a, s);
                } else
                  super.toAssignable(e, s);
              }
              toAssignableObjectExpressionProp(e, s, i) {
                e.kind === "get" || e.kind === "set" ? this.raise(f.PatternHasAccessor, { at: e.key }) : e.method ? this.raise(f.PatternHasMethod, { at: e.key }) : super.toAssignableObjectExpressionProp(e, s, i);
              }
              finishCallExpression(e, s) {
                let i = super.finishCallExpression(e, s);
                if (i.callee.type === "Import") {
                  if (i.type = "ImportExpression", i.source = i.arguments[0], this.hasPlugin("importAssertions")) {
                    var a;
                    i.attributes = (a = i.arguments[1]) != null ? a : null;
                  }
                  delete i.arguments, delete i.callee;
                }
                return i;
              }
              toReferencedArguments(e) {
                e.type !== "ImportExpression" && super.toReferencedArguments(e);
              }
              parseExport(e, s) {
                let i = this.state.lastTokStartLoc, a = super.parseExport(e, s);
                switch (a.type) {
                  case "ExportAllDeclaration":
                    a.exported = null;
                    break;
                  case "ExportNamedDeclaration":
                    a.specifiers.length === 1 && a.specifiers[0].type === "ExportNamespaceSpecifier" && (a.type = "ExportAllDeclaration", a.exported = a.specifiers[0].exported, delete a.specifiers);
                  case "ExportDefaultDeclaration":
                    {
                      var n;
                      let { declaration: o } = a;
                      (o == null ? void 0 : o.type) === "ClassDeclaration" && ((n = o.decorators) == null ? void 0 : n.length) > 0 && o.start === a.start && this.resetStartLocation(a, i);
                    }
                    break;
                }
                return a;
              }
              parseSubscript(e, s, i, a) {
                let n = super.parseSubscript(e, s, i, a);
                if (a.optionalChainMember) {
                  if ((n.type === "OptionalMemberExpression" || n.type === "OptionalCallExpression") && (n.type = n.type.substring(8)), a.stop) {
                    let o = this.startNodeAtNode(n);
                    return o.expression = n, this.finishNode(o, "ChainExpression");
                  }
                } else
                  (n.type === "MemberExpression" || n.type === "CallExpression") && (n.optional = false);
                return n;
              }
              hasPropertyAsPrivateName(e) {
                return e.type === "ChainExpression" && (e = e.expression), super.hasPropertyAsPrivateName(e);
              }
              isObjectProperty(e) {
                return e.type === "Property" && e.kind === "init" && !e.method;
              }
              isObjectMethod(e) {
                return e.method || e.kind === "get" || e.kind === "set";
              }
              finishNodeAt(e, s, i) {
                return ze(super.finishNodeAt(e, s, i));
              }
              resetStartLocation(e, s) {
                super.resetStartLocation(e, s), ze(e);
              }
              resetEndLocation(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.lastTokEndLoc;
                super.resetEndLocation(e, s), ze(e);
              }
            }, Vt = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", pr = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F", tl = new RegExp("[" + Vt + "]"), sl = new RegExp("[" + Vt + pr + "]");
            Vt = pr = null;
            var fr = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 4026, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 757, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938, 6, 4191], rl = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 81, 2, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 9, 5351, 0, 7, 14, 13835, 9, 87, 9, 39, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 983, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
            function Kt(t3, r) {
              let e = 65536;
              for (let s = 0, i = r.length; s < i; s += 2) {
                if (e += r[s], e > t3)
                  return false;
                if (e += r[s + 1], e >= t3)
                  return true;
              }
              return false;
            }
            function fe(t3) {
              return t3 < 65 ? t3 === 36 : t3 <= 90 ? true : t3 < 97 ? t3 === 95 : t3 <= 122 ? true : t3 <= 65535 ? t3 >= 170 && tl.test(String.fromCharCode(t3)) : Kt(t3, fr);
            }
            function De(t3) {
              return t3 < 48 ? t3 === 36 : t3 < 58 ? true : t3 < 65 ? false : t3 <= 90 ? true : t3 < 97 ? t3 === 95 : t3 <= 122 ? true : t3 <= 65535 ? t3 >= 170 && sl.test(String.fromCharCode(t3)) : Kt(t3, fr) || Kt(t3, rl);
            }
            var Wt = { keyword: ["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"], strict: ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"], strictBind: ["eval", "arguments"] }, il = new Set(Wt.keyword), al = new Set(Wt.strict), nl = new Set(Wt.strictBind);
            function dr(t3, r) {
              return r && t3 === "await" || t3 === "enum";
            }
            function mr(t3, r) {
              return dr(t3, r) || al.has(t3);
            }
            function yr(t3) {
              return nl.has(t3);
            }
            function xr(t3, r) {
              return mr(t3, r) || yr(t3);
            }
            function ol(t3) {
              return il.has(t3);
            }
            function ll(t3, r, e) {
              return t3 === 64 && r === 64 && fe(e);
            }
            var hl = /* @__PURE__ */ new Set(["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete", "implements", "interface", "let", "package", "private", "protected", "public", "static", "yield", "eval", "arguments", "enum", "await"]);
            function ul(t3) {
              return hl.has(t3);
            }
            var Fe = 0, Le = 1, de = 2, Gt = 4, gr = 8, ht = 16, Pr = 32, Ee = 64, ut = 128, Oe = 256, ct = Le | de | ut | Oe, le = 1, Ce = 2, Ar = 4, be = 8, pt = 16, Tr = 64, ft = 128, Jt = 256, Xt = 512, Yt = 1024, Qt = 2048, Ve = 4096, dt = 8192, vr = le | Ce | be | ft | dt, Be = le | 0 | be | dt, cl = le | 0 | be | 0, mt = le | 0 | Ar | 0, Er = le | 0 | pt | 0, pl = 0 | Ce | 0 | ft, fl = 0 | Ce | 0 | 0, Cr = le | Ce | be | Jt | dt, br = 0 | Yt, Pe = 0 | Tr, dl = le | 0 | 0 | Tr, ml = Cr | Xt, yl = 0 | Yt, Sr = 0 | Ce | 0 | Ve, xl = Qt, yt = 4, Zt = 2, es = 1, ts = Zt | es, gl = Zt | yt, Pl = es | yt, Al = Zt, Tl = es, ss = 0, rs = class {
              constructor(t3) {
                this.var = /* @__PURE__ */ new Set(), this.lexical = /* @__PURE__ */ new Set(), this.functions = /* @__PURE__ */ new Set(), this.flags = t3;
              }
            }, is = class {
              constructor(t3, r) {
                this.parser = void 0, this.scopeStack = [], this.inModule = void 0, this.undefinedExports = /* @__PURE__ */ new Map(), this.parser = t3, this.inModule = r;
              }
              get inTopLevel() {
                return (this.currentScope().flags & Le) > 0;
              }
              get inFunction() {
                return (this.currentVarScopeFlags() & de) > 0;
              }
              get allowSuper() {
                return (this.currentThisScopeFlags() & ht) > 0;
              }
              get allowDirectSuper() {
                return (this.currentThisScopeFlags() & Pr) > 0;
              }
              get inClass() {
                return (this.currentThisScopeFlags() & Ee) > 0;
              }
              get inClassAndNotInNonArrowFunction() {
                let t3 = this.currentThisScopeFlags();
                return (t3 & Ee) > 0 && (t3 & de) === 0;
              }
              get inStaticBlock() {
                for (let t3 = this.scopeStack.length - 1; ; t3--) {
                  let { flags: r } = this.scopeStack[t3];
                  if (r & ut)
                    return true;
                  if (r & (ct | Ee))
                    return false;
                }
              }
              get inNonArrowFunction() {
                return (this.currentThisScopeFlags() & de) > 0;
              }
              get treatFunctionsAsVar() {
                return this.treatFunctionsAsVarInScope(this.currentScope());
              }
              createScope(t3) {
                return new rs(t3);
              }
              enter(t3) {
                this.scopeStack.push(this.createScope(t3));
              }
              exit() {
                return this.scopeStack.pop().flags;
              }
              treatFunctionsAsVarInScope(t3) {
                return !!(t3.flags & (de | ut) || !this.parser.inModule && t3.flags & Le);
              }
              declareName(t3, r, e) {
                let s = this.currentScope();
                if (r & be || r & pt)
                  this.checkRedeclarationInScope(s, t3, r, e), r & pt ? s.functions.add(t3) : s.lexical.add(t3), r & be && this.maybeExportDefined(s, t3);
                else if (r & Ar)
                  for (let i = this.scopeStack.length - 1; i >= 0 && (s = this.scopeStack[i], this.checkRedeclarationInScope(s, t3, r, e), s.var.add(t3), this.maybeExportDefined(s, t3), !(s.flags & ct)); --i)
                    ;
                this.parser.inModule && s.flags & Le && this.undefinedExports.delete(t3);
              }
              maybeExportDefined(t3, r) {
                this.parser.inModule && t3.flags & Le && this.undefinedExports.delete(r);
              }
              checkRedeclarationInScope(t3, r, e, s) {
                this.isRedeclaredInScope(t3, r, e) && this.parser.raise(f.VarRedeclaration, { at: s, identifierName: r });
              }
              isRedeclaredInScope(t3, r, e) {
                return e & le ? e & be ? t3.lexical.has(r) || t3.functions.has(r) || t3.var.has(r) : e & pt ? t3.lexical.has(r) || !this.treatFunctionsAsVarInScope(t3) && t3.var.has(r) : t3.lexical.has(r) && !(t3.flags & gr && t3.lexical.values().next().value === r) || !this.treatFunctionsAsVarInScope(t3) && t3.functions.has(r) : false;
              }
              checkLocalExport(t3) {
                let { name: r } = t3, e = this.scopeStack[0];
                !e.lexical.has(r) && !e.var.has(r) && !e.functions.has(r) && this.undefinedExports.set(r, t3.loc.start);
              }
              currentScope() {
                return this.scopeStack[this.scopeStack.length - 1];
              }
              currentVarScopeFlags() {
                for (let t3 = this.scopeStack.length - 1; ; t3--) {
                  let { flags: r } = this.scopeStack[t3];
                  if (r & ct)
                    return r;
                }
              }
              currentThisScopeFlags() {
                for (let t3 = this.scopeStack.length - 1; ; t3--) {
                  let { flags: r } = this.scopeStack[t3];
                  if (r & (ct | Ee) && !(r & Gt))
                    return r;
                }
              }
            }, vl = class extends rs {
              constructor() {
                super(...arguments), this.declareFunctions = /* @__PURE__ */ new Set();
              }
            }, El = class extends is {
              createScope(t3) {
                return new vl(t3);
              }
              declareName(t3, r, e) {
                let s = this.currentScope();
                if (r & Qt) {
                  this.checkRedeclarationInScope(s, t3, r, e), this.maybeExportDefined(s, t3), s.declareFunctions.add(t3);
                  return;
                }
                super.declareName(t3, r, e);
              }
              isRedeclaredInScope(t3, r, e) {
                return super.isRedeclaredInScope(t3, r, e) ? true : e & Qt ? !t3.declareFunctions.has(r) && (t3.lexical.has(r) || t3.functions.has(r)) : false;
              }
              checkLocalExport(t3) {
                this.scopeStack[0].declareFunctions.has(t3.name) || super.checkLocalExport(t3);
              }
            }, Cl = class {
              constructor() {
                this.sawUnambiguousESM = false, this.ambiguousScriptDifferentAst = false;
              }
              hasPlugin(t3) {
                if (typeof t3 == "string")
                  return this.plugins.has(t3);
                {
                  let [r, e] = t3;
                  if (!this.hasPlugin(r))
                    return false;
                  let s = this.plugins.get(r);
                  for (let i of Object.keys(e))
                    if ((s == null ? void 0 : s[i]) !== e[i])
                      return false;
                  return true;
                }
              }
              getPluginOption(t3, r) {
                var e;
                return (e = this.plugins.get(t3)) == null ? void 0 : e[r];
              }
            };
            function wr(t3, r) {
              t3.trailingComments === void 0 ? t3.trailingComments = r : t3.trailingComments.unshift(...r);
            }
            function bl(t3, r) {
              t3.leadingComments === void 0 ? t3.leadingComments = r : t3.leadingComments.unshift(...r);
            }
            function Ke(t3, r) {
              t3.innerComments === void 0 ? t3.innerComments = r : t3.innerComments.unshift(...r);
            }
            function We(t3, r, e) {
              let s = null, i = r.length;
              for (; s === null && i > 0; )
                s = r[--i];
              s === null || s.start > e.start ? Ke(t3, e.comments) : wr(s, e.comments);
            }
            var Sl = class extends Cl {
              addComment(t3) {
                this.filename && (t3.loc.filename = this.filename), this.state.comments.push(t3);
              }
              processComment(t3) {
                let { commentStack: r } = this.state, e = r.length;
                if (e === 0)
                  return;
                let s = e - 1, i = r[s];
                i.start === t3.end && (i.leadingNode = t3, s--);
                let { start: a } = t3;
                for (; s >= 0; s--) {
                  let n = r[s], o = n.end;
                  if (o > a)
                    n.containingNode = t3, this.finalizeComment(n), r.splice(s, 1);
                  else {
                    o === a && (n.trailingNode = t3);
                    break;
                  }
                }
              }
              finalizeComment(t3) {
                let { comments: r } = t3;
                if (t3.leadingNode !== null || t3.trailingNode !== null)
                  t3.leadingNode !== null && wr(t3.leadingNode, r), t3.trailingNode !== null && bl(t3.trailingNode, r);
                else {
                  let { containingNode: e, start: s } = t3;
                  if (this.input.charCodeAt(s - 1) === 44)
                    switch (e.type) {
                      case "ObjectExpression":
                      case "ObjectPattern":
                      case "RecordExpression":
                        We(e, e.properties, t3);
                        break;
                      case "CallExpression":
                      case "OptionalCallExpression":
                        We(e, e.arguments, t3);
                        break;
                      case "FunctionDeclaration":
                      case "FunctionExpression":
                      case "ArrowFunctionExpression":
                      case "ObjectMethod":
                      case "ClassMethod":
                      case "ClassPrivateMethod":
                        We(e, e.params, t3);
                        break;
                      case "ArrayExpression":
                      case "ArrayPattern":
                      case "TupleExpression":
                        We(e, e.elements, t3);
                        break;
                      case "ExportNamedDeclaration":
                      case "ImportDeclaration":
                        We(e, e.specifiers, t3);
                        break;
                      default:
                        Ke(e, r);
                    }
                  else
                    Ke(e, r);
                }
              }
              finalizeRemainingComments() {
                let { commentStack: t3 } = this.state;
                for (let r = t3.length - 1; r >= 0; r--)
                  this.finalizeComment(t3[r]);
                this.state.commentStack = [];
              }
              resetPreviousNodeTrailingComments(t3) {
                let { commentStack: r } = this.state, { length: e } = r;
                if (e === 0)
                  return;
                let s = r[e - 1];
                s.leadingNode === t3 && (s.leadingNode = null);
              }
              takeSurroundingComments(t3, r, e) {
                let { commentStack: s } = this.state, i = s.length;
                if (i === 0)
                  return;
                let a = i - 1;
                for (; a >= 0; a--) {
                  let n = s[a], o = n.end;
                  if (n.start === e)
                    n.leadingNode = t3;
                  else if (o === r)
                    n.trailingNode = t3;
                  else if (o < r)
                    break;
                }
              }
            }, as = /\r\n?|[\n\u2028\u2029]/, xt = new RegExp(as.source, "g");
            function Ge(t3) {
              switch (t3) {
                case 10:
                case 13:
                case 8232:
                case 8233:
                  return true;
                default:
                  return false;
              }
            }
            var ns = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, wl = /(?:[^\S\n\r\u2028\u2029]|\/\/.*|\/\*.*?\*\/)*/y, Ir = new RegExp("(?=(" + wl.source + "))\\1" + /(?=[\n\r\u2028\u2029]|\/\*(?!.*?\*\/)|$)/.source, "y");
            function Il(t3) {
              switch (t3) {
                case 9:
                case 11:
                case 12:
                case 32:
                case 160:
                case 5760:
                case 8192:
                case 8193:
                case 8194:
                case 8195:
                case 8196:
                case 8197:
                case 8198:
                case 8199:
                case 8200:
                case 8201:
                case 8202:
                case 8239:
                case 8287:
                case 12288:
                case 65279:
                  return true;
                default:
                  return false;
              }
            }
            var Nr = class {
              constructor() {
                this.strict = void 0, this.curLine = void 0, this.lineStart = void 0, this.startLoc = void 0, this.endLoc = void 0, this.errors = [], this.potentialArrowAt = -1, this.noArrowAt = [], this.noArrowParamsConversionAt = [], this.maybeInArrowParameters = false, this.inType = false, this.noAnonFunctionType = false, this.hasFlowComment = false, this.isAmbientContext = false, this.inAbstractClass = false, this.inDisallowConditionalTypesContext = false, this.topicContext = { maxNumOfResolvableTopics: 0, maxTopicIndex: null }, this.soloAwait = false, this.inFSharpPipelineDirectBody = false, this.labels = [], this.comments = [], this.commentStack = [], this.pos = 0, this.type = 137, this.value = null, this.start = 0, this.end = 0, this.lastTokEndLoc = null, this.lastTokStartLoc = null, this.lastTokStart = 0, this.context = [x.brace], this.canStartJSXElement = true, this.containsEsc = false, this.firstInvalidTemplateEscapePos = null, this.strictErrors = /* @__PURE__ */ new Map(), this.tokensLength = 0;
              }
              init(t3) {
                let { strictMode: r, sourceType: e, startLine: s, startColumn: i } = t3;
                this.strict = r === false ? false : r === true ? true : e === "module", this.curLine = s, this.lineStart = -i, this.startLoc = this.endLoc = new ge(s, i, 0);
              }
              curPosition() {
                return new ge(this.curLine, this.pos - this.lineStart, this.pos);
              }
              clone(t3) {
                let r = new Nr(), e = Object.keys(this);
                for (let s = 0, i = e.length; s < i; s++) {
                  let a = e[s], n = this[a];
                  !t3 && Array.isArray(n) && (n = n.slice()), r[a] = n;
                }
                return r;
              }
            }, Nl = function(r) {
              return r >= 48 && r <= 57;
            }, kr = { decBinOct: /* @__PURE__ */ new Set([46, 66, 69, 79, 95, 98, 101, 111]), hex: /* @__PURE__ */ new Set([46, 88, 95, 120]) }, gt2 = { bin: (t3) => t3 === 48 || t3 === 49, oct: (t3) => t3 >= 48 && t3 <= 55, dec: (t3) => t3 >= 48 && t3 <= 57, hex: (t3) => t3 >= 48 && t3 <= 57 || t3 >= 65 && t3 <= 70 || t3 >= 97 && t3 <= 102 };
            function Dr(t3, r, e, s, i, a) {
              let n = e, o = s, u = i, c = "", y = null, g = e, { length: T } = r;
              for (; ; ) {
                if (e >= T) {
                  a.unterminated(n, o, u), c += r.slice(g, e);
                  break;
                }
                let C = r.charCodeAt(e);
                if (kl(t3, C, r, e)) {
                  c += r.slice(g, e);
                  break;
                }
                if (C === 92) {
                  c += r.slice(g, e);
                  let M = Dl(r, e, s, i, t3 === "template", a);
                  M.ch === null && !y ? y = { pos: e, lineStart: s, curLine: i } : c += M.ch, { pos: e, lineStart: s, curLine: i } = M, g = e;
                } else
                  C === 8232 || C === 8233 ? (++e, ++i, s = e) : C === 10 || C === 13 ? t3 === "template" ? (c += r.slice(g, e) + `
`, ++e, C === 13 && r.charCodeAt(e) === 10 && ++e, ++i, g = s = e) : a.unterminated(n, o, u) : ++e;
              }
              return { pos: e, str: c, firstInvalidLoc: y, lineStart: s, curLine: i, containsInvalid: !!y };
            }
            function kl(t3, r, e, s) {
              return t3 === "template" ? r === 96 || r === 36 && e.charCodeAt(s + 1) === 123 : r === (t3 === "double" ? 34 : 39);
            }
            function Dl(t3, r, e, s, i, a) {
              let n = !i;
              r++;
              let o = (c) => ({ pos: r, ch: c, lineStart: e, curLine: s }), u = t3.charCodeAt(r++);
              switch (u) {
                case 110:
                  return o(`
`);
                case 114:
                  return o("\r");
                case 120: {
                  let c;
                  return { code: c, pos: r } = os(t3, r, e, s, 2, false, n, a), o(c === null ? null : String.fromCharCode(c));
                }
                case 117: {
                  let c;
                  return { code: c, pos: r } = Lr(t3, r, e, s, n, a), o(c === null ? null : String.fromCodePoint(c));
                }
                case 116:
                  return o("	");
                case 98:
                  return o("\b");
                case 118:
                  return o("\v");
                case 102:
                  return o("\f");
                case 13:
                  t3.charCodeAt(r) === 10 && ++r;
                case 10:
                  e = r, ++s;
                case 8232:
                case 8233:
                  return o("");
                case 56:
                case 57:
                  if (i)
                    return o(null);
                  a.strictNumericEscape(r - 1, e, s);
                default:
                  if (u >= 48 && u <= 55) {
                    let c = r - 1, g = t3.slice(c, r + 2).match(/^[0-7]+/)[0], T = parseInt(g, 8);
                    T > 255 && (g = g.slice(0, -1), T = parseInt(g, 8)), r += g.length - 1;
                    let C = t3.charCodeAt(r);
                    if (g !== "0" || C === 56 || C === 57) {
                      if (i)
                        return o(null);
                      a.strictNumericEscape(c, e, s);
                    }
                    return o(String.fromCharCode(T));
                  }
                  return o(String.fromCharCode(u));
              }
            }
            function os(t3, r, e, s, i, a, n, o) {
              let u = r, c;
              return { n: c, pos: r } = Fr(t3, r, e, s, 16, i, a, false, o, !n), c === null && (n ? o.invalidEscapeSequence(u, e, s) : r = u - 1), { code: c, pos: r };
            }
            function Fr(t3, r, e, s, i, a, n, o, u, c) {
              let y = r, g = i === 16 ? kr.hex : kr.decBinOct, T = i === 16 ? gt2.hex : i === 10 ? gt2.dec : i === 8 ? gt2.oct : gt2.bin, C = false, M = 0;
              for (let j = 0, K = a == null ? 1 / 0 : a; j < K; ++j) {
                let W = t3.charCodeAt(r), V;
                if (W === 95 && o !== "bail") {
                  let X = t3.charCodeAt(r - 1), je = t3.charCodeAt(r + 1);
                  if (o) {
                    if (Number.isNaN(je) || !T(je) || g.has(X) || g.has(je)) {
                      if (c)
                        return { n: null, pos: r };
                      u.unexpectedNumericSeparator(r, e, s);
                    }
                  } else {
                    if (c)
                      return { n: null, pos: r };
                    u.numericSeparatorInEscapeSequence(r, e, s);
                  }
                  ++r;
                  continue;
                }
                if (W >= 97 ? V = W - 97 + 10 : W >= 65 ? V = W - 65 + 10 : Nl(W) ? V = W - 48 : V = 1 / 0, V >= i) {
                  if (V <= 9 && c)
                    return { n: null, pos: r };
                  if (V <= 9 && u.invalidDigit(r, e, s, i))
                    V = 0;
                  else if (n)
                    V = 0, C = true;
                  else
                    break;
                }
                ++r, M = M * i + V;
              }
              return r === y || a != null && r - y !== a || C ? { n: null, pos: r } : { n: M, pos: r };
            }
            function Lr(t3, r, e, s, i, a) {
              let n = t3.charCodeAt(r), o;
              if (n === 123) {
                if (++r, { code: o, pos: r } = os(t3, r, e, s, t3.indexOf("}", r) - r, true, i, a), ++r, o !== null && o > 1114111)
                  if (i)
                    a.invalidCodePoint(r, e, s);
                  else
                    return { code: null, pos: r };
              } else
                ({ code: o, pos: r } = os(t3, r, e, s, 4, false, i, a));
              return { code: o, pos: r };
            }
            var Fl = ["at"], Ll = ["at"];
            function Je(t3, r, e) {
              return new ge(e, t3 - r, t3);
            }
            var Ol = /* @__PURE__ */ new Set([103, 109, 115, 105, 121, 117, 100, 118]), Ae = class {
              constructor(t3) {
                this.type = t3.type, this.value = t3.value, this.start = t3.start, this.end = t3.end, this.loc = new lt2(t3.startLoc, t3.endLoc);
              }
            }, Bl = class extends Sl {
              constructor(t3, r) {
                super(), this.isLookahead = void 0, this.tokens = [], this.errorHandlers_readInt = { invalidDigit: (e, s, i, a) => this.options.errorRecovery ? (this.raise(f.InvalidDigit, { at: Je(e, s, i), radix: a }), true) : false, numericSeparatorInEscapeSequence: this.errorBuilder(f.NumericSeparatorInEscapeSequence), unexpectedNumericSeparator: this.errorBuilder(f.UnexpectedNumericSeparator) }, this.errorHandlers_readCodePoint = Object.assign({}, this.errorHandlers_readInt, { invalidEscapeSequence: this.errorBuilder(f.InvalidEscapeSequence), invalidCodePoint: this.errorBuilder(f.InvalidCodePoint) }), this.errorHandlers_readStringContents_string = Object.assign({}, this.errorHandlers_readCodePoint, { strictNumericEscape: (e, s, i) => {
                  this.recordStrictModeErrors(f.StrictNumericEscape, { at: Je(e, s, i) });
                }, unterminated: (e, s, i) => {
                  throw this.raise(f.UnterminatedString, { at: Je(e - 1, s, i) });
                } }), this.errorHandlers_readStringContents_template = Object.assign({}, this.errorHandlers_readCodePoint, { strictNumericEscape: this.errorBuilder(f.StrictNumericEscape), unterminated: (e, s, i) => {
                  throw this.raise(f.UnterminatedTemplate, { at: Je(e, s, i) });
                } }), this.state = new Nr(), this.state.init(t3), this.input = r, this.length = r.length, this.isLookahead = false;
              }
              pushToken(t3) {
                this.tokens.length = this.state.tokensLength, this.tokens.push(t3), ++this.state.tokensLength;
              }
              next() {
                this.checkKeywordEscapes(), this.options.tokens && this.pushToken(new Ae(this.state)), this.state.lastTokStart = this.state.start, this.state.lastTokEndLoc = this.state.endLoc, this.state.lastTokStartLoc = this.state.startLoc, this.nextToken();
              }
              eat(t3) {
                return this.match(t3) ? (this.next(), true) : false;
              }
              match(t3) {
                return this.state.type === t3;
              }
              createLookaheadState(t3) {
                return { pos: t3.pos, value: null, type: t3.type, start: t3.start, end: t3.end, context: [this.curContext()], inType: t3.inType, startLoc: t3.startLoc, lastTokEndLoc: t3.lastTokEndLoc, curLine: t3.curLine, lineStart: t3.lineStart, curPosition: t3.curPosition };
              }
              lookahead() {
                let t3 = this.state;
                this.state = this.createLookaheadState(t3), this.isLookahead = true, this.nextToken(), this.isLookahead = false;
                let r = this.state;
                return this.state = t3, r;
              }
              nextTokenStart() {
                return this.nextTokenStartSince(this.state.pos);
              }
              nextTokenStartSince(t3) {
                return ns.lastIndex = t3, ns.test(this.input) ? ns.lastIndex : t3;
              }
              lookaheadCharCode() {
                return this.input.charCodeAt(this.nextTokenStart());
              }
              codePointAtPos(t3) {
                let r = this.input.charCodeAt(t3);
                if ((r & 64512) === 55296 && ++t3 < this.input.length) {
                  let e = this.input.charCodeAt(t3);
                  (e & 64512) === 56320 && (r = 65536 + ((r & 1023) << 10) + (e & 1023));
                }
                return r;
              }
              setStrict(t3) {
                this.state.strict = t3, t3 && (this.state.strictErrors.forEach((r) => {
                  let [e, s] = r;
                  return this.raise(e, { at: s });
                }), this.state.strictErrors.clear());
              }
              curContext() {
                return this.state.context[this.state.context.length - 1];
              }
              nextToken() {
                if (this.skipSpace(), this.state.start = this.state.pos, this.isLookahead || (this.state.startLoc = this.state.curPosition()), this.state.pos >= this.length) {
                  this.finishToken(137);
                  return;
                }
                this.getTokenFromCode(this.codePointAtPos(this.state.pos));
              }
              skipBlockComment(t3) {
                let r;
                this.isLookahead || (r = this.state.curPosition());
                let e = this.state.pos, s = this.input.indexOf(t3, e + 2);
                if (s === -1)
                  throw this.raise(f.UnterminatedComment, { at: this.state.curPosition() });
                for (this.state.pos = s + t3.length, xt.lastIndex = e + 2; xt.test(this.input) && xt.lastIndex <= s; )
                  ++this.state.curLine, this.state.lineStart = xt.lastIndex;
                if (this.isLookahead)
                  return;
                let i = { type: "CommentBlock", value: this.input.slice(e + 2, s), start: e, end: s + t3.length, loc: new lt2(r, this.state.curPosition()) };
                return this.options.tokens && this.pushToken(i), i;
              }
              skipLineComment(t3) {
                let r = this.state.pos, e;
                this.isLookahead || (e = this.state.curPosition());
                let s = this.input.charCodeAt(this.state.pos += t3);
                if (this.state.pos < this.length)
                  for (; !Ge(s) && ++this.state.pos < this.length; )
                    s = this.input.charCodeAt(this.state.pos);
                if (this.isLookahead)
                  return;
                let i = this.state.pos, n = { type: "CommentLine", value: this.input.slice(r + t3, i), start: r, end: i, loc: new lt2(e, this.state.curPosition()) };
                return this.options.tokens && this.pushToken(n), n;
              }
              skipSpace() {
                let t3 = this.state.pos, r = [];
                e:
                  for (; this.state.pos < this.length; ) {
                    let e = this.input.charCodeAt(this.state.pos);
                    switch (e) {
                      case 32:
                      case 160:
                      case 9:
                        ++this.state.pos;
                        break;
                      case 13:
                        this.input.charCodeAt(this.state.pos + 1) === 10 && ++this.state.pos;
                      case 10:
                      case 8232:
                      case 8233:
                        ++this.state.pos, ++this.state.curLine, this.state.lineStart = this.state.pos;
                        break;
                      case 47:
                        switch (this.input.charCodeAt(this.state.pos + 1)) {
                          case 42: {
                            let s = this.skipBlockComment("*/");
                            s !== void 0 && (this.addComment(s), this.options.attachComment && r.push(s));
                            break;
                          }
                          case 47: {
                            let s = this.skipLineComment(2);
                            s !== void 0 && (this.addComment(s), this.options.attachComment && r.push(s));
                            break;
                          }
                          default:
                            break e;
                        }
                        break;
                      default:
                        if (Il(e))
                          ++this.state.pos;
                        else if (e === 45 && !this.inModule && this.options.annexB) {
                          let s = this.state.pos;
                          if (this.input.charCodeAt(s + 1) === 45 && this.input.charCodeAt(s + 2) === 62 && (t3 === 0 || this.state.lineStart > t3)) {
                            let i = this.skipLineComment(3);
                            i !== void 0 && (this.addComment(i), this.options.attachComment && r.push(i));
                          } else
                            break e;
                        } else if (e === 60 && !this.inModule && this.options.annexB) {
                          let s = this.state.pos;
                          if (this.input.charCodeAt(s + 1) === 33 && this.input.charCodeAt(s + 2) === 45 && this.input.charCodeAt(s + 3) === 45) {
                            let i = this.skipLineComment(4);
                            i !== void 0 && (this.addComment(i), this.options.attachComment && r.push(i));
                          } else
                            break e;
                        } else
                          break e;
                    }
                  }
                if (r.length > 0) {
                  let e = this.state.pos, s = { start: t3, end: e, comments: r, leadingNode: null, trailingNode: null, containingNode: null };
                  this.state.commentStack.push(s);
                }
              }
              finishToken(t3, r) {
                this.state.end = this.state.pos, this.state.endLoc = this.state.curPosition();
                let e = this.state.type;
                this.state.type = t3, this.state.value = r, this.isLookahead || this.updateContext(e);
              }
              replaceToken(t3) {
                this.state.type = t3, this.updateContext();
              }
              readToken_numberSign() {
                if (this.state.pos === 0 && this.readToken_interpreter())
                  return;
                let t3 = this.state.pos + 1, r = this.codePointAtPos(t3);
                if (r >= 48 && r <= 57)
                  throw this.raise(f.UnexpectedDigitAfterHash, { at: this.state.curPosition() });
                if (r === 123 || r === 91 && this.hasPlugin("recordAndTuple")) {
                  if (this.expectPlugin("recordAndTuple"), this.getPluginOption("recordAndTuple", "syntaxType") === "bar")
                    throw this.raise(r === 123 ? f.RecordExpressionHashIncorrectStartSyntaxType : f.TupleExpressionHashIncorrectStartSyntaxType, { at: this.state.curPosition() });
                  this.state.pos += 2, r === 123 ? this.finishToken(7) : this.finishToken(1);
                } else
                  fe(r) ? (++this.state.pos, this.finishToken(136, this.readWord1(r))) : r === 92 ? (++this.state.pos, this.finishToken(136, this.readWord1())) : this.finishOp(27, 1);
              }
              readToken_dot() {
                let t3 = this.input.charCodeAt(this.state.pos + 1);
                if (t3 >= 48 && t3 <= 57) {
                  this.readNumber(true);
                  return;
                }
                t3 === 46 && this.input.charCodeAt(this.state.pos + 2) === 46 ? (this.state.pos += 3, this.finishToken(21)) : (++this.state.pos, this.finishToken(16));
              }
              readToken_slash() {
                this.input.charCodeAt(this.state.pos + 1) === 61 ? this.finishOp(31, 2) : this.finishOp(56, 1);
              }
              readToken_interpreter() {
                if (this.state.pos !== 0 || this.length < 2)
                  return false;
                let t3 = this.input.charCodeAt(this.state.pos + 1);
                if (t3 !== 33)
                  return false;
                let r = this.state.pos;
                for (this.state.pos += 1; !Ge(t3) && ++this.state.pos < this.length; )
                  t3 = this.input.charCodeAt(this.state.pos);
                let e = this.input.slice(r + 2, this.state.pos);
                return this.finishToken(28, e), true;
              }
              readToken_mult_modulo(t3) {
                let r = t3 === 42 ? 55 : 54, e = 1, s = this.input.charCodeAt(this.state.pos + 1);
                t3 === 42 && s === 42 && (e++, s = this.input.charCodeAt(this.state.pos + 2), r = 57), s === 61 && !this.state.inType && (e++, r = t3 === 37 ? 33 : 30), this.finishOp(r, e);
              }
              readToken_pipe_amp(t3) {
                let r = this.input.charCodeAt(this.state.pos + 1);
                if (r === t3) {
                  this.input.charCodeAt(this.state.pos + 2) === 61 ? this.finishOp(30, 3) : this.finishOp(t3 === 124 ? 41 : 42, 2);
                  return;
                }
                if (t3 === 124) {
                  if (r === 62) {
                    this.finishOp(39, 2);
                    return;
                  }
                  if (this.hasPlugin("recordAndTuple") && r === 125) {
                    if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                      throw this.raise(f.RecordExpressionBarIncorrectEndSyntaxType, { at: this.state.curPosition() });
                    this.state.pos += 2, this.finishToken(9);
                    return;
                  }
                  if (this.hasPlugin("recordAndTuple") && r === 93) {
                    if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                      throw this.raise(f.TupleExpressionBarIncorrectEndSyntaxType, { at: this.state.curPosition() });
                    this.state.pos += 2, this.finishToken(4);
                    return;
                  }
                }
                if (r === 61) {
                  this.finishOp(30, 2);
                  return;
                }
                this.finishOp(t3 === 124 ? 43 : 45, 1);
              }
              readToken_caret() {
                let t3 = this.input.charCodeAt(this.state.pos + 1);
                t3 === 61 && !this.state.inType ? this.finishOp(32, 2) : t3 === 94 && this.hasPlugin(["pipelineOperator", { proposal: "hack", topicToken: "^^" }]) ? (this.finishOp(37, 2), this.input.codePointAt(this.state.pos) === 94 && this.unexpected()) : this.finishOp(44, 1);
              }
              readToken_atSign() {
                this.input.charCodeAt(this.state.pos + 1) === 64 && this.hasPlugin(["pipelineOperator", { proposal: "hack", topicToken: "@@" }]) ? this.finishOp(38, 2) : this.finishOp(26, 1);
              }
              readToken_plus_min(t3) {
                let r = this.input.charCodeAt(this.state.pos + 1);
                if (r === t3) {
                  this.finishOp(34, 2);
                  return;
                }
                r === 61 ? this.finishOp(30, 2) : this.finishOp(53, 1);
              }
              readToken_lt() {
                let { pos: t3 } = this.state, r = this.input.charCodeAt(t3 + 1);
                if (r === 60) {
                  if (this.input.charCodeAt(t3 + 2) === 61) {
                    this.finishOp(30, 3);
                    return;
                  }
                  this.finishOp(51, 2);
                  return;
                }
                if (r === 61) {
                  this.finishOp(49, 2);
                  return;
                }
                this.finishOp(47, 1);
              }
              readToken_gt() {
                let { pos: t3 } = this.state, r = this.input.charCodeAt(t3 + 1);
                if (r === 62) {
                  let e = this.input.charCodeAt(t3 + 2) === 62 ? 3 : 2;
                  if (this.input.charCodeAt(t3 + e) === 61) {
                    this.finishOp(30, e + 1);
                    return;
                  }
                  this.finishOp(52, e);
                  return;
                }
                if (r === 61) {
                  this.finishOp(49, 2);
                  return;
                }
                this.finishOp(48, 1);
              }
              readToken_eq_excl(t3) {
                let r = this.input.charCodeAt(this.state.pos + 1);
                if (r === 61) {
                  this.finishOp(46, this.input.charCodeAt(this.state.pos + 2) === 61 ? 3 : 2);
                  return;
                }
                if (t3 === 61 && r === 62) {
                  this.state.pos += 2, this.finishToken(19);
                  return;
                }
                this.finishOp(t3 === 61 ? 29 : 35, 1);
              }
              readToken_question() {
                let t3 = this.input.charCodeAt(this.state.pos + 1), r = this.input.charCodeAt(this.state.pos + 2);
                t3 === 63 ? r === 61 ? this.finishOp(30, 3) : this.finishOp(40, 2) : t3 === 46 && !(r >= 48 && r <= 57) ? (this.state.pos += 2, this.finishToken(18)) : (++this.state.pos, this.finishToken(17));
              }
              getTokenFromCode(t3) {
                switch (t3) {
                  case 46:
                    this.readToken_dot();
                    return;
                  case 40:
                    ++this.state.pos, this.finishToken(10);
                    return;
                  case 41:
                    ++this.state.pos, this.finishToken(11);
                    return;
                  case 59:
                    ++this.state.pos, this.finishToken(13);
                    return;
                  case 44:
                    ++this.state.pos, this.finishToken(12);
                    return;
                  case 91:
                    if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                      if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                        throw this.raise(f.TupleExpressionBarIncorrectStartSyntaxType, { at: this.state.curPosition() });
                      this.state.pos += 2, this.finishToken(2);
                    } else
                      ++this.state.pos, this.finishToken(0);
                    return;
                  case 93:
                    ++this.state.pos, this.finishToken(3);
                    return;
                  case 123:
                    if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                      if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                        throw this.raise(f.RecordExpressionBarIncorrectStartSyntaxType, { at: this.state.curPosition() });
                      this.state.pos += 2, this.finishToken(6);
                    } else
                      ++this.state.pos, this.finishToken(5);
                    return;
                  case 125:
                    ++this.state.pos, this.finishToken(8);
                    return;
                  case 58:
                    this.hasPlugin("functionBind") && this.input.charCodeAt(this.state.pos + 1) === 58 ? this.finishOp(15, 2) : (++this.state.pos, this.finishToken(14));
                    return;
                  case 63:
                    this.readToken_question();
                    return;
                  case 96:
                    this.readTemplateToken();
                    return;
                  case 48: {
                    let r = this.input.charCodeAt(this.state.pos + 1);
                    if (r === 120 || r === 88) {
                      this.readRadixNumber(16);
                      return;
                    }
                    if (r === 111 || r === 79) {
                      this.readRadixNumber(8);
                      return;
                    }
                    if (r === 98 || r === 66) {
                      this.readRadixNumber(2);
                      return;
                    }
                  }
                  case 49:
                  case 50:
                  case 51:
                  case 52:
                  case 53:
                  case 54:
                  case 55:
                  case 56:
                  case 57:
                    this.readNumber(false);
                    return;
                  case 34:
                  case 39:
                    this.readString(t3);
                    return;
                  case 47:
                    this.readToken_slash();
                    return;
                  case 37:
                  case 42:
                    this.readToken_mult_modulo(t3);
                    return;
                  case 124:
                  case 38:
                    this.readToken_pipe_amp(t3);
                    return;
                  case 94:
                    this.readToken_caret();
                    return;
                  case 43:
                  case 45:
                    this.readToken_plus_min(t3);
                    return;
                  case 60:
                    this.readToken_lt();
                    return;
                  case 62:
                    this.readToken_gt();
                    return;
                  case 61:
                  case 33:
                    this.readToken_eq_excl(t3);
                    return;
                  case 126:
                    this.finishOp(36, 1);
                    return;
                  case 64:
                    this.readToken_atSign();
                    return;
                  case 35:
                    this.readToken_numberSign();
                    return;
                  case 92:
                    this.readWord();
                    return;
                  default:
                    if (fe(t3)) {
                      this.readWord(t3);
                      return;
                    }
                }
                throw this.raise(f.InvalidOrUnexpectedToken, { at: this.state.curPosition(), unexpected: String.fromCodePoint(t3) });
              }
              finishOp(t3, r) {
                let e = this.input.slice(this.state.pos, this.state.pos + r);
                this.state.pos += r, this.finishToken(t3, e);
              }
              readRegexp() {
                let t3 = this.state.startLoc, r = this.state.start + 1, e, s, { pos: i } = this.state;
                for (; ; ++i) {
                  if (i >= this.length)
                    throw this.raise(f.UnterminatedRegExp, { at: Y(t3, 1) });
                  let u = this.input.charCodeAt(i);
                  if (Ge(u))
                    throw this.raise(f.UnterminatedRegExp, { at: Y(t3, 1) });
                  if (e)
                    e = false;
                  else {
                    if (u === 91)
                      s = true;
                    else if (u === 93 && s)
                      s = false;
                    else if (u === 47 && !s)
                      break;
                    e = u === 92;
                  }
                }
                let a = this.input.slice(r, i);
                ++i;
                let n = "", o = () => Y(t3, i + 2 - r);
                for (; i < this.length; ) {
                  let u = this.codePointAtPos(i), c = String.fromCharCode(u);
                  if (Ol.has(u))
                    u === 118 ? (this.expectPlugin("regexpUnicodeSets", o()), n.includes("u") && this.raise(f.IncompatibleRegExpUVFlags, { at: o() })) : u === 117 && n.includes("v") && this.raise(f.IncompatibleRegExpUVFlags, { at: o() }), n.includes(c) && this.raise(f.DuplicateRegExpFlags, { at: o() });
                  else if (De(u) || u === 92)
                    this.raise(f.MalformedRegExpFlags, { at: o() });
                  else
                    break;
                  ++i, n += c;
                }
                this.state.pos = i, this.finishToken(135, { pattern: a, flags: n });
              }
              readInt(t3, r) {
                let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, { n: i, pos: a } = Fr(this.input, this.state.pos, this.state.lineStart, this.state.curLine, t3, r, e, s, this.errorHandlers_readInt, false);
                return this.state.pos = a, i;
              }
              readRadixNumber(t3) {
                let r = this.state.curPosition(), e = false;
                this.state.pos += 2;
                let s = this.readInt(t3);
                s == null && this.raise(f.InvalidDigit, { at: Y(r, 2), radix: t3 });
                let i = this.input.charCodeAt(this.state.pos);
                if (i === 110)
                  ++this.state.pos, e = true;
                else if (i === 109)
                  throw this.raise(f.InvalidDecimal, { at: r });
                if (fe(this.codePointAtPos(this.state.pos)))
                  throw this.raise(f.NumberIdentifier, { at: this.state.curPosition() });
                if (e) {
                  let a = this.input.slice(r.index, this.state.pos).replace(/[_n]/g, "");
                  this.finishToken(133, a);
                  return;
                }
                this.finishToken(132, s);
              }
              readNumber(t3) {
                let r = this.state.pos, e = this.state.curPosition(), s = false, i = false, a = false, n = false, o = false;
                !t3 && this.readInt(10) === null && this.raise(f.InvalidNumber, { at: this.state.curPosition() });
                let u = this.state.pos - r >= 2 && this.input.charCodeAt(r) === 48;
                if (u) {
                  let T = this.input.slice(r, this.state.pos);
                  if (this.recordStrictModeErrors(f.StrictOctalLiteral, { at: e }), !this.state.strict) {
                    let C = T.indexOf("_");
                    C > 0 && this.raise(f.ZeroDigitNumericSeparator, { at: Y(e, C) });
                  }
                  o = u && !/[89]/.test(T);
                }
                let c = this.input.charCodeAt(this.state.pos);
                if (c === 46 && !o && (++this.state.pos, this.readInt(10), s = true, c = this.input.charCodeAt(this.state.pos)), (c === 69 || c === 101) && !o && (c = this.input.charCodeAt(++this.state.pos), (c === 43 || c === 45) && ++this.state.pos, this.readInt(10) === null && this.raise(f.InvalidOrMissingExponent, { at: e }), s = true, n = true, c = this.input.charCodeAt(this.state.pos)), c === 110 && ((s || u) && this.raise(f.InvalidBigIntLiteral, { at: e }), ++this.state.pos, i = true), c === 109 && (this.expectPlugin("decimal", this.state.curPosition()), (n || u) && this.raise(f.InvalidDecimal, { at: e }), ++this.state.pos, a = true), fe(this.codePointAtPos(this.state.pos)))
                  throw this.raise(f.NumberIdentifier, { at: this.state.curPosition() });
                let y = this.input.slice(r, this.state.pos).replace(/[_mn]/g, "");
                if (i) {
                  this.finishToken(133, y);
                  return;
                }
                if (a) {
                  this.finishToken(134, y);
                  return;
                }
                let g = o ? parseInt(y, 8) : parseFloat(y);
                this.finishToken(132, g);
              }
              readCodePoint(t3) {
                let { code: r, pos: e } = Lr(this.input, this.state.pos, this.state.lineStart, this.state.curLine, t3, this.errorHandlers_readCodePoint);
                return this.state.pos = e, r;
              }
              readString(t3) {
                let { str: r, pos: e, curLine: s, lineStart: i } = Dr(t3 === 34 ? "double" : "single", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_string);
                this.state.pos = e + 1, this.state.lineStart = i, this.state.curLine = s, this.finishToken(131, r);
              }
              readTemplateContinuation() {
                this.match(8) || this.unexpected(null, 8), this.state.pos--, this.readTemplateToken();
              }
              readTemplateToken() {
                let t3 = this.input[this.state.pos], { str: r, firstInvalidLoc: e, pos: s, curLine: i, lineStart: a } = Dr("template", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_template);
                this.state.pos = s + 1, this.state.lineStart = a, this.state.curLine = i, e && (this.state.firstInvalidTemplateEscapePos = new ge(e.curLine, e.pos - e.lineStart, e.pos)), this.input.codePointAt(s) === 96 ? this.finishToken(24, e ? null : t3 + r + "`") : (this.state.pos++, this.finishToken(25, e ? null : t3 + r + "${"));
              }
              recordStrictModeErrors(t3, r) {
                let { at: e } = r, s = e.index;
                this.state.strict && !this.state.strictErrors.has(s) ? this.raise(t3, { at: e }) : this.state.strictErrors.set(s, [t3, e]);
              }
              readWord1(t3) {
                this.state.containsEsc = false;
                let r = "", e = this.state.pos, s = this.state.pos;
                for (t3 !== void 0 && (this.state.pos += t3 <= 65535 ? 1 : 2); this.state.pos < this.length; ) {
                  let i = this.codePointAtPos(this.state.pos);
                  if (De(i))
                    this.state.pos += i <= 65535 ? 1 : 2;
                  else if (i === 92) {
                    this.state.containsEsc = true, r += this.input.slice(s, this.state.pos);
                    let a = this.state.curPosition(), n = this.state.pos === e ? fe : De;
                    if (this.input.charCodeAt(++this.state.pos) !== 117) {
                      this.raise(f.MissingUnicodeEscape, { at: this.state.curPosition() }), s = this.state.pos - 1;
                      continue;
                    }
                    ++this.state.pos;
                    let o = this.readCodePoint(true);
                    o !== null && (n(o) || this.raise(f.EscapedCharNotAnIdentifier, { at: a }), r += String.fromCodePoint(o)), s = this.state.pos;
                  } else
                    break;
                }
                return r + this.input.slice(s, this.state.pos);
              }
              readWord(t3) {
                let r = this.readWord1(t3), e = L.get(r);
                e !== void 0 ? this.finishToken(e, xe(e)) : this.finishToken(130, r);
              }
              checkKeywordEscapes() {
                let { type: t3 } = this.state;
                $t(t3) && this.state.containsEsc && this.raise(f.InvalidEscapedReservedWord, { at: this.state.startLoc, reservedWord: xe(t3) });
              }
              raise(t3, r) {
                let { at: e } = r, s = ot(r, Fl), i = e instanceof ge ? e : e.loc.start, a = t3({ loc: i, details: s });
                if (!this.options.errorRecovery)
                  throw a;
                return this.isLookahead || this.state.errors.push(a), a;
              }
              raiseOverwrite(t3, r) {
                let { at: e } = r, s = ot(r, Ll), i = e instanceof ge ? e : e.loc.start, a = i.index, n = this.state.errors;
                for (let o = n.length - 1; o >= 0; o--) {
                  let u = n[o];
                  if (u.loc.index === a)
                    return n[o] = t3({ loc: i, details: s });
                  if (u.loc.index < a)
                    break;
                }
                return this.raise(t3, r);
              }
              updateContext(t3) {
              }
              unexpected(t3, r) {
                throw this.raise(f.UnexpectedToken, { expected: r ? xe(r) : null, at: t3 != null ? t3 : this.state.startLoc });
              }
              expectPlugin(t3, r) {
                if (this.hasPlugin(t3))
                  return true;
                throw this.raise(f.MissingPlugin, { at: r != null ? r : this.state.startLoc, missingPlugin: [t3] });
              }
              expectOnePlugin(t3) {
                if (!t3.some((r) => this.hasPlugin(r)))
                  throw this.raise(f.MissingOneOfPlugins, { at: this.state.startLoc, missingPlugin: t3 });
              }
              errorBuilder(t3) {
                return (r, e, s) => {
                  this.raise(t3, { at: Je(r, e, s) });
                };
              }
            }, Ml = class {
              constructor() {
                this.privateNames = /* @__PURE__ */ new Set(), this.loneAccessors = /* @__PURE__ */ new Map(), this.undefinedPrivateNames = /* @__PURE__ */ new Map();
              }
            }, _l = class {
              constructor(t3) {
                this.parser = void 0, this.stack = [], this.undefinedPrivateNames = /* @__PURE__ */ new Map(), this.parser = t3;
              }
              current() {
                return this.stack[this.stack.length - 1];
              }
              enter() {
                this.stack.push(new Ml());
              }
              exit() {
                let t3 = this.stack.pop(), r = this.current();
                for (let [e, s] of Array.from(t3.undefinedPrivateNames))
                  r ? r.undefinedPrivateNames.has(e) || r.undefinedPrivateNames.set(e, s) : this.parser.raise(f.InvalidPrivateFieldResolution, { at: s, identifierName: e });
              }
              declarePrivateName(t3, r, e) {
                let { privateNames: s, loneAccessors: i, undefinedPrivateNames: a } = this.current(), n = s.has(t3);
                if (r & ts) {
                  let o = n && i.get(t3);
                  if (o) {
                    let u = o & yt, c = r & yt, y = o & ts, g = r & ts;
                    n = y === g || u !== c, n || i.delete(t3);
                  } else
                    n || i.set(t3, r);
                }
                n && this.parser.raise(f.PrivateNameRedeclaration, { at: e, identifierName: t3 }), s.add(t3), a.delete(t3);
              }
              usePrivateName(t3, r) {
                let e;
                for (e of this.stack)
                  if (e.privateNames.has(t3))
                    return;
                e ? e.undefinedPrivateNames.set(t3, r) : this.parser.raise(f.InvalidPrivateFieldResolution, { at: r, identifierName: t3 });
              }
            }, Rl = 0, Or = 1, ls = 2, Br = 3, Pt = class {
              constructor() {
                let t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Rl;
                this.type = void 0, this.type = t3;
              }
              canBeArrowParameterDeclaration() {
                return this.type === ls || this.type === Or;
              }
              isCertainlyParameterDeclaration() {
                return this.type === Br;
              }
            }, Mr = class extends Pt {
              constructor(t3) {
                super(t3), this.declarationErrors = /* @__PURE__ */ new Map();
              }
              recordDeclarationError(t3, r) {
                let { at: e } = r, s = e.index;
                this.declarationErrors.set(s, [t3, e]);
              }
              clearDeclarationError(t3) {
                this.declarationErrors.delete(t3);
              }
              iterateErrors(t3) {
                this.declarationErrors.forEach(t3);
              }
            }, jl = class {
              constructor(t3) {
                this.parser = void 0, this.stack = [new Pt()], this.parser = t3;
              }
              enter(t3) {
                this.stack.push(t3);
              }
              exit() {
                this.stack.pop();
              }
              recordParameterInitializerError(t3, r) {
                let { at: e } = r, s = { at: e.loc.start }, { stack: i } = this, a = i.length - 1, n = i[a];
                for (; !n.isCertainlyParameterDeclaration(); ) {
                  if (n.canBeArrowParameterDeclaration())
                    n.recordDeclarationError(t3, s);
                  else
                    return;
                  n = i[--a];
                }
                this.parser.raise(t3, s);
              }
              recordArrowParameterBindingError(t3, r) {
                let { at: e } = r, { stack: s } = this, i = s[s.length - 1], a = { at: e.loc.start };
                if (i.isCertainlyParameterDeclaration())
                  this.parser.raise(t3, a);
                else if (i.canBeArrowParameterDeclaration())
                  i.recordDeclarationError(t3, a);
                else
                  return;
              }
              recordAsyncArrowParametersError(t3) {
                let { at: r } = t3, { stack: e } = this, s = e.length - 1, i = e[s];
                for (; i.canBeArrowParameterDeclaration(); )
                  i.type === ls && i.recordDeclarationError(f.AwaitBindingIdentifier, { at: r }), i = e[--s];
              }
              validateAsPattern() {
                let { stack: t3 } = this, r = t3[t3.length - 1];
                r.canBeArrowParameterDeclaration() && r.iterateErrors((e) => {
                  let [s, i] = e;
                  this.parser.raise(s, { at: i });
                  let a = t3.length - 2, n = t3[a];
                  for (; n.canBeArrowParameterDeclaration(); )
                    n.clearDeclarationError(i.index), n = t3[--a];
                });
              }
            };
            function ql() {
              return new Pt(Br);
            }
            function Ul() {
              return new Mr(Or);
            }
            function $l() {
              return new Mr(ls);
            }
            function _r() {
              return new Pt();
            }
            var Me = 0, Rr = 1, At = 2, jr = 4, _e = 8, Hl = class {
              constructor() {
                this.stacks = [];
              }
              enter(t3) {
                this.stacks.push(t3);
              }
              exit() {
                this.stacks.pop();
              }
              currentFlags() {
                return this.stacks[this.stacks.length - 1];
              }
              get hasAwait() {
                return (this.currentFlags() & At) > 0;
              }
              get hasYield() {
                return (this.currentFlags() & Rr) > 0;
              }
              get hasReturn() {
                return (this.currentFlags() & jr) > 0;
              }
              get hasIn() {
                return (this.currentFlags() & _e) > 0;
              }
            };
            function Tt(t3, r) {
              return (t3 ? At : 0) | (r ? Rr : 0);
            }
            var zl = class extends Bl {
              addExtra(t3, r, e) {
                let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
                if (!t3)
                  return;
                let i = t3.extra = t3.extra || {};
                s ? i[r] = e : Object.defineProperty(i, r, { enumerable: s, value: e });
              }
              isContextual(t3) {
                return this.state.type === t3 && !this.state.containsEsc;
              }
              isUnparsedContextual(t3, r) {
                let e = t3 + r.length;
                if (this.input.slice(t3, e) === r) {
                  let s = this.input.charCodeAt(e);
                  return !(De(s) || (s & 64512) === 55296);
                }
                return false;
              }
              isLookaheadContextual(t3) {
                let r = this.nextTokenStart();
                return this.isUnparsedContextual(r, t3);
              }
              eatContextual(t3) {
                return this.isContextual(t3) ? (this.next(), true) : false;
              }
              expectContextual(t3, r) {
                if (!this.eatContextual(t3)) {
                  if (r != null)
                    throw this.raise(r, { at: this.state.startLoc });
                  this.unexpected(null, t3);
                }
              }
              canInsertSemicolon() {
                return this.match(137) || this.match(8) || this.hasPrecedingLineBreak();
              }
              hasPrecedingLineBreak() {
                return as.test(this.input.slice(this.state.lastTokEndLoc.index, this.state.start));
              }
              hasFollowingLineBreak() {
                return Ir.lastIndex = this.state.end, Ir.test(this.input);
              }
              isLineTerminator() {
                return this.eat(13) || this.canInsertSemicolon();
              }
              semicolon() {
                ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true) ? this.isLineTerminator() : this.eat(13)) || this.raise(f.MissingSemicolon, { at: this.state.lastTokEndLoc });
              }
              expect(t3, r) {
                this.eat(t3) || this.unexpected(r, t3);
              }
              tryParse(t3) {
                let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.clone(), e = { node: null };
                try {
                  let s = t3(function() {
                    let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                    throw e.node = i, e;
                  });
                  if (this.state.errors.length > r.errors.length) {
                    let i = this.state;
                    return this.state = r, this.state.tokensLength = i.tokensLength, { node: s, error: i.errors[r.errors.length], thrown: false, aborted: false, failState: i };
                  }
                  return { node: s, error: null, thrown: false, aborted: false, failState: null };
                } catch (s) {
                  let i = this.state;
                  if (this.state = r, s instanceof SyntaxError)
                    return { node: null, error: s, thrown: true, aborted: false, failState: i };
                  if (s === e)
                    return { node: e.node, error: null, thrown: false, aborted: true, failState: i };
                  throw s;
                }
              }
              checkExpressionErrors(t3, r) {
                if (!t3)
                  return false;
                let { shorthandAssignLoc: e, doubleProtoLoc: s, privateKeyLoc: i, optionalParametersLoc: a } = t3, n = !!e || !!s || !!a || !!i;
                if (!r)
                  return n;
                e != null && this.raise(f.InvalidCoverInitializedName, { at: e }), s != null && this.raise(f.DuplicateProto, { at: s }), i != null && this.raise(f.UnexpectedPrivateField, { at: i }), a != null && this.unexpected(a);
              }
              isLiteralPropertyName() {
                return it(this.state.type);
              }
              isPrivateName(t3) {
                return t3.type === "PrivateName";
              }
              getPrivateNameSV(t3) {
                return t3.id.name;
              }
              hasPropertyAsPrivateName(t3) {
                return (t3.type === "MemberExpression" || t3.type === "OptionalMemberExpression") && this.isPrivateName(t3.property);
              }
              isObjectProperty(t3) {
                return t3.type === "ObjectProperty";
              }
              isObjectMethod(t3) {
                return t3.type === "ObjectMethod";
              }
              initializeScopes() {
                let t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options.sourceType === "module", r = this.state.labels;
                this.state.labels = [];
                let e = this.exportedIdentifiers;
                this.exportedIdentifiers = /* @__PURE__ */ new Set();
                let s = this.inModule;
                this.inModule = t3;
                let i = this.scope, a = this.getScopeHandler();
                this.scope = new a(this, t3);
                let n = this.prodParam;
                this.prodParam = new Hl();
                let o = this.classScope;
                this.classScope = new _l(this);
                let u = this.expressionScope;
                return this.expressionScope = new jl(this), () => {
                  this.state.labels = r, this.exportedIdentifiers = e, this.inModule = s, this.scope = i, this.prodParam = n, this.classScope = o, this.expressionScope = u;
                };
              }
              enterInitialScopes() {
                let t3 = Me;
                this.inModule && (t3 |= At), this.scope.enter(Le), this.prodParam.enter(t3);
              }
              checkDestructuringPrivate(t3) {
                let { privateKeyLoc: r } = t3;
                r !== null && this.expectPlugin("destructuringPrivate", r);
              }
            }, vt = class {
              constructor() {
                this.shorthandAssignLoc = null, this.doubleProtoLoc = null, this.privateKeyLoc = null, this.optionalParametersLoc = null;
              }
            }, Et = class {
              constructor(t3, r, e) {
                this.type = "", this.start = r, this.end = 0, this.loc = new lt2(e), t3 != null && t3.options.ranges && (this.range = [r, 0]), t3 != null && t3.filename && (this.loc.filename = t3.filename);
              }
            }, hs = Et.prototype;
            hs.__clone = function() {
              let t3 = new Et(void 0, this.start, this.loc.start), r = Object.keys(this);
              for (let e = 0, s = r.length; e < s; e++) {
                let i = r[e];
                i !== "leadingComments" && i !== "trailingComments" && i !== "innerComments" && (t3[i] = this[i]);
              }
              return t3;
            };
            function Vl(t3) {
              return me(t3);
            }
            function me(t3) {
              let { type: r, start: e, end: s, loc: i, range: a, extra: n, name: o } = t3, u = Object.create(hs);
              return u.type = r, u.start = e, u.end = s, u.loc = i, u.range = a, u.extra = n, u.name = o, r === "Placeholder" && (u.expectedNode = t3.expectedNode), u;
            }
            function Kl(t3) {
              let { type: r, start: e, end: s, loc: i, range: a, extra: n } = t3;
              if (r === "Placeholder")
                return Vl(t3);
              let o = Object.create(hs);
              return o.type = r, o.start = e, o.end = s, o.loc = i, o.range = a, t3.raw !== void 0 ? o.raw = t3.raw : o.extra = n, o.value = t3.value, o;
            }
            var Wl = class extends zl {
              startNode() {
                return new Et(this, this.state.start, this.state.startLoc);
              }
              startNodeAt(t3) {
                return new Et(this, t3.index, t3);
              }
              startNodeAtNode(t3) {
                return this.startNodeAt(t3.loc.start);
              }
              finishNode(t3, r) {
                return this.finishNodeAt(t3, r, this.state.lastTokEndLoc);
              }
              finishNodeAt(t3, r, e) {
                return t3.type = r, t3.end = e.index, t3.loc.end = e, this.options.ranges && (t3.range[1] = e.index), this.options.attachComment && this.processComment(t3), t3;
              }
              resetStartLocation(t3, r) {
                t3.start = r.index, t3.loc.start = r, this.options.ranges && (t3.range[0] = r.index);
              }
              resetEndLocation(t3) {
                let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.lastTokEndLoc;
                t3.end = r.index, t3.loc.end = r, this.options.ranges && (t3.range[1] = r.index);
              }
              resetStartLocationFromNode(t3, r) {
                this.resetStartLocation(t3, r.loc.start);
              }
            }, Gl = /* @__PURE__ */ new Set(["_", "any", "bool", "boolean", "empty", "extends", "false", "interface", "mixed", "null", "number", "static", "string", "true", "typeof", "void"]), D = pe`flow`({ AmbiguousConditionalArrow: "Ambiguous expression: wrap the arrow functions in parentheses to disambiguate.", AmbiguousDeclareModuleKind: "Found both `declare module.exports` and `declare export` in the same module. Modules can only have 1 since they are either an ES module or they are a CommonJS module.", AssignReservedType: (t3) => {
              let { reservedType: r } = t3;
              return `Cannot overwrite reserved type ${r}.`;
            }, DeclareClassElement: "The `declare` modifier can only appear on class fields.", DeclareClassFieldInitializer: "Initializers are not allowed in fields with the `declare` modifier.", DuplicateDeclareModuleExports: "Duplicate `declare module.exports` statement.", EnumBooleanMemberNotInitialized: (t3) => {
              let { memberName: r, enumName: e } = t3;
              return `Boolean enum members need to be initialized. Use either \`${r} = true,\` or \`${r} = false,\` in enum \`${e}\`.`;
            }, EnumDuplicateMemberName: (t3) => {
              let { memberName: r, enumName: e } = t3;
              return `Enum member names need to be unique, but the name \`${r}\` has already been used before in enum \`${e}\`.`;
            }, EnumInconsistentMemberValues: (t3) => {
              let { enumName: r } = t3;
              return `Enum \`${r}\` has inconsistent member initializers. Either use no initializers, or consistently use literals (either booleans, numbers, or strings) for all member initializers.`;
            }, EnumInvalidExplicitType: (t3) => {
              let { invalidEnumType: r, enumName: e } = t3;
              return `Enum type \`${r}\` is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${e}\`.`;
            }, EnumInvalidExplicitTypeUnknownSupplied: (t3) => {
              let { enumName: r } = t3;
              return `Supplied enum type is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${r}\`.`;
            }, EnumInvalidMemberInitializerPrimaryType: (t3) => {
              let { enumName: r, memberName: e, explicitType: s } = t3;
              return `Enum \`${r}\` has type \`${s}\`, so the initializer of \`${e}\` needs to be a ${s} literal.`;
            }, EnumInvalidMemberInitializerSymbolType: (t3) => {
              let { enumName: r, memberName: e } = t3;
              return `Symbol enum members cannot be initialized. Use \`${e},\` in enum \`${r}\`.`;
            }, EnumInvalidMemberInitializerUnknownType: (t3) => {
              let { enumName: r, memberName: e } = t3;
              return `The enum member initializer for \`${e}\` needs to be a literal (either a boolean, number, or string) in enum \`${r}\`.`;
            }, EnumInvalidMemberName: (t3) => {
              let { enumName: r, memberName: e, suggestion: s } = t3;
              return `Enum member names cannot start with lowercase 'a' through 'z'. Instead of using \`${e}\`, consider using \`${s}\`, in enum \`${r}\`.`;
            }, EnumNumberMemberNotInitialized: (t3) => {
              let { enumName: r, memberName: e } = t3;
              return `Number enum members need to be initialized, e.g. \`${e} = 1\` in enum \`${r}\`.`;
            }, EnumStringMemberInconsistentlyInitailized: (t3) => {
              let { enumName: r } = t3;
              return `String enum members need to consistently either all use initializers, or use no initializers, in enum \`${r}\`.`;
            }, GetterMayNotHaveThisParam: "A getter cannot have a `this` parameter.", ImportReflectionHasImportType: "An `import module` declaration can not use `type` or `typeof` keyword.", ImportTypeShorthandOnlyInPureImport: "The `type` and `typeof` keywords on named imports can only be used on regular `import` statements. It cannot be used with `import type` or `import typeof` statements.", InexactInsideExact: "Explicit inexact syntax cannot appear inside an explicit exact object type.", InexactInsideNonObject: "Explicit inexact syntax cannot appear in class or interface definitions.", InexactVariance: "Explicit inexact syntax cannot have variance.", InvalidNonTypeImportInDeclareModule: "Imports within a `declare module` body must always be `import type` or `import typeof`.", MissingTypeParamDefault: "Type parameter declaration needs a default, since a preceding type parameter declaration has a default.", NestedDeclareModule: "`declare module` cannot be used inside another `declare module`.", NestedFlowComment: "Cannot have a flow comment inside another flow comment.", PatternIsOptional: Object.assign({ message: "A binding pattern parameter cannot be optional in an implementation signature." }, { reasonCode: "OptionalBindingPattern" }), SetterMayNotHaveThisParam: "A setter cannot have a `this` parameter.", SpreadVariance: "Spread properties cannot have variance.", ThisParamAnnotationRequired: "A type annotation is required for the `this` parameter.", ThisParamBannedInConstructor: "Constructors cannot have a `this` parameter; constructors don't bind `this` like other functions.", ThisParamMayNotBeOptional: "The `this` parameter cannot be optional.", ThisParamMustBeFirst: "The `this` parameter must be the first function parameter.", ThisParamNoDefault: "The `this` parameter may not have a default value.", TypeBeforeInitializer: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.", TypeCastInPattern: "The type cast expression is expected to be wrapped with parenthesis.", UnexpectedExplicitInexactInObject: "Explicit inexact syntax must appear at the end of an inexact object.", UnexpectedReservedType: (t3) => {
              let { reservedType: r } = t3;
              return `Unexpected reserved type ${r}.`;
            }, UnexpectedReservedUnderscore: "`_` is only allowed as a type argument to call or new.", UnexpectedSpaceBetweenModuloChecks: "Spaces between `%` and `checks` are not allowed here.", UnexpectedSpreadType: "Spread operator cannot appear in class or interface definitions.", UnexpectedSubtractionOperand: 'Unexpected token, expected "number" or "bigint".', UnexpectedTokenAfterTypeParameter: "Expected an arrow function after this type parameter declaration.", UnexpectedTypeParameterBeforeAsyncArrowFunction: "Type parameters must come after the async keyword, e.g. instead of `<T> async () => {}`, use `async <T>() => {}`.", UnsupportedDeclareExportKind: (t3) => {
              let { unsupportedExportKind: r, suggestion: e } = t3;
              return `\`declare export ${r}\` is not supported. Use \`${e}\` instead.`;
            }, UnsupportedStatementInDeclareModule: "Only declares and type imports are allowed inside declare module.", UnterminatedFlowComment: "Unterminated flow-comment." });
            function Jl(t3) {
              return t3.type === "DeclareExportAllDeclaration" || t3.type === "DeclareExportDeclaration" && (!t3.declaration || t3.declaration.type !== "TypeAlias" && t3.declaration.type !== "InterfaceDeclaration");
            }
            function us(t3) {
              return t3.importKind === "type" || t3.importKind === "typeof";
            }
            function qr(t3) {
              return te(t3) && t3 !== 97;
            }
            var Xl = { const: "declare export var", let: "declare export var", type: "export type", interface: "export interface" };
            function Yl(t3, r) {
              let e = [], s = [];
              for (let i = 0; i < t3.length; i++)
                (r(t3[i], i, t3) ? e : s).push(t3[i]);
              return [e, s];
            }
            var Ql = /\*?\s*@((?:no)?flow)\b/, Zl = (t3) => class extends t3 {
              constructor() {
                super(...arguments), this.flowPragma = void 0;
              }
              getScopeHandler() {
                return El;
              }
              shouldParseTypes() {
                return this.getPluginOption("flow", "all") || this.flowPragma === "flow";
              }
              shouldParseEnums() {
                return !!this.getPluginOption("flow", "enums");
              }
              finishToken(e, s) {
                e !== 131 && e !== 13 && e !== 28 && this.flowPragma === void 0 && (this.flowPragma = null), super.finishToken(e, s);
              }
              addComment(e) {
                if (this.flowPragma === void 0) {
                  let s = Ql.exec(e.value);
                  if (s)
                    if (s[1] === "flow")
                      this.flowPragma = "flow";
                    else if (s[1] === "noflow")
                      this.flowPragma = "noflow";
                    else
                      throw new Error("Unexpected flow pragma");
                }
                super.addComment(e);
              }
              flowParseTypeInitialiser(e) {
                let s = this.state.inType;
                this.state.inType = true, this.expect(e || 14);
                let i = this.flowParseType();
                return this.state.inType = s, i;
              }
              flowParsePredicate() {
                let e = this.startNode(), s = this.state.startLoc;
                return this.next(), this.expectContextual(108), this.state.lastTokStart > s.index + 1 && this.raise(D.UnexpectedSpaceBetweenModuloChecks, { at: s }), this.eat(10) ? (e.value = super.parseExpression(), this.expect(11), this.finishNode(e, "DeclaredPredicate")) : this.finishNode(e, "InferredPredicate");
              }
              flowParseTypeAndPredicateInitialiser() {
                let e = this.state.inType;
                this.state.inType = true, this.expect(14);
                let s = null, i = null;
                return this.match(54) ? (this.state.inType = e, i = this.flowParsePredicate()) : (s = this.flowParseType(), this.state.inType = e, this.match(54) && (i = this.flowParsePredicate())), [s, i];
              }
              flowParseDeclareClass(e) {
                return this.next(), this.flowParseInterfaceish(e, true), this.finishNode(e, "DeclareClass");
              }
              flowParseDeclareFunction(e) {
                this.next();
                let s = e.id = this.parseIdentifier(), i = this.startNode(), a = this.startNode();
                this.match(47) ? i.typeParameters = this.flowParseTypeParameterDeclaration() : i.typeParameters = null, this.expect(10);
                let n = this.flowParseFunctionTypeParams();
                return i.params = n.params, i.rest = n.rest, i.this = n._this, this.expect(11), [i.returnType, e.predicate] = this.flowParseTypeAndPredicateInitialiser(), a.typeAnnotation = this.finishNode(i, "FunctionTypeAnnotation"), s.typeAnnotation = this.finishNode(a, "TypeAnnotation"), this.resetEndLocation(s), this.semicolon(), this.scope.declareName(e.id.name, xl, e.id.loc.start), this.finishNode(e, "DeclareFunction");
              }
              flowParseDeclare(e, s) {
                if (this.match(80))
                  return this.flowParseDeclareClass(e);
                if (this.match(68))
                  return this.flowParseDeclareFunction(e);
                if (this.match(74))
                  return this.flowParseDeclareVariable(e);
                if (this.eatContextual(125))
                  return this.match(16) ? this.flowParseDeclareModuleExports(e) : (s && this.raise(D.NestedDeclareModule, { at: this.state.lastTokStartLoc }), this.flowParseDeclareModule(e));
                if (this.isContextual(128))
                  return this.flowParseDeclareTypeAlias(e);
                if (this.isContextual(129))
                  return this.flowParseDeclareOpaqueType(e);
                if (this.isContextual(127))
                  return this.flowParseDeclareInterface(e);
                if (this.match(82))
                  return this.flowParseDeclareExportDeclaration(e, s);
                this.unexpected();
              }
              flowParseDeclareVariable(e) {
                return this.next(), e.id = this.flowParseTypeAnnotatableIdentifier(true), this.scope.declareName(e.id.name, mt, e.id.loc.start), this.semicolon(), this.finishNode(e, "DeclareVariable");
              }
              flowParseDeclareModule(e) {
                this.scope.enter(Fe), this.match(131) ? e.id = super.parseExprAtom() : e.id = this.parseIdentifier();
                let s = e.body = this.startNode(), i = s.body = [];
                for (this.expect(5); !this.match(8); ) {
                  let o = this.startNode();
                  this.match(83) ? (this.next(), !this.isContextual(128) && !this.match(87) && this.raise(D.InvalidNonTypeImportInDeclareModule, { at: this.state.lastTokStartLoc }), super.parseImport(o)) : (this.expectContextual(123, D.UnsupportedStatementInDeclareModule), o = this.flowParseDeclare(o, true)), i.push(o);
                }
                this.scope.exit(), this.expect(8), this.finishNode(s, "BlockStatement");
                let a = null, n = false;
                return i.forEach((o) => {
                  Jl(o) ? (a === "CommonJS" && this.raise(D.AmbiguousDeclareModuleKind, { at: o }), a = "ES") : o.type === "DeclareModuleExports" && (n && this.raise(D.DuplicateDeclareModuleExports, { at: o }), a === "ES" && this.raise(D.AmbiguousDeclareModuleKind, { at: o }), a = "CommonJS", n = true);
                }), e.kind = a || "CommonJS", this.finishNode(e, "DeclareModule");
              }
              flowParseDeclareExportDeclaration(e, s) {
                if (this.expect(82), this.eat(65))
                  return this.match(68) || this.match(80) ? e.declaration = this.flowParseDeclare(this.startNode()) : (e.declaration = this.flowParseType(), this.semicolon()), e.default = true, this.finishNode(e, "DeclareExportDeclaration");
                if (this.match(75) || this.isLet() || (this.isContextual(128) || this.isContextual(127)) && !s) {
                  let i = this.state.value;
                  throw this.raise(D.UnsupportedDeclareExportKind, { at: this.state.startLoc, unsupportedExportKind: i, suggestion: Xl[i] });
                }
                if (this.match(74) || this.match(68) || this.match(80) || this.isContextual(129))
                  return e.declaration = this.flowParseDeclare(this.startNode()), e.default = false, this.finishNode(e, "DeclareExportDeclaration");
                if (this.match(55) || this.match(5) || this.isContextual(127) || this.isContextual(128) || this.isContextual(129))
                  return e = this.parseExport(e, null), e.type === "ExportNamedDeclaration" && (e.type = "ExportDeclaration", e.default = false, delete e.exportKind), e.type = "Declare" + e.type, e;
                this.unexpected();
              }
              flowParseDeclareModuleExports(e) {
                return this.next(), this.expectContextual(109), e.typeAnnotation = this.flowParseTypeAnnotation(), this.semicolon(), this.finishNode(e, "DeclareModuleExports");
              }
              flowParseDeclareTypeAlias(e) {
                this.next();
                let s = this.flowParseTypeAlias(e);
                return s.type = "DeclareTypeAlias", s;
              }
              flowParseDeclareOpaqueType(e) {
                this.next();
                let s = this.flowParseOpaqueType(e, true);
                return s.type = "DeclareOpaqueType", s;
              }
              flowParseDeclareInterface(e) {
                return this.next(), this.flowParseInterfaceish(e, false), this.finishNode(e, "DeclareInterface");
              }
              flowParseInterfaceish(e, s) {
                if (e.id = this.flowParseRestrictedIdentifier(!s, true), this.scope.declareName(e.id.name, s ? Er : Be, e.id.loc.start), this.match(47) ? e.typeParameters = this.flowParseTypeParameterDeclaration() : e.typeParameters = null, e.extends = [], e.implements = [], e.mixins = [], this.eat(81))
                  do
                    e.extends.push(this.flowParseInterfaceExtends());
                  while (!s && this.eat(12));
                if (s) {
                  if (this.eatContextual(115))
                    do
                      e.mixins.push(this.flowParseInterfaceExtends());
                    while (this.eat(12));
                  if (this.eatContextual(111))
                    do
                      e.implements.push(this.flowParseInterfaceExtends());
                    while (this.eat(12));
                }
                e.body = this.flowParseObjectType({ allowStatic: s, allowExact: false, allowSpread: false, allowProto: s, allowInexact: false });
              }
              flowParseInterfaceExtends() {
                let e = this.startNode();
                return e.id = this.flowParseQualifiedTypeIdentifier(), this.match(47) ? e.typeParameters = this.flowParseTypeParameterInstantiation() : e.typeParameters = null, this.finishNode(e, "InterfaceExtends");
              }
              flowParseInterface(e) {
                return this.flowParseInterfaceish(e, false), this.finishNode(e, "InterfaceDeclaration");
              }
              checkNotUnderscore(e) {
                e === "_" && this.raise(D.UnexpectedReservedUnderscore, { at: this.state.startLoc });
              }
              checkReservedType(e, s, i) {
                Gl.has(e) && this.raise(i ? D.AssignReservedType : D.UnexpectedReservedType, { at: s, reservedType: e });
              }
              flowParseRestrictedIdentifier(e, s) {
                return this.checkReservedType(this.state.value, this.state.startLoc, s), this.parseIdentifier(e);
              }
              flowParseTypeAlias(e) {
                return e.id = this.flowParseRestrictedIdentifier(false, true), this.scope.declareName(e.id.name, Be, e.id.loc.start), this.match(47) ? e.typeParameters = this.flowParseTypeParameterDeclaration() : e.typeParameters = null, e.right = this.flowParseTypeInitialiser(29), this.semicolon(), this.finishNode(e, "TypeAlias");
              }
              flowParseOpaqueType(e, s) {
                return this.expectContextual(128), e.id = this.flowParseRestrictedIdentifier(true, true), this.scope.declareName(e.id.name, Be, e.id.loc.start), this.match(47) ? e.typeParameters = this.flowParseTypeParameterDeclaration() : e.typeParameters = null, e.supertype = null, this.match(14) && (e.supertype = this.flowParseTypeInitialiser(14)), e.impltype = null, s || (e.impltype = this.flowParseTypeInitialiser(29)), this.semicolon(), this.finishNode(e, "OpaqueType");
              }
              flowParseTypeParameter() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, s = this.state.startLoc, i = this.startNode(), a = this.flowParseVariance(), n = this.flowParseTypeAnnotatableIdentifier();
                return i.name = n.name, i.variance = a, i.bound = n.typeAnnotation, this.match(29) ? (this.eat(29), i.default = this.flowParseType()) : e && this.raise(D.MissingTypeParamDefault, { at: s }), this.finishNode(i, "TypeParameter");
              }
              flowParseTypeParameterDeclaration() {
                let e = this.state.inType, s = this.startNode();
                s.params = [], this.state.inType = true, this.match(47) || this.match(140) ? this.next() : this.unexpected();
                let i = false;
                do {
                  let a = this.flowParseTypeParameter(i);
                  s.params.push(a), a.default && (i = true), this.match(48) || this.expect(12);
                } while (!this.match(48));
                return this.expect(48), this.state.inType = e, this.finishNode(s, "TypeParameterDeclaration");
              }
              flowParseTypeParameterInstantiation() {
                let e = this.startNode(), s = this.state.inType;
                e.params = [], this.state.inType = true, this.expect(47);
                let i = this.state.noAnonFunctionType;
                for (this.state.noAnonFunctionType = false; !this.match(48); )
                  e.params.push(this.flowParseType()), this.match(48) || this.expect(12);
                return this.state.noAnonFunctionType = i, this.expect(48), this.state.inType = s, this.finishNode(e, "TypeParameterInstantiation");
              }
              flowParseTypeParameterInstantiationCallOrNew() {
                let e = this.startNode(), s = this.state.inType;
                for (e.params = [], this.state.inType = true, this.expect(47); !this.match(48); )
                  e.params.push(this.flowParseTypeOrImplicitInstantiation()), this.match(48) || this.expect(12);
                return this.expect(48), this.state.inType = s, this.finishNode(e, "TypeParameterInstantiation");
              }
              flowParseInterfaceType() {
                let e = this.startNode();
                if (this.expectContextual(127), e.extends = [], this.eat(81))
                  do
                    e.extends.push(this.flowParseInterfaceExtends());
                  while (this.eat(12));
                return e.body = this.flowParseObjectType({ allowStatic: false, allowExact: false, allowSpread: false, allowProto: false, allowInexact: false }), this.finishNode(e, "InterfaceTypeAnnotation");
              }
              flowParseObjectPropertyKey() {
                return this.match(132) || this.match(131) ? super.parseExprAtom() : this.parseIdentifier(true);
              }
              flowParseObjectTypeIndexer(e, s, i) {
                return e.static = s, this.lookahead().type === 14 ? (e.id = this.flowParseObjectPropertyKey(), e.key = this.flowParseTypeInitialiser()) : (e.id = null, e.key = this.flowParseType()), this.expect(3), e.value = this.flowParseTypeInitialiser(), e.variance = i, this.finishNode(e, "ObjectTypeIndexer");
              }
              flowParseObjectTypeInternalSlot(e, s) {
                return e.static = s, e.id = this.flowParseObjectPropertyKey(), this.expect(3), this.expect(3), this.match(47) || this.match(10) ? (e.method = true, e.optional = false, e.value = this.flowParseObjectTypeMethodish(this.startNodeAt(e.loc.start))) : (e.method = false, this.eat(17) && (e.optional = true), e.value = this.flowParseTypeInitialiser()), this.finishNode(e, "ObjectTypeInternalSlot");
              }
              flowParseObjectTypeMethodish(e) {
                for (e.params = [], e.rest = null, e.typeParameters = null, e.this = null, this.match(47) && (e.typeParameters = this.flowParseTypeParameterDeclaration()), this.expect(10), this.match(78) && (e.this = this.flowParseFunctionTypeParam(true), e.this.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21); )
                  e.params.push(this.flowParseFunctionTypeParam(false)), this.match(11) || this.expect(12);
                return this.eat(21) && (e.rest = this.flowParseFunctionTypeParam(false)), this.expect(11), e.returnType = this.flowParseTypeInitialiser(), this.finishNode(e, "FunctionTypeAnnotation");
              }
              flowParseObjectTypeCallProperty(e, s) {
                let i = this.startNode();
                return e.static = s, e.value = this.flowParseObjectTypeMethodish(i), this.finishNode(e, "ObjectTypeCallProperty");
              }
              flowParseObjectType(e) {
                let { allowStatic: s, allowExact: i, allowSpread: a, allowProto: n, allowInexact: o } = e, u = this.state.inType;
                this.state.inType = true;
                let c = this.startNode();
                c.callProperties = [], c.properties = [], c.indexers = [], c.internalSlots = [];
                let y, g, T = false;
                for (i && this.match(6) ? (this.expect(6), y = 9, g = true) : (this.expect(5), y = 8, g = false), c.exact = g; !this.match(y); ) {
                  let M = false, j = null, K = null, W = this.startNode();
                  if (n && this.isContextual(116)) {
                    let X = this.lookahead();
                    X.type !== 14 && X.type !== 17 && (this.next(), j = this.state.startLoc, s = false);
                  }
                  if (s && this.isContextual(104)) {
                    let X = this.lookahead();
                    X.type !== 14 && X.type !== 17 && (this.next(), M = true);
                  }
                  let V = this.flowParseVariance();
                  if (this.eat(0))
                    j != null && this.unexpected(j), this.eat(0) ? (V && this.unexpected(V.loc.start), c.internalSlots.push(this.flowParseObjectTypeInternalSlot(W, M))) : c.indexers.push(this.flowParseObjectTypeIndexer(W, M, V));
                  else if (this.match(10) || this.match(47))
                    j != null && this.unexpected(j), V && this.unexpected(V.loc.start), c.callProperties.push(this.flowParseObjectTypeCallProperty(W, M));
                  else {
                    let X = "init";
                    if (this.isContextual(98) || this.isContextual(103)) {
                      let Nh = this.lookahead();
                      it(Nh.type) && (X = this.state.value, this.next());
                    }
                    let je = this.flowParseObjectTypeProperty(W, M, j, V, X, a, o != null ? o : !g);
                    je === null ? (T = true, K = this.state.lastTokStartLoc) : c.properties.push(je);
                  }
                  this.flowObjectTypeSemicolon(), K && !this.match(8) && !this.match(9) && this.raise(D.UnexpectedExplicitInexactInObject, { at: K });
                }
                this.expect(y), a && (c.inexact = T);
                let C = this.finishNode(c, "ObjectTypeAnnotation");
                return this.state.inType = u, C;
              }
              flowParseObjectTypeProperty(e, s, i, a, n, o, u) {
                if (this.eat(21))
                  return this.match(12) || this.match(13) || this.match(8) || this.match(9) ? (o ? u || this.raise(D.InexactInsideExact, { at: this.state.lastTokStartLoc }) : this.raise(D.InexactInsideNonObject, { at: this.state.lastTokStartLoc }), a && this.raise(D.InexactVariance, { at: a }), null) : (o || this.raise(D.UnexpectedSpreadType, { at: this.state.lastTokStartLoc }), i != null && this.unexpected(i), a && this.raise(D.SpreadVariance, { at: a }), e.argument = this.flowParseType(), this.finishNode(e, "ObjectTypeSpreadProperty"));
                {
                  e.key = this.flowParseObjectPropertyKey(), e.static = s, e.proto = i != null, e.kind = n;
                  let c = false;
                  return this.match(47) || this.match(10) ? (e.method = true, i != null && this.unexpected(i), a && this.unexpected(a.loc.start), e.value = this.flowParseObjectTypeMethodish(this.startNodeAt(e.loc.start)), (n === "get" || n === "set") && this.flowCheckGetterSetterParams(e), !o && e.key.name === "constructor" && e.value.this && this.raise(D.ThisParamBannedInConstructor, { at: e.value.this })) : (n !== "init" && this.unexpected(), e.method = false, this.eat(17) && (c = true), e.value = this.flowParseTypeInitialiser(), e.variance = a), e.optional = c, this.finishNode(e, "ObjectTypeProperty");
                }
              }
              flowCheckGetterSetterParams(e) {
                let s = e.kind === "get" ? 0 : 1, i = e.value.params.length + (e.value.rest ? 1 : 0);
                e.value.this && this.raise(e.kind === "get" ? D.GetterMayNotHaveThisParam : D.SetterMayNotHaveThisParam, { at: e.value.this }), i !== s && this.raise(e.kind === "get" ? f.BadGetterArity : f.BadSetterArity, { at: e }), e.kind === "set" && e.value.rest && this.raise(f.BadSetterRestParameter, { at: e });
              }
              flowObjectTypeSemicolon() {
                !this.eat(13) && !this.eat(12) && !this.match(8) && !this.match(9) && this.unexpected();
              }
              flowParseQualifiedTypeIdentifier(e, s) {
                var i;
                (i = e) != null || (e = this.state.startLoc);
                let a = s || this.flowParseRestrictedIdentifier(true);
                for (; this.eat(16); ) {
                  let n = this.startNodeAt(e);
                  n.qualification = a, n.id = this.flowParseRestrictedIdentifier(true), a = this.finishNode(n, "QualifiedTypeIdentifier");
                }
                return a;
              }
              flowParseGenericType(e, s) {
                let i = this.startNodeAt(e);
                return i.typeParameters = null, i.id = this.flowParseQualifiedTypeIdentifier(e, s), this.match(47) && (i.typeParameters = this.flowParseTypeParameterInstantiation()), this.finishNode(i, "GenericTypeAnnotation");
              }
              flowParseTypeofType() {
                let e = this.startNode();
                return this.expect(87), e.argument = this.flowParsePrimaryType(), this.finishNode(e, "TypeofTypeAnnotation");
              }
              flowParseTupleType() {
                let e = this.startNode();
                for (e.types = [], this.expect(0); this.state.pos < this.length && !this.match(3) && (e.types.push(this.flowParseType()), !this.match(3)); )
                  this.expect(12);
                return this.expect(3), this.finishNode(e, "TupleTypeAnnotation");
              }
              flowParseFunctionTypeParam(e) {
                let s = null, i = false, a = null, n = this.startNode(), o = this.lookahead(), u = this.state.type === 78;
                return o.type === 14 || o.type === 17 ? (u && !e && this.raise(D.ThisParamMustBeFirst, { at: n }), s = this.parseIdentifier(u), this.eat(17) && (i = true, u && this.raise(D.ThisParamMayNotBeOptional, { at: n })), a = this.flowParseTypeInitialiser()) : a = this.flowParseType(), n.name = s, n.optional = i, n.typeAnnotation = a, this.finishNode(n, "FunctionTypeParam");
              }
              reinterpretTypeAsFunctionTypeParam(e) {
                let s = this.startNodeAt(e.loc.start);
                return s.name = null, s.optional = false, s.typeAnnotation = e, this.finishNode(s, "FunctionTypeParam");
              }
              flowParseFunctionTypeParams() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], s = null, i = null;
                for (this.match(78) && (i = this.flowParseFunctionTypeParam(true), i.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21); )
                  e.push(this.flowParseFunctionTypeParam(false)), this.match(11) || this.expect(12);
                return this.eat(21) && (s = this.flowParseFunctionTypeParam(false)), { params: e, rest: s, _this: i };
              }
              flowIdentToTypeAnnotation(e, s, i) {
                switch (i.name) {
                  case "any":
                    return this.finishNode(s, "AnyTypeAnnotation");
                  case "bool":
                  case "boolean":
                    return this.finishNode(s, "BooleanTypeAnnotation");
                  case "mixed":
                    return this.finishNode(s, "MixedTypeAnnotation");
                  case "empty":
                    return this.finishNode(s, "EmptyTypeAnnotation");
                  case "number":
                    return this.finishNode(s, "NumberTypeAnnotation");
                  case "string":
                    return this.finishNode(s, "StringTypeAnnotation");
                  case "symbol":
                    return this.finishNode(s, "SymbolTypeAnnotation");
                  default:
                    return this.checkNotUnderscore(i.name), this.flowParseGenericType(e, i);
                }
              }
              flowParsePrimaryType() {
                let e = this.state.startLoc, s = this.startNode(), i, a, n = false, o = this.state.noAnonFunctionType;
                switch (this.state.type) {
                  case 5:
                    return this.flowParseObjectType({ allowStatic: false, allowExact: false, allowSpread: true, allowProto: false, allowInexact: true });
                  case 6:
                    return this.flowParseObjectType({ allowStatic: false, allowExact: true, allowSpread: true, allowProto: false, allowInexact: false });
                  case 0:
                    return this.state.noAnonFunctionType = false, a = this.flowParseTupleType(), this.state.noAnonFunctionType = o, a;
                  case 47:
                    return s.typeParameters = this.flowParseTypeParameterDeclaration(), this.expect(10), i = this.flowParseFunctionTypeParams(), s.params = i.params, s.rest = i.rest, s.this = i._this, this.expect(11), this.expect(19), s.returnType = this.flowParseType(), this.finishNode(s, "FunctionTypeAnnotation");
                  case 10:
                    if (this.next(), !this.match(11) && !this.match(21))
                      if (q(this.state.type) || this.match(78)) {
                        let u = this.lookahead().type;
                        n = u !== 17 && u !== 14;
                      } else
                        n = true;
                    if (n) {
                      if (this.state.noAnonFunctionType = false, a = this.flowParseType(), this.state.noAnonFunctionType = o, this.state.noAnonFunctionType || !(this.match(12) || this.match(11) && this.lookahead().type === 19))
                        return this.expect(11), a;
                      this.eat(12);
                    }
                    return a ? i = this.flowParseFunctionTypeParams([this.reinterpretTypeAsFunctionTypeParam(a)]) : i = this.flowParseFunctionTypeParams(), s.params = i.params, s.rest = i.rest, s.this = i._this, this.expect(11), this.expect(19), s.returnType = this.flowParseType(), s.typeParameters = null, this.finishNode(s, "FunctionTypeAnnotation");
                  case 131:
                    return this.parseLiteral(this.state.value, "StringLiteralTypeAnnotation");
                  case 85:
                  case 86:
                    return s.value = this.match(85), this.next(), this.finishNode(s, "BooleanLiteralTypeAnnotation");
                  case 53:
                    if (this.state.value === "-") {
                      if (this.next(), this.match(132))
                        return this.parseLiteralAtNode(-this.state.value, "NumberLiteralTypeAnnotation", s);
                      if (this.match(133))
                        return this.parseLiteralAtNode(-this.state.value, "BigIntLiteralTypeAnnotation", s);
                      throw this.raise(D.UnexpectedSubtractionOperand, { at: this.state.startLoc });
                    }
                    this.unexpected();
                    return;
                  case 132:
                    return this.parseLiteral(this.state.value, "NumberLiteralTypeAnnotation");
                  case 133:
                    return this.parseLiteral(this.state.value, "BigIntLiteralTypeAnnotation");
                  case 88:
                    return this.next(), this.finishNode(s, "VoidTypeAnnotation");
                  case 84:
                    return this.next(), this.finishNode(s, "NullLiteralTypeAnnotation");
                  case 78:
                    return this.next(), this.finishNode(s, "ThisTypeAnnotation");
                  case 55:
                    return this.next(), this.finishNode(s, "ExistsTypeAnnotation");
                  case 87:
                    return this.flowParseTypeofType();
                  default:
                    if ($t(this.state.type)) {
                      let u = xe(this.state.type);
                      return this.next(), super.createIdentifier(s, u);
                    } else if (q(this.state.type))
                      return this.isContextual(127) ? this.flowParseInterfaceType() : this.flowIdentToTypeAnnotation(e, s, this.parseIdentifier());
                }
                this.unexpected();
              }
              flowParsePostfixType() {
                let e = this.state.startLoc, s = this.flowParsePrimaryType(), i = false;
                for (; (this.match(0) || this.match(18)) && !this.canInsertSemicolon(); ) {
                  let a = this.startNodeAt(e), n = this.eat(18);
                  i = i || n, this.expect(0), !n && this.match(3) ? (a.elementType = s, this.next(), s = this.finishNode(a, "ArrayTypeAnnotation")) : (a.objectType = s, a.indexType = this.flowParseType(), this.expect(3), i ? (a.optional = n, s = this.finishNode(a, "OptionalIndexedAccessType")) : s = this.finishNode(a, "IndexedAccessType"));
                }
                return s;
              }
              flowParsePrefixType() {
                let e = this.startNode();
                return this.eat(17) ? (e.typeAnnotation = this.flowParsePrefixType(), this.finishNode(e, "NullableTypeAnnotation")) : this.flowParsePostfixType();
              }
              flowParseAnonFunctionWithoutParens() {
                let e = this.flowParsePrefixType();
                if (!this.state.noAnonFunctionType && this.eat(19)) {
                  let s = this.startNodeAt(e.loc.start);
                  return s.params = [this.reinterpretTypeAsFunctionTypeParam(e)], s.rest = null, s.this = null, s.returnType = this.flowParseType(), s.typeParameters = null, this.finishNode(s, "FunctionTypeAnnotation");
                }
                return e;
              }
              flowParseIntersectionType() {
                let e = this.startNode();
                this.eat(45);
                let s = this.flowParseAnonFunctionWithoutParens();
                for (e.types = [s]; this.eat(45); )
                  e.types.push(this.flowParseAnonFunctionWithoutParens());
                return e.types.length === 1 ? s : this.finishNode(e, "IntersectionTypeAnnotation");
              }
              flowParseUnionType() {
                let e = this.startNode();
                this.eat(43);
                let s = this.flowParseIntersectionType();
                for (e.types = [s]; this.eat(43); )
                  e.types.push(this.flowParseIntersectionType());
                return e.types.length === 1 ? s : this.finishNode(e, "UnionTypeAnnotation");
              }
              flowParseType() {
                let e = this.state.inType;
                this.state.inType = true;
                let s = this.flowParseUnionType();
                return this.state.inType = e, s;
              }
              flowParseTypeOrImplicitInstantiation() {
                if (this.state.type === 130 && this.state.value === "_") {
                  let e = this.state.startLoc, s = this.parseIdentifier();
                  return this.flowParseGenericType(e, s);
                } else
                  return this.flowParseType();
              }
              flowParseTypeAnnotation() {
                let e = this.startNode();
                return e.typeAnnotation = this.flowParseTypeInitialiser(), this.finishNode(e, "TypeAnnotation");
              }
              flowParseTypeAnnotatableIdentifier(e) {
                let s = e ? this.parseIdentifier() : this.flowParseRestrictedIdentifier();
                return this.match(14) && (s.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(s)), s;
              }
              typeCastToParameter(e) {
                return e.expression.typeAnnotation = e.typeAnnotation, this.resetEndLocation(e.expression, e.typeAnnotation.loc.end), e.expression;
              }
              flowParseVariance() {
                let e = null;
                return this.match(53) ? (e = this.startNode(), this.state.value === "+" ? e.kind = "plus" : e.kind = "minus", this.next(), this.finishNode(e, "Variance")) : e;
              }
              parseFunctionBody(e, s) {
                let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                if (s) {
                  this.forwardNoArrowParamsConversionAt(e, () => super.parseFunctionBody(e, true, i));
                  return;
                }
                super.parseFunctionBody(e, false, i);
              }
              parseFunctionBodyAndFinish(e, s) {
                let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                if (this.match(14)) {
                  let a = this.startNode();
                  [a.typeAnnotation, e.predicate] = this.flowParseTypeAndPredicateInitialiser(), e.returnType = a.typeAnnotation ? this.finishNode(a, "TypeAnnotation") : null;
                }
                return super.parseFunctionBodyAndFinish(e, s, i);
              }
              parseStatementLike(e) {
                if (this.state.strict && this.isContextual(127)) {
                  let i = this.lookahead();
                  if (te(i.type)) {
                    let a = this.startNode();
                    return this.next(), this.flowParseInterface(a);
                  }
                } else if (this.shouldParseEnums() && this.isContextual(124)) {
                  let i = this.startNode();
                  return this.next(), this.flowParseEnumDeclaration(i);
                }
                let s = super.parseStatementLike(e);
                return this.flowPragma === void 0 && !this.isValidDirective(s) && (this.flowPragma = null), s;
              }
              parseExpressionStatement(e, s, i) {
                if (s.type === "Identifier") {
                  if (s.name === "declare") {
                    if (this.match(80) || q(this.state.type) || this.match(68) || this.match(74) || this.match(82))
                      return this.flowParseDeclare(e);
                  } else if (q(this.state.type)) {
                    if (s.name === "interface")
                      return this.flowParseInterface(e);
                    if (s.name === "type")
                      return this.flowParseTypeAlias(e);
                    if (s.name === "opaque")
                      return this.flowParseOpaqueType(e, false);
                  }
                }
                return super.parseExpressionStatement(e, s, i);
              }
              shouldParseExportDeclaration() {
                let { type: e } = this.state;
                return hr(e) || this.shouldParseEnums() && e === 124 ? !this.state.containsEsc : super.shouldParseExportDeclaration();
              }
              isExportDefaultSpecifier() {
                let { type: e } = this.state;
                return hr(e) || this.shouldParseEnums() && e === 124 ? this.state.containsEsc : super.isExportDefaultSpecifier();
              }
              parseExportDefaultExpression() {
                if (this.shouldParseEnums() && this.isContextual(124)) {
                  let e = this.startNode();
                  return this.next(), this.flowParseEnumDeclaration(e);
                }
                return super.parseExportDefaultExpression();
              }
              parseConditional(e, s, i) {
                if (!this.match(17))
                  return e;
                if (this.state.maybeInArrowParameters) {
                  let T = this.lookaheadCharCode();
                  if (T === 44 || T === 61 || T === 58 || T === 41)
                    return this.setOptionalParametersError(i), e;
                }
                this.expect(17);
                let a = this.state.clone(), n = this.state.noArrowAt, o = this.startNodeAt(s), { consequent: u, failed: c } = this.tryParseConditionalConsequent(), [y, g] = this.getArrowLikeExpressions(u);
                if (c || g.length > 0) {
                  let T = [...n];
                  if (g.length > 0) {
                    this.state = a, this.state.noArrowAt = T;
                    for (let C = 0; C < g.length; C++)
                      T.push(g[C].start);
                    ({ consequent: u, failed: c } = this.tryParseConditionalConsequent()), [y, g] = this.getArrowLikeExpressions(u);
                  }
                  c && y.length > 1 && this.raise(D.AmbiguousConditionalArrow, { at: a.startLoc }), c && y.length === 1 && (this.state = a, T.push(y[0].start), this.state.noArrowAt = T, { consequent: u, failed: c } = this.tryParseConditionalConsequent());
                }
                return this.getArrowLikeExpressions(u, true), this.state.noArrowAt = n, this.expect(14), o.test = e, o.consequent = u, o.alternate = this.forwardNoArrowParamsConversionAt(o, () => this.parseMaybeAssign(void 0, void 0)), this.finishNode(o, "ConditionalExpression");
              }
              tryParseConditionalConsequent() {
                this.state.noArrowParamsConversionAt.push(this.state.start);
                let e = this.parseMaybeAssignAllowIn(), s = !this.match(14);
                return this.state.noArrowParamsConversionAt.pop(), { consequent: e, failed: s };
              }
              getArrowLikeExpressions(e, s) {
                let i = [e], a = [];
                for (; i.length !== 0; ) {
                  let n = i.pop();
                  n.type === "ArrowFunctionExpression" ? (n.typeParameters || !n.returnType ? this.finishArrowValidation(n) : a.push(n), i.push(n.body)) : n.type === "ConditionalExpression" && (i.push(n.consequent), i.push(n.alternate));
                }
                return s ? (a.forEach((n) => this.finishArrowValidation(n)), [a, []]) : Yl(a, (n) => n.params.every((o) => this.isAssignable(o, true)));
              }
              finishArrowValidation(e) {
                var s;
                this.toAssignableList(e.params, (s = e.extra) == null ? void 0 : s.trailingCommaLoc, false), this.scope.enter(de | Gt), super.checkParams(e, false, true), this.scope.exit();
              }
              forwardNoArrowParamsConversionAt(e, s) {
                let i;
                return this.state.noArrowParamsConversionAt.indexOf(e.start) !== -1 ? (this.state.noArrowParamsConversionAt.push(this.state.start), i = s(), this.state.noArrowParamsConversionAt.pop()) : i = s(), i;
              }
              parseParenItem(e, s) {
                if (e = super.parseParenItem(e, s), this.eat(17) && (e.optional = true, this.resetEndLocation(e)), this.match(14)) {
                  let i = this.startNodeAt(s);
                  return i.expression = e, i.typeAnnotation = this.flowParseTypeAnnotation(), this.finishNode(i, "TypeCastExpression");
                }
                return e;
              }
              assertModuleNodeAllowed(e) {
                e.type === "ImportDeclaration" && (e.importKind === "type" || e.importKind === "typeof") || e.type === "ExportNamedDeclaration" && e.exportKind === "type" || e.type === "ExportAllDeclaration" && e.exportKind === "type" || super.assertModuleNodeAllowed(e);
              }
              parseExport(e, s) {
                let i = super.parseExport(e, s);
                return (i.type === "ExportNamedDeclaration" || i.type === "ExportAllDeclaration") && (i.exportKind = i.exportKind || "value"), i;
              }
              parseExportDeclaration(e) {
                if (this.isContextual(128)) {
                  e.exportKind = "type";
                  let s = this.startNode();
                  return this.next(), this.match(5) ? (e.specifiers = this.parseExportSpecifiers(true), super.parseExportFrom(e), null) : this.flowParseTypeAlias(s);
                } else if (this.isContextual(129)) {
                  e.exportKind = "type";
                  let s = this.startNode();
                  return this.next(), this.flowParseOpaqueType(s, false);
                } else if (this.isContextual(127)) {
                  e.exportKind = "type";
                  let s = this.startNode();
                  return this.next(), this.flowParseInterface(s);
                } else if (this.shouldParseEnums() && this.isContextual(124)) {
                  e.exportKind = "value";
                  let s = this.startNode();
                  return this.next(), this.flowParseEnumDeclaration(s);
                } else
                  return super.parseExportDeclaration(e);
              }
              eatExportStar(e) {
                return super.eatExportStar(e) ? true : this.isContextual(128) && this.lookahead().type === 55 ? (e.exportKind = "type", this.next(), this.next(), true) : false;
              }
              maybeParseExportNamespaceSpecifier(e) {
                let { startLoc: s } = this.state, i = super.maybeParseExportNamespaceSpecifier(e);
                return i && e.exportKind === "type" && this.unexpected(s), i;
              }
              parseClassId(e, s, i) {
                super.parseClassId(e, s, i), this.match(47) && (e.typeParameters = this.flowParseTypeParameterDeclaration());
              }
              parseClassMember(e, s, i) {
                let { startLoc: a } = this.state;
                if (this.isContextual(123)) {
                  if (super.parseClassMemberFromModifier(e, s))
                    return;
                  s.declare = true;
                }
                super.parseClassMember(e, s, i), s.declare && (s.type !== "ClassProperty" && s.type !== "ClassPrivateProperty" && s.type !== "PropertyDefinition" ? this.raise(D.DeclareClassElement, { at: a }) : s.value && this.raise(D.DeclareClassFieldInitializer, { at: s.value }));
              }
              isIterator(e) {
                return e === "iterator" || e === "asyncIterator";
              }
              readIterator() {
                let e = super.readWord1(), s = "@@" + e;
                (!this.isIterator(e) || !this.state.inType) && this.raise(f.InvalidIdentifier, { at: this.state.curPosition(), identifierName: s }), this.finishToken(130, s);
              }
              getTokenFromCode(e) {
                let s = this.input.charCodeAt(this.state.pos + 1);
                e === 123 && s === 124 ? this.finishOp(6, 2) : this.state.inType && (e === 62 || e === 60) ? this.finishOp(e === 62 ? 48 : 47, 1) : this.state.inType && e === 63 ? s === 46 ? this.finishOp(18, 2) : this.finishOp(17, 1) : ll(e, s, this.input.charCodeAt(this.state.pos + 2)) ? (this.state.pos += 2, this.readIterator()) : super.getTokenFromCode(e);
              }
              isAssignable(e, s) {
                return e.type === "TypeCastExpression" ? this.isAssignable(e.expression, s) : super.isAssignable(e, s);
              }
              toAssignable(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                !s && e.type === "AssignmentExpression" && e.left.type === "TypeCastExpression" && (e.left = this.typeCastToParameter(e.left)), super.toAssignable(e, s);
              }
              toAssignableList(e, s, i) {
                for (let a = 0; a < e.length; a++) {
                  let n = e[a];
                  (n == null ? void 0 : n.type) === "TypeCastExpression" && (e[a] = this.typeCastToParameter(n));
                }
                super.toAssignableList(e, s, i);
              }
              toReferencedList(e, s) {
                for (let a = 0; a < e.length; a++) {
                  var i;
                  let n = e[a];
                  n && n.type === "TypeCastExpression" && !((i = n.extra) != null && i.parenthesized) && (e.length > 1 || !s) && this.raise(D.TypeCastInPattern, { at: n.typeAnnotation });
                }
                return e;
              }
              parseArrayLike(e, s, i, a) {
                let n = super.parseArrayLike(e, s, i, a);
                return s && !this.state.maybeInArrowParameters && this.toReferencedList(n.elements), n;
              }
              isValidLVal(e, s, i) {
                return e === "TypeCastExpression" || super.isValidLVal(e, s, i);
              }
              parseClassProperty(e) {
                return this.match(14) && (e.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassProperty(e);
              }
              parseClassPrivateProperty(e) {
                return this.match(14) && (e.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassPrivateProperty(e);
              }
              isClassMethod() {
                return this.match(47) || super.isClassMethod();
              }
              isClassProperty() {
                return this.match(14) || super.isClassProperty();
              }
              isNonstaticConstructor(e) {
                return !this.match(14) && super.isNonstaticConstructor(e);
              }
              pushClassMethod(e, s, i, a, n, o) {
                if (s.variance && this.unexpected(s.variance.loc.start), delete s.variance, this.match(47) && (s.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassMethod(e, s, i, a, n, o), s.params && n) {
                  let u = s.params;
                  u.length > 0 && this.isThisParam(u[0]) && this.raise(D.ThisParamBannedInConstructor, { at: s });
                } else if (s.type === "MethodDefinition" && n && s.value.params) {
                  let u = s.value.params;
                  u.length > 0 && this.isThisParam(u[0]) && this.raise(D.ThisParamBannedInConstructor, { at: s });
                }
              }
              pushClassPrivateMethod(e, s, i, a) {
                s.variance && this.unexpected(s.variance.loc.start), delete s.variance, this.match(47) && (s.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassPrivateMethod(e, s, i, a);
              }
              parseClassSuper(e) {
                if (super.parseClassSuper(e), e.superClass && this.match(47) && (e.superTypeParameters = this.flowParseTypeParameterInstantiation()), this.isContextual(111)) {
                  this.next();
                  let s = e.implements = [];
                  do {
                    let i = this.startNode();
                    i.id = this.flowParseRestrictedIdentifier(true), this.match(47) ? i.typeParameters = this.flowParseTypeParameterInstantiation() : i.typeParameters = null, s.push(this.finishNode(i, "ClassImplements"));
                  } while (this.eat(12));
                }
              }
              checkGetterSetterParams(e) {
                super.checkGetterSetterParams(e);
                let s = this.getObjectOrClassMethodParams(e);
                if (s.length > 0) {
                  let i = s[0];
                  this.isThisParam(i) && e.kind === "get" ? this.raise(D.GetterMayNotHaveThisParam, { at: i }) : this.isThisParam(i) && this.raise(D.SetterMayNotHaveThisParam, { at: i });
                }
              }
              parsePropertyNamePrefixOperator(e) {
                e.variance = this.flowParseVariance();
              }
              parseObjPropValue(e, s, i, a, n, o, u) {
                e.variance && this.unexpected(e.variance.loc.start), delete e.variance;
                let c;
                this.match(47) && !o && (c = this.flowParseTypeParameterDeclaration(), this.match(10) || this.unexpected());
                let y = super.parseObjPropValue(e, s, i, a, n, o, u);
                return c && ((y.value || y).typeParameters = c), y;
              }
              parseAssignableListItemTypes(e) {
                return this.eat(17) && (e.type !== "Identifier" && this.raise(D.PatternIsOptional, { at: e }), this.isThisParam(e) && this.raise(D.ThisParamMayNotBeOptional, { at: e }), e.optional = true), this.match(14) ? e.typeAnnotation = this.flowParseTypeAnnotation() : this.isThisParam(e) && this.raise(D.ThisParamAnnotationRequired, { at: e }), this.match(29) && this.isThisParam(e) && this.raise(D.ThisParamNoDefault, { at: e }), this.resetEndLocation(e), e;
              }
              parseMaybeDefault(e, s) {
                let i = super.parseMaybeDefault(e, s);
                return i.type === "AssignmentPattern" && i.typeAnnotation && i.right.start < i.typeAnnotation.start && this.raise(D.TypeBeforeInitializer, { at: i.typeAnnotation }), i;
              }
              shouldParseDefaultImport(e) {
                return us(e) ? qr(this.state.type) : super.shouldParseDefaultImport(e);
              }
              checkImportReflection(e) {
                super.checkImportReflection(e), e.module && e.importKind !== "value" && this.raise(D.ImportReflectionHasImportType, { at: e.specifiers[0].loc.start });
              }
              parseImportSpecifierLocal(e, s, i) {
                s.local = us(e) ? this.flowParseRestrictedIdentifier(true, true) : this.parseIdentifier(), e.specifiers.push(this.finishImportSpecifier(s, i));
              }
              maybeParseDefaultImportSpecifier(e) {
                e.importKind = "value";
                let s = null;
                if (this.match(87) ? s = "typeof" : this.isContextual(128) && (s = "type"), s) {
                  let i = this.lookahead(), { type: a } = i;
                  s === "type" && a === 55 && this.unexpected(null, i.type), (qr(a) || a === 5 || a === 55) && (this.next(), e.importKind = s);
                }
                return super.maybeParseDefaultImportSpecifier(e);
              }
              parseImportSpecifier(e, s, i, a, n) {
                let o = e.imported, u = null;
                o.type === "Identifier" && (o.name === "type" ? u = "type" : o.name === "typeof" && (u = "typeof"));
                let c = false;
                if (this.isContextual(93) && !this.isLookaheadContextual("as")) {
                  let g = this.parseIdentifier(true);
                  u !== null && !te(this.state.type) ? (e.imported = g, e.importKind = u, e.local = me(g)) : (e.imported = o, e.importKind = null, e.local = this.parseIdentifier());
                } else {
                  if (u !== null && te(this.state.type))
                    e.imported = this.parseIdentifier(true), e.importKind = u;
                  else {
                    if (s)
                      throw this.raise(f.ImportBindingIsString, { at: e, importName: o.value });
                    e.imported = o, e.importKind = null;
                  }
                  this.eatContextual(93) ? e.local = this.parseIdentifier() : (c = true, e.local = me(e.imported));
                }
                let y = us(e);
                return i && y && this.raise(D.ImportTypeShorthandOnlyInPureImport, { at: e }), (i || y) && this.checkReservedType(e.local.name, e.local.loc.start, true), c && !i && !y && this.checkReservedWord(e.local.name, e.loc.start, true, true), this.finishImportSpecifier(e, "ImportSpecifier");
              }
              parseBindingAtom() {
                switch (this.state.type) {
                  case 78:
                    return this.parseIdentifier(true);
                  default:
                    return super.parseBindingAtom();
                }
              }
              parseFunctionParams(e, s) {
                let i = e.kind;
                i !== "get" && i !== "set" && this.match(47) && (e.typeParameters = this.flowParseTypeParameterDeclaration()), super.parseFunctionParams(e, s);
              }
              parseVarId(e, s) {
                super.parseVarId(e, s), this.match(14) && (e.id.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(e.id));
              }
              parseAsyncArrowFromCallExpression(e, s) {
                if (this.match(14)) {
                  let i = this.state.noAnonFunctionType;
                  this.state.noAnonFunctionType = true, e.returnType = this.flowParseTypeAnnotation(), this.state.noAnonFunctionType = i;
                }
                return super.parseAsyncArrowFromCallExpression(e, s);
              }
              shouldParseAsyncArrow() {
                return this.match(14) || super.shouldParseAsyncArrow();
              }
              parseMaybeAssign(e, s) {
                var i;
                let a = null, n;
                if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
                  if (a = this.state.clone(), n = this.tryParse(() => super.parseMaybeAssign(e, s), a), !n.error)
                    return n.node;
                  let { context: c } = this.state, y = c[c.length - 1];
                  (y === x.j_oTag || y === x.j_expr) && c.pop();
                }
                if ((i = n) != null && i.error || this.match(47)) {
                  var o, u;
                  a = a || this.state.clone();
                  let c, y = this.tryParse((T) => {
                    var C;
                    c = this.flowParseTypeParameterDeclaration();
                    let M = this.forwardNoArrowParamsConversionAt(c, () => {
                      let K = super.parseMaybeAssign(e, s);
                      return this.resetStartLocationFromNode(K, c), K;
                    });
                    (C = M.extra) != null && C.parenthesized && T();
                    let j = this.maybeUnwrapTypeCastExpression(M);
                    return j.type !== "ArrowFunctionExpression" && T(), j.typeParameters = c, this.resetStartLocationFromNode(j, c), M;
                  }, a), g = null;
                  if (y.node && this.maybeUnwrapTypeCastExpression(y.node).type === "ArrowFunctionExpression") {
                    if (!y.error && !y.aborted)
                      return y.node.async && this.raise(D.UnexpectedTypeParameterBeforeAsyncArrowFunction, { at: c }), y.node;
                    g = y.node;
                  }
                  if ((o = n) != null && o.node)
                    return this.state = n.failState, n.node;
                  if (g)
                    return this.state = y.failState, g;
                  throw (u = n) != null && u.thrown ? n.error : y.thrown ? y.error : this.raise(D.UnexpectedTokenAfterTypeParameter, { at: c });
                }
                return super.parseMaybeAssign(e, s);
              }
              parseArrow(e) {
                if (this.match(14)) {
                  let s = this.tryParse(() => {
                    let i = this.state.noAnonFunctionType;
                    this.state.noAnonFunctionType = true;
                    let a = this.startNode();
                    return [a.typeAnnotation, e.predicate] = this.flowParseTypeAndPredicateInitialiser(), this.state.noAnonFunctionType = i, this.canInsertSemicolon() && this.unexpected(), this.match(19) || this.unexpected(), a;
                  });
                  if (s.thrown)
                    return null;
                  s.error && (this.state = s.failState), e.returnType = s.node.typeAnnotation ? this.finishNode(s.node, "TypeAnnotation") : null;
                }
                return super.parseArrow(e);
              }
              shouldParseArrow(e) {
                return this.match(14) || super.shouldParseArrow(e);
              }
              setArrowFunctionParameters(e, s) {
                this.state.noArrowParamsConversionAt.indexOf(e.start) !== -1 ? e.params = s : super.setArrowFunctionParameters(e, s);
              }
              checkParams(e, s, i) {
                let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
                if (!(i && this.state.noArrowParamsConversionAt.indexOf(e.start) !== -1)) {
                  for (let n = 0; n < e.params.length; n++)
                    this.isThisParam(e.params[n]) && n > 0 && this.raise(D.ThisParamMustBeFirst, { at: e.params[n] });
                  super.checkParams(e, s, i, a);
                }
              }
              parseParenAndDistinguishExpression(e) {
                return super.parseParenAndDistinguishExpression(e && this.state.noArrowAt.indexOf(this.state.start) === -1);
              }
              parseSubscripts(e, s, i) {
                if (e.type === "Identifier" && e.name === "async" && this.state.noArrowAt.indexOf(s.index) !== -1) {
                  this.next();
                  let a = this.startNodeAt(s);
                  a.callee = e, a.arguments = super.parseCallExpressionArguments(11, false), e = this.finishNode(a, "CallExpression");
                } else if (e.type === "Identifier" && e.name === "async" && this.match(47)) {
                  let a = this.state.clone(), n = this.tryParse((u) => this.parseAsyncArrowWithTypeParameters(s) || u(), a);
                  if (!n.error && !n.aborted)
                    return n.node;
                  let o = this.tryParse(() => super.parseSubscripts(e, s, i), a);
                  if (o.node && !o.error)
                    return o.node;
                  if (n.node)
                    return this.state = n.failState, n.node;
                  if (o.node)
                    return this.state = o.failState, o.node;
                  throw n.error || o.error;
                }
                return super.parseSubscripts(e, s, i);
              }
              parseSubscript(e, s, i, a) {
                if (this.match(18) && this.isLookaheadToken_lt()) {
                  if (a.optionalChainMember = true, i)
                    return a.stop = true, e;
                  this.next();
                  let n = this.startNodeAt(s);
                  return n.callee = e, n.typeArguments = this.flowParseTypeParameterInstantiation(), this.expect(10), n.arguments = this.parseCallExpressionArguments(11, false), n.optional = true, this.finishCallExpression(n, true);
                } else if (!i && this.shouldParseTypes() && this.match(47)) {
                  let n = this.startNodeAt(s);
                  n.callee = e;
                  let o = this.tryParse(() => (n.typeArguments = this.flowParseTypeParameterInstantiationCallOrNew(), this.expect(10), n.arguments = super.parseCallExpressionArguments(11, false), a.optionalChainMember && (n.optional = false), this.finishCallExpression(n, a.optionalChainMember)));
                  if (o.node)
                    return o.error && (this.state = o.failState), o.node;
                }
                return super.parseSubscript(e, s, i, a);
              }
              parseNewCallee(e) {
                super.parseNewCallee(e);
                let s = null;
                this.shouldParseTypes() && this.match(47) && (s = this.tryParse(() => this.flowParseTypeParameterInstantiationCallOrNew()).node), e.typeArguments = s;
              }
              parseAsyncArrowWithTypeParameters(e) {
                let s = this.startNodeAt(e);
                if (this.parseFunctionParams(s, false), !!this.parseArrow(s))
                  return super.parseArrowExpression(s, void 0, true);
              }
              readToken_mult_modulo(e) {
                let s = this.input.charCodeAt(this.state.pos + 1);
                if (e === 42 && s === 47 && this.state.hasFlowComment) {
                  this.state.hasFlowComment = false, this.state.pos += 2, this.nextToken();
                  return;
                }
                super.readToken_mult_modulo(e);
              }
              readToken_pipe_amp(e) {
                let s = this.input.charCodeAt(this.state.pos + 1);
                if (e === 124 && s === 125) {
                  this.finishOp(9, 2);
                  return;
                }
                super.readToken_pipe_amp(e);
              }
              parseTopLevel(e, s) {
                let i = super.parseTopLevel(e, s);
                return this.state.hasFlowComment && this.raise(D.UnterminatedFlowComment, { at: this.state.curPosition() }), i;
              }
              skipBlockComment() {
                if (this.hasPlugin("flowComments") && this.skipFlowComment()) {
                  if (this.state.hasFlowComment)
                    throw this.raise(D.NestedFlowComment, { at: this.state.startLoc });
                  this.hasFlowCommentCompletion();
                  let e = this.skipFlowComment();
                  e && (this.state.pos += e, this.state.hasFlowComment = true);
                  return;
                }
                return super.skipBlockComment(this.state.hasFlowComment ? "*-/" : "*/");
              }
              skipFlowComment() {
                let { pos: e } = this.state, s = 2;
                for (; [32, 9].includes(this.input.charCodeAt(e + s)); )
                  s++;
                let i = this.input.charCodeAt(s + e), a = this.input.charCodeAt(s + e + 1);
                return i === 58 && a === 58 ? s + 2 : this.input.slice(s + e, s + e + 12) === "flow-include" ? s + 12 : i === 58 && a !== 58 ? s : false;
              }
              hasFlowCommentCompletion() {
                if (this.input.indexOf("*/", this.state.pos) === -1)
                  throw this.raise(f.UnterminatedComment, { at: this.state.curPosition() });
              }
              flowEnumErrorBooleanMemberNotInitialized(e, s) {
                let { enumName: i, memberName: a } = s;
                this.raise(D.EnumBooleanMemberNotInitialized, { at: e, memberName: a, enumName: i });
              }
              flowEnumErrorInvalidMemberInitializer(e, s) {
                return this.raise(s.explicitType ? s.explicitType === "symbol" ? D.EnumInvalidMemberInitializerSymbolType : D.EnumInvalidMemberInitializerPrimaryType : D.EnumInvalidMemberInitializerUnknownType, Object.assign({ at: e }, s));
              }
              flowEnumErrorNumberMemberNotInitialized(e, s) {
                let { enumName: i, memberName: a } = s;
                this.raise(D.EnumNumberMemberNotInitialized, { at: e, enumName: i, memberName: a });
              }
              flowEnumErrorStringMemberInconsistentlyInitailized(e, s) {
                let { enumName: i } = s;
                this.raise(D.EnumStringMemberInconsistentlyInitailized, { at: e, enumName: i });
              }
              flowEnumMemberInit() {
                let e = this.state.startLoc, s = () => this.match(12) || this.match(8);
                switch (this.state.type) {
                  case 132: {
                    let i = this.parseNumericLiteral(this.state.value);
                    return s() ? { type: "number", loc: i.loc.start, value: i } : { type: "invalid", loc: e };
                  }
                  case 131: {
                    let i = this.parseStringLiteral(this.state.value);
                    return s() ? { type: "string", loc: i.loc.start, value: i } : { type: "invalid", loc: e };
                  }
                  case 85:
                  case 86: {
                    let i = this.parseBooleanLiteral(this.match(85));
                    return s() ? { type: "boolean", loc: i.loc.start, value: i } : { type: "invalid", loc: e };
                  }
                  default:
                    return { type: "invalid", loc: e };
                }
              }
              flowEnumMemberRaw() {
                let e = this.state.startLoc, s = this.parseIdentifier(true), i = this.eat(29) ? this.flowEnumMemberInit() : { type: "none", loc: e };
                return { id: s, init: i };
              }
              flowEnumCheckExplicitTypeMismatch(e, s, i) {
                let { explicitType: a } = s;
                a !== null && a !== i && this.flowEnumErrorInvalidMemberInitializer(e, s);
              }
              flowEnumMembers(e) {
                let { enumName: s, explicitType: i } = e, a = /* @__PURE__ */ new Set(), n = { booleanMembers: [], numberMembers: [], stringMembers: [], defaultedMembers: [] }, o = false;
                for (; !this.match(8); ) {
                  if (this.eat(21)) {
                    o = true;
                    break;
                  }
                  let u = this.startNode(), { id: c, init: y } = this.flowEnumMemberRaw(), g = c.name;
                  if (g === "")
                    continue;
                  /^[a-z]/.test(g) && this.raise(D.EnumInvalidMemberName, { at: c, memberName: g, suggestion: g[0].toUpperCase() + g.slice(1), enumName: s }), a.has(g) && this.raise(D.EnumDuplicateMemberName, { at: c, memberName: g, enumName: s }), a.add(g);
                  let T = { enumName: s, explicitType: i, memberName: g };
                  switch (u.id = c, y.type) {
                    case "boolean": {
                      this.flowEnumCheckExplicitTypeMismatch(y.loc, T, "boolean"), u.init = y.value, n.booleanMembers.push(this.finishNode(u, "EnumBooleanMember"));
                      break;
                    }
                    case "number": {
                      this.flowEnumCheckExplicitTypeMismatch(y.loc, T, "number"), u.init = y.value, n.numberMembers.push(this.finishNode(u, "EnumNumberMember"));
                      break;
                    }
                    case "string": {
                      this.flowEnumCheckExplicitTypeMismatch(y.loc, T, "string"), u.init = y.value, n.stringMembers.push(this.finishNode(u, "EnumStringMember"));
                      break;
                    }
                    case "invalid":
                      throw this.flowEnumErrorInvalidMemberInitializer(y.loc, T);
                    case "none":
                      switch (i) {
                        case "boolean":
                          this.flowEnumErrorBooleanMemberNotInitialized(y.loc, T);
                          break;
                        case "number":
                          this.flowEnumErrorNumberMemberNotInitialized(y.loc, T);
                          break;
                        default:
                          n.defaultedMembers.push(this.finishNode(u, "EnumDefaultedMember"));
                      }
                  }
                  this.match(8) || this.expect(12);
                }
                return { members: n, hasUnknownMembers: o };
              }
              flowEnumStringMembers(e, s, i) {
                let { enumName: a } = i;
                if (e.length === 0)
                  return s;
                if (s.length === 0)
                  return e;
                if (s.length > e.length) {
                  for (let n of e)
                    this.flowEnumErrorStringMemberInconsistentlyInitailized(n, { enumName: a });
                  return s;
                } else {
                  for (let n of s)
                    this.flowEnumErrorStringMemberInconsistentlyInitailized(n, { enumName: a });
                  return e;
                }
              }
              flowEnumParseExplicitType(e) {
                let { enumName: s } = e;
                if (!this.eatContextual(101))
                  return null;
                if (!q(this.state.type))
                  throw this.raise(D.EnumInvalidExplicitTypeUnknownSupplied, { at: this.state.startLoc, enumName: s });
                let { value: i } = this.state;
                return this.next(), i !== "boolean" && i !== "number" && i !== "string" && i !== "symbol" && this.raise(D.EnumInvalidExplicitType, { at: this.state.startLoc, enumName: s, invalidEnumType: i }), i;
              }
              flowEnumBody(e, s) {
                let i = s.name, a = s.loc.start, n = this.flowEnumParseExplicitType({ enumName: i });
                this.expect(5);
                let { members: o, hasUnknownMembers: u } = this.flowEnumMembers({ enumName: i, explicitType: n });
                switch (e.hasUnknownMembers = u, n) {
                  case "boolean":
                    return e.explicitType = true, e.members = o.booleanMembers, this.expect(8), this.finishNode(e, "EnumBooleanBody");
                  case "number":
                    return e.explicitType = true, e.members = o.numberMembers, this.expect(8), this.finishNode(e, "EnumNumberBody");
                  case "string":
                    return e.explicitType = true, e.members = this.flowEnumStringMembers(o.stringMembers, o.defaultedMembers, { enumName: i }), this.expect(8), this.finishNode(e, "EnumStringBody");
                  case "symbol":
                    return e.members = o.defaultedMembers, this.expect(8), this.finishNode(e, "EnumSymbolBody");
                  default: {
                    let c = () => (e.members = [], this.expect(8), this.finishNode(e, "EnumStringBody"));
                    e.explicitType = false;
                    let y = o.booleanMembers.length, g = o.numberMembers.length, T = o.stringMembers.length, C = o.defaultedMembers.length;
                    if (!y && !g && !T && !C)
                      return c();
                    if (!y && !g)
                      return e.members = this.flowEnumStringMembers(o.stringMembers, o.defaultedMembers, { enumName: i }), this.expect(8), this.finishNode(e, "EnumStringBody");
                    if (!g && !T && y >= C) {
                      for (let M of o.defaultedMembers)
                        this.flowEnumErrorBooleanMemberNotInitialized(M.loc.start, { enumName: i, memberName: M.id.name });
                      return e.members = o.booleanMembers, this.expect(8), this.finishNode(e, "EnumBooleanBody");
                    } else if (!y && !T && g >= C) {
                      for (let M of o.defaultedMembers)
                        this.flowEnumErrorNumberMemberNotInitialized(M.loc.start, { enumName: i, memberName: M.id.name });
                      return e.members = o.numberMembers, this.expect(8), this.finishNode(e, "EnumNumberBody");
                    } else
                      return this.raise(D.EnumInconsistentMemberValues, { at: a, enumName: i }), c();
                  }
                }
              }
              flowParseEnumDeclaration(e) {
                let s = this.parseIdentifier();
                return e.id = s, e.body = this.flowEnumBody(this.startNode(), s), this.finishNode(e, "EnumDeclaration");
              }
              isLookaheadToken_lt() {
                let e = this.nextTokenStart();
                if (this.input.charCodeAt(e) === 60) {
                  let s = this.input.charCodeAt(e + 1);
                  return s !== 60 && s !== 61;
                }
                return false;
              }
              maybeUnwrapTypeCastExpression(e) {
                return e.type === "TypeCastExpression" ? e.expression : e;
              }
            }, eh = { __proto__: null, quot: '"', amp: "&", apos: "'", lt: "<", gt: ">", nbsp: "\xA0", iexcl: "\xA1", cent: "\xA2", pound: "\xA3", curren: "\xA4", yen: "\xA5", brvbar: "\xA6", sect: "\xA7", uml: "\xA8", copy: "\xA9", ordf: "\xAA", laquo: "\xAB", not: "\xAC", shy: "\xAD", reg: "\xAE", macr: "\xAF", deg: "\xB0", plusmn: "\xB1", sup2: "\xB2", sup3: "\xB3", acute: "\xB4", micro: "\xB5", para: "\xB6", middot: "\xB7", cedil: "\xB8", sup1: "\xB9", ordm: "\xBA", raquo: "\xBB", frac14: "\xBC", frac12: "\xBD", frac34: "\xBE", iquest: "\xBF", Agrave: "\xC0", Aacute: "\xC1", Acirc: "\xC2", Atilde: "\xC3", Auml: "\xC4", Aring: "\xC5", AElig: "\xC6", Ccedil: "\xC7", Egrave: "\xC8", Eacute: "\xC9", Ecirc: "\xCA", Euml: "\xCB", Igrave: "\xCC", Iacute: "\xCD", Icirc: "\xCE", Iuml: "\xCF", ETH: "\xD0", Ntilde: "\xD1", Ograve: "\xD2", Oacute: "\xD3", Ocirc: "\xD4", Otilde: "\xD5", Ouml: "\xD6", times: "\xD7", Oslash: "\xD8", Ugrave: "\xD9", Uacute: "\xDA", Ucirc: "\xDB", Uuml: "\xDC", Yacute: "\xDD", THORN: "\xDE", szlig: "\xDF", agrave: "\xE0", aacute: "\xE1", acirc: "\xE2", atilde: "\xE3", auml: "\xE4", aring: "\xE5", aelig: "\xE6", ccedil: "\xE7", egrave: "\xE8", eacute: "\xE9", ecirc: "\xEA", euml: "\xEB", igrave: "\xEC", iacute: "\xED", icirc: "\xEE", iuml: "\xEF", eth: "\xF0", ntilde: "\xF1", ograve: "\xF2", oacute: "\xF3", ocirc: "\xF4", otilde: "\xF5", ouml: "\xF6", divide: "\xF7", oslash: "\xF8", ugrave: "\xF9", uacute: "\xFA", ucirc: "\xFB", uuml: "\xFC", yacute: "\xFD", thorn: "\xFE", yuml: "\xFF", OElig: "\u0152", oelig: "\u0153", Scaron: "\u0160", scaron: "\u0161", Yuml: "\u0178", fnof: "\u0192", circ: "\u02C6", tilde: "\u02DC", Alpha: "\u0391", Beta: "\u0392", Gamma: "\u0393", Delta: "\u0394", Epsilon: "\u0395", Zeta: "\u0396", Eta: "\u0397", Theta: "\u0398", Iota: "\u0399", Kappa: "\u039A", Lambda: "\u039B", Mu: "\u039C", Nu: "\u039D", Xi: "\u039E", Omicron: "\u039F", Pi: "\u03A0", Rho: "\u03A1", Sigma: "\u03A3", Tau: "\u03A4", Upsilon: "\u03A5", Phi: "\u03A6", Chi: "\u03A7", Psi: "\u03A8", Omega: "\u03A9", alpha: "\u03B1", beta: "\u03B2", gamma: "\u03B3", delta: "\u03B4", epsilon: "\u03B5", zeta: "\u03B6", eta: "\u03B7", theta: "\u03B8", iota: "\u03B9", kappa: "\u03BA", lambda: "\u03BB", mu: "\u03BC", nu: "\u03BD", xi: "\u03BE", omicron: "\u03BF", pi: "\u03C0", rho: "\u03C1", sigmaf: "\u03C2", sigma: "\u03C3", tau: "\u03C4", upsilon: "\u03C5", phi: "\u03C6", chi: "\u03C7", psi: "\u03C8", omega: "\u03C9", thetasym: "\u03D1", upsih: "\u03D2", piv: "\u03D6", ensp: "\u2002", emsp: "\u2003", thinsp: "\u2009", zwnj: "\u200C", zwj: "\u200D", lrm: "\u200E", rlm: "\u200F", ndash: "\u2013", mdash: "\u2014", lsquo: "\u2018", rsquo: "\u2019", sbquo: "\u201A", ldquo: "\u201C", rdquo: "\u201D", bdquo: "\u201E", dagger: "\u2020", Dagger: "\u2021", bull: "\u2022", hellip: "\u2026", permil: "\u2030", prime: "\u2032", Prime: "\u2033", lsaquo: "\u2039", rsaquo: "\u203A", oline: "\u203E", frasl: "\u2044", euro: "\u20AC", image: "\u2111", weierp: "\u2118", real: "\u211C", trade: "\u2122", alefsym: "\u2135", larr: "\u2190", uarr: "\u2191", rarr: "\u2192", darr: "\u2193", harr: "\u2194", crarr: "\u21B5", lArr: "\u21D0", uArr: "\u21D1", rArr: "\u21D2", dArr: "\u21D3", hArr: "\u21D4", forall: "\u2200", part: "\u2202", exist: "\u2203", empty: "\u2205", nabla: "\u2207", isin: "\u2208", notin: "\u2209", ni: "\u220B", prod: "\u220F", sum: "\u2211", minus: "\u2212", lowast: "\u2217", radic: "\u221A", prop: "\u221D", infin: "\u221E", ang: "\u2220", and: "\u2227", or: "\u2228", cap: "\u2229", cup: "\u222A", int: "\u222B", there4: "\u2234", sim: "\u223C", cong: "\u2245", asymp: "\u2248", ne: "\u2260", equiv: "\u2261", le: "\u2264", ge: "\u2265", sub: "\u2282", sup: "\u2283", nsub: "\u2284", sube: "\u2286", supe: "\u2287", oplus: "\u2295", otimes: "\u2297", perp: "\u22A5", sdot: "\u22C5", lceil: "\u2308", rceil: "\u2309", lfloor: "\u230A", rfloor: "\u230B", lang: "\u2329", rang: "\u232A", loz: "\u25CA", spades: "\u2660", clubs: "\u2663", hearts: "\u2665", diams: "\u2666" }, Se = pe`jsx`({ AttributeIsEmpty: "JSX attributes must only be assigned a non-empty expression.", MissingClosingTagElement: (t3) => {
              let { openingTagName: r } = t3;
              return `Expected corresponding JSX closing tag for <${r}>.`;
            }, MissingClosingTagFragment: "Expected corresponding JSX closing tag for <>.", UnexpectedSequenceExpression: "Sequence expressions cannot be directly nested inside JSX. Did you mean to wrap it in parentheses (...)?", UnexpectedToken: (t3) => {
              let { unexpected: r, HTMLEntity: e } = t3;
              return `Unexpected token \`${r}\`. Did you mean \`${e}\` or \`{'${r}'}\`?`;
            }, UnsupportedJsxValue: "JSX value should be either an expression or a quoted JSX text.", UnterminatedJsxContent: "Unterminated JSX contents.", UnwrappedAdjacentJSXElements: "Adjacent JSX elements must be wrapped in an enclosing tag. Did you want a JSX fragment <>...</>?" });
            function Te(t3) {
              return t3 ? t3.type === "JSXOpeningFragment" || t3.type === "JSXClosingFragment" : false;
            }
            function Re(t3) {
              if (t3.type === "JSXIdentifier")
                return t3.name;
              if (t3.type === "JSXNamespacedName")
                return t3.namespace.name + ":" + t3.name.name;
              if (t3.type === "JSXMemberExpression")
                return Re(t3.object) + "." + Re(t3.property);
              throw new Error("Node had unexpected type: " + t3.type);
            }
            var th = (t3) => class extends t3 {
              jsxReadToken() {
                let e = "", s = this.state.pos;
                for (; ; ) {
                  if (this.state.pos >= this.length)
                    throw this.raise(Se.UnterminatedJsxContent, { at: this.state.startLoc });
                  let i = this.input.charCodeAt(this.state.pos);
                  switch (i) {
                    case 60:
                    case 123:
                      if (this.state.pos === this.state.start) {
                        i === 60 && this.state.canStartJSXElement ? (++this.state.pos, this.finishToken(140)) : super.getTokenFromCode(i);
                        return;
                      }
                      e += this.input.slice(s, this.state.pos), this.finishToken(139, e);
                      return;
                    case 38:
                      e += this.input.slice(s, this.state.pos), e += this.jsxReadEntity(), s = this.state.pos;
                      break;
                    case 62:
                    case 125:
                    default:
                      Ge(i) ? (e += this.input.slice(s, this.state.pos), e += this.jsxReadNewLine(true), s = this.state.pos) : ++this.state.pos;
                  }
                }
              }
              jsxReadNewLine(e) {
                let s = this.input.charCodeAt(this.state.pos), i;
                return ++this.state.pos, s === 13 && this.input.charCodeAt(this.state.pos) === 10 ? (++this.state.pos, i = e ? `
` : `\r
`) : i = String.fromCharCode(s), ++this.state.curLine, this.state.lineStart = this.state.pos, i;
              }
              jsxReadString(e) {
                let s = "", i = ++this.state.pos;
                for (; ; ) {
                  if (this.state.pos >= this.length)
                    throw this.raise(f.UnterminatedString, { at: this.state.startLoc });
                  let a = this.input.charCodeAt(this.state.pos);
                  if (a === e)
                    break;
                  a === 38 ? (s += this.input.slice(i, this.state.pos), s += this.jsxReadEntity(), i = this.state.pos) : Ge(a) ? (s += this.input.slice(i, this.state.pos), s += this.jsxReadNewLine(false), i = this.state.pos) : ++this.state.pos;
                }
                s += this.input.slice(i, this.state.pos++), this.finishToken(131, s);
              }
              jsxReadEntity() {
                let e = ++this.state.pos;
                if (this.codePointAtPos(this.state.pos) === 35) {
                  ++this.state.pos;
                  let s = 10;
                  this.codePointAtPos(this.state.pos) === 120 && (s = 16, ++this.state.pos);
                  let i = this.readInt(s, void 0, false, "bail");
                  if (i !== null && this.codePointAtPos(this.state.pos) === 59)
                    return ++this.state.pos, String.fromCodePoint(i);
                } else {
                  let s = 0, i = false;
                  for (; s++ < 10 && this.state.pos < this.length && !(i = this.codePointAtPos(this.state.pos) == 59); )
                    ++this.state.pos;
                  if (i) {
                    let a = this.input.slice(e, this.state.pos), n = eh[a];
                    if (++this.state.pos, n)
                      return n;
                  }
                }
                return this.state.pos = e, "&";
              }
              jsxReadWord() {
                let e, s = this.state.pos;
                do
                  e = this.input.charCodeAt(++this.state.pos);
                while (De(e) || e === 45);
                this.finishToken(138, this.input.slice(s, this.state.pos));
              }
              jsxParseIdentifier() {
                let e = this.startNode();
                return this.match(138) ? e.name = this.state.value : $t(this.state.type) ? e.name = xe(this.state.type) : this.unexpected(), this.next(), this.finishNode(e, "JSXIdentifier");
              }
              jsxParseNamespacedName() {
                let e = this.state.startLoc, s = this.jsxParseIdentifier();
                if (!this.eat(14))
                  return s;
                let i = this.startNodeAt(e);
                return i.namespace = s, i.name = this.jsxParseIdentifier(), this.finishNode(i, "JSXNamespacedName");
              }
              jsxParseElementName() {
                let e = this.state.startLoc, s = this.jsxParseNamespacedName();
                if (s.type === "JSXNamespacedName")
                  return s;
                for (; this.eat(16); ) {
                  let i = this.startNodeAt(e);
                  i.object = s, i.property = this.jsxParseIdentifier(), s = this.finishNode(i, "JSXMemberExpression");
                }
                return s;
              }
              jsxParseAttributeValue() {
                let e;
                switch (this.state.type) {
                  case 5:
                    return e = this.startNode(), this.setContext(x.brace), this.next(), e = this.jsxParseExpressionContainer(e, x.j_oTag), e.expression.type === "JSXEmptyExpression" && this.raise(Se.AttributeIsEmpty, { at: e }), e;
                  case 140:
                  case 131:
                    return this.parseExprAtom();
                  default:
                    throw this.raise(Se.UnsupportedJsxValue, { at: this.state.startLoc });
                }
              }
              jsxParseEmptyExpression() {
                let e = this.startNodeAt(this.state.lastTokEndLoc);
                return this.finishNodeAt(e, "JSXEmptyExpression", this.state.startLoc);
              }
              jsxParseSpreadChild(e) {
                return this.next(), e.expression = this.parseExpression(), this.setContext(x.j_expr), this.state.canStartJSXElement = true, this.expect(8), this.finishNode(e, "JSXSpreadChild");
              }
              jsxParseExpressionContainer(e, s) {
                if (this.match(8))
                  e.expression = this.jsxParseEmptyExpression();
                else {
                  let i = this.parseExpression();
                  e.expression = i;
                }
                return this.setContext(s), this.state.canStartJSXElement = true, this.expect(8), this.finishNode(e, "JSXExpressionContainer");
              }
              jsxParseAttribute() {
                let e = this.startNode();
                return this.match(5) ? (this.setContext(x.brace), this.next(), this.expect(21), e.argument = this.parseMaybeAssignAllowIn(), this.setContext(x.j_oTag), this.state.canStartJSXElement = true, this.expect(8), this.finishNode(e, "JSXSpreadAttribute")) : (e.name = this.jsxParseNamespacedName(), e.value = this.eat(29) ? this.jsxParseAttributeValue() : null, this.finishNode(e, "JSXAttribute"));
              }
              jsxParseOpeningElementAt(e) {
                let s = this.startNodeAt(e);
                return this.eat(141) ? this.finishNode(s, "JSXOpeningFragment") : (s.name = this.jsxParseElementName(), this.jsxParseOpeningElementAfterName(s));
              }
              jsxParseOpeningElementAfterName(e) {
                let s = [];
                for (; !this.match(56) && !this.match(141); )
                  s.push(this.jsxParseAttribute());
                return e.attributes = s, e.selfClosing = this.eat(56), this.expect(141), this.finishNode(e, "JSXOpeningElement");
              }
              jsxParseClosingElementAt(e) {
                let s = this.startNodeAt(e);
                return this.eat(141) ? this.finishNode(s, "JSXClosingFragment") : (s.name = this.jsxParseElementName(), this.expect(141), this.finishNode(s, "JSXClosingElement"));
              }
              jsxParseElementAt(e) {
                let s = this.startNodeAt(e), i = [], a = this.jsxParseOpeningElementAt(e), n = null;
                if (!a.selfClosing) {
                  e:
                    for (; ; )
                      switch (this.state.type) {
                        case 140:
                          if (e = this.state.startLoc, this.next(), this.eat(56)) {
                            n = this.jsxParseClosingElementAt(e);
                            break e;
                          }
                          i.push(this.jsxParseElementAt(e));
                          break;
                        case 139:
                          i.push(this.parseExprAtom());
                          break;
                        case 5: {
                          let o = this.startNode();
                          this.setContext(x.brace), this.next(), this.match(21) ? i.push(this.jsxParseSpreadChild(o)) : i.push(this.jsxParseExpressionContainer(o, x.j_expr));
                          break;
                        }
                        default:
                          this.unexpected();
                      }
                  Te(a) && !Te(n) && n !== null ? this.raise(Se.MissingClosingTagFragment, { at: n }) : !Te(a) && Te(n) ? this.raise(Se.MissingClosingTagElement, { at: n, openingTagName: Re(a.name) }) : !Te(a) && !Te(n) && Re(n.name) !== Re(a.name) && this.raise(Se.MissingClosingTagElement, { at: n, openingTagName: Re(a.name) });
                }
                if (Te(a) ? (s.openingFragment = a, s.closingFragment = n) : (s.openingElement = a, s.closingElement = n), s.children = i, this.match(47))
                  throw this.raise(Se.UnwrappedAdjacentJSXElements, { at: this.state.startLoc });
                return Te(a) ? this.finishNode(s, "JSXFragment") : this.finishNode(s, "JSXElement");
              }
              jsxParseElement() {
                let e = this.state.startLoc;
                return this.next(), this.jsxParseElementAt(e);
              }
              setContext(e) {
                let { context: s } = this.state;
                s[s.length - 1] = e;
              }
              parseExprAtom(e) {
                return this.match(139) ? this.parseLiteral(this.state.value, "JSXText") : this.match(140) ? this.jsxParseElement() : this.match(47) && this.input.charCodeAt(this.state.pos) !== 33 ? (this.replaceToken(140), this.jsxParseElement()) : super.parseExprAtom(e);
              }
              skipSpace() {
                this.curContext().preserveSpace || super.skipSpace();
              }
              getTokenFromCode(e) {
                let s = this.curContext();
                if (s === x.j_expr) {
                  this.jsxReadToken();
                  return;
                }
                if (s === x.j_oTag || s === x.j_cTag) {
                  if (fe(e)) {
                    this.jsxReadWord();
                    return;
                  }
                  if (e === 62) {
                    ++this.state.pos, this.finishToken(141);
                    return;
                  }
                  if ((e === 34 || e === 39) && s === x.j_oTag) {
                    this.jsxReadString(e);
                    return;
                  }
                }
                if (e === 60 && this.state.canStartJSXElement && this.input.charCodeAt(this.state.pos + 1) !== 33) {
                  ++this.state.pos, this.finishToken(140);
                  return;
                }
                super.getTokenFromCode(e);
              }
              updateContext(e) {
                let { context: s, type: i } = this.state;
                if (i === 56 && e === 140)
                  s.splice(-2, 2, x.j_cTag), this.state.canStartJSXElement = false;
                else if (i === 140)
                  s.push(x.j_oTag);
                else if (i === 141) {
                  let a = s[s.length - 1];
                  a === x.j_oTag && e === 56 || a === x.j_cTag ? (s.pop(), this.state.canStartJSXElement = s[s.length - 1] === x.j_expr) : (this.setContext(x.j_expr), this.state.canStartJSXElement = true);
                } else
                  this.state.canStartJSXElement = se(i);
              }
            }, sh = class extends rs {
              constructor() {
                super(...arguments), this.types = /* @__PURE__ */ new Set(), this.enums = /* @__PURE__ */ new Set(), this.constEnums = /* @__PURE__ */ new Set(), this.classes = /* @__PURE__ */ new Set(), this.exportOnlyBindings = /* @__PURE__ */ new Set();
              }
            }, rh = class extends is {
              constructor() {
                super(...arguments), this.importsStack = [];
              }
              createScope(t3) {
                return this.importsStack.push(/* @__PURE__ */ new Set()), new sh(t3);
              }
              enter(t3) {
                t3 == Oe && this.importsStack.push(/* @__PURE__ */ new Set()), super.enter(t3);
              }
              exit() {
                let t3 = super.exit();
                return t3 == Oe && this.importsStack.pop(), t3;
              }
              hasImport(t3, r) {
                let e = this.importsStack.length;
                if (this.importsStack[e - 1].has(t3))
                  return true;
                if (!r && e > 1) {
                  for (let s = 0; s < e - 1; s++)
                    if (this.importsStack[s].has(t3))
                      return true;
                }
                return false;
              }
              declareName(t3, r, e) {
                if (r & Ve) {
                  this.hasImport(t3, true) && this.parser.raise(f.VarRedeclaration, { at: e, identifierName: t3 }), this.importsStack[this.importsStack.length - 1].add(t3);
                  return;
                }
                let s = this.currentScope();
                if (r & Yt) {
                  this.maybeExportDefined(s, t3), s.exportOnlyBindings.add(t3);
                  return;
                }
                super.declareName(t3, r, e), r & Ce && (r & le || (this.checkRedeclarationInScope(s, t3, r, e), this.maybeExportDefined(s, t3)), s.types.add(t3)), r & Jt && s.enums.add(t3), r & Xt && s.constEnums.add(t3), r & ft && s.classes.add(t3);
              }
              isRedeclaredInScope(t3, r, e) {
                if (t3.enums.has(r)) {
                  if (e & Jt) {
                    let s = !!(e & Xt), i = t3.constEnums.has(r);
                    return s !== i;
                  }
                  return true;
                }
                return e & ft && t3.classes.has(r) ? t3.lexical.has(r) ? !!(e & le) : false : e & Ce && t3.types.has(r) ? true : super.isRedeclaredInScope(t3, r, e);
              }
              checkLocalExport(t3) {
                let { name: r } = t3;
                if (this.hasImport(r))
                  return;
                let e = this.scopeStack.length;
                for (let s = e - 1; s >= 0; s--) {
                  let i = this.scopeStack[s];
                  if (i.types.has(r) || i.exportOnlyBindings.has(r))
                    return;
                }
                super.checkLocalExport(t3);
              }
            }, ih = (t3, r) => Object.hasOwnProperty.call(t3, r) && t3[r], Ur = (t3) => t3.type === "ParenthesizedExpression" ? Ur(t3.expression) : t3, ah = class extends Wl {
              toAssignable(t3) {
                let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var e, s;
                let i;
                switch ((t3.type === "ParenthesizedExpression" || (e = t3.extra) != null && e.parenthesized) && (i = Ur(t3), r ? i.type === "Identifier" ? this.expressionScope.recordArrowParameterBindingError(f.InvalidParenthesizedAssignment, { at: t3 }) : i.type !== "MemberExpression" && this.raise(f.InvalidParenthesizedAssignment, { at: t3 }) : this.raise(f.InvalidParenthesizedAssignment, { at: t3 })), t3.type) {
                  case "Identifier":
                  case "ObjectPattern":
                  case "ArrayPattern":
                  case "AssignmentPattern":
                  case "RestElement":
                    break;
                  case "ObjectExpression":
                    t3.type = "ObjectPattern";
                    for (let n = 0, o = t3.properties.length, u = o - 1; n < o; n++) {
                      var a;
                      let c = t3.properties[n], y = n === u;
                      this.toAssignableObjectExpressionProp(c, y, r), y && c.type === "RestElement" && (a = t3.extra) != null && a.trailingCommaLoc && this.raise(f.RestTrailingComma, { at: t3.extra.trailingCommaLoc });
                    }
                    break;
                  case "ObjectProperty": {
                    let { key: n, value: o } = t3;
                    this.isPrivateName(n) && this.classScope.usePrivateName(this.getPrivateNameSV(n), n.loc.start), this.toAssignable(o, r);
                    break;
                  }
                  case "SpreadElement":
                    throw new Error("Internal @babel/parser error (this is a bug, please report it). SpreadElement should be converted by .toAssignable's caller.");
                  case "ArrayExpression":
                    t3.type = "ArrayPattern", this.toAssignableList(t3.elements, (s = t3.extra) == null ? void 0 : s.trailingCommaLoc, r);
                    break;
                  case "AssignmentExpression":
                    t3.operator !== "=" && this.raise(f.MissingEqInAssignment, { at: t3.left.loc.end }), t3.type = "AssignmentPattern", delete t3.operator, this.toAssignable(t3.left, r);
                    break;
                  case "ParenthesizedExpression":
                    this.toAssignable(i, r);
                    break;
                }
              }
              toAssignableObjectExpressionProp(t3, r, e) {
                if (t3.type === "ObjectMethod")
                  this.raise(t3.kind === "get" || t3.kind === "set" ? f.PatternHasAccessor : f.PatternHasMethod, { at: t3.key });
                else if (t3.type === "SpreadElement") {
                  t3.type = "RestElement";
                  let s = t3.argument;
                  this.checkToRestConversion(s, false), this.toAssignable(s, e), r || this.raise(f.RestTrailingComma, { at: t3 });
                } else
                  this.toAssignable(t3, e);
              }
              toAssignableList(t3, r, e) {
                let s = t3.length - 1;
                for (let i = 0; i <= s; i++) {
                  let a = t3[i];
                  if (a) {
                    if (a.type === "SpreadElement") {
                      a.type = "RestElement";
                      let n = a.argument;
                      this.checkToRestConversion(n, true), this.toAssignable(n, e);
                    } else
                      this.toAssignable(a, e);
                    a.type === "RestElement" && (i < s ? this.raise(f.RestTrailingComma, { at: a }) : r && this.raise(f.RestTrailingComma, { at: r }));
                  }
                }
              }
              isAssignable(t3, r) {
                switch (t3.type) {
                  case "Identifier":
                  case "ObjectPattern":
                  case "ArrayPattern":
                  case "AssignmentPattern":
                  case "RestElement":
                    return true;
                  case "ObjectExpression": {
                    let e = t3.properties.length - 1;
                    return t3.properties.every((s, i) => s.type !== "ObjectMethod" && (i === e || s.type !== "SpreadElement") && this.isAssignable(s));
                  }
                  case "ObjectProperty":
                    return this.isAssignable(t3.value);
                  case "SpreadElement":
                    return this.isAssignable(t3.argument);
                  case "ArrayExpression":
                    return t3.elements.every((e) => e === null || this.isAssignable(e));
                  case "AssignmentExpression":
                    return t3.operator === "=";
                  case "ParenthesizedExpression":
                    return this.isAssignable(t3.expression);
                  case "MemberExpression":
                  case "OptionalMemberExpression":
                    return !r;
                  default:
                    return false;
                }
              }
              toReferencedList(t3, r) {
                return t3;
              }
              toReferencedListDeep(t3, r) {
                this.toReferencedList(t3, r);
                for (let e of t3)
                  (e == null ? void 0 : e.type) === "ArrayExpression" && this.toReferencedListDeep(e.elements);
              }
              parseSpread(t3) {
                let r = this.startNode();
                return this.next(), r.argument = this.parseMaybeAssignAllowIn(t3, void 0), this.finishNode(r, "SpreadElement");
              }
              parseRestBinding() {
                let t3 = this.startNode();
                return this.next(), t3.argument = this.parseBindingAtom(), this.finishNode(t3, "RestElement");
              }
              parseBindingAtom() {
                switch (this.state.type) {
                  case 0: {
                    let t3 = this.startNode();
                    return this.next(), t3.elements = this.parseBindingList(3, 93, 1), this.finishNode(t3, "ArrayPattern");
                  }
                  case 5:
                    return this.parseObjectLike(8, true);
                }
                return this.parseIdentifier();
              }
              parseBindingList(t3, r, e) {
                let s = e & 1, i = [], a = true;
                for (; !this.eat(t3); )
                  if (a ? a = false : this.expect(12), s && this.match(12))
                    i.push(null);
                  else {
                    if (this.eat(t3))
                      break;
                    if (this.match(21)) {
                      if (i.push(this.parseAssignableListItemTypes(this.parseRestBinding(), e)), !this.checkCommaAfterRest(r)) {
                        this.expect(t3);
                        break;
                      }
                    } else {
                      let n = [];
                      for (this.match(26) && this.hasPlugin("decorators") && this.raise(f.UnsupportedParameterDecorator, { at: this.state.startLoc }); this.match(26); )
                        n.push(this.parseDecorator());
                      i.push(this.parseAssignableListItem(e, n));
                    }
                  }
                return i;
              }
              parseBindingRestProperty(t3) {
                return this.next(), t3.argument = this.parseIdentifier(), this.checkCommaAfterRest(125), this.finishNode(t3, "RestElement");
              }
              parseBindingProperty() {
                let t3 = this.startNode(), { type: r, startLoc: e } = this.state;
                return r === 21 ? this.parseBindingRestProperty(t3) : (r === 136 ? (this.expectPlugin("destructuringPrivate", e), this.classScope.usePrivateName(this.state.value, e), t3.key = this.parsePrivateName()) : this.parsePropertyName(t3), t3.method = false, this.parseObjPropValue(t3, e, false, false, true, false));
              }
              parseAssignableListItem(t3, r) {
                let e = this.parseMaybeDefault();
                this.parseAssignableListItemTypes(e, t3);
                let s = this.parseMaybeDefault(e.loc.start, e);
                return r.length && (e.decorators = r), s;
              }
              parseAssignableListItemTypes(t3, r) {
                return t3;
              }
              parseMaybeDefault(t3, r) {
                var e, s;
                if ((e = t3) != null || (t3 = this.state.startLoc), r = (s = r) != null ? s : this.parseBindingAtom(), !this.eat(29))
                  return r;
                let i = this.startNodeAt(t3);
                return i.left = r, i.right = this.parseMaybeAssignAllowIn(), this.finishNode(i, "AssignmentPattern");
              }
              isValidLVal(t3, r, e) {
                return ih({ AssignmentPattern: "left", RestElement: "argument", ObjectProperty: "value", ParenthesizedExpression: "expression", ArrayPattern: "elements", ObjectPattern: "properties" }, t3);
              }
              checkLVal(t3, r) {
                let { in: e, binding: s = Pe, checkClashes: i = false, strictModeChanged: a = false, hasParenthesizedAncestor: n = false } = r;
                var o;
                let u = t3.type;
                if (this.isObjectMethod(t3))
                  return;
                if (u === "MemberExpression") {
                  s !== Pe && this.raise(f.InvalidPropertyBindingPattern, { at: t3 });
                  return;
                }
                if (u === "Identifier") {
                  this.checkIdentifier(t3, s, a);
                  let { name: C } = t3;
                  i && (i.has(C) ? this.raise(f.ParamDupe, { at: t3 }) : i.add(C));
                  return;
                }
                let c = this.isValidLVal(u, !(n || (o = t3.extra) != null && o.parenthesized) && e.type === "AssignmentExpression", s);
                if (c === true)
                  return;
                if (c === false) {
                  let C = s === Pe ? f.InvalidLhs : f.InvalidLhsBinding;
                  this.raise(C, { at: t3, ancestor: e });
                  return;
                }
                let [y, g] = Array.isArray(c) ? c : [c, u === "ParenthesizedExpression"], T = u === "ArrayPattern" || u === "ObjectPattern" || u === "ParenthesizedExpression" ? { type: u } : e;
                for (let C of [].concat(t3[y]))
                  C && this.checkLVal(C, { in: T, binding: s, checkClashes: i, strictModeChanged: a, hasParenthesizedAncestor: g });
              }
              checkIdentifier(t3, r) {
                let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                this.state.strict && (e ? xr(t3.name, this.inModule) : yr(t3.name)) && (r === Pe ? this.raise(f.StrictEvalArguments, { at: t3, referenceName: t3.name }) : this.raise(f.StrictEvalArgumentsBinding, { at: t3, bindingName: t3.name })), r & dt && t3.name === "let" && this.raise(f.LetInLexicalBinding, { at: t3 }), r & Pe || this.declareNameFromIdentifier(t3, r);
              }
              declareNameFromIdentifier(t3, r) {
                this.scope.declareName(t3.name, r, t3.loc.start);
              }
              checkToRestConversion(t3, r) {
                switch (t3.type) {
                  case "ParenthesizedExpression":
                    this.checkToRestConversion(t3.expression, r);
                    break;
                  case "Identifier":
                  case "MemberExpression":
                    break;
                  case "ArrayExpression":
                  case "ObjectExpression":
                    if (r)
                      break;
                  default:
                    this.raise(f.InvalidRestAssignmentPattern, { at: t3 });
                }
              }
              checkCommaAfterRest(t3) {
                return this.match(12) ? (this.raise(this.lookaheadCharCode() === t3 ? f.RestTrailingComma : f.ElementAfterRest, { at: this.state.startLoc }), true) : false;
              }
            }, nh = (t3, r) => Object.hasOwnProperty.call(t3, r) && t3[r];
            function oh(t3) {
              if (t3 == null)
                throw new Error(`Unexpected ${t3} value.`);
              return t3;
            }
            function $r(t3) {
              if (!t3)
                throw new Error("Assert fail");
            }
            var I = pe`typescript`({ AbstractMethodHasImplementation: (t3) => {
              let { methodName: r } = t3;
              return `Method '${r}' cannot have an implementation because it is marked abstract.`;
            }, AbstractPropertyHasInitializer: (t3) => {
              let { propertyName: r } = t3;
              return `Property '${r}' cannot have an initializer because it is marked abstract.`;
            }, AccesorCannotDeclareThisParameter: "'get' and 'set' accessors cannot declare 'this' parameters.", AccesorCannotHaveTypeParameters: "An accessor cannot have type parameters.", AccessorCannotBeOptional: "An 'accessor' property cannot be declared optional.", ClassMethodHasDeclare: "Class methods cannot have the 'declare' modifier.", ClassMethodHasReadonly: "Class methods cannot have the 'readonly' modifier.", ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference: "A 'const' initializer in an ambient context must be a string or numeric literal or literal enum reference.", ConstructorHasTypeParameters: "Type parameters cannot appear on a constructor declaration.", DeclareAccessor: (t3) => {
              let { kind: r } = t3;
              return `'declare' is not allowed in ${r}ters.`;
            }, DeclareClassFieldHasInitializer: "Initializers are not allowed in ambient contexts.", DeclareFunctionHasImplementation: "An implementation cannot be declared in ambient contexts.", DuplicateAccessibilityModifier: (t3) => {
              let { modifier: r } = t3;
              return "Accessibility modifier already seen.";
            }, DuplicateModifier: (t3) => {
              let { modifier: r } = t3;
              return `Duplicate modifier: '${r}'.`;
            }, EmptyHeritageClauseType: (t3) => {
              let { token: r } = t3;
              return `'${r}' list cannot be empty.`;
            }, EmptyTypeArguments: "Type argument list cannot be empty.", EmptyTypeParameters: "Type parameter list cannot be empty.", ExpectedAmbientAfterExportDeclare: "'export declare' must be followed by an ambient declaration.", ImportAliasHasImportType: "An import alias can not use 'import type'.", ImportReflectionHasImportType: "An `import module` declaration can not use `type` modifier", IncompatibleModifiers: (t3) => {
              let { modifiers: r } = t3;
              return `'${r[0]}' modifier cannot be used with '${r[1]}' modifier.`;
            }, IndexSignatureHasAbstract: "Index signatures cannot have the 'abstract' modifier.", IndexSignatureHasAccessibility: (t3) => {
              let { modifier: r } = t3;
              return `Index signatures cannot have an accessibility modifier ('${r}').`;
            }, IndexSignatureHasDeclare: "Index signatures cannot have the 'declare' modifier.", IndexSignatureHasOverride: "'override' modifier cannot appear on an index signature.", IndexSignatureHasStatic: "Index signatures cannot have the 'static' modifier.", InitializerNotAllowedInAmbientContext: "Initializers are not allowed in ambient contexts.", InvalidModifierOnTypeMember: (t3) => {
              let { modifier: r } = t3;
              return `'${r}' modifier cannot appear on a type member.`;
            }, InvalidModifierOnTypeParameter: (t3) => {
              let { modifier: r } = t3;
              return `'${r}' modifier cannot appear on a type parameter.`;
            }, InvalidModifierOnTypeParameterPositions: (t3) => {
              let { modifier: r } = t3;
              return `'${r}' modifier can only appear on a type parameter of a class, interface or type alias.`;
            }, InvalidModifiersOrder: (t3) => {
              let { orderedModifiers: r } = t3;
              return `'${r[0]}' modifier must precede '${r[1]}' modifier.`;
            }, InvalidPropertyAccessAfterInstantiationExpression: "Invalid property access after an instantiation expression. You can either wrap the instantiation expression in parentheses, or delete the type arguments.", InvalidTupleMemberLabel: "Tuple members must be labeled with a simple identifier.", MissingInterfaceName: "'interface' declarations must be followed by an identifier.", MixedLabeledAndUnlabeledElements: "Tuple members must all have names or all not have names.", NonAbstractClassHasAbstractMethod: "Abstract methods can only appear within an abstract class.", NonClassMethodPropertyHasAbstractModifer: "'abstract' modifier can only appear on a class, method, or property declaration.", OptionalTypeBeforeRequired: "A required element cannot follow an optional element.", OverrideNotInSubClass: "This member cannot have an 'override' modifier because its containing class does not extend another class.", PatternIsOptional: "A binding pattern parameter cannot be optional in an implementation signature.", PrivateElementHasAbstract: "Private elements cannot have the 'abstract' modifier.", PrivateElementHasAccessibility: (t3) => {
              let { modifier: r } = t3;
              return `Private elements cannot have an accessibility modifier ('${r}').`;
            }, ReadonlyForMethodSignature: "'readonly' modifier can only appear on a property declaration or index signature.", ReservedArrowTypeParam: "This syntax is reserved in files with the .mts or .cts extension. Add a trailing comma, as in `<T,>() => ...`.", ReservedTypeAssertion: "This syntax is reserved in files with the .mts or .cts extension. Use an `as` expression instead.", SetAccesorCannotHaveOptionalParameter: "A 'set' accessor cannot have an optional parameter.", SetAccesorCannotHaveRestParameter: "A 'set' accessor cannot have rest parameter.", SetAccesorCannotHaveReturnType: "A 'set' accessor cannot have a return type annotation.", SingleTypeParameterWithoutTrailingComma: (t3) => {
              let { typeParameterName: r } = t3;
              return `Single type parameter ${r} should have a trailing comma. Example usage: <${r},>.`;
            }, StaticBlockCannotHaveModifier: "Static class blocks cannot have any modifier.", TupleOptionalAfterType: "A labeled tuple optional element must be declared using a question mark after the name and before the colon (`name?: type`), rather than after the type (`name: type?`).", TypeAnnotationAfterAssign: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.", TypeImportCannotSpecifyDefaultAndNamed: "A type-only import can specify a default import or named bindings, but not both.", TypeModifierIsUsedInTypeExports: "The 'type' modifier cannot be used on a named export when 'export type' is used on its export statement.", TypeModifierIsUsedInTypeImports: "The 'type' modifier cannot be used on a named import when 'import type' is used on its import statement.", UnexpectedParameterModifier: "A parameter property is only allowed in a constructor implementation.", UnexpectedReadonly: "'readonly' type modifier is only permitted on array and tuple literal types.", UnexpectedTypeAnnotation: "Did not expect a type annotation here.", UnexpectedTypeCastInParameter: "Unexpected type cast in parameter position.", UnsupportedImportTypeArgument: "Argument in a type import must be a string literal.", UnsupportedParameterPropertyKind: "A parameter property may not be declared using a binding pattern.", UnsupportedSignatureParameterKind: (t3) => {
              let { type: r } = t3;
              return `Name in a signature must be an Identifier, ObjectPattern or ArrayPattern, instead got ${r}.`;
            } });
            function lh(t3) {
              switch (t3) {
                case "any":
                  return "TSAnyKeyword";
                case "boolean":
                  return "TSBooleanKeyword";
                case "bigint":
                  return "TSBigIntKeyword";
                case "never":
                  return "TSNeverKeyword";
                case "number":
                  return "TSNumberKeyword";
                case "object":
                  return "TSObjectKeyword";
                case "string":
                  return "TSStringKeyword";
                case "symbol":
                  return "TSSymbolKeyword";
                case "undefined":
                  return "TSUndefinedKeyword";
                case "unknown":
                  return "TSUnknownKeyword";
                default:
                  return;
              }
            }
            function Hr(t3) {
              return t3 === "private" || t3 === "public" || t3 === "protected";
            }
            function hh(t3) {
              return t3 === "in" || t3 === "out";
            }
            var uh = (t3) => class extends t3 {
              constructor() {
                super(...arguments), this.tsParseInOutModifiers = this.tsParseModifiers.bind(this, { allowedModifiers: ["in", "out"], disallowedModifiers: ["const", "public", "private", "protected", "readonly", "declare", "abstract", "override"], errorTemplate: I.InvalidModifierOnTypeParameter }), this.tsParseConstModifier = this.tsParseModifiers.bind(this, { allowedModifiers: ["const"], disallowedModifiers: ["in", "out"], errorTemplate: I.InvalidModifierOnTypeParameterPositions }), this.tsParseInOutConstModifiers = this.tsParseModifiers.bind(this, { allowedModifiers: ["in", "out", "const"], disallowedModifiers: ["public", "private", "protected", "readonly", "declare", "abstract", "override"], errorTemplate: I.InvalidModifierOnTypeParameter });
              }
              getScopeHandler() {
                return rh;
              }
              tsIsIdentifier() {
                return q(this.state.type);
              }
              tsTokenCanFollowModifier() {
                return (this.match(0) || this.match(5) || this.match(55) || this.match(21) || this.match(136) || this.isLiteralPropertyName()) && !this.hasPrecedingLineBreak();
              }
              tsNextTokenCanFollowModifier() {
                return this.next(), this.tsTokenCanFollowModifier();
              }
              tsParseModifier(e, s) {
                if (!q(this.state.type) && this.state.type !== 58 && this.state.type !== 75)
                  return;
                let i = this.state.value;
                if (e.indexOf(i) !== -1) {
                  if (s && this.tsIsStartOfStaticBlocks())
                    return;
                  if (this.tsTryParse(this.tsNextTokenCanFollowModifier.bind(this)))
                    return i;
                }
              }
              tsParseModifiers(e, s) {
                let { allowedModifiers: i, disallowedModifiers: a, stopOnStartOfClassStaticBlock: n, errorTemplate: o = I.InvalidModifierOnTypeMember } = e, u = (y, g, T, C) => {
                  g === T && s[C] && this.raise(I.InvalidModifiersOrder, { at: y, orderedModifiers: [T, C] });
                }, c = (y, g, T, C) => {
                  (s[T] && g === C || s[C] && g === T) && this.raise(I.IncompatibleModifiers, { at: y, modifiers: [T, C] });
                };
                for (; ; ) {
                  let { startLoc: y } = this.state, g = this.tsParseModifier(i.concat(a != null ? a : []), n);
                  if (!g)
                    break;
                  Hr(g) ? s.accessibility ? this.raise(I.DuplicateAccessibilityModifier, { at: y, modifier: g }) : (u(y, g, g, "override"), u(y, g, g, "static"), u(y, g, g, "readonly"), s.accessibility = g) : hh(g) ? (s[g] && this.raise(I.DuplicateModifier, { at: y, modifier: g }), s[g] = true, u(y, g, "in", "out")) : (Object.hasOwnProperty.call(s, g) ? this.raise(I.DuplicateModifier, { at: y, modifier: g }) : (u(y, g, "static", "readonly"), u(y, g, "static", "override"), u(y, g, "override", "readonly"), u(y, g, "abstract", "override"), c(y, g, "declare", "override"), c(y, g, "static", "abstract")), s[g] = true), a != null && a.includes(g) && this.raise(o, { at: y, modifier: g });
                }
              }
              tsIsListTerminator(e) {
                switch (e) {
                  case "EnumMembers":
                  case "TypeMembers":
                    return this.match(8);
                  case "HeritageClauseElement":
                    return this.match(5);
                  case "TupleElementTypes":
                    return this.match(3);
                  case "TypeParametersOrArguments":
                    return this.match(48);
                }
              }
              tsParseList(e, s) {
                let i = [];
                for (; !this.tsIsListTerminator(e); )
                  i.push(s());
                return i;
              }
              tsParseDelimitedList(e, s, i) {
                return oh(this.tsParseDelimitedListWorker(e, s, true, i));
              }
              tsParseDelimitedListWorker(e, s, i, a) {
                let n = [], o = -1;
                for (; !this.tsIsListTerminator(e); ) {
                  o = -1;
                  let u = s();
                  if (u == null)
                    return;
                  if (n.push(u), this.eat(12)) {
                    o = this.state.lastTokStart;
                    continue;
                  }
                  if (this.tsIsListTerminator(e))
                    break;
                  i && this.expect(12);
                  return;
                }
                return a && (a.value = o), n;
              }
              tsParseBracketedList(e, s, i, a, n) {
                a || (i ? this.expect(0) : this.expect(47));
                let o = this.tsParseDelimitedList(e, s, n);
                return i ? this.expect(3) : this.expect(48), o;
              }
              tsParseImportType() {
                let e = this.startNode();
                return this.expect(83), this.expect(10), this.match(131) || this.raise(I.UnsupportedImportTypeArgument, { at: this.state.startLoc }), e.argument = super.parseExprAtom(), this.expect(11), this.eat(16) && (e.qualifier = this.tsParseEntityName()), this.match(47) && (e.typeParameters = this.tsParseTypeArguments()), this.finishNode(e, "TSImportType");
              }
              tsParseEntityName() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, s = this.parseIdentifier(e);
                for (; this.eat(16); ) {
                  let i = this.startNodeAtNode(s);
                  i.left = s, i.right = this.parseIdentifier(e), s = this.finishNode(i, "TSQualifiedName");
                }
                return s;
              }
              tsParseTypeReference() {
                let e = this.startNode();
                return e.typeName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (e.typeParameters = this.tsParseTypeArguments()), this.finishNode(e, "TSTypeReference");
              }
              tsParseThisTypePredicate(e) {
                this.next();
                let s = this.startNodeAtNode(e);
                return s.parameterName = e, s.typeAnnotation = this.tsParseTypeAnnotation(false), s.asserts = false, this.finishNode(s, "TSTypePredicate");
              }
              tsParseThisTypeNode() {
                let e = this.startNode();
                return this.next(), this.finishNode(e, "TSThisType");
              }
              tsParseTypeQuery() {
                let e = this.startNode();
                return this.expect(87), this.match(83) ? e.exprName = this.tsParseImportType() : e.exprName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (e.typeParameters = this.tsParseTypeArguments()), this.finishNode(e, "TSTypeQuery");
              }
              tsParseTypeParameter(e) {
                let s = this.startNode();
                return e(s), s.name = this.tsParseTypeParameterName(), s.constraint = this.tsEatThenParseType(81), s.default = this.tsEatThenParseType(29), this.finishNode(s, "TSTypeParameter");
              }
              tsTryParseTypeParameters(e) {
                if (this.match(47))
                  return this.tsParseTypeParameters(e);
              }
              tsParseTypeParameters(e) {
                let s = this.startNode();
                this.match(47) || this.match(140) ? this.next() : this.unexpected();
                let i = { value: -1 };
                return s.params = this.tsParseBracketedList("TypeParametersOrArguments", this.tsParseTypeParameter.bind(this, e), false, true, i), s.params.length === 0 && this.raise(I.EmptyTypeParameters, { at: s }), i.value !== -1 && this.addExtra(s, "trailingComma", i.value), this.finishNode(s, "TSTypeParameterDeclaration");
              }
              tsFillSignature(e, s) {
                let i = e === 19, a = "parameters", n = "typeAnnotation";
                s.typeParameters = this.tsTryParseTypeParameters(this.tsParseConstModifier), this.expect(10), s[a] = this.tsParseBindingListForSignature(), i ? s[n] = this.tsParseTypeOrTypePredicateAnnotation(e) : this.match(e) && (s[n] = this.tsParseTypeOrTypePredicateAnnotation(e));
              }
              tsParseBindingListForSignature() {
                return super.parseBindingList(11, 41, 2).map((e) => (e.type !== "Identifier" && e.type !== "RestElement" && e.type !== "ObjectPattern" && e.type !== "ArrayPattern" && this.raise(I.UnsupportedSignatureParameterKind, { at: e, type: e.type }), e));
              }
              tsParseTypeMemberSemicolon() {
                !this.eat(12) && !this.isLineTerminator() && this.expect(13);
              }
              tsParseSignatureMember(e, s) {
                return this.tsFillSignature(14, s), this.tsParseTypeMemberSemicolon(), this.finishNode(s, e);
              }
              tsIsUnambiguouslyIndexSignature() {
                return this.next(), q(this.state.type) ? (this.next(), this.match(14)) : false;
              }
              tsTryParseIndexSignature(e) {
                if (!(this.match(0) && this.tsLookAhead(this.tsIsUnambiguouslyIndexSignature.bind(this))))
                  return;
                this.expect(0);
                let s = this.parseIdentifier();
                s.typeAnnotation = this.tsParseTypeAnnotation(), this.resetEndLocation(s), this.expect(3), e.parameters = [s];
                let i = this.tsTryParseTypeAnnotation();
                return i && (e.typeAnnotation = i), this.tsParseTypeMemberSemicolon(), this.finishNode(e, "TSIndexSignature");
              }
              tsParsePropertyOrMethodSignature(e, s) {
                this.eat(17) && (e.optional = true);
                let i = e;
                if (this.match(10) || this.match(47)) {
                  s && this.raise(I.ReadonlyForMethodSignature, { at: e });
                  let a = i;
                  a.kind && this.match(47) && this.raise(I.AccesorCannotHaveTypeParameters, { at: this.state.curPosition() }), this.tsFillSignature(14, a), this.tsParseTypeMemberSemicolon();
                  let n = "parameters", o = "typeAnnotation";
                  if (a.kind === "get")
                    a[n].length > 0 && (this.raise(f.BadGetterArity, { at: this.state.curPosition() }), this.isThisParam(a[n][0]) && this.raise(I.AccesorCannotDeclareThisParameter, { at: this.state.curPosition() }));
                  else if (a.kind === "set") {
                    if (a[n].length !== 1)
                      this.raise(f.BadSetterArity, { at: this.state.curPosition() });
                    else {
                      let u = a[n][0];
                      this.isThisParam(u) && this.raise(I.AccesorCannotDeclareThisParameter, { at: this.state.curPosition() }), u.type === "Identifier" && u.optional && this.raise(I.SetAccesorCannotHaveOptionalParameter, { at: this.state.curPosition() }), u.type === "RestElement" && this.raise(I.SetAccesorCannotHaveRestParameter, { at: this.state.curPosition() });
                    }
                    a[o] && this.raise(I.SetAccesorCannotHaveReturnType, { at: a[o] });
                  } else
                    a.kind = "method";
                  return this.finishNode(a, "TSMethodSignature");
                } else {
                  let a = i;
                  s && (a.readonly = true);
                  let n = this.tsTryParseTypeAnnotation();
                  return n && (a.typeAnnotation = n), this.tsParseTypeMemberSemicolon(), this.finishNode(a, "TSPropertySignature");
                }
              }
              tsParseTypeMember() {
                let e = this.startNode();
                if (this.match(10) || this.match(47))
                  return this.tsParseSignatureMember("TSCallSignatureDeclaration", e);
                if (this.match(77)) {
                  let i = this.startNode();
                  return this.next(), this.match(10) || this.match(47) ? this.tsParseSignatureMember("TSConstructSignatureDeclaration", e) : (e.key = this.createIdentifier(i, "new"), this.tsParsePropertyOrMethodSignature(e, false));
                }
                this.tsParseModifiers({ allowedModifiers: ["readonly"], disallowedModifiers: ["declare", "abstract", "private", "protected", "public", "static", "override"] }, e);
                let s = this.tsTryParseIndexSignature(e);
                return s || (super.parsePropertyName(e), !e.computed && e.key.type === "Identifier" && (e.key.name === "get" || e.key.name === "set") && this.tsTokenCanFollowModifier() && (e.kind = e.key.name, super.parsePropertyName(e)), this.tsParsePropertyOrMethodSignature(e, !!e.readonly));
              }
              tsParseTypeLiteral() {
                let e = this.startNode();
                return e.members = this.tsParseObjectTypeMembers(), this.finishNode(e, "TSTypeLiteral");
              }
              tsParseObjectTypeMembers() {
                this.expect(5);
                let e = this.tsParseList("TypeMembers", this.tsParseTypeMember.bind(this));
                return this.expect(8), e;
              }
              tsIsStartOfMappedType() {
                return this.next(), this.eat(53) ? this.isContextual(120) : (this.isContextual(120) && this.next(), !this.match(0) || (this.next(), !this.tsIsIdentifier()) ? false : (this.next(), this.match(58)));
              }
              tsParseMappedTypeParameter() {
                let e = this.startNode();
                return e.name = this.tsParseTypeParameterName(), e.constraint = this.tsExpectThenParseType(58), this.finishNode(e, "TSTypeParameter");
              }
              tsParseMappedType() {
                let e = this.startNode();
                return this.expect(5), this.match(53) ? (e.readonly = this.state.value, this.next(), this.expectContextual(120)) : this.eatContextual(120) && (e.readonly = true), this.expect(0), e.typeParameter = this.tsParseMappedTypeParameter(), e.nameType = this.eatContextual(93) ? this.tsParseType() : null, this.expect(3), this.match(53) ? (e.optional = this.state.value, this.next(), this.expect(17)) : this.eat(17) && (e.optional = true), e.typeAnnotation = this.tsTryParseType(), this.semicolon(), this.expect(8), this.finishNode(e, "TSMappedType");
              }
              tsParseTupleType() {
                let e = this.startNode();
                e.elementTypes = this.tsParseBracketedList("TupleElementTypes", this.tsParseTupleElementType.bind(this), true, false);
                let s = false, i = null;
                return e.elementTypes.forEach((a) => {
                  var n;
                  let { type: o } = a;
                  s && o !== "TSRestType" && o !== "TSOptionalType" && !(o === "TSNamedTupleMember" && a.optional) && this.raise(I.OptionalTypeBeforeRequired, { at: a }), s || (s = o === "TSNamedTupleMember" && a.optional || o === "TSOptionalType");
                  let u = o;
                  o === "TSRestType" && (a = a.typeAnnotation, u = a.type);
                  let c = u === "TSNamedTupleMember";
                  (n = i) != null || (i = c), i !== c && this.raise(I.MixedLabeledAndUnlabeledElements, { at: a });
                }), this.finishNode(e, "TSTupleType");
              }
              tsParseTupleElementType() {
                let { startLoc: e } = this.state, s = this.eat(21), i, a, n, o, c = te(this.state.type) ? this.lookaheadCharCode() : null;
                if (c === 58)
                  i = true, n = false, a = this.parseIdentifier(true), this.expect(14), o = this.tsParseType();
                else if (c === 63) {
                  n = true;
                  let y = this.state.startLoc, g = this.state.value, T = this.tsParseNonArrayType();
                  this.lookaheadCharCode() === 58 ? (i = true, a = this.createIdentifier(this.startNodeAt(y), g), this.expect(17), this.expect(14), o = this.tsParseType()) : (i = false, o = T, this.expect(17));
                } else
                  o = this.tsParseType(), n = this.eat(17), i = this.eat(14);
                if (i) {
                  let y;
                  a ? (y = this.startNodeAtNode(a), y.optional = n, y.label = a, y.elementType = o, this.eat(17) && (y.optional = true, this.raise(I.TupleOptionalAfterType, { at: this.state.lastTokStartLoc }))) : (y = this.startNodeAtNode(o), y.optional = n, this.raise(I.InvalidTupleMemberLabel, { at: o }), y.label = o, y.elementType = this.tsParseType()), o = this.finishNode(y, "TSNamedTupleMember");
                } else if (n) {
                  let y = this.startNodeAtNode(o);
                  y.typeAnnotation = o, o = this.finishNode(y, "TSOptionalType");
                }
                if (s) {
                  let y = this.startNodeAt(e);
                  y.typeAnnotation = o, o = this.finishNode(y, "TSRestType");
                }
                return o;
              }
              tsParseParenthesizedType() {
                let e = this.startNode();
                return this.expect(10), e.typeAnnotation = this.tsParseType(), this.expect(11), this.finishNode(e, "TSParenthesizedType");
              }
              tsParseFunctionOrConstructorType(e, s) {
                let i = this.startNode();
                return e === "TSConstructorType" && (i.abstract = !!s, s && this.next(), this.next()), this.tsInAllowConditionalTypesContext(() => this.tsFillSignature(19, i)), this.finishNode(i, e);
              }
              tsParseLiteralTypeNode() {
                let e = this.startNode();
                return e.literal = (() => {
                  switch (this.state.type) {
                    case 132:
                    case 133:
                    case 131:
                    case 85:
                    case 86:
                      return super.parseExprAtom();
                    default:
                      this.unexpected();
                  }
                })(), this.finishNode(e, "TSLiteralType");
              }
              tsParseTemplateLiteralType() {
                let e = this.startNode();
                return e.literal = super.parseTemplate(false), this.finishNode(e, "TSLiteralType");
              }
              parseTemplateSubstitution() {
                return this.state.inType ? this.tsParseType() : super.parseTemplateSubstitution();
              }
              tsParseThisTypeOrThisTypePredicate() {
                let e = this.tsParseThisTypeNode();
                return this.isContextual(114) && !this.hasPrecedingLineBreak() ? this.tsParseThisTypePredicate(e) : e;
              }
              tsParseNonArrayType() {
                switch (this.state.type) {
                  case 131:
                  case 132:
                  case 133:
                  case 85:
                  case 86:
                    return this.tsParseLiteralTypeNode();
                  case 53:
                    if (this.state.value === "-") {
                      let e = this.startNode(), s = this.lookahead();
                      return s.type !== 132 && s.type !== 133 && this.unexpected(), e.literal = this.parseMaybeUnary(), this.finishNode(e, "TSLiteralType");
                    }
                    break;
                  case 78:
                    return this.tsParseThisTypeOrThisTypePredicate();
                  case 87:
                    return this.tsParseTypeQuery();
                  case 83:
                    return this.tsParseImportType();
                  case 5:
                    return this.tsLookAhead(this.tsIsStartOfMappedType.bind(this)) ? this.tsParseMappedType() : this.tsParseTypeLiteral();
                  case 0:
                    return this.tsParseTupleType();
                  case 10:
                    return this.tsParseParenthesizedType();
                  case 25:
                  case 24:
                    return this.tsParseTemplateLiteralType();
                  default: {
                    let { type: e } = this.state;
                    if (q(e) || e === 88 || e === 84) {
                      let s = e === 88 ? "TSVoidKeyword" : e === 84 ? "TSNullKeyword" : lh(this.state.value);
                      if (s !== void 0 && this.lookaheadCharCode() !== 46) {
                        let i = this.startNode();
                        return this.next(), this.finishNode(i, s);
                      }
                      return this.tsParseTypeReference();
                    }
                  }
                }
                this.unexpected();
              }
              tsParseArrayTypeOrHigher() {
                let e = this.tsParseNonArrayType();
                for (; !this.hasPrecedingLineBreak() && this.eat(0); )
                  if (this.match(3)) {
                    let s = this.startNodeAtNode(e);
                    s.elementType = e, this.expect(3), e = this.finishNode(s, "TSArrayType");
                  } else {
                    let s = this.startNodeAtNode(e);
                    s.objectType = e, s.indexType = this.tsParseType(), this.expect(3), e = this.finishNode(s, "TSIndexedAccessType");
                  }
                return e;
              }
              tsParseTypeOperator() {
                let e = this.startNode(), s = this.state.value;
                return this.next(), e.operator = s, e.typeAnnotation = this.tsParseTypeOperatorOrHigher(), s === "readonly" && this.tsCheckTypeAnnotationForReadOnly(e), this.finishNode(e, "TSTypeOperator");
              }
              tsCheckTypeAnnotationForReadOnly(e) {
                switch (e.typeAnnotation.type) {
                  case "TSTupleType":
                  case "TSArrayType":
                    return;
                  default:
                    this.raise(I.UnexpectedReadonly, { at: e });
                }
              }
              tsParseInferType() {
                let e = this.startNode();
                this.expectContextual(113);
                let s = this.startNode();
                return s.name = this.tsParseTypeParameterName(), s.constraint = this.tsTryParse(() => this.tsParseConstraintForInferType()), e.typeParameter = this.finishNode(s, "TSTypeParameter"), this.finishNode(e, "TSInferType");
              }
              tsParseConstraintForInferType() {
                if (this.eat(81)) {
                  let e = this.tsInDisallowConditionalTypesContext(() => this.tsParseType());
                  if (this.state.inDisallowConditionalTypesContext || !this.match(17))
                    return e;
                }
              }
              tsParseTypeOperatorOrHigher() {
                return qo(this.state.type) && !this.state.containsEsc ? this.tsParseTypeOperator() : this.isContextual(113) ? this.tsParseInferType() : this.tsInAllowConditionalTypesContext(() => this.tsParseArrayTypeOrHigher());
              }
              tsParseUnionOrIntersectionType(e, s, i) {
                let a = this.startNode(), n = this.eat(i), o = [];
                do
                  o.push(s());
                while (this.eat(i));
                return o.length === 1 && !n ? o[0] : (a.types = o, this.finishNode(a, e));
              }
              tsParseIntersectionTypeOrHigher() {
                return this.tsParseUnionOrIntersectionType("TSIntersectionType", this.tsParseTypeOperatorOrHigher.bind(this), 45);
              }
              tsParseUnionTypeOrHigher() {
                return this.tsParseUnionOrIntersectionType("TSUnionType", this.tsParseIntersectionTypeOrHigher.bind(this), 43);
              }
              tsIsStartOfFunctionType() {
                return this.match(47) ? true : this.match(10) && this.tsLookAhead(this.tsIsUnambiguouslyStartOfFunctionType.bind(this));
              }
              tsSkipParameterStart() {
                if (q(this.state.type) || this.match(78))
                  return this.next(), true;
                if (this.match(5)) {
                  let { errors: e } = this.state, s = e.length;
                  try {
                    return this.parseObjectLike(8, true), e.length === s;
                  } catch {
                    return false;
                  }
                }
                if (this.match(0)) {
                  this.next();
                  let { errors: e } = this.state, s = e.length;
                  try {
                    return super.parseBindingList(3, 93, 1), e.length === s;
                  } catch {
                    return false;
                  }
                }
                return false;
              }
              tsIsUnambiguouslyStartOfFunctionType() {
                return this.next(), !!(this.match(11) || this.match(21) || this.tsSkipParameterStart() && (this.match(14) || this.match(12) || this.match(17) || this.match(29) || this.match(11) && (this.next(), this.match(19))));
              }
              tsParseTypeOrTypePredicateAnnotation(e) {
                return this.tsInType(() => {
                  let s = this.startNode();
                  this.expect(e);
                  let i = this.startNode(), a = !!this.tsTryParse(this.tsParseTypePredicateAsserts.bind(this));
                  if (a && this.match(78)) {
                    let u = this.tsParseThisTypeOrThisTypePredicate();
                    return u.type === "TSThisType" ? (i.parameterName = u, i.asserts = true, i.typeAnnotation = null, u = this.finishNode(i, "TSTypePredicate")) : (this.resetStartLocationFromNode(u, i), u.asserts = true), s.typeAnnotation = u, this.finishNode(s, "TSTypeAnnotation");
                  }
                  let n = this.tsIsIdentifier() && this.tsTryParse(this.tsParseTypePredicatePrefix.bind(this));
                  if (!n)
                    return a ? (i.parameterName = this.parseIdentifier(), i.asserts = a, i.typeAnnotation = null, s.typeAnnotation = this.finishNode(i, "TSTypePredicate"), this.finishNode(s, "TSTypeAnnotation")) : this.tsParseTypeAnnotation(false, s);
                  let o = this.tsParseTypeAnnotation(false);
                  return i.parameterName = n, i.typeAnnotation = o, i.asserts = a, s.typeAnnotation = this.finishNode(i, "TSTypePredicate"), this.finishNode(s, "TSTypeAnnotation");
                });
              }
              tsTryParseTypeOrTypePredicateAnnotation() {
                return this.match(14) ? this.tsParseTypeOrTypePredicateAnnotation(14) : void 0;
              }
              tsTryParseTypeAnnotation() {
                return this.match(14) ? this.tsParseTypeAnnotation() : void 0;
              }
              tsTryParseType() {
                return this.tsEatThenParseType(14);
              }
              tsParseTypePredicatePrefix() {
                let e = this.parseIdentifier();
                if (this.isContextual(114) && !this.hasPrecedingLineBreak())
                  return this.next(), e;
              }
              tsParseTypePredicateAsserts() {
                if (this.state.type !== 107)
                  return false;
                let e = this.state.containsEsc;
                return this.next(), !q(this.state.type) && !this.match(78) ? false : (e && this.raise(f.InvalidEscapedReservedWord, { at: this.state.lastTokStartLoc, reservedWord: "asserts" }), true);
              }
              tsParseTypeAnnotation() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.startNode();
                return this.tsInType(() => {
                  e && this.expect(14), s.typeAnnotation = this.tsParseType();
                }), this.finishNode(s, "TSTypeAnnotation");
              }
              tsParseType() {
                $r(this.state.inType);
                let e = this.tsParseNonConditionalType();
                if (this.state.inDisallowConditionalTypesContext || this.hasPrecedingLineBreak() || !this.eat(81))
                  return e;
                let s = this.startNodeAtNode(e);
                return s.checkType = e, s.extendsType = this.tsInDisallowConditionalTypesContext(() => this.tsParseNonConditionalType()), this.expect(17), s.trueType = this.tsInAllowConditionalTypesContext(() => this.tsParseType()), this.expect(14), s.falseType = this.tsInAllowConditionalTypesContext(() => this.tsParseType()), this.finishNode(s, "TSConditionalType");
              }
              isAbstractConstructorSignature() {
                return this.isContextual(122) && this.lookahead().type === 77;
              }
              tsParseNonConditionalType() {
                return this.tsIsStartOfFunctionType() ? this.tsParseFunctionOrConstructorType("TSFunctionType") : this.match(77) ? this.tsParseFunctionOrConstructorType("TSConstructorType") : this.isAbstractConstructorSignature() ? this.tsParseFunctionOrConstructorType("TSConstructorType", true) : this.tsParseUnionTypeOrHigher();
              }
              tsParseTypeAssertion() {
                this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(I.ReservedTypeAssertion, { at: this.state.startLoc });
                let e = this.startNode();
                return e.typeAnnotation = this.tsInType(() => (this.next(), this.match(75) ? this.tsParseTypeReference() : this.tsParseType())), this.expect(48), e.expression = this.parseMaybeUnary(), this.finishNode(e, "TSTypeAssertion");
              }
              tsParseHeritageClause(e) {
                let s = this.state.startLoc, i = this.tsParseDelimitedList("HeritageClauseElement", () => {
                  let a = this.startNode();
                  return a.expression = this.tsParseEntityName(), this.match(47) && (a.typeParameters = this.tsParseTypeArguments()), this.finishNode(a, "TSExpressionWithTypeArguments");
                });
                return i.length || this.raise(I.EmptyHeritageClauseType, { at: s, token: e }), i;
              }
              tsParseInterfaceDeclaration(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this.hasFollowingLineBreak())
                  return null;
                this.expectContextual(127), s.declare && (e.declare = true), q(this.state.type) ? (e.id = this.parseIdentifier(), this.checkIdentifier(e.id, pl)) : (e.id = null, this.raise(I.MissingInterfaceName, { at: this.state.startLoc })), e.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutConstModifiers), this.eat(81) && (e.extends = this.tsParseHeritageClause("extends"));
                let i = this.startNode();
                return i.body = this.tsInType(this.tsParseObjectTypeMembers.bind(this)), e.body = this.finishNode(i, "TSInterfaceBody"), this.finishNode(e, "TSInterfaceDeclaration");
              }
              tsParseTypeAliasDeclaration(e) {
                return e.id = this.parseIdentifier(), this.checkIdentifier(e.id, fl), e.typeAnnotation = this.tsInType(() => {
                  if (e.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers), this.expect(29), this.isContextual(112) && this.lookahead().type !== 16) {
                    let s = this.startNode();
                    return this.next(), this.finishNode(s, "TSIntrinsicKeyword");
                  }
                  return this.tsParseType();
                }), this.semicolon(), this.finishNode(e, "TSTypeAliasDeclaration");
              }
              tsInNoContext(e) {
                let s = this.state.context;
                this.state.context = [s[0]];
                try {
                  return e();
                } finally {
                  this.state.context = s;
                }
              }
              tsInType(e) {
                let s = this.state.inType;
                this.state.inType = true;
                try {
                  return e();
                } finally {
                  this.state.inType = s;
                }
              }
              tsInDisallowConditionalTypesContext(e) {
                let s = this.state.inDisallowConditionalTypesContext;
                this.state.inDisallowConditionalTypesContext = true;
                try {
                  return e();
                } finally {
                  this.state.inDisallowConditionalTypesContext = s;
                }
              }
              tsInAllowConditionalTypesContext(e) {
                let s = this.state.inDisallowConditionalTypesContext;
                this.state.inDisallowConditionalTypesContext = false;
                try {
                  return e();
                } finally {
                  this.state.inDisallowConditionalTypesContext = s;
                }
              }
              tsEatThenParseType(e) {
                return this.match(e) ? this.tsNextThenParseType() : void 0;
              }
              tsExpectThenParseType(e) {
                return this.tsDoThenParseType(() => this.expect(e));
              }
              tsNextThenParseType() {
                return this.tsDoThenParseType(() => this.next());
              }
              tsDoThenParseType(e) {
                return this.tsInType(() => (e(), this.tsParseType()));
              }
              tsParseEnumMember() {
                let e = this.startNode();
                return e.id = this.match(131) ? super.parseStringLiteral(this.state.value) : this.parseIdentifier(true), this.eat(29) && (e.initializer = super.parseMaybeAssignAllowIn()), this.finishNode(e, "TSEnumMember");
              }
              tsParseEnumDeclaration(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return s.const && (e.const = true), s.declare && (e.declare = true), this.expectContextual(124), e.id = this.parseIdentifier(), this.checkIdentifier(e.id, e.const ? ml : Cr), this.expect(5), e.members = this.tsParseDelimitedList("EnumMembers", this.tsParseEnumMember.bind(this)), this.expect(8), this.finishNode(e, "TSEnumDeclaration");
              }
              tsParseModuleBlock() {
                let e = this.startNode();
                return this.scope.enter(Fe), this.expect(5), super.parseBlockOrModuleBlockBody(e.body = [], void 0, true, 8), this.scope.exit(), this.finishNode(e, "TSModuleBlock");
              }
              tsParseModuleOrNamespaceDeclaration(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (e.id = this.parseIdentifier(), s || this.checkIdentifier(e.id, yl), this.eat(16)) {
                  let i = this.startNode();
                  this.tsParseModuleOrNamespaceDeclaration(i, true), e.body = i;
                } else
                  this.scope.enter(Oe), this.prodParam.enter(Me), e.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit();
                return this.finishNode(e, "TSModuleDeclaration");
              }
              tsParseAmbientExternalModuleDeclaration(e) {
                return this.isContextual(110) ? (e.global = true, e.id = this.parseIdentifier()) : this.match(131) ? e.id = super.parseStringLiteral(this.state.value) : this.unexpected(), this.match(5) ? (this.scope.enter(Oe), this.prodParam.enter(Me), e.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit()) : this.semicolon(), this.finishNode(e, "TSModuleDeclaration");
              }
              tsParseImportEqualsDeclaration(e, s) {
                e.isExport = s || false, e.id = this.parseIdentifier(), this.checkIdentifier(e.id, Ve), this.expect(29);
                let i = this.tsParseModuleReference();
                return e.importKind === "type" && i.type !== "TSExternalModuleReference" && this.raise(I.ImportAliasHasImportType, { at: i }), e.moduleReference = i, this.semicolon(), this.finishNode(e, "TSImportEqualsDeclaration");
              }
              tsIsExternalModuleReference() {
                return this.isContextual(117) && this.lookaheadCharCode() === 40;
              }
              tsParseModuleReference() {
                return this.tsIsExternalModuleReference() ? this.tsParseExternalModuleReference() : this.tsParseEntityName(false);
              }
              tsParseExternalModuleReference() {
                let e = this.startNode();
                return this.expectContextual(117), this.expect(10), this.match(131) || this.unexpected(), e.expression = super.parseExprAtom(), this.expect(11), this.finishNode(e, "TSExternalModuleReference");
              }
              tsLookAhead(e) {
                let s = this.state.clone(), i = e();
                return this.state = s, i;
              }
              tsTryParseAndCatch(e) {
                let s = this.tryParse((i) => e() || i());
                if (!(s.aborted || !s.node))
                  return s.error && (this.state = s.failState), s.node;
              }
              tsTryParse(e) {
                let s = this.state.clone(), i = e();
                if (i !== void 0 && i !== false)
                  return i;
                this.state = s;
              }
              tsTryParseDeclare(e) {
                if (this.isLineTerminator())
                  return;
                let s = this.state.type, i;
                return this.isContextual(99) && (s = 74, i = "let"), this.tsInAmbientContext(() => {
                  if (s === 68)
                    return e.declare = true, super.parseFunctionStatement(e, false, false);
                  if (s === 80)
                    return e.declare = true, this.parseClass(e, true, false);
                  if (s === 124)
                    return this.tsParseEnumDeclaration(e, { declare: true });
                  if (s === 110)
                    return this.tsParseAmbientExternalModuleDeclaration(e);
                  if (s === 75 || s === 74)
                    return !this.match(75) || !this.isLookaheadContextual("enum") ? (e.declare = true, this.parseVarStatement(e, i || this.state.value, true)) : (this.expect(75), this.tsParseEnumDeclaration(e, { const: true, declare: true }));
                  if (s === 127) {
                    let a = this.tsParseInterfaceDeclaration(e, { declare: true });
                    if (a)
                      return a;
                  }
                  if (q(s))
                    return this.tsParseDeclaration(e, this.state.value, true, null);
                });
              }
              tsTryParseExportDeclaration() {
                return this.tsParseDeclaration(this.startNode(), this.state.value, true, null);
              }
              tsParseExpressionStatement(e, s, i) {
                switch (s.name) {
                  case "declare": {
                    let a = this.tsTryParseDeclare(e);
                    if (a)
                      return a.declare = true, a;
                    break;
                  }
                  case "global":
                    if (this.match(5)) {
                      this.scope.enter(Oe), this.prodParam.enter(Me);
                      let a = e;
                      return a.global = true, a.id = s, a.body = this.tsParseModuleBlock(), this.scope.exit(), this.prodParam.exit(), this.finishNode(a, "TSModuleDeclaration");
                    }
                    break;
                  default:
                    return this.tsParseDeclaration(e, s.name, false, i);
                }
              }
              tsParseDeclaration(e, s, i, a) {
                switch (s) {
                  case "abstract":
                    if (this.tsCheckLineTerminator(i) && (this.match(80) || q(this.state.type)))
                      return this.tsParseAbstractDeclaration(e, a);
                    break;
                  case "module":
                    if (this.tsCheckLineTerminator(i)) {
                      if (this.match(131))
                        return this.tsParseAmbientExternalModuleDeclaration(e);
                      if (q(this.state.type))
                        return this.tsParseModuleOrNamespaceDeclaration(e);
                    }
                    break;
                  case "namespace":
                    if (this.tsCheckLineTerminator(i) && q(this.state.type))
                      return this.tsParseModuleOrNamespaceDeclaration(e);
                    break;
                  case "type":
                    if (this.tsCheckLineTerminator(i) && q(this.state.type))
                      return this.tsParseTypeAliasDeclaration(e);
                    break;
                }
              }
              tsCheckLineTerminator(e) {
                return e ? this.hasFollowingLineBreak() ? false : (this.next(), true) : !this.isLineTerminator();
              }
              tsTryParseGenericAsyncArrowFunction(e) {
                if (!this.match(47))
                  return;
                let s = this.state.maybeInArrowParameters;
                this.state.maybeInArrowParameters = true;
                let i = this.tsTryParseAndCatch(() => {
                  let a = this.startNodeAt(e);
                  return a.typeParameters = this.tsParseTypeParameters(this.tsParseConstModifier), super.parseFunctionParams(a), a.returnType = this.tsTryParseTypeOrTypePredicateAnnotation(), this.expect(19), a;
                });
                if (this.state.maybeInArrowParameters = s, !!i)
                  return super.parseArrowExpression(i, null, true);
              }
              tsParseTypeArgumentsInExpression() {
                if (this.reScan_lt() === 47)
                  return this.tsParseTypeArguments();
              }
              tsParseTypeArguments() {
                let e = this.startNode();
                return e.params = this.tsInType(() => this.tsInNoContext(() => (this.expect(47), this.tsParseDelimitedList("TypeParametersOrArguments", this.tsParseType.bind(this))))), e.params.length === 0 && this.raise(I.EmptyTypeArguments, { at: e }), this.expect(48), this.finishNode(e, "TSTypeParameterInstantiation");
              }
              tsIsDeclarationStart() {
                return Uo(this.state.type);
              }
              isExportDefaultSpecifier() {
                return this.tsIsDeclarationStart() ? false : super.isExportDefaultSpecifier();
              }
              parseAssignableListItem(e, s) {
                let i = this.state.startLoc, a = {};
                this.tsParseModifiers({ allowedModifiers: ["public", "private", "protected", "override", "readonly"] }, a);
                let n = a.accessibility, o = a.override, u = a.readonly;
                !(e & 4) && (n || u || o) && this.raise(I.UnexpectedParameterModifier, { at: i });
                let c = this.parseMaybeDefault();
                this.parseAssignableListItemTypes(c, e);
                let y = this.parseMaybeDefault(c.loc.start, c);
                if (n || u || o) {
                  let g = this.startNodeAt(i);
                  return s.length && (g.decorators = s), n && (g.accessibility = n), u && (g.readonly = u), o && (g.override = o), y.type !== "Identifier" && y.type !== "AssignmentPattern" && this.raise(I.UnsupportedParameterPropertyKind, { at: g }), g.parameter = y, this.finishNode(g, "TSParameterProperty");
                }
                return s.length && (c.decorators = s), y;
              }
              isSimpleParameter(e) {
                return e.type === "TSParameterProperty" && super.isSimpleParameter(e.parameter) || super.isSimpleParameter(e);
              }
              tsDisallowOptionalPattern(e) {
                for (let s of e.params)
                  s.type !== "Identifier" && s.optional && !this.state.isAmbientContext && this.raise(I.PatternIsOptional, { at: s });
              }
              setArrowFunctionParameters(e, s, i) {
                super.setArrowFunctionParameters(e, s, i), this.tsDisallowOptionalPattern(e);
              }
              parseFunctionBodyAndFinish(e, s) {
                let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                this.match(14) && (e.returnType = this.tsParseTypeOrTypePredicateAnnotation(14));
                let a = s === "FunctionDeclaration" ? "TSDeclareFunction" : s === "ClassMethod" || s === "ClassPrivateMethod" ? "TSDeclareMethod" : void 0;
                return a && !this.match(5) && this.isLineTerminator() ? this.finishNode(e, a) : a === "TSDeclareFunction" && this.state.isAmbientContext && (this.raise(I.DeclareFunctionHasImplementation, { at: e }), e.declare) ? super.parseFunctionBodyAndFinish(e, a, i) : (this.tsDisallowOptionalPattern(e), super.parseFunctionBodyAndFinish(e, s, i));
              }
              registerFunctionStatementId(e) {
                !e.body && e.id ? this.checkIdentifier(e.id, br) : super.registerFunctionStatementId(e);
              }
              tsCheckForInvalidTypeCasts(e) {
                e.forEach((s) => {
                  (s == null ? void 0 : s.type) === "TSTypeCastExpression" && this.raise(I.UnexpectedTypeAnnotation, { at: s.typeAnnotation });
                });
              }
              toReferencedList(e, s) {
                return this.tsCheckForInvalidTypeCasts(e), e;
              }
              parseArrayLike(e, s, i, a) {
                let n = super.parseArrayLike(e, s, i, a);
                return n.type === "ArrayExpression" && this.tsCheckForInvalidTypeCasts(n.elements), n;
              }
              parseSubscript(e, s, i, a) {
                if (!this.hasPrecedingLineBreak() && this.match(35)) {
                  this.state.canStartJSXElement = false, this.next();
                  let o = this.startNodeAt(s);
                  return o.expression = e, this.finishNode(o, "TSNonNullExpression");
                }
                let n = false;
                if (this.match(18) && this.lookaheadCharCode() === 60) {
                  if (i)
                    return a.stop = true, e;
                  a.optionalChainMember = n = true, this.next();
                }
                if (this.match(47) || this.match(51)) {
                  let o, u = this.tsTryParseAndCatch(() => {
                    if (!i && this.atPossibleAsyncArrow(e)) {
                      let T = this.tsTryParseGenericAsyncArrowFunction(s);
                      if (T)
                        return T;
                    }
                    let c = this.tsParseTypeArgumentsInExpression();
                    if (!c)
                      return;
                    if (n && !this.match(10)) {
                      o = this.state.curPosition();
                      return;
                    }
                    if (nt(this.state.type)) {
                      let T = super.parseTaggedTemplateExpression(e, s, a);
                      return T.typeParameters = c, T;
                    }
                    if (!i && this.eat(10)) {
                      let T = this.startNodeAt(s);
                      return T.callee = e, T.arguments = this.parseCallExpressionArguments(11, false), this.tsCheckForInvalidTypeCasts(T.arguments), T.typeParameters = c, a.optionalChainMember && (T.optional = n), this.finishCallExpression(T, a.optionalChainMember);
                    }
                    let y = this.state.type;
                    if (y === 48 || y === 52 || y !== 10 && He(y) && !this.hasPrecedingLineBreak())
                      return;
                    let g = this.startNodeAt(s);
                    return g.expression = e, g.typeParameters = c, this.finishNode(g, "TSInstantiationExpression");
                  });
                  if (o && this.unexpected(o, 10), u)
                    return u.type === "TSInstantiationExpression" && (this.match(16) || this.match(18) && this.lookaheadCharCode() !== 40) && this.raise(I.InvalidPropertyAccessAfterInstantiationExpression, { at: this.state.startLoc }), u;
                }
                return super.parseSubscript(e, s, i, a);
              }
              parseNewCallee(e) {
                var s;
                super.parseNewCallee(e);
                let { callee: i } = e;
                i.type === "TSInstantiationExpression" && !((s = i.extra) != null && s.parenthesized) && (e.typeParameters = i.typeParameters, e.callee = i.expression);
              }
              parseExprOp(e, s, i) {
                let a;
                if (at2(58) > i && !this.hasPrecedingLineBreak() && (this.isContextual(93) || (a = this.isContextual(118)))) {
                  let n = this.startNodeAt(s);
                  return n.expression = e, n.typeAnnotation = this.tsInType(() => (this.next(), this.match(75) ? (a && this.raise(f.UnexpectedKeyword, { at: this.state.startLoc, keyword: "const" }), this.tsParseTypeReference()) : this.tsParseType())), this.finishNode(n, a ? "TSSatisfiesExpression" : "TSAsExpression"), this.reScan_lt_gt(), this.parseExprOp(n, s, i);
                }
                return super.parseExprOp(e, s, i);
              }
              checkReservedWord(e, s, i, a) {
                this.state.isAmbientContext || super.checkReservedWord(e, s, i, a);
              }
              checkImportReflection(e) {
                super.checkImportReflection(e), e.module && e.importKind !== "value" && this.raise(I.ImportReflectionHasImportType, { at: e.specifiers[0].loc.start });
              }
              checkDuplicateExports() {
              }
              parseImport(e) {
                if (e.importKind = "value", q(this.state.type) || this.match(55) || this.match(5)) {
                  let i = this.lookahead();
                  if (this.isContextual(128) && i.type !== 12 && i.type !== 97 && i.type !== 29 && (e.importKind = "type", this.next(), i = this.lookahead()), q(this.state.type) && i.type === 29)
                    return this.tsParseImportEqualsDeclaration(e);
                }
                let s = super.parseImport(e);
                return s.importKind === "type" && s.specifiers.length > 1 && s.specifiers[0].type === "ImportDefaultSpecifier" && this.raise(I.TypeImportCannotSpecifyDefaultAndNamed, { at: s }), s;
              }
              parseExport(e, s) {
                if (this.match(83))
                  return this.next(), this.isContextual(128) && this.lookaheadCharCode() !== 61 ? (e.importKind = "type", this.next()) : e.importKind = "value", this.tsParseImportEqualsDeclaration(e, true);
                if (this.eat(29)) {
                  let i = e;
                  return i.expression = super.parseExpression(), this.semicolon(), this.finishNode(i, "TSExportAssignment");
                } else if (this.eatContextual(93)) {
                  let i = e;
                  return this.expectContextual(126), i.id = this.parseIdentifier(), this.semicolon(), this.finishNode(i, "TSNamespaceExportDeclaration");
                } else {
                  if (e.exportKind = "value", this.isContextual(128)) {
                    let i = this.lookaheadCharCode();
                    (i === 123 || i === 42) && (this.next(), e.exportKind = "type");
                  }
                  return super.parseExport(e, s);
                }
              }
              isAbstractClass() {
                return this.isContextual(122) && this.lookahead().type === 80;
              }
              parseExportDefaultExpression() {
                if (this.isAbstractClass()) {
                  let e = this.startNode();
                  return this.next(), e.abstract = true, this.parseClass(e, true, true);
                }
                if (this.match(127)) {
                  let e = this.tsParseInterfaceDeclaration(this.startNode());
                  if (e)
                    return e;
                }
                return super.parseExportDefaultExpression();
              }
              parseVarStatement(e, s) {
                let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, { isAmbientContext: a } = this.state, n = super.parseVarStatement(e, s, i || a);
                if (!a)
                  return n;
                for (let { id: o, init: u } of n.declarations)
                  u && (s !== "const" || o.typeAnnotation ? this.raise(I.InitializerNotAllowedInAmbientContext, { at: u }) : ph(u, this.hasPlugin("estree")) || this.raise(I.ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference, { at: u }));
                return n;
              }
              parseStatementContent(e, s) {
                if (this.match(75) && this.isLookaheadContextual("enum")) {
                  let i = this.startNode();
                  return this.expect(75), this.tsParseEnumDeclaration(i, { const: true });
                }
                if (this.isContextual(124))
                  return this.tsParseEnumDeclaration(this.startNode());
                if (this.isContextual(127)) {
                  let i = this.tsParseInterfaceDeclaration(this.startNode());
                  if (i)
                    return i;
                }
                return super.parseStatementContent(e, s);
              }
              parseAccessModifier() {
                return this.tsParseModifier(["public", "protected", "private"]);
              }
              tsHasSomeModifiers(e, s) {
                return s.some((i) => Hr(i) ? e.accessibility === i : !!e[i]);
              }
              tsIsStartOfStaticBlocks() {
                return this.isContextual(104) && this.lookaheadCharCode() === 123;
              }
              parseClassMember(e, s, i) {
                let a = ["declare", "private", "public", "protected", "override", "abstract", "readonly", "static"];
                this.tsParseModifiers({ allowedModifiers: a, disallowedModifiers: ["in", "out"], stopOnStartOfClassStaticBlock: true, errorTemplate: I.InvalidModifierOnTypeParameterPositions }, s);
                let n = () => {
                  this.tsIsStartOfStaticBlocks() ? (this.next(), this.next(), this.tsHasSomeModifiers(s, a) && this.raise(I.StaticBlockCannotHaveModifier, { at: this.state.curPosition() }), super.parseClassStaticBlock(e, s)) : this.parseClassMemberWithIsStatic(e, s, i, !!s.static);
                };
                s.declare ? this.tsInAmbientContext(n) : n();
              }
              parseClassMemberWithIsStatic(e, s, i, a) {
                let n = this.tsTryParseIndexSignature(s);
                if (n) {
                  e.body.push(n), s.abstract && this.raise(I.IndexSignatureHasAbstract, { at: s }), s.accessibility && this.raise(I.IndexSignatureHasAccessibility, { at: s, modifier: s.accessibility }), s.declare && this.raise(I.IndexSignatureHasDeclare, { at: s }), s.override && this.raise(I.IndexSignatureHasOverride, { at: s });
                  return;
                }
                !this.state.inAbstractClass && s.abstract && this.raise(I.NonAbstractClassHasAbstractMethod, { at: s }), s.override && (i.hadSuperClass || this.raise(I.OverrideNotInSubClass, { at: s })), super.parseClassMemberWithIsStatic(e, s, i, a);
              }
              parsePostMemberNameModifiers(e) {
                this.eat(17) && (e.optional = true), e.readonly && this.match(10) && this.raise(I.ClassMethodHasReadonly, { at: e }), e.declare && this.match(10) && this.raise(I.ClassMethodHasDeclare, { at: e });
              }
              parseExpressionStatement(e, s, i) {
                return (s.type === "Identifier" ? this.tsParseExpressionStatement(e, s, i) : void 0) || super.parseExpressionStatement(e, s, i);
              }
              shouldParseExportDeclaration() {
                return this.tsIsDeclarationStart() ? true : super.shouldParseExportDeclaration();
              }
              parseConditional(e, s, i) {
                if (!this.state.maybeInArrowParameters || !this.match(17))
                  return super.parseConditional(e, s, i);
                let a = this.tryParse(() => super.parseConditional(e, s));
                return a.node ? (a.error && (this.state = a.failState), a.node) : (a.error && super.setOptionalParametersError(i, a.error), e);
              }
              parseParenItem(e, s) {
                if (e = super.parseParenItem(e, s), this.eat(17) && (e.optional = true, this.resetEndLocation(e)), this.match(14)) {
                  let i = this.startNodeAt(s);
                  return i.expression = e, i.typeAnnotation = this.tsParseTypeAnnotation(), this.finishNode(i, "TSTypeCastExpression");
                }
                return e;
              }
              parseExportDeclaration(e) {
                if (!this.state.isAmbientContext && this.isContextual(123))
                  return this.tsInAmbientContext(() => this.parseExportDeclaration(e));
                let s = this.state.startLoc, i = this.eatContextual(123);
                if (i && (this.isContextual(123) || !this.shouldParseExportDeclaration()))
                  throw this.raise(I.ExpectedAmbientAfterExportDeclare, { at: this.state.startLoc });
                let n = q(this.state.type) && this.tsTryParseExportDeclaration() || super.parseExportDeclaration(e);
                return n ? ((n.type === "TSInterfaceDeclaration" || n.type === "TSTypeAliasDeclaration" || i) && (e.exportKind = "type"), i && (this.resetStartLocation(n, s), n.declare = true), n) : null;
              }
              parseClassId(e, s, i, a) {
                if ((!s || i) && this.isContextual(111))
                  return;
                super.parseClassId(e, s, i, e.declare ? br : vr);
                let n = this.tsTryParseTypeParameters(this.tsParseInOutConstModifiers);
                n && (e.typeParameters = n);
              }
              parseClassPropertyAnnotation(e) {
                e.optional || (this.eat(35) ? e.definite = true : this.eat(17) && (e.optional = true));
                let s = this.tsTryParseTypeAnnotation();
                s && (e.typeAnnotation = s);
              }
              parseClassProperty(e) {
                if (this.parseClassPropertyAnnotation(e), this.state.isAmbientContext && !(e.readonly && !e.typeAnnotation) && this.match(29) && this.raise(I.DeclareClassFieldHasInitializer, { at: this.state.startLoc }), e.abstract && this.match(29)) {
                  let { key: s } = e;
                  this.raise(I.AbstractPropertyHasInitializer, { at: this.state.startLoc, propertyName: s.type === "Identifier" && !e.computed ? s.name : `[${this.input.slice(s.start, s.end)}]` });
                }
                return super.parseClassProperty(e);
              }
              parseClassPrivateProperty(e) {
                return e.abstract && this.raise(I.PrivateElementHasAbstract, { at: e }), e.accessibility && this.raise(I.PrivateElementHasAccessibility, { at: e, modifier: e.accessibility }), this.parseClassPropertyAnnotation(e), super.parseClassPrivateProperty(e);
              }
              parseClassAccessorProperty(e) {
                return this.parseClassPropertyAnnotation(e), e.optional && this.raise(I.AccessorCannotBeOptional, { at: e }), super.parseClassAccessorProperty(e);
              }
              pushClassMethod(e, s, i, a, n, o) {
                let u = this.tsTryParseTypeParameters(this.tsParseConstModifier);
                u && n && this.raise(I.ConstructorHasTypeParameters, { at: u });
                let { declare: c = false, kind: y } = s;
                c && (y === "get" || y === "set") && this.raise(I.DeclareAccessor, { at: s, kind: y }), u && (s.typeParameters = u), super.pushClassMethod(e, s, i, a, n, o);
              }
              pushClassPrivateMethod(e, s, i, a) {
                let n = this.tsTryParseTypeParameters(this.tsParseConstModifier);
                n && (s.typeParameters = n), super.pushClassPrivateMethod(e, s, i, a);
              }
              declareClassPrivateMethodInScope(e, s) {
                e.type !== "TSDeclareMethod" && (e.type === "MethodDefinition" && !e.value.body || super.declareClassPrivateMethodInScope(e, s));
              }
              parseClassSuper(e) {
                super.parseClassSuper(e), e.superClass && (this.match(47) || this.match(51)) && (e.superTypeParameters = this.tsParseTypeArgumentsInExpression()), this.eatContextual(111) && (e.implements = this.tsParseHeritageClause("implements"));
              }
              parseObjPropValue(e, s, i, a, n, o, u) {
                let c = this.tsTryParseTypeParameters(this.tsParseConstModifier);
                return c && (e.typeParameters = c), super.parseObjPropValue(e, s, i, a, n, o, u);
              }
              parseFunctionParams(e, s) {
                let i = this.tsTryParseTypeParameters(this.tsParseConstModifier);
                i && (e.typeParameters = i), super.parseFunctionParams(e, s);
              }
              parseVarId(e, s) {
                super.parseVarId(e, s), e.id.type === "Identifier" && !this.hasPrecedingLineBreak() && this.eat(35) && (e.definite = true);
                let i = this.tsTryParseTypeAnnotation();
                i && (e.id.typeAnnotation = i, this.resetEndLocation(e.id));
              }
              parseAsyncArrowFromCallExpression(e, s) {
                return this.match(14) && (e.returnType = this.tsParseTypeAnnotation()), super.parseAsyncArrowFromCallExpression(e, s);
              }
              parseMaybeAssign(e, s) {
                var i, a, n, o, u, c, y;
                let g, T, C;
                if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
                  if (g = this.state.clone(), T = this.tryParse(() => super.parseMaybeAssign(e, s), g), !T.error)
                    return T.node;
                  let { context: K } = this.state, W = K[K.length - 1];
                  (W === x.j_oTag || W === x.j_expr) && K.pop();
                }
                if (!((i = T) != null && i.error) && !this.match(47))
                  return super.parseMaybeAssign(e, s);
                (!g || g === this.state) && (g = this.state.clone());
                let M, j = this.tryParse((K) => {
                  var W, V;
                  M = this.tsParseTypeParameters(this.tsParseConstModifier);
                  let X = super.parseMaybeAssign(e, s);
                  return (X.type !== "ArrowFunctionExpression" || (W = X.extra) != null && W.parenthesized) && K(), ((V = M) == null ? void 0 : V.params.length) !== 0 && this.resetStartLocationFromNode(X, M), X.typeParameters = M, X;
                }, g);
                if (!j.error && !j.aborted)
                  return M && this.reportReservedArrowTypeParam(M), j.node;
                if (!T && ($r(!this.hasPlugin("jsx")), C = this.tryParse(() => super.parseMaybeAssign(e, s), g), !C.error))
                  return C.node;
                if ((a = T) != null && a.node)
                  return this.state = T.failState, T.node;
                if (j.node)
                  return this.state = j.failState, M && this.reportReservedArrowTypeParam(M), j.node;
                if ((n = C) != null && n.node)
                  return this.state = C.failState, C.node;
                throw (o = T) != null && o.thrown ? T.error : j.thrown ? j.error : (u = C) != null && u.thrown ? C.error : ((c = T) == null ? void 0 : c.error) || j.error || ((y = C) == null ? void 0 : y.error);
              }
              reportReservedArrowTypeParam(e) {
                var s;
                e.params.length === 1 && !e.params[0].constraint && !((s = e.extra) != null && s.trailingComma) && this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(I.ReservedArrowTypeParam, { at: e });
              }
              parseMaybeUnary(e, s) {
                return !this.hasPlugin("jsx") && this.match(47) ? this.tsParseTypeAssertion() : super.parseMaybeUnary(e, s);
              }
              parseArrow(e) {
                if (this.match(14)) {
                  let s = this.tryParse((i) => {
                    let a = this.tsParseTypeOrTypePredicateAnnotation(14);
                    return (this.canInsertSemicolon() || !this.match(19)) && i(), a;
                  });
                  if (s.aborted)
                    return;
                  s.thrown || (s.error && (this.state = s.failState), e.returnType = s.node);
                }
                return super.parseArrow(e);
              }
              parseAssignableListItemTypes(e, s) {
                if (!(s & 2))
                  return e;
                this.eat(17) && (e.optional = true);
                let i = this.tsTryParseTypeAnnotation();
                return i && (e.typeAnnotation = i), this.resetEndLocation(e), e;
              }
              isAssignable(e, s) {
                switch (e.type) {
                  case "TSTypeCastExpression":
                    return this.isAssignable(e.expression, s);
                  case "TSParameterProperty":
                    return true;
                  default:
                    return super.isAssignable(e, s);
                }
              }
              toAssignable(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                switch (e.type) {
                  case "ParenthesizedExpression":
                    this.toAssignableParenthesizedExpression(e, s);
                    break;
                  case "TSAsExpression":
                  case "TSSatisfiesExpression":
                  case "TSNonNullExpression":
                  case "TSTypeAssertion":
                    s ? this.expressionScope.recordArrowParameterBindingError(I.UnexpectedTypeCastInParameter, { at: e }) : this.raise(I.UnexpectedTypeCastInParameter, { at: e }), this.toAssignable(e.expression, s);
                    break;
                  case "AssignmentExpression":
                    !s && e.left.type === "TSTypeCastExpression" && (e.left = this.typeCastToParameter(e.left));
                  default:
                    super.toAssignable(e, s);
                }
              }
              toAssignableParenthesizedExpression(e, s) {
                switch (e.expression.type) {
                  case "TSAsExpression":
                  case "TSSatisfiesExpression":
                  case "TSNonNullExpression":
                  case "TSTypeAssertion":
                  case "ParenthesizedExpression":
                    this.toAssignable(e.expression, s);
                    break;
                  default:
                    super.toAssignable(e, s);
                }
              }
              checkToRestConversion(e, s) {
                switch (e.type) {
                  case "TSAsExpression":
                  case "TSSatisfiesExpression":
                  case "TSTypeAssertion":
                  case "TSNonNullExpression":
                    this.checkToRestConversion(e.expression, false);
                    break;
                  default:
                    super.checkToRestConversion(e, s);
                }
              }
              isValidLVal(e, s, i) {
                return nh({ TSTypeCastExpression: true, TSParameterProperty: "parameter", TSNonNullExpression: "expression", TSAsExpression: (i !== Pe || !s) && ["expression", true], TSSatisfiesExpression: (i !== Pe || !s) && ["expression", true], TSTypeAssertion: (i !== Pe || !s) && ["expression", true] }, e) || super.isValidLVal(e, s, i);
              }
              parseBindingAtom() {
                switch (this.state.type) {
                  case 78:
                    return this.parseIdentifier(true);
                  default:
                    return super.parseBindingAtom();
                }
              }
              parseMaybeDecoratorArguments(e) {
                if (this.match(47) || this.match(51)) {
                  let s = this.tsParseTypeArgumentsInExpression();
                  if (this.match(10)) {
                    let i = super.parseMaybeDecoratorArguments(e);
                    return i.typeParameters = s, i;
                  }
                  this.unexpected(null, 10);
                }
                return super.parseMaybeDecoratorArguments(e);
              }
              checkCommaAfterRest(e) {
                return this.state.isAmbientContext && this.match(12) && this.lookaheadCharCode() === e ? (this.next(), false) : super.checkCommaAfterRest(e);
              }
              isClassMethod() {
                return this.match(47) || super.isClassMethod();
              }
              isClassProperty() {
                return this.match(35) || this.match(14) || super.isClassProperty();
              }
              parseMaybeDefault(e, s) {
                let i = super.parseMaybeDefault(e, s);
                return i.type === "AssignmentPattern" && i.typeAnnotation && i.right.start < i.typeAnnotation.start && this.raise(I.TypeAnnotationAfterAssign, { at: i.typeAnnotation }), i;
              }
              getTokenFromCode(e) {
                if (this.state.inType) {
                  if (e === 62) {
                    this.finishOp(48, 1);
                    return;
                  }
                  if (e === 60) {
                    this.finishOp(47, 1);
                    return;
                  }
                }
                super.getTokenFromCode(e);
              }
              reScan_lt_gt() {
                let { type: e } = this.state;
                e === 47 ? (this.state.pos -= 1, this.readToken_lt()) : e === 48 && (this.state.pos -= 1, this.readToken_gt());
              }
              reScan_lt() {
                let { type: e } = this.state;
                return e === 51 ? (this.state.pos -= 2, this.finishOp(47, 1), 47) : e;
              }
              toAssignableList(e, s, i) {
                for (let a = 0; a < e.length; a++) {
                  let n = e[a];
                  (n == null ? void 0 : n.type) === "TSTypeCastExpression" && (e[a] = this.typeCastToParameter(n));
                }
                super.toAssignableList(e, s, i);
              }
              typeCastToParameter(e) {
                return e.expression.typeAnnotation = e.typeAnnotation, this.resetEndLocation(e.expression, e.typeAnnotation.loc.end), e.expression;
              }
              shouldParseArrow(e) {
                return this.match(14) ? e.every((s) => this.isAssignable(s, true)) : super.shouldParseArrow(e);
              }
              shouldParseAsyncArrow() {
                return this.match(14) || super.shouldParseAsyncArrow();
              }
              canHaveLeadingDecorator() {
                return super.canHaveLeadingDecorator() || this.isAbstractClass();
              }
              jsxParseOpeningElementAfterName(e) {
                if (this.match(47) || this.match(51)) {
                  let s = this.tsTryParseAndCatch(() => this.tsParseTypeArgumentsInExpression());
                  s && (e.typeParameters = s);
                }
                return super.jsxParseOpeningElementAfterName(e);
              }
              getGetterSetterExpectedParamCount(e) {
                let s = super.getGetterSetterExpectedParamCount(e), a = this.getObjectOrClassMethodParams(e)[0];
                return a && this.isThisParam(a) ? s + 1 : s;
              }
              parseCatchClauseParam() {
                let e = super.parseCatchClauseParam(), s = this.tsTryParseTypeAnnotation();
                return s && (e.typeAnnotation = s, this.resetEndLocation(e)), e;
              }
              tsInAmbientContext(e) {
                let s = this.state.isAmbientContext;
                this.state.isAmbientContext = true;
                try {
                  return e();
                } finally {
                  this.state.isAmbientContext = s;
                }
              }
              parseClass(e, s, i) {
                let a = this.state.inAbstractClass;
                this.state.inAbstractClass = !!e.abstract;
                try {
                  return super.parseClass(e, s, i);
                } finally {
                  this.state.inAbstractClass = a;
                }
              }
              tsParseAbstractDeclaration(e, s) {
                if (this.match(80))
                  return e.abstract = true, this.maybeTakeDecorators(s, this.parseClass(e, true, false));
                if (this.isContextual(127)) {
                  if (!this.hasFollowingLineBreak())
                    return e.abstract = true, this.raise(I.NonClassMethodPropertyHasAbstractModifer, { at: e }), this.tsParseInterfaceDeclaration(e);
                } else
                  this.unexpected(null, 80);
              }
              parseMethod(e, s, i, a, n, o, u) {
                let c = super.parseMethod(e, s, i, a, n, o, u);
                if (c.abstract && (this.hasPlugin("estree") ? !!c.value.body : !!c.body)) {
                  let { key: g } = c;
                  this.raise(I.AbstractMethodHasImplementation, { at: c, methodName: g.type === "Identifier" && !c.computed ? g.name : `[${this.input.slice(g.start, g.end)}]` });
                }
                return c;
              }
              tsParseTypeParameterName() {
                return this.parseIdentifier().name;
              }
              shouldParseAsAmbientContext() {
                return !!this.getPluginOption("typescript", "dts");
              }
              parse() {
                return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = true), super.parse();
              }
              getExpression() {
                return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = true), super.getExpression();
              }
              parseExportSpecifier(e, s, i, a) {
                return !s && a ? (this.parseTypeOnlyImportExportSpecifier(e, false, i), this.finishNode(e, "ExportSpecifier")) : (e.exportKind = "value", super.parseExportSpecifier(e, s, i, a));
              }
              parseImportSpecifier(e, s, i, a, n) {
                return !s && a ? (this.parseTypeOnlyImportExportSpecifier(e, true, i), this.finishNode(e, "ImportSpecifier")) : (e.importKind = "value", super.parseImportSpecifier(e, s, i, a, i ? Sr : Ve));
              }
              parseTypeOnlyImportExportSpecifier(e, s, i) {
                let a = s ? "imported" : "local", n = s ? "local" : "exported", o = e[a], u, c = false, y = true, g = o.loc.start;
                if (this.isContextual(93)) {
                  let C = this.parseIdentifier();
                  if (this.isContextual(93)) {
                    let M = this.parseIdentifier();
                    te(this.state.type) ? (c = true, o = C, u = s ? this.parseIdentifier() : this.parseModuleExportName(), y = false) : (u = M, y = false);
                  } else
                    te(this.state.type) ? (y = false, u = s ? this.parseIdentifier() : this.parseModuleExportName()) : (c = true, o = C);
                } else
                  te(this.state.type) && (c = true, s ? (o = this.parseIdentifier(true), this.isContextual(93) || this.checkReservedWord(o.name, o.loc.start, true, true)) : o = this.parseModuleExportName());
                c && i && this.raise(s ? I.TypeModifierIsUsedInTypeImports : I.TypeModifierIsUsedInTypeExports, { at: g }), e[a] = o, e[n] = u;
                let T = s ? "importKind" : "exportKind";
                e[T] = c ? "type" : "value", y && this.eatContextual(93) && (e[n] = s ? this.parseIdentifier() : this.parseModuleExportName()), e[n] || (e[n] = me(e[a])), s && this.checkIdentifier(e[n], c ? Sr : Ve);
              }
            };
            function ch(t3) {
              if (t3.type !== "MemberExpression")
                return false;
              let { computed: r, property: e } = t3;
              return r && e.type !== "StringLiteral" && (e.type !== "TemplateLiteral" || e.expressions.length > 0) ? false : Vr(t3.object);
            }
            function ph(t3, r) {
              var e;
              let { type: s } = t3;
              if ((e = t3.extra) != null && e.parenthesized)
                return false;
              if (r) {
                if (s === "Literal") {
                  let { value: i } = t3;
                  if (typeof i == "string" || typeof i == "boolean")
                    return true;
                }
              } else if (s === "StringLiteral" || s === "BooleanLiteral")
                return true;
              return !!(zr(t3, r) || fh(t3, r) || s === "TemplateLiteral" && t3.expressions.length === 0 || ch(t3));
            }
            function zr(t3, r) {
              return r ? t3.type === "Literal" && (typeof t3.value == "number" || "bigint" in t3) : t3.type === "NumericLiteral" || t3.type === "BigIntLiteral";
            }
            function fh(t3, r) {
              if (t3.type === "UnaryExpression") {
                let { operator: e, argument: s } = t3;
                if (e === "-" && zr(s, r))
                  return true;
              }
              return false;
            }
            function Vr(t3) {
              return t3.type === "Identifier" ? true : t3.type !== "MemberExpression" || t3.computed ? false : Vr(t3.object);
            }
            var Kr = pe`placeholders`({ ClassNameIsRequired: "A class name is required.", UnexpectedSpace: "Unexpected space in placeholder." }), dh = (t3) => class extends t3 {
              parsePlaceholder(e) {
                if (this.match(142)) {
                  let s = this.startNode();
                  return this.next(), this.assertNoSpace(), s.name = super.parseIdentifier(true), this.assertNoSpace(), this.expect(142), this.finishPlaceholder(s, e);
                }
              }
              finishPlaceholder(e, s) {
                let i = !!(e.expectedNode && e.type === "Placeholder");
                return e.expectedNode = s, i ? e : this.finishNode(e, "Placeholder");
              }
              getTokenFromCode(e) {
                e === 37 && this.input.charCodeAt(this.state.pos + 1) === 37 ? this.finishOp(142, 2) : super.getTokenFromCode(e);
              }
              parseExprAtom(e) {
                return this.parsePlaceholder("Expression") || super.parseExprAtom(e);
              }
              parseIdentifier(e) {
                return this.parsePlaceholder("Identifier") || super.parseIdentifier(e);
              }
              checkReservedWord(e, s, i, a) {
                e !== void 0 && super.checkReservedWord(e, s, i, a);
              }
              parseBindingAtom() {
                return this.parsePlaceholder("Pattern") || super.parseBindingAtom();
              }
              isValidLVal(e, s, i) {
                return e === "Placeholder" || super.isValidLVal(e, s, i);
              }
              toAssignable(e, s) {
                e && e.type === "Placeholder" && e.expectedNode === "Expression" ? e.expectedNode = "Pattern" : super.toAssignable(e, s);
              }
              chStartsBindingIdentifier(e, s) {
                return !!(super.chStartsBindingIdentifier(e, s) || this.lookahead().type === 142);
              }
              verifyBreakContinue(e, s) {
                e.label && e.label.type === "Placeholder" || super.verifyBreakContinue(e, s);
              }
              parseExpressionStatement(e, s) {
                if (s.type !== "Placeholder" || s.extra && s.extra.parenthesized)
                  return super.parseExpressionStatement(e, s);
                if (this.match(14)) {
                  let i = e;
                  return i.label = this.finishPlaceholder(s, "Identifier"), this.next(), i.body = super.parseStatementOrSloppyAnnexBFunctionDeclaration(), this.finishNode(i, "LabeledStatement");
                }
                return this.semicolon(), e.name = s.name, this.finishPlaceholder(e, "Statement");
              }
              parseBlock(e, s, i) {
                return this.parsePlaceholder("BlockStatement") || super.parseBlock(e, s, i);
              }
              parseFunctionId(e) {
                return this.parsePlaceholder("Identifier") || super.parseFunctionId(e);
              }
              parseClass(e, s, i) {
                let a = s ? "ClassDeclaration" : "ClassExpression";
                this.next();
                let n = this.state.strict, o = this.parsePlaceholder("Identifier");
                if (o)
                  if (this.match(81) || this.match(142) || this.match(5))
                    e.id = o;
                  else {
                    if (i || !s)
                      return e.id = null, e.body = this.finishPlaceholder(o, "ClassBody"), this.finishNode(e, a);
                    throw this.raise(Kr.ClassNameIsRequired, { at: this.state.startLoc });
                  }
                else
                  this.parseClassId(e, s, i);
                return super.parseClassSuper(e), e.body = this.parsePlaceholder("ClassBody") || super.parseClassBody(!!e.superClass, n), this.finishNode(e, a);
              }
              parseExport(e, s) {
                let i = this.parsePlaceholder("Identifier");
                if (!i)
                  return super.parseExport(e, s);
                if (!this.isContextual(97) && !this.match(12))
                  return e.specifiers = [], e.source = null, e.declaration = this.finishPlaceholder(i, "Declaration"), this.finishNode(e, "ExportNamedDeclaration");
                this.expectPlugin("exportDefaultFrom");
                let a = this.startNode();
                return a.exported = i, e.specifiers = [this.finishNode(a, "ExportDefaultSpecifier")], super.parseExport(e, s);
              }
              isExportDefaultSpecifier() {
                if (this.match(65)) {
                  let e = this.nextTokenStart();
                  if (this.isUnparsedContextual(e, "from") && this.input.startsWith(xe(142), this.nextTokenStartSince(e + 4)))
                    return true;
                }
                return super.isExportDefaultSpecifier();
              }
              maybeParseExportDefaultSpecifier(e) {
                return e.specifiers && e.specifiers.length > 0 ? true : super.maybeParseExportDefaultSpecifier(e);
              }
              checkExport(e) {
                let { specifiers: s } = e;
                s != null && s.length && (e.specifiers = s.filter((i) => i.exported.type === "Placeholder")), super.checkExport(e), e.specifiers = s;
              }
              parseImport(e) {
                let s = this.parsePlaceholder("Identifier");
                if (!s)
                  return super.parseImport(e);
                if (e.specifiers = [], !this.isContextual(97) && !this.match(12))
                  return e.source = this.finishPlaceholder(s, "StringLiteral"), this.semicolon(), this.finishNode(e, "ImportDeclaration");
                let i = this.startNodeAtNode(s);
                return i.local = s, e.specifiers.push(this.finishNode(i, "ImportDefaultSpecifier")), this.eat(12) && (this.maybeParseStarImportSpecifier(e) || this.parseNamedImportSpecifiers(e)), this.expectContextual(97), e.source = this.parseImportSource(), this.semicolon(), this.finishNode(e, "ImportDeclaration");
              }
              parseImportSource() {
                return this.parsePlaceholder("StringLiteral") || super.parseImportSource();
              }
              assertNoSpace() {
                this.state.start > this.state.lastTokEndLoc.index && this.raise(Kr.UnexpectedSpace, { at: this.state.lastTokEndLoc });
              }
            }, mh = (t3) => class extends t3 {
              parseV8Intrinsic() {
                if (this.match(54)) {
                  let e = this.state.startLoc, s = this.startNode();
                  if (this.next(), q(this.state.type)) {
                    let i = this.parseIdentifierName(), a = this.createIdentifier(s, i);
                    if (a.type = "V8IntrinsicIdentifier", this.match(10))
                      return a;
                  }
                  this.unexpected(e);
                }
              }
              parseExprAtom(e) {
                return this.parseV8Intrinsic() || super.parseExprAtom(e);
              }
            };
            function J(t3, r) {
              let [e, s] = typeof r == "string" ? [r, {}] : r, i = Object.keys(s), a = i.length === 0;
              return t3.some((n) => {
                if (typeof n == "string")
                  return a && n === e;
                {
                  let [o, u] = n;
                  if (o !== e)
                    return false;
                  for (let c of i)
                    if (u[c] !== s[c])
                      return false;
                  return true;
                }
              });
            }
            function we(t3, r, e) {
              let s = t3.find((i) => Array.isArray(i) ? i[0] === r : i === r);
              return s && Array.isArray(s) && s.length > 1 ? s[1][e] : null;
            }
            var Wr = ["minimal", "fsharp", "hack", "smart"], Gr = ["^^", "@@", "^", "%", "#"], Jr = ["hash", "bar"];
            function yh(t3) {
              if (J(t3, "decorators")) {
                if (J(t3, "decorators-legacy"))
                  throw new Error("Cannot use the decorators and decorators-legacy plugin together");
                let r = we(t3, "decorators", "decoratorsBeforeExport");
                if (r != null && typeof r != "boolean")
                  throw new Error("'decoratorsBeforeExport' must be a boolean, if specified.");
                let e = we(t3, "decorators", "allowCallParenthesized");
                if (e != null && typeof e != "boolean")
                  throw new Error("'allowCallParenthesized' must be a boolean.");
              }
              if (J(t3, "flow") && J(t3, "typescript"))
                throw new Error("Cannot combine flow and typescript plugins.");
              if (J(t3, "placeholders") && J(t3, "v8intrinsic"))
                throw new Error("Cannot combine placeholders and v8intrinsic plugins.");
              if (J(t3, "pipelineOperator")) {
                let r = we(t3, "pipelineOperator", "proposal");
                if (!Wr.includes(r)) {
                  let s = Wr.map((i) => `"${i}"`).join(", ");
                  throw new Error(`"pipelineOperator" requires "proposal" option whose value must be one of: ${s}.`);
                }
                let e = J(t3, ["recordAndTuple", { syntaxType: "hash" }]);
                if (r === "hack") {
                  if (J(t3, "placeholders"))
                    throw new Error("Cannot combine placeholders plugin and Hack-style pipes.");
                  if (J(t3, "v8intrinsic"))
                    throw new Error("Cannot combine v8intrinsic plugin and Hack-style pipes.");
                  let s = we(t3, "pipelineOperator", "topicToken");
                  if (!Gr.includes(s)) {
                    let i = Gr.map((a) => `"${a}"`).join(", ");
                    throw new Error(`"pipelineOperator" in "proposal": "hack" mode also requires a "topicToken" option whose value must be one of: ${i}.`);
                  }
                  if (s === "#" && e)
                    throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "hack", topicToken: "#" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
                } else if (r === "smart" && e)
                  throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "smart" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
              }
              if (J(t3, "moduleAttributes")) {
                if (J(t3, "importAssertions"))
                  throw new Error("Cannot combine importAssertions and moduleAttributes plugins.");
                if (we(t3, "moduleAttributes", "version") !== "may-2020")
                  throw new Error("The 'moduleAttributes' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is 'may-2020'.");
              }
              if (J(t3, "recordAndTuple") && we(t3, "recordAndTuple", "syntaxType") != null && !Jr.includes(we(t3, "recordAndTuple", "syntaxType")))
                throw new Error("The 'syntaxType' option of the 'recordAndTuple' plugin must be one of: " + Jr.map((r) => `'${r}'`).join(", "));
              if (J(t3, "asyncDoExpressions") && !J(t3, "doExpressions")) {
                let r = new Error("'asyncDoExpressions' requires 'doExpressions', please add 'doExpressions' to parser plugins.");
                throw r.missingPlugins = "doExpressions", r;
              }
            }
            var Xr = { estree: el, jsx: th, flow: Zl, typescript: uh, v8intrinsic: mh, placeholders: dh }, xh = Object.keys(Xr), gh = class extends ah {
              checkProto(t3, r, e, s) {
                if (t3.type === "SpreadElement" || this.isObjectMethod(t3) || t3.computed || t3.shorthand)
                  return;
                let i = t3.key;
                if ((i.type === "Identifier" ? i.name : i.value) === "__proto__") {
                  if (r) {
                    this.raise(f.RecordNoProto, { at: i });
                    return;
                  }
                  e.used && (s ? s.doubleProtoLoc === null && (s.doubleProtoLoc = i.loc.start) : this.raise(f.DuplicateProto, { at: i })), e.used = true;
                }
              }
              shouldExitDescending(t3, r) {
                return t3.type === "ArrowFunctionExpression" && t3.start === r;
              }
              getExpression() {
                this.enterInitialScopes(), this.nextToken();
                let t3 = this.parseExpression();
                return this.match(137) || this.unexpected(), this.finalizeRemainingComments(), t3.comments = this.state.comments, t3.errors = this.state.errors, this.options.tokens && (t3.tokens = this.tokens), t3;
              }
              parseExpression(t3, r) {
                return t3 ? this.disallowInAnd(() => this.parseExpressionBase(r)) : this.allowInAnd(() => this.parseExpressionBase(r));
              }
              parseExpressionBase(t3) {
                let r = this.state.startLoc, e = this.parseMaybeAssign(t3);
                if (this.match(12)) {
                  let s = this.startNodeAt(r);
                  for (s.expressions = [e]; this.eat(12); )
                    s.expressions.push(this.parseMaybeAssign(t3));
                  return this.toReferencedList(s.expressions), this.finishNode(s, "SequenceExpression");
                }
                return e;
              }
              parseMaybeAssignDisallowIn(t3, r) {
                return this.disallowInAnd(() => this.parseMaybeAssign(t3, r));
              }
              parseMaybeAssignAllowIn(t3, r) {
                return this.allowInAnd(() => this.parseMaybeAssign(t3, r));
              }
              setOptionalParametersError(t3, r) {
                var e;
                t3.optionalParametersLoc = (e = r == null ? void 0 : r.loc) != null ? e : this.state.startLoc;
              }
              parseMaybeAssign(t3, r) {
                let e = this.state.startLoc;
                if (this.isContextual(106) && this.prodParam.hasYield) {
                  let n = this.parseYield();
                  return r && (n = r.call(this, n, e)), n;
                }
                let s;
                t3 ? s = false : (t3 = new vt(), s = true);
                let { type: i } = this.state;
                (i === 10 || q(i)) && (this.state.potentialArrowAt = this.state.start);
                let a = this.parseMaybeConditional(t3);
                if (r && (a = r.call(this, a, e)), Bo(this.state.type)) {
                  let n = this.startNodeAt(e), o = this.state.value;
                  if (n.operator = o, this.match(29)) {
                    this.toAssignable(a, true), n.left = a;
                    let u = e.index;
                    t3.doubleProtoLoc != null && t3.doubleProtoLoc.index >= u && (t3.doubleProtoLoc = null), t3.shorthandAssignLoc != null && t3.shorthandAssignLoc.index >= u && (t3.shorthandAssignLoc = null), t3.privateKeyLoc != null && t3.privateKeyLoc.index >= u && (this.checkDestructuringPrivate(t3), t3.privateKeyLoc = null);
                  } else
                    n.left = a;
                  return this.next(), n.right = this.parseMaybeAssign(), this.checkLVal(a, { in: this.finishNode(n, "AssignmentExpression") }), n;
                } else
                  s && this.checkExpressionErrors(t3, true);
                return a;
              }
              parseMaybeConditional(t3) {
                let r = this.state.startLoc, e = this.state.potentialArrowAt, s = this.parseExprOps(t3);
                return this.shouldExitDescending(s, e) ? s : this.parseConditional(s, r, t3);
              }
              parseConditional(t3, r, e) {
                if (this.eat(17)) {
                  let s = this.startNodeAt(r);
                  return s.test = t3, s.consequent = this.parseMaybeAssignAllowIn(), this.expect(14), s.alternate = this.parseMaybeAssign(), this.finishNode(s, "ConditionalExpression");
                }
                return t3;
              }
              parseMaybeUnaryOrPrivate(t3) {
                return this.match(136) ? this.parsePrivateName() : this.parseMaybeUnary(t3);
              }
              parseExprOps(t3) {
                let r = this.state.startLoc, e = this.state.potentialArrowAt, s = this.parseMaybeUnaryOrPrivate(t3);
                return this.shouldExitDescending(s, e) ? s : this.parseExprOp(s, r, -1);
              }
              parseExprOp(t3, r, e) {
                if (this.isPrivateName(t3)) {
                  let i = this.getPrivateNameSV(t3);
                  (e >= at2(58) || !this.prodParam.hasIn || !this.match(58)) && this.raise(f.PrivateInExpectedIn, { at: t3, identifierName: i }), this.classScope.usePrivateName(i, t3.loc.start);
                }
                let s = this.state.type;
                if (_o(s) && (this.prodParam.hasIn || !this.match(58))) {
                  let i = at2(s);
                  if (i > e) {
                    if (s === 39) {
                      if (this.expectPlugin("pipelineOperator"), this.state.inFSharpPipelineDirectBody)
                        return t3;
                      this.checkPipelineAtInfixOperator(t3, r);
                    }
                    let a = this.startNodeAt(r);
                    a.left = t3, a.operator = this.state.value;
                    let n = s === 41 || s === 42, o = s === 40;
                    if (o && (i = at2(42)), this.next(), s === 39 && this.hasPlugin(["pipelineOperator", { proposal: "minimal" }]) && this.state.type === 96 && this.prodParam.hasAwait)
                      throw this.raise(f.UnexpectedAwaitAfterPipelineBody, { at: this.state.startLoc });
                    a.right = this.parseExprOpRightExpr(s, i);
                    let u = this.finishNode(a, n || o ? "LogicalExpression" : "BinaryExpression"), c = this.state.type;
                    if (o && (c === 41 || c === 42) || n && c === 40)
                      throw this.raise(f.MixingCoalesceWithLogical, { at: this.state.startLoc });
                    return this.parseExprOp(u, r, e);
                  }
                }
                return t3;
              }
              parseExprOpRightExpr(t3, r) {
                let e = this.state.startLoc;
                switch (t3) {
                  case 39:
                    switch (this.getPluginOption("pipelineOperator", "proposal")) {
                      case "hack":
                        return this.withTopicBindingContext(() => this.parseHackPipeBody());
                      case "smart":
                        return this.withTopicBindingContext(() => {
                          if (this.prodParam.hasYield && this.isContextual(106))
                            throw this.raise(f.PipeBodyIsTighter, { at: this.state.startLoc });
                          return this.parseSmartPipelineBodyInStyle(this.parseExprOpBaseRightExpr(t3, r), e);
                        });
                      case "fsharp":
                        return this.withSoloAwaitPermittingContext(() => this.parseFSharpPipelineBody(r));
                    }
                  default:
                    return this.parseExprOpBaseRightExpr(t3, r);
                }
              }
              parseExprOpBaseRightExpr(t3, r) {
                let e = this.state.startLoc;
                return this.parseExprOp(this.parseMaybeUnaryOrPrivate(), e, $o(t3) ? r - 1 : r);
              }
              parseHackPipeBody() {
                var t3;
                let { startLoc: r } = this.state, e = this.parseMaybeAssign();
                return Go.has(e.type) && !((t3 = e.extra) != null && t3.parenthesized) && this.raise(f.PipeUnparenthesizedBody, { at: r, type: e.type }), this.topicReferenceWasUsedInCurrentContext() || this.raise(f.PipeTopicUnused, { at: r }), e;
              }
              checkExponentialAfterUnary(t3) {
                this.match(57) && this.raise(f.UnexpectedTokenUnaryExponentiation, { at: t3.argument });
              }
              parseMaybeUnary(t3, r) {
                let e = this.state.startLoc, s = this.isContextual(96);
                if (s && this.isAwaitAllowed()) {
                  this.next();
                  let o = this.parseAwait(e);
                  return r || this.checkExponentialAfterUnary(o), o;
                }
                let i = this.match(34), a = this.startNode();
                if (jo(this.state.type)) {
                  a.operator = this.state.value, a.prefix = true, this.match(72) && this.expectPlugin("throwExpressions");
                  let o = this.match(89);
                  if (this.next(), a.argument = this.parseMaybeUnary(null, true), this.checkExpressionErrors(t3, true), this.state.strict && o) {
                    let u = a.argument;
                    u.type === "Identifier" ? this.raise(f.StrictDelete, { at: a }) : this.hasPropertyAsPrivateName(u) && this.raise(f.DeletePrivateField, { at: a });
                  }
                  if (!i)
                    return r || this.checkExponentialAfterUnary(a), this.finishNode(a, "UnaryExpression");
                }
                let n = this.parseUpdate(a, i, t3);
                if (s) {
                  let { type: o } = this.state;
                  if ((this.hasPlugin("v8intrinsic") ? He(o) : He(o) && !this.match(54)) && !this.isAmbiguousAwait())
                    return this.raiseOverwrite(f.AwaitNotInAsyncContext, { at: e }), this.parseAwait(e);
                }
                return n;
              }
              parseUpdate(t3, r, e) {
                if (r) {
                  let a = t3;
                  return this.checkLVal(a.argument, { in: this.finishNode(a, "UpdateExpression") }), t3;
                }
                let s = this.state.startLoc, i = this.parseExprSubscripts(e);
                if (this.checkExpressionErrors(e, false))
                  return i;
                for (; Ro(this.state.type) && !this.canInsertSemicolon(); ) {
                  let a = this.startNodeAt(s);
                  a.operator = this.state.value, a.prefix = false, a.argument = i, this.next(), this.checkLVal(i, { in: i = this.finishNode(a, "UpdateExpression") });
                }
                return i;
              }
              parseExprSubscripts(t3) {
                let r = this.state.startLoc, e = this.state.potentialArrowAt, s = this.parseExprAtom(t3);
                return this.shouldExitDescending(s, e) ? s : this.parseSubscripts(s, r);
              }
              parseSubscripts(t3, r, e) {
                let s = { optionalChainMember: false, maybeAsyncArrow: this.atPossibleAsyncArrow(t3), stop: false };
                do
                  t3 = this.parseSubscript(t3, r, e, s), s.maybeAsyncArrow = false;
                while (!s.stop);
                return t3;
              }
              parseSubscript(t3, r, e, s) {
                let { type: i } = this.state;
                if (!e && i === 15)
                  return this.parseBind(t3, r, e, s);
                if (nt(i))
                  return this.parseTaggedTemplateExpression(t3, r, s);
                let a = false;
                if (i === 18) {
                  if (e && (this.raise(f.OptionalChainingNoNew, { at: this.state.startLoc }), this.lookaheadCharCode() === 40))
                    return s.stop = true, t3;
                  s.optionalChainMember = a = true, this.next();
                }
                if (!e && this.match(10))
                  return this.parseCoverCallAndAsyncArrowHead(t3, r, s, a);
                {
                  let n = this.eat(0);
                  return n || a || this.eat(16) ? this.parseMember(t3, r, s, n, a) : (s.stop = true, t3);
                }
              }
              parseMember(t3, r, e, s, i) {
                let a = this.startNodeAt(r);
                return a.object = t3, a.computed = s, s ? (a.property = this.parseExpression(), this.expect(3)) : this.match(136) ? (t3.type === "Super" && this.raise(f.SuperPrivateField, { at: r }), this.classScope.usePrivateName(this.state.value, this.state.startLoc), a.property = this.parsePrivateName()) : a.property = this.parseIdentifier(true), e.optionalChainMember ? (a.optional = i, this.finishNode(a, "OptionalMemberExpression")) : this.finishNode(a, "MemberExpression");
              }
              parseBind(t3, r, e, s) {
                let i = this.startNodeAt(r);
                return i.object = t3, this.next(), i.callee = this.parseNoCallExpr(), s.stop = true, this.parseSubscripts(this.finishNode(i, "BindExpression"), r, e);
              }
              parseCoverCallAndAsyncArrowHead(t3, r, e, s) {
                let i = this.state.maybeInArrowParameters, a = null;
                this.state.maybeInArrowParameters = true, this.next();
                let n = this.startNodeAt(r);
                n.callee = t3;
                let { maybeAsyncArrow: o, optionalChainMember: u } = e;
                o && (this.expressionScope.enter($l()), a = new vt()), u && (n.optional = s), s ? n.arguments = this.parseCallExpressionArguments(11) : n.arguments = this.parseCallExpressionArguments(11, t3.type === "Import", t3.type !== "Super", n, a);
                let c = this.finishCallExpression(n, u);
                return o && this.shouldParseAsyncArrow() && !s ? (e.stop = true, this.checkDestructuringPrivate(a), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), c = this.parseAsyncArrowFromCallExpression(this.startNodeAt(r), c)) : (o && (this.checkExpressionErrors(a, true), this.expressionScope.exit()), this.toReferencedArguments(c)), this.state.maybeInArrowParameters = i, c;
              }
              toReferencedArguments(t3, r) {
                this.toReferencedListDeep(t3.arguments, r);
              }
              parseTaggedTemplateExpression(t3, r, e) {
                let s = this.startNodeAt(r);
                return s.tag = t3, s.quasi = this.parseTemplate(true), e.optionalChainMember && this.raise(f.OptionalChainingNoTemplate, { at: r }), this.finishNode(s, "TaggedTemplateExpression");
              }
              atPossibleAsyncArrow(t3) {
                return t3.type === "Identifier" && t3.name === "async" && this.state.lastTokEndLoc.index === t3.end && !this.canInsertSemicolon() && t3.end - t3.start === 5 && t3.start === this.state.potentialArrowAt;
              }
              finishCallExpression(t3, r) {
                if (t3.callee.type === "Import")
                  if (t3.arguments.length === 2 && (this.hasPlugin("moduleAttributes") || this.expectPlugin("importAssertions")), t3.arguments.length === 0 || t3.arguments.length > 2)
                    this.raise(f.ImportCallArity, { at: t3, maxArgumentCount: this.hasPlugin("importAssertions") || this.hasPlugin("moduleAttributes") ? 2 : 1 });
                  else
                    for (let e of t3.arguments)
                      e.type === "SpreadElement" && this.raise(f.ImportCallSpreadArgument, { at: e });
                return this.finishNode(t3, r ? "OptionalCallExpression" : "CallExpression");
              }
              parseCallExpressionArguments(t3, r, e, s, i) {
                let a = [], n = true, o = this.state.inFSharpPipelineDirectBody;
                for (this.state.inFSharpPipelineDirectBody = false; !this.eat(t3); ) {
                  if (n)
                    n = false;
                  else if (this.expect(12), this.match(t3)) {
                    r && !this.hasPlugin("importAssertions") && !this.hasPlugin("moduleAttributes") && this.raise(f.ImportCallArgumentTrailingComma, { at: this.state.lastTokStartLoc }), s && this.addTrailingCommaExtraToNode(s), this.next();
                    break;
                  }
                  a.push(this.parseExprListItem(false, i, e));
                }
                return this.state.inFSharpPipelineDirectBody = o, a;
              }
              shouldParseAsyncArrow() {
                return this.match(19) && !this.canInsertSemicolon();
              }
              parseAsyncArrowFromCallExpression(t3, r) {
                var e;
                return this.resetPreviousNodeTrailingComments(r), this.expect(19), this.parseArrowExpression(t3, r.arguments, true, (e = r.extra) == null ? void 0 : e.trailingCommaLoc), r.innerComments && Ke(t3, r.innerComments), r.callee.trailingComments && Ke(t3, r.callee.trailingComments), t3;
              }
              parseNoCallExpr() {
                let t3 = this.state.startLoc;
                return this.parseSubscripts(this.parseExprAtom(), t3, true);
              }
              parseExprAtom(t3) {
                let r, e = null, { type: s } = this.state;
                switch (s) {
                  case 79:
                    return this.parseSuper();
                  case 83:
                    return r = this.startNode(), this.next(), this.match(16) ? this.parseImportMetaProperty(r) : (this.match(10) || this.raise(f.UnsupportedImport, { at: this.state.lastTokStartLoc }), this.finishNode(r, "Import"));
                  case 78:
                    return r = this.startNode(), this.next(), this.finishNode(r, "ThisExpression");
                  case 90:
                    return this.parseDo(this.startNode(), false);
                  case 56:
                  case 31:
                    return this.readRegexp(), this.parseRegExpLiteral(this.state.value);
                  case 132:
                    return this.parseNumericLiteral(this.state.value);
                  case 133:
                    return this.parseBigIntLiteral(this.state.value);
                  case 134:
                    return this.parseDecimalLiteral(this.state.value);
                  case 131:
                    return this.parseStringLiteral(this.state.value);
                  case 84:
                    return this.parseNullLiteral();
                  case 85:
                    return this.parseBooleanLiteral(true);
                  case 86:
                    return this.parseBooleanLiteral(false);
                  case 10: {
                    let i = this.state.potentialArrowAt === this.state.start;
                    return this.parseParenAndDistinguishExpression(i);
                  }
                  case 2:
                  case 1:
                    return this.parseArrayLike(this.state.type === 2 ? 4 : 3, false, true);
                  case 0:
                    return this.parseArrayLike(3, true, false, t3);
                  case 6:
                  case 7:
                    return this.parseObjectLike(this.state.type === 6 ? 9 : 8, false, true);
                  case 5:
                    return this.parseObjectLike(8, false, false, t3);
                  case 68:
                    return this.parseFunctionOrFunctionSent();
                  case 26:
                    e = this.parseDecorators();
                  case 80:
                    return this.parseClass(this.maybeTakeDecorators(e, this.startNode()), false);
                  case 77:
                    return this.parseNewOrNewTarget();
                  case 25:
                  case 24:
                    return this.parseTemplate(false);
                  case 15: {
                    r = this.startNode(), this.next(), r.object = null;
                    let i = r.callee = this.parseNoCallExpr();
                    if (i.type === "MemberExpression")
                      return this.finishNode(r, "BindExpression");
                    throw this.raise(f.UnsupportedBind, { at: i });
                  }
                  case 136:
                    return this.raise(f.PrivateInExpectedIn, { at: this.state.startLoc, identifierName: this.state.value }), this.parsePrivateName();
                  case 33:
                    return this.parseTopicReferenceThenEqualsSign(54, "%");
                  case 32:
                    return this.parseTopicReferenceThenEqualsSign(44, "^");
                  case 37:
                  case 38:
                    return this.parseTopicReference("hack");
                  case 44:
                  case 54:
                  case 27: {
                    let i = this.getPluginOption("pipelineOperator", "proposal");
                    if (i)
                      return this.parseTopicReference(i);
                    this.unexpected();
                    break;
                  }
                  case 47: {
                    let i = this.input.codePointAt(this.nextTokenStart());
                    fe(i) || i === 62 ? this.expectOnePlugin(["jsx", "flow", "typescript"]) : this.unexpected();
                    break;
                  }
                  default:
                    if (q(s)) {
                      if (this.isContextual(125) && this.lookaheadCharCode() === 123 && !this.hasFollowingLineBreak())
                        return this.parseModuleExpression();
                      let i = this.state.potentialArrowAt === this.state.start, a = this.state.containsEsc, n = this.parseIdentifier();
                      if (!a && n.name === "async" && !this.canInsertSemicolon()) {
                        let { type: o } = this.state;
                        if (o === 68)
                          return this.resetPreviousNodeTrailingComments(n), this.next(), this.parseAsyncFunctionExpression(this.startNodeAtNode(n));
                        if (q(o))
                          return this.lookaheadCharCode() === 61 ? this.parseAsyncArrowUnaryFunction(this.startNodeAtNode(n)) : n;
                        if (o === 90)
                          return this.resetPreviousNodeTrailingComments(n), this.parseDo(this.startNodeAtNode(n), true);
                      }
                      return i && this.match(19) && !this.canInsertSemicolon() ? (this.next(), this.parseArrowExpression(this.startNodeAtNode(n), [n], false)) : n;
                    } else
                      this.unexpected();
                }
              }
              parseTopicReferenceThenEqualsSign(t3, r) {
                let e = this.getPluginOption("pipelineOperator", "proposal");
                if (e)
                  return this.state.type = t3, this.state.value = r, this.state.pos--, this.state.end--, this.state.endLoc = Y(this.state.endLoc, -1), this.parseTopicReference(e);
                this.unexpected();
              }
              parseTopicReference(t3) {
                let r = this.startNode(), e = this.state.startLoc, s = this.state.type;
                return this.next(), this.finishTopicReference(r, e, t3, s);
              }
              finishTopicReference(t3, r, e, s) {
                if (this.testTopicReferenceConfiguration(e, r, s)) {
                  let i = e === "smart" ? "PipelinePrimaryTopicReference" : "TopicReference";
                  return this.topicReferenceIsAllowedInCurrentContext() || this.raise(e === "smart" ? f.PrimaryTopicNotAllowed : f.PipeTopicUnbound, { at: r }), this.registerTopicReference(), this.finishNode(t3, i);
                } else
                  throw this.raise(f.PipeTopicUnconfiguredToken, { at: r, token: xe(s) });
              }
              testTopicReferenceConfiguration(t3, r, e) {
                switch (t3) {
                  case "hack":
                    return this.hasPlugin(["pipelineOperator", { topicToken: xe(e) }]);
                  case "smart":
                    return e === 27;
                  default:
                    throw this.raise(f.PipeTopicRequiresHackPipes, { at: r });
                }
              }
              parseAsyncArrowUnaryFunction(t3) {
                this.prodParam.enter(Tt(true, this.prodParam.hasYield));
                let r = [this.parseIdentifier()];
                return this.prodParam.exit(), this.hasPrecedingLineBreak() && this.raise(f.LineTerminatorBeforeArrow, { at: this.state.curPosition() }), this.expect(19), this.parseArrowExpression(t3, r, true);
              }
              parseDo(t3, r) {
                this.expectPlugin("doExpressions"), r && this.expectPlugin("asyncDoExpressions"), t3.async = r, this.next();
                let e = this.state.labels;
                return this.state.labels = [], r ? (this.prodParam.enter(At), t3.body = this.parseBlock(), this.prodParam.exit()) : t3.body = this.parseBlock(), this.state.labels = e, this.finishNode(t3, "DoExpression");
              }
              parseSuper() {
                let t3 = this.startNode();
                return this.next(), this.match(10) && !this.scope.allowDirectSuper && !this.options.allowSuperOutsideMethod ? this.raise(f.SuperNotAllowed, { at: t3 }) : !this.scope.allowSuper && !this.options.allowSuperOutsideMethod && this.raise(f.UnexpectedSuper, { at: t3 }), !this.match(10) && !this.match(0) && !this.match(16) && this.raise(f.UnsupportedSuper, { at: t3 }), this.finishNode(t3, "Super");
              }
              parsePrivateName() {
                let t3 = this.startNode(), r = this.startNodeAt(Y(this.state.startLoc, 1)), e = this.state.value;
                return this.next(), t3.id = this.createIdentifier(r, e), this.finishNode(t3, "PrivateName");
              }
              parseFunctionOrFunctionSent() {
                let t3 = this.startNode();
                if (this.next(), this.prodParam.hasYield && this.match(16)) {
                  let r = this.createIdentifier(this.startNodeAtNode(t3), "function");
                  return this.next(), this.match(102) ? this.expectPlugin("functionSent") : this.hasPlugin("functionSent") || this.unexpected(), this.parseMetaProperty(t3, r, "sent");
                }
                return this.parseFunction(t3);
              }
              parseMetaProperty(t3, r, e) {
                t3.meta = r;
                let s = this.state.containsEsc;
                return t3.property = this.parseIdentifier(true), (t3.property.name !== e || s) && this.raise(f.UnsupportedMetaProperty, { at: t3.property, target: r.name, onlyValidPropertyName: e }), this.finishNode(t3, "MetaProperty");
              }
              parseImportMetaProperty(t3) {
                let r = this.createIdentifier(this.startNodeAtNode(t3), "import");
                return this.next(), this.isContextual(100) && (this.inModule || this.raise(f.ImportMetaOutsideModule, { at: r }), this.sawUnambiguousESM = true), this.parseMetaProperty(t3, r, "meta");
              }
              parseLiteralAtNode(t3, r, e) {
                return this.addExtra(e, "rawValue", t3), this.addExtra(e, "raw", this.input.slice(e.start, this.state.end)), e.value = t3, this.next(), this.finishNode(e, r);
              }
              parseLiteral(t3, r) {
                let e = this.startNode();
                return this.parseLiteralAtNode(t3, r, e);
              }
              parseStringLiteral(t3) {
                return this.parseLiteral(t3, "StringLiteral");
              }
              parseNumericLiteral(t3) {
                return this.parseLiteral(t3, "NumericLiteral");
              }
              parseBigIntLiteral(t3) {
                return this.parseLiteral(t3, "BigIntLiteral");
              }
              parseDecimalLiteral(t3) {
                return this.parseLiteral(t3, "DecimalLiteral");
              }
              parseRegExpLiteral(t3) {
                let r = this.parseLiteral(t3.value, "RegExpLiteral");
                return r.pattern = t3.pattern, r.flags = t3.flags, r;
              }
              parseBooleanLiteral(t3) {
                let r = this.startNode();
                return r.value = t3, this.next(), this.finishNode(r, "BooleanLiteral");
              }
              parseNullLiteral() {
                let t3 = this.startNode();
                return this.next(), this.finishNode(t3, "NullLiteral");
              }
              parseParenAndDistinguishExpression(t3) {
                let r = this.state.startLoc, e;
                this.next(), this.expressionScope.enter(Ul());
                let s = this.state.maybeInArrowParameters, i = this.state.inFSharpPipelineDirectBody;
                this.state.maybeInArrowParameters = true, this.state.inFSharpPipelineDirectBody = false;
                let a = this.state.startLoc, n = [], o = new vt(), u = true, c, y;
                for (; !this.match(11); ) {
                  if (u)
                    u = false;
                  else if (this.expect(12, o.optionalParametersLoc === null ? null : o.optionalParametersLoc), this.match(11)) {
                    y = this.state.startLoc;
                    break;
                  }
                  if (this.match(21)) {
                    let C = this.state.startLoc;
                    if (c = this.state.startLoc, n.push(this.parseParenItem(this.parseRestBinding(), C)), !this.checkCommaAfterRest(41))
                      break;
                  } else
                    n.push(this.parseMaybeAssignAllowIn(o, this.parseParenItem));
                }
                let g = this.state.lastTokEndLoc;
                this.expect(11), this.state.maybeInArrowParameters = s, this.state.inFSharpPipelineDirectBody = i;
                let T = this.startNodeAt(r);
                return t3 && this.shouldParseArrow(n) && (T = this.parseArrow(T)) ? (this.checkDestructuringPrivate(o), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), this.parseArrowExpression(T, n, false), T) : (this.expressionScope.exit(), n.length || this.unexpected(this.state.lastTokStartLoc), y && this.unexpected(y), c && this.unexpected(c), this.checkExpressionErrors(o, true), this.toReferencedListDeep(n, true), n.length > 1 ? (e = this.startNodeAt(a), e.expressions = n, this.finishNode(e, "SequenceExpression"), this.resetEndLocation(e, g)) : e = n[0], this.wrapParenthesis(r, e));
              }
              wrapParenthesis(t3, r) {
                if (!this.options.createParenthesizedExpressions)
                  return this.addExtra(r, "parenthesized", true), this.addExtra(r, "parenStart", t3.index), this.takeSurroundingComments(r, t3.index, this.state.lastTokEndLoc.index), r;
                let e = this.startNodeAt(t3);
                return e.expression = r, this.finishNode(e, "ParenthesizedExpression");
              }
              shouldParseArrow(t3) {
                return !this.canInsertSemicolon();
              }
              parseArrow(t3) {
                if (this.eat(19))
                  return t3;
              }
              parseParenItem(t3, r) {
                return t3;
              }
              parseNewOrNewTarget() {
                let t3 = this.startNode();
                if (this.next(), this.match(16)) {
                  let r = this.createIdentifier(this.startNodeAtNode(t3), "new");
                  this.next();
                  let e = this.parseMetaProperty(t3, r, "target");
                  return !this.scope.inNonArrowFunction && !this.scope.inClass && !this.options.allowNewTargetOutsideFunction && this.raise(f.UnexpectedNewTarget, { at: e }), e;
                }
                return this.parseNew(t3);
              }
              parseNew(t3) {
                if (this.parseNewCallee(t3), this.eat(10)) {
                  let r = this.parseExprList(11);
                  this.toReferencedList(r), t3.arguments = r;
                } else
                  t3.arguments = [];
                return this.finishNode(t3, "NewExpression");
              }
              parseNewCallee(t3) {
                t3.callee = this.parseNoCallExpr(), t3.callee.type === "Import" && this.raise(f.ImportCallNotNewExpression, { at: t3.callee });
              }
              parseTemplateElement(t3) {
                let { start: r, startLoc: e, end: s, value: i } = this.state, a = r + 1, n = this.startNodeAt(Y(e, 1));
                i === null && (t3 || this.raise(f.InvalidEscapeSequenceTemplate, { at: Y(this.state.firstInvalidTemplateEscapePos, 1) }));
                let o = this.match(24), u = o ? -1 : -2, c = s + u;
                n.value = { raw: this.input.slice(a, c).replace(/\r\n?/g, `
`), cooked: i === null ? null : i.slice(1, u) }, n.tail = o, this.next();
                let y = this.finishNode(n, "TemplateElement");
                return this.resetEndLocation(y, Y(this.state.lastTokEndLoc, u)), y;
              }
              parseTemplate(t3) {
                let r = this.startNode();
                r.expressions = [];
                let e = this.parseTemplateElement(t3);
                for (r.quasis = [e]; !e.tail; )
                  r.expressions.push(this.parseTemplateSubstitution()), this.readTemplateContinuation(), r.quasis.push(e = this.parseTemplateElement(t3));
                return this.finishNode(r, "TemplateLiteral");
              }
              parseTemplateSubstitution() {
                return this.parseExpression();
              }
              parseObjectLike(t3, r, e, s) {
                e && this.expectPlugin("recordAndTuple");
                let i = this.state.inFSharpPipelineDirectBody;
                this.state.inFSharpPipelineDirectBody = false;
                let a = /* @__PURE__ */ Object.create(null), n = true, o = this.startNode();
                for (o.properties = [], this.next(); !this.match(t3); ) {
                  if (n)
                    n = false;
                  else if (this.expect(12), this.match(t3)) {
                    this.addTrailingCommaExtraToNode(o);
                    break;
                  }
                  let c;
                  r ? c = this.parseBindingProperty() : (c = this.parsePropertyDefinition(s), this.checkProto(c, e, a, s)), e && !this.isObjectProperty(c) && c.type !== "SpreadElement" && this.raise(f.InvalidRecordProperty, { at: c }), c.shorthand && this.addExtra(c, "shorthand", true), o.properties.push(c);
                }
                this.next(), this.state.inFSharpPipelineDirectBody = i;
                let u = "ObjectExpression";
                return r ? u = "ObjectPattern" : e && (u = "RecordExpression"), this.finishNode(o, u);
              }
              addTrailingCommaExtraToNode(t3) {
                this.addExtra(t3, "trailingComma", this.state.lastTokStart), this.addExtra(t3, "trailingCommaLoc", this.state.lastTokStartLoc, false);
              }
              maybeAsyncOrAccessorProp(t3) {
                return !t3.computed && t3.key.type === "Identifier" && (this.isLiteralPropertyName() || this.match(0) || this.match(55));
              }
              parsePropertyDefinition(t3) {
                let r = [];
                if (this.match(26))
                  for (this.hasPlugin("decorators") && this.raise(f.UnsupportedPropertyDecorator, { at: this.state.startLoc }); this.match(26); )
                    r.push(this.parseDecorator());
                let e = this.startNode(), s = false, i = false, a;
                if (this.match(21))
                  return r.length && this.unexpected(), this.parseSpread();
                r.length && (e.decorators = r, r = []), e.method = false, t3 && (a = this.state.startLoc);
                let n = this.eat(55);
                this.parsePropertyNamePrefixOperator(e);
                let o = this.state.containsEsc, u = this.parsePropertyName(e, t3);
                if (!n && !o && this.maybeAsyncOrAccessorProp(e)) {
                  let c = u.name;
                  c === "async" && !this.hasPrecedingLineBreak() && (s = true, this.resetPreviousNodeTrailingComments(u), n = this.eat(55), this.parsePropertyName(e)), (c === "get" || c === "set") && (i = true, this.resetPreviousNodeTrailingComments(u), e.kind = c, this.match(55) && (n = true, this.raise(f.AccessorIsGenerator, { at: this.state.curPosition(), kind: c }), this.next()), this.parsePropertyName(e));
                }
                return this.parseObjPropValue(e, a, n, s, false, i, t3);
              }
              getGetterSetterExpectedParamCount(t3) {
                return t3.kind === "get" ? 0 : 1;
              }
              getObjectOrClassMethodParams(t3) {
                return t3.params;
              }
              checkGetterSetterParams(t3) {
                var r;
                let e = this.getGetterSetterExpectedParamCount(t3), s = this.getObjectOrClassMethodParams(t3);
                s.length !== e && this.raise(t3.kind === "get" ? f.BadGetterArity : f.BadSetterArity, { at: t3 }), t3.kind === "set" && ((r = s[s.length - 1]) == null ? void 0 : r.type) === "RestElement" && this.raise(f.BadSetterRestParameter, { at: t3 });
              }
              parseObjectMethod(t3, r, e, s, i) {
                if (i) {
                  let a = this.parseMethod(t3, r, false, false, false, "ObjectMethod");
                  return this.checkGetterSetterParams(a), a;
                }
                if (e || r || this.match(10))
                  return s && this.unexpected(), t3.kind = "method", t3.method = true, this.parseMethod(t3, r, e, false, false, "ObjectMethod");
              }
              parseObjectProperty(t3, r, e, s) {
                if (t3.shorthand = false, this.eat(14))
                  return t3.value = e ? this.parseMaybeDefault(this.state.startLoc) : this.parseMaybeAssignAllowIn(s), this.finishNode(t3, "ObjectProperty");
                if (!t3.computed && t3.key.type === "Identifier") {
                  if (this.checkReservedWord(t3.key.name, t3.key.loc.start, true, false), e)
                    t3.value = this.parseMaybeDefault(r, me(t3.key));
                  else if (this.match(29)) {
                    let i = this.state.startLoc;
                    s != null ? s.shorthandAssignLoc === null && (s.shorthandAssignLoc = i) : this.raise(f.InvalidCoverInitializedName, { at: i }), t3.value = this.parseMaybeDefault(r, me(t3.key));
                  } else
                    t3.value = me(t3.key);
                  return t3.shorthand = true, this.finishNode(t3, "ObjectProperty");
                }
              }
              parseObjPropValue(t3, r, e, s, i, a, n) {
                let o = this.parseObjectMethod(t3, e, s, i, a) || this.parseObjectProperty(t3, r, i, n);
                return o || this.unexpected(), o;
              }
              parsePropertyName(t3, r) {
                if (this.eat(0))
                  t3.computed = true, t3.key = this.parseMaybeAssignAllowIn(), this.expect(3);
                else {
                  let { type: e, value: s } = this.state, i;
                  if (te(e))
                    i = this.parseIdentifier(true);
                  else
                    switch (e) {
                      case 132:
                        i = this.parseNumericLiteral(s);
                        break;
                      case 131:
                        i = this.parseStringLiteral(s);
                        break;
                      case 133:
                        i = this.parseBigIntLiteral(s);
                        break;
                      case 134:
                        i = this.parseDecimalLiteral(s);
                        break;
                      case 136: {
                        let a = this.state.startLoc;
                        r != null ? r.privateKeyLoc === null && (r.privateKeyLoc = a) : this.raise(f.UnexpectedPrivateField, { at: a }), i = this.parsePrivateName();
                        break;
                      }
                      default:
                        this.unexpected();
                    }
                  t3.key = i, e !== 136 && (t3.computed = false);
                }
                return t3.key;
              }
              initFunction(t3, r) {
                t3.id = null, t3.generator = false, t3.async = r;
              }
              parseMethod(t3, r, e, s, i, a) {
                let n = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
                this.initFunction(t3, e), t3.generator = r, this.scope.enter(de | ht | (n ? Ee : 0) | (i ? Pr : 0)), this.prodParam.enter(Tt(e, t3.generator)), this.parseFunctionParams(t3, s);
                let o = this.parseFunctionBodyAndFinish(t3, a, true);
                return this.prodParam.exit(), this.scope.exit(), o;
              }
              parseArrayLike(t3, r, e, s) {
                e && this.expectPlugin("recordAndTuple");
                let i = this.state.inFSharpPipelineDirectBody;
                this.state.inFSharpPipelineDirectBody = false;
                let a = this.startNode();
                return this.next(), a.elements = this.parseExprList(t3, !e, s, a), this.state.inFSharpPipelineDirectBody = i, this.finishNode(a, e ? "TupleExpression" : "ArrayExpression");
              }
              parseArrowExpression(t3, r, e, s) {
                this.scope.enter(de | Gt);
                let i = Tt(e, false);
                !this.match(5) && this.prodParam.hasIn && (i |= _e), this.prodParam.enter(i), this.initFunction(t3, e);
                let a = this.state.maybeInArrowParameters;
                return r && (this.state.maybeInArrowParameters = true, this.setArrowFunctionParameters(t3, r, s)), this.state.maybeInArrowParameters = false, this.parseFunctionBody(t3, true), this.prodParam.exit(), this.scope.exit(), this.state.maybeInArrowParameters = a, this.finishNode(t3, "ArrowFunctionExpression");
              }
              setArrowFunctionParameters(t3, r, e) {
                this.toAssignableList(r, e, false), t3.params = r;
              }
              parseFunctionBodyAndFinish(t3, r) {
                let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                return this.parseFunctionBody(t3, false, e), this.finishNode(t3, r);
              }
              parseFunctionBody(t3, r) {
                let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, s = r && !this.match(5);
                if (this.expressionScope.enter(_r()), s)
                  t3.body = this.parseMaybeAssign(), this.checkParams(t3, false, r, false);
                else {
                  let i = this.state.strict, a = this.state.labels;
                  this.state.labels = [], this.prodParam.enter(this.prodParam.currentFlags() | jr), t3.body = this.parseBlock(true, false, (n) => {
                    let o = !this.isSimpleParamList(t3.params);
                    n && o && this.raise(f.IllegalLanguageModeDirective, { at: (t3.kind === "method" || t3.kind === "constructor") && t3.key ? t3.key.loc.end : t3 });
                    let u = !i && this.state.strict;
                    this.checkParams(t3, !this.state.strict && !r && !e && !o, r, u), this.state.strict && t3.id && this.checkIdentifier(t3.id, dl, u);
                  }), this.prodParam.exit(), this.state.labels = a;
                }
                this.expressionScope.exit();
              }
              isSimpleParameter(t3) {
                return t3.type === "Identifier";
              }
              isSimpleParamList(t3) {
                for (let r = 0, e = t3.length; r < e; r++)
                  if (!this.isSimpleParameter(t3[r]))
                    return false;
                return true;
              }
              checkParams(t3, r, e) {
                let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, i = !r && /* @__PURE__ */ new Set(), a = { type: "FormalParameters" };
                for (let n of t3.params)
                  this.checkLVal(n, { in: a, binding: mt, checkClashes: i, strictModeChanged: s });
              }
              parseExprList(t3, r, e, s) {
                let i = [], a = true;
                for (; !this.eat(t3); ) {
                  if (a)
                    a = false;
                  else if (this.expect(12), this.match(t3)) {
                    s && this.addTrailingCommaExtraToNode(s), this.next();
                    break;
                  }
                  i.push(this.parseExprListItem(r, e));
                }
                return i;
              }
              parseExprListItem(t3, r, e) {
                let s;
                if (this.match(12))
                  t3 || this.raise(f.UnexpectedToken, { at: this.state.curPosition(), unexpected: "," }), s = null;
                else if (this.match(21)) {
                  let i = this.state.startLoc;
                  s = this.parseParenItem(this.parseSpread(r), i);
                } else if (this.match(17)) {
                  this.expectPlugin("partialApplication"), e || this.raise(f.UnexpectedArgumentPlaceholder, { at: this.state.startLoc });
                  let i = this.startNode();
                  this.next(), s = this.finishNode(i, "ArgumentPlaceholder");
                } else
                  s = this.parseMaybeAssignAllowIn(r, this.parseParenItem);
                return s;
              }
              parseIdentifier(t3) {
                let r = this.startNode(), e = this.parseIdentifierName(t3);
                return this.createIdentifier(r, e);
              }
              createIdentifier(t3, r) {
                return t3.name = r, t3.loc.identifierName = r, this.finishNode(t3, "Identifier");
              }
              parseIdentifierName(t3) {
                let r, { startLoc: e, type: s } = this.state;
                te(s) ? r = this.state.value : this.unexpected();
                let i = ue(s);
                return t3 ? i && this.replaceToken(130) : this.checkReservedWord(r, e, i, false), this.next(), r;
              }
              checkReservedWord(t3, r, e, s) {
                if (t3.length > 10 || !ul(t3))
                  return;
                if (e && ol(t3)) {
                  this.raise(f.UnexpectedKeyword, { at: r, keyword: t3 });
                  return;
                }
                if ((this.state.strict ? s ? xr : mr : dr)(t3, this.inModule)) {
                  this.raise(f.UnexpectedReservedWord, { at: r, reservedWord: t3 });
                  return;
                } else if (t3 === "yield") {
                  if (this.prodParam.hasYield) {
                    this.raise(f.YieldBindingIdentifier, { at: r });
                    return;
                  }
                } else if (t3 === "await") {
                  if (this.prodParam.hasAwait) {
                    this.raise(f.AwaitBindingIdentifier, { at: r });
                    return;
                  }
                  if (this.scope.inStaticBlock) {
                    this.raise(f.AwaitBindingIdentifierInStaticBlock, { at: r });
                    return;
                  }
                  this.expressionScope.recordAsyncArrowParametersError({ at: r });
                } else if (t3 === "arguments" && this.scope.inClassAndNotInNonArrowFunction) {
                  this.raise(f.ArgumentsInClass, { at: r });
                  return;
                }
              }
              isAwaitAllowed() {
                return !!(this.prodParam.hasAwait || this.options.allowAwaitOutsideFunction && !this.scope.inFunction);
              }
              parseAwait(t3) {
                let r = this.startNodeAt(t3);
                return this.expressionScope.recordParameterInitializerError(f.AwaitExpressionFormalParameter, { at: r }), this.eat(55) && this.raise(f.ObsoleteAwaitStar, { at: r }), !this.scope.inFunction && !this.options.allowAwaitOutsideFunction && (this.isAmbiguousAwait() ? this.ambiguousScriptDifferentAst = true : this.sawUnambiguousESM = true), this.state.soloAwait || (r.argument = this.parseMaybeUnary(null, true)), this.finishNode(r, "AwaitExpression");
              }
              isAmbiguousAwait() {
                if (this.hasPrecedingLineBreak())
                  return true;
                let { type: t3 } = this.state;
                return t3 === 53 || t3 === 10 || t3 === 0 || nt(t3) || t3 === 101 && !this.state.containsEsc || t3 === 135 || t3 === 56 || this.hasPlugin("v8intrinsic") && t3 === 54;
              }
              parseYield() {
                let t3 = this.startNode();
                this.expressionScope.recordParameterInitializerError(f.YieldInParameter, { at: t3 }), this.next();
                let r = false, e = null;
                if (!this.hasPrecedingLineBreak())
                  switch (r = this.eat(55), this.state.type) {
                    case 13:
                    case 137:
                    case 8:
                    case 11:
                    case 3:
                    case 9:
                    case 14:
                    case 12:
                      if (!r)
                        break;
                    default:
                      e = this.parseMaybeAssign();
                  }
                return t3.delegate = r, t3.argument = e, this.finishNode(t3, "YieldExpression");
              }
              checkPipelineAtInfixOperator(t3, r) {
                this.hasPlugin(["pipelineOperator", { proposal: "smart" }]) && t3.type === "SequenceExpression" && this.raise(f.PipelineHeadSequenceExpression, { at: r });
              }
              parseSmartPipelineBodyInStyle(t3, r) {
                if (this.isSimpleReference(t3)) {
                  let e = this.startNodeAt(r);
                  return e.callee = t3, this.finishNode(e, "PipelineBareFunction");
                } else {
                  let e = this.startNodeAt(r);
                  return this.checkSmartPipeTopicBodyEarlyErrors(r), e.expression = t3, this.finishNode(e, "PipelineTopicExpression");
                }
              }
              isSimpleReference(t3) {
                switch (t3.type) {
                  case "MemberExpression":
                    return !t3.computed && this.isSimpleReference(t3.object);
                  case "Identifier":
                    return true;
                  default:
                    return false;
                }
              }
              checkSmartPipeTopicBodyEarlyErrors(t3) {
                if (this.match(19))
                  throw this.raise(f.PipelineBodyNoArrow, { at: this.state.startLoc });
                this.topicReferenceWasUsedInCurrentContext() || this.raise(f.PipelineTopicUnused, { at: t3 });
              }
              withTopicBindingContext(t3) {
                let r = this.state.topicContext;
                this.state.topicContext = { maxNumOfResolvableTopics: 1, maxTopicIndex: null };
                try {
                  return t3();
                } finally {
                  this.state.topicContext = r;
                }
              }
              withSmartMixTopicForbiddingContext(t3) {
                if (this.hasPlugin(["pipelineOperator", { proposal: "smart" }])) {
                  let r = this.state.topicContext;
                  this.state.topicContext = { maxNumOfResolvableTopics: 0, maxTopicIndex: null };
                  try {
                    return t3();
                  } finally {
                    this.state.topicContext = r;
                  }
                } else
                  return t3();
              }
              withSoloAwaitPermittingContext(t3) {
                let r = this.state.soloAwait;
                this.state.soloAwait = true;
                try {
                  return t3();
                } finally {
                  this.state.soloAwait = r;
                }
              }
              allowInAnd(t3) {
                let r = this.prodParam.currentFlags();
                if (_e & ~r) {
                  this.prodParam.enter(r | _e);
                  try {
                    return t3();
                  } finally {
                    this.prodParam.exit();
                  }
                }
                return t3();
              }
              disallowInAnd(t3) {
                let r = this.prodParam.currentFlags();
                if (_e & r) {
                  this.prodParam.enter(r & ~_e);
                  try {
                    return t3();
                  } finally {
                    this.prodParam.exit();
                  }
                }
                return t3();
              }
              registerTopicReference() {
                this.state.topicContext.maxTopicIndex = 0;
              }
              topicReferenceIsAllowedInCurrentContext() {
                return this.state.topicContext.maxNumOfResolvableTopics >= 1;
              }
              topicReferenceWasUsedInCurrentContext() {
                return this.state.topicContext.maxTopicIndex != null && this.state.topicContext.maxTopicIndex >= 0;
              }
              parseFSharpPipelineBody(t3) {
                let r = this.state.startLoc;
                this.state.potentialArrowAt = this.state.start;
                let e = this.state.inFSharpPipelineDirectBody;
                this.state.inFSharpPipelineDirectBody = true;
                let s = this.parseExprOp(this.parseMaybeUnaryOrPrivate(), r, t3);
                return this.state.inFSharpPipelineDirectBody = e, s;
              }
              parseModuleExpression() {
                this.expectPlugin("moduleBlocks");
                let t3 = this.startNode();
                this.next(), this.match(5) || this.unexpected(null, 5);
                let r = this.startNodeAt(this.state.endLoc);
                this.next();
                let e = this.initializeScopes(true);
                this.enterInitialScopes();
                try {
                  t3.body = this.parseProgram(r, 8, "module");
                } finally {
                  e();
                }
                return this.finishNode(t3, "ModuleExpression");
              }
              parsePropertyNamePrefixOperator(t3) {
              }
            }, cs = { kind: "loop" }, Ph = { kind: "switch" }, Ah = /[\uD800-\uDFFF]/u, ps = /in(?:stanceof)?/y;
            function Th(t3, r) {
              for (let e = 0; e < t3.length; e++) {
                let s = t3[e], { type: i } = s;
                if (typeof i == "number") {
                  {
                    if (i === 136) {
                      let { loc: a, start: n, value: o, end: u } = s, c = n + 1, y = Y(a.start, 1);
                      t3.splice(e, 1, new Ae({ type: ce(27), value: "#", start: n, end: c, startLoc: a.start, endLoc: y }), new Ae({ type: ce(130), value: o, start: c, end: u, startLoc: y, endLoc: a.end })), e++;
                      continue;
                    }
                    if (nt(i)) {
                      let { loc: a, start: n, value: o, end: u } = s, c = n + 1, y = Y(a.start, 1), g;
                      r.charCodeAt(n) === 96 ? g = new Ae({ type: ce(22), value: "`", start: n, end: c, startLoc: a.start, endLoc: y }) : g = new Ae({ type: ce(8), value: "}", start: n, end: c, startLoc: a.start, endLoc: y });
                      let T, C, M, j;
                      i === 24 ? (C = u - 1, M = Y(a.end, -1), T = o === null ? null : o.slice(1, -1), j = new Ae({ type: ce(22), value: "`", start: C, end: u, startLoc: M, endLoc: a.end })) : (C = u - 2, M = Y(a.end, -2), T = o === null ? null : o.slice(1, -2), j = new Ae({ type: ce(23), value: "${", start: C, end: u, startLoc: M, endLoc: a.end })), t3.splice(e, 1, g, new Ae({ type: ce(20), value: T, start: c, end: C, startLoc: y, endLoc: M }), j), e += 2;
                      continue;
                    }
                  }
                  s.type = ce(i);
                }
              }
              return t3;
            }
            var vh = class extends gh {
              parseTopLevel(t3, r) {
                return t3.program = this.parseProgram(r), t3.comments = this.state.comments, this.options.tokens && (t3.tokens = Th(this.tokens, this.input)), this.finishNode(t3, "File");
              }
              parseProgram(t3) {
                let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 137, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.options.sourceType;
                if (t3.sourceType = e, t3.interpreter = this.parseInterpreterDirective(), this.parseBlockBody(t3, true, true, r), this.inModule && !this.options.allowUndeclaredExports && this.scope.undefinedExports.size > 0)
                  for (let [i, a] of Array.from(this.scope.undefinedExports))
                    this.raise(f.ModuleExportUndefined, { at: a, localName: i });
                let s;
                return r === 137 ? s = this.finishNode(t3, "Program") : s = this.finishNodeAt(t3, "Program", Y(this.state.startLoc, -1)), s;
              }
              stmtToDirective(t3) {
                let r = t3;
                r.type = "Directive", r.value = r.expression, delete r.expression;
                let e = r.value, s = e.value, i = this.input.slice(e.start, e.end), a = e.value = i.slice(1, -1);
                return this.addExtra(e, "raw", i), this.addExtra(e, "rawValue", a), this.addExtra(e, "expressionValue", s), e.type = "DirectiveLiteral", r;
              }
              parseInterpreterDirective() {
                if (!this.match(28))
                  return null;
                let t3 = this.startNode();
                return t3.value = this.state.value, this.next(), this.finishNode(t3, "InterpreterDirective");
              }
              isLet() {
                return this.isContextual(99) ? this.hasFollowingBindingAtom() : false;
              }
              chStartsBindingIdentifier(t3, r) {
                if (fe(t3)) {
                  if (ps.lastIndex = r, ps.test(this.input)) {
                    let e = this.codePointAtPos(ps.lastIndex);
                    if (!De(e) && e !== 92)
                      return false;
                  }
                  return true;
                } else
                  return t3 === 92;
              }
              chStartsBindingPattern(t3) {
                return t3 === 91 || t3 === 123;
              }
              hasFollowingBindingAtom() {
                let t3 = this.nextTokenStart(), r = this.codePointAtPos(t3);
                return this.chStartsBindingPattern(r) || this.chStartsBindingIdentifier(r, t3);
              }
              hasFollowingBindingIdentifier() {
                let t3 = this.nextTokenStart(), r = this.codePointAtPos(t3);
                return this.chStartsBindingIdentifier(r, t3);
              }
              startsUsingForOf() {
                let t3 = this.lookahead();
                return t3.type === 101 && !t3.containsEsc ? false : (this.expectPlugin("explicitResourceManagement"), true);
              }
              parseModuleItem() {
                return this.parseStatementLike(15);
              }
              parseStatementListItem() {
                return this.parseStatementLike(6 | (!this.options.annexB || this.state.strict ? 0 : 8));
              }
              parseStatementOrSloppyAnnexBFunctionDeclaration() {
                let t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, r = 0;
                return this.options.annexB && !this.state.strict && (r |= 4, t3 && (r |= 8)), this.parseStatementLike(r);
              }
              parseStatement() {
                return this.parseStatementLike(0);
              }
              parseStatementLike(t3) {
                let r = null;
                return this.match(26) && (r = this.parseDecorators(true)), this.parseStatementContent(t3, r);
              }
              parseStatementContent(t3, r) {
                let e = this.state.type, s = this.startNode(), i = !!(t3 & 2), a = !!(t3 & 4), n = t3 & 1;
                switch (e) {
                  case 60:
                    return this.parseBreakContinueStatement(s, true);
                  case 63:
                    return this.parseBreakContinueStatement(s, false);
                  case 64:
                    return this.parseDebuggerStatement(s);
                  case 90:
                    return this.parseDoWhileStatement(s);
                  case 91:
                    return this.parseForStatement(s);
                  case 68:
                    if (this.lookaheadCharCode() === 46)
                      break;
                    return a || this.raise(this.state.strict ? f.StrictFunction : this.options.annexB ? f.SloppyFunctionAnnexB : f.SloppyFunction, { at: this.state.startLoc }), this.parseFunctionStatement(s, false, !i && a);
                  case 80:
                    return i || this.unexpected(), this.parseClass(this.maybeTakeDecorators(r, s), true);
                  case 69:
                    return this.parseIfStatement(s);
                  case 70:
                    return this.parseReturnStatement(s);
                  case 71:
                    return this.parseSwitchStatement(s);
                  case 72:
                    return this.parseThrowStatement(s);
                  case 73:
                    return this.parseTryStatement(s);
                  case 105:
                    if (this.hasFollowingLineBreak() || this.state.containsEsc || !this.hasFollowingBindingIdentifier())
                      break;
                    return this.expectPlugin("explicitResourceManagement"), !this.scope.inModule && this.scope.inTopLevel ? this.raise(f.UnexpectedUsingDeclaration, { at: this.state.startLoc }) : i || this.raise(f.UnexpectedLexicalDeclaration, { at: this.state.startLoc }), this.parseVarStatement(s, "using");
                  case 99: {
                    if (this.state.containsEsc)
                      break;
                    let c = this.nextTokenStart(), y = this.codePointAtPos(c);
                    if (y !== 91 && (!i && this.hasFollowingLineBreak() || !this.chStartsBindingIdentifier(y, c) && y !== 123))
                      break;
                  }
                  case 75:
                    i || this.raise(f.UnexpectedLexicalDeclaration, { at: this.state.startLoc });
                  case 74: {
                    let c = this.state.value;
                    return this.parseVarStatement(s, c);
                  }
                  case 92:
                    return this.parseWhileStatement(s);
                  case 76:
                    return this.parseWithStatement(s);
                  case 5:
                    return this.parseBlock();
                  case 13:
                    return this.parseEmptyStatement(s);
                  case 83: {
                    let c = this.lookaheadCharCode();
                    if (c === 40 || c === 46)
                      break;
                  }
                  case 82: {
                    !this.options.allowImportExportEverywhere && !n && this.raise(f.UnexpectedImportExport, { at: this.state.startLoc }), this.next();
                    let c;
                    return e === 83 ? (c = this.parseImport(s), c.type === "ImportDeclaration" && (!c.importKind || c.importKind === "value") && (this.sawUnambiguousESM = true)) : (c = this.parseExport(s, r), (c.type === "ExportNamedDeclaration" && (!c.exportKind || c.exportKind === "value") || c.type === "ExportAllDeclaration" && (!c.exportKind || c.exportKind === "value") || c.type === "ExportDefaultDeclaration") && (this.sawUnambiguousESM = true)), this.assertModuleNodeAllowed(c), c;
                  }
                  default:
                    if (this.isAsyncFunction())
                      return i || this.raise(f.AsyncFunctionInSingleStatementContext, { at: this.state.startLoc }), this.next(), this.parseFunctionStatement(s, true, !i && a);
                }
                let o = this.state.value, u = this.parseExpression();
                return q(e) && u.type === "Identifier" && this.eat(14) ? this.parseLabeledStatement(s, o, u, t3) : this.parseExpressionStatement(s, u, r);
              }
              assertModuleNodeAllowed(t3) {
                !this.options.allowImportExportEverywhere && !this.inModule && this.raise(f.ImportOutsideModule, { at: t3 });
              }
              decoratorsEnabledBeforeExport() {
                return this.hasPlugin("decorators-legacy") ? true : this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") !== false;
              }
              maybeTakeDecorators(t3, r, e) {
                return t3 && (r.decorators && r.decorators.length > 0 ? (typeof this.getPluginOption("decorators", "decoratorsBeforeExport") != "boolean" && this.raise(f.DecoratorsBeforeAfterExport, { at: r.decorators[0] }), r.decorators.unshift(...t3)) : r.decorators = t3, this.resetStartLocationFromNode(r, t3[0]), e && this.resetStartLocationFromNode(e, r)), r;
              }
              canHaveLeadingDecorator() {
                return this.match(80);
              }
              parseDecorators(t3) {
                let r = [];
                do
                  r.push(this.parseDecorator());
                while (this.match(26));
                if (this.match(82))
                  t3 || this.unexpected(), this.decoratorsEnabledBeforeExport() || this.raise(f.DecoratorExportClass, { at: this.state.startLoc });
                else if (!this.canHaveLeadingDecorator())
                  throw this.raise(f.UnexpectedLeadingDecorator, { at: this.state.startLoc });
                return r;
              }
              parseDecorator() {
                this.expectOnePlugin(["decorators", "decorators-legacy"]);
                let t3 = this.startNode();
                if (this.next(), this.hasPlugin("decorators")) {
                  let r = this.state.startLoc, e;
                  if (this.match(10)) {
                    let s = this.state.startLoc;
                    this.next(), e = this.parseExpression(), this.expect(11), e = this.wrapParenthesis(s, e);
                    let i = this.state.startLoc;
                    t3.expression = this.parseMaybeDecoratorArguments(e), this.getPluginOption("decorators", "allowCallParenthesized") === false && t3.expression !== e && this.raise(f.DecoratorArgumentsOutsideParentheses, { at: i });
                  } else {
                    for (e = this.parseIdentifier(false); this.eat(16); ) {
                      let s = this.startNodeAt(r);
                      s.object = e, this.match(136) ? (this.classScope.usePrivateName(this.state.value, this.state.startLoc), s.property = this.parsePrivateName()) : s.property = this.parseIdentifier(true), s.computed = false, e = this.finishNode(s, "MemberExpression");
                    }
                    t3.expression = this.parseMaybeDecoratorArguments(e);
                  }
                } else
                  t3.expression = this.parseExprSubscripts();
                return this.finishNode(t3, "Decorator");
              }
              parseMaybeDecoratorArguments(t3) {
                if (this.eat(10)) {
                  let r = this.startNodeAtNode(t3);
                  return r.callee = t3, r.arguments = this.parseCallExpressionArguments(11, false), this.toReferencedList(r.arguments), this.finishNode(r, "CallExpression");
                }
                return t3;
              }
              parseBreakContinueStatement(t3, r) {
                return this.next(), this.isLineTerminator() ? t3.label = null : (t3.label = this.parseIdentifier(), this.semicolon()), this.verifyBreakContinue(t3, r), this.finishNode(t3, r ? "BreakStatement" : "ContinueStatement");
              }
              verifyBreakContinue(t3, r) {
                let e;
                for (e = 0; e < this.state.labels.length; ++e) {
                  let s = this.state.labels[e];
                  if ((t3.label == null || s.name === t3.label.name) && (s.kind != null && (r || s.kind === "loop") || t3.label && r))
                    break;
                }
                if (e === this.state.labels.length) {
                  let s = r ? "BreakStatement" : "ContinueStatement";
                  this.raise(f.IllegalBreakContinue, { at: t3, type: s });
                }
              }
              parseDebuggerStatement(t3) {
                return this.next(), this.semicolon(), this.finishNode(t3, "DebuggerStatement");
              }
              parseHeaderExpression() {
                this.expect(10);
                let t3 = this.parseExpression();
                return this.expect(11), t3;
              }
              parseDoWhileStatement(t3) {
                return this.next(), this.state.labels.push(cs), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.state.labels.pop(), this.expect(92), t3.test = this.parseHeaderExpression(), this.eat(13), this.finishNode(t3, "DoWhileStatement");
              }
              parseForStatement(t3) {
                this.next(), this.state.labels.push(cs);
                let r = null;
                if (this.isAwaitAllowed() && this.eatContextual(96) && (r = this.state.lastTokStartLoc), this.scope.enter(Fe), this.expect(10), this.match(13))
                  return r !== null && this.unexpected(r), this.parseFor(t3, null);
                let e = this.isContextual(99), s = this.isContextual(105) && !this.hasFollowingLineBreak(), i = e && this.hasFollowingBindingAtom() || s && this.hasFollowingBindingIdentifier() && this.startsUsingForOf();
                if (this.match(74) || this.match(75) || i) {
                  let c = this.startNode(), y = this.state.value;
                  this.next(), this.parseVar(c, true, y);
                  let g = this.finishNode(c, "VariableDeclaration"), T = this.match(58);
                  return T && s && this.raise(f.ForInUsing, { at: g }), (T || this.isContextual(101)) && g.declarations.length === 1 ? this.parseForIn(t3, g, r) : (r !== null && this.unexpected(r), this.parseFor(t3, g));
                }
                let a = this.isContextual(95), n = new vt(), o = this.parseExpression(true, n), u = this.isContextual(101);
                if (u && (e && this.raise(f.ForOfLet, { at: o }), r === null && a && o.type === "Identifier" && this.raise(f.ForOfAsync, { at: o })), u || this.match(58)) {
                  this.checkDestructuringPrivate(n), this.toAssignable(o, true);
                  let c = u ? "ForOfStatement" : "ForInStatement";
                  return this.checkLVal(o, { in: { type: c } }), this.parseForIn(t3, o, r);
                } else
                  this.checkExpressionErrors(n, true);
                return r !== null && this.unexpected(r), this.parseFor(t3, o);
              }
              parseFunctionStatement(t3, r, e) {
                return this.next(), this.parseFunction(t3, 1 | (e ? 2 : 0) | (r ? 8 : 0));
              }
              parseIfStatement(t3) {
                return this.next(), t3.test = this.parseHeaderExpression(), t3.consequent = this.parseStatementOrSloppyAnnexBFunctionDeclaration(), t3.alternate = this.eat(66) ? this.parseStatementOrSloppyAnnexBFunctionDeclaration() : null, this.finishNode(t3, "IfStatement");
              }
              parseReturnStatement(t3) {
                return !this.prodParam.hasReturn && !this.options.allowReturnOutsideFunction && this.raise(f.IllegalReturn, { at: this.state.startLoc }), this.next(), this.isLineTerminator() ? t3.argument = null : (t3.argument = this.parseExpression(), this.semicolon()), this.finishNode(t3, "ReturnStatement");
              }
              parseSwitchStatement(t3) {
                this.next(), t3.discriminant = this.parseHeaderExpression();
                let r = t3.cases = [];
                this.expect(5), this.state.labels.push(Ph), this.scope.enter(Fe);
                let e;
                for (let s; !this.match(8); )
                  if (this.match(61) || this.match(65)) {
                    let i = this.match(61);
                    e && this.finishNode(e, "SwitchCase"), r.push(e = this.startNode()), e.consequent = [], this.next(), i ? e.test = this.parseExpression() : (s && this.raise(f.MultipleDefaultsInSwitch, { at: this.state.lastTokStartLoc }), s = true, e.test = null), this.expect(14);
                  } else
                    e ? e.consequent.push(this.parseStatementListItem()) : this.unexpected();
                return this.scope.exit(), e && this.finishNode(e, "SwitchCase"), this.next(), this.state.labels.pop(), this.finishNode(t3, "SwitchStatement");
              }
              parseThrowStatement(t3) {
                return this.next(), this.hasPrecedingLineBreak() && this.raise(f.NewlineAfterThrow, { at: this.state.lastTokEndLoc }), t3.argument = this.parseExpression(), this.semicolon(), this.finishNode(t3, "ThrowStatement");
              }
              parseCatchClauseParam() {
                let t3 = this.parseBindingAtom();
                return this.scope.enter(this.options.annexB && t3.type === "Identifier" ? gr : 0), this.checkLVal(t3, { in: { type: "CatchClause" }, binding: cl }), t3;
              }
              parseTryStatement(t3) {
                if (this.next(), t3.block = this.parseBlock(), t3.handler = null, this.match(62)) {
                  let r = this.startNode();
                  this.next(), this.match(10) ? (this.expect(10), r.param = this.parseCatchClauseParam(), this.expect(11)) : (r.param = null, this.scope.enter(Fe)), r.body = this.withSmartMixTopicForbiddingContext(() => this.parseBlock(false, false)), this.scope.exit(), t3.handler = this.finishNode(r, "CatchClause");
                }
                return t3.finalizer = this.eat(67) ? this.parseBlock() : null, !t3.handler && !t3.finalizer && this.raise(f.NoCatchOrFinally, { at: t3 }), this.finishNode(t3, "TryStatement");
              }
              parseVarStatement(t3, r) {
                let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                return this.next(), this.parseVar(t3, false, r, e), this.semicolon(), this.finishNode(t3, "VariableDeclaration");
              }
              parseWhileStatement(t3) {
                return this.next(), t3.test = this.parseHeaderExpression(), this.state.labels.push(cs), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.state.labels.pop(), this.finishNode(t3, "WhileStatement");
              }
              parseWithStatement(t3) {
                return this.state.strict && this.raise(f.StrictWith, { at: this.state.startLoc }), this.next(), t3.object = this.parseHeaderExpression(), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.finishNode(t3, "WithStatement");
              }
              parseEmptyStatement(t3) {
                return this.next(), this.finishNode(t3, "EmptyStatement");
              }
              parseLabeledStatement(t3, r, e, s) {
                for (let a of this.state.labels)
                  a.name === r && this.raise(f.LabelRedeclaration, { at: e, labelName: r });
                let i = Mo(this.state.type) ? "loop" : this.match(71) ? "switch" : null;
                for (let a = this.state.labels.length - 1; a >= 0; a--) {
                  let n = this.state.labels[a];
                  if (n.statementStart === t3.start)
                    n.statementStart = this.state.start, n.kind = i;
                  else
                    break;
                }
                return this.state.labels.push({ name: r, kind: i, statementStart: this.state.start }), t3.body = s & 8 ? this.parseStatementOrSloppyAnnexBFunctionDeclaration(true) : this.parseStatement(), this.state.labels.pop(), t3.label = e, this.finishNode(t3, "LabeledStatement");
              }
              parseExpressionStatement(t3, r, e) {
                return t3.expression = r, this.semicolon(), this.finishNode(t3, "ExpressionStatement");
              }
              parseBlock() {
                let t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, e = arguments.length > 2 ? arguments[2] : void 0, s = this.startNode();
                return t3 && this.state.strictErrors.clear(), this.expect(5), r && this.scope.enter(Fe), this.parseBlockBody(s, t3, false, 8, e), r && this.scope.exit(), this.finishNode(s, "BlockStatement");
              }
              isValidDirective(t3) {
                return t3.type === "ExpressionStatement" && t3.expression.type === "StringLiteral" && !t3.expression.extra.parenthesized;
              }
              parseBlockBody(t3, r, e, s, i) {
                let a = t3.body = [], n = t3.directives = [];
                this.parseBlockOrModuleBlockBody(a, r ? n : void 0, e, s, i);
              }
              parseBlockOrModuleBlockBody(t3, r, e, s, i) {
                let a = this.state.strict, n = false, o = false;
                for (; !this.match(s); ) {
                  let u = e ? this.parseModuleItem() : this.parseStatementListItem();
                  if (r && !o) {
                    if (this.isValidDirective(u)) {
                      let c = this.stmtToDirective(u);
                      r.push(c), !n && c.value.value === "use strict" && (n = true, this.setStrict(true));
                      continue;
                    }
                    o = true, this.state.strictErrors.clear();
                  }
                  t3.push(u);
                }
                i && i.call(this, n), a || this.setStrict(false), this.next();
              }
              parseFor(t3, r) {
                return t3.init = r, this.semicolon(false), t3.test = this.match(13) ? null : this.parseExpression(), this.semicolon(false), t3.update = this.match(11) ? null : this.parseExpression(), this.expect(11), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.scope.exit(), this.state.labels.pop(), this.finishNode(t3, "ForStatement");
              }
              parseForIn(t3, r, e) {
                let s = this.match(58);
                return this.next(), s ? e !== null && this.unexpected(e) : t3.await = e !== null, r.type === "VariableDeclaration" && r.declarations[0].init != null && (!s || !this.options.annexB || this.state.strict || r.kind !== "var" || r.declarations[0].id.type !== "Identifier") && this.raise(f.ForInOfLoopInitializer, { at: r, type: s ? "ForInStatement" : "ForOfStatement" }), r.type === "AssignmentPattern" && this.raise(f.InvalidLhs, { at: r, ancestor: { type: "ForStatement" } }), t3.left = r, t3.right = s ? this.parseExpression() : this.parseMaybeAssignAllowIn(), this.expect(11), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.scope.exit(), this.state.labels.pop(), this.finishNode(t3, s ? "ForInStatement" : "ForOfStatement");
              }
              parseVar(t3, r, e) {
                let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, i = t3.declarations = [];
                for (t3.kind = e; ; ) {
                  let a = this.startNode();
                  if (this.parseVarId(a, e), a.init = this.eat(29) ? r ? this.parseMaybeAssignDisallowIn() : this.parseMaybeAssignAllowIn() : null, a.init === null && !s && (a.id.type !== "Identifier" && !(r && (this.match(58) || this.isContextual(101))) ? this.raise(f.DeclarationMissingInitializer, { at: this.state.lastTokEndLoc, kind: "destructuring" }) : e === "const" && !(this.match(58) || this.isContextual(101)) && this.raise(f.DeclarationMissingInitializer, { at: this.state.lastTokEndLoc, kind: "const" })), i.push(this.finishNode(a, "VariableDeclarator")), !this.eat(12))
                    break;
                }
                return t3;
              }
              parseVarId(t3, r) {
                r === "using" && !this.inModule && this.match(96) && this.raise(f.AwaitInUsingBinding, { at: this.state.startLoc });
                let e = this.parseBindingAtom();
                this.checkLVal(e, { in: { type: "VariableDeclarator" }, binding: r === "var" ? mt : Be }), t3.id = e;
              }
              parseAsyncFunctionExpression(t3) {
                return this.parseFunction(t3, 8);
              }
              parseFunction(t3) {
                let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, e = r & 2, s = !!(r & 1), i = s && !(r & 4), a = !!(r & 8);
                this.initFunction(t3, a), this.match(55) && (e && this.raise(f.GeneratorInSingleStatementContext, { at: this.state.startLoc }), this.next(), t3.generator = true), s && (t3.id = this.parseFunctionId(i));
                let n = this.state.maybeInArrowParameters;
                return this.state.maybeInArrowParameters = false, this.scope.enter(de), this.prodParam.enter(Tt(a, t3.generator)), s || (t3.id = this.parseFunctionId()), this.parseFunctionParams(t3, false), this.withSmartMixTopicForbiddingContext(() => {
                  this.parseFunctionBodyAndFinish(t3, s ? "FunctionDeclaration" : "FunctionExpression");
                }), this.prodParam.exit(), this.scope.exit(), s && !e && this.registerFunctionStatementId(t3), this.state.maybeInArrowParameters = n, t3;
              }
              parseFunctionId(t3) {
                return t3 || q(this.state.type) ? this.parseIdentifier() : null;
              }
              parseFunctionParams(t3, r) {
                this.expect(10), this.expressionScope.enter(ql()), t3.params = this.parseBindingList(11, 41, 2 | (r ? 4 : 0)), this.expressionScope.exit();
              }
              registerFunctionStatementId(t3) {
                t3.id && this.scope.declareName(t3.id.name, !this.options.annexB || this.state.strict || t3.generator || t3.async ? this.scope.treatFunctionsAsVar ? mt : Be : Er, t3.id.loc.start);
              }
              parseClass(t3, r, e) {
                this.next();
                let s = this.state.strict;
                return this.state.strict = true, this.parseClassId(t3, r, e), this.parseClassSuper(t3), t3.body = this.parseClassBody(!!t3.superClass, s), this.finishNode(t3, r ? "ClassDeclaration" : "ClassExpression");
              }
              isClassProperty() {
                return this.match(29) || this.match(13) || this.match(8);
              }
              isClassMethod() {
                return this.match(10);
              }
              isNonstaticConstructor(t3) {
                return !t3.computed && !t3.static && (t3.key.name === "constructor" || t3.key.value === "constructor");
              }
              parseClassBody(t3, r) {
                this.classScope.enter();
                let e = { hadConstructor: false, hadSuperClass: t3 }, s = [], i = this.startNode();
                if (i.body = [], this.expect(5), this.withSmartMixTopicForbiddingContext(() => {
                  for (; !this.match(8); ) {
                    if (this.eat(13)) {
                      if (s.length > 0)
                        throw this.raise(f.DecoratorSemicolon, { at: this.state.lastTokEndLoc });
                      continue;
                    }
                    if (this.match(26)) {
                      s.push(this.parseDecorator());
                      continue;
                    }
                    let a = this.startNode();
                    s.length && (a.decorators = s, this.resetStartLocationFromNode(a, s[0]), s = []), this.parseClassMember(i, a, e), a.kind === "constructor" && a.decorators && a.decorators.length > 0 && this.raise(f.DecoratorConstructor, { at: a });
                  }
                }), this.state.strict = r, this.next(), s.length)
                  throw this.raise(f.TrailingDecorator, { at: this.state.startLoc });
                return this.classScope.exit(), this.finishNode(i, "ClassBody");
              }
              parseClassMemberFromModifier(t3, r) {
                let e = this.parseIdentifier(true);
                if (this.isClassMethod()) {
                  let s = r;
                  return s.kind = "method", s.computed = false, s.key = e, s.static = false, this.pushClassMethod(t3, s, false, false, false, false), true;
                } else if (this.isClassProperty()) {
                  let s = r;
                  return s.computed = false, s.key = e, s.static = false, t3.body.push(this.parseClassProperty(s)), true;
                }
                return this.resetPreviousNodeTrailingComments(e), false;
              }
              parseClassMember(t3, r, e) {
                let s = this.isContextual(104);
                if (s) {
                  if (this.parseClassMemberFromModifier(t3, r))
                    return;
                  if (this.eat(5)) {
                    this.parseClassStaticBlock(t3, r);
                    return;
                  }
                }
                this.parseClassMemberWithIsStatic(t3, r, e, s);
              }
              parseClassMemberWithIsStatic(t3, r, e, s) {
                let i = r, a = r, n = r, o = r, u = r, c = i, y = i;
                if (r.static = s, this.parsePropertyNamePrefixOperator(r), this.eat(55)) {
                  c.kind = "method";
                  let j = this.match(136);
                  if (this.parseClassElementName(c), j) {
                    this.pushClassPrivateMethod(t3, a, true, false);
                    return;
                  }
                  this.isNonstaticConstructor(i) && this.raise(f.ConstructorIsGenerator, { at: i.key }), this.pushClassMethod(t3, i, true, false, false, false);
                  return;
                }
                let g = q(this.state.type) && !this.state.containsEsc, T = this.match(136), C = this.parseClassElementName(r), M = this.state.startLoc;
                if (this.parsePostMemberNameModifiers(y), this.isClassMethod()) {
                  if (c.kind = "method", T) {
                    this.pushClassPrivateMethod(t3, a, false, false);
                    return;
                  }
                  let j = this.isNonstaticConstructor(i), K = false;
                  j && (i.kind = "constructor", e.hadConstructor && !this.hasPlugin("typescript") && this.raise(f.DuplicateConstructor, { at: C }), j && this.hasPlugin("typescript") && r.override && this.raise(f.OverrideOnConstructor, { at: C }), e.hadConstructor = true, K = e.hadSuperClass), this.pushClassMethod(t3, i, false, false, j, K);
                } else if (this.isClassProperty())
                  T ? this.pushClassPrivateProperty(t3, o) : this.pushClassProperty(t3, n);
                else if (g && C.name === "async" && !this.isLineTerminator()) {
                  this.resetPreviousNodeTrailingComments(C);
                  let j = this.eat(55);
                  y.optional && this.unexpected(M), c.kind = "method";
                  let K = this.match(136);
                  this.parseClassElementName(c), this.parsePostMemberNameModifiers(y), K ? this.pushClassPrivateMethod(t3, a, j, true) : (this.isNonstaticConstructor(i) && this.raise(f.ConstructorIsAsync, { at: i.key }), this.pushClassMethod(t3, i, j, true, false, false));
                } else if (g && (C.name === "get" || C.name === "set") && !(this.match(55) && this.isLineTerminator())) {
                  this.resetPreviousNodeTrailingComments(C), c.kind = C.name;
                  let j = this.match(136);
                  this.parseClassElementName(i), j ? this.pushClassPrivateMethod(t3, a, false, false) : (this.isNonstaticConstructor(i) && this.raise(f.ConstructorIsAccessor, { at: i.key }), this.pushClassMethod(t3, i, false, false, false, false)), this.checkGetterSetterParams(i);
                } else if (g && C.name === "accessor" && !this.isLineTerminator()) {
                  this.expectPlugin("decoratorAutoAccessors"), this.resetPreviousNodeTrailingComments(C);
                  let j = this.match(136);
                  this.parseClassElementName(n), this.pushClassAccessorProperty(t3, u, j);
                } else
                  this.isLineTerminator() ? T ? this.pushClassPrivateProperty(t3, o) : this.pushClassProperty(t3, n) : this.unexpected();
              }
              parseClassElementName(t3) {
                let { type: r, value: e } = this.state;
                if ((r === 130 || r === 131) && t3.static && e === "prototype" && this.raise(f.StaticPrototype, { at: this.state.startLoc }), r === 136) {
                  e === "constructor" && this.raise(f.ConstructorClassPrivateField, { at: this.state.startLoc });
                  let s = this.parsePrivateName();
                  return t3.key = s, s;
                }
                return this.parsePropertyName(t3);
              }
              parseClassStaticBlock(t3, r) {
                var e;
                this.scope.enter(Ee | ut | ht);
                let s = this.state.labels;
                this.state.labels = [], this.prodParam.enter(Me);
                let i = r.body = [];
                this.parseBlockOrModuleBlockBody(i, void 0, false, 8), this.prodParam.exit(), this.scope.exit(), this.state.labels = s, t3.body.push(this.finishNode(r, "StaticBlock")), (e = r.decorators) != null && e.length && this.raise(f.DecoratorStaticBlock, { at: r });
              }
              pushClassProperty(t3, r) {
                !r.computed && (r.key.name === "constructor" || r.key.value === "constructor") && this.raise(f.ConstructorClassField, { at: r.key }), t3.body.push(this.parseClassProperty(r));
              }
              pushClassPrivateProperty(t3, r) {
                let e = this.parseClassPrivateProperty(r);
                t3.body.push(e), this.classScope.declarePrivateName(this.getPrivateNameSV(e.key), ss, e.key.loc.start);
              }
              pushClassAccessorProperty(t3, r, e) {
                if (!e && !r.computed) {
                  let i = r.key;
                  (i.name === "constructor" || i.value === "constructor") && this.raise(f.ConstructorClassField, { at: i });
                }
                let s = this.parseClassAccessorProperty(r);
                t3.body.push(s), e && this.classScope.declarePrivateName(this.getPrivateNameSV(s.key), ss, s.key.loc.start);
              }
              pushClassMethod(t3, r, e, s, i, a) {
                t3.body.push(this.parseMethod(r, e, s, i, a, "ClassMethod", true));
              }
              pushClassPrivateMethod(t3, r, e, s) {
                let i = this.parseMethod(r, e, s, false, false, "ClassPrivateMethod", true);
                t3.body.push(i);
                let a = i.kind === "get" ? i.static ? gl : Al : i.kind === "set" ? i.static ? Pl : Tl : ss;
                this.declareClassPrivateMethodInScope(i, a);
              }
              declareClassPrivateMethodInScope(t3, r) {
                this.classScope.declarePrivateName(this.getPrivateNameSV(t3.key), r, t3.key.loc.start);
              }
              parsePostMemberNameModifiers(t3) {
              }
              parseClassPrivateProperty(t3) {
                return this.parseInitializer(t3), this.semicolon(), this.finishNode(t3, "ClassPrivateProperty");
              }
              parseClassProperty(t3) {
                return this.parseInitializer(t3), this.semicolon(), this.finishNode(t3, "ClassProperty");
              }
              parseClassAccessorProperty(t3) {
                return this.parseInitializer(t3), this.semicolon(), this.finishNode(t3, "ClassAccessorProperty");
              }
              parseInitializer(t3) {
                this.scope.enter(Ee | ht), this.expressionScope.enter(_r()), this.prodParam.enter(Me), t3.value = this.eat(29) ? this.parseMaybeAssignAllowIn() : null, this.expressionScope.exit(), this.prodParam.exit(), this.scope.exit();
              }
              parseClassId(t3, r, e) {
                let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : vr;
                if (q(this.state.type))
                  t3.id = this.parseIdentifier(), r && this.declareNameFromIdentifier(t3.id, s);
                else if (e || !r)
                  t3.id = null;
                else
                  throw this.raise(f.MissingClassName, { at: this.state.startLoc });
              }
              parseClassSuper(t3) {
                t3.superClass = this.eat(81) ? this.parseExprSubscripts() : null;
              }
              parseExport(t3, r) {
                let e = this.maybeParseExportDefaultSpecifier(t3), s = !e || this.eat(12), i = s && this.eatExportStar(t3), a = i && this.maybeParseExportNamespaceSpecifier(t3), n = s && (!a || this.eat(12)), o = e || i;
                if (i && !a) {
                  if (e && this.unexpected(), r)
                    throw this.raise(f.UnsupportedDecoratorExport, { at: t3 });
                  return this.parseExportFrom(t3, true), this.finishNode(t3, "ExportAllDeclaration");
                }
                let u = this.maybeParseExportNamedSpecifiers(t3);
                e && s && !i && !u && this.unexpected(null, 5), a && n && this.unexpected(null, 97);
                let c;
                if (o || u) {
                  if (c = false, r)
                    throw this.raise(f.UnsupportedDecoratorExport, { at: t3 });
                  this.parseExportFrom(t3, o);
                } else
                  c = this.maybeParseExportDeclaration(t3);
                if (o || u || c) {
                  var y;
                  let g = t3;
                  if (this.checkExport(g, true, false, !!g.source), ((y = g.declaration) == null ? void 0 : y.type) === "ClassDeclaration")
                    this.maybeTakeDecorators(r, g.declaration, g);
                  else if (r)
                    throw this.raise(f.UnsupportedDecoratorExport, { at: t3 });
                  return this.finishNode(g, "ExportNamedDeclaration");
                }
                if (this.eat(65)) {
                  let g = t3, T = this.parseExportDefaultExpression();
                  if (g.declaration = T, T.type === "ClassDeclaration")
                    this.maybeTakeDecorators(r, T, g);
                  else if (r)
                    throw this.raise(f.UnsupportedDecoratorExport, { at: t3 });
                  return this.checkExport(g, true, true), this.finishNode(g, "ExportDefaultDeclaration");
                }
                this.unexpected(null, 5);
              }
              eatExportStar(t3) {
                return this.eat(55);
              }
              maybeParseExportDefaultSpecifier(t3) {
                if (this.isExportDefaultSpecifier()) {
                  this.expectPlugin("exportDefaultFrom");
                  let r = this.startNode();
                  return r.exported = this.parseIdentifier(true), t3.specifiers = [this.finishNode(r, "ExportDefaultSpecifier")], true;
                }
                return false;
              }
              maybeParseExportNamespaceSpecifier(t3) {
                if (this.isContextual(93)) {
                  t3.specifiers || (t3.specifiers = []);
                  let r = this.startNodeAt(this.state.lastTokStartLoc);
                  return this.next(), r.exported = this.parseModuleExportName(), t3.specifiers.push(this.finishNode(r, "ExportNamespaceSpecifier")), true;
                }
                return false;
              }
              maybeParseExportNamedSpecifiers(t3) {
                if (this.match(5)) {
                  t3.specifiers || (t3.specifiers = []);
                  let r = t3.exportKind === "type";
                  return t3.specifiers.push(...this.parseExportSpecifiers(r)), t3.source = null, t3.declaration = null, this.hasPlugin("importAssertions") && (t3.assertions = []), true;
                }
                return false;
              }
              maybeParseExportDeclaration(t3) {
                return this.shouldParseExportDeclaration() ? (t3.specifiers = [], t3.source = null, this.hasPlugin("importAssertions") && (t3.assertions = []), t3.declaration = this.parseExportDeclaration(t3), true) : false;
              }
              isAsyncFunction() {
                if (!this.isContextual(95))
                  return false;
                let t3 = this.nextTokenStart();
                return !as.test(this.input.slice(this.state.pos, t3)) && this.isUnparsedContextual(t3, "function");
              }
              parseExportDefaultExpression() {
                let t3 = this.startNode();
                if (this.match(68))
                  return this.next(), this.parseFunction(t3, 5);
                if (this.isAsyncFunction())
                  return this.next(), this.next(), this.parseFunction(t3, 13);
                if (this.match(80))
                  return this.parseClass(t3, true, true);
                if (this.match(26))
                  return this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") === true && this.raise(f.DecoratorBeforeExport, { at: this.state.startLoc }), this.parseClass(this.maybeTakeDecorators(this.parseDecorators(false), this.startNode()), true, true);
                if (this.match(75) || this.match(74) || this.isLet())
                  throw this.raise(f.UnsupportedDefaultExport, { at: this.state.startLoc });
                let r = this.parseMaybeAssignAllowIn();
                return this.semicolon(), r;
              }
              parseExportDeclaration(t3) {
                return this.match(80) ? this.parseClass(this.startNode(), true, false) : this.parseStatementListItem();
              }
              isExportDefaultSpecifier() {
                let { type: t3 } = this.state;
                if (q(t3)) {
                  if (t3 === 95 && !this.state.containsEsc || t3 === 99)
                    return false;
                  if ((t3 === 128 || t3 === 127) && !this.state.containsEsc) {
                    let { type: s } = this.lookahead();
                    if (q(s) && s !== 97 || s === 5)
                      return this.expectOnePlugin(["flow", "typescript"]), false;
                  }
                } else if (!this.match(65))
                  return false;
                let r = this.nextTokenStart(), e = this.isUnparsedContextual(r, "from");
                if (this.input.charCodeAt(r) === 44 || q(this.state.type) && e)
                  return true;
                if (this.match(65) && e) {
                  let s = this.input.charCodeAt(this.nextTokenStartSince(r + 4));
                  return s === 34 || s === 39;
                }
                return false;
              }
              parseExportFrom(t3, r) {
                if (this.eatContextual(97)) {
                  t3.source = this.parseImportSource(), this.checkExport(t3);
                  let e = this.maybeParseImportAssertions();
                  e && (t3.assertions = e, this.checkJSONModuleImport(t3));
                } else
                  r && this.unexpected();
                this.semicolon();
              }
              shouldParseExportDeclaration() {
                let { type: t3 } = this.state;
                return t3 === 26 && (this.expectOnePlugin(["decorators", "decorators-legacy"]), this.hasPlugin("decorators")) ? (this.getPluginOption("decorators", "decoratorsBeforeExport") === true && this.raise(f.DecoratorBeforeExport, { at: this.state.startLoc }), true) : t3 === 74 || t3 === 75 || t3 === 68 || t3 === 80 || this.isLet() || this.isAsyncFunction();
              }
              checkExport(t3, r, e, s) {
                if (r) {
                  if (e) {
                    if (this.checkDuplicateExports(t3, "default"), this.hasPlugin("exportDefaultFrom")) {
                      var i;
                      let a = t3.declaration;
                      a.type === "Identifier" && a.name === "from" && a.end - a.start === 4 && !((i = a.extra) != null && i.parenthesized) && this.raise(f.ExportDefaultFromAsIdentifier, { at: a });
                    }
                  } else if (t3.specifiers && t3.specifiers.length)
                    for (let a of t3.specifiers) {
                      let { exported: n } = a, o = n.type === "Identifier" ? n.name : n.value;
                      if (this.checkDuplicateExports(a, o), !s && a.local) {
                        let { local: u } = a;
                        u.type !== "Identifier" ? this.raise(f.ExportBindingIsString, { at: a, localName: u.value, exportName: o }) : (this.checkReservedWord(u.name, u.loc.start, true, false), this.scope.checkLocalExport(u));
                      }
                    }
                  else if (t3.declaration) {
                    if (t3.declaration.type === "FunctionDeclaration" || t3.declaration.type === "ClassDeclaration") {
                      let a = t3.declaration.id;
                      if (!a)
                        throw new Error("Assertion failure");
                      this.checkDuplicateExports(t3, a.name);
                    } else if (t3.declaration.type === "VariableDeclaration")
                      for (let a of t3.declaration.declarations)
                        this.checkDeclaration(a.id);
                  }
                }
              }
              checkDeclaration(t3) {
                if (t3.type === "Identifier")
                  this.checkDuplicateExports(t3, t3.name);
                else if (t3.type === "ObjectPattern")
                  for (let r of t3.properties)
                    this.checkDeclaration(r);
                else if (t3.type === "ArrayPattern")
                  for (let r of t3.elements)
                    r && this.checkDeclaration(r);
                else
                  t3.type === "ObjectProperty" ? this.checkDeclaration(t3.value) : t3.type === "RestElement" ? this.checkDeclaration(t3.argument) : t3.type === "AssignmentPattern" && this.checkDeclaration(t3.left);
              }
              checkDuplicateExports(t3, r) {
                this.exportedIdentifiers.has(r) && (r === "default" ? this.raise(f.DuplicateDefaultExport, { at: t3 }) : this.raise(f.DuplicateExport, { at: t3, exportName: r })), this.exportedIdentifiers.add(r);
              }
              parseExportSpecifiers(t3) {
                let r = [], e = true;
                for (this.expect(5); !this.eat(8); ) {
                  if (e)
                    e = false;
                  else if (this.expect(12), this.eat(8))
                    break;
                  let s = this.isContextual(128), i = this.match(131), a = this.startNode();
                  a.local = this.parseModuleExportName(), r.push(this.parseExportSpecifier(a, i, t3, s));
                }
                return r;
              }
              parseExportSpecifier(t3, r, e, s) {
                return this.eatContextual(93) ? t3.exported = this.parseModuleExportName() : r ? t3.exported = Kl(t3.local) : t3.exported || (t3.exported = me(t3.local)), this.finishNode(t3, "ExportSpecifier");
              }
              parseModuleExportName() {
                if (this.match(131)) {
                  let t3 = this.parseStringLiteral(this.state.value), r = t3.value.match(Ah);
                  return r && this.raise(f.ModuleExportNameHasLoneSurrogate, { at: t3, surrogateCharCode: r[0].charCodeAt(0) }), t3;
                }
                return this.parseIdentifier(true);
              }
              isJSONModuleImport(t3) {
                return t3.assertions != null ? t3.assertions.some((r) => {
                  let { key: e, value: s } = r;
                  return s.value === "json" && (e.type === "Identifier" ? e.name === "type" : e.value === "type");
                }) : false;
              }
              checkImportReflection(t3) {
                if (t3.module) {
                  var r;
                  (t3.specifiers.length !== 1 || t3.specifiers[0].type !== "ImportDefaultSpecifier") && this.raise(f.ImportReflectionNotBinding, { at: t3.specifiers[0].loc.start }), ((r = t3.assertions) == null ? void 0 : r.length) > 0 && this.raise(f.ImportReflectionHasAssertion, { at: t3.specifiers[0].loc.start });
                }
              }
              checkJSONModuleImport(t3) {
                if (this.isJSONModuleImport(t3) && t3.type !== "ExportAllDeclaration") {
                  let { specifiers: r } = t3;
                  if (r != null) {
                    let e = r.find((s) => {
                      let i;
                      if (s.type === "ExportSpecifier" ? i = s.local : s.type === "ImportSpecifier" && (i = s.imported), i !== void 0)
                        return i.type === "Identifier" ? i.name !== "default" : i.value !== "default";
                    });
                    e !== void 0 && this.raise(f.ImportJSONBindingNotDefault, { at: e.loc.start });
                  }
                }
              }
              parseMaybeImportReflection(t3) {
                let r = false;
                if (this.isContextual(125)) {
                  let e = this.lookahead(), s = e.type;
                  q(s) ? (s !== 97 || this.input.charCodeAt(this.nextTokenStartSince(e.end)) === 102) && (r = true) : s !== 12 && (r = true);
                }
                r ? (this.expectPlugin("importReflection"), this.next(), t3.module = true) : this.hasPlugin("importReflection") && (t3.module = false);
              }
              parseImport(t3) {
                if (t3.specifiers = [], !this.match(131)) {
                  this.parseMaybeImportReflection(t3);
                  let s = !this.maybeParseDefaultImportSpecifier(t3) || this.eat(12), i = s && this.maybeParseStarImportSpecifier(t3);
                  s && !i && this.parseNamedImportSpecifiers(t3), this.expectContextual(97);
                }
                t3.source = this.parseImportSource();
                let r = this.maybeParseImportAssertions();
                if (r)
                  t3.assertions = r;
                else {
                  let e = this.maybeParseModuleAttributes();
                  e && (t3.attributes = e);
                }
                return this.checkImportReflection(t3), this.checkJSONModuleImport(t3), this.semicolon(), this.finishNode(t3, "ImportDeclaration");
              }
              parseImportSource() {
                return this.match(131) || this.unexpected(), this.parseExprAtom();
              }
              shouldParseDefaultImport(t3) {
                return q(this.state.type);
              }
              parseImportSpecifierLocal(t3, r, e) {
                r.local = this.parseIdentifier(), t3.specifiers.push(this.finishImportSpecifier(r, e));
              }
              finishImportSpecifier(t3, r) {
                let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Be;
                return this.checkLVal(t3.local, { in: { type: r }, binding: e }), this.finishNode(t3, r);
              }
              parseAssertEntries() {
                let t3 = [], r = /* @__PURE__ */ new Set();
                do {
                  if (this.match(8))
                    break;
                  let e = this.startNode(), s = this.state.value;
                  if (r.has(s) && this.raise(f.ModuleAttributesWithDuplicateKeys, { at: this.state.startLoc, key: s }), r.add(s), this.match(131) ? e.key = this.parseStringLiteral(s) : e.key = this.parseIdentifier(true), this.expect(14), !this.match(131))
                    throw this.raise(f.ModuleAttributeInvalidValue, { at: this.state.startLoc });
                  e.value = this.parseStringLiteral(this.state.value), t3.push(this.finishNode(e, "ImportAttribute"));
                } while (this.eat(12));
                return t3;
              }
              maybeParseModuleAttributes() {
                if (this.match(76) && !this.hasPrecedingLineBreak())
                  this.expectPlugin("moduleAttributes"), this.next();
                else
                  return this.hasPlugin("moduleAttributes") ? [] : null;
                let t3 = [], r = /* @__PURE__ */ new Set();
                do {
                  let e = this.startNode();
                  if (e.key = this.parseIdentifier(true), e.key.name !== "type" && this.raise(f.ModuleAttributeDifferentFromType, { at: e.key }), r.has(e.key.name) && this.raise(f.ModuleAttributesWithDuplicateKeys, { at: e.key, key: e.key.name }), r.add(e.key.name), this.expect(14), !this.match(131))
                    throw this.raise(f.ModuleAttributeInvalidValue, { at: this.state.startLoc });
                  e.value = this.parseStringLiteral(this.state.value), this.finishNode(e, "ImportAttribute"), t3.push(e);
                } while (this.eat(12));
                return t3;
              }
              maybeParseImportAssertions() {
                if (this.isContextual(94) && !this.hasPrecedingLineBreak())
                  this.expectPlugin("importAssertions"), this.next();
                else
                  return this.hasPlugin("importAssertions") ? [] : null;
                this.eat(5);
                let t3 = this.parseAssertEntries();
                return this.eat(8), t3;
              }
              maybeParseDefaultImportSpecifier(t3) {
                return this.shouldParseDefaultImport(t3) ? (this.parseImportSpecifierLocal(t3, this.startNode(), "ImportDefaultSpecifier"), true) : false;
              }
              maybeParseStarImportSpecifier(t3) {
                if (this.match(55)) {
                  let r = this.startNode();
                  return this.next(), this.expectContextual(93), this.parseImportSpecifierLocal(t3, r, "ImportNamespaceSpecifier"), true;
                }
                return false;
              }
              parseNamedImportSpecifiers(t3) {
                let r = true;
                for (this.expect(5); !this.eat(8); ) {
                  if (r)
                    r = false;
                  else {
                    if (this.eat(14))
                      throw this.raise(f.DestructureNamedImport, { at: this.state.startLoc });
                    if (this.expect(12), this.eat(8))
                      break;
                  }
                  let e = this.startNode(), s = this.match(131), i = this.isContextual(128);
                  e.imported = this.parseModuleExportName();
                  let a = this.parseImportSpecifier(e, s, t3.importKind === "type" || t3.importKind === "typeof", i, void 0);
                  t3.specifiers.push(a);
                }
              }
              parseImportSpecifier(t3, r, e, s, i) {
                if (this.eatContextual(93))
                  t3.local = this.parseIdentifier();
                else {
                  let { imported: a } = t3;
                  if (r)
                    throw this.raise(f.ImportBindingIsString, { at: t3, importName: a.value });
                  this.checkReservedWord(a.name, t3.loc.start, true, true), t3.local || (t3.local = me(a));
                }
                return this.finishImportSpecifier(t3, "ImportSpecifier", i);
              }
              isThisParam(t3) {
                return t3.type === "Identifier" && t3.name === "this";
              }
            }, Yr = class extends vh {
              constructor(t3, r) {
                t3 = p(t3), super(t3, r), this.options = t3, this.initializeScopes(), this.plugins = Eh(this.options.plugins), this.filename = t3.sourceFilename;
              }
              getScopeHandler() {
                return is;
              }
              parse() {
                this.enterInitialScopes();
                let t3 = this.startNode(), r = this.startNode();
                return this.nextToken(), t3.errors = null, this.parseTopLevel(t3, r), t3.errors = this.state.errors, t3;
              }
            };
            function Eh(t3) {
              let r = /* @__PURE__ */ new Map();
              for (let e of t3) {
                let [s, i] = Array.isArray(e) ? e : [e, {}];
                r.has(s) || r.set(s, i || {});
              }
              return r;
            }
            function Ch(t3, r) {
              var e;
              if (((e = r) == null ? void 0 : e.sourceType) === "unambiguous") {
                r = Object.assign({}, r);
                try {
                  r.sourceType = "module";
                  let s = Xe(r, t3), i = s.parse();
                  if (s.sawUnambiguousESM)
                    return i;
                  if (s.ambiguousScriptDifferentAst)
                    try {
                      return r.sourceType = "script", Xe(r, t3).parse();
                    } catch {
                    }
                  else
                    i.program.sourceType = "script";
                  return i;
                } catch (s) {
                  try {
                    return r.sourceType = "script", Xe(r, t3).parse();
                  } catch {
                  }
                  throw s;
                }
              } else
                return Xe(r, t3).parse();
            }
            function bh(t3, r) {
              let e = Xe(r, t3);
              return e.options.strictMode && (e.state.strict = true), e.getExpression();
            }
            function Sh(t3) {
              let r = {};
              for (let e of Object.keys(t3))
                r[e] = ce(t3[e]);
              return r;
            }
            var wh = Sh(Z);
            function Xe(t3, r) {
              let e = Yr;
              return t3 != null && t3.plugins && (yh(t3.plugins), e = Ih(t3.plugins)), new e(t3, r);
            }
            var Qr = {};
            function Ih(t3) {
              let r = xh.filter((i) => J(t3, i)), e = r.join("/"), s = Qr[e];
              if (!s) {
                s = Yr;
                for (let i of r)
                  s = Xr[i](s);
                Qr[e] = s;
              }
              return s;
            }
            l.parse = Ch, l.parseExpression = bh, l.tokTypes = wh;
          } }), Xf = $({ "src/language-js/parse/json.js"(l, h) {
            "use strict";
            U();
            var p = Io(), d = lr(), x = ko(), P = Do();
            function m() {
              let w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, { allowComments: L = true } = w;
              return function(_) {
                let { parseExpression: G } = Fo(), N;
                try {
                  N = G(_, { tokens: true, ranges: true });
                } catch (O) {
                  throw P(O);
                }
                if (!L && p(N.comments))
                  throw v(N.comments[0], "Comment");
                return S(N), N;
              };
            }
            function v(w, L) {
              let [A, _] = [w.loc.start, w.loc.end].map((G) => {
                let { line: N, column: O } = G;
                return { line: N, column: O + 1 };
              });
              return d(`${L} is not allowed in JSON.`, { start: A, end: _ });
            }
            function S(w) {
              switch (w.type) {
                case "ArrayExpression":
                  for (let L of w.elements)
                    L !== null && S(L);
                  return;
                case "ObjectExpression":
                  for (let L of w.properties)
                    S(L);
                  return;
                case "ObjectProperty":
                  if (w.computed)
                    throw v(w.key, "Computed key");
                  if (w.shorthand)
                    throw v(w.key, "Shorthand property");
                  w.key.type !== "Identifier" && S(w.key), S(w.value);
                  return;
                case "UnaryExpression": {
                  let { operator: L, argument: A } = w;
                  if (L !== "+" && L !== "-")
                    throw v(w, `Operator '${w.operator}'`);
                  if (A.type === "NumericLiteral" || A.type === "Identifier" && (A.name === "Infinity" || A.name === "NaN"))
                    return;
                  throw v(A, `Operator '${L}' before '${A.type}'`);
                }
                case "Identifier":
                  if (w.name !== "Infinity" && w.name !== "NaN" && w.name !== "undefined")
                    throw v(w, `Identifier '${w.name}'`);
                  return;
                case "TemplateLiteral":
                  if (p(w.expressions))
                    throw v(w.expressions[0], "'TemplateLiteral' with expression");
                  for (let L of w.quasis)
                    S(L);
                  return;
                case "NullLiteral":
                case "BooleanLiteral":
                case "NumericLiteral":
                case "StringLiteral":
                case "TemplateElement":
                  return;
                default:
                  throw v(w, `'${w.type}'`);
              }
            }
            var k = m(), F = { json: x({ parse: k, hasPragma() {
              return true;
            } }), json5: x(k), "json-stringify": x({ parse: m({ allowComments: false }), astFormat: "estree-json" }) };
            h.exports = F;
          } });
          U();
          var Yf = kf(), Qf = po(), Zf = Of(), Ue = ko(), ed = Do(), td = Jf(), sd = Xf(), rd = { sourceType: "module", allowImportExportEverywhere: true, allowReturnOutsideFunction: true, allowSuperOutsideMethod: true, allowUndeclaredExports: true, errorRecovery: true, createParenthesizedExpressions: true, plugins: ["doExpressions", "exportDefaultFrom", "functionBind", "functionSent", "throwExpressions", "partialApplication", ["decorators", { decoratorsBeforeExport: false }], "importAssertions", "decimal", "moduleBlocks", "asyncDoExpressions", "regexpUnicodeSets", "destructuringPrivate", "decoratorAutoAccessors"], tokens: true, ranges: true }, id = ["recordAndTuple", { syntaxType: "hash" }], no = "v8intrinsic", oo = [["pipelineOperator", { proposal: "hack", topicToken: "%" }], ["pipelineOperator", { proposal: "minimal" }], ["pipelineOperator", { proposal: "fsharp" }]], he = function(l) {
            let h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : rd;
            return Object.assign(Object.assign({}, h), {}, { plugins: [...h.plugins, ...l] });
          }, ad = /@(?:no)?flow\b/;
          function nd(l, h) {
            if (h.filepath && h.filepath.endsWith(".js.flow"))
              return true;
            let p = Qf(l);
            p && (l = l.slice(p.length));
            let d = Zf(l, 0);
            return d !== false && (l = l.slice(0, d)), ad.test(l);
          }
          function od(l, h, p) {
            let d = Fo()[l], x = d(h, p), P = x.errors.find((m) => !fd.has(m.reasonCode));
            if (P)
              throw P;
            return x;
          }
          function $e(l) {
            for (var h = arguments.length, p = new Array(h > 1 ? h - 1 : 0), d = 1; d < h; d++)
              p[d - 1] = arguments[d];
            return function(x, P) {
              let m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              if ((m.parser === "babel" || m.parser === "__babel_estree") && nd(x, m))
                return m.parser = "babel-flow", Lo(x, P, m);
              let v = p;
              m.__babelSourceType === "script" && (v = v.map((w) => Object.assign(Object.assign({}, w), {}, { sourceType: "script" }))), /#[[{]/.test(x) && (v = v.map((w) => he([id], w)));
              let S = /%[A-Z]/.test(x);
              x.includes("|>") ? v = (S ? [...oo, no] : oo).flatMap((L) => v.map((A) => he([L], A))) : S && (v = v.map((w) => he([no], w)));
              let { result: k, error: F } = Yf(...v.map((w) => () => od(l, x, w)));
              if (!k)
                throw ed(F);
              return m.originalText = x, td(k, m);
            };
          }
          var ld = $e("parse", he(["jsx", "flow"])), Lo = $e("parse", he(["jsx", ["flow", { all: true, enums: true }]])), hd = $e("parse", he(["jsx", "typescript"]), he(["typescript"])), ud = $e("parse", he(["jsx", "flow", "estree"])), cd = $e("parseExpression", he(["jsx"])), pd = $e("parseExpression", he(["typescript"])), fd = /* @__PURE__ */ new Set(["StrictNumericEscape", "StrictWith", "StrictOctalLiteral", "StrictDelete", "StrictEvalArguments", "StrictEvalArgumentsBinding", "StrictFunction", "EmptyTypeArguments", "EmptyTypeParameters", "ConstructorHasTypeParameters", "UnsupportedParameterPropertyKind", "UnexpectedParameterModifier", "MixedLabeledAndUnlabeledElements", "InvalidTupleMemberLabel", "NonClassMethodPropertyHasAbstractModifer", "ReadonlyForMethodSignature", "ClassMethodHasDeclare", "ClassMethodHasReadonly", "InvalidModifierOnTypeMember", "DuplicateAccessibilityModifier", "IndexSignatureHasDeclare", "DecoratorExportClass", "ParamDupe", "InvalidDecimal", "RestTrailingComma", "UnsupportedParameterDecorator", "UnterminatedJsxContent", "UnexpectedReservedWord", "ModuleAttributesWithDuplicateKeys", "LineTerminatorBeforeArrow", "InvalidEscapeSequenceTemplate", "NonAbstractClassHasAbstractMethod", "UnsupportedPropertyDecorator", "OptionalTypeBeforeRequired", "PatternIsOptional", "OptionalBindingPattern", "DeclareClassFieldHasInitializer", "TypeImportCannotSpecifyDefaultAndNamed", "DeclareFunctionHasImplementation", "ConstructorClassField", "VarRedeclaration", "InvalidPrivateFieldResolution", "DuplicateExport"]), lo = Ue(ld), ho = Ue(hd), uo = Ue(cd), dd = Ue(pd);
          Oo.exports = { parsers: Object.assign(Object.assign({ babel: lo, "babel-flow": Ue(Lo), "babel-ts": ho }, sd), {}, { __js_expression: uo, __vue_expression: uo, __vue_ts_expression: dd, __vue_event_binding: lo, __vue_ts_event_binding: ho, __babel_estree: Ue(ud) }) };
        });
        return md();
      });
    }
  });

  // ../../node_modules/.pnpm/prettier@2.8.8/node_modules/prettier/parser-postcss.js
  var require_parser_postcss = __commonJS({
    "../../node_modules/.pnpm/prettier@2.8.8/node_modules/prettier/parser-postcss.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      (function(e) {
        if (typeof exports8 == "object" && typeof module2 == "object")
          module2.exports = e();
        else if (typeof define == "function" && define.amd)
          define(e);
        else {
          var i = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : typeof self < "u" ? self : this || {};
          i.prettierPlugins = i.prettierPlugins || {}, i.prettierPlugins.postcss = e();
        }
      })(function() {
        "use strict";
        var U = (e, n) => () => (n || e((n = { exports: {} }).exports, n), n.exports);
        var pe = U((wp, Gt) => {
          var er = function(e) {
            return e && e.Math == Math && e;
          };
          Gt.exports = er(typeof globalThis == "object" && globalThis) || er(typeof window == "object" && window) || er(typeof self == "object" && self) || er(typeof global == "object" && global) || function() {
            return this;
          }() || Function("return this")();
        });
        var be = U((_p, Ht) => {
          Ht.exports = function(e) {
            try {
              return !!e();
            } catch {
              return true;
            }
          };
        });
        var Oe = U((bp, Jt) => {
          var _a = be();
          Jt.exports = !_a(function() {
            return Object.defineProperty({}, 1, { get: function() {
              return 7;
            } })[1] != 7;
          });
        });
        var Tr = U((xp, Kt) => {
          var ba = be();
          Kt.exports = !ba(function() {
            var e = function() {
            }.bind();
            return typeof e != "function" || e.hasOwnProperty("prototype");
          });
        });
        var tr = U((Sp, Qt) => {
          var xa = Tr(), rr = Function.prototype.call;
          Qt.exports = xa ? rr.bind(rr) : function() {
            return rr.apply(rr, arguments);
          };
        });
        var en = U((Zt) => {
          "use strict";
          var Yt = {}.propertyIsEnumerable, Xt = Object.getOwnPropertyDescriptor, Sa = Xt && !Yt.call({ 1: 2 }, 1);
          Zt.f = Sa ? function(n) {
            var i = Xt(this, n);
            return !!i && i.enumerable;
          } : Yt;
        });
        var Er = U((Op, rn) => {
          rn.exports = function(e, n) {
            return { enumerable: !(e & 1), configurable: !(e & 2), writable: !(e & 4), value: n };
          };
        });
        var xe = U((Tp, sn) => {
          var tn = Tr(), nn = Function.prototype, qr = nn.call, ka = tn && nn.bind.bind(qr, qr);
          sn.exports = tn ? ka : function(e) {
            return function() {
              return qr.apply(e, arguments);
            };
          };
        });
        var un = U((Ep, an) => {
          var on3 = xe(), Oa = on3({}.toString), Ta = on3("".slice);
          an.exports = function(e) {
            return Ta(Oa(e), 8, -1);
          };
        });
        var ln = U((qp, cn) => {
          var Ea = xe(), qa = be(), Aa = un(), Ar = Object, Pa = Ea("".split);
          cn.exports = qa(function() {
            return !Ar("z").propertyIsEnumerable(0);
          }) ? function(e) {
            return Aa(e) == "String" ? Pa(e, "") : Ar(e);
          } : Ar;
        });
        var Pr = U((Ap, fn) => {
          fn.exports = function(e) {
            return e == null;
          };
        });
        var Ir = U((Pp, pn) => {
          var Ia = Pr(), Ra = TypeError;
          pn.exports = function(e) {
            if (Ia(e))
              throw Ra("Can't call method on " + e);
            return e;
          };
        });
        var nr = U((Ip, hn) => {
          var Ca = ln(), Na = Ir();
          hn.exports = function(e) {
            return Ca(Na(e));
          };
        });
        var Cr = U((Rp, dn) => {
          var Rr = typeof document == "object" && document.all, ja = typeof Rr > "u" && Rr !== void 0;
          dn.exports = { all: Rr, IS_HTMLDDA: ja };
        });
        var he = U((Cp, mn) => {
          var vn = Cr(), Ma = vn.all;
          mn.exports = vn.IS_HTMLDDA ? function(e) {
            return typeof e == "function" || e === Ma;
          } : function(e) {
            return typeof e == "function";
          };
        });
        var Me = U((Np, wn) => {
          var gn = he(), yn = Cr(), Da = yn.all;
          wn.exports = yn.IS_HTMLDDA ? function(e) {
            return typeof e == "object" ? e !== null : gn(e) || e === Da;
          } : function(e) {
            return typeof e == "object" ? e !== null : gn(e);
          };
        });
        var ir = U((jp, _n) => {
          var Nr = pe(), La = he(), za = function(e) {
            return La(e) ? e : void 0;
          };
          _n.exports = function(e, n) {
            return arguments.length < 2 ? za(Nr[e]) : Nr[e] && Nr[e][n];
          };
        });
        var xn = U((Mp, bn) => {
          var Ba = xe();
          bn.exports = Ba({}.isPrototypeOf);
        });
        var kn = U((Dp, Sn) => {
          var Fa = ir();
          Sn.exports = Fa("navigator", "userAgent") || "";
        });
        var In = U((Lp, Pn) => {
          var An = pe(), jr = kn(), On = An.process, Tn = An.Deno, En = On && On.versions || Tn && Tn.version, qn = En && En.v8, de, sr;
          qn && (de = qn.split("."), sr = de[0] > 0 && de[0] < 4 ? 1 : +(de[0] + de[1]));
          !sr && jr && (de = jr.match(/Edge\/(\d+)/), (!de || de[1] >= 74) && (de = jr.match(/Chrome\/(\d+)/), de && (sr = +de[1])));
          Pn.exports = sr;
        });
        var Mr = U((zp, Cn) => {
          var Rn = In(), Ua = be();
          Cn.exports = !!Object.getOwnPropertySymbols && !Ua(function() {
            var e = Symbol();
            return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && Rn && Rn < 41;
          });
        });
        var Dr = U((Bp, Nn) => {
          var $a = Mr();
          Nn.exports = $a && !Symbol.sham && typeof Symbol.iterator == "symbol";
        });
        var Lr = U((Fp, jn) => {
          var Wa = ir(), Va = he(), Ga = xn(), Ha = Dr(), Ja = Object;
          jn.exports = Ha ? function(e) {
            return typeof e == "symbol";
          } : function(e) {
            var n = Wa("Symbol");
            return Va(n) && Ga(n.prototype, Ja(e));
          };
        });
        var Dn = U((Up, Mn) => {
          var Ka = String;
          Mn.exports = function(e) {
            try {
              return Ka(e);
            } catch {
              return "Object";
            }
          };
        });
        var zn = U(($p, Ln) => {
          var Qa = he(), Ya = Dn(), Xa = TypeError;
          Ln.exports = function(e) {
            if (Qa(e))
              return e;
            throw Xa(Ya(e) + " is not a function");
          };
        });
        var Fn = U((Wp, Bn) => {
          var Za = zn(), eu = Pr();
          Bn.exports = function(e, n) {
            var i = e[n];
            return eu(i) ? void 0 : Za(i);
          };
        });
        var $n = U((Vp, Un) => {
          var zr = tr(), Br = he(), Fr = Me(), ru = TypeError;
          Un.exports = function(e, n) {
            var i, u;
            if (n === "string" && Br(i = e.toString) && !Fr(u = zr(i, e)) || Br(i = e.valueOf) && !Fr(u = zr(i, e)) || n !== "string" && Br(i = e.toString) && !Fr(u = zr(i, e)))
              return u;
            throw ru("Can't convert object to primitive value");
          };
        });
        var Vn = U((Gp, Wn) => {
          Wn.exports = false;
        });
        var or = U((Hp, Hn) => {
          var Gn = pe(), tu = Object.defineProperty;
          Hn.exports = function(e, n) {
            try {
              tu(Gn, e, { value: n, configurable: true, writable: true });
            } catch {
              Gn[e] = n;
            }
            return n;
          };
        });
        var ar = U((Jp, Kn) => {
          var nu = pe(), iu = or(), Jn = "__core-js_shared__", su = nu[Jn] || iu(Jn, {});
          Kn.exports = su;
        });
        var Ur = U((Kp, Yn) => {
          var ou = Vn(), Qn = ar();
          (Yn.exports = function(e, n) {
            return Qn[e] || (Qn[e] = n !== void 0 ? n : {});
          })("versions", []).push({ version: "3.26.1", mode: ou ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE", source: "https://github.com/zloirock/core-js" });
        });
        var Zn = U((Qp, Xn) => {
          var au = Ir(), uu = Object;
          Xn.exports = function(e) {
            return uu(au(e));
          };
        });
        var Te = U((Yp, ei) => {
          var cu = xe(), lu = Zn(), fu = cu({}.hasOwnProperty);
          ei.exports = Object.hasOwn || function(n, i) {
            return fu(lu(n), i);
          };
        });
        var $r = U((Xp, ri) => {
          var pu = xe(), hu = 0, du = Math.random(), vu = pu(1 .toString);
          ri.exports = function(e) {
            return "Symbol(" + (e === void 0 ? "" : e) + ")_" + vu(++hu + du, 36);
          };
        });
        var ai = U((Zp, oi) => {
          var mu = pe(), gu = Ur(), ti = Te(), yu = $r(), ni = Mr(), si = Dr(), De = gu("wks"), Ee = mu.Symbol, ii = Ee && Ee.for, wu = si ? Ee : Ee && Ee.withoutSetter || yu;
          oi.exports = function(e) {
            if (!ti(De, e) || !(ni || typeof De[e] == "string")) {
              var n = "Symbol." + e;
              ni && ti(Ee, e) ? De[e] = Ee[e] : si && ii ? De[e] = ii(n) : De[e] = wu(n);
            }
            return De[e];
          };
        });
        var fi = U((eh, li) => {
          var _u = tr(), ui = Me(), ci = Lr(), bu = Fn(), xu = $n(), Su = ai(), ku = TypeError, Ou = Su("toPrimitive");
          li.exports = function(e, n) {
            if (!ui(e) || ci(e))
              return e;
            var i = bu(e, Ou), u;
            if (i) {
              if (n === void 0 && (n = "default"), u = _u(i, e, n), !ui(u) || ci(u))
                return u;
              throw ku("Can't convert object to primitive value");
            }
            return n === void 0 && (n = "number"), xu(e, n);
          };
        });
        var Wr = U((rh, pi) => {
          var Tu = fi(), Eu = Lr();
          pi.exports = function(e) {
            var n = Tu(e, "string");
            return Eu(n) ? n : n + "";
          };
        });
        var vi = U((th, di) => {
          var qu = pe(), hi = Me(), Vr = qu.document, Au = hi(Vr) && hi(Vr.createElement);
          di.exports = function(e) {
            return Au ? Vr.createElement(e) : {};
          };
        });
        var Gr = U((nh, mi) => {
          var Pu = Oe(), Iu = be(), Ru = vi();
          mi.exports = !Pu && !Iu(function() {
            return Object.defineProperty(Ru("div"), "a", { get: function() {
              return 7;
            } }).a != 7;
          });
        });
        var Hr = U((yi) => {
          var Cu = Oe(), Nu = tr(), ju = en(), Mu = Er(), Du = nr(), Lu = Wr(), zu = Te(), Bu = Gr(), gi = Object.getOwnPropertyDescriptor;
          yi.f = Cu ? gi : function(n, i) {
            if (n = Du(n), i = Lu(i), Bu)
              try {
                return gi(n, i);
              } catch {
              }
            if (zu(n, i))
              return Mu(!Nu(ju.f, n, i), n[i]);
          };
        });
        var _i = U((sh, wi) => {
          var Fu = Oe(), Uu = be();
          wi.exports = Fu && Uu(function() {
            return Object.defineProperty(function() {
            }, "prototype", { value: 42, writable: false }).prototype != 42;
          });
        });
        var Jr = U((oh, bi) => {
          var $u = Me(), Wu = String, Vu = TypeError;
          bi.exports = function(e) {
            if ($u(e))
              return e;
            throw Vu(Wu(e) + " is not an object");
          };
        });
        var cr = U((Si) => {
          var Gu = Oe(), Hu = Gr(), Ju = _i(), ur = Jr(), xi = Wr(), Ku = TypeError, Kr = Object.defineProperty, Qu = Object.getOwnPropertyDescriptor, Qr = "enumerable", Yr = "configurable", Xr = "writable";
          Si.f = Gu ? Ju ? function(n, i, u) {
            if (ur(n), i = xi(i), ur(u), typeof n == "function" && i === "prototype" && "value" in u && Xr in u && !u[Xr]) {
              var o = Qu(n, i);
              o && o[Xr] && (n[i] = u.value, u = { configurable: Yr in u ? u[Yr] : o[Yr], enumerable: Qr in u ? u[Qr] : o[Qr], writable: false });
            }
            return Kr(n, i, u);
          } : Kr : function(n, i, u) {
            if (ur(n), i = xi(i), ur(u), Hu)
              try {
                return Kr(n, i, u);
              } catch {
              }
            if ("get" in u || "set" in u)
              throw Ku("Accessors not supported");
            return "value" in u && (n[i] = u.value), n;
          };
        });
        var Zr = U((uh, ki) => {
          var Yu = Oe(), Xu = cr(), Zu = Er();
          ki.exports = Yu ? function(e, n, i) {
            return Xu.f(e, n, Zu(1, i));
          } : function(e, n, i) {
            return e[n] = i, e;
          };
        });
        var Ei = U((ch, Ti) => {
          var et = Oe(), ec = Te(), Oi = Function.prototype, rc = et && Object.getOwnPropertyDescriptor, rt = ec(Oi, "name"), tc = rt && function() {
          }.name === "something", nc = rt && (!et || et && rc(Oi, "name").configurable);
          Ti.exports = { EXISTS: rt, PROPER: tc, CONFIGURABLE: nc };
        });
        var Ai = U((lh, qi) => {
          var ic = xe(), sc = he(), tt = ar(), oc = ic(Function.toString);
          sc(tt.inspectSource) || (tt.inspectSource = function(e) {
            return oc(e);
          });
          qi.exports = tt.inspectSource;
        });
        var Ri = U((fh, Ii) => {
          var ac = pe(), uc = he(), Pi = ac.WeakMap;
          Ii.exports = uc(Pi) && /native code/.test(String(Pi));
        });
        var ji = U((ph, Ni) => {
          var cc = Ur(), lc = $r(), Ci = cc("keys");
          Ni.exports = function(e) {
            return Ci[e] || (Ci[e] = lc(e));
          };
        });
        var nt = U((hh, Mi) => {
          Mi.exports = {};
        });
        var Bi = U((dh, zi) => {
          var fc = Ri(), Li = pe(), pc = Me(), hc = Zr(), it = Te(), st = ar(), dc = ji(), vc = nt(), Di = "Object already initialized", ot = Li.TypeError, mc = Li.WeakMap, lr, Fe, fr, gc = function(e) {
            return fr(e) ? Fe(e) : lr(e, {});
          }, yc = function(e) {
            return function(n) {
              var i;
              if (!pc(n) || (i = Fe(n)).type !== e)
                throw ot("Incompatible receiver, " + e + " required");
              return i;
            };
          };
          fc || st.state ? (ve = st.state || (st.state = new mc()), ve.get = ve.get, ve.has = ve.has, ve.set = ve.set, lr = function(e, n) {
            if (ve.has(e))
              throw ot(Di);
            return n.facade = e, ve.set(e, n), n;
          }, Fe = function(e) {
            return ve.get(e) || {};
          }, fr = function(e) {
            return ve.has(e);
          }) : (qe = dc("state"), vc[qe] = true, lr = function(e, n) {
            if (it(e, qe))
              throw ot(Di);
            return n.facade = e, hc(e, qe, n), n;
          }, Fe = function(e) {
            return it(e, qe) ? e[qe] : {};
          }, fr = function(e) {
            return it(e, qe);
          });
          var ve, qe;
          zi.exports = { set: lr, get: Fe, has: fr, enforce: gc, getterFor: yc };
        });
        var $i = U((vh, Ui) => {
          var wc = be(), _c = he(), pr = Te(), at2 = Oe(), bc = Ei().CONFIGURABLE, xc = Ai(), Fi = Bi(), Sc = Fi.enforce, kc = Fi.get, hr = Object.defineProperty, Oc = at2 && !wc(function() {
            return hr(function() {
            }, "length", { value: 8 }).length !== 8;
          }), Tc = String(String).split("String"), Ec = Ui.exports = function(e, n, i) {
            String(n).slice(0, 7) === "Symbol(" && (n = "[" + String(n).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), i && i.getter && (n = "get " + n), i && i.setter && (n = "set " + n), (!pr(e, "name") || bc && e.name !== n) && (at2 ? hr(e, "name", { value: n, configurable: true }) : e.name = n), Oc && i && pr(i, "arity") && e.length !== i.arity && hr(e, "length", { value: i.arity });
            try {
              i && pr(i, "constructor") && i.constructor ? at2 && hr(e, "prototype", { writable: false }) : e.prototype && (e.prototype = void 0);
            } catch {
            }
            var u = Sc(e);
            return pr(u, "source") || (u.source = Tc.join(typeof n == "string" ? n : "")), e;
          };
          Function.prototype.toString = Ec(function() {
            return _c(this) && kc(this).source || xc(this);
          }, "toString");
        });
        var Vi = U((mh, Wi) => {
          var qc = he(), Ac = cr(), Pc = $i(), Ic = or();
          Wi.exports = function(e, n, i, u) {
            u || (u = {});
            var o = u.enumerable, h = u.name !== void 0 ? u.name : n;
            if (qc(i) && Pc(i, h, u), u.global)
              o ? e[n] = i : Ic(n, i);
            else {
              try {
                u.unsafe ? e[n] && (o = true) : delete e[n];
              } catch {
              }
              o ? e[n] = i : Ac.f(e, n, { value: i, enumerable: false, configurable: !u.nonConfigurable, writable: !u.nonWritable });
            }
            return e;
          };
        });
        var Hi = U((gh, Gi) => {
          var Rc = Math.ceil, Cc = Math.floor;
          Gi.exports = Math.trunc || function(n) {
            var i = +n;
            return (i > 0 ? Cc : Rc)(i);
          };
        });
        var ut = U((yh, Ji) => {
          var Nc = Hi();
          Ji.exports = function(e) {
            var n = +e;
            return n !== n || n === 0 ? 0 : Nc(n);
          };
        });
        var Qi = U((wh, Ki) => {
          var jc = ut(), Mc = Math.max, Dc = Math.min;
          Ki.exports = function(e, n) {
            var i = jc(e);
            return i < 0 ? Mc(i + n, 0) : Dc(i, n);
          };
        });
        var Xi = U((_h, Yi) => {
          var Lc = ut(), zc = Math.min;
          Yi.exports = function(e) {
            return e > 0 ? zc(Lc(e), 9007199254740991) : 0;
          };
        });
        var es = U((bh, Zi) => {
          var Bc = Xi();
          Zi.exports = function(e) {
            return Bc(e.length);
          };
        });
        var ns = U((xh, ts) => {
          var Fc = nr(), Uc = Qi(), $c = es(), rs = function(e) {
            return function(n, i, u) {
              var o = Fc(n), h = $c(o), l = Uc(u, h), p;
              if (e && i != i) {
                for (; h > l; )
                  if (p = o[l++], p != p)
                    return true;
              } else
                for (; h > l; l++)
                  if ((e || l in o) && o[l] === i)
                    return e || l || 0;
              return !e && -1;
            };
          };
          ts.exports = { includes: rs(true), indexOf: rs(false) };
        });
        var os = U((Sh, ss) => {
          var Wc = xe(), ct = Te(), Vc = nr(), Gc = ns().indexOf, Hc = nt(), is = Wc([].push);
          ss.exports = function(e, n) {
            var i = Vc(e), u = 0, o = [], h;
            for (h in i)
              !ct(Hc, h) && ct(i, h) && is(o, h);
            for (; n.length > u; )
              ct(i, h = n[u++]) && (~Gc(o, h) || is(o, h));
            return o;
          };
        });
        var us = U((kh, as) => {
          as.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        });
        var ls = U((cs) => {
          var Jc = os(), Kc = us(), Qc = Kc.concat("length", "prototype");
          cs.f = Object.getOwnPropertyNames || function(n) {
            return Jc(n, Qc);
          };
        });
        var ps = U((fs) => {
          fs.f = Object.getOwnPropertySymbols;
        });
        var ds = U((Eh, hs) => {
          var Yc = ir(), Xc = xe(), Zc = ls(), el = ps(), rl = Jr(), tl = Xc([].concat);
          hs.exports = Yc("Reflect", "ownKeys") || function(n) {
            var i = Zc.f(rl(n)), u = el.f;
            return u ? tl(i, u(n)) : i;
          };
        });
        var gs = U((qh, ms) => {
          var vs = Te(), nl = ds(), il = Hr(), sl = cr();
          ms.exports = function(e, n, i) {
            for (var u = nl(n), o = sl.f, h = il.f, l = 0; l < u.length; l++) {
              var p = u[l];
              !vs(e, p) && !(i && vs(i, p)) && o(e, p, h(n, p));
            }
          };
        });
        var ws = U((Ah, ys) => {
          var ol = be(), al = he(), ul = /#|\.prototype\./, Ue = function(e, n) {
            var i = ll[cl(e)];
            return i == pl ? true : i == fl ? false : al(n) ? ol(n) : !!n;
          }, cl = Ue.normalize = function(e) {
            return String(e).replace(ul, ".").toLowerCase();
          }, ll = Ue.data = {}, fl = Ue.NATIVE = "N", pl = Ue.POLYFILL = "P";
          ys.exports = Ue;
        });
        var bs = U((Ph, _s) => {
          var lt2 = pe(), hl = Hr().f, dl = Zr(), vl = Vi(), ml = or(), gl = gs(), yl = ws();
          _s.exports = function(e, n) {
            var i = e.target, u = e.global, o = e.stat, h, l, p, m, c, t3;
            if (u ? l = lt2 : o ? l = lt2[i] || ml(i, {}) : l = (lt2[i] || {}).prototype, l)
              for (p in n) {
                if (c = n[p], e.dontCallGetSet ? (t3 = hl(l, p), m = t3 && t3.value) : m = l[p], h = yl(u ? p : i + (o ? "." : "#") + p, e.forced), !h && m !== void 0) {
                  if (typeof c == typeof m)
                    continue;
                  gl(c, m);
                }
                (e.sham || m && m.sham) && dl(c, "sham", true), vl(l, p, c, e);
              }
          };
        });
        var xs = U(() => {
          var wl = bs(), ft = pe();
          wl({ global: true, forced: ft.globalThis !== ft }, { globalThis: ft });
        });
        var Ss = U(() => {
          xs();
        });
        var gp = U((Fh, wa) => {
          Ss();
          var Et = Object.defineProperty, _l = Object.getOwnPropertyDescriptor, qt = Object.getOwnPropertyNames, bl = Object.prototype.hasOwnProperty, Le = (e, n) => function() {
            return e && (n = (0, e[qt(e)[0]])(e = 0)), n;
          }, P = (e, n) => function() {
            return n || (0, e[qt(e)[0]])((n = { exports: {} }).exports, n), n.exports;
          }, At = (e, n) => {
            for (var i in n)
              Et(e, i, { get: n[i], enumerable: true });
          }, xl = (e, n, i, u) => {
            if (n && typeof n == "object" || typeof n == "function")
              for (let o of qt(n))
                !bl.call(e, o) && o !== i && Et(e, o, { get: () => n[o], enumerable: !(u = _l(n, o)) || u.enumerable });
            return e;
          }, Pt = (e) => xl(Et({}, "__esModule", { value: true }), e), A = Le({ "<define:process>"() {
          } }), Sl = P({ "src/common/parser-create-error.js"(e, n) {
            "use strict";
            A();
            function i(u, o) {
              let h = new SyntaxError(u + " (" + o.start.line + ":" + o.start.column + ")");
              return h.loc = o, h;
            }
            n.exports = i;
          } }), Us = P({ "src/utils/get-last.js"(e, n) {
            "use strict";
            A();
            var i = (u) => u[u.length - 1];
            n.exports = i;
          } }), $s = P({ "src/utils/front-matter/parse.js"(e, n) {
            "use strict";
            A();
            var i = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
            function u(o) {
              let h = o.match(i);
              if (!h)
                return { content: o };
              let { startDelimiter: l, language: p, value: m = "", endDelimiter: c } = h.groups, t3 = p.trim() || "yaml";
              if (l === "+++" && (t3 = "toml"), t3 !== "yaml" && l !== c)
                return { content: o };
              let [r] = h;
              return { frontMatter: { type: "front-matter", lang: t3, value: m, startDelimiter: l, endDelimiter: c, raw: r.replace(/\n$/, "") }, content: r.replace(/[^\n]/g, " ") + o.slice(r.length) };
            }
            n.exports = u;
          } }), Ws = {};
          At(Ws, { EOL: () => bt, arch: () => kl, cpus: () => Ys, default: () => to, endianness: () => Vs, freemem: () => Ks, getNetworkInterfaces: () => ro, hostname: () => Gs, loadavg: () => Hs, networkInterfaces: () => eo, platform: () => Ol, release: () => Zs, tmpDir: () => wt, tmpdir: () => _t, totalmem: () => Qs, type: () => Xs, uptime: () => Js });
          function Vs() {
            if (typeof dr > "u") {
              var e = new ArrayBuffer(2), n = new Uint8Array(e), i = new Uint16Array(e);
              if (n[0] = 1, n[1] = 2, i[0] === 258)
                dr = "BE";
              else if (i[0] === 513)
                dr = "LE";
              else
                throw new Error("unable to figure out endianess");
            }
            return dr;
          }
          function Gs() {
            return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
          }
          function Hs() {
            return [];
          }
          function Js() {
            return 0;
          }
          function Ks() {
            return Number.MAX_VALUE;
          }
          function Qs() {
            return Number.MAX_VALUE;
          }
          function Ys() {
            return [];
          }
          function Xs() {
            return "Browser";
          }
          function Zs() {
            return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
          }
          function eo() {
          }
          function ro() {
          }
          function kl() {
            return "javascript";
          }
          function Ol() {
            return "browser";
          }
          function wt() {
            return "/tmp";
          }
          var dr, _t, bt, to, Tl = Le({ "node-modules-polyfills:os"() {
            A(), _t = wt, bt = `
`, to = { EOL: bt, tmpdir: _t, tmpDir: wt, networkInterfaces: eo, getNetworkInterfaces: ro, release: Zs, type: Xs, cpus: Ys, totalmem: Qs, freemem: Ks, uptime: Js, loadavg: Hs, hostname: Gs, endianness: Vs };
          } }), El = P({ "node-modules-polyfills-commonjs:os"(e, n) {
            A();
            var i = (Tl(), Pt(Ws));
            if (i && i.default) {
              n.exports = i.default;
              for (let u in i)
                n.exports[u] = i[u];
            } else
              i && (n.exports = i);
          } }), ql = P({ "node_modules/detect-newline/index.js"(e, n) {
            "use strict";
            A();
            var i = (u) => {
              if (typeof u != "string")
                throw new TypeError("Expected a string");
              let o = u.match(/(?:\r?\n)/g) || [];
              if (o.length === 0)
                return;
              let h = o.filter((p) => p === `\r
`).length, l = o.length - h;
              return h > l ? `\r
` : `
`;
            };
            n.exports = i, n.exports.graceful = (u) => typeof u == "string" && i(u) || `
`;
          } }), Al = P({ "node_modules/jest-docblock/build/index.js"(e) {
            "use strict";
            A(), Object.defineProperty(e, "__esModule", { value: true }), e.extract = s, e.parse = g, e.parseWithComments = v, e.print = y, e.strip = f;
            function n() {
              let d = El();
              return n = function() {
                return d;
              }, d;
            }
            function i() {
              let d = u(ql());
              return i = function() {
                return d;
              }, d;
            }
            function u(d) {
              return d && d.__esModule ? d : { default: d };
            }
            var o = /\*\/$/, h = /^\/\*\*?/, l = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, p = /(^|\s+)\/\/([^\r\n]*)/g, m = /^(\r?\n)+/, c = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, t3 = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, r = /(\r?\n|^) *\* ?/g, a = [];
            function s(d) {
              let _ = d.match(l);
              return _ ? _[0].trimLeft() : "";
            }
            function f(d) {
              let _ = d.match(l);
              return _ && _[0] ? d.substring(_[0].length) : d;
            }
            function g(d) {
              return v(d).pragmas;
            }
            function v(d) {
              let _ = (0, i().default)(d) || n().EOL;
              d = d.replace(h, "").replace(o, "").replace(r, "$1");
              let k = "";
              for (; k !== d; )
                k = d, d = d.replace(c, `${_}$1 $2${_}`);
              d = d.replace(m, "").trimRight();
              let x = /* @__PURE__ */ Object.create(null), N = d.replace(t3, "").replace(m, "").trimRight(), I;
              for (; I = t3.exec(d); ) {
                let W = I[2].replace(p, "");
                typeof x[I[1]] == "string" || Array.isArray(x[I[1]]) ? x[I[1]] = a.concat(x[I[1]], W) : x[I[1]] = W;
              }
              return { comments: N, pragmas: x };
            }
            function y(d) {
              let { comments: _ = "", pragmas: k = {} } = d, x = (0, i().default)(_) || n().EOL, N = "/**", I = " *", W = " */", $ = Object.keys(k), H = $.map((V) => w(V, k[V])).reduce((V, B) => V.concat(B), []).map((V) => `${I} ${V}${x}`).join("");
              if (!_) {
                if ($.length === 0)
                  return "";
                if ($.length === 1 && !Array.isArray(k[$[0]])) {
                  let V = k[$[0]];
                  return `${N} ${w($[0], V)[0]}${W}`;
                }
              }
              let D = _.split(x).map((V) => `${I} ${V}`).join(x) + x;
              return N + x + (_ ? D : "") + (_ && $.length ? I + x : "") + H + W;
            }
            function w(d, _) {
              return a.concat(_).map((k) => `@${d} ${k}`.trim());
            }
          } }), Pl = P({ "src/common/end-of-line.js"(e, n) {
            "use strict";
            A();
            function i(l) {
              let p = l.indexOf("\r");
              return p >= 0 ? l.charAt(p + 1) === `
` ? "crlf" : "cr" : "lf";
            }
            function u(l) {
              switch (l) {
                case "cr":
                  return "\r";
                case "crlf":
                  return `\r
`;
                default:
                  return `
`;
              }
            }
            function o(l, p) {
              let m;
              switch (p) {
                case `
`:
                  m = /\n/g;
                  break;
                case "\r":
                  m = /\r/g;
                  break;
                case `\r
`:
                  m = /\r\n/g;
                  break;
                default:
                  throw new Error(`Unexpected "eol" ${JSON.stringify(p)}.`);
              }
              let c = l.match(m);
              return c ? c.length : 0;
            }
            function h(l) {
              return l.replace(/\r\n?/g, `
`);
            }
            n.exports = { guessEndOfLine: i, convertEndOfLineToChars: u, countEndOfLineChars: o, normalizeEndOfLine: h };
          } }), Il = P({ "src/language-js/utils/get-shebang.js"(e, n) {
            "use strict";
            A();
            function i(u) {
              if (!u.startsWith("#!"))
                return "";
              let o = u.indexOf(`
`);
              return o === -1 ? u : u.slice(0, o);
            }
            n.exports = i;
          } }), Rl = P({ "src/language-js/pragma.js"(e, n) {
            "use strict";
            A();
            var { parseWithComments: i, strip: u, extract: o, print: h } = Al(), { normalizeEndOfLine: l } = Pl(), p = Il();
            function m(r) {
              let a = p(r);
              a && (r = r.slice(a.length + 1));
              let s = o(r), { pragmas: f, comments: g } = i(s);
              return { shebang: a, text: r, pragmas: f, comments: g };
            }
            function c(r) {
              let a = Object.keys(m(r).pragmas);
              return a.includes("prettier") || a.includes("format");
            }
            function t3(r) {
              let { shebang: a, text: s, pragmas: f, comments: g } = m(r), v = u(s), y = h({ pragmas: Object.assign({ format: "" }, f), comments: g.trimStart() });
              return (a ? `${a}
` : "") + l(y) + (v.startsWith(`
`) ? `
` : `

`) + v;
            }
            n.exports = { hasPragma: c, insertPragma: t3 };
          } }), Cl = P({ "src/language-css/pragma.js"(e, n) {
            "use strict";
            A();
            var i = Rl(), u = $s();
            function o(l) {
              return i.hasPragma(u(l).content);
            }
            function h(l) {
              let { frontMatter: p, content: m } = u(l);
              return (p ? p.raw + `

` : "") + i.insertPragma(m);
            }
            n.exports = { hasPragma: o, insertPragma: h };
          } }), Nl = P({ "src/utils/text/skip.js"(e, n) {
            "use strict";
            A();
            function i(p) {
              return (m, c, t3) => {
                let r = t3 && t3.backwards;
                if (c === false)
                  return false;
                let { length: a } = m, s = c;
                for (; s >= 0 && s < a; ) {
                  let f = m.charAt(s);
                  if (p instanceof RegExp) {
                    if (!p.test(f))
                      return s;
                  } else if (!p.includes(f))
                    return s;
                  r ? s-- : s++;
                }
                return s === -1 || s === a ? s : false;
              };
            }
            var u = i(/\s/), o = i(" 	"), h = i(",; 	"), l = i(/[^\n\r]/);
            n.exports = { skipWhitespace: u, skipSpaces: o, skipToLineEnd: h, skipEverythingButNewLine: l };
          } }), jl = P({ "src/utils/line-column-to-index.js"(e, n) {
            "use strict";
            A(), n.exports = function(i, u) {
              let o = 0;
              for (let h = 0; h < i.line - 1; ++h)
                o = u.indexOf(`
`, o) + 1;
              return o + i.column;
            };
          } }), no = P({ "src/language-css/loc.js"(e, n) {
            "use strict";
            A();
            var { skipEverythingButNewLine: i } = Nl(), u = Us(), o = jl();
            function h(s, f) {
              return typeof s.sourceIndex == "number" ? s.sourceIndex : s.source ? o(s.source.start, f) - 1 : null;
            }
            function l(s, f) {
              if (s.type === "css-comment" && s.inline)
                return i(f, s.source.startOffset);
              let g = s.nodes && u(s.nodes);
              return g && s.source && !s.source.end && (s = g), s.source && s.source.end ? o(s.source.end, f) : null;
            }
            function p(s, f) {
              s.source && (s.source.startOffset = h(s, f), s.source.endOffset = l(s, f));
              for (let g in s) {
                let v = s[g];
                g === "source" || !v || typeof v != "object" || (v.type === "value-root" || v.type === "value-unknown" ? m(v, c(s), v.text || v.value) : p(v, f));
              }
            }
            function m(s, f, g) {
              s.source && (s.source.startOffset = h(s, g) + f, s.source.endOffset = l(s, g) + f);
              for (let v in s) {
                let y = s[v];
                v === "source" || !y || typeof y != "object" || m(y, f, g);
              }
            }
            function c(s) {
              let f = s.source.startOffset;
              return typeof s.prop == "string" && (f += s.prop.length), s.type === "css-atrule" && typeof s.name == "string" && (f += 1 + s.name.length + s.raws.afterName.match(/^\s*:?\s*/)[0].length), s.type !== "css-atrule" && s.raws && typeof s.raws.between == "string" && (f += s.raws.between.length), f;
            }
            function t3(s) {
              let f = "initial", g = "initial", v, y = false, w = [];
              for (let d = 0; d < s.length; d++) {
                let _ = s[d];
                switch (f) {
                  case "initial":
                    if (_ === "'") {
                      f = "single-quotes";
                      continue;
                    }
                    if (_ === '"') {
                      f = "double-quotes";
                      continue;
                    }
                    if ((_ === "u" || _ === "U") && s.slice(d, d + 4).toLowerCase() === "url(") {
                      f = "url", d += 3;
                      continue;
                    }
                    if (_ === "*" && s[d - 1] === "/") {
                      f = "comment-block";
                      continue;
                    }
                    if (_ === "/" && s[d - 1] === "/") {
                      f = "comment-inline", v = d - 1;
                      continue;
                    }
                    continue;
                  case "single-quotes":
                    if (_ === "'" && s[d - 1] !== "\\" && (f = g, g = "initial"), _ === `
` || _ === "\r")
                      return s;
                    continue;
                  case "double-quotes":
                    if (_ === '"' && s[d - 1] !== "\\" && (f = g, g = "initial"), _ === `
` || _ === "\r")
                      return s;
                    continue;
                  case "url":
                    if (_ === ")" && (f = "initial"), _ === `
` || _ === "\r")
                      return s;
                    if (_ === "'") {
                      f = "single-quotes", g = "url";
                      continue;
                    }
                    if (_ === '"') {
                      f = "double-quotes", g = "url";
                      continue;
                    }
                    continue;
                  case "comment-block":
                    _ === "/" && s[d - 1] === "*" && (f = "initial");
                    continue;
                  case "comment-inline":
                    (_ === '"' || _ === "'" || _ === "*") && (y = true), (_ === `
` || _ === "\r") && (y && w.push([v, d]), f = "initial", y = false);
                    continue;
                }
              }
              for (let [d, _] of w)
                s = s.slice(0, d) + s.slice(d, _).replace(/["'*]/g, " ") + s.slice(_);
              return s;
            }
            function r(s) {
              return s.source.startOffset;
            }
            function a(s) {
              return s.source.endOffset;
            }
            n.exports = { locStart: r, locEnd: a, calculateLoc: p, replaceQuotesInInlineComments: t3 };
          } }), Ml = P({ "src/utils/is-non-empty-array.js"(e, n) {
            "use strict";
            A();
            function i(u) {
              return Array.isArray(u) && u.length > 0;
            }
            n.exports = i;
          } }), Dl = P({ "src/language-css/utils/has-scss-interpolation.js"(e, n) {
            "use strict";
            A();
            var i = Ml();
            function u(o) {
              if (i(o)) {
                for (let h = o.length - 1; h > 0; h--)
                  if (o[h].type === "word" && o[h].value === "{" && o[h - 1].type === "word" && o[h - 1].value.endsWith("#"))
                    return true;
              }
              return false;
            }
            n.exports = u;
          } }), Ll = P({ "src/language-css/utils/has-string-or-function.js"(e, n) {
            "use strict";
            A();
            function i(u) {
              return u.some((o) => o.type === "string" || o.type === "func");
            }
            n.exports = i;
          } }), zl = P({ "src/language-css/utils/is-less-parser.js"(e, n) {
            "use strict";
            A();
            function i(u) {
              return u.parser === "css" || u.parser === "less";
            }
            n.exports = i;
          } }), Bl = P({ "src/language-css/utils/is-scss.js"(e, n) {
            "use strict";
            A();
            function i(u, o) {
              return u === "less" || u === "scss" ? u === "scss" : /(?:\w\s*:\s*[^:}]+|#){|@import[^\n]+(?:url|,)/.test(o);
            }
            n.exports = i;
          } }), Fl = P({ "src/language-css/utils/is-scss-nested-property-node.js"(e, n) {
            "use strict";
            A();
            function i(u) {
              return u.selector ? u.selector.replace(/\/\*.*?\*\//, "").replace(/\/\/.*\n/, "").trim().endsWith(":") : false;
            }
            n.exports = i;
          } }), Ul = P({ "src/language-css/utils/is-scss-variable.js"(e, n) {
            "use strict";
            A();
            function i(u) {
              return Boolean((u == null ? void 0 : u.type) === "word" && u.value.startsWith("$"));
            }
            n.exports = i;
          } }), $l = P({ "src/language-css/utils/stringify-node.js"(e, n) {
            "use strict";
            A();
            function i(u) {
              var o, h, l;
              if (u.groups) {
                var p, m, c;
                let y = ((p = u.open) === null || p === void 0 ? void 0 : p.value) || "", w = u.groups.map((_) => i(_)).join(((m = u.groups[0]) === null || m === void 0 ? void 0 : m.type) === "comma_group" ? "," : ""), d = ((c = u.close) === null || c === void 0 ? void 0 : c.value) || "";
                return y + w + d;
              }
              let t3 = ((o = u.raws) === null || o === void 0 ? void 0 : o.before) || "", r = ((h = u.raws) === null || h === void 0 ? void 0 : h.quote) || "", a = u.type === "atword" ? "@" : "", s = u.value || "", f = u.unit || "", g = u.group ? i(u.group) : "", v = ((l = u.raws) === null || l === void 0 ? void 0 : l.after) || "";
              return t3 + r + a + s + r + f + g + v;
            }
            n.exports = i;
          } }), Wl = P({ "src/language-css/utils/is-module-rule-name.js"(e, n) {
            "use strict";
            A();
            var i = /* @__PURE__ */ new Set(["import", "use", "forward"]);
            function u(o) {
              return i.has(o);
            }
            n.exports = u;
          } }), we = P({ "node_modules/postcss-values-parser/lib/node.js"(e, n) {
            "use strict";
            A();
            var i = function(u, o) {
              let h = new u.constructor();
              for (let l in u) {
                if (!u.hasOwnProperty(l))
                  continue;
                let p = u[l], m = typeof p;
                l === "parent" && m === "object" ? o && (h[l] = o) : l === "source" ? h[l] = p : p instanceof Array ? h[l] = p.map((c) => i(c, h)) : l !== "before" && l !== "after" && l !== "between" && l !== "semicolon" && (m === "object" && p !== null && (p = i(p)), h[l] = p);
              }
              return h;
            };
            n.exports = class {
              constructor(o) {
                o = o || {}, this.raws = { before: "", after: "" };
                for (let h in o)
                  this[h] = o[h];
              }
              remove() {
                return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
              }
              toString() {
                return [this.raws.before, String(this.value), this.raws.after].join("");
              }
              clone(o) {
                o = o || {};
                let h = i(this);
                for (let l in o)
                  h[l] = o[l];
                return h;
              }
              cloneBefore(o) {
                o = o || {};
                let h = this.clone(o);
                return this.parent.insertBefore(this, h), h;
              }
              cloneAfter(o) {
                o = o || {};
                let h = this.clone(o);
                return this.parent.insertAfter(this, h), h;
              }
              replaceWith() {
                let o = Array.prototype.slice.call(arguments);
                if (this.parent) {
                  for (let h of o)
                    this.parent.insertBefore(this, h);
                  this.remove();
                }
                return this;
              }
              moveTo(o) {
                return this.cleanRaws(this.root() === o.root()), this.remove(), o.append(this), this;
              }
              moveBefore(o) {
                return this.cleanRaws(this.root() === o.root()), this.remove(), o.parent.insertBefore(o, this), this;
              }
              moveAfter(o) {
                return this.cleanRaws(this.root() === o.root()), this.remove(), o.parent.insertAfter(o, this), this;
              }
              next() {
                let o = this.parent.index(this);
                return this.parent.nodes[o + 1];
              }
              prev() {
                let o = this.parent.index(this);
                return this.parent.nodes[o - 1];
              }
              toJSON() {
                let o = {};
                for (let h in this) {
                  if (!this.hasOwnProperty(h) || h === "parent")
                    continue;
                  let l = this[h];
                  l instanceof Array ? o[h] = l.map((p) => typeof p == "object" && p.toJSON ? p.toJSON() : p) : typeof l == "object" && l.toJSON ? o[h] = l.toJSON() : o[h] = l;
                }
                return o;
              }
              root() {
                let o = this;
                for (; o.parent; )
                  o = o.parent;
                return o;
              }
              cleanRaws(o) {
                delete this.raws.before, delete this.raws.after, o || delete this.raws.between;
              }
              positionInside(o) {
                let h = this.toString(), l = this.source.start.column, p = this.source.start.line;
                for (let m = 0; m < o; m++)
                  h[m] === `
` ? (l = 1, p += 1) : l += 1;
                return { line: p, column: l };
              }
              positionBy(o) {
                let h = this.source.start;
                if (Object(o).index)
                  h = this.positionInside(o.index);
                else if (Object(o).word) {
                  let l = this.toString().indexOf(o.word);
                  l !== -1 && (h = this.positionInside(l));
                }
                return h;
              }
            };
          } }), ae = P({ "node_modules/postcss-values-parser/lib/container.js"(e, n) {
            "use strict";
            A();
            var i = we(), u = class extends i {
              constructor(o) {
                super(o), this.nodes || (this.nodes = []);
              }
              push(o) {
                return o.parent = this, this.nodes.push(o), this;
              }
              each(o) {
                this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
                let h = this.lastEach, l, p;
                if (this.indexes[h] = 0, !!this.nodes) {
                  for (; this.indexes[h] < this.nodes.length && (l = this.indexes[h], p = o(this.nodes[l], l), p !== false); )
                    this.indexes[h] += 1;
                  return delete this.indexes[h], p;
                }
              }
              walk(o) {
                return this.each((h, l) => {
                  let p = o(h, l);
                  return p !== false && h.walk && (p = h.walk(o)), p;
                });
              }
              walkType(o, h) {
                if (!o || !h)
                  throw new Error("Parameters {type} and {callback} are required.");
                let l = typeof o == "function";
                return this.walk((p, m) => {
                  if (l && p instanceof o || !l && p.type === o)
                    return h.call(this, p, m);
                });
              }
              append(o) {
                return o.parent = this, this.nodes.push(o), this;
              }
              prepend(o) {
                return o.parent = this, this.nodes.unshift(o), this;
              }
              cleanRaws(o) {
                if (super.cleanRaws(o), this.nodes)
                  for (let h of this.nodes)
                    h.cleanRaws(o);
              }
              insertAfter(o, h) {
                let l = this.index(o), p;
                this.nodes.splice(l + 1, 0, h);
                for (let m in this.indexes)
                  p = this.indexes[m], l <= p && (this.indexes[m] = p + this.nodes.length);
                return this;
              }
              insertBefore(o, h) {
                let l = this.index(o), p;
                this.nodes.splice(l, 0, h);
                for (let m in this.indexes)
                  p = this.indexes[m], l <= p && (this.indexes[m] = p + this.nodes.length);
                return this;
              }
              removeChild(o) {
                o = this.index(o), this.nodes[o].parent = void 0, this.nodes.splice(o, 1);
                let h;
                for (let l in this.indexes)
                  h = this.indexes[l], h >= o && (this.indexes[l] = h - 1);
                return this;
              }
              removeAll() {
                for (let o of this.nodes)
                  o.parent = void 0;
                return this.nodes = [], this;
              }
              every(o) {
                return this.nodes.every(o);
              }
              some(o) {
                return this.nodes.some(o);
              }
              index(o) {
                return typeof o == "number" ? o : this.nodes.indexOf(o);
              }
              get first() {
                if (this.nodes)
                  return this.nodes[0];
              }
              get last() {
                if (this.nodes)
                  return this.nodes[this.nodes.length - 1];
              }
              toString() {
                let o = this.nodes.map(String).join("");
                return this.value && (o = this.value + o), this.raws.before && (o = this.raws.before + o), this.raws.after && (o += this.raws.after), o;
              }
            };
            u.registerWalker = (o) => {
              let h = "walk" + o.name;
              h.lastIndexOf("s") !== h.length - 1 && (h += "s"), !u.prototype[h] && (u.prototype[h] = function(l) {
                return this.walkType(o, l);
              });
            }, n.exports = u;
          } }), Vl = P({ "node_modules/postcss-values-parser/lib/root.js"(e, n) {
            "use strict";
            A();
            var i = ae();
            n.exports = class extends i {
              constructor(o) {
                super(o), this.type = "root";
              }
            };
          } }), io = P({ "node_modules/postcss-values-parser/lib/value.js"(e, n) {
            "use strict";
            A();
            var i = ae();
            n.exports = class extends i {
              constructor(o) {
                super(o), this.type = "value", this.unbalanced = 0;
              }
            };
          } }), so = P({ "node_modules/postcss-values-parser/lib/atword.js"(e, n) {
            "use strict";
            A();
            var i = ae(), u = class extends i {
              constructor(o) {
                super(o), this.type = "atword";
              }
              toString() {
                let o = this.quoted ? this.raws.quote : "";
                return [this.raws.before, "@", String.prototype.toString.call(this.value), this.raws.after].join("");
              }
            };
            i.registerWalker(u), n.exports = u;
          } }), oo = P({ "node_modules/postcss-values-parser/lib/colon.js"(e, n) {
            "use strict";
            A();
            var i = ae(), u = we(), o = class extends u {
              constructor(h) {
                super(h), this.type = "colon";
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), ao = P({ "node_modules/postcss-values-parser/lib/comma.js"(e, n) {
            "use strict";
            A();
            var i = ae(), u = we(), o = class extends u {
              constructor(h) {
                super(h), this.type = "comma";
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), uo = P({ "node_modules/postcss-values-parser/lib/comment.js"(e, n) {
            "use strict";
            A();
            var i = ae(), u = we(), o = class extends u {
              constructor(h) {
                super(h), this.type = "comment", this.inline = Object(h).inline || false;
              }
              toString() {
                return [this.raws.before, this.inline ? "//" : "/*", String(this.value), this.inline ? "" : "*/", this.raws.after].join("");
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), co = P({ "node_modules/postcss-values-parser/lib/function.js"(e, n) {
            "use strict";
            A();
            var i = ae(), u = class extends i {
              constructor(o) {
                super(o), this.type = "func", this.unbalanced = -1;
              }
            };
            i.registerWalker(u), n.exports = u;
          } }), lo = P({ "node_modules/postcss-values-parser/lib/number.js"(e, n) {
            "use strict";
            A();
            var i = ae(), u = we(), o = class extends u {
              constructor(h) {
                super(h), this.type = "number", this.unit = Object(h).unit || "";
              }
              toString() {
                return [this.raws.before, String(this.value), this.unit, this.raws.after].join("");
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), fo = P({ "node_modules/postcss-values-parser/lib/operator.js"(e, n) {
            "use strict";
            A();
            var i = ae(), u = we(), o = class extends u {
              constructor(h) {
                super(h), this.type = "operator";
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), po = P({ "node_modules/postcss-values-parser/lib/paren.js"(e, n) {
            "use strict";
            A();
            var i = ae(), u = we(), o = class extends u {
              constructor(h) {
                super(h), this.type = "paren", this.parenType = "";
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), ho = P({ "node_modules/postcss-values-parser/lib/string.js"(e, n) {
            "use strict";
            A();
            var i = ae(), u = we(), o = class extends u {
              constructor(h) {
                super(h), this.type = "string";
              }
              toString() {
                let h = this.quoted ? this.raws.quote : "";
                return [this.raws.before, h, this.value + "", h, this.raws.after].join("");
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), vo = P({ "node_modules/postcss-values-parser/lib/word.js"(e, n) {
            "use strict";
            A();
            var i = ae(), u = we(), o = class extends u {
              constructor(h) {
                super(h), this.type = "word";
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), mo = P({ "node_modules/postcss-values-parser/lib/unicode-range.js"(e, n) {
            "use strict";
            A();
            var i = ae(), u = we(), o = class extends u {
              constructor(h) {
                super(h), this.type = "unicode-range";
              }
            };
            i.registerWalker(o), n.exports = o;
          } });
          function go() {
            throw new Error("setTimeout has not been defined");
          }
          function yo() {
            throw new Error("clearTimeout has not been defined");
          }
          function wo(e) {
            if (Se === setTimeout)
              return setTimeout(e, 0);
            if ((Se === go || !Se) && setTimeout)
              return Se = setTimeout, setTimeout(e, 0);
            try {
              return Se(e, 0);
            } catch {
              try {
                return Se.call(null, e, 0);
              } catch {
                return Se.call(this, e, 0);
              }
            }
          }
          function Gl(e) {
            if (ke === clearTimeout)
              return clearTimeout(e);
            if ((ke === yo || !ke) && clearTimeout)
              return ke = clearTimeout, clearTimeout(e);
            try {
              return ke(e);
            } catch {
              try {
                return ke.call(null, e);
              } catch {
                return ke.call(this, e);
              }
            }
          }
          function Hl() {
            !Ne || !Ce || (Ne = false, Ce.length ? me = Ce.concat(me) : We = -1, me.length && _o());
          }
          function _o() {
            if (!Ne) {
              var e = wo(Hl);
              Ne = true;
              for (var n = me.length; n; ) {
                for (Ce = me, me = []; ++We < n; )
                  Ce && Ce[We].run();
                We = -1, n = me.length;
              }
              Ce = null, Ne = false, Gl(e);
            }
          }
          function Jl(e) {
            var n = new Array(arguments.length - 1);
            if (arguments.length > 1)
              for (var i = 1; i < arguments.length; i++)
                n[i - 1] = arguments[i];
            me.push(new bo(e, n)), me.length === 1 && !Ne && wo(_o);
          }
          function bo(e, n) {
            this.fun = e, this.array = n;
          }
          function Ae() {
          }
          function Kl(e) {
            throw new Error("process.binding is not supported");
          }
          function Ql() {
            return "/";
          }
          function Yl(e) {
            throw new Error("process.chdir is not supported");
          }
          function Xl() {
            return 0;
          }
          function Zl(e) {
            var n = xo.call(Ie) * 1e-3, i = Math.floor(n), u = Math.floor(n % 1 * 1e9);
            return e && (i = i - e[0], u = u - e[1], u < 0 && (i--, u += 1e9)), [i, u];
          }
          function ef() {
            var e = new Date(), n = e - So;
            return n / 1e3;
          }
          var Se, ke, me, Ne, Ce, We, ks, Os, Ts, Es, qs, As, Ps, Is, Rs, Cs, Ns, js, Ms, Ds, Ls, zs, Ie, xo, So, Bs, Ve, rf = Le({ "node-modules-polyfills:process"() {
            A(), Se = go, ke = yo, typeof globalThis.setTimeout == "function" && (Se = setTimeout), typeof globalThis.clearTimeout == "function" && (ke = clearTimeout), me = [], Ne = false, We = -1, bo.prototype.run = function() {
              this.fun.apply(null, this.array);
            }, ks = "browser", Os = "browser", Ts = true, Es = {}, qs = [], As = "", Ps = {}, Is = {}, Rs = {}, Cs = Ae, Ns = Ae, js = Ae, Ms = Ae, Ds = Ae, Ls = Ae, zs = Ae, Ie = globalThis.performance || {}, xo = Ie.now || Ie.mozNow || Ie.msNow || Ie.oNow || Ie.webkitNow || function() {
              return new Date().getTime();
            }, So = new Date(), Bs = { nextTick: Jl, title: ks, browser: Ts, env: Es, argv: qs, version: As, versions: Ps, on: Cs, addListener: Ns, once: js, off: Ms, removeListener: Ds, removeAllListeners: Ls, emit: zs, binding: Kl, cwd: Ql, chdir: Yl, umask: Xl, hrtime: Zl, platform: Os, release: Is, config: Rs, uptime: ef }, Ve = Bs;
          } }), pt, It, tf = Le({ "node_modules/rollup-plugin-node-polyfills/polyfills/inherits.js"() {
            A(), typeof Object.create == "function" ? pt = function(n, i) {
              n.super_ = i, n.prototype = Object.create(i.prototype, { constructor: { value: n, enumerable: false, writable: true, configurable: true } });
            } : pt = function(n, i) {
              n.super_ = i;
              var u = function() {
              };
              u.prototype = i.prototype, n.prototype = new u(), n.prototype.constructor = n;
            }, It = pt;
          } }), ko = {};
          At(ko, { _extend: () => Mt, debuglog: () => Oo, default: () => No, deprecate: () => Rt, format: () => wr, inherits: () => It, inspect: () => ye, isArray: () => Ct, isBoolean: () => _r, isBuffer: () => Ao, isDate: () => gr, isError: () => He, isFunction: () => Je, isNull: () => Ke, isNullOrUndefined: () => To, isNumber: () => Nt, isObject: () => je, isPrimitive: () => qo, isRegExp: () => Ge, isString: () => Qe, isSymbol: () => Eo, isUndefined: () => ge, log: () => Po });
          function wr(e) {
            if (!Qe(e)) {
              for (var n = [], i = 0; i < arguments.length; i++)
                n.push(ye(arguments[i]));
              return n.join(" ");
            }
            for (var i = 1, u = arguments, o = u.length, h = String(e).replace(Ro, function(p) {
              if (p === "%%")
                return "%";
              if (i >= o)
                return p;
              switch (p) {
                case "%s":
                  return String(u[i++]);
                case "%d":
                  return Number(u[i++]);
                case "%j":
                  try {
                    return JSON.stringify(u[i++]);
                  } catch {
                    return "[Circular]";
                  }
                default:
                  return p;
              }
            }), l = u[i]; i < o; l = u[++i])
              Ke(l) || !je(l) ? h += " " + l : h += " " + ye(l);
            return h;
          }
          function Rt(e, n) {
            if (ge(globalThis.process))
              return function() {
                return Rt(e, n).apply(this, arguments);
              };
            if (Ve.noDeprecation === true)
              return e;
            var i = false;
            function u() {
              if (!i) {
                if (Ve.throwDeprecation)
                  throw new Error(n);
                Ve.traceDeprecation ? console.trace(n) : console.error(n), i = true;
              }
              return e.apply(this, arguments);
            }
            return u;
          }
          function Oo(e) {
            if (ge(vt) && (vt = Ve.env.NODE_DEBUG || ""), e = e.toUpperCase(), !$e[e])
              if (new RegExp("\\b" + e + "\\b", "i").test(vt)) {
                var n = 0;
                $e[e] = function() {
                  var i = wr.apply(null, arguments);
                  console.error("%s %d: %s", e, n, i);
                };
              } else
                $e[e] = function() {
                };
            return $e[e];
          }
          function ye(e, n) {
            var i = { seen: [], stylize: sf };
            return arguments.length >= 3 && (i.depth = arguments[2]), arguments.length >= 4 && (i.colors = arguments[3]), _r(n) ? i.showHidden = n : n && Mt(i, n), ge(i.showHidden) && (i.showHidden = false), ge(i.depth) && (i.depth = 2), ge(i.colors) && (i.colors = false), ge(i.customInspect) && (i.customInspect = true), i.colors && (i.stylize = nf), mr(i, e, i.depth);
          }
          function nf(e, n) {
            var i = ye.styles[n];
            return i ? "\x1B[" + ye.colors[i][0] + "m" + e + "\x1B[" + ye.colors[i][1] + "m" : e;
          }
          function sf(e, n) {
            return e;
          }
          function of(e) {
            var n = {};
            return e.forEach(function(i, u) {
              n[i] = true;
            }), n;
          }
          function mr(e, n, i) {
            if (e.customInspect && n && Je(n.inspect) && n.inspect !== ye && !(n.constructor && n.constructor.prototype === n)) {
              var u = n.inspect(i, e);
              return Qe(u) || (u = mr(e, u, i)), u;
            }
            var o = af(e, n);
            if (o)
              return o;
            var h = Object.keys(n), l = of(h);
            if (e.showHidden && (h = Object.getOwnPropertyNames(n)), He(n) && (h.indexOf("message") >= 0 || h.indexOf("description") >= 0))
              return ht(n);
            if (h.length === 0) {
              if (Je(n)) {
                var p = n.name ? ": " + n.name : "";
                return e.stylize("[Function" + p + "]", "special");
              }
              if (Ge(n))
                return e.stylize(RegExp.prototype.toString.call(n), "regexp");
              if (gr(n))
                return e.stylize(Date.prototype.toString.call(n), "date");
              if (He(n))
                return ht(n);
            }
            var m = "", c = false, t3 = ["{", "}"];
            if (Ct(n) && (c = true, t3 = ["[", "]"]), Je(n)) {
              var r = n.name ? ": " + n.name : "";
              m = " [Function" + r + "]";
            }
            if (Ge(n) && (m = " " + RegExp.prototype.toString.call(n)), gr(n) && (m = " " + Date.prototype.toUTCString.call(n)), He(n) && (m = " " + ht(n)), h.length === 0 && (!c || n.length == 0))
              return t3[0] + m + t3[1];
            if (i < 0)
              return Ge(n) ? e.stylize(RegExp.prototype.toString.call(n), "regexp") : e.stylize("[Object]", "special");
            e.seen.push(n);
            var a;
            return c ? a = uf(e, n, i, l, h) : a = h.map(function(s) {
              return xt(e, n, i, l, s, c);
            }), e.seen.pop(), cf(a, m, t3);
          }
          function af(e, n) {
            if (ge(n))
              return e.stylize("undefined", "undefined");
            if (Qe(n)) {
              var i = "'" + JSON.stringify(n).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
              return e.stylize(i, "string");
            }
            if (Nt(n))
              return e.stylize("" + n, "number");
            if (_r(n))
              return e.stylize("" + n, "boolean");
            if (Ke(n))
              return e.stylize("null", "null");
          }
          function ht(e) {
            return "[" + Error.prototype.toString.call(e) + "]";
          }
          function uf(e, n, i, u, o) {
            for (var h = [], l = 0, p = n.length; l < p; ++l)
              Io(n, String(l)) ? h.push(xt(e, n, i, u, String(l), true)) : h.push("");
            return o.forEach(function(m) {
              m.match(/^\d+$/) || h.push(xt(e, n, i, u, m, true));
            }), h;
          }
          function xt(e, n, i, u, o, h) {
            var l, p, m;
            if (m = Object.getOwnPropertyDescriptor(n, o) || { value: n[o] }, m.get ? m.set ? p = e.stylize("[Getter/Setter]", "special") : p = e.stylize("[Getter]", "special") : m.set && (p = e.stylize("[Setter]", "special")), Io(u, o) || (l = "[" + o + "]"), p || (e.seen.indexOf(m.value) < 0 ? (Ke(i) ? p = mr(e, m.value, null) : p = mr(e, m.value, i - 1), p.indexOf(`
`) > -1 && (h ? p = p.split(`
`).map(function(c) {
              return "  " + c;
            }).join(`
`).substr(2) : p = `
` + p.split(`
`).map(function(c) {
              return "   " + c;
            }).join(`
`))) : p = e.stylize("[Circular]", "special")), ge(l)) {
              if (h && o.match(/^\d+$/))
                return p;
              l = JSON.stringify("" + o), l.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (l = l.substr(1, l.length - 2), l = e.stylize(l, "name")) : (l = l.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), l = e.stylize(l, "string"));
            }
            return l + ": " + p;
          }
          function cf(e, n, i) {
            var u = 0, o = e.reduce(function(h, l) {
              return u++, l.indexOf(`
`) >= 0 && u++, h + l.replace(/\u001b\[\d\d?m/g, "").length + 1;
            }, 0);
            return o > 60 ? i[0] + (n === "" ? "" : n + `
 `) + " " + e.join(`,
  `) + " " + i[1] : i[0] + n + " " + e.join(", ") + " " + i[1];
          }
          function Ct(e) {
            return Array.isArray(e);
          }
          function _r(e) {
            return typeof e == "boolean";
          }
          function Ke(e) {
            return e === null;
          }
          function To(e) {
            return e == null;
          }
          function Nt(e) {
            return typeof e == "number";
          }
          function Qe(e) {
            return typeof e == "string";
          }
          function Eo(e) {
            return typeof e == "symbol";
          }
          function ge(e) {
            return e === void 0;
          }
          function Ge(e) {
            return je(e) && jt(e) === "[object RegExp]";
          }
          function je(e) {
            return typeof e == "object" && e !== null;
          }
          function gr(e) {
            return je(e) && jt(e) === "[object Date]";
          }
          function He(e) {
            return je(e) && (jt(e) === "[object Error]" || e instanceof Error);
          }
          function Je(e) {
            return typeof e == "function";
          }
          function qo(e) {
            return e === null || typeof e == "boolean" || typeof e == "number" || typeof e == "string" || typeof e == "symbol" || typeof e > "u";
          }
          function Ao(e) {
            return Buffer2.isBuffer(e);
          }
          function jt(e) {
            return Object.prototype.toString.call(e);
          }
          function dt(e) {
            return e < 10 ? "0" + e.toString(10) : e.toString(10);
          }
          function lf() {
            var e = new Date(), n = [dt(e.getHours()), dt(e.getMinutes()), dt(e.getSeconds())].join(":");
            return [e.getDate(), Co[e.getMonth()], n].join(" ");
          }
          function Po() {
            console.log("%s - %s", lf(), wr.apply(null, arguments));
          }
          function Mt(e, n) {
            if (!n || !je(n))
              return e;
            for (var i = Object.keys(n), u = i.length; u--; )
              e[i[u]] = n[i[u]];
            return e;
          }
          function Io(e, n) {
            return Object.prototype.hasOwnProperty.call(e, n);
          }
          var Ro, $e, vt, Co, No, ff = Le({ "node-modules-polyfills:util"() {
            A(), rf(), tf(), Ro = /%[sdj%]/g, $e = {}, ye.colors = { bold: [1, 22], italic: [3, 23], underline: [4, 24], inverse: [7, 27], white: [37, 39], grey: [90, 39], black: [30, 39], blue: [34, 39], cyan: [36, 39], green: [32, 39], magenta: [35, 39], red: [31, 39], yellow: [33, 39] }, ye.styles = { special: "cyan", number: "yellow", boolean: "yellow", undefined: "grey", null: "bold", string: "green", date: "magenta", regexp: "red" }, Co = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], No = { inherits: It, _extend: Mt, log: Po, isBuffer: Ao, isPrimitive: qo, isFunction: Je, isError: He, isDate: gr, isObject: je, isRegExp: Ge, isUndefined: ge, isSymbol: Eo, isString: Qe, isNumber: Nt, isNullOrUndefined: To, isNull: Ke, isBoolean: _r, isArray: Ct, inspect: ye, deprecate: Rt, format: wr, debuglog: Oo };
          } }), pf = P({ "node-modules-polyfills-commonjs:util"(e, n) {
            A();
            var i = (ff(), Pt(ko));
            if (i && i.default) {
              n.exports = i.default;
              for (let u in i)
                n.exports[u] = i[u];
            } else
              i && (n.exports = i);
          } }), hf = P({ "node_modules/postcss-values-parser/lib/errors/TokenizeError.js"(e, n) {
            "use strict";
            A();
            var i = class extends Error {
              constructor(u) {
                super(u), this.name = this.constructor.name, this.message = u || "An error ocurred while tokzenizing.", typeof Error.captureStackTrace == "function" ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error(u).stack;
              }
            };
            n.exports = i;
          } }), df = P({ "node_modules/postcss-values-parser/lib/tokenize.js"(e, n) {
            "use strict";
            A();
            var i = "{".charCodeAt(0), u = "}".charCodeAt(0), o = "(".charCodeAt(0), h = ")".charCodeAt(0), l = "'".charCodeAt(0), p = '"'.charCodeAt(0), m = "\\".charCodeAt(0), c = "/".charCodeAt(0), t3 = ".".charCodeAt(0), r = ",".charCodeAt(0), a = ":".charCodeAt(0), s = "*".charCodeAt(0), f = "-".charCodeAt(0), g = "+".charCodeAt(0), v = "#".charCodeAt(0), y = `
`.charCodeAt(0), w = " ".charCodeAt(0), d = "\f".charCodeAt(0), _ = "	".charCodeAt(0), k = "\r".charCodeAt(0), x = "@".charCodeAt(0), N = "e".charCodeAt(0), I = "E".charCodeAt(0), W = "0".charCodeAt(0), $ = "9".charCodeAt(0), H = "u".charCodeAt(0), D = "U".charCodeAt(0), V = /[ \n\t\r\{\(\)'"\\;,/]/g, B = /[ \n\t\r\(\)\{\}\*:;@!&'"\+\|~>,\[\]\\]|\/(?=\*)/g, O = /[ \n\t\r\(\)\{\}\*:;@!&'"\-\+\|~>,\[\]\\]|\//g, j = /^[a-z0-9]/i, C = /^[a-f0-9?\-]/i, R = pf(), X = hf();
            n.exports = function(Q, K) {
              K = K || {};
              let J = [], M = Q.valueOf(), Y = M.length, G = -1, E = 1, S = 0, b = 0, L = null, q, T, F, z, ee, te, ue, le, re, ne, oe, ie;
              function ce(Ze) {
                let _e = R.format("Unclosed %s at line: %d, column: %d, token: %d", Ze, E, S - G, S);
                throw new X(_e);
              }
              function fe() {
                let Ze = R.format("Syntax error at line: %d, column: %d, token: %d", E, S - G, S);
                throw new X(Ze);
              }
              for (; S < Y; ) {
                switch (q = M.charCodeAt(S), q === y && (G = S, E += 1), q) {
                  case y:
                  case w:
                  case _:
                  case k:
                  case d:
                    T = S;
                    do
                      T += 1, q = M.charCodeAt(T), q === y && (G = T, E += 1);
                    while (q === w || q === y || q === _ || q === k || q === d);
                    J.push(["space", M.slice(S, T), E, S - G, E, T - G, S]), S = T - 1;
                    break;
                  case a:
                    T = S + 1, J.push(["colon", M.slice(S, T), E, S - G, E, T - G, S]), S = T - 1;
                    break;
                  case r:
                    T = S + 1, J.push(["comma", M.slice(S, T), E, S - G, E, T - G, S]), S = T - 1;
                    break;
                  case i:
                    J.push(["{", "{", E, S - G, E, T - G, S]);
                    break;
                  case u:
                    J.push(["}", "}", E, S - G, E, T - G, S]);
                    break;
                  case o:
                    b++, L = !L && b === 1 && J.length > 0 && J[J.length - 1][0] === "word" && J[J.length - 1][1] === "url", J.push(["(", "(", E, S - G, E, T - G, S]);
                    break;
                  case h:
                    b--, L = L && b > 0, J.push([")", ")", E, S - G, E, T - G, S]);
                    break;
                  case l:
                  case p:
                    F = q === l ? "'" : '"', T = S;
                    do
                      for (ne = false, T = M.indexOf(F, T + 1), T === -1 && ce("quote", F), oe = T; M.charCodeAt(oe - 1) === m; )
                        oe -= 1, ne = !ne;
                    while (ne);
                    J.push(["string", M.slice(S, T + 1), E, S - G, E, T - G, S]), S = T;
                    break;
                  case x:
                    V.lastIndex = S + 1, V.test(M), V.lastIndex === 0 ? T = M.length - 1 : T = V.lastIndex - 2, J.push(["atword", M.slice(S, T + 1), E, S - G, E, T - G, S]), S = T;
                    break;
                  case m:
                    T = S, q = M.charCodeAt(T + 1), ue && q !== c && q !== w && q !== y && q !== _ && q !== k && q !== d && (T += 1), J.push(["word", M.slice(S, T + 1), E, S - G, E, T - G, S]), S = T;
                    break;
                  case g:
                  case f:
                  case s:
                    T = S + 1, ie = M.slice(S + 1, T + 1);
                    let Ze = M.slice(S - 1, S);
                    if (q === f && ie.charCodeAt(0) === f) {
                      T++, J.push(["word", M.slice(S, T), E, S - G, E, T - G, S]), S = T - 1;
                      break;
                    }
                    J.push(["operator", M.slice(S, T), E, S - G, E, T - G, S]), S = T - 1;
                    break;
                  default:
                    if (q === c && (M.charCodeAt(S + 1) === s || K.loose && !L && M.charCodeAt(S + 1) === c)) {
                      if (M.charCodeAt(S + 1) === s)
                        T = M.indexOf("*/", S + 2) + 1, T === 0 && ce("comment", "*/");
                      else {
                        let Be = M.indexOf(`
`, S + 2);
                        T = Be !== -1 ? Be - 1 : Y;
                      }
                      te = M.slice(S, T + 1), z = te.split(`
`), ee = z.length - 1, ee > 0 ? (le = E + ee, re = T - z[ee].length) : (le = E, re = G), J.push(["comment", te, E, S - G, le, T - re, S]), G = re, E = le, S = T;
                    } else if (q === v && !j.test(M.slice(S + 1, S + 2)))
                      T = S + 1, J.push(["#", M.slice(S, T), E, S - G, E, T - G, S]), S = T - 1;
                    else if ((q === H || q === D) && M.charCodeAt(S + 1) === g) {
                      T = S + 2;
                      do
                        T += 1, q = M.charCodeAt(T);
                      while (T < Y && C.test(M.slice(T, T + 1)));
                      J.push(["unicoderange", M.slice(S, T), E, S - G, E, T - G, S]), S = T - 1;
                    } else if (q === c)
                      T = S + 1, J.push(["operator", M.slice(S, T), E, S - G, E, T - G, S]), S = T - 1;
                    else {
                      let _e = B;
                      if (q >= W && q <= $ && (_e = O), _e.lastIndex = S + 1, _e.test(M), _e.lastIndex === 0 ? T = M.length - 1 : T = _e.lastIndex - 2, _e === O || q === t3) {
                        let Be = M.charCodeAt(T), Wt = M.charCodeAt(T + 1), Vt = M.charCodeAt(T + 2);
                        (Be === N || Be === I) && (Wt === f || Wt === g) && Vt >= W && Vt <= $ && (O.lastIndex = T + 2, O.test(M), O.lastIndex === 0 ? T = M.length - 1 : T = O.lastIndex - 2);
                      }
                      J.push(["word", M.slice(S, T + 1), E, S - G, E, T - G, S]), S = T;
                    }
                    break;
                }
                S++;
              }
              return J;
            };
          } }), jo = P({ "node_modules/flatten/index.js"(e, n) {
            A(), n.exports = function(u, o) {
              if (o = typeof o == "number" ? o : 1 / 0, !o)
                return Array.isArray(u) ? u.map(function(l) {
                  return l;
                }) : u;
              return h(u, 1);
              function h(l, p) {
                return l.reduce(function(m, c) {
                  return Array.isArray(c) && p < o ? m.concat(h(c, p + 1)) : m.concat(c);
                }, []);
              }
            };
          } }), Mo = P({ "node_modules/indexes-of/index.js"(e, n) {
            A(), n.exports = function(i, u) {
              for (var o = -1, h = []; (o = i.indexOf(u, o + 1)) !== -1; )
                h.push(o);
              return h;
            };
          } }), Do = P({ "node_modules/uniq/uniq.js"(e, n) {
            "use strict";
            A();
            function i(h, l) {
              for (var p = 1, m = h.length, c = h[0], t3 = h[0], r = 1; r < m; ++r)
                if (t3 = c, c = h[r], l(c, t3)) {
                  if (r === p) {
                    p++;
                    continue;
                  }
                  h[p++] = c;
                }
              return h.length = p, h;
            }
            function u(h) {
              for (var l = 1, p = h.length, m = h[0], c = h[0], t3 = 1; t3 < p; ++t3, c = m)
                if (c = m, m = h[t3], m !== c) {
                  if (t3 === l) {
                    l++;
                    continue;
                  }
                  h[l++] = m;
                }
              return h.length = l, h;
            }
            function o(h, l, p) {
              return h.length === 0 ? h : l ? (p || h.sort(l), i(h, l)) : (p || h.sort(), u(h));
            }
            n.exports = o;
          } }), vf = P({ "node_modules/postcss-values-parser/lib/errors/ParserError.js"(e, n) {
            "use strict";
            A();
            var i = class extends Error {
              constructor(u) {
                super(u), this.name = this.constructor.name, this.message = u || "An error ocurred while parsing.", typeof Error.captureStackTrace == "function" ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error(u).stack;
              }
            };
            n.exports = i;
          } }), mf = P({ "node_modules/postcss-values-parser/lib/parser.js"(e, n) {
            "use strict";
            A();
            var i = Vl(), u = io(), o = so(), h = oo(), l = ao(), p = uo(), m = co(), c = lo(), t3 = fo(), r = po(), a = ho(), s = vo(), f = mo(), g = df(), v = jo(), y = Mo(), w = Do(), d = vf();
            function _(k) {
              return k.sort((x, N) => x - N);
            }
            n.exports = class {
              constructor(x, N) {
                let I = { loose: false };
                this.cache = [], this.input = x, this.options = Object.assign({}, I, N), this.position = 0, this.unbalanced = 0, this.root = new i();
                let W = new u();
                this.root.append(W), this.current = W, this.tokens = g(x, this.options);
              }
              parse() {
                return this.loop();
              }
              colon() {
                let x = this.currToken;
                this.newNode(new h({ value: x[1], source: { start: { line: x[2], column: x[3] }, end: { line: x[4], column: x[5] } }, sourceIndex: x[6] })), this.position++;
              }
              comma() {
                let x = this.currToken;
                this.newNode(new l({ value: x[1], source: { start: { line: x[2], column: x[3] }, end: { line: x[4], column: x[5] } }, sourceIndex: x[6] })), this.position++;
              }
              comment() {
                let x = false, N = this.currToken[1].replace(/\/\*|\*\//g, ""), I;
                this.options.loose && N.startsWith("//") && (N = N.substring(2), x = true), I = new p({ value: N, inline: x, source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[4], column: this.currToken[5] } }, sourceIndex: this.currToken[6] }), this.newNode(I), this.position++;
              }
              error(x, N) {
                throw new d(x + ` at line: ${N[2]}, column ${N[3]}`);
              }
              loop() {
                for (; this.position < this.tokens.length; )
                  this.parseTokens();
                return !this.current.last && this.spaces ? this.current.raws.before += this.spaces : this.spaces && (this.current.last.raws.after += this.spaces), this.spaces = "", this.root;
              }
              operator() {
                let x = this.currToken[1], N;
                if (x === "+" || x === "-") {
                  if (this.options.loose || this.position > 0 && (this.current.type === "func" && this.current.value === "calc" ? this.prevToken[0] !== "space" && this.prevToken[0] !== "(" ? this.error("Syntax Error", this.currToken) : this.nextToken[0] !== "space" && this.nextToken[0] !== "word" ? this.error("Syntax Error", this.currToken) : this.nextToken[0] === "word" && this.current.last.type !== "operator" && this.current.last.value !== "(" && this.error("Syntax Error", this.currToken) : (this.nextToken[0] === "space" || this.nextToken[0] === "operator" || this.prevToken[0] === "operator") && this.error("Syntax Error", this.currToken)), this.options.loose) {
                    if ((!this.current.nodes.length || this.current.last && this.current.last.type === "operator") && this.nextToken[0] === "word")
                      return this.word();
                  } else if (this.nextToken[0] === "word")
                    return this.word();
                }
                return N = new t3({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] }), this.position++, this.newNode(N);
              }
              parseTokens() {
                switch (this.currToken[0]) {
                  case "space":
                    this.space();
                    break;
                  case "colon":
                    this.colon();
                    break;
                  case "comma":
                    this.comma();
                    break;
                  case "comment":
                    this.comment();
                    break;
                  case "(":
                    this.parenOpen();
                    break;
                  case ")":
                    this.parenClose();
                    break;
                  case "atword":
                  case "word":
                    this.word();
                    break;
                  case "operator":
                    this.operator();
                    break;
                  case "string":
                    this.string();
                    break;
                  case "unicoderange":
                    this.unicodeRange();
                    break;
                  default:
                    this.word();
                    break;
                }
              }
              parenOpen() {
                let x = 1, N = this.position + 1, I = this.currToken, W;
                for (; N < this.tokens.length && x; ) {
                  let $ = this.tokens[N];
                  $[0] === "(" && x++, $[0] === ")" && x--, N++;
                }
                if (x && this.error("Expected closing parenthesis", I), W = this.current.last, W && W.type === "func" && W.unbalanced < 0 && (W.unbalanced = 0, this.current = W), this.current.unbalanced++, this.newNode(new r({ value: I[1], source: { start: { line: I[2], column: I[3] }, end: { line: I[4], column: I[5] } }, sourceIndex: I[6] })), this.position++, this.current.type === "func" && this.current.unbalanced && this.current.value === "url" && this.currToken[0] !== "string" && this.currToken[0] !== ")" && !this.options.loose) {
                  let $ = this.nextToken, H = this.currToken[1], D = { line: this.currToken[2], column: this.currToken[3] };
                  for (; $ && $[0] !== ")" && this.current.unbalanced; )
                    this.position++, H += this.currToken[1], $ = this.nextToken;
                  this.position !== this.tokens.length - 1 && (this.position++, this.newNode(new s({ value: H, source: { start: D, end: { line: this.currToken[4], column: this.currToken[5] } }, sourceIndex: this.currToken[6] })));
                }
              }
              parenClose() {
                let x = this.currToken;
                this.newNode(new r({ value: x[1], source: { start: { line: x[2], column: x[3] }, end: { line: x[4], column: x[5] } }, sourceIndex: x[6] })), this.position++, !(this.position >= this.tokens.length - 1 && !this.current.unbalanced) && (this.current.unbalanced--, this.current.unbalanced < 0 && this.error("Expected opening parenthesis", x), !this.current.unbalanced && this.cache.length && (this.current = this.cache.pop()));
              }
              space() {
                let x = this.currToken;
                this.position === this.tokens.length - 1 || this.nextToken[0] === "," || this.nextToken[0] === ")" ? (this.current.last.raws.after += x[1], this.position++) : (this.spaces = x[1], this.position++);
              }
              unicodeRange() {
                let x = this.currToken;
                this.newNode(new f({ value: x[1], source: { start: { line: x[2], column: x[3] }, end: { line: x[4], column: x[5] } }, sourceIndex: x[6] })), this.position++;
              }
              splitWord() {
                let x = this.nextToken, N = this.currToken[1], I = /^[\+\-]?((\d+(\.\d*)?)|(\.\d+))([eE][\+\-]?\d+)?/, W = /^(?!\#([a-z0-9]+))[\#\{\}]/gi, $, H;
                if (!W.test(N))
                  for (; x && x[0] === "word"; ) {
                    this.position++;
                    let D = this.currToken[1];
                    N += D, x = this.nextToken;
                  }
                $ = y(N, "@"), H = _(w(v([[0], $]))), H.forEach((D, V) => {
                  let B = H[V + 1] || N.length, O = N.slice(D, B), j;
                  if (~$.indexOf(D))
                    j = new o({ value: O.slice(1), source: { start: { line: this.currToken[2], column: this.currToken[3] + D }, end: { line: this.currToken[4], column: this.currToken[3] + (B - 1) } }, sourceIndex: this.currToken[6] + H[V] });
                  else if (I.test(this.currToken[1])) {
                    let C = O.replace(I, "");
                    j = new c({ value: O.replace(C, ""), source: { start: { line: this.currToken[2], column: this.currToken[3] + D }, end: { line: this.currToken[4], column: this.currToken[3] + (B - 1) } }, sourceIndex: this.currToken[6] + H[V], unit: C });
                  } else
                    j = new (x && x[0] === "(" ? m : s)({ value: O, source: { start: { line: this.currToken[2], column: this.currToken[3] + D }, end: { line: this.currToken[4], column: this.currToken[3] + (B - 1) } }, sourceIndex: this.currToken[6] + H[V] }), j.type === "word" ? (j.isHex = /^#(.+)/.test(O), j.isColor = /^#([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(O)) : this.cache.push(this.current);
                  this.newNode(j);
                }), this.position++;
              }
              string() {
                let x = this.currToken, N = this.currToken[1], I = /^(\"|\')/, W = I.test(N), $ = "", H;
                W && ($ = N.match(I)[0], N = N.slice(1, N.length - 1)), H = new a({ value: N, source: { start: { line: x[2], column: x[3] }, end: { line: x[4], column: x[5] } }, sourceIndex: x[6], quoted: W }), H.raws.quote = $, this.newNode(H), this.position++;
              }
              word() {
                return this.splitWord();
              }
              newNode(x) {
                return this.spaces && (x.raws.before += this.spaces, this.spaces = ""), this.current.append(x);
              }
              get currToken() {
                return this.tokens[this.position];
              }
              get nextToken() {
                return this.tokens[this.position + 1];
              }
              get prevToken() {
                return this.tokens[this.position - 1];
              }
            };
          } }), gf = P({ "node_modules/postcss-values-parser/lib/index.js"(e, n) {
            "use strict";
            A();
            var i = mf(), u = so(), o = oo(), h = ao(), l = uo(), p = co(), m = lo(), c = fo(), t3 = po(), r = ho(), a = mo(), s = io(), f = vo(), g = function(v, y) {
              return new i(v, y);
            };
            g.atword = function(v) {
              return new u(v);
            }, g.colon = function(v) {
              return new o(Object.assign({ value: ":" }, v));
            }, g.comma = function(v) {
              return new h(Object.assign({ value: "," }, v));
            }, g.comment = function(v) {
              return new l(v);
            }, g.func = function(v) {
              return new p(v);
            }, g.number = function(v) {
              return new m(v);
            }, g.operator = function(v) {
              return new c(v);
            }, g.paren = function(v) {
              return new t3(Object.assign({ value: "(" }, v));
            }, g.string = function(v) {
              return new r(Object.assign({ quote: "'" }, v));
            }, g.value = function(v) {
              return new s(v);
            }, g.word = function(v) {
              return new f(v);
            }, g.unicodeRange = function(v) {
              return new a(v);
            }, n.exports = g;
          } }), ze = P({ "node_modules/postcss-selector-parser/dist/selectors/node.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
              return typeof l;
            } : function(l) {
              return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
            };
            function u(l, p) {
              if (!(l instanceof p))
                throw new TypeError("Cannot call a class as a function");
            }
            var o = function l(p, m) {
              if ((typeof p > "u" ? "undefined" : i(p)) !== "object")
                return p;
              var c = new p.constructor();
              for (var t3 in p)
                if (p.hasOwnProperty(t3)) {
                  var r = p[t3], a = typeof r > "u" ? "undefined" : i(r);
                  t3 === "parent" && a === "object" ? m && (c[t3] = m) : r instanceof Array ? c[t3] = r.map(function(s) {
                    return l(s, c);
                  }) : c[t3] = l(r, c);
                }
              return c;
            }, h = function() {
              function l() {
                var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                u(this, l);
                for (var m in p)
                  this[m] = p[m];
                var c = p.spaces;
                c = c === void 0 ? {} : c;
                var t3 = c.before, r = t3 === void 0 ? "" : t3, a = c.after, s = a === void 0 ? "" : a;
                this.spaces = { before: r, after: s };
              }
              return l.prototype.remove = function() {
                return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
              }, l.prototype.replaceWith = function() {
                if (this.parent) {
                  for (var m in arguments)
                    this.parent.insertBefore(this, arguments[m]);
                  this.remove();
                }
                return this;
              }, l.prototype.next = function() {
                return this.parent.at(this.parent.index(this) + 1);
              }, l.prototype.prev = function() {
                return this.parent.at(this.parent.index(this) - 1);
              }, l.prototype.clone = function() {
                var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = o(this);
                for (var t3 in m)
                  c[t3] = m[t3];
                return c;
              }, l.prototype.toString = function() {
                return [this.spaces.before, String(this.value), this.spaces.after].join("");
              }, l;
            }();
            e.default = h, n.exports = e.default;
          } }), se = P({ "node_modules/postcss-selector-parser/dist/selectors/types.js"(e) {
            "use strict";
            A(), e.__esModule = true;
            var n = e.TAG = "tag", i = e.STRING = "string", u = e.SELECTOR = "selector", o = e.ROOT = "root", h = e.PSEUDO = "pseudo", l = e.NESTING = "nesting", p = e.ID = "id", m = e.COMMENT = "comment", c = e.COMBINATOR = "combinator", t3 = e.CLASS = "class", r = e.ATTRIBUTE = "attribute", a = e.UNIVERSAL = "universal";
          } }), Dt = P({ "node_modules/postcss-selector-parser/dist/selectors/container.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = function() {
              function s(f, g) {
                for (var v = 0; v < g.length; v++) {
                  var y = g[v];
                  y.enumerable = y.enumerable || false, y.configurable = true, "value" in y && (y.writable = true), Object.defineProperty(f, y.key, y);
                }
              }
              return function(f, g, v) {
                return g && s(f.prototype, g), v && s(f, v), f;
              };
            }(), u = ze(), o = m(u), h = se(), l = p(h);
            function p(s) {
              if (s && s.__esModule)
                return s;
              var f = {};
              if (s != null)
                for (var g in s)
                  Object.prototype.hasOwnProperty.call(s, g) && (f[g] = s[g]);
              return f.default = s, f;
            }
            function m(s) {
              return s && s.__esModule ? s : { default: s };
            }
            function c(s, f) {
              if (!(s instanceof f))
                throw new TypeError("Cannot call a class as a function");
            }
            function t3(s, f) {
              if (!s)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return f && (typeof f == "object" || typeof f == "function") ? f : s;
            }
            function r(s, f) {
              if (typeof f != "function" && f !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof f);
              s.prototype = Object.create(f && f.prototype, { constructor: { value: s, enumerable: false, writable: true, configurable: true } }), f && (Object.setPrototypeOf ? Object.setPrototypeOf(s, f) : s.__proto__ = f);
            }
            var a = function(s) {
              r(f, s);
              function f(g) {
                c(this, f);
                var v = t3(this, s.call(this, g));
                return v.nodes || (v.nodes = []), v;
              }
              return f.prototype.append = function(v) {
                return v.parent = this, this.nodes.push(v), this;
              }, f.prototype.prepend = function(v) {
                return v.parent = this, this.nodes.unshift(v), this;
              }, f.prototype.at = function(v) {
                return this.nodes[v];
              }, f.prototype.index = function(v) {
                return typeof v == "number" ? v : this.nodes.indexOf(v);
              }, f.prototype.removeChild = function(v) {
                v = this.index(v), this.at(v).parent = void 0, this.nodes.splice(v, 1);
                var y = void 0;
                for (var w in this.indexes)
                  y = this.indexes[w], y >= v && (this.indexes[w] = y - 1);
                return this;
              }, f.prototype.removeAll = function() {
                for (var w = this.nodes, v = Array.isArray(w), y = 0, w = v ? w : w[Symbol.iterator](); ; ) {
                  var d;
                  if (v) {
                    if (y >= w.length)
                      break;
                    d = w[y++];
                  } else {
                    if (y = w.next(), y.done)
                      break;
                    d = y.value;
                  }
                  var _ = d;
                  _.parent = void 0;
                }
                return this.nodes = [], this;
              }, f.prototype.empty = function() {
                return this.removeAll();
              }, f.prototype.insertAfter = function(v, y) {
                var w = this.index(v);
                this.nodes.splice(w + 1, 0, y);
                var d = void 0;
                for (var _ in this.indexes)
                  d = this.indexes[_], w <= d && (this.indexes[_] = d + this.nodes.length);
                return this;
              }, f.prototype.insertBefore = function(v, y) {
                var w = this.index(v);
                this.nodes.splice(w, 0, y);
                var d = void 0;
                for (var _ in this.indexes)
                  d = this.indexes[_], w <= d && (this.indexes[_] = d + this.nodes.length);
                return this;
              }, f.prototype.each = function(v) {
                this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach++;
                var y = this.lastEach;
                if (this.indexes[y] = 0, !!this.length) {
                  for (var w = void 0, d = void 0; this.indexes[y] < this.length && (w = this.indexes[y], d = v(this.at(w), w), d !== false); )
                    this.indexes[y] += 1;
                  if (delete this.indexes[y], d === false)
                    return false;
                }
              }, f.prototype.walk = function(v) {
                return this.each(function(y, w) {
                  var d = v(y, w);
                  if (d !== false && y.length && (d = y.walk(v)), d === false)
                    return false;
                });
              }, f.prototype.walkAttributes = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.ATTRIBUTE)
                    return v.call(y, w);
                });
              }, f.prototype.walkClasses = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.CLASS)
                    return v.call(y, w);
                });
              }, f.prototype.walkCombinators = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.COMBINATOR)
                    return v.call(y, w);
                });
              }, f.prototype.walkComments = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.COMMENT)
                    return v.call(y, w);
                });
              }, f.prototype.walkIds = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.ID)
                    return v.call(y, w);
                });
              }, f.prototype.walkNesting = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.NESTING)
                    return v.call(y, w);
                });
              }, f.prototype.walkPseudos = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.PSEUDO)
                    return v.call(y, w);
                });
              }, f.prototype.walkTags = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.TAG)
                    return v.call(y, w);
                });
              }, f.prototype.walkUniversals = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.UNIVERSAL)
                    return v.call(y, w);
                });
              }, f.prototype.split = function(v) {
                var y = this, w = [];
                return this.reduce(function(d, _, k) {
                  var x = v.call(y, _);
                  return w.push(_), x ? (d.push(w), w = []) : k === y.length - 1 && d.push(w), d;
                }, []);
              }, f.prototype.map = function(v) {
                return this.nodes.map(v);
              }, f.prototype.reduce = function(v, y) {
                return this.nodes.reduce(v, y);
              }, f.prototype.every = function(v) {
                return this.nodes.every(v);
              }, f.prototype.some = function(v) {
                return this.nodes.some(v);
              }, f.prototype.filter = function(v) {
                return this.nodes.filter(v);
              }, f.prototype.sort = function(v) {
                return this.nodes.sort(v);
              }, f.prototype.toString = function() {
                return this.map(String).join("");
              }, i(f, [{ key: "first", get: function() {
                return this.at(0);
              } }, { key: "last", get: function() {
                return this.at(this.length - 1);
              } }, { key: "length", get: function() {
                return this.nodes.length;
              } }]), f;
            }(o.default);
            e.default = a, n.exports = e.default;
          } }), Lo = P({ "node_modules/postcss-selector-parser/dist/selectors/root.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Dt(), u = h(i), o = se();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = p(this, t3.call(this, a));
                return s.type = o.ROOT, s;
              }
              return r.prototype.toString = function() {
                var s = this.reduce(function(f, g) {
                  var v = String(g);
                  return v ? f + v + "," : "";
                }, "").slice(0, -1);
                return this.trailingComma ? s + "," : s;
              }, r;
            }(u.default);
            e.default = c, n.exports = e.default;
          } }), zo = P({ "node_modules/postcss-selector-parser/dist/selectors/selector.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Dt(), u = h(i), o = se();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = p(this, t3.call(this, a));
                return s.type = o.SELECTOR, s;
              }
              return r;
            }(u.default);
            e.default = c, n.exports = e.default;
          } }), Ye = P({ "node_modules/postcss-selector-parser/dist/selectors/namespace.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = function() {
              function t3(r, a) {
                for (var s = 0; s < a.length; s++) {
                  var f = a[s];
                  f.enumerable = f.enumerable || false, f.configurable = true, "value" in f && (f.writable = true), Object.defineProperty(r, f.key, f);
                }
              }
              return function(r, a, s) {
                return a && t3(r.prototype, a), s && t3(r, s), r;
              };
            }(), u = ze(), o = h(u);
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              m(r, t3);
              function r() {
                return l(this, r), p(this, t3.apply(this, arguments));
              }
              return r.prototype.toString = function() {
                return [this.spaces.before, this.ns, String(this.value), this.spaces.after].join("");
              }, i(r, [{ key: "ns", get: function() {
                var s = this.namespace;
                return s ? (typeof s == "string" ? s : "") + "|" : "";
              } }]), r;
            }(o.default);
            e.default = c, n.exports = e.default;
          } }), Bo = P({ "node_modules/postcss-selector-parser/dist/selectors/className.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ye(), u = h(i), o = se();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = p(this, t3.call(this, a));
                return s.type = o.CLASS, s;
              }
              return r.prototype.toString = function() {
                return [this.spaces.before, this.ns, String("." + this.value), this.spaces.after].join("");
              }, r;
            }(u.default);
            e.default = c, n.exports = e.default;
          } }), Fo = P({ "node_modules/postcss-selector-parser/dist/selectors/comment.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = ze(), u = h(i), o = se();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = p(this, t3.call(this, a));
                return s.type = o.COMMENT, s;
              }
              return r;
            }(u.default);
            e.default = c, n.exports = e.default;
          } }), Uo = P({ "node_modules/postcss-selector-parser/dist/selectors/id.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ye(), u = h(i), o = se();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = p(this, t3.call(this, a));
                return s.type = o.ID, s;
              }
              return r.prototype.toString = function() {
                return [this.spaces.before, this.ns, String("#" + this.value), this.spaces.after].join("");
              }, r;
            }(u.default);
            e.default = c, n.exports = e.default;
          } }), $o = P({ "node_modules/postcss-selector-parser/dist/selectors/tag.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ye(), u = h(i), o = se();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = p(this, t3.call(this, a));
                return s.type = o.TAG, s;
              }
              return r;
            }(u.default);
            e.default = c, n.exports = e.default;
          } }), Wo = P({ "node_modules/postcss-selector-parser/dist/selectors/string.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = ze(), u = h(i), o = se();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = p(this, t3.call(this, a));
                return s.type = o.STRING, s;
              }
              return r;
            }(u.default);
            e.default = c, n.exports = e.default;
          } }), Vo = P({ "node_modules/postcss-selector-parser/dist/selectors/pseudo.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Dt(), u = h(i), o = se();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = p(this, t3.call(this, a));
                return s.type = o.PSEUDO, s;
              }
              return r.prototype.toString = function() {
                var s = this.length ? "(" + this.map(String).join(",") + ")" : "";
                return [this.spaces.before, String(this.value), s, this.spaces.after].join("");
              }, r;
            }(u.default);
            e.default = c, n.exports = e.default;
          } }), Go = P({ "node_modules/postcss-selector-parser/dist/selectors/attribute.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ye(), u = h(i), o = se();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = p(this, t3.call(this, a));
                return s.type = o.ATTRIBUTE, s.raws = {}, s;
              }
              return r.prototype.toString = function() {
                var s = [this.spaces.before, "[", this.ns, this.attribute];
                return this.operator && s.push(this.operator), this.value && s.push(this.value), this.raws.insensitive ? s.push(this.raws.insensitive) : this.insensitive && s.push(" i"), s.push("]"), s.concat(this.spaces.after).join("");
              }, r;
            }(u.default);
            e.default = c, n.exports = e.default;
          } }), Ho = P({ "node_modules/postcss-selector-parser/dist/selectors/universal.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ye(), u = h(i), o = se();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = p(this, t3.call(this, a));
                return s.type = o.UNIVERSAL, s.value = "*", s;
              }
              return r;
            }(u.default);
            e.default = c, n.exports = e.default;
          } }), Jo = P({ "node_modules/postcss-selector-parser/dist/selectors/combinator.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = ze(), u = h(i), o = se();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = p(this, t3.call(this, a));
                return s.type = o.COMBINATOR, s;
              }
              return r;
            }(u.default);
            e.default = c, n.exports = e.default;
          } }), Ko = P({ "node_modules/postcss-selector-parser/dist/selectors/nesting.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = ze(), u = h(i), o = se();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = p(this, t3.call(this, a));
                return s.type = o.NESTING, s.value = "&", s;
              }
              return r;
            }(u.default);
            e.default = c, n.exports = e.default;
          } }), yf = P({ "node_modules/postcss-selector-parser/dist/sortAscending.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = i;
            function i(u) {
              return u.sort(function(o, h) {
                return o - h;
              });
            }
            n.exports = e.default;
          } }), wf = P({ "node_modules/postcss-selector-parser/dist/tokenize.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = H;
            var i = 39, u = 34, o = 92, h = 47, l = 10, p = 32, m = 12, c = 9, t3 = 13, r = 43, a = 62, s = 126, f = 124, g = 44, v = 40, y = 41, w = 91, d = 93, _ = 59, k = 42, x = 58, N = 38, I = 64, W = /[ \n\t\r\{\(\)'"\\;/]/g, $ = /[ \n\t\r\(\)\*:;@!&'"\+\|~>,\[\]\\]|\/(?=\*)/g;
            function H(D) {
              for (var V = [], B = D.css.valueOf(), O = void 0, j = void 0, C = void 0, R = void 0, X = void 0, Z = void 0, Q = void 0, K = void 0, J = void 0, M = void 0, Y = void 0, G = B.length, E = -1, S = 1, b = 0, L = function(T, F) {
                if (D.safe)
                  B += F, j = B.length - 1;
                else
                  throw D.error("Unclosed " + T, S, b - E, b);
              }; b < G; ) {
                switch (O = B.charCodeAt(b), O === l && (E = b, S += 1), O) {
                  case l:
                  case p:
                  case c:
                  case t3:
                  case m:
                    j = b;
                    do
                      j += 1, O = B.charCodeAt(j), O === l && (E = j, S += 1);
                    while (O === p || O === l || O === c || O === t3 || O === m);
                    V.push(["space", B.slice(b, j), S, b - E, b]), b = j - 1;
                    break;
                  case r:
                  case a:
                  case s:
                  case f:
                    j = b;
                    do
                      j += 1, O = B.charCodeAt(j);
                    while (O === r || O === a || O === s || O === f);
                    V.push(["combinator", B.slice(b, j), S, b - E, b]), b = j - 1;
                    break;
                  case k:
                    V.push(["*", "*", S, b - E, b]);
                    break;
                  case N:
                    V.push(["&", "&", S, b - E, b]);
                    break;
                  case g:
                    V.push([",", ",", S, b - E, b]);
                    break;
                  case w:
                    V.push(["[", "[", S, b - E, b]);
                    break;
                  case d:
                    V.push(["]", "]", S, b - E, b]);
                    break;
                  case x:
                    V.push([":", ":", S, b - E, b]);
                    break;
                  case _:
                    V.push([";", ";", S, b - E, b]);
                    break;
                  case v:
                    V.push(["(", "(", S, b - E, b]);
                    break;
                  case y:
                    V.push([")", ")", S, b - E, b]);
                    break;
                  case i:
                  case u:
                    C = O === i ? "'" : '"', j = b;
                    do
                      for (M = false, j = B.indexOf(C, j + 1), j === -1 && L("quote", C), Y = j; B.charCodeAt(Y - 1) === o; )
                        Y -= 1, M = !M;
                    while (M);
                    V.push(["string", B.slice(b, j + 1), S, b - E, S, j - E, b]), b = j;
                    break;
                  case I:
                    W.lastIndex = b + 1, W.test(B), W.lastIndex === 0 ? j = B.length - 1 : j = W.lastIndex - 2, V.push(["at-word", B.slice(b, j + 1), S, b - E, S, j - E, b]), b = j;
                    break;
                  case o:
                    for (j = b, Q = true; B.charCodeAt(j + 1) === o; )
                      j += 1, Q = !Q;
                    O = B.charCodeAt(j + 1), Q && O !== h && O !== p && O !== l && O !== c && O !== t3 && O !== m && (j += 1), V.push(["word", B.slice(b, j + 1), S, b - E, S, j - E, b]), b = j;
                    break;
                  default:
                    O === h && B.charCodeAt(b + 1) === k ? (j = B.indexOf("*/", b + 2) + 1, j === 0 && L("comment", "*/"), Z = B.slice(b, j + 1), R = Z.split(`
`), X = R.length - 1, X > 0 ? (K = S + X, J = j - R[X].length) : (K = S, J = E), V.push(["comment", Z, S, b - E, K, j - J, b]), E = J, S = K, b = j) : ($.lastIndex = b + 1, $.test(B), $.lastIndex === 0 ? j = B.length - 1 : j = $.lastIndex - 2, V.push(["word", B.slice(b, j + 1), S, b - E, S, j - E, b]), b = j);
                    break;
                }
                b++;
              }
              return V;
            }
            n.exports = e.default;
          } }), _f = P({ "node_modules/postcss-selector-parser/dist/parser.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = function() {
              function E(S, b) {
                for (var L = 0; L < b.length; L++) {
                  var q = b[L];
                  q.enumerable = q.enumerable || false, q.configurable = true, "value" in q && (q.writable = true), Object.defineProperty(S, q.key, q);
                }
              }
              return function(S, b, L) {
                return b && E(S.prototype, b), L && E(S, L), S;
              };
            }(), u = jo(), o = M(u), h = Mo(), l = M(h), p = Do(), m = M(p), c = Lo(), t3 = M(c), r = zo(), a = M(r), s = Bo(), f = M(s), g = Fo(), v = M(g), y = Uo(), w = M(y), d = $o(), _ = M(d), k = Wo(), x = M(k), N = Vo(), I = M(N), W = Go(), $ = M(W), H = Ho(), D = M(H), V = Jo(), B = M(V), O = Ko(), j = M(O), C = yf(), R = M(C), X = wf(), Z = M(X), Q = se(), K = J(Q);
            function J(E) {
              if (E && E.__esModule)
                return E;
              var S = {};
              if (E != null)
                for (var b in E)
                  Object.prototype.hasOwnProperty.call(E, b) && (S[b] = E[b]);
              return S.default = E, S;
            }
            function M(E) {
              return E && E.__esModule ? E : { default: E };
            }
            function Y(E, S) {
              if (!(E instanceof S))
                throw new TypeError("Cannot call a class as a function");
            }
            var G = function() {
              function E(S) {
                Y(this, E), this.input = S, this.lossy = S.options.lossless === false, this.position = 0, this.root = new t3.default();
                var b = new a.default();
                return this.root.append(b), this.current = b, this.lossy ? this.tokens = (0, Z.default)({ safe: S.safe, css: S.css.trim() }) : this.tokens = (0, Z.default)(S), this.loop();
              }
              return E.prototype.attribute = function() {
                var b = "", L = void 0, q = this.currToken;
                for (this.position++; this.position < this.tokens.length && this.currToken[0] !== "]"; )
                  b += this.tokens[this.position][1], this.position++;
                this.position === this.tokens.length && !~b.indexOf("]") && this.error("Expected a closing square bracket.");
                var T = b.split(/((?:[*~^$|]?=))([^]*)/), F = T[0].split(/(\|)/g), z = { operator: T[1], value: T[2], source: { start: { line: q[2], column: q[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: q[4] };
                if (F.length > 1 ? (F[0] === "" && (F[0] = true), z.attribute = this.parseValue(F[2]), z.namespace = this.parseNamespace(F[0])) : z.attribute = this.parseValue(T[0]), L = new $.default(z), T[2]) {
                  var ee = T[2].split(/(\s+i\s*?)$/), te = ee[0].trim();
                  L.value = this.lossy ? te : ee[0], ee[1] && (L.insensitive = true, this.lossy || (L.raws.insensitive = ee[1])), L.quoted = te[0] === "'" || te[0] === '"', L.raws.unquoted = L.quoted ? te.slice(1, -1) : te;
                }
                this.newNode(L), this.position++;
              }, E.prototype.combinator = function() {
                if (this.currToken[1] === "|")
                  return this.namespace();
                for (var b = new B.default({ value: "", source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] }); this.position < this.tokens.length && this.currToken && (this.currToken[0] === "space" || this.currToken[0] === "combinator"); )
                  this.nextToken && this.nextToken[0] === "combinator" ? (b.spaces.before = this.parseSpace(this.currToken[1]), b.source.start.line = this.nextToken[2], b.source.start.column = this.nextToken[3], b.source.end.column = this.nextToken[3], b.source.end.line = this.nextToken[2], b.sourceIndex = this.nextToken[4]) : this.prevToken && this.prevToken[0] === "combinator" ? b.spaces.after = this.parseSpace(this.currToken[1]) : this.currToken[0] === "combinator" ? b.value = this.currToken[1] : this.currToken[0] === "space" && (b.value = this.parseSpace(this.currToken[1], " ")), this.position++;
                return this.newNode(b);
              }, E.prototype.comma = function() {
                if (this.position === this.tokens.length - 1) {
                  this.root.trailingComma = true, this.position++;
                  return;
                }
                var b = new a.default();
                this.current.parent.append(b), this.current = b, this.position++;
              }, E.prototype.comment = function() {
                var b = new v.default({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[4], column: this.currToken[5] } }, sourceIndex: this.currToken[6] });
                this.newNode(b), this.position++;
              }, E.prototype.error = function(b) {
                throw new this.input.error(b);
              }, E.prototype.missingBackslash = function() {
                return this.error("Expected a backslash preceding the semicolon.");
              }, E.prototype.missingParenthesis = function() {
                return this.error("Expected opening parenthesis.");
              }, E.prototype.missingSquareBracket = function() {
                return this.error("Expected opening square bracket.");
              }, E.prototype.namespace = function() {
                var b = this.prevToken && this.prevToken[1] || true;
                if (this.nextToken[0] === "word")
                  return this.position++, this.word(b);
                if (this.nextToken[0] === "*")
                  return this.position++, this.universal(b);
              }, E.prototype.nesting = function() {
                this.newNode(new j.default({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] })), this.position++;
              }, E.prototype.parentheses = function() {
                var b = this.current.last;
                if (b && b.type === K.PSEUDO) {
                  var L = new a.default(), q = this.current;
                  b.append(L), this.current = L;
                  var T = 1;
                  for (this.position++; this.position < this.tokens.length && T; )
                    this.currToken[0] === "(" && T++, this.currToken[0] === ")" && T--, T ? this.parse() : (L.parent.source.end.line = this.currToken[2], L.parent.source.end.column = this.currToken[3], this.position++);
                  T && this.error("Expected closing parenthesis."), this.current = q;
                } else {
                  var F = 1;
                  for (this.position++, b.value += "("; this.position < this.tokens.length && F; )
                    this.currToken[0] === "(" && F++, this.currToken[0] === ")" && F--, b.value += this.parseParenthesisToken(this.currToken), this.position++;
                  F && this.error("Expected closing parenthesis.");
                }
              }, E.prototype.pseudo = function() {
                for (var b = this, L = "", q = this.currToken; this.currToken && this.currToken[0] === ":"; )
                  L += this.currToken[1], this.position++;
                if (!this.currToken)
                  return this.error("Expected pseudo-class or pseudo-element");
                if (this.currToken[0] === "word") {
                  var T = void 0;
                  this.splitWord(false, function(F, z) {
                    L += F, T = new I.default({ value: L, source: { start: { line: q[2], column: q[3] }, end: { line: b.currToken[4], column: b.currToken[5] } }, sourceIndex: q[4] }), b.newNode(T), z > 1 && b.nextToken && b.nextToken[0] === "(" && b.error("Misplaced parenthesis.");
                  });
                } else
                  this.error('Unexpected "' + this.currToken[0] + '" found.');
              }, E.prototype.space = function() {
                var b = this.currToken;
                this.position === 0 || this.prevToken[0] === "," || this.prevToken[0] === "(" ? (this.spaces = this.parseSpace(b[1]), this.position++) : this.position === this.tokens.length - 1 || this.nextToken[0] === "," || this.nextToken[0] === ")" ? (this.current.last.spaces.after = this.parseSpace(b[1]), this.position++) : this.combinator();
              }, E.prototype.string = function() {
                var b = this.currToken;
                this.newNode(new x.default({ value: this.currToken[1], source: { start: { line: b[2], column: b[3] }, end: { line: b[4], column: b[5] } }, sourceIndex: b[6] })), this.position++;
              }, E.prototype.universal = function(b) {
                var L = this.nextToken;
                if (L && L[1] === "|")
                  return this.position++, this.namespace();
                this.newNode(new D.default({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] }), b), this.position++;
              }, E.prototype.splitWord = function(b, L) {
                for (var q = this, T = this.nextToken, F = this.currToken[1]; T && T[0] === "word"; ) {
                  this.position++;
                  var z = this.currToken[1];
                  if (F += z, z.lastIndexOf("\\") === z.length - 1) {
                    var ee = this.nextToken;
                    ee && ee[0] === "space" && (F += this.parseSpace(ee[1], " "), this.position++);
                  }
                  T = this.nextToken;
                }
                var te = (0, l.default)(F, "."), ue = (0, l.default)(F, "#"), le = (0, l.default)(F, "#{");
                le.length && (ue = ue.filter(function(ne) {
                  return !~le.indexOf(ne);
                }));
                var re = (0, R.default)((0, m.default)((0, o.default)([[0], te, ue])));
                re.forEach(function(ne, oe) {
                  var ie = re[oe + 1] || F.length, ce = F.slice(ne, ie);
                  if (oe === 0 && L)
                    return L.call(q, ce, re.length);
                  var fe = void 0;
                  ~te.indexOf(ne) ? fe = new f.default({ value: ce.slice(1), source: { start: { line: q.currToken[2], column: q.currToken[3] + ne }, end: { line: q.currToken[4], column: q.currToken[3] + (ie - 1) } }, sourceIndex: q.currToken[6] + re[oe] }) : ~ue.indexOf(ne) ? fe = new w.default({ value: ce.slice(1), source: { start: { line: q.currToken[2], column: q.currToken[3] + ne }, end: { line: q.currToken[4], column: q.currToken[3] + (ie - 1) } }, sourceIndex: q.currToken[6] + re[oe] }) : fe = new _.default({ value: ce, source: { start: { line: q.currToken[2], column: q.currToken[3] + ne }, end: { line: q.currToken[4], column: q.currToken[3] + (ie - 1) } }, sourceIndex: q.currToken[6] + re[oe] }), q.newNode(fe, b);
                }), this.position++;
              }, E.prototype.word = function(b) {
                var L = this.nextToken;
                return L && L[1] === "|" ? (this.position++, this.namespace()) : this.splitWord(b);
              }, E.prototype.loop = function() {
                for (; this.position < this.tokens.length; )
                  this.parse(true);
                return this.root;
              }, E.prototype.parse = function(b) {
                switch (this.currToken[0]) {
                  case "space":
                    this.space();
                    break;
                  case "comment":
                    this.comment();
                    break;
                  case "(":
                    this.parentheses();
                    break;
                  case ")":
                    b && this.missingParenthesis();
                    break;
                  case "[":
                    this.attribute();
                    break;
                  case "]":
                    this.missingSquareBracket();
                    break;
                  case "at-word":
                  case "word":
                    this.word();
                    break;
                  case ":":
                    this.pseudo();
                    break;
                  case ";":
                    this.missingBackslash();
                    break;
                  case ",":
                    this.comma();
                    break;
                  case "*":
                    this.universal();
                    break;
                  case "&":
                    this.nesting();
                    break;
                  case "combinator":
                    this.combinator();
                    break;
                  case "string":
                    this.string();
                    break;
                }
              }, E.prototype.parseNamespace = function(b) {
                if (this.lossy && typeof b == "string") {
                  var L = b.trim();
                  return L.length ? L : true;
                }
                return b;
              }, E.prototype.parseSpace = function(b, L) {
                return this.lossy ? L || "" : b;
              }, E.prototype.parseValue = function(b) {
                return this.lossy && b && typeof b == "string" ? b.trim() : b;
              }, E.prototype.parseParenthesisToken = function(b) {
                return this.lossy ? b[0] === "space" ? this.parseSpace(b[1], " ") : this.parseValue(b[1]) : b[1];
              }, E.prototype.newNode = function(b, L) {
                return L && (b.namespace = this.parseNamespace(L)), this.spaces && (b.spaces.before = this.spaces, this.spaces = ""), this.current.append(b);
              }, i(E, [{ key: "currToken", get: function() {
                return this.tokens[this.position];
              } }, { key: "nextToken", get: function() {
                return this.tokens[this.position + 1];
              } }, { key: "prevToken", get: function() {
                return this.tokens[this.position - 1];
              } }]), E;
            }();
            e.default = G, n.exports = e.default;
          } }), bf = P({ "node_modules/postcss-selector-parser/dist/processor.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = function() {
              function m(c, t3) {
                for (var r = 0; r < t3.length; r++) {
                  var a = t3[r];
                  a.enumerable = a.enumerable || false, a.configurable = true, "value" in a && (a.writable = true), Object.defineProperty(c, a.key, a);
                }
              }
              return function(c, t3, r) {
                return t3 && m(c.prototype, t3), r && m(c, r), c;
              };
            }(), u = _f(), o = h(u);
            function h(m) {
              return m && m.__esModule ? m : { default: m };
            }
            function l(m, c) {
              if (!(m instanceof c))
                throw new TypeError("Cannot call a class as a function");
            }
            var p = function() {
              function m(c) {
                return l(this, m), this.func = c || function() {
                }, this;
              }
              return m.prototype.process = function(t3) {
                var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = new o.default({ css: t3, error: function(f) {
                  throw new Error(f);
                }, options: r });
                return this.res = a, this.func(a), this;
              }, i(m, [{ key: "result", get: function() {
                return String(this.res);
              } }]), m;
            }();
            e.default = p, n.exports = e.default;
          } }), xf = P({ "node_modules/postcss-selector-parser/dist/index.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = bf(), u = O(i), o = Go(), h = O(o), l = Bo(), p = O(l), m = Jo(), c = O(m), t3 = Fo(), r = O(t3), a = Uo(), s = O(a), f = Ko(), g = O(f), v = Vo(), y = O(v), w = Lo(), d = O(w), _ = zo(), k = O(_), x = Wo(), N = O(x), I = $o(), W = O(I), $ = Ho(), H = O($), D = se(), V = B(D);
            function B(C) {
              if (C && C.__esModule)
                return C;
              var R = {};
              if (C != null)
                for (var X in C)
                  Object.prototype.hasOwnProperty.call(C, X) && (R[X] = C[X]);
              return R.default = C, R;
            }
            function O(C) {
              return C && C.__esModule ? C : { default: C };
            }
            var j = function(R) {
              return new u.default(R);
            };
            j.attribute = function(C) {
              return new h.default(C);
            }, j.className = function(C) {
              return new p.default(C);
            }, j.combinator = function(C) {
              return new c.default(C);
            }, j.comment = function(C) {
              return new r.default(C);
            }, j.id = function(C) {
              return new s.default(C);
            }, j.nesting = function(C) {
              return new g.default(C);
            }, j.pseudo = function(C) {
              return new y.default(C);
            }, j.root = function(C) {
              return new d.default(C);
            }, j.selector = function(C) {
              return new k.default(C);
            }, j.string = function(C) {
              return new N.default(C);
            }, j.tag = function(C) {
              return new W.default(C);
            }, j.universal = function(C) {
              return new H.default(C);
            }, Object.keys(V).forEach(function(C) {
              C !== "__esModule" && (j[C] = V[C]);
            }), e.default = j, n.exports = e.default;
          } }), Qo = P({ "node_modules/postcss-media-query-parser/dist/nodes/Node.js"(e) {
            "use strict";
            A(), Object.defineProperty(e, "__esModule", { value: true });
            function n(i) {
              this.after = i.after, this.before = i.before, this.type = i.type, this.value = i.value, this.sourceIndex = i.sourceIndex;
            }
            e.default = n;
          } }), Yo = P({ "node_modules/postcss-media-query-parser/dist/nodes/Container.js"(e) {
            "use strict";
            A(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Qo(), i = u(n);
            function u(h) {
              return h && h.__esModule ? h : { default: h };
            }
            function o(h) {
              var l = this;
              this.constructor(h), this.nodes = h.nodes, this.after === void 0 && (this.after = this.nodes.length > 0 ? this.nodes[this.nodes.length - 1].after : ""), this.before === void 0 && (this.before = this.nodes.length > 0 ? this.nodes[0].before : ""), this.sourceIndex === void 0 && (this.sourceIndex = this.before.length), this.nodes.forEach(function(p) {
                p.parent = l;
              });
            }
            o.prototype = Object.create(i.default.prototype), o.constructor = i.default, o.prototype.walk = function(l, p) {
              for (var m = typeof l == "string" || l instanceof RegExp, c = m ? p : l, t3 = typeof l == "string" ? new RegExp(l) : l, r = 0; r < this.nodes.length; r++) {
                var a = this.nodes[r], s = m ? t3.test(a.type) : true;
                if (s && c && c(a, r, this.nodes) === false || a.nodes && a.walk(l, p) === false)
                  return false;
              }
              return true;
            }, o.prototype.each = function() {
              for (var l = arguments.length <= 0 || arguments[0] === void 0 ? function() {
              } : arguments[0], p = 0; p < this.nodes.length; p++) {
                var m = this.nodes[p];
                if (l(m, p, this.nodes) === false)
                  return false;
              }
              return true;
            }, e.default = o;
          } }), Sf = P({ "node_modules/postcss-media-query-parser/dist/parsers.js"(e) {
            "use strict";
            A(), Object.defineProperty(e, "__esModule", { value: true }), e.parseMediaFeature = l, e.parseMediaQuery = p, e.parseMediaList = m;
            var n = Qo(), i = h(n), u = Yo(), o = h(u);
            function h(c) {
              return c && c.__esModule ? c : { default: c };
            }
            function l(c) {
              var t3 = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1], r = [{ mode: "normal", character: null }], a = [], s = 0, f = "", g = null, v = null, y = t3, w = c;
              c[0] === "(" && c[c.length - 1] === ")" && (w = c.substring(1, c.length - 1), y++);
              for (var d = 0; d < w.length; d++) {
                var _ = w[d];
                if ((_ === "'" || _ === '"') && (r[s].isCalculationEnabled === true ? (r.push({ mode: "string", isCalculationEnabled: false, character: _ }), s++) : r[s].mode === "string" && r[s].character === _ && w[d - 1] !== "\\" && (r.pop(), s--)), _ === "{" ? (r.push({ mode: "interpolation", isCalculationEnabled: true }), s++) : _ === "}" && (r.pop(), s--), r[s].mode === "normal" && _ === ":") {
                  var k = w.substring(d + 1);
                  v = { type: "value", before: /^(\s*)/.exec(k)[1], after: /(\s*)$/.exec(k)[1], value: k.trim() }, v.sourceIndex = v.before.length + d + 1 + y, g = { type: "colon", sourceIndex: d + y, after: v.before, value: ":" };
                  break;
                }
                f += _;
              }
              return f = { type: "media-feature", before: /^(\s*)/.exec(f)[1], after: /(\s*)$/.exec(f)[1], value: f.trim() }, f.sourceIndex = f.before.length + y, a.push(f), g !== null && (g.before = f.after, a.push(g)), v !== null && a.push(v), a;
            }
            function p(c) {
              var t3 = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1], r = [], a = 0, s = false, f = void 0;
              function g() {
                return { before: "", after: "", value: "" };
              }
              f = g();
              for (var v = 0; v < c.length; v++) {
                var y = c[v];
                s ? (f.value += y, (y === "{" || y === "(") && a++, (y === ")" || y === "}") && a--) : y.search(/\s/) !== -1 ? f.before += y : (y === "(" && (f.type = "media-feature-expression", a++), f.value = y, f.sourceIndex = t3 + v, s = true), s && a === 0 && (y === ")" || v === c.length - 1 || c[v + 1].search(/\s/) !== -1) && (["not", "only", "and"].indexOf(f.value) !== -1 && (f.type = "keyword"), f.type === "media-feature-expression" && (f.nodes = l(f.value, f.sourceIndex)), r.push(Array.isArray(f.nodes) ? new o.default(f) : new i.default(f)), f = g(), s = false);
              }
              for (var w = 0; w < r.length; w++)
                if (f = r[w], w > 0 && (r[w - 1].after = f.before), f.type === void 0) {
                  if (w > 0) {
                    if (r[w - 1].type === "media-feature-expression") {
                      f.type = "keyword";
                      continue;
                    }
                    if (r[w - 1].value === "not" || r[w - 1].value === "only") {
                      f.type = "media-type";
                      continue;
                    }
                    if (r[w - 1].value === "and") {
                      f.type = "media-feature-expression";
                      continue;
                    }
                    r[w - 1].type === "media-type" && (r[w + 1] ? f.type = r[w + 1].type === "media-feature-expression" ? "keyword" : "media-feature-expression" : f.type = "media-feature-expression");
                  }
                  if (w === 0) {
                    if (!r[w + 1]) {
                      f.type = "media-type";
                      continue;
                    }
                    if (r[w + 1] && (r[w + 1].type === "media-feature-expression" || r[w + 1].type === "keyword")) {
                      f.type = "media-type";
                      continue;
                    }
                    if (r[w + 2]) {
                      if (r[w + 2].type === "media-feature-expression") {
                        f.type = "media-type", r[w + 1].type = "keyword";
                        continue;
                      }
                      if (r[w + 2].type === "keyword") {
                        f.type = "keyword", r[w + 1].type = "media-type";
                        continue;
                      }
                    }
                    if (r[w + 3] && r[w + 3].type === "media-feature-expression") {
                      f.type = "keyword", r[w + 1].type = "media-type", r[w + 2].type = "keyword";
                      continue;
                    }
                  }
                }
              return r;
            }
            function m(c) {
              var t3 = [], r = 0, a = 0, s = /^(\s*)url\s*\(/.exec(c);
              if (s !== null) {
                for (var f = s[0].length, g = 1; g > 0; ) {
                  var v = c[f];
                  v === "(" && g++, v === ")" && g--, f++;
                }
                t3.unshift(new i.default({ type: "url", value: c.substring(0, f).trim(), sourceIndex: s[1].length, before: s[1], after: /^(\s*)/.exec(c.substring(f))[1] })), r = f;
              }
              for (var y = r; y < c.length; y++) {
                var w = c[y];
                if (w === "(" && a++, w === ")" && a--, a === 0 && w === ",") {
                  var d = c.substring(r, y), _ = /^(\s*)/.exec(d)[1];
                  t3.push(new o.default({ type: "media-query", value: d.trim(), sourceIndex: r + _.length, nodes: p(d, r), before: _, after: /(\s*)$/.exec(d)[1] })), r = y + 1;
                }
              }
              var k = c.substring(r), x = /^(\s*)/.exec(k)[1];
              return t3.push(new o.default({ type: "media-query", value: k.trim(), sourceIndex: r + x.length, nodes: p(k, r), before: x, after: /(\s*)$/.exec(k)[1] })), t3;
            }
          } }), kf = P({ "node_modules/postcss-media-query-parser/dist/index.js"(e) {
            "use strict";
            A(), Object.defineProperty(e, "__esModule", { value: true }), e.default = h;
            var n = Yo(), i = o(n), u = Sf();
            function o(l) {
              return l && l.__esModule ? l : { default: l };
            }
            function h(l) {
              return new i.default({ nodes: (0, u.parseMediaList)(l), type: "media-query-list", value: l.trim() });
            }
          } }), Xo = {};
          At(Xo, { basename: () => na, default: () => sa, delimiter: () => kt, dirname: () => ta, extname: () => ia, isAbsolute: () => zt, join: () => ea, normalize: () => Lt, relative: () => ra, resolve: () => yr, sep: () => St });
          function Zo(e, n) {
            for (var i = 0, u = e.length - 1; u >= 0; u--) {
              var o = e[u];
              o === "." ? e.splice(u, 1) : o === ".." ? (e.splice(u, 1), i++) : i && (e.splice(u, 1), i--);
            }
            if (n)
              for (; i--; i)
                e.unshift("..");
            return e;
          }
          function yr() {
            for (var e = "", n = false, i = arguments.length - 1; i >= -1 && !n; i--) {
              var u = i >= 0 ? arguments[i] : "/";
              if (typeof u != "string")
                throw new TypeError("Arguments to path.resolve must be strings");
              if (!u)
                continue;
              e = u + "/" + e, n = u.charAt(0) === "/";
            }
            return e = Zo(Bt(e.split("/"), function(o) {
              return !!o;
            }), !n).join("/"), (n ? "/" : "") + e || ".";
          }
          function Lt(e) {
            var n = zt(e), i = oa(e, -1) === "/";
            return e = Zo(Bt(e.split("/"), function(u) {
              return !!u;
            }), !n).join("/"), !e && !n && (e = "."), e && i && (e += "/"), (n ? "/" : "") + e;
          }
          function zt(e) {
            return e.charAt(0) === "/";
          }
          function ea() {
            var e = Array.prototype.slice.call(arguments, 0);
            return Lt(Bt(e, function(n, i) {
              if (typeof n != "string")
                throw new TypeError("Arguments to path.join must be strings");
              return n;
            }).join("/"));
          }
          function ra(e, n) {
            e = yr(e).substr(1), n = yr(n).substr(1);
            function i(c) {
              for (var t3 = 0; t3 < c.length && c[t3] === ""; t3++)
                ;
              for (var r = c.length - 1; r >= 0 && c[r] === ""; r--)
                ;
              return t3 > r ? [] : c.slice(t3, r - t3 + 1);
            }
            for (var u = i(e.split("/")), o = i(n.split("/")), h = Math.min(u.length, o.length), l = h, p = 0; p < h; p++)
              if (u[p] !== o[p]) {
                l = p;
                break;
              }
            for (var m = [], p = l; p < u.length; p++)
              m.push("..");
            return m = m.concat(o.slice(l)), m.join("/");
          }
          function ta(e) {
            var n = br(e), i = n[0], u = n[1];
            return !i && !u ? "." : (u && (u = u.substr(0, u.length - 1)), i + u);
          }
          function na(e, n) {
            var i = br(e)[2];
            return n && i.substr(-1 * n.length) === n && (i = i.substr(0, i.length - n.length)), i;
          }
          function ia(e) {
            return br(e)[3];
          }
          function Bt(e, n) {
            if (e.filter)
              return e.filter(n);
            for (var i = [], u = 0; u < e.length; u++)
              n(e[u], u, e) && i.push(e[u]);
            return i;
          }
          var Fs, br, St, kt, sa, oa, Of = Le({ "node-modules-polyfills:path"() {
            A(), Fs = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/, br = function(e) {
              return Fs.exec(e).slice(1);
            }, St = "/", kt = ":", sa = { extname: ia, basename: na, dirname: ta, sep: St, delimiter: kt, relative: ra, join: ea, isAbsolute: zt, normalize: Lt, resolve: yr }, oa = "ab".substr(-1) === "b" ? function(e, n, i) {
              return e.substr(n, i);
            } : function(e, n, i) {
              return n < 0 && (n = e.length + n), e.substr(n, i);
            };
          } }), Tf = P({ "node-modules-polyfills-commonjs:path"(e, n) {
            A();
            var i = (Of(), Pt(Xo));
            if (i && i.default) {
              n.exports = i.default;
              for (let u in i)
                n.exports[u] = i[u];
            } else
              i && (n.exports = i);
          } }), Ef = P({ "node_modules/picocolors/picocolors.browser.js"(e, n) {
            A();
            var i = String, u = function() {
              return { isColorSupported: false, reset: i, bold: i, dim: i, italic: i, underline: i, inverse: i, hidden: i, strikethrough: i, black: i, red: i, green: i, yellow: i, blue: i, magenta: i, cyan: i, white: i, gray: i, bgBlack: i, bgRed: i, bgGreen: i, bgYellow: i, bgBlue: i, bgMagenta: i, bgCyan: i, bgWhite: i };
            };
            n.exports = u(), n.exports.createColors = u;
          } }), qf = P({ "(disabled):node_modules/postcss/lib/terminal-highlight"() {
            A();
          } }), aa = P({ "node_modules/postcss/lib/css-syntax-error.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = o(Ef()), u = o(qf());
            function o(g) {
              return g && g.__esModule ? g : { default: g };
            }
            function h(g) {
              if (g === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return g;
            }
            function l(g, v) {
              g.prototype = Object.create(v.prototype), g.prototype.constructor = g, g.__proto__ = v;
            }
            function p(g) {
              var v = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
              return p = function(w) {
                if (w === null || !t3(w))
                  return w;
                if (typeof w != "function")
                  throw new TypeError("Super expression must either be null or a function");
                if (typeof v < "u") {
                  if (v.has(w))
                    return v.get(w);
                  v.set(w, d);
                }
                function d() {
                  return m(w, arguments, a(this).constructor);
                }
                return d.prototype = Object.create(w.prototype, { constructor: { value: d, enumerable: false, writable: true, configurable: true } }), r(d, w);
              }, p(g);
            }
            function m(g, v, y) {
              return c() ? m = Reflect.construct : m = function(d, _, k) {
                var x = [null];
                x.push.apply(x, _);
                var N = Function.bind.apply(d, x), I = new N();
                return k && r(I, k.prototype), I;
              }, m.apply(null, arguments);
            }
            function c() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return false;
              if (typeof Proxy == "function")
                return true;
              try {
                return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
                })), true;
              } catch {
                return false;
              }
            }
            function t3(g) {
              return Function.toString.call(g).indexOf("[native code]") !== -1;
            }
            function r(g, v) {
              return r = Object.setPrototypeOf || function(w, d) {
                return w.__proto__ = d, w;
              }, r(g, v);
            }
            function a(g) {
              return a = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
                return y.__proto__ || Object.getPrototypeOf(y);
              }, a(g);
            }
            var s = function(g) {
              l(v, g);
              function v(w, d, _, k, x, N) {
                var I;
                return I = g.call(this, w) || this, I.name = "CssSyntaxError", I.reason = w, x && (I.file = x), k && (I.source = k), N && (I.plugin = N), typeof d < "u" && typeof _ < "u" && (I.line = d, I.column = _), I.setMessage(), Error.captureStackTrace && Error.captureStackTrace(h(I), v), I;
              }
              var y = v.prototype;
              return y.setMessage = function() {
                this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
              }, y.showSourceCode = function(d) {
                var _ = this;
                if (!this.source)
                  return "";
                var k = this.source;
                u.default && (typeof d > "u" && (d = i.default.isColorSupported), d && (k = (0, u.default)(k)));
                var x = k.split(/\r?\n/), N = Math.max(this.line - 3, 0), I = Math.min(this.line + 2, x.length), W = String(I).length;
                function $(D) {
                  return d && i.default.red ? i.default.red(i.default.bold(D)) : D;
                }
                function H(D) {
                  return d && i.default.gray ? i.default.gray(D) : D;
                }
                return x.slice(N, I).map(function(D, V) {
                  var B = N + 1 + V, O = " " + (" " + B).slice(-W) + " | ";
                  if (B === _.line) {
                    var j = H(O.replace(/\d/g, " ")) + D.slice(0, _.column - 1).replace(/[^\t]/g, " ");
                    return $(">") + H(O) + D + `
 ` + j + $("^");
                  }
                  return " " + H(O) + D;
                }).join(`
`);
              }, y.toString = function() {
                var d = this.showSourceCode();
                return d && (d = `

` + d + `
`), this.name + ": " + this.message + d;
              }, v;
            }(p(Error)), f = s;
            e.default = f, n.exports = e.default;
          } }), Af = P({ "node_modules/postcss/lib/previous-map.js"(e, n) {
            A(), n.exports = class {
            };
          } }), xr = P({ "node_modules/postcss/lib/input.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = h(Tf()), u = h(aa()), o = h(Af());
            function h(r) {
              return r && r.__esModule ? r : { default: r };
            }
            function l(r, a) {
              for (var s = 0; s < a.length; s++) {
                var f = a[s];
                f.enumerable = f.enumerable || false, f.configurable = true, "value" in f && (f.writable = true), Object.defineProperty(r, f.key, f);
              }
            }
            function p(r, a, s) {
              return a && l(r.prototype, a), s && l(r, s), r;
            }
            var m = 0, c = function() {
              function r(s, f) {
                if (f === void 0 && (f = {}), s === null || typeof s > "u" || typeof s == "object" && !s.toString)
                  throw new Error("PostCSS received " + s + " instead of CSS string");
                this.css = s.toString(), this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE" ? (this.hasBOM = true, this.css = this.css.slice(1)) : this.hasBOM = false, f.from && (/^\w+:\/\//.test(f.from) || i.default.isAbsolute(f.from) ? this.file = f.from : this.file = i.default.resolve(f.from));
                var g = new o.default(this.css, f);
                if (g.text) {
                  this.map = g;
                  var v = g.consumer().file;
                  !this.file && v && (this.file = this.mapResolve(v));
                }
                this.file || (m += 1, this.id = "<input css " + m + ">"), this.map && (this.map.file = this.from);
              }
              var a = r.prototype;
              return a.error = function(f, g, v, y) {
                y === void 0 && (y = {});
                var w, d = this.origin(g, v);
                return d ? w = new u.default(f, d.line, d.column, d.source, d.file, y.plugin) : w = new u.default(f, g, v, this.css, this.file, y.plugin), w.input = { line: g, column: v, source: this.css }, this.file && (w.input.file = this.file), w;
              }, a.origin = function(f, g) {
                if (!this.map)
                  return false;
                var v = this.map.consumer(), y = v.originalPositionFor({ line: f, column: g });
                if (!y.source)
                  return false;
                var w = { file: this.mapResolve(y.source), line: y.line, column: y.column }, d = v.sourceContentFor(y.source);
                return d && (w.source = d), w;
              }, a.mapResolve = function(f) {
                return /^\w+:\/\//.test(f) ? f : i.default.resolve(this.map.consumer().sourceRoot || ".", f);
              }, p(r, [{ key: "from", get: function() {
                return this.file || this.id;
              } }]), r;
            }(), t3 = c;
            e.default = t3, n.exports = e.default;
          } }), Sr = P({ "node_modules/postcss/lib/stringifier.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = { colon: ": ", indent: "    ", beforeDecl: `
`, beforeRule: `
`, beforeOpen: " ", beforeClose: `
`, beforeComment: `
`, after: `
`, emptyBody: "", commentLeft: " ", commentRight: " ", semicolon: false };
            function u(l) {
              return l[0].toUpperCase() + l.slice(1);
            }
            var o = function() {
              function l(m) {
                this.builder = m;
              }
              var p = l.prototype;
              return p.stringify = function(c, t3) {
                this[c.type](c, t3);
              }, p.root = function(c) {
                this.body(c), c.raws.after && this.builder(c.raws.after);
              }, p.comment = function(c) {
                var t3 = this.raw(c, "left", "commentLeft"), r = this.raw(c, "right", "commentRight");
                this.builder("/*" + t3 + c.text + r + "*/", c);
              }, p.decl = function(c, t3) {
                var r = this.raw(c, "between", "colon"), a = c.prop + r + this.rawValue(c, "value");
                c.important && (a += c.raws.important || " !important"), t3 && (a += ";"), this.builder(a, c);
              }, p.rule = function(c) {
                this.block(c, this.rawValue(c, "selector")), c.raws.ownSemicolon && this.builder(c.raws.ownSemicolon, c, "end");
              }, p.atrule = function(c, t3) {
                var r = "@" + c.name, a = c.params ? this.rawValue(c, "params") : "";
                if (typeof c.raws.afterName < "u" ? r += c.raws.afterName : a && (r += " "), c.nodes)
                  this.block(c, r + a);
                else {
                  var s = (c.raws.between || "") + (t3 ? ";" : "");
                  this.builder(r + a + s, c);
                }
              }, p.body = function(c) {
                for (var t3 = c.nodes.length - 1; t3 > 0 && c.nodes[t3].type === "comment"; )
                  t3 -= 1;
                for (var r = this.raw(c, "semicolon"), a = 0; a < c.nodes.length; a++) {
                  var s = c.nodes[a], f = this.raw(s, "before");
                  f && this.builder(f), this.stringify(s, t3 !== a || r);
                }
              }, p.block = function(c, t3) {
                var r = this.raw(c, "between", "beforeOpen");
                this.builder(t3 + r + "{", c, "start");
                var a;
                c.nodes && c.nodes.length ? (this.body(c), a = this.raw(c, "after")) : a = this.raw(c, "after", "emptyBody"), a && this.builder(a), this.builder("}", c, "end");
              }, p.raw = function(c, t3, r) {
                var a;
                if (r || (r = t3), t3 && (a = c.raws[t3], typeof a < "u"))
                  return a;
                var s = c.parent;
                if (r === "before" && (!s || s.type === "root" && s.first === c))
                  return "";
                if (!s)
                  return i[r];
                var f = c.root();
                if (f.rawCache || (f.rawCache = {}), typeof f.rawCache[r] < "u")
                  return f.rawCache[r];
                if (r === "before" || r === "after")
                  return this.beforeAfter(c, r);
                var g = "raw" + u(r);
                return this[g] ? a = this[g](f, c) : f.walk(function(v) {
                  if (a = v.raws[t3], typeof a < "u")
                    return false;
                }), typeof a > "u" && (a = i[r]), f.rawCache[r] = a, a;
              }, p.rawSemicolon = function(c) {
                var t3;
                return c.walk(function(r) {
                  if (r.nodes && r.nodes.length && r.last.type === "decl" && (t3 = r.raws.semicolon, typeof t3 < "u"))
                    return false;
                }), t3;
              }, p.rawEmptyBody = function(c) {
                var t3;
                return c.walk(function(r) {
                  if (r.nodes && r.nodes.length === 0 && (t3 = r.raws.after, typeof t3 < "u"))
                    return false;
                }), t3;
              }, p.rawIndent = function(c) {
                if (c.raws.indent)
                  return c.raws.indent;
                var t3;
                return c.walk(function(r) {
                  var a = r.parent;
                  if (a && a !== c && a.parent && a.parent === c && typeof r.raws.before < "u") {
                    var s = r.raws.before.split(`
`);
                    return t3 = s[s.length - 1], t3 = t3.replace(/[^\s]/g, ""), false;
                  }
                }), t3;
              }, p.rawBeforeComment = function(c, t3) {
                var r;
                return c.walkComments(function(a) {
                  if (typeof a.raws.before < "u")
                    return r = a.raws.before, r.indexOf(`
`) !== -1 && (r = r.replace(/[^\n]+$/, "")), false;
                }), typeof r > "u" ? r = this.raw(t3, null, "beforeDecl") : r && (r = r.replace(/[^\s]/g, "")), r;
              }, p.rawBeforeDecl = function(c, t3) {
                var r;
                return c.walkDecls(function(a) {
                  if (typeof a.raws.before < "u")
                    return r = a.raws.before, r.indexOf(`
`) !== -1 && (r = r.replace(/[^\n]+$/, "")), false;
                }), typeof r > "u" ? r = this.raw(t3, null, "beforeRule") : r && (r = r.replace(/[^\s]/g, "")), r;
              }, p.rawBeforeRule = function(c) {
                var t3;
                return c.walk(function(r) {
                  if (r.nodes && (r.parent !== c || c.first !== r) && typeof r.raws.before < "u")
                    return t3 = r.raws.before, t3.indexOf(`
`) !== -1 && (t3 = t3.replace(/[^\n]+$/, "")), false;
                }), t3 && (t3 = t3.replace(/[^\s]/g, "")), t3;
              }, p.rawBeforeClose = function(c) {
                var t3;
                return c.walk(function(r) {
                  if (r.nodes && r.nodes.length > 0 && typeof r.raws.after < "u")
                    return t3 = r.raws.after, t3.indexOf(`
`) !== -1 && (t3 = t3.replace(/[^\n]+$/, "")), false;
                }), t3 && (t3 = t3.replace(/[^\s]/g, "")), t3;
              }, p.rawBeforeOpen = function(c) {
                var t3;
                return c.walk(function(r) {
                  if (r.type !== "decl" && (t3 = r.raws.between, typeof t3 < "u"))
                    return false;
                }), t3;
              }, p.rawColon = function(c) {
                var t3;
                return c.walkDecls(function(r) {
                  if (typeof r.raws.between < "u")
                    return t3 = r.raws.between.replace(/[^\s:]/g, ""), false;
                }), t3;
              }, p.beforeAfter = function(c, t3) {
                var r;
                c.type === "decl" ? r = this.raw(c, null, "beforeDecl") : c.type === "comment" ? r = this.raw(c, null, "beforeComment") : t3 === "before" ? r = this.raw(c, null, "beforeRule") : r = this.raw(c, null, "beforeClose");
                for (var a = c.parent, s = 0; a && a.type !== "root"; )
                  s += 1, a = a.parent;
                if (r.indexOf(`
`) !== -1) {
                  var f = this.raw(c, null, "indent");
                  if (f.length)
                    for (var g = 0; g < s; g++)
                      r += f;
                }
                return r;
              }, p.rawValue = function(c, t3) {
                var r = c[t3], a = c.raws[t3];
                return a && a.value === r ? a.raw : r;
              }, l;
            }(), h = o;
            e.default = h, n.exports = e.default;
          } }), ua = P({ "node_modules/postcss/lib/stringify.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = u(Sr());
            function u(l) {
              return l && l.__esModule ? l : { default: l };
            }
            function o(l, p) {
              var m = new i.default(p);
              m.stringify(l);
            }
            var h = o;
            e.default = h, n.exports = e.default;
          } }), Ft = P({ "node_modules/postcss/lib/node.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = h(aa()), u = h(Sr()), o = h(ua());
            function h(c) {
              return c && c.__esModule ? c : { default: c };
            }
            function l(c, t3) {
              var r = new c.constructor();
              for (var a in c)
                if (c.hasOwnProperty(a)) {
                  var s = c[a], f = typeof s;
                  a === "parent" && f === "object" ? t3 && (r[a] = t3) : a === "source" ? r[a] = s : s instanceof Array ? r[a] = s.map(function(g) {
                    return l(g, r);
                  }) : (f === "object" && s !== null && (s = l(s)), r[a] = s);
                }
              return r;
            }
            var p = function() {
              function c(r) {
                r === void 0 && (r = {}), this.raws = {};
                for (var a in r)
                  this[a] = r[a];
              }
              var t3 = c.prototype;
              return t3.error = function(a, s) {
                if (s === void 0 && (s = {}), this.source) {
                  var f = this.positionBy(s);
                  return this.source.input.error(a, f.line, f.column, s);
                }
                return new i.default(a);
              }, t3.warn = function(a, s, f) {
                var g = { node: this };
                for (var v in f)
                  g[v] = f[v];
                return a.warn(s, g);
              }, t3.remove = function() {
                return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
              }, t3.toString = function(a) {
                a === void 0 && (a = o.default), a.stringify && (a = a.stringify);
                var s = "";
                return a(this, function(f) {
                  s += f;
                }), s;
              }, t3.clone = function(a) {
                a === void 0 && (a = {});
                var s = l(this);
                for (var f in a)
                  s[f] = a[f];
                return s;
              }, t3.cloneBefore = function(a) {
                a === void 0 && (a = {});
                var s = this.clone(a);
                return this.parent.insertBefore(this, s), s;
              }, t3.cloneAfter = function(a) {
                a === void 0 && (a = {});
                var s = this.clone(a);
                return this.parent.insertAfter(this, s), s;
              }, t3.replaceWith = function() {
                if (this.parent) {
                  for (var a = arguments.length, s = new Array(a), f = 0; f < a; f++)
                    s[f] = arguments[f];
                  for (var g = 0, v = s; g < v.length; g++) {
                    var y = v[g];
                    this.parent.insertBefore(this, y);
                  }
                  this.remove();
                }
                return this;
              }, t3.next = function() {
                if (this.parent) {
                  var a = this.parent.index(this);
                  return this.parent.nodes[a + 1];
                }
              }, t3.prev = function() {
                if (this.parent) {
                  var a = this.parent.index(this);
                  return this.parent.nodes[a - 1];
                }
              }, t3.before = function(a) {
                return this.parent.insertBefore(this, a), this;
              }, t3.after = function(a) {
                return this.parent.insertAfter(this, a), this;
              }, t3.toJSON = function() {
                var a = {};
                for (var s in this)
                  if (this.hasOwnProperty(s) && s !== "parent") {
                    var f = this[s];
                    f instanceof Array ? a[s] = f.map(function(g) {
                      return typeof g == "object" && g.toJSON ? g.toJSON() : g;
                    }) : typeof f == "object" && f.toJSON ? a[s] = f.toJSON() : a[s] = f;
                  }
                return a;
              }, t3.raw = function(a, s) {
                var f = new u.default();
                return f.raw(this, a, s);
              }, t3.root = function() {
                for (var a = this; a.parent; )
                  a = a.parent;
                return a;
              }, t3.cleanRaws = function(a) {
                delete this.raws.before, delete this.raws.after, a || delete this.raws.between;
              }, t3.positionInside = function(a) {
                for (var s = this.toString(), f = this.source.start.column, g = this.source.start.line, v = 0; v < a; v++)
                  s[v] === `
` ? (f = 1, g += 1) : f += 1;
                return { line: g, column: f };
              }, t3.positionBy = function(a) {
                var s = this.source.start;
                if (a.index)
                  s = this.positionInside(a.index);
                else if (a.word) {
                  var f = this.toString().indexOf(a.word);
                  f !== -1 && (s = this.positionInside(f));
                }
                return s;
              }, c;
            }(), m = p;
            e.default = m, n.exports = e.default;
          } }), kr = P({ "node_modules/postcss/lib/comment.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = u(Ft());
            function u(p) {
              return p && p.__esModule ? p : { default: p };
            }
            function o(p, m) {
              p.prototype = Object.create(m.prototype), p.prototype.constructor = p, p.__proto__ = m;
            }
            var h = function(p) {
              o(m, p);
              function m(c) {
                var t3;
                return t3 = p.call(this, c) || this, t3.type = "comment", t3;
              }
              return m;
            }(i.default), l = h;
            e.default = l, n.exports = e.default;
          } }), ca = P({ "node_modules/postcss/lib/declaration.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = u(Ft());
            function u(p) {
              return p && p.__esModule ? p : { default: p };
            }
            function o(p, m) {
              p.prototype = Object.create(m.prototype), p.prototype.constructor = p, p.__proto__ = m;
            }
            var h = function(p) {
              o(m, p);
              function m(c) {
                var t3;
                return t3 = p.call(this, c) || this, t3.type = "decl", t3;
              }
              return m;
            }(i.default), l = h;
            e.default = l, n.exports = e.default;
          } }), Ut = P({ "node_modules/postcss/lib/tokenize.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = W;
            var i = "'".charCodeAt(0), u = '"'.charCodeAt(0), o = "\\".charCodeAt(0), h = "/".charCodeAt(0), l = `
`.charCodeAt(0), p = " ".charCodeAt(0), m = "\f".charCodeAt(0), c = "	".charCodeAt(0), t3 = "\r".charCodeAt(0), r = "[".charCodeAt(0), a = "]".charCodeAt(0), s = "(".charCodeAt(0), f = ")".charCodeAt(0), g = "{".charCodeAt(0), v = "}".charCodeAt(0), y = ";".charCodeAt(0), w = "*".charCodeAt(0), d = ":".charCodeAt(0), _ = "@".charCodeAt(0), k = /[ \n\t\r\f{}()'"\\;/[\]#]/g, x = /[ \n\t\r\f(){}:;@!'"\\\][#]|\/(?=\*)/g, N = /.[\\/("'\n]/, I = /[a-f0-9]/i;
            function W($, H) {
              H === void 0 && (H = {});
              var D = $.css.valueOf(), V = H.ignoreErrors, B, O, j, C, R, X, Z, Q, K, J, M, Y, G, E, S = D.length, b = -1, L = 1, q = 0, T = [], F = [];
              function z() {
                return q;
              }
              function ee(re) {
                throw $.error("Unclosed " + re, L, q - b);
              }
              function te() {
                return F.length === 0 && q >= S;
              }
              function ue(re) {
                if (F.length)
                  return F.pop();
                if (!(q >= S)) {
                  var ne = re ? re.ignoreUnclosed : false;
                  switch (B = D.charCodeAt(q), (B === l || B === m || B === t3 && D.charCodeAt(q + 1) !== l) && (b = q, L += 1), B) {
                    case l:
                    case p:
                    case c:
                    case t3:
                    case m:
                      O = q;
                      do
                        O += 1, B = D.charCodeAt(O), B === l && (b = O, L += 1);
                      while (B === p || B === l || B === c || B === t3 || B === m);
                      E = ["space", D.slice(q, O)], q = O - 1;
                      break;
                    case r:
                    case a:
                    case g:
                    case v:
                    case d:
                    case y:
                    case f:
                      var oe = String.fromCharCode(B);
                      E = [oe, oe, L, q - b];
                      break;
                    case s:
                      if (Y = T.length ? T.pop()[1] : "", G = D.charCodeAt(q + 1), Y === "url" && G !== i && G !== u && G !== p && G !== l && G !== c && G !== m && G !== t3) {
                        O = q;
                        do {
                          if (J = false, O = D.indexOf(")", O + 1), O === -1)
                            if (V || ne) {
                              O = q;
                              break;
                            } else
                              ee("bracket");
                          for (M = O; D.charCodeAt(M - 1) === o; )
                            M -= 1, J = !J;
                        } while (J);
                        E = ["brackets", D.slice(q, O + 1), L, q - b, L, O - b], q = O;
                      } else
                        O = D.indexOf(")", q + 1), X = D.slice(q, O + 1), O === -1 || N.test(X) ? E = ["(", "(", L, q - b] : (E = ["brackets", X, L, q - b, L, O - b], q = O);
                      break;
                    case i:
                    case u:
                      j = B === i ? "'" : '"', O = q;
                      do {
                        if (J = false, O = D.indexOf(j, O + 1), O === -1)
                          if (V || ne) {
                            O = q + 1;
                            break;
                          } else
                            ee("string");
                        for (M = O; D.charCodeAt(M - 1) === o; )
                          M -= 1, J = !J;
                      } while (J);
                      X = D.slice(q, O + 1), C = X.split(`
`), R = C.length - 1, R > 0 ? (Q = L + R, K = O - C[R].length) : (Q = L, K = b), E = ["string", D.slice(q, O + 1), L, q - b, Q, O - K], b = K, L = Q, q = O;
                      break;
                    case _:
                      k.lastIndex = q + 1, k.test(D), k.lastIndex === 0 ? O = D.length - 1 : O = k.lastIndex - 2, E = ["at-word", D.slice(q, O + 1), L, q - b, L, O - b], q = O;
                      break;
                    case o:
                      for (O = q, Z = true; D.charCodeAt(O + 1) === o; )
                        O += 1, Z = !Z;
                      if (B = D.charCodeAt(O + 1), Z && B !== h && B !== p && B !== l && B !== c && B !== t3 && B !== m && (O += 1, I.test(D.charAt(O)))) {
                        for (; I.test(D.charAt(O + 1)); )
                          O += 1;
                        D.charCodeAt(O + 1) === p && (O += 1);
                      }
                      E = ["word", D.slice(q, O + 1), L, q - b, L, O - b], q = O;
                      break;
                    default:
                      B === h && D.charCodeAt(q + 1) === w ? (O = D.indexOf("*/", q + 2) + 1, O === 0 && (V || ne ? O = D.length : ee("comment")), X = D.slice(q, O + 1), C = X.split(`
`), R = C.length - 1, R > 0 ? (Q = L + R, K = O - C[R].length) : (Q = L, K = b), E = ["comment", X, L, q - b, Q, O - K], b = K, L = Q, q = O) : (x.lastIndex = q + 1, x.test(D), x.lastIndex === 0 ? O = D.length - 1 : O = x.lastIndex - 2, E = ["word", D.slice(q, O + 1), L, q - b, L, O - b], T.push(E), q = O);
                      break;
                  }
                  return q++, E;
                }
              }
              function le(re) {
                F.push(re);
              }
              return { back: le, nextToken: ue, endOfFile: te, position: z };
            }
            n.exports = e.default;
          } }), la = P({ "node_modules/postcss/lib/parse.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = o($t()), u = o(xr());
            function o(p) {
              return p && p.__esModule ? p : { default: p };
            }
            function h(p, m) {
              var c = new u.default(p, m), t3 = new i.default(c);
              try {
                t3.parse();
              } catch (r) {
                throw r;
              }
              return t3.root;
            }
            var l = h;
            e.default = l, n.exports = e.default;
          } }), Pf = P({ "node_modules/postcss/lib/list.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = { split: function(h, l, p) {
              for (var m = [], c = "", t3 = false, r = 0, a = false, s = false, f = 0; f < h.length; f++) {
                var g = h[f];
                a ? s ? s = false : g === "\\" ? s = true : g === a && (a = false) : g === '"' || g === "'" ? a = g : g === "(" ? r += 1 : g === ")" ? r > 0 && (r -= 1) : r === 0 && l.indexOf(g) !== -1 && (t3 = true), t3 ? (c !== "" && m.push(c.trim()), c = "", t3 = false) : c += g;
              }
              return (p || c !== "") && m.push(c.trim()), m;
            }, space: function(h) {
              var l = [" ", `
`, "	"];
              return i.split(h, l);
            }, comma: function(h) {
              return i.split(h, [","], true);
            } }, u = i;
            e.default = u, n.exports = e.default;
          } }), fa = P({ "node_modules/postcss/lib/rule.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = o(Or()), u = o(Pf());
            function o(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function h(t3, r) {
              for (var a = 0; a < r.length; a++) {
                var s = r[a];
                s.enumerable = s.enumerable || false, s.configurable = true, "value" in s && (s.writable = true), Object.defineProperty(t3, s.key, s);
              }
            }
            function l(t3, r, a) {
              return r && h(t3.prototype, r), a && h(t3, a), t3;
            }
            function p(t3, r) {
              t3.prototype = Object.create(r.prototype), t3.prototype.constructor = t3, t3.__proto__ = r;
            }
            var m = function(t3) {
              p(r, t3);
              function r(a) {
                var s;
                return s = t3.call(this, a) || this, s.type = "rule", s.nodes || (s.nodes = []), s;
              }
              return l(r, [{ key: "selectors", get: function() {
                return u.default.comma(this.selector);
              }, set: function(s) {
                var f = this.selector ? this.selector.match(/,\s*/) : null, g = f ? f[0] : "," + this.raw("between", "beforeOpen");
                this.selector = s.join(g);
              } }]), r;
            }(i.default), c = m;
            e.default = c, n.exports = e.default;
          } }), Or = P({ "node_modules/postcss/lib/container.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = h(ca()), u = h(kr()), o = h(Ft());
            function h(g) {
              return g && g.__esModule ? g : { default: g };
            }
            function l(g, v) {
              var y;
              if (typeof Symbol > "u" || g[Symbol.iterator] == null) {
                if (Array.isArray(g) || (y = p(g)) || v && g && typeof g.length == "number") {
                  y && (g = y);
                  var w = 0;
                  return function() {
                    return w >= g.length ? { done: true } : { done: false, value: g[w++] };
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              return y = g[Symbol.iterator](), y.next.bind(y);
            }
            function p(g, v) {
              if (g) {
                if (typeof g == "string")
                  return m(g, v);
                var y = Object.prototype.toString.call(g).slice(8, -1);
                if (y === "Object" && g.constructor && (y = g.constructor.name), y === "Map" || y === "Set")
                  return Array.from(g);
                if (y === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(y))
                  return m(g, v);
              }
            }
            function m(g, v) {
              (v == null || v > g.length) && (v = g.length);
              for (var y = 0, w = new Array(v); y < v; y++)
                w[y] = g[y];
              return w;
            }
            function c(g, v) {
              for (var y = 0; y < v.length; y++) {
                var w = v[y];
                w.enumerable = w.enumerable || false, w.configurable = true, "value" in w && (w.writable = true), Object.defineProperty(g, w.key, w);
              }
            }
            function t3(g, v, y) {
              return v && c(g.prototype, v), y && c(g, y), g;
            }
            function r(g, v) {
              g.prototype = Object.create(v.prototype), g.prototype.constructor = g, g.__proto__ = v;
            }
            function a(g) {
              return g.map(function(v) {
                return v.nodes && (v.nodes = a(v.nodes)), delete v.source, v;
              });
            }
            var s = function(g) {
              r(v, g);
              function v() {
                return g.apply(this, arguments) || this;
              }
              var y = v.prototype;
              return y.push = function(d) {
                return d.parent = this, this.nodes.push(d), this;
              }, y.each = function(d) {
                this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
                var _ = this.lastEach;
                if (this.indexes[_] = 0, !!this.nodes) {
                  for (var k, x; this.indexes[_] < this.nodes.length && (k = this.indexes[_], x = d(this.nodes[k], k), x !== false); )
                    this.indexes[_] += 1;
                  return delete this.indexes[_], x;
                }
              }, y.walk = function(d) {
                return this.each(function(_, k) {
                  var x;
                  try {
                    x = d(_, k);
                  } catch (I) {
                    if (I.postcssNode = _, I.stack && _.source && /\n\s{4}at /.test(I.stack)) {
                      var N = _.source;
                      I.stack = I.stack.replace(/\n\s{4}at /, "$&" + N.input.from + ":" + N.start.line + ":" + N.start.column + "$&");
                    }
                    throw I;
                  }
                  return x !== false && _.walk && (x = _.walk(d)), x;
                });
              }, y.walkDecls = function(d, _) {
                return _ ? d instanceof RegExp ? this.walk(function(k, x) {
                  if (k.type === "decl" && d.test(k.prop))
                    return _(k, x);
                }) : this.walk(function(k, x) {
                  if (k.type === "decl" && k.prop === d)
                    return _(k, x);
                }) : (_ = d, this.walk(function(k, x) {
                  if (k.type === "decl")
                    return _(k, x);
                }));
              }, y.walkRules = function(d, _) {
                return _ ? d instanceof RegExp ? this.walk(function(k, x) {
                  if (k.type === "rule" && d.test(k.selector))
                    return _(k, x);
                }) : this.walk(function(k, x) {
                  if (k.type === "rule" && k.selector === d)
                    return _(k, x);
                }) : (_ = d, this.walk(function(k, x) {
                  if (k.type === "rule")
                    return _(k, x);
                }));
              }, y.walkAtRules = function(d, _) {
                return _ ? d instanceof RegExp ? this.walk(function(k, x) {
                  if (k.type === "atrule" && d.test(k.name))
                    return _(k, x);
                }) : this.walk(function(k, x) {
                  if (k.type === "atrule" && k.name === d)
                    return _(k, x);
                }) : (_ = d, this.walk(function(k, x) {
                  if (k.type === "atrule")
                    return _(k, x);
                }));
              }, y.walkComments = function(d) {
                return this.walk(function(_, k) {
                  if (_.type === "comment")
                    return d(_, k);
                });
              }, y.append = function() {
                for (var d = arguments.length, _ = new Array(d), k = 0; k < d; k++)
                  _[k] = arguments[k];
                for (var x = 0, N = _; x < N.length; x++)
                  for (var I = N[x], W = this.normalize(I, this.last), $ = l(W), H; !(H = $()).done; ) {
                    var D = H.value;
                    this.nodes.push(D);
                  }
                return this;
              }, y.prepend = function() {
                for (var d = arguments.length, _ = new Array(d), k = 0; k < d; k++)
                  _[k] = arguments[k];
                _ = _.reverse();
                for (var x = l(_), N; !(N = x()).done; ) {
                  for (var I = N.value, W = this.normalize(I, this.first, "prepend").reverse(), $ = l(W), H; !(H = $()).done; ) {
                    var D = H.value;
                    this.nodes.unshift(D);
                  }
                  for (var V in this.indexes)
                    this.indexes[V] = this.indexes[V] + W.length;
                }
                return this;
              }, y.cleanRaws = function(d) {
                if (g.prototype.cleanRaws.call(this, d), this.nodes)
                  for (var _ = l(this.nodes), k; !(k = _()).done; ) {
                    var x = k.value;
                    x.cleanRaws(d);
                  }
              }, y.insertBefore = function(d, _) {
                d = this.index(d);
                for (var k = d === 0 ? "prepend" : false, x = this.normalize(_, this.nodes[d], k).reverse(), N = l(x), I; !(I = N()).done; ) {
                  var W = I.value;
                  this.nodes.splice(d, 0, W);
                }
                var $;
                for (var H in this.indexes)
                  $ = this.indexes[H], d <= $ && (this.indexes[H] = $ + x.length);
                return this;
              }, y.insertAfter = function(d, _) {
                d = this.index(d);
                for (var k = this.normalize(_, this.nodes[d]).reverse(), x = l(k), N; !(N = x()).done; ) {
                  var I = N.value;
                  this.nodes.splice(d + 1, 0, I);
                }
                var W;
                for (var $ in this.indexes)
                  W = this.indexes[$], d < W && (this.indexes[$] = W + k.length);
                return this;
              }, y.removeChild = function(d) {
                d = this.index(d), this.nodes[d].parent = void 0, this.nodes.splice(d, 1);
                var _;
                for (var k in this.indexes)
                  _ = this.indexes[k], _ >= d && (this.indexes[k] = _ - 1);
                return this;
              }, y.removeAll = function() {
                for (var d = l(this.nodes), _; !(_ = d()).done; ) {
                  var k = _.value;
                  k.parent = void 0;
                }
                return this.nodes = [], this;
              }, y.replaceValues = function(d, _, k) {
                return k || (k = _, _ = {}), this.walkDecls(function(x) {
                  _.props && _.props.indexOf(x.prop) === -1 || _.fast && x.value.indexOf(_.fast) === -1 || (x.value = x.value.replace(d, k));
                }), this;
              }, y.every = function(d) {
                return this.nodes.every(d);
              }, y.some = function(d) {
                return this.nodes.some(d);
              }, y.index = function(d) {
                return typeof d == "number" ? d : this.nodes.indexOf(d);
              }, y.normalize = function(d, _) {
                var k = this;
                if (typeof d == "string") {
                  var x = la();
                  d = a(x(d).nodes);
                } else if (Array.isArray(d)) {
                  d = d.slice(0);
                  for (var N = l(d), I; !(I = N()).done; ) {
                    var W = I.value;
                    W.parent && W.parent.removeChild(W, "ignore");
                  }
                } else if (d.type === "root") {
                  d = d.nodes.slice(0);
                  for (var $ = l(d), H; !(H = $()).done; ) {
                    var D = H.value;
                    D.parent && D.parent.removeChild(D, "ignore");
                  }
                } else if (d.type)
                  d = [d];
                else if (d.prop) {
                  if (typeof d.value > "u")
                    throw new Error("Value field is missed in node creation");
                  typeof d.value != "string" && (d.value = String(d.value)), d = [new i.default(d)];
                } else if (d.selector) {
                  var V = fa();
                  d = [new V(d)];
                } else if (d.name) {
                  var B = pa();
                  d = [new B(d)];
                } else if (d.text)
                  d = [new u.default(d)];
                else
                  throw new Error("Unknown node type in node creation");
                var O = d.map(function(j) {
                  return j.parent && j.parent.removeChild(j), typeof j.raws.before > "u" && _ && typeof _.raws.before < "u" && (j.raws.before = _.raws.before.replace(/[^\s]/g, "")), j.parent = k, j;
                });
                return O;
              }, t3(v, [{ key: "first", get: function() {
                if (this.nodes)
                  return this.nodes[0];
              } }, { key: "last", get: function() {
                if (this.nodes)
                  return this.nodes[this.nodes.length - 1];
              } }]), v;
            }(o.default), f = s;
            e.default = f, n.exports = e.default;
          } }), pa = P({ "node_modules/postcss/lib/at-rule.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = u(Or());
            function u(p) {
              return p && p.__esModule ? p : { default: p };
            }
            function o(p, m) {
              p.prototype = Object.create(m.prototype), p.prototype.constructor = p, p.__proto__ = m;
            }
            var h = function(p) {
              o(m, p);
              function m(t3) {
                var r;
                return r = p.call(this, t3) || this, r.type = "atrule", r;
              }
              var c = m.prototype;
              return c.append = function() {
                var r;
                this.nodes || (this.nodes = []);
                for (var a = arguments.length, s = new Array(a), f = 0; f < a; f++)
                  s[f] = arguments[f];
                return (r = p.prototype.append).call.apply(r, [this].concat(s));
              }, c.prepend = function() {
                var r;
                this.nodes || (this.nodes = []);
                for (var a = arguments.length, s = new Array(a), f = 0; f < a; f++)
                  s[f] = arguments[f];
                return (r = p.prototype.prepend).call.apply(r, [this].concat(s));
              }, m;
            }(i.default), l = h;
            e.default = l, n.exports = e.default;
          } }), If = P({ "node_modules/postcss/lib/map-generator.js"(e, n) {
            A(), n.exports = class {
              generate() {
              }
            };
          } }), Rf = P({ "node_modules/postcss/lib/warn-once.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = u;
            var i = {};
            function u(o) {
              i[o] || (i[o] = true, typeof console < "u" && console.warn && console.warn(o));
            }
            n.exports = e.default;
          } }), Cf = P({ "node_modules/postcss/lib/warning.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = function() {
              function o(l, p) {
                if (p === void 0 && (p = {}), this.type = "warning", this.text = l, p.node && p.node.source) {
                  var m = p.node.positionBy(p);
                  this.line = m.line, this.column = m.column;
                }
                for (var c in p)
                  this[c] = p[c];
              }
              var h = o.prototype;
              return h.toString = function() {
                return this.node ? this.node.error(this.text, { plugin: this.plugin, index: this.index, word: this.word }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
              }, o;
            }(), u = i;
            e.default = u, n.exports = e.default;
          } }), Nf = P({ "node_modules/postcss/lib/result.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = u(Cf());
            function u(m) {
              return m && m.__esModule ? m : { default: m };
            }
            function o(m, c) {
              for (var t3 = 0; t3 < c.length; t3++) {
                var r = c[t3];
                r.enumerable = r.enumerable || false, r.configurable = true, "value" in r && (r.writable = true), Object.defineProperty(m, r.key, r);
              }
            }
            function h(m, c, t3) {
              return c && o(m.prototype, c), t3 && o(m, t3), m;
            }
            var l = function() {
              function m(t3, r, a) {
                this.processor = t3, this.messages = [], this.root = r, this.opts = a, this.css = void 0, this.map = void 0;
              }
              var c = m.prototype;
              return c.toString = function() {
                return this.css;
              }, c.warn = function(r, a) {
                a === void 0 && (a = {}), a.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (a.plugin = this.lastPlugin.postcssPlugin);
                var s = new i.default(r, a);
                return this.messages.push(s), s;
              }, c.warnings = function() {
                return this.messages.filter(function(r) {
                  return r.type === "warning";
                });
              }, h(m, [{ key: "content", get: function() {
                return this.css;
              } }]), m;
            }(), p = l;
            e.default = p, n.exports = e.default;
          } }), ha = P({ "node_modules/postcss/lib/lazy-result.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = p(If()), u = p(ua()), o = p(Rf()), h = p(Nf()), l = p(la());
            function p(v) {
              return v && v.__esModule ? v : { default: v };
            }
            function m(v, y) {
              var w;
              if (typeof Symbol > "u" || v[Symbol.iterator] == null) {
                if (Array.isArray(v) || (w = c(v)) || y && v && typeof v.length == "number") {
                  w && (v = w);
                  var d = 0;
                  return function() {
                    return d >= v.length ? { done: true } : { done: false, value: v[d++] };
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              return w = v[Symbol.iterator](), w.next.bind(w);
            }
            function c(v, y) {
              if (v) {
                if (typeof v == "string")
                  return t3(v, y);
                var w = Object.prototype.toString.call(v).slice(8, -1);
                if (w === "Object" && v.constructor && (w = v.constructor.name), w === "Map" || w === "Set")
                  return Array.from(v);
                if (w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w))
                  return t3(v, y);
              }
            }
            function t3(v, y) {
              (y == null || y > v.length) && (y = v.length);
              for (var w = 0, d = new Array(y); w < y; w++)
                d[w] = v[w];
              return d;
            }
            function r(v, y) {
              for (var w = 0; w < y.length; w++) {
                var d = y[w];
                d.enumerable = d.enumerable || false, d.configurable = true, "value" in d && (d.writable = true), Object.defineProperty(v, d.key, d);
              }
            }
            function a(v, y, w) {
              return y && r(v.prototype, y), w && r(v, w), v;
            }
            function s(v) {
              return typeof v == "object" && typeof v.then == "function";
            }
            var f = function() {
              function v(w, d, _) {
                this.stringified = false, this.processed = false;
                var k;
                if (typeof d == "object" && d !== null && d.type === "root")
                  k = d;
                else if (d instanceof v || d instanceof h.default)
                  k = d.root, d.map && (typeof _.map > "u" && (_.map = {}), _.map.inline || (_.map.inline = false), _.map.prev = d.map);
                else {
                  var x = l.default;
                  _.syntax && (x = _.syntax.parse), _.parser && (x = _.parser), x.parse && (x = x.parse);
                  try {
                    k = x(d, _);
                  } catch (N) {
                    this.error = N;
                  }
                }
                this.result = new h.default(w, k, _);
              }
              var y = v.prototype;
              return y.warnings = function() {
                return this.sync().warnings();
              }, y.toString = function() {
                return this.css;
              }, y.then = function(d, _) {
                return this.async().then(d, _);
              }, y.catch = function(d) {
                return this.async().catch(d);
              }, y.finally = function(d) {
                return this.async().then(d, d);
              }, y.handleError = function(d, _) {
                try {
                  if (this.error = d, d.name === "CssSyntaxError" && !d.plugin)
                    d.plugin = _.postcssPlugin, d.setMessage();
                  else if (_.postcssVersion && false)
                    var k, x, N, I, W;
                } catch ($) {
                  console && console.error && console.error($);
                }
              }, y.asyncTick = function(d, _) {
                var k = this;
                if (this.plugin >= this.processor.plugins.length)
                  return this.processed = true, d();
                try {
                  var x = this.processor.plugins[this.plugin], N = this.run(x);
                  this.plugin += 1, s(N) ? N.then(function() {
                    k.asyncTick(d, _);
                  }).catch(function(I) {
                    k.handleError(I, x), k.processed = true, _(I);
                  }) : this.asyncTick(d, _);
                } catch (I) {
                  this.processed = true, _(I);
                }
              }, y.async = function() {
                var d = this;
                return this.processed ? new Promise(function(_, k) {
                  d.error ? k(d.error) : _(d.stringify());
                }) : this.processing ? this.processing : (this.processing = new Promise(function(_, k) {
                  if (d.error)
                    return k(d.error);
                  d.plugin = 0, d.asyncTick(_, k);
                }).then(function() {
                  return d.processed = true, d.stringify();
                }), this.processing);
              }, y.sync = function() {
                if (this.processed)
                  return this.result;
                if (this.processed = true, this.processing)
                  throw new Error("Use process(css).then(cb) to work with async plugins");
                if (this.error)
                  throw this.error;
                for (var d = m(this.result.processor.plugins), _; !(_ = d()).done; ) {
                  var k = _.value, x = this.run(k);
                  if (s(x))
                    throw new Error("Use process(css).then(cb) to work with async plugins");
                }
                return this.result;
              }, y.run = function(d) {
                this.result.lastPlugin = d;
                try {
                  return d(this.result.root, this.result);
                } catch (_) {
                  throw this.handleError(_, d), _;
                }
              }, y.stringify = function() {
                if (this.stringified)
                  return this.result;
                this.stringified = true, this.sync();
                var d = this.result.opts, _ = u.default;
                d.syntax && (_ = d.syntax.stringify), d.stringifier && (_ = d.stringifier), _.stringify && (_ = _.stringify);
                var k = new i.default(_, this.result.root, this.result.opts), x = k.generate();
                return this.result.css = x[0], this.result.map = x[1], this.result;
              }, a(v, [{ key: "processor", get: function() {
                return this.result.processor;
              } }, { key: "opts", get: function() {
                return this.result.opts;
              } }, { key: "css", get: function() {
                return this.stringify().css;
              } }, { key: "content", get: function() {
                return this.stringify().content;
              } }, { key: "map", get: function() {
                return this.stringify().map;
              } }, { key: "root", get: function() {
                return this.sync().root;
              } }, { key: "messages", get: function() {
                return this.sync().messages;
              } }]), v;
            }(), g = f;
            e.default = g, n.exports = e.default;
          } }), jf = P({ "node_modules/postcss/lib/processor.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = u(ha());
            function u(c) {
              return c && c.__esModule ? c : { default: c };
            }
            function o(c, t3) {
              var r;
              if (typeof Symbol > "u" || c[Symbol.iterator] == null) {
                if (Array.isArray(c) || (r = h(c)) || t3 && c && typeof c.length == "number") {
                  r && (c = r);
                  var a = 0;
                  return function() {
                    return a >= c.length ? { done: true } : { done: false, value: c[a++] };
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              return r = c[Symbol.iterator](), r.next.bind(r);
            }
            function h(c, t3) {
              if (c) {
                if (typeof c == "string")
                  return l(c, t3);
                var r = Object.prototype.toString.call(c).slice(8, -1);
                if (r === "Object" && c.constructor && (r = c.constructor.name), r === "Map" || r === "Set")
                  return Array.from(c);
                if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                  return l(c, t3);
              }
            }
            function l(c, t3) {
              (t3 == null || t3 > c.length) && (t3 = c.length);
              for (var r = 0, a = new Array(t3); r < t3; r++)
                a[r] = c[r];
              return a;
            }
            var p = function() {
              function c(r) {
                r === void 0 && (r = []), this.version = "7.0.39", this.plugins = this.normalize(r);
              }
              var t3 = c.prototype;
              return t3.use = function(a) {
                return this.plugins = this.plugins.concat(this.normalize([a])), this;
              }, t3.process = function(r) {
                function a(s) {
                  return r.apply(this, arguments);
                }
                return a.toString = function() {
                  return r.toString();
                }, a;
              }(function(r, a) {
                return a === void 0 && (a = {}), this.plugins.length === 0 && (a.parser, a.stringifier), new i.default(this, r, a);
              }), t3.normalize = function(a) {
                for (var s = [], f = o(a), g; !(g = f()).done; ) {
                  var v = g.value;
                  if (v.postcss === true) {
                    var y = v();
                    throw new Error("PostCSS plugin " + y.postcssPlugin + ` requires PostCSS 8.
Migration guide for end-users:
https://github.com/postcss/postcss/wiki/PostCSS-8-for-end-users`);
                  }
                  if (v.postcss && (v = v.postcss), typeof v == "object" && Array.isArray(v.plugins))
                    s = s.concat(v.plugins);
                  else if (typeof v == "function")
                    s.push(v);
                  else if (!(typeof v == "object" && (v.parse || v.stringify)))
                    throw typeof v == "object" && v.postcssPlugin ? new Error("PostCSS plugin " + v.postcssPlugin + ` requires PostCSS 8.
Migration guide for end-users:
https://github.com/postcss/postcss/wiki/PostCSS-8-for-end-users`) : new Error(v + " is not a PostCSS plugin");
                }
                return s;
              }, c;
            }(), m = p;
            e.default = m, n.exports = e.default;
          } }), Mf = P({ "node_modules/postcss/lib/root.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = u(Or());
            function u(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function o(t3, r) {
              var a;
              if (typeof Symbol > "u" || t3[Symbol.iterator] == null) {
                if (Array.isArray(t3) || (a = h(t3)) || r && t3 && typeof t3.length == "number") {
                  a && (t3 = a);
                  var s = 0;
                  return function() {
                    return s >= t3.length ? { done: true } : { done: false, value: t3[s++] };
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              return a = t3[Symbol.iterator](), a.next.bind(a);
            }
            function h(t3, r) {
              if (t3) {
                if (typeof t3 == "string")
                  return l(t3, r);
                var a = Object.prototype.toString.call(t3).slice(8, -1);
                if (a === "Object" && t3.constructor && (a = t3.constructor.name), a === "Map" || a === "Set")
                  return Array.from(t3);
                if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a))
                  return l(t3, r);
              }
            }
            function l(t3, r) {
              (r == null || r > t3.length) && (r = t3.length);
              for (var a = 0, s = new Array(r); a < r; a++)
                s[a] = t3[a];
              return s;
            }
            function p(t3, r) {
              t3.prototype = Object.create(r.prototype), t3.prototype.constructor = t3, t3.__proto__ = r;
            }
            var m = function(t3) {
              p(r, t3);
              function r(s) {
                var f;
                return f = t3.call(this, s) || this, f.type = "root", f.nodes || (f.nodes = []), f;
              }
              var a = r.prototype;
              return a.removeChild = function(f, g) {
                var v = this.index(f);
                return !g && v === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[v].raws.before), t3.prototype.removeChild.call(this, f);
              }, a.normalize = function(f, g, v) {
                var y = t3.prototype.normalize.call(this, f);
                if (g) {
                  if (v === "prepend")
                    this.nodes.length > 1 ? g.raws.before = this.nodes[1].raws.before : delete g.raws.before;
                  else if (this.first !== g)
                    for (var w = o(y), d; !(d = w()).done; ) {
                      var _ = d.value;
                      _.raws.before = g.raws.before;
                    }
                }
                return y;
              }, a.toResult = function(f) {
                f === void 0 && (f = {});
                var g = ha(), v = jf(), y = new g(new v(), this, f);
                return y.stringify();
              }, r;
            }(i.default), c = m;
            e.default = c, n.exports = e.default;
          } }), $t = P({ "node_modules/postcss/lib/parser.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = m(ca()), u = m(Ut()), o = m(kr()), h = m(pa()), l = m(Mf()), p = m(fa());
            function m(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            var c = function() {
              function t3(a) {
                this.input = a, this.root = new l.default(), this.current = this.root, this.spaces = "", this.semicolon = false, this.createTokenizer(), this.root.source = { input: a, start: { line: 1, column: 1 } };
              }
              var r = t3.prototype;
              return r.createTokenizer = function() {
                this.tokenizer = (0, u.default)(this.input);
              }, r.parse = function() {
                for (var s; !this.tokenizer.endOfFile(); )
                  switch (s = this.tokenizer.nextToken(), s[0]) {
                    case "space":
                      this.spaces += s[1];
                      break;
                    case ";":
                      this.freeSemicolon(s);
                      break;
                    case "}":
                      this.end(s);
                      break;
                    case "comment":
                      this.comment(s);
                      break;
                    case "at-word":
                      this.atrule(s);
                      break;
                    case "{":
                      this.emptyRule(s);
                      break;
                    default:
                      this.other(s);
                      break;
                  }
                this.endFile();
              }, r.comment = function(s) {
                var f = new o.default();
                this.init(f, s[2], s[3]), f.source.end = { line: s[4], column: s[5] };
                var g = s[1].slice(2, -2);
                if (/^\s*$/.test(g))
                  f.text = "", f.raws.left = g, f.raws.right = "";
                else {
                  var v = g.match(/^(\s*)([^]*[^\s])(\s*)$/);
                  f.text = v[2], f.raws.left = v[1], f.raws.right = v[3];
                }
              }, r.emptyRule = function(s) {
                var f = new p.default();
                this.init(f, s[2], s[3]), f.selector = "", f.raws.between = "", this.current = f;
              }, r.other = function(s) {
                for (var f = false, g = null, v = false, y = null, w = [], d = [], _ = s; _; ) {
                  if (g = _[0], d.push(_), g === "(" || g === "[")
                    y || (y = _), w.push(g === "(" ? ")" : "]");
                  else if (w.length === 0)
                    if (g === ";")
                      if (v) {
                        this.decl(d);
                        return;
                      } else
                        break;
                    else if (g === "{") {
                      this.rule(d);
                      return;
                    } else if (g === "}") {
                      this.tokenizer.back(d.pop()), f = true;
                      break;
                    } else
                      g === ":" && (v = true);
                  else
                    g === w[w.length - 1] && (w.pop(), w.length === 0 && (y = null));
                  _ = this.tokenizer.nextToken();
                }
                if (this.tokenizer.endOfFile() && (f = true), w.length > 0 && this.unclosedBracket(y), f && v) {
                  for (; d.length && (_ = d[d.length - 1][0], !(_ !== "space" && _ !== "comment")); )
                    this.tokenizer.back(d.pop());
                  this.decl(d);
                } else
                  this.unknownWord(d);
              }, r.rule = function(s) {
                s.pop();
                var f = new p.default();
                this.init(f, s[0][2], s[0][3]), f.raws.between = this.spacesAndCommentsFromEnd(s), this.raw(f, "selector", s), this.current = f;
              }, r.decl = function(s) {
                var f = new i.default();
                this.init(f);
                var g = s[s.length - 1];
                for (g[0] === ";" && (this.semicolon = true, s.pop()), g[4] ? f.source.end = { line: g[4], column: g[5] } : f.source.end = { line: g[2], column: g[3] }; s[0][0] !== "word"; )
                  s.length === 1 && this.unknownWord(s), f.raws.before += s.shift()[1];
                for (f.source.start = { line: s[0][2], column: s[0][3] }, f.prop = ""; s.length; ) {
                  var v = s[0][0];
                  if (v === ":" || v === "space" || v === "comment")
                    break;
                  f.prop += s.shift()[1];
                }
                f.raws.between = "";
                for (var y; s.length; )
                  if (y = s.shift(), y[0] === ":") {
                    f.raws.between += y[1];
                    break;
                  } else
                    y[0] === "word" && /\w/.test(y[1]) && this.unknownWord([y]), f.raws.between += y[1];
                (f.prop[0] === "_" || f.prop[0] === "*") && (f.raws.before += f.prop[0], f.prop = f.prop.slice(1)), f.raws.between += this.spacesAndCommentsFromStart(s), this.precheckMissedSemicolon(s);
                for (var w = s.length - 1; w > 0; w--) {
                  if (y = s[w], y[1].toLowerCase() === "!important") {
                    f.important = true;
                    var d = this.stringFrom(s, w);
                    d = this.spacesFromEnd(s) + d, d !== " !important" && (f.raws.important = d);
                    break;
                  } else if (y[1].toLowerCase() === "important") {
                    for (var _ = s.slice(0), k = "", x = w; x > 0; x--) {
                      var N = _[x][0];
                      if (k.trim().indexOf("!") === 0 && N !== "space")
                        break;
                      k = _.pop()[1] + k;
                    }
                    k.trim().indexOf("!") === 0 && (f.important = true, f.raws.important = k, s = _);
                  }
                  if (y[0] !== "space" && y[0] !== "comment")
                    break;
                }
                this.raw(f, "value", s), f.value.indexOf(":") !== -1 && this.checkMissedSemicolon(s);
              }, r.atrule = function(s) {
                var f = new h.default();
                f.name = s[1].slice(1), f.name === "" && this.unnamedAtrule(f, s), this.init(f, s[2], s[3]);
                for (var g, v, y = false, w = false, d = []; !this.tokenizer.endOfFile(); ) {
                  if (s = this.tokenizer.nextToken(), s[0] === ";") {
                    f.source.end = { line: s[2], column: s[3] }, this.semicolon = true;
                    break;
                  } else if (s[0] === "{") {
                    w = true;
                    break;
                  } else if (s[0] === "}") {
                    if (d.length > 0) {
                      for (v = d.length - 1, g = d[v]; g && g[0] === "space"; )
                        g = d[--v];
                      g && (f.source.end = { line: g[4], column: g[5] });
                    }
                    this.end(s);
                    break;
                  } else
                    d.push(s);
                  if (this.tokenizer.endOfFile()) {
                    y = true;
                    break;
                  }
                }
                f.raws.between = this.spacesAndCommentsFromEnd(d), d.length ? (f.raws.afterName = this.spacesAndCommentsFromStart(d), this.raw(f, "params", d), y && (s = d[d.length - 1], f.source.end = { line: s[4], column: s[5] }, this.spaces = f.raws.between, f.raws.between = "")) : (f.raws.afterName = "", f.params = ""), w && (f.nodes = [], this.current = f);
              }, r.end = function(s) {
                this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = false, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = { line: s[2], column: s[3] }, this.current = this.current.parent) : this.unexpectedClose(s);
              }, r.endFile = function() {
                this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces;
              }, r.freeSemicolon = function(s) {
                if (this.spaces += s[1], this.current.nodes) {
                  var f = this.current.nodes[this.current.nodes.length - 1];
                  f && f.type === "rule" && !f.raws.ownSemicolon && (f.raws.ownSemicolon = this.spaces, this.spaces = "");
                }
              }, r.init = function(s, f, g) {
                this.current.push(s), s.source = { start: { line: f, column: g }, input: this.input }, s.raws.before = this.spaces, this.spaces = "", s.type !== "comment" && (this.semicolon = false);
              }, r.raw = function(s, f, g) {
                for (var v, y, w = g.length, d = "", _ = true, k, x, N = /^([.|#])?([\w])+/i, I = 0; I < w; I += 1) {
                  if (v = g[I], y = v[0], y === "comment" && s.type === "rule") {
                    x = g[I - 1], k = g[I + 1], x[0] !== "space" && k[0] !== "space" && N.test(x[1]) && N.test(k[1]) ? d += v[1] : _ = false;
                    continue;
                  }
                  y === "comment" || y === "space" && I === w - 1 ? _ = false : d += v[1];
                }
                if (!_) {
                  var W = g.reduce(function($, H) {
                    return $ + H[1];
                  }, "");
                  s.raws[f] = { value: d, raw: W };
                }
                s[f] = d;
              }, r.spacesAndCommentsFromEnd = function(s) {
                for (var f, g = ""; s.length && (f = s[s.length - 1][0], !(f !== "space" && f !== "comment")); )
                  g = s.pop()[1] + g;
                return g;
              }, r.spacesAndCommentsFromStart = function(s) {
                for (var f, g = ""; s.length && (f = s[0][0], !(f !== "space" && f !== "comment")); )
                  g += s.shift()[1];
                return g;
              }, r.spacesFromEnd = function(s) {
                for (var f, g = ""; s.length && (f = s[s.length - 1][0], f === "space"); )
                  g = s.pop()[1] + g;
                return g;
              }, r.stringFrom = function(s, f) {
                for (var g = "", v = f; v < s.length; v++)
                  g += s[v][1];
                return s.splice(f, s.length - f), g;
              }, r.colon = function(s) {
                for (var f = 0, g, v, y, w = 0; w < s.length; w++) {
                  if (g = s[w], v = g[0], v === "(" && (f += 1), v === ")" && (f -= 1), f === 0 && v === ":")
                    if (!y)
                      this.doubleColon(g);
                    else {
                      if (y[0] === "word" && y[1] === "progid")
                        continue;
                      return w;
                    }
                  y = g;
                }
                return false;
              }, r.unclosedBracket = function(s) {
                throw this.input.error("Unclosed bracket", s[2], s[3]);
              }, r.unknownWord = function(s) {
                throw this.input.error("Unknown word", s[0][2], s[0][3]);
              }, r.unexpectedClose = function(s) {
                throw this.input.error("Unexpected }", s[2], s[3]);
              }, r.unclosedBlock = function() {
                var s = this.current.source.start;
                throw this.input.error("Unclosed block", s.line, s.column);
              }, r.doubleColon = function(s) {
                throw this.input.error("Double colon", s[2], s[3]);
              }, r.unnamedAtrule = function(s, f) {
                throw this.input.error("At-rule without name", f[2], f[3]);
              }, r.precheckMissedSemicolon = function() {
              }, r.checkMissedSemicolon = function(s) {
                var f = this.colon(s);
                if (f !== false) {
                  for (var g = 0, v, y = f - 1; y >= 0 && (v = s[y], !(v[0] !== "space" && (g += 1, g === 2))); y--)
                    ;
                  throw this.input.error("Missed semicolon", v[2], v[3]);
                }
              }, t3;
            }();
            e.default = c, n.exports = e.default;
          } }), Df = P({ "node_modules/postcss-less/lib/nodes/inline-comment.js"(e, n) {
            A();
            var i = Ut(), u = xr();
            n.exports = { isInlineComment(o) {
              if (o[0] === "word" && o[1].slice(0, 2) === "//") {
                let h = o, l = [], p;
                for (; o; ) {
                  if (/\r?\n/.test(o[1])) {
                    if (/['"].*\r?\n/.test(o[1])) {
                      l.push(o[1].substring(0, o[1].indexOf(`
`)));
                      let c = o[1].substring(o[1].indexOf(`
`));
                      c += this.input.css.valueOf().substring(this.tokenizer.position()), this.input = new u(c), this.tokenizer = i(this.input);
                    } else
                      this.tokenizer.back(o);
                    break;
                  }
                  l.push(o[1]), p = o, o = this.tokenizer.nextToken({ ignoreUnclosed: true });
                }
                let m = ["comment", l.join(""), h[2], h[3], p[2], p[3]];
                return this.inlineComment(m), true;
              } else if (o[1] === "/") {
                let h = this.tokenizer.nextToken({ ignoreUnclosed: true });
                if (h[0] === "comment" && /^\/\*/.test(h[1]))
                  return h[0] = "word", h[1] = h[1].slice(1), o[1] = "//", this.tokenizer.back(h), n.exports.isInlineComment.bind(this)(o);
              }
              return false;
            } };
          } }), Lf = P({ "node_modules/postcss-less/lib/nodes/interpolation.js"(e, n) {
            A(), n.exports = { interpolation(i) {
              let u = i, o = [i], h = ["word", "{", "}"];
              if (i = this.tokenizer.nextToken(), u[1].length > 1 || i[0] !== "{")
                return this.tokenizer.back(i), false;
              for (; i && h.includes(i[0]); )
                o.push(i), i = this.tokenizer.nextToken();
              let l = o.map((r) => r[1]);
              [u] = o;
              let p = o.pop(), m = [u[2], u[3]], c = [p[4] || p[2], p[5] || p[3]], t3 = ["word", l.join("")].concat(m, c);
              return this.tokenizer.back(i), this.tokenizer.back(t3), true;
            } };
          } }), zf = P({ "node_modules/postcss-less/lib/nodes/mixin.js"(e, n) {
            A();
            var i = /^#[0-9a-fA-F]{6}$|^#[0-9a-fA-F]{3}$/, u = /\.[0-9]/, o = (h) => {
              let [, l] = h, [p] = l;
              return (p === "." || p === "#") && i.test(l) === false && u.test(l) === false;
            };
            n.exports = { isMixinToken: o };
          } }), Bf = P({ "node_modules/postcss-less/lib/nodes/import.js"(e, n) {
            A();
            var i = Ut(), u = /^url\((.+)\)/;
            n.exports = (o) => {
              let { name: h, params: l = "" } = o;
              if (h === "import" && l.length) {
                o.import = true;
                let p = i({ css: l });
                for (o.filename = l.replace(u, "$1"); !p.endOfFile(); ) {
                  let [m, c] = p.nextToken();
                  if (m === "word" && c === "url")
                    return;
                  if (m === "brackets") {
                    o.options = c, o.filename = l.replace(c, "").trim();
                    break;
                  }
                }
              }
            };
          } }), Ff = P({ "node_modules/postcss-less/lib/nodes/variable.js"(e, n) {
            A();
            var i = /:$/, u = /^:(\s+)?/;
            n.exports = (o) => {
              let { name: h, params: l = "" } = o;
              if (o.name.slice(-1) === ":") {
                if (i.test(h)) {
                  let [p] = h.match(i);
                  o.name = h.replace(p, ""), o.raws.afterName = p + (o.raws.afterName || ""), o.variable = true, o.value = o.params;
                }
                if (u.test(l)) {
                  let [p] = l.match(u);
                  o.value = l.replace(p, ""), o.raws.afterName = (o.raws.afterName || "") + p, o.variable = true;
                }
              }
            };
          } }), Uf = P({ "node_modules/postcss-less/lib/LessParser.js"(e, n) {
            A();
            var i = kr(), u = $t(), { isInlineComment: o } = Df(), { interpolation: h } = Lf(), { isMixinToken: l } = zf(), p = Bf(), m = Ff(), c = /(!\s*important)$/i;
            n.exports = class extends u {
              constructor() {
                super(...arguments), this.lastNode = null;
              }
              atrule(r) {
                h.bind(this)(r) || (super.atrule(r), p(this.lastNode), m(this.lastNode));
              }
              decl() {
                super.decl(...arguments), /extend\(.+\)/i.test(this.lastNode.value) && (this.lastNode.extend = true);
              }
              each(r) {
                r[0][1] = ` ${r[0][1]}`;
                let a = r.findIndex((y) => y[0] === "("), s = r.reverse().find((y) => y[0] === ")"), f = r.reverse().indexOf(s), v = r.splice(a, f).map((y) => y[1]).join("");
                for (let y of r.reverse())
                  this.tokenizer.back(y);
                this.atrule(this.tokenizer.nextToken()), this.lastNode.function = true, this.lastNode.params = v;
              }
              init(r, a, s) {
                super.init(r, a, s), this.lastNode = r;
              }
              inlineComment(r) {
                let a = new i(), s = r[1].slice(2);
                if (this.init(a, r[2], r[3]), a.source.end = { line: r[4], column: r[5] }, a.inline = true, a.raws.begin = "//", /^\s*$/.test(s))
                  a.text = "", a.raws.left = s, a.raws.right = "";
                else {
                  let f = s.match(/^(\s*)([^]*[^\s])(\s*)$/);
                  [, a.raws.left, a.text, a.raws.right] = f;
                }
              }
              mixin(r) {
                let [a] = r, s = a[1].slice(0, 1), f = r.findIndex((d) => d[0] === "brackets"), g = r.findIndex((d) => d[0] === "("), v = "";
                if ((f < 0 || f > 3) && g > 0) {
                  let d = r.reduce((V, B, O) => B[0] === ")" ? O : V), k = r.slice(g, d + g).map((V) => V[1]).join(""), [x] = r.slice(g), N = [x[2], x[3]], [I] = r.slice(d, d + 1), W = [I[2], I[3]], $ = ["brackets", k].concat(N, W), H = r.slice(0, g), D = r.slice(d + 1);
                  r = H, r.push($), r = r.concat(D);
                }
                let y = [];
                for (let d of r)
                  if ((d[1] === "!" || y.length) && y.push(d), d[1] === "important")
                    break;
                if (y.length) {
                  let [d] = y, _ = r.indexOf(d), k = y[y.length - 1], x = [d[2], d[3]], N = [k[4], k[5]], W = ["word", y.map(($) => $[1]).join("")].concat(x, N);
                  r.splice(_, y.length, W);
                }
                let w = r.findIndex((d) => c.test(d[1]));
                w > 0 && ([, v] = r[w], r.splice(w, 1));
                for (let d of r.reverse())
                  this.tokenizer.back(d);
                this.atrule(this.tokenizer.nextToken()), this.lastNode.mixin = true, this.lastNode.raws.identifier = s, v && (this.lastNode.important = true, this.lastNode.raws.important = v);
              }
              other(r) {
                o.bind(this)(r) || super.other(r);
              }
              rule(r) {
                let a = r[r.length - 1], s = r[r.length - 2];
                if (s[0] === "at-word" && a[0] === "{" && (this.tokenizer.back(a), h.bind(this)(s))) {
                  let g = this.tokenizer.nextToken();
                  r = r.slice(0, r.length - 2).concat([g]);
                  for (let v of r.reverse())
                    this.tokenizer.back(v);
                  return;
                }
                super.rule(r), /:extend\(.+\)/i.test(this.lastNode.selector) && (this.lastNode.extend = true);
              }
              unknownWord(r) {
                let [a] = r;
                if (r[0][1] === "each" && r[1][0] === "(") {
                  this.each(r);
                  return;
                }
                if (l(a)) {
                  this.mixin(r);
                  return;
                }
                super.unknownWord(r);
              }
            };
          } }), $f = P({ "node_modules/postcss-less/lib/LessStringifier.js"(e, n) {
            A();
            var i = Sr();
            n.exports = class extends i {
              atrule(o, h) {
                if (!o.mixin && !o.variable && !o.function) {
                  super.atrule(o, h);
                  return;
                }
                let p = `${o.function ? "" : o.raws.identifier || "@"}${o.name}`, m = o.params ? this.rawValue(o, "params") : "", c = o.raws.important || "";
                if (o.variable && (m = o.value), typeof o.raws.afterName < "u" ? p += o.raws.afterName : m && (p += " "), o.nodes)
                  this.block(o, p + m + c);
                else {
                  let t3 = (o.raws.between || "") + c + (h ? ";" : "");
                  this.builder(p + m + t3, o);
                }
              }
              comment(o) {
                if (o.inline) {
                  let h = this.raw(o, "left", "commentLeft"), l = this.raw(o, "right", "commentRight");
                  this.builder(`//${h}${o.text}${l}`, o);
                } else
                  super.comment(o);
              }
            };
          } }), Wf = P({ "node_modules/postcss-less/lib/index.js"(e, n) {
            A();
            var i = xr(), u = Uf(), o = $f();
            n.exports = { parse(h, l) {
              let p = new i(h, l), m = new u(p);
              return m.parse(), m.root;
            }, stringify(h, l) {
              new o(l).stringify(h);
            }, nodeToString(h) {
              let l = "";
              return n.exports.stringify(h, (p) => {
                l += p;
              }), l;
            } };
          } }), Vf = P({ "node_modules/postcss-scss/lib/scss-stringifier.js"(e, n) {
            "use strict";
            A();
            function i(h, l) {
              h.prototype = Object.create(l.prototype), h.prototype.constructor = h, h.__proto__ = l;
            }
            var u = Sr(), o = function(h) {
              i(l, h);
              function l() {
                return h.apply(this, arguments) || this;
              }
              var p = l.prototype;
              return p.comment = function(c) {
                var t3 = this.raw(c, "left", "commentLeft"), r = this.raw(c, "right", "commentRight");
                if (c.raws.inline) {
                  var a = c.raws.text || c.text;
                  this.builder("//" + t3 + a + r, c);
                } else
                  this.builder("/*" + t3 + c.text + r + "*/", c);
              }, p.decl = function(c, t3) {
                if (!c.isNested)
                  h.prototype.decl.call(this, c, t3);
                else {
                  var r = this.raw(c, "between", "colon"), a = c.prop + r + this.rawValue(c, "value");
                  c.important && (a += c.raws.important || " !important"), this.builder(a + "{", c, "start");
                  var s;
                  c.nodes && c.nodes.length ? (this.body(c), s = this.raw(c, "after")) : s = this.raw(c, "after", "emptyBody"), s && this.builder(s), this.builder("}", c, "end");
                }
              }, p.rawValue = function(c, t3) {
                var r = c[t3], a = c.raws[t3];
                return a && a.value === r ? a.scss ? a.scss : a.raw : r;
              }, l;
            }(u);
            n.exports = o;
          } }), Gf = P({ "node_modules/postcss-scss/lib/scss-stringify.js"(e, n) {
            "use strict";
            A();
            var i = Vf();
            n.exports = function(o, h) {
              var l = new i(h);
              l.stringify(o);
            };
          } }), Hf = P({ "node_modules/postcss-scss/lib/nested-declaration.js"(e, n) {
            "use strict";
            A();
            function i(h, l) {
              h.prototype = Object.create(l.prototype), h.prototype.constructor = h, h.__proto__ = l;
            }
            var u = Or(), o = function(h) {
              i(l, h);
              function l(p) {
                var m;
                return m = h.call(this, p) || this, m.type = "decl", m.isNested = true, m.nodes || (m.nodes = []), m;
              }
              return l;
            }(u);
            n.exports = o;
          } }), Jf = P({ "node_modules/postcss-scss/lib/scss-tokenize.js"(e, n) {
            "use strict";
            A();
            var i = "'".charCodeAt(0), u = '"'.charCodeAt(0), o = "\\".charCodeAt(0), h = "/".charCodeAt(0), l = `
`.charCodeAt(0), p = " ".charCodeAt(0), m = "\f".charCodeAt(0), c = "	".charCodeAt(0), t3 = "\r".charCodeAt(0), r = "[".charCodeAt(0), a = "]".charCodeAt(0), s = "(".charCodeAt(0), f = ")".charCodeAt(0), g = "{".charCodeAt(0), v = "}".charCodeAt(0), y = ";".charCodeAt(0), w = "*".charCodeAt(0), d = ":".charCodeAt(0), _ = "@".charCodeAt(0), k = ",".charCodeAt(0), x = "#".charCodeAt(0), N = /[ \n\t\r\f{}()'"\\;/[\]#]/g, I = /[ \n\t\r\f(){}:;@!'"\\\][#]|\/(?=\*)/g, W = /.[\\/("'\n]/, $ = /[a-f0-9]/i, H = /[\r\f\n]/g;
            n.exports = function(V, B) {
              B === void 0 && (B = {});
              var O = V.css.valueOf(), j = B.ignoreErrors, C, R, X, Z, Q, K, J, M, Y, G, E, S, b, L, q = O.length, T = -1, F = 1, z = 0, ee = [], te = [];
              function ue(ie) {
                throw V.error("Unclosed " + ie, F, z - T);
              }
              function le() {
                return te.length === 0 && z >= q;
              }
              function re() {
                for (var ie = 1, ce = false, fe = false; ie > 0; )
                  R += 1, O.length <= R && ue("interpolation"), C = O.charCodeAt(R), S = O.charCodeAt(R + 1), ce ? !fe && C === ce ? (ce = false, fe = false) : C === o ? fe = !G : fe && (fe = false) : C === i || C === u ? ce = C : C === v ? ie -= 1 : C === x && S === g && (ie += 1);
              }
              function ne() {
                if (te.length)
                  return te.pop();
                if (!(z >= q)) {
                  switch (C = O.charCodeAt(z), (C === l || C === m || C === t3 && O.charCodeAt(z + 1) !== l) && (T = z, F += 1), C) {
                    case l:
                    case p:
                    case c:
                    case t3:
                    case m:
                      R = z;
                      do
                        R += 1, C = O.charCodeAt(R), C === l && (T = R, F += 1);
                      while (C === p || C === l || C === c || C === t3 || C === m);
                      b = ["space", O.slice(z, R)], z = R - 1;
                      break;
                    case r:
                      b = ["[", "[", F, z - T];
                      break;
                    case a:
                      b = ["]", "]", F, z - T];
                      break;
                    case g:
                      b = ["{", "{", F, z - T];
                      break;
                    case v:
                      b = ["}", "}", F, z - T];
                      break;
                    case k:
                      b = ["word", ",", F, z - T, F, z - T + 1];
                      break;
                    case d:
                      b = [":", ":", F, z - T];
                      break;
                    case y:
                      b = [";", ";", F, z - T];
                      break;
                    case s:
                      if (E = ee.length ? ee.pop()[1] : "", S = O.charCodeAt(z + 1), E === "url" && S !== i && S !== u) {
                        for (L = 1, G = false, R = z + 1; R <= O.length - 1; ) {
                          if (S = O.charCodeAt(R), S === o)
                            G = !G;
                          else if (S === s)
                            L += 1;
                          else if (S === f && (L -= 1, L === 0))
                            break;
                          R += 1;
                        }
                        K = O.slice(z, R + 1), Z = K.split(`
`), Q = Z.length - 1, Q > 0 ? (M = F + Q, Y = R - Z[Q].length) : (M = F, Y = T), b = ["brackets", K, F, z - T, M, R - Y], T = Y, F = M, z = R;
                      } else
                        R = O.indexOf(")", z + 1), K = O.slice(z, R + 1), R === -1 || W.test(K) ? b = ["(", "(", F, z - T] : (b = ["brackets", K, F, z - T, F, R - T], z = R);
                      break;
                    case f:
                      b = [")", ")", F, z - T];
                      break;
                    case i:
                    case u:
                      for (X = C, R = z, G = false; R < q && (R++, R === q && ue("string"), C = O.charCodeAt(R), S = O.charCodeAt(R + 1), !(!G && C === X)); )
                        C === o ? G = !G : G ? G = false : C === x && S === g && re();
                      K = O.slice(z, R + 1), Z = K.split(`
`), Q = Z.length - 1, Q > 0 ? (M = F + Q, Y = R - Z[Q].length) : (M = F, Y = T), b = ["string", O.slice(z, R + 1), F, z - T, M, R - Y], T = Y, F = M, z = R;
                      break;
                    case _:
                      N.lastIndex = z + 1, N.test(O), N.lastIndex === 0 ? R = O.length - 1 : R = N.lastIndex - 2, b = ["at-word", O.slice(z, R + 1), F, z - T, F, R - T], z = R;
                      break;
                    case o:
                      for (R = z, J = true; O.charCodeAt(R + 1) === o; )
                        R += 1, J = !J;
                      if (C = O.charCodeAt(R + 1), J && C !== h && C !== p && C !== l && C !== c && C !== t3 && C !== m && (R += 1, $.test(O.charAt(R)))) {
                        for (; $.test(O.charAt(R + 1)); )
                          R += 1;
                        O.charCodeAt(R + 1) === p && (R += 1);
                      }
                      b = ["word", O.slice(z, R + 1), F, z - T, F, R - T], z = R;
                      break;
                    default:
                      S = O.charCodeAt(z + 1), C === x && S === g ? (R = z, re(), K = O.slice(z, R + 1), Z = K.split(`
`), Q = Z.length - 1, Q > 0 ? (M = F + Q, Y = R - Z[Q].length) : (M = F, Y = T), b = ["word", K, F, z - T, M, R - Y], T = Y, F = M, z = R) : C === h && S === w ? (R = O.indexOf("*/", z + 2) + 1, R === 0 && (j ? R = O.length : ue("comment")), K = O.slice(z, R + 1), Z = K.split(`
`), Q = Z.length - 1, Q > 0 ? (M = F + Q, Y = R - Z[Q].length) : (M = F, Y = T), b = ["comment", K, F, z - T, M, R - Y], T = Y, F = M, z = R) : C === h && S === h ? (H.lastIndex = z + 1, H.test(O), H.lastIndex === 0 ? R = O.length - 1 : R = H.lastIndex - 2, K = O.slice(z, R + 1), b = ["comment", K, F, z - T, F, R - T, "inline"], z = R) : (I.lastIndex = z + 1, I.test(O), I.lastIndex === 0 ? R = O.length - 1 : R = I.lastIndex - 2, b = ["word", O.slice(z, R + 1), F, z - T, F, R - T], ee.push(b), z = R);
                      break;
                  }
                  return z++, b;
                }
              }
              function oe(ie) {
                te.push(ie);
              }
              return { back: oe, nextToken: ne, endOfFile: le };
            };
          } }), Kf = P({ "node_modules/postcss-scss/lib/scss-parser.js"(e, n) {
            "use strict";
            A();
            function i(m, c) {
              m.prototype = Object.create(c.prototype), m.prototype.constructor = m, m.__proto__ = c;
            }
            var u = kr(), o = $t(), h = Hf(), l = Jf(), p = function(m) {
              i(c, m);
              function c() {
                return m.apply(this, arguments) || this;
              }
              var t3 = c.prototype;
              return t3.createTokenizer = function() {
                this.tokenizer = l(this.input);
              }, t3.rule = function(a) {
                for (var s = false, f = 0, g = "", w = a, v = Array.isArray(w), y = 0, w = v ? w : w[Symbol.iterator](); ; ) {
                  var d;
                  if (v) {
                    if (y >= w.length)
                      break;
                    d = w[y++];
                  } else {
                    if (y = w.next(), y.done)
                      break;
                    d = y.value;
                  }
                  var _ = d;
                  if (s)
                    _[0] !== "comment" && _[0] !== "{" && (g += _[1]);
                  else {
                    if (_[0] === "space" && _[1].indexOf(`
`) !== -1)
                      break;
                    _[0] === "(" ? f += 1 : _[0] === ")" ? f -= 1 : f === 0 && _[0] === ":" && (s = true);
                  }
                }
                if (!s || g.trim() === "" || /^[a-zA-Z-:#]/.test(g))
                  m.prototype.rule.call(this, a);
                else {
                  a.pop();
                  var k = new h();
                  this.init(k);
                  var x = a[a.length - 1];
                  for (x[4] ? k.source.end = { line: x[4], column: x[5] } : k.source.end = { line: x[2], column: x[3] }; a[0][0] !== "word"; )
                    k.raws.before += a.shift()[1];
                  for (k.source.start = { line: a[0][2], column: a[0][3] }, k.prop = ""; a.length; ) {
                    var N = a[0][0];
                    if (N === ":" || N === "space" || N === "comment")
                      break;
                    k.prop += a.shift()[1];
                  }
                  k.raws.between = "";
                  for (var I; a.length; )
                    if (I = a.shift(), I[0] === ":") {
                      k.raws.between += I[1];
                      break;
                    } else
                      k.raws.between += I[1];
                  (k.prop[0] === "_" || k.prop[0] === "*") && (k.raws.before += k.prop[0], k.prop = k.prop.slice(1)), k.raws.between += this.spacesAndCommentsFromStart(a), this.precheckMissedSemicolon(a);
                  for (var W = a.length - 1; W > 0; W--) {
                    if (I = a[W], I[1] === "!important") {
                      k.important = true;
                      var $ = this.stringFrom(a, W);
                      $ = this.spacesFromEnd(a) + $, $ !== " !important" && (k.raws.important = $);
                      break;
                    } else if (I[1] === "important") {
                      for (var H = a.slice(0), D = "", V = W; V > 0; V--) {
                        var B = H[V][0];
                        if (D.trim().indexOf("!") === 0 && B !== "space")
                          break;
                        D = H.pop()[1] + D;
                      }
                      D.trim().indexOf("!") === 0 && (k.important = true, k.raws.important = D, a = H);
                    }
                    if (I[0] !== "space" && I[0] !== "comment")
                      break;
                  }
                  this.raw(k, "value", a), k.value.indexOf(":") !== -1 && this.checkMissedSemicolon(a), this.current = k;
                }
              }, t3.comment = function(a) {
                if (a[6] === "inline") {
                  var s = new u();
                  this.init(s, a[2], a[3]), s.raws.inline = true, s.source.end = { line: a[4], column: a[5] };
                  var f = a[1].slice(2);
                  if (/^\s*$/.test(f))
                    s.text = "", s.raws.left = f, s.raws.right = "";
                  else {
                    var g = f.match(/^(\s*)([^]*[^\s])(\s*)$/), v = g[2].replace(/(\*\/|\/\*)/g, "*//*");
                    s.text = v, s.raws.left = g[1], s.raws.right = g[3], s.raws.text = g[2];
                  }
                } else
                  m.prototype.comment.call(this, a);
              }, t3.raw = function(a, s, f) {
                if (m.prototype.raw.call(this, a, s, f), a.raws[s]) {
                  var g = a.raws[s].raw;
                  a.raws[s].raw = f.reduce(function(v, y) {
                    if (y[0] === "comment" && y[6] === "inline") {
                      var w = y[1].slice(2).replace(/(\*\/|\/\*)/g, "*//*");
                      return v + "/*" + w + "*/";
                    } else
                      return v + y[1];
                  }, ""), g !== a.raws[s].raw && (a.raws[s].scss = g);
                }
              }, c;
            }(o);
            n.exports = p;
          } }), Qf = P({ "node_modules/postcss-scss/lib/scss-parse.js"(e, n) {
            "use strict";
            A();
            var i = xr(), u = Kf();
            n.exports = function(h, l) {
              var p = new i(h, l), m = new u(p);
              return m.parse(), m.root;
            };
          } }), Yf = P({ "node_modules/postcss-scss/lib/scss-syntax.js"(e, n) {
            "use strict";
            A();
            var i = Gf(), u = Qf();
            n.exports = { parse: u, stringify: i };
          } });
          A();
          var Xf = Sl(), mt = Us(), Zf = $s(), { hasPragma: ep } = Cl(), { locStart: rp, locEnd: tp } = no(), { calculateLoc: np, replaceQuotesInInlineComments: ip } = no(), sp = Dl(), op = Ll(), gt2 = zl(), da = Bl(), ap = Fl(), up = Ul(), cp = $l(), lp = Wl(), fp = (e) => {
            for (; e.parent; )
              e = e.parent;
            return e;
          };
          function pp(e, n) {
            let { nodes: i } = e, u = { open: null, close: null, groups: [], type: "paren_group" }, o = [u], h = u, l = { groups: [], type: "comma_group" }, p = [l];
            for (let m = 0; m < i.length; ++m) {
              let c = i[m];
              if (da(n.parser, c.value) && c.type === "number" && c.unit === ".." && mt(c.value) === "." && (c.value = c.value.slice(0, -1), c.unit = "..."), c.type === "func" && c.value === "selector" && (c.group.groups = [Re(fp(e).text.slice(c.group.open.sourceIndex + 1, c.group.close.sourceIndex))]), c.type === "func" && c.value === "url") {
                let t3 = c.group && c.group.groups || [], r = [];
                for (let a = 0; a < t3.length; a++) {
                  let s = t3[a];
                  s.type === "comma_group" ? r = [...r, ...s.groups] : r.push(s);
                }
                if (sp(r) || !op(r) && !up(r[0])) {
                  let a = cp({ groups: c.group.groups });
                  c.group.groups = [a.trim()];
                }
              }
              if (c.type === "paren" && c.value === "(")
                u = { open: c, close: null, groups: [], type: "paren_group" }, o.push(u), l = { groups: [], type: "comma_group" }, p.push(l);
              else if (c.type === "paren" && c.value === ")") {
                if (l.groups.length > 0 && u.groups.push(l), u.close = c, p.length === 1)
                  throw new Error("Unbalanced parenthesis");
                p.pop(), l = mt(p), l.groups.push(u), o.pop(), u = mt(o);
              } else
                c.type === "comma" ? (u.groups.push(l), l = { groups: [], type: "comma_group" }, p[p.length - 1] = l) : l.groups.push(c);
            }
            return l.groups.length > 0 && u.groups.push(l), h;
          }
          function vr(e) {
            return e.type === "paren_group" && !e.open && !e.close && e.groups.length === 1 || e.type === "comma_group" && e.groups.length === 1 ? vr(e.groups[0]) : e.type === "paren_group" || e.type === "comma_group" ? Object.assign(Object.assign({}, e), {}, { groups: e.groups.map(vr) }) : e;
          }
          function Xe(e, n, i) {
            if (e && typeof e == "object") {
              delete e.parent;
              for (let u in e)
                Xe(e[u], n, i), u === "type" && typeof e[u] == "string" && !e[u].startsWith(n) && (!i || !i.test(e[u])) && (e[u] = n + e[u]);
            }
            return e;
          }
          function va(e) {
            if (e && typeof e == "object") {
              delete e.parent;
              for (let n in e)
                va(e[n]);
              !Array.isArray(e) && e.value && !e.type && (e.type = "unknown");
            }
            return e;
          }
          function ma(e, n) {
            if (e && typeof e == "object") {
              for (let i in e)
                i !== "parent" && (ma(e[i], n), i === "nodes" && (e.group = vr(pp(e, n)), delete e[i]));
              delete e.parent;
            }
            return e;
          }
          function Pe(e, n) {
            let i = gf(), u = null;
            try {
              u = i(e, { loose: true }).parse();
            } catch {
              return { type: "value-unknown", value: e };
            }
            u.text = e;
            let o = ma(u, n);
            return Xe(o, "value-", /^selector-/);
          }
          function Re(e) {
            if (/\/\/|\/\*/.test(e))
              return { type: "selector-unknown", value: e.trim() };
            let n = xf(), i = null;
            try {
              n((u) => {
                i = u;
              }).process(e);
            } catch {
              return { type: "selector-unknown", value: e };
            }
            return Xe(i, "selector-");
          }
          function hp(e) {
            let n = kf().default, i = null;
            try {
              i = n(e);
            } catch {
              return { type: "selector-unknown", value: e };
            }
            return Xe(va(i), "media-");
          }
          var dp = /(\s*)(!default).*$/, vp = /(\s*)(!global).*$/;
          function ga(e, n) {
            if (e && typeof e == "object") {
              delete e.parent;
              for (let m in e)
                ga(e[m], n);
              if (!e.type)
                return e;
              e.raws || (e.raws = {});
              let h = "";
              if (typeof e.selector == "string") {
                var i;
                h = e.raws.selector ? (i = e.raws.selector.scss) !== null && i !== void 0 ? i : e.raws.selector.raw : e.selector, e.raws.between && e.raws.between.trim().length > 0 && (h += e.raws.between), e.raws.selector = h;
              }
              let l = "";
              if (typeof e.value == "string") {
                var u;
                l = e.raws.value ? (u = e.raws.value.scss) !== null && u !== void 0 ? u : e.raws.value.raw : e.value, l = l.trim(), e.raws.value = l;
              }
              let p = "";
              if (typeof e.params == "string") {
                var o;
                p = e.raws.params ? (o = e.raws.params.scss) !== null && o !== void 0 ? o : e.raws.params.raw : e.params, e.raws.afterName && e.raws.afterName.trim().length > 0 && (p = e.raws.afterName + p), e.raws.between && e.raws.between.trim().length > 0 && (p = p + e.raws.between), p = p.trim(), e.raws.params = p;
              }
              if (h.trim().length > 0)
                return h.startsWith("@") && h.endsWith(":") ? e : e.mixin ? (e.selector = Pe(h, n), e) : (ap(e) && (e.isSCSSNesterProperty = true), e.selector = Re(h), e);
              if (l.length > 0) {
                let m = l.match(dp);
                m && (l = l.slice(0, m.index), e.scssDefault = true, m[0].trim() !== "!default" && (e.raws.scssDefault = m[0]));
                let c = l.match(vp);
                if (c && (l = l.slice(0, c.index), e.scssGlobal = true, c[0].trim() !== "!global" && (e.raws.scssGlobal = c[0])), l.startsWith("progid:"))
                  return { type: "value-unknown", value: l };
                e.value = Pe(l, n);
              }
              if (gt2(n) && e.type === "css-decl" && l.startsWith("extend(") && (e.extend || (e.extend = e.raws.between === ":"), e.extend && !e.selector && (delete e.value, e.selector = Re(l.slice(7, -1)))), e.type === "css-atrule") {
                if (gt2(n)) {
                  if (e.mixin) {
                    let m = e.raws.identifier + e.name + e.raws.afterName + e.raws.params;
                    return e.selector = Re(m), delete e.params, e;
                  }
                  if (e.function)
                    return e;
                }
                if (n.parser === "css" && e.name === "custom-selector") {
                  let m = e.params.match(/:--\S+\s+/)[0].trim();
                  return e.customSelector = m, e.selector = Re(e.params.slice(m.length).trim()), delete e.params, e;
                }
                if (gt2(n)) {
                  if (e.name.includes(":") && !e.params) {
                    e.variable = true;
                    let m = e.name.split(":");
                    e.name = m[0], e.value = Pe(m.slice(1).join(":"), n);
                  }
                  if (!["page", "nest", "keyframes"].includes(e.name) && e.params && e.params[0] === ":") {
                    e.variable = true;
                    let m = e.params.slice(1);
                    m && (e.value = Pe(m, n)), e.raws.afterName += ":";
                  }
                  if (e.variable)
                    return delete e.params, e.value || delete e.value, e;
                }
              }
              if (e.type === "css-atrule" && p.length > 0) {
                let { name: m } = e, c = e.name.toLowerCase();
                return m === "warn" || m === "error" ? (e.params = { type: "media-unknown", value: p }, e) : m === "extend" || m === "nest" ? (e.selector = Re(p), delete e.params, e) : m === "at-root" ? (/^\(\s*(?:without|with)\s*:.+\)$/s.test(p) ? e.params = Pe(p, n) : (e.selector = Re(p), delete e.params), e) : lp(c) ? (e.import = true, delete e.filename, e.params = Pe(p, n), e) : ["namespace", "supports", "if", "else", "for", "each", "while", "debug", "mixin", "include", "function", "return", "define-mixin", "add-mixin"].includes(m) ? (p = p.replace(/(\$\S+?)(\s+)?\.{3}/, "$1...$2"), p = p.replace(/^(?!if)(\S+)(\s+)\(/, "$1($2"), e.value = Pe(p, n), delete e.params, e) : ["media", "custom-media"].includes(c) ? p.includes("#{") ? { type: "media-unknown", value: p } : (e.params = hp(p), e) : (e.params = p, e);
              }
            }
            return e;
          }
          function ya(e, n, i) {
            let u = Zf(n), { frontMatter: o } = u;
            n = u.content;
            let h;
            try {
              h = e(n);
            } catch (l) {
              let { name: p, reason: m, line: c, column: t3 } = l;
              throw typeof c != "number" ? l : Xf(`${p}: ${m}`, { start: { line: c, column: t3 } });
            }
            return h = ga(Xe(h, "css-"), i), np(h, n), o && (o.source = { startOffset: 0, endOffset: o.raw.length }, h.nodes.unshift(o)), h;
          }
          function mp(e, n) {
            let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = da(i.parser, e) ? [Tt, Ot] : [Ot, Tt], h;
            for (let l of o)
              try {
                return l(e, n, i);
              } catch (p) {
                h = h || p;
              }
            if (h)
              throw h;
          }
          function Ot(e, n) {
            let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, u = Wf();
            return ya((o) => u.parse(ip(o)), e, i);
          }
          function Tt(e, n) {
            let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, { parse: u } = Yf();
            return ya(u, e, i);
          }
          var yt = { astFormat: "postcss", hasPragma: ep, locStart: rp, locEnd: tp };
          wa.exports = { parsers: { css: Object.assign(Object.assign({}, yt), {}, { parse: mp }), less: Object.assign(Object.assign({}, yt), {}, { parse: Ot }), scss: Object.assign(Object.assign({}, yt), {}, { parse: Tt }) } };
        });
        return gp();
      });
    }
  });

  // ../../node_modules/.pnpm/prettier@2.8.8/node_modules/prettier/parser-html.js
  var require_parser_html = __commonJS({
    "../../node_modules/.pnpm/prettier@2.8.8/node_modules/prettier/parser-html.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      (function(e) {
        if (typeof exports8 == "object" && typeof module2 == "object")
          module2.exports = e();
        else if (typeof define == "function" && define.amd)
          define(e);
        else {
          var i = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : typeof self < "u" ? self : this || {};
          i.prettierPlugins = i.prettierPlugins || {}, i.prettierPlugins.html = e();
        }
      })(function() {
        "use strict";
        var S = (e, r) => () => (r || e((r = { exports: {} }).exports, r), r.exports);
        var ee = S((cc, Kr) => {
          var Ne = function(e) {
            return e && e.Math == Math && e;
          };
          Kr.exports = Ne(typeof globalThis == "object" && globalThis) || Ne(typeof window == "object" && window) || Ne(typeof self == "object" && self) || Ne(typeof global == "object" && global) || function() {
            return this;
          }() || Function("return this")();
        });
        var se = S((hc, Jr) => {
          Jr.exports = function(e) {
            try {
              return !!e();
            } catch {
              return true;
            }
          };
        });
        var ae = S((pc, Zr) => {
          var qs = se();
          Zr.exports = !qs(function() {
            return Object.defineProperty({}, 1, { get: function() {
              return 7;
            } })[1] != 7;
          });
        });
        var Oe = S((fc, eu) => {
          var Is = se();
          eu.exports = !Is(function() {
            var e = function() {
            }.bind();
            return typeof e != "function" || e.hasOwnProperty("prototype");
          });
        });
        var De = S((dc, ru) => {
          var Rs = Oe(), qe = Function.prototype.call;
          ru.exports = Rs ? qe.bind(qe) : function() {
            return qe.apply(qe, arguments);
          };
        });
        var su = S((nu) => {
          "use strict";
          var uu = {}.propertyIsEnumerable, tu = Object.getOwnPropertyDescriptor, xs = tu && !uu.call({ 1: 2 }, 1);
          nu.f = xs ? function(r) {
            var u = tu(this, r);
            return !!u && u.enumerable;
          } : uu;
        });
        var Ie = S((Cc, iu) => {
          iu.exports = function(e, r) {
            return { enumerable: !(e & 1), configurable: !(e & 2), writable: !(e & 4), value: r };
          };
        });
        var re = S((mc, Du) => {
          var au = Oe(), ou = Function.prototype, er = ou.call, Ps = au && ou.bind.bind(er, er);
          Du.exports = au ? Ps : function(e) {
            return function() {
              return er.apply(e, arguments);
            };
          };
        });
        var me = S((gc, cu) => {
          var lu = re(), ks = lu({}.toString), Ls = lu("".slice);
          cu.exports = function(e) {
            return Ls(ks(e), 8, -1);
          };
        });
        var pu = S((Fc, hu) => {
          var $s = re(), Ms = se(), js = me(), rr = Object, Us = $s("".split);
          hu.exports = Ms(function() {
            return !rr("z").propertyIsEnumerable(0);
          }) ? function(e) {
            return js(e) == "String" ? Us(e, "") : rr(e);
          } : rr;
        });
        var Re = S((Ac, fu) => {
          fu.exports = function(e) {
            return e == null;
          };
        });
        var ur = S((vc, du) => {
          var Gs = Re(), Vs = TypeError;
          du.exports = function(e) {
            if (Gs(e))
              throw Vs("Can't call method on " + e);
            return e;
          };
        });
        var xe = S((_c, Eu) => {
          var Xs = pu(), Hs = ur();
          Eu.exports = function(e) {
            return Xs(Hs(e));
          };
        });
        var nr = S((Sc, Cu) => {
          var tr = typeof document == "object" && document.all, zs = typeof tr > "u" && tr !== void 0;
          Cu.exports = { all: tr, IS_HTMLDDA: zs };
        });
        var Y = S((yc, gu) => {
          var mu = nr(), Ws = mu.all;
          gu.exports = mu.IS_HTMLDDA ? function(e) {
            return typeof e == "function" || e === Ws;
          } : function(e) {
            return typeof e == "function";
          };
        });
        var le = S((Tc, vu) => {
          var Fu = Y(), Au = nr(), Ys = Au.all;
          vu.exports = Au.IS_HTMLDDA ? function(e) {
            return typeof e == "object" ? e !== null : Fu(e) || e === Ys;
          } : function(e) {
            return typeof e == "object" ? e !== null : Fu(e);
          };
        });
        var ge = S((Bc, _u) => {
          var sr = ee(), Qs = Y(), Ks = function(e) {
            return Qs(e) ? e : void 0;
          };
          _u.exports = function(e, r) {
            return arguments.length < 2 ? Ks(sr[e]) : sr[e] && sr[e][r];
          };
        });
        var ir = S((bc, Su) => {
          var Js = re();
          Su.exports = Js({}.isPrototypeOf);
        });
        var Tu = S((wc, yu) => {
          var Zs = ge();
          yu.exports = Zs("navigator", "userAgent") || "";
        });
        var Iu = S((Nc, qu) => {
          var Ou = ee(), ar = Tu(), Bu = Ou.process, bu = Ou.Deno, wu = Bu && Bu.versions || bu && bu.version, Nu = wu && wu.v8, ue, Pe;
          Nu && (ue = Nu.split("."), Pe = ue[0] > 0 && ue[0] < 4 ? 1 : +(ue[0] + ue[1]));
          !Pe && ar && (ue = ar.match(/Edge\/(\d+)/), (!ue || ue[1] >= 74) && (ue = ar.match(/Chrome\/(\d+)/), ue && (Pe = +ue[1])));
          qu.exports = Pe;
        });
        var or = S((Oc, xu) => {
          var Ru = Iu(), ei = se();
          xu.exports = !!Object.getOwnPropertySymbols && !ei(function() {
            var e = Symbol();
            return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && Ru && Ru < 41;
          });
        });
        var Dr = S((qc, Pu) => {
          var ri = or();
          Pu.exports = ri && !Symbol.sham && typeof Symbol.iterator == "symbol";
        });
        var lr = S((Ic, ku) => {
          var ui = ge(), ti = Y(), ni = ir(), si = Dr(), ii = Object;
          ku.exports = si ? function(e) {
            return typeof e == "symbol";
          } : function(e) {
            var r = ui("Symbol");
            return ti(r) && ni(r.prototype, ii(e));
          };
        });
        var ke = S((Rc, Lu) => {
          var ai = String;
          Lu.exports = function(e) {
            try {
              return ai(e);
            } catch {
              return "Object";
            }
          };
        });
        var Fe = S((xc, $u) => {
          var oi = Y(), Di = ke(), li = TypeError;
          $u.exports = function(e) {
            if (oi(e))
              return e;
            throw li(Di(e) + " is not a function");
          };
        });
        var Le = S((Pc, Mu) => {
          var ci = Fe(), hi = Re();
          Mu.exports = function(e, r) {
            var u = e[r];
            return hi(u) ? void 0 : ci(u);
          };
        });
        var Uu = S((kc, ju) => {
          var cr = De(), hr = Y(), pr = le(), pi = TypeError;
          ju.exports = function(e, r) {
            var u, n;
            if (r === "string" && hr(u = e.toString) && !pr(n = cr(u, e)) || hr(u = e.valueOf) && !pr(n = cr(u, e)) || r !== "string" && hr(u = e.toString) && !pr(n = cr(u, e)))
              return n;
            throw pi("Can't convert object to primitive value");
          };
        });
        var Vu = S((Lc, Gu) => {
          Gu.exports = false;
        });
        var $e = S(($c, Hu) => {
          var Xu = ee(), fi = Object.defineProperty;
          Hu.exports = function(e, r) {
            try {
              fi(Xu, e, { value: r, configurable: true, writable: true });
            } catch {
              Xu[e] = r;
            }
            return r;
          };
        });
        var Me = S((Mc, Wu) => {
          var di = ee(), Ei = $e(), zu = "__core-js_shared__", Ci = di[zu] || Ei(zu, {});
          Wu.exports = Ci;
        });
        var fr = S((jc, Qu) => {
          var mi = Vu(), Yu = Me();
          (Qu.exports = function(e, r) {
            return Yu[e] || (Yu[e] = r !== void 0 ? r : {});
          })("versions", []).push({ version: "3.26.1", mode: mi ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE", source: "https://github.com/zloirock/core-js" });
        });
        var dr = S((Uc, Ku) => {
          var gi = ur(), Fi = Object;
          Ku.exports = function(e) {
            return Fi(gi(e));
          };
        });
        var oe = S((Gc, Ju) => {
          var Ai = re(), vi = dr(), _i = Ai({}.hasOwnProperty);
          Ju.exports = Object.hasOwn || function(r, u) {
            return _i(vi(r), u);
          };
        });
        var Er = S((Vc, Zu) => {
          var Si = re(), yi = 0, Ti = Math.random(), Bi = Si(1 .toString);
          Zu.exports = function(e) {
            return "Symbol(" + (e === void 0 ? "" : e) + ")_" + Bi(++yi + Ti, 36);
          };
        });
        var he = S((Xc, nt) => {
          var bi = ee(), wi = fr(), et = oe(), Ni = Er(), rt = or(), tt = Dr(), fe = wi("wks"), ce = bi.Symbol, ut = ce && ce.for, Oi = tt ? ce : ce && ce.withoutSetter || Ni;
          nt.exports = function(e) {
            if (!et(fe, e) || !(rt || typeof fe[e] == "string")) {
              var r = "Symbol." + e;
              rt && et(ce, e) ? fe[e] = ce[e] : tt && ut ? fe[e] = ut(r) : fe[e] = Oi(r);
            }
            return fe[e];
          };
        });
        var ot = S((Hc, at2) => {
          var qi = De(), st = le(), it = lr(), Ii = Le(), Ri = Uu(), xi = he(), Pi = TypeError, ki = xi("toPrimitive");
          at2.exports = function(e, r) {
            if (!st(e) || it(e))
              return e;
            var u = Ii(e, ki), n;
            if (u) {
              if (r === void 0 && (r = "default"), n = qi(u, e, r), !st(n) || it(n))
                return n;
              throw Pi("Can't convert object to primitive value");
            }
            return r === void 0 && (r = "number"), Ri(e, r);
          };
        });
        var je = S((zc, Dt) => {
          var Li = ot(), $i = lr();
          Dt.exports = function(e) {
            var r = Li(e, "string");
            return $i(r) ? r : r + "";
          };
        });
        var ht = S((Wc, ct) => {
          var Mi = ee(), lt2 = le(), Cr = Mi.document, ji = lt2(Cr) && lt2(Cr.createElement);
          ct.exports = function(e) {
            return ji ? Cr.createElement(e) : {};
          };
        });
        var mr = S((Yc, pt) => {
          var Ui = ae(), Gi = se(), Vi = ht();
          pt.exports = !Ui && !Gi(function() {
            return Object.defineProperty(Vi("div"), "a", { get: function() {
              return 7;
            } }).a != 7;
          });
        });
        var gr = S((dt) => {
          var Xi = ae(), Hi = De(), zi = su(), Wi = Ie(), Yi = xe(), Qi = je(), Ki = oe(), Ji = mr(), ft = Object.getOwnPropertyDescriptor;
          dt.f = Xi ? ft : function(r, u) {
            if (r = Yi(r), u = Qi(u), Ji)
              try {
                return ft(r, u);
              } catch {
              }
            if (Ki(r, u))
              return Wi(!Hi(zi.f, r, u), r[u]);
          };
        });
        var Ct = S((Kc, Et) => {
          var Zi = ae(), ea = se();
          Et.exports = Zi && ea(function() {
            return Object.defineProperty(function() {
            }, "prototype", { value: 42, writable: false }).prototype != 42;
          });
        });
        var de = S((Jc, mt) => {
          var ra = le(), ua = String, ta = TypeError;
          mt.exports = function(e) {
            if (ra(e))
              return e;
            throw ta(ua(e) + " is not an object");
          };
        });
        var Ae = S((Ft) => {
          var na = ae(), sa = mr(), ia = Ct(), Ue = de(), gt2 = je(), aa = TypeError, Fr = Object.defineProperty, oa = Object.getOwnPropertyDescriptor, Ar = "enumerable", vr = "configurable", _r = "writable";
          Ft.f = na ? ia ? function(r, u, n) {
            if (Ue(r), u = gt2(u), Ue(n), typeof r == "function" && u === "prototype" && "value" in n && _r in n && !n[_r]) {
              var D = oa(r, u);
              D && D[_r] && (r[u] = n.value, n = { configurable: vr in n ? n[vr] : D[vr], enumerable: Ar in n ? n[Ar] : D[Ar], writable: false });
            }
            return Fr(r, u, n);
          } : Fr : function(r, u, n) {
            if (Ue(r), u = gt2(u), Ue(n), sa)
              try {
                return Fr(r, u, n);
              } catch {
              }
            if ("get" in n || "set" in n)
              throw aa("Accessors not supported");
            return "value" in n && (r[u] = n.value), r;
          };
        });
        var Sr = S((e2, At) => {
          var Da = ae(), la = Ae(), ca = Ie();
          At.exports = Da ? function(e, r, u) {
            return la.f(e, r, ca(1, u));
          } : function(e, r, u) {
            return e[r] = u, e;
          };
        });
        var St = S((r2, _t) => {
          var yr = ae(), ha = oe(), vt = Function.prototype, pa = yr && Object.getOwnPropertyDescriptor, Tr = ha(vt, "name"), fa = Tr && function() {
          }.name === "something", da = Tr && (!yr || yr && pa(vt, "name").configurable);
          _t.exports = { EXISTS: Tr, PROPER: fa, CONFIGURABLE: da };
        });
        var br = S((u2, yt) => {
          var Ea = re(), Ca = Y(), Br = Me(), ma = Ea(Function.toString);
          Ca(Br.inspectSource) || (Br.inspectSource = function(e) {
            return ma(e);
          });
          yt.exports = Br.inspectSource;
        });
        var bt = S((t22, Bt) => {
          var ga = ee(), Fa = Y(), Tt = ga.WeakMap;
          Bt.exports = Fa(Tt) && /native code/.test(String(Tt));
        });
        var Ot = S((n2, Nt) => {
          var Aa = fr(), va = Er(), wt = Aa("keys");
          Nt.exports = function(e) {
            return wt[e] || (wt[e] = va(e));
          };
        });
        var wr = S((s2, qt) => {
          qt.exports = {};
        });
        var Pt = S((i2, xt) => {
          var _a = bt(), Rt = ee(), Sa = le(), ya = Sr(), Nr = oe(), Or = Me(), Ta = Ot(), Ba = wr(), It = "Object already initialized", qr = Rt.TypeError, ba = Rt.WeakMap, Ge, ve, Ve, wa = function(e) {
            return Ve(e) ? ve(e) : Ge(e, {});
          }, Na = function(e) {
            return function(r) {
              var u;
              if (!Sa(r) || (u = ve(r)).type !== e)
                throw qr("Incompatible receiver, " + e + " required");
              return u;
            };
          };
          _a || Or.state ? (te = Or.state || (Or.state = new ba()), te.get = te.get, te.has = te.has, te.set = te.set, Ge = function(e, r) {
            if (te.has(e))
              throw qr(It);
            return r.facade = e, te.set(e, r), r;
          }, ve = function(e) {
            return te.get(e) || {};
          }, Ve = function(e) {
            return te.has(e);
          }) : (pe = Ta("state"), Ba[pe] = true, Ge = function(e, r) {
            if (Nr(e, pe))
              throw qr(It);
            return r.facade = e, ya(e, pe, r), r;
          }, ve = function(e) {
            return Nr(e, pe) ? e[pe] : {};
          }, Ve = function(e) {
            return Nr(e, pe);
          });
          var te, pe;
          xt.exports = { set: Ge, get: ve, has: Ve, enforce: wa, getterFor: Na };
        });
        var $t = S((a2, Lt) => {
          var Oa = se(), qa = Y(), Xe = oe(), Ir = ae(), Ia = St().CONFIGURABLE, Ra = br(), kt = Pt(), xa = kt.enforce, Pa = kt.get, He = Object.defineProperty, ka = Ir && !Oa(function() {
            return He(function() {
            }, "length", { value: 8 }).length !== 8;
          }), La = String(String).split("String"), $a = Lt.exports = function(e, r, u) {
            String(r).slice(0, 7) === "Symbol(" && (r = "[" + String(r).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), u && u.getter && (r = "get " + r), u && u.setter && (r = "set " + r), (!Xe(e, "name") || Ia && e.name !== r) && (Ir ? He(e, "name", { value: r, configurable: true }) : e.name = r), ka && u && Xe(u, "arity") && e.length !== u.arity && He(e, "length", { value: u.arity });
            try {
              u && Xe(u, "constructor") && u.constructor ? Ir && He(e, "prototype", { writable: false }) : e.prototype && (e.prototype = void 0);
            } catch {
            }
            var n = xa(e);
            return Xe(n, "source") || (n.source = La.join(typeof r == "string" ? r : "")), e;
          };
          Function.prototype.toString = $a(function() {
            return qa(this) && Pa(this).source || Ra(this);
          }, "toString");
        });
        var jt = S((o2, Mt) => {
          var Ma = Y(), ja = Ae(), Ua = $t(), Ga = $e();
          Mt.exports = function(e, r, u, n) {
            n || (n = {});
            var D = n.enumerable, s = n.name !== void 0 ? n.name : r;
            if (Ma(u) && Ua(u, s, n), n.global)
              D ? e[r] = u : Ga(r, u);
            else {
              try {
                n.unsafe ? e[r] && (D = true) : delete e[r];
              } catch {
              }
              D ? e[r] = u : ja.f(e, r, { value: u, enumerable: false, configurable: !n.nonConfigurable, writable: !n.nonWritable });
            }
            return e;
          };
        });
        var Gt = S((D2, Ut) => {
          var Va = Math.ceil, Xa = Math.floor;
          Ut.exports = Math.trunc || function(r) {
            var u = +r;
            return (u > 0 ? Xa : Va)(u);
          };
        });
        var Rr = S((l2, Vt) => {
          var Ha = Gt();
          Vt.exports = function(e) {
            var r = +e;
            return r !== r || r === 0 ? 0 : Ha(r);
          };
        });
        var Ht = S((c2, Xt) => {
          var za = Rr(), Wa = Math.max, Ya = Math.min;
          Xt.exports = function(e, r) {
            var u = za(e);
            return u < 0 ? Wa(u + r, 0) : Ya(u, r);
          };
        });
        var Wt = S((h2, zt) => {
          var Qa = Rr(), Ka = Math.min;
          zt.exports = function(e) {
            return e > 0 ? Ka(Qa(e), 9007199254740991) : 0;
          };
        });
        var _e = S((p2, Yt) => {
          var Ja = Wt();
          Yt.exports = function(e) {
            return Ja(e.length);
          };
        });
        var Jt = S((f2, Kt) => {
          var Za = xe(), eo = Ht(), ro = _e(), Qt = function(e) {
            return function(r, u, n) {
              var D = Za(r), s = ro(D), i = eo(n, s), f;
              if (e && u != u) {
                for (; s > i; )
                  if (f = D[i++], f != f)
                    return true;
              } else
                for (; s > i; i++)
                  if ((e || i in D) && D[i] === u)
                    return e || i || 0;
              return !e && -1;
            };
          };
          Kt.exports = { includes: Qt(true), indexOf: Qt(false) };
        });
        var rn = S((d2, en) => {
          var uo = re(), xr = oe(), to = xe(), no = Jt().indexOf, so = wr(), Zt = uo([].push);
          en.exports = function(e, r) {
            var u = to(e), n = 0, D = [], s;
            for (s in u)
              !xr(so, s) && xr(u, s) && Zt(D, s);
            for (; r.length > n; )
              xr(u, s = r[n++]) && (~no(D, s) || Zt(D, s));
            return D;
          };
        });
        var tn = S((E2, un) => {
          un.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        });
        var sn = S((nn) => {
          var io = rn(), ao = tn(), oo = ao.concat("length", "prototype");
          nn.f = Object.getOwnPropertyNames || function(r) {
            return io(r, oo);
          };
        });
        var on3 = S((an) => {
          an.f = Object.getOwnPropertySymbols;
        });
        var ln = S((g2, Dn) => {
          var Do = ge(), lo = re(), co = sn(), ho = on3(), po = de(), fo = lo([].concat);
          Dn.exports = Do("Reflect", "ownKeys") || function(r) {
            var u = co.f(po(r)), n = ho.f;
            return n ? fo(u, n(r)) : u;
          };
        });
        var pn = S((F2, hn) => {
          var cn = oe(), Eo = ln(), Co = gr(), mo = Ae();
          hn.exports = function(e, r, u) {
            for (var n = Eo(r), D = mo.f, s = Co.f, i = 0; i < n.length; i++) {
              var f = n[i];
              !cn(e, f) && !(u && cn(u, f)) && D(e, f, s(r, f));
            }
          };
        });
        var dn = S((A2, fn) => {
          var go = se(), Fo = Y(), Ao = /#|\.prototype\./, Se = function(e, r) {
            var u = _o[vo(e)];
            return u == yo ? true : u == So ? false : Fo(r) ? go(r) : !!r;
          }, vo = Se.normalize = function(e) {
            return String(e).replace(Ao, ".").toLowerCase();
          }, _o = Se.data = {}, So = Se.NATIVE = "N", yo = Se.POLYFILL = "P";
          fn.exports = Se;
        });
        var ze = S((v2, En) => {
          var Pr = ee(), To = gr().f, Bo = Sr(), bo = jt(), wo = $e(), No = pn(), Oo = dn();
          En.exports = function(e, r) {
            var u = e.target, n = e.global, D = e.stat, s, i, f, c, F, a;
            if (n ? i = Pr : D ? i = Pr[u] || wo(u, {}) : i = (Pr[u] || {}).prototype, i)
              for (f in r) {
                if (F = r[f], e.dontCallGetSet ? (a = To(i, f), c = a && a.value) : c = i[f], s = Oo(n ? f : u + (D ? "." : "#") + f, e.forced), !s && c !== void 0) {
                  if (typeof F == typeof c)
                    continue;
                  No(F, c);
                }
                (e.sham || c && c.sham) && Bo(F, "sham", true), bo(i, f, F, e);
              }
          };
        });
        var Cn = S(() => {
          var qo = ze(), kr = ee();
          qo({ global: true, forced: kr.globalThis !== kr }, { globalThis: kr });
        });
        var mn = S(() => {
          Cn();
        });
        var Lr = S((B2, gn) => {
          var Io = me();
          gn.exports = Array.isArray || function(r) {
            return Io(r) == "Array";
          };
        });
        var An = S((b2, Fn) => {
          var Ro = TypeError, xo = 9007199254740991;
          Fn.exports = function(e) {
            if (e > xo)
              throw Ro("Maximum allowed index exceeded");
            return e;
          };
        });
        var _n = S((w2, vn) => {
          var Po = me(), ko = re();
          vn.exports = function(e) {
            if (Po(e) === "Function")
              return ko(e);
          };
        });
        var $r = S((N2, yn) => {
          var Sn = _n(), Lo = Fe(), $o = Oe(), Mo = Sn(Sn.bind);
          yn.exports = function(e, r) {
            return Lo(e), r === void 0 ? e : $o ? Mo(e, r) : function() {
              return e.apply(r, arguments);
            };
          };
        });
        var bn = S((O2, Bn) => {
          "use strict";
          var jo = Lr(), Uo = _e(), Go = An(), Vo = $r(), Tn = function(e, r, u, n, D, s, i, f) {
            for (var c = D, F = 0, a = i ? Vo(i, f) : false, l, h; F < n; )
              F in u && (l = a ? a(u[F], F, r) : u[F], s > 0 && jo(l) ? (h = Uo(l), c = Tn(e, r, l, h, c, s - 1) - 1) : (Go(c + 1), e[c] = l), c++), F++;
            return c;
          };
          Bn.exports = Tn;
        });
        var On = S((q2, Nn) => {
          var Xo = he(), Ho = Xo("toStringTag"), wn = {};
          wn[Ho] = "z";
          Nn.exports = String(wn) === "[object z]";
        });
        var Mr = S((I2, qn) => {
          var zo = On(), Wo = Y(), We = me(), Yo = he(), Qo = Yo("toStringTag"), Ko = Object, Jo = We(function() {
            return arguments;
          }()) == "Arguments", Zo = function(e, r) {
            try {
              return e[r];
            } catch {
            }
          };
          qn.exports = zo ? We : function(e) {
            var r, u, n;
            return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (u = Zo(r = Ko(e), Qo)) == "string" ? u : Jo ? We(r) : (n = We(r)) == "Object" && Wo(r.callee) ? "Arguments" : n;
          };
        });
        var Ln = S((R2, kn) => {
          var eD = re(), rD = se(), In = Y(), uD = Mr(), tD = ge(), nD = br(), Rn = function() {
          }, sD = [], xn = tD("Reflect", "construct"), jr = /^\s*(?:class|function)\b/, iD = eD(jr.exec), aD = !jr.exec(Rn), ye = function(r) {
            if (!In(r))
              return false;
            try {
              return xn(Rn, sD, r), true;
            } catch {
              return false;
            }
          }, Pn = function(r) {
            if (!In(r))
              return false;
            switch (uD(r)) {
              case "AsyncFunction":
              case "GeneratorFunction":
              case "AsyncGeneratorFunction":
                return false;
            }
            try {
              return aD || !!iD(jr, nD(r));
            } catch {
              return true;
            }
          };
          Pn.sham = true;
          kn.exports = !xn || rD(function() {
            var e;
            return ye(ye.call) || !ye(Object) || !ye(function() {
              e = true;
            }) || e;
          }) ? Pn : ye;
        });
        var Un = S((x2, jn) => {
          var $n = Lr(), oD = Ln(), DD = le(), lD = he(), cD = lD("species"), Mn = Array;
          jn.exports = function(e) {
            var r;
            return $n(e) && (r = e.constructor, oD(r) && (r === Mn || $n(r.prototype)) ? r = void 0 : DD(r) && (r = r[cD], r === null && (r = void 0))), r === void 0 ? Mn : r;
          };
        });
        var Vn = S((P2, Gn) => {
          var hD = Un();
          Gn.exports = function(e, r) {
            return new (hD(e))(r === 0 ? 0 : r);
          };
        });
        var Xn = S(() => {
          "use strict";
          var pD = ze(), fD = bn(), dD = Fe(), ED = dr(), CD = _e(), mD = Vn();
          pD({ target: "Array", proto: true }, { flatMap: function(r) {
            var u = ED(this), n = CD(u), D;
            return dD(r), D = mD(u, 0), D.length = fD(D, u, u, n, 0, 1, r, arguments.length > 1 ? arguments[1] : void 0), D;
          } });
        });
        var Ur = S(($2, Hn) => {
          Hn.exports = {};
        });
        var Wn = S((M2, zn) => {
          var gD = he(), FD = Ur(), AD = gD("iterator"), vD = Array.prototype;
          zn.exports = function(e) {
            return e !== void 0 && (FD.Array === e || vD[AD] === e);
          };
        });
        var Gr = S((j2, Qn) => {
          var _D = Mr(), Yn = Le(), SD = Re(), yD = Ur(), TD = he(), BD = TD("iterator");
          Qn.exports = function(e) {
            if (!SD(e))
              return Yn(e, BD) || Yn(e, "@@iterator") || yD[_D(e)];
          };
        });
        var Jn = S((U2, Kn) => {
          var bD = De(), wD = Fe(), ND = de(), OD = ke(), qD = Gr(), ID = TypeError;
          Kn.exports = function(e, r) {
            var u = arguments.length < 2 ? qD(e) : r;
            if (wD(u))
              return ND(bD(u, e));
            throw ID(OD(e) + " is not iterable");
          };
        });
        var rs = S((G2, es) => {
          var RD = De(), Zn = de(), xD = Le();
          es.exports = function(e, r, u) {
            var n, D;
            Zn(e);
            try {
              if (n = xD(e, "return"), !n) {
                if (r === "throw")
                  throw u;
                return u;
              }
              n = RD(n, e);
            } catch (s) {
              D = true, n = s;
            }
            if (r === "throw")
              throw u;
            if (D)
              throw n;
            return Zn(n), u;
          };
        });
        var is = S((V2, ss) => {
          var PD = $r(), kD = De(), LD = de(), $D = ke(), MD = Wn(), jD = _e(), us = ir(), UD = Jn(), GD = Gr(), ts = rs(), VD = TypeError, Ye = function(e, r) {
            this.stopped = e, this.result = r;
          }, ns = Ye.prototype;
          ss.exports = function(e, r, u) {
            var n = u && u.that, D = !!(u && u.AS_ENTRIES), s = !!(u && u.IS_RECORD), i = !!(u && u.IS_ITERATOR), f = !!(u && u.INTERRUPTED), c = PD(r, n), F, a, l, h, C, d, m, T = function(g) {
              return F && ts(F, "normal", g), new Ye(true, g);
            }, w = function(g) {
              return D ? (LD(g), f ? c(g[0], g[1], T) : c(g[0], g[1])) : f ? c(g, T) : c(g);
            };
            if (s)
              F = e.iterator;
            else if (i)
              F = e;
            else {
              if (a = GD(e), !a)
                throw VD($D(e) + " is not iterable");
              if (MD(a)) {
                for (l = 0, h = jD(e); h > l; l++)
                  if (C = w(e[l]), C && us(ns, C))
                    return C;
                return new Ye(false);
              }
              F = UD(e, a);
            }
            for (d = s ? e.next : F.next; !(m = kD(d, F)).done; ) {
              try {
                C = w(m.value);
              } catch (g) {
                ts(F, "throw", g);
              }
              if (typeof C == "object" && C && us(ns, C))
                return C;
            }
            return new Ye(false);
          };
        });
        var os = S((X2, as) => {
          "use strict";
          var XD = je(), HD = Ae(), zD = Ie();
          as.exports = function(e, r, u) {
            var n = XD(r);
            n in e ? HD.f(e, n, zD(0, u)) : e[n] = u;
          };
        });
        var Ds = S(() => {
          var WD = ze(), YD = is(), QD = os();
          WD({ target: "Object", stat: true }, { fromEntries: function(r) {
            var u = {};
            return YD(r, function(n, D) {
              QD(u, n, D);
            }, { AS_ENTRIES: true }), u;
          } });
        });
        var Dc = S((W2, Os) => {
          var KD = ["cliName", "cliCategory", "cliDescription"];
          function JD(e, r) {
            if (e == null)
              return {};
            var u = ZD(e, r), n, D;
            if (Object.getOwnPropertySymbols) {
              var s = Object.getOwnPropertySymbols(e);
              for (D = 0; D < s.length; D++)
                n = s[D], !(r.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (u[n] = e[n]);
            }
            return u;
          }
          function ZD(e, r) {
            if (e == null)
              return {};
            var u = {}, n = Object.keys(e), D, s;
            for (s = 0; s < n.length; s++)
              D = n[s], !(r.indexOf(D) >= 0) && (u[D] = e[D]);
            return u;
          }
          mn();
          Xn();
          Ds();
          var el = Object.create, Je = Object.defineProperty, rl = Object.getOwnPropertyDescriptor, Xr = Object.getOwnPropertyNames, ul = Object.getPrototypeOf, tl = Object.prototype.hasOwnProperty, Ee = (e, r) => function() {
            return e && (r = (0, e[Xr(e)[0]])(e = 0)), r;
          }, I = (e, r) => function() {
            return r || (0, e[Xr(e)[0]])((r = { exports: {} }).exports, r), r.exports;
          }, ps = (e, r) => {
            for (var u in r)
              Je(e, u, { get: r[u], enumerable: true });
          }, fs = (e, r, u, n) => {
            if (r && typeof r == "object" || typeof r == "function")
              for (let D of Xr(r))
                !tl.call(e, D) && D !== u && Je(e, D, { get: () => r[D], enumerable: !(n = rl(r, D)) || n.enumerable });
            return e;
          }, nl = (e, r, u) => (u = e != null ? el(ul(e)) : {}, fs(r || !e || !e.__esModule ? Je(u, "default", { value: e, enumerable: true }) : u, e)), ds = (e) => fs(Je({}, "__esModule", { value: true }), e), Te, q = Ee({ "<define:process>"() {
            Te = { env: {}, argv: [] };
          } }), Es = I({ "node_modules/angular-html-parser/lib/compiler/src/chars.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true }), e.$EOF = 0, e.$BSPACE = 8, e.$TAB = 9, e.$LF = 10, e.$VTAB = 11, e.$FF = 12, e.$CR = 13, e.$SPACE = 32, e.$BANG = 33, e.$DQ = 34, e.$HASH = 35, e.$$ = 36, e.$PERCENT = 37, e.$AMPERSAND = 38, e.$SQ = 39, e.$LPAREN = 40, e.$RPAREN = 41, e.$STAR = 42, e.$PLUS = 43, e.$COMMA = 44, e.$MINUS = 45, e.$PERIOD = 46, e.$SLASH = 47, e.$COLON = 58, e.$SEMICOLON = 59, e.$LT = 60, e.$EQ = 61, e.$GT = 62, e.$QUESTION = 63, e.$0 = 48, e.$7 = 55, e.$9 = 57, e.$A = 65, e.$E = 69, e.$F = 70, e.$X = 88, e.$Z = 90, e.$LBRACKET = 91, e.$BACKSLASH = 92, e.$RBRACKET = 93, e.$CARET = 94, e.$_ = 95, e.$a = 97, e.$b = 98, e.$e = 101, e.$f = 102, e.$n = 110, e.$r = 114, e.$t = 116, e.$u = 117, e.$v = 118, e.$x = 120, e.$z = 122, e.$LBRACE = 123, e.$BAR = 124, e.$RBRACE = 125, e.$NBSP = 160, e.$PIPE = 124, e.$TILDA = 126, e.$AT = 64, e.$BT = 96;
            function r(f) {
              return f >= e.$TAB && f <= e.$SPACE || f == e.$NBSP;
            }
            e.isWhitespace = r;
            function u(f) {
              return e.$0 <= f && f <= e.$9;
            }
            e.isDigit = u;
            function n(f) {
              return f >= e.$a && f <= e.$z || f >= e.$A && f <= e.$Z;
            }
            e.isAsciiLetter = n;
            function D(f) {
              return f >= e.$a && f <= e.$f || f >= e.$A && f <= e.$F || u(f);
            }
            e.isAsciiHexDigit = D;
            function s(f) {
              return f === e.$LF || f === e.$CR;
            }
            e.isNewLine = s;
            function i(f) {
              return e.$0 <= f && f <= e.$7;
            }
            e.isOctalDigit = i;
          } }), sl = I({ "node_modules/angular-html-parser/lib/compiler/src/aot/static_symbol.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = class {
              constructor(n, D, s) {
                this.filePath = n, this.name = D, this.members = s;
              }
              assertNoMembers() {
                if (this.members.length)
                  throw new Error(`Illegal state: symbol without members expected, but got ${JSON.stringify(this)}.`);
              }
            };
            e.StaticSymbol = r;
            var u = class {
              constructor() {
                this.cache = /* @__PURE__ */ new Map();
              }
              get(n, D, s) {
                s = s || [];
                let i = s.length ? `.${s.join(".")}` : "", f = `"${n}".${D}${i}`, c = this.cache.get(f);
                return c || (c = new r(n, D, s), this.cache.set(f, c)), c;
              }
            };
            e.StaticSymbolCache = u;
          } }), il = I({ "node_modules/angular-html-parser/lib/compiler/src/util.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = /-+([a-z0-9])/g;
            function u(o) {
              return o.replace(r, function() {
                for (var E = arguments.length, p = new Array(E), A = 0; A < E; A++)
                  p[A] = arguments[A];
                return p[1].toUpperCase();
              });
            }
            e.dashCaseToCamelCase = u;
            function n(o, E) {
              return s(o, ":", E);
            }
            e.splitAtColon = n;
            function D(o, E) {
              return s(o, ".", E);
            }
            e.splitAtPeriod = D;
            function s(o, E, p) {
              let A = o.indexOf(E);
              return A == -1 ? p : [o.slice(0, A).trim(), o.slice(A + 1).trim()];
            }
            function i(o, E, p) {
              return Array.isArray(o) ? E.visitArray(o, p) : g(o) ? E.visitStringMap(o, p) : o == null || typeof o == "string" || typeof o == "number" || typeof o == "boolean" ? E.visitPrimitive(o, p) : E.visitOther(o, p);
            }
            e.visitValue = i;
            function f(o) {
              return o != null;
            }
            e.isDefined = f;
            function c(o) {
              return o === void 0 ? null : o;
            }
            e.noUndefined = c;
            var F = class {
              visitArray(o, E) {
                return o.map((p) => i(p, this, E));
              }
              visitStringMap(o, E) {
                let p = {};
                return Object.keys(o).forEach((A) => {
                  p[A] = i(o[A], this, E);
                }), p;
              }
              visitPrimitive(o, E) {
                return o;
              }
              visitOther(o, E) {
                return o;
              }
            };
            e.ValueTransformer = F, e.SyncAsync = { assertSync: (o) => {
              if (_(o))
                throw new Error("Illegal state: value cannot be a promise");
              return o;
            }, then: (o, E) => _(o) ? o.then(E) : E(o), all: (o) => o.some(_) ? Promise.all(o) : o };
            function a(o) {
              throw new Error(`Internal Error: ${o}`);
            }
            e.error = a;
            function l(o, E) {
              let p = Error(o);
              return p[h] = true, E && (p[C] = E), p;
            }
            e.syntaxError = l;
            var h = "ngSyntaxError", C = "ngParseErrors";
            function d(o) {
              return o[h];
            }
            e.isSyntaxError = d;
            function m(o) {
              return o[C] || [];
            }
            e.getParseErrors = m;
            function T(o) {
              return o.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
            }
            e.escapeRegExp = T;
            var w = Object.getPrototypeOf({});
            function g(o) {
              return typeof o == "object" && o !== null && Object.getPrototypeOf(o) === w;
            }
            function N(o) {
              let E = "";
              for (let p = 0; p < o.length; p++) {
                let A = o.charCodeAt(p);
                if (A >= 55296 && A <= 56319 && o.length > p + 1) {
                  let P = o.charCodeAt(p + 1);
                  P >= 56320 && P <= 57343 && (p++, A = (A - 55296 << 10) + P - 56320 + 65536);
                }
                A <= 127 ? E += String.fromCharCode(A) : A <= 2047 ? E += String.fromCharCode(A >> 6 & 31 | 192, A & 63 | 128) : A <= 65535 ? E += String.fromCharCode(A >> 12 | 224, A >> 6 & 63 | 128, A & 63 | 128) : A <= 2097151 && (E += String.fromCharCode(A >> 18 & 7 | 240, A >> 12 & 63 | 128, A >> 6 & 63 | 128, A & 63 | 128));
              }
              return E;
            }
            e.utf8Encode = N;
            function R(o) {
              if (typeof o == "string")
                return o;
              if (o instanceof Array)
                return "[" + o.map(R).join(", ") + "]";
              if (o == null)
                return "" + o;
              if (o.overriddenName)
                return `${o.overriddenName}`;
              if (o.name)
                return `${o.name}`;
              if (!o.toString)
                return "object";
              let E = o.toString();
              if (E == null)
                return "" + E;
              let p = E.indexOf(`
`);
              return p === -1 ? E : E.substring(0, p);
            }
            e.stringify = R;
            function j(o) {
              return typeof o == "function" && o.hasOwnProperty("__forward_ref__") ? o() : o;
            }
            e.resolveForwardRef = j;
            function _(o) {
              return !!o && typeof o.then == "function";
            }
            e.isPromise = _;
            var O = class {
              constructor(o) {
                this.full = o;
                let E = o.split(".");
                this.major = E[0], this.minor = E[1], this.patch = E.slice(2).join(".");
              }
            };
            e.Version = O;
            var x = typeof window < "u" && window, k = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, $ = typeof globalThis < "u" && globalThis, t3 = $ || x || k;
            e.global = t3;
          } }), al = I({ "node_modules/angular-html-parser/lib/compiler/src/compile_metadata.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = sl(), u = il(), n = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
            function D(p) {
              return p.replace(/\W/g, "_");
            }
            e.sanitizeIdentifier = D;
            var s = 0;
            function i(p) {
              if (!p || !p.reference)
                return null;
              let A = p.reference;
              if (A instanceof r.StaticSymbol)
                return A.name;
              if (A.__anonymousType)
                return A.__anonymousType;
              let P = u.stringify(A);
              return P.indexOf("(") >= 0 ? (P = `anonymous_${s++}`, A.__anonymousType = P) : P = D(P), P;
            }
            e.identifierName = i;
            function f(p) {
              let A = p.reference;
              return A instanceof r.StaticSymbol ? A.filePath : `./${u.stringify(A)}`;
            }
            e.identifierModuleUrl = f;
            function c(p, A) {
              return `View_${i({ reference: p })}_${A}`;
            }
            e.viewClassName = c;
            function F(p) {
              return `RenderType_${i({ reference: p })}`;
            }
            e.rendererTypeName = F;
            function a(p) {
              return `HostView_${i({ reference: p })}`;
            }
            e.hostViewClassName = a;
            function l(p) {
              return `${i({ reference: p })}NgFactory`;
            }
            e.componentFactoryName = l;
            var h;
            (function(p) {
              p[p.Pipe = 0] = "Pipe", p[p.Directive = 1] = "Directive", p[p.NgModule = 2] = "NgModule", p[p.Injectable = 3] = "Injectable";
            })(h = e.CompileSummaryKind || (e.CompileSummaryKind = {}));
            function C(p) {
              return p.value != null ? D(p.value) : i(p.identifier);
            }
            e.tokenName = C;
            function d(p) {
              return p.identifier != null ? p.identifier.reference : p.value;
            }
            e.tokenReference = d;
            var m = class {
              constructor() {
                let { moduleUrl: p, styles: A, styleUrls: P } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.moduleUrl = p || null, this.styles = _(A), this.styleUrls = _(P);
              }
            };
            e.CompileStylesheetMetadata = m;
            var T = class {
              constructor(p) {
                let { encapsulation: A, template: P, templateUrl: M, htmlAst: z, styles: V, styleUrls: X, externalStylesheets: H, animations: Q, ngContentSelectors: K, interpolation: J, isInline: v, preserveWhitespaces: y } = p;
                if (this.encapsulation = A, this.template = P, this.templateUrl = M, this.htmlAst = z, this.styles = _(V), this.styleUrls = _(X), this.externalStylesheets = _(H), this.animations = Q ? x(Q) : [], this.ngContentSelectors = K || [], J && J.length != 2)
                  throw new Error("'interpolation' should have a start and an end symbol.");
                this.interpolation = J, this.isInline = v, this.preserveWhitespaces = y;
              }
              toSummary() {
                return { ngContentSelectors: this.ngContentSelectors, encapsulation: this.encapsulation, styles: this.styles, animations: this.animations };
              }
            };
            e.CompileTemplateMetadata = T;
            var w = class {
              static create(p) {
                let { isHost: A, type: P, isComponent: M, selector: z, exportAs: V, changeDetection: X, inputs: H, outputs: Q, host: K, providers: J, viewProviders: v, queries: y, guards: B, viewQueries: b, entryComponents: L, template: U, componentViewType: G, rendererType: W, componentFactory: ne } = p, be = {}, we = {}, Wr = {};
                K != null && Object.keys(K).forEach((Z) => {
                  let ie = K[Z], Ce = Z.match(n);
                  Ce === null ? Wr[Z] = ie : Ce[1] != null ? we[Ce[1]] = ie : Ce[2] != null && (be[Ce[2]] = ie);
                });
                let Yr = {};
                H != null && H.forEach((Z) => {
                  let ie = u.splitAtColon(Z, [Z, Z]);
                  Yr[ie[0]] = ie[1];
                });
                let Qr = {};
                return Q != null && Q.forEach((Z) => {
                  let ie = u.splitAtColon(Z, [Z, Z]);
                  Qr[ie[0]] = ie[1];
                }), new w({ isHost: A, type: P, isComponent: !!M, selector: z, exportAs: V, changeDetection: X, inputs: Yr, outputs: Qr, hostListeners: be, hostProperties: we, hostAttributes: Wr, providers: J, viewProviders: v, queries: y, guards: B, viewQueries: b, entryComponents: L, template: U, componentViewType: G, rendererType: W, componentFactory: ne });
              }
              constructor(p) {
                let { isHost: A, type: P, isComponent: M, selector: z, exportAs: V, changeDetection: X, inputs: H, outputs: Q, hostListeners: K, hostProperties: J, hostAttributes: v, providers: y, viewProviders: B, queries: b, guards: L, viewQueries: U, entryComponents: G, template: W, componentViewType: ne, rendererType: be, componentFactory: we } = p;
                this.isHost = !!A, this.type = P, this.isComponent = M, this.selector = z, this.exportAs = V, this.changeDetection = X, this.inputs = H, this.outputs = Q, this.hostListeners = K, this.hostProperties = J, this.hostAttributes = v, this.providers = _(y), this.viewProviders = _(B), this.queries = _(b), this.guards = L, this.viewQueries = _(U), this.entryComponents = _(G), this.template = W, this.componentViewType = ne, this.rendererType = be, this.componentFactory = we;
              }
              toSummary() {
                return { summaryKind: h.Directive, type: this.type, isComponent: this.isComponent, selector: this.selector, exportAs: this.exportAs, inputs: this.inputs, outputs: this.outputs, hostListeners: this.hostListeners, hostProperties: this.hostProperties, hostAttributes: this.hostAttributes, providers: this.providers, viewProviders: this.viewProviders, queries: this.queries, guards: this.guards, viewQueries: this.viewQueries, entryComponents: this.entryComponents, changeDetection: this.changeDetection, template: this.template && this.template.toSummary(), componentViewType: this.componentViewType, rendererType: this.rendererType, componentFactory: this.componentFactory };
              }
            };
            e.CompileDirectiveMetadata = w;
            var g = class {
              constructor(p) {
                let { type: A, name: P, pure: M } = p;
                this.type = A, this.name = P, this.pure = !!M;
              }
              toSummary() {
                return { summaryKind: h.Pipe, type: this.type, name: this.name, pure: this.pure };
              }
            };
            e.CompilePipeMetadata = g;
            var N = class {
            };
            e.CompileShallowModuleMetadata = N;
            var R = class {
              constructor(p) {
                let { type: A, providers: P, declaredDirectives: M, exportedDirectives: z, declaredPipes: V, exportedPipes: X, entryComponents: H, bootstrapComponents: Q, importedModules: K, exportedModules: J, schemas: v, transitiveModule: y, id: B } = p;
                this.type = A || null, this.declaredDirectives = _(M), this.exportedDirectives = _(z), this.declaredPipes = _(V), this.exportedPipes = _(X), this.providers = _(P), this.entryComponents = _(H), this.bootstrapComponents = _(Q), this.importedModules = _(K), this.exportedModules = _(J), this.schemas = _(v), this.id = B || null, this.transitiveModule = y || null;
              }
              toSummary() {
                let p = this.transitiveModule;
                return { summaryKind: h.NgModule, type: this.type, entryComponents: p.entryComponents, providers: p.providers, modules: p.modules, exportedDirectives: p.exportedDirectives, exportedPipes: p.exportedPipes };
              }
            };
            e.CompileNgModuleMetadata = R;
            var j = class {
              constructor() {
                this.directivesSet = /* @__PURE__ */ new Set(), this.directives = [], this.exportedDirectivesSet = /* @__PURE__ */ new Set(), this.exportedDirectives = [], this.pipesSet = /* @__PURE__ */ new Set(), this.pipes = [], this.exportedPipesSet = /* @__PURE__ */ new Set(), this.exportedPipes = [], this.modulesSet = /* @__PURE__ */ new Set(), this.modules = [], this.entryComponentsSet = /* @__PURE__ */ new Set(), this.entryComponents = [], this.providers = [];
              }
              addProvider(p, A) {
                this.providers.push({ provider: p, module: A });
              }
              addDirective(p) {
                this.directivesSet.has(p.reference) || (this.directivesSet.add(p.reference), this.directives.push(p));
              }
              addExportedDirective(p) {
                this.exportedDirectivesSet.has(p.reference) || (this.exportedDirectivesSet.add(p.reference), this.exportedDirectives.push(p));
              }
              addPipe(p) {
                this.pipesSet.has(p.reference) || (this.pipesSet.add(p.reference), this.pipes.push(p));
              }
              addExportedPipe(p) {
                this.exportedPipesSet.has(p.reference) || (this.exportedPipesSet.add(p.reference), this.exportedPipes.push(p));
              }
              addModule(p) {
                this.modulesSet.has(p.reference) || (this.modulesSet.add(p.reference), this.modules.push(p));
              }
              addEntryComponent(p) {
                this.entryComponentsSet.has(p.componentType) || (this.entryComponentsSet.add(p.componentType), this.entryComponents.push(p));
              }
            };
            e.TransitiveCompileNgModuleMetadata = j;
            function _(p) {
              return p || [];
            }
            var O = class {
              constructor(p, A) {
                let { useClass: P, useValue: M, useExisting: z, useFactory: V, deps: X, multi: H } = A;
                this.token = p, this.useClass = P || null, this.useValue = M, this.useExisting = z, this.useFactory = V || null, this.dependencies = X || null, this.multi = !!H;
              }
            };
            e.ProviderMeta = O;
            function x(p) {
              return p.reduce((A, P) => {
                let M = Array.isArray(P) ? x(P) : P;
                return A.concat(M);
              }, []);
            }
            e.flatten = x;
            function k(p) {
              return p.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, "ng:///");
            }
            function $(p, A, P) {
              let M;
              return P.isInline ? A.type.reference instanceof r.StaticSymbol ? M = `${A.type.reference.filePath}.${A.type.reference.name}.html` : M = `${i(p)}/${i(A.type)}.html` : M = P.templateUrl, A.type.reference instanceof r.StaticSymbol ? M : k(M);
            }
            e.templateSourceUrl = $;
            function t3(p, A) {
              let P = p.moduleUrl.split(/\/\\/g), M = P[P.length - 1];
              return k(`css/${A}${M}.ngstyle.js`);
            }
            e.sharedStylesheetJitUrl = t3;
            function o(p) {
              return k(`${i(p.type)}/module.ngfactory.js`);
            }
            e.ngModuleJitUrl = o;
            function E(p, A) {
              return k(`${i(p)}/${i(A.type)}.ngfactory.js`);
            }
            e.templateJitUrl = E;
          } }), Be = I({ "node_modules/angular-html-parser/lib/compiler/src/parse_util.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Es(), u = al(), n = class {
              constructor(a, l, h, C) {
                this.file = a, this.offset = l, this.line = h, this.col = C;
              }
              toString() {
                return this.offset != null ? `${this.file.url}@${this.line}:${this.col}` : this.file.url;
              }
              moveBy(a) {
                let l = this.file.content, h = l.length, C = this.offset, d = this.line, m = this.col;
                for (; C > 0 && a < 0; )
                  if (C--, a++, l.charCodeAt(C) == r.$LF) {
                    d--;
                    let w = l.substr(0, C - 1).lastIndexOf(String.fromCharCode(r.$LF));
                    m = w > 0 ? C - w : C;
                  } else
                    m--;
                for (; C < h && a > 0; ) {
                  let T = l.charCodeAt(C);
                  C++, a--, T == r.$LF ? (d++, m = 0) : m++;
                }
                return new n(this.file, C, d, m);
              }
              getContext(a, l) {
                let h = this.file.content, C = this.offset;
                if (C != null) {
                  C > h.length - 1 && (C = h.length - 1);
                  let d = C, m = 0, T = 0;
                  for (; m < a && C > 0 && (C--, m++, !(h[C] == `
` && ++T == l)); )
                    ;
                  for (m = 0, T = 0; m < a && d < h.length - 1 && (d++, m++, !(h[d] == `
` && ++T == l)); )
                    ;
                  return { before: h.substring(C, this.offset), after: h.substring(this.offset, d + 1) };
                }
                return null;
              }
            };
            e.ParseLocation = n;
            var D = class {
              constructor(a, l) {
                this.content = a, this.url = l;
              }
            };
            e.ParseSourceFile = D;
            var s = class {
              constructor(a, l) {
                let h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                this.start = a, this.end = l, this.details = h;
              }
              toString() {
                return this.start.file.content.substring(this.start.offset, this.end.offset);
              }
            };
            e.ParseSourceSpan = s, e.EMPTY_PARSE_LOCATION = new n(new D("", ""), 0, 0, 0), e.EMPTY_SOURCE_SPAN = new s(e.EMPTY_PARSE_LOCATION, e.EMPTY_PARSE_LOCATION);
            var i;
            (function(a) {
              a[a.WARNING = 0] = "WARNING", a[a.ERROR = 1] = "ERROR";
            })(i = e.ParseErrorLevel || (e.ParseErrorLevel = {}));
            var f = class {
              constructor(a, l) {
                let h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : i.ERROR;
                this.span = a, this.msg = l, this.level = h;
              }
              contextualMessage() {
                let a = this.span.start.getContext(100, 3);
                return a ? `${this.msg} ("${a.before}[${i[this.level]} ->]${a.after}")` : this.msg;
              }
              toString() {
                let a = this.span.details ? `, ${this.span.details}` : "";
                return `${this.contextualMessage()}: ${this.span.start}${a}`;
              }
            };
            e.ParseError = f;
            function c(a, l) {
              let h = u.identifierModuleUrl(l), C = h != null ? `in ${a} ${u.identifierName(l)} in ${h}` : `in ${a} ${u.identifierName(l)}`, d = new D("", C);
              return new s(new n(d, -1, -1, -1), new n(d, -1, -1, -1));
            }
            e.typeSourceSpan = c;
            function F(a, l, h) {
              let C = `in ${a} ${l} in ${h}`, d = new D("", C);
              return new s(new n(d, -1, -1, -1), new n(d, -1, -1, -1));
            }
            e.r3JitTypeSourceSpan = F;
          } }), ol = I({ "src/utils/front-matter/parse.js"(e, r) {
            "use strict";
            q();
            var u = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
            function n(D) {
              let s = D.match(u);
              if (!s)
                return { content: D };
              let { startDelimiter: i, language: f, value: c = "", endDelimiter: F } = s.groups, a = f.trim() || "yaml";
              if (i === "+++" && (a = "toml"), a !== "yaml" && i !== F)
                return { content: D };
              let [l] = s;
              return { frontMatter: { type: "front-matter", lang: a, value: c, startDelimiter: i, endDelimiter: F, raw: l.replace(/\n$/, "") }, content: l.replace(/[^\n]/g, " ") + D.slice(l.length) };
            }
            r.exports = n;
          } }), Cs = I({ "src/utils/get-last.js"(e, r) {
            "use strict";
            q();
            var u = (n) => n[n.length - 1];
            r.exports = u;
          } }), Dl = I({ "src/common/parser-create-error.js"(e, r) {
            "use strict";
            q();
            function u(n, D) {
              let s = new SyntaxError(n + " (" + D.start.line + ":" + D.start.column + ")");
              return s.loc = D, s;
            }
            r.exports = u;
          } }), ms = {};
          ps(ms, { default: () => ll });
          function ll(e) {
            if (typeof e != "string")
              throw new TypeError("Expected a string");
            return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
          }
          var cl = Ee({ "node_modules/escape-string-regexp/index.js"() {
            q();
          } }), gs = I({ "node_modules/semver/internal/debug.js"(e, r) {
            q();
            var u = typeof Te == "object" && Te.env && Te.env.NODE_DEBUG && /\bsemver\b/i.test(Te.env.NODE_DEBUG) ? function() {
              for (var n = arguments.length, D = new Array(n), s = 0; s < n; s++)
                D[s] = arguments[s];
              return console.error("SEMVER", ...D);
            } : () => {
            };
            r.exports = u;
          } }), Fs = I({ "node_modules/semver/internal/constants.js"(e, r) {
            q();
            var u = "2.0.0", n = 256, D = Number.MAX_SAFE_INTEGER || 9007199254740991, s = 16;
            r.exports = { SEMVER_SPEC_VERSION: u, MAX_LENGTH: n, MAX_SAFE_INTEGER: D, MAX_SAFE_COMPONENT_LENGTH: s };
          } }), hl = I({ "node_modules/semver/internal/re.js"(e, r) {
            q();
            var { MAX_SAFE_COMPONENT_LENGTH: u } = Fs(), n = gs();
            e = r.exports = {};
            var D = e.re = [], s = e.src = [], i = e.t = {}, f = 0, c = (F, a, l) => {
              let h = f++;
              n(F, h, a), i[F] = h, s[h] = a, D[h] = new RegExp(a, l ? "g" : void 0);
            };
            c("NUMERICIDENTIFIER", "0|[1-9]\\d*"), c("NUMERICIDENTIFIERLOOSE", "[0-9]+"), c("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), c("MAINVERSION", `(${s[i.NUMERICIDENTIFIER]})\\.(${s[i.NUMERICIDENTIFIER]})\\.(${s[i.NUMERICIDENTIFIER]})`), c("MAINVERSIONLOOSE", `(${s[i.NUMERICIDENTIFIERLOOSE]})\\.(${s[i.NUMERICIDENTIFIERLOOSE]})\\.(${s[i.NUMERICIDENTIFIERLOOSE]})`), c("PRERELEASEIDENTIFIER", `(?:${s[i.NUMERICIDENTIFIER]}|${s[i.NONNUMERICIDENTIFIER]})`), c("PRERELEASEIDENTIFIERLOOSE", `(?:${s[i.NUMERICIDENTIFIERLOOSE]}|${s[i.NONNUMERICIDENTIFIER]})`), c("PRERELEASE", `(?:-(${s[i.PRERELEASEIDENTIFIER]}(?:\\.${s[i.PRERELEASEIDENTIFIER]})*))`), c("PRERELEASELOOSE", `(?:-?(${s[i.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${s[i.PRERELEASEIDENTIFIERLOOSE]})*))`), c("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), c("BUILD", `(?:\\+(${s[i.BUILDIDENTIFIER]}(?:\\.${s[i.BUILDIDENTIFIER]})*))`), c("FULLPLAIN", `v?${s[i.MAINVERSION]}${s[i.PRERELEASE]}?${s[i.BUILD]}?`), c("FULL", `^${s[i.FULLPLAIN]}$`), c("LOOSEPLAIN", `[v=\\s]*${s[i.MAINVERSIONLOOSE]}${s[i.PRERELEASELOOSE]}?${s[i.BUILD]}?`), c("LOOSE", `^${s[i.LOOSEPLAIN]}$`), c("GTLT", "((?:<|>)?=?)"), c("XRANGEIDENTIFIERLOOSE", `${s[i.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), c("XRANGEIDENTIFIER", `${s[i.NUMERICIDENTIFIER]}|x|X|\\*`), c("XRANGEPLAIN", `[v=\\s]*(${s[i.XRANGEIDENTIFIER]})(?:\\.(${s[i.XRANGEIDENTIFIER]})(?:\\.(${s[i.XRANGEIDENTIFIER]})(?:${s[i.PRERELEASE]})?${s[i.BUILD]}?)?)?`), c("XRANGEPLAINLOOSE", `[v=\\s]*(${s[i.XRANGEIDENTIFIERLOOSE]})(?:\\.(${s[i.XRANGEIDENTIFIERLOOSE]})(?:\\.(${s[i.XRANGEIDENTIFIERLOOSE]})(?:${s[i.PRERELEASELOOSE]})?${s[i.BUILD]}?)?)?`), c("XRANGE", `^${s[i.GTLT]}\\s*${s[i.XRANGEPLAIN]}$`), c("XRANGELOOSE", `^${s[i.GTLT]}\\s*${s[i.XRANGEPLAINLOOSE]}$`), c("COERCE", `(^|[^\\d])(\\d{1,${u}})(?:\\.(\\d{1,${u}}))?(?:\\.(\\d{1,${u}}))?(?:$|[^\\d])`), c("COERCERTL", s[i.COERCE], true), c("LONETILDE", "(?:~>?)"), c("TILDETRIM", `(\\s*)${s[i.LONETILDE]}\\s+`, true), e.tildeTrimReplace = "$1~", c("TILDE", `^${s[i.LONETILDE]}${s[i.XRANGEPLAIN]}$`), c("TILDELOOSE", `^${s[i.LONETILDE]}${s[i.XRANGEPLAINLOOSE]}$`), c("LONECARET", "(?:\\^)"), c("CARETTRIM", `(\\s*)${s[i.LONECARET]}\\s+`, true), e.caretTrimReplace = "$1^", c("CARET", `^${s[i.LONECARET]}${s[i.XRANGEPLAIN]}$`), c("CARETLOOSE", `^${s[i.LONECARET]}${s[i.XRANGEPLAINLOOSE]}$`), c("COMPARATORLOOSE", `^${s[i.GTLT]}\\s*(${s[i.LOOSEPLAIN]})$|^$`), c("COMPARATOR", `^${s[i.GTLT]}\\s*(${s[i.FULLPLAIN]})$|^$`), c("COMPARATORTRIM", `(\\s*)${s[i.GTLT]}\\s*(${s[i.LOOSEPLAIN]}|${s[i.XRANGEPLAIN]})`, true), e.comparatorTrimReplace = "$1$2$3", c("HYPHENRANGE", `^\\s*(${s[i.XRANGEPLAIN]})\\s+-\\s+(${s[i.XRANGEPLAIN]})\\s*$`), c("HYPHENRANGELOOSE", `^\\s*(${s[i.XRANGEPLAINLOOSE]})\\s+-\\s+(${s[i.XRANGEPLAINLOOSE]})\\s*$`), c("STAR", "(<|>)?=?\\s*\\*"), c("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), c("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
          } }), pl = I({ "node_modules/semver/internal/parse-options.js"(e, r) {
            q();
            var u = ["includePrerelease", "loose", "rtl"], n = (D) => D ? typeof D != "object" ? { loose: true } : u.filter((s) => D[s]).reduce((s, i) => (s[i] = true, s), {}) : {};
            r.exports = n;
          } }), fl = I({ "node_modules/semver/internal/identifiers.js"(e, r) {
            q();
            var u = /^[0-9]+$/, n = (s, i) => {
              let f = u.test(s), c = u.test(i);
              return f && c && (s = +s, i = +i), s === i ? 0 : f && !c ? -1 : c && !f ? 1 : s < i ? -1 : 1;
            }, D = (s, i) => n(i, s);
            r.exports = { compareIdentifiers: n, rcompareIdentifiers: D };
          } }), dl = I({ "node_modules/semver/classes/semver.js"(e, r) {
            q();
            var u = gs(), { MAX_LENGTH: n, MAX_SAFE_INTEGER: D } = Fs(), { re: s, t: i } = hl(), f = pl(), { compareIdentifiers: c } = fl(), F = class {
              constructor(a, l) {
                if (l = f(l), a instanceof F) {
                  if (a.loose === !!l.loose && a.includePrerelease === !!l.includePrerelease)
                    return a;
                  a = a.version;
                } else if (typeof a != "string")
                  throw new TypeError(`Invalid Version: ${a}`);
                if (a.length > n)
                  throw new TypeError(`version is longer than ${n} characters`);
                u("SemVer", a, l), this.options = l, this.loose = !!l.loose, this.includePrerelease = !!l.includePrerelease;
                let h = a.trim().match(l.loose ? s[i.LOOSE] : s[i.FULL]);
                if (!h)
                  throw new TypeError(`Invalid Version: ${a}`);
                if (this.raw = a, this.major = +h[1], this.minor = +h[2], this.patch = +h[3], this.major > D || this.major < 0)
                  throw new TypeError("Invalid major version");
                if (this.minor > D || this.minor < 0)
                  throw new TypeError("Invalid minor version");
                if (this.patch > D || this.patch < 0)
                  throw new TypeError("Invalid patch version");
                h[4] ? this.prerelease = h[4].split(".").map((C) => {
                  if (/^[0-9]+$/.test(C)) {
                    let d = +C;
                    if (d >= 0 && d < D)
                      return d;
                  }
                  return C;
                }) : this.prerelease = [], this.build = h[5] ? h[5].split(".") : [], this.format();
              }
              format() {
                return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
              }
              toString() {
                return this.version;
              }
              compare(a) {
                if (u("SemVer.compare", this.version, this.options, a), !(a instanceof F)) {
                  if (typeof a == "string" && a === this.version)
                    return 0;
                  a = new F(a, this.options);
                }
                return a.version === this.version ? 0 : this.compareMain(a) || this.comparePre(a);
              }
              compareMain(a) {
                return a instanceof F || (a = new F(a, this.options)), c(this.major, a.major) || c(this.minor, a.minor) || c(this.patch, a.patch);
              }
              comparePre(a) {
                if (a instanceof F || (a = new F(a, this.options)), this.prerelease.length && !a.prerelease.length)
                  return -1;
                if (!this.prerelease.length && a.prerelease.length)
                  return 1;
                if (!this.prerelease.length && !a.prerelease.length)
                  return 0;
                let l = 0;
                do {
                  let h = this.prerelease[l], C = a.prerelease[l];
                  if (u("prerelease compare", l, h, C), h === void 0 && C === void 0)
                    return 0;
                  if (C === void 0)
                    return 1;
                  if (h === void 0)
                    return -1;
                  if (h === C)
                    continue;
                  return c(h, C);
                } while (++l);
              }
              compareBuild(a) {
                a instanceof F || (a = new F(a, this.options));
                let l = 0;
                do {
                  let h = this.build[l], C = a.build[l];
                  if (u("prerelease compare", l, h, C), h === void 0 && C === void 0)
                    return 0;
                  if (C === void 0)
                    return 1;
                  if (h === void 0)
                    return -1;
                  if (h === C)
                    continue;
                  return c(h, C);
                } while (++l);
              }
              inc(a, l) {
                switch (a) {
                  case "premajor":
                    this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", l);
                    break;
                  case "preminor":
                    this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", l);
                    break;
                  case "prepatch":
                    this.prerelease.length = 0, this.inc("patch", l), this.inc("pre", l);
                    break;
                  case "prerelease":
                    this.prerelease.length === 0 && this.inc("patch", l), this.inc("pre", l);
                    break;
                  case "major":
                    (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                    break;
                  case "minor":
                    (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
                    break;
                  case "patch":
                    this.prerelease.length === 0 && this.patch++, this.prerelease = [];
                    break;
                  case "pre":
                    if (this.prerelease.length === 0)
                      this.prerelease = [0];
                    else {
                      let h = this.prerelease.length;
                      for (; --h >= 0; )
                        typeof this.prerelease[h] == "number" && (this.prerelease[h]++, h = -2);
                      h === -1 && this.prerelease.push(0);
                    }
                    l && (c(this.prerelease[0], l) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [l, 0]) : this.prerelease = [l, 0]);
                    break;
                  default:
                    throw new Error(`invalid increment argument: ${a}`);
                }
                return this.format(), this.raw = this.version, this;
              }
            };
            r.exports = F;
          } }), Hr = I({ "node_modules/semver/functions/compare.js"(e, r) {
            q();
            var u = dl(), n = (D, s, i) => new u(D, i).compare(new u(s, i));
            r.exports = n;
          } }), El = I({ "node_modules/semver/functions/lt.js"(e, r) {
            q();
            var u = Hr(), n = (D, s, i) => u(D, s, i) < 0;
            r.exports = n;
          } }), Cl = I({ "node_modules/semver/functions/gte.js"(e, r) {
            q();
            var u = Hr(), n = (D, s, i) => u(D, s, i) >= 0;
            r.exports = n;
          } }), ml = I({ "src/utils/arrayify.js"(e, r) {
            "use strict";
            q(), r.exports = (u, n) => Object.entries(u).map((D) => {
              let [s, i] = D;
              return Object.assign({ [n]: s }, i);
            });
          } }), gl = I({ "package.json"(e, r) {
            r.exports = { version: "2.8.8" };
          } }), Fl = I({ "node_modules/outdent/lib/index.js"(e, r) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true }), e.outdent = void 0;
            function u() {
              for (var g = [], N = 0; N < arguments.length; N++)
                g[N] = arguments[N];
            }
            function n() {
              return typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : D();
            }
            function D() {
              return { add: u, delete: u, get: u, set: u, has: function(g) {
                return false;
              } };
            }
            var s = Object.prototype.hasOwnProperty, i = function(g, N) {
              return s.call(g, N);
            };
            function f(g, N) {
              for (var R in N)
                i(N, R) && (g[R] = N[R]);
              return g;
            }
            var c = /^[ \t]*(?:\r\n|\r|\n)/, F = /(?:\r\n|\r|\n)[ \t]*$/, a = /^(?:[\r\n]|$)/, l = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/, h = /^[ \t]*[\r\n][ \t\r\n]*$/;
            function C(g, N, R) {
              var j = 0, _ = g[0].match(l);
              _ && (j = _[1].length);
              var O = "(\\r\\n|\\r|\\n).{0," + j + "}", x = new RegExp(O, "g");
              N && (g = g.slice(1));
              var k = R.newline, $ = R.trimLeadingNewline, t3 = R.trimTrailingNewline, o = typeof k == "string", E = g.length, p = g.map(function(A, P) {
                return A = A.replace(x, "$1"), P === 0 && $ && (A = A.replace(c, "")), P === E - 1 && t3 && (A = A.replace(F, "")), o && (A = A.replace(/\r\n|\n|\r/g, function(M) {
                  return k;
                })), A;
              });
              return p;
            }
            function d(g, N) {
              for (var R = "", j = 0, _ = g.length; j < _; j++)
                R += g[j], j < _ - 1 && (R += N[j]);
              return R;
            }
            function m(g) {
              return i(g, "raw") && i(g, "length");
            }
            function T(g) {
              var N = n(), R = n();
              function j(O) {
                for (var x = [], k = 1; k < arguments.length; k++)
                  x[k - 1] = arguments[k];
                if (m(O)) {
                  var $ = O, t3 = (x[0] === j || x[0] === w) && h.test($[0]) && a.test($[1]), o = t3 ? R : N, E = o.get($);
                  if (E || (E = C($, t3, g), o.set($, E)), x.length === 0)
                    return E[0];
                  var p = d(E, t3 ? x.slice(1) : x);
                  return p;
                } else
                  return T(f(f({}, g), O || {}));
              }
              var _ = f(j, { string: function(O) {
                return C([O], false, g)[0];
              } });
              return _;
            }
            var w = T({ trimLeadingNewline: true, trimTrailingNewline: true });
            if (e.outdent = w, e.default = w, typeof r < "u")
              try {
                r.exports = w, Object.defineProperty(w, "__esModule", { value: true }), w.default = w, w.outdent = w;
              } catch {
              }
          } }), Al = I({ "src/main/core-options.js"(e, r) {
            "use strict";
            q();
            var { outdent: u } = Fl(), n = "Config", D = "Editor", s = "Format", i = "Other", f = "Output", c = "Global", F = "Special", a = { cursorOffset: { since: "1.4.0", category: F, type: "int", default: -1, range: { start: -1, end: Number.POSITIVE_INFINITY, step: 1 }, description: u`
      Print (to stderr) where a cursor at the given position would move to after formatting.
      This option cannot be used with --range-start and --range-end.
    `, cliCategory: D }, endOfLine: { since: "1.15.0", category: c, type: "choice", default: [{ since: "1.15.0", value: "auto" }, { since: "2.0.0", value: "lf" }], description: "Which end of line characters to apply.", choices: [{ value: "lf", description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos" }, { value: "crlf", description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows" }, { value: "cr", description: "Carriage Return character only (\\r), used very rarely" }, { value: "auto", description: u`
          Maintain existing
          (mixed values within one file are normalised by looking at what's used after the first line)
        ` }] }, filepath: { since: "1.4.0", category: F, type: "path", description: "Specify the input filepath. This will be used to do parser inference.", cliName: "stdin-filepath", cliCategory: i, cliDescription: "Path to the file to pretend that stdin comes from." }, insertPragma: { since: "1.8.0", category: F, type: "boolean", default: false, description: "Insert @format pragma into file's first docblock comment.", cliCategory: i }, parser: { since: "0.0.10", category: c, type: "choice", default: [{ since: "0.0.10", value: "babylon" }, { since: "1.13.0", value: void 0 }], description: "Which parser to use.", exception: (l) => typeof l == "string" || typeof l == "function", choices: [{ value: "flow", description: "Flow" }, { value: "babel", since: "1.16.0", description: "JavaScript" }, { value: "babel-flow", since: "1.16.0", description: "Flow" }, { value: "babel-ts", since: "2.0.0", description: "TypeScript" }, { value: "typescript", since: "1.4.0", description: "TypeScript" }, { value: "acorn", since: "2.6.0", description: "JavaScript" }, { value: "espree", since: "2.2.0", description: "JavaScript" }, { value: "meriyah", since: "2.2.0", description: "JavaScript" }, { value: "css", since: "1.7.1", description: "CSS" }, { value: "less", since: "1.7.1", description: "Less" }, { value: "scss", since: "1.7.1", description: "SCSS" }, { value: "json", since: "1.5.0", description: "JSON" }, { value: "json5", since: "1.13.0", description: "JSON5" }, { value: "json-stringify", since: "1.13.0", description: "JSON.stringify" }, { value: "graphql", since: "1.5.0", description: "GraphQL" }, { value: "markdown", since: "1.8.0", description: "Markdown" }, { value: "mdx", since: "1.15.0", description: "MDX" }, { value: "vue", since: "1.10.0", description: "Vue" }, { value: "yaml", since: "1.14.0", description: "YAML" }, { value: "glimmer", since: "2.3.0", description: "Ember / Handlebars" }, { value: "html", since: "1.15.0", description: "HTML" }, { value: "angular", since: "1.15.0", description: "Angular" }, { value: "lwc", since: "1.17.0", description: "Lightning Web Components" }] }, plugins: { since: "1.10.0", type: "path", array: true, default: [{ value: [] }], category: c, description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.", exception: (l) => typeof l == "string" || typeof l == "object", cliName: "plugin", cliCategory: n }, pluginSearchDirs: { since: "1.13.0", type: "path", array: true, default: [{ value: [] }], category: c, description: u`
      Custom directory that contains prettier plugins in node_modules subdirectory.
      Overrides default behavior when plugins are searched relatively to the location of Prettier.
      Multiple values are accepted.
    `, exception: (l) => typeof l == "string" || typeof l == "object", cliName: "plugin-search-dir", cliCategory: n }, printWidth: { since: "0.0.0", category: c, type: "int", default: 80, description: "The line length where Prettier will try wrap.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, rangeEnd: { since: "1.4.0", category: F, type: "int", default: Number.POSITIVE_INFINITY, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: u`
      Format code ending at a given character offset (exclusive).
      The range will extend forwards to the end of the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: D }, rangeStart: { since: "1.4.0", category: F, type: "int", default: 0, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: u`
      Format code starting at a given character offset.
      The range will extend backwards to the start of the first line containing the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: D }, requirePragma: { since: "1.7.0", category: F, type: "boolean", default: false, description: u`
      Require either '@prettier' or '@format' to be present in the file's first docblock comment
      in order for it to be formatted.
    `, cliCategory: i }, tabWidth: { type: "int", category: c, default: 2, description: "Number of spaces per indentation level.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, useTabs: { since: "1.0.0", category: c, type: "boolean", default: false, description: "Indent with tabs instead of spaces." }, embeddedLanguageFormatting: { since: "2.1.0", category: c, type: "choice", default: [{ since: "2.1.0", value: "auto" }], description: "Control how Prettier formats quoted code embedded in the file.", choices: [{ value: "auto", description: "Format embedded code if Prettier can automatically identify it." }, { value: "off", description: "Never automatically format embedded code." }] } };
            r.exports = { CATEGORY_CONFIG: n, CATEGORY_EDITOR: D, CATEGORY_FORMAT: s, CATEGORY_OTHER: i, CATEGORY_OUTPUT: f, CATEGORY_GLOBAL: c, CATEGORY_SPECIAL: F, options: a };
          } }), vl = I({ "src/main/support.js"(e, r) {
            "use strict";
            q();
            var u = { compare: Hr(), lt: El(), gte: Cl() }, n = ml(), D = gl().version, s = Al().options;
            function i() {
              let { plugins: c = [], showUnreleased: F = false, showDeprecated: a = false, showInternal: l = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, h = D.split("-", 1)[0], C = c.flatMap((g) => g.languages || []).filter(m), d = n(Object.assign({}, ...c.map((g) => {
                let { options: N } = g;
                return N;
              }), s), "name").filter((g) => m(g) && T(g)).sort((g, N) => g.name === N.name ? 0 : g.name < N.name ? -1 : 1).map(w).map((g) => {
                g = Object.assign({}, g), Array.isArray(g.default) && (g.default = g.default.length === 1 ? g.default[0].value : g.default.filter(m).sort((R, j) => u.compare(j.since, R.since))[0].value), Array.isArray(g.choices) && (g.choices = g.choices.filter((R) => m(R) && T(R)), g.name === "parser" && f(g, C, c));
                let N = Object.fromEntries(c.filter((R) => R.defaultOptions && R.defaultOptions[g.name] !== void 0).map((R) => [R.name, R.defaultOptions[g.name]]));
                return Object.assign(Object.assign({}, g), {}, { pluginDefaults: N });
              });
              return { languages: C, options: d };
              function m(g) {
                return F || !("since" in g) || g.since && u.gte(h, g.since);
              }
              function T(g) {
                return a || !("deprecated" in g) || g.deprecated && u.lt(h, g.deprecated);
              }
              function w(g) {
                if (l)
                  return g;
                let { cliName: N, cliCategory: R, cliDescription: j } = g;
                return JD(g, KD);
              }
            }
            function f(c, F, a) {
              let l = new Set(c.choices.map((h) => h.value));
              for (let h of F)
                if (h.parsers) {
                  for (let C of h.parsers)
                    if (!l.has(C)) {
                      l.add(C);
                      let d = a.find((T) => T.parsers && T.parsers[C]), m = h.name;
                      d && d.name && (m += ` (plugin: ${d.name})`), c.choices.push({ value: C, description: m });
                    }
                }
            }
            r.exports = { getSupportInfo: i };
          } }), _l = I({ "src/utils/is-non-empty-array.js"(e, r) {
            "use strict";
            q();
            function u(n) {
              return Array.isArray(n) && n.length > 0;
            }
            r.exports = u;
          } });
          function Sl() {
            let { onlyFirst: e = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
            return new RegExp(r, e ? void 0 : "g");
          }
          var yl = Ee({ "node_modules/strip-ansi/node_modules/ansi-regex/index.js"() {
            q();
          } });
          function Tl(e) {
            if (typeof e != "string")
              throw new TypeError(`Expected a \`string\`, got \`${typeof e}\``);
            return e.replace(Sl(), "");
          }
          var Bl = Ee({ "node_modules/strip-ansi/index.js"() {
            q(), yl();
          } });
          function bl(e) {
            return Number.isInteger(e) ? e >= 4352 && (e <= 4447 || e === 9001 || e === 9002 || 11904 <= e && e <= 12871 && e !== 12351 || 12880 <= e && e <= 19903 || 19968 <= e && e <= 42182 || 43360 <= e && e <= 43388 || 44032 <= e && e <= 55203 || 63744 <= e && e <= 64255 || 65040 <= e && e <= 65049 || 65072 <= e && e <= 65131 || 65281 <= e && e <= 65376 || 65504 <= e && e <= 65510 || 110592 <= e && e <= 110593 || 127488 <= e && e <= 127569 || 131072 <= e && e <= 262141) : false;
          }
          var wl = Ee({ "node_modules/is-fullwidth-code-point/index.js"() {
            q();
          } }), Nl = I({ "node_modules/emoji-regex/index.js"(e, r) {
            "use strict";
            q(), r.exports = function() {
              return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
            };
          } }), As = {};
          ps(As, { default: () => Ol });
          function Ol(e) {
            if (typeof e != "string" || e.length === 0 || (e = Tl(e), e.length === 0))
              return 0;
            e = e.replace((0, vs.default)(), "  ");
            let r = 0;
            for (let u = 0; u < e.length; u++) {
              let n = e.codePointAt(u);
              n <= 31 || n >= 127 && n <= 159 || n >= 768 && n <= 879 || (n > 65535 && u++, r += bl(n) ? 2 : 1);
            }
            return r;
          }
          var vs, ql = Ee({ "node_modules/string-width/index.js"() {
            q(), Bl(), wl(), vs = nl(Nl());
          } }), Il = I({ "src/utils/get-string-width.js"(e, r) {
            "use strict";
            q();
            var u = (ql(), ds(As)).default, n = /[^\x20-\x7F]/;
            function D(s) {
              return s ? n.test(s) ? u(s) : s.length : 0;
            }
            r.exports = D;
          } }), zr = I({ "src/utils/text/skip.js"(e, r) {
            "use strict";
            q();
            function u(f) {
              return (c, F, a) => {
                let l = a && a.backwards;
                if (F === false)
                  return false;
                let { length: h } = c, C = F;
                for (; C >= 0 && C < h; ) {
                  let d = c.charAt(C);
                  if (f instanceof RegExp) {
                    if (!f.test(d))
                      return C;
                  } else if (!f.includes(d))
                    return C;
                  l ? C-- : C++;
                }
                return C === -1 || C === h ? C : false;
              };
            }
            var n = u(/\s/), D = u(" 	"), s = u(",; 	"), i = u(/[^\n\r]/);
            r.exports = { skipWhitespace: n, skipSpaces: D, skipToLineEnd: s, skipEverythingButNewLine: i };
          } }), _s = I({ "src/utils/text/skip-inline-comment.js"(e, r) {
            "use strict";
            q();
            function u(n, D) {
              if (D === false)
                return false;
              if (n.charAt(D) === "/" && n.charAt(D + 1) === "*") {
                for (let s = D + 2; s < n.length; ++s)
                  if (n.charAt(s) === "*" && n.charAt(s + 1) === "/")
                    return s + 2;
              }
              return D;
            }
            r.exports = u;
          } }), Ss = I({ "src/utils/text/skip-trailing-comment.js"(e, r) {
            "use strict";
            q();
            var { skipEverythingButNewLine: u } = zr();
            function n(D, s) {
              return s === false ? false : D.charAt(s) === "/" && D.charAt(s + 1) === "/" ? u(D, s) : s;
            }
            r.exports = n;
          } }), ys = I({ "src/utils/text/skip-newline.js"(e, r) {
            "use strict";
            q();
            function u(n, D, s) {
              let i = s && s.backwards;
              if (D === false)
                return false;
              let f = n.charAt(D);
              if (i) {
                if (n.charAt(D - 1) === "\r" && f === `
`)
                  return D - 2;
                if (f === `
` || f === "\r" || f === "\u2028" || f === "\u2029")
                  return D - 1;
              } else {
                if (f === "\r" && n.charAt(D + 1) === `
`)
                  return D + 2;
                if (f === `
` || f === "\r" || f === "\u2028" || f === "\u2029")
                  return D + 1;
              }
              return D;
            }
            r.exports = u;
          } }), Rl = I({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(e, r) {
            "use strict";
            q();
            var u = _s(), n = ys(), D = Ss(), { skipSpaces: s } = zr();
            function i(f, c) {
              let F = null, a = c;
              for (; a !== F; )
                F = a, a = s(f, a), a = u(f, a), a = D(f, a), a = n(f, a);
              return a;
            }
            r.exports = i;
          } }), xl = I({ "src/common/util.js"(e, r) {
            "use strict";
            q();
            var { default: u } = (cl(), ds(ms)), n = Cs(), { getSupportInfo: D } = vl(), s = _l(), i = Il(), { skipWhitespace: f, skipSpaces: c, skipToLineEnd: F, skipEverythingButNewLine: a } = zr(), l = _s(), h = Ss(), C = ys(), d = Rl(), m = (v) => v[v.length - 2];
            function T(v) {
              return (y, B, b) => {
                let L = b && b.backwards;
                if (B === false)
                  return false;
                let { length: U } = y, G = B;
                for (; G >= 0 && G < U; ) {
                  let W = y.charAt(G);
                  if (v instanceof RegExp) {
                    if (!v.test(W))
                      return G;
                  } else if (!v.includes(W))
                    return G;
                  L ? G-- : G++;
                }
                return G === -1 || G === U ? G : false;
              };
            }
            function w(v, y) {
              let B = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, b = c(v, B.backwards ? y - 1 : y, B), L = C(v, b, B);
              return b !== L;
            }
            function g(v, y, B) {
              for (let b = y; b < B; ++b)
                if (v.charAt(b) === `
`)
                  return true;
              return false;
            }
            function N(v, y, B) {
              let b = B(y) - 1;
              b = c(v, b, { backwards: true }), b = C(v, b, { backwards: true }), b = c(v, b, { backwards: true });
              let L = C(v, b, { backwards: true });
              return b !== L;
            }
            function R(v, y) {
              let B = null, b = y;
              for (; b !== B; )
                B = b, b = F(v, b), b = l(v, b), b = c(v, b);
              return b = h(v, b), b = C(v, b), b !== false && w(v, b);
            }
            function j(v, y, B) {
              return R(v, B(y));
            }
            function _(v, y, B) {
              return d(v, B(y));
            }
            function O(v, y, B) {
              return v.charAt(_(v, y, B));
            }
            function x(v, y) {
              let B = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              return c(v, B.backwards ? y - 1 : y, B) !== y;
            }
            function k(v, y) {
              let B = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, b = 0;
              for (let L = B; L < v.length; ++L)
                v[L] === "	" ? b = b + y - b % y : b++;
              return b;
            }
            function $(v, y) {
              let B = v.lastIndexOf(`
`);
              return B === -1 ? 0 : k(v.slice(B + 1).match(/^[\t ]*/)[0], y);
            }
            function t3(v, y) {
              let B = { quote: '"', regex: /"/g, escaped: "&quot;" }, b = { quote: "'", regex: /'/g, escaped: "&apos;" }, L = y === "'" ? b : B, U = L === b ? B : b, G = L;
              if (v.includes(L.quote) || v.includes(U.quote)) {
                let W = (v.match(L.regex) || []).length, ne = (v.match(U.regex) || []).length;
                G = W > ne ? U : L;
              }
              return G;
            }
            function o(v, y) {
              let B = v.slice(1, -1), b = y.parser === "json" || y.parser === "json5" && y.quoteProps === "preserve" && !y.singleQuote ? '"' : y.__isInHtmlAttribute ? "'" : t3(B, y.singleQuote ? "'" : '"').quote;
              return E(B, b, !(y.parser === "css" || y.parser === "less" || y.parser === "scss" || y.__embeddedInHtml));
            }
            function E(v, y, B) {
              let b = y === '"' ? "'" : '"', L = /\\(.)|(["'])/gs, U = v.replace(L, (G, W, ne) => W === b ? W : ne === y ? "\\" + ne : ne || (B && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(W) ? W : "\\" + W));
              return y + U + y;
            }
            function p(v) {
              return v.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
            }
            function A(v, y) {
              let B = v.match(new RegExp(`(${u(y)})+`, "g"));
              return B === null ? 0 : B.reduce((b, L) => Math.max(b, L.length / y.length), 0);
            }
            function P(v, y) {
              let B = v.match(new RegExp(`(${u(y)})+`, "g"));
              if (B === null)
                return 0;
              let b = /* @__PURE__ */ new Map(), L = 0;
              for (let U of B) {
                let G = U.length / y.length;
                b.set(G, true), G > L && (L = G);
              }
              for (let U = 1; U < L; U++)
                if (!b.get(U))
                  return U;
              return L + 1;
            }
            function M(v, y) {
              (v.comments || (v.comments = [])).push(y), y.printed = false, y.nodeDescription = J(v);
            }
            function z(v, y) {
              y.leading = true, y.trailing = false, M(v, y);
            }
            function V(v, y, B) {
              y.leading = false, y.trailing = false, B && (y.marker = B), M(v, y);
            }
            function X(v, y) {
              y.leading = false, y.trailing = true, M(v, y);
            }
            function H(v, y) {
              let { languages: B } = D({ plugins: y.plugins }), b = B.find((L) => {
                let { name: U } = L;
                return U.toLowerCase() === v;
              }) || B.find((L) => {
                let { aliases: U } = L;
                return Array.isArray(U) && U.includes(v);
              }) || B.find((L) => {
                let { extensions: U } = L;
                return Array.isArray(U) && U.includes(`.${v}`);
              });
              return b && b.parsers[0];
            }
            function Q(v) {
              return v && v.type === "front-matter";
            }
            function K(v) {
              let y = /* @__PURE__ */ new WeakMap();
              return function(B) {
                return y.has(B) || y.set(B, Symbol(v)), y.get(B);
              };
            }
            function J(v) {
              let y = v.type || v.kind || "(unknown type)", B = String(v.name || v.id && (typeof v.id == "object" ? v.id.name : v.id) || v.key && (typeof v.key == "object" ? v.key.name : v.key) || v.value && (typeof v.value == "object" ? "" : String(v.value)) || v.operator || "");
              return B.length > 20 && (B = B.slice(0, 19) + "\u2026"), y + (B ? " " + B : "");
            }
            r.exports = { inferParserByLanguage: H, getStringWidth: i, getMaxContinuousCount: A, getMinNotPresentContinuousCount: P, getPenultimate: m, getLast: n, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: d, getNextNonSpaceNonCommentCharacterIndex: _, getNextNonSpaceNonCommentCharacter: O, skip: T, skipWhitespace: f, skipSpaces: c, skipToLineEnd: F, skipEverythingButNewLine: a, skipInlineComment: l, skipTrailingComment: h, skipNewline: C, isNextLineEmptyAfterIndex: R, isNextLineEmpty: j, isPreviousLineEmpty: N, hasNewline: w, hasNewlineInRange: g, hasSpaces: x, getAlignmentSize: k, getIndentSize: $, getPreferredQuote: t3, printString: o, printNumber: p, makeString: E, addLeadingComment: z, addDanglingComment: V, addTrailingComment: X, isFrontMatterNode: Q, isNonEmptyArray: s, createGroupIdMapper: K };
          } }), Pl = I({ "vendors/html-tag-names.json"(e, r) {
            r.exports = { htmlTagNames: ["a", "abbr", "acronym", "address", "applet", "area", "article", "aside", "audio", "b", "base", "basefont", "bdi", "bdo", "bgsound", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "command", "content", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "embed", "fieldset", "figcaption", "figure", "font", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "image", "img", "input", "ins", "isindex", "kbd", "keygen", "label", "legend", "li", "link", "listing", "main", "map", "mark", "marquee", "math", "menu", "menuitem", "meta", "meter", "multicol", "nav", "nextid", "nobr", "noembed", "noframes", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "plaintext", "pre", "progress", "q", "rb", "rbc", "rp", "rt", "rtc", "ruby", "s", "samp", "script", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "tt", "u", "ul", "var", "video", "wbr", "xmp"] };
          } }), Ts = I({ "src/language-html/utils/array-to-map.js"(e, r) {
            "use strict";
            q();
            function u(n) {
              let D = /* @__PURE__ */ Object.create(null);
              for (let s of n)
                D[s] = true;
              return D;
            }
            r.exports = u;
          } }), kl = I({ "src/language-html/utils/html-tag-names.js"(e, r) {
            "use strict";
            q();
            var { htmlTagNames: u } = Pl(), n = Ts(), D = n(u);
            r.exports = D;
          } }), Ll = I({ "vendors/html-element-attributes.json"(e, r) {
            r.exports = { htmlElementAttributes: { "*": ["accesskey", "autocapitalize", "autofocus", "class", "contenteditable", "dir", "draggable", "enterkeyhint", "hidden", "id", "inputmode", "is", "itemid", "itemprop", "itemref", "itemscope", "itemtype", "lang", "nonce", "slot", "spellcheck", "style", "tabindex", "title", "translate"], a: ["charset", "coords", "download", "href", "hreflang", "name", "ping", "referrerpolicy", "rel", "rev", "shape", "target", "type"], applet: ["align", "alt", "archive", "code", "codebase", "height", "hspace", "name", "object", "vspace", "width"], area: ["alt", "coords", "download", "href", "hreflang", "nohref", "ping", "referrerpolicy", "rel", "shape", "target", "type"], audio: ["autoplay", "controls", "crossorigin", "loop", "muted", "preload", "src"], base: ["href", "target"], basefont: ["color", "face", "size"], blockquote: ["cite"], body: ["alink", "background", "bgcolor", "link", "text", "vlink"], br: ["clear"], button: ["disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "name", "type", "value"], canvas: ["height", "width"], caption: ["align"], col: ["align", "char", "charoff", "span", "valign", "width"], colgroup: ["align", "char", "charoff", "span", "valign", "width"], data: ["value"], del: ["cite", "datetime"], details: ["open"], dialog: ["open"], dir: ["compact"], div: ["align"], dl: ["compact"], embed: ["height", "src", "type", "width"], fieldset: ["disabled", "form", "name"], font: ["color", "face", "size"], form: ["accept", "accept-charset", "action", "autocomplete", "enctype", "method", "name", "novalidate", "target"], frame: ["frameborder", "longdesc", "marginheight", "marginwidth", "name", "noresize", "scrolling", "src"], frameset: ["cols", "rows"], h1: ["align"], h2: ["align"], h3: ["align"], h4: ["align"], h5: ["align"], h6: ["align"], head: ["profile"], hr: ["align", "noshade", "size", "width"], html: ["manifest", "version"], iframe: ["align", "allow", "allowfullscreen", "allowpaymentrequest", "allowusermedia", "frameborder", "height", "loading", "longdesc", "marginheight", "marginwidth", "name", "referrerpolicy", "sandbox", "scrolling", "src", "srcdoc", "width"], img: ["align", "alt", "border", "crossorigin", "decoding", "height", "hspace", "ismap", "loading", "longdesc", "name", "referrerpolicy", "sizes", "src", "srcset", "usemap", "vspace", "width"], input: ["accept", "align", "alt", "autocomplete", "checked", "dirname", "disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "height", "ismap", "list", "max", "maxlength", "min", "minlength", "multiple", "name", "pattern", "placeholder", "readonly", "required", "size", "src", "step", "type", "usemap", "value", "width"], ins: ["cite", "datetime"], isindex: ["prompt"], label: ["for", "form"], legend: ["align"], li: ["type", "value"], link: ["as", "charset", "color", "crossorigin", "disabled", "href", "hreflang", "imagesizes", "imagesrcset", "integrity", "media", "referrerpolicy", "rel", "rev", "sizes", "target", "type"], map: ["name"], menu: ["compact"], meta: ["charset", "content", "http-equiv", "media", "name", "scheme"], meter: ["high", "low", "max", "min", "optimum", "value"], object: ["align", "archive", "border", "classid", "codebase", "codetype", "data", "declare", "form", "height", "hspace", "name", "standby", "type", "typemustmatch", "usemap", "vspace", "width"], ol: ["compact", "reversed", "start", "type"], optgroup: ["disabled", "label"], option: ["disabled", "label", "selected", "value"], output: ["for", "form", "name"], p: ["align"], param: ["name", "type", "value", "valuetype"], pre: ["width"], progress: ["max", "value"], q: ["cite"], script: ["async", "charset", "crossorigin", "defer", "integrity", "language", "nomodule", "referrerpolicy", "src", "type"], select: ["autocomplete", "disabled", "form", "multiple", "name", "required", "size"], slot: ["name"], source: ["height", "media", "sizes", "src", "srcset", "type", "width"], style: ["media", "type"], table: ["align", "bgcolor", "border", "cellpadding", "cellspacing", "frame", "rules", "summary", "width"], tbody: ["align", "char", "charoff", "valign"], td: ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"], textarea: ["autocomplete", "cols", "dirname", "disabled", "form", "maxlength", "minlength", "name", "placeholder", "readonly", "required", "rows", "wrap"], tfoot: ["align", "char", "charoff", "valign"], th: ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"], thead: ["align", "char", "charoff", "valign"], time: ["datetime"], tr: ["align", "bgcolor", "char", "charoff", "valign"], track: ["default", "kind", "label", "src", "srclang"], ul: ["compact", "type"], video: ["autoplay", "controls", "crossorigin", "height", "loop", "muted", "playsinline", "poster", "preload", "src", "width"] } };
          } }), $l = I({ "src/language-html/utils/map-object.js"(e, r) {
            "use strict";
            q();
            function u(n, D) {
              let s = /* @__PURE__ */ Object.create(null);
              for (let [i, f] of Object.entries(n))
                s[i] = D(f, i);
              return s;
            }
            r.exports = u;
          } }), Ml = I({ "src/language-html/utils/html-elements-attributes.js"(e, r) {
            "use strict";
            q();
            var { htmlElementAttributes: u } = Ll(), n = $l(), D = Ts(), s = n(u, D);
            r.exports = s;
          } }), jl = I({ "src/language-html/utils/is-unknown-namespace.js"(e, r) {
            "use strict";
            q();
            function u(n) {
              return n.type === "element" && !n.hasExplicitNamespace && !["html", "svg"].includes(n.namespace);
            }
            r.exports = u;
          } }), Ul = I({ "src/language-html/pragma.js"(e, r) {
            "use strict";
            q();
            function u(D) {
              return /^\s*<!--\s*@(?:format|prettier)\s*-->/.test(D);
            }
            function n(D) {
              return `<!-- @format -->

` + D.replace(/^\s*\n/, "");
            }
            r.exports = { hasPragma: u, insertPragma: n };
          } }), Gl = I({ "src/language-html/ast.js"(e, r) {
            "use strict";
            q();
            var u = { attrs: true, children: true }, n = /* @__PURE__ */ new Set(["parent"]), D = class {
              constructor() {
                let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                for (let f of /* @__PURE__ */ new Set([...n, ...Object.keys(i)]))
                  this.setProperty(f, i[f]);
              }
              setProperty(i, f) {
                if (this[i] !== f) {
                  if (i in u && (f = f.map((c) => this.createChild(c))), !n.has(i)) {
                    this[i] = f;
                    return;
                  }
                  Object.defineProperty(this, i, { value: f, enumerable: false, configurable: true });
                }
              }
              map(i) {
                let f;
                for (let c in u) {
                  let F = this[c];
                  if (F) {
                    let a = s(F, (l) => l.map(i));
                    f !== F && (f || (f = new D({ parent: this.parent })), f.setProperty(c, a));
                  }
                }
                if (f)
                  for (let c in this)
                    c in u || (f[c] = this[c]);
                return i(f || this);
              }
              walk(i) {
                for (let f in u) {
                  let c = this[f];
                  if (c)
                    for (let F = 0; F < c.length; F++)
                      c[F].walk(i);
                }
                i(this);
              }
              createChild(i) {
                let f = i instanceof D ? i.clone() : new D(i);
                return f.setProperty("parent", this), f;
              }
              insertChildBefore(i, f) {
                this.children.splice(this.children.indexOf(i), 0, this.createChild(f));
              }
              removeChild(i) {
                this.children.splice(this.children.indexOf(i), 1);
              }
              replaceChild(i, f) {
                this.children[this.children.indexOf(i)] = this.createChild(f);
              }
              clone() {
                return new D(this);
              }
              get firstChild() {
                var i;
                return (i = this.children) === null || i === void 0 ? void 0 : i[0];
              }
              get lastChild() {
                var i;
                return (i = this.children) === null || i === void 0 ? void 0 : i[this.children.length - 1];
              }
              get prev() {
                var i;
                return (i = this.parent) === null || i === void 0 ? void 0 : i.children[this.parent.children.indexOf(this) - 1];
              }
              get next() {
                var i;
                return (i = this.parent) === null || i === void 0 ? void 0 : i.children[this.parent.children.indexOf(this) + 1];
              }
              get rawName() {
                return this.hasExplicitNamespace ? this.fullName : this.name;
              }
              get fullName() {
                return this.namespace ? this.namespace + ":" + this.name : this.name;
              }
              get attrMap() {
                return Object.fromEntries(this.attrs.map((i) => [i.fullName, i.value]));
              }
            };
            function s(i, f) {
              let c = i.map(f);
              return c.some((F, a) => F !== i[a]) ? c : i;
            }
            r.exports = { Node: D };
          } }), Vl = I({ "src/language-html/conditional-comment.js"(e, r) {
            "use strict";
            q();
            var { ParseSourceSpan: u } = Be(), n = [{ regex: /^(\[if([^\]]*)]>)(.*?)<!\s*\[endif]$/s, parse: s }, { regex: /^\[if([^\]]*)]><!$/, parse: i }, { regex: /^<!\s*\[endif]$/, parse: f }];
            function D(c, F) {
              if (c.value)
                for (let { regex: a, parse: l } of n) {
                  let h = c.value.match(a);
                  if (h)
                    return l(c, F, h);
                }
              return null;
            }
            function s(c, F, a) {
              let [, l, h, C] = a, d = 4 + l.length, m = c.sourceSpan.start.moveBy(d), T = m.moveBy(C.length), [w, g] = (() => {
                try {
                  return [true, F(C, m).children];
                } catch {
                  return [false, [{ type: "text", value: C, sourceSpan: new u(m, T) }]];
                }
              })();
              return { type: "ieConditionalComment", complete: w, children: g, condition: h.trim().replace(/\s+/g, " "), sourceSpan: c.sourceSpan, startSourceSpan: new u(c.sourceSpan.start, m), endSourceSpan: new u(T, c.sourceSpan.end) };
            }
            function i(c, F, a) {
              let [, l] = a;
              return { type: "ieConditionalStartComment", condition: l.trim().replace(/\s+/g, " "), sourceSpan: c.sourceSpan };
            }
            function f(c) {
              return { type: "ieConditionalEndComment", sourceSpan: c.sourceSpan };
            }
            r.exports = { parseIeConditionalComment: D };
          } }), Xl = I({ "src/language-html/loc.js"(e, r) {
            "use strict";
            q();
            function u(D) {
              return D.sourceSpan.start.offset;
            }
            function n(D) {
              return D.sourceSpan.end.offset;
            }
            r.exports = { locStart: u, locEnd: n };
          } }), Ze = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/tags.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r;
            (function(c) {
              c[c.RAW_TEXT = 0] = "RAW_TEXT", c[c.ESCAPABLE_RAW_TEXT = 1] = "ESCAPABLE_RAW_TEXT", c[c.PARSABLE_DATA = 2] = "PARSABLE_DATA";
            })(r = e.TagContentType || (e.TagContentType = {}));
            function u(c) {
              if (c[0] != ":")
                return [null, c];
              let F = c.indexOf(":", 1);
              if (F == -1)
                throw new Error(`Unsupported format "${c}" expecting ":namespace:name"`);
              return [c.slice(1, F), c.slice(F + 1)];
            }
            e.splitNsName = u;
            function n(c) {
              return u(c)[1] === "ng-container";
            }
            e.isNgContainer = n;
            function D(c) {
              return u(c)[1] === "ng-content";
            }
            e.isNgContent = D;
            function s(c) {
              return u(c)[1] === "ng-template";
            }
            e.isNgTemplate = s;
            function i(c) {
              return c === null ? null : u(c)[0];
            }
            e.getNsPrefix = i;
            function f(c, F) {
              return c ? `:${c}:${F}` : F;
            }
            e.mergeNsAndName = f, e.NAMED_ENTITIES = { Aacute: "\xC1", aacute: "\xE1", Abreve: "\u0102", abreve: "\u0103", ac: "\u223E", acd: "\u223F", acE: "\u223E\u0333", Acirc: "\xC2", acirc: "\xE2", acute: "\xB4", Acy: "\u0410", acy: "\u0430", AElig: "\xC6", aelig: "\xE6", af: "\u2061", Afr: "\u{1D504}", afr: "\u{1D51E}", Agrave: "\xC0", agrave: "\xE0", alefsym: "\u2135", aleph: "\u2135", Alpha: "\u0391", alpha: "\u03B1", Amacr: "\u0100", amacr: "\u0101", amalg: "\u2A3F", AMP: "&", amp: "&", And: "\u2A53", and: "\u2227", andand: "\u2A55", andd: "\u2A5C", andslope: "\u2A58", andv: "\u2A5A", ang: "\u2220", ange: "\u29A4", angle: "\u2220", angmsd: "\u2221", angmsdaa: "\u29A8", angmsdab: "\u29A9", angmsdac: "\u29AA", angmsdad: "\u29AB", angmsdae: "\u29AC", angmsdaf: "\u29AD", angmsdag: "\u29AE", angmsdah: "\u29AF", angrt: "\u221F", angrtvb: "\u22BE", angrtvbd: "\u299D", angsph: "\u2222", angst: "\xC5", angzarr: "\u237C", Aogon: "\u0104", aogon: "\u0105", Aopf: "\u{1D538}", aopf: "\u{1D552}", ap: "\u2248", apacir: "\u2A6F", apE: "\u2A70", ape: "\u224A", apid: "\u224B", apos: "'", ApplyFunction: "\u2061", approx: "\u2248", approxeq: "\u224A", Aring: "\xC5", aring: "\xE5", Ascr: "\u{1D49C}", ascr: "\u{1D4B6}", Assign: "\u2254", ast: "*", asymp: "\u2248", asympeq: "\u224D", Atilde: "\xC3", atilde: "\xE3", Auml: "\xC4", auml: "\xE4", awconint: "\u2233", awint: "\u2A11", backcong: "\u224C", backepsilon: "\u03F6", backprime: "\u2035", backsim: "\u223D", backsimeq: "\u22CD", Backslash: "\u2216", Barv: "\u2AE7", barvee: "\u22BD", Barwed: "\u2306", barwed: "\u2305", barwedge: "\u2305", bbrk: "\u23B5", bbrktbrk: "\u23B6", bcong: "\u224C", Bcy: "\u0411", bcy: "\u0431", bdquo: "\u201E", becaus: "\u2235", Because: "\u2235", because: "\u2235", bemptyv: "\u29B0", bepsi: "\u03F6", bernou: "\u212C", Bernoullis: "\u212C", Beta: "\u0392", beta: "\u03B2", beth: "\u2136", between: "\u226C", Bfr: "\u{1D505}", bfr: "\u{1D51F}", bigcap: "\u22C2", bigcirc: "\u25EF", bigcup: "\u22C3", bigodot: "\u2A00", bigoplus: "\u2A01", bigotimes: "\u2A02", bigsqcup: "\u2A06", bigstar: "\u2605", bigtriangledown: "\u25BD", bigtriangleup: "\u25B3", biguplus: "\u2A04", bigvee: "\u22C1", bigwedge: "\u22C0", bkarow: "\u290D", blacklozenge: "\u29EB", blacksquare: "\u25AA", blacktriangle: "\u25B4", blacktriangledown: "\u25BE", blacktriangleleft: "\u25C2", blacktriangleright: "\u25B8", blank: "\u2423", blk12: "\u2592", blk14: "\u2591", blk34: "\u2593", block: "\u2588", bne: "=\u20E5", bnequiv: "\u2261\u20E5", bNot: "\u2AED", bnot: "\u2310", Bopf: "\u{1D539}", bopf: "\u{1D553}", bot: "\u22A5", bottom: "\u22A5", bowtie: "\u22C8", boxbox: "\u29C9", boxDL: "\u2557", boxDl: "\u2556", boxdL: "\u2555", boxdl: "\u2510", boxDR: "\u2554", boxDr: "\u2553", boxdR: "\u2552", boxdr: "\u250C", boxH: "\u2550", boxh: "\u2500", boxHD: "\u2566", boxHd: "\u2564", boxhD: "\u2565", boxhd: "\u252C", boxHU: "\u2569", boxHu: "\u2567", boxhU: "\u2568", boxhu: "\u2534", boxminus: "\u229F", boxplus: "\u229E", boxtimes: "\u22A0", boxUL: "\u255D", boxUl: "\u255C", boxuL: "\u255B", boxul: "\u2518", boxUR: "\u255A", boxUr: "\u2559", boxuR: "\u2558", boxur: "\u2514", boxV: "\u2551", boxv: "\u2502", boxVH: "\u256C", boxVh: "\u256B", boxvH: "\u256A", boxvh: "\u253C", boxVL: "\u2563", boxVl: "\u2562", boxvL: "\u2561", boxvl: "\u2524", boxVR: "\u2560", boxVr: "\u255F", boxvR: "\u255E", boxvr: "\u251C", bprime: "\u2035", Breve: "\u02D8", breve: "\u02D8", brvbar: "\xA6", Bscr: "\u212C", bscr: "\u{1D4B7}", bsemi: "\u204F", bsim: "\u223D", bsime: "\u22CD", bsol: "\\", bsolb: "\u29C5", bsolhsub: "\u27C8", bull: "\u2022", bullet: "\u2022", bump: "\u224E", bumpE: "\u2AAE", bumpe: "\u224F", Bumpeq: "\u224E", bumpeq: "\u224F", Cacute: "\u0106", cacute: "\u0107", Cap: "\u22D2", cap: "\u2229", capand: "\u2A44", capbrcup: "\u2A49", capcap: "\u2A4B", capcup: "\u2A47", capdot: "\u2A40", CapitalDifferentialD: "\u2145", caps: "\u2229\uFE00", caret: "\u2041", caron: "\u02C7", Cayleys: "\u212D", ccaps: "\u2A4D", Ccaron: "\u010C", ccaron: "\u010D", Ccedil: "\xC7", ccedil: "\xE7", Ccirc: "\u0108", ccirc: "\u0109", Cconint: "\u2230", ccups: "\u2A4C", ccupssm: "\u2A50", Cdot: "\u010A", cdot: "\u010B", cedil: "\xB8", Cedilla: "\xB8", cemptyv: "\u29B2", cent: "\xA2", CenterDot: "\xB7", centerdot: "\xB7", Cfr: "\u212D", cfr: "\u{1D520}", CHcy: "\u0427", chcy: "\u0447", check: "\u2713", checkmark: "\u2713", Chi: "\u03A7", chi: "\u03C7", cir: "\u25CB", circ: "\u02C6", circeq: "\u2257", circlearrowleft: "\u21BA", circlearrowright: "\u21BB", circledast: "\u229B", circledcirc: "\u229A", circleddash: "\u229D", CircleDot: "\u2299", circledR: "\xAE", circledS: "\u24C8", CircleMinus: "\u2296", CirclePlus: "\u2295", CircleTimes: "\u2297", cirE: "\u29C3", cire: "\u2257", cirfnint: "\u2A10", cirmid: "\u2AEF", cirscir: "\u29C2", ClockwiseContourIntegral: "\u2232", CloseCurlyDoubleQuote: "\u201D", CloseCurlyQuote: "\u2019", clubs: "\u2663", clubsuit: "\u2663", Colon: "\u2237", colon: ":", Colone: "\u2A74", colone: "\u2254", coloneq: "\u2254", comma: ",", commat: "@", comp: "\u2201", compfn: "\u2218", complement: "\u2201", complexes: "\u2102", cong: "\u2245", congdot: "\u2A6D", Congruent: "\u2261", Conint: "\u222F", conint: "\u222E", ContourIntegral: "\u222E", Copf: "\u2102", copf: "\u{1D554}", coprod: "\u2210", Coproduct: "\u2210", COPY: "\xA9", copy: "\xA9", copysr: "\u2117", CounterClockwiseContourIntegral: "\u2233", crarr: "\u21B5", Cross: "\u2A2F", cross: "\u2717", Cscr: "\u{1D49E}", cscr: "\u{1D4B8}", csub: "\u2ACF", csube: "\u2AD1", csup: "\u2AD0", csupe: "\u2AD2", ctdot: "\u22EF", cudarrl: "\u2938", cudarrr: "\u2935", cuepr: "\u22DE", cuesc: "\u22DF", cularr: "\u21B6", cularrp: "\u293D", Cup: "\u22D3", cup: "\u222A", cupbrcap: "\u2A48", CupCap: "\u224D", cupcap: "\u2A46", cupcup: "\u2A4A", cupdot: "\u228D", cupor: "\u2A45", cups: "\u222A\uFE00", curarr: "\u21B7", curarrm: "\u293C", curlyeqprec: "\u22DE", curlyeqsucc: "\u22DF", curlyvee: "\u22CE", curlywedge: "\u22CF", curren: "\xA4", curvearrowleft: "\u21B6", curvearrowright: "\u21B7", cuvee: "\u22CE", cuwed: "\u22CF", cwconint: "\u2232", cwint: "\u2231", cylcty: "\u232D", Dagger: "\u2021", dagger: "\u2020", daleth: "\u2138", Darr: "\u21A1", dArr: "\u21D3", darr: "\u2193", dash: "\u2010", Dashv: "\u2AE4", dashv: "\u22A3", dbkarow: "\u290F", dblac: "\u02DD", Dcaron: "\u010E", dcaron: "\u010F", Dcy: "\u0414", dcy: "\u0434", DD: "\u2145", dd: "\u2146", ddagger: "\u2021", ddarr: "\u21CA", DDotrahd: "\u2911", ddotseq: "\u2A77", deg: "\xB0", Del: "\u2207", Delta: "\u0394", delta: "\u03B4", demptyv: "\u29B1", dfisht: "\u297F", Dfr: "\u{1D507}", dfr: "\u{1D521}", dHar: "\u2965", dharl: "\u21C3", dharr: "\u21C2", DiacriticalAcute: "\xB4", DiacriticalDot: "\u02D9", DiacriticalDoubleAcute: "\u02DD", DiacriticalGrave: "`", DiacriticalTilde: "\u02DC", diam: "\u22C4", Diamond: "\u22C4", diamond: "\u22C4", diamondsuit: "\u2666", diams: "\u2666", die: "\xA8", DifferentialD: "\u2146", digamma: "\u03DD", disin: "\u22F2", div: "\xF7", divide: "\xF7", divideontimes: "\u22C7", divonx: "\u22C7", DJcy: "\u0402", djcy: "\u0452", dlcorn: "\u231E", dlcrop: "\u230D", dollar: "$", Dopf: "\u{1D53B}", dopf: "\u{1D555}", Dot: "\xA8", dot: "\u02D9", DotDot: "\u20DC", doteq: "\u2250", doteqdot: "\u2251", DotEqual: "\u2250", dotminus: "\u2238", dotplus: "\u2214", dotsquare: "\u22A1", doublebarwedge: "\u2306", DoubleContourIntegral: "\u222F", DoubleDot: "\xA8", DoubleDownArrow: "\u21D3", DoubleLeftArrow: "\u21D0", DoubleLeftRightArrow: "\u21D4", DoubleLeftTee: "\u2AE4", DoubleLongLeftArrow: "\u27F8", DoubleLongLeftRightArrow: "\u27FA", DoubleLongRightArrow: "\u27F9", DoubleRightArrow: "\u21D2", DoubleRightTee: "\u22A8", DoubleUpArrow: "\u21D1", DoubleUpDownArrow: "\u21D5", DoubleVerticalBar: "\u2225", DownArrow: "\u2193", Downarrow: "\u21D3", downarrow: "\u2193", DownArrowBar: "\u2913", DownArrowUpArrow: "\u21F5", DownBreve: "\u0311", downdownarrows: "\u21CA", downharpoonleft: "\u21C3", downharpoonright: "\u21C2", DownLeftRightVector: "\u2950", DownLeftTeeVector: "\u295E", DownLeftVector: "\u21BD", DownLeftVectorBar: "\u2956", DownRightTeeVector: "\u295F", DownRightVector: "\u21C1", DownRightVectorBar: "\u2957", DownTee: "\u22A4", DownTeeArrow: "\u21A7", drbkarow: "\u2910", drcorn: "\u231F", drcrop: "\u230C", Dscr: "\u{1D49F}", dscr: "\u{1D4B9}", DScy: "\u0405", dscy: "\u0455", dsol: "\u29F6", Dstrok: "\u0110", dstrok: "\u0111", dtdot: "\u22F1", dtri: "\u25BF", dtrif: "\u25BE", duarr: "\u21F5", duhar: "\u296F", dwangle: "\u29A6", DZcy: "\u040F", dzcy: "\u045F", dzigrarr: "\u27FF", Eacute: "\xC9", eacute: "\xE9", easter: "\u2A6E", Ecaron: "\u011A", ecaron: "\u011B", ecir: "\u2256", Ecirc: "\xCA", ecirc: "\xEA", ecolon: "\u2255", Ecy: "\u042D", ecy: "\u044D", eDDot: "\u2A77", Edot: "\u0116", eDot: "\u2251", edot: "\u0117", ee: "\u2147", efDot: "\u2252", Efr: "\u{1D508}", efr: "\u{1D522}", eg: "\u2A9A", Egrave: "\xC8", egrave: "\xE8", egs: "\u2A96", egsdot: "\u2A98", el: "\u2A99", Element: "\u2208", elinters: "\u23E7", ell: "\u2113", els: "\u2A95", elsdot: "\u2A97", Emacr: "\u0112", emacr: "\u0113", empty: "\u2205", emptyset: "\u2205", EmptySmallSquare: "\u25FB", emptyv: "\u2205", EmptyVerySmallSquare: "\u25AB", emsp: "\u2003", emsp13: "\u2004", emsp14: "\u2005", ENG: "\u014A", eng: "\u014B", ensp: "\u2002", Eogon: "\u0118", eogon: "\u0119", Eopf: "\u{1D53C}", eopf: "\u{1D556}", epar: "\u22D5", eparsl: "\u29E3", eplus: "\u2A71", epsi: "\u03B5", Epsilon: "\u0395", epsilon: "\u03B5", epsiv: "\u03F5", eqcirc: "\u2256", eqcolon: "\u2255", eqsim: "\u2242", eqslantgtr: "\u2A96", eqslantless: "\u2A95", Equal: "\u2A75", equals: "=", EqualTilde: "\u2242", equest: "\u225F", Equilibrium: "\u21CC", equiv: "\u2261", equivDD: "\u2A78", eqvparsl: "\u29E5", erarr: "\u2971", erDot: "\u2253", Escr: "\u2130", escr: "\u212F", esdot: "\u2250", Esim: "\u2A73", esim: "\u2242", Eta: "\u0397", eta: "\u03B7", ETH: "\xD0", eth: "\xF0", Euml: "\xCB", euml: "\xEB", euro: "\u20AC", excl: "!", exist: "\u2203", Exists: "\u2203", expectation: "\u2130", ExponentialE: "\u2147", exponentiale: "\u2147", fallingdotseq: "\u2252", Fcy: "\u0424", fcy: "\u0444", female: "\u2640", ffilig: "\uFB03", fflig: "\uFB00", ffllig: "\uFB04", Ffr: "\u{1D509}", ffr: "\u{1D523}", filig: "\uFB01", FilledSmallSquare: "\u25FC", FilledVerySmallSquare: "\u25AA", fjlig: "fj", flat: "\u266D", fllig: "\uFB02", fltns: "\u25B1", fnof: "\u0192", Fopf: "\u{1D53D}", fopf: "\u{1D557}", ForAll: "\u2200", forall: "\u2200", fork: "\u22D4", forkv: "\u2AD9", Fouriertrf: "\u2131", fpartint: "\u2A0D", frac12: "\xBD", frac13: "\u2153", frac14: "\xBC", frac15: "\u2155", frac16: "\u2159", frac18: "\u215B", frac23: "\u2154", frac25: "\u2156", frac34: "\xBE", frac35: "\u2157", frac38: "\u215C", frac45: "\u2158", frac56: "\u215A", frac58: "\u215D", frac78: "\u215E", frasl: "\u2044", frown: "\u2322", Fscr: "\u2131", fscr: "\u{1D4BB}", gacute: "\u01F5", Gamma: "\u0393", gamma: "\u03B3", Gammad: "\u03DC", gammad: "\u03DD", gap: "\u2A86", Gbreve: "\u011E", gbreve: "\u011F", Gcedil: "\u0122", Gcirc: "\u011C", gcirc: "\u011D", Gcy: "\u0413", gcy: "\u0433", Gdot: "\u0120", gdot: "\u0121", gE: "\u2267", ge: "\u2265", gEl: "\u2A8C", gel: "\u22DB", geq: "\u2265", geqq: "\u2267", geqslant: "\u2A7E", ges: "\u2A7E", gescc: "\u2AA9", gesdot: "\u2A80", gesdoto: "\u2A82", gesdotol: "\u2A84", gesl: "\u22DB\uFE00", gesles: "\u2A94", Gfr: "\u{1D50A}", gfr: "\u{1D524}", Gg: "\u22D9", gg: "\u226B", ggg: "\u22D9", gimel: "\u2137", GJcy: "\u0403", gjcy: "\u0453", gl: "\u2277", gla: "\u2AA5", glE: "\u2A92", glj: "\u2AA4", gnap: "\u2A8A", gnapprox: "\u2A8A", gnE: "\u2269", gne: "\u2A88", gneq: "\u2A88", gneqq: "\u2269", gnsim: "\u22E7", Gopf: "\u{1D53E}", gopf: "\u{1D558}", grave: "`", GreaterEqual: "\u2265", GreaterEqualLess: "\u22DB", GreaterFullEqual: "\u2267", GreaterGreater: "\u2AA2", GreaterLess: "\u2277", GreaterSlantEqual: "\u2A7E", GreaterTilde: "\u2273", Gscr: "\u{1D4A2}", gscr: "\u210A", gsim: "\u2273", gsime: "\u2A8E", gsiml: "\u2A90", GT: ">", Gt: "\u226B", gt: ">", gtcc: "\u2AA7", gtcir: "\u2A7A", gtdot: "\u22D7", gtlPar: "\u2995", gtquest: "\u2A7C", gtrapprox: "\u2A86", gtrarr: "\u2978", gtrdot: "\u22D7", gtreqless: "\u22DB", gtreqqless: "\u2A8C", gtrless: "\u2277", gtrsim: "\u2273", gvertneqq: "\u2269\uFE00", gvnE: "\u2269\uFE00", Hacek: "\u02C7", hairsp: "\u200A", half: "\xBD", hamilt: "\u210B", HARDcy: "\u042A", hardcy: "\u044A", hArr: "\u21D4", harr: "\u2194", harrcir: "\u2948", harrw: "\u21AD", Hat: "^", hbar: "\u210F", Hcirc: "\u0124", hcirc: "\u0125", hearts: "\u2665", heartsuit: "\u2665", hellip: "\u2026", hercon: "\u22B9", Hfr: "\u210C", hfr: "\u{1D525}", HilbertSpace: "\u210B", hksearow: "\u2925", hkswarow: "\u2926", hoarr: "\u21FF", homtht: "\u223B", hookleftarrow: "\u21A9", hookrightarrow: "\u21AA", Hopf: "\u210D", hopf: "\u{1D559}", horbar: "\u2015", HorizontalLine: "\u2500", Hscr: "\u210B", hscr: "\u{1D4BD}", hslash: "\u210F", Hstrok: "\u0126", hstrok: "\u0127", HumpDownHump: "\u224E", HumpEqual: "\u224F", hybull: "\u2043", hyphen: "\u2010", Iacute: "\xCD", iacute: "\xED", ic: "\u2063", Icirc: "\xCE", icirc: "\xEE", Icy: "\u0418", icy: "\u0438", Idot: "\u0130", IEcy: "\u0415", iecy: "\u0435", iexcl: "\xA1", iff: "\u21D4", Ifr: "\u2111", ifr: "\u{1D526}", Igrave: "\xCC", igrave: "\xEC", ii: "\u2148", iiiint: "\u2A0C", iiint: "\u222D", iinfin: "\u29DC", iiota: "\u2129", IJlig: "\u0132", ijlig: "\u0133", Im: "\u2111", Imacr: "\u012A", imacr: "\u012B", image: "\u2111", ImaginaryI: "\u2148", imagline: "\u2110", imagpart: "\u2111", imath: "\u0131", imof: "\u22B7", imped: "\u01B5", Implies: "\u21D2", in: "\u2208", incare: "\u2105", infin: "\u221E", infintie: "\u29DD", inodot: "\u0131", Int: "\u222C", int: "\u222B", intcal: "\u22BA", integers: "\u2124", Integral: "\u222B", intercal: "\u22BA", Intersection: "\u22C2", intlarhk: "\u2A17", intprod: "\u2A3C", InvisibleComma: "\u2063", InvisibleTimes: "\u2062", IOcy: "\u0401", iocy: "\u0451", Iogon: "\u012E", iogon: "\u012F", Iopf: "\u{1D540}", iopf: "\u{1D55A}", Iota: "\u0399", iota: "\u03B9", iprod: "\u2A3C", iquest: "\xBF", Iscr: "\u2110", iscr: "\u{1D4BE}", isin: "\u2208", isindot: "\u22F5", isinE: "\u22F9", isins: "\u22F4", isinsv: "\u22F3", isinv: "\u2208", it: "\u2062", Itilde: "\u0128", itilde: "\u0129", Iukcy: "\u0406", iukcy: "\u0456", Iuml: "\xCF", iuml: "\xEF", Jcirc: "\u0134", jcirc: "\u0135", Jcy: "\u0419", jcy: "\u0439", Jfr: "\u{1D50D}", jfr: "\u{1D527}", jmath: "\u0237", Jopf: "\u{1D541}", jopf: "\u{1D55B}", Jscr: "\u{1D4A5}", jscr: "\u{1D4BF}", Jsercy: "\u0408", jsercy: "\u0458", Jukcy: "\u0404", jukcy: "\u0454", Kappa: "\u039A", kappa: "\u03BA", kappav: "\u03F0", Kcedil: "\u0136", kcedil: "\u0137", Kcy: "\u041A", kcy: "\u043A", Kfr: "\u{1D50E}", kfr: "\u{1D528}", kgreen: "\u0138", KHcy: "\u0425", khcy: "\u0445", KJcy: "\u040C", kjcy: "\u045C", Kopf: "\u{1D542}", kopf: "\u{1D55C}", Kscr: "\u{1D4A6}", kscr: "\u{1D4C0}", lAarr: "\u21DA", Lacute: "\u0139", lacute: "\u013A", laemptyv: "\u29B4", lagran: "\u2112", Lambda: "\u039B", lambda: "\u03BB", Lang: "\u27EA", lang: "\u27E8", langd: "\u2991", langle: "\u27E8", lap: "\u2A85", Laplacetrf: "\u2112", laquo: "\xAB", Larr: "\u219E", lArr: "\u21D0", larr: "\u2190", larrb: "\u21E4", larrbfs: "\u291F", larrfs: "\u291D", larrhk: "\u21A9", larrlp: "\u21AB", larrpl: "\u2939", larrsim: "\u2973", larrtl: "\u21A2", lat: "\u2AAB", lAtail: "\u291B", latail: "\u2919", late: "\u2AAD", lates: "\u2AAD\uFE00", lBarr: "\u290E", lbarr: "\u290C", lbbrk: "\u2772", lbrace: "{", lbrack: "[", lbrke: "\u298B", lbrksld: "\u298F", lbrkslu: "\u298D", Lcaron: "\u013D", lcaron: "\u013E", Lcedil: "\u013B", lcedil: "\u013C", lceil: "\u2308", lcub: "{", Lcy: "\u041B", lcy: "\u043B", ldca: "\u2936", ldquo: "\u201C", ldquor: "\u201E", ldrdhar: "\u2967", ldrushar: "\u294B", ldsh: "\u21B2", lE: "\u2266", le: "\u2264", LeftAngleBracket: "\u27E8", LeftArrow: "\u2190", Leftarrow: "\u21D0", leftarrow: "\u2190", LeftArrowBar: "\u21E4", LeftArrowRightArrow: "\u21C6", leftarrowtail: "\u21A2", LeftCeiling: "\u2308", LeftDoubleBracket: "\u27E6", LeftDownTeeVector: "\u2961", LeftDownVector: "\u21C3", LeftDownVectorBar: "\u2959", LeftFloor: "\u230A", leftharpoondown: "\u21BD", leftharpoonup: "\u21BC", leftleftarrows: "\u21C7", LeftRightArrow: "\u2194", Leftrightarrow: "\u21D4", leftrightarrow: "\u2194", leftrightarrows: "\u21C6", leftrightharpoons: "\u21CB", leftrightsquigarrow: "\u21AD", LeftRightVector: "\u294E", LeftTee: "\u22A3", LeftTeeArrow: "\u21A4", LeftTeeVector: "\u295A", leftthreetimes: "\u22CB", LeftTriangle: "\u22B2", LeftTriangleBar: "\u29CF", LeftTriangleEqual: "\u22B4", LeftUpDownVector: "\u2951", LeftUpTeeVector: "\u2960", LeftUpVector: "\u21BF", LeftUpVectorBar: "\u2958", LeftVector: "\u21BC", LeftVectorBar: "\u2952", lEg: "\u2A8B", leg: "\u22DA", leq: "\u2264", leqq: "\u2266", leqslant: "\u2A7D", les: "\u2A7D", lescc: "\u2AA8", lesdot: "\u2A7F", lesdoto: "\u2A81", lesdotor: "\u2A83", lesg: "\u22DA\uFE00", lesges: "\u2A93", lessapprox: "\u2A85", lessdot: "\u22D6", lesseqgtr: "\u22DA", lesseqqgtr: "\u2A8B", LessEqualGreater: "\u22DA", LessFullEqual: "\u2266", LessGreater: "\u2276", lessgtr: "\u2276", LessLess: "\u2AA1", lesssim: "\u2272", LessSlantEqual: "\u2A7D", LessTilde: "\u2272", lfisht: "\u297C", lfloor: "\u230A", Lfr: "\u{1D50F}", lfr: "\u{1D529}", lg: "\u2276", lgE: "\u2A91", lHar: "\u2962", lhard: "\u21BD", lharu: "\u21BC", lharul: "\u296A", lhblk: "\u2584", LJcy: "\u0409", ljcy: "\u0459", Ll: "\u22D8", ll: "\u226A", llarr: "\u21C7", llcorner: "\u231E", Lleftarrow: "\u21DA", llhard: "\u296B", lltri: "\u25FA", Lmidot: "\u013F", lmidot: "\u0140", lmoust: "\u23B0", lmoustache: "\u23B0", lnap: "\u2A89", lnapprox: "\u2A89", lnE: "\u2268", lne: "\u2A87", lneq: "\u2A87", lneqq: "\u2268", lnsim: "\u22E6", loang: "\u27EC", loarr: "\u21FD", lobrk: "\u27E6", LongLeftArrow: "\u27F5", Longleftarrow: "\u27F8", longleftarrow: "\u27F5", LongLeftRightArrow: "\u27F7", Longleftrightarrow: "\u27FA", longleftrightarrow: "\u27F7", longmapsto: "\u27FC", LongRightArrow: "\u27F6", Longrightarrow: "\u27F9", longrightarrow: "\u27F6", looparrowleft: "\u21AB", looparrowright: "\u21AC", lopar: "\u2985", Lopf: "\u{1D543}", lopf: "\u{1D55D}", loplus: "\u2A2D", lotimes: "\u2A34", lowast: "\u2217", lowbar: "_", LowerLeftArrow: "\u2199", LowerRightArrow: "\u2198", loz: "\u25CA", lozenge: "\u25CA", lozf: "\u29EB", lpar: "(", lparlt: "\u2993", lrarr: "\u21C6", lrcorner: "\u231F", lrhar: "\u21CB", lrhard: "\u296D", lrm: "\u200E", lrtri: "\u22BF", lsaquo: "\u2039", Lscr: "\u2112", lscr: "\u{1D4C1}", Lsh: "\u21B0", lsh: "\u21B0", lsim: "\u2272", lsime: "\u2A8D", lsimg: "\u2A8F", lsqb: "[", lsquo: "\u2018", lsquor: "\u201A", Lstrok: "\u0141", lstrok: "\u0142", LT: "<", Lt: "\u226A", lt: "<", ltcc: "\u2AA6", ltcir: "\u2A79", ltdot: "\u22D6", lthree: "\u22CB", ltimes: "\u22C9", ltlarr: "\u2976", ltquest: "\u2A7B", ltri: "\u25C3", ltrie: "\u22B4", ltrif: "\u25C2", ltrPar: "\u2996", lurdshar: "\u294A", luruhar: "\u2966", lvertneqq: "\u2268\uFE00", lvnE: "\u2268\uFE00", macr: "\xAF", male: "\u2642", malt: "\u2720", maltese: "\u2720", Map: "\u2905", map: "\u21A6", mapsto: "\u21A6", mapstodown: "\u21A7", mapstoleft: "\u21A4", mapstoup: "\u21A5", marker: "\u25AE", mcomma: "\u2A29", Mcy: "\u041C", mcy: "\u043C", mdash: "\u2014", mDDot: "\u223A", measuredangle: "\u2221", MediumSpace: "\u205F", Mellintrf: "\u2133", Mfr: "\u{1D510}", mfr: "\u{1D52A}", mho: "\u2127", micro: "\xB5", mid: "\u2223", midast: "*", midcir: "\u2AF0", middot: "\xB7", minus: "\u2212", minusb: "\u229F", minusd: "\u2238", minusdu: "\u2A2A", MinusPlus: "\u2213", mlcp: "\u2ADB", mldr: "\u2026", mnplus: "\u2213", models: "\u22A7", Mopf: "\u{1D544}", mopf: "\u{1D55E}", mp: "\u2213", Mscr: "\u2133", mscr: "\u{1D4C2}", mstpos: "\u223E", Mu: "\u039C", mu: "\u03BC", multimap: "\u22B8", mumap: "\u22B8", nabla: "\u2207", Nacute: "\u0143", nacute: "\u0144", nang: "\u2220\u20D2", nap: "\u2249", napE: "\u2A70\u0338", napid: "\u224B\u0338", napos: "\u0149", napprox: "\u2249", natur: "\u266E", natural: "\u266E", naturals: "\u2115", nbsp: "\xA0", nbump: "\u224E\u0338", nbumpe: "\u224F\u0338", ncap: "\u2A43", Ncaron: "\u0147", ncaron: "\u0148", Ncedil: "\u0145", ncedil: "\u0146", ncong: "\u2247", ncongdot: "\u2A6D\u0338", ncup: "\u2A42", Ncy: "\u041D", ncy: "\u043D", ndash: "\u2013", ne: "\u2260", nearhk: "\u2924", neArr: "\u21D7", nearr: "\u2197", nearrow: "\u2197", nedot: "\u2250\u0338", NegativeMediumSpace: "\u200B", NegativeThickSpace: "\u200B", NegativeThinSpace: "\u200B", NegativeVeryThinSpace: "\u200B", nequiv: "\u2262", nesear: "\u2928", nesim: "\u2242\u0338", NestedGreaterGreater: "\u226B", NestedLessLess: "\u226A", NewLine: `
`, nexist: "\u2204", nexists: "\u2204", Nfr: "\u{1D511}", nfr: "\u{1D52B}", ngE: "\u2267\u0338", nge: "\u2271", ngeq: "\u2271", ngeqq: "\u2267\u0338", ngeqslant: "\u2A7E\u0338", nges: "\u2A7E\u0338", nGg: "\u22D9\u0338", ngsim: "\u2275", nGt: "\u226B\u20D2", ngt: "\u226F", ngtr: "\u226F", nGtv: "\u226B\u0338", nhArr: "\u21CE", nharr: "\u21AE", nhpar: "\u2AF2", ni: "\u220B", nis: "\u22FC", nisd: "\u22FA", niv: "\u220B", NJcy: "\u040A", njcy: "\u045A", nlArr: "\u21CD", nlarr: "\u219A", nldr: "\u2025", nlE: "\u2266\u0338", nle: "\u2270", nLeftarrow: "\u21CD", nleftarrow: "\u219A", nLeftrightarrow: "\u21CE", nleftrightarrow: "\u21AE", nleq: "\u2270", nleqq: "\u2266\u0338", nleqslant: "\u2A7D\u0338", nles: "\u2A7D\u0338", nless: "\u226E", nLl: "\u22D8\u0338", nlsim: "\u2274", nLt: "\u226A\u20D2", nlt: "\u226E", nltri: "\u22EA", nltrie: "\u22EC", nLtv: "\u226A\u0338", nmid: "\u2224", NoBreak: "\u2060", NonBreakingSpace: "\xA0", Nopf: "\u2115", nopf: "\u{1D55F}", Not: "\u2AEC", not: "\xAC", NotCongruent: "\u2262", NotCupCap: "\u226D", NotDoubleVerticalBar: "\u2226", NotElement: "\u2209", NotEqual: "\u2260", NotEqualTilde: "\u2242\u0338", NotExists: "\u2204", NotGreater: "\u226F", NotGreaterEqual: "\u2271", NotGreaterFullEqual: "\u2267\u0338", NotGreaterGreater: "\u226B\u0338", NotGreaterLess: "\u2279", NotGreaterSlantEqual: "\u2A7E\u0338", NotGreaterTilde: "\u2275", NotHumpDownHump: "\u224E\u0338", NotHumpEqual: "\u224F\u0338", notin: "\u2209", notindot: "\u22F5\u0338", notinE: "\u22F9\u0338", notinva: "\u2209", notinvb: "\u22F7", notinvc: "\u22F6", NotLeftTriangle: "\u22EA", NotLeftTriangleBar: "\u29CF\u0338", NotLeftTriangleEqual: "\u22EC", NotLess: "\u226E", NotLessEqual: "\u2270", NotLessGreater: "\u2278", NotLessLess: "\u226A\u0338", NotLessSlantEqual: "\u2A7D\u0338", NotLessTilde: "\u2274", NotNestedGreaterGreater: "\u2AA2\u0338", NotNestedLessLess: "\u2AA1\u0338", notni: "\u220C", notniva: "\u220C", notnivb: "\u22FE", notnivc: "\u22FD", NotPrecedes: "\u2280", NotPrecedesEqual: "\u2AAF\u0338", NotPrecedesSlantEqual: "\u22E0", NotReverseElement: "\u220C", NotRightTriangle: "\u22EB", NotRightTriangleBar: "\u29D0\u0338", NotRightTriangleEqual: "\u22ED", NotSquareSubset: "\u228F\u0338", NotSquareSubsetEqual: "\u22E2", NotSquareSuperset: "\u2290\u0338", NotSquareSupersetEqual: "\u22E3", NotSubset: "\u2282\u20D2", NotSubsetEqual: "\u2288", NotSucceeds: "\u2281", NotSucceedsEqual: "\u2AB0\u0338", NotSucceedsSlantEqual: "\u22E1", NotSucceedsTilde: "\u227F\u0338", NotSuperset: "\u2283\u20D2", NotSupersetEqual: "\u2289", NotTilde: "\u2241", NotTildeEqual: "\u2244", NotTildeFullEqual: "\u2247", NotTildeTilde: "\u2249", NotVerticalBar: "\u2224", npar: "\u2226", nparallel: "\u2226", nparsl: "\u2AFD\u20E5", npart: "\u2202\u0338", npolint: "\u2A14", npr: "\u2280", nprcue: "\u22E0", npre: "\u2AAF\u0338", nprec: "\u2280", npreceq: "\u2AAF\u0338", nrArr: "\u21CF", nrarr: "\u219B", nrarrc: "\u2933\u0338", nrarrw: "\u219D\u0338", nRightarrow: "\u21CF", nrightarrow: "\u219B", nrtri: "\u22EB", nrtrie: "\u22ED", nsc: "\u2281", nsccue: "\u22E1", nsce: "\u2AB0\u0338", Nscr: "\u{1D4A9}", nscr: "\u{1D4C3}", nshortmid: "\u2224", nshortparallel: "\u2226", nsim: "\u2241", nsime: "\u2244", nsimeq: "\u2244", nsmid: "\u2224", nspar: "\u2226", nsqsube: "\u22E2", nsqsupe: "\u22E3", nsub: "\u2284", nsubE: "\u2AC5\u0338", nsube: "\u2288", nsubset: "\u2282\u20D2", nsubseteq: "\u2288", nsubseteqq: "\u2AC5\u0338", nsucc: "\u2281", nsucceq: "\u2AB0\u0338", nsup: "\u2285", nsupE: "\u2AC6\u0338", nsupe: "\u2289", nsupset: "\u2283\u20D2", nsupseteq: "\u2289", nsupseteqq: "\u2AC6\u0338", ntgl: "\u2279", Ntilde: "\xD1", ntilde: "\xF1", ntlg: "\u2278", ntriangleleft: "\u22EA", ntrianglelefteq: "\u22EC", ntriangleright: "\u22EB", ntrianglerighteq: "\u22ED", Nu: "\u039D", nu: "\u03BD", num: "#", numero: "\u2116", numsp: "\u2007", nvap: "\u224D\u20D2", nVDash: "\u22AF", nVdash: "\u22AE", nvDash: "\u22AD", nvdash: "\u22AC", nvge: "\u2265\u20D2", nvgt: ">\u20D2", nvHarr: "\u2904", nvinfin: "\u29DE", nvlArr: "\u2902", nvle: "\u2264\u20D2", nvlt: "<\u20D2", nvltrie: "\u22B4\u20D2", nvrArr: "\u2903", nvrtrie: "\u22B5\u20D2", nvsim: "\u223C\u20D2", nwarhk: "\u2923", nwArr: "\u21D6", nwarr: "\u2196", nwarrow: "\u2196", nwnear: "\u2927", Oacute: "\xD3", oacute: "\xF3", oast: "\u229B", ocir: "\u229A", Ocirc: "\xD4", ocirc: "\xF4", Ocy: "\u041E", ocy: "\u043E", odash: "\u229D", Odblac: "\u0150", odblac: "\u0151", odiv: "\u2A38", odot: "\u2299", odsold: "\u29BC", OElig: "\u0152", oelig: "\u0153", ofcir: "\u29BF", Ofr: "\u{1D512}", ofr: "\u{1D52C}", ogon: "\u02DB", Ograve: "\xD2", ograve: "\xF2", ogt: "\u29C1", ohbar: "\u29B5", ohm: "\u03A9", oint: "\u222E", olarr: "\u21BA", olcir: "\u29BE", olcross: "\u29BB", oline: "\u203E", olt: "\u29C0", Omacr: "\u014C", omacr: "\u014D", Omega: "\u03A9", omega: "\u03C9", Omicron: "\u039F", omicron: "\u03BF", omid: "\u29B6", ominus: "\u2296", Oopf: "\u{1D546}", oopf: "\u{1D560}", opar: "\u29B7", OpenCurlyDoubleQuote: "\u201C", OpenCurlyQuote: "\u2018", operp: "\u29B9", oplus: "\u2295", Or: "\u2A54", or: "\u2228", orarr: "\u21BB", ord: "\u2A5D", order: "\u2134", orderof: "\u2134", ordf: "\xAA", ordm: "\xBA", origof: "\u22B6", oror: "\u2A56", orslope: "\u2A57", orv: "\u2A5B", oS: "\u24C8", Oscr: "\u{1D4AA}", oscr: "\u2134", Oslash: "\xD8", oslash: "\xF8", osol: "\u2298", Otilde: "\xD5", otilde: "\xF5", Otimes: "\u2A37", otimes: "\u2297", otimesas: "\u2A36", Ouml: "\xD6", ouml: "\xF6", ovbar: "\u233D", OverBar: "\u203E", OverBrace: "\u23DE", OverBracket: "\u23B4", OverParenthesis: "\u23DC", par: "\u2225", para: "\xB6", parallel: "\u2225", parsim: "\u2AF3", parsl: "\u2AFD", part: "\u2202", PartialD: "\u2202", Pcy: "\u041F", pcy: "\u043F", percnt: "%", period: ".", permil: "\u2030", perp: "\u22A5", pertenk: "\u2031", Pfr: "\u{1D513}", pfr: "\u{1D52D}", Phi: "\u03A6", phi: "\u03C6", phiv: "\u03D5", phmmat: "\u2133", phone: "\u260E", Pi: "\u03A0", pi: "\u03C0", pitchfork: "\u22D4", piv: "\u03D6", planck: "\u210F", planckh: "\u210E", plankv: "\u210F", plus: "+", plusacir: "\u2A23", plusb: "\u229E", pluscir: "\u2A22", plusdo: "\u2214", plusdu: "\u2A25", pluse: "\u2A72", PlusMinus: "\xB1", plusmn: "\xB1", plussim: "\u2A26", plustwo: "\u2A27", pm: "\xB1", Poincareplane: "\u210C", pointint: "\u2A15", Popf: "\u2119", popf: "\u{1D561}", pound: "\xA3", Pr: "\u2ABB", pr: "\u227A", prap: "\u2AB7", prcue: "\u227C", prE: "\u2AB3", pre: "\u2AAF", prec: "\u227A", precapprox: "\u2AB7", preccurlyeq: "\u227C", Precedes: "\u227A", PrecedesEqual: "\u2AAF", PrecedesSlantEqual: "\u227C", PrecedesTilde: "\u227E", preceq: "\u2AAF", precnapprox: "\u2AB9", precneqq: "\u2AB5", precnsim: "\u22E8", precsim: "\u227E", Prime: "\u2033", prime: "\u2032", primes: "\u2119", prnap: "\u2AB9", prnE: "\u2AB5", prnsim: "\u22E8", prod: "\u220F", Product: "\u220F", profalar: "\u232E", profline: "\u2312", profsurf: "\u2313", prop: "\u221D", Proportion: "\u2237", Proportional: "\u221D", propto: "\u221D", prsim: "\u227E", prurel: "\u22B0", Pscr: "\u{1D4AB}", pscr: "\u{1D4C5}", Psi: "\u03A8", psi: "\u03C8", puncsp: "\u2008", Qfr: "\u{1D514}", qfr: "\u{1D52E}", qint: "\u2A0C", Qopf: "\u211A", qopf: "\u{1D562}", qprime: "\u2057", Qscr: "\u{1D4AC}", qscr: "\u{1D4C6}", quaternions: "\u210D", quatint: "\u2A16", quest: "?", questeq: "\u225F", QUOT: '"', quot: '"', rAarr: "\u21DB", race: "\u223D\u0331", Racute: "\u0154", racute: "\u0155", radic: "\u221A", raemptyv: "\u29B3", Rang: "\u27EB", rang: "\u27E9", rangd: "\u2992", range: "\u29A5", rangle: "\u27E9", raquo: "\xBB", Rarr: "\u21A0", rArr: "\u21D2", rarr: "\u2192", rarrap: "\u2975", rarrb: "\u21E5", rarrbfs: "\u2920", rarrc: "\u2933", rarrfs: "\u291E", rarrhk: "\u21AA", rarrlp: "\u21AC", rarrpl: "\u2945", rarrsim: "\u2974", Rarrtl: "\u2916", rarrtl: "\u21A3", rarrw: "\u219D", rAtail: "\u291C", ratail: "\u291A", ratio: "\u2236", rationals: "\u211A", RBarr: "\u2910", rBarr: "\u290F", rbarr: "\u290D", rbbrk: "\u2773", rbrace: "}", rbrack: "]", rbrke: "\u298C", rbrksld: "\u298E", rbrkslu: "\u2990", Rcaron: "\u0158", rcaron: "\u0159", Rcedil: "\u0156", rcedil: "\u0157", rceil: "\u2309", rcub: "}", Rcy: "\u0420", rcy: "\u0440", rdca: "\u2937", rdldhar: "\u2969", rdquo: "\u201D", rdquor: "\u201D", rdsh: "\u21B3", Re: "\u211C", real: "\u211C", realine: "\u211B", realpart: "\u211C", reals: "\u211D", rect: "\u25AD", REG: "\xAE", reg: "\xAE", ReverseElement: "\u220B", ReverseEquilibrium: "\u21CB", ReverseUpEquilibrium: "\u296F", rfisht: "\u297D", rfloor: "\u230B", Rfr: "\u211C", rfr: "\u{1D52F}", rHar: "\u2964", rhard: "\u21C1", rharu: "\u21C0", rharul: "\u296C", Rho: "\u03A1", rho: "\u03C1", rhov: "\u03F1", RightAngleBracket: "\u27E9", RightArrow: "\u2192", Rightarrow: "\u21D2", rightarrow: "\u2192", RightArrowBar: "\u21E5", RightArrowLeftArrow: "\u21C4", rightarrowtail: "\u21A3", RightCeiling: "\u2309", RightDoubleBracket: "\u27E7", RightDownTeeVector: "\u295D", RightDownVector: "\u21C2", RightDownVectorBar: "\u2955", RightFloor: "\u230B", rightharpoondown: "\u21C1", rightharpoonup: "\u21C0", rightleftarrows: "\u21C4", rightleftharpoons: "\u21CC", rightrightarrows: "\u21C9", rightsquigarrow: "\u219D", RightTee: "\u22A2", RightTeeArrow: "\u21A6", RightTeeVector: "\u295B", rightthreetimes: "\u22CC", RightTriangle: "\u22B3", RightTriangleBar: "\u29D0", RightTriangleEqual: "\u22B5", RightUpDownVector: "\u294F", RightUpTeeVector: "\u295C", RightUpVector: "\u21BE", RightUpVectorBar: "\u2954", RightVector: "\u21C0", RightVectorBar: "\u2953", ring: "\u02DA", risingdotseq: "\u2253", rlarr: "\u21C4", rlhar: "\u21CC", rlm: "\u200F", rmoust: "\u23B1", rmoustache: "\u23B1", rnmid: "\u2AEE", roang: "\u27ED", roarr: "\u21FE", robrk: "\u27E7", ropar: "\u2986", Ropf: "\u211D", ropf: "\u{1D563}", roplus: "\u2A2E", rotimes: "\u2A35", RoundImplies: "\u2970", rpar: ")", rpargt: "\u2994", rppolint: "\u2A12", rrarr: "\u21C9", Rrightarrow: "\u21DB", rsaquo: "\u203A", Rscr: "\u211B", rscr: "\u{1D4C7}", Rsh: "\u21B1", rsh: "\u21B1", rsqb: "]", rsquo: "\u2019", rsquor: "\u2019", rthree: "\u22CC", rtimes: "\u22CA", rtri: "\u25B9", rtrie: "\u22B5", rtrif: "\u25B8", rtriltri: "\u29CE", RuleDelayed: "\u29F4", ruluhar: "\u2968", rx: "\u211E", Sacute: "\u015A", sacute: "\u015B", sbquo: "\u201A", Sc: "\u2ABC", sc: "\u227B", scap: "\u2AB8", Scaron: "\u0160", scaron: "\u0161", sccue: "\u227D", scE: "\u2AB4", sce: "\u2AB0", Scedil: "\u015E", scedil: "\u015F", Scirc: "\u015C", scirc: "\u015D", scnap: "\u2ABA", scnE: "\u2AB6", scnsim: "\u22E9", scpolint: "\u2A13", scsim: "\u227F", Scy: "\u0421", scy: "\u0441", sdot: "\u22C5", sdotb: "\u22A1", sdote: "\u2A66", searhk: "\u2925", seArr: "\u21D8", searr: "\u2198", searrow: "\u2198", sect: "\xA7", semi: ";", seswar: "\u2929", setminus: "\u2216", setmn: "\u2216", sext: "\u2736", Sfr: "\u{1D516}", sfr: "\u{1D530}", sfrown: "\u2322", sharp: "\u266F", SHCHcy: "\u0429", shchcy: "\u0449", SHcy: "\u0428", shcy: "\u0448", ShortDownArrow: "\u2193", ShortLeftArrow: "\u2190", shortmid: "\u2223", shortparallel: "\u2225", ShortRightArrow: "\u2192", ShortUpArrow: "\u2191", shy: "\xAD", Sigma: "\u03A3", sigma: "\u03C3", sigmaf: "\u03C2", sigmav: "\u03C2", sim: "\u223C", simdot: "\u2A6A", sime: "\u2243", simeq: "\u2243", simg: "\u2A9E", simgE: "\u2AA0", siml: "\u2A9D", simlE: "\u2A9F", simne: "\u2246", simplus: "\u2A24", simrarr: "\u2972", slarr: "\u2190", SmallCircle: "\u2218", smallsetminus: "\u2216", smashp: "\u2A33", smeparsl: "\u29E4", smid: "\u2223", smile: "\u2323", smt: "\u2AAA", smte: "\u2AAC", smtes: "\u2AAC\uFE00", SOFTcy: "\u042C", softcy: "\u044C", sol: "/", solb: "\u29C4", solbar: "\u233F", Sopf: "\u{1D54A}", sopf: "\u{1D564}", spades: "\u2660", spadesuit: "\u2660", spar: "\u2225", sqcap: "\u2293", sqcaps: "\u2293\uFE00", sqcup: "\u2294", sqcups: "\u2294\uFE00", Sqrt: "\u221A", sqsub: "\u228F", sqsube: "\u2291", sqsubset: "\u228F", sqsubseteq: "\u2291", sqsup: "\u2290", sqsupe: "\u2292", sqsupset: "\u2290", sqsupseteq: "\u2292", squ: "\u25A1", Square: "\u25A1", square: "\u25A1", SquareIntersection: "\u2293", SquareSubset: "\u228F", SquareSubsetEqual: "\u2291", SquareSuperset: "\u2290", SquareSupersetEqual: "\u2292", SquareUnion: "\u2294", squarf: "\u25AA", squf: "\u25AA", srarr: "\u2192", Sscr: "\u{1D4AE}", sscr: "\u{1D4C8}", ssetmn: "\u2216", ssmile: "\u2323", sstarf: "\u22C6", Star: "\u22C6", star: "\u2606", starf: "\u2605", straightepsilon: "\u03F5", straightphi: "\u03D5", strns: "\xAF", Sub: "\u22D0", sub: "\u2282", subdot: "\u2ABD", subE: "\u2AC5", sube: "\u2286", subedot: "\u2AC3", submult: "\u2AC1", subnE: "\u2ACB", subne: "\u228A", subplus: "\u2ABF", subrarr: "\u2979", Subset: "\u22D0", subset: "\u2282", subseteq: "\u2286", subseteqq: "\u2AC5", SubsetEqual: "\u2286", subsetneq: "\u228A", subsetneqq: "\u2ACB", subsim: "\u2AC7", subsub: "\u2AD5", subsup: "\u2AD3", succ: "\u227B", succapprox: "\u2AB8", succcurlyeq: "\u227D", Succeeds: "\u227B", SucceedsEqual: "\u2AB0", SucceedsSlantEqual: "\u227D", SucceedsTilde: "\u227F", succeq: "\u2AB0", succnapprox: "\u2ABA", succneqq: "\u2AB6", succnsim: "\u22E9", succsim: "\u227F", SuchThat: "\u220B", Sum: "\u2211", sum: "\u2211", sung: "\u266A", Sup: "\u22D1", sup: "\u2283", sup1: "\xB9", sup2: "\xB2", sup3: "\xB3", supdot: "\u2ABE", supdsub: "\u2AD8", supE: "\u2AC6", supe: "\u2287", supedot: "\u2AC4", Superset: "\u2283", SupersetEqual: "\u2287", suphsol: "\u27C9", suphsub: "\u2AD7", suplarr: "\u297B", supmult: "\u2AC2", supnE: "\u2ACC", supne: "\u228B", supplus: "\u2AC0", Supset: "\u22D1", supset: "\u2283", supseteq: "\u2287", supseteqq: "\u2AC6", supsetneq: "\u228B", supsetneqq: "\u2ACC", supsim: "\u2AC8", supsub: "\u2AD4", supsup: "\u2AD6", swarhk: "\u2926", swArr: "\u21D9", swarr: "\u2199", swarrow: "\u2199", swnwar: "\u292A", szlig: "\xDF", Tab: "	", target: "\u2316", Tau: "\u03A4", tau: "\u03C4", tbrk: "\u23B4", Tcaron: "\u0164", tcaron: "\u0165", Tcedil: "\u0162", tcedil: "\u0163", Tcy: "\u0422", tcy: "\u0442", tdot: "\u20DB", telrec: "\u2315", Tfr: "\u{1D517}", tfr: "\u{1D531}", there4: "\u2234", Therefore: "\u2234", therefore: "\u2234", Theta: "\u0398", theta: "\u03B8", thetasym: "\u03D1", thetav: "\u03D1", thickapprox: "\u2248", thicksim: "\u223C", ThickSpace: "\u205F\u200A", thinsp: "\u2009", ThinSpace: "\u2009", thkap: "\u2248", thksim: "\u223C", THORN: "\xDE", thorn: "\xFE", Tilde: "\u223C", tilde: "\u02DC", TildeEqual: "\u2243", TildeFullEqual: "\u2245", TildeTilde: "\u2248", times: "\xD7", timesb: "\u22A0", timesbar: "\u2A31", timesd: "\u2A30", tint: "\u222D", toea: "\u2928", top: "\u22A4", topbot: "\u2336", topcir: "\u2AF1", Topf: "\u{1D54B}", topf: "\u{1D565}", topfork: "\u2ADA", tosa: "\u2929", tprime: "\u2034", TRADE: "\u2122", trade: "\u2122", triangle: "\u25B5", triangledown: "\u25BF", triangleleft: "\u25C3", trianglelefteq: "\u22B4", triangleq: "\u225C", triangleright: "\u25B9", trianglerighteq: "\u22B5", tridot: "\u25EC", trie: "\u225C", triminus: "\u2A3A", TripleDot: "\u20DB", triplus: "\u2A39", trisb: "\u29CD", tritime: "\u2A3B", trpezium: "\u23E2", Tscr: "\u{1D4AF}", tscr: "\u{1D4C9}", TScy: "\u0426", tscy: "\u0446", TSHcy: "\u040B", tshcy: "\u045B", Tstrok: "\u0166", tstrok: "\u0167", twixt: "\u226C", twoheadleftarrow: "\u219E", twoheadrightarrow: "\u21A0", Uacute: "\xDA", uacute: "\xFA", Uarr: "\u219F", uArr: "\u21D1", uarr: "\u2191", Uarrocir: "\u2949", Ubrcy: "\u040E", ubrcy: "\u045E", Ubreve: "\u016C", ubreve: "\u016D", Ucirc: "\xDB", ucirc: "\xFB", Ucy: "\u0423", ucy: "\u0443", udarr: "\u21C5", Udblac: "\u0170", udblac: "\u0171", udhar: "\u296E", ufisht: "\u297E", Ufr: "\u{1D518}", ufr: "\u{1D532}", Ugrave: "\xD9", ugrave: "\xF9", uHar: "\u2963", uharl: "\u21BF", uharr: "\u21BE", uhblk: "\u2580", ulcorn: "\u231C", ulcorner: "\u231C", ulcrop: "\u230F", ultri: "\u25F8", Umacr: "\u016A", umacr: "\u016B", uml: "\xA8", UnderBar: "_", UnderBrace: "\u23DF", UnderBracket: "\u23B5", UnderParenthesis: "\u23DD", Union: "\u22C3", UnionPlus: "\u228E", Uogon: "\u0172", uogon: "\u0173", Uopf: "\u{1D54C}", uopf: "\u{1D566}", UpArrow: "\u2191", Uparrow: "\u21D1", uparrow: "\u2191", UpArrowBar: "\u2912", UpArrowDownArrow: "\u21C5", UpDownArrow: "\u2195", Updownarrow: "\u21D5", updownarrow: "\u2195", UpEquilibrium: "\u296E", upharpoonleft: "\u21BF", upharpoonright: "\u21BE", uplus: "\u228E", UpperLeftArrow: "\u2196", UpperRightArrow: "\u2197", Upsi: "\u03D2", upsi: "\u03C5", upsih: "\u03D2", Upsilon: "\u03A5", upsilon: "\u03C5", UpTee: "\u22A5", UpTeeArrow: "\u21A5", upuparrows: "\u21C8", urcorn: "\u231D", urcorner: "\u231D", urcrop: "\u230E", Uring: "\u016E", uring: "\u016F", urtri: "\u25F9", Uscr: "\u{1D4B0}", uscr: "\u{1D4CA}", utdot: "\u22F0", Utilde: "\u0168", utilde: "\u0169", utri: "\u25B5", utrif: "\u25B4", uuarr: "\u21C8", Uuml: "\xDC", uuml: "\xFC", uwangle: "\u29A7", vangrt: "\u299C", varepsilon: "\u03F5", varkappa: "\u03F0", varnothing: "\u2205", varphi: "\u03D5", varpi: "\u03D6", varpropto: "\u221D", vArr: "\u21D5", varr: "\u2195", varrho: "\u03F1", varsigma: "\u03C2", varsubsetneq: "\u228A\uFE00", varsubsetneqq: "\u2ACB\uFE00", varsupsetneq: "\u228B\uFE00", varsupsetneqq: "\u2ACC\uFE00", vartheta: "\u03D1", vartriangleleft: "\u22B2", vartriangleright: "\u22B3", Vbar: "\u2AEB", vBar: "\u2AE8", vBarv: "\u2AE9", Vcy: "\u0412", vcy: "\u0432", VDash: "\u22AB", Vdash: "\u22A9", vDash: "\u22A8", vdash: "\u22A2", Vdashl: "\u2AE6", Vee: "\u22C1", vee: "\u2228", veebar: "\u22BB", veeeq: "\u225A", vellip: "\u22EE", Verbar: "\u2016", verbar: "|", Vert: "\u2016", vert: "|", VerticalBar: "\u2223", VerticalLine: "|", VerticalSeparator: "\u2758", VerticalTilde: "\u2240", VeryThinSpace: "\u200A", Vfr: "\u{1D519}", vfr: "\u{1D533}", vltri: "\u22B2", vnsub: "\u2282\u20D2", vnsup: "\u2283\u20D2", Vopf: "\u{1D54D}", vopf: "\u{1D567}", vprop: "\u221D", vrtri: "\u22B3", Vscr: "\u{1D4B1}", vscr: "\u{1D4CB}", vsubnE: "\u2ACB\uFE00", vsubne: "\u228A\uFE00", vsupnE: "\u2ACC\uFE00", vsupne: "\u228B\uFE00", Vvdash: "\u22AA", vzigzag: "\u299A", Wcirc: "\u0174", wcirc: "\u0175", wedbar: "\u2A5F", Wedge: "\u22C0", wedge: "\u2227", wedgeq: "\u2259", weierp: "\u2118", Wfr: "\u{1D51A}", wfr: "\u{1D534}", Wopf: "\u{1D54E}", wopf: "\u{1D568}", wp: "\u2118", wr: "\u2240", wreath: "\u2240", Wscr: "\u{1D4B2}", wscr: "\u{1D4CC}", xcap: "\u22C2", xcirc: "\u25EF", xcup: "\u22C3", xdtri: "\u25BD", Xfr: "\u{1D51B}", xfr: "\u{1D535}", xhArr: "\u27FA", xharr: "\u27F7", Xi: "\u039E", xi: "\u03BE", xlArr: "\u27F8", xlarr: "\u27F5", xmap: "\u27FC", xnis: "\u22FB", xodot: "\u2A00", Xopf: "\u{1D54F}", xopf: "\u{1D569}", xoplus: "\u2A01", xotime: "\u2A02", xrArr: "\u27F9", xrarr: "\u27F6", Xscr: "\u{1D4B3}", xscr: "\u{1D4CD}", xsqcup: "\u2A06", xuplus: "\u2A04", xutri: "\u25B3", xvee: "\u22C1", xwedge: "\u22C0", Yacute: "\xDD", yacute: "\xFD", YAcy: "\u042F", yacy: "\u044F", Ycirc: "\u0176", ycirc: "\u0177", Ycy: "\u042B", ycy: "\u044B", yen: "\xA5", Yfr: "\u{1D51C}", yfr: "\u{1D536}", YIcy: "\u0407", yicy: "\u0457", Yopf: "\u{1D550}", yopf: "\u{1D56A}", Yscr: "\u{1D4B4}", yscr: "\u{1D4CE}", YUcy: "\u042E", yucy: "\u044E", Yuml: "\u0178", yuml: "\xFF", Zacute: "\u0179", zacute: "\u017A", Zcaron: "\u017D", zcaron: "\u017E", Zcy: "\u0417", zcy: "\u0437", Zdot: "\u017B", zdot: "\u017C", zeetrf: "\u2128", ZeroWidthSpace: "\u200B", Zeta: "\u0396", zeta: "\u03B6", Zfr: "\u2128", zfr: "\u{1D537}", ZHcy: "\u0416", zhcy: "\u0436", zigrarr: "\u21DD", Zopf: "\u2124", zopf: "\u{1D56B}", Zscr: "\u{1D4B5}", zscr: "\u{1D4CF}", zwj: "\u200D", zwnj: "\u200C" }, e.NGSP_UNICODE = "\uE500", e.NAMED_ENTITIES.ngsp = e.NGSP_UNICODE;
          } }), Bs = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/html_tags.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Ze(), u = class {
              constructor() {
                let { closedByChildren: i, implicitNamespacePrefix: f, contentType: c = r.TagContentType.PARSABLE_DATA, closedByParent: F = false, isVoid: a = false, ignoreFirstLf: l = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.closedByChildren = {}, this.closedByParent = false, this.canSelfClose = false, i && i.length > 0 && i.forEach((h) => this.closedByChildren[h] = true), this.isVoid = a, this.closedByParent = F || a, this.implicitNamespacePrefix = f || null, this.contentType = c, this.ignoreFirstLf = l;
              }
              isClosedByChild(i) {
                return this.isVoid || i.toLowerCase() in this.closedByChildren;
              }
            };
            e.HtmlTagDefinition = u;
            var n, D;
            function s(i) {
              return D || (n = new u(), D = { base: new u({ isVoid: true }), meta: new u({ isVoid: true }), area: new u({ isVoid: true }), embed: new u({ isVoid: true }), link: new u({ isVoid: true }), img: new u({ isVoid: true }), input: new u({ isVoid: true }), param: new u({ isVoid: true }), hr: new u({ isVoid: true }), br: new u({ isVoid: true }), source: new u({ isVoid: true }), track: new u({ isVoid: true }), wbr: new u({ isVoid: true }), p: new u({ closedByChildren: ["address", "article", "aside", "blockquote", "div", "dl", "fieldset", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "main", "nav", "ol", "p", "pre", "section", "table", "ul"], closedByParent: true }), thead: new u({ closedByChildren: ["tbody", "tfoot"] }), tbody: new u({ closedByChildren: ["tbody", "tfoot"], closedByParent: true }), tfoot: new u({ closedByChildren: ["tbody"], closedByParent: true }), tr: new u({ closedByChildren: ["tr"], closedByParent: true }), td: new u({ closedByChildren: ["td", "th"], closedByParent: true }), th: new u({ closedByChildren: ["td", "th"], closedByParent: true }), col: new u({ isVoid: true }), svg: new u({ implicitNamespacePrefix: "svg" }), math: new u({ implicitNamespacePrefix: "math" }), li: new u({ closedByChildren: ["li"], closedByParent: true }), dt: new u({ closedByChildren: ["dt", "dd"] }), dd: new u({ closedByChildren: ["dt", "dd"], closedByParent: true }), rb: new u({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: true }), rt: new u({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: true }), rtc: new u({ closedByChildren: ["rb", "rtc", "rp"], closedByParent: true }), rp: new u({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: true }), optgroup: new u({ closedByChildren: ["optgroup"], closedByParent: true }), option: new u({ closedByChildren: ["option", "optgroup"], closedByParent: true }), pre: new u({ ignoreFirstLf: true }), listing: new u({ ignoreFirstLf: true }), style: new u({ contentType: r.TagContentType.RAW_TEXT }), script: new u({ contentType: r.TagContentType.RAW_TEXT }), title: new u({ contentType: r.TagContentType.ESCAPABLE_RAW_TEXT }), textarea: new u({ contentType: r.TagContentType.ESCAPABLE_RAW_TEXT, ignoreFirstLf: true }) }), D[i] || n;
            }
            e.getHtmlTagDefinition = s;
          } }), Hl = I({ "node_modules/angular-html-parser/lib/compiler/src/ast_path.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = class {
              constructor(u) {
                let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
                this.path = u, this.position = n;
              }
              get empty() {
                return !this.path || !this.path.length;
              }
              get head() {
                return this.path[0];
              }
              get tail() {
                return this.path[this.path.length - 1];
              }
              parentOf(u) {
                return u && this.path[this.path.indexOf(u) - 1];
              }
              childOf(u) {
                return this.path[this.path.indexOf(u) + 1];
              }
              first(u) {
                for (let n = this.path.length - 1; n >= 0; n--) {
                  let D = this.path[n];
                  if (D instanceof u)
                    return D;
                }
              }
              push(u) {
                this.path.push(u);
              }
              pop() {
                return this.path.pop();
              }
            };
            e.AstPath = r;
          } }), bs = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/ast.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Hl(), u = class {
              constructor(d, m, T) {
                this.value = d, this.sourceSpan = m, this.i18n = T, this.type = "text";
              }
              visit(d, m) {
                return d.visitText(this, m);
              }
            };
            e.Text = u;
            var n = class {
              constructor(d, m) {
                this.value = d, this.sourceSpan = m, this.type = "cdata";
              }
              visit(d, m) {
                return d.visitCdata(this, m);
              }
            };
            e.CDATA = n;
            var D = class {
              constructor(d, m, T, w, g, N) {
                this.switchValue = d, this.type = m, this.cases = T, this.sourceSpan = w, this.switchValueSourceSpan = g, this.i18n = N;
              }
              visit(d, m) {
                return d.visitExpansion(this, m);
              }
            };
            e.Expansion = D;
            var s = class {
              constructor(d, m, T, w, g) {
                this.value = d, this.expression = m, this.sourceSpan = T, this.valueSourceSpan = w, this.expSourceSpan = g;
              }
              visit(d, m) {
                return d.visitExpansionCase(this, m);
              }
            };
            e.ExpansionCase = s;
            var i = class {
              constructor(d, m, T) {
                let w = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, g = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, N = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
                this.name = d, this.value = m, this.sourceSpan = T, this.valueSpan = w, this.nameSpan = g, this.i18n = N, this.type = "attribute";
              }
              visit(d, m) {
                return d.visitAttribute(this, m);
              }
            };
            e.Attribute = i;
            var f = class {
              constructor(d, m, T, w) {
                let g = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, N = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, R = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, j = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
                this.name = d, this.attrs = m, this.children = T, this.sourceSpan = w, this.startSourceSpan = g, this.endSourceSpan = N, this.nameSpan = R, this.i18n = j, this.type = "element";
              }
              visit(d, m) {
                return d.visitElement(this, m);
              }
            };
            e.Element = f;
            var c = class {
              constructor(d, m) {
                this.value = d, this.sourceSpan = m, this.type = "comment";
              }
              visit(d, m) {
                return d.visitComment(this, m);
              }
            };
            e.Comment = c;
            var F = class {
              constructor(d, m) {
                this.value = d, this.sourceSpan = m, this.type = "docType";
              }
              visit(d, m) {
                return d.visitDocType(this, m);
              }
            };
            e.DocType = F;
            function a(d, m) {
              let T = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, w = [], g = d.visit ? (N) => d.visit(N, T) || N.visit(d, T) : (N) => N.visit(d, T);
              return m.forEach((N) => {
                let R = g(N);
                R && w.push(R);
              }), w;
            }
            e.visitAll = a;
            var l = class {
              constructor() {
              }
              visitElement(d, m) {
                this.visitChildren(m, (T) => {
                  T(d.attrs), T(d.children);
                });
              }
              visitAttribute(d, m) {
              }
              visitText(d, m) {
              }
              visitCdata(d, m) {
              }
              visitComment(d, m) {
              }
              visitDocType(d, m) {
              }
              visitExpansion(d, m) {
                return this.visitChildren(m, (T) => {
                  T(d.cases);
                });
              }
              visitExpansionCase(d, m) {
              }
              visitChildren(d, m) {
                let T = [], w = this;
                function g(N) {
                  N && T.push(a(w, N, d));
                }
                return m(g), Array.prototype.concat.apply([], T);
              }
            };
            e.RecursiveVisitor = l;
            function h(d) {
              let m = d.sourceSpan.start.offset, T = d.sourceSpan.end.offset;
              return d instanceof f && (d.endSourceSpan ? T = d.endSourceSpan.end.offset : d.children && d.children.length && (T = h(d.children[d.children.length - 1]).end)), { start: m, end: T };
            }
            function C(d, m) {
              let T = [], w = new class extends l {
                visit(g, N) {
                  let R = h(g);
                  if (R.start <= m && m < R.end)
                    T.push(g);
                  else
                    return true;
                }
              }();
              return a(w, d), new r.AstPath(T, m);
            }
            e.findNode = C;
          } }), zl = I({ "node_modules/angular-html-parser/lib/compiler/src/assertions.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            function r(D, s) {
              if (s != null) {
                if (!Array.isArray(s))
                  throw new Error(`Expected '${D}' to be an array of strings.`);
                for (let i = 0; i < s.length; i += 1)
                  if (typeof s[i] != "string")
                    throw new Error(`Expected '${D}' to be an array of strings.`);
              }
            }
            e.assertArrayOfStrings = r;
            var u = [/^\s*$/, /[<>]/, /^[{}]$/, /&(#|[a-z])/i, /^\/\//];
            function n(D, s) {
              if (s != null && !(Array.isArray(s) && s.length == 2))
                throw new Error(`Expected '${D}' to be an array, [start, end].`);
              if (s != null) {
                let i = s[0], f = s[1];
                u.forEach((c) => {
                  if (c.test(i) || c.test(f))
                    throw new Error(`['${i}', '${f}'] contains unusable interpolation symbol.`);
                });
              }
            }
            e.assertInterpolationSymbols = n;
          } }), Wl = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/interpolation_config.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = zl(), u = class {
              constructor(n, D) {
                this.start = n, this.end = D;
              }
              static fromArray(n) {
                return n ? (r.assertInterpolationSymbols("interpolation", n), new u(n[0], n[1])) : e.DEFAULT_INTERPOLATION_CONFIG;
              }
            };
            e.InterpolationConfig = u, e.DEFAULT_INTERPOLATION_CONFIG = new u("{{", "}}");
          } }), Yl = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/lexer.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Es(), u = Be(), n = Wl(), D = Ze(), s;
            (function(t3) {
              t3[t3.TAG_OPEN_START = 0] = "TAG_OPEN_START", t3[t3.TAG_OPEN_END = 1] = "TAG_OPEN_END", t3[t3.TAG_OPEN_END_VOID = 2] = "TAG_OPEN_END_VOID", t3[t3.TAG_CLOSE = 3] = "TAG_CLOSE", t3[t3.TEXT = 4] = "TEXT", t3[t3.ESCAPABLE_RAW_TEXT = 5] = "ESCAPABLE_RAW_TEXT", t3[t3.RAW_TEXT = 6] = "RAW_TEXT", t3[t3.COMMENT_START = 7] = "COMMENT_START", t3[t3.COMMENT_END = 8] = "COMMENT_END", t3[t3.CDATA_START = 9] = "CDATA_START", t3[t3.CDATA_END = 10] = "CDATA_END", t3[t3.ATTR_NAME = 11] = "ATTR_NAME", t3[t3.ATTR_QUOTE = 12] = "ATTR_QUOTE", t3[t3.ATTR_VALUE = 13] = "ATTR_VALUE", t3[t3.DOC_TYPE_START = 14] = "DOC_TYPE_START", t3[t3.DOC_TYPE_END = 15] = "DOC_TYPE_END", t3[t3.EXPANSION_FORM_START = 16] = "EXPANSION_FORM_START", t3[t3.EXPANSION_CASE_VALUE = 17] = "EXPANSION_CASE_VALUE", t3[t3.EXPANSION_CASE_EXP_START = 18] = "EXPANSION_CASE_EXP_START", t3[t3.EXPANSION_CASE_EXP_END = 19] = "EXPANSION_CASE_EXP_END", t3[t3.EXPANSION_FORM_END = 20] = "EXPANSION_FORM_END", t3[t3.EOF = 21] = "EOF";
            })(s = e.TokenType || (e.TokenType = {}));
            var i = class {
              constructor(t3, o, E) {
                this.type = t3, this.parts = o, this.sourceSpan = E;
              }
            };
            e.Token = i;
            var f = class extends u.ParseError {
              constructor(t3, o, E) {
                super(E, t3), this.tokenType = o;
              }
            };
            e.TokenError = f;
            var c = class {
              constructor(t3, o) {
                this.tokens = t3, this.errors = o;
              }
            };
            e.TokenizeResult = c;
            function F(t3, o, E) {
              let p = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
              return new d(new u.ParseSourceFile(t3, o), E, p).tokenize();
            }
            e.tokenize = F;
            var a = /\r\n?/g;
            function l(t3) {
              return `Unexpected character "${t3 === r.$EOF ? "EOF" : String.fromCharCode(t3)}"`;
            }
            function h(t3) {
              return `Unknown entity "${t3}" - use the "&#<decimal>;" or  "&#x<hex>;" syntax`;
            }
            var C = class {
              constructor(t3) {
                this.error = t3;
              }
            }, d = class {
              constructor(t3, o, E) {
                this._getTagContentType = o, this._currentTokenStart = null, this._currentTokenType = null, this._expansionCaseStack = [], this._inInterpolation = false, this._fullNameStack = [], this.tokens = [], this.errors = [], this._tokenizeIcu = E.tokenizeExpansionForms || false, this._interpolationConfig = E.interpolationConfig || n.DEFAULT_INTERPOLATION_CONFIG, this._leadingTriviaCodePoints = E.leadingTriviaChars && E.leadingTriviaChars.map((A) => A.codePointAt(0) || 0), this._canSelfClose = E.canSelfClose || false, this._allowHtmComponentClosingTags = E.allowHtmComponentClosingTags || false;
                let p = E.range || { endPos: t3.content.length, startPos: 0, startLine: 0, startCol: 0 };
                this._cursor = E.escapedString ? new k(t3, p) : new x(t3, p);
                try {
                  this._cursor.init();
                } catch (A) {
                  this.handleError(A);
                }
              }
              _processCarriageReturns(t3) {
                return t3.replace(a, `
`);
              }
              tokenize() {
                for (; this._cursor.peek() !== r.$EOF; ) {
                  let t3 = this._cursor.clone();
                  try {
                    if (this._attemptCharCode(r.$LT))
                      if (this._attemptCharCode(r.$BANG))
                        this._attemptStr("[CDATA[") ? this._consumeCdata(t3) : this._attemptStr("--") ? this._consumeComment(t3) : this._attemptStrCaseInsensitive("doctype") ? this._consumeDocType(t3) : this._consumeBogusComment(t3);
                      else if (this._attemptCharCode(r.$SLASH))
                        this._consumeTagClose(t3);
                      else {
                        let o = this._cursor.clone();
                        this._attemptCharCode(r.$QUESTION) ? (this._cursor = o, this._consumeBogusComment(t3)) : this._consumeTagOpen(t3);
                      }
                    else
                      this._tokenizeIcu && this._tokenizeExpansionForm() || this._consumeText();
                  } catch (o) {
                    this.handleError(o);
                  }
                }
                return this._beginToken(s.EOF), this._endToken([]), new c(O(this.tokens), this.errors);
              }
              _tokenizeExpansionForm() {
                if (this.isExpansionFormStart())
                  return this._consumeExpansionFormStart(), true;
                if (R(this._cursor.peek()) && this._isInExpansionForm())
                  return this._consumeExpansionCaseStart(), true;
                if (this._cursor.peek() === r.$RBRACE) {
                  if (this._isInExpansionCase())
                    return this._consumeExpansionCaseEnd(), true;
                  if (this._isInExpansionForm())
                    return this._consumeExpansionFormEnd(), true;
                }
                return false;
              }
              _beginToken(t3) {
                let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._cursor.clone();
                this._currentTokenStart = o, this._currentTokenType = t3;
              }
              _endToken(t3) {
                let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._cursor.clone();
                if (this._currentTokenStart === null)
                  throw new f("Programming error - attempted to end a token when there was no start to the token", this._currentTokenType, this._cursor.getSpan(o));
                if (this._currentTokenType === null)
                  throw new f("Programming error - attempted to end a token which has no token type", null, this._cursor.getSpan(this._currentTokenStart));
                let E = new i(this._currentTokenType, t3, this._cursor.getSpan(this._currentTokenStart, this._leadingTriviaCodePoints));
                return this.tokens.push(E), this._currentTokenStart = null, this._currentTokenType = null, E;
              }
              _createError(t3, o) {
                this._isInExpansionForm() && (t3 += ` (Do you have an unescaped "{" in your template? Use "{{ '{' }}") to escape it.)`);
                let E = new f(t3, this._currentTokenType, o);
                return this._currentTokenStart = null, this._currentTokenType = null, new C(E);
              }
              handleError(t3) {
                if (t3 instanceof $ && (t3 = this._createError(t3.msg, this._cursor.getSpan(t3.cursor))), t3 instanceof C)
                  this.errors.push(t3.error);
                else
                  throw t3;
              }
              _attemptCharCode(t3) {
                return this._cursor.peek() === t3 ? (this._cursor.advance(), true) : false;
              }
              _attemptCharCodeCaseInsensitive(t3) {
                return j(this._cursor.peek(), t3) ? (this._cursor.advance(), true) : false;
              }
              _requireCharCode(t3) {
                let o = this._cursor.clone();
                if (!this._attemptCharCode(t3))
                  throw this._createError(l(this._cursor.peek()), this._cursor.getSpan(o));
              }
              _attemptStr(t3) {
                let o = t3.length;
                if (this._cursor.charsLeft() < o)
                  return false;
                let E = this._cursor.clone();
                for (let p = 0; p < o; p++)
                  if (!this._attemptCharCode(t3.charCodeAt(p)))
                    return this._cursor = E, false;
                return true;
              }
              _attemptStrCaseInsensitive(t3) {
                for (let o = 0; o < t3.length; o++)
                  if (!this._attemptCharCodeCaseInsensitive(t3.charCodeAt(o)))
                    return false;
                return true;
              }
              _requireStr(t3) {
                let o = this._cursor.clone();
                if (!this._attemptStr(t3))
                  throw this._createError(l(this._cursor.peek()), this._cursor.getSpan(o));
              }
              _requireStrCaseInsensitive(t3) {
                let o = this._cursor.clone();
                if (!this._attemptStrCaseInsensitive(t3))
                  throw this._createError(l(this._cursor.peek()), this._cursor.getSpan(o));
              }
              _attemptCharCodeUntilFn(t3) {
                for (; !t3(this._cursor.peek()); )
                  this._cursor.advance();
              }
              _requireCharCodeUntilFn(t3, o) {
                let E = this._cursor.clone();
                if (this._attemptCharCodeUntilFn(t3), this._cursor.clone().diff(E) < o)
                  throw this._createError(l(this._cursor.peek()), this._cursor.getSpan(E));
              }
              _attemptUntilChar(t3) {
                for (; this._cursor.peek() !== t3; )
                  this._cursor.advance();
              }
              _readChar(t3) {
                if (t3 && this._cursor.peek() === r.$AMPERSAND)
                  return this._decodeEntity();
                {
                  let o = String.fromCodePoint(this._cursor.peek());
                  return this._cursor.advance(), o;
                }
              }
              _decodeEntity() {
                let t3 = this._cursor.clone();
                if (this._cursor.advance(), this._attemptCharCode(r.$HASH)) {
                  let o = this._attemptCharCode(r.$x) || this._attemptCharCode(r.$X), E = this._cursor.clone();
                  if (this._attemptCharCodeUntilFn(g), this._cursor.peek() != r.$SEMICOLON)
                    throw this._createError(l(this._cursor.peek()), this._cursor.getSpan());
                  let p = this._cursor.getChars(E);
                  this._cursor.advance();
                  try {
                    let A = parseInt(p, o ? 16 : 10);
                    return String.fromCharCode(A);
                  } catch {
                    throw this._createError(h(this._cursor.getChars(t3)), this._cursor.getSpan());
                  }
                } else {
                  let o = this._cursor.clone();
                  if (this._attemptCharCodeUntilFn(N), this._cursor.peek() != r.$SEMICOLON)
                    return this._cursor = o, "&";
                  let E = this._cursor.getChars(o);
                  this._cursor.advance();
                  let p = D.NAMED_ENTITIES[E];
                  if (!p)
                    throw this._createError(h(E), this._cursor.getSpan(t3));
                  return p;
                }
              }
              _consumeRawText(t3, o) {
                this._beginToken(t3 ? s.ESCAPABLE_RAW_TEXT : s.RAW_TEXT);
                let E = [];
                for (; ; ) {
                  let p = this._cursor.clone(), A = o();
                  if (this._cursor = p, A)
                    break;
                  E.push(this._readChar(t3));
                }
                return this._endToken([this._processCarriageReturns(E.join(""))]);
              }
              _consumeComment(t3) {
                this._beginToken(s.COMMENT_START, t3), this._endToken([]), this._consumeRawText(false, () => this._attemptStr("-->")), this._beginToken(s.COMMENT_END), this._requireStr("-->"), this._endToken([]);
              }
              _consumeBogusComment(t3) {
                this._beginToken(s.COMMENT_START, t3), this._endToken([]), this._consumeRawText(false, () => this._cursor.peek() === r.$GT), this._beginToken(s.COMMENT_END), this._cursor.advance(), this._endToken([]);
              }
              _consumeCdata(t3) {
                this._beginToken(s.CDATA_START, t3), this._endToken([]), this._consumeRawText(false, () => this._attemptStr("]]>")), this._beginToken(s.CDATA_END), this._requireStr("]]>"), this._endToken([]);
              }
              _consumeDocType(t3) {
                this._beginToken(s.DOC_TYPE_START, t3), this._endToken([]), this._consumeRawText(false, () => this._cursor.peek() === r.$GT), this._beginToken(s.DOC_TYPE_END), this._cursor.advance(), this._endToken([]);
              }
              _consumePrefixAndName() {
                let t3 = this._cursor.clone(), o = "";
                for (; this._cursor.peek() !== r.$COLON && !w(this._cursor.peek()); )
                  this._cursor.advance();
                let E;
                this._cursor.peek() === r.$COLON ? (o = this._cursor.getChars(t3), this._cursor.advance(), E = this._cursor.clone()) : E = t3, this._requireCharCodeUntilFn(T, o === "" ? 0 : 1);
                let p = this._cursor.getChars(E);
                return [o, p];
              }
              _consumeTagOpen(t3) {
                let o, E, p, A = this.tokens.length, P = this._cursor.clone(), M = [];
                try {
                  if (!r.isAsciiLetter(this._cursor.peek()))
                    throw this._createError(l(this._cursor.peek()), this._cursor.getSpan(t3));
                  for (p = this._consumeTagOpenStart(t3), E = p.parts[0], o = p.parts[1], this._attemptCharCodeUntilFn(m); this._cursor.peek() !== r.$SLASH && this._cursor.peek() !== r.$GT; ) {
                    let [V, X] = this._consumeAttributeName();
                    if (this._attemptCharCodeUntilFn(m), this._attemptCharCode(r.$EQ)) {
                      this._attemptCharCodeUntilFn(m);
                      let H = this._consumeAttributeValue();
                      M.push({ prefix: V, name: X, value: H });
                    } else
                      M.push({ prefix: V, name: X });
                    this._attemptCharCodeUntilFn(m);
                  }
                  this._consumeTagOpenEnd();
                } catch (V) {
                  if (V instanceof C) {
                    this._cursor = P, p && (this.tokens.length = A), this._beginToken(s.TEXT, t3), this._endToken(["<"]);
                    return;
                  }
                  throw V;
                }
                if (this._canSelfClose && this.tokens[this.tokens.length - 1].type === s.TAG_OPEN_END_VOID)
                  return;
                let z = this._getTagContentType(o, E, this._fullNameStack.length > 0, M);
                this._handleFullNameStackForTagOpen(E, o), z === D.TagContentType.RAW_TEXT ? this._consumeRawTextWithTagClose(E, o, false) : z === D.TagContentType.ESCAPABLE_RAW_TEXT && this._consumeRawTextWithTagClose(E, o, true);
              }
              _consumeRawTextWithTagClose(t3, o, E) {
                let p = this._consumeRawText(E, () => !this._attemptCharCode(r.$LT) || !this._attemptCharCode(r.$SLASH) || (this._attemptCharCodeUntilFn(m), !this._attemptStrCaseInsensitive(t3 ? `${t3}:${o}` : o)) ? false : (this._attemptCharCodeUntilFn(m), this._attemptCharCode(r.$GT)));
                this._beginToken(s.TAG_CLOSE), this._requireCharCodeUntilFn((A) => A === r.$GT, 3), this._cursor.advance(), this._endToken([t3, o]), this._handleFullNameStackForTagClose(t3, o);
              }
              _consumeTagOpenStart(t3) {
                this._beginToken(s.TAG_OPEN_START, t3);
                let o = this._consumePrefixAndName();
                return this._endToken(o);
              }
              _consumeAttributeName() {
                let t3 = this._cursor.peek();
                if (t3 === r.$SQ || t3 === r.$DQ)
                  throw this._createError(l(t3), this._cursor.getSpan());
                this._beginToken(s.ATTR_NAME);
                let o = this._consumePrefixAndName();
                return this._endToken(o), o;
              }
              _consumeAttributeValue() {
                let t3;
                if (this._cursor.peek() === r.$SQ || this._cursor.peek() === r.$DQ) {
                  this._beginToken(s.ATTR_QUOTE);
                  let o = this._cursor.peek();
                  this._cursor.advance(), this._endToken([String.fromCodePoint(o)]), this._beginToken(s.ATTR_VALUE);
                  let E = [];
                  for (; this._cursor.peek() !== o; )
                    E.push(this._readChar(true));
                  t3 = this._processCarriageReturns(E.join("")), this._endToken([t3]), this._beginToken(s.ATTR_QUOTE), this._cursor.advance(), this._endToken([String.fromCodePoint(o)]);
                } else {
                  this._beginToken(s.ATTR_VALUE);
                  let o = this._cursor.clone();
                  this._requireCharCodeUntilFn(T, 1), t3 = this._processCarriageReturns(this._cursor.getChars(o)), this._endToken([t3]);
                }
                return t3;
              }
              _consumeTagOpenEnd() {
                let t3 = this._attemptCharCode(r.$SLASH) ? s.TAG_OPEN_END_VOID : s.TAG_OPEN_END;
                this._beginToken(t3), this._requireCharCode(r.$GT), this._endToken([]);
              }
              _consumeTagClose(t3) {
                if (this._beginToken(s.TAG_CLOSE, t3), this._attemptCharCodeUntilFn(m), this._allowHtmComponentClosingTags && this._attemptCharCode(r.$SLASH))
                  this._attemptCharCodeUntilFn(m), this._requireCharCode(r.$GT), this._endToken([]);
                else {
                  let [o, E] = this._consumePrefixAndName();
                  this._attemptCharCodeUntilFn(m), this._requireCharCode(r.$GT), this._endToken([o, E]), this._handleFullNameStackForTagClose(o, E);
                }
              }
              _consumeExpansionFormStart() {
                this._beginToken(s.EXPANSION_FORM_START), this._requireCharCode(r.$LBRACE), this._endToken([]), this._expansionCaseStack.push(s.EXPANSION_FORM_START), this._beginToken(s.RAW_TEXT);
                let t3 = this._readUntil(r.$COMMA);
                this._endToken([t3]), this._requireCharCode(r.$COMMA), this._attemptCharCodeUntilFn(m), this._beginToken(s.RAW_TEXT);
                let o = this._readUntil(r.$COMMA);
                this._endToken([o]), this._requireCharCode(r.$COMMA), this._attemptCharCodeUntilFn(m);
              }
              _consumeExpansionCaseStart() {
                this._beginToken(s.EXPANSION_CASE_VALUE);
                let t3 = this._readUntil(r.$LBRACE).trim();
                this._endToken([t3]), this._attemptCharCodeUntilFn(m), this._beginToken(s.EXPANSION_CASE_EXP_START), this._requireCharCode(r.$LBRACE), this._endToken([]), this._attemptCharCodeUntilFn(m), this._expansionCaseStack.push(s.EXPANSION_CASE_EXP_START);
              }
              _consumeExpansionCaseEnd() {
                this._beginToken(s.EXPANSION_CASE_EXP_END), this._requireCharCode(r.$RBRACE), this._endToken([]), this._attemptCharCodeUntilFn(m), this._expansionCaseStack.pop();
              }
              _consumeExpansionFormEnd() {
                this._beginToken(s.EXPANSION_FORM_END), this._requireCharCode(r.$RBRACE), this._endToken([]), this._expansionCaseStack.pop();
              }
              _consumeText() {
                let t3 = this._cursor.clone();
                this._beginToken(s.TEXT, t3);
                let o = [];
                do
                  this._interpolationConfig && this._attemptStr(this._interpolationConfig.start) ? (o.push(this._interpolationConfig.start), this._inInterpolation = true) : this._interpolationConfig && this._inInterpolation && this._attemptStr(this._interpolationConfig.end) ? (o.push(this._interpolationConfig.end), this._inInterpolation = false) : o.push(this._readChar(true));
                while (!this._isTextEnd());
                this._endToken([this._processCarriageReturns(o.join(""))]);
              }
              _isTextEnd() {
                return !!(this._cursor.peek() === r.$LT || this._cursor.peek() === r.$EOF || this._tokenizeIcu && !this._inInterpolation && (this.isExpansionFormStart() || this._cursor.peek() === r.$RBRACE && this._isInExpansionCase()));
              }
              _readUntil(t3) {
                let o = this._cursor.clone();
                return this._attemptUntilChar(t3), this._cursor.getChars(o);
              }
              _isInExpansionCase() {
                return this._expansionCaseStack.length > 0 && this._expansionCaseStack[this._expansionCaseStack.length - 1] === s.EXPANSION_CASE_EXP_START;
              }
              _isInExpansionForm() {
                return this._expansionCaseStack.length > 0 && this._expansionCaseStack[this._expansionCaseStack.length - 1] === s.EXPANSION_FORM_START;
              }
              isExpansionFormStart() {
                if (this._cursor.peek() !== r.$LBRACE)
                  return false;
                if (this._interpolationConfig) {
                  let t3 = this._cursor.clone(), o = this._attemptStr(this._interpolationConfig.start);
                  return this._cursor = t3, !o;
                }
                return true;
              }
              _handleFullNameStackForTagOpen(t3, o) {
                let E = D.mergeNsAndName(t3, o);
                (this._fullNameStack.length === 0 || this._fullNameStack[this._fullNameStack.length - 1] === E) && this._fullNameStack.push(E);
              }
              _handleFullNameStackForTagClose(t3, o) {
                let E = D.mergeNsAndName(t3, o);
                this._fullNameStack.length !== 0 && this._fullNameStack[this._fullNameStack.length - 1] === E && this._fullNameStack.pop();
              }
            };
            function m(t3) {
              return !r.isWhitespace(t3) || t3 === r.$EOF;
            }
            function T(t3) {
              return r.isWhitespace(t3) || t3 === r.$GT || t3 === r.$SLASH || t3 === r.$SQ || t3 === r.$DQ || t3 === r.$EQ;
            }
            function w(t3) {
              return (t3 < r.$a || r.$z < t3) && (t3 < r.$A || r.$Z < t3) && (t3 < r.$0 || t3 > r.$9);
            }
            function g(t3) {
              return t3 == r.$SEMICOLON || t3 == r.$EOF || !r.isAsciiHexDigit(t3);
            }
            function N(t3) {
              return t3 == r.$SEMICOLON || t3 == r.$EOF || !r.isAsciiLetter(t3);
            }
            function R(t3) {
              return t3 === r.$EQ || r.isAsciiLetter(t3) || r.isDigit(t3);
            }
            function j(t3, o) {
              return _(t3) == _(o);
            }
            function _(t3) {
              return t3 >= r.$a && t3 <= r.$z ? t3 - r.$a + r.$A : t3;
            }
            function O(t3) {
              let o = [], E;
              for (let p = 0; p < t3.length; p++) {
                let A = t3[p];
                E && E.type == s.TEXT && A.type == s.TEXT ? (E.parts[0] += A.parts[0], E.sourceSpan.end = A.sourceSpan.end) : (E = A, o.push(E));
              }
              return o;
            }
            var x = class {
              constructor(t3, o) {
                if (t3 instanceof x)
                  this.file = t3.file, this.input = t3.input, this.end = t3.end, this.state = Object.assign({}, t3.state);
                else {
                  if (!o)
                    throw new Error("Programming error: the range argument must be provided with a file argument.");
                  this.file = t3, this.input = t3.content, this.end = o.endPos, this.state = { peek: -1, offset: o.startPos, line: o.startLine, column: o.startCol };
                }
              }
              clone() {
                return new x(this);
              }
              peek() {
                return this.state.peek;
              }
              charsLeft() {
                return this.end - this.state.offset;
              }
              diff(t3) {
                return this.state.offset - t3.state.offset;
              }
              advance() {
                this.advanceState(this.state);
              }
              init() {
                this.updatePeek(this.state);
              }
              getSpan(t3, o) {
                if (t3 = t3 || this, o)
                  for (t3 = t3.clone(); this.diff(t3) > 0 && o.indexOf(t3.peek()) !== -1; )
                    t3.advance();
                return new u.ParseSourceSpan(new u.ParseLocation(t3.file, t3.state.offset, t3.state.line, t3.state.column), new u.ParseLocation(this.file, this.state.offset, this.state.line, this.state.column));
              }
              getChars(t3) {
                return this.input.substring(t3.state.offset, this.state.offset);
              }
              charAt(t3) {
                return this.input.charCodeAt(t3);
              }
              advanceState(t3) {
                if (t3.offset >= this.end)
                  throw this.state = t3, new $('Unexpected character "EOF"', this);
                let o = this.charAt(t3.offset);
                o === r.$LF ? (t3.line++, t3.column = 0) : r.isNewLine(o) || t3.column++, t3.offset++, this.updatePeek(t3);
              }
              updatePeek(t3) {
                t3.peek = t3.offset >= this.end ? r.$EOF : this.charAt(t3.offset);
              }
            }, k = class extends x {
              constructor(t3, o) {
                t3 instanceof k ? (super(t3), this.internalState = Object.assign({}, t3.internalState)) : (super(t3, o), this.internalState = this.state);
              }
              advance() {
                this.state = this.internalState, super.advance(), this.processEscapeSequence();
              }
              init() {
                super.init(), this.processEscapeSequence();
              }
              clone() {
                return new k(this);
              }
              getChars(t3) {
                let o = t3.clone(), E = "";
                for (; o.internalState.offset < this.internalState.offset; )
                  E += String.fromCodePoint(o.peek()), o.advance();
                return E;
              }
              processEscapeSequence() {
                let t3 = () => this.internalState.peek;
                if (t3() === r.$BACKSLASH)
                  if (this.internalState = Object.assign({}, this.state), this.advanceState(this.internalState), t3() === r.$n)
                    this.state.peek = r.$LF;
                  else if (t3() === r.$r)
                    this.state.peek = r.$CR;
                  else if (t3() === r.$v)
                    this.state.peek = r.$VTAB;
                  else if (t3() === r.$t)
                    this.state.peek = r.$TAB;
                  else if (t3() === r.$b)
                    this.state.peek = r.$BSPACE;
                  else if (t3() === r.$f)
                    this.state.peek = r.$FF;
                  else if (t3() === r.$u)
                    if (this.advanceState(this.internalState), t3() === r.$LBRACE) {
                      this.advanceState(this.internalState);
                      let o = this.clone(), E = 0;
                      for (; t3() !== r.$RBRACE; )
                        this.advanceState(this.internalState), E++;
                      this.state.peek = this.decodeHexDigits(o, E);
                    } else {
                      let o = this.clone();
                      this.advanceState(this.internalState), this.advanceState(this.internalState), this.advanceState(this.internalState), this.state.peek = this.decodeHexDigits(o, 4);
                    }
                  else if (t3() === r.$x) {
                    this.advanceState(this.internalState);
                    let o = this.clone();
                    this.advanceState(this.internalState), this.state.peek = this.decodeHexDigits(o, 2);
                  } else if (r.isOctalDigit(t3())) {
                    let o = "", E = 0, p = this.clone();
                    for (; r.isOctalDigit(t3()) && E < 3; )
                      p = this.clone(), o += String.fromCodePoint(t3()), this.advanceState(this.internalState), E++;
                    this.state.peek = parseInt(o, 8), this.internalState = p.internalState;
                  } else
                    r.isNewLine(this.internalState.peek) ? (this.advanceState(this.internalState), this.state = this.internalState) : this.state.peek = this.internalState.peek;
              }
              decodeHexDigits(t3, o) {
                let E = this.input.substr(t3.internalState.offset, o), p = parseInt(E, 16);
                if (isNaN(p))
                  throw t3.state = t3.internalState, new $("Invalid hexadecimal escape sequence", t3);
                return p;
              }
            }, $ = class {
              constructor(t3, o) {
                this.msg = t3, this.cursor = o;
              }
            };
            e.CursorError = $;
          } }), ls = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/parser.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Be(), u = bs(), n = Yl(), D = Ze(), s = class extends r.ParseError {
              constructor(a, l, h) {
                super(l, h), this.elementName = a;
              }
              static create(a, l, h) {
                return new s(a, l, h);
              }
            };
            e.TreeError = s;
            var i = class {
              constructor(a, l) {
                this.rootNodes = a, this.errors = l;
              }
            };
            e.ParseTreeResult = i;
            var f = class {
              constructor(a) {
                this.getTagDefinition = a;
              }
              parse(a, l, h) {
                let C = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, d = arguments.length > 4 ? arguments[4] : void 0, m = (x) => function(k) {
                  for (var $ = arguments.length, t3 = new Array($ > 1 ? $ - 1 : 0), o = 1; o < $; o++)
                    t3[o - 1] = arguments[o];
                  return x(k.toLowerCase(), ...t3);
                }, T = C ? this.getTagDefinition : m(this.getTagDefinition), w = (x) => T(x).contentType, g = C ? d : m(d), N = d ? (x, k, $, t3) => {
                  let o = g(x, k, $, t3);
                  return o !== void 0 ? o : w(x);
                } : w, R = n.tokenize(a, l, N, h), j = h && h.canSelfClose || false, _ = h && h.allowHtmComponentClosingTags || false, O = new c(R.tokens, T, j, _, C).build();
                return new i(O.rootNodes, R.errors.concat(O.errors));
              }
            };
            e.Parser = f;
            var c = class {
              constructor(a, l, h, C, d) {
                this.tokens = a, this.getTagDefinition = l, this.canSelfClose = h, this.allowHtmComponentClosingTags = C, this.isTagNameCaseSensitive = d, this._index = -1, this._rootNodes = [], this._errors = [], this._elementStack = [], this._advance();
              }
              build() {
                for (; this._peek.type !== n.TokenType.EOF; )
                  this._peek.type === n.TokenType.TAG_OPEN_START ? this._consumeStartTag(this._advance()) : this._peek.type === n.TokenType.TAG_CLOSE ? (this._closeVoidElement(), this._consumeEndTag(this._advance())) : this._peek.type === n.TokenType.CDATA_START ? (this._closeVoidElement(), this._consumeCdata(this._advance())) : this._peek.type === n.TokenType.COMMENT_START ? (this._closeVoidElement(), this._consumeComment(this._advance())) : this._peek.type === n.TokenType.TEXT || this._peek.type === n.TokenType.RAW_TEXT || this._peek.type === n.TokenType.ESCAPABLE_RAW_TEXT ? (this._closeVoidElement(), this._consumeText(this._advance())) : this._peek.type === n.TokenType.EXPANSION_FORM_START ? this._consumeExpansion(this._advance()) : this._peek.type === n.TokenType.DOC_TYPE_START ? this._consumeDocType(this._advance()) : this._advance();
                return new i(this._rootNodes, this._errors);
              }
              _advance() {
                let a = this._peek;
                return this._index < this.tokens.length - 1 && this._index++, this._peek = this.tokens[this._index], a;
              }
              _advanceIf(a) {
                return this._peek.type === a ? this._advance() : null;
              }
              _consumeCdata(a) {
                let l = this._advance(), h = this._getText(l), C = this._advanceIf(n.TokenType.CDATA_END);
                this._addToParent(new u.CDATA(h, new r.ParseSourceSpan(a.sourceSpan.start, (C || l).sourceSpan.end)));
              }
              _consumeComment(a) {
                let l = this._advanceIf(n.TokenType.RAW_TEXT), h = this._advanceIf(n.TokenType.COMMENT_END), C = l != null ? l.parts[0].trim() : null, d = new r.ParseSourceSpan(a.sourceSpan.start, (h || l || a).sourceSpan.end);
                this._addToParent(new u.Comment(C, d));
              }
              _consumeDocType(a) {
                let l = this._advanceIf(n.TokenType.RAW_TEXT), h = this._advanceIf(n.TokenType.DOC_TYPE_END), C = l != null ? l.parts[0].trim() : null, d = new r.ParseSourceSpan(a.sourceSpan.start, (h || l || a).sourceSpan.end);
                this._addToParent(new u.DocType(C, d));
              }
              _consumeExpansion(a) {
                let l = this._advance(), h = this._advance(), C = [];
                for (; this._peek.type === n.TokenType.EXPANSION_CASE_VALUE; ) {
                  let m = this._parseExpansionCase();
                  if (!m)
                    return;
                  C.push(m);
                }
                if (this._peek.type !== n.TokenType.EXPANSION_FORM_END) {
                  this._errors.push(s.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '}'."));
                  return;
                }
                let d = new r.ParseSourceSpan(a.sourceSpan.start, this._peek.sourceSpan.end);
                this._addToParent(new u.Expansion(l.parts[0], h.parts[0], C, d, l.sourceSpan)), this._advance();
              }
              _parseExpansionCase() {
                let a = this._advance();
                if (this._peek.type !== n.TokenType.EXPANSION_CASE_EXP_START)
                  return this._errors.push(s.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '{'.")), null;
                let l = this._advance(), h = this._collectExpansionExpTokens(l);
                if (!h)
                  return null;
                let C = this._advance();
                h.push(new n.Token(n.TokenType.EOF, [], C.sourceSpan));
                let d = new c(h, this.getTagDefinition, this.canSelfClose, this.allowHtmComponentClosingTags, this.isTagNameCaseSensitive).build();
                if (d.errors.length > 0)
                  return this._errors = this._errors.concat(d.errors), null;
                let m = new r.ParseSourceSpan(a.sourceSpan.start, C.sourceSpan.end), T = new r.ParseSourceSpan(l.sourceSpan.start, C.sourceSpan.end);
                return new u.ExpansionCase(a.parts[0], d.rootNodes, m, a.sourceSpan, T);
              }
              _collectExpansionExpTokens(a) {
                let l = [], h = [n.TokenType.EXPANSION_CASE_EXP_START];
                for (; ; ) {
                  if ((this._peek.type === n.TokenType.EXPANSION_FORM_START || this._peek.type === n.TokenType.EXPANSION_CASE_EXP_START) && h.push(this._peek.type), this._peek.type === n.TokenType.EXPANSION_CASE_EXP_END)
                    if (F(h, n.TokenType.EXPANSION_CASE_EXP_START)) {
                      if (h.pop(), h.length == 0)
                        return l;
                    } else
                      return this._errors.push(s.create(null, a.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
                  if (this._peek.type === n.TokenType.EXPANSION_FORM_END)
                    if (F(h, n.TokenType.EXPANSION_FORM_START))
                      h.pop();
                    else
                      return this._errors.push(s.create(null, a.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
                  if (this._peek.type === n.TokenType.EOF)
                    return this._errors.push(s.create(null, a.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
                  l.push(this._advance());
                }
              }
              _getText(a) {
                let l = a.parts[0];
                if (l.length > 0 && l[0] == `
`) {
                  let h = this._getParentElement();
                  h != null && h.children.length == 0 && this.getTagDefinition(h.name).ignoreFirstLf && (l = l.substring(1));
                }
                return l;
              }
              _consumeText(a) {
                let l = this._getText(a);
                l.length > 0 && this._addToParent(new u.Text(l, a.sourceSpan));
              }
              _closeVoidElement() {
                let a = this._getParentElement();
                a && this.getTagDefinition(a.name).isVoid && this._elementStack.pop();
              }
              _consumeStartTag(a) {
                let l = a.parts[0], h = a.parts[1], C = [];
                for (; this._peek.type === n.TokenType.ATTR_NAME; )
                  C.push(this._consumeAttr(this._advance()));
                let d = this._getElementFullName(l, h, this._getParentElement()), m = false;
                if (this._peek.type === n.TokenType.TAG_OPEN_END_VOID) {
                  this._advance(), m = true;
                  let R = this.getTagDefinition(d);
                  this.canSelfClose || R.canSelfClose || D.getNsPrefix(d) !== null || R.isVoid || this._errors.push(s.create(d, a.sourceSpan, `Only void and foreign elements can be self closed "${a.parts[1]}"`));
                } else
                  this._peek.type === n.TokenType.TAG_OPEN_END && (this._advance(), m = false);
                let T = this._peek.sourceSpan.start, w = new r.ParseSourceSpan(a.sourceSpan.start, T), g = new r.ParseSourceSpan(a.sourceSpan.start.moveBy(1), a.sourceSpan.end), N = new u.Element(d, C, [], w, w, void 0, g);
                this._pushElement(N), m && (this._popElement(d), N.endSourceSpan = w);
              }
              _pushElement(a) {
                let l = this._getParentElement();
                l && this.getTagDefinition(l.name).isClosedByChild(a.name) && this._elementStack.pop(), this._addToParent(a), this._elementStack.push(a);
              }
              _consumeEndTag(a) {
                let l = this.allowHtmComponentClosingTags && a.parts.length === 0 ? null : this._getElementFullName(a.parts[0], a.parts[1], this._getParentElement());
                if (this._getParentElement() && (this._getParentElement().endSourceSpan = a.sourceSpan), l && this.getTagDefinition(l).isVoid)
                  this._errors.push(s.create(l, a.sourceSpan, `Void elements do not have end tags "${a.parts[1]}"`));
                else if (!this._popElement(l)) {
                  let h = `Unexpected closing tag "${l}". It may happen when the tag has already been closed by another tag. For more info see https://www.w3.org/TR/html5/syntax.html#closing-elements-that-have-implied-end-tags`;
                  this._errors.push(s.create(l, a.sourceSpan, h));
                }
              }
              _popElement(a) {
                for (let l = this._elementStack.length - 1; l >= 0; l--) {
                  let h = this._elementStack[l];
                  if (!a || (D.getNsPrefix(h.name) ? h.name == a : h.name.toLowerCase() == a.toLowerCase()))
                    return this._elementStack.splice(l, this._elementStack.length - l), true;
                  if (!this.getTagDefinition(h.name).closedByParent)
                    return false;
                }
                return false;
              }
              _consumeAttr(a) {
                let l = D.mergeNsAndName(a.parts[0], a.parts[1]), h = a.sourceSpan.end, C = "", d, m;
                if (this._peek.type === n.TokenType.ATTR_QUOTE && (m = this._advance().sourceSpan.start), this._peek.type === n.TokenType.ATTR_VALUE) {
                  let T = this._advance();
                  C = T.parts[0], h = T.sourceSpan.end, d = T.sourceSpan;
                }
                return this._peek.type === n.TokenType.ATTR_QUOTE && (h = this._advance().sourceSpan.end, d = new r.ParseSourceSpan(m, h)), new u.Attribute(l, C, new r.ParseSourceSpan(a.sourceSpan.start, h), d, a.sourceSpan);
              }
              _getParentElement() {
                return this._elementStack.length > 0 ? this._elementStack[this._elementStack.length - 1] : null;
              }
              _getParentElementSkippingContainers() {
                let a = null;
                for (let l = this._elementStack.length - 1; l >= 0; l--) {
                  if (!D.isNgContainer(this._elementStack[l].name))
                    return { parent: this._elementStack[l], container: a };
                  a = this._elementStack[l];
                }
                return { parent: null, container: a };
              }
              _addToParent(a) {
                let l = this._getParentElement();
                l != null ? l.children.push(a) : this._rootNodes.push(a);
              }
              _insertBeforeContainer(a, l, h) {
                if (!l)
                  this._addToParent(h), this._elementStack.push(h);
                else {
                  if (a) {
                    let C = a.children.indexOf(l);
                    a.children[C] = h;
                  } else
                    this._rootNodes.push(h);
                  h.children.push(l), this._elementStack.splice(this._elementStack.indexOf(l), 0, h);
                }
              }
              _getElementFullName(a, l, h) {
                return a === "" && (a = this.getTagDefinition(l).implicitNamespacePrefix || "", a === "" && h != null && (a = D.getNsPrefix(h.name))), D.mergeNsAndName(a, l);
              }
            };
            function F(a, l) {
              return a.length > 0 && a[a.length - 1] === l;
            }
          } }), Ql = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/html_parser.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Bs(), u = ls(), n = ls();
            e.ParseTreeResult = n.ParseTreeResult, e.TreeError = n.TreeError;
            var D = class extends u.Parser {
              constructor() {
                super(r.getHtmlTagDefinition);
              }
              parse(s, i, f) {
                let c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, F = arguments.length > 4 ? arguments[4] : void 0;
                return super.parse(s, i, f, c, F);
              }
            };
            e.HtmlParser = D;
          } }), ws = I({ "node_modules/angular-html-parser/lib/angular-html-parser/src/index.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Ql(), u = Ze();
            e.TagContentType = u.TagContentType;
            var n = null, D = () => (n || (n = new r.HtmlParser()), n);
            function s(i) {
              let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { canSelfClose: c = false, allowHtmComponentClosingTags: F = false, isTagNameCaseSensitive: a = false, getTagContentType: l } = f;
              return D().parse(i, "angular-html-parser", { tokenizeExpansionForms: false, interpolationConfig: void 0, canSelfClose: c, allowHtmComponentClosingTags: F }, a, l);
            }
            e.parse = s;
          } });
          q();
          var { ParseSourceSpan: Qe, ParseLocation: cs, ParseSourceFile: Kl } = Be(), Jl = ol(), Zl = Cs(), ec = Dl(), { inferParserByLanguage: rc } = xl(), uc = kl(), Vr = Ml(), hs = jl(), { hasPragma: tc } = Ul(), { Node: nc } = Gl(), { parseIeConditionalComment: sc } = Vl(), { locStart: ic, locEnd: ac } = Xl();
          function oc(e, r, u) {
            let { canSelfClose: n, normalizeTagName: D, normalizeAttributeName: s, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: f, getTagContentType: c } = r, F = ws(), { RecursiveVisitor: a, visitAll: l } = bs(), { ParseSourceSpan: h } = Be(), { getHtmlTagDefinition: C } = Bs(), { rootNodes: d, errors: m } = F.parse(e, { canSelfClose: n, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: f, getTagContentType: c });
            if (u.parser === "vue")
              if (d.some((O) => O.type === "docType" && O.value === "html" || O.type === "element" && O.name.toLowerCase() === "html")) {
                n = true, D = true, s = true, i = true, f = false;
                let O = F.parse(e, { canSelfClose: n, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: f });
                d = O.rootNodes, m = O.errors;
              } else {
                let O = (x) => {
                  if (!x || x.type !== "element" || x.name !== "template")
                    return false;
                  let k = x.attrs.find((t3) => t3.name === "lang"), $ = k && k.value;
                  return !$ || rc($, u) === "html";
                };
                if (d.some(O)) {
                  let x, k = () => F.parse(e, { canSelfClose: n, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: f }), $ = () => x || (x = k()), t3 = (o) => $().rootNodes.find((E) => {
                    let { startSourceSpan: p } = E;
                    return p && p.start.offset === o.startSourceSpan.start.offset;
                  });
                  for (let o = 0; o < d.length; o++) {
                    let E = d[o], { endSourceSpan: p, startSourceSpan: A } = E;
                    if (p === null)
                      m = $().errors, d[o] = t3(E) || E;
                    else if (O(E)) {
                      let M = $(), z = A.end.offset, V = p.start.offset;
                      for (let X of M.errors) {
                        let { offset: H } = X.span.start;
                        if (z < H && H < V) {
                          m = [X];
                          break;
                        }
                      }
                      d[o] = t3(E) || E;
                    }
                  }
                }
              }
            if (m.length > 0) {
              let { msg: _, span: { start: O, end: x } } = m[0];
              throw ec(_, { start: { line: O.line + 1, column: O.col + 1 }, end: { line: x.line + 1, column: x.col + 1 } });
            }
            let T = (_) => {
              let O = _.name.startsWith(":") ? _.name.slice(1).split(":")[0] : null, x = _.nameSpan.toString(), k = O !== null && x.startsWith(`${O}:`), $ = k ? x.slice(O.length + 1) : x;
              _.name = $, _.namespace = O, _.hasExplicitNamespace = k;
            }, w = (_) => {
              switch (_.type) {
                case "element":
                  T(_);
                  for (let O of _.attrs)
                    T(O), O.valueSpan ? (O.value = O.valueSpan.toString(), /["']/.test(O.value[0]) && (O.value = O.value.slice(1, -1))) : O.value = null;
                  break;
                case "comment":
                  _.value = _.sourceSpan.toString().slice(4, -3);
                  break;
                case "text":
                  _.value = _.sourceSpan.toString();
                  break;
              }
            }, g = (_, O) => {
              let x = _.toLowerCase();
              return O(x) ? x : _;
            }, N = (_) => {
              if (_.type === "element" && (D && (!_.namespace || _.namespace === _.tagDefinition.implicitNamespacePrefix || hs(_)) && (_.name = g(_.name, (O) => O in uc)), s)) {
                let O = Vr[_.name] || /* @__PURE__ */ Object.create(null);
                for (let x of _.attrs)
                  x.namespace || (x.name = g(x.name, (k) => _.name in Vr && (k in Vr["*"] || k in O)));
              }
            }, R = (_) => {
              _.sourceSpan && _.endSourceSpan && (_.sourceSpan = new h(_.sourceSpan.start, _.endSourceSpan.end));
            }, j = (_) => {
              if (_.type === "element") {
                let O = C(f ? _.name : _.name.toLowerCase());
                !_.namespace || _.namespace === O.implicitNamespacePrefix || hs(_) ? _.tagDefinition = O : _.tagDefinition = C("");
              }
            };
            return l(new class extends a {
              visit(_) {
                w(_), j(_), N(_), R(_);
              }
            }(), d), d;
          }
          function Ns(e, r, u) {
            let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, { frontMatter: D, content: s } = n ? Jl(e) : { frontMatter: null, content: e }, i = new Kl(e, r.filepath), f = new cs(i, 0, 0, 0), c = f.moveBy(e.length), F = { type: "root", sourceSpan: new Qe(f, c), children: oc(s, u, r) };
            if (D) {
              let h = new cs(i, 0, 0, 0), C = h.moveBy(D.raw.length);
              D.sourceSpan = new Qe(h, C), F.children.unshift(D);
            }
            let a = new nc(F), l = (h, C) => {
              let { offset: d } = C, m = e.slice(0, d).replace(/[^\n\r]/g, " "), w = Ns(m + h, r, u, false);
              w.sourceSpan = new Qe(C, Zl(w.children).sourceSpan.end);
              let g = w.children[0];
              return g.length === d ? w.children.shift() : (g.sourceSpan = new Qe(g.sourceSpan.start.moveBy(d), g.sourceSpan.end), g.value = g.value.slice(d)), w;
            };
            return a.walk((h) => {
              if (h.type === "comment") {
                let C = sc(h, l);
                C && h.parent.replaceChild(h, C);
              }
            }), a;
          }
          function Ke() {
            let { name: e, canSelfClose: r = false, normalizeTagName: u = false, normalizeAttributeName: n = false, allowHtmComponentClosingTags: D = false, isTagNameCaseSensitive: s = false, getTagContentType: i } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return { parse: (f, c, F) => Ns(f, Object.assign({ parser: e }, F), { canSelfClose: r, normalizeTagName: u, normalizeAttributeName: n, allowHtmComponentClosingTags: D, isTagNameCaseSensitive: s, getTagContentType: i }), hasPragma: tc, astFormat: "html", locStart: ic, locEnd: ac };
          }
          Os.exports = { parsers: { html: Ke({ name: "html", canSelfClose: true, normalizeTagName: true, normalizeAttributeName: true, allowHtmComponentClosingTags: true }), angular: Ke({ name: "angular", canSelfClose: true }), vue: Ke({ name: "vue", canSelfClose: true, isTagNameCaseSensitive: true, getTagContentType: (e, r, u, n) => {
            if (e.toLowerCase() !== "html" && !u && (e !== "template" || n.some((D) => {
              let { name: s, value: i } = D;
              return s === "lang" && i !== "html" && i !== "" && i !== void 0;
            })))
              return ws().TagContentType.RAW_TEXT;
          } }), lwc: Ke({ name: "lwc" }) } };
        });
        return Dc();
      });
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/internal/constants.js
  var require_constants2 = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/internal/constants.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var SEMVER_SPEC_VERSION = "2.0.0";
      var MAX_LENGTH = 256;
      var MAX_SAFE_INTEGER7 = Number.MAX_SAFE_INTEGER || 9007199254740991;
      var MAX_SAFE_COMPONENT_LENGTH = 16;
      var MAX_SAFE_BUILD_LENGTH = MAX_LENGTH - 6;
      var RELEASE_TYPES = [
        "major",
        "premajor",
        "minor",
        "preminor",
        "patch",
        "prepatch",
        "prerelease"
      ];
      module2.exports = {
        MAX_LENGTH,
        MAX_SAFE_COMPONENT_LENGTH,
        MAX_SAFE_BUILD_LENGTH,
        MAX_SAFE_INTEGER: MAX_SAFE_INTEGER7,
        RELEASE_TYPES,
        SEMVER_SPEC_VERSION,
        FLAG_INCLUDE_PRERELEASE: 1,
        FLAG_LOOSE: 2
      };
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/internal/debug.js
  var require_debug2 = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/internal/debug.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var debug = typeof define_process_default === "object" && define_process_default.env && define_process_default.env.NODE_DEBUG && /\bsemver\b/i.test(define_process_default.env.NODE_DEBUG) ? (...args) => console.error("SEMVER", ...args) : () => {
      };
      module2.exports = debug;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/internal/re.js
  var require_re = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/internal/re.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var {
        MAX_SAFE_COMPONENT_LENGTH,
        MAX_SAFE_BUILD_LENGTH,
        MAX_LENGTH
      } = require_constants2();
      var debug = require_debug2();
      exports8 = module2.exports = {};
      var re = exports8.re = [];
      var safeRe = exports8.safeRe = [];
      var src = exports8.src = [];
      var safeSrc = exports8.safeSrc = [];
      var t3 = exports8.t = {};
      var R = 0;
      var LETTERDASHNUMBER = "[a-zA-Z0-9-]";
      var safeRegexReplacements = [
        ["\\s", 1],
        ["\\d", MAX_LENGTH],
        [LETTERDASHNUMBER, MAX_SAFE_BUILD_LENGTH]
      ];
      var makeSafeRegex = (value) => {
        for (const [token, max2] of safeRegexReplacements) {
          value = value.split(`${token}*`).join(`${token}{0,${max2}}`).split(`${token}+`).join(`${token}{1,${max2}}`);
        }
        return value;
      };
      var createToken = (name, value, isGlobal) => {
        const safe = makeSafeRegex(value);
        const index = R++;
        debug(name, index, value);
        t3[name] = index;
        src[index] = value;
        safeSrc[index] = safe;
        re[index] = new RegExp(value, isGlobal ? "g" : void 0);
        safeRe[index] = new RegExp(safe, isGlobal ? "g" : void 0);
      };
      createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
      createToken("NUMERICIDENTIFIERLOOSE", "\\d+");
      createToken("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
      createToken("MAINVERSION", `(${src[t3.NUMERICIDENTIFIER]})\\.(${src[t3.NUMERICIDENTIFIER]})\\.(${src[t3.NUMERICIDENTIFIER]})`);
      createToken("MAINVERSIONLOOSE", `(${src[t3.NUMERICIDENTIFIERLOOSE]})\\.(${src[t3.NUMERICIDENTIFIERLOOSE]})\\.(${src[t3.NUMERICIDENTIFIERLOOSE]})`);
      createToken("PRERELEASEIDENTIFIER", `(?:${src[t3.NUMERICIDENTIFIER]}|${src[t3.NONNUMERICIDENTIFIER]})`);
      createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t3.NUMERICIDENTIFIERLOOSE]}|${src[t3.NONNUMERICIDENTIFIER]})`);
      createToken("PRERELEASE", `(?:-(${src[t3.PRERELEASEIDENTIFIER]}(?:\\.${src[t3.PRERELEASEIDENTIFIER]})*))`);
      createToken("PRERELEASELOOSE", `(?:-?(${src[t3.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t3.PRERELEASEIDENTIFIERLOOSE]})*))`);
      createToken("BUILDIDENTIFIER", `${LETTERDASHNUMBER}+`);
      createToken("BUILD", `(?:\\+(${src[t3.BUILDIDENTIFIER]}(?:\\.${src[t3.BUILDIDENTIFIER]})*))`);
      createToken("FULLPLAIN", `v?${src[t3.MAINVERSION]}${src[t3.PRERELEASE]}?${src[t3.BUILD]}?`);
      createToken("FULL", `^${src[t3.FULLPLAIN]}$`);
      createToken("LOOSEPLAIN", `[v=\\s]*${src[t3.MAINVERSIONLOOSE]}${src[t3.PRERELEASELOOSE]}?${src[t3.BUILD]}?`);
      createToken("LOOSE", `^${src[t3.LOOSEPLAIN]}$`);
      createToken("GTLT", "((?:<|>)?=?)");
      createToken("XRANGEIDENTIFIERLOOSE", `${src[t3.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
      createToken("XRANGEIDENTIFIER", `${src[t3.NUMERICIDENTIFIER]}|x|X|\\*`);
      createToken("XRANGEPLAIN", `[v=\\s]*(${src[t3.XRANGEIDENTIFIER]})(?:\\.(${src[t3.XRANGEIDENTIFIER]})(?:\\.(${src[t3.XRANGEIDENTIFIER]})(?:${src[t3.PRERELEASE]})?${src[t3.BUILD]}?)?)?`);
      createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t3.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t3.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t3.XRANGEIDENTIFIERLOOSE]})(?:${src[t3.PRERELEASELOOSE]})?${src[t3.BUILD]}?)?)?`);
      createToken("XRANGE", `^${src[t3.GTLT]}\\s*${src[t3.XRANGEPLAIN]}$`);
      createToken("XRANGELOOSE", `^${src[t3.GTLT]}\\s*${src[t3.XRANGEPLAINLOOSE]}$`);
      createToken("COERCEPLAIN", `${"(^|[^\\d])(\\d{1,"}${MAX_SAFE_COMPONENT_LENGTH}})(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?`);
      createToken("COERCE", `${src[t3.COERCEPLAIN]}(?:$|[^\\d])`);
      createToken("COERCEFULL", src[t3.COERCEPLAIN] + `(?:${src[t3.PRERELEASE]})?(?:${src[t3.BUILD]})?(?:$|[^\\d])`);
      createToken("COERCERTL", src[t3.COERCE], true);
      createToken("COERCERTLFULL", src[t3.COERCEFULL], true);
      createToken("LONETILDE", "(?:~>?)");
      createToken("TILDETRIM", `(\\s*)${src[t3.LONETILDE]}\\s+`, true);
      exports8.tildeTrimReplace = "$1~";
      createToken("TILDE", `^${src[t3.LONETILDE]}${src[t3.XRANGEPLAIN]}$`);
      createToken("TILDELOOSE", `^${src[t3.LONETILDE]}${src[t3.XRANGEPLAINLOOSE]}$`);
      createToken("LONECARET", "(?:\\^)");
      createToken("CARETTRIM", `(\\s*)${src[t3.LONECARET]}\\s+`, true);
      exports8.caretTrimReplace = "$1^";
      createToken("CARET", `^${src[t3.LONECARET]}${src[t3.XRANGEPLAIN]}$`);
      createToken("CARETLOOSE", `^${src[t3.LONECARET]}${src[t3.XRANGEPLAINLOOSE]}$`);
      createToken("COMPARATORLOOSE", `^${src[t3.GTLT]}\\s*(${src[t3.LOOSEPLAIN]})$|^$`);
      createToken("COMPARATOR", `^${src[t3.GTLT]}\\s*(${src[t3.FULLPLAIN]})$|^$`);
      createToken("COMPARATORTRIM", `(\\s*)${src[t3.GTLT]}\\s*(${src[t3.LOOSEPLAIN]}|${src[t3.XRANGEPLAIN]})`, true);
      exports8.comparatorTrimReplace = "$1$2$3";
      createToken("HYPHENRANGE", `^\\s*(${src[t3.XRANGEPLAIN]})\\s+-\\s+(${src[t3.XRANGEPLAIN]})\\s*$`);
      createToken("HYPHENRANGELOOSE", `^\\s*(${src[t3.XRANGEPLAINLOOSE]})\\s+-\\s+(${src[t3.XRANGEPLAINLOOSE]})\\s*$`);
      createToken("STAR", "(<|>)?=?\\s*\\*");
      createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
      createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/internal/parse-options.js
  var require_parse_options = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/internal/parse-options.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var looseOption = Object.freeze({ loose: true });
      var emptyOpts = Object.freeze({});
      var parseOptions = (options) => {
        if (!options) {
          return emptyOpts;
        }
        if (typeof options !== "object") {
          return looseOption;
        }
        return options;
      };
      module2.exports = parseOptions;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/internal/identifiers.js
  var require_identifiers = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/internal/identifiers.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var numeric = /^[0-9]+$/;
      var compareIdentifiers = (a, b) => {
        const anum = numeric.test(a);
        const bnum = numeric.test(b);
        if (anum && bnum) {
          a = +a;
          b = +b;
        }
        return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
      };
      var rcompareIdentifiers = (a, b) => compareIdentifiers(b, a);
      module2.exports = {
        compareIdentifiers,
        rcompareIdentifiers
      };
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/classes/semver.js
  var require_semver = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/classes/semver.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var debug = require_debug2();
      var { MAX_LENGTH, MAX_SAFE_INTEGER: MAX_SAFE_INTEGER7 } = require_constants2();
      var { safeRe: re, safeSrc: src, t: t3 } = require_re();
      var parseOptions = require_parse_options();
      var { compareIdentifiers } = require_identifiers();
      var SemVer = class {
        constructor(version3, options) {
          options = parseOptions(options);
          if (version3 instanceof SemVer) {
            if (version3.loose === !!options.loose && version3.includePrerelease === !!options.includePrerelease) {
              return version3;
            } else {
              version3 = version3.version;
            }
          } else if (typeof version3 !== "string") {
            throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version3}".`);
          }
          if (version3.length > MAX_LENGTH) {
            throw new TypeError(
              `version is longer than ${MAX_LENGTH} characters`
            );
          }
          debug("SemVer", version3, options);
          this.options = options;
          this.loose = !!options.loose;
          this.includePrerelease = !!options.includePrerelease;
          const m = version3.trim().match(options.loose ? re[t3.LOOSE] : re[t3.FULL]);
          if (!m) {
            throw new TypeError(`Invalid Version: ${version3}`);
          }
          this.raw = version3;
          this.major = +m[1];
          this.minor = +m[2];
          this.patch = +m[3];
          if (this.major > MAX_SAFE_INTEGER7 || this.major < 0) {
            throw new TypeError("Invalid major version");
          }
          if (this.minor > MAX_SAFE_INTEGER7 || this.minor < 0) {
            throw new TypeError("Invalid minor version");
          }
          if (this.patch > MAX_SAFE_INTEGER7 || this.patch < 0) {
            throw new TypeError("Invalid patch version");
          }
          if (!m[4]) {
            this.prerelease = [];
          } else {
            this.prerelease = m[4].split(".").map((id) => {
              if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < MAX_SAFE_INTEGER7) {
                  return num;
                }
              }
              return id;
            });
          }
          this.build = m[5] ? m[5].split(".") : [];
          this.format();
        }
        format() {
          this.version = `${this.major}.${this.minor}.${this.patch}`;
          if (this.prerelease.length) {
            this.version += `-${this.prerelease.join(".")}`;
          }
          return this.version;
        }
        toString() {
          return this.version;
        }
        compare(other) {
          debug("SemVer.compare", this.version, this.options, other);
          if (!(other instanceof SemVer)) {
            if (typeof other === "string" && other === this.version) {
              return 0;
            }
            other = new SemVer(other, this.options);
          }
          if (other.version === this.version) {
            return 0;
          }
          return this.compareMain(other) || this.comparePre(other);
        }
        compareMain(other) {
          if (!(other instanceof SemVer)) {
            other = new SemVer(other, this.options);
          }
          return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
        }
        comparePre(other) {
          if (!(other instanceof SemVer)) {
            other = new SemVer(other, this.options);
          }
          if (this.prerelease.length && !other.prerelease.length) {
            return -1;
          } else if (!this.prerelease.length && other.prerelease.length) {
            return 1;
          } else if (!this.prerelease.length && !other.prerelease.length) {
            return 0;
          }
          let i = 0;
          do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            debug("prerelease compare", i, a, b);
            if (a === void 0 && b === void 0) {
              return 0;
            } else if (b === void 0) {
              return 1;
            } else if (a === void 0) {
              return -1;
            } else if (a === b) {
              continue;
            } else {
              return compareIdentifiers(a, b);
            }
          } while (++i);
        }
        compareBuild(other) {
          if (!(other instanceof SemVer)) {
            other = new SemVer(other, this.options);
          }
          let i = 0;
          do {
            const a = this.build[i];
            const b = other.build[i];
            debug("build compare", i, a, b);
            if (a === void 0 && b === void 0) {
              return 0;
            } else if (b === void 0) {
              return 1;
            } else if (a === void 0) {
              return -1;
            } else if (a === b) {
              continue;
            } else {
              return compareIdentifiers(a, b);
            }
          } while (++i);
        }
        inc(release3, identifier3, identifierBase) {
          if (release3.startsWith("pre")) {
            if (!identifier3 && identifierBase === false) {
              throw new Error("invalid increment argument: identifier is empty");
            }
            if (identifier3) {
              const r = new RegExp(`^${this.options.loose ? src[t3.PRERELEASELOOSE] : src[t3.PRERELEASE]}$`);
              const match = `-${identifier3}`.match(r);
              if (!match || match[1] !== identifier3) {
                throw new Error(`invalid identifier: ${identifier3}`);
              }
            }
          }
          switch (release3) {
            case "premajor":
              this.prerelease.length = 0;
              this.patch = 0;
              this.minor = 0;
              this.major++;
              this.inc("pre", identifier3, identifierBase);
              break;
            case "preminor":
              this.prerelease.length = 0;
              this.patch = 0;
              this.minor++;
              this.inc("pre", identifier3, identifierBase);
              break;
            case "prepatch":
              this.prerelease.length = 0;
              this.inc("patch", identifier3, identifierBase);
              this.inc("pre", identifier3, identifierBase);
              break;
            case "prerelease":
              if (this.prerelease.length === 0) {
                this.inc("patch", identifier3, identifierBase);
              }
              this.inc("pre", identifier3, identifierBase);
              break;
            case "release":
              if (this.prerelease.length === 0) {
                throw new Error(`version ${this.raw} is not a prerelease`);
              }
              this.prerelease.length = 0;
              break;
            case "major":
              if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) {
                this.major++;
              }
              this.minor = 0;
              this.patch = 0;
              this.prerelease = [];
              break;
            case "minor":
              if (this.patch !== 0 || this.prerelease.length === 0) {
                this.minor++;
              }
              this.patch = 0;
              this.prerelease = [];
              break;
            case "patch":
              if (this.prerelease.length === 0) {
                this.patch++;
              }
              this.prerelease = [];
              break;
            case "pre": {
              const base = Number(identifierBase) ? 1 : 0;
              if (this.prerelease.length === 0) {
                this.prerelease = [base];
              } else {
                let i = this.prerelease.length;
                while (--i >= 0) {
                  if (typeof this.prerelease[i] === "number") {
                    this.prerelease[i]++;
                    i = -2;
                  }
                }
                if (i === -1) {
                  if (identifier3 === this.prerelease.join(".") && identifierBase === false) {
                    throw new Error("invalid increment argument: identifier already exists");
                  }
                  this.prerelease.push(base);
                }
              }
              if (identifier3) {
                let prerelease = [identifier3, base];
                if (identifierBase === false) {
                  prerelease = [identifier3];
                }
                if (compareIdentifiers(this.prerelease[0], identifier3) === 0) {
                  if (isNaN(this.prerelease[1])) {
                    this.prerelease = prerelease;
                  }
                } else {
                  this.prerelease = prerelease;
                }
              }
              break;
            }
            default:
              throw new Error(`invalid increment argument: ${release3}`);
          }
          this.raw = this.format();
          if (this.build.length) {
            this.raw += `+${this.build.join(".")}`;
          }
          return this;
        }
      };
      module2.exports = SemVer;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/parse.js
  var require_parse2 = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/parse.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var SemVer = require_semver();
      var parse4 = (version3, options, throwErrors = false) => {
        if (version3 instanceof SemVer) {
          return version3;
        }
        try {
          return new SemVer(version3, options);
        } catch (er) {
          if (!throwErrors) {
            return null;
          }
          throw er;
        }
      };
      module2.exports = parse4;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/valid.js
  var require_valid = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/valid.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var parse4 = require_parse2();
      var valid = (version3, options) => {
        const v = parse4(version3, options);
        return v ? v.version : null;
      };
      module2.exports = valid;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/clean.js
  var require_clean = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/clean.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var parse4 = require_parse2();
      var clean = (version3, options) => {
        const s = parse4(version3.trim().replace(/^[=v]+/, ""), options);
        return s ? s.version : null;
      };
      module2.exports = clean;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/inc.js
  var require_inc = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/inc.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var SemVer = require_semver();
      var inc = (version3, release3, options, identifier3, identifierBase) => {
        if (typeof options === "string") {
          identifierBase = identifier3;
          identifier3 = options;
          options = void 0;
        }
        try {
          return new SemVer(
            version3 instanceof SemVer ? version3.version : version3,
            options
          ).inc(release3, identifier3, identifierBase).version;
        } catch (er) {
          return null;
        }
      };
      module2.exports = inc;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/diff.js
  var require_diff = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/diff.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var parse4 = require_parse2();
      var diff = (version1, version22) => {
        const v1 = parse4(version1, null, true);
        const v2 = parse4(version22, null, true);
        const comparison = v1.compare(v2);
        if (comparison === 0) {
          return null;
        }
        const v1Higher = comparison > 0;
        const highVersion = v1Higher ? v1 : v2;
        const lowVersion = v1Higher ? v2 : v1;
        const highHasPre = !!highVersion.prerelease.length;
        const lowHasPre = !!lowVersion.prerelease.length;
        if (lowHasPre && !highHasPre) {
          if (!lowVersion.patch && !lowVersion.minor) {
            return "major";
          }
          if (lowVersion.compareMain(highVersion) === 0) {
            if (lowVersion.minor && !lowVersion.patch) {
              return "minor";
            }
            return "patch";
          }
        }
        const prefix = highHasPre ? "pre" : "";
        if (v1.major !== v2.major) {
          return prefix + "major";
        }
        if (v1.minor !== v2.minor) {
          return prefix + "minor";
        }
        if (v1.patch !== v2.patch) {
          return prefix + "patch";
        }
        return "prerelease";
      };
      module2.exports = diff;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/major.js
  var require_major = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/major.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var SemVer = require_semver();
      var major = (a, loose) => new SemVer(a, loose).major;
      module2.exports = major;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/minor.js
  var require_minor = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/minor.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var SemVer = require_semver();
      var minor = (a, loose) => new SemVer(a, loose).minor;
      module2.exports = minor;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/patch.js
  var require_patch = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/patch.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var SemVer = require_semver();
      var patch = (a, loose) => new SemVer(a, loose).patch;
      module2.exports = patch;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/prerelease.js
  var require_prerelease = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/prerelease.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var parse4 = require_parse2();
      var prerelease = (version3, options) => {
        const parsed = parse4(version3, options);
        return parsed && parsed.prerelease.length ? parsed.prerelease : null;
      };
      module2.exports = prerelease;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/compare.js
  var require_compare = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/compare.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var SemVer = require_semver();
      var compare = (a, b, loose) => new SemVer(a, loose).compare(new SemVer(b, loose));
      module2.exports = compare;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/rcompare.js
  var require_rcompare = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/rcompare.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var compare = require_compare();
      var rcompare = (a, b, loose) => compare(b, a, loose);
      module2.exports = rcompare;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/compare-loose.js
  var require_compare_loose = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/compare-loose.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var compare = require_compare();
      var compareLoose = (a, b) => compare(a, b, true);
      module2.exports = compareLoose;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/compare-build.js
  var require_compare_build = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/compare-build.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var SemVer = require_semver();
      var compareBuild = (a, b, loose) => {
        const versionA = new SemVer(a, loose);
        const versionB = new SemVer(b, loose);
        return versionA.compare(versionB) || versionA.compareBuild(versionB);
      };
      module2.exports = compareBuild;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/sort.js
  var require_sort = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/sort.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var compareBuild = require_compare_build();
      var sort = (list, loose) => list.sort((a, b) => compareBuild(a, b, loose));
      module2.exports = sort;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/rsort.js
  var require_rsort = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/rsort.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var compareBuild = require_compare_build();
      var rsort = (list, loose) => list.sort((a, b) => compareBuild(b, a, loose));
      module2.exports = rsort;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/gt.js
  var require_gt = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/gt.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var compare = require_compare();
      var gt2 = (a, b, loose) => compare(a, b, loose) > 0;
      module2.exports = gt2;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/lt.js
  var require_lt = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/lt.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var compare = require_compare();
      var lt2 = (a, b, loose) => compare(a, b, loose) < 0;
      module2.exports = lt2;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/eq.js
  var require_eq = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/eq.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var compare = require_compare();
      var eq2 = (a, b, loose) => compare(a, b, loose) === 0;
      module2.exports = eq2;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/neq.js
  var require_neq = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/neq.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var compare = require_compare();
      var neq = (a, b, loose) => compare(a, b, loose) !== 0;
      module2.exports = neq;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/gte.js
  var require_gte = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/gte.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var compare = require_compare();
      var gte2 = (a, b, loose) => compare(a, b, loose) >= 0;
      module2.exports = gte2;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/lte.js
  var require_lte = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/lte.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var compare = require_compare();
      var lte2 = (a, b, loose) => compare(a, b, loose) <= 0;
      module2.exports = lte2;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/cmp.js
  var require_cmp = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/cmp.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var eq2 = require_eq();
      var neq = require_neq();
      var gt2 = require_gt();
      var gte2 = require_gte();
      var lt2 = require_lt();
      var lte2 = require_lte();
      var cmp = (a, op, b, loose) => {
        switch (op) {
          case "===":
            if (typeof a === "object") {
              a = a.version;
            }
            if (typeof b === "object") {
              b = b.version;
            }
            return a === b;
          case "!==":
            if (typeof a === "object") {
              a = a.version;
            }
            if (typeof b === "object") {
              b = b.version;
            }
            return a !== b;
          case "":
          case "=":
          case "==":
            return eq2(a, b, loose);
          case "!=":
            return neq(a, b, loose);
          case ">":
            return gt2(a, b, loose);
          case ">=":
            return gte2(a, b, loose);
          case "<":
            return lt2(a, b, loose);
          case "<=":
            return lte2(a, b, loose);
          default:
            throw new TypeError(`Invalid operator: ${op}`);
        }
      };
      module2.exports = cmp;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/coerce.js
  var require_coerce = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/coerce.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var SemVer = require_semver();
      var parse4 = require_parse2();
      var { safeRe: re, t: t3 } = require_re();
      var coerce = (version3, options) => {
        if (version3 instanceof SemVer) {
          return version3;
        }
        if (typeof version3 === "number") {
          version3 = String(version3);
        }
        if (typeof version3 !== "string") {
          return null;
        }
        options = options || {};
        let match = null;
        if (!options.rtl) {
          match = version3.match(options.includePrerelease ? re[t3.COERCEFULL] : re[t3.COERCE]);
        } else {
          const coerceRtlRegex = options.includePrerelease ? re[t3.COERCERTLFULL] : re[t3.COERCERTL];
          let next;
          while ((next = coerceRtlRegex.exec(version3)) && (!match || match.index + match[0].length !== version3.length)) {
            if (!match || next.index + next[0].length !== match.index + match[0].length) {
              match = next;
            }
            coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
          }
          coerceRtlRegex.lastIndex = -1;
        }
        if (match === null) {
          return null;
        }
        const major = match[2];
        const minor = match[3] || "0";
        const patch = match[4] || "0";
        const prerelease = options.includePrerelease && match[5] ? `-${match[5]}` : "";
        const build = options.includePrerelease && match[6] ? `+${match[6]}` : "";
        return parse4(`${major}.${minor}.${patch}${prerelease}${build}`, options);
      };
      module2.exports = coerce;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/internal/lrucache.js
  var require_lrucache = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/internal/lrucache.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var LRUCache = class {
        constructor() {
          this.max = 1e3;
          this.map = /* @__PURE__ */ new Map();
        }
        get(key) {
          const value = this.map.get(key);
          if (value === void 0) {
            return void 0;
          } else {
            this.map.delete(key);
            this.map.set(key, value);
            return value;
          }
        }
        delete(key) {
          return this.map.delete(key);
        }
        set(key, value) {
          const deleted = this.delete(key);
          if (!deleted && value !== void 0) {
            if (this.map.size >= this.max) {
              const firstKey = this.map.keys().next().value;
              this.delete(firstKey);
            }
            this.map.set(key, value);
          }
          return this;
        }
      };
      module2.exports = LRUCache;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/classes/range.js
  var require_range = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/classes/range.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var SPACE_CHARACTERS = /\s+/g;
      var Range = class {
        constructor(range2, options) {
          options = parseOptions(options);
          if (range2 instanceof Range) {
            if (range2.loose === !!options.loose && range2.includePrerelease === !!options.includePrerelease) {
              return range2;
            } else {
              return new Range(range2.raw, options);
            }
          }
          if (range2 instanceof Comparator) {
            this.raw = range2.value;
            this.set = [[range2]];
            this.formatted = void 0;
            return this;
          }
          this.options = options;
          this.loose = !!options.loose;
          this.includePrerelease = !!options.includePrerelease;
          this.raw = range2.trim().replace(SPACE_CHARACTERS, " ");
          this.set = this.raw.split("||").map((r) => this.parseRange(r.trim())).filter((c) => c.length);
          if (!this.set.length) {
            throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
          }
          if (this.set.length > 1) {
            const first = this.set[0];
            this.set = this.set.filter((c) => !isNullSet(c[0]));
            if (this.set.length === 0) {
              this.set = [first];
            } else if (this.set.length > 1) {
              for (const c of this.set) {
                if (c.length === 1 && isAny(c[0])) {
                  this.set = [c];
                  break;
                }
              }
            }
          }
          this.formatted = void 0;
        }
        get range() {
          if (this.formatted === void 0) {
            this.formatted = "";
            for (let i = 0; i < this.set.length; i++) {
              if (i > 0) {
                this.formatted += "||";
              }
              const comps = this.set[i];
              for (let k = 0; k < comps.length; k++) {
                if (k > 0) {
                  this.formatted += " ";
                }
                this.formatted += comps[k].toString().trim();
              }
            }
          }
          return this.formatted;
        }
        format() {
          return this.range;
        }
        toString() {
          return this.range;
        }
        parseRange(range2) {
          const memoOpts = (this.options.includePrerelease && FLAG_INCLUDE_PRERELEASE) | (this.options.loose && FLAG_LOOSE);
          const memoKey = memoOpts + ":" + range2;
          const cached = cache.get(memoKey);
          if (cached) {
            return cached;
          }
          const loose = this.options.loose;
          const hr = loose ? re[t3.HYPHENRANGELOOSE] : re[t3.HYPHENRANGE];
          range2 = range2.replace(hr, hyphenReplace(this.options.includePrerelease));
          debug("hyphen replace", range2);
          range2 = range2.replace(re[t3.COMPARATORTRIM], comparatorTrimReplace);
          debug("comparator trim", range2);
          range2 = range2.replace(re[t3.TILDETRIM], tildeTrimReplace);
          debug("tilde trim", range2);
          range2 = range2.replace(re[t3.CARETTRIM], caretTrimReplace);
          debug("caret trim", range2);
          let rangeList = range2.split(" ").map((comp) => parseComparator(comp, this.options)).join(" ").split(/\s+/).map((comp) => replaceGTE0(comp, this.options));
          if (loose) {
            rangeList = rangeList.filter((comp) => {
              debug("loose invalid filter", comp, this.options);
              return !!comp.match(re[t3.COMPARATORLOOSE]);
            });
          }
          debug("range list", rangeList);
          const rangeMap = /* @__PURE__ */ new Map();
          const comparators = rangeList.map((comp) => new Comparator(comp, this.options));
          for (const comp of comparators) {
            if (isNullSet(comp)) {
              return [comp];
            }
            rangeMap.set(comp.value, comp);
          }
          if (rangeMap.size > 1 && rangeMap.has("")) {
            rangeMap.delete("");
          }
          const result2 = [...rangeMap.values()];
          cache.set(memoKey, result2);
          return result2;
        }
        intersects(range2, options) {
          if (!(range2 instanceof Range)) {
            throw new TypeError("a Range is required");
          }
          return this.set.some((thisComparators) => {
            return isSatisfiable(thisComparators, options) && range2.set.some((rangeComparators) => {
              return isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator) => {
                return rangeComparators.every((rangeComparator) => {
                  return thisComparator.intersects(rangeComparator, options);
                });
              });
            });
          });
        }
        test(version3) {
          if (!version3) {
            return false;
          }
          if (typeof version3 === "string") {
            try {
              version3 = new SemVer(version3, this.options);
            } catch (er) {
              return false;
            }
          }
          for (let i = 0; i < this.set.length; i++) {
            if (testSet(this.set[i], version3, this.options)) {
              return true;
            }
          }
          return false;
        }
      };
      module2.exports = Range;
      var LRU = require_lrucache();
      var cache = new LRU();
      var parseOptions = require_parse_options();
      var Comparator = require_comparator();
      var debug = require_debug2();
      var SemVer = require_semver();
      var {
        safeRe: re,
        t: t3,
        comparatorTrimReplace,
        tildeTrimReplace,
        caretTrimReplace
      } = require_re();
      var { FLAG_INCLUDE_PRERELEASE, FLAG_LOOSE } = require_constants2();
      var isNullSet = (c) => c.value === "<0.0.0-0";
      var isAny = (c) => c.value === "";
      var isSatisfiable = (comparators, options) => {
        let result2 = true;
        const remainingComparators = comparators.slice();
        let testComparator = remainingComparators.pop();
        while (result2 && remainingComparators.length) {
          result2 = remainingComparators.every((otherComparator) => {
            return testComparator.intersects(otherComparator, options);
          });
          testComparator = remainingComparators.pop();
        }
        return result2;
      };
      var parseComparator = (comp, options) => {
        debug("comp", comp, options);
        comp = replaceCarets(comp, options);
        debug("caret", comp);
        comp = replaceTildes(comp, options);
        debug("tildes", comp);
        comp = replaceXRanges(comp, options);
        debug("xrange", comp);
        comp = replaceStars(comp, options);
        debug("stars", comp);
        return comp;
      };
      var isX = (id) => !id || id.toLowerCase() === "x" || id === "*";
      var replaceTildes = (comp, options) => {
        return comp.trim().split(/\s+/).map((c) => replaceTilde(c, options)).join(" ");
      };
      var replaceTilde = (comp, options) => {
        const r = options.loose ? re[t3.TILDELOOSE] : re[t3.TILDE];
        return comp.replace(r, (_, M, m, p, pr) => {
          debug("tilde", comp, _, M, m, p, pr);
          let ret;
          if (isX(M)) {
            ret = "";
          } else if (isX(m)) {
            ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
          } else if (isX(p)) {
            ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
          } else if (pr) {
            debug("replaceTilde pr", pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
          } else {
            ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
          }
          debug("tilde return", ret);
          return ret;
        });
      };
      var replaceCarets = (comp, options) => {
        return comp.trim().split(/\s+/).map((c) => replaceCaret(c, options)).join(" ");
      };
      var replaceCaret = (comp, options) => {
        debug("caret", comp, options);
        const r = options.loose ? re[t3.CARETLOOSE] : re[t3.CARET];
        const z = options.includePrerelease ? "-0" : "";
        return comp.replace(r, (_, M, m, p, pr) => {
          debug("caret", comp, _, M, m, p, pr);
          let ret;
          if (isX(M)) {
            ret = "";
          } else if (isX(m)) {
            ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
          } else if (isX(p)) {
            if (M === "0") {
              ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            } else {
              ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
            }
          } else if (pr) {
            debug("replaceCaret pr", pr);
            if (M === "0") {
              if (m === "0") {
                ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
              } else {
                ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
              }
            } else {
              ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
            }
          } else {
            debug("no pr");
            if (M === "0") {
              if (m === "0") {
                ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
              } else {
                ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
              }
            } else {
              ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
            }
          }
          debug("caret return", ret);
          return ret;
        });
      };
      var replaceXRanges = (comp, options) => {
        debug("replaceXRanges", comp, options);
        return comp.split(/\s+/).map((c) => replaceXRange(c, options)).join(" ");
      };
      var replaceXRange = (comp, options) => {
        comp = comp.trim();
        const r = options.loose ? re[t3.XRANGELOOSE] : re[t3.XRANGE];
        return comp.replace(r, (ret, gtlt, M, m, p, pr) => {
          debug("xRange", comp, ret, gtlt, M, m, p, pr);
          const xM = isX(M);
          const xm = xM || isX(m);
          const xp = xm || isX(p);
          const anyX = xp;
          if (gtlt === "=" && anyX) {
            gtlt = "";
          }
          pr = options.includePrerelease ? "-0" : "";
          if (xM) {
            if (gtlt === ">" || gtlt === "<") {
              ret = "<0.0.0-0";
            } else {
              ret = "*";
            }
          } else if (gtlt && anyX) {
            if (xm) {
              m = 0;
            }
            p = 0;
            if (gtlt === ">") {
              gtlt = ">=";
              if (xm) {
                M = +M + 1;
                m = 0;
                p = 0;
              } else {
                m = +m + 1;
                p = 0;
              }
            } else if (gtlt === "<=") {
              gtlt = "<";
              if (xm) {
                M = +M + 1;
              } else {
                m = +m + 1;
              }
            }
            if (gtlt === "<") {
              pr = "-0";
            }
            ret = `${gtlt + M}.${m}.${p}${pr}`;
          } else if (xm) {
            ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
          } else if (xp) {
            ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
          }
          debug("xRange return", ret);
          return ret;
        });
      };
      var replaceStars = (comp, options) => {
        debug("replaceStars", comp, options);
        return comp.trim().replace(re[t3.STAR], "");
      };
      var replaceGTE0 = (comp, options) => {
        debug("replaceGTE0", comp, options);
        return comp.trim().replace(re[options.includePrerelease ? t3.GTE0PRE : t3.GTE0], "");
      };
      var hyphenReplace = (incPr) => ($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr) => {
        if (isX(fM)) {
          from = "";
        } else if (isX(fm)) {
          from = `>=${fM}.0.0${incPr ? "-0" : ""}`;
        } else if (isX(fp)) {
          from = `>=${fM}.${fm}.0${incPr ? "-0" : ""}`;
        } else if (fpr) {
          from = `>=${from}`;
        } else {
          from = `>=${from}${incPr ? "-0" : ""}`;
        }
        if (isX(tM)) {
          to = "";
        } else if (isX(tm)) {
          to = `<${+tM + 1}.0.0-0`;
        } else if (isX(tp)) {
          to = `<${tM}.${+tm + 1}.0-0`;
        } else if (tpr) {
          to = `<=${tM}.${tm}.${tp}-${tpr}`;
        } else if (incPr) {
          to = `<${tM}.${tm}.${+tp + 1}-0`;
        } else {
          to = `<=${to}`;
        }
        return `${from} ${to}`.trim();
      };
      var testSet = (set2, version3, options) => {
        for (let i = 0; i < set2.length; i++) {
          if (!set2[i].test(version3)) {
            return false;
          }
        }
        if (version3.prerelease.length && !options.includePrerelease) {
          for (let i = 0; i < set2.length; i++) {
            debug(set2[i].semver);
            if (set2[i].semver === Comparator.ANY) {
              continue;
            }
            if (set2[i].semver.prerelease.length > 0) {
              const allowed = set2[i].semver;
              if (allowed.major === version3.major && allowed.minor === version3.minor && allowed.patch === version3.patch) {
                return true;
              }
            }
          }
          return false;
        }
        return true;
      };
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/classes/comparator.js
  var require_comparator = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/classes/comparator.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var ANY = Symbol("SemVer ANY");
      var Comparator = class {
        static get ANY() {
          return ANY;
        }
        constructor(comp, options) {
          options = parseOptions(options);
          if (comp instanceof Comparator) {
            if (comp.loose === !!options.loose) {
              return comp;
            } else {
              comp = comp.value;
            }
          }
          comp = comp.trim().split(/\s+/).join(" ");
          debug("comparator", comp, options);
          this.options = options;
          this.loose = !!options.loose;
          this.parse(comp);
          if (this.semver === ANY) {
            this.value = "";
          } else {
            this.value = this.operator + this.semver.version;
          }
          debug("comp", this);
        }
        parse(comp) {
          const r = this.options.loose ? re[t3.COMPARATORLOOSE] : re[t3.COMPARATOR];
          const m = comp.match(r);
          if (!m) {
            throw new TypeError(`Invalid comparator: ${comp}`);
          }
          this.operator = m[1] !== void 0 ? m[1] : "";
          if (this.operator === "=") {
            this.operator = "";
          }
          if (!m[2]) {
            this.semver = ANY;
          } else {
            this.semver = new SemVer(m[2], this.options.loose);
          }
        }
        toString() {
          return this.value;
        }
        test(version3) {
          debug("Comparator.test", version3, this.options.loose);
          if (this.semver === ANY || version3 === ANY) {
            return true;
          }
          if (typeof version3 === "string") {
            try {
              version3 = new SemVer(version3, this.options);
            } catch (er) {
              return false;
            }
          }
          return cmp(version3, this.operator, this.semver, this.options);
        }
        intersects(comp, options) {
          if (!(comp instanceof Comparator)) {
            throw new TypeError("a Comparator is required");
          }
          if (this.operator === "") {
            if (this.value === "") {
              return true;
            }
            return new Range(comp.value, options).test(this.value);
          } else if (comp.operator === "") {
            if (comp.value === "") {
              return true;
            }
            return new Range(this.value, options).test(comp.semver);
          }
          options = parseOptions(options);
          if (options.includePrerelease && (this.value === "<0.0.0-0" || comp.value === "<0.0.0-0")) {
            return false;
          }
          if (!options.includePrerelease && (this.value.startsWith("<0.0.0") || comp.value.startsWith("<0.0.0"))) {
            return false;
          }
          if (this.operator.startsWith(">") && comp.operator.startsWith(">")) {
            return true;
          }
          if (this.operator.startsWith("<") && comp.operator.startsWith("<")) {
            return true;
          }
          if (this.semver.version === comp.semver.version && this.operator.includes("=") && comp.operator.includes("=")) {
            return true;
          }
          if (cmp(this.semver, "<", comp.semver, options) && this.operator.startsWith(">") && comp.operator.startsWith("<")) {
            return true;
          }
          if (cmp(this.semver, ">", comp.semver, options) && this.operator.startsWith("<") && comp.operator.startsWith(">")) {
            return true;
          }
          return false;
        }
      };
      module2.exports = Comparator;
      var parseOptions = require_parse_options();
      var { safeRe: re, t: t3 } = require_re();
      var cmp = require_cmp();
      var debug = require_debug2();
      var SemVer = require_semver();
      var Range = require_range();
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/satisfies.js
  var require_satisfies = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/functions/satisfies.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var Range = require_range();
      var satisfies = (version3, range2, options) => {
        try {
          range2 = new Range(range2, options);
        } catch (er) {
          return false;
        }
        return range2.test(version3);
      };
      module2.exports = satisfies;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/to-comparators.js
  var require_to_comparators = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/to-comparators.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var Range = require_range();
      var toComparators = (range2, options) => new Range(range2, options).set.map((comp) => comp.map((c) => c.value).join(" ").trim().split(" "));
      module2.exports = toComparators;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/max-satisfying.js
  var require_max_satisfying = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/max-satisfying.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var SemVer = require_semver();
      var Range = require_range();
      var maxSatisfying = (versions3, range2, options) => {
        let max2 = null;
        let maxSV = null;
        let rangeObj = null;
        try {
          rangeObj = new Range(range2, options);
        } catch (er) {
          return null;
        }
        versions3.forEach((v) => {
          if (rangeObj.test(v)) {
            if (!max2 || maxSV.compare(v) === -1) {
              max2 = v;
              maxSV = new SemVer(max2, options);
            }
          }
        });
        return max2;
      };
      module2.exports = maxSatisfying;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/min-satisfying.js
  var require_min_satisfying = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/min-satisfying.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var SemVer = require_semver();
      var Range = require_range();
      var minSatisfying = (versions3, range2, options) => {
        let min2 = null;
        let minSV = null;
        let rangeObj = null;
        try {
          rangeObj = new Range(range2, options);
        } catch (er) {
          return null;
        }
        versions3.forEach((v) => {
          if (rangeObj.test(v)) {
            if (!min2 || minSV.compare(v) === 1) {
              min2 = v;
              minSV = new SemVer(min2, options);
            }
          }
        });
        return min2;
      };
      module2.exports = minSatisfying;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/min-version.js
  var require_min_version = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/min-version.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var SemVer = require_semver();
      var Range = require_range();
      var gt2 = require_gt();
      var minVersion = (range2, loose) => {
        range2 = new Range(range2, loose);
        let minver = new SemVer("0.0.0");
        if (range2.test(minver)) {
          return minver;
        }
        minver = new SemVer("0.0.0-0");
        if (range2.test(minver)) {
          return minver;
        }
        minver = null;
        for (let i = 0; i < range2.set.length; ++i) {
          const comparators = range2.set[i];
          let setMin = null;
          comparators.forEach((comparator) => {
            const compver = new SemVer(comparator.semver.version);
            switch (comparator.operator) {
              case ">":
                if (compver.prerelease.length === 0) {
                  compver.patch++;
                } else {
                  compver.prerelease.push(0);
                }
                compver.raw = compver.format();
              case "":
              case ">=":
                if (!setMin || gt2(compver, setMin)) {
                  setMin = compver;
                }
                break;
              case "<":
              case "<=":
                break;
              default:
                throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
          });
          if (setMin && (!minver || gt2(minver, setMin))) {
            minver = setMin;
          }
        }
        if (minver && range2.test(minver)) {
          return minver;
        }
        return null;
      };
      module2.exports = minVersion;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/valid.js
  var require_valid2 = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/valid.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var Range = require_range();
      var validRange = (range2, options) => {
        try {
          return new Range(range2, options).range || "*";
        } catch (er) {
          return null;
        }
      };
      module2.exports = validRange;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/outside.js
  var require_outside = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/outside.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var SemVer = require_semver();
      var Comparator = require_comparator();
      var { ANY } = Comparator;
      var Range = require_range();
      var satisfies = require_satisfies();
      var gt2 = require_gt();
      var lt2 = require_lt();
      var lte2 = require_lte();
      var gte2 = require_gte();
      var outside = (version3, range2, hilo, options) => {
        version3 = new SemVer(version3, options);
        range2 = new Range(range2, options);
        let gtfn, ltefn, ltfn, comp, ecomp;
        switch (hilo) {
          case ">":
            gtfn = gt2;
            ltefn = lte2;
            ltfn = lt2;
            comp = ">";
            ecomp = ">=";
            break;
          case "<":
            gtfn = lt2;
            ltefn = gte2;
            ltfn = gt2;
            comp = "<";
            ecomp = "<=";
            break;
          default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
        }
        if (satisfies(version3, range2, options)) {
          return false;
        }
        for (let i = 0; i < range2.set.length; ++i) {
          const comparators = range2.set[i];
          let high = null;
          let low = null;
          comparators.forEach((comparator) => {
            if (comparator.semver === ANY) {
              comparator = new Comparator(">=0.0.0");
            }
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) {
              high = comparator;
            } else if (ltfn(comparator.semver, low.semver, options)) {
              low = comparator;
            }
          });
          if (high.operator === comp || high.operator === ecomp) {
            return false;
          }
          if ((!low.operator || low.operator === comp) && ltefn(version3, low.semver)) {
            return false;
          } else if (low.operator === ecomp && ltfn(version3, low.semver)) {
            return false;
          }
        }
        return true;
      };
      module2.exports = outside;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/gtr.js
  var require_gtr = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/gtr.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var outside = require_outside();
      var gtr = (version3, range2, options) => outside(version3, range2, ">", options);
      module2.exports = gtr;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/ltr.js
  var require_ltr = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/ltr.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var outside = require_outside();
      var ltr = (version3, range2, options) => outside(version3, range2, "<", options);
      module2.exports = ltr;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/intersects.js
  var require_intersects = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/intersects.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var Range = require_range();
      var intersects = (r1, r2, options) => {
        r1 = new Range(r1, options);
        r2 = new Range(r2, options);
        return r1.intersects(r2, options);
      };
      module2.exports = intersects;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/simplify.js
  var require_simplify = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/simplify.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var satisfies = require_satisfies();
      var compare = require_compare();
      module2.exports = (versions3, range2, options) => {
        const set2 = [];
        let first = null;
        let prev = null;
        const v = versions3.sort((a, b) => compare(a, b, options));
        for (const version3 of v) {
          const included = satisfies(version3, range2, options);
          if (included) {
            prev = version3;
            if (!first) {
              first = version3;
            }
          } else {
            if (prev) {
              set2.push([first, prev]);
            }
            prev = null;
            first = null;
          }
        }
        if (first) {
          set2.push([first, null]);
        }
        const ranges = [];
        for (const [min2, max2] of set2) {
          if (min2 === max2) {
            ranges.push(min2);
          } else if (!max2 && min2 === v[0]) {
            ranges.push("*");
          } else if (!max2) {
            ranges.push(`>=${min2}`);
          } else if (min2 === v[0]) {
            ranges.push(`<=${max2}`);
          } else {
            ranges.push(`${min2} - ${max2}`);
          }
        }
        const simplified = ranges.join(" || ");
        const original = typeof range2.raw === "string" ? range2.raw : String(range2);
        return simplified.length < original.length ? simplified : range2;
      };
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/subset.js
  var require_subset = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/ranges/subset.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var Range = require_range();
      var Comparator = require_comparator();
      var { ANY } = Comparator;
      var satisfies = require_satisfies();
      var compare = require_compare();
      var subset = (sub, dom, options = {}) => {
        if (sub === dom) {
          return true;
        }
        sub = new Range(sub, options);
        dom = new Range(dom, options);
        let sawNonNull = false;
        OUTER:
          for (const simpleSub of sub.set) {
            for (const simpleDom of dom.set) {
              const isSub = simpleSubset(simpleSub, simpleDom, options);
              sawNonNull = sawNonNull || isSub !== null;
              if (isSub) {
                continue OUTER;
              }
            }
            if (sawNonNull) {
              return false;
            }
          }
        return true;
      };
      var minimumVersionWithPreRelease = [new Comparator(">=0.0.0-0")];
      var minimumVersion = [new Comparator(">=0.0.0")];
      var simpleSubset = (sub, dom, options) => {
        if (sub === dom) {
          return true;
        }
        if (sub.length === 1 && sub[0].semver === ANY) {
          if (dom.length === 1 && dom[0].semver === ANY) {
            return true;
          } else if (options.includePrerelease) {
            sub = minimumVersionWithPreRelease;
          } else {
            sub = minimumVersion;
          }
        }
        if (dom.length === 1 && dom[0].semver === ANY) {
          if (options.includePrerelease) {
            return true;
          } else {
            dom = minimumVersion;
          }
        }
        const eqSet = /* @__PURE__ */ new Set();
        let gt2, lt2;
        for (const c of sub) {
          if (c.operator === ">" || c.operator === ">=") {
            gt2 = higherGT(gt2, c, options);
          } else if (c.operator === "<" || c.operator === "<=") {
            lt2 = lowerLT(lt2, c, options);
          } else {
            eqSet.add(c.semver);
          }
        }
        if (eqSet.size > 1) {
          return null;
        }
        let gtltComp;
        if (gt2 && lt2) {
          gtltComp = compare(gt2.semver, lt2.semver, options);
          if (gtltComp > 0) {
            return null;
          } else if (gtltComp === 0 && (gt2.operator !== ">=" || lt2.operator !== "<=")) {
            return null;
          }
        }
        for (const eq2 of eqSet) {
          if (gt2 && !satisfies(eq2, String(gt2), options)) {
            return null;
          }
          if (lt2 && !satisfies(eq2, String(lt2), options)) {
            return null;
          }
          for (const c of dom) {
            if (!satisfies(eq2, String(c), options)) {
              return false;
            }
          }
          return true;
        }
        let higher, lower;
        let hasDomLT, hasDomGT;
        let needDomLTPre = lt2 && !options.includePrerelease && lt2.semver.prerelease.length ? lt2.semver : false;
        let needDomGTPre = gt2 && !options.includePrerelease && gt2.semver.prerelease.length ? gt2.semver : false;
        if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt2.operator === "<" && needDomLTPre.prerelease[0] === 0) {
          needDomLTPre = false;
        }
        for (const c of dom) {
          hasDomGT = hasDomGT || c.operator === ">" || c.operator === ">=";
          hasDomLT = hasDomLT || c.operator === "<" || c.operator === "<=";
          if (gt2) {
            if (needDomGTPre) {
              if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) {
                needDomGTPre = false;
              }
            }
            if (c.operator === ">" || c.operator === ">=") {
              higher = higherGT(gt2, c, options);
              if (higher === c && higher !== gt2) {
                return false;
              }
            } else if (gt2.operator === ">=" && !satisfies(gt2.semver, String(c), options)) {
              return false;
            }
          }
          if (lt2) {
            if (needDomLTPre) {
              if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) {
                needDomLTPre = false;
              }
            }
            if (c.operator === "<" || c.operator === "<=") {
              lower = lowerLT(lt2, c, options);
              if (lower === c && lower !== lt2) {
                return false;
              }
            } else if (lt2.operator === "<=" && !satisfies(lt2.semver, String(c), options)) {
              return false;
            }
          }
          if (!c.operator && (lt2 || gt2) && gtltComp !== 0) {
            return false;
          }
        }
        if (gt2 && hasDomLT && !lt2 && gtltComp !== 0) {
          return false;
        }
        if (lt2 && hasDomGT && !gt2 && gtltComp !== 0) {
          return false;
        }
        if (needDomGTPre || needDomLTPre) {
          return false;
        }
        return true;
      };
      var higherGT = (a, b, options) => {
        if (!a) {
          return b;
        }
        const comp = compare(a.semver, b.semver, options);
        return comp > 0 ? a : comp < 0 ? b : b.operator === ">" && a.operator === ">=" ? b : a;
      };
      var lowerLT = (a, b, options) => {
        if (!a) {
          return b;
        }
        const comp = compare(a.semver, b.semver, options);
        return comp < 0 ? a : comp > 0 ? b : b.operator === "<" && a.operator === "<=" ? b : a;
      };
      module2.exports = subset;
    }
  });

  // ../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/index.js
  var require_semver2 = __commonJS({
    "../../node_modules/.pnpm/semver@7.7.1/node_modules/semver/index.js"(exports8, module2) {
      init_define_process();
      init_dirname();
      init_buffer2();
      init_process2();
      var internalRe = require_re();
      var constants = require_constants2();
      var SemVer = require_semver();
      var identifiers = require_identifiers();
      var parse4 = require_parse2();
      var valid = require_valid();
      var clean = require_clean();
      var inc = require_inc();
      var diff = require_diff();
      var major = require_major();
      var minor = require_minor();
      var patch = require_patch();
      var prerelease = require_prerelease();
      var compare = require_compare();
      var rcompare = require_rcompare();
      var compareLoose = require_compare_loose();
      var compareBuild = require_compare_build();
      var sort = require_sort();
      var rsort = require_rsort();
      var gt2 = require_gt();
      var lt2 = require_lt();
      var eq2 = require_eq();
      var neq = require_neq();
      var gte2 = require_gte();
      var lte2 = require_lte();
      var cmp = require_cmp();
      var coerce = require_coerce();
      var Comparator = require_comparator();
      var Range = require_range();
      var satisfies = require_satisfies();
      var toComparators = require_to_comparators();
      var maxSatisfying = require_max_satisfying();
      var minSatisfying = require_min_satisfying();
      var minVersion = require_min_version();
      var validRange = require_valid2();
      var outside = require_outside();
      var gtr = require_gtr();
      var ltr = require_ltr();
      var intersects = require_intersects();
      var simplifyRange = require_simplify();
      var subset = require_subset();
      module2.exports = {
        parse: parse4,
        valid,
        clean,
        inc,
        diff,
        major,
        minor,
        patch,
        prerelease,
        compare,
        rcompare,
        compareLoose,
        compareBuild,
        sort,
        rsort,
        gt: gt2,
        lt: lt2,
        eq: eq2,
        neq,
        gte: gte2,
        lte: lte2,
        cmp,
        coerce,
        Comparator,
        Range,
        satisfies,
        toComparators,
        maxSatisfying,
        minSatisfying,
        minVersion,
        validRange,
        outside,
        gtr,
        ltr,
        intersects,
        simplifyRange,
        subset,
        SemVer,
        re: internalRe.re,
        src: internalRe.src,
        tokens: internalRe.t,
        SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
        RELEASE_TYPES: constants.RELEASE_TYPES,
        compareIdentifiers: identifiers.compareIdentifiers,
        rcompareIdentifiers: identifiers.rcompareIdentifiers
      };
    }
  });

  // src/standalone-worker.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/standalone.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/polyfills/buffer.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  init_buffer();
  if (self && !self.Buffer) {
    Object.assign(self, {
      Buffer: Buffer2
    });
  }

  // src/generator/ProjectBuilder.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/parser/SchemaParser.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/types/index.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/types/core.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/types/deps.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/types/error.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var CodeGeneratorError = class extends Error {
    constructor(message, detail) {
      super(message);
      __publicField(this, "detail");
      this.name = this.constructor.name;
      this.detail = detail;
      Object.setPrototypeOf(this, new.target.prototype);
    }
  };
  var CompatibilityError = class extends CodeGeneratorError {
  };
  var PublisherError = class extends CodeGeneratorError {
  };

  // src/types/analyze.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/types/intermediate.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/types/publisher.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/types/jsx.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/types/statements.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var TARGET_FILE_TO_SUBMODULE = {
    "services.ts": "services",
    "store.ts": "store",
    "hooks.ts": "hooks",
    "constants.ts": "constants",
    "utils.ts": "utils",
    "types.ts": "types",
    "schema.tsx": "schema",
    "index.tsx": "index"
  };
  var TARGET_FILE_TO_FILETYPE = {
    "services.ts": "ts",
    "store.ts": "ts",
    "hooks.ts": "ts",
    "constants.ts": "ts",
    "utils.ts": "ts",
    "types.ts": "ts",
    "schema.tsx": "tsx",
    "index.tsx": "tsx"
  };
  function getSubModuleFromTargetFile(targetFile) {
    if (targetFile in TARGET_FILE_TO_SUBMODULE) {
      return TARGET_FILE_TO_SUBMODULE[targetFile];
    }
    return targetFile.replace(/\.(tsx?|jsx?)$/, "");
  }
  function getFileTypeFromTargetFile(targetFile) {
    if (targetFile in TARGET_FILE_TO_FILETYPE) {
      return TARGET_FILE_TO_FILETYPE[targetFile];
    }
    const match = targetFile.match(/\.(tsx|jsx|ts|js)$/);
    return match ? match[1] : "ts";
  }
  function getImportPathFromTargetFile(targetFile) {
    const subModule = getSubModuleFromTargetFile(targetFile);
    return `./${subModule}`;
  }
  var DEFAULT_TARGET_FILE = "index.tsx";

  // src/const/index.ts
  var const_exports = {};
  __export(const_exports, {
    BUILTIN_SLOT_NAMES: () => BUILTIN_SLOT_NAMES,
    CLASS_DEFINE_CHUNK_NAME: () => CLASS_DEFINE_CHUNK_NAME,
    COMMON_CHUNK_NAME: () => COMMON_CHUNK_NAME,
    COMMON_SUB_MODULE_NAME: () => COMMON_SUB_MODULE_NAME,
    CONTAINER_TYPE: () => CONTAINER_TYPE,
    DEFAULT_LINK_AFTER: () => DEFAULT_LINK_AFTER,
    FILE_TYPE_FAMILY: () => FILE_TYPE_FAMILY,
    FUNCTION_DEFINE_CHUNK_NAME: () => FUNCTION_DEFINE_CHUNK_NAME,
    NATIVE_ELE_PKG: () => NATIVE_ELE_PKG,
    SUPPORT_SCHEMA_VERSION_LIST: () => SUPPORT_SCHEMA_VERSION_LIST,
    isBuiltinSlotName: () => isBuiltinSlotName
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/const/file.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var FILE_TYPE_FAMILY = [["tsx" /* TSX */, "ts" /* TS */, "jsx" /* JSX */, "js" /* JS */]];

  // src/const/generator.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var COMMON_CHUNK_NAME = {
    ExternalDepsImport: "CommonExternalDependencyImport",
    InternalDepsImport: "CommonInternalDependencyImport",
    ImportAliasDefine: "CommonImportAliasDefine",
    FileVarDefine: "CommonFileScopeVarDefine",
    FileUtilDefine: "CommonFileScopeMethodDefine",
    FileMainContent: "CommonFileMainContent",
    FileExport: "CommonFileExport",
    StyleDepsImport: "CommonStyleDepsImport",
    StyleCssContent: "CommonStyleCssContent",
    HtmlContent: "CommonHtmlContent",
    CustomContent: "CommonCustomContent"
  };
  var CLASS_DEFINE_CHUNK_NAME = {
    Start: "CommonClassDefineStart",
    ConstructorStart: "CommonClassDefineConstructorStart",
    ConstructorContent: "CommonClassDefineConstructorContent",
    ConstructorEnd: "CommonClassDefineConstructorEnd",
    StaticVar: "CommonClassDefineStaticVar",
    StaticMethod: "CommonClassDefineStaticMethod",
    InsVar: "CommonClassDefineInsVar",
    InsVarMethod: "CommonClassDefineInsVarMethod",
    InsMethod: "CommonClassDefineInsMethod",
    InsPrivateMethod: "CommonClassDefineInsPrivateMethod",
    End: "CommonClassDefineEnd"
  };
  var FUNCTION_DEFINE_CHUNK_NAME = {
    Start: "CommonFunctionDefineStart",
    InsStatement: "CommonFunctionDefineInsStatement",
    End: "CommonFunctionDefineEnd"
  };
  var DEFAULT_LINK_AFTER = {
    [COMMON_CHUNK_NAME.ExternalDepsImport]: [],
    [COMMON_CHUNK_NAME.InternalDepsImport]: [COMMON_CHUNK_NAME.ExternalDepsImport],
    [COMMON_CHUNK_NAME.ImportAliasDefine]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport
    ],
    [COMMON_CHUNK_NAME.FileVarDefine]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine
    ],
    [COMMON_CHUNK_NAME.FileUtilDefine]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine,
      COMMON_CHUNK_NAME.FileVarDefine
    ],
    [CLASS_DEFINE_CHUNK_NAME.Start]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine,
      COMMON_CHUNK_NAME.FileVarDefine,
      COMMON_CHUNK_NAME.FileUtilDefine
    ],
    [CLASS_DEFINE_CHUNK_NAME.ConstructorStart]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod,
      CLASS_DEFINE_CHUNK_NAME.InsVar,
      CLASS_DEFINE_CHUNK_NAME.InsVarMethod
    ],
    [CLASS_DEFINE_CHUNK_NAME.ConstructorContent]: [CLASS_DEFINE_CHUNK_NAME.ConstructorStart],
    [CLASS_DEFINE_CHUNK_NAME.ConstructorEnd]: [
      CLASS_DEFINE_CHUNK_NAME.ConstructorStart,
      CLASS_DEFINE_CHUNK_NAME.ConstructorContent
    ],
    [CLASS_DEFINE_CHUNK_NAME.StaticVar]: [CLASS_DEFINE_CHUNK_NAME.Start],
    [CLASS_DEFINE_CHUNK_NAME.StaticMethod]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar
    ],
    [CLASS_DEFINE_CHUNK_NAME.InsVar]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod
    ],
    [CLASS_DEFINE_CHUNK_NAME.InsVarMethod]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod,
      CLASS_DEFINE_CHUNK_NAME.InsVar
    ],
    [CLASS_DEFINE_CHUNK_NAME.InsMethod]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod,
      CLASS_DEFINE_CHUNK_NAME.InsVar,
      CLASS_DEFINE_CHUNK_NAME.InsVarMethod,
      CLASS_DEFINE_CHUNK_NAME.ConstructorEnd
    ],
    [CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod,
      CLASS_DEFINE_CHUNK_NAME.InsVar,
      CLASS_DEFINE_CHUNK_NAME.InsVarMethod,
      CLASS_DEFINE_CHUNK_NAME.InsMethod,
      CLASS_DEFINE_CHUNK_NAME.ConstructorEnd
    ],
    [CLASS_DEFINE_CHUNK_NAME.End]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod,
      CLASS_DEFINE_CHUNK_NAME.InsVar,
      CLASS_DEFINE_CHUNK_NAME.InsVarMethod,
      CLASS_DEFINE_CHUNK_NAME.InsMethod,
      CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
      CLASS_DEFINE_CHUNK_NAME.ConstructorEnd
    ],
    [FUNCTION_DEFINE_CHUNK_NAME.Start]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine,
      COMMON_CHUNK_NAME.FileVarDefine,
      COMMON_CHUNK_NAME.FileUtilDefine
    ],
    [FUNCTION_DEFINE_CHUNK_NAME.End]: [
      FUNCTION_DEFINE_CHUNK_NAME.InsStatement
    ],
    [COMMON_CHUNK_NAME.FileMainContent]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine,
      COMMON_CHUNK_NAME.FileVarDefine,
      COMMON_CHUNK_NAME.FileUtilDefine,
      CLASS_DEFINE_CHUNK_NAME.End
    ],
    [COMMON_CHUNK_NAME.FileExport]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine,
      COMMON_CHUNK_NAME.FileVarDefine,
      COMMON_CHUNK_NAME.FileUtilDefine,
      CLASS_DEFINE_CHUNK_NAME.End,
      COMMON_CHUNK_NAME.FileMainContent
    ],
    [COMMON_CHUNK_NAME.StyleDepsImport]: [],
    [COMMON_CHUNK_NAME.StyleCssContent]: [COMMON_CHUNK_NAME.StyleDepsImport],
    [COMMON_CHUNK_NAME.HtmlContent]: []
  };
  var COMMON_SUB_MODULE_NAME = "index";

  // src/const/index.ts
  var NATIVE_ELE_PKG = "native";
  var CONTAINER_TYPE = {
    COMPONENT: "Component",
    BLOCK: "Block",
    PAGE: "Page"
  };
  var SUPPORT_SCHEMA_VERSION_LIST = ["0.0.1", "1.0.0"];
  var BUILTIN_SLOT_NAMES = [
    "pages",
    "components",
    "router",
    "entry",
    "appConfig",
    "buildConfig",
    "constants",
    "utils",
    "i18n",
    "globalStyle",
    "htmlEntry",
    "packageJSON",
    "lowcode.config",
    "demo"
  ];
  var isBuiltinSlotName = function(name) {
    return BUILTIN_SLOT_NAMES.includes(name);
  };

  // src/utils/errors.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getErrorMessage(error) {
    if (!error) {
      return null;
    }
    if (error instanceof Error) {
      return error.message;
    }
    if (typeof error === "string") {
      return error;
    }
    if (typeof error === "object" && error !== null) {
      return getErrorMessage(error.message) || getErrorMessage(error.errorMessage) || getErrorMessage(error.detail);
    }
    return null;
  }

  // src/utils/schema.ts
  var schema_exports = {};
  __export(schema_exports, {
    ContainerType: () => ContainerType,
    handleSubNodes: () => handleSubNodes,
    isContainerSchema: () => isContainerSchema,
    isNpmInfo: () => isNpmInfo,
    isValidContainerType: () => isValidContainerType
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/lodash.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/add.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createMathOperation.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseToNumber.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isSymbol.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseGetTag.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Symbol.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_root.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_freeGlobal.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
  var freeGlobal_default = freeGlobal;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_root.js
  var freeSelf = typeof self == "object" && self && self.Object === Object && self;
  var root = freeGlobal_default || freeSelf || Function("return this")();
  var root_default = root;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Symbol.js
  var Symbol2 = root_default.Symbol;
  var Symbol_default = Symbol2;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getRawTag.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var objectProto = Object.prototype;
  var hasOwnProperty2 = objectProto.hasOwnProperty;
  var nativeObjectToString = objectProto.toString;
  var symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
  function getRawTag(value) {
    var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
    try {
      value[symToStringTag] = void 0;
      var unmasked = true;
    } catch (e) {
    }
    var result2 = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result2;
  }
  var getRawTag_default = getRawTag;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_objectToString.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var objectProto2 = Object.prototype;
  var nativeObjectToString2 = objectProto2.toString;
  function objectToString(value) {
    return nativeObjectToString2.call(value);
  }
  var objectToString_default = objectToString;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseGetTag.js
  var nullTag = "[object Null]";
  var undefinedTag = "[object Undefined]";
  var symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
  function baseGetTag(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag : nullTag;
    }
    return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag_default(value) : objectToString_default(value);
  }
  var baseGetTag_default = baseGetTag;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isObjectLike.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isObjectLike(value) {
    return value != null && typeof value == "object";
  }
  var isObjectLike_default = isObjectLike;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isSymbol.js
  var symbolTag = "[object Symbol]";
  function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike_default(value) && baseGetTag_default(value) == symbolTag;
  }
  var isSymbol_default = isSymbol;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseToNumber.js
  var NAN = 0 / 0;
  function baseToNumber(value) {
    if (typeof value == "number") {
      return value;
    }
    if (isSymbol_default(value)) {
      return NAN;
    }
    return +value;
  }
  var baseToNumber_default = baseToNumber;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseToString.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayMap.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function arrayMap(array, iteratee2) {
    var index = -1, length = array == null ? 0 : array.length, result2 = Array(length);
    while (++index < length) {
      result2[index] = iteratee2(array[index], index, array);
    }
    return result2;
  }
  var arrayMap_default = arrayMap;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArray.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var isArray = Array.isArray;
  var isArray_default = isArray;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseToString.js
  var INFINITY = 1 / 0;
  var symbolProto = Symbol_default ? Symbol_default.prototype : void 0;
  var symbolToString = symbolProto ? symbolProto.toString : void 0;
  function baseToString(value) {
    if (typeof value == "string") {
      return value;
    }
    if (isArray_default(value)) {
      return arrayMap_default(value, baseToString) + "";
    }
    if (isSymbol_default(value)) {
      return symbolToString ? symbolToString.call(value) : "";
    }
    var result2 = value + "";
    return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
  }
  var baseToString_default = baseToString;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createMathOperation.js
  function createMathOperation(operator, defaultValue) {
    return function(value, other) {
      var result2;
      if (value === void 0 && other === void 0) {
        return defaultValue;
      }
      if (value !== void 0) {
        result2 = value;
      }
      if (other !== void 0) {
        if (result2 === void 0) {
          return other;
        }
        if (typeof value == "string" || typeof other == "string") {
          value = baseToString_default(value);
          other = baseToString_default(other);
        } else {
          value = baseToNumber_default(value);
          other = baseToNumber_default(other);
        }
        result2 = operator(value, other);
      }
      return result2;
    };
  }
  var createMathOperation_default = createMathOperation;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/add.js
  var add = createMathOperation_default(function(augend, addend) {
    return augend + addend;
  }, 0);
  var add_default = add;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/after.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toInteger.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toFinite.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toNumber.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseTrim.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_trimmedEndIndex.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var reWhitespace = /\s/;
  function trimmedEndIndex(string) {
    var index = string.length;
    while (index-- && reWhitespace.test(string.charAt(index))) {
    }
    return index;
  }
  var trimmedEndIndex_default = trimmedEndIndex;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseTrim.js
  var reTrimStart = /^\s+/;
  function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex_default(string) + 1).replace(reTrimStart, "") : string;
  }
  var baseTrim_default = baseTrim;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isObject.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
  }
  var isObject_default = isObject;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toNumber.js
  var NAN2 = 0 / 0;
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
  var reIsBinary = /^0b[01]+$/i;
  var reIsOctal = /^0o[0-7]+$/i;
  var freeParseInt = parseInt;
  function toNumber(value) {
    if (typeof value == "number") {
      return value;
    }
    if (isSymbol_default(value)) {
      return NAN2;
    }
    if (isObject_default(value)) {
      var other = typeof value.valueOf == "function" ? value.valueOf() : value;
      value = isObject_default(other) ? other + "" : other;
    }
    if (typeof value != "string") {
      return value === 0 ? value : +value;
    }
    value = baseTrim_default(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN2 : +value;
  }
  var toNumber_default = toNumber;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toFinite.js
  var INFINITY2 = 1 / 0;
  var MAX_INTEGER = 17976931348623157e292;
  function toFinite(value) {
    if (!value) {
      return value === 0 ? value : 0;
    }
    value = toNumber_default(value);
    if (value === INFINITY2 || value === -INFINITY2) {
      var sign = value < 0 ? -1 : 1;
      return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
  }
  var toFinite_default = toFinite;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toInteger.js
  function toInteger(value) {
    var result2 = toFinite_default(value), remainder = result2 % 1;
    return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
  }
  var toInteger_default = toInteger;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/after.js
  var FUNC_ERROR_TEXT = "Expected a function";
  function after(n, func) {
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    n = toInteger_default(n);
    return function() {
      if (--n < 1) {
        return func.apply(this, arguments);
      }
    };
  }
  var after_default = after;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/ary.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createWrap.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSetData.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/identity.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function identity(value) {
    return value;
  }
  var identity_default = identity;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_metaMap.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_WeakMap.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getNative.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsNative.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isFunction.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var asyncTag = "[object AsyncFunction]";
  var funcTag = "[object Function]";
  var genTag = "[object GeneratorFunction]";
  var proxyTag = "[object Proxy]";
  function isFunction(value) {
    if (!isObject_default(value)) {
      return false;
    }
    var tag = baseGetTag_default(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  var isFunction_default = isFunction;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isMasked.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_coreJsData.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var coreJsData = root_default["__core-js_shared__"];
  var coreJsData_default = coreJsData;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isMasked.js
  var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData_default && coreJsData_default.keys && coreJsData_default.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  var isMasked_default = isMasked;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_toSource.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var funcProto = Function.prototype;
  var funcToString = funcProto.toString;
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  var toSource_default = toSource;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsNative.js
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  var funcProto2 = Function.prototype;
  var objectProto3 = Object.prototype;
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty3 = objectProto3.hasOwnProperty;
  var reIsNative = RegExp(
    "^" + funcToString2.call(hasOwnProperty3).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function baseIsNative(value) {
    if (!isObject_default(value) || isMasked_default(value)) {
      return false;
    }
    var pattern = isFunction_default(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource_default(value));
  }
  var baseIsNative_default = baseIsNative;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getValue.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getValue(object, key) {
    return object == null ? void 0 : object[key];
  }
  var getValue_default = getValue;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getNative.js
  function getNative(object, key) {
    var value = getValue_default(object, key);
    return baseIsNative_default(value) ? value : void 0;
  }
  var getNative_default = getNative;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_WeakMap.js
  var WeakMap2 = getNative_default(root_default, "WeakMap");
  var WeakMap_default = WeakMap2;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_metaMap.js
  var metaMap = WeakMap_default && new WeakMap_default();
  var metaMap_default = metaMap;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSetData.js
  var baseSetData = !metaMap_default ? identity_default : function(func, data) {
    metaMap_default.set(func, data);
    return func;
  };
  var baseSetData_default = baseSetData;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createBind.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createCtor.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseCreate.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var objectCreate = Object.create;
  var baseCreate = function() {
    function object() {
    }
    return function(proto) {
      if (!isObject_default(proto)) {
        return {};
      }
      if (objectCreate) {
        return objectCreate(proto);
      }
      object.prototype = proto;
      var result2 = new object();
      object.prototype = void 0;
      return result2;
    };
  }();
  var baseCreate_default = baseCreate;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createCtor.js
  function createCtor(Ctor) {
    return function() {
      var args = arguments;
      switch (args.length) {
        case 0:
          return new Ctor();
        case 1:
          return new Ctor(args[0]);
        case 2:
          return new Ctor(args[0], args[1]);
        case 3:
          return new Ctor(args[0], args[1], args[2]);
        case 4:
          return new Ctor(args[0], args[1], args[2], args[3]);
        case 5:
          return new Ctor(args[0], args[1], args[2], args[3], args[4]);
        case 6:
          return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
        case 7:
          return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
      }
      var thisBinding = baseCreate_default(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
      return isObject_default(result2) ? result2 : thisBinding;
    };
  }
  var createCtor_default = createCtor;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createBind.js
  var WRAP_BIND_FLAG = 1;
  function createBind(func, bitmask, thisArg) {
    var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor_default(func);
    function wrapper() {
      var fn = this && this !== root_default && this instanceof wrapper ? Ctor : func;
      return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
  }
  var createBind_default = createBind;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createCurry.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_apply.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args[0]);
      case 2:
        return func.call(thisArg, args[0], args[1]);
      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }
  var apply_default = apply;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createHybrid.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_composeArgs.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeMax = Math.max;
  function composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while (++leftIndex < leftLength) {
      result2[leftIndex] = partials[leftIndex];
    }
    while (++argsIndex < holdersLength) {
      if (isUncurried || argsIndex < argsLength) {
        result2[holders[argsIndex]] = args[argsIndex];
      }
    }
    while (rangeLength--) {
      result2[leftIndex++] = args[argsIndex++];
    }
    return result2;
  }
  var composeArgs_default = composeArgs;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_composeArgsRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeMax2 = Math.max;
  function composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result2 = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while (++argsIndex < rangeLength) {
      result2[argsIndex] = args[argsIndex];
    }
    var offset = argsIndex;
    while (++rightIndex < rightLength) {
      result2[offset + rightIndex] = partials[rightIndex];
    }
    while (++holdersIndex < holdersLength) {
      if (isUncurried || argsIndex < argsLength) {
        result2[offset + holders[holdersIndex]] = args[argsIndex++];
      }
    }
    return result2;
  }
  var composeArgsRight_default = composeArgsRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_countHolders.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function countHolders(array, placeholder) {
    var length = array.length, result2 = 0;
    while (length--) {
      if (array[length] === placeholder) {
        ++result2;
      }
    }
    return result2;
  }
  var countHolders_default = countHolders;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createRecurry.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isLaziable.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_LazyWrapper.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseLodash.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseLodash() {
  }
  var baseLodash_default = baseLodash;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_LazyWrapper.js
  var MAX_ARRAY_LENGTH = 4294967295;
  function LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = MAX_ARRAY_LENGTH;
    this.__views__ = [];
  }
  LazyWrapper.prototype = baseCreate_default(baseLodash_default.prototype);
  LazyWrapper.prototype.constructor = LazyWrapper;
  var LazyWrapper_default = LazyWrapper;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getData.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/noop.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function noop2() {
  }
  var noop_default = noop2;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getData.js
  var getData = !metaMap_default ? noop_default : function(func) {
    return metaMap_default.get(func);
  };
  var getData_default = getData;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getFuncName.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_realNames.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var realNames = {};
  var realNames_default = realNames;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getFuncName.js
  var objectProto4 = Object.prototype;
  var hasOwnProperty4 = objectProto4.hasOwnProperty;
  function getFuncName(func) {
    var result2 = func.name + "", array = realNames_default[result2], length = hasOwnProperty4.call(realNames_default, result2) ? array.length : 0;
    while (length--) {
      var data = array[length], otherFunc = data.func;
      if (otherFunc == null || otherFunc == func) {
        return data.name;
      }
    }
    return result2;
  }
  var getFuncName_default = getFuncName;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/wrapperLodash.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_LodashWrapper.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = void 0;
  }
  LodashWrapper.prototype = baseCreate_default(baseLodash_default.prototype);
  LodashWrapper.prototype.constructor = LodashWrapper;
  var LodashWrapper_default = LodashWrapper;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_wrapperClone.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_copyArray.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while (++index < length) {
      array[index] = source[index];
    }
    return array;
  }
  var copyArray_default = copyArray;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_wrapperClone.js
  function wrapperClone(wrapper) {
    if (wrapper instanceof LazyWrapper_default) {
      return wrapper.clone();
    }
    var result2 = new LodashWrapper_default(wrapper.__wrapped__, wrapper.__chain__);
    result2.__actions__ = copyArray_default(wrapper.__actions__);
    result2.__index__ = wrapper.__index__;
    result2.__values__ = wrapper.__values__;
    return result2;
  }
  var wrapperClone_default = wrapperClone;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/wrapperLodash.js
  var objectProto5 = Object.prototype;
  var hasOwnProperty5 = objectProto5.hasOwnProperty;
  function lodash(value) {
    if (isObjectLike_default(value) && !isArray_default(value) && !(value instanceof LazyWrapper_default)) {
      if (value instanceof LodashWrapper_default) {
        return value;
      }
      if (hasOwnProperty5.call(value, "__wrapped__")) {
        return wrapperClone_default(value);
      }
    }
    return new LodashWrapper_default(value);
  }
  lodash.prototype = baseLodash_default.prototype;
  lodash.prototype.constructor = lodash;
  var wrapperLodash_default = lodash;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isLaziable.js
  function isLaziable(func) {
    var funcName = getFuncName_default(func), other = wrapperLodash_default[funcName];
    if (typeof other != "function" || !(funcName in LazyWrapper_default.prototype)) {
      return false;
    }
    if (func === other) {
      return true;
    }
    var data = getData_default(other);
    return !!data && func === data[0];
  }
  var isLaziable_default = isLaziable;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_setData.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_shortOut.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var HOT_COUNT = 800;
  var HOT_SPAN = 16;
  var nativeNow = Date.now;
  function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
      var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;
      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }
      return func.apply(void 0, arguments);
    };
  }
  var shortOut_default = shortOut;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_setData.js
  var setData = shortOut_default(baseSetData_default);
  var setData_default = setData;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_setWrapToString.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getWrapDetails.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/;
  var reSplitDetails = /,? & /;
  function getWrapDetails(source) {
    var match = source.match(reWrapDetails);
    return match ? match[1].split(reSplitDetails) : [];
  }
  var getWrapDetails_default = getWrapDetails;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_insertWrapDetails.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
  function insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) {
      return source;
    }
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
    details = details.join(length > 2 ? ", " : " ");
    return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
  }
  var insertWrapDetails_default = insertWrapDetails;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_setToString.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSetToString.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/constant.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function constant(value) {
    return function() {
      return value;
    };
  }
  var constant_default = constant;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_defineProperty.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var defineProperty = function() {
    try {
      var func = getNative_default(Object, "defineProperty");
      func({}, "", {});
      return func;
    } catch (e) {
    }
  }();
  var defineProperty_default = defineProperty;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSetToString.js
  var baseSetToString = !defineProperty_default ? identity_default : function(func, string) {
    return defineProperty_default(func, "toString", {
      "configurable": true,
      "enumerable": false,
      "value": constant_default(string),
      "writable": true
    });
  };
  var baseSetToString_default = baseSetToString;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_setToString.js
  var setToString = shortOut_default(baseSetToString_default);
  var setToString_default = setToString;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_updateWrapDetails.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayEach.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function arrayEach(array, iteratee2) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (iteratee2(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }
  var arrayEach_default = arrayEach;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayIncludes.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIndexOf.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseFindIndex.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while (fromRight ? index-- : ++index < length) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }
  var baseFindIndex_default = baseFindIndex;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsNaN.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseIsNaN(value) {
    return value !== value;
  }
  var baseIsNaN_default = baseIsNaN;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_strictIndexOf.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }
  var strictIndexOf_default = strictIndexOf;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIndexOf.js
  function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf_default(array, value, fromIndex) : baseFindIndex_default(array, baseIsNaN_default, fromIndex);
  }
  var baseIndexOf_default = baseIndexOf;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayIncludes.js
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf_default(array, value, 0) > -1;
  }
  var arrayIncludes_default = arrayIncludes;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_updateWrapDetails.js
  var WRAP_BIND_FLAG2 = 1;
  var WRAP_BIND_KEY_FLAG = 2;
  var WRAP_CURRY_FLAG = 8;
  var WRAP_CURRY_RIGHT_FLAG = 16;
  var WRAP_PARTIAL_FLAG = 32;
  var WRAP_PARTIAL_RIGHT_FLAG = 64;
  var WRAP_ARY_FLAG = 128;
  var WRAP_REARG_FLAG = 256;
  var WRAP_FLIP_FLAG = 512;
  var wrapFlags = [
    ["ary", WRAP_ARY_FLAG],
    ["bind", WRAP_BIND_FLAG2],
    ["bindKey", WRAP_BIND_KEY_FLAG],
    ["curry", WRAP_CURRY_FLAG],
    ["curryRight", WRAP_CURRY_RIGHT_FLAG],
    ["flip", WRAP_FLIP_FLAG],
    ["partial", WRAP_PARTIAL_FLAG],
    ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
    ["rearg", WRAP_REARG_FLAG]
  ];
  function updateWrapDetails(details, bitmask) {
    arrayEach_default(wrapFlags, function(pair) {
      var value = "_." + pair[0];
      if (bitmask & pair[1] && !arrayIncludes_default(details, value)) {
        details.push(value);
      }
    });
    return details.sort();
  }
  var updateWrapDetails_default = updateWrapDetails;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_setWrapToString.js
  function setWrapToString(wrapper, reference, bitmask) {
    var source = reference + "";
    return setToString_default(wrapper, insertWrapDetails_default(source, updateWrapDetails_default(getWrapDetails_default(source), bitmask)));
  }
  var setWrapToString_default = setWrapToString;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createRecurry.js
  var WRAP_BIND_FLAG3 = 1;
  var WRAP_BIND_KEY_FLAG2 = 2;
  var WRAP_CURRY_BOUND_FLAG = 4;
  var WRAP_CURRY_FLAG2 = 8;
  var WRAP_PARTIAL_FLAG2 = 32;
  var WRAP_PARTIAL_RIGHT_FLAG2 = 64;
  function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
    var isCurry = bitmask & WRAP_CURRY_FLAG2, newHolders = isCurry ? holders : void 0, newHoldersRight = isCurry ? void 0 : holders, newPartials = isCurry ? partials : void 0, newPartialsRight = isCurry ? void 0 : partials;
    bitmask |= isCurry ? WRAP_PARTIAL_FLAG2 : WRAP_PARTIAL_RIGHT_FLAG2;
    bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG2 : WRAP_PARTIAL_FLAG2);
    if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
      bitmask &= ~(WRAP_BIND_FLAG3 | WRAP_BIND_KEY_FLAG2);
    }
    var newData = [
      func,
      bitmask,
      thisArg,
      newPartials,
      newHolders,
      newPartialsRight,
      newHoldersRight,
      argPos,
      ary2,
      arity
    ];
    var result2 = wrapFunc.apply(void 0, newData);
    if (isLaziable_default(func)) {
      setData_default(result2, newData);
    }
    result2.placeholder = placeholder;
    return setWrapToString_default(result2, func, bitmask);
  }
  var createRecurry_default = createRecurry;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getHolder.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getHolder(func) {
    var object = func;
    return object.placeholder;
  }
  var getHolder_default = getHolder;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_reorder.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isIndex.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var MAX_SAFE_INTEGER = 9007199254740991;
  var reIsUint = /^(?:0|[1-9]\d*)$/;
  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  var isIndex_default = isIndex;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_reorder.js
  var nativeMin = Math.min;
  function reorder(array, indexes) {
    var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray_default(array);
    while (length--) {
      var index = indexes[length];
      array[length] = isIndex_default(index, arrLength) ? oldArray[index] : void 0;
    }
    return array;
  }
  var reorder_default = reorder;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_replaceHolders.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var PLACEHOLDER = "__lodash_placeholder__";
  function replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result2 = [];
    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result2[resIndex++] = index;
      }
    }
    return result2;
  }
  var replaceHolders_default = replaceHolders;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createHybrid.js
  var WRAP_BIND_FLAG4 = 1;
  var WRAP_BIND_KEY_FLAG3 = 2;
  var WRAP_CURRY_FLAG3 = 8;
  var WRAP_CURRY_RIGHT_FLAG2 = 16;
  var WRAP_ARY_FLAG2 = 128;
  var WRAP_FLIP_FLAG2 = 512;
  function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
    var isAry = bitmask & WRAP_ARY_FLAG2, isBind = bitmask & WRAP_BIND_FLAG4, isBindKey = bitmask & WRAP_BIND_KEY_FLAG3, isCurried = bitmask & (WRAP_CURRY_FLAG3 | WRAP_CURRY_RIGHT_FLAG2), isFlip = bitmask & WRAP_FLIP_FLAG2, Ctor = isBindKey ? void 0 : createCtor_default(func);
    function wrapper() {
      var length = arguments.length, args = Array(length), index = length;
      while (index--) {
        args[index] = arguments[index];
      }
      if (isCurried) {
        var placeholder = getHolder_default(wrapper), holdersCount = countHolders_default(args, placeholder);
      }
      if (partials) {
        args = composeArgs_default(args, partials, holders, isCurried);
      }
      if (partialsRight) {
        args = composeArgsRight_default(args, partialsRight, holdersRight, isCurried);
      }
      length -= holdersCount;
      if (isCurried && length < arity) {
        var newHolders = replaceHolders_default(args, placeholder);
        return createRecurry_default(
          func,
          bitmask,
          createHybrid,
          wrapper.placeholder,
          thisArg,
          args,
          newHolders,
          argPos,
          ary2,
          arity - length
        );
      }
      var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
      length = args.length;
      if (argPos) {
        args = reorder_default(args, argPos);
      } else if (isFlip && length > 1) {
        args.reverse();
      }
      if (isAry && ary2 < length) {
        args.length = ary2;
      }
      if (this && this !== root_default && this instanceof wrapper) {
        fn = Ctor || createCtor_default(fn);
      }
      return fn.apply(thisBinding, args);
    }
    return wrapper;
  }
  var createHybrid_default = createHybrid;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createCurry.js
  function createCurry(func, bitmask, arity) {
    var Ctor = createCtor_default(func);
    function wrapper() {
      var length = arguments.length, args = Array(length), index = length, placeholder = getHolder_default(wrapper);
      while (index--) {
        args[index] = arguments[index];
      }
      var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders_default(args, placeholder);
      length -= holders.length;
      if (length < arity) {
        return createRecurry_default(
          func,
          bitmask,
          createHybrid_default,
          wrapper.placeholder,
          void 0,
          args,
          holders,
          void 0,
          void 0,
          arity - length
        );
      }
      var fn = this && this !== root_default && this instanceof wrapper ? Ctor : func;
      return apply_default(fn, this, args);
    }
    return wrapper;
  }
  var createCurry_default = createCurry;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createPartial.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var WRAP_BIND_FLAG5 = 1;
  function createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & WRAP_BIND_FLAG5, Ctor = createCtor_default(func);
    function wrapper() {
      var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== root_default && this instanceof wrapper ? Ctor : func;
      while (++leftIndex < leftLength) {
        args[leftIndex] = partials[leftIndex];
      }
      while (argsLength--) {
        args[leftIndex++] = arguments[++argsIndex];
      }
      return apply_default(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
  }
  var createPartial_default = createPartial;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mergeData.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var PLACEHOLDER2 = "__lodash_placeholder__";
  var WRAP_BIND_FLAG6 = 1;
  var WRAP_BIND_KEY_FLAG4 = 2;
  var WRAP_CURRY_BOUND_FLAG2 = 4;
  var WRAP_CURRY_FLAG4 = 8;
  var WRAP_ARY_FLAG3 = 128;
  var WRAP_REARG_FLAG2 = 256;
  var nativeMin2 = Math.min;
  function mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG6 | WRAP_BIND_KEY_FLAG4 | WRAP_ARY_FLAG3);
    var isCombo = srcBitmask == WRAP_ARY_FLAG3 && bitmask == WRAP_CURRY_FLAG4 || srcBitmask == WRAP_ARY_FLAG3 && bitmask == WRAP_REARG_FLAG2 && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG3 | WRAP_REARG_FLAG2) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG4;
    if (!(isCommon || isCombo)) {
      return data;
    }
    if (srcBitmask & WRAP_BIND_FLAG6) {
      data[2] = source[2];
      newBitmask |= bitmask & WRAP_BIND_FLAG6 ? 0 : WRAP_CURRY_BOUND_FLAG2;
    }
    var value = source[3];
    if (value) {
      var partials = data[3];
      data[3] = partials ? composeArgs_default(partials, value, source[4]) : value;
      data[4] = partials ? replaceHolders_default(data[3], PLACEHOLDER2) : source[4];
    }
    value = source[5];
    if (value) {
      partials = data[5];
      data[5] = partials ? composeArgsRight_default(partials, value, source[6]) : value;
      data[6] = partials ? replaceHolders_default(data[5], PLACEHOLDER2) : source[6];
    }
    value = source[7];
    if (value) {
      data[7] = value;
    }
    if (srcBitmask & WRAP_ARY_FLAG3) {
      data[8] = data[8] == null ? source[8] : nativeMin2(data[8], source[8]);
    }
    if (data[9] == null) {
      data[9] = source[9];
    }
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
  }
  var mergeData_default = mergeData;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createWrap.js
  var FUNC_ERROR_TEXT2 = "Expected a function";
  var WRAP_BIND_FLAG7 = 1;
  var WRAP_BIND_KEY_FLAG5 = 2;
  var WRAP_CURRY_FLAG5 = 8;
  var WRAP_CURRY_RIGHT_FLAG3 = 16;
  var WRAP_PARTIAL_FLAG3 = 32;
  var WRAP_PARTIAL_RIGHT_FLAG3 = 64;
  var nativeMax3 = Math.max;
  function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
    var isBindKey = bitmask & WRAP_BIND_KEY_FLAG5;
    if (!isBindKey && typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT2);
    }
    var length = partials ? partials.length : 0;
    if (!length) {
      bitmask &= ~(WRAP_PARTIAL_FLAG3 | WRAP_PARTIAL_RIGHT_FLAG3);
      partials = holders = void 0;
    }
    ary2 = ary2 === void 0 ? ary2 : nativeMax3(toInteger_default(ary2), 0);
    arity = arity === void 0 ? arity : toInteger_default(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & WRAP_PARTIAL_RIGHT_FLAG3) {
      var partialsRight = partials, holdersRight = holders;
      partials = holders = void 0;
    }
    var data = isBindKey ? void 0 : getData_default(func);
    var newData = [
      func,
      bitmask,
      thisArg,
      partials,
      holders,
      partialsRight,
      holdersRight,
      argPos,
      ary2,
      arity
    ];
    if (data) {
      mergeData_default(newData, data);
    }
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === void 0 ? isBindKey ? 0 : func.length : nativeMax3(newData[9] - length, 0);
    if (!arity && bitmask & (WRAP_CURRY_FLAG5 | WRAP_CURRY_RIGHT_FLAG3)) {
      bitmask &= ~(WRAP_CURRY_FLAG5 | WRAP_CURRY_RIGHT_FLAG3);
    }
    if (!bitmask || bitmask == WRAP_BIND_FLAG7) {
      var result2 = createBind_default(func, bitmask, thisArg);
    } else if (bitmask == WRAP_CURRY_FLAG5 || bitmask == WRAP_CURRY_RIGHT_FLAG3) {
      result2 = createCurry_default(func, bitmask, arity);
    } else if ((bitmask == WRAP_PARTIAL_FLAG3 || bitmask == (WRAP_BIND_FLAG7 | WRAP_PARTIAL_FLAG3)) && !holders.length) {
      result2 = createPartial_default(func, bitmask, thisArg, partials);
    } else {
      result2 = createHybrid_default.apply(void 0, newData);
    }
    var setter = data ? baseSetData_default : setData_default;
    return setWrapToString_default(setter(result2, newData), func, bitmask);
  }
  var createWrap_default = createWrap;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/ary.js
  var WRAP_ARY_FLAG4 = 128;
  function ary(func, n, guard) {
    n = guard ? void 0 : n;
    n = func && n == null ? func.length : n;
    return createWrap_default(func, WRAP_ARY_FLAG4, void 0, void 0, void 0, void 0, n);
  }
  var ary_default = ary;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/assign.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_assignValue.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseAssignValue.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty_default) {
      defineProperty_default(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
      });
    } else {
      object[key] = value;
    }
  }
  var baseAssignValue_default = baseAssignValue;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/eq.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  var eq_default = eq;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_assignValue.js
  var objectProto6 = Object.prototype;
  var hasOwnProperty6 = objectProto6.hasOwnProperty;
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty6.call(object, key) && eq_default(objValue, value)) || value === void 0 && !(key in object)) {
      baseAssignValue_default(object, key, value);
    }
  }
  var assignValue_default = assignValue;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_copyObject.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function copyObject(source, props, object, customizer2) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while (++index < length) {
      var key = props[index];
      var newValue = customizer2 ? customizer2(object[key], source[key], key, object, source) : void 0;
      if (newValue === void 0) {
        newValue = source[key];
      }
      if (isNew) {
        baseAssignValue_default(object, key, newValue);
      } else {
        assignValue_default(object, key, newValue);
      }
    }
    return object;
  }
  var copyObject_default = copyObject;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createAssigner.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseRest.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_overRest.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeMax4 = Math.max;
  function overRest(func, start, transform2) {
    start = nativeMax4(start === void 0 ? func.length - 1 : start, 0);
    return function() {
      var args = arguments, index = -1, length = nativeMax4(args.length - start, 0), array = Array(length);
      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = transform2(array);
      return apply_default(func, this, otherArgs);
    };
  }
  var overRest_default = overRest;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseRest.js
  function baseRest(func, start) {
    return setToString_default(overRest_default(func, start, identity_default), func + "");
  }
  var baseRest_default = baseRest;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isIterateeCall.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArrayLike.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isLength.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  var isLength_default = isLength;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArrayLike.js
  function isArrayLike(value) {
    return value != null && isLength_default(value.length) && !isFunction_default(value);
  }
  var isArrayLike_default = isArrayLike;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isIterateeCall.js
  function isIterateeCall(value, index, object) {
    if (!isObject_default(object)) {
      return false;
    }
    var type = typeof index;
    if (type == "number" ? isArrayLike_default(object) && isIndex_default(index, object.length) : type == "string" && index in object) {
      return eq_default(object[index], value);
    }
    return false;
  }
  var isIterateeCall_default = isIterateeCall;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createAssigner.js
  function createAssigner(assigner) {
    return baseRest_default(function(object, sources) {
      var index = -1, length = sources.length, customizer2 = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
      customizer2 = assigner.length > 3 && typeof customizer2 == "function" ? (length--, customizer2) : void 0;
      if (guard && isIterateeCall_default(sources[0], sources[1], guard)) {
        customizer2 = length < 3 ? void 0 : customizer2;
        length = 1;
      }
      object = Object(object);
      while (++index < length) {
        var source = sources[index];
        if (source) {
          assigner(object, source, index, customizer2);
        }
      }
      return object;
    });
  }
  var createAssigner_default = createAssigner;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isPrototype.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var objectProto7 = Object.prototype;
  function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto7;
    return value === proto;
  }
  var isPrototype_default = isPrototype;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/keys.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayLikeKeys.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseTimes.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseTimes(n, iteratee2) {
    var index = -1, result2 = Array(n);
    while (++index < n) {
      result2[index] = iteratee2(index);
    }
    return result2;
  }
  var baseTimes_default = baseTimes;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArguments.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsArguments.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var argsTag = "[object Arguments]";
  function baseIsArguments(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == argsTag;
  }
  var baseIsArguments_default = baseIsArguments;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArguments.js
  var objectProto8 = Object.prototype;
  var hasOwnProperty7 = objectProto8.hasOwnProperty;
  var propertyIsEnumerable = objectProto8.propertyIsEnumerable;
  var isArguments = baseIsArguments_default(function() {
    return arguments;
  }()) ? baseIsArguments_default : function(value) {
    return isObjectLike_default(value) && hasOwnProperty7.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
  };
  var isArguments_default = isArguments;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isBuffer.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/stubFalse.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function stubFalse() {
    return false;
  }
  var stubFalse_default = stubFalse;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isBuffer.js
  var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
  var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer3 = moduleExports ? root_default.Buffer : void 0;
  var nativeIsBuffer = Buffer3 ? Buffer3.isBuffer : void 0;
  var isBuffer = nativeIsBuffer || stubFalse_default;
  var isBuffer_default = isBuffer;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isTypedArray.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsTypedArray.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var argsTag2 = "[object Arguments]";
  var arrayTag = "[object Array]";
  var boolTag = "[object Boolean]";
  var dateTag = "[object Date]";
  var errorTag = "[object Error]";
  var funcTag2 = "[object Function]";
  var mapTag = "[object Map]";
  var numberTag = "[object Number]";
  var objectTag = "[object Object]";
  var regexpTag = "[object RegExp]";
  var setTag = "[object Set]";
  var stringTag = "[object String]";
  var weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]";
  var dataViewTag = "[object DataView]";
  var float32Tag = "[object Float32Array]";
  var float64Tag = "[object Float64Array]";
  var int8Tag = "[object Int8Array]";
  var int16Tag = "[object Int16Array]";
  var int32Tag = "[object Int32Array]";
  var uint8Tag = "[object Uint8Array]";
  var uint8ClampedTag = "[object Uint8ClampedArray]";
  var uint16Tag = "[object Uint16Array]";
  var uint32Tag = "[object Uint32Array]";
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag2] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag2] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  function baseIsTypedArray(value) {
    return isObjectLike_default(value) && isLength_default(value.length) && !!typedArrayTags[baseGetTag_default(value)];
  }
  var baseIsTypedArray_default = baseIsTypedArray;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseUnary.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }
  var baseUnary_default = baseUnary;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_nodeUtil.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var freeExports2 = typeof exports == "object" && exports && !exports.nodeType && exports;
  var freeModule2 = freeExports2 && typeof module == "object" && module && !module.nodeType && module;
  var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
  var freeProcess = moduleExports2 && freeGlobal_default.process;
  var nodeUtil = function() {
    try {
      var types2 = freeModule2 && freeModule2.require && freeModule2.require("util").types;
      if (types2) {
        return types2;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  var nodeUtil_default = nodeUtil;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isTypedArray.js
  var nodeIsTypedArray = nodeUtil_default && nodeUtil_default.isTypedArray;
  var isTypedArray = nodeIsTypedArray ? baseUnary_default(nodeIsTypedArray) : baseIsTypedArray_default;
  var isTypedArray_default = isTypedArray;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayLikeKeys.js
  var objectProto9 = Object.prototype;
  var hasOwnProperty8 = objectProto9.hasOwnProperty;
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray_default(value), isArg = !isArr && isArguments_default(value), isBuff = !isArr && !isArg && isBuffer_default(value), isType = !isArr && !isArg && !isBuff && isTypedArray_default(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes_default(value.length, String) : [], length = result2.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty8.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex_default(key, length)))) {
        result2.push(key);
      }
    }
    return result2;
  }
  var arrayLikeKeys_default = arrayLikeKeys;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseKeys.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_nativeKeys.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_overArg.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function overArg(func, transform2) {
    return function(arg) {
      return func(transform2(arg));
    };
  }
  var overArg_default = overArg;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_nativeKeys.js
  var nativeKeys = overArg_default(Object.keys, Object);
  var nativeKeys_default = nativeKeys;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseKeys.js
  var objectProto10 = Object.prototype;
  var hasOwnProperty9 = objectProto10.hasOwnProperty;
  function baseKeys(object) {
    if (!isPrototype_default(object)) {
      return nativeKeys_default(object);
    }
    var result2 = [];
    for (var key in Object(object)) {
      if (hasOwnProperty9.call(object, key) && key != "constructor") {
        result2.push(key);
      }
    }
    return result2;
  }
  var baseKeys_default = baseKeys;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/keys.js
  function keys(object) {
    return isArrayLike_default(object) ? arrayLikeKeys_default(object) : baseKeys_default(object);
  }
  var keys_default = keys;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/assign.js
  var objectProto11 = Object.prototype;
  var hasOwnProperty10 = objectProto11.hasOwnProperty;
  var assign = createAssigner_default(function(object, source) {
    if (isPrototype_default(source) || isArrayLike_default(source)) {
      copyObject_default(source, keys_default(source), object);
      return;
    }
    for (var key in source) {
      if (hasOwnProperty10.call(source, key)) {
        assignValue_default(object, key, source[key]);
      }
    }
  });
  var assign_default = assign;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/assignIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/keysIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseKeysIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_nativeKeysIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function nativeKeysIn(object) {
    var result2 = [];
    if (object != null) {
      for (var key in Object(object)) {
        result2.push(key);
      }
    }
    return result2;
  }
  var nativeKeysIn_default = nativeKeysIn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseKeysIn.js
  var objectProto12 = Object.prototype;
  var hasOwnProperty11 = objectProto12.hasOwnProperty;
  function baseKeysIn(object) {
    if (!isObject_default(object)) {
      return nativeKeysIn_default(object);
    }
    var isProto = isPrototype_default(object), result2 = [];
    for (var key in object) {
      if (!(key == "constructor" && (isProto || !hasOwnProperty11.call(object, key)))) {
        result2.push(key);
      }
    }
    return result2;
  }
  var baseKeysIn_default = baseKeysIn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/keysIn.js
  function keysIn(object) {
    return isArrayLike_default(object) ? arrayLikeKeys_default(object, true) : baseKeysIn_default(object);
  }
  var keysIn_default = keysIn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/assignIn.js
  var assignIn = createAssigner_default(function(object, source) {
    copyObject_default(source, keysIn_default(source), object);
  });
  var assignIn_default = assignIn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/assignInWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var assignInWith = createAssigner_default(function(object, source, srcIndex, customizer2) {
    copyObject_default(source, keysIn_default(source), object, customizer2);
  });
  var assignInWith_default = assignInWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/assignWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var assignWith = createAssigner_default(function(object, source, srcIndex, customizer2) {
    copyObject_default(source, keys_default(source), object, customizer2);
  });
  var assignWith_default = assignWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/at.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseAt.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/get.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseGet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_castPath.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isKey.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
  var reIsPlainProp = /^\w*$/;
  function isKey(value, object) {
    if (isArray_default(value)) {
      return false;
    }
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol_default(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }
  var isKey_default = isKey;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stringToPath.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_memoizeCapped.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/memoize.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_MapCache.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheClear.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Hash.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashClear.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_nativeCreate.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeCreate = getNative_default(Object, "create");
  var nativeCreate_default = nativeCreate;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashClear.js
  function hashClear() {
    this.__data__ = nativeCreate_default ? nativeCreate_default(null) : {};
    this.size = 0;
  }
  var hashClear_default = hashClear;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashDelete.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function hashDelete(key) {
    var result2 = this.has(key) && delete this.__data__[key];
    this.size -= result2 ? 1 : 0;
    return result2;
  }
  var hashDelete_default = hashDelete;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashGet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  var objectProto13 = Object.prototype;
  var hasOwnProperty12 = objectProto13.hasOwnProperty;
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate_default) {
      var result2 = data[key];
      return result2 === HASH_UNDEFINED ? void 0 : result2;
    }
    return hasOwnProperty12.call(data, key) ? data[key] : void 0;
  }
  var hashGet_default = hashGet;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashHas.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var objectProto14 = Object.prototype;
  var hasOwnProperty13 = objectProto14.hasOwnProperty;
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate_default ? data[key] !== void 0 : hasOwnProperty13.call(data, key);
  }
  var hashHas_default = hashHas;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashSet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate_default && value === void 0 ? HASH_UNDEFINED2 : value;
    return this;
  }
  var hashSet_default = hashSet;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Hash.js
  function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  Hash.prototype.clear = hashClear_default;
  Hash.prototype["delete"] = hashDelete_default;
  Hash.prototype.get = hashGet_default;
  Hash.prototype.has = hashHas_default;
  Hash.prototype.set = hashSet_default;
  var Hash_default = Hash;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_ListCache.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheClear.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  var listCacheClear_default = listCacheClear;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheDelete.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_assocIndexOf.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq_default(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  var assocIndexOf_default = assocIndexOf;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheDelete.js
  var arrayProto = Array.prototype;
  var splice = arrayProto.splice;
  function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf_default(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }
  var listCacheDelete_default = listCacheDelete;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheGet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf_default(data, key);
    return index < 0 ? void 0 : data[index][1];
  }
  var listCacheGet_default = listCacheGet;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheHas.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function listCacheHas(key) {
    return assocIndexOf_default(this.__data__, key) > -1;
  }
  var listCacheHas_default = listCacheHas;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheSet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf_default(data, key);
    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  var listCacheSet_default = listCacheSet;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_ListCache.js
  function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  ListCache.prototype.clear = listCacheClear_default;
  ListCache.prototype["delete"] = listCacheDelete_default;
  ListCache.prototype.get = listCacheGet_default;
  ListCache.prototype.has = listCacheHas_default;
  ListCache.prototype.set = listCacheSet_default;
  var ListCache_default = ListCache;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Map.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var Map2 = getNative_default(root_default, "Map");
  var Map_default = Map2;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheClear.js
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash_default(),
      "map": new (Map_default || ListCache_default)(),
      "string": new Hash_default()
    };
  }
  var mapCacheClear_default = mapCacheClear;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheDelete.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getMapData.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isKeyable.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  var isKeyable_default = isKeyable;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getMapData.js
  function getMapData(map2, key) {
    var data = map2.__data__;
    return isKeyable_default(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  var getMapData_default = getMapData;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheDelete.js
  function mapCacheDelete(key) {
    var result2 = getMapData_default(this, key)["delete"](key);
    this.size -= result2 ? 1 : 0;
    return result2;
  }
  var mapCacheDelete_default = mapCacheDelete;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheGet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function mapCacheGet(key) {
    return getMapData_default(this, key).get(key);
  }
  var mapCacheGet_default = mapCacheGet;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheHas.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function mapCacheHas(key) {
    return getMapData_default(this, key).has(key);
  }
  var mapCacheHas_default = mapCacheHas;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheSet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function mapCacheSet(key, value) {
    var data = getMapData_default(this, key), size2 = data.size;
    data.set(key, value);
    this.size += data.size == size2 ? 0 : 1;
    return this;
  }
  var mapCacheSet_default = mapCacheSet;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_MapCache.js
  function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  MapCache.prototype.clear = mapCacheClear_default;
  MapCache.prototype["delete"] = mapCacheDelete_default;
  MapCache.prototype.get = mapCacheGet_default;
  MapCache.prototype.has = mapCacheHas_default;
  MapCache.prototype.set = mapCacheSet_default;
  var MapCache_default = MapCache;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/memoize.js
  var FUNC_ERROR_TEXT3 = "Expected a function";
  function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") {
      throw new TypeError(FUNC_ERROR_TEXT3);
    }
    var memoized = function() {
      var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
      if (cache.has(key)) {
        return cache.get(key);
      }
      var result2 = func.apply(this, args);
      memoized.cache = cache.set(key, result2) || cache;
      return result2;
    };
    memoized.cache = new (memoize.Cache || MapCache_default)();
    return memoized;
  }
  memoize.Cache = MapCache_default;
  var memoize_default = memoize;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_memoizeCapped.js
  var MAX_MEMOIZE_SIZE = 500;
  function memoizeCapped(func) {
    var result2 = memoize_default(func, function(key) {
      if (cache.size === MAX_MEMOIZE_SIZE) {
        cache.clear();
      }
      return key;
    });
    var cache = result2.cache;
    return result2;
  }
  var memoizeCapped_default = memoizeCapped;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stringToPath.js
  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
  var reEscapeChar = /\\(\\)?/g;
  var stringToPath = memoizeCapped_default(function(string) {
    var result2 = [];
    if (string.charCodeAt(0) === 46) {
      result2.push("");
    }
    string.replace(rePropName, function(match, number, quote, subString) {
      result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result2;
  });
  var stringToPath_default = stringToPath;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toString.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function toString(value) {
    return value == null ? "" : baseToString_default(value);
  }
  var toString_default = toString;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_castPath.js
  function castPath(value, object) {
    if (isArray_default(value)) {
      return value;
    }
    return isKey_default(value, object) ? [value] : stringToPath_default(toString_default(value));
  }
  var castPath_default = castPath;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_toKey.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var INFINITY3 = 1 / 0;
  function toKey(value) {
    if (typeof value == "string" || isSymbol_default(value)) {
      return value;
    }
    var result2 = value + "";
    return result2 == "0" && 1 / value == -INFINITY3 ? "-0" : result2;
  }
  var toKey_default = toKey;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseGet.js
  function baseGet(object, path) {
    path = castPath_default(path, object);
    var index = 0, length = path.length;
    while (object != null && index < length) {
      object = object[toKey_default(path[index++])];
    }
    return index && index == length ? object : void 0;
  }
  var baseGet_default = baseGet;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/get.js
  function get(object, path, defaultValue) {
    var result2 = object == null ? void 0 : baseGet_default(object, path);
    return result2 === void 0 ? defaultValue : result2;
  }
  var get_default = get;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseAt.js
  function baseAt(object, paths) {
    var index = -1, length = paths.length, result2 = Array(length), skip = object == null;
    while (++index < length) {
      result2[index] = skip ? void 0 : get_default(object, paths[index]);
    }
    return result2;
  }
  var baseAt_default = baseAt;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_flatRest.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/flatten.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseFlatten.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayPush.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function arrayPush(array, values2) {
    var index = -1, length = values2.length, offset = array.length;
    while (++index < length) {
      array[offset + index] = values2[index];
    }
    return array;
  }
  var arrayPush_default = arrayPush;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isFlattenable.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var spreadableSymbol = Symbol_default ? Symbol_default.isConcatSpreadable : void 0;
  function isFlattenable(value) {
    return isArray_default(value) || isArguments_default(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
  }
  var isFlattenable_default = isFlattenable;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseFlatten.js
  function baseFlatten(array, depth, predicate, isStrict, result2) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable_default);
    result2 || (result2 = []);
    while (++index < length) {
      var value = array[index];
      if (depth > 0 && predicate(value)) {
        if (depth > 1) {
          baseFlatten(value, depth - 1, predicate, isStrict, result2);
        } else {
          arrayPush_default(result2, value);
        }
      } else if (!isStrict) {
        result2[result2.length] = value;
      }
    }
    return result2;
  }
  var baseFlatten_default = baseFlatten;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/flatten.js
  function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten_default(array, 1) : [];
  }
  var flatten_default = flatten;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_flatRest.js
  function flatRest(func) {
    return setToString_default(overRest_default(func, void 0, flatten_default), func + "");
  }
  var flatRest_default = flatRest;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/at.js
  var at = flatRest_default(baseAt_default);
  var at_default = at;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/attempt.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isError.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isPlainObject.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getPrototype.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var getPrototype = overArg_default(Object.getPrototypeOf, Object);
  var getPrototype_default = getPrototype;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isPlainObject.js
  var objectTag2 = "[object Object]";
  var funcProto3 = Function.prototype;
  var objectProto15 = Object.prototype;
  var funcToString3 = funcProto3.toString;
  var hasOwnProperty14 = objectProto15.hasOwnProperty;
  var objectCtorString = funcToString3.call(Object);
  function isPlainObject(value) {
    if (!isObjectLike_default(value) || baseGetTag_default(value) != objectTag2) {
      return false;
    }
    var proto = getPrototype_default(value);
    if (proto === null) {
      return true;
    }
    var Ctor = hasOwnProperty14.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString3.call(Ctor) == objectCtorString;
  }
  var isPlainObject_default = isPlainObject;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isError.js
  var domExcTag = "[object DOMException]";
  var errorTag2 = "[object Error]";
  function isError(value) {
    if (!isObjectLike_default(value)) {
      return false;
    }
    var tag = baseGetTag_default(value);
    return tag == errorTag2 || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject_default(value);
  }
  var isError_default = isError;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/attempt.js
  var attempt = baseRest_default(function(func, args) {
    try {
      return apply_default(func, void 0, args);
    } catch (e) {
      return isError_default(e) ? e : new Error(e);
    }
  });
  var attempt_default = attempt;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/before.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var FUNC_ERROR_TEXT4 = "Expected a function";
  function before(n, func) {
    var result2;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT4);
    }
    n = toInteger_default(n);
    return function() {
      if (--n > 0) {
        result2 = func.apply(this, arguments);
      }
      if (n <= 1) {
        func = void 0;
      }
      return result2;
    };
  }
  var before_default = before;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/bind.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var WRAP_BIND_FLAG8 = 1;
  var WRAP_PARTIAL_FLAG4 = 32;
  var bind = baseRest_default(function(func, thisArg, partials) {
    var bitmask = WRAP_BIND_FLAG8;
    if (partials.length) {
      var holders = replaceHolders_default(partials, getHolder_default(bind));
      bitmask |= WRAP_PARTIAL_FLAG4;
    }
    return createWrap_default(func, bitmask, thisArg, partials, holders);
  });
  bind.placeholder = {};
  var bind_default = bind;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/bindAll.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var bindAll = flatRest_default(function(object, methodNames) {
    arrayEach_default(methodNames, function(key) {
      key = toKey_default(key);
      baseAssignValue_default(object, key, bind_default(object[key], object));
    });
    return object;
  });
  var bindAll_default = bindAll;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/bindKey.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var WRAP_BIND_FLAG9 = 1;
  var WRAP_BIND_KEY_FLAG6 = 2;
  var WRAP_PARTIAL_FLAG5 = 32;
  var bindKey = baseRest_default(function(object, key, partials) {
    var bitmask = WRAP_BIND_FLAG9 | WRAP_BIND_KEY_FLAG6;
    if (partials.length) {
      var holders = replaceHolders_default(partials, getHolder_default(bindKey));
      bitmask |= WRAP_PARTIAL_FLAG5;
    }
    return createWrap_default(key, bitmask, object, partials, holders);
  });
  bindKey.placeholder = {};
  var bindKey_default = bindKey;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/camelCase.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/capitalize.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/upperFirst.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createCaseFirst.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_castSlice.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSlice.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }
    end = end > length ? length : end;
    if (end < 0) {
      end += length;
    }
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result2 = Array(length);
    while (++index < length) {
      result2[index] = array[index + start];
    }
    return result2;
  }
  var baseSlice_default = baseSlice;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_castSlice.js
  function castSlice(array, start, end) {
    var length = array.length;
    end = end === void 0 ? length : end;
    return !start && end >= length ? array : baseSlice_default(array, start, end);
  }
  var castSlice_default = castSlice;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hasUnicode.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var rsAstralRange = "\\ud800-\\udfff";
  var rsComboMarksRange = "\\u0300-\\u036f";
  var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange = "\\u20d0-\\u20ff";
  var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
  var rsVarRange = "\\ufe0e\\ufe0f";
  var rsZWJ = "\\u200d";
  var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }
  var hasUnicode_default = hasUnicode;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stringToArray.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_asciiToArray.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function asciiToArray(string) {
    return string.split("");
  }
  var asciiToArray_default = asciiToArray;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_unicodeToArray.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var rsAstralRange2 = "\\ud800-\\udfff";
  var rsComboMarksRange2 = "\\u0300-\\u036f";
  var reComboHalfMarksRange2 = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange2 = "\\u20d0-\\u20ff";
  var rsComboRange2 = rsComboMarksRange2 + reComboHalfMarksRange2 + rsComboSymbolsRange2;
  var rsVarRange2 = "\\ufe0e\\ufe0f";
  var rsAstral = "[" + rsAstralRange2 + "]";
  var rsCombo = "[" + rsComboRange2 + "]";
  var rsFitz = "\\ud83c[\\udffb-\\udfff]";
  var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
  var rsNonAstral = "[^" + rsAstralRange2 + "]";
  var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
  var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
  var rsZWJ2 = "\\u200d";
  var reOptMod = rsModifier + "?";
  var rsOptVar = "[" + rsVarRange2 + "]?";
  var rsOptJoin = "(?:" + rsZWJ2 + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
  var rsSeq = rsOptVar + reOptMod + rsOptJoin;
  var rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
  var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }
  var unicodeToArray_default = unicodeToArray;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stringToArray.js
  function stringToArray(string) {
    return hasUnicode_default(string) ? unicodeToArray_default(string) : asciiToArray_default(string);
  }
  var stringToArray_default = stringToArray;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createCaseFirst.js
  function createCaseFirst(methodName) {
    return function(string) {
      string = toString_default(string);
      var strSymbols = hasUnicode_default(string) ? stringToArray_default(string) : void 0;
      var chr = strSymbols ? strSymbols[0] : string.charAt(0);
      var trailing = strSymbols ? castSlice_default(strSymbols, 1).join("") : string.slice(1);
      return chr[methodName]() + trailing;
    };
  }
  var createCaseFirst_default = createCaseFirst;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/upperFirst.js
  var upperFirst = createCaseFirst_default("toUpperCase");
  var upperFirst_default = upperFirst;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/capitalize.js
  function capitalize(string) {
    return upperFirst_default(toString_default(string).toLowerCase());
  }
  var capitalize_default = capitalize;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createCompounder.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayReduce.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function arrayReduce(array, iteratee2, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee2(accumulator, array[index], index, array);
    }
    return accumulator;
  }
  var arrayReduce_default = arrayReduce;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/deburr.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_deburrLetter.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_basePropertyOf.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? void 0 : object[key];
    };
  }
  var basePropertyOf_default = basePropertyOf;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_deburrLetter.js
  var deburredLetters = {
    "\xC0": "A",
    "\xC1": "A",
    "\xC2": "A",
    "\xC3": "A",
    "\xC4": "A",
    "\xC5": "A",
    "\xE0": "a",
    "\xE1": "a",
    "\xE2": "a",
    "\xE3": "a",
    "\xE4": "a",
    "\xE5": "a",
    "\xC7": "C",
    "\xE7": "c",
    "\xD0": "D",
    "\xF0": "d",
    "\xC8": "E",
    "\xC9": "E",
    "\xCA": "E",
    "\xCB": "E",
    "\xE8": "e",
    "\xE9": "e",
    "\xEA": "e",
    "\xEB": "e",
    "\xCC": "I",
    "\xCD": "I",
    "\xCE": "I",
    "\xCF": "I",
    "\xEC": "i",
    "\xED": "i",
    "\xEE": "i",
    "\xEF": "i",
    "\xD1": "N",
    "\xF1": "n",
    "\xD2": "O",
    "\xD3": "O",
    "\xD4": "O",
    "\xD5": "O",
    "\xD6": "O",
    "\xD8": "O",
    "\xF2": "o",
    "\xF3": "o",
    "\xF4": "o",
    "\xF5": "o",
    "\xF6": "o",
    "\xF8": "o",
    "\xD9": "U",
    "\xDA": "U",
    "\xDB": "U",
    "\xDC": "U",
    "\xF9": "u",
    "\xFA": "u",
    "\xFB": "u",
    "\xFC": "u",
    "\xDD": "Y",
    "\xFD": "y",
    "\xFF": "y",
    "\xC6": "Ae",
    "\xE6": "ae",
    "\xDE": "Th",
    "\xFE": "th",
    "\xDF": "ss",
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
  };
  var deburrLetter = basePropertyOf_default(deburredLetters);
  var deburrLetter_default = deburrLetter;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/deburr.js
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
  var rsComboMarksRange3 = "\\u0300-\\u036f";
  var reComboHalfMarksRange3 = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange3 = "\\u20d0-\\u20ff";
  var rsComboRange3 = rsComboMarksRange3 + reComboHalfMarksRange3 + rsComboSymbolsRange3;
  var rsCombo2 = "[" + rsComboRange3 + "]";
  var reComboMark = RegExp(rsCombo2, "g");
  function deburr(string) {
    string = toString_default(string);
    return string && string.replace(reLatin, deburrLetter_default).replace(reComboMark, "");
  }
  var deburr_default = deburr;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/words.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_asciiWords.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }
  var asciiWords_default = asciiWords;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hasUnicodeWord.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }
  var hasUnicodeWord_default = hasUnicodeWord;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_unicodeWords.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var rsAstralRange3 = "\\ud800-\\udfff";
  var rsComboMarksRange4 = "\\u0300-\\u036f";
  var reComboHalfMarksRange4 = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange4 = "\\u20d0-\\u20ff";
  var rsComboRange4 = rsComboMarksRange4 + reComboHalfMarksRange4 + rsComboSymbolsRange4;
  var rsDingbatRange = "\\u2700-\\u27bf";
  var rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff";
  var rsMathOpRange = "\\xac\\xb1\\xd7\\xf7";
  var rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf";
  var rsPunctuationRange = "\\u2000-\\u206f";
  var rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000";
  var rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde";
  var rsVarRange3 = "\\ufe0e\\ufe0f";
  var rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
  var rsApos = "['\u2019]";
  var rsBreak = "[" + rsBreakRange + "]";
  var rsCombo3 = "[" + rsComboRange4 + "]";
  var rsDigits = "\\d+";
  var rsDingbat = "[" + rsDingbatRange + "]";
  var rsLower = "[" + rsLowerRange + "]";
  var rsMisc = "[^" + rsAstralRange3 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]";
  var rsFitz2 = "\\ud83c[\\udffb-\\udfff]";
  var rsModifier2 = "(?:" + rsCombo3 + "|" + rsFitz2 + ")";
  var rsNonAstral2 = "[^" + rsAstralRange3 + "]";
  var rsRegional2 = "(?:\\ud83c[\\udde6-\\uddff]){2}";
  var rsSurrPair2 = "[\\ud800-\\udbff][\\udc00-\\udfff]";
  var rsUpper = "[" + rsUpperRange + "]";
  var rsZWJ3 = "\\u200d";
  var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")";
  var rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")";
  var rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?";
  var rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?";
  var reOptMod2 = rsModifier2 + "?";
  var rsOptVar2 = "[" + rsVarRange3 + "]?";
  var rsOptJoin2 = "(?:" + rsZWJ3 + "(?:" + [rsNonAstral2, rsRegional2, rsSurrPair2].join("|") + ")" + rsOptVar2 + reOptMod2 + ")*";
  var rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])";
  var rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])";
  var rsSeq2 = rsOptVar2 + reOptMod2 + rsOptJoin2;
  var rsEmoji = "(?:" + [rsDingbat, rsRegional2, rsSurrPair2].join("|") + ")" + rsSeq2;
  var reUnicodeWord = RegExp([
    rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
    rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
    rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
    rsUpper + "+" + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join("|"), "g");
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }
  var unicodeWords_default = unicodeWords;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/words.js
  function words(string, pattern, guard) {
    string = toString_default(string);
    pattern = guard ? void 0 : pattern;
    if (pattern === void 0) {
      return hasUnicodeWord_default(string) ? unicodeWords_default(string) : asciiWords_default(string);
    }
    return string.match(pattern) || [];
  }
  var words_default = words;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createCompounder.js
  var rsApos2 = "['\u2019]";
  var reApos = RegExp(rsApos2, "g");
  function createCompounder(callback) {
    return function(string) {
      return arrayReduce_default(words_default(deburr_default(string).replace(reApos, "")), callback, "");
    };
  }
  var createCompounder_default = createCompounder;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/camelCase.js
  var camelCase = createCompounder_default(function(result2, word, index) {
    word = word.toLowerCase();
    return result2 + (index ? capitalize_default(word) : word);
  });
  var camelCase_default = camelCase;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/castArray.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function castArray() {
    if (!arguments.length) {
      return [];
    }
    var value = arguments[0];
    return isArray_default(value) ? value : [value];
  }
  var castArray_default = castArray;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/ceil.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createRound.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeIsFinite = root_default.isFinite;
  var nativeMin3 = Math.min;
  function createRound(methodName) {
    var func = Math[methodName];
    return function(number, precision) {
      number = toNumber_default(number);
      precision = precision == null ? 0 : nativeMin3(toInteger_default(precision), 292);
      if (precision && nativeIsFinite(number)) {
        var pair = (toString_default(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
        pair = (toString_default(value) + "e").split("e");
        return +(pair[0] + "e" + (+pair[1] - precision));
      }
      return func(number);
    };
  }
  var createRound_default = createRound;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/ceil.js
  var ceil = createRound_default("ceil");
  var ceil_default = ceil;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/chain.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function chain(value) {
    var result2 = wrapperLodash_default(value);
    result2.__chain__ = true;
    return result2;
  }
  var chain_default = chain;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/chunk.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeCeil = Math.ceil;
  var nativeMax5 = Math.max;
  function chunk(array, size2, guard) {
    if (guard ? isIterateeCall_default(array, size2, guard) : size2 === void 0) {
      size2 = 1;
    } else {
      size2 = nativeMax5(toInteger_default(size2), 0);
    }
    var length = array == null ? 0 : array.length;
    if (!length || size2 < 1) {
      return [];
    }
    var index = 0, resIndex = 0, result2 = Array(nativeCeil(length / size2));
    while (index < length) {
      result2[resIndex++] = baseSlice_default(array, index, index += size2);
    }
    return result2;
  }
  var chunk_default = chunk;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/clamp.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseClamp.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseClamp(number, lower, upper) {
    if (number === number) {
      if (upper !== void 0) {
        number = number <= upper ? number : upper;
      }
      if (lower !== void 0) {
        number = number >= lower ? number : lower;
      }
    }
    return number;
  }
  var baseClamp_default = baseClamp;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/clamp.js
  function clamp(number, lower, upper) {
    if (upper === void 0) {
      upper = lower;
      lower = void 0;
    }
    if (upper !== void 0) {
      upper = toNumber_default(upper);
      upper = upper === upper ? upper : 0;
    }
    if (lower !== void 0) {
      lower = toNumber_default(lower);
      lower = lower === lower ? lower : 0;
    }
    return baseClamp_default(toNumber_default(number), lower, upper);
  }
  var clamp_default = clamp;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/clone.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseClone.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Stack.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stackClear.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function stackClear() {
    this.__data__ = new ListCache_default();
    this.size = 0;
  }
  var stackClear_default = stackClear;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stackDelete.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function stackDelete(key) {
    var data = this.__data__, result2 = data["delete"](key);
    this.size = data.size;
    return result2;
  }
  var stackDelete_default = stackDelete;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stackGet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function stackGet(key) {
    return this.__data__.get(key);
  }
  var stackGet_default = stackGet;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stackHas.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function stackHas(key) {
    return this.__data__.has(key);
  }
  var stackHas_default = stackHas;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stackSet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var LARGE_ARRAY_SIZE = 200;
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache_default) {
      var pairs = data.__data__;
      if (!Map_default || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache_default(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }
  var stackSet_default = stackSet;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Stack.js
  function Stack(entries) {
    var data = this.__data__ = new ListCache_default(entries);
    this.size = data.size;
  }
  Stack.prototype.clear = stackClear_default;
  Stack.prototype["delete"] = stackDelete_default;
  Stack.prototype.get = stackGet_default;
  Stack.prototype.has = stackHas_default;
  Stack.prototype.set = stackSet_default;
  var Stack_default = Stack;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseAssign.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseAssign(object, source) {
    return object && copyObject_default(source, keys_default(source), object);
  }
  var baseAssign_default = baseAssign;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseAssignIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseAssignIn(object, source) {
    return object && copyObject_default(source, keysIn_default(source), object);
  }
  var baseAssignIn_default = baseAssignIn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_cloneBuffer.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var freeExports3 = typeof exports == "object" && exports && !exports.nodeType && exports;
  var freeModule3 = freeExports3 && typeof module == "object" && module && !module.nodeType && module;
  var moduleExports3 = freeModule3 && freeModule3.exports === freeExports3;
  var Buffer4 = moduleExports3 ? root_default.Buffer : void 0;
  var allocUnsafe = Buffer4 ? Buffer4.allocUnsafe : void 0;
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result2);
    return result2;
  }
  var cloneBuffer_default = cloneBuffer;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_copySymbols.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getSymbols.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayFilter.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result2[resIndex++] = value;
      }
    }
    return result2;
  }
  var arrayFilter_default = arrayFilter;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/stubArray.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function stubArray() {
    return [];
  }
  var stubArray_default = stubArray;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getSymbols.js
  var objectProto16 = Object.prototype;
  var propertyIsEnumerable2 = objectProto16.propertyIsEnumerable;
  var nativeGetSymbols = Object.getOwnPropertySymbols;
  var getSymbols = !nativeGetSymbols ? stubArray_default : function(object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return arrayFilter_default(nativeGetSymbols(object), function(symbol) {
      return propertyIsEnumerable2.call(object, symbol);
    });
  };
  var getSymbols_default = getSymbols;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_copySymbols.js
  function copySymbols(source, object) {
    return copyObject_default(source, getSymbols_default(source), object);
  }
  var copySymbols_default = copySymbols;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_copySymbolsIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getSymbolsIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeGetSymbols2 = Object.getOwnPropertySymbols;
  var getSymbolsIn = !nativeGetSymbols2 ? stubArray_default : function(object) {
    var result2 = [];
    while (object) {
      arrayPush_default(result2, getSymbols_default(object));
      object = getPrototype_default(object);
    }
    return result2;
  };
  var getSymbolsIn_default = getSymbolsIn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_copySymbolsIn.js
  function copySymbolsIn(source, object) {
    return copyObject_default(source, getSymbolsIn_default(source), object);
  }
  var copySymbolsIn_default = copySymbolsIn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getAllKeys.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseGetAllKeys.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result2 = keysFunc(object);
    return isArray_default(object) ? result2 : arrayPush_default(result2, symbolsFunc(object));
  }
  var baseGetAllKeys_default = baseGetAllKeys;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getAllKeys.js
  function getAllKeys(object) {
    return baseGetAllKeys_default(object, keys_default, getSymbols_default);
  }
  var getAllKeys_default = getAllKeys;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getAllKeysIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getAllKeysIn(object) {
    return baseGetAllKeys_default(object, keysIn_default, getSymbolsIn_default);
  }
  var getAllKeysIn_default = getAllKeysIn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getTag.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_DataView.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var DataView2 = getNative_default(root_default, "DataView");
  var DataView_default = DataView2;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Promise.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var Promise2 = getNative_default(root_default, "Promise");
  var Promise_default = Promise2;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Set.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var Set2 = getNative_default(root_default, "Set");
  var Set_default = Set2;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getTag.js
  var mapTag2 = "[object Map]";
  var objectTag3 = "[object Object]";
  var promiseTag = "[object Promise]";
  var setTag2 = "[object Set]";
  var weakMapTag2 = "[object WeakMap]";
  var dataViewTag2 = "[object DataView]";
  var dataViewCtorString = toSource_default(DataView_default);
  var mapCtorString = toSource_default(Map_default);
  var promiseCtorString = toSource_default(Promise_default);
  var setCtorString = toSource_default(Set_default);
  var weakMapCtorString = toSource_default(WeakMap_default);
  var getTag = baseGetTag_default;
  if (DataView_default && getTag(new DataView_default(new ArrayBuffer(1))) != dataViewTag2 || Map_default && getTag(new Map_default()) != mapTag2 || Promise_default && getTag(Promise_default.resolve()) != promiseTag || Set_default && getTag(new Set_default()) != setTag2 || WeakMap_default && getTag(new WeakMap_default()) != weakMapTag2) {
    getTag = function(value) {
      var result2 = baseGetTag_default(value), Ctor = result2 == objectTag3 ? value.constructor : void 0, ctorString = Ctor ? toSource_default(Ctor) : "";
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag2;
          case mapCtorString:
            return mapTag2;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag2;
          case weakMapCtorString:
            return weakMapTag2;
        }
      }
      return result2;
    };
  }
  var getTag_default = getTag;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_initCloneArray.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var objectProto17 = Object.prototype;
  var hasOwnProperty15 = objectProto17.hasOwnProperty;
  function initCloneArray(array) {
    var length = array.length, result2 = new array.constructor(length);
    if (length && typeof array[0] == "string" && hasOwnProperty15.call(array, "index")) {
      result2.index = array.index;
      result2.input = array.input;
    }
    return result2;
  }
  var initCloneArray_default = initCloneArray;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_initCloneByTag.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_cloneArrayBuffer.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Uint8Array.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var Uint8Array2 = root_default.Uint8Array;
  var Uint8Array_default = Uint8Array2;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_cloneArrayBuffer.js
  function cloneArrayBuffer(arrayBuffer) {
    var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array_default(result2).set(new Uint8Array_default(arrayBuffer));
    return result2;
  }
  var cloneArrayBuffer_default = cloneArrayBuffer;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_cloneDataView.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer_default(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
  }
  var cloneDataView_default = cloneDataView;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_cloneRegExp.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var reFlags = /\w*$/;
  function cloneRegExp(regexp) {
    var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result2.lastIndex = regexp.lastIndex;
    return result2;
  }
  var cloneRegExp_default = cloneRegExp;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_cloneSymbol.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var symbolProto2 = Symbol_default ? Symbol_default.prototype : void 0;
  var symbolValueOf = symbolProto2 ? symbolProto2.valueOf : void 0;
  function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
  }
  var cloneSymbol_default = cloneSymbol;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_cloneTypedArray.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer_default(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  var cloneTypedArray_default = cloneTypedArray;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_initCloneByTag.js
  var boolTag2 = "[object Boolean]";
  var dateTag2 = "[object Date]";
  var mapTag3 = "[object Map]";
  var numberTag2 = "[object Number]";
  var regexpTag2 = "[object RegExp]";
  var setTag3 = "[object Set]";
  var stringTag2 = "[object String]";
  var symbolTag2 = "[object Symbol]";
  var arrayBufferTag2 = "[object ArrayBuffer]";
  var dataViewTag3 = "[object DataView]";
  var float32Tag2 = "[object Float32Array]";
  var float64Tag2 = "[object Float64Array]";
  var int8Tag2 = "[object Int8Array]";
  var int16Tag2 = "[object Int16Array]";
  var int32Tag2 = "[object Int32Array]";
  var uint8Tag2 = "[object Uint8Array]";
  var uint8ClampedTag2 = "[object Uint8ClampedArray]";
  var uint16Tag2 = "[object Uint16Array]";
  var uint32Tag2 = "[object Uint32Array]";
  function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch (tag) {
      case arrayBufferTag2:
        return cloneArrayBuffer_default(object);
      case boolTag2:
      case dateTag2:
        return new Ctor(+object);
      case dataViewTag3:
        return cloneDataView_default(object, isDeep);
      case float32Tag2:
      case float64Tag2:
      case int8Tag2:
      case int16Tag2:
      case int32Tag2:
      case uint8Tag2:
      case uint8ClampedTag2:
      case uint16Tag2:
      case uint32Tag2:
        return cloneTypedArray_default(object, isDeep);
      case mapTag3:
        return new Ctor();
      case numberTag2:
      case stringTag2:
        return new Ctor(object);
      case regexpTag2:
        return cloneRegExp_default(object);
      case setTag3:
        return new Ctor();
      case symbolTag2:
        return cloneSymbol_default(object);
    }
  }
  var initCloneByTag_default = initCloneByTag;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_initCloneObject.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype_default(object) ? baseCreate_default(getPrototype_default(object)) : {};
  }
  var initCloneObject_default = initCloneObject;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isMap.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsMap.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var mapTag4 = "[object Map]";
  function baseIsMap(value) {
    return isObjectLike_default(value) && getTag_default(value) == mapTag4;
  }
  var baseIsMap_default = baseIsMap;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isMap.js
  var nodeIsMap = nodeUtil_default && nodeUtil_default.isMap;
  var isMap = nodeIsMap ? baseUnary_default(nodeIsMap) : baseIsMap_default;
  var isMap_default = isMap;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isSet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsSet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var setTag4 = "[object Set]";
  function baseIsSet(value) {
    return isObjectLike_default(value) && getTag_default(value) == setTag4;
  }
  var baseIsSet_default = baseIsSet;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isSet.js
  var nodeIsSet = nodeUtil_default && nodeUtil_default.isSet;
  var isSet = nodeIsSet ? baseUnary_default(nodeIsSet) : baseIsSet_default;
  var isSet_default = isSet;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseClone.js
  var CLONE_DEEP_FLAG = 1;
  var CLONE_FLAT_FLAG = 2;
  var CLONE_SYMBOLS_FLAG = 4;
  var argsTag3 = "[object Arguments]";
  var arrayTag2 = "[object Array]";
  var boolTag3 = "[object Boolean]";
  var dateTag3 = "[object Date]";
  var errorTag3 = "[object Error]";
  var funcTag3 = "[object Function]";
  var genTag2 = "[object GeneratorFunction]";
  var mapTag5 = "[object Map]";
  var numberTag3 = "[object Number]";
  var objectTag4 = "[object Object]";
  var regexpTag3 = "[object RegExp]";
  var setTag5 = "[object Set]";
  var stringTag3 = "[object String]";
  var symbolTag3 = "[object Symbol]";
  var weakMapTag3 = "[object WeakMap]";
  var arrayBufferTag3 = "[object ArrayBuffer]";
  var dataViewTag4 = "[object DataView]";
  var float32Tag3 = "[object Float32Array]";
  var float64Tag3 = "[object Float64Array]";
  var int8Tag3 = "[object Int8Array]";
  var int16Tag3 = "[object Int16Array]";
  var int32Tag3 = "[object Int32Array]";
  var uint8Tag3 = "[object Uint8Array]";
  var uint8ClampedTag3 = "[object Uint8ClampedArray]";
  var uint16Tag3 = "[object Uint16Array]";
  var uint32Tag3 = "[object Uint32Array]";
  var cloneableTags = {};
  cloneableTags[argsTag3] = cloneableTags[arrayTag2] = cloneableTags[arrayBufferTag3] = cloneableTags[dataViewTag4] = cloneableTags[boolTag3] = cloneableTags[dateTag3] = cloneableTags[float32Tag3] = cloneableTags[float64Tag3] = cloneableTags[int8Tag3] = cloneableTags[int16Tag3] = cloneableTags[int32Tag3] = cloneableTags[mapTag5] = cloneableTags[numberTag3] = cloneableTags[objectTag4] = cloneableTags[regexpTag3] = cloneableTags[setTag5] = cloneableTags[stringTag3] = cloneableTags[symbolTag3] = cloneableTags[uint8Tag3] = cloneableTags[uint8ClampedTag3] = cloneableTags[uint16Tag3] = cloneableTags[uint32Tag3] = true;
  cloneableTags[errorTag3] = cloneableTags[funcTag3] = cloneableTags[weakMapTag3] = false;
  function baseClone(value, bitmask, customizer2, key, object, stack) {
    var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer2) {
      result2 = object ? customizer2(value, key, object, stack) : customizer2(value);
    }
    if (result2 !== void 0) {
      return result2;
    }
    if (!isObject_default(value)) {
      return value;
    }
    var isArr = isArray_default(value);
    if (isArr) {
      result2 = initCloneArray_default(value);
      if (!isDeep) {
        return copyArray_default(value, result2);
      }
    } else {
      var tag = getTag_default(value), isFunc = tag == funcTag3 || tag == genTag2;
      if (isBuffer_default(value)) {
        return cloneBuffer_default(value, isDeep);
      }
      if (tag == objectTag4 || tag == argsTag3 || isFunc && !object) {
        result2 = isFlat || isFunc ? {} : initCloneObject_default(value);
        if (!isDeep) {
          return isFlat ? copySymbolsIn_default(value, baseAssignIn_default(result2, value)) : copySymbols_default(value, baseAssign_default(result2, value));
        }
      } else {
        if (!cloneableTags[tag]) {
          return object ? value : {};
        }
        result2 = initCloneByTag_default(value, tag, isDeep);
      }
    }
    stack || (stack = new Stack_default());
    var stacked = stack.get(value);
    if (stacked) {
      return stacked;
    }
    stack.set(value, result2);
    if (isSet_default(value)) {
      value.forEach(function(subValue) {
        result2.add(baseClone(subValue, bitmask, customizer2, subValue, value, stack));
      });
    } else if (isMap_default(value)) {
      value.forEach(function(subValue, key2) {
        result2.set(key2, baseClone(subValue, bitmask, customizer2, key2, value, stack));
      });
    }
    var keysFunc = isFull ? isFlat ? getAllKeysIn_default : getAllKeys_default : isFlat ? keysIn_default : keys_default;
    var props = isArr ? void 0 : keysFunc(value);
    arrayEach_default(props || value, function(subValue, key2) {
      if (props) {
        key2 = subValue;
        subValue = value[key2];
      }
      assignValue_default(result2, key2, baseClone(subValue, bitmask, customizer2, key2, value, stack));
    });
    return result2;
  }
  var baseClone_default = baseClone;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/clone.js
  var CLONE_SYMBOLS_FLAG2 = 4;
  function clone(value) {
    return baseClone_default(value, CLONE_SYMBOLS_FLAG2);
  }
  var clone_default = clone;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/cloneDeep.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var CLONE_DEEP_FLAG2 = 1;
  var CLONE_SYMBOLS_FLAG3 = 4;
  function cloneDeep(value) {
    return baseClone_default(value, CLONE_DEEP_FLAG2 | CLONE_SYMBOLS_FLAG3);
  }
  var cloneDeep_default = cloneDeep;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/cloneDeepWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var CLONE_DEEP_FLAG3 = 1;
  var CLONE_SYMBOLS_FLAG4 = 4;
  function cloneDeepWith(value, customizer2) {
    customizer2 = typeof customizer2 == "function" ? customizer2 : void 0;
    return baseClone_default(value, CLONE_DEEP_FLAG3 | CLONE_SYMBOLS_FLAG4, customizer2);
  }
  var cloneDeepWith_default = cloneDeepWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/cloneWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var CLONE_SYMBOLS_FLAG5 = 4;
  function cloneWith(value, customizer2) {
    customizer2 = typeof customizer2 == "function" ? customizer2 : void 0;
    return baseClone_default(value, CLONE_SYMBOLS_FLAG5, customizer2);
  }
  var cloneWith_default = cloneWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/commit.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function wrapperCommit() {
    return new LodashWrapper_default(this.value(), this.__chain__);
  }
  var commit_default = wrapperCommit;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/compact.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
    while (++index < length) {
      var value = array[index];
      if (value) {
        result2[resIndex++] = value;
      }
    }
    return result2;
  }
  var compact_default = compact;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/concat.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function concat() {
    var length = arguments.length;
    if (!length) {
      return [];
    }
    var args = Array(length - 1), array = arguments[0], index = length;
    while (index--) {
      args[index - 1] = arguments[index];
    }
    return arrayPush_default(isArray_default(array) ? copyArray_default(array) : [array], baseFlatten_default(args, 1));
  }
  var concat_default = concat;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/cond.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIteratee.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseMatches.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsMatch.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsEqual.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsEqualDeep.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_equalArrays.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_SetCache.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_setCacheAdd.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var HASH_UNDEFINED3 = "__lodash_hash_undefined__";
  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED3);
    return this;
  }
  var setCacheAdd_default = setCacheAdd;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_setCacheHas.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function setCacheHas(value) {
    return this.__data__.has(value);
  }
  var setCacheHas_default = setCacheHas;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_SetCache.js
  function SetCache(values2) {
    var index = -1, length = values2 == null ? 0 : values2.length;
    this.__data__ = new MapCache_default();
    while (++index < length) {
      this.add(values2[index]);
    }
  }
  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd_default;
  SetCache.prototype.has = setCacheHas_default;
  var SetCache_default = SetCache;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arraySome.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }
  var arraySome_default = arraySome;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_cacheHas.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function cacheHas(cache, key) {
    return cache.has(key);
  }
  var cacheHas_default = cacheHas;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_equalArrays.js
  var COMPARE_PARTIAL_FLAG = 1;
  var COMPARE_UNORDERED_FLAG = 2;
  function equalArrays(array, other, bitmask, customizer2, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) {
      return arrStacked == other && othStacked == array;
    }
    var index = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache_default() : void 0;
    stack.set(array, other);
    stack.set(other, array);
    while (++index < arrLength) {
      var arrValue = array[index], othValue = other[index];
      if (customizer2) {
        var compared = isPartial ? customizer2(othValue, arrValue, index, other, array, stack) : customizer2(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result2 = false;
        break;
      }
      if (seen) {
        if (!arraySome_default(other, function(othValue2, othIndex) {
          if (!cacheHas_default(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer2, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result2 = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer2, stack))) {
        result2 = false;
        break;
      }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result2;
  }
  var equalArrays_default = equalArrays;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_equalByTag.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapToArray.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function mapToArray(map2) {
    var index = -1, result2 = Array(map2.size);
    map2.forEach(function(value, key) {
      result2[++index] = [key, value];
    });
    return result2;
  }
  var mapToArray_default = mapToArray;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_setToArray.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function setToArray(set2) {
    var index = -1, result2 = Array(set2.size);
    set2.forEach(function(value) {
      result2[++index] = value;
    });
    return result2;
  }
  var setToArray_default = setToArray;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_equalByTag.js
  var COMPARE_PARTIAL_FLAG2 = 1;
  var COMPARE_UNORDERED_FLAG2 = 2;
  var boolTag4 = "[object Boolean]";
  var dateTag4 = "[object Date]";
  var errorTag4 = "[object Error]";
  var mapTag6 = "[object Map]";
  var numberTag4 = "[object Number]";
  var regexpTag4 = "[object RegExp]";
  var setTag6 = "[object Set]";
  var stringTag4 = "[object String]";
  var symbolTag4 = "[object Symbol]";
  var arrayBufferTag4 = "[object ArrayBuffer]";
  var dataViewTag5 = "[object DataView]";
  var symbolProto3 = Symbol_default ? Symbol_default.prototype : void 0;
  var symbolValueOf2 = symbolProto3 ? symbolProto3.valueOf : void 0;
  function equalByTag(object, other, tag, bitmask, customizer2, equalFunc, stack) {
    switch (tag) {
      case dataViewTag5:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;
      case arrayBufferTag4:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array_default(object), new Uint8Array_default(other))) {
          return false;
        }
        return true;
      case boolTag4:
      case dateTag4:
      case numberTag4:
        return eq_default(+object, +other);
      case errorTag4:
        return object.name == other.name && object.message == other.message;
      case regexpTag4:
      case stringTag4:
        return object == other + "";
      case mapTag6:
        var convert = mapToArray_default;
      case setTag6:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
        convert || (convert = setToArray_default);
        if (object.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG2;
        stack.set(object, other);
        var result2 = equalArrays_default(convert(object), convert(other), bitmask, customizer2, equalFunc, stack);
        stack["delete"](object);
        return result2;
      case symbolTag4:
        if (symbolValueOf2) {
          return symbolValueOf2.call(object) == symbolValueOf2.call(other);
        }
    }
    return false;
  }
  var equalByTag_default = equalByTag;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_equalObjects.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var COMPARE_PARTIAL_FLAG3 = 1;
  var objectProto18 = Object.prototype;
  var hasOwnProperty16 = objectProto18.hasOwnProperty;
  function equalObjects(object, other, bitmask, customizer2, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG3, objProps = getAllKeys_default(object), objLength = objProps.length, othProps = getAllKeys_default(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty16.call(other, key))) {
        return false;
      }
    }
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) {
      return objStacked == other && othStacked == object;
    }
    var result2 = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key], othValue = other[key];
      if (customizer2) {
        var compared = isPartial ? customizer2(othValue, objValue, key, other, object, stack) : customizer2(objValue, othValue, key, object, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer2, stack) : compared)) {
        result2 = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result2 && !skipCtor) {
      var objCtor = object.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result2 = false;
      }
    }
    stack["delete"](object);
    stack["delete"](other);
    return result2;
  }
  var equalObjects_default = equalObjects;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsEqualDeep.js
  var COMPARE_PARTIAL_FLAG4 = 1;
  var argsTag4 = "[object Arguments]";
  var arrayTag3 = "[object Array]";
  var objectTag5 = "[object Object]";
  var objectProto19 = Object.prototype;
  var hasOwnProperty17 = objectProto19.hasOwnProperty;
  function baseIsEqualDeep(object, other, bitmask, customizer2, equalFunc, stack) {
    var objIsArr = isArray_default(object), othIsArr = isArray_default(other), objTag = objIsArr ? arrayTag3 : getTag_default(object), othTag = othIsArr ? arrayTag3 : getTag_default(other);
    objTag = objTag == argsTag4 ? objectTag5 : objTag;
    othTag = othTag == argsTag4 ? objectTag5 : othTag;
    var objIsObj = objTag == objectTag5, othIsObj = othTag == objectTag5, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer_default(object)) {
      if (!isBuffer_default(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack_default());
      return objIsArr || isTypedArray_default(object) ? equalArrays_default(object, other, bitmask, customizer2, equalFunc, stack) : equalByTag_default(object, other, objTag, bitmask, customizer2, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG4)) {
      var objIsWrapped = objIsObj && hasOwnProperty17.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty17.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack_default());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer2, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack_default());
    return equalObjects_default(object, other, bitmask, customizer2, equalFunc, stack);
  }
  var baseIsEqualDeep_default = baseIsEqualDeep;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsEqual.js
  function baseIsEqual(value, other, bitmask, customizer2, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike_default(value) && !isObjectLike_default(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep_default(value, other, bitmask, customizer2, baseIsEqual, stack);
  }
  var baseIsEqual_default = baseIsEqual;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsMatch.js
  var COMPARE_PARTIAL_FLAG5 = 1;
  var COMPARE_UNORDERED_FLAG3 = 2;
  function baseIsMatch(object, source, matchData, customizer2) {
    var index = matchData.length, length = index, noCustomizer = !customizer2;
    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (index--) {
      var data = matchData[index];
      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }
    while (++index < length) {
      data = matchData[index];
      var key = data[0], objValue = object[key], srcValue = data[1];
      if (noCustomizer && data[2]) {
        if (objValue === void 0 && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack_default();
        if (customizer2) {
          var result2 = customizer2(objValue, srcValue, key, object, source, stack);
        }
        if (!(result2 === void 0 ? baseIsEqual_default(srcValue, objValue, COMPARE_PARTIAL_FLAG5 | COMPARE_UNORDERED_FLAG3, customizer2, stack) : result2)) {
          return false;
        }
      }
    }
    return true;
  }
  var baseIsMatch_default = baseIsMatch;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getMatchData.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isStrictComparable.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isStrictComparable(value) {
    return value === value && !isObject_default(value);
  }
  var isStrictComparable_default = isStrictComparable;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getMatchData.js
  function getMatchData(object) {
    var result2 = keys_default(object), length = result2.length;
    while (length--) {
      var key = result2[length], value = object[key];
      result2[length] = [key, value, isStrictComparable_default(value)];
    }
    return result2;
  }
  var getMatchData_default = getMatchData;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_matchesStrictComparable.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function matchesStrictComparable(key, srcValue) {
    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
    };
  }
  var matchesStrictComparable_default = matchesStrictComparable;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseMatches.js
  function baseMatches(source) {
    var matchData = getMatchData_default(source);
    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable_default(matchData[0][0], matchData[0][1]);
    }
    return function(object) {
      return object === source || baseIsMatch_default(object, source, matchData);
    };
  }
  var baseMatches_default = baseMatches;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseMatchesProperty.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/hasIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseHasIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }
  var baseHasIn_default = baseHasIn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hasPath.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function hasPath(object, path, hasFunc) {
    path = castPath_default(path, object);
    var index = -1, length = path.length, result2 = false;
    while (++index < length) {
      var key = toKey_default(path[index]);
      if (!(result2 = object != null && hasFunc(object, key))) {
        break;
      }
      object = object[key];
    }
    if (result2 || ++index != length) {
      return result2;
    }
    length = object == null ? 0 : object.length;
    return !!length && isLength_default(length) && isIndex_default(key, length) && (isArray_default(object) || isArguments_default(object));
  }
  var hasPath_default = hasPath;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/hasIn.js
  function hasIn(object, path) {
    return object != null && hasPath_default(object, path, baseHasIn_default);
  }
  var hasIn_default = hasIn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseMatchesProperty.js
  var COMPARE_PARTIAL_FLAG6 = 1;
  var COMPARE_UNORDERED_FLAG4 = 2;
  function baseMatchesProperty(path, srcValue) {
    if (isKey_default(path) && isStrictComparable_default(srcValue)) {
      return matchesStrictComparable_default(toKey_default(path), srcValue);
    }
    return function(object) {
      var objValue = get_default(object, path);
      return objValue === void 0 && objValue === srcValue ? hasIn_default(object, path) : baseIsEqual_default(srcValue, objValue, COMPARE_PARTIAL_FLAG6 | COMPARE_UNORDERED_FLAG4);
    };
  }
  var baseMatchesProperty_default = baseMatchesProperty;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/property.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseProperty.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseProperty(key) {
    return function(object) {
      return object == null ? void 0 : object[key];
    };
  }
  var baseProperty_default = baseProperty;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_basePropertyDeep.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function basePropertyDeep(path) {
    return function(object) {
      return baseGet_default(object, path);
    };
  }
  var basePropertyDeep_default = basePropertyDeep;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/property.js
  function property(path) {
    return isKey_default(path) ? baseProperty_default(toKey_default(path)) : basePropertyDeep_default(path);
  }
  var property_default = property;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIteratee.js
  function baseIteratee(value) {
    if (typeof value == "function") {
      return value;
    }
    if (value == null) {
      return identity_default;
    }
    if (typeof value == "object") {
      return isArray_default(value) ? baseMatchesProperty_default(value[0], value[1]) : baseMatches_default(value);
    }
    return property_default(value);
  }
  var baseIteratee_default = baseIteratee;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/cond.js
  var FUNC_ERROR_TEXT5 = "Expected a function";
  function cond(pairs) {
    var length = pairs == null ? 0 : pairs.length, toIteratee = baseIteratee_default;
    pairs = !length ? [] : arrayMap_default(pairs, function(pair) {
      if (typeof pair[1] != "function") {
        throw new TypeError(FUNC_ERROR_TEXT5);
      }
      return [toIteratee(pair[0]), pair[1]];
    });
    return baseRest_default(function(args) {
      var index = -1;
      while (++index < length) {
        var pair = pairs[index];
        if (apply_default(pair[0], this, args)) {
          return apply_default(pair[1], this, args);
        }
      }
    });
  }
  var cond_default = cond;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/conforms.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseConforms.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseConformsTo.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseConformsTo(object, source, props) {
    var length = props.length;
    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (length--) {
      var key = props[length], predicate = source[key], value = object[key];
      if (value === void 0 && !(key in object) || !predicate(value)) {
        return false;
      }
    }
    return true;
  }
  var baseConformsTo_default = baseConformsTo;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseConforms.js
  function baseConforms(source) {
    var props = keys_default(source);
    return function(object) {
      return baseConformsTo_default(object, source, props);
    };
  }
  var baseConforms_default = baseConforms;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/conforms.js
  var CLONE_DEEP_FLAG4 = 1;
  function conforms(source) {
    return baseConforms_default(baseClone_default(source, CLONE_DEEP_FLAG4));
  }
  var conforms_default = conforms;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/conformsTo.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function conformsTo(object, source) {
    return source == null || baseConformsTo_default(object, source, keys_default(source));
  }
  var conformsTo_default = conformsTo;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/countBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createAggregator.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayAggregator.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function arrayAggregator(array, setter, iteratee2, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee2(value), array);
    }
    return accumulator;
  }
  var arrayAggregator_default = arrayAggregator;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseAggregator.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseEach.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseForOwn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseFor.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createBaseFor.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function createBaseFor(fromRight) {
    return function(object, iteratee2, keysFunc) {
      var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee2(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }
  var createBaseFor_default = createBaseFor;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseFor.js
  var baseFor = createBaseFor_default();
  var baseFor_default = baseFor;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseForOwn.js
  function baseForOwn(object, iteratee2) {
    return object && baseFor_default(object, iteratee2, keys_default);
  }
  var baseForOwn_default = baseForOwn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createBaseEach.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee2) {
      if (collection == null) {
        return collection;
      }
      if (!isArrayLike_default(collection)) {
        return eachFunc(collection, iteratee2);
      }
      var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
      while (fromRight ? index-- : ++index < length) {
        if (iteratee2(iterable[index], index, iterable) === false) {
          break;
        }
      }
      return collection;
    };
  }
  var createBaseEach_default = createBaseEach;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseEach.js
  var baseEach = createBaseEach_default(baseForOwn_default);
  var baseEach_default = baseEach;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseAggregator.js
  function baseAggregator(collection, setter, iteratee2, accumulator) {
    baseEach_default(collection, function(value, key, collection2) {
      setter(accumulator, value, iteratee2(value), collection2);
    });
    return accumulator;
  }
  var baseAggregator_default = baseAggregator;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createAggregator.js
  function createAggregator(setter, initializer) {
    return function(collection, iteratee2) {
      var func = isArray_default(collection) ? arrayAggregator_default : baseAggregator_default, accumulator = initializer ? initializer() : {};
      return func(collection, setter, baseIteratee_default(iteratee2, 2), accumulator);
    };
  }
  var createAggregator_default = createAggregator;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/countBy.js
  var objectProto20 = Object.prototype;
  var hasOwnProperty18 = objectProto20.hasOwnProperty;
  var countBy = createAggregator_default(function(result2, value, key) {
    if (hasOwnProperty18.call(result2, key)) {
      ++result2[key];
    } else {
      baseAssignValue_default(result2, key, 1);
    }
  });
  var countBy_default = countBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/create.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function create(prototype, properties) {
    var result2 = baseCreate_default(prototype);
    return properties == null ? result2 : baseAssign_default(result2, properties);
  }
  var create_default = create;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/curry.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var WRAP_CURRY_FLAG6 = 8;
  function curry(func, arity, guard) {
    arity = guard ? void 0 : arity;
    var result2 = createWrap_default(func, WRAP_CURRY_FLAG6, void 0, void 0, void 0, void 0, void 0, arity);
    result2.placeholder = curry.placeholder;
    return result2;
  }
  curry.placeholder = {};
  var curry_default = curry;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/curryRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var WRAP_CURRY_RIGHT_FLAG4 = 16;
  function curryRight(func, arity, guard) {
    arity = guard ? void 0 : arity;
    var result2 = createWrap_default(func, WRAP_CURRY_RIGHT_FLAG4, void 0, void 0, void 0, void 0, void 0, arity);
    result2.placeholder = curryRight.placeholder;
    return result2;
  }
  curryRight.placeholder = {};
  var curryRight_default = curryRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/debounce.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/now.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var now = function() {
    return root_default.Date.now();
  };
  var now_default = now;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/debounce.js
  var FUNC_ERROR_TEXT6 = "Expected a function";
  var nativeMax6 = Math.max;
  var nativeMin4 = Math.min;
  function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT6);
    }
    wait = toNumber_default(wait) || 0;
    if (isObject_default(options)) {
      leading = !!options.leading;
      maxing = "maxWait" in options;
      maxWait = maxing ? nativeMax6(toNumber_default(options.maxWait) || 0, wait) : maxWait;
      trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
      var args = lastArgs, thisArg = lastThis;
      lastArgs = lastThis = void 0;
      lastInvokeTime = time;
      result2 = func.apply(thisArg, args);
      return result2;
    }
    function leadingEdge(time) {
      lastInvokeTime = time;
      timerId = setTimeout(timerExpired, wait);
      return leading ? invokeFunc(time) : result2;
    }
    function remainingWait(time) {
      var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
      return maxing ? nativeMin4(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
      var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
      return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
      var time = now_default();
      if (shouldInvoke(time)) {
        return trailingEdge(time);
      }
      timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
      timerId = void 0;
      if (trailing && lastArgs) {
        return invokeFunc(time);
      }
      lastArgs = lastThis = void 0;
      return result2;
    }
    function cancel() {
      if (timerId !== void 0) {
        clearTimeout(timerId);
      }
      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timerId = void 0;
    }
    function flush() {
      return timerId === void 0 ? result2 : trailingEdge(now_default());
    }
    function debounced() {
      var time = now_default(), isInvoking = shouldInvoke(time);
      lastArgs = arguments;
      lastThis = this;
      lastCallTime = time;
      if (isInvoking) {
        if (timerId === void 0) {
          return leadingEdge(lastCallTime);
        }
        if (maxing) {
          clearTimeout(timerId);
          timerId = setTimeout(timerExpired, wait);
          return invokeFunc(lastCallTime);
        }
      }
      if (timerId === void 0) {
        timerId = setTimeout(timerExpired, wait);
      }
      return result2;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  }
  var debounce_default = debounce;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/defaultTo.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
  var defaultTo_default = defaultTo;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/defaults.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var objectProto21 = Object.prototype;
  var hasOwnProperty19 = objectProto21.hasOwnProperty;
  var defaults = baseRest_default(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : void 0;
    if (guard && isIterateeCall_default(sources[0], sources[1], guard)) {
      length = 1;
    }
    while (++index < length) {
      var source = sources[index];
      var props = keysIn_default(source);
      var propsIndex = -1;
      var propsLength = props.length;
      while (++propsIndex < propsLength) {
        var key = props[propsIndex];
        var value = object[key];
        if (value === void 0 || eq_default(value, objectProto21[key]) && !hasOwnProperty19.call(object, key)) {
          object[key] = source[key];
        }
      }
    }
    return object;
  });
  var defaults_default = defaults;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/defaultsDeep.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_customDefaultsMerge.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseMerge.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_assignMergeValue.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function assignMergeValue(object, key, value) {
    if (value !== void 0 && !eq_default(object[key], value) || value === void 0 && !(key in object)) {
      baseAssignValue_default(object, key, value);
    }
  }
  var assignMergeValue_default = assignMergeValue;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseMergeDeep.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArrayLikeObject.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isArrayLikeObject(value) {
    return isObjectLike_default(value) && isArrayLike_default(value);
  }
  var isArrayLikeObject_default = isArrayLikeObject;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_safeGet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") {
      return;
    }
    if (key == "__proto__") {
      return;
    }
    return object[key];
  }
  var safeGet_default = safeGet;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toPlainObject.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function toPlainObject(value) {
    return copyObject_default(value, keysIn_default(value));
  }
  var toPlainObject_default = toPlainObject;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseMergeDeep.js
  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer2, stack) {
    var objValue = safeGet_default(object, key), srcValue = safeGet_default(source, key), stacked = stack.get(srcValue);
    if (stacked) {
      assignMergeValue_default(object, key, stacked);
      return;
    }
    var newValue = customizer2 ? customizer2(objValue, srcValue, key + "", object, source, stack) : void 0;
    var isCommon = newValue === void 0;
    if (isCommon) {
      var isArr = isArray_default(srcValue), isBuff = !isArr && isBuffer_default(srcValue), isTyped = !isArr && !isBuff && isTypedArray_default(srcValue);
      newValue = srcValue;
      if (isArr || isBuff || isTyped) {
        if (isArray_default(objValue)) {
          newValue = objValue;
        } else if (isArrayLikeObject_default(objValue)) {
          newValue = copyArray_default(objValue);
        } else if (isBuff) {
          isCommon = false;
          newValue = cloneBuffer_default(srcValue, true);
        } else if (isTyped) {
          isCommon = false;
          newValue = cloneTypedArray_default(srcValue, true);
        } else {
          newValue = [];
        }
      } else if (isPlainObject_default(srcValue) || isArguments_default(srcValue)) {
        newValue = objValue;
        if (isArguments_default(objValue)) {
          newValue = toPlainObject_default(objValue);
        } else if (!isObject_default(objValue) || isFunction_default(objValue)) {
          newValue = initCloneObject_default(srcValue);
        }
      } else {
        isCommon = false;
      }
    }
    if (isCommon) {
      stack.set(srcValue, newValue);
      mergeFunc(newValue, srcValue, srcIndex, customizer2, stack);
      stack["delete"](srcValue);
    }
    assignMergeValue_default(object, key, newValue);
  }
  var baseMergeDeep_default = baseMergeDeep;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseMerge.js
  function baseMerge(object, source, srcIndex, customizer2, stack) {
    if (object === source) {
      return;
    }
    baseFor_default(source, function(srcValue, key) {
      stack || (stack = new Stack_default());
      if (isObject_default(srcValue)) {
        baseMergeDeep_default(object, source, key, srcIndex, baseMerge, customizer2, stack);
      } else {
        var newValue = customizer2 ? customizer2(safeGet_default(object, key), srcValue, key + "", object, source, stack) : void 0;
        if (newValue === void 0) {
          newValue = srcValue;
        }
        assignMergeValue_default(object, key, newValue);
      }
    }, keysIn_default);
  }
  var baseMerge_default = baseMerge;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_customDefaultsMerge.js
  function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if (isObject_default(objValue) && isObject_default(srcValue)) {
      stack.set(srcValue, objValue);
      baseMerge_default(objValue, srcValue, void 0, customDefaultsMerge, stack);
      stack["delete"](srcValue);
    }
    return objValue;
  }
  var customDefaultsMerge_default = customDefaultsMerge;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/mergeWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var mergeWith = createAssigner_default(function(object, source, srcIndex, customizer2) {
    baseMerge_default(object, source, srcIndex, customizer2);
  });
  var mergeWith_default = mergeWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/defaultsDeep.js
  var defaultsDeep = baseRest_default(function(args) {
    args.push(void 0, customDefaultsMerge_default);
    return apply_default(mergeWith_default, void 0, args);
  });
  var defaultsDeep_default = defaultsDeep;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/defer.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseDelay.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var FUNC_ERROR_TEXT7 = "Expected a function";
  function baseDelay(func, wait, args) {
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT7);
    }
    return setTimeout(function() {
      func.apply(void 0, args);
    }, wait);
  }
  var baseDelay_default = baseDelay;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/defer.js
  var defer = baseRest_default(function(func, args) {
    return baseDelay_default(func, 1, args);
  });
  var defer_default = defer;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/delay.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var delay = baseRest_default(function(func, wait, args) {
    return baseDelay_default(func, toNumber_default(wait) || 0, args);
  });
  var delay_default = delay;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/difference.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseDifference.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayIncludesWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }
  var arrayIncludesWith_default = arrayIncludesWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseDifference.js
  var LARGE_ARRAY_SIZE2 = 200;
  function baseDifference(array, values2, iteratee2, comparator) {
    var index = -1, includes2 = arrayIncludes_default, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
    if (!length) {
      return result2;
    }
    if (iteratee2) {
      values2 = arrayMap_default(values2, baseUnary_default(iteratee2));
    }
    if (comparator) {
      includes2 = arrayIncludesWith_default;
      isCommon = false;
    } else if (values2.length >= LARGE_ARRAY_SIZE2) {
      includes2 = cacheHas_default;
      isCommon = false;
      values2 = new SetCache_default(values2);
    }
    outer:
      while (++index < length) {
        var value = array[index], computed = iteratee2 == null ? value : iteratee2(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values2[valuesIndex] === computed) {
              continue outer;
            }
          }
          result2.push(value);
        } else if (!includes2(values2, computed, comparator)) {
          result2.push(value);
        }
      }
    return result2;
  }
  var baseDifference_default = baseDifference;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/difference.js
  var difference = baseRest_default(function(array, values2) {
    return isArrayLikeObject_default(array) ? baseDifference_default(array, baseFlatten_default(values2, 1, isArrayLikeObject_default, true)) : [];
  });
  var difference_default = difference;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/differenceBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/last.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : void 0;
  }
  var last_default = last;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/differenceBy.js
  var differenceBy = baseRest_default(function(array, values2) {
    var iteratee2 = last_default(values2);
    if (isArrayLikeObject_default(iteratee2)) {
      iteratee2 = void 0;
    }
    return isArrayLikeObject_default(array) ? baseDifference_default(array, baseFlatten_default(values2, 1, isArrayLikeObject_default, true), baseIteratee_default(iteratee2, 2)) : [];
  });
  var differenceBy_default = differenceBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/differenceWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var differenceWith = baseRest_default(function(array, values2) {
    var comparator = last_default(values2);
    if (isArrayLikeObject_default(comparator)) {
      comparator = void 0;
    }
    return isArrayLikeObject_default(array) ? baseDifference_default(array, baseFlatten_default(values2, 1, isArrayLikeObject_default, true), void 0, comparator) : [];
  });
  var differenceWith_default = differenceWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/divide.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var divide = createMathOperation_default(function(dividend, divisor) {
    return dividend / divisor;
  }, 1);
  var divide_default = divide;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/drop.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function drop(array, n, guard) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    n = guard || n === void 0 ? 1 : toInteger_default(n);
    return baseSlice_default(array, n < 0 ? 0 : n, length);
  }
  var drop_default = drop;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/dropRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function dropRight(array, n, guard) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    n = guard || n === void 0 ? 1 : toInteger_default(n);
    n = length - n;
    return baseSlice_default(array, 0, n < 0 ? 0 : n);
  }
  var dropRight_default = dropRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/dropRightWhile.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseWhile.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseWhile(array, predicate, isDrop, fromRight) {
    var length = array.length, index = fromRight ? length : -1;
    while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
    }
    return isDrop ? baseSlice_default(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice_default(array, fromRight ? index + 1 : 0, fromRight ? length : index);
  }
  var baseWhile_default = baseWhile;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/dropRightWhile.js
  function dropRightWhile(array, predicate) {
    return array && array.length ? baseWhile_default(array, baseIteratee_default(predicate, 3), true, true) : [];
  }
  var dropRightWhile_default = dropRightWhile;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/dropWhile.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function dropWhile(array, predicate) {
    return array && array.length ? baseWhile_default(array, baseIteratee_default(predicate, 3), true) : [];
  }
  var dropWhile_default = dropWhile;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/each.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/forEach.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_castFunction.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function castFunction(value) {
    return typeof value == "function" ? value : identity_default;
  }
  var castFunction_default = castFunction;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/forEach.js
  function forEach(collection, iteratee2) {
    var func = isArray_default(collection) ? arrayEach_default : baseEach_default;
    return func(collection, castFunction_default(iteratee2));
  }
  var forEach_default = forEach;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/eachRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/forEachRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayEachRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function arrayEachRight(array, iteratee2) {
    var length = array == null ? 0 : array.length;
    while (length--) {
      if (iteratee2(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }
  var arrayEachRight_default = arrayEachRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseEachRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseForOwnRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseForRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var baseForRight = createBaseFor_default(true);
  var baseForRight_default = baseForRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseForOwnRight.js
  function baseForOwnRight(object, iteratee2) {
    return object && baseForRight_default(object, iteratee2, keys_default);
  }
  var baseForOwnRight_default = baseForOwnRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseEachRight.js
  var baseEachRight = createBaseEach_default(baseForOwnRight_default, true);
  var baseEachRight_default = baseEachRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/forEachRight.js
  function forEachRight(collection, iteratee2) {
    var func = isArray_default(collection) ? arrayEachRight_default : baseEachRight_default;
    return func(collection, castFunction_default(iteratee2));
  }
  var forEachRight_default = forEachRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/endsWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function endsWith(string, target, position) {
    string = toString_default(string);
    target = baseToString_default(target);
    var length = string.length;
    position = position === void 0 ? length : baseClamp_default(toInteger_default(position), 0, length);
    var end = position;
    position -= target.length;
    return position >= 0 && string.slice(position, end) == target;
  }
  var endsWith_default = endsWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/entries.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toPairs.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createToPairs.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseToPairs.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseToPairs(object, props) {
    return arrayMap_default(props, function(key) {
      return [key, object[key]];
    });
  }
  var baseToPairs_default = baseToPairs;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_setToPairs.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function setToPairs(set2) {
    var index = -1, result2 = Array(set2.size);
    set2.forEach(function(value) {
      result2[++index] = [value, value];
    });
    return result2;
  }
  var setToPairs_default = setToPairs;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createToPairs.js
  var mapTag7 = "[object Map]";
  var setTag7 = "[object Set]";
  function createToPairs(keysFunc) {
    return function(object) {
      var tag = getTag_default(object);
      if (tag == mapTag7) {
        return mapToArray_default(object);
      }
      if (tag == setTag7) {
        return setToPairs_default(object);
      }
      return baseToPairs_default(object, keysFunc(object));
    };
  }
  var createToPairs_default = createToPairs;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toPairs.js
  var toPairs = createToPairs_default(keys_default);
  var toPairs_default = toPairs;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/entriesIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toPairsIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var toPairsIn = createToPairs_default(keysIn_default);
  var toPairsIn_default = toPairsIn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/escape.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_escapeHtmlChar.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var htmlEscapes = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  };
  var escapeHtmlChar = basePropertyOf_default(htmlEscapes);
  var escapeHtmlChar_default = escapeHtmlChar;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/escape.js
  var reUnescapedHtml = /[&<>"']/g;
  var reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
  function escape(string) {
    string = toString_default(string);
    return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar_default) : string;
  }
  var escape_default = escape;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/escapeRegExp.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reHasRegExpChar = RegExp(reRegExpChar2.source);
  function escapeRegExp(string) {
    string = toString_default(string);
    return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar2, "\\$&") : string;
  }
  var escapeRegExp_default = escapeRegExp;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/every.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayEvery.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }
  var arrayEvery_default = arrayEvery;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseEvery.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseEvery(collection, predicate) {
    var result2 = true;
    baseEach_default(collection, function(value, index, collection2) {
      result2 = !!predicate(value, index, collection2);
      return result2;
    });
    return result2;
  }
  var baseEvery_default = baseEvery;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/every.js
  function every(collection, predicate, guard) {
    var func = isArray_default(collection) ? arrayEvery_default : baseEvery_default;
    if (guard && isIterateeCall_default(collection, predicate, guard)) {
      predicate = void 0;
    }
    return func(collection, baseIteratee_default(predicate, 3));
  }
  var every_default = every;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/extend.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/extendWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/fill.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseFill.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toLength.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var MAX_ARRAY_LENGTH2 = 4294967295;
  function toLength(value) {
    return value ? baseClamp_default(toInteger_default(value), 0, MAX_ARRAY_LENGTH2) : 0;
  }
  var toLength_default = toLength;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseFill.js
  function baseFill(array, value, start, end) {
    var length = array.length;
    start = toInteger_default(start);
    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }
    end = end === void 0 || end > length ? length : toInteger_default(end);
    if (end < 0) {
      end += length;
    }
    end = start > end ? 0 : toLength_default(end);
    while (start < end) {
      array[start++] = value;
    }
    return array;
  }
  var baseFill_default = baseFill;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/fill.js
  function fill(array, value, start, end) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    if (start && typeof start != "number" && isIterateeCall_default(array, value, start)) {
      start = 0;
      end = length;
    }
    return baseFill_default(array, value, start, end);
  }
  var fill_default = fill;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/filter.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseFilter.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseFilter(collection, predicate) {
    var result2 = [];
    baseEach_default(collection, function(value, index, collection2) {
      if (predicate(value, index, collection2)) {
        result2.push(value);
      }
    });
    return result2;
  }
  var baseFilter_default = baseFilter;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/filter.js
  function filter(collection, predicate) {
    var func = isArray_default(collection) ? arrayFilter_default : baseFilter_default;
    return func(collection, baseIteratee_default(predicate, 3));
  }
  var filter_default = filter;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/find.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createFind.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
      var iterable = Object(collection);
      if (!isArrayLike_default(collection)) {
        var iteratee2 = baseIteratee_default(predicate, 3);
        collection = keys_default(collection);
        predicate = function(key) {
          return iteratee2(iterable[key], key, iterable);
        };
      }
      var index = findIndexFunc(collection, predicate, fromIndex);
      return index > -1 ? iterable[iteratee2 ? collection[index] : index] : void 0;
    };
  }
  var createFind_default = createFind;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/findIndex.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeMax7 = Math.max;
  function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return -1;
    }
    var index = fromIndex == null ? 0 : toInteger_default(fromIndex);
    if (index < 0) {
      index = nativeMax7(length + index, 0);
    }
    return baseFindIndex_default(array, baseIteratee_default(predicate, 3), index);
  }
  var findIndex_default = findIndex;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/find.js
  var find = createFind_default(findIndex_default);
  var find_default = find;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/findKey.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseFindKey.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseFindKey(collection, predicate, eachFunc) {
    var result2;
    eachFunc(collection, function(value, key, collection2) {
      if (predicate(value, key, collection2)) {
        result2 = key;
        return false;
      }
    });
    return result2;
  }
  var baseFindKey_default = baseFindKey;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/findKey.js
  function findKey(object, predicate) {
    return baseFindKey_default(object, baseIteratee_default(predicate, 3), baseForOwn_default);
  }
  var findKey_default = findKey;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/findLast.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/findLastIndex.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeMax8 = Math.max;
  var nativeMin5 = Math.min;
  function findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return -1;
    }
    var index = length - 1;
    if (fromIndex !== void 0) {
      index = toInteger_default(fromIndex);
      index = fromIndex < 0 ? nativeMax8(length + index, 0) : nativeMin5(index, length - 1);
    }
    return baseFindIndex_default(array, baseIteratee_default(predicate, 3), index, true);
  }
  var findLastIndex_default = findLastIndex;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/findLast.js
  var findLast = createFind_default(findLastIndex_default);
  var findLast_default = findLast;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/findLastKey.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function findLastKey(object, predicate) {
    return baseFindKey_default(object, baseIteratee_default(predicate, 3), baseForOwnRight_default);
  }
  var findLastKey_default = findLastKey;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/first.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/head.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function head(array) {
    return array && array.length ? array[0] : void 0;
  }
  var head_default = head;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/flatMap.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/map.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseMap.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseMap(collection, iteratee2) {
    var index = -1, result2 = isArrayLike_default(collection) ? Array(collection.length) : [];
    baseEach_default(collection, function(value, key, collection2) {
      result2[++index] = iteratee2(value, key, collection2);
    });
    return result2;
  }
  var baseMap_default = baseMap;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/map.js
  function map(collection, iteratee2) {
    var func = isArray_default(collection) ? arrayMap_default : baseMap_default;
    return func(collection, baseIteratee_default(iteratee2, 3));
  }
  var map_default = map;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/flatMap.js
  function flatMap(collection, iteratee2) {
    return baseFlatten_default(map_default(collection, iteratee2), 1);
  }
  var flatMap_default = flatMap;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/flatMapDeep.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var INFINITY4 = 1 / 0;
  function flatMapDeep(collection, iteratee2) {
    return baseFlatten_default(map_default(collection, iteratee2), INFINITY4);
  }
  var flatMapDeep_default = flatMapDeep;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/flatMapDepth.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function flatMapDepth(collection, iteratee2, depth) {
    depth = depth === void 0 ? 1 : toInteger_default(depth);
    return baseFlatten_default(map_default(collection, iteratee2), depth);
  }
  var flatMapDepth_default = flatMapDepth;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/flattenDeep.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var INFINITY5 = 1 / 0;
  function flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten_default(array, INFINITY5) : [];
  }
  var flattenDeep_default = flattenDeep;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/flattenDepth.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function flattenDepth(array, depth) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    depth = depth === void 0 ? 1 : toInteger_default(depth);
    return baseFlatten_default(array, depth);
  }
  var flattenDepth_default = flattenDepth;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/flip.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var WRAP_FLIP_FLAG3 = 512;
  function flip(func) {
    return createWrap_default(func, WRAP_FLIP_FLAG3);
  }
  var flip_default = flip;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/floor.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var floor = createRound_default("floor");
  var floor_default = floor;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/flow.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createFlow.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var FUNC_ERROR_TEXT8 = "Expected a function";
  var WRAP_CURRY_FLAG7 = 8;
  var WRAP_PARTIAL_FLAG6 = 32;
  var WRAP_ARY_FLAG5 = 128;
  var WRAP_REARG_FLAG3 = 256;
  function createFlow(fromRight) {
    return flatRest_default(function(funcs) {
      var length = funcs.length, index = length, prereq = LodashWrapper_default.prototype.thru;
      if (fromRight) {
        funcs.reverse();
      }
      while (index--) {
        var func = funcs[index];
        if (typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT8);
        }
        if (prereq && !wrapper && getFuncName_default(func) == "wrapper") {
          var wrapper = new LodashWrapper_default([], true);
        }
      }
      index = wrapper ? index : length;
      while (++index < length) {
        func = funcs[index];
        var funcName = getFuncName_default(func), data = funcName == "wrapper" ? getData_default(func) : void 0;
        if (data && isLaziable_default(data[0]) && data[1] == (WRAP_ARY_FLAG5 | WRAP_CURRY_FLAG7 | WRAP_PARTIAL_FLAG6 | WRAP_REARG_FLAG3) && !data[4].length && data[9] == 1) {
          wrapper = wrapper[getFuncName_default(data[0])].apply(wrapper, data[3]);
        } else {
          wrapper = func.length == 1 && isLaziable_default(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
      }
      return function() {
        var args = arguments, value = args[0];
        if (wrapper && args.length == 1 && isArray_default(value)) {
          return wrapper.plant(value).value();
        }
        var index2 = 0, result2 = length ? funcs[index2].apply(this, args) : value;
        while (++index2 < length) {
          result2 = funcs[index2].call(this, result2);
        }
        return result2;
      };
    });
  }
  var createFlow_default = createFlow;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/flow.js
  var flow = createFlow_default();
  var flow_default = flow;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/flowRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var flowRight = createFlow_default(true);
  var flowRight_default = flowRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/forIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function forIn(object, iteratee2) {
    return object == null ? object : baseFor_default(object, castFunction_default(iteratee2), keysIn_default);
  }
  var forIn_default = forIn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/forInRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function forInRight(object, iteratee2) {
    return object == null ? object : baseForRight_default(object, castFunction_default(iteratee2), keysIn_default);
  }
  var forInRight_default = forInRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/forOwn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function forOwn(object, iteratee2) {
    return object && baseForOwn_default(object, castFunction_default(iteratee2));
  }
  var forOwn_default = forOwn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/forOwnRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function forOwnRight(object, iteratee2) {
    return object && baseForOwnRight_default(object, castFunction_default(iteratee2));
  }
  var forOwnRight_default = forOwnRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/fromPairs.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function fromPairs(pairs) {
    var index = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
    while (++index < length) {
      var pair = pairs[index];
      result2[pair[0]] = pair[1];
    }
    return result2;
  }
  var fromPairs_default = fromPairs;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/functions.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseFunctions.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseFunctions(object, props) {
    return arrayFilter_default(props, function(key) {
      return isFunction_default(object[key]);
    });
  }
  var baseFunctions_default = baseFunctions;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/functions.js
  function functions(object) {
    return object == null ? [] : baseFunctions_default(object, keys_default(object));
  }
  var functions_default = functions;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/functionsIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function functionsIn(object) {
    return object == null ? [] : baseFunctions_default(object, keysIn_default(object));
  }
  var functionsIn_default = functionsIn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/groupBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var objectProto22 = Object.prototype;
  var hasOwnProperty20 = objectProto22.hasOwnProperty;
  var groupBy = createAggregator_default(function(result2, value, key) {
    if (hasOwnProperty20.call(result2, key)) {
      result2[key].push(value);
    } else {
      baseAssignValue_default(result2, key, [value]);
    }
  });
  var groupBy_default = groupBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/gt.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseGt.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseGt(value, other) {
    return value > other;
  }
  var baseGt_default = baseGt;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createRelationalOperation.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function createRelationalOperation(operator) {
    return function(value, other) {
      if (!(typeof value == "string" && typeof other == "string")) {
        value = toNumber_default(value);
        other = toNumber_default(other);
      }
      return operator(value, other);
    };
  }
  var createRelationalOperation_default = createRelationalOperation;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/gt.js
  var gt = createRelationalOperation_default(baseGt_default);
  var gt_default = gt;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/gte.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var gte = createRelationalOperation_default(function(value, other) {
    return value >= other;
  });
  var gte_default = gte;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/has.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseHas.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var objectProto23 = Object.prototype;
  var hasOwnProperty21 = objectProto23.hasOwnProperty;
  function baseHas(object, key) {
    return object != null && hasOwnProperty21.call(object, key);
  }
  var baseHas_default = baseHas;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/has.js
  function has(object, path) {
    return object != null && hasPath_default(object, path, baseHas_default);
  }
  var has_default = has;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/inRange.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseInRange.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeMax9 = Math.max;
  var nativeMin6 = Math.min;
  function baseInRange(number, start, end) {
    return number >= nativeMin6(start, end) && number < nativeMax9(start, end);
  }
  var baseInRange_default = baseInRange;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/inRange.js
  function inRange(number, start, end) {
    start = toFinite_default(start);
    if (end === void 0) {
      end = start;
      start = 0;
    } else {
      end = toFinite_default(end);
    }
    number = toNumber_default(number);
    return baseInRange_default(number, start, end);
  }
  var inRange_default = inRange;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/includes.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isString.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var stringTag5 = "[object String]";
  function isString(value) {
    return typeof value == "string" || !isArray_default(value) && isObjectLike_default(value) && baseGetTag_default(value) == stringTag5;
  }
  var isString_default = isString;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/values.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseValues.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseValues(object, props) {
    return arrayMap_default(props, function(key) {
      return object[key];
    });
  }
  var baseValues_default = baseValues;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/values.js
  function values(object) {
    return object == null ? [] : baseValues_default(object, keys_default(object));
  }
  var values_default = values;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/includes.js
  var nativeMax10 = Math.max;
  function includes(collection, value, fromIndex, guard) {
    collection = isArrayLike_default(collection) ? collection : values_default(collection);
    fromIndex = fromIndex && !guard ? toInteger_default(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) {
      fromIndex = nativeMax10(length + fromIndex, 0);
    }
    return isString_default(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf_default(collection, value, fromIndex) > -1;
  }
  var includes_default = includes;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/indexOf.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeMax11 = Math.max;
  function indexOf(array, value, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return -1;
    }
    var index = fromIndex == null ? 0 : toInteger_default(fromIndex);
    if (index < 0) {
      index = nativeMax11(length + index, 0);
    }
    return baseIndexOf_default(array, value, index);
  }
  var indexOf_default = indexOf;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/initial.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function initial(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseSlice_default(array, 0, -1) : [];
  }
  var initial_default = initial;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/intersection.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIntersection.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeMin7 = Math.min;
  function baseIntersection(arrays, iteratee2, comparator) {
    var includes2 = comparator ? arrayIncludesWith_default : arrayIncludes_default, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result2 = [];
    while (othIndex--) {
      var array = arrays[othIndex];
      if (othIndex && iteratee2) {
        array = arrayMap_default(array, baseUnary_default(iteratee2));
      }
      maxLength = nativeMin7(array.length, maxLength);
      caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache_default(othIndex && array) : void 0;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer:
      while (++index < length && result2.length < maxLength) {
        var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? cacheHas_default(seen, computed) : includes2(result2, computed, comparator))) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache ? cacheHas_default(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result2.push(value);
        }
      }
    return result2;
  }
  var baseIntersection_default = baseIntersection;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_castArrayLikeObject.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function castArrayLikeObject(value) {
    return isArrayLikeObject_default(value) ? value : [];
  }
  var castArrayLikeObject_default = castArrayLikeObject;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/intersection.js
  var intersection = baseRest_default(function(arrays) {
    var mapped = arrayMap_default(arrays, castArrayLikeObject_default);
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection_default(mapped) : [];
  });
  var intersection_default = intersection;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/intersectionBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var intersectionBy = baseRest_default(function(arrays) {
    var iteratee2 = last_default(arrays), mapped = arrayMap_default(arrays, castArrayLikeObject_default);
    if (iteratee2 === last_default(mapped)) {
      iteratee2 = void 0;
    } else {
      mapped.pop();
    }
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection_default(mapped, baseIteratee_default(iteratee2, 2)) : [];
  });
  var intersectionBy_default = intersectionBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/intersectionWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var intersectionWith = baseRest_default(function(arrays) {
    var comparator = last_default(arrays), mapped = arrayMap_default(arrays, castArrayLikeObject_default);
    comparator = typeof comparator == "function" ? comparator : void 0;
    if (comparator) {
      mapped.pop();
    }
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection_default(mapped, void 0, comparator) : [];
  });
  var intersectionWith_default = intersectionWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/invert.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createInverter.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseInverter.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseInverter(object, setter, iteratee2, accumulator) {
    baseForOwn_default(object, function(value, key, object2) {
      setter(accumulator, iteratee2(value), key, object2);
    });
    return accumulator;
  }
  var baseInverter_default = baseInverter;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createInverter.js
  function createInverter(setter, toIteratee) {
    return function(object, iteratee2) {
      return baseInverter_default(object, setter, toIteratee(iteratee2), {});
    };
  }
  var createInverter_default = createInverter;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/invert.js
  var objectProto24 = Object.prototype;
  var nativeObjectToString3 = objectProto24.toString;
  var invert = createInverter_default(function(result2, value, key) {
    if (value != null && typeof value.toString != "function") {
      value = nativeObjectToString3.call(value);
    }
    result2[value] = key;
  }, constant_default(identity_default));
  var invert_default = invert;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/invertBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var objectProto25 = Object.prototype;
  var hasOwnProperty22 = objectProto25.hasOwnProperty;
  var nativeObjectToString4 = objectProto25.toString;
  var invertBy = createInverter_default(function(result2, value, key) {
    if (value != null && typeof value.toString != "function") {
      value = nativeObjectToString4.call(value);
    }
    if (hasOwnProperty22.call(result2, value)) {
      result2[value].push(key);
    } else {
      result2[value] = [key];
    }
  }, baseIteratee_default);
  var invertBy_default = invertBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/invoke.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseInvoke.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_parent.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function parent(object, path) {
    return path.length < 2 ? object : baseGet_default(object, baseSlice_default(path, 0, -1));
  }
  var parent_default = parent;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseInvoke.js
  function baseInvoke(object, path, args) {
    path = castPath_default(path, object);
    object = parent_default(object, path);
    var func = object == null ? object : object[toKey_default(last_default(path))];
    return func == null ? void 0 : apply_default(func, object, args);
  }
  var baseInvoke_default = baseInvoke;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/invoke.js
  var invoke = baseRest_default(baseInvoke_default);
  var invoke_default = invoke;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/invokeMap.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var invokeMap = baseRest_default(function(collection, path, args) {
    var index = -1, isFunc = typeof path == "function", result2 = isArrayLike_default(collection) ? Array(collection.length) : [];
    baseEach_default(collection, function(value) {
      result2[++index] = isFunc ? apply_default(path, value, args) : baseInvoke_default(value, path, args);
    });
    return result2;
  });
  var invokeMap_default = invokeMap;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArrayBuffer.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsArrayBuffer.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var arrayBufferTag5 = "[object ArrayBuffer]";
  function baseIsArrayBuffer(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == arrayBufferTag5;
  }
  var baseIsArrayBuffer_default = baseIsArrayBuffer;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArrayBuffer.js
  var nodeIsArrayBuffer = nodeUtil_default && nodeUtil_default.isArrayBuffer;
  var isArrayBuffer = nodeIsArrayBuffer ? baseUnary_default(nodeIsArrayBuffer) : baseIsArrayBuffer_default;
  var isArrayBuffer_default = isArrayBuffer;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isBoolean.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var boolTag5 = "[object Boolean]";
  function isBoolean(value) {
    return value === true || value === false || isObjectLike_default(value) && baseGetTag_default(value) == boolTag5;
  }
  var isBoolean_default = isBoolean;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isDate.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsDate.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var dateTag5 = "[object Date]";
  function baseIsDate(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == dateTag5;
  }
  var baseIsDate_default = baseIsDate;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isDate.js
  var nodeIsDate = nodeUtil_default && nodeUtil_default.isDate;
  var isDate = nodeIsDate ? baseUnary_default(nodeIsDate) : baseIsDate_default;
  var isDate_default = isDate;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isElement.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isElement(value) {
    return isObjectLike_default(value) && value.nodeType === 1 && !isPlainObject_default(value);
  }
  var isElement_default = isElement;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEmpty.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var mapTag8 = "[object Map]";
  var setTag8 = "[object Set]";
  var objectProto26 = Object.prototype;
  var hasOwnProperty23 = objectProto26.hasOwnProperty;
  function isEmpty(value) {
    if (value == null) {
      return true;
    }
    if (isArrayLike_default(value) && (isArray_default(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer_default(value) || isTypedArray_default(value) || isArguments_default(value))) {
      return !value.length;
    }
    var tag = getTag_default(value);
    if (tag == mapTag8 || tag == setTag8) {
      return !value.size;
    }
    if (isPrototype_default(value)) {
      return !baseKeys_default(value).length;
    }
    for (var key in value) {
      if (hasOwnProperty23.call(value, key)) {
        return false;
      }
    }
    return true;
  }
  var isEmpty_default = isEmpty;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEqual.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isEqual(value, other) {
    return baseIsEqual_default(value, other);
  }
  var isEqual_default = isEqual;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEqualWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isEqualWith(value, other, customizer2) {
    customizer2 = typeof customizer2 == "function" ? customizer2 : void 0;
    var result2 = customizer2 ? customizer2(value, other) : void 0;
    return result2 === void 0 ? baseIsEqual_default(value, other, void 0, customizer2) : !!result2;
  }
  var isEqualWith_default = isEqualWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isFinite.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeIsFinite2 = root_default.isFinite;
  function isFinite2(value) {
    return typeof value == "number" && nativeIsFinite2(value);
  }
  var isFinite_default = isFinite2;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isInteger.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isInteger(value) {
    return typeof value == "number" && value == toInteger_default(value);
  }
  var isInteger_default = isInteger;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isMatch.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isMatch(object, source) {
    return object === source || baseIsMatch_default(object, source, getMatchData_default(source));
  }
  var isMatch_default = isMatch;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isMatchWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isMatchWith(object, source, customizer2) {
    customizer2 = typeof customizer2 == "function" ? customizer2 : void 0;
    return baseIsMatch_default(object, source, getMatchData_default(source), customizer2);
  }
  var isMatchWith_default = isMatchWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNaN.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNumber.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var numberTag5 = "[object Number]";
  function isNumber(value) {
    return typeof value == "number" || isObjectLike_default(value) && baseGetTag_default(value) == numberTag5;
  }
  var isNumber_default = isNumber;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNaN.js
  function isNaN2(value) {
    return isNumber_default(value) && value != +value;
  }
  var isNaN_default = isNaN2;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNative.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isMaskable.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var isMaskable = coreJsData_default ? isFunction_default : stubFalse_default;
  var isMaskable_default = isMaskable;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNative.js
  var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.";
  function isNative(value) {
    if (isMaskable_default(value)) {
      throw new Error(CORE_ERROR_TEXT);
    }
    return baseIsNative_default(value);
  }
  var isNative_default = isNative;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isNil(value) {
    return value == null;
  }
  var isNil_default = isNil;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNull.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isNull(value) {
    return value === null;
  }
  var isNull_default = isNull;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isRegExp.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsRegExp.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var regexpTag5 = "[object RegExp]";
  function baseIsRegExp(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == regexpTag5;
  }
  var baseIsRegExp_default = baseIsRegExp;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isRegExp.js
  var nodeIsRegExp = nodeUtil_default && nodeUtil_default.isRegExp;
  var isRegExp = nodeIsRegExp ? baseUnary_default(nodeIsRegExp) : baseIsRegExp_default;
  var isRegExp_default = isRegExp;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isSafeInteger.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var MAX_SAFE_INTEGER3 = 9007199254740991;
  function isSafeInteger(value) {
    return isInteger_default(value) && value >= -MAX_SAFE_INTEGER3 && value <= MAX_SAFE_INTEGER3;
  }
  var isSafeInteger_default = isSafeInteger;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isUndefined.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isUndefined(value) {
    return value === void 0;
  }
  var isUndefined_default = isUndefined;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isWeakMap.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var weakMapTag4 = "[object WeakMap]";
  function isWeakMap(value) {
    return isObjectLike_default(value) && getTag_default(value) == weakMapTag4;
  }
  var isWeakMap_default = isWeakMap;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isWeakSet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var weakSetTag = "[object WeakSet]";
  function isWeakSet(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == weakSetTag;
  }
  var isWeakSet_default = isWeakSet;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/iteratee.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var CLONE_DEEP_FLAG5 = 1;
  function iteratee(func) {
    return baseIteratee_default(typeof func == "function" ? func : baseClone_default(func, CLONE_DEEP_FLAG5));
  }
  var iteratee_default = iteratee;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/join.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var arrayProto2 = Array.prototype;
  var nativeJoin = arrayProto2.join;
  function join(array, separator) {
    return array == null ? "" : nativeJoin.call(array, separator);
  }
  var join_default = join;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/kebabCase.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var kebabCase = createCompounder_default(function(result2, word, index) {
    return result2 + (index ? "-" : "") + word.toLowerCase();
  });
  var kebabCase_default = kebabCase;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/keyBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var keyBy = createAggregator_default(function(result2, value, key) {
    baseAssignValue_default(result2, key, value);
  });
  var keyBy_default = keyBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/lastIndexOf.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_strictLastIndexOf.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }
  var strictLastIndexOf_default = strictLastIndexOf;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/lastIndexOf.js
  var nativeMax12 = Math.max;
  var nativeMin8 = Math.min;
  function lastIndexOf(array, value, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return -1;
    }
    var index = length;
    if (fromIndex !== void 0) {
      index = toInteger_default(fromIndex);
      index = index < 0 ? nativeMax12(length + index, 0) : nativeMin8(index, length - 1);
    }
    return value === value ? strictLastIndexOf_default(array, value, index) : baseFindIndex_default(array, baseIsNaN_default, index, true);
  }
  var lastIndexOf_default = lastIndexOf;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/lowerCase.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var lowerCase = createCompounder_default(function(result2, word, index) {
    return result2 + (index ? " " : "") + word.toLowerCase();
  });
  var lowerCase_default = lowerCase;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/lowerFirst.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var lowerFirst = createCaseFirst_default("toLowerCase");
  var lowerFirst_default = lowerFirst;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/lt.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseLt.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseLt(value, other) {
    return value < other;
  }
  var baseLt_default = baseLt;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/lt.js
  var lt = createRelationalOperation_default(baseLt_default);
  var lt_default = lt;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/lte.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var lte = createRelationalOperation_default(function(value, other) {
    return value <= other;
  });
  var lte_default = lte;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/mapKeys.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function mapKeys(object, iteratee2) {
    var result2 = {};
    iteratee2 = baseIteratee_default(iteratee2, 3);
    baseForOwn_default(object, function(value, key, object2) {
      baseAssignValue_default(result2, iteratee2(value, key, object2), value);
    });
    return result2;
  }
  var mapKeys_default = mapKeys;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/mapValues.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function mapValues(object, iteratee2) {
    var result2 = {};
    iteratee2 = baseIteratee_default(iteratee2, 3);
    baseForOwn_default(object, function(value, key, object2) {
      baseAssignValue_default(result2, key, iteratee2(value, key, object2));
    });
    return result2;
  }
  var mapValues_default = mapValues;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/matches.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var CLONE_DEEP_FLAG6 = 1;
  function matches(source) {
    return baseMatches_default(baseClone_default(source, CLONE_DEEP_FLAG6));
  }
  var matches_default = matches;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/matchesProperty.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var CLONE_DEEP_FLAG7 = 1;
  function matchesProperty(path, srcValue) {
    return baseMatchesProperty_default(path, baseClone_default(srcValue, CLONE_DEEP_FLAG7));
  }
  var matchesProperty_default = matchesProperty;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/max.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseExtremum.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseExtremum(array, iteratee2, comparator) {
    var index = -1, length = array.length;
    while (++index < length) {
      var value = array[index], current = iteratee2(value);
      if (current != null && (computed === void 0 ? current === current && !isSymbol_default(current) : comparator(current, computed))) {
        var computed = current, result2 = value;
      }
    }
    return result2;
  }
  var baseExtremum_default = baseExtremum;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/max.js
  function max(array) {
    return array && array.length ? baseExtremum_default(array, identity_default, baseGt_default) : void 0;
  }
  var max_default = max;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/maxBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function maxBy(array, iteratee2) {
    return array && array.length ? baseExtremum_default(array, baseIteratee_default(iteratee2, 2), baseGt_default) : void 0;
  }
  var maxBy_default = maxBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/mean.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseMean.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSum.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseSum(array, iteratee2) {
    var result2, index = -1, length = array.length;
    while (++index < length) {
      var current = iteratee2(array[index]);
      if (current !== void 0) {
        result2 = result2 === void 0 ? current : result2 + current;
      }
    }
    return result2;
  }
  var baseSum_default = baseSum;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseMean.js
  var NAN3 = 0 / 0;
  function baseMean(array, iteratee2) {
    var length = array == null ? 0 : array.length;
    return length ? baseSum_default(array, iteratee2) / length : NAN3;
  }
  var baseMean_default = baseMean;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/mean.js
  function mean(array) {
    return baseMean_default(array, identity_default);
  }
  var mean_default = mean;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/meanBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function meanBy(array, iteratee2) {
    return baseMean_default(array, baseIteratee_default(iteratee2, 2));
  }
  var meanBy_default = meanBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/merge.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var merge = createAssigner_default(function(object, source, srcIndex) {
    baseMerge_default(object, source, srcIndex);
  });
  var merge_default = merge;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/method.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var method = baseRest_default(function(path, args) {
    return function(object) {
      return baseInvoke_default(object, path, args);
    };
  });
  var method_default = method;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/methodOf.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var methodOf = baseRest_default(function(object, args) {
    return function(path) {
      return baseInvoke_default(object, path, args);
    };
  });
  var methodOf_default = methodOf;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/min.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function min(array) {
    return array && array.length ? baseExtremum_default(array, identity_default, baseLt_default) : void 0;
  }
  var min_default = min;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/minBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function minBy(array, iteratee2) {
    return array && array.length ? baseExtremum_default(array, baseIteratee_default(iteratee2, 2), baseLt_default) : void 0;
  }
  var minBy_default = minBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/mixin.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function mixin(object, source, options) {
    var props = keys_default(source), methodNames = baseFunctions_default(source, props);
    var chain2 = !(isObject_default(options) && "chain" in options) || !!options.chain, isFunc = isFunction_default(object);
    arrayEach_default(methodNames, function(methodName) {
      var func = source[methodName];
      object[methodName] = func;
      if (isFunc) {
        object.prototype[methodName] = function() {
          var chainAll = this.__chain__;
          if (chain2 || chainAll) {
            var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray_default(this.__actions__);
            actions.push({ "func": func, "args": arguments, "thisArg": object });
            result2.__chain__ = chainAll;
            return result2;
          }
          return func.apply(object, arrayPush_default([this.value()], arguments));
        };
      }
    });
    return object;
  }
  var mixin_default = mixin;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/multiply.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var multiply = createMathOperation_default(function(multiplier, multiplicand) {
    return multiplier * multiplicand;
  }, 1);
  var multiply_default = multiply;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/negate.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var FUNC_ERROR_TEXT9 = "Expected a function";
  function negate(predicate) {
    if (typeof predicate != "function") {
      throw new TypeError(FUNC_ERROR_TEXT9);
    }
    return function() {
      var args = arguments;
      switch (args.length) {
        case 0:
          return !predicate.call(this);
        case 1:
          return !predicate.call(this, args[0]);
        case 2:
          return !predicate.call(this, args[0], args[1]);
        case 3:
          return !predicate.call(this, args[0], args[1], args[2]);
      }
      return !predicate.apply(this, args);
    };
  }
  var negate_default = negate;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/next.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toArray.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_iteratorToArray.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function iteratorToArray(iterator) {
    var data, result2 = [];
    while (!(data = iterator.next()).done) {
      result2.push(data.value);
    }
    return result2;
  }
  var iteratorToArray_default = iteratorToArray;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toArray.js
  var mapTag9 = "[object Map]";
  var setTag9 = "[object Set]";
  var symIterator = Symbol_default ? Symbol_default.iterator : void 0;
  function toArray(value) {
    if (!value) {
      return [];
    }
    if (isArrayLike_default(value)) {
      return isString_default(value) ? stringToArray_default(value) : copyArray_default(value);
    }
    if (symIterator && value[symIterator]) {
      return iteratorToArray_default(value[symIterator]());
    }
    var tag = getTag_default(value), func = tag == mapTag9 ? mapToArray_default : tag == setTag9 ? setToArray_default : values_default;
    return func(value);
  }
  var toArray_default = toArray;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/next.js
  function wrapperNext() {
    if (this.__values__ === void 0) {
      this.__values__ = toArray_default(this.value());
    }
    var done = this.__index__ >= this.__values__.length, value = done ? void 0 : this.__values__[this.__index__++];
    return { "done": done, "value": value };
  }
  var next_default = wrapperNext;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/nth.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseNth.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseNth(array, n) {
    var length = array.length;
    if (!length) {
      return;
    }
    n += n < 0 ? length : 0;
    return isIndex_default(n, length) ? array[n] : void 0;
  }
  var baseNth_default = baseNth;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/nth.js
  function nth(array, n) {
    return array && array.length ? baseNth_default(array, toInteger_default(n)) : void 0;
  }
  var nth_default = nth;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/nthArg.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function nthArg(n) {
    n = toInteger_default(n);
    return baseRest_default(function(args) {
      return baseNth_default(args, n);
    });
  }
  var nthArg_default = nthArg;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/omit.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseUnset.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseUnset(object, path) {
    path = castPath_default(path, object);
    object = parent_default(object, path);
    return object == null || delete object[toKey_default(last_default(path))];
  }
  var baseUnset_default = baseUnset;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_customOmitClone.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function customOmitClone(value) {
    return isPlainObject_default(value) ? void 0 : value;
  }
  var customOmitClone_default = customOmitClone;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/omit.js
  var CLONE_DEEP_FLAG8 = 1;
  var CLONE_FLAT_FLAG2 = 2;
  var CLONE_SYMBOLS_FLAG6 = 4;
  var omit = flatRest_default(function(object, paths) {
    var result2 = {};
    if (object == null) {
      return result2;
    }
    var isDeep = false;
    paths = arrayMap_default(paths, function(path) {
      path = castPath_default(path, object);
      isDeep || (isDeep = path.length > 1);
      return path;
    });
    copyObject_default(object, getAllKeysIn_default(object), result2);
    if (isDeep) {
      result2 = baseClone_default(result2, CLONE_DEEP_FLAG8 | CLONE_FLAT_FLAG2 | CLONE_SYMBOLS_FLAG6, customOmitClone_default);
    }
    var length = paths.length;
    while (length--) {
      baseUnset_default(result2, paths[length]);
    }
    return result2;
  });
  var omit_default = omit;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/omitBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pickBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_basePickBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseSet(object, path, value, customizer2) {
    if (!isObject_default(object)) {
      return object;
    }
    path = castPath_default(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while (nested != null && ++index < length) {
      var key = toKey_default(path[index]), newValue = value;
      if (key === "__proto__" || key === "constructor" || key === "prototype") {
        return object;
      }
      if (index != lastIndex) {
        var objValue = nested[key];
        newValue = customizer2 ? customizer2(objValue, key, nested) : void 0;
        if (newValue === void 0) {
          newValue = isObject_default(objValue) ? objValue : isIndex_default(path[index + 1]) ? [] : {};
        }
      }
      assignValue_default(nested, key, newValue);
      nested = nested[key];
    }
    return object;
  }
  var baseSet_default = baseSet;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_basePickBy.js
  function basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result2 = {};
    while (++index < length) {
      var path = paths[index], value = baseGet_default(object, path);
      if (predicate(value, path)) {
        baseSet_default(result2, castPath_default(path, object), value);
      }
    }
    return result2;
  }
  var basePickBy_default = basePickBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pickBy.js
  function pickBy(object, predicate) {
    if (object == null) {
      return {};
    }
    var props = arrayMap_default(getAllKeysIn_default(object), function(prop) {
      return [prop];
    });
    predicate = baseIteratee_default(predicate);
    return basePickBy_default(object, props, function(value, path) {
      return predicate(value, path[0]);
    });
  }
  var pickBy_default = pickBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/omitBy.js
  function omitBy(object, predicate) {
    return pickBy_default(object, negate_default(baseIteratee_default(predicate)));
  }
  var omitBy_default = omitBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/once.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function once2(func) {
    return before_default(2, func);
  }
  var once_default = once2;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/orderBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseOrderBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSortBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }
  var baseSortBy_default = baseSortBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_compareMultiple.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_compareAscending.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function compareAscending(value, other) {
    if (value !== other) {
      var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol_default(value);
      var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol_default(other);
      if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
        return 1;
      }
      if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
        return -1;
      }
    }
    return 0;
  }
  var compareAscending_default = compareAscending;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_compareMultiple.js
  function compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while (++index < length) {
      var result2 = compareAscending_default(objCriteria[index], othCriteria[index]);
      if (result2) {
        if (index >= ordersLength) {
          return result2;
        }
        var order = orders[index];
        return result2 * (order == "desc" ? -1 : 1);
      }
    }
    return object.index - other.index;
  }
  var compareMultiple_default = compareMultiple;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseOrderBy.js
  function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) {
      iteratees = arrayMap_default(iteratees, function(iteratee2) {
        if (isArray_default(iteratee2)) {
          return function(value) {
            return baseGet_default(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
          };
        }
        return iteratee2;
      });
    } else {
      iteratees = [identity_default];
    }
    var index = -1;
    iteratees = arrayMap_default(iteratees, baseUnary_default(baseIteratee_default));
    var result2 = baseMap_default(collection, function(value, key, collection2) {
      var criteria = arrayMap_default(iteratees, function(iteratee2) {
        return iteratee2(value);
      });
      return { "criteria": criteria, "index": ++index, "value": value };
    });
    return baseSortBy_default(result2, function(object, other) {
      return compareMultiple_default(object, other, orders);
    });
  }
  var baseOrderBy_default = baseOrderBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/orderBy.js
  function orderBy(collection, iteratees, orders, guard) {
    if (collection == null) {
      return [];
    }
    if (!isArray_default(iteratees)) {
      iteratees = iteratees == null ? [] : [iteratees];
    }
    orders = guard ? void 0 : orders;
    if (!isArray_default(orders)) {
      orders = orders == null ? [] : [orders];
    }
    return baseOrderBy_default(collection, iteratees, orders);
  }
  var orderBy_default = orderBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/over.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createOver.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function createOver(arrayFunc) {
    return flatRest_default(function(iteratees) {
      iteratees = arrayMap_default(iteratees, baseUnary_default(baseIteratee_default));
      return baseRest_default(function(args) {
        var thisArg = this;
        return arrayFunc(iteratees, function(iteratee2) {
          return apply_default(iteratee2, thisArg, args);
        });
      });
    });
  }
  var createOver_default = createOver;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/over.js
  var over = createOver_default(arrayMap_default);
  var over_default = over;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/overArgs.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_castRest.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var castRest = baseRest_default;
  var castRest_default = castRest;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/overArgs.js
  var nativeMin9 = Math.min;
  var overArgs = castRest_default(function(func, transforms) {
    transforms = transforms.length == 1 && isArray_default(transforms[0]) ? arrayMap_default(transforms[0], baseUnary_default(baseIteratee_default)) : arrayMap_default(baseFlatten_default(transforms, 1), baseUnary_default(baseIteratee_default));
    var funcsLength = transforms.length;
    return baseRest_default(function(args) {
      var index = -1, length = nativeMin9(args.length, funcsLength);
      while (++index < length) {
        args[index] = transforms[index].call(this, args[index]);
      }
      return apply_default(func, this, args);
    });
  });
  var overArgs_default = overArgs;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/overEvery.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var overEvery = createOver_default(arrayEvery_default);
  var overEvery_default = overEvery;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/overSome.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var overSome = createOver_default(arraySome_default);
  var overSome_default = overSome;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pad.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createPadding.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseRepeat.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var MAX_SAFE_INTEGER4 = 9007199254740991;
  var nativeFloor = Math.floor;
  function baseRepeat(string, n) {
    var result2 = "";
    if (!string || n < 1 || n > MAX_SAFE_INTEGER4) {
      return result2;
    }
    do {
      if (n % 2) {
        result2 += string;
      }
      n = nativeFloor(n / 2);
      if (n) {
        string += string;
      }
    } while (n);
    return result2;
  }
  var baseRepeat_default = baseRepeat;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stringSize.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_asciiSize.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var asciiSize = baseProperty_default("length");
  var asciiSize_default = asciiSize;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_unicodeSize.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var rsAstralRange4 = "\\ud800-\\udfff";
  var rsComboMarksRange5 = "\\u0300-\\u036f";
  var reComboHalfMarksRange5 = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange5 = "\\u20d0-\\u20ff";
  var rsComboRange5 = rsComboMarksRange5 + reComboHalfMarksRange5 + rsComboSymbolsRange5;
  var rsVarRange4 = "\\ufe0e\\ufe0f";
  var rsAstral2 = "[" + rsAstralRange4 + "]";
  var rsCombo4 = "[" + rsComboRange5 + "]";
  var rsFitz3 = "\\ud83c[\\udffb-\\udfff]";
  var rsModifier3 = "(?:" + rsCombo4 + "|" + rsFitz3 + ")";
  var rsNonAstral3 = "[^" + rsAstralRange4 + "]";
  var rsRegional3 = "(?:\\ud83c[\\udde6-\\uddff]){2}";
  var rsSurrPair3 = "[\\ud800-\\udbff][\\udc00-\\udfff]";
  var rsZWJ4 = "\\u200d";
  var reOptMod3 = rsModifier3 + "?";
  var rsOptVar3 = "[" + rsVarRange4 + "]?";
  var rsOptJoin3 = "(?:" + rsZWJ4 + "(?:" + [rsNonAstral3, rsRegional3, rsSurrPair3].join("|") + ")" + rsOptVar3 + reOptMod3 + ")*";
  var rsSeq3 = rsOptVar3 + reOptMod3 + rsOptJoin3;
  var rsSymbol2 = "(?:" + [rsNonAstral3 + rsCombo4 + "?", rsCombo4, rsRegional3, rsSurrPair3, rsAstral2].join("|") + ")";
  var reUnicode2 = RegExp(rsFitz3 + "(?=" + rsFitz3 + ")|" + rsSymbol2 + rsSeq3, "g");
  function unicodeSize(string) {
    var result2 = reUnicode2.lastIndex = 0;
    while (reUnicode2.test(string)) {
      ++result2;
    }
    return result2;
  }
  var unicodeSize_default = unicodeSize;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stringSize.js
  function stringSize(string) {
    return hasUnicode_default(string) ? unicodeSize_default(string) : asciiSize_default(string);
  }
  var stringSize_default = stringSize;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createPadding.js
  var nativeCeil2 = Math.ceil;
  function createPadding(length, chars) {
    chars = chars === void 0 ? " " : baseToString_default(chars);
    var charsLength = chars.length;
    if (charsLength < 2) {
      return charsLength ? baseRepeat_default(chars, length) : chars;
    }
    var result2 = baseRepeat_default(chars, nativeCeil2(length / stringSize_default(chars)));
    return hasUnicode_default(chars) ? castSlice_default(stringToArray_default(result2), 0, length).join("") : result2.slice(0, length);
  }
  var createPadding_default = createPadding;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pad.js
  var nativeCeil3 = Math.ceil;
  var nativeFloor2 = Math.floor;
  function pad(string, length, chars) {
    string = toString_default(string);
    length = toInteger_default(length);
    var strLength = length ? stringSize_default(string) : 0;
    if (!length || strLength >= length) {
      return string;
    }
    var mid = (length - strLength) / 2;
    return createPadding_default(nativeFloor2(mid), chars) + string + createPadding_default(nativeCeil3(mid), chars);
  }
  var pad_default = pad;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/padEnd.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function padEnd(string, length, chars) {
    string = toString_default(string);
    length = toInteger_default(length);
    var strLength = length ? stringSize_default(string) : 0;
    return length && strLength < length ? string + createPadding_default(length - strLength, chars) : string;
  }
  var padEnd_default = padEnd;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/padStart.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function padStart(string, length, chars) {
    string = toString_default(string);
    length = toInteger_default(length);
    var strLength = length ? stringSize_default(string) : 0;
    return length && strLength < length ? createPadding_default(length - strLength, chars) + string : string;
  }
  var padStart_default = padStart;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/parseInt.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var reTrimStart2 = /^\s+/;
  var nativeParseInt = root_default.parseInt;
  function parseInt2(string, radix, guard) {
    if (guard || radix == null) {
      radix = 0;
    } else if (radix) {
      radix = +radix;
    }
    return nativeParseInt(toString_default(string).replace(reTrimStart2, ""), radix || 0);
  }
  var parseInt_default = parseInt2;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/partial.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var WRAP_PARTIAL_FLAG7 = 32;
  var partial = baseRest_default(function(func, partials) {
    var holders = replaceHolders_default(partials, getHolder_default(partial));
    return createWrap_default(func, WRAP_PARTIAL_FLAG7, void 0, partials, holders);
  });
  partial.placeholder = {};
  var partial_default = partial;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/partialRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var WRAP_PARTIAL_RIGHT_FLAG4 = 64;
  var partialRight = baseRest_default(function(func, partials) {
    var holders = replaceHolders_default(partials, getHolder_default(partialRight));
    return createWrap_default(func, WRAP_PARTIAL_RIGHT_FLAG4, void 0, partials, holders);
  });
  partialRight.placeholder = {};
  var partialRight_default = partialRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/partition.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var partition = createAggregator_default(function(result2, value, key) {
    result2[key ? 0 : 1].push(value);
  }, function() {
    return [[], []];
  });
  var partition_default = partition;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pick.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_basePick.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function basePick(object, paths) {
    return basePickBy_default(object, paths, function(value, path) {
      return hasIn_default(object, path);
    });
  }
  var basePick_default = basePick;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pick.js
  var pick = flatRest_default(function(object, paths) {
    return object == null ? {} : basePick_default(object, paths);
  });
  var pick_default = pick;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/plant.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function wrapperPlant(value) {
    var result2, parent2 = this;
    while (parent2 instanceof baseLodash_default) {
      var clone2 = wrapperClone_default(parent2);
      clone2.__index__ = 0;
      clone2.__values__ = void 0;
      if (result2) {
        previous.__wrapped__ = clone2;
      } else {
        result2 = clone2;
      }
      var previous = clone2;
      parent2 = parent2.__wrapped__;
    }
    previous.__wrapped__ = value;
    return result2;
  }
  var plant_default = wrapperPlant;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/propertyOf.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function propertyOf(object) {
    return function(path) {
      return object == null ? void 0 : baseGet_default(object, path);
    };
  }
  var propertyOf_default = propertyOf;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pull.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pullAll.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_basePullAll.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIndexOfWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }
  var baseIndexOfWith_default = baseIndexOfWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_basePullAll.js
  var arrayProto3 = Array.prototype;
  var splice2 = arrayProto3.splice;
  function basePullAll(array, values2, iteratee2, comparator) {
    var indexOf2 = comparator ? baseIndexOfWith_default : baseIndexOf_default, index = -1, length = values2.length, seen = array;
    if (array === values2) {
      values2 = copyArray_default(values2);
    }
    if (iteratee2) {
      seen = arrayMap_default(array, baseUnary_default(iteratee2));
    }
    while (++index < length) {
      var fromIndex = 0, value = values2[index], computed = iteratee2 ? iteratee2(value) : value;
      while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
        if (seen !== array) {
          splice2.call(seen, fromIndex, 1);
        }
        splice2.call(array, fromIndex, 1);
      }
    }
    return array;
  }
  var basePullAll_default = basePullAll;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pullAll.js
  function pullAll(array, values2) {
    return array && array.length && values2 && values2.length ? basePullAll_default(array, values2) : array;
  }
  var pullAll_default = pullAll;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pull.js
  var pull = baseRest_default(pullAll_default);
  var pull_default = pull;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pullAllBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function pullAllBy(array, values2, iteratee2) {
    return array && array.length && values2 && values2.length ? basePullAll_default(array, values2, baseIteratee_default(iteratee2, 2)) : array;
  }
  var pullAllBy_default = pullAllBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pullAllWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function pullAllWith(array, values2, comparator) {
    return array && array.length && values2 && values2.length ? basePullAll_default(array, values2, void 0, comparator) : array;
  }
  var pullAllWith_default = pullAllWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pullAt.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_basePullAt.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var arrayProto4 = Array.prototype;
  var splice3 = arrayProto4.splice;
  function basePullAt(array, indexes) {
    var length = array ? indexes.length : 0, lastIndex = length - 1;
    while (length--) {
      var index = indexes[length];
      if (length == lastIndex || index !== previous) {
        var previous = index;
        if (isIndex_default(index)) {
          splice3.call(array, index, 1);
        } else {
          baseUnset_default(array, index);
        }
      }
    }
    return array;
  }
  var basePullAt_default = basePullAt;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pullAt.js
  var pullAt = flatRest_default(function(array, indexes) {
    var length = array == null ? 0 : array.length, result2 = baseAt_default(array, indexes);
    basePullAt_default(array, arrayMap_default(indexes, function(index) {
      return isIndex_default(index, length) ? +index : index;
    }).sort(compareAscending_default));
    return result2;
  });
  var pullAt_default = pullAt;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/random.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseRandom.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeFloor3 = Math.floor;
  var nativeRandom = Math.random;
  function baseRandom(lower, upper) {
    return lower + nativeFloor3(nativeRandom() * (upper - lower + 1));
  }
  var baseRandom_default = baseRandom;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/random.js
  var freeParseFloat = parseFloat;
  var nativeMin10 = Math.min;
  var nativeRandom2 = Math.random;
  function random(lower, upper, floating) {
    if (floating && typeof floating != "boolean" && isIterateeCall_default(lower, upper, floating)) {
      upper = floating = void 0;
    }
    if (floating === void 0) {
      if (typeof upper == "boolean") {
        floating = upper;
        upper = void 0;
      } else if (typeof lower == "boolean") {
        floating = lower;
        lower = void 0;
      }
    }
    if (lower === void 0 && upper === void 0) {
      lower = 0;
      upper = 1;
    } else {
      lower = toFinite_default(lower);
      if (upper === void 0) {
        upper = lower;
        lower = 0;
      } else {
        upper = toFinite_default(upper);
      }
    }
    if (lower > upper) {
      var temp = lower;
      lower = upper;
      upper = temp;
    }
    if (floating || lower % 1 || upper % 1) {
      var rand = nativeRandom2();
      return nativeMin10(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
    }
    return baseRandom_default(lower, upper);
  }
  var random_default = random;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/range.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createRange.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseRange.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeCeil4 = Math.ceil;
  var nativeMax13 = Math.max;
  function baseRange(start, end, step, fromRight) {
    var index = -1, length = nativeMax13(nativeCeil4((end - start) / (step || 1)), 0), result2 = Array(length);
    while (length--) {
      result2[fromRight ? length : ++index] = start;
      start += step;
    }
    return result2;
  }
  var baseRange_default = baseRange;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createRange.js
  function createRange(fromRight) {
    return function(start, end, step) {
      if (step && typeof step != "number" && isIterateeCall_default(start, end, step)) {
        end = step = void 0;
      }
      start = toFinite_default(start);
      if (end === void 0) {
        end = start;
        start = 0;
      } else {
        end = toFinite_default(end);
      }
      step = step === void 0 ? start < end ? 1 : -1 : toFinite_default(step);
      return baseRange_default(start, end, step, fromRight);
    };
  }
  var createRange_default = createRange;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/range.js
  var range = createRange_default();
  var range_default = range;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/rangeRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var rangeRight = createRange_default(true);
  var rangeRight_default = rangeRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/rearg.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var WRAP_REARG_FLAG4 = 256;
  var rearg = flatRest_default(function(func, indexes) {
    return createWrap_default(func, WRAP_REARG_FLAG4, void 0, void 0, void 0, indexes);
  });
  var rearg_default = rearg;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/reduce.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseReduce.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseReduce(collection, iteratee2, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection2) {
      accumulator = initAccum ? (initAccum = false, value) : iteratee2(accumulator, value, index, collection2);
    });
    return accumulator;
  }
  var baseReduce_default = baseReduce;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/reduce.js
  function reduce(collection, iteratee2, accumulator) {
    var func = isArray_default(collection) ? arrayReduce_default : baseReduce_default, initAccum = arguments.length < 3;
    return func(collection, baseIteratee_default(iteratee2, 4), accumulator, initAccum, baseEach_default);
  }
  var reduce_default = reduce;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/reduceRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayReduceRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function arrayReduceRight(array, iteratee2, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee2(accumulator, array[length], length, array);
    }
    return accumulator;
  }
  var arrayReduceRight_default = arrayReduceRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/reduceRight.js
  function reduceRight(collection, iteratee2, accumulator) {
    var func = isArray_default(collection) ? arrayReduceRight_default : baseReduce_default, initAccum = arguments.length < 3;
    return func(collection, baseIteratee_default(iteratee2, 4), accumulator, initAccum, baseEachRight_default);
  }
  var reduceRight_default = reduceRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/reject.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function reject(collection, predicate) {
    var func = isArray_default(collection) ? arrayFilter_default : baseFilter_default;
    return func(collection, negate_default(baseIteratee_default(predicate, 3)));
  }
  var reject_default = reject;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/remove.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function remove(array, predicate) {
    var result2 = [];
    if (!(array && array.length)) {
      return result2;
    }
    var index = -1, indexes = [], length = array.length;
    predicate = baseIteratee_default(predicate, 3);
    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result2.push(value);
        indexes.push(index);
      }
    }
    basePullAt_default(array, indexes);
    return result2;
  }
  var remove_default = remove;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/repeat.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function repeat(string, n, guard) {
    if (guard ? isIterateeCall_default(string, n, guard) : n === void 0) {
      n = 1;
    } else {
      n = toInteger_default(n);
    }
    return baseRepeat_default(toString_default(string), n);
  }
  var repeat_default = repeat;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/replace.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function replace() {
    var args = arguments, string = toString_default(args[0]);
    return args.length < 3 ? string : string.replace(args[1], args[2]);
  }
  var replace_default = replace;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/rest.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var FUNC_ERROR_TEXT10 = "Expected a function";
  function rest(func, start) {
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT10);
    }
    start = start === void 0 ? start : toInteger_default(start);
    return baseRest_default(func, start);
  }
  var rest_default = rest;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/result.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function result(object, path, defaultValue) {
    path = castPath_default(path, object);
    var index = -1, length = path.length;
    if (!length) {
      length = 1;
      object = void 0;
    }
    while (++index < length) {
      var value = object == null ? void 0 : object[toKey_default(path[index])];
      if (value === void 0) {
        index = length;
        value = defaultValue;
      }
      object = isFunction_default(value) ? value.call(object) : value;
    }
    return object;
  }
  var result_default = result;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/reverse.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var arrayProto5 = Array.prototype;
  var nativeReverse = arrayProto5.reverse;
  function reverse(array) {
    return array == null ? array : nativeReverse.call(array);
  }
  var reverse_default = reverse;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/round.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var round = createRound_default("round");
  var round_default = round;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sample.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arraySample.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function arraySample(array) {
    var length = array.length;
    return length ? array[baseRandom_default(0, length - 1)] : void 0;
  }
  var arraySample_default = arraySample;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSample.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseSample(collection) {
    return arraySample_default(values_default(collection));
  }
  var baseSample_default = baseSample;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sample.js
  function sample(collection) {
    var func = isArray_default(collection) ? arraySample_default : baseSample_default;
    return func(collection);
  }
  var sample_default = sample;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sampleSize.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arraySampleSize.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_shuffleSelf.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function shuffleSelf(array, size2) {
    var index = -1, length = array.length, lastIndex = length - 1;
    size2 = size2 === void 0 ? length : size2;
    while (++index < size2) {
      var rand = baseRandom_default(index, lastIndex), value = array[rand];
      array[rand] = array[index];
      array[index] = value;
    }
    array.length = size2;
    return array;
  }
  var shuffleSelf_default = shuffleSelf;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arraySampleSize.js
  function arraySampleSize(array, n) {
    return shuffleSelf_default(copyArray_default(array), baseClamp_default(n, 0, array.length));
  }
  var arraySampleSize_default = arraySampleSize;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSampleSize.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseSampleSize(collection, n) {
    var array = values_default(collection);
    return shuffleSelf_default(array, baseClamp_default(n, 0, array.length));
  }
  var baseSampleSize_default = baseSampleSize;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sampleSize.js
  function sampleSize(collection, n, guard) {
    if (guard ? isIterateeCall_default(collection, n, guard) : n === void 0) {
      n = 1;
    } else {
      n = toInteger_default(n);
    }
    var func = isArray_default(collection) ? arraySampleSize_default : baseSampleSize_default;
    return func(collection, n);
  }
  var sampleSize_default = sampleSize;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/set.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function set(object, path, value) {
    return object == null ? object : baseSet_default(object, path, value);
  }
  var set_default = set;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/setWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function setWith(object, path, value, customizer2) {
    customizer2 = typeof customizer2 == "function" ? customizer2 : void 0;
    return object == null ? object : baseSet_default(object, path, value, customizer2);
  }
  var setWith_default = setWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/shuffle.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayShuffle.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function arrayShuffle(array) {
    return shuffleSelf_default(copyArray_default(array));
  }
  var arrayShuffle_default = arrayShuffle;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseShuffle.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseShuffle(collection) {
    return shuffleSelf_default(values_default(collection));
  }
  var baseShuffle_default = baseShuffle;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/shuffle.js
  function shuffle(collection) {
    var func = isArray_default(collection) ? arrayShuffle_default : baseShuffle_default;
    return func(collection);
  }
  var shuffle_default = shuffle;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/size.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var mapTag10 = "[object Map]";
  var setTag10 = "[object Set]";
  function size(collection) {
    if (collection == null) {
      return 0;
    }
    if (isArrayLike_default(collection)) {
      return isString_default(collection) ? stringSize_default(collection) : collection.length;
    }
    var tag = getTag_default(collection);
    if (tag == mapTag10 || tag == setTag10) {
      return collection.size;
    }
    return baseKeys_default(collection).length;
  }
  var size_default = size;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/slice.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function slice(array, start, end) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    if (end && typeof end != "number" && isIterateeCall_default(array, start, end)) {
      start = 0;
      end = length;
    } else {
      start = start == null ? 0 : toInteger_default(start);
      end = end === void 0 ? length : toInteger_default(end);
    }
    return baseSlice_default(array, start, end);
  }
  var slice_default = slice;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/snakeCase.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var snakeCase = createCompounder_default(function(result2, word, index) {
    return result2 + (index ? "_" : "") + word.toLowerCase();
  });
  var snakeCase_default = snakeCase;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/some.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSome.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseSome(collection, predicate) {
    var result2;
    baseEach_default(collection, function(value, index, collection2) {
      result2 = predicate(value, index, collection2);
      return !result2;
    });
    return !!result2;
  }
  var baseSome_default = baseSome;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/some.js
  function some(collection, predicate, guard) {
    var func = isArray_default(collection) ? arraySome_default : baseSome_default;
    if (guard && isIterateeCall_default(collection, predicate, guard)) {
      predicate = void 0;
    }
    return func(collection, baseIteratee_default(predicate, 3));
  }
  var some_default = some;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sortBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var sortBy = baseRest_default(function(collection, iteratees) {
    if (collection == null) {
      return [];
    }
    var length = iteratees.length;
    if (length > 1 && isIterateeCall_default(collection, iteratees[0], iteratees[1])) {
      iteratees = [];
    } else if (length > 2 && isIterateeCall_default(iteratees[0], iteratees[1], iteratees[2])) {
      iteratees = [iteratees[0]];
    }
    return baseOrderBy_default(collection, baseFlatten_default(iteratees, 1), []);
  });
  var sortBy_default = sortBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sortedIndex.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSortedIndex.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSortedIndexBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var MAX_ARRAY_LENGTH3 = 4294967295;
  var MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH3 - 1;
  var nativeFloor4 = Math.floor;
  var nativeMin11 = Math.min;
  function baseSortedIndexBy(array, value, iteratee2, retHighest) {
    var low = 0, high = array == null ? 0 : array.length;
    if (high === 0) {
      return 0;
    }
    value = iteratee2(value);
    var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol_default(value), valIsUndefined = value === void 0;
    while (low < high) {
      var mid = nativeFloor4((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== void 0, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol_default(computed);
      if (valIsNaN) {
        var setLow = retHighest || othIsReflexive;
      } else if (valIsUndefined) {
        setLow = othIsReflexive && (retHighest || othIsDefined);
      } else if (valIsNull) {
        setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
      } else if (valIsSymbol) {
        setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
      } else if (othIsNull || othIsSymbol) {
        setLow = false;
      } else {
        setLow = retHighest ? computed <= value : computed < value;
      }
      if (setLow) {
        low = mid + 1;
      } else {
        high = mid;
      }
    }
    return nativeMin11(high, MAX_ARRAY_INDEX);
  }
  var baseSortedIndexBy_default = baseSortedIndexBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSortedIndex.js
  var MAX_ARRAY_LENGTH4 = 4294967295;
  var HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH4 >>> 1;
  function baseSortedIndex(array, value, retHighest) {
    var low = 0, high = array == null ? low : array.length;
    if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
      while (low < high) {
        var mid = low + high >>> 1, computed = array[mid];
        if (computed !== null && !isSymbol_default(computed) && (retHighest ? computed <= value : computed < value)) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return high;
    }
    return baseSortedIndexBy_default(array, value, identity_default, retHighest);
  }
  var baseSortedIndex_default = baseSortedIndex;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sortedIndex.js
  function sortedIndex(array, value) {
    return baseSortedIndex_default(array, value);
  }
  var sortedIndex_default = sortedIndex;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sortedIndexBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function sortedIndexBy(array, value, iteratee2) {
    return baseSortedIndexBy_default(array, value, baseIteratee_default(iteratee2, 2));
  }
  var sortedIndexBy_default = sortedIndexBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sortedIndexOf.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function sortedIndexOf(array, value) {
    var length = array == null ? 0 : array.length;
    if (length) {
      var index = baseSortedIndex_default(array, value);
      if (index < length && eq_default(array[index], value)) {
        return index;
      }
    }
    return -1;
  }
  var sortedIndexOf_default = sortedIndexOf;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sortedLastIndex.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function sortedLastIndex(array, value) {
    return baseSortedIndex_default(array, value, true);
  }
  var sortedLastIndex_default = sortedLastIndex;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sortedLastIndexBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function sortedLastIndexBy(array, value, iteratee2) {
    return baseSortedIndexBy_default(array, value, baseIteratee_default(iteratee2, 2), true);
  }
  var sortedLastIndexBy_default = sortedLastIndexBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sortedLastIndexOf.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function sortedLastIndexOf(array, value) {
    var length = array == null ? 0 : array.length;
    if (length) {
      var index = baseSortedIndex_default(array, value, true) - 1;
      if (eq_default(array[index], value)) {
        return index;
      }
    }
    return -1;
  }
  var sortedLastIndexOf_default = sortedLastIndexOf;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sortedUniq.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSortedUniq.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseSortedUniq(array, iteratee2) {
    var index = -1, length = array.length, resIndex = 0, result2 = [];
    while (++index < length) {
      var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
      if (!index || !eq_default(computed, seen)) {
        var seen = computed;
        result2[resIndex++] = value === 0 ? 0 : value;
      }
    }
    return result2;
  }
  var baseSortedUniq_default = baseSortedUniq;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sortedUniq.js
  function sortedUniq(array) {
    return array && array.length ? baseSortedUniq_default(array) : [];
  }
  var sortedUniq_default = sortedUniq;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sortedUniqBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function sortedUniqBy(array, iteratee2) {
    return array && array.length ? baseSortedUniq_default(array, baseIteratee_default(iteratee2, 2)) : [];
  }
  var sortedUniqBy_default = sortedUniqBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/split.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var MAX_ARRAY_LENGTH5 = 4294967295;
  function split(string, separator, limit) {
    if (limit && typeof limit != "number" && isIterateeCall_default(string, separator, limit)) {
      separator = limit = void 0;
    }
    limit = limit === void 0 ? MAX_ARRAY_LENGTH5 : limit >>> 0;
    if (!limit) {
      return [];
    }
    string = toString_default(string);
    if (string && (typeof separator == "string" || separator != null && !isRegExp_default(separator))) {
      separator = baseToString_default(separator);
      if (!separator && hasUnicode_default(string)) {
        return castSlice_default(stringToArray_default(string), 0, limit);
      }
    }
    return string.split(separator, limit);
  }
  var split_default = split;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/spread.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var FUNC_ERROR_TEXT11 = "Expected a function";
  var nativeMax14 = Math.max;
  function spread(func, start) {
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT11);
    }
    start = start == null ? 0 : nativeMax14(toInteger_default(start), 0);
    return baseRest_default(function(args) {
      var array = args[start], otherArgs = castSlice_default(args, 0, start);
      if (array) {
        arrayPush_default(otherArgs, array);
      }
      return apply_default(func, this, otherArgs);
    });
  }
  var spread_default = spread;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/startCase.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var startCase = createCompounder_default(function(result2, word, index) {
    return result2 + (index ? " " : "") + upperFirst_default(word);
  });
  var startCase_default = startCase;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/startsWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function startsWith(string, target, position) {
    string = toString_default(string);
    position = position == null ? 0 : baseClamp_default(toInteger_default(position), 0, string.length);
    target = baseToString_default(target);
    return string.slice(position, position + target.length) == target;
  }
  var startsWith_default = startsWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/stubObject.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function stubObject() {
    return {};
  }
  var stubObject_default = stubObject;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/stubString.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function stubString() {
    return "";
  }
  var stubString_default = stubString;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/stubTrue.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function stubTrue() {
    return true;
  }
  var stubTrue_default = stubTrue;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/subtract.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var subtract = createMathOperation_default(function(minuend, subtrahend) {
    return minuend - subtrahend;
  }, 0);
  var subtract_default = subtract;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sum.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function sum(array) {
    return array && array.length ? baseSum_default(array, identity_default) : 0;
  }
  var sum_default = sum;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/sumBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function sumBy(array, iteratee2) {
    return array && array.length ? baseSum_default(array, baseIteratee_default(iteratee2, 2)) : 0;
  }
  var sumBy_default = sumBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/tail.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function tail(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseSlice_default(array, 1, length) : [];
  }
  var tail_default = tail;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/take.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function take(array, n, guard) {
    if (!(array && array.length)) {
      return [];
    }
    n = guard || n === void 0 ? 1 : toInteger_default(n);
    return baseSlice_default(array, 0, n < 0 ? 0 : n);
  }
  var take_default = take;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/takeRight.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function takeRight(array, n, guard) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    n = guard || n === void 0 ? 1 : toInteger_default(n);
    n = length - n;
    return baseSlice_default(array, n < 0 ? 0 : n, length);
  }
  var takeRight_default = takeRight;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/takeRightWhile.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function takeRightWhile(array, predicate) {
    return array && array.length ? baseWhile_default(array, baseIteratee_default(predicate, 3), false, true) : [];
  }
  var takeRightWhile_default = takeRightWhile;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/takeWhile.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function takeWhile(array, predicate) {
    return array && array.length ? baseWhile_default(array, baseIteratee_default(predicate, 3)) : [];
  }
  var takeWhile_default = takeWhile;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/tap.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function tap(value, interceptor) {
    interceptor(value);
    return value;
  }
  var tap_default = tap;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/template.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_customDefaultsAssignIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var objectProto27 = Object.prototype;
  var hasOwnProperty24 = objectProto27.hasOwnProperty;
  function customDefaultsAssignIn(objValue, srcValue, key, object) {
    if (objValue === void 0 || eq_default(objValue, objectProto27[key]) && !hasOwnProperty24.call(object, key)) {
      return srcValue;
    }
    return objValue;
  }
  var customDefaultsAssignIn_default = customDefaultsAssignIn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_escapeStringChar.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var stringEscapes = {
    "\\": "\\",
    "'": "'",
    "\n": "n",
    "\r": "r",
    "\u2028": "u2028",
    "\u2029": "u2029"
  };
  function escapeStringChar(chr) {
    return "\\" + stringEscapes[chr];
  }
  var escapeStringChar_default = escapeStringChar;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_reInterpolate.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var reInterpolate = /<%=([\s\S]+?)%>/g;
  var reInterpolate_default = reInterpolate;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/templateSettings.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_reEscape.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var reEscape = /<%-([\s\S]+?)%>/g;
  var reEscape_default = reEscape;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_reEvaluate.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var reEvaluate = /<%([\s\S]+?)%>/g;
  var reEvaluate_default = reEvaluate;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/templateSettings.js
  var templateSettings = {
    "escape": reEscape_default,
    "evaluate": reEvaluate_default,
    "interpolate": reInterpolate_default,
    "variable": "",
    "imports": {
      "_": { "escape": escape_default }
    }
  };
  var templateSettings_default = templateSettings;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/template.js
  var INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
  var reEmptyStringLeading = /\b__p \+= '';/g;
  var reEmptyStringMiddle = /\b(__p \+=) '' \+/g;
  var reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
  var reNoMatch = /($^)/;
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
  var objectProto28 = Object.prototype;
  var hasOwnProperty25 = objectProto28.hasOwnProperty;
  function template(string, options, guard) {
    var settings = templateSettings_default.imports._.templateSettings || templateSettings_default;
    if (guard && isIterateeCall_default(string, options, guard)) {
      options = void 0;
    }
    string = toString_default(string);
    options = assignInWith_default({}, options, settings, customDefaultsAssignIn_default);
    var imports = assignInWith_default({}, options.imports, settings.imports, customDefaultsAssignIn_default), importsKeys = keys_default(imports), importsValues = baseValues_default(imports, importsKeys);
    var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
    var reDelimiters = RegExp(
      (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate_default ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
      "g"
    );
    var sourceURL = hasOwnProperty25.call(options, "sourceURL") ? "//# sourceURL=" + (options.sourceURL + "").replace(/\s/g, " ") + "\n" : "";
    string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
      interpolateValue || (interpolateValue = esTemplateValue);
      source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar_default);
      if (escapeValue) {
        isEscaping = true;
        source += "' +\n__e(" + escapeValue + ") +\n'";
      }
      if (evaluateValue) {
        isEvaluating = true;
        source += "';\n" + evaluateValue + ";\n__p += '";
      }
      if (interpolateValue) {
        source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
      }
      index = offset + match.length;
      return match;
    });
    source += "';\n";
    var variable = hasOwnProperty25.call(options, "variable") && options.variable;
    if (!variable) {
      source = "with (obj) {\n" + source + "\n}\n";
    } else if (reForbiddenIdentifierChars.test(variable)) {
      throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
    }
    source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
    source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
    var result2 = attempt_default(function() {
      return Function(importsKeys, sourceURL + "return " + source).apply(void 0, importsValues);
    });
    result2.source = source;
    if (isError_default(result2)) {
      throw result2;
    }
    return result2;
  }
  var template_default = template;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/throttle.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var FUNC_ERROR_TEXT12 = "Expected a function";
  function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT12);
    }
    if (isObject_default(options)) {
      leading = "leading" in options ? !!options.leading : leading;
      trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return debounce_default(func, wait, {
      "leading": leading,
      "maxWait": wait,
      "trailing": trailing
    });
  }
  var throttle_default = throttle;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/thru.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function thru(value, interceptor) {
    return interceptor(value);
  }
  var thru_default = thru;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/times.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var MAX_SAFE_INTEGER5 = 9007199254740991;
  var MAX_ARRAY_LENGTH6 = 4294967295;
  var nativeMin12 = Math.min;
  function times(n, iteratee2) {
    n = toInteger_default(n);
    if (n < 1 || n > MAX_SAFE_INTEGER5) {
      return [];
    }
    var index = MAX_ARRAY_LENGTH6, length = nativeMin12(n, MAX_ARRAY_LENGTH6);
    iteratee2 = castFunction_default(iteratee2);
    n -= MAX_ARRAY_LENGTH6;
    var result2 = baseTimes_default(length, iteratee2);
    while (++index < n) {
      iteratee2(index);
    }
    return result2;
  }
  var times_default = times;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toIterator.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function wrapperToIterator() {
    return this;
  }
  var toIterator_default = wrapperToIterator;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toJSON.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/wrapperValue.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseWrapperValue.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseWrapperValue(value, actions) {
    var result2 = value;
    if (result2 instanceof LazyWrapper_default) {
      result2 = result2.value();
    }
    return arrayReduce_default(actions, function(result3, action) {
      return action.func.apply(action.thisArg, arrayPush_default([result3], action.args));
    }, result2);
  }
  var baseWrapperValue_default = baseWrapperValue;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/wrapperValue.js
  function wrapperValue() {
    return baseWrapperValue_default(this.__wrapped__, this.__actions__);
  }
  var wrapperValue_default = wrapperValue;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toLower.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function toLower(value) {
    return toString_default(value).toLowerCase();
  }
  var toLower_default = toLower;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toPath.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function toPath(value) {
    if (isArray_default(value)) {
      return arrayMap_default(value, toKey_default);
    }
    return isSymbol_default(value) ? [value] : copyArray_default(stringToPath_default(toString_default(value)));
  }
  var toPath_default = toPath;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toSafeInteger.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var MAX_SAFE_INTEGER6 = 9007199254740991;
  function toSafeInteger(value) {
    return value ? baseClamp_default(toInteger_default(value), -MAX_SAFE_INTEGER6, MAX_SAFE_INTEGER6) : value === 0 ? value : 0;
  }
  var toSafeInteger_default = toSafeInteger;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toUpper.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function toUpper(value) {
    return toString_default(value).toUpperCase();
  }
  var toUpper_default = toUpper;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/transform.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function transform(object, iteratee2, accumulator) {
    var isArr = isArray_default(object), isArrLike = isArr || isBuffer_default(object) || isTypedArray_default(object);
    iteratee2 = baseIteratee_default(iteratee2, 4);
    if (accumulator == null) {
      var Ctor = object && object.constructor;
      if (isArrLike) {
        accumulator = isArr ? new Ctor() : [];
      } else if (isObject_default(object)) {
        accumulator = isFunction_default(Ctor) ? baseCreate_default(getPrototype_default(object)) : {};
      } else {
        accumulator = {};
      }
    }
    (isArrLike ? arrayEach_default : baseForOwn_default)(object, function(value, index, object2) {
      return iteratee2(accumulator, value, index, object2);
    });
    return accumulator;
  }
  var transform_default = transform;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/trim.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_charsEndIndex.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while (index-- && baseIndexOf_default(chrSymbols, strSymbols[index], 0) > -1) {
    }
    return index;
  }
  var charsEndIndex_default = charsEndIndex;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_charsStartIndex.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while (++index < length && baseIndexOf_default(chrSymbols, strSymbols[index], 0) > -1) {
    }
    return index;
  }
  var charsStartIndex_default = charsStartIndex;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/trim.js
  function trim(string, chars, guard) {
    string = toString_default(string);
    if (string && (guard || chars === void 0)) {
      return baseTrim_default(string);
    }
    if (!string || !(chars = baseToString_default(chars))) {
      return string;
    }
    var strSymbols = stringToArray_default(string), chrSymbols = stringToArray_default(chars), start = charsStartIndex_default(strSymbols, chrSymbols), end = charsEndIndex_default(strSymbols, chrSymbols) + 1;
    return castSlice_default(strSymbols, start, end).join("");
  }
  var trim_default = trim;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/trimEnd.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function trimEnd(string, chars, guard) {
    string = toString_default(string);
    if (string && (guard || chars === void 0)) {
      return string.slice(0, trimmedEndIndex_default(string) + 1);
    }
    if (!string || !(chars = baseToString_default(chars))) {
      return string;
    }
    var strSymbols = stringToArray_default(string), end = charsEndIndex_default(strSymbols, stringToArray_default(chars)) + 1;
    return castSlice_default(strSymbols, 0, end).join("");
  }
  var trimEnd_default = trimEnd;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/trimStart.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var reTrimStart3 = /^\s+/;
  function trimStart(string, chars, guard) {
    string = toString_default(string);
    if (string && (guard || chars === void 0)) {
      return string.replace(reTrimStart3, "");
    }
    if (!string || !(chars = baseToString_default(chars))) {
      return string;
    }
    var strSymbols = stringToArray_default(string), start = charsStartIndex_default(strSymbols, stringToArray_default(chars));
    return castSlice_default(strSymbols, start).join("");
  }
  var trimStart_default = trimStart;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/truncate.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var DEFAULT_TRUNC_LENGTH = 30;
  var DEFAULT_TRUNC_OMISSION = "...";
  var reFlags2 = /\w*$/;
  function truncate(string, options) {
    var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
    if (isObject_default(options)) {
      var separator = "separator" in options ? options.separator : separator;
      length = "length" in options ? toInteger_default(options.length) : length;
      omission = "omission" in options ? baseToString_default(options.omission) : omission;
    }
    string = toString_default(string);
    var strLength = string.length;
    if (hasUnicode_default(string)) {
      var strSymbols = stringToArray_default(string);
      strLength = strSymbols.length;
    }
    if (length >= strLength) {
      return string;
    }
    var end = length - stringSize_default(omission);
    if (end < 1) {
      return omission;
    }
    var result2 = strSymbols ? castSlice_default(strSymbols, 0, end).join("") : string.slice(0, end);
    if (separator === void 0) {
      return result2 + omission;
    }
    if (strSymbols) {
      end += result2.length - end;
    }
    if (isRegExp_default(separator)) {
      if (string.slice(end).search(separator)) {
        var match, substring = result2;
        if (!separator.global) {
          separator = RegExp(separator.source, toString_default(reFlags2.exec(separator)) + "g");
        }
        separator.lastIndex = 0;
        while (match = separator.exec(substring)) {
          var newEnd = match.index;
        }
        result2 = result2.slice(0, newEnd === void 0 ? end : newEnd);
      }
    } else if (string.indexOf(baseToString_default(separator), end) != end) {
      var index = result2.lastIndexOf(separator);
      if (index > -1) {
        result2 = result2.slice(0, index);
      }
    }
    return result2 + omission;
  }
  var truncate_default = truncate;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/unary.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function unary(func) {
    return ary_default(func, 1);
  }
  var unary_default = unary;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/unescape.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_unescapeHtmlChar.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var htmlUnescapes = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'"
  };
  var unescapeHtmlChar = basePropertyOf_default(htmlUnescapes);
  var unescapeHtmlChar_default = unescapeHtmlChar;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/unescape.js
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g;
  var reHasEscapedHtml = RegExp(reEscapedHtml.source);
  function unescape(string) {
    string = toString_default(string);
    return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar_default) : string;
  }
  var unescape_default = unescape;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/union.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseUniq.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_createSet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var INFINITY6 = 1 / 0;
  var createSet = !(Set_default && 1 / setToArray_default(new Set_default([, -0]))[1] == INFINITY6) ? noop_default : function(values2) {
    return new Set_default(values2);
  };
  var createSet_default = createSet;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseUniq.js
  var LARGE_ARRAY_SIZE3 = 200;
  function baseUniq(array, iteratee2, comparator) {
    var index = -1, includes2 = arrayIncludes_default, length = array.length, isCommon = true, result2 = [], seen = result2;
    if (comparator) {
      isCommon = false;
      includes2 = arrayIncludesWith_default;
    } else if (length >= LARGE_ARRAY_SIZE3) {
      var set2 = iteratee2 ? null : createSet_default(array);
      if (set2) {
        return setToArray_default(set2);
      }
      isCommon = false;
      includes2 = cacheHas_default;
      seen = new SetCache_default();
    } else {
      seen = iteratee2 ? [] : result2;
    }
    outer:
      while (++index < length) {
        var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee2) {
            seen.push(computed);
          }
          result2.push(value);
        } else if (!includes2(seen, computed, comparator)) {
          if (seen !== result2) {
            seen.push(computed);
          }
          result2.push(value);
        }
      }
    return result2;
  }
  var baseUniq_default = baseUniq;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/union.js
  var union = baseRest_default(function(arrays) {
    return baseUniq_default(baseFlatten_default(arrays, 1, isArrayLikeObject_default, true));
  });
  var union_default = union;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/unionBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var unionBy = baseRest_default(function(arrays) {
    var iteratee2 = last_default(arrays);
    if (isArrayLikeObject_default(iteratee2)) {
      iteratee2 = void 0;
    }
    return baseUniq_default(baseFlatten_default(arrays, 1, isArrayLikeObject_default, true), baseIteratee_default(iteratee2, 2));
  });
  var unionBy_default = unionBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/unionWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var unionWith = baseRest_default(function(arrays) {
    var comparator = last_default(arrays);
    comparator = typeof comparator == "function" ? comparator : void 0;
    return baseUniq_default(baseFlatten_default(arrays, 1, isArrayLikeObject_default, true), void 0, comparator);
  });
  var unionWith_default = unionWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/uniq.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function uniq(array) {
    return array && array.length ? baseUniq_default(array) : [];
  }
  var uniq_default = uniq;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/uniqBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function uniqBy(array, iteratee2) {
    return array && array.length ? baseUniq_default(array, baseIteratee_default(iteratee2, 2)) : [];
  }
  var uniqBy_default = uniqBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/uniqWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function uniqWith(array, comparator) {
    comparator = typeof comparator == "function" ? comparator : void 0;
    return array && array.length ? baseUniq_default(array, void 0, comparator) : [];
  }
  var uniqWith_default = uniqWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/uniqueId.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var idCounter = 0;
  function uniqueId(prefix) {
    var id = ++idCounter;
    return toString_default(prefix) + id;
  }
  var uniqueId_default = uniqueId;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/unset.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function unset(object, path) {
    return object == null ? true : baseUnset_default(object, path);
  }
  var unset_default = unset;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/unzip.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeMax15 = Math.max;
  function unzip(array) {
    if (!(array && array.length)) {
      return [];
    }
    var length = 0;
    array = arrayFilter_default(array, function(group) {
      if (isArrayLikeObject_default(group)) {
        length = nativeMax15(group.length, length);
        return true;
      }
    });
    return baseTimes_default(length, function(index) {
      return arrayMap_default(array, baseProperty_default(index));
    });
  }
  var unzip_default = unzip;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/unzipWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function unzipWith(array, iteratee2) {
    if (!(array && array.length)) {
      return [];
    }
    var result2 = unzip_default(array);
    if (iteratee2 == null) {
      return result2;
    }
    return arrayMap_default(result2, function(group) {
      return apply_default(iteratee2, void 0, group);
    });
  }
  var unzipWith_default = unzipWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/update.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseUpdate.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseUpdate(object, path, updater, customizer2) {
    return baseSet_default(object, path, updater(baseGet_default(object, path)), customizer2);
  }
  var baseUpdate_default = baseUpdate;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/update.js
  function update(object, path, updater) {
    return object == null ? object : baseUpdate_default(object, path, castFunction_default(updater));
  }
  var update_default = update;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/updateWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function updateWith(object, path, updater, customizer2) {
    customizer2 = typeof customizer2 == "function" ? customizer2 : void 0;
    return object == null ? object : baseUpdate_default(object, path, castFunction_default(updater), customizer2);
  }
  var updateWith_default = updateWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/upperCase.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var upperCase = createCompounder_default(function(result2, word, index) {
    return result2 + (index ? " " : "") + word.toUpperCase();
  });
  var upperCase_default = upperCase;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/valueOf.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/valuesIn.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function valuesIn(object) {
    return object == null ? [] : baseValues_default(object, keysIn_default(object));
  }
  var valuesIn_default = valuesIn;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/without.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var without = baseRest_default(function(array, values2) {
    return isArrayLikeObject_default(array) ? baseDifference_default(array, values2) : [];
  });
  var without_default = without;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/wrap.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function wrap(value, wrapper) {
    return partial_default(castFunction_default(wrapper), value);
  }
  var wrap_default = wrap;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/wrapperAt.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var wrapperAt = flatRest_default(function(paths) {
    var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
      return baseAt_default(object, paths);
    };
    if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper_default) || !isIndex_default(start)) {
      return this.thru(interceptor);
    }
    value = value.slice(start, +start + (length ? 1 : 0));
    value.__actions__.push({
      "func": thru_default,
      "args": [interceptor],
      "thisArg": void 0
    });
    return new LodashWrapper_default(value, this.__chain__).thru(function(array) {
      if (length && !array.length) {
        array.push(void 0);
      }
      return array;
    });
  });
  var wrapperAt_default = wrapperAt;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/wrapperChain.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function wrapperChain() {
    return chain_default(this);
  }
  var wrapperChain_default = wrapperChain;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/wrapperReverse.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function wrapperReverse() {
    var value = this.__wrapped__;
    if (value instanceof LazyWrapper_default) {
      var wrapped = value;
      if (this.__actions__.length) {
        wrapped = new LazyWrapper_default(this);
      }
      wrapped = wrapped.reverse();
      wrapped.__actions__.push({
        "func": thru_default,
        "args": [reverse_default],
        "thisArg": void 0
      });
      return new LodashWrapper_default(wrapped, this.__chain__);
    }
    return this.thru(reverse_default);
  }
  var wrapperReverse_default = wrapperReverse;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/xor.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseXor.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseXor(arrays, iteratee2, comparator) {
    var length = arrays.length;
    if (length < 2) {
      return length ? baseUniq_default(arrays[0]) : [];
    }
    var index = -1, result2 = Array(length);
    while (++index < length) {
      var array = arrays[index], othIndex = -1;
      while (++othIndex < length) {
        if (othIndex != index) {
          result2[index] = baseDifference_default(result2[index] || array, arrays[othIndex], iteratee2, comparator);
        }
      }
    }
    return baseUniq_default(baseFlatten_default(result2, 1), iteratee2, comparator);
  }
  var baseXor_default = baseXor;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/xor.js
  var xor = baseRest_default(function(arrays) {
    return baseXor_default(arrayFilter_default(arrays, isArrayLikeObject_default));
  });
  var xor_default = xor;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/xorBy.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var xorBy = baseRest_default(function(arrays) {
    var iteratee2 = last_default(arrays);
    if (isArrayLikeObject_default(iteratee2)) {
      iteratee2 = void 0;
    }
    return baseXor_default(arrayFilter_default(arrays, isArrayLikeObject_default), baseIteratee_default(iteratee2, 2));
  });
  var xorBy_default = xorBy;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/xorWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var xorWith = baseRest_default(function(arrays) {
    var comparator = last_default(arrays);
    comparator = typeof comparator == "function" ? comparator : void 0;
    return baseXor_default(arrayFilter_default(arrays, isArrayLikeObject_default), void 0, comparator);
  });
  var xorWith_default = xorWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/zip.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var zip = baseRest_default(unzip_default);
  var zip_default = zip;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/zipObject.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseZipObject.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function baseZipObject(props, values2, assignFunc) {
    var index = -1, length = props.length, valsLength = values2.length, result2 = {};
    while (++index < length) {
      var value = index < valsLength ? values2[index] : void 0;
      assignFunc(result2, props[index], value);
    }
    return result2;
  }
  var baseZipObject_default = baseZipObject;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/zipObject.js
  function zipObject(props, values2) {
    return baseZipObject_default(props || [], values2 || [], assignValue_default);
  }
  var zipObject_default = zipObject;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/zipObjectDeep.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function zipObjectDeep(props, values2) {
    return baseZipObject_default(props || [], values2 || [], baseSet_default);
  }
  var zipObjectDeep_default = zipObjectDeep;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/zipWith.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var zipWith = baseRest_default(function(arrays) {
    var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : void 0;
    iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : void 0;
    return unzipWith_default(arrays, iteratee2);
  });
  var zipWith_default = zipWith;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/lodash.default.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/array.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/array.default.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var array_default_default = {
    chunk: chunk_default,
    compact: compact_default,
    concat: concat_default,
    difference: difference_default,
    differenceBy: differenceBy_default,
    differenceWith: differenceWith_default,
    drop: drop_default,
    dropRight: dropRight_default,
    dropRightWhile: dropRightWhile_default,
    dropWhile: dropWhile_default,
    fill: fill_default,
    findIndex: findIndex_default,
    findLastIndex: findLastIndex_default,
    first: head_default,
    flatten: flatten_default,
    flattenDeep: flattenDeep_default,
    flattenDepth: flattenDepth_default,
    fromPairs: fromPairs_default,
    head: head_default,
    indexOf: indexOf_default,
    initial: initial_default,
    intersection: intersection_default,
    intersectionBy: intersectionBy_default,
    intersectionWith: intersectionWith_default,
    join: join_default,
    last: last_default,
    lastIndexOf: lastIndexOf_default,
    nth: nth_default,
    pull: pull_default,
    pullAll: pullAll_default,
    pullAllBy: pullAllBy_default,
    pullAllWith: pullAllWith_default,
    pullAt: pullAt_default,
    remove: remove_default,
    reverse: reverse_default,
    slice: slice_default,
    sortedIndex: sortedIndex_default,
    sortedIndexBy: sortedIndexBy_default,
    sortedIndexOf: sortedIndexOf_default,
    sortedLastIndex: sortedLastIndex_default,
    sortedLastIndexBy: sortedLastIndexBy_default,
    sortedLastIndexOf: sortedLastIndexOf_default,
    sortedUniq: sortedUniq_default,
    sortedUniqBy: sortedUniqBy_default,
    tail: tail_default,
    take: take_default,
    takeRight: takeRight_default,
    takeRightWhile: takeRightWhile_default,
    takeWhile: takeWhile_default,
    union: union_default,
    unionBy: unionBy_default,
    unionWith: unionWith_default,
    uniq: uniq_default,
    uniqBy: uniqBy_default,
    uniqWith: uniqWith_default,
    unzip: unzip_default,
    unzipWith: unzipWith_default,
    without: without_default,
    xor: xor_default,
    xorBy: xorBy_default,
    xorWith: xorWith_default,
    zip: zip_default,
    zipObject: zipObject_default,
    zipObjectDeep: zipObjectDeep_default,
    zipWith: zipWith_default
  };

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/collection.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/collection.default.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var collection_default_default = {
    countBy: countBy_default,
    each: forEach_default,
    eachRight: forEachRight_default,
    every: every_default,
    filter: filter_default,
    find: find_default,
    findLast: findLast_default,
    flatMap: flatMap_default,
    flatMapDeep: flatMapDeep_default,
    flatMapDepth: flatMapDepth_default,
    forEach: forEach_default,
    forEachRight: forEachRight_default,
    groupBy: groupBy_default,
    includes: includes_default,
    invokeMap: invokeMap_default,
    keyBy: keyBy_default,
    map: map_default,
    orderBy: orderBy_default,
    partition: partition_default,
    reduce: reduce_default,
    reduceRight: reduceRight_default,
    reject: reject_default,
    sample: sample_default,
    sampleSize: sampleSize_default,
    shuffle: shuffle_default,
    size: size_default,
    some: some_default,
    sortBy: sortBy_default
  };

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/date.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/date.default.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var date_default_default = {
    now: now_default
  };

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/function.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/function.default.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var function_default_default = {
    after: after_default,
    ary: ary_default,
    before: before_default,
    bind: bind_default,
    bindKey: bindKey_default,
    curry: curry_default,
    curryRight: curryRight_default,
    debounce: debounce_default,
    defer: defer_default,
    delay: delay_default,
    flip: flip_default,
    memoize: memoize_default,
    negate: negate_default,
    once: once_default,
    overArgs: overArgs_default,
    partial: partial_default,
    partialRight: partialRight_default,
    rearg: rearg_default,
    rest: rest_default,
    spread: spread_default,
    throttle: throttle_default,
    unary: unary_default,
    wrap: wrap_default
  };

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/lang.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/lang.default.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var lang_default_default = {
    castArray: castArray_default,
    clone: clone_default,
    cloneDeep: cloneDeep_default,
    cloneDeepWith: cloneDeepWith_default,
    cloneWith: cloneWith_default,
    conformsTo: conformsTo_default,
    eq: eq_default,
    gt: gt_default,
    gte: gte_default,
    isArguments: isArguments_default,
    isArray: isArray_default,
    isArrayBuffer: isArrayBuffer_default,
    isArrayLike: isArrayLike_default,
    isArrayLikeObject: isArrayLikeObject_default,
    isBoolean: isBoolean_default,
    isBuffer: isBuffer_default,
    isDate: isDate_default,
    isElement: isElement_default,
    isEmpty: isEmpty_default,
    isEqual: isEqual_default,
    isEqualWith: isEqualWith_default,
    isError: isError_default,
    isFinite: isFinite_default,
    isFunction: isFunction_default,
    isInteger: isInteger_default,
    isLength: isLength_default,
    isMap: isMap_default,
    isMatch: isMatch_default,
    isMatchWith: isMatchWith_default,
    isNaN: isNaN_default,
    isNative: isNative_default,
    isNil: isNil_default,
    isNull: isNull_default,
    isNumber: isNumber_default,
    isObject: isObject_default,
    isObjectLike: isObjectLike_default,
    isPlainObject: isPlainObject_default,
    isRegExp: isRegExp_default,
    isSafeInteger: isSafeInteger_default,
    isSet: isSet_default,
    isString: isString_default,
    isSymbol: isSymbol_default,
    isTypedArray: isTypedArray_default,
    isUndefined: isUndefined_default,
    isWeakMap: isWeakMap_default,
    isWeakSet: isWeakSet_default,
    lt: lt_default,
    lte: lte_default,
    toArray: toArray_default,
    toFinite: toFinite_default,
    toInteger: toInteger_default,
    toLength: toLength_default,
    toNumber: toNumber_default,
    toPlainObject: toPlainObject_default,
    toSafeInteger: toSafeInteger_default,
    toString: toString_default
  };

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/math.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/math.default.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var math_default_default = {
    add: add_default,
    ceil: ceil_default,
    divide: divide_default,
    floor: floor_default,
    max: max_default,
    maxBy: maxBy_default,
    mean: mean_default,
    meanBy: meanBy_default,
    min: min_default,
    minBy: minBy_default,
    multiply: multiply_default,
    round: round_default,
    subtract: subtract_default,
    sum: sum_default,
    sumBy: sumBy_default
  };

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/number.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/number.default.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var number_default_default = {
    clamp: clamp_default,
    inRange: inRange_default,
    random: random_default
  };

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/object.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/object.default.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var object_default_default = {
    assign: assign_default,
    assignIn: assignIn_default,
    assignInWith: assignInWith_default,
    assignWith: assignWith_default,
    at: at_default,
    create: create_default,
    defaults: defaults_default,
    defaultsDeep: defaultsDeep_default,
    entries: toPairs_default,
    entriesIn: toPairsIn_default,
    extend: assignIn_default,
    extendWith: assignInWith_default,
    findKey: findKey_default,
    findLastKey: findLastKey_default,
    forIn: forIn_default,
    forInRight: forInRight_default,
    forOwn: forOwn_default,
    forOwnRight: forOwnRight_default,
    functions: functions_default,
    functionsIn: functionsIn_default,
    get: get_default,
    has: has_default,
    hasIn: hasIn_default,
    invert: invert_default,
    invertBy: invertBy_default,
    invoke: invoke_default,
    keys: keys_default,
    keysIn: keysIn_default,
    mapKeys: mapKeys_default,
    mapValues: mapValues_default,
    merge: merge_default,
    mergeWith: mergeWith_default,
    omit: omit_default,
    omitBy: omitBy_default,
    pick: pick_default,
    pickBy: pickBy_default,
    result: result_default,
    set: set_default,
    setWith: setWith_default,
    toPairs: toPairs_default,
    toPairsIn: toPairsIn_default,
    transform: transform_default,
    unset: unset_default,
    update: update_default,
    updateWith: updateWith_default,
    values: values_default,
    valuesIn: valuesIn_default
  };

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/seq.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/seq.default.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var seq_default_default = {
    at: wrapperAt_default,
    chain: chain_default,
    commit: commit_default,
    lodash: wrapperLodash_default,
    next: next_default,
    plant: plant_default,
    reverse: wrapperReverse_default,
    tap: tap_default,
    thru: thru_default,
    toIterator: toIterator_default,
    toJSON: wrapperValue_default,
    value: wrapperValue_default,
    valueOf: wrapperValue_default,
    wrapperChain: wrapperChain_default
  };

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/string.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/string.default.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var string_default_default = {
    camelCase: camelCase_default,
    capitalize: capitalize_default,
    deburr: deburr_default,
    endsWith: endsWith_default,
    escape: escape_default,
    escapeRegExp: escapeRegExp_default,
    kebabCase: kebabCase_default,
    lowerCase: lowerCase_default,
    lowerFirst: lowerFirst_default,
    pad: pad_default,
    padEnd: padEnd_default,
    padStart: padStart_default,
    parseInt: parseInt_default,
    repeat: repeat_default,
    replace: replace_default,
    snakeCase: snakeCase_default,
    split: split_default,
    startCase: startCase_default,
    startsWith: startsWith_default,
    template: template_default,
    templateSettings: templateSettings_default,
    toLower: toLower_default,
    toUpper: toUpper_default,
    trim: trim_default,
    trimEnd: trimEnd_default,
    trimStart: trimStart_default,
    truncate: truncate_default,
    unescape: unescape_default,
    upperCase: upperCase_default,
    upperFirst: upperFirst_default,
    words: words_default
  };

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/util.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/util.default.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var util_default_default = {
    attempt: attempt_default,
    bindAll: bindAll_default,
    cond: cond_default,
    conforms: conforms_default,
    constant: constant_default,
    defaultTo: defaultTo_default,
    flow: flow_default,
    flowRight: flowRight_default,
    identity: identity_default,
    iteratee: iteratee_default,
    matches: matches_default,
    matchesProperty: matchesProperty_default,
    method: method_default,
    methodOf: methodOf_default,
    mixin: mixin_default,
    noop: noop_default,
    nthArg: nthArg_default,
    over: over_default,
    overEvery: overEvery_default,
    overSome: overSome_default,
    property: property_default,
    propertyOf: propertyOf_default,
    range: range_default,
    rangeRight: rangeRight_default,
    stubArray: stubArray_default,
    stubFalse: stubFalse_default,
    stubObject: stubObject_default,
    stubString: stubString_default,
    stubTrue: stubTrue_default,
    times: times_default,
    toPath: toPath_default,
    uniqueId: uniqueId_default
  };

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_lazyClone.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function lazyClone() {
    var result2 = new LazyWrapper_default(this.__wrapped__);
    result2.__actions__ = copyArray_default(this.__actions__);
    result2.__dir__ = this.__dir__;
    result2.__filtered__ = this.__filtered__;
    result2.__iteratees__ = copyArray_default(this.__iteratees__);
    result2.__takeCount__ = this.__takeCount__;
    result2.__views__ = copyArray_default(this.__views__);
    return result2;
  }
  var lazyClone_default = lazyClone;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_lazyReverse.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function lazyReverse() {
    if (this.__filtered__) {
      var result2 = new LazyWrapper_default(this);
      result2.__dir__ = -1;
      result2.__filtered__ = true;
    } else {
      result2 = this.clone();
      result2.__dir__ *= -1;
    }
    return result2;
  }
  var lazyReverse_default = lazyReverse;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_lazyValue.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getView.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var nativeMax16 = Math.max;
  var nativeMin13 = Math.min;
  function getView(start, end, transforms) {
    var index = -1, length = transforms.length;
    while (++index < length) {
      var data = transforms[index], size2 = data.size;
      switch (data.type) {
        case "drop":
          start += size2;
          break;
        case "dropRight":
          end -= size2;
          break;
        case "take":
          end = nativeMin13(end, start + size2);
          break;
        case "takeRight":
          start = nativeMax16(start, end - size2);
          break;
      }
    }
    return { "start": start, "end": end };
  }
  var getView_default = getView;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_lazyValue.js
  var LAZY_FILTER_FLAG = 1;
  var LAZY_MAP_FLAG = 2;
  var nativeMin14 = Math.min;
  function lazyValue() {
    var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray_default(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView_default(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin14(length, this.__takeCount__);
    if (!isArr || !isRight && arrLength == length && takeCount == length) {
      return baseWrapperValue_default(array, this.__actions__);
    }
    var result2 = [];
    outer:
      while (length-- && resIndex < takeCount) {
        index += dir;
        var iterIndex = -1, value = array[index];
        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result2[resIndex++] = value;
      }
    return result2;
  }
  var lazyValue_default = lazyValue;

  // ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/lodash.default.js
  var VERSION = "4.17.21";
  var WRAP_BIND_KEY_FLAG7 = 2;
  var LAZY_FILTER_FLAG2 = 1;
  var LAZY_WHILE_FLAG = 3;
  var MAX_ARRAY_LENGTH7 = 4294967295;
  var arrayProto6 = Array.prototype;
  var objectProto29 = Object.prototype;
  var hasOwnProperty26 = objectProto29.hasOwnProperty;
  var symIterator2 = Symbol_default ? Symbol_default.iterator : void 0;
  var nativeMax17 = Math.max;
  var nativeMin15 = Math.min;
  var mixin2 = function(func) {
    return function(object, source, options) {
      if (options == null) {
        var isObj = isObject_default(source), props = isObj && keys_default(source), methodNames = props && props.length && baseFunctions_default(source, props);
        if (!(methodNames ? methodNames.length : isObj)) {
          options = source;
          source = object;
          object = this;
        }
      }
      return func(object, source, options);
    };
  }(mixin_default);
  wrapperLodash_default.after = function_default_default.after;
  wrapperLodash_default.ary = function_default_default.ary;
  wrapperLodash_default.assign = object_default_default.assign;
  wrapperLodash_default.assignIn = object_default_default.assignIn;
  wrapperLodash_default.assignInWith = object_default_default.assignInWith;
  wrapperLodash_default.assignWith = object_default_default.assignWith;
  wrapperLodash_default.at = object_default_default.at;
  wrapperLodash_default.before = function_default_default.before;
  wrapperLodash_default.bind = function_default_default.bind;
  wrapperLodash_default.bindAll = util_default_default.bindAll;
  wrapperLodash_default.bindKey = function_default_default.bindKey;
  wrapperLodash_default.castArray = lang_default_default.castArray;
  wrapperLodash_default.chain = seq_default_default.chain;
  wrapperLodash_default.chunk = array_default_default.chunk;
  wrapperLodash_default.compact = array_default_default.compact;
  wrapperLodash_default.concat = array_default_default.concat;
  wrapperLodash_default.cond = util_default_default.cond;
  wrapperLodash_default.conforms = util_default_default.conforms;
  wrapperLodash_default.constant = util_default_default.constant;
  wrapperLodash_default.countBy = collection_default_default.countBy;
  wrapperLodash_default.create = object_default_default.create;
  wrapperLodash_default.curry = function_default_default.curry;
  wrapperLodash_default.curryRight = function_default_default.curryRight;
  wrapperLodash_default.debounce = function_default_default.debounce;
  wrapperLodash_default.defaults = object_default_default.defaults;
  wrapperLodash_default.defaultsDeep = object_default_default.defaultsDeep;
  wrapperLodash_default.defer = function_default_default.defer;
  wrapperLodash_default.delay = function_default_default.delay;
  wrapperLodash_default.difference = array_default_default.difference;
  wrapperLodash_default.differenceBy = array_default_default.differenceBy;
  wrapperLodash_default.differenceWith = array_default_default.differenceWith;
  wrapperLodash_default.drop = array_default_default.drop;
  wrapperLodash_default.dropRight = array_default_default.dropRight;
  wrapperLodash_default.dropRightWhile = array_default_default.dropRightWhile;
  wrapperLodash_default.dropWhile = array_default_default.dropWhile;
  wrapperLodash_default.fill = array_default_default.fill;
  wrapperLodash_default.filter = collection_default_default.filter;
  wrapperLodash_default.flatMap = collection_default_default.flatMap;
  wrapperLodash_default.flatMapDeep = collection_default_default.flatMapDeep;
  wrapperLodash_default.flatMapDepth = collection_default_default.flatMapDepth;
  wrapperLodash_default.flatten = array_default_default.flatten;
  wrapperLodash_default.flattenDeep = array_default_default.flattenDeep;
  wrapperLodash_default.flattenDepth = array_default_default.flattenDepth;
  wrapperLodash_default.flip = function_default_default.flip;
  wrapperLodash_default.flow = util_default_default.flow;
  wrapperLodash_default.flowRight = util_default_default.flowRight;
  wrapperLodash_default.fromPairs = array_default_default.fromPairs;
  wrapperLodash_default.functions = object_default_default.functions;
  wrapperLodash_default.functionsIn = object_default_default.functionsIn;
  wrapperLodash_default.groupBy = collection_default_default.groupBy;
  wrapperLodash_default.initial = array_default_default.initial;
  wrapperLodash_default.intersection = array_default_default.intersection;
  wrapperLodash_default.intersectionBy = array_default_default.intersectionBy;
  wrapperLodash_default.intersectionWith = array_default_default.intersectionWith;
  wrapperLodash_default.invert = object_default_default.invert;
  wrapperLodash_default.invertBy = object_default_default.invertBy;
  wrapperLodash_default.invokeMap = collection_default_default.invokeMap;
  wrapperLodash_default.iteratee = util_default_default.iteratee;
  wrapperLodash_default.keyBy = collection_default_default.keyBy;
  wrapperLodash_default.keys = keys_default;
  wrapperLodash_default.keysIn = object_default_default.keysIn;
  wrapperLodash_default.map = collection_default_default.map;
  wrapperLodash_default.mapKeys = object_default_default.mapKeys;
  wrapperLodash_default.mapValues = object_default_default.mapValues;
  wrapperLodash_default.matches = util_default_default.matches;
  wrapperLodash_default.matchesProperty = util_default_default.matchesProperty;
  wrapperLodash_default.memoize = function_default_default.memoize;
  wrapperLodash_default.merge = object_default_default.merge;
  wrapperLodash_default.mergeWith = object_default_default.mergeWith;
  wrapperLodash_default.method = util_default_default.method;
  wrapperLodash_default.methodOf = util_default_default.methodOf;
  wrapperLodash_default.mixin = mixin2;
  wrapperLodash_default.negate = negate_default;
  wrapperLodash_default.nthArg = util_default_default.nthArg;
  wrapperLodash_default.omit = object_default_default.omit;
  wrapperLodash_default.omitBy = object_default_default.omitBy;
  wrapperLodash_default.once = function_default_default.once;
  wrapperLodash_default.orderBy = collection_default_default.orderBy;
  wrapperLodash_default.over = util_default_default.over;
  wrapperLodash_default.overArgs = function_default_default.overArgs;
  wrapperLodash_default.overEvery = util_default_default.overEvery;
  wrapperLodash_default.overSome = util_default_default.overSome;
  wrapperLodash_default.partial = function_default_default.partial;
  wrapperLodash_default.partialRight = function_default_default.partialRight;
  wrapperLodash_default.partition = collection_default_default.partition;
  wrapperLodash_default.pick = object_default_default.pick;
  wrapperLodash_default.pickBy = object_default_default.pickBy;
  wrapperLodash_default.property = util_default_default.property;
  wrapperLodash_default.propertyOf = util_default_default.propertyOf;
  wrapperLodash_default.pull = array_default_default.pull;
  wrapperLodash_default.pullAll = array_default_default.pullAll;
  wrapperLodash_default.pullAllBy = array_default_default.pullAllBy;
  wrapperLodash_default.pullAllWith = array_default_default.pullAllWith;
  wrapperLodash_default.pullAt = array_default_default.pullAt;
  wrapperLodash_default.range = util_default_default.range;
  wrapperLodash_default.rangeRight = util_default_default.rangeRight;
  wrapperLodash_default.rearg = function_default_default.rearg;
  wrapperLodash_default.reject = collection_default_default.reject;
  wrapperLodash_default.remove = array_default_default.remove;
  wrapperLodash_default.rest = function_default_default.rest;
  wrapperLodash_default.reverse = array_default_default.reverse;
  wrapperLodash_default.sampleSize = collection_default_default.sampleSize;
  wrapperLodash_default.set = object_default_default.set;
  wrapperLodash_default.setWith = object_default_default.setWith;
  wrapperLodash_default.shuffle = collection_default_default.shuffle;
  wrapperLodash_default.slice = array_default_default.slice;
  wrapperLodash_default.sortBy = collection_default_default.sortBy;
  wrapperLodash_default.sortedUniq = array_default_default.sortedUniq;
  wrapperLodash_default.sortedUniqBy = array_default_default.sortedUniqBy;
  wrapperLodash_default.split = string_default_default.split;
  wrapperLodash_default.spread = function_default_default.spread;
  wrapperLodash_default.tail = array_default_default.tail;
  wrapperLodash_default.take = array_default_default.take;
  wrapperLodash_default.takeRight = array_default_default.takeRight;
  wrapperLodash_default.takeRightWhile = array_default_default.takeRightWhile;
  wrapperLodash_default.takeWhile = array_default_default.takeWhile;
  wrapperLodash_default.tap = seq_default_default.tap;
  wrapperLodash_default.throttle = function_default_default.throttle;
  wrapperLodash_default.thru = thru_default;
  wrapperLodash_default.toArray = lang_default_default.toArray;
  wrapperLodash_default.toPairs = object_default_default.toPairs;
  wrapperLodash_default.toPairsIn = object_default_default.toPairsIn;
  wrapperLodash_default.toPath = util_default_default.toPath;
  wrapperLodash_default.toPlainObject = lang_default_default.toPlainObject;
  wrapperLodash_default.transform = object_default_default.transform;
  wrapperLodash_default.unary = function_default_default.unary;
  wrapperLodash_default.union = array_default_default.union;
  wrapperLodash_default.unionBy = array_default_default.unionBy;
  wrapperLodash_default.unionWith = array_default_default.unionWith;
  wrapperLodash_default.uniq = array_default_default.uniq;
  wrapperLodash_default.uniqBy = array_default_default.uniqBy;
  wrapperLodash_default.uniqWith = array_default_default.uniqWith;
  wrapperLodash_default.unset = object_default_default.unset;
  wrapperLodash_default.unzip = array_default_default.unzip;
  wrapperLodash_default.unzipWith = array_default_default.unzipWith;
  wrapperLodash_default.update = object_default_default.update;
  wrapperLodash_default.updateWith = object_default_default.updateWith;
  wrapperLodash_default.values = object_default_default.values;
  wrapperLodash_default.valuesIn = object_default_default.valuesIn;
  wrapperLodash_default.without = array_default_default.without;
  wrapperLodash_default.words = string_default_default.words;
  wrapperLodash_default.wrap = function_default_default.wrap;
  wrapperLodash_default.xor = array_default_default.xor;
  wrapperLodash_default.xorBy = array_default_default.xorBy;
  wrapperLodash_default.xorWith = array_default_default.xorWith;
  wrapperLodash_default.zip = array_default_default.zip;
  wrapperLodash_default.zipObject = array_default_default.zipObject;
  wrapperLodash_default.zipObjectDeep = array_default_default.zipObjectDeep;
  wrapperLodash_default.zipWith = array_default_default.zipWith;
  wrapperLodash_default.entries = object_default_default.toPairs;
  wrapperLodash_default.entriesIn = object_default_default.toPairsIn;
  wrapperLodash_default.extend = object_default_default.assignIn;
  wrapperLodash_default.extendWith = object_default_default.assignInWith;
  mixin2(wrapperLodash_default, wrapperLodash_default);
  wrapperLodash_default.add = math_default_default.add;
  wrapperLodash_default.attempt = util_default_default.attempt;
  wrapperLodash_default.camelCase = string_default_default.camelCase;
  wrapperLodash_default.capitalize = string_default_default.capitalize;
  wrapperLodash_default.ceil = math_default_default.ceil;
  wrapperLodash_default.clamp = number_default_default.clamp;
  wrapperLodash_default.clone = lang_default_default.clone;
  wrapperLodash_default.cloneDeep = lang_default_default.cloneDeep;
  wrapperLodash_default.cloneDeepWith = lang_default_default.cloneDeepWith;
  wrapperLodash_default.cloneWith = lang_default_default.cloneWith;
  wrapperLodash_default.conformsTo = lang_default_default.conformsTo;
  wrapperLodash_default.deburr = string_default_default.deburr;
  wrapperLodash_default.defaultTo = util_default_default.defaultTo;
  wrapperLodash_default.divide = math_default_default.divide;
  wrapperLodash_default.endsWith = string_default_default.endsWith;
  wrapperLodash_default.eq = lang_default_default.eq;
  wrapperLodash_default.escape = string_default_default.escape;
  wrapperLodash_default.escapeRegExp = string_default_default.escapeRegExp;
  wrapperLodash_default.every = collection_default_default.every;
  wrapperLodash_default.find = collection_default_default.find;
  wrapperLodash_default.findIndex = array_default_default.findIndex;
  wrapperLodash_default.findKey = object_default_default.findKey;
  wrapperLodash_default.findLast = collection_default_default.findLast;
  wrapperLodash_default.findLastIndex = array_default_default.findLastIndex;
  wrapperLodash_default.findLastKey = object_default_default.findLastKey;
  wrapperLodash_default.floor = math_default_default.floor;
  wrapperLodash_default.forEach = collection_default_default.forEach;
  wrapperLodash_default.forEachRight = collection_default_default.forEachRight;
  wrapperLodash_default.forIn = object_default_default.forIn;
  wrapperLodash_default.forInRight = object_default_default.forInRight;
  wrapperLodash_default.forOwn = object_default_default.forOwn;
  wrapperLodash_default.forOwnRight = object_default_default.forOwnRight;
  wrapperLodash_default.get = object_default_default.get;
  wrapperLodash_default.gt = lang_default_default.gt;
  wrapperLodash_default.gte = lang_default_default.gte;
  wrapperLodash_default.has = object_default_default.has;
  wrapperLodash_default.hasIn = object_default_default.hasIn;
  wrapperLodash_default.head = array_default_default.head;
  wrapperLodash_default.identity = identity_default;
  wrapperLodash_default.includes = collection_default_default.includes;
  wrapperLodash_default.indexOf = array_default_default.indexOf;
  wrapperLodash_default.inRange = number_default_default.inRange;
  wrapperLodash_default.invoke = object_default_default.invoke;
  wrapperLodash_default.isArguments = lang_default_default.isArguments;
  wrapperLodash_default.isArray = isArray_default;
  wrapperLodash_default.isArrayBuffer = lang_default_default.isArrayBuffer;
  wrapperLodash_default.isArrayLike = lang_default_default.isArrayLike;
  wrapperLodash_default.isArrayLikeObject = lang_default_default.isArrayLikeObject;
  wrapperLodash_default.isBoolean = lang_default_default.isBoolean;
  wrapperLodash_default.isBuffer = lang_default_default.isBuffer;
  wrapperLodash_default.isDate = lang_default_default.isDate;
  wrapperLodash_default.isElement = lang_default_default.isElement;
  wrapperLodash_default.isEmpty = lang_default_default.isEmpty;
  wrapperLodash_default.isEqual = lang_default_default.isEqual;
  wrapperLodash_default.isEqualWith = lang_default_default.isEqualWith;
  wrapperLodash_default.isError = lang_default_default.isError;
  wrapperLodash_default.isFinite = lang_default_default.isFinite;
  wrapperLodash_default.isFunction = lang_default_default.isFunction;
  wrapperLodash_default.isInteger = lang_default_default.isInteger;
  wrapperLodash_default.isLength = lang_default_default.isLength;
  wrapperLodash_default.isMap = lang_default_default.isMap;
  wrapperLodash_default.isMatch = lang_default_default.isMatch;
  wrapperLodash_default.isMatchWith = lang_default_default.isMatchWith;
  wrapperLodash_default.isNaN = lang_default_default.isNaN;
  wrapperLodash_default.isNative = lang_default_default.isNative;
  wrapperLodash_default.isNil = lang_default_default.isNil;
  wrapperLodash_default.isNull = lang_default_default.isNull;
  wrapperLodash_default.isNumber = lang_default_default.isNumber;
  wrapperLodash_default.isObject = isObject_default;
  wrapperLodash_default.isObjectLike = lang_default_default.isObjectLike;
  wrapperLodash_default.isPlainObject = lang_default_default.isPlainObject;
  wrapperLodash_default.isRegExp = lang_default_default.isRegExp;
  wrapperLodash_default.isSafeInteger = lang_default_default.isSafeInteger;
  wrapperLodash_default.isSet = lang_default_default.isSet;
  wrapperLodash_default.isString = lang_default_default.isString;
  wrapperLodash_default.isSymbol = lang_default_default.isSymbol;
  wrapperLodash_default.isTypedArray = lang_default_default.isTypedArray;
  wrapperLodash_default.isUndefined = lang_default_default.isUndefined;
  wrapperLodash_default.isWeakMap = lang_default_default.isWeakMap;
  wrapperLodash_default.isWeakSet = lang_default_default.isWeakSet;
  wrapperLodash_default.join = array_default_default.join;
  wrapperLodash_default.kebabCase = string_default_default.kebabCase;
  wrapperLodash_default.last = last_default;
  wrapperLodash_default.lastIndexOf = array_default_default.lastIndexOf;
  wrapperLodash_default.lowerCase = string_default_default.lowerCase;
  wrapperLodash_default.lowerFirst = string_default_default.lowerFirst;
  wrapperLodash_default.lt = lang_default_default.lt;
  wrapperLodash_default.lte = lang_default_default.lte;
  wrapperLodash_default.max = math_default_default.max;
  wrapperLodash_default.maxBy = math_default_default.maxBy;
  wrapperLodash_default.mean = math_default_default.mean;
  wrapperLodash_default.meanBy = math_default_default.meanBy;
  wrapperLodash_default.min = math_default_default.min;
  wrapperLodash_default.minBy = math_default_default.minBy;
  wrapperLodash_default.stubArray = util_default_default.stubArray;
  wrapperLodash_default.stubFalse = util_default_default.stubFalse;
  wrapperLodash_default.stubObject = util_default_default.stubObject;
  wrapperLodash_default.stubString = util_default_default.stubString;
  wrapperLodash_default.stubTrue = util_default_default.stubTrue;
  wrapperLodash_default.multiply = math_default_default.multiply;
  wrapperLodash_default.nth = array_default_default.nth;
  wrapperLodash_default.noop = util_default_default.noop;
  wrapperLodash_default.now = date_default_default.now;
  wrapperLodash_default.pad = string_default_default.pad;
  wrapperLodash_default.padEnd = string_default_default.padEnd;
  wrapperLodash_default.padStart = string_default_default.padStart;
  wrapperLodash_default.parseInt = string_default_default.parseInt;
  wrapperLodash_default.random = number_default_default.random;
  wrapperLodash_default.reduce = collection_default_default.reduce;
  wrapperLodash_default.reduceRight = collection_default_default.reduceRight;
  wrapperLodash_default.repeat = string_default_default.repeat;
  wrapperLodash_default.replace = string_default_default.replace;
  wrapperLodash_default.result = object_default_default.result;
  wrapperLodash_default.round = math_default_default.round;
  wrapperLodash_default.sample = collection_default_default.sample;
  wrapperLodash_default.size = collection_default_default.size;
  wrapperLodash_default.snakeCase = string_default_default.snakeCase;
  wrapperLodash_default.some = collection_default_default.some;
  wrapperLodash_default.sortedIndex = array_default_default.sortedIndex;
  wrapperLodash_default.sortedIndexBy = array_default_default.sortedIndexBy;
  wrapperLodash_default.sortedIndexOf = array_default_default.sortedIndexOf;
  wrapperLodash_default.sortedLastIndex = array_default_default.sortedLastIndex;
  wrapperLodash_default.sortedLastIndexBy = array_default_default.sortedLastIndexBy;
  wrapperLodash_default.sortedLastIndexOf = array_default_default.sortedLastIndexOf;
  wrapperLodash_default.startCase = string_default_default.startCase;
  wrapperLodash_default.startsWith = string_default_default.startsWith;
  wrapperLodash_default.subtract = math_default_default.subtract;
  wrapperLodash_default.sum = math_default_default.sum;
  wrapperLodash_default.sumBy = math_default_default.sumBy;
  wrapperLodash_default.template = string_default_default.template;
  wrapperLodash_default.times = util_default_default.times;
  wrapperLodash_default.toFinite = lang_default_default.toFinite;
  wrapperLodash_default.toInteger = toInteger_default;
  wrapperLodash_default.toLength = lang_default_default.toLength;
  wrapperLodash_default.toLower = string_default_default.toLower;
  wrapperLodash_default.toNumber = lang_default_default.toNumber;
  wrapperLodash_default.toSafeInteger = lang_default_default.toSafeInteger;
  wrapperLodash_default.toString = lang_default_default.toString;
  wrapperLodash_default.toUpper = string_default_default.toUpper;
  wrapperLodash_default.trim = string_default_default.trim;
  wrapperLodash_default.trimEnd = string_default_default.trimEnd;
  wrapperLodash_default.trimStart = string_default_default.trimStart;
  wrapperLodash_default.truncate = string_default_default.truncate;
  wrapperLodash_default.unescape = string_default_default.unescape;
  wrapperLodash_default.uniqueId = util_default_default.uniqueId;
  wrapperLodash_default.upperCase = string_default_default.upperCase;
  wrapperLodash_default.upperFirst = string_default_default.upperFirst;
  wrapperLodash_default.each = collection_default_default.forEach;
  wrapperLodash_default.eachRight = collection_default_default.forEachRight;
  wrapperLodash_default.first = array_default_default.head;
  mixin2(wrapperLodash_default, function() {
    var source = {};
    baseForOwn_default(wrapperLodash_default, function(func, methodName) {
      if (!hasOwnProperty26.call(wrapperLodash_default.prototype, methodName)) {
        source[methodName] = func;
      }
    });
    return source;
  }(), { "chain": false });
  wrapperLodash_default.VERSION = VERSION;
  (wrapperLodash_default.templateSettings = string_default_default.templateSettings).imports._ = wrapperLodash_default;
  arrayEach_default(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
    wrapperLodash_default[methodName].placeholder = wrapperLodash_default;
  });
  arrayEach_default(["drop", "take"], function(methodName, index) {
    LazyWrapper_default.prototype[methodName] = function(n) {
      n = n === void 0 ? 1 : nativeMax17(toInteger_default(n), 0);
      var result2 = this.__filtered__ && !index ? new LazyWrapper_default(this) : this.clone();
      if (result2.__filtered__) {
        result2.__takeCount__ = nativeMin15(n, result2.__takeCount__);
      } else {
        result2.__views__.push({
          "size": nativeMin15(n, MAX_ARRAY_LENGTH7),
          "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
        });
      }
      return result2;
    };
    LazyWrapper_default.prototype[methodName + "Right"] = function(n) {
      return this.reverse()[methodName](n).reverse();
    };
  });
  arrayEach_default(["filter", "map", "takeWhile"], function(methodName, index) {
    var type = index + 1, isFilter = type == LAZY_FILTER_FLAG2 || type == LAZY_WHILE_FLAG;
    LazyWrapper_default.prototype[methodName] = function(iteratee2) {
      var result2 = this.clone();
      result2.__iteratees__.push({
        "iteratee": baseIteratee_default(iteratee2, 3),
        "type": type
      });
      result2.__filtered__ = result2.__filtered__ || isFilter;
      return result2;
    };
  });
  arrayEach_default(["head", "last"], function(methodName, index) {
    var takeName = "take" + (index ? "Right" : "");
    LazyWrapper_default.prototype[methodName] = function() {
      return this[takeName](1).value()[0];
    };
  });
  arrayEach_default(["initial", "tail"], function(methodName, index) {
    var dropName = "drop" + (index ? "" : "Right");
    LazyWrapper_default.prototype[methodName] = function() {
      return this.__filtered__ ? new LazyWrapper_default(this) : this[dropName](1);
    };
  });
  LazyWrapper_default.prototype.compact = function() {
    return this.filter(identity_default);
  };
  LazyWrapper_default.prototype.find = function(predicate) {
    return this.filter(predicate).head();
  };
  LazyWrapper_default.prototype.findLast = function(predicate) {
    return this.reverse().find(predicate);
  };
  LazyWrapper_default.prototype.invokeMap = baseRest_default(function(path, args) {
    if (typeof path == "function") {
      return new LazyWrapper_default(this);
    }
    return this.map(function(value) {
      return baseInvoke_default(value, path, args);
    });
  });
  LazyWrapper_default.prototype.reject = function(predicate) {
    return this.filter(negate_default(baseIteratee_default(predicate)));
  };
  LazyWrapper_default.prototype.slice = function(start, end) {
    start = toInteger_default(start);
    var result2 = this;
    if (result2.__filtered__ && (start > 0 || end < 0)) {
      return new LazyWrapper_default(result2);
    }
    if (start < 0) {
      result2 = result2.takeRight(-start);
    } else if (start) {
      result2 = result2.drop(start);
    }
    if (end !== void 0) {
      end = toInteger_default(end);
      result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
    }
    return result2;
  };
  LazyWrapper_default.prototype.takeRightWhile = function(predicate) {
    return this.reverse().takeWhile(predicate).reverse();
  };
  LazyWrapper_default.prototype.toArray = function() {
    return this.take(MAX_ARRAY_LENGTH7);
  };
  baseForOwn_default(LazyWrapper_default.prototype, function(func, methodName) {
    var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = wrapperLodash_default[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
    if (!lodashFunc) {
      return;
    }
    wrapperLodash_default.prototype[methodName] = function() {
      var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper_default, iteratee2 = args[0], useLazy = isLazy || isArray_default(value);
      var interceptor = function(value2) {
        var result3 = lodashFunc.apply(wrapperLodash_default, arrayPush_default([value2], args));
        return isTaker && chainAll ? result3[0] : result3;
      };
      if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
        isLazy = useLazy = false;
      }
      var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
      if (!retUnwrapped && useLazy) {
        value = onlyLazy ? value : new LazyWrapper_default(this);
        var result2 = func.apply(value, args);
        result2.__actions__.push({ "func": thru_default, "args": [interceptor], "thisArg": void 0 });
        return new LodashWrapper_default(result2, chainAll);
      }
      if (isUnwrapped && onlyLazy) {
        return func.apply(this, args);
      }
      result2 = this.thru(interceptor);
      return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
    };
  });
  arrayEach_default(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
    var func = arrayProto6[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
    wrapperLodash_default.prototype[methodName] = function() {
      var args = arguments;
      if (retUnwrapped && !this.__chain__) {
        var value = this.value();
        return func.apply(isArray_default(value) ? value : [], args);
      }
      return this[chainName](function(value2) {
        return func.apply(isArray_default(value2) ? value2 : [], args);
      });
    };
  });
  baseForOwn_default(LazyWrapper_default.prototype, function(func, methodName) {
    var lodashFunc = wrapperLodash_default[methodName];
    if (lodashFunc) {
      var key = lodashFunc.name + "";
      if (!hasOwnProperty26.call(realNames_default, key)) {
        realNames_default[key] = [];
      }
      realNames_default[key].push({ "name": methodName, "func": lodashFunc });
    }
  });
  realNames_default[createHybrid_default(void 0, WRAP_BIND_KEY_FLAG7).name] = [{
    "name": "wrapper",
    "func": void 0
  }];
  LazyWrapper_default.prototype.clone = lazyClone_default;
  LazyWrapper_default.prototype.reverse = lazyReverse_default;
  LazyWrapper_default.prototype.value = lazyValue_default;
  wrapperLodash_default.prototype.at = seq_default_default.at;
  wrapperLodash_default.prototype.chain = seq_default_default.wrapperChain;
  wrapperLodash_default.prototype.commit = seq_default_default.commit;
  wrapperLodash_default.prototype.next = seq_default_default.next;
  wrapperLodash_default.prototype.plant = seq_default_default.plant;
  wrapperLodash_default.prototype.reverse = seq_default_default.reverse;
  wrapperLodash_default.prototype.toJSON = wrapperLodash_default.prototype.valueOf = wrapperLodash_default.prototype.value = seq_default_default.value;
  wrapperLodash_default.prototype.first = wrapperLodash_default.prototype.head;
  if (symIterator2) {
    wrapperLodash_default.prototype[symIterator2] = seq_default_default.toIterator;
  }
  var lodash_default_default = wrapperLodash_default;

  // ../../packages/shared/es/index.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/index.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-action-content-object.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-object.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isObject2(obj) {
    return obj && typeof obj === "object";
  }

  // ../../packages/shared/es/check-types/is-dom-text.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isDOMText(data) {
    return typeof data === "string";
  }

  // ../../packages/shared/es/check-types/is-i18n-data.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isI18nData(obj) {
    if (!isObject2(obj)) {
      return false;
    }
    return obj.type === "i18n";
  }

  // ../../packages/shared/es/check-types/is-jsblock.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-jsexpression.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isJSExpression(data) {
    if (!isObject2(data)) {
      return false;
    }
    return data.type === "JSExpression" && data.extType !== "function";
  }

  // ../../packages/shared/es/check-types/is-isfunction.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isInnerJsFunction(data) {
    if (!isObject2(data)) {
      return false;
    }
    return data.type === "JSExpression" && data.extType === "function";
  }
  function isJSFunction(data) {
    if (!isObject2(data)) {
      return false;
    }
    return data.type === "JSFunction" || isInnerJsFunction(data);
  }

  // ../../packages/shared/es/check-types/is-jsslot.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isJSSlot(data) {
    if (!isObject2(data)) {
      return false;
    }
    return data.type === "JSSlot";
  }

  // ../../packages/shared/es/check-types/is-lowcode-component-type.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-procode-component-type.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-node-schema.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isNodeSchema(data) {
    if (!isObject2(data)) {
      return false;
    }
    return "componentName" in data && !data.isNode;
  }

  // ../../packages/shared/es/check-types/is-project-schema.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-title-config.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/is-plain-object.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/is-object.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-drag-node-data-object.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/index.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/@alilc+lowcode-datasource-types@1.2.1/node_modules/@alilc/lowcode-datasource-types/es/index.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/@alilc+lowcode-datasource-types@1.2.1/node_modules/@alilc/lowcode-datasource-types/es/data-source.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var RuntimeDataSourceStatus;
  (function(RuntimeDataSourceStatus2) {
    RuntimeDataSourceStatus2["Initial"] = "init";
    RuntimeDataSourceStatus2["Loading"] = "loading";
    RuntimeDataSourceStatus2["Loaded"] = "loaded";
    RuntimeDataSourceStatus2["Error"] = "error";
  })(RuntimeDataSourceStatus || (RuntimeDataSourceStatus = {}));

  // ../../node_modules/.pnpm/@alilc+lowcode-datasource-types@1.2.1/node_modules/@alilc/lowcode-datasource-types/es/data-source-handlers.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/@alilc+lowcode-datasource-types@1.2.1/node_modules/@alilc/lowcode-datasource-types/es/data-source-interpret.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/@alilc+lowcode-datasource-types@1.2.1/node_modules/@alilc/lowcode-datasource-types/es/data-source-runtime.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/@alilc+lowcode-datasource-types@1.2.1/node_modules/@alilc/lowcode-datasource-types/es/value-type.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/@alilc+lowcode-datasource-types@1.2.1/node_modules/@alilc/lowcode-datasource-types/es/ExtraConfig.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/editor.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/activity.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/code-intermediate.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/code-result.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/assets.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var AssetLevel = /* @__PURE__ */ function(AssetLevel2) {
    AssetLevel2[AssetLevel2["Environment"] = 1] = "Environment";
    AssetLevel2[AssetLevel2["Library"] = 2] = "Library";
    AssetLevel2[AssetLevel2["Theme"] = 3] = "Theme";
    AssetLevel2[AssetLevel2["Runtime"] = 4] = "Runtime";
    AssetLevel2[AssetLevel2["Components"] = 5] = "Components";
    AssetLevel2[AssetLevel2["App"] = 6] = "App";
    return AssetLevel2;
  }({});
  var AssetLevels = [AssetLevel.Environment, AssetLevel.Library, AssetLevel.Theme, AssetLevel.Runtime, AssetLevel.Components, AssetLevel.App];

  // ../../packages/types/es/event/index.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/event/node.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/event/prop.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/index.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/index.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/location.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/active-target.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/component-instance.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/node-schema.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/disposable.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/assets-json.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/metadata-transducer.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/component-action.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/preference-value-type.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/project-schema.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/block-schema.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/component-schema.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/container-schema.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/page-schema.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/root-schema.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/props-transducer.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/registered-setter.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/custom-view.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/widget-base-config.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/node-data.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/icon-type.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/transformed-component-metadata.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/i8n-data.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/npm-info.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/drag-node-data-object.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/drag-node-object.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/prop-change-options.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/drag-any-object.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/drag-object.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/composite-value.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/props-map.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/props-list.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/plugin-config.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/plugin-declaration-property.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/plugin-declaration.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/plugin-meta.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/plugin-creater.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/plugin.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/setter-type.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/set-value-options.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/field-config.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/field-extra-props.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/component-sort.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/component-metadata.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/reference.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/component-description.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/remote-component-description.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/package.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/action-content-object.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/title-config.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/title-content.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/prop-config.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/prop-types.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/snippet.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/advanced.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/configure.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/value-type.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/tip-content.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/metadata.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/dynamic-setter.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/icon-config.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/dom-text.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/i18n-map.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/app-config.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/npm.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/dynamic-props.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ignore:./setter-config
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/tip-config.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/widget-config-area.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/hotkey-callback.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/plugin-register-options.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/resource-list.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/engine-options.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/on-change-options.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/slot-schema.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/node-data-type.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/node-instance.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/editor-value-key.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/editor-get-options.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/editor-get-result.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/editor-register-options.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/editor-view.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/resource-type.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/resource-type-config.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/editor-view-config.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/hotkey-callback-config.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/hotkey-callbacks.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/scrollable.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/simulator-renderer.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/config-transducer.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/context-menu.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/type/command.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/api/index.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/api/common.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/api/event.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/api/hotkey.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/api/material.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/api/project.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/api/setters.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/api/simulator-host.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/api/skeleton.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/api/plugins.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/api/logger.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/api/canvas.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/api/workspace.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/api/commonUI.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/api/command.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/index.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/component-meta.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/detecting.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/document-model.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/drag-object.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/dragon.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/drop-location.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/history.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/locate-event.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/modal-nodes-manager.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/node-children.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/node.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/prop.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/props.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/selection.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/setting-prop-entry.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/setting-top-entry.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/window.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/scroll-target.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/scroller.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/active-tracker.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/exclusive-group.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/plugin-context.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/setting-target.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/engine-config.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/editor.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/preference.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/plugin-instance.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/sensor.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/resource.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/clipboard.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/setting-field.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/editor-view.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/skeleton-item.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/model/simulator-render.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/enum/index.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/enum/event-names.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/enum/transition-type.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/enum/transform-stage.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/enum/drag-object-type.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/enum/prop-value-changed-type.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/enum/plugin-register-level.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell/enum/context-menu.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/shell-model-factory.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/types/es/core-model-factory.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-drag-node-object.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-drag-any-object.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-location-children-detail.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-node.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-location-data.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-setting-field.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-lowcode-project-schema.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-component-schema.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-basic-prop-type.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../packages/shared/es/check-types/is-required-prop-type.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/utils/common.ts
  var common_exports = {};
  __export(common_exports, {
    camel2dash: () => camel2dash,
    camelize: () => camelize,
    generateID: () => generateID,
    getStaticExprValue: () => getStaticExprValue,
    isExternalDependency: () => isExternalDependency,
    isInternalDependency: () => isInternalDependency,
    isJSExpressionFn: () => isJSExpressionFn,
    isJSExpressionSpread: () => isJSExpressionSpread,
    uniqueArray: () => uniqueArray,
    upperCaseFirst: () => upperCaseFirst
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var import_change_case = __toESM(require_change_case());
  var import_short_uuid = __toESM(require_short_uuid());
  function camel2dash(input) {
    return import_change_case.default.paramCase(input);
  }
  function camelize(str) {
    return import_change_case.default.camelCase(str);
  }
  function generateID() {
    return import_short_uuid.default.generate();
  }
  function upperCaseFirst(inputValue) {
    return import_change_case.default.upperCaseFirst(inputValue);
  }
  function uniqueArray(arr, by) {
    const map2 = {};
    arr.forEach((item) => {
      map2[by(item)] = item;
    });
    const uniqueKeys = Array.from(new Set(Object.keys(map2)));
    const uniqueItems = uniqueKeys.map((key) => map2[key]);
    return uniqueItems;
  }
  function getStaticExprValue(expr) {
    return Function(`"use strict";return (${expr})`)();
  }
  function isJSExpressionFn(data) {
    return (data == null ? void 0 : data.type) === "JSExpression" && (data == null ? void 0 : data.extType) === "function";
  }
  function isJSExpressionSpread(data) {
    return (data == null ? void 0 : data.type) === "JSExpression" && (data == null ? void 0 : data.extType) === "spread";
  }
  function isInternalDependency(dependency) {
    return dependency.dependencyType === "Internal" /* Internal */;
  }
  function isExternalDependency(dependency) {
    return dependency.dependencyType === "External" /* External */;
  }

  // src/utils/schema.ts
  function isContainerSchema(x) {
    return typeof x === "object" && x && typeof x.componentName === "string" && typeof x.fileName === "string";
  }
  function isNpmInfo(x) {
    return typeof x === "object" && x && typeof x.package === "string";
  }
  var noop3 = () => void 0;
  var handleChildrenDefaultOptions = {
    rerun: false
  };
  var DEFAULT_MAX_DEPTH = 1e5;
  function handleSubNodes(children, handlers, options) {
    var _a;
    const opt = {
      ...handleChildrenDefaultOptions,
      ...options || {}
    };
    const maxDepth = (_a = opt.maxDepth) != null ? _a : DEFAULT_MAX_DEPTH;
    if (maxDepth <= 0) {
      throw new Error("handleSubNodes maxDepth reached");
    }
    if (Array.isArray(children)) {
      const list = children;
      return list.map((child) => handleSubNodes(child, handlers, { ...opt, maxDepth: maxDepth - 1 })).reduce((p, c) => p.concat(c), []);
    }
    let result2;
    const childrenRes = [];
    if (children === null || children === void 0) {
      return [];
    } else if (isDOMText(children)) {
      const handler = handlers.string || noop3;
      result2 = handler(children);
    } else if (isJSExpression(children)) {
      const handler = handlers.expression || noop3;
      result2 = handler(children);
    } else if (isJSSlot(children)) {
      return handleSubNodes(children.value, handlers, { ...opt, maxDepth: maxDepth - 1 });
    } else if (isNodeSchema(children)) {
      const handler = handlers.node || noop3;
      const child = children;
      result2 = handler(child);
      if (child.children) {
        const childRes = handleSubNodes(child.children, handlers, opt);
        childrenRes.push(...childRes);
      }
      if (child.props) {
        if (Array.isArray(child.props)) {
          child.props.forEach(({ value }) => {
            const childRes = handleCompositeValueInProps(value);
            childrenRes.push(...childRes);
          });
        } else {
          Object.values(child.props).forEach((value) => {
            const childRes = handleCompositeValueInProps(value);
            childrenRes.push(...childRes);
          });
        }
      }
    } else if (isI18nData(children)) {
      const i18nObj = children;
      const text = i18nObj["zh-CN"] || i18nObj.use && i18nObj[i18nObj.use] || i18nObj["en-US"] || "";
      const handler = handlers.string || noop3;
      result2 = handler(text);
    } else {
      throw new CodeGeneratorError("handleSubNodes got invalid NodeData", children);
    }
    if (result2 !== void 0) {
      childrenRes.unshift(result2);
    }
    return childrenRes;
    function handleCompositeValueInProps(value) {
      if (isJSSlot(value)) {
        return handleSubNodes(value.value, handlers, { ...opt, maxDepth: maxDepth - 1 });
      }
      if (Array.isArray(value)) {
        return flatMap_default(value, (v) => handleCompositeValueInProps(v));
      }
      if (!isJSExpression(value) && !isJSExpressionFn(value) && !isJSFunction(value) && typeof value === "object" && value !== null) {
        return flatMap_default(Object.values(value), (v) => handleCompositeValueInProps(v));
      }
      return [];
    }
  }
  function isValidContainerType(schema) {
    return ["Page", "Component", "Block"].includes(schema.componentName);
  }
  var ContainerType = /* @__PURE__ */ ((ContainerType2) => {
    ContainerType2["Page"] = "Page";
    ContainerType2["Component"] = "Component";
    ContainerType2["Block"] = "Block";
    return ContainerType2;
  })(ContainerType || {});

  // src/analyzer/componentAnalyzer.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var componentAnalyzer = (container) => {
    let hasRefAttr = false;
    const nodeValidator = (n) => {
      if (n.props) {
        const props = n.props;
        if (props.ref) {
          hasRefAttr = true;
        }
      }
    };
    nodeValidator(container);
    if (!hasRefAttr && container.children) {
      handleSubNodes(
        container.children,
        {
          node: nodeValidator
        },
        {
          rerun: true
        }
      );
    }
    return {
      isUsingRef: hasRefAttr
    };
  };

  // src/utils/validate.ts
  var validate_exports = {};
  __export(validate_exports, {
    ensureValidClassName: () => ensureValidClassName,
    isValidComponentName: () => isValidComponentName,
    isValidIdentifier: () => isValidIdentifier
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var isValidIdentifier = (name) => {
    return /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/.test(name);
  };
  var isValidComponentName = (name) => {
    return /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF.]*$/.test(name);
  };
  var ensureValidClassName = (name) => {
    if (!isValidIdentifier(name)) {
      return `$${name.replace(/[^_$a-zA-Z0-9]/g, "")}`;
    }
    return name;
  };

  // src/parser/SchemaParser.ts
  var defaultContainer = {
    containerType: "Component",
    componentName: "Component",
    moduleName: "Index",
    fileName: "Index",
    css: "",
    props: {}
  };
  function getRootComponentName(typeName, maps) {
    if (maps[typeName]) {
      const rec = maps[typeName];
      if (rec.destructuring) {
        return rec.componentName || typeName;
      }
      const peerName = Object.keys(maps).find((depName) => {
        const depInfo = maps[depName];
        return depName !== typeName && !depInfo.destructuring && depInfo.package === rec.package && depInfo.version === rec.version && depInfo.main === rec.main && depInfo.exportName === rec.exportName && depInfo.subName === rec.subName;
      });
      return peerName || typeName;
    }
    return typeName;
  }
  function processChildren(schema) {
    if (schema.props) {
      if (Array.isArray(schema.props)) {
      } else {
        const nodeProps = schema.props;
        if (nodeProps.children) {
          if (!schema.children) {
            schema.children = nodeProps.children;
          } else {
            let _children = [];
            if (Array.isArray(schema.children)) {
              _children = _children.concat(schema.children);
            } else {
              _children.push(schema.children);
            }
            if (Array.isArray(nodeProps.children)) {
              _children = _children.concat(nodeProps.children);
            } else {
              _children.push(nodeProps.children);
            }
            schema.children = _children;
          }
          delete nodeProps.children;
        }
      }
    }
  }
  function getInternalDep(internalDeps, depName) {
    const dep = internalDeps[depName];
    return dep && dep.type !== "pages" /* PAGE */ ? dep : null;
  }
  var SchemaParser = class {
    validate(schema) {
      if (SUPPORT_SCHEMA_VERSION_LIST.indexOf(schema.version) < 0) {
        throw new CompatibilityError(`Not support schema with version [${schema.version}]`);
      }
      return true;
    }
    parse(schemaSrc) {
      const compDeps = {};
      const internalDeps = {};
      let utilsDeps = [];
      const schema = this.decodeSchema(schemaSrc);
      schema.componentsMap.forEach((info) => {
        var _a, _b;
        if (info.componentName) {
          compDeps[info.componentName] = {
            ...info,
            dependencyType: "External" /* External */,
            componentName: info.componentName,
            exportName: (_a = info.exportName) != null ? _a : info.componentName,
            version: info.version || "*",
            destructuring: (_b = info.destructuring) != null ? _b : false
          };
        }
      });
      let containers;
      if (schema.componentsTree.length > 0) {
        const firstRoot = schema.componentsTree[0];
        if (!firstRoot.fileName && !isValidContainerType(firstRoot)) {
          const container = {
            ...firstRoot,
            ...defaultContainer,
            props: firstRoot.props || defaultContainer.props,
            css: firstRoot.css || defaultContainer.css,
            moduleName: firstRoot.moduleName || defaultContainer.moduleName,
            children: schema.componentsTree
          };
          containers = [container];
        } else {
          containers = schema.componentsTree.map((n) => {
            const subRoot = n;
            let fileName = subRoot.fileName;
            let modulePaths = [];
            if (subRoot.fileName.includes("/")) {
              const paths = subRoot.fileName.split("/");
              modulePaths = paths;
              fileName = paths.pop();
            }
            const container = {
              ...subRoot,
              componentName: getRootComponentName(subRoot.componentName, compDeps),
              containerType: subRoot.componentName,
              modulePaths,
              moduleName: ensureValidClassName(
                subRoot.componentName === "Component" /* Component */ ? fileName : fileName
              )
            };
            return container;
          });
        }
      } else {
        throw new CodeGeneratorError("Can't find anything to generate.");
      }
      containers = containers.map((con) => ({
        ...con,
        analyzeResult: componentAnalyzer(con)
      }));
      containers.forEach((container) => {
        let type;
        switch (container.containerType) {
          case "Page":
            type = "pages" /* PAGE */;
            break;
          case "Block":
            type = "components" /* BLOCK */;
            break;
          default:
            type = "components" /* COMPONENT */;
            break;
        }
        const dep = {
          type,
          moduleName: container.moduleName,
          destructuring: false,
          exportName: container.moduleName,
          dependencyType: "Internal" /* Internal */
        };
        internalDeps[dep.moduleName] = dep;
      });
      const containersDeps = [].concat(...containers.map((c) => c.deps || []));
      containers.forEach((container) => {
        if (container.children) {
          handleSubNodes(
            container.children,
            {
              node: (i) => processChildren(i)
            },
            {
              rerun: true
            }
          );
        }
      });
      containers.forEach((container) => {
        const depNames = this.getComponentNames(container);
        container.deps = uniqueArray(depNames, (i) => i).map((depName) => getInternalDep(internalDeps, depName) || compDeps[depName]).filter(Boolean);
      });
      const routes = containers.filter((container) => container.containerType === "Page").map((page) => {
        const { meta } = page;
        const moduleName = page.modulePaths && page.modulePaths.length > 0 ? page.modulePaths.concat(page.moduleName).join("/") : page.moduleName;
        if (meta) {
          return {
            path: meta.router || `/${page.moduleName}`,
            fileName: meta.name || page.fileName,
            fileType: meta.fileType || page.fileType,
            componentName: moduleName,
            title: page.title
          };
        }
        return {
          path: page.moduleName,
          fileName: page.fileName,
          fileType: page.fileType,
          componentName: moduleName,
          title: page.title
        };
      });
      const routerDeps = routes.map((r) => internalDeps[r.componentName] || compDeps[r.componentName]).filter((dep) => !!dep);
      let utils;
      if (schema.utils) {
        utils = schema.utils;
        utilsDeps = schema.utils.filter(
          (u) => u.type !== "function"
        ).map(
          (u) => {
            var _a, _b;
            return {
              ...u.content,
              componentName: u.name,
              version: u.content.version || "*",
              destructuring: (_a = u.content.destructuring) != null ? _a : false,
              exportName: (_b = u.content.exportName) != null ? _b : u.name
            };
          }
        );
      } else {
        utils = [];
      }
      let npms = [];
      containers.forEach((con) => {
        const p = (con.deps || []).map((dep) => {
          return dep.dependencyType === "External" /* External */ ? dep : null;
        }).filter((dep) => dep !== null);
        const npmInfos = p.filter(Boolean).map((i) => ({
          package: i.package,
          version: i.version
        }));
        npms.push(...npmInfos);
      });
      npms.push(
        ...utilsDeps.map((utilsDep) => ({
          package: utilsDep.package,
          version: utilsDep.version
        }))
      );
      npms = uniqueArray(npms, (i) => i.package).filter(Boolean);
      return {
        containers,
        globalUtils: {
          utils,
          deps: utilsDeps
        },
        globalI18n: schema.i18n,
        globalRouter: {
          routes,
          deps: routerDeps
        },
        project: {
          css: schema.css,
          constants: schema.constants,
          config: schema.config || {},
          meta: schema.meta || {},
          i18n: schema.i18n,
          containersDeps,
          utilsDeps,
          packages: npms || [],
          dataSourcesTypes: this.collectDataSourcesTypes(schema),
          projectRemark: this.getProjectRemark(containers)
        }
      };
    }
    getProjectRemark(containers) {
      return {
        isSingleComponent: containers.length === 1 && containers[0].containerType === "Component"
      };
    }
    getComponentNames(children) {
      return handleSubNodes(
        children,
        {
          node: (i) => i.componentName
        },
        {
          rerun: true
        }
      );
    }
    decodeSchema(schemaSrc) {
      let schema;
      if (typeof schemaSrc === "string") {
        try {
          schema = JSON.parse(schemaSrc);
        } catch (error) {
          throw new CodeGeneratorError(
            `Parse schema failed: ${getErrorMessage(error) || "unknown reason"}`
          );
        }
      } else {
        schema = schemaSrc;
      }
      return schema;
    }
    collectDataSourcesTypes(schema) {
      var _a, _b;
      const dataSourcesTypes = /* @__PURE__ */ new Set();
      const defaultDataSourceType = "fetch";
      (_b = (_a = schema.dataSource) == null ? void 0 : _a.list) == null ? void 0 : _b.forEach((ds) => {
        dataSourcesTypes.add(ds.type || defaultDataSourceType);
      });
      schema.componentsTree.forEach((rootNode) => {
        var _a2, _b2;
        (_b2 = (_a2 = rootNode.dataSource) == null ? void 0 : _a2.list) == null ? void 0 : _b2.forEach((ds) => {
          dataSourcesTypes.add(ds.type || defaultDataSourceType);
        });
      });
      return Array.from(dataSourcesTypes.values());
    }
  };

  // src/utils/resultHelper.ts
  var resultHelper_exports = {};
  __export(resultHelper_exports, {
    addDirectory: () => addDirectory,
    addFile: () => addFile,
    addFileByPath: () => addFileByPath,
    createResultDir: () => createResultDir,
    createResultFile: () => createResultFile,
    findDir: () => findDir,
    findFile: () => findFile,
    flattenResult: () => flattenResult,
    getFileNameWithExt: () => getFileNameWithExt,
    globDirs: () => globDirs,
    globFiles: () => globFiles,
    mergeJSON: () => mergeJSON,
    removeDirsFromResult: () => removeDirsFromResult,
    removeFilesFromResult: () => removeFilesFromResult,
    scanDirs: () => scanDirs,
    scanFiles: () => scanFiles
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var import_nanomatch = __toESM(require_nanomatch());
  function createResultFile(name, ext = "jsx", content = "") {
    return {
      name,
      ext,
      content
    };
  }
  function createResultDir(name) {
    return {
      name,
      dirs: [],
      files: []
    };
  }
  function addDirectory(target, dir) {
    const _dir = target.dirs.find((d) => d.name === dir.name);
    if (!_dir) {
      target.dirs.push(dir);
    } else {
      return _dir;
    }
    return dir;
  }
  function customizer(objValue, srcValue) {
    if (isArray_default(objValue) && isArray_default(srcValue)) {
      return union_default(objValue, srcValue);
    }
    if (isObject_default(objValue) && isObject_default(srcValue)) {
      return mergeWith_default(objValue, srcValue, customizer);
    }
    return srcValue;
  }
  var mergeJSON = (object1, object2) => {
    return { ...mergeWith_default(object1, object2, customizer) };
  };
  function addFile(target, file2) {
    if (target.files.findIndex((f) => f.name === file2.name && f.ext === file2.ext) < 0) {
      target.files.push(file2);
    } else {
      if (file2.ext === "json") {
        const targetFile = target.files.find((f) => f.name === file2.name && f.ext === file2.ext);
        const content = JSON.stringify(mergeJSON(JSON.parse(targetFile.content), JSON.parse(file2.content)), null, 2);
        targetFile.content = content;
      } else {
        throw new CodeGeneratorError(
          `Adding same file to one directory: ${file2.name} -> ${target.name}`
        );
      }
    }
  }
  function addFileByPath(target, file2) {
    const parts = file2.name.split("/");
    if (parts.length === 1) {
      addFile(target, file2);
      return;
    }
    const dirParts = parts.slice(0, -1);
    const fileName = parts[parts.length - 1];
    let current = target;
    for (const part of dirParts) {
      const existing = current.dirs.find((d) => d.name === part);
      if (existing) {
        current = existing;
      } else {
        const newDir = createResultDir(part);
        addDirectory(current, newDir);
        current = newDir;
      }
    }
    addFile(current, { ...file2, name: fileName });
  }
  function flattenResult(dir, cwd3 = "") {
    if (!dir.files.length && !dir.dirs.length) {
      return [];
    }
    return [
      ...dir.files.map(
        (file2) => ({
          pathName: joinPath(cwd3, `${file2.name}${file2.ext ? `.${file2.ext}` : ""}`),
          content: file2.content
        })
      )
    ].concat(...dir.dirs.map((subDir) => flattenResult(subDir, joinPath(cwd3, subDir.name))));
  }
  function findFile(result2, fileGlobExpr, options = {}, resultDirPath = getResultNameOrDefault(result2, "")) {
    const maxDepth = !/\/|\*\*/.test(fileGlobExpr) ? 1 : void 0;
    const files = scanFiles(result2, resultDirPath, maxDepth);
    for (let [filePath, file2] of files) {
      if (import_nanomatch.default.isMatch(filePath, fileGlobExpr, options)) {
        return file2;
      }
    }
    return null;
  }
  function* globFiles(result2, fileGlobExpr, options = {}, resultDirPath = getResultNameOrDefault(result2, "")) {
    const files = scanFiles(result2, resultDirPath);
    for (let [filePath, file2] of files) {
      if (import_nanomatch.default.isMatch(filePath, fileGlobExpr, options)) {
        yield [filePath, file2];
      }
    }
  }
  function* scanFiles(result2, resultDirPath = getResultNameOrDefault(result2, ""), maxDepth = 1e4) {
    for (let file2 of result2.files) {
      const fileName = getFileNameWithExt(file2);
      yield [joinPath(resultDirPath, fileName), file2];
    }
    for (let subDir of result2.dirs) {
      yield* scanFiles(subDir, joinPath(resultDirPath, subDir.name), maxDepth - 1);
    }
  }
  function getFileNameWithExt(file2) {
    return `${file2.name}${file2.ext ? `.${file2.ext}` : ""}`;
  }
  function getResultNameOrDefault(result2, defaultDir = "/") {
    return result2.name && result2.name !== "." ? result2.name : defaultDir;
  }
  function joinPath(...pathParts) {
    return pathParts.filter((x) => x !== "" && x !== ".").join("/").replace(/\\+/g, "/").replace(/\/+/g, "/");
  }
  function* scanDirs(result2, resultDirPath = getResultNameOrDefault(result2, ""), maxDepth = 1e4) {
    yield [resultDirPath, result2];
    for (let subDir of result2.dirs) {
      yield* scanDirs(subDir, joinPath(resultDirPath, subDir.name), maxDepth - 1);
    }
  }
  function* globDirs(result2, dirGlobExpr, options = {}, resultDirPath = getResultNameOrDefault(result2, "")) {
    const dirs = scanDirs(result2, resultDirPath);
    for (let [dirPath, dir] of dirs) {
      if (import_nanomatch.default.isMatch(dirPath, dirGlobExpr, options)) {
        yield [dirPath, dir];
      }
    }
  }
  function findDir(result2, dirGlobExpr, options = {}, resultDirPath = getResultNameOrDefault(result2, "")) {
    const dirs = scanDirs(result2, resultDirPath);
    for (let [dirPath, dir] of dirs) {
      if (import_nanomatch.default.isMatch(dirPath, dirGlobExpr, options)) {
        return dir;
      }
    }
    return null;
  }
  function removeFilesFromResult(result2, filePathGlobExpr, globOptions = {}) {
    let removedCount = 0;
    const [dirPath, fileName] = splitPath(filePathGlobExpr);
    const dirs = dirPath ? globDirs(result2, dirPath) : [["", result2]];
    for (let [, dir] of dirs) {
      const files = globFiles(dir, fileName, globOptions, ".");
      for (let [, file2] of files) {
        dir.files.splice(dir.files.indexOf(file2), 1);
        removedCount += 1;
      }
    }
    return removedCount;
  }
  function removeDirsFromResult(result2, dirPathGlobExpr, globOptions = {}) {
    let removedCount = 0;
    const [dirPath, fileName] = splitPath(dirPathGlobExpr);
    const dirs = dirPath ? globDirs(result2, dirPath) : [["", result2]];
    for (let [, dir] of dirs) {
      const foundDirs = globDirs(dir, fileName, globOptions, ".");
      for (let [, foundDir] of foundDirs) {
        dir.dirs.splice(dir.dirs.indexOf(foundDir), 1);
        removedCount += 1;
      }
    }
    return removedCount;
  }
  function splitPath(filePath) {
    const parts = filePath.split("/");
    const fileName = parts.pop() || "";
    return [joinPath(...parts), fileName];
  }

  // src/generator/ModuleBuilder.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/generator/ChunkBuilder.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var IMPORT_RE = /import\s+([\s\S]*?)\s+from\s+['"](.*?)['"]\s*;/g;
  function parseImportStatements(content) {
    const result2 = /* @__PURE__ */ new Map();
    IMPORT_RE.lastIndex = 0;
    let match = IMPORT_RE.exec(content);
    while (match !== null) {
      const specifiers = match[1].trim();
      const pkg = match[2];
      const existing = result2.get(pkg) || {
        defaultImport: null,
        namespaceImport: null,
        namedImports: /* @__PURE__ */ new Set()
      };
      const nsMatch = specifiers.match(/\*\s+as\s+(\w+)/);
      if (nsMatch) {
        existing.namespaceImport = nsMatch[1];
      } else {
        const namedMatch = specifiers.match(/\{([^}]*)\}/);
        if (namedMatch) {
          namedMatch[1].split(",").map((s) => s.trim()).filter(Boolean).forEach((name) => existing.namedImports.add(name));
          const before2 = specifiers.substring(0, specifiers.indexOf("{"));
          const defaultName = before2.replace(/,\s*$/, "").trim();
          if (defaultName) {
            existing.defaultImport = defaultName;
          }
        } else {
          existing.defaultImport = specifiers;
        }
      }
      result2.set(pkg, existing);
      match = IMPORT_RE.exec(content);
    }
    return result2;
  }
  function renderImportEntry(pkg, spec) {
    const parts = [];
    if (spec.defaultImport && spec.namedImports.size > 0) {
      const names = Array.from(spec.namedImports).join(", ");
      parts.push(`import ${spec.defaultImport}, { ${names} } from '${pkg}';`);
    } else if (spec.defaultImport) {
      parts.push(`import ${spec.defaultImport} from '${pkg}';`);
    } else if (spec.namedImports.size > 0) {
      const names = Array.from(spec.namedImports).join(", ");
      parts.push(`import { ${names} } from '${pkg}';`);
    }
    if (spec.namespaceImport) {
      parts.push(`import * as ${spec.namespaceImport} from '${pkg}';`);
    }
    return parts.join("\n");
  }
  function consolidateExternalImports(chunks, subModule) {
    const targetIndices = [];
    let templateChunk = null;
    for (let i = 0; i < chunks.length; i++) {
      const c = chunks[i];
      const sm = c.subModule || COMMON_SUB_MODULE_NAME;
      if (c.name === COMMON_CHUNK_NAME.ExternalDepsImport && sm === subModule) {
        targetIndices.push(i);
        if (!templateChunk)
          templateChunk = c;
      }
    }
    if (targetIndices.length <= 1 || !templateChunk)
      return;
    const merged = /* @__PURE__ */ new Map();
    for (const idx of targetIndices) {
      const parsed = parseImportStatements(String(chunks[idx].content));
      for (const [pkg, spec] of parsed) {
        const existing = merged.get(pkg) || {
          defaultImport: null,
          namespaceImport: null,
          namedImports: /* @__PURE__ */ new Set()
        };
        if (spec.defaultImport)
          existing.defaultImport = spec.defaultImport;
        if (spec.namespaceImport)
          existing.namespaceImport = spec.namespaceImport;
        spec.namedImports.forEach((n) => existing.namedImports.add(n));
        merged.set(pkg, existing);
      }
    }
    for (let i = targetIndices.length - 1; i >= 0; i--) {
      chunks.splice(targetIndices[i], 1);
    }
    const content = Array.from(merged.entries()).map(([pkg, spec]) => renderImportEntry(pkg, spec)).filter(Boolean).join("\n");
    if (content) {
      chunks.push({
        type: "string" /* STRING */,
        fileType: templateChunk.fileType,
        subModule,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `${content}
`,
        linkAfter: []
      });
    }
  }
  function whichFamily(type) {
    const idx = FILE_TYPE_FAMILY.findIndex((family) => family.indexOf(type) >= 0);
    if (idx < 0) {
      return void 0;
    }
    return [idx, FILE_TYPE_FAMILY[idx]];
  }
  var groupChunks = (chunks) => {
    const tmp = {};
    const col = chunks.reduce((chunksSet, chunk2) => {
      const fileKey = chunk2.subModule || COMMON_SUB_MODULE_NAME;
      if (!chunksSet[fileKey]) {
        chunksSet[fileKey] = [];
      }
      const res = whichFamily(chunk2.fileType);
      const info = {
        chunk: chunk2
      };
      if (res) {
        const [familyIdx, family] = res;
        const rank = family.indexOf(chunk2.fileType);
        if (tmp[fileKey]) {
          if (tmp[fileKey][familyIdx] !== void 0) {
            if (tmp[fileKey][familyIdx] > rank) {
              tmp[fileKey][familyIdx] = rank;
            }
          } else {
            tmp[fileKey][familyIdx] = rank;
          }
        } else {
          tmp[fileKey] = {};
          tmp[fileKey][familyIdx] = rank;
        }
        info.familyIdx = familyIdx;
      }
      chunksSet[fileKey].push(info);
      return chunksSet;
    }, {});
    const result2 = [];
    Object.keys(col).forEach((key) => {
      const byType = {};
      col[key].forEach((info) => {
        let t3 = info.chunk.fileType;
        if (info.familyIdx !== void 0) {
          t3 = FILE_TYPE_FAMILY[info.familyIdx][tmp[key][info.familyIdx]];
          info.chunk.fileType = t3;
        }
        if (!byType[t3]) {
          byType[t3] = [];
        }
        byType[t3].push(info.chunk);
      });
      result2.push(...Object.keys(byType).map((t3) => byType[t3]));
    });
    return result2;
  };
  var ChunkBuilder = class {
    constructor(plugins3 = []) {
      __publicField(this, "plugins");
      this.plugins = plugins3;
    }
    async run(ir, initialStructure = {
      ir,
      chunks: [],
      depNames: [],
      contextData: {},
      imports: {}
    }) {
      const structure = initialStructure;
      const finalStructure = await this.plugins.reduce(
        async (previousPluginOperation, plugin) => {
          const modifiedStructure = await previousPluginOperation;
          return plugin(modifiedStructure);
        },
        Promise.resolve(structure)
      );
      if (!isEmpty_default(finalStructure.imports)) {
        const content = Object.entries(finalStructure.imports).map(([pkg, spec]) => renderImportEntry(pkg, spec)).filter(Boolean).join("\n");
        if (content) {
          finalStructure.chunks.push({
            type: "string" /* STRING */,
            fileType: "tsx" /* TSX */,
            subModule: COMMON_SUB_MODULE_NAME,
            name: COMMON_CHUNK_NAME.ExternalDepsImport,
            content: `${content}
`,
            linkAfter: []
          });
        }
      }
      const subModules = new Set(
        finalStructure.chunks.map((c) => c.subModule || COMMON_SUB_MODULE_NAME)
      );
      for (const subModule of subModules) {
        consolidateExternalImports(finalStructure.chunks, subModule);
      }
      const chunks = groupChunks(finalStructure.chunks);
      return {
        chunks
      };
    }
    getPlugins() {
      return this.plugins;
    }
    addPlugin(plugin) {
      this.plugins.push(plugin);
    }
  };

  // src/generator/CodeBuilder.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var CodeBuilder = class {
    constructor(chunkDefinitions = []) {
      __publicField(this, "chunkDefinitions", []);
      __publicField(this, "generators", {
        ["string" /* STRING */]: (str) => str,
        ["json" /* JSON */]: (json) => JSON.stringify(json)
      });
      this.chunkDefinitions = chunkDefinitions;
    }
    link(chunkDefinitions = []) {
      const chunks = chunkDefinitions || this.chunkDefinitions;
      if (chunks.length <= 0) {
        return "";
      }
      const unprocessedChunks = chunks.map((chunk2) => {
        return {
          name: chunk2.name,
          type: chunk2.type,
          content: chunk2.content,
          linkAfter: this.cleanupInvalidChunks(chunk2.linkAfter, chunks)
        };
      });
      const resultingString = [];
      while (unprocessedChunks.length > 0) {
        let indexToRemove = 0;
        for (let index = 0; index < unprocessedChunks.length; index++) {
          if (unprocessedChunks[index].linkAfter.length <= 0) {
            indexToRemove = index;
            break;
          }
        }
        if (unprocessedChunks[indexToRemove].linkAfter.length > 0) {
          throw new CodeGeneratorError(
            "Operation aborted. Reason: cyclic dependency between chunks."
          );
        }
        const { type, content, name } = unprocessedChunks[indexToRemove];
        const compiledContent = this.generateByType(type, content);
        if (compiledContent) {
          resultingString.push(`${compiledContent}
`);
        }
        unprocessedChunks.splice(indexToRemove, 1);
        if (!unprocessedChunks.some((ch) => ch.name === name)) {
          unprocessedChunks.forEach(
            (ch) => {
              ch.linkAfter = ch.linkAfter.filter((after2) => after2 !== name);
            }
          );
        }
      }
      return resultingString.join("\n");
    }
    generateByType(type, content) {
      if (!content) {
        return "";
      }
      if (Array.isArray(content)) {
        return content.map((contentItem) => this.generateByType(type, contentItem)).join("\n");
      }
      if (!this.generators[type]) {
        throw new Error(
          `Attempted to generate unknown type ${type}. Please register a generator for this type in builder/index.ts`
        );
      }
      return this.generators[type](content);
    }
    cleanupInvalidChunks(linkAfter, chunks) {
      return linkAfter.filter((chunkName) => chunks.some((chunk2) => chunk2.name === chunkName));
    }
  };

  // src/generator/ModuleBuilder.ts
  function createModuleBuilder(options = {
    plugins: [],
    postProcessors: []
  }) {
    const chunkGenerator = new ChunkBuilder(options.plugins);
    const linker = new CodeBuilder();
    const generateModule = async (input) => {
      const moduleMainName = options.mainFileName || COMMON_SUB_MODULE_NAME;
      if (chunkGenerator.getPlugins().length <= 0) {
        throw new CodeGeneratorError(
          "No plugins found. Component generation cannot work without any plugins!"
        );
      }
      let files = [];
      const { chunks } = await chunkGenerator.run(input, {
        ir: input,
        chunks: [],
        depNames: [],
        imports: {},
        contextData: options.contextData || {}
      });
      chunks.forEach((fileChunkList) => {
        const content = linker.link(fileChunkList);
        const file2 = createResultFile(
          fileChunkList[0].subModule || moduleMainName,
          fileChunkList[0].fileType,
          content
        );
        files.push(file2);
      });
      if (options.postProcessors.length > 0) {
        files = files.map((file2) => {
          let { content, ext: type, name } = file2;
          options.postProcessors.forEach((processer) => {
            content = processer(content, type, name);
          });
          return createResultFile(file2.name, type, content);
        });
      }
      return {
        files
      };
    };
    const generateModuleCode = async (schema) => {
      const schemaParser = new SchemaParser();
      const parseResult = schemaParser.parse(schema);
      const containerInfo = parseResult.containers[0];
      const { files } = await generateModule(containerInfo);
      const dir = createResultDir(containerInfo.moduleName);
      files.forEach((file2) => addFileByPath(dir, file2));
      return dir;
    };
    const linkCodeChunks = (chunks, fileName) => {
      const files = [];
      Object.keys(chunks).forEach((fileKey) => {
        const fileChunkList = chunks[fileKey];
        const content = linker.link(fileChunkList);
        const file2 = createResultFile(
          fileChunkList[0].subModule || fileName,
          fileChunkList[0].fileType,
          content
        );
        files.push(file2);
      });
      return files;
    };
    return {
      generateModule,
      generateModuleCode,
      linkCodeChunks,
      addPlugin: chunkGenerator.addPlugin.bind(chunkGenerator)
    };
  }

  // src/generator/ProjectBuilder.ts
  var ProjectBuilder = class {
    constructor(builderOptions) {
      __publicField(this, "template");
      __publicField(this, "plugins");
      __publicField(this, "postProcessors");
      __publicField(this, "schemaParser");
      __publicField(this, "projectPreProcessors");
      __publicField(this, "projectPostProcessors");
      __publicField(this, "inStrictMode");
      __publicField(this, "mode");
      __publicField(this, "extraContextData");
      let customBuilderOptions = builderOptions;
      if (typeof builderOptions.customizeBuilderOptions === "function") {
        customBuilderOptions = builderOptions.customizeBuilderOptions(builderOptions);
      }
      const {
        template: template2,
        plugins: plugins3,
        postProcessors,
        schemaParser = new SchemaParser(),
        projectPreProcessors = [],
        projectPostProcessors = [],
        mode = "incremental",
        rootPaths = ["src"],
        pagePaths = [],
        configPaths = [],
        inStrictMode = false,
        extraContextData = {}
      } = customBuilderOptions;
      this.template = template2(rootPaths, pagePaths, configPaths);
      this.plugins = plugins3;
      this.postProcessors = postProcessors;
      this.schemaParser = schemaParser;
      this.projectPreProcessors = projectPreProcessors;
      this.projectPostProcessors = projectPostProcessors;
      this.inStrictMode = inStrictMode;
      this.mode = mode;
    }
    async generateProject(originalSchema) {
      var _a, _b, _c;
      const { schemaParser } = this;
      let schema = typeof originalSchema === "string" ? JSON.parse(originalSchema) : originalSchema;
      for (const preProcessor of this.projectPreProcessors) {
        schema = await preProcessor(schema);
      }
      if (!schemaParser.validate(schema)) {
        throw new CodeGeneratorError("Schema is invalid");
      }
      const parseResult = schemaParser.parse(schema);
      let projectRoot = { name: ".", dirs: [], files: [] };
      if (this.mode === "fully") {
        projectRoot = await this.template.generateTemplate(parseResult);
      }
      let buildResult = [];
      const builders = this.createModuleBuilders({
        extraContextData: {
          projectRemark: (_a = parseResult == null ? void 0 : parseResult.project) == null ? void 0 : _a.projectRemark,
          template: this.template
        }
      });
      const containerBuildResult = await Promise.all(
        parseResult.containers.map(async (containerInfo) => {
          let builder;
          let path;
          if (containerInfo.containerType === "Page") {
            builder = builders.pages;
            path = this.template.slots.pages.path.concat(containerInfo.modulePaths || []);
          } else if (containerInfo.containerType === "Block") {
            builder = builders.components;
            path = this.template.slots.pages.path.concat(containerInfo.modulePaths || []);
          } else {
            builder = builders.components;
            path = this.template.slots.components.path.concat(containerInfo.modulePaths || []);
          }
          const { files } = await builder.generateModule(containerInfo);
          return {
            moduleName: containerInfo.moduleName,
            path,
            files
          };
        })
      );
      buildResult = buildResult.concat(containerBuildResult);
      if (parseResult.globalRouter && builders.config) {
        const { files } = await builders.config.generateModule(parseResult);
        buildResult.push({
          path: this.template.slots.config.path,
          files
        });
      }
      if (parseResult.globalRouter && builders.detailsMap) {
        const { files } = await builders.detailsMap.generateModule(parseResult);
        buildResult.push({
          path: this.template.slots.detailsMap.path,
          files
        });
      }
      if (parseResult.project && builders.constants && this.template.slots.constants) {
        const { files } = await builders.constants.generateModule(parseResult.project);
        buildResult.push({
          path: this.template.slots.constants.path,
          files
        });
      }
      if (parseResult.globalUtils && builders.utils && this.template.slots.utils) {
        const { files } = await builders.utils.generateModule(parseResult.globalUtils);
        buildResult.push({
          path: this.template.slots.utils.path,
          files
        });
      }
      if (builders.i18n && this.template.slots.i18n) {
        const { files } = await builders.i18n.generateModule(parseResult.project);
        buildResult.push({
          path: this.template.slots.i18n.path,
          files
        });
      }
      if (parseResult.project && builders.entry) {
        const { files } = await builders.entry.generateModule(parseResult.project);
        buildResult.push({
          path: this.template.slots.entry.path,
          files
        });
      }
      if (this.mode === "fully") {
        await this.createModeFully(builders, parseResult, buildResult);
      }
      const isSingleComponent = (_c = (_b = parseResult == null ? void 0 : parseResult.project) == null ? void 0 : _b.projectRemark) == null ? void 0 : _c.isSingleComponent;
      buildResult.forEach((moduleInfo) => {
        let targetDir = getDirFromRoot(projectRoot, moduleInfo.path);
        if (moduleInfo.moduleName && !isSingleComponent && moduleInfo.moduleName.toLowerCase() !== "index") {
          let dir = createResultDir(moduleInfo.moduleName);
          dir = addDirectory(targetDir, dir);
          targetDir = dir;
        }
        moduleInfo.files.forEach((file2) => addFileByPath(targetDir, file2));
      });
      let finalResult = projectRoot;
      for (const projectPostProcessor of this.projectPostProcessors) {
        finalResult = await projectPostProcessor(finalResult, schema, originalSchema, {
          template: this.template,
          parseResult
        });
      }
      return finalResult;
    }
    async createModeFully(builders, parseResult, buildResult) {
      if (parseResult.globalRouter && builders.router) {
        const { files } = await builders.router.generateModule(parseResult.globalRouter);
        buildResult.push({
          path: this.template.slots.router.path,
          files
        });
      }
      if (builders.appConfig) {
        const { files } = await builders.appConfig.generateModule(parseResult);
        buildResult.push({
          path: this.template.slots.appConfig.path,
          files
        });
      }
      if (builders.buildConfig) {
        const { files } = await builders.buildConfig.generateModule(parseResult);
        buildResult.push({
          path: this.template.slots.buildConfig.path,
          files
        });
      }
      if (parseResult.project && builders.globalStyle) {
        const { files } = await builders.globalStyle.generateModule(parseResult.project);
        buildResult.push({
          path: this.template.slots.globalStyle.path,
          files
        });
      }
      if (parseResult.project && builders.htmlEntry) {
        const { files } = await builders.htmlEntry.generateModule(parseResult.project);
        buildResult.push({
          path: this.template.slots.htmlEntry.path,
          files
        });
      }
      if (parseResult.project && builders.packageJSON) {
        const { files } = await builders.packageJSON.generateModule(parseResult.project);
        buildResult.push({
          path: this.template.slots.packageJSON.path,
          files
        });
      }
      if (parseResult.project && builders.demo) {
        const { files } = await builders.demo.generateModule(parseResult.project);
        buildResult.push({
          path: this.template.slots.demo.path,
          files
        });
      }
      await this.generateExtraSlots(builders, parseResult, buildResult);
    }
    createModuleBuilders(extraContextData = {}) {
      const builders = {};
      Object.keys(this.plugins).forEach((pluginName) => {
        if (this.plugins[pluginName].length > 0) {
          const options = {};
          if (this.template.slots[pluginName] && this.template.slots[pluginName].fileName) {
            options.mainFileName = this.template.slots[pluginName].fileName;
          }
          builders[pluginName] = createModuleBuilder({
            plugins: this.plugins[pluginName],
            postProcessors: this.postProcessors,
            contextData: {
              inStrictMode: this.inStrictMode,
              tolerateEvalErrors: true,
              evalErrorsHandler: "",
              ...this.extraContextData,
              ...extraContextData
            },
            ...options
          });
        }
      });
      return builders;
    }
    async generateExtraSlots(builders, parseResult, buildResult) {
      for (const slotName in this.template.slots) {
        if (!isBuiltinSlotName(slotName)) {
          const { files } = await builders[slotName].generateModule(parseResult);
          buildResult.push({
            path: this.template.slots[slotName].path,
            files
          });
        }
      }
    }
  };
  function createProjectBuilder(initOptions) {
    return new ProjectBuilder(initOptions);
  }
  function getDirFromRoot(root2, path) {
    let current = root2;
    path.forEach((p) => {
      const exist = current.dirs.find((d) => d.name === p);
      if (exist) {
        current = exist;
      } else {
        let newDir = createResultDir(p);
        newDir = addDirectory(current, newDir);
        current = newDir;
      }
    });
    return current;
  }

  // src/publisher/zip/index.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/publisher/zip/utils.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var import_jszip = __toESM(require_jszip_min());
  var isNodeProcess = () => {
    return typeof define_process_default === "object" && typeof define_process_default.versions === "object" && typeof define_process_default.versions.node !== "undefined";
  };
  var writeZipToDisk = (zipFolderPath, content, zipName) => {
    if (!isNodeProcess()) {
      throw new Error("ZipPublisher: writeZipToDisk is only available in NodeJS");
    }
    const fs = require_fs();
    const path = (init_path(), __toCommonJS(path_exports));
    if (!fs.existsSync(zipFolderPath)) {
      fs.mkdirSync(zipFolderPath, { recursive: true });
    }
    const zipPath = path.join(zipFolderPath, `${zipName}.zip`);
    const writeStream = fs.createWriteStream(zipPath);
    writeStream.write(content);
    writeStream.end();
  };
  var generateProjectZip = async (project) => {
    let zip2 = new import_jszip.default();
    zip2 = writeFolderToZip(project, zip2, true);
    const zipType = isNodeProcess() ? "nodebuffer" : "blob";
    return zip2.generateAsync({ type: zipType });
  };
  var writeFolderToZip = (folder, parentFolder, ignoreFolder = false) => {
    const zipFolder = ignoreFolder ? parentFolder : parentFolder.folder(folder.name);
    if (zipFolder !== null) {
      folder.files.forEach((file2) => {
        const options = {};
        const fileName = file2.ext ? `${file2.name}.${file2.ext}` : file2.name;
        zipFolder.file(fileName, file2.content, options);
      });
      folder.dirs.forEach((subFolder) => {
        writeFolderToZip(subFolder, zipFolder);
      });
    }
    return parentFolder;
  };

  // src/publisher/zip/index.ts
  var import_file_saver = __toESM(require_FileSaver_min());
  var createZipPublisher = (params = {}) => {
    let { project, outputPath } = params;
    const getProject = () => project;
    const setProject = (projectToSet) => {
      project = projectToSet;
    };
    const getOutputPath = () => outputPath;
    const setOutputPath = (path) => {
      outputPath = path;
    };
    const publish = async (options = {}) => {
      const projectToPublish = options.project || project;
      if (!projectToPublish) {
        throw new PublisherError("MissingProject");
      }
      const zipName = options.projectSlug || params.projectSlug || projectToPublish.name;
      try {
        const zipContent = await generateProjectZip(projectToPublish);
        if (isNodeProcess()) {
          const projectOutputPath = options.outputPath || outputPath;
          if (projectOutputPath) {
            await writeZipToDisk(projectOutputPath, zipContent, zipName);
          }
        } else {
          (0, import_file_saver.saveAs)(zipContent, `${zipName}.zip`);
        }
        return { success: true, payload: zipContent };
      } catch (error) {
        throw new PublisherError(getErrorMessage(error) || "UnknownError");
      }
    };
    return {
      publish,
      getProject,
      setProject,
      getOutputPath,
      setOutputPath
    };
  };

  // src/solutions/gant.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/plugins/common/esmodule.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/utils/pathHelper.ts
  var pathHelper_exports = {};
  __export(pathHelper_exports, {
    getSlotRelativePath: () => getSlotRelativePath,
    relativePath: () => relativePath
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function relativePath(from, to) {
    const length = Math.min(from.length, to.length);
    let samePartsLength = length;
    for (let i = 0; i < length; i++) {
      if (from[i] !== to[i]) {
        samePartsLength = i;
        break;
      }
    }
    if (samePartsLength === 0) {
      return to;
    }
    let outputParts = [];
    for (let i = samePartsLength; i < from.length; i++) {
      outputParts.push("..");
    }
    outputParts = [...outputParts, ...to.slice(samePartsLength)];
    if (outputParts[0] !== "..") {
      outputParts.unshift(".");
    }
    return outputParts;
  }
  function getSlotRelativePath(options) {
    var _a;
    const { contextData, from, to, modulePaths = [], moduleName } = options;
    const { extraContextData } = contextData || {};
    const isSingleComponent = (_a = extraContextData == null ? void 0 : extraContextData.projectRemark) == null ? void 0 : _a.isSingleComponent;
    const template2 = extraContextData == null ? void 0 : extraContextData.template;
    let toPath2 = to ? template2.slots[to].path : [];
    if (to) {
      toPath2 = [...toPath2, template2.slots[to].fileName];
    }
    let fromPath = from ? [...template2.slots[from].path, ...modulePaths] : [...modulePaths];
    if (!isSingleComponent && from && ["components", "pages"].indexOf(from) > -1) {
      const isIndexPage = moduleName && moduleName.toLowerCase() === "index";
      if (!isIndexPage) {
        fromPath = [...fromPath, "pageName"];
      }
    }
    return relativePath(fromPath, toPath2).join("/");
  }

  // src/plugins/common/esmodule.ts
  var DEP_MAIN_BLOCKLIST = ["lib", "lib/index", "es", "es/index", "main"];
  var DEFAULT_EXPORT_NAME = "__default__";
  function groupDepsByPack(deps) {
    const depMap = {};
    const addDep = (pkg, dep) => {
      if (!depMap[pkg]) {
        depMap[pkg] = [];
      }
      depMap[pkg].push(dep);
    };
    deps.forEach((dep) => {
      if (dep.dependencyType === "Internal" /* Internal */) {
        addDep(`${dep.moduleName}${dep.main ? `/${dep.main}` : ""}`, dep);
      } else {
        let depMain = "";
        if (dep.main && DEP_MAIN_BLOCKLIST.indexOf(dep.main) < 0) {
          depMain = dep.main;
        }
        if (depMain.substring(0, 1) === "/") {
          depMain = depMain.substring(1);
        }
        addDep(`${dep.package}${depMain ? `/${depMain}` : ""}`, dep);
      }
    });
    return depMap;
  }
  function getDependencyIdentifier(info) {
    return info.aliasName || info.exportName;
  }
  function getExportNameOfDep(dep) {
    if (dep.destructuring) {
      return dep.exportName || dep.componentName || throwNewError("destructuring dependency must have exportName or componentName");
    }
    if (!dep.subName) {
      return dep.componentName || dep.exportName || throwNewError("dependency item must have componentName or exportName");
    }
    return dep.exportName || `__$${camelCase_default(
      get_default(dep, "moduleName") || get_default(dep, "package") || throwNewError("dep.moduleName or dep.package is undefined")
    )}_default`;
  }
  function throwNewError(msg) {
    throw new Error(msg);
  }
  function buildPackageImport(pkg, rootPath, deps, targetFileType, useAliasName) {
    if (!pkg || pkg === "undefined" || pkg === "null") {
      return [];
    }
    const chunks = [];
    const exportItems = {};
    const defaultExportNames = [];
    const depsInfo = deps.map((dep) => {
      const info = {
        exportName: getExportNameOfDep(dep),
        isDefault: !dep.destructuring,
        subName: dep.subName || void 0,
        nodeIdentifier: dep.componentName || void 0,
        source: dep
      };
      if (info.isDefault) {
        if (defaultExportNames.indexOf(info.exportName) < 0) {
          defaultExportNames.push(info.exportName);
        }
      }
      if (!info.subName) {
        if (info.nodeIdentifier === info.exportName) {
          info.nodeIdentifier = void 0;
        }
        if (info.isDefault) {
          info.aliasName = info.nodeIdentifier || info.exportName;
          info.exportName = DEFAULT_EXPORT_NAME;
        }
        if (info.nodeIdentifier) {
          info.aliasName = info.nodeIdentifier;
          info.nodeIdentifier = void 0;
        }
      } else {
        if (info.isDefault) {
          info.aliasName = info.exportName;
          info.exportName = DEFAULT_EXPORT_NAME;
        }
        if (info.nodeIdentifier === `${info.exportName}.${info.subName}`) {
          info.nodeIdentifier = void 0;
        }
      }
      return info;
    });
    depsInfo.forEach((info) => {
      if (!exportItems[info.exportName]) {
        exportItems[info.exportName] = {
          exportName: info.exportName,
          isDefault: info.isDefault,
          aliasNames: [],
          needOriginExport: false
        };
      }
      if (!info.nodeIdentifier && !info.aliasName) {
        exportItems[info.exportName].needOriginExport = true;
      }
    });
    depsInfo.forEach((info) => {
      if (info.aliasName) {
        const { aliasNames } = exportItems[info.exportName];
        if (aliasNames.indexOf(info.aliasName) < 0) {
          aliasNames.push(info.aliasName);
        }
      }
    });
    depsInfo.forEach((info) => {
      if (info.nodeIdentifier) {
        const exportItem = exportItems[info.exportName];
        if (!exportItem.needOriginExport && exportItem.aliasNames.length > 0) {
          info.aliasName = exportItem.aliasNames[0];
        }
      }
    });
    const nodeIdentifiers = depsInfo.map((info) => info.nodeIdentifier).filter(Boolean);
    const conflictInfos = flatMap_default(Object.keys(exportItems), (exportName) => {
      const exportItem = exportItems[exportName];
      const usedNames = [
        ...exportItem.aliasNames,
        ...exportItem.needOriginExport || exportItem.aliasNames.length <= 0 ? [exportName] : []
      ];
      const conflictNames = usedNames.filter((n) => nodeIdentifiers.indexOf(n) >= 0);
      if (conflictNames.length > 0) {
        return [
          ...conflictNames.indexOf(exportName) >= 0 ? [[exportName, true, exportItem]] : [],
          ...conflictNames.filter((n) => n !== exportName).map((n) => [n, false, exportItem])
        ];
      }
      return [];
    });
    const conflictExports = conflictInfos.filter((c) => c[1]).map((c) => c[0]);
    const conflictAlias = conflictInfos.filter((c) => !c[1]).map((c) => c[0]);
    const solutions = {};
    depsInfo.forEach((info) => {
      if (info.aliasName && conflictAlias.indexOf(info.aliasName) >= 0) {
        let solution = solutions[info.aliasName];
        if (!solution) {
          solution = `${info.aliasName}Alias`;
          const conflictItem = (conflictInfos.find((c) => c[0] === info.aliasName) || [])[2];
          conflictItem.aliasNames = conflictItem.aliasNames.filter((a) => a !== info.aliasName);
          conflictItem.aliasNames.push(solution);
          solutions[info.aliasName] = solution;
        }
        info.aliasName = solution;
      }
      if (conflictExports.indexOf(info.exportName) >= 0) {
        let solution = solutions[info.exportName];
        if (!solution) {
          solution = `${info.exportName}Export`;
          const conflictItem = (conflictInfos.find((c) => c[0] === info.exportName) || [])[2];
          conflictItem.aliasNames.push(solution);
          conflictItem.needOriginExport = false;
          solutions[info.exportName] = solution;
        }
        info.aliasName = solution;
      }
    });
    depsInfo.forEach((info) => {
      const name = info.aliasName || info.exportName;
      if (!isValidIdentifier(name)) {
        throw new CodeGeneratorError(`Invalid Identifier [${name}]`);
      }
      if (info.nodeIdentifier && !isValidComponentName(info.nodeIdentifier)) {
        throw new CodeGeneratorError(`Invalid Identifier [${info.nodeIdentifier}]`);
      }
    });
    const aliasDefineStatements = {};
    if (useAliasName) {
      Object.keys(exportItems).forEach((exportName) => {
        var _a;
        const aliasList = ((_a = exportItems[exportName]) == null ? void 0 : _a.aliasNames) || [];
        if (aliasList.length > 0) {
          const srcName = exportItems[exportName].needOriginExport ? exportName : aliasList[0];
          const aliasNameList = exportItems[exportName].needOriginExport ? aliasList : aliasList.slice(1);
          aliasNameList.forEach((a) => {
            if (!aliasDefineStatements[a]) {
              aliasDefineStatements[a] = `const ${a} = ${srcName};`;
            }
          });
        }
      });
    }
    function getDefaultExportName(info) {
      if (info.isDefault) {
        return defaultExportNames[0];
      }
      return info.exportName;
    }
    depsInfo.forEach((info) => {
      if (info.nodeIdentifier) {
        const ownerName = getDependencyIdentifier(info);
        chunks.push({
          type: "string" /* STRING */,
          fileType: targetFileType,
          name: COMMON_CHUNK_NAME.ImportAliasDefine,
          content: useAliasName ? `const ${info.nodeIdentifier} = ${ownerName}.${info.subName};` : "",
          linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport, COMMON_CHUNK_NAME.InternalDepsImport],
          ext: {
            originalName: `${getDefaultExportName(info)}.${info.subName}`,
            aliasName: info.nodeIdentifier,
            dependency: info.source
          }
        });
      } else if (info.aliasName) {
        if (info.isDefault && defaultExportNames.find((n) => n === info.aliasName)) {
          delete aliasDefineStatements[info.aliasName];
          return;
        }
        let contentStatement = "";
        if (aliasDefineStatements[info.aliasName]) {
          contentStatement = aliasDefineStatements[info.aliasName];
          delete aliasDefineStatements[info.aliasName];
        }
        chunks.push({
          type: "string" /* STRING */,
          fileType: targetFileType,
          name: COMMON_CHUNK_NAME.ImportAliasDefine,
          content: contentStatement,
          linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport, COMMON_CHUNK_NAME.InternalDepsImport],
          ext: {
            originalName: getDefaultExportName(info),
            aliasName: info.aliasName,
            dependency: info.source
          }
        });
      }
    });
    Object.keys(aliasDefineStatements).forEach((a) => {
      chunks.push({
        type: "string" /* STRING */,
        fileType: targetFileType,
        name: COMMON_CHUNK_NAME.ImportAliasDefine,
        content: aliasDefineStatements[a],
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport, COMMON_CHUNK_NAME.InternalDepsImport]
      });
    });
    const exportItemList = Object.keys(exportItems).map((k) => exportItems[k]);
    const defaultExport = exportItemList.filter((item) => item.isDefault);
    const otherExports = exportItemList.filter((item) => !item.isDefault);
    const statementL = ["import"];
    if (defaultExport.length > 0) {
      if (useAliasName) {
        statementL.push(defaultExportNames[0]);
      } else {
        statementL.push(defaultExport[0].aliasNames[0]);
      }
      if (otherExports.length > 0) {
        statementL.push(", ");
      }
    }
    if (otherExports.length > 0) {
      const items = otherExports.map((item) => {
        return !useAliasName || item.needOriginExport || item.aliasNames.length <= 0 ? item.exportName : `${item.exportName} as ${item.aliasNames[0]}`;
      });
      statementL.push(`{ ${items.join(", ")} }`);
    }
    statementL.push("from");
    const getInternalDependencyModuleId = () => `${rootPath}${pkg}`;
    if (deps[0].dependencyType === "Internal" /* Internal */) {
      statementL.push(`'${getInternalDependencyModuleId()}';`);
      chunks.push({
        type: "string" /* STRING */,
        fileType: targetFileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: statementL.join(" "),
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
    } else {
      statementL.push(`'${pkg}';`);
      chunks.push({
        type: "string" /* STRING */,
        fileType: targetFileType,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: statementL.join(" "),
        linkAfter: []
      });
    }
    if (defaultExportNames.length > 1) {
      if (deps[0].dependencyType === "Internal" /* Internal */) {
        defaultExportNames.slice(1).forEach((exportName) => {
          chunks.push({
            type: "string" /* STRING */,
            fileType: targetFileType,
            name: COMMON_CHUNK_NAME.InternalDepsImport,
            content: `import ${exportName} from '${getInternalDependencyModuleId()}';`,
            linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
          });
        });
      } else {
        defaultExportNames.slice(1).forEach((exportName) => {
          chunks.push({
            type: "string" /* STRING */,
            fileType: targetFileType,
            name: COMMON_CHUNK_NAME.ExternalDepsImport,
            content: `import ${exportName} from '${pkg}';`,
            linkAfter: []
          });
          chunks.push({
            type: "string" /* STRING */,
            fileType: targetFileType,
            name: COMMON_CHUNK_NAME.ImportAliasDefine,
            content: "",
            linkAfter: [],
            ext: {
              aliasName: exportName,
              originalName: exportName,
              dependency: {
                package: pkg,
                componentName: exportName
              }
            }
          });
        });
      }
    }
    return chunks;
  }
  var pluginFactory = (config3) => {
    const cfg = {
      fileType: "js" /* JS */,
      useAliasName: true,
      ...config3 || {}
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      if (ir && ir.deps && ir.deps.length > 0) {
        const deps = cfg.filter ? cfg.filter(ir.deps) : ir.deps;
        const packs = groupDepsByPack(deps);
        let rootPath = "@/";
        if (pre.contextData) {
          rootPath = getSlotRelativePath({
            contextData: pre.contextData,
            from: "router",
            to: "pages"
          });
        }
        Object.keys(packs).forEach((pkg) => {
          const chunks = buildPackageImport(
            pkg,
            rootPath,
            packs[pkg],
            cfg.fileType,
            cfg.useAliasName
          );
          next.chunks.push(...chunks);
        });
      }
      return next;
    };
    return plugin;
  };
  var esmodule_default = pluginFactory;

  // src/plugins/common/styleImport.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var import_change_case2 = __toESM(require_change_case());
  var pluginFactory2 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const { chunks } = next;
      if (ir && ir.deps && ir.deps.length > 0) {
        let lowcodeMaterialsStyleAdded = false;
        let fusionUIStyleAdded = false;
        let nextStyleAddedMap = {};
        ir.deps.forEach((dep) => {
          if (dep.package === "@alifd/next" && !nextStyleAddedMap[dep.exportName]) {
            chunks.push({
              type: "string" /* STRING */,
              fileType: "jsx" /* JSX */,
              name: COMMON_CHUNK_NAME.InternalDepsImport,
              content: `import '@alifd/next/lib/${import_change_case2.default.paramCase(dep.exportName)}/style';`,
              linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
            });
            nextStyleAddedMap[dep.exportName] = true;
          } else if (dep.package === "@alilc/lowcode-materials" && !lowcodeMaterialsStyleAdded) {
            chunks.push({
              type: "string" /* STRING */,
              fileType: "jsx" /* JSX */,
              name: COMMON_CHUNK_NAME.InternalDepsImport,
              content: "import '@alilc/lowcode-materials/lib/style';",
              linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
            });
            lowcodeMaterialsStyleAdded = true;
          } else if (dep.package === "@alifd/fusion-ui" && !fusionUIStyleAdded) {
            chunks.push({
              type: "string" /* STRING */,
              fileType: "jsx" /* JSX */,
              name: COMMON_CHUNK_NAME.InternalDepsImport,
              content: "import '@alifd/fusion-ui/lib/style';",
              linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
            });
            fusionUIStyleAdded = true;
          }
        });
      }
      return next;
    };
    return plugin;
  };
  var styleImport_default = pluginFactory2;

  // src/plugins/component/react/containerClass.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var import_change_case3 = __toESM(require_change_case());

  // src/plugins/component/react/const.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var REACT_CHUNK_NAME = {
    ClassRenderStart: "ReactComponentClassRenderStart",
    ClassRenderPre: "ReactComponentClassRenderPre",
    ClassRenderEnd: "ReactComponentClassRenderEnd",
    ClassRenderJSX: "ReactComponentClassRenderJSX",
    ClassDidMountStart: "ReactComponentClassDidMountStart",
    ClassDidMountEnd: "ReactComponentClassDidMountEnd",
    ClassDidMountContent: "ReactComponentClassDidMountContent",
    FunctionRenderStart: "ReactComponentFunctionRenderStart",
    FunctionRenderEnd: "ReactComponentFunctionRenderEnd",
    FunctionRenderJSX: "ReactComponentFunctionRenderJSX"
  };

  // src/plugins/component/react/containerClass.ts
  var pluginFactory3 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const componentClassName = ensureValidClassName(
        `${import_change_case3.default.pascalCase(ir.moduleName)}$$${ir.containerType}`
      );
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.Start,
        content: `class ${componentClassName} extends React.Component {`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      if (ir.containerType === "Component") {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "jsx" /* JSX */,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `static displayName = '${ir.moduleName}';`,
          linkAfter: [
            CLASS_DEFINE_CHUNK_NAME.Start
          ]
        });
      }
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.End,
        content: "}",
        linkAfter: [
          ...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.End],
          REACT_CHUNK_NAME.ClassRenderEnd,
          REACT_CHUNK_NAME.ClassDidMountEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorStart,
        content: "constructor(props, context) { super(props); ",
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorStart]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorEnd,
        content: "}",
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorEnd]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME.ClassDidMountStart,
        content: "componentDidMount() {",
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.End]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME.ClassDidMountEnd,
        content: "}",
        linkAfter: [REACT_CHUNK_NAME.ClassDidMountContent, REACT_CHUNK_NAME.ClassDidMountStart]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME.ClassRenderStart,
        content: "render() {",
        linkAfter: [
          ...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.End],
          REACT_CHUNK_NAME.ClassDidMountEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME.ClassRenderEnd,
        content: "}",
        linkAfter: [
          REACT_CHUNK_NAME.ClassRenderStart,
          REACT_CHUNK_NAME.ClassRenderPre,
          REACT_CHUNK_NAME.ClassRenderJSX
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `export default ${componentClassName};`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          CLASS_DEFINE_CHUNK_NAME.End
        ]
      });
      return next;
    };
    return plugin;
  };
  var containerClass_default = pluginFactory3;

  // src/plugins/component/react/containerInitState.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/utils/compositeType.ts
  var compositeType_exports = {};
  __export(compositeType_exports, {
    generateCompositeType: () => generateCompositeType
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/utils/jsExpression.ts
  var jsExpression_exports = {};
  __export(jsExpression_exports, {
    generateExpression: () => generateExpression,
    generateFunction: () => generateFunction,
    isBroadJSFunction: () => isBroadJSFunction
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var parser2 = __toESM(require_lib2());
  var import_generator7 = __toESM(require_lib6());
  var import_traverse2 = __toESM(require_lib9());
  var t2 = __toESM(require_lib5());

  // src/utils/expressionParser.ts
  var expressionParser_exports = {};
  __export(expressionParser_exports, {
    ParseError: () => ParseError,
    parseExpression: () => parseExpression2,
    parseExpressionConvertThis2Context: () => parseExpressionConvertThis2Context,
    parseExpressionGetGlobalVariables: () => parseExpressionGetGlobalVariables,
    parseExpressionGetKeywords: () => parseExpressionGetKeywords,
    transformExpressionLocalRef: () => transformExpressionLocalRef
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var parser = __toESM(require_lib2());
  var import_generator6 = __toESM(require_lib6());
  var import_traverse = __toESM(require_lib9());
  var t = __toESM(require_lib5());
  var import_types10 = __toESM(require_lib5());

  // src/utils/OrderedSet.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var OrderedSet = class {
    constructor(items) {
      __publicField(this, "_set", /* @__PURE__ */ new Set());
      __publicField(this, "_arr", []);
      if (items) {
        this._set = new Set(items);
        this._arr = items.slice(0);
      }
    }
    add(item) {
      if (!this._set.has(item)) {
        this._set.add(item);
        this._arr.push(item);
      }
    }
    delete(item) {
      if (this._set.has(item)) {
        this._set.delete(item);
        this._arr.splice(this._arr.indexOf(item), 1);
      }
    }
    has(item) {
      return this._set.has(item);
    }
    toArray() {
      return this._arr.slice(0);
    }
  };

  // src/utils/expressionParser.ts
  var ParseError = class extends Error {
    constructor(expr, detail) {
      super(`Failed to parse expression "${typeof expr === "string" ? expr : (0, import_generator6.default)(expr)}"`);
      __publicField(this, "expr");
      __publicField(this, "detail");
      this.expr = expr;
      this.detail = detail;
      Object.setPrototypeOf(this, new.target.prototype);
    }
  };
  var MAYBE_EXPRESSIONS = {
    ArrayExpression: { fields: ["elements"] },
    AssignmentExpression: { fields: ["left", "right"] },
    BinaryExpression: { fields: ["left", "right"] },
    CallExpression: { fields: ["arguments", "callee"] },
    ConditionalExpression: { fields: ["test", "consequent", "alternate"] },
    DoWhileStatement: { fields: ["test"] },
    ExpressionStatement: { fields: ["expression"] },
    ForInStatement: { fields: ["right"] },
    ForStatement: { fields: ["init", "test", "update"] },
    IfStatement: { fields: ["test"] },
    LogicalExpression: { fields: ["left", "right"] },
    MemberExpression: {
      fields: (node) => {
        return node.type === "MemberExpression" && node.computed ? ["object", "property"] : ["object"];
      }
    },
    NewExpression: { fields: ["callee", "arguments"] },
    ObjectMethod: {
      fields: (node) => {
        return node.type === "ObjectMethod" && node.computed ? ["key"] : [];
      }
    },
    ObjectProperty: {
      fields: (node) => {
        return node.type === "ObjectProperty" && node.computed ? ["key", "value"] : ["value"];
      }
    },
    ReturnStatement: { fields: ["argument"] },
    SequenceExpression: { fields: ["expressions"] },
    ParenthesizedExpression: { fields: ["expression"] },
    SwitchCase: { fields: ["test"] },
    SwitchStatement: { fields: ["discriminant"] },
    ThrowStatement: { fields: ["argument"] },
    UnaryExpression: { fields: ["argument"] },
    UpdateExpression: { fields: ["argument"] },
    VariableDeclarator: { fields: ["init"] },
    WhileStatement: { fields: ["test"] },
    WithStatement: { fields: ["object"] },
    AssignmentPattern: { fields: ["right"] },
    ArrowFunctionExpression: { fields: ["body"] },
    ClassExpression: { fields: ["superClass"] },
    ClassDeclaration: { fields: ["superClass"] },
    ExportDefaultDeclaration: { fields: ["declaration"] },
    ForOfStatement: { fields: ["right"] },
    ClassMethod: {
      fields: (node) => {
        return node.type === "ClassMethod" && node.computed ? ["key"] : [];
      }
    },
    SpreadElement: { fields: ["argument"] },
    TaggedTemplateExpression: { fields: ["tag"] },
    TemplateLiteral: { fields: ["expressions"] },
    YieldExpression: { fields: ["argument"] },
    AwaitExpression: { fields: ["argument"] },
    OptionalMemberExpression: {
      fields: (node) => {
        return node.type === "OptionalMemberExpression" && node.computed ? ["object", "property"] : ["object"];
      }
    },
    OptionalCallExpression: { fields: ["callee", "arguments"] },
    JSXSpreadAttribute: { fields: ["argument"] },
    BindExpression: { fields: ["object", "callee"] },
    ClassProperty: {
      fields: (node) => {
        return node.type === "ClassProperty" && node.computed ? ["key", "value"] : ["value"];
      }
    },
    PipelineTopicExpression: { fields: ["expression"] },
    PipelineBareFunction: { fields: ["callee"] },
    ClassPrivateProperty: { fields: ["value"] },
    Decorator: { fields: ["expression"] },
    TupleExpression: { fields: ["elements"] },
    TSDeclareMethod: {
      fields: (node) => {
        return node.type === "TSDeclareMethod" && node.computed ? ["key"] : [];
      }
    },
    TSPropertySignature: {
      fields: (node) => {
        return node.type === "TSPropertySignature" && node.computed ? ["key", "initializer"] : ["initializer"];
      }
    },
    TSMethodSignature: {
      fields: (node) => {
        return node.type === "TSMethodSignature" && node.computed ? ["key"] : [];
      }
    },
    TSAsExpression: { fields: ["expression"] },
    TSTypeAssertion: { fields: ["expression"] },
    TSEnumDeclaration: { fields: ["initializer"] },
    TSEnumMember: { fields: ["initializer"] },
    TSNonNullExpression: { fields: ["expression"] },
    TSExportAssignment: { fields: ["expression"] }
  };
  var CROSS_THIS_SCOPE_TYPE_NODE = {
    ArrowFunctionExpression: false,
    FunctionExpression: true,
    FunctionDeclaration: true,
    ClassDeclaration: true,
    ClassExpression: true,
    ClassBody: true,
    ClassImplements: true,
    ClassMethod: true,
    ClassPrivateMethod: true,
    ClassProperty: true,
    ClassPrivateProperty: true,
    DeclareClass: true
  };
  var JS_KEYWORDS = ["arguments", "this", "super"];
  function parseExpressionGetKeywords(expr) {
    if (!expr) {
      return [];
    }
    try {
      const keywordVars = new OrderedSet();
      const ast = parser.parse(`!(${expr});`, {
        plugins: ["jsx"]
      });
      const addIdentifierIfNeeded = (x) => {
        if (typeof x === "object" && (0, import_types10.isIdentifier)(x) && JS_KEYWORDS.includes(x.name)) {
          keywordVars.add(x.name);
        }
      };
      (0, import_traverse.default)(ast, {
        enter(path) {
          var _a;
          const { node } = path;
          const expressionFields = (_a = MAYBE_EXPRESSIONS[node.type]) == null ? void 0 : _a.fields;
          if (expressionFields) {
            (typeof expressionFields === "function" ? expressionFields(node) : expressionFields).forEach((fieldName) => {
              const fieldValue = node[fieldName];
              if (typeof fieldValue === "object") {
                if (Array.isArray(fieldValue)) {
                  fieldValue.forEach((item) => {
                    addIdentifierIfNeeded(item);
                  });
                } else {
                  addIdentifierIfNeeded(fieldValue);
                }
              }
            });
          }
        }
      });
      return keywordVars.toArray().filter(Boolean);
    } catch (e) {
      throw new ParseError(expr, e);
    }
  }
  function parseExpressionGetGlobalVariables(expr, { filter: filter2 = () => true } = {}) {
    if (!expr) {
      return [];
    }
    try {
      const undeclaredVars = new OrderedSet();
      const ast = parser.parse(`!(${expr});`);
      const addUndeclaredIdentifierIfNeeded = (x, path) => {
        if (typeof x === "object" && (0, import_types10.isIdentifier)(x) && !path.scope.hasBinding(x.name)) {
          undeclaredVars.add(x.name);
        }
      };
      (0, import_traverse.default)(ast, {
        enter(path) {
          var _a;
          const { node } = path;
          const expressionFields = (_a = MAYBE_EXPRESSIONS[node.type]) == null ? void 0 : _a.fields;
          if (expressionFields) {
            (typeof expressionFields === "function" ? expressionFields(node) : expressionFields).forEach((fieldName) => {
              const fieldValue = node[fieldName];
              if (typeof fieldValue === "object") {
                if (Array.isArray(fieldValue)) {
                  fieldValue.forEach((item) => {
                    addUndeclaredIdentifierIfNeeded(item, path);
                  });
                } else {
                  addUndeclaredIdentifierIfNeeded(fieldValue, path);
                }
              }
            });
          }
        }
      });
      return undeclaredVars.toArray().filter(filter2);
    } catch (e) {
      throw new ParseError(expr, e);
    }
  }
  function parseExpressionConvertThis2Context(expr, contextName = "__$$context", localVariables = []) {
    if (!expr) {
      return expr.toString();
    }
    try {
      const exprAst = typeof expr === "string" ? parser.parseExpression(expr) : expr;
      const exprWrapAst = t.expressionStatement(exprAst);
      const fileAst = t.file(t.program([exprWrapAst]));
      const localVariablesSet = new Set(localVariables);
      let thisScopeLevel = CROSS_THIS_SCOPE_TYPE_NODE[exprAst.type] ? -1 : 0;
      (0, import_traverse.default)(fileAst, {
        enter(path) {
          if (CROSS_THIS_SCOPE_TYPE_NODE[path.node.type]) {
            thisScopeLevel++;
          }
        },
        exit(path) {
          if (CROSS_THIS_SCOPE_TYPE_NODE[path.node.type]) {
            thisScopeLevel--;
          }
        },
        MemberExpression(path) {
          if (!path.isMemberExpression()) {
            return;
          }
          const obj = path.get("object");
          if (!obj.isThisExpression()) {
            return;
          }
          if (!path.node.computed) {
            const prop = path.get("property");
            if (prop.isIdentifier() && localVariablesSet.has(prop.node.name)) {
              path.replaceWith(t.identifier(prop.node.name));
              return;
            }
          }
          if (thisScopeLevel <= 0) {
            obj.replaceWith(t.identifier(contextName));
          }
        },
        ThisExpression(path) {
          if (!path.isThisExpression()) {
            return;
          }
          if (path.parent.type === "MemberExpression") {
            return;
          }
          if (thisScopeLevel <= 0) {
            path.replaceWith(t.identifier(contextName));
          }
        }
      });
      const { code } = (0, import_generator6.default)(exprWrapAst.expression, { sourceMaps: false });
      return code;
    } catch (e) {
      throw new ParseError(expr, e);
    }
  }
  function parseExpression2(expr) {
    try {
      return parser.parseExpression(expr);
    } catch (e) {
      throw new ParseError(expr, e);
    }
  }
  function transformExpressionLocalRef(expr, scope) {
    if (!expr) {
      return expr;
    }
    if (!scope) {
      throw new Error("transform expression without scope");
    }
    try {
      const exprAst = typeof expr === "string" ? parser.parseExpression(expr) : expr;
      const exprWrapAst = t.expressionStatement(exprAst);
      const fileAst = t.file(t.program([exprWrapAst]));
      (0, import_traverse.default)(fileAst, {
        MemberExpression(path) {
          if (!path.isMemberExpression()) {
            return;
          }
          const obj = path.get("object");
          if (!obj.isThisExpression()) {
            return;
          }
          const prop = path.get("property");
          let memberName = "";
          if (!path.node.computed && prop.isIdentifier()) {
            memberName = prop.node.name;
          } else if (path.node.computed && prop.isStringLiteral()) {
            memberName = prop.node.value;
          }
          if (memberName && scope.bindings && scope.bindings.hasBinding(memberName)) {
            path.replaceWith(t.identifier(memberName));
          }
        }
      });
      const { code } = (0, import_generator6.default)(exprWrapAst.expression, { sourceMaps: false });
      return code;
    } catch (e) {
      throw new ParseError(expr, e);
    }
  }

  // src/utils/jsExpression.ts
  function parseFunction(content) {
    try {
      const ast = parser2.parse(`(${content});`, {
        plugins: ["jsx"]
      });
      let resultNode = null;
      (0, import_traverse2.default)(ast, {
        FunctionExpression(path) {
          resultNode = path.node;
          path.stop();
        }
      });
      return resultNode;
    } catch (e) {
      throw new ParseError(content, e);
    }
  }
  function transformFuncExpr2MethodMember(methodName, content) {
    const funcNode = parseFunction(content);
    if (funcNode) {
      const targetNode = t2.classMethod(
        "method",
        methodName && t2.identifier(methodName) || funcNode.id || t2.identifier("notDefineName"),
        funcNode.params,
        funcNode.body,
        void 0,
        void 0,
        void 0,
        funcNode.async || void 0
      );
      const { code: resultCode } = (0, import_generator7.default)(targetNode, { sourceMaps: false });
      return resultCode;
    }
    throw new Error("Can not find Function Statement");
  }
  function getArrowFunction(content) {
    const funcNode = parseFunction(content);
    if (funcNode) {
      const targetNode = t2.arrowFunctionExpression(
        funcNode.params,
        funcNode.body,
        funcNode.async || void 0
      );
      const { code: resultCode } = (0, import_generator7.default)(targetNode, { sourceMaps: false });
      return resultCode;
    }
    return content;
  }
  function getBodyStatements(content) {
    const funcNode = parseFunction(content);
    if (funcNode) {
      const statements = funcNode.body.body;
      const targetNode = t2.program(statements, void 0, "module", void 0);
      const { code: resultCode } = (0, import_generator7.default)(targetNode, { sourceMaps: false });
      return resultCode;
    }
    throw new Error("Can not find Function Statement");
  }
  function isBroadJSFunction(value) {
    return isJSExpressionFn(value) || isJSFunction(value);
  }
  function generateExpression(value, scope) {
    var _a;
    if (isJSExpression(value)) {
      const exprVal = (_a = value.value) == null ? void 0 : _a.trim();
      if (!exprVal) {
        return "null";
      }
      const afterProcessWithLocals = transformExpressionLocalRef(exprVal, scope);
      return afterProcessWithLocals;
    }
    throw new CodeGeneratorError("Not a JSExpression");
  }
  function getFunctionSource(cfg) {
    return cfg.source || cfg.value || cfg.compiled || "";
  }
  function generateFunction(value, config3 = {
    name: void 0,
    isMember: false,
    isBlock: false,
    isArrow: false,
    isBindExpr: false
  }) {
    if (isBroadJSFunction(value)) {
      const functionCfg = value;
      const functionSource = getFunctionSource(functionCfg);
      if (config3.isMember) {
        return transformFuncExpr2MethodMember(config3.name || "", functionSource);
      }
      if (config3.isBlock) {
        return getBodyStatements(functionSource);
      }
      if (config3.isArrow) {
        return getArrowFunction(functionSource);
      }
      if (config3.isBindExpr) {
        return `(${functionSource}).bind(this)`;
      }
      return functionSource;
    }
    if (isJSExpression(value)) {
      return value.value;
    }
    throw new CodeGeneratorError("Not a JSFunction or JSExpression");
  }

  // src/utils/jsSlot.ts
  var jsSlot_exports = {};
  __export(jsSlot_exports, {
    generateJsSlot: () => generateJsSlot
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/utils/jsxHelpers.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function unwrapJsExprQuoteInJsx(jsxExpr) {
    if (jsxExpr.length >= 2 && jsxExpr[0] === "{" && jsxExpr[jsxExpr.length - 1] === "}") {
      return jsxExpr.slice(1, jsxExpr.length - 1);
    }
    return jsxExpr;
  }

  // src/utils/jsSlot.ts
  function generateSingleLineComment(commentText) {
    return `/* ${commentText.split("\n").join(" ").replace(/\*\//g, "*-/")}*/`;
  }
  function generateJsSlot(slot, scope, generator) {
    if (isJSSlot(slot)) {
      const { title: title3, params, value } = slot;
      const slotScope = params ? scope.createSubScope(params || []) : scope;
      const contentExpr = !value ? "null" : generateNodeDataOrArrayForJsSlot(value, generator, slotScope);
      if (params) {
        return [
          title3 && generateSingleLineComment(title3),
          "(",
          (params || []).join(", "),
          ") => ((__$$context) => (",
          contentExpr,
          "))(",
          `  __$$createChildContext(__$$context, { ${(params || []).join(", ")} }`,
          "))"
        ].filter(Boolean).join("");
      }
      return contentExpr || "[]";
    }
    throw new CodeGeneratorError("Not a JSSlot");
  }
  function generateNodeDataOrArrayForJsSlot(value, generator, scope) {
    if (Array.isArray(value)) {
      if (value.length === 0) {
        return "[]";
      }
      if (value.length === 1) {
        return unwrapJsExprQuoteInJsx(generator(value, scope)) || "null";
      }
      return `[
${value.map((v, index) => {
        var _a;
        if (typeof v === "string") {
          return JSON.stringify(v);
        }
        let nodeData = v;
        if (isNodeSchema(v) && !((_a = v.props) == null ? void 0 : _a.key)) {
          nodeData = {
            ...v,
            props: {
              key: index,
              ...v.props || {}
            }
          };
        }
        return unwrapJsExprQuoteInJsx(generator(nodeData, scope)) || "null";
      }).join(",\n") || "null"}
]`;
    }
    return unwrapJsExprQuoteInJsx(generator(value, scope)) || "null";
  }

  // src/utils/aopHelper.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function executeFunctionStack(input, scope, funcs, baseFunc, config3) {
    const funcList = [];
    if (Array.isArray(funcs)) {
      funcList.push(...funcs);
    } else {
      funcList.push(funcs);
    }
    let next = baseFunc;
    while (funcList.length > 0) {
      const func = funcList.pop();
      if (func) {
        const warppedFunc = ((nextFunc) => (i, s, cfg) => func(i, s, cfg, nextFunc))(next);
        next = warppedFunc;
      }
    }
    return next(input, scope, config3);
  }

  // src/utils/compositeType.ts
  function isVariable(v) {
    if (lodash_default_default.isObject(v) && v.type === "variable") {
      return true;
    }
    return false;
  }
  function isDataSource(v) {
    return typeof v === "object" && v != null && v.type === "DataSource";
  }
  function generateArray(value, scope, options = {}) {
    const body = value.map((v) => generateUnknownType(v, scope, options)).join(",");
    return `[${body}]`;
  }
  function generateObject(value, scope, options = {}) {
    if (value.type === "i18n") {
      const text = value["zh-CN"] || value[value.use] || value["en-US"] || "";
      if (value.params && typeof value.params === "object") {
        return `tr(${JSON.stringify(text)}, ${generateUnknownType(value.params, scope, options)})`;
      }
      return `tr(${JSON.stringify(text)})`;
    }
    const body = Object.keys(value).map((key) => {
      const propName = JSON.stringify(key);
      const v = generateUnknownType(value[key], scope, options);
      if (isJSExpressionSpread(value[key])) {
        return `...${v}`;
      }
      return `${propName}: ${v}`;
    }).join(",\n");
    return `{${body}}`;
  }
  function generateString(value) {
    return JSON.stringify(value);
  }
  function generateNumber(value) {
    return String(value);
  }
  function generateBool(value) {
    return value ? "true" : "false";
  }
  function genFunction(value) {
    const globalVars = parseExpressionGetKeywords(value.value);
    if (globalVars.includes("arguments")) {
      return generateFunction(value, { isBindExpr: true });
    }
    return generateFunction(value, { isArrow: true });
  }
  function genJsSlot(value, scope, options = {}) {
    if (options.nodeGenerator) {
      return generateJsSlot(value, scope, options.nodeGenerator);
    }
    return "";
  }
  function generateUnknownType(value, scope, options = {}) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    if (lodash_default_default.isUndefined(value)) {
      return "undefined";
    }
    if (lodash_default_default.isNull(value)) {
      return "null";
    }
    if (lodash_default_default.isArray(value)) {
      if ((_a = options.handlers) == null ? void 0 : _a.array) {
        return executeFunctionStack(value, scope, options.handlers.array, generateArray, options);
      }
      return generateArray(value, scope, options);
    }
    if (isVariable(value)) {
      const transValue = {
        type: "JSExpression",
        value: value.variable
      };
      if ((_b = options.handlers) == null ? void 0 : _b.expression) {
        const expression = executeFunctionStack(
          transValue,
          scope,
          options.handlers.expression,
          generateExpression,
          options
        );
        return expression || "undefined";
      }
      return generateExpression(transValue, scope);
    }
    if (isJSExpression(value)) {
      if ((_c = options.handlers) == null ? void 0 : _c.expression) {
        const str = executeFunctionStack(
          value,
          scope,
          options.handlers.expression,
          generateExpression,
          options
        );
        return str;
      }
      return generateExpression(value, scope);
    }
    if (isJSFunction(value) || isJSExpressionFn(value)) {
      if ((_d = options.handlers) == null ? void 0 : _d.function) {
        return executeFunctionStack(value, scope, options.handlers.function, genFunction, options);
      }
      return genFunction(value);
    }
    if (isJSSlot(value)) {
      if ((_e = options.handlers) == null ? void 0 : _e.slot) {
        return executeFunctionStack(value, scope, options.handlers.slot, genJsSlot, options);
      }
      return genJsSlot(value, scope, options);
    }
    if (isDataSource(value)) {
      return generateUnknownType(
        {
          type: "JSExpression",
          value: `this.dataSourceMap[${JSON.stringify(value.id)}]`
        },
        scope,
        options
      );
    }
    if (lodash_default_default.isObject(value)) {
      if ((_f = options.handlers) == null ? void 0 : _f.object) {
        return executeFunctionStack(
          value,
          scope,
          options.handlers.object,
          generateObject,
          options
        );
      }
      return generateObject(value, scope, options);
    }
    if (lodash_default_default.isString(value)) {
      if ((_g = options.handlers) == null ? void 0 : _g.string) {
        return executeFunctionStack(value, scope, options.handlers.string, generateString, options);
      }
      return generateString(value);
    }
    if (lodash_default_default.isNumber(value)) {
      if ((_h = options.handlers) == null ? void 0 : _h.number) {
        return executeFunctionStack(value, scope, options.handlers.number, generateNumber, options);
      }
      return generateNumber(value);
    }
    if (lodash_default_default.isBoolean(value)) {
      if ((_i = options.handlers) == null ? void 0 : _i.boolean) {
        return executeFunctionStack(value, scope, options.handlers.boolean, generateBool, options);
      }
      return generateBool(value);
    }
    throw new CodeGeneratorError("Meet unknown composite value type");
  }
  function generateCompositeType(value, scope, options = {}) {
    const result2 = generateUnknownType(value, scope, options);
    return result2;
  }

  // src/utils/Scope.ts
  var Scope_exports = {};
  __export(Scope_exports, {
    Scope: () => Scope
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/utils/ScopeBindings.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var ScopeBindings = class {
    constructor(p = null) {
      __publicField(this, "parent");
      __publicField(this, "_bindings", new OrderedSet());
      this.parent = p;
    }
    hasBinding(varName) {
      var _a;
      return this._bindings.has(varName) || !!((_a = this.parent) == null ? void 0 : _a.hasBinding(varName));
    }
    hasOwnBinding(varName) {
      return this._bindings.has(varName);
    }
    addBinding(varName) {
      this._bindings.add(varName);
    }
    removeBinding(varName) {
      this._bindings.delete(varName);
    }
    getAllBindings() {
      const allBindings = new OrderedSet(this._bindings.toArray());
      for (let { parent: parent2 } = this; parent2; parent2 = parent2 == null ? void 0 : parent2.parent) {
        parent2.getAllOwnedBindings().forEach((varName) => {
          allBindings.add(varName);
        });
      }
      return allBindings.toArray();
    }
    getAllOwnedBindings() {
      return this._bindings.toArray();
    }
  };

  // src/utils/Scope.ts
  var Scope = class {
    constructor(parent2 = null) {
      this.parent = parent2;
      __publicField(this, "bindings");
      this.bindings = void 0;
    }
    static createRootScope() {
      return new Scope();
    }
    createSubScope(ownIdentifiers) {
      const originalScopeBindings = this.bindings;
      const newScopeBindings = new ScopeBindings(originalScopeBindings);
      ownIdentifiers.forEach((identifier3) => {
        newScopeBindings.addBinding(identifier3);
      });
      const newScope = new Scope(this);
      newScope.bindings = newScopeBindings;
      return newScope;
    }
  };

  // src/plugins/component/react/containerInitState.ts
  var pluginFactory4 = (config3) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      implementType: "inConstructor",
      ...config3
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const state = ir.state || {};
      const fields = Object.keys(state).map((stateName) => {
        const value = generateCompositeType(state[stateName], scope);
        return `${stateName}: ${value},`;
      });
      if (cfg.implementType === "inConstructor") {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: `this.state = { ${fields.join("")} };`,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
      } else if (cfg.implementType === "insMember") {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `state = { ${fields.join("")} };`,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsVar]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInitState_default = pluginFactory4;

  // src/plugins/component/react/containerInjectContext.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory5 = (config3) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config3
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const { inStrictMode } = next.contextData;
      if (!inStrictMode) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `
          _context = this;
        `,
          linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
        });
      } else {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `
          _context = this._createContext();
        `,
          linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
          content: `
          _createContext() {
            const self = this;
            const context = {
              get state() { return self.state; },
              setState(newState, callback) { self.setState(newState, callback); },
              get dataSourceMap() { return self._dataSourceEngine.dataSourceMap || {}; },
              async reloadDataSource() { await self._dataSourceEngine.reloadDataSource(); },
              get utils() { return self.utils; },
              get page() { return context; },
              get component() { return context; },
              get props() { return self.props; },
              get constants() { return self.constants; },
              get $() { return self.$ },
              get $$() { return self.$$ },
              ...this._methods,
            };
  
            return context;
          }
        `,
          linkAfter: DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInjectContext_default = pluginFactory5;

  // src/plugins/component/react/containerInjectUtils.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory6 = (config3) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config3
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `

      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      return next;
    };
    return plugin;
  };
  var containerInjectUtils_default = pluginFactory6;

  // src/plugins/component/react/containerInjectDataSourceEngine.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var import_change_case4 = __toESM(require_change_case());
  var pluginFactory7 = (config3) => {
    const cfg = {
      ...config3,
      fileType: (config3 == null ? void 0 : config3.fileType) || "jsx" /* JSX */
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const scope = Scope.createRootScope();
      const dataSourceConfig = isValidContainerType(pre.ir) ? pre.ir.dataSource : null;
      const dataSourceItems = dataSourceConfig && dataSourceConfig.list || [];
      const dataSourceEngineOptions = { runtimeConfig: true };
      if (dataSourceItems.length > 0) {
        const requestHandlersMap = {};
        dataSourceItems.forEach((ds) => {
          var _a, _b;
          const dsType = ds.type || "fetch";
          if (!(dsType in requestHandlersMap) && dsType !== "custom") {
            const handlerFactoryName = `__$$create${import_change_case4.default.pascal(dsType)}RequestHandler`;
            requestHandlersMap[dsType] = {
              type: "JSExpression",
              value: handlerFactoryName + (dsType === "urlParams" ? "(window.location.search)" : "()")
            };
            const handlerFactoryExportName = `create${import_change_case4.default.pascal(dsType)}Handler`;
            const handlerPkgName = ((_b = (_a = cfg.datasourceConfig) == null ? void 0 : _a.handlersPackages) == null ? void 0 : _b[dsType]) || `@alilc/lowcode-datasource-${import_change_case4.default.kebab(dsType)}-handler`;
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: "jsx" /* JSX */,
              name: COMMON_CHUNK_NAME.ExternalDepsImport,
              content: `
              import { ${handlerFactoryExportName} as ${handlerFactoryName} } from '${handlerPkgName}';
            `,
              linkAfter: []
            });
          }
        });
        Object.assign(dataSourceEngineOptions, { requestHandlersMap });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "jsx" /* JSX */,
          name: COMMON_CHUNK_NAME.ExternalDepsImport,
          content: `
          import { create as __$$createDataSourceEngine } from '@alilc/lowcode-datasource-engine/runtime';
        `,
          linkAfter: []
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `
          _dataSourceConfig = this._defineDataSourceConfig();
          _dataSourceEngine = __$$createDataSourceEngine(
            this._dataSourceConfig,
            this,
            ${generateCompositeType(dataSourceEngineOptions, scope)}
          );

          get dataSourceMap() {
            return this._dataSourceEngine.dataSourceMap || {};
          }

          reloadDataSource = async () => {
            await this._dataSourceEngine.reloadDataSource();
          }

          `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsVar]]
        });
        next.chunks.unshift({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: REACT_CHUNK_NAME.ClassDidMountContent,
          content: `
          this._dataSourceEngine.reloadDataSource();
        `,
          linkAfter: [REACT_CHUNK_NAME.ClassDidMountStart]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: `
  _defineDataSourceConfig() {
    const _this = this;
    return (${generateCompositeType(
            {
              ...dataSourceConfig,
              list: [
                ...dataSourceItems.map((item) => ({
                  ...item,
                  isInit: wrapAsFunction(item.isInit, scope),
                  options: wrapAsFunction(item.options, scope)
                }))
              ]
            },
            scope,
            {
              handlers: {
                function: (jsFunc) => parseExpressionConvertThis2Context(jsFunc.value, "_this"),
                expression: (jsExpr) => parseExpressionConvertThis2Context(jsExpr.value, "_this")
              }
            }
          )});
  }
        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInjectDataSourceEngine_default = pluginFactory7;
  function wrapAsFunction(value, scope) {
    if (isJSExpression(value) || isJSFunction(value) || isJSExpressionFn(value)) {
      return {
        type: "JSExpression",
        value: `function(){ return ((${value.value}))}.bind(this)`
      };
    }
    return {
      type: "JSExpression",
      value: `function(){return((${generateCompositeType(value, scope)}))}.bind(this)`
    };
  }

  // src/plugins/component/react/containerInjectConstants.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory8 = (config3) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config3
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import __$$constants from '${getSlotRelativePath({
          contextData: next.contextData,
          modulePaths: next.ir.modulePaths,
          from: cfg.scope || "components",
          to: "constants",
          moduleName: next.ir.moduleName
        })}';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsVar,
        content: `
        get constants() {
          return __$$constants || {};
        }
        `,
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsVar]]
      });
      return next;
    };
    return plugin;
  };
  var containerInjectConstants_default = pluginFactory8;

  // src/plugins/component/react/containerInjectI18n.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory9 = (config3) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config3
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import * as __$$i18n from '${getSlotRelativePath({
          contextData: next.contextData,
          modulePaths: next.ir.modulePaths,
          from: cfg.scope || "components",
          to: "i18n",
          moduleName: next.ir.moduleName
        })}';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
        content: `
        __$$i18n._inject2(this);
      `,
        linkAfter: [
          ...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]
        ]
      });
      return next;
    };
    return plugin;
  };
  var containerInjectI18n_default = pluginFactory9;

  // src/plugins/component/react/containerLifeCycle.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory10 = (config3) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      exportNameMapping: {},
      normalizeNameMapping: {},
      ...config3
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      if (ir.lifeCycles) {
        const { lifeCycles } = ir;
        const chunks = Object.keys(lifeCycles).map((lifeCycleName) => {
          var _a;
          if (!isJSFunction(lifeCycles[lifeCycleName]) && !isJSExpressionFn(lifeCycles[lifeCycleName]) && !isJSExpression(lifeCycles[lifeCycleName])) {
            return null;
          }
          let normalizeName;
          if (lifeCycleName === "constructor") {
            normalizeName = lifeCycleName;
          } else {
            normalizeName = cfg.normalizeNameMapping[lifeCycleName] || lifeCycleName;
          }
          if ((_a = cfg == null ? void 0 : cfg.exclude) == null ? void 0 : _a.includes(normalizeName)) {
            return null;
          }
          const exportName = cfg.exportNameMapping[lifeCycleName] || lifeCycleName;
          if (normalizeName === "constructor") {
            return {
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
              content: generateFunction(lifeCycles[lifeCycleName], { isBlock: true }),
              linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorStart]]
            };
          }
          if (normalizeName === "componentDidMount") {
            return {
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: REACT_CHUNK_NAME.ClassDidMountContent,
              content: generateFunction(lifeCycles[lifeCycleName], { isBlock: true }),
              linkAfter: [REACT_CHUNK_NAME.ClassDidMountStart]
            };
          }
          if (normalizeName === "render") {
            return {
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: REACT_CHUNK_NAME.ClassRenderPre,
              content: generateFunction(lifeCycles[lifeCycleName], { isBlock: true }),
              linkAfter: [REACT_CHUNK_NAME.ClassRenderStart]
            };
          }
          return {
            type: "string" /* STRING */,
            fileType: cfg.fileType,
            name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
            content: generateFunction(lifeCycles[lifeCycleName], {
              name: exportName,
              isMember: true
            }),
            linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
          };
        }).filter((i) => !!i);
        next.chunks.push(...chunks.filter((x) => x !== null));
      }
      return next;
    };
    return plugin;
  };
  var containerLifeCycle_default = pluginFactory10;

  // src/plugins/component/react/containerMethod.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory11 = (config3) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config3
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const { inStrictMode } = next.contextData;
      if (!ir.methods) {
        return next;
      }
      const { methods } = ir;
      const chunks = Object.keys(methods).map((methodName) => ({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
        content: generateFunction(methods[methodName], { name: methodName, isMember: true }),
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
      }));
      next.chunks.push(...chunks);
      if (inStrictMode) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: Object.keys(ir.methods).map(
            (methodName) => isValidIdentifier(methodName) ? `.${methodName}` : `[${JSON.stringify(methodName)}]`
          ).map((method2) => `this._context${method2} = this${method2};`).join("\n"),
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerMethod_default = pluginFactory11;

  // src/plugins/component/react/jsx.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/utils/nodeToJSX.ts
  var nodeToJSX_exports = {};
  __export(nodeToJSX_exports, {
    createNodeGenerator: () => createNodeGenerator,
    createReactFunctionNodeGenerator: () => createReactFunctionNodeGenerator,
    createReactNodeGenerator: () => createReactNodeGenerator,
    generateConditionReactCtrl: () => generateConditionReactCtrl,
    generateReactExprInJS: () => generateReactExprInJS,
    generateReactFunctionLoopCtrl: () => generateReactFunctionLoopCtrl,
    generateReactLoopCtrl: () => generateReactLoopCtrl,
    isPureString: () => isPureString
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // ../../node_modules/.pnpm/fp-ts@2.16.9/node_modules/fp-ts/es6/function.js
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function pipe(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch (arguments.length) {
      case 1:
        return a;
      case 2:
        return ab(a);
      case 3:
        return bc(ab(a));
      case 4:
        return cd(bc(ab(a)));
      case 5:
        return de(cd(bc(ab(a))));
      case 6:
        return ef(de(cd(bc(ab(a)))));
      case 7:
        return fg(ef(de(cd(bc(ab(a))))));
      case 8:
        return gh(fg(ef(de(cd(bc(ab(a)))))));
      case 9:
        return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
      default: {
        var ret = arguments[0];
        for (var i = 1; i < arguments.length; i++) {
          ret = arguments[i](ret);
        }
        return ret;
      }
    }
  }

  // src/utils/encodeJsxAttrString.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var SPECIAL_CHARS = `
\r'"<>&`;
  var SPECIAL_CHARS_REG = new RegExp(
    `[${SPECIAL_CHARS.split("").map((c) => `\\x${lodash_default_default.padStart(c.charCodeAt(0).toString(16), 2, "0")}`).join("")}]`,
    "g"
  );
  function encodeJsxStringNode(str) {
    return str.replace(SPECIAL_CHARS_REG, (c) => `&#${c.charCodeAt(0)};`);
  }

  // src/core/jsx/handlers/transformThis2Context.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var import_generator16 = __toESM(require_lib6());
  function transformThis2Context(expr, scope, { ignoreRootScope = false } = {}) {
    var _a;
    if (ignoreRootScope && scope.parent == null) {
      return typeof expr === "string" ? expr : (0, import_generator16.default)(expr).code;
    }
    return parseExpressionConvertThis2Context(
      expr,
      "__$$context",
      ((_a = scope.bindings) == null ? void 0 : _a.getAllBindings()) || []
    );
  }

  // src/utils/nodeToJSX.ts
  function mergeNodeGeneratorConfig(cfg1, cfg2 = {}) {
    const resCfg = {};
    if (cfg1.handlers || cfg2.handlers) {
      resCfg.handlers = {
        ...cfg1.handlers || {},
        ...cfg2.handlers || {}
      };
    }
    if (cfg1.tagMapping || cfg2.tagMapping) {
      resCfg.tagMapping = cfg2.tagMapping || cfg1.tagMapping;
    }
    if (cfg1.attrPlugins || cfg2.attrPlugins) {
      resCfg.attrPlugins = [];
      resCfg.attrPlugins.push(...cfg2.attrPlugins || []);
      resCfg.attrPlugins.push(...cfg1.attrPlugins || []);
    }
    if (cfg1.nodePlugins || cfg2.nodePlugins) {
      resCfg.nodePlugins = [];
      resCfg.nodePlugins.push(...cfg2.nodePlugins || []);
      resCfg.nodePlugins.push(...cfg1.nodePlugins || []);
    }
    return resCfg;
  }
  function isPureString(v) {
    return v[0] === "'" && v[v.length - 1] === "'" || v[0] === '"' && v[v.length - 1] === '"';
  }
  function generateAttrValue(attrData, scope, config3) {
    const valueStr = generateCompositeType(attrData.attrValue, scope, {
      handlers: config3 == null ? void 0 : config3.handlers,
      nodeGenerator: config3 == null ? void 0 : config3.self
    });
    return [
      {
        type: "NodeCodePieceAttr" /* ATTR */,
        name: attrData.attrName,
        value: valueStr,
        extType: isJSExpressionSpread(attrData.attrValue) ? "spread" : void 0
      }
    ];
  }
  function generateAttr(attrName, attrValue, scope, config3) {
    let pieces;
    if (config3 == null ? void 0 : config3.attrPlugins) {
      pieces = executeFunctionStack(
        { attrName, attrValue },
        scope,
        config3.attrPlugins,
        generateAttrValue,
        config3
      );
    } else {
      pieces = generateAttrValue({ attrName, attrValue }, scope, config3);
    }
    pieces = pieces.map((p) => {
      let newValue;
      if (p.value && isPureString(p.value)) {
        const content = getStaticExprValue(p.value);
        newValue = JSON.stringify(encodeJsxStringNode(content));
      } else {
        newValue = `{${p.value}}`;
      }
      if (p.extType === "spread") {
        newValue = newValue.replace("{", "{...");
      } else {
        newValue = `${p.name}=${newValue}`;
      }
      return {
        value: newValue,
        type: "NodeCodePieceAttr" /* ATTR */
      };
    });
    return pieces;
  }
  function generateAttrs(nodeItem, scope, config3) {
    const { props } = nodeItem;
    let pieces = [];
    if (props) {
      if (!Array.isArray(props)) {
        Object.keys(props).forEach((propName) => {
          if (isValidIdentifier(propName)) {
            pieces = pieces.concat(
              generateAttr(propName, props[propName], scope, config3)
            );
          }
        });
      } else {
        props.forEach((prop) => {
          if (prop.name && isValidIdentifier(prop.name) && !prop.spread) {
            pieces = pieces.concat(generateAttr(prop.name, prop.value, scope, config3));
          }
        });
      }
    }
    return pieces;
  }
  function generateBasicNode(nodeItem, scope, config3) {
    const pieces = [];
    const tagName = ((config3 == null ? void 0 : config3.tagMapping) || lodash_default_default.identity)(nodeItem.componentName);
    pieces.push({
      value: tagName || "",
      type: "NodeCodePieceTag" /* TAG */
    });
    return pieces;
  }
  function generateSimpleNode(nodeItem, scope, config3) {
    const basicParts = generateBasicNode(nodeItem, scope, config3) || [];
    const attrParts = generateAttrs(nodeItem, scope, config3) || [];
    const childrenParts = [];
    if (nodeItem.children && (config3 == null ? void 0 : config3.self)) {
      const childrenStr = config3.self(nodeItem.children, scope);
      childrenParts.push({
        type: "NodeCodePieceChildren" /* CHILDREN */,
        value: childrenStr
      });
    }
    return [...basicParts, ...attrParts, ...childrenParts];
  }
  function linkPieces(pieces) {
    const tagsPieces = pieces.filter((p) => p.type === "NodeCodePieceTag" /* TAG */);
    if (tagsPieces.length !== 1) {
      throw new CodeGeneratorError("Only one tag definition required", tagsPieces);
    }
    const tagName = tagsPieces[0].value;
    const beforeParts = pieces.filter((p) => p.type === "NodeCodePieceBefore" /* BEFORE */).map((p) => p.value).join("");
    const afterParts = pieces.filter((p) => p.type === "NodeCodePieceAfter" /* AFTER */).map((p) => p.value).join("");
    const childrenParts = pieces.filter((p) => p.type === "NodeCodePieceChildren" /* CHILDREN */).map((p) => p.value).join("");
    let attrsParts = pieces.filter((p) => p.type === "NodeCodePieceAttr" /* ATTR */).map((p) => p.value).join(" ");
    attrsParts = attrsParts ? ` ${attrsParts}` : "";
    if (tagName === "Fragment" || tagName === "") {
      if (childrenParts) {
        if (attrsParts.trim()) {
          return `${beforeParts}<React.Fragment${attrsParts}>${childrenParts}</React.Fragment>${afterParts}`;
        } else {
          return `${beforeParts}<>${childrenParts}</>${afterParts}`;
        }
      }
      return "";
    }
    if (childrenParts) {
      return `${beforeParts}<${tagName}${attrsParts}>${childrenParts}</${tagName}>${afterParts}`;
    }
    return `${beforeParts}<${tagName}${attrsParts} />${afterParts}`;
  }
  function generateNodeSchema(nodeItem, scope, config3) {
    const pieces = [];
    if (config3 == null ? void 0 : config3.nodePlugins) {
      const res = executeFunctionStack(
        nodeItem,
        scope,
        config3.nodePlugins,
        generateSimpleNode,
        config3
      );
      pieces.push(...res);
    } else {
      pieces.push(...generateSimpleNode(nodeItem, scope, config3));
    }
    return linkPieces(pieces);
  }
  function generateReactLoopCtrl(nodeItem, scope, config3, next) {
    var _a, _b, _c;
    if (nodeItem.loop) {
      const tolerateEvalErrors = (_a = config3 == null ? void 0 : config3.tolerateEvalErrors) != null ? _a : true;
      const loopItemName = ((_b = nodeItem.loopArgs) == null ? void 0 : _b[0]) || "item";
      const loopIndexName = ((_c = nodeItem.loopArgs) == null ? void 0 : _c[1]) || "index";
      const subScope = scope.createSubScope([loopItemName, loopIndexName]);
      const pieces = next ? next(nodeItem, subScope, config3) : [];
      const loopDataExpr = pipe(
        nodeItem.loop,
        (expr) => generateCompositeType(expr, scope, {
          handlers: config3 == null ? void 0 : config3.handlers,
          tolerateEvalErrors: false
        }),
        (expr) => transformThis2Context(expr, scope, { ignoreRootScope: true }),
        (expr) => tolerateEvalErrors ? `__$$evalArray(() => (${expr}))` : expr
      );
      pieces.unshift({
        value: `(${loopDataExpr}).map((${loopItemName}, ${loopIndexName}) => ((__$$context) => (`,
        type: "NodeCodePieceBefore" /* BEFORE */
      });
      pieces.push({
        value: `))(__$$createChildContext(__$$context, { ${loopItemName}, ${loopIndexName} })))`,
        type: "NodeCodePieceAfter" /* AFTER */
      });
      return pieces;
    }
    return next ? next(nodeItem, scope, config3) : [];
  }
  function generateReactFunctionLoopCtrl(nodeItem, scope, config3, next) {
    var _a, _b, _c;
    if (nodeItem.loop) {
      const tolerateEvalErrors = (_a = config3 == null ? void 0 : config3.tolerateEvalErrors) != null ? _a : true;
      const loopItemName = ((_b = nodeItem.loopArgs) == null ? void 0 : _b[0]) || "item";
      const loopIndexName = ((_c = nodeItem.loopArgs) == null ? void 0 : _c[1]) || "index";
      const subScope = scope.createSubScope([loopItemName, loopIndexName]);
      const pieces = next ? next(nodeItem, subScope, config3) : [];
      const loopDataExpr = pipe(
        nodeItem.loop,
        (expr) => generateCompositeType(expr, scope, {
          handlers: config3 == null ? void 0 : config3.handlers,
          tolerateEvalErrors: false
        }),
        (expr) => tolerateEvalErrors ? `__$$evalArray(() => (${expr}))` : expr
      );
      pieces.unshift({
        value: `(${loopDataExpr}).map((${loopItemName}, ${loopIndexName}) => `,
        type: "NodeCodePieceBefore" /* BEFORE */
      });
      pieces.push({
        value: ")",
        type: "NodeCodePieceAfter" /* AFTER */
      });
      return pieces;
    }
    return next ? next(nodeItem, scope, config3) : [];
  }
  function generateConditionReactCtrl(nodeItem, scope, config3, next) {
    const pieces = next ? next(nodeItem, scope, config3) : [];
    if (nodeItem.condition != null && nodeItem.condition !== true) {
      const value = generateCompositeType(nodeItem.condition, scope, {
        handlers: config3 == null ? void 0 : config3.handlers
      });
      pieces.unshift({
        value: `!!(${value}) && (`,
        type: "NodeCodePieceBefore" /* BEFORE */
      });
      pieces.push({
        value: ")",
        type: "NodeCodePieceAfter" /* AFTER */
      });
    }
    return pieces;
  }
  function generateReactExprInJS(nodeItem, scope, config3, next) {
    const pieces = next ? next(nodeItem, scope, config3) : [];
    if (nodeItem.condition != null && nodeItem.condition !== true || nodeItem.loop != null) {
      pieces.unshift({
        value: "{",
        type: "NodeCodePieceBefore" /* BEFORE */
      });
      pieces.push({
        value: "}",
        type: "NodeCodePieceAfter" /* AFTER */
      });
    }
    return pieces;
  }
  var handleChildren = (v) => v.join("");
  function createNodeGenerator(cfg = {}) {
    const generateNode = (nodeItem, scope) => {
      if (lodash_default_default.isArray(nodeItem)) {
        const resList = nodeItem.map((n) => generateNode(n, scope));
        return handleChildren(resList);
      }
      if (isNodeSchema(nodeItem)) {
        return generateNodeSchema(nodeItem, scope, {
          ...cfg,
          self: generateNode
        });
      }
      const valueStr = generateCompositeType(nodeItem, scope, {
        handlers: cfg.handlers,
        nodeGenerator: generateNode
      });
      if (isPureString(valueStr)) {
        return encodeJsxStringNode(getStaticExprValue(valueStr));
      }
      return `{${valueStr}}`;
    };
    return (nodeItem, scope) => unwrapJsExprQuoteInJsx(generateNode(nodeItem, scope));
  }
  var defaultReactGeneratorConfig = {
    nodePlugins: [generateReactExprInJS, generateReactLoopCtrl, generateConditionReactCtrl]
  };
  var defaultReactFunctionGeneratorConfig = {
    nodePlugins: [generateReactExprInJS, generateReactFunctionLoopCtrl, generateConditionReactCtrl]
  };
  function createReactNodeGenerator(cfg) {
    const newCfg = mergeNodeGeneratorConfig(defaultReactGeneratorConfig, cfg);
    return createNodeGenerator(newCfg);
  }
  function createReactFunctionNodeGenerator(cfg) {
    const newCfg = mergeNodeGeneratorConfig(defaultReactFunctionGeneratorConfig, cfg);
    return createNodeGenerator(newCfg);
  }

  // src/core/jsx/handlers/transformJsExpression.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/core/jsx/util/isLiteralAtomicExpr.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isLiteralAtomicExpr(expr) {
    return expr === "null" || expr === "undefined" || expr === "true" || expr === "false" || /^-?\d+(\.\d+)?$/.test(expr);
  }

  // src/core/jsx/util/isSimpleStraightLiteral.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function isSimpleStraightLiteral(expr) {
    switch (expr.type) {
      case "BigIntLiteral":
      case "BooleanLiteral":
      case "DecimalLiteral":
      case "NullLiteral":
      case "NumericLiteral":
      case "RegExpLiteral":
      case "StringLiteral":
        return true;
      default:
        return false;
    }
  }

  // src/core/jsx/handlers/transformJsExpression.ts
  function transformJsExpr(expr, scope, { dontWrapEval = false, dontTransformThis2ContextAtRootScope = false } = {}) {
    if (!expr) {
      return "undefined";
    }
    if (isLiteralAtomicExpr(expr)) {
      return expr;
    }
    const exprAst = parseExpression2(expr);
    if (isSimpleStraightLiteral(exprAst)) {
      return expr;
    }
    if (dontWrapEval) {
      return transformThis2Context(exprAst, scope, {
        ignoreRootScope: dontTransformThis2ContextAtRootScope
      });
    }
    switch (exprAst.type) {
      case "ArrowFunctionExpression":
      case "FunctionExpression":
        return transformThis2Context(exprAst, scope, {
          ignoreRootScope: dontTransformThis2ContextAtRootScope
        });
      default:
        break;
    }
    return transformThis2Context(exprAst, scope, {
      ignoreRootScope: dontTransformThis2ContextAtRootScope
    });
  }

  // src/plugins/component/react/jsx.ts
  var pluginFactory12 = (config3) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      nodeTypeMapping: {},
      ...config3
    };
    const { nodeTypeMapping } = cfg;
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const { tolerateEvalErrors = true, evalErrorsHandler = "" } = next.contextData;
      const customHandlers = {
        expression(input, scope2, config4) {
          var _a;
          return transformJsExpr(generateExpression(input, scope2), scope2, {
            dontWrapEval: !((_a = config4 == null ? void 0 : config4.tolerateEvalErrors) != null ? _a : tolerateEvalErrors),
            dontTransformThis2ContextAtRootScope: true
          });
        },
        function(input, scope2) {
          return transformThis2Context(
            generateCompositeType(
              {
                type: "JSFunction",
                value: input.value || "function () {}"
              },
              Scope.createRootScope()
            ),
            scope2,
            { ignoreRootScope: true }
          );
        }
      };
      const generatorPlugins = {
        handlers: customHandlers,
        tagMapping: (v) => nodeTypeMapping[v] || v,
        tolerateEvalErrors
      };
      if (next.contextData.useRefApi) {
        generatorPlugins.attrPlugins = [
          (attrData, scope2, pluginCfg, nextFunc) => {
            if (attrData.attrName === "ref") {
              return [
                {
                  name: attrData.attrName,
                  value: `this._refsManager.linkRef('${attrData.attrValue}')`,
                  type: "NodeCodePieceAttr" /* ATTR */
                }
              ];
            }
            return nextFunc ? nextFunc(attrData, scope2, pluginCfg) : [];
          }
        ];
      }
      const generator = createReactNodeGenerator(generatorPlugins);
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const jsxContent = generator(ir, scope);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: REACT_CHUNK_NAME.ClassRenderJSX,
        content: `
        const __$$context = this._context || this;
        const { state } = __$$context;
        return ${jsxContent};
      `,
        linkAfter: [REACT_CHUNK_NAME.ClassRenderStart, REACT_CHUNK_NAME.ClassRenderPre]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.CustomContent,
        content: [
          tolerateEvalErrors && `
          function __$$eval(expr) {
            try {
              return expr();
            } catch (error) {
              ${evalErrorsHandler}
            }
          }

          function __$$evalArray(expr) {
            const res = __$$eval(expr);
            return Array.isArray(res) ? res : [];
          }
      `,
          `
        function __$$createChildContext(oldContext, ext) {
          const childContext = {
            ...oldContext,
            ...ext,
          };
          childContext.__proto__ = oldContext;
          return childContext;
        }
      `
        ].filter(Boolean).join("\n"),
        linkAfter: [COMMON_CHUNK_NAME.FileExport]
      });
      return next;
    };
    return plugin;
  };
  var jsx_default = pluginFactory12;

  // src/plugins/component/react/reactCommonDeps.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory13 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "tsx" /* TSX */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
        import React from 'react';`,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var reactCommonDeps_default = pluginFactory13;

  // src/plugins/component/style/css.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory14 = (config3) => {
    const cfg = {
      fileType: "css" /* CSS */,
      moduleFileType: "tsx" /* TSX */,
      ...config3
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const hasCssContent = ir.css && ir.css.trim().length > 0;
      if (hasCssContent) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: COMMON_CHUNK_NAME.StyleCssContent,
          content: ir.css,
          linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.moduleFileType,
          name: COMMON_CHUNK_NAME.InternalDepsImport,
          content: `import './index.${cfg.fileType}';`,
          linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
        });
      }
      return next;
    };
    return plugin;
  };
  var css_default = pluginFactory14;

  // src/plugins/project/constants.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory15 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const constantStr = generateCompositeType(ir.constants || {}, scope);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "ts" /* TS */,
        name: COMMON_CHUNK_NAME.FileVarDefine,
        content: `
        const __$$constants = (${constantStr});
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "ts" /* TS */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `
        export default __$$constants;
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          COMMON_CHUNK_NAME.FileMainContent
        ]
      });
      return next;
    };
    return plugin;
  };
  var constants_default = pluginFactory15;

  // src/plugins/project/i18n.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory16 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const i18nStr = ir.i18n ? JSON.stringify(ir.i18n, null, 2) : "{}";
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "ts" /* TS */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: `
        const i18nConfig = ${i18nStr};

        let locale = typeof navigator === 'object' && typeof navigator.language === 'string' ? navigator.language : 'zh-CN';

        const getLocale = () => locale;

        const setLocale = (target) => {
          locale = target;
        };

        const isEmptyVariables = variables => (
          Array.isArray(variables) && variables.length === 0
          || typeof variables === 'object' && (!variables || Object.keys(variables).length === 0)
        );

        // \u6309\u4F4E\u4EE3\u7801\u89C4\u8303\u91CC\u9762\u7684\u8981\u6C42\u8FDB\u884C\u53D8\u91CF\u66FF\u6362
        const format = (msg, variables) => (
          typeof msg === 'string'
            ? msg.replace(/\\$?\\{(\\w+)\\}/g, (match, key) => variables?.[key] ?? '')
            : msg
        );

        const i18nFormat = ({ id, defaultMessage, fallback }, variables) => {
          const msg = i18nConfig[locale]?.[id] ??  i18nConfig[locale.replace('-', '_')]?.[id] ??  defaultMessage;
          if (msg == null) {
            console.warn('[i18n]: unknown message id: %o (locale=%o)', id, locale);
            return fallback === undefined ? \`\${id}\` : fallback;
          }

          return format(msg, variables);
        }

        const i18n = (id, params) => {
          return i18nFormat({ id }, params);
        };

        // \u5C06\u56FD\u9645\u5316\u7684\u4E00\u4E9B\u65B9\u6CD5\u6CE8\u5165\u5230\u76EE\u6807\u5BF9\u8C61&\u4E0A\u4E0B\u6587\u4E2D
        const _inject2 = (target) => {
          target.i18n = i18n;
          target.getLocale = getLocale;
          target.setLocale = (locale) => {
            setLocale(locale);
            target.forceUpdate();
          };
          target._i18nText = (t) => {
            // \u4F18\u5148\u53D6\u76F4\u63A5\u4F20\u8FC7\u6765\u7684\u8BED\u6599
            const localMsg = t[locale] ?? t[String(locale).replace('-', '_')]
            if (localMsg != null) {
              return format(localMsg, t.params);
            }

            // \u5176\u6B21\u7528\u9879\u76EE\u7EA7\u522B\u7684
            const projectMsg = i18nFormat({ id: t.key, fallback: null }, t.params);
            if (projectMsg != null) {
              return projectMsg;
            }

            // \u515C\u5E95\u7528 use \u6307\u5B9A\u7684\u6216\u9ED8\u8BA4\u8BED\u8A00\u7684
            return format(t[t.use || "zh-CN"] ?? t.en_US, t.params);
          }

          // \u6CE8\u5165\u5230\u4E0A\u4E0B\u6587\u4E2D\u53BB
          if (target._context && target._context !== target) {
            Object.assign(target._context, {
              i18n,
              getLocale, setLocale: target.setLocale
            });
          }
        }
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "ts" /* TS */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `
        export {
          getLocale,
          setLocale,
          i18n,
          i18nFormat,
          _inject2,
        };
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          COMMON_CHUNK_NAME.FileMainContent
        ]
      });
      return next;
    };
    return plugin;
  };
  var i18n_default = pluginFactory16;

  // src/plugins/project/utils.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory17 = (baseFramework) => {
    const plugin = async (pre) => {
      const framework = baseFramework || "react";
      const next = {
        ...pre
      };
      const ir = next.ir;
      if (ir.utils) {
        const allDependencies = ir.utils.map((util) => util.dependencies).filter(Boolean);
        for (const dep of allDependencies) {
          next.chunks.push({
            type: "string" /* STRING */,
            fileType: "tsx" /* TSX */,
            name: COMMON_CHUNK_NAME.ExternalDepsImport,
            content: dep,
            linkAfter: []
          });
        }
        const exportUtils = ir.utils.filter((util) => util.export);
        const exportDefaultUtils = ir.utils.filter((util) => !util.export);
        if (exportUtils) {
          exportUtils.forEach((util) => {
            if (util.type === "function") {
              next.chunks.push({
                type: "string" /* STRING */,
                fileType: "tsx" /* TSX */,
                name: COMMON_CHUNK_NAME.FileExport,
                content: `
                export const ${util.name} = ${util.content.value};
              `,
                linkAfter: [
                  COMMON_CHUNK_NAME.ExternalDepsImport,
                  COMMON_CHUNK_NAME.InternalDepsImport,
                  COMMON_CHUNK_NAME.ImportAliasDefine
                ]
              });
            }
          });
        }
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "tsx" /* TSX */,
          name: COMMON_CHUNK_NAME.FileExport,
          content: `
          export default {
        `,
          linkAfter: [
            COMMON_CHUNK_NAME.ExternalDepsImport,
            COMMON_CHUNK_NAME.InternalDepsImport,
            COMMON_CHUNK_NAME.ImportAliasDefine,
            COMMON_CHUNK_NAME.FileVarDefine,
            COMMON_CHUNK_NAME.FileUtilDefine,
            COMMON_CHUNK_NAME.FileMainContent
          ]
        });
        exportDefaultUtils.forEach((util) => {
          if (util.type === "function") {
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: "tsx" /* TSX */,
              name: COMMON_CHUNK_NAME.FileVarDefine,
              content: `
              const ${util.name} = ${util.content.value};
            `,
              linkAfter: [
                COMMON_CHUNK_NAME.ExternalDepsImport,
                COMMON_CHUNK_NAME.InternalDepsImport,
                COMMON_CHUNK_NAME.ImportAliasDefine
              ]
            });
          }
          next.chunks.push({
            type: "string" /* STRING */,
            fileType: "tsx" /* TSX */,
            name: COMMON_CHUNK_NAME.FileExport,
            content: `${util.name},`,
            linkAfter: [
              COMMON_CHUNK_NAME.ExternalDepsImport,
              COMMON_CHUNK_NAME.InternalDepsImport,
              COMMON_CHUNK_NAME.ImportAliasDefine,
              COMMON_CHUNK_NAME.FileVarDefine,
              COMMON_CHUNK_NAME.FileUtilDefine,
              COMMON_CHUNK_NAME.FileMainContent
            ]
          });
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "tsx" /* TSX */,
          name: COMMON_CHUNK_NAME.FileExport,
          content: `
          };
        `,
          linkAfter: [
            COMMON_CHUNK_NAME.ExternalDepsImport,
            COMMON_CHUNK_NAME.InternalDepsImport,
            COMMON_CHUNK_NAME.ImportAliasDefine,
            COMMON_CHUNK_NAME.FileVarDefine,
            COMMON_CHUNK_NAME.FileUtilDefine,
            COMMON_CHUNK_NAME.FileMainContent
          ]
        });
      }
      return next;
    };
    return plugin;
  };
  var utils_default = pluginFactory17;

  // src/plugins/project/framework/gant/index.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/plugins/project/framework/gant/template/index.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/plugins/project/framework/gant/template/static-files.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/utils/templateHelper.ts
  var templateHelper_exports = {};
  __export(templateHelper_exports, {
    insertFile: () => insertFile,
    runFileGenerator: () => runFileGenerator
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function insertFile(root2, path, file2) {
    let current = root2;
    path.forEach((pathNode) => {
      const dir = current.dirs.find((d) => d.name === pathNode);
      if (dir) {
        current = dir;
      } else {
        let newDir = createResultDir(pathNode);
        newDir = addDirectory(current, newDir);
        current = newDir;
      }
    });
    addFile(current, file2);
  }
  function runFileGenerator(root2, fun) {
    try {
      const result2 = fun();
      const [path, file2] = result2;
      insertFile(root2, path, file2);
    } catch (error) {
      throw new Error(`Error: ${typeof fun}`);
    }
  }

  // src/plugins/project/framework/gant/template/files/.editorconfig.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile() {
    return [
      ["."],
      {
        name: ".editorconfig",
        ext: "",
        content: "# http://editorconfig.org\nroot = true\n\n[*]\nindent_style = space\nindent_size = 2\nend_of_line = lf\ncharset = utf-8\ntrim_trailing_whitespace = true\ninsert_final_newline = true\n\n[*.md]\ntrim_trailing_whitespace = false\n\n[Makefile]\nindent_style = tab\n"
      }
    ];
  }

  // src/plugins/project/framework/gant/template/files/.gitignore.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile2() {
    return [
      ["."],
      {
        name: ".gitignore",
        ext: "",
        content: "# See https://help.github.com/articles/ignoring-files/ for more about ignoring files.\n\n# dependencies\n/node_modules\n/npm-debug.log*\n/yarn-error.log\n/yarn.lock\n/package-lock.json\n\n# production\n/dist\n\n# misc\n.DS_Store\n\n# umi\n/src/.umi\n/src/.umi-production\n/src/.umi-test\n/.env.local\n"
      }
    ];
  }

  // src/plugins/project/framework/gant/template/files/.prettierignore.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile3() {
    return [
      ["."],
      {
        name: ".prettierignore",
        ext: "",
        content: "**/*.md\n**/*.svg\n**/*.ejs\n**/*.html\npackage.json\n.umi\n.umi-production\n.umi-test\n"
      }
    ];
  }

  // src/plugins/project/framework/gant/template/files/.prettierrc.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile4() {
    return [
      ["."],
      {
        name: ".prettierrc",
        ext: "",
        content: '{\n  "singleQuote": true,\n  "trailingComma": "all",\n  "printWidth": 80,\n  "overrides": [\n    {\n      "files": ".prettierrc",\n      "options": { "parser": "json" }\n    }\n  ]\n}\n'
      }
    ];
  }

  // src/plugins/project/framework/gant/template/files/.umirc.ts.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile5() {
    return [
      ["."],
      {
        name: ".umirc",
        ext: "ts",
        content: "import { defineConfig } from 'umi';\n\nexport default defineConfig({\n  nodeModulesTransform: {\n    type: 'none',\n  },\n  routes: [\n    { path: '/', component: '@/pages/index' },\n  ],\n  fastRefresh: {},\n});\n"
      }
    ];
  }

  // src/plugins/project/framework/gant/template/files/package.json.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile6() {
    return [
      ["."],
      {
        name: "package",
        ext: "json",
        content: `{
  "private": true,
  "scripts": {
    "start": "umi dev",
    "build": "umi build",
    "postinstall": "umi generate tmp",
    "prettier": "prettier --write '**/*.{js,jsx,tsx,ts,less,md,json}'",
    "test": "umi-test",
    "test:coverage": "umi-test --coverage"
  },
  "gitHooks": {
    "pre-commit": "lint-staged"
  },
  "lint-staged": {
    "*.{js,jsx,less,md,json}": [
      "prettier --write"
    ],
    "*.ts?(x)": [
      "prettier --parser=typescript --write"
    ]
  },
  "dependencies": {
    "@ant-design/pro-layout": "^6.5.0",
    "react": "17.x",
    "react-dom": "17.x",
    "umi": "^3.5.43"
  },
  "devDependencies": {
    "@types/react": "^17.0.0",
    "@types/react-dom": "^17.0.0",
    "@umijs/preset-react": "1.x",
    "@umijs/test": "^3.5.43",
    "lint-staged": "^10.0.7",
    "prettier": "^2.2.0",
    "typescript": "^4.1.2",
    "yorkie": "^2.0.0"
  }
}
`
      }
    ];
  }

  // src/plugins/project/framework/gant/template/files/pnpm-lock.yaml.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile7() {
    return [
      ["."],
      {
        name: "pnpm-lock",
        ext: "yaml",
        content: "lockfileVersion: '9.0'\n\nsettings:\n  autoInstallPeers: true\n  excludeLinksFromLockfile: false\n\nimporters:\n\n  .:\n    dependencies:\n      '@ant-design/pro-layout':\n        specifier: ^6.5.0\n        version: 6.38.22(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react:\n        specifier: 17.x\n        version: 17.0.2\n      react-dom:\n        specifier: 17.x\n        version: 17.0.2(react@17.0.2)\n      umi:\n        specifier: ^3.5.43\n        version: 3.5.43(react-router@5.2.0(react@16.14.0))\n    devDependencies:\n      '@types/react':\n        specifier: ^17.0.0\n        version: 17.0.83\n      '@types/react-dom':\n        specifier: ^17.0.0\n        version: 17.0.26(@types/react@17.0.83)\n      '@umijs/preset-react':\n        specifier: 1.x\n        version: 1.8.32(@ant-design/icons@4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(@ant-design/pro-layout@6.38.22(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(dva-core@2.0.4(redux@4.2.1))(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@17.0.2))(react@17.0.2)(redbox-react@1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/test':\n        specifier: ^3.5.43\n        version: 3.5.43\n      lint-staged:\n        specifier: ^10.0.7\n        version: 10.5.4\n      prettier:\n        specifier: ^2.2.0\n        version: 2.8.8\n      typescript:\n        specifier: ^4.1.2\n        version: 4.9.5\n      yorkie:\n        specifier: ^2.0.0\n        version: 2.0.0\n\npackages:\n\n  '@ahooksjs/use-request@2.8.15':\n    resolution: {integrity: sha512-xhVaM4fyIiAMdVFuuU5i3CFUdFa/IblF+fvITVMFaUEO3w/V5tVCAF6WIA3T03n1/RPuzRkA7Ao1PFtSGtGelw==}\n    peerDependencies:\n      react: ^16.8.0 || ^17.0.0\n\n  '@ampproject/remapping@2.3.0':\n    resolution: {integrity: sha512-30iZtAPgz+LTIYoeivqYo853f02jBYSd5uGnGpkFV0M3xOt9aN73erkgYAmZU43x4VfqcnLxW9Kpg3R5LC4YYw==}\n    engines: {node: '>=6.0.0'}\n\n  '@ant-design/colors@6.0.0':\n    resolution: {integrity: sha512-qAZRvPzfdWHtfameEGP2Qvuf838NhergR35o+EuVyB5XvSA98xod5r4utvi4TJ3ywmevm290g9nsCG5MryrdWQ==}\n\n  '@ant-design/icons-svg@4.4.2':\n    resolution: {integrity: sha512-vHbT+zJEVzllwP+CM+ul7reTEfBR0vgxFe7+lREAsAA7YGsYpboiq2sQNeQeRvh09GfQgs/GyFEvZpJ9cLXpXA==}\n\n  '@ant-design/icons@4.8.3':\n    resolution: {integrity: sha512-HGlIQZzrEbAhpJR6+IGdzfbPym94Owr6JZkJ2QCCnOkPVIWMO2xgIVcOKnl8YcpijIo39V7l2qQL5fmtw56cMw==}\n    engines: {node: '>=8'}\n    peerDependencies:\n      react: '>=16.0.0'\n      react-dom: '>=16.0.0'\n\n  '@ant-design/pro-layout@6.38.22':\n    resolution: {integrity: sha512-rsxY2E0BTyRE7IO67VACWVPSfdtDnTaWtECuMnc4ctL+xmnzbnnr0zEHVQ+S58BxLnCqO3IyOsSc0nFl2hHsnQ==}\n    peerDependencies:\n      react: '>=16.9.0'\n\n  '@ant-design/pro-provider@1.10.0':\n    resolution: {integrity: sha512-gbQtq+Qlnob6aEghiWX/kXEzNhe4eOFlv5Ue2/xsal+22qvot/kFoOB652TD76fMI7vlkoema1pTKsvD5Uji6A==}\n    peerDependencies:\n      react: '>=16.9.0'\n\n  '@ant-design/pro-utils@1.45.3':\n    resolution: {integrity: sha512-W2qtyckdkHTWGVXfFfqb9s/ahq3o4GlIZC3+WDiGUgqJTsUkwY69yV67E2ZfAro1XRXblUzbvxIv96M7bEAfFg==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  '@ant-design/react-slick@1.0.2':\n    resolution: {integrity: sha512-Wj8onxL/T8KQLFFiCA4t8eIRGpRR+UPgOdac2sYzonv+i0n3kXHmvHLLiOYL655DQx2Umii9Y9nNgL7ssu5haQ==}\n    peerDependencies:\n      react: '>=16.9.0'\n\n  '@babel/code-frame@7.26.2':\n    resolution: {integrity: sha512-RJlIHRueQgwWitWgF8OdFYGZX328Ax5BCemNGlqHfplnRT9ESi8JkFlvaVYbS+UubVY6dpv87Fs2u5M29iNFVQ==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/compat-data@7.26.3':\n    resolution: {integrity: sha512-nHIxvKPniQXpmQLb0vhY3VaFb3S0YrTAwpOWJZh1wn3oJPjJk9Asva204PsBdmAE8vpzfHudT8DB0scYvy9q0g==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/core@7.18.6':\n    resolution: {integrity: sha512-cQbWBpxcbbs/IUredIPkHiAGULLV8iwgNRMFzvbhEXISp4f3rUUXE5+TIw6KwUWUR3DwyI6gmBRnmAtYaWehwQ==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/generator@7.26.3':\n    resolution: {integrity: sha512-6FF/urZvD0sTeO7k6/B15pMLC4CHUv1426lzr3N01aHJTl046uCAh9LXW/fzeXXjPNCJ6iABW5XaWOsIZB93aQ==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/helper-compilation-targets@7.25.9':\n    resolution: {integrity: sha512-j9Db8Suy6yV/VHa4qzrj9yZfZxhLWQdVnRlXxmKLYlhWUVB1sB2G5sxuWYXk/whHD9iW76PmNzxZ4UCnTQTVEQ==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/helper-module-imports@7.25.9':\n    resolution: {integrity: sha512-tnUA4RsrmflIM6W6RFTLFSXITtl0wKjgpnLgXyowocVPrbYrLUXSBXDgTs8BlbmIzIdlBySRQjINYs2BAkiLtw==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/helper-module-transforms@7.26.0':\n    resolution: {integrity: sha512-xO+xu6B5K2czEnQye6BHA7DolFFmS3LB7stHZFaOLb1pAwO1HWLS8fXA+eh0A2yIvltPVmx3eNNDBJA2SLHXFw==}\n    engines: {node: '>=6.9.0'}\n    peerDependencies:\n      '@babel/core': ^7.0.0\n\n  '@babel/helper-plugin-utils@7.25.9':\n    resolution: {integrity: sha512-kSMlyUVdWe25rEsRGviIgOWnoT/nfABVWlqt9N19/dIPWViAOW2s9wznP5tURbs/IDuNk4gPy3YdYRgH3uxhBw==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/helper-string-parser@7.25.9':\n    resolution: {integrity: sha512-4A/SCr/2KLd5jrtOMFzaKjVtAei3+2r/NChoBNoZ3EyP/+GlhoaEGoWOZUmFmoITP7zOJyHIMm+DYRd8o3PvHA==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/helper-validator-identifier@7.25.9':\n    resolution: {integrity: sha512-Ed61U6XJc3CVRfkERJWDz4dJwKe7iLmmJsbOGu9wSloNSFttHV0I8g6UAgb7qnK5ly5bGLPd4oXZlxCdANBOWQ==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/helper-validator-option@7.25.9':\n    resolution: {integrity: sha512-e/zv1co8pp55dNdEcCynfj9X7nyUKUXoUEwfXqaZt0omVOmDe9oOTdKStH4GmAw6zxMFs50ZayuMfHDKlO7Tfw==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/helpers@7.26.0':\n    resolution: {integrity: sha512-tbhNuIxNcVb21pInl3ZSjksLCvgdZy9KwJ8brv993QtIVKJBBkYXz4q4ZbAv31GdnC+R90np23L5FbEBlthAEw==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/parser@7.26.3':\n    resolution: {integrity: sha512-WJ/CvmY8Mea8iDXo6a7RK2wbmJITT5fN3BEkRuFlxVyNx8jOKIIhmC4fSkTcPcf8JyavbBwIe6OpiCOBXt/IcA==}\n    engines: {node: '>=6.0.0'}\n    hasBin: true\n\n  '@babel/plugin-syntax-async-generators@7.8.4':\n    resolution: {integrity: sha512-tycmZxkGfZaxhMRbXlPXuVFpdWlXpir2W4AMhSJgRKzk/eDlIXOhb2LHWoLpDF7TEHylV5zNhykX6KAgHJmTNw==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-bigint@7.8.3':\n    resolution: {integrity: sha512-wnTnFlG+YxQm3vDxpGE57Pj0srRU4sHE/mDkt1qv2YJJSeUAec2ma4WLUnUPeKjyrfntVwe/N6dCXpU+zL3Npg==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-class-properties@7.12.13':\n    resolution: {integrity: sha512-fm4idjKla0YahUNgFNLCB0qySdsoPiZP3iQE3rky0mBUtMZ23yDJ9SJdg6dXTSDnulOVqiF3Hgr9nbXvXTQZYA==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-class-static-block@7.14.5':\n    resolution: {integrity: sha512-b+YyPmr6ldyNnM6sqYeMWE+bgJcJpO6yS4QD7ymxgH34GBPNDM/THBh8iunyvKIZztiwLH4CJZ0RxTk9emgpjw==}\n    engines: {node: '>=6.9.0'}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-import-attributes@7.26.0':\n    resolution: {integrity: sha512-e2dttdsJ1ZTpi3B9UYGLw41hifAubg19AtCu/2I/F1QNVclOBr1dYpTdmdyZ84Xiz43BS/tCUkMAZNLv12Pi+A==}\n    engines: {node: '>=6.9.0'}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-import-meta@7.10.4':\n    resolution: {integrity: sha512-Yqfm+XDx0+Prh3VSeEQCPU81yC+JWZ2pDPFSS4ZdpfZhp4MkFMaDC1UqseovEKwSUpnIL7+vK+Clp7bfh0iD7g==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-json-strings@7.8.3':\n    resolution: {integrity: sha512-lY6kdGpWHvjoe2vk4WrAapEuBR69EMxZl+RoGRhrFGNYVK8mOPAW8VfbT/ZgrFbXlDNiiaxQnAtgVCZ6jv30EA==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-logical-assignment-operators@7.10.4':\n    resolution: {integrity: sha512-d8waShlpFDinQ5MtvGU9xDAOzKH47+FFoney2baFIoMr952hKOLp1HR7VszoZvOsV/4+RRszNY7D17ba0te0ig==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-nullish-coalescing-operator@7.8.3':\n    resolution: {integrity: sha512-aSff4zPII1u2QD7y+F8oDsz19ew4IGEJg9SVW+bqwpwtfFleiQDMdzA/R+UlWDzfnHFCxxleFT0PMIrR36XLNQ==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-numeric-separator@7.10.4':\n    resolution: {integrity: sha512-9H6YdfkcK/uOnY/K7/aA2xpzaAgkQn37yzWUMRK7OaPOqOpGS1+n0H5hxT9AUw9EsSjPW8SVyMJwYRtWs3X3ug==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-object-rest-spread@7.8.3':\n    resolution: {integrity: sha512-XoqMijGZb9y3y2XskN+P1wUGiVwWZ5JmoDRwx5+3GmEplNyVM2s2Dg8ILFQm8rWM48orGy5YpI5Bl8U1y7ydlA==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-optional-catch-binding@7.8.3':\n    resolution: {integrity: sha512-6VPD0Pc1lpTqw0aKoeRTMiB+kWhAoT24PA+ksWSBrFtl5SIRVpZlwN3NNPQjehA2E/91FV3RjLWoVTglWcSV3Q==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-optional-chaining@7.8.3':\n    resolution: {integrity: sha512-KoK9ErH1MBlCPxV0VANkXW2/dw4vlbGDrFgz8bmUsBGYkFRcbRwMh6cIJubdPrkxRwuGdtCk0v/wPTKbQgBjkg==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-private-property-in-object@7.14.5':\n    resolution: {integrity: sha512-0wVnp9dxJ72ZUJDV27ZfbSj6iHLoytYZmh3rFcxNnvsJF3ktkzLDZPy/mA17HGsaQT3/DQsWYX1f1QGWkCoVUg==}\n    engines: {node: '>=6.9.0'}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-top-level-await@7.14.5':\n    resolution: {integrity: sha512-hx++upLv5U1rgYfwe1xBQUhRmU41NEvpUvrp8jkrSCdvGSnM5/qdRMtylJ6PG5OFkBaHkbTAKTnd3/YyESRHFw==}\n    engines: {node: '>=6.9.0'}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/runtime@7.18.6':\n    resolution: {integrity: sha512-t9wi7/AW6XtKahAe20Yw0/mMljKq0B1r2fPdvaAdV/KPDZewFXdaaa6K7lxmZBZ8FBNpCiAT6iHPmd6QO9bKfQ==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/runtime@7.26.0':\n    resolution: {integrity: sha512-FDSOghenHTiToteC/QRlv2q3DhPZ/oOXTBoirfWNx1Cx3TMVcGWQtMMmQcSvb/JjpNeGzx8Pq/b4fKEJuWm1sw==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/template@7.25.9':\n    resolution: {integrity: sha512-9DGttpmPvIxBb/2uwpVo3dqJ+O6RooAFOS+lB+xDqoE2PVCE8nfoHMdZLpfCQRLwvohzXISPZcgxt80xLfsuwg==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/traverse@7.26.4':\n    resolution: {integrity: sha512-fH+b7Y4p3yqvApJALCPJcwb0/XaOSgtK4pzV6WVjPR5GLFQBRI7pfoX2V2iM48NXvX07NUxxm1Vw98YjqTcU5w==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/types@7.26.3':\n    resolution: {integrity: sha512-vN5p+1kl59GVKMvTHt55NzzmYVxprfJD+ql7U9NFIfKCBkYE55LYtS+WtPlaYOyzydrKI8Nezd+aZextrd+FMA==}\n    engines: {node: '>=6.9.0'}\n\n  '@bcoe/v8-coverage@0.2.3':\n    resolution: {integrity: sha512-0hYQ8SB4Db5zvZB4axdMHGwEaQjkZzFjQiN9LVYvIFB2nSUHW9tYpxWriPrWDASIxiaXax83REcLxuSdnGPZtw==}\n\n  '@bloomberg/record-tuple-polyfill@0.0.3':\n    resolution: {integrity: sha512-sBnCqW0nqofE47mxFnw+lvx6kzsQstwaQMVkh66qm/A6IlsnH7WsyGuVXTou8RF2wL4W7ybOoHPvP2WgIo6rhQ==}\n\n  '@cnakazawa/watch@1.0.4':\n    resolution: {integrity: sha512-v9kIhKwjeZThiWrLmj0y17CWoyddASLj9O2yvbZkbvw/N3rWOYy9zkV66ursAoVr0mV15bL8g0c4QZUE6cdDoQ==}\n    engines: {node: '>=0.1.95'}\n    hasBin: true\n\n  '@csstools/convert-colors@1.4.0':\n    resolution: {integrity: sha512-5a6wqoJV/xEdbRNKVo6I4hO3VjyDq//8q2f9I6PBAvMesJHFauXDorcNCsr9RzvsZnaWi5NYCcfyqP1QeFHFbw==}\n    engines: {node: '>=4.0.0'}\n\n  '@ctrl/tinycolor@3.6.1':\n    resolution: {integrity: sha512-SITSV6aIXsuVNV3f3O0f2n/cgyEDWoSqtZMYiAmcsYHydcKrOz3gUxB/iXd/Qf08+IZX4KpgNbvUdMBmWz+kcA==}\n    engines: {node: '>=10'}\n\n  '@formatjs/intl-displaynames@1.2.10':\n    resolution: {integrity: sha512-GROA2RP6+7Ouu0WnHFF78O5XIU7pBfI19WM1qm93l6MFWibUk67nCfVCK3VAYJkLy8L8ZxjkYT11VIAfvSz8wg==}\n\n  '@formatjs/intl-listformat@1.4.8':\n    resolution: {integrity: sha512-WNMQlEg0e50VZrGIkgD5n7+DAMGt3boKi1GJALfhFMymslJb5i+5WzWxyj/3a929Z6MAFsmzRIJjKuv+BxKAOQ==}\n\n  '@formatjs/intl-pluralrules@1.5.9':\n    resolution: {integrity: sha512-37E1ZG+Oqo3qrpUfumzNcFTV+V+NCExmTkkQ9Zw4FSlvJ4WhbbeYdieVapUVz9M0cLy8XrhCkfuM/Kn03iKReg==}\n\n  '@formatjs/intl-relativetimeformat@4.5.16':\n    resolution: {integrity: sha512-IQ0haY97oHAH5OYUdykNiepdyEWj3SAT+Fp9ZpR85ov2JNiFx+12WWlxlVS8ehdyncC2ZMt/SwFIy2huK2+6/A==}\n\n  '@formatjs/intl-unified-numberformat@3.3.7':\n    resolution: {integrity: sha512-KnWgLRHzCAgT9eyt3OS34RHoyD7dPDYhRcuKn+/6Kv2knDF8Im43J6vlSW6Hm1w63fNq3ZIT1cFk7RuVO3Psag==}\n    deprecated: We have renamed the package to @formatjs/intl-numberformat\n\n  '@formatjs/intl-utils@2.3.0':\n    resolution: {integrity: sha512-KWk80UPIzPmUg+P0rKh6TqspRw0G6eux1PuJr+zz47ftMaZ9QDwbGzHZbtzWkl5hgayM/qrKRutllRC7D/vVXQ==}\n    deprecated: the package is rather renamed to @formatjs/ecma-abstract with some changes in functionality (primarily selectUnit is removed and we don't plan to make any further changes to this package\n\n  '@istanbuljs/load-nyc-config@1.1.0':\n    resolution: {integrity: sha512-VjeHSlIzpv/NyD3N0YuHfXOPDIixcA1q2ZV98wsMqcYlPmv2n3Yb2lYP9XMElnaFVXg5A7YLTeLu6V84uQDjmQ==}\n    engines: {node: '>=8'}\n\n  '@istanbuljs/schema@0.1.3':\n    resolution: {integrity: sha512-ZXRY4jNvVgSVQ8DL3LTcakaAtXwTVUxE81hslsyD2AtoXW/wVob10HkOJ1X/pAlcI7D+2YoZKg5do8G/w6RYgA==}\n    engines: {node: '>=8'}\n\n  '@jest/console@26.6.2':\n    resolution: {integrity: sha512-IY1R2i2aLsLr7Id3S6p2BA82GNWryt4oSvEXLAKc+L2zdi89dSkE8xC1C+0kpATG4JhBJREnQOH7/zmccM2B0g==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/core@26.6.3':\n    resolution: {integrity: sha512-xvV1kKbhfUqFVuZ8Cyo+JPpipAHHAV3kcDBftiduK8EICXmTFddryy3P7NfZt8Pv37rA9nEJBKCCkglCPt/Xjw==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/environment@26.6.2':\n    resolution: {integrity: sha512-nFy+fHl28zUrRsCeMB61VDThV1pVTtlEokBRgqPrcT1JNq4yRNIyTHfyht6PqtUvY9IsuLGTrbG8kPXjSZIZwA==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/fake-timers@26.6.2':\n    resolution: {integrity: sha512-14Uleatt7jdzefLPYM3KLcnUl1ZNikaKq34enpb5XG9i81JpppDb5muZvonvKyrl7ftEHkKS5L5/eB/kxJ+bvA==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/globals@26.6.2':\n    resolution: {integrity: sha512-85Ltnm7HlB/KesBUuALwQ68YTU72w9H2xW9FjZ1eL1U3lhtefjjl5c2MiUbpXt/i6LaPRvoOFJ22yCBSfQ0JIA==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/reporters@26.6.2':\n    resolution: {integrity: sha512-h2bW53APG4HvkOnVMo8q3QXa6pcaNt1HkwVsOPMBV6LD/q9oSpxNSYZQYkAnjdMjrJ86UuYeLo+aEZClV6opnw==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/source-map@26.6.2':\n    resolution: {integrity: sha512-YwYcCwAnNmOVsZ8mr3GfnzdXDAl4LaenZP5z+G0c8bzC9/dugL8zRmxZzdoTl4IaS3CryS1uWnROLPFmb6lVvA==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/test-result@26.6.2':\n    resolution: {integrity: sha512-5O7H5c/7YlojphYNrK02LlDIV2GNPYisKwHm2QTKjNZeEzezCbwYs9swJySv2UfPMyZ0VdsmMv7jIlD/IKYQpQ==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/test-sequencer@26.6.3':\n    resolution: {integrity: sha512-YHlVIjP5nfEyjlrSr8t/YdNfU/1XEt7c5b4OxcXCjyRhjzLYu/rO69/WHPuYcbCWkz8kAeZVZp2N2+IOLLEPGw==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/transform@26.6.2':\n    resolution: {integrity: sha512-E9JjhUgNzvuQ+vVAL21vlyfy12gP0GhazGgJC4h6qUt1jSdUXGWJ1wfu/X7Sd8etSgxV4ovT1pb9v5D6QW4XgA==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/types@26.6.2':\n    resolution: {integrity: sha512-fC6QCp7Sc5sX6g8Tvbmj4XUTbyrik0akgRy03yjXbQaBWWNWGE7SGtJk98m0N8nzegD/7SggrUlivxo5ax4KWQ==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jridgewell/gen-mapping@0.3.8':\n    resolution: {integrity: sha512-imAbBGkb+ebQyxKgzv5Hu2nmROxoDOXHh80evxdoXNOrvAnVx7zimzc1Oo5h9RlfV4vPXaE2iM5pOFbvOCClWA==}\n    engines: {node: '>=6.0.0'}\n\n  '@jridgewell/resolve-uri@3.1.2':\n    resolution: {integrity: sha512-bRISgCIjP20/tbWSPWMEi54QVPRZExkuD9lJL+UIxUKtwVJA8wW1Trb1jMs1RFXo1CBTNZ/5hpC9QvmKWdopKw==}\n    engines: {node: '>=6.0.0'}\n\n  '@jridgewell/set-array@1.2.1':\n    resolution: {integrity: sha512-R8gLRTZeyp03ymzP/6Lil/28tGeGEzhx1q2k703KGWRAI1VdvPIXdG70VJc2pAMw3NA6JKL5hhFu1sJX0Mnn/A==}\n    engines: {node: '>=6.0.0'}\n\n  '@jridgewell/source-map@0.3.6':\n    resolution: {integrity: sha512-1ZJTZebgqllO79ue2bm3rIGud/bOe0pP5BjSRCRxxYkEZS8STV7zN84UBbiYu7jy+eCKSnVIUgoWWE/tt+shMQ==}\n\n  '@jridgewell/sourcemap-codec@1.5.0':\n    resolution: {integrity: sha512-gv3ZRaISU3fjPAgNsriBRqGWQL6quFx04YMPW/zD8XMLsU32mhCCbfbO6KZFLjvYpCZ8zyDEgqsgf+PwPaM7GQ==}\n\n  '@jridgewell/trace-mapping@0.3.25':\n    resolution: {integrity: sha512-vNk6aEwybGtawWmy/PzwnGDOjCkLWSD2wqvjGGAgOAwCGWySYXfYoxt00IJkTF+8Lb57DwOb3Aa0o9CApepiYQ==}\n\n  '@qixian.cs/path-to-regexp@6.1.0':\n    resolution: {integrity: sha512-2jIiLiVZB1jnY7IIRQKtoV8Gnr7XIhk4mC88ONGunZE3hYt5IHUG4BE/6+JiTBjjEWQLBeWnZB8hGpppkufiVw==}\n\n  '@rc-component/portal@1.1.2':\n    resolution: {integrity: sha512-6f813C0IsasTZms08kfA8kPAGxbbkYToa8ALaiDIGGECU4i9hj8Plgbx0sNJDrey3EtHO30hmdaxtT0138xZcg==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  '@sinonjs/commons@1.8.6':\n    resolution: {integrity: sha512-Ky+XkAkqPZSm3NLBeUng77EBQl3cmeJhITaGHdYH8kjVB+aun3S4XBRti2zt17mtt0mIUDiNxYeoJm6drVvBJQ==}\n\n  '@sinonjs/fake-timers@6.0.1':\n    resolution: {integrity: sha512-MZPUxrmFubI36XS1DI3qmI0YdN1gks62JtFZvxR67ljjSNCeK6U08Zx4msEWOXuofgqUt6zPHSi1H9fbjR/NRA==}\n\n  '@tootallnate/once@1.1.2':\n    resolution: {integrity: sha512-RbzJvlNzmRq5c3O09UipeuXno4tA1FE6ikOjxZK0tuxVv3412l64l5t1W5pj4+rJq9vpkm/kwiR07aZXnsKPxw==}\n    engines: {node: '>= 6'}\n\n  '@types/babel__core@7.20.5':\n    resolution: {integrity: sha512-qoQprZvz5wQFJwMDqeseRXWv3rqMvhgpbXFfVyWhbx9X47POIA6i/+dXefEmZKoAgOaTdaIgNSMqMIU61yRyzA==}\n\n  '@types/babel__generator@7.6.8':\n    resolution: {integrity: sha512-ASsj+tpEDsEiFr1arWrlN6V3mdfjRMZt6LtK/Vp/kreFLnr5QH5+DhvD5nINYZXzwJvXeGq+05iUXcAzVrqWtw==}\n\n  '@types/babel__template@7.4.4':\n    resolution: {integrity: sha512-h/NUaSyG5EyxBIp8YRxo4RMe2/qQgvyowRwVMzhYhBCONbW8PUsg4lkFMrhgZhUe5z3L3MiLDuvyJ/CaPa2A8A==}\n\n  '@types/babel__traverse@7.20.6':\n    resolution: {integrity: sha512-r1bzfrm0tomOI8g1SzvCaQHo6Lcv6zu0EA+W2kHrt8dyrHQxGzBBL4kdkzIS+jBMV+EYcMAEAqXqYaLJq5rOZg==}\n\n  '@types/graceful-fs@4.1.9':\n    resolution: {integrity: sha512-olP3sd1qOEe5dXTSaFvQG+02VdRXcdytWLAZsAq1PecU8uqQAhkrnbli7DagjtXKW/Bl7YJbUsa8MPcuc8LHEQ==}\n\n  '@types/history@4.7.11':\n    resolution: {integrity: sha512-qjDJRrmvBMiTx+jyLxvLfJU7UznFuokDv4f3WRuriHKERccVpFU+8XMQUAbDzoiJCsmexxRExQeMwwCdamSKDA==}\n\n  '@types/history@5.0.0':\n    resolution: {integrity: sha512-hy8b7Y1J8OGe6LbAjj3xniQrj3v6lsivCcrmf4TzSgPzLkhIeKgc5IZnT7ReIqmEuodjfO8EYAuoFvIrHi/+jQ==}\n    deprecated: This is a stub types definition. history provides its own type definitions, so you do not need this installed.\n\n  '@types/hoist-non-react-statics@3.3.6':\n    resolution: {integrity: sha512-lPByRJUer/iN/xa4qpyL0qmL11DqNW81iU/IG1S3uvRUq4oKagz8VCxZjiWkumgt66YT3vOdDgZ0o32sGKtCEw==}\n\n  '@types/invariant@2.2.37':\n    resolution: {integrity: sha512-IwpIMieE55oGWiXkQPSBY1nw1nFs6bsKXTFskNY8sdS17K24vyEBRQZEwlRS7ZmXCWnJcQtbxWzly+cODWGs2A==}\n\n  '@types/isomorphic-fetch@0.0.35':\n    resolution: {integrity: sha512-DaZNUvLDCAnCTjgwxgiL1eQdxIKEpNLOlTNtAgnZc50bG2copGhRrFN9/PxPBuJe+tZVLCbQ7ls0xveXVRPkvw==}\n\n  '@types/istanbul-lib-coverage@2.0.6':\n    resolution: {integrity: sha512-2QF/t/auWm0lsy8XtKVPG19v3sSOQlJe/YHZgfjb/KBBHOGSV+J2q/S671rcq9uTBrLAXmZpqJiaQbMT+zNU1w==}\n\n  '@types/istanbul-lib-report@3.0.3':\n    resolution: {integrity: sha512-NQn7AHQnk/RSLOxrBbGyJM/aVQ+pjj5HCgasFxc0K/KhoATfQ/47AyUl15I2yBUpihjmas+a+VJBOqecrFH+uA==}\n\n  '@types/istanbul-reports@3.0.4':\n    resolution: {integrity: sha512-pk2B1NWalF9toCRu6gjBzR69syFjP4Od8WRAX+0mmf9lAjCRicLOWc+ZrxZHx/0XRjotgkF9t6iaMJ+aXcOdZQ==}\n\n  '@types/json-schema@7.0.15':\n    resolution: {integrity: sha512-5+fP8P8MFNC+AyZCDxrB2pkZFPGzqQWUzpSeuuVLvm8VMcorNYavBqoFcxK8bQz4Qsbn4oUEEem4wDLfcysGHA==}\n\n  '@types/node@22.10.2':\n    resolution: {integrity: sha512-Xxr6BBRCAOQixvonOye19wnzyDiUtTeqldOOmj3CkeblonbccA12PFwlufvRdrpjXxqnmUaeiU5EOA+7s5diUQ==}\n\n  '@types/normalize-package-data@2.4.4':\n    resolution: {integrity: sha512-37i+OaWTh9qeK4LSHPsyRC7NahnGotNuZvjLSgcPzblpHB3rrCJxAOgI5gCdKm7coonsaX1Of0ILiTcnZjbfxA==}\n\n  '@types/parse-json@4.0.2':\n    resolution: {integrity: sha512-dISoDXWWQwUquiKsyZ4Ng+HX2KsPL7LyHKHQwgGFEA3IaKac4Obd+h2a/a6waisAoepJlBcx9paWqjA8/HVjCw==}\n\n  '@types/prettier@2.7.3':\n    resolution: {integrity: sha512-+68kP9yzs4LMp7VNh8gdzMSPZFL44MLGqiHWvttYJe+6qnuVr4Ek9wSBQoveqY/r+LwjCcU29kNVkidwim+kYA==}\n\n  '@types/prop-types@15.7.14':\n    resolution: {integrity: sha512-gNMvNH49DJ7OJYv+KAKn0Xp45p8PLl6zo2YnvDIbTd4J6MER2BmWN49TG7n9LvkyihINxeKW8+3bfS2yDC9dzQ==}\n\n  '@types/react-dom@16.9.25':\n    resolution: {integrity: sha512-ZK//eAPhwft9Ul2/Zj+6O11YR6L4JX0J2sVeBC9Ft7x7HFN7xk7yUV/zDxqV6rjvqgl6r8Dq7oQImxtyf/Mzcw==}\n    peerDependencies:\n      '@types/react': ^16.0.0\n\n  '@types/react-dom@17.0.26':\n    resolution: {integrity: sha512-Z+2VcYXJwOqQ79HreLU/1fyQ88eXSSFh6I3JdrEHQIfYSI0kCQpTGvOrbE6jFGGYXKsHuwY9tBa/w5Uo6KzrEg==}\n    peerDependencies:\n      '@types/react': ^17.0.0\n\n  '@types/react-helmet@6.1.11':\n    resolution: {integrity: sha512-0QcdGLddTERotCXo3VFlUSWO3ztraw8nZ6e3zJSgG7apwV5xt+pJUS8ewPBqT4NYB1optGLprNQzFleIY84u/g==}\n\n  '@types/react-redux@7.1.34':\n    resolution: {integrity: sha512-GdFaVjEbYv4Fthm2ZLvj1VSCedV7TqE5y1kNwnjSdBOTXuRSgowux6J8TAct15T3CKBr63UMk+2CO7ilRhyrAQ==}\n\n  '@types/react-router-config@5.0.2':\n    resolution: {integrity: sha512-WOSetDV3YPxbkVJAdv/bqExJjmcdCi/vpCJh3NfQOy1X15vHMSiMioXIcGekXDJJYhqGUMDo9e337mh508foAA==}\n\n  '@types/react-router-dom@5.1.7':\n    resolution: {integrity: sha512-D5mHD6TbdV/DNHYsnwBTv+y73ei+mMjrkGrla86HthE4/PVvL1J94Bu3qABU+COXzpL23T1EZapVVpwHuBXiUg==}\n\n  '@types/react-router-dom@5.3.3':\n    resolution: {integrity: sha512-kpqnYK4wcdm5UaWI3fLcELopqLrHgLqNsdpHauzlQktfkHL3npOSwtj1Uz9oKBAzs7lFtVkV8j83voAz2D8fhw==}\n\n  '@types/react-router@5.1.12':\n    resolution: {integrity: sha512-0bhXQwHYfMeJlCh7mGhc0VJTRm0Gk+Z8T00aiP4702mDUuLs9SMhnd2DitpjWFjdOecx2UXtICK14H9iMnziGA==}\n\n  '@types/react-router@5.1.20':\n    resolution: {integrity: sha512-jGjmu/ZqS7FjSH6owMcD5qpq19+1RS9DeVRqfl1FeBMxTDQAGwlMWOcs52NDoXaNKyG3d1cYQFMs9rCrb88o9Q==}\n\n  '@types/react@16.14.62':\n    resolution: {integrity: sha512-BWf7hqninZav6nerxXj+NeZT/mTpDeG6Lk2zREHAy63CrnXoOGPGtNqTFYFN/sqpSaREDP5otVV88axIXmKfGA==}\n\n  '@types/react@17.0.83':\n    resolution: {integrity: sha512-l0m4ArKJvmFtR4e8UmKrj1pB4tUgOhJITf+mADyF/p69Ts1YAR/E+G9XEM0mHXKVRa1dQNHseyyDNzeuAXfXQw==}\n\n  '@types/scheduler@0.16.8':\n    resolution: {integrity: sha512-WZLiwShhwLRmeV6zH+GkbOFT6Z6VklCItrDioxUnv+u4Ll+8vKeFySoFyK/0ctcRpOmwAicELfmys1sDc/Rw+A==}\n\n  '@types/stack-utils@2.0.3':\n    resolution: {integrity: sha512-9aEbYZ3TbYMznPdcdr3SmIrLXwC/AKZXQeCf9Pgao5CKb8CyHuEX5jzWPTkvregvhRJHcpRO6BFoGW9ycaOkYw==}\n\n  '@types/yargs-parser@21.0.3':\n    resolution: {integrity: sha512-I4q9QU9MQv4oEOz4tAHJtNz1cwuLxn2F3xcc2iV5WdqLPpUnj30aUuxt1mAxYTG+oe8CZMV/+6rU4S4gRDzqtQ==}\n\n  '@types/yargs@15.0.19':\n    resolution: {integrity: sha512-2XUaGVmyQjgyAZldf0D0c14vvo/yv0MhQBSTJcejMMaitsn3nxCB6TmH4G0ZQf+uxROOa9mpanoSm8h6SG/1ZA==}\n\n  '@umijs/ast@3.5.43':\n    resolution: {integrity: sha512-P+yperHXuPCewEhgzKRXOxhpQmcK06J2PuLs7XaeQatpUTP//omJeIAcSHV8Rr9ynuvYnz9lS1qKqjgfjmZ8bA==}\n\n  '@umijs/babel-plugin-auto-css-modules@3.5.43':\n    resolution: {integrity: sha512-u1JTVqgABY3cSCWsaRumnPINZzgUE5WDTsm7BYXf5a+mdZQiv87pCU2jC6S4OabMqm3mR75gJc5wLR4sFnlkrA==}\n\n  '@umijs/babel-plugin-import-to-await-require@3.5.43':\n    resolution: {integrity: sha512-PhPTS/i2yBEdZbsSp6Cj3cEcxwLOcacjzUgkH+g9vvVwMSAgMqkI1Tx57Y70LZorE4PeUNl5yeS9hGm24JAMQA==}\n\n  '@umijs/babel-plugin-lock-core-js-3@3.5.43':\n    resolution: {integrity: sha512-hOb6cyCrn/4SQ2qGc6RBOG7aPtMHqyuy2iJonzFobdbkOW5nOnYfK/F3oeSJqn/amynFr3W6cUdflyg3Mn5lRQ==}\n\n  '@umijs/babel-plugin-no-anonymous-default-export@3.5.43':\n    resolution: {integrity: sha512-itH+IV96AChX7zKDLEKNi6IEHL+RT8DsP8BSH3oDGWRE0OM4VlpM42N195bsMtOtdl7kCb9HUP1Bg1J/+hHwsw==}\n\n  '@umijs/babel-preset-umi@3.5.43':\n    resolution: {integrity: sha512-raFsiPYy70QNKM4jSo+qdO3wkZr9PCsSSz/+CGTUPkpre5sk6ISDcuXdvEJ92viMe1Xk1+LaPcnbJqIdu7EClA==}\n\n  '@umijs/bundler-utils@3.5.43':\n    resolution: {integrity: sha512-Vw1qR+4KBQx/M1NwlDrMPydyBoA/qLT+nxZKAeIwCjkJT42QSJn38OMDqsRKRPkuoL5tLN4Ss+PbXoJ5evLWoA==}\n\n  '@umijs/bundler-webpack@3.5.43':\n    resolution: {integrity: sha512-Sf15PCMSbt0QMnRcNGIU+Nd6dha5aBZPdOE7IdlWLXJ9rSICNuhblD2P5L8MscwomOXYvsPKzNGI92MUyfjq5w==}\n    hasBin: true\n\n  '@umijs/case-sensitive-paths-webpack-plugin@1.0.1':\n    resolution: {integrity: sha512-kDKJ8yTarxwxGJDInG33hOpaQRZ//XpNuuznQ/1Mscypw6kappzFmrBr2dOYave++K7JHouoANF354UpbEQw0Q==}\n\n  '@umijs/core@3.5.43':\n    resolution: {integrity: sha512-YT/ZrYZl5xrffW3WyDzsrec0FMhebjDoJSA7A2X2WX8lmsIhjzrVEDeR265+t5J+OH7joB8pMMiV/tvhVPHb7w==}\n\n  '@umijs/deps@3.5.43':\n    resolution: {integrity: sha512-1UugbYw+Emcq1AngzLgCvpMDdIVjpBVGwdrWDcxt3zjSR/2teRbaMdzUEqaMaqMWYVMbZKorARuyit5hZorrXQ==}\n\n  '@umijs/plugin-access@2.4.3':\n    resolution: {integrity: sha512-6FON4aHzVFs/vtFK5Sdnw+FBolfoYi8wV8V9Q8x2T19NwjZtjXSPjt0gtrG4jdx4LRsSV2DKLaMGoJYbNr94aA==}\n    peerDependencies:\n      '@umijs/plugin-initial-state': 2.x\n      '@umijs/plugin-model': 2.x\n      umi: 3.x\n\n  '@umijs/plugin-analytics@0.2.2':\n    resolution: {integrity: sha512-dVDzUfgIdEwdCC6a5IsMYpIPI+bEZjBEqIhAvw9dic6Vk77w9RxQxyRfW11dDmdXLAwWphp22NntQNt1ejZPtg==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-antd@0.13.0':\n    resolution: {integrity: sha512-7tooYtOylVatrzMWCJtk8JFQL90i94OD0FgZYpKBbM7keThH8prYkSkDJFIDkuGfZ6pl6BJT8ESnYLxf2OiQUw==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-crossorigin@1.2.1':\n    resolution: {integrity: sha512-4oXNFBLOCH1FHTgFi7EDmlcjjYMthOQlrTT+mSbNeMzvl0P/WKldSJsYAUXUTg+I7vlbb5bNby4dpHKK37JcbQ==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-dva@0.13.0':\n    resolution: {integrity: sha512-cpGq8vzN8AmyWxexWLQ+WGqfT0WMCiryvU5EcNGbx1/Ub9aICUfPBpB46cxJrxjDCjUzuVslRNb2pdgI0xXUXg==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-helmet@1.1.3':\n    resolution: {integrity: sha512-X4GRFlvOb8DxMDm1vExfpWOvxl6bp0oZz114DyhwnMSriJ8RcHAigTjtVJHYxJpKv7P6KayN3n13J4w/XZGWMg==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-initial-state@2.4.0':\n    resolution: {integrity: sha512-UHH5fTL9skm4771R3xvWCrjd5xiQ7OdJ83G0P1YZLhuNbh0cAFVT8SPTU8dA9o8TTAZ66IEq7axhWl1cGxVsXw==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-layout@0.18.1':\n    resolution: {integrity: sha512-15YTcFpic0v15nFzlg6G8nvMCveBtcBL77Wr9wXYJdgR0iU7dnO7T4OqbLwgEc1uHxtGhTVibi6nSGelX56zCg==}\n    peerDependencies:\n      '@ant-design/icons': ^4.0.0\n      '@ant-design/pro-layout': ^6.0.0\n      '@umijs/plugin-initial-state': 2.x\n      '@umijs/plugin-locale': 0.x\n      '@umijs/plugin-model': 2.x\n      umi: 3.x\n\n  '@umijs/plugin-locale@0.15.2':\n    resolution: {integrity: sha512-/m3ik0NKbE/PHFPKPqSBEwGi5RUB6Dz2T7jepDXhU8ycV0zUPGbDbChUx1r/3t5zveZIND1s/7A49Apb+ujUmg==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-model@2.6.2':\n    resolution: {integrity: sha512-MKLAgYIoBkciavxTqJY6VOhvnNQv7jp+olNmXqqZ3I3WsLg7jo33NCOAA3ej103kmo9ZvD9R1aakl7e9WKsdAw==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-request@2.8.0':\n    resolution: {integrity: sha512-bwJg0rFbMZcizO+fHbSNz6X/U6suR84ciLIo9zLtRMuradx/yanMnz+ckh2dlZvTlGYrckkJwWgoSFxWlU8yyA==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-test@1.0.2':\n    resolution: {integrity: sha512-EIV86Xmw/Cn8vRLXha+ct0PfY6gRRKov5lanvt1B2L5t6xAqnTd03AxmB7i1Go9vDcFxDBheuDf/nyGiT/xTFw==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/preset-built-in@3.5.43':\n    resolution: {integrity: sha512-h9DVc5MjdUON7/xH3bxq76AHDPBTLjntDWBrW6xn+OhDT4j8/YFXrDQwaCwihCJe1eNUBLoVUjWIEIthw7g1Gg==}\n    peerDependencies:\n      react: 16.x || 17.x\n\n  '@umijs/preset-react@1.8.32':\n    resolution: {integrity: sha512-f/jJRxIRzRrZ040GMdBuV3byvtbx35oWymDT5A/q/e+QmjCrs6c9XCRktGInKIhZycqI/GuA6eLaxXIKvu6b9A==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/renderer-mpa@3.5.43':\n    resolution: {integrity: sha512-posQsrkFru/Q9Jft42w4pr/MEFsImd9DlKOV9zYil1ZM6JBS3/hKMmCeSd2Uku7+KgSS/8HSfc4qX/GyeRTzwA==}\n    peerDependencies:\n      react: 16.x || 17.x\n      react-dom: 16.x || 17.x\n\n  '@umijs/renderer-react@3.5.43':\n    resolution: {integrity: sha512-nadGLVbc6qrEX5pd+qY4nr9Mzl7x2hhxec2JeAd2Bg0JkZYNC8H4crTfe844uLm3MvqAtAhomGhN5c0ejDEBhA==}\n    peerDependencies:\n      react: 16.x || 17.x\n      react-dom: 16.x || 17.x\n\n  '@umijs/route-utils@2.2.2':\n    resolution: {integrity: sha512-cMk6qizy0pfpiwpVCvNQB0BKBUJEH33pDv5q5k2tSleSDw2abkJkTu2Kd5hKzoESLuFK43oGeOfcplZqm2bRxw==}\n\n  '@umijs/runtime@3.5.43':\n    resolution: {integrity: sha512-jCmkF5QcqbqzJgtd12Hy6XthLTAcaD4feMHnzM+UqTE74N7lfD13P0brXHrGqkcLbI1NgUs+9rKYIUa56w6jpw==}\n    peerDependencies:\n      react: 16.x || 17.x\n\n  '@umijs/server@3.5.43':\n    resolution: {integrity: sha512-aUSNqnO6WvhgIU6jK1+2YCNkuP6UgiEhTaT/VkSPZdCjagfov2ZfJQ0xWl8x7tocuAaBph6UvXFJWjCQvZ5pHw==}\n\n  '@umijs/ssr-darkreader@4.9.45':\n    resolution: {integrity: sha512-XlcwzSYQ/SRZpHdwIyMDS4FOGX5kP4U/2g2mykyn/iPQTK4xTiQAyBu6UnnDnn7d5P8s7Atzh1C7H0ETNOypJg==}\n\n  '@umijs/test@3.5.43':\n    resolution: {integrity: sha512-9jrziC5ngjrfiJFSdhNDMYcQNrnCQoph/Bu8lZsuBmBQwswN3YqVqefDc4fh4Kl1e4OisKtDfUDtUro8ZApaRQ==}\n    hasBin: true\n\n  '@umijs/types@3.5.43':\n    resolution: {integrity: sha512-XVZuT1X+VpPYrdlDEeginBwBNZaYUDtt3WOyFvfGmBEdqD0iNx0ZgyWmJBhlfRcck5+oYkFpOzmmRIROux2zlA==}\n\n  '@umijs/use-params@1.0.9':\n    resolution: {integrity: sha512-QlN0RJSBVQBwLRNxbxjQ5qzqYIGn+K7USppMoIOVlf7fxXHsnQZ2bEsa6Pm74bt6DVQxpUE8HqvdStn6Y9FV1w==}\n    peerDependencies:\n      react: '*'\n\n  '@umijs/utils@3.5.43':\n    resolution: {integrity: sha512-LQrCkZEa9Fb0zhId1n6CdU489tzJp4/usHVvVcTwjah7jF48zrHXD4OClGjSxvZ63d+3950mZY5IWE9UZVhnDg==}\n\n  abab@2.0.6:\n    resolution: {integrity: sha512-j2afSsaIENvHZN2B8GOpF566vZ5WVk5opAiMTvWgaQT8DkbOqsTfvNAvHoRGU2zzP8cPoqys+xHTRDWW8L+/BA==}\n    deprecated: Use your platform's native atob() and btoa() methods instead\n\n  acorn-globals@6.0.0:\n    resolution: {integrity: sha512-ZQl7LOWaF5ePqqcX4hLuv/bLXYQNfNWw2c0/yX/TsPRKamzHcTGQnlCjHT3TsmkOUVEPS3crCxiPfdzE/Trlhg==}\n\n  acorn-walk@7.2.0:\n    resolution: {integrity: sha512-OPdCF6GsMIP+Az+aWfAAOEt2/+iVDKE7oy6lJ098aoe59oAmK76qV6Gw60SbZ8jHuG2wH058GF4pLFbYamYrVA==}\n    engines: {node: '>=0.4.0'}\n\n  acorn@7.4.1:\n    resolution: {integrity: sha512-nQyp0o1/mNdbTO1PO6kHkwSrmgZ0MT/jCCpNiwbUjGoRN4dlBhqJtoQuCnEOKzgTVwg0ZWiCoQy6SxMebQVh8A==}\n    engines: {node: '>=0.4.0'}\n    hasBin: true\n\n  acorn@8.14.0:\n    resolution: {integrity: sha512-cl669nCJTZBsL97OF4kUQm5g5hC2uihk0NxY3WENAC0TYdILVkAyHymAntgxGkl7K+t0cXIrH5siy5S4XkFycA==}\n    engines: {node: '>=0.4.0'}\n    hasBin: true\n\n  add-dom-event-listener@1.1.0:\n    resolution: {integrity: sha512-WCxx1ixHT0GQU9hb0KI/mhgRQhnU+U3GvwY6ZvVjYq8rsihIGoaIOUbY0yMPBxLH5MDtr0kz3fisWGNcbWW7Jw==}\n\n  agent-base@6.0.2:\n    resolution: {integrity: sha512-RZNwNclF7+MS/8bDg70amg32dyeZGZxiDuQmZxKLAlQjr3jGyLx+4Kkk58UO7D2QdgFIQCovuSuZESne6RG6XQ==}\n    engines: {node: '>= 6.0.0'}\n\n  aggregate-error@3.1.0:\n    resolution: {integrity: sha512-4I7Td01quW/RpocfNayFdFVk1qSuoh0E7JrbRJ16nH01HhKFQ88INq9Sd+nd72zqRySlr9BmDA8xlEJ6vJMrYA==}\n    engines: {node: '>=8'}\n\n  ajv-errors@1.0.1:\n    resolution: {integrity: sha512-DCRfO/4nQ+89p/RK43i8Ezd41EqdGIU4ld7nGF8OQ14oc/we5rEntLCUa7+jrn3nn83BosfwZA0wb4pon2o8iQ==}\n    peerDependencies:\n      ajv: '>=5.0.0'\n\n  ajv-keywords@3.5.2:\n    resolution: {integrity: sha512-5p6WTN0DdTGVQk6VjcEju19IgaHudalcfabD7yhDGeA6bcQnmL+CpveLJq/3hvfwd1aof6L386Ougkx6RfyMIQ==}\n    peerDependencies:\n      ajv: ^6.9.1\n\n  ajv@6.12.6:\n    resolution: {integrity: sha512-j3fVLgvTo527anyYyJOGTYJbG+vnnQYvE0m5mmkc1TK+nxAppkCLMIL0aZ4dblVCNoGShhm+kzE4ZUykBoMg4g==}\n\n  ansi-colors@4.1.3:\n    resolution: {integrity: sha512-/6w/C21Pm1A7aZitlI5Ni/2J6FFQN8i1Cvz3kHABAAbw93v/NlvKdVOqz7CCWz/3iv/JplRSEEZ83XION15ovw==}\n    engines: {node: '>=6'}\n\n  ansi-escapes@4.3.2:\n    resolution: {integrity: sha512-gKXj5ALrKWQLsYG9jlTRmR/xKluxHV+Z9QEwNIgCfM1/uwPMCuzVVnh5mwTd+OuBZcwSIMbqssNWRm1lE51QaQ==}\n    engines: {node: '>=8'}\n\n  ansi-html@0.0.9:\n    resolution: {integrity: sha512-ozbS3LuenHVxNRh/wdnN16QapUHzauqSomAl1jwwJRRsGwFwtj644lIhxfWu0Fy0acCij2+AEgHvjscq3dlVXg==}\n    engines: {'0': node >= 0.8.0}\n    hasBin: true\n\n  ansi-regex@5.0.1:\n    resolution: {integrity: sha512-quJQXlTSUGL2LH9SUXo8VwsY4soanhgo6LNSm84E1LBcE8s3O0wpdiRzyR9z/ZZJMlMWv37qOOb9pdJlMUEKFQ==}\n    engines: {node: '>=8'}\n\n  ansi-styles@3.2.1:\n    resolution: {integrity: sha512-VT0ZI6kZRdTh8YyJw3SMbYm/u+NqfsAxEpWO0Pf9sq8/e94WxxOpPKx9FR1FlyCtOVDNOQ+8ntlqFxiRc+r5qA==}\n    engines: {node: '>=4'}\n\n  ansi-styles@4.3.0:\n    resolution: {integrity: sha512-zbB9rCJAT1rbjiVDb2hqKFHNYLxgtk8NURxZ3IZwD3F6NtxbXZQCnnSi1Lkx+IDohdPlFp222wVALIheZJQSEg==}\n    engines: {node: '>=8'}\n\n  antd-mobile@2.3.4:\n    resolution: {integrity: sha512-Uw02Ghc+DPzaQceJQ+5p1ZnQFafvILA0chTTen7m7c89Uzbw6Ny3zsVZDE1gfteNEIsL4JpPe0I/+aI3Q/nPAA==}\n\n  antd@4.24.16:\n    resolution: {integrity: sha512-zZrK4UYxHtU6tGOOf0uG/kBRx1kTvypfuSB3GqE/SBQxFhZ/TZ+yj7Z1qwI8vGfMtUUJdLeuoCAqGDa1zPsXnQ==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  anymatch@2.0.0:\n    resolution: {integrity: sha512-5teOsQWABXHHBFP9y3skS5P3d/WfWXpv3FUpy+LorMrNYaT9pI4oLMQX7jzQ2KklNpGpWHzdCXTDT2Y3XGlZBw==}\n\n  anymatch@3.1.3:\n    resolution: {integrity: sha512-KMReFUr0B4t+D+OBkjR3KYqvocp2XaSzO55UcB6mgQMd3KbcE+mWTyvVV7D/zsdEbNnV6acZUutkiHQXvTr1Rw==}\n    engines: {node: '>= 8'}\n\n  arch@2.2.0:\n    resolution: {integrity: sha512-Of/R0wqp83cgHozfIYLbBMnej79U/SVGOOyuB3VVFv1NRM/PSFMK12x9KVtiYzJqmnU5WR2qp0Z5rHb7sWGnFQ==}\n\n  argparse@1.0.10:\n    resolution: {integrity: sha512-o5Roy6tNG4SL/FOkCAN6RzjiakZS25RLYFrcMttJqbdd8BWrnA+fGz57iN5Pb06pvBGvl5gQ0B48dJlslXvoTg==}\n\n  arr-diff@4.0.0:\n    resolution: {integrity: sha512-YVIQ82gZPGBebQV/a8dar4AitzCQs0jjXwMPZllpXMaGjXPYVUawSxQrRsjhjupyVxEvbHgUmIhKVlND+j02kA==}\n    engines: {node: '>=0.10.0'}\n\n  arr-flatten@1.1.0:\n    resolution: {integrity: sha512-L3hKV5R/p5o81R7O02IGnwpDmkp6E982XhtbuwSe3O4qOtMMMtodicASA1Cny2U+aCXcNpml+m4dPsvsJ3jatg==}\n    engines: {node: '>=0.10.0'}\n\n  arr-union@3.1.0:\n    resolution: {integrity: sha512-sKpyeERZ02v1FeCZT8lrfJq5u6goHCtpTAzPwJYe7c8SPFOboNjNg1vz2L4VTn9T4PQxEx13TbXLmYUcS6Ug7Q==}\n    engines: {node: '>=0.10.0'}\n\n  array-tree-filter@2.1.0:\n    resolution: {integrity: sha512-4ROwICNlNw/Hqa9v+rk5h22KjmzB1JGTMVKP2AKJBOCgb0yL0ASf0+YvCcLNNwquOHNX48jkeZIJ3a+oOQqKcw==}\n\n  array-unique@0.3.2:\n    resolution: {integrity: sha512-SleRWjh9JUud2wH1hPs9rZBZ33H6T9HOiL0uwGnGx9FpE6wKGyfWugmbkEOIs6qWrZhg0LWeLziLrEwQJhs5mQ==}\n    engines: {node: '>=0.10.0'}\n\n  asap@2.0.6:\n    resolution: {integrity: sha512-BSHWgDSAiKs50o2Re8ppvp3seVHXSRM44cdSsT9FfNEUUZLOGWVCsiWaRPWM1Znn+mqZ1OfVZ3z3DWEzSp7hRA==}\n\n  asn1.js@4.10.1:\n    resolution: {integrity: sha512-p32cOF5q0Zqs9uBiONKYLm6BClCoBCM5O9JfeUSlnQLBTxYdTK+pW+nXflm8UkKd2UYlEbYz5qEi0JuZR9ckSw==}\n\n  assert@1.5.1:\n    resolution: {integrity: sha512-zzw1uCAgLbsKwBfFc8CX78DDg+xZeBksSO3vwVIDDN5i94eOrPsSSyiVhmsSABFDM/OcpE2aagCat9dnWQLG1A==}\n\n  assign-symbols@1.0.0:\n    resolution: {integrity: sha512-Q+JC7Whu8HhmTdBph/Tq59IoRtoy6KAm5zzPv00WdujX82lbAL8K7WVjne7vdCsAmbF4AYaDOPyO3k0kl8qIrw==}\n    engines: {node: '>=0.10.0'}\n\n  astral-regex@2.0.0:\n    resolution: {integrity: sha512-Z7tMw1ytTXt5jqMcOP+OQteU1VuNK9Y02uuJtKQ1Sv69jXQKKg5cibLwGJow8yzZP+eAc18EmLGPal0bp36rvQ==}\n    engines: {node: '>=8'}\n\n  async-validator@4.2.5:\n    resolution: {integrity: sha512-7HhHjtERjqlNbZtqNqy2rckN/SpOOlmDliet+lP7k+eKZEjPk3DgyeU9lIXLdeLz0uBbbVp+9Qdow9wJWgwwfg==}\n\n  asynckit@0.4.0:\n    resolution: {integrity: sha512-Oei9OH4tRh0YqU3GxhX79dM/mwVgvbZJaSNaRk+bshkj0S5cfHcgYakreBjrHwatXKbz+IoIdYLxrKim2MjW0Q==}\n\n  atob@2.1.2:\n    resolution: {integrity: sha512-Wm6ukoaOGJi/73p/cl2GvLjTI5JM1k/O14isD73YML8StrH/7/lRFgmg8nICZgD3bZZvjwCGxtMOD3wWNAu8cg==}\n    engines: {node: '>= 4.5.0'}\n    hasBin: true\n\n  autoprefixer@9.8.8:\n    resolution: {integrity: sha512-eM9d/swFopRt5gdJ7jrpCwgvEMIayITpojhkkSMRsFHYuH5bkSQ4p/9qTEHtmNudUZh22Tehu7I6CxAW0IXTKA==}\n    hasBin: true\n\n  babel-jest@26.6.3:\n    resolution: {integrity: sha512-pl4Q+GAVOHwvjrck6jKjvmGhnO3jHX/xuB9d27f+EJZ/6k+6nMuPjorrYp7s++bKKdANwzElBWnLWaObvTnaZA==}\n    engines: {node: '>= 10.14.2'}\n    peerDependencies:\n      '@babel/core': ^7.0.0\n\n  babel-plugin-dva-hmr@0.4.2:\n    resolution: {integrity: sha512-QP5W0IT9LDFgoqkXD0g7wn/FMn7zO562P8qys23twXri4i3E1SGOQ3z7jqcPrqzfTZHx+Ufr+cXy9oI6OLMYZg==}\n    peerDependencies:\n      redbox-react: 1.x\n\n  babel-plugin-istanbul@6.1.1:\n    resolution: {integrity: sha512-Y1IQok9821cC9onCx5otgFfRm7Lm+I+wwxOx738M/WLPZ9Q42m4IG5W0FNX8WLL2gYMZo3JkuXIH2DOpWM+qwA==}\n    engines: {node: '>=8'}\n\n  babel-plugin-jest-hoist@26.6.2:\n    resolution: {integrity: sha512-PO9t0697lNTmcEHH69mdtYiOIkkOlj9fySqfO3K1eCcdISevLAE0xY59VLLUj0SoiPiTX/JU2CYFpILydUa5Lw==}\n    engines: {node: '>= 10.14.2'}\n\n  babel-preset-current-node-syntax@1.1.0:\n    resolution: {integrity: sha512-ldYss8SbBlWva1bs28q78Ju5Zq1F+8BrqBZZ0VFhLBvhh6lCpC2o3gDJi/5DRLs9FgYZCnmPYIVFU4lRXCkyUw==}\n    peerDependencies:\n      '@babel/core': ^7.0.0\n\n  babel-preset-jest@26.6.2:\n    resolution: {integrity: sha512-YvdtlVm9t3k777c5NPQIv6cxFFFapys25HiUmuSgHwIZhfifweR5c5Sf5nwE3MAbfu327CYSvps8Yx6ANLyleQ==}\n    engines: {node: '>= 10.14.2'}\n    peerDependencies:\n      '@babel/core': ^7.0.0\n\n  babel-runtime@6.26.0:\n    resolution: {integrity: sha512-ITKNuq2wKlW1fJg9sSW52eepoYgZBggvOAHC0u/CYu/qxQ9EVzThCgR69BnSXLHjy2f7SY5zaQ4yt7H9ZVxY2g==}\n\n  balanced-match@1.0.2:\n    resolution: {integrity: sha512-3oSeUO0TMV67hN1AmbXsK4yaqU7tjiHlbxRDZOpH0KW9+CeX4bRAaX0Anxt0tx2MrpRpWwQaPwIlISEJhYU5Pw==}\n\n  base64-js@1.5.1:\n    resolution: {integrity: sha512-AKpaYlHn8t4SVbOHCy+b5+KKgvR4vrsD8vbvrbiQJps7fKDTkjkDry6ji0rUJjC0kzbNePLwzxq8iypo41qeWA==}\n\n  base@0.11.2:\n    resolution: {integrity: sha512-5T6P4xPgpp0YDFvSWwEZ4NoE3aM4QBQXDzmVbraCkFj8zHM+mba8SyqB5DbZWyR7mYHo6Y7BdQo3MoA4m0TeQg==}\n    engines: {node: '>=0.10.0'}\n\n  big.js@5.2.2:\n    resolution: {integrity: sha512-vyL2OymJxmarO8gxMr0mhChsO9QGwhynfuu4+MHTAW6czfq9humCB7rKpUjDd9YUiDPU4mzpyupFSvOClAwbmQ==}\n\n  binary-extensions@2.3.0:\n    resolution: {integrity: sha512-Ceh+7ox5qe7LJuLHoY0feh3pHuUDHAcRUeyL2VYghZwfpkNIy/+8Ocg0a3UuSoYzavmylwuLWQOf3hl0jjMMIw==}\n    engines: {node: '>=8'}\n\n  bn.js@4.12.1:\n    resolution: {integrity: sha512-k8TVBiPkPJT9uHLdOKfFpqcfprwBFOAAXXozRubr7R7PfIuKvQlzcI4M0pALeqXN09vdaMbUdUj+pass+uULAg==}\n\n  bn.js@5.2.1:\n    resolution: {integrity: sha512-eXRvHzWyYPBuB4NBy0cmYQjGitUrtqwbvlzP3G6VFnNRbsZQIxQ10PbKKHt8gZ/HW/D/747aDl+QkDqg3KQLMQ==}\n\n  brace-expansion@1.1.11:\n    resolution: {integrity: sha512-iCuPHDFgrHX7H2vEI/5xpz07zSHB00TpugqhmYtVmMO6518mCuRMoOYFldEBl0g187ufozdaHgWKcYFb61qGiA==}\n\n  braces@2.3.2:\n    resolution: {integrity: sha512-aNdbnj9P8PjdXU4ybaWLK2IF3jc/EoDYbC7AazW6to3TRsfXxscC9UXOB5iDiEQrkyIbWp2SLQda4+QAa7nc3w==}\n    engines: {node: '>=0.10.0'}\n\n  braces@3.0.3:\n    resolution: {integrity: sha512-yQbXgO/OSZVD2IsiLlro+7Hf6Q18EJrKSEsdoMzKePKXct3gvD8oLcOQdIzGupr5Fj+EDe8gO/lxc1BzfMpxvA==}\n    engines: {node: '>=8'}\n\n  brorand@1.1.0:\n    resolution: {integrity: sha512-cKV8tMCEpQs4hK/ik71d6LrPOnpkpGBR0wzxqr68g2m/LB2GxVYQroAjMJZRVM1Y4BCjCKc3vAamxSzOY2RP+w==}\n\n  browser-process-hrtime@1.0.0:\n    resolution: {integrity: sha512-9o5UecI3GhkpM6DrXr69PblIuWxPKk9Y0jHBRhdocZ2y7YECBFCsHm79Pr3OyR2AvjhDkabFJaDJMYRazHgsow==}\n\n  browserify-aes@1.2.0:\n    resolution: {integrity: sha512-+7CHXqGuspUn/Sl5aO7Ea0xWGAtETPXNSAjHo48JfLdPWcMng33Xe4znFvQweqc/uzk5zSOI3H52CYnjCfb5hA==}\n\n  browserify-cipher@1.0.1:\n    resolution: {integrity: sha512-sPhkz0ARKbf4rRQt2hTpAHqn47X3llLkUGn+xEJzLjwY8LRs2p0v7ljvI5EyoRO/mexrNunNECisZs+gw2zz1w==}\n\n  browserify-des@1.0.2:\n    resolution: {integrity: sha512-BioO1xf3hFwz4kc6iBhI3ieDFompMhrMlnDFC4/0/vd5MokpuAc3R+LYbwTA9A5Yc9pq9UYPqffKpW2ObuwX5A==}\n\n  browserify-rsa@4.1.1:\n    resolution: {integrity: sha512-YBjSAiTqM04ZVei6sXighu679a3SqWORA3qZTEqZImnlkDIFtKc6pNutpjyZ8RJTjQtuYfeetkxM11GwoYXMIQ==}\n    engines: {node: '>= 0.10'}\n\n  browserify-sign@4.2.3:\n    resolution: {integrity: sha512-JWCZW6SKhfhjJxO8Tyiiy+XYB7cqd2S5/+WeYHsKdNKFlCBhKbblba1A/HN/90YwtxKc8tCErjffZl++UNmGiw==}\n    engines: {node: '>= 0.12'}\n\n  browserify-zlib@0.2.0:\n    resolution: {integrity: sha512-Z942RysHXmJrhqk88FmKBVq/v5tqmSkDz7p54G/MGyjMnCFFnC79XWNbg+Vta8W6Wb2qtSZTSxIGkJrRpCFEiA==}\n\n  browserslist@4.24.2:\n    resolution: {integrity: sha512-ZIc+Q62revdMcqC6aChtW4jz3My3klmCO1fEmINZY/8J3EpBg5/A/D0AKmBveUh6pgoeycoMkVMko84tuYS+Gg==}\n    engines: {node: ^6 || ^7 || ^8 || ^9 || ^10 || ^11 || ^12 || >=13.7}\n    hasBin: true\n\n  bser@2.1.1:\n    resolution: {integrity: sha512-gQxTNE/GAfIIrmHLUE3oJyp5FO6HRBfhjnw4/wMmA63ZGDJnWBmgY/lyQBpnDUkGmAhbSe39tx2d/iTOAfglwQ==}\n\n  buffer-from@1.1.2:\n    resolution: {integrity: sha512-E+XQCRwSbaaiChtv6k6Dwgc+bx+Bs6vuKJHHl5kox/BaKbhiXzqQOwK4cO22yElGp2OCmjwVhT3HmxgyPGnJfQ==}\n\n  buffer-xor@1.0.3:\n    resolution: {integrity: sha512-571s0T7nZWK6vB67HI5dyUF7wXiNcfaPPPTl6zYCNApANjIvYJTg7hlud/+cJpdAhS7dVzqMLmfhfHR3rAcOjQ==}\n\n  buffer@4.9.2:\n    resolution: {integrity: sha512-xq+q3SRMOxGivLhBNaUdC64hDTQwejJ+H0T/NB1XMtTVEwNTrfFF3gAxiyW0Bu/xWEGhjVKgUcMhCrUy2+uCWg==}\n\n  builtin-status-codes@3.0.0:\n    resolution: {integrity: sha512-HpGFw18DgFWlncDfjTa2rcQ4W88O1mC8e8yZ2AvQY5KDaktSTwo+KRf6nHK6FRI5FyRyb/5T6+TSxfP7QyGsmQ==}\n\n  cache-base@1.0.1:\n    resolution: {integrity: sha512-AKcdTnFSWATd5/GCPRxr2ChwIJ85CeyrEyjRHlKxQ56d4XJMGym0uAiKn0xbLOGOl3+yRpOTi484dVCEc5AUzQ==}\n    engines: {node: '>=0.10.0'}\n\n  call-bind-apply-helpers@1.0.1:\n    resolution: {integrity: sha512-BhYE+WDaywFg2TBWYNXAE+8B1ATnThNBqXHP5nQu0jWJdVvY2hvkpyB3qOmtmDePiS5/BDQ8wASEWGMWRG148g==}\n    engines: {node: '>= 0.4'}\n\n  call-bind@1.0.8:\n    resolution: {integrity: sha512-oKlSFMcMwpUg2ednkhQ454wfWiU/ul3CkJe/PEHcTKuiX6RpbehUiFMXu13HalGZxfUwCQzZG747YXBn1im9ww==}\n    engines: {node: '>= 0.4'}\n\n  call-bound@1.0.2:\n    resolution: {integrity: sha512-0lk0PHFe/uz0vl527fG9CgdE9WdafjDbCXvBbs+LUv000TVt2Jjhqbs4Jwm8gz070w8xXyEAxrPOMullsxXeGg==}\n    engines: {node: '>= 0.4'}\n\n  caller-callsite@2.0.0:\n    resolution: {integrity: sha512-JuG3qI4QOftFsZyOn1qq87fq5grLIyk1JYd5lJmdA+fG7aQ9pA/i3JIJGcO3q0MrRcHlOt1U+ZeHW8Dq9axALQ==}\n    engines: {node: '>=4'}\n\n  caller-path@2.0.0:\n    resolution: {integrity: sha512-MCL3sf6nCSXOwCTzvPKhN18TU7AHTvdtam8DAogxcrJ8Rjfbbg7Lgng64H9Iy+vUV6VGFClN/TyxBkAebLRR4A==}\n    engines: {node: '>=4'}\n\n  callsites@2.0.0:\n    resolution: {integrity: sha512-ksWePWBloaWPxJYQ8TL0JHvtci6G5QTKwQ95RcWAa/lzoAKuAOflGdAK92hpHXjkwb8zLxoLNUoNYZgVsaJzvQ==}\n    engines: {node: '>=4'}\n\n  callsites@3.1.0:\n    resolution: {integrity: sha512-P8BjAsXvZS+VIDUI11hHCQEv74YT67YUi5JJFNWIqL235sBmjX4+qx9Muvls5ivyNENctx46xQLQ3aTuE7ssaQ==}\n    engines: {node: '>=6'}\n\n  camelcase@5.3.1:\n    resolution: {integrity: sha512-L28STB170nwWS63UjtlEOE3dldQApaJXZkOI1uMFfzf3rRuPegHaHesyee+YxQ+W6SvRDQV6UrdOdRiR153wJg==}\n    engines: {node: '>=6'}\n\n  camelcase@6.3.0:\n    resolution: {integrity: sha512-Gmy6FhYlCY7uOElZUSbxo2UCDH8owEk996gkbrpsgGtrJLM3J7jGxl9Ic7Qwwj4ivOE5AWZWRMecDdF7hqGjFA==}\n    engines: {node: '>=10'}\n\n  caniuse-lite@1.0.30001688:\n    resolution: {integrity: sha512-Nmqpru91cuABu/DTCXbM2NSRHzM2uVHfPnhJ/1zEAJx/ILBRVmz3pzH4N7DZqbdG0gWClsCC05Oj0mJ/1AWMbA==}\n\n  capture-exit@2.0.0:\n    resolution: {integrity: sha512-PiT/hQmTonHhl/HFGN+Lx3JJUznrVYJ3+AQsnthneZbvW7x+f08Tk7yLJTLEOUvBTbduLeeBkxEaYXUOUrRq6g==}\n    engines: {node: 6.* || 8.* || >= 10.*}\n\n  chalk@2.4.2:\n    resolution: {integrity: sha512-Mti+f9lpJNcwF4tWV8/OrTTtF1gZi+f8FqlyAdouralcFWFQWF2+NgCHShjkCb+IFBLq9buZwE1xckQU4peSuQ==}\n    engines: {node: '>=4'}\n\n  chalk@4.1.2:\n    resolution: {integrity: sha512-oKnbhFyRIXpUuez8iBMmyEa4nbj4IOQyuhc/wy9kY7/WVPcwIO9VA668Pu8RkO7+0G76SLROeyw9CpQ061i4mA==}\n    engines: {node: '>=10'}\n\n  char-regex@1.0.2:\n    resolution: {integrity: sha512-kWWXztvZ5SBQV+eRgKFeh8q5sLuZY2+8WUIzlxWVTg+oGwY14qylx1KbKzHd8P6ZYkAg0xyIDU9JMHhyJMZ1jw==}\n    engines: {node: '>=10'}\n\n  chokidar@3.5.1:\n    resolution: {integrity: sha512-9+s+Od+W0VJJzawDma/gvBNQqkTiqYTWLuZoyAsivsI4AaWTCzHG06/TMjsf1cYe9Cb97UCEhjz7HvnPk2p/tw==}\n    engines: {node: '>= 8.10.0'}\n\n  ci-info@1.6.0:\n    resolution: {integrity: sha512-vsGdkwSCDpWmP80ncATX7iea5DWQemg1UgCW5J8tqjU3lYw4FBYuj89J0CTVomA7BEfvSZd84GmHko+MxFQU2A==}\n\n  ci-info@2.0.0:\n    resolution: {integrity: sha512-5tK7EtrZ0N+OLFMthtqOj4fI2Jeb88C4CAZPu25LDVUgXJ0A3Js4PMGqrn0JU1W0Mh1/Z8wZzYPxqUrXeBboCQ==}\n\n  cipher-base@1.0.6:\n    resolution: {integrity: sha512-3Ek9H3X6pj5TgenXYtNWdaBon1tgYCaebd+XPg0keyjEbEfkD4KkmAxkQ/i1vYvxdcT5nscLBfq9VJRmCBcFSw==}\n    engines: {node: '>= 0.10'}\n\n  cjs-module-lexer@0.6.0:\n    resolution: {integrity: sha512-uc2Vix1frTfnuzxxu1Hp4ktSvM3QaI4oXl4ZUqL1wjTu/BGki9TrCWoqLTg/drR1KwAEarXuRFCG2Svr1GxPFw==}\n\n  class-utils@0.3.6:\n    resolution: {integrity: sha512-qOhPa/Fj7s6TY8H8esGu5QNpMMQxz79h+urzrNYN6mn+9BnxlDGf5QZ+XeCDsxSjPqsSR56XOZOJmpeurnLMeg==}\n    engines: {node: '>=0.10.0'}\n\n  classnames@2.5.1:\n    resolution: {integrity: sha512-saHYOzhIQs6wy2sVxTM6bUDsQO4F50V9RQ22qBpEdCW+I+/Wmke2HOl6lS6dTpdxVhb88/I6+Hs+438c3lfUow==}\n\n  clean-stack@2.2.0:\n    resolution: {integrity: sha512-4diC9HaTE+KRAMWhDhrGOECgWZxoevMc5TlkObMqNSsVU62PYzXZ/SMTjzyGAFF1YusgxGcSWTEXBhp0CPwQ1A==}\n    engines: {node: '>=6'}\n\n  cli-cursor@3.1.0:\n    resolution: {integrity: sha512-I/zHAwsKf9FqGoXM4WWRACob9+SNukZTd94DWF57E4toouRulbCxcUh6RKUEOQlYTHJnzkPMySvPNaaSLNfLZw==}\n    engines: {node: '>=8'}\n\n  cli-truncate@2.1.0:\n    resolution: {integrity: sha512-n8fOixwDD6b/ObinzTrp1ZKFzbgvKZvuz/TvejnLn1aQfC6r52XEx85FmuC+3HI+JM7coBRXUvNqEU2PHVrHpg==}\n    engines: {node: '>=8'}\n\n  clipboardy@2.3.0:\n    resolution: {integrity: sha512-mKhiIL2DrQIsuXMgBgnfEHOZOryC7kY7YO//TN6c63wlEm3NG5tz+YgY5rVi29KCmq/QQjKYvM7a19+MDOTHOQ==}\n    engines: {node: '>=8'}\n\n  cliui@6.0.0:\n    resolution: {integrity: sha512-t6wbgtoCXvAzst7QgXxJYqPt0usEfbgQdftEPbLL/cvv6HPE5VgvqCuAIDR0NgU52ds6rFwqrgakNLrHEjCbrQ==}\n\n  co@4.6.0:\n    resolution: {integrity: sha512-QVb0dM5HvG+uaxitm8wONl7jltx8dqhfU33DcqtOZcLSVIKSDDLDi7+0LbAKiyI8hD9u42m2YxXSkMGWThaecQ==}\n    engines: {iojs: '>= 1.0.0', node: '>= 0.12.0'}\n\n  collect-v8-coverage@1.0.2:\n    resolution: {integrity: sha512-lHl4d5/ONEbLlJvaJNtsF/Lz+WvB07u2ycqTYbdrq7UypDXailES4valYb2eWiJFxZlVmpGekfqoxQhzyFdT4Q==}\n\n  collection-visit@1.0.0:\n    resolution: {integrity: sha512-lNkKvzEeMBBjUGHZ+q6z9pSJla0KWAQPvtzhEV9+iGyQYG+pBpl7xKDhxoNSOZH2hhv0v5k0y2yAM4o4SjoSkw==}\n    engines: {node: '>=0.10.0'}\n\n  color-convert@1.9.3:\n    resolution: {integrity: sha512-QfAUtd+vFdAtFQcC8CCyYt1fYWxSqAiK2cSD6zDB8N3cpsEBAvRxp9zOGg6G/SHHJYAT88/az/IuDGALsNVbGg==}\n\n  color-convert@2.0.1:\n    resolution: {integrity: sha512-RRECPsj7iu/xb5oKYcsFHSppFNnsj/52OVTRKb4zP5onXwVF3zVmmToNcOfGC+CRDpfK/U584fMg38ZHCaElKQ==}\n    engines: {node: '>=7.0.0'}\n\n  color-name@1.1.3:\n    resolution: {integrity: sha512-72fSenhMw2HZMTVHeCA9KCmpEIbzWiQsjN+BHcBbS9vr1mtt+vJjPdksIBNUmKAW8TFUDPJK5SUU3QhE9NEXDw==}\n\n  color-name@1.1.4:\n    resolution: {integrity: sha512-dOy+3AuW3a2wNbZHIuMZpTcgjGuLU/uBL/ubcZF9OXbDo8ff4O8yVp5Bf0efS8uEoYo5q4Fx7dY9OgQGXgAsQA==}\n\n  colorette@2.0.20:\n    resolution: {integrity: sha512-IfEDxwoWIjkeXL1eXcDiow4UbKjhLdq6/EuSVR9GMN7KVH3r9gQ83e73hsz1Nd1T3ijd5xv1wcWRYO+D6kCI2w==}\n\n  combined-stream@1.0.8:\n    resolution: {integrity: sha512-FQN4MRfuJeHf7cBbBMJFXhKSDq+2kAArBlmRBvcvFE5BB1HZKXtSFASDhdlz9zOYwxh8lDdnvmMOe/+5cdoEdg==}\n    engines: {node: '>= 0.8'}\n\n  commander@2.20.3:\n    resolution: {integrity: sha512-GpVkmM8vF2vQUkj2LvZmD35JxeJOLCwJ9cUkugyk2nuhbv3+mJvpLYYt+0+USMxE+oj+ey/lJEnhZw75x/OMcQ==}\n\n  commander@6.2.1:\n    resolution: {integrity: sha512-U7VdrJFnJgo4xjrHpTzu0yrHPGImdsmD95ZlgYSEajAn2JKzDhDTPG9kBTefmObL2w/ngeZnilk+OV9CG3d7UA==}\n    engines: {node: '>= 6'}\n\n  component-classes@1.2.6:\n    resolution: {integrity: sha512-hPFGULxdwugu1QWW3SvVOCUHLzO34+a2J6Wqy0c5ASQkfi9/8nZcBB0ZohaEbXOQlCflMAEMmEWk7u7BVs4koA==}\n\n  component-emitter@1.3.1:\n    resolution: {integrity: sha512-T0+barUSQRTUQASh8bx02dl+DhF54GtIDY13Y3m9oWTklKbb3Wv974meRpeZ3lp1JpLVECWWNHC4vaG2XHXouQ==}\n\n  component-indexof@0.0.3:\n    resolution: {integrity: sha512-puDQKvx/64HZXb4hBwIcvQLaLgux8o1CbWl39s41hrIIZDl1lJiD5jc22gj3RBeGK0ovxALDYpIbyjqDUUl0rw==}\n\n  compute-scroll-into-view@1.0.20:\n    resolution: {integrity: sha512-UCB0ioiyj8CRjtrvaceBLqqhZCVP+1B8+NWQhmdsm0VXOJtobBCf1dBQmebCCo34qZmUwZfIH2MZLqNHazrfjg==}\n\n  concat-map@0.0.1:\n    resolution: {integrity: sha512-/Srv4dswyQNBfohGpz9o6Yb3Gz3SrUDqBH5rTuhGR7ahtlbYKnVxw2bCFMRljaA7EXHaXZ8wsHdodFvbkhKmqg==}\n\n  connected-react-router@6.5.2:\n    resolution: {integrity: sha512-qzsLPZCofSI80fwy+HgxtEgSGS4ndYUUZAWaw1dqaOGPLKX/FVwIOEb7q+hjHdnZ4v5pKZcNv5GG4urjujIoyA==}\n    peerDependencies:\n      history: ^4.7.2\n      react: ^16.4.0\n      react-redux: ^6.0.0 || ^7.1.0\n      react-router: ^4.3.1 || ^5.0.0\n      redux: ^3.6.0 || ^4.0.0\n\n  console-browserify@1.2.0:\n    resolution: {integrity: sha512-ZMkYO/LkF17QvCPqM0gxw8yUzigAOZOSWSHg91FH6orS7vcEj5dVZTidN2fQ14yBSdg97RqhSNwLUXInd52OTA==}\n\n  constants-browserify@1.0.0:\n    resolution: {integrity: sha512-xFxOwqIzR/e1k1gLiWEophSCMqXcwVHIH7akf7b/vxcUeGunlj3hvZaaqxwHsTgn+IndtkQJgSztIDWeumWJDQ==}\n\n  convert-source-map@1.9.0:\n    resolution: {integrity: sha512-ASFBup0Mz1uyiIjANan1jzLQami9z1PoYSZCiiYW2FczPbenXc45FZdBZLzOT+r6+iciuEModtmCti+hjaAk0A==}\n\n  copy-descriptor@0.1.1:\n    resolution: {integrity: sha512-XgZ0pFcakEUlbwQEVNg3+QAis1FyTL3Qel9FYy8pSkQqoG3PNoT0bOCQtOXcOkur21r2Eq2kI+IE+gsmAEVlYw==}\n    engines: {node: '>=0.10.0'}\n\n  copy-to-clipboard@3.3.3:\n    resolution: {integrity: sha512-2KV8NhB5JqC3ky0r9PMCAZKbUHSwtEo4CwCs0KXgruG43gX5PMqDEBbVU4OUzw2MuAWUfsuFmWvEKG5QRfSnJA==}\n\n  core-js-pure@3.39.0:\n    resolution: {integrity: sha512-7fEcWwKI4rJinnK+wLTezeg2smbFFdSBP6E2kQZNbnzM2s1rpKQ6aaRteZSSg7FLU3P0HGGVo/gbpfanU36urg==}\n\n  core-js@1.2.7:\n    resolution: {integrity: sha512-ZiPp9pZlgxpWRu0M+YWbm6+aQ84XEfH1JRXvfOc/fILWI0VKhLC2LX13X1NYq4fULzLMq7Hfh43CSo2/aIaUPA==}\n    deprecated: core-js@<3.23.3 is no longer maintained and not recommended for usage due to the number of issues. Because of the V8 engine whims, feature detection in old core-js versions could cause a slowdown up to 100x even if nothing is polyfilled. Some versions have web compatibility issues. Please, upgrade your dependencies to the actual version of core-js.\n\n  core-js@2.6.12:\n    resolution: {integrity: sha512-Kb2wC0fvsWfQrgk8HU5lW6U/Lcs8+9aaYcy4ZFc6DDlo4nZ7n70dEgE5rtR0oG6ufKDUnrwfWL1mXR5ljDatrQ==}\n    deprecated: core-js@<3.23.3 is no longer maintained and not recommended for usage due to the number of issues. Because of the V8 engine whims, feature detection in old core-js versions could cause a slowdown up to 100x even if nothing is polyfilled. Some versions have web compatibility issues. Please, upgrade your dependencies to the actual version of core-js.\n\n  core-js@3.6.5:\n    resolution: {integrity: sha512-vZVEEwZoIsI+vPEuoF9Iqf5H7/M3eeQqWlQnYa8FSKKePuYTf5MWnxb5SDAzCa60b3JBRS5g9b+Dq7b1y/RCrA==}\n    deprecated: core-js@<3.23.3 is no longer maintained and not recommended for usage due to the number of issues. Because of the V8 engine whims, feature detection in old core-js versions could cause a slowdown up to 100x even if nothing is polyfilled. Some versions have web compatibility issues. Please, upgrade your dependencies to the actual version of core-js.\n\n  core-js@3.8.2:\n    resolution: {integrity: sha512-FfApuSRgrR6G5s58casCBd9M2k+4ikuu4wbW6pJyYU7bd9zvFc9qf7vr5xmrZOhT9nn+8uwlH1oRR9jTnFoA3A==}\n    deprecated: core-js@<3.23.3 is no longer maintained and not recommended for usage due to the number of issues. Because of the V8 engine whims, feature detection in old core-js versions could cause a slowdown up to 100x even if nothing is polyfilled. Some versions have web compatibility issues. Please, upgrade your dependencies to the actual version of core-js.\n\n  core-util-is@1.0.3:\n    resolution: {integrity: sha512-ZQBvi1DcpJ4GDqanjucZ2Hj3wEO5pZDS89BWbkcrvdxksJorwUDDZamX9ldFkp9aw2lmBDLgkObEA4DWNJ9FYQ==}\n\n  cosmiconfig@5.2.1:\n    resolution: {integrity: sha512-H65gsXo1SKjf8zmrJ67eJk8aIRKV5ff2D4uKZIBZShbhGSpEmsQOPW/SKMKYhSTrqR7ufy6RP69rPogdaPh/kA==}\n    engines: {node: '>=4'}\n\n  cosmiconfig@7.1.0:\n    resolution: {integrity: sha512-AdmX6xUzdNASswsFtmwSt7Vj8po9IuqXm0UXz7QKPuEUmPB4XyjGfaAr2PSuELMwkRMVH1EpIkX5bTZGRB3eCA==}\n    engines: {node: '>=10'}\n\n  create-ecdh@4.0.4:\n    resolution: {integrity: sha512-mf+TCx8wWc9VpuxfP2ht0iSISLZnt0JgWlrOKZiNqyUZWnjIaCIVNQArMHnCZKfEYRg6IM7A+NeJoN8gf/Ws0A==}\n\n  create-hash@1.2.0:\n    resolution: {integrity: sha512-z00bCGNHDG8mHAkP7CtT1qVu+bFQUPjYq/4Iv3C3kWjTFV10zIjfSoeqXo9Asws8gwSHDGj/hl2u4OGIjapeCg==}\n\n  create-hmac@1.1.7:\n    resolution: {integrity: sha512-MJG9liiZ+ogc4TzUwuvbER1JRdgvUFSB5+VR/g5h82fGaIRWMWddtKBHi7/sVhfjQZ6SehlyhvQYrcYkaUIpLg==}\n\n  create-react-class@15.7.0:\n    resolution: {integrity: sha512-QZv4sFWG9S5RUvkTYWbflxeZX+JG7Cz0Tn33rQBJ+WFQTqTfUTjMjiv9tnfXazjsO5r0KhPs+AqCjyrQX6h2ng==}\n\n  cross-spawn@5.1.0:\n    resolution: {integrity: sha512-pTgQJ5KC0d2hcY8eyL1IzlBPYjTkyH72XRZPnLyKus2mBfNjQs3klqbJU2VILqZryAZUt9JOb3h/mWMy23/f5A==}\n\n  cross-spawn@6.0.6:\n    resolution: {integrity: sha512-VqCUuhcd1iB+dsv8gxPttb5iZh/D0iubSP21g36KXdEuf6I5JiioesUVjpCdHV9MZRUfVFlvwtIUyPfxo5trtw==}\n    engines: {node: '>=4.8'}\n\n  cross-spawn@7.0.6:\n    resolution: {integrity: sha512-uV2QOWP2nWzsy2aMp8aRibhi9dlzF5Hgh5SHaB9OiTGEyDTiJJyx0uy51QXdyWbtAHNua4XJzUKca3OzKUd3vA==}\n    engines: {node: '>= 8'}\n\n  crypto-browserify@3.12.1:\n    resolution: {integrity: sha512-r4ESw/IlusD17lgQi1O20Fa3qNnsckR126TdUuBgAu7GBYSIPvdNyONd3Zrxh0xCwA4+6w/TDArBPsMvhur+KQ==}\n    engines: {node: '>= 0.10'}\n\n  css-animation@1.6.1:\n    resolution: {integrity: sha512-/48+/BaEaHRY6kNQ2OIPzKf9A6g8WjZYjhiNDNuIVbsm5tXCGIAsHDjB4Xu1C4vXJtUWZo26O68OQkDpNBaPog==}\n\n  css-blank-pseudo@0.1.4:\n    resolution: {integrity: sha512-LHz35Hr83dnFeipc7oqFDmsjHdljj3TQtxGGiNWSOsTLIAubSm4TEz8qCaKFpk7idaQ1GfWscF4E6mgpBysA1w==}\n    engines: {node: '>=6.0.0'}\n    hasBin: true\n\n  css-has-pseudo@0.10.0:\n    resolution: {integrity: sha512-Z8hnfsZu4o/kt+AuFzeGpLVhFOGO9mluyHBaA2bA8aCGTwah5sT3WV/fTHH8UNZUytOIImuGPrl/prlb4oX4qQ==}\n    engines: {node: '>=6.0.0'}\n    hasBin: true\n\n  css-prefers-color-scheme@3.1.1:\n    resolution: {integrity: sha512-MTu6+tMs9S3EUqzmqLXEcgNRbNkkD/TGFvowpeoWJn5Vfq7FMgsmRQs9X5NXAURiOBmOxm/lLjsDNXDE6k9bhg==}\n    engines: {node: '>=6.0.0'}\n    hasBin: true\n\n  cssdb@4.4.0:\n    resolution: {integrity: sha512-LsTAR1JPEM9TpGhl/0p3nQecC2LJ0kD8X5YARu1hk/9I1gril5vDtMZyNxcEpxxDj34YNck/ucjuoUd66K03oQ==}\n\n  cssesc@2.0.0:\n    resolution: {integrity: sha512-MsCAG1z9lPdoO/IUMLSBWBSVxVtJ1395VGIQ+Fc2gNdkQ1hNDnQdw3YhA71WJCBW1vdwA0cAnk/DnW6bqoEUYg==}\n    engines: {node: '>=4'}\n    hasBin: true\n\n  cssesc@3.0.0:\n    resolution: {integrity: sha512-/Tb/JcjK111nNScGob5MNtsntNM1aCNUDipB/TkwZFhyDrrE47SOx/18wF2bbjgc3ZzCSKW1T5nt5EbFoAz/Vg==}\n    engines: {node: '>=4'}\n    hasBin: true\n\n  cssom@0.3.8:\n    resolution: {integrity: sha512-b0tGHbfegbhPJpxpiBPU2sCkigAqtM9O121le6bbOlgyV+NyGyCmVfJ6QW9eRjz8CpNfWEOYBIMIGRYkLwsIYg==}\n\n  cssom@0.4.4:\n    resolution: {integrity: sha512-p3pvU7r1MyyqbTk+WbNJIgJjG2VmTIaB10rI93LzVPrmDJKkzKYMtxxyAvQXR/NS6otuzveI7+7BBq3SjBS2mw==}\n\n  cssstyle@2.3.0:\n    resolution: {integrity: sha512-AZL67abkUzIuvcHqk7c09cezpGNcxUxU4Ioi/05xHk4DQeTkWmGYftIE6ctU6AEt+Gn4n1lDStOtj7FKycP71A==}\n    engines: {node: '>=8'}\n\n  csstype@3.1.3:\n    resolution: {integrity: sha512-M1uQkMl8rQK/szD0LNhtqxIPLpimGm8sOBwU7lLnCpSbTyY3yeU1Vc7l4KT5zT4s/yOxHH5O7tIuuLOCnLADRw==}\n\n  data-urls@2.0.0:\n    resolution: {integrity: sha512-X5eWTSXO/BJmpdIKCRuKUgSCgAN0OwliVK3yPKbwIWU1Tdw5BRajxlzMidvh+gwko9AfQ9zIj52pzF91Q3YAvQ==}\n    engines: {node: '>=10'}\n\n  date-fns@2.30.0:\n    resolution: {integrity: sha512-fnULvOpxnC5/Vg3NCiWelDsLiUc9bRwAPs/+LfTLNvetFCtCTN+yQz15C/fs4AwX1R9K5GLtLfn8QW+dWisaAw==}\n    engines: {node: '>=0.11'}\n\n  dayjs@1.11.13:\n    resolution: {integrity: sha512-oaMBel6gjolK862uaPQOVTA7q3TZhuSvuMQAAglQDOWYO9A91IrAOUJEyKVlqJlHE0vq5p5UXxzdPfMH/x6xNg==}\n\n  debug@2.6.9:\n    resolution: {integrity: sha512-bC7ElrdJaJnPbAP+1EotYvqZsb3ecl5wi6Bfi6BJTUcNowp6cvspg0jXznRTKDjm/E7AdgFBVeAPVMNcKGsHMA==}\n    peerDependencies:\n      supports-color: '*'\n    peerDependenciesMeta:\n      supports-color:\n        optional: true\n\n  debug@4.4.0:\n    resolution: {integrity: sha512-6WTZ/IxCY/T6BALoZHaE4ctp9xm+Z5kY/pzYaCHRFeyVhojxlrm+46y68HA6hr0TcwEssoxNiDEUJQjfPZ/RYA==}\n    engines: {node: '>=6.0'}\n    peerDependencies:\n      supports-color: '*'\n    peerDependenciesMeta:\n      supports-color:\n        optional: true\n\n  decamelize@1.2.0:\n    resolution: {integrity: sha512-z2S+W9X73hAUUki+N+9Za2lBlun89zigOyGrsax+KUQ6wKW4ZoWpEYBkGhQjwAjjDCkWxhY0VKEhk8wzY7F5cA==}\n    engines: {node: '>=0.10.0'}\n\n  decimal.js@10.4.3:\n    resolution: {integrity: sha512-VBBaLc1MgL5XpzgIP7ny5Z6Nx3UrRkIViUkPUdtl9aya5amy3De1gsUUSB1g3+3sExYNjCAsAznmukyxCb1GRA==}\n\n  decode-uri-component@0.2.2:\n    resolution: {integrity: sha512-FqUYQ+8o158GyGTrMFJms9qh3CqTKvAqgqsTnkLI8sKu0028orqBhxNMFkFen0zGyg6epACD32pjVk58ngIErQ==}\n    engines: {node: '>=0.10'}\n\n  dedent@0.7.0:\n    resolution: {integrity: sha512-Q6fKUPqnAHAyhiUgFU7BUzLiv0kd8saH9al7tnu5Q/okj6dnupxyTgFIBjVzJATdfIAm9NAsvXNzjaKa+bxVyA==}\n\n  deepmerge@1.5.2:\n    resolution: {integrity: sha512-95k0GDqvBjZavkuvzx/YqVLv/6YYa17fz6ILMSf7neqQITCPbnfEnQvEgMPNjH4kgobe7+WIL0yJEHku+H3qtQ==}\n    engines: {node: '>=0.10.0'}\n\n  deepmerge@4.3.1:\n    resolution: {integrity: sha512-3sUqbMEc77XqpdNO7FRyRog+eW3ph+GYCbj+rK+uYyRMuwsVy0rMiVtPn+QJlKFvWP/1PYpapqYn0Me2knFn+A==}\n    engines: {node: '>=0.10.0'}\n\n  define-data-property@1.1.4:\n    resolution: {integrity: sha512-rBMvIzlpA8v6E+SJZoo++HAYqsLrkg7MSfIinMPFhmkorw7X+dOXVJQs+QT69zGkzMyfDnIMN2Wid1+NbL3T+A==}\n    engines: {node: '>= 0.4'}\n\n  define-properties@1.2.1:\n    resolution: {integrity: sha512-8QmQKqEASLd5nx0U1B1okLElbUuuttJ/AnYmRXbbbGDWh6uS208EjD4Xqq/I9wK7u0v6O08XhTWnt5XtEbR6Dg==}\n    engines: {node: '>= 0.4'}\n\n  define-property@0.2.5:\n    resolution: {integrity: sha512-Rr7ADjQZenceVOAKop6ALkkRAmH1A4Gx9hV/7ZujPUN2rkATqFO0JZLZInbAjpZYoJ1gUx8MRMQVkYemcbMSTA==}\n    engines: {node: '>=0.10.0'}\n\n  define-property@1.0.0:\n    resolution: {integrity: sha512-cZTYKFWspt9jZsMscWo8sc/5lbPC9Q0N5nBLgb+Yd915iL3udB1uFgS3B8YCx66UVHq018DAVFoee7x+gxggeA==}\n    engines: {node: '>=0.10.0'}\n\n  define-property@2.0.2:\n    resolution: {integrity: sha512-jwK2UV4cnPpbcG7+VRARKTZPUWowwXA8bzH5NP6ud0oeAxyYPuGZUAC7hMugpCdz4BeSZl2Dl9k66CHJ/46ZYQ==}\n    engines: {node: '>=0.10.0'}\n\n  delayed-stream@1.0.0:\n    resolution: {integrity: sha512-ZySD7Nf91aLB0RxL4KGrKHBXl7Eds1DAmEdcoVawXnLD7SDhpNgtuII2aAkg7a7QS41jxPSZ17p4VdGnMHk3MQ==}\n    engines: {node: '>=0.4.0'}\n\n  des.js@1.1.0:\n    resolution: {integrity: sha512-r17GxjhUCjSRy8aiJpr8/UadFIzMzJGexI3Nmz4ADi9LYSFx4gTBp80+NaX/YsXWWLhpZ7v/v/ubEc/bCNfKwg==}\n\n  detect-newline@3.1.0:\n    resolution: {integrity: sha512-TLz+x/vEXm/Y7P7wn1EJFNLxYpUD4TgMosxY6fAVJUnJMbupHBOncxyWUG9OpTaH9EBD7uFI5LfEgmMOc54DsA==}\n    engines: {node: '>=8'}\n\n  diff-sequences@26.6.2:\n    resolution: {integrity: sha512-Mv/TDa3nZ9sbc5soK+OoA74BsS3mL37yixCvUAQkiuA4Wz6YtwP/K47n2rv2ovzHZvoiQeA5FTQOschKkEwB0Q==}\n    engines: {node: '>= 10.14.2'}\n\n  diffie-hellman@5.0.3:\n    resolution: {integrity: sha512-kqag/Nl+f3GwyK25fhUMYj81BUOrZ9IuJsjIcDE5icNM9FJHAVm3VcUDxdLPoQtTuUylWm6ZIknYJwwaPxsUzg==}\n\n  dom-align@1.12.4:\n    resolution: {integrity: sha512-R8LUSEay/68zE5c8/3BDxiTEvgb4xZTF0RKmAHfiEVN3klfIpXfi2/QCoiWPccVQ0J/ZGdz9OjzL4uJEP/MRAw==}\n\n  dom-walk@0.1.2:\n    resolution: {integrity: sha512-6QvTW9mrGeIegrFXdtQi9pk7O/nSK6lSdXW2eqUspN5LWD7UTji2Fqw5V2YLjBpHEoU9Xl/eUWNpDeZvoyOv2w==}\n\n  domain-browser@1.2.0:\n    resolution: {integrity: sha512-jnjyiM6eRyZl2H+W8Q/zLMA481hzi0eszAaBUzIVnmYVDBbnLxVNnfu1HgEBvCbL+71FrxMl3E6lpKH7Ge3OXA==}\n    engines: {node: '>=0.4', npm: '>=1.2'}\n\n  domexception@2.0.1:\n    resolution: {integrity: sha512-yxJ2mFy/sibVQlu5qHjOkf9J3K6zgmCxgJ94u2EdvDOV09H+32LtRswEcUsmUWN72pVLOEnTSRaIVVzVQgS0dg==}\n    engines: {node: '>=8'}\n    deprecated: Use your platform's native DOMException instead\n\n  dunder-proto@1.0.0:\n    resolution: {integrity: sha512-9+Sj30DIu+4KvHqMfLUGLFYL2PkURSYMVXJyXe92nFRvlYq5hBjLEhblKB+vkd/WVlUYMWigiY07T91Fkk0+4A==}\n    engines: {node: '>= 0.4'}\n\n  dva-core@2.0.4:\n    resolution: {integrity: sha512-Zh39llFyItu9HKXKfCZVf9UFtDTcypdAjGBew1S+wK8BGVzFpm1GPTdd6uIMeg7O6STtCvt2Qv+RwUut1GFynA==}\n    peerDependencies:\n      redux: 4.x\n\n  dva-immer@0.5.2:\n    resolution: {integrity: sha512-xg23ktGsrdzgiU0ACl8vFm2+E2GBWbtXndXRKM9wtHDR+yMH27NfttVuAZQWvv4aaj6f5/bC+TdsZ9t7n6cAhQ==}\n    peerDependencies:\n      dva: ^2.5.0-0\n\n  dva-loading@3.0.25:\n    resolution: {integrity: sha512-RYbpSjvPj2NF+3YSc9QkDpwM1wO8uRAVfU6VGSgIxA2kA/Xd6yoY+VQM7GDRnvCvT579pESeBZBXk+8WKWOdDA==}\n    peerDependencies:\n      dva-core: ^1.1.0 || ^1.5.0-0 || ^1.6.0-0\n\n  dva@2.6.0-beta.23:\n    resolution: {integrity: sha512-noeOz3Erxpc6YLEsyyS//zGszeRYWKEvZoeCZ0LaCvWrV7Cxah9Xt/I9V1SS9eYDySaSgTUOoU+dLweQpCScAA==}\n    peerDependencies:\n      react: ^16.8.4\n      react-dom: ^16.8.4\n\n  electron-to-chromium@1.5.73:\n    resolution: {integrity: sha512-8wGNxG9tAG5KhGd3eeA0o6ixhiNdgr0DcHWm85XPCphwZgD1lIEoi6t3VERayWao7SF7AAZTw6oARGJeVjH8Kg==}\n\n  elliptic@6.6.1:\n    resolution: {integrity: sha512-RaddvvMatK2LJHqFJ+YA4WysVN5Ita9E35botqIYspQ4TkRAlCicdzKOjlyv/1Za5RyTNn7di//eEV0uTAfe3g==}\n\n  emittery@0.7.2:\n    resolution: {integrity: sha512-A8OG5SR/ij3SsJdWDJdkkSYUjQdCUx6APQXem0SaEePBSRg4eymGYwBkKo1Y6DU+af/Jn2dBQqDBvjnr9Vi8nQ==}\n    engines: {node: '>=10'}\n\n  emoji-regex@8.0.0:\n    resolution: {integrity: sha512-MSjYzcWNOA0ewAHpz0MxpYFvwg6yjy1NG3xteoqz644VCo/RPgnr1/GGt+ic3iJTzQ8Eu3TdM14SawnVUmGE6A==}\n\n  emojis-list@3.0.0:\n    resolution: {integrity: sha512-/kyM18EfinwXZbno9FyUGeFh87KC8HRQBQGildHZbEuRyWFOmv1U10o9BBp8XVZDVNNuQKyIGIu5ZYAAXJ0V2Q==}\n    engines: {node: '>= 4'}\n\n  encoding@0.1.13:\n    resolution: {integrity: sha512-ETBauow1T35Y/WZMkio9jiM0Z5xjHHmJ4XmjZOq1l/dXz3lr2sRn87nJy20RupqSh1F2m3HHPSp8ShIPQJrJ3A==}\n\n  end-of-stream@1.4.4:\n    resolution: {integrity: sha512-+uw1inIHVPQoaVuHzRyXd21icM+cnt4CzD5rW+NC1wjOUSTOs+Te7FOv7AhN7vS9x/oIyhLP5PR1H+phQAHu5Q==}\n\n  enquirer@2.4.1:\n    resolution: {integrity: sha512-rRqJg/6gd538VHvR3PSrdRBb/1Vy2YfzHqzvbhGIQpDRKIa4FgV/54b5Q1xYSxOOwKvjXweS26E0Q+nAMwp2pQ==}\n    engines: {node: '>=8.6'}\n\n  error-ex@1.3.2:\n    resolution: {integrity: sha512-7dFHNmqeFSEt2ZBsCriorKnn3Z2pj+fd9kmI6QoWw4//DL+icEBfc0U7qJCisqrTsKTjw4fNFy2pW9OqStD84g==}\n\n  error-stack-parser@1.3.6:\n    resolution: {integrity: sha512-xhuSYd8wLgOXwNgjcPeXMPL/IiiA1Huck+OPvClpJViVNNlJVtM41o+1emp7bPvlCJwCatFX2DWc05/DgfbWzA==}\n\n  error-stack-parser@2.1.4:\n    resolution: {integrity: sha512-Sk5V6wVazPhq5MhpO+AUxJn5x7XSXGl1R93Vn7i+zS15KDVxQijejNCrz8340/2bgLBjR9GtEG8ZVKONDjcqGQ==}\n\n  es-define-property@1.0.1:\n    resolution: {integrity: sha512-e3nRfgfUZ4rNGL232gUgX06QNyyez04KdjFrF+LTRoOXmrOgFKDg4BCdsjW8EnT69eqdYGmRpJwiPVYNrCaW3g==}\n    engines: {node: '>= 0.4'}\n\n  es-errors@1.3.0:\n    resolution: {integrity: sha512-Zf5H2Kxt2xjTvbJvP2ZWLEICxA6j+hAmMzIlypy4xcBg1vKVnx89Wy0GbS+kf5cwCVFFzdCFh2XSCFNULS6csw==}\n    engines: {node: '>= 0.4'}\n\n  es-module-lexer@0.7.1:\n    resolution: {integrity: sha512-MgtWFl5No+4S3TmhDmCz2ObFGm6lEpTnzbQi+Dd+pw4mlTIZTmM2iAs5gRlmx5zS9luzobCSBSI90JM/1/JgOw==}\n\n  es-object-atoms@1.0.0:\n    resolution: {integrity: sha512-MZ4iQ6JwHOBQjahnjwaC1ZtIBH+2ohjamzAO3oaHcXYup7qxjF2fixyH+Q71voWHeOkI2q/TnJao/KfXYIZWbw==}\n    engines: {node: '>= 0.4'}\n\n  es5-imcompatible-versions@0.1.90:\n    resolution: {integrity: sha512-2MPI0t/VV4j/oz1qbMekb4gCW81dewTpM2XJHKnPpZiPGu+1rVWmhTnwcq1vt8AFwWrkNF4RE7OZ9ibnKFYKwg==}\n\n  esbuild@0.12.15:\n    resolution: {integrity: sha512-72V4JNd2+48eOVCXx49xoSWHgC3/cCy96e7mbXKY+WOWghN00cCmlGnwVLRhRHorvv0dgCyuMYBZlM2xDM5OQw==}\n    hasBin: true\n\n  escalade@3.2.0:\n    resolution: {integrity: sha512-WUj2qlxaQtO4g6Pq5c29GTcWGDyd8itL8zTlipgECz3JesAiiOKotd8JU6otB3PACgG6xkJUyVhboMS+bje/jA==}\n    engines: {node: '>=6'}\n\n  escape-string-regexp@1.0.5:\n    resolution: {integrity: sha512-vbRorB5FUQWvla16U8R/qgaFIya2qGzwDrNmCZuYKrbdSUMG6I1ZCGQRefkRVhuOkIGVne7BQ35DSfo1qvJqFg==}\n    engines: {node: '>=0.8.0'}\n\n  escape-string-regexp@2.0.0:\n    resolution: {integrity: sha512-UpzcLCXolUWcNu5HtVMHYdXJjArjsF9C0aNnquZYY4uW/Vu0miy5YoWvbV345HauVvcAUnpRuhMMcqTcGOY2+w==}\n    engines: {node: '>=8'}\n\n  escodegen@2.1.0:\n    resolution: {integrity: sha512-2NlIDTwUWJN0mRPQOdtQBzbUHvdGY2P1VXSyU83Q3xKxM7WHX2Ql8dKq782Q9TgQUNOLEzEYu9bzLNj1q88I5w==}\n    engines: {node: '>=6.0'}\n    hasBin: true\n\n  esprima@4.0.1:\n    resolution: {integrity: sha512-eGuFFw7Upda+g4p+QHvnW0RyTX/SVeJBDM/gCtMARO0cLuT2HcEKnTPvhjV6aGeqrCB/sbNop0Kszm0jsaWU4A==}\n    engines: {node: '>=4'}\n    hasBin: true\n\n  estraverse@5.3.0:\n    resolution: {integrity: sha512-MMdARuVEQziNTeJD8DgMqmhwR11BRQ/cBP+pLtYdSTnf3MIO8fFeiINEbX36ZdNlfU/7A9f3gUw49B3oQsvwBA==}\n    engines: {node: '>=4.0'}\n\n  esutils@2.0.3:\n    resolution: {integrity: sha512-kVscqXk4OCp68SZ0dkgEKVi6/8ij300KBWTJq32P/dYeWTSwK41WyTxalN1eRmA5Z9UU/LX9D7FWSmV9SAYx6g==}\n    engines: {node: '>=0.10.0'}\n\n  events@3.3.0:\n    resolution: {integrity: sha512-mQw+2fkQbALzQ7V0MY0IqdnXNOeTtP4r0lN9z7AAawCXgqea7bDii20AYrIBrFd/Hx0M2Ocz6S111CaFkUcb0Q==}\n    engines: {node: '>=0.8.x'}\n\n  evp_bytestokey@1.0.3:\n    resolution: {integrity: sha512-/f2Go4TognH/KvCISP7OUsHn85hT9nUkxxA9BEWxFn+Oj9o8ZNLm/40hdlgSLyuOimsrTKLUMEorQexp/aPQeA==}\n\n  exec-sh@0.3.6:\n    resolution: {integrity: sha512-nQn+hI3yp+oD0huYhKwvYI32+JFeq+XkNcD1GAo3Y/MjxsfVGmrrzrnzjWiNY6f+pUCP440fThsFh5gZrRAU/w==}\n\n  execa@0.8.0:\n    resolution: {integrity: sha512-zDWS+Rb1E8BlqqhALSt9kUhss8Qq4nN3iof3gsOdyINksElaPyNBtKUMTR62qhvgVWR0CqCX7sdnKe4MnUbFEA==}\n    engines: {node: '>=4'}\n\n  execa@1.0.0:\n    resolution: {integrity: sha512-adbxcyWV46qiHyvSp50TKt05tB4tK3HcmF7/nxfAdhnox83seTDbwnaqKO4sXRy7roHAIFqJP/Rw/AuEbX61LA==}\n    engines: {node: '>=6'}\n\n  execa@4.1.0:\n    resolution: {integrity: sha512-j5W0//W7f8UxAn8hXVnwG8tLwdiUy4FJLcSupCg6maBYZDpyBvTApK7KyuI4bKj8KOh1r2YH+6ucuYtJv1bTZA==}\n    engines: {node: '>=10'}\n\n  exenv@1.2.2:\n    resolution: {integrity: sha512-Z+ktTxTwv9ILfgKCk32OX3n/doe+OcLTRtqK9pcL+JsP3J1/VW8Uvl4ZjLlKqeW4rzK4oesDOGMEMRIZqtP4Iw==}\n\n  exit@0.1.2:\n    resolution: {integrity: sha512-Zk/eNKV2zbjpKzrsQ+n1G6poVbErQxJ0LBOJXaKZ1EViLzH+hrLu9cdXI4zw9dBQJslwBEpbQ2P1oS7nDxs6jQ==}\n    engines: {node: '>= 0.8.0'}\n\n  expand-brackets@2.1.4:\n    resolution: {integrity: sha512-w/ozOKR9Obk3qoWeY/WDi6MFta9AoMR+zud60mdnbniMcBxRuFJyDt2LdX/14A1UABeqk+Uk+LDfUpvoGKppZA==}\n    engines: {node: '>=0.10.0'}\n\n  expect@26.6.2:\n    resolution: {integrity: sha512-9/hlOBkQl2l/PLHJx6JjoDF6xPKcJEsUlWKb23rKE7KzeDqUZKXKNMW27KIue5JMdBV9HgmoJPcc8HtO85t9IA==}\n    engines: {node: '>= 10.14.2'}\n\n  extend-shallow@2.0.1:\n    resolution: {integrity: sha512-zCnTtlxNoAiDc3gqY2aYAWFx7XWWiasuF2K8Me5WbN8otHKTUKBwjPtNpRs/rbUZm7KxWAaNj7P1a/p52GbVug==}\n    engines: {node: '>=0.10.0'}\n\n  extend-shallow@3.0.2:\n    resolution: {integrity: sha512-BwY5b5Ql4+qZoefgMj2NUmx+tehVTH/Kf4k1ZEtOHNFcm2wSxMRo992l6X3TIgni2eZVTZ85xMOjF31fwZAj6Q==}\n    engines: {node: '>=0.10.0'}\n\n  extglob@2.0.4:\n    resolution: {integrity: sha512-Nmb6QXkELsuBr24CJSkilo6UHHgbekK5UiZgfE6UHD3Eb27YC6oD+bhcT+tJ6cl8dmsgdQxnWlcry8ksBIBLpw==}\n    engines: {node: '>=0.10.0'}\n\n  fast-deep-equal@3.1.1:\n    resolution: {integrity: sha512-8UEa58QDLauDNfpbrX55Q9jrGHThw2ZMdOky5Gl1CDtVeJDPVrG4Jxx1N8jw2gkWaff5UUuX1KJd+9zGe2B+ZA==}\n\n  fast-deep-equal@3.1.3:\n    resolution: {integrity: sha512-f3qQ9oQy9j2AhBe/H9VC91wLmKBCCU/gDOnKNAYG5hswO7BLKj09Hc5HYNz9cGI++xlpDCIgDaitVs03ATR84Q==}\n\n  fast-json-stable-stringify@2.1.0:\n    resolution: {integrity: sha512-lhd/wF+Lk98HZoTCtlVraHtfh5XYijIjalXck7saUtuanSDyLMxnHhSXEDJqHxD7msR8D0uCmqlkwjCV8xvwHw==}\n\n  fb-watchman@2.0.2:\n    resolution: {integrity: sha512-p5161BqbuCaSnB8jIbzQHOlpgsPmK5rJVDfDKO91Axs5NC1uu3HRQm6wt9cd9/+GtQQIO53JdGXXoyDpTAsgYA==}\n\n  fbjs@0.8.18:\n    resolution: {integrity: sha512-EQaWFK+fEPSoibjNy8IxUtaFOMXcWsY0JaVrQoZR9zC8N2Ygf9iDITPWjUTVIax95b6I742JFLqASHfsag/vKA==}\n\n  fill-range@4.0.0:\n    resolution: {integrity: sha512-VcpLTWqWDiTerugjj8e3+esbg+skS3M9e54UuR3iCeIDMXCLTsAH8hTSzDQU/X6/6t3eYkOKoZSef2PlU6U1XQ==}\n    engines: {node: '>=0.10.0'}\n\n  fill-range@7.1.1:\n    resolution: {integrity: sha512-YsGpe3WHLK8ZYi4tWDg2Jy3ebRz2rXowDxnld4bkQB00cc/1Zw9AWnC0i9ztDJitivtQvaI9KaLyKrc+hBW0yg==}\n    engines: {node: '>=8'}\n\n  filter-obj@1.1.0:\n    resolution: {integrity: sha512-8rXg1ZnX7xzy2NGDVkBVaAy+lSlPNwad13BtgSlLuxfIslyt5Vg64U7tFcCt4WS1R0hvtnQybT/IyCkGZ3DpXQ==}\n    engines: {node: '>=0.10.0'}\n\n  find-up@4.1.0:\n    resolution: {integrity: sha512-PpOwAdQ/YlXQ2vj8a3h8IipDuYRi3wceVQQGYWxNINccq40Anw7BlsEXCMbt1Zt+OLA6Fq9suIpIWD0OsnISlw==}\n    engines: {node: '>=8'}\n\n  flatten@1.0.3:\n    resolution: {integrity: sha512-dVsPA/UwQ8+2uoFe5GHtiBMu48dWLTdsuEd7CKGlZlD78r1TTWBvDuFaFGKCo/ZfEr95Uk56vZoX86OsHkUeIg==}\n    deprecated: flatten is deprecated in favor of utility frameworks such as lodash.\n\n  for-in@1.0.2:\n    resolution: {integrity: sha512-7EwmXrOjyL+ChxMhmG5lnW9MPt1aIeZEwKhQzoBUdTV0N3zuwWDZYVJatDvZ2OyzPUvdIAZDsCetk3coyMfcnQ==}\n    engines: {node: '>=0.10.0'}\n\n  form-data@3.0.2:\n    resolution: {integrity: sha512-sJe+TQb2vIaIyO783qN6BlMYWMw3WBOHA1Ay2qxsnjuafEOQFJ2JakedOQirT6D5XPRxDvS7AHYyem9fTpb4LQ==}\n    engines: {node: '>= 6'}\n\n  fragment-cache@0.2.1:\n    resolution: {integrity: sha512-GMBAbW9antB8iZRHLoGw0b3HANt57diZYFO/HL1JGIC1MjKrdmhxvrJbupnVvpys0zsz7yBApXdQyfepKly2kA==}\n    engines: {node: '>=0.10.0'}\n\n  fs.realpath@1.0.0:\n    resolution: {integrity: sha512-OO0pH2lK6a0hZnAdau5ItzHPI6pUlvI7jMVnxUQRtw4owF2wk8lOSabtGDCTP4Ggrg2MbGnWO9X8K1t4+fGMDw==}\n\n  fsevents@2.3.3:\n    resolution: {integrity: sha512-5xoDfX+fL7faATnagmWPpbFtwh/R77WmMMqqHGS65C3vvB0YHrgF+B1YmZ3441tMj5n63k0212XNoJwzlhffQw==}\n    engines: {node: ^8.16.0 || ^10.6.0 || >=11.0.0}\n    os: [darwin]\n\n  function-bind@1.1.2:\n    resolution: {integrity: sha512-7XHNxH7qX9xG5mIwxkhumTox/MIRNcOgDrxWsMt2pAr23WHp6MrRlN7FBSFpCpr+oVO0F744iUgR82nJMfG2SA==}\n\n  gensync@1.0.0-beta.2:\n    resolution: {integrity: sha512-3hN7NaskYvMDLQY55gnW3NQ+mesEAepTqlg+VEbj7zzqEMBVNhzcGYYeqFo/TlYz6eQiFcp1HcsCZO+nGgS8zg==}\n    engines: {node: '>=6.9.0'}\n\n  get-caller-file@2.0.5:\n    resolution: {integrity: sha512-DyFP3BM/3YHTQOCUL/w0OZHR0lpKeGrxotcHWcqNEdnltqFwXVfhEBQ94eIo34AfQpo0rGki4cyIiftY06h2Fg==}\n    engines: {node: 6.* || 8.* || >= 10.*}\n\n  get-intrinsic@1.2.6:\n    resolution: {integrity: sha512-qxsEs+9A+u85HhllWJJFicJfPDhRmjzoYdl64aMWW9yRIJmSyxdn8IEkuIM530/7T+lv0TIHd8L6Q/ra0tEoeA==}\n    engines: {node: '>= 0.4'}\n\n  get-own-enumerable-property-symbols@3.0.2:\n    resolution: {integrity: sha512-I0UBV/XOz1XkIJHEUDMZAbzCThU/H8DxmSfmdGcKPnVhu2VfFqr34jr9777IyaTYvxjedWhqVIilEDsCdP5G6g==}\n\n  get-package-type@0.1.0:\n    resolution: {integrity: sha512-pjzuKtY64GYfWizNAJ0fr9VqttZkNiK2iS430LtIHzjBEr6bX8Am2zm4sW4Ro5wjWW5cAlRL1qAMTcXbjNAO2Q==}\n    engines: {node: '>=8.0.0'}\n\n  get-stream@3.0.0:\n    resolution: {integrity: sha512-GlhdIUuVakc8SJ6kK0zAFbiGzRFzNnY4jUuEbV9UROo4Y+0Ny4fjvcZFVTeDA4odpFyOQzaw6hXukJSq/f28sQ==}\n    engines: {node: '>=4'}\n\n  get-stream@4.1.0:\n    resolution: {integrity: sha512-GMat4EJ5161kIy2HevLlr4luNjBgvmj413KaQA7jt4V8B4RDsfpHk7WQ9GVqfYyyx8OS/L66Kox+rJRNklLK7w==}\n    engines: {node: '>=6'}\n\n  get-stream@5.2.0:\n    resolution: {integrity: sha512-nBF+F1rAZVCu/p7rjzgA+Yb4lfYXrpl7a6VmJrU8wF9I1CKvP/QwPNZHnOlwbTkY6dvtFIzFMSyQXbLoTQPRpA==}\n    engines: {node: '>=8'}\n\n  get-value@2.0.6:\n    resolution: {integrity: sha512-Ln0UQDlxH1BapMu3GPtf7CuYNwRZf2gwCuPqbyG6pB8WfmFpzqcy4xtAaAMUhnNqjMKTiCPZG2oMT3YSx8U2NA==}\n    engines: {node: '>=0.10.0'}\n\n  glob-parent@5.1.2:\n    resolution: {integrity: sha512-AOIgSQCepiJYwP3ARnGx+5VnTu2HBYdzbGP45eLw1vr3zB3vZLeyed1sC9hnbcOc9/SrMyM5RPQrkGz4aS9Zow==}\n    engines: {node: '>= 6'}\n\n  glob@7.2.3:\n    resolution: {integrity: sha512-nFR0zLpU2YCaRxwoCJvL6UvCH2JFyFVIvwTLsIf21AuHlMskA1hhTdk+LlYJtOlYt9v6dvszD2BGRqBL+iQK9Q==}\n    deprecated: Glob versions prior to v9 are no longer supported\n\n  global@4.4.0:\n    resolution: {integrity: sha512-wv/LAoHdRE3BeTGz53FAamhGlPLhlssK45usmGFThIi4XqnBmjKQ16u+RNbP7WvigRZDxUsM0J3gcQ5yicaL0w==}\n\n  globals@11.12.0:\n    resolution: {integrity: sha512-WOBp/EEGUiIsJSp7wcv/y6MO+lV9UoncWqxuFfm8eBwzWNgyfBd6Gz+IeKQ9jCmyhoH99g15M3T+QaVHFjizVA==}\n    engines: {node: '>=4'}\n\n  gopd@1.2.0:\n    resolution: {integrity: sha512-ZUKRh6/kUFoAiTAtTYPZJ3hw9wNxx+BIBOijnlG9PnrJsCcSjs1wyyD6vJpaYtgnzDrKYRSqf3OO6Rfa93xsRg==}\n    engines: {node: '>= 0.4'}\n\n  graceful-fs@4.2.11:\n    resolution: {integrity: sha512-RbJ5/jmFcNNCcDV5o9eTnBLJ/HszWV0P73bc+Ff4nS/rJj+YaS6IGyiOL0VoBYX+l1Wrl3k63h/KrH+nhJ0XvQ==}\n\n  growly@1.3.0:\n    resolution: {integrity: sha512-+xGQY0YyAWCnqy7Cd++hc2JqMYzlm0dG30Jd0beaA64sROr8C4nt8Yc9V5Ro3avlSUDTN0ulqP/VBKi1/lLygw==}\n\n  harmony-reflect@1.6.2:\n    resolution: {integrity: sha512-HIp/n38R9kQjDEziXyDTuW3vvoxxyxjxFzXLrBr18uB47GnSt+G9D29fqrpM5ZkspMcPICud3XsBJQ4Y2URg8g==}\n\n  has-flag@3.0.0:\n    resolution: {integrity: sha512-sKJf1+ceQBr4SMkvQnBDNDtf4TXpVhVGateu0t918bl30FnbE2m4vNLX+VWe/dpjlb+HugGYzW7uQXH98HPEYw==}\n    engines: {node: '>=4'}\n\n  has-flag@4.0.0:\n    resolution: {integrity: sha512-EykJT/Q1KjTWctppgIAgfSO0tKVuZUjhgMr17kqTumMl6Afv3EISleU7qZUzoXDFTAHTDC4NOoG/ZxU3EvlMPQ==}\n    engines: {node: '>=8'}\n\n  has-property-descriptors@1.0.2:\n    resolution: {integrity: sha512-55JNKuIW+vq4Ke1BjOTjM2YctQIvCT7GFzHwmfZPGo5wnrgkid0YQtnAleFSqumZm4az3n2BS+erby5ipJdgrg==}\n\n  has-symbols@1.1.0:\n    resolution: {integrity: sha512-1cDNdwJ2Jaohmb3sg4OmKaMBwuC48sYni5HUw2DvsC8LjGTLK9h+eb1X6RyuOHe4hT0ULCW68iomhjUoKUqlPQ==}\n    engines: {node: '>= 0.4'}\n\n  has-value@0.3.1:\n    resolution: {integrity: sha512-gpG936j8/MzaeID5Yif+577c17TxaDmhuyVgSwtnL/q8UUTySg8Mecb+8Cf1otgLoD7DDH75axp86ER7LFsf3Q==}\n    engines: {node: '>=0.10.0'}\n\n  has-value@1.0.0:\n    resolution: {integrity: sha512-IBXk4GTsLYdQ7Rvt+GRBrFSVEkmuOUy4re0Xjd9kJSUQpnTrWR4/y9RpfexN9vkAPMFuQoeWKwqzPozRTlasGw==}\n    engines: {node: '>=0.10.0'}\n\n  has-values@0.1.4:\n    resolution: {integrity: sha512-J8S0cEdWuQbqD9//tlZxiMuMNmxB8PlEwvYwuxsTmR1G5RXUePEX/SJn7aD0GMLieuZYSwNH0cQuJGwnYunXRQ==}\n    engines: {node: '>=0.10.0'}\n\n  has-values@1.0.0:\n    resolution: {integrity: sha512-ODYZC64uqzmtfGMEAX/FvZiRyWLpAC3vYnNunURUnkGVTS+mI0smVsWaPydRBsE3g+ok7h960jChO8mFcWlHaQ==}\n    engines: {node: '>=0.10.0'}\n\n  hash-base@3.0.5:\n    resolution: {integrity: sha512-vXm0l45VbcHEVlTCzs8M+s0VeYsB2lnlAaThoLKGXr3bE/VWDOelNUnycUPEhKEaXARL2TEFjBOyUiM6+55KBg==}\n    engines: {node: '>= 0.10'}\n\n  hash.js@1.1.7:\n    resolution: {integrity: sha512-taOaskGt4z4SOANNseOviYDvjEJinIkRgmp7LbKP2YTTmVxWBl87s/uzK9r+44BclBSp2X7K1hqeNfz9JbBeXA==}\n\n  hasown@2.0.2:\n    resolution: {integrity: sha512-0hJU9SCPvmMzIBdZFqNPXWa6dqh7WdH0cII9y+CyS8rG3nL48Bclra9HmKhVVUHyPWNH5Y7xDwAB7bfgSjkUMQ==}\n    engines: {node: '>= 0.4'}\n\n  history-with-query@4.10.4:\n    resolution: {integrity: sha512-JnskQK8X+PbRFHSdDAExhoJyhLnlLZL+UuHQuQhys+Se9/ukRDRBWU4JVTjsiIfbv1fcEmR3oqKW56OYmk5M5w==}\n\n  history@4.10.1:\n    resolution: {integrity: sha512-36nwAD620w12kuzPAsyINPWJqlNbij+hpK1k9XRloDtym8mxzGYl2c17LnV6IAGB2Dmg4tEa7G7DlawS0+qjew==}\n\n  history@5.3.0:\n    resolution: {integrity: sha512-ZqaKwjjrAYUYfLG+htGaIIZ4nioX2L70ZUMIFysS3xvBsSG4x/n1V6TXV3N8ZYNuFGlDirFg32T7B6WOUPDYcQ==}\n\n  hmac-drbg@1.0.1:\n    resolution: {integrity: sha512-Tti3gMqLdZfhOQY1Mzf/AanLiqh1WTiJgEj26ZuYQ9fbkLomzGchCws4FyrSd4VkpBfiNhaE1On+lOz894jvXg==}\n\n  hoist-non-react-statics@3.3.2:\n    resolution: {integrity: sha512-/gGivxi8JPKWNm/W0jSmzcMPpfpPLc3dY/6GxhX2hQ9iGj3aDfklV4ET7NjKpSinLpJ5vafa9iiGIEZg10SfBw==}\n\n  hosted-git-info@2.8.9:\n    resolution: {integrity: sha512-mxIDAb9Lsm6DoOJ7xH+5+X4y1LU/4Hi50L9C5sIswK3JzULS4bwk1FvjdBgvYR4bzT4tuUQiC15FE2f5HbLvYw==}\n\n  html-encoding-sniffer@2.0.1:\n    resolution: {integrity: sha512-D5JbOMBIR/TVZkubHT+OyT2705QvogUW4IBn6nHd756OwieSF9aDYFj4dv6HHEVGYbHaLETa3WggZYWWMyy3ZQ==}\n    engines: {node: '>=10'}\n\n  html-entities@2.5.2:\n    resolution: {integrity: sha512-K//PSRMQk4FZ78Kyau+mZurHn3FH0Vwr+H36eE0rPbeYkRRi9YxceYPhuN60UwWorxyKHhqoAJl2OFKa4BVtaA==}\n\n  html-escaper@2.0.2:\n    resolution: {integrity: sha512-H2iMtd0I4Mt5eYiapRdIDjp+XzelXQ0tFE4JS7YFwFevXXMmOp9myNrUvCg0D6ws8iqkRPBfKHgbwig1SmlLfg==}\n\n  http-proxy-agent@4.0.1:\n    resolution: {integrity: sha512-k0zdNgqWTGA6aeIRVpvfVob4fL52dTfaehylg0Y4UvSySvOq/Y+BOyPrgpUrA7HylqvU8vIZGsRuXmspskV0Tg==}\n    engines: {node: '>= 6'}\n\n  https-browserify@1.0.0:\n    resolution: {integrity: sha512-J+FkSdyD+0mA0N+81tMotaRMfSL9SGi+xpD3T6YApKsc3bGSXJlfXri3VyFOeYkfLRQisDk1W+jIFFKBeUBbBg==}\n\n  https-proxy-agent@5.0.1:\n    resolution: {integrity: sha512-dFcAjpTQFgoLMzC2VwU+C/CbS7uRL0lWmxDITmqm7C+7F0Odmj6s9l6alZc6AELXhrnggM2CeWSXHGOdX2YtwA==}\n    engines: {node: '>= 6'}\n\n  human-signals@1.1.1:\n    resolution: {integrity: sha512-SEQu7vl8KjNL2eoGBLF3+wAjpsNfA9XMlXAYj/3EdaNfAlxKthD1xjEQfGOUhllCGGJVNY34bRr6lPINhNjyZw==}\n    engines: {node: '>=8.12.0'}\n\n  iconv-lite@0.4.24:\n    resolution: {integrity: sha512-v3MXnZAcvnywkTUEZomIActle7RXXeedOR31wwl7VlyoXO4Qi9arvSenNQWne1TcRwhCL1HwLI21bEqdpj8/rA==}\n    engines: {node: '>=0.10.0'}\n\n  iconv-lite@0.6.3:\n    resolution: {integrity: sha512-4fCk79wshMdzMp2rH06qWrJE4iolqLhCUH+OiuIgU++RB0+94NlDL81atO7GX55uUKueo0txHNtvEyI6D7WdMw==}\n    engines: {node: '>=0.10.0'}\n\n  identity-obj-proxy@3.0.0:\n    resolution: {integrity: sha512-00n6YnVHKrinT9t0d9+5yZC6UBNJANpYEQvL2LlX6Ab9lnmxzIRcEmTPuyGScvl1+jKuCICX1Z0Ab1pPKKdikA==}\n    engines: {node: '>=4'}\n\n  ieee754@1.2.1:\n    resolution: {integrity: sha512-dcyqhDvX1C46lXZcVqCpK+FtMRQVdIMN6/Df5js2zouUsqG7I6sFxitIC+7KYK29KdXOLHdu9zL4sFnoVQnqaA==}\n\n  immer@7.0.15:\n    resolution: {integrity: sha512-yM7jo9+hvYgvdCQdqvhCNRRio0SCXc8xDPzA25SvKWa7b1WVPjLwQs1VYU5JPXjcJPTqAa5NP5dqpORGYBQ2AA==}\n\n  immutable@3.8.2:\n    resolution: {integrity: sha512-15gZoQ38eYjEjxkorfbcgBKBL6R7T459OuK+CpcWt7O3KF4uPCx2tD0uFETlUDIyo+1789crbMhTvQBSR5yBMg==}\n    engines: {node: '>=0.10.0'}\n\n  import-cwd@2.1.0:\n    resolution: {integrity: sha512-Ew5AZzJQFqrOV5BTW3EIoHAnoie1LojZLXKcCQ/yTRyVZosBhK1x1ViYjHGf5pAFOq8ZyChZp6m/fSN7pJyZtg==}\n    engines: {node: '>=4'}\n\n  import-fresh@2.0.0:\n    resolution: {integrity: sha512-eZ5H8rcgYazHbKC3PG4ClHNykCSxtAhxSSEM+2mb+7evD2CKF5V7c0dNum7AdpDh0ZdICwZY9sRSn8f+KH96sg==}\n    engines: {node: '>=4'}\n\n  import-fresh@3.3.0:\n    resolution: {integrity: sha512-veYYhQa+D1QBKznvhUHxb8faxlrwUnxseDAbAp457E0wLNio2bOSKnjYDhMj+YiAq61xrMGhQk9iXVk5FzgQMw==}\n    engines: {node: '>=6'}\n\n  import-from@2.1.0:\n    resolution: {integrity: sha512-0vdnLL2wSGnhlRmzHJAg5JHjt1l2vYhzJ7tNLGbeVg0fse56tpGaH0uzH+r9Slej+BSXXEHvBKDEnVSLLE9/+w==}\n    engines: {node: '>=4'}\n\n  import-local@3.2.0:\n    resolution: {integrity: sha512-2SPlun1JUPWoM6t3F0dw0FkCF/jWY8kttcY4f599GLTSjh2OCuuhdTkJQsEcZzBqbXZGKMK2OqW1oZsjtf/gQA==}\n    engines: {node: '>=8'}\n    hasBin: true\n\n  imurmurhash@0.1.4:\n    resolution: {integrity: sha512-JmXMZ6wuvDmLiHEml9ykzqO6lwFbof0GG4IkcGaENdCRDDmMVnny7s5HsIgHCbaq0w2MyPhDqkhTUgS2LU2PHA==}\n    engines: {node: '>=0.8.19'}\n\n  indent-string@4.0.0:\n    resolution: {integrity: sha512-EdDDZu4A2OyIK7Lr/2zG+w5jmbuk1DVBnEwREQvBzspBJkCEbRa8GxU1lghYcaGJCnRWibjDXlq779X1/y5xwg==}\n    engines: {node: '>=8'}\n\n  indexes-of@1.0.1:\n    resolution: {integrity: sha512-bup+4tap3Hympa+JBJUG7XuOsdNQ6fxt0MHyXMKuLBKn0OqsTfvUxkUrroEX1+B2VsSHvCjiIcZVxRtYa4nllA==}\n\n  inflight@1.0.6:\n    resolution: {integrity: sha512-k92I/b08q4wvFscXCLvqfsHCrjrF7yiXsQuIVvVE7N82W3+aqpzuUdBbfhWcy/FZR3/4IgflMgKLOsvPDrGCJA==}\n    deprecated: This module is not supported, and leaks memory. Do not use it. Check out lru-cache if you want a good and tested way to coalesce async requests by a key value, which is much more comprehensive and powerful.\n\n  inherits@2.0.3:\n    resolution: {integrity: sha512-x00IRNXNy63jwGkJmzPigoySHbaqpNuzKbBOmzK+g2OdZpQ9w+sxCN+VSB3ja7IAge2OP2qpfxTjeNcyjmW1uw==}\n\n  inherits@2.0.4:\n    resolution: {integrity: sha512-k/vGaX4/Yla3WzyMCvTQOXYeIHvqOKtnqBduzTHpzpQZzAskKMhZ2K+EnBiSM9zGSoIFeMpXKxa4dYeZIQqewQ==}\n\n  intl-format-cache@4.3.1:\n    resolution: {integrity: sha512-OEUYNA7D06agqPOYhbTkl0T8HA3QKSuwWh1HiClEnpd9vw7N+3XsQt5iZ0GUEchp5CW1fQk/tary+NsbF3yQ1Q==}\n\n  intl-messageformat-parser@3.6.4:\n    resolution: {integrity: sha512-RgPGwue0mJtoX2Ax8EmMzJzttxjnva7gx0Q7mKJ4oALrTZvtmCeAw5Msz2PcjW4dtCh/h7vN/8GJCxZO1uv+OA==}\n    deprecated: We've written a new parser that's 6x faster and is backwards compatible. Please use @formatjs/icu-messageformat-parser\n\n  intl-messageformat@7.8.4:\n    resolution: {integrity: sha512-yS0cLESCKCYjseCOGXuV4pxJm/buTfyCJ1nzQjryHmSehlptbZbn9fnlk1I9peLopZGGbjj46yHHiTAEZ1qOTA==}\n\n  intl@1.2.5:\n    resolution: {integrity: sha512-rK0KcPHeBFBcqsErKSpvZnrOmWOj+EmDkyJ57e90YWaQNqbcivcqmKDlHEeNprDWOsKzPsh1BfSpPQdDvclHVw==}\n\n  invariant@2.2.4:\n    resolution: {integrity: sha512-phJfQVBuaJM5raOpJjSfkiD6BpbCE4Ns//LaXl6wGYtUBY83nWS6Rf9tXm2e8VaK60JEjYldbPif/A2B1C2gNA==}\n\n  is-accessor-descriptor@1.0.1:\n    resolution: {integrity: sha512-YBUanLI8Yoihw923YeFUS5fs0fF2f5TSFTNiYAAzhhDscDa3lEqYuz1pDOEP5KvX94I9ey3vsqjJcLVFVU+3QA==}\n    engines: {node: '>= 0.10'}\n\n  is-arrayish@0.2.1:\n    resolution: {integrity: sha512-zz06S8t0ozoDXMG+ube26zeCTNXcKIPJZJi8hBrF4idCLms4CG9QtK7qBl1boi5ODzFpjswb5JPmHCbMpjaYzg==}\n\n  is-binary-path@2.1.0:\n    resolution: {integrity: sha512-ZMERYes6pDydyuGidse7OsHxtbI7WVeUEozgR/g7rd0xUimYNlvZRE/K2MgZTjWy725IfelLeVcEM97mmtRGXw==}\n    engines: {node: '>=8'}\n\n  is-buffer@1.1.6:\n    resolution: {integrity: sha512-NcdALwpXkTm5Zvvbk7owOUSvVvBKDgKP5/ewfXEznmQFfs4ZRmanOeKBTjRVjka3QFoN6XJ+9F3USqfHqTaU5w==}\n\n  is-ci@1.2.1:\n    resolution: {integrity: sha512-s6tfsaQaQi3JNciBH6shVqEDvhGut0SUXr31ag8Pd8BBbVVlcGfWhpPmEOoM6RJ5TFhbypvf5yyRw/VXW1IiWg==}\n    hasBin: true\n\n  is-ci@2.0.0:\n    resolution: {integrity: sha512-YfJT7rkpQB0updsdHLGWrvhBJfcfzNNawYDNIyQXJz0IViGf75O8EBPKSdvw2rF+LGCsX4FZ8tcr3b19LcZq4w==}\n    hasBin: true\n\n  is-core-module@2.15.1:\n    resolution: {integrity: sha512-z0vtXSwucUJtANQWldhbtbt7BnL0vxiFjIdDLAatwhDYty2bad6s+rijD6Ri4YuYJubLzIJLUidCh09e1djEVQ==}\n    engines: {node: '>= 0.4'}\n\n  is-data-descriptor@1.0.1:\n    resolution: {integrity: sha512-bc4NlCDiCr28U4aEsQ3Qs2491gVq4V8G7MQyws968ImqjKuYtTJXrl7Vq7jsN7Ly/C3xj5KWFrY7sHNeDkAzXw==}\n    engines: {node: '>= 0.4'}\n\n  is-descriptor@0.1.7:\n    resolution: {integrity: sha512-C3grZTvObeN1xud4cRWl366OMXZTj0+HGyk4hvfpx4ZHt1Pb60ANSXqCK7pdOTeUQpRzECBSTphqvD7U+l22Eg==}\n    engines: {node: '>= 0.4'}\n\n  is-descriptor@1.0.3:\n    resolution: {integrity: sha512-JCNNGbwWZEVaSPtS45mdtrneRWJFp07LLmykxeFV5F6oBvNF8vHSfJuJgoT472pSfk+Mf8VnlrspaFBHWM8JAw==}\n    engines: {node: '>= 0.4'}\n\n  is-directory@0.3.1:\n    resolution: {integrity: sha512-yVChGzahRFvbkscn2MlwGismPO12i9+znNruC5gVEntG3qu0xQMzsGg/JFbrsqDOHtHFPci+V5aP5T9I+yeKqw==}\n    engines: {node: '>=0.10.0'}\n\n  is-docker@2.2.1:\n    resolution: {integrity: sha512-F+i2BKsFrH66iaUFc0woD8sLy8getkwTwtOBjvs56Cx4CgJDeKQeqfz8wAYiSb8JOprWhHH5p77PbmYCvvUuXQ==}\n    engines: {node: '>=8'}\n    hasBin: true\n\n  is-extendable@0.1.1:\n    resolution: {integrity: sha512-5BMULNob1vgFX6EjQw5izWDxrecWK9AM72rugNr0TFldMOi0fj6Jk+zeKIt0xGj4cEfQIJth4w3OKWOJ4f+AFw==}\n    engines: {node: '>=0.10.0'}\n\n  is-extendable@1.0.1:\n    resolution: {integrity: sha512-arnXMxT1hhoKo9k1LZdmlNyJdDDfy2v0fXjFlmok4+i8ul/6WlbVge9bhM74OpNPQPMGUToDtz+KXa1PneJxOA==}\n    engines: {node: '>=0.10.0'}\n\n  is-extglob@2.1.1:\n    resolution: {integrity: sha512-SbKbANkN603Vi4jEZv49LeVJMn4yGwsbzZworEoyEiutsN3nJYdbO36zfhGJ6QEDpOZIFkDtnq5JRxmvl3jsoQ==}\n    engines: {node: '>=0.10.0'}\n\n  is-fullwidth-code-point@3.0.0:\n    resolution: {integrity: sha512-zymm5+u+sCsSWyD9qNaejV3DFvhCKclKdizYaJUuHA83RLjb7nSuGnddCHGv0hk+KY7BMAlsWeK4Ueg6EV6XQg==}\n    engines: {node: '>=8'}\n\n  is-generator-fn@2.1.0:\n    resolution: {integrity: sha512-cTIB4yPYL/Grw0EaSzASzg6bBy9gqCofvWN8okThAYIxKJZC+udlRAmGbM0XLeniEJSs8uEgHPGuHSe1XsOLSQ==}\n    engines: {node: '>=6'}\n\n  is-glob@4.0.3:\n    resolution: {integrity: sha512-xelSayHH36ZgE7ZWhli7pW34hNbNl8Ojv5KVmkJD4hBdD3th8Tfk9vYasLM+mXWOZhFkgZfxhLSnrwRr4elSSg==}\n    engines: {node: '>=0.10.0'}\n\n  is-number@3.0.0:\n    resolution: {integrity: sha512-4cboCqIpliH+mAvFNegjZQ4kgKc3ZUhQVr3HvWbSh5q3WH2v82ct+T2Y1hdU5Gdtorx/cLifQjqCbL7bpznLTg==}\n    engines: {node: '>=0.10.0'}\n\n  is-number@7.0.0:\n    resolution: {integrity: sha512-41Cifkg6e8TylSpdtTpeLVMqvSBEVzTttHvERD741+pnZ8ANv0004MRL43QKPDlK9cGvNp6NZWZUBlbGXYxxng==}\n    engines: {node: '>=0.12.0'}\n\n  is-obj@1.0.1:\n    resolution: {integrity: sha512-l4RyHgRqGN4Y3+9JHVrNqO+tN0rV5My76uW5/nuO4K1b6vw5G8d/cmFjP9tRfEsdhZNt0IFdZuK/c2Vr4Nb+Qg==}\n    engines: {node: '>=0.10.0'}\n\n  is-plain-obj@1.1.0:\n    resolution: {integrity: sha512-yvkRyxmFKEOQ4pNXCmJG5AEQNlXJS5LaONXo5/cLdTZdWvsZ1ioJEonLGAosKlMWE8lwUy/bJzMjcw8az73+Fg==}\n    engines: {node: '>=0.10.0'}\n\n  is-plain-object@2.0.4:\n    resolution: {integrity: sha512-h5PpgXkWitc38BBMYawTYMWJHFZJVnBquFE57xFpjB8pJFiF6gZ+bU+WyI/yqXiFR5mdLsgYNaPe8uao6Uv9Og==}\n    engines: {node: '>=0.10.0'}\n\n  is-potential-custom-element-name@1.0.1:\n    resolution: {integrity: sha512-bCYeRA2rVibKZd+s2625gGnGF/t7DSqDs4dP7CrLA1m7jKWz6pps0LpYLJN8Q64HtmPKJ1hrN3nzPNKFEKOUiQ==}\n\n  is-regexp@1.0.0:\n    resolution: {integrity: sha512-7zjFAPO4/gwyQAAgRRmqeEeyIICSdmCqa3tsVHMdBzaXXRiqopZL4Cyghg/XulGWrtABTpbnYYzzIRffLkP4oA==}\n    engines: {node: '>=0.10.0'}\n\n  is-stream@1.1.0:\n    resolution: {integrity: sha512-uQPm8kcs47jx38atAcWTVxyltQYoPT68y9aWYdV6yWXSyW8mzSat0TL6CiWdZeCdF3KrAvpVtnHbTv4RN+rqdQ==}\n    engines: {node: '>=0.10.0'}\n\n  is-stream@2.0.1:\n    resolution: {integrity: sha512-hFoiJiTl63nn+kstHGBtewWSKnQLpyb155KHheA1l39uvtO9nWIop1p3udqPcUd/xbF1VLMO4n7OI6p7RbngDg==}\n    engines: {node: '>=8'}\n\n  is-typedarray@1.0.0:\n    resolution: {integrity: sha512-cyA56iCMHAh5CdzjJIa4aohJyeO1YbwLi3Jc35MmRU6poroFjIGZzUzupGiRPOjgHg9TLu43xbpwXk523fMxKA==}\n\n  is-unicode-supported@0.1.0:\n    resolution: {integrity: sha512-knxG2q4UC3u8stRGyAVJCOdxFmv5DZiRcdlIaAQXAbSfJya+OhopNotLQrstBhququ4ZpuKbDc/8S6mgXgPFPw==}\n    engines: {node: '>=10'}\n\n  is-windows@1.0.2:\n    resolution: {integrity: sha512-eXK1UInq2bPmjyX6e3VHIzMLobc4J94i4AWn+Hpq3OU5KkrRC96OAcR3PRJ/pGu6m8TRnBHP9dkXQVsT/COVIA==}\n    engines: {node: '>=0.10.0'}\n\n  is-wsl@2.2.0:\n    resolution: {integrity: sha512-fKzAra0rGJUUBwGBgNkHZuToZcn+TtXHpeCgmkMJMMYx1sQDYaCSyjJBSCa2nH1DGm7s3n1oBnohoVTBaN7Lww==}\n    engines: {node: '>=8'}\n\n  isarray@0.0.1:\n    resolution: {integrity: sha512-D2S+3GLxWH+uhrNEcoh/fnmYeP8E8/zHl644d/jdA0g2uyXvy3sb0qxotE+ne0LtccHknQzWwZEzhak7oJ0COQ==}\n\n  isarray@1.0.0:\n    resolution: {integrity: sha512-VLghIWNM6ELQzo7zwmcg0NmTVyWKYjvIeM83yjp0wRDTmUnrM678fQbcKBo6n2CJEF0szoG//ytg+TKla89ALQ==}\n\n  isexe@2.0.0:\n    resolution: {integrity: sha512-RHxMLp9lnKHGHRng9QFhRCMbYAcVpn69smSGcq3f36xjgVVWThj4qqLbTLlq7Ssj8B+fIQ1EuCEGI2lKsyQeIw==}\n\n  isobject@2.1.0:\n    resolution: {integrity: sha512-+OUdGJlgjOBZDfxnDjYYG6zp487z0JGNQq3cYQYg5f5hKR+syHMsaztzGeml/4kGG55CSpKSpWTY+jYGgsHLgA==}\n    engines: {node: '>=0.10.0'}\n\n  isobject@3.0.1:\n    resolution: {integrity: sha512-WhB9zCku7EGTj/HQQRz5aUQEUeoQZH2bWcltRErOpymJ4boYE6wL9Tbr23krRPSZ+C5zqNSrSw+Cc7sZZ4b7vg==}\n    engines: {node: '>=0.10.0'}\n\n  isomorphic-fetch@2.2.1:\n    resolution: {integrity: sha512-9c4TNAKYXM5PRyVcwUZrF3W09nQ+sO7+jydgs4ZGW9dhsLG2VOlISJABombdQqQRXCwuYG3sYV/puGf5rp0qmA==}\n\n  istanbul-lib-coverage@3.2.2:\n    resolution: {integrity: sha512-O8dpsF+r0WV/8MNRKfnmrtCWhuKjxrq2w+jpzBL5UZKTi2LeVWnWOmWRxFlesJONmc+wLAGvKQZEOanko0LFTg==}\n    engines: {node: '>=8'}\n\n  istanbul-lib-instrument@4.0.3:\n    resolution: {integrity: sha512-BXgQl9kf4WTCPCCpmFGoJkz/+uhvm7h7PFKUYxh7qarQd3ER33vHG//qaE8eN25l07YqZPpHXU9I09l/RD5aGQ==}\n    engines: {node: '>=8'}\n\n  istanbul-lib-instrument@5.2.1:\n    resolution: {integrity: sha512-pzqtp31nLv/XFOzXGuvhCb8qhjmTVo5vjVk19XE4CRlSWz0KoeJ3bw9XsA7nOp9YBf4qHjwBxkDzKcME/J29Yg==}\n    engines: {node: '>=8'}\n\n  istanbul-lib-report@3.0.1:\n    resolution: {integrity: sha512-GCfE1mtsHGOELCU8e/Z7YWzpmybrx/+dSTfLrvY8qRmaY6zXTKWn6WQIjaAFw069icm6GVMNkgu0NzI4iPZUNw==}\n    engines: {node: '>=10'}\n\n  istanbul-lib-source-maps@4.0.1:\n    resolution: {integrity: sha512-n3s8EwkdFIJCG3BPKBYvskgXGoy88ARzvegkitk60NxRdwltLOTaH7CUiMRXvwYorl0Q712iEjcWB+fK/MrWVw==}\n    engines: {node: '>=10'}\n\n  istanbul-reports@3.1.7:\n    resolution: {integrity: sha512-BewmUXImeuRk2YY0PVbxgKAysvhRPUQE0h5QRM++nVWyubKGV0l8qQ5op8+B2DOmwSe63Jivj0BjkPQVf8fP5g==}\n    engines: {node: '>=8'}\n\n  javascript-stringify@2.1.0:\n    resolution: {integrity: sha512-JVAfqNPTvNq3sB/VHQJAFxN/sPgKnsKrCwyRt15zwNCdrMMJDdcEOdubuy+DuJYYdm0ox1J4uzEuYKkN+9yhVg==}\n\n  jest-changed-files@26.6.2:\n    resolution: {integrity: sha512-fDS7szLcY9sCtIip8Fjry9oGf3I2ht/QT21bAHm5Dmf0mD4X3ReNUf17y+bO6fR8WgbIZTlbyG1ak/53cbRzKQ==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-cli@26.6.3:\n    resolution: {integrity: sha512-GF9noBSa9t08pSyl3CY4frMrqp+aQXFGFkf5hEPbh/pIUFYWMK6ZLTfbmadxJVcJrdRoChlWQsA2VkJcDFK8hg==}\n    engines: {node: '>= 10.14.2'}\n    hasBin: true\n\n  jest-config@26.6.3:\n    resolution: {integrity: sha512-t5qdIj/bCj2j7NFVHb2nFB4aUdfucDn3JRKgrZnplb8nieAirAzRSHP8uDEd+qV6ygzg9Pz4YG7UTJf94LPSyg==}\n    engines: {node: '>= 10.14.2'}\n    peerDependencies:\n      ts-node: '>=9.0.0'\n    peerDependenciesMeta:\n      ts-node:\n        optional: true\n\n  jest-diff@26.6.2:\n    resolution: {integrity: sha512-6m+9Z3Gv9wN0WFVasqjCL/06+EFCMTqDEUl/b87HYK2rAPTyfz4ZIuSlPhY51PIQRWx5TaxeF1qmXKe9gfN3sA==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-docblock@26.0.0:\n    resolution: {integrity: sha512-RDZ4Iz3QbtRWycd8bUEPxQsTlYazfYn/h5R65Fc6gOfwozFhoImx+affzky/FFBuqISPTqjXomoIGJVKBWoo0w==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-each@26.6.2:\n    resolution: {integrity: sha512-Mer/f0KaATbjl8MCJ+0GEpNdqmnVmDYqCTJYTvoo7rqmRiDllmp2AYN+06F93nXcY3ur9ShIjS+CO/uD+BbH4A==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-environment-jsdom@26.6.2:\n    resolution: {integrity: sha512-jgPqCruTlt3Kwqg5/WVFyHIOJHsiAvhcp2qiR2QQstuG9yWox5+iHpU3ZrcBxW14T4fe5Z68jAfLRh7joCSP2Q==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-environment-node@26.6.2:\n    resolution: {integrity: sha512-zhtMio3Exty18dy8ee8eJ9kjnRyZC1N4C1Nt/VShN1apyXc8rWGtJ9lI7vqiWcyyXS4BVSEn9lxAM2D+07/Tag==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-get-type@26.3.0:\n    resolution: {integrity: sha512-TpfaviN1R2pQWkIihlfEanwOXK0zcxrKEE4MlU6Tn7keoXdN6/3gK/xl0yEh8DOunn5pOVGKf8hB4R9gVh04ig==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-haste-map@26.6.2:\n    resolution: {integrity: sha512-easWIJXIw71B2RdR8kgqpjQrbMRWQBgiBwXYEhtGUTaX+doCjBheluShdDMeR8IMfJiTqH4+zfhtg29apJf/8w==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-jasmine2@26.6.3:\n    resolution: {integrity: sha512-kPKUrQtc8aYwBV7CqBg5pu+tmYXlvFlSFYn18ev4gPFtrRzB15N2gW/Roew3187q2w2eHuu0MU9TJz6w0/nPEg==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-leak-detector@26.6.2:\n    resolution: {integrity: sha512-i4xlXpsVSMeKvg2cEKdfhh0H39qlJlP5Ex1yQxwF9ubahboQYMgTtz5oML35AVA3B4Eu+YsmwaiKVev9KCvLxg==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-matcher-utils@26.6.2:\n    resolution: {integrity: sha512-llnc8vQgYcNqDrqRDXWwMr9i7rS5XFiCwvh6DTP7Jqa2mqpcCBBlpCbn+trkG0KNhPu/h8rzyBkriOtBstvWhw==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-message-util@26.6.2:\n    resolution: {integrity: sha512-rGiLePzQ3AzwUshu2+Rn+UMFk0pHN58sOG+IaJbk5Jxuqo3NYO1U2/MIR4S1sKgsoYSXSzdtSa0TgrmtUwEbmA==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-mock@26.6.2:\n    resolution: {integrity: sha512-YyFjePHHp1LzpzYcmgqkJ0nm0gg/lJx2aZFzFy1S6eUqNjXsOqTK10zNRff2dNfssgokjkG65OlWNcIlgd3zew==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-pnp-resolver@1.2.3:\n    resolution: {integrity: sha512-+3NpwQEnRoIBtx4fyhblQDPgJI0H1IEIkX7ShLUjPGA7TtUTvI1oiKi3SR4oBR0hQhQR80l4WAe5RrXBwWMA8w==}\n    engines: {node: '>=6'}\n    peerDependencies:\n      jest-resolve: '*'\n    peerDependenciesMeta:\n      jest-resolve:\n        optional: true\n\n  jest-regex-util@26.0.0:\n    resolution: {integrity: sha512-Gv3ZIs/nA48/Zvjrl34bf+oD76JHiGDUxNOVgUjh3j890sblXryjY4rss71fPtD/njchl6PSE2hIhvyWa1eT0A==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-resolve-dependencies@26.6.3:\n    resolution: {integrity: sha512-pVwUjJkxbhe4RY8QEWzN3vns2kqyuldKpxlxJlzEYfKSvY6/bMvxoFrYYzUO1Gx28yKWN37qyV7rIoIp2h8fTg==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-resolve@26.6.2:\n    resolution: {integrity: sha512-sOxsZOq25mT1wRsfHcbtkInS+Ek7Q8jCHUB0ZUTP0tc/c41QHriU/NunqMfCUWsL4H3MHpvQD4QR9kSYhS7UvQ==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-runner@26.6.3:\n    resolution: {integrity: sha512-atgKpRHnaA2OvByG/HpGA4g6CSPS/1LK0jK3gATJAoptC1ojltpmVlYC3TYgdmGp+GLuhzpH30Gvs36szSL2JQ==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-runtime@26.6.3:\n    resolution: {integrity: sha512-lrzyR3N8sacTAMeonbqpnSka1dHNux2uk0qqDXVkMv2c/A3wYnvQ4EXuI013Y6+gSKSCxdaczvf4HF0mVXHRdw==}\n    engines: {node: '>= 10.14.2'}\n    hasBin: true\n\n  jest-serializer@26.6.2:\n    resolution: {integrity: sha512-S5wqyz0DXnNJPd/xfIzZ5Xnp1HrJWBczg8mMfMpN78OJ5eDxXyf+Ygld9wX1DnUWbIbhM1YDY95NjR4CBXkb2g==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-snapshot@26.6.2:\n    resolution: {integrity: sha512-OLhxz05EzUtsAmOMzuupt1lHYXCNib0ECyuZ/PZOx9TrZcC8vL0x+DUG3TL+GLX3yHG45e6YGjIm0XwDc3q3og==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-util@26.6.2:\n    resolution: {integrity: sha512-MDW0fKfsn0OI7MS7Euz6h8HNDXVQ0gaM9uW6RjfDmd1DAFcaxX9OqIakHIqhbnmF08Cf2DLDG+ulq8YQQ0Lp0Q==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-validate@26.6.2:\n    resolution: {integrity: sha512-NEYZ9Aeyj0i5rQqbq+tpIOom0YS1u2MVu6+euBsvpgIme+FOfRmoC4R5p0JiAUpaFvFy24xgrpMknarR/93XjQ==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-watcher@26.6.2:\n    resolution: {integrity: sha512-WKJob0P/Em2csiVthsI68p6aGKTIcsfjH9Gsx1f0A3Italz43e3ho0geSAVsmj09RWOELP1AZ/DXyJgOgDKxXQ==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-worker@24.9.0:\n    resolution: {integrity: sha512-51PE4haMSXcHohnSMdM42anbvZANYTqMrr52tVKPqqsPJMzoP6FYYDVqahX/HrAoKEKz3uUPzSvKs9A3qR4iVw==}\n    engines: {node: '>= 6'}\n\n  jest-worker@26.6.2:\n    resolution: {integrity: sha512-KWYVV1c4i+jbMpaBC+U++4Va0cp8OisU185o73T1vo99hqi7w8tSJfUXYswwqqrjzwxa6KpRK54WhPvwf5w6PQ==}\n    engines: {node: '>= 10.13.0'}\n\n  jest@26.6.3:\n    resolution: {integrity: sha512-lGS5PXGAzR4RF7V5+XObhqz2KZIDUA1yD0DG6pBVmy10eh0ZIXQImRuzocsI/N2XZ1GrLFwTS27In2i2jlpq1Q==}\n    engines: {node: '>= 10.14.2'}\n    hasBin: true\n\n  js-tokens@4.0.0:\n    resolution: {integrity: sha512-RdJUflcE3cUzKiMqQgsCu06FPu9UdIJO0beYbPhHN4k6apgJtifcoCtT9bcxOpYBtpD2kCM6Sbzg4CausW/PKQ==}\n\n  js-yaml@3.14.1:\n    resolution: {integrity: sha512-okMH7OXXJ7YrN9Ok3/SXrnu4iX9yOk+25nqX4imS2npuvTYDmo/QEZoqwZkYaIDk3jVvBOTOIEgEhaLOynBS9g==}\n    hasBin: true\n\n  jsdom@16.7.0:\n    resolution: {integrity: sha512-u9Smc2G1USStM+s/x1ru5Sxrl6mPYCbByG1U/hUmqaVsm4tbNyS7CicOSRyuGQYZhTu0h84qkZZQ/I+dzizSVw==}\n    engines: {node: '>=10'}\n    peerDependencies:\n      canvas: ^2.5.0\n    peerDependenciesMeta:\n      canvas:\n        optional: true\n\n  jsesc@3.1.0:\n    resolution: {integrity: sha512-/sM3dO2FOzXjKQhJuo0Q173wf2KOo8t4I8vHy6lF9poUp7bKT0/NHE8fPX23PwfhnykfqnC2xRxOnVw5XuGIaA==}\n    engines: {node: '>=6'}\n    hasBin: true\n\n  json-parse-better-errors@1.0.2:\n    resolution: {integrity: sha512-mrqyZKfX5EhL7hvqcV6WG1yYjnjeuYDzDhhcAAUrq8Po85NBQBJP+ZDUT75qZQ98IkUoBqdkExkukOU7Ts2wrw==}\n\n  json-parse-even-better-errors@2.3.1:\n    resolution: {integrity: sha512-xyFwyhro/JEof6Ghe2iz2NcXoj2sloNsWr/XsERDK/oiPCfaNhl5ONfp+jQdAZRQQ0IJWNzH9zIZF7li91kh2w==}\n\n  json-schema-traverse@0.4.1:\n    resolution: {integrity: sha512-xbbCH5dCYU5T8LcEhhuh7HJ88HXuW3qsI3Y0zOZFKfZEHcpWiHU/Jxzk629Brsab/mMiHQti9wMP+845RPe3Vg==}\n\n  json2mq@0.2.0:\n    resolution: {integrity: sha512-SzoRg7ux5DWTII9J2qkrZrqV1gt+rTaoufMxEzXbS26Uid0NwaJd123HcoB80TgubEppxxIGdNxCx50fEoEWQA==}\n\n  json5@1.0.2:\n    resolution: {integrity: sha512-g1MWMLBiz8FKi1e4w0UyVL3w+iJceWAFBAaBnnGKOpNa5f8TLktkbre1+s6oICydWAm+HRUGTmI+//xv2hvXYA==}\n    hasBin: true\n\n  json5@2.2.3:\n    resolution: {integrity: sha512-XmOWe7eyHYH14cLdVPoyg+GOH3rYX++KpzrylJwSW98t3Nk+U8XOl8FWKOgwtzdb8lXGf6zYwDUzeHMWfxasyg==}\n    engines: {node: '>=6'}\n    hasBin: true\n\n  kind-of@3.2.2:\n    resolution: {integrity: sha512-NOW9QQXMoZGg/oqnVNoNTTIFEIid1627WCffUBJEdMxYApq7mNE7CpzucIPc+ZQg25Phej7IJSmX3hO+oblOtQ==}\n    engines: {node: '>=0.10.0'}\n\n  kind-of@4.0.0:\n    resolution: {integrity: sha512-24XsCxmEbRwEDbz/qz3stgin8TTzZ1ESR56OMCN0ujYg+vRutNSiOj9bHH9u85DKgXguraugV5sFuvbD4FW/hw==}\n    engines: {node: '>=0.10.0'}\n\n  kind-of@6.0.3:\n    resolution: {integrity: sha512-dcS1ul+9tmeD95T+x28/ehLgd9mENa3LsvDTtzm3vyBEO7RPptvAD+t44WVXaUjTBRcrpFeFlC8WCruUR456hw==}\n    engines: {node: '>=0.10.0'}\n\n  kleur@3.0.3:\n    resolution: {integrity: sha512-eTIzlVOSUR+JxdDFepEYcBMtZ9Qqdef+rnzWdRZuMbOywu5tO2w2N7rqjoANZ5k9vywhL6Br1VRjUIgTQx4E8w==}\n    engines: {node: '>=6'}\n\n  leven@3.1.0:\n    resolution: {integrity: sha512-qsda+H8jTaUaN/x5vzW2rzc+8Rw4TAQ/4KjB46IwK5VH+IlVeeeje/EoZRpiXvIqjFgK84QffqPztGI3VBLG1A==}\n    engines: {node: '>=6'}\n\n  lines-and-columns@1.2.4:\n    resolution: {integrity: sha512-7ylylesZQ/PV29jhEDl3Ufjo6ZX7gCqJr5F7PKrqc93v7fzSymt1BpwEU8nAUXs8qzzvqhbjhK5QZg6Mt/HkBg==}\n\n  lint-staged@10.5.4:\n    resolution: {integrity: sha512-EechC3DdFic/TdOPgj/RB3FicqE6932LTHCUm0Y2fsD9KGlLB+RwJl2q1IYBIvEsKzDOgn0D4gll+YxG5RsrKg==}\n    hasBin: true\n\n  listr2@3.14.0:\n    resolution: {integrity: sha512-TyWI8G99GX9GjE54cJ+RrNMcIFBfwMPxc3XTFiAYGN4s10hWROGtOg7+O6u6LE3mNkyld7RSLE6nrKBvTfcs3g==}\n    engines: {node: '>=10.0.0'}\n    peerDependencies:\n      enquirer: '>= 2.3.0 < 3'\n    peerDependenciesMeta:\n      enquirer:\n        optional: true\n\n  loader-utils@1.4.2:\n    resolution: {integrity: sha512-I5d00Pd/jwMD2QCduo657+YM/6L3KZu++pmX9VFncxaxvHcru9jx1lBaFft+r4Mt2jK0Yhp41XlRAihzPxHNCg==}\n    engines: {node: '>=4.0.0'}\n\n  locate-path@5.0.0:\n    resolution: {integrity: sha512-t7hw9pI+WvuwNJXwk5zVHpyhIqzg2qTlklJOf0mVxGSbe3Fp2VieZcduNYjaLDoy6p9uGpQEGWG87WpMKlNq8g==}\n    engines: {node: '>=8'}\n\n  lodash.debounce@4.0.8:\n    resolution: {integrity: sha512-FT1yDzDYEoYWhnSGnpE/4Kj1fLZkDFyqRb7fNt6FdYOSxlUWAtp42Eh6Wb0rGIv/m9Bgo7x4GhQbm5Ys4SG5ow==}\n\n  lodash.isequal@4.5.0:\n    resolution: {integrity: sha512-pDo3lu8Jhfjqls6GkMgpahsF9kCyayhgykjyLMNFTKWrpVdAQtYyB4muAMWozBB4ig/dtWAmsMxLEI8wuz+DYQ==}\n\n  lodash.merge@4.6.2:\n    resolution: {integrity: sha512-0KpjqXRVvrYyCsX1swR/XTK0va6VQkQM6MNo7PqW77ByjAhoARA8EfrP1N4+KlKj8YS0ZUCtRT/YUuhyYDujIQ==}\n\n  lodash.throttle@4.1.1:\n    resolution: {integrity: sha512-wIkUCfVKpVsWo3JSZlc+8MB5it+2AN5W8J7YVMST30UrvcQNZ1Okbj+rbVniijTWE6FGYy4XJq/rHkas8qJMLQ==}\n\n  lodash@4.17.21:\n    resolution: {integrity: sha512-v2kDEe57lecTulaDIuNTPy3Ry4gLGJ6Z1O3vE1krgXZNrsQ+LFTGHVxVjcXPs17LhbZVGedAJv8XZ1tvj5FvSg==}\n\n  log-symbols@4.1.0:\n    resolution: {integrity: sha512-8XPvpAA8uyhfteu8pIvQxpJZ7SYYdpUivZpGy6sFsBuKRY/7rQGavedeB8aK+Zkyq6upMFVL/9AW6vOYzfRyLg==}\n    engines: {node: '>=10'}\n\n  log-update@4.0.0:\n    resolution: {integrity: sha512-9fkkDevMefjg0mmzWFBW8YkFP91OrizzkW3diF7CpG+S2EYdy4+TVfGwz1zeF8x7hCx1ovSPTOE9Ngib74qqUg==}\n    engines: {node: '>=10'}\n\n  loose-envify@1.4.0:\n    resolution: {integrity: sha512-lyuxPGr/Wfhrlem2CL/UcnUc1zcqKAImBDzukY7Y5F/yQiNdko6+fRLevlw1HgMySw7f611UIY408EtxRSoK3Q==}\n    hasBin: true\n\n  lru-cache@4.1.5:\n    resolution: {integrity: sha512-sWZlbEP2OsHNkXrMl5GYk/jKk70MBng6UU4YI/qGDYbgf6YbP4EvmqISbXCoJiRKs+1bSpFHVgQxvJ17F2li5g==}\n\n  lru-cache@5.1.1:\n    resolution: {integrity: sha512-KpNARQA3Iwv+jTA0utUVVbrh+Jlrr1Fv0e56GGzAFOXN7dk/FviaDW8LHmK52DlcH4WP2n6gI8vN1aesBFgo9w==}\n\n  make-dir@4.0.0:\n    resolution: {integrity: sha512-hXdUTZYIVOt1Ex//jAQi+wTZZpUpwBj/0QsOzqegb3rGMMeJiSEu5xLHnYfBrRV4RH2+OCSOO95Is/7x1WJ4bw==}\n    engines: {node: '>=10'}\n\n  makeerror@1.0.12:\n    resolution: {integrity: sha512-JmqCvUhmt43madlpFzG4BQzG2Z3m6tvQDNKdClZnO3VbIudJYmxsT0FNJMeiB2+JTSlTQTSbU8QdesVmwJcmLg==}\n\n  map-cache@0.2.2:\n    resolution: {integrity: sha512-8y/eV9QQZCiyn1SprXSrCmqJN0yNRATe+PO8ztwqrvrbdRLA3eYJF0yaR0YayLWkMbsQSKWS9N2gPcGEc4UsZg==}\n    engines: {node: '>=0.10.0'}\n\n  map-visit@1.0.0:\n    resolution: {integrity: sha512-4y7uGv8bd2WdM9vpQsiQNo41Ln1NvhvDRuVt0k2JZQ+ezN2uaQes7lZeZ+QQUHOLQAtDaBJ+7wCbi+ab/KFs+w==}\n    engines: {node: '>=0.10.0'}\n\n  math-intrinsics@1.0.0:\n    resolution: {integrity: sha512-4MqMiKP90ybymYvsut0CH2g4XWbfLtmlCkXmtmdcDCxNB+mQcu1w/1+L/VD7vi/PSv7X2JYV7SCcR+jiPXnQtA==}\n    engines: {node: '>= 0.4'}\n\n  md5.js@1.3.5:\n    resolution: {integrity: sha512-xitP+WxNPcTTOgnTJcrhM0xvdPepipPSf3I8EIpGKeFLjt3PlJLIDG3u8EX53ZIubkb+5U2+3rELYpEhHhzdkg==}\n\n  memoize-one@5.2.1:\n    resolution: {integrity: sha512-zYiwtZUcYyXKo/np96AGZAckk+FWWsUdJ3cHGGmld7+AhvcWmQyGCYUh1hc4Q/pkOhb65dQR/pqCyK0cOaHz4Q==}\n\n  merge-stream@2.0.0:\n    resolution: {integrity: sha512-abv/qOcuPfk3URPfDzmZU1LKmuw8kT+0nIHvKrKgFrwifol/doWcdA4ZqsWQ8ENrFKkd67Mfpo/LovbIUsbt3w==}\n\n  micromatch@3.1.10:\n    resolution: {integrity: sha512-MWikgl9n9M3w+bpsY3He8L+w9eF9338xRl8IAO5viDizwSzziFEyUzo2xrrloB64ADbTf8uA8vRqqttDTOmccg==}\n    engines: {node: '>=0.10.0'}\n\n  micromatch@4.0.8:\n    resolution: {integrity: sha512-PXwfBhYu0hBCPw8Dn0E+WDYb7af3dSLVWKi3HGv84IdF4TyFoC0ysxFd0Goxw7nSv4T/PzEJQxsYsEiFCKo2BA==}\n    engines: {node: '>=8.6'}\n\n  miller-rabin@4.0.1:\n    resolution: {integrity: sha512-115fLhvZVqWwHPbClyntxEVfVDfl9DLLTuJvq3g2O/Oxi8AiNouAHvDSzHS0viUJc+V5vm3eq91Xwqn9dp4jRA==}\n    hasBin: true\n\n  mime-db@1.52.0:\n    resolution: {integrity: sha512-sPU4uV7dYlvtWJxwwxHD0PuihVNiE7TyAbQ5SWxDCB9mUYvOgroQOwYQQOKPJ8CIbE+1ETVlOoK1UC2nU3gYvg==}\n    engines: {node: '>= 0.6'}\n\n  mime-types@2.1.35:\n    resolution: {integrity: sha512-ZDY+bPm5zTTF+YpCrAU9nK0UgICYPT0QtT1NZWFv4s++TNkcgVaT0g6+4R2uI4MjQjzysHB1zxuWL50hzaeXiw==}\n    engines: {node: '>= 0.6'}\n\n  mime@1.4.1:\n    resolution: {integrity: sha512-KI1+qOZu5DcW6wayYHSzR/tXKCDC5Om4s1z2QJjDULzLcmf3DvzS7oluY4HCTrc+9FiKmWUgeNLg7W3uIQvxtQ==}\n    hasBin: true\n\n  mimic-fn@2.1.0:\n    resolution: {integrity: sha512-OqbOk5oEQeAZ8WXWydlu9HJjz9WVdEIvamMCcXmuqUYjTknH/sqsWvhQ3vgwKFRR1HpjvNBKQ37nbJgYzGqGcg==}\n    engines: {node: '>=6'}\n\n  min-document@2.19.0:\n    resolution: {integrity: sha512-9Wy1B3m3f66bPPmU5hdA4DR4PB2OfDU/+GS3yAB7IQozE3tqXaVv2zOjgla7MEGSRv95+ILmOuvhLkOK6wJtCQ==}\n\n  mini-create-react-context@0.4.1:\n    resolution: {integrity: sha512-YWCYEmd5CQeHGSAKrYvXgmzzkrvssZcuuQDDeqkT+PziKGMgE+0MCCtcKbROzocGBG1meBLl2FotlRwf4gAzbQ==}\n    deprecated: Package no longer supported. Contact Support at https://www.npmjs.com/support for more info.\n    peerDependencies:\n      prop-types: ^15.0.0\n      react: ^0.14.0 || ^15.0.0 || ^16.0.0 || ^17.0.0\n\n  minimalistic-assert@1.0.1:\n    resolution: {integrity: sha512-UtJcAD4yEaGtjPezWuO9wC4nwUnVH/8/Im3yEHQP4b67cXlD/Qr9hdITCU1xDbSEXg2XKNaP8jsReV7vQd00/A==}\n\n  minimalistic-crypto-utils@1.0.1:\n    resolution: {integrity: sha512-JIYlbt6g8i5jKfJ3xz7rF0LXmv2TkDxBLUkiBeZ7bAx4GnnNMr8xFpGnOxn6GhTEHx3SjRrZEoU+j04prX1ktg==}\n\n  minimatch@3.1.2:\n    resolution: {integrity: sha512-J7p63hRiAjw1NDEww1W7i37+ByIrOWO5XQQAzZ3VOcL0PNybwpfmV/N05zFAzwQ9USyEcX6t3UO+K5aqBQOIHw==}\n\n  minimist@1.2.8:\n    resolution: {integrity: sha512-2yyAR8qBkN3YuheJanUpWC5U3bb5osDywNB8RzDVlDwDHbocAJveqqj1u8+SVD7jkWT4yvsHCpWqqWqAxb0zCA==}\n\n  mixin-deep@1.3.2:\n    resolution: {integrity: sha512-WRoDn//mXBiJ1H40rqa3vH0toePwSsGb45iInWlTySa+Uu4k3tYUSxa2v1KqAiLtvlrSzaExqS1gtk96A9zvEA==}\n    engines: {node: '>=0.10.0'}\n\n  moment@2.30.1:\n    resolution: {integrity: sha512-uEmtNhbDOrWPFS+hdjFCBfy9f2YoyzRpwcl+DqpC6taX21FzsTLQVbMV/W7PzNSX6x/bhC1zA3c2UQ5NzH6how==}\n\n  ms@2.0.0:\n    resolution: {integrity: sha512-Tpp60P6IUJDTuOq/5Z8cdskzJujfwqfOTkrwIwj7IRISpnkJnT6SyJ4PCPnGMoFjC9ddhal5KVIYtAt97ix05A==}\n\n  ms@2.1.3:\n    resolution: {integrity: sha512-6FlzubTLZG3J2a/NVCAleEhjzq5oxgHyaCU9yYXvcLsvoVaHJq/s5xXI6/XXP6tz7R9xAOtHnSO/tXtF3WRTlA==}\n\n  nanomatch@1.2.13:\n    resolution: {integrity: sha512-fpoe2T0RbHwBTBUOftAfBPaDEi06ufaUai0mE6Yn1kacc3SnTErfb/h+X94VXzI64rKFHYImXSvdwGGCmwOqCA==}\n    engines: {node: '>=0.10.0'}\n\n  natural-compare@1.4.0:\n    resolution: {integrity: sha512-OWND8ei3VtNC9h7V60qff3SVobHr996CTwgxubgyQYEpg290h9J0buyECNNJexkFm5sOajh5G116RYA1c8ZMSw==}\n\n  nice-try@1.0.5:\n    resolution: {integrity: sha512-1nh45deeb5olNY7eX82BkPO7SSxR5SSYJiPTrTdFUVYwAl8CKMA5N9PjTYkHiRjisVcxcQ1HXdLhx2qxxJzLNQ==}\n\n  node-fetch@1.7.3:\n    resolution: {integrity: sha512-NhZ4CsKx7cYm2vSrBAr2PvFOe6sWDf0UYLRqA6svUYg7+/TSfVAu49jYC4BvQ4Sms9SZgdqGBgroqfDhJdTyKQ==}\n\n  node-int64@0.4.0:\n    resolution: {integrity: sha512-O5lz91xSOeoXP6DulyHfllpq+Eg00MWitZIbtPfoSEvqIHdl5gfcY6hYzDWnj0qD5tz52PI08u9qUvSVeUBeHw==}\n\n  node-libs-browser@2.2.1:\n    resolution: {integrity: sha512-h/zcD8H9kaDZ9ALUWwlBUDo6TKF8a7qBSCSEGfjTVIYeqsioSKaAX+BN7NgiMGp6iSIXZ3PxgCu8KS3b71YK5Q==}\n\n  node-notifier@8.0.2:\n    resolution: {integrity: sha512-oJP/9NAdd9+x2Q+rfphB2RJCHjod70RcRLjosiPMMu5gjIfwVnOUGq2nbTjTUbmy0DJ/tFIVT30+Qe3nzl4TJg==}\n\n  node-releases@2.0.19:\n    resolution: {integrity: sha512-xxOWJsBKtzAq7DY0J+DTzuz58K8e7sJbdgwkbMWQe8UYB6ekmsQ45q0M/tJDsGaZmbC+l7n57UV8Hl5tHxO9uw==}\n\n  normalize-package-data@2.5.0:\n    resolution: {integrity: sha512-/5CMN3T0R4XTj4DcGaexo+roZSdSFW/0AOOTROrjxzCG1wrWXEsGbRKevjlIL+ZDE4sZlJr5ED4YW0yqmkK+eA==}\n\n  normalize-path@1.0.0:\n    resolution: {integrity: sha512-7WyT0w8jhpDStXRq5836AMmihQwq2nrUVQrgjvUo/p/NZf9uy/MeJ246lBJVmWuYXMlJuG9BNZHF0hWjfTbQUA==}\n    engines: {node: '>=0.10.0'}\n\n  normalize-path@2.1.1:\n    resolution: {integrity: sha512-3pKJwH184Xo/lnH6oyP1q2pMd7HcypqqmRs91/6/i2CGtWwIKGCkOOMTm/zXbgTEWHw1uNpNi/igc3ePOYHb6w==}\n    engines: {node: '>=0.10.0'}\n\n  normalize-path@3.0.0:\n    resolution: {integrity: sha512-6eZs5Ls3WtCisHWp9S2GUy8dqkpGi4BVSz3GaqiE6ezub0512ESztXUwUB6C6IKbQkY2Pnb/mD4WYojCRwcwLA==}\n    engines: {node: '>=0.10.0'}\n\n  normalize-range@0.1.2:\n    resolution: {integrity: sha512-bdok/XvKII3nUpklnV6P2hxtMNrCboOjAcyBuQnWEhO665FwrSNRxU+AqpsyvO6LgGYPspN+lu5CLtw4jPRKNA==}\n    engines: {node: '>=0.10.0'}\n\n  normalize-url@1.9.1:\n    resolution: {integrity: sha512-A48My/mtCklowHBlI8Fq2jFWK4tX4lJ5E6ytFsSOq1fzpvT0SQSgKhSg7lN5c2uYFOrUAOQp6zhhJnpp1eMloQ==}\n    engines: {node: '>=4'}\n\n  normalize.css@7.0.0:\n    resolution: {integrity: sha512-LYaFZxj2Q1Q9e1VJ0f6laG46Rt5s9URhKyckNaA2vZnL/0gwQHWhM7ALQkp3WBQKM5sXRLQ5Ehrfkp+E/ZiCRg==}\n\n  npm-run-path@2.0.2:\n    resolution: {integrity: sha512-lJxZYlT4DW/bRUtFh1MQIWqmLwQfAxnqWG4HhEdjMlkrJYnJn0Jrr2u3mgxqaWsdiBc76TYkTG/mhrnYTuzfHw==}\n    engines: {node: '>=4'}\n\n  npm-run-path@4.0.1:\n    resolution: {integrity: sha512-S48WzZW777zhNIrn7gxOlISNAqi9ZC/uQFnRdbeIHhZhCA6UqpkOT8T1G7BvfdgP4Er8gF4sUbaS0i7QvIfCWw==}\n    engines: {node: '>=8'}\n\n  num2fraction@1.2.2:\n    resolution: {integrity: sha512-Y1wZESM7VUThYY+4W+X4ySH2maqcA+p7UR+w8VWNWVAd6lwuXXWz/w/Cz43J/dI2I+PS6wD5N+bJUF+gjWvIqg==}\n\n  nwsapi@2.2.16:\n    resolution: {integrity: sha512-F1I/bimDpj3ncaNDhfyMWuFqmQDBwDB0Fogc2qpL3BWvkQteFD/8BzWuIRl83rq0DXfm8SGt/HFhLXZyljTXcQ==}\n\n  object-assign@4.1.1:\n    resolution: {integrity: sha512-rJgTQnkUnH1sFw8yT6VSU3zD3sWmu6sZhIseY8VX+GRu3P6F7Fu+JNDoXfklElbLJSnc3FUQHVe4cU5hj+BcUg==}\n    engines: {node: '>=0.10.0'}\n\n  object-copy@0.1.0:\n    resolution: {integrity: sha512-79LYn6VAb63zgtmAteVOWo9Vdj71ZVBy3Pbse+VqxDpEP83XuujMrGqHIwAXJ5I/aM0zU7dIyIAhifVTPrNItQ==}\n    engines: {node: '>=0.10.0'}\n\n  object-inspect@1.13.3:\n    resolution: {integrity: sha512-kDCGIbxkDSXE3euJZZXzc6to7fCrKHNI/hSRQnRuQ+BWjFNzZwiFF8fj/6o2t2G9/jTj8PSIYTfCLelLZEeRpA==}\n    engines: {node: '>= 0.4'}\n\n  object-keys@1.1.1:\n    resolution: {integrity: sha512-NuAESUOUMrlIXOfHKzD6bpPu3tYt3xvjNdRIQ+FeT0lNb4K8WR70CaDxhuNguS2XG+GjkyMwOzsN5ZktImfhLA==}\n    engines: {node: '>= 0.4'}\n\n  object-visit@1.0.1:\n    resolution: {integrity: sha512-GBaMwwAVK9qbQN3Scdo0OyvgPW7l3lnaVMj84uTOZlswkX0KpF6fyDBJhtTthf7pymztoN36/KEr1DyhF96zEA==}\n    engines: {node: '>=0.10.0'}\n\n  object.assign@4.1.5:\n    resolution: {integrity: sha512-byy+U7gp+FVwmyzKPYhW2h5l3crpmGsxl7X2s8y43IgxvG4g3QZ6CffDtsNQy1WsmZpQbO+ybo0AlW7TY6DcBQ==}\n    engines: {node: '>= 0.4'}\n\n  object.pick@1.3.0:\n    resolution: {integrity: sha512-tqa/UMy/CCoYmj+H5qc07qvSL9dqcs/WZENZ1JbtWBlATP+iVOe778gE6MSijnyCnORzDuX6hU+LA4SZ09YjFQ==}\n    engines: {node: '>=0.10.0'}\n\n  omit.js@2.0.2:\n    resolution: {integrity: sha512-hJmu9D+bNB40YpL9jYebQl4lsTW6yEHRTroJzNLqQJYHm7c+NQnJGfZmIWh8S3q3KoaxV1aLhV6B3+0N0/kyJg==}\n\n  once@1.4.0:\n    resolution: {integrity: sha512-lNaJgI+2Q5URQBkccEKHTQOPaXdUxnZZElQTZY0MFUAuaEqe1E+Nyvgdz/aIyNi6Z9MzO5dv1H8n58/GELp3+w==}\n\n  onetime@5.1.2:\n    resolution: {integrity: sha512-kbpaSSGJTWdAY5KPVeMOKXSrPtr8C8C7wodJbcsd51jRnmD+GZu8Y0VoU6Dm5Z4vWr0Ig/1NKuWRKf7j5aaYSg==}\n    engines: {node: '>=6'}\n\n  os-browserify@0.3.0:\n    resolution: {integrity: sha512-gjcpUc3clBf9+210TRaDWbf+rZZZEshZ+DlXMRCeAjp0xhTrnQsKHypIy1J3d5hKdUzj69t708EHtU8P6bUn0A==}\n\n  p-each-series@2.2.0:\n    resolution: {integrity: sha512-ycIL2+1V32th+8scbpTvyHNaHe02z0sjgh91XXjAk+ZeXoPN4Z46DVUnzdso0aX4KckKw0FNNFHdjZ2UsZvxiA==}\n    engines: {node: '>=8'}\n\n  p-finally@1.0.0:\n    resolution: {integrity: sha512-LICb2p9CB7FS+0eR1oqWnHhp0FljGLZCWBE9aix0Uye9W8LTQPwMTYVGWQWIw9RdQiDg4+epXQODwIYJtSJaow==}\n    engines: {node: '>=4'}\n\n  p-limit@2.3.0:\n    resolution: {integrity: sha512-//88mFWSJx8lxCzwdAABTJL2MyWB12+eIY7MDL2SqLmAkeKU9qxRvWuSyTjm3FUmpBEMuFfckAIqEaVGUDxb6w==}\n    engines: {node: '>=6'}\n\n  p-locate@4.1.0:\n    resolution: {integrity: sha512-R79ZZ/0wAxKGu3oYMlz8jy/kbhsNrS7SKZ7PxEHBgJ5+F2mtFW2fK2cOtBh1cHYkQsbzFV7I+EoRKe6Yt0oK7A==}\n    engines: {node: '>=8'}\n\n  p-map@4.0.0:\n    resolution: {integrity: sha512-/bjOqmgETBYB5BoEeGVea8dmvHb2m9GLy1E9W43yeyfP6QQCZGFNa+XRceJEuDB6zqr+gKpIAmlLebMpykw/MQ==}\n    engines: {node: '>=10'}\n\n  p-try@2.2.0:\n    resolution: {integrity: sha512-R4nPAVTAU0B9D35/Gk3uJf/7XYbQcyohSKdvAxIRSNghFl4e71hVoGnBNQz9cWaXxO2I10KTC+3jMdvvoKw6dQ==}\n    engines: {node: '>=6'}\n\n  pako@1.0.11:\n    resolution: {integrity: sha512-4hLB8Py4zZce5s4yd9XzopqwVv/yGNhV1Bl8NTmCq1763HeK2+EwVTv+leGeL13Dnh2wfbqowVPXCIO0z4taYw==}\n\n  parent-module@1.0.1:\n    resolution: {integrity: sha512-GQ2EWRpQV8/o+Aw8YqtfZZPfNRWZYkbidE9k5rpl/hC3vtHHBfGm2Ifi6qWV+coDGkrUKZAxE3Lot5kcsRlh+g==}\n    engines: {node: '>=6'}\n\n  parse-asn1@5.1.7:\n    resolution: {integrity: sha512-CTM5kuWR3sx9IFamcl5ErfPl6ea/N8IYwiJ+vpeB2g+1iknv7zBl5uPwbMbRVznRVbrNY6lGuDoE5b30grmbqg==}\n    engines: {node: '>= 0.10'}\n\n  parse-json@4.0.0:\n    resolution: {integrity: sha512-aOIos8bujGN93/8Ox/jPLh7RwVnPEysynVFE+fQZyg6jKELEHwzgKdLRFHUgXJL6kylijVSBC4BvN9OmsB48Rw==}\n    engines: {node: '>=4'}\n\n  parse-json@5.2.0:\n    resolution: {integrity: sha512-ayCKvm/phCGxOkYRSCM82iDwct8/EonSEgCSxWxD7ve6jHggsFl4fZVQBPRNgQoKiuV/odhFrGzQXZwbifC8Rg==}\n    engines: {node: '>=8'}\n\n  parse5@6.0.1:\n    resolution: {integrity: sha512-Ofn/CTFzRGTTxwpNEs9PP93gXShHcTq255nzRYSKe8AkVpZY7e1fpmTfOyoIvjP5HG7Z2ZM7VS9PPhQGW2pOpw==}\n\n  pascalcase@0.1.1:\n    resolution: {integrity: sha512-XHXfu/yOQRy9vYOtUDVMN60OEJjW013GoObG1o+xwQTpB9eYJX/BjXMsdW13ZDPruFhYYn0AG22w0xgQMwl3Nw==}\n    engines: {node: '>=0.10.0'}\n\n  path-browserify@0.0.1:\n    resolution: {integrity: sha512-BapA40NHICOS+USX9SN4tyhq+A2RrN/Ws5F0Z5aMHDp98Fl86lX8Oti8B7uN93L4Ifv4fHOEA+pQw87gmMO/lQ==}\n\n  path-exists@4.0.0:\n    resolution: {integrity: sha512-ak9Qy5Q7jYb2Wwcey5Fpvg2KoAc/ZIhLSLOSBmRmygPsGwkVVt0fZa0qrtMz+m6tJTAHfZQ8FnmB4MG4LWy7/w==}\n    engines: {node: '>=8'}\n\n  path-is-absolute@1.0.1:\n    resolution: {integrity: sha512-AVbw3UJ2e9bq64vSaS9Am0fje1Pa8pbGqTTsmXfaIiMpnr5DlDhfJOuLj9Sf95ZPVDAUerDfEk88MPmPe7UCQg==}\n    engines: {node: '>=0.10.0'}\n\n  path-key@2.0.1:\n    resolution: {integrity: sha512-fEHGKCSmUSDPv4uoj8AlD+joPlq3peND+HRYyxFz4KPw4z926S/b8rIuFs2FYJg3BwsxJf6A9/3eIdLaYC+9Dw==}\n    engines: {node: '>=4'}\n\n  path-key@3.1.1:\n    resolution: {integrity: sha512-ojmeN0qd+y0jszEtoY48r0Peq5dwMEkIlCOu6Q5f41lfkswXuKtYrhgoTpLnyIcHm24Uhqx+5Tqm2InSwLhE6Q==}\n    engines: {node: '>=8'}\n\n  path-parse@1.0.7:\n    resolution: {integrity: sha512-LDJzPVEEEPR+y48z93A0Ed0yXb8pAByGWo/k5YYdYgpY2/2EsOsksJrq7lOHxryrVOn1ejG6oAp8ahvOIQD8sw==}\n\n  path-to-regexp@1.9.0:\n    resolution: {integrity: sha512-xIp7/apCFJuUHdDLWe8O1HIkb0kQrOMb/0u6FXQjemHn/ii5LrIzU6bdECnsiTF/GjZkMEKg1xdiZwNqDYlZ6g==}\n\n  path-to-regexp@2.4.0:\n    resolution: {integrity: sha512-G6zHoVqC6GGTQkZwF4lkuEyMbVOjoBKAEybQUypI1WTkqinCOrq2x6U2+phkJ1XsEMTy4LjtwPI7HW+NVrRR2w==}\n\n  path-type@4.0.0:\n    resolution: {integrity: sha512-gDKb8aZMDeD/tZWs9P6+q0J9Mwkdl6xMV8TjnGP3qJVJ06bdMgkbBlLU8IdfOsIsFz2BW1rNVT3XuNEl8zPAvw==}\n    engines: {node: '>=8'}\n\n  pbkdf2@3.1.2:\n    resolution: {integrity: sha512-iuh7L6jA7JEGu2WxDwtQP1ddOpaJNC4KlDEFfdQajSGgGPNi4OyDc2R7QnbY2bR9QjBVGwgvTdNJZoE7RaxUMA==}\n    engines: {node: '>=0.12'}\n\n  performance-now@2.1.0:\n    resolution: {integrity: sha512-7EAHlyLHI56VEIdK57uwHdHKIaAGbnXPiw0yWbarQZOKaKpvUIgW0jWRVLiatnM+XXlSwsanIBH/hzGMJulMow==}\n\n  picocolors@0.2.1:\n    resolution: {integrity: sha512-cMlDqaLEqfSaW8Z7N5Jw+lyIW869EzT73/F5lhtY9cLGoVxSXznfgfXMO0Z5K0o0Q2TkTXq+0KFsdnSe3jDViA==}\n\n  picocolors@1.1.1:\n    resolution: {integrity: sha512-xceH2snhtb5M9liqDsmEw56le376mTZkEX/jEb/RxNFyegNul7eNslCXP9FDj/Lcu0X8KEyMceP2ntpaHrDEVA==}\n\n  picomatch@2.3.1:\n    resolution: {integrity: sha512-JU3teHTNjmE2VCGFzuY8EXzCDVwEqB2a8fsIvwaStHhAWJEeVd1o1QD80CU6+ZdEXXSLbSsuLwJjkCBWqRQUVA==}\n    engines: {node: '>=8.6'}\n\n  pirates@4.0.6:\n    resolution: {integrity: sha512-saLsH7WeYYPiD25LDuLRRY/i+6HaPYr6G1OUlN39otzkSTxKnubR9RTxS3/Kk50s1g2JTgFwWQDQyplC5/SHZg==}\n    engines: {node: '>= 6'}\n\n  pkg-dir@4.2.0:\n    resolution: {integrity: sha512-HRDzbaKjC+AOWVXxAU/x54COGeIv9eb+6CkDSQoNTt4XyWoIJvuPsXizxu/Fr23EiekbtZwmh1IcIG/l/a10GQ==}\n    engines: {node: '>=8'}\n\n  please-upgrade-node@3.2.0:\n    resolution: {integrity: sha512-gQR3WpIgNIKwBMVLkpMUeR3e1/E1y42bqDQZfql+kDeXd8COYfM8PQA4X6y7a8u9Ua9FHmsrrmirW2vHs45hWg==}\n\n  posix-character-classes@0.1.1:\n    resolution: {integrity: sha512-xTgYBc3fuo7Yt7JbiuFxSYGToMoz8fLoE6TC9Wx1P/u+LfeThMOAqmuyECnlBaaJb+u1m9hHiXUEtwW4OzfUJg==}\n    engines: {node: '>=0.10.0'}\n\n  postcss-attribute-case-insensitive@4.0.2:\n    resolution: {integrity: sha512-clkFxk/9pcdb4Vkn0hAHq3YnxBQ2p0CGD1dy24jN+reBck+EWxMbxSUqN4Yj7t0w8csl87K6p0gxBe1utkJsYA==}\n\n  postcss-color-functional-notation@2.0.1:\n    resolution: {integrity: sha512-ZBARCypjEDofW4P6IdPVTLhDNXPRn8T2s1zHbZidW6rPaaZvcnCS2soYFIQJrMZSxiePJ2XIYTlcb2ztr/eT2g==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-color-gray@5.0.0:\n    resolution: {integrity: sha512-q6BuRnAGKM/ZRpfDascZlIZPjvwsRye7UDNalqVz3s7GDxMtqPY6+Q871liNxsonUw8oC61OG+PSaysYpl1bnw==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-color-hex-alpha@5.0.3:\n    resolution: {integrity: sha512-PF4GDel8q3kkreVXKLAGNpHKilXsZ6xuu+mOQMHWHLPNyjiUBOr75sp5ZKJfmv1MCus5/DWUGcK9hm6qHEnXYw==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-color-mod-function@3.0.3:\n    resolution: {integrity: sha512-YP4VG+xufxaVtzV6ZmhEtc+/aTXH3d0JLpnYfxqTvwZPbJhWqp8bSY3nfNzNRFLgB4XSaBA82OE4VjOOKpCdVQ==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-color-rebeccapurple@4.0.1:\n    resolution: {integrity: sha512-aAe3OhkS6qJXBbqzvZth2Au4V3KieR5sRQ4ptb2b2O8wgvB3SJBsdG+jsn2BZbbwekDG8nTfcCNKcSfe/lEy8g==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-custom-media@7.0.8:\n    resolution: {integrity: sha512-c9s5iX0Ge15o00HKbuRuTqNndsJUbaXdiNsksnVH8H4gdc+zbLzr/UasOwNG6CTDpLFekVY4672eWdiiWu2GUg==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-custom-properties@8.0.11:\n    resolution: {integrity: sha512-nm+o0eLdYqdnJ5abAJeXp4CEU1c1k+eB2yMCvhgzsds/e0umabFrN6HoTy/8Q4K5ilxERdl/JD1LO5ANoYBeMA==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-custom-selectors@5.1.2:\n    resolution: {integrity: sha512-DSGDhqinCqXqlS4R7KGxL1OSycd1lydugJ1ky4iRXPHdBRiozyMHrdu0H3o7qNOCiZwySZTUI5MV0T8QhCLu+w==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-dir-pseudo-class@5.0.0:\n    resolution: {integrity: sha512-3pm4oq8HYWMZePJY+5ANriPs3P07q+LW6FAdTlkFH2XqDdP4HeeJYMOzn0HYLhRSjBO3fhiqSwwU9xEULSrPgw==}\n    engines: {node: '>=4.0.0'}\n\n  postcss-double-position-gradients@1.0.0:\n    resolution: {integrity: sha512-G+nV8EnQq25fOI8CH/B6krEohGWnF5+3A6H/+JEpOncu5dCnkS1QQ6+ct3Jkaepw1NGVqqOZH6lqrm244mCftA==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-env-function@2.0.2:\n    resolution: {integrity: sha512-rwac4BuZlITeUbiBq60h/xbLzXY43qOsIErngWa4l7Mt+RaSkT7QBjXVGTcBHupykkblHMDrBFh30zchYPaOUw==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-flexbugs-fixes@4.2.1:\n    resolution: {integrity: sha512-9SiofaZ9CWpQWxOwRh1b/r85KD5y7GgvsNt1056k6OYLvWUun0czCvogfJgylC22uJTwW1KzY3Gz65NZRlvoiQ==}\n\n  postcss-focus-visible@4.0.0:\n    resolution: {integrity: sha512-Z5CkWBw0+idJHSV6+Bgf2peDOFf/x4o+vX/pwcNYrWpXFrSfTkQ3JQ1ojrq9yS+upnAlNRHeg8uEwFTgorjI8g==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-focus-within@3.0.0:\n    resolution: {integrity: sha512-W0APui8jQeBKbCGZudW37EeMCjDeVxKgiYfIIEo8Bdh5SpB9sxds/Iq8SEuzS0Q4YFOlG7EPFulbbxujpkrV2w==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-font-variant@4.0.1:\n    resolution: {integrity: sha512-I3ADQSTNtLTTd8uxZhtSOrTCQ9G4qUVKPjHiDk0bV75QSxXjVWiJVJ2VLdspGUi9fbW9BcjKJoRvxAH1pckqmA==}\n\n  postcss-gap-properties@2.0.0:\n    resolution: {integrity: sha512-QZSqDaMgXCHuHTEzMsS2KfVDOq7ZFiknSpkrPJY6jmxbugUPTuSzs/vuE5I3zv0WAS+3vhrlqhijiprnuQfzmg==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-image-set-function@3.0.1:\n    resolution: {integrity: sha512-oPTcFFip5LZy8Y/whto91L9xdRHCWEMs3e1MdJxhgt4jy2WYXfhkng59fH5qLXSCPN8k4n94p1Czrfe5IOkKUw==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-initial@3.0.4:\n    resolution: {integrity: sha512-3RLn6DIpMsK1l5UUy9jxQvoDeUN4gP939tDcKUHD/kM8SGSKbFAnvkpFpj3Bhtz3HGk1jWY5ZNWX6mPta5M9fg==}\n\n  postcss-lab-function@2.0.1:\n    resolution: {integrity: sha512-whLy1IeZKY+3fYdqQFuDBf8Auw+qFuVnChWjmxm/UhHWqNHZx+B99EwxTvGYmUBqe3Fjxs4L1BoZTJmPu6usVg==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-load-config@2.1.2:\n    resolution: {integrity: sha512-/rDeGV6vMUo3mwJZmeHfEDvwnTKKqQ0S7OHUi/kJvvtx3aWtyWG2/0ZWnzCt2keEclwN6Tf0DST2v9kITdOKYw==}\n    engines: {node: '>= 4'}\n\n  postcss-loader@3.0.0:\n    resolution: {integrity: sha512-cLWoDEY5OwHcAjDnkyRQzAXfs2jrKjXpO/HQFcc5b5u/r7aa471wdmChmwfnv7x2u840iat/wi0lQ5nbRgSkUA==}\n    engines: {node: '>= 6'}\n\n  postcss-logical@3.0.0:\n    resolution: {integrity: sha512-1SUKdJc2vuMOmeItqGuNaC+N8MzBWFWEkAnRnLpFYj1tGGa7NqyVBujfRtgNa2gXR+6RkGUiB2O5Vmh7E2RmiA==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-media-minmax@4.0.0:\n    resolution: {integrity: sha512-fo9moya6qyxsjbFAYl97qKO9gyre3qvbMnkOZeZwlsW6XYFsvs2DMGDlchVLfAd8LHPZDxivu/+qW2SMQeTHBw==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-nesting@7.0.1:\n    resolution: {integrity: sha512-FrorPb0H3nuVq0Sff7W2rnc3SmIcruVC6YwpcS+k687VxyxO33iE1amna7wHuRVzM8vfiYofXSBHNAZ3QhLvYg==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-overflow-shorthand@2.0.0:\n    resolution: {integrity: sha512-aK0fHc9CBNx8jbzMYhshZcEv8LtYnBIRYQD5i7w/K/wS9c2+0NSR6B3OVMu5y0hBHYLcMGjfU+dmWYNKH0I85g==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-page-break@2.0.0:\n    resolution: {integrity: sha512-tkpTSrLpfLfD9HvgOlJuigLuk39wVTbbd8RKcy8/ugV2bNBUW3xU+AIqyxhDrQr1VUj1RmyJrBn1YWrqUm9zAQ==}\n\n  postcss-place@4.0.1:\n    resolution: {integrity: sha512-Zb6byCSLkgRKLODj/5mQugyuj9bvAAw9LqJJjgwz5cYryGeXfFZfSXoP1UfveccFmeq0b/2xxwcTEVScnqGxBg==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-preset-env@6.7.0:\n    resolution: {integrity: sha512-eU4/K5xzSFwUFJ8hTdTQzo2RBLbDVt83QZrAvI07TULOkmyQlnYlpwep+2yIK+K+0KlZO4BvFcleOCCcUtwchg==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-pseudo-class-any-link@6.0.0:\n    resolution: {integrity: sha512-lgXW9sYJdLqtmw23otOzrtbDXofUdfYzNm4PIpNE322/swES3VU9XlXHeJS46zT2onFO7V1QFdD4Q9LiZj8mew==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-replace-overflow-wrap@3.0.0:\n    resolution: {integrity: sha512-2T5hcEHArDT6X9+9dVSPQdo7QHzG4XKclFT8rU5TzJPDN7RIRTbO9c4drUISOVemLj03aezStHCR2AIcr8XLpw==}\n\n  postcss-safe-parser@4.0.2:\n    resolution: {integrity: sha512-Uw6ekxSWNLCPesSv/cmqf2bY/77z11O7jZGPax3ycZMFU/oi2DMH9i89AdHc1tRwFg/arFoEwX0IS3LCUxJh1g==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-selector-matches@4.0.0:\n    resolution: {integrity: sha512-LgsHwQR/EsRYSqlwdGzeaPKVT0Ml7LAT6E75T8W8xLJY62CE4S/l03BWIt3jT8Taq22kXP08s2SfTSzaraoPww==}\n\n  postcss-selector-not@4.0.1:\n    resolution: {integrity: sha512-YolvBgInEK5/79C+bdFMyzqTg6pkYqDbzZIST/PDMqa/o3qtXenD05apBG2jLgT0/BQ77d4U2UK12jWpilqMAQ==}\n\n  postcss-selector-parser@5.0.0:\n    resolution: {integrity: sha512-w+zLE5Jhg6Liz8+rQOWEAwtwkyqpfnmsinXjXg6cY7YIONZZtgvE0v2O0uhQBs0peNomOJwWRKt6JBfTdTd3OQ==}\n    engines: {node: '>=4'}\n\n  postcss-selector-parser@6.1.2:\n    resolution: {integrity: sha512-Q8qQfPiZ+THO/3ZrOrO0cJJKfpYCagtMUkXbnEfmgUjwXg6z/WBeOyS9APBBPCTSiDV+s4SwQGu8yFsiMRIudg==}\n    engines: {node: '>=4'}\n\n  postcss-value-parser@4.2.0:\n    resolution: {integrity: sha512-1NNCs6uurfkVbeXG4S8JFT9t19m45ICnif8zWLd5oPSZ50QnwMfK+H3jv408d4jw/7Bttv5axS5IiHoLaVNHeQ==}\n\n  postcss-values-parser@2.0.1:\n    resolution: {integrity: sha512-2tLuBsA6P4rYTNKCXYG/71C7j1pU6pK503suYOmn4xYrQIzW+opD+7FAFNuGSdZC/3Qfy334QbeMu7MEb8gOxg==}\n    engines: {node: '>=6.14.4'}\n\n  postcss@7.0.32:\n    resolution: {integrity: sha512-03eXong5NLnNCD05xscnGKGDZ98CyzoqPSMjOe6SuoQY7Z2hIj0Ld1g/O/UQRuOle2aRtiIRDg9tDcTGAkLfKw==}\n    engines: {node: '>=6.0.0'}\n\n  prepend-http@1.0.4:\n    resolution: {integrity: sha512-PhmXi5XmoyKw1Un4E+opM2KcsJInDvKyuOumcjjw3waw86ZNjHwVUOOWLc4bCzLdcKNaWBH9e99sbWzDQsVaYg==}\n    engines: {node: '>=0.10.0'}\n\n  prettier@2.2.1:\n    resolution: {integrity: sha512-PqyhM2yCjg/oKkFPtTGUojv7gnZAoG80ttl45O6x2Ug/rMJw4wcc9k6aaf2hibP7BGVCCM33gZoGjyvt9mm16Q==}\n    engines: {node: '>=10.13.0'}\n    hasBin: true\n\n  prettier@2.8.8:\n    resolution: {integrity: sha512-tdN8qQGvNjw4CHbY+XXk0JgCXn9QiF21a55rBe5LJAU+kDyC4WQn4+awm2Xfk2lQMk5fKup9XgzTZtGkjBdP9Q==}\n    engines: {node: '>=10.13.0'}\n    hasBin: true\n\n  pretty-format@26.6.2:\n    resolution: {integrity: sha512-7AeGuCYNGmycyQbCqd/3PWH4eOoX/OiCa0uphp57NVTeAGdJGaAliecxwBDHYQCIvrW7aDBZCYeNTP/WX69mkg==}\n    engines: {node: '>= 10'}\n\n  process-nextick-args@2.0.1:\n    resolution: {integrity: sha512-3ouUOpQhtgrbOa17J7+uxOTpITYWaGP7/AhoR3+A+/1e9skrzelGi/dXzEYyvbxubEF6Wn2ypscTKiKJFFn1ag==}\n\n  process@0.11.10:\n    resolution: {integrity: sha512-cdGef/drWFoydD1JsMzuFf8100nZl+GT+yacc2bEced5f9Rjk4z+WtFUTBu9PhOi9j/jfmBPu0mMEY4wIdAF8A==}\n    engines: {node: '>= 0.6.0'}\n\n  promise@7.3.1:\n    resolution: {integrity: sha512-nolQXZ/4L+bP/UGlkfaIujX9BKxGwmQ9OT4mOt5yvy8iK1h3wqTEJCijzGANTCCl9nWjY41juyAn2K3Q1hLLTg==}\n\n  prompts@2.4.2:\n    resolution: {integrity: sha512-NxNv/kLguCA7p3jE8oL2aEBsrJWgAakBpgmgK6lpPWV+WuOmY6r2/zbAVnP+T8bQlA0nzHXSJSJW0Hq7ylaD2Q==}\n    engines: {node: '>= 6'}\n\n  prop-types@15.8.1:\n    resolution: {integrity: sha512-oj87CgZICdulUohogVAR7AjlC0327U4el4L6eAvOqCeudMDVU0NThNaV+b9Df4dXgSP1gXMTnPdhfe/2qDH5cg==}\n\n  pseudomap@1.0.2:\n    resolution: {integrity: sha512-b/YwNhb8lk1Zz2+bXXpS/LK9OisiZZ1SNsSLxN1x2OXVEhW2Ckr/7mWE5vrC1ZTiJlD9g19jWszTmJsB+oEpFQ==}\n\n  psl@1.15.0:\n    resolution: {integrity: sha512-JZd3gMVBAVQkSs6HdNZo9Sdo0LNcQeMNP3CozBJb3JYC/QUYZTnKxP+f8oWRX4rHP5EurWxqAHTSwUCjlNKa1w==}\n\n  public-encrypt@4.0.3:\n    resolution: {integrity: sha512-zVpa8oKZSz5bTMTFClc1fQOnyyEzpl5ozpi1B5YcvBrdohMjH2rfsBtyXcuNuwjsDIXmBYlF2N5FlJYhR29t8Q==}\n\n  pump@3.0.2:\n    resolution: {integrity: sha512-tUPXtzlGM8FE3P0ZL6DVs/3P58k9nk8/jZeQCurTJylQA8qFYzHFfhBJkuqyE0FifOsQ0uKWekiZ5g8wtr28cw==}\n\n  punycode@1.4.1:\n    resolution: {integrity: sha512-jmYNElW7yvO7TV33CjSmvSiE2yco3bV2czu/OzDKdMNVZQWfxCblURLhf+47syQRBntjfLdd/H0egrzIG+oaFQ==}\n\n  punycode@2.3.1:\n    resolution: {integrity: sha512-vYt7UD1U9Wg6138shLtLOvdAu+8DsC/ilFtEVHcH+wydcSpNE20AfSOduf6MkRFahL5FY7X1oU7nKVZFtfq8Fg==}\n    engines: {node: '>=6'}\n\n  qs@6.13.1:\n    resolution: {integrity: sha512-EJPeIn0CYrGu+hli1xilKAPXODtJ12T0sP63Ijx2/khC2JtuaN3JyNIpvmnkmaEtha9ocbG4A4cMcr+TvqvwQg==}\n    engines: {node: '>=0.6'}\n\n  query-string@4.3.4:\n    resolution: {integrity: sha512-O2XLNDBIg1DnTOa+2XrIwSiXEV8h2KImXUnjhhn2+UsvZ+Es2uyd5CCRTNQlDGbzUQOW3aYCBx9rVA6dzsiY7Q==}\n    engines: {node: '>=0.10.0'}\n\n  query-string@6.14.1:\n    resolution: {integrity: sha512-XDxAeVmpfu1/6IjyT/gXHOl+S0vQ9owggJ30hhWKdHAsNPOcasn5o9BW0eejZqL2e4vMjhAxoW3jVHcD6mbcYw==}\n    engines: {node: '>=6'}\n\n  querystring-es3@0.2.1:\n    resolution: {integrity: sha512-773xhDQnZBMFobEiztv8LIl70ch5MSF/jUQVlhwFyBILqq96anmoctVIYz+ZRp0qbCKATTn6ev02M3r7Ga5vqA==}\n    engines: {node: '>=0.4.x'}\n\n  querystringify@2.2.0:\n    resolution: {integrity: sha512-FIqgj2EUvTa7R50u0rGsyTftzjYmv/a3hO345bZNrqabNqjtgiDMgmo4mkUjd+nzU5oF3dClKqFIPUKybUyqoQ==}\n\n  raf@3.4.1:\n    resolution: {integrity: sha512-Sq4CW4QhwOHE8ucn6J34MqtZCeWFP2aQSmrlroYgqAV1PjStIhJXxYuTgUIfkEk7zTLjmIjLmU5q+fbD1NnOJA==}\n\n  randombytes@2.1.0:\n    resolution: {integrity: sha512-vYl3iOX+4CKUWuxGi9Ukhie6fsqXqS9FE2Zaic4tNFD2N2QQaXOMFbuKK4QmDHC0JO6B1Zp41J0LpT0oR68amQ==}\n\n  randomfill@1.0.4:\n    resolution: {integrity: sha512-87lcbR8+MhcWcUiQ+9e+Rwx8MyR2P7qnt15ynUlbm3TU/fjbgz4GsvfSUDTemtCCtVCqb4ZcEFlyPNTh9bBTLw==}\n\n  rc-align@2.4.5:\n    resolution: {integrity: sha512-nv9wYUYdfyfK+qskThf4BQUSIadeI/dCsfaMZfNEoxm9HwOIioQ+LyqmMK6jWHAZQgOzMLaqawhuBXlF63vgjw==}\n\n  rc-align@4.0.15:\n    resolution: {integrity: sha512-wqJtVH60pka/nOX7/IspElA8gjPNQKIx/ZqJ6heATCkXpe1Zg4cPVrMD2vC96wjsFFL8WsmhPbx9tdMo1qqlIA==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-animate@2.11.1:\n    resolution: {integrity: sha512-1NyuCGFJG/0Y+9RKh5y/i/AalUCA51opyyS/jO2seELpgymZm2u9QV3xwODwEuzkmeQ1BDPxMLmYLcTJedPlkQ==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-cascader@3.7.3:\n    resolution: {integrity: sha512-KBpT+kzhxDW+hxPiNk4zaKa99+Lie2/8nnI11XF+FIOPl4Bj9VlFZi61GrnWzhLGA7VEN+dTxAkNOjkySDa0dA==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-checkbox@2.0.3:\n    resolution: {integrity: sha512-sSDV5AcxK5CxBTyUNj9pb0zfhdgLLsWKHwJG18ikeGoIwklcxXvIF6cI/KGVbPLFDa8mPS5WLOlLRqbq/1/ouw==}\n\n  rc-checkbox@3.0.1:\n    resolution: {integrity: sha512-k7nxDWxYF+jDI0ZcCvuvj71xONmWRVe5+1MKcERRR9MRyP3tZ69b+yUCSXXh+sik4/Hc9P5wHr2nnUoGS2zBjA==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-collapse@1.9.3:\n    resolution: {integrity: sha512-8cG+FzudmgFCC9zRGKXJZA36zoI9Dmyjp6UDi8N80sXUch0JOpsZDxgcFzw4HPpPpK/dARtTilEe9zyuspnW0w==}\n\n  rc-collapse@3.4.2:\n    resolution: {integrity: sha512-jpTwLgJzkhAgp2Wpi3xmbTbbYExg6fkptL67Uu5LCRVEj6wqmy0DHTjjeynsjOLsppHGHu41t1ELntZ0lEvS/Q==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-dialog@9.0.4:\n    resolution: {integrity: sha512-pmnPRZKd9CGzGgf4a1ysBvMhxm8Afx5fF6M7AzLtJ0qh8X1bshurDlqnK4MBNAB4hAeAMMbz6Ytb1rkGMvKFbQ==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-drawer@6.3.0:\n    resolution: {integrity: sha512-uBZVb3xTAR+dBV53d/bUhTctCw3pwcwJoM7g5aX+7vgwt2zzVzoJ6aqFjYJpBlZ9zp0dVYN8fV+hykFE7c4lig==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-dropdown@4.0.1:\n    resolution: {integrity: sha512-OdpXuOcme1rm45cR0Jzgfl1otzmU4vuBVb+etXM8vcaULGokAKVpKlw8p6xzspG7jGd/XxShvq+N3VNEfk/l5g==}\n    peerDependencies:\n      react: '>=16.11.0'\n      react-dom: '>=16.11.0'\n\n  rc-field-form@1.38.2:\n    resolution: {integrity: sha512-O83Oi1qPyEv31Sg+Jwvsj6pXc8uQI2BtIAkURr5lvEYHVggXJhdU/nynK8wY1gbw0qR48k731sN5ON4egRCROA==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-gesture@0.0.22:\n    resolution: {integrity: sha512-6G6qrCE0MUTXyjh/powj91XkjRjoFL4HiJLPU5lALXHvGX+/efcUjGYUrHrrw0mwQdmrmg4POqnY/bibns+G3g==}\n\n  rc-image@5.13.0:\n    resolution: {integrity: sha512-iZTOmw5eWo2+gcrJMMcnd7SsxVHl3w5xlyCgsULUdJhJbnuI8i/AL0tVOsE7aLn9VfOh1qgDT3mC2G75/c7mqg==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-input-number@7.3.11:\n    resolution: {integrity: sha512-aMWPEjFeles6PQnMqP5eWpxzsvHm9rh1jQOWXExUEIxhX62Fyl/ptifLHOn17+waDG1T/YUb6flfJbvwRhHrbA==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-input@0.1.4:\n    resolution: {integrity: sha512-FqDdNz+fV2dKNgfXzcSLKvC+jEs1709t7nD+WdfjrdSaOcefpgc7BUJYadc3usaING+b7ediMTfKxuJBsEFbXA==}\n    peerDependencies:\n      react: '>=16.0.0'\n      react-dom: '>=16.0.0'\n\n  rc-mentions@1.13.1:\n    resolution: {integrity: sha512-FCkaWw6JQygtOz0+Vxz/M/NWqrWHB9LwqlY2RtcuFqWJNFK9njijOOzTSsBGANliGufVUzx/xuPHmZPBV0+Hgw==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-menu@9.8.4:\n    resolution: {integrity: sha512-lmw2j8I2fhdIzHmC9ajfImfckt0WDb2KVJJBBRIsxPEw2kGkEfjLMUoB1NgiNT/Q5cC8PdjGOGQjHJIJMwyNMw==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-motion@2.9.4:\n    resolution: {integrity: sha512-TAPUUufDqhPO669qJobI0d9U0XZ/VPNQyZTivUxxzU1EyuPe3PtHSx7Kb902KuzQgu7sS18z8GguaxZEALV/ww==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-notification@4.6.1:\n    resolution: {integrity: sha512-NSmFYwrrdY3+un1GvDAJQw62Xi9LNMSsoQyo95tuaYrcad5Bn9gJUL8AREufRxSQAQnr64u3LtP3EUyLYT6bhw==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-overflow@1.3.2:\n    resolution: {integrity: sha512-nsUm78jkYAoPygDAcGZeC2VwIg/IBGSodtOY3pMof4W3M9qRJgqaDYm03ZayHlde3I6ipliAxbN0RUcGf5KOzw==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-pagination@3.2.0:\n    resolution: {integrity: sha512-5tIXjB670WwwcAJzAqp2J+cOBS9W3cH/WU1EiYwXljuZ4vtZXKlY2Idq8FZrnYBz8KhN3vwPo9CoV/SJS6SL1w==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-picker@2.7.6:\n    resolution: {integrity: sha512-H9if/BUJUZBOhPfWcPeT15JUI3/ntrG9muzERrXDkSoWmDj4yzmBvumozpxYrHwjcKnjyDGAke68d+whWwvhHA==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-progress@3.4.2:\n    resolution: {integrity: sha512-iAGhwWU+tsayP+Jkl9T4+6rHeQTG9kDz8JAHZk4XtQOcYN5fj9H34NXNEdRdZx94VUDHMqCb1yOIvi8eJRh67w==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-rate@2.9.3:\n    resolution: {integrity: sha512-2THssUSnRhtqIouQIIXqsZGzRczvp4WsH4WvGuhiwm+LG2fVpDUJliP9O1zeDOZvYfBE/Bup4SgHun/eCkbjgQ==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-resize-observer@1.4.1:\n    resolution: {integrity: sha512-JbAeFDsaaZRPwaTlXnCqgeO9c6E7qoaE/hxsub08cdnnPn6767c/j9+r/TifUdfvwXtdcfHygKbZ7ecM/PXo/Q==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-segmented@2.3.0:\n    resolution: {integrity: sha512-I3FtM5Smua/ESXutFfb8gJ8ZPcvFR+qUgeeGFQHBOvRiRKyAk4aBE5nfqrxXx+h8/vn60DQjOt6i4RNtrbOobg==}\n    peerDependencies:\n      react: '>=16.0.0'\n      react-dom: '>=16.0.0'\n\n  rc-select@14.1.18:\n    resolution: {integrity: sha512-4JgY3oG2Yz68ECMUSCON7mtxuJvCSj+LJpHEg/AONaaVBxIIrmI/ZTuMJkyojall/X50YdBe5oMKqHHPNiPzEg==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '*'\n      react-dom: '*'\n\n  rc-slider@10.0.1:\n    resolution: {integrity: sha512-igTKF3zBet7oS/3yNiIlmU8KnZ45npmrmHlUUio8PNbIhzMcsh+oE/r2UD42Y6YD2D/s+kzCQkzQrPD6RY435Q==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-slider@8.2.0:\n    resolution: {integrity: sha512-rnO36M3VhMoPWh1kRuCeJoluT4duAW7+5aLaAn9oLu2pKEKsuOFUh5DmA2kEo88UmvPV6nr7HHDeZuC8SNM/lA==}\n\n  rc-steps@5.0.0:\n    resolution: {integrity: sha512-9TgRvnVYirdhbV0C3syJFj9EhCRqoJAsxt4i1rED5o8/ZcSv5TLIYyo4H8MCjLPvbe2R+oBAm/IYBEtC+OS1Rw==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-swipeout@2.0.11:\n    resolution: {integrity: sha512-d37Lgn4RX4OOQyuA2BFo0rGlUwrmZk5q83srH3ixJ1Y1jidr2GKjgJDbNeGUVZPNfYBL91Elu6+xfVGftWf4Lg==}\n\n  rc-switch@3.2.2:\n    resolution: {integrity: sha512-+gUJClsZZzvAHGy1vZfnwySxj+MjLlGRyXKXScrtCTcmiYNPzxDFOxdQ/3pK1Kt/0POvwJ/6ALOR8gwdXGhs+A==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-table@7.26.0:\n    resolution: {integrity: sha512-0cD8e6S+DTGAt5nBZQIPFYEaIukn17sfa5uFL98faHlH/whZzD8ii3dbFL4wmUDEL4BLybhYop+QUfZJ4CPvNQ==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-tabs@12.5.10:\n    resolution: {integrity: sha512-Ay0l0jtd4eXepFH9vWBvinBjqOpqzcsJTerBGwJy435P2S90Uu38q8U/mvc1sxUEVOXX5ZCFbxcWPnfG3dH+tQ==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-textarea@0.4.7:\n    resolution: {integrity: sha512-IQPd1CDI3mnMlkFyzt2O4gQ2lxUsnBAeJEoZGJnkkXgORNqyM9qovdrCj9NzcRfpHgLdzaEbU3AmobNFGUznwQ==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-tooltip@3.7.3:\n    resolution: {integrity: sha512-dE2ibukxxkrde7wH9W8ozHKUO4aQnPZ6qBHtrTH9LoO836PjDdiaWO73fgPB05VfJs9FbZdmGPVEbXCeOP99Ww==}\n\n  rc-tooltip@5.2.2:\n    resolution: {integrity: sha512-jtQzU/18S6EI3lhSGoDYhPqNpWajMtS5VV/ld1LwyfrDByQpYmw/LW6U7oFXXLukjfDHQ7Ju705A82PRNFWYhg==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-tree-select@5.5.5:\n    resolution: {integrity: sha512-k2av7jF6tW9bIO4mQhaVdV4kJ1c54oxV3/hHVU+oD251Gb5JN+m1RbJFTMf1o0rAFqkvto33rxMdpafaGKQRJw==}\n    peerDependencies:\n      react: '*'\n      react-dom: '*'\n\n  rc-tree@5.7.12:\n    resolution: {integrity: sha512-LXA5nY2hG5koIAlHW5sgXgLpOMz+bFRbnZZ+cCg0tQs4Wv1AmY7EDi1SK7iFXhslYockbqUerQan82jljoaItg==}\n    engines: {node: '>=10.x'}\n    peerDependencies:\n      react: '*'\n      react-dom: '*'\n\n  rc-trigger@2.6.5:\n    resolution: {integrity: sha512-m6Cts9hLeZWsTvWnuMm7oElhf+03GOjOLfTuU0QmdB9ZrW7jR2IpI5rpNM7i9MvAAlMAmTx5Zr7g3uu/aMvZAw==}\n\n  rc-trigger@5.3.4:\n    resolution: {integrity: sha512-mQv+vas0TwKcjAO2izNPkqR4j86OemLRmvL2nOzdP9OWNWA1ivoTt5hzFqYNW9zACwmTezRiN8bttrC7cZzYSw==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-upload@4.3.6:\n    resolution: {integrity: sha512-Bt7ESeG5tT3IY82fZcP+s0tQU2xmo1W6P3S8NboUUliquJLQYLkUcsaExi3IlBVr43GQMCjo30RA2o0i70+NjA==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-util@4.21.1:\n    resolution: {integrity: sha512-Z+vlkSQVc1l8O2UjR3WQ+XdWlhj5q9BMQNLk2iOBch75CqPfrJyGtcWMcnhRlNuDu0Ndtt4kLVO8JI8BrABobg==}\n\n  rc-util@5.44.1:\n    resolution: {integrity: sha512-h6z91oGfWJPZgunkFBWSobfL0CkyLeaUNWP1ru7b05GMUSe2uHgTk0EiFEQ11v+zJBrORuXFl6Htf949ZSDdOw==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-virtual-list@3.16.0:\n    resolution: {integrity: sha512-tRpWBC0msU+MxFxnD6+y4v0P17Yzplf+mbiHrqRvfVanx0S4o0XV+2zu4vv7hM9nNfcucO+MPHivqpRT2lfnFQ==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  react-dom@16.14.0:\n    resolution: {integrity: sha512-1gCeQXDLoIqMgqD3IO2Ah9bnf0w9kzhwN5q4FGnHZ67hBm9yePzB5JJAIQCc8x3pFnNlwFq4RidZggNAAkzWWw==}\n    peerDependencies:\n      react: ^16.14.0\n\n  react-dom@17.0.2:\n    resolution: {integrity: sha512-s4h96KtLDUQlsENhMn1ar8t2bEa+q/YAtj8pPPdIjPDGBDIVNsrD9aXNWqspUe6AzKCIG0C1HZZLqLV7qpOBGA==}\n    peerDependencies:\n      react: 17.0.2\n\n  react-fast-compare@3.2.2:\n    resolution: {integrity: sha512-nsO+KSNgo1SbJqJEYRE9ERzo7YtYbou/OqjSQKxV7jcKox7+usiUVZOAC+XnDOABXggQTno0Y1CpVnuWEc1boQ==}\n\n  react-helmet@6.1.0:\n    resolution: {integrity: sha512-4uMzEY9nlDlgxr61NL3XbKRy1hEkXmKNXhjbAIOVw5vcFrsdYbH2FEwcNyWvWinl103nXgzYNlns9ca+8kFiWw==}\n    peerDependencies:\n      react: '>=16.3.0'\n\n  react-intl@3.12.1:\n    resolution: {integrity: sha512-cgumW29mwROIqyp8NXStYsoIm27+8FqnxykiLSawWjOxGIBeLuN/+p2srei5SRIumcJefOkOIHP+NDck05RgHg==}\n    peerDependencies:\n      react: ^16.3.0\n\n  react-is@16.13.1:\n    resolution: {integrity: sha512-24e6ynE2H+OKt4kqsOvNd8kBpV65zoxbA4BVsEOB3ARVWQki/DHzaUoC5KuON/BiccDaCCTZBuOcfZs70kR8bQ==}\n\n  react-is@17.0.2:\n    resolution: {integrity: sha512-w2GsyukL62IJnlaff/nRegPQR94C/XXamvMWmSHRJ4y7Ts/4ocGRmTHvOs8PSE6pB3dWOrD/nueuU5sduBsQ4w==}\n\n  react-is@18.3.1:\n    resolution: {integrity: sha512-/LLMVyas0ljjAtoYiPqYiL8VWXzUUdThrmU5+n20DZv+a+ClRoevUzw5JxU+Ieh5/c87ytoTBV9G1FiKfNJdmg==}\n\n  react-lifecycles-compat@3.0.4:\n    resolution: {integrity: sha512-fBASbA6LnOU9dOU2eW7aQ8xmYBSXUIWr+UmF9b1efZBazGNO+rcXT/icdKnYm2pTwcRylVUYwW7H1PHfLekVzA==}\n\n  react-native-swipeout@2.3.6:\n    resolution: {integrity: sha512-t9suUCspzck4vp2pWggWe0frS/QOtX6yYCawHnEes75A7dZCEE74bxX2A1bQzGH9cUMjq6xsdfC94RbiDKIkJg==}\n    deprecated: Package no longer supported. Use at your own risk or consider using https://github.com/software-mansion/react-native-gesture-handler\n\n  react-redux@7.2.9:\n    resolution: {integrity: sha512-Gx4L3uM182jEEayZfRbI/G11ZpYdNAnBs70lFVMNdHJI76XYtR+7m0MN+eAs7UHBPhWXcnFPaS+9owSCJQHNpQ==}\n    peerDependencies:\n      react: ^16.8.3 || ^17 || ^18\n      react-dom: '*'\n      react-native: '*'\n    peerDependenciesMeta:\n      react-dom:\n        optional: true\n      react-native:\n        optional: true\n\n  react-refresh@0.10.0:\n    resolution: {integrity: sha512-PgidR3wST3dDYKr6b4pJoqQFpPGNKDSCDx4cZoshjXipw3LzO7mG1My2pwEzz2JVkF+inx3xRpDeQLFQGH/hsQ==}\n    engines: {node: '>=0.10.0'}\n\n  react-router-config@5.1.1:\n    resolution: {integrity: sha512-DuanZjaD8mQp1ppHjgnnUnyOlqYXZVjnov/JzFhjLEwd3Z4dYjMSnqrEzzGThH47vpCOqPPwJM2FtthLeJ8Pbg==}\n    peerDependencies:\n      react: '>=15'\n      react-router: '>=5'\n\n  react-router-dom@5.2.0:\n    resolution: {integrity: sha512-gxAmfylo2QUjcwxI63RhQ5G85Qqt4voZpUXSEqCwykV0baaOTQDR1f0PmY8AELqIyVc0NEZUj0Gov5lNGcXgsA==}\n    peerDependencies:\n      react: '>=15'\n\n  react-router-dom@5.3.4:\n    resolution: {integrity: sha512-m4EqFMHv/Ih4kpcBCONHbkT68KoAeHN4p3lAGoNryfHi0dMy0kCzEZakiKRsvg5wHZ/JLrLW8o8KomWiz/qbYQ==}\n    peerDependencies:\n      react: '>=15'\n\n  react-router@5.2.0:\n    resolution: {integrity: sha512-smz1DUuFHRKdcJC0jobGo8cVbhO3x50tCL4icacOlcwDOEQPq4TMqwx3sY1TP+DvtTgz4nm3thuo7A+BK2U0Dw==}\n    peerDependencies:\n      react: '>=15'\n\n  react-router@5.3.4:\n    resolution: {integrity: sha512-Ys9K+ppnJah3QuaRiLxk+jDWOR1MekYQrlytiXxC1RyfbdsZkS5pvKAzCCr031xHixZwpnsYNT5xysdFHQaYsA==}\n    peerDependencies:\n      react: '>=15'\n\n  react-side-effect@2.1.2:\n    resolution: {integrity: sha512-PVjOcvVOyIILrYoyGEpDN3vmYNLdy1CajSFNt4TDsVQC5KpTijDvWVoR+/7Rz2xT978D8/ZtFceXxzsPwZEDvw==}\n    peerDependencies:\n      react: ^16.3.0 || ^17.0.0 || ^18.0.0\n\n  react-sortable-hoc@2.0.0:\n    resolution: {integrity: sha512-JZUw7hBsAHXK7PTyErJyI7SopSBFRcFHDjWW5SWjcugY0i6iH7f+eJkY8cJmGMlZ1C9xz1J3Vjz0plFpavVeRg==}\n    peerDependencies:\n      prop-types: ^15.5.7\n      react: ^16.3.0 || ^17.0.0\n      react-dom: ^16.3.0 || ^17.0.0\n\n  react-tween-state@0.1.5:\n    resolution: {integrity: sha512-sJQpjsdn0wjlDIUpfpb7jQGnOG8hAEW2e8k0KPA+xmf5KFa6Xat2JldbmxBhaqP0S/uIXhVE5ymKyH/b9X8nYA==}\n\n  react@16.14.0:\n    resolution: {integrity: sha512-0X2CImDkJGApiAlcf0ODKIneSwBPhqJawOa5wCtKbu7ZECrmS26NvtSILynQ66cgkT/RJ4LidJOc3bUESwmU8g==}\n    engines: {node: '>=0.10.0'}\n\n  react@17.0.2:\n    resolution: {integrity: sha512-gnhPt75i/dq/z3/6q/0asP78D0u592D5L1pd7M8P+dck6Fu/jJeL6iVVK23fptSUZj8Vjf++7wXA8UNclGQcbA==}\n    engines: {node: '>=0.10.0'}\n\n  read-pkg-up@7.0.1:\n    resolution: {integrity: sha512-zK0TB7Xd6JpCLmlLmufqykGE+/TlOePD6qKClNW7hHDKFh/J7/7gCWGR7joEQEW1bKq3a3yUZSObOoWLFQ4ohg==}\n    engines: {node: '>=8'}\n\n  read-pkg@5.2.0:\n    resolution: {integrity: sha512-Ug69mNOpfvKDAc2Q8DRpMjjzdtrnv9HcSMX+4VsZxD1aZ6ZzrIE7rlzXBtWTyhULSMKg076AW6WR5iZpD0JiOg==}\n    engines: {node: '>=8'}\n\n  readable-stream@2.3.8:\n    resolution: {integrity: sha512-8p0AUk4XODgIewSi0l8Epjs+EVnWiK7NoDIEGU0HhE7+ZyY8D1IMY7odu5lRrFXGg71L15KG8QrPmum45RTtdA==}\n\n  readdirp@3.5.0:\n    resolution: {integrity: sha512-cMhu7c/8rdhkHXWsY+osBhfSy0JikwpHK/5+imo+LpeasTF8ouErHrlYkwT0++njiyuDvc7OFY5T3ukvZ8qmFQ==}\n    engines: {node: '>=8.10.0'}\n\n  redbox-react@1.6.0:\n    resolution: {integrity: sha512-mLjM5eYR41yOp5YKHpd3syFeGq6B4Wj5vZr64nbLvTZW5ZLff4LYk7VE4ITpVxkZpCY6OZuqh0HiP3A3uEaCpg==}\n    peerDependencies:\n      react: ^0.14.0 || ^15.0.0 || ^16.0.0-beta || ^16.0.0\n      react-dom: ^0.14.0 || ^15.0.0 || ^16.0.0-beta || ^16.0.0\n\n  redux-saga@0.16.2:\n    resolution: {integrity: sha512-iIjKnRThI5sKPEASpUvySemjzwqwI13e3qP7oLub+FycCRDysLSAOwt958niZW6LhxfmS6Qm1BzbU70w/Koc4w==}\n\n  redux@4.2.1:\n    resolution: {integrity: sha512-LAUYz4lc+Do8/g7aeRa8JkyDErK6ekstQaqWQrNRW//MY1TvCEpMtpTWvlQ+FPbWCx+Xixu/6SHt5N0HR+SB4w==}\n\n  regenerate-unicode-properties@10.0.1:\n    resolution: {integrity: sha512-vn5DU6yg6h8hP/2OkQo3K7uVILvY4iu0oI4t3HFa81UPkhGJwkRwM10JEc3upjdhHjs/k8GJY1sRBhk5sr69Bw==}\n    engines: {node: '>=4'}\n\n  regenerate@1.4.2:\n    resolution: {integrity: sha512-zrceR/XhGYU/d/opr2EKO7aRHUeiBI8qjtfHqADTwZd6Szfy16la6kqD0MIUs5z5hx6AaKa+PixpPrR289+I0A==}\n\n  regenerator-runtime@0.11.1:\n    resolution: {integrity: sha512-MguG95oij0fC3QV3URf4V2SDYGJhJnJGqvIIgdECeODCT98wSWDAJ94SSuVpYQUoTcGUIL6L4yNB7j1DFFHSBg==}\n\n  regenerator-runtime@0.13.11:\n    resolution: {integrity: sha512-kY1AZVr2Ra+t+piVaJ4gxaFaReZVH40AKNo7UCX6W+dEwBo/2oZJzqfuN1qLq1oL45o56cPaTXELwrTh8Fpggg==}\n\n  regenerator-runtime@0.13.5:\n    resolution: {integrity: sha512-ZS5w8CpKFinUzOwW3c83oPeVXoNsrLsaCoLtJvAClH135j/R77RuymhiSErhm2lKcwSCIpmvIWSbDkIfAqKQlA==}\n\n  regenerator-runtime@0.14.1:\n    resolution: {integrity: sha512-dYnhHh0nJoMfnkZs6GmmhFknAGRrLznOu5nc9ML+EJxGvrx6H7teuevqVqCuPcPK//3eDrrjQhehXVx9cnkGdw==}\n\n  regex-not@1.0.2:\n    resolution: {integrity: sha512-J6SDjUgDxQj5NusnOtdFxDwN/+HWykR8GELwctJ7mdqhcyy1xEc4SRFHUXvxTp661YaVKAjfRLZ9cCqS6tn32A==}\n    engines: {node: '>=0.10.0'}\n\n  remove-trailing-separator@1.1.0:\n    resolution: {integrity: sha512-/hS+Y0u3aOfIETiaiirUFwDBDzmXPvO+jAfKTitUngIPzdKc6Z0LoFjM/CK5PL4C+eKwHohlHAb6H0VFfmmUsw==}\n\n  repeat-element@1.1.4:\n    resolution: {integrity: sha512-LFiNfRcSu7KK3evMyYOuCzv3L10TW7yC1G2/+StMjK8Y6Vqd2MG7r/Qjw4ghtuCOjFvlnms/iMmLqpvW/ES/WQ==}\n    engines: {node: '>=0.10.0'}\n\n  repeat-string@1.6.1:\n    resolution: {integrity: sha512-PV0dzCYDNfRi1jCDbJzpW7jNNDRuCOG/jI5ctQcGKt/clZD+YcPS3yIlWuTJMmESC8aevCFmWJy5wjAFgNqN6w==}\n    engines: {node: '>=0.10'}\n\n  require-directory@2.1.1:\n    resolution: {integrity: sha512-fGxEI7+wsG9xrvdjsrlmL22OMTTiHRwAMroiEeMgq8gzoLC/PQr7RsRDSTLUg/bZAZtF+TVIkHc6/4RIKrui+Q==}\n    engines: {node: '>=0.10.0'}\n\n  require-main-filename@2.0.0:\n    resolution: {integrity: sha512-NKN5kMDylKuldxYLSUfrbo5Tuzh4hd+2E8NPPX02mZtn1VuREQToYe/ZdlJy+J3uCpfaiGF05e7B8W0iXbQHmg==}\n\n  requires-port@1.0.0:\n    resolution: {integrity: sha512-KigOCHcocU3XODJxsu8i/j8T9tzT4adHiecwORRQ0ZZFcp7ahwXuRU1m+yuO90C5ZUyGeGfocHDI14M3L3yDAQ==}\n\n  resize-observer-polyfill@1.5.1:\n    resolution: {integrity: sha512-LwZrotdHOo12nQuZlHEmtuXdqGoOD0OhaxopaNFxWzInpEgaLWoVuAMbTzixuosCx2nEG58ngzW3vxdWoxIgdg==}\n\n  resolve-cwd@3.0.0:\n    resolution: {integrity: sha512-OrZaX2Mb+rJCpH/6CpSqt9xFVpN++x01XnN2ie9g6P5/3xelLAkXWVADpdz1IHD/KFfEXyE6V0U01OQ3UO2rEg==}\n    engines: {node: '>=8'}\n\n  resolve-from@3.0.0:\n    resolution: {integrity: sha512-GnlH6vxLymXJNMBo7XP1fJIzBFbdYt49CuTwmB/6N53t+kMPRMFKz783LlQ4tv28XoQfMWinAJX6WCGf2IlaIw==}\n    engines: {node: '>=4'}\n\n  resolve-from@4.0.0:\n    resolution: {integrity: sha512-pb/MYmXstAkysRFx8piNI1tGFNQIFA3vkE3Gq4EuA1dF6gHp/+vgZqsCGJapvy8N3Q+4o7FwvquPJcnZ7RYy4g==}\n    engines: {node: '>=4'}\n\n  resolve-from@5.0.0:\n    resolution: {integrity: sha512-qYg9KP24dD5qka9J47d0aVky0N+b4fTU89LN9iDnjB5waksiC49rvMB0PrUJQGoTmH50XPiqOvAjDfaijGxYZw==}\n    engines: {node: '>=8'}\n\n  resolve-pathname@3.0.0:\n    resolution: {integrity: sha512-C7rARubxI8bXFNB/hqcp/4iUeIXJhJZvFPFPiSPRnhU5UPxzMFIl+2E6yY6c4k9giDJAhtV+enfA+G89N6Csng==}\n\n  resolve-url@0.2.1:\n    resolution: {integrity: sha512-ZuF55hVUQaaczgOIwqWzkEcEidmlD/xl44x1UZnhOXcYuFN2S6+rcxpG+C1N3So0wvNI3DmJICUFfu2SxhBmvg==}\n    deprecated: https://github.com/lydell/resolve-url#deprecated\n\n  resolve@1.22.8:\n    resolution: {integrity: sha512-oKWePCxqpd6FlLvGV1VU0x7bkPmmCNolxzjMf4NczoDnQcIWrAF+cPtZn5i6n+RfD2d9i0tzpKnG6Yk168yIyw==}\n    hasBin: true\n\n  restore-cursor@3.1.0:\n    resolution: {integrity: sha512-l+sSefzHpj5qimhFSE5a8nufZYAM3sBSVMAPtYkmC+4EH2anSGaEMXSD0izRQbu9nfyQ9y5JrVmp7E8oZrUjvA==}\n    engines: {node: '>=8'}\n\n  ret@0.1.15:\n    resolution: {integrity: sha512-TTlYpa+OL+vMMNG24xSlQGEJ3B/RzEfUlLct7b5G/ytav+wPrplCpVMFuwzXbkecJrb6IYo1iFb0S9v37754mg==}\n    engines: {node: '>=0.12'}\n\n  rfdc@1.4.1:\n    resolution: {integrity: sha512-q1b3N5QkRUWUl7iyylaaj3kOpIT0N2i9MqIEQXP73GVsN9cw3fdx8X63cEmWhJGi2PPCF23Ijp7ktmd39rawIA==}\n\n  rimraf@3.0.2:\n    resolution: {integrity: sha512-JZkJMZkAGFFPP2YqXZXPbMlMBgsxzE8ILs4lMIX/2o0L9UBw9O/Y3o6wFw/i9YLapcUJWwqbi3kdxIPdC62TIA==}\n    deprecated: Rimraf versions prior to v4 are no longer supported\n    hasBin: true\n\n  ripemd160@2.0.2:\n    resolution: {integrity: sha512-ii4iagi25WusVoiC4B4lq7pbXfAp3D9v5CwfkY33vffw2+pkDjY1D8GaN7spsxvCSx8dkPqOZCEZyfxcmJG2IA==}\n\n  rmc-align@1.0.0:\n    resolution: {integrity: sha512-3gEa5/+hqqoEVoeQ25KoRc8DOsXIdSaVpaBq1zQFaV941LR3xvZIRTlxTDT/IagYwoGM1KZea/jd7cNMYP34Rg==}\n\n  rmc-calendar@1.1.4:\n    resolution: {integrity: sha512-xxQZaPFDnpHt4IFO8mukYrXSgC1W8LcNVp+EoX4iyeOJFimungOKB/iP5/cy+st8yXq8lUgk9TXsHNtM6Xo6ZA==}\n\n  rmc-cascader@5.0.3:\n    resolution: {integrity: sha512-PxDhMjWViDdG4SMZqoXtAthGwgDyYnyxxZEE17IDDYsiCHpWtOhoIL8nsI+/hZ212UT/XF2LpqCsOlMoJiYk+w==}\n\n  rmc-date-picker@6.0.10:\n    resolution: {integrity: sha512-/9+I6lm3EDEl6M7862V6++zFuxwsM0UEq8wSHbotYIPPmyB/65gx1cviblghOv2QfB0O9+U2w3qEJlRP/WsMrA==}\n\n  rmc-dialog@1.1.1:\n    resolution: {integrity: sha512-28aJqtPTX6v13Z/aU1WBy1AFIXkE74PxZXde7JvtEIy9hQDTjH8fqOi822BpzAbXCyNE7jF9iFomy3H2ClsDJA==}\n\n  rmc-drawer@0.4.11:\n    resolution: {integrity: sha512-YfB9XEJ8iM0MMuLWAK4313uOxSM8NAljC8Cqun1KamXutglYTuRviUuTLNSOzV8HHPp5kNpsVduvPCGLWXvThw==}\n    engines: {node: '>=4.0.0'}\n\n  rmc-feedback@2.0.0:\n    resolution: {integrity: sha512-5PWOGOW7VXks/l3JzlOU9NIxRpuaSS8d9zA3UULUCuTKnpwBHNvv1jSJzxgbbCQeYzROWUpgKI4za3X4C/mKmQ==}\n\n  rmc-input-number@1.0.5:\n    resolution: {integrity: sha512-prPkEtoOVde77GnEnEaBeWjBobMOPgGqU5bd0gxfp1kt1pUN740mMpVAcH7uxpJjVfmw+kuGWtiz4S7CueagSg==}\n\n  rmc-list-view@0.11.5:\n    resolution: {integrity: sha512-eMOC5394tLNawcdEEhF7boMpQgpjJGDdL5lS+LblAWdBec7Q4EYkUdnrKNbt+O9k5RGM6nSLAGZK5oB4FN85Lg==}\n\n  rmc-notification@1.0.0:\n    resolution: {integrity: sha512-9sPxjltFvtRLt2v312Hu7OXwk53pHkBYgINRDmnJ3A5NF1qtJeCCcdN0Xr0fzJ6sbQvtGju822tWHdzYA9u7Vw==}\n\n  rmc-nuka-carousel@3.0.1:\n    resolution: {integrity: sha512-w2EPTERMUUZqcUSKFuejjin7xsMlhrLrtS0A/igTXpFJGq3kemDKcRi7q3pSYDuZBHYBl5iV4UqsLLkjdFtrYA==}\n\n  rmc-picker@5.0.10:\n    resolution: {integrity: sha512-KZ70+WjcaZHnG5GyCxWCPFWAZ12s6NqyrbW73LeqH0WEqaTMMs0sOrk2f4mQAZ/CGT0XcFN6VZLw7Ozoxfn7LA==}\n\n  rmc-pull-to-refresh@1.0.13:\n    resolution: {integrity: sha512-iYLsURiR7G/sKmRA6p2kq6ZXicn7Hyeo6VQFljssV1eMW+fzDgihhaz0kv5mza0f88vphGJvjOihT9E6+xGb6Q==}\n\n  rmc-steps@1.0.1:\n    resolution: {integrity: sha512-8ijtwp4D1CYTtI2yerXJYqCv+GQbiBc9T12nrFngd/vM0y+58CnznGphTAueF6IWf7qbxBwcjTrcFgg7bP2YGA==}\n\n  rmc-tabs@1.2.29:\n    resolution: {integrity: sha512-wiJS9WSJi9JH9GQO+FqncX+zaHP31qHa/S8nDW9UXUx0qbCX294QcJEnvfB+WmsfUws7rXjs6sOQp5EDiObnHg==}\n\n  rmc-tooltip@1.0.1:\n    resolution: {integrity: sha512-fSDArf2BlMVrHExmBiqb2TkCRJHshvXFJQ/7tMraLellwaJLNiwrxtWpW329k3S+zTtoVG8UxFS1TjBGEsMzRg==}\n\n  rmc-trigger@1.0.12:\n    resolution: {integrity: sha512-AccQniX7PX7Pm8hBhHEsnf3JU6CA61Xc7fAt2WbO+oXrGaI/jqN8C3COhhOXG54S5iTOjLS26j858zshwAxR9A==}\n\n  rsvp@4.8.5:\n    resolution: {integrity: sha512-nfMOlASu9OnRJo1mbEk2cz0D56a1MBNrJ7orjRZQG10XDyuvwksKbuXNp6qa+kbn839HwjwhBzhFmdsaEAfauA==}\n    engines: {node: 6.* || >= 7.*}\n\n  rxjs@7.8.1:\n    resolution: {integrity: sha512-AA3TVj+0A2iuIoQkWEK/tqFjBq2j+6PO6Y0zJcvzLAFhEFIO3HL0vls9hWLncZbAAbK0mar7oZ4V079I/qPMxg==}\n\n  safe-buffer@5.1.2:\n    resolution: {integrity: sha512-Gd2UZBJDkXlY7GbJxfsE8/nvKkUEU1G38c1siN6QP6a9PT9MmHB8GnpscSmMJSoF8LOIrt8ud/wPtojys4G6+g==}\n\n  safe-buffer@5.2.1:\n    resolution: {integrity: sha512-rp3So07KcdmmKbGvgaNxQSJr7bGVSVk5S9Eq1F+ppbRo70+YeaDxkw5Dd8NPN+GD6bjnYm2VuPuCXmpuYvmCXQ==}\n\n  safe-regex@1.1.0:\n    resolution: {integrity: sha512-aJXcif4xnaNUzvUuC5gcb46oTS7zvg4jpMTnuqtrEPlR3vFr4pxtdTwaF1Qs3Enjn9HK+ZlwQui+a7z0SywIzg==}\n\n  safer-buffer@2.1.2:\n    resolution: {integrity: sha512-YZo3K82SD7Riyi0E1EQPojLz7kpepnSQI9IyPbHHg1XXXevb5dJI7tpyN2ADxGcQbHG7vcyRHk0cbwqcQriUtg==}\n\n  sane@4.1.0:\n    resolution: {integrity: sha512-hhbzAgTIX8O7SHfp2c8/kREfEn4qO/9q8C9beyY6+tvZ87EpoZ3i1RIEvp27YBswnNbY9mWd6paKVmKbAgLfZA==}\n    engines: {node: 6.* || 8.* || >= 10.*}\n    deprecated: some dependency vulnerabilities fixed, support for node < 10 dropped, and newer ECMAScript syntax/features added\n    hasBin: true\n\n  saxes@5.0.1:\n    resolution: {integrity: sha512-5LBh1Tls8c9xgGjw3QrMwETmTMVk0oFgvrFSvWx62llR2hcEInrKNZ2GZCCuuy2lvWrdl5jhbpeqc5hRYKFOcw==}\n    engines: {node: '>=10'}\n\n  scheduler@0.19.1:\n    resolution: {integrity: sha512-n/zwRWRYSUj0/3g/otKDRPMh6qv2SYMWNq85IEa8iZyAv8od9zDYpGSnpBEjNgcMNq6Scbu5KfIPxNF72R/2EA==}\n\n  scheduler@0.20.2:\n    resolution: {integrity: sha512-2eWfGgAqqWFGqtdMmcL5zCMK1U8KlXv8SQFGglL3CEtd0aDVDWgeF/YoCmvln55m5zSk3J/20hTaSBeSObsQDQ==}\n\n  schema-utils@1.0.0:\n    resolution: {integrity: sha512-i27Mic4KovM/lnGsy8whRCHhc7VicJajAjTrYg11K9zfZXnYIt4k5F+kZkwjnrhKzLic/HLU4j11mjsz2G/75g==}\n    engines: {node: '>= 4'}\n\n  schema-utils@3.3.0:\n    resolution: {integrity: sha512-pN/yOAvcC+5rQ5nERGuwrjLlYvLTbCibnZ1I7B1LaiAz9BRBlE9GMgE/eqV30P7aJQUf7Ddimy/RsbYO/GrVGg==}\n    engines: {node: '>= 10.13.0'}\n\n  scroll-into-view-if-needed@2.2.31:\n    resolution: {integrity: sha512-dGCXy99wZQivjmjIqihaBQNjryrz5rueJY7eHfTdyWEiR4ttYpsajb14rn9s5d4DY4EcY6+4+U/maARBXJedkA==}\n\n  seamless-immutable@7.1.4:\n    resolution: {integrity: sha512-XiUO1QP4ki4E2PHegiGAlu6r82o5A+6tRh7IkGGTVg/h+UoeX4nFBeCGPOhb4CYjvkqsfm/TUtvOMYC1xmV30A==}\n\n  semver-compare@1.0.0:\n    resolution: {integrity: sha512-YM3/ITh2MJ5MtzaM429anh+x2jiLVjqILF4m4oyQB18W7Ggea7BfqdH/wGMK7dDiMghv/6WG7znWMwUDzJiXow==}\n\n  semver@5.7.2:\n    resolution: {integrity: sha512-cBznnQ9KjJqU67B52RMC65CMarK2600WFnbkcaiwWq3xy/5haFJlshgnpjovMVJ+Hff49d8GEn0b87C5pDQ10g==}\n    hasBin: true\n\n  semver@6.3.1:\n    resolution: {integrity: sha512-BR7VvDCVHO+q2xBEWskxS6DJE1qRnb7DxzUrogb71CWoSficBxYsiAGd+Kl0mmq/MprG9yArRkyrQxTO6XjMzA==}\n    hasBin: true\n\n  semver@7.6.3:\n    resolution: {integrity: sha512-oVekP1cKtI+CTDvHWYFUcMtsK/00wmAEfyqKfNdARm8u1wNVhSgaX7A8d4UuIlUI5e84iEwOhs7ZPYRmzU9U6A==}\n    engines: {node: '>=10'}\n    hasBin: true\n\n  set-blocking@2.0.0:\n    resolution: {integrity: sha512-KiKBS8AnWGEyLzofFfmvKwpdPzqiy16LvQfK3yv/fVH7Bj13/wl3JSR1J+rfgRE9q7xUJK4qvgS8raSOeLUehw==}\n\n  set-function-length@1.2.2:\n    resolution: {integrity: sha512-pgRc4hJ4/sNjWCSS9AmnS40x3bNMDTknHgL5UaMBTMyJnU90EgWh1Rz+MC9eFu4BuN/UwZjKQuY/1v3rM7HMfg==}\n    engines: {node: '>= 0.4'}\n\n  set-value@2.0.1:\n    resolution: {integrity: sha512-JxHc1weCN68wRY0fhCoXpyK55m/XPHafOmK4UWD7m2CI14GMcFypt4w/0+NV5f/ZMby2F6S2wwA7fgynh9gWSw==}\n    engines: {node: '>=0.10.0'}\n\n  setimmediate@1.0.5:\n    resolution: {integrity: sha512-MATJdZp8sLqDl/68LfQmbP8zKPLQNV6BIZoIgrscFDQ+RsvK/BxeDQOgyxKKoh0y/8h3BqVFnCqQ/gd+reiIXA==}\n\n  sha.js@2.4.11:\n    resolution: {integrity: sha512-QMEp5B7cftE7APOjk5Y6xgrbWu+WkLVQwk8JNjZ8nKRciZaByEW6MubieAiToS7+dwvrjGhH8jRXz3MVd0AYqQ==}\n    hasBin: true\n\n  shallow-equal@1.2.1:\n    resolution: {integrity: sha512-S4vJDjHHMBaiZuT9NPb616CSmLf618jawtv3sufLl6ivK8WocjAo58cXwbRV1cgqxH0Qbv+iUt6m05eqEa2IRA==}\n\n  shallowequal@1.1.0:\n    resolution: {integrity: sha512-y0m1JoUZSlPAjXVtPPW70aZWfIL/dSP7AFkRnniLCrK/8MDKog3TySTBmckD+RObVxH0v4Tox67+F14PdED2oQ==}\n\n  shebang-command@1.2.0:\n    resolution: {integrity: sha512-EV3L1+UQWGor21OmnvojK36mhg+TyIKDh3iFBKBohr5xeXIhNBcx8oWdgkTEEQ+BEFFYdLRuqMfd5L84N1V5Vg==}\n    engines: {node: '>=0.10.0'}\n\n  shebang-command@2.0.0:\n    resolution: {integrity: sha512-kHxr2zZpYtdmrN1qDjrrX/Z1rR1kG8Dx+gkpK1G4eXmvXswmcE1hTWBWYUzlraYw1/yZp6YuDY77YtvbN0dmDA==}\n    engines: {node: '>=8'}\n\n  shebang-regex@1.0.0:\n    resolution: {integrity: sha512-wpoSFAxys6b2a2wHZ1XpDSgD7N9iVjg29Ph9uV/uaP9Ex/KXlkTZTeddxDPSYQpgvzKLGJke2UU0AzoGCjNIvQ==}\n    engines: {node: '>=0.10.0'}\n\n  shebang-regex@3.0.0:\n    resolution: {integrity: sha512-7++dFhtcx3353uBaq8DDR4NuxBetBzC7ZQOhmTQInHEd6bSrXdiEyzCvG07Z44UYdLShWUyXt5M/yhz8ekcb1A==}\n    engines: {node: '>=8'}\n\n  shellwords@0.1.1:\n    resolution: {integrity: sha512-vFwSUfQvqybiICwZY5+DAWIPLKsWO31Q91JSKl3UYv+K5c2QRPzn0qzec6QPu1Qc9eHYItiP3NdJqNVqetYAww==}\n\n  side-channel-list@1.0.0:\n    resolution: {integrity: sha512-FCLHtRD/gnpCiCHEiJLOwdmFP+wzCmDEkc9y7NsYxeF4u7Btsn1ZuwgwJGxImImHicJArLP4R0yX4c2KCrMrTA==}\n    engines: {node: '>= 0.4'}\n\n  side-channel-map@1.0.1:\n    resolution: {integrity: sha512-VCjCNfgMsby3tTdo02nbjtM/ewra6jPHmpThenkTYh8pG9ucZ/1P8So4u4FGBek/BjpOVsDCMoLA/iuBKIFXRA==}\n    engines: {node: '>= 0.4'}\n\n  side-channel-weakmap@1.0.2:\n    resolution: {integrity: sha512-WPS/HvHQTYnHisLo9McqBHOJk2FkHO/tlpvldyrnem4aeQp4hai3gythswg6p01oSoTl58rcpiFAjF2br2Ak2A==}\n    engines: {node: '>= 0.4'}\n\n  side-channel@1.1.0:\n    resolution: {integrity: sha512-ZX99e6tRweoUXqR+VBrslhda51Nh5MTQwou5tnUDgbtyM0dBgmhEDtWGP/xbKn6hqfPRHujUNwz5fy/wbbhnpw==}\n    engines: {node: '>= 0.4'}\n\n  signal-exit@3.0.7:\n    resolution: {integrity: sha512-wnD2ZE+l+SPC/uoS0vXeE9L1+0wuaMqKlfz9AMUo38JsyLSBWSFcHR1Rri62LZc12vLr1gb3jl7iwQhgwpAbGQ==}\n\n  sisteransi@1.0.5:\n    resolution: {integrity: sha512-bLGGlR1QxBcynn2d5YmDX4MGjlZvy2MRBDRNHLJ8VI6l6+9FUiyTFNJ0IveOSP0bcXgVDPRcfGqA0pjaqUpfVg==}\n\n  slash@3.0.0:\n    resolution: {integrity: sha512-g9Q1haeby36OSStwb4ntCGGGaKsaVSjQ68fBxoQcutl5fS1vuY18H3wSt3jFyFtrkx+Kz0V1G85A4MyAdDMi2Q==}\n    engines: {node: '>=8'}\n\n  slice-ansi@3.0.0:\n    resolution: {integrity: sha512-pSyv7bSTC7ig9Dcgbw9AuRNUb5k5V6oDudjZoMBSr13qpLBG7tB+zgCkARjq7xIUgdz5P1Qe8u+rSGdouOOIyQ==}\n    engines: {node: '>=8'}\n\n  slice-ansi@4.0.0:\n    resolution: {integrity: sha512-qMCMfhY040cVHT43K9BFygqYbUPFZKHOg7K73mtTWJRb8pyP3fzf4Ixd5SzdEJQ6MRUg/WBnOLxghZtKKurENQ==}\n    engines: {node: '>=10'}\n\n  snapdragon-node@2.1.1:\n    resolution: {integrity: sha512-O27l4xaMYt/RSQ5TR3vpWCAB5Kb/czIcqUFOM/C4fYcLnbZUc1PkjTAMjof2pBWaSTwOUd6qUHcFGVGj7aIwnw==}\n    engines: {node: '>=0.10.0'}\n\n  snapdragon-util@3.0.1:\n    resolution: {integrity: sha512-mbKkMdQKsjX4BAL4bRYTj21edOf8cN7XHdYUJEe+Zn99hVEYcMvKPct1IqNe7+AZPirn8BCDOQBHQZknqmKlZQ==}\n    engines: {node: '>=0.10.0'}\n\n  snapdragon@0.8.2:\n    resolution: {integrity: sha512-FtyOnWN/wCHTVXOMwvSv26d+ko5vWlIDD6zoUJ7LW8vh+ZBC8QdljveRP+crNrtBwioEUWy/4dMtbBjA4ioNlg==}\n    engines: {node: '>=0.10.0'}\n\n  sort-keys@1.1.2:\n    resolution: {integrity: sha512-vzn8aSqKgytVik0iwdBEi+zevbTYZogewTUM6dtpmGwEcdzbub/TX4bCzRhebDCRC3QzXgJsLRKB2V/Oof7HXg==}\n    engines: {node: '>=0.10.0'}\n\n  source-map-resolve@0.5.3:\n    resolution: {integrity: sha512-Htz+RnsXWk5+P2slx5Jh3Q66vhQj1Cllm0zvnaY98+NFx+Dv2CF/f5O/t8x+KaNdrdIAsruNzoh/KpialbqAnw==}\n    deprecated: See https://github.com/lydell/source-map-resolve#deprecated\n\n  source-map-support@0.5.21:\n    resolution: {integrity: sha512-uBHU3L3czsIyYXKX88fdrGovxdSCoTGDRZ6SYXtSRxLZUzHg5P/66Ht6uoUlHu9EZod+inXhKo3qQgwXUT/y1w==}\n\n  source-map-url@0.4.1:\n    resolution: {integrity: sha512-cPiFOTLUKvJFIg4SKVScy4ilPPW6rFgMgfuZJPNoDuMs3nC1HbMUycBoJw77xFIp6z1UJQJOfx6C9GMH80DiTw==}\n    deprecated: See https://github.com/lydell/source-map-url#deprecated\n\n  source-map@0.5.6:\n    resolution: {integrity: sha512-MjZkVp0NHr5+TPihLcadqnlVoGIoWo4IBHptutGh9wI3ttUYvCG26HkSuDi+K6lsZ25syXJXcctwgyVCt//xqA==}\n    engines: {node: '>=0.10.0'}\n\n  source-map@0.5.7:\n    resolution: {integrity: sha512-LbrmJOMUSdEVxIKvdcJzQC+nQhe8FUZQTXQy6+I75skNgn3OoQ0DZA8YnFa7gp8tqtL3KPf1kmo0R5DoApeSGQ==}\n    engines: {node: '>=0.10.0'}\n\n  source-map@0.6.1:\n    resolution: {integrity: sha512-UjgapumWlbMhkBgzT7Ykc5YXUT46F0iKu8SGXq0bcwP5dz/h0Plj6enJqjz1Zbq2l5WaqYnrVbwWOWMyF3F47g==}\n    engines: {node: '>=0.10.0'}\n\n  source-map@0.7.4:\n    resolution: {integrity: sha512-l3BikUxvPOcn5E74dZiq5BGsTb5yEwhaTSzccU6t4sDOH8NWJCstKO5QT2CvtFoK6F0saL7p9xHAqHOlCPJygA==}\n    engines: {node: '>= 8'}\n\n  sourcemapped-stacktrace@1.1.11:\n    resolution: {integrity: sha512-O0pcWjJqzQFVsisPlPXuNawJHHg9N9UgpJ/aDmvi9+vnS3x1C0NhwkVFzzZ1VN0Xo+bekyweoqYvBw5ZBKiNnQ==}\n\n  spdx-correct@3.2.0:\n    resolution: {integrity: sha512-kN9dJbvnySHULIluDHy32WHRUu3Og7B9sbY7tsFLctQkIqnMh3hErYgdMjTYuqmcXX+lK5T1lnUt3G7zNswmZA==}\n\n  spdx-exceptions@2.5.0:\n    resolution: {integrity: sha512-PiU42r+xO4UbUS1buo3LPJkjlO7430Xn5SVAhdpzzsPHsjbYVflnnFdATgabnLude+Cqu25p6N+g2lw/PFsa4w==}\n\n  spdx-expression-parse@3.0.1:\n    resolution: {integrity: sha512-cbqHunsQWnJNE6KhVSMsMeH5H/L9EpymbzqTQ3uLwNCLZ1Q481oWaofqH7nO6V07xlXwY6PhQdQ2IedWx/ZK4Q==}\n\n  spdx-license-ids@3.0.20:\n    resolution: {integrity: sha512-jg25NiDV/1fLtSgEgyvVyDunvaNHbuwF9lfNV17gSmPFAlYzdfNBlLtLzXTevwkPj7DhGbmN9VnmJIgLnhvaBw==}\n\n  split-on-first@1.1.0:\n    resolution: {integrity: sha512-43ZssAJaMusuKWL8sKUBQXHWOpq8d6CfN/u1p4gUzfJkM05C8rxTmYrkIPTXapZpORA6LkkzcUulJ8FqA7Uudw==}\n    engines: {node: '>=6'}\n\n  split-string@3.1.0:\n    resolution: {integrity: sha512-NzNVhJDYpwceVVii8/Hu6DKfD2G+NrQHlS/V/qgv763EYudVwEcMQNxd2lh+0VrUByXN/oJkl5grOhYWvQUYiw==}\n    engines: {node: '>=0.10.0'}\n\n  sprintf-js@1.0.3:\n    resolution: {integrity: sha512-D9cPgkvLlV3t3IzL0D0YLvGA9Ahk4PcvVwUbN0dSGr1aP0Nrt4AEnTUbuGvquEC0mA64Gqt1fzirlRs5ibXx8g==}\n\n  stack-utils@2.0.6:\n    resolution: {integrity: sha512-XlkWvfIm6RmsWtNJx+uqtKLS8eqFbxUg0ZzLXqY0caEy9l7hruX8IpiDnjsLavoBgqCCR71TqWO8MaXYheJ3RQ==}\n    engines: {node: '>=10'}\n\n  stackframe@0.3.1:\n    resolution: {integrity: sha512-XmoiF4T5nuWEp2x2w92WdGjdHGY/cZa6LIbRsDRQR/Xlk4uW0PAUlH1zJYVffocwKpCdwyuypIp25xsSXEtZHw==}\n\n  stackframe@1.3.4:\n    resolution: {integrity: sha512-oeVtt7eWQS+Na6F//S4kJ2K2VbRlS9D43mAlMyVpVWovy9o+jfgH8O9agzANzaiLjclA0oYzUXEM4PurhSUChw==}\n\n  static-extend@0.1.2:\n    resolution: {integrity: sha512-72E9+uLc27Mt718pMHt9VMNiAL4LMsmDbBva8mxWUCkT07fSzEGMYUCk0XWY6lp0j6RBAG4cJ3mWuZv2OE3s0g==}\n    engines: {node: '>=0.10.0'}\n\n  stream-browserify@2.0.2:\n    resolution: {integrity: sha512-nX6hmklHs/gr2FuxYDltq8fJA1GDlxKQCz8O/IM4atRqBH8OORmBNgfvW5gG10GT/qQ9u0CzIvr2X5Pkt6ntqg==}\n\n  stream-http@2.8.3:\n    resolution: {integrity: sha512-+TSkfINHDo4J+ZobQLWiMouQYB+UVYFttRA94FpEzzJ7ZdqcL4uUUQ7WkdkI4DSozGmgBUE/a47L+38PenXhUw==}\n\n  strict-uri-encode@1.1.0:\n    resolution: {integrity: sha512-R3f198pcvnB+5IpnBlRkphuE9n46WyVl8I39W/ZUTZLz4nqSP/oLYUrcnJrw462Ds8he4YKMov2efsTIw1BDGQ==}\n    engines: {node: '>=0.10.0'}\n\n  strict-uri-encode@2.0.0:\n    resolution: {integrity: sha512-QwiXZgpRcKkhTj2Scnn++4PKtWsH0kpzZ62L2R6c/LUVYv7hVnZqcg2+sMuT6R7Jusu1vviK/MFsu6kNJfWlEQ==}\n    engines: {node: '>=4'}\n\n  string-argv@0.3.1:\n    resolution: {integrity: sha512-a1uQGz7IyVy9YwhqjZIZu1c8JO8dNIe20xBmSS6qu9kv++k3JGzCVmprbNN5Kn+BgzD5E7YYwg1CcjuJMRNsvg==}\n    engines: {node: '>=0.6.19'}\n\n  string-convert@0.2.1:\n    resolution: {integrity: sha512-u/1tdPl4yQnPBjnVrmdLo9gtuLvELKsAoRapekWggdiQNvvvum+jYF329d84NAa660KQw7pB2n36KrIKVoXa3A==}\n\n  string-length@4.0.2:\n    resolution: {integrity: sha512-+l6rNN5fYHNhZZy41RXsYptCjA2Igmq4EG7kZAYFQI1E1VTXarr6ZPXBg6eq7Y6eK4FEhY6AJlyuFIb/v/S0VQ==}\n    engines: {node: '>=10'}\n\n  string-width@4.2.3:\n    resolution: {integrity: sha512-wKyQRQpjJ0sIp62ErSZdGsjMJWsap5oRNihHhu6G7JVO/9jIB6UyevL+tXuOqrng8j/cxKTWyWUwvSTriiZz/g==}\n    engines: {node: '>=8'}\n\n  string_decoder@1.1.1:\n    resolution: {integrity: sha512-n/ShnvDi6FHbbVfviro+WojiFzv+s8MPMHBczVePfUpDJLwoLT0ht1l4YwBCbi8pJAveEEdnkHyPyTP/mzRfwg==}\n\n  string_decoder@1.3.0:\n    resolution: {integrity: sha512-hkRX8U1WjJFd8LsDJ2yQ/wWWxaopEsABU1XfkM8A+j0+85JAGppt16cr1Whg6KIbb4okU6Mql6BOj+uup/wKeA==}\n\n  stringify-object@3.3.0:\n    resolution: {integrity: sha512-rHqiFh1elqCQ9WPLIC8I0Q/g/wj5J1eMkyoiD6eoQApWHP0FtlK7rqnhmabL5VUY9JQCcqwwvlOaSuutekgyrw==}\n    engines: {node: '>=4'}\n\n  strip-ansi@6.0.1:\n    resolution: {integrity: sha512-Y38VPSHcqkFrCpFnQ9vuSXmquuv5oXOKpGeT6aGrr3o3Gc9AlVa6JBfUSOCnbxGGZF+/0ooI7KrPuUSztUdU5A==}\n    engines: {node: '>=8'}\n\n  strip-bom@4.0.0:\n    resolution: {integrity: sha512-3xurFv5tEgii33Zi8Jtp55wEIILR9eh34FAW00PZf+JnSsTmV/ioewSgQl97JHvgjoRGwPShsWm+IdrxB35d0w==}\n    engines: {node: '>=8'}\n\n  strip-eof@1.0.0:\n    resolution: {integrity: sha512-7FCwGGmx8mD5xQd3RPUvnSpUXHM3BWuzjtpD4TXsfcZ9EL4azvVVUscFYwD9nx8Kh+uCBC00XBtAykoMHwTh8Q==}\n    engines: {node: '>=0.10.0'}\n\n  strip-final-newline@2.0.0:\n    resolution: {integrity: sha512-BrpvfNAE3dcvq7ll3xVumzjKjZQ5tI1sEUIKr3Uoks0XUl45St3FlatVqef9prk4jRDzhW6WZg+3bk93y6pLjA==}\n    engines: {node: '>=6'}\n\n  strip-indent@2.0.0:\n    resolution: {integrity: sha512-RsSNPLpq6YUL7QYy44RnPVTn/lcVZtb48Uof3X5JLbF4zD/Gs7ZFDv2HWol+leoQN2mT86LAzSshGfkTlSOpsA==}\n    engines: {node: '>=4'}\n\n  supports-color@5.5.0:\n    resolution: {integrity: sha512-QjVjwdXIt408MIiAqCX4oUKsgU2EqAGzs2Ppkm4aQYbjm+ZEWEcW4SfFNTr4uMNZma0ey4f5lgLrkB0aX0QMow==}\n    engines: {node: '>=4'}\n\n  supports-color@6.1.0:\n    resolution: {integrity: sha512-qe1jfm1Mg7Nq/NSh6XE24gPXROEVsWHxC1LIx//XNlD9iw7YZQGjZNjYN7xGaEG6iKdA8EtNFW6R0gjnVXp+wQ==}\n    engines: {node: '>=6'}\n\n  supports-color@7.2.0:\n    resolution: {integrity: sha512-qpCAvRl9stuOHveKsn7HncJRvv501qIacKzQlO/+Lwxc9+0q2wLyv4Dfvt80/DPn2pqOBsJdDiogXGR9+OvwRw==}\n    engines: {node: '>=8'}\n\n  supports-hyperlinks@2.3.0:\n    resolution: {integrity: sha512-RpsAZlpWcDwOPQA22aCH4J0t7L8JmAvsCxfOSEwm7cQs3LshN36QaTkwd70DnBOXDWGssw2eUoc8CaRWT0XunA==}\n    engines: {node: '>=8'}\n\n  supports-preserve-symlinks-flag@1.0.0:\n    resolution: {integrity: sha512-ot0WnXS9fgdkgIcePe6RHNk1WA8+muPa6cSjeR3V8K27q9BB1rTE3R1p7Hv0z1ZyAc8s6Vvv8DIyWf681MAt0w==}\n    engines: {node: '>= 0.4'}\n\n  swr@1.3.0:\n    resolution: {integrity: sha512-dkghQrOl2ORX9HYrMDtPa7LTVHJjCTeZoB1dqTbnnEDlSvN8JEKpYIYurDfvbQFUUS8Cg8PceFVZNkW0KNNYPw==}\n    peerDependencies:\n      react: ^16.11.0 || ^17.0.0 || ^18.0.0\n\n  symbol-tree@3.2.4:\n    resolution: {integrity: sha512-9QNk5KwDF+Bvz+PyObkmSYjI5ksVUYtjW7AU22r2NKcfLJcXp96hkDWU3+XndOsUb+AQ9QhfzfCT2O+CNWT5Tw==}\n\n  terminal-link@2.1.1:\n    resolution: {integrity: sha512-un0FmiRUQNr5PJqy9kP7c40F5BOfpGlYTrxonDChEZB7pzZxRNp/bt+ymiy9/npwXya9KH99nJ/GXFIiUkYGFQ==}\n    engines: {node: '>=8'}\n\n  terser@5.14.2:\n    resolution: {integrity: sha512-oL0rGeM/WFQCUd0y2QrWxYnq7tfSuKBiqTjRPWrRgB46WD/kiwHwF8T23z78H6Q6kGCuuHcPB+KULHRdxvVGQA==}\n    engines: {node: '>=10'}\n    hasBin: true\n\n  test-exclude@6.0.0:\n    resolution: {integrity: sha512-cAGWPIyOHU6zlmg88jwm7VRyXnMN7iV68OGAbYDk/Mh/xC/pzVPlQtY6ngoIH/5/tciuhGfvESU8GrHrcxD56w==}\n    engines: {node: '>=8'}\n\n  throat@5.0.0:\n    resolution: {integrity: sha512-fcwX4mndzpLQKBS1DVYhGAcYaYt7vsHNIvQV+WXMvnow5cgjPphq5CaayLaGsjRdSCKZFNGt7/GYAuXaNOiYCA==}\n\n  throttle-debounce@5.0.2:\n    resolution: {integrity: sha512-B71/4oyj61iNH0KeCamLuE2rmKuTO5byTOSVwECM5FA7TiAiAW+UqTKZ9ERueC4qvgSttUhdmq1mXC3kJqGX7A==}\n    engines: {node: '>=12.22'}\n\n  through@2.3.8:\n    resolution: {integrity: sha512-w89qg7PI8wAdvX60bMDP+bFoD5Dvhm9oLheFp5O4a2QF0cSBGsBX4qZmadPMvVqlLJBBci+WqGGOAPvcDeNSVg==}\n\n  timers-browserify@2.0.12:\n    resolution: {integrity: sha512-9phl76Cqm6FhSX9Xe1ZUAMLtm1BLkKj2Qd5ApyWkXzsMRaA7dgr81kf4wJmQf/hAvg8EEyJxDo3du/0KlhPiKQ==}\n    engines: {node: '>=0.6.0'}\n\n  tiny-invariant@1.3.3:\n    resolution: {integrity: sha512-+FbBPE1o9QAYvviau/qC5SE3caw21q3xkvWKBtja5vgqOWIHHJ3ioaq1VPfn/Szqctz2bU/oYeKd9/z5BL+PVg==}\n\n  tiny-warning@1.0.3:\n    resolution: {integrity: sha512-lBN9zLN/oAf68o3zNXYrdCt1kP8WsiGW8Oo2ka41b2IM5JL/S1CTyX1rW0mb/zSuJun0ZUrDxx4sqvYS2FWzPA==}\n\n  tmpl@1.0.5:\n    resolution: {integrity: sha512-3f0uOEAQwIqGuWW2MVzYg8fV/QNnc/IpuJNG837rLuczAaLVHslWHZQj4IGiEl5Hs3kkbhwL9Ab7Hrsmuj+Smw==}\n\n  to-arraybuffer@1.0.1:\n    resolution: {integrity: sha512-okFlQcoGTi4LQBG/PgSYblw9VOyptsz2KJZqc6qtgGdes8VktzUQkj4BI2blit072iS8VODNcMA+tvnS9dnuMA==}\n\n  to-object-path@0.3.0:\n    resolution: {integrity: sha512-9mWHdnGRuh3onocaHzukyvCZhzvr6tiflAy/JRFXcJX0TjgfWA9pk9t8CMbzmBE4Jfw58pXbkngtBtqYxzNEyg==}\n    engines: {node: '>=0.10.0'}\n\n  to-regex-range@2.1.1:\n    resolution: {integrity: sha512-ZZWNfCjUokXXDGXFpZehJIkZqq91BcULFq/Pi7M5i4JnxXdhMKAK682z8bCW3o8Hj1wuuzoKcW3DfVzaP6VuNg==}\n    engines: {node: '>=0.10.0'}\n\n  to-regex-range@5.0.1:\n    resolution: {integrity: sha512-65P7iz6X5yEr1cwcgvQxbbIw7Uk3gOy5dIdtZ4rDveLqhrdJP+Li/Hx6tyK0NEb+2GCyneCMJiGqrADCSNk8sQ==}\n    engines: {node: '>=8.0'}\n\n  to-regex@3.0.2:\n    resolution: {integrity: sha512-FWtleNAtZ/Ki2qtqej2CXTOayOH9bHDQF+Q48VpWyDXjbYxA4Yz8iDB31zXOBUlOHHKidDbqGVrTUvQMPmBGBw==}\n    engines: {node: '>=0.10.0'}\n\n  toggle-selection@1.0.6:\n    resolution: {integrity: sha512-BiZS+C1OS8g/q2RRbJmy59xpyghNBqrr6k5L/uKBGRsTfxmu3ffiRnd8mlGPUVayg8pvfi5urfnu8TU7DVOkLQ==}\n\n  tough-cookie@4.1.4:\n    resolution: {integrity: sha512-Loo5UUvLD9ScZ6jh8beX1T6sO1w2/MpCRpEP7V280GKMVUQ0Jzar2U3UJPsrdbziLEMMhu3Ujnq//rhiFuIeag==}\n    engines: {node: '>=6'}\n\n  tr46@2.1.0:\n    resolution: {integrity: sha512-15Ih7phfcdP5YxqiB+iDtLoaTz4Nd35+IiAv0kQ5FNKHzXgdWqPoTIqEDDJmXceQt4JZk6lVPT8lnDlPpGDppw==}\n    engines: {node: '>=8'}\n\n  tslib@2.8.1:\n    resolution: {integrity: sha512-oJFu94HQb+KVduSUQL7wnpmqnfmLsOA/nAh6b6EH0wCEoK0/mPeXU6c3wKDV83MkOuHPRHtSXKKU99IBazS/2w==}\n\n  tty-browserify@0.0.0:\n    resolution: {integrity: sha512-JVa5ijo+j/sOoHGjw0sxw734b1LhBkQ3bvUGNdxnVXDCX81Yx7TFgnZygxrIIWn23hbfTaMYLwRmAxFyDuFmIw==}\n\n  tween-functions@1.2.0:\n    resolution: {integrity: sha512-PZBtLYcCLtEcjL14Fzb1gSxPBeL7nWvGhO5ZFPGqziCcr8uvHp0NDmdjBchp6KHL+tExcg0m3NISmKxhU394dA==}\n\n  type-detect@4.0.8:\n    resolution: {integrity: sha512-0fr/mIH1dlO+x7TlcMy+bIDqKPsw/70tVyeHW787goQjhmqaZe10uwLujubK9q9Lg6Fiho1KUKDYz0Z7k7g5/g==}\n    engines: {node: '>=4'}\n\n  type-fest@0.21.3:\n    resolution: {integrity: sha512-t0rzBq87m3fVcduHDUFhKmyyX+9eo6WQjZvf51Ea/M0Q7+T374Jp1aUiyUl0GKxp8M/OETVHSDvmkyPgvX+X2w==}\n    engines: {node: '>=10'}\n\n  type-fest@0.6.0:\n    resolution: {integrity: sha512-q+MB8nYR1KDLrgr4G5yemftpMC7/QLqVndBmEEdqzmNj5dcFOO4Oo8qlwZE3ULT3+Zim1F8Kq4cBnikNhlCMlg==}\n    engines: {node: '>=8'}\n\n  type-fest@0.8.1:\n    resolution: {integrity: sha512-4dbzIzqvjtgiM5rw1k5rEHtBANKmdudhGyBEajN01fEyhaAIhsoKNy6y7+IN93IfpFtwY9iqi7kD+xwKhQsNJA==}\n    engines: {node: '>=8'}\n\n  typedarray-to-buffer@3.1.5:\n    resolution: {integrity: sha512-zdu8XMNEDepKKR+XYOXAVPtWui0ly0NtohUscw+UmaHiAWT8hrV1rr//H6V+0DvJ3OQ19S979M0laLfX8rm82Q==}\n\n  typescript@4.9.5:\n    resolution: {integrity: sha512-1FXk9E2Hm+QzZQ7z+McJiHL4NW1F2EzMu9Nq9i3zAaGqibafqYwCVU6WyWAuyQRRzOlxou8xZSyXLEN8oKj24g==}\n    engines: {node: '>=4.2.0'}\n    hasBin: true\n\n  ua-parser-js@0.7.39:\n    resolution: {integrity: sha512-IZ6acm6RhQHNibSt7+c09hhvsKy9WUr4DVbeq9U8o71qxyYtJpQeDxQnMrVqnIFMLcQjHO0I9wgfO2vIahht4w==}\n    hasBin: true\n\n  umi-request@1.4.0:\n    resolution: {integrity: sha512-OknwtQZddZHi0Ggi+Vr/olJ7HNMx4AzlywyK0W3NZBT7B0stjeZ9lcztA85dBgdAj3KVk8uPJPZSnGaDjELhrA==}\n\n  umi@3.5.43:\n    resolution: {integrity: sha512-WWusH/o3MTGIJ+S6MiUquz5OwOAQKVdgGHD0CwYBBXcUmwodeZ1mpQSfj8u7VO/OLgVfCmBw8ENsdaWEK6OMtw==}\n    hasBin: true\n\n  undici-types@6.20.0:\n    resolution: {integrity: sha512-Ny6QZ2Nju20vw1SRHe3d9jVu6gJ+4e3+MMpqu7pqE5HT6WsTSlce++GQmK5UXS8mzV8DSYHrQH+Xrf2jVcuKNg==}\n\n  union-value@1.0.1:\n    resolution: {integrity: sha512-tJfXmxMeWYnczCVs7XAEvIV7ieppALdyepWMkHkwciRpZraG/xwT+s2JN8+pr1+8jCRf80FFzvr+MpQeeoF4Xg==}\n    engines: {node: '>=0.10.0'}\n\n  uniq@1.0.1:\n    resolution: {integrity: sha512-Gw+zz50YNKPDKXs+9d+aKAjVwpjNwqzvNpLigIruT4HA9lMZNdMqs9x07kKHB/L9WRzqp4+DlTU5s4wG2esdoA==}\n\n  universalify@0.2.0:\n    resolution: {integrity: sha512-CJ1QgKmNg3CwvAv/kOFmtnEN05f0D/cn9QntgNOQlQF9dgvVTHj3t+8JPdjqawCHk7V/KA+fbUqzZ9XWhcqPUg==}\n    engines: {node: '>= 4.0.0'}\n\n  unset-value@1.0.0:\n    resolution: {integrity: sha512-PcA2tsuGSF9cnySLHTLSh2qrQiJ70mn+r+Glzxv2TWZblxsxCC52BDlZoPCsz7STd9pN7EZetkWZBAvk4cgZdQ==}\n    engines: {node: '>=0.10.0'}\n\n  unstated-next@1.1.0:\n    resolution: {integrity: sha512-AAn47ZncPvgBGOvMcn8tSRxsrqwf2VdAPxLASTuLJvZt4rhKfDvUkmYZLGfclImSfTVMv7tF4ynaVxin0JjDCA==}\n\n  update-browserslist-db@1.1.1:\n    resolution: {integrity: sha512-R8UzCaa9Az+38REPiJ1tXlImTJXlVfgHZsglwBD/k6nj76ctsH1E3q4doGrukiLQd3sGQYu56r5+lo5r94l29A==}\n    hasBin: true\n    peerDependencies:\n      browserslist: '>= 4.21.0'\n\n  uri-js@4.4.1:\n    resolution: {integrity: sha512-7rKUyy33Q1yc98pQ1DAmLtwX109F7TIfWlW1Ydo8Wl1ii1SeHieeh0HHfPeL2fMXK6z0s8ecKs9frCuLJvndBg==}\n\n  urix@0.1.0:\n    resolution: {integrity: sha512-Am1ousAhSLBeB9cG/7k7r2R0zj50uDRlZHPGbazid5s9rlF1F/QKYObEKSIunSjIOkJZqwRRLpvewjEkM7pSqg==}\n    deprecated: Please see https://github.com/lydell/urix#deprecated\n\n  url-parse@1.5.10:\n    resolution: {integrity: sha512-WypcfiRhfeUP9vvF0j6rw0J3hrWrw6iZv3+22h6iRMJ/8z1Tj6XfLP4DsUix5MhMPnXpiHDoKyoZ/bdCkwBCiQ==}\n\n  url@0.11.4:\n    resolution: {integrity: sha512-oCwdVC7mTuWiPyjLUz/COz5TLk6wgp0RCsN+wHZ2Ekneac9w8uuV0njcbbie2ME+Vs+d6duwmYuR3HgQXs1fOg==}\n    engines: {node: '>= 0.4'}\n\n  use-json-comparison@1.0.6:\n    resolution: {integrity: sha512-xPadt5yMRbEmVfOSGFSMqjjICrq7nLbfSH3rYIXsrtcuFX7PmbYDN/ku8ObBn3v8o/yZelO1OxUS5+5TI3+fUw==}\n    peerDependencies:\n      react: '>=16.9.0'\n\n  use-media-antd-query@1.1.0:\n    resolution: {integrity: sha512-B6kKZwNV4R+l4Rl11sWO7HqOay9alzs1Vp1b4YJqjz33YxbltBCZtt/yxXxkXN9rc1S7OeEL/GbwC30Wmqhw6Q==}\n    peerDependencies:\n      react: '>=16.9.0'\n\n  use-subscription@1.5.1:\n    resolution: {integrity: sha512-Xv2a1P/yReAjAbhylMfFplFKj9GssgTwN7RlcTxBujFQcloStWNDQdc4g4NRWH9xS4i/FDk04vQBptAXoF3VcA==}\n    peerDependencies:\n      react: ^16.8.0 || ^17.0.0\n\n  use@3.1.1:\n    resolution: {integrity: sha512-cwESVXlO3url9YWlFW/TA9cshCEhtu7IKJ/p5soJ/gGpj7vbvFrAY/eIioQ6Dw23KjZhYgiIo8HOs1nQ2vr/oQ==}\n    engines: {node: '>=0.10.0'}\n\n  util-deprecate@1.0.2:\n    resolution: {integrity: sha512-EPD5q1uXyFxJpCrLnCc1nHnq3gOa6DZBocAIiI2TaSCA7VCJ1UJDMagCzIkXNsUYfD1daK//LTEQ8xiIbrHtcw==}\n\n  util@0.10.4:\n    resolution: {integrity: sha512-0Pm9hTQ3se5ll1XihRic3FDIku70C+iHUdT/W926rSgHV5QgXsYbKZN8MSC3tJtSkhuROzvsQjAaFENRXr+19A==}\n\n  util@0.11.1:\n    resolution: {integrity: sha512-HShAsny+zS2TZfaXxD9tYj4HQGlBezXZMZuM/S5PKLLoZkShZiGk9o5CzukI1LVHZvjdvZ2Sj1aW/Ndn2NB/HQ==}\n\n  uuid@8.3.2:\n    resolution: {integrity: sha512-+NYs2QeMWy+GWFOEm9xnn6HCDp0l7QBD7ml8zLUmJ+93Q5NF0NocErnwkTkXVFNiX3/fpC6afS8Dhb/gz7R7eg==}\n    hasBin: true\n\n  v8-compile-cache@2.3.0:\n    resolution: {integrity: sha512-l8lCEmLcLYZh4nbunNZvQCJc5pv7+RCwa8q/LdUx8u7lsWvPDKmpodJAJNwkAhJC//dFY48KuIEmjtd4RViDrA==}\n\n  v8-to-istanbul@7.1.2:\n    resolution: {integrity: sha512-TxNb7YEUwkLXCQYeudi6lgQ/SZrzNO4kMdlqVxaZPUIUjCv6iSSypUQX70kNBSERpQ8fk48+d61FXk+tgqcWow==}\n    engines: {node: '>=10.10.0'}\n\n  validate-npm-package-license@3.0.4:\n    resolution: {integrity: sha512-DpKm2Ui/xN7/HQKCtpZxoRWBhZ9Z0kqtygG8XCgNQ8ZlDnxuQmWhj566j8fN4Cu3/JmbhsDo7fcAJq4s9h27Ew==}\n\n  value-equal@1.0.1:\n    resolution: {integrity: sha512-NOJ6JZCAWr0zlxZt+xqCHNTEKOsrks2HQd4MqhP1qy4z1SkbEP467eNx6TgDKXMvUOb+OENfJCZwM+16n7fRfw==}\n\n  vm-browserify@1.1.2:\n    resolution: {integrity: sha512-2ham8XPWTONajOR0ohOKOHXkm3+gaBmGut3SRuu75xLd/RRaY6vqgh8NBYYk7+RW3u5AtzPQZG8F10LHkl0lAQ==}\n\n  w3c-hr-time@1.0.2:\n    resolution: {integrity: sha512-z8P5DvDNjKDoFIHK7q8r8lackT6l+jo/Ye3HOle7l9nICP9lf1Ci25fy9vHd0JOWewkIFzXIEig3TdKT7JQ5fQ==}\n    deprecated: Use your platform's native performance.now() and performance.timeOrigin.\n\n  w3c-xmlserializer@2.0.0:\n    resolution: {integrity: sha512-4tzD0mF8iSiMiNs30BiLO3EpfGLZUT2MSX/G+o7ZywDzliWQ3OPtTZ0PTC3B3ca1UAf4cJMHB+2Bf56EriJuRA==}\n    engines: {node: '>=10'}\n\n  walker@1.0.8:\n    resolution: {integrity: sha512-ts/8E8l5b7kY0vlWLewOkDXMmPdLcVV4GmOQLyxuSswIJsweeFZtAsMF7k1Nszz+TYBQrlYRmzOnr398y1JemQ==}\n\n  warning@3.0.0:\n    resolution: {integrity: sha512-jMBt6pUrKn5I+OGgtQ4YZLdhIeJmObddh6CsibPxyQ5yPZm1XExSyzC1LCNX7BzhxWgiHmizBWJTHJIjMjTQYQ==}\n\n  warning@4.0.3:\n    resolution: {integrity: sha512-rpJyN222KWIvHJ/F53XSZv0Zl/accqHR8et1kpaMTD/fLCRxtV8iX8czMzY7sVZupTI3zcUTg8eycS2kNF9l6w==}\n\n  webidl-conversions@5.0.0:\n    resolution: {integrity: sha512-VlZwKPCkYKxQgeSbH5EyngOmRp7Ww7I9rQLERETtf5ofd9pGeswWiOtogpEO850jziPRarreGxn5QIiTqpb2wA==}\n    engines: {node: '>=8'}\n\n  webidl-conversions@6.1.0:\n    resolution: {integrity: sha512-qBIvFLGiBpLjfwmYAaHPXsn+ho5xZnGvyGvsarywGNc8VyQJUMHJ8OBKGGrPER0okBeMDaan4mNBlgBROxuI8w==}\n    engines: {node: '>=10.4'}\n\n  webpack-chain@6.5.1:\n    resolution: {integrity: sha512-7doO/SRtLu8q5WM0s7vPKPWX580qhi0/yBHkOxNkv50f6qB76Zy9o2wRTrrPULqYTvQlVHuvbA8v+G5ayuUDsA==}\n    engines: {node: '>=8'}\n    deprecated: Package no longer supported. Contact Support at https://www.npmjs.com/support for more info.\n\n  whatwg-encoding@1.0.5:\n    resolution: {integrity: sha512-b5lim54JOPN9HtzvK9HFXvBma/rnfFeqsic0hSpjtDbVxR3dJKLc+KB4V6GgiGOvl7CY/KNh8rxSo9DKQrnUEw==}\n\n  whatwg-fetch@3.6.20:\n    resolution: {integrity: sha512-EqhiFU6daOA8kpjOWTL0olhVOF3i7OrFzSYiGsEMB8GcXS+RrzauAERX65xMeNWVqxA6HXH2m69Z9LaKKdisfg==}\n\n  whatwg-mimetype@2.3.0:\n    resolution: {integrity: sha512-M4yMwr6mAnQz76TbJm914+gPpB/nCwvZbJU28cUD6dR004SAxDLOOSUaB1JDRqLtaOV/vi0IC5lEAGFgrjGv/g==}\n\n  whatwg-url@8.7.0:\n    resolution: {integrity: sha512-gAojqb/m9Q8a5IV96E3fHJM70AzCkgt4uXYX2O7EmuyOnLrViCQlsEBmF9UQIu3/aeAIp2U17rtbpZWNntQqdg==}\n    engines: {node: '>=10'}\n\n  which-module@2.0.1:\n    resolution: {integrity: sha512-iBdZ57RDvnOR9AGBhML2vFZf7h8vmBjhoaZqODJBFWHVtKkDmKuHai3cx5PgVMrX5YDNp27AofYbAwctSS+vhQ==}\n\n  which@1.3.1:\n    resolution: {integrity: sha512-HxJdYWq1MTIQbJ3nw0cqssHoTNU267KlrDuGZ1WYlxDStUtKUhOaJmh112/TZmHxxUfuJqPXSOm7tDyas0OSIQ==}\n    hasBin: true\n\n  which@2.0.2:\n    resolution: {integrity: sha512-BLI3Tl1TW3Pvl70l3yq3Y64i+awpwXqsGBYWkkqMtnbXgrMD+yj7rhW0kuEDxzJaYXGjEW5ogapKNMEKNMjibA==}\n    engines: {node: '>= 8'}\n    hasBin: true\n\n  wrap-ansi@6.2.0:\n    resolution: {integrity: sha512-r6lPcBGxZXlIcymEu7InxDMhdW0KDxpLgoFLcguasxCaJ/SOIZwINatK9KY/tf+ZrlywOKU0UDj3ATXUBfxJXA==}\n    engines: {node: '>=8'}\n\n  wrap-ansi@7.0.0:\n    resolution: {integrity: sha512-YVGIj2kamLSTxw6NsZjoBxfSwsn0ycdesmc4p+Q21c5zPuZ1pl+NfxVdxPtdHvmNVOQ6XSYG4AUtyt/Fi7D16Q==}\n    engines: {node: '>=10'}\n\n  wrappy@1.0.2:\n    resolution: {integrity: sha512-l4Sp/DRseor9wL6EvV2+TuQn63dMkPjZ/sp9XkghTEbV9KlPS1xUsZ3u7/IQO4wxtcFB4bgpQPRcR3QCvezPcQ==}\n\n  write-file-atomic@3.0.3:\n    resolution: {integrity: sha512-AvHcyZ5JnSfq3ioSyjrBkH9yW4m7Ayk8/9My/DD9onKeu/94fwrMocemO2QAJFAlnnDN+ZDS+ZjAR5ua1/PV/Q==}\n\n  ws@7.5.10:\n    resolution: {integrity: sha512-+dbF1tHwZpXcbOJdVOkzLDxZP1ailvSxM6ZweXTegylPny803bFhA+vqBYw4s31NSAk4S2Qz+AKXK9a4wkdjcQ==}\n    engines: {node: '>=8.3.0'}\n    peerDependencies:\n      bufferutil: ^4.0.1\n      utf-8-validate: ^5.0.2\n    peerDependenciesMeta:\n      bufferutil:\n        optional: true\n      utf-8-validate:\n        optional: true\n\n  xml-name-validator@3.0.0:\n    resolution: {integrity: sha512-A5CUptxDsvxKJEU3yO6DuWBSJz/qizqzJKOMIfUJHETbBw/sFaDxgd6fxm1ewUaM0jZ444Fc5vC5ROYurg/4Pw==}\n\n  xmlchars@2.2.0:\n    resolution: {integrity: sha512-JZnDKK8B0RCDw84FNdDAIpZK+JuJw+s7Lz8nksI7SIuU3UXJJslUthsi+uWBUYOwPFwW7W7PRLRfUKpxjtjFCw==}\n\n  xtend@4.0.2:\n    resolution: {integrity: sha512-LKYU1iAXJXUgAXn9URjiu+MWhyUXHsvfp7mcuYm9dSUKK0/CjtrUwFAxD82/mCWbtLsGjFIad0wIsod4zrTAEQ==}\n    engines: {node: '>=0.4'}\n\n  y18n@4.0.3:\n    resolution: {integrity: sha512-JKhqTOwSrqNA1NY5lSztJ1GrBiUodLMmIZuLiDaMRJ+itFd+ABVE8XBjOvIWL+rSqNDC74LCSFmlb/U4UZ4hJQ==}\n\n  yallist@2.1.2:\n    resolution: {integrity: sha512-ncTzHV7NvsQZkYe1DW7cbDLm0YpzHmZF5r/iyP3ZnQtMiJ+pjzisCiMNI+Sj+xQF5pXhSHxSB3uDbsBTzY/c2A==}\n\n  yallist@3.1.1:\n    resolution: {integrity: sha512-a4UGQaWPH59mOXUYnAG2ewncQS4i4F43Tv3JoAM+s2VDAmS9NsK8GpDMLrCHPksFT7h3K6TOoUNn2pb7RoXx4g==}\n\n  yaml@1.10.2:\n    resolution: {integrity: sha512-r3vXyErRCYJ7wg28yvBY5VSoAF8ZvlcW9/BwUzEtUsjvX/DKs24dIkuwjtuprwJJHsbyUbLApepYTR1BN4uHrg==}\n    engines: {node: '>= 6'}\n\n  yargs-parser@18.1.3:\n    resolution: {integrity: sha512-o50j0JeToy/4K6OZcaQmW6lyXXKhq7csREXcDwk2omFPJEwUNOVtJKvmDr9EI1fAJZUyZcRF7kxGBWmRXudrCQ==}\n    engines: {node: '>=6'}\n\n  yargs@15.4.1:\n    resolution: {integrity: sha512-aePbxDmcYW++PaqBsJ+HYUFwCdv4LVvdnhBy78E57PIor8/OVvhMrADFFEDh8DHDFRv/O9i3lPhsENjO7QX0+A==}\n    engines: {node: '>=8'}\n\n  yorkie@2.0.0:\n    resolution: {integrity: sha512-jcKpkthap6x63MB4TxwCyuIGkV0oYP/YRyuQU5UO0Yz/E/ZAu+653/uov+phdmO54n6BcvFRyyt0RRrWdN2mpw==}\n    engines: {node: '>=4'}\n\n  zscroller@0.4.8:\n    resolution: {integrity: sha512-G5NiNLKx2+QhhvZi2yV1jjVXY50otktxkseX2hG2N/eixohOUk0AY8ZpbAxNqS9oJS/NxItCsowupy2tsXxAMw==}\n\nsnapshots:\n\n  '@ahooksjs/use-request@2.8.15(react@17.0.2)':\n    dependencies:\n      lodash.debounce: 4.0.8\n      lodash.throttle: 4.1.1\n      react: 17.0.2\n\n  '@ampproject/remapping@2.3.0':\n    dependencies:\n      '@jridgewell/gen-mapping': 0.3.8\n      '@jridgewell/trace-mapping': 0.3.25\n\n  '@ant-design/colors@6.0.0':\n    dependencies:\n      '@ctrl/tinycolor': 3.6.1\n\n  '@ant-design/icons-svg@4.4.2': {}\n\n  '@ant-design/icons@4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)':\n    dependencies:\n      '@ant-design/colors': 6.0.0\n      '@ant-design/icons-svg': 4.4.2\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      lodash: 4.17.21\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  '@ant-design/pro-layout@6.38.22(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2)':\n    dependencies:\n      '@ant-design/icons': 4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@ant-design/pro-provider': 1.10.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@ant-design/pro-utils': 1.45.3(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@babel/runtime': 7.26.0\n      '@umijs/route-utils': 2.2.2\n      '@umijs/ssr-darkreader': 4.9.45\n      '@umijs/use-params': 1.0.9(react@17.0.2)\n      antd: 4.24.16(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      classnames: 2.5.1\n      lodash.merge: 4.6.2\n      omit.js: 2.0.2\n      path-to-regexp: 2.4.0\n      rc-resize-observer: 1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      swr: 1.3.0(react@17.0.2)\n      unstated-next: 1.1.0\n      use-json-comparison: 1.0.6(react@17.0.2)\n      use-media-antd-query: 1.1.0(react@17.0.2)\n      warning: 4.0.3\n    transitivePeerDependencies:\n      - prop-types\n      - react-dom\n\n  '@ant-design/pro-provider@1.10.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)':\n    dependencies:\n      '@babel/runtime': 7.26.0\n      antd: 4.24.16(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      swr: 1.3.0(react@17.0.2)\n    transitivePeerDependencies:\n      - react-dom\n\n  '@ant-design/pro-utils@1.45.3(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2)':\n    dependencies:\n      '@ant-design/icons': 4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@ant-design/pro-provider': 1.10.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@babel/runtime': 7.26.0\n      antd: 4.24.16(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      classnames: 2.5.1\n      moment: 2.30.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      react-sortable-hoc: 2.0.0(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      swr: 1.3.0(react@17.0.2)\n    transitivePeerDependencies:\n      - prop-types\n\n  '@ant-design/react-slick@1.0.2(react@17.0.2)':\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      json2mq: 0.2.0\n      react: 17.0.2\n      resize-observer-polyfill: 1.5.1\n      throttle-debounce: 5.0.2\n\n  '@babel/code-frame@7.26.2':\n    dependencies:\n      '@babel/helper-validator-identifier': 7.25.9\n      js-tokens: 4.0.0\n      picocolors: 1.1.1\n\n  '@babel/compat-data@7.26.3': {}\n\n  '@babel/core@7.18.6':\n    dependencies:\n      '@ampproject/remapping': 2.3.0\n      '@babel/code-frame': 7.26.2\n      '@babel/generator': 7.26.3\n      '@babel/helper-compilation-targets': 7.25.9\n      '@babel/helper-module-transforms': 7.26.0(@babel/core@7.18.6)\n      '@babel/helpers': 7.26.0\n      '@babel/parser': 7.26.3\n      '@babel/template': 7.25.9\n      '@babel/traverse': 7.26.4\n      '@babel/types': 7.26.3\n      convert-source-map: 1.9.0\n      debug: 4.4.0\n      gensync: 1.0.0-beta.2\n      json5: 2.2.3\n      semver: 6.3.1\n    transitivePeerDependencies:\n      - supports-color\n\n  '@babel/generator@7.26.3':\n    dependencies:\n      '@babel/parser': 7.26.3\n      '@babel/types': 7.26.3\n      '@jridgewell/gen-mapping': 0.3.8\n      '@jridgewell/trace-mapping': 0.3.25\n      jsesc: 3.1.0\n\n  '@babel/helper-compilation-targets@7.25.9':\n    dependencies:\n      '@babel/compat-data': 7.26.3\n      '@babel/helper-validator-option': 7.25.9\n      browserslist: 4.24.2\n      lru-cache: 5.1.1\n      semver: 6.3.1\n\n  '@babel/helper-module-imports@7.25.9':\n    dependencies:\n      '@babel/traverse': 7.26.4\n      '@babel/types': 7.26.3\n    transitivePeerDependencies:\n      - supports-color\n\n  '@babel/helper-module-transforms@7.26.0(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-module-imports': 7.25.9\n      '@babel/helper-validator-identifier': 7.25.9\n      '@babel/traverse': 7.26.4\n    transitivePeerDependencies:\n      - supports-color\n\n  '@babel/helper-plugin-utils@7.25.9': {}\n\n  '@babel/helper-string-parser@7.25.9': {}\n\n  '@babel/helper-validator-identifier@7.25.9': {}\n\n  '@babel/helper-validator-option@7.25.9': {}\n\n  '@babel/helpers@7.26.0':\n    dependencies:\n      '@babel/template': 7.25.9\n      '@babel/types': 7.26.3\n\n  '@babel/parser@7.26.3':\n    dependencies:\n      '@babel/types': 7.26.3\n\n  '@babel/plugin-syntax-async-generators@7.8.4(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-bigint@7.8.3(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-class-properties@7.12.13(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-class-static-block@7.14.5(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-import-attributes@7.26.0(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-import-meta@7.10.4(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-json-strings@7.8.3(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-logical-assignment-operators@7.10.4(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-nullish-coalescing-operator@7.8.3(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-numeric-separator@7.10.4(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-object-rest-spread@7.8.3(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-optional-catch-binding@7.8.3(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-optional-chaining@7.8.3(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-private-property-in-object@7.14.5(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-top-level-await@7.14.5(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/runtime@7.18.6':\n    dependencies:\n      regenerator-runtime: 0.13.11\n\n  '@babel/runtime@7.26.0':\n    dependencies:\n      regenerator-runtime: 0.14.1\n\n  '@babel/template@7.25.9':\n    dependencies:\n      '@babel/code-frame': 7.26.2\n      '@babel/parser': 7.26.3\n      '@babel/types': 7.26.3\n\n  '@babel/traverse@7.26.4':\n    dependencies:\n      '@babel/code-frame': 7.26.2\n      '@babel/generator': 7.26.3\n      '@babel/parser': 7.26.3\n      '@babel/template': 7.25.9\n      '@babel/types': 7.26.3\n      debug: 4.4.0\n      globals: 11.12.0\n    transitivePeerDependencies:\n      - supports-color\n\n  '@babel/types@7.26.3':\n    dependencies:\n      '@babel/helper-string-parser': 7.25.9\n      '@babel/helper-validator-identifier': 7.25.9\n\n  '@bcoe/v8-coverage@0.2.3': {}\n\n  '@bloomberg/record-tuple-polyfill@0.0.3': {}\n\n  '@cnakazawa/watch@1.0.4':\n    dependencies:\n      exec-sh: 0.3.6\n      minimist: 1.2.8\n\n  '@csstools/convert-colors@1.4.0': {}\n\n  '@ctrl/tinycolor@3.6.1': {}\n\n  '@formatjs/intl-displaynames@1.2.10':\n    dependencies:\n      '@formatjs/intl-utils': 2.3.0\n\n  '@formatjs/intl-listformat@1.4.8':\n    dependencies:\n      '@formatjs/intl-utils': 2.3.0\n\n  '@formatjs/intl-pluralrules@1.5.9':\n    dependencies:\n      '@formatjs/intl-utils': 2.3.0\n\n  '@formatjs/intl-relativetimeformat@4.5.16':\n    dependencies:\n      '@formatjs/intl-utils': 2.3.0\n\n  '@formatjs/intl-unified-numberformat@3.3.7':\n    dependencies:\n      '@formatjs/intl-utils': 2.3.0\n\n  '@formatjs/intl-utils@2.3.0': {}\n\n  '@istanbuljs/load-nyc-config@1.1.0':\n    dependencies:\n      camelcase: 5.3.1\n      find-up: 4.1.0\n      get-package-type: 0.1.0\n      js-yaml: 3.14.1\n      resolve-from: 5.0.0\n\n  '@istanbuljs/schema@0.1.3': {}\n\n  '@jest/console@26.6.2':\n    dependencies:\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      chalk: 4.1.2\n      jest-message-util: 26.6.2\n      jest-util: 26.6.2\n      slash: 3.0.0\n\n  '@jest/core@26.6.3':\n    dependencies:\n      '@jest/console': 26.6.2\n      '@jest/reporters': 26.6.2\n      '@jest/test-result': 26.6.2\n      '@jest/transform': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      ansi-escapes: 4.3.2\n      chalk: 4.1.2\n      exit: 0.1.2\n      graceful-fs: 4.2.11\n      jest-changed-files: 26.6.2\n      jest-config: 26.6.3\n      jest-haste-map: 26.6.2\n      jest-message-util: 26.6.2\n      jest-regex-util: 26.0.0\n      jest-resolve: 26.6.2\n      jest-resolve-dependencies: 26.6.3\n      jest-runner: 26.6.3\n      jest-runtime: 26.6.3\n      jest-snapshot: 26.6.2\n      jest-util: 26.6.2\n      jest-validate: 26.6.2\n      jest-watcher: 26.6.2\n      micromatch: 4.0.8\n      p-each-series: 2.2.0\n      rimraf: 3.0.2\n      slash: 3.0.0\n      strip-ansi: 6.0.1\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  '@jest/environment@26.6.2':\n    dependencies:\n      '@jest/fake-timers': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      jest-mock: 26.6.2\n\n  '@jest/fake-timers@26.6.2':\n    dependencies:\n      '@jest/types': 26.6.2\n      '@sinonjs/fake-timers': 6.0.1\n      '@types/node': 22.10.2\n      jest-message-util: 26.6.2\n      jest-mock: 26.6.2\n      jest-util: 26.6.2\n\n  '@jest/globals@26.6.2':\n    dependencies:\n      '@jest/environment': 26.6.2\n      '@jest/types': 26.6.2\n      expect: 26.6.2\n\n  '@jest/reporters@26.6.2':\n    dependencies:\n      '@bcoe/v8-coverage': 0.2.3\n      '@jest/console': 26.6.2\n      '@jest/test-result': 26.6.2\n      '@jest/transform': 26.6.2\n      '@jest/types': 26.6.2\n      chalk: 4.1.2\n      collect-v8-coverage: 1.0.2\n      exit: 0.1.2\n      glob: 7.2.3\n      graceful-fs: 4.2.11\n      istanbul-lib-coverage: 3.2.2\n      istanbul-lib-instrument: 4.0.3\n      istanbul-lib-report: 3.0.1\n      istanbul-lib-source-maps: 4.0.1\n      istanbul-reports: 3.1.7\n      jest-haste-map: 26.6.2\n      jest-resolve: 26.6.2\n      jest-util: 26.6.2\n      jest-worker: 26.6.2\n      slash: 3.0.0\n      source-map: 0.6.1\n      string-length: 4.0.2\n      terminal-link: 2.1.1\n      v8-to-istanbul: 7.1.2\n    optionalDependencies:\n      node-notifier: 8.0.2\n    transitivePeerDependencies:\n      - supports-color\n\n  '@jest/source-map@26.6.2':\n    dependencies:\n      callsites: 3.1.0\n      graceful-fs: 4.2.11\n      source-map: 0.6.1\n\n  '@jest/test-result@26.6.2':\n    dependencies:\n      '@jest/console': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/istanbul-lib-coverage': 2.0.6\n      collect-v8-coverage: 1.0.2\n\n  '@jest/test-sequencer@26.6.3':\n    dependencies:\n      '@jest/test-result': 26.6.2\n      graceful-fs: 4.2.11\n      jest-haste-map: 26.6.2\n      jest-runner: 26.6.3\n      jest-runtime: 26.6.3\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  '@jest/transform@26.6.2':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@jest/types': 26.6.2\n      babel-plugin-istanbul: 6.1.1\n      chalk: 4.1.2\n      convert-source-map: 1.9.0\n      fast-json-stable-stringify: 2.1.0\n      graceful-fs: 4.2.11\n      jest-haste-map: 26.6.2\n      jest-regex-util: 26.0.0\n      jest-util: 26.6.2\n      micromatch: 4.0.8\n      pirates: 4.0.6\n      slash: 3.0.0\n      source-map: 0.6.1\n      write-file-atomic: 3.0.3\n    transitivePeerDependencies:\n      - supports-color\n\n  '@jest/types@26.6.2':\n    dependencies:\n      '@types/istanbul-lib-coverage': 2.0.6\n      '@types/istanbul-reports': 3.0.4\n      '@types/node': 22.10.2\n      '@types/yargs': 15.0.19\n      chalk: 4.1.2\n\n  '@jridgewell/gen-mapping@0.3.8':\n    dependencies:\n      '@jridgewell/set-array': 1.2.1\n      '@jridgewell/sourcemap-codec': 1.5.0\n      '@jridgewell/trace-mapping': 0.3.25\n\n  '@jridgewell/resolve-uri@3.1.2': {}\n\n  '@jridgewell/set-array@1.2.1': {}\n\n  '@jridgewell/source-map@0.3.6':\n    dependencies:\n      '@jridgewell/gen-mapping': 0.3.8\n      '@jridgewell/trace-mapping': 0.3.25\n\n  '@jridgewell/sourcemap-codec@1.5.0': {}\n\n  '@jridgewell/trace-mapping@0.3.25':\n    dependencies:\n      '@jridgewell/resolve-uri': 3.1.2\n      '@jridgewell/sourcemap-codec': 1.5.0\n\n  '@qixian.cs/path-to-regexp@6.1.0': {}\n\n  '@rc-component/portal@1.1.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)':\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  '@sinonjs/commons@1.8.6':\n    dependencies:\n      type-detect: 4.0.8\n\n  '@sinonjs/fake-timers@6.0.1':\n    dependencies:\n      '@sinonjs/commons': 1.8.6\n\n  '@tootallnate/once@1.1.2': {}\n\n  '@types/babel__core@7.20.5':\n    dependencies:\n      '@babel/parser': 7.26.3\n      '@babel/types': 7.26.3\n      '@types/babel__generator': 7.6.8\n      '@types/babel__template': 7.4.4\n      '@types/babel__traverse': 7.20.6\n\n  '@types/babel__generator@7.6.8':\n    dependencies:\n      '@babel/types': 7.26.3\n\n  '@types/babel__template@7.4.4':\n    dependencies:\n      '@babel/parser': 7.26.3\n      '@babel/types': 7.26.3\n\n  '@types/babel__traverse@7.20.6':\n    dependencies:\n      '@babel/types': 7.26.3\n\n  '@types/graceful-fs@4.1.9':\n    dependencies:\n      '@types/node': 22.10.2\n\n  '@types/history@4.7.11': {}\n\n  '@types/history@5.0.0':\n    dependencies:\n      history: 5.3.0\n\n  '@types/hoist-non-react-statics@3.3.6':\n    dependencies:\n      '@types/react': 17.0.83\n      hoist-non-react-statics: 3.3.2\n\n  '@types/invariant@2.2.37': {}\n\n  '@types/isomorphic-fetch@0.0.35': {}\n\n  '@types/istanbul-lib-coverage@2.0.6': {}\n\n  '@types/istanbul-lib-report@3.0.3':\n    dependencies:\n      '@types/istanbul-lib-coverage': 2.0.6\n\n  '@types/istanbul-reports@3.0.4':\n    dependencies:\n      '@types/istanbul-lib-report': 3.0.3\n\n  '@types/json-schema@7.0.15': {}\n\n  '@types/node@22.10.2':\n    dependencies:\n      undici-types: 6.20.0\n\n  '@types/normalize-package-data@2.4.4': {}\n\n  '@types/parse-json@4.0.2': {}\n\n  '@types/prettier@2.7.3': {}\n\n  '@types/prop-types@15.7.14': {}\n\n  '@types/react-dom@16.9.25(@types/react@16.14.62)':\n    dependencies:\n      '@types/react': 16.14.62\n\n  '@types/react-dom@17.0.26(@types/react@17.0.83)':\n    dependencies:\n      '@types/react': 17.0.83\n\n  '@types/react-helmet@6.1.11':\n    dependencies:\n      '@types/react': 17.0.83\n\n  '@types/react-redux@7.1.34':\n    dependencies:\n      '@types/hoist-non-react-statics': 3.3.6\n      '@types/react': 17.0.83\n      hoist-non-react-statics: 3.3.2\n      redux: 4.2.1\n\n  '@types/react-router-config@5.0.2':\n    dependencies:\n      '@types/history': 5.0.0\n      '@types/react': 17.0.83\n      '@types/react-router': 5.1.20\n\n  '@types/react-router-dom@5.1.7':\n    dependencies:\n      '@types/history': 5.0.0\n      '@types/react': 17.0.83\n      '@types/react-router': 5.1.12\n\n  '@types/react-router-dom@5.3.3':\n    dependencies:\n      '@types/history': 4.7.11\n      '@types/react': 17.0.83\n      '@types/react-router': 5.1.20\n\n  '@types/react-router@5.1.12':\n    dependencies:\n      '@types/history': 5.0.0\n      '@types/react': 17.0.83\n\n  '@types/react-router@5.1.20':\n    dependencies:\n      '@types/history': 4.7.11\n      '@types/react': 17.0.83\n\n  '@types/react@16.14.62':\n    dependencies:\n      '@types/prop-types': 15.7.14\n      '@types/scheduler': 0.16.8\n      csstype: 3.1.3\n\n  '@types/react@17.0.83':\n    dependencies:\n      '@types/prop-types': 15.7.14\n      '@types/scheduler': 0.16.8\n      csstype: 3.1.3\n\n  '@types/scheduler@0.16.8': {}\n\n  '@types/stack-utils@2.0.3': {}\n\n  '@types/yargs-parser@21.0.3': {}\n\n  '@types/yargs@15.0.19':\n    dependencies:\n      '@types/yargs-parser': 21.0.3\n\n  '@umijs/ast@3.5.43':\n    dependencies:\n      '@umijs/utils': 3.5.43\n\n  '@umijs/babel-plugin-auto-css-modules@3.5.43':\n    dependencies:\n      '@umijs/utils': 3.5.43\n\n  '@umijs/babel-plugin-import-to-await-require@3.5.43':\n    dependencies:\n      '@umijs/utils': 3.5.43\n\n  '@umijs/babel-plugin-lock-core-js-3@3.5.43':\n    dependencies:\n      '@umijs/utils': 3.5.43\n      core-js: 3.6.5\n\n  '@umijs/babel-plugin-no-anonymous-default-export@3.5.43':\n    dependencies:\n      '@umijs/utils': 3.5.43\n\n  '@umijs/babel-preset-umi@3.5.43':\n    dependencies:\n      '@babel/runtime': 7.18.6\n      '@umijs/babel-plugin-auto-css-modules': 3.5.43\n      '@umijs/babel-plugin-import-to-await-require': 3.5.43\n      '@umijs/babel-plugin-lock-core-js-3': 3.5.43\n      '@umijs/babel-plugin-no-anonymous-default-export': 3.5.43\n      '@umijs/deps': 3.5.43\n      '@umijs/utils': 3.5.43\n\n  '@umijs/bundler-utils@3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)':\n    dependencies:\n      '@umijs/babel-preset-umi': 3.5.43\n      '@umijs/types': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/utils': 3.5.43\n    transitivePeerDependencies:\n      - react\n      - react-dom\n      - react-router\n\n  '@umijs/bundler-webpack@3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)':\n    dependencies:\n      '@umijs/bundler-utils': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/case-sensitive-paths-webpack-plugin': 1.0.1\n      '@umijs/deps': 3.5.43\n      '@umijs/types': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/utils': 3.5.43\n      jest-worker: 26.6.2\n      node-libs-browser: 2.2.1\n      normalize-url: 1.9.1\n      postcss: 7.0.32\n      postcss-flexbugs-fixes: 4.2.1\n      postcss-loader: 3.0.0\n      postcss-preset-env: 6.7.0\n      postcss-safe-parser: 4.0.2\n      terser: 5.14.2\n      webpack-chain: 6.5.1\n    transitivePeerDependencies:\n      - react\n      - react-dom\n      - react-router\n\n  '@umijs/case-sensitive-paths-webpack-plugin@1.0.1': {}\n\n  '@umijs/core@3.5.43':\n    dependencies:\n      '@umijs/ast': 3.5.43\n      '@umijs/babel-preset-umi': 3.5.43\n      '@umijs/deps': 3.5.43\n      '@umijs/utils': 3.5.43\n\n  '@umijs/deps@3.5.43':\n    dependencies:\n      '@bloomberg/record-tuple-polyfill': 0.0.3\n      chokidar: 3.5.1\n      clipboardy: 2.3.0\n      esbuild: 0.12.15\n      jest-worker: 24.9.0\n      prettier: 2.2.1\n      regenerate: 1.4.2\n      regenerate-unicode-properties: 10.0.1\n\n  '@umijs/plugin-access@2.4.3(@umijs/plugin-initial-state@2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(@umijs/plugin-model@2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      '@umijs/plugin-initial-state': 2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-model': 2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n\n  '@umijs/plugin-analytics@0.2.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n\n  '@umijs/plugin-antd@0.13.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      antd: 4.24.16(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      antd-mobile: 2.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      semver: 7.6.3\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  '@umijs/plugin-crossorigin@1.2.1(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n\n  '@umijs/plugin-dva@0.13.0(dva-core@2.0.4(redux@4.2.1))(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@17.0.2))(react@17.0.2)(redbox-react@1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      babel-plugin-dva-hmr: 0.4.2(redbox-react@1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2))\n      dva: 2.6.0-beta.23(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@16.14.0))(react@17.0.2)\n      dva-immer: 0.5.2(dva@2.6.0-beta.23(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@16.14.0))(react@17.0.2))\n      dva-loading: 3.0.25(dva-core@2.0.4(redux@4.2.1))\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n    transitivePeerDependencies:\n      - dva-core\n      - react\n      - react-dom\n      - react-native\n      - react-router\n      - redbox-react\n\n  '@umijs/plugin-helmet@1.1.3(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      '@types/react-helmet': 6.1.11\n      react-helmet: 6.1.0(react@17.0.2)\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n    transitivePeerDependencies:\n      - react\n\n  '@umijs/plugin-initial-state@2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n\n  '@umijs/plugin-layout@0.18.1(@ant-design/icons@4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(@ant-design/pro-layout@6.38.22(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(@umijs/plugin-initial-state@2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(@umijs/plugin-locale@0.15.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(@umijs/plugin-model@2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      '@ant-design/icons': 4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@ant-design/pro-layout': 6.38.22(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@umijs/plugin-initial-state': 2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-locale': 0.15.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-model': 2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/route-utils': 2.2.2\n      antd: 4.24.16(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      lodash: 4.17.21\n      path-to-regexp: 1.9.0\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  '@umijs/plugin-locale@0.15.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      '@ant-design/icons': 4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@formatjs/intl-pluralrules': 1.5.9\n      '@formatjs/intl-relativetimeformat': 4.5.16\n      intl: 1.2.5\n      moment: 2.30.1\n      react-intl: 3.12.1(react@17.0.2)\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n      warning: 4.0.3\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  '@umijs/plugin-model@2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      fast-deep-equal: 3.1.1\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n\n  '@umijs/plugin-request@2.8.0(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      '@ahooksjs/use-request': 2.8.15(react@17.0.2)\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n      umi-request: 1.4.0\n    transitivePeerDependencies:\n      - react\n\n  '@umijs/plugin-test@1.0.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      '@umijs/test': 3.5.43\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  '@umijs/preset-built-in@3.5.43(react-dom@16.14.0(react@16.14.0))(react@16.14.0)':\n    dependencies:\n      '@types/react-router-config': 5.0.2\n      '@umijs/babel-preset-umi': 3.5.43\n      '@umijs/bundler-webpack': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/core': 3.5.43\n      '@umijs/deps': 3.5.43\n      '@umijs/renderer-mpa': 3.5.43(react-dom@16.14.0(react@16.14.0))(react@16.14.0)\n      '@umijs/renderer-react': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/runtime': 3.5.43(react@16.14.0)\n      '@umijs/server': 3.5.43\n      '@umijs/types': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/utils': 3.5.43\n      ansi-html: 0.0.9\n      core-js: 3.6.5\n      core-js-pure: 3.39.0\n      error-stack-parser: 2.1.4\n      es-module-lexer: 0.7.1\n      es5-imcompatible-versions: 0.1.90\n      history-with-query: 4.10.4\n      html-entities: 2.5.2\n      mime: 1.4.1\n      react: 16.14.0\n      react-refresh: 0.10.0\n      react-router: 5.2.0(react@17.0.2)\n      react-router-config: 5.1.1(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      react-router-dom: 5.2.0(react@16.14.0)\n      regenerator-runtime: 0.13.5\n      schema-utils: 3.3.0\n    transitivePeerDependencies:\n      - react-dom\n\n  '@umijs/preset-react@1.8.32(@ant-design/icons@4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(@ant-design/pro-layout@6.38.22(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(dva-core@2.0.4(redux@4.2.1))(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@17.0.2))(react@17.0.2)(redbox-react@1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      '@umijs/plugin-access': 2.4.3(@umijs/plugin-initial-state@2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(@umijs/plugin-model@2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-analytics': 0.2.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-antd': 0.13.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-crossorigin': 1.2.1(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-dva': 0.13.0(dva-core@2.0.4(redux@4.2.1))(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@17.0.2))(react@17.0.2)(redbox-react@1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-helmet': 1.1.3(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-initial-state': 2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-layout': 0.18.1(@ant-design/icons@4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(@ant-design/pro-layout@6.38.22(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(@umijs/plugin-initial-state@2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(@umijs/plugin-locale@0.15.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(@umijs/plugin-model@2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-locale': 0.15.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-model': 2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-request': 2.8.0(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-test': 1.0.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n    transitivePeerDependencies:\n      - '@ant-design/icons'\n      - '@ant-design/pro-layout'\n      - bufferutil\n      - canvas\n      - dva-core\n      - react\n      - react-dom\n      - react-native\n      - react-router\n      - redbox-react\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  '@umijs/renderer-mpa@3.5.43(react-dom@16.14.0(react@16.14.0))(react@16.14.0)':\n    dependencies:\n      '@types/react': 16.14.62\n      '@types/react-dom': 16.9.25(@types/react@16.14.62)\n      '@umijs/runtime': 3.5.43(react@16.14.0)\n      react: 16.14.0\n      react-dom: 16.14.0(react@16.14.0)\n\n  '@umijs/renderer-react@3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)':\n    dependencies:\n      '@types/react': 16.14.62\n      '@types/react-dom': 16.9.25(@types/react@16.14.62)\n      '@types/react-router-config': 5.0.2\n      '@umijs/runtime': 3.5.43(react@16.14.0)\n      react: 16.14.0\n      react-dom: 16.14.0(react@16.14.0)\n      react-router-config: 5.1.1(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n    transitivePeerDependencies:\n      - react-router\n\n  '@umijs/route-utils@2.2.2':\n    dependencies:\n      '@qixian.cs/path-to-regexp': 6.1.0\n      fast-deep-equal: 3.1.3\n      lodash.isequal: 4.5.0\n      memoize-one: 5.2.1\n\n  '@umijs/runtime@3.5.43(react@16.14.0)':\n    dependencies:\n      '@types/react-router': 5.1.12\n      '@types/react-router-dom': 5.1.7\n      history-with-query: 4.10.4\n      react: 16.14.0\n      react-router: 5.2.0(react@16.14.0)\n      react-router-dom: 5.2.0(react@16.14.0)\n      use-subscription: 1.5.1(react@16.14.0)\n\n  '@umijs/server@3.5.43':\n    dependencies:\n      '@umijs/core': 3.5.43\n      '@umijs/deps': 3.5.43\n      '@umijs/utils': 3.5.43\n\n  '@umijs/ssr-darkreader@4.9.45': {}\n\n  '@umijs/test@3.5.43':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@umijs/babel-preset-umi': 3.5.43\n      '@umijs/utils': 3.5.43\n      babel-jest: 26.6.3(@babel/core@7.18.6)\n      core-js: 3.8.2\n      identity-obj-proxy: 3.0.0\n      jest: 26.6.3\n      jest-cli: 26.6.3\n      regenerator-runtime: 0.13.11\n      whatwg-fetch: 3.6.20\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  '@umijs/types@3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)':\n    dependencies:\n      '@umijs/babel-preset-umi': 3.5.43\n      '@umijs/core': 3.5.43\n      '@umijs/deps': 3.5.43\n      '@umijs/renderer-react': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/server': 3.5.43\n      '@umijs/utils': 3.5.43\n      webpack-chain: 6.5.1\n    transitivePeerDependencies:\n      - react\n      - react-dom\n      - react-router\n\n  '@umijs/use-params@1.0.9(react@17.0.2)':\n    dependencies:\n      react: 17.0.2\n\n  '@umijs/utils@3.5.43':\n    dependencies:\n      '@umijs/babel-preset-umi': 3.5.43\n      '@umijs/deps': 3.5.43\n\n  abab@2.0.6: {}\n\n  acorn-globals@6.0.0:\n    dependencies:\n      acorn: 7.4.1\n      acorn-walk: 7.2.0\n\n  acorn-walk@7.2.0: {}\n\n  acorn@7.4.1: {}\n\n  acorn@8.14.0: {}\n\n  add-dom-event-listener@1.1.0:\n    dependencies:\n      object-assign: 4.1.1\n\n  agent-base@6.0.2:\n    dependencies:\n      debug: 4.4.0\n    transitivePeerDependencies:\n      - supports-color\n\n  aggregate-error@3.1.0:\n    dependencies:\n      clean-stack: 2.2.0\n      indent-string: 4.0.0\n\n  ajv-errors@1.0.1(ajv@6.12.6):\n    dependencies:\n      ajv: 6.12.6\n\n  ajv-keywords@3.5.2(ajv@6.12.6):\n    dependencies:\n      ajv: 6.12.6\n\n  ajv@6.12.6:\n    dependencies:\n      fast-deep-equal: 3.1.3\n      fast-json-stable-stringify: 2.1.0\n      json-schema-traverse: 0.4.1\n      uri-js: 4.4.1\n\n  ansi-colors@4.1.3: {}\n\n  ansi-escapes@4.3.2:\n    dependencies:\n      type-fest: 0.21.3\n\n  ansi-html@0.0.9: {}\n\n  ansi-regex@5.0.1: {}\n\n  ansi-styles@3.2.1:\n    dependencies:\n      color-convert: 1.9.3\n\n  ansi-styles@4.3.0:\n    dependencies:\n      color-convert: 2.0.1\n\n  antd-mobile@2.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      array-tree-filter: 2.1.0\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      normalize.css: 7.0.0\n      rc-checkbox: 2.0.3\n      rc-collapse: 1.9.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-slider: 8.2.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-swipeout: 2.0.11\n      rmc-calendar: 1.1.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-cascader: 5.0.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-date-picker: 6.0.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-dialog: 1.1.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-drawer: 0.4.11\n      rmc-feedback: 2.0.0\n      rmc-input-number: 1.0.5\n      rmc-list-view: 0.11.5\n      rmc-notification: 1.0.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-nuka-carousel: 3.0.1\n      rmc-picker: 5.0.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-pull-to-refresh: 1.0.13\n      rmc-steps: 1.0.1\n      rmc-tabs: 1.2.29\n      rmc-tooltip: 1.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  antd@4.24.16(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@ant-design/colors': 6.0.0\n      '@ant-design/icons': 4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@ant-design/react-slick': 1.0.2(react@17.0.2)\n      '@babel/runtime': 7.26.0\n      '@ctrl/tinycolor': 3.6.1\n      classnames: 2.5.1\n      copy-to-clipboard: 3.3.3\n      lodash: 4.17.21\n      moment: 2.30.1\n      rc-cascader: 3.7.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-checkbox: 3.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-collapse: 3.4.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-dialog: 9.0.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-drawer: 6.3.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-dropdown: 4.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-field-form: 1.38.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-image: 5.13.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-input: 0.1.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-input-number: 7.3.11(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-mentions: 1.13.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-menu: 9.8.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-notification: 4.6.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-pagination: 3.2.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-picker: 2.7.6(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-progress: 3.4.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-rate: 2.9.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-resize-observer: 1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-segmented: 2.3.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-select: 14.1.18(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-slider: 10.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-steps: 5.0.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-switch: 3.2.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-table: 7.26.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-tabs: 12.5.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-textarea: 0.4.7(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-tooltip: 5.2.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-tree: 5.7.12(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-tree-select: 5.5.5(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-trigger: 5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-upload: 4.3.6(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      scroll-into-view-if-needed: 2.2.31\n\n  anymatch@2.0.0:\n    dependencies:\n      micromatch: 3.1.10\n      normalize-path: 2.1.1\n    transitivePeerDependencies:\n      - supports-color\n\n  anymatch@3.1.3:\n    dependencies:\n      normalize-path: 3.0.0\n      picomatch: 2.3.1\n\n  arch@2.2.0: {}\n\n  argparse@1.0.10:\n    dependencies:\n      sprintf-js: 1.0.3\n\n  arr-diff@4.0.0: {}\n\n  arr-flatten@1.1.0: {}\n\n  arr-union@3.1.0: {}\n\n  array-tree-filter@2.1.0: {}\n\n  array-unique@0.3.2: {}\n\n  asap@2.0.6: {}\n\n  asn1.js@4.10.1:\n    dependencies:\n      bn.js: 4.12.1\n      inherits: 2.0.4\n      minimalistic-assert: 1.0.1\n\n  assert@1.5.1:\n    dependencies:\n      object.assign: 4.1.5\n      util: 0.10.4\n\n  assign-symbols@1.0.0: {}\n\n  astral-regex@2.0.0: {}\n\n  async-validator@4.2.5: {}\n\n  asynckit@0.4.0: {}\n\n  atob@2.1.2: {}\n\n  autoprefixer@9.8.8:\n    dependencies:\n      browserslist: 4.24.2\n      caniuse-lite: 1.0.30001688\n      normalize-range: 0.1.2\n      num2fraction: 1.2.2\n      picocolors: 0.2.1\n      postcss: 7.0.32\n      postcss-value-parser: 4.2.0\n\n  babel-jest@26.6.3(@babel/core@7.18.6):\n    dependencies:\n      '@babel/core': 7.18.6\n      '@jest/transform': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/babel__core': 7.20.5\n      babel-plugin-istanbul: 6.1.1\n      babel-preset-jest: 26.6.2(@babel/core@7.18.6)\n      chalk: 4.1.2\n      graceful-fs: 4.2.11\n      slash: 3.0.0\n    transitivePeerDependencies:\n      - supports-color\n\n  babel-plugin-dva-hmr@0.4.2(redbox-react@1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)):\n    dependencies:\n      redbox-react: 1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n\n  babel-plugin-istanbul@6.1.1:\n    dependencies:\n      '@babel/helper-plugin-utils': 7.25.9\n      '@istanbuljs/load-nyc-config': 1.1.0\n      '@istanbuljs/schema': 0.1.3\n      istanbul-lib-instrument: 5.2.1\n      test-exclude: 6.0.0\n    transitivePeerDependencies:\n      - supports-color\n\n  babel-plugin-jest-hoist@26.6.2:\n    dependencies:\n      '@babel/template': 7.25.9\n      '@babel/types': 7.26.3\n      '@types/babel__core': 7.20.5\n      '@types/babel__traverse': 7.20.6\n\n  babel-preset-current-node-syntax@1.1.0(@babel/core@7.18.6):\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/plugin-syntax-async-generators': 7.8.4(@babel/core@7.18.6)\n      '@babel/plugin-syntax-bigint': 7.8.3(@babel/core@7.18.6)\n      '@babel/plugin-syntax-class-properties': 7.12.13(@babel/core@7.18.6)\n      '@babel/plugin-syntax-class-static-block': 7.14.5(@babel/core@7.18.6)\n      '@babel/plugin-syntax-import-attributes': 7.26.0(@babel/core@7.18.6)\n      '@babel/plugin-syntax-import-meta': 7.10.4(@babel/core@7.18.6)\n      '@babel/plugin-syntax-json-strings': 7.8.3(@babel/core@7.18.6)\n      '@babel/plugin-syntax-logical-assignment-operators': 7.10.4(@babel/core@7.18.6)\n      '@babel/plugin-syntax-nullish-coalescing-operator': 7.8.3(@babel/core@7.18.6)\n      '@babel/plugin-syntax-numeric-separator': 7.10.4(@babel/core@7.18.6)\n      '@babel/plugin-syntax-object-rest-spread': 7.8.3(@babel/core@7.18.6)\n      '@babel/plugin-syntax-optional-catch-binding': 7.8.3(@babel/core@7.18.6)\n      '@babel/plugin-syntax-optional-chaining': 7.8.3(@babel/core@7.18.6)\n      '@babel/plugin-syntax-private-property-in-object': 7.14.5(@babel/core@7.18.6)\n      '@babel/plugin-syntax-top-level-await': 7.14.5(@babel/core@7.18.6)\n\n  babel-preset-jest@26.6.2(@babel/core@7.18.6):\n    dependencies:\n      '@babel/core': 7.18.6\n      babel-plugin-jest-hoist: 26.6.2\n      babel-preset-current-node-syntax: 1.1.0(@babel/core@7.18.6)\n\n  babel-runtime@6.26.0:\n    dependencies:\n      core-js: 2.6.12\n      regenerator-runtime: 0.11.1\n\n  balanced-match@1.0.2: {}\n\n  base64-js@1.5.1: {}\n\n  base@0.11.2:\n    dependencies:\n      cache-base: 1.0.1\n      class-utils: 0.3.6\n      component-emitter: 1.3.1\n      define-property: 1.0.0\n      isobject: 3.0.1\n      mixin-deep: 1.3.2\n      pascalcase: 0.1.1\n\n  big.js@5.2.2: {}\n\n  binary-extensions@2.3.0: {}\n\n  bn.js@4.12.1: {}\n\n  bn.js@5.2.1: {}\n\n  brace-expansion@1.1.11:\n    dependencies:\n      balanced-match: 1.0.2\n      concat-map: 0.0.1\n\n  braces@2.3.2:\n    dependencies:\n      arr-flatten: 1.1.0\n      array-unique: 0.3.2\n      extend-shallow: 2.0.1\n      fill-range: 4.0.0\n      isobject: 3.0.1\n      repeat-element: 1.1.4\n      snapdragon: 0.8.2\n      snapdragon-node: 2.1.1\n      split-string: 3.1.0\n      to-regex: 3.0.2\n    transitivePeerDependencies:\n      - supports-color\n\n  braces@3.0.3:\n    dependencies:\n      fill-range: 7.1.1\n\n  brorand@1.1.0: {}\n\n  browser-process-hrtime@1.0.0: {}\n\n  browserify-aes@1.2.0:\n    dependencies:\n      buffer-xor: 1.0.3\n      cipher-base: 1.0.6\n      create-hash: 1.2.0\n      evp_bytestokey: 1.0.3\n      inherits: 2.0.4\n      safe-buffer: 5.2.1\n\n  browserify-cipher@1.0.1:\n    dependencies:\n      browserify-aes: 1.2.0\n      browserify-des: 1.0.2\n      evp_bytestokey: 1.0.3\n\n  browserify-des@1.0.2:\n    dependencies:\n      cipher-base: 1.0.6\n      des.js: 1.1.0\n      inherits: 2.0.4\n      safe-buffer: 5.2.1\n\n  browserify-rsa@4.1.1:\n    dependencies:\n      bn.js: 5.2.1\n      randombytes: 2.1.0\n      safe-buffer: 5.2.1\n\n  browserify-sign@4.2.3:\n    dependencies:\n      bn.js: 5.2.1\n      browserify-rsa: 4.1.1\n      create-hash: 1.2.0\n      create-hmac: 1.1.7\n      elliptic: 6.6.1\n      hash-base: 3.0.5\n      inherits: 2.0.4\n      parse-asn1: 5.1.7\n      readable-stream: 2.3.8\n      safe-buffer: 5.2.1\n\n  browserify-zlib@0.2.0:\n    dependencies:\n      pako: 1.0.11\n\n  browserslist@4.24.2:\n    dependencies:\n      caniuse-lite: 1.0.30001688\n      electron-to-chromium: 1.5.73\n      node-releases: 2.0.19\n      update-browserslist-db: 1.1.1(browserslist@4.24.2)\n\n  bser@2.1.1:\n    dependencies:\n      node-int64: 0.4.0\n\n  buffer-from@1.1.2: {}\n\n  buffer-xor@1.0.3: {}\n\n  buffer@4.9.2:\n    dependencies:\n      base64-js: 1.5.1\n      ieee754: 1.2.1\n      isarray: 1.0.0\n\n  builtin-status-codes@3.0.0: {}\n\n  cache-base@1.0.1:\n    dependencies:\n      collection-visit: 1.0.0\n      component-emitter: 1.3.1\n      get-value: 2.0.6\n      has-value: 1.0.0\n      isobject: 3.0.1\n      set-value: 2.0.1\n      to-object-path: 0.3.0\n      union-value: 1.0.1\n      unset-value: 1.0.0\n\n  call-bind-apply-helpers@1.0.1:\n    dependencies:\n      es-errors: 1.3.0\n      function-bind: 1.1.2\n\n  call-bind@1.0.8:\n    dependencies:\n      call-bind-apply-helpers: 1.0.1\n      es-define-property: 1.0.1\n      get-intrinsic: 1.2.6\n      set-function-length: 1.2.2\n\n  call-bound@1.0.2:\n    dependencies:\n      call-bind: 1.0.8\n      get-intrinsic: 1.2.6\n\n  caller-callsite@2.0.0:\n    dependencies:\n      callsites: 2.0.0\n\n  caller-path@2.0.0:\n    dependencies:\n      caller-callsite: 2.0.0\n\n  callsites@2.0.0: {}\n\n  callsites@3.1.0: {}\n\n  camelcase@5.3.1: {}\n\n  camelcase@6.3.0: {}\n\n  caniuse-lite@1.0.30001688: {}\n\n  capture-exit@2.0.0:\n    dependencies:\n      rsvp: 4.8.5\n\n  chalk@2.4.2:\n    dependencies:\n      ansi-styles: 3.2.1\n      escape-string-regexp: 1.0.5\n      supports-color: 5.5.0\n\n  chalk@4.1.2:\n    dependencies:\n      ansi-styles: 4.3.0\n      supports-color: 7.2.0\n\n  char-regex@1.0.2: {}\n\n  chokidar@3.5.1:\n    dependencies:\n      anymatch: 3.1.3\n      braces: 3.0.3\n      glob-parent: 5.1.2\n      is-binary-path: 2.1.0\n      is-glob: 4.0.3\n      normalize-path: 3.0.0\n      readdirp: 3.5.0\n    optionalDependencies:\n      fsevents: 2.3.3\n\n  ci-info@1.6.0: {}\n\n  ci-info@2.0.0: {}\n\n  cipher-base@1.0.6:\n    dependencies:\n      inherits: 2.0.4\n      safe-buffer: 5.2.1\n\n  cjs-module-lexer@0.6.0: {}\n\n  class-utils@0.3.6:\n    dependencies:\n      arr-union: 3.1.0\n      define-property: 0.2.5\n      isobject: 3.0.1\n      static-extend: 0.1.2\n\n  classnames@2.5.1: {}\n\n  clean-stack@2.2.0: {}\n\n  cli-cursor@3.1.0:\n    dependencies:\n      restore-cursor: 3.1.0\n\n  cli-truncate@2.1.0:\n    dependencies:\n      slice-ansi: 3.0.0\n      string-width: 4.2.3\n\n  clipboardy@2.3.0:\n    dependencies:\n      arch: 2.2.0\n      execa: 1.0.0\n      is-wsl: 2.2.0\n\n  cliui@6.0.0:\n    dependencies:\n      string-width: 4.2.3\n      strip-ansi: 6.0.1\n      wrap-ansi: 6.2.0\n\n  co@4.6.0: {}\n\n  collect-v8-coverage@1.0.2: {}\n\n  collection-visit@1.0.0:\n    dependencies:\n      map-visit: 1.0.0\n      object-visit: 1.0.1\n\n  color-convert@1.9.3:\n    dependencies:\n      color-name: 1.1.3\n\n  color-convert@2.0.1:\n    dependencies:\n      color-name: 1.1.4\n\n  color-name@1.1.3: {}\n\n  color-name@1.1.4: {}\n\n  colorette@2.0.20: {}\n\n  combined-stream@1.0.8:\n    dependencies:\n      delayed-stream: 1.0.0\n\n  commander@2.20.3: {}\n\n  commander@6.2.1: {}\n\n  component-classes@1.2.6:\n    dependencies:\n      component-indexof: 0.0.3\n\n  component-emitter@1.3.1: {}\n\n  component-indexof@0.0.3: {}\n\n  compute-scroll-into-view@1.0.20: {}\n\n  concat-map@0.0.1: {}\n\n  connected-react-router@6.5.2(history@4.10.1)(react-redux@7.2.9(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(react-router@5.2.0(react@16.14.0))(react@17.0.2)(redux@4.2.1):\n    dependencies:\n      history: 4.10.1\n      immutable: 3.8.2\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-redux: 7.2.9(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react-router: 5.2.0(react@17.0.2)\n      redux: 4.2.1\n      seamless-immutable: 7.1.4\n\n  console-browserify@1.2.0: {}\n\n  constants-browserify@1.0.0: {}\n\n  convert-source-map@1.9.0: {}\n\n  copy-descriptor@0.1.1: {}\n\n  copy-to-clipboard@3.3.3:\n    dependencies:\n      toggle-selection: 1.0.6\n\n  core-js-pure@3.39.0: {}\n\n  core-js@1.2.7: {}\n\n  core-js@2.6.12: {}\n\n  core-js@3.6.5: {}\n\n  core-js@3.8.2: {}\n\n  core-util-is@1.0.3: {}\n\n  cosmiconfig@5.2.1:\n    dependencies:\n      import-fresh: 2.0.0\n      is-directory: 0.3.1\n      js-yaml: 3.14.1\n      parse-json: 4.0.0\n\n  cosmiconfig@7.1.0:\n    dependencies:\n      '@types/parse-json': 4.0.2\n      import-fresh: 3.3.0\n      parse-json: 5.2.0\n      path-type: 4.0.0\n      yaml: 1.10.2\n\n  create-ecdh@4.0.4:\n    dependencies:\n      bn.js: 4.12.1\n      elliptic: 6.6.1\n\n  create-hash@1.2.0:\n    dependencies:\n      cipher-base: 1.0.6\n      inherits: 2.0.4\n      md5.js: 1.3.5\n      ripemd160: 2.0.2\n      sha.js: 2.4.11\n\n  create-hmac@1.1.7:\n    dependencies:\n      cipher-base: 1.0.6\n      create-hash: 1.2.0\n      inherits: 2.0.4\n      ripemd160: 2.0.2\n      safe-buffer: 5.2.1\n      sha.js: 2.4.11\n\n  create-react-class@15.7.0:\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n\n  cross-spawn@5.1.0:\n    dependencies:\n      lru-cache: 4.1.5\n      shebang-command: 1.2.0\n      which: 1.3.1\n\n  cross-spawn@6.0.6:\n    dependencies:\n      nice-try: 1.0.5\n      path-key: 2.0.1\n      semver: 5.7.2\n      shebang-command: 1.2.0\n      which: 1.3.1\n\n  cross-spawn@7.0.6:\n    dependencies:\n      path-key: 3.1.1\n      shebang-command: 2.0.0\n      which: 2.0.2\n\n  crypto-browserify@3.12.1:\n    dependencies:\n      browserify-cipher: 1.0.1\n      browserify-sign: 4.2.3\n      create-ecdh: 4.0.4\n      create-hash: 1.2.0\n      create-hmac: 1.1.7\n      diffie-hellman: 5.0.3\n      hash-base: 3.0.5\n      inherits: 2.0.4\n      pbkdf2: 3.1.2\n      public-encrypt: 4.0.3\n      randombytes: 2.1.0\n      randomfill: 1.0.4\n\n  css-animation@1.6.1:\n    dependencies:\n      babel-runtime: 6.26.0\n      component-classes: 1.2.6\n\n  css-blank-pseudo@0.1.4:\n    dependencies:\n      postcss: 7.0.32\n\n  css-has-pseudo@0.10.0:\n    dependencies:\n      postcss: 7.0.32\n      postcss-selector-parser: 5.0.0\n\n  css-prefers-color-scheme@3.1.1:\n    dependencies:\n      postcss: 7.0.32\n\n  cssdb@4.4.0: {}\n\n  cssesc@2.0.0: {}\n\n  cssesc@3.0.0: {}\n\n  cssom@0.3.8: {}\n\n  cssom@0.4.4: {}\n\n  cssstyle@2.3.0:\n    dependencies:\n      cssom: 0.3.8\n\n  csstype@3.1.3: {}\n\n  data-urls@2.0.0:\n    dependencies:\n      abab: 2.0.6\n      whatwg-mimetype: 2.3.0\n      whatwg-url: 8.7.0\n\n  date-fns@2.30.0:\n    dependencies:\n      '@babel/runtime': 7.26.0\n\n  dayjs@1.11.13: {}\n\n  debug@2.6.9:\n    dependencies:\n      ms: 2.0.0\n\n  debug@4.4.0:\n    dependencies:\n      ms: 2.1.3\n\n  decamelize@1.2.0: {}\n\n  decimal.js@10.4.3: {}\n\n  decode-uri-component@0.2.2: {}\n\n  dedent@0.7.0: {}\n\n  deepmerge@1.5.2: {}\n\n  deepmerge@4.3.1: {}\n\n  define-data-property@1.1.4:\n    dependencies:\n      es-define-property: 1.0.1\n      es-errors: 1.3.0\n      gopd: 1.2.0\n\n  define-properties@1.2.1:\n    dependencies:\n      define-data-property: 1.1.4\n      has-property-descriptors: 1.0.2\n      object-keys: 1.1.1\n\n  define-property@0.2.5:\n    dependencies:\n      is-descriptor: 0.1.7\n\n  define-property@1.0.0:\n    dependencies:\n      is-descriptor: 1.0.3\n\n  define-property@2.0.2:\n    dependencies:\n      is-descriptor: 1.0.3\n      isobject: 3.0.1\n\n  delayed-stream@1.0.0: {}\n\n  des.js@1.1.0:\n    dependencies:\n      inherits: 2.0.4\n      minimalistic-assert: 1.0.1\n\n  detect-newline@3.1.0: {}\n\n  diff-sequences@26.6.2: {}\n\n  diffie-hellman@5.0.3:\n    dependencies:\n      bn.js: 4.12.1\n      miller-rabin: 4.0.1\n      randombytes: 2.1.0\n\n  dom-align@1.12.4: {}\n\n  dom-walk@0.1.2: {}\n\n  domain-browser@1.2.0: {}\n\n  domexception@2.0.1:\n    dependencies:\n      webidl-conversions: 5.0.0\n\n  dunder-proto@1.0.0:\n    dependencies:\n      call-bind-apply-helpers: 1.0.1\n      es-errors: 1.3.0\n      gopd: 1.2.0\n\n  dva-core@2.0.4(redux@4.2.1):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      flatten: 1.0.3\n      global: 4.4.0\n      invariant: 2.2.4\n      is-plain-object: 2.0.4\n      redux: 4.2.1\n      redux-saga: 0.16.2\n      warning: 3.0.0\n\n  dva-immer@0.5.2(dva@2.6.0-beta.23(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@16.14.0))(react@17.0.2)):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      dva: 2.6.0-beta.23(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@16.14.0))(react@17.0.2)\n      immer: 7.0.15\n\n  dva-loading@3.0.25(dva-core@2.0.4(redux@4.2.1)):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      dva-core: 2.0.4(redux@4.2.1)\n\n  dva@2.6.0-beta.23(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@16.14.0))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      '@types/isomorphic-fetch': 0.0.35\n      '@types/react-redux': 7.1.34\n      '@types/react-router-dom': 5.3.3\n      connected-react-router: 6.5.2(history@4.10.1)(react-redux@7.2.9(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(react-router@5.2.0(react@16.14.0))(react@17.0.2)(redux@4.2.1)\n      dva-core: 2.0.4(redux@4.2.1)\n      global: 4.4.0\n      history: 4.10.1\n      invariant: 2.2.4\n      isomorphic-fetch: 2.2.1\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      react-redux: 7.2.9(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react-router-dom: 5.3.4(react@17.0.2)\n      redux: 4.2.1\n    transitivePeerDependencies:\n      - react-native\n      - react-router\n\n  electron-to-chromium@1.5.73: {}\n\n  elliptic@6.6.1:\n    dependencies:\n      bn.js: 4.12.1\n      brorand: 1.1.0\n      hash.js: 1.1.7\n      hmac-drbg: 1.0.1\n      inherits: 2.0.4\n      minimalistic-assert: 1.0.1\n      minimalistic-crypto-utils: 1.0.1\n\n  emittery@0.7.2: {}\n\n  emoji-regex@8.0.0: {}\n\n  emojis-list@3.0.0: {}\n\n  encoding@0.1.13:\n    dependencies:\n      iconv-lite: 0.6.3\n\n  end-of-stream@1.4.4:\n    dependencies:\n      once: 1.4.0\n\n  enquirer@2.4.1:\n    dependencies:\n      ansi-colors: 4.1.3\n      strip-ansi: 6.0.1\n\n  error-ex@1.3.2:\n    dependencies:\n      is-arrayish: 0.2.1\n\n  error-stack-parser@1.3.6:\n    dependencies:\n      stackframe: 0.3.1\n\n  error-stack-parser@2.1.4:\n    dependencies:\n      stackframe: 1.3.4\n\n  es-define-property@1.0.1: {}\n\n  es-errors@1.3.0: {}\n\n  es-module-lexer@0.7.1: {}\n\n  es-object-atoms@1.0.0:\n    dependencies:\n      es-errors: 1.3.0\n\n  es5-imcompatible-versions@0.1.90: {}\n\n  esbuild@0.12.15: {}\n\n  escalade@3.2.0: {}\n\n  escape-string-regexp@1.0.5: {}\n\n  escape-string-regexp@2.0.0: {}\n\n  escodegen@2.1.0:\n    dependencies:\n      esprima: 4.0.1\n      estraverse: 5.3.0\n      esutils: 2.0.3\n    optionalDependencies:\n      source-map: 0.6.1\n\n  esprima@4.0.1: {}\n\n  estraverse@5.3.0: {}\n\n  esutils@2.0.3: {}\n\n  events@3.3.0: {}\n\n  evp_bytestokey@1.0.3:\n    dependencies:\n      md5.js: 1.3.5\n      safe-buffer: 5.2.1\n\n  exec-sh@0.3.6: {}\n\n  execa@0.8.0:\n    dependencies:\n      cross-spawn: 5.1.0\n      get-stream: 3.0.0\n      is-stream: 1.1.0\n      npm-run-path: 2.0.2\n      p-finally: 1.0.0\n      signal-exit: 3.0.7\n      strip-eof: 1.0.0\n\n  execa@1.0.0:\n    dependencies:\n      cross-spawn: 6.0.6\n      get-stream: 4.1.0\n      is-stream: 1.1.0\n      npm-run-path: 2.0.2\n      p-finally: 1.0.0\n      signal-exit: 3.0.7\n      strip-eof: 1.0.0\n\n  execa@4.1.0:\n    dependencies:\n      cross-spawn: 7.0.6\n      get-stream: 5.2.0\n      human-signals: 1.1.1\n      is-stream: 2.0.1\n      merge-stream: 2.0.0\n      npm-run-path: 4.0.1\n      onetime: 5.1.2\n      signal-exit: 3.0.7\n      strip-final-newline: 2.0.0\n\n  exenv@1.2.2: {}\n\n  exit@0.1.2: {}\n\n  expand-brackets@2.1.4:\n    dependencies:\n      debug: 2.6.9\n      define-property: 0.2.5\n      extend-shallow: 2.0.1\n      posix-character-classes: 0.1.1\n      regex-not: 1.0.2\n      snapdragon: 0.8.2\n      to-regex: 3.0.2\n    transitivePeerDependencies:\n      - supports-color\n\n  expect@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      ansi-styles: 4.3.0\n      jest-get-type: 26.3.0\n      jest-matcher-utils: 26.6.2\n      jest-message-util: 26.6.2\n      jest-regex-util: 26.0.0\n\n  extend-shallow@2.0.1:\n    dependencies:\n      is-extendable: 0.1.1\n\n  extend-shallow@3.0.2:\n    dependencies:\n      assign-symbols: 1.0.0\n      is-extendable: 1.0.1\n\n  extglob@2.0.4:\n    dependencies:\n      array-unique: 0.3.2\n      define-property: 1.0.0\n      expand-brackets: 2.1.4\n      extend-shallow: 2.0.1\n      fragment-cache: 0.2.1\n      regex-not: 1.0.2\n      snapdragon: 0.8.2\n      to-regex: 3.0.2\n    transitivePeerDependencies:\n      - supports-color\n\n  fast-deep-equal@3.1.1: {}\n\n  fast-deep-equal@3.1.3: {}\n\n  fast-json-stable-stringify@2.1.0: {}\n\n  fb-watchman@2.0.2:\n    dependencies:\n      bser: 2.1.1\n\n  fbjs@0.8.18:\n    dependencies:\n      core-js: 1.2.7\n      isomorphic-fetch: 2.2.1\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n      promise: 7.3.1\n      setimmediate: 1.0.5\n      ua-parser-js: 0.7.39\n\n  fill-range@4.0.0:\n    dependencies:\n      extend-shallow: 2.0.1\n      is-number: 3.0.0\n      repeat-string: 1.6.1\n      to-regex-range: 2.1.1\n\n  fill-range@7.1.1:\n    dependencies:\n      to-regex-range: 5.0.1\n\n  filter-obj@1.1.0: {}\n\n  find-up@4.1.0:\n    dependencies:\n      locate-path: 5.0.0\n      path-exists: 4.0.0\n\n  flatten@1.0.3: {}\n\n  for-in@1.0.2: {}\n\n  form-data@3.0.2:\n    dependencies:\n      asynckit: 0.4.0\n      combined-stream: 1.0.8\n      mime-types: 2.1.35\n\n  fragment-cache@0.2.1:\n    dependencies:\n      map-cache: 0.2.2\n\n  fs.realpath@1.0.0: {}\n\n  fsevents@2.3.3:\n    optional: true\n\n  function-bind@1.1.2: {}\n\n  gensync@1.0.0-beta.2: {}\n\n  get-caller-file@2.0.5: {}\n\n  get-intrinsic@1.2.6:\n    dependencies:\n      call-bind-apply-helpers: 1.0.1\n      dunder-proto: 1.0.0\n      es-define-property: 1.0.1\n      es-errors: 1.3.0\n      es-object-atoms: 1.0.0\n      function-bind: 1.1.2\n      gopd: 1.2.0\n      has-symbols: 1.1.0\n      hasown: 2.0.2\n      math-intrinsics: 1.0.0\n\n  get-own-enumerable-property-symbols@3.0.2: {}\n\n  get-package-type@0.1.0: {}\n\n  get-stream@3.0.0: {}\n\n  get-stream@4.1.0:\n    dependencies:\n      pump: 3.0.2\n\n  get-stream@5.2.0:\n    dependencies:\n      pump: 3.0.2\n\n  get-value@2.0.6: {}\n\n  glob-parent@5.1.2:\n    dependencies:\n      is-glob: 4.0.3\n\n  glob@7.2.3:\n    dependencies:\n      fs.realpath: 1.0.0\n      inflight: 1.0.6\n      inherits: 2.0.4\n      minimatch: 3.1.2\n      once: 1.4.0\n      path-is-absolute: 1.0.1\n\n  global@4.4.0:\n    dependencies:\n      min-document: 2.19.0\n      process: 0.11.10\n\n  globals@11.12.0: {}\n\n  gopd@1.2.0: {}\n\n  graceful-fs@4.2.11: {}\n\n  growly@1.3.0:\n    optional: true\n\n  harmony-reflect@1.6.2: {}\n\n  has-flag@3.0.0: {}\n\n  has-flag@4.0.0: {}\n\n  has-property-descriptors@1.0.2:\n    dependencies:\n      es-define-property: 1.0.1\n\n  has-symbols@1.1.0: {}\n\n  has-value@0.3.1:\n    dependencies:\n      get-value: 2.0.6\n      has-values: 0.1.4\n      isobject: 2.1.0\n\n  has-value@1.0.0:\n    dependencies:\n      get-value: 2.0.6\n      has-values: 1.0.0\n      isobject: 3.0.1\n\n  has-values@0.1.4: {}\n\n  has-values@1.0.0:\n    dependencies:\n      is-number: 3.0.0\n      kind-of: 4.0.0\n\n  hash-base@3.0.5:\n    dependencies:\n      inherits: 2.0.4\n      safe-buffer: 5.2.1\n\n  hash.js@1.1.7:\n    dependencies:\n      inherits: 2.0.4\n      minimalistic-assert: 1.0.1\n\n  hasown@2.0.2:\n    dependencies:\n      function-bind: 1.1.2\n\n  history-with-query@4.10.4:\n    dependencies:\n      '@babel/runtime': 7.26.0\n      loose-envify: 1.4.0\n      query-string: 6.14.1\n      resolve-pathname: 3.0.0\n      tiny-invariant: 1.3.3\n      tiny-warning: 1.0.3\n      value-equal: 1.0.1\n\n  history@4.10.1:\n    dependencies:\n      '@babel/runtime': 7.26.0\n      loose-envify: 1.4.0\n      resolve-pathname: 3.0.0\n      tiny-invariant: 1.3.3\n      tiny-warning: 1.0.3\n      value-equal: 1.0.1\n\n  history@5.3.0:\n    dependencies:\n      '@babel/runtime': 7.26.0\n\n  hmac-drbg@1.0.1:\n    dependencies:\n      hash.js: 1.1.7\n      minimalistic-assert: 1.0.1\n      minimalistic-crypto-utils: 1.0.1\n\n  hoist-non-react-statics@3.3.2:\n    dependencies:\n      react-is: 16.13.1\n\n  hosted-git-info@2.8.9: {}\n\n  html-encoding-sniffer@2.0.1:\n    dependencies:\n      whatwg-encoding: 1.0.5\n\n  html-entities@2.5.2: {}\n\n  html-escaper@2.0.2: {}\n\n  http-proxy-agent@4.0.1:\n    dependencies:\n      '@tootallnate/once': 1.1.2\n      agent-base: 6.0.2\n      debug: 4.4.0\n    transitivePeerDependencies:\n      - supports-color\n\n  https-browserify@1.0.0: {}\n\n  https-proxy-agent@5.0.1:\n    dependencies:\n      agent-base: 6.0.2\n      debug: 4.4.0\n    transitivePeerDependencies:\n      - supports-color\n\n  human-signals@1.1.1: {}\n\n  iconv-lite@0.4.24:\n    dependencies:\n      safer-buffer: 2.1.2\n\n  iconv-lite@0.6.3:\n    dependencies:\n      safer-buffer: 2.1.2\n\n  identity-obj-proxy@3.0.0:\n    dependencies:\n      harmony-reflect: 1.6.2\n\n  ieee754@1.2.1: {}\n\n  immer@7.0.15: {}\n\n  immutable@3.8.2: {}\n\n  import-cwd@2.1.0:\n    dependencies:\n      import-from: 2.1.0\n\n  import-fresh@2.0.0:\n    dependencies:\n      caller-path: 2.0.0\n      resolve-from: 3.0.0\n\n  import-fresh@3.3.0:\n    dependencies:\n      parent-module: 1.0.1\n      resolve-from: 4.0.0\n\n  import-from@2.1.0:\n    dependencies:\n      resolve-from: 3.0.0\n\n  import-local@3.2.0:\n    dependencies:\n      pkg-dir: 4.2.0\n      resolve-cwd: 3.0.0\n\n  imurmurhash@0.1.4: {}\n\n  indent-string@4.0.0: {}\n\n  indexes-of@1.0.1: {}\n\n  inflight@1.0.6:\n    dependencies:\n      once: 1.4.0\n      wrappy: 1.0.2\n\n  inherits@2.0.3: {}\n\n  inherits@2.0.4: {}\n\n  intl-format-cache@4.3.1: {}\n\n  intl-messageformat-parser@3.6.4:\n    dependencies:\n      '@formatjs/intl-unified-numberformat': 3.3.7\n\n  intl-messageformat@7.8.4:\n    dependencies:\n      intl-format-cache: 4.3.1\n      intl-messageformat-parser: 3.6.4\n\n  intl@1.2.5: {}\n\n  invariant@2.2.4:\n    dependencies:\n      loose-envify: 1.4.0\n\n  is-accessor-descriptor@1.0.1:\n    dependencies:\n      hasown: 2.0.2\n\n  is-arrayish@0.2.1: {}\n\n  is-binary-path@2.1.0:\n    dependencies:\n      binary-extensions: 2.3.0\n\n  is-buffer@1.1.6: {}\n\n  is-ci@1.2.1:\n    dependencies:\n      ci-info: 1.6.0\n\n  is-ci@2.0.0:\n    dependencies:\n      ci-info: 2.0.0\n\n  is-core-module@2.15.1:\n    dependencies:\n      hasown: 2.0.2\n\n  is-data-descriptor@1.0.1:\n    dependencies:\n      hasown: 2.0.2\n\n  is-descriptor@0.1.7:\n    dependencies:\n      is-accessor-descriptor: 1.0.1\n      is-data-descriptor: 1.0.1\n\n  is-descriptor@1.0.3:\n    dependencies:\n      is-accessor-descriptor: 1.0.1\n      is-data-descriptor: 1.0.1\n\n  is-directory@0.3.1: {}\n\n  is-docker@2.2.1: {}\n\n  is-extendable@0.1.1: {}\n\n  is-extendable@1.0.1:\n    dependencies:\n      is-plain-object: 2.0.4\n\n  is-extglob@2.1.1: {}\n\n  is-fullwidth-code-point@3.0.0: {}\n\n  is-generator-fn@2.1.0: {}\n\n  is-glob@4.0.3:\n    dependencies:\n      is-extglob: 2.1.1\n\n  is-number@3.0.0:\n    dependencies:\n      kind-of: 3.2.2\n\n  is-number@7.0.0: {}\n\n  is-obj@1.0.1: {}\n\n  is-plain-obj@1.1.0: {}\n\n  is-plain-object@2.0.4:\n    dependencies:\n      isobject: 3.0.1\n\n  is-potential-custom-element-name@1.0.1: {}\n\n  is-regexp@1.0.0: {}\n\n  is-stream@1.1.0: {}\n\n  is-stream@2.0.1: {}\n\n  is-typedarray@1.0.0: {}\n\n  is-unicode-supported@0.1.0: {}\n\n  is-windows@1.0.2: {}\n\n  is-wsl@2.2.0:\n    dependencies:\n      is-docker: 2.2.1\n\n  isarray@0.0.1: {}\n\n  isarray@1.0.0: {}\n\n  isexe@2.0.0: {}\n\n  isobject@2.1.0:\n    dependencies:\n      isarray: 1.0.0\n\n  isobject@3.0.1: {}\n\n  isomorphic-fetch@2.2.1:\n    dependencies:\n      node-fetch: 1.7.3\n      whatwg-fetch: 3.6.20\n\n  istanbul-lib-coverage@3.2.2: {}\n\n  istanbul-lib-instrument@4.0.3:\n    dependencies:\n      '@babel/core': 7.18.6\n      '@istanbuljs/schema': 0.1.3\n      istanbul-lib-coverage: 3.2.2\n      semver: 6.3.1\n    transitivePeerDependencies:\n      - supports-color\n\n  istanbul-lib-instrument@5.2.1:\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/parser': 7.26.3\n      '@istanbuljs/schema': 0.1.3\n      istanbul-lib-coverage: 3.2.2\n      semver: 6.3.1\n    transitivePeerDependencies:\n      - supports-color\n\n  istanbul-lib-report@3.0.1:\n    dependencies:\n      istanbul-lib-coverage: 3.2.2\n      make-dir: 4.0.0\n      supports-color: 7.2.0\n\n  istanbul-lib-source-maps@4.0.1:\n    dependencies:\n      debug: 4.4.0\n      istanbul-lib-coverage: 3.2.2\n      source-map: 0.6.1\n    transitivePeerDependencies:\n      - supports-color\n\n  istanbul-reports@3.1.7:\n    dependencies:\n      html-escaper: 2.0.2\n      istanbul-lib-report: 3.0.1\n\n  javascript-stringify@2.1.0: {}\n\n  jest-changed-files@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      execa: 4.1.0\n      throat: 5.0.0\n\n  jest-cli@26.6.3:\n    dependencies:\n      '@jest/core': 26.6.3\n      '@jest/test-result': 26.6.2\n      '@jest/types': 26.6.2\n      chalk: 4.1.2\n      exit: 0.1.2\n      graceful-fs: 4.2.11\n      import-local: 3.2.0\n      is-ci: 2.0.0\n      jest-config: 26.6.3\n      jest-util: 26.6.2\n      jest-validate: 26.6.2\n      prompts: 2.4.2\n      yargs: 15.4.1\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  jest-config@26.6.3:\n    dependencies:\n      '@babel/core': 7.18.6\n      '@jest/test-sequencer': 26.6.3\n      '@jest/types': 26.6.2\n      babel-jest: 26.6.3(@babel/core@7.18.6)\n      chalk: 4.1.2\n      deepmerge: 4.3.1\n      glob: 7.2.3\n      graceful-fs: 4.2.11\n      jest-environment-jsdom: 26.6.2\n      jest-environment-node: 26.6.2\n      jest-get-type: 26.3.0\n      jest-jasmine2: 26.6.3\n      jest-regex-util: 26.0.0\n      jest-resolve: 26.6.2\n      jest-util: 26.6.2\n      jest-validate: 26.6.2\n      micromatch: 4.0.8\n      pretty-format: 26.6.2\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - utf-8-validate\n\n  jest-diff@26.6.2:\n    dependencies:\n      chalk: 4.1.2\n      diff-sequences: 26.6.2\n      jest-get-type: 26.3.0\n      pretty-format: 26.6.2\n\n  jest-docblock@26.0.0:\n    dependencies:\n      detect-newline: 3.1.0\n\n  jest-each@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      chalk: 4.1.2\n      jest-get-type: 26.3.0\n      jest-util: 26.6.2\n      pretty-format: 26.6.2\n\n  jest-environment-jsdom@26.6.2:\n    dependencies:\n      '@jest/environment': 26.6.2\n      '@jest/fake-timers': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      jest-mock: 26.6.2\n      jest-util: 26.6.2\n      jsdom: 16.7.0\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - utf-8-validate\n\n  jest-environment-node@26.6.2:\n    dependencies:\n      '@jest/environment': 26.6.2\n      '@jest/fake-timers': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      jest-mock: 26.6.2\n      jest-util: 26.6.2\n\n  jest-get-type@26.3.0: {}\n\n  jest-haste-map@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      '@types/graceful-fs': 4.1.9\n      '@types/node': 22.10.2\n      anymatch: 3.1.3\n      fb-watchman: 2.0.2\n      graceful-fs: 4.2.11\n      jest-regex-util: 26.0.0\n      jest-serializer: 26.6.2\n      jest-util: 26.6.2\n      jest-worker: 26.6.2\n      micromatch: 4.0.8\n      sane: 4.1.0\n      walker: 1.0.8\n    optionalDependencies:\n      fsevents: 2.3.3\n    transitivePeerDependencies:\n      - supports-color\n\n  jest-jasmine2@26.6.3:\n    dependencies:\n      '@babel/traverse': 7.26.4\n      '@jest/environment': 26.6.2\n      '@jest/source-map': 26.6.2\n      '@jest/test-result': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      chalk: 4.1.2\n      co: 4.6.0\n      expect: 26.6.2\n      is-generator-fn: 2.1.0\n      jest-each: 26.6.2\n      jest-matcher-utils: 26.6.2\n      jest-message-util: 26.6.2\n      jest-runtime: 26.6.3\n      jest-snapshot: 26.6.2\n      jest-util: 26.6.2\n      pretty-format: 26.6.2\n      throat: 5.0.0\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  jest-leak-detector@26.6.2:\n    dependencies:\n      jest-get-type: 26.3.0\n      pretty-format: 26.6.2\n\n  jest-matcher-utils@26.6.2:\n    dependencies:\n      chalk: 4.1.2\n      jest-diff: 26.6.2\n      jest-get-type: 26.3.0\n      pretty-format: 26.6.2\n\n  jest-message-util@26.6.2:\n    dependencies:\n      '@babel/code-frame': 7.26.2\n      '@jest/types': 26.6.2\n      '@types/stack-utils': 2.0.3\n      chalk: 4.1.2\n      graceful-fs: 4.2.11\n      micromatch: 4.0.8\n      pretty-format: 26.6.2\n      slash: 3.0.0\n      stack-utils: 2.0.6\n\n  jest-mock@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n\n  jest-pnp-resolver@1.2.3(jest-resolve@26.6.2):\n    optionalDependencies:\n      jest-resolve: 26.6.2\n\n  jest-regex-util@26.0.0: {}\n\n  jest-resolve-dependencies@26.6.3:\n    dependencies:\n      '@jest/types': 26.6.2\n      jest-regex-util: 26.0.0\n      jest-snapshot: 26.6.2\n    transitivePeerDependencies:\n      - supports-color\n\n  jest-resolve@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      chalk: 4.1.2\n      graceful-fs: 4.2.11\n      jest-pnp-resolver: 1.2.3(jest-resolve@26.6.2)\n      jest-util: 26.6.2\n      read-pkg-up: 7.0.1\n      resolve: 1.22.8\n      slash: 3.0.0\n\n  jest-runner@26.6.3:\n    dependencies:\n      '@jest/console': 26.6.2\n      '@jest/environment': 26.6.2\n      '@jest/test-result': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      chalk: 4.1.2\n      emittery: 0.7.2\n      exit: 0.1.2\n      graceful-fs: 4.2.11\n      jest-config: 26.6.3\n      jest-docblock: 26.0.0\n      jest-haste-map: 26.6.2\n      jest-leak-detector: 26.6.2\n      jest-message-util: 26.6.2\n      jest-resolve: 26.6.2\n      jest-runtime: 26.6.3\n      jest-util: 26.6.2\n      jest-worker: 26.6.2\n      source-map-support: 0.5.21\n      throat: 5.0.0\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  jest-runtime@26.6.3:\n    dependencies:\n      '@jest/console': 26.6.2\n      '@jest/environment': 26.6.2\n      '@jest/fake-timers': 26.6.2\n      '@jest/globals': 26.6.2\n      '@jest/source-map': 26.6.2\n      '@jest/test-result': 26.6.2\n      '@jest/transform': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/yargs': 15.0.19\n      chalk: 4.1.2\n      cjs-module-lexer: 0.6.0\n      collect-v8-coverage: 1.0.2\n      exit: 0.1.2\n      glob: 7.2.3\n      graceful-fs: 4.2.11\n      jest-config: 26.6.3\n      jest-haste-map: 26.6.2\n      jest-message-util: 26.6.2\n      jest-mock: 26.6.2\n      jest-regex-util: 26.0.0\n      jest-resolve: 26.6.2\n      jest-snapshot: 26.6.2\n      jest-util: 26.6.2\n      jest-validate: 26.6.2\n      slash: 3.0.0\n      strip-bom: 4.0.0\n      yargs: 15.4.1\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  jest-serializer@26.6.2:\n    dependencies:\n      '@types/node': 22.10.2\n      graceful-fs: 4.2.11\n\n  jest-snapshot@26.6.2:\n    dependencies:\n      '@babel/types': 7.26.3\n      '@jest/types': 26.6.2\n      '@types/babel__traverse': 7.20.6\n      '@types/prettier': 2.7.3\n      chalk: 4.1.2\n      expect: 26.6.2\n      graceful-fs: 4.2.11\n      jest-diff: 26.6.2\n      jest-get-type: 26.3.0\n      jest-haste-map: 26.6.2\n      jest-matcher-utils: 26.6.2\n      jest-message-util: 26.6.2\n      jest-resolve: 26.6.2\n      natural-compare: 1.4.0\n      pretty-format: 26.6.2\n      semver: 7.6.3\n    transitivePeerDependencies:\n      - supports-color\n\n  jest-util@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      chalk: 4.1.2\n      graceful-fs: 4.2.11\n      is-ci: 2.0.0\n      micromatch: 4.0.8\n\n  jest-validate@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      camelcase: 6.3.0\n      chalk: 4.1.2\n      jest-get-type: 26.3.0\n      leven: 3.1.0\n      pretty-format: 26.6.2\n\n  jest-watcher@26.6.2:\n    dependencies:\n      '@jest/test-result': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      ansi-escapes: 4.3.2\n      chalk: 4.1.2\n      jest-util: 26.6.2\n      string-length: 4.0.2\n\n  jest-worker@24.9.0:\n    dependencies:\n      merge-stream: 2.0.0\n      supports-color: 6.1.0\n\n  jest-worker@26.6.2:\n    dependencies:\n      '@types/node': 22.10.2\n      merge-stream: 2.0.0\n      supports-color: 7.2.0\n\n  jest@26.6.3:\n    dependencies:\n      '@jest/core': 26.6.3\n      import-local: 3.2.0\n      jest-cli: 26.6.3\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  js-tokens@4.0.0: {}\n\n  js-yaml@3.14.1:\n    dependencies:\n      argparse: 1.0.10\n      esprima: 4.0.1\n\n  jsdom@16.7.0:\n    dependencies:\n      abab: 2.0.6\n      acorn: 8.14.0\n      acorn-globals: 6.0.0\n      cssom: 0.4.4\n      cssstyle: 2.3.0\n      data-urls: 2.0.0\n      decimal.js: 10.4.3\n      domexception: 2.0.1\n      escodegen: 2.1.0\n      form-data: 3.0.2\n      html-encoding-sniffer: 2.0.1\n      http-proxy-agent: 4.0.1\n      https-proxy-agent: 5.0.1\n      is-potential-custom-element-name: 1.0.1\n      nwsapi: 2.2.16\n      parse5: 6.0.1\n      saxes: 5.0.1\n      symbol-tree: 3.2.4\n      tough-cookie: 4.1.4\n      w3c-hr-time: 1.0.2\n      w3c-xmlserializer: 2.0.0\n      webidl-conversions: 6.1.0\n      whatwg-encoding: 1.0.5\n      whatwg-mimetype: 2.3.0\n      whatwg-url: 8.7.0\n      ws: 7.5.10\n      xml-name-validator: 3.0.0\n    transitivePeerDependencies:\n      - bufferutil\n      - supports-color\n      - utf-8-validate\n\n  jsesc@3.1.0: {}\n\n  json-parse-better-errors@1.0.2: {}\n\n  json-parse-even-better-errors@2.3.1: {}\n\n  json-schema-traverse@0.4.1: {}\n\n  json2mq@0.2.0:\n    dependencies:\n      string-convert: 0.2.1\n\n  json5@1.0.2:\n    dependencies:\n      minimist: 1.2.8\n\n  json5@2.2.3: {}\n\n  kind-of@3.2.2:\n    dependencies:\n      is-buffer: 1.1.6\n\n  kind-of@4.0.0:\n    dependencies:\n      is-buffer: 1.1.6\n\n  kind-of@6.0.3: {}\n\n  kleur@3.0.3: {}\n\n  leven@3.1.0: {}\n\n  lines-and-columns@1.2.4: {}\n\n  lint-staged@10.5.4:\n    dependencies:\n      chalk: 4.1.2\n      cli-truncate: 2.1.0\n      commander: 6.2.1\n      cosmiconfig: 7.1.0\n      debug: 4.4.0\n      dedent: 0.7.0\n      enquirer: 2.4.1\n      execa: 4.1.0\n      listr2: 3.14.0(enquirer@2.4.1)\n      log-symbols: 4.1.0\n      micromatch: 4.0.8\n      normalize-path: 3.0.0\n      please-upgrade-node: 3.2.0\n      string-argv: 0.3.1\n      stringify-object: 3.3.0\n    transitivePeerDependencies:\n      - supports-color\n\n  listr2@3.14.0(enquirer@2.4.1):\n    dependencies:\n      cli-truncate: 2.1.0\n      colorette: 2.0.20\n      log-update: 4.0.0\n      p-map: 4.0.0\n      rfdc: 1.4.1\n      rxjs: 7.8.1\n      through: 2.3.8\n      wrap-ansi: 7.0.0\n    optionalDependencies:\n      enquirer: 2.4.1\n\n  loader-utils@1.4.2:\n    dependencies:\n      big.js: 5.2.2\n      emojis-list: 3.0.0\n      json5: 1.0.2\n\n  locate-path@5.0.0:\n    dependencies:\n      p-locate: 4.1.0\n\n  lodash.debounce@4.0.8: {}\n\n  lodash.isequal@4.5.0: {}\n\n  lodash.merge@4.6.2: {}\n\n  lodash.throttle@4.1.1: {}\n\n  lodash@4.17.21: {}\n\n  log-symbols@4.1.0:\n    dependencies:\n      chalk: 4.1.2\n      is-unicode-supported: 0.1.0\n\n  log-update@4.0.0:\n    dependencies:\n      ansi-escapes: 4.3.2\n      cli-cursor: 3.1.0\n      slice-ansi: 4.0.0\n      wrap-ansi: 6.2.0\n\n  loose-envify@1.4.0:\n    dependencies:\n      js-tokens: 4.0.0\n\n  lru-cache@4.1.5:\n    dependencies:\n      pseudomap: 1.0.2\n      yallist: 2.1.2\n\n  lru-cache@5.1.1:\n    dependencies:\n      yallist: 3.1.1\n\n  make-dir@4.0.0:\n    dependencies:\n      semver: 7.6.3\n\n  makeerror@1.0.12:\n    dependencies:\n      tmpl: 1.0.5\n\n  map-cache@0.2.2: {}\n\n  map-visit@1.0.0:\n    dependencies:\n      object-visit: 1.0.1\n\n  math-intrinsics@1.0.0: {}\n\n  md5.js@1.3.5:\n    dependencies:\n      hash-base: 3.0.5\n      inherits: 2.0.4\n      safe-buffer: 5.2.1\n\n  memoize-one@5.2.1: {}\n\n  merge-stream@2.0.0: {}\n\n  micromatch@3.1.10:\n    dependencies:\n      arr-diff: 4.0.0\n      array-unique: 0.3.2\n      braces: 2.3.2\n      define-property: 2.0.2\n      extend-shallow: 3.0.2\n      extglob: 2.0.4\n      fragment-cache: 0.2.1\n      kind-of: 6.0.3\n      nanomatch: 1.2.13\n      object.pick: 1.3.0\n      regex-not: 1.0.2\n      snapdragon: 0.8.2\n      to-regex: 3.0.2\n    transitivePeerDependencies:\n      - supports-color\n\n  micromatch@4.0.8:\n    dependencies:\n      braces: 3.0.3\n      picomatch: 2.3.1\n\n  miller-rabin@4.0.1:\n    dependencies:\n      bn.js: 4.12.1\n      brorand: 1.1.0\n\n  mime-db@1.52.0: {}\n\n  mime-types@2.1.35:\n    dependencies:\n      mime-db: 1.52.0\n\n  mime@1.4.1: {}\n\n  mimic-fn@2.1.0: {}\n\n  min-document@2.19.0:\n    dependencies:\n      dom-walk: 0.1.2\n\n  mini-create-react-context@0.4.1(prop-types@15.8.1)(react@16.14.0):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      prop-types: 15.8.1\n      react: 16.14.0\n      tiny-warning: 1.0.3\n\n  mini-create-react-context@0.4.1(prop-types@15.8.1)(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      prop-types: 15.8.1\n      react: 17.0.2\n      tiny-warning: 1.0.3\n\n  minimalistic-assert@1.0.1: {}\n\n  minimalistic-crypto-utils@1.0.1: {}\n\n  minimatch@3.1.2:\n    dependencies:\n      brace-expansion: 1.1.11\n\n  minimist@1.2.8: {}\n\n  mixin-deep@1.3.2:\n    dependencies:\n      for-in: 1.0.2\n      is-extendable: 1.0.1\n\n  moment@2.30.1: {}\n\n  ms@2.0.0: {}\n\n  ms@2.1.3: {}\n\n  nanomatch@1.2.13:\n    dependencies:\n      arr-diff: 4.0.0\n      array-unique: 0.3.2\n      define-property: 2.0.2\n      extend-shallow: 3.0.2\n      fragment-cache: 0.2.1\n      is-windows: 1.0.2\n      kind-of: 6.0.3\n      object.pick: 1.3.0\n      regex-not: 1.0.2\n      snapdragon: 0.8.2\n      to-regex: 3.0.2\n    transitivePeerDependencies:\n      - supports-color\n\n  natural-compare@1.4.0: {}\n\n  nice-try@1.0.5: {}\n\n  node-fetch@1.7.3:\n    dependencies:\n      encoding: 0.1.13\n      is-stream: 1.1.0\n\n  node-int64@0.4.0: {}\n\n  node-libs-browser@2.2.1:\n    dependencies:\n      assert: 1.5.1\n      browserify-zlib: 0.2.0\n      buffer: 4.9.2\n      console-browserify: 1.2.0\n      constants-browserify: 1.0.0\n      crypto-browserify: 3.12.1\n      domain-browser: 1.2.0\n      events: 3.3.0\n      https-browserify: 1.0.0\n      os-browserify: 0.3.0\n      path-browserify: 0.0.1\n      process: 0.11.10\n      punycode: 1.4.1\n      querystring-es3: 0.2.1\n      readable-stream: 2.3.8\n      stream-browserify: 2.0.2\n      stream-http: 2.8.3\n      string_decoder: 1.3.0\n      timers-browserify: 2.0.12\n      tty-browserify: 0.0.0\n      url: 0.11.4\n      util: 0.11.1\n      vm-browserify: 1.1.2\n\n  node-notifier@8.0.2:\n    dependencies:\n      growly: 1.3.0\n      is-wsl: 2.2.0\n      semver: 7.6.3\n      shellwords: 0.1.1\n      uuid: 8.3.2\n      which: 2.0.2\n    optional: true\n\n  node-releases@2.0.19: {}\n\n  normalize-package-data@2.5.0:\n    dependencies:\n      hosted-git-info: 2.8.9\n      resolve: 1.22.8\n      semver: 5.7.2\n      validate-npm-package-license: 3.0.4\n\n  normalize-path@1.0.0: {}\n\n  normalize-path@2.1.1:\n    dependencies:\n      remove-trailing-separator: 1.1.0\n\n  normalize-path@3.0.0: {}\n\n  normalize-range@0.1.2: {}\n\n  normalize-url@1.9.1:\n    dependencies:\n      object-assign: 4.1.1\n      prepend-http: 1.0.4\n      query-string: 4.3.4\n      sort-keys: 1.1.2\n\n  normalize.css@7.0.0: {}\n\n  npm-run-path@2.0.2:\n    dependencies:\n      path-key: 2.0.1\n\n  npm-run-path@4.0.1:\n    dependencies:\n      path-key: 3.1.1\n\n  num2fraction@1.2.2: {}\n\n  nwsapi@2.2.16: {}\n\n  object-assign@4.1.1: {}\n\n  object-copy@0.1.0:\n    dependencies:\n      copy-descriptor: 0.1.1\n      define-property: 0.2.5\n      kind-of: 3.2.2\n\n  object-inspect@1.13.3: {}\n\n  object-keys@1.1.1: {}\n\n  object-visit@1.0.1:\n    dependencies:\n      isobject: 3.0.1\n\n  object.assign@4.1.5:\n    dependencies:\n      call-bind: 1.0.8\n      define-properties: 1.2.1\n      has-symbols: 1.1.0\n      object-keys: 1.1.1\n\n  object.pick@1.3.0:\n    dependencies:\n      isobject: 3.0.1\n\n  omit.js@2.0.2: {}\n\n  once@1.4.0:\n    dependencies:\n      wrappy: 1.0.2\n\n  onetime@5.1.2:\n    dependencies:\n      mimic-fn: 2.1.0\n\n  os-browserify@0.3.0: {}\n\n  p-each-series@2.2.0: {}\n\n  p-finally@1.0.0: {}\n\n  p-limit@2.3.0:\n    dependencies:\n      p-try: 2.2.0\n\n  p-locate@4.1.0:\n    dependencies:\n      p-limit: 2.3.0\n\n  p-map@4.0.0:\n    dependencies:\n      aggregate-error: 3.1.0\n\n  p-try@2.2.0: {}\n\n  pako@1.0.11: {}\n\n  parent-module@1.0.1:\n    dependencies:\n      callsites: 3.1.0\n\n  parse-asn1@5.1.7:\n    dependencies:\n      asn1.js: 4.10.1\n      browserify-aes: 1.2.0\n      evp_bytestokey: 1.0.3\n      hash-base: 3.0.5\n      pbkdf2: 3.1.2\n      safe-buffer: 5.2.1\n\n  parse-json@4.0.0:\n    dependencies:\n      error-ex: 1.3.2\n      json-parse-better-errors: 1.0.2\n\n  parse-json@5.2.0:\n    dependencies:\n      '@babel/code-frame': 7.26.2\n      error-ex: 1.3.2\n      json-parse-even-better-errors: 2.3.1\n      lines-and-columns: 1.2.4\n\n  parse5@6.0.1: {}\n\n  pascalcase@0.1.1: {}\n\n  path-browserify@0.0.1: {}\n\n  path-exists@4.0.0: {}\n\n  path-is-absolute@1.0.1: {}\n\n  path-key@2.0.1: {}\n\n  path-key@3.1.1: {}\n\n  path-parse@1.0.7: {}\n\n  path-to-regexp@1.9.0:\n    dependencies:\n      isarray: 0.0.1\n\n  path-to-regexp@2.4.0: {}\n\n  path-type@4.0.0: {}\n\n  pbkdf2@3.1.2:\n    dependencies:\n      create-hash: 1.2.0\n      create-hmac: 1.1.7\n      ripemd160: 2.0.2\n      safe-buffer: 5.2.1\n      sha.js: 2.4.11\n\n  performance-now@2.1.0: {}\n\n  picocolors@0.2.1: {}\n\n  picocolors@1.1.1: {}\n\n  picomatch@2.3.1: {}\n\n  pirates@4.0.6: {}\n\n  pkg-dir@4.2.0:\n    dependencies:\n      find-up: 4.1.0\n\n  please-upgrade-node@3.2.0:\n    dependencies:\n      semver-compare: 1.0.0\n\n  posix-character-classes@0.1.1: {}\n\n  postcss-attribute-case-insensitive@4.0.2:\n    dependencies:\n      postcss: 7.0.32\n      postcss-selector-parser: 6.1.2\n\n  postcss-color-functional-notation@2.0.1:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-color-gray@5.0.0:\n    dependencies:\n      '@csstools/convert-colors': 1.4.0\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-color-hex-alpha@5.0.3:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-color-mod-function@3.0.3:\n    dependencies:\n      '@csstools/convert-colors': 1.4.0\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-color-rebeccapurple@4.0.1:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-custom-media@7.0.8:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-custom-properties@8.0.11:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-custom-selectors@5.1.2:\n    dependencies:\n      postcss: 7.0.32\n      postcss-selector-parser: 5.0.0\n\n  postcss-dir-pseudo-class@5.0.0:\n    dependencies:\n      postcss: 7.0.32\n      postcss-selector-parser: 5.0.0\n\n  postcss-double-position-gradients@1.0.0:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-env-function@2.0.2:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-flexbugs-fixes@4.2.1:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-focus-visible@4.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-focus-within@3.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-font-variant@4.0.1:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-gap-properties@2.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-image-set-function@3.0.1:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-initial@3.0.4:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-lab-function@2.0.1:\n    dependencies:\n      '@csstools/convert-colors': 1.4.0\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-load-config@2.1.2:\n    dependencies:\n      cosmiconfig: 5.2.1\n      import-cwd: 2.1.0\n\n  postcss-loader@3.0.0:\n    dependencies:\n      loader-utils: 1.4.2\n      postcss: 7.0.32\n      postcss-load-config: 2.1.2\n      schema-utils: 1.0.0\n\n  postcss-logical@3.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-media-minmax@4.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-nesting@7.0.1:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-overflow-shorthand@2.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-page-break@2.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-place@4.0.1:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-preset-env@6.7.0:\n    dependencies:\n      autoprefixer: 9.8.8\n      browserslist: 4.24.2\n      caniuse-lite: 1.0.30001688\n      css-blank-pseudo: 0.1.4\n      css-has-pseudo: 0.10.0\n      css-prefers-color-scheme: 3.1.1\n      cssdb: 4.4.0\n      postcss: 7.0.32\n      postcss-attribute-case-insensitive: 4.0.2\n      postcss-color-functional-notation: 2.0.1\n      postcss-color-gray: 5.0.0\n      postcss-color-hex-alpha: 5.0.3\n      postcss-color-mod-function: 3.0.3\n      postcss-color-rebeccapurple: 4.0.1\n      postcss-custom-media: 7.0.8\n      postcss-custom-properties: 8.0.11\n      postcss-custom-selectors: 5.1.2\n      postcss-dir-pseudo-class: 5.0.0\n      postcss-double-position-gradients: 1.0.0\n      postcss-env-function: 2.0.2\n      postcss-focus-visible: 4.0.0\n      postcss-focus-within: 3.0.0\n      postcss-font-variant: 4.0.1\n      postcss-gap-properties: 2.0.0\n      postcss-image-set-function: 3.0.1\n      postcss-initial: 3.0.4\n      postcss-lab-function: 2.0.1\n      postcss-logical: 3.0.0\n      postcss-media-minmax: 4.0.0\n      postcss-nesting: 7.0.1\n      postcss-overflow-shorthand: 2.0.0\n      postcss-page-break: 2.0.0\n      postcss-place: 4.0.1\n      postcss-pseudo-class-any-link: 6.0.0\n      postcss-replace-overflow-wrap: 3.0.0\n      postcss-selector-matches: 4.0.0\n      postcss-selector-not: 4.0.1\n\n  postcss-pseudo-class-any-link@6.0.0:\n    dependencies:\n      postcss: 7.0.32\n      postcss-selector-parser: 5.0.0\n\n  postcss-replace-overflow-wrap@3.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-safe-parser@4.0.2:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-selector-matches@4.0.0:\n    dependencies:\n      balanced-match: 1.0.2\n      postcss: 7.0.32\n\n  postcss-selector-not@4.0.1:\n    dependencies:\n      balanced-match: 1.0.2\n      postcss: 7.0.32\n\n  postcss-selector-parser@5.0.0:\n    dependencies:\n      cssesc: 2.0.0\n      indexes-of: 1.0.1\n      uniq: 1.0.1\n\n  postcss-selector-parser@6.1.2:\n    dependencies:\n      cssesc: 3.0.0\n      util-deprecate: 1.0.2\n\n  postcss-value-parser@4.2.0: {}\n\n  postcss-values-parser@2.0.1:\n    dependencies:\n      flatten: 1.0.3\n      indexes-of: 1.0.1\n      uniq: 1.0.1\n\n  postcss@7.0.32:\n    dependencies:\n      chalk: 2.4.2\n      source-map: 0.6.1\n      supports-color: 6.1.0\n\n  prepend-http@1.0.4: {}\n\n  prettier@2.2.1: {}\n\n  prettier@2.8.8: {}\n\n  pretty-format@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      ansi-regex: 5.0.1\n      ansi-styles: 4.3.0\n      react-is: 17.0.2\n\n  process-nextick-args@2.0.1: {}\n\n  process@0.11.10: {}\n\n  promise@7.3.1:\n    dependencies:\n      asap: 2.0.6\n\n  prompts@2.4.2:\n    dependencies:\n      kleur: 3.0.3\n      sisteransi: 1.0.5\n\n  prop-types@15.8.1:\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n      react-is: 16.13.1\n\n  pseudomap@1.0.2: {}\n\n  psl@1.15.0:\n    dependencies:\n      punycode: 2.3.1\n\n  public-encrypt@4.0.3:\n    dependencies:\n      bn.js: 4.12.1\n      browserify-rsa: 4.1.1\n      create-hash: 1.2.0\n      parse-asn1: 5.1.7\n      randombytes: 2.1.0\n      safe-buffer: 5.2.1\n\n  pump@3.0.2:\n    dependencies:\n      end-of-stream: 1.4.4\n      once: 1.4.0\n\n  punycode@1.4.1: {}\n\n  punycode@2.3.1: {}\n\n  qs@6.13.1:\n    dependencies:\n      side-channel: 1.1.0\n\n  query-string@4.3.4:\n    dependencies:\n      object-assign: 4.1.1\n      strict-uri-encode: 1.1.0\n\n  query-string@6.14.1:\n    dependencies:\n      decode-uri-component: 0.2.2\n      filter-obj: 1.1.0\n      split-on-first: 1.1.0\n      strict-uri-encode: 2.0.0\n\n  querystring-es3@0.2.1: {}\n\n  querystringify@2.2.0: {}\n\n  raf@3.4.1:\n    dependencies:\n      performance-now: 2.1.0\n\n  randombytes@2.1.0:\n    dependencies:\n      safe-buffer: 5.2.1\n\n  randomfill@1.0.4:\n    dependencies:\n      randombytes: 2.1.0\n      safe-buffer: 5.2.1\n\n  rc-align@2.4.5:\n    dependencies:\n      babel-runtime: 6.26.0\n      dom-align: 1.12.4\n      prop-types: 15.8.1\n      rc-util: 4.21.1\n\n  rc-align@4.0.15(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      dom-align: 1.12.4\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      resize-observer-polyfill: 1.5.1\n\n  rc-animate@2.11.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      css-animation: 1.6.1\n      prop-types: 15.8.1\n      raf: 3.4.1\n      rc-util: 4.21.1\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      react-lifecycles-compat: 3.0.4\n\n  rc-cascader@3.7.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      array-tree-filter: 2.1.0\n      classnames: 2.5.1\n      rc-select: 14.1.18(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-tree: 5.7.12(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-checkbox@2.0.3:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      prop-types: 15.8.1\n      rc-util: 4.21.1\n\n  rc-checkbox@3.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-collapse@1.9.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      classnames: 2.5.1\n      css-animation: 1.6.1\n      prop-types: 15.8.1\n      rc-animate: 2.11.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rc-collapse@3.4.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      shallowequal: 1.1.0\n\n  rc-dialog@9.0.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      '@rc-component/portal': 1.1.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-drawer@6.3.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      '@rc-component/portal': 1.1.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-dropdown@4.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-trigger: 5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-field-form@1.38.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      async-validator: 4.2.5\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-gesture@0.0.22:\n    dependencies:\n      babel-runtime: 6.26.0\n\n  rc-image@5.13.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      '@rc-component/portal': 1.1.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      classnames: 2.5.1\n      rc-dialog: 9.0.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-input-number@7.3.11(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-input@0.1.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-mentions@1.13.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-menu: 9.8.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-textarea: 0.4.7(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-trigger: 5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-menu@9.8.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-overflow: 1.3.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-trigger: 5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-motion@2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-notification@4.6.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-overflow@1.3.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-resize-observer: 1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-pagination@3.2.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-picker@2.7.6(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      date-fns: 2.30.0\n      dayjs: 1.11.13\n      moment: 2.30.1\n      rc-trigger: 5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      shallowequal: 1.1.0\n\n  rc-progress@3.4.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-rate@2.9.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-resize-observer@1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      resize-observer-polyfill: 1.5.1\n\n  rc-segmented@2.3.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-select@14.1.18(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-overflow: 1.3.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-trigger: 5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-virtual-list: 3.16.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-slider@10.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      shallowequal: 1.1.0\n\n  rc-slider@8.2.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      prop-types: 15.8.1\n      rc-tooltip: 3.7.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 4.21.1\n      shallowequal: 1.1.0\n      warning: 3.0.0\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rc-steps@5.0.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-swipeout@2.0.11:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      rc-gesture: 0.0.22\n      react-native-swipeout: 2.3.6\n\n  rc-switch@3.2.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-table@7.26.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-resize-observer: 1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      shallowequal: 1.1.0\n\n  rc-tabs@12.5.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-dropdown: 4.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-menu: 9.8.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-resize-observer: 1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-textarea@0.4.7(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-resize-observer: 1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      shallowequal: 1.1.0\n\n  rc-tooltip@3.7.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      prop-types: 15.8.1\n      rc-trigger: 2.6.5(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rc-tooltip@5.2.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-trigger: 5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-tree-select@5.5.5(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-select: 14.1.18(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-tree: 5.7.12(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-tree@5.7.12(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-virtual-list: 3.16.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-trigger@2.6.5(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      prop-types: 15.8.1\n      rc-align: 2.4.5\n      rc-animate: 2.11.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 4.21.1\n      react-lifecycles-compat: 3.0.4\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rc-trigger@5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-align: 4.0.15(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-upload@4.3.6(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-util@4.21.1:\n    dependencies:\n      add-dom-event-listener: 1.1.0\n      prop-types: 15.8.1\n      react-is: 16.13.1\n      react-lifecycles-compat: 3.0.4\n      shallowequal: 1.1.0\n\n  rc-util@5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      react-is: 18.3.1\n\n  rc-virtual-list@3.16.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-resize-observer: 1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  react-dom@16.14.0(react@16.14.0):\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n      prop-types: 15.8.1\n      react: 16.14.0\n      scheduler: 0.19.1\n\n  react-dom@17.0.2(react@17.0.2):\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n      react: 17.0.2\n      scheduler: 0.20.2\n\n  react-fast-compare@3.2.2: {}\n\n  react-helmet@6.1.0(react@17.0.2):\n    dependencies:\n      object-assign: 4.1.1\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-fast-compare: 3.2.2\n      react-side-effect: 2.1.2(react@17.0.2)\n\n  react-intl@3.12.1(react@17.0.2):\n    dependencies:\n      '@formatjs/intl-displaynames': 1.2.10\n      '@formatjs/intl-listformat': 1.4.8\n      '@formatjs/intl-relativetimeformat': 4.5.16\n      '@formatjs/intl-unified-numberformat': 3.3.7\n      '@formatjs/intl-utils': 2.3.0\n      '@types/hoist-non-react-statics': 3.3.6\n      '@types/invariant': 2.2.37\n      hoist-non-react-statics: 3.3.2\n      intl-format-cache: 4.3.1\n      intl-messageformat: 7.8.4\n      intl-messageformat-parser: 3.6.4\n      react: 17.0.2\n      shallow-equal: 1.2.1\n\n  react-is@16.13.1: {}\n\n  react-is@17.0.2: {}\n\n  react-is@18.3.1: {}\n\n  react-lifecycles-compat@3.0.4: {}\n\n  react-native-swipeout@2.3.6:\n    dependencies:\n      create-react-class: 15.7.0\n      prop-types: 15.8.1\n      react-tween-state: 0.1.5\n\n  react-redux@7.2.9(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      '@types/react-redux': 7.1.34\n      hoist-non-react-statics: 3.3.2\n      loose-envify: 1.4.0\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-is: 17.0.2\n    optionalDependencies:\n      react-dom: 17.0.2(react@17.0.2)\n\n  react-refresh@0.10.0: {}\n\n  react-router-config@5.1.1(react-router@5.2.0(react@16.14.0))(react@16.14.0):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      react: 16.14.0\n      react-router: 5.2.0(react@17.0.2)\n\n  react-router-dom@5.2.0(react@16.14.0):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      history: 4.10.1\n      loose-envify: 1.4.0\n      prop-types: 15.8.1\n      react: 16.14.0\n      react-router: 5.2.0(react@16.14.0)\n      tiny-invariant: 1.3.3\n      tiny-warning: 1.0.3\n\n  react-router-dom@5.3.4(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      history: 4.10.1\n      loose-envify: 1.4.0\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-router: 5.3.4(react@17.0.2)\n      tiny-invariant: 1.3.3\n      tiny-warning: 1.0.3\n\n  react-router@5.2.0(react@16.14.0):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      history: 4.10.1\n      hoist-non-react-statics: 3.3.2\n      loose-envify: 1.4.0\n      mini-create-react-context: 0.4.1(prop-types@15.8.1)(react@16.14.0)\n      path-to-regexp: 1.9.0\n      prop-types: 15.8.1\n      react: 16.14.0\n      react-is: 16.13.1\n      tiny-invariant: 1.3.3\n      tiny-warning: 1.0.3\n\n  react-router@5.2.0(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      history: 4.10.1\n      hoist-non-react-statics: 3.3.2\n      loose-envify: 1.4.0\n      mini-create-react-context: 0.4.1(prop-types@15.8.1)(react@17.0.2)\n      path-to-regexp: 1.9.0\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-is: 16.13.1\n      tiny-invariant: 1.3.3\n      tiny-warning: 1.0.3\n\n  react-router@5.3.4(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      history: 4.10.1\n      hoist-non-react-statics: 3.3.2\n      loose-envify: 1.4.0\n      path-to-regexp: 1.9.0\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-is: 16.13.1\n      tiny-invariant: 1.3.3\n      tiny-warning: 1.0.3\n\n  react-side-effect@2.1.2(react@17.0.2):\n    dependencies:\n      react: 17.0.2\n\n  react-sortable-hoc@2.0.0(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      invariant: 2.2.4\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  react-tween-state@0.1.5:\n    dependencies:\n      raf: 3.4.1\n      tween-functions: 1.2.0\n\n  react@16.14.0:\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n      prop-types: 15.8.1\n\n  react@17.0.2:\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n\n  read-pkg-up@7.0.1:\n    dependencies:\n      find-up: 4.1.0\n      read-pkg: 5.2.0\n      type-fest: 0.8.1\n\n  read-pkg@5.2.0:\n    dependencies:\n      '@types/normalize-package-data': 2.4.4\n      normalize-package-data: 2.5.0\n      parse-json: 5.2.0\n      type-fest: 0.6.0\n\n  readable-stream@2.3.8:\n    dependencies:\n      core-util-is: 1.0.3\n      inherits: 2.0.4\n      isarray: 1.0.0\n      process-nextick-args: 2.0.1\n      safe-buffer: 5.1.2\n      string_decoder: 1.1.1\n      util-deprecate: 1.0.2\n\n  readdirp@3.5.0:\n    dependencies:\n      picomatch: 2.3.1\n\n  redbox-react@1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      error-stack-parser: 1.3.6\n      object-assign: 4.1.1\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      sourcemapped-stacktrace: 1.1.11\n\n  redux-saga@0.16.2: {}\n\n  redux@4.2.1:\n    dependencies:\n      '@babel/runtime': 7.26.0\n\n  regenerate-unicode-properties@10.0.1:\n    dependencies:\n      regenerate: 1.4.2\n\n  regenerate@1.4.2: {}\n\n  regenerator-runtime@0.11.1: {}\n\n  regenerator-runtime@0.13.11: {}\n\n  regenerator-runtime@0.13.5: {}\n\n  regenerator-runtime@0.14.1: {}\n\n  regex-not@1.0.2:\n    dependencies:\n      extend-shallow: 3.0.2\n      safe-regex: 1.1.0\n\n  remove-trailing-separator@1.1.0: {}\n\n  repeat-element@1.1.4: {}\n\n  repeat-string@1.6.1: {}\n\n  require-directory@2.1.1: {}\n\n  require-main-filename@2.0.0: {}\n\n  requires-port@1.0.0: {}\n\n  resize-observer-polyfill@1.5.1: {}\n\n  resolve-cwd@3.0.0:\n    dependencies:\n      resolve-from: 5.0.0\n\n  resolve-from@3.0.0: {}\n\n  resolve-from@4.0.0: {}\n\n  resolve-from@5.0.0: {}\n\n  resolve-pathname@3.0.0: {}\n\n  resolve-url@0.2.1: {}\n\n  resolve@1.22.8:\n    dependencies:\n      is-core-module: 2.15.1\n      path-parse: 1.0.7\n      supports-preserve-symlinks-flag: 1.0.0\n\n  restore-cursor@3.1.0:\n    dependencies:\n      onetime: 5.1.2\n      signal-exit: 3.0.7\n\n  ret@0.1.15: {}\n\n  rfdc@1.4.1: {}\n\n  rimraf@3.0.2:\n    dependencies:\n      glob: 7.2.3\n\n  ripemd160@2.0.2:\n    dependencies:\n      hash-base: 3.0.5\n      inherits: 2.0.4\n\n  rmc-align@1.0.0:\n    dependencies:\n      babel-runtime: 6.26.0\n      dom-align: 1.12.4\n      rc-util: 4.21.1\n\n  rmc-calendar@1.1.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      rc-animate: 2.11.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-date-picker: 6.0.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rmc-cascader@5.0.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      array-tree-filter: 2.1.0\n      babel-runtime: 6.26.0\n      rmc-picker: 5.0.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rmc-date-picker@6.0.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      rmc-picker: 5.0.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rmc-dialog@1.1.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      rc-animate: 2.11.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rmc-drawer@0.4.11:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      prop-types: 15.8.1\n\n  rmc-feedback@2.0.0:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n\n  rmc-input-number@1.0.5:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      rmc-feedback: 2.0.0\n\n  rmc-list-view@0.11.5:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      fbjs: 0.8.18\n      prop-types: 15.8.1\n      warning: 3.0.0\n      zscroller: 0.4.8\n\n  rmc-notification@1.0.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      prop-types: 15.8.1\n      rc-animate: 2.11.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 4.21.1\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rmc-nuka-carousel@3.0.1:\n    dependencies:\n      exenv: 1.2.2\n      raf: 3.4.1\n\n  rmc-picker@5.0.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      rmc-dialog: 1.1.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-feedback: 2.0.0\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rmc-pull-to-refresh@1.0.13:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n\n  rmc-steps@1.0.1:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n\n  rmc-tabs@1.2.29:\n    dependencies:\n      babel-runtime: 6.26.0\n      rc-gesture: 0.0.22\n\n  rmc-tooltip@1.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      rmc-trigger: 1.0.12(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rmc-trigger@1.0.12(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      rc-animate: 2.11.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 4.21.1\n      rmc-align: 1.0.0\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rsvp@4.8.5: {}\n\n  rxjs@7.8.1:\n    dependencies:\n      tslib: 2.8.1\n\n  safe-buffer@5.1.2: {}\n\n  safe-buffer@5.2.1: {}\n\n  safe-regex@1.1.0:\n    dependencies:\n      ret: 0.1.15\n\n  safer-buffer@2.1.2: {}\n\n  sane@4.1.0:\n    dependencies:\n      '@cnakazawa/watch': 1.0.4\n      anymatch: 2.0.0\n      capture-exit: 2.0.0\n      exec-sh: 0.3.6\n      execa: 1.0.0\n      fb-watchman: 2.0.2\n      micromatch: 3.1.10\n      minimist: 1.2.8\n      walker: 1.0.8\n    transitivePeerDependencies:\n      - supports-color\n\n  saxes@5.0.1:\n    dependencies:\n      xmlchars: 2.2.0\n\n  scheduler@0.19.1:\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n\n  scheduler@0.20.2:\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n\n  schema-utils@1.0.0:\n    dependencies:\n      ajv: 6.12.6\n      ajv-errors: 1.0.1(ajv@6.12.6)\n      ajv-keywords: 3.5.2(ajv@6.12.6)\n\n  schema-utils@3.3.0:\n    dependencies:\n      '@types/json-schema': 7.0.15\n      ajv: 6.12.6\n      ajv-keywords: 3.5.2(ajv@6.12.6)\n\n  scroll-into-view-if-needed@2.2.31:\n    dependencies:\n      compute-scroll-into-view: 1.0.20\n\n  seamless-immutable@7.1.4: {}\n\n  semver-compare@1.0.0: {}\n\n  semver@5.7.2: {}\n\n  semver@6.3.1: {}\n\n  semver@7.6.3: {}\n\n  set-blocking@2.0.0: {}\n\n  set-function-length@1.2.2:\n    dependencies:\n      define-data-property: 1.1.4\n      es-errors: 1.3.0\n      function-bind: 1.1.2\n      get-intrinsic: 1.2.6\n      gopd: 1.2.0\n      has-property-descriptors: 1.0.2\n\n  set-value@2.0.1:\n    dependencies:\n      extend-shallow: 2.0.1\n      is-extendable: 0.1.1\n      is-plain-object: 2.0.4\n      split-string: 3.1.0\n\n  setimmediate@1.0.5: {}\n\n  sha.js@2.4.11:\n    dependencies:\n      inherits: 2.0.4\n      safe-buffer: 5.2.1\n\n  shallow-equal@1.2.1: {}\n\n  shallowequal@1.1.0: {}\n\n  shebang-command@1.2.0:\n    dependencies:\n      shebang-regex: 1.0.0\n\n  shebang-command@2.0.0:\n    dependencies:\n      shebang-regex: 3.0.0\n\n  shebang-regex@1.0.0: {}\n\n  shebang-regex@3.0.0: {}\n\n  shellwords@0.1.1:\n    optional: true\n\n  side-channel-list@1.0.0:\n    dependencies:\n      es-errors: 1.3.0\n      object-inspect: 1.13.3\n\n  side-channel-map@1.0.1:\n    dependencies:\n      call-bound: 1.0.2\n      es-errors: 1.3.0\n      get-intrinsic: 1.2.6\n      object-inspect: 1.13.3\n\n  side-channel-weakmap@1.0.2:\n    dependencies:\n      call-bound: 1.0.2\n      es-errors: 1.3.0\n      get-intrinsic: 1.2.6\n      object-inspect: 1.13.3\n      side-channel-map: 1.0.1\n\n  side-channel@1.1.0:\n    dependencies:\n      es-errors: 1.3.0\n      object-inspect: 1.13.3\n      side-channel-list: 1.0.0\n      side-channel-map: 1.0.1\n      side-channel-weakmap: 1.0.2\n\n  signal-exit@3.0.7: {}\n\n  sisteransi@1.0.5: {}\n\n  slash@3.0.0: {}\n\n  slice-ansi@3.0.0:\n    dependencies:\n      ansi-styles: 4.3.0\n      astral-regex: 2.0.0\n      is-fullwidth-code-point: 3.0.0\n\n  slice-ansi@4.0.0:\n    dependencies:\n      ansi-styles: 4.3.0\n      astral-regex: 2.0.0\n      is-fullwidth-code-point: 3.0.0\n\n  snapdragon-node@2.1.1:\n    dependencies:\n      define-property: 1.0.0\n      isobject: 3.0.1\n      snapdragon-util: 3.0.1\n\n  snapdragon-util@3.0.1:\n    dependencies:\n      kind-of: 3.2.2\n\n  snapdragon@0.8.2:\n    dependencies:\n      base: 0.11.2\n      debug: 2.6.9\n      define-property: 0.2.5\n      extend-shallow: 2.0.1\n      map-cache: 0.2.2\n      source-map: 0.5.7\n      source-map-resolve: 0.5.3\n      use: 3.1.1\n    transitivePeerDependencies:\n      - supports-color\n\n  sort-keys@1.1.2:\n    dependencies:\n      is-plain-obj: 1.1.0\n\n  source-map-resolve@0.5.3:\n    dependencies:\n      atob: 2.1.2\n      decode-uri-component: 0.2.2\n      resolve-url: 0.2.1\n      source-map-url: 0.4.1\n      urix: 0.1.0\n\n  source-map-support@0.5.21:\n    dependencies:\n      buffer-from: 1.1.2\n      source-map: 0.6.1\n\n  source-map-url@0.4.1: {}\n\n  source-map@0.5.6: {}\n\n  source-map@0.5.7: {}\n\n  source-map@0.6.1: {}\n\n  source-map@0.7.4: {}\n\n  sourcemapped-stacktrace@1.1.11:\n    dependencies:\n      source-map: 0.5.6\n\n  spdx-correct@3.2.0:\n    dependencies:\n      spdx-expression-parse: 3.0.1\n      spdx-license-ids: 3.0.20\n\n  spdx-exceptions@2.5.0: {}\n\n  spdx-expression-parse@3.0.1:\n    dependencies:\n      spdx-exceptions: 2.5.0\n      spdx-license-ids: 3.0.20\n\n  spdx-license-ids@3.0.20: {}\n\n  split-on-first@1.1.0: {}\n\n  split-string@3.1.0:\n    dependencies:\n      extend-shallow: 3.0.2\n\n  sprintf-js@1.0.3: {}\n\n  stack-utils@2.0.6:\n    dependencies:\n      escape-string-regexp: 2.0.0\n\n  stackframe@0.3.1: {}\n\n  stackframe@1.3.4: {}\n\n  static-extend@0.1.2:\n    dependencies:\n      define-property: 0.2.5\n      object-copy: 0.1.0\n\n  stream-browserify@2.0.2:\n    dependencies:\n      inherits: 2.0.4\n      readable-stream: 2.3.8\n\n  stream-http@2.8.3:\n    dependencies:\n      builtin-status-codes: 3.0.0\n      inherits: 2.0.4\n      readable-stream: 2.3.8\n      to-arraybuffer: 1.0.1\n      xtend: 4.0.2\n\n  strict-uri-encode@1.1.0: {}\n\n  strict-uri-encode@2.0.0: {}\n\n  string-argv@0.3.1: {}\n\n  string-convert@0.2.1: {}\n\n  string-length@4.0.2:\n    dependencies:\n      char-regex: 1.0.2\n      strip-ansi: 6.0.1\n\n  string-width@4.2.3:\n    dependencies:\n      emoji-regex: 8.0.0\n      is-fullwidth-code-point: 3.0.0\n      strip-ansi: 6.0.1\n\n  string_decoder@1.1.1:\n    dependencies:\n      safe-buffer: 5.1.2\n\n  string_decoder@1.3.0:\n    dependencies:\n      safe-buffer: 5.2.1\n\n  stringify-object@3.3.0:\n    dependencies:\n      get-own-enumerable-property-symbols: 3.0.2\n      is-obj: 1.0.1\n      is-regexp: 1.0.0\n\n  strip-ansi@6.0.1:\n    dependencies:\n      ansi-regex: 5.0.1\n\n  strip-bom@4.0.0: {}\n\n  strip-eof@1.0.0: {}\n\n  strip-final-newline@2.0.0: {}\n\n  strip-indent@2.0.0: {}\n\n  supports-color@5.5.0:\n    dependencies:\n      has-flag: 3.0.0\n\n  supports-color@6.1.0:\n    dependencies:\n      has-flag: 3.0.0\n\n  supports-color@7.2.0:\n    dependencies:\n      has-flag: 4.0.0\n\n  supports-hyperlinks@2.3.0:\n    dependencies:\n      has-flag: 4.0.0\n      supports-color: 7.2.0\n\n  supports-preserve-symlinks-flag@1.0.0: {}\n\n  swr@1.3.0(react@17.0.2):\n    dependencies:\n      react: 17.0.2\n\n  symbol-tree@3.2.4: {}\n\n  terminal-link@2.1.1:\n    dependencies:\n      ansi-escapes: 4.3.2\n      supports-hyperlinks: 2.3.0\n\n  terser@5.14.2:\n    dependencies:\n      '@jridgewell/source-map': 0.3.6\n      acorn: 8.14.0\n      commander: 2.20.3\n      source-map-support: 0.5.21\n\n  test-exclude@6.0.0:\n    dependencies:\n      '@istanbuljs/schema': 0.1.3\n      glob: 7.2.3\n      minimatch: 3.1.2\n\n  throat@5.0.0: {}\n\n  throttle-debounce@5.0.2: {}\n\n  through@2.3.8: {}\n\n  timers-browserify@2.0.12:\n    dependencies:\n      setimmediate: 1.0.5\n\n  tiny-invariant@1.3.3: {}\n\n  tiny-warning@1.0.3: {}\n\n  tmpl@1.0.5: {}\n\n  to-arraybuffer@1.0.1: {}\n\n  to-object-path@0.3.0:\n    dependencies:\n      kind-of: 3.2.2\n\n  to-regex-range@2.1.1:\n    dependencies:\n      is-number: 3.0.0\n      repeat-string: 1.6.1\n\n  to-regex-range@5.0.1:\n    dependencies:\n      is-number: 7.0.0\n\n  to-regex@3.0.2:\n    dependencies:\n      define-property: 2.0.2\n      extend-shallow: 3.0.2\n      regex-not: 1.0.2\n      safe-regex: 1.1.0\n\n  toggle-selection@1.0.6: {}\n\n  tough-cookie@4.1.4:\n    dependencies:\n      psl: 1.15.0\n      punycode: 2.3.1\n      universalify: 0.2.0\n      url-parse: 1.5.10\n\n  tr46@2.1.0:\n    dependencies:\n      punycode: 2.3.1\n\n  tslib@2.8.1: {}\n\n  tty-browserify@0.0.0: {}\n\n  tween-functions@1.2.0: {}\n\n  type-detect@4.0.8: {}\n\n  type-fest@0.21.3: {}\n\n  type-fest@0.6.0: {}\n\n  type-fest@0.8.1: {}\n\n  typedarray-to-buffer@3.1.5:\n    dependencies:\n      is-typedarray: 1.0.0\n\n  typescript@4.9.5: {}\n\n  ua-parser-js@0.7.39: {}\n\n  umi-request@1.4.0:\n    dependencies:\n      isomorphic-fetch: 2.2.1\n      qs: 6.13.1\n\n  umi@3.5.43(react-router@5.2.0(react@16.14.0)):\n    dependencies:\n      '@umijs/bundler-webpack': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/core': 3.5.43\n      '@umijs/deps': 3.5.43\n      '@umijs/preset-built-in': 3.5.43(react-dom@16.14.0(react@16.14.0))(react@16.14.0)\n      '@umijs/runtime': 3.5.43(react@16.14.0)\n      '@umijs/types': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/utils': 3.5.43\n      react: 16.14.0\n      react-dom: 16.14.0(react@16.14.0)\n      v8-compile-cache: 2.3.0\n    transitivePeerDependencies:\n      - react-router\n\n  undici-types@6.20.0: {}\n\n  union-value@1.0.1:\n    dependencies:\n      arr-union: 3.1.0\n      get-value: 2.0.6\n      is-extendable: 0.1.1\n      set-value: 2.0.1\n\n  uniq@1.0.1: {}\n\n  universalify@0.2.0: {}\n\n  unset-value@1.0.0:\n    dependencies:\n      has-value: 0.3.1\n      isobject: 3.0.1\n\n  unstated-next@1.1.0: {}\n\n  update-browserslist-db@1.1.1(browserslist@4.24.2):\n    dependencies:\n      browserslist: 4.24.2\n      escalade: 3.2.0\n      picocolors: 1.1.1\n\n  uri-js@4.4.1:\n    dependencies:\n      punycode: 2.3.1\n\n  urix@0.1.0: {}\n\n  url-parse@1.5.10:\n    dependencies:\n      querystringify: 2.2.0\n      requires-port: 1.0.0\n\n  url@0.11.4:\n    dependencies:\n      punycode: 1.4.1\n      qs: 6.13.1\n\n  use-json-comparison@1.0.6(react@17.0.2):\n    dependencies:\n      react: 17.0.2\n\n  use-media-antd-query@1.1.0(react@17.0.2):\n    dependencies:\n      react: 17.0.2\n\n  use-subscription@1.5.1(react@16.14.0):\n    dependencies:\n      object-assign: 4.1.1\n      react: 16.14.0\n\n  use@3.1.1: {}\n\n  util-deprecate@1.0.2: {}\n\n  util@0.10.4:\n    dependencies:\n      inherits: 2.0.3\n\n  util@0.11.1:\n    dependencies:\n      inherits: 2.0.3\n\n  uuid@8.3.2:\n    optional: true\n\n  v8-compile-cache@2.3.0: {}\n\n  v8-to-istanbul@7.1.2:\n    dependencies:\n      '@types/istanbul-lib-coverage': 2.0.6\n      convert-source-map: 1.9.0\n      source-map: 0.7.4\n\n  validate-npm-package-license@3.0.4:\n    dependencies:\n      spdx-correct: 3.2.0\n      spdx-expression-parse: 3.0.1\n\n  value-equal@1.0.1: {}\n\n  vm-browserify@1.1.2: {}\n\n  w3c-hr-time@1.0.2:\n    dependencies:\n      browser-process-hrtime: 1.0.0\n\n  w3c-xmlserializer@2.0.0:\n    dependencies:\n      xml-name-validator: 3.0.0\n\n  walker@1.0.8:\n    dependencies:\n      makeerror: 1.0.12\n\n  warning@3.0.0:\n    dependencies:\n      loose-envify: 1.4.0\n\n  warning@4.0.3:\n    dependencies:\n      loose-envify: 1.4.0\n\n  webidl-conversions@5.0.0: {}\n\n  webidl-conversions@6.1.0: {}\n\n  webpack-chain@6.5.1:\n    dependencies:\n      deepmerge: 1.5.2\n      javascript-stringify: 2.1.0\n\n  whatwg-encoding@1.0.5:\n    dependencies:\n      iconv-lite: 0.4.24\n\n  whatwg-fetch@3.6.20: {}\n\n  whatwg-mimetype@2.3.0: {}\n\n  whatwg-url@8.7.0:\n    dependencies:\n      lodash: 4.17.21\n      tr46: 2.1.0\n      webidl-conversions: 6.1.0\n\n  which-module@2.0.1: {}\n\n  which@1.3.1:\n    dependencies:\n      isexe: 2.0.0\n\n  which@2.0.2:\n    dependencies:\n      isexe: 2.0.0\n\n  wrap-ansi@6.2.0:\n    dependencies:\n      ansi-styles: 4.3.0\n      string-width: 4.2.3\n      strip-ansi: 6.0.1\n\n  wrap-ansi@7.0.0:\n    dependencies:\n      ansi-styles: 4.3.0\n      string-width: 4.2.3\n      strip-ansi: 6.0.1\n\n  wrappy@1.0.2: {}\n\n  write-file-atomic@3.0.3:\n    dependencies:\n      imurmurhash: 0.1.4\n      is-typedarray: 1.0.0\n      signal-exit: 3.0.7\n      typedarray-to-buffer: 3.1.5\n\n  ws@7.5.10: {}\n\n  xml-name-validator@3.0.0: {}\n\n  xmlchars@2.2.0: {}\n\n  xtend@4.0.2: {}\n\n  y18n@4.0.3: {}\n\n  yallist@2.1.2: {}\n\n  yallist@3.1.1: {}\n\n  yaml@1.10.2: {}\n\n  yargs-parser@18.1.3:\n    dependencies:\n      camelcase: 5.3.1\n      decamelize: 1.2.0\n\n  yargs@15.4.1:\n    dependencies:\n      cliui: 6.0.0\n      decamelize: 1.2.0\n      find-up: 4.1.0\n      get-caller-file: 2.0.5\n      require-directory: 2.1.1\n      require-main-filename: 2.0.0\n      set-blocking: 2.0.0\n      string-width: 4.2.3\n      which-module: 2.0.1\n      y18n: 4.0.3\n      yargs-parser: 18.1.3\n\n  yorkie@2.0.0:\n    dependencies:\n      execa: 0.8.0\n      is-ci: 1.2.1\n      normalize-path: 1.0.0\n      strip-indent: 2.0.0\n\n  zscroller@0.4.8:\n    dependencies:\n      babel-runtime: 6.26.0\n"
      }
    ];
  }

  // src/plugins/project/framework/gant/template/files/README.md.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile8() {
    return [
      ["."],
      {
        name: "README",
        ext: "md",
        content: "# umi project\n\n## Getting Started\n\nInstall dependencies,\n\n```bash\n$ yarn\n```\n\nStart the dev server,\n\n```bash\n$ yarn start\n```\n"
      }
    ];
  }

  // src/plugins/project/framework/gant/template/files/tsconfig.json.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile9() {
    return [
      ["."],
      {
        name: "tsconfig",
        ext: "json",
        content: '{\n  "compilerOptions": {\n    "target": "esnext",\n    "module": "esnext",\n    "moduleResolution": "node",\n    "resolveJsonModule": true,\n    "importHelpers": true,\n    "jsx": "react-jsx",\n    "esModuleInterop": true,\n    "sourceMap": true,\n    "baseUrl": "./",\n    "strict": true,\n    "paths": {\n      "@/*": ["src/*"],\n      "@@/*": ["src/.umi/*"]\n    },\n    "allowSyntheticDefaultImports": true\n  },\n  "include": [\n    "mock/**/*",\n    "src/**/*",\n    "config/**/*",\n    ".umirc.ts",\n    "typings.d.ts"\n  ],\n  "exclude": [\n    "node_modules",\n    "lib",\n    "es",\n    "dist",\n    "typings",\n    "**/__test__",\n    "test",\n    "docs",\n    "tests"\n  ]\n}\n'
      }
    ];
  }

  // src/plugins/project/framework/gant/template/files/typings.d.ts.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile10() {
    return [
      ["."],
      {
        name: "typings.d",
        ext: "ts",
        content: "declare module '*.css';\ndeclare module '*.less';\ndeclare module '*.png';\ndeclare module '*.svg' {\n  export function ReactComponent(\n    props: React.SVGProps<SVGSVGElement>,\n  ): React.ReactElement;\n  const url: string;\n  export default url;\n}\n"
      }
    ];
  }

  // src/plugins/project/framework/gant/template/static-files.ts
  function generateStaticFiles(root2 = createResultDir(".")) {
    runFileGenerator(root2, getFile);
    runFileGenerator(root2, getFile2);
    runFileGenerator(root2, getFile3);
    runFileGenerator(root2, getFile4);
    runFileGenerator(root2, getFile5);
    runFileGenerator(root2, getFile6);
    runFileGenerator(root2, getFile7);
    runFileGenerator(root2, getFile8);
    runFileGenerator(root2, getFile9);
    runFileGenerator(root2, getFile10);
    return root2;
  }

  // src/plugins/project/framework/gant/template/index.ts
  var gantChunkTemplate = (rootPaths = ["src"], pagePaths = ["pages"], configPaths = []) => ({
    slots: {
      root: {
        path: [rootPaths[0]]
      },
      components: {
        path: [...rootPaths, "components"]
      },
      pages: {
        path: [...rootPaths, ...pagePaths]
      },
      router: {
        path: rootPaths,
        fileName: "routes"
      },
      entry: {
        path: [...rootPaths, "lowcode-common"],
        fileName: "app"
      },
      constants: {
        path: [...rootPaths, "lowcode-common"],
        fileName: "constants"
      },
      utils: {
        path: [...rootPaths, "lowcode-common"],
        fileName: "utils"
      },
      i18n: {
        path: [...rootPaths, "lowcode-common"],
        fileName: "i18n"
      },
      globalStyle: {
        path: [...rootPaths, "lowcode-common"],
        fileName: "global"
      },
      htmlEntry: {
        path: ["public"],
        fileName: "index"
      },
      packageJSON: {
        path: [],
        fileName: "package"
      },
      config: {
        path: [...rootPaths, "lowcode-common"],
        fileName: "config"
      },
      detailsMap: {
        path: [...rootPaths, "lowcode-common"],
        fileName: "detailsMap"
      }
    },
    generateTemplate() {
      return generateStaticFiles();
    }
  });
  var template_default2 = gantChunkTemplate;

  // src/plugins/project/framework/gant/plugins/entry.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory18 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "ts" /* TS */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
        import { withKeyboardRedirect } from 'procomponents';
      `,
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "ts" /* TS */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: `
        window.lc_navigate = (event, itemPath) => {
          withKeyboardRedirect(event, itemPath);
        };
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      return next;
    };
    return plugin;
  };
  var entry_default = pluginFactory18;

  // src/plugins/project/framework/gant/plugins/globalStyle.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory19 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "scss" /* SCSS */,
        name: COMMON_CHUNK_NAME.StyleDepsImport,
        content: `
        
      `,
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "scss" /* SCSS */,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: `
        body {
          -webkit-font-smoothing: antialiased;
        }
      `,
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "scss" /* SCSS */,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: ir.css || "",
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      return next;
    };
    return plugin;
  };
  var globalStyle_default = pluginFactory19;

  // src/plugins/project/framework/gant/plugins/packageJSON.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/utils/dataSource.ts
  var dataSource_exports = {};
  __export(dataSource_exports, {
    buildDataSourceDependencies: () => buildDataSourceDependencies
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var import_change_case5 = __toESM(require_change_case());
  function buildDataSourceDependencies(ir, cfg = {}) {
    return {
      [cfg.enginePackage || "@alilc/lowcode-datasource-engine"]: cfg.engineVersion || "^1.0.0",
      ...(ir.dataSourcesTypes || []).reduce(
        (acc, dsType) => {
          var _a;
          return {
            ...acc,
            [getDataSourceHandlerPackageName(dsType)]: ((_a = cfg.handlersVersion) == null ? void 0 : _a[dsType]) || "^1.0.0"
          };
        },
        {}
      )
    };
    function getDataSourceHandlerPackageName(dsType) {
      var _a;
      return ((_a = cfg.handlersPackages) == null ? void 0 : _a[dsType]) || `@alilc/lowcode-datasource-${import_change_case5.default.kebab(dsType)}-handler`;
    }
  }

  // src/plugins/project/framework/gant/plugins/packageJSON.ts
  var pluginFactory20 = (cfg) => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const packageJson = {
        name: (cfg == null ? void 0 : cfg.packageName) || "gant-lowcode-demo-app",
        version: (cfg == null ? void 0 : cfg.packageVersion) || "0.1.5",
        dependencies: {
          ...buildDataSourceDependencies(ir, cfg == null ? void 0 : cfg.datasourceConfig)
        },
        devDependencies: {}
      };
      ir.packages.forEach((packageInfo) => {
        packageJson.dependencies[packageInfo.package] = packageInfo.version;
      });
      next.chunks.push({
        type: "json" /* JSON */,
        fileType: "json" /* JSON */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: packageJson,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var packageJSON_default = pluginFactory20;

  // src/plugins/project/framework/gant/plugins/config.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory21 = (cfg) => {
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      const rootPath = getSlotRelativePath({
        contextData: next.contextData,
        from: "config",
        to: "pages"
      });
      const routeList = ((_a = ir.globalRouter) == null ? void 0 : _a.routes) || [];
      const needsFileNamePath = (route) => {
        const rawPath = route.path.replace(/\/index$/, "") || route.path;
        return rawPath === "index" || rawPath === "/index";
      };
      const fileNameBases = routeList.map((route) => (route.fileName || "").replace(/\/index$/, ""));
      const depths = routeList.map(() => 1);
      let hasConflict = true;
      while (hasConflict) {
        hasConflict = false;
        const segMap = /* @__PURE__ */ new Map();
        routeList.forEach((route, i) => {
          if (!needsFileNamePath(route))
            return;
          const parts = fileNameBases[i].split("/");
          const seg = parts.slice(Math.max(0, parts.length - depths[i])).join("/");
          if (!segMap.has(seg))
            segMap.set(seg, []);
          segMap.get(seg).push(i);
        });
        const conflictGroups = Array.from(segMap.values()).filter((indices) => indices.length > 1);
        for (const indices of conflictGroups) {
          for (const i of indices) {
            const maxDepth = fileNameBases[i].split("/").length;
            if (depths[i] < maxDepth) {
              depths[i]++;
              hasConflict = true;
            }
          }
        }
      }
      const routes = routeList.map((route, i) => {
        let pathSegment;
        if (needsFileNamePath(route)) {
          const parts = fileNameBases[i].split("/");
          pathSegment = parts.slice(Math.max(0, parts.length - depths[i])).join("/");
        } else {
          pathSegment = route.path.replace(/\/index$/, "") || route.path;
        }
        const componentName = route.componentName.replace(/\/index$/, "");
        const component = `@lowcode/${rootPath}${componentName}`.replace(/^@lowcode\/\.\//, "@lowcode/");
        return {
          path: `/**/${pathSegment}`,
          title: route.title || pathSegment,
          component,
          exact: true
        };
      });
      const configContent = `export default {
  resolve: {
    alias: {
      '@lowcode': __dirname,
    },
  },
  routes: ${JSON.stringify(routes, null, 4).replace(/"(@lowcode\/[^"]+)"/g, "'$1'").replace(/"(\*\*\/[^"]+)"/g, "'$1'")},
};
`;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "ts" /* TS */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: configContent,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var config_default = pluginFactory21;

  // src/plugins/project/framework/gant/plugins/router.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory22 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import BasicLayout from '@/layouts/BasicLayout';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileVarDefine,
        content: `
        const routerConfig = [
          {
            path: '/',
            component: BasicLayout,
            children: [
              ${ir.routes.map(
          (route) => `
                    {
                      path: '${route.path}',
                      component: ${route.componentName},
                    }
                  `
        ).join(",")}
            ],
          },
        ];
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `
        export default routerConfig;
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.FileUtilDefine,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileMainContent
        ]
      });
      return next;
    };
    return plugin;
  };
  var router_default = pluginFactory22;

  // src/plugins/project/framework/gant/plugins/detailsMap.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory23 = (config3) => {
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      const detailRoutes = (_a = ir.globalRouter) == null ? void 0 : _a.routes.filter((route) => route.fileType === "detail");
      if (detailRoutes && detailRoutes.length > 0) {
        const detailsMapContent = `import { lazy } from 'react';

      export default {
      ${detailRoutes.map((route) => {
          const path = route.componentName.replace(/^\//, "");
          const componentPath = `@@ibom/${route.componentName}`;
          return `  '${path}': lazy(() => import('${componentPath}')),`;
        }).join("\n")}
      }
      `;
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "ts" /* TS */,
          name: COMMON_CHUNK_NAME.FileMainContent,
          content: detailsMapContent,
          linkAfter: [],
          subModule: "detailsMap"
        });
      }
      return next;
    };
    return plugin;
  };
  var detailsMap_default = pluginFactory23;

  // src/plugins/project/framework/gant/index.ts
  var gant_default = {
    template: template_default2,
    plugins: {
      entry: entry_default,
      globalStyle: globalStyle_default,
      packageJSON: packageJSON_default,
      config: config_default,
      router: router_default,
      detailsMap: detailsMap_default
    }
  };

  // src/postprocessor/index.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/postprocessor/prettier/index.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var import_prettier = __toESM(require_standalone());
  var import_parser_babel = __toESM(require_parser_babel());
  var import_parser_postcss = __toESM(require_parser_postcss());
  var import_parser_html = __toESM(require_parser_html());
  var PARSERS = ["css", "scss", "less", "json", "html", "vue"];
  var factory = (config3) => {
    const cfg = {
      customFileTypeParser: {},
      ...config3
    };
    const codePrettier = (content, fileType) => {
      let parser3;
      if (fileType === "js" || fileType === "jsx" || fileType === "ts" || fileType === "tsx") {
        parser3 = "babel-ts";
      } else if (fileType === "json") {
        parser3 = "json-stringify";
      } else if (PARSERS.indexOf(fileType) >= 0) {
        parser3 = fileType;
      } else if (cfg.customFileTypeParser[fileType]) {
        parser3 = cfg.customFileTypeParser[fileType];
      } else {
        return content;
      }
      return import_prettier.default.format(content, {
        parser: parser3,
        plugins: [import_parser_babel.default, import_parser_postcss.default, import_parser_html.default, ...cfg.plugins || []],
        singleQuote: true,
        jsxSingleQuote: false
      });
    };
    return codePrettier;
  };
  var prettier_default = factory;

  // src/plugins/component/react/containerFunction.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var import_change_case6 = __toESM(require_change_case());
  var pluginFactory24 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const isIndexModule = ir.moduleName.toLowerCase() === "index";
      const effectiveModuleName = isIndexModule && ir.modulePaths && ir.modulePaths.length > 0 ? ir.modulePaths[ir.modulePaths.length - 1] : ir.moduleName;
      const componentClassName = ensureValidClassName(
        `${import_change_case6.default.pascalCase(effectiveModuleName)}${ir.containerType}`
      );
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "tsx" /* TSX */,
        name: FUNCTION_DEFINE_CHUNK_NAME.Start,
        content: `export default function ${componentClassName}(props) {`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "tsx" /* TSX */,
        name: FUNCTION_DEFINE_CHUNK_NAME.End,
        content: "}",
        linkAfter: [
          REACT_CHUNK_NAME.FunctionRenderJSX,
          ...DEFAULT_LINK_AFTER[FUNCTION_DEFINE_CHUNK_NAME.End]
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "tsx" /* TSX */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: "",
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          FUNCTION_DEFINE_CHUNK_NAME.End
        ]
      });
      return next;
    };
    return plugin;
  };
  var containerFunction_default = pluginFactory24;

  // src/plugins/component/react/containerState.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory25 = (config3) => {
    const cfg = {
      fileType: "tsx" /* TSX */,
      ...config3
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      if (!ir.statements) {
        return next;
      }
      const { state } = ir;
      if (state) {
        try {
          JSON.stringify(state);
        } catch (error) {
          console.error("state \u5FC5\u987B\u662F\u53EF\u5E8F\u5217\u5316\u7684\u5BF9\u8C61", error);
          return next;
        }
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: FUNCTION_DEFINE_CHUNK_NAME.InsStatement,
          content: `const [state, setState] = useSetState(${JSON.stringify(state)});`,
          linkAfter: [...DEFAULT_LINK_AFTER[FUNCTION_DEFINE_CHUNK_NAME.Start]]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "tsx" /* TSX */,
          name: COMMON_CHUNK_NAME.ExternalDepsImport,
          content: "import { useSetState } from 'ahooks';",
          linkAfter: []
        });
      }
      return next;
    };
    return plugin;
  };
  var containerState_default = pluginFactory25;

  // src/plugins/component/react/containerStatement.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/utils/statementHelper.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var CATEGORY_TO_TARGET_FILE = {
    service: "services.ts",
    hook: "hooks.ts",
    state: "store.ts",
    store: "store.ts",
    constant: "constants.ts",
    util: "utils.ts",
    effect: "index.tsx",
    callback: "index.tsx",
    component: "index.tsx",
    schema: "schema.tsx"
  };
  function inferTargetFile(stmt) {
    if (stmt.targetFile) {
      return stmt.targetFile;
    }
    if (stmt.category) {
      return CATEGORY_TO_TARGET_FILE[stmt.category] || DEFAULT_TARGET_FILE;
    }
    return DEFAULT_TARGET_FILE;
  }
  function analyzeInternalDependencies(statements) {
    const result2 = /* @__PURE__ */ new Map();
    const stmtMap = new Map(statements.map((s) => [s.id, s]));
    for (const stmt of statements) {
      if (!stmt.internalRefs || stmt.internalRefs.length === 0)
        continue;
      const targetFile = inferTargetFile(stmt);
      for (const refId of stmt.internalRefs) {
        const refStmt = stmtMap.get(refId);
        if (!refStmt)
          continue;
        const refTargetFile = inferTargetFile(refStmt);
        if (refTargetFile === targetFile)
          continue;
        if (!result2.has(targetFile)) {
          result2.set(targetFile, /* @__PURE__ */ new Map());
        }
        const fileImports = result2.get(targetFile);
        if (!fileImports.has(refTargetFile)) {
          fileImports.set(refTargetFile, /* @__PURE__ */ new Set());
        }
        refStmt.names.forEach((name) => fileImports.get(refTargetFile).add(name));
      }
    }
    const INDEX_FILE = "index.tsx";
    const componentRefPattern = /^[^.]+\.[^.]+\.[^.]+$/;
    for (const stmt of statements) {
      if (!stmt.references || stmt.references.length === 0)
        continue;
      const stmtTargetFile = inferTargetFile(stmt);
      if (stmtTargetFile === INDEX_FILE)
        continue;
      const hasComponentRef = stmt.references.some((ref) => componentRefPattern.test(ref));
      if (!hasComponentRef)
        continue;
      if (!result2.has(INDEX_FILE)) {
        result2.set(INDEX_FILE, /* @__PURE__ */ new Map());
      }
      const fileImports = result2.get(INDEX_FILE);
      if (!fileImports.has(stmtTargetFile)) {
        fileImports.set(stmtTargetFile, /* @__PURE__ */ new Set());
      }
      stmt.names.forEach((name) => fileImports.get(stmtTargetFile).add(name));
    }
    return result2;
  }
  function inferExportedStatements(statements) {
    const exportedIds = /* @__PURE__ */ new Set();
    const stmtMap = new Map(statements.map((s) => [s.id, s]));
    for (const stmt of statements) {
      if (stmt.exported) {
        exportedIds.add(stmt.id);
        continue;
      }
      if (!stmt.internalRefs)
        continue;
      for (const refId of stmt.internalRefs) {
        const refStmt = stmtMap.get(refId);
        if (!refStmt)
          continue;
        const stmtFile = inferTargetFile(stmt);
        const refFile = inferTargetFile(refStmt);
        if (stmtFile !== refFile) {
          exportedIds.add(refId);
        }
      }
    }
    return exportedIds;
  }
  function generateInternalImportStatement(fromFile, importNames) {
    const importPath = getImportPathFromTargetFile(fromFile);
    const names = importNames.join(", ");
    return `import { ${names} } from '${importPath}';`;
  }
  function groupStatementsByTargetFile(statements) {
    const grouped = /* @__PURE__ */ new Map();
    for (const stmt of statements) {
      const targetFile = inferTargetFile(stmt);
      if (!grouped.has(targetFile)) {
        grouped.set(targetFile, []);
      }
      grouped.get(targetFile).push(stmt);
    }
    return grouped;
  }
  function collectExternalDependencies(statements) {
    const imports = {};
    for (const stmt of statements) {
      if (!stmt.dependencies)
        continue;
      for (const dep of stmt.dependencies) {
        if (!dep.package)
          continue;
        if (!imports[dep.package]) {
          imports[dep.package] = {
            defaultImport: null,
            namespaceImport: null,
            namedImports: /* @__PURE__ */ new Set()
          };
        }
        if (dep.default) {
          imports[dep.package].defaultImport = dep.importName;
        } else if (dep.namespace) {
          imports[dep.package].namespaceImport = dep.importName;
        } else {
          imports[dep.package].namedImports.add(dep.importName);
        }
      }
    }
    return imports;
  }
  function addExportKeyword(source) {
    const isStringArray = Array.isArray(source);
    const content = isStringArray ? source.join("\n") : source;
    const trimmed = content.trim();
    if (trimmed.startsWith("export ")) {
      return source;
    }
    const patterns = [
      /^(const\s+)/,
      /^(let\s+)/,
      /^(var\s+)/,
      /^(function\s+)/,
      /^(class\s+)/,
      /^(async\s+function\s+)/
    ];
    for (const pattern of patterns) {
      if (pattern.test(trimmed)) {
        const exported = trimmed.replace(pattern, "export $1");
        return isStringArray ? exported.split("\n") : exported;
      }
    }
    return source;
  }

  // src/utils/mergeImportMaps.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function mergeImportMaps(...maps) {
    const result2 = {};
    for (const map2 of maps) {
      for (const source of Object.keys(map2)) {
        const incoming = map2[source];
        if (!result2[source]) {
          result2[source] = {
            defaultImport: incoming.defaultImport,
            namespaceImport: incoming.namespaceImport,
            namedImports: new Set(incoming.namedImports)
          };
          continue;
        }
        const existing = result2[source];
        incoming.namedImports.forEach((name) => {
          existing.namedImports.add(name);
        });
        if (existing.defaultImport && incoming.defaultImport && existing.defaultImport !== incoming.defaultImport) {
          throw new Error(
            `Conflicting default imports from "${source}": "${existing.defaultImport}" vs "${incoming.defaultImport}"`
          );
        }
        existing.defaultImport || (existing.defaultImport = incoming.defaultImport);
        if (existing.namespaceImport && incoming.namespaceImport && existing.namespaceImport !== incoming.namespaceImport) {
          throw new Error(
            `Conflicting namespace imports from "${source}": "${existing.namespaceImport}" vs "${incoming.namespaceImport}"`
          );
        }
        existing.namespaceImport || (existing.namespaceImport = incoming.namespaceImport);
      }
    }
    return result2;
  }

  // src/plugins/component/react/containerStatement.ts
  function getLinkAfterForStatement(targetFile, isPrivate) {
    if (targetFile === "index.tsx") {
      if (isPrivate) {
        return [...DEFAULT_LINK_AFTER[FUNCTION_DEFINE_CHUNK_NAME.Start]];
      }
      return [...DEFAULT_LINK_AFTER[COMMON_CHUNK_NAME.FileVarDefine]];
    }
    return [COMMON_CHUNK_NAME.InternalDepsImport, COMMON_CHUNK_NAME.ExternalDepsImport];
  }
  function getChunkNameForStatement(targetFile, subModule, isPrivate) {
    if (targetFile === "index.tsx") {
      if (isPrivate) {
        return FUNCTION_DEFINE_CHUNK_NAME.InsStatement;
      }
      return COMMON_CHUNK_NAME.FileVarDefine;
    }
    return `${subModule}Statement`;
  }
  var pluginFactory26 = () => {
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      if (!ir.statements || ir.statements.length === 0) {
        return next;
      }
      const statements = ir.statements;
      const exportedIds = inferExportedStatements(statements);
      const grouped = groupStatementsByTargetFile(statements);
      const internalDeps = analyzeInternalDependencies(statements);
      const allChunks = [];
      const allImports = {};
      const subModuleToFileType = {};
      for (const [targetFile, stmts] of grouped) {
        const subModule = getSubModuleFromTargetFile(targetFile);
        const fileType = getFileTypeFromTargetFile(targetFile);
        subModuleToFileType[subModule] = fileType;
        const fileExternalImports = collectExternalDependencies(stmts);
        if (Object.keys(fileExternalImports).length > 0) {
          allImports[subModule] = fileExternalImports;
        }
        const depsFromOtherFiles = internalDeps.get(targetFile);
        if (depsFromOtherFiles) {
          for (const [fromFile, names] of depsFromOtherFiles) {
            const importContent = generateInternalImportStatement(fromFile, Array.from(names));
            allChunks.push({
              type: "string" /* STRING */,
              fileType,
              subModule,
              name: COMMON_CHUNK_NAME.InternalDepsImport,
              content: importContent,
              linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
            });
          }
        }
        for (const stmt of stmts) {
          let content = "";
          if (stmt.source) {
            content = stmt.source;
          } else if (stmt.value) {
            content = isArray_default(stmt.value) ? stmt.value.join("") : stmt.value;
          }
          const needExport = exportedIds.has(stmt.id) && targetFile !== "index.tsx";
          if (needExport) {
            const exportedContent = addExportKeyword(content);
            content = Array.isArray(exportedContent) ? exportedContent.join("\n") : exportedContent;
          }
          const isPrivate = stmt.private !== false;
          const chunkName = getChunkNameForStatement(targetFile, subModule, isPrivate);
          allChunks.push({
            type: "string" /* STRING */,
            fileType,
            subModule,
            name: chunkName,
            content,
            linkAfter: getLinkAfterForStatement(targetFile, isPrivate)
          });
        }
      }
      const indexInternalDeps = internalDeps.get("index.tsx");
      if (indexInternalDeps && !grouped.has("index.tsx")) {
        for (const [fromFile, names] of indexInternalDeps) {
          const importContent = generateInternalImportStatement(fromFile, Array.from(names));
          allChunks.push({
            type: "string" /* STRING */,
            fileType: "tsx",
            subModule: "index",
            name: COMMON_CHUNK_NAME.InternalDepsImport,
            content: importContent,
            linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
          });
        }
      }
      for (const [subModule, imports] of Object.entries(allImports)) {
        if (subModule === "index") {
          next.imports = mergeImportMaps({}, next.imports, imports);
        } else {
          for (const [pkg, spec] of Object.entries(imports)) {
            if (!pkg)
              continue;
            const importLines = [];
            if (spec.defaultImport) {
              importLines.push(`import ${spec.defaultImport} from '${pkg}';`);
            }
            if (spec.namespaceImport) {
              importLines.push(`import * as ${spec.namespaceImport} from '${pkg}';`);
            }
            if (spec.namedImports.size > 0) {
              const names = Array.from(spec.namedImports).join(", ");
              importLines.push(`import { ${names} } from '${pkg}';`);
            }
            if (importLines.length > 0) {
              const fileType = (_a = subModuleToFileType[subModule]) != null ? _a : "ts" /* TS */;
              allChunks.push({
                type: "string" /* STRING */,
                fileType,
                subModule,
                name: COMMON_CHUNK_NAME.ExternalDepsImport,
                content: importLines.join("\n"),
                linkAfter: []
              });
            }
          }
        }
      }
      next.chunks.push(...allChunks);
      return next;
    };
    return plugin;
  };
  var containerStatement_default = pluginFactory26;

  // src/plugins/component/react/functionJsx.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory27 = (config3) => {
    const cfg = {
      fileType: "tsx" /* TSX */,
      nodeTypeMapping: {},
      ...config3
    };
    const { nodeTypeMapping, fragmentAttrFilter } = cfg;
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const { tolerateEvalErrors = true, evalErrorsHandler = "" } = next.contextData;
      const imports = {};
      const customHandlers = {
        expression(input, scope2, config4) {
          var _a;
          const expr = generateExpression(input, scope2);
          return transformJsExpr(expr, scope2, {
            dontWrapEval: !((_a = config4 == null ? void 0 : config4.tolerateEvalErrors) != null ? _a : tolerateEvalErrors),
            dontTransformThis2ContextAtRootScope: true
          });
        },
        function(input, scope2) {
          if (input.imports) {
            input.imports.forEach((dep) => {
              const existing = imports[dep.package] || {
                defaultImport: null,
                namespaceImport: null,
                namedImports: /* @__PURE__ */ new Set()
              };
              if (dep.default) {
                existing.defaultImport = dep.importName;
              } else if (dep.namespace) {
                existing.namespaceImport = dep.importName;
              } else {
                existing.namedImports.add(dep.importName);
              }
              imports[dep.package] = existing;
            });
          }
          return transformThis2Context(
            generateCompositeType(
              {
                type: "JSFunction",
                value: input.value || "function () {}"
              },
              Scope.createRootScope()
            ),
            scope2,
            { ignoreRootScope: true }
          );
        }
      };
      const createFragmentAttrFilter = (tagMappingFn) => {
        return (nodeItem, scope2, config4, next2) => {
          const pieces = next2 ? next2(nodeItem, scope2, config4) : [];
          const tagName = tagMappingFn(nodeItem.componentName);
          if (tagName !== "React.Fragment" && tagName !== "Fragment") {
            return pieces;
          }
          return pieces.filter((piece) => {
            if (piece.type === "NodeCodePieceAttr" /* ATTR */) {
              return piece.name === "key";
            }
            return true;
          });
        };
      };
      const generatorPlugins = {
        handlers: customHandlers,
        tagMapping: (v) => nodeTypeMapping[v] || v,
        tolerateEvalErrors
      };
      if (fragmentAttrFilter) {
        generatorPlugins.nodePlugins = [createFragmentAttrFilter((v) => nodeTypeMapping[v] || v)];
      }
      if (next.contextData.useRefApi) {
        generatorPlugins.attrPlugins = [
          (attrData, scope2, pluginCfg, nextFunc) => {
            if (attrData.attrName === "ref") {
              return [
                {
                  name: attrData.attrName,
                  value: `this._refsManager.linkRef('${attrData.attrValue}')`,
                  type: "NodeCodePieceAttr" /* ATTR */
                }
              ];
            }
            return nextFunc ? nextFunc(attrData, scope2, pluginCfg) : [];
          }
        ];
      }
      const generator = createReactFunctionNodeGenerator(generatorPlugins);
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const jsxContent = generator(ir, scope);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: REACT_CHUNK_NAME.FunctionRenderJSX,
        content: `return ${jsxContent};`,
        linkAfter: [FUNCTION_DEFINE_CHUNK_NAME.Start, FUNCTION_DEFINE_CHUNK_NAME.InsStatement]
      });
      next.depNames = Object.keys(imports);
      next.imports = mergeImportMaps({}, next.imports, imports);
      const fragmentMappedNames = new Set(
        Object.entries(nodeTypeMapping).filter(([_, mapped]) => mapped === "Fragment").map(([original]) => original)
      );
      if (fragmentMappedNames.size > 0) {
        for (let i = next.chunks.length - 1; i >= 0; i--) {
          const chunk2 = next.chunks[i];
          if (chunk2.name !== COMMON_CHUNK_NAME.ExternalDepsImport)
            continue;
          const content = String(chunk2.content).trim();
          const namedMatch = content.match(
            /^import\s+(?:(\w+)\s*,\s*)?\{([^}]*)\}\s+from\s+['"]([^'"]*)['"]\s*;?$/
          );
          if (!namedMatch)
            continue;
          const defaultImport = namedMatch[1] || null;
          const names = namedMatch[2].split(",").map((s) => s.trim()).filter(Boolean);
          const filtered = names.filter((n) => !fragmentMappedNames.has(n));
          if (filtered.length === names.length)
            continue;
          if (filtered.length === 0 && !defaultImport) {
            next.chunks.splice(i, 1);
          } else {
            const namedPart = filtered.length > 0 ? `{ ${filtered.join(", ")} }` : "";
            const importParts = [defaultImport, namedPart].filter(Boolean).join(", ");
            next.chunks[i] = { ...chunk2, content: `import ${importParts} from '${namedMatch[3]}';` };
          }
        }
      }
      return next;
    };
    return plugin;
  };
  var functionJsx_default = pluginFactory27;

  // src/solutions/gant.ts
  function createGantChunkProjectBuilder(options) {
    return createProjectBuilder({
      mode: options == null ? void 0 : options.mode,
      inStrictMode: options == null ? void 0 : options.inStrictMode,
      rootPaths: options == null ? void 0 : options.rootPaths,
      pagePaths: options == null ? void 0 : options.pagePaths,
      configPaths: options == null ? void 0 : options.configPaths,
      extraContextData: { ...options },
      template: gant_default.template,
      plugins: {
        components: [
          reactCommonDeps_default(),
          esmodule_default({
            fileType: "tsx"
          }),
          containerInjectUtils_default(),
          styleImport_default(),
          containerFunction_default(),
          containerState_default(),
          containerStatement_default(),
          functionJsx_default({
            nodeTypeMapping: {
              Div: "div",
              Component: "div",
              Page: "Fragment",
              Block: "div"
            },
            fragmentAttrFilter: true
          }),
          css_default()
        ],
        pages: [
          reactCommonDeps_default(),
          esmodule_default({
            fileType: "tsx"
          }),
          containerInjectUtils_default({ scope: "pages" }),
          styleImport_default(),
          containerFunction_default(),
          containerState_default(),
          containerStatement_default(),
          functionJsx_default({
            nodeTypeMapping: {
              Div: "div",
              Component: "Fragment",
              Page: "Fragment",
              Block: "Fragment"
            },
            fragmentAttrFilter: true
          }),
          css_default()
        ],
        router: [esmodule_default(), gant_default.plugins.router()],
        entry: [gant_default.plugins.entry()],
        constants: [constants_default()],
        utils: [esmodule_default(), utils_default("react")],
        i18n: [i18n_default()],
        globalStyle: [gant_default.plugins.globalStyle()],
        packageJSON: [gant_default.plugins.packageJSON()],
        config: [gant_default.plugins.config()],
        detailsMap: [gant_default.plugins.detailsMap()]
      },
      postProcessors: [prettier_default()],
      customizeBuilderOptions: options == null ? void 0 : options.customizeBuilderOptions
    });
  }
  var plugins = {
    containerClass: containerClass_default,
    containerInjectContext: containerInjectContext_default,
    containerInjectUtils: containerInjectUtils_default,
    containerInjectDataSourceEngine: containerInjectDataSourceEngine_default,
    containerInjectI18n: containerInjectI18n_default,
    containerInjectConstants: containerInjectConstants_default,
    containerInitState: containerInitState_default,
    containerLifeCycle: containerLifeCycle_default,
    containerMethod: containerMethod_default,
    jsx: jsx_default,
    commonDeps: reactCommonDeps_default,
    reactCommonDeps: reactCommonDeps_default
  };

  // src/solutions/gant-legacy.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/plugins/project/framework/gant-legacy/index.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/plugins/project/framework/gant-legacy/template/index.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/plugins/project/framework/gant-legacy/template/static-files.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/plugins/project/framework/gant-legacy/template/files/.editorconfig.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile11() {
    return [
      ["."],
      {
        name: ".editorconfig",
        ext: "",
        content: "# http://editorconfig.org\nroot = true\n\n[*]\nindent_style = space\nindent_size = 2\nend_of_line = lf\ncharset = utf-8\ntrim_trailing_whitespace = true\ninsert_final_newline = true\n\n[*.md]\ntrim_trailing_whitespace = false\n\n[Makefile]\nindent_style = tab\n"
      }
    ];
  }

  // src/plugins/project/framework/gant-legacy/template/files/.gitignore.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile12() {
    return [
      ["."],
      {
        name: ".gitignore",
        ext: "",
        content: "# See https://help.github.com/articles/ignoring-files/ for more about ignoring files.\n\n# dependencies\n/node_modules\n/npm-debug.log*\n/yarn-error.log\n/yarn.lock\n/package-lock.json\n\n# production\n/dist\n\n# misc\n.DS_Store\n\n# umi\n/src/.umi\n/src/.umi-production\n/src/.umi-test\n/.env.local\n"
      }
    ];
  }

  // src/plugins/project/framework/gant-legacy/template/files/.prettierignore.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile13() {
    return [
      ["."],
      {
        name: ".prettierignore",
        ext: "",
        content: "**/*.md\n**/*.svg\n**/*.ejs\n**/*.html\npackage.json\n.umi\n.umi-production\n.umi-test\n"
      }
    ];
  }

  // src/plugins/project/framework/gant-legacy/template/files/.prettierrc.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile14() {
    return [
      ["."],
      {
        name: ".prettierrc",
        ext: "",
        content: '{\n  "singleQuote": true,\n  "trailingComma": "all",\n  "printWidth": 80,\n  "overrides": [\n    {\n      "files": ".prettierrc",\n      "options": { "parser": "json" }\n    }\n  ]\n}\n'
      }
    ];
  }

  // src/plugins/project/framework/gant-legacy/template/files/.umirc.ts.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile15() {
    return [
      ["."],
      {
        name: ".umirc",
        ext: "ts",
        content: "import { defineConfig } from 'umi';\n\nexport default defineConfig({\n  nodeModulesTransform: {\n    type: 'none',\n  },\n  routes: [\n    { path: '/', component: '@/pages/index' },\n  ],\n  fastRefresh: {},\n});\n"
      }
    ];
  }

  // src/plugins/project/framework/gant-legacy/template/files/package.json.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile16() {
    return [
      ["."],
      {
        name: "package",
        ext: "json",
        content: `{
  "private": true,
  "scripts": {
    "start": "umi dev",
    "build": "umi build",
    "postinstall": "umi generate tmp",
    "prettier": "prettier --write '**/*.{js,jsx,tsx,ts,less,md,json}'",
    "test": "umi-test",
    "test:coverage": "umi-test --coverage"
  },
  "gitHooks": {
    "pre-commit": "lint-staged"
  },
  "lint-staged": {
    "*.{js,jsx,less,md,json}": [
      "prettier --write"
    ],
    "*.ts?(x)": [
      "prettier --parser=typescript --write"
    ]
  },
  "dependencies": {
    "@ant-design/pro-layout": "^6.5.0",
    "react": "17.x",
    "react-dom": "17.x",
    "umi": "^3.5.43"
  },
  "devDependencies": {
    "@types/react": "^17.0.0",
    "@types/react-dom": "^17.0.0",
    "@umijs/preset-react": "1.x",
    "@umijs/test": "^3.5.43",
    "lint-staged": "^10.0.7",
    "prettier": "^2.2.0",
    "typescript": "^4.1.2",
    "yorkie": "^2.0.0"
  }
}
`
      }
    ];
  }

  // src/plugins/project/framework/gant-legacy/template/files/pnpm-lock.yaml.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile17() {
    return [
      ["."],
      {
        name: "pnpm-lock",
        ext: "yaml",
        content: "lockfileVersion: '9.0'\n\nsettings:\n  autoInstallPeers: true\n  excludeLinksFromLockfile: false\n\nimporters:\n\n  .:\n    dependencies:\n      '@ant-design/pro-layout':\n        specifier: ^6.5.0\n        version: 6.38.22(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react:\n        specifier: 17.x\n        version: 17.0.2\n      react-dom:\n        specifier: 17.x\n        version: 17.0.2(react@17.0.2)\n      umi:\n        specifier: ^3.5.43\n        version: 3.5.43(react-router@5.2.0(react@16.14.0))\n    devDependencies:\n      '@types/react':\n        specifier: ^17.0.0\n        version: 17.0.83\n      '@types/react-dom':\n        specifier: ^17.0.0\n        version: 17.0.26(@types/react@17.0.83)\n      '@umijs/preset-react':\n        specifier: 1.x\n        version: 1.8.32(@ant-design/icons@4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(@ant-design/pro-layout@6.38.22(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(dva-core@2.0.4(redux@4.2.1))(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@17.0.2))(react@17.0.2)(redbox-react@1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/test':\n        specifier: ^3.5.43\n        version: 3.5.43\n      lint-staged:\n        specifier: ^10.0.7\n        version: 10.5.4\n      prettier:\n        specifier: ^2.2.0\n        version: 2.8.8\n      typescript:\n        specifier: ^4.1.2\n        version: 4.9.5\n      yorkie:\n        specifier: ^2.0.0\n        version: 2.0.0\n\npackages:\n\n  '@ahooksjs/use-request@2.8.15':\n    resolution: {integrity: sha512-xhVaM4fyIiAMdVFuuU5i3CFUdFa/IblF+fvITVMFaUEO3w/V5tVCAF6WIA3T03n1/RPuzRkA7Ao1PFtSGtGelw==}\n    peerDependencies:\n      react: ^16.8.0 || ^17.0.0\n\n  '@ampproject/remapping@2.3.0':\n    resolution: {integrity: sha512-30iZtAPgz+LTIYoeivqYo853f02jBYSd5uGnGpkFV0M3xOt9aN73erkgYAmZU43x4VfqcnLxW9Kpg3R5LC4YYw==}\n    engines: {node: '>=6.0.0'}\n\n  '@ant-design/colors@6.0.0':\n    resolution: {integrity: sha512-qAZRvPzfdWHtfameEGP2Qvuf838NhergR35o+EuVyB5XvSA98xod5r4utvi4TJ3ywmevm290g9nsCG5MryrdWQ==}\n\n  '@ant-design/icons-svg@4.4.2':\n    resolution: {integrity: sha512-vHbT+zJEVzllwP+CM+ul7reTEfBR0vgxFe7+lREAsAA7YGsYpboiq2sQNeQeRvh09GfQgs/GyFEvZpJ9cLXpXA==}\n\n  '@ant-design/icons@4.8.3':\n    resolution: {integrity: sha512-HGlIQZzrEbAhpJR6+IGdzfbPym94Owr6JZkJ2QCCnOkPVIWMO2xgIVcOKnl8YcpijIo39V7l2qQL5fmtw56cMw==}\n    engines: {node: '>=8'}\n    peerDependencies:\n      react: '>=16.0.0'\n      react-dom: '>=16.0.0'\n\n  '@ant-design/pro-layout@6.38.22':\n    resolution: {integrity: sha512-rsxY2E0BTyRE7IO67VACWVPSfdtDnTaWtECuMnc4ctL+xmnzbnnr0zEHVQ+S58BxLnCqO3IyOsSc0nFl2hHsnQ==}\n    peerDependencies:\n      react: '>=16.9.0'\n\n  '@ant-design/pro-provider@1.10.0':\n    resolution: {integrity: sha512-gbQtq+Qlnob6aEghiWX/kXEzNhe4eOFlv5Ue2/xsal+22qvot/kFoOB652TD76fMI7vlkoema1pTKsvD5Uji6A==}\n    peerDependencies:\n      react: '>=16.9.0'\n\n  '@ant-design/pro-utils@1.45.3':\n    resolution: {integrity: sha512-W2qtyckdkHTWGVXfFfqb9s/ahq3o4GlIZC3+WDiGUgqJTsUkwY69yV67E2ZfAro1XRXblUzbvxIv96M7bEAfFg==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  '@ant-design/react-slick@1.0.2':\n    resolution: {integrity: sha512-Wj8onxL/T8KQLFFiCA4t8eIRGpRR+UPgOdac2sYzonv+i0n3kXHmvHLLiOYL655DQx2Umii9Y9nNgL7ssu5haQ==}\n    peerDependencies:\n      react: '>=16.9.0'\n\n  '@babel/code-frame@7.26.2':\n    resolution: {integrity: sha512-RJlIHRueQgwWitWgF8OdFYGZX328Ax5BCemNGlqHfplnRT9ESi8JkFlvaVYbS+UubVY6dpv87Fs2u5M29iNFVQ==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/compat-data@7.26.3':\n    resolution: {integrity: sha512-nHIxvKPniQXpmQLb0vhY3VaFb3S0YrTAwpOWJZh1wn3oJPjJk9Asva204PsBdmAE8vpzfHudT8DB0scYvy9q0g==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/core@7.18.6':\n    resolution: {integrity: sha512-cQbWBpxcbbs/IUredIPkHiAGULLV8iwgNRMFzvbhEXISp4f3rUUXE5+TIw6KwUWUR3DwyI6gmBRnmAtYaWehwQ==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/generator@7.26.3':\n    resolution: {integrity: sha512-6FF/urZvD0sTeO7k6/B15pMLC4CHUv1426lzr3N01aHJTl046uCAh9LXW/fzeXXjPNCJ6iABW5XaWOsIZB93aQ==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/helper-compilation-targets@7.25.9':\n    resolution: {integrity: sha512-j9Db8Suy6yV/VHa4qzrj9yZfZxhLWQdVnRlXxmKLYlhWUVB1sB2G5sxuWYXk/whHD9iW76PmNzxZ4UCnTQTVEQ==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/helper-module-imports@7.25.9':\n    resolution: {integrity: sha512-tnUA4RsrmflIM6W6RFTLFSXITtl0wKjgpnLgXyowocVPrbYrLUXSBXDgTs8BlbmIzIdlBySRQjINYs2BAkiLtw==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/helper-module-transforms@7.26.0':\n    resolution: {integrity: sha512-xO+xu6B5K2czEnQye6BHA7DolFFmS3LB7stHZFaOLb1pAwO1HWLS8fXA+eh0A2yIvltPVmx3eNNDBJA2SLHXFw==}\n    engines: {node: '>=6.9.0'}\n    peerDependencies:\n      '@babel/core': ^7.0.0\n\n  '@babel/helper-plugin-utils@7.25.9':\n    resolution: {integrity: sha512-kSMlyUVdWe25rEsRGviIgOWnoT/nfABVWlqt9N19/dIPWViAOW2s9wznP5tURbs/IDuNk4gPy3YdYRgH3uxhBw==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/helper-string-parser@7.25.9':\n    resolution: {integrity: sha512-4A/SCr/2KLd5jrtOMFzaKjVtAei3+2r/NChoBNoZ3EyP/+GlhoaEGoWOZUmFmoITP7zOJyHIMm+DYRd8o3PvHA==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/helper-validator-identifier@7.25.9':\n    resolution: {integrity: sha512-Ed61U6XJc3CVRfkERJWDz4dJwKe7iLmmJsbOGu9wSloNSFttHV0I8g6UAgb7qnK5ly5bGLPd4oXZlxCdANBOWQ==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/helper-validator-option@7.25.9':\n    resolution: {integrity: sha512-e/zv1co8pp55dNdEcCynfj9X7nyUKUXoUEwfXqaZt0omVOmDe9oOTdKStH4GmAw6zxMFs50ZayuMfHDKlO7Tfw==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/helpers@7.26.0':\n    resolution: {integrity: sha512-tbhNuIxNcVb21pInl3ZSjksLCvgdZy9KwJ8brv993QtIVKJBBkYXz4q4ZbAv31GdnC+R90np23L5FbEBlthAEw==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/parser@7.26.3':\n    resolution: {integrity: sha512-WJ/CvmY8Mea8iDXo6a7RK2wbmJITT5fN3BEkRuFlxVyNx8jOKIIhmC4fSkTcPcf8JyavbBwIe6OpiCOBXt/IcA==}\n    engines: {node: '>=6.0.0'}\n    hasBin: true\n\n  '@babel/plugin-syntax-async-generators@7.8.4':\n    resolution: {integrity: sha512-tycmZxkGfZaxhMRbXlPXuVFpdWlXpir2W4AMhSJgRKzk/eDlIXOhb2LHWoLpDF7TEHylV5zNhykX6KAgHJmTNw==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-bigint@7.8.3':\n    resolution: {integrity: sha512-wnTnFlG+YxQm3vDxpGE57Pj0srRU4sHE/mDkt1qv2YJJSeUAec2ma4WLUnUPeKjyrfntVwe/N6dCXpU+zL3Npg==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-class-properties@7.12.13':\n    resolution: {integrity: sha512-fm4idjKla0YahUNgFNLCB0qySdsoPiZP3iQE3rky0mBUtMZ23yDJ9SJdg6dXTSDnulOVqiF3Hgr9nbXvXTQZYA==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-class-static-block@7.14.5':\n    resolution: {integrity: sha512-b+YyPmr6ldyNnM6sqYeMWE+bgJcJpO6yS4QD7ymxgH34GBPNDM/THBh8iunyvKIZztiwLH4CJZ0RxTk9emgpjw==}\n    engines: {node: '>=6.9.0'}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-import-attributes@7.26.0':\n    resolution: {integrity: sha512-e2dttdsJ1ZTpi3B9UYGLw41hifAubg19AtCu/2I/F1QNVclOBr1dYpTdmdyZ84Xiz43BS/tCUkMAZNLv12Pi+A==}\n    engines: {node: '>=6.9.0'}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-import-meta@7.10.4':\n    resolution: {integrity: sha512-Yqfm+XDx0+Prh3VSeEQCPU81yC+JWZ2pDPFSS4ZdpfZhp4MkFMaDC1UqseovEKwSUpnIL7+vK+Clp7bfh0iD7g==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-json-strings@7.8.3':\n    resolution: {integrity: sha512-lY6kdGpWHvjoe2vk4WrAapEuBR69EMxZl+RoGRhrFGNYVK8mOPAW8VfbT/ZgrFbXlDNiiaxQnAtgVCZ6jv30EA==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-logical-assignment-operators@7.10.4':\n    resolution: {integrity: sha512-d8waShlpFDinQ5MtvGU9xDAOzKH47+FFoney2baFIoMr952hKOLp1HR7VszoZvOsV/4+RRszNY7D17ba0te0ig==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-nullish-coalescing-operator@7.8.3':\n    resolution: {integrity: sha512-aSff4zPII1u2QD7y+F8oDsz19ew4IGEJg9SVW+bqwpwtfFleiQDMdzA/R+UlWDzfnHFCxxleFT0PMIrR36XLNQ==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-numeric-separator@7.10.4':\n    resolution: {integrity: sha512-9H6YdfkcK/uOnY/K7/aA2xpzaAgkQn37yzWUMRK7OaPOqOpGS1+n0H5hxT9AUw9EsSjPW8SVyMJwYRtWs3X3ug==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-object-rest-spread@7.8.3':\n    resolution: {integrity: sha512-XoqMijGZb9y3y2XskN+P1wUGiVwWZ5JmoDRwx5+3GmEplNyVM2s2Dg8ILFQm8rWM48orGy5YpI5Bl8U1y7ydlA==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-optional-catch-binding@7.8.3':\n    resolution: {integrity: sha512-6VPD0Pc1lpTqw0aKoeRTMiB+kWhAoT24PA+ksWSBrFtl5SIRVpZlwN3NNPQjehA2E/91FV3RjLWoVTglWcSV3Q==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-optional-chaining@7.8.3':\n    resolution: {integrity: sha512-KoK9ErH1MBlCPxV0VANkXW2/dw4vlbGDrFgz8bmUsBGYkFRcbRwMh6cIJubdPrkxRwuGdtCk0v/wPTKbQgBjkg==}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-private-property-in-object@7.14.5':\n    resolution: {integrity: sha512-0wVnp9dxJ72ZUJDV27ZfbSj6iHLoytYZmh3rFcxNnvsJF3ktkzLDZPy/mA17HGsaQT3/DQsWYX1f1QGWkCoVUg==}\n    engines: {node: '>=6.9.0'}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/plugin-syntax-top-level-await@7.14.5':\n    resolution: {integrity: sha512-hx++upLv5U1rgYfwe1xBQUhRmU41NEvpUvrp8jkrSCdvGSnM5/qdRMtylJ6PG5OFkBaHkbTAKTnd3/YyESRHFw==}\n    engines: {node: '>=6.9.0'}\n    peerDependencies:\n      '@babel/core': ^7.0.0-0\n\n  '@babel/runtime@7.18.6':\n    resolution: {integrity: sha512-t9wi7/AW6XtKahAe20Yw0/mMljKq0B1r2fPdvaAdV/KPDZewFXdaaa6K7lxmZBZ8FBNpCiAT6iHPmd6QO9bKfQ==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/runtime@7.26.0':\n    resolution: {integrity: sha512-FDSOghenHTiToteC/QRlv2q3DhPZ/oOXTBoirfWNx1Cx3TMVcGWQtMMmQcSvb/JjpNeGzx8Pq/b4fKEJuWm1sw==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/template@7.25.9':\n    resolution: {integrity: sha512-9DGttpmPvIxBb/2uwpVo3dqJ+O6RooAFOS+lB+xDqoE2PVCE8nfoHMdZLpfCQRLwvohzXISPZcgxt80xLfsuwg==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/traverse@7.26.4':\n    resolution: {integrity: sha512-fH+b7Y4p3yqvApJALCPJcwb0/XaOSgtK4pzV6WVjPR5GLFQBRI7pfoX2V2iM48NXvX07NUxxm1Vw98YjqTcU5w==}\n    engines: {node: '>=6.9.0'}\n\n  '@babel/types@7.26.3':\n    resolution: {integrity: sha512-vN5p+1kl59GVKMvTHt55NzzmYVxprfJD+ql7U9NFIfKCBkYE55LYtS+WtPlaYOyzydrKI8Nezd+aZextrd+FMA==}\n    engines: {node: '>=6.9.0'}\n\n  '@bcoe/v8-coverage@0.2.3':\n    resolution: {integrity: sha512-0hYQ8SB4Db5zvZB4axdMHGwEaQjkZzFjQiN9LVYvIFB2nSUHW9tYpxWriPrWDASIxiaXax83REcLxuSdnGPZtw==}\n\n  '@bloomberg/record-tuple-polyfill@0.0.3':\n    resolution: {integrity: sha512-sBnCqW0nqofE47mxFnw+lvx6kzsQstwaQMVkh66qm/A6IlsnH7WsyGuVXTou8RF2wL4W7ybOoHPvP2WgIo6rhQ==}\n\n  '@cnakazawa/watch@1.0.4':\n    resolution: {integrity: sha512-v9kIhKwjeZThiWrLmj0y17CWoyddASLj9O2yvbZkbvw/N3rWOYy9zkV66ursAoVr0mV15bL8g0c4QZUE6cdDoQ==}\n    engines: {node: '>=0.1.95'}\n    hasBin: true\n\n  '@csstools/convert-colors@1.4.0':\n    resolution: {integrity: sha512-5a6wqoJV/xEdbRNKVo6I4hO3VjyDq//8q2f9I6PBAvMesJHFauXDorcNCsr9RzvsZnaWi5NYCcfyqP1QeFHFbw==}\n    engines: {node: '>=4.0.0'}\n\n  '@ctrl/tinycolor@3.6.1':\n    resolution: {integrity: sha512-SITSV6aIXsuVNV3f3O0f2n/cgyEDWoSqtZMYiAmcsYHydcKrOz3gUxB/iXd/Qf08+IZX4KpgNbvUdMBmWz+kcA==}\n    engines: {node: '>=10'}\n\n  '@formatjs/intl-displaynames@1.2.10':\n    resolution: {integrity: sha512-GROA2RP6+7Ouu0WnHFF78O5XIU7pBfI19WM1qm93l6MFWibUk67nCfVCK3VAYJkLy8L8ZxjkYT11VIAfvSz8wg==}\n\n  '@formatjs/intl-listformat@1.4.8':\n    resolution: {integrity: sha512-WNMQlEg0e50VZrGIkgD5n7+DAMGt3boKi1GJALfhFMymslJb5i+5WzWxyj/3a929Z6MAFsmzRIJjKuv+BxKAOQ==}\n\n  '@formatjs/intl-pluralrules@1.5.9':\n    resolution: {integrity: sha512-37E1ZG+Oqo3qrpUfumzNcFTV+V+NCExmTkkQ9Zw4FSlvJ4WhbbeYdieVapUVz9M0cLy8XrhCkfuM/Kn03iKReg==}\n\n  '@formatjs/intl-relativetimeformat@4.5.16':\n    resolution: {integrity: sha512-IQ0haY97oHAH5OYUdykNiepdyEWj3SAT+Fp9ZpR85ov2JNiFx+12WWlxlVS8ehdyncC2ZMt/SwFIy2huK2+6/A==}\n\n  '@formatjs/intl-unified-numberformat@3.3.7':\n    resolution: {integrity: sha512-KnWgLRHzCAgT9eyt3OS34RHoyD7dPDYhRcuKn+/6Kv2knDF8Im43J6vlSW6Hm1w63fNq3ZIT1cFk7RuVO3Psag==}\n    deprecated: We have renamed the package to @formatjs/intl-numberformat\n\n  '@formatjs/intl-utils@2.3.0':\n    resolution: {integrity: sha512-KWk80UPIzPmUg+P0rKh6TqspRw0G6eux1PuJr+zz47ftMaZ9QDwbGzHZbtzWkl5hgayM/qrKRutllRC7D/vVXQ==}\n    deprecated: the package is rather renamed to @formatjs/ecma-abstract with some changes in functionality (primarily selectUnit is removed and we don't plan to make any further changes to this package\n\n  '@istanbuljs/load-nyc-config@1.1.0':\n    resolution: {integrity: sha512-VjeHSlIzpv/NyD3N0YuHfXOPDIixcA1q2ZV98wsMqcYlPmv2n3Yb2lYP9XMElnaFVXg5A7YLTeLu6V84uQDjmQ==}\n    engines: {node: '>=8'}\n\n  '@istanbuljs/schema@0.1.3':\n    resolution: {integrity: sha512-ZXRY4jNvVgSVQ8DL3LTcakaAtXwTVUxE81hslsyD2AtoXW/wVob10HkOJ1X/pAlcI7D+2YoZKg5do8G/w6RYgA==}\n    engines: {node: '>=8'}\n\n  '@jest/console@26.6.2':\n    resolution: {integrity: sha512-IY1R2i2aLsLr7Id3S6p2BA82GNWryt4oSvEXLAKc+L2zdi89dSkE8xC1C+0kpATG4JhBJREnQOH7/zmccM2B0g==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/core@26.6.3':\n    resolution: {integrity: sha512-xvV1kKbhfUqFVuZ8Cyo+JPpipAHHAV3kcDBftiduK8EICXmTFddryy3P7NfZt8Pv37rA9nEJBKCCkglCPt/Xjw==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/environment@26.6.2':\n    resolution: {integrity: sha512-nFy+fHl28zUrRsCeMB61VDThV1pVTtlEokBRgqPrcT1JNq4yRNIyTHfyht6PqtUvY9IsuLGTrbG8kPXjSZIZwA==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/fake-timers@26.6.2':\n    resolution: {integrity: sha512-14Uleatt7jdzefLPYM3KLcnUl1ZNikaKq34enpb5XG9i81JpppDb5muZvonvKyrl7ftEHkKS5L5/eB/kxJ+bvA==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/globals@26.6.2':\n    resolution: {integrity: sha512-85Ltnm7HlB/KesBUuALwQ68YTU72w9H2xW9FjZ1eL1U3lhtefjjl5c2MiUbpXt/i6LaPRvoOFJ22yCBSfQ0JIA==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/reporters@26.6.2':\n    resolution: {integrity: sha512-h2bW53APG4HvkOnVMo8q3QXa6pcaNt1HkwVsOPMBV6LD/q9oSpxNSYZQYkAnjdMjrJ86UuYeLo+aEZClV6opnw==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/source-map@26.6.2':\n    resolution: {integrity: sha512-YwYcCwAnNmOVsZ8mr3GfnzdXDAl4LaenZP5z+G0c8bzC9/dugL8zRmxZzdoTl4IaS3CryS1uWnROLPFmb6lVvA==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/test-result@26.6.2':\n    resolution: {integrity: sha512-5O7H5c/7YlojphYNrK02LlDIV2GNPYisKwHm2QTKjNZeEzezCbwYs9swJySv2UfPMyZ0VdsmMv7jIlD/IKYQpQ==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/test-sequencer@26.6.3':\n    resolution: {integrity: sha512-YHlVIjP5nfEyjlrSr8t/YdNfU/1XEt7c5b4OxcXCjyRhjzLYu/rO69/WHPuYcbCWkz8kAeZVZp2N2+IOLLEPGw==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/transform@26.6.2':\n    resolution: {integrity: sha512-E9JjhUgNzvuQ+vVAL21vlyfy12gP0GhazGgJC4h6qUt1jSdUXGWJ1wfu/X7Sd8etSgxV4ovT1pb9v5D6QW4XgA==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jest/types@26.6.2':\n    resolution: {integrity: sha512-fC6QCp7Sc5sX6g8Tvbmj4XUTbyrik0akgRy03yjXbQaBWWNWGE7SGtJk98m0N8nzegD/7SggrUlivxo5ax4KWQ==}\n    engines: {node: '>= 10.14.2'}\n\n  '@jridgewell/gen-mapping@0.3.8':\n    resolution: {integrity: sha512-imAbBGkb+ebQyxKgzv5Hu2nmROxoDOXHh80evxdoXNOrvAnVx7zimzc1Oo5h9RlfV4vPXaE2iM5pOFbvOCClWA==}\n    engines: {node: '>=6.0.0'}\n\n  '@jridgewell/resolve-uri@3.1.2':\n    resolution: {integrity: sha512-bRISgCIjP20/tbWSPWMEi54QVPRZExkuD9lJL+UIxUKtwVJA8wW1Trb1jMs1RFXo1CBTNZ/5hpC9QvmKWdopKw==}\n    engines: {node: '>=6.0.0'}\n\n  '@jridgewell/set-array@1.2.1':\n    resolution: {integrity: sha512-R8gLRTZeyp03ymzP/6Lil/28tGeGEzhx1q2k703KGWRAI1VdvPIXdG70VJc2pAMw3NA6JKL5hhFu1sJX0Mnn/A==}\n    engines: {node: '>=6.0.0'}\n\n  '@jridgewell/source-map@0.3.6':\n    resolution: {integrity: sha512-1ZJTZebgqllO79ue2bm3rIGud/bOe0pP5BjSRCRxxYkEZS8STV7zN84UBbiYu7jy+eCKSnVIUgoWWE/tt+shMQ==}\n\n  '@jridgewell/sourcemap-codec@1.5.0':\n    resolution: {integrity: sha512-gv3ZRaISU3fjPAgNsriBRqGWQL6quFx04YMPW/zD8XMLsU32mhCCbfbO6KZFLjvYpCZ8zyDEgqsgf+PwPaM7GQ==}\n\n  '@jridgewell/trace-mapping@0.3.25':\n    resolution: {integrity: sha512-vNk6aEwybGtawWmy/PzwnGDOjCkLWSD2wqvjGGAgOAwCGWySYXfYoxt00IJkTF+8Lb57DwOb3Aa0o9CApepiYQ==}\n\n  '@qixian.cs/path-to-regexp@6.1.0':\n    resolution: {integrity: sha512-2jIiLiVZB1jnY7IIRQKtoV8Gnr7XIhk4mC88ONGunZE3hYt5IHUG4BE/6+JiTBjjEWQLBeWnZB8hGpppkufiVw==}\n\n  '@rc-component/portal@1.1.2':\n    resolution: {integrity: sha512-6f813C0IsasTZms08kfA8kPAGxbbkYToa8ALaiDIGGECU4i9hj8Plgbx0sNJDrey3EtHO30hmdaxtT0138xZcg==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  '@sinonjs/commons@1.8.6':\n    resolution: {integrity: sha512-Ky+XkAkqPZSm3NLBeUng77EBQl3cmeJhITaGHdYH8kjVB+aun3S4XBRti2zt17mtt0mIUDiNxYeoJm6drVvBJQ==}\n\n  '@sinonjs/fake-timers@6.0.1':\n    resolution: {integrity: sha512-MZPUxrmFubI36XS1DI3qmI0YdN1gks62JtFZvxR67ljjSNCeK6U08Zx4msEWOXuofgqUt6zPHSi1H9fbjR/NRA==}\n\n  '@tootallnate/once@1.1.2':\n    resolution: {integrity: sha512-RbzJvlNzmRq5c3O09UipeuXno4tA1FE6ikOjxZK0tuxVv3412l64l5t1W5pj4+rJq9vpkm/kwiR07aZXnsKPxw==}\n    engines: {node: '>= 6'}\n\n  '@types/babel__core@7.20.5':\n    resolution: {integrity: sha512-qoQprZvz5wQFJwMDqeseRXWv3rqMvhgpbXFfVyWhbx9X47POIA6i/+dXefEmZKoAgOaTdaIgNSMqMIU61yRyzA==}\n\n  '@types/babel__generator@7.6.8':\n    resolution: {integrity: sha512-ASsj+tpEDsEiFr1arWrlN6V3mdfjRMZt6LtK/Vp/kreFLnr5QH5+DhvD5nINYZXzwJvXeGq+05iUXcAzVrqWtw==}\n\n  '@types/babel__template@7.4.4':\n    resolution: {integrity: sha512-h/NUaSyG5EyxBIp8YRxo4RMe2/qQgvyowRwVMzhYhBCONbW8PUsg4lkFMrhgZhUe5z3L3MiLDuvyJ/CaPa2A8A==}\n\n  '@types/babel__traverse@7.20.6':\n    resolution: {integrity: sha512-r1bzfrm0tomOI8g1SzvCaQHo6Lcv6zu0EA+W2kHrt8dyrHQxGzBBL4kdkzIS+jBMV+EYcMAEAqXqYaLJq5rOZg==}\n\n  '@types/graceful-fs@4.1.9':\n    resolution: {integrity: sha512-olP3sd1qOEe5dXTSaFvQG+02VdRXcdytWLAZsAq1PecU8uqQAhkrnbli7DagjtXKW/Bl7YJbUsa8MPcuc8LHEQ==}\n\n  '@types/history@4.7.11':\n    resolution: {integrity: sha512-qjDJRrmvBMiTx+jyLxvLfJU7UznFuokDv4f3WRuriHKERccVpFU+8XMQUAbDzoiJCsmexxRExQeMwwCdamSKDA==}\n\n  '@types/history@5.0.0':\n    resolution: {integrity: sha512-hy8b7Y1J8OGe6LbAjj3xniQrj3v6lsivCcrmf4TzSgPzLkhIeKgc5IZnT7ReIqmEuodjfO8EYAuoFvIrHi/+jQ==}\n    deprecated: This is a stub types definition. history provides its own type definitions, so you do not need this installed.\n\n  '@types/hoist-non-react-statics@3.3.6':\n    resolution: {integrity: sha512-lPByRJUer/iN/xa4qpyL0qmL11DqNW81iU/IG1S3uvRUq4oKagz8VCxZjiWkumgt66YT3vOdDgZ0o32sGKtCEw==}\n\n  '@types/invariant@2.2.37':\n    resolution: {integrity: sha512-IwpIMieE55oGWiXkQPSBY1nw1nFs6bsKXTFskNY8sdS17K24vyEBRQZEwlRS7ZmXCWnJcQtbxWzly+cODWGs2A==}\n\n  '@types/isomorphic-fetch@0.0.35':\n    resolution: {integrity: sha512-DaZNUvLDCAnCTjgwxgiL1eQdxIKEpNLOlTNtAgnZc50bG2copGhRrFN9/PxPBuJe+tZVLCbQ7ls0xveXVRPkvw==}\n\n  '@types/istanbul-lib-coverage@2.0.6':\n    resolution: {integrity: sha512-2QF/t/auWm0lsy8XtKVPG19v3sSOQlJe/YHZgfjb/KBBHOGSV+J2q/S671rcq9uTBrLAXmZpqJiaQbMT+zNU1w==}\n\n  '@types/istanbul-lib-report@3.0.3':\n    resolution: {integrity: sha512-NQn7AHQnk/RSLOxrBbGyJM/aVQ+pjj5HCgasFxc0K/KhoATfQ/47AyUl15I2yBUpihjmas+a+VJBOqecrFH+uA==}\n\n  '@types/istanbul-reports@3.0.4':\n    resolution: {integrity: sha512-pk2B1NWalF9toCRu6gjBzR69syFjP4Od8WRAX+0mmf9lAjCRicLOWc+ZrxZHx/0XRjotgkF9t6iaMJ+aXcOdZQ==}\n\n  '@types/json-schema@7.0.15':\n    resolution: {integrity: sha512-5+fP8P8MFNC+AyZCDxrB2pkZFPGzqQWUzpSeuuVLvm8VMcorNYavBqoFcxK8bQz4Qsbn4oUEEem4wDLfcysGHA==}\n\n  '@types/node@22.10.2':\n    resolution: {integrity: sha512-Xxr6BBRCAOQixvonOye19wnzyDiUtTeqldOOmj3CkeblonbccA12PFwlufvRdrpjXxqnmUaeiU5EOA+7s5diUQ==}\n\n  '@types/normalize-package-data@2.4.4':\n    resolution: {integrity: sha512-37i+OaWTh9qeK4LSHPsyRC7NahnGotNuZvjLSgcPzblpHB3rrCJxAOgI5gCdKm7coonsaX1Of0ILiTcnZjbfxA==}\n\n  '@types/parse-json@4.0.2':\n    resolution: {integrity: sha512-dISoDXWWQwUquiKsyZ4Ng+HX2KsPL7LyHKHQwgGFEA3IaKac4Obd+h2a/a6waisAoepJlBcx9paWqjA8/HVjCw==}\n\n  '@types/prettier@2.7.3':\n    resolution: {integrity: sha512-+68kP9yzs4LMp7VNh8gdzMSPZFL44MLGqiHWvttYJe+6qnuVr4Ek9wSBQoveqY/r+LwjCcU29kNVkidwim+kYA==}\n\n  '@types/prop-types@15.7.14':\n    resolution: {integrity: sha512-gNMvNH49DJ7OJYv+KAKn0Xp45p8PLl6zo2YnvDIbTd4J6MER2BmWN49TG7n9LvkyihINxeKW8+3bfS2yDC9dzQ==}\n\n  '@types/react-dom@16.9.25':\n    resolution: {integrity: sha512-ZK//eAPhwft9Ul2/Zj+6O11YR6L4JX0J2sVeBC9Ft7x7HFN7xk7yUV/zDxqV6rjvqgl6r8Dq7oQImxtyf/Mzcw==}\n    peerDependencies:\n      '@types/react': ^16.0.0\n\n  '@types/react-dom@17.0.26':\n    resolution: {integrity: sha512-Z+2VcYXJwOqQ79HreLU/1fyQ88eXSSFh6I3JdrEHQIfYSI0kCQpTGvOrbE6jFGGYXKsHuwY9tBa/w5Uo6KzrEg==}\n    peerDependencies:\n      '@types/react': ^17.0.0\n\n  '@types/react-helmet@6.1.11':\n    resolution: {integrity: sha512-0QcdGLddTERotCXo3VFlUSWO3ztraw8nZ6e3zJSgG7apwV5xt+pJUS8ewPBqT4NYB1optGLprNQzFleIY84u/g==}\n\n  '@types/react-redux@7.1.34':\n    resolution: {integrity: sha512-GdFaVjEbYv4Fthm2ZLvj1VSCedV7TqE5y1kNwnjSdBOTXuRSgowux6J8TAct15T3CKBr63UMk+2CO7ilRhyrAQ==}\n\n  '@types/react-router-config@5.0.2':\n    resolution: {integrity: sha512-WOSetDV3YPxbkVJAdv/bqExJjmcdCi/vpCJh3NfQOy1X15vHMSiMioXIcGekXDJJYhqGUMDo9e337mh508foAA==}\n\n  '@types/react-router-dom@5.1.7':\n    resolution: {integrity: sha512-D5mHD6TbdV/DNHYsnwBTv+y73ei+mMjrkGrla86HthE4/PVvL1J94Bu3qABU+COXzpL23T1EZapVVpwHuBXiUg==}\n\n  '@types/react-router-dom@5.3.3':\n    resolution: {integrity: sha512-kpqnYK4wcdm5UaWI3fLcELopqLrHgLqNsdpHauzlQktfkHL3npOSwtj1Uz9oKBAzs7lFtVkV8j83voAz2D8fhw==}\n\n  '@types/react-router@5.1.12':\n    resolution: {integrity: sha512-0bhXQwHYfMeJlCh7mGhc0VJTRm0Gk+Z8T00aiP4702mDUuLs9SMhnd2DitpjWFjdOecx2UXtICK14H9iMnziGA==}\n\n  '@types/react-router@5.1.20':\n    resolution: {integrity: sha512-jGjmu/ZqS7FjSH6owMcD5qpq19+1RS9DeVRqfl1FeBMxTDQAGwlMWOcs52NDoXaNKyG3d1cYQFMs9rCrb88o9Q==}\n\n  '@types/react@16.14.62':\n    resolution: {integrity: sha512-BWf7hqninZav6nerxXj+NeZT/mTpDeG6Lk2zREHAy63CrnXoOGPGtNqTFYFN/sqpSaREDP5otVV88axIXmKfGA==}\n\n  '@types/react@17.0.83':\n    resolution: {integrity: sha512-l0m4ArKJvmFtR4e8UmKrj1pB4tUgOhJITf+mADyF/p69Ts1YAR/E+G9XEM0mHXKVRa1dQNHseyyDNzeuAXfXQw==}\n\n  '@types/scheduler@0.16.8':\n    resolution: {integrity: sha512-WZLiwShhwLRmeV6zH+GkbOFT6Z6VklCItrDioxUnv+u4Ll+8vKeFySoFyK/0ctcRpOmwAicELfmys1sDc/Rw+A==}\n\n  '@types/stack-utils@2.0.3':\n    resolution: {integrity: sha512-9aEbYZ3TbYMznPdcdr3SmIrLXwC/AKZXQeCf9Pgao5CKb8CyHuEX5jzWPTkvregvhRJHcpRO6BFoGW9ycaOkYw==}\n\n  '@types/yargs-parser@21.0.3':\n    resolution: {integrity: sha512-I4q9QU9MQv4oEOz4tAHJtNz1cwuLxn2F3xcc2iV5WdqLPpUnj30aUuxt1mAxYTG+oe8CZMV/+6rU4S4gRDzqtQ==}\n\n  '@types/yargs@15.0.19':\n    resolution: {integrity: sha512-2XUaGVmyQjgyAZldf0D0c14vvo/yv0MhQBSTJcejMMaitsn3nxCB6TmH4G0ZQf+uxROOa9mpanoSm8h6SG/1ZA==}\n\n  '@umijs/ast@3.5.43':\n    resolution: {integrity: sha512-P+yperHXuPCewEhgzKRXOxhpQmcK06J2PuLs7XaeQatpUTP//omJeIAcSHV8Rr9ynuvYnz9lS1qKqjgfjmZ8bA==}\n\n  '@umijs/babel-plugin-auto-css-modules@3.5.43':\n    resolution: {integrity: sha512-u1JTVqgABY3cSCWsaRumnPINZzgUE5WDTsm7BYXf5a+mdZQiv87pCU2jC6S4OabMqm3mR75gJc5wLR4sFnlkrA==}\n\n  '@umijs/babel-plugin-import-to-await-require@3.5.43':\n    resolution: {integrity: sha512-PhPTS/i2yBEdZbsSp6Cj3cEcxwLOcacjzUgkH+g9vvVwMSAgMqkI1Tx57Y70LZorE4PeUNl5yeS9hGm24JAMQA==}\n\n  '@umijs/babel-plugin-lock-core-js-3@3.5.43':\n    resolution: {integrity: sha512-hOb6cyCrn/4SQ2qGc6RBOG7aPtMHqyuy2iJonzFobdbkOW5nOnYfK/F3oeSJqn/amynFr3W6cUdflyg3Mn5lRQ==}\n\n  '@umijs/babel-plugin-no-anonymous-default-export@3.5.43':\n    resolution: {integrity: sha512-itH+IV96AChX7zKDLEKNi6IEHL+RT8DsP8BSH3oDGWRE0OM4VlpM42N195bsMtOtdl7kCb9HUP1Bg1J/+hHwsw==}\n\n  '@umijs/babel-preset-umi@3.5.43':\n    resolution: {integrity: sha512-raFsiPYy70QNKM4jSo+qdO3wkZr9PCsSSz/+CGTUPkpre5sk6ISDcuXdvEJ92viMe1Xk1+LaPcnbJqIdu7EClA==}\n\n  '@umijs/bundler-utils@3.5.43':\n    resolution: {integrity: sha512-Vw1qR+4KBQx/M1NwlDrMPydyBoA/qLT+nxZKAeIwCjkJT42QSJn38OMDqsRKRPkuoL5tLN4Ss+PbXoJ5evLWoA==}\n\n  '@umijs/bundler-webpack@3.5.43':\n    resolution: {integrity: sha512-Sf15PCMSbt0QMnRcNGIU+Nd6dha5aBZPdOE7IdlWLXJ9rSICNuhblD2P5L8MscwomOXYvsPKzNGI92MUyfjq5w==}\n    hasBin: true\n\n  '@umijs/case-sensitive-paths-webpack-plugin@1.0.1':\n    resolution: {integrity: sha512-kDKJ8yTarxwxGJDInG33hOpaQRZ//XpNuuznQ/1Mscypw6kappzFmrBr2dOYave++K7JHouoANF354UpbEQw0Q==}\n\n  '@umijs/core@3.5.43':\n    resolution: {integrity: sha512-YT/ZrYZl5xrffW3WyDzsrec0FMhebjDoJSA7A2X2WX8lmsIhjzrVEDeR265+t5J+OH7joB8pMMiV/tvhVPHb7w==}\n\n  '@umijs/deps@3.5.43':\n    resolution: {integrity: sha512-1UugbYw+Emcq1AngzLgCvpMDdIVjpBVGwdrWDcxt3zjSR/2teRbaMdzUEqaMaqMWYVMbZKorARuyit5hZorrXQ==}\n\n  '@umijs/plugin-access@2.4.3':\n    resolution: {integrity: sha512-6FON4aHzVFs/vtFK5Sdnw+FBolfoYi8wV8V9Q8x2T19NwjZtjXSPjt0gtrG4jdx4LRsSV2DKLaMGoJYbNr94aA==}\n    peerDependencies:\n      '@umijs/plugin-initial-state': 2.x\n      '@umijs/plugin-model': 2.x\n      umi: 3.x\n\n  '@umijs/plugin-analytics@0.2.2':\n    resolution: {integrity: sha512-dVDzUfgIdEwdCC6a5IsMYpIPI+bEZjBEqIhAvw9dic6Vk77w9RxQxyRfW11dDmdXLAwWphp22NntQNt1ejZPtg==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-antd@0.13.0':\n    resolution: {integrity: sha512-7tooYtOylVatrzMWCJtk8JFQL90i94OD0FgZYpKBbM7keThH8prYkSkDJFIDkuGfZ6pl6BJT8ESnYLxf2OiQUw==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-crossorigin@1.2.1':\n    resolution: {integrity: sha512-4oXNFBLOCH1FHTgFi7EDmlcjjYMthOQlrTT+mSbNeMzvl0P/WKldSJsYAUXUTg+I7vlbb5bNby4dpHKK37JcbQ==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-dva@0.13.0':\n    resolution: {integrity: sha512-cpGq8vzN8AmyWxexWLQ+WGqfT0WMCiryvU5EcNGbx1/Ub9aICUfPBpB46cxJrxjDCjUzuVslRNb2pdgI0xXUXg==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-helmet@1.1.3':\n    resolution: {integrity: sha512-X4GRFlvOb8DxMDm1vExfpWOvxl6bp0oZz114DyhwnMSriJ8RcHAigTjtVJHYxJpKv7P6KayN3n13J4w/XZGWMg==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-initial-state@2.4.0':\n    resolution: {integrity: sha512-UHH5fTL9skm4771R3xvWCrjd5xiQ7OdJ83G0P1YZLhuNbh0cAFVT8SPTU8dA9o8TTAZ66IEq7axhWl1cGxVsXw==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-layout@0.18.1':\n    resolution: {integrity: sha512-15YTcFpic0v15nFzlg6G8nvMCveBtcBL77Wr9wXYJdgR0iU7dnO7T4OqbLwgEc1uHxtGhTVibi6nSGelX56zCg==}\n    peerDependencies:\n      '@ant-design/icons': ^4.0.0\n      '@ant-design/pro-layout': ^6.0.0\n      '@umijs/plugin-initial-state': 2.x\n      '@umijs/plugin-locale': 0.x\n      '@umijs/plugin-model': 2.x\n      umi: 3.x\n\n  '@umijs/plugin-locale@0.15.2':\n    resolution: {integrity: sha512-/m3ik0NKbE/PHFPKPqSBEwGi5RUB6Dz2T7jepDXhU8ycV0zUPGbDbChUx1r/3t5zveZIND1s/7A49Apb+ujUmg==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-model@2.6.2':\n    resolution: {integrity: sha512-MKLAgYIoBkciavxTqJY6VOhvnNQv7jp+olNmXqqZ3I3WsLg7jo33NCOAA3ej103kmo9ZvD9R1aakl7e9WKsdAw==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-request@2.8.0':\n    resolution: {integrity: sha512-bwJg0rFbMZcizO+fHbSNz6X/U6suR84ciLIo9zLtRMuradx/yanMnz+ckh2dlZvTlGYrckkJwWgoSFxWlU8yyA==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/plugin-test@1.0.2':\n    resolution: {integrity: sha512-EIV86Xmw/Cn8vRLXha+ct0PfY6gRRKov5lanvt1B2L5t6xAqnTd03AxmB7i1Go9vDcFxDBheuDf/nyGiT/xTFw==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/preset-built-in@3.5.43':\n    resolution: {integrity: sha512-h9DVc5MjdUON7/xH3bxq76AHDPBTLjntDWBrW6xn+OhDT4j8/YFXrDQwaCwihCJe1eNUBLoVUjWIEIthw7g1Gg==}\n    peerDependencies:\n      react: 16.x || 17.x\n\n  '@umijs/preset-react@1.8.32':\n    resolution: {integrity: sha512-f/jJRxIRzRrZ040GMdBuV3byvtbx35oWymDT5A/q/e+QmjCrs6c9XCRktGInKIhZycqI/GuA6eLaxXIKvu6b9A==}\n    peerDependencies:\n      umi: 3.x\n\n  '@umijs/renderer-mpa@3.5.43':\n    resolution: {integrity: sha512-posQsrkFru/Q9Jft42w4pr/MEFsImd9DlKOV9zYil1ZM6JBS3/hKMmCeSd2Uku7+KgSS/8HSfc4qX/GyeRTzwA==}\n    peerDependencies:\n      react: 16.x || 17.x\n      react-dom: 16.x || 17.x\n\n  '@umijs/renderer-react@3.5.43':\n    resolution: {integrity: sha512-nadGLVbc6qrEX5pd+qY4nr9Mzl7x2hhxec2JeAd2Bg0JkZYNC8H4crTfe844uLm3MvqAtAhomGhN5c0ejDEBhA==}\n    peerDependencies:\n      react: 16.x || 17.x\n      react-dom: 16.x || 17.x\n\n  '@umijs/route-utils@2.2.2':\n    resolution: {integrity: sha512-cMk6qizy0pfpiwpVCvNQB0BKBUJEH33pDv5q5k2tSleSDw2abkJkTu2Kd5hKzoESLuFK43oGeOfcplZqm2bRxw==}\n\n  '@umijs/runtime@3.5.43':\n    resolution: {integrity: sha512-jCmkF5QcqbqzJgtd12Hy6XthLTAcaD4feMHnzM+UqTE74N7lfD13P0brXHrGqkcLbI1NgUs+9rKYIUa56w6jpw==}\n    peerDependencies:\n      react: 16.x || 17.x\n\n  '@umijs/server@3.5.43':\n    resolution: {integrity: sha512-aUSNqnO6WvhgIU6jK1+2YCNkuP6UgiEhTaT/VkSPZdCjagfov2ZfJQ0xWl8x7tocuAaBph6UvXFJWjCQvZ5pHw==}\n\n  '@umijs/ssr-darkreader@4.9.45':\n    resolution: {integrity: sha512-XlcwzSYQ/SRZpHdwIyMDS4FOGX5kP4U/2g2mykyn/iPQTK4xTiQAyBu6UnnDnn7d5P8s7Atzh1C7H0ETNOypJg==}\n\n  '@umijs/test@3.5.43':\n    resolution: {integrity: sha512-9jrziC5ngjrfiJFSdhNDMYcQNrnCQoph/Bu8lZsuBmBQwswN3YqVqefDc4fh4Kl1e4OisKtDfUDtUro8ZApaRQ==}\n    hasBin: true\n\n  '@umijs/types@3.5.43':\n    resolution: {integrity: sha512-XVZuT1X+VpPYrdlDEeginBwBNZaYUDtt3WOyFvfGmBEdqD0iNx0ZgyWmJBhlfRcck5+oYkFpOzmmRIROux2zlA==}\n\n  '@umijs/use-params@1.0.9':\n    resolution: {integrity: sha512-QlN0RJSBVQBwLRNxbxjQ5qzqYIGn+K7USppMoIOVlf7fxXHsnQZ2bEsa6Pm74bt6DVQxpUE8HqvdStn6Y9FV1w==}\n    peerDependencies:\n      react: '*'\n\n  '@umijs/utils@3.5.43':\n    resolution: {integrity: sha512-LQrCkZEa9Fb0zhId1n6CdU489tzJp4/usHVvVcTwjah7jF48zrHXD4OClGjSxvZ63d+3950mZY5IWE9UZVhnDg==}\n\n  abab@2.0.6:\n    resolution: {integrity: sha512-j2afSsaIENvHZN2B8GOpF566vZ5WVk5opAiMTvWgaQT8DkbOqsTfvNAvHoRGU2zzP8cPoqys+xHTRDWW8L+/BA==}\n    deprecated: Use your platform's native atob() and btoa() methods instead\n\n  acorn-globals@6.0.0:\n    resolution: {integrity: sha512-ZQl7LOWaF5ePqqcX4hLuv/bLXYQNfNWw2c0/yX/TsPRKamzHcTGQnlCjHT3TsmkOUVEPS3crCxiPfdzE/Trlhg==}\n\n  acorn-walk@7.2.0:\n    resolution: {integrity: sha512-OPdCF6GsMIP+Az+aWfAAOEt2/+iVDKE7oy6lJ098aoe59oAmK76qV6Gw60SbZ8jHuG2wH058GF4pLFbYamYrVA==}\n    engines: {node: '>=0.4.0'}\n\n  acorn@7.4.1:\n    resolution: {integrity: sha512-nQyp0o1/mNdbTO1PO6kHkwSrmgZ0MT/jCCpNiwbUjGoRN4dlBhqJtoQuCnEOKzgTVwg0ZWiCoQy6SxMebQVh8A==}\n    engines: {node: '>=0.4.0'}\n    hasBin: true\n\n  acorn@8.14.0:\n    resolution: {integrity: sha512-cl669nCJTZBsL97OF4kUQm5g5hC2uihk0NxY3WENAC0TYdILVkAyHymAntgxGkl7K+t0cXIrH5siy5S4XkFycA==}\n    engines: {node: '>=0.4.0'}\n    hasBin: true\n\n  add-dom-event-listener@1.1.0:\n    resolution: {integrity: sha512-WCxx1ixHT0GQU9hb0KI/mhgRQhnU+U3GvwY6ZvVjYq8rsihIGoaIOUbY0yMPBxLH5MDtr0kz3fisWGNcbWW7Jw==}\n\n  agent-base@6.0.2:\n    resolution: {integrity: sha512-RZNwNclF7+MS/8bDg70amg32dyeZGZxiDuQmZxKLAlQjr3jGyLx+4Kkk58UO7D2QdgFIQCovuSuZESne6RG6XQ==}\n    engines: {node: '>= 6.0.0'}\n\n  aggregate-error@3.1.0:\n    resolution: {integrity: sha512-4I7Td01quW/RpocfNayFdFVk1qSuoh0E7JrbRJ16nH01HhKFQ88INq9Sd+nd72zqRySlr9BmDA8xlEJ6vJMrYA==}\n    engines: {node: '>=8'}\n\n  ajv-errors@1.0.1:\n    resolution: {integrity: sha512-DCRfO/4nQ+89p/RK43i8Ezd41EqdGIU4ld7nGF8OQ14oc/we5rEntLCUa7+jrn3nn83BosfwZA0wb4pon2o8iQ==}\n    peerDependencies:\n      ajv: '>=5.0.0'\n\n  ajv-keywords@3.5.2:\n    resolution: {integrity: sha512-5p6WTN0DdTGVQk6VjcEju19IgaHudalcfabD7yhDGeA6bcQnmL+CpveLJq/3hvfwd1aof6L386Ougkx6RfyMIQ==}\n    peerDependencies:\n      ajv: ^6.9.1\n\n  ajv@6.12.6:\n    resolution: {integrity: sha512-j3fVLgvTo527anyYyJOGTYJbG+vnnQYvE0m5mmkc1TK+nxAppkCLMIL0aZ4dblVCNoGShhm+kzE4ZUykBoMg4g==}\n\n  ansi-colors@4.1.3:\n    resolution: {integrity: sha512-/6w/C21Pm1A7aZitlI5Ni/2J6FFQN8i1Cvz3kHABAAbw93v/NlvKdVOqz7CCWz/3iv/JplRSEEZ83XION15ovw==}\n    engines: {node: '>=6'}\n\n  ansi-escapes@4.3.2:\n    resolution: {integrity: sha512-gKXj5ALrKWQLsYG9jlTRmR/xKluxHV+Z9QEwNIgCfM1/uwPMCuzVVnh5mwTd+OuBZcwSIMbqssNWRm1lE51QaQ==}\n    engines: {node: '>=8'}\n\n  ansi-html@0.0.9:\n    resolution: {integrity: sha512-ozbS3LuenHVxNRh/wdnN16QapUHzauqSomAl1jwwJRRsGwFwtj644lIhxfWu0Fy0acCij2+AEgHvjscq3dlVXg==}\n    engines: {'0': node >= 0.8.0}\n    hasBin: true\n\n  ansi-regex@5.0.1:\n    resolution: {integrity: sha512-quJQXlTSUGL2LH9SUXo8VwsY4soanhgo6LNSm84E1LBcE8s3O0wpdiRzyR9z/ZZJMlMWv37qOOb9pdJlMUEKFQ==}\n    engines: {node: '>=8'}\n\n  ansi-styles@3.2.1:\n    resolution: {integrity: sha512-VT0ZI6kZRdTh8YyJw3SMbYm/u+NqfsAxEpWO0Pf9sq8/e94WxxOpPKx9FR1FlyCtOVDNOQ+8ntlqFxiRc+r5qA==}\n    engines: {node: '>=4'}\n\n  ansi-styles@4.3.0:\n    resolution: {integrity: sha512-zbB9rCJAT1rbjiVDb2hqKFHNYLxgtk8NURxZ3IZwD3F6NtxbXZQCnnSi1Lkx+IDohdPlFp222wVALIheZJQSEg==}\n    engines: {node: '>=8'}\n\n  antd-mobile@2.3.4:\n    resolution: {integrity: sha512-Uw02Ghc+DPzaQceJQ+5p1ZnQFafvILA0chTTen7m7c89Uzbw6Ny3zsVZDE1gfteNEIsL4JpPe0I/+aI3Q/nPAA==}\n\n  antd@4.24.16:\n    resolution: {integrity: sha512-zZrK4UYxHtU6tGOOf0uG/kBRx1kTvypfuSB3GqE/SBQxFhZ/TZ+yj7Z1qwI8vGfMtUUJdLeuoCAqGDa1zPsXnQ==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  anymatch@2.0.0:\n    resolution: {integrity: sha512-5teOsQWABXHHBFP9y3skS5P3d/WfWXpv3FUpy+LorMrNYaT9pI4oLMQX7jzQ2KklNpGpWHzdCXTDT2Y3XGlZBw==}\n\n  anymatch@3.1.3:\n    resolution: {integrity: sha512-KMReFUr0B4t+D+OBkjR3KYqvocp2XaSzO55UcB6mgQMd3KbcE+mWTyvVV7D/zsdEbNnV6acZUutkiHQXvTr1Rw==}\n    engines: {node: '>= 8'}\n\n  arch@2.2.0:\n    resolution: {integrity: sha512-Of/R0wqp83cgHozfIYLbBMnej79U/SVGOOyuB3VVFv1NRM/PSFMK12x9KVtiYzJqmnU5WR2qp0Z5rHb7sWGnFQ==}\n\n  argparse@1.0.10:\n    resolution: {integrity: sha512-o5Roy6tNG4SL/FOkCAN6RzjiakZS25RLYFrcMttJqbdd8BWrnA+fGz57iN5Pb06pvBGvl5gQ0B48dJlslXvoTg==}\n\n  arr-diff@4.0.0:\n    resolution: {integrity: sha512-YVIQ82gZPGBebQV/a8dar4AitzCQs0jjXwMPZllpXMaGjXPYVUawSxQrRsjhjupyVxEvbHgUmIhKVlND+j02kA==}\n    engines: {node: '>=0.10.0'}\n\n  arr-flatten@1.1.0:\n    resolution: {integrity: sha512-L3hKV5R/p5o81R7O02IGnwpDmkp6E982XhtbuwSe3O4qOtMMMtodicASA1Cny2U+aCXcNpml+m4dPsvsJ3jatg==}\n    engines: {node: '>=0.10.0'}\n\n  arr-union@3.1.0:\n    resolution: {integrity: sha512-sKpyeERZ02v1FeCZT8lrfJq5u6goHCtpTAzPwJYe7c8SPFOboNjNg1vz2L4VTn9T4PQxEx13TbXLmYUcS6Ug7Q==}\n    engines: {node: '>=0.10.0'}\n\n  array-tree-filter@2.1.0:\n    resolution: {integrity: sha512-4ROwICNlNw/Hqa9v+rk5h22KjmzB1JGTMVKP2AKJBOCgb0yL0ASf0+YvCcLNNwquOHNX48jkeZIJ3a+oOQqKcw==}\n\n  array-unique@0.3.2:\n    resolution: {integrity: sha512-SleRWjh9JUud2wH1hPs9rZBZ33H6T9HOiL0uwGnGx9FpE6wKGyfWugmbkEOIs6qWrZhg0LWeLziLrEwQJhs5mQ==}\n    engines: {node: '>=0.10.0'}\n\n  asap@2.0.6:\n    resolution: {integrity: sha512-BSHWgDSAiKs50o2Re8ppvp3seVHXSRM44cdSsT9FfNEUUZLOGWVCsiWaRPWM1Znn+mqZ1OfVZ3z3DWEzSp7hRA==}\n\n  asn1.js@4.10.1:\n    resolution: {integrity: sha512-p32cOF5q0Zqs9uBiONKYLm6BClCoBCM5O9JfeUSlnQLBTxYdTK+pW+nXflm8UkKd2UYlEbYz5qEi0JuZR9ckSw==}\n\n  assert@1.5.1:\n    resolution: {integrity: sha512-zzw1uCAgLbsKwBfFc8CX78DDg+xZeBksSO3vwVIDDN5i94eOrPsSSyiVhmsSABFDM/OcpE2aagCat9dnWQLG1A==}\n\n  assign-symbols@1.0.0:\n    resolution: {integrity: sha512-Q+JC7Whu8HhmTdBph/Tq59IoRtoy6KAm5zzPv00WdujX82lbAL8K7WVjne7vdCsAmbF4AYaDOPyO3k0kl8qIrw==}\n    engines: {node: '>=0.10.0'}\n\n  astral-regex@2.0.0:\n    resolution: {integrity: sha512-Z7tMw1ytTXt5jqMcOP+OQteU1VuNK9Y02uuJtKQ1Sv69jXQKKg5cibLwGJow8yzZP+eAc18EmLGPal0bp36rvQ==}\n    engines: {node: '>=8'}\n\n  async-validator@4.2.5:\n    resolution: {integrity: sha512-7HhHjtERjqlNbZtqNqy2rckN/SpOOlmDliet+lP7k+eKZEjPk3DgyeU9lIXLdeLz0uBbbVp+9Qdow9wJWgwwfg==}\n\n  asynckit@0.4.0:\n    resolution: {integrity: sha512-Oei9OH4tRh0YqU3GxhX79dM/mwVgvbZJaSNaRk+bshkj0S5cfHcgYakreBjrHwatXKbz+IoIdYLxrKim2MjW0Q==}\n\n  atob@2.1.2:\n    resolution: {integrity: sha512-Wm6ukoaOGJi/73p/cl2GvLjTI5JM1k/O14isD73YML8StrH/7/lRFgmg8nICZgD3bZZvjwCGxtMOD3wWNAu8cg==}\n    engines: {node: '>= 4.5.0'}\n    hasBin: true\n\n  autoprefixer@9.8.8:\n    resolution: {integrity: sha512-eM9d/swFopRt5gdJ7jrpCwgvEMIayITpojhkkSMRsFHYuH5bkSQ4p/9qTEHtmNudUZh22Tehu7I6CxAW0IXTKA==}\n    hasBin: true\n\n  babel-jest@26.6.3:\n    resolution: {integrity: sha512-pl4Q+GAVOHwvjrck6jKjvmGhnO3jHX/xuB9d27f+EJZ/6k+6nMuPjorrYp7s++bKKdANwzElBWnLWaObvTnaZA==}\n    engines: {node: '>= 10.14.2'}\n    peerDependencies:\n      '@babel/core': ^7.0.0\n\n  babel-plugin-dva-hmr@0.4.2:\n    resolution: {integrity: sha512-QP5W0IT9LDFgoqkXD0g7wn/FMn7zO562P8qys23twXri4i3E1SGOQ3z7jqcPrqzfTZHx+Ufr+cXy9oI6OLMYZg==}\n    peerDependencies:\n      redbox-react: 1.x\n\n  babel-plugin-istanbul@6.1.1:\n    resolution: {integrity: sha512-Y1IQok9821cC9onCx5otgFfRm7Lm+I+wwxOx738M/WLPZ9Q42m4IG5W0FNX8WLL2gYMZo3JkuXIH2DOpWM+qwA==}\n    engines: {node: '>=8'}\n\n  babel-plugin-jest-hoist@26.6.2:\n    resolution: {integrity: sha512-PO9t0697lNTmcEHH69mdtYiOIkkOlj9fySqfO3K1eCcdISevLAE0xY59VLLUj0SoiPiTX/JU2CYFpILydUa5Lw==}\n    engines: {node: '>= 10.14.2'}\n\n  babel-preset-current-node-syntax@1.1.0:\n    resolution: {integrity: sha512-ldYss8SbBlWva1bs28q78Ju5Zq1F+8BrqBZZ0VFhLBvhh6lCpC2o3gDJi/5DRLs9FgYZCnmPYIVFU4lRXCkyUw==}\n    peerDependencies:\n      '@babel/core': ^7.0.0\n\n  babel-preset-jest@26.6.2:\n    resolution: {integrity: sha512-YvdtlVm9t3k777c5NPQIv6cxFFFapys25HiUmuSgHwIZhfifweR5c5Sf5nwE3MAbfu327CYSvps8Yx6ANLyleQ==}\n    engines: {node: '>= 10.14.2'}\n    peerDependencies:\n      '@babel/core': ^7.0.0\n\n  babel-runtime@6.26.0:\n    resolution: {integrity: sha512-ITKNuq2wKlW1fJg9sSW52eepoYgZBggvOAHC0u/CYu/qxQ9EVzThCgR69BnSXLHjy2f7SY5zaQ4yt7H9ZVxY2g==}\n\n  balanced-match@1.0.2:\n    resolution: {integrity: sha512-3oSeUO0TMV67hN1AmbXsK4yaqU7tjiHlbxRDZOpH0KW9+CeX4bRAaX0Anxt0tx2MrpRpWwQaPwIlISEJhYU5Pw==}\n\n  base64-js@1.5.1:\n    resolution: {integrity: sha512-AKpaYlHn8t4SVbOHCy+b5+KKgvR4vrsD8vbvrbiQJps7fKDTkjkDry6ji0rUJjC0kzbNePLwzxq8iypo41qeWA==}\n\n  base@0.11.2:\n    resolution: {integrity: sha512-5T6P4xPgpp0YDFvSWwEZ4NoE3aM4QBQXDzmVbraCkFj8zHM+mba8SyqB5DbZWyR7mYHo6Y7BdQo3MoA4m0TeQg==}\n    engines: {node: '>=0.10.0'}\n\n  big.js@5.2.2:\n    resolution: {integrity: sha512-vyL2OymJxmarO8gxMr0mhChsO9QGwhynfuu4+MHTAW6czfq9humCB7rKpUjDd9YUiDPU4mzpyupFSvOClAwbmQ==}\n\n  binary-extensions@2.3.0:\n    resolution: {integrity: sha512-Ceh+7ox5qe7LJuLHoY0feh3pHuUDHAcRUeyL2VYghZwfpkNIy/+8Ocg0a3UuSoYzavmylwuLWQOf3hl0jjMMIw==}\n    engines: {node: '>=8'}\n\n  bn.js@4.12.1:\n    resolution: {integrity: sha512-k8TVBiPkPJT9uHLdOKfFpqcfprwBFOAAXXozRubr7R7PfIuKvQlzcI4M0pALeqXN09vdaMbUdUj+pass+uULAg==}\n\n  bn.js@5.2.1:\n    resolution: {integrity: sha512-eXRvHzWyYPBuB4NBy0cmYQjGitUrtqwbvlzP3G6VFnNRbsZQIxQ10PbKKHt8gZ/HW/D/747aDl+QkDqg3KQLMQ==}\n\n  brace-expansion@1.1.11:\n    resolution: {integrity: sha512-iCuPHDFgrHX7H2vEI/5xpz07zSHB00TpugqhmYtVmMO6518mCuRMoOYFldEBl0g187ufozdaHgWKcYFb61qGiA==}\n\n  braces@2.3.2:\n    resolution: {integrity: sha512-aNdbnj9P8PjdXU4ybaWLK2IF3jc/EoDYbC7AazW6to3TRsfXxscC9UXOB5iDiEQrkyIbWp2SLQda4+QAa7nc3w==}\n    engines: {node: '>=0.10.0'}\n\n  braces@3.0.3:\n    resolution: {integrity: sha512-yQbXgO/OSZVD2IsiLlro+7Hf6Q18EJrKSEsdoMzKePKXct3gvD8oLcOQdIzGupr5Fj+EDe8gO/lxc1BzfMpxvA==}\n    engines: {node: '>=8'}\n\n  brorand@1.1.0:\n    resolution: {integrity: sha512-cKV8tMCEpQs4hK/ik71d6LrPOnpkpGBR0wzxqr68g2m/LB2GxVYQroAjMJZRVM1Y4BCjCKc3vAamxSzOY2RP+w==}\n\n  browser-process-hrtime@1.0.0:\n    resolution: {integrity: sha512-9o5UecI3GhkpM6DrXr69PblIuWxPKk9Y0jHBRhdocZ2y7YECBFCsHm79Pr3OyR2AvjhDkabFJaDJMYRazHgsow==}\n\n  browserify-aes@1.2.0:\n    resolution: {integrity: sha512-+7CHXqGuspUn/Sl5aO7Ea0xWGAtETPXNSAjHo48JfLdPWcMng33Xe4znFvQweqc/uzk5zSOI3H52CYnjCfb5hA==}\n\n  browserify-cipher@1.0.1:\n    resolution: {integrity: sha512-sPhkz0ARKbf4rRQt2hTpAHqn47X3llLkUGn+xEJzLjwY8LRs2p0v7ljvI5EyoRO/mexrNunNECisZs+gw2zz1w==}\n\n  browserify-des@1.0.2:\n    resolution: {integrity: sha512-BioO1xf3hFwz4kc6iBhI3ieDFompMhrMlnDFC4/0/vd5MokpuAc3R+LYbwTA9A5Yc9pq9UYPqffKpW2ObuwX5A==}\n\n  browserify-rsa@4.1.1:\n    resolution: {integrity: sha512-YBjSAiTqM04ZVei6sXighu679a3SqWORA3qZTEqZImnlkDIFtKc6pNutpjyZ8RJTjQtuYfeetkxM11GwoYXMIQ==}\n    engines: {node: '>= 0.10'}\n\n  browserify-sign@4.2.3:\n    resolution: {integrity: sha512-JWCZW6SKhfhjJxO8Tyiiy+XYB7cqd2S5/+WeYHsKdNKFlCBhKbblba1A/HN/90YwtxKc8tCErjffZl++UNmGiw==}\n    engines: {node: '>= 0.12'}\n\n  browserify-zlib@0.2.0:\n    resolution: {integrity: sha512-Z942RysHXmJrhqk88FmKBVq/v5tqmSkDz7p54G/MGyjMnCFFnC79XWNbg+Vta8W6Wb2qtSZTSxIGkJrRpCFEiA==}\n\n  browserslist@4.24.2:\n    resolution: {integrity: sha512-ZIc+Q62revdMcqC6aChtW4jz3My3klmCO1fEmINZY/8J3EpBg5/A/D0AKmBveUh6pgoeycoMkVMko84tuYS+Gg==}\n    engines: {node: ^6 || ^7 || ^8 || ^9 || ^10 || ^11 || ^12 || >=13.7}\n    hasBin: true\n\n  bser@2.1.1:\n    resolution: {integrity: sha512-gQxTNE/GAfIIrmHLUE3oJyp5FO6HRBfhjnw4/wMmA63ZGDJnWBmgY/lyQBpnDUkGmAhbSe39tx2d/iTOAfglwQ==}\n\n  buffer-from@1.1.2:\n    resolution: {integrity: sha512-E+XQCRwSbaaiChtv6k6Dwgc+bx+Bs6vuKJHHl5kox/BaKbhiXzqQOwK4cO22yElGp2OCmjwVhT3HmxgyPGnJfQ==}\n\n  buffer-xor@1.0.3:\n    resolution: {integrity: sha512-571s0T7nZWK6vB67HI5dyUF7wXiNcfaPPPTl6zYCNApANjIvYJTg7hlud/+cJpdAhS7dVzqMLmfhfHR3rAcOjQ==}\n\n  buffer@4.9.2:\n    resolution: {integrity: sha512-xq+q3SRMOxGivLhBNaUdC64hDTQwejJ+H0T/NB1XMtTVEwNTrfFF3gAxiyW0Bu/xWEGhjVKgUcMhCrUy2+uCWg==}\n\n  builtin-status-codes@3.0.0:\n    resolution: {integrity: sha512-HpGFw18DgFWlncDfjTa2rcQ4W88O1mC8e8yZ2AvQY5KDaktSTwo+KRf6nHK6FRI5FyRyb/5T6+TSxfP7QyGsmQ==}\n\n  cache-base@1.0.1:\n    resolution: {integrity: sha512-AKcdTnFSWATd5/GCPRxr2ChwIJ85CeyrEyjRHlKxQ56d4XJMGym0uAiKn0xbLOGOl3+yRpOTi484dVCEc5AUzQ==}\n    engines: {node: '>=0.10.0'}\n\n  call-bind-apply-helpers@1.0.1:\n    resolution: {integrity: sha512-BhYE+WDaywFg2TBWYNXAE+8B1ATnThNBqXHP5nQu0jWJdVvY2hvkpyB3qOmtmDePiS5/BDQ8wASEWGMWRG148g==}\n    engines: {node: '>= 0.4'}\n\n  call-bind@1.0.8:\n    resolution: {integrity: sha512-oKlSFMcMwpUg2ednkhQ454wfWiU/ul3CkJe/PEHcTKuiX6RpbehUiFMXu13HalGZxfUwCQzZG747YXBn1im9ww==}\n    engines: {node: '>= 0.4'}\n\n  call-bound@1.0.2:\n    resolution: {integrity: sha512-0lk0PHFe/uz0vl527fG9CgdE9WdafjDbCXvBbs+LUv000TVt2Jjhqbs4Jwm8gz070w8xXyEAxrPOMullsxXeGg==}\n    engines: {node: '>= 0.4'}\n\n  caller-callsite@2.0.0:\n    resolution: {integrity: sha512-JuG3qI4QOftFsZyOn1qq87fq5grLIyk1JYd5lJmdA+fG7aQ9pA/i3JIJGcO3q0MrRcHlOt1U+ZeHW8Dq9axALQ==}\n    engines: {node: '>=4'}\n\n  caller-path@2.0.0:\n    resolution: {integrity: sha512-MCL3sf6nCSXOwCTzvPKhN18TU7AHTvdtam8DAogxcrJ8Rjfbbg7Lgng64H9Iy+vUV6VGFClN/TyxBkAebLRR4A==}\n    engines: {node: '>=4'}\n\n  callsites@2.0.0:\n    resolution: {integrity: sha512-ksWePWBloaWPxJYQ8TL0JHvtci6G5QTKwQ95RcWAa/lzoAKuAOflGdAK92hpHXjkwb8zLxoLNUoNYZgVsaJzvQ==}\n    engines: {node: '>=4'}\n\n  callsites@3.1.0:\n    resolution: {integrity: sha512-P8BjAsXvZS+VIDUI11hHCQEv74YT67YUi5JJFNWIqL235sBmjX4+qx9Muvls5ivyNENctx46xQLQ3aTuE7ssaQ==}\n    engines: {node: '>=6'}\n\n  camelcase@5.3.1:\n    resolution: {integrity: sha512-L28STB170nwWS63UjtlEOE3dldQApaJXZkOI1uMFfzf3rRuPegHaHesyee+YxQ+W6SvRDQV6UrdOdRiR153wJg==}\n    engines: {node: '>=6'}\n\n  camelcase@6.3.0:\n    resolution: {integrity: sha512-Gmy6FhYlCY7uOElZUSbxo2UCDH8owEk996gkbrpsgGtrJLM3J7jGxl9Ic7Qwwj4ivOE5AWZWRMecDdF7hqGjFA==}\n    engines: {node: '>=10'}\n\n  caniuse-lite@1.0.30001688:\n    resolution: {integrity: sha512-Nmqpru91cuABu/DTCXbM2NSRHzM2uVHfPnhJ/1zEAJx/ILBRVmz3pzH4N7DZqbdG0gWClsCC05Oj0mJ/1AWMbA==}\n\n  capture-exit@2.0.0:\n    resolution: {integrity: sha512-PiT/hQmTonHhl/HFGN+Lx3JJUznrVYJ3+AQsnthneZbvW7x+f08Tk7yLJTLEOUvBTbduLeeBkxEaYXUOUrRq6g==}\n    engines: {node: 6.* || 8.* || >= 10.*}\n\n  chalk@2.4.2:\n    resolution: {integrity: sha512-Mti+f9lpJNcwF4tWV8/OrTTtF1gZi+f8FqlyAdouralcFWFQWF2+NgCHShjkCb+IFBLq9buZwE1xckQU4peSuQ==}\n    engines: {node: '>=4'}\n\n  chalk@4.1.2:\n    resolution: {integrity: sha512-oKnbhFyRIXpUuez8iBMmyEa4nbj4IOQyuhc/wy9kY7/WVPcwIO9VA668Pu8RkO7+0G76SLROeyw9CpQ061i4mA==}\n    engines: {node: '>=10'}\n\n  char-regex@1.0.2:\n    resolution: {integrity: sha512-kWWXztvZ5SBQV+eRgKFeh8q5sLuZY2+8WUIzlxWVTg+oGwY14qylx1KbKzHd8P6ZYkAg0xyIDU9JMHhyJMZ1jw==}\n    engines: {node: '>=10'}\n\n  chokidar@3.5.1:\n    resolution: {integrity: sha512-9+s+Od+W0VJJzawDma/gvBNQqkTiqYTWLuZoyAsivsI4AaWTCzHG06/TMjsf1cYe9Cb97UCEhjz7HvnPk2p/tw==}\n    engines: {node: '>= 8.10.0'}\n\n  ci-info@1.6.0:\n    resolution: {integrity: sha512-vsGdkwSCDpWmP80ncATX7iea5DWQemg1UgCW5J8tqjU3lYw4FBYuj89J0CTVomA7BEfvSZd84GmHko+MxFQU2A==}\n\n  ci-info@2.0.0:\n    resolution: {integrity: sha512-5tK7EtrZ0N+OLFMthtqOj4fI2Jeb88C4CAZPu25LDVUgXJ0A3Js4PMGqrn0JU1W0Mh1/Z8wZzYPxqUrXeBboCQ==}\n\n  cipher-base@1.0.6:\n    resolution: {integrity: sha512-3Ek9H3X6pj5TgenXYtNWdaBon1tgYCaebd+XPg0keyjEbEfkD4KkmAxkQ/i1vYvxdcT5nscLBfq9VJRmCBcFSw==}\n    engines: {node: '>= 0.10'}\n\n  cjs-module-lexer@0.6.0:\n    resolution: {integrity: sha512-uc2Vix1frTfnuzxxu1Hp4ktSvM3QaI4oXl4ZUqL1wjTu/BGki9TrCWoqLTg/drR1KwAEarXuRFCG2Svr1GxPFw==}\n\n  class-utils@0.3.6:\n    resolution: {integrity: sha512-qOhPa/Fj7s6TY8H8esGu5QNpMMQxz79h+urzrNYN6mn+9BnxlDGf5QZ+XeCDsxSjPqsSR56XOZOJmpeurnLMeg==}\n    engines: {node: '>=0.10.0'}\n\n  classnames@2.5.1:\n    resolution: {integrity: sha512-saHYOzhIQs6wy2sVxTM6bUDsQO4F50V9RQ22qBpEdCW+I+/Wmke2HOl6lS6dTpdxVhb88/I6+Hs+438c3lfUow==}\n\n  clean-stack@2.2.0:\n    resolution: {integrity: sha512-4diC9HaTE+KRAMWhDhrGOECgWZxoevMc5TlkObMqNSsVU62PYzXZ/SMTjzyGAFF1YusgxGcSWTEXBhp0CPwQ1A==}\n    engines: {node: '>=6'}\n\n  cli-cursor@3.1.0:\n    resolution: {integrity: sha512-I/zHAwsKf9FqGoXM4WWRACob9+SNukZTd94DWF57E4toouRulbCxcUh6RKUEOQlYTHJnzkPMySvPNaaSLNfLZw==}\n    engines: {node: '>=8'}\n\n  cli-truncate@2.1.0:\n    resolution: {integrity: sha512-n8fOixwDD6b/ObinzTrp1ZKFzbgvKZvuz/TvejnLn1aQfC6r52XEx85FmuC+3HI+JM7coBRXUvNqEU2PHVrHpg==}\n    engines: {node: '>=8'}\n\n  clipboardy@2.3.0:\n    resolution: {integrity: sha512-mKhiIL2DrQIsuXMgBgnfEHOZOryC7kY7YO//TN6c63wlEm3NG5tz+YgY5rVi29KCmq/QQjKYvM7a19+MDOTHOQ==}\n    engines: {node: '>=8'}\n\n  cliui@6.0.0:\n    resolution: {integrity: sha512-t6wbgtoCXvAzst7QgXxJYqPt0usEfbgQdftEPbLL/cvv6HPE5VgvqCuAIDR0NgU52ds6rFwqrgakNLrHEjCbrQ==}\n\n  co@4.6.0:\n    resolution: {integrity: sha512-QVb0dM5HvG+uaxitm8wONl7jltx8dqhfU33DcqtOZcLSVIKSDDLDi7+0LbAKiyI8hD9u42m2YxXSkMGWThaecQ==}\n    engines: {iojs: '>= 1.0.0', node: '>= 0.12.0'}\n\n  collect-v8-coverage@1.0.2:\n    resolution: {integrity: sha512-lHl4d5/ONEbLlJvaJNtsF/Lz+WvB07u2ycqTYbdrq7UypDXailES4valYb2eWiJFxZlVmpGekfqoxQhzyFdT4Q==}\n\n  collection-visit@1.0.0:\n    resolution: {integrity: sha512-lNkKvzEeMBBjUGHZ+q6z9pSJla0KWAQPvtzhEV9+iGyQYG+pBpl7xKDhxoNSOZH2hhv0v5k0y2yAM4o4SjoSkw==}\n    engines: {node: '>=0.10.0'}\n\n  color-convert@1.9.3:\n    resolution: {integrity: sha512-QfAUtd+vFdAtFQcC8CCyYt1fYWxSqAiK2cSD6zDB8N3cpsEBAvRxp9zOGg6G/SHHJYAT88/az/IuDGALsNVbGg==}\n\n  color-convert@2.0.1:\n    resolution: {integrity: sha512-RRECPsj7iu/xb5oKYcsFHSppFNnsj/52OVTRKb4zP5onXwVF3zVmmToNcOfGC+CRDpfK/U584fMg38ZHCaElKQ==}\n    engines: {node: '>=7.0.0'}\n\n  color-name@1.1.3:\n    resolution: {integrity: sha512-72fSenhMw2HZMTVHeCA9KCmpEIbzWiQsjN+BHcBbS9vr1mtt+vJjPdksIBNUmKAW8TFUDPJK5SUU3QhE9NEXDw==}\n\n  color-name@1.1.4:\n    resolution: {integrity: sha512-dOy+3AuW3a2wNbZHIuMZpTcgjGuLU/uBL/ubcZF9OXbDo8ff4O8yVp5Bf0efS8uEoYo5q4Fx7dY9OgQGXgAsQA==}\n\n  colorette@2.0.20:\n    resolution: {integrity: sha512-IfEDxwoWIjkeXL1eXcDiow4UbKjhLdq6/EuSVR9GMN7KVH3r9gQ83e73hsz1Nd1T3ijd5xv1wcWRYO+D6kCI2w==}\n\n  combined-stream@1.0.8:\n    resolution: {integrity: sha512-FQN4MRfuJeHf7cBbBMJFXhKSDq+2kAArBlmRBvcvFE5BB1HZKXtSFASDhdlz9zOYwxh8lDdnvmMOe/+5cdoEdg==}\n    engines: {node: '>= 0.8'}\n\n  commander@2.20.3:\n    resolution: {integrity: sha512-GpVkmM8vF2vQUkj2LvZmD35JxeJOLCwJ9cUkugyk2nuhbv3+mJvpLYYt+0+USMxE+oj+ey/lJEnhZw75x/OMcQ==}\n\n  commander@6.2.1:\n    resolution: {integrity: sha512-U7VdrJFnJgo4xjrHpTzu0yrHPGImdsmD95ZlgYSEajAn2JKzDhDTPG9kBTefmObL2w/ngeZnilk+OV9CG3d7UA==}\n    engines: {node: '>= 6'}\n\n  component-classes@1.2.6:\n    resolution: {integrity: sha512-hPFGULxdwugu1QWW3SvVOCUHLzO34+a2J6Wqy0c5ASQkfi9/8nZcBB0ZohaEbXOQlCflMAEMmEWk7u7BVs4koA==}\n\n  component-emitter@1.3.1:\n    resolution: {integrity: sha512-T0+barUSQRTUQASh8bx02dl+DhF54GtIDY13Y3m9oWTklKbb3Wv974meRpeZ3lp1JpLVECWWNHC4vaG2XHXouQ==}\n\n  component-indexof@0.0.3:\n    resolution: {integrity: sha512-puDQKvx/64HZXb4hBwIcvQLaLgux8o1CbWl39s41hrIIZDl1lJiD5jc22gj3RBeGK0ovxALDYpIbyjqDUUl0rw==}\n\n  compute-scroll-into-view@1.0.20:\n    resolution: {integrity: sha512-UCB0ioiyj8CRjtrvaceBLqqhZCVP+1B8+NWQhmdsm0VXOJtobBCf1dBQmebCCo34qZmUwZfIH2MZLqNHazrfjg==}\n\n  concat-map@0.0.1:\n    resolution: {integrity: sha512-/Srv4dswyQNBfohGpz9o6Yb3Gz3SrUDqBH5rTuhGR7ahtlbYKnVxw2bCFMRljaA7EXHaXZ8wsHdodFvbkhKmqg==}\n\n  connected-react-router@6.5.2:\n    resolution: {integrity: sha512-qzsLPZCofSI80fwy+HgxtEgSGS4ndYUUZAWaw1dqaOGPLKX/FVwIOEb7q+hjHdnZ4v5pKZcNv5GG4urjujIoyA==}\n    peerDependencies:\n      history: ^4.7.2\n      react: ^16.4.0\n      react-redux: ^6.0.0 || ^7.1.0\n      react-router: ^4.3.1 || ^5.0.0\n      redux: ^3.6.0 || ^4.0.0\n\n  console-browserify@1.2.0:\n    resolution: {integrity: sha512-ZMkYO/LkF17QvCPqM0gxw8yUzigAOZOSWSHg91FH6orS7vcEj5dVZTidN2fQ14yBSdg97RqhSNwLUXInd52OTA==}\n\n  constants-browserify@1.0.0:\n    resolution: {integrity: sha512-xFxOwqIzR/e1k1gLiWEophSCMqXcwVHIH7akf7b/vxcUeGunlj3hvZaaqxwHsTgn+IndtkQJgSztIDWeumWJDQ==}\n\n  convert-source-map@1.9.0:\n    resolution: {integrity: sha512-ASFBup0Mz1uyiIjANan1jzLQami9z1PoYSZCiiYW2FczPbenXc45FZdBZLzOT+r6+iciuEModtmCti+hjaAk0A==}\n\n  copy-descriptor@0.1.1:\n    resolution: {integrity: sha512-XgZ0pFcakEUlbwQEVNg3+QAis1FyTL3Qel9FYy8pSkQqoG3PNoT0bOCQtOXcOkur21r2Eq2kI+IE+gsmAEVlYw==}\n    engines: {node: '>=0.10.0'}\n\n  copy-to-clipboard@3.3.3:\n    resolution: {integrity: sha512-2KV8NhB5JqC3ky0r9PMCAZKbUHSwtEo4CwCs0KXgruG43gX5PMqDEBbVU4OUzw2MuAWUfsuFmWvEKG5QRfSnJA==}\n\n  core-js-pure@3.39.0:\n    resolution: {integrity: sha512-7fEcWwKI4rJinnK+wLTezeg2smbFFdSBP6E2kQZNbnzM2s1rpKQ6aaRteZSSg7FLU3P0HGGVo/gbpfanU36urg==}\n\n  core-js@1.2.7:\n    resolution: {integrity: sha512-ZiPp9pZlgxpWRu0M+YWbm6+aQ84XEfH1JRXvfOc/fILWI0VKhLC2LX13X1NYq4fULzLMq7Hfh43CSo2/aIaUPA==}\n    deprecated: core-js@<3.23.3 is no longer maintained and not recommended for usage due to the number of issues. Because of the V8 engine whims, feature detection in old core-js versions could cause a slowdown up to 100x even if nothing is polyfilled. Some versions have web compatibility issues. Please, upgrade your dependencies to the actual version of core-js.\n\n  core-js@2.6.12:\n    resolution: {integrity: sha512-Kb2wC0fvsWfQrgk8HU5lW6U/Lcs8+9aaYcy4ZFc6DDlo4nZ7n70dEgE5rtR0oG6ufKDUnrwfWL1mXR5ljDatrQ==}\n    deprecated: core-js@<3.23.3 is no longer maintained and not recommended for usage due to the number of issues. Because of the V8 engine whims, feature detection in old core-js versions could cause a slowdown up to 100x even if nothing is polyfilled. Some versions have web compatibility issues. Please, upgrade your dependencies to the actual version of core-js.\n\n  core-js@3.6.5:\n    resolution: {integrity: sha512-vZVEEwZoIsI+vPEuoF9Iqf5H7/M3eeQqWlQnYa8FSKKePuYTf5MWnxb5SDAzCa60b3JBRS5g9b+Dq7b1y/RCrA==}\n    deprecated: core-js@<3.23.3 is no longer maintained and not recommended for usage due to the number of issues. Because of the V8 engine whims, feature detection in old core-js versions could cause a slowdown up to 100x even if nothing is polyfilled. Some versions have web compatibility issues. Please, upgrade your dependencies to the actual version of core-js.\n\n  core-js@3.8.2:\n    resolution: {integrity: sha512-FfApuSRgrR6G5s58casCBd9M2k+4ikuu4wbW6pJyYU7bd9zvFc9qf7vr5xmrZOhT9nn+8uwlH1oRR9jTnFoA3A==}\n    deprecated: core-js@<3.23.3 is no longer maintained and not recommended for usage due to the number of issues. Because of the V8 engine whims, feature detection in old core-js versions could cause a slowdown up to 100x even if nothing is polyfilled. Some versions have web compatibility issues. Please, upgrade your dependencies to the actual version of core-js.\n\n  core-util-is@1.0.3:\n    resolution: {integrity: sha512-ZQBvi1DcpJ4GDqanjucZ2Hj3wEO5pZDS89BWbkcrvdxksJorwUDDZamX9ldFkp9aw2lmBDLgkObEA4DWNJ9FYQ==}\n\n  cosmiconfig@5.2.1:\n    resolution: {integrity: sha512-H65gsXo1SKjf8zmrJ67eJk8aIRKV5ff2D4uKZIBZShbhGSpEmsQOPW/SKMKYhSTrqR7ufy6RP69rPogdaPh/kA==}\n    engines: {node: '>=4'}\n\n  cosmiconfig@7.1.0:\n    resolution: {integrity: sha512-AdmX6xUzdNASswsFtmwSt7Vj8po9IuqXm0UXz7QKPuEUmPB4XyjGfaAr2PSuELMwkRMVH1EpIkX5bTZGRB3eCA==}\n    engines: {node: '>=10'}\n\n  create-ecdh@4.0.4:\n    resolution: {integrity: sha512-mf+TCx8wWc9VpuxfP2ht0iSISLZnt0JgWlrOKZiNqyUZWnjIaCIVNQArMHnCZKfEYRg6IM7A+NeJoN8gf/Ws0A==}\n\n  create-hash@1.2.0:\n    resolution: {integrity: sha512-z00bCGNHDG8mHAkP7CtT1qVu+bFQUPjYq/4Iv3C3kWjTFV10zIjfSoeqXo9Asws8gwSHDGj/hl2u4OGIjapeCg==}\n\n  create-hmac@1.1.7:\n    resolution: {integrity: sha512-MJG9liiZ+ogc4TzUwuvbER1JRdgvUFSB5+VR/g5h82fGaIRWMWddtKBHi7/sVhfjQZ6SehlyhvQYrcYkaUIpLg==}\n\n  create-react-class@15.7.0:\n    resolution: {integrity: sha512-QZv4sFWG9S5RUvkTYWbflxeZX+JG7Cz0Tn33rQBJ+WFQTqTfUTjMjiv9tnfXazjsO5r0KhPs+AqCjyrQX6h2ng==}\n\n  cross-spawn@5.1.0:\n    resolution: {integrity: sha512-pTgQJ5KC0d2hcY8eyL1IzlBPYjTkyH72XRZPnLyKus2mBfNjQs3klqbJU2VILqZryAZUt9JOb3h/mWMy23/f5A==}\n\n  cross-spawn@6.0.6:\n    resolution: {integrity: sha512-VqCUuhcd1iB+dsv8gxPttb5iZh/D0iubSP21g36KXdEuf6I5JiioesUVjpCdHV9MZRUfVFlvwtIUyPfxo5trtw==}\n    engines: {node: '>=4.8'}\n\n  cross-spawn@7.0.6:\n    resolution: {integrity: sha512-uV2QOWP2nWzsy2aMp8aRibhi9dlzF5Hgh5SHaB9OiTGEyDTiJJyx0uy51QXdyWbtAHNua4XJzUKca3OzKUd3vA==}\n    engines: {node: '>= 8'}\n\n  crypto-browserify@3.12.1:\n    resolution: {integrity: sha512-r4ESw/IlusD17lgQi1O20Fa3qNnsckR126TdUuBgAu7GBYSIPvdNyONd3Zrxh0xCwA4+6w/TDArBPsMvhur+KQ==}\n    engines: {node: '>= 0.10'}\n\n  css-animation@1.6.1:\n    resolution: {integrity: sha512-/48+/BaEaHRY6kNQ2OIPzKf9A6g8WjZYjhiNDNuIVbsm5tXCGIAsHDjB4Xu1C4vXJtUWZo26O68OQkDpNBaPog==}\n\n  css-blank-pseudo@0.1.4:\n    resolution: {integrity: sha512-LHz35Hr83dnFeipc7oqFDmsjHdljj3TQtxGGiNWSOsTLIAubSm4TEz8qCaKFpk7idaQ1GfWscF4E6mgpBysA1w==}\n    engines: {node: '>=6.0.0'}\n    hasBin: true\n\n  css-has-pseudo@0.10.0:\n    resolution: {integrity: sha512-Z8hnfsZu4o/kt+AuFzeGpLVhFOGO9mluyHBaA2bA8aCGTwah5sT3WV/fTHH8UNZUytOIImuGPrl/prlb4oX4qQ==}\n    engines: {node: '>=6.0.0'}\n    hasBin: true\n\n  css-prefers-color-scheme@3.1.1:\n    resolution: {integrity: sha512-MTu6+tMs9S3EUqzmqLXEcgNRbNkkD/TGFvowpeoWJn5Vfq7FMgsmRQs9X5NXAURiOBmOxm/lLjsDNXDE6k9bhg==}\n    engines: {node: '>=6.0.0'}\n    hasBin: true\n\n  cssdb@4.4.0:\n    resolution: {integrity: sha512-LsTAR1JPEM9TpGhl/0p3nQecC2LJ0kD8X5YARu1hk/9I1gril5vDtMZyNxcEpxxDj34YNck/ucjuoUd66K03oQ==}\n\n  cssesc@2.0.0:\n    resolution: {integrity: sha512-MsCAG1z9lPdoO/IUMLSBWBSVxVtJ1395VGIQ+Fc2gNdkQ1hNDnQdw3YhA71WJCBW1vdwA0cAnk/DnW6bqoEUYg==}\n    engines: {node: '>=4'}\n    hasBin: true\n\n  cssesc@3.0.0:\n    resolution: {integrity: sha512-/Tb/JcjK111nNScGob5MNtsntNM1aCNUDipB/TkwZFhyDrrE47SOx/18wF2bbjgc3ZzCSKW1T5nt5EbFoAz/Vg==}\n    engines: {node: '>=4'}\n    hasBin: true\n\n  cssom@0.3.8:\n    resolution: {integrity: sha512-b0tGHbfegbhPJpxpiBPU2sCkigAqtM9O121le6bbOlgyV+NyGyCmVfJ6QW9eRjz8CpNfWEOYBIMIGRYkLwsIYg==}\n\n  cssom@0.4.4:\n    resolution: {integrity: sha512-p3pvU7r1MyyqbTk+WbNJIgJjG2VmTIaB10rI93LzVPrmDJKkzKYMtxxyAvQXR/NS6otuzveI7+7BBq3SjBS2mw==}\n\n  cssstyle@2.3.0:\n    resolution: {integrity: sha512-AZL67abkUzIuvcHqk7c09cezpGNcxUxU4Ioi/05xHk4DQeTkWmGYftIE6ctU6AEt+Gn4n1lDStOtj7FKycP71A==}\n    engines: {node: '>=8'}\n\n  csstype@3.1.3:\n    resolution: {integrity: sha512-M1uQkMl8rQK/szD0LNhtqxIPLpimGm8sOBwU7lLnCpSbTyY3yeU1Vc7l4KT5zT4s/yOxHH5O7tIuuLOCnLADRw==}\n\n  data-urls@2.0.0:\n    resolution: {integrity: sha512-X5eWTSXO/BJmpdIKCRuKUgSCgAN0OwliVK3yPKbwIWU1Tdw5BRajxlzMidvh+gwko9AfQ9zIj52pzF91Q3YAvQ==}\n    engines: {node: '>=10'}\n\n  date-fns@2.30.0:\n    resolution: {integrity: sha512-fnULvOpxnC5/Vg3NCiWelDsLiUc9bRwAPs/+LfTLNvetFCtCTN+yQz15C/fs4AwX1R9K5GLtLfn8QW+dWisaAw==}\n    engines: {node: '>=0.11'}\n\n  dayjs@1.11.13:\n    resolution: {integrity: sha512-oaMBel6gjolK862uaPQOVTA7q3TZhuSvuMQAAglQDOWYO9A91IrAOUJEyKVlqJlHE0vq5p5UXxzdPfMH/x6xNg==}\n\n  debug@2.6.9:\n    resolution: {integrity: sha512-bC7ElrdJaJnPbAP+1EotYvqZsb3ecl5wi6Bfi6BJTUcNowp6cvspg0jXznRTKDjm/E7AdgFBVeAPVMNcKGsHMA==}\n    peerDependencies:\n      supports-color: '*'\n    peerDependenciesMeta:\n      supports-color:\n        optional: true\n\n  debug@4.4.0:\n    resolution: {integrity: sha512-6WTZ/IxCY/T6BALoZHaE4ctp9xm+Z5kY/pzYaCHRFeyVhojxlrm+46y68HA6hr0TcwEssoxNiDEUJQjfPZ/RYA==}\n    engines: {node: '>=6.0'}\n    peerDependencies:\n      supports-color: '*'\n    peerDependenciesMeta:\n      supports-color:\n        optional: true\n\n  decamelize@1.2.0:\n    resolution: {integrity: sha512-z2S+W9X73hAUUki+N+9Za2lBlun89zigOyGrsax+KUQ6wKW4ZoWpEYBkGhQjwAjjDCkWxhY0VKEhk8wzY7F5cA==}\n    engines: {node: '>=0.10.0'}\n\n  decimal.js@10.4.3:\n    resolution: {integrity: sha512-VBBaLc1MgL5XpzgIP7ny5Z6Nx3UrRkIViUkPUdtl9aya5amy3De1gsUUSB1g3+3sExYNjCAsAznmukyxCb1GRA==}\n\n  decode-uri-component@0.2.2:\n    resolution: {integrity: sha512-FqUYQ+8o158GyGTrMFJms9qh3CqTKvAqgqsTnkLI8sKu0028orqBhxNMFkFen0zGyg6epACD32pjVk58ngIErQ==}\n    engines: {node: '>=0.10'}\n\n  dedent@0.7.0:\n    resolution: {integrity: sha512-Q6fKUPqnAHAyhiUgFU7BUzLiv0kd8saH9al7tnu5Q/okj6dnupxyTgFIBjVzJATdfIAm9NAsvXNzjaKa+bxVyA==}\n\n  deepmerge@1.5.2:\n    resolution: {integrity: sha512-95k0GDqvBjZavkuvzx/YqVLv/6YYa17fz6ILMSf7neqQITCPbnfEnQvEgMPNjH4kgobe7+WIL0yJEHku+H3qtQ==}\n    engines: {node: '>=0.10.0'}\n\n  deepmerge@4.3.1:\n    resolution: {integrity: sha512-3sUqbMEc77XqpdNO7FRyRog+eW3ph+GYCbj+rK+uYyRMuwsVy0rMiVtPn+QJlKFvWP/1PYpapqYn0Me2knFn+A==}\n    engines: {node: '>=0.10.0'}\n\n  define-data-property@1.1.4:\n    resolution: {integrity: sha512-rBMvIzlpA8v6E+SJZoo++HAYqsLrkg7MSfIinMPFhmkorw7X+dOXVJQs+QT69zGkzMyfDnIMN2Wid1+NbL3T+A==}\n    engines: {node: '>= 0.4'}\n\n  define-properties@1.2.1:\n    resolution: {integrity: sha512-8QmQKqEASLd5nx0U1B1okLElbUuuttJ/AnYmRXbbbGDWh6uS208EjD4Xqq/I9wK7u0v6O08XhTWnt5XtEbR6Dg==}\n    engines: {node: '>= 0.4'}\n\n  define-property@0.2.5:\n    resolution: {integrity: sha512-Rr7ADjQZenceVOAKop6ALkkRAmH1A4Gx9hV/7ZujPUN2rkATqFO0JZLZInbAjpZYoJ1gUx8MRMQVkYemcbMSTA==}\n    engines: {node: '>=0.10.0'}\n\n  define-property@1.0.0:\n    resolution: {integrity: sha512-cZTYKFWspt9jZsMscWo8sc/5lbPC9Q0N5nBLgb+Yd915iL3udB1uFgS3B8YCx66UVHq018DAVFoee7x+gxggeA==}\n    engines: {node: '>=0.10.0'}\n\n  define-property@2.0.2:\n    resolution: {integrity: sha512-jwK2UV4cnPpbcG7+VRARKTZPUWowwXA8bzH5NP6ud0oeAxyYPuGZUAC7hMugpCdz4BeSZl2Dl9k66CHJ/46ZYQ==}\n    engines: {node: '>=0.10.0'}\n\n  delayed-stream@1.0.0:\n    resolution: {integrity: sha512-ZySD7Nf91aLB0RxL4KGrKHBXl7Eds1DAmEdcoVawXnLD7SDhpNgtuII2aAkg7a7QS41jxPSZ17p4VdGnMHk3MQ==}\n    engines: {node: '>=0.4.0'}\n\n  des.js@1.1.0:\n    resolution: {integrity: sha512-r17GxjhUCjSRy8aiJpr8/UadFIzMzJGexI3Nmz4ADi9LYSFx4gTBp80+NaX/YsXWWLhpZ7v/v/ubEc/bCNfKwg==}\n\n  detect-newline@3.1.0:\n    resolution: {integrity: sha512-TLz+x/vEXm/Y7P7wn1EJFNLxYpUD4TgMosxY6fAVJUnJMbupHBOncxyWUG9OpTaH9EBD7uFI5LfEgmMOc54DsA==}\n    engines: {node: '>=8'}\n\n  diff-sequences@26.6.2:\n    resolution: {integrity: sha512-Mv/TDa3nZ9sbc5soK+OoA74BsS3mL37yixCvUAQkiuA4Wz6YtwP/K47n2rv2ovzHZvoiQeA5FTQOschKkEwB0Q==}\n    engines: {node: '>= 10.14.2'}\n\n  diffie-hellman@5.0.3:\n    resolution: {integrity: sha512-kqag/Nl+f3GwyK25fhUMYj81BUOrZ9IuJsjIcDE5icNM9FJHAVm3VcUDxdLPoQtTuUylWm6ZIknYJwwaPxsUzg==}\n\n  dom-align@1.12.4:\n    resolution: {integrity: sha512-R8LUSEay/68zE5c8/3BDxiTEvgb4xZTF0RKmAHfiEVN3klfIpXfi2/QCoiWPccVQ0J/ZGdz9OjzL4uJEP/MRAw==}\n\n  dom-walk@0.1.2:\n    resolution: {integrity: sha512-6QvTW9mrGeIegrFXdtQi9pk7O/nSK6lSdXW2eqUspN5LWD7UTji2Fqw5V2YLjBpHEoU9Xl/eUWNpDeZvoyOv2w==}\n\n  domain-browser@1.2.0:\n    resolution: {integrity: sha512-jnjyiM6eRyZl2H+W8Q/zLMA481hzi0eszAaBUzIVnmYVDBbnLxVNnfu1HgEBvCbL+71FrxMl3E6lpKH7Ge3OXA==}\n    engines: {node: '>=0.4', npm: '>=1.2'}\n\n  domexception@2.0.1:\n    resolution: {integrity: sha512-yxJ2mFy/sibVQlu5qHjOkf9J3K6zgmCxgJ94u2EdvDOV09H+32LtRswEcUsmUWN72pVLOEnTSRaIVVzVQgS0dg==}\n    engines: {node: '>=8'}\n    deprecated: Use your platform's native DOMException instead\n\n  dunder-proto@1.0.0:\n    resolution: {integrity: sha512-9+Sj30DIu+4KvHqMfLUGLFYL2PkURSYMVXJyXe92nFRvlYq5hBjLEhblKB+vkd/WVlUYMWigiY07T91Fkk0+4A==}\n    engines: {node: '>= 0.4'}\n\n  dva-core@2.0.4:\n    resolution: {integrity: sha512-Zh39llFyItu9HKXKfCZVf9UFtDTcypdAjGBew1S+wK8BGVzFpm1GPTdd6uIMeg7O6STtCvt2Qv+RwUut1GFynA==}\n    peerDependencies:\n      redux: 4.x\n\n  dva-immer@0.5.2:\n    resolution: {integrity: sha512-xg23ktGsrdzgiU0ACl8vFm2+E2GBWbtXndXRKM9wtHDR+yMH27NfttVuAZQWvv4aaj6f5/bC+TdsZ9t7n6cAhQ==}\n    peerDependencies:\n      dva: ^2.5.0-0\n\n  dva-loading@3.0.25:\n    resolution: {integrity: sha512-RYbpSjvPj2NF+3YSc9QkDpwM1wO8uRAVfU6VGSgIxA2kA/Xd6yoY+VQM7GDRnvCvT579pESeBZBXk+8WKWOdDA==}\n    peerDependencies:\n      dva-core: ^1.1.0 || ^1.5.0-0 || ^1.6.0-0\n\n  dva@2.6.0-beta.23:\n    resolution: {integrity: sha512-noeOz3Erxpc6YLEsyyS//zGszeRYWKEvZoeCZ0LaCvWrV7Cxah9Xt/I9V1SS9eYDySaSgTUOoU+dLweQpCScAA==}\n    peerDependencies:\n      react: ^16.8.4\n      react-dom: ^16.8.4\n\n  electron-to-chromium@1.5.73:\n    resolution: {integrity: sha512-8wGNxG9tAG5KhGd3eeA0o6ixhiNdgr0DcHWm85XPCphwZgD1lIEoi6t3VERayWao7SF7AAZTw6oARGJeVjH8Kg==}\n\n  elliptic@6.6.1:\n    resolution: {integrity: sha512-RaddvvMatK2LJHqFJ+YA4WysVN5Ita9E35botqIYspQ4TkRAlCicdzKOjlyv/1Za5RyTNn7di//eEV0uTAfe3g==}\n\n  emittery@0.7.2:\n    resolution: {integrity: sha512-A8OG5SR/ij3SsJdWDJdkkSYUjQdCUx6APQXem0SaEePBSRg4eymGYwBkKo1Y6DU+af/Jn2dBQqDBvjnr9Vi8nQ==}\n    engines: {node: '>=10'}\n\n  emoji-regex@8.0.0:\n    resolution: {integrity: sha512-MSjYzcWNOA0ewAHpz0MxpYFvwg6yjy1NG3xteoqz644VCo/RPgnr1/GGt+ic3iJTzQ8Eu3TdM14SawnVUmGE6A==}\n\n  emojis-list@3.0.0:\n    resolution: {integrity: sha512-/kyM18EfinwXZbno9FyUGeFh87KC8HRQBQGildHZbEuRyWFOmv1U10o9BBp8XVZDVNNuQKyIGIu5ZYAAXJ0V2Q==}\n    engines: {node: '>= 4'}\n\n  encoding@0.1.13:\n    resolution: {integrity: sha512-ETBauow1T35Y/WZMkio9jiM0Z5xjHHmJ4XmjZOq1l/dXz3lr2sRn87nJy20RupqSh1F2m3HHPSp8ShIPQJrJ3A==}\n\n  end-of-stream@1.4.4:\n    resolution: {integrity: sha512-+uw1inIHVPQoaVuHzRyXd21icM+cnt4CzD5rW+NC1wjOUSTOs+Te7FOv7AhN7vS9x/oIyhLP5PR1H+phQAHu5Q==}\n\n  enquirer@2.4.1:\n    resolution: {integrity: sha512-rRqJg/6gd538VHvR3PSrdRBb/1Vy2YfzHqzvbhGIQpDRKIa4FgV/54b5Q1xYSxOOwKvjXweS26E0Q+nAMwp2pQ==}\n    engines: {node: '>=8.6'}\n\n  error-ex@1.3.2:\n    resolution: {integrity: sha512-7dFHNmqeFSEt2ZBsCriorKnn3Z2pj+fd9kmI6QoWw4//DL+icEBfc0U7qJCisqrTsKTjw4fNFy2pW9OqStD84g==}\n\n  error-stack-parser@1.3.6:\n    resolution: {integrity: sha512-xhuSYd8wLgOXwNgjcPeXMPL/IiiA1Huck+OPvClpJViVNNlJVtM41o+1emp7bPvlCJwCatFX2DWc05/DgfbWzA==}\n\n  error-stack-parser@2.1.4:\n    resolution: {integrity: sha512-Sk5V6wVazPhq5MhpO+AUxJn5x7XSXGl1R93Vn7i+zS15KDVxQijejNCrz8340/2bgLBjR9GtEG8ZVKONDjcqGQ==}\n\n  es-define-property@1.0.1:\n    resolution: {integrity: sha512-e3nRfgfUZ4rNGL232gUgX06QNyyez04KdjFrF+LTRoOXmrOgFKDg4BCdsjW8EnT69eqdYGmRpJwiPVYNrCaW3g==}\n    engines: {node: '>= 0.4'}\n\n  es-errors@1.3.0:\n    resolution: {integrity: sha512-Zf5H2Kxt2xjTvbJvP2ZWLEICxA6j+hAmMzIlypy4xcBg1vKVnx89Wy0GbS+kf5cwCVFFzdCFh2XSCFNULS6csw==}\n    engines: {node: '>= 0.4'}\n\n  es-module-lexer@0.7.1:\n    resolution: {integrity: sha512-MgtWFl5No+4S3TmhDmCz2ObFGm6lEpTnzbQi+Dd+pw4mlTIZTmM2iAs5gRlmx5zS9luzobCSBSI90JM/1/JgOw==}\n\n  es-object-atoms@1.0.0:\n    resolution: {integrity: sha512-MZ4iQ6JwHOBQjahnjwaC1ZtIBH+2ohjamzAO3oaHcXYup7qxjF2fixyH+Q71voWHeOkI2q/TnJao/KfXYIZWbw==}\n    engines: {node: '>= 0.4'}\n\n  es5-imcompatible-versions@0.1.90:\n    resolution: {integrity: sha512-2MPI0t/VV4j/oz1qbMekb4gCW81dewTpM2XJHKnPpZiPGu+1rVWmhTnwcq1vt8AFwWrkNF4RE7OZ9ibnKFYKwg==}\n\n  esbuild@0.12.15:\n    resolution: {integrity: sha512-72V4JNd2+48eOVCXx49xoSWHgC3/cCy96e7mbXKY+WOWghN00cCmlGnwVLRhRHorvv0dgCyuMYBZlM2xDM5OQw==}\n    hasBin: true\n\n  escalade@3.2.0:\n    resolution: {integrity: sha512-WUj2qlxaQtO4g6Pq5c29GTcWGDyd8itL8zTlipgECz3JesAiiOKotd8JU6otB3PACgG6xkJUyVhboMS+bje/jA==}\n    engines: {node: '>=6'}\n\n  escape-string-regexp@1.0.5:\n    resolution: {integrity: sha512-vbRorB5FUQWvla16U8R/qgaFIya2qGzwDrNmCZuYKrbdSUMG6I1ZCGQRefkRVhuOkIGVne7BQ35DSfo1qvJqFg==}\n    engines: {node: '>=0.8.0'}\n\n  escape-string-regexp@2.0.0:\n    resolution: {integrity: sha512-UpzcLCXolUWcNu5HtVMHYdXJjArjsF9C0aNnquZYY4uW/Vu0miy5YoWvbV345HauVvcAUnpRuhMMcqTcGOY2+w==}\n    engines: {node: '>=8'}\n\n  escodegen@2.1.0:\n    resolution: {integrity: sha512-2NlIDTwUWJN0mRPQOdtQBzbUHvdGY2P1VXSyU83Q3xKxM7WHX2Ql8dKq782Q9TgQUNOLEzEYu9bzLNj1q88I5w==}\n    engines: {node: '>=6.0'}\n    hasBin: true\n\n  esprima@4.0.1:\n    resolution: {integrity: sha512-eGuFFw7Upda+g4p+QHvnW0RyTX/SVeJBDM/gCtMARO0cLuT2HcEKnTPvhjV6aGeqrCB/sbNop0Kszm0jsaWU4A==}\n    engines: {node: '>=4'}\n    hasBin: true\n\n  estraverse@5.3.0:\n    resolution: {integrity: sha512-MMdARuVEQziNTeJD8DgMqmhwR11BRQ/cBP+pLtYdSTnf3MIO8fFeiINEbX36ZdNlfU/7A9f3gUw49B3oQsvwBA==}\n    engines: {node: '>=4.0'}\n\n  esutils@2.0.3:\n    resolution: {integrity: sha512-kVscqXk4OCp68SZ0dkgEKVi6/8ij300KBWTJq32P/dYeWTSwK41WyTxalN1eRmA5Z9UU/LX9D7FWSmV9SAYx6g==}\n    engines: {node: '>=0.10.0'}\n\n  events@3.3.0:\n    resolution: {integrity: sha512-mQw+2fkQbALzQ7V0MY0IqdnXNOeTtP4r0lN9z7AAawCXgqea7bDii20AYrIBrFd/Hx0M2Ocz6S111CaFkUcb0Q==}\n    engines: {node: '>=0.8.x'}\n\n  evp_bytestokey@1.0.3:\n    resolution: {integrity: sha512-/f2Go4TognH/KvCISP7OUsHn85hT9nUkxxA9BEWxFn+Oj9o8ZNLm/40hdlgSLyuOimsrTKLUMEorQexp/aPQeA==}\n\n  exec-sh@0.3.6:\n    resolution: {integrity: sha512-nQn+hI3yp+oD0huYhKwvYI32+JFeq+XkNcD1GAo3Y/MjxsfVGmrrzrnzjWiNY6f+pUCP440fThsFh5gZrRAU/w==}\n\n  execa@0.8.0:\n    resolution: {integrity: sha512-zDWS+Rb1E8BlqqhALSt9kUhss8Qq4nN3iof3gsOdyINksElaPyNBtKUMTR62qhvgVWR0CqCX7sdnKe4MnUbFEA==}\n    engines: {node: '>=4'}\n\n  execa@1.0.0:\n    resolution: {integrity: sha512-adbxcyWV46qiHyvSp50TKt05tB4tK3HcmF7/nxfAdhnox83seTDbwnaqKO4sXRy7roHAIFqJP/Rw/AuEbX61LA==}\n    engines: {node: '>=6'}\n\n  execa@4.1.0:\n    resolution: {integrity: sha512-j5W0//W7f8UxAn8hXVnwG8tLwdiUy4FJLcSupCg6maBYZDpyBvTApK7KyuI4bKj8KOh1r2YH+6ucuYtJv1bTZA==}\n    engines: {node: '>=10'}\n\n  exenv@1.2.2:\n    resolution: {integrity: sha512-Z+ktTxTwv9ILfgKCk32OX3n/doe+OcLTRtqK9pcL+JsP3J1/VW8Uvl4ZjLlKqeW4rzK4oesDOGMEMRIZqtP4Iw==}\n\n  exit@0.1.2:\n    resolution: {integrity: sha512-Zk/eNKV2zbjpKzrsQ+n1G6poVbErQxJ0LBOJXaKZ1EViLzH+hrLu9cdXI4zw9dBQJslwBEpbQ2P1oS7nDxs6jQ==}\n    engines: {node: '>= 0.8.0'}\n\n  expand-brackets@2.1.4:\n    resolution: {integrity: sha512-w/ozOKR9Obk3qoWeY/WDi6MFta9AoMR+zud60mdnbniMcBxRuFJyDt2LdX/14A1UABeqk+Uk+LDfUpvoGKppZA==}\n    engines: {node: '>=0.10.0'}\n\n  expect@26.6.2:\n    resolution: {integrity: sha512-9/hlOBkQl2l/PLHJx6JjoDF6xPKcJEsUlWKb23rKE7KzeDqUZKXKNMW27KIue5JMdBV9HgmoJPcc8HtO85t9IA==}\n    engines: {node: '>= 10.14.2'}\n\n  extend-shallow@2.0.1:\n    resolution: {integrity: sha512-zCnTtlxNoAiDc3gqY2aYAWFx7XWWiasuF2K8Me5WbN8otHKTUKBwjPtNpRs/rbUZm7KxWAaNj7P1a/p52GbVug==}\n    engines: {node: '>=0.10.0'}\n\n  extend-shallow@3.0.2:\n    resolution: {integrity: sha512-BwY5b5Ql4+qZoefgMj2NUmx+tehVTH/Kf4k1ZEtOHNFcm2wSxMRo992l6X3TIgni2eZVTZ85xMOjF31fwZAj6Q==}\n    engines: {node: '>=0.10.0'}\n\n  extglob@2.0.4:\n    resolution: {integrity: sha512-Nmb6QXkELsuBr24CJSkilo6UHHgbekK5UiZgfE6UHD3Eb27YC6oD+bhcT+tJ6cl8dmsgdQxnWlcry8ksBIBLpw==}\n    engines: {node: '>=0.10.0'}\n\n  fast-deep-equal@3.1.1:\n    resolution: {integrity: sha512-8UEa58QDLauDNfpbrX55Q9jrGHThw2ZMdOky5Gl1CDtVeJDPVrG4Jxx1N8jw2gkWaff5UUuX1KJd+9zGe2B+ZA==}\n\n  fast-deep-equal@3.1.3:\n    resolution: {integrity: sha512-f3qQ9oQy9j2AhBe/H9VC91wLmKBCCU/gDOnKNAYG5hswO7BLKj09Hc5HYNz9cGI++xlpDCIgDaitVs03ATR84Q==}\n\n  fast-json-stable-stringify@2.1.0:\n    resolution: {integrity: sha512-lhd/wF+Lk98HZoTCtlVraHtfh5XYijIjalXck7saUtuanSDyLMxnHhSXEDJqHxD7msR8D0uCmqlkwjCV8xvwHw==}\n\n  fb-watchman@2.0.2:\n    resolution: {integrity: sha512-p5161BqbuCaSnB8jIbzQHOlpgsPmK5rJVDfDKO91Axs5NC1uu3HRQm6wt9cd9/+GtQQIO53JdGXXoyDpTAsgYA==}\n\n  fbjs@0.8.18:\n    resolution: {integrity: sha512-EQaWFK+fEPSoibjNy8IxUtaFOMXcWsY0JaVrQoZR9zC8N2Ygf9iDITPWjUTVIax95b6I742JFLqASHfsag/vKA==}\n\n  fill-range@4.0.0:\n    resolution: {integrity: sha512-VcpLTWqWDiTerugjj8e3+esbg+skS3M9e54UuR3iCeIDMXCLTsAH8hTSzDQU/X6/6t3eYkOKoZSef2PlU6U1XQ==}\n    engines: {node: '>=0.10.0'}\n\n  fill-range@7.1.1:\n    resolution: {integrity: sha512-YsGpe3WHLK8ZYi4tWDg2Jy3ebRz2rXowDxnld4bkQB00cc/1Zw9AWnC0i9ztDJitivtQvaI9KaLyKrc+hBW0yg==}\n    engines: {node: '>=8'}\n\n  filter-obj@1.1.0:\n    resolution: {integrity: sha512-8rXg1ZnX7xzy2NGDVkBVaAy+lSlPNwad13BtgSlLuxfIslyt5Vg64U7tFcCt4WS1R0hvtnQybT/IyCkGZ3DpXQ==}\n    engines: {node: '>=0.10.0'}\n\n  find-up@4.1.0:\n    resolution: {integrity: sha512-PpOwAdQ/YlXQ2vj8a3h8IipDuYRi3wceVQQGYWxNINccq40Anw7BlsEXCMbt1Zt+OLA6Fq9suIpIWD0OsnISlw==}\n    engines: {node: '>=8'}\n\n  flatten@1.0.3:\n    resolution: {integrity: sha512-dVsPA/UwQ8+2uoFe5GHtiBMu48dWLTdsuEd7CKGlZlD78r1TTWBvDuFaFGKCo/ZfEr95Uk56vZoX86OsHkUeIg==}\n    deprecated: flatten is deprecated in favor of utility frameworks such as lodash.\n\n  for-in@1.0.2:\n    resolution: {integrity: sha512-7EwmXrOjyL+ChxMhmG5lnW9MPt1aIeZEwKhQzoBUdTV0N3zuwWDZYVJatDvZ2OyzPUvdIAZDsCetk3coyMfcnQ==}\n    engines: {node: '>=0.10.0'}\n\n  form-data@3.0.2:\n    resolution: {integrity: sha512-sJe+TQb2vIaIyO783qN6BlMYWMw3WBOHA1Ay2qxsnjuafEOQFJ2JakedOQirT6D5XPRxDvS7AHYyem9fTpb4LQ==}\n    engines: {node: '>= 6'}\n\n  fragment-cache@0.2.1:\n    resolution: {integrity: sha512-GMBAbW9antB8iZRHLoGw0b3HANt57diZYFO/HL1JGIC1MjKrdmhxvrJbupnVvpys0zsz7yBApXdQyfepKly2kA==}\n    engines: {node: '>=0.10.0'}\n\n  fs.realpath@1.0.0:\n    resolution: {integrity: sha512-OO0pH2lK6a0hZnAdau5ItzHPI6pUlvI7jMVnxUQRtw4owF2wk8lOSabtGDCTP4Ggrg2MbGnWO9X8K1t4+fGMDw==}\n\n  fsevents@2.3.3:\n    resolution: {integrity: sha512-5xoDfX+fL7faATnagmWPpbFtwh/R77WmMMqqHGS65C3vvB0YHrgF+B1YmZ3441tMj5n63k0212XNoJwzlhffQw==}\n    engines: {node: ^8.16.0 || ^10.6.0 || >=11.0.0}\n    os: [darwin]\n\n  function-bind@1.1.2:\n    resolution: {integrity: sha512-7XHNxH7qX9xG5mIwxkhumTox/MIRNcOgDrxWsMt2pAr23WHp6MrRlN7FBSFpCpr+oVO0F744iUgR82nJMfG2SA==}\n\n  gensync@1.0.0-beta.2:\n    resolution: {integrity: sha512-3hN7NaskYvMDLQY55gnW3NQ+mesEAepTqlg+VEbj7zzqEMBVNhzcGYYeqFo/TlYz6eQiFcp1HcsCZO+nGgS8zg==}\n    engines: {node: '>=6.9.0'}\n\n  get-caller-file@2.0.5:\n    resolution: {integrity: sha512-DyFP3BM/3YHTQOCUL/w0OZHR0lpKeGrxotcHWcqNEdnltqFwXVfhEBQ94eIo34AfQpo0rGki4cyIiftY06h2Fg==}\n    engines: {node: 6.* || 8.* || >= 10.*}\n\n  get-intrinsic@1.2.6:\n    resolution: {integrity: sha512-qxsEs+9A+u85HhllWJJFicJfPDhRmjzoYdl64aMWW9yRIJmSyxdn8IEkuIM530/7T+lv0TIHd8L6Q/ra0tEoeA==}\n    engines: {node: '>= 0.4'}\n\n  get-own-enumerable-property-symbols@3.0.2:\n    resolution: {integrity: sha512-I0UBV/XOz1XkIJHEUDMZAbzCThU/H8DxmSfmdGcKPnVhu2VfFqr34jr9777IyaTYvxjedWhqVIilEDsCdP5G6g==}\n\n  get-package-type@0.1.0:\n    resolution: {integrity: sha512-pjzuKtY64GYfWizNAJ0fr9VqttZkNiK2iS430LtIHzjBEr6bX8Am2zm4sW4Ro5wjWW5cAlRL1qAMTcXbjNAO2Q==}\n    engines: {node: '>=8.0.0'}\n\n  get-stream@3.0.0:\n    resolution: {integrity: sha512-GlhdIUuVakc8SJ6kK0zAFbiGzRFzNnY4jUuEbV9UROo4Y+0Ny4fjvcZFVTeDA4odpFyOQzaw6hXukJSq/f28sQ==}\n    engines: {node: '>=4'}\n\n  get-stream@4.1.0:\n    resolution: {integrity: sha512-GMat4EJ5161kIy2HevLlr4luNjBgvmj413KaQA7jt4V8B4RDsfpHk7WQ9GVqfYyyx8OS/L66Kox+rJRNklLK7w==}\n    engines: {node: '>=6'}\n\n  get-stream@5.2.0:\n    resolution: {integrity: sha512-nBF+F1rAZVCu/p7rjzgA+Yb4lfYXrpl7a6VmJrU8wF9I1CKvP/QwPNZHnOlwbTkY6dvtFIzFMSyQXbLoTQPRpA==}\n    engines: {node: '>=8'}\n\n  get-value@2.0.6:\n    resolution: {integrity: sha512-Ln0UQDlxH1BapMu3GPtf7CuYNwRZf2gwCuPqbyG6pB8WfmFpzqcy4xtAaAMUhnNqjMKTiCPZG2oMT3YSx8U2NA==}\n    engines: {node: '>=0.10.0'}\n\n  glob-parent@5.1.2:\n    resolution: {integrity: sha512-AOIgSQCepiJYwP3ARnGx+5VnTu2HBYdzbGP45eLw1vr3zB3vZLeyed1sC9hnbcOc9/SrMyM5RPQrkGz4aS9Zow==}\n    engines: {node: '>= 6'}\n\n  glob@7.2.3:\n    resolution: {integrity: sha512-nFR0zLpU2YCaRxwoCJvL6UvCH2JFyFVIvwTLsIf21AuHlMskA1hhTdk+LlYJtOlYt9v6dvszD2BGRqBL+iQK9Q==}\n    deprecated: Glob versions prior to v9 are no longer supported\n\n  global@4.4.0:\n    resolution: {integrity: sha512-wv/LAoHdRE3BeTGz53FAamhGlPLhlssK45usmGFThIi4XqnBmjKQ16u+RNbP7WvigRZDxUsM0J3gcQ5yicaL0w==}\n\n  globals@11.12.0:\n    resolution: {integrity: sha512-WOBp/EEGUiIsJSp7wcv/y6MO+lV9UoncWqxuFfm8eBwzWNgyfBd6Gz+IeKQ9jCmyhoH99g15M3T+QaVHFjizVA==}\n    engines: {node: '>=4'}\n\n  gopd@1.2.0:\n    resolution: {integrity: sha512-ZUKRh6/kUFoAiTAtTYPZJ3hw9wNxx+BIBOijnlG9PnrJsCcSjs1wyyD6vJpaYtgnzDrKYRSqf3OO6Rfa93xsRg==}\n    engines: {node: '>= 0.4'}\n\n  graceful-fs@4.2.11:\n    resolution: {integrity: sha512-RbJ5/jmFcNNCcDV5o9eTnBLJ/HszWV0P73bc+Ff4nS/rJj+YaS6IGyiOL0VoBYX+l1Wrl3k63h/KrH+nhJ0XvQ==}\n\n  growly@1.3.0:\n    resolution: {integrity: sha512-+xGQY0YyAWCnqy7Cd++hc2JqMYzlm0dG30Jd0beaA64sROr8C4nt8Yc9V5Ro3avlSUDTN0ulqP/VBKi1/lLygw==}\n\n  harmony-reflect@1.6.2:\n    resolution: {integrity: sha512-HIp/n38R9kQjDEziXyDTuW3vvoxxyxjxFzXLrBr18uB47GnSt+G9D29fqrpM5ZkspMcPICud3XsBJQ4Y2URg8g==}\n\n  has-flag@3.0.0:\n    resolution: {integrity: sha512-sKJf1+ceQBr4SMkvQnBDNDtf4TXpVhVGateu0t918bl30FnbE2m4vNLX+VWe/dpjlb+HugGYzW7uQXH98HPEYw==}\n    engines: {node: '>=4'}\n\n  has-flag@4.0.0:\n    resolution: {integrity: sha512-EykJT/Q1KjTWctppgIAgfSO0tKVuZUjhgMr17kqTumMl6Afv3EISleU7qZUzoXDFTAHTDC4NOoG/ZxU3EvlMPQ==}\n    engines: {node: '>=8'}\n\n  has-property-descriptors@1.0.2:\n    resolution: {integrity: sha512-55JNKuIW+vq4Ke1BjOTjM2YctQIvCT7GFzHwmfZPGo5wnrgkid0YQtnAleFSqumZm4az3n2BS+erby5ipJdgrg==}\n\n  has-symbols@1.1.0:\n    resolution: {integrity: sha512-1cDNdwJ2Jaohmb3sg4OmKaMBwuC48sYni5HUw2DvsC8LjGTLK9h+eb1X6RyuOHe4hT0ULCW68iomhjUoKUqlPQ==}\n    engines: {node: '>= 0.4'}\n\n  has-value@0.3.1:\n    resolution: {integrity: sha512-gpG936j8/MzaeID5Yif+577c17TxaDmhuyVgSwtnL/q8UUTySg8Mecb+8Cf1otgLoD7DDH75axp86ER7LFsf3Q==}\n    engines: {node: '>=0.10.0'}\n\n  has-value@1.0.0:\n    resolution: {integrity: sha512-IBXk4GTsLYdQ7Rvt+GRBrFSVEkmuOUy4re0Xjd9kJSUQpnTrWR4/y9RpfexN9vkAPMFuQoeWKwqzPozRTlasGw==}\n    engines: {node: '>=0.10.0'}\n\n  has-values@0.1.4:\n    resolution: {integrity: sha512-J8S0cEdWuQbqD9//tlZxiMuMNmxB8PlEwvYwuxsTmR1G5RXUePEX/SJn7aD0GMLieuZYSwNH0cQuJGwnYunXRQ==}\n    engines: {node: '>=0.10.0'}\n\n  has-values@1.0.0:\n    resolution: {integrity: sha512-ODYZC64uqzmtfGMEAX/FvZiRyWLpAC3vYnNunURUnkGVTS+mI0smVsWaPydRBsE3g+ok7h960jChO8mFcWlHaQ==}\n    engines: {node: '>=0.10.0'}\n\n  hash-base@3.0.5:\n    resolution: {integrity: sha512-vXm0l45VbcHEVlTCzs8M+s0VeYsB2lnlAaThoLKGXr3bE/VWDOelNUnycUPEhKEaXARL2TEFjBOyUiM6+55KBg==}\n    engines: {node: '>= 0.10'}\n\n  hash.js@1.1.7:\n    resolution: {integrity: sha512-taOaskGt4z4SOANNseOviYDvjEJinIkRgmp7LbKP2YTTmVxWBl87s/uzK9r+44BclBSp2X7K1hqeNfz9JbBeXA==}\n\n  hasown@2.0.2:\n    resolution: {integrity: sha512-0hJU9SCPvmMzIBdZFqNPXWa6dqh7WdH0cII9y+CyS8rG3nL48Bclra9HmKhVVUHyPWNH5Y7xDwAB7bfgSjkUMQ==}\n    engines: {node: '>= 0.4'}\n\n  history-with-query@4.10.4:\n    resolution: {integrity: sha512-JnskQK8X+PbRFHSdDAExhoJyhLnlLZL+UuHQuQhys+Se9/ukRDRBWU4JVTjsiIfbv1fcEmR3oqKW56OYmk5M5w==}\n\n  history@4.10.1:\n    resolution: {integrity: sha512-36nwAD620w12kuzPAsyINPWJqlNbij+hpK1k9XRloDtym8mxzGYl2c17LnV6IAGB2Dmg4tEa7G7DlawS0+qjew==}\n\n  history@5.3.0:\n    resolution: {integrity: sha512-ZqaKwjjrAYUYfLG+htGaIIZ4nioX2L70ZUMIFysS3xvBsSG4x/n1V6TXV3N8ZYNuFGlDirFg32T7B6WOUPDYcQ==}\n\n  hmac-drbg@1.0.1:\n    resolution: {integrity: sha512-Tti3gMqLdZfhOQY1Mzf/AanLiqh1WTiJgEj26ZuYQ9fbkLomzGchCws4FyrSd4VkpBfiNhaE1On+lOz894jvXg==}\n\n  hoist-non-react-statics@3.3.2:\n    resolution: {integrity: sha512-/gGivxi8JPKWNm/W0jSmzcMPpfpPLc3dY/6GxhX2hQ9iGj3aDfklV4ET7NjKpSinLpJ5vafa9iiGIEZg10SfBw==}\n\n  hosted-git-info@2.8.9:\n    resolution: {integrity: sha512-mxIDAb9Lsm6DoOJ7xH+5+X4y1LU/4Hi50L9C5sIswK3JzULS4bwk1FvjdBgvYR4bzT4tuUQiC15FE2f5HbLvYw==}\n\n  html-encoding-sniffer@2.0.1:\n    resolution: {integrity: sha512-D5JbOMBIR/TVZkubHT+OyT2705QvogUW4IBn6nHd756OwieSF9aDYFj4dv6HHEVGYbHaLETa3WggZYWWMyy3ZQ==}\n    engines: {node: '>=10'}\n\n  html-entities@2.5.2:\n    resolution: {integrity: sha512-K//PSRMQk4FZ78Kyau+mZurHn3FH0Vwr+H36eE0rPbeYkRRi9YxceYPhuN60UwWorxyKHhqoAJl2OFKa4BVtaA==}\n\n  html-escaper@2.0.2:\n    resolution: {integrity: sha512-H2iMtd0I4Mt5eYiapRdIDjp+XzelXQ0tFE4JS7YFwFevXXMmOp9myNrUvCg0D6ws8iqkRPBfKHgbwig1SmlLfg==}\n\n  http-proxy-agent@4.0.1:\n    resolution: {integrity: sha512-k0zdNgqWTGA6aeIRVpvfVob4fL52dTfaehylg0Y4UvSySvOq/Y+BOyPrgpUrA7HylqvU8vIZGsRuXmspskV0Tg==}\n    engines: {node: '>= 6'}\n\n  https-browserify@1.0.0:\n    resolution: {integrity: sha512-J+FkSdyD+0mA0N+81tMotaRMfSL9SGi+xpD3T6YApKsc3bGSXJlfXri3VyFOeYkfLRQisDk1W+jIFFKBeUBbBg==}\n\n  https-proxy-agent@5.0.1:\n    resolution: {integrity: sha512-dFcAjpTQFgoLMzC2VwU+C/CbS7uRL0lWmxDITmqm7C+7F0Odmj6s9l6alZc6AELXhrnggM2CeWSXHGOdX2YtwA==}\n    engines: {node: '>= 6'}\n\n  human-signals@1.1.1:\n    resolution: {integrity: sha512-SEQu7vl8KjNL2eoGBLF3+wAjpsNfA9XMlXAYj/3EdaNfAlxKthD1xjEQfGOUhllCGGJVNY34bRr6lPINhNjyZw==}\n    engines: {node: '>=8.12.0'}\n\n  iconv-lite@0.4.24:\n    resolution: {integrity: sha512-v3MXnZAcvnywkTUEZomIActle7RXXeedOR31wwl7VlyoXO4Qi9arvSenNQWne1TcRwhCL1HwLI21bEqdpj8/rA==}\n    engines: {node: '>=0.10.0'}\n\n  iconv-lite@0.6.3:\n    resolution: {integrity: sha512-4fCk79wshMdzMp2rH06qWrJE4iolqLhCUH+OiuIgU++RB0+94NlDL81atO7GX55uUKueo0txHNtvEyI6D7WdMw==}\n    engines: {node: '>=0.10.0'}\n\n  identity-obj-proxy@3.0.0:\n    resolution: {integrity: sha512-00n6YnVHKrinT9t0d9+5yZC6UBNJANpYEQvL2LlX6Ab9lnmxzIRcEmTPuyGScvl1+jKuCICX1Z0Ab1pPKKdikA==}\n    engines: {node: '>=4'}\n\n  ieee754@1.2.1:\n    resolution: {integrity: sha512-dcyqhDvX1C46lXZcVqCpK+FtMRQVdIMN6/Df5js2zouUsqG7I6sFxitIC+7KYK29KdXOLHdu9zL4sFnoVQnqaA==}\n\n  immer@7.0.15:\n    resolution: {integrity: sha512-yM7jo9+hvYgvdCQdqvhCNRRio0SCXc8xDPzA25SvKWa7b1WVPjLwQs1VYU5JPXjcJPTqAa5NP5dqpORGYBQ2AA==}\n\n  immutable@3.8.2:\n    resolution: {integrity: sha512-15gZoQ38eYjEjxkorfbcgBKBL6R7T459OuK+CpcWt7O3KF4uPCx2tD0uFETlUDIyo+1789crbMhTvQBSR5yBMg==}\n    engines: {node: '>=0.10.0'}\n\n  import-cwd@2.1.0:\n    resolution: {integrity: sha512-Ew5AZzJQFqrOV5BTW3EIoHAnoie1LojZLXKcCQ/yTRyVZosBhK1x1ViYjHGf5pAFOq8ZyChZp6m/fSN7pJyZtg==}\n    engines: {node: '>=4'}\n\n  import-fresh@2.0.0:\n    resolution: {integrity: sha512-eZ5H8rcgYazHbKC3PG4ClHNykCSxtAhxSSEM+2mb+7evD2CKF5V7c0dNum7AdpDh0ZdICwZY9sRSn8f+KH96sg==}\n    engines: {node: '>=4'}\n\n  import-fresh@3.3.0:\n    resolution: {integrity: sha512-veYYhQa+D1QBKznvhUHxb8faxlrwUnxseDAbAp457E0wLNio2bOSKnjYDhMj+YiAq61xrMGhQk9iXVk5FzgQMw==}\n    engines: {node: '>=6'}\n\n  import-from@2.1.0:\n    resolution: {integrity: sha512-0vdnLL2wSGnhlRmzHJAg5JHjt1l2vYhzJ7tNLGbeVg0fse56tpGaH0uzH+r9Slej+BSXXEHvBKDEnVSLLE9/+w==}\n    engines: {node: '>=4'}\n\n  import-local@3.2.0:\n    resolution: {integrity: sha512-2SPlun1JUPWoM6t3F0dw0FkCF/jWY8kttcY4f599GLTSjh2OCuuhdTkJQsEcZzBqbXZGKMK2OqW1oZsjtf/gQA==}\n    engines: {node: '>=8'}\n    hasBin: true\n\n  imurmurhash@0.1.4:\n    resolution: {integrity: sha512-JmXMZ6wuvDmLiHEml9ykzqO6lwFbof0GG4IkcGaENdCRDDmMVnny7s5HsIgHCbaq0w2MyPhDqkhTUgS2LU2PHA==}\n    engines: {node: '>=0.8.19'}\n\n  indent-string@4.0.0:\n    resolution: {integrity: sha512-EdDDZu4A2OyIK7Lr/2zG+w5jmbuk1DVBnEwREQvBzspBJkCEbRa8GxU1lghYcaGJCnRWibjDXlq779X1/y5xwg==}\n    engines: {node: '>=8'}\n\n  indexes-of@1.0.1:\n    resolution: {integrity: sha512-bup+4tap3Hympa+JBJUG7XuOsdNQ6fxt0MHyXMKuLBKn0OqsTfvUxkUrroEX1+B2VsSHvCjiIcZVxRtYa4nllA==}\n\n  inflight@1.0.6:\n    resolution: {integrity: sha512-k92I/b08q4wvFscXCLvqfsHCrjrF7yiXsQuIVvVE7N82W3+aqpzuUdBbfhWcy/FZR3/4IgflMgKLOsvPDrGCJA==}\n    deprecated: This module is not supported, and leaks memory. Do not use it. Check out lru-cache if you want a good and tested way to coalesce async requests by a key value, which is much more comprehensive and powerful.\n\n  inherits@2.0.3:\n    resolution: {integrity: sha512-x00IRNXNy63jwGkJmzPigoySHbaqpNuzKbBOmzK+g2OdZpQ9w+sxCN+VSB3ja7IAge2OP2qpfxTjeNcyjmW1uw==}\n\n  inherits@2.0.4:\n    resolution: {integrity: sha512-k/vGaX4/Yla3WzyMCvTQOXYeIHvqOKtnqBduzTHpzpQZzAskKMhZ2K+EnBiSM9zGSoIFeMpXKxa4dYeZIQqewQ==}\n\n  intl-format-cache@4.3.1:\n    resolution: {integrity: sha512-OEUYNA7D06agqPOYhbTkl0T8HA3QKSuwWh1HiClEnpd9vw7N+3XsQt5iZ0GUEchp5CW1fQk/tary+NsbF3yQ1Q==}\n\n  intl-messageformat-parser@3.6.4:\n    resolution: {integrity: sha512-RgPGwue0mJtoX2Ax8EmMzJzttxjnva7gx0Q7mKJ4oALrTZvtmCeAw5Msz2PcjW4dtCh/h7vN/8GJCxZO1uv+OA==}\n    deprecated: We've written a new parser that's 6x faster and is backwards compatible. Please use @formatjs/icu-messageformat-parser\n\n  intl-messageformat@7.8.4:\n    resolution: {integrity: sha512-yS0cLESCKCYjseCOGXuV4pxJm/buTfyCJ1nzQjryHmSehlptbZbn9fnlk1I9peLopZGGbjj46yHHiTAEZ1qOTA==}\n\n  intl@1.2.5:\n    resolution: {integrity: sha512-rK0KcPHeBFBcqsErKSpvZnrOmWOj+EmDkyJ57e90YWaQNqbcivcqmKDlHEeNprDWOsKzPsh1BfSpPQdDvclHVw==}\n\n  invariant@2.2.4:\n    resolution: {integrity: sha512-phJfQVBuaJM5raOpJjSfkiD6BpbCE4Ns//LaXl6wGYtUBY83nWS6Rf9tXm2e8VaK60JEjYldbPif/A2B1C2gNA==}\n\n  is-accessor-descriptor@1.0.1:\n    resolution: {integrity: sha512-YBUanLI8Yoihw923YeFUS5fs0fF2f5TSFTNiYAAzhhDscDa3lEqYuz1pDOEP5KvX94I9ey3vsqjJcLVFVU+3QA==}\n    engines: {node: '>= 0.10'}\n\n  is-arrayish@0.2.1:\n    resolution: {integrity: sha512-zz06S8t0ozoDXMG+ube26zeCTNXcKIPJZJi8hBrF4idCLms4CG9QtK7qBl1boi5ODzFpjswb5JPmHCbMpjaYzg==}\n\n  is-binary-path@2.1.0:\n    resolution: {integrity: sha512-ZMERYes6pDydyuGidse7OsHxtbI7WVeUEozgR/g7rd0xUimYNlvZRE/K2MgZTjWy725IfelLeVcEM97mmtRGXw==}\n    engines: {node: '>=8'}\n\n  is-buffer@1.1.6:\n    resolution: {integrity: sha512-NcdALwpXkTm5Zvvbk7owOUSvVvBKDgKP5/ewfXEznmQFfs4ZRmanOeKBTjRVjka3QFoN6XJ+9F3USqfHqTaU5w==}\n\n  is-ci@1.2.1:\n    resolution: {integrity: sha512-s6tfsaQaQi3JNciBH6shVqEDvhGut0SUXr31ag8Pd8BBbVVlcGfWhpPmEOoM6RJ5TFhbypvf5yyRw/VXW1IiWg==}\n    hasBin: true\n\n  is-ci@2.0.0:\n    resolution: {integrity: sha512-YfJT7rkpQB0updsdHLGWrvhBJfcfzNNawYDNIyQXJz0IViGf75O8EBPKSdvw2rF+LGCsX4FZ8tcr3b19LcZq4w==}\n    hasBin: true\n\n  is-core-module@2.15.1:\n    resolution: {integrity: sha512-z0vtXSwucUJtANQWldhbtbt7BnL0vxiFjIdDLAatwhDYty2bad6s+rijD6Ri4YuYJubLzIJLUidCh09e1djEVQ==}\n    engines: {node: '>= 0.4'}\n\n  is-data-descriptor@1.0.1:\n    resolution: {integrity: sha512-bc4NlCDiCr28U4aEsQ3Qs2491gVq4V8G7MQyws968ImqjKuYtTJXrl7Vq7jsN7Ly/C3xj5KWFrY7sHNeDkAzXw==}\n    engines: {node: '>= 0.4'}\n\n  is-descriptor@0.1.7:\n    resolution: {integrity: sha512-C3grZTvObeN1xud4cRWl366OMXZTj0+HGyk4hvfpx4ZHt1Pb60ANSXqCK7pdOTeUQpRzECBSTphqvD7U+l22Eg==}\n    engines: {node: '>= 0.4'}\n\n  is-descriptor@1.0.3:\n    resolution: {integrity: sha512-JCNNGbwWZEVaSPtS45mdtrneRWJFp07LLmykxeFV5F6oBvNF8vHSfJuJgoT472pSfk+Mf8VnlrspaFBHWM8JAw==}\n    engines: {node: '>= 0.4'}\n\n  is-directory@0.3.1:\n    resolution: {integrity: sha512-yVChGzahRFvbkscn2MlwGismPO12i9+znNruC5gVEntG3qu0xQMzsGg/JFbrsqDOHtHFPci+V5aP5T9I+yeKqw==}\n    engines: {node: '>=0.10.0'}\n\n  is-docker@2.2.1:\n    resolution: {integrity: sha512-F+i2BKsFrH66iaUFc0woD8sLy8getkwTwtOBjvs56Cx4CgJDeKQeqfz8wAYiSb8JOprWhHH5p77PbmYCvvUuXQ==}\n    engines: {node: '>=8'}\n    hasBin: true\n\n  is-extendable@0.1.1:\n    resolution: {integrity: sha512-5BMULNob1vgFX6EjQw5izWDxrecWK9AM72rugNr0TFldMOi0fj6Jk+zeKIt0xGj4cEfQIJth4w3OKWOJ4f+AFw==}\n    engines: {node: '>=0.10.0'}\n\n  is-extendable@1.0.1:\n    resolution: {integrity: sha512-arnXMxT1hhoKo9k1LZdmlNyJdDDfy2v0fXjFlmok4+i8ul/6WlbVge9bhM74OpNPQPMGUToDtz+KXa1PneJxOA==}\n    engines: {node: '>=0.10.0'}\n\n  is-extglob@2.1.1:\n    resolution: {integrity: sha512-SbKbANkN603Vi4jEZv49LeVJMn4yGwsbzZworEoyEiutsN3nJYdbO36zfhGJ6QEDpOZIFkDtnq5JRxmvl3jsoQ==}\n    engines: {node: '>=0.10.0'}\n\n  is-fullwidth-code-point@3.0.0:\n    resolution: {integrity: sha512-zymm5+u+sCsSWyD9qNaejV3DFvhCKclKdizYaJUuHA83RLjb7nSuGnddCHGv0hk+KY7BMAlsWeK4Ueg6EV6XQg==}\n    engines: {node: '>=8'}\n\n  is-generator-fn@2.1.0:\n    resolution: {integrity: sha512-cTIB4yPYL/Grw0EaSzASzg6bBy9gqCofvWN8okThAYIxKJZC+udlRAmGbM0XLeniEJSs8uEgHPGuHSe1XsOLSQ==}\n    engines: {node: '>=6'}\n\n  is-glob@4.0.3:\n    resolution: {integrity: sha512-xelSayHH36ZgE7ZWhli7pW34hNbNl8Ojv5KVmkJD4hBdD3th8Tfk9vYasLM+mXWOZhFkgZfxhLSnrwRr4elSSg==}\n    engines: {node: '>=0.10.0'}\n\n  is-number@3.0.0:\n    resolution: {integrity: sha512-4cboCqIpliH+mAvFNegjZQ4kgKc3ZUhQVr3HvWbSh5q3WH2v82ct+T2Y1hdU5Gdtorx/cLifQjqCbL7bpznLTg==}\n    engines: {node: '>=0.10.0'}\n\n  is-number@7.0.0:\n    resolution: {integrity: sha512-41Cifkg6e8TylSpdtTpeLVMqvSBEVzTttHvERD741+pnZ8ANv0004MRL43QKPDlK9cGvNp6NZWZUBlbGXYxxng==}\n    engines: {node: '>=0.12.0'}\n\n  is-obj@1.0.1:\n    resolution: {integrity: sha512-l4RyHgRqGN4Y3+9JHVrNqO+tN0rV5My76uW5/nuO4K1b6vw5G8d/cmFjP9tRfEsdhZNt0IFdZuK/c2Vr4Nb+Qg==}\n    engines: {node: '>=0.10.0'}\n\n  is-plain-obj@1.1.0:\n    resolution: {integrity: sha512-yvkRyxmFKEOQ4pNXCmJG5AEQNlXJS5LaONXo5/cLdTZdWvsZ1ioJEonLGAosKlMWE8lwUy/bJzMjcw8az73+Fg==}\n    engines: {node: '>=0.10.0'}\n\n  is-plain-object@2.0.4:\n    resolution: {integrity: sha512-h5PpgXkWitc38BBMYawTYMWJHFZJVnBquFE57xFpjB8pJFiF6gZ+bU+WyI/yqXiFR5mdLsgYNaPe8uao6Uv9Og==}\n    engines: {node: '>=0.10.0'}\n\n  is-potential-custom-element-name@1.0.1:\n    resolution: {integrity: sha512-bCYeRA2rVibKZd+s2625gGnGF/t7DSqDs4dP7CrLA1m7jKWz6pps0LpYLJN8Q64HtmPKJ1hrN3nzPNKFEKOUiQ==}\n\n  is-regexp@1.0.0:\n    resolution: {integrity: sha512-7zjFAPO4/gwyQAAgRRmqeEeyIICSdmCqa3tsVHMdBzaXXRiqopZL4Cyghg/XulGWrtABTpbnYYzzIRffLkP4oA==}\n    engines: {node: '>=0.10.0'}\n\n  is-stream@1.1.0:\n    resolution: {integrity: sha512-uQPm8kcs47jx38atAcWTVxyltQYoPT68y9aWYdV6yWXSyW8mzSat0TL6CiWdZeCdF3KrAvpVtnHbTv4RN+rqdQ==}\n    engines: {node: '>=0.10.0'}\n\n  is-stream@2.0.1:\n    resolution: {integrity: sha512-hFoiJiTl63nn+kstHGBtewWSKnQLpyb155KHheA1l39uvtO9nWIop1p3udqPcUd/xbF1VLMO4n7OI6p7RbngDg==}\n    engines: {node: '>=8'}\n\n  is-typedarray@1.0.0:\n    resolution: {integrity: sha512-cyA56iCMHAh5CdzjJIa4aohJyeO1YbwLi3Jc35MmRU6poroFjIGZzUzupGiRPOjgHg9TLu43xbpwXk523fMxKA==}\n\n  is-unicode-supported@0.1.0:\n    resolution: {integrity: sha512-knxG2q4UC3u8stRGyAVJCOdxFmv5DZiRcdlIaAQXAbSfJya+OhopNotLQrstBhququ4ZpuKbDc/8S6mgXgPFPw==}\n    engines: {node: '>=10'}\n\n  is-windows@1.0.2:\n    resolution: {integrity: sha512-eXK1UInq2bPmjyX6e3VHIzMLobc4J94i4AWn+Hpq3OU5KkrRC96OAcR3PRJ/pGu6m8TRnBHP9dkXQVsT/COVIA==}\n    engines: {node: '>=0.10.0'}\n\n  is-wsl@2.2.0:\n    resolution: {integrity: sha512-fKzAra0rGJUUBwGBgNkHZuToZcn+TtXHpeCgmkMJMMYx1sQDYaCSyjJBSCa2nH1DGm7s3n1oBnohoVTBaN7Lww==}\n    engines: {node: '>=8'}\n\n  isarray@0.0.1:\n    resolution: {integrity: sha512-D2S+3GLxWH+uhrNEcoh/fnmYeP8E8/zHl644d/jdA0g2uyXvy3sb0qxotE+ne0LtccHknQzWwZEzhak7oJ0COQ==}\n\n  isarray@1.0.0:\n    resolution: {integrity: sha512-VLghIWNM6ELQzo7zwmcg0NmTVyWKYjvIeM83yjp0wRDTmUnrM678fQbcKBo6n2CJEF0szoG//ytg+TKla89ALQ==}\n\n  isexe@2.0.0:\n    resolution: {integrity: sha512-RHxMLp9lnKHGHRng9QFhRCMbYAcVpn69smSGcq3f36xjgVVWThj4qqLbTLlq7Ssj8B+fIQ1EuCEGI2lKsyQeIw==}\n\n  isobject@2.1.0:\n    resolution: {integrity: sha512-+OUdGJlgjOBZDfxnDjYYG6zp487z0JGNQq3cYQYg5f5hKR+syHMsaztzGeml/4kGG55CSpKSpWTY+jYGgsHLgA==}\n    engines: {node: '>=0.10.0'}\n\n  isobject@3.0.1:\n    resolution: {integrity: sha512-WhB9zCku7EGTj/HQQRz5aUQEUeoQZH2bWcltRErOpymJ4boYE6wL9Tbr23krRPSZ+C5zqNSrSw+Cc7sZZ4b7vg==}\n    engines: {node: '>=0.10.0'}\n\n  isomorphic-fetch@2.2.1:\n    resolution: {integrity: sha512-9c4TNAKYXM5PRyVcwUZrF3W09nQ+sO7+jydgs4ZGW9dhsLG2VOlISJABombdQqQRXCwuYG3sYV/puGf5rp0qmA==}\n\n  istanbul-lib-coverage@3.2.2:\n    resolution: {integrity: sha512-O8dpsF+r0WV/8MNRKfnmrtCWhuKjxrq2w+jpzBL5UZKTi2LeVWnWOmWRxFlesJONmc+wLAGvKQZEOanko0LFTg==}\n    engines: {node: '>=8'}\n\n  istanbul-lib-instrument@4.0.3:\n    resolution: {integrity: sha512-BXgQl9kf4WTCPCCpmFGoJkz/+uhvm7h7PFKUYxh7qarQd3ER33vHG//qaE8eN25l07YqZPpHXU9I09l/RD5aGQ==}\n    engines: {node: '>=8'}\n\n  istanbul-lib-instrument@5.2.1:\n    resolution: {integrity: sha512-pzqtp31nLv/XFOzXGuvhCb8qhjmTVo5vjVk19XE4CRlSWz0KoeJ3bw9XsA7nOp9YBf4qHjwBxkDzKcME/J29Yg==}\n    engines: {node: '>=8'}\n\n  istanbul-lib-report@3.0.1:\n    resolution: {integrity: sha512-GCfE1mtsHGOELCU8e/Z7YWzpmybrx/+dSTfLrvY8qRmaY6zXTKWn6WQIjaAFw069icm6GVMNkgu0NzI4iPZUNw==}\n    engines: {node: '>=10'}\n\n  istanbul-lib-source-maps@4.0.1:\n    resolution: {integrity: sha512-n3s8EwkdFIJCG3BPKBYvskgXGoy88ARzvegkitk60NxRdwltLOTaH7CUiMRXvwYorl0Q712iEjcWB+fK/MrWVw==}\n    engines: {node: '>=10'}\n\n  istanbul-reports@3.1.7:\n    resolution: {integrity: sha512-BewmUXImeuRk2YY0PVbxgKAysvhRPUQE0h5QRM++nVWyubKGV0l8qQ5op8+B2DOmwSe63Jivj0BjkPQVf8fP5g==}\n    engines: {node: '>=8'}\n\n  javascript-stringify@2.1.0:\n    resolution: {integrity: sha512-JVAfqNPTvNq3sB/VHQJAFxN/sPgKnsKrCwyRt15zwNCdrMMJDdcEOdubuy+DuJYYdm0ox1J4uzEuYKkN+9yhVg==}\n\n  jest-changed-files@26.6.2:\n    resolution: {integrity: sha512-fDS7szLcY9sCtIip8Fjry9oGf3I2ht/QT21bAHm5Dmf0mD4X3ReNUf17y+bO6fR8WgbIZTlbyG1ak/53cbRzKQ==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-cli@26.6.3:\n    resolution: {integrity: sha512-GF9noBSa9t08pSyl3CY4frMrqp+aQXFGFkf5hEPbh/pIUFYWMK6ZLTfbmadxJVcJrdRoChlWQsA2VkJcDFK8hg==}\n    engines: {node: '>= 10.14.2'}\n    hasBin: true\n\n  jest-config@26.6.3:\n    resolution: {integrity: sha512-t5qdIj/bCj2j7NFVHb2nFB4aUdfucDn3JRKgrZnplb8nieAirAzRSHP8uDEd+qV6ygzg9Pz4YG7UTJf94LPSyg==}\n    engines: {node: '>= 10.14.2'}\n    peerDependencies:\n      ts-node: '>=9.0.0'\n    peerDependenciesMeta:\n      ts-node:\n        optional: true\n\n  jest-diff@26.6.2:\n    resolution: {integrity: sha512-6m+9Z3Gv9wN0WFVasqjCL/06+EFCMTqDEUl/b87HYK2rAPTyfz4ZIuSlPhY51PIQRWx5TaxeF1qmXKe9gfN3sA==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-docblock@26.0.0:\n    resolution: {integrity: sha512-RDZ4Iz3QbtRWycd8bUEPxQsTlYazfYn/h5R65Fc6gOfwozFhoImx+affzky/FFBuqISPTqjXomoIGJVKBWoo0w==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-each@26.6.2:\n    resolution: {integrity: sha512-Mer/f0KaATbjl8MCJ+0GEpNdqmnVmDYqCTJYTvoo7rqmRiDllmp2AYN+06F93nXcY3ur9ShIjS+CO/uD+BbH4A==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-environment-jsdom@26.6.2:\n    resolution: {integrity: sha512-jgPqCruTlt3Kwqg5/WVFyHIOJHsiAvhcp2qiR2QQstuG9yWox5+iHpU3ZrcBxW14T4fe5Z68jAfLRh7joCSP2Q==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-environment-node@26.6.2:\n    resolution: {integrity: sha512-zhtMio3Exty18dy8ee8eJ9kjnRyZC1N4C1Nt/VShN1apyXc8rWGtJ9lI7vqiWcyyXS4BVSEn9lxAM2D+07/Tag==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-get-type@26.3.0:\n    resolution: {integrity: sha512-TpfaviN1R2pQWkIihlfEanwOXK0zcxrKEE4MlU6Tn7keoXdN6/3gK/xl0yEh8DOunn5pOVGKf8hB4R9gVh04ig==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-haste-map@26.6.2:\n    resolution: {integrity: sha512-easWIJXIw71B2RdR8kgqpjQrbMRWQBgiBwXYEhtGUTaX+doCjBheluShdDMeR8IMfJiTqH4+zfhtg29apJf/8w==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-jasmine2@26.6.3:\n    resolution: {integrity: sha512-kPKUrQtc8aYwBV7CqBg5pu+tmYXlvFlSFYn18ev4gPFtrRzB15N2gW/Roew3187q2w2eHuu0MU9TJz6w0/nPEg==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-leak-detector@26.6.2:\n    resolution: {integrity: sha512-i4xlXpsVSMeKvg2cEKdfhh0H39qlJlP5Ex1yQxwF9ubahboQYMgTtz5oML35AVA3B4Eu+YsmwaiKVev9KCvLxg==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-matcher-utils@26.6.2:\n    resolution: {integrity: sha512-llnc8vQgYcNqDrqRDXWwMr9i7rS5XFiCwvh6DTP7Jqa2mqpcCBBlpCbn+trkG0KNhPu/h8rzyBkriOtBstvWhw==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-message-util@26.6.2:\n    resolution: {integrity: sha512-rGiLePzQ3AzwUshu2+Rn+UMFk0pHN58sOG+IaJbk5Jxuqo3NYO1U2/MIR4S1sKgsoYSXSzdtSa0TgrmtUwEbmA==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-mock@26.6.2:\n    resolution: {integrity: sha512-YyFjePHHp1LzpzYcmgqkJ0nm0gg/lJx2aZFzFy1S6eUqNjXsOqTK10zNRff2dNfssgokjkG65OlWNcIlgd3zew==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-pnp-resolver@1.2.3:\n    resolution: {integrity: sha512-+3NpwQEnRoIBtx4fyhblQDPgJI0H1IEIkX7ShLUjPGA7TtUTvI1oiKi3SR4oBR0hQhQR80l4WAe5RrXBwWMA8w==}\n    engines: {node: '>=6'}\n    peerDependencies:\n      jest-resolve: '*'\n    peerDependenciesMeta:\n      jest-resolve:\n        optional: true\n\n  jest-regex-util@26.0.0:\n    resolution: {integrity: sha512-Gv3ZIs/nA48/Zvjrl34bf+oD76JHiGDUxNOVgUjh3j890sblXryjY4rss71fPtD/njchl6PSE2hIhvyWa1eT0A==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-resolve-dependencies@26.6.3:\n    resolution: {integrity: sha512-pVwUjJkxbhe4RY8QEWzN3vns2kqyuldKpxlxJlzEYfKSvY6/bMvxoFrYYzUO1Gx28yKWN37qyV7rIoIp2h8fTg==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-resolve@26.6.2:\n    resolution: {integrity: sha512-sOxsZOq25mT1wRsfHcbtkInS+Ek7Q8jCHUB0ZUTP0tc/c41QHriU/NunqMfCUWsL4H3MHpvQD4QR9kSYhS7UvQ==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-runner@26.6.3:\n    resolution: {integrity: sha512-atgKpRHnaA2OvByG/HpGA4g6CSPS/1LK0jK3gATJAoptC1ojltpmVlYC3TYgdmGp+GLuhzpH30Gvs36szSL2JQ==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-runtime@26.6.3:\n    resolution: {integrity: sha512-lrzyR3N8sacTAMeonbqpnSka1dHNux2uk0qqDXVkMv2c/A3wYnvQ4EXuI013Y6+gSKSCxdaczvf4HF0mVXHRdw==}\n    engines: {node: '>= 10.14.2'}\n    hasBin: true\n\n  jest-serializer@26.6.2:\n    resolution: {integrity: sha512-S5wqyz0DXnNJPd/xfIzZ5Xnp1HrJWBczg8mMfMpN78OJ5eDxXyf+Ygld9wX1DnUWbIbhM1YDY95NjR4CBXkb2g==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-snapshot@26.6.2:\n    resolution: {integrity: sha512-OLhxz05EzUtsAmOMzuupt1lHYXCNib0ECyuZ/PZOx9TrZcC8vL0x+DUG3TL+GLX3yHG45e6YGjIm0XwDc3q3og==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-util@26.6.2:\n    resolution: {integrity: sha512-MDW0fKfsn0OI7MS7Euz6h8HNDXVQ0gaM9uW6RjfDmd1DAFcaxX9OqIakHIqhbnmF08Cf2DLDG+ulq8YQQ0Lp0Q==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-validate@26.6.2:\n    resolution: {integrity: sha512-NEYZ9Aeyj0i5rQqbq+tpIOom0YS1u2MVu6+euBsvpgIme+FOfRmoC4R5p0JiAUpaFvFy24xgrpMknarR/93XjQ==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-watcher@26.6.2:\n    resolution: {integrity: sha512-WKJob0P/Em2csiVthsI68p6aGKTIcsfjH9Gsx1f0A3Italz43e3ho0geSAVsmj09RWOELP1AZ/DXyJgOgDKxXQ==}\n    engines: {node: '>= 10.14.2'}\n\n  jest-worker@24.9.0:\n    resolution: {integrity: sha512-51PE4haMSXcHohnSMdM42anbvZANYTqMrr52tVKPqqsPJMzoP6FYYDVqahX/HrAoKEKz3uUPzSvKs9A3qR4iVw==}\n    engines: {node: '>= 6'}\n\n  jest-worker@26.6.2:\n    resolution: {integrity: sha512-KWYVV1c4i+jbMpaBC+U++4Va0cp8OisU185o73T1vo99hqi7w8tSJfUXYswwqqrjzwxa6KpRK54WhPvwf5w6PQ==}\n    engines: {node: '>= 10.13.0'}\n\n  jest@26.6.3:\n    resolution: {integrity: sha512-lGS5PXGAzR4RF7V5+XObhqz2KZIDUA1yD0DG6pBVmy10eh0ZIXQImRuzocsI/N2XZ1GrLFwTS27In2i2jlpq1Q==}\n    engines: {node: '>= 10.14.2'}\n    hasBin: true\n\n  js-tokens@4.0.0:\n    resolution: {integrity: sha512-RdJUflcE3cUzKiMqQgsCu06FPu9UdIJO0beYbPhHN4k6apgJtifcoCtT9bcxOpYBtpD2kCM6Sbzg4CausW/PKQ==}\n\n  js-yaml@3.14.1:\n    resolution: {integrity: sha512-okMH7OXXJ7YrN9Ok3/SXrnu4iX9yOk+25nqX4imS2npuvTYDmo/QEZoqwZkYaIDk3jVvBOTOIEgEhaLOynBS9g==}\n    hasBin: true\n\n  jsdom@16.7.0:\n    resolution: {integrity: sha512-u9Smc2G1USStM+s/x1ru5Sxrl6mPYCbByG1U/hUmqaVsm4tbNyS7CicOSRyuGQYZhTu0h84qkZZQ/I+dzizSVw==}\n    engines: {node: '>=10'}\n    peerDependencies:\n      canvas: ^2.5.0\n    peerDependenciesMeta:\n      canvas:\n        optional: true\n\n  jsesc@3.1.0:\n    resolution: {integrity: sha512-/sM3dO2FOzXjKQhJuo0Q173wf2KOo8t4I8vHy6lF9poUp7bKT0/NHE8fPX23PwfhnykfqnC2xRxOnVw5XuGIaA==}\n    engines: {node: '>=6'}\n    hasBin: true\n\n  json-parse-better-errors@1.0.2:\n    resolution: {integrity: sha512-mrqyZKfX5EhL7hvqcV6WG1yYjnjeuYDzDhhcAAUrq8Po85NBQBJP+ZDUT75qZQ98IkUoBqdkExkukOU7Ts2wrw==}\n\n  json-parse-even-better-errors@2.3.1:\n    resolution: {integrity: sha512-xyFwyhro/JEof6Ghe2iz2NcXoj2sloNsWr/XsERDK/oiPCfaNhl5ONfp+jQdAZRQQ0IJWNzH9zIZF7li91kh2w==}\n\n  json-schema-traverse@0.4.1:\n    resolution: {integrity: sha512-xbbCH5dCYU5T8LcEhhuh7HJ88HXuW3qsI3Y0zOZFKfZEHcpWiHU/Jxzk629Brsab/mMiHQti9wMP+845RPe3Vg==}\n\n  json2mq@0.2.0:\n    resolution: {integrity: sha512-SzoRg7ux5DWTII9J2qkrZrqV1gt+rTaoufMxEzXbS26Uid0NwaJd123HcoB80TgubEppxxIGdNxCx50fEoEWQA==}\n\n  json5@1.0.2:\n    resolution: {integrity: sha512-g1MWMLBiz8FKi1e4w0UyVL3w+iJceWAFBAaBnnGKOpNa5f8TLktkbre1+s6oICydWAm+HRUGTmI+//xv2hvXYA==}\n    hasBin: true\n\n  json5@2.2.3:\n    resolution: {integrity: sha512-XmOWe7eyHYH14cLdVPoyg+GOH3rYX++KpzrylJwSW98t3Nk+U8XOl8FWKOgwtzdb8lXGf6zYwDUzeHMWfxasyg==}\n    engines: {node: '>=6'}\n    hasBin: true\n\n  kind-of@3.2.2:\n    resolution: {integrity: sha512-NOW9QQXMoZGg/oqnVNoNTTIFEIid1627WCffUBJEdMxYApq7mNE7CpzucIPc+ZQg25Phej7IJSmX3hO+oblOtQ==}\n    engines: {node: '>=0.10.0'}\n\n  kind-of@4.0.0:\n    resolution: {integrity: sha512-24XsCxmEbRwEDbz/qz3stgin8TTzZ1ESR56OMCN0ujYg+vRutNSiOj9bHH9u85DKgXguraugV5sFuvbD4FW/hw==}\n    engines: {node: '>=0.10.0'}\n\n  kind-of@6.0.3:\n    resolution: {integrity: sha512-dcS1ul+9tmeD95T+x28/ehLgd9mENa3LsvDTtzm3vyBEO7RPptvAD+t44WVXaUjTBRcrpFeFlC8WCruUR456hw==}\n    engines: {node: '>=0.10.0'}\n\n  kleur@3.0.3:\n    resolution: {integrity: sha512-eTIzlVOSUR+JxdDFepEYcBMtZ9Qqdef+rnzWdRZuMbOywu5tO2w2N7rqjoANZ5k9vywhL6Br1VRjUIgTQx4E8w==}\n    engines: {node: '>=6'}\n\n  leven@3.1.0:\n    resolution: {integrity: sha512-qsda+H8jTaUaN/x5vzW2rzc+8Rw4TAQ/4KjB46IwK5VH+IlVeeeje/EoZRpiXvIqjFgK84QffqPztGI3VBLG1A==}\n    engines: {node: '>=6'}\n\n  lines-and-columns@1.2.4:\n    resolution: {integrity: sha512-7ylylesZQ/PV29jhEDl3Ufjo6ZX7gCqJr5F7PKrqc93v7fzSymt1BpwEU8nAUXs8qzzvqhbjhK5QZg6Mt/HkBg==}\n\n  lint-staged@10.5.4:\n    resolution: {integrity: sha512-EechC3DdFic/TdOPgj/RB3FicqE6932LTHCUm0Y2fsD9KGlLB+RwJl2q1IYBIvEsKzDOgn0D4gll+YxG5RsrKg==}\n    hasBin: true\n\n  listr2@3.14.0:\n    resolution: {integrity: sha512-TyWI8G99GX9GjE54cJ+RrNMcIFBfwMPxc3XTFiAYGN4s10hWROGtOg7+O6u6LE3mNkyld7RSLE6nrKBvTfcs3g==}\n    engines: {node: '>=10.0.0'}\n    peerDependencies:\n      enquirer: '>= 2.3.0 < 3'\n    peerDependenciesMeta:\n      enquirer:\n        optional: true\n\n  loader-utils@1.4.2:\n    resolution: {integrity: sha512-I5d00Pd/jwMD2QCduo657+YM/6L3KZu++pmX9VFncxaxvHcru9jx1lBaFft+r4Mt2jK0Yhp41XlRAihzPxHNCg==}\n    engines: {node: '>=4.0.0'}\n\n  locate-path@5.0.0:\n    resolution: {integrity: sha512-t7hw9pI+WvuwNJXwk5zVHpyhIqzg2qTlklJOf0mVxGSbe3Fp2VieZcduNYjaLDoy6p9uGpQEGWG87WpMKlNq8g==}\n    engines: {node: '>=8'}\n\n  lodash.debounce@4.0.8:\n    resolution: {integrity: sha512-FT1yDzDYEoYWhnSGnpE/4Kj1fLZkDFyqRb7fNt6FdYOSxlUWAtp42Eh6Wb0rGIv/m9Bgo7x4GhQbm5Ys4SG5ow==}\n\n  lodash.isequal@4.5.0:\n    resolution: {integrity: sha512-pDo3lu8Jhfjqls6GkMgpahsF9kCyayhgykjyLMNFTKWrpVdAQtYyB4muAMWozBB4ig/dtWAmsMxLEI8wuz+DYQ==}\n\n  lodash.merge@4.6.2:\n    resolution: {integrity: sha512-0KpjqXRVvrYyCsX1swR/XTK0va6VQkQM6MNo7PqW77ByjAhoARA8EfrP1N4+KlKj8YS0ZUCtRT/YUuhyYDujIQ==}\n\n  lodash.throttle@4.1.1:\n    resolution: {integrity: sha512-wIkUCfVKpVsWo3JSZlc+8MB5it+2AN5W8J7YVMST30UrvcQNZ1Okbj+rbVniijTWE6FGYy4XJq/rHkas8qJMLQ==}\n\n  lodash@4.17.21:\n    resolution: {integrity: sha512-v2kDEe57lecTulaDIuNTPy3Ry4gLGJ6Z1O3vE1krgXZNrsQ+LFTGHVxVjcXPs17LhbZVGedAJv8XZ1tvj5FvSg==}\n\n  log-symbols@4.1.0:\n    resolution: {integrity: sha512-8XPvpAA8uyhfteu8pIvQxpJZ7SYYdpUivZpGy6sFsBuKRY/7rQGavedeB8aK+Zkyq6upMFVL/9AW6vOYzfRyLg==}\n    engines: {node: '>=10'}\n\n  log-update@4.0.0:\n    resolution: {integrity: sha512-9fkkDevMefjg0mmzWFBW8YkFP91OrizzkW3diF7CpG+S2EYdy4+TVfGwz1zeF8x7hCx1ovSPTOE9Ngib74qqUg==}\n    engines: {node: '>=10'}\n\n  loose-envify@1.4.0:\n    resolution: {integrity: sha512-lyuxPGr/Wfhrlem2CL/UcnUc1zcqKAImBDzukY7Y5F/yQiNdko6+fRLevlw1HgMySw7f611UIY408EtxRSoK3Q==}\n    hasBin: true\n\n  lru-cache@4.1.5:\n    resolution: {integrity: sha512-sWZlbEP2OsHNkXrMl5GYk/jKk70MBng6UU4YI/qGDYbgf6YbP4EvmqISbXCoJiRKs+1bSpFHVgQxvJ17F2li5g==}\n\n  lru-cache@5.1.1:\n    resolution: {integrity: sha512-KpNARQA3Iwv+jTA0utUVVbrh+Jlrr1Fv0e56GGzAFOXN7dk/FviaDW8LHmK52DlcH4WP2n6gI8vN1aesBFgo9w==}\n\n  make-dir@4.0.0:\n    resolution: {integrity: sha512-hXdUTZYIVOt1Ex//jAQi+wTZZpUpwBj/0QsOzqegb3rGMMeJiSEu5xLHnYfBrRV4RH2+OCSOO95Is/7x1WJ4bw==}\n    engines: {node: '>=10'}\n\n  makeerror@1.0.12:\n    resolution: {integrity: sha512-JmqCvUhmt43madlpFzG4BQzG2Z3m6tvQDNKdClZnO3VbIudJYmxsT0FNJMeiB2+JTSlTQTSbU8QdesVmwJcmLg==}\n\n  map-cache@0.2.2:\n    resolution: {integrity: sha512-8y/eV9QQZCiyn1SprXSrCmqJN0yNRATe+PO8ztwqrvrbdRLA3eYJF0yaR0YayLWkMbsQSKWS9N2gPcGEc4UsZg==}\n    engines: {node: '>=0.10.0'}\n\n  map-visit@1.0.0:\n    resolution: {integrity: sha512-4y7uGv8bd2WdM9vpQsiQNo41Ln1NvhvDRuVt0k2JZQ+ezN2uaQes7lZeZ+QQUHOLQAtDaBJ+7wCbi+ab/KFs+w==}\n    engines: {node: '>=0.10.0'}\n\n  math-intrinsics@1.0.0:\n    resolution: {integrity: sha512-4MqMiKP90ybymYvsut0CH2g4XWbfLtmlCkXmtmdcDCxNB+mQcu1w/1+L/VD7vi/PSv7X2JYV7SCcR+jiPXnQtA==}\n    engines: {node: '>= 0.4'}\n\n  md5.js@1.3.5:\n    resolution: {integrity: sha512-xitP+WxNPcTTOgnTJcrhM0xvdPepipPSf3I8EIpGKeFLjt3PlJLIDG3u8EX53ZIubkb+5U2+3rELYpEhHhzdkg==}\n\n  memoize-one@5.2.1:\n    resolution: {integrity: sha512-zYiwtZUcYyXKo/np96AGZAckk+FWWsUdJ3cHGGmld7+AhvcWmQyGCYUh1hc4Q/pkOhb65dQR/pqCyK0cOaHz4Q==}\n\n  merge-stream@2.0.0:\n    resolution: {integrity: sha512-abv/qOcuPfk3URPfDzmZU1LKmuw8kT+0nIHvKrKgFrwifol/doWcdA4ZqsWQ8ENrFKkd67Mfpo/LovbIUsbt3w==}\n\n  micromatch@3.1.10:\n    resolution: {integrity: sha512-MWikgl9n9M3w+bpsY3He8L+w9eF9338xRl8IAO5viDizwSzziFEyUzo2xrrloB64ADbTf8uA8vRqqttDTOmccg==}\n    engines: {node: '>=0.10.0'}\n\n  micromatch@4.0.8:\n    resolution: {integrity: sha512-PXwfBhYu0hBCPw8Dn0E+WDYb7af3dSLVWKi3HGv84IdF4TyFoC0ysxFd0Goxw7nSv4T/PzEJQxsYsEiFCKo2BA==}\n    engines: {node: '>=8.6'}\n\n  miller-rabin@4.0.1:\n    resolution: {integrity: sha512-115fLhvZVqWwHPbClyntxEVfVDfl9DLLTuJvq3g2O/Oxi8AiNouAHvDSzHS0viUJc+V5vm3eq91Xwqn9dp4jRA==}\n    hasBin: true\n\n  mime-db@1.52.0:\n    resolution: {integrity: sha512-sPU4uV7dYlvtWJxwwxHD0PuihVNiE7TyAbQ5SWxDCB9mUYvOgroQOwYQQOKPJ8CIbE+1ETVlOoK1UC2nU3gYvg==}\n    engines: {node: '>= 0.6'}\n\n  mime-types@2.1.35:\n    resolution: {integrity: sha512-ZDY+bPm5zTTF+YpCrAU9nK0UgICYPT0QtT1NZWFv4s++TNkcgVaT0g6+4R2uI4MjQjzysHB1zxuWL50hzaeXiw==}\n    engines: {node: '>= 0.6'}\n\n  mime@1.4.1:\n    resolution: {integrity: sha512-KI1+qOZu5DcW6wayYHSzR/tXKCDC5Om4s1z2QJjDULzLcmf3DvzS7oluY4HCTrc+9FiKmWUgeNLg7W3uIQvxtQ==}\n    hasBin: true\n\n  mimic-fn@2.1.0:\n    resolution: {integrity: sha512-OqbOk5oEQeAZ8WXWydlu9HJjz9WVdEIvamMCcXmuqUYjTknH/sqsWvhQ3vgwKFRR1HpjvNBKQ37nbJgYzGqGcg==}\n    engines: {node: '>=6'}\n\n  min-document@2.19.0:\n    resolution: {integrity: sha512-9Wy1B3m3f66bPPmU5hdA4DR4PB2OfDU/+GS3yAB7IQozE3tqXaVv2zOjgla7MEGSRv95+ILmOuvhLkOK6wJtCQ==}\n\n  mini-create-react-context@0.4.1:\n    resolution: {integrity: sha512-YWCYEmd5CQeHGSAKrYvXgmzzkrvssZcuuQDDeqkT+PziKGMgE+0MCCtcKbROzocGBG1meBLl2FotlRwf4gAzbQ==}\n    deprecated: Package no longer supported. Contact Support at https://www.npmjs.com/support for more info.\n    peerDependencies:\n      prop-types: ^15.0.0\n      react: ^0.14.0 || ^15.0.0 || ^16.0.0 || ^17.0.0\n\n  minimalistic-assert@1.0.1:\n    resolution: {integrity: sha512-UtJcAD4yEaGtjPezWuO9wC4nwUnVH/8/Im3yEHQP4b67cXlD/Qr9hdITCU1xDbSEXg2XKNaP8jsReV7vQd00/A==}\n\n  minimalistic-crypto-utils@1.0.1:\n    resolution: {integrity: sha512-JIYlbt6g8i5jKfJ3xz7rF0LXmv2TkDxBLUkiBeZ7bAx4GnnNMr8xFpGnOxn6GhTEHx3SjRrZEoU+j04prX1ktg==}\n\n  minimatch@3.1.2:\n    resolution: {integrity: sha512-J7p63hRiAjw1NDEww1W7i37+ByIrOWO5XQQAzZ3VOcL0PNybwpfmV/N05zFAzwQ9USyEcX6t3UO+K5aqBQOIHw==}\n\n  minimist@1.2.8:\n    resolution: {integrity: sha512-2yyAR8qBkN3YuheJanUpWC5U3bb5osDywNB8RzDVlDwDHbocAJveqqj1u8+SVD7jkWT4yvsHCpWqqWqAxb0zCA==}\n\n  mixin-deep@1.3.2:\n    resolution: {integrity: sha512-WRoDn//mXBiJ1H40rqa3vH0toePwSsGb45iInWlTySa+Uu4k3tYUSxa2v1KqAiLtvlrSzaExqS1gtk96A9zvEA==}\n    engines: {node: '>=0.10.0'}\n\n  moment@2.30.1:\n    resolution: {integrity: sha512-uEmtNhbDOrWPFS+hdjFCBfy9f2YoyzRpwcl+DqpC6taX21FzsTLQVbMV/W7PzNSX6x/bhC1zA3c2UQ5NzH6how==}\n\n  ms@2.0.0:\n    resolution: {integrity: sha512-Tpp60P6IUJDTuOq/5Z8cdskzJujfwqfOTkrwIwj7IRISpnkJnT6SyJ4PCPnGMoFjC9ddhal5KVIYtAt97ix05A==}\n\n  ms@2.1.3:\n    resolution: {integrity: sha512-6FlzubTLZG3J2a/NVCAleEhjzq5oxgHyaCU9yYXvcLsvoVaHJq/s5xXI6/XXP6tz7R9xAOtHnSO/tXtF3WRTlA==}\n\n  nanomatch@1.2.13:\n    resolution: {integrity: sha512-fpoe2T0RbHwBTBUOftAfBPaDEi06ufaUai0mE6Yn1kacc3SnTErfb/h+X94VXzI64rKFHYImXSvdwGGCmwOqCA==}\n    engines: {node: '>=0.10.0'}\n\n  natural-compare@1.4.0:\n    resolution: {integrity: sha512-OWND8ei3VtNC9h7V60qff3SVobHr996CTwgxubgyQYEpg290h9J0buyECNNJexkFm5sOajh5G116RYA1c8ZMSw==}\n\n  nice-try@1.0.5:\n    resolution: {integrity: sha512-1nh45deeb5olNY7eX82BkPO7SSxR5SSYJiPTrTdFUVYwAl8CKMA5N9PjTYkHiRjisVcxcQ1HXdLhx2qxxJzLNQ==}\n\n  node-fetch@1.7.3:\n    resolution: {integrity: sha512-NhZ4CsKx7cYm2vSrBAr2PvFOe6sWDf0UYLRqA6svUYg7+/TSfVAu49jYC4BvQ4Sms9SZgdqGBgroqfDhJdTyKQ==}\n\n  node-int64@0.4.0:\n    resolution: {integrity: sha512-O5lz91xSOeoXP6DulyHfllpq+Eg00MWitZIbtPfoSEvqIHdl5gfcY6hYzDWnj0qD5tz52PI08u9qUvSVeUBeHw==}\n\n  node-libs-browser@2.2.1:\n    resolution: {integrity: sha512-h/zcD8H9kaDZ9ALUWwlBUDo6TKF8a7qBSCSEGfjTVIYeqsioSKaAX+BN7NgiMGp6iSIXZ3PxgCu8KS3b71YK5Q==}\n\n  node-notifier@8.0.2:\n    resolution: {integrity: sha512-oJP/9NAdd9+x2Q+rfphB2RJCHjod70RcRLjosiPMMu5gjIfwVnOUGq2nbTjTUbmy0DJ/tFIVT30+Qe3nzl4TJg==}\n\n  node-releases@2.0.19:\n    resolution: {integrity: sha512-xxOWJsBKtzAq7DY0J+DTzuz58K8e7sJbdgwkbMWQe8UYB6ekmsQ45q0M/tJDsGaZmbC+l7n57UV8Hl5tHxO9uw==}\n\n  normalize-package-data@2.5.0:\n    resolution: {integrity: sha512-/5CMN3T0R4XTj4DcGaexo+roZSdSFW/0AOOTROrjxzCG1wrWXEsGbRKevjlIL+ZDE4sZlJr5ED4YW0yqmkK+eA==}\n\n  normalize-path@1.0.0:\n    resolution: {integrity: sha512-7WyT0w8jhpDStXRq5836AMmihQwq2nrUVQrgjvUo/p/NZf9uy/MeJ246lBJVmWuYXMlJuG9BNZHF0hWjfTbQUA==}\n    engines: {node: '>=0.10.0'}\n\n  normalize-path@2.1.1:\n    resolution: {integrity: sha512-3pKJwH184Xo/lnH6oyP1q2pMd7HcypqqmRs91/6/i2CGtWwIKGCkOOMTm/zXbgTEWHw1uNpNi/igc3ePOYHb6w==}\n    engines: {node: '>=0.10.0'}\n\n  normalize-path@3.0.0:\n    resolution: {integrity: sha512-6eZs5Ls3WtCisHWp9S2GUy8dqkpGi4BVSz3GaqiE6ezub0512ESztXUwUB6C6IKbQkY2Pnb/mD4WYojCRwcwLA==}\n    engines: {node: '>=0.10.0'}\n\n  normalize-range@0.1.2:\n    resolution: {integrity: sha512-bdok/XvKII3nUpklnV6P2hxtMNrCboOjAcyBuQnWEhO665FwrSNRxU+AqpsyvO6LgGYPspN+lu5CLtw4jPRKNA==}\n    engines: {node: '>=0.10.0'}\n\n  normalize-url@1.9.1:\n    resolution: {integrity: sha512-A48My/mtCklowHBlI8Fq2jFWK4tX4lJ5E6ytFsSOq1fzpvT0SQSgKhSg7lN5c2uYFOrUAOQp6zhhJnpp1eMloQ==}\n    engines: {node: '>=4'}\n\n  normalize.css@7.0.0:\n    resolution: {integrity: sha512-LYaFZxj2Q1Q9e1VJ0f6laG46Rt5s9URhKyckNaA2vZnL/0gwQHWhM7ALQkp3WBQKM5sXRLQ5Ehrfkp+E/ZiCRg==}\n\n  npm-run-path@2.0.2:\n    resolution: {integrity: sha512-lJxZYlT4DW/bRUtFh1MQIWqmLwQfAxnqWG4HhEdjMlkrJYnJn0Jrr2u3mgxqaWsdiBc76TYkTG/mhrnYTuzfHw==}\n    engines: {node: '>=4'}\n\n  npm-run-path@4.0.1:\n    resolution: {integrity: sha512-S48WzZW777zhNIrn7gxOlISNAqi9ZC/uQFnRdbeIHhZhCA6UqpkOT8T1G7BvfdgP4Er8gF4sUbaS0i7QvIfCWw==}\n    engines: {node: '>=8'}\n\n  num2fraction@1.2.2:\n    resolution: {integrity: sha512-Y1wZESM7VUThYY+4W+X4ySH2maqcA+p7UR+w8VWNWVAd6lwuXXWz/w/Cz43J/dI2I+PS6wD5N+bJUF+gjWvIqg==}\n\n  nwsapi@2.2.16:\n    resolution: {integrity: sha512-F1I/bimDpj3ncaNDhfyMWuFqmQDBwDB0Fogc2qpL3BWvkQteFD/8BzWuIRl83rq0DXfm8SGt/HFhLXZyljTXcQ==}\n\n  object-assign@4.1.1:\n    resolution: {integrity: sha512-rJgTQnkUnH1sFw8yT6VSU3zD3sWmu6sZhIseY8VX+GRu3P6F7Fu+JNDoXfklElbLJSnc3FUQHVe4cU5hj+BcUg==}\n    engines: {node: '>=0.10.0'}\n\n  object-copy@0.1.0:\n    resolution: {integrity: sha512-79LYn6VAb63zgtmAteVOWo9Vdj71ZVBy3Pbse+VqxDpEP83XuujMrGqHIwAXJ5I/aM0zU7dIyIAhifVTPrNItQ==}\n    engines: {node: '>=0.10.0'}\n\n  object-inspect@1.13.3:\n    resolution: {integrity: sha512-kDCGIbxkDSXE3euJZZXzc6to7fCrKHNI/hSRQnRuQ+BWjFNzZwiFF8fj/6o2t2G9/jTj8PSIYTfCLelLZEeRpA==}\n    engines: {node: '>= 0.4'}\n\n  object-keys@1.1.1:\n    resolution: {integrity: sha512-NuAESUOUMrlIXOfHKzD6bpPu3tYt3xvjNdRIQ+FeT0lNb4K8WR70CaDxhuNguS2XG+GjkyMwOzsN5ZktImfhLA==}\n    engines: {node: '>= 0.4'}\n\n  object-visit@1.0.1:\n    resolution: {integrity: sha512-GBaMwwAVK9qbQN3Scdo0OyvgPW7l3lnaVMj84uTOZlswkX0KpF6fyDBJhtTthf7pymztoN36/KEr1DyhF96zEA==}\n    engines: {node: '>=0.10.0'}\n\n  object.assign@4.1.5:\n    resolution: {integrity: sha512-byy+U7gp+FVwmyzKPYhW2h5l3crpmGsxl7X2s8y43IgxvG4g3QZ6CffDtsNQy1WsmZpQbO+ybo0AlW7TY6DcBQ==}\n    engines: {node: '>= 0.4'}\n\n  object.pick@1.3.0:\n    resolution: {integrity: sha512-tqa/UMy/CCoYmj+H5qc07qvSL9dqcs/WZENZ1JbtWBlATP+iVOe778gE6MSijnyCnORzDuX6hU+LA4SZ09YjFQ==}\n    engines: {node: '>=0.10.0'}\n\n  omit.js@2.0.2:\n    resolution: {integrity: sha512-hJmu9D+bNB40YpL9jYebQl4lsTW6yEHRTroJzNLqQJYHm7c+NQnJGfZmIWh8S3q3KoaxV1aLhV6B3+0N0/kyJg==}\n\n  once@1.4.0:\n    resolution: {integrity: sha512-lNaJgI+2Q5URQBkccEKHTQOPaXdUxnZZElQTZY0MFUAuaEqe1E+Nyvgdz/aIyNi6Z9MzO5dv1H8n58/GELp3+w==}\n\n  onetime@5.1.2:\n    resolution: {integrity: sha512-kbpaSSGJTWdAY5KPVeMOKXSrPtr8C8C7wodJbcsd51jRnmD+GZu8Y0VoU6Dm5Z4vWr0Ig/1NKuWRKf7j5aaYSg==}\n    engines: {node: '>=6'}\n\n  os-browserify@0.3.0:\n    resolution: {integrity: sha512-gjcpUc3clBf9+210TRaDWbf+rZZZEshZ+DlXMRCeAjp0xhTrnQsKHypIy1J3d5hKdUzj69t708EHtU8P6bUn0A==}\n\n  p-each-series@2.2.0:\n    resolution: {integrity: sha512-ycIL2+1V32th+8scbpTvyHNaHe02z0sjgh91XXjAk+ZeXoPN4Z46DVUnzdso0aX4KckKw0FNNFHdjZ2UsZvxiA==}\n    engines: {node: '>=8'}\n\n  p-finally@1.0.0:\n    resolution: {integrity: sha512-LICb2p9CB7FS+0eR1oqWnHhp0FljGLZCWBE9aix0Uye9W8LTQPwMTYVGWQWIw9RdQiDg4+epXQODwIYJtSJaow==}\n    engines: {node: '>=4'}\n\n  p-limit@2.3.0:\n    resolution: {integrity: sha512-//88mFWSJx8lxCzwdAABTJL2MyWB12+eIY7MDL2SqLmAkeKU9qxRvWuSyTjm3FUmpBEMuFfckAIqEaVGUDxb6w==}\n    engines: {node: '>=6'}\n\n  p-locate@4.1.0:\n    resolution: {integrity: sha512-R79ZZ/0wAxKGu3oYMlz8jy/kbhsNrS7SKZ7PxEHBgJ5+F2mtFW2fK2cOtBh1cHYkQsbzFV7I+EoRKe6Yt0oK7A==}\n    engines: {node: '>=8'}\n\n  p-map@4.0.0:\n    resolution: {integrity: sha512-/bjOqmgETBYB5BoEeGVea8dmvHb2m9GLy1E9W43yeyfP6QQCZGFNa+XRceJEuDB6zqr+gKpIAmlLebMpykw/MQ==}\n    engines: {node: '>=10'}\n\n  p-try@2.2.0:\n    resolution: {integrity: sha512-R4nPAVTAU0B9D35/Gk3uJf/7XYbQcyohSKdvAxIRSNghFl4e71hVoGnBNQz9cWaXxO2I10KTC+3jMdvvoKw6dQ==}\n    engines: {node: '>=6'}\n\n  pako@1.0.11:\n    resolution: {integrity: sha512-4hLB8Py4zZce5s4yd9XzopqwVv/yGNhV1Bl8NTmCq1763HeK2+EwVTv+leGeL13Dnh2wfbqowVPXCIO0z4taYw==}\n\n  parent-module@1.0.1:\n    resolution: {integrity: sha512-GQ2EWRpQV8/o+Aw8YqtfZZPfNRWZYkbidE9k5rpl/hC3vtHHBfGm2Ifi6qWV+coDGkrUKZAxE3Lot5kcsRlh+g==}\n    engines: {node: '>=6'}\n\n  parse-asn1@5.1.7:\n    resolution: {integrity: sha512-CTM5kuWR3sx9IFamcl5ErfPl6ea/N8IYwiJ+vpeB2g+1iknv7zBl5uPwbMbRVznRVbrNY6lGuDoE5b30grmbqg==}\n    engines: {node: '>= 0.10'}\n\n  parse-json@4.0.0:\n    resolution: {integrity: sha512-aOIos8bujGN93/8Ox/jPLh7RwVnPEysynVFE+fQZyg6jKELEHwzgKdLRFHUgXJL6kylijVSBC4BvN9OmsB48Rw==}\n    engines: {node: '>=4'}\n\n  parse-json@5.2.0:\n    resolution: {integrity: sha512-ayCKvm/phCGxOkYRSCM82iDwct8/EonSEgCSxWxD7ve6jHggsFl4fZVQBPRNgQoKiuV/odhFrGzQXZwbifC8Rg==}\n    engines: {node: '>=8'}\n\n  parse5@6.0.1:\n    resolution: {integrity: sha512-Ofn/CTFzRGTTxwpNEs9PP93gXShHcTq255nzRYSKe8AkVpZY7e1fpmTfOyoIvjP5HG7Z2ZM7VS9PPhQGW2pOpw==}\n\n  pascalcase@0.1.1:\n    resolution: {integrity: sha512-XHXfu/yOQRy9vYOtUDVMN60OEJjW013GoObG1o+xwQTpB9eYJX/BjXMsdW13ZDPruFhYYn0AG22w0xgQMwl3Nw==}\n    engines: {node: '>=0.10.0'}\n\n  path-browserify@0.0.1:\n    resolution: {integrity: sha512-BapA40NHICOS+USX9SN4tyhq+A2RrN/Ws5F0Z5aMHDp98Fl86lX8Oti8B7uN93L4Ifv4fHOEA+pQw87gmMO/lQ==}\n\n  path-exists@4.0.0:\n    resolution: {integrity: sha512-ak9Qy5Q7jYb2Wwcey5Fpvg2KoAc/ZIhLSLOSBmRmygPsGwkVVt0fZa0qrtMz+m6tJTAHfZQ8FnmB4MG4LWy7/w==}\n    engines: {node: '>=8'}\n\n  path-is-absolute@1.0.1:\n    resolution: {integrity: sha512-AVbw3UJ2e9bq64vSaS9Am0fje1Pa8pbGqTTsmXfaIiMpnr5DlDhfJOuLj9Sf95ZPVDAUerDfEk88MPmPe7UCQg==}\n    engines: {node: '>=0.10.0'}\n\n  path-key@2.0.1:\n    resolution: {integrity: sha512-fEHGKCSmUSDPv4uoj8AlD+joPlq3peND+HRYyxFz4KPw4z926S/b8rIuFs2FYJg3BwsxJf6A9/3eIdLaYC+9Dw==}\n    engines: {node: '>=4'}\n\n  path-key@3.1.1:\n    resolution: {integrity: sha512-ojmeN0qd+y0jszEtoY48r0Peq5dwMEkIlCOu6Q5f41lfkswXuKtYrhgoTpLnyIcHm24Uhqx+5Tqm2InSwLhE6Q==}\n    engines: {node: '>=8'}\n\n  path-parse@1.0.7:\n    resolution: {integrity: sha512-LDJzPVEEEPR+y48z93A0Ed0yXb8pAByGWo/k5YYdYgpY2/2EsOsksJrq7lOHxryrVOn1ejG6oAp8ahvOIQD8sw==}\n\n  path-to-regexp@1.9.0:\n    resolution: {integrity: sha512-xIp7/apCFJuUHdDLWe8O1HIkb0kQrOMb/0u6FXQjemHn/ii5LrIzU6bdECnsiTF/GjZkMEKg1xdiZwNqDYlZ6g==}\n\n  path-to-regexp@2.4.0:\n    resolution: {integrity: sha512-G6zHoVqC6GGTQkZwF4lkuEyMbVOjoBKAEybQUypI1WTkqinCOrq2x6U2+phkJ1XsEMTy4LjtwPI7HW+NVrRR2w==}\n\n  path-type@4.0.0:\n    resolution: {integrity: sha512-gDKb8aZMDeD/tZWs9P6+q0J9Mwkdl6xMV8TjnGP3qJVJ06bdMgkbBlLU8IdfOsIsFz2BW1rNVT3XuNEl8zPAvw==}\n    engines: {node: '>=8'}\n\n  pbkdf2@3.1.2:\n    resolution: {integrity: sha512-iuh7L6jA7JEGu2WxDwtQP1ddOpaJNC4KlDEFfdQajSGgGPNi4OyDc2R7QnbY2bR9QjBVGwgvTdNJZoE7RaxUMA==}\n    engines: {node: '>=0.12'}\n\n  performance-now@2.1.0:\n    resolution: {integrity: sha512-7EAHlyLHI56VEIdK57uwHdHKIaAGbnXPiw0yWbarQZOKaKpvUIgW0jWRVLiatnM+XXlSwsanIBH/hzGMJulMow==}\n\n  picocolors@0.2.1:\n    resolution: {integrity: sha512-cMlDqaLEqfSaW8Z7N5Jw+lyIW869EzT73/F5lhtY9cLGoVxSXznfgfXMO0Z5K0o0Q2TkTXq+0KFsdnSe3jDViA==}\n\n  picocolors@1.1.1:\n    resolution: {integrity: sha512-xceH2snhtb5M9liqDsmEw56le376mTZkEX/jEb/RxNFyegNul7eNslCXP9FDj/Lcu0X8KEyMceP2ntpaHrDEVA==}\n\n  picomatch@2.3.1:\n    resolution: {integrity: sha512-JU3teHTNjmE2VCGFzuY8EXzCDVwEqB2a8fsIvwaStHhAWJEeVd1o1QD80CU6+ZdEXXSLbSsuLwJjkCBWqRQUVA==}\n    engines: {node: '>=8.6'}\n\n  pirates@4.0.6:\n    resolution: {integrity: sha512-saLsH7WeYYPiD25LDuLRRY/i+6HaPYr6G1OUlN39otzkSTxKnubR9RTxS3/Kk50s1g2JTgFwWQDQyplC5/SHZg==}\n    engines: {node: '>= 6'}\n\n  pkg-dir@4.2.0:\n    resolution: {integrity: sha512-HRDzbaKjC+AOWVXxAU/x54COGeIv9eb+6CkDSQoNTt4XyWoIJvuPsXizxu/Fr23EiekbtZwmh1IcIG/l/a10GQ==}\n    engines: {node: '>=8'}\n\n  please-upgrade-node@3.2.0:\n    resolution: {integrity: sha512-gQR3WpIgNIKwBMVLkpMUeR3e1/E1y42bqDQZfql+kDeXd8COYfM8PQA4X6y7a8u9Ua9FHmsrrmirW2vHs45hWg==}\n\n  posix-character-classes@0.1.1:\n    resolution: {integrity: sha512-xTgYBc3fuo7Yt7JbiuFxSYGToMoz8fLoE6TC9Wx1P/u+LfeThMOAqmuyECnlBaaJb+u1m9hHiXUEtwW4OzfUJg==}\n    engines: {node: '>=0.10.0'}\n\n  postcss-attribute-case-insensitive@4.0.2:\n    resolution: {integrity: sha512-clkFxk/9pcdb4Vkn0hAHq3YnxBQ2p0CGD1dy24jN+reBck+EWxMbxSUqN4Yj7t0w8csl87K6p0gxBe1utkJsYA==}\n\n  postcss-color-functional-notation@2.0.1:\n    resolution: {integrity: sha512-ZBARCypjEDofW4P6IdPVTLhDNXPRn8T2s1zHbZidW6rPaaZvcnCS2soYFIQJrMZSxiePJ2XIYTlcb2ztr/eT2g==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-color-gray@5.0.0:\n    resolution: {integrity: sha512-q6BuRnAGKM/ZRpfDascZlIZPjvwsRye7UDNalqVz3s7GDxMtqPY6+Q871liNxsonUw8oC61OG+PSaysYpl1bnw==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-color-hex-alpha@5.0.3:\n    resolution: {integrity: sha512-PF4GDel8q3kkreVXKLAGNpHKilXsZ6xuu+mOQMHWHLPNyjiUBOr75sp5ZKJfmv1MCus5/DWUGcK9hm6qHEnXYw==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-color-mod-function@3.0.3:\n    resolution: {integrity: sha512-YP4VG+xufxaVtzV6ZmhEtc+/aTXH3d0JLpnYfxqTvwZPbJhWqp8bSY3nfNzNRFLgB4XSaBA82OE4VjOOKpCdVQ==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-color-rebeccapurple@4.0.1:\n    resolution: {integrity: sha512-aAe3OhkS6qJXBbqzvZth2Au4V3KieR5sRQ4ptb2b2O8wgvB3SJBsdG+jsn2BZbbwekDG8nTfcCNKcSfe/lEy8g==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-custom-media@7.0.8:\n    resolution: {integrity: sha512-c9s5iX0Ge15o00HKbuRuTqNndsJUbaXdiNsksnVH8H4gdc+zbLzr/UasOwNG6CTDpLFekVY4672eWdiiWu2GUg==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-custom-properties@8.0.11:\n    resolution: {integrity: sha512-nm+o0eLdYqdnJ5abAJeXp4CEU1c1k+eB2yMCvhgzsds/e0umabFrN6HoTy/8Q4K5ilxERdl/JD1LO5ANoYBeMA==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-custom-selectors@5.1.2:\n    resolution: {integrity: sha512-DSGDhqinCqXqlS4R7KGxL1OSycd1lydugJ1ky4iRXPHdBRiozyMHrdu0H3o7qNOCiZwySZTUI5MV0T8QhCLu+w==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-dir-pseudo-class@5.0.0:\n    resolution: {integrity: sha512-3pm4oq8HYWMZePJY+5ANriPs3P07q+LW6FAdTlkFH2XqDdP4HeeJYMOzn0HYLhRSjBO3fhiqSwwU9xEULSrPgw==}\n    engines: {node: '>=4.0.0'}\n\n  postcss-double-position-gradients@1.0.0:\n    resolution: {integrity: sha512-G+nV8EnQq25fOI8CH/B6krEohGWnF5+3A6H/+JEpOncu5dCnkS1QQ6+ct3Jkaepw1NGVqqOZH6lqrm244mCftA==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-env-function@2.0.2:\n    resolution: {integrity: sha512-rwac4BuZlITeUbiBq60h/xbLzXY43qOsIErngWa4l7Mt+RaSkT7QBjXVGTcBHupykkblHMDrBFh30zchYPaOUw==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-flexbugs-fixes@4.2.1:\n    resolution: {integrity: sha512-9SiofaZ9CWpQWxOwRh1b/r85KD5y7GgvsNt1056k6OYLvWUun0czCvogfJgylC22uJTwW1KzY3Gz65NZRlvoiQ==}\n\n  postcss-focus-visible@4.0.0:\n    resolution: {integrity: sha512-Z5CkWBw0+idJHSV6+Bgf2peDOFf/x4o+vX/pwcNYrWpXFrSfTkQ3JQ1ojrq9yS+upnAlNRHeg8uEwFTgorjI8g==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-focus-within@3.0.0:\n    resolution: {integrity: sha512-W0APui8jQeBKbCGZudW37EeMCjDeVxKgiYfIIEo8Bdh5SpB9sxds/Iq8SEuzS0Q4YFOlG7EPFulbbxujpkrV2w==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-font-variant@4.0.1:\n    resolution: {integrity: sha512-I3ADQSTNtLTTd8uxZhtSOrTCQ9G4qUVKPjHiDk0bV75QSxXjVWiJVJ2VLdspGUi9fbW9BcjKJoRvxAH1pckqmA==}\n\n  postcss-gap-properties@2.0.0:\n    resolution: {integrity: sha512-QZSqDaMgXCHuHTEzMsS2KfVDOq7ZFiknSpkrPJY6jmxbugUPTuSzs/vuE5I3zv0WAS+3vhrlqhijiprnuQfzmg==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-image-set-function@3.0.1:\n    resolution: {integrity: sha512-oPTcFFip5LZy8Y/whto91L9xdRHCWEMs3e1MdJxhgt4jy2WYXfhkng59fH5qLXSCPN8k4n94p1Czrfe5IOkKUw==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-initial@3.0.4:\n    resolution: {integrity: sha512-3RLn6DIpMsK1l5UUy9jxQvoDeUN4gP939tDcKUHD/kM8SGSKbFAnvkpFpj3Bhtz3HGk1jWY5ZNWX6mPta5M9fg==}\n\n  postcss-lab-function@2.0.1:\n    resolution: {integrity: sha512-whLy1IeZKY+3fYdqQFuDBf8Auw+qFuVnChWjmxm/UhHWqNHZx+B99EwxTvGYmUBqe3Fjxs4L1BoZTJmPu6usVg==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-load-config@2.1.2:\n    resolution: {integrity: sha512-/rDeGV6vMUo3mwJZmeHfEDvwnTKKqQ0S7OHUi/kJvvtx3aWtyWG2/0ZWnzCt2keEclwN6Tf0DST2v9kITdOKYw==}\n    engines: {node: '>= 4'}\n\n  postcss-loader@3.0.0:\n    resolution: {integrity: sha512-cLWoDEY5OwHcAjDnkyRQzAXfs2jrKjXpO/HQFcc5b5u/r7aa471wdmChmwfnv7x2u840iat/wi0lQ5nbRgSkUA==}\n    engines: {node: '>= 6'}\n\n  postcss-logical@3.0.0:\n    resolution: {integrity: sha512-1SUKdJc2vuMOmeItqGuNaC+N8MzBWFWEkAnRnLpFYj1tGGa7NqyVBujfRtgNa2gXR+6RkGUiB2O5Vmh7E2RmiA==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-media-minmax@4.0.0:\n    resolution: {integrity: sha512-fo9moya6qyxsjbFAYl97qKO9gyre3qvbMnkOZeZwlsW6XYFsvs2DMGDlchVLfAd8LHPZDxivu/+qW2SMQeTHBw==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-nesting@7.0.1:\n    resolution: {integrity: sha512-FrorPb0H3nuVq0Sff7W2rnc3SmIcruVC6YwpcS+k687VxyxO33iE1amna7wHuRVzM8vfiYofXSBHNAZ3QhLvYg==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-overflow-shorthand@2.0.0:\n    resolution: {integrity: sha512-aK0fHc9CBNx8jbzMYhshZcEv8LtYnBIRYQD5i7w/K/wS9c2+0NSR6B3OVMu5y0hBHYLcMGjfU+dmWYNKH0I85g==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-page-break@2.0.0:\n    resolution: {integrity: sha512-tkpTSrLpfLfD9HvgOlJuigLuk39wVTbbd8RKcy8/ugV2bNBUW3xU+AIqyxhDrQr1VUj1RmyJrBn1YWrqUm9zAQ==}\n\n  postcss-place@4.0.1:\n    resolution: {integrity: sha512-Zb6byCSLkgRKLODj/5mQugyuj9bvAAw9LqJJjgwz5cYryGeXfFZfSXoP1UfveccFmeq0b/2xxwcTEVScnqGxBg==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-preset-env@6.7.0:\n    resolution: {integrity: sha512-eU4/K5xzSFwUFJ8hTdTQzo2RBLbDVt83QZrAvI07TULOkmyQlnYlpwep+2yIK+K+0KlZO4BvFcleOCCcUtwchg==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-pseudo-class-any-link@6.0.0:\n    resolution: {integrity: sha512-lgXW9sYJdLqtmw23otOzrtbDXofUdfYzNm4PIpNE322/swES3VU9XlXHeJS46zT2onFO7V1QFdD4Q9LiZj8mew==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-replace-overflow-wrap@3.0.0:\n    resolution: {integrity: sha512-2T5hcEHArDT6X9+9dVSPQdo7QHzG4XKclFT8rU5TzJPDN7RIRTbO9c4drUISOVemLj03aezStHCR2AIcr8XLpw==}\n\n  postcss-safe-parser@4.0.2:\n    resolution: {integrity: sha512-Uw6ekxSWNLCPesSv/cmqf2bY/77z11O7jZGPax3ycZMFU/oi2DMH9i89AdHc1tRwFg/arFoEwX0IS3LCUxJh1g==}\n    engines: {node: '>=6.0.0'}\n\n  postcss-selector-matches@4.0.0:\n    resolution: {integrity: sha512-LgsHwQR/EsRYSqlwdGzeaPKVT0Ml7LAT6E75T8W8xLJY62CE4S/l03BWIt3jT8Taq22kXP08s2SfTSzaraoPww==}\n\n  postcss-selector-not@4.0.1:\n    resolution: {integrity: sha512-YolvBgInEK5/79C+bdFMyzqTg6pkYqDbzZIST/PDMqa/o3qtXenD05apBG2jLgT0/BQ77d4U2UK12jWpilqMAQ==}\n\n  postcss-selector-parser@5.0.0:\n    resolution: {integrity: sha512-w+zLE5Jhg6Liz8+rQOWEAwtwkyqpfnmsinXjXg6cY7YIONZZtgvE0v2O0uhQBs0peNomOJwWRKt6JBfTdTd3OQ==}\n    engines: {node: '>=4'}\n\n  postcss-selector-parser@6.1.2:\n    resolution: {integrity: sha512-Q8qQfPiZ+THO/3ZrOrO0cJJKfpYCagtMUkXbnEfmgUjwXg6z/WBeOyS9APBBPCTSiDV+s4SwQGu8yFsiMRIudg==}\n    engines: {node: '>=4'}\n\n  postcss-value-parser@4.2.0:\n    resolution: {integrity: sha512-1NNCs6uurfkVbeXG4S8JFT9t19m45ICnif8zWLd5oPSZ50QnwMfK+H3jv408d4jw/7Bttv5axS5IiHoLaVNHeQ==}\n\n  postcss-values-parser@2.0.1:\n    resolution: {integrity: sha512-2tLuBsA6P4rYTNKCXYG/71C7j1pU6pK503suYOmn4xYrQIzW+opD+7FAFNuGSdZC/3Qfy334QbeMu7MEb8gOxg==}\n    engines: {node: '>=6.14.4'}\n\n  postcss@7.0.32:\n    resolution: {integrity: sha512-03eXong5NLnNCD05xscnGKGDZ98CyzoqPSMjOe6SuoQY7Z2hIj0Ld1g/O/UQRuOle2aRtiIRDg9tDcTGAkLfKw==}\n    engines: {node: '>=6.0.0'}\n\n  prepend-http@1.0.4:\n    resolution: {integrity: sha512-PhmXi5XmoyKw1Un4E+opM2KcsJInDvKyuOumcjjw3waw86ZNjHwVUOOWLc4bCzLdcKNaWBH9e99sbWzDQsVaYg==}\n    engines: {node: '>=0.10.0'}\n\n  prettier@2.2.1:\n    resolution: {integrity: sha512-PqyhM2yCjg/oKkFPtTGUojv7gnZAoG80ttl45O6x2Ug/rMJw4wcc9k6aaf2hibP7BGVCCM33gZoGjyvt9mm16Q==}\n    engines: {node: '>=10.13.0'}\n    hasBin: true\n\n  prettier@2.8.8:\n    resolution: {integrity: sha512-tdN8qQGvNjw4CHbY+XXk0JgCXn9QiF21a55rBe5LJAU+kDyC4WQn4+awm2Xfk2lQMk5fKup9XgzTZtGkjBdP9Q==}\n    engines: {node: '>=10.13.0'}\n    hasBin: true\n\n  pretty-format@26.6.2:\n    resolution: {integrity: sha512-7AeGuCYNGmycyQbCqd/3PWH4eOoX/OiCa0uphp57NVTeAGdJGaAliecxwBDHYQCIvrW7aDBZCYeNTP/WX69mkg==}\n    engines: {node: '>= 10'}\n\n  process-nextick-args@2.0.1:\n    resolution: {integrity: sha512-3ouUOpQhtgrbOa17J7+uxOTpITYWaGP7/AhoR3+A+/1e9skrzelGi/dXzEYyvbxubEF6Wn2ypscTKiKJFFn1ag==}\n\n  process@0.11.10:\n    resolution: {integrity: sha512-cdGef/drWFoydD1JsMzuFf8100nZl+GT+yacc2bEced5f9Rjk4z+WtFUTBu9PhOi9j/jfmBPu0mMEY4wIdAF8A==}\n    engines: {node: '>= 0.6.0'}\n\n  promise@7.3.1:\n    resolution: {integrity: sha512-nolQXZ/4L+bP/UGlkfaIujX9BKxGwmQ9OT4mOt5yvy8iK1h3wqTEJCijzGANTCCl9nWjY41juyAn2K3Q1hLLTg==}\n\n  prompts@2.4.2:\n    resolution: {integrity: sha512-NxNv/kLguCA7p3jE8oL2aEBsrJWgAakBpgmgK6lpPWV+WuOmY6r2/zbAVnP+T8bQlA0nzHXSJSJW0Hq7ylaD2Q==}\n    engines: {node: '>= 6'}\n\n  prop-types@15.8.1:\n    resolution: {integrity: sha512-oj87CgZICdulUohogVAR7AjlC0327U4el4L6eAvOqCeudMDVU0NThNaV+b9Df4dXgSP1gXMTnPdhfe/2qDH5cg==}\n\n  pseudomap@1.0.2:\n    resolution: {integrity: sha512-b/YwNhb8lk1Zz2+bXXpS/LK9OisiZZ1SNsSLxN1x2OXVEhW2Ckr/7mWE5vrC1ZTiJlD9g19jWszTmJsB+oEpFQ==}\n\n  psl@1.15.0:\n    resolution: {integrity: sha512-JZd3gMVBAVQkSs6HdNZo9Sdo0LNcQeMNP3CozBJb3JYC/QUYZTnKxP+f8oWRX4rHP5EurWxqAHTSwUCjlNKa1w==}\n\n  public-encrypt@4.0.3:\n    resolution: {integrity: sha512-zVpa8oKZSz5bTMTFClc1fQOnyyEzpl5ozpi1B5YcvBrdohMjH2rfsBtyXcuNuwjsDIXmBYlF2N5FlJYhR29t8Q==}\n\n  pump@3.0.2:\n    resolution: {integrity: sha512-tUPXtzlGM8FE3P0ZL6DVs/3P58k9nk8/jZeQCurTJylQA8qFYzHFfhBJkuqyE0FifOsQ0uKWekiZ5g8wtr28cw==}\n\n  punycode@1.4.1:\n    resolution: {integrity: sha512-jmYNElW7yvO7TV33CjSmvSiE2yco3bV2czu/OzDKdMNVZQWfxCblURLhf+47syQRBntjfLdd/H0egrzIG+oaFQ==}\n\n  punycode@2.3.1:\n    resolution: {integrity: sha512-vYt7UD1U9Wg6138shLtLOvdAu+8DsC/ilFtEVHcH+wydcSpNE20AfSOduf6MkRFahL5FY7X1oU7nKVZFtfq8Fg==}\n    engines: {node: '>=6'}\n\n  qs@6.13.1:\n    resolution: {integrity: sha512-EJPeIn0CYrGu+hli1xilKAPXODtJ12T0sP63Ijx2/khC2JtuaN3JyNIpvmnkmaEtha9ocbG4A4cMcr+TvqvwQg==}\n    engines: {node: '>=0.6'}\n\n  query-string@4.3.4:\n    resolution: {integrity: sha512-O2XLNDBIg1DnTOa+2XrIwSiXEV8h2KImXUnjhhn2+UsvZ+Es2uyd5CCRTNQlDGbzUQOW3aYCBx9rVA6dzsiY7Q==}\n    engines: {node: '>=0.10.0'}\n\n  query-string@6.14.1:\n    resolution: {integrity: sha512-XDxAeVmpfu1/6IjyT/gXHOl+S0vQ9owggJ30hhWKdHAsNPOcasn5o9BW0eejZqL2e4vMjhAxoW3jVHcD6mbcYw==}\n    engines: {node: '>=6'}\n\n  querystring-es3@0.2.1:\n    resolution: {integrity: sha512-773xhDQnZBMFobEiztv8LIl70ch5MSF/jUQVlhwFyBILqq96anmoctVIYz+ZRp0qbCKATTn6ev02M3r7Ga5vqA==}\n    engines: {node: '>=0.4.x'}\n\n  querystringify@2.2.0:\n    resolution: {integrity: sha512-FIqgj2EUvTa7R50u0rGsyTftzjYmv/a3hO345bZNrqabNqjtgiDMgmo4mkUjd+nzU5oF3dClKqFIPUKybUyqoQ==}\n\n  raf@3.4.1:\n    resolution: {integrity: sha512-Sq4CW4QhwOHE8ucn6J34MqtZCeWFP2aQSmrlroYgqAV1PjStIhJXxYuTgUIfkEk7zTLjmIjLmU5q+fbD1NnOJA==}\n\n  randombytes@2.1.0:\n    resolution: {integrity: sha512-vYl3iOX+4CKUWuxGi9Ukhie6fsqXqS9FE2Zaic4tNFD2N2QQaXOMFbuKK4QmDHC0JO6B1Zp41J0LpT0oR68amQ==}\n\n  randomfill@1.0.4:\n    resolution: {integrity: sha512-87lcbR8+MhcWcUiQ+9e+Rwx8MyR2P7qnt15ynUlbm3TU/fjbgz4GsvfSUDTemtCCtVCqb4ZcEFlyPNTh9bBTLw==}\n\n  rc-align@2.4.5:\n    resolution: {integrity: sha512-nv9wYUYdfyfK+qskThf4BQUSIadeI/dCsfaMZfNEoxm9HwOIioQ+LyqmMK6jWHAZQgOzMLaqawhuBXlF63vgjw==}\n\n  rc-align@4.0.15:\n    resolution: {integrity: sha512-wqJtVH60pka/nOX7/IspElA8gjPNQKIx/ZqJ6heATCkXpe1Zg4cPVrMD2vC96wjsFFL8WsmhPbx9tdMo1qqlIA==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-animate@2.11.1:\n    resolution: {integrity: sha512-1NyuCGFJG/0Y+9RKh5y/i/AalUCA51opyyS/jO2seELpgymZm2u9QV3xwODwEuzkmeQ1BDPxMLmYLcTJedPlkQ==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-cascader@3.7.3:\n    resolution: {integrity: sha512-KBpT+kzhxDW+hxPiNk4zaKa99+Lie2/8nnI11XF+FIOPl4Bj9VlFZi61GrnWzhLGA7VEN+dTxAkNOjkySDa0dA==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-checkbox@2.0.3:\n    resolution: {integrity: sha512-sSDV5AcxK5CxBTyUNj9pb0zfhdgLLsWKHwJG18ikeGoIwklcxXvIF6cI/KGVbPLFDa8mPS5WLOlLRqbq/1/ouw==}\n\n  rc-checkbox@3.0.1:\n    resolution: {integrity: sha512-k7nxDWxYF+jDI0ZcCvuvj71xONmWRVe5+1MKcERRR9MRyP3tZ69b+yUCSXXh+sik4/Hc9P5wHr2nnUoGS2zBjA==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-collapse@1.9.3:\n    resolution: {integrity: sha512-8cG+FzudmgFCC9zRGKXJZA36zoI9Dmyjp6UDi8N80sXUch0JOpsZDxgcFzw4HPpPpK/dARtTilEe9zyuspnW0w==}\n\n  rc-collapse@3.4.2:\n    resolution: {integrity: sha512-jpTwLgJzkhAgp2Wpi3xmbTbbYExg6fkptL67Uu5LCRVEj6wqmy0DHTjjeynsjOLsppHGHu41t1ELntZ0lEvS/Q==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-dialog@9.0.4:\n    resolution: {integrity: sha512-pmnPRZKd9CGzGgf4a1ysBvMhxm8Afx5fF6M7AzLtJ0qh8X1bshurDlqnK4MBNAB4hAeAMMbz6Ytb1rkGMvKFbQ==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-drawer@6.3.0:\n    resolution: {integrity: sha512-uBZVb3xTAR+dBV53d/bUhTctCw3pwcwJoM7g5aX+7vgwt2zzVzoJ6aqFjYJpBlZ9zp0dVYN8fV+hykFE7c4lig==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-dropdown@4.0.1:\n    resolution: {integrity: sha512-OdpXuOcme1rm45cR0Jzgfl1otzmU4vuBVb+etXM8vcaULGokAKVpKlw8p6xzspG7jGd/XxShvq+N3VNEfk/l5g==}\n    peerDependencies:\n      react: '>=16.11.0'\n      react-dom: '>=16.11.0'\n\n  rc-field-form@1.38.2:\n    resolution: {integrity: sha512-O83Oi1qPyEv31Sg+Jwvsj6pXc8uQI2BtIAkURr5lvEYHVggXJhdU/nynK8wY1gbw0qR48k731sN5ON4egRCROA==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-gesture@0.0.22:\n    resolution: {integrity: sha512-6G6qrCE0MUTXyjh/powj91XkjRjoFL4HiJLPU5lALXHvGX+/efcUjGYUrHrrw0mwQdmrmg4POqnY/bibns+G3g==}\n\n  rc-image@5.13.0:\n    resolution: {integrity: sha512-iZTOmw5eWo2+gcrJMMcnd7SsxVHl3w5xlyCgsULUdJhJbnuI8i/AL0tVOsE7aLn9VfOh1qgDT3mC2G75/c7mqg==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-input-number@7.3.11:\n    resolution: {integrity: sha512-aMWPEjFeles6PQnMqP5eWpxzsvHm9rh1jQOWXExUEIxhX62Fyl/ptifLHOn17+waDG1T/YUb6flfJbvwRhHrbA==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-input@0.1.4:\n    resolution: {integrity: sha512-FqDdNz+fV2dKNgfXzcSLKvC+jEs1709t7nD+WdfjrdSaOcefpgc7BUJYadc3usaING+b7ediMTfKxuJBsEFbXA==}\n    peerDependencies:\n      react: '>=16.0.0'\n      react-dom: '>=16.0.0'\n\n  rc-mentions@1.13.1:\n    resolution: {integrity: sha512-FCkaWw6JQygtOz0+Vxz/M/NWqrWHB9LwqlY2RtcuFqWJNFK9njijOOzTSsBGANliGufVUzx/xuPHmZPBV0+Hgw==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-menu@9.8.4:\n    resolution: {integrity: sha512-lmw2j8I2fhdIzHmC9ajfImfckt0WDb2KVJJBBRIsxPEw2kGkEfjLMUoB1NgiNT/Q5cC8PdjGOGQjHJIJMwyNMw==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-motion@2.9.4:\n    resolution: {integrity: sha512-TAPUUufDqhPO669qJobI0d9U0XZ/VPNQyZTivUxxzU1EyuPe3PtHSx7Kb902KuzQgu7sS18z8GguaxZEALV/ww==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-notification@4.6.1:\n    resolution: {integrity: sha512-NSmFYwrrdY3+un1GvDAJQw62Xi9LNMSsoQyo95tuaYrcad5Bn9gJUL8AREufRxSQAQnr64u3LtP3EUyLYT6bhw==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-overflow@1.3.2:\n    resolution: {integrity: sha512-nsUm78jkYAoPygDAcGZeC2VwIg/IBGSodtOY3pMof4W3M9qRJgqaDYm03ZayHlde3I6ipliAxbN0RUcGf5KOzw==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-pagination@3.2.0:\n    resolution: {integrity: sha512-5tIXjB670WwwcAJzAqp2J+cOBS9W3cH/WU1EiYwXljuZ4vtZXKlY2Idq8FZrnYBz8KhN3vwPo9CoV/SJS6SL1w==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-picker@2.7.6:\n    resolution: {integrity: sha512-H9if/BUJUZBOhPfWcPeT15JUI3/ntrG9muzERrXDkSoWmDj4yzmBvumozpxYrHwjcKnjyDGAke68d+whWwvhHA==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-progress@3.4.2:\n    resolution: {integrity: sha512-iAGhwWU+tsayP+Jkl9T4+6rHeQTG9kDz8JAHZk4XtQOcYN5fj9H34NXNEdRdZx94VUDHMqCb1yOIvi8eJRh67w==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-rate@2.9.3:\n    resolution: {integrity: sha512-2THssUSnRhtqIouQIIXqsZGzRczvp4WsH4WvGuhiwm+LG2fVpDUJliP9O1zeDOZvYfBE/Bup4SgHun/eCkbjgQ==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-resize-observer@1.4.1:\n    resolution: {integrity: sha512-JbAeFDsaaZRPwaTlXnCqgeO9c6E7qoaE/hxsub08cdnnPn6767c/j9+r/TifUdfvwXtdcfHygKbZ7ecM/PXo/Q==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-segmented@2.3.0:\n    resolution: {integrity: sha512-I3FtM5Smua/ESXutFfb8gJ8ZPcvFR+qUgeeGFQHBOvRiRKyAk4aBE5nfqrxXx+h8/vn60DQjOt6i4RNtrbOobg==}\n    peerDependencies:\n      react: '>=16.0.0'\n      react-dom: '>=16.0.0'\n\n  rc-select@14.1.18:\n    resolution: {integrity: sha512-4JgY3oG2Yz68ECMUSCON7mtxuJvCSj+LJpHEg/AONaaVBxIIrmI/ZTuMJkyojall/X50YdBe5oMKqHHPNiPzEg==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '*'\n      react-dom: '*'\n\n  rc-slider@10.0.1:\n    resolution: {integrity: sha512-igTKF3zBet7oS/3yNiIlmU8KnZ45npmrmHlUUio8PNbIhzMcsh+oE/r2UD42Y6YD2D/s+kzCQkzQrPD6RY435Q==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-slider@8.2.0:\n    resolution: {integrity: sha512-rnO36M3VhMoPWh1kRuCeJoluT4duAW7+5aLaAn9oLu2pKEKsuOFUh5DmA2kEo88UmvPV6nr7HHDeZuC8SNM/lA==}\n\n  rc-steps@5.0.0:\n    resolution: {integrity: sha512-9TgRvnVYirdhbV0C3syJFj9EhCRqoJAsxt4i1rED5o8/ZcSv5TLIYyo4H8MCjLPvbe2R+oBAm/IYBEtC+OS1Rw==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-swipeout@2.0.11:\n    resolution: {integrity: sha512-d37Lgn4RX4OOQyuA2BFo0rGlUwrmZk5q83srH3ixJ1Y1jidr2GKjgJDbNeGUVZPNfYBL91Elu6+xfVGftWf4Lg==}\n\n  rc-switch@3.2.2:\n    resolution: {integrity: sha512-+gUJClsZZzvAHGy1vZfnwySxj+MjLlGRyXKXScrtCTcmiYNPzxDFOxdQ/3pK1Kt/0POvwJ/6ALOR8gwdXGhs+A==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-table@7.26.0:\n    resolution: {integrity: sha512-0cD8e6S+DTGAt5nBZQIPFYEaIukn17sfa5uFL98faHlH/whZzD8ii3dbFL4wmUDEL4BLybhYop+QUfZJ4CPvNQ==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-tabs@12.5.10:\n    resolution: {integrity: sha512-Ay0l0jtd4eXepFH9vWBvinBjqOpqzcsJTerBGwJy435P2S90Uu38q8U/mvc1sxUEVOXX5ZCFbxcWPnfG3dH+tQ==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-textarea@0.4.7:\n    resolution: {integrity: sha512-IQPd1CDI3mnMlkFyzt2O4gQ2lxUsnBAeJEoZGJnkkXgORNqyM9qovdrCj9NzcRfpHgLdzaEbU3AmobNFGUznwQ==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-tooltip@3.7.3:\n    resolution: {integrity: sha512-dE2ibukxxkrde7wH9W8ozHKUO4aQnPZ6qBHtrTH9LoO836PjDdiaWO73fgPB05VfJs9FbZdmGPVEbXCeOP99Ww==}\n\n  rc-tooltip@5.2.2:\n    resolution: {integrity: sha512-jtQzU/18S6EI3lhSGoDYhPqNpWajMtS5VV/ld1LwyfrDByQpYmw/LW6U7oFXXLukjfDHQ7Ju705A82PRNFWYhg==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-tree-select@5.5.5:\n    resolution: {integrity: sha512-k2av7jF6tW9bIO4mQhaVdV4kJ1c54oxV3/hHVU+oD251Gb5JN+m1RbJFTMf1o0rAFqkvto33rxMdpafaGKQRJw==}\n    peerDependencies:\n      react: '*'\n      react-dom: '*'\n\n  rc-tree@5.7.12:\n    resolution: {integrity: sha512-LXA5nY2hG5koIAlHW5sgXgLpOMz+bFRbnZZ+cCg0tQs4Wv1AmY7EDi1SK7iFXhslYockbqUerQan82jljoaItg==}\n    engines: {node: '>=10.x'}\n    peerDependencies:\n      react: '*'\n      react-dom: '*'\n\n  rc-trigger@2.6.5:\n    resolution: {integrity: sha512-m6Cts9hLeZWsTvWnuMm7oElhf+03GOjOLfTuU0QmdB9ZrW7jR2IpI5rpNM7i9MvAAlMAmTx5Zr7g3uu/aMvZAw==}\n\n  rc-trigger@5.3.4:\n    resolution: {integrity: sha512-mQv+vas0TwKcjAO2izNPkqR4j86OemLRmvL2nOzdP9OWNWA1ivoTt5hzFqYNW9zACwmTezRiN8bttrC7cZzYSw==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-upload@4.3.6:\n    resolution: {integrity: sha512-Bt7ESeG5tT3IY82fZcP+s0tQU2xmo1W6P3S8NboUUliquJLQYLkUcsaExi3IlBVr43GQMCjo30RA2o0i70+NjA==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-util@4.21.1:\n    resolution: {integrity: sha512-Z+vlkSQVc1l8O2UjR3WQ+XdWlhj5q9BMQNLk2iOBch75CqPfrJyGtcWMcnhRlNuDu0Ndtt4kLVO8JI8BrABobg==}\n\n  rc-util@5.44.1:\n    resolution: {integrity: sha512-h6z91oGfWJPZgunkFBWSobfL0CkyLeaUNWP1ru7b05GMUSe2uHgTk0EiFEQ11v+zJBrORuXFl6Htf949ZSDdOw==}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  rc-virtual-list@3.16.0:\n    resolution: {integrity: sha512-tRpWBC0msU+MxFxnD6+y4v0P17Yzplf+mbiHrqRvfVanx0S4o0XV+2zu4vv7hM9nNfcucO+MPHivqpRT2lfnFQ==}\n    engines: {node: '>=8.x'}\n    peerDependencies:\n      react: '>=16.9.0'\n      react-dom: '>=16.9.0'\n\n  react-dom@16.14.0:\n    resolution: {integrity: sha512-1gCeQXDLoIqMgqD3IO2Ah9bnf0w9kzhwN5q4FGnHZ67hBm9yePzB5JJAIQCc8x3pFnNlwFq4RidZggNAAkzWWw==}\n    peerDependencies:\n      react: ^16.14.0\n\n  react-dom@17.0.2:\n    resolution: {integrity: sha512-s4h96KtLDUQlsENhMn1ar8t2bEa+q/YAtj8pPPdIjPDGBDIVNsrD9aXNWqspUe6AzKCIG0C1HZZLqLV7qpOBGA==}\n    peerDependencies:\n      react: 17.0.2\n\n  react-fast-compare@3.2.2:\n    resolution: {integrity: sha512-nsO+KSNgo1SbJqJEYRE9ERzo7YtYbou/OqjSQKxV7jcKox7+usiUVZOAC+XnDOABXggQTno0Y1CpVnuWEc1boQ==}\n\n  react-helmet@6.1.0:\n    resolution: {integrity: sha512-4uMzEY9nlDlgxr61NL3XbKRy1hEkXmKNXhjbAIOVw5vcFrsdYbH2FEwcNyWvWinl103nXgzYNlns9ca+8kFiWw==}\n    peerDependencies:\n      react: '>=16.3.0'\n\n  react-intl@3.12.1:\n    resolution: {integrity: sha512-cgumW29mwROIqyp8NXStYsoIm27+8FqnxykiLSawWjOxGIBeLuN/+p2srei5SRIumcJefOkOIHP+NDck05RgHg==}\n    peerDependencies:\n      react: ^16.3.0\n\n  react-is@16.13.1:\n    resolution: {integrity: sha512-24e6ynE2H+OKt4kqsOvNd8kBpV65zoxbA4BVsEOB3ARVWQki/DHzaUoC5KuON/BiccDaCCTZBuOcfZs70kR8bQ==}\n\n  react-is@17.0.2:\n    resolution: {integrity: sha512-w2GsyukL62IJnlaff/nRegPQR94C/XXamvMWmSHRJ4y7Ts/4ocGRmTHvOs8PSE6pB3dWOrD/nueuU5sduBsQ4w==}\n\n  react-is@18.3.1:\n    resolution: {integrity: sha512-/LLMVyas0ljjAtoYiPqYiL8VWXzUUdThrmU5+n20DZv+a+ClRoevUzw5JxU+Ieh5/c87ytoTBV9G1FiKfNJdmg==}\n\n  react-lifecycles-compat@3.0.4:\n    resolution: {integrity: sha512-fBASbA6LnOU9dOU2eW7aQ8xmYBSXUIWr+UmF9b1efZBazGNO+rcXT/icdKnYm2pTwcRylVUYwW7H1PHfLekVzA==}\n\n  react-native-swipeout@2.3.6:\n    resolution: {integrity: sha512-t9suUCspzck4vp2pWggWe0frS/QOtX6yYCawHnEes75A7dZCEE74bxX2A1bQzGH9cUMjq6xsdfC94RbiDKIkJg==}\n    deprecated: Package no longer supported. Use at your own risk or consider using https://github.com/software-mansion/react-native-gesture-handler\n\n  react-redux@7.2.9:\n    resolution: {integrity: sha512-Gx4L3uM182jEEayZfRbI/G11ZpYdNAnBs70lFVMNdHJI76XYtR+7m0MN+eAs7UHBPhWXcnFPaS+9owSCJQHNpQ==}\n    peerDependencies:\n      react: ^16.8.3 || ^17 || ^18\n      react-dom: '*'\n      react-native: '*'\n    peerDependenciesMeta:\n      react-dom:\n        optional: true\n      react-native:\n        optional: true\n\n  react-refresh@0.10.0:\n    resolution: {integrity: sha512-PgidR3wST3dDYKr6b4pJoqQFpPGNKDSCDx4cZoshjXipw3LzO7mG1My2pwEzz2JVkF+inx3xRpDeQLFQGH/hsQ==}\n    engines: {node: '>=0.10.0'}\n\n  react-router-config@5.1.1:\n    resolution: {integrity: sha512-DuanZjaD8mQp1ppHjgnnUnyOlqYXZVjnov/JzFhjLEwd3Z4dYjMSnqrEzzGThH47vpCOqPPwJM2FtthLeJ8Pbg==}\n    peerDependencies:\n      react: '>=15'\n      react-router: '>=5'\n\n  react-router-dom@5.2.0:\n    resolution: {integrity: sha512-gxAmfylo2QUjcwxI63RhQ5G85Qqt4voZpUXSEqCwykV0baaOTQDR1f0PmY8AELqIyVc0NEZUj0Gov5lNGcXgsA==}\n    peerDependencies:\n      react: '>=15'\n\n  react-router-dom@5.3.4:\n    resolution: {integrity: sha512-m4EqFMHv/Ih4kpcBCONHbkT68KoAeHN4p3lAGoNryfHi0dMy0kCzEZakiKRsvg5wHZ/JLrLW8o8KomWiz/qbYQ==}\n    peerDependencies:\n      react: '>=15'\n\n  react-router@5.2.0:\n    resolution: {integrity: sha512-smz1DUuFHRKdcJC0jobGo8cVbhO3x50tCL4icacOlcwDOEQPq4TMqwx3sY1TP+DvtTgz4nm3thuo7A+BK2U0Dw==}\n    peerDependencies:\n      react: '>=15'\n\n  react-router@5.3.4:\n    resolution: {integrity: sha512-Ys9K+ppnJah3QuaRiLxk+jDWOR1MekYQrlytiXxC1RyfbdsZkS5pvKAzCCr031xHixZwpnsYNT5xysdFHQaYsA==}\n    peerDependencies:\n      react: '>=15'\n\n  react-side-effect@2.1.2:\n    resolution: {integrity: sha512-PVjOcvVOyIILrYoyGEpDN3vmYNLdy1CajSFNt4TDsVQC5KpTijDvWVoR+/7Rz2xT978D8/ZtFceXxzsPwZEDvw==}\n    peerDependencies:\n      react: ^16.3.0 || ^17.0.0 || ^18.0.0\n\n  react-sortable-hoc@2.0.0:\n    resolution: {integrity: sha512-JZUw7hBsAHXK7PTyErJyI7SopSBFRcFHDjWW5SWjcugY0i6iH7f+eJkY8cJmGMlZ1C9xz1J3Vjz0plFpavVeRg==}\n    peerDependencies:\n      prop-types: ^15.5.7\n      react: ^16.3.0 || ^17.0.0\n      react-dom: ^16.3.0 || ^17.0.0\n\n  react-tween-state@0.1.5:\n    resolution: {integrity: sha512-sJQpjsdn0wjlDIUpfpb7jQGnOG8hAEW2e8k0KPA+xmf5KFa6Xat2JldbmxBhaqP0S/uIXhVE5ymKyH/b9X8nYA==}\n\n  react@16.14.0:\n    resolution: {integrity: sha512-0X2CImDkJGApiAlcf0ODKIneSwBPhqJawOa5wCtKbu7ZECrmS26NvtSILynQ66cgkT/RJ4LidJOc3bUESwmU8g==}\n    engines: {node: '>=0.10.0'}\n\n  react@17.0.2:\n    resolution: {integrity: sha512-gnhPt75i/dq/z3/6q/0asP78D0u592D5L1pd7M8P+dck6Fu/jJeL6iVVK23fptSUZj8Vjf++7wXA8UNclGQcbA==}\n    engines: {node: '>=0.10.0'}\n\n  read-pkg-up@7.0.1:\n    resolution: {integrity: sha512-zK0TB7Xd6JpCLmlLmufqykGE+/TlOePD6qKClNW7hHDKFh/J7/7gCWGR7joEQEW1bKq3a3yUZSObOoWLFQ4ohg==}\n    engines: {node: '>=8'}\n\n  read-pkg@5.2.0:\n    resolution: {integrity: sha512-Ug69mNOpfvKDAc2Q8DRpMjjzdtrnv9HcSMX+4VsZxD1aZ6ZzrIE7rlzXBtWTyhULSMKg076AW6WR5iZpD0JiOg==}\n    engines: {node: '>=8'}\n\n  readable-stream@2.3.8:\n    resolution: {integrity: sha512-8p0AUk4XODgIewSi0l8Epjs+EVnWiK7NoDIEGU0HhE7+ZyY8D1IMY7odu5lRrFXGg71L15KG8QrPmum45RTtdA==}\n\n  readdirp@3.5.0:\n    resolution: {integrity: sha512-cMhu7c/8rdhkHXWsY+osBhfSy0JikwpHK/5+imo+LpeasTF8ouErHrlYkwT0++njiyuDvc7OFY5T3ukvZ8qmFQ==}\n    engines: {node: '>=8.10.0'}\n\n  redbox-react@1.6.0:\n    resolution: {integrity: sha512-mLjM5eYR41yOp5YKHpd3syFeGq6B4Wj5vZr64nbLvTZW5ZLff4LYk7VE4ITpVxkZpCY6OZuqh0HiP3A3uEaCpg==}\n    peerDependencies:\n      react: ^0.14.0 || ^15.0.0 || ^16.0.0-beta || ^16.0.0\n      react-dom: ^0.14.0 || ^15.0.0 || ^16.0.0-beta || ^16.0.0\n\n  redux-saga@0.16.2:\n    resolution: {integrity: sha512-iIjKnRThI5sKPEASpUvySemjzwqwI13e3qP7oLub+FycCRDysLSAOwt958niZW6LhxfmS6Qm1BzbU70w/Koc4w==}\n\n  redux@4.2.1:\n    resolution: {integrity: sha512-LAUYz4lc+Do8/g7aeRa8JkyDErK6ekstQaqWQrNRW//MY1TvCEpMtpTWvlQ+FPbWCx+Xixu/6SHt5N0HR+SB4w==}\n\n  regenerate-unicode-properties@10.0.1:\n    resolution: {integrity: sha512-vn5DU6yg6h8hP/2OkQo3K7uVILvY4iu0oI4t3HFa81UPkhGJwkRwM10JEc3upjdhHjs/k8GJY1sRBhk5sr69Bw==}\n    engines: {node: '>=4'}\n\n  regenerate@1.4.2:\n    resolution: {integrity: sha512-zrceR/XhGYU/d/opr2EKO7aRHUeiBI8qjtfHqADTwZd6Szfy16la6kqD0MIUs5z5hx6AaKa+PixpPrR289+I0A==}\n\n  regenerator-runtime@0.11.1:\n    resolution: {integrity: sha512-MguG95oij0fC3QV3URf4V2SDYGJhJnJGqvIIgdECeODCT98wSWDAJ94SSuVpYQUoTcGUIL6L4yNB7j1DFFHSBg==}\n\n  regenerator-runtime@0.13.11:\n    resolution: {integrity: sha512-kY1AZVr2Ra+t+piVaJ4gxaFaReZVH40AKNo7UCX6W+dEwBo/2oZJzqfuN1qLq1oL45o56cPaTXELwrTh8Fpggg==}\n\n  regenerator-runtime@0.13.5:\n    resolution: {integrity: sha512-ZS5w8CpKFinUzOwW3c83oPeVXoNsrLsaCoLtJvAClH135j/R77RuymhiSErhm2lKcwSCIpmvIWSbDkIfAqKQlA==}\n\n  regenerator-runtime@0.14.1:\n    resolution: {integrity: sha512-dYnhHh0nJoMfnkZs6GmmhFknAGRrLznOu5nc9ML+EJxGvrx6H7teuevqVqCuPcPK//3eDrrjQhehXVx9cnkGdw==}\n\n  regex-not@1.0.2:\n    resolution: {integrity: sha512-J6SDjUgDxQj5NusnOtdFxDwN/+HWykR8GELwctJ7mdqhcyy1xEc4SRFHUXvxTp661YaVKAjfRLZ9cCqS6tn32A==}\n    engines: {node: '>=0.10.0'}\n\n  remove-trailing-separator@1.1.0:\n    resolution: {integrity: sha512-/hS+Y0u3aOfIETiaiirUFwDBDzmXPvO+jAfKTitUngIPzdKc6Z0LoFjM/CK5PL4C+eKwHohlHAb6H0VFfmmUsw==}\n\n  repeat-element@1.1.4:\n    resolution: {integrity: sha512-LFiNfRcSu7KK3evMyYOuCzv3L10TW7yC1G2/+StMjK8Y6Vqd2MG7r/Qjw4ghtuCOjFvlnms/iMmLqpvW/ES/WQ==}\n    engines: {node: '>=0.10.0'}\n\n  repeat-string@1.6.1:\n    resolution: {integrity: sha512-PV0dzCYDNfRi1jCDbJzpW7jNNDRuCOG/jI5ctQcGKt/clZD+YcPS3yIlWuTJMmESC8aevCFmWJy5wjAFgNqN6w==}\n    engines: {node: '>=0.10'}\n\n  require-directory@2.1.1:\n    resolution: {integrity: sha512-fGxEI7+wsG9xrvdjsrlmL22OMTTiHRwAMroiEeMgq8gzoLC/PQr7RsRDSTLUg/bZAZtF+TVIkHc6/4RIKrui+Q==}\n    engines: {node: '>=0.10.0'}\n\n  require-main-filename@2.0.0:\n    resolution: {integrity: sha512-NKN5kMDylKuldxYLSUfrbo5Tuzh4hd+2E8NPPX02mZtn1VuREQToYe/ZdlJy+J3uCpfaiGF05e7B8W0iXbQHmg==}\n\n  requires-port@1.0.0:\n    resolution: {integrity: sha512-KigOCHcocU3XODJxsu8i/j8T9tzT4adHiecwORRQ0ZZFcp7ahwXuRU1m+yuO90C5ZUyGeGfocHDI14M3L3yDAQ==}\n\n  resize-observer-polyfill@1.5.1:\n    resolution: {integrity: sha512-LwZrotdHOo12nQuZlHEmtuXdqGoOD0OhaxopaNFxWzInpEgaLWoVuAMbTzixuosCx2nEG58ngzW3vxdWoxIgdg==}\n\n  resolve-cwd@3.0.0:\n    resolution: {integrity: sha512-OrZaX2Mb+rJCpH/6CpSqt9xFVpN++x01XnN2ie9g6P5/3xelLAkXWVADpdz1IHD/KFfEXyE6V0U01OQ3UO2rEg==}\n    engines: {node: '>=8'}\n\n  resolve-from@3.0.0:\n    resolution: {integrity: sha512-GnlH6vxLymXJNMBo7XP1fJIzBFbdYt49CuTwmB/6N53t+kMPRMFKz783LlQ4tv28XoQfMWinAJX6WCGf2IlaIw==}\n    engines: {node: '>=4'}\n\n  resolve-from@4.0.0:\n    resolution: {integrity: sha512-pb/MYmXstAkysRFx8piNI1tGFNQIFA3vkE3Gq4EuA1dF6gHp/+vgZqsCGJapvy8N3Q+4o7FwvquPJcnZ7RYy4g==}\n    engines: {node: '>=4'}\n\n  resolve-from@5.0.0:\n    resolution: {integrity: sha512-qYg9KP24dD5qka9J47d0aVky0N+b4fTU89LN9iDnjB5waksiC49rvMB0PrUJQGoTmH50XPiqOvAjDfaijGxYZw==}\n    engines: {node: '>=8'}\n\n  resolve-pathname@3.0.0:\n    resolution: {integrity: sha512-C7rARubxI8bXFNB/hqcp/4iUeIXJhJZvFPFPiSPRnhU5UPxzMFIl+2E6yY6c4k9giDJAhtV+enfA+G89N6Csng==}\n\n  resolve-url@0.2.1:\n    resolution: {integrity: sha512-ZuF55hVUQaaczgOIwqWzkEcEidmlD/xl44x1UZnhOXcYuFN2S6+rcxpG+C1N3So0wvNI3DmJICUFfu2SxhBmvg==}\n    deprecated: https://github.com/lydell/resolve-url#deprecated\n\n  resolve@1.22.8:\n    resolution: {integrity: sha512-oKWePCxqpd6FlLvGV1VU0x7bkPmmCNolxzjMf4NczoDnQcIWrAF+cPtZn5i6n+RfD2d9i0tzpKnG6Yk168yIyw==}\n    hasBin: true\n\n  restore-cursor@3.1.0:\n    resolution: {integrity: sha512-l+sSefzHpj5qimhFSE5a8nufZYAM3sBSVMAPtYkmC+4EH2anSGaEMXSD0izRQbu9nfyQ9y5JrVmp7E8oZrUjvA==}\n    engines: {node: '>=8'}\n\n  ret@0.1.15:\n    resolution: {integrity: sha512-TTlYpa+OL+vMMNG24xSlQGEJ3B/RzEfUlLct7b5G/ytav+wPrplCpVMFuwzXbkecJrb6IYo1iFb0S9v37754mg==}\n    engines: {node: '>=0.12'}\n\n  rfdc@1.4.1:\n    resolution: {integrity: sha512-q1b3N5QkRUWUl7iyylaaj3kOpIT0N2i9MqIEQXP73GVsN9cw3fdx8X63cEmWhJGi2PPCF23Ijp7ktmd39rawIA==}\n\n  rimraf@3.0.2:\n    resolution: {integrity: sha512-JZkJMZkAGFFPP2YqXZXPbMlMBgsxzE8ILs4lMIX/2o0L9UBw9O/Y3o6wFw/i9YLapcUJWwqbi3kdxIPdC62TIA==}\n    deprecated: Rimraf versions prior to v4 are no longer supported\n    hasBin: true\n\n  ripemd160@2.0.2:\n    resolution: {integrity: sha512-ii4iagi25WusVoiC4B4lq7pbXfAp3D9v5CwfkY33vffw2+pkDjY1D8GaN7spsxvCSx8dkPqOZCEZyfxcmJG2IA==}\n\n  rmc-align@1.0.0:\n    resolution: {integrity: sha512-3gEa5/+hqqoEVoeQ25KoRc8DOsXIdSaVpaBq1zQFaV941LR3xvZIRTlxTDT/IagYwoGM1KZea/jd7cNMYP34Rg==}\n\n  rmc-calendar@1.1.4:\n    resolution: {integrity: sha512-xxQZaPFDnpHt4IFO8mukYrXSgC1W8LcNVp+EoX4iyeOJFimungOKB/iP5/cy+st8yXq8lUgk9TXsHNtM6Xo6ZA==}\n\n  rmc-cascader@5.0.3:\n    resolution: {integrity: sha512-PxDhMjWViDdG4SMZqoXtAthGwgDyYnyxxZEE17IDDYsiCHpWtOhoIL8nsI+/hZ212UT/XF2LpqCsOlMoJiYk+w==}\n\n  rmc-date-picker@6.0.10:\n    resolution: {integrity: sha512-/9+I6lm3EDEl6M7862V6++zFuxwsM0UEq8wSHbotYIPPmyB/65gx1cviblghOv2QfB0O9+U2w3qEJlRP/WsMrA==}\n\n  rmc-dialog@1.1.1:\n    resolution: {integrity: sha512-28aJqtPTX6v13Z/aU1WBy1AFIXkE74PxZXde7JvtEIy9hQDTjH8fqOi822BpzAbXCyNE7jF9iFomy3H2ClsDJA==}\n\n  rmc-drawer@0.4.11:\n    resolution: {integrity: sha512-YfB9XEJ8iM0MMuLWAK4313uOxSM8NAljC8Cqun1KamXutglYTuRviUuTLNSOzV8HHPp5kNpsVduvPCGLWXvThw==}\n    engines: {node: '>=4.0.0'}\n\n  rmc-feedback@2.0.0:\n    resolution: {integrity: sha512-5PWOGOW7VXks/l3JzlOU9NIxRpuaSS8d9zA3UULUCuTKnpwBHNvv1jSJzxgbbCQeYzROWUpgKI4za3X4C/mKmQ==}\n\n  rmc-input-number@1.0.5:\n    resolution: {integrity: sha512-prPkEtoOVde77GnEnEaBeWjBobMOPgGqU5bd0gxfp1kt1pUN740mMpVAcH7uxpJjVfmw+kuGWtiz4S7CueagSg==}\n\n  rmc-list-view@0.11.5:\n    resolution: {integrity: sha512-eMOC5394tLNawcdEEhF7boMpQgpjJGDdL5lS+LblAWdBec7Q4EYkUdnrKNbt+O9k5RGM6nSLAGZK5oB4FN85Lg==}\n\n  rmc-notification@1.0.0:\n    resolution: {integrity: sha512-9sPxjltFvtRLt2v312Hu7OXwk53pHkBYgINRDmnJ3A5NF1qtJeCCcdN0Xr0fzJ6sbQvtGju822tWHdzYA9u7Vw==}\n\n  rmc-nuka-carousel@3.0.1:\n    resolution: {integrity: sha512-w2EPTERMUUZqcUSKFuejjin7xsMlhrLrtS0A/igTXpFJGq3kemDKcRi7q3pSYDuZBHYBl5iV4UqsLLkjdFtrYA==}\n\n  rmc-picker@5.0.10:\n    resolution: {integrity: sha512-KZ70+WjcaZHnG5GyCxWCPFWAZ12s6NqyrbW73LeqH0WEqaTMMs0sOrk2f4mQAZ/CGT0XcFN6VZLw7Ozoxfn7LA==}\n\n  rmc-pull-to-refresh@1.0.13:\n    resolution: {integrity: sha512-iYLsURiR7G/sKmRA6p2kq6ZXicn7Hyeo6VQFljssV1eMW+fzDgihhaz0kv5mza0f88vphGJvjOihT9E6+xGb6Q==}\n\n  rmc-steps@1.0.1:\n    resolution: {integrity: sha512-8ijtwp4D1CYTtI2yerXJYqCv+GQbiBc9T12nrFngd/vM0y+58CnznGphTAueF6IWf7qbxBwcjTrcFgg7bP2YGA==}\n\n  rmc-tabs@1.2.29:\n    resolution: {integrity: sha512-wiJS9WSJi9JH9GQO+FqncX+zaHP31qHa/S8nDW9UXUx0qbCX294QcJEnvfB+WmsfUws7rXjs6sOQp5EDiObnHg==}\n\n  rmc-tooltip@1.0.1:\n    resolution: {integrity: sha512-fSDArf2BlMVrHExmBiqb2TkCRJHshvXFJQ/7tMraLellwaJLNiwrxtWpW329k3S+zTtoVG8UxFS1TjBGEsMzRg==}\n\n  rmc-trigger@1.0.12:\n    resolution: {integrity: sha512-AccQniX7PX7Pm8hBhHEsnf3JU6CA61Xc7fAt2WbO+oXrGaI/jqN8C3COhhOXG54S5iTOjLS26j858zshwAxR9A==}\n\n  rsvp@4.8.5:\n    resolution: {integrity: sha512-nfMOlASu9OnRJo1mbEk2cz0D56a1MBNrJ7orjRZQG10XDyuvwksKbuXNp6qa+kbn839HwjwhBzhFmdsaEAfauA==}\n    engines: {node: 6.* || >= 7.*}\n\n  rxjs@7.8.1:\n    resolution: {integrity: sha512-AA3TVj+0A2iuIoQkWEK/tqFjBq2j+6PO6Y0zJcvzLAFhEFIO3HL0vls9hWLncZbAAbK0mar7oZ4V079I/qPMxg==}\n\n  safe-buffer@5.1.2:\n    resolution: {integrity: sha512-Gd2UZBJDkXlY7GbJxfsE8/nvKkUEU1G38c1siN6QP6a9PT9MmHB8GnpscSmMJSoF8LOIrt8ud/wPtojys4G6+g==}\n\n  safe-buffer@5.2.1:\n    resolution: {integrity: sha512-rp3So07KcdmmKbGvgaNxQSJr7bGVSVk5S9Eq1F+ppbRo70+YeaDxkw5Dd8NPN+GD6bjnYm2VuPuCXmpuYvmCXQ==}\n\n  safe-regex@1.1.0:\n    resolution: {integrity: sha512-aJXcif4xnaNUzvUuC5gcb46oTS7zvg4jpMTnuqtrEPlR3vFr4pxtdTwaF1Qs3Enjn9HK+ZlwQui+a7z0SywIzg==}\n\n  safer-buffer@2.1.2:\n    resolution: {integrity: sha512-YZo3K82SD7Riyi0E1EQPojLz7kpepnSQI9IyPbHHg1XXXevb5dJI7tpyN2ADxGcQbHG7vcyRHk0cbwqcQriUtg==}\n\n  sane@4.1.0:\n    resolution: {integrity: sha512-hhbzAgTIX8O7SHfp2c8/kREfEn4qO/9q8C9beyY6+tvZ87EpoZ3i1RIEvp27YBswnNbY9mWd6paKVmKbAgLfZA==}\n    engines: {node: 6.* || 8.* || >= 10.*}\n    deprecated: some dependency vulnerabilities fixed, support for node < 10 dropped, and newer ECMAScript syntax/features added\n    hasBin: true\n\n  saxes@5.0.1:\n    resolution: {integrity: sha512-5LBh1Tls8c9xgGjw3QrMwETmTMVk0oFgvrFSvWx62llR2hcEInrKNZ2GZCCuuy2lvWrdl5jhbpeqc5hRYKFOcw==}\n    engines: {node: '>=10'}\n\n  scheduler@0.19.1:\n    resolution: {integrity: sha512-n/zwRWRYSUj0/3g/otKDRPMh6qv2SYMWNq85IEa8iZyAv8od9zDYpGSnpBEjNgcMNq6Scbu5KfIPxNF72R/2EA==}\n\n  scheduler@0.20.2:\n    resolution: {integrity: sha512-2eWfGgAqqWFGqtdMmcL5zCMK1U8KlXv8SQFGglL3CEtd0aDVDWgeF/YoCmvln55m5zSk3J/20hTaSBeSObsQDQ==}\n\n  schema-utils@1.0.0:\n    resolution: {integrity: sha512-i27Mic4KovM/lnGsy8whRCHhc7VicJajAjTrYg11K9zfZXnYIt4k5F+kZkwjnrhKzLic/HLU4j11mjsz2G/75g==}\n    engines: {node: '>= 4'}\n\n  schema-utils@3.3.0:\n    resolution: {integrity: sha512-pN/yOAvcC+5rQ5nERGuwrjLlYvLTbCibnZ1I7B1LaiAz9BRBlE9GMgE/eqV30P7aJQUf7Ddimy/RsbYO/GrVGg==}\n    engines: {node: '>= 10.13.0'}\n\n  scroll-into-view-if-needed@2.2.31:\n    resolution: {integrity: sha512-dGCXy99wZQivjmjIqihaBQNjryrz5rueJY7eHfTdyWEiR4ttYpsajb14rn9s5d4DY4EcY6+4+U/maARBXJedkA==}\n\n  seamless-immutable@7.1.4:\n    resolution: {integrity: sha512-XiUO1QP4ki4E2PHegiGAlu6r82o5A+6tRh7IkGGTVg/h+UoeX4nFBeCGPOhb4CYjvkqsfm/TUtvOMYC1xmV30A==}\n\n  semver-compare@1.0.0:\n    resolution: {integrity: sha512-YM3/ITh2MJ5MtzaM429anh+x2jiLVjqILF4m4oyQB18W7Ggea7BfqdH/wGMK7dDiMghv/6WG7znWMwUDzJiXow==}\n\n  semver@5.7.2:\n    resolution: {integrity: sha512-cBznnQ9KjJqU67B52RMC65CMarK2600WFnbkcaiwWq3xy/5haFJlshgnpjovMVJ+Hff49d8GEn0b87C5pDQ10g==}\n    hasBin: true\n\n  semver@6.3.1:\n    resolution: {integrity: sha512-BR7VvDCVHO+q2xBEWskxS6DJE1qRnb7DxzUrogb71CWoSficBxYsiAGd+Kl0mmq/MprG9yArRkyrQxTO6XjMzA==}\n    hasBin: true\n\n  semver@7.6.3:\n    resolution: {integrity: sha512-oVekP1cKtI+CTDvHWYFUcMtsK/00wmAEfyqKfNdARm8u1wNVhSgaX7A8d4UuIlUI5e84iEwOhs7ZPYRmzU9U6A==}\n    engines: {node: '>=10'}\n    hasBin: true\n\n  set-blocking@2.0.0:\n    resolution: {integrity: sha512-KiKBS8AnWGEyLzofFfmvKwpdPzqiy16LvQfK3yv/fVH7Bj13/wl3JSR1J+rfgRE9q7xUJK4qvgS8raSOeLUehw==}\n\n  set-function-length@1.2.2:\n    resolution: {integrity: sha512-pgRc4hJ4/sNjWCSS9AmnS40x3bNMDTknHgL5UaMBTMyJnU90EgWh1Rz+MC9eFu4BuN/UwZjKQuY/1v3rM7HMfg==}\n    engines: {node: '>= 0.4'}\n\n  set-value@2.0.1:\n    resolution: {integrity: sha512-JxHc1weCN68wRY0fhCoXpyK55m/XPHafOmK4UWD7m2CI14GMcFypt4w/0+NV5f/ZMby2F6S2wwA7fgynh9gWSw==}\n    engines: {node: '>=0.10.0'}\n\n  setimmediate@1.0.5:\n    resolution: {integrity: sha512-MATJdZp8sLqDl/68LfQmbP8zKPLQNV6BIZoIgrscFDQ+RsvK/BxeDQOgyxKKoh0y/8h3BqVFnCqQ/gd+reiIXA==}\n\n  sha.js@2.4.11:\n    resolution: {integrity: sha512-QMEp5B7cftE7APOjk5Y6xgrbWu+WkLVQwk8JNjZ8nKRciZaByEW6MubieAiToS7+dwvrjGhH8jRXz3MVd0AYqQ==}\n    hasBin: true\n\n  shallow-equal@1.2.1:\n    resolution: {integrity: sha512-S4vJDjHHMBaiZuT9NPb616CSmLf618jawtv3sufLl6ivK8WocjAo58cXwbRV1cgqxH0Qbv+iUt6m05eqEa2IRA==}\n\n  shallowequal@1.1.0:\n    resolution: {integrity: sha512-y0m1JoUZSlPAjXVtPPW70aZWfIL/dSP7AFkRnniLCrK/8MDKog3TySTBmckD+RObVxH0v4Tox67+F14PdED2oQ==}\n\n  shebang-command@1.2.0:\n    resolution: {integrity: sha512-EV3L1+UQWGor21OmnvojK36mhg+TyIKDh3iFBKBohr5xeXIhNBcx8oWdgkTEEQ+BEFFYdLRuqMfd5L84N1V5Vg==}\n    engines: {node: '>=0.10.0'}\n\n  shebang-command@2.0.0:\n    resolution: {integrity: sha512-kHxr2zZpYtdmrN1qDjrrX/Z1rR1kG8Dx+gkpK1G4eXmvXswmcE1hTWBWYUzlraYw1/yZp6YuDY77YtvbN0dmDA==}\n    engines: {node: '>=8'}\n\n  shebang-regex@1.0.0:\n    resolution: {integrity: sha512-wpoSFAxys6b2a2wHZ1XpDSgD7N9iVjg29Ph9uV/uaP9Ex/KXlkTZTeddxDPSYQpgvzKLGJke2UU0AzoGCjNIvQ==}\n    engines: {node: '>=0.10.0'}\n\n  shebang-regex@3.0.0:\n    resolution: {integrity: sha512-7++dFhtcx3353uBaq8DDR4NuxBetBzC7ZQOhmTQInHEd6bSrXdiEyzCvG07Z44UYdLShWUyXt5M/yhz8ekcb1A==}\n    engines: {node: '>=8'}\n\n  shellwords@0.1.1:\n    resolution: {integrity: sha512-vFwSUfQvqybiICwZY5+DAWIPLKsWO31Q91JSKl3UYv+K5c2QRPzn0qzec6QPu1Qc9eHYItiP3NdJqNVqetYAww==}\n\n  side-channel-list@1.0.0:\n    resolution: {integrity: sha512-FCLHtRD/gnpCiCHEiJLOwdmFP+wzCmDEkc9y7NsYxeF4u7Btsn1ZuwgwJGxImImHicJArLP4R0yX4c2KCrMrTA==}\n    engines: {node: '>= 0.4'}\n\n  side-channel-map@1.0.1:\n    resolution: {integrity: sha512-VCjCNfgMsby3tTdo02nbjtM/ewra6jPHmpThenkTYh8pG9ucZ/1P8So4u4FGBek/BjpOVsDCMoLA/iuBKIFXRA==}\n    engines: {node: '>= 0.4'}\n\n  side-channel-weakmap@1.0.2:\n    resolution: {integrity: sha512-WPS/HvHQTYnHisLo9McqBHOJk2FkHO/tlpvldyrnem4aeQp4hai3gythswg6p01oSoTl58rcpiFAjF2br2Ak2A==}\n    engines: {node: '>= 0.4'}\n\n  side-channel@1.1.0:\n    resolution: {integrity: sha512-ZX99e6tRweoUXqR+VBrslhda51Nh5MTQwou5tnUDgbtyM0dBgmhEDtWGP/xbKn6hqfPRHujUNwz5fy/wbbhnpw==}\n    engines: {node: '>= 0.4'}\n\n  signal-exit@3.0.7:\n    resolution: {integrity: sha512-wnD2ZE+l+SPC/uoS0vXeE9L1+0wuaMqKlfz9AMUo38JsyLSBWSFcHR1Rri62LZc12vLr1gb3jl7iwQhgwpAbGQ==}\n\n  sisteransi@1.0.5:\n    resolution: {integrity: sha512-bLGGlR1QxBcynn2d5YmDX4MGjlZvy2MRBDRNHLJ8VI6l6+9FUiyTFNJ0IveOSP0bcXgVDPRcfGqA0pjaqUpfVg==}\n\n  slash@3.0.0:\n    resolution: {integrity: sha512-g9Q1haeby36OSStwb4ntCGGGaKsaVSjQ68fBxoQcutl5fS1vuY18H3wSt3jFyFtrkx+Kz0V1G85A4MyAdDMi2Q==}\n    engines: {node: '>=8'}\n\n  slice-ansi@3.0.0:\n    resolution: {integrity: sha512-pSyv7bSTC7ig9Dcgbw9AuRNUb5k5V6oDudjZoMBSr13qpLBG7tB+zgCkARjq7xIUgdz5P1Qe8u+rSGdouOOIyQ==}\n    engines: {node: '>=8'}\n\n  slice-ansi@4.0.0:\n    resolution: {integrity: sha512-qMCMfhY040cVHT43K9BFygqYbUPFZKHOg7K73mtTWJRb8pyP3fzf4Ixd5SzdEJQ6MRUg/WBnOLxghZtKKurENQ==}\n    engines: {node: '>=10'}\n\n  snapdragon-node@2.1.1:\n    resolution: {integrity: sha512-O27l4xaMYt/RSQ5TR3vpWCAB5Kb/czIcqUFOM/C4fYcLnbZUc1PkjTAMjof2pBWaSTwOUd6qUHcFGVGj7aIwnw==}\n    engines: {node: '>=0.10.0'}\n\n  snapdragon-util@3.0.1:\n    resolution: {integrity: sha512-mbKkMdQKsjX4BAL4bRYTj21edOf8cN7XHdYUJEe+Zn99hVEYcMvKPct1IqNe7+AZPirn8BCDOQBHQZknqmKlZQ==}\n    engines: {node: '>=0.10.0'}\n\n  snapdragon@0.8.2:\n    resolution: {integrity: sha512-FtyOnWN/wCHTVXOMwvSv26d+ko5vWlIDD6zoUJ7LW8vh+ZBC8QdljveRP+crNrtBwioEUWy/4dMtbBjA4ioNlg==}\n    engines: {node: '>=0.10.0'}\n\n  sort-keys@1.1.2:\n    resolution: {integrity: sha512-vzn8aSqKgytVik0iwdBEi+zevbTYZogewTUM6dtpmGwEcdzbub/TX4bCzRhebDCRC3QzXgJsLRKB2V/Oof7HXg==}\n    engines: {node: '>=0.10.0'}\n\n  source-map-resolve@0.5.3:\n    resolution: {integrity: sha512-Htz+RnsXWk5+P2slx5Jh3Q66vhQj1Cllm0zvnaY98+NFx+Dv2CF/f5O/t8x+KaNdrdIAsruNzoh/KpialbqAnw==}\n    deprecated: See https://github.com/lydell/source-map-resolve#deprecated\n\n  source-map-support@0.5.21:\n    resolution: {integrity: sha512-uBHU3L3czsIyYXKX88fdrGovxdSCoTGDRZ6SYXtSRxLZUzHg5P/66Ht6uoUlHu9EZod+inXhKo3qQgwXUT/y1w==}\n\n  source-map-url@0.4.1:\n    resolution: {integrity: sha512-cPiFOTLUKvJFIg4SKVScy4ilPPW6rFgMgfuZJPNoDuMs3nC1HbMUycBoJw77xFIp6z1UJQJOfx6C9GMH80DiTw==}\n    deprecated: See https://github.com/lydell/source-map-url#deprecated\n\n  source-map@0.5.6:\n    resolution: {integrity: sha512-MjZkVp0NHr5+TPihLcadqnlVoGIoWo4IBHptutGh9wI3ttUYvCG26HkSuDi+K6lsZ25syXJXcctwgyVCt//xqA==}\n    engines: {node: '>=0.10.0'}\n\n  source-map@0.5.7:\n    resolution: {integrity: sha512-LbrmJOMUSdEVxIKvdcJzQC+nQhe8FUZQTXQy6+I75skNgn3OoQ0DZA8YnFa7gp8tqtL3KPf1kmo0R5DoApeSGQ==}\n    engines: {node: '>=0.10.0'}\n\n  source-map@0.6.1:\n    resolution: {integrity: sha512-UjgapumWlbMhkBgzT7Ykc5YXUT46F0iKu8SGXq0bcwP5dz/h0Plj6enJqjz1Zbq2l5WaqYnrVbwWOWMyF3F47g==}\n    engines: {node: '>=0.10.0'}\n\n  source-map@0.7.4:\n    resolution: {integrity: sha512-l3BikUxvPOcn5E74dZiq5BGsTb5yEwhaTSzccU6t4sDOH8NWJCstKO5QT2CvtFoK6F0saL7p9xHAqHOlCPJygA==}\n    engines: {node: '>= 8'}\n\n  sourcemapped-stacktrace@1.1.11:\n    resolution: {integrity: sha512-O0pcWjJqzQFVsisPlPXuNawJHHg9N9UgpJ/aDmvi9+vnS3x1C0NhwkVFzzZ1VN0Xo+bekyweoqYvBw5ZBKiNnQ==}\n\n  spdx-correct@3.2.0:\n    resolution: {integrity: sha512-kN9dJbvnySHULIluDHy32WHRUu3Og7B9sbY7tsFLctQkIqnMh3hErYgdMjTYuqmcXX+lK5T1lnUt3G7zNswmZA==}\n\n  spdx-exceptions@2.5.0:\n    resolution: {integrity: sha512-PiU42r+xO4UbUS1buo3LPJkjlO7430Xn5SVAhdpzzsPHsjbYVflnnFdATgabnLude+Cqu25p6N+g2lw/PFsa4w==}\n\n  spdx-expression-parse@3.0.1:\n    resolution: {integrity: sha512-cbqHunsQWnJNE6KhVSMsMeH5H/L9EpymbzqTQ3uLwNCLZ1Q481oWaofqH7nO6V07xlXwY6PhQdQ2IedWx/ZK4Q==}\n\n  spdx-license-ids@3.0.20:\n    resolution: {integrity: sha512-jg25NiDV/1fLtSgEgyvVyDunvaNHbuwF9lfNV17gSmPFAlYzdfNBlLtLzXTevwkPj7DhGbmN9VnmJIgLnhvaBw==}\n\n  split-on-first@1.1.0:\n    resolution: {integrity: sha512-43ZssAJaMusuKWL8sKUBQXHWOpq8d6CfN/u1p4gUzfJkM05C8rxTmYrkIPTXapZpORA6LkkzcUulJ8FqA7Uudw==}\n    engines: {node: '>=6'}\n\n  split-string@3.1.0:\n    resolution: {integrity: sha512-NzNVhJDYpwceVVii8/Hu6DKfD2G+NrQHlS/V/qgv763EYudVwEcMQNxd2lh+0VrUByXN/oJkl5grOhYWvQUYiw==}\n    engines: {node: '>=0.10.0'}\n\n  sprintf-js@1.0.3:\n    resolution: {integrity: sha512-D9cPgkvLlV3t3IzL0D0YLvGA9Ahk4PcvVwUbN0dSGr1aP0Nrt4AEnTUbuGvquEC0mA64Gqt1fzirlRs5ibXx8g==}\n\n  stack-utils@2.0.6:\n    resolution: {integrity: sha512-XlkWvfIm6RmsWtNJx+uqtKLS8eqFbxUg0ZzLXqY0caEy9l7hruX8IpiDnjsLavoBgqCCR71TqWO8MaXYheJ3RQ==}\n    engines: {node: '>=10'}\n\n  stackframe@0.3.1:\n    resolution: {integrity: sha512-XmoiF4T5nuWEp2x2w92WdGjdHGY/cZa6LIbRsDRQR/Xlk4uW0PAUlH1zJYVffocwKpCdwyuypIp25xsSXEtZHw==}\n\n  stackframe@1.3.4:\n    resolution: {integrity: sha512-oeVtt7eWQS+Na6F//S4kJ2K2VbRlS9D43mAlMyVpVWovy9o+jfgH8O9agzANzaiLjclA0oYzUXEM4PurhSUChw==}\n\n  static-extend@0.1.2:\n    resolution: {integrity: sha512-72E9+uLc27Mt718pMHt9VMNiAL4LMsmDbBva8mxWUCkT07fSzEGMYUCk0XWY6lp0j6RBAG4cJ3mWuZv2OE3s0g==}\n    engines: {node: '>=0.10.0'}\n\n  stream-browserify@2.0.2:\n    resolution: {integrity: sha512-nX6hmklHs/gr2FuxYDltq8fJA1GDlxKQCz8O/IM4atRqBH8OORmBNgfvW5gG10GT/qQ9u0CzIvr2X5Pkt6ntqg==}\n\n  stream-http@2.8.3:\n    resolution: {integrity: sha512-+TSkfINHDo4J+ZobQLWiMouQYB+UVYFttRA94FpEzzJ7ZdqcL4uUUQ7WkdkI4DSozGmgBUE/a47L+38PenXhUw==}\n\n  strict-uri-encode@1.1.0:\n    resolution: {integrity: sha512-R3f198pcvnB+5IpnBlRkphuE9n46WyVl8I39W/ZUTZLz4nqSP/oLYUrcnJrw462Ds8he4YKMov2efsTIw1BDGQ==}\n    engines: {node: '>=0.10.0'}\n\n  strict-uri-encode@2.0.0:\n    resolution: {integrity: sha512-QwiXZgpRcKkhTj2Scnn++4PKtWsH0kpzZ62L2R6c/LUVYv7hVnZqcg2+sMuT6R7Jusu1vviK/MFsu6kNJfWlEQ==}\n    engines: {node: '>=4'}\n\n  string-argv@0.3.1:\n    resolution: {integrity: sha512-a1uQGz7IyVy9YwhqjZIZu1c8JO8dNIe20xBmSS6qu9kv++k3JGzCVmprbNN5Kn+BgzD5E7YYwg1CcjuJMRNsvg==}\n    engines: {node: '>=0.6.19'}\n\n  string-convert@0.2.1:\n    resolution: {integrity: sha512-u/1tdPl4yQnPBjnVrmdLo9gtuLvELKsAoRapekWggdiQNvvvum+jYF329d84NAa660KQw7pB2n36KrIKVoXa3A==}\n\n  string-length@4.0.2:\n    resolution: {integrity: sha512-+l6rNN5fYHNhZZy41RXsYptCjA2Igmq4EG7kZAYFQI1E1VTXarr6ZPXBg6eq7Y6eK4FEhY6AJlyuFIb/v/S0VQ==}\n    engines: {node: '>=10'}\n\n  string-width@4.2.3:\n    resolution: {integrity: sha512-wKyQRQpjJ0sIp62ErSZdGsjMJWsap5oRNihHhu6G7JVO/9jIB6UyevL+tXuOqrng8j/cxKTWyWUwvSTriiZz/g==}\n    engines: {node: '>=8'}\n\n  string_decoder@1.1.1:\n    resolution: {integrity: sha512-n/ShnvDi6FHbbVfviro+WojiFzv+s8MPMHBczVePfUpDJLwoLT0ht1l4YwBCbi8pJAveEEdnkHyPyTP/mzRfwg==}\n\n  string_decoder@1.3.0:\n    resolution: {integrity: sha512-hkRX8U1WjJFd8LsDJ2yQ/wWWxaopEsABU1XfkM8A+j0+85JAGppt16cr1Whg6KIbb4okU6Mql6BOj+uup/wKeA==}\n\n  stringify-object@3.3.0:\n    resolution: {integrity: sha512-rHqiFh1elqCQ9WPLIC8I0Q/g/wj5J1eMkyoiD6eoQApWHP0FtlK7rqnhmabL5VUY9JQCcqwwvlOaSuutekgyrw==}\n    engines: {node: '>=4'}\n\n  strip-ansi@6.0.1:\n    resolution: {integrity: sha512-Y38VPSHcqkFrCpFnQ9vuSXmquuv5oXOKpGeT6aGrr3o3Gc9AlVa6JBfUSOCnbxGGZF+/0ooI7KrPuUSztUdU5A==}\n    engines: {node: '>=8'}\n\n  strip-bom@4.0.0:\n    resolution: {integrity: sha512-3xurFv5tEgii33Zi8Jtp55wEIILR9eh34FAW00PZf+JnSsTmV/ioewSgQl97JHvgjoRGwPShsWm+IdrxB35d0w==}\n    engines: {node: '>=8'}\n\n  strip-eof@1.0.0:\n    resolution: {integrity: sha512-7FCwGGmx8mD5xQd3RPUvnSpUXHM3BWuzjtpD4TXsfcZ9EL4azvVVUscFYwD9nx8Kh+uCBC00XBtAykoMHwTh8Q==}\n    engines: {node: '>=0.10.0'}\n\n  strip-final-newline@2.0.0:\n    resolution: {integrity: sha512-BrpvfNAE3dcvq7ll3xVumzjKjZQ5tI1sEUIKr3Uoks0XUl45St3FlatVqef9prk4jRDzhW6WZg+3bk93y6pLjA==}\n    engines: {node: '>=6'}\n\n  strip-indent@2.0.0:\n    resolution: {integrity: sha512-RsSNPLpq6YUL7QYy44RnPVTn/lcVZtb48Uof3X5JLbF4zD/Gs7ZFDv2HWol+leoQN2mT86LAzSshGfkTlSOpsA==}\n    engines: {node: '>=4'}\n\n  supports-color@5.5.0:\n    resolution: {integrity: sha512-QjVjwdXIt408MIiAqCX4oUKsgU2EqAGzs2Ppkm4aQYbjm+ZEWEcW4SfFNTr4uMNZma0ey4f5lgLrkB0aX0QMow==}\n    engines: {node: '>=4'}\n\n  supports-color@6.1.0:\n    resolution: {integrity: sha512-qe1jfm1Mg7Nq/NSh6XE24gPXROEVsWHxC1LIx//XNlD9iw7YZQGjZNjYN7xGaEG6iKdA8EtNFW6R0gjnVXp+wQ==}\n    engines: {node: '>=6'}\n\n  supports-color@7.2.0:\n    resolution: {integrity: sha512-qpCAvRl9stuOHveKsn7HncJRvv501qIacKzQlO/+Lwxc9+0q2wLyv4Dfvt80/DPn2pqOBsJdDiogXGR9+OvwRw==}\n    engines: {node: '>=8'}\n\n  supports-hyperlinks@2.3.0:\n    resolution: {integrity: sha512-RpsAZlpWcDwOPQA22aCH4J0t7L8JmAvsCxfOSEwm7cQs3LshN36QaTkwd70DnBOXDWGssw2eUoc8CaRWT0XunA==}\n    engines: {node: '>=8'}\n\n  supports-preserve-symlinks-flag@1.0.0:\n    resolution: {integrity: sha512-ot0WnXS9fgdkgIcePe6RHNk1WA8+muPa6cSjeR3V8K27q9BB1rTE3R1p7Hv0z1ZyAc8s6Vvv8DIyWf681MAt0w==}\n    engines: {node: '>= 0.4'}\n\n  swr@1.3.0:\n    resolution: {integrity: sha512-dkghQrOl2ORX9HYrMDtPa7LTVHJjCTeZoB1dqTbnnEDlSvN8JEKpYIYurDfvbQFUUS8Cg8PceFVZNkW0KNNYPw==}\n    peerDependencies:\n      react: ^16.11.0 || ^17.0.0 || ^18.0.0\n\n  symbol-tree@3.2.4:\n    resolution: {integrity: sha512-9QNk5KwDF+Bvz+PyObkmSYjI5ksVUYtjW7AU22r2NKcfLJcXp96hkDWU3+XndOsUb+AQ9QhfzfCT2O+CNWT5Tw==}\n\n  terminal-link@2.1.1:\n    resolution: {integrity: sha512-un0FmiRUQNr5PJqy9kP7c40F5BOfpGlYTrxonDChEZB7pzZxRNp/bt+ymiy9/npwXya9KH99nJ/GXFIiUkYGFQ==}\n    engines: {node: '>=8'}\n\n  terser@5.14.2:\n    resolution: {integrity: sha512-oL0rGeM/WFQCUd0y2QrWxYnq7tfSuKBiqTjRPWrRgB46WD/kiwHwF8T23z78H6Q6kGCuuHcPB+KULHRdxvVGQA==}\n    engines: {node: '>=10'}\n    hasBin: true\n\n  test-exclude@6.0.0:\n    resolution: {integrity: sha512-cAGWPIyOHU6zlmg88jwm7VRyXnMN7iV68OGAbYDk/Mh/xC/pzVPlQtY6ngoIH/5/tciuhGfvESU8GrHrcxD56w==}\n    engines: {node: '>=8'}\n\n  throat@5.0.0:\n    resolution: {integrity: sha512-fcwX4mndzpLQKBS1DVYhGAcYaYt7vsHNIvQV+WXMvnow5cgjPphq5CaayLaGsjRdSCKZFNGt7/GYAuXaNOiYCA==}\n\n  throttle-debounce@5.0.2:\n    resolution: {integrity: sha512-B71/4oyj61iNH0KeCamLuE2rmKuTO5byTOSVwECM5FA7TiAiAW+UqTKZ9ERueC4qvgSttUhdmq1mXC3kJqGX7A==}\n    engines: {node: '>=12.22'}\n\n  through@2.3.8:\n    resolution: {integrity: sha512-w89qg7PI8wAdvX60bMDP+bFoD5Dvhm9oLheFp5O4a2QF0cSBGsBX4qZmadPMvVqlLJBBci+WqGGOAPvcDeNSVg==}\n\n  timers-browserify@2.0.12:\n    resolution: {integrity: sha512-9phl76Cqm6FhSX9Xe1ZUAMLtm1BLkKj2Qd5ApyWkXzsMRaA7dgr81kf4wJmQf/hAvg8EEyJxDo3du/0KlhPiKQ==}\n    engines: {node: '>=0.6.0'}\n\n  tiny-invariant@1.3.3:\n    resolution: {integrity: sha512-+FbBPE1o9QAYvviau/qC5SE3caw21q3xkvWKBtja5vgqOWIHHJ3ioaq1VPfn/Szqctz2bU/oYeKd9/z5BL+PVg==}\n\n  tiny-warning@1.0.3:\n    resolution: {integrity: sha512-lBN9zLN/oAf68o3zNXYrdCt1kP8WsiGW8Oo2ka41b2IM5JL/S1CTyX1rW0mb/zSuJun0ZUrDxx4sqvYS2FWzPA==}\n\n  tmpl@1.0.5:\n    resolution: {integrity: sha512-3f0uOEAQwIqGuWW2MVzYg8fV/QNnc/IpuJNG837rLuczAaLVHslWHZQj4IGiEl5Hs3kkbhwL9Ab7Hrsmuj+Smw==}\n\n  to-arraybuffer@1.0.1:\n    resolution: {integrity: sha512-okFlQcoGTi4LQBG/PgSYblw9VOyptsz2KJZqc6qtgGdes8VktzUQkj4BI2blit072iS8VODNcMA+tvnS9dnuMA==}\n\n  to-object-path@0.3.0:\n    resolution: {integrity: sha512-9mWHdnGRuh3onocaHzukyvCZhzvr6tiflAy/JRFXcJX0TjgfWA9pk9t8CMbzmBE4Jfw58pXbkngtBtqYxzNEyg==}\n    engines: {node: '>=0.10.0'}\n\n  to-regex-range@2.1.1:\n    resolution: {integrity: sha512-ZZWNfCjUokXXDGXFpZehJIkZqq91BcULFq/Pi7M5i4JnxXdhMKAK682z8bCW3o8Hj1wuuzoKcW3DfVzaP6VuNg==}\n    engines: {node: '>=0.10.0'}\n\n  to-regex-range@5.0.1:\n    resolution: {integrity: sha512-65P7iz6X5yEr1cwcgvQxbbIw7Uk3gOy5dIdtZ4rDveLqhrdJP+Li/Hx6tyK0NEb+2GCyneCMJiGqrADCSNk8sQ==}\n    engines: {node: '>=8.0'}\n\n  to-regex@3.0.2:\n    resolution: {integrity: sha512-FWtleNAtZ/Ki2qtqej2CXTOayOH9bHDQF+Q48VpWyDXjbYxA4Yz8iDB31zXOBUlOHHKidDbqGVrTUvQMPmBGBw==}\n    engines: {node: '>=0.10.0'}\n\n  toggle-selection@1.0.6:\n    resolution: {integrity: sha512-BiZS+C1OS8g/q2RRbJmy59xpyghNBqrr6k5L/uKBGRsTfxmu3ffiRnd8mlGPUVayg8pvfi5urfnu8TU7DVOkLQ==}\n\n  tough-cookie@4.1.4:\n    resolution: {integrity: sha512-Loo5UUvLD9ScZ6jh8beX1T6sO1w2/MpCRpEP7V280GKMVUQ0Jzar2U3UJPsrdbziLEMMhu3Ujnq//rhiFuIeag==}\n    engines: {node: '>=6'}\n\n  tr46@2.1.0:\n    resolution: {integrity: sha512-15Ih7phfcdP5YxqiB+iDtLoaTz4Nd35+IiAv0kQ5FNKHzXgdWqPoTIqEDDJmXceQt4JZk6lVPT8lnDlPpGDppw==}\n    engines: {node: '>=8'}\n\n  tslib@2.8.1:\n    resolution: {integrity: sha512-oJFu94HQb+KVduSUQL7wnpmqnfmLsOA/nAh6b6EH0wCEoK0/mPeXU6c3wKDV83MkOuHPRHtSXKKU99IBazS/2w==}\n\n  tty-browserify@0.0.0:\n    resolution: {integrity: sha512-JVa5ijo+j/sOoHGjw0sxw734b1LhBkQ3bvUGNdxnVXDCX81Yx7TFgnZygxrIIWn23hbfTaMYLwRmAxFyDuFmIw==}\n\n  tween-functions@1.2.0:\n    resolution: {integrity: sha512-PZBtLYcCLtEcjL14Fzb1gSxPBeL7nWvGhO5ZFPGqziCcr8uvHp0NDmdjBchp6KHL+tExcg0m3NISmKxhU394dA==}\n\n  type-detect@4.0.8:\n    resolution: {integrity: sha512-0fr/mIH1dlO+x7TlcMy+bIDqKPsw/70tVyeHW787goQjhmqaZe10uwLujubK9q9Lg6Fiho1KUKDYz0Z7k7g5/g==}\n    engines: {node: '>=4'}\n\n  type-fest@0.21.3:\n    resolution: {integrity: sha512-t0rzBq87m3fVcduHDUFhKmyyX+9eo6WQjZvf51Ea/M0Q7+T374Jp1aUiyUl0GKxp8M/OETVHSDvmkyPgvX+X2w==}\n    engines: {node: '>=10'}\n\n  type-fest@0.6.0:\n    resolution: {integrity: sha512-q+MB8nYR1KDLrgr4G5yemftpMC7/QLqVndBmEEdqzmNj5dcFOO4Oo8qlwZE3ULT3+Zim1F8Kq4cBnikNhlCMlg==}\n    engines: {node: '>=8'}\n\n  type-fest@0.8.1:\n    resolution: {integrity: sha512-4dbzIzqvjtgiM5rw1k5rEHtBANKmdudhGyBEajN01fEyhaAIhsoKNy6y7+IN93IfpFtwY9iqi7kD+xwKhQsNJA==}\n    engines: {node: '>=8'}\n\n  typedarray-to-buffer@3.1.5:\n    resolution: {integrity: sha512-zdu8XMNEDepKKR+XYOXAVPtWui0ly0NtohUscw+UmaHiAWT8hrV1rr//H6V+0DvJ3OQ19S979M0laLfX8rm82Q==}\n\n  typescript@4.9.5:\n    resolution: {integrity: sha512-1FXk9E2Hm+QzZQ7z+McJiHL4NW1F2EzMu9Nq9i3zAaGqibafqYwCVU6WyWAuyQRRzOlxou8xZSyXLEN8oKj24g==}\n    engines: {node: '>=4.2.0'}\n    hasBin: true\n\n  ua-parser-js@0.7.39:\n    resolution: {integrity: sha512-IZ6acm6RhQHNibSt7+c09hhvsKy9WUr4DVbeq9U8o71qxyYtJpQeDxQnMrVqnIFMLcQjHO0I9wgfO2vIahht4w==}\n    hasBin: true\n\n  umi-request@1.4.0:\n    resolution: {integrity: sha512-OknwtQZddZHi0Ggi+Vr/olJ7HNMx4AzlywyK0W3NZBT7B0stjeZ9lcztA85dBgdAj3KVk8uPJPZSnGaDjELhrA==}\n\n  umi@3.5.43:\n    resolution: {integrity: sha512-WWusH/o3MTGIJ+S6MiUquz5OwOAQKVdgGHD0CwYBBXcUmwodeZ1mpQSfj8u7VO/OLgVfCmBw8ENsdaWEK6OMtw==}\n    hasBin: true\n\n  undici-types@6.20.0:\n    resolution: {integrity: sha512-Ny6QZ2Nju20vw1SRHe3d9jVu6gJ+4e3+MMpqu7pqE5HT6WsTSlce++GQmK5UXS8mzV8DSYHrQH+Xrf2jVcuKNg==}\n\n  union-value@1.0.1:\n    resolution: {integrity: sha512-tJfXmxMeWYnczCVs7XAEvIV7ieppALdyepWMkHkwciRpZraG/xwT+s2JN8+pr1+8jCRf80FFzvr+MpQeeoF4Xg==}\n    engines: {node: '>=0.10.0'}\n\n  uniq@1.0.1:\n    resolution: {integrity: sha512-Gw+zz50YNKPDKXs+9d+aKAjVwpjNwqzvNpLigIruT4HA9lMZNdMqs9x07kKHB/L9WRzqp4+DlTU5s4wG2esdoA==}\n\n  universalify@0.2.0:\n    resolution: {integrity: sha512-CJ1QgKmNg3CwvAv/kOFmtnEN05f0D/cn9QntgNOQlQF9dgvVTHj3t+8JPdjqawCHk7V/KA+fbUqzZ9XWhcqPUg==}\n    engines: {node: '>= 4.0.0'}\n\n  unset-value@1.0.0:\n    resolution: {integrity: sha512-PcA2tsuGSF9cnySLHTLSh2qrQiJ70mn+r+Glzxv2TWZblxsxCC52BDlZoPCsz7STd9pN7EZetkWZBAvk4cgZdQ==}\n    engines: {node: '>=0.10.0'}\n\n  unstated-next@1.1.0:\n    resolution: {integrity: sha512-AAn47ZncPvgBGOvMcn8tSRxsrqwf2VdAPxLASTuLJvZt4rhKfDvUkmYZLGfclImSfTVMv7tF4ynaVxin0JjDCA==}\n\n  update-browserslist-db@1.1.1:\n    resolution: {integrity: sha512-R8UzCaa9Az+38REPiJ1tXlImTJXlVfgHZsglwBD/k6nj76ctsH1E3q4doGrukiLQd3sGQYu56r5+lo5r94l29A==}\n    hasBin: true\n    peerDependencies:\n      browserslist: '>= 4.21.0'\n\n  uri-js@4.4.1:\n    resolution: {integrity: sha512-7rKUyy33Q1yc98pQ1DAmLtwX109F7TIfWlW1Ydo8Wl1ii1SeHieeh0HHfPeL2fMXK6z0s8ecKs9frCuLJvndBg==}\n\n  urix@0.1.0:\n    resolution: {integrity: sha512-Am1ousAhSLBeB9cG/7k7r2R0zj50uDRlZHPGbazid5s9rlF1F/QKYObEKSIunSjIOkJZqwRRLpvewjEkM7pSqg==}\n    deprecated: Please see https://github.com/lydell/urix#deprecated\n\n  url-parse@1.5.10:\n    resolution: {integrity: sha512-WypcfiRhfeUP9vvF0j6rw0J3hrWrw6iZv3+22h6iRMJ/8z1Tj6XfLP4DsUix5MhMPnXpiHDoKyoZ/bdCkwBCiQ==}\n\n  url@0.11.4:\n    resolution: {integrity: sha512-oCwdVC7mTuWiPyjLUz/COz5TLk6wgp0RCsN+wHZ2Ekneac9w8uuV0njcbbie2ME+Vs+d6duwmYuR3HgQXs1fOg==}\n    engines: {node: '>= 0.4'}\n\n  use-json-comparison@1.0.6:\n    resolution: {integrity: sha512-xPadt5yMRbEmVfOSGFSMqjjICrq7nLbfSH3rYIXsrtcuFX7PmbYDN/ku8ObBn3v8o/yZelO1OxUS5+5TI3+fUw==}\n    peerDependencies:\n      react: '>=16.9.0'\n\n  use-media-antd-query@1.1.0:\n    resolution: {integrity: sha512-B6kKZwNV4R+l4Rl11sWO7HqOay9alzs1Vp1b4YJqjz33YxbltBCZtt/yxXxkXN9rc1S7OeEL/GbwC30Wmqhw6Q==}\n    peerDependencies:\n      react: '>=16.9.0'\n\n  use-subscription@1.5.1:\n    resolution: {integrity: sha512-Xv2a1P/yReAjAbhylMfFplFKj9GssgTwN7RlcTxBujFQcloStWNDQdc4g4NRWH9xS4i/FDk04vQBptAXoF3VcA==}\n    peerDependencies:\n      react: ^16.8.0 || ^17.0.0\n\n  use@3.1.1:\n    resolution: {integrity: sha512-cwESVXlO3url9YWlFW/TA9cshCEhtu7IKJ/p5soJ/gGpj7vbvFrAY/eIioQ6Dw23KjZhYgiIo8HOs1nQ2vr/oQ==}\n    engines: {node: '>=0.10.0'}\n\n  util-deprecate@1.0.2:\n    resolution: {integrity: sha512-EPD5q1uXyFxJpCrLnCc1nHnq3gOa6DZBocAIiI2TaSCA7VCJ1UJDMagCzIkXNsUYfD1daK//LTEQ8xiIbrHtcw==}\n\n  util@0.10.4:\n    resolution: {integrity: sha512-0Pm9hTQ3se5ll1XihRic3FDIku70C+iHUdT/W926rSgHV5QgXsYbKZN8MSC3tJtSkhuROzvsQjAaFENRXr+19A==}\n\n  util@0.11.1:\n    resolution: {integrity: sha512-HShAsny+zS2TZfaXxD9tYj4HQGlBezXZMZuM/S5PKLLoZkShZiGk9o5CzukI1LVHZvjdvZ2Sj1aW/Ndn2NB/HQ==}\n\n  uuid@8.3.2:\n    resolution: {integrity: sha512-+NYs2QeMWy+GWFOEm9xnn6HCDp0l7QBD7ml8zLUmJ+93Q5NF0NocErnwkTkXVFNiX3/fpC6afS8Dhb/gz7R7eg==}\n    hasBin: true\n\n  v8-compile-cache@2.3.0:\n    resolution: {integrity: sha512-l8lCEmLcLYZh4nbunNZvQCJc5pv7+RCwa8q/LdUx8u7lsWvPDKmpodJAJNwkAhJC//dFY48KuIEmjtd4RViDrA==}\n\n  v8-to-istanbul@7.1.2:\n    resolution: {integrity: sha512-TxNb7YEUwkLXCQYeudi6lgQ/SZrzNO4kMdlqVxaZPUIUjCv6iSSypUQX70kNBSERpQ8fk48+d61FXk+tgqcWow==}\n    engines: {node: '>=10.10.0'}\n\n  validate-npm-package-license@3.0.4:\n    resolution: {integrity: sha512-DpKm2Ui/xN7/HQKCtpZxoRWBhZ9Z0kqtygG8XCgNQ8ZlDnxuQmWhj566j8fN4Cu3/JmbhsDo7fcAJq4s9h27Ew==}\n\n  value-equal@1.0.1:\n    resolution: {integrity: sha512-NOJ6JZCAWr0zlxZt+xqCHNTEKOsrks2HQd4MqhP1qy4z1SkbEP467eNx6TgDKXMvUOb+OENfJCZwM+16n7fRfw==}\n\n  vm-browserify@1.1.2:\n    resolution: {integrity: sha512-2ham8XPWTONajOR0ohOKOHXkm3+gaBmGut3SRuu75xLd/RRaY6vqgh8NBYYk7+RW3u5AtzPQZG8F10LHkl0lAQ==}\n\n  w3c-hr-time@1.0.2:\n    resolution: {integrity: sha512-z8P5DvDNjKDoFIHK7q8r8lackT6l+jo/Ye3HOle7l9nICP9lf1Ci25fy9vHd0JOWewkIFzXIEig3TdKT7JQ5fQ==}\n    deprecated: Use your platform's native performance.now() and performance.timeOrigin.\n\n  w3c-xmlserializer@2.0.0:\n    resolution: {integrity: sha512-4tzD0mF8iSiMiNs30BiLO3EpfGLZUT2MSX/G+o7ZywDzliWQ3OPtTZ0PTC3B3ca1UAf4cJMHB+2Bf56EriJuRA==}\n    engines: {node: '>=10'}\n\n  walker@1.0.8:\n    resolution: {integrity: sha512-ts/8E8l5b7kY0vlWLewOkDXMmPdLcVV4GmOQLyxuSswIJsweeFZtAsMF7k1Nszz+TYBQrlYRmzOnr398y1JemQ==}\n\n  warning@3.0.0:\n    resolution: {integrity: sha512-jMBt6pUrKn5I+OGgtQ4YZLdhIeJmObddh6CsibPxyQ5yPZm1XExSyzC1LCNX7BzhxWgiHmizBWJTHJIjMjTQYQ==}\n\n  warning@4.0.3:\n    resolution: {integrity: sha512-rpJyN222KWIvHJ/F53XSZv0Zl/accqHR8et1kpaMTD/fLCRxtV8iX8czMzY7sVZupTI3zcUTg8eycS2kNF9l6w==}\n\n  webidl-conversions@5.0.0:\n    resolution: {integrity: sha512-VlZwKPCkYKxQgeSbH5EyngOmRp7Ww7I9rQLERETtf5ofd9pGeswWiOtogpEO850jziPRarreGxn5QIiTqpb2wA==}\n    engines: {node: '>=8'}\n\n  webidl-conversions@6.1.0:\n    resolution: {integrity: sha512-qBIvFLGiBpLjfwmYAaHPXsn+ho5xZnGvyGvsarywGNc8VyQJUMHJ8OBKGGrPER0okBeMDaan4mNBlgBROxuI8w==}\n    engines: {node: '>=10.4'}\n\n  webpack-chain@6.5.1:\n    resolution: {integrity: sha512-7doO/SRtLu8q5WM0s7vPKPWX580qhi0/yBHkOxNkv50f6qB76Zy9o2wRTrrPULqYTvQlVHuvbA8v+G5ayuUDsA==}\n    engines: {node: '>=8'}\n    deprecated: Package no longer supported. Contact Support at https://www.npmjs.com/support for more info.\n\n  whatwg-encoding@1.0.5:\n    resolution: {integrity: sha512-b5lim54JOPN9HtzvK9HFXvBma/rnfFeqsic0hSpjtDbVxR3dJKLc+KB4V6GgiGOvl7CY/KNh8rxSo9DKQrnUEw==}\n\n  whatwg-fetch@3.6.20:\n    resolution: {integrity: sha512-EqhiFU6daOA8kpjOWTL0olhVOF3i7OrFzSYiGsEMB8GcXS+RrzauAERX65xMeNWVqxA6HXH2m69Z9LaKKdisfg==}\n\n  whatwg-mimetype@2.3.0:\n    resolution: {integrity: sha512-M4yMwr6mAnQz76TbJm914+gPpB/nCwvZbJU28cUD6dR004SAxDLOOSUaB1JDRqLtaOV/vi0IC5lEAGFgrjGv/g==}\n\n  whatwg-url@8.7.0:\n    resolution: {integrity: sha512-gAojqb/m9Q8a5IV96E3fHJM70AzCkgt4uXYX2O7EmuyOnLrViCQlsEBmF9UQIu3/aeAIp2U17rtbpZWNntQqdg==}\n    engines: {node: '>=10'}\n\n  which-module@2.0.1:\n    resolution: {integrity: sha512-iBdZ57RDvnOR9AGBhML2vFZf7h8vmBjhoaZqODJBFWHVtKkDmKuHai3cx5PgVMrX5YDNp27AofYbAwctSS+vhQ==}\n\n  which@1.3.1:\n    resolution: {integrity: sha512-HxJdYWq1MTIQbJ3nw0cqssHoTNU267KlrDuGZ1WYlxDStUtKUhOaJmh112/TZmHxxUfuJqPXSOm7tDyas0OSIQ==}\n    hasBin: true\n\n  which@2.0.2:\n    resolution: {integrity: sha512-BLI3Tl1TW3Pvl70l3yq3Y64i+awpwXqsGBYWkkqMtnbXgrMD+yj7rhW0kuEDxzJaYXGjEW5ogapKNMEKNMjibA==}\n    engines: {node: '>= 8'}\n    hasBin: true\n\n  wrap-ansi@6.2.0:\n    resolution: {integrity: sha512-r6lPcBGxZXlIcymEu7InxDMhdW0KDxpLgoFLcguasxCaJ/SOIZwINatK9KY/tf+ZrlywOKU0UDj3ATXUBfxJXA==}\n    engines: {node: '>=8'}\n\n  wrap-ansi@7.0.0:\n    resolution: {integrity: sha512-YVGIj2kamLSTxw6NsZjoBxfSwsn0ycdesmc4p+Q21c5zPuZ1pl+NfxVdxPtdHvmNVOQ6XSYG4AUtyt/Fi7D16Q==}\n    engines: {node: '>=10'}\n\n  wrappy@1.0.2:\n    resolution: {integrity: sha512-l4Sp/DRseor9wL6EvV2+TuQn63dMkPjZ/sp9XkghTEbV9KlPS1xUsZ3u7/IQO4wxtcFB4bgpQPRcR3QCvezPcQ==}\n\n  write-file-atomic@3.0.3:\n    resolution: {integrity: sha512-AvHcyZ5JnSfq3ioSyjrBkH9yW4m7Ayk8/9My/DD9onKeu/94fwrMocemO2QAJFAlnnDN+ZDS+ZjAR5ua1/PV/Q==}\n\n  ws@7.5.10:\n    resolution: {integrity: sha512-+dbF1tHwZpXcbOJdVOkzLDxZP1ailvSxM6ZweXTegylPny803bFhA+vqBYw4s31NSAk4S2Qz+AKXK9a4wkdjcQ==}\n    engines: {node: '>=8.3.0'}\n    peerDependencies:\n      bufferutil: ^4.0.1\n      utf-8-validate: ^5.0.2\n    peerDependenciesMeta:\n      bufferutil:\n        optional: true\n      utf-8-validate:\n        optional: true\n\n  xml-name-validator@3.0.0:\n    resolution: {integrity: sha512-A5CUptxDsvxKJEU3yO6DuWBSJz/qizqzJKOMIfUJHETbBw/sFaDxgd6fxm1ewUaM0jZ444Fc5vC5ROYurg/4Pw==}\n\n  xmlchars@2.2.0:\n    resolution: {integrity: sha512-JZnDKK8B0RCDw84FNdDAIpZK+JuJw+s7Lz8nksI7SIuU3UXJJslUthsi+uWBUYOwPFwW7W7PRLRfUKpxjtjFCw==}\n\n  xtend@4.0.2:\n    resolution: {integrity: sha512-LKYU1iAXJXUgAXn9URjiu+MWhyUXHsvfp7mcuYm9dSUKK0/CjtrUwFAxD82/mCWbtLsGjFIad0wIsod4zrTAEQ==}\n    engines: {node: '>=0.4'}\n\n  y18n@4.0.3:\n    resolution: {integrity: sha512-JKhqTOwSrqNA1NY5lSztJ1GrBiUodLMmIZuLiDaMRJ+itFd+ABVE8XBjOvIWL+rSqNDC74LCSFmlb/U4UZ4hJQ==}\n\n  yallist@2.1.2:\n    resolution: {integrity: sha512-ncTzHV7NvsQZkYe1DW7cbDLm0YpzHmZF5r/iyP3ZnQtMiJ+pjzisCiMNI+Sj+xQF5pXhSHxSB3uDbsBTzY/c2A==}\n\n  yallist@3.1.1:\n    resolution: {integrity: sha512-a4UGQaWPH59mOXUYnAG2ewncQS4i4F43Tv3JoAM+s2VDAmS9NsK8GpDMLrCHPksFT7h3K6TOoUNn2pb7RoXx4g==}\n\n  yaml@1.10.2:\n    resolution: {integrity: sha512-r3vXyErRCYJ7wg28yvBY5VSoAF8ZvlcW9/BwUzEtUsjvX/DKs24dIkuwjtuprwJJHsbyUbLApepYTR1BN4uHrg==}\n    engines: {node: '>= 6'}\n\n  yargs-parser@18.1.3:\n    resolution: {integrity: sha512-o50j0JeToy/4K6OZcaQmW6lyXXKhq7csREXcDwk2omFPJEwUNOVtJKvmDr9EI1fAJZUyZcRF7kxGBWmRXudrCQ==}\n    engines: {node: '>=6'}\n\n  yargs@15.4.1:\n    resolution: {integrity: sha512-aePbxDmcYW++PaqBsJ+HYUFwCdv4LVvdnhBy78E57PIor8/OVvhMrADFFEDh8DHDFRv/O9i3lPhsENjO7QX0+A==}\n    engines: {node: '>=8'}\n\n  yorkie@2.0.0:\n    resolution: {integrity: sha512-jcKpkthap6x63MB4TxwCyuIGkV0oYP/YRyuQU5UO0Yz/E/ZAu+653/uov+phdmO54n6BcvFRyyt0RRrWdN2mpw==}\n    engines: {node: '>=4'}\n\n  zscroller@0.4.8:\n    resolution: {integrity: sha512-G5NiNLKx2+QhhvZi2yV1jjVXY50otktxkseX2hG2N/eixohOUk0AY8ZpbAxNqS9oJS/NxItCsowupy2tsXxAMw==}\n\nsnapshots:\n\n  '@ahooksjs/use-request@2.8.15(react@17.0.2)':\n    dependencies:\n      lodash.debounce: 4.0.8\n      lodash.throttle: 4.1.1\n      react: 17.0.2\n\n  '@ampproject/remapping@2.3.0':\n    dependencies:\n      '@jridgewell/gen-mapping': 0.3.8\n      '@jridgewell/trace-mapping': 0.3.25\n\n  '@ant-design/colors@6.0.0':\n    dependencies:\n      '@ctrl/tinycolor': 3.6.1\n\n  '@ant-design/icons-svg@4.4.2': {}\n\n  '@ant-design/icons@4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)':\n    dependencies:\n      '@ant-design/colors': 6.0.0\n      '@ant-design/icons-svg': 4.4.2\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      lodash: 4.17.21\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  '@ant-design/pro-layout@6.38.22(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2)':\n    dependencies:\n      '@ant-design/icons': 4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@ant-design/pro-provider': 1.10.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@ant-design/pro-utils': 1.45.3(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@babel/runtime': 7.26.0\n      '@umijs/route-utils': 2.2.2\n      '@umijs/ssr-darkreader': 4.9.45\n      '@umijs/use-params': 1.0.9(react@17.0.2)\n      antd: 4.24.16(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      classnames: 2.5.1\n      lodash.merge: 4.6.2\n      omit.js: 2.0.2\n      path-to-regexp: 2.4.0\n      rc-resize-observer: 1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      swr: 1.3.0(react@17.0.2)\n      unstated-next: 1.1.0\n      use-json-comparison: 1.0.6(react@17.0.2)\n      use-media-antd-query: 1.1.0(react@17.0.2)\n      warning: 4.0.3\n    transitivePeerDependencies:\n      - prop-types\n      - react-dom\n\n  '@ant-design/pro-provider@1.10.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)':\n    dependencies:\n      '@babel/runtime': 7.26.0\n      antd: 4.24.16(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      swr: 1.3.0(react@17.0.2)\n    transitivePeerDependencies:\n      - react-dom\n\n  '@ant-design/pro-utils@1.45.3(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2)':\n    dependencies:\n      '@ant-design/icons': 4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@ant-design/pro-provider': 1.10.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@babel/runtime': 7.26.0\n      antd: 4.24.16(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      classnames: 2.5.1\n      moment: 2.30.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      react-sortable-hoc: 2.0.0(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      swr: 1.3.0(react@17.0.2)\n    transitivePeerDependencies:\n      - prop-types\n\n  '@ant-design/react-slick@1.0.2(react@17.0.2)':\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      json2mq: 0.2.0\n      react: 17.0.2\n      resize-observer-polyfill: 1.5.1\n      throttle-debounce: 5.0.2\n\n  '@babel/code-frame@7.26.2':\n    dependencies:\n      '@babel/helper-validator-identifier': 7.25.9\n      js-tokens: 4.0.0\n      picocolors: 1.1.1\n\n  '@babel/compat-data@7.26.3': {}\n\n  '@babel/core@7.18.6':\n    dependencies:\n      '@ampproject/remapping': 2.3.0\n      '@babel/code-frame': 7.26.2\n      '@babel/generator': 7.26.3\n      '@babel/helper-compilation-targets': 7.25.9\n      '@babel/helper-module-transforms': 7.26.0(@babel/core@7.18.6)\n      '@babel/helpers': 7.26.0\n      '@babel/parser': 7.26.3\n      '@babel/template': 7.25.9\n      '@babel/traverse': 7.26.4\n      '@babel/types': 7.26.3\n      convert-source-map: 1.9.0\n      debug: 4.4.0\n      gensync: 1.0.0-beta.2\n      json5: 2.2.3\n      semver: 6.3.1\n    transitivePeerDependencies:\n      - supports-color\n\n  '@babel/generator@7.26.3':\n    dependencies:\n      '@babel/parser': 7.26.3\n      '@babel/types': 7.26.3\n      '@jridgewell/gen-mapping': 0.3.8\n      '@jridgewell/trace-mapping': 0.3.25\n      jsesc: 3.1.0\n\n  '@babel/helper-compilation-targets@7.25.9':\n    dependencies:\n      '@babel/compat-data': 7.26.3\n      '@babel/helper-validator-option': 7.25.9\n      browserslist: 4.24.2\n      lru-cache: 5.1.1\n      semver: 6.3.1\n\n  '@babel/helper-module-imports@7.25.9':\n    dependencies:\n      '@babel/traverse': 7.26.4\n      '@babel/types': 7.26.3\n    transitivePeerDependencies:\n      - supports-color\n\n  '@babel/helper-module-transforms@7.26.0(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-module-imports': 7.25.9\n      '@babel/helper-validator-identifier': 7.25.9\n      '@babel/traverse': 7.26.4\n    transitivePeerDependencies:\n      - supports-color\n\n  '@babel/helper-plugin-utils@7.25.9': {}\n\n  '@babel/helper-string-parser@7.25.9': {}\n\n  '@babel/helper-validator-identifier@7.25.9': {}\n\n  '@babel/helper-validator-option@7.25.9': {}\n\n  '@babel/helpers@7.26.0':\n    dependencies:\n      '@babel/template': 7.25.9\n      '@babel/types': 7.26.3\n\n  '@babel/parser@7.26.3':\n    dependencies:\n      '@babel/types': 7.26.3\n\n  '@babel/plugin-syntax-async-generators@7.8.4(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-bigint@7.8.3(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-class-properties@7.12.13(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-class-static-block@7.14.5(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-import-attributes@7.26.0(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-import-meta@7.10.4(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-json-strings@7.8.3(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-logical-assignment-operators@7.10.4(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-nullish-coalescing-operator@7.8.3(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-numeric-separator@7.10.4(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-object-rest-spread@7.8.3(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-optional-catch-binding@7.8.3(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-optional-chaining@7.8.3(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-private-property-in-object@7.14.5(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/plugin-syntax-top-level-await@7.14.5(@babel/core@7.18.6)':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/helper-plugin-utils': 7.25.9\n\n  '@babel/runtime@7.18.6':\n    dependencies:\n      regenerator-runtime: 0.13.11\n\n  '@babel/runtime@7.26.0':\n    dependencies:\n      regenerator-runtime: 0.14.1\n\n  '@babel/template@7.25.9':\n    dependencies:\n      '@babel/code-frame': 7.26.2\n      '@babel/parser': 7.26.3\n      '@babel/types': 7.26.3\n\n  '@babel/traverse@7.26.4':\n    dependencies:\n      '@babel/code-frame': 7.26.2\n      '@babel/generator': 7.26.3\n      '@babel/parser': 7.26.3\n      '@babel/template': 7.25.9\n      '@babel/types': 7.26.3\n      debug: 4.4.0\n      globals: 11.12.0\n    transitivePeerDependencies:\n      - supports-color\n\n  '@babel/types@7.26.3':\n    dependencies:\n      '@babel/helper-string-parser': 7.25.9\n      '@babel/helper-validator-identifier': 7.25.9\n\n  '@bcoe/v8-coverage@0.2.3': {}\n\n  '@bloomberg/record-tuple-polyfill@0.0.3': {}\n\n  '@cnakazawa/watch@1.0.4':\n    dependencies:\n      exec-sh: 0.3.6\n      minimist: 1.2.8\n\n  '@csstools/convert-colors@1.4.0': {}\n\n  '@ctrl/tinycolor@3.6.1': {}\n\n  '@formatjs/intl-displaynames@1.2.10':\n    dependencies:\n      '@formatjs/intl-utils': 2.3.0\n\n  '@formatjs/intl-listformat@1.4.8':\n    dependencies:\n      '@formatjs/intl-utils': 2.3.0\n\n  '@formatjs/intl-pluralrules@1.5.9':\n    dependencies:\n      '@formatjs/intl-utils': 2.3.0\n\n  '@formatjs/intl-relativetimeformat@4.5.16':\n    dependencies:\n      '@formatjs/intl-utils': 2.3.0\n\n  '@formatjs/intl-unified-numberformat@3.3.7':\n    dependencies:\n      '@formatjs/intl-utils': 2.3.0\n\n  '@formatjs/intl-utils@2.3.0': {}\n\n  '@istanbuljs/load-nyc-config@1.1.0':\n    dependencies:\n      camelcase: 5.3.1\n      find-up: 4.1.0\n      get-package-type: 0.1.0\n      js-yaml: 3.14.1\n      resolve-from: 5.0.0\n\n  '@istanbuljs/schema@0.1.3': {}\n\n  '@jest/console@26.6.2':\n    dependencies:\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      chalk: 4.1.2\n      jest-message-util: 26.6.2\n      jest-util: 26.6.2\n      slash: 3.0.0\n\n  '@jest/core@26.6.3':\n    dependencies:\n      '@jest/console': 26.6.2\n      '@jest/reporters': 26.6.2\n      '@jest/test-result': 26.6.2\n      '@jest/transform': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      ansi-escapes: 4.3.2\n      chalk: 4.1.2\n      exit: 0.1.2\n      graceful-fs: 4.2.11\n      jest-changed-files: 26.6.2\n      jest-config: 26.6.3\n      jest-haste-map: 26.6.2\n      jest-message-util: 26.6.2\n      jest-regex-util: 26.0.0\n      jest-resolve: 26.6.2\n      jest-resolve-dependencies: 26.6.3\n      jest-runner: 26.6.3\n      jest-runtime: 26.6.3\n      jest-snapshot: 26.6.2\n      jest-util: 26.6.2\n      jest-validate: 26.6.2\n      jest-watcher: 26.6.2\n      micromatch: 4.0.8\n      p-each-series: 2.2.0\n      rimraf: 3.0.2\n      slash: 3.0.0\n      strip-ansi: 6.0.1\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  '@jest/environment@26.6.2':\n    dependencies:\n      '@jest/fake-timers': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      jest-mock: 26.6.2\n\n  '@jest/fake-timers@26.6.2':\n    dependencies:\n      '@jest/types': 26.6.2\n      '@sinonjs/fake-timers': 6.0.1\n      '@types/node': 22.10.2\n      jest-message-util: 26.6.2\n      jest-mock: 26.6.2\n      jest-util: 26.6.2\n\n  '@jest/globals@26.6.2':\n    dependencies:\n      '@jest/environment': 26.6.2\n      '@jest/types': 26.6.2\n      expect: 26.6.2\n\n  '@jest/reporters@26.6.2':\n    dependencies:\n      '@bcoe/v8-coverage': 0.2.3\n      '@jest/console': 26.6.2\n      '@jest/test-result': 26.6.2\n      '@jest/transform': 26.6.2\n      '@jest/types': 26.6.2\n      chalk: 4.1.2\n      collect-v8-coverage: 1.0.2\n      exit: 0.1.2\n      glob: 7.2.3\n      graceful-fs: 4.2.11\n      istanbul-lib-coverage: 3.2.2\n      istanbul-lib-instrument: 4.0.3\n      istanbul-lib-report: 3.0.1\n      istanbul-lib-source-maps: 4.0.1\n      istanbul-reports: 3.1.7\n      jest-haste-map: 26.6.2\n      jest-resolve: 26.6.2\n      jest-util: 26.6.2\n      jest-worker: 26.6.2\n      slash: 3.0.0\n      source-map: 0.6.1\n      string-length: 4.0.2\n      terminal-link: 2.1.1\n      v8-to-istanbul: 7.1.2\n    optionalDependencies:\n      node-notifier: 8.0.2\n    transitivePeerDependencies:\n      - supports-color\n\n  '@jest/source-map@26.6.2':\n    dependencies:\n      callsites: 3.1.0\n      graceful-fs: 4.2.11\n      source-map: 0.6.1\n\n  '@jest/test-result@26.6.2':\n    dependencies:\n      '@jest/console': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/istanbul-lib-coverage': 2.0.6\n      collect-v8-coverage: 1.0.2\n\n  '@jest/test-sequencer@26.6.3':\n    dependencies:\n      '@jest/test-result': 26.6.2\n      graceful-fs: 4.2.11\n      jest-haste-map: 26.6.2\n      jest-runner: 26.6.3\n      jest-runtime: 26.6.3\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  '@jest/transform@26.6.2':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@jest/types': 26.6.2\n      babel-plugin-istanbul: 6.1.1\n      chalk: 4.1.2\n      convert-source-map: 1.9.0\n      fast-json-stable-stringify: 2.1.0\n      graceful-fs: 4.2.11\n      jest-haste-map: 26.6.2\n      jest-regex-util: 26.0.0\n      jest-util: 26.6.2\n      micromatch: 4.0.8\n      pirates: 4.0.6\n      slash: 3.0.0\n      source-map: 0.6.1\n      write-file-atomic: 3.0.3\n    transitivePeerDependencies:\n      - supports-color\n\n  '@jest/types@26.6.2':\n    dependencies:\n      '@types/istanbul-lib-coverage': 2.0.6\n      '@types/istanbul-reports': 3.0.4\n      '@types/node': 22.10.2\n      '@types/yargs': 15.0.19\n      chalk: 4.1.2\n\n  '@jridgewell/gen-mapping@0.3.8':\n    dependencies:\n      '@jridgewell/set-array': 1.2.1\n      '@jridgewell/sourcemap-codec': 1.5.0\n      '@jridgewell/trace-mapping': 0.3.25\n\n  '@jridgewell/resolve-uri@3.1.2': {}\n\n  '@jridgewell/set-array@1.2.1': {}\n\n  '@jridgewell/source-map@0.3.6':\n    dependencies:\n      '@jridgewell/gen-mapping': 0.3.8\n      '@jridgewell/trace-mapping': 0.3.25\n\n  '@jridgewell/sourcemap-codec@1.5.0': {}\n\n  '@jridgewell/trace-mapping@0.3.25':\n    dependencies:\n      '@jridgewell/resolve-uri': 3.1.2\n      '@jridgewell/sourcemap-codec': 1.5.0\n\n  '@qixian.cs/path-to-regexp@6.1.0': {}\n\n  '@rc-component/portal@1.1.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)':\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  '@sinonjs/commons@1.8.6':\n    dependencies:\n      type-detect: 4.0.8\n\n  '@sinonjs/fake-timers@6.0.1':\n    dependencies:\n      '@sinonjs/commons': 1.8.6\n\n  '@tootallnate/once@1.1.2': {}\n\n  '@types/babel__core@7.20.5':\n    dependencies:\n      '@babel/parser': 7.26.3\n      '@babel/types': 7.26.3\n      '@types/babel__generator': 7.6.8\n      '@types/babel__template': 7.4.4\n      '@types/babel__traverse': 7.20.6\n\n  '@types/babel__generator@7.6.8':\n    dependencies:\n      '@babel/types': 7.26.3\n\n  '@types/babel__template@7.4.4':\n    dependencies:\n      '@babel/parser': 7.26.3\n      '@babel/types': 7.26.3\n\n  '@types/babel__traverse@7.20.6':\n    dependencies:\n      '@babel/types': 7.26.3\n\n  '@types/graceful-fs@4.1.9':\n    dependencies:\n      '@types/node': 22.10.2\n\n  '@types/history@4.7.11': {}\n\n  '@types/history@5.0.0':\n    dependencies:\n      history: 5.3.0\n\n  '@types/hoist-non-react-statics@3.3.6':\n    dependencies:\n      '@types/react': 17.0.83\n      hoist-non-react-statics: 3.3.2\n\n  '@types/invariant@2.2.37': {}\n\n  '@types/isomorphic-fetch@0.0.35': {}\n\n  '@types/istanbul-lib-coverage@2.0.6': {}\n\n  '@types/istanbul-lib-report@3.0.3':\n    dependencies:\n      '@types/istanbul-lib-coverage': 2.0.6\n\n  '@types/istanbul-reports@3.0.4':\n    dependencies:\n      '@types/istanbul-lib-report': 3.0.3\n\n  '@types/json-schema@7.0.15': {}\n\n  '@types/node@22.10.2':\n    dependencies:\n      undici-types: 6.20.0\n\n  '@types/normalize-package-data@2.4.4': {}\n\n  '@types/parse-json@4.0.2': {}\n\n  '@types/prettier@2.7.3': {}\n\n  '@types/prop-types@15.7.14': {}\n\n  '@types/react-dom@16.9.25(@types/react@16.14.62)':\n    dependencies:\n      '@types/react': 16.14.62\n\n  '@types/react-dom@17.0.26(@types/react@17.0.83)':\n    dependencies:\n      '@types/react': 17.0.83\n\n  '@types/react-helmet@6.1.11':\n    dependencies:\n      '@types/react': 17.0.83\n\n  '@types/react-redux@7.1.34':\n    dependencies:\n      '@types/hoist-non-react-statics': 3.3.6\n      '@types/react': 17.0.83\n      hoist-non-react-statics: 3.3.2\n      redux: 4.2.1\n\n  '@types/react-router-config@5.0.2':\n    dependencies:\n      '@types/history': 5.0.0\n      '@types/react': 17.0.83\n      '@types/react-router': 5.1.20\n\n  '@types/react-router-dom@5.1.7':\n    dependencies:\n      '@types/history': 5.0.0\n      '@types/react': 17.0.83\n      '@types/react-router': 5.1.12\n\n  '@types/react-router-dom@5.3.3':\n    dependencies:\n      '@types/history': 4.7.11\n      '@types/react': 17.0.83\n      '@types/react-router': 5.1.20\n\n  '@types/react-router@5.1.12':\n    dependencies:\n      '@types/history': 5.0.0\n      '@types/react': 17.0.83\n\n  '@types/react-router@5.1.20':\n    dependencies:\n      '@types/history': 4.7.11\n      '@types/react': 17.0.83\n\n  '@types/react@16.14.62':\n    dependencies:\n      '@types/prop-types': 15.7.14\n      '@types/scheduler': 0.16.8\n      csstype: 3.1.3\n\n  '@types/react@17.0.83':\n    dependencies:\n      '@types/prop-types': 15.7.14\n      '@types/scheduler': 0.16.8\n      csstype: 3.1.3\n\n  '@types/scheduler@0.16.8': {}\n\n  '@types/stack-utils@2.0.3': {}\n\n  '@types/yargs-parser@21.0.3': {}\n\n  '@types/yargs@15.0.19':\n    dependencies:\n      '@types/yargs-parser': 21.0.3\n\n  '@umijs/ast@3.5.43':\n    dependencies:\n      '@umijs/utils': 3.5.43\n\n  '@umijs/babel-plugin-auto-css-modules@3.5.43':\n    dependencies:\n      '@umijs/utils': 3.5.43\n\n  '@umijs/babel-plugin-import-to-await-require@3.5.43':\n    dependencies:\n      '@umijs/utils': 3.5.43\n\n  '@umijs/babel-plugin-lock-core-js-3@3.5.43':\n    dependencies:\n      '@umijs/utils': 3.5.43\n      core-js: 3.6.5\n\n  '@umijs/babel-plugin-no-anonymous-default-export@3.5.43':\n    dependencies:\n      '@umijs/utils': 3.5.43\n\n  '@umijs/babel-preset-umi@3.5.43':\n    dependencies:\n      '@babel/runtime': 7.18.6\n      '@umijs/babel-plugin-auto-css-modules': 3.5.43\n      '@umijs/babel-plugin-import-to-await-require': 3.5.43\n      '@umijs/babel-plugin-lock-core-js-3': 3.5.43\n      '@umijs/babel-plugin-no-anonymous-default-export': 3.5.43\n      '@umijs/deps': 3.5.43\n      '@umijs/utils': 3.5.43\n\n  '@umijs/bundler-utils@3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)':\n    dependencies:\n      '@umijs/babel-preset-umi': 3.5.43\n      '@umijs/types': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/utils': 3.5.43\n    transitivePeerDependencies:\n      - react\n      - react-dom\n      - react-router\n\n  '@umijs/bundler-webpack@3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)':\n    dependencies:\n      '@umijs/bundler-utils': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/case-sensitive-paths-webpack-plugin': 1.0.1\n      '@umijs/deps': 3.5.43\n      '@umijs/types': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/utils': 3.5.43\n      jest-worker: 26.6.2\n      node-libs-browser: 2.2.1\n      normalize-url: 1.9.1\n      postcss: 7.0.32\n      postcss-flexbugs-fixes: 4.2.1\n      postcss-loader: 3.0.0\n      postcss-preset-env: 6.7.0\n      postcss-safe-parser: 4.0.2\n      terser: 5.14.2\n      webpack-chain: 6.5.1\n    transitivePeerDependencies:\n      - react\n      - react-dom\n      - react-router\n\n  '@umijs/case-sensitive-paths-webpack-plugin@1.0.1': {}\n\n  '@umijs/core@3.5.43':\n    dependencies:\n      '@umijs/ast': 3.5.43\n      '@umijs/babel-preset-umi': 3.5.43\n      '@umijs/deps': 3.5.43\n      '@umijs/utils': 3.5.43\n\n  '@umijs/deps@3.5.43':\n    dependencies:\n      '@bloomberg/record-tuple-polyfill': 0.0.3\n      chokidar: 3.5.1\n      clipboardy: 2.3.0\n      esbuild: 0.12.15\n      jest-worker: 24.9.0\n      prettier: 2.2.1\n      regenerate: 1.4.2\n      regenerate-unicode-properties: 10.0.1\n\n  '@umijs/plugin-access@2.4.3(@umijs/plugin-initial-state@2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(@umijs/plugin-model@2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      '@umijs/plugin-initial-state': 2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-model': 2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n\n  '@umijs/plugin-analytics@0.2.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n\n  '@umijs/plugin-antd@0.13.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      antd: 4.24.16(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      antd-mobile: 2.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      semver: 7.6.3\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  '@umijs/plugin-crossorigin@1.2.1(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n\n  '@umijs/plugin-dva@0.13.0(dva-core@2.0.4(redux@4.2.1))(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@17.0.2))(react@17.0.2)(redbox-react@1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      babel-plugin-dva-hmr: 0.4.2(redbox-react@1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2))\n      dva: 2.6.0-beta.23(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@16.14.0))(react@17.0.2)\n      dva-immer: 0.5.2(dva@2.6.0-beta.23(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@16.14.0))(react@17.0.2))\n      dva-loading: 3.0.25(dva-core@2.0.4(redux@4.2.1))\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n    transitivePeerDependencies:\n      - dva-core\n      - react\n      - react-dom\n      - react-native\n      - react-router\n      - redbox-react\n\n  '@umijs/plugin-helmet@1.1.3(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      '@types/react-helmet': 6.1.11\n      react-helmet: 6.1.0(react@17.0.2)\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n    transitivePeerDependencies:\n      - react\n\n  '@umijs/plugin-initial-state@2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n\n  '@umijs/plugin-layout@0.18.1(@ant-design/icons@4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(@ant-design/pro-layout@6.38.22(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(@umijs/plugin-initial-state@2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(@umijs/plugin-locale@0.15.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(@umijs/plugin-model@2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      '@ant-design/icons': 4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@ant-design/pro-layout': 6.38.22(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@umijs/plugin-initial-state': 2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-locale': 0.15.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-model': 2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/route-utils': 2.2.2\n      antd: 4.24.16(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      lodash: 4.17.21\n      path-to-regexp: 1.9.0\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  '@umijs/plugin-locale@0.15.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      '@ant-design/icons': 4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@formatjs/intl-pluralrules': 1.5.9\n      '@formatjs/intl-relativetimeformat': 4.5.16\n      intl: 1.2.5\n      moment: 2.30.1\n      react-intl: 3.12.1(react@17.0.2)\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n      warning: 4.0.3\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  '@umijs/plugin-model@2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      fast-deep-equal: 3.1.1\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n\n  '@umijs/plugin-request@2.8.0(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      '@ahooksjs/use-request': 2.8.15(react@17.0.2)\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n      umi-request: 1.4.0\n    transitivePeerDependencies:\n      - react\n\n  '@umijs/plugin-test@1.0.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      '@umijs/test': 3.5.43\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  '@umijs/preset-built-in@3.5.43(react-dom@16.14.0(react@16.14.0))(react@16.14.0)':\n    dependencies:\n      '@types/react-router-config': 5.0.2\n      '@umijs/babel-preset-umi': 3.5.43\n      '@umijs/bundler-webpack': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/core': 3.5.43\n      '@umijs/deps': 3.5.43\n      '@umijs/renderer-mpa': 3.5.43(react-dom@16.14.0(react@16.14.0))(react@16.14.0)\n      '@umijs/renderer-react': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/runtime': 3.5.43(react@16.14.0)\n      '@umijs/server': 3.5.43\n      '@umijs/types': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/utils': 3.5.43\n      ansi-html: 0.0.9\n      core-js: 3.6.5\n      core-js-pure: 3.39.0\n      error-stack-parser: 2.1.4\n      es-module-lexer: 0.7.1\n      es5-imcompatible-versions: 0.1.90\n      history-with-query: 4.10.4\n      html-entities: 2.5.2\n      mime: 1.4.1\n      react: 16.14.0\n      react-refresh: 0.10.0\n      react-router: 5.2.0(react@17.0.2)\n      react-router-config: 5.1.1(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      react-router-dom: 5.2.0(react@16.14.0)\n      regenerator-runtime: 0.13.5\n      schema-utils: 3.3.0\n    transitivePeerDependencies:\n      - react-dom\n\n  '@umijs/preset-react@1.8.32(@ant-design/icons@4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(@ant-design/pro-layout@6.38.22(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(dva-core@2.0.4(redux@4.2.1))(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@17.0.2))(react@17.0.2)(redbox-react@1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(umi@3.5.43(react-router@5.2.0(react@16.14.0)))':\n    dependencies:\n      '@umijs/plugin-access': 2.4.3(@umijs/plugin-initial-state@2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(@umijs/plugin-model@2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-analytics': 0.2.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-antd': 0.13.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-crossorigin': 1.2.1(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-dva': 0.13.0(dva-core@2.0.4(redux@4.2.1))(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@17.0.2))(react@17.0.2)(redbox-react@1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-helmet': 1.1.3(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-initial-state': 2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-layout': 0.18.1(@ant-design/icons@4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(@ant-design/pro-layout@6.38.22(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(@umijs/plugin-initial-state@2.4.0(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(@umijs/plugin-locale@0.15.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(@umijs/plugin-model@2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0))))(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-locale': 0.15.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-model': 2.6.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-request': 2.8.0(react@17.0.2)(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      '@umijs/plugin-test': 1.0.2(umi@3.5.43(react-router@5.2.0(react@16.14.0)))\n      umi: 3.5.43(react-router@5.2.0(react@16.14.0))\n    transitivePeerDependencies:\n      - '@ant-design/icons'\n      - '@ant-design/pro-layout'\n      - bufferutil\n      - canvas\n      - dva-core\n      - react\n      - react-dom\n      - react-native\n      - react-router\n      - redbox-react\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  '@umijs/renderer-mpa@3.5.43(react-dom@16.14.0(react@16.14.0))(react@16.14.0)':\n    dependencies:\n      '@types/react': 16.14.62\n      '@types/react-dom': 16.9.25(@types/react@16.14.62)\n      '@umijs/runtime': 3.5.43(react@16.14.0)\n      react: 16.14.0\n      react-dom: 16.14.0(react@16.14.0)\n\n  '@umijs/renderer-react@3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)':\n    dependencies:\n      '@types/react': 16.14.62\n      '@types/react-dom': 16.9.25(@types/react@16.14.62)\n      '@types/react-router-config': 5.0.2\n      '@umijs/runtime': 3.5.43(react@16.14.0)\n      react: 16.14.0\n      react-dom: 16.14.0(react@16.14.0)\n      react-router-config: 5.1.1(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n    transitivePeerDependencies:\n      - react-router\n\n  '@umijs/route-utils@2.2.2':\n    dependencies:\n      '@qixian.cs/path-to-regexp': 6.1.0\n      fast-deep-equal: 3.1.3\n      lodash.isequal: 4.5.0\n      memoize-one: 5.2.1\n\n  '@umijs/runtime@3.5.43(react@16.14.0)':\n    dependencies:\n      '@types/react-router': 5.1.12\n      '@types/react-router-dom': 5.1.7\n      history-with-query: 4.10.4\n      react: 16.14.0\n      react-router: 5.2.0(react@16.14.0)\n      react-router-dom: 5.2.0(react@16.14.0)\n      use-subscription: 1.5.1(react@16.14.0)\n\n  '@umijs/server@3.5.43':\n    dependencies:\n      '@umijs/core': 3.5.43\n      '@umijs/deps': 3.5.43\n      '@umijs/utils': 3.5.43\n\n  '@umijs/ssr-darkreader@4.9.45': {}\n\n  '@umijs/test@3.5.43':\n    dependencies:\n      '@babel/core': 7.18.6\n      '@umijs/babel-preset-umi': 3.5.43\n      '@umijs/utils': 3.5.43\n      babel-jest: 26.6.3(@babel/core@7.18.6)\n      core-js: 3.8.2\n      identity-obj-proxy: 3.0.0\n      jest: 26.6.3\n      jest-cli: 26.6.3\n      regenerator-runtime: 0.13.11\n      whatwg-fetch: 3.6.20\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  '@umijs/types@3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)':\n    dependencies:\n      '@umijs/babel-preset-umi': 3.5.43\n      '@umijs/core': 3.5.43\n      '@umijs/deps': 3.5.43\n      '@umijs/renderer-react': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/server': 3.5.43\n      '@umijs/utils': 3.5.43\n      webpack-chain: 6.5.1\n    transitivePeerDependencies:\n      - react\n      - react-dom\n      - react-router\n\n  '@umijs/use-params@1.0.9(react@17.0.2)':\n    dependencies:\n      react: 17.0.2\n\n  '@umijs/utils@3.5.43':\n    dependencies:\n      '@umijs/babel-preset-umi': 3.5.43\n      '@umijs/deps': 3.5.43\n\n  abab@2.0.6: {}\n\n  acorn-globals@6.0.0:\n    dependencies:\n      acorn: 7.4.1\n      acorn-walk: 7.2.0\n\n  acorn-walk@7.2.0: {}\n\n  acorn@7.4.1: {}\n\n  acorn@8.14.0: {}\n\n  add-dom-event-listener@1.1.0:\n    dependencies:\n      object-assign: 4.1.1\n\n  agent-base@6.0.2:\n    dependencies:\n      debug: 4.4.0\n    transitivePeerDependencies:\n      - supports-color\n\n  aggregate-error@3.1.0:\n    dependencies:\n      clean-stack: 2.2.0\n      indent-string: 4.0.0\n\n  ajv-errors@1.0.1(ajv@6.12.6):\n    dependencies:\n      ajv: 6.12.6\n\n  ajv-keywords@3.5.2(ajv@6.12.6):\n    dependencies:\n      ajv: 6.12.6\n\n  ajv@6.12.6:\n    dependencies:\n      fast-deep-equal: 3.1.3\n      fast-json-stable-stringify: 2.1.0\n      json-schema-traverse: 0.4.1\n      uri-js: 4.4.1\n\n  ansi-colors@4.1.3: {}\n\n  ansi-escapes@4.3.2:\n    dependencies:\n      type-fest: 0.21.3\n\n  ansi-html@0.0.9: {}\n\n  ansi-regex@5.0.1: {}\n\n  ansi-styles@3.2.1:\n    dependencies:\n      color-convert: 1.9.3\n\n  ansi-styles@4.3.0:\n    dependencies:\n      color-convert: 2.0.1\n\n  antd-mobile@2.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      array-tree-filter: 2.1.0\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      normalize.css: 7.0.0\n      rc-checkbox: 2.0.3\n      rc-collapse: 1.9.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-slider: 8.2.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-swipeout: 2.0.11\n      rmc-calendar: 1.1.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-cascader: 5.0.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-date-picker: 6.0.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-dialog: 1.1.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-drawer: 0.4.11\n      rmc-feedback: 2.0.0\n      rmc-input-number: 1.0.5\n      rmc-list-view: 0.11.5\n      rmc-notification: 1.0.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-nuka-carousel: 3.0.1\n      rmc-picker: 5.0.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-pull-to-refresh: 1.0.13\n      rmc-steps: 1.0.1\n      rmc-tabs: 1.2.29\n      rmc-tooltip: 1.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  antd@4.24.16(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@ant-design/colors': 6.0.0\n      '@ant-design/icons': 4.8.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      '@ant-design/react-slick': 1.0.2(react@17.0.2)\n      '@babel/runtime': 7.26.0\n      '@ctrl/tinycolor': 3.6.1\n      classnames: 2.5.1\n      copy-to-clipboard: 3.3.3\n      lodash: 4.17.21\n      moment: 2.30.1\n      rc-cascader: 3.7.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-checkbox: 3.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-collapse: 3.4.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-dialog: 9.0.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-drawer: 6.3.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-dropdown: 4.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-field-form: 1.38.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-image: 5.13.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-input: 0.1.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-input-number: 7.3.11(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-mentions: 1.13.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-menu: 9.8.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-notification: 4.6.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-pagination: 3.2.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-picker: 2.7.6(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-progress: 3.4.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-rate: 2.9.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-resize-observer: 1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-segmented: 2.3.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-select: 14.1.18(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-slider: 10.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-steps: 5.0.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-switch: 3.2.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-table: 7.26.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-tabs: 12.5.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-textarea: 0.4.7(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-tooltip: 5.2.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-tree: 5.7.12(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-tree-select: 5.5.5(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-trigger: 5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-upload: 4.3.6(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      scroll-into-view-if-needed: 2.2.31\n\n  anymatch@2.0.0:\n    dependencies:\n      micromatch: 3.1.10\n      normalize-path: 2.1.1\n    transitivePeerDependencies:\n      - supports-color\n\n  anymatch@3.1.3:\n    dependencies:\n      normalize-path: 3.0.0\n      picomatch: 2.3.1\n\n  arch@2.2.0: {}\n\n  argparse@1.0.10:\n    dependencies:\n      sprintf-js: 1.0.3\n\n  arr-diff@4.0.0: {}\n\n  arr-flatten@1.1.0: {}\n\n  arr-union@3.1.0: {}\n\n  array-tree-filter@2.1.0: {}\n\n  array-unique@0.3.2: {}\n\n  asap@2.0.6: {}\n\n  asn1.js@4.10.1:\n    dependencies:\n      bn.js: 4.12.1\n      inherits: 2.0.4\n      minimalistic-assert: 1.0.1\n\n  assert@1.5.1:\n    dependencies:\n      object.assign: 4.1.5\n      util: 0.10.4\n\n  assign-symbols@1.0.0: {}\n\n  astral-regex@2.0.0: {}\n\n  async-validator@4.2.5: {}\n\n  asynckit@0.4.0: {}\n\n  atob@2.1.2: {}\n\n  autoprefixer@9.8.8:\n    dependencies:\n      browserslist: 4.24.2\n      caniuse-lite: 1.0.30001688\n      normalize-range: 0.1.2\n      num2fraction: 1.2.2\n      picocolors: 0.2.1\n      postcss: 7.0.32\n      postcss-value-parser: 4.2.0\n\n  babel-jest@26.6.3(@babel/core@7.18.6):\n    dependencies:\n      '@babel/core': 7.18.6\n      '@jest/transform': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/babel__core': 7.20.5\n      babel-plugin-istanbul: 6.1.1\n      babel-preset-jest: 26.6.2(@babel/core@7.18.6)\n      chalk: 4.1.2\n      graceful-fs: 4.2.11\n      slash: 3.0.0\n    transitivePeerDependencies:\n      - supports-color\n\n  babel-plugin-dva-hmr@0.4.2(redbox-react@1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)):\n    dependencies:\n      redbox-react: 1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n\n  babel-plugin-istanbul@6.1.1:\n    dependencies:\n      '@babel/helper-plugin-utils': 7.25.9\n      '@istanbuljs/load-nyc-config': 1.1.0\n      '@istanbuljs/schema': 0.1.3\n      istanbul-lib-instrument: 5.2.1\n      test-exclude: 6.0.0\n    transitivePeerDependencies:\n      - supports-color\n\n  babel-plugin-jest-hoist@26.6.2:\n    dependencies:\n      '@babel/template': 7.25.9\n      '@babel/types': 7.26.3\n      '@types/babel__core': 7.20.5\n      '@types/babel__traverse': 7.20.6\n\n  babel-preset-current-node-syntax@1.1.0(@babel/core@7.18.6):\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/plugin-syntax-async-generators': 7.8.4(@babel/core@7.18.6)\n      '@babel/plugin-syntax-bigint': 7.8.3(@babel/core@7.18.6)\n      '@babel/plugin-syntax-class-properties': 7.12.13(@babel/core@7.18.6)\n      '@babel/plugin-syntax-class-static-block': 7.14.5(@babel/core@7.18.6)\n      '@babel/plugin-syntax-import-attributes': 7.26.0(@babel/core@7.18.6)\n      '@babel/plugin-syntax-import-meta': 7.10.4(@babel/core@7.18.6)\n      '@babel/plugin-syntax-json-strings': 7.8.3(@babel/core@7.18.6)\n      '@babel/plugin-syntax-logical-assignment-operators': 7.10.4(@babel/core@7.18.6)\n      '@babel/plugin-syntax-nullish-coalescing-operator': 7.8.3(@babel/core@7.18.6)\n      '@babel/plugin-syntax-numeric-separator': 7.10.4(@babel/core@7.18.6)\n      '@babel/plugin-syntax-object-rest-spread': 7.8.3(@babel/core@7.18.6)\n      '@babel/plugin-syntax-optional-catch-binding': 7.8.3(@babel/core@7.18.6)\n      '@babel/plugin-syntax-optional-chaining': 7.8.3(@babel/core@7.18.6)\n      '@babel/plugin-syntax-private-property-in-object': 7.14.5(@babel/core@7.18.6)\n      '@babel/plugin-syntax-top-level-await': 7.14.5(@babel/core@7.18.6)\n\n  babel-preset-jest@26.6.2(@babel/core@7.18.6):\n    dependencies:\n      '@babel/core': 7.18.6\n      babel-plugin-jest-hoist: 26.6.2\n      babel-preset-current-node-syntax: 1.1.0(@babel/core@7.18.6)\n\n  babel-runtime@6.26.0:\n    dependencies:\n      core-js: 2.6.12\n      regenerator-runtime: 0.11.1\n\n  balanced-match@1.0.2: {}\n\n  base64-js@1.5.1: {}\n\n  base@0.11.2:\n    dependencies:\n      cache-base: 1.0.1\n      class-utils: 0.3.6\n      component-emitter: 1.3.1\n      define-property: 1.0.0\n      isobject: 3.0.1\n      mixin-deep: 1.3.2\n      pascalcase: 0.1.1\n\n  big.js@5.2.2: {}\n\n  binary-extensions@2.3.0: {}\n\n  bn.js@4.12.1: {}\n\n  bn.js@5.2.1: {}\n\n  brace-expansion@1.1.11:\n    dependencies:\n      balanced-match: 1.0.2\n      concat-map: 0.0.1\n\n  braces@2.3.2:\n    dependencies:\n      arr-flatten: 1.1.0\n      array-unique: 0.3.2\n      extend-shallow: 2.0.1\n      fill-range: 4.0.0\n      isobject: 3.0.1\n      repeat-element: 1.1.4\n      snapdragon: 0.8.2\n      snapdragon-node: 2.1.1\n      split-string: 3.1.0\n      to-regex: 3.0.2\n    transitivePeerDependencies:\n      - supports-color\n\n  braces@3.0.3:\n    dependencies:\n      fill-range: 7.1.1\n\n  brorand@1.1.0: {}\n\n  browser-process-hrtime@1.0.0: {}\n\n  browserify-aes@1.2.0:\n    dependencies:\n      buffer-xor: 1.0.3\n      cipher-base: 1.0.6\n      create-hash: 1.2.0\n      evp_bytestokey: 1.0.3\n      inherits: 2.0.4\n      safe-buffer: 5.2.1\n\n  browserify-cipher@1.0.1:\n    dependencies:\n      browserify-aes: 1.2.0\n      browserify-des: 1.0.2\n      evp_bytestokey: 1.0.3\n\n  browserify-des@1.0.2:\n    dependencies:\n      cipher-base: 1.0.6\n      des.js: 1.1.0\n      inherits: 2.0.4\n      safe-buffer: 5.2.1\n\n  browserify-rsa@4.1.1:\n    dependencies:\n      bn.js: 5.2.1\n      randombytes: 2.1.0\n      safe-buffer: 5.2.1\n\n  browserify-sign@4.2.3:\n    dependencies:\n      bn.js: 5.2.1\n      browserify-rsa: 4.1.1\n      create-hash: 1.2.0\n      create-hmac: 1.1.7\n      elliptic: 6.6.1\n      hash-base: 3.0.5\n      inherits: 2.0.4\n      parse-asn1: 5.1.7\n      readable-stream: 2.3.8\n      safe-buffer: 5.2.1\n\n  browserify-zlib@0.2.0:\n    dependencies:\n      pako: 1.0.11\n\n  browserslist@4.24.2:\n    dependencies:\n      caniuse-lite: 1.0.30001688\n      electron-to-chromium: 1.5.73\n      node-releases: 2.0.19\n      update-browserslist-db: 1.1.1(browserslist@4.24.2)\n\n  bser@2.1.1:\n    dependencies:\n      node-int64: 0.4.0\n\n  buffer-from@1.1.2: {}\n\n  buffer-xor@1.0.3: {}\n\n  buffer@4.9.2:\n    dependencies:\n      base64-js: 1.5.1\n      ieee754: 1.2.1\n      isarray: 1.0.0\n\n  builtin-status-codes@3.0.0: {}\n\n  cache-base@1.0.1:\n    dependencies:\n      collection-visit: 1.0.0\n      component-emitter: 1.3.1\n      get-value: 2.0.6\n      has-value: 1.0.0\n      isobject: 3.0.1\n      set-value: 2.0.1\n      to-object-path: 0.3.0\n      union-value: 1.0.1\n      unset-value: 1.0.0\n\n  call-bind-apply-helpers@1.0.1:\n    dependencies:\n      es-errors: 1.3.0\n      function-bind: 1.1.2\n\n  call-bind@1.0.8:\n    dependencies:\n      call-bind-apply-helpers: 1.0.1\n      es-define-property: 1.0.1\n      get-intrinsic: 1.2.6\n      set-function-length: 1.2.2\n\n  call-bound@1.0.2:\n    dependencies:\n      call-bind: 1.0.8\n      get-intrinsic: 1.2.6\n\n  caller-callsite@2.0.0:\n    dependencies:\n      callsites: 2.0.0\n\n  caller-path@2.0.0:\n    dependencies:\n      caller-callsite: 2.0.0\n\n  callsites@2.0.0: {}\n\n  callsites@3.1.0: {}\n\n  camelcase@5.3.1: {}\n\n  camelcase@6.3.0: {}\n\n  caniuse-lite@1.0.30001688: {}\n\n  capture-exit@2.0.0:\n    dependencies:\n      rsvp: 4.8.5\n\n  chalk@2.4.2:\n    dependencies:\n      ansi-styles: 3.2.1\n      escape-string-regexp: 1.0.5\n      supports-color: 5.5.0\n\n  chalk@4.1.2:\n    dependencies:\n      ansi-styles: 4.3.0\n      supports-color: 7.2.0\n\n  char-regex@1.0.2: {}\n\n  chokidar@3.5.1:\n    dependencies:\n      anymatch: 3.1.3\n      braces: 3.0.3\n      glob-parent: 5.1.2\n      is-binary-path: 2.1.0\n      is-glob: 4.0.3\n      normalize-path: 3.0.0\n      readdirp: 3.5.0\n    optionalDependencies:\n      fsevents: 2.3.3\n\n  ci-info@1.6.0: {}\n\n  ci-info@2.0.0: {}\n\n  cipher-base@1.0.6:\n    dependencies:\n      inherits: 2.0.4\n      safe-buffer: 5.2.1\n\n  cjs-module-lexer@0.6.0: {}\n\n  class-utils@0.3.6:\n    dependencies:\n      arr-union: 3.1.0\n      define-property: 0.2.5\n      isobject: 3.0.1\n      static-extend: 0.1.2\n\n  classnames@2.5.1: {}\n\n  clean-stack@2.2.0: {}\n\n  cli-cursor@3.1.0:\n    dependencies:\n      restore-cursor: 3.1.0\n\n  cli-truncate@2.1.0:\n    dependencies:\n      slice-ansi: 3.0.0\n      string-width: 4.2.3\n\n  clipboardy@2.3.0:\n    dependencies:\n      arch: 2.2.0\n      execa: 1.0.0\n      is-wsl: 2.2.0\n\n  cliui@6.0.0:\n    dependencies:\n      string-width: 4.2.3\n      strip-ansi: 6.0.1\n      wrap-ansi: 6.2.0\n\n  co@4.6.0: {}\n\n  collect-v8-coverage@1.0.2: {}\n\n  collection-visit@1.0.0:\n    dependencies:\n      map-visit: 1.0.0\n      object-visit: 1.0.1\n\n  color-convert@1.9.3:\n    dependencies:\n      color-name: 1.1.3\n\n  color-convert@2.0.1:\n    dependencies:\n      color-name: 1.1.4\n\n  color-name@1.1.3: {}\n\n  color-name@1.1.4: {}\n\n  colorette@2.0.20: {}\n\n  combined-stream@1.0.8:\n    dependencies:\n      delayed-stream: 1.0.0\n\n  commander@2.20.3: {}\n\n  commander@6.2.1: {}\n\n  component-classes@1.2.6:\n    dependencies:\n      component-indexof: 0.0.3\n\n  component-emitter@1.3.1: {}\n\n  component-indexof@0.0.3: {}\n\n  compute-scroll-into-view@1.0.20: {}\n\n  concat-map@0.0.1: {}\n\n  connected-react-router@6.5.2(history@4.10.1)(react-redux@7.2.9(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(react-router@5.2.0(react@16.14.0))(react@17.0.2)(redux@4.2.1):\n    dependencies:\n      history: 4.10.1\n      immutable: 3.8.2\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-redux: 7.2.9(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react-router: 5.2.0(react@17.0.2)\n      redux: 4.2.1\n      seamless-immutable: 7.1.4\n\n  console-browserify@1.2.0: {}\n\n  constants-browserify@1.0.0: {}\n\n  convert-source-map@1.9.0: {}\n\n  copy-descriptor@0.1.1: {}\n\n  copy-to-clipboard@3.3.3:\n    dependencies:\n      toggle-selection: 1.0.6\n\n  core-js-pure@3.39.0: {}\n\n  core-js@1.2.7: {}\n\n  core-js@2.6.12: {}\n\n  core-js@3.6.5: {}\n\n  core-js@3.8.2: {}\n\n  core-util-is@1.0.3: {}\n\n  cosmiconfig@5.2.1:\n    dependencies:\n      import-fresh: 2.0.0\n      is-directory: 0.3.1\n      js-yaml: 3.14.1\n      parse-json: 4.0.0\n\n  cosmiconfig@7.1.0:\n    dependencies:\n      '@types/parse-json': 4.0.2\n      import-fresh: 3.3.0\n      parse-json: 5.2.0\n      path-type: 4.0.0\n      yaml: 1.10.2\n\n  create-ecdh@4.0.4:\n    dependencies:\n      bn.js: 4.12.1\n      elliptic: 6.6.1\n\n  create-hash@1.2.0:\n    dependencies:\n      cipher-base: 1.0.6\n      inherits: 2.0.4\n      md5.js: 1.3.5\n      ripemd160: 2.0.2\n      sha.js: 2.4.11\n\n  create-hmac@1.1.7:\n    dependencies:\n      cipher-base: 1.0.6\n      create-hash: 1.2.0\n      inherits: 2.0.4\n      ripemd160: 2.0.2\n      safe-buffer: 5.2.1\n      sha.js: 2.4.11\n\n  create-react-class@15.7.0:\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n\n  cross-spawn@5.1.0:\n    dependencies:\n      lru-cache: 4.1.5\n      shebang-command: 1.2.0\n      which: 1.3.1\n\n  cross-spawn@6.0.6:\n    dependencies:\n      nice-try: 1.0.5\n      path-key: 2.0.1\n      semver: 5.7.2\n      shebang-command: 1.2.0\n      which: 1.3.1\n\n  cross-spawn@7.0.6:\n    dependencies:\n      path-key: 3.1.1\n      shebang-command: 2.0.0\n      which: 2.0.2\n\n  crypto-browserify@3.12.1:\n    dependencies:\n      browserify-cipher: 1.0.1\n      browserify-sign: 4.2.3\n      create-ecdh: 4.0.4\n      create-hash: 1.2.0\n      create-hmac: 1.1.7\n      diffie-hellman: 5.0.3\n      hash-base: 3.0.5\n      inherits: 2.0.4\n      pbkdf2: 3.1.2\n      public-encrypt: 4.0.3\n      randombytes: 2.1.0\n      randomfill: 1.0.4\n\n  css-animation@1.6.1:\n    dependencies:\n      babel-runtime: 6.26.0\n      component-classes: 1.2.6\n\n  css-blank-pseudo@0.1.4:\n    dependencies:\n      postcss: 7.0.32\n\n  css-has-pseudo@0.10.0:\n    dependencies:\n      postcss: 7.0.32\n      postcss-selector-parser: 5.0.0\n\n  css-prefers-color-scheme@3.1.1:\n    dependencies:\n      postcss: 7.0.32\n\n  cssdb@4.4.0: {}\n\n  cssesc@2.0.0: {}\n\n  cssesc@3.0.0: {}\n\n  cssom@0.3.8: {}\n\n  cssom@0.4.4: {}\n\n  cssstyle@2.3.0:\n    dependencies:\n      cssom: 0.3.8\n\n  csstype@3.1.3: {}\n\n  data-urls@2.0.0:\n    dependencies:\n      abab: 2.0.6\n      whatwg-mimetype: 2.3.0\n      whatwg-url: 8.7.0\n\n  date-fns@2.30.0:\n    dependencies:\n      '@babel/runtime': 7.26.0\n\n  dayjs@1.11.13: {}\n\n  debug@2.6.9:\n    dependencies:\n      ms: 2.0.0\n\n  debug@4.4.0:\n    dependencies:\n      ms: 2.1.3\n\n  decamelize@1.2.0: {}\n\n  decimal.js@10.4.3: {}\n\n  decode-uri-component@0.2.2: {}\n\n  dedent@0.7.0: {}\n\n  deepmerge@1.5.2: {}\n\n  deepmerge@4.3.1: {}\n\n  define-data-property@1.1.4:\n    dependencies:\n      es-define-property: 1.0.1\n      es-errors: 1.3.0\n      gopd: 1.2.0\n\n  define-properties@1.2.1:\n    dependencies:\n      define-data-property: 1.1.4\n      has-property-descriptors: 1.0.2\n      object-keys: 1.1.1\n\n  define-property@0.2.5:\n    dependencies:\n      is-descriptor: 0.1.7\n\n  define-property@1.0.0:\n    dependencies:\n      is-descriptor: 1.0.3\n\n  define-property@2.0.2:\n    dependencies:\n      is-descriptor: 1.0.3\n      isobject: 3.0.1\n\n  delayed-stream@1.0.0: {}\n\n  des.js@1.1.0:\n    dependencies:\n      inherits: 2.0.4\n      minimalistic-assert: 1.0.1\n\n  detect-newline@3.1.0: {}\n\n  diff-sequences@26.6.2: {}\n\n  diffie-hellman@5.0.3:\n    dependencies:\n      bn.js: 4.12.1\n      miller-rabin: 4.0.1\n      randombytes: 2.1.0\n\n  dom-align@1.12.4: {}\n\n  dom-walk@0.1.2: {}\n\n  domain-browser@1.2.0: {}\n\n  domexception@2.0.1:\n    dependencies:\n      webidl-conversions: 5.0.0\n\n  dunder-proto@1.0.0:\n    dependencies:\n      call-bind-apply-helpers: 1.0.1\n      es-errors: 1.3.0\n      gopd: 1.2.0\n\n  dva-core@2.0.4(redux@4.2.1):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      flatten: 1.0.3\n      global: 4.4.0\n      invariant: 2.2.4\n      is-plain-object: 2.0.4\n      redux: 4.2.1\n      redux-saga: 0.16.2\n      warning: 3.0.0\n\n  dva-immer@0.5.2(dva@2.6.0-beta.23(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@16.14.0))(react@17.0.2)):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      dva: 2.6.0-beta.23(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@16.14.0))(react@17.0.2)\n      immer: 7.0.15\n\n  dva-loading@3.0.25(dva-core@2.0.4(redux@4.2.1)):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      dva-core: 2.0.4(redux@4.2.1)\n\n  dva@2.6.0-beta.23(react-dom@17.0.2(react@17.0.2))(react-router@5.2.0(react@16.14.0))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      '@types/isomorphic-fetch': 0.0.35\n      '@types/react-redux': 7.1.34\n      '@types/react-router-dom': 5.3.3\n      connected-react-router: 6.5.2(history@4.10.1)(react-redux@7.2.9(react-dom@17.0.2(react@17.0.2))(react@17.0.2))(react-router@5.2.0(react@16.14.0))(react@17.0.2)(redux@4.2.1)\n      dva-core: 2.0.4(redux@4.2.1)\n      global: 4.4.0\n      history: 4.10.1\n      invariant: 2.2.4\n      isomorphic-fetch: 2.2.1\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      react-redux: 7.2.9(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react-router-dom: 5.3.4(react@17.0.2)\n      redux: 4.2.1\n    transitivePeerDependencies:\n      - react-native\n      - react-router\n\n  electron-to-chromium@1.5.73: {}\n\n  elliptic@6.6.1:\n    dependencies:\n      bn.js: 4.12.1\n      brorand: 1.1.0\n      hash.js: 1.1.7\n      hmac-drbg: 1.0.1\n      inherits: 2.0.4\n      minimalistic-assert: 1.0.1\n      minimalistic-crypto-utils: 1.0.1\n\n  emittery@0.7.2: {}\n\n  emoji-regex@8.0.0: {}\n\n  emojis-list@3.0.0: {}\n\n  encoding@0.1.13:\n    dependencies:\n      iconv-lite: 0.6.3\n\n  end-of-stream@1.4.4:\n    dependencies:\n      once: 1.4.0\n\n  enquirer@2.4.1:\n    dependencies:\n      ansi-colors: 4.1.3\n      strip-ansi: 6.0.1\n\n  error-ex@1.3.2:\n    dependencies:\n      is-arrayish: 0.2.1\n\n  error-stack-parser@1.3.6:\n    dependencies:\n      stackframe: 0.3.1\n\n  error-stack-parser@2.1.4:\n    dependencies:\n      stackframe: 1.3.4\n\n  es-define-property@1.0.1: {}\n\n  es-errors@1.3.0: {}\n\n  es-module-lexer@0.7.1: {}\n\n  es-object-atoms@1.0.0:\n    dependencies:\n      es-errors: 1.3.0\n\n  es5-imcompatible-versions@0.1.90: {}\n\n  esbuild@0.12.15: {}\n\n  escalade@3.2.0: {}\n\n  escape-string-regexp@1.0.5: {}\n\n  escape-string-regexp@2.0.0: {}\n\n  escodegen@2.1.0:\n    dependencies:\n      esprima: 4.0.1\n      estraverse: 5.3.0\n      esutils: 2.0.3\n    optionalDependencies:\n      source-map: 0.6.1\n\n  esprima@4.0.1: {}\n\n  estraverse@5.3.0: {}\n\n  esutils@2.0.3: {}\n\n  events@3.3.0: {}\n\n  evp_bytestokey@1.0.3:\n    dependencies:\n      md5.js: 1.3.5\n      safe-buffer: 5.2.1\n\n  exec-sh@0.3.6: {}\n\n  execa@0.8.0:\n    dependencies:\n      cross-spawn: 5.1.0\n      get-stream: 3.0.0\n      is-stream: 1.1.0\n      npm-run-path: 2.0.2\n      p-finally: 1.0.0\n      signal-exit: 3.0.7\n      strip-eof: 1.0.0\n\n  execa@1.0.0:\n    dependencies:\n      cross-spawn: 6.0.6\n      get-stream: 4.1.0\n      is-stream: 1.1.0\n      npm-run-path: 2.0.2\n      p-finally: 1.0.0\n      signal-exit: 3.0.7\n      strip-eof: 1.0.0\n\n  execa@4.1.0:\n    dependencies:\n      cross-spawn: 7.0.6\n      get-stream: 5.2.0\n      human-signals: 1.1.1\n      is-stream: 2.0.1\n      merge-stream: 2.0.0\n      npm-run-path: 4.0.1\n      onetime: 5.1.2\n      signal-exit: 3.0.7\n      strip-final-newline: 2.0.0\n\n  exenv@1.2.2: {}\n\n  exit@0.1.2: {}\n\n  expand-brackets@2.1.4:\n    dependencies:\n      debug: 2.6.9\n      define-property: 0.2.5\n      extend-shallow: 2.0.1\n      posix-character-classes: 0.1.1\n      regex-not: 1.0.2\n      snapdragon: 0.8.2\n      to-regex: 3.0.2\n    transitivePeerDependencies:\n      - supports-color\n\n  expect@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      ansi-styles: 4.3.0\n      jest-get-type: 26.3.0\n      jest-matcher-utils: 26.6.2\n      jest-message-util: 26.6.2\n      jest-regex-util: 26.0.0\n\n  extend-shallow@2.0.1:\n    dependencies:\n      is-extendable: 0.1.1\n\n  extend-shallow@3.0.2:\n    dependencies:\n      assign-symbols: 1.0.0\n      is-extendable: 1.0.1\n\n  extglob@2.0.4:\n    dependencies:\n      array-unique: 0.3.2\n      define-property: 1.0.0\n      expand-brackets: 2.1.4\n      extend-shallow: 2.0.1\n      fragment-cache: 0.2.1\n      regex-not: 1.0.2\n      snapdragon: 0.8.2\n      to-regex: 3.0.2\n    transitivePeerDependencies:\n      - supports-color\n\n  fast-deep-equal@3.1.1: {}\n\n  fast-deep-equal@3.1.3: {}\n\n  fast-json-stable-stringify@2.1.0: {}\n\n  fb-watchman@2.0.2:\n    dependencies:\n      bser: 2.1.1\n\n  fbjs@0.8.18:\n    dependencies:\n      core-js: 1.2.7\n      isomorphic-fetch: 2.2.1\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n      promise: 7.3.1\n      setimmediate: 1.0.5\n      ua-parser-js: 0.7.39\n\n  fill-range@4.0.0:\n    dependencies:\n      extend-shallow: 2.0.1\n      is-number: 3.0.0\n      repeat-string: 1.6.1\n      to-regex-range: 2.1.1\n\n  fill-range@7.1.1:\n    dependencies:\n      to-regex-range: 5.0.1\n\n  filter-obj@1.1.0: {}\n\n  find-up@4.1.0:\n    dependencies:\n      locate-path: 5.0.0\n      path-exists: 4.0.0\n\n  flatten@1.0.3: {}\n\n  for-in@1.0.2: {}\n\n  form-data@3.0.2:\n    dependencies:\n      asynckit: 0.4.0\n      combined-stream: 1.0.8\n      mime-types: 2.1.35\n\n  fragment-cache@0.2.1:\n    dependencies:\n      map-cache: 0.2.2\n\n  fs.realpath@1.0.0: {}\n\n  fsevents@2.3.3:\n    optional: true\n\n  function-bind@1.1.2: {}\n\n  gensync@1.0.0-beta.2: {}\n\n  get-caller-file@2.0.5: {}\n\n  get-intrinsic@1.2.6:\n    dependencies:\n      call-bind-apply-helpers: 1.0.1\n      dunder-proto: 1.0.0\n      es-define-property: 1.0.1\n      es-errors: 1.3.0\n      es-object-atoms: 1.0.0\n      function-bind: 1.1.2\n      gopd: 1.2.0\n      has-symbols: 1.1.0\n      hasown: 2.0.2\n      math-intrinsics: 1.0.0\n\n  get-own-enumerable-property-symbols@3.0.2: {}\n\n  get-package-type@0.1.0: {}\n\n  get-stream@3.0.0: {}\n\n  get-stream@4.1.0:\n    dependencies:\n      pump: 3.0.2\n\n  get-stream@5.2.0:\n    dependencies:\n      pump: 3.0.2\n\n  get-value@2.0.6: {}\n\n  glob-parent@5.1.2:\n    dependencies:\n      is-glob: 4.0.3\n\n  glob@7.2.3:\n    dependencies:\n      fs.realpath: 1.0.0\n      inflight: 1.0.6\n      inherits: 2.0.4\n      minimatch: 3.1.2\n      once: 1.4.0\n      path-is-absolute: 1.0.1\n\n  global@4.4.0:\n    dependencies:\n      min-document: 2.19.0\n      process: 0.11.10\n\n  globals@11.12.0: {}\n\n  gopd@1.2.0: {}\n\n  graceful-fs@4.2.11: {}\n\n  growly@1.3.0:\n    optional: true\n\n  harmony-reflect@1.6.2: {}\n\n  has-flag@3.0.0: {}\n\n  has-flag@4.0.0: {}\n\n  has-property-descriptors@1.0.2:\n    dependencies:\n      es-define-property: 1.0.1\n\n  has-symbols@1.1.0: {}\n\n  has-value@0.3.1:\n    dependencies:\n      get-value: 2.0.6\n      has-values: 0.1.4\n      isobject: 2.1.0\n\n  has-value@1.0.0:\n    dependencies:\n      get-value: 2.0.6\n      has-values: 1.0.0\n      isobject: 3.0.1\n\n  has-values@0.1.4: {}\n\n  has-values@1.0.0:\n    dependencies:\n      is-number: 3.0.0\n      kind-of: 4.0.0\n\n  hash-base@3.0.5:\n    dependencies:\n      inherits: 2.0.4\n      safe-buffer: 5.2.1\n\n  hash.js@1.1.7:\n    dependencies:\n      inherits: 2.0.4\n      minimalistic-assert: 1.0.1\n\n  hasown@2.0.2:\n    dependencies:\n      function-bind: 1.1.2\n\n  history-with-query@4.10.4:\n    dependencies:\n      '@babel/runtime': 7.26.0\n      loose-envify: 1.4.0\n      query-string: 6.14.1\n      resolve-pathname: 3.0.0\n      tiny-invariant: 1.3.3\n      tiny-warning: 1.0.3\n      value-equal: 1.0.1\n\n  history@4.10.1:\n    dependencies:\n      '@babel/runtime': 7.26.0\n      loose-envify: 1.4.0\n      resolve-pathname: 3.0.0\n      tiny-invariant: 1.3.3\n      tiny-warning: 1.0.3\n      value-equal: 1.0.1\n\n  history@5.3.0:\n    dependencies:\n      '@babel/runtime': 7.26.0\n\n  hmac-drbg@1.0.1:\n    dependencies:\n      hash.js: 1.1.7\n      minimalistic-assert: 1.0.1\n      minimalistic-crypto-utils: 1.0.1\n\n  hoist-non-react-statics@3.3.2:\n    dependencies:\n      react-is: 16.13.1\n\n  hosted-git-info@2.8.9: {}\n\n  html-encoding-sniffer@2.0.1:\n    dependencies:\n      whatwg-encoding: 1.0.5\n\n  html-entities@2.5.2: {}\n\n  html-escaper@2.0.2: {}\n\n  http-proxy-agent@4.0.1:\n    dependencies:\n      '@tootallnate/once': 1.1.2\n      agent-base: 6.0.2\n      debug: 4.4.0\n    transitivePeerDependencies:\n      - supports-color\n\n  https-browserify@1.0.0: {}\n\n  https-proxy-agent@5.0.1:\n    dependencies:\n      agent-base: 6.0.2\n      debug: 4.4.0\n    transitivePeerDependencies:\n      - supports-color\n\n  human-signals@1.1.1: {}\n\n  iconv-lite@0.4.24:\n    dependencies:\n      safer-buffer: 2.1.2\n\n  iconv-lite@0.6.3:\n    dependencies:\n      safer-buffer: 2.1.2\n\n  identity-obj-proxy@3.0.0:\n    dependencies:\n      harmony-reflect: 1.6.2\n\n  ieee754@1.2.1: {}\n\n  immer@7.0.15: {}\n\n  immutable@3.8.2: {}\n\n  import-cwd@2.1.0:\n    dependencies:\n      import-from: 2.1.0\n\n  import-fresh@2.0.0:\n    dependencies:\n      caller-path: 2.0.0\n      resolve-from: 3.0.0\n\n  import-fresh@3.3.0:\n    dependencies:\n      parent-module: 1.0.1\n      resolve-from: 4.0.0\n\n  import-from@2.1.0:\n    dependencies:\n      resolve-from: 3.0.0\n\n  import-local@3.2.0:\n    dependencies:\n      pkg-dir: 4.2.0\n      resolve-cwd: 3.0.0\n\n  imurmurhash@0.1.4: {}\n\n  indent-string@4.0.0: {}\n\n  indexes-of@1.0.1: {}\n\n  inflight@1.0.6:\n    dependencies:\n      once: 1.4.0\n      wrappy: 1.0.2\n\n  inherits@2.0.3: {}\n\n  inherits@2.0.4: {}\n\n  intl-format-cache@4.3.1: {}\n\n  intl-messageformat-parser@3.6.4:\n    dependencies:\n      '@formatjs/intl-unified-numberformat': 3.3.7\n\n  intl-messageformat@7.8.4:\n    dependencies:\n      intl-format-cache: 4.3.1\n      intl-messageformat-parser: 3.6.4\n\n  intl@1.2.5: {}\n\n  invariant@2.2.4:\n    dependencies:\n      loose-envify: 1.4.0\n\n  is-accessor-descriptor@1.0.1:\n    dependencies:\n      hasown: 2.0.2\n\n  is-arrayish@0.2.1: {}\n\n  is-binary-path@2.1.0:\n    dependencies:\n      binary-extensions: 2.3.0\n\n  is-buffer@1.1.6: {}\n\n  is-ci@1.2.1:\n    dependencies:\n      ci-info: 1.6.0\n\n  is-ci@2.0.0:\n    dependencies:\n      ci-info: 2.0.0\n\n  is-core-module@2.15.1:\n    dependencies:\n      hasown: 2.0.2\n\n  is-data-descriptor@1.0.1:\n    dependencies:\n      hasown: 2.0.2\n\n  is-descriptor@0.1.7:\n    dependencies:\n      is-accessor-descriptor: 1.0.1\n      is-data-descriptor: 1.0.1\n\n  is-descriptor@1.0.3:\n    dependencies:\n      is-accessor-descriptor: 1.0.1\n      is-data-descriptor: 1.0.1\n\n  is-directory@0.3.1: {}\n\n  is-docker@2.2.1: {}\n\n  is-extendable@0.1.1: {}\n\n  is-extendable@1.0.1:\n    dependencies:\n      is-plain-object: 2.0.4\n\n  is-extglob@2.1.1: {}\n\n  is-fullwidth-code-point@3.0.0: {}\n\n  is-generator-fn@2.1.0: {}\n\n  is-glob@4.0.3:\n    dependencies:\n      is-extglob: 2.1.1\n\n  is-number@3.0.0:\n    dependencies:\n      kind-of: 3.2.2\n\n  is-number@7.0.0: {}\n\n  is-obj@1.0.1: {}\n\n  is-plain-obj@1.1.0: {}\n\n  is-plain-object@2.0.4:\n    dependencies:\n      isobject: 3.0.1\n\n  is-potential-custom-element-name@1.0.1: {}\n\n  is-regexp@1.0.0: {}\n\n  is-stream@1.1.0: {}\n\n  is-stream@2.0.1: {}\n\n  is-typedarray@1.0.0: {}\n\n  is-unicode-supported@0.1.0: {}\n\n  is-windows@1.0.2: {}\n\n  is-wsl@2.2.0:\n    dependencies:\n      is-docker: 2.2.1\n\n  isarray@0.0.1: {}\n\n  isarray@1.0.0: {}\n\n  isexe@2.0.0: {}\n\n  isobject@2.1.0:\n    dependencies:\n      isarray: 1.0.0\n\n  isobject@3.0.1: {}\n\n  isomorphic-fetch@2.2.1:\n    dependencies:\n      node-fetch: 1.7.3\n      whatwg-fetch: 3.6.20\n\n  istanbul-lib-coverage@3.2.2: {}\n\n  istanbul-lib-instrument@4.0.3:\n    dependencies:\n      '@babel/core': 7.18.6\n      '@istanbuljs/schema': 0.1.3\n      istanbul-lib-coverage: 3.2.2\n      semver: 6.3.1\n    transitivePeerDependencies:\n      - supports-color\n\n  istanbul-lib-instrument@5.2.1:\n    dependencies:\n      '@babel/core': 7.18.6\n      '@babel/parser': 7.26.3\n      '@istanbuljs/schema': 0.1.3\n      istanbul-lib-coverage: 3.2.2\n      semver: 6.3.1\n    transitivePeerDependencies:\n      - supports-color\n\n  istanbul-lib-report@3.0.1:\n    dependencies:\n      istanbul-lib-coverage: 3.2.2\n      make-dir: 4.0.0\n      supports-color: 7.2.0\n\n  istanbul-lib-source-maps@4.0.1:\n    dependencies:\n      debug: 4.4.0\n      istanbul-lib-coverage: 3.2.2\n      source-map: 0.6.1\n    transitivePeerDependencies:\n      - supports-color\n\n  istanbul-reports@3.1.7:\n    dependencies:\n      html-escaper: 2.0.2\n      istanbul-lib-report: 3.0.1\n\n  javascript-stringify@2.1.0: {}\n\n  jest-changed-files@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      execa: 4.1.0\n      throat: 5.0.0\n\n  jest-cli@26.6.3:\n    dependencies:\n      '@jest/core': 26.6.3\n      '@jest/test-result': 26.6.2\n      '@jest/types': 26.6.2\n      chalk: 4.1.2\n      exit: 0.1.2\n      graceful-fs: 4.2.11\n      import-local: 3.2.0\n      is-ci: 2.0.0\n      jest-config: 26.6.3\n      jest-util: 26.6.2\n      jest-validate: 26.6.2\n      prompts: 2.4.2\n      yargs: 15.4.1\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  jest-config@26.6.3:\n    dependencies:\n      '@babel/core': 7.18.6\n      '@jest/test-sequencer': 26.6.3\n      '@jest/types': 26.6.2\n      babel-jest: 26.6.3(@babel/core@7.18.6)\n      chalk: 4.1.2\n      deepmerge: 4.3.1\n      glob: 7.2.3\n      graceful-fs: 4.2.11\n      jest-environment-jsdom: 26.6.2\n      jest-environment-node: 26.6.2\n      jest-get-type: 26.3.0\n      jest-jasmine2: 26.6.3\n      jest-regex-util: 26.0.0\n      jest-resolve: 26.6.2\n      jest-util: 26.6.2\n      jest-validate: 26.6.2\n      micromatch: 4.0.8\n      pretty-format: 26.6.2\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - utf-8-validate\n\n  jest-diff@26.6.2:\n    dependencies:\n      chalk: 4.1.2\n      diff-sequences: 26.6.2\n      jest-get-type: 26.3.0\n      pretty-format: 26.6.2\n\n  jest-docblock@26.0.0:\n    dependencies:\n      detect-newline: 3.1.0\n\n  jest-each@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      chalk: 4.1.2\n      jest-get-type: 26.3.0\n      jest-util: 26.6.2\n      pretty-format: 26.6.2\n\n  jest-environment-jsdom@26.6.2:\n    dependencies:\n      '@jest/environment': 26.6.2\n      '@jest/fake-timers': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      jest-mock: 26.6.2\n      jest-util: 26.6.2\n      jsdom: 16.7.0\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - utf-8-validate\n\n  jest-environment-node@26.6.2:\n    dependencies:\n      '@jest/environment': 26.6.2\n      '@jest/fake-timers': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      jest-mock: 26.6.2\n      jest-util: 26.6.2\n\n  jest-get-type@26.3.0: {}\n\n  jest-haste-map@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      '@types/graceful-fs': 4.1.9\n      '@types/node': 22.10.2\n      anymatch: 3.1.3\n      fb-watchman: 2.0.2\n      graceful-fs: 4.2.11\n      jest-regex-util: 26.0.0\n      jest-serializer: 26.6.2\n      jest-util: 26.6.2\n      jest-worker: 26.6.2\n      micromatch: 4.0.8\n      sane: 4.1.0\n      walker: 1.0.8\n    optionalDependencies:\n      fsevents: 2.3.3\n    transitivePeerDependencies:\n      - supports-color\n\n  jest-jasmine2@26.6.3:\n    dependencies:\n      '@babel/traverse': 7.26.4\n      '@jest/environment': 26.6.2\n      '@jest/source-map': 26.6.2\n      '@jest/test-result': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      chalk: 4.1.2\n      co: 4.6.0\n      expect: 26.6.2\n      is-generator-fn: 2.1.0\n      jest-each: 26.6.2\n      jest-matcher-utils: 26.6.2\n      jest-message-util: 26.6.2\n      jest-runtime: 26.6.3\n      jest-snapshot: 26.6.2\n      jest-util: 26.6.2\n      pretty-format: 26.6.2\n      throat: 5.0.0\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  jest-leak-detector@26.6.2:\n    dependencies:\n      jest-get-type: 26.3.0\n      pretty-format: 26.6.2\n\n  jest-matcher-utils@26.6.2:\n    dependencies:\n      chalk: 4.1.2\n      jest-diff: 26.6.2\n      jest-get-type: 26.3.0\n      pretty-format: 26.6.2\n\n  jest-message-util@26.6.2:\n    dependencies:\n      '@babel/code-frame': 7.26.2\n      '@jest/types': 26.6.2\n      '@types/stack-utils': 2.0.3\n      chalk: 4.1.2\n      graceful-fs: 4.2.11\n      micromatch: 4.0.8\n      pretty-format: 26.6.2\n      slash: 3.0.0\n      stack-utils: 2.0.6\n\n  jest-mock@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n\n  jest-pnp-resolver@1.2.3(jest-resolve@26.6.2):\n    optionalDependencies:\n      jest-resolve: 26.6.2\n\n  jest-regex-util@26.0.0: {}\n\n  jest-resolve-dependencies@26.6.3:\n    dependencies:\n      '@jest/types': 26.6.2\n      jest-regex-util: 26.0.0\n      jest-snapshot: 26.6.2\n    transitivePeerDependencies:\n      - supports-color\n\n  jest-resolve@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      chalk: 4.1.2\n      graceful-fs: 4.2.11\n      jest-pnp-resolver: 1.2.3(jest-resolve@26.6.2)\n      jest-util: 26.6.2\n      read-pkg-up: 7.0.1\n      resolve: 1.22.8\n      slash: 3.0.0\n\n  jest-runner@26.6.3:\n    dependencies:\n      '@jest/console': 26.6.2\n      '@jest/environment': 26.6.2\n      '@jest/test-result': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      chalk: 4.1.2\n      emittery: 0.7.2\n      exit: 0.1.2\n      graceful-fs: 4.2.11\n      jest-config: 26.6.3\n      jest-docblock: 26.0.0\n      jest-haste-map: 26.6.2\n      jest-leak-detector: 26.6.2\n      jest-message-util: 26.6.2\n      jest-resolve: 26.6.2\n      jest-runtime: 26.6.3\n      jest-util: 26.6.2\n      jest-worker: 26.6.2\n      source-map-support: 0.5.21\n      throat: 5.0.0\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  jest-runtime@26.6.3:\n    dependencies:\n      '@jest/console': 26.6.2\n      '@jest/environment': 26.6.2\n      '@jest/fake-timers': 26.6.2\n      '@jest/globals': 26.6.2\n      '@jest/source-map': 26.6.2\n      '@jest/test-result': 26.6.2\n      '@jest/transform': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/yargs': 15.0.19\n      chalk: 4.1.2\n      cjs-module-lexer: 0.6.0\n      collect-v8-coverage: 1.0.2\n      exit: 0.1.2\n      glob: 7.2.3\n      graceful-fs: 4.2.11\n      jest-config: 26.6.3\n      jest-haste-map: 26.6.2\n      jest-message-util: 26.6.2\n      jest-mock: 26.6.2\n      jest-regex-util: 26.0.0\n      jest-resolve: 26.6.2\n      jest-snapshot: 26.6.2\n      jest-util: 26.6.2\n      jest-validate: 26.6.2\n      slash: 3.0.0\n      strip-bom: 4.0.0\n      yargs: 15.4.1\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  jest-serializer@26.6.2:\n    dependencies:\n      '@types/node': 22.10.2\n      graceful-fs: 4.2.11\n\n  jest-snapshot@26.6.2:\n    dependencies:\n      '@babel/types': 7.26.3\n      '@jest/types': 26.6.2\n      '@types/babel__traverse': 7.20.6\n      '@types/prettier': 2.7.3\n      chalk: 4.1.2\n      expect: 26.6.2\n      graceful-fs: 4.2.11\n      jest-diff: 26.6.2\n      jest-get-type: 26.3.0\n      jest-haste-map: 26.6.2\n      jest-matcher-utils: 26.6.2\n      jest-message-util: 26.6.2\n      jest-resolve: 26.6.2\n      natural-compare: 1.4.0\n      pretty-format: 26.6.2\n      semver: 7.6.3\n    transitivePeerDependencies:\n      - supports-color\n\n  jest-util@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      chalk: 4.1.2\n      graceful-fs: 4.2.11\n      is-ci: 2.0.0\n      micromatch: 4.0.8\n\n  jest-validate@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      camelcase: 6.3.0\n      chalk: 4.1.2\n      jest-get-type: 26.3.0\n      leven: 3.1.0\n      pretty-format: 26.6.2\n\n  jest-watcher@26.6.2:\n    dependencies:\n      '@jest/test-result': 26.6.2\n      '@jest/types': 26.6.2\n      '@types/node': 22.10.2\n      ansi-escapes: 4.3.2\n      chalk: 4.1.2\n      jest-util: 26.6.2\n      string-length: 4.0.2\n\n  jest-worker@24.9.0:\n    dependencies:\n      merge-stream: 2.0.0\n      supports-color: 6.1.0\n\n  jest-worker@26.6.2:\n    dependencies:\n      '@types/node': 22.10.2\n      merge-stream: 2.0.0\n      supports-color: 7.2.0\n\n  jest@26.6.3:\n    dependencies:\n      '@jest/core': 26.6.3\n      import-local: 3.2.0\n      jest-cli: 26.6.3\n    transitivePeerDependencies:\n      - bufferutil\n      - canvas\n      - supports-color\n      - ts-node\n      - utf-8-validate\n\n  js-tokens@4.0.0: {}\n\n  js-yaml@3.14.1:\n    dependencies:\n      argparse: 1.0.10\n      esprima: 4.0.1\n\n  jsdom@16.7.0:\n    dependencies:\n      abab: 2.0.6\n      acorn: 8.14.0\n      acorn-globals: 6.0.0\n      cssom: 0.4.4\n      cssstyle: 2.3.0\n      data-urls: 2.0.0\n      decimal.js: 10.4.3\n      domexception: 2.0.1\n      escodegen: 2.1.0\n      form-data: 3.0.2\n      html-encoding-sniffer: 2.0.1\n      http-proxy-agent: 4.0.1\n      https-proxy-agent: 5.0.1\n      is-potential-custom-element-name: 1.0.1\n      nwsapi: 2.2.16\n      parse5: 6.0.1\n      saxes: 5.0.1\n      symbol-tree: 3.2.4\n      tough-cookie: 4.1.4\n      w3c-hr-time: 1.0.2\n      w3c-xmlserializer: 2.0.0\n      webidl-conversions: 6.1.0\n      whatwg-encoding: 1.0.5\n      whatwg-mimetype: 2.3.0\n      whatwg-url: 8.7.0\n      ws: 7.5.10\n      xml-name-validator: 3.0.0\n    transitivePeerDependencies:\n      - bufferutil\n      - supports-color\n      - utf-8-validate\n\n  jsesc@3.1.0: {}\n\n  json-parse-better-errors@1.0.2: {}\n\n  json-parse-even-better-errors@2.3.1: {}\n\n  json-schema-traverse@0.4.1: {}\n\n  json2mq@0.2.0:\n    dependencies:\n      string-convert: 0.2.1\n\n  json5@1.0.2:\n    dependencies:\n      minimist: 1.2.8\n\n  json5@2.2.3: {}\n\n  kind-of@3.2.2:\n    dependencies:\n      is-buffer: 1.1.6\n\n  kind-of@4.0.0:\n    dependencies:\n      is-buffer: 1.1.6\n\n  kind-of@6.0.3: {}\n\n  kleur@3.0.3: {}\n\n  leven@3.1.0: {}\n\n  lines-and-columns@1.2.4: {}\n\n  lint-staged@10.5.4:\n    dependencies:\n      chalk: 4.1.2\n      cli-truncate: 2.1.0\n      commander: 6.2.1\n      cosmiconfig: 7.1.0\n      debug: 4.4.0\n      dedent: 0.7.0\n      enquirer: 2.4.1\n      execa: 4.1.0\n      listr2: 3.14.0(enquirer@2.4.1)\n      log-symbols: 4.1.0\n      micromatch: 4.0.8\n      normalize-path: 3.0.0\n      please-upgrade-node: 3.2.0\n      string-argv: 0.3.1\n      stringify-object: 3.3.0\n    transitivePeerDependencies:\n      - supports-color\n\n  listr2@3.14.0(enquirer@2.4.1):\n    dependencies:\n      cli-truncate: 2.1.0\n      colorette: 2.0.20\n      log-update: 4.0.0\n      p-map: 4.0.0\n      rfdc: 1.4.1\n      rxjs: 7.8.1\n      through: 2.3.8\n      wrap-ansi: 7.0.0\n    optionalDependencies:\n      enquirer: 2.4.1\n\n  loader-utils@1.4.2:\n    dependencies:\n      big.js: 5.2.2\n      emojis-list: 3.0.0\n      json5: 1.0.2\n\n  locate-path@5.0.0:\n    dependencies:\n      p-locate: 4.1.0\n\n  lodash.debounce@4.0.8: {}\n\n  lodash.isequal@4.5.0: {}\n\n  lodash.merge@4.6.2: {}\n\n  lodash.throttle@4.1.1: {}\n\n  lodash@4.17.21: {}\n\n  log-symbols@4.1.0:\n    dependencies:\n      chalk: 4.1.2\n      is-unicode-supported: 0.1.0\n\n  log-update@4.0.0:\n    dependencies:\n      ansi-escapes: 4.3.2\n      cli-cursor: 3.1.0\n      slice-ansi: 4.0.0\n      wrap-ansi: 6.2.0\n\n  loose-envify@1.4.0:\n    dependencies:\n      js-tokens: 4.0.0\n\n  lru-cache@4.1.5:\n    dependencies:\n      pseudomap: 1.0.2\n      yallist: 2.1.2\n\n  lru-cache@5.1.1:\n    dependencies:\n      yallist: 3.1.1\n\n  make-dir@4.0.0:\n    dependencies:\n      semver: 7.6.3\n\n  makeerror@1.0.12:\n    dependencies:\n      tmpl: 1.0.5\n\n  map-cache@0.2.2: {}\n\n  map-visit@1.0.0:\n    dependencies:\n      object-visit: 1.0.1\n\n  math-intrinsics@1.0.0: {}\n\n  md5.js@1.3.5:\n    dependencies:\n      hash-base: 3.0.5\n      inherits: 2.0.4\n      safe-buffer: 5.2.1\n\n  memoize-one@5.2.1: {}\n\n  merge-stream@2.0.0: {}\n\n  micromatch@3.1.10:\n    dependencies:\n      arr-diff: 4.0.0\n      array-unique: 0.3.2\n      braces: 2.3.2\n      define-property: 2.0.2\n      extend-shallow: 3.0.2\n      extglob: 2.0.4\n      fragment-cache: 0.2.1\n      kind-of: 6.0.3\n      nanomatch: 1.2.13\n      object.pick: 1.3.0\n      regex-not: 1.0.2\n      snapdragon: 0.8.2\n      to-regex: 3.0.2\n    transitivePeerDependencies:\n      - supports-color\n\n  micromatch@4.0.8:\n    dependencies:\n      braces: 3.0.3\n      picomatch: 2.3.1\n\n  miller-rabin@4.0.1:\n    dependencies:\n      bn.js: 4.12.1\n      brorand: 1.1.0\n\n  mime-db@1.52.0: {}\n\n  mime-types@2.1.35:\n    dependencies:\n      mime-db: 1.52.0\n\n  mime@1.4.1: {}\n\n  mimic-fn@2.1.0: {}\n\n  min-document@2.19.0:\n    dependencies:\n      dom-walk: 0.1.2\n\n  mini-create-react-context@0.4.1(prop-types@15.8.1)(react@16.14.0):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      prop-types: 15.8.1\n      react: 16.14.0\n      tiny-warning: 1.0.3\n\n  mini-create-react-context@0.4.1(prop-types@15.8.1)(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      prop-types: 15.8.1\n      react: 17.0.2\n      tiny-warning: 1.0.3\n\n  minimalistic-assert@1.0.1: {}\n\n  minimalistic-crypto-utils@1.0.1: {}\n\n  minimatch@3.1.2:\n    dependencies:\n      brace-expansion: 1.1.11\n\n  minimist@1.2.8: {}\n\n  mixin-deep@1.3.2:\n    dependencies:\n      for-in: 1.0.2\n      is-extendable: 1.0.1\n\n  moment@2.30.1: {}\n\n  ms@2.0.0: {}\n\n  ms@2.1.3: {}\n\n  nanomatch@1.2.13:\n    dependencies:\n      arr-diff: 4.0.0\n      array-unique: 0.3.2\n      define-property: 2.0.2\n      extend-shallow: 3.0.2\n      fragment-cache: 0.2.1\n      is-windows: 1.0.2\n      kind-of: 6.0.3\n      object.pick: 1.3.0\n      regex-not: 1.0.2\n      snapdragon: 0.8.2\n      to-regex: 3.0.2\n    transitivePeerDependencies:\n      - supports-color\n\n  natural-compare@1.4.0: {}\n\n  nice-try@1.0.5: {}\n\n  node-fetch@1.7.3:\n    dependencies:\n      encoding: 0.1.13\n      is-stream: 1.1.0\n\n  node-int64@0.4.0: {}\n\n  node-libs-browser@2.2.1:\n    dependencies:\n      assert: 1.5.1\n      browserify-zlib: 0.2.0\n      buffer: 4.9.2\n      console-browserify: 1.2.0\n      constants-browserify: 1.0.0\n      crypto-browserify: 3.12.1\n      domain-browser: 1.2.0\n      events: 3.3.0\n      https-browserify: 1.0.0\n      os-browserify: 0.3.0\n      path-browserify: 0.0.1\n      process: 0.11.10\n      punycode: 1.4.1\n      querystring-es3: 0.2.1\n      readable-stream: 2.3.8\n      stream-browserify: 2.0.2\n      stream-http: 2.8.3\n      string_decoder: 1.3.0\n      timers-browserify: 2.0.12\n      tty-browserify: 0.0.0\n      url: 0.11.4\n      util: 0.11.1\n      vm-browserify: 1.1.2\n\n  node-notifier@8.0.2:\n    dependencies:\n      growly: 1.3.0\n      is-wsl: 2.2.0\n      semver: 7.6.3\n      shellwords: 0.1.1\n      uuid: 8.3.2\n      which: 2.0.2\n    optional: true\n\n  node-releases@2.0.19: {}\n\n  normalize-package-data@2.5.0:\n    dependencies:\n      hosted-git-info: 2.8.9\n      resolve: 1.22.8\n      semver: 5.7.2\n      validate-npm-package-license: 3.0.4\n\n  normalize-path@1.0.0: {}\n\n  normalize-path@2.1.1:\n    dependencies:\n      remove-trailing-separator: 1.1.0\n\n  normalize-path@3.0.0: {}\n\n  normalize-range@0.1.2: {}\n\n  normalize-url@1.9.1:\n    dependencies:\n      object-assign: 4.1.1\n      prepend-http: 1.0.4\n      query-string: 4.3.4\n      sort-keys: 1.1.2\n\n  normalize.css@7.0.0: {}\n\n  npm-run-path@2.0.2:\n    dependencies:\n      path-key: 2.0.1\n\n  npm-run-path@4.0.1:\n    dependencies:\n      path-key: 3.1.1\n\n  num2fraction@1.2.2: {}\n\n  nwsapi@2.2.16: {}\n\n  object-assign@4.1.1: {}\n\n  object-copy@0.1.0:\n    dependencies:\n      copy-descriptor: 0.1.1\n      define-property: 0.2.5\n      kind-of: 3.2.2\n\n  object-inspect@1.13.3: {}\n\n  object-keys@1.1.1: {}\n\n  object-visit@1.0.1:\n    dependencies:\n      isobject: 3.0.1\n\n  object.assign@4.1.5:\n    dependencies:\n      call-bind: 1.0.8\n      define-properties: 1.2.1\n      has-symbols: 1.1.0\n      object-keys: 1.1.1\n\n  object.pick@1.3.0:\n    dependencies:\n      isobject: 3.0.1\n\n  omit.js@2.0.2: {}\n\n  once@1.4.0:\n    dependencies:\n      wrappy: 1.0.2\n\n  onetime@5.1.2:\n    dependencies:\n      mimic-fn: 2.1.0\n\n  os-browserify@0.3.0: {}\n\n  p-each-series@2.2.0: {}\n\n  p-finally@1.0.0: {}\n\n  p-limit@2.3.0:\n    dependencies:\n      p-try: 2.2.0\n\n  p-locate@4.1.0:\n    dependencies:\n      p-limit: 2.3.0\n\n  p-map@4.0.0:\n    dependencies:\n      aggregate-error: 3.1.0\n\n  p-try@2.2.0: {}\n\n  pako@1.0.11: {}\n\n  parent-module@1.0.1:\n    dependencies:\n      callsites: 3.1.0\n\n  parse-asn1@5.1.7:\n    dependencies:\n      asn1.js: 4.10.1\n      browserify-aes: 1.2.0\n      evp_bytestokey: 1.0.3\n      hash-base: 3.0.5\n      pbkdf2: 3.1.2\n      safe-buffer: 5.2.1\n\n  parse-json@4.0.0:\n    dependencies:\n      error-ex: 1.3.2\n      json-parse-better-errors: 1.0.2\n\n  parse-json@5.2.0:\n    dependencies:\n      '@babel/code-frame': 7.26.2\n      error-ex: 1.3.2\n      json-parse-even-better-errors: 2.3.1\n      lines-and-columns: 1.2.4\n\n  parse5@6.0.1: {}\n\n  pascalcase@0.1.1: {}\n\n  path-browserify@0.0.1: {}\n\n  path-exists@4.0.0: {}\n\n  path-is-absolute@1.0.1: {}\n\n  path-key@2.0.1: {}\n\n  path-key@3.1.1: {}\n\n  path-parse@1.0.7: {}\n\n  path-to-regexp@1.9.0:\n    dependencies:\n      isarray: 0.0.1\n\n  path-to-regexp@2.4.0: {}\n\n  path-type@4.0.0: {}\n\n  pbkdf2@3.1.2:\n    dependencies:\n      create-hash: 1.2.0\n      create-hmac: 1.1.7\n      ripemd160: 2.0.2\n      safe-buffer: 5.2.1\n      sha.js: 2.4.11\n\n  performance-now@2.1.0: {}\n\n  picocolors@0.2.1: {}\n\n  picocolors@1.1.1: {}\n\n  picomatch@2.3.1: {}\n\n  pirates@4.0.6: {}\n\n  pkg-dir@4.2.0:\n    dependencies:\n      find-up: 4.1.0\n\n  please-upgrade-node@3.2.0:\n    dependencies:\n      semver-compare: 1.0.0\n\n  posix-character-classes@0.1.1: {}\n\n  postcss-attribute-case-insensitive@4.0.2:\n    dependencies:\n      postcss: 7.0.32\n      postcss-selector-parser: 6.1.2\n\n  postcss-color-functional-notation@2.0.1:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-color-gray@5.0.0:\n    dependencies:\n      '@csstools/convert-colors': 1.4.0\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-color-hex-alpha@5.0.3:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-color-mod-function@3.0.3:\n    dependencies:\n      '@csstools/convert-colors': 1.4.0\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-color-rebeccapurple@4.0.1:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-custom-media@7.0.8:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-custom-properties@8.0.11:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-custom-selectors@5.1.2:\n    dependencies:\n      postcss: 7.0.32\n      postcss-selector-parser: 5.0.0\n\n  postcss-dir-pseudo-class@5.0.0:\n    dependencies:\n      postcss: 7.0.32\n      postcss-selector-parser: 5.0.0\n\n  postcss-double-position-gradients@1.0.0:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-env-function@2.0.2:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-flexbugs-fixes@4.2.1:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-focus-visible@4.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-focus-within@3.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-font-variant@4.0.1:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-gap-properties@2.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-image-set-function@3.0.1:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-initial@3.0.4:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-lab-function@2.0.1:\n    dependencies:\n      '@csstools/convert-colors': 1.4.0\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-load-config@2.1.2:\n    dependencies:\n      cosmiconfig: 5.2.1\n      import-cwd: 2.1.0\n\n  postcss-loader@3.0.0:\n    dependencies:\n      loader-utils: 1.4.2\n      postcss: 7.0.32\n      postcss-load-config: 2.1.2\n      schema-utils: 1.0.0\n\n  postcss-logical@3.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-media-minmax@4.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-nesting@7.0.1:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-overflow-shorthand@2.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-page-break@2.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-place@4.0.1:\n    dependencies:\n      postcss: 7.0.32\n      postcss-values-parser: 2.0.1\n\n  postcss-preset-env@6.7.0:\n    dependencies:\n      autoprefixer: 9.8.8\n      browserslist: 4.24.2\n      caniuse-lite: 1.0.30001688\n      css-blank-pseudo: 0.1.4\n      css-has-pseudo: 0.10.0\n      css-prefers-color-scheme: 3.1.1\n      cssdb: 4.4.0\n      postcss: 7.0.32\n      postcss-attribute-case-insensitive: 4.0.2\n      postcss-color-functional-notation: 2.0.1\n      postcss-color-gray: 5.0.0\n      postcss-color-hex-alpha: 5.0.3\n      postcss-color-mod-function: 3.0.3\n      postcss-color-rebeccapurple: 4.0.1\n      postcss-custom-media: 7.0.8\n      postcss-custom-properties: 8.0.11\n      postcss-custom-selectors: 5.1.2\n      postcss-dir-pseudo-class: 5.0.0\n      postcss-double-position-gradients: 1.0.0\n      postcss-env-function: 2.0.2\n      postcss-focus-visible: 4.0.0\n      postcss-focus-within: 3.0.0\n      postcss-font-variant: 4.0.1\n      postcss-gap-properties: 2.0.0\n      postcss-image-set-function: 3.0.1\n      postcss-initial: 3.0.4\n      postcss-lab-function: 2.0.1\n      postcss-logical: 3.0.0\n      postcss-media-minmax: 4.0.0\n      postcss-nesting: 7.0.1\n      postcss-overflow-shorthand: 2.0.0\n      postcss-page-break: 2.0.0\n      postcss-place: 4.0.1\n      postcss-pseudo-class-any-link: 6.0.0\n      postcss-replace-overflow-wrap: 3.0.0\n      postcss-selector-matches: 4.0.0\n      postcss-selector-not: 4.0.1\n\n  postcss-pseudo-class-any-link@6.0.0:\n    dependencies:\n      postcss: 7.0.32\n      postcss-selector-parser: 5.0.0\n\n  postcss-replace-overflow-wrap@3.0.0:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-safe-parser@4.0.2:\n    dependencies:\n      postcss: 7.0.32\n\n  postcss-selector-matches@4.0.0:\n    dependencies:\n      balanced-match: 1.0.2\n      postcss: 7.0.32\n\n  postcss-selector-not@4.0.1:\n    dependencies:\n      balanced-match: 1.0.2\n      postcss: 7.0.32\n\n  postcss-selector-parser@5.0.0:\n    dependencies:\n      cssesc: 2.0.0\n      indexes-of: 1.0.1\n      uniq: 1.0.1\n\n  postcss-selector-parser@6.1.2:\n    dependencies:\n      cssesc: 3.0.0\n      util-deprecate: 1.0.2\n\n  postcss-value-parser@4.2.0: {}\n\n  postcss-values-parser@2.0.1:\n    dependencies:\n      flatten: 1.0.3\n      indexes-of: 1.0.1\n      uniq: 1.0.1\n\n  postcss@7.0.32:\n    dependencies:\n      chalk: 2.4.2\n      source-map: 0.6.1\n      supports-color: 6.1.0\n\n  prepend-http@1.0.4: {}\n\n  prettier@2.2.1: {}\n\n  prettier@2.8.8: {}\n\n  pretty-format@26.6.2:\n    dependencies:\n      '@jest/types': 26.6.2\n      ansi-regex: 5.0.1\n      ansi-styles: 4.3.0\n      react-is: 17.0.2\n\n  process-nextick-args@2.0.1: {}\n\n  process@0.11.10: {}\n\n  promise@7.3.1:\n    dependencies:\n      asap: 2.0.6\n\n  prompts@2.4.2:\n    dependencies:\n      kleur: 3.0.3\n      sisteransi: 1.0.5\n\n  prop-types@15.8.1:\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n      react-is: 16.13.1\n\n  pseudomap@1.0.2: {}\n\n  psl@1.15.0:\n    dependencies:\n      punycode: 2.3.1\n\n  public-encrypt@4.0.3:\n    dependencies:\n      bn.js: 4.12.1\n      browserify-rsa: 4.1.1\n      create-hash: 1.2.0\n      parse-asn1: 5.1.7\n      randombytes: 2.1.0\n      safe-buffer: 5.2.1\n\n  pump@3.0.2:\n    dependencies:\n      end-of-stream: 1.4.4\n      once: 1.4.0\n\n  punycode@1.4.1: {}\n\n  punycode@2.3.1: {}\n\n  qs@6.13.1:\n    dependencies:\n      side-channel: 1.1.0\n\n  query-string@4.3.4:\n    dependencies:\n      object-assign: 4.1.1\n      strict-uri-encode: 1.1.0\n\n  query-string@6.14.1:\n    dependencies:\n      decode-uri-component: 0.2.2\n      filter-obj: 1.1.0\n      split-on-first: 1.1.0\n      strict-uri-encode: 2.0.0\n\n  querystring-es3@0.2.1: {}\n\n  querystringify@2.2.0: {}\n\n  raf@3.4.1:\n    dependencies:\n      performance-now: 2.1.0\n\n  randombytes@2.1.0:\n    dependencies:\n      safe-buffer: 5.2.1\n\n  randomfill@1.0.4:\n    dependencies:\n      randombytes: 2.1.0\n      safe-buffer: 5.2.1\n\n  rc-align@2.4.5:\n    dependencies:\n      babel-runtime: 6.26.0\n      dom-align: 1.12.4\n      prop-types: 15.8.1\n      rc-util: 4.21.1\n\n  rc-align@4.0.15(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      dom-align: 1.12.4\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      resize-observer-polyfill: 1.5.1\n\n  rc-animate@2.11.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      css-animation: 1.6.1\n      prop-types: 15.8.1\n      raf: 3.4.1\n      rc-util: 4.21.1\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      react-lifecycles-compat: 3.0.4\n\n  rc-cascader@3.7.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      array-tree-filter: 2.1.0\n      classnames: 2.5.1\n      rc-select: 14.1.18(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-tree: 5.7.12(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-checkbox@2.0.3:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      prop-types: 15.8.1\n      rc-util: 4.21.1\n\n  rc-checkbox@3.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-collapse@1.9.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      classnames: 2.5.1\n      css-animation: 1.6.1\n      prop-types: 15.8.1\n      rc-animate: 2.11.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rc-collapse@3.4.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      shallowequal: 1.1.0\n\n  rc-dialog@9.0.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      '@rc-component/portal': 1.1.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-drawer@6.3.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      '@rc-component/portal': 1.1.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-dropdown@4.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-trigger: 5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-field-form@1.38.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      async-validator: 4.2.5\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-gesture@0.0.22:\n    dependencies:\n      babel-runtime: 6.26.0\n\n  rc-image@5.13.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      '@rc-component/portal': 1.1.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      classnames: 2.5.1\n      rc-dialog: 9.0.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-input-number@7.3.11(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-input@0.1.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-mentions@1.13.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-menu: 9.8.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-textarea: 0.4.7(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-trigger: 5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-menu@9.8.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-overflow: 1.3.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-trigger: 5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-motion@2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-notification@4.6.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-overflow@1.3.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-resize-observer: 1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-pagination@3.2.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-picker@2.7.6(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      date-fns: 2.30.0\n      dayjs: 1.11.13\n      moment: 2.30.1\n      rc-trigger: 5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      shallowequal: 1.1.0\n\n  rc-progress@3.4.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-rate@2.9.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-resize-observer@1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      resize-observer-polyfill: 1.5.1\n\n  rc-segmented@2.3.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-select@14.1.18(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-overflow: 1.3.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-trigger: 5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-virtual-list: 3.16.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-slider@10.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      shallowequal: 1.1.0\n\n  rc-slider@8.2.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      prop-types: 15.8.1\n      rc-tooltip: 3.7.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 4.21.1\n      shallowequal: 1.1.0\n      warning: 3.0.0\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rc-steps@5.0.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-swipeout@2.0.11:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      rc-gesture: 0.0.22\n      react-native-swipeout: 2.3.6\n\n  rc-switch@3.2.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-table@7.26.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-resize-observer: 1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      shallowequal: 1.1.0\n\n  rc-tabs@12.5.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-dropdown: 4.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-menu: 9.8.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-resize-observer: 1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-textarea@0.4.7(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-resize-observer: 1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      shallowequal: 1.1.0\n\n  rc-tooltip@3.7.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      prop-types: 15.8.1\n      rc-trigger: 2.6.5(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rc-tooltip@5.2.2(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-trigger: 5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-tree-select@5.5.5(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-select: 14.1.18(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-tree: 5.7.12(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-tree@5.7.12(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-virtual-list: 3.16.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-trigger@2.6.5(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      prop-types: 15.8.1\n      rc-align: 2.4.5\n      rc-animate: 2.11.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 4.21.1\n      react-lifecycles-compat: 3.0.4\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rc-trigger@5.3.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-align: 4.0.15(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-motion: 2.9.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-upload@4.3.6(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  rc-util@4.21.1:\n    dependencies:\n      add-dom-event-listener: 1.1.0\n      prop-types: 15.8.1\n      react-is: 16.13.1\n      react-lifecycles-compat: 3.0.4\n      shallowequal: 1.1.0\n\n  rc-util@5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      react-is: 18.3.1\n\n  rc-virtual-list@3.16.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      classnames: 2.5.1\n      rc-resize-observer: 1.4.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 5.44.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  react-dom@16.14.0(react@16.14.0):\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n      prop-types: 15.8.1\n      react: 16.14.0\n      scheduler: 0.19.1\n\n  react-dom@17.0.2(react@17.0.2):\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n      react: 17.0.2\n      scheduler: 0.20.2\n\n  react-fast-compare@3.2.2: {}\n\n  react-helmet@6.1.0(react@17.0.2):\n    dependencies:\n      object-assign: 4.1.1\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-fast-compare: 3.2.2\n      react-side-effect: 2.1.2(react@17.0.2)\n\n  react-intl@3.12.1(react@17.0.2):\n    dependencies:\n      '@formatjs/intl-displaynames': 1.2.10\n      '@formatjs/intl-listformat': 1.4.8\n      '@formatjs/intl-relativetimeformat': 4.5.16\n      '@formatjs/intl-unified-numberformat': 3.3.7\n      '@formatjs/intl-utils': 2.3.0\n      '@types/hoist-non-react-statics': 3.3.6\n      '@types/invariant': 2.2.37\n      hoist-non-react-statics: 3.3.2\n      intl-format-cache: 4.3.1\n      intl-messageformat: 7.8.4\n      intl-messageformat-parser: 3.6.4\n      react: 17.0.2\n      shallow-equal: 1.2.1\n\n  react-is@16.13.1: {}\n\n  react-is@17.0.2: {}\n\n  react-is@18.3.1: {}\n\n  react-lifecycles-compat@3.0.4: {}\n\n  react-native-swipeout@2.3.6:\n    dependencies:\n      create-react-class: 15.7.0\n      prop-types: 15.8.1\n      react-tween-state: 0.1.5\n\n  react-redux@7.2.9(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      '@types/react-redux': 7.1.34\n      hoist-non-react-statics: 3.3.2\n      loose-envify: 1.4.0\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-is: 17.0.2\n    optionalDependencies:\n      react-dom: 17.0.2(react@17.0.2)\n\n  react-refresh@0.10.0: {}\n\n  react-router-config@5.1.1(react-router@5.2.0(react@16.14.0))(react@16.14.0):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      react: 16.14.0\n      react-router: 5.2.0(react@17.0.2)\n\n  react-router-dom@5.2.0(react@16.14.0):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      history: 4.10.1\n      loose-envify: 1.4.0\n      prop-types: 15.8.1\n      react: 16.14.0\n      react-router: 5.2.0(react@16.14.0)\n      tiny-invariant: 1.3.3\n      tiny-warning: 1.0.3\n\n  react-router-dom@5.3.4(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      history: 4.10.1\n      loose-envify: 1.4.0\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-router: 5.3.4(react@17.0.2)\n      tiny-invariant: 1.3.3\n      tiny-warning: 1.0.3\n\n  react-router@5.2.0(react@16.14.0):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      history: 4.10.1\n      hoist-non-react-statics: 3.3.2\n      loose-envify: 1.4.0\n      mini-create-react-context: 0.4.1(prop-types@15.8.1)(react@16.14.0)\n      path-to-regexp: 1.9.0\n      prop-types: 15.8.1\n      react: 16.14.0\n      react-is: 16.13.1\n      tiny-invariant: 1.3.3\n      tiny-warning: 1.0.3\n\n  react-router@5.2.0(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      history: 4.10.1\n      hoist-non-react-statics: 3.3.2\n      loose-envify: 1.4.0\n      mini-create-react-context: 0.4.1(prop-types@15.8.1)(react@17.0.2)\n      path-to-regexp: 1.9.0\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-is: 16.13.1\n      tiny-invariant: 1.3.3\n      tiny-warning: 1.0.3\n\n  react-router@5.3.4(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      history: 4.10.1\n      hoist-non-react-statics: 3.3.2\n      loose-envify: 1.4.0\n      path-to-regexp: 1.9.0\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-is: 16.13.1\n      tiny-invariant: 1.3.3\n      tiny-warning: 1.0.3\n\n  react-side-effect@2.1.2(react@17.0.2):\n    dependencies:\n      react: 17.0.2\n\n  react-sortable-hoc@2.0.0(prop-types@15.8.1)(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      '@babel/runtime': 7.26.0\n      invariant: 2.2.4\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n\n  react-tween-state@0.1.5:\n    dependencies:\n      raf: 3.4.1\n      tween-functions: 1.2.0\n\n  react@16.14.0:\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n      prop-types: 15.8.1\n\n  react@17.0.2:\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n\n  read-pkg-up@7.0.1:\n    dependencies:\n      find-up: 4.1.0\n      read-pkg: 5.2.0\n      type-fest: 0.8.1\n\n  read-pkg@5.2.0:\n    dependencies:\n      '@types/normalize-package-data': 2.4.4\n      normalize-package-data: 2.5.0\n      parse-json: 5.2.0\n      type-fest: 0.6.0\n\n  readable-stream@2.3.8:\n    dependencies:\n      core-util-is: 1.0.3\n      inherits: 2.0.4\n      isarray: 1.0.0\n      process-nextick-args: 2.0.1\n      safe-buffer: 5.1.2\n      string_decoder: 1.1.1\n      util-deprecate: 1.0.2\n\n  readdirp@3.5.0:\n    dependencies:\n      picomatch: 2.3.1\n\n  redbox-react@1.6.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      error-stack-parser: 1.3.6\n      object-assign: 4.1.1\n      prop-types: 15.8.1\n      react: 17.0.2\n      react-dom: 17.0.2(react@17.0.2)\n      sourcemapped-stacktrace: 1.1.11\n\n  redux-saga@0.16.2: {}\n\n  redux@4.2.1:\n    dependencies:\n      '@babel/runtime': 7.26.0\n\n  regenerate-unicode-properties@10.0.1:\n    dependencies:\n      regenerate: 1.4.2\n\n  regenerate@1.4.2: {}\n\n  regenerator-runtime@0.11.1: {}\n\n  regenerator-runtime@0.13.11: {}\n\n  regenerator-runtime@0.13.5: {}\n\n  regenerator-runtime@0.14.1: {}\n\n  regex-not@1.0.2:\n    dependencies:\n      extend-shallow: 3.0.2\n      safe-regex: 1.1.0\n\n  remove-trailing-separator@1.1.0: {}\n\n  repeat-element@1.1.4: {}\n\n  repeat-string@1.6.1: {}\n\n  require-directory@2.1.1: {}\n\n  require-main-filename@2.0.0: {}\n\n  requires-port@1.0.0: {}\n\n  resize-observer-polyfill@1.5.1: {}\n\n  resolve-cwd@3.0.0:\n    dependencies:\n      resolve-from: 5.0.0\n\n  resolve-from@3.0.0: {}\n\n  resolve-from@4.0.0: {}\n\n  resolve-from@5.0.0: {}\n\n  resolve-pathname@3.0.0: {}\n\n  resolve-url@0.2.1: {}\n\n  resolve@1.22.8:\n    dependencies:\n      is-core-module: 2.15.1\n      path-parse: 1.0.7\n      supports-preserve-symlinks-flag: 1.0.0\n\n  restore-cursor@3.1.0:\n    dependencies:\n      onetime: 5.1.2\n      signal-exit: 3.0.7\n\n  ret@0.1.15: {}\n\n  rfdc@1.4.1: {}\n\n  rimraf@3.0.2:\n    dependencies:\n      glob: 7.2.3\n\n  ripemd160@2.0.2:\n    dependencies:\n      hash-base: 3.0.5\n      inherits: 2.0.4\n\n  rmc-align@1.0.0:\n    dependencies:\n      babel-runtime: 6.26.0\n      dom-align: 1.12.4\n      rc-util: 4.21.1\n\n  rmc-calendar@1.1.4(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      rc-animate: 2.11.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-date-picker: 6.0.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rmc-cascader@5.0.3(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      array-tree-filter: 2.1.0\n      babel-runtime: 6.26.0\n      rmc-picker: 5.0.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rmc-date-picker@6.0.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      rmc-picker: 5.0.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rmc-dialog@1.1.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      rc-animate: 2.11.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rmc-drawer@0.4.11:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      prop-types: 15.8.1\n\n  rmc-feedback@2.0.0:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n\n  rmc-input-number@1.0.5:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      rmc-feedback: 2.0.0\n\n  rmc-list-view@0.11.5:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      fbjs: 0.8.18\n      prop-types: 15.8.1\n      warning: 3.0.0\n      zscroller: 0.4.8\n\n  rmc-notification@1.0.0(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      prop-types: 15.8.1\n      rc-animate: 2.11.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 4.21.1\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rmc-nuka-carousel@3.0.1:\n    dependencies:\n      exenv: 1.2.2\n      raf: 3.4.1\n\n  rmc-picker@5.0.10(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n      rmc-dialog: 1.1.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rmc-feedback: 2.0.0\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rmc-pull-to-refresh@1.0.13:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n\n  rmc-steps@1.0.1:\n    dependencies:\n      babel-runtime: 6.26.0\n      classnames: 2.5.1\n\n  rmc-tabs@1.2.29:\n    dependencies:\n      babel-runtime: 6.26.0\n      rc-gesture: 0.0.22\n\n  rmc-tooltip@1.0.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      rmc-trigger: 1.0.12(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rmc-trigger@1.0.12(react-dom@17.0.2(react@17.0.2))(react@17.0.2):\n    dependencies:\n      babel-runtime: 6.26.0\n      rc-animate: 2.11.1(react-dom@17.0.2(react@17.0.2))(react@17.0.2)\n      rc-util: 4.21.1\n      rmc-align: 1.0.0\n    transitivePeerDependencies:\n      - react\n      - react-dom\n\n  rsvp@4.8.5: {}\n\n  rxjs@7.8.1:\n    dependencies:\n      tslib: 2.8.1\n\n  safe-buffer@5.1.2: {}\n\n  safe-buffer@5.2.1: {}\n\n  safe-regex@1.1.0:\n    dependencies:\n      ret: 0.1.15\n\n  safer-buffer@2.1.2: {}\n\n  sane@4.1.0:\n    dependencies:\n      '@cnakazawa/watch': 1.0.4\n      anymatch: 2.0.0\n      capture-exit: 2.0.0\n      exec-sh: 0.3.6\n      execa: 1.0.0\n      fb-watchman: 2.0.2\n      micromatch: 3.1.10\n      minimist: 1.2.8\n      walker: 1.0.8\n    transitivePeerDependencies:\n      - supports-color\n\n  saxes@5.0.1:\n    dependencies:\n      xmlchars: 2.2.0\n\n  scheduler@0.19.1:\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n\n  scheduler@0.20.2:\n    dependencies:\n      loose-envify: 1.4.0\n      object-assign: 4.1.1\n\n  schema-utils@1.0.0:\n    dependencies:\n      ajv: 6.12.6\n      ajv-errors: 1.0.1(ajv@6.12.6)\n      ajv-keywords: 3.5.2(ajv@6.12.6)\n\n  schema-utils@3.3.0:\n    dependencies:\n      '@types/json-schema': 7.0.15\n      ajv: 6.12.6\n      ajv-keywords: 3.5.2(ajv@6.12.6)\n\n  scroll-into-view-if-needed@2.2.31:\n    dependencies:\n      compute-scroll-into-view: 1.0.20\n\n  seamless-immutable@7.1.4: {}\n\n  semver-compare@1.0.0: {}\n\n  semver@5.7.2: {}\n\n  semver@6.3.1: {}\n\n  semver@7.6.3: {}\n\n  set-blocking@2.0.0: {}\n\n  set-function-length@1.2.2:\n    dependencies:\n      define-data-property: 1.1.4\n      es-errors: 1.3.0\n      function-bind: 1.1.2\n      get-intrinsic: 1.2.6\n      gopd: 1.2.0\n      has-property-descriptors: 1.0.2\n\n  set-value@2.0.1:\n    dependencies:\n      extend-shallow: 2.0.1\n      is-extendable: 0.1.1\n      is-plain-object: 2.0.4\n      split-string: 3.1.0\n\n  setimmediate@1.0.5: {}\n\n  sha.js@2.4.11:\n    dependencies:\n      inherits: 2.0.4\n      safe-buffer: 5.2.1\n\n  shallow-equal@1.2.1: {}\n\n  shallowequal@1.1.0: {}\n\n  shebang-command@1.2.0:\n    dependencies:\n      shebang-regex: 1.0.0\n\n  shebang-command@2.0.0:\n    dependencies:\n      shebang-regex: 3.0.0\n\n  shebang-regex@1.0.0: {}\n\n  shebang-regex@3.0.0: {}\n\n  shellwords@0.1.1:\n    optional: true\n\n  side-channel-list@1.0.0:\n    dependencies:\n      es-errors: 1.3.0\n      object-inspect: 1.13.3\n\n  side-channel-map@1.0.1:\n    dependencies:\n      call-bound: 1.0.2\n      es-errors: 1.3.0\n      get-intrinsic: 1.2.6\n      object-inspect: 1.13.3\n\n  side-channel-weakmap@1.0.2:\n    dependencies:\n      call-bound: 1.0.2\n      es-errors: 1.3.0\n      get-intrinsic: 1.2.6\n      object-inspect: 1.13.3\n      side-channel-map: 1.0.1\n\n  side-channel@1.1.0:\n    dependencies:\n      es-errors: 1.3.0\n      object-inspect: 1.13.3\n      side-channel-list: 1.0.0\n      side-channel-map: 1.0.1\n      side-channel-weakmap: 1.0.2\n\n  signal-exit@3.0.7: {}\n\n  sisteransi@1.0.5: {}\n\n  slash@3.0.0: {}\n\n  slice-ansi@3.0.0:\n    dependencies:\n      ansi-styles: 4.3.0\n      astral-regex: 2.0.0\n      is-fullwidth-code-point: 3.0.0\n\n  slice-ansi@4.0.0:\n    dependencies:\n      ansi-styles: 4.3.0\n      astral-regex: 2.0.0\n      is-fullwidth-code-point: 3.0.0\n\n  snapdragon-node@2.1.1:\n    dependencies:\n      define-property: 1.0.0\n      isobject: 3.0.1\n      snapdragon-util: 3.0.1\n\n  snapdragon-util@3.0.1:\n    dependencies:\n      kind-of: 3.2.2\n\n  snapdragon@0.8.2:\n    dependencies:\n      base: 0.11.2\n      debug: 2.6.9\n      define-property: 0.2.5\n      extend-shallow: 2.0.1\n      map-cache: 0.2.2\n      source-map: 0.5.7\n      source-map-resolve: 0.5.3\n      use: 3.1.1\n    transitivePeerDependencies:\n      - supports-color\n\n  sort-keys@1.1.2:\n    dependencies:\n      is-plain-obj: 1.1.0\n\n  source-map-resolve@0.5.3:\n    dependencies:\n      atob: 2.1.2\n      decode-uri-component: 0.2.2\n      resolve-url: 0.2.1\n      source-map-url: 0.4.1\n      urix: 0.1.0\n\n  source-map-support@0.5.21:\n    dependencies:\n      buffer-from: 1.1.2\n      source-map: 0.6.1\n\n  source-map-url@0.4.1: {}\n\n  source-map@0.5.6: {}\n\n  source-map@0.5.7: {}\n\n  source-map@0.6.1: {}\n\n  source-map@0.7.4: {}\n\n  sourcemapped-stacktrace@1.1.11:\n    dependencies:\n      source-map: 0.5.6\n\n  spdx-correct@3.2.0:\n    dependencies:\n      spdx-expression-parse: 3.0.1\n      spdx-license-ids: 3.0.20\n\n  spdx-exceptions@2.5.0: {}\n\n  spdx-expression-parse@3.0.1:\n    dependencies:\n      spdx-exceptions: 2.5.0\n      spdx-license-ids: 3.0.20\n\n  spdx-license-ids@3.0.20: {}\n\n  split-on-first@1.1.0: {}\n\n  split-string@3.1.0:\n    dependencies:\n      extend-shallow: 3.0.2\n\n  sprintf-js@1.0.3: {}\n\n  stack-utils@2.0.6:\n    dependencies:\n      escape-string-regexp: 2.0.0\n\n  stackframe@0.3.1: {}\n\n  stackframe@1.3.4: {}\n\n  static-extend@0.1.2:\n    dependencies:\n      define-property: 0.2.5\n      object-copy: 0.1.0\n\n  stream-browserify@2.0.2:\n    dependencies:\n      inherits: 2.0.4\n      readable-stream: 2.3.8\n\n  stream-http@2.8.3:\n    dependencies:\n      builtin-status-codes: 3.0.0\n      inherits: 2.0.4\n      readable-stream: 2.3.8\n      to-arraybuffer: 1.0.1\n      xtend: 4.0.2\n\n  strict-uri-encode@1.1.0: {}\n\n  strict-uri-encode@2.0.0: {}\n\n  string-argv@0.3.1: {}\n\n  string-convert@0.2.1: {}\n\n  string-length@4.0.2:\n    dependencies:\n      char-regex: 1.0.2\n      strip-ansi: 6.0.1\n\n  string-width@4.2.3:\n    dependencies:\n      emoji-regex: 8.0.0\n      is-fullwidth-code-point: 3.0.0\n      strip-ansi: 6.0.1\n\n  string_decoder@1.1.1:\n    dependencies:\n      safe-buffer: 5.1.2\n\n  string_decoder@1.3.0:\n    dependencies:\n      safe-buffer: 5.2.1\n\n  stringify-object@3.3.0:\n    dependencies:\n      get-own-enumerable-property-symbols: 3.0.2\n      is-obj: 1.0.1\n      is-regexp: 1.0.0\n\n  strip-ansi@6.0.1:\n    dependencies:\n      ansi-regex: 5.0.1\n\n  strip-bom@4.0.0: {}\n\n  strip-eof@1.0.0: {}\n\n  strip-final-newline@2.0.0: {}\n\n  strip-indent@2.0.0: {}\n\n  supports-color@5.5.0:\n    dependencies:\n      has-flag: 3.0.0\n\n  supports-color@6.1.0:\n    dependencies:\n      has-flag: 3.0.0\n\n  supports-color@7.2.0:\n    dependencies:\n      has-flag: 4.0.0\n\n  supports-hyperlinks@2.3.0:\n    dependencies:\n      has-flag: 4.0.0\n      supports-color: 7.2.0\n\n  supports-preserve-symlinks-flag@1.0.0: {}\n\n  swr@1.3.0(react@17.0.2):\n    dependencies:\n      react: 17.0.2\n\n  symbol-tree@3.2.4: {}\n\n  terminal-link@2.1.1:\n    dependencies:\n      ansi-escapes: 4.3.2\n      supports-hyperlinks: 2.3.0\n\n  terser@5.14.2:\n    dependencies:\n      '@jridgewell/source-map': 0.3.6\n      acorn: 8.14.0\n      commander: 2.20.3\n      source-map-support: 0.5.21\n\n  test-exclude@6.0.0:\n    dependencies:\n      '@istanbuljs/schema': 0.1.3\n      glob: 7.2.3\n      minimatch: 3.1.2\n\n  throat@5.0.0: {}\n\n  throttle-debounce@5.0.2: {}\n\n  through@2.3.8: {}\n\n  timers-browserify@2.0.12:\n    dependencies:\n      setimmediate: 1.0.5\n\n  tiny-invariant@1.3.3: {}\n\n  tiny-warning@1.0.3: {}\n\n  tmpl@1.0.5: {}\n\n  to-arraybuffer@1.0.1: {}\n\n  to-object-path@0.3.0:\n    dependencies:\n      kind-of: 3.2.2\n\n  to-regex-range@2.1.1:\n    dependencies:\n      is-number: 3.0.0\n      repeat-string: 1.6.1\n\n  to-regex-range@5.0.1:\n    dependencies:\n      is-number: 7.0.0\n\n  to-regex@3.0.2:\n    dependencies:\n      define-property: 2.0.2\n      extend-shallow: 3.0.2\n      regex-not: 1.0.2\n      safe-regex: 1.1.0\n\n  toggle-selection@1.0.6: {}\n\n  tough-cookie@4.1.4:\n    dependencies:\n      psl: 1.15.0\n      punycode: 2.3.1\n      universalify: 0.2.0\n      url-parse: 1.5.10\n\n  tr46@2.1.0:\n    dependencies:\n      punycode: 2.3.1\n\n  tslib@2.8.1: {}\n\n  tty-browserify@0.0.0: {}\n\n  tween-functions@1.2.0: {}\n\n  type-detect@4.0.8: {}\n\n  type-fest@0.21.3: {}\n\n  type-fest@0.6.0: {}\n\n  type-fest@0.8.1: {}\n\n  typedarray-to-buffer@3.1.5:\n    dependencies:\n      is-typedarray: 1.0.0\n\n  typescript@4.9.5: {}\n\n  ua-parser-js@0.7.39: {}\n\n  umi-request@1.4.0:\n    dependencies:\n      isomorphic-fetch: 2.2.1\n      qs: 6.13.1\n\n  umi@3.5.43(react-router@5.2.0(react@16.14.0)):\n    dependencies:\n      '@umijs/bundler-webpack': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/core': 3.5.43\n      '@umijs/deps': 3.5.43\n      '@umijs/preset-built-in': 3.5.43(react-dom@16.14.0(react@16.14.0))(react@16.14.0)\n      '@umijs/runtime': 3.5.43(react@16.14.0)\n      '@umijs/types': 3.5.43(react-dom@16.14.0(react@16.14.0))(react-router@5.2.0(react@16.14.0))(react@16.14.0)\n      '@umijs/utils': 3.5.43\n      react: 16.14.0\n      react-dom: 16.14.0(react@16.14.0)\n      v8-compile-cache: 2.3.0\n    transitivePeerDependencies:\n      - react-router\n\n  undici-types@6.20.0: {}\n\n  union-value@1.0.1:\n    dependencies:\n      arr-union: 3.1.0\n      get-value: 2.0.6\n      is-extendable: 0.1.1\n      set-value: 2.0.1\n\n  uniq@1.0.1: {}\n\n  universalify@0.2.0: {}\n\n  unset-value@1.0.0:\n    dependencies:\n      has-value: 0.3.1\n      isobject: 3.0.1\n\n  unstated-next@1.1.0: {}\n\n  update-browserslist-db@1.1.1(browserslist@4.24.2):\n    dependencies:\n      browserslist: 4.24.2\n      escalade: 3.2.0\n      picocolors: 1.1.1\n\n  uri-js@4.4.1:\n    dependencies:\n      punycode: 2.3.1\n\n  urix@0.1.0: {}\n\n  url-parse@1.5.10:\n    dependencies:\n      querystringify: 2.2.0\n      requires-port: 1.0.0\n\n  url@0.11.4:\n    dependencies:\n      punycode: 1.4.1\n      qs: 6.13.1\n\n  use-json-comparison@1.0.6(react@17.0.2):\n    dependencies:\n      react: 17.0.2\n\n  use-media-antd-query@1.1.0(react@17.0.2):\n    dependencies:\n      react: 17.0.2\n\n  use-subscription@1.5.1(react@16.14.0):\n    dependencies:\n      object-assign: 4.1.1\n      react: 16.14.0\n\n  use@3.1.1: {}\n\n  util-deprecate@1.0.2: {}\n\n  util@0.10.4:\n    dependencies:\n      inherits: 2.0.3\n\n  util@0.11.1:\n    dependencies:\n      inherits: 2.0.3\n\n  uuid@8.3.2:\n    optional: true\n\n  v8-compile-cache@2.3.0: {}\n\n  v8-to-istanbul@7.1.2:\n    dependencies:\n      '@types/istanbul-lib-coverage': 2.0.6\n      convert-source-map: 1.9.0\n      source-map: 0.7.4\n\n  validate-npm-package-license@3.0.4:\n    dependencies:\n      spdx-correct: 3.2.0\n      spdx-expression-parse: 3.0.1\n\n  value-equal@1.0.1: {}\n\n  vm-browserify@1.1.2: {}\n\n  w3c-hr-time@1.0.2:\n    dependencies:\n      browser-process-hrtime: 1.0.0\n\n  w3c-xmlserializer@2.0.0:\n    dependencies:\n      xml-name-validator: 3.0.0\n\n  walker@1.0.8:\n    dependencies:\n      makeerror: 1.0.12\n\n  warning@3.0.0:\n    dependencies:\n      loose-envify: 1.4.0\n\n  warning@4.0.3:\n    dependencies:\n      loose-envify: 1.4.0\n\n  webidl-conversions@5.0.0: {}\n\n  webidl-conversions@6.1.0: {}\n\n  webpack-chain@6.5.1:\n    dependencies:\n      deepmerge: 1.5.2\n      javascript-stringify: 2.1.0\n\n  whatwg-encoding@1.0.5:\n    dependencies:\n      iconv-lite: 0.4.24\n\n  whatwg-fetch@3.6.20: {}\n\n  whatwg-mimetype@2.3.0: {}\n\n  whatwg-url@8.7.0:\n    dependencies:\n      lodash: 4.17.21\n      tr46: 2.1.0\n      webidl-conversions: 6.1.0\n\n  which-module@2.0.1: {}\n\n  which@1.3.1:\n    dependencies:\n      isexe: 2.0.0\n\n  which@2.0.2:\n    dependencies:\n      isexe: 2.0.0\n\n  wrap-ansi@6.2.0:\n    dependencies:\n      ansi-styles: 4.3.0\n      string-width: 4.2.3\n      strip-ansi: 6.0.1\n\n  wrap-ansi@7.0.0:\n    dependencies:\n      ansi-styles: 4.3.0\n      string-width: 4.2.3\n      strip-ansi: 6.0.1\n\n  wrappy@1.0.2: {}\n\n  write-file-atomic@3.0.3:\n    dependencies:\n      imurmurhash: 0.1.4\n      is-typedarray: 1.0.0\n      signal-exit: 3.0.7\n      typedarray-to-buffer: 3.1.5\n\n  ws@7.5.10: {}\n\n  xml-name-validator@3.0.0: {}\n\n  xmlchars@2.2.0: {}\n\n  xtend@4.0.2: {}\n\n  y18n@4.0.3: {}\n\n  yallist@2.1.2: {}\n\n  yallist@3.1.1: {}\n\n  yaml@1.10.2: {}\n\n  yargs-parser@18.1.3:\n    dependencies:\n      camelcase: 5.3.1\n      decamelize: 1.2.0\n\n  yargs@15.4.1:\n    dependencies:\n      cliui: 6.0.0\n      decamelize: 1.2.0\n      find-up: 4.1.0\n      get-caller-file: 2.0.5\n      require-directory: 2.1.1\n      require-main-filename: 2.0.0\n      set-blocking: 2.0.0\n      string-width: 4.2.3\n      which-module: 2.0.1\n      y18n: 4.0.3\n      yargs-parser: 18.1.3\n\n  yorkie@2.0.0:\n    dependencies:\n      execa: 0.8.0\n      is-ci: 1.2.1\n      normalize-path: 1.0.0\n      strip-indent: 2.0.0\n\n  zscroller@0.4.8:\n    dependencies:\n      babel-runtime: 6.26.0\n"
      }
    ];
  }

  // src/plugins/project/framework/gant-legacy/template/files/README.md.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile18() {
    return [
      ["."],
      {
        name: "README",
        ext: "md",
        content: "# umi project\n\n## Getting Started\n\nInstall dependencies,\n\n```bash\n$ yarn\n```\n\nStart the dev server,\n\n```bash\n$ yarn start\n```\n"
      }
    ];
  }

  // src/plugins/project/framework/gant-legacy/template/files/tsconfig.json.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile19() {
    return [
      ["."],
      {
        name: "tsconfig",
        ext: "json",
        content: '{\n  "compilerOptions": {\n    "target": "esnext",\n    "module": "esnext",\n    "moduleResolution": "node",\n    "resolveJsonModule": true,\n    "importHelpers": true,\n    "jsx": "react-jsx",\n    "esModuleInterop": true,\n    "sourceMap": true,\n    "baseUrl": "./",\n    "strict": true,\n    "paths": {\n      "@/*": ["src/*"],\n      "@@/*": ["src/.umi/*"]\n    },\n    "allowSyntheticDefaultImports": true\n  },\n  "include": [\n    "mock/**/*",\n    "src/**/*",\n    "config/**/*",\n    ".umirc.ts",\n    "typings.d.ts"\n  ],\n  "exclude": [\n    "node_modules",\n    "lib",\n    "es",\n    "dist",\n    "typings",\n    "**/__test__",\n    "test",\n    "docs",\n    "tests"\n  ]\n}\n'
      }
    ];
  }

  // src/plugins/project/framework/gant-legacy/template/files/typings.d.ts.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  function getFile20() {
    return [
      ["."],
      {
        name: "typings.d",
        ext: "ts",
        content: "declare module '*.css';\ndeclare module '*.less';\ndeclare module '*.png';\ndeclare module '*.svg' {\n  export function ReactComponent(\n    props: React.SVGProps<SVGSVGElement>,\n  ): React.ReactElement;\n  const url: string;\n  export default url;\n}\n"
      }
    ];
  }

  // src/plugins/project/framework/gant-legacy/template/static-files.ts
  function generateStaticFiles2(root2 = createResultDir(".")) {
    runFileGenerator(root2, getFile11);
    runFileGenerator(root2, getFile12);
    runFileGenerator(root2, getFile13);
    runFileGenerator(root2, getFile14);
    runFileGenerator(root2, getFile15);
    runFileGenerator(root2, getFile16);
    runFileGenerator(root2, getFile17);
    runFileGenerator(root2, getFile18);
    runFileGenerator(root2, getFile19);
    runFileGenerator(root2, getFile20);
    return root2;
  }

  // src/plugins/project/framework/gant-legacy/template/index.ts
  var gantChunkTemplate2 = (rootPaths = ["src"], pagePaths = ["pages"], configPaths = []) => ({
    slots: {
      root: {
        path: [rootPaths[0]]
      },
      components: {
        path: [...rootPaths, "components"]
      },
      pages: {
        path: [...rootPaths, ...pagePaths]
      },
      router: {
        path: rootPaths,
        fileName: "routes"
      },
      entry: {
        path: rootPaths,
        fileName: "lowcode-app"
      },
      constants: {
        path: [...rootPaths, "lowcode-common"],
        fileName: "constants"
      },
      utils: {
        path: [...rootPaths, "lowcode-common"],
        fileName: "utils"
      },
      i18n: {
        path: [...rootPaths, "lowcode-common"],
        fileName: "i18n"
      },
      globalStyle: {
        path: [...rootPaths, "lowcode-common"],
        fileName: "global"
      },
      htmlEntry: {
        path: ["public"],
        fileName: "index"
      },
      packageJSON: {
        path: [],
        fileName: "package"
      },
      config: {
        path: [...rootPaths, ...configPaths],
        fileName: "lowcode.config"
      }
    },
    generateTemplate() {
      return generateStaticFiles2();
    }
  });
  var template_default3 = gantChunkTemplate2;

  // src/plugins/project/framework/gant-legacy/plugins/entry.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory28 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "ts" /* TS */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
        import { withKeyboardRedirect } from '@/utils/utils';
      `,
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "ts" /* TS */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: `
        window.lc_navigate = (event, itemPath) => {
          withKeyboardRedirect(event, itemPath);
        };
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      return next;
    };
    return plugin;
  };
  var entry_default2 = pluginFactory28;

  // src/plugins/project/framework/gant-legacy/plugins/globalStyle.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory29 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "scss" /* SCSS */,
        name: COMMON_CHUNK_NAME.StyleDepsImport,
        content: `
        
      `,
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "scss" /* SCSS */,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: `
        body {
          -webkit-font-smoothing: antialiased;
        }
      `,
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "scss" /* SCSS */,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: ir.css || "",
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      return next;
    };
    return plugin;
  };
  var globalStyle_default2 = pluginFactory29;

  // src/plugins/project/framework/gant-legacy/plugins/packageJSON.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory30 = (cfg) => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const packageJson = {
        name: (cfg == null ? void 0 : cfg.packageName) || "gant-lowcode-demo-app",
        version: (cfg == null ? void 0 : cfg.packageVersion) || "0.1.5",
        dependencies: {
          ...buildDataSourceDependencies(ir, cfg == null ? void 0 : cfg.datasourceConfig)
        },
        devDependencies: {}
      };
      ir.packages.forEach((packageInfo) => {
        packageJson.dependencies[packageInfo.package] = packageInfo.version;
      });
      next.chunks.push({
        type: "json" /* JSON */,
        fileType: "json" /* JSON */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: packageJson,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var packageJSON_default2 = pluginFactory30;

  // src/plugins/project/framework/gant-legacy/plugins/lowcodeConfigJSON.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory31 = (cfg) => {
    const plugin = async (pre) => {
      var _a, _b;
      const next = {
        ...pre
      };
      const ir = next.ir;
      const rootPath = getSlotRelativePath({
        contextData: next.contextData,
        from: "root",
        to: "pages"
      });
      const lowcodeConfigJSON = {
        name: (cfg == null ? void 0 : cfg.packageName) || "gant-lowcode-app",
        version: (cfg == null ? void 0 : cfg.packageVersion) || "0.0.0",
        routes: (_a = ir.globalRouter) == null ? void 0 : _a.routes.map((route) => ({
          path: `/**/${route.path}`,
          name: route.fileName,
          component: `${rootPath}${route.componentName}`
        })),
        dependencies: {
          ...buildDataSourceDependencies(ir.project, cfg == null ? void 0 : cfg.datasourceConfig)
        },
        ...((_b = ir.project) == null ? void 0 : _b.config) || {}
      };
      ir.project.packages.forEach((packageInfo) => {
        lowcodeConfigJSON.dependencies[packageInfo.package] = packageInfo.version;
      });
      next.chunks.push({
        type: "json" /* JSON */,
        fileType: "json" /* JSON */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: lowcodeConfigJSON,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var lowcodeConfigJSON_default = pluginFactory31;

  // src/plugins/project/framework/gant-legacy/plugins/router.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory32 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import BasicLayout from '@/layouts/BasicLayout';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileVarDefine,
        content: `
        const routerConfig = [
          {
            path: '/',
            component: BasicLayout,
            children: [
              ${ir.routes.map(
          (route) => `
                    {
                      path: '${route.path}',
                      component: ${route.componentName},
                    }
                  `
        ).join(",")}
            ],
          },
        ];
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `
        export default routerConfig;
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.FileUtilDefine,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileMainContent
        ]
      });
      return next;
    };
    return plugin;
  };
  var router_default2 = pluginFactory32;

  // src/plugins/project/framework/gant-legacy/index.ts
  var gant_legacy_default = {
    template: template_default3,
    plugins: {
      entry: entry_default2,
      globalStyle: globalStyle_default2,
      packageJSON: packageJSON_default2,
      lowcodeConfigJSON: lowcodeConfigJSON_default,
      router: router_default2
    }
  };

  // src/solutions/gant-legacy.ts
  function createGantChunkProjectBuilder2(options) {
    return createProjectBuilder({
      mode: options == null ? void 0 : options.mode,
      inStrictMode: options == null ? void 0 : options.inStrictMode,
      rootPaths: options == null ? void 0 : options.rootPaths,
      pagePaths: options == null ? void 0 : options.pagePaths,
      configPaths: options == null ? void 0 : options.configPaths,
      extraContextData: { ...options },
      template: gant_legacy_default.template,
      plugins: {
        components: [
          reactCommonDeps_default(),
          esmodule_default({
            fileType: "tsx"
          }),
          containerInjectUtils_default(),
          styleImport_default(),
          containerFunction_default(),
          containerState_default(),
          containerStatement_default(),
          functionJsx_default({
            nodeTypeMapping: {
              Div: "div",
              Component: "div",
              Page: "div",
              Block: "div"
            }
          }),
          css_default()
        ],
        pages: [
          reactCommonDeps_default(),
          esmodule_default({
            fileType: "tsx"
          }),
          containerInjectUtils_default({ scope: "pages" }),
          styleImport_default(),
          containerFunction_default(),
          containerState_default(),
          containerStatement_default(),
          functionJsx_default({
            nodeTypeMapping: {
              Div: "div",
              Component: "div",
              Page: "div",
              Block: "div"
            }
          }),
          css_default()
        ],
        router: [esmodule_default(), gant_legacy_default.plugins.router()],
        entry: [gant_legacy_default.plugins.entry()],
        constants: [constants_default()],
        utils: [esmodule_default(), utils_default("react")],
        i18n: [i18n_default()],
        globalStyle: [gant_legacy_default.plugins.globalStyle()],
        packageJSON: [gant_legacy_default.plugins.packageJSON()],
        config: [gant_legacy_default.plugins.lowcodeConfigJSON()]
      },
      postProcessors: [prettier_default()],
      customizeBuilderOptions: options == null ? void 0 : options.customizeBuilderOptions
    });
  }
  var plugins2 = {
    containerClass: containerClass_default,
    containerInjectContext: containerInjectContext_default,
    containerInjectUtils: containerInjectUtils_default,
    containerInjectDataSourceEngine: containerInjectDataSourceEngine_default,
    containerInjectI18n: containerInjectI18n_default,
    containerInjectConstants: containerInjectConstants_default,
    containerInitState: containerInitState_default,
    containerLifeCycle: containerLifeCycle_default,
    containerMethod: containerMethod_default,
    jsx: jsx_default,
    commonDeps: reactCommonDeps_default,
    reactCommonDeps: reactCommonDeps_default
  };

  // src/plugins/common/requireUtils.ts
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var pluginFactory33 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: "import * from 'react';",
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var requireUtils_default = pluginFactory33;

  // src/utils/index.ts
  var utils_exports = {};
  __export(utils_exports, {
    common: () => common_exports,
    compositeType: () => compositeType_exports,
    dataSource: () => dataSource_exports,
    expressionParser: () => expressionParser_exports,
    jsExpression: () => jsExpression_exports,
    jsSlot: () => jsSlot_exports,
    nodeToJSX: () => nodeToJSX_exports,
    pathHelper: () => pathHelper_exports,
    resultHelper: () => resultHelper_exports,
    schema: () => schema_exports,
    scope: () => Scope_exports,
    templateHelper: () => templateHelper_exports,
    validate: () => validate_exports,
    version: () => version_exports
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();

  // src/utils/version.ts
  var version_exports = {};
  __export(version_exports, {
    calcCompatibleVersion: () => calcCompatibleVersion
  });
  init_define_process();
  init_dirname();
  init_buffer2();
  init_process2();
  var import_semver = __toESM(require_semver2());
  function calcCompatibleVersion(v1, v2) {
    if (!v1 && !v2) {
      return "*";
    }
    if (!v1 || v1 === "*") {
      return v2 || "*";
    }
    if (!v2 || v2 === "*") {
      return v1;
    }
    if (v1 === v2) {
      return v1;
    }
    if (!import_semver.default.intersects(v1, v2, { loose: true })) {
      throw new Error(`no compatible versions for "${v1}" and "${v2}"`);
    }
    if (import_semver.default.subset(v1, v2, { loose: true })) {
      return v1;
    }
    return v2;
  }

  // src/standalone.ts
  var standalone_default = {
    createProjectBuilder,
    createModuleBuilder,
    solutions: {
      gant: createGantChunkProjectBuilder,
      gantLegacy: createGantChunkProjectBuilder2
    },
    solutionParts: {
      gant: gant_default,
      gantLegacy: gant_legacy_default
    },
    publishers: {
      zip: createZipPublisher
    },
    plugins: {
      common: {
        esmodule: esmodule_default,
        esModule: esmodule_default,
        requireUtils: requireUtils_default,
        styleImport: styleImport_default
      },
      style: {
        css: css_default
      },
      project: {
        constants: constants_default,
        i18n: i18n_default,
        utils: utils_default
      },
      gant: {
        ...plugins
      },
      gantLegacy: {
        ...plugins2
      }
    },
    postprocessor: {
      prettier: prettier_default
    },
    utils: utils_exports,
    chunkNames: {
      COMMON_CHUNK_NAME,
      CLASS_DEFINE_CHUNK_NAME,
      REACT_CHUNK_NAME
    },
    defaultLinkAfter: {
      COMMON_DEFAULT_LINK_AFTER: DEFAULT_LINK_AFTER
    },
    constants: const_exports
  };

  // src/standalone-worker.ts
  if (typeof self !== "undefined") {
    self.onmessage = (event) => {
      const msg = event.data || {};
      if (msg.type === "run") {
        run(msg);
      }
    };
    self.postMessage({ type: "ready" });
  }
  async function run(msg) {
    try {
      print("begin run...");
      self.postMessage({ type: "run:begin" });
      const { solution, builderOptions } = msg;
      if (!solution) {
        throw new Error("solution is required");
      }
      const createAppBuilder = standalone_default.solutions[solution];
      if (typeof createAppBuilder !== "function") {
        throw new Error(`solution '${solution}' is invalid`);
      }
      const appBuilder = createAppBuilder(builderOptions);
      print("generating from schema: %o", msg.schema);
      const result2 = await appBuilder.generateProject(msg.schema);
      print("generated result: %o", result2);
      const finalResult = msg.flattenResult ? standalone_default.utils.resultHelper.flattenResult(result2) : result2;
      if (msg.flattenResult) {
        print("flatten result: %o", finalResult);
      }
      self.postMessage({
        type: "run:end",
        result: finalResult
      });
    } catch (e) {
      printErr(`${e}`);
      self.postMessage({
        type: "run:error",
        errorMsg: `${(e == null ? void 0 : e.message) || e}`,
        errorDetail: `${e}`
      });
    }
  }
  function print(text, ...args) {
    console.debug(`[code-generator/worker]: ${text}`, ...args);
    self.postMessage({
      type: "stdout",
      data: text,
      args
    });
  }
  var sendPrint = print;
  function printErr(text, ...args) {
    console.debug(`[code-generator/worker]: %c${text}`, "color:red", ...args);
    self.postMessage({
      type: "stderr",
      data: text,
      args
    });
  }
})();
//# sourceMappingURL=standalone-worker.js.map
